var ule = Object.defineProperty;
var dle = (e, t, n) => t in e ? ule(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var ve = (e, t, n) => (dle(e, typeof t != "symbol" ? t + "" : t, n), n);
import { i as Ha, a as nv, M as Q1, O as fle, c as t0, g as vn, b as hle, B as Gs, A as gle, _ as QP, U as ple, S as WH, m as mN, D as mle, d as xu, C as vle, L as yle, e as ble, f as _le, P as Sle, h as mn, l as ac, j as wle, k as bx, n as er, o as Xn, u as No, p as qH, q as xle, r as GH, s as KH, w as Ele, t as Cle, v as Ms, x as Ic, y as d5, z as r$, E as Tle, F as Ile, G as $le, H as JP } from "./text-3bb32a4d.mjs";
import { J as i2t, N as o2t, Q as a2t, R as s2t, K as c2t, I as l2t, T as u2t } from "./text-3bb32a4d.mjs";
import * as $ from "react";
import j, { useContext as gt, useRef as $e, useCallback as Wt, useDebugValue as Ale, version as Rle, isValidElement as ZP, createContext as Ca, useLayoutEffect as Fa, useEffect as ot, useState as Qe, forwardRef as ia, useMemo as Tt, Children as Ple, createRef as Ole, useImperativeHandle as eO, cloneElement as YH, useSyncExternalStore as Mle, memo as hi, createElement as cf, Fragment as XH, useId as tO } from "react";
import * as kle from "react-dom";
import vN, { unstable_batchedUpdates as nO, createPortal as rO, flushSync as i$ } from "react-dom";
import ce, { StyleSheetManager as Nle, keyframes as gi, css as Dle } from "styled-components";
function jle({
  toolResults: e,
  conferQuestionId: t
}) {
  return e.reduce((r, i) => {
    switch (i.toolName) {
      case "record_answer": {
        const o = Lle(i.input);
        return o ? {
          ...r,
          [o.questionId]: {
            id: `${t}::${o.questionId}`,
            value: o.answer,
            info: {
              question: o.question
            }
          }
        } : r;
      }
      default:
        return r;
    }
  }, {});
}
function Lle(e) {
  const { questionId: t, question: n, answer: r } = e;
  return typeof t != "string" || typeof n != "string" || typeof r != "string" ? null : {
    questionId: t,
    question: n,
    answer: r
  };
}
class lu {
  constructor(t, n) {
    ve(this, "_answer");
    ve(this, "log");
    this._answer = t, this.log = n;
  }
  convertedToQuestionType(t) {
    return this._answer.questionType === t ? this : new lu(
      {
        ...this._answer,
        questionType: t
      },
      this.log
    );
  }
  getAnswer() {
    return this._answer;
  }
  getValue(t) {
    return t !== this._answer.questionType && this.log.error(
      `Question type ${t} does not match answer type ${this._answer.questionType}`
    ), this._answer.value === null ? null : this._answer.value;
  }
  hasId(t, n) {
    const r = this.getValue(n);
    return r === null ? !1 : this._findNestedValue(t, r) !== null;
  }
  getNestedValueAsNumber(t, n) {
    const r = this.getNestedValue(t, n);
    if (r === null)
      return null;
    const i = Number(r.value);
    return Number.isNaN(i) ? null : i;
  }
  isValid(t) {
    var n;
    switch (t) {
      case "multiInput":
      case "matrix":
      case "multiSelectMatrix":
      case "dropdown-matrix":
      case "input-matrix":
        return ((n = this._answer.validity) == null ? void 0 : n.valid) ?? !1;
      default:
        return !0;
    }
  }
  invalidMessages(t) {
    var n;
    return ((n = this._answer.validity) == null ? void 0 : n.messages) ?? ["This question requires an answer"];
  }
  getNestedValue(t, n) {
    const r = this.getValue(n);
    return r === null ? null : this._findNestedValue(t, r);
  }
  _findNestedValue(t, n) {
    return Array.isArray(n) ? n.find((r) => r.id === t) || null : Ha(n) ? n.id === t ? n : null : this._findNestedValue(t, n ? n[t] : null);
  }
}
class C0 {
  constructor(t, n) {
    ve(this, "_surveyAnswers");
    ve(this, "log");
    this._surveyAnswers = t, this.log = n;
  }
  get(t) {
    const n = this._surveyAnswers[t];
    return n ? new lu(n, this.log) : null;
  }
  raw() {
    return this._surveyAnswers;
  }
}
function o$(e) {
  return e == null ? !1 : Array.isArray(e) ? e.some(o$) : Ha(e) ? e.value.trim().length > 0 : Object.values(e).some(o$);
}
function Fle(e, t, n) {
  return n ? "complete" : e.some((i) => {
    var o;
    if (i.hideUi)
      return !1;
    switch (i.type) {
      case "welcomePage":
      case "infoPage":
      case "hidden":
      case "endPage":
      case "rewardPage":
      case "loggingTestPage":
        return !1;
      default:
        return o$((o = t[i.id]) == null ? void 0 : o.value);
    }
  }) ? "in-progress" : "not-started";
}
function a$(e) {
  const t = e.settings.sectionNavigation, n = {
    mode: t,
    sections: [],
    questionSections: {},
    introductionQuestionIds: [],
    errors: []
  };
  if (!t)
    return n;
  if (t !== "review" && t !== "free")
    return n.errors.push("sectionNavigation must be review or free"), n;
  let r, i;
  const o = /* @__PURE__ */ new Set();
  return e.questions.forEach((a) => {
    var s;
    if (!nv(a)) {
      if (a.section) {
        const c = a.section.id;
        if (!(c != null && c.trim())) {
          n.errors.push(`Question ${a.id}: section navigation requires a section id`);
          return;
        }
        const l = a.section.parent;
        if (l && (!l.id.trim() || !l.name.trim())) {
          n.errors.push(`Question ${a.id}: section parent requires an id and name`);
          return;
        }
        if ((r == null ? void 0 : r.id) !== c) {
          n.sections.some((d) => d.id === c) && n.errors.push(`Section ${c} must occupy one ordered section`), r = { id: c, info: a.section, questionIds: [] }, n.sections.push(r);
          const u = l == null ? void 0 : l.id;
          u && u !== i && o.has(u) && n.errors.push(`Section parent ${u} must occupy one ordered section group`), u && o.add(u), i = u;
        } else
          (l == null ? void 0 : l.id) !== ((s = r.info.parent) == null ? void 0 : s.id) && n.errors.push(`Question ${a.id}: section parent changes within section ${c}`);
      }
      r ? (r.questionIds.push(a.id), n.questionSections[a.id] = r.id) : n.introductionQuestionIds.push(a.id);
    }
  }), n.sections.length || n.errors.push("Section navigation requires at least one section"), n;
}
function Vle(e) {
  if (!(!e.mode || e.errors.length))
    return {
      mode: e.mode,
      sectionIds: e.sections.map((t) => t.id),
      questionSections: e.questionSections,
      introductionQuestionIds: e.introductionQuestionIds
    };
}
function s$(e, t, n, r = {}, i) {
  if (!e.mode || e.errors.length)
    return [];
  const o = t.find((d) => d.id === n.currentQuestionId), a = o && e.questionSections[o.id];
  if (!o || !a || o.hideUi || nv(o) || n.isSubmitClicked)
    return [];
  const s = t.indexOf(o), c = n.currentAnswer ? { ...n.userAnswers, [n.currentAnswer.questionId]: n.currentAnswer } : n.userAnswers, l = new C0(c, new Q1()), u = new Map(t.map((d) => [d.id, d]));
  return e.sections.flatMap((d) => {
    var p, g;
    const f = d.questionIds.map((m) => u.get(m)).filter((m) => !!m), h = Fle(
      f,
      c,
      !!((p = n.completedSectionIds) != null && p.includes(d.id))
    );
    try {
      const m = !d.info.canNavigate || d.info.canNavigate({ answers: l });
      if (!m && d.id !== a)
        return [];
      const v = f.find((b) => {
        var w;
        return !((w = b.skip) != null && w.call(b, { answers: l }));
      });
      if (!v)
        return [];
      const y = t.indexOf(v) < s;
      let _;
      return r.busy || o.type === "hidden" || r.nextDisabled && r.prevDisabled ? _ = "Please wait for this question to finish." : m ? e.mode === "review" && r.customNavigation ? _ = "Use the question controls to finish this step." : e.mode === "review" && !((g = n.unlockedSectionIds) != null && g.includes(d.id)) ? _ = "Continue using Next to reach or review this section." : y && (r.prevDisabled || o.hidePreviousButton) ? _ = "Going back is unavailable on this question." : e.mode === "review" && !y && r.nextDisabled && (_ = "Finish this question before continuing.") : _ = "This section is unavailable from the navigation.", [
        {
          id: d.id,
          name: d.info.name,
          parent: d.info.parent,
          colour: d.info.colour,
          number: d.info.number,
          active: a === d.id,
          status: h,
          targetQuestionId: v.id,
          disabledReason: _
        }
      ];
    } catch (m) {
      return i == null || i(m instanceof Error ? m : new Error(String(m))), [
        {
          id: d.id,
          name: d.info.name,
          parent: d.info.parent,
          colour: d.info.colour,
          number: d.info.number,
          active: a === d.id,
          status: h,
          disabledReason: "This section is currently unavailable."
        }
      ];
    }
  });
}
function c$(e, t) {
  return `${encodeURIComponent(e)}::${encodeURIComponent(t)}`;
}
function l$(e, t) {
  return `${encodeURIComponent(e)}::${typeof t}:${encodeURIComponent(String(t))}`;
}
function yN(e, t, n) {
  return Object.fromEntries(
    e.flatMap((r) => {
      const i = Object.prototype.hasOwnProperty.call(n, r.id) ? n[r.id] : [], o = t.filter((c) => i.includes(c.id)), a = o.find((c) => c.submit), s = (a ? [a] : o).map((c) => ({
        id: c.id,
        value: c.value,
        info: { statementValue: r.value, submit: c.submit === !0 }
      }));
      return s.length ? [[r.id, s]] : [];
    })
  );
}
function bN(e, t, n) {
  const r = !n || t.length > 0 && t.every((i) => {
    var o;
    return ((o = e[i.id]) == null ? void 0 : o.length) > 0;
  });
  return {
    valid: r,
    messages: r ? [] : ["This question requires at least one selection in every row"]
  };
}
function Ble(e, t, n) {
  const r = new Map(
    (e ?? []).map((i) => [
      l$(i.statementId, i.choiceId),
      { ...i, available: !1 }
    ])
  );
  for (const i of t)
    for (const o of n)
      r.set(l$(i.id, o.id), {
        statementId: i.id,
        choiceId: o.id,
        available: !0
      });
  return [...r.values()];
}
var u$ = { exports: {} }, wm = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var _N;
function zle() {
  if (_N)
    return wm;
  _N = 1;
  var e = j, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, i = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function a(s, c, l) {
    var u, d = {}, f = null, h = null;
    l !== void 0 && (f = "" + l), c.key !== void 0 && (f = "" + c.key), c.ref !== void 0 && (h = c.ref);
    for (u in c)
      r.call(c, u) && !o.hasOwnProperty(u) && (d[u] = c[u]);
    if (s && s.defaultProps)
      for (u in c = s.defaultProps, c)
        d[u] === void 0 && (d[u] = c[u]);
    return { $$typeof: t, type: s, key: f, ref: h, props: d, _owner: i.current };
  }
  return wm.Fragment = n, wm.jsx = a, wm.jsxs = a, wm;
}
var xm = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var SN;
function Hle() {
  return SN || (SN = 1, process.env.NODE_ENV !== "production" && function() {
    var e = j, t = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), s = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), p = Symbol.iterator, g = "@@iterator";
    function m(re) {
      if (re === null || typeof re != "object")
        return null;
      var Se = p && re[p] || re[g];
      return typeof Se == "function" ? Se : null;
    }
    var v = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(re) {
      {
        for (var Se = arguments.length, De = new Array(Se > 1 ? Se - 1 : 0), Ye = 1; Ye < Se; Ye++)
          De[Ye - 1] = arguments[Ye];
        _("error", re, De);
      }
    }
    function _(re, Se, De) {
      {
        var Ye = v.ReactDebugCurrentFrame, $t = Ye.getStackAddendum();
        $t !== "" && (Se += "%s", De = De.concat([$t]));
        var Ct = De.map(function(ut) {
          return String(ut);
        });
        Ct.unshift("Warning: " + Se), Function.prototype.apply.call(console[re], console, Ct);
      }
    }
    var b = !1, w = !1, C = !1, x = !1, T = !1, E;
    E = Symbol.for("react.module.reference");
    function R(re) {
      return !!(typeof re == "string" || typeof re == "function" || re === r || re === o || T || re === i || re === l || re === u || x || re === h || b || w || C || typeof re == "object" && re !== null && (re.$$typeof === f || re.$$typeof === d || re.$$typeof === a || re.$$typeof === s || re.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      re.$$typeof === E || re.getModuleId !== void 0));
    }
    function I(re, Se, De) {
      var Ye = re.displayName;
      if (Ye)
        return Ye;
      var $t = Se.displayName || Se.name || "";
      return $t !== "" ? De + "(" + $t + ")" : De;
    }
    function O(re) {
      return re.displayName || "Context";
    }
    function P(re) {
      if (re == null)
        return null;
      if (typeof re.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof re == "function")
        return re.displayName || re.name || null;
      if (typeof re == "string")
        return re;
      switch (re) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case o:
          return "Profiler";
        case i:
          return "StrictMode";
        case l:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof re == "object")
        switch (re.$$typeof) {
          case s:
            var Se = re;
            return O(Se) + ".Consumer";
          case a:
            var De = re;
            return O(De._context) + ".Provider";
          case c:
            return I(re, re.render, "ForwardRef");
          case d:
            var Ye = re.displayName || null;
            return Ye !== null ? Ye : P(re.type) || "Memo";
          case f: {
            var $t = re, Ct = $t._payload, ut = $t._init;
            try {
              return P(ut(Ct));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var k = Object.assign, L = 0, N, D, z, V, B, U, Q;
    function Y() {
    }
    Y.__reactDisabledLog = !0;
    function q() {
      {
        if (L === 0) {
          N = console.log, D = console.info, z = console.warn, V = console.error, B = console.group, U = console.groupCollapsed, Q = console.groupEnd;
          var re = {
            configurable: !0,
            enumerable: !0,
            value: Y,
            writable: !0
          };
          Object.defineProperties(console, {
            info: re,
            log: re,
            warn: re,
            error: re,
            group: re,
            groupCollapsed: re,
            groupEnd: re
          });
        }
        L++;
      }
    }
    function X() {
      {
        if (L--, L === 0) {
          var re = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: k({}, re, {
              value: N
            }),
            info: k({}, re, {
              value: D
            }),
            warn: k({}, re, {
              value: z
            }),
            error: k({}, re, {
              value: V
            }),
            group: k({}, re, {
              value: B
            }),
            groupCollapsed: k({}, re, {
              value: U
            }),
            groupEnd: k({}, re, {
              value: Q
            })
          });
        }
        L < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var ne = v.ReactCurrentDispatcher, Z;
    function J(re, Se, De) {
      {
        if (Z === void 0)
          try {
            throw Error();
          } catch ($t) {
            var Ye = $t.stack.trim().match(/\n( *(at )?)/);
            Z = Ye && Ye[1] || "";
          }
        return `
` + Z + re;
      }
    }
    var K = !1, ee;
    {
      var te = typeof WeakMap == "function" ? WeakMap : Map;
      ee = new te();
    }
    function H(re, Se) {
      if (!re || K)
        return "";
      {
        var De = ee.get(re);
        if (De !== void 0)
          return De;
      }
      var Ye;
      K = !0;
      var $t = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Ct;
      Ct = ne.current, ne.current = null, q();
      try {
        if (Se) {
          var ut = function() {
            throw Error();
          };
          if (Object.defineProperty(ut.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(ut, []);
            } catch (Ot) {
              Ye = Ot;
            }
            Reflect.construct(re, [], ut);
          } else {
            try {
              ut.call();
            } catch (Ot) {
              Ye = Ot;
            }
            re.call(ut.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Ot) {
            Ye = Ot;
          }
          re();
        }
      } catch (Ot) {
        if (Ot && Ye && typeof Ot.stack == "string") {
          for (var Mt = Ot.stack.split(`
`), Xe = Ye.stack.split(`
`), je = Mt.length - 1, Ze = Xe.length - 1; je >= 1 && Ze >= 0 && Mt[je] !== Xe[Ze]; )
            Ze--;
          for (; je >= 1 && Ze >= 0; je--, Ze--)
            if (Mt[je] !== Xe[Ze]) {
              if (je !== 1 || Ze !== 1)
                do
                  if (je--, Ze--, Ze < 0 || Mt[je] !== Xe[Ze]) {
                    var dt = `
` + Mt[je].replace(" at new ", " at ");
                    return re.displayName && dt.includes("<anonymous>") && (dt = dt.replace("<anonymous>", re.displayName)), typeof re == "function" && ee.set(re, dt), dt;
                  }
                while (je >= 1 && Ze >= 0);
              break;
            }
        }
      } finally {
        K = !1, ne.current = Ct, X(), Error.prepareStackTrace = $t;
      }
      var Ge = re ? re.displayName || re.name : "", Lt = Ge ? J(Ge) : "";
      return typeof re == "function" && ee.set(re, Lt), Lt;
    }
    function ie(re, Se, De) {
      return H(re, !1);
    }
    function W(re) {
      var Se = re.prototype;
      return !!(Se && Se.isReactComponent);
    }
    function se(re, Se, De) {
      if (re == null)
        return "";
      if (typeof re == "function")
        return H(re, W(re));
      if (typeof re == "string")
        return J(re);
      switch (re) {
        case l:
          return J("Suspense");
        case u:
          return J("SuspenseList");
      }
      if (typeof re == "object")
        switch (re.$$typeof) {
          case c:
            return ie(re.render);
          case d:
            return se(re.type, Se, De);
          case f: {
            var Ye = re, $t = Ye._payload, Ct = Ye._init;
            try {
              return se(Ct($t), Se, De);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, ge = {}, me = v.ReactDebugCurrentFrame;
    function pe(re) {
      if (re) {
        var Se = re._owner, De = se(re.type, re._source, Se ? Se.type : null);
        me.setExtraStackFrame(De);
      } else
        me.setExtraStackFrame(null);
    }
    function Te(re, Se, De, Ye, $t) {
      {
        var Ct = Function.call.bind(le);
        for (var ut in re)
          if (Ct(re, ut)) {
            var Mt = void 0;
            try {
              if (typeof re[ut] != "function") {
                var Xe = Error((Ye || "React class") + ": " + De + " type `" + ut + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof re[ut] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Xe.name = "Invariant Violation", Xe;
              }
              Mt = re[ut](Se, ut, Ye, De, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (je) {
              Mt = je;
            }
            Mt && !(Mt instanceof Error) && (pe($t), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Ye || "React class", De, ut, typeof Mt), pe(null)), Mt instanceof Error && !(Mt.message in ge) && (ge[Mt.message] = !0, pe($t), y("Failed %s type: %s", De, Mt.message), pe(null));
          }
      }
    }
    var de = Array.isArray;
    function Ae(re) {
      return de(re);
    }
    function ue(re) {
      {
        var Se = typeof Symbol == "function" && Symbol.toStringTag, De = Se && re[Symbol.toStringTag] || re.constructor.name || "Object";
        return De;
      }
    }
    function be(re) {
      try {
        return Ie(re), !1;
      } catch {
        return !0;
      }
    }
    function Ie(re) {
      return "" + re;
    }
    function Ve(re) {
      if (be(re))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", ue(re)), Ie(re);
    }
    var ze = v.ReactCurrentOwner, Ne = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, lt, mt, vt;
    vt = {};
    function ke(re) {
      if (le.call(re, "ref")) {
        var Se = Object.getOwnPropertyDescriptor(re, "ref").get;
        if (Se && Se.isReactWarning)
          return !1;
      }
      return re.ref !== void 0;
    }
    function xe(re) {
      if (le.call(re, "key")) {
        var Se = Object.getOwnPropertyDescriptor(re, "key").get;
        if (Se && Se.isReactWarning)
          return !1;
      }
      return re.key !== void 0;
    }
    function Re(re, Se) {
      if (typeof re.ref == "string" && ze.current && Se && ze.current.stateNode !== Se) {
        var De = P(ze.current.type);
        vt[De] || (y('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', P(ze.current.type), re.ref), vt[De] = !0);
      }
    }
    function yt(re, Se) {
      {
        var De = function() {
          lt || (lt = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Se));
        };
        De.isReactWarning = !0, Object.defineProperty(re, "key", {
          get: De,
          configurable: !0
        });
      }
    }
    function Pt(re, Se) {
      {
        var De = function() {
          mt || (mt = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Se));
        };
        De.isReactWarning = !0, Object.defineProperty(re, "ref", {
          get: De,
          configurable: !0
        });
      }
    }
    var _t = function(re, Se, De, Ye, $t, Ct, ut) {
      var Mt = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: re,
        key: Se,
        ref: De,
        props: ut,
        // Record the component responsible for creating this element.
        _owner: Ct
      };
      return Mt._store = {}, Object.defineProperty(Mt._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(Mt, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Ye
      }), Object.defineProperty(Mt, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: $t
      }), Object.freeze && (Object.freeze(Mt.props), Object.freeze(Mt)), Mt;
    };
    function St(re, Se, De, Ye, $t) {
      {
        var Ct, ut = {}, Mt = null, Xe = null;
        De !== void 0 && (Ve(De), Mt = "" + De), xe(Se) && (Ve(Se.key), Mt = "" + Se.key), ke(Se) && (Xe = Se.ref, Re(Se, $t));
        for (Ct in Se)
          le.call(Se, Ct) && !Ne.hasOwnProperty(Ct) && (ut[Ct] = Se[Ct]);
        if (re && re.defaultProps) {
          var je = re.defaultProps;
          for (Ct in je)
            ut[Ct] === void 0 && (ut[Ct] = je[Ct]);
        }
        if (Mt || Xe) {
          var Ze = typeof re == "function" ? re.displayName || re.name || "Unknown" : re;
          Mt && yt(ut, Ze), Xe && Pt(ut, Ze);
        }
        return _t(re, Mt, Xe, $t, Ye, ze.current, ut);
      }
    }
    var ft = v.ReactCurrentOwner, kn = v.ReactDebugCurrentFrame;
    function Dt(re) {
      if (re) {
        var Se = re._owner, De = se(re.type, re._source, Se ? Se.type : null);
        kn.setExtraStackFrame(De);
      } else
        kn.setExtraStackFrame(null);
    }
    var nt;
    nt = !1;
    function Be(re) {
      return typeof re == "object" && re !== null && re.$$typeof === t;
    }
    function st() {
      {
        if (ft.current) {
          var re = P(ft.current.type);
          if (re)
            return `

Check the render method of \`` + re + "`.";
        }
        return "";
      }
    }
    function pt(re) {
      {
        if (re !== void 0) {
          var Se = re.fileName.replace(/^.*[\\\/]/, ""), De = re.lineNumber;
          return `

Check your code at ` + Se + ":" + De + ".";
        }
        return "";
      }
    }
    var Et = {};
    function Ke(re) {
      {
        var Se = st();
        if (!Se) {
          var De = typeof re == "string" ? re : re.displayName || re.name;
          De && (Se = `

Check the top-level render call using <` + De + ">.");
        }
        return Se;
      }
    }
    function rt(re, Se) {
      {
        if (!re._store || re._store.validated || re.key != null)
          return;
        re._store.validated = !0;
        var De = Ke(Se);
        if (Et[De])
          return;
        Et[De] = !0;
        var Ye = "";
        re && re._owner && re._owner !== ft.current && (Ye = " It was passed a child from " + P(re._owner.type) + "."), Dt(re), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', De, Ye), Dt(null);
      }
    }
    function Le(re, Se) {
      {
        if (typeof re != "object")
          return;
        if (Ae(re))
          for (var De = 0; De < re.length; De++) {
            var Ye = re[De];
            Be(Ye) && rt(Ye, Se);
          }
        else if (Be(re))
          re._store && (re._store.validated = !0);
        else if (re) {
          var $t = m(re);
          if (typeof $t == "function" && $t !== re.entries)
            for (var Ct = $t.call(re), ut; !(ut = Ct.next()).done; )
              Be(ut.value) && rt(ut.value, Se);
        }
      }
    }
    function Xt(re) {
      {
        var Se = re.type;
        if (Se == null || typeof Se == "string")
          return;
        var De;
        if (typeof Se == "function")
          De = Se.propTypes;
        else if (typeof Se == "object" && (Se.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        Se.$$typeof === d))
          De = Se.propTypes;
        else
          return;
        if (De) {
          var Ye = P(Se);
          Te(De, re.props, "prop", Ye, re);
        } else if (Se.PropTypes !== void 0 && !nt) {
          nt = !0;
          var $t = P(Se);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", $t || "Unknown");
        }
        typeof Se.getDefaultProps == "function" && !Se.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ht(re) {
      {
        for (var Se = Object.keys(re.props), De = 0; De < Se.length; De++) {
          var Ye = Se[De];
          if (Ye !== "children" && Ye !== "key") {
            Dt(re), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Ye), Dt(null);
            break;
          }
        }
        re.ref !== null && (Dt(re), y("Invalid attribute `ref` supplied to `React.Fragment`."), Dt(null));
      }
    }
    var Ue = {};
    function We(re, Se, De, Ye, $t, Ct) {
      {
        var ut = R(re);
        if (!ut) {
          var Mt = "";
          (re === void 0 || typeof re == "object" && re !== null && Object.keys(re).length === 0) && (Mt += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Xe = pt($t);
          Xe ? Mt += Xe : Mt += st();
          var je;
          re === null ? je = "null" : Ae(re) ? je = "array" : re !== void 0 && re.$$typeof === t ? (je = "<" + (P(re.type) || "Unknown") + " />", Mt = " Did you accidentally export a JSX literal instead of a component?") : je = typeof re, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", je, Mt);
        }
        var Ze = St(re, Se, De, $t, Ct);
        if (Ze == null)
          return Ze;
        if (ut) {
          var dt = Se.children;
          if (dt !== void 0)
            if (Ye)
              if (Ae(dt)) {
                for (var Ge = 0; Ge < dt.length; Ge++)
                  Le(dt[Ge], re);
                Object.freeze && Object.freeze(dt);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Le(dt, re);
        }
        if (le.call(Se, "key")) {
          var Lt = P(re), Ot = Object.keys(Se).filter(function(Kn) {
            return Kn !== "key";
          }), xn = Ot.length > 0 ? "{key: someKey, " + Ot.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Ue[Lt + xn]) {
            var mr = Ot.length > 0 ? "{" + Ot.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, xn, Lt, mr, Lt), Ue[Lt + xn] = !0;
          }
        }
        return re === r ? Ht(Ze) : Xt(Ze), Ze;
      }
    }
    function ct(re, Se, De) {
      return We(re, Se, De, !0);
    }
    function ht(re, Se, De) {
      return We(re, Se, De, !1);
    }
    var Rt = ht, Ft = ct;
    xm.Fragment = r, xm.jsx = Rt, xm.jsxs = Ft;
  }()), xm;
}
process.env.NODE_ENV === "production" ? u$.exports = zle() : u$.exports = Hle();
var A = u$.exports, d$ = { exports: {} }, f5 = {};
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var wN;
function Ule() {
  if (wN)
    return f5;
  wN = 1;
  var e = j;
  function t(d, f) {
    return d === f && (d !== 0 || 1 / d === 1 / f) || d !== d && f !== f;
  }
  var n = typeof Object.is == "function" ? Object.is : t, r = e.useState, i = e.useEffect, o = e.useLayoutEffect, a = e.useDebugValue;
  function s(d, f) {
    var h = f(), p = r({ inst: { value: h, getSnapshot: f } }), g = p[0].inst, m = p[1];
    return o(function() {
      g.value = h, g.getSnapshot = f, c(g) && m({ inst: g });
    }, [d, h, f]), i(function() {
      return c(g) && m({ inst: g }), d(function() {
        c(g) && m({ inst: g });
      });
    }, [d]), a(h), h;
  }
  function c(d) {
    var f = d.getSnapshot;
    d = d.value;
    try {
      var h = f();
      return !n(d, h);
    } catch {
      return !0;
    }
  }
  function l(d, f) {
    return f();
  }
  var u = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? l : s;
  return f5.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : u, f5;
}
var h5 = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var xN;
function Wle() {
  return xN || (xN = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var e = j, t = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function n(_) {
      {
        for (var b = arguments.length, w = new Array(b > 1 ? b - 1 : 0), C = 1; C < b; C++)
          w[C - 1] = arguments[C];
        r("error", _, w);
      }
    }
    function r(_, b, w) {
      {
        var C = t.ReactDebugCurrentFrame, x = C.getStackAddendum();
        x !== "" && (b += "%s", w = w.concat([x]));
        var T = w.map(function(E) {
          return String(E);
        });
        T.unshift("Warning: " + b), Function.prototype.apply.call(console[_], console, T);
      }
    }
    function i(_, b) {
      return _ === b && (_ !== 0 || 1 / _ === 1 / b) || _ !== _ && b !== b;
    }
    var o = typeof Object.is == "function" ? Object.is : i, a = e.useState, s = e.useEffect, c = e.useLayoutEffect, l = e.useDebugValue, u = !1, d = !1;
    function f(_, b, w) {
      u || e.startTransition !== void 0 && (u = !0, n("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."));
      var C = b();
      if (!d) {
        var x = b();
        o(C, x) || (n("The result of getSnapshot should be cached to avoid an infinite loop"), d = !0);
      }
      var T = a({
        inst: {
          value: C,
          getSnapshot: b
        }
      }), E = T[0].inst, R = T[1];
      return c(function() {
        E.value = C, E.getSnapshot = b, h(E) && R({
          inst: E
        });
      }, [_, C, b]), s(function() {
        h(E) && R({
          inst: E
        });
        var I = function() {
          h(E) && R({
            inst: E
          });
        };
        return _(I);
      }, [_]), l(C), C;
    }
    function h(_) {
      var b = _.getSnapshot, w = _.value;
      try {
        var C = b();
        return !o(w, C);
      } catch {
        return !0;
      }
    }
    function p(_, b, w) {
      return b();
    }
    var g = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", m = !g, v = m ? p : f, y = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : v;
    h5.useSyncExternalStore = y, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), h5;
}
process.env.NODE_ENV === "production" ? d$.exports = Ule() : d$.exports = Wle();
var QH = d$.exports, f$ = { exports: {} }, g5 = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var EN;
function qle() {
  if (EN)
    return g5;
  EN = 1;
  var e = j, t = QH;
  function n(l, u) {
    return l === u && (l !== 0 || 1 / l === 1 / u) || l !== l && u !== u;
  }
  var r = typeof Object.is == "function" ? Object.is : n, i = t.useSyncExternalStore, o = e.useRef, a = e.useEffect, s = e.useMemo, c = e.useDebugValue;
  return g5.useSyncExternalStoreWithSelector = function(l, u, d, f, h) {
    var p = o(null);
    if (p.current === null) {
      var g = { hasValue: !1, value: null };
      p.current = g;
    } else
      g = p.current;
    p = s(function() {
      function v(C) {
        if (!y) {
          if (y = !0, _ = C, C = f(C), h !== void 0 && g.hasValue) {
            var x = g.value;
            if (h(x, C))
              return b = x;
          }
          return b = C;
        }
        if (x = b, r(_, C))
          return x;
        var T = f(C);
        return h !== void 0 && h(x, T) ? x : (_ = C, b = T);
      }
      var y = !1, _, b, w = d === void 0 ? null : d;
      return [function() {
        return v(u());
      }, w === null ? void 0 : function() {
        return v(w());
      }];
    }, [u, d, f, h]);
    var m = i(l, p[0], p[1]);
    return a(function() {
      g.hasValue = !0, g.value = m;
    }, [m]), c(m), m;
  }, g5;
}
var p5 = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var CN;
function Gle() {
  return CN || (CN = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var e = j, t = QH;
    function n(u, d) {
      return u === d && (u !== 0 || 1 / u === 1 / d) || u !== u && d !== d;
    }
    var r = typeof Object.is == "function" ? Object.is : n, i = t.useSyncExternalStore, o = e.useRef, a = e.useEffect, s = e.useMemo, c = e.useDebugValue;
    function l(u, d, f, h, p) {
      var g = o(null), m;
      g.current === null ? (m = {
        hasValue: !1,
        value: null
      }, g.current = m) : m = g.current;
      var v = s(function() {
        var w = !1, C, x, T = function(O) {
          if (!w) {
            w = !0, C = O;
            var P = h(O);
            if (p !== void 0 && m.hasValue) {
              var k = m.value;
              if (p(k, P))
                return x = k, k;
            }
            return x = P, P;
          }
          var L = C, N = x;
          if (r(L, O))
            return N;
          var D = h(O);
          return p !== void 0 && p(N, D) ? N : (C = O, x = D, D);
        }, E = f === void 0 ? null : f, R = function() {
          return T(d());
        }, I = E === null ? void 0 : function() {
          return T(E());
        };
        return [R, I];
      }, [d, f, h, p]), y = v[0], _ = v[1], b = i(u, y, _);
      return a(function() {
        m.hasValue = !0, m.value = b;
      }, [b]), c(b), b;
    }
    p5.useSyncExternalStoreWithSelector = l, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), p5;
}
process.env.NODE_ENV === "production" ? f$.exports = qle() : f$.exports = Gle();
var Kle = f$.exports;
function Yle(e) {
  e();
}
let JH = Yle;
const Xle = (e) => JH = e, Qle = () => JH, TN = Symbol.for("react-redux-context"), IN = typeof globalThis < "u" ? globalThis : (
  /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */
  {}
);
function Jle() {
  var e;
  if (!$.createContext)
    return {};
  const t = (e = IN[TN]) != null ? e : IN[TN] = /* @__PURE__ */ new Map();
  let n = t.get($.createContext);
  return n || (n = $.createContext(null), process.env.NODE_ENV !== "production" && (n.displayName = "ReactRedux"), t.set($.createContext, n)), n;
}
const Eu = /* @__PURE__ */ Jle();
function iO(e = Eu) {
  return function() {
    const n = gt(e);
    if (process.env.NODE_ENV !== "production" && !n)
      throw new Error("could not find react-redux context value; please ensure the component is wrapped in a <Provider>");
    return n;
  };
}
const ZH = /* @__PURE__ */ iO(), Zle = () => {
  throw new Error("uSES not initialized!");
};
let eU = Zle;
const eue = (e) => {
  eU = e;
}, tue = (e, t) => e === t;
function nue(e = Eu) {
  const t = e === Eu ? ZH : iO(e);
  return function(r, i = {}) {
    const {
      equalityFn: o = tue,
      stabilityCheck: a = void 0,
      noopCheck: s = void 0
    } = typeof i == "function" ? {
      equalityFn: i
    } : i;
    if (process.env.NODE_ENV !== "production") {
      if (!r)
        throw new Error("You must pass a selector to useSelector");
      if (typeof r != "function")
        throw new Error("You must pass a function as a selector to useSelector");
      if (typeof o != "function")
        throw new Error("You must pass a function as an equality function to useSelector");
    }
    const {
      store: c,
      subscription: l,
      getServerState: u,
      stabilityCheck: d,
      noopCheck: f
    } = t(), h = $e(!0), p = Wt({
      [r.name](m) {
        const v = r(m);
        if (process.env.NODE_ENV !== "production") {
          const y = typeof a > "u" ? d : a;
          if (y === "always" || y === "once" && h.current) {
            const b = r(m);
            if (!o(v, b)) {
              let w;
              try {
                throw new Error();
              } catch (C) {
                ({
                  stack: w
                } = C);
              }
              console.warn("Selector " + (r.name || "unknown") + ` returned a different result when called with the same parameters. This can lead to unnecessary rerenders.
Selectors that return a new reference (such as an object or an array) should be memoized: https://redux.js.org/usage/deriving-data-selectors#optimizing-selectors-with-memoization`, {
                state: m,
                selected: v,
                selected2: b,
                stack: w
              });
            }
          }
          const _ = typeof s > "u" ? f : s;
          if ((_ === "always" || _ === "once" && h.current) && v === m) {
            let b;
            try {
              throw new Error();
            } catch (w) {
              ({
                stack: b
              } = w);
            }
            console.warn("Selector " + (r.name || "unknown") + ` returned the root state when called. This can lead to unnecessary rerenders.
Selectors that return the entire state are almost certainly a mistake, as they will cause a rerender whenever *anything* in state changes.`, {
              stack: b
            });
          }
          h.current && (h.current = !1);
        }
        return v;
      }
    }[r.name], [r, d, a]), g = eU(l.addNestedSub, c.getState, u || c.getState, p, o);
    return Ale(g), g;
  };
}
const _x = /* @__PURE__ */ nue();
function xt() {
  return xt = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, xt.apply(null, arguments);
}
function rue(e, t) {
  if (e == null)
    return {};
  var n = {};
  for (var r in e)
    if ({}.hasOwnProperty.call(e, r)) {
      if (t.includes(r))
        continue;
      n[r] = e[r];
    }
  return n;
}
var h$ = { exports: {} }, Vn = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var $N;
function iue() {
  if ($N)
    return Vn;
  $N = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, l = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, f = e ? Symbol.for("react.suspense_list") : 60120, h = e ? Symbol.for("react.memo") : 60115, p = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, m = e ? Symbol.for("react.fundamental") : 60117, v = e ? Symbol.for("react.responder") : 60118, y = e ? Symbol.for("react.scope") : 60119;
  function _(w) {
    if (typeof w == "object" && w !== null) {
      var C = w.$$typeof;
      switch (C) {
        case t:
          switch (w = w.type, w) {
            case c:
            case l:
            case r:
            case o:
            case i:
            case d:
              return w;
            default:
              switch (w = w && w.$$typeof, w) {
                case s:
                case u:
                case p:
                case h:
                case a:
                  return w;
                default:
                  return C;
              }
          }
        case n:
          return C;
      }
    }
  }
  function b(w) {
    return _(w) === l;
  }
  return Vn.AsyncMode = c, Vn.ConcurrentMode = l, Vn.ContextConsumer = s, Vn.ContextProvider = a, Vn.Element = t, Vn.ForwardRef = u, Vn.Fragment = r, Vn.Lazy = p, Vn.Memo = h, Vn.Portal = n, Vn.Profiler = o, Vn.StrictMode = i, Vn.Suspense = d, Vn.isAsyncMode = function(w) {
    return b(w) || _(w) === c;
  }, Vn.isConcurrentMode = b, Vn.isContextConsumer = function(w) {
    return _(w) === s;
  }, Vn.isContextProvider = function(w) {
    return _(w) === a;
  }, Vn.isElement = function(w) {
    return typeof w == "object" && w !== null && w.$$typeof === t;
  }, Vn.isForwardRef = function(w) {
    return _(w) === u;
  }, Vn.isFragment = function(w) {
    return _(w) === r;
  }, Vn.isLazy = function(w) {
    return _(w) === p;
  }, Vn.isMemo = function(w) {
    return _(w) === h;
  }, Vn.isPortal = function(w) {
    return _(w) === n;
  }, Vn.isProfiler = function(w) {
    return _(w) === o;
  }, Vn.isStrictMode = function(w) {
    return _(w) === i;
  }, Vn.isSuspense = function(w) {
    return _(w) === d;
  }, Vn.isValidElementType = function(w) {
    return typeof w == "string" || typeof w == "function" || w === r || w === l || w === o || w === i || w === d || w === f || typeof w == "object" && w !== null && (w.$$typeof === p || w.$$typeof === h || w.$$typeof === a || w.$$typeof === s || w.$$typeof === u || w.$$typeof === m || w.$$typeof === v || w.$$typeof === y || w.$$typeof === g);
  }, Vn.typeOf = _, Vn;
}
var Bn = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var AN;
function oue() {
  return AN || (AN = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, l = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, f = e ? Symbol.for("react.suspense_list") : 60120, h = e ? Symbol.for("react.memo") : 60115, p = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, m = e ? Symbol.for("react.fundamental") : 60117, v = e ? Symbol.for("react.responder") : 60118, y = e ? Symbol.for("react.scope") : 60119;
    function _(H) {
      return typeof H == "string" || typeof H == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      H === r || H === l || H === o || H === i || H === d || H === f || typeof H == "object" && H !== null && (H.$$typeof === p || H.$$typeof === h || H.$$typeof === a || H.$$typeof === s || H.$$typeof === u || H.$$typeof === m || H.$$typeof === v || H.$$typeof === y || H.$$typeof === g);
    }
    function b(H) {
      if (typeof H == "object" && H !== null) {
        var ie = H.$$typeof;
        switch (ie) {
          case t:
            var W = H.type;
            switch (W) {
              case c:
              case l:
              case r:
              case o:
              case i:
              case d:
                return W;
              default:
                var se = W && W.$$typeof;
                switch (se) {
                  case s:
                  case u:
                  case p:
                  case h:
                  case a:
                    return se;
                  default:
                    return ie;
                }
            }
          case n:
            return ie;
        }
      }
    }
    var w = c, C = l, x = s, T = a, E = t, R = u, I = r, O = p, P = h, k = n, L = o, N = i, D = d, z = !1;
    function V(H) {
      return z || (z = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), B(H) || b(H) === c;
    }
    function B(H) {
      return b(H) === l;
    }
    function U(H) {
      return b(H) === s;
    }
    function Q(H) {
      return b(H) === a;
    }
    function Y(H) {
      return typeof H == "object" && H !== null && H.$$typeof === t;
    }
    function q(H) {
      return b(H) === u;
    }
    function X(H) {
      return b(H) === r;
    }
    function ne(H) {
      return b(H) === p;
    }
    function Z(H) {
      return b(H) === h;
    }
    function J(H) {
      return b(H) === n;
    }
    function K(H) {
      return b(H) === o;
    }
    function ee(H) {
      return b(H) === i;
    }
    function te(H) {
      return b(H) === d;
    }
    Bn.AsyncMode = w, Bn.ConcurrentMode = C, Bn.ContextConsumer = x, Bn.ContextProvider = T, Bn.Element = E, Bn.ForwardRef = R, Bn.Fragment = I, Bn.Lazy = O, Bn.Memo = P, Bn.Portal = k, Bn.Profiler = L, Bn.StrictMode = N, Bn.Suspense = D, Bn.isAsyncMode = V, Bn.isConcurrentMode = B, Bn.isContextConsumer = U, Bn.isContextProvider = Q, Bn.isElement = Y, Bn.isForwardRef = q, Bn.isFragment = X, Bn.isLazy = ne, Bn.isMemo = Z, Bn.isPortal = J, Bn.isProfiler = K, Bn.isStrictMode = ee, Bn.isSuspense = te, Bn.isValidElementType = _, Bn.typeOf = b;
  }()), Bn;
}
process.env.NODE_ENV === "production" ? h$.exports = iue() : h$.exports = oue();
var oO = h$.exports, tU = oO, aue = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, sue = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, nU = {};
nU[tU.ForwardRef] = aue;
nU[tU.Memo] = sue;
var zn = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var RN;
function cue() {
  if (RN)
    return zn;
  RN = 1;
  var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), a = Symbol.for("react.context"), s = Symbol.for("react.server_context"), c = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), p;
  p = Symbol.for("react.module.reference");
  function g(m) {
    if (typeof m == "object" && m !== null) {
      var v = m.$$typeof;
      switch (v) {
        case e:
          switch (m = m.type, m) {
            case n:
            case i:
            case r:
            case l:
            case u:
              return m;
            default:
              switch (m = m && m.$$typeof, m) {
                case s:
                case a:
                case c:
                case f:
                case d:
                case o:
                  return m;
                default:
                  return v;
              }
          }
        case t:
          return v;
      }
    }
  }
  return zn.ContextConsumer = a, zn.ContextProvider = o, zn.Element = e, zn.ForwardRef = c, zn.Fragment = n, zn.Lazy = f, zn.Memo = d, zn.Portal = t, zn.Profiler = i, zn.StrictMode = r, zn.Suspense = l, zn.SuspenseList = u, zn.isAsyncMode = function() {
    return !1;
  }, zn.isConcurrentMode = function() {
    return !1;
  }, zn.isContextConsumer = function(m) {
    return g(m) === a;
  }, zn.isContextProvider = function(m) {
    return g(m) === o;
  }, zn.isElement = function(m) {
    return typeof m == "object" && m !== null && m.$$typeof === e;
  }, zn.isForwardRef = function(m) {
    return g(m) === c;
  }, zn.isFragment = function(m) {
    return g(m) === n;
  }, zn.isLazy = function(m) {
    return g(m) === f;
  }, zn.isMemo = function(m) {
    return g(m) === d;
  }, zn.isPortal = function(m) {
    return g(m) === t;
  }, zn.isProfiler = function(m) {
    return g(m) === i;
  }, zn.isStrictMode = function(m) {
    return g(m) === r;
  }, zn.isSuspense = function(m) {
    return g(m) === l;
  }, zn.isSuspenseList = function(m) {
    return g(m) === u;
  }, zn.isValidElementType = function(m) {
    return typeof m == "string" || typeof m == "function" || m === n || m === i || m === r || m === l || m === u || m === h || typeof m == "object" && m !== null && (m.$$typeof === f || m.$$typeof === d || m.$$typeof === o || m.$$typeof === a || m.$$typeof === c || m.$$typeof === p || m.getModuleId !== void 0);
  }, zn.typeOf = g, zn;
}
var Hn = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var PN;
function lue() {
  return PN || (PN = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), a = Symbol.for("react.context"), s = Symbol.for("react.server_context"), c = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), p = !1, g = !1, m = !1, v = !1, y = !1, _;
    _ = Symbol.for("react.module.reference");
    function b(W) {
      return !!(typeof W == "string" || typeof W == "function" || W === n || W === i || y || W === r || W === l || W === u || v || W === h || p || g || m || typeof W == "object" && W !== null && (W.$$typeof === f || W.$$typeof === d || W.$$typeof === o || W.$$typeof === a || W.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      W.$$typeof === _ || W.getModuleId !== void 0));
    }
    function w(W) {
      if (typeof W == "object" && W !== null) {
        var se = W.$$typeof;
        switch (se) {
          case e:
            var le = W.type;
            switch (le) {
              case n:
              case i:
              case r:
              case l:
              case u:
                return le;
              default:
                var ge = le && le.$$typeof;
                switch (ge) {
                  case s:
                  case a:
                  case c:
                  case f:
                  case d:
                  case o:
                    return ge;
                  default:
                    return se;
                }
            }
          case t:
            return se;
        }
      }
    }
    var C = a, x = o, T = e, E = c, R = n, I = f, O = d, P = t, k = i, L = r, N = l, D = u, z = !1, V = !1;
    function B(W) {
      return z || (z = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function U(W) {
      return V || (V = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function Q(W) {
      return w(W) === a;
    }
    function Y(W) {
      return w(W) === o;
    }
    function q(W) {
      return typeof W == "object" && W !== null && W.$$typeof === e;
    }
    function X(W) {
      return w(W) === c;
    }
    function ne(W) {
      return w(W) === n;
    }
    function Z(W) {
      return w(W) === f;
    }
    function J(W) {
      return w(W) === d;
    }
    function K(W) {
      return w(W) === t;
    }
    function ee(W) {
      return w(W) === i;
    }
    function te(W) {
      return w(W) === r;
    }
    function H(W) {
      return w(W) === l;
    }
    function ie(W) {
      return w(W) === u;
    }
    Hn.ContextConsumer = C, Hn.ContextProvider = x, Hn.Element = T, Hn.ForwardRef = E, Hn.Fragment = R, Hn.Lazy = I, Hn.Memo = O, Hn.Portal = P, Hn.Profiler = k, Hn.StrictMode = L, Hn.Suspense = N, Hn.SuspenseList = D, Hn.isAsyncMode = B, Hn.isConcurrentMode = U, Hn.isContextConsumer = Q, Hn.isContextProvider = Y, Hn.isElement = q, Hn.isForwardRef = X, Hn.isFragment = ne, Hn.isLazy = Z, Hn.isMemo = J, Hn.isPortal = K, Hn.isProfiler = ee, Hn.isStrictMode = te, Hn.isSuspense = H, Hn.isSuspenseList = ie, Hn.isValidElementType = b, Hn.typeOf = w;
  }()), Hn;
}
process.env.NODE_ENV === "production" ? cue() : lue();
function uue() {
  const e = Qle();
  let t = null, n = null;
  return {
    clear() {
      t = null, n = null;
    },
    notify() {
      e(() => {
        let r = t;
        for (; r; )
          r.callback(), r = r.next;
      });
    },
    get() {
      let r = [], i = t;
      for (; i; )
        r.push(i), i = i.next;
      return r;
    },
    subscribe(r) {
      let i = !0, o = n = {
        callback: r,
        next: null,
        prev: n
      };
      return o.prev ? o.prev.next = o : t = o, function() {
        !i || t === null || (i = !1, o.next ? o.next.prev = o.prev : n = o.prev, o.prev ? o.prev.next = o.next : t = o.next);
      };
    }
  };
}
const ON = {
  notify() {
  },
  get: () => []
};
function due(e, t) {
  let n, r = ON, i = 0, o = !1;
  function a(g) {
    u();
    const m = r.subscribe(g);
    let v = !1;
    return () => {
      v || (v = !0, m(), d());
    };
  }
  function s() {
    r.notify();
  }
  function c() {
    p.onStateChange && p.onStateChange();
  }
  function l() {
    return o;
  }
  function u() {
    i++, n || (n = t ? t.addNestedSub(c) : e.subscribe(c), r = uue());
  }
  function d() {
    i--, n && i === 0 && (n(), n = void 0, r.clear(), r = ON);
  }
  function f() {
    o || (o = !0, u());
  }
  function h() {
    o && (o = !1, d());
  }
  const p = {
    addNestedSub: a,
    notifyNestedSubs: s,
    handleChangeWrapper: c,
    isSubscribed: l,
    trySubscribe: f,
    tryUnsubscribe: h,
    getListeners: () => r
  };
  return p;
}
const fue = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", hue = fue ? $.useLayoutEffect : $.useEffect;
function gue({
  store: e,
  context: t,
  children: n,
  serverState: r,
  stabilityCheck: i = "once",
  noopCheck: o = "once"
}) {
  const a = $.useMemo(() => {
    const l = due(e);
    return {
      store: e,
      subscription: l,
      getServerState: r ? () => r : void 0,
      stabilityCheck: i,
      noopCheck: o
    };
  }, [e, r, i, o]), s = $.useMemo(() => e.getState(), [e]);
  hue(() => {
    const {
      subscription: l
    } = a;
    return l.onStateChange = l.notifyNestedSubs, l.trySubscribe(), s !== e.getState() && l.notifyNestedSubs(), () => {
      l.tryUnsubscribe(), l.onStateChange = void 0;
    };
  }, [a, s]);
  const c = t || Eu;
  return /* @__PURE__ */ $.createElement(c.Provider, {
    value: a
  }, n);
}
function rU(e = Eu) {
  const t = (
    // @ts-ignore
    e === Eu ? ZH : (
      // @ts-ignore
      iO(e)
    )
  );
  return function() {
    const {
      store: r
    } = t();
    return r;
  };
}
const iU = /* @__PURE__ */ rU();
function pue(e = Eu) {
  const t = (
    // @ts-ignore
    e === Eu ? iU : rU(e)
  );
  return function() {
    return t().dispatch;
  };
}
const mue = /* @__PURE__ */ pue();
eue(Kle.useSyncExternalStoreWithSelector);
Xle(nO);
function Pi(e) {
  for (var t = arguments.length, n = Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  if (process.env.NODE_ENV !== "production") {
    var i = Cue[e], o = i ? typeof i == "function" ? i.apply(null, n) : i : "unknown error nr: " + e;
    throw Error("[Immer] " + o);
  }
  throw Error("[Immer] minified error nr: " + e + (n.length ? " " + n.map(function(a) {
    return "'" + a + "'";
  }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function Cu(e) {
  return !!e && !!e[Rr];
}
function cl(e) {
  var t;
  return !!e && (function(n) {
    if (!n || typeof n != "object")
      return !1;
    var r = Object.getPrototypeOf(n);
    if (r === null)
      return !0;
    var i = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
    return i === Object || typeof i == "function" && Function.toString.call(i) === Tue;
  }(e) || Array.isArray(e) || !!e[FN] || !!(!((t = e.constructor) === null || t === void 0) && t[FN]) || aO(e) || sO(e));
}
function lf(e, t, n) {
  n === void 0 && (n = !1), xp(e) === 0 ? (n ? Object.keys : rg)(e).forEach(function(r) {
    n && typeof r == "symbol" || t(r, e[r], e);
  }) : e.forEach(function(r, i) {
    return t(i, r, e);
  });
}
function xp(e) {
  var t = e[Rr];
  return t ? t.i > 3 ? t.i - 4 : t.i : Array.isArray(e) ? 1 : aO(e) ? 2 : sO(e) ? 3 : 0;
}
function ng(e, t) {
  return xp(e) === 2 ? e.has(t) : Object.prototype.hasOwnProperty.call(e, t);
}
function vue(e, t) {
  return xp(e) === 2 ? e.get(t) : e[t];
}
function oU(e, t, n) {
  var r = xp(e);
  r === 2 ? e.set(t, n) : r === 3 ? e.add(n) : e[t] = n;
}
function aU(e, t) {
  return e === t ? e !== 0 || 1 / e == 1 / t : e != e && t != t;
}
function aO(e) {
  return xue && e instanceof Map;
}
function sO(e) {
  return Eue && e instanceof Set;
}
function Vl(e) {
  return e.o || e.t;
}
function cO(e) {
  if (Array.isArray(e))
    return Array.prototype.slice.call(e);
  var t = cU(e);
  delete t[Rr];
  for (var n = rg(t), r = 0; r < n.length; r++) {
    var i = n[r], o = t[i];
    o.writable === !1 && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (t[i] = { configurable: !0, writable: !0, enumerable: o.enumerable, value: e[i] });
  }
  return Object.create(Object.getPrototypeOf(e), t);
}
function lO(e, t) {
  return t === void 0 && (t = !1), uO(e) || Cu(e) || !cl(e) || (xp(e) > 1 && (e.set = e.add = e.clear = e.delete = yue), Object.freeze(e), t && lf(e, function(n, r) {
    return lO(r, !0);
  }, !0)), e;
}
function yue() {
  Pi(2);
}
function uO(e) {
  return e == null || typeof e != "object" || Object.isFrozen(e);
}
function sc(e) {
  var t = v$[e];
  return t || Pi(18, e), t;
}
function bue(e, t) {
  v$[e] || (v$[e] = t);
}
function g$() {
  return process.env.NODE_ENV === "production" || xg || Pi(0), xg;
}
function m5(e, t) {
  t && (sc("Patches"), e.u = [], e.s = [], e.v = t);
}
function k_(e) {
  p$(e), e.p.forEach(_ue), e.p = null;
}
function p$(e) {
  e === xg && (xg = e.l);
}
function MN(e) {
  return xg = { p: [], l: xg, h: e, m: !0, _: 0 };
}
function _ue(e) {
  var t = e[Rr];
  t.i === 0 || t.i === 1 ? t.j() : t.g = !0;
}
function v5(e, t) {
  t._ = t.p.length;
  var n = t.p[0], r = e !== void 0 && e !== n;
  return t.h.O || sc("ES5").S(t, e, r), r ? (n[Rr].P && (k_(t), Pi(4)), cl(e) && (e = N_(t, e), t.l || D_(t, e)), t.u && sc("Patches").M(n[Rr].t, e, t.u, t.s)) : e = N_(t, n, []), k_(t), t.u && t.v(t.u, t.s), e !== sU ? e : void 0;
}
function N_(e, t, n) {
  if (uO(t))
    return t;
  var r = t[Rr];
  if (!r)
    return lf(t, function(s, c) {
      return kN(e, r, t, s, c, n);
    }, !0), t;
  if (r.A !== e)
    return t;
  if (!r.P)
    return D_(e, r.t, !0), r.t;
  if (!r.I) {
    r.I = !0, r.A._--;
    var i = r.i === 4 || r.i === 5 ? r.o = cO(r.k) : r.o, o = i, a = !1;
    r.i === 3 && (o = new Set(i), i.clear(), a = !0), lf(o, function(s, c) {
      return kN(e, r, i, s, c, n, a);
    }), D_(e, i, !1), n && e.u && sc("Patches").N(r, n, e.u, e.s);
  }
  return r.o;
}
function kN(e, t, n, r, i, o, a) {
  if (process.env.NODE_ENV !== "production" && i === n && Pi(5), Cu(i)) {
    var s = N_(e, i, o && t && t.i !== 3 && !ng(t.R, r) ? o.concat(r) : void 0);
    if (oU(n, r, s), !Cu(s))
      return;
    e.m = !1;
  } else
    a && n.add(i);
  if (cl(i) && !uO(i)) {
    if (!e.h.D && e._ < 1)
      return;
    N_(e, i), t && t.A.l || D_(e, i);
  }
}
function D_(e, t, n) {
  n === void 0 && (n = !1), !e.l && e.h.D && e.m && lO(t, n);
}
function y5(e, t) {
  var n = e[Rr];
  return (n ? Vl(n) : e)[t];
}
function NN(e, t) {
  if (t in e)
    for (var n = Object.getPrototypeOf(e); n; ) {
      var r = Object.getOwnPropertyDescriptor(n, t);
      if (r)
        return r;
      n = Object.getPrototypeOf(n);
    }
}
function ql(e) {
  e.P || (e.P = !0, e.l && ql(e.l));
}
function b5(e) {
  e.o || (e.o = cO(e.t));
}
function m$(e, t, n) {
  var r = aO(t) ? sc("MapSet").F(t, n) : sO(t) ? sc("MapSet").T(t, n) : e.O ? function(i, o) {
    var a = Array.isArray(i), s = { i: a ? 1 : 0, A: o ? o.A : g$(), P: !1, I: !1, R: {}, l: o, t: i, k: null, o: null, j: null, C: !1 }, c = s, l = rv;
    a && (c = [s], l = n0);
    var u = Proxy.revocable(c, l), d = u.revoke, f = u.proxy;
    return s.k = f, s.j = d, f;
  }(t, n) : sc("ES5").J(t, n);
  return (n ? n.A : g$()).p.push(r), r;
}
function Sue(e) {
  return Cu(e) || Pi(22, e), function t(n) {
    if (!cl(n))
      return n;
    var r, i = n[Rr], o = xp(n);
    if (i) {
      if (!i.P && (i.i < 4 || !sc("ES5").K(i)))
        return i.t;
      i.I = !0, r = DN(n, o), i.I = !1;
    } else
      r = DN(n, o);
    return lf(r, function(a, s) {
      i && vue(i.t, a) === s || oU(r, a, t(s));
    }), o === 3 ? new Set(r) : r;
  }(e);
}
function DN(e, t) {
  switch (t) {
    case 2:
      return new Map(e);
    case 3:
      return Array.from(e);
  }
  return cO(e);
}
function wue() {
  function e(a, s) {
    var c = o[a];
    return c ? c.enumerable = s : o[a] = c = { configurable: !0, enumerable: s, get: function() {
      var l = this[Rr];
      return process.env.NODE_ENV !== "production" && i(l), rv.get(l, a);
    }, set: function(l) {
      var u = this[Rr];
      process.env.NODE_ENV !== "production" && i(u), rv.set(u, a, l);
    } }, c;
  }
  function t(a) {
    for (var s = a.length - 1; s >= 0; s--) {
      var c = a[s][Rr];
      if (!c.P)
        switch (c.i) {
          case 5:
            r(c) && ql(c);
            break;
          case 4:
            n(c) && ql(c);
        }
    }
  }
  function n(a) {
    for (var s = a.t, c = a.k, l = rg(c), u = l.length - 1; u >= 0; u--) {
      var d = l[u];
      if (d !== Rr) {
        var f = s[d];
        if (f === void 0 && !ng(s, d))
          return !0;
        var h = c[d], p = h && h[Rr];
        if (p ? p.t !== f : !aU(h, f))
          return !0;
      }
    }
    var g = !!s[Rr];
    return l.length !== rg(s).length + (g ? 0 : 1);
  }
  function r(a) {
    var s = a.k;
    if (s.length !== a.t.length)
      return !0;
    var c = Object.getOwnPropertyDescriptor(s, s.length - 1);
    if (c && !c.get)
      return !0;
    for (var l = 0; l < s.length; l++)
      if (!s.hasOwnProperty(l))
        return !0;
    return !1;
  }
  function i(a) {
    a.g && Pi(3, JSON.stringify(Vl(a)));
  }
  var o = {};
  bue("ES5", { J: function(a, s) {
    var c = Array.isArray(a), l = function(d, f) {
      if (d) {
        for (var h = Array(f.length), p = 0; p < f.length; p++)
          Object.defineProperty(h, "" + p, e(p, !0));
        return h;
      }
      var g = cU(f);
      delete g[Rr];
      for (var m = rg(g), v = 0; v < m.length; v++) {
        var y = m[v];
        g[y] = e(y, d || !!g[y].enumerable);
      }
      return Object.create(Object.getPrototypeOf(f), g);
    }(c, a), u = { i: c ? 5 : 4, A: s ? s.A : g$(), P: !1, I: !1, R: {}, l: s, t: a, k: l, o: null, g: !1, C: !1 };
    return Object.defineProperty(l, Rr, { value: u, writable: !0 }), l;
  }, S: function(a, s, c) {
    c ? Cu(s) && s[Rr].A === a && t(a.p) : (a.u && function l(u) {
      if (u && typeof u == "object") {
        var d = u[Rr];
        if (d) {
          var f = d.t, h = d.k, p = d.R, g = d.i;
          if (g === 4)
            lf(h, function(b) {
              b !== Rr && (f[b] !== void 0 || ng(f, b) ? p[b] || l(h[b]) : (p[b] = !0, ql(d)));
            }), lf(f, function(b) {
              h[b] !== void 0 || ng(h, b) || (p[b] = !1, ql(d));
            });
          else if (g === 5) {
            if (r(d) && (ql(d), p.length = !0), h.length < f.length)
              for (var m = h.length; m < f.length; m++)
                p[m] = !1;
            else
              for (var v = f.length; v < h.length; v++)
                p[v] = !0;
            for (var y = Math.min(h.length, f.length), _ = 0; _ < y; _++)
              h.hasOwnProperty(_) || (p[_] = !0), p[_] === void 0 && l(h[_]);
          }
        }
      }
    }(a.p[0]), t(a.p));
  }, K: function(a) {
    return a.i === 4 ? n(a) : r(a);
  } });
}
var jN, xg, dO = typeof Symbol < "u" && typeof Symbol("x") == "symbol", xue = typeof Map < "u", Eue = typeof Set < "u", LN = typeof Proxy < "u" && Proxy.revocable !== void 0 && typeof Reflect < "u", sU = dO ? Symbol.for("immer-nothing") : ((jN = {})["immer-nothing"] = !0, jN), FN = dO ? Symbol.for("immer-draftable") : "__$immer_draftable", Rr = dO ? Symbol.for("immer-state") : "__$immer_state", Cue = { 0: "Illegal state", 1: "Immer drafts cannot have computed properties", 2: "This object has been frozen and should not be mutated", 3: function(e) {
  return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + e;
}, 4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.", 5: "Immer forbids circular references", 6: "The first or second argument to `produce` must be a function", 7: "The third argument to `produce` must be a function or undefined", 8: "First argument to `createDraft` must be a plain object, an array, or an immerable object", 9: "First argument to `finishDraft` must be a draft returned by `createDraft`", 10: "The given draft is already finalized", 11: "Object.defineProperty() cannot be used on an Immer draft", 12: "Object.setPrototypeOf() cannot be used on an Immer draft", 13: "Immer only supports deleting array indices", 14: "Immer only supports setting array indices and the 'length' property", 15: function(e) {
  return "Cannot apply patch, path doesn't resolve: " + e;
}, 16: 'Sets cannot have "replace" patches.', 17: function(e) {
  return "Unsupported patch operation: " + e;
}, 18: function(e) {
  return "The plugin for '" + e + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + e + "()` when initializing your application.";
}, 20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available", 21: function(e) {
  return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + e + "'";
}, 22: function(e) {
  return "'current' expects a draft, got: " + e;
}, 23: function(e) {
  return "'original' expects a draft, got: " + e;
}, 24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed" }, Tue = "" + Object.prototype.constructor, rg = typeof Reflect < "u" && Reflect.ownKeys ? Reflect.ownKeys : Object.getOwnPropertySymbols !== void 0 ? function(e) {
  return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
} : Object.getOwnPropertyNames, cU = Object.getOwnPropertyDescriptors || function(e) {
  var t = {};
  return rg(e).forEach(function(n) {
    t[n] = Object.getOwnPropertyDescriptor(e, n);
  }), t;
}, v$ = {}, rv = { get: function(e, t) {
  if (t === Rr)
    return e;
  var n = Vl(e);
  if (!ng(n, t))
    return function(i, o, a) {
      var s, c = NN(o, a);
      return c ? "value" in c ? c.value : (s = c.get) === null || s === void 0 ? void 0 : s.call(i.k) : void 0;
    }(e, n, t);
  var r = n[t];
  return e.I || !cl(r) ? r : r === y5(e.t, t) ? (b5(e), e.o[t] = m$(e.A.h, r, e)) : r;
}, has: function(e, t) {
  return t in Vl(e);
}, ownKeys: function(e) {
  return Reflect.ownKeys(Vl(e));
}, set: function(e, t, n) {
  var r = NN(Vl(e), t);
  if (r != null && r.set)
    return r.set.call(e.k, n), !0;
  if (!e.P) {
    var i = y5(Vl(e), t), o = i == null ? void 0 : i[Rr];
    if (o && o.t === n)
      return e.o[t] = n, e.R[t] = !1, !0;
    if (aU(n, i) && (n !== void 0 || ng(e.t, t)))
      return !0;
    b5(e), ql(e);
  }
  return e.o[t] === n && (n !== void 0 || t in e.o) || Number.isNaN(n) && Number.isNaN(e.o[t]) || (e.o[t] = n, e.R[t] = !0), !0;
}, deleteProperty: function(e, t) {
  return y5(e.t, t) !== void 0 || t in e.t ? (e.R[t] = !1, b5(e), ql(e)) : delete e.R[t], e.o && delete e.o[t], !0;
}, getOwnPropertyDescriptor: function(e, t) {
  var n = Vl(e), r = Reflect.getOwnPropertyDescriptor(n, t);
  return r && { writable: !0, configurable: e.i !== 1 || t !== "length", enumerable: r.enumerable, value: n[t] };
}, defineProperty: function() {
  Pi(11);
}, getPrototypeOf: function(e) {
  return Object.getPrototypeOf(e.t);
}, setPrototypeOf: function() {
  Pi(12);
} }, n0 = {};
lf(rv, function(e, t) {
  n0[e] = function() {
    return arguments[0] = arguments[0][0], t.apply(this, arguments);
  };
}), n0.deleteProperty = function(e, t) {
  return process.env.NODE_ENV !== "production" && isNaN(parseInt(t)) && Pi(13), n0.set.call(this, e, t, void 0);
}, n0.set = function(e, t, n) {
  return process.env.NODE_ENV !== "production" && t !== "length" && isNaN(parseInt(t)) && Pi(14), rv.set.call(this, e[0], t, n, e[0]);
};
var Iue = function() {
  function e(n) {
    var r = this;
    this.O = LN, this.D = !0, this.produce = function(i, o, a) {
      if (typeof i == "function" && typeof o != "function") {
        var s = o;
        o = i;
        var c = r;
        return function(g) {
          var m = this;
          g === void 0 && (g = s);
          for (var v = arguments.length, y = Array(v > 1 ? v - 1 : 0), _ = 1; _ < v; _++)
            y[_ - 1] = arguments[_];
          return c.produce(g, function(b) {
            var w;
            return (w = o).call.apply(w, [m, b].concat(y));
          });
        };
      }
      var l;
      if (typeof o != "function" && Pi(6), a !== void 0 && typeof a != "function" && Pi(7), cl(i)) {
        var u = MN(r), d = m$(r, i, void 0), f = !0;
        try {
          l = o(d), f = !1;
        } finally {
          f ? k_(u) : p$(u);
        }
        return typeof Promise < "u" && l instanceof Promise ? l.then(function(g) {
          return m5(u, a), v5(g, u);
        }, function(g) {
          throw k_(u), g;
        }) : (m5(u, a), v5(l, u));
      }
      if (!i || typeof i != "object") {
        if ((l = o(i)) === void 0 && (l = i), l === sU && (l = void 0), r.D && lO(l, !0), a) {
          var h = [], p = [];
          sc("Patches").M(i, l, h, p), a(h, p);
        }
        return l;
      }
      Pi(21, i);
    }, this.produceWithPatches = function(i, o) {
      if (typeof i == "function")
        return function(l) {
          for (var u = arguments.length, d = Array(u > 1 ? u - 1 : 0), f = 1; f < u; f++)
            d[f - 1] = arguments[f];
          return r.produceWithPatches(l, function(h) {
            return i.apply(void 0, [h].concat(d));
          });
        };
      var a, s, c = r.produce(i, o, function(l, u) {
        a = l, s = u;
      });
      return typeof Promise < "u" && c instanceof Promise ? c.then(function(l) {
        return [l, a, s];
      }) : [c, a, s];
    }, typeof (n == null ? void 0 : n.useProxies) == "boolean" && this.setUseProxies(n.useProxies), typeof (n == null ? void 0 : n.autoFreeze) == "boolean" && this.setAutoFreeze(n.autoFreeze);
  }
  var t = e.prototype;
  return t.createDraft = function(n) {
    cl(n) || Pi(8), Cu(n) && (n = Sue(n));
    var r = MN(this), i = m$(this, n, void 0);
    return i[Rr].C = !0, p$(r), i;
  }, t.finishDraft = function(n, r) {
    var i = n && n[Rr];
    process.env.NODE_ENV !== "production" && (i && i.C || Pi(9), i.I && Pi(10));
    var o = i.A;
    return m5(o, r), v5(void 0, o);
  }, t.setAutoFreeze = function(n) {
    this.D = n;
  }, t.setUseProxies = function(n) {
    n && !LN && Pi(20), this.O = n;
  }, t.applyPatches = function(n, r) {
    var i;
    for (i = r.length - 1; i >= 0; i--) {
      var o = r[i];
      if (o.path.length === 0 && o.op === "replace") {
        n = o.value;
        break;
      }
    }
    i > -1 && (r = r.slice(i + 1));
    var a = sc("Patches").$;
    return Cu(n) ? a(n, r) : this.produce(n, function(s) {
      return a(s, r);
    });
  }, e;
}(), Sa = new Iue(), lU = Sa.produce;
Sa.produceWithPatches.bind(Sa);
Sa.setAutoFreeze.bind(Sa);
Sa.setUseProxies.bind(Sa);
Sa.applyPatches.bind(Sa);
Sa.createDraft.bind(Sa);
Sa.finishDraft.bind(Sa);
function It(e) {
  "@babel/helpers - typeof";
  return It = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, It(e);
}
function $ue(e, t) {
  if (It(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (It(r) != "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function uU(e) {
  var t = $ue(e, "string");
  return It(t) == "symbol" ? t : t + "";
}
function oe(e, t, n) {
  return (t = uU(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function VN(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function ae(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? VN(Object(n), !0).forEach(function(r) {
      oe(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : VN(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function oo(e) {
  return "Minified Redux error #" + e + "; visit https://redux.js.org/Errors?code=" + e + " for the full message or use the non-minified dev environment for full errors. ";
}
var BN = function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
}(), _5 = function() {
  return Math.random().toString(36).substring(7).split("").join(".");
}, qd = {
  INIT: "@@redux/INIT" + _5(),
  REPLACE: "@@redux/REPLACE" + _5(),
  PROBE_UNKNOWN_ACTION: function() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + _5();
  }
};
function dU(e) {
  if (typeof e != "object" || e === null)
    return !1;
  for (var t = e; Object.getPrototypeOf(t) !== null; )
    t = Object.getPrototypeOf(t);
  return Object.getPrototypeOf(e) === t;
}
function Aue(e) {
  if (e === void 0)
    return "undefined";
  if (e === null)
    return "null";
  var t = typeof e;
  switch (t) {
    case "boolean":
    case "string":
    case "number":
    case "symbol":
    case "function":
      return t;
  }
  if (Array.isArray(e))
    return "array";
  if (Oue(e))
    return "date";
  if (Pue(e))
    return "error";
  var n = Rue(e);
  switch (n) {
    case "Symbol":
    case "Promise":
    case "WeakMap":
    case "WeakSet":
    case "Map":
    case "Set":
      return n;
  }
  return t.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function Rue(e) {
  return typeof e.constructor == "function" ? e.constructor.name : null;
}
function Pue(e) {
  return e instanceof Error || typeof e.message == "string" && e.constructor && typeof e.constructor.stackTraceLimit == "number";
}
function Oue(e) {
  return e instanceof Date ? !0 : typeof e.toDateString == "function" && typeof e.getDate == "function" && typeof e.setDate == "function";
}
function xd(e) {
  var t = typeof e;
  return process.env.NODE_ENV !== "production" && (t = Aue(e)), t;
}
function fU(e, t, n) {
  var r;
  if (typeof t == "function" && typeof n == "function" || typeof n == "function" && typeof arguments[3] == "function")
    throw new Error(process.env.NODE_ENV === "production" ? oo(0) : "It looks like you are passing several store enhancers to createStore(). This is not supported. Instead, compose them together to a single function. See https://redux.js.org/tutorials/fundamentals/part-4-store#creating-a-store-with-enhancers for an example.");
  if (typeof t == "function" && typeof n > "u" && (n = t, t = void 0), typeof n < "u") {
    if (typeof n != "function")
      throw new Error(process.env.NODE_ENV === "production" ? oo(1) : "Expected the enhancer to be a function. Instead, received: '" + xd(n) + "'");
    return n(fU)(e, t);
  }
  if (typeof e != "function")
    throw new Error(process.env.NODE_ENV === "production" ? oo(2) : "Expected the root reducer to be a function. Instead, received: '" + xd(e) + "'");
  var i = e, o = t, a = [], s = a, c = !1;
  function l() {
    s === a && (s = a.slice());
  }
  function u() {
    if (c)
      throw new Error(process.env.NODE_ENV === "production" ? oo(3) : "You may not call store.getState() while the reducer is executing. The reducer has already received the state as an argument. Pass it down from the top reducer instead of reading it from the store.");
    return o;
  }
  function d(g) {
    if (typeof g != "function")
      throw new Error(process.env.NODE_ENV === "production" ? oo(4) : "Expected the listener to be a function. Instead, received: '" + xd(g) + "'");
    if (c)
      throw new Error(process.env.NODE_ENV === "production" ? oo(5) : "You may not call store.subscribe() while the reducer is executing. If you would like to be notified after the store has been updated, subscribe from a component and invoke store.getState() in the callback to access the latest state. See https://redux.js.org/api/store#subscribelistener for more details.");
    var m = !0;
    return l(), s.push(g), function() {
      if (m) {
        if (c)
          throw new Error(process.env.NODE_ENV === "production" ? oo(6) : "You may not unsubscribe from a store listener while the reducer is executing. See https://redux.js.org/api/store#subscribelistener for more details.");
        m = !1, l();
        var y = s.indexOf(g);
        s.splice(y, 1), a = null;
      }
    };
  }
  function f(g) {
    if (!dU(g))
      throw new Error(process.env.NODE_ENV === "production" ? oo(7) : "Actions must be plain objects. Instead, the actual type was: '" + xd(g) + "'. You may need to add middleware to your store setup to handle dispatching other values, such as 'redux-thunk' to handle dispatching functions. See https://redux.js.org/tutorials/fundamentals/part-4-store#middleware and https://redux.js.org/tutorials/fundamentals/part-6-async-logic#using-the-redux-thunk-middleware for examples.");
    if (typeof g.type > "u")
      throw new Error(process.env.NODE_ENV === "production" ? oo(8) : 'Actions may not have an undefined "type" property. You may have misspelled an action type string constant.');
    if (c)
      throw new Error(process.env.NODE_ENV === "production" ? oo(9) : "Reducers may not dispatch actions.");
    try {
      c = !0, o = i(o, g);
    } finally {
      c = !1;
    }
    for (var m = a = s, v = 0; v < m.length; v++) {
      var y = m[v];
      y();
    }
    return g;
  }
  function h(g) {
    if (typeof g != "function")
      throw new Error(process.env.NODE_ENV === "production" ? oo(10) : "Expected the nextReducer to be a function. Instead, received: '" + xd(g));
    i = g, f({
      type: qd.REPLACE
    });
  }
  function p() {
    var g, m = d;
    return g = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function(y) {
        if (typeof y != "object" || y === null)
          throw new Error(process.env.NODE_ENV === "production" ? oo(11) : "Expected the observer to be an object. Instead, received: '" + xd(y) + "'");
        function _() {
          y.next && y.next(u());
        }
        _();
        var b = m(_);
        return {
          unsubscribe: b
        };
      }
    }, g[BN] = function() {
      return this;
    }, g;
  }
  return f({
    type: qd.INIT
  }), r = {
    dispatch: f,
    subscribe: d,
    getState: u,
    replaceReducer: h
  }, r[BN] = p, r;
}
function zN(e) {
  typeof console < "u" && typeof console.error == "function" && console.error(e);
  try {
    throw new Error(e);
  } catch {
  }
}
function Mue(e, t, n, r) {
  var i = Object.keys(t), o = n && n.type === qd.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
  if (i.length === 0)
    return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
  if (!dU(e))
    return "The " + o + ' has unexpected type of "' + xd(e) + '". Expected argument to be an object with the following ' + ('keys: "' + i.join('", "') + '"');
  var a = Object.keys(e).filter(function(s) {
    return !t.hasOwnProperty(s) && !r[s];
  });
  if (a.forEach(function(s) {
    r[s] = !0;
  }), !(n && n.type === qd.REPLACE) && a.length > 0)
    return "Unexpected " + (a.length > 1 ? "keys" : "key") + " " + ('"' + a.join('", "') + '" found in ' + o + ". ") + "Expected to find one of the known reducer keys instead: " + ('"' + i.join('", "') + '". Unexpected keys will be ignored.');
}
function kue(e) {
  Object.keys(e).forEach(function(t) {
    var n = e[t], r = n(void 0, {
      type: qd.INIT
    });
    if (typeof r > "u")
      throw new Error(process.env.NODE_ENV === "production" ? oo(12) : 'The slice reducer for key "' + t + `" returned undefined during initialization. If the state passed to the reducer is undefined, you must explicitly return the initial state. The initial state may not be undefined. If you don't want to set a value for this reducer, you can use null instead of undefined.`);
    if (typeof n(void 0, {
      type: qd.PROBE_UNKNOWN_ACTION()
    }) > "u")
      throw new Error(process.env.NODE_ENV === "production" ? oo(13) : 'The slice reducer for key "' + t + '" returned undefined when probed with a random type. ' + ("Don't try to handle '" + qd.INIT + `' or other actions in "redux/*" `) + "namespace. They are considered private. Instead, you must return the current state for any unknown actions, unless it is undefined, in which case you must return the initial state, regardless of the action type. The initial state may not be undefined, but can be null.");
  });
}
function hU(e) {
  for (var t = Object.keys(e), n = {}, r = 0; r < t.length; r++) {
    var i = t[r];
    process.env.NODE_ENV !== "production" && typeof e[i] > "u" && zN('No reducer provided for key "' + i + '"'), typeof e[i] == "function" && (n[i] = e[i]);
  }
  var o = Object.keys(n), a;
  process.env.NODE_ENV !== "production" && (a = {});
  var s;
  try {
    kue(n);
  } catch (c) {
    s = c;
  }
  return function(l, u) {
    if (l === void 0 && (l = {}), s)
      throw s;
    if (process.env.NODE_ENV !== "production") {
      var d = Mue(l, n, u, a);
      d && zN(d);
    }
    for (var f = !1, h = {}, p = 0; p < o.length; p++) {
      var g = o[p], m = n[g], v = l[g], y = m(v, u);
      if (typeof y > "u") {
        var _ = u && u.type;
        throw new Error(process.env.NODE_ENV === "production" ? oo(14) : "When called with an action of type " + (_ ? '"' + String(_) + '"' : "(unknown type)") + ', the slice reducer for key "' + g + '" returned undefined. To ignore an action, you must explicitly return the previous state. If you want this reducer to hold no value, you can return null instead of undefined.');
      }
      h[g] = y, f = f || y !== v;
    }
    return f = f || o.length !== Object.keys(l).length, f ? h : l;
  };
}
function j_() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return t.length === 0 ? function(r) {
    return r;
  } : t.length === 1 ? t[0] : t.reduce(function(r, i) {
    return function() {
      return r(i.apply(void 0, arguments));
    };
  });
}
function Nue() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return function(r) {
    return function() {
      var i = r.apply(void 0, arguments), o = function() {
        throw new Error(process.env.NODE_ENV === "production" ? oo(15) : "Dispatching while constructing your middleware is not allowed. Other middleware would not be applied to this dispatch.");
      }, a = {
        getState: i.getState,
        dispatch: function() {
          return o.apply(void 0, arguments);
        }
      }, s = t.map(function(c) {
        return c(a);
      });
      return o = j_.apply(void 0, s)(i.dispatch), ae(ae({}, i), {}, {
        dispatch: o
      });
    };
  };
}
function gU(e) {
  var t = function(r) {
    var i = r.dispatch, o = r.getState;
    return function(a) {
      return function(s) {
        return typeof s == "function" ? s(i, o, e) : a(s);
      };
    };
  };
  return t;
}
var pU = gU();
pU.withExtraArgument = gU;
const HN = pU;
var mU = globalThis && globalThis.__extends || function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (r[o] = i[o]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), Due = globalThis && globalThis.__generator || function(e, t) {
  var n = { label: 0, sent: function() {
    if (o[0] & 1)
      throw o[1];
    return o[1];
  }, trys: [], ops: [] }, r, i, o, a;
  return a = { next: s(0), throw: s(1), return: s(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function s(l) {
    return function(u) {
      return c([l, u]);
    };
  }
  function c(l) {
    if (r)
      throw new TypeError("Generator is already executing.");
    for (; n; )
      try {
        if (r = 1, i && (o = l[0] & 2 ? i.return : l[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, l[1])).done)
          return o;
        switch (i = 0, o && (l = [l[0] & 2, o.value]), l[0]) {
          case 0:
          case 1:
            o = l;
            break;
          case 4:
            return n.label++, { value: l[1], done: !1 };
          case 5:
            n.label++, i = l[1], l = [0];
            continue;
          case 7:
            l = n.ops.pop(), n.trys.pop();
            continue;
          default:
            if (o = n.trys, !(o = o.length > 0 && o[o.length - 1]) && (l[0] === 6 || l[0] === 2)) {
              n = 0;
              continue;
            }
            if (l[0] === 3 && (!o || l[1] > o[0] && l[1] < o[3])) {
              n.label = l[1];
              break;
            }
            if (l[0] === 6 && n.label < o[1]) {
              n.label = o[1], o = l;
              break;
            }
            if (o && n.label < o[2]) {
              n.label = o[2], n.ops.push(l);
              break;
            }
            o[2] && n.ops.pop(), n.trys.pop();
            continue;
        }
        l = t.call(e, n);
      } catch (u) {
        l = [6, u], i = 0;
      } finally {
        r = o = 0;
      }
    if (l[0] & 5)
      throw l[1];
    return { value: l[0] ? l[1] : void 0, done: !0 };
  }
}, Eg = globalThis && globalThis.__spreadArray || function(e, t) {
  for (var n = 0, r = t.length, i = e.length; n < r; n++, i++)
    e[i] = t[n];
  return e;
}, jue = Object.defineProperty, Lue = Object.defineProperties, Fue = Object.getOwnPropertyDescriptors, UN = Object.getOwnPropertySymbols, Vue = Object.prototype.hasOwnProperty, Bue = Object.prototype.propertyIsEnumerable, WN = function(e, t, n) {
  return t in e ? jue(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
}, uu = function(e, t) {
  for (var n in t || (t = {}))
    Vue.call(t, n) && WN(e, n, t[n]);
  if (UN)
    for (var r = 0, i = UN(t); r < i.length; r++) {
      var n = i[r];
      Bue.call(t, n) && WN(e, n, t[n]);
    }
  return e;
}, S5 = function(e, t) {
  return Lue(e, Fue(t));
}, zue = function(e, t, n) {
  return new Promise(function(r, i) {
    var o = function(c) {
      try {
        s(n.next(c));
      } catch (l) {
        i(l);
      }
    }, a = function(c) {
      try {
        s(n.throw(c));
      } catch (l) {
        i(l);
      }
    }, s = function(c) {
      return c.done ? r(c.value) : Promise.resolve(c.value).then(o, a);
    };
    s((n = n.apply(e, t)).next());
  });
}, Hue = typeof window < "u" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
  if (arguments.length !== 0)
    return typeof arguments[0] == "object" ? j_ : j_.apply(null, arguments);
};
function vU(e) {
  if (typeof e != "object" || e === null)
    return !1;
  var t = Object.getPrototypeOf(e);
  if (t === null)
    return !0;
  for (var n = t; Object.getPrototypeOf(n) !== null; )
    n = Object.getPrototypeOf(n);
  return t === n;
}
var Uue = function(e) {
  return e && typeof e.match == "function";
};
function du(e, t) {
  function n() {
    for (var r = [], i = 0; i < arguments.length; i++)
      r[i] = arguments[i];
    if (t) {
      var o = t.apply(void 0, r);
      if (!o)
        throw new Error("prepareAction did not return an object");
      return uu(uu({
        type: e,
        payload: o.payload
      }, "meta" in o && { meta: o.meta }), "error" in o && { error: o.error });
    }
    return { type: e, payload: r[0] };
  }
  return n.toString = function() {
    return "" + e;
  }, n.type = e, n.match = function(r) {
    return r.type === e;
  }, n;
}
function Wue(e) {
  return typeof e == "function" && "type" in e && Uue(e);
}
function que(e) {
  var t = e ? ("" + e).split("/") : [], n = t[t.length - 1] || "actionCreator";
  return 'Detected an action creator with type "' + (e || "unknown") + `" being dispatched. 
Make sure you're calling the action creator before dispatching, i.e. \`dispatch(` + n + "())` instead of `dispatch(" + n + ")`. This is necessary even if the action has no payload.";
}
function Gue(e) {
  if (e === void 0 && (e = {}), process.env.NODE_ENV === "production")
    return function() {
      return function(r) {
        return function(i) {
          return r(i);
        };
      };
    };
  var t = e.isActionCreator, n = t === void 0 ? Wue : t;
  return function() {
    return function(r) {
      return function(i) {
        return n(i) && console.warn(que(i.type)), r(i);
      };
    };
  };
}
function yU(e, t) {
  var n = 0;
  return {
    measureTime: function(r) {
      var i = Date.now();
      try {
        return r();
      } finally {
        var o = Date.now();
        n += o - i;
      }
    },
    warnIfExceeded: function() {
      n > e && console.warn(t + " took " + n + "ms, which is more than the warning threshold of " + e + `ms. 
If your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.
It is disabled in production builds, so you don't need to worry about that.`);
    }
  };
}
var Kue = (
  /** @class */
  function(e) {
    mU(t, e);
    function t() {
      for (var n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      var i = e.apply(this, n) || this;
      return Object.setPrototypeOf(i, t.prototype), i;
    }
    return Object.defineProperty(t, Symbol.species, {
      get: function() {
        return t;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.concat = function() {
      for (var n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      return e.prototype.concat.apply(this, n);
    }, t.prototype.prepend = function() {
      for (var n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      return n.length === 1 && Array.isArray(n[0]) ? new (t.bind.apply(t, Eg([void 0], n[0].concat(this))))() : new (t.bind.apply(t, Eg([void 0], n.concat(this))))();
    }, t;
  }(Array)
), Yue = (
  /** @class */
  function(e) {
    mU(t, e);
    function t() {
      for (var n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      var i = e.apply(this, n) || this;
      return Object.setPrototypeOf(i, t.prototype), i;
    }
    return Object.defineProperty(t, Symbol.species, {
      get: function() {
        return t;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.concat = function() {
      for (var n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      return e.prototype.concat.apply(this, n);
    }, t.prototype.prepend = function() {
      for (var n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      return n.length === 1 && Array.isArray(n[0]) ? new (t.bind.apply(t, Eg([void 0], n[0].concat(this))))() : new (t.bind.apply(t, Eg([void 0], n.concat(this))))();
    }, t;
  }(Array)
);
function y$(e) {
  return cl(e) ? lU(e, function() {
  }) : e;
}
var Xue = process.env.NODE_ENV === "production", qN = "Invariant failed";
function GN(e, t) {
  if (!e)
    throw Xue ? new Error(qN) : new Error(qN + ": " + (t || ""));
}
function Que(e, t, n, r) {
  return JSON.stringify(e, Jue(t, r), n);
}
function Jue(e, t) {
  var n = [], r = [];
  return t || (t = function(i, o) {
    return n[0] === o ? "[Circular ~]" : "[Circular ~." + r.slice(0, n.indexOf(o)).join(".") + "]";
  }), function(i, o) {
    if (n.length > 0) {
      var a = n.indexOf(this);
      ~a ? n.splice(a + 1) : n.push(this), ~a ? r.splice(a, 1 / 0, i) : r.push(i), ~n.indexOf(o) && (o = t.call(this, i, o));
    } else
      n.push(o);
    return e == null ? o : e.call(this, i, o);
  };
}
function Zue(e) {
  return typeof e != "object" || e == null || Object.isFrozen(e);
}
function ede(e, t, n) {
  var r = bU(e, t, n);
  return {
    detectMutations: function() {
      return _U(e, t, r, n);
    }
  };
}
function bU(e, t, n, r, i) {
  t === void 0 && (t = []), r === void 0 && (r = ""), i === void 0 && (i = /* @__PURE__ */ new Set());
  var o = { value: n };
  if (!e(n) && !i.has(n)) {
    i.add(n), o.children = {};
    for (var a in n) {
      var s = r ? r + "." + a : a;
      t.length && t.indexOf(s) !== -1 || (o.children[a] = bU(e, t, n[a], s));
    }
  }
  return o;
}
function _U(e, t, n, r, i, o) {
  t === void 0 && (t = []), i === void 0 && (i = !1), o === void 0 && (o = "");
  var a = n ? n.value : void 0, s = a === r;
  if (i && !s && !Number.isNaN(r))
    return { wasMutated: !0, path: o };
  if (e(a) || e(r))
    return { wasMutated: !1 };
  var c = {};
  for (var l in n.children)
    c[l] = !0;
  for (var l in r)
    c[l] = !0;
  var u = t.length > 0, d = function(h) {
    var p = o ? o + "." + h : h;
    if (u) {
      var g = t.some(function(v) {
        return v instanceof RegExp ? v.test(p) : p === v;
      });
      if (g)
        return "continue";
    }
    var m = _U(e, t, n.children[h], r[h], s, p);
    if (m.wasMutated)
      return { value: m };
  };
  for (var l in c) {
    var f = d(l);
    if (typeof f == "object")
      return f.value;
  }
  return { wasMutated: !1 };
}
function tde(e) {
  if (e === void 0 && (e = {}), process.env.NODE_ENV === "production")
    return function() {
      return function(c) {
        return function(l) {
          return c(l);
        };
      };
    };
  var t = e.isImmutable, n = t === void 0 ? Zue : t, r = e.ignoredPaths, i = e.warnAfter, o = i === void 0 ? 32 : i, a = e.ignore;
  r = r || a;
  var s = ede.bind(null, n, r);
  return function(c) {
    var l = c.getState, u = l(), d = s(u), f;
    return function(h) {
      return function(p) {
        var g = yU(o, "ImmutableStateInvariantMiddleware");
        g.measureTime(function() {
          u = l(), f = d.detectMutations(), d = s(u), GN(!f.wasMutated, "A state mutation was detected between dispatches, in the path '" + (f.path || "") + "'.  This may cause incorrect behavior. (https://redux.js.org/style-guide/style-guide#do-not-mutate-state)");
        });
        var m = h(p);
        return g.measureTime(function() {
          u = l(), f = d.detectMutations(), d = s(u), f.wasMutated && GN(!f.wasMutated, "A state mutation was detected inside a dispatch, in the path: " + (f.path || "") + ". Take a look at the reducer(s) handling the action " + Que(p) + ". (https://redux.js.org/style-guide/style-guide#do-not-mutate-state)");
        }), g.warnIfExceeded(), m;
      };
    };
  };
}
function SU(e) {
  var t = typeof e;
  return e == null || t === "string" || t === "boolean" || t === "number" || Array.isArray(e) || vU(e);
}
function b$(e, t, n, r, i, o) {
  t === void 0 && (t = ""), n === void 0 && (n = SU), i === void 0 && (i = []);
  var a;
  if (!n(e))
    return {
      keyPath: t || "<root>",
      value: e
    };
  if (typeof e != "object" || e === null || o != null && o.has(e))
    return !1;
  for (var s = r != null ? r(e) : Object.entries(e), c = i.length > 0, l = function(m, v) {
    var y = t ? t + "." + m : m;
    if (c) {
      var _ = i.some(function(b) {
        return b instanceof RegExp ? b.test(y) : y === b;
      });
      if (_)
        return "continue";
    }
    if (!n(v))
      return { value: {
        keyPath: y,
        value: v
      } };
    if (typeof v == "object" && (a = b$(v, y, n, r, i, o), a))
      return { value: a };
  }, u = 0, d = s; u < d.length; u++) {
    var f = d[u], h = f[0], p = f[1], g = l(h, p);
    if (typeof g == "object")
      return g.value;
  }
  return o && wU(e) && o.add(e), !1;
}
function wU(e) {
  if (!Object.isFrozen(e))
    return !1;
  for (var t = 0, n = Object.values(e); t < n.length; t++) {
    var r = n[t];
    if (!(typeof r != "object" || r === null) && !wU(r))
      return !1;
  }
  return !0;
}
function nde(e) {
  if (e === void 0 && (e = {}), process.env.NODE_ENV === "production")
    return function() {
      return function(_) {
        return function(b) {
          return _(b);
        };
      };
    };
  var t = e.isSerializable, n = t === void 0 ? SU : t, r = e.getEntries, i = e.ignoredActions, o = i === void 0 ? [] : i, a = e.ignoredActionPaths, s = a === void 0 ? ["meta.arg", "meta.baseQueryMeta"] : a, c = e.ignoredPaths, l = c === void 0 ? [] : c, u = e.warnAfter, d = u === void 0 ? 32 : u, f = e.ignoreState, h = f === void 0 ? !1 : f, p = e.ignoreActions, g = p === void 0 ? !1 : p, m = e.disableCache, v = m === void 0 ? !1 : m, y = !v && WeakSet ? /* @__PURE__ */ new WeakSet() : void 0;
  return function(_) {
    return function(b) {
      return function(w) {
        var C = b(w), x = yU(d, "SerializableStateInvariantMiddleware");
        return !g && !(o.length && o.indexOf(w.type) !== -1) && x.measureTime(function() {
          var T = b$(w, "", n, r, s, y);
          if (T) {
            var E = T.keyPath, R = T.value;
            console.error("A non-serializable value was detected in an action, in the path: `" + E + "`. Value:", R, `
Take a look at the logic that dispatched this action: `, w, `
(See https://redux.js.org/faq/actions#why-should-type-be-a-string-or-at-least-serializable-why-should-my-action-types-be-constants)`, `
(To allow non-serializable values see: https://redux-toolkit.js.org/usage/usage-guide#working-with-non-serializable-data)`);
          }
        }), h || (x.measureTime(function() {
          var T = _.getState(), E = b$(T, "", n, r, l, y);
          if (E) {
            var R = E.keyPath, I = E.value;
            console.error("A non-serializable value was detected in the state, in the path: `" + R + "`. Value:", I, `
Take a look at the reducer(s) handling this action type: ` + w.type + `.
(See https://redux.js.org/faq/organizing-state#can-i-put-functions-promises-or-other-non-serializable-items-in-my-store-state)`);
          }
        }), x.warnIfExceeded()), C;
      };
    };
  };
}
function Mb(e) {
  return typeof e == "boolean";
}
function rde() {
  return function(t) {
    return ide(t);
  };
}
function ide(e) {
  e === void 0 && (e = {});
  var t = e.thunk, n = t === void 0 ? !0 : t, r = e.immutableCheck, i = r === void 0 ? !0 : r, o = e.serializableCheck, a = o === void 0 ? !0 : o, s = e.actionCreatorCheck, c = s === void 0 ? !0 : s, l = new Kue();
  if (n && (Mb(n) ? l.push(HN) : l.push(HN.withExtraArgument(n.extraArgument))), process.env.NODE_ENV !== "production") {
    if (i) {
      var u = {};
      Mb(i) || (u = i), l.unshift(tde(u));
    }
    if (a) {
      var d = {};
      Mb(a) || (d = a), l.push(nde(d));
    }
    if (c) {
      var f = {};
      Mb(c) || (f = c), l.unshift(Gue(f));
    }
  }
  return l;
}
var w5 = process.env.NODE_ENV === "production";
function ode(e) {
  var t = rde(), n = e || {}, r = n.reducer, i = r === void 0 ? void 0 : r, o = n.middleware, a = o === void 0 ? t() : o, s = n.devTools, c = s === void 0 ? !0 : s, l = n.preloadedState, u = l === void 0 ? void 0 : l, d = n.enhancers, f = d === void 0 ? void 0 : d, h;
  if (typeof i == "function")
    h = i;
  else if (vU(i))
    h = hU(i);
  else
    throw new Error('"reducer" is a required argument, and must be a function or an object of functions that can be passed to combineReducers');
  var p = a;
  if (typeof p == "function" && (p = p(t), !w5 && !Array.isArray(p)))
    throw new Error("when using a middleware builder function, an array of middleware must be returned");
  if (!w5 && p.some(function(b) {
    return typeof b != "function";
  }))
    throw new Error("each middleware provided to configureStore must be a function");
  var g = Nue.apply(void 0, p), m = j_;
  c && (m = Hue(uu({
    trace: !w5
  }, typeof c == "object" && c)));
  var v = new Yue(g), y = v;
  Array.isArray(f) ? y = Eg([g], f) : typeof f == "function" && (y = f(v));
  var _ = m.apply(void 0, y);
  return fU(h, u, _);
}
function xU(e) {
  var t = {}, n = [], r, i = {
    addCase: function(o, a) {
      if (process.env.NODE_ENV !== "production") {
        if (n.length > 0)
          throw new Error("`builder.addCase` should only be called before calling `builder.addMatcher`");
        if (r)
          throw new Error("`builder.addCase` should only be called before calling `builder.addDefaultCase`");
      }
      var s = typeof o == "string" ? o : o.type;
      if (!s)
        throw new Error("`builder.addCase` cannot be called with an empty action type");
      if (s in t)
        throw new Error("`builder.addCase` cannot be called with two reducers for the same action type");
      return t[s] = a, i;
    },
    addMatcher: function(o, a) {
      if (process.env.NODE_ENV !== "production" && r)
        throw new Error("`builder.addMatcher` should only be called before calling `builder.addDefaultCase`");
      return n.push({ matcher: o, reducer: a }), i;
    },
    addDefaultCase: function(o) {
      if (process.env.NODE_ENV !== "production" && r)
        throw new Error("`builder.addDefaultCase` can only be called once");
      return r = o, i;
    }
  };
  return e(i), [t, n, r];
}
function ade(e) {
  return typeof e == "function";
}
var KN = !1;
function sde(e, t, n, r) {
  n === void 0 && (n = []), process.env.NODE_ENV !== "production" && typeof t == "object" && (KN || (KN = !0, console.warn("The object notation for `createReducer` is deprecated, and will be removed in RTK 2.0. Please use the 'builder callback' notation instead: https://redux-toolkit.js.org/api/createReducer")));
  var i = typeof t == "function" ? xU(t) : [t, n, r], o = i[0], a = i[1], s = i[2], c;
  if (ade(e))
    c = function() {
      return y$(e());
    };
  else {
    var l = y$(e);
    c = function() {
      return l;
    };
  }
  function u(d, f) {
    d === void 0 && (d = c());
    var h = Eg([
      o[f.type]
    ], a.filter(function(p) {
      var g = p.matcher;
      return g(f);
    }).map(function(p) {
      var g = p.reducer;
      return g;
    }));
    return h.filter(function(p) {
      return !!p;
    }).length === 0 && (h = [s]), h.reduce(function(p, g) {
      if (g)
        if (Cu(p)) {
          var m = p, v = g(m, f);
          return v === void 0 ? p : v;
        } else {
          if (cl(p))
            return lU(p, function(y) {
              return g(y, f);
            });
          var v = g(p, f);
          if (v === void 0) {
            if (p === null)
              return p;
            throw Error("A case reducer on a non-draftable value must not return undefined");
          }
          return v;
        }
      return p;
    }, d);
  }
  return u.getInitialState = c, u;
}
var YN = !1;
function cde(e, t) {
  return e + "/" + t;
}
function lde(e) {
  var t = e.name;
  if (!t)
    throw new Error("`name` is a required option for createSlice");
  typeof process < "u" && process.env.NODE_ENV === "development" && e.initialState === void 0 && console.error("You must provide an `initialState` value that is not `undefined`. You may have misspelled `initialState`");
  var n = typeof e.initialState == "function" ? e.initialState : y$(e.initialState), r = e.reducers || {}, i = Object.keys(r), o = {}, a = {}, s = {};
  i.forEach(function(u) {
    var d = r[u], f = cde(t, u), h, p;
    "reducer" in d ? (h = d.reducer, p = d.prepare) : h = d, o[u] = h, a[f] = h, s[u] = p ? du(f, p) : du(f);
  });
  function c() {
    process.env.NODE_ENV !== "production" && typeof e.extraReducers == "object" && (YN || (YN = !0, console.warn("The object notation for `createSlice.extraReducers` is deprecated, and will be removed in RTK 2.0. Please use the 'builder callback' notation instead: https://redux-toolkit.js.org/api/createSlice")));
    var u = typeof e.extraReducers == "function" ? xU(e.extraReducers) : [e.extraReducers], d = u[0], f = d === void 0 ? {} : d, h = u[1], p = h === void 0 ? [] : h, g = u[2], m = g === void 0 ? void 0 : g, v = uu(uu({}, f), a);
    return sde(n, function(y) {
      for (var _ in v)
        y.addCase(_, v[_]);
      for (var b = 0, w = p; b < w.length; b++) {
        var C = w[b];
        y.addMatcher(C.matcher, C.reducer);
      }
      m && y.addDefaultCase(m);
    });
  }
  var l;
  return {
    name: t,
    reducer: function(u, d) {
      return l || (l = c()), l(u, d);
    },
    actions: s,
    caseReducers: o,
    getInitialState: function() {
      return l || (l = c()), l.getInitialState();
    }
  };
}
var ude = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW", dde = function(e) {
  e === void 0 && (e = 21);
  for (var t = "", n = e; n--; )
    t += ude[Math.random() * 64 | 0];
  return t;
}, fde = [
  "name",
  "message",
  "stack",
  "code"
], x5 = (
  /** @class */
  function() {
    function e(t, n) {
      this.payload = t, this.meta = n;
    }
    return e;
  }()
), XN = (
  /** @class */
  function() {
    function e(t, n) {
      this.payload = t, this.meta = n;
    }
    return e;
  }()
), hde = function(e) {
  if (typeof e == "object" && e !== null) {
    for (var t = {}, n = 0, r = fde; n < r.length; n++) {
      var i = r[n];
      typeof e[i] == "string" && (t[i] = e[i]);
    }
    return t;
  }
  return { message: String(e) };
};
(function() {
  function e(t, n, r) {
    var i = du(t + "/fulfilled", function(u, d, f, h) {
      return {
        payload: u,
        meta: S5(uu({}, h || {}), {
          arg: f,
          requestId: d,
          requestStatus: "fulfilled"
        })
      };
    }), o = du(t + "/pending", function(u, d, f) {
      return {
        payload: void 0,
        meta: S5(uu({}, f || {}), {
          arg: d,
          requestId: u,
          requestStatus: "pending"
        })
      };
    }), a = du(t + "/rejected", function(u, d, f, h, p) {
      return {
        payload: h,
        error: (r && r.serializeError || hde)(u || "Rejected"),
        meta: S5(uu({}, p || {}), {
          arg: f,
          requestId: d,
          rejectedWithValue: !!h,
          requestStatus: "rejected",
          aborted: (u == null ? void 0 : u.name) === "AbortError",
          condition: (u == null ? void 0 : u.name) === "ConditionError"
        })
      };
    }), s = !1, c = typeof AbortController < "u" ? AbortController : (
      /** @class */
      function() {
        function u() {
          this.signal = {
            aborted: !1,
            addEventListener: function() {
            },
            dispatchEvent: function() {
              return !1;
            },
            onabort: function() {
            },
            removeEventListener: function() {
            },
            reason: void 0,
            throwIfAborted: function() {
            }
          };
        }
        return u.prototype.abort = function() {
          process.env.NODE_ENV !== "production" && (s || (s = !0, console.info("This platform does not implement AbortController. \nIf you want to use the AbortController to react to `abort` events, please consider importing a polyfill like 'abortcontroller-polyfill/dist/abortcontroller-polyfill-only'.")));
        }, u;
      }()
    );
    function l(u) {
      return function(d, f, h) {
        var p = r != null && r.idGenerator ? r.idGenerator(u) : dde(), g = new c(), m;
        function v(_) {
          m = _, g.abort();
        }
        var y = function() {
          return zue(this, null, function() {
            var _, b, w, C, x, T, E;
            return Due(this, function(R) {
              switch (R.label) {
                case 0:
                  return R.trys.push([0, 4, , 5]), C = (_ = r == null ? void 0 : r.condition) == null ? void 0 : _.call(r, u, { getState: f, extra: h }), pde(C) ? [4, C] : [3, 2];
                case 1:
                  C = R.sent(), R.label = 2;
                case 2:
                  if (C === !1 || g.signal.aborted)
                    throw {
                      name: "ConditionError",
                      message: "Aborted due to condition callback returning false."
                    };
                  return x = new Promise(function(I, O) {
                    return g.signal.addEventListener("abort", function() {
                      return O({
                        name: "AbortError",
                        message: m || "Aborted"
                      });
                    });
                  }), d(o(p, u, (b = r == null ? void 0 : r.getPendingMeta) == null ? void 0 : b.call(r, { requestId: p, arg: u }, { getState: f, extra: h }))), [4, Promise.race([
                    x,
                    Promise.resolve(n(u, {
                      dispatch: d,
                      getState: f,
                      extra: h,
                      requestId: p,
                      signal: g.signal,
                      abort: v,
                      rejectWithValue: function(I, O) {
                        return new x5(I, O);
                      },
                      fulfillWithValue: function(I, O) {
                        return new XN(I, O);
                      }
                    })).then(function(I) {
                      if (I instanceof x5)
                        throw I;
                      return I instanceof XN ? i(I.payload, p, u, I.meta) : i(I, p, u);
                    })
                  ])];
                case 3:
                  return w = R.sent(), [3, 5];
                case 4:
                  return T = R.sent(), w = T instanceof x5 ? a(null, p, u, T.payload, T.meta) : a(T, p, u), [3, 5];
                case 5:
                  return E = r && !r.dispatchConditionRejection && a.match(w) && w.meta.condition, E || d(w), [2, w];
              }
            });
          });
        }();
        return Object.assign(y, {
          abort: v,
          requestId: p,
          arg: u,
          unwrap: function() {
            return y.then(gde);
          }
        });
      };
    }
    return Object.assign(l, {
      pending: o,
      rejected: a,
      fulfilled: i,
      typePrefix: t
    });
  }
  return e.withTypes = function() {
    return e;
  }, e;
})();
function gde(e) {
  if (e.meta && e.meta.rejectedWithValue)
    throw e.payload;
  if (e.error)
    throw e.error;
  return e.payload;
}
function pde(e) {
  return e !== null && typeof e == "object" && typeof e.then == "function";
}
var fO = "listenerMiddleware";
du(fO + "/add");
du(fO + "/removeAll");
du(fO + "/remove");
var QN;
typeof queueMicrotask == "function" && queueMicrotask.bind(typeof window < "u" ? window : typeof global < "u" ? global : globalThis);
wue();
var mde = new fle(function(e) {
  return e.complete();
});
const RCt = (e) => e.replace(/[^A-ZA-z]/g, ""), PCt = (e, t) => e.substring(0, t), OCt = (e, t) => e && e.trim().length <= t, MCt = (e) => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(e), E5 = (e, t) => {
  if (e === void 0)
    return 0;
  const n = new Date(e), i = new Date(t).getTime() - n.getTime();
  return isNaN(i) ? 0 : i / 1e3;
}, vde = () => {
  const e = navigator.userAgent;
  return /(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(e) ? "tablet" : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
    e
  ) ? "mobile" : "desktop";
};
function yde() {
  this.__data__ = [], this.size = 0;
}
var bde = yde;
function _de(e, t) {
  return e === t || e !== e && t !== t;
}
var jf = _de, Sde = jf;
function wde(e, t) {
  for (var n = e.length; n--; )
    if (Sde(e[n][0], t))
      return n;
  return -1;
}
var Sx = wde, xde = Sx, Ede = Array.prototype, Cde = Ede.splice;
function Tde(e) {
  var t = this.__data__, n = xde(t, e);
  if (n < 0)
    return !1;
  var r = t.length - 1;
  return n == r ? t.pop() : Cde.call(t, n, 1), --this.size, !0;
}
var Ide = Tde, $de = Sx;
function Ade(e) {
  var t = this.__data__, n = $de(t, e);
  return n < 0 ? void 0 : t[n][1];
}
var Rde = Ade, Pde = Sx;
function Ode(e) {
  return Pde(this.__data__, e) > -1;
}
var Mde = Ode, kde = Sx;
function Nde(e, t) {
  var n = this.__data__, r = kde(n, e);
  return r < 0 ? (++this.size, n.push([e, t])) : n[r][1] = t, this;
}
var Dde = Nde, jde = bde, Lde = Ide, Fde = Rde, Vde = Mde, Bde = Dde;
function Ep(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
Ep.prototype.clear = jde;
Ep.prototype.delete = Lde;
Ep.prototype.get = Fde;
Ep.prototype.has = Vde;
Ep.prototype.set = Bde;
var wx = Ep, zde = wx;
function Hde() {
  this.__data__ = new zde(), this.size = 0;
}
var Ude = Hde;
function Wde(e) {
  var t = this.__data__, n = t.delete(e);
  return this.size = t.size, n;
}
var qde = Wde;
function Gde(e) {
  return this.__data__.get(e);
}
var Kde = Gde;
function Yde(e) {
  return this.__data__.has(e);
}
var Xde = Yde, Qde = typeof t0 == "object" && t0 && t0.Object === Object && t0, EU = Qde, Jde = EU, Zde = typeof self == "object" && self && self.Object === Object && self, efe = Jde || Zde || Function("return this")(), $c = efe, tfe = $c, nfe = tfe.Symbol, Cp = nfe, JN = Cp, CU = Object.prototype, rfe = CU.hasOwnProperty, ife = CU.toString, Em = JN ? JN.toStringTag : void 0;
function ofe(e) {
  var t = rfe.call(e, Em), n = e[Em];
  try {
    e[Em] = void 0;
    var r = !0;
  } catch {
  }
  var i = ife.call(e);
  return r && (t ? e[Em] = n : delete e[Em]), i;
}
var afe = ofe, sfe = Object.prototype, cfe = sfe.toString;
function lfe(e) {
  return cfe.call(e);
}
var ufe = lfe, ZN = Cp, dfe = afe, ffe = ufe, hfe = "[object Null]", gfe = "[object Undefined]", e7 = ZN ? ZN.toStringTag : void 0;
function pfe(e) {
  return e == null ? e === void 0 ? gfe : hfe : e7 && e7 in Object(e) ? dfe(e) : ffe(e);
}
var wl = pfe;
function mfe(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var Ya = mfe;
const _$ = /* @__PURE__ */ vn(Ya);
var vfe = wl, yfe = Ya, bfe = "[object AsyncFunction]", _fe = "[object Function]", Sfe = "[object GeneratorFunction]", wfe = "[object Proxy]";
function xfe(e) {
  if (!yfe(e))
    return !1;
  var t = vfe(e);
  return t == _fe || t == Sfe || t == bfe || t == wfe;
}
var xx = xfe;
const Efe = /* @__PURE__ */ vn(xx);
var Cfe = $c, Tfe = Cfe["__core-js_shared__"], Ife = Tfe, C5 = Ife, t7 = function() {
  var e = /[^.]+$/.exec(C5 && C5.keys && C5.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function $fe(e) {
  return !!t7 && t7 in e;
}
var Afe = $fe, Rfe = Function.prototype, Pfe = Rfe.toString;
function Ofe(e) {
  if (e != null) {
    try {
      return Pfe.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var TU = Ofe, Mfe = xx, kfe = Afe, Nfe = Ya, Dfe = TU, jfe = /[\\^$.*+?()[\]{}|]/g, Lfe = /^\[object .+?Constructor\]$/, Ffe = Function.prototype, Vfe = Object.prototype, Bfe = Ffe.toString, zfe = Vfe.hasOwnProperty, Hfe = RegExp(
  "^" + Bfe.call(zfe).replace(jfe, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function Ufe(e) {
  if (!Nfe(e) || kfe(e))
    return !1;
  var t = Mfe(e) ? Hfe : Lfe;
  return t.test(Dfe(e));
}
var Wfe = Ufe;
function qfe(e, t) {
  return e == null ? void 0 : e[t];
}
var Gfe = qfe, Kfe = Wfe, Yfe = Gfe;
function Xfe(e, t) {
  var n = Yfe(e, t);
  return Kfe(n) ? n : void 0;
}
var Lf = Xfe, Qfe = Lf, Jfe = $c, Zfe = Qfe(Jfe, "Map"), hO = Zfe, ehe = Lf, the = ehe(Object, "create"), Ex = the, n7 = Ex;
function nhe() {
  this.__data__ = n7 ? n7(null) : {}, this.size = 0;
}
var rhe = nhe;
function ihe(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var ohe = ihe, ahe = Ex, she = "__lodash_hash_undefined__", che = Object.prototype, lhe = che.hasOwnProperty;
function uhe(e) {
  var t = this.__data__;
  if (ahe) {
    var n = t[e];
    return n === she ? void 0 : n;
  }
  return lhe.call(t, e) ? t[e] : void 0;
}
var dhe = uhe, fhe = Ex, hhe = Object.prototype, ghe = hhe.hasOwnProperty;
function phe(e) {
  var t = this.__data__;
  return fhe ? t[e] !== void 0 : ghe.call(t, e);
}
var mhe = phe, vhe = Ex, yhe = "__lodash_hash_undefined__";
function bhe(e, t) {
  var n = this.__data__;
  return this.size += this.has(e) ? 0 : 1, n[e] = vhe && t === void 0 ? yhe : t, this;
}
var _he = bhe, She = rhe, whe = ohe, xhe = dhe, Ehe = mhe, Che = _he;
function Tp(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
Tp.prototype.clear = She;
Tp.prototype.delete = whe;
Tp.prototype.get = xhe;
Tp.prototype.has = Ehe;
Tp.prototype.set = Che;
var The = Tp, r7 = The, Ihe = wx, $he = hO;
function Ahe() {
  this.size = 0, this.__data__ = {
    hash: new r7(),
    map: new ($he || Ihe)(),
    string: new r7()
  };
}
var Rhe = Ahe;
function Phe(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
var Ohe = Phe, Mhe = Ohe;
function khe(e, t) {
  var n = e.__data__;
  return Mhe(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
}
var Cx = khe, Nhe = Cx;
function Dhe(e) {
  var t = Nhe(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
var jhe = Dhe, Lhe = Cx;
function Fhe(e) {
  return Lhe(this, e).get(e);
}
var Vhe = Fhe, Bhe = Cx;
function zhe(e) {
  return Bhe(this, e).has(e);
}
var Hhe = zhe, Uhe = Cx;
function Whe(e, t) {
  var n = Uhe(this, e), r = n.size;
  return n.set(e, t), this.size += n.size == r ? 0 : 1, this;
}
var qhe = Whe, Ghe = Rhe, Khe = jhe, Yhe = Vhe, Xhe = Hhe, Qhe = qhe;
function Ip(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
Ip.prototype.clear = Ghe;
Ip.prototype.delete = Khe;
Ip.prototype.get = Yhe;
Ip.prototype.has = Xhe;
Ip.prototype.set = Qhe;
var gO = Ip, Jhe = wx, Zhe = hO, ege = gO, tge = 200;
function nge(e, t) {
  var n = this.__data__;
  if (n instanceof Jhe) {
    var r = n.__data__;
    if (!Zhe || r.length < tge - 1)
      return r.push([e, t]), this.size = ++n.size, this;
    n = this.__data__ = new ege(r);
  }
  return n.set(e, t), this.size = n.size, this;
}
var rge = nge, ige = wx, oge = Ude, age = qde, sge = Kde, cge = Xde, lge = rge;
function $p(e) {
  var t = this.__data__ = new ige(e);
  this.size = t.size;
}
$p.prototype.clear = oge;
$p.prototype.delete = age;
$p.prototype.get = sge;
$p.prototype.has = cge;
$p.prototype.set = lge;
var Tx = $p, uge = "__lodash_hash_undefined__";
function dge(e) {
  return this.__data__.set(e, uge), this;
}
var fge = dge;
function hge(e) {
  return this.__data__.has(e);
}
var gge = hge, pge = gO, mge = fge, vge = gge;
function L_(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.__data__ = new pge(); ++t < n; )
    this.add(e[t]);
}
L_.prototype.add = L_.prototype.push = mge;
L_.prototype.has = vge;
var pO = L_;
function yge(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length; ++n < r; )
    if (t(e[n], n, e))
      return !0;
  return !1;
}
var bge = yge;
function _ge(e, t) {
  return e.has(t);
}
var mO = _ge, Sge = pO, wge = bge, xge = mO, Ege = 1, Cge = 2;
function Tge(e, t, n, r, i, o) {
  var a = n & Ege, s = e.length, c = t.length;
  if (s != c && !(a && c > s))
    return !1;
  var l = o.get(e), u = o.get(t);
  if (l && u)
    return l == t && u == e;
  var d = -1, f = !0, h = n & Cge ? new Sge() : void 0;
  for (o.set(e, t), o.set(t, e); ++d < s; ) {
    var p = e[d], g = t[d];
    if (r)
      var m = a ? r(g, p, d, t, e, o) : r(p, g, d, e, t, o);
    if (m !== void 0) {
      if (m)
        continue;
      f = !1;
      break;
    }
    if (h) {
      if (!wge(t, function(v, y) {
        if (!xge(h, y) && (p === v || i(p, v, n, r, o)))
          return h.push(y);
      })) {
        f = !1;
        break;
      }
    } else if (!(p === g || i(p, g, n, r, o))) {
      f = !1;
      break;
    }
  }
  return o.delete(e), o.delete(t), f;
}
var IU = Tge, Ige = $c, $ge = Ige.Uint8Array, $U = $ge;
function Age(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(r, i) {
    n[++t] = [i, r];
  }), n;
}
var Rge = Age;
function Pge(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(r) {
    n[++t] = r;
  }), n;
}
var vO = Pge, i7 = Cp, o7 = $U, Oge = jf, Mge = IU, kge = Rge, Nge = vO, Dge = 1, jge = 2, Lge = "[object Boolean]", Fge = "[object Date]", Vge = "[object Error]", Bge = "[object Map]", zge = "[object Number]", Hge = "[object RegExp]", Uge = "[object Set]", Wge = "[object String]", qge = "[object Symbol]", Gge = "[object ArrayBuffer]", Kge = "[object DataView]", a7 = i7 ? i7.prototype : void 0, T5 = a7 ? a7.valueOf : void 0;
function Yge(e, t, n, r, i, o, a) {
  switch (n) {
    case Kge:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case Gge:
      return !(e.byteLength != t.byteLength || !o(new o7(e), new o7(t)));
    case Lge:
    case Fge:
    case zge:
      return Oge(+e, +t);
    case Vge:
      return e.name == t.name && e.message == t.message;
    case Hge:
    case Wge:
      return e == t + "";
    case Bge:
      var s = kge;
    case Uge:
      var c = r & Dge;
      if (s || (s = Nge), e.size != t.size && !c)
        return !1;
      var l = a.get(e);
      if (l)
        return l == t;
      r |= jge, a.set(e, t);
      var u = Mge(s(e), s(t), r, i, o, a);
      return a.delete(e), u;
    case qge:
      if (T5)
        return T5.call(e) == T5.call(t);
  }
  return !1;
}
var Xge = Yge;
function Qge(e, t) {
  for (var n = -1, r = t.length, i = e.length; ++n < r; )
    e[i + n] = t[n];
  return e;
}
var yO = Qge, Jge = Array.isArray, Yi = Jge, Zge = yO, epe = Yi;
function tpe(e, t, n) {
  var r = t(e);
  return epe(e) ? r : Zge(r, n(e));
}
var AU = tpe;
function npe(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length, i = 0, o = []; ++n < r; ) {
    var a = e[n];
    t(a, n, e) && (o[i++] = a);
  }
  return o;
}
var RU = npe;
function rpe() {
  return [];
}
var PU = rpe, ipe = RU, ope = PU, ape = Object.prototype, spe = ape.propertyIsEnumerable, s7 = Object.getOwnPropertySymbols, cpe = s7 ? function(e) {
  return e == null ? [] : (e = Object(e), ipe(s7(e), function(t) {
    return spe.call(e, t);
  }));
} : ope, bO = cpe;
function lpe(e, t) {
  for (var n = -1, r = Array(e); ++n < e; )
    r[n] = t(n);
  return r;
}
var upe = lpe;
function dpe(e) {
  return e != null && typeof e == "object";
}
var Xa = dpe, fpe = wl, hpe = Xa, gpe = "[object Arguments]";
function ppe(e) {
  return hpe(e) && fpe(e) == gpe;
}
var mpe = ppe, c7 = mpe, vpe = Xa, OU = Object.prototype, ype = OU.hasOwnProperty, bpe = OU.propertyIsEnumerable, _pe = c7(function() {
  return arguments;
}()) ? c7 : function(e) {
  return vpe(e) && ype.call(e, "callee") && !bpe.call(e, "callee");
}, ny = _pe, F_ = { exports: {} };
function Spe() {
  return !1;
}
var wpe = Spe;
F_.exports;
(function(e, t) {
  var n = $c, r = wpe, i = t && !t.nodeType && t, o = i && !0 && e && !e.nodeType && e, a = o && o.exports === i, s = a ? n.Buffer : void 0, c = s ? s.isBuffer : void 0, l = c || r;
  e.exports = l;
})(F_, F_.exports);
var ry = F_.exports, xpe = 9007199254740991, Epe = /^(?:0|[1-9]\d*)$/;
function Cpe(e, t) {
  var n = typeof e;
  return t = t ?? xpe, !!t && (n == "number" || n != "symbol" && Epe.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var Ix = Cpe, Tpe = 9007199254740991;
function Ipe(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= Tpe;
}
var _O = Ipe, $pe = wl, Ape = _O, Rpe = Xa, Ppe = "[object Arguments]", Ope = "[object Array]", Mpe = "[object Boolean]", kpe = "[object Date]", Npe = "[object Error]", Dpe = "[object Function]", jpe = "[object Map]", Lpe = "[object Number]", Fpe = "[object Object]", Vpe = "[object RegExp]", Bpe = "[object Set]", zpe = "[object String]", Hpe = "[object WeakMap]", Upe = "[object ArrayBuffer]", Wpe = "[object DataView]", qpe = "[object Float32Array]", Gpe = "[object Float64Array]", Kpe = "[object Int8Array]", Ype = "[object Int16Array]", Xpe = "[object Int32Array]", Qpe = "[object Uint8Array]", Jpe = "[object Uint8ClampedArray]", Zpe = "[object Uint16Array]", eme = "[object Uint32Array]", yr = {};
yr[qpe] = yr[Gpe] = yr[Kpe] = yr[Ype] = yr[Xpe] = yr[Qpe] = yr[Jpe] = yr[Zpe] = yr[eme] = !0;
yr[Ppe] = yr[Ope] = yr[Upe] = yr[Mpe] = yr[Wpe] = yr[kpe] = yr[Npe] = yr[Dpe] = yr[jpe] = yr[Lpe] = yr[Fpe] = yr[Vpe] = yr[Bpe] = yr[zpe] = yr[Hpe] = !1;
function tme(e) {
  return Rpe(e) && Ape(e.length) && !!yr[$pe(e)];
}
var nme = tme;
function rme(e) {
  return function(t) {
    return e(t);
  };
}
var Ap = rme, V_ = { exports: {} };
V_.exports;
(function(e, t) {
  var n = EU, r = t && !t.nodeType && t, i = r && !0 && e && !e.nodeType && e, o = i && i.exports === r, a = o && n.process, s = function() {
    try {
      var c = i && i.require && i.require("util").types;
      return c || a && a.binding && a.binding("util");
    } catch {
    }
  }();
  e.exports = s;
})(V_, V_.exports);
var $x = V_.exports, ime = nme, ome = Ap, l7 = $x, u7 = l7 && l7.isTypedArray, ame = u7 ? ome(u7) : ime, Ax = ame, sme = upe, cme = ny, lme = Yi, ume = ry, dme = Ix, fme = Ax, hme = Object.prototype, gme = hme.hasOwnProperty;
function pme(e, t) {
  var n = lme(e), r = !n && cme(e), i = !n && !r && ume(e), o = !n && !r && !i && fme(e), a = n || r || i || o, s = a ? sme(e.length, String) : [], c = s.length;
  for (var l in e)
    (t || gme.call(e, l)) && !(a && // Safari 9 has enumerable `arguments.length` in strict mode.
    (l == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    i && (l == "offset" || l == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    o && (l == "buffer" || l == "byteLength" || l == "byteOffset") || // Skip index properties.
    dme(l, c))) && s.push(l);
  return s;
}
var MU = pme, mme = Object.prototype;
function vme(e) {
  var t = e && e.constructor, n = typeof t == "function" && t.prototype || mme;
  return e === n;
}
var iy = vme;
function yme(e, t) {
  return function(n) {
    return e(t(n));
  };
}
var kU = yme, bme = kU, _me = bme(Object.keys, Object), Sme = _me, wme = iy, xme = Sme, Eme = Object.prototype, Cme = Eme.hasOwnProperty;
function Tme(e) {
  if (!wme(e))
    return xme(e);
  var t = [];
  for (var n in Object(e))
    Cme.call(e, n) && n != "constructor" && t.push(n);
  return t;
}
var NU = Tme, Ime = xx, $me = _O;
function Ame(e) {
  return e != null && $me(e.length) && !Ime(e);
}
var qu = Ame, Rme = MU, Pme = NU, Ome = qu;
function Mme(e) {
  return Ome(e) ? Rme(e) : Pme(e);
}
var Rp = Mme, kme = AU, Nme = bO, Dme = Rp;
function jme(e) {
  return kme(e, Dme, Nme);
}
var DU = jme, d7 = DU, Lme = 1, Fme = Object.prototype, Vme = Fme.hasOwnProperty;
function Bme(e, t, n, r, i, o) {
  var a = n & Lme, s = d7(e), c = s.length, l = d7(t), u = l.length;
  if (c != u && !a)
    return !1;
  for (var d = c; d--; ) {
    var f = s[d];
    if (!(a ? f in t : Vme.call(t, f)))
      return !1;
  }
  var h = o.get(e), p = o.get(t);
  if (h && p)
    return h == t && p == e;
  var g = !0;
  o.set(e, t), o.set(t, e);
  for (var m = a; ++d < c; ) {
    f = s[d];
    var v = e[f], y = t[f];
    if (r)
      var _ = a ? r(y, v, f, t, e, o) : r(v, y, f, e, t, o);
    if (!(_ === void 0 ? v === y || i(v, y, n, r, o) : _)) {
      g = !1;
      break;
    }
    m || (m = f == "constructor");
  }
  if (g && !m) {
    var b = e.constructor, w = t.constructor;
    b != w && "constructor" in e && "constructor" in t && !(typeof b == "function" && b instanceof b && typeof w == "function" && w instanceof w) && (g = !1);
  }
  return o.delete(e), o.delete(t), g;
}
var zme = Bme, Hme = Lf, Ume = $c, Wme = Hme(Ume, "DataView"), qme = Wme, Gme = Lf, Kme = $c, Yme = Gme(Kme, "Promise"), Xme = Yme, Qme = Lf, Jme = $c, Zme = Qme(Jme, "Set"), jU = Zme, e0e = Lf, t0e = $c, n0e = e0e(t0e, "WeakMap"), r0e = n0e, S$ = qme, w$ = hO, x$ = Xme, E$ = jU, C$ = r0e, LU = wl, Pp = TU, f7 = "[object Map]", i0e = "[object Object]", h7 = "[object Promise]", g7 = "[object Set]", p7 = "[object WeakMap]", m7 = "[object DataView]", o0e = Pp(S$), a0e = Pp(w$), s0e = Pp(x$), c0e = Pp(E$), l0e = Pp(C$), Ed = LU;
(S$ && Ed(new S$(new ArrayBuffer(1))) != m7 || w$ && Ed(new w$()) != f7 || x$ && Ed(x$.resolve()) != h7 || E$ && Ed(new E$()) != g7 || C$ && Ed(new C$()) != p7) && (Ed = function(e) {
  var t = LU(e), n = t == i0e ? e.constructor : void 0, r = n ? Pp(n) : "";
  if (r)
    switch (r) {
      case o0e:
        return m7;
      case a0e:
        return f7;
      case s0e:
        return h7;
      case c0e:
        return g7;
      case l0e:
        return p7;
    }
  return t;
});
var oy = Ed, I5 = Tx, u0e = IU, d0e = Xge, f0e = zme, v7 = oy, y7 = Yi, b7 = ry, h0e = Ax, g0e = 1, _7 = "[object Arguments]", S7 = "[object Array]", kb = "[object Object]", p0e = Object.prototype, w7 = p0e.hasOwnProperty;
function m0e(e, t, n, r, i, o) {
  var a = y7(e), s = y7(t), c = a ? S7 : v7(e), l = s ? S7 : v7(t);
  c = c == _7 ? kb : c, l = l == _7 ? kb : l;
  var u = c == kb, d = l == kb, f = c == l;
  if (f && b7(e)) {
    if (!b7(t))
      return !1;
    a = !0, u = !1;
  }
  if (f && !u)
    return o || (o = new I5()), a || h0e(e) ? u0e(e, t, n, r, i, o) : d0e(e, t, c, n, r, i, o);
  if (!(n & g0e)) {
    var h = u && w7.call(e, "__wrapped__"), p = d && w7.call(t, "__wrapped__");
    if (h || p) {
      var g = h ? e.value() : e, m = p ? t.value() : t;
      return o || (o = new I5()), i(g, m, n, r, o);
    }
  }
  return f ? (o || (o = new I5()), f0e(e, t, n, r, i, o)) : !1;
}
var v0e = m0e, y0e = v0e, x7 = Xa;
function FU(e, t, n, r, i) {
  return e === t ? !0 : e == null || t == null || !x7(e) && !x7(t) ? e !== e && t !== t : y0e(e, t, n, r, FU, i);
}
var SO = FU, b0e = SO;
function _0e(e, t) {
  return b0e(e, t);
}
var S0e = _0e;
const VU = /* @__PURE__ */ vn(S0e);
function w0e(e, t, n) {
  var i, o;
  const r = (i = e.sectionNavigation) == null ? void 0 : i.questionSections[t.id];
  return !r || !t.completesSection || t.hideUi || t.type === "hidden" || nv(t) || !n || n.id === t.id || (o = e.completedSectionIds) != null && o.includes(r) ? e.completedSectionIds : [...e.completedSectionIds ?? [], r];
}
function x0e(e, t) {
  var i, o;
  const n = t && ((i = e.sectionNavigation) == null ? void 0 : i.questionSections[t]);
  if (((o = e.sectionNavigation) == null ? void 0 : o.mode) !== "review" || !n)
    return e.unlockedSectionIds;
  const r = e.unlockedSectionIds ?? [];
  return r.includes(n) ? r : [...r, n];
}
function E7(e, t) {
  var r, i, o;
  const n = t && ((r = e.sectionNavigation) == null ? void 0 : r.questionSections[t]);
  return ((i = e.sectionNavigation) == null ? void 0 : i.mode) !== "review" || !n || !!((o = e.unlockedSectionIds) != null && o.includes(n));
}
function C7(e, t) {
  var s;
  const n = e.sectionNavigation;
  if ((n == null ? void 0 : n.mode) !== "review" || VU((s = e.currentAnswer) == null ? void 0 : s.value, t.value))
    return {};
  const r = n.questionSections[t.questionId];
  if (!r && !n.introductionQuestionIds.includes(t.questionId))
    return {};
  const i = n.sectionIds.indexOf(r), o = e.unlockedSectionIds ?? [], a = o.filter((c) => n.sectionIds.indexOf(c) <= i);
  return {
    // Persistence watches this array by reference; replace it only when locks change.
    unlockedSectionIds: a.length === o.length ? e.unlockedSectionIds : a,
    questionHistory: e.questionHistory.filter((c) => {
      const l = c.qid && n.questionSections[c.qid];
      return !l || a.includes(l);
    })
  };
}
const T7 = {
  surveyId: null,
  submissionId: null,
  currentQuestionId: null,
  currentQuestionType: void 0,
  userAnswers: {},
  currentAnswer: void 0,
  questionHistory: [],
  timeOnCurrentQuestion: "",
  // error: () => ({ type: ERROR }),
  // log: services.loggingService,
  isSubmitClicked: !1,
  direction: "forwards",
  isHydrated: !1,
  initialised: !1
}, I7 = (e) => ({
  qid: e.currentQuestionId,
  questionType: e.currentQuestionType
});
function $7(e) {
  return e === null ? "" : e;
}
function hh(e, t) {
  return {
    ...hle(e),
    ...t,
    aggregateAnswers: e.aggregateAnswers === !0,
    qStartTime: (/* @__PURE__ */ new Date()).toUTCString()
  };
}
const BU = lde({
  name: "survey",
  initialState: T7,
  reducers: {
    configureSectionNavigation: (e, t) => {
      var o;
      const n = Vle(
        a$(t.payload)
      ), r = e.currentQuestionId && (n == null ? void 0 : n.questionSections[e.currentQuestionId]), i = (n == null ? void 0 : n.mode) === "review" ? (e.unlockedSectionIds ?? (r ? [r] : [])).filter(
        (a) => n.sectionIds.includes(a)
      ) : void 0;
      return {
        ...e,
        sectionNavigation: n,
        unlockedSectionIds: i,
        completedSectionIds: (o = e.completedSectionIds) == null ? void 0 : o.filter(
          (a) => n == null ? void 0 : n.sectionIds.includes(a)
        )
      };
    },
    goToSection: (e, t) => {
      const { survey: n, sectionId: r } = t.payload;
      if (!e.sectionNavigation)
        return e;
      const i = s$(
        a$(n),
        n.questions,
        e
      ).find((s) => s.id === r);
      if (!(i != null && i.targetQuestionId) || i.disabledReason || i.targetQuestionId === e.currentQuestionId)
        return e;
      const o = n.questions.find((s) => s.id === i.targetQuestionId);
      if (!o)
        return e;
      let a = e.userAnswers;
      if (e.currentAnswer && e.currentQuestionId) {
        const s = (/* @__PURE__ */ new Date()).toUTCString();
        a = {
          ...a,
          [e.currentQuestionId]: {
            ...e.currentAnswer,
            qEndTime: s,
            timeTaken: (e.currentAnswer.timeTaken ?? 0) + E5(e.currentAnswer.qStartTime, s)
          }
        };
      }
      return {
        ...e,
        userAnswers: a,
        currentQuestionId: o.id,
        currentQuestionType: o.type,
        currentAnswer: hh(o, a[o.id]),
        questionHistory: [I7(e), ...e.questionHistory],
        // A section entry executes its leading calculations even when its index is earlier.
        direction: "forwards"
      };
    },
    initialise: (e, t) => {
      var c;
      let n;
      const { questions: r, startQuestionId: i, surveyId: o, existingState: a } = t.payload;
      if (a && a.initialised) {
        let l;
        if (a.currentQuestionId && a.currentQuestionType) {
          const u = r.find(
            (f) => f.id === a.currentQuestionId
          ), d = (c = a.userAnswers) == null ? void 0 : c[a.currentQuestionId];
          l = u ? hh(u, d) : d ?? {
            questionId: a.currentQuestionId,
            questionType: a.currentQuestionType,
            aggregateAnswers: !1,
            value: null,
            qStartTime: (/* @__PURE__ */ new Date()).toUTCString()
          };
        }
        return {
          ...e,
          ...a,
          surveyId: o,
          currentAnswer: l,
          isHydrated: !0
        };
      }
      if (!a || !a.initialised)
        return n = i && r.find((l) => l.id === i) || r[0], {
          ...T7,
          surveyId: o,
          currentQuestionId: n.id,
          currentQuestionType: n.type,
          currentAnswer: hh(n),
          isHydrated: !0
        };
      e.currentQuestionId !== null ? n = r.find((l) => l.id === e.currentQuestionId) || r[0] : i ? n = r.find((l) => l.id === i) || r[0] : n = r[0];
      const s = hh(n, e.currentAnswer);
      return {
        ...e,
        surveyId: o,
        currentQuestionId: n.id,
        currentQuestionType: n.type,
        currentAnswer: s,
        isHydrated: !0
      };
    },
    setSubmissionId: (e, t) => ({
      ...e,
      submissionId: t.payload
    }),
    goToNextQuestion: (e, t) => {
      var s;
      let n;
      const r = t.payload.find((c) => c.id === e.currentQuestionId);
      if (!r)
        return e;
      if (r.next)
        n = r.next({
          answers: new C0(e.userAnswers, new Q1())
        });
      else {
        const c = t.payload.findIndex((l) => l.id === e.currentQuestionId) + 1;
        c >= t.payload.length ? n = e.currentQuestionId : n = t.payload[c].id;
      }
      const i = r.type === "hidden" ? e.questionHistory : [I7(e)].concat(e.questionHistory);
      let o = t.payload.find((c) => c.id === n), a = 0;
      for (; o != null && o.skip && o.skip({
        answers: new C0(e.userAnswers, new Q1())
      }); ) {
        if (a = t.payload.findIndex((c) => c.id === n) + 1, a >= t.payload.length)
          break;
        o = t.payload[a], n = o.id;
      }
      return {
        ...e,
        currentQuestionId: n,
        unlockedSectionIds: x0e(e, n),
        completedSectionIds: w0e(e, r, o),
        currentQuestionType: (s = t.payload.find((c) => c.id === n)) == null ? void 0 : s.type,
        questionHistory: i,
        currentAnswer: void 0,
        direction: "forwards"
      };
    },
    goToPreviousQuestion: (e, t) => {
      var o;
      const n = t.payload, r = n == null ? void 0 : n.find((a) => a.id === e.currentQuestionId);
      if (r != null && r.previous) {
        const a = r.previous({
          answers: new C0(e.userAnswers, new Q1())
        });
        return E7(e, a) ? {
          ...e,
          currentQuestionId: a,
          currentQuestionType: (o = n == null ? void 0 : n.find((s) => s.id === a)) == null ? void 0 : o.type,
          currentAnswer: void 0,
          direction: "backwards"
        } : e;
      }
      const i = e.questionHistory.filter((a) => E7(e, a.qid));
      return i.length > 0 ? {
        ...e,
        currentQuestionId: i[0].qid,
        currentQuestionType: i[0].questionType,
        questionHistory: i.slice(1),
        currentAnswer: void 0,
        direction: "backwards"
      } : e;
    },
    updateAnswer: (e) => {
      var t, n, r;
      if (e.currentAnswer) {
        const i = (/* @__PURE__ */ new Date()).toUTCString(), o = E5((t = e.currentAnswer) == null ? void 0 : t.qStartTime, i), a = {
          ...e.currentAnswer,
          qEndTime: i,
          timeTaken: (n = e.currentAnswer) != null && n.timeTaken ? ((r = e.currentAnswer) == null ? void 0 : r.timeTaken) + o : o
        }, s = $7(e.currentQuestionId);
        return {
          ...e,
          userAnswers: {
            ...e.userAnswers,
            [s]: a
          },
          currentAnswer: void 0
        };
      }
      return e;
    },
    recordAnswer: (e) => {
      var t, n, r;
      if (e.currentAnswer && e.currentQuestionId !== null) {
        const i = (/* @__PURE__ */ new Date()).toUTCString(), o = E5((t = e.currentAnswer) == null ? void 0 : t.qStartTime, i), a = {
          ...e.currentAnswer,
          qEndTime: i,
          timeTaken: (n = e.currentAnswer) != null && n.timeTaken ? ((r = e.currentAnswer) == null ? void 0 : r.timeTaken) + o : o
        };
        return {
          ...e,
          userAnswers: {
            ...e.userAnswers,
            [e.currentQuestionId]: a
          }
        };
      }
      return e;
    },
    retrieveAnswer: (e, t) => {
      const n = $7(e.currentQuestionId), r = t.payload.find((i) => i.id === e.currentQuestionId);
      if (n in e.userAnswers && r) {
        const i = e.userAnswers[n];
        return {
          ...e,
          currentAnswer: hh(r, i)
        };
      } else if (r)
        return {
          ...e,
          currentAnswer: hh(r)
        };
      return e;
    },
    injectCurrent: (e, t) => {
      if (e.currentAnswer) {
        const n = { ...e.currentAnswer, ...t.payload };
        return {
          ...e,
          ...C7(e, n),
          currentAnswer: n
        };
      }
      return e;
    },
    updateCurrent: (e, t) => ({
      ...e,
      ...C7(e, t.payload),
      currentAnswer: t.payload,
      currentQuestionId: t.payload.questionId
    }),
    onSubmitClicked: (e) => ({
      ...e,
      isSubmitClicked: !0
    })
  }
}), {
  configureSectionNavigation: E0e,
  goToSection: C0e,
  initialise: kCt,
  setSubmissionId: zU,
  goToNextQuestion: T0e,
  goToPreviousQuestion: I0e,
  updateAnswer: A7,
  retrieveAnswer: R7,
  injectCurrent: $0e,
  updateCurrent: HU,
  recordAnswer: UU,
  onSubmitClicked: A0e
} = BU.actions, R0e = BU.reducer;
class P0e {
  constructor(t) {
    ve(this, "store");
    ve(this, "user");
    ve(this, "userSubscription");
    ve(this, "databaseManager");
    ve(this, "userManager");
    ve(this, "readySubject", new Gs(!1));
    ve(this, "log");
    ve(this, "initialised", !1);
    this.store = ode({
      reducer: this.rootReducer(),
      middleware: (n) => this.getMiddleware(n)
    }), this.log = t;
  }
  rootReducer() {
    return hU({
      survey: R0e
    });
  }
  async initialise(t, n, r, i, o, a) {
    if (this.log.info("ReduxStoreManager", "initialise"), this.initialised) {
      this.log.info("ReduxStoreManager already initialized, skippping");
      return;
    }
    this.initialised = !0, this.databaseManager = n;
    const s = {
      surveyId: t.settings.surveyName,
      questions: t.questions,
      startQuestionId: t.settings.startQuestionId
    };
    a && (s.existingState = a), this.store.dispatch({ type: "survey/initialise", payload: s }), this.store.dispatch(E0e(t)), this.store.dispatch(zU(i)), this.userManager = r, this.userSubscription = this.userManager.observeUser().subscribe({
      next: async (c) => {
        c.user && c.initialised && this.subscribeDatabase(c.user, t, i, o);
      },
      error: (c) => {
        const l = c;
        this.log.error("Error observing current user", { error: l }), this.readySubject.error(l);
      }
    }), this.log.info("ReduxStoreManager", "initialised");
  }
  dispose() {
    var t;
    (t = this.userSubscription) == null || t.unsubscribe();
  }
  observeReady() {
    return this.readySubject;
  }
  async subscribeDatabase(t, n, r, i) {
    var o;
    if (this.log.info("subscribeDatabase", t, n.settings.surveyName, r, i), !t) {
      this.readySubject.next(!1);
      return;
    }
    try {
      await ((o = this.databaseManager) == null ? void 0 : o.subscribeToStore(
        this.store,
        n.settings.surveyName,
        t,
        r
      )), this.log.info("ReduxStoreManager", "subscribeDatabase", "database subscribed"), this.readySubject.next(!0);
    } catch (a) {
      const s = a;
      this.log.error("Error connecting database to redux store.", { error: s }), this.readySubject.next(!1);
    }
  }
  getStore() {
    return this.store;
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getMiddleware(t) {
    return t({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: [
          "survey/goToNextQuestion",
          "survey/goToPreviousQuestion",
          "survey/retrieveAnswer",
          "survey/initialise",
          "survey/configureSectionNavigation",
          "survey/goToSection"
        ],
        // Ignore these field paths in all actions
        ignoredActionPaths: [
          "payload.choices",
          "payload.defaultValues",
          "payload.header",
          "payload.text",
          "payload.outputs"
        ]
      }
    });
  }
}
const WU = mue, uf = _x, O0e = () => {
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const qU = function(e) {
  const t = [];
  let n = 0;
  for (let r = 0; r < e.length; r++) {
    let i = e.charCodeAt(r);
    i < 128 ? t[n++] = i : i < 2048 ? (t[n++] = i >> 6 | 192, t[n++] = i & 63 | 128) : (i & 64512) === 55296 && r + 1 < e.length && (e.charCodeAt(r + 1) & 64512) === 56320 ? (i = 65536 + ((i & 1023) << 10) + (e.charCodeAt(++r) & 1023), t[n++] = i >> 18 | 240, t[n++] = i >> 12 & 63 | 128, t[n++] = i >> 6 & 63 | 128, t[n++] = i & 63 | 128) : (t[n++] = i >> 12 | 224, t[n++] = i >> 6 & 63 | 128, t[n++] = i & 63 | 128);
  }
  return t;
}, M0e = function(e) {
  const t = [];
  let n = 0, r = 0;
  for (; n < e.length; ) {
    const i = e[n++];
    if (i < 128)
      t[r++] = String.fromCharCode(i);
    else if (i > 191 && i < 224) {
      const o = e[n++];
      t[r++] = String.fromCharCode((i & 31) << 6 | o & 63);
    } else if (i > 239 && i < 365) {
      const o = e[n++], a = e[n++], s = e[n++], c = ((i & 7) << 18 | (o & 63) << 12 | (a & 63) << 6 | s & 63) - 65536;
      t[r++] = String.fromCharCode(55296 + (c >> 10)), t[r++] = String.fromCharCode(56320 + (c & 1023));
    } else {
      const o = e[n++], a = e[n++];
      t[r++] = String.fromCharCode((i & 15) << 12 | (o & 63) << 6 | a & 63);
    }
  }
  return t.join("");
}, GU = {
  /**
   * Maps bytes to characters.
   */
  byteToCharMap_: null,
  /**
   * Maps characters to bytes.
   */
  charToByteMap_: null,
  /**
   * Maps bytes to websafe characters.
   * @private
   */
  byteToCharMapWebSafe_: null,
  /**
   * Maps websafe characters to bytes.
   * @private
   */
  charToByteMapWebSafe_: null,
  /**
   * Our default alphabet, shared between
   * ENCODED_VALS and ENCODED_VALS_WEBSAFE
   */
  ENCODED_VALS_BASE: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
  /**
   * Our default alphabet. Value 64 (=) is special; it means "nothing."
   */
  get ENCODED_VALS() {
    return this.ENCODED_VALS_BASE + "+/=";
  },
  /**
   * Our websafe alphabet.
   */
  get ENCODED_VALS_WEBSAFE() {
    return this.ENCODED_VALS_BASE + "-_.";
  },
  /**
   * Whether this browser supports the atob and btoa functions. This extension
   * started at Mozilla but is now implemented by many browsers. We use the
   * ASSUME_* variables to avoid pulling in the full useragent detection library
   * but still allowing the standard per-browser compilations.
   *
   */
  HAS_NATIVE_SUPPORT: typeof atob == "function",
  /**
   * Base64-encode an array of bytes.
   *
   * @param input An array of bytes (numbers with
   *     value in [0, 255]) to encode.
   * @param webSafe Boolean indicating we should use the
   *     alternative alphabet.
   * @return The base64 encoded string.
   */
  encodeByteArray(e, t) {
    if (!Array.isArray(e))
      throw Error("encodeByteArray takes an array as a parameter");
    this.init_();
    const n = t ? this.byteToCharMapWebSafe_ : this.byteToCharMap_, r = [];
    for (let i = 0; i < e.length; i += 3) {
      const o = e[i], a = i + 1 < e.length, s = a ? e[i + 1] : 0, c = i + 2 < e.length, l = c ? e[i + 2] : 0, u = o >> 2, d = (o & 3) << 4 | s >> 4;
      let f = (s & 15) << 2 | l >> 6, h = l & 63;
      c || (h = 64, a || (f = 64)), r.push(n[u], n[d], n[f], n[h]);
    }
    return r.join("");
  },
  /**
   * Base64-encode a string.
   *
   * @param input A string to encode.
   * @param webSafe If true, we should use the
   *     alternative alphabet.
   * @return The base64 encoded string.
   */
  encodeString(e, t) {
    return this.HAS_NATIVE_SUPPORT && !t ? btoa(e) : this.encodeByteArray(qU(e), t);
  },
  /**
   * Base64-decode a string.
   *
   * @param input to decode.
   * @param webSafe True if we should use the
   *     alternative alphabet.
   * @return string representing the decoded value.
   */
  decodeString(e, t) {
    return this.HAS_NATIVE_SUPPORT && !t ? atob(e) : M0e(this.decodeStringToByteArray(e, t));
  },
  /**
   * Base64-decode a string.
   *
   * In base-64 decoding, groups of four characters are converted into three
   * bytes.  If the encoder did not apply padding, the input length may not
   * be a multiple of 4.
   *
   * In this case, the last group will have fewer than 4 characters, and
   * padding will be inferred.  If the group has one or two characters, it decodes
   * to one byte.  If the group has three characters, it decodes to two bytes.
   *
   * @param input Input to decode.
   * @param webSafe True if we should use the web-safe alphabet.
   * @return bytes representing the decoded value.
   */
  decodeStringToByteArray(e, t) {
    this.init_();
    const n = t ? this.charToByteMapWebSafe_ : this.charToByteMap_, r = [];
    for (let i = 0; i < e.length; ) {
      const o = n[e.charAt(i++)], s = i < e.length ? n[e.charAt(i)] : 0;
      ++i;
      const l = i < e.length ? n[e.charAt(i)] : 64;
      ++i;
      const d = i < e.length ? n[e.charAt(i)] : 64;
      if (++i, o == null || s == null || l == null || d == null)
        throw new k0e();
      const f = o << 2 | s >> 4;
      if (r.push(f), l !== 64) {
        const h = s << 4 & 240 | l >> 2;
        if (r.push(h), d !== 64) {
          const p = l << 6 & 192 | d;
          r.push(p);
        }
      }
    }
    return r;
  },
  /**
   * Lazy static initialization function. Called before
   * accessing any of the static map variables.
   * @private
   */
  init_() {
    if (!this.byteToCharMap_) {
      this.byteToCharMap_ = {}, this.charToByteMap_ = {}, this.byteToCharMapWebSafe_ = {}, this.charToByteMapWebSafe_ = {};
      for (let e = 0; e < this.ENCODED_VALS.length; e++)
        this.byteToCharMap_[e] = this.ENCODED_VALS.charAt(e), this.charToByteMap_[this.byteToCharMap_[e]] = e, this.byteToCharMapWebSafe_[e] = this.ENCODED_VALS_WEBSAFE.charAt(e), this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[e]] = e, e >= this.ENCODED_VALS_BASE.length && (this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(e)] = e, this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(e)] = e);
    }
  }
};
class k0e extends Error {
  constructor() {
    super(...arguments), this.name = "DecodeBase64StringError";
  }
}
const N0e = function(e) {
  const t = qU(e);
  return GU.encodeByteArray(t, !0);
}, B_ = function(e) {
  return N0e(e).replace(/\./g, "");
}, KU = function(e) {
  try {
    return GU.decodeString(e, !0);
  } catch (t) {
    console.error("base64Decode failed: ", t);
  }
  return null;
};
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function D0e() {
  if (typeof self < "u")
    return self;
  if (typeof window < "u")
    return window;
  if (typeof global < "u")
    return global;
  throw new Error("Unable to locate global object.");
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const j0e = () => D0e().__FIREBASE_DEFAULTS__, L0e = () => {
  if (typeof process > "u" || typeof process.env > "u")
    return;
  const e = process.env.__FIREBASE_DEFAULTS__;
  if (e)
    return JSON.parse(e);
}, F0e = () => {
  if (typeof document > "u")
    return;
  let e;
  try {
    e = document.cookie.match(/__FIREBASE_DEFAULTS__=([^;]+)/);
  } catch {
    return;
  }
  const t = e && KU(e[1]);
  return t && JSON.parse(t);
}, Rx = () => {
  try {
    return O0e() || j0e() || L0e() || F0e();
  } catch (e) {
    console.info(`Unable to get __FIREBASE_DEFAULTS__ due to: ${e}`);
    return;
  }
}, YU = (e) => {
  var t, n;
  return (n = (t = Rx()) === null || t === void 0 ? void 0 : t.emulatorHosts) === null || n === void 0 ? void 0 : n[e];
}, XU = (e) => {
  const t = YU(e);
  if (!t)
    return;
  const n = t.lastIndexOf(":");
  if (n <= 0 || n + 1 === t.length)
    throw new Error(`Invalid host ${t} with no separate hostname and port!`);
  const r = parseInt(t.substring(n + 1), 10);
  return t[0] === "[" ? [t.substring(1, n - 1), r] : [t.substring(0, n), r];
}, QU = () => {
  var e;
  return (e = Rx()) === null || e === void 0 ? void 0 : e.config;
}, JU = (e) => {
  var t;
  return (t = Rx()) === null || t === void 0 ? void 0 : t[`_${e}`];
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class V0e {
  constructor() {
    this.reject = () => {
    }, this.resolve = () => {
    }, this.promise = new Promise((t, n) => {
      this.resolve = t, this.reject = n;
    });
  }
  /**
   * Our API internals are not promisified and cannot because our callback APIs have subtle expectations around
   * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
   * and returns a node-style callback which will resolve or reject the Deferred's promise.
   */
  wrapCallback(t) {
    return (n, r) => {
      n ? this.reject(n) : this.resolve(r), typeof t == "function" && (this.promise.catch(() => {
      }), t.length === 1 ? t(n) : t(n, r));
    };
  }
}
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Gu(e) {
  try {
    return (e.startsWith("http://") || e.startsWith("https://") ? new URL(e).hostname : e).endsWith(".cloudworkstations.dev");
  } catch {
    return !1;
  }
}
async function Px(e) {
  return (await fetch(e, {
    credentials: "include"
  })).ok;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function B0e(e, t) {
  if (e.uid)
    throw new Error('The "uid" field is no longer supported by mockUserToken. Please use "sub" instead for Firebase Auth User ID.');
  const n = {
    alg: "none",
    type: "JWT"
  }, r = t || "demo-project", i = e.iat || 0, o = e.sub || e.user_id;
  if (!o)
    throw new Error("mockUserToken must contain 'sub' or 'user_id' field!");
  const a = Object.assign({
    // Set all required fields to decent defaults
    iss: `https://securetoken.google.com/${r}`,
    aud: r,
    iat: i,
    exp: i + 3600,
    auth_time: i,
    sub: o,
    user_id: o,
    firebase: {
      sign_in_provider: "custom",
      identities: {}
    }
  }, e), s = "";
  return [
    B_(JSON.stringify(n)),
    B_(JSON.stringify(a)),
    s
  ].join(".");
}
const T0 = {};
function z0e() {
  const e = {
    prod: [],
    emulator: []
  };
  for (const t of Object.keys(T0))
    T0[t] ? e.emulator.push(t) : e.prod.push(t);
  return e;
}
function H0e(e) {
  let t = document.getElementById(e), n = !1;
  return t || (t = document.createElement("div"), t.setAttribute("id", e), n = !0), { created: n, element: t };
}
let P7 = !1;
function wO(e, t) {
  if (typeof window > "u" || typeof document > "u" || !Gu(window.location.host) || T0[e] === t || T0[e] || // If already set to use emulator, can't go back to prod.
  P7)
    return;
  T0[e] = t;
  function n(f) {
    return `__firebase__banner__${f}`;
  }
  const r = "__firebase__banner", o = z0e().prod.length > 0;
  function a() {
    const f = document.getElementById(r);
    f && f.remove();
  }
  function s(f) {
    f.style.display = "flex", f.style.background = "#7faaf0", f.style.position = "fixed", f.style.bottom = "5px", f.style.left = "5px", f.style.padding = ".5em", f.style.borderRadius = "5px", f.style.alignItems = "center";
  }
  function c(f, h) {
    f.setAttribute("width", "24"), f.setAttribute("id", h), f.setAttribute("height", "24"), f.setAttribute("viewBox", "0 0 24 24"), f.setAttribute("fill", "none"), f.style.marginLeft = "-6px";
  }
  function l() {
    const f = document.createElement("span");
    return f.style.cursor = "pointer", f.style.marginLeft = "16px", f.style.fontSize = "24px", f.innerHTML = " &times;", f.onclick = () => {
      P7 = !0, a();
    }, f;
  }
  function u(f, h) {
    f.setAttribute("id", h), f.innerText = "Learn more", f.href = "https://firebase.google.com/docs/studio/preview-apps#preview-backend", f.setAttribute("target", "__blank"), f.style.paddingLeft = "5px", f.style.textDecoration = "underline";
  }
  function d() {
    const f = H0e(r), h = n("text"), p = document.getElementById(h) || document.createElement("span"), g = n("learnmore"), m = document.getElementById(g) || document.createElement("a"), v = n("preprendIcon"), y = document.getElementById(v) || document.createElementNS("http://www.w3.org/2000/svg", "svg");
    if (f.created) {
      const _ = f.element;
      s(_), u(m, g);
      const b = l();
      c(y, v), _.append(y, p, m, b), document.body.appendChild(_);
    }
    o ? (p.innerText = "Preview backend disconnected.", y.innerHTML = `<g clip-path="url(#clip0_6013_33858)">
<path d="M4.8 17.6L12 5.6L19.2 17.6H4.8ZM6.91667 16.4H17.0833L12 7.93333L6.91667 16.4ZM12 15.6C12.1667 15.6 12.3056 15.5444 12.4167 15.4333C12.5389 15.3111 12.6 15.1667 12.6 15C12.6 14.8333 12.5389 14.6944 12.4167 14.5833C12.3056 14.4611 12.1667 14.4 12 14.4C11.8333 14.4 11.6889 14.4611 11.5667 14.5833C11.4556 14.6944 11.4 14.8333 11.4 15C11.4 15.1667 11.4556 15.3111 11.5667 15.4333C11.6889 15.5444 11.8333 15.6 12 15.6ZM11.4 13.6H12.6V10.4H11.4V13.6Z" fill="#212121"/>
</g>
<defs>
<clipPath id="clip0_6013_33858">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>`) : (y.innerHTML = `<g clip-path="url(#clip0_6083_34804)">
<path d="M11.4 15.2H12.6V11.2H11.4V15.2ZM12 10C12.1667 10 12.3056 9.94444 12.4167 9.83333C12.5389 9.71111 12.6 9.56667 12.6 9.4C12.6 9.23333 12.5389 9.09444 12.4167 8.98333C12.3056 8.86111 12.1667 8.8 12 8.8C11.8333 8.8 11.6889 8.86111 11.5667 8.98333C11.4556 9.09444 11.4 9.23333 11.4 9.4C11.4 9.56667 11.4556 9.71111 11.5667 9.83333C11.6889 9.94444 11.8333 10 12 10ZM12 18.4C11.1222 18.4 10.2944 18.2333 9.51667 17.9C8.73889 17.5667 8.05556 17.1111 7.46667 16.5333C6.88889 15.9444 6.43333 15.2611 6.1 14.4833C5.76667 13.7056 5.6 12.8778 5.6 12C5.6 11.1111 5.76667 10.2833 6.1 9.51667C6.43333 8.73889 6.88889 8.06111 7.46667 7.48333C8.05556 6.89444 8.73889 6.43333 9.51667 6.1C10.2944 5.76667 11.1222 5.6 12 5.6C12.8889 5.6 13.7167 5.76667 14.4833 6.1C15.2611 6.43333 15.9389 6.89444 16.5167 7.48333C17.1056 8.06111 17.5667 8.73889 17.9 9.51667C18.2333 10.2833 18.4 11.1111 18.4 12C18.4 12.8778 18.2333 13.7056 17.9 14.4833C17.5667 15.2611 17.1056 15.9444 16.5167 16.5333C15.9389 17.1111 15.2611 17.5667 14.4833 17.9C13.7167 18.2333 12.8889 18.4 12 18.4ZM12 17.2C13.4444 17.2 14.6722 16.6944 15.6833 15.6833C16.6944 14.6722 17.2 13.4444 17.2 12C17.2 10.5556 16.6944 9.32778 15.6833 8.31667C14.6722 7.30555 13.4444 6.8 12 6.8C10.5556 6.8 9.32778 7.30555 8.31667 8.31667C7.30556 9.32778 6.8 10.5556 6.8 12C6.8 13.4444 7.30556 14.6722 8.31667 15.6833C9.32778 16.6944 10.5556 17.2 12 17.2Z" fill="#212121"/>
</g>
<defs>
<clipPath id="clip0_6083_34804">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>`, p.innerText = "Preview backend running in this workspace."), p.setAttribute("id", h);
  }
  document.readyState === "loading" ? window.addEventListener("DOMContentLoaded", d) : d();
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function ho() {
  return typeof navigator < "u" && typeof navigator.userAgent == "string" ? navigator.userAgent : "";
}
function U0e() {
  return typeof window < "u" && // @ts-ignore Setting up an broadly applicable index signature for Window
  // just to deal with this case would probably be a bad idea.
  !!(window.cordova || window.phonegap || window.PhoneGap) && /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test(ho());
}
function W0e() {
  var e;
  const t = (e = Rx()) === null || e === void 0 ? void 0 : e.forceEnvironment;
  if (t === "node")
    return !0;
  if (t === "browser")
    return !1;
  try {
    return Object.prototype.toString.call(global.process) === "[object process]";
  } catch {
    return !1;
  }
}
function q0e() {
  return typeof navigator < "u" && navigator.userAgent === "Cloudflare-Workers";
}
function ZU() {
  const e = typeof chrome == "object" ? chrome.runtime : typeof browser == "object" ? browser.runtime : void 0;
  return typeof e == "object" && e.id !== void 0;
}
function G0e() {
  return typeof navigator == "object" && navigator.product === "ReactNative";
}
function K0e() {
  const e = ho();
  return e.indexOf("MSIE ") >= 0 || e.indexOf("Trident/") >= 0;
}
function Y0e() {
  return !W0e() && !!navigator.userAgent && navigator.userAgent.includes("Safari") && !navigator.userAgent.includes("Chrome");
}
function eW() {
  try {
    return typeof indexedDB == "object";
  } catch {
    return !1;
  }
}
function tW() {
  return new Promise((e, t) => {
    try {
      let n = !0;
      const r = "validate-browser-context-for-indexeddb-analytics-module", i = self.indexedDB.open(r);
      i.onsuccess = () => {
        i.result.close(), n || self.indexedDB.deleteDatabase(r), e(!0);
      }, i.onupgradeneeded = () => {
        n = !1;
      }, i.onerror = () => {
        var o;
        t(((o = i.error) === null || o === void 0 ? void 0 : o.message) || "");
      };
    } catch (n) {
      t(n);
    }
  });
}
function X0e() {
  return !(typeof navigator > "u" || !navigator.cookieEnabled);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Q0e = "FirebaseError";
class Qa extends Error {
  constructor(t, n, r) {
    super(n), this.code = t, this.customData = r, this.name = Q0e, Object.setPrototypeOf(this, Qa.prototype), Error.captureStackTrace && Error.captureStackTrace(this, Ff.prototype.create);
  }
}
class Ff {
  constructor(t, n, r) {
    this.service = t, this.serviceName = n, this.errors = r;
  }
  create(t, ...n) {
    const r = n[0] || {}, i = `${this.service}/${t}`, o = this.errors[t], a = o ? J0e(o, r) : "Error", s = `${this.serviceName}: ${a} (${i}).`;
    return new Qa(i, s, r);
  }
}
function J0e(e, t) {
  return e.replace(Z0e, (n, r) => {
    const i = t[r];
    return i != null ? String(i) : `<${r}?>`;
  });
}
const Z0e = /\{\$([^}]+)}/g;
function eve(e) {
  for (const t in e)
    if (Object.prototype.hasOwnProperty.call(e, t))
      return !1;
  return !0;
}
function ll(e, t) {
  if (e === t)
    return !0;
  const n = Object.keys(e), r = Object.keys(t);
  for (const i of n) {
    if (!r.includes(i))
      return !1;
    const o = e[i], a = t[i];
    if (O7(o) && O7(a)) {
      if (!ll(o, a))
        return !1;
    } else if (o !== a)
      return !1;
  }
  for (const i of r)
    if (!n.includes(i))
      return !1;
  return !0;
}
function O7(e) {
  return e !== null && typeof e == "object";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function ay(e) {
  const t = [];
  for (const [n, r] of Object.entries(e))
    Array.isArray(r) ? r.forEach((i) => {
      t.push(encodeURIComponent(n) + "=" + encodeURIComponent(i));
    }) : t.push(encodeURIComponent(n) + "=" + encodeURIComponent(r));
  return t.length ? "&" + t.join("&") : "";
}
function r0(e) {
  const t = {};
  return e.replace(/^\?/, "").split("&").forEach((r) => {
    if (r) {
      const [i, o] = r.split("=");
      t[decodeURIComponent(i)] = decodeURIComponent(o);
    }
  }), t;
}
function i0(e) {
  const t = e.indexOf("?");
  if (!t)
    return "";
  const n = e.indexOf("#", t);
  return e.substring(t, n > 0 ? n : void 0);
}
function tve(e, t) {
  const n = new nve(e, t);
  return n.subscribe.bind(n);
}
class nve {
  /**
   * @param executor Function which can make calls to a single Observer
   *     as a proxy.
   * @param onNoObservers Callback when count of Observers goes to zero.
   */
  constructor(t, n) {
    this.observers = [], this.unsubscribes = [], this.observerCount = 0, this.task = Promise.resolve(), this.finalized = !1, this.onNoObservers = n, this.task.then(() => {
      t(this);
    }).catch((r) => {
      this.error(r);
    });
  }
  next(t) {
    this.forEachObserver((n) => {
      n.next(t);
    });
  }
  error(t) {
    this.forEachObserver((n) => {
      n.error(t);
    }), this.close(t);
  }
  complete() {
    this.forEachObserver((t) => {
      t.complete();
    }), this.close();
  }
  /**
   * Subscribe function that can be used to add an Observer to the fan-out list.
   *
   * - We require that no event is sent to a subscriber synchronously to their
   *   call to subscribe().
   */
  subscribe(t, n, r) {
    let i;
    if (t === void 0 && n === void 0 && r === void 0)
      throw new Error("Missing Observer.");
    rve(t, [
      "next",
      "error",
      "complete"
    ]) ? i = t : i = {
      next: t,
      error: n,
      complete: r
    }, i.next === void 0 && (i.next = $5), i.error === void 0 && (i.error = $5), i.complete === void 0 && (i.complete = $5);
    const o = this.unsubscribeOne.bind(this, this.observers.length);
    return this.finalized && this.task.then(() => {
      try {
        this.finalError ? i.error(this.finalError) : i.complete();
      } catch {
      }
    }), this.observers.push(i), o;
  }
  // Unsubscribe is synchronous - we guarantee that no events are sent to
  // any unsubscribed Observer.
  unsubscribeOne(t) {
    this.observers === void 0 || this.observers[t] === void 0 || (delete this.observers[t], this.observerCount -= 1, this.observerCount === 0 && this.onNoObservers !== void 0 && this.onNoObservers(this));
  }
  forEachObserver(t) {
    if (!this.finalized)
      for (let n = 0; n < this.observers.length; n++)
        this.sendOne(n, t);
  }
  // Call the Observer via one of it's callback function. We are careful to
  // confirm that the observe has not been unsubscribed since this asynchronous
  // function had been queued.
  sendOne(t, n) {
    this.task.then(() => {
      if (this.observers !== void 0 && this.observers[t] !== void 0)
        try {
          n(this.observers[t]);
        } catch (r) {
          typeof console < "u" && console.error && console.error(r);
        }
    });
  }
  close(t) {
    this.finalized || (this.finalized = !0, t !== void 0 && (this.finalError = t), this.task.then(() => {
      this.observers = void 0, this.onNoObservers = void 0;
    }));
  }
}
function rve(e, t) {
  if (typeof e != "object" || e === null)
    return !1;
  for (const n of t)
    if (n in e && typeof e[n] == "function")
      return !0;
  return !1;
}
function $5() {
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const ive = 1e3, ove = 2, ave = 4 * 60 * 60 * 1e3, sve = 0.5;
function M7(e, t = ive, n = ove) {
  const r = t * Math.pow(n, e), i = Math.round(
    // A fraction of the backoff value to add/subtract.
    // Deviation: changes multiplication order to improve readability.
    sve * r * // A random float (rounded to int by Math.round above) in the range [-1, 1]. Determines
    // if we add or subtract.
    (Math.random() - 0.5) * 2
  );
  return Math.min(ave, r + i);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Or(e) {
  return e && e._delegate ? e._delegate : e;
}
class Ua {
  /**
   *
   * @param name The public service name, e.g. app, auth, firestore, database
   * @param instanceFactory Service factory responsible for creating the public interface
   * @param type whether the service provided by the component is public or private
   */
  constructor(t, n, r) {
    this.name = t, this.instanceFactory = n, this.type = r, this.multipleInstances = !1, this.serviceProps = {}, this.instantiationMode = "LAZY", this.onInstanceCreated = null;
  }
  setInstantiationMode(t) {
    return this.instantiationMode = t, this;
  }
  setMultipleInstances(t) {
    return this.multipleInstances = t, this;
  }
  setServiceProps(t) {
    return this.serviceProps = t, this;
  }
  setInstanceCreatedCallback(t) {
    return this.onInstanceCreated = t, this;
  }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Cd = "[DEFAULT]";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class cve {
  constructor(t, n) {
    this.name = t, this.container = n, this.component = null, this.instances = /* @__PURE__ */ new Map(), this.instancesDeferred = /* @__PURE__ */ new Map(), this.instancesOptions = /* @__PURE__ */ new Map(), this.onInitCallbacks = /* @__PURE__ */ new Map();
  }
  /**
   * @param identifier A provider can provide multiple instances of a service
   * if this.component.multipleInstances is true.
   */
  get(t) {
    const n = this.normalizeInstanceIdentifier(t);
    if (!this.instancesDeferred.has(n)) {
      const r = new V0e();
      if (this.instancesDeferred.set(n, r), this.isInitialized(n) || this.shouldAutoInitialize())
        try {
          const i = this.getOrInitializeService({
            instanceIdentifier: n
          });
          i && r.resolve(i);
        } catch {
        }
    }
    return this.instancesDeferred.get(n).promise;
  }
  getImmediate(t) {
    var n;
    const r = this.normalizeInstanceIdentifier(t == null ? void 0 : t.identifier), i = (n = t == null ? void 0 : t.optional) !== null && n !== void 0 ? n : !1;
    if (this.isInitialized(r) || this.shouldAutoInitialize())
      try {
        return this.getOrInitializeService({
          instanceIdentifier: r
        });
      } catch (o) {
        if (i)
          return null;
        throw o;
      }
    else {
      if (i)
        return null;
      throw Error(`Service ${this.name} is not available`);
    }
  }
  getComponent() {
    return this.component;
  }
  setComponent(t) {
    if (t.name !== this.name)
      throw Error(`Mismatching Component ${t.name} for Provider ${this.name}.`);
    if (this.component)
      throw Error(`Component for ${this.name} has already been provided`);
    if (this.component = t, !!this.shouldAutoInitialize()) {
      if (uve(t))
        try {
          this.getOrInitializeService({ instanceIdentifier: Cd });
        } catch {
        }
      for (const [n, r] of this.instancesDeferred.entries()) {
        const i = this.normalizeInstanceIdentifier(n);
        try {
          const o = this.getOrInitializeService({
            instanceIdentifier: i
          });
          r.resolve(o);
        } catch {
        }
      }
    }
  }
  clearInstance(t = Cd) {
    this.instancesDeferred.delete(t), this.instancesOptions.delete(t), this.instances.delete(t);
  }
  // app.delete() will call this method on every provider to delete the services
  // TODO: should we mark the provider as deleted?
  async delete() {
    const t = Array.from(this.instances.values());
    await Promise.all([
      ...t.filter((n) => "INTERNAL" in n).map((n) => n.INTERNAL.delete()),
      ...t.filter((n) => "_delete" in n).map((n) => n._delete())
    ]);
  }
  isComponentSet() {
    return this.component != null;
  }
  isInitialized(t = Cd) {
    return this.instances.has(t);
  }
  getOptions(t = Cd) {
    return this.instancesOptions.get(t) || {};
  }
  initialize(t = {}) {
    const { options: n = {} } = t, r = this.normalizeInstanceIdentifier(t.instanceIdentifier);
    if (this.isInitialized(r))
      throw Error(`${this.name}(${r}) has already been initialized`);
    if (!this.isComponentSet())
      throw Error(`Component ${this.name} has not been registered yet`);
    const i = this.getOrInitializeService({
      instanceIdentifier: r,
      options: n
    });
    for (const [o, a] of this.instancesDeferred.entries()) {
      const s = this.normalizeInstanceIdentifier(o);
      r === s && a.resolve(i);
    }
    return i;
  }
  /**
   *
   * @param callback - a function that will be invoked  after the provider has been initialized by calling provider.initialize().
   * The function is invoked SYNCHRONOUSLY, so it should not execute any longrunning tasks in order to not block the program.
   *
   * @param identifier An optional instance identifier
   * @returns a function to unregister the callback
   */
  onInit(t, n) {
    var r;
    const i = this.normalizeInstanceIdentifier(n), o = (r = this.onInitCallbacks.get(i)) !== null && r !== void 0 ? r : /* @__PURE__ */ new Set();
    o.add(t), this.onInitCallbacks.set(i, o);
    const a = this.instances.get(i);
    return a && t(a, i), () => {
      o.delete(t);
    };
  }
  /**
   * Invoke onInit callbacks synchronously
   * @param instance the service instance`
   */
  invokeOnInitCallbacks(t, n) {
    const r = this.onInitCallbacks.get(n);
    if (r)
      for (const i of r)
        try {
          i(t, n);
        } catch {
        }
  }
  getOrInitializeService({ instanceIdentifier: t, options: n = {} }) {
    let r = this.instances.get(t);
    if (!r && this.component && (r = this.component.instanceFactory(this.container, {
      instanceIdentifier: lve(t),
      options: n
    }), this.instances.set(t, r), this.instancesOptions.set(t, n), this.invokeOnInitCallbacks(r, t), this.component.onInstanceCreated))
      try {
        this.component.onInstanceCreated(this.container, t, r);
      } catch {
      }
    return r || null;
  }
  normalizeInstanceIdentifier(t = Cd) {
    return this.component ? this.component.multipleInstances ? t : Cd : t;
  }
  shouldAutoInitialize() {
    return !!this.component && this.component.instantiationMode !== "EXPLICIT";
  }
}
function lve(e) {
  return e === Cd ? void 0 : e;
}
function uve(e) {
  return e.instantiationMode === "EAGER";
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class dve {
  constructor(t) {
    this.name = t, this.providers = /* @__PURE__ */ new Map();
  }
  /**
   *
   * @param component Component being added
   * @param overwrite When a component with the same name has already been registered,
   * if overwrite is true: overwrite the existing component with the new component and create a new
   * provider with the new component. It can be useful in tests where you want to use different mocks
   * for different tests.
   * if overwrite is false: throw an exception
   */
  addComponent(t) {
    const n = this.getProvider(t.name);
    if (n.isComponentSet())
      throw new Error(`Component ${t.name} has already been registered with ${this.name}`);
    n.setComponent(t);
  }
  addOrOverwriteComponent(t) {
    this.getProvider(t.name).isComponentSet() && this.providers.delete(t.name), this.addComponent(t);
  }
  /**
   * getProvider provides a type safe interface where it can only be called with a field name
   * present in NameServiceMapping interface.
   *
   * Firebase SDKs providing services should extend NameServiceMapping interface to register
   * themselves.
   */
  getProvider(t) {
    if (this.providers.has(t))
      return this.providers.get(t);
    const n = new cve(t, this);
    return this.providers.set(t, n), n;
  }
  getProviders() {
    return Array.from(this.providers.values());
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var _n;
(function(e) {
  e[e.DEBUG = 0] = "DEBUG", e[e.VERBOSE = 1] = "VERBOSE", e[e.INFO = 2] = "INFO", e[e.WARN = 3] = "WARN", e[e.ERROR = 4] = "ERROR", e[e.SILENT = 5] = "SILENT";
})(_n || (_n = {}));
const fve = {
  debug: _n.DEBUG,
  verbose: _n.VERBOSE,
  info: _n.INFO,
  warn: _n.WARN,
  error: _n.ERROR,
  silent: _n.SILENT
}, hve = _n.INFO, gve = {
  [_n.DEBUG]: "log",
  [_n.VERBOSE]: "log",
  [_n.INFO]: "info",
  [_n.WARN]: "warn",
  [_n.ERROR]: "error"
}, pve = (e, t, ...n) => {
  if (t < e.logLevel)
    return;
  const r = (/* @__PURE__ */ new Date()).toISOString(), i = gve[t];
  if (i)
    console[i](`[${r}]  ${e.name}:`, ...n);
  else
    throw new Error(`Attempted to log a message with an invalid logType (value: ${t})`);
};
class Ox {
  /**
   * Gives you an instance of a Logger to capture messages according to
   * Firebase's logging scheme.
   *
   * @param name The name that the logs will be associated with
   */
  constructor(t) {
    this.name = t, this._logLevel = hve, this._logHandler = pve, this._userLogHandler = null;
  }
  get logLevel() {
    return this._logLevel;
  }
  set logLevel(t) {
    if (!(t in _n))
      throw new TypeError(`Invalid value "${t}" assigned to \`logLevel\``);
    this._logLevel = t;
  }
  // Workaround for setter/getter having to be the same type.
  setLogLevel(t) {
    this._logLevel = typeof t == "string" ? fve[t] : t;
  }
  get logHandler() {
    return this._logHandler;
  }
  set logHandler(t) {
    if (typeof t != "function")
      throw new TypeError("Value assigned to `logHandler` must be a function");
    this._logHandler = t;
  }
  get userLogHandler() {
    return this._userLogHandler;
  }
  set userLogHandler(t) {
    this._userLogHandler = t;
  }
  /**
   * The functions below are all based on the `console` interface
   */
  debug(...t) {
    this._userLogHandler && this._userLogHandler(this, _n.DEBUG, ...t), this._logHandler(this, _n.DEBUG, ...t);
  }
  log(...t) {
    this._userLogHandler && this._userLogHandler(this, _n.VERBOSE, ...t), this._logHandler(this, _n.VERBOSE, ...t);
  }
  info(...t) {
    this._userLogHandler && this._userLogHandler(this, _n.INFO, ...t), this._logHandler(this, _n.INFO, ...t);
  }
  warn(...t) {
    this._userLogHandler && this._userLogHandler(this, _n.WARN, ...t), this._logHandler(this, _n.WARN, ...t);
  }
  error(...t) {
    this._userLogHandler && this._userLogHandler(this, _n.ERROR, ...t), this._logHandler(this, _n.ERROR, ...t);
  }
}
const mve = (e, t) => t.some((n) => e instanceof n);
let k7, N7;
function vve() {
  return k7 || (k7 = [
    IDBDatabase,
    IDBObjectStore,
    IDBIndex,
    IDBCursor,
    IDBTransaction
  ]);
}
function yve() {
  return N7 || (N7 = [
    IDBCursor.prototype.advance,
    IDBCursor.prototype.continue,
    IDBCursor.prototype.continuePrimaryKey
  ]);
}
const nW = /* @__PURE__ */ new WeakMap(), T$ = /* @__PURE__ */ new WeakMap(), rW = /* @__PURE__ */ new WeakMap(), A5 = /* @__PURE__ */ new WeakMap(), xO = /* @__PURE__ */ new WeakMap();
function bve(e) {
  const t = new Promise((n, r) => {
    const i = () => {
      e.removeEventListener("success", o), e.removeEventListener("error", a);
    }, o = () => {
      n(fu(e.result)), i();
    }, a = () => {
      r(e.error), i();
    };
    e.addEventListener("success", o), e.addEventListener("error", a);
  });
  return t.then((n) => {
    n instanceof IDBCursor && nW.set(n, e);
  }).catch(() => {
  }), xO.set(t, e), t;
}
function _ve(e) {
  if (T$.has(e))
    return;
  const t = new Promise((n, r) => {
    const i = () => {
      e.removeEventListener("complete", o), e.removeEventListener("error", a), e.removeEventListener("abort", a);
    }, o = () => {
      n(), i();
    }, a = () => {
      r(e.error || new DOMException("AbortError", "AbortError")), i();
    };
    e.addEventListener("complete", o), e.addEventListener("error", a), e.addEventListener("abort", a);
  });
  T$.set(e, t);
}
let I$ = {
  get(e, t, n) {
    if (e instanceof IDBTransaction) {
      if (t === "done")
        return T$.get(e);
      if (t === "objectStoreNames")
        return e.objectStoreNames || rW.get(e);
      if (t === "store")
        return n.objectStoreNames[1] ? void 0 : n.objectStore(n.objectStoreNames[0]);
    }
    return fu(e[t]);
  },
  set(e, t, n) {
    return e[t] = n, !0;
  },
  has(e, t) {
    return e instanceof IDBTransaction && (t === "done" || t === "store") ? !0 : t in e;
  }
};
function Sve(e) {
  I$ = e(I$);
}
function wve(e) {
  return e === IDBDatabase.prototype.transaction && !("objectStoreNames" in IDBTransaction.prototype) ? function(t, ...n) {
    const r = e.call(R5(this), t, ...n);
    return rW.set(r, t.sort ? t.sort() : [t]), fu(r);
  } : yve().includes(e) ? function(...t) {
    return e.apply(R5(this), t), fu(nW.get(this));
  } : function(...t) {
    return fu(e.apply(R5(this), t));
  };
}
function xve(e) {
  return typeof e == "function" ? wve(e) : (e instanceof IDBTransaction && _ve(e), mve(e, vve()) ? new Proxy(e, I$) : e);
}
function fu(e) {
  if (e instanceof IDBRequest)
    return bve(e);
  if (A5.has(e))
    return A5.get(e);
  const t = xve(e);
  return t !== e && (A5.set(e, t), xO.set(t, e)), t;
}
const R5 = (e) => xO.get(e);
function iW(e, t, { blocked: n, upgrade: r, blocking: i, terminated: o } = {}) {
  const a = indexedDB.open(e, t), s = fu(a);
  return r && a.addEventListener("upgradeneeded", (c) => {
    r(fu(a.result), c.oldVersion, c.newVersion, fu(a.transaction), c);
  }), n && a.addEventListener("blocked", (c) => n(
    // Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
    c.oldVersion,
    c.newVersion,
    c
  )), s.then((c) => {
    o && c.addEventListener("close", () => o()), i && c.addEventListener("versionchange", (l) => i(l.oldVersion, l.newVersion, l));
  }).catch(() => {
  }), s;
}
const Eve = ["get", "getKey", "getAll", "getAllKeys", "count"], Cve = ["put", "add", "delete", "clear"], P5 = /* @__PURE__ */ new Map();
function D7(e, t) {
  if (!(e instanceof IDBDatabase && !(t in e) && typeof t == "string"))
    return;
  if (P5.get(t))
    return P5.get(t);
  const n = t.replace(/FromIndex$/, ""), r = t !== n, i = Cve.includes(n);
  if (
    // Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(n in (r ? IDBIndex : IDBObjectStore).prototype) || !(i || Eve.includes(n))
  )
    return;
  const o = async function(a, ...s) {
    const c = this.transaction(a, i ? "readwrite" : "readonly");
    let l = c.store;
    return r && (l = l.index(s.shift())), (await Promise.all([
      l[n](...s),
      i && c.done
    ]))[0];
  };
  return P5.set(t, o), o;
}
Sve((e) => ({
  ...e,
  get: (t, n, r) => D7(t, n) || e.get(t, n, r),
  has: (t, n) => !!D7(t, n) || e.has(t, n)
}));
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Tve {
  constructor(t) {
    this.container = t;
  }
  // In initial implementation, this will be called by installations on
  // auth token refresh, and installations will send this string.
  getPlatformInfoString() {
    return this.container.getProviders().map((n) => {
      if (Ive(n)) {
        const r = n.getImmediate();
        return `${r.library}/${r.version}`;
      } else
        return null;
    }).filter((n) => n).join(" ");
  }
}
function Ive(e) {
  const t = e.getComponent();
  return (t == null ? void 0 : t.type) === "VERSION";
}
const $$ = "@firebase/app", j7 = "0.13.2";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const ul = new Ox("@firebase/app"), $ve = "@firebase/app-compat", Ave = "@firebase/analytics-compat", Rve = "@firebase/analytics", Pve = "@firebase/app-check-compat", Ove = "@firebase/app-check", Mve = "@firebase/auth", kve = "@firebase/auth-compat", Nve = "@firebase/database", Dve = "@firebase/data-connect", jve = "@firebase/database-compat", Lve = "@firebase/functions", Fve = "@firebase/functions-compat", Vve = "@firebase/installations", Bve = "@firebase/installations-compat", zve = "@firebase/messaging", Hve = "@firebase/messaging-compat", Uve = "@firebase/performance", Wve = "@firebase/performance-compat", qve = "@firebase/remote-config", Gve = "@firebase/remote-config-compat", Kve = "@firebase/storage", Yve = "@firebase/storage-compat", Xve = "@firebase/firestore", Qve = "@firebase/ai", Jve = "@firebase/firestore-compat", Zve = "firebase", eye = "11.10.0";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const A$ = "[DEFAULT]", tye = {
  [$$]: "fire-core",
  [$ve]: "fire-core-compat",
  [Rve]: "fire-analytics",
  [Ave]: "fire-analytics-compat",
  [Ove]: "fire-app-check",
  [Pve]: "fire-app-check-compat",
  [Mve]: "fire-auth",
  [kve]: "fire-auth-compat",
  [Nve]: "fire-rtdb",
  [Dve]: "fire-data-connect",
  [jve]: "fire-rtdb-compat",
  [Lve]: "fire-fn",
  [Fve]: "fire-fn-compat",
  [Vve]: "fire-iid",
  [Bve]: "fire-iid-compat",
  [zve]: "fire-fcm",
  [Hve]: "fire-fcm-compat",
  [Uve]: "fire-perf",
  [Wve]: "fire-perf-compat",
  [qve]: "fire-rc",
  [Gve]: "fire-rc-compat",
  [Kve]: "fire-gcs",
  [Yve]: "fire-gcs-compat",
  [Xve]: "fire-fst",
  [Jve]: "fire-fst-compat",
  [Qve]: "fire-vertex",
  "fire-js": "fire-js",
  // Platform identifier for JS SDK.
  [Zve]: "fire-js-all"
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const z_ = /* @__PURE__ */ new Map(), nye = /* @__PURE__ */ new Map(), R$ = /* @__PURE__ */ new Map();
function L7(e, t) {
  try {
    e.container.addComponent(t);
  } catch (n) {
    ul.debug(`Component ${t.name} failed to register with FirebaseApp ${e.name}`, n);
  }
}
function Is(e) {
  const t = e.name;
  if (R$.has(t))
    return ul.debug(`There were multiple attempts to register component ${t}.`), !1;
  R$.set(t, e);
  for (const n of z_.values())
    L7(n, e);
  for (const n of nye.values())
    L7(n, e);
  return !0;
}
function xl(e, t) {
  const n = e.container.getProvider("heartbeat").getImmediate({ optional: !0 });
  return n && n.triggerHeartbeat(), e.container.getProvider(t);
}
function Io(e) {
  return e == null ? !1 : e.settings !== void 0;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const rye = {
  "no-app": "No Firebase App '{$appName}' has been created - call initializeApp() first",
  "bad-app-name": "Illegal App name: '{$appName}'",
  "duplicate-app": "Firebase App named '{$appName}' already exists with different options or config",
  "app-deleted": "Firebase App named '{$appName}' already deleted",
  "server-app-deleted": "Firebase Server App has been deleted",
  "no-options": "Need to provide options, when not being deployed to hosting via source.",
  "invalid-app-argument": "firebase.{$appName}() takes either no argument or a Firebase App instance.",
  "invalid-log-argument": "First argument to `onLog` must be null or a function.",
  "idb-open": "Error thrown when opening IndexedDB. Original error: {$originalErrorMessage}.",
  "idb-get": "Error thrown when reading from IndexedDB. Original error: {$originalErrorMessage}.",
  "idb-set": "Error thrown when writing to IndexedDB. Original error: {$originalErrorMessage}.",
  "idb-delete": "Error thrown when deleting from IndexedDB. Original error: {$originalErrorMessage}.",
  "finalization-registry-not-supported": "FirebaseServerApp deleteOnDeref field defined but the JS runtime does not support FinalizationRegistry.",
  "invalid-server-app-environment": "FirebaseServerApp is not for use in browser environments."
}, hu = new Ff("app", "Firebase", rye);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class iye {
  constructor(t, n, r) {
    this._isDeleted = !1, this._options = Object.assign({}, t), this._config = Object.assign({}, n), this._name = n.name, this._automaticDataCollectionEnabled = n.automaticDataCollectionEnabled, this._container = r, this.container.addComponent(new Ua(
      "app",
      () => this,
      "PUBLIC"
      /* ComponentType.PUBLIC */
    ));
  }
  get automaticDataCollectionEnabled() {
    return this.checkDestroyed(), this._automaticDataCollectionEnabled;
  }
  set automaticDataCollectionEnabled(t) {
    this.checkDestroyed(), this._automaticDataCollectionEnabled = t;
  }
  get name() {
    return this.checkDestroyed(), this._name;
  }
  get options() {
    return this.checkDestroyed(), this._options;
  }
  get config() {
    return this.checkDestroyed(), this._config;
  }
  get container() {
    return this._container;
  }
  get isDeleted() {
    return this._isDeleted;
  }
  set isDeleted(t) {
    this._isDeleted = t;
  }
  /**
   * This function will throw an Error if the App has already been deleted -
   * use before performing API actions on the App.
   */
  checkDestroyed() {
    if (this.isDeleted)
      throw hu.create("app-deleted", { appName: this._name });
  }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Op = eye;
function oW(e, t = {}) {
  let n = e;
  typeof t != "object" && (t = { name: t });
  const r = Object.assign({ name: A$, automaticDataCollectionEnabled: !0 }, t), i = r.name;
  if (typeof i != "string" || !i)
    throw hu.create("bad-app-name", {
      appName: String(i)
    });
  if (n || (n = QU()), !n)
    throw hu.create(
      "no-options"
      /* AppError.NO_OPTIONS */
    );
  const o = z_.get(i);
  if (o) {
    if (ll(n, o.options) && ll(r, o.config))
      return o;
    throw hu.create("duplicate-app", { appName: i });
  }
  const a = new dve(i);
  for (const c of R$.values())
    a.addComponent(c);
  const s = new iye(n, r, a);
  return z_.set(i, s), s;
}
function Mx(e = A$) {
  const t = z_.get(e);
  if (!t && e === A$ && QU())
    return oW();
  if (!t)
    throw hu.create("no-app", { appName: e });
  return t;
}
function ta(e, t, n) {
  var r;
  let i = (r = tye[e]) !== null && r !== void 0 ? r : e;
  n && (i += `-${n}`);
  const o = i.match(/\s|\//), a = t.match(/\s|\//);
  if (o || a) {
    const s = [
      `Unable to register library "${i}" with version "${t}":`
    ];
    o && s.push(`library name "${i}" contains illegal characters (whitespace or "/")`), o && a && s.push("and"), a && s.push(`version name "${t}" contains illegal characters (whitespace or "/")`), ul.warn(s.join(" "));
    return;
  }
  Is(new Ua(
    `${i}-version`,
    () => ({ library: i, version: t }),
    "VERSION"
    /* ComponentType.VERSION */
  ));
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const oye = "firebase-heartbeat-database", aye = 1, iv = "firebase-heartbeat-store";
let O5 = null;
function aW() {
  return O5 || (O5 = iW(oye, aye, {
    upgrade: (e, t) => {
      switch (t) {
        case 0:
          try {
            e.createObjectStore(iv);
          } catch (n) {
            console.warn(n);
          }
      }
    }
  }).catch((e) => {
    throw hu.create("idb-open", {
      originalErrorMessage: e.message
    });
  })), O5;
}
async function sye(e) {
  try {
    const n = (await aW()).transaction(iv), r = await n.objectStore(iv).get(sW(e));
    return await n.done, r;
  } catch (t) {
    if (t instanceof Qa)
      ul.warn(t.message);
    else {
      const n = hu.create("idb-get", {
        originalErrorMessage: t == null ? void 0 : t.message
      });
      ul.warn(n.message);
    }
  }
}
async function F7(e, t) {
  try {
    const r = (await aW()).transaction(iv, "readwrite");
    await r.objectStore(iv).put(t, sW(e)), await r.done;
  } catch (n) {
    if (n instanceof Qa)
      ul.warn(n.message);
    else {
      const r = hu.create("idb-set", {
        originalErrorMessage: n == null ? void 0 : n.message
      });
      ul.warn(r.message);
    }
  }
}
function sW(e) {
  return `${e.name}!${e.options.appId}`;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const cye = 1024, lye = 30;
class uye {
  constructor(t) {
    this.container = t, this._heartbeatsCache = null;
    const n = this.container.getProvider("app").getImmediate();
    this._storage = new fye(n), this._heartbeatsCachePromise = this._storage.read().then((r) => (this._heartbeatsCache = r, r));
  }
  /**
   * Called to report a heartbeat. The function will generate
   * a HeartbeatsByUserAgent object, update heartbeatsCache, and persist it
   * to IndexedDB.
   * Note that we only store one heartbeat per day. So if a heartbeat for today is
   * already logged, subsequent calls to this function in the same day will be ignored.
   */
  async triggerHeartbeat() {
    var t, n;
    try {
      const i = this.container.getProvider("platform-logger").getImmediate().getPlatformInfoString(), o = V7();
      if (((t = this._heartbeatsCache) === null || t === void 0 ? void 0 : t.heartbeats) == null && (this._heartbeatsCache = await this._heartbeatsCachePromise, ((n = this._heartbeatsCache) === null || n === void 0 ? void 0 : n.heartbeats) == null) || this._heartbeatsCache.lastSentHeartbeatDate === o || this._heartbeatsCache.heartbeats.some((a) => a.date === o))
        return;
      if (this._heartbeatsCache.heartbeats.push({ date: o, agent: i }), this._heartbeatsCache.heartbeats.length > lye) {
        const a = hye(this._heartbeatsCache.heartbeats);
        this._heartbeatsCache.heartbeats.splice(a, 1);
      }
      return this._storage.overwrite(this._heartbeatsCache);
    } catch (r) {
      ul.warn(r);
    }
  }
  /**
   * Returns a base64 encoded string which can be attached to the heartbeat-specific header directly.
   * It also clears all heartbeats from memory as well as in IndexedDB.
   *
   * NOTE: Consuming product SDKs should not send the header if this method
   * returns an empty string.
   */
  async getHeartbeatsHeader() {
    var t;
    try {
      if (this._heartbeatsCache === null && await this._heartbeatsCachePromise, ((t = this._heartbeatsCache) === null || t === void 0 ? void 0 : t.heartbeats) == null || this._heartbeatsCache.heartbeats.length === 0)
        return "";
      const n = V7(), { heartbeatsToSend: r, unsentEntries: i } = dye(this._heartbeatsCache.heartbeats), o = B_(JSON.stringify({ version: 2, heartbeats: r }));
      return this._heartbeatsCache.lastSentHeartbeatDate = n, i.length > 0 ? (this._heartbeatsCache.heartbeats = i, await this._storage.overwrite(this._heartbeatsCache)) : (this._heartbeatsCache.heartbeats = [], this._storage.overwrite(this._heartbeatsCache)), o;
    } catch (n) {
      return ul.warn(n), "";
    }
  }
}
function V7() {
  return (/* @__PURE__ */ new Date()).toISOString().substring(0, 10);
}
function dye(e, t = cye) {
  const n = [];
  let r = e.slice();
  for (const i of e) {
    const o = n.find((a) => a.agent === i.agent);
    if (o) {
      if (o.dates.push(i.date), B7(n) > t) {
        o.dates.pop();
        break;
      }
    } else if (n.push({
      agent: i.agent,
      dates: [i.date]
    }), B7(n) > t) {
      n.pop();
      break;
    }
    r = r.slice(1);
  }
  return {
    heartbeatsToSend: n,
    unsentEntries: r
  };
}
class fye {
  constructor(t) {
    this.app = t, this._canUseIndexedDBPromise = this.runIndexedDBEnvironmentCheck();
  }
  async runIndexedDBEnvironmentCheck() {
    return eW() ? tW().then(() => !0).catch(() => !1) : !1;
  }
  /**
   * Read all heartbeats.
   */
  async read() {
    if (await this._canUseIndexedDBPromise) {
      const n = await sye(this.app);
      return n != null && n.heartbeats ? n : { heartbeats: [] };
    } else
      return { heartbeats: [] };
  }
  // overwrite the storage with the provided heartbeats
  async overwrite(t) {
    var n;
    if (await this._canUseIndexedDBPromise) {
      const i = await this.read();
      return F7(this.app, {
        lastSentHeartbeatDate: (n = t.lastSentHeartbeatDate) !== null && n !== void 0 ? n : i.lastSentHeartbeatDate,
        heartbeats: t.heartbeats
      });
    } else
      return;
  }
  // add heartbeats
  async add(t) {
    var n;
    if (await this._canUseIndexedDBPromise) {
      const i = await this.read();
      return F7(this.app, {
        lastSentHeartbeatDate: (n = t.lastSentHeartbeatDate) !== null && n !== void 0 ? n : i.lastSentHeartbeatDate,
        heartbeats: [
          ...i.heartbeats,
          ...t.heartbeats
        ]
      });
    } else
      return;
  }
}
function B7(e) {
  return B_(
    // heartbeatsCache wrapper properties
    JSON.stringify({ version: 2, heartbeats: e })
  ).length;
}
function hye(e) {
  if (e.length === 0)
    return -1;
  let t = 0, n = e[0].date;
  for (let r = 1; r < e.length; r++)
    e[r].date < n && (n = e[r].date, t = r);
  return t;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function gye(e) {
  Is(new Ua(
    "platform-logger",
    (t) => new Tve(t),
    "PRIVATE"
    /* ComponentType.PRIVATE */
  )), Is(new Ua(
    "heartbeat",
    (t) => new uye(t),
    "PRIVATE"
    /* ComponentType.PRIVATE */
  )), ta($$, j7, e), ta($$, j7, "esm2017"), ta("fire-js", "");
}
gye("");
const cW = "@firebase/installations", EO = "0.6.18";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const lW = 1e4, uW = `w:${EO}`, dW = "FIS_v2", pye = "https://firebaseinstallations.googleapis.com/v1", mye = 60 * 60 * 1e3, vye = "installations", yye = "Installations";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const bye = {
  "missing-app-config-values": 'Missing App configuration value: "{$valueName}"',
  "not-registered": "Firebase Installation is not registered.",
  "installation-not-found": "Firebase Installation not found.",
  "request-failed": '{$requestName} request failed with error "{$serverCode} {$serverStatus}: {$serverMessage}"',
  "app-offline": "Could not process request. Application offline.",
  "delete-pending-registration": "Can't delete installation while there is a pending registration request."
}, df = new Ff(vye, yye, bye);
function fW(e) {
  return e instanceof Qa && e.code.includes(
    "request-failed"
    /* ErrorCode.REQUEST_FAILED */
  );
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function hW({ projectId: e }) {
  return `${pye}/projects/${e}/installations`;
}
function gW(e) {
  return {
    token: e.token,
    requestStatus: 2,
    expiresIn: Sye(e.expiresIn),
    creationTime: Date.now()
  };
}
async function pW(e, t) {
  const r = (await t.json()).error;
  return df.create("request-failed", {
    requestName: e,
    serverCode: r.code,
    serverMessage: r.message,
    serverStatus: r.status
  });
}
function mW({ apiKey: e }) {
  return new Headers({
    "Content-Type": "application/json",
    Accept: "application/json",
    "x-goog-api-key": e
  });
}
function _ye(e, { refreshToken: t }) {
  const n = mW(e);
  return n.append("Authorization", wye(t)), n;
}
async function vW(e) {
  const t = await e();
  return t.status >= 500 && t.status < 600 ? e() : t;
}
function Sye(e) {
  return Number(e.replace("s", "000"));
}
function wye(e) {
  return `${dW} ${e}`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function xye({ appConfig: e, heartbeatServiceProvider: t }, { fid: n }) {
  const r = hW(e), i = mW(e), o = t.getImmediate({
    optional: !0
  });
  if (o) {
    const l = await o.getHeartbeatsHeader();
    l && i.append("x-firebase-client", l);
  }
  const a = {
    fid: n,
    authVersion: dW,
    appId: e.appId,
    sdkVersion: uW
  }, s = {
    method: "POST",
    headers: i,
    body: JSON.stringify(a)
  }, c = await vW(() => fetch(r, s));
  if (c.ok) {
    const l = await c.json();
    return {
      fid: l.fid || n,
      registrationStatus: 2,
      refreshToken: l.refreshToken,
      authToken: gW(l.authToken)
    };
  } else
    throw await pW("Create Installation", c);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function yW(e) {
  return new Promise((t) => {
    setTimeout(t, e);
  });
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Eye(e) {
  return btoa(String.fromCharCode(...e)).replace(/\+/g, "-").replace(/\//g, "_");
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Cye = /^[cdef][\w-]{21}$/, P$ = "";
function Tye() {
  try {
    const e = new Uint8Array(17);
    (self.crypto || self.msCrypto).getRandomValues(e), e[0] = 112 + e[0] % 16;
    const n = Iye(e);
    return Cye.test(n) ? n : P$;
  } catch {
    return P$;
  }
}
function Iye(e) {
  return Eye(e).substr(0, 22);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function kx(e) {
  return `${e.appName}!${e.appId}`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const bW = /* @__PURE__ */ new Map();
function _W(e, t) {
  const n = kx(e);
  SW(n, t), $ye(n, t);
}
function SW(e, t) {
  const n = bW.get(e);
  if (n)
    for (const r of n)
      r(t);
}
function $ye(e, t) {
  const n = Aye();
  n && n.postMessage({ key: e, fid: t }), Rye();
}
let Od = null;
function Aye() {
  return !Od && "BroadcastChannel" in self && (Od = new BroadcastChannel("[Firebase] FID Change"), Od.onmessage = (e) => {
    SW(e.data.key, e.data.fid);
  }), Od;
}
function Rye() {
  bW.size === 0 && Od && (Od.close(), Od = null);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Pye = "firebase-installations-database", Oye = 1, ff = "firebase-installations-store";
let M5 = null;
function CO() {
  return M5 || (M5 = iW(Pye, Oye, {
    upgrade: (e, t) => {
      switch (t) {
        case 0:
          e.createObjectStore(ff);
      }
    }
  })), M5;
}
async function H_(e, t) {
  const n = kx(e), i = (await CO()).transaction(ff, "readwrite"), o = i.objectStore(ff), a = await o.get(n);
  return await o.put(t, n), await i.done, (!a || a.fid !== t.fid) && _W(e, t.fid), t;
}
async function wW(e) {
  const t = kx(e), r = (await CO()).transaction(ff, "readwrite");
  await r.objectStore(ff).delete(t), await r.done;
}
async function Nx(e, t) {
  const n = kx(e), i = (await CO()).transaction(ff, "readwrite"), o = i.objectStore(ff), a = await o.get(n), s = t(a);
  return s === void 0 ? await o.delete(n) : await o.put(s, n), await i.done, s && (!a || a.fid !== s.fid) && _W(e, s.fid), s;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function TO(e) {
  let t;
  const n = await Nx(e.appConfig, (r) => {
    const i = Mye(r), o = kye(e, i);
    return t = o.registrationPromise, o.installationEntry;
  });
  return n.fid === P$ ? { installationEntry: await t } : {
    installationEntry: n,
    registrationPromise: t
  };
}
function Mye(e) {
  const t = e || {
    fid: Tye(),
    registrationStatus: 0
    /* RequestStatus.NOT_STARTED */
  };
  return xW(t);
}
function kye(e, t) {
  if (t.registrationStatus === 0) {
    if (!navigator.onLine) {
      const i = Promise.reject(df.create(
        "app-offline"
        /* ErrorCode.APP_OFFLINE */
      ));
      return {
        installationEntry: t,
        registrationPromise: i
      };
    }
    const n = {
      fid: t.fid,
      registrationStatus: 1,
      registrationTime: Date.now()
    }, r = Nye(e, n);
    return { installationEntry: n, registrationPromise: r };
  } else
    return t.registrationStatus === 1 ? {
      installationEntry: t,
      registrationPromise: Dye(e)
    } : { installationEntry: t };
}
async function Nye(e, t) {
  try {
    const n = await xye(e, t);
    return H_(e.appConfig, n);
  } catch (n) {
    throw fW(n) && n.customData.serverCode === 409 ? await wW(e.appConfig) : await H_(e.appConfig, {
      fid: t.fid,
      registrationStatus: 0
      /* RequestStatus.NOT_STARTED */
    }), n;
  }
}
async function Dye(e) {
  let t = await z7(e.appConfig);
  for (; t.registrationStatus === 1; )
    await yW(100), t = await z7(e.appConfig);
  if (t.registrationStatus === 0) {
    const { installationEntry: n, registrationPromise: r } = await TO(e);
    return r || n;
  }
  return t;
}
function z7(e) {
  return Nx(e, (t) => {
    if (!t)
      throw df.create(
        "installation-not-found"
        /* ErrorCode.INSTALLATION_NOT_FOUND */
      );
    return xW(t);
  });
}
function xW(e) {
  return jye(e) ? {
    fid: e.fid,
    registrationStatus: 0
    /* RequestStatus.NOT_STARTED */
  } : e;
}
function jye(e) {
  return e.registrationStatus === 1 && e.registrationTime + lW < Date.now();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function Lye({ appConfig: e, heartbeatServiceProvider: t }, n) {
  const r = Fye(e, n), i = _ye(e, n), o = t.getImmediate({
    optional: !0
  });
  if (o) {
    const l = await o.getHeartbeatsHeader();
    l && i.append("x-firebase-client", l);
  }
  const a = {
    installation: {
      sdkVersion: uW,
      appId: e.appId
    }
  }, s = {
    method: "POST",
    headers: i,
    body: JSON.stringify(a)
  }, c = await vW(() => fetch(r, s));
  if (c.ok) {
    const l = await c.json();
    return gW(l);
  } else
    throw await pW("Generate Auth Token", c);
}
function Fye(e, { fid: t }) {
  return `${hW(e)}/${t}/authTokens:generate`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function IO(e, t = !1) {
  let n;
  const r = await Nx(e.appConfig, (o) => {
    if (!EW(o))
      throw df.create(
        "not-registered"
        /* ErrorCode.NOT_REGISTERED */
      );
    const a = o.authToken;
    if (!t && zye(a))
      return o;
    if (a.requestStatus === 1)
      return n = Vye(e, t), o;
    {
      if (!navigator.onLine)
        throw df.create(
          "app-offline"
          /* ErrorCode.APP_OFFLINE */
        );
      const s = Uye(o);
      return n = Bye(e, s), s;
    }
  });
  return n ? await n : r.authToken;
}
async function Vye(e, t) {
  let n = await H7(e.appConfig);
  for (; n.authToken.requestStatus === 1; )
    await yW(100), n = await H7(e.appConfig);
  const r = n.authToken;
  return r.requestStatus === 0 ? IO(e, t) : r;
}
function H7(e) {
  return Nx(e, (t) => {
    if (!EW(t))
      throw df.create(
        "not-registered"
        /* ErrorCode.NOT_REGISTERED */
      );
    const n = t.authToken;
    return Wye(n) ? Object.assign(Object.assign({}, t), { authToken: {
      requestStatus: 0
      /* RequestStatus.NOT_STARTED */
    } }) : t;
  });
}
async function Bye(e, t) {
  try {
    const n = await Lye(e, t), r = Object.assign(Object.assign({}, t), { authToken: n });
    return await H_(e.appConfig, r), n;
  } catch (n) {
    if (fW(n) && (n.customData.serverCode === 401 || n.customData.serverCode === 404))
      await wW(e.appConfig);
    else {
      const r = Object.assign(Object.assign({}, t), { authToken: {
        requestStatus: 0
        /* RequestStatus.NOT_STARTED */
      } });
      await H_(e.appConfig, r);
    }
    throw n;
  }
}
function EW(e) {
  return e !== void 0 && e.registrationStatus === 2;
}
function zye(e) {
  return e.requestStatus === 2 && !Hye(e);
}
function Hye(e) {
  const t = Date.now();
  return t < e.creationTime || e.creationTime + e.expiresIn < t + mye;
}
function Uye(e) {
  const t = {
    requestStatus: 1,
    requestTime: Date.now()
  };
  return Object.assign(Object.assign({}, e), { authToken: t });
}
function Wye(e) {
  return e.requestStatus === 1 && e.requestTime + lW < Date.now();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function qye(e) {
  const t = e, { installationEntry: n, registrationPromise: r } = await TO(t);
  return r ? r.catch(console.error) : IO(t).catch(console.error), n.fid;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function Gye(e, t = !1) {
  const n = e;
  return await Kye(n), (await IO(n, t)).token;
}
async function Kye(e) {
  const { registrationPromise: t } = await TO(e);
  t && await t;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Yye(e) {
  if (!e || !e.options)
    throw k5("App Configuration");
  if (!e.name)
    throw k5("App Name");
  const t = [
    "projectId",
    "apiKey",
    "appId"
  ];
  for (const n of t)
    if (!e.options[n])
      throw k5(n);
  return {
    appName: e.name,
    projectId: e.options.projectId,
    apiKey: e.options.apiKey,
    appId: e.options.appId
  };
}
function k5(e) {
  return df.create("missing-app-config-values", {
    valueName: e
  });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const CW = "installations", Xye = "installations-internal", Qye = (e) => {
  const t = e.getProvider("app").getImmediate(), n = Yye(t), r = xl(t, "heartbeat");
  return {
    app: t,
    appConfig: n,
    heartbeatServiceProvider: r,
    _delete: () => Promise.resolve()
  };
}, Jye = (e) => {
  const t = e.getProvider("app").getImmediate(), n = xl(t, CW).getImmediate();
  return {
    getId: () => qye(n),
    getToken: (i) => Gye(n, i)
  };
};
function Zye() {
  Is(new Ua(
    CW,
    Qye,
    "PUBLIC"
    /* ComponentType.PUBLIC */
  )), Is(new Ua(
    Xye,
    Jye,
    "PRIVATE"
    /* ComponentType.PRIVATE */
  ));
}
Zye();
ta(cW, EO);
ta(cW, EO, "esm2017");
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const U_ = "analytics", ebe = "firebase_id", tbe = "origin", nbe = 60 * 1e3, rbe = "https://firebase.googleapis.com/v1alpha/projects/-/apps/{app-id}/webConfig", $O = "https://www.googletagmanager.com/gtag/js";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const na = new Ox("@firebase/analytics");
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const ibe = {
  "already-exists": "A Firebase Analytics instance with the appId {$id}  already exists. Only one Firebase Analytics instance can be created for each appId.",
  "already-initialized": "initializeAnalytics() cannot be called again with different options than those it was initially called with. It can be called again with the same options to return the existing instance, or getAnalytics() can be used to get a reference to the already-initialized instance.",
  "already-initialized-settings": "Firebase Analytics has already been initialized.settings() must be called before initializing any Analytics instanceor it will have no effect.",
  "interop-component-reg-failed": "Firebase Analytics Interop Component failed to instantiate: {$reason}",
  "invalid-analytics-context": "Firebase Analytics is not supported in this environment. Wrap initialization of analytics in analytics.isSupported() to prevent initialization in unsupported environments. Details: {$errorInfo}",
  "indexeddb-unavailable": "IndexedDB unavailable or restricted in this environment. Wrap initialization of analytics in analytics.isSupported() to prevent initialization in unsupported environments. Details: {$errorInfo}",
  "fetch-throttle": "The config fetch request timed out while in an exponential backoff state. Unix timestamp in milliseconds when fetch request throttling ends: {$throttleEndTimeMillis}.",
  "config-fetch-failed": "Dynamic config fetch failed: [{$httpStatus}] {$responseMessage}",
  "no-api-key": 'The "apiKey" field is empty in the local Firebase config. Firebase Analytics requires this field tocontain a valid API key.',
  "no-app-id": 'The "appId" field is empty in the local Firebase config. Firebase Analytics requires this field tocontain a valid app ID.',
  "no-client-id": 'The "client_id" field is empty.',
  "invalid-gtag-resource": "Trusted Types detected an invalid gtag resource: {$gtagURL}."
}, ba = new Ff("analytics", "Analytics", ibe);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function obe(e) {
  if (!e.startsWith($O)) {
    const t = ba.create("invalid-gtag-resource", {
      gtagURL: e
    });
    return na.warn(t.message), "";
  }
  return e;
}
function TW(e) {
  return Promise.all(e.map((t) => t.catch((n) => n)));
}
function abe(e, t) {
  let n;
  return window.trustedTypes && (n = window.trustedTypes.createPolicy(e, t)), n;
}
function sbe(e, t) {
  const n = abe("firebase-js-sdk-policy", {
    createScriptURL: obe
  }), r = document.createElement("script"), i = `${$O}?l=${e}&id=${t}`;
  r.src = n ? n == null ? void 0 : n.createScriptURL(i) : i, r.async = !0, document.head.appendChild(r);
}
function cbe(e) {
  let t = [];
  return Array.isArray(window[e]) ? t = window[e] : window[e] = t, t;
}
async function lbe(e, t, n, r, i, o) {
  const a = r[i];
  try {
    if (a)
      await t[a];
    else {
      const c = (await TW(n)).find((l) => l.measurementId === i);
      c && await t[c.appId];
    }
  } catch (s) {
    na.error(s);
  }
  e("config", i, o);
}
async function ube(e, t, n, r, i) {
  try {
    let o = [];
    if (i && i.send_to) {
      let a = i.send_to;
      Array.isArray(a) || (a = [a]);
      const s = await TW(n);
      for (const c of a) {
        const l = s.find((d) => d.measurementId === c), u = l && t[l.appId];
        if (u)
          o.push(u);
        else {
          o = [];
          break;
        }
      }
    }
    o.length === 0 && (o = Object.values(t)), await Promise.all(o), e("event", r, i || {});
  } catch (o) {
    na.error(o);
  }
}
function dbe(e, t, n, r) {
  async function i(o, ...a) {
    try {
      if (o === "event") {
        const [s, c] = a;
        await ube(e, t, n, s, c);
      } else if (o === "config") {
        const [s, c] = a;
        await lbe(e, t, n, r, s, c);
      } else if (o === "consent") {
        const [s, c] = a;
        e("consent", s, c);
      } else if (o === "get") {
        const [s, c, l] = a;
        e("get", s, c, l);
      } else if (o === "set") {
        const [s] = a;
        e("set", s);
      } else
        e(o, ...a);
    } catch (s) {
      na.error(s);
    }
  }
  return i;
}
function fbe(e, t, n, r, i) {
  let o = function(...a) {
    window[r].push(arguments);
  };
  return window[i] && typeof window[i] == "function" && (o = window[i]), window[i] = dbe(o, e, t, n), {
    gtagCore: o,
    wrappedGtag: window[i]
  };
}
function hbe(e) {
  const t = window.document.getElementsByTagName("script");
  for (const n of Object.values(t))
    if (n.src && n.src.includes($O) && n.src.includes(e))
      return n;
  return null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const gbe = 30, pbe = 1e3;
class mbe {
  constructor(t = {}, n = pbe) {
    this.throttleMetadata = t, this.intervalMillis = n;
  }
  getThrottleMetadata(t) {
    return this.throttleMetadata[t];
  }
  setThrottleMetadata(t, n) {
    this.throttleMetadata[t] = n;
  }
  deleteThrottleMetadata(t) {
    delete this.throttleMetadata[t];
  }
}
const IW = new mbe();
function vbe(e) {
  return new Headers({
    Accept: "application/json",
    "x-goog-api-key": e
  });
}
async function ybe(e) {
  var t;
  const { appId: n, apiKey: r } = e, i = {
    method: "GET",
    headers: vbe(r)
  }, o = rbe.replace("{app-id}", n), a = await fetch(o, i);
  if (a.status !== 200 && a.status !== 304) {
    let s = "";
    try {
      const c = await a.json();
      !((t = c.error) === null || t === void 0) && t.message && (s = c.error.message);
    } catch {
    }
    throw ba.create("config-fetch-failed", {
      httpStatus: a.status,
      responseMessage: s
    });
  }
  return a.json();
}
async function bbe(e, t = IW, n) {
  const { appId: r, apiKey: i, measurementId: o } = e.options;
  if (!r)
    throw ba.create(
      "no-app-id"
      /* AnalyticsError.NO_APP_ID */
    );
  if (!i) {
    if (o)
      return {
        measurementId: o,
        appId: r
      };
    throw ba.create(
      "no-api-key"
      /* AnalyticsError.NO_API_KEY */
    );
  }
  const a = t.getThrottleMetadata(r) || {
    backoffCount: 0,
    throttleEndTimeMillis: Date.now()
  }, s = new wbe();
  return setTimeout(async () => {
    s.abort();
  }, n !== void 0 ? n : nbe), $W({ appId: r, apiKey: i, measurementId: o }, a, s, t);
}
async function $W(e, { throttleEndTimeMillis: t, backoffCount: n }, r, i = IW) {
  var o;
  const { appId: a, measurementId: s } = e;
  try {
    await _be(r, t);
  } catch (c) {
    if (s)
      return na.warn(`Timed out fetching this Firebase app's measurement ID from the server. Falling back to the measurement ID ${s} provided in the "measurementId" field in the local Firebase config. [${c == null ? void 0 : c.message}]`), { appId: a, measurementId: s };
    throw c;
  }
  try {
    const c = await ybe(e);
    return i.deleteThrottleMetadata(a), c;
  } catch (c) {
    const l = c;
    if (!Sbe(l)) {
      if (i.deleteThrottleMetadata(a), s)
        return na.warn(`Failed to fetch this Firebase app's measurement ID from the server. Falling back to the measurement ID ${s} provided in the "measurementId" field in the local Firebase config. [${l == null ? void 0 : l.message}]`), { appId: a, measurementId: s };
      throw c;
    }
    const u = Number((o = l == null ? void 0 : l.customData) === null || o === void 0 ? void 0 : o.httpStatus) === 503 ? M7(n, i.intervalMillis, gbe) : M7(n, i.intervalMillis), d = {
      throttleEndTimeMillis: Date.now() + u,
      backoffCount: n + 1
    };
    return i.setThrottleMetadata(a, d), na.debug(`Calling attemptFetch again in ${u} millis`), $W(e, d, r, i);
  }
}
function _be(e, t) {
  return new Promise((n, r) => {
    const i = Math.max(t - Date.now(), 0), o = setTimeout(n, i);
    e.addEventListener(() => {
      clearTimeout(o), r(ba.create("fetch-throttle", {
        throttleEndTimeMillis: t
      }));
    });
  });
}
function Sbe(e) {
  if (!(e instanceof Qa) || !e.customData)
    return !1;
  const t = Number(e.customData.httpStatus);
  return t === 429 || t === 500 || t === 503 || t === 504;
}
class wbe {
  constructor() {
    this.listeners = [];
  }
  addEventListener(t) {
    this.listeners.push(t);
  }
  abort() {
    this.listeners.forEach((t) => t());
  }
}
async function xbe(e, t, n, r, i) {
  if (i && i.global) {
    e("event", n, r);
    return;
  } else {
    const o = await t, a = Object.assign(Object.assign({}, r), { send_to: o });
    e("event", n, a);
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function Ebe() {
  if (eW())
    try {
      await tW();
    } catch (e) {
      return na.warn(ba.create("indexeddb-unavailable", {
        errorInfo: e == null ? void 0 : e.toString()
      }).message), !1;
    }
  else
    return na.warn(ba.create("indexeddb-unavailable", {
      errorInfo: "IndexedDB is not available in this environment."
    }).message), !1;
  return !0;
}
async function Cbe(e, t, n, r, i, o, a) {
  var s;
  const c = bbe(e);
  c.then((h) => {
    n[h.measurementId] = h.appId, e.options.measurementId && h.measurementId !== e.options.measurementId && na.warn(`The measurement ID in the local Firebase config (${e.options.measurementId}) does not match the measurement ID fetched from the server (${h.measurementId}). To ensure analytics events are always sent to the correct Analytics property, update the measurement ID field in the local config or remove it from the local config.`);
  }).catch((h) => na.error(h)), t.push(c);
  const l = Ebe().then((h) => {
    if (h)
      return r.getId();
  }), [u, d] = await Promise.all([
    c,
    l
  ]);
  hbe(o) || sbe(o, u.measurementId), i("js", /* @__PURE__ */ new Date());
  const f = (s = a == null ? void 0 : a.config) !== null && s !== void 0 ? s : {};
  return f[tbe] = "firebase", f.update = !0, d != null && (f[ebe] = d), i("config", u.measurementId, f), u.measurementId;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Tbe {
  constructor(t) {
    this.app = t;
  }
  _delete() {
    return delete I0[this.app.options.appId], Promise.resolve();
  }
}
let I0 = {}, U7 = [];
const W7 = {};
let N5 = "dataLayer", Ibe = "gtag", q7, AW, G7 = !1;
function $be() {
  const e = [];
  if (ZU() && e.push("This is a browser extension environment."), X0e() || e.push("Cookies are not available."), e.length > 0) {
    const t = e.map((r, i) => `(${i + 1}) ${r}`).join(" "), n = ba.create("invalid-analytics-context", {
      errorInfo: t
    });
    na.warn(n.message);
  }
}
function Abe(e, t, n) {
  $be();
  const r = e.options.appId;
  if (!r)
    throw ba.create(
      "no-app-id"
      /* AnalyticsError.NO_APP_ID */
    );
  if (!e.options.apiKey)
    if (e.options.measurementId)
      na.warn(`The "apiKey" field is empty in the local Firebase config. This is needed to fetch the latest measurement ID for this Firebase app. Falling back to the measurement ID ${e.options.measurementId} provided in the "measurementId" field in the local Firebase config.`);
    else
      throw ba.create(
        "no-api-key"
        /* AnalyticsError.NO_API_KEY */
      );
  if (I0[r] != null)
    throw ba.create("already-exists", {
      id: r
    });
  if (!G7) {
    cbe(N5);
    const { wrappedGtag: o, gtagCore: a } = fbe(I0, U7, W7, N5, Ibe);
    AW = o, q7 = a, G7 = !0;
  }
  return I0[r] = Cbe(e, U7, W7, t, q7, N5, n), new Tbe(e);
}
function Rbe(e = Mx()) {
  e = Or(e);
  const t = xl(e, U_);
  return t.isInitialized() ? t.getImmediate() : Pbe(e);
}
function Pbe(e, t = {}) {
  const n = xl(e, U_);
  if (n.isInitialized()) {
    const i = n.getImmediate();
    if (ll(t, n.getOptions()))
      return i;
    throw ba.create(
      "already-initialized"
      /* AnalyticsError.ALREADY_INITIALIZED */
    );
  }
  return n.initialize({ options: t });
}
function RW(e, t, n, r) {
  e = Or(e), xbe(AW, I0[e.app.options.appId], t, n, r).catch((i) => na.error(i));
}
const K7 = "@firebase/analytics", Y7 = "0.10.17";
function Obe() {
  Is(new Ua(
    U_,
    (t, { options: n }) => {
      const r = t.getProvider("app").getImmediate(), i = t.getProvider("installations-internal").getImmediate();
      return Abe(r, i, n);
    },
    "PUBLIC"
    /* ComponentType.PUBLIC */
  )), Is(new Ua(
    "analytics-internal",
    e,
    "PRIVATE"
    /* ComponentType.PRIVATE */
  )), ta(K7, Y7), ta(K7, Y7, "esm2017");
  function e(t) {
    try {
      const n = t.getProvider(U_).getImmediate();
      return {
        logEvent: (r, i, o) => RW(n, r, i, o)
      };
    } catch (n) {
      throw ba.create("interop-component-reg-failed", {
        reason: n
      });
    }
  }
}
Obe();
class NCt extends gle {
  constructor(n, r) {
    super();
    ve(this, "analytics");
    ve(this, "log");
    this.analytics = Rbe(n), this.log = r;
  }
  async initialise() {
  }
  dispose() {
  }
  logEvent(n, r) {
    this.log.info("FirebaseAnalyticsService", "logEvent", n, r), RW(this.analytics, n, r);
  }
}
function PW() {
  return {
    "dependent-sdk-initialized-before-auth": "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK."
  };
}
const Mbe = PW, OW = new Ff("auth", "Firebase", PW());
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const W_ = new Ox("@firebase/auth");
function kbe(e, ...t) {
  W_.logLevel <= _n.WARN && W_.warn(`Auth (${Op}): ${e}`, ...t);
}
function J1(e, ...t) {
  W_.logLevel <= _n.ERROR && W_.error(`Auth (${Op}): ${e}`, ...t);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Wa(e, ...t) {
  throw RO(e, ...t);
}
function bs(e, ...t) {
  return RO(e, ...t);
}
function AO(e, t, n) {
  const r = Object.assign(Object.assign({}, Mbe()), { [t]: n });
  return new Ff("auth", "Firebase", r).create(t, {
    appName: e.name
  });
}
function cc(e) {
  return AO(e, "operation-not-supported-in-this-environment", "Operations that alter the current user are not supported in conjunction with FirebaseServerApp");
}
function MW(e, t, n) {
  const r = n;
  if (!(t instanceof r))
    throw r.name !== t.constructor.name && Wa(
      e,
      "argument-error"
      /* AuthErrorCode.ARGUMENT_ERROR */
    ), AO(e, "argument-error", `Type of ${t.constructor.name} does not match expected instance.Did you pass a reference from a different Auth SDK?`);
}
function RO(e, ...t) {
  if (typeof e != "string") {
    const n = t[0], r = [...t.slice(1)];
    return r[0] && (r[0].appName = e.name), e._errorFactory.create(n, ...r);
  }
  return OW.create(e, ...t);
}
function Vt(e, t, ...n) {
  if (!e)
    throw RO(t, ...n);
}
function Xc(e) {
  const t = "INTERNAL ASSERTION FAILED: " + e;
  throw J1(t), new Error(t);
}
function dl(e, t) {
  e || Xc(t);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function O$() {
  var e;
  return typeof self < "u" && ((e = self.location) === null || e === void 0 ? void 0 : e.href) || "";
}
function Nbe() {
  return X7() === "http:" || X7() === "https:";
}
function X7() {
  var e;
  return typeof self < "u" && ((e = self.location) === null || e === void 0 ? void 0 : e.protocol) || null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Dbe() {
  return typeof navigator < "u" && navigator && "onLine" in navigator && typeof navigator.onLine == "boolean" && // Apply only for traditional web apps and Chrome extensions.
  // This is especially true for Cordova apps which have unreliable
  // navigator.onLine behavior unless cordova-plugin-network-information is
  // installed which overwrites the native navigator.onLine value and
  // defines navigator.connection.
  (Nbe() || ZU() || "connection" in navigator) ? navigator.onLine : !0;
}
function jbe() {
  if (typeof navigator > "u")
    return null;
  const e = navigator;
  return (
    // Most reliable, but only supported in Chrome/Firefox.
    e.languages && e.languages[0] || // Supported in most browsers, but returns the language of the browser
    // UI, not the language set in browser settings.
    e.language || // Couldn't determine language.
    null
  );
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class sy {
  constructor(t, n) {
    this.shortDelay = t, this.longDelay = n, dl(n > t, "Short delay should be less than long delay!"), this.isMobile = U0e() || G0e();
  }
  get() {
    return Dbe() ? this.isMobile ? this.longDelay : this.shortDelay : Math.min(5e3, this.shortDelay);
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function PO(e, t) {
  dl(e.emulator, "Emulator should always be set here");
  const { url: n } = e.emulator;
  return t ? `${n}${t.startsWith("/") ? t.slice(1) : t}` : n;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class kW {
  static initialize(t, n, r) {
    this.fetchImpl = t, n && (this.headersImpl = n), r && (this.responseImpl = r);
  }
  static fetch() {
    if (this.fetchImpl)
      return this.fetchImpl;
    if (typeof self < "u" && "fetch" in self)
      return self.fetch;
    if (typeof globalThis < "u" && globalThis.fetch)
      return globalThis.fetch;
    if (typeof fetch < "u")
      return fetch;
    Xc("Could not find fetch implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
  }
  static headers() {
    if (this.headersImpl)
      return this.headersImpl;
    if (typeof self < "u" && "Headers" in self)
      return self.Headers;
    if (typeof globalThis < "u" && globalThis.Headers)
      return globalThis.Headers;
    if (typeof Headers < "u")
      return Headers;
    Xc("Could not find Headers implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
  }
  static response() {
    if (this.responseImpl)
      return this.responseImpl;
    if (typeof self < "u" && "Response" in self)
      return self.Response;
    if (typeof globalThis < "u" && globalThis.Response)
      return globalThis.Response;
    if (typeof Response < "u")
      return Response;
    Xc("Could not find Response implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Lbe = {
  // Custom token errors.
  CREDENTIAL_MISMATCH: "custom-token-mismatch",
  // This can only happen if the SDK sends a bad request.
  MISSING_CUSTOM_TOKEN: "internal-error",
  // Create Auth URI errors.
  INVALID_IDENTIFIER: "invalid-email",
  // This can only happen if the SDK sends a bad request.
  MISSING_CONTINUE_URI: "internal-error",
  // Sign in with email and password errors (some apply to sign up too).
  INVALID_PASSWORD: "wrong-password",
  // This can only happen if the SDK sends a bad request.
  MISSING_PASSWORD: "missing-password",
  // Thrown if Email Enumeration Protection is enabled in the project and the email or password is
  // invalid.
  INVALID_LOGIN_CREDENTIALS: "invalid-credential",
  // Sign up with email and password errors.
  EMAIL_EXISTS: "email-already-in-use",
  PASSWORD_LOGIN_DISABLED: "operation-not-allowed",
  // Verify assertion for sign in with credential errors:
  INVALID_IDP_RESPONSE: "invalid-credential",
  INVALID_PENDING_TOKEN: "invalid-credential",
  FEDERATED_USER_ID_ALREADY_LINKED: "credential-already-in-use",
  // This can only happen if the SDK sends a bad request.
  MISSING_REQ_TYPE: "internal-error",
  // Send Password reset email errors:
  EMAIL_NOT_FOUND: "user-not-found",
  RESET_PASSWORD_EXCEED_LIMIT: "too-many-requests",
  EXPIRED_OOB_CODE: "expired-action-code",
  INVALID_OOB_CODE: "invalid-action-code",
  // This can only happen if the SDK sends a bad request.
  MISSING_OOB_CODE: "internal-error",
  // Operations that require ID token in request:
  CREDENTIAL_TOO_OLD_LOGIN_AGAIN: "requires-recent-login",
  INVALID_ID_TOKEN: "invalid-user-token",
  TOKEN_EXPIRED: "user-token-expired",
  USER_NOT_FOUND: "user-token-expired",
  // Other errors.
  TOO_MANY_ATTEMPTS_TRY_LATER: "too-many-requests",
  PASSWORD_DOES_NOT_MEET_REQUIREMENTS: "password-does-not-meet-requirements",
  // Phone Auth related errors.
  INVALID_CODE: "invalid-verification-code",
  INVALID_SESSION_INFO: "invalid-verification-id",
  INVALID_TEMPORARY_PROOF: "invalid-credential",
  MISSING_SESSION_INFO: "missing-verification-id",
  SESSION_EXPIRED: "code-expired",
  // Other action code errors when additional settings passed.
  // MISSING_CONTINUE_URI is getting mapped to INTERNAL_ERROR above.
  // This is OK as this error will be caught by client side validation.
  MISSING_ANDROID_PACKAGE_NAME: "missing-android-pkg-name",
  UNAUTHORIZED_DOMAIN: "unauthorized-continue-uri",
  // getProjectConfig errors when clientId is passed.
  INVALID_OAUTH_CLIENT_ID: "invalid-oauth-client-id",
  // User actions (sign-up or deletion) disabled errors.
  ADMIN_ONLY_OPERATION: "admin-restricted-operation",
  // Multi factor related errors.
  INVALID_MFA_PENDING_CREDENTIAL: "invalid-multi-factor-session",
  MFA_ENROLLMENT_NOT_FOUND: "multi-factor-info-not-found",
  MISSING_MFA_ENROLLMENT_ID: "missing-multi-factor-info",
  MISSING_MFA_PENDING_CREDENTIAL: "missing-multi-factor-session",
  SECOND_FACTOR_EXISTS: "second-factor-already-in-use",
  SECOND_FACTOR_LIMIT_EXCEEDED: "maximum-second-factor-count-exceeded",
  // Blocking functions related errors.
  BLOCKING_FUNCTION_ERROR_RESPONSE: "internal-error",
  // Recaptcha related errors.
  RECAPTCHA_NOT_ENABLED: "recaptcha-not-enabled",
  MISSING_RECAPTCHA_TOKEN: "missing-recaptcha-token",
  INVALID_RECAPTCHA_TOKEN: "invalid-recaptcha-token",
  INVALID_RECAPTCHA_ACTION: "invalid-recaptcha-action",
  MISSING_CLIENT_TYPE: "missing-client-type",
  MISSING_RECAPTCHA_VERSION: "missing-recaptcha-version",
  INVALID_RECAPTCHA_VERSION: "invalid-recaptcha-version",
  INVALID_REQ_TYPE: "invalid-req-type"
  /* AuthErrorCode.INVALID_REQ_TYPE */
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Fbe = [
  "/v1/accounts:signInWithCustomToken",
  "/v1/accounts:signInWithEmailLink",
  "/v1/accounts:signInWithIdp",
  "/v1/accounts:signInWithPassword",
  "/v1/accounts:signInWithPhoneNumber",
  "/v1/token"
  /* Endpoint.TOKEN */
], Vbe = new sy(3e4, 6e4);
function Ku(e, t) {
  return e.tenantId && !t.tenantId ? Object.assign(Object.assign({}, t), { tenantId: e.tenantId }) : t;
}
async function Yu(e, t, n, r, i = {}) {
  return NW(e, i, async () => {
    let o = {}, a = {};
    r && (t === "GET" ? a = r : o = {
      body: JSON.stringify(r)
    });
    const s = ay(Object.assign({ key: e.config.apiKey }, a)).slice(1), c = await e._getAdditionalHeaders();
    c[
      "Content-Type"
      /* HttpHeader.CONTENT_TYPE */
    ] = "application/json", e.languageCode && (c[
      "X-Firebase-Locale"
      /* HttpHeader.X_FIREBASE_LOCALE */
    ] = e.languageCode);
    const l = Object.assign({
      method: t,
      headers: c
    }, o);
    return q0e() || (l.referrerPolicy = "no-referrer"), e.emulatorConfig && Gu(e.emulatorConfig.host) && (l.credentials = "include"), kW.fetch()(await DW(e, e.config.apiHost, n, s), l);
  });
}
async function NW(e, t, n) {
  e._canInitEmulator = !1;
  const r = Object.assign(Object.assign({}, Lbe), t);
  try {
    const i = new zbe(e), o = await Promise.race([
      n(),
      i.promise
    ]);
    i.clearNetworkTimeout();
    const a = await o.json();
    if ("needConfirmation" in a)
      throw Nb(e, "account-exists-with-different-credential", a);
    if (o.ok && !("errorMessage" in a))
      return a;
    {
      const s = o.ok ? a.errorMessage : a.error.message, [c, l] = s.split(" : ");
      if (c === "FEDERATED_USER_ID_ALREADY_LINKED")
        throw Nb(e, "credential-already-in-use", a);
      if (c === "EMAIL_EXISTS")
        throw Nb(e, "email-already-in-use", a);
      if (c === "USER_DISABLED")
        throw Nb(e, "user-disabled", a);
      const u = r[c] || c.toLowerCase().replace(/[_\s]+/g, "-");
      if (l)
        throw AO(e, u, l);
      Wa(e, u);
    }
  } catch (i) {
    if (i instanceof Qa)
      throw i;
    Wa(e, "network-request-failed", { message: String(i) });
  }
}
async function cy(e, t, n, r, i = {}) {
  const o = await Yu(e, t, n, r, i);
  return "mfaPendingCredential" in o && Wa(e, "multi-factor-auth-required", {
    _serverResponse: o
  }), o;
}
async function DW(e, t, n, r) {
  const i = `${t}${n}?${r}`, o = e, a = o.config.emulator ? PO(e.config, i) : `${e.config.apiScheme}://${i}`;
  return Fbe.includes(n) && (await o._persistenceManagerAvailable, o._getPersistenceType() === "COOKIE") ? o._getPersistence()._getFinalTarget(a).toString() : a;
}
function Bbe(e) {
  switch (e) {
    case "ENFORCE":
      return "ENFORCE";
    case "AUDIT":
      return "AUDIT";
    case "OFF":
      return "OFF";
    default:
      return "ENFORCEMENT_STATE_UNSPECIFIED";
  }
}
class zbe {
  clearNetworkTimeout() {
    clearTimeout(this.timer);
  }
  constructor(t) {
    this.auth = t, this.timer = null, this.promise = new Promise((n, r) => {
      this.timer = setTimeout(() => r(bs(
        this.auth,
        "network-request-failed"
        /* AuthErrorCode.NETWORK_REQUEST_FAILED */
      )), Vbe.get());
    });
  }
}
function Nb(e, t, n) {
  const r = {
    appName: e.name
  };
  n.email && (r.email = n.email), n.phoneNumber && (r.phoneNumber = n.phoneNumber);
  const i = bs(e, t, r);
  return i.customData._tokenResponse = n, i;
}
function Q7(e) {
  return e !== void 0 && e.enterprise !== void 0;
}
class Hbe {
  constructor(t) {
    if (this.siteKey = "", this.recaptchaEnforcementState = [], t.recaptchaKey === void 0)
      throw new Error("recaptchaKey undefined");
    this.siteKey = t.recaptchaKey.split("/")[3], this.recaptchaEnforcementState = t.recaptchaEnforcementState;
  }
  /**
   * Returns the reCAPTCHA Enterprise enforcement state for the given provider.
   *
   * @param providerStr - The provider whose enforcement state is to be returned.
   * @returns The reCAPTCHA Enterprise enforcement state for the given provider.
   */
  getProviderEnforcementState(t) {
    if (!this.recaptchaEnforcementState || this.recaptchaEnforcementState.length === 0)
      return null;
    for (const n of this.recaptchaEnforcementState)
      if (n.provider && n.provider === t)
        return Bbe(n.enforcementState);
    return null;
  }
  /**
   * Returns true if the reCAPTCHA Enterprise enforcement state for the provider is set to ENFORCE or AUDIT.
   *
   * @param providerStr - The provider whose enablement state is to be returned.
   * @returns Whether or not reCAPTCHA Enterprise protection is enabled for the given provider.
   */
  isProviderEnabled(t) {
    return this.getProviderEnforcementState(t) === "ENFORCE" || this.getProviderEnforcementState(t) === "AUDIT";
  }
  /**
   * Returns true if reCAPTCHA Enterprise protection is enabled in at least one provider, otherwise
   * returns false.
   *
   * @returns Whether or not reCAPTCHA Enterprise protection is enabled for at least one provider.
   */
  isAnyProviderEnabled() {
    return this.isProviderEnabled(
      "EMAIL_PASSWORD_PROVIDER"
      /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */
    ) || this.isProviderEnabled(
      "PHONE_PROVIDER"
      /* RecaptchaAuthProvider.PHONE_PROVIDER */
    );
  }
}
async function Ube(e, t) {
  return Yu(e, "GET", "/v2/recaptchaConfig", Ku(e, t));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function Wbe(e, t) {
  return Yu(e, "POST", "/v1/accounts:delete", t);
}
async function q_(e, t) {
  return Yu(e, "POST", "/v1/accounts:lookup", t);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function $0(e) {
  if (e)
    try {
      const t = new Date(Number(e));
      if (!isNaN(t.getTime()))
        return t.toUTCString();
    } catch {
    }
}
async function qbe(e, t = !1) {
  const n = Or(e), r = await n.getIdToken(t), i = OO(r);
  Vt(
    i && i.exp && i.auth_time && i.iat,
    n.auth,
    "internal-error"
    /* AuthErrorCode.INTERNAL_ERROR */
  );
  const o = typeof i.firebase == "object" ? i.firebase : void 0, a = o == null ? void 0 : o.sign_in_provider;
  return {
    claims: i,
    token: r,
    authTime: $0(D5(i.auth_time)),
    issuedAtTime: $0(D5(i.iat)),
    expirationTime: $0(D5(i.exp)),
    signInProvider: a || null,
    signInSecondFactor: (o == null ? void 0 : o.sign_in_second_factor) || null
  };
}
function D5(e) {
  return Number(e) * 1e3;
}
function OO(e) {
  const [t, n, r] = e.split(".");
  if (t === void 0 || n === void 0 || r === void 0)
    return J1("JWT malformed, contained fewer than 3 sections"), null;
  try {
    const i = KU(n);
    return i ? JSON.parse(i) : (J1("Failed to decode base64 JWT payload"), null);
  } catch (i) {
    return J1("Caught error parsing JWT payload as JSON", i == null ? void 0 : i.toString()), null;
  }
}
function J7(e) {
  const t = OO(e);
  return Vt(
    t,
    "internal-error"
    /* AuthErrorCode.INTERNAL_ERROR */
  ), Vt(
    typeof t.exp < "u",
    "internal-error"
    /* AuthErrorCode.INTERNAL_ERROR */
  ), Vt(
    typeof t.iat < "u",
    "internal-error"
    /* AuthErrorCode.INTERNAL_ERROR */
  ), Number(t.exp) - Number(t.iat);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function ov(e, t, n = !1) {
  if (n)
    return t;
  try {
    return await t;
  } catch (r) {
    throw r instanceof Qa && Gbe(r) && e.auth.currentUser === e && await e.auth.signOut(), r;
  }
}
function Gbe({ code: e }) {
  return e === "auth/user-disabled" || e === "auth/user-token-expired";
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Kbe {
  constructor(t) {
    this.user = t, this.isRunning = !1, this.timerId = null, this.errorBackoff = 3e4;
  }
  _start() {
    this.isRunning || (this.isRunning = !0, this.schedule());
  }
  _stop() {
    this.isRunning && (this.isRunning = !1, this.timerId !== null && clearTimeout(this.timerId));
  }
  getInterval(t) {
    var n;
    if (t) {
      const r = this.errorBackoff;
      return this.errorBackoff = Math.min(
        this.errorBackoff * 2,
        96e4
        /* Duration.RETRY_BACKOFF_MAX */
      ), r;
    } else {
      this.errorBackoff = 3e4;
      const i = ((n = this.user.stsTokenManager.expirationTime) !== null && n !== void 0 ? n : 0) - Date.now() - 3e5;
      return Math.max(0, i);
    }
  }
  schedule(t = !1) {
    if (!this.isRunning)
      return;
    const n = this.getInterval(t);
    this.timerId = setTimeout(async () => {
      await this.iteration();
    }, n);
  }
  async iteration() {
    try {
      await this.user.getIdToken(!0);
    } catch (t) {
      (t == null ? void 0 : t.code) === "auth/network-request-failed" && this.schedule(
        /* wasError */
        !0
      );
      return;
    }
    this.schedule();
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class M$ {
  constructor(t, n) {
    this.createdAt = t, this.lastLoginAt = n, this._initializeTime();
  }
  _initializeTime() {
    this.lastSignInTime = $0(this.lastLoginAt), this.creationTime = $0(this.createdAt);
  }
  _copy(t) {
    this.createdAt = t.createdAt, this.lastLoginAt = t.lastLoginAt, this._initializeTime();
  }
  toJSON() {
    return {
      createdAt: this.createdAt,
      lastLoginAt: this.lastLoginAt
    };
  }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function G_(e) {
  var t;
  const n = e.auth, r = await e.getIdToken(), i = await ov(e, q_(n, { idToken: r }));
  Vt(
    i == null ? void 0 : i.users.length,
    n,
    "internal-error"
    /* AuthErrorCode.INTERNAL_ERROR */
  );
  const o = i.users[0];
  e._notifyReloadListener(o);
  const a = !((t = o.providerUserInfo) === null || t === void 0) && t.length ? jW(o.providerUserInfo) : [], s = Xbe(e.providerData, a), c = e.isAnonymous, l = !(e.email && o.passwordHash) && !(s != null && s.length), u = c ? l : !1, d = {
    uid: o.localId,
    displayName: o.displayName || null,
    photoURL: o.photoUrl || null,
    email: o.email || null,
    emailVerified: o.emailVerified || !1,
    phoneNumber: o.phoneNumber || null,
    tenantId: o.tenantId || null,
    providerData: s,
    metadata: new M$(o.createdAt, o.lastLoginAt),
    isAnonymous: u
  };
  Object.assign(e, d);
}
async function Ybe(e) {
  const t = Or(e);
  await G_(t), await t.auth._persistUserIfCurrent(t), t.auth._notifyListenersIfCurrent(t);
}
function Xbe(e, t) {
  return [...e.filter((r) => !t.some((i) => i.providerId === r.providerId)), ...t];
}
function jW(e) {
  return e.map((t) => {
    var { providerId: n } = t, r = QP(t, ["providerId"]);
    return {
      providerId: n,
      uid: r.rawId || "",
      displayName: r.displayName || null,
      email: r.email || null,
      phoneNumber: r.phoneNumber || null,
      photoURL: r.photoUrl || null
    };
  });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function Qbe(e, t) {
  const n = await NW(e, {}, async () => {
    const r = ay({
      grant_type: "refresh_token",
      refresh_token: t
    }).slice(1), { tokenApiHost: i, apiKey: o } = e.config, a = await DW(e, i, "/v1/token", `key=${o}`), s = await e._getAdditionalHeaders();
    s[
      "Content-Type"
      /* HttpHeader.CONTENT_TYPE */
    ] = "application/x-www-form-urlencoded";
    const c = {
      method: "POST",
      headers: s,
      body: r
    };
    return e.emulatorConfig && Gu(e.emulatorConfig.host) && (c.credentials = "include"), kW.fetch()(a, c);
  });
  return {
    accessToken: n.access_token,
    expiresIn: n.expires_in,
    refreshToken: n.refresh_token
  };
}
async function Jbe(e, t) {
  return Yu(e, "POST", "/v2/accounts:revokeToken", Ku(e, t));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ig {
  constructor() {
    this.refreshToken = null, this.accessToken = null, this.expirationTime = null;
  }
  get isExpired() {
    return !this.expirationTime || Date.now() > this.expirationTime - 3e4;
  }
  updateFromServerResponse(t) {
    Vt(
      t.idToken,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    ), Vt(
      typeof t.idToken < "u",
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    ), Vt(
      typeof t.refreshToken < "u",
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    );
    const n = "expiresIn" in t && typeof t.expiresIn < "u" ? Number(t.expiresIn) : J7(t.idToken);
    this.updateTokensAndExpiration(t.idToken, t.refreshToken, n);
  }
  updateFromIdToken(t) {
    Vt(
      t.length !== 0,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    );
    const n = J7(t);
    this.updateTokensAndExpiration(t, null, n);
  }
  async getToken(t, n = !1) {
    return !n && this.accessToken && !this.isExpired ? this.accessToken : (Vt(
      this.refreshToken,
      t,
      "user-token-expired"
      /* AuthErrorCode.TOKEN_EXPIRED */
    ), this.refreshToken ? (await this.refresh(t, this.refreshToken), this.accessToken) : null);
  }
  clearRefreshToken() {
    this.refreshToken = null;
  }
  async refresh(t, n) {
    const { accessToken: r, refreshToken: i, expiresIn: o } = await Qbe(t, n);
    this.updateTokensAndExpiration(r, i, Number(o));
  }
  updateTokensAndExpiration(t, n, r) {
    this.refreshToken = n || null, this.accessToken = t || null, this.expirationTime = Date.now() + r * 1e3;
  }
  static fromJSON(t, n) {
    const { refreshToken: r, accessToken: i, expirationTime: o } = n, a = new ig();
    return r && (Vt(typeof r == "string", "internal-error", {
      appName: t
    }), a.refreshToken = r), i && (Vt(typeof i == "string", "internal-error", {
      appName: t
    }), a.accessToken = i), o && (Vt(typeof o == "number", "internal-error", {
      appName: t
    }), a.expirationTime = o), a;
  }
  toJSON() {
    return {
      refreshToken: this.refreshToken,
      accessToken: this.accessToken,
      expirationTime: this.expirationTime
    };
  }
  _assign(t) {
    this.accessToken = t.accessToken, this.refreshToken = t.refreshToken, this.expirationTime = t.expirationTime;
  }
  _clone() {
    return Object.assign(new ig(), this.toJSON());
  }
  _performRefresh() {
    return Xc("not implemented");
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Ml(e, t) {
  Vt(typeof e == "string" || typeof e > "u", "internal-error", { appName: t });
}
class gs {
  constructor(t) {
    var { uid: n, auth: r, stsTokenManager: i } = t, o = QP(t, ["uid", "auth", "stsTokenManager"]);
    this.providerId = "firebase", this.proactiveRefresh = new Kbe(this), this.reloadUserInfo = null, this.reloadListener = null, this.uid = n, this.auth = r, this.stsTokenManager = i, this.accessToken = i.accessToken, this.displayName = o.displayName || null, this.email = o.email || null, this.emailVerified = o.emailVerified || !1, this.phoneNumber = o.phoneNumber || null, this.photoURL = o.photoURL || null, this.isAnonymous = o.isAnonymous || !1, this.tenantId = o.tenantId || null, this.providerData = o.providerData ? [...o.providerData] : [], this.metadata = new M$(o.createdAt || void 0, o.lastLoginAt || void 0);
  }
  async getIdToken(t) {
    const n = await ov(this, this.stsTokenManager.getToken(this.auth, t));
    return Vt(
      n,
      this.auth,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    ), this.accessToken !== n && (this.accessToken = n, await this.auth._persistUserIfCurrent(this), this.auth._notifyListenersIfCurrent(this)), n;
  }
  getIdTokenResult(t) {
    return qbe(this, t);
  }
  reload() {
    return Ybe(this);
  }
  _assign(t) {
    this !== t && (Vt(
      this.uid === t.uid,
      this.auth,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    ), this.displayName = t.displayName, this.photoURL = t.photoURL, this.email = t.email, this.emailVerified = t.emailVerified, this.phoneNumber = t.phoneNumber, this.isAnonymous = t.isAnonymous, this.tenantId = t.tenantId, this.providerData = t.providerData.map((n) => Object.assign({}, n)), this.metadata._copy(t.metadata), this.stsTokenManager._assign(t.stsTokenManager));
  }
  _clone(t) {
    const n = new gs(Object.assign(Object.assign({}, this), { auth: t, stsTokenManager: this.stsTokenManager._clone() }));
    return n.metadata._copy(this.metadata), n;
  }
  _onReload(t) {
    Vt(
      !this.reloadListener,
      this.auth,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    ), this.reloadListener = t, this.reloadUserInfo && (this._notifyReloadListener(this.reloadUserInfo), this.reloadUserInfo = null);
  }
  _notifyReloadListener(t) {
    this.reloadListener ? this.reloadListener(t) : this.reloadUserInfo = t;
  }
  _startProactiveRefresh() {
    this.proactiveRefresh._start();
  }
  _stopProactiveRefresh() {
    this.proactiveRefresh._stop();
  }
  async _updateTokensIfNecessary(t, n = !1) {
    let r = !1;
    t.idToken && t.idToken !== this.stsTokenManager.accessToken && (this.stsTokenManager.updateFromServerResponse(t), r = !0), n && await G_(this), await this.auth._persistUserIfCurrent(this), r && this.auth._notifyListenersIfCurrent(this);
  }
  async delete() {
    if (Io(this.auth.app))
      return Promise.reject(cc(this.auth));
    const t = await this.getIdToken();
    return await ov(this, Wbe(this.auth, { idToken: t })), this.stsTokenManager.clearRefreshToken(), this.auth.signOut();
  }
  toJSON() {
    return Object.assign(Object.assign({
      uid: this.uid,
      email: this.email || void 0,
      emailVerified: this.emailVerified,
      displayName: this.displayName || void 0,
      isAnonymous: this.isAnonymous,
      photoURL: this.photoURL || void 0,
      phoneNumber: this.phoneNumber || void 0,
      tenantId: this.tenantId || void 0,
      providerData: this.providerData.map((t) => Object.assign({}, t)),
      stsTokenManager: this.stsTokenManager.toJSON(),
      // Redirect event ID must be maintained in case there is a pending
      // redirect event.
      _redirectEventId: this._redirectEventId
    }, this.metadata.toJSON()), {
      // Required for compatibility with the legacy SDK (go/firebase-auth-sdk-persistence-parsing):
      apiKey: this.auth.config.apiKey,
      appName: this.auth.name
    });
  }
  get refreshToken() {
    return this.stsTokenManager.refreshToken || "";
  }
  static _fromJSON(t, n) {
    var r, i, o, a, s, c, l, u;
    const d = (r = n.displayName) !== null && r !== void 0 ? r : void 0, f = (i = n.email) !== null && i !== void 0 ? i : void 0, h = (o = n.phoneNumber) !== null && o !== void 0 ? o : void 0, p = (a = n.photoURL) !== null && a !== void 0 ? a : void 0, g = (s = n.tenantId) !== null && s !== void 0 ? s : void 0, m = (c = n._redirectEventId) !== null && c !== void 0 ? c : void 0, v = (l = n.createdAt) !== null && l !== void 0 ? l : void 0, y = (u = n.lastLoginAt) !== null && u !== void 0 ? u : void 0, { uid: _, emailVerified: b, isAnonymous: w, providerData: C, stsTokenManager: x } = n;
    Vt(
      _ && x,
      t,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    );
    const T = ig.fromJSON(this.name, x);
    Vt(
      typeof _ == "string",
      t,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    ), Ml(d, t.name), Ml(f, t.name), Vt(
      typeof b == "boolean",
      t,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    ), Vt(
      typeof w == "boolean",
      t,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    ), Ml(h, t.name), Ml(p, t.name), Ml(g, t.name), Ml(m, t.name), Ml(v, t.name), Ml(y, t.name);
    const E = new gs({
      uid: _,
      auth: t,
      email: f,
      emailVerified: b,
      displayName: d,
      isAnonymous: w,
      photoURL: p,
      phoneNumber: h,
      tenantId: g,
      stsTokenManager: T,
      createdAt: v,
      lastLoginAt: y
    });
    return C && Array.isArray(C) && (E.providerData = C.map((R) => Object.assign({}, R))), m && (E._redirectEventId = m), E;
  }
  /**
   * Initialize a User from an idToken server response
   * @param auth
   * @param idTokenResponse
   */
  static async _fromIdTokenResponse(t, n, r = !1) {
    const i = new ig();
    i.updateFromServerResponse(n);
    const o = new gs({
      uid: n.localId,
      auth: t,
      stsTokenManager: i,
      isAnonymous: r
    });
    return await G_(o), o;
  }
  /**
   * Initialize a User from an idToken server response
   * @param auth
   * @param idTokenResponse
   */
  static async _fromGetAccountInfoResponse(t, n, r) {
    const i = n.users[0];
    Vt(
      i.localId !== void 0,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    );
    const o = i.providerUserInfo !== void 0 ? jW(i.providerUserInfo) : [], a = !(i.email && i.passwordHash) && !(o != null && o.length), s = new ig();
    s.updateFromIdToken(r);
    const c = new gs({
      uid: i.localId,
      auth: t,
      stsTokenManager: s,
      isAnonymous: a
    }), l = {
      uid: i.localId,
      displayName: i.displayName || null,
      photoURL: i.photoUrl || null,
      email: i.email || null,
      emailVerified: i.emailVerified || !1,
      phoneNumber: i.phoneNumber || null,
      tenantId: i.tenantId || null,
      providerData: o,
      metadata: new M$(i.createdAt, i.lastLoginAt),
      isAnonymous: !(i.email && i.passwordHash) && !(o != null && o.length)
    };
    return Object.assign(c, l), c;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Z7 = /* @__PURE__ */ new Map();
function Qc(e) {
  dl(e instanceof Function, "Expected a class definition");
  let t = Z7.get(e);
  return t ? (dl(t instanceof e, "Instance stored in cache mismatched with class"), t) : (t = new e(), Z7.set(e, t), t);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class LW {
  constructor() {
    this.type = "NONE", this.storage = {};
  }
  async _isAvailable() {
    return !0;
  }
  async _set(t, n) {
    this.storage[t] = n;
  }
  async _get(t) {
    const n = this.storage[t];
    return n === void 0 ? null : n;
  }
  async _remove(t) {
    delete this.storage[t];
  }
  _addListener(t, n) {
  }
  _removeListener(t, n) {
  }
}
LW.type = "NONE";
const eD = LW;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Z1(e, t, n) {
  return `firebase:${e}:${t}:${n}`;
}
class og {
  constructor(t, n, r) {
    this.persistence = t, this.auth = n, this.userKey = r;
    const { config: i, name: o } = this.auth;
    this.fullUserKey = Z1(this.userKey, i.apiKey, o), this.fullPersistenceKey = Z1("persistence", i.apiKey, o), this.boundEventHandler = n._onStorageEvent.bind(n), this.persistence._addListener(this.fullUserKey, this.boundEventHandler);
  }
  setCurrentUser(t) {
    return this.persistence._set(this.fullUserKey, t.toJSON());
  }
  async getCurrentUser() {
    const t = await this.persistence._get(this.fullUserKey);
    if (!t)
      return null;
    if (typeof t == "string") {
      const n = await q_(this.auth, { idToken: t }).catch(() => {
      });
      return n ? gs._fromGetAccountInfoResponse(this.auth, n, t) : null;
    }
    return gs._fromJSON(this.auth, t);
  }
  removeCurrentUser() {
    return this.persistence._remove(this.fullUserKey);
  }
  savePersistenceForRedirect() {
    return this.persistence._set(this.fullPersistenceKey, this.persistence.type);
  }
  async setPersistence(t) {
    if (this.persistence === t)
      return;
    const n = await this.getCurrentUser();
    if (await this.removeCurrentUser(), this.persistence = t, n)
      return this.setCurrentUser(n);
  }
  delete() {
    this.persistence._removeListener(this.fullUserKey, this.boundEventHandler);
  }
  static async create(t, n, r = "authUser") {
    if (!n.length)
      return new og(Qc(eD), t, r);
    const i = (await Promise.all(n.map(async (l) => {
      if (await l._isAvailable())
        return l;
    }))).filter((l) => l);
    let o = i[0] || Qc(eD);
    const a = Z1(r, t.config.apiKey, t.name);
    let s = null;
    for (const l of n)
      try {
        const u = await l._get(a);
        if (u) {
          let d;
          if (typeof u == "string") {
            const f = await q_(t, {
              idToken: u
            }).catch(() => {
            });
            if (!f)
              break;
            d = await gs._fromGetAccountInfoResponse(t, f, u);
          } else
            d = gs._fromJSON(t, u);
          l !== o && (s = d), o = l;
          break;
        }
      } catch {
      }
    const c = i.filter((l) => l._shouldAllowMigration);
    return !o._shouldAllowMigration || !c.length ? new og(o, t, r) : (o = c[0], s && await o._set(a, s.toJSON()), await Promise.all(n.map(async (l) => {
      if (l !== o)
        try {
          await l._remove(a);
        } catch {
        }
    })), new og(o, t, r));
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function tD(e) {
  const t = e.toLowerCase();
  if (t.includes("opera/") || t.includes("opr/") || t.includes("opios/"))
    return "Opera";
  if (zW(t))
    return "IEMobile";
  if (t.includes("msie") || t.includes("trident/"))
    return "IE";
  if (t.includes("edge/"))
    return "Edge";
  if (FW(t))
    return "Firefox";
  if (t.includes("silk/"))
    return "Silk";
  if (UW(t))
    return "Blackberry";
  if (WW(t))
    return "Webos";
  if (VW(t))
    return "Safari";
  if ((t.includes("chrome/") || BW(t)) && !t.includes("edge/"))
    return "Chrome";
  if (HW(t))
    return "Android";
  {
    const n = /([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/, r = e.match(n);
    if ((r == null ? void 0 : r.length) === 2)
      return r[1];
  }
  return "Other";
}
function FW(e = ho()) {
  return /firefox\//i.test(e);
}
function VW(e = ho()) {
  const t = e.toLowerCase();
  return t.includes("safari/") && !t.includes("chrome/") && !t.includes("crios/") && !t.includes("android");
}
function BW(e = ho()) {
  return /crios\//i.test(e);
}
function zW(e = ho()) {
  return /iemobile/i.test(e);
}
function HW(e = ho()) {
  return /android/i.test(e);
}
function UW(e = ho()) {
  return /blackberry/i.test(e);
}
function WW(e = ho()) {
  return /webos/i.test(e);
}
function MO(e = ho()) {
  return /iphone|ipad|ipod/i.test(e) || /macintosh/i.test(e) && /mobile/i.test(e);
}
function Zbe(e = ho()) {
  var t;
  return MO(e) && !!(!((t = window.navigator) === null || t === void 0) && t.standalone);
}
function e1e() {
  return K0e() && document.documentMode === 10;
}
function qW(e = ho()) {
  return MO(e) || HW(e) || WW(e) || UW(e) || /windows phone/i.test(e) || zW(e);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function GW(e, t = []) {
  let n;
  switch (e) {
    case "Browser":
      n = tD(ho());
      break;
    case "Worker":
      n = `${tD(ho())}-${e}`;
      break;
    default:
      n = e;
  }
  const r = t.length ? t.join(",") : "FirebaseCore-web";
  return `${n}/JsCore/${Op}/${r}`;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class t1e {
  constructor(t) {
    this.auth = t, this.queue = [];
  }
  pushCallback(t, n) {
    const r = (o) => new Promise((a, s) => {
      try {
        const c = t(o);
        a(c);
      } catch (c) {
        s(c);
      }
    });
    r.onAbort = n, this.queue.push(r);
    const i = this.queue.length - 1;
    return () => {
      this.queue[i] = () => Promise.resolve();
    };
  }
  async runMiddleware(t) {
    if (this.auth.currentUser === t)
      return;
    const n = [];
    try {
      for (const r of this.queue)
        await r(t), r.onAbort && n.push(r.onAbort);
    } catch (r) {
      n.reverse();
      for (const i of n)
        try {
          i();
        } catch {
        }
      throw this.auth._errorFactory.create("login-blocked", {
        originalMessage: r == null ? void 0 : r.message
      });
    }
  }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function n1e(e, t = {}) {
  return Yu(e, "GET", "/v2/passwordPolicy", Ku(e, t));
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const r1e = 6;
class i1e {
  constructor(t) {
    var n, r, i, o;
    const a = t.customStrengthOptions;
    this.customStrengthOptions = {}, this.customStrengthOptions.minPasswordLength = (n = a.minPasswordLength) !== null && n !== void 0 ? n : r1e, a.maxPasswordLength && (this.customStrengthOptions.maxPasswordLength = a.maxPasswordLength), a.containsLowercaseCharacter !== void 0 && (this.customStrengthOptions.containsLowercaseLetter = a.containsLowercaseCharacter), a.containsUppercaseCharacter !== void 0 && (this.customStrengthOptions.containsUppercaseLetter = a.containsUppercaseCharacter), a.containsNumericCharacter !== void 0 && (this.customStrengthOptions.containsNumericCharacter = a.containsNumericCharacter), a.containsNonAlphanumericCharacter !== void 0 && (this.customStrengthOptions.containsNonAlphanumericCharacter = a.containsNonAlphanumericCharacter), this.enforcementState = t.enforcementState, this.enforcementState === "ENFORCEMENT_STATE_UNSPECIFIED" && (this.enforcementState = "OFF"), this.allowedNonAlphanumericCharacters = (i = (r = t.allowedNonAlphanumericCharacters) === null || r === void 0 ? void 0 : r.join("")) !== null && i !== void 0 ? i : "", this.forceUpgradeOnSignin = (o = t.forceUpgradeOnSignin) !== null && o !== void 0 ? o : !1, this.schemaVersion = t.schemaVersion;
  }
  validatePassword(t) {
    var n, r, i, o, a, s;
    const c = {
      isValid: !0,
      passwordPolicy: this
    };
    return this.validatePasswordLengthOptions(t, c), this.validatePasswordCharacterOptions(t, c), c.isValid && (c.isValid = (n = c.meetsMinPasswordLength) !== null && n !== void 0 ? n : !0), c.isValid && (c.isValid = (r = c.meetsMaxPasswordLength) !== null && r !== void 0 ? r : !0), c.isValid && (c.isValid = (i = c.containsLowercaseLetter) !== null && i !== void 0 ? i : !0), c.isValid && (c.isValid = (o = c.containsUppercaseLetter) !== null && o !== void 0 ? o : !0), c.isValid && (c.isValid = (a = c.containsNumericCharacter) !== null && a !== void 0 ? a : !0), c.isValid && (c.isValid = (s = c.containsNonAlphanumericCharacter) !== null && s !== void 0 ? s : !0), c;
  }
  /**
   * Validates that the password meets the length options for the policy.
   *
   * @param password Password to validate.
   * @param status Validation status.
   */
  validatePasswordLengthOptions(t, n) {
    const r = this.customStrengthOptions.minPasswordLength, i = this.customStrengthOptions.maxPasswordLength;
    r && (n.meetsMinPasswordLength = t.length >= r), i && (n.meetsMaxPasswordLength = t.length <= i);
  }
  /**
   * Validates that the password meets the character options for the policy.
   *
   * @param password Password to validate.
   * @param status Validation status.
   */
  validatePasswordCharacterOptions(t, n) {
    this.updatePasswordCharacterOptionsStatuses(
      n,
      /* containsLowercaseCharacter= */
      !1,
      /* containsUppercaseCharacter= */
      !1,
      /* containsNumericCharacter= */
      !1,
      /* containsNonAlphanumericCharacter= */
      !1
    );
    let r;
    for (let i = 0; i < t.length; i++)
      r = t.charAt(i), this.updatePasswordCharacterOptionsStatuses(
        n,
        /* containsLowercaseCharacter= */
        r >= "a" && r <= "z",
        /* containsUppercaseCharacter= */
        r >= "A" && r <= "Z",
        /* containsNumericCharacter= */
        r >= "0" && r <= "9",
        /* containsNonAlphanumericCharacter= */
        this.allowedNonAlphanumericCharacters.includes(r)
      );
  }
  /**
   * Updates the running validation status with the statuses for the character options.
   * Expected to be called each time a character is processed to update each option status
   * based on the current character.
   *
   * @param status Validation status.
   * @param containsLowercaseCharacter Whether the character is a lowercase letter.
   * @param containsUppercaseCharacter Whether the character is an uppercase letter.
   * @param containsNumericCharacter Whether the character is a numeric character.
   * @param containsNonAlphanumericCharacter Whether the character is a non-alphanumeric character.
   */
  updatePasswordCharacterOptionsStatuses(t, n, r, i, o) {
    this.customStrengthOptions.containsLowercaseLetter && (t.containsLowercaseLetter || (t.containsLowercaseLetter = n)), this.customStrengthOptions.containsUppercaseLetter && (t.containsUppercaseLetter || (t.containsUppercaseLetter = r)), this.customStrengthOptions.containsNumericCharacter && (t.containsNumericCharacter || (t.containsNumericCharacter = i)), this.customStrengthOptions.containsNonAlphanumericCharacter && (t.containsNonAlphanumericCharacter || (t.containsNonAlphanumericCharacter = o));
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class o1e {
  constructor(t, n, r, i) {
    this.app = t, this.heartbeatServiceProvider = n, this.appCheckServiceProvider = r, this.config = i, this.currentUser = null, this.emulatorConfig = null, this.operations = Promise.resolve(), this.authStateSubscription = new nD(this), this.idTokenSubscription = new nD(this), this.beforeStateQueue = new t1e(this), this.redirectUser = null, this.isProactiveRefreshEnabled = !1, this.EXPECTED_PASSWORD_POLICY_SCHEMA_VERSION = 1, this._canInitEmulator = !0, this._isInitialized = !1, this._deleted = !1, this._initializationPromise = null, this._popupRedirectResolver = null, this._errorFactory = OW, this._agentRecaptchaConfig = null, this._tenantRecaptchaConfigs = {}, this._projectPasswordPolicy = null, this._tenantPasswordPolicies = {}, this._resolvePersistenceManagerAvailable = void 0, this.lastNotifiedUid = void 0, this.languageCode = null, this.tenantId = null, this.settings = { appVerificationDisabledForTesting: !1 }, this.frameworks = [], this.name = t.name, this.clientVersion = i.sdkClientVersion, this._persistenceManagerAvailable = new Promise((o) => this._resolvePersistenceManagerAvailable = o);
  }
  _initializeWithPersistence(t, n) {
    return n && (this._popupRedirectResolver = Qc(n)), this._initializationPromise = this.queue(async () => {
      var r, i, o;
      if (!this._deleted && (this.persistenceManager = await og.create(this, t), (r = this._resolvePersistenceManagerAvailable) === null || r === void 0 || r.call(this), !this._deleted)) {
        if (!((i = this._popupRedirectResolver) === null || i === void 0) && i._shouldInitProactively)
          try {
            await this._popupRedirectResolver._initialize(this);
          } catch {
          }
        await this.initializeCurrentUser(n), this.lastNotifiedUid = ((o = this.currentUser) === null || o === void 0 ? void 0 : o.uid) || null, !this._deleted && (this._isInitialized = !0);
      }
    }), this._initializationPromise;
  }
  /**
   * If the persistence is changed in another window, the user manager will let us know
   */
  async _onStorageEvent() {
    if (this._deleted)
      return;
    const t = await this.assertedPersistence.getCurrentUser();
    if (!(!this.currentUser && !t)) {
      if (this.currentUser && t && this.currentUser.uid === t.uid) {
        this._currentUser._assign(t), await this.currentUser.getIdToken();
        return;
      }
      await this._updateCurrentUser(
        t,
        /* skipBeforeStateCallbacks */
        !0
      );
    }
  }
  async initializeCurrentUserFromIdToken(t) {
    try {
      const n = await q_(this, { idToken: t }), r = await gs._fromGetAccountInfoResponse(this, n, t);
      await this.directlySetCurrentUser(r);
    } catch (n) {
      console.warn("FirebaseServerApp could not login user with provided authIdToken: ", n), await this.directlySetCurrentUser(null);
    }
  }
  async initializeCurrentUser(t) {
    var n;
    if (Io(this.app)) {
      const a = this.app.settings.authIdToken;
      return a ? new Promise((s) => {
        setTimeout(() => this.initializeCurrentUserFromIdToken(a).then(s, s));
      }) : this.directlySetCurrentUser(null);
    }
    const r = await this.assertedPersistence.getCurrentUser();
    let i = r, o = !1;
    if (t && this.config.authDomain) {
      await this.getOrInitRedirectPersistenceManager();
      const a = (n = this.redirectUser) === null || n === void 0 ? void 0 : n._redirectEventId, s = i == null ? void 0 : i._redirectEventId, c = await this.tryRedirectSignIn(t);
      (!a || a === s) && (c != null && c.user) && (i = c.user, o = !0);
    }
    if (!i)
      return this.directlySetCurrentUser(null);
    if (!i._redirectEventId) {
      if (o)
        try {
          await this.beforeStateQueue.runMiddleware(i);
        } catch (a) {
          i = r, this._popupRedirectResolver._overrideRedirectResult(this, () => Promise.reject(a));
        }
      return i ? this.reloadAndSetCurrentUserOrClear(i) : this.directlySetCurrentUser(null);
    }
    return Vt(
      this._popupRedirectResolver,
      this,
      "argument-error"
      /* AuthErrorCode.ARGUMENT_ERROR */
    ), await this.getOrInitRedirectPersistenceManager(), this.redirectUser && this.redirectUser._redirectEventId === i._redirectEventId ? this.directlySetCurrentUser(i) : this.reloadAndSetCurrentUserOrClear(i);
  }
  async tryRedirectSignIn(t) {
    let n = null;
    try {
      n = await this._popupRedirectResolver._completeRedirectFn(this, t, !0);
    } catch {
      await this._setRedirectUser(null);
    }
    return n;
  }
  async reloadAndSetCurrentUserOrClear(t) {
    try {
      await G_(t);
    } catch (n) {
      if ((n == null ? void 0 : n.code) !== "auth/network-request-failed")
        return this.directlySetCurrentUser(null);
    }
    return this.directlySetCurrentUser(t);
  }
  useDeviceLanguage() {
    this.languageCode = jbe();
  }
  async _delete() {
    this._deleted = !0;
  }
  async updateCurrentUser(t) {
    if (Io(this.app))
      return Promise.reject(cc(this));
    const n = t ? Or(t) : null;
    return n && Vt(
      n.auth.config.apiKey === this.config.apiKey,
      this,
      "invalid-user-token"
      /* AuthErrorCode.INVALID_AUTH */
    ), this._updateCurrentUser(n && n._clone(this));
  }
  async _updateCurrentUser(t, n = !1) {
    if (!this._deleted)
      return t && Vt(
        this.tenantId === t.tenantId,
        this,
        "tenant-id-mismatch"
        /* AuthErrorCode.TENANT_ID_MISMATCH */
      ), n || await this.beforeStateQueue.runMiddleware(t), this.queue(async () => {
        await this.directlySetCurrentUser(t), this.notifyAuthListeners();
      });
  }
  async signOut() {
    return Io(this.app) ? Promise.reject(cc(this)) : (await this.beforeStateQueue.runMiddleware(null), (this.redirectPersistenceManager || this._popupRedirectResolver) && await this._setRedirectUser(null), this._updateCurrentUser(
      null,
      /* skipBeforeStateCallbacks */
      !0
    ));
  }
  setPersistence(t) {
    return Io(this.app) ? Promise.reject(cc(this)) : this.queue(async () => {
      await this.assertedPersistence.setPersistence(Qc(t));
    });
  }
  _getRecaptchaConfig() {
    return this.tenantId == null ? this._agentRecaptchaConfig : this._tenantRecaptchaConfigs[this.tenantId];
  }
  async validatePassword(t) {
    this._getPasswordPolicyInternal() || await this._updatePasswordPolicy();
    const n = this._getPasswordPolicyInternal();
    return n.schemaVersion !== this.EXPECTED_PASSWORD_POLICY_SCHEMA_VERSION ? Promise.reject(this._errorFactory.create("unsupported-password-policy-schema-version", {})) : n.validatePassword(t);
  }
  _getPasswordPolicyInternal() {
    return this.tenantId === null ? this._projectPasswordPolicy : this._tenantPasswordPolicies[this.tenantId];
  }
  async _updatePasswordPolicy() {
    const t = await n1e(this), n = new i1e(t);
    this.tenantId === null ? this._projectPasswordPolicy = n : this._tenantPasswordPolicies[this.tenantId] = n;
  }
  _getPersistenceType() {
    return this.assertedPersistence.persistence.type;
  }
  _getPersistence() {
    return this.assertedPersistence.persistence;
  }
  _updateErrorMap(t) {
    this._errorFactory = new Ff("auth", "Firebase", t());
  }
  onAuthStateChanged(t, n, r) {
    return this.registerStateListener(this.authStateSubscription, t, n, r);
  }
  beforeAuthStateChanged(t, n) {
    return this.beforeStateQueue.pushCallback(t, n);
  }
  onIdTokenChanged(t, n, r) {
    return this.registerStateListener(this.idTokenSubscription, t, n, r);
  }
  authStateReady() {
    return new Promise((t, n) => {
      if (this.currentUser)
        t();
      else {
        const r = this.onAuthStateChanged(() => {
          r(), t();
        }, n);
      }
    });
  }
  /**
   * Revokes the given access token. Currently only supports Apple OAuth access tokens.
   */
  async revokeAccessToken(t) {
    if (this.currentUser) {
      const n = await this.currentUser.getIdToken(), r = {
        providerId: "apple.com",
        tokenType: "ACCESS_TOKEN",
        token: t,
        idToken: n
      };
      this.tenantId != null && (r.tenantId = this.tenantId), await Jbe(this, r);
    }
  }
  toJSON() {
    var t;
    return {
      apiKey: this.config.apiKey,
      authDomain: this.config.authDomain,
      appName: this.name,
      currentUser: (t = this._currentUser) === null || t === void 0 ? void 0 : t.toJSON()
    };
  }
  async _setRedirectUser(t, n) {
    const r = await this.getOrInitRedirectPersistenceManager(n);
    return t === null ? r.removeCurrentUser() : r.setCurrentUser(t);
  }
  async getOrInitRedirectPersistenceManager(t) {
    if (!this.redirectPersistenceManager) {
      const n = t && Qc(t) || this._popupRedirectResolver;
      Vt(
        n,
        this,
        "argument-error"
        /* AuthErrorCode.ARGUMENT_ERROR */
      ), this.redirectPersistenceManager = await og.create(
        this,
        [Qc(n._redirectPersistence)],
        "redirectUser"
        /* KeyName.REDIRECT_USER */
      ), this.redirectUser = await this.redirectPersistenceManager.getCurrentUser();
    }
    return this.redirectPersistenceManager;
  }
  async _redirectUserForId(t) {
    var n, r;
    return this._isInitialized && await this.queue(async () => {
    }), ((n = this._currentUser) === null || n === void 0 ? void 0 : n._redirectEventId) === t ? this._currentUser : ((r = this.redirectUser) === null || r === void 0 ? void 0 : r._redirectEventId) === t ? this.redirectUser : null;
  }
  async _persistUserIfCurrent(t) {
    if (t === this.currentUser)
      return this.queue(async () => this.directlySetCurrentUser(t));
  }
  /** Notifies listeners only if the user is current */
  _notifyListenersIfCurrent(t) {
    t === this.currentUser && this.notifyAuthListeners();
  }
  _key() {
    return `${this.config.authDomain}:${this.config.apiKey}:${this.name}`;
  }
  _startProactiveRefresh() {
    this.isProactiveRefreshEnabled = !0, this.currentUser && this._currentUser._startProactiveRefresh();
  }
  _stopProactiveRefresh() {
    this.isProactiveRefreshEnabled = !1, this.currentUser && this._currentUser._stopProactiveRefresh();
  }
  /** Returns the current user cast as the internal type */
  get _currentUser() {
    return this.currentUser;
  }
  notifyAuthListeners() {
    var t, n;
    if (!this._isInitialized)
      return;
    this.idTokenSubscription.next(this.currentUser);
    const r = (n = (t = this.currentUser) === null || t === void 0 ? void 0 : t.uid) !== null && n !== void 0 ? n : null;
    this.lastNotifiedUid !== r && (this.lastNotifiedUid = r, this.authStateSubscription.next(this.currentUser));
  }
  registerStateListener(t, n, r, i) {
    if (this._deleted)
      return () => {
      };
    const o = typeof n == "function" ? n : n.next.bind(n);
    let a = !1;
    const s = this._isInitialized ? Promise.resolve() : this._initializationPromise;
    if (Vt(
      s,
      this,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    ), s.then(() => {
      a || o(this.currentUser);
    }), typeof n == "function") {
      const c = t.addObserver(n, r, i);
      return () => {
        a = !0, c();
      };
    } else {
      const c = t.addObserver(n);
      return () => {
        a = !0, c();
      };
    }
  }
  /**
   * Unprotected (from race conditions) method to set the current user. This
   * should only be called from within a queued callback. This is necessary
   * because the queue shouldn't rely on another queued callback.
   */
  async directlySetCurrentUser(t) {
    this.currentUser && this.currentUser !== t && this._currentUser._stopProactiveRefresh(), t && this.isProactiveRefreshEnabled && t._startProactiveRefresh(), this.currentUser = t, t ? await this.assertedPersistence.setCurrentUser(t) : await this.assertedPersistence.removeCurrentUser();
  }
  queue(t) {
    return this.operations = this.operations.then(t, t), this.operations;
  }
  get assertedPersistence() {
    return Vt(
      this.persistenceManager,
      this,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    ), this.persistenceManager;
  }
  _logFramework(t) {
    !t || this.frameworks.includes(t) || (this.frameworks.push(t), this.frameworks.sort(), this.clientVersion = GW(this.config.clientPlatform, this._getFrameworks()));
  }
  _getFrameworks() {
    return this.frameworks;
  }
  async _getAdditionalHeaders() {
    var t;
    const n = {
      "X-Client-Version": this.clientVersion
    };
    this.app.options.appId && (n[
      "X-Firebase-gmpid"
      /* HttpHeader.X_FIREBASE_GMPID */
    ] = this.app.options.appId);
    const r = await ((t = this.heartbeatServiceProvider.getImmediate({
      optional: !0
    })) === null || t === void 0 ? void 0 : t.getHeartbeatsHeader());
    r && (n[
      "X-Firebase-Client"
      /* HttpHeader.X_FIREBASE_CLIENT */
    ] = r);
    const i = await this._getAppCheckToken();
    return i && (n[
      "X-Firebase-AppCheck"
      /* HttpHeader.X_FIREBASE_APP_CHECK */
    ] = i), n;
  }
  async _getAppCheckToken() {
    var t;
    if (Io(this.app) && this.app.settings.appCheckToken)
      return this.app.settings.appCheckToken;
    const n = await ((t = this.appCheckServiceProvider.getImmediate({ optional: !0 })) === null || t === void 0 ? void 0 : t.getToken());
    return n != null && n.error && kbe(`Error while retrieving App Check token: ${n.error}`), n == null ? void 0 : n.token;
  }
}
function El(e) {
  return Or(e);
}
class nD {
  constructor(t) {
    this.auth = t, this.observer = null, this.addObserver = tve((n) => this.observer = n);
  }
  get next() {
    return Vt(
      this.observer,
      this.auth,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    ), this.observer.next.bind(this.observer);
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
let Dx = {
  async loadJS() {
    throw new Error("Unable to load external scripts");
  },
  recaptchaV2Script: "",
  recaptchaEnterpriseScript: "",
  gapiScript: ""
};
function a1e(e) {
  Dx = e;
}
function KW(e) {
  return Dx.loadJS(e);
}
function s1e() {
  return Dx.recaptchaEnterpriseScript;
}
function c1e() {
  return Dx.gapiScript;
}
function l1e(e) {
  return `__${e}${Math.floor(Math.random() * 1e6)}`;
}
class u1e {
  constructor() {
    this.enterprise = new d1e();
  }
  ready(t) {
    t();
  }
  execute(t, n) {
    return Promise.resolve("token");
  }
  render(t, n) {
    return "";
  }
}
class d1e {
  ready(t) {
    t();
  }
  execute(t, n) {
    return Promise.resolve("token");
  }
  render(t, n) {
    return "";
  }
}
const f1e = "recaptcha-enterprise", YW = "NO_RECAPTCHA";
class h1e {
  /**
   *
   * @param authExtern - The corresponding Firebase {@link Auth} instance.
   *
   */
  constructor(t) {
    this.type = f1e, this.auth = El(t);
  }
  /**
   * Executes the verification process.
   *
   * @returns A Promise for a token that can be used to assert the validity of a request.
   */
  async verify(t = "verify", n = !1) {
    async function r(o) {
      if (!n) {
        if (o.tenantId == null && o._agentRecaptchaConfig != null)
          return o._agentRecaptchaConfig.siteKey;
        if (o.tenantId != null && o._tenantRecaptchaConfigs[o.tenantId] !== void 0)
          return o._tenantRecaptchaConfigs[o.tenantId].siteKey;
      }
      return new Promise(async (a, s) => {
        Ube(o, {
          clientType: "CLIENT_TYPE_WEB",
          version: "RECAPTCHA_ENTERPRISE"
          /* RecaptchaVersion.ENTERPRISE */
        }).then((c) => {
          if (c.recaptchaKey === void 0)
            s(new Error("recaptcha Enterprise site key undefined"));
          else {
            const l = new Hbe(c);
            return o.tenantId == null ? o._agentRecaptchaConfig = l : o._tenantRecaptchaConfigs[o.tenantId] = l, a(l.siteKey);
          }
        }).catch((c) => {
          s(c);
        });
      });
    }
    function i(o, a, s) {
      const c = window.grecaptcha;
      Q7(c) ? c.enterprise.ready(() => {
        c.enterprise.execute(o, { action: t }).then((l) => {
          a(l);
        }).catch(() => {
          a(YW);
        });
      }) : s(Error("No reCAPTCHA enterprise script loaded."));
    }
    return this.auth.settings.appVerificationDisabledForTesting ? new u1e().execute("siteKey", { action: "verify" }) : new Promise((o, a) => {
      r(this.auth).then((s) => {
        if (!n && Q7(window.grecaptcha))
          i(s, o, a);
        else {
          if (typeof window > "u") {
            a(new Error("RecaptchaVerifier is only supported in browser"));
            return;
          }
          let c = s1e();
          c.length !== 0 && (c += s), KW(c).then(() => {
            i(s, o, a);
          }).catch((l) => {
            a(l);
          });
        }
      }).catch((s) => {
        a(s);
      });
    });
  }
}
async function Cm(e, t, n, r = !1, i = !1) {
  const o = new h1e(e);
  let a;
  if (i)
    a = YW;
  else
    try {
      a = await o.verify(n);
    } catch {
      a = await o.verify(n, !0);
    }
  const s = Object.assign({}, t);
  if (n === "mfaSmsEnrollment" || n === "mfaSmsSignIn") {
    if ("phoneEnrollmentInfo" in s) {
      const c = s.phoneEnrollmentInfo.phoneNumber, l = s.phoneEnrollmentInfo.recaptchaToken;
      Object.assign(s, {
        phoneEnrollmentInfo: {
          phoneNumber: c,
          recaptchaToken: l,
          captchaResponse: a,
          clientType: "CLIENT_TYPE_WEB",
          recaptchaVersion: "RECAPTCHA_ENTERPRISE"
          /* RecaptchaVersion.ENTERPRISE */
        }
      });
    } else if ("phoneSignInInfo" in s) {
      const c = s.phoneSignInInfo.recaptchaToken;
      Object.assign(s, {
        phoneSignInInfo: {
          recaptchaToken: c,
          captchaResponse: a,
          clientType: "CLIENT_TYPE_WEB",
          recaptchaVersion: "RECAPTCHA_ENTERPRISE"
          /* RecaptchaVersion.ENTERPRISE */
        }
      });
    }
    return s;
  }
  return r ? Object.assign(s, { captchaResp: a }) : Object.assign(s, { captchaResponse: a }), Object.assign(s, {
    clientType: "CLIENT_TYPE_WEB"
    /* RecaptchaClientType.WEB */
  }), Object.assign(s, {
    recaptchaVersion: "RECAPTCHA_ENTERPRISE"
    /* RecaptchaVersion.ENTERPRISE */
  }), s;
}
async function rD(e, t, n, r, i) {
  var o, a;
  if (i === "EMAIL_PASSWORD_PROVIDER")
    if (!((o = e._getRecaptchaConfig()) === null || o === void 0) && o.isProviderEnabled(
      "EMAIL_PASSWORD_PROVIDER"
      /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */
    )) {
      const s = await Cm(
        e,
        t,
        n,
        n === "getOobCode"
        /* RecaptchaActionName.GET_OOB_CODE */
      );
      return r(e, s);
    } else
      return r(e, t).catch(async (s) => {
        if (s.code === "auth/missing-recaptcha-token") {
          console.log(`${n} is protected by reCAPTCHA Enterprise for this project. Automatically triggering the reCAPTCHA flow and restarting the flow.`);
          const c = await Cm(
            e,
            t,
            n,
            n === "getOobCode"
            /* RecaptchaActionName.GET_OOB_CODE */
          );
          return r(e, c);
        } else
          return Promise.reject(s);
      });
  else if (i === "PHONE_PROVIDER")
    if (!((a = e._getRecaptchaConfig()) === null || a === void 0) && a.isProviderEnabled(
      "PHONE_PROVIDER"
      /* RecaptchaAuthProvider.PHONE_PROVIDER */
    )) {
      const s = await Cm(e, t, n);
      return r(e, s).catch(async (c) => {
        var l;
        if (((l = e._getRecaptchaConfig()) === null || l === void 0 ? void 0 : l.getProviderEnforcementState(
          "PHONE_PROVIDER"
          /* RecaptchaAuthProvider.PHONE_PROVIDER */
        )) === "AUDIT" && (c.code === "auth/missing-recaptcha-token" || c.code === "auth/invalid-app-credential")) {
          console.log(`Failed to verify with reCAPTCHA Enterprise. Automatically triggering the reCAPTCHA v2 flow to complete the ${n} flow.`);
          const u = await Cm(
            e,
            t,
            n,
            !1,
            // isCaptchaResp
            !0
            // isFakeToken
          );
          return r(e, u);
        }
        return Promise.reject(c);
      });
    } else {
      const s = await Cm(
        e,
        t,
        n,
        !1,
        // isCaptchaResp
        !0
        // isFakeToken
      );
      return r(e, s);
    }
  else
    return Promise.reject(i + " provider is not supported.");
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function g1e(e, t) {
  const n = xl(e, "auth");
  if (n.isInitialized()) {
    const i = n.getImmediate(), o = n.getOptions();
    if (ll(o, t ?? {}))
      return i;
    Wa(
      i,
      "already-initialized"
      /* AuthErrorCode.ALREADY_INITIALIZED */
    );
  }
  return n.initialize({ options: t });
}
function p1e(e, t) {
  const n = (t == null ? void 0 : t.persistence) || [], r = (Array.isArray(n) ? n : [n]).map(Qc);
  t != null && t.errorMap && e._updateErrorMap(t.errorMap), e._initializeWithPersistence(r, t == null ? void 0 : t.popupRedirectResolver);
}
function XW(e, t, n) {
  const r = El(e);
  Vt(
    /^https?:\/\//.test(t),
    r,
    "invalid-emulator-scheme"
    /* AuthErrorCode.INVALID_EMULATOR_SCHEME */
  );
  const i = !!(n != null && n.disableWarnings), o = QW(t), { host: a, port: s } = m1e(t), c = s === null ? "" : `:${s}`, l = { url: `${o}//${a}${c}/` }, u = Object.freeze({
    host: a,
    port: s,
    protocol: o.replace(":", ""),
    options: Object.freeze({ disableWarnings: i })
  });
  if (!r._canInitEmulator) {
    Vt(
      r.config.emulator && r.emulatorConfig,
      r,
      "emulator-config-failed"
      /* AuthErrorCode.EMULATOR_CONFIG_FAILED */
    ), Vt(
      ll(l, r.config.emulator) && ll(u, r.emulatorConfig),
      r,
      "emulator-config-failed"
      /* AuthErrorCode.EMULATOR_CONFIG_FAILED */
    );
    return;
  }
  r.config.emulator = l, r.emulatorConfig = u, r.settings.appVerificationDisabledForTesting = !0, Gu(a) ? (Px(`${o}//${a}${c}`), wO("Auth", !0)) : i || v1e();
}
function QW(e) {
  const t = e.indexOf(":");
  return t < 0 ? "" : e.substr(0, t + 1);
}
function m1e(e) {
  const t = QW(e), n = /(\/\/)?([^?#/]+)/.exec(e.substr(t.length));
  if (!n)
    return { host: "", port: null };
  const r = n[2].split("@").pop() || "", i = /^(\[[^\]]+\])(:|$)/.exec(r);
  if (i) {
    const o = i[1];
    return { host: o, port: iD(r.substr(o.length + 1)) };
  } else {
    const [o, a] = r.split(":");
    return { host: o, port: iD(a) };
  }
}
function iD(e) {
  if (!e)
    return null;
  const t = Number(e);
  return isNaN(t) ? null : t;
}
function v1e() {
  function e() {
    const t = document.createElement("p"), n = t.style;
    t.innerText = "Running in emulator mode. Do not use with production credentials.", n.position = "fixed", n.width = "100%", n.backgroundColor = "#ffffff", n.border = ".1em solid #000000", n.color = "#b50000", n.bottom = "0px", n.left = "0px", n.margin = "0px", n.zIndex = "10000", n.textAlign = "center", t.classList.add("firebase-emulator-warning"), document.body.appendChild(t);
  }
  typeof console < "u" && typeof console.info == "function" && console.info("WARNING: You are using the Auth Emulator, which is intended for local testing only.  Do not use with production credentials."), typeof window < "u" && typeof document < "u" && (document.readyState === "loading" ? window.addEventListener("DOMContentLoaded", e) : e());
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class kO {
  /** @internal */
  constructor(t, n) {
    this.providerId = t, this.signInMethod = n;
  }
  /**
   * Returns a JSON-serializable representation of this object.
   *
   * @returns a JSON-serializable representation of this object.
   */
  toJSON() {
    return Xc("not implemented");
  }
  /** @internal */
  _getIdTokenResponse(t) {
    return Xc("not implemented");
  }
  /** @internal */
  _linkToIdToken(t, n) {
    return Xc("not implemented");
  }
  /** @internal */
  _getReauthenticationResolver(t) {
    return Xc("not implemented");
  }
}
async function y1e(e, t) {
  return Yu(e, "POST", "/v1/accounts:signUp", t);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function b1e(e, t) {
  return cy(e, "POST", "/v1/accounts:signInWithPassword", Ku(e, t));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function _1e(e, t) {
  return cy(e, "POST", "/v1/accounts:signInWithEmailLink", Ku(e, t));
}
async function S1e(e, t) {
  return cy(e, "POST", "/v1/accounts:signInWithEmailLink", Ku(e, t));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class av extends kO {
  /** @internal */
  constructor(t, n, r, i = null) {
    super("password", r), this._email = t, this._password = n, this._tenantId = i;
  }
  /** @internal */
  static _fromEmailAndPassword(t, n) {
    return new av(
      t,
      n,
      "password"
      /* SignInMethod.EMAIL_PASSWORD */
    );
  }
  /** @internal */
  static _fromEmailAndCode(t, n, r = null) {
    return new av(t, n, "emailLink", r);
  }
  /** {@inheritdoc AuthCredential.toJSON} */
  toJSON() {
    return {
      email: this._email,
      password: this._password,
      signInMethod: this.signInMethod,
      tenantId: this._tenantId
    };
  }
  /**
   * Static method to deserialize a JSON representation of an object into an {@link  AuthCredential}.
   *
   * @param json - Either `object` or the stringified representation of the object. When string is
   * provided, `JSON.parse` would be called first.
   *
   * @returns If the JSON input does not represent an {@link AuthCredential}, null is returned.
   */
  static fromJSON(t) {
    const n = typeof t == "string" ? JSON.parse(t) : t;
    if (n != null && n.email && (n != null && n.password)) {
      if (n.signInMethod === "password")
        return this._fromEmailAndPassword(n.email, n.password);
      if (n.signInMethod === "emailLink")
        return this._fromEmailAndCode(n.email, n.password, n.tenantId);
    }
    return null;
  }
  /** @internal */
  async _getIdTokenResponse(t) {
    switch (this.signInMethod) {
      case "password":
        const n = {
          returnSecureToken: !0,
          email: this._email,
          password: this._password,
          clientType: "CLIENT_TYPE_WEB"
          /* RecaptchaClientType.WEB */
        };
        return rD(
          t,
          n,
          "signInWithPassword",
          b1e,
          "EMAIL_PASSWORD_PROVIDER"
          /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */
        );
      case "emailLink":
        return _1e(t, {
          email: this._email,
          oobCode: this._password
        });
      default:
        Wa(
          t,
          "internal-error"
          /* AuthErrorCode.INTERNAL_ERROR */
        );
    }
  }
  /** @internal */
  async _linkToIdToken(t, n) {
    switch (this.signInMethod) {
      case "password":
        const r = {
          idToken: n,
          returnSecureToken: !0,
          email: this._email,
          password: this._password,
          clientType: "CLIENT_TYPE_WEB"
          /* RecaptchaClientType.WEB */
        };
        return rD(
          t,
          r,
          "signUpPassword",
          y1e,
          "EMAIL_PASSWORD_PROVIDER"
          /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */
        );
      case "emailLink":
        return S1e(t, {
          idToken: n,
          email: this._email,
          oobCode: this._password
        });
      default:
        Wa(
          t,
          "internal-error"
          /* AuthErrorCode.INTERNAL_ERROR */
        );
    }
  }
  /** @internal */
  _getReauthenticationResolver(t) {
    return this._getIdTokenResponse(t);
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function ag(e, t) {
  return cy(e, "POST", "/v1/accounts:signInWithIdp", Ku(e, t));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const w1e = "http://localhost";
class fl extends kO {
  constructor() {
    super(...arguments), this.pendingToken = null;
  }
  /** @internal */
  static _fromParams(t) {
    const n = new fl(t.providerId, t.signInMethod);
    return t.idToken || t.accessToken ? (t.idToken && (n.idToken = t.idToken), t.accessToken && (n.accessToken = t.accessToken), t.nonce && !t.pendingToken && (n.nonce = t.nonce), t.pendingToken && (n.pendingToken = t.pendingToken)) : t.oauthToken && t.oauthTokenSecret ? (n.accessToken = t.oauthToken, n.secret = t.oauthTokenSecret) : Wa(
      "argument-error"
      /* AuthErrorCode.ARGUMENT_ERROR */
    ), n;
  }
  /** {@inheritdoc AuthCredential.toJSON}  */
  toJSON() {
    return {
      idToken: this.idToken,
      accessToken: this.accessToken,
      secret: this.secret,
      nonce: this.nonce,
      pendingToken: this.pendingToken,
      providerId: this.providerId,
      signInMethod: this.signInMethod
    };
  }
  /**
   * Static method to deserialize a JSON representation of an object into an
   * {@link  AuthCredential}.
   *
   * @param json - Input can be either Object or the stringified representation of the object.
   * When string is provided, JSON.parse would be called first.
   *
   * @returns If the JSON input does not represent an {@link  AuthCredential}, null is returned.
   */
  static fromJSON(t) {
    const n = typeof t == "string" ? JSON.parse(t) : t, { providerId: r, signInMethod: i } = n, o = QP(n, ["providerId", "signInMethod"]);
    if (!r || !i)
      return null;
    const a = new fl(r, i);
    return a.idToken = o.idToken || void 0, a.accessToken = o.accessToken || void 0, a.secret = o.secret, a.nonce = o.nonce, a.pendingToken = o.pendingToken || null, a;
  }
  /** @internal */
  _getIdTokenResponse(t) {
    const n = this.buildRequest();
    return ag(t, n);
  }
  /** @internal */
  _linkToIdToken(t, n) {
    const r = this.buildRequest();
    return r.idToken = n, ag(t, r);
  }
  /** @internal */
  _getReauthenticationResolver(t) {
    const n = this.buildRequest();
    return n.autoCreate = !1, ag(t, n);
  }
  buildRequest() {
    const t = {
      requestUri: w1e,
      returnSecureToken: !0
    };
    if (this.pendingToken)
      t.pendingToken = this.pendingToken;
    else {
      const n = {};
      this.idToken && (n.id_token = this.idToken), this.accessToken && (n.access_token = this.accessToken), this.secret && (n.oauth_token_secret = this.secret), n.providerId = this.providerId, this.nonce && !this.pendingToken && (n.nonce = this.nonce), t.postBody = ay(n);
    }
    return t;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function x1e(e) {
  switch (e) {
    case "recoverEmail":
      return "RECOVER_EMAIL";
    case "resetPassword":
      return "PASSWORD_RESET";
    case "signIn":
      return "EMAIL_SIGNIN";
    case "verifyEmail":
      return "VERIFY_EMAIL";
    case "verifyAndChangeEmail":
      return "VERIFY_AND_CHANGE_EMAIL";
    case "revertSecondFactorAddition":
      return "REVERT_SECOND_FACTOR_ADDITION";
    default:
      return null;
  }
}
function E1e(e) {
  const t = r0(i0(e)).link, n = t ? r0(i0(t)).deep_link_id : null, r = r0(i0(e)).deep_link_id;
  return (r ? r0(i0(r)).link : null) || r || n || t || e;
}
class NO {
  /**
   * @param actionLink - The link from which to extract the URL.
   * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
   *
   * @internal
   */
  constructor(t) {
    var n, r, i, o, a, s;
    const c = r0(i0(t)), l = (n = c.apiKey) !== null && n !== void 0 ? n : null, u = (r = c.oobCode) !== null && r !== void 0 ? r : null, d = x1e((i = c.mode) !== null && i !== void 0 ? i : null);
    Vt(
      l && u && d,
      "argument-error"
      /* AuthErrorCode.ARGUMENT_ERROR */
    ), this.apiKey = l, this.operation = d, this.code = u, this.continueUrl = (o = c.continueUrl) !== null && o !== void 0 ? o : null, this.languageCode = (a = c.lang) !== null && a !== void 0 ? a : null, this.tenantId = (s = c.tenantId) !== null && s !== void 0 ? s : null;
  }
  /**
   * Parses the email action link string and returns an {@link ActionCodeURL} if the link is valid,
   * otherwise returns null.
   *
   * @param link  - The email action link string.
   * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
   *
   * @public
   */
  static parseLink(t) {
    const n = E1e(t);
    try {
      return new NO(n);
    } catch {
      return null;
    }
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Mp {
  constructor() {
    this.providerId = Mp.PROVIDER_ID;
  }
  /**
   * Initialize an {@link AuthCredential} using an email and password.
   *
   * @example
   * ```javascript
   * const authCredential = EmailAuthProvider.credential(email, password);
   * const userCredential = await signInWithCredential(auth, authCredential);
   * ```
   *
   * @example
   * ```javascript
   * const userCredential = await signInWithEmailAndPassword(auth, email, password);
   * ```
   *
   * @param email - Email address.
   * @param password - User account password.
   * @returns The auth provider credential.
   */
  static credential(t, n) {
    return av._fromEmailAndPassword(t, n);
  }
  /**
   * Initialize an {@link AuthCredential} using an email and an email link after a sign in with
   * email link operation.
   *
   * @example
   * ```javascript
   * const authCredential = EmailAuthProvider.credentialWithLink(auth, email, emailLink);
   * const userCredential = await signInWithCredential(auth, authCredential);
   * ```
   *
   * @example
   * ```javascript
   * await sendSignInLinkToEmail(auth, email);
   * // Obtain emailLink from user.
   * const userCredential = await signInWithEmailLink(auth, email, emailLink);
   * ```
   *
   * @param auth - The {@link Auth} instance used to verify the link.
   * @param email - Email address.
   * @param emailLink - Sign-in email link.
   * @returns - The auth provider credential.
   */
  static credentialWithLink(t, n) {
    const r = NO.parseLink(n);
    return Vt(
      r,
      "argument-error"
      /* AuthErrorCode.ARGUMENT_ERROR */
    ), av._fromEmailAndCode(t, r.code, r.tenantId);
  }
}
Mp.PROVIDER_ID = "password";
Mp.EMAIL_PASSWORD_SIGN_IN_METHOD = "password";
Mp.EMAIL_LINK_SIGN_IN_METHOD = "emailLink";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class jx {
  /**
   * Constructor for generic OAuth providers.
   *
   * @param providerId - Provider for which credentials should be generated.
   */
  constructor(t) {
    this.providerId = t, this.defaultLanguageCode = null, this.customParameters = {};
  }
  /**
   * Set the language gode.
   *
   * @param languageCode - language code
   */
  setDefaultLanguage(t) {
    this.defaultLanguageCode = t;
  }
  /**
   * Sets the OAuth custom parameters to pass in an OAuth request for popup and redirect sign-in
   * operations.
   *
   * @remarks
   * For a detailed list, check the reserved required OAuth 2.0 parameters such as `client_id`,
   * `redirect_uri`, `scope`, `response_type`, and `state` are not allowed and will be ignored.
   *
   * @param customOAuthParameters - The custom OAuth parameters to pass in the OAuth request.
   */
  setCustomParameters(t) {
    return this.customParameters = t, this;
  }
  /**
   * Retrieve the current list of {@link CustomParameters}.
   */
  getCustomParameters() {
    return this.customParameters;
  }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class kp extends jx {
  constructor() {
    super(...arguments), this.scopes = [];
  }
  /**
   * Add an OAuth scope to the credential.
   *
   * @param scope - Provider OAuth scope to add.
   */
  addScope(t) {
    return this.scopes.includes(t) || this.scopes.push(t), this;
  }
  /**
   * Retrieve the current list of OAuth scopes.
   */
  getScopes() {
    return [...this.scopes];
  }
}
class A0 extends kp {
  /**
   * Creates an {@link OAuthCredential} from a JSON string or a plain object.
   * @param json - A plain object or a JSON string
   */
  static credentialFromJSON(t) {
    const n = typeof t == "string" ? JSON.parse(t) : t;
    return Vt(
      "providerId" in n && "signInMethod" in n,
      "argument-error"
      /* AuthErrorCode.ARGUMENT_ERROR */
    ), fl._fromParams(n);
  }
  /**
   * Creates a {@link OAuthCredential} from a generic OAuth provider's access token or ID token.
   *
   * @remarks
   * The raw nonce is required when an ID token with a nonce field is provided. The SHA-256 hash of
   * the raw nonce must match the nonce field in the ID token.
   *
   * @example
   * ```javascript
   * // `googleUser` from the onsuccess Google Sign In callback.
   * // Initialize a generate OAuth provider with a `google.com` providerId.
   * const provider = new OAuthProvider('google.com');
   * const credential = provider.credential({
   *   idToken: googleUser.getAuthResponse().id_token,
   * });
   * const result = await signInWithCredential(credential);
   * ```
   *
   * @param params - Either the options object containing the ID token, access token and raw nonce
   * or the ID token string.
   */
  credential(t) {
    return this._credential(Object.assign(Object.assign({}, t), { nonce: t.rawNonce }));
  }
  /** An internal credential method that accepts more permissive options */
  _credential(t) {
    return Vt(
      t.idToken || t.accessToken,
      "argument-error"
      /* AuthErrorCode.ARGUMENT_ERROR */
    ), fl._fromParams(Object.assign(Object.assign({}, t), { providerId: this.providerId, signInMethod: this.providerId }));
  }
  /**
   * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
   *
   * @param userCredential - The user credential.
   */
  static credentialFromResult(t) {
    return A0.oauthCredentialFromTaggedObject(t);
  }
  /**
   * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
   * thrown during a sign-in, link, or reauthenticate operation.
   *
   * @param userCredential - The user credential.
   */
  static credentialFromError(t) {
    return A0.oauthCredentialFromTaggedObject(t.customData || {});
  }
  static oauthCredentialFromTaggedObject({ _tokenResponse: t }) {
    if (!t)
      return null;
    const { oauthIdToken: n, oauthAccessToken: r, oauthTokenSecret: i, pendingToken: o, nonce: a, providerId: s } = t;
    if (!r && !i && !n && !o || !s)
      return null;
    try {
      return new A0(s)._credential({
        idToken: n,
        accessToken: r,
        nonce: a,
        pendingToken: o
      });
    } catch {
      return null;
    }
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Gl extends kp {
  constructor() {
    super(
      "facebook.com"
      /* ProviderId.FACEBOOK */
    );
  }
  /**
   * Creates a credential for Facebook.
   *
   * @example
   * ```javascript
   * // `event` from the Facebook auth.authResponseChange callback.
   * const credential = FacebookAuthProvider.credential(event.authResponse.accessToken);
   * const result = await signInWithCredential(credential);
   * ```
   *
   * @param accessToken - Facebook access token.
   */
  static credential(t) {
    return fl._fromParams({
      providerId: Gl.PROVIDER_ID,
      signInMethod: Gl.FACEBOOK_SIGN_IN_METHOD,
      accessToken: t
    });
  }
  /**
   * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
   *
   * @param userCredential - The user credential.
   */
  static credentialFromResult(t) {
    return Gl.credentialFromTaggedObject(t);
  }
  /**
   * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
   * thrown during a sign-in, link, or reauthenticate operation.
   *
   * @param userCredential - The user credential.
   */
  static credentialFromError(t) {
    return Gl.credentialFromTaggedObject(t.customData || {});
  }
  static credentialFromTaggedObject({ _tokenResponse: t }) {
    if (!t || !("oauthAccessToken" in t) || !t.oauthAccessToken)
      return null;
    try {
      return Gl.credential(t.oauthAccessToken);
    } catch {
      return null;
    }
  }
}
Gl.FACEBOOK_SIGN_IN_METHOD = "facebook.com";
Gl.PROVIDER_ID = "facebook.com";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Kl extends kp {
  constructor() {
    super(
      "google.com"
      /* ProviderId.GOOGLE */
    ), this.addScope("profile");
  }
  /**
   * Creates a credential for Google. At least one of ID token and access token is required.
   *
   * @example
   * ```javascript
   * // \`googleUser\` from the onsuccess Google Sign In callback.
   * const credential = GoogleAuthProvider.credential(googleUser.getAuthResponse().id_token);
   * const result = await signInWithCredential(credential);
   * ```
   *
   * @param idToken - Google ID token.
   * @param accessToken - Google access token.
   */
  static credential(t, n) {
    return fl._fromParams({
      providerId: Kl.PROVIDER_ID,
      signInMethod: Kl.GOOGLE_SIGN_IN_METHOD,
      idToken: t,
      accessToken: n
    });
  }
  /**
   * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
   *
   * @param userCredential - The user credential.
   */
  static credentialFromResult(t) {
    return Kl.credentialFromTaggedObject(t);
  }
  /**
   * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
   * thrown during a sign-in, link, or reauthenticate operation.
   *
   * @param userCredential - The user credential.
   */
  static credentialFromError(t) {
    return Kl.credentialFromTaggedObject(t.customData || {});
  }
  static credentialFromTaggedObject({ _tokenResponse: t }) {
    if (!t)
      return null;
    const { oauthIdToken: n, oauthAccessToken: r } = t;
    if (!n && !r)
      return null;
    try {
      return Kl.credential(n, r);
    } catch {
      return null;
    }
  }
}
Kl.GOOGLE_SIGN_IN_METHOD = "google.com";
Kl.PROVIDER_ID = "google.com";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Yl extends kp {
  constructor() {
    super(
      "github.com"
      /* ProviderId.GITHUB */
    );
  }
  /**
   * Creates a credential for GitHub.
   *
   * @param accessToken - GitHub access token.
   */
  static credential(t) {
    return fl._fromParams({
      providerId: Yl.PROVIDER_ID,
      signInMethod: Yl.GITHUB_SIGN_IN_METHOD,
      accessToken: t
    });
  }
  /**
   * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
   *
   * @param userCredential - The user credential.
   */
  static credentialFromResult(t) {
    return Yl.credentialFromTaggedObject(t);
  }
  /**
   * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
   * thrown during a sign-in, link, or reauthenticate operation.
   *
   * @param userCredential - The user credential.
   */
  static credentialFromError(t) {
    return Yl.credentialFromTaggedObject(t.customData || {});
  }
  static credentialFromTaggedObject({ _tokenResponse: t }) {
    if (!t || !("oauthAccessToken" in t) || !t.oauthAccessToken)
      return null;
    try {
      return Yl.credential(t.oauthAccessToken);
    } catch {
      return null;
    }
  }
}
Yl.GITHUB_SIGN_IN_METHOD = "github.com";
Yl.PROVIDER_ID = "github.com";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Xl extends kp {
  constructor() {
    super(
      "twitter.com"
      /* ProviderId.TWITTER */
    );
  }
  /**
   * Creates a credential for Twitter.
   *
   * @param token - Twitter access token.
   * @param secret - Twitter secret.
   */
  static credential(t, n) {
    return fl._fromParams({
      providerId: Xl.PROVIDER_ID,
      signInMethod: Xl.TWITTER_SIGN_IN_METHOD,
      oauthToken: t,
      oauthTokenSecret: n
    });
  }
  /**
   * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
   *
   * @param userCredential - The user credential.
   */
  static credentialFromResult(t) {
    return Xl.credentialFromTaggedObject(t);
  }
  /**
   * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
   * thrown during a sign-in, link, or reauthenticate operation.
   *
   * @param userCredential - The user credential.
   */
  static credentialFromError(t) {
    return Xl.credentialFromTaggedObject(t.customData || {});
  }
  static credentialFromTaggedObject({ _tokenResponse: t }) {
    if (!t)
      return null;
    const { oauthAccessToken: n, oauthTokenSecret: r } = t;
    if (!n || !r)
      return null;
    try {
      return Xl.credential(n, r);
    } catch {
      return null;
    }
  }
}
Xl.TWITTER_SIGN_IN_METHOD = "twitter.com";
Xl.PROVIDER_ID = "twitter.com";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function C1e(e, t) {
  return cy(e, "POST", "/v1/accounts:signUp", Ku(e, t));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Tu {
  constructor(t) {
    this.user = t.user, this.providerId = t.providerId, this._tokenResponse = t._tokenResponse, this.operationType = t.operationType;
  }
  static async _fromIdTokenResponse(t, n, r, i = !1) {
    const o = await gs._fromIdTokenResponse(t, r, i), a = oD(r);
    return new Tu({
      user: o,
      providerId: a,
      _tokenResponse: r,
      operationType: n
    });
  }
  static async _forOperation(t, n, r) {
    await t._updateTokensIfNecessary(
      r,
      /* reload */
      !0
    );
    const i = oD(r);
    return new Tu({
      user: t,
      providerId: i,
      _tokenResponse: r,
      operationType: n
    });
  }
}
function oD(e) {
  return e.providerId ? e.providerId : "phoneNumber" in e ? "phone" : null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function T1e(e) {
  var t;
  if (Io(e.app))
    return Promise.reject(cc(e));
  const n = El(e);
  if (await n._initializationPromise, !((t = n.currentUser) === null || t === void 0) && t.isAnonymous)
    return new Tu({
      user: n.currentUser,
      providerId: null,
      operationType: "signIn"
      /* OperationType.SIGN_IN */
    });
  const r = await C1e(n, {
    returnSecureToken: !0
  }), i = await Tu._fromIdTokenResponse(n, "signIn", r, !0);
  return await n._updateCurrentUser(i.user), i;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class K_ extends Qa {
  constructor(t, n, r, i) {
    var o;
    super(n.code, n.message), this.operationType = r, this.user = i, Object.setPrototypeOf(this, K_.prototype), this.customData = {
      appName: t.name,
      tenantId: (o = t.tenantId) !== null && o !== void 0 ? o : void 0,
      _serverResponse: n.customData._serverResponse,
      operationType: r
    };
  }
  static _fromErrorAndOperation(t, n, r, i) {
    return new K_(t, n, r, i);
  }
}
function JW(e, t, n, r) {
  return (t === "reauthenticate" ? n._getReauthenticationResolver(e) : n._getIdTokenResponse(e)).catch((o) => {
    throw o.code === "auth/multi-factor-auth-required" ? K_._fromErrorAndOperation(e, o, t, r) : o;
  });
}
async function I1e(e, t, n = !1) {
  const r = await ov(e, t._linkToIdToken(e.auth, await e.getIdToken()), n);
  return Tu._forOperation(e, "link", r);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function $1e(e, t, n = !1) {
  const { auth: r } = e;
  if (Io(r.app))
    return Promise.reject(cc(r));
  const i = "reauthenticate";
  try {
    const o = await ov(e, JW(r, i, t, e), n);
    Vt(
      o.idToken,
      r,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    );
    const a = OO(o.idToken);
    Vt(
      a,
      r,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    );
    const { sub: s } = a;
    return Vt(
      e.uid === s,
      r,
      "user-mismatch"
      /* AuthErrorCode.USER_MISMATCH */
    ), Tu._forOperation(e, i, o);
  } catch (o) {
    throw (o == null ? void 0 : o.code) === "auth/user-not-found" && Wa(
      r,
      "user-mismatch"
      /* AuthErrorCode.USER_MISMATCH */
    ), o;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function ZW(e, t, n = !1) {
  if (Io(e.app))
    return Promise.reject(cc(e));
  const r = "signIn", i = await JW(e, r, t), o = await Tu._fromIdTokenResponse(e, r, i);
  return n || await e._updateCurrentUser(o.user), o;
}
async function A1e(e, t) {
  return ZW(El(e), t);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function R1e(e) {
  const t = El(e);
  t._getPasswordPolicyInternal() && await t._updatePasswordPolicy();
}
function P1e(e, t, n) {
  return Io(e.app) ? Promise.reject(cc(e)) : A1e(Or(e), Mp.credential(t, n)).catch(async (r) => {
    throw r.code === "auth/password-does-not-meet-requirements" && R1e(e), r;
  });
}
function O1e(e, t, n, r) {
  return Or(e).onIdTokenChanged(t, n, r);
}
function M1e(e, t, n) {
  return Or(e).beforeAuthStateChanged(t, n);
}
function k1e(e) {
  return Or(e).signOut();
}
const Y_ = "__sak";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class eq {
  constructor(t, n) {
    this.storageRetriever = t, this.type = n;
  }
  _isAvailable() {
    try {
      return this.storage ? (this.storage.setItem(Y_, "1"), this.storage.removeItem(Y_), Promise.resolve(!0)) : Promise.resolve(!1);
    } catch {
      return Promise.resolve(!1);
    }
  }
  _set(t, n) {
    return this.storage.setItem(t, JSON.stringify(n)), Promise.resolve();
  }
  _get(t) {
    const n = this.storage.getItem(t);
    return Promise.resolve(n ? JSON.parse(n) : null);
  }
  _remove(t) {
    return this.storage.removeItem(t), Promise.resolve();
  }
  get storage() {
    return this.storageRetriever();
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const N1e = 1e3, D1e = 10;
class tq extends eq {
  constructor() {
    super(
      () => window.localStorage,
      "LOCAL"
      /* PersistenceType.LOCAL */
    ), this.boundEventHandler = (t, n) => this.onStorageEvent(t, n), this.listeners = {}, this.localCache = {}, this.pollTimer = null, this.fallbackToPolling = qW(), this._shouldAllowMigration = !0;
  }
  forAllChangedKeys(t) {
    for (const n of Object.keys(this.listeners)) {
      const r = this.storage.getItem(n), i = this.localCache[n];
      r !== i && t(n, i, r);
    }
  }
  onStorageEvent(t, n = !1) {
    if (!t.key) {
      this.forAllChangedKeys((a, s, c) => {
        this.notifyListeners(a, c);
      });
      return;
    }
    const r = t.key;
    n ? this.detachListener() : this.stopPolling();
    const i = () => {
      const a = this.storage.getItem(r);
      !n && this.localCache[r] === a || this.notifyListeners(r, a);
    }, o = this.storage.getItem(r);
    e1e() && o !== t.newValue && t.newValue !== t.oldValue ? setTimeout(i, D1e) : i();
  }
  notifyListeners(t, n) {
    this.localCache[t] = n;
    const r = this.listeners[t];
    if (r)
      for (const i of Array.from(r))
        i(n && JSON.parse(n));
  }
  startPolling() {
    this.stopPolling(), this.pollTimer = setInterval(() => {
      this.forAllChangedKeys((t, n, r) => {
        this.onStorageEvent(
          new StorageEvent("storage", {
            key: t,
            oldValue: n,
            newValue: r
          }),
          /* poll */
          !0
        );
      });
    }, N1e);
  }
  stopPolling() {
    this.pollTimer && (clearInterval(this.pollTimer), this.pollTimer = null);
  }
  attachListener() {
    window.addEventListener("storage", this.boundEventHandler);
  }
  detachListener() {
    window.removeEventListener("storage", this.boundEventHandler);
  }
  _addListener(t, n) {
    Object.keys(this.listeners).length === 0 && (this.fallbackToPolling ? this.startPolling() : this.attachListener()), this.listeners[t] || (this.listeners[t] = /* @__PURE__ */ new Set(), this.localCache[t] = this.storage.getItem(t)), this.listeners[t].add(n);
  }
  _removeListener(t, n) {
    this.listeners[t] && (this.listeners[t].delete(n), this.listeners[t].size === 0 && delete this.listeners[t]), Object.keys(this.listeners).length === 0 && (this.detachListener(), this.stopPolling());
  }
  // Update local cache on base operations:
  async _set(t, n) {
    await super._set(t, n), this.localCache[t] = JSON.stringify(n);
  }
  async _get(t) {
    const n = await super._get(t);
    return this.localCache[t] = JSON.stringify(n), n;
  }
  async _remove(t) {
    await super._remove(t), delete this.localCache[t];
  }
}
tq.type = "LOCAL";
const j1e = tq;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class nq extends eq {
  constructor() {
    super(
      () => window.sessionStorage,
      "SESSION"
      /* PersistenceType.SESSION */
    );
  }
  _addListener(t, n) {
  }
  _removeListener(t, n) {
  }
}
nq.type = "SESSION";
const rq = nq;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function L1e(e) {
  return Promise.all(e.map(async (t) => {
    try {
      return {
        fulfilled: !0,
        value: await t
      };
    } catch (n) {
      return {
        fulfilled: !1,
        reason: n
      };
    }
  }));
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Lx {
  constructor(t) {
    this.eventTarget = t, this.handlersMap = {}, this.boundEventHandler = this.handleEvent.bind(this);
  }
  /**
   * Obtain an instance of a Receiver for a given event target, if none exists it will be created.
   *
   * @param eventTarget - An event target (such as window or self) through which the underlying
   * messages will be received.
   */
  static _getInstance(t) {
    const n = this.receivers.find((i) => i.isListeningto(t));
    if (n)
      return n;
    const r = new Lx(t);
    return this.receivers.push(r), r;
  }
  isListeningto(t) {
    return this.eventTarget === t;
  }
  /**
   * Fans out a MessageEvent to the appropriate listeners.
   *
   * @remarks
   * Sends an {@link Status.ACK} upon receipt and a {@link Status.DONE} once all handlers have
   * finished processing.
   *
   * @param event - The MessageEvent.
   *
   */
  async handleEvent(t) {
    const n = t, { eventId: r, eventType: i, data: o } = n.data, a = this.handlersMap[i];
    if (!(a != null && a.size))
      return;
    n.ports[0].postMessage({
      status: "ack",
      eventId: r,
      eventType: i
    });
    const s = Array.from(a).map(async (l) => l(n.origin, o)), c = await L1e(s);
    n.ports[0].postMessage({
      status: "done",
      eventId: r,
      eventType: i,
      response: c
    });
  }
  /**
   * Subscribe an event handler for a particular event.
   *
   * @param eventType - Event name to subscribe to.
   * @param eventHandler - The event handler which should receive the events.
   *
   */
  _subscribe(t, n) {
    Object.keys(this.handlersMap).length === 0 && this.eventTarget.addEventListener("message", this.boundEventHandler), this.handlersMap[t] || (this.handlersMap[t] = /* @__PURE__ */ new Set()), this.handlersMap[t].add(n);
  }
  /**
   * Unsubscribe an event handler from a particular event.
   *
   * @param eventType - Event name to unsubscribe from.
   * @param eventHandler - Optional event handler, if none provided, unsubscribe all handlers on this event.
   *
   */
  _unsubscribe(t, n) {
    this.handlersMap[t] && n && this.handlersMap[t].delete(n), (!n || this.handlersMap[t].size === 0) && delete this.handlersMap[t], Object.keys(this.handlersMap).length === 0 && this.eventTarget.removeEventListener("message", this.boundEventHandler);
  }
}
Lx.receivers = [];
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function DO(e = "", t = 10) {
  let n = "";
  for (let r = 0; r < t; r++)
    n += Math.floor(Math.random() * 10);
  return e + n;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class F1e {
  constructor(t) {
    this.target = t, this.handlers = /* @__PURE__ */ new Set();
  }
  /**
   * Unsubscribe the handler and remove it from our tracking Set.
   *
   * @param handler - The handler to unsubscribe.
   */
  removeMessageHandler(t) {
    t.messageChannel && (t.messageChannel.port1.removeEventListener("message", t.onMessage), t.messageChannel.port1.close()), this.handlers.delete(t);
  }
  /**
   * Send a message to the Receiver located at {@link target}.
   *
   * @remarks
   * We'll first wait a bit for an ACK , if we get one we will wait significantly longer until the
   * receiver has had a chance to fully process the event.
   *
   * @param eventType - Type of event to send.
   * @param data - The payload of the event.
   * @param timeout - Timeout for waiting on an ACK from the receiver.
   *
   * @returns An array of settled promises from all the handlers that were listening on the receiver.
   */
  async _send(t, n, r = 50) {
    const i = typeof MessageChannel < "u" ? new MessageChannel() : null;
    if (!i)
      throw new Error(
        "connection_unavailable"
        /* _MessageError.CONNECTION_UNAVAILABLE */
      );
    let o, a;
    return new Promise((s, c) => {
      const l = DO("", 20);
      i.port1.start();
      const u = setTimeout(() => {
        c(new Error(
          "unsupported_event"
          /* _MessageError.UNSUPPORTED_EVENT */
        ));
      }, r);
      a = {
        messageChannel: i,
        onMessage(d) {
          const f = d;
          if (f.data.eventId === l)
            switch (f.data.status) {
              case "ack":
                clearTimeout(u), o = setTimeout(
                  () => {
                    c(new Error(
                      "timeout"
                      /* _MessageError.TIMEOUT */
                    ));
                  },
                  3e3
                  /* _TimeoutDuration.COMPLETION */
                );
                break;
              case "done":
                clearTimeout(o), s(f.data.response);
                break;
              default:
                clearTimeout(u), clearTimeout(o), c(new Error(
                  "invalid_response"
                  /* _MessageError.INVALID_RESPONSE */
                ));
                break;
            }
        }
      }, this.handlers.add(a), i.port1.addEventListener("message", a.onMessage), this.target.postMessage({
        eventType: t,
        eventId: l,
        data: n
      }, [i.port2]);
    }).finally(() => {
      a && this.removeMessageHandler(a);
    });
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function lc() {
  return window;
}
function V1e(e) {
  lc().location.href = e;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function iq() {
  return typeof lc().WorkerGlobalScope < "u" && typeof lc().importScripts == "function";
}
async function B1e() {
  if (!(navigator != null && navigator.serviceWorker))
    return null;
  try {
    return (await navigator.serviceWorker.ready).active;
  } catch {
    return null;
  }
}
function z1e() {
  var e;
  return ((e = navigator == null ? void 0 : navigator.serviceWorker) === null || e === void 0 ? void 0 : e.controller) || null;
}
function H1e() {
  return iq() ? self : null;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const oq = "firebaseLocalStorageDb", U1e = 1, X_ = "firebaseLocalStorage", aq = "fbase_key";
class ly {
  constructor(t) {
    this.request = t;
  }
  toPromise() {
    return new Promise((t, n) => {
      this.request.addEventListener("success", () => {
        t(this.request.result);
      }), this.request.addEventListener("error", () => {
        n(this.request.error);
      });
    });
  }
}
function Fx(e, t) {
  return e.transaction([X_], t ? "readwrite" : "readonly").objectStore(X_);
}
function W1e() {
  const e = indexedDB.deleteDatabase(oq);
  return new ly(e).toPromise();
}
function k$() {
  const e = indexedDB.open(oq, U1e);
  return new Promise((t, n) => {
    e.addEventListener("error", () => {
      n(e.error);
    }), e.addEventListener("upgradeneeded", () => {
      const r = e.result;
      try {
        r.createObjectStore(X_, { keyPath: aq });
      } catch (i) {
        n(i);
      }
    }), e.addEventListener("success", async () => {
      const r = e.result;
      r.objectStoreNames.contains(X_) ? t(r) : (r.close(), await W1e(), t(await k$()));
    });
  });
}
async function aD(e, t, n) {
  const r = Fx(e, !0).put({
    [aq]: t,
    value: n
  });
  return new ly(r).toPromise();
}
async function q1e(e, t) {
  const n = Fx(e, !1).get(t), r = await new ly(n).toPromise();
  return r === void 0 ? null : r.value;
}
function sD(e, t) {
  const n = Fx(e, !0).delete(t);
  return new ly(n).toPromise();
}
const G1e = 800, K1e = 3;
class sq {
  constructor() {
    this.type = "LOCAL", this._shouldAllowMigration = !0, this.listeners = {}, this.localCache = {}, this.pollTimer = null, this.pendingWrites = 0, this.receiver = null, this.sender = null, this.serviceWorkerReceiverAvailable = !1, this.activeServiceWorker = null, this._workerInitializationPromise = this.initializeServiceWorkerMessaging().then(() => {
    }, () => {
    });
  }
  async _openDb() {
    return this.db ? this.db : (this.db = await k$(), this.db);
  }
  async _withRetries(t) {
    let n = 0;
    for (; ; )
      try {
        const r = await this._openDb();
        return await t(r);
      } catch (r) {
        if (n++ > K1e)
          throw r;
        this.db && (this.db.close(), this.db = void 0);
      }
  }
  /**
   * IndexedDB events do not propagate from the main window to the worker context.  We rely on a
   * postMessage interface to send these events to the worker ourselves.
   */
  async initializeServiceWorkerMessaging() {
    return iq() ? this.initializeReceiver() : this.initializeSender();
  }
  /**
   * As the worker we should listen to events from the main window.
   */
  async initializeReceiver() {
    this.receiver = Lx._getInstance(H1e()), this.receiver._subscribe("keyChanged", async (t, n) => ({
      keyProcessed: (await this._poll()).includes(n.key)
    })), this.receiver._subscribe("ping", async (t, n) => [
      "keyChanged"
      /* _EventType.KEY_CHANGED */
    ]);
  }
  /**
   * As the main window, we should let the worker know when keys change (set and remove).
   *
   * @remarks
   * {@link https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerContainer/ready | ServiceWorkerContainer.ready}
   * may not resolve.
   */
  async initializeSender() {
    var t, n;
    if (this.activeServiceWorker = await B1e(), !this.activeServiceWorker)
      return;
    this.sender = new F1e(this.activeServiceWorker);
    const r = await this.sender._send(
      "ping",
      {},
      800
      /* _TimeoutDuration.LONG_ACK */
    );
    r && !((t = r[0]) === null || t === void 0) && t.fulfilled && !((n = r[0]) === null || n === void 0) && n.value.includes(
      "keyChanged"
      /* _EventType.KEY_CHANGED */
    ) && (this.serviceWorkerReceiverAvailable = !0);
  }
  /**
   * Let the worker know about a changed key, the exact key doesn't technically matter since the
   * worker will just trigger a full sync anyway.
   *
   * @remarks
   * For now, we only support one service worker per page.
   *
   * @param key - Storage key which changed.
   */
  async notifyServiceWorker(t) {
    if (!(!this.sender || !this.activeServiceWorker || z1e() !== this.activeServiceWorker))
      try {
        await this.sender._send(
          "keyChanged",
          { key: t },
          // Use long timeout if receiver has previously responded to a ping from us.
          this.serviceWorkerReceiverAvailable ? 800 : 50
          /* _TimeoutDuration.ACK */
        );
      } catch {
      }
  }
  async _isAvailable() {
    try {
      if (!indexedDB)
        return !1;
      const t = await k$();
      return await aD(t, Y_, "1"), await sD(t, Y_), !0;
    } catch {
    }
    return !1;
  }
  async _withPendingWrite(t) {
    this.pendingWrites++;
    try {
      await t();
    } finally {
      this.pendingWrites--;
    }
  }
  async _set(t, n) {
    return this._withPendingWrite(async () => (await this._withRetries((r) => aD(r, t, n)), this.localCache[t] = n, this.notifyServiceWorker(t)));
  }
  async _get(t) {
    const n = await this._withRetries((r) => q1e(r, t));
    return this.localCache[t] = n, n;
  }
  async _remove(t) {
    return this._withPendingWrite(async () => (await this._withRetries((n) => sD(n, t)), delete this.localCache[t], this.notifyServiceWorker(t)));
  }
  async _poll() {
    const t = await this._withRetries((i) => {
      const o = Fx(i, !1).getAll();
      return new ly(o).toPromise();
    });
    if (!t)
      return [];
    if (this.pendingWrites !== 0)
      return [];
    const n = [], r = /* @__PURE__ */ new Set();
    if (t.length !== 0)
      for (const { fbase_key: i, value: o } of t)
        r.add(i), JSON.stringify(this.localCache[i]) !== JSON.stringify(o) && (this.notifyListeners(i, o), n.push(i));
    for (const i of Object.keys(this.localCache))
      this.localCache[i] && !r.has(i) && (this.notifyListeners(i, null), n.push(i));
    return n;
  }
  notifyListeners(t, n) {
    this.localCache[t] = n;
    const r = this.listeners[t];
    if (r)
      for (const i of Array.from(r))
        i(n);
  }
  startPolling() {
    this.stopPolling(), this.pollTimer = setInterval(async () => this._poll(), G1e);
  }
  stopPolling() {
    this.pollTimer && (clearInterval(this.pollTimer), this.pollTimer = null);
  }
  _addListener(t, n) {
    Object.keys(this.listeners).length === 0 && this.startPolling(), this.listeners[t] || (this.listeners[t] = /* @__PURE__ */ new Set(), this._get(t)), this.listeners[t].add(n);
  }
  _removeListener(t, n) {
    this.listeners[t] && (this.listeners[t].delete(n), this.listeners[t].size === 0 && delete this.listeners[t]), Object.keys(this.listeners).length === 0 && this.stopPolling();
  }
}
sq.type = "LOCAL";
const Y1e = sq;
new sy(3e4, 6e4);
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function jO(e, t) {
  return t ? Qc(t) : (Vt(
    e._popupRedirectResolver,
    e,
    "argument-error"
    /* AuthErrorCode.ARGUMENT_ERROR */
  ), e._popupRedirectResolver);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class LO extends kO {
  constructor(t) {
    super(
      "custom",
      "custom"
      /* ProviderId.CUSTOM */
    ), this.params = t;
  }
  _getIdTokenResponse(t) {
    return ag(t, this._buildIdpRequest());
  }
  _linkToIdToken(t, n) {
    return ag(t, this._buildIdpRequest(n));
  }
  _getReauthenticationResolver(t) {
    return ag(t, this._buildIdpRequest());
  }
  _buildIdpRequest(t) {
    const n = {
      requestUri: this.params.requestUri,
      sessionId: this.params.sessionId,
      postBody: this.params.postBody,
      tenantId: this.params.tenantId,
      pendingToken: this.params.pendingToken,
      returnSecureToken: !0,
      returnIdpCredential: !0
    };
    return t && (n.idToken = t), n;
  }
}
function X1e(e) {
  return ZW(e.auth, new LO(e), e.bypassAuthState);
}
function Q1e(e) {
  const { auth: t, user: n } = e;
  return Vt(
    n,
    t,
    "internal-error"
    /* AuthErrorCode.INTERNAL_ERROR */
  ), $1e(n, new LO(e), e.bypassAuthState);
}
async function J1e(e) {
  const { auth: t, user: n } = e;
  return Vt(
    n,
    t,
    "internal-error"
    /* AuthErrorCode.INTERNAL_ERROR */
  ), I1e(n, new LO(e), e.bypassAuthState);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class cq {
  constructor(t, n, r, i, o = !1) {
    this.auth = t, this.resolver = r, this.user = i, this.bypassAuthState = o, this.pendingPromise = null, this.eventManager = null, this.filter = Array.isArray(n) ? n : [n];
  }
  execute() {
    return new Promise(async (t, n) => {
      this.pendingPromise = { resolve: t, reject: n };
      try {
        this.eventManager = await this.resolver._initialize(this.auth), await this.onExecution(), this.eventManager.registerConsumer(this);
      } catch (r) {
        this.reject(r);
      }
    });
  }
  async onAuthEvent(t) {
    const { urlResponse: n, sessionId: r, postBody: i, tenantId: o, error: a, type: s } = t;
    if (a) {
      this.reject(a);
      return;
    }
    const c = {
      auth: this.auth,
      requestUri: n,
      sessionId: r,
      tenantId: o || void 0,
      postBody: i || void 0,
      user: this.user,
      bypassAuthState: this.bypassAuthState
    };
    try {
      this.resolve(await this.getIdpTask(s)(c));
    } catch (l) {
      this.reject(l);
    }
  }
  onError(t) {
    this.reject(t);
  }
  getIdpTask(t) {
    switch (t) {
      case "signInViaPopup":
      case "signInViaRedirect":
        return X1e;
      case "linkViaPopup":
      case "linkViaRedirect":
        return J1e;
      case "reauthViaPopup":
      case "reauthViaRedirect":
        return Q1e;
      default:
        Wa(
          this.auth,
          "internal-error"
          /* AuthErrorCode.INTERNAL_ERROR */
        );
    }
  }
  resolve(t) {
    dl(this.pendingPromise, "Pending promise was never set"), this.pendingPromise.resolve(t), this.unregisterAndCleanUp();
  }
  reject(t) {
    dl(this.pendingPromise, "Pending promise was never set"), this.pendingPromise.reject(t), this.unregisterAndCleanUp();
  }
  unregisterAndCleanUp() {
    this.eventManager && this.eventManager.unregisterConsumer(this), this.pendingPromise = null, this.cleanUp();
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Z1e = new sy(2e3, 1e4);
async function e_e(e, t, n) {
  if (Io(e.app))
    return Promise.reject(bs(
      e,
      "operation-not-supported-in-this-environment"
      /* AuthErrorCode.OPERATION_NOT_SUPPORTED */
    ));
  const r = El(e);
  MW(e, t, jx);
  const i = jO(r, n);
  return new Md(r, "signInViaPopup", t, i).executeNotNull();
}
class Md extends cq {
  constructor(t, n, r, i, o) {
    super(t, n, i, o), this.provider = r, this.authWindow = null, this.pollId = null, Md.currentPopupAction && Md.currentPopupAction.cancel(), Md.currentPopupAction = this;
  }
  async executeNotNull() {
    const t = await this.execute();
    return Vt(
      t,
      this.auth,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    ), t;
  }
  async onExecution() {
    dl(this.filter.length === 1, "Popup operations only handle one event");
    const t = DO();
    this.authWindow = await this.resolver._openPopup(
      this.auth,
      this.provider,
      this.filter[0],
      // There's always one, see constructor
      t
    ), this.authWindow.associatedEvent = t, this.resolver._originValidation(this.auth).catch((n) => {
      this.reject(n);
    }), this.resolver._isIframeWebStorageSupported(this.auth, (n) => {
      n || this.reject(bs(
        this.auth,
        "web-storage-unsupported"
        /* AuthErrorCode.WEB_STORAGE_UNSUPPORTED */
      ));
    }), this.pollUserCancellation();
  }
  get eventId() {
    var t;
    return ((t = this.authWindow) === null || t === void 0 ? void 0 : t.associatedEvent) || null;
  }
  cancel() {
    this.reject(bs(
      this.auth,
      "cancelled-popup-request"
      /* AuthErrorCode.EXPIRED_POPUP_REQUEST */
    ));
  }
  cleanUp() {
    this.authWindow && this.authWindow.close(), this.pollId && window.clearTimeout(this.pollId), this.authWindow = null, this.pollId = null, Md.currentPopupAction = null;
  }
  pollUserCancellation() {
    const t = () => {
      var n, r;
      if (!((r = (n = this.authWindow) === null || n === void 0 ? void 0 : n.window) === null || r === void 0) && r.closed) {
        this.pollId = window.setTimeout(
          () => {
            this.pollId = null, this.reject(bs(
              this.auth,
              "popup-closed-by-user"
              /* AuthErrorCode.POPUP_CLOSED_BY_USER */
            ));
          },
          8e3
          /* _Timeout.AUTH_EVENT */
        );
        return;
      }
      this.pollId = window.setTimeout(t, Z1e.get());
    };
    t();
  }
}
Md.currentPopupAction = null;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const t_e = "pendingRedirect", e_ = /* @__PURE__ */ new Map();
class n_e extends cq {
  constructor(t, n, r = !1) {
    super(t, [
      "signInViaRedirect",
      "linkViaRedirect",
      "reauthViaRedirect",
      "unknown"
      /* AuthEventType.UNKNOWN */
    ], n, void 0, r), this.eventId = null;
  }
  /**
   * Override the execute function; if we already have a redirect result, then
   * just return it.
   */
  async execute() {
    let t = e_.get(this.auth._key());
    if (!t) {
      try {
        const r = await r_e(this.resolver, this.auth) ? await super.execute() : null;
        t = () => Promise.resolve(r);
      } catch (n) {
        t = () => Promise.reject(n);
      }
      e_.set(this.auth._key(), t);
    }
    return this.bypassAuthState || e_.set(this.auth._key(), () => Promise.resolve(null)), t();
  }
  async onAuthEvent(t) {
    if (t.type === "signInViaRedirect")
      return super.onAuthEvent(t);
    if (t.type === "unknown") {
      this.resolve(null);
      return;
    }
    if (t.eventId) {
      const n = await this.auth._redirectUserForId(t.eventId);
      if (n)
        return this.user = n, super.onAuthEvent(t);
      this.resolve(null);
    }
  }
  async onExecution() {
  }
  cleanUp() {
  }
}
async function r_e(e, t) {
  const n = uq(t), r = lq(e);
  if (!await r._isAvailable())
    return !1;
  const i = await r._get(n) === "true";
  return await r._remove(n), i;
}
async function i_e(e, t) {
  return lq(e)._set(uq(t), "true");
}
function o_e(e, t) {
  e_.set(e._key(), t);
}
function lq(e) {
  return Qc(e._redirectPersistence);
}
function uq(e) {
  return Z1(t_e, e.config.apiKey, e.name);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function a_e(e, t, n) {
  return s_e(e, t, n);
}
async function s_e(e, t, n) {
  if (Io(e.app))
    return Promise.reject(cc(e));
  const r = El(e);
  MW(e, t, jx), await r._initializationPromise;
  const i = jO(r, n);
  return await i_e(i, r), i._openRedirect(
    r,
    t,
    "signInViaRedirect"
    /* AuthEventType.SIGN_IN_VIA_REDIRECT */
  );
}
async function c_e(e, t, n = !1) {
  if (Io(e.app))
    return Promise.reject(cc(e));
  const r = El(e), i = jO(r, t), a = await new n_e(r, i, n).execute();
  return a && !n && (delete a.user._redirectEventId, await r._persistUserIfCurrent(a.user), await r._setRedirectUser(null, t)), a;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const l_e = 10 * 60 * 1e3;
class u_e {
  constructor(t) {
    this.auth = t, this.cachedEventUids = /* @__PURE__ */ new Set(), this.consumers = /* @__PURE__ */ new Set(), this.queuedRedirectEvent = null, this.hasHandledPotentialRedirect = !1, this.lastProcessedEventTime = Date.now();
  }
  registerConsumer(t) {
    this.consumers.add(t), this.queuedRedirectEvent && this.isEventForConsumer(this.queuedRedirectEvent, t) && (this.sendToConsumer(this.queuedRedirectEvent, t), this.saveEventToCache(this.queuedRedirectEvent), this.queuedRedirectEvent = null);
  }
  unregisterConsumer(t) {
    this.consumers.delete(t);
  }
  onEvent(t) {
    if (this.hasEventBeenHandled(t))
      return !1;
    let n = !1;
    return this.consumers.forEach((r) => {
      this.isEventForConsumer(t, r) && (n = !0, this.sendToConsumer(t, r), this.saveEventToCache(t));
    }), this.hasHandledPotentialRedirect || !d_e(t) || (this.hasHandledPotentialRedirect = !0, n || (this.queuedRedirectEvent = t, n = !0)), n;
  }
  sendToConsumer(t, n) {
    var r;
    if (t.error && !dq(t)) {
      const i = ((r = t.error.code) === null || r === void 0 ? void 0 : r.split("auth/")[1]) || "internal-error";
      n.onError(bs(this.auth, i));
    } else
      n.onAuthEvent(t);
  }
  isEventForConsumer(t, n) {
    const r = n.eventId === null || !!t.eventId && t.eventId === n.eventId;
    return n.filter.includes(t.type) && r;
  }
  hasEventBeenHandled(t) {
    return Date.now() - this.lastProcessedEventTime >= l_e && this.cachedEventUids.clear(), this.cachedEventUids.has(cD(t));
  }
  saveEventToCache(t) {
    this.cachedEventUids.add(cD(t)), this.lastProcessedEventTime = Date.now();
  }
}
function cD(e) {
  return [e.type, e.eventId, e.sessionId, e.tenantId].filter((t) => t).join("-");
}
function dq({ type: e, error: t }) {
  return e === "unknown" && (t == null ? void 0 : t.code) === "auth/no-auth-event";
}
function d_e(e) {
  switch (e.type) {
    case "signInViaRedirect":
    case "linkViaRedirect":
    case "reauthViaRedirect":
      return !0;
    case "unknown":
      return dq(e);
    default:
      return !1;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function f_e(e, t = {}) {
  return Yu(e, "GET", "/v1/projects", t);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const h_e = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/, g_e = /^https?/;
async function p_e(e) {
  if (e.config.emulator)
    return;
  const { authorizedDomains: t } = await f_e(e);
  for (const n of t)
    try {
      if (m_e(n))
        return;
    } catch {
    }
  Wa(
    e,
    "unauthorized-domain"
    /* AuthErrorCode.INVALID_ORIGIN */
  );
}
function m_e(e) {
  const t = O$(), { protocol: n, hostname: r } = new URL(t);
  if (e.startsWith("chrome-extension://")) {
    const a = new URL(e);
    return a.hostname === "" && r === "" ? n === "chrome-extension:" && e.replace("chrome-extension://", "") === t.replace("chrome-extension://", "") : n === "chrome-extension:" && a.hostname === r;
  }
  if (!g_e.test(n))
    return !1;
  if (h_e.test(e))
    return r === e;
  const i = e.replace(/\./g, "\\.");
  return new RegExp("^(.+\\." + i + "|" + i + ")$", "i").test(r);
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const v_e = new sy(3e4, 6e4);
function lD() {
  const e = lc().___jsl;
  if (e != null && e.H) {
    for (const t of Object.keys(e.H))
      if (e.H[t].r = e.H[t].r || [], e.H[t].L = e.H[t].L || [], e.H[t].r = [...e.H[t].L], e.CP)
        for (let n = 0; n < e.CP.length; n++)
          e.CP[n] = null;
  }
}
function y_e(e) {
  return new Promise((t, n) => {
    var r, i, o;
    function a() {
      lD(), gapi.load("gapi.iframes", {
        callback: () => {
          t(gapi.iframes.getContext());
        },
        ontimeout: () => {
          lD(), n(bs(
            e,
            "network-request-failed"
            /* AuthErrorCode.NETWORK_REQUEST_FAILED */
          ));
        },
        timeout: v_e.get()
      });
    }
    if (!((i = (r = lc().gapi) === null || r === void 0 ? void 0 : r.iframes) === null || i === void 0) && i.Iframe)
      t(gapi.iframes.getContext());
    else if (!((o = lc().gapi) === null || o === void 0) && o.load)
      a();
    else {
      const s = l1e("iframefcb");
      return lc()[s] = () => {
        gapi.load ? a() : n(bs(
          e,
          "network-request-failed"
          /* AuthErrorCode.NETWORK_REQUEST_FAILED */
        ));
      }, KW(`${c1e()}?onload=${s}`).catch((c) => n(c));
    }
  }).catch((t) => {
    throw t_ = null, t;
  });
}
let t_ = null;
function b_e(e) {
  return t_ = t_ || y_e(e), t_;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const __e = new sy(5e3, 15e3), S_e = "__/auth/iframe", w_e = "emulator/auth/iframe", x_e = {
  style: {
    position: "absolute",
    top: "-100px",
    width: "1px",
    height: "1px"
  },
  "aria-hidden": "true",
  tabindex: "-1"
}, E_e = /* @__PURE__ */ new Map([
  ["identitytoolkit.googleapis.com", "p"],
  // production
  ["staging-identitytoolkit.sandbox.googleapis.com", "s"],
  // staging
  ["test-identitytoolkit.sandbox.googleapis.com", "t"]
  // test
]);
function C_e(e) {
  const t = e.config;
  Vt(
    t.authDomain,
    e,
    "auth-domain-config-required"
    /* AuthErrorCode.MISSING_AUTH_DOMAIN */
  );
  const n = t.emulator ? PO(t, w_e) : `https://${e.config.authDomain}/${S_e}`, r = {
    apiKey: t.apiKey,
    appName: e.name,
    v: Op
  }, i = E_e.get(e.config.apiHost);
  i && (r.eid = i);
  const o = e._getFrameworks();
  return o.length && (r.fw = o.join(",")), `${n}?${ay(r).slice(1)}`;
}
async function T_e(e) {
  const t = await b_e(e), n = lc().gapi;
  return Vt(
    n,
    e,
    "internal-error"
    /* AuthErrorCode.INTERNAL_ERROR */
  ), t.open({
    where: document.body,
    url: C_e(e),
    messageHandlersFilter: n.iframes.CROSS_ORIGIN_IFRAMES_FILTER,
    attributes: x_e,
    dontclear: !0
  }, (r) => new Promise(async (i, o) => {
    await r.restyle({
      // Prevent iframe from closing on mouse out.
      setHideOnLeave: !1
    });
    const a = bs(
      e,
      "network-request-failed"
      /* AuthErrorCode.NETWORK_REQUEST_FAILED */
    ), s = lc().setTimeout(() => {
      o(a);
    }, __e.get());
    function c() {
      lc().clearTimeout(s), i(r);
    }
    r.ping(c).then(c, () => {
      o(a);
    });
  }));
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const I_e = {
  location: "yes",
  resizable: "yes",
  statusbar: "yes",
  toolbar: "no"
}, $_e = 500, A_e = 600, R_e = "_blank", P_e = "http://localhost";
class uD {
  constructor(t) {
    this.window = t, this.associatedEvent = null;
  }
  close() {
    if (this.window)
      try {
        this.window.close();
      } catch {
      }
  }
}
function O_e(e, t, n, r = $_e, i = A_e) {
  const o = Math.max((window.screen.availHeight - i) / 2, 0).toString(), a = Math.max((window.screen.availWidth - r) / 2, 0).toString();
  let s = "";
  const c = Object.assign(Object.assign({}, I_e), {
    width: r.toString(),
    height: i.toString(),
    top: o,
    left: a
  }), l = ho().toLowerCase();
  n && (s = BW(l) ? R_e : n), FW(l) && (t = t || P_e, c.scrollbars = "yes");
  const u = Object.entries(c).reduce((f, [h, p]) => `${f}${h}=${p},`, "");
  if (Zbe(l) && s !== "_self")
    return M_e(t || "", s), new uD(null);
  const d = window.open(t || "", s, u);
  Vt(
    d,
    e,
    "popup-blocked"
    /* AuthErrorCode.POPUP_BLOCKED */
  );
  try {
    d.focus();
  } catch {
  }
  return new uD(d);
}
function M_e(e, t) {
  const n = document.createElement("a");
  n.href = e, n.target = t;
  const r = document.createEvent("MouseEvent");
  r.initMouseEvent("click", !0, !0, window, 1, 0, 0, 0, 0, !1, !1, !1, !1, 1, null), n.dispatchEvent(r);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const k_e = "__/auth/handler", N_e = "emulator/auth/handler", D_e = encodeURIComponent("fac");
async function dD(e, t, n, r, i, o) {
  Vt(
    e.config.authDomain,
    e,
    "auth-domain-config-required"
    /* AuthErrorCode.MISSING_AUTH_DOMAIN */
  ), Vt(
    e.config.apiKey,
    e,
    "invalid-api-key"
    /* AuthErrorCode.INVALID_API_KEY */
  );
  const a = {
    apiKey: e.config.apiKey,
    appName: e.name,
    authType: n,
    redirectUrl: r,
    v: Op,
    eventId: i
  };
  if (t instanceof jx) {
    t.setDefaultLanguage(e.languageCode), a.providerId = t.providerId || "", eve(t.getCustomParameters()) || (a.customParameters = JSON.stringify(t.getCustomParameters()));
    for (const [u, d] of Object.entries(o || {}))
      a[u] = d;
  }
  if (t instanceof kp) {
    const u = t.getScopes().filter((d) => d !== "");
    u.length > 0 && (a.scopes = u.join(","));
  }
  e.tenantId && (a.tid = e.tenantId);
  const s = a;
  for (const u of Object.keys(s))
    s[u] === void 0 && delete s[u];
  const c = await e._getAppCheckToken(), l = c ? `#${D_e}=${encodeURIComponent(c)}` : "";
  return `${j_e(e)}?${ay(s).slice(1)}${l}`;
}
function j_e({ config: e }) {
  return e.emulator ? PO(e, N_e) : `https://${e.authDomain}/${k_e}`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const j5 = "webStorageSupport";
class L_e {
  constructor() {
    this.eventManagers = {}, this.iframes = {}, this.originValidationPromises = {}, this._redirectPersistence = rq, this._completeRedirectFn = c_e, this._overrideRedirectResult = o_e;
  }
  // Wrapping in async even though we don't await anywhere in order
  // to make sure errors are raised as promise rejections
  async _openPopup(t, n, r, i) {
    var o;
    dl((o = this.eventManagers[t._key()]) === null || o === void 0 ? void 0 : o.manager, "_initialize() not called before _openPopup()");
    const a = await dD(t, n, r, O$(), i);
    return O_e(t, a, DO());
  }
  async _openRedirect(t, n, r, i) {
    await this._originValidation(t);
    const o = await dD(t, n, r, O$(), i);
    return V1e(o), new Promise(() => {
    });
  }
  _initialize(t) {
    const n = t._key();
    if (this.eventManagers[n]) {
      const { manager: i, promise: o } = this.eventManagers[n];
      return i ? Promise.resolve(i) : (dl(o, "If manager is not set, promise should be"), o);
    }
    const r = this.initAndGetManager(t);
    return this.eventManagers[n] = { promise: r }, r.catch(() => {
      delete this.eventManagers[n];
    }), r;
  }
  async initAndGetManager(t) {
    const n = await T_e(t), r = new u_e(t);
    return n.register("authEvent", (i) => (Vt(
      i == null ? void 0 : i.authEvent,
      t,
      "invalid-auth-event"
      /* AuthErrorCode.INVALID_AUTH_EVENT */
    ), {
      status: r.onEvent(i.authEvent) ? "ACK" : "ERROR"
      /* GapiOutcome.ERROR */
    }), gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER), this.eventManagers[t._key()] = { manager: r }, this.iframes[t._key()] = n, r;
  }
  _isIframeWebStorageSupported(t, n) {
    this.iframes[t._key()].send(j5, { type: j5 }, (i) => {
      var o;
      const a = (o = i == null ? void 0 : i[0]) === null || o === void 0 ? void 0 : o[j5];
      a !== void 0 && n(!!a), Wa(
        t,
        "internal-error"
        /* AuthErrorCode.INTERNAL_ERROR */
      );
    }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
  }
  _originValidation(t) {
    const n = t._key();
    return this.originValidationPromises[n] || (this.originValidationPromises[n] = p_e(t)), this.originValidationPromises[n];
  }
  get _shouldInitProactively() {
    return qW() || VW() || MO();
  }
}
const F_e = L_e;
var fD = "@firebase/auth", hD = "1.10.8";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class V_e {
  constructor(t) {
    this.auth = t, this.internalListeners = /* @__PURE__ */ new Map();
  }
  getUid() {
    var t;
    return this.assertAuthConfigured(), ((t = this.auth.currentUser) === null || t === void 0 ? void 0 : t.uid) || null;
  }
  async getToken(t) {
    return this.assertAuthConfigured(), await this.auth._initializationPromise, this.auth.currentUser ? { accessToken: await this.auth.currentUser.getIdToken(t) } : null;
  }
  addAuthTokenListener(t) {
    if (this.assertAuthConfigured(), this.internalListeners.has(t))
      return;
    const n = this.auth.onIdTokenChanged((r) => {
      t((r == null ? void 0 : r.stsTokenManager.accessToken) || null);
    });
    this.internalListeners.set(t, n), this.updateProactiveRefresh();
  }
  removeAuthTokenListener(t) {
    this.assertAuthConfigured();
    const n = this.internalListeners.get(t);
    n && (this.internalListeners.delete(t), n(), this.updateProactiveRefresh());
  }
  assertAuthConfigured() {
    Vt(
      this.auth._initializationPromise,
      "dependent-sdk-initialized-before-auth"
      /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */
    );
  }
  updateProactiveRefresh() {
    this.internalListeners.size > 0 ? this.auth._startProactiveRefresh() : this.auth._stopProactiveRefresh();
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function B_e(e) {
  switch (e) {
    case "Node":
      return "node";
    case "ReactNative":
      return "rn";
    case "Worker":
      return "webworker";
    case "Cordova":
      return "cordova";
    case "WebExtension":
      return "web-extension";
    default:
      return;
  }
}
function z_e(e) {
  Is(new Ua(
    "auth",
    (t, { options: n }) => {
      const r = t.getProvider("app").getImmediate(), i = t.getProvider("heartbeat"), o = t.getProvider("app-check-internal"), { apiKey: a, authDomain: s } = r.options;
      Vt(a && !a.includes(":"), "invalid-api-key", { appName: r.name });
      const c = {
        apiKey: a,
        authDomain: s,
        clientPlatform: e,
        apiHost: "identitytoolkit.googleapis.com",
        tokenApiHost: "securetoken.googleapis.com",
        apiScheme: "https",
        sdkClientVersion: GW(e)
      }, l = new o1e(r, i, o, c);
      return p1e(l, n), l;
    },
    "PUBLIC"
    /* ComponentType.PUBLIC */
  ).setInstantiationMode(
    "EXPLICIT"
    /* InstantiationMode.EXPLICIT */
  ).setInstanceCreatedCallback((t, n, r) => {
    t.getProvider(
      "auth-internal"
      /* _ComponentName.AUTH_INTERNAL */
    ).initialize();
  })), Is(new Ua(
    "auth-internal",
    (t) => {
      const n = El(t.getProvider(
        "auth"
        /* _ComponentName.AUTH */
      ).getImmediate());
      return ((r) => new V_e(r))(n);
    },
    "PRIVATE"
    /* ComponentType.PRIVATE */
  ).setInstantiationMode(
    "EXPLICIT"
    /* InstantiationMode.EXPLICIT */
  )), ta(fD, hD, B_e(e)), ta(fD, hD, "esm2017");
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const H_e = 5 * 60, U_e = JU("authIdTokenMaxAge") || H_e;
let gD = null;
const W_e = (e) => async (t) => {
  const n = t && await t.getIdTokenResult(), r = n && ((/* @__PURE__ */ new Date()).getTime() - Date.parse(n.issuedAtTime)) / 1e3;
  if (r && r > U_e)
    return;
  const i = n == null ? void 0 : n.token;
  gD !== i && (gD = i, await fetch(e, {
    method: i ? "POST" : "DELETE",
    headers: i ? {
      Authorization: `Bearer ${i}`
    } : {}
  }));
};
function q_e(e = Mx()) {
  const t = xl(e, "auth");
  if (t.isInitialized())
    return t.getImmediate();
  const n = g1e(e, {
    popupRedirectResolver: F_e,
    persistence: [
      Y1e,
      j1e,
      rq
    ]
  }), r = JU("authTokenSyncURL");
  if (r && typeof isSecureContext == "boolean" && isSecureContext) {
    const o = new URL(r, location.origin);
    if (location.origin === o.origin) {
      const a = W_e(o.toString());
      M1e(n, a, () => a(n.currentUser)), O1e(n, (s) => a(s));
    }
  }
  const i = YU("auth");
  return i && XW(n, `http://${i}`), n;
}
function G_e() {
  var e, t;
  return (t = (e = document.getElementsByTagName("head")) === null || e === void 0 ? void 0 : e[0]) !== null && t !== void 0 ? t : document;
}
a1e({
  loadJS(e) {
    return new Promise((t, n) => {
      const r = document.createElement("script");
      r.setAttribute("src", e), r.onload = t, r.onerror = (i) => {
        const o = bs(
          "internal-error"
          /* AuthErrorCode.INTERNAL_ERROR */
        );
        o.customData = i, n(o);
      }, r.type = "text/javascript", r.charset = "UTF-8", G_e().appendChild(r);
    });
  },
  gapiScript: "https://apis.google.com/js/api.js",
  recaptchaV2Script: "https://www.google.com/recaptcha/api.js",
  recaptchaEnterpriseScript: "https://www.google.com/recaptcha/enterprise.js?render="
});
z_e(
  "Browser"
  /* ClientPlatform.BROWSER */
);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const K_e = "type.googleapis.com/google.protobuf.Int64Value", Y_e = "type.googleapis.com/google.protobuf.UInt64Value";
function fq(e, t) {
  const n = {};
  for (const r in e)
    e.hasOwnProperty(r) && (n[r] = t(e[r]));
  return n;
}
function Q_(e) {
  if (e == null)
    return null;
  if (e instanceof Number && (e = e.valueOf()), typeof e == "number" && isFinite(e) || e === !0 || e === !1 || Object.prototype.toString.call(e) === "[object String]")
    return e;
  if (e instanceof Date)
    return e.toISOString();
  if (Array.isArray(e))
    return e.map((t) => Q_(t));
  if (typeof e == "function" || typeof e == "object")
    return fq(e, (t) => Q_(t));
  throw new Error("Data cannot be encoded in JSON: " + e);
}
function Cg(e) {
  if (e == null)
    return e;
  if (e["@type"])
    switch (e["@type"]) {
      case K_e:
      case Y_e: {
        const t = Number(e.value);
        if (isNaN(t))
          throw new Error("Data cannot be decoded from JSON: " + e);
        return t;
      }
      default:
        throw new Error("Data cannot be decoded from JSON: " + e);
    }
  return Array.isArray(e) ? e.map((t) => Cg(t)) : typeof e == "function" || typeof e == "object" ? fq(e, (t) => Cg(t)) : e;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const FO = "functions";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const pD = {
  OK: "ok",
  CANCELLED: "cancelled",
  UNKNOWN: "unknown",
  INVALID_ARGUMENT: "invalid-argument",
  DEADLINE_EXCEEDED: "deadline-exceeded",
  NOT_FOUND: "not-found",
  ALREADY_EXISTS: "already-exists",
  PERMISSION_DENIED: "permission-denied",
  UNAUTHENTICATED: "unauthenticated",
  RESOURCE_EXHAUSTED: "resource-exhausted",
  FAILED_PRECONDITION: "failed-precondition",
  ABORTED: "aborted",
  OUT_OF_RANGE: "out-of-range",
  UNIMPLEMENTED: "unimplemented",
  INTERNAL: "internal",
  UNAVAILABLE: "unavailable",
  DATA_LOSS: "data-loss"
};
class Zo extends Qa {
  /**
   * Constructs a new instance of the `FunctionsError` class.
   */
  constructor(t, n, r) {
    super(`${FO}/${t}`, n || ""), this.details = r, Object.setPrototypeOf(this, Zo.prototype);
  }
}
function X_e(e) {
  if (e >= 200 && e < 300)
    return "ok";
  switch (e) {
    case 0:
      return "internal";
    case 400:
      return "invalid-argument";
    case 401:
      return "unauthenticated";
    case 403:
      return "permission-denied";
    case 404:
      return "not-found";
    case 409:
      return "aborted";
    case 429:
      return "resource-exhausted";
    case 499:
      return "cancelled";
    case 500:
      return "internal";
    case 501:
      return "unimplemented";
    case 503:
      return "unavailable";
    case 504:
      return "deadline-exceeded";
  }
  return "unknown";
}
function J_(e, t) {
  let n = X_e(e), r = n, i;
  try {
    const o = t && t.error;
    if (o) {
      const a = o.status;
      if (typeof a == "string") {
        if (!pD[a])
          return new Zo("internal", "internal");
        n = pD[a], r = a;
      }
      const s = o.message;
      typeof s == "string" && (r = s), i = o.details, i !== void 0 && (i = Cg(i));
    }
  } catch {
  }
  return n === "ok" ? null : new Zo(n, r, i);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Q_e {
  constructor(t, n, r, i) {
    this.app = t, this.auth = null, this.messaging = null, this.appCheck = null, this.serverAppAppCheckToken = null, Io(t) && t.settings.appCheckToken && (this.serverAppAppCheckToken = t.settings.appCheckToken), this.auth = n.getImmediate({ optional: !0 }), this.messaging = r.getImmediate({
      optional: !0
    }), this.auth || n.get().then((o) => this.auth = o, () => {
    }), this.messaging || r.get().then((o) => this.messaging = o, () => {
    }), this.appCheck || i == null || i.get().then((o) => this.appCheck = o, () => {
    });
  }
  async getAuthToken() {
    if (this.auth)
      try {
        const t = await this.auth.getToken();
        return t == null ? void 0 : t.accessToken;
      } catch {
        return;
      }
  }
  async getMessagingToken() {
    if (!(!this.messaging || !("Notification" in self) || Notification.permission !== "granted"))
      try {
        return await this.messaging.getToken();
      } catch {
        return;
      }
  }
  async getAppCheckToken(t) {
    if (this.serverAppAppCheckToken)
      return this.serverAppAppCheckToken;
    if (this.appCheck) {
      const n = t ? await this.appCheck.getLimitedUseToken() : await this.appCheck.getToken();
      return n.error ? null : n.token;
    }
    return null;
  }
  async getContext(t) {
    const n = await this.getAuthToken(), r = await this.getMessagingToken(), i = await this.getAppCheckToken(t);
    return { authToken: n, messagingToken: r, appCheckToken: i };
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const N$ = "us-central1", J_e = /^data: (.*?)(?:\n|$)/;
function Z_e(e) {
  let t = null;
  return {
    promise: new Promise((n, r) => {
      t = setTimeout(() => {
        r(new Zo("deadline-exceeded", "deadline-exceeded"));
      }, e);
    }),
    cancel: () => {
      t && clearTimeout(t);
    }
  };
}
class eSe {
  /**
   * Creates a new Functions service for the given app.
   * @param app - The FirebaseApp to use.
   */
  constructor(t, n, r, i, o = N$, a = (...s) => fetch(...s)) {
    this.app = t, this.fetchImpl = a, this.emulatorOrigin = null, this.contextProvider = new Q_e(t, n, r, i), this.cancelAllRequests = new Promise((s) => {
      this.deleteService = () => Promise.resolve(s());
    });
    try {
      const s = new URL(o);
      this.customDomain = s.origin + (s.pathname === "/" ? "" : s.pathname), this.region = N$;
    } catch {
      this.customDomain = null, this.region = o;
    }
  }
  _delete() {
    return this.deleteService();
  }
  /**
   * Returns the URL for a callable with the given name.
   * @param name - The name of the callable.
   * @internal
   */
  _url(t) {
    const n = this.app.options.projectId;
    return this.emulatorOrigin !== null ? `${this.emulatorOrigin}/${n}/${this.region}/${t}` : this.customDomain !== null ? `${this.customDomain}/${t}` : `https://${this.region}-${n}.cloudfunctions.net/${t}`;
  }
}
function tSe(e, t, n) {
  const r = Gu(t);
  e.emulatorOrigin = `http${r ? "s" : ""}://${t}:${n}`, r && (Px(e.emulatorOrigin), wO("Functions", !0));
}
function nSe(e, t, n) {
  const r = (i) => iSe(e, t, i, n || {});
  return r.stream = (i, o) => aSe(e, t, i, o), r;
}
async function rSe(e, t, n, r) {
  n["Content-Type"] = "application/json";
  let i;
  try {
    i = await r(e, {
      method: "POST",
      body: JSON.stringify(t),
      headers: n
    });
  } catch {
    return {
      status: 0,
      json: null
    };
  }
  let o = null;
  try {
    o = await i.json();
  } catch {
  }
  return {
    status: i.status,
    json: o
  };
}
async function hq(e, t) {
  const n = {}, r = await e.contextProvider.getContext(t.limitedUseAppCheckTokens);
  return r.authToken && (n.Authorization = "Bearer " + r.authToken), r.messagingToken && (n["Firebase-Instance-ID-Token"] = r.messagingToken), r.appCheckToken !== null && (n["X-Firebase-AppCheck"] = r.appCheckToken), n;
}
function iSe(e, t, n, r) {
  const i = e._url(t);
  return oSe(e, i, n, r);
}
async function oSe(e, t, n, r) {
  n = Q_(n);
  const i = { data: n }, o = await hq(e, r), a = r.timeout || 7e4, s = Z_e(a), c = await Promise.race([
    rSe(t, i, o, e.fetchImpl),
    s.promise,
    e.cancelAllRequests
  ]);
  if (s.cancel(), !c)
    throw new Zo("cancelled", "Firebase Functions instance was deleted.");
  const l = J_(c.status, c.json);
  if (l)
    throw l;
  if (!c.json)
    throw new Zo("internal", "Response is not valid JSON object.");
  let u = c.json.data;
  if (typeof u > "u" && (u = c.json.result), typeof u > "u")
    throw new Zo("internal", "Response is missing data field.");
  return { data: Cg(u) };
}
function aSe(e, t, n, r) {
  const i = e._url(t);
  return sSe(e, i, n, r || {});
}
async function sSe(e, t, n, r) {
  var i;
  n = Q_(n);
  const o = { data: n }, a = await hq(e, r);
  a["Content-Type"] = "application/json", a.Accept = "text/event-stream";
  let s;
  try {
    s = await e.fetchImpl(t, {
      method: "POST",
      body: JSON.stringify(o),
      headers: a,
      signal: r == null ? void 0 : r.signal
    });
  } catch (h) {
    if (h instanceof Error && h.name === "AbortError") {
      const g = new Zo("cancelled", "Request was cancelled.");
      return {
        data: Promise.reject(g),
        stream: {
          [Symbol.asyncIterator]() {
            return {
              next() {
                return Promise.reject(g);
              }
            };
          }
        }
      };
    }
    const p = J_(0, null);
    return {
      data: Promise.reject(p),
      // Return an empty async iterator
      stream: {
        [Symbol.asyncIterator]() {
          return {
            next() {
              return Promise.reject(p);
            }
          };
        }
      }
    };
  }
  let c, l;
  const u = new Promise((h, p) => {
    c = h, l = p;
  });
  (i = r == null ? void 0 : r.signal) === null || i === void 0 || i.addEventListener("abort", () => {
    const h = new Zo("cancelled", "Request was cancelled.");
    l(h);
  });
  const d = s.body.getReader(), f = cSe(d, c, l, r == null ? void 0 : r.signal);
  return {
    stream: {
      [Symbol.asyncIterator]() {
        const h = f.getReader();
        return {
          async next() {
            const { value: p, done: g } = await h.read();
            return { value: p, done: g };
          },
          async return() {
            return await h.cancel(), { done: !0, value: void 0 };
          }
        };
      }
    },
    data: u
  };
}
function cSe(e, t, n, r) {
  const i = (a, s) => {
    const c = a.match(J_e);
    if (!c)
      return;
    const l = c[1];
    try {
      const u = JSON.parse(l);
      if ("result" in u) {
        t(Cg(u.result));
        return;
      }
      if ("message" in u) {
        s.enqueue(Cg(u.message));
        return;
      }
      if ("error" in u) {
        const d = J_(0, u);
        s.error(d), n(d);
        return;
      }
    } catch (u) {
      if (u instanceof Zo) {
        s.error(u), n(u);
        return;
      }
    }
  }, o = new TextDecoder();
  return new ReadableStream({
    start(a) {
      let s = "";
      return c();
      async function c() {
        if (r != null && r.aborted) {
          const l = new Zo("cancelled", "Request was cancelled");
          return a.error(l), n(l), Promise.resolve();
        }
        try {
          const { value: l, done: u } = await e.read();
          if (u) {
            s.trim() && i(s.trim(), a), a.close();
            return;
          }
          if (r != null && r.aborted) {
            const f = new Zo("cancelled", "Request was cancelled");
            a.error(f), n(f), await e.cancel();
            return;
          }
          s += o.decode(l, { stream: !0 });
          const d = s.split(`
`);
          s = d.pop() || "";
          for (const f of d)
            f.trim() && i(f.trim(), a);
          return c();
        } catch (l) {
          const u = l instanceof Zo ? l : J_(0, null);
          a.error(u), n(u);
        }
      }
    },
    cancel() {
      return e.cancel();
    }
  });
}
const mD = "@firebase/functions", vD = "0.12.9";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const lSe = "auth-internal", uSe = "app-check-internal", dSe = "messaging-internal";
function fSe(e) {
  const t = (n, { instanceIdentifier: r }) => {
    const i = n.getProvider("app").getImmediate(), o = n.getProvider(lSe), a = n.getProvider(dSe), s = n.getProvider(uSe);
    return new eSe(i, o, a, s, r);
  };
  Is(new Ua(
    FO,
    t,
    "PUBLIC"
    /* ComponentType.PUBLIC */
  ).setMultipleInstances(!0)), ta(mD, vD, e), ta(mD, vD, "esm2017");
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function gq(e = Mx(), t = N$) {
  const r = xl(Or(e), FO).getImmediate({
    identifier: t
  }), i = XU("functions");
  return i && pq(r, ...i), r;
}
function pq(e, t, n) {
  tSe(Or(e), t, n);
}
function ks(e, t, n) {
  return nSe(Or(e), t, n);
}
fSe();
var yD = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
/** @license
Copyright The Closure Library Authors.
SPDX-License-Identifier: Apache-2.0
*/
var gu, mq;
(function() {
  var e;
  /** @license
  
   Copyright The Closure Library Authors.
   SPDX-License-Identifier: Apache-2.0
  */
  function t(x, T) {
    function E() {
    }
    E.prototype = T.prototype, x.D = T.prototype, x.prototype = new E(), x.prototype.constructor = x, x.C = function(R, I, O) {
      for (var P = Array(arguments.length - 2), k = 2; k < arguments.length; k++)
        P[k - 2] = arguments[k];
      return T.prototype[I].apply(R, P);
    };
  }
  function n() {
    this.blockSize = -1;
  }
  function r() {
    this.blockSize = -1, this.blockSize = 64, this.g = Array(4), this.B = Array(this.blockSize), this.o = this.h = 0, this.s();
  }
  t(r, n), r.prototype.s = function() {
    this.g[0] = 1732584193, this.g[1] = 4023233417, this.g[2] = 2562383102, this.g[3] = 271733878, this.o = this.h = 0;
  };
  function i(x, T, E) {
    E || (E = 0);
    var R = Array(16);
    if (typeof T == "string")
      for (var I = 0; 16 > I; ++I)
        R[I] = T.charCodeAt(E++) | T.charCodeAt(E++) << 8 | T.charCodeAt(E++) << 16 | T.charCodeAt(E++) << 24;
    else
      for (I = 0; 16 > I; ++I)
        R[I] = T[E++] | T[E++] << 8 | T[E++] << 16 | T[E++] << 24;
    T = x.g[0], E = x.g[1], I = x.g[2];
    var O = x.g[3], P = T + (O ^ E & (I ^ O)) + R[0] + 3614090360 & 4294967295;
    T = E + (P << 7 & 4294967295 | P >>> 25), P = O + (I ^ T & (E ^ I)) + R[1] + 3905402710 & 4294967295, O = T + (P << 12 & 4294967295 | P >>> 20), P = I + (E ^ O & (T ^ E)) + R[2] + 606105819 & 4294967295, I = O + (P << 17 & 4294967295 | P >>> 15), P = E + (T ^ I & (O ^ T)) + R[3] + 3250441966 & 4294967295, E = I + (P << 22 & 4294967295 | P >>> 10), P = T + (O ^ E & (I ^ O)) + R[4] + 4118548399 & 4294967295, T = E + (P << 7 & 4294967295 | P >>> 25), P = O + (I ^ T & (E ^ I)) + R[5] + 1200080426 & 4294967295, O = T + (P << 12 & 4294967295 | P >>> 20), P = I + (E ^ O & (T ^ E)) + R[6] + 2821735955 & 4294967295, I = O + (P << 17 & 4294967295 | P >>> 15), P = E + (T ^ I & (O ^ T)) + R[7] + 4249261313 & 4294967295, E = I + (P << 22 & 4294967295 | P >>> 10), P = T + (O ^ E & (I ^ O)) + R[8] + 1770035416 & 4294967295, T = E + (P << 7 & 4294967295 | P >>> 25), P = O + (I ^ T & (E ^ I)) + R[9] + 2336552879 & 4294967295, O = T + (P << 12 & 4294967295 | P >>> 20), P = I + (E ^ O & (T ^ E)) + R[10] + 4294925233 & 4294967295, I = O + (P << 17 & 4294967295 | P >>> 15), P = E + (T ^ I & (O ^ T)) + R[11] + 2304563134 & 4294967295, E = I + (P << 22 & 4294967295 | P >>> 10), P = T + (O ^ E & (I ^ O)) + R[12] + 1804603682 & 4294967295, T = E + (P << 7 & 4294967295 | P >>> 25), P = O + (I ^ T & (E ^ I)) + R[13] + 4254626195 & 4294967295, O = T + (P << 12 & 4294967295 | P >>> 20), P = I + (E ^ O & (T ^ E)) + R[14] + 2792965006 & 4294967295, I = O + (P << 17 & 4294967295 | P >>> 15), P = E + (T ^ I & (O ^ T)) + R[15] + 1236535329 & 4294967295, E = I + (P << 22 & 4294967295 | P >>> 10), P = T + (I ^ O & (E ^ I)) + R[1] + 4129170786 & 4294967295, T = E + (P << 5 & 4294967295 | P >>> 27), P = O + (E ^ I & (T ^ E)) + R[6] + 3225465664 & 4294967295, O = T + (P << 9 & 4294967295 | P >>> 23), P = I + (T ^ E & (O ^ T)) + R[11] + 643717713 & 4294967295, I = O + (P << 14 & 4294967295 | P >>> 18), P = E + (O ^ T & (I ^ O)) + R[0] + 3921069994 & 4294967295, E = I + (P << 20 & 4294967295 | P >>> 12), P = T + (I ^ O & (E ^ I)) + R[5] + 3593408605 & 4294967295, T = E + (P << 5 & 4294967295 | P >>> 27), P = O + (E ^ I & (T ^ E)) + R[10] + 38016083 & 4294967295, O = T + (P << 9 & 4294967295 | P >>> 23), P = I + (T ^ E & (O ^ T)) + R[15] + 3634488961 & 4294967295, I = O + (P << 14 & 4294967295 | P >>> 18), P = E + (O ^ T & (I ^ O)) + R[4] + 3889429448 & 4294967295, E = I + (P << 20 & 4294967295 | P >>> 12), P = T + (I ^ O & (E ^ I)) + R[9] + 568446438 & 4294967295, T = E + (P << 5 & 4294967295 | P >>> 27), P = O + (E ^ I & (T ^ E)) + R[14] + 3275163606 & 4294967295, O = T + (P << 9 & 4294967295 | P >>> 23), P = I + (T ^ E & (O ^ T)) + R[3] + 4107603335 & 4294967295, I = O + (P << 14 & 4294967295 | P >>> 18), P = E + (O ^ T & (I ^ O)) + R[8] + 1163531501 & 4294967295, E = I + (P << 20 & 4294967295 | P >>> 12), P = T + (I ^ O & (E ^ I)) + R[13] + 2850285829 & 4294967295, T = E + (P << 5 & 4294967295 | P >>> 27), P = O + (E ^ I & (T ^ E)) + R[2] + 4243563512 & 4294967295, O = T + (P << 9 & 4294967295 | P >>> 23), P = I + (T ^ E & (O ^ T)) + R[7] + 1735328473 & 4294967295, I = O + (P << 14 & 4294967295 | P >>> 18), P = E + (O ^ T & (I ^ O)) + R[12] + 2368359562 & 4294967295, E = I + (P << 20 & 4294967295 | P >>> 12), P = T + (E ^ I ^ O) + R[5] + 4294588738 & 4294967295, T = E + (P << 4 & 4294967295 | P >>> 28), P = O + (T ^ E ^ I) + R[8] + 2272392833 & 4294967295, O = T + (P << 11 & 4294967295 | P >>> 21), P = I + (O ^ T ^ E) + R[11] + 1839030562 & 4294967295, I = O + (P << 16 & 4294967295 | P >>> 16), P = E + (I ^ O ^ T) + R[14] + 4259657740 & 4294967295, E = I + (P << 23 & 4294967295 | P >>> 9), P = T + (E ^ I ^ O) + R[1] + 2763975236 & 4294967295, T = E + (P << 4 & 4294967295 | P >>> 28), P = O + (T ^ E ^ I) + R[4] + 1272893353 & 4294967295, O = T + (P << 11 & 4294967295 | P >>> 21), P = I + (O ^ T ^ E) + R[7] + 4139469664 & 4294967295, I = O + (P << 16 & 4294967295 | P >>> 16), P = E + (I ^ O ^ T) + R[10] + 3200236656 & 4294967295, E = I + (P << 23 & 4294967295 | P >>> 9), P = T + (E ^ I ^ O) + R[13] + 681279174 & 4294967295, T = E + (P << 4 & 4294967295 | P >>> 28), P = O + (T ^ E ^ I) + R[0] + 3936430074 & 4294967295, O = T + (P << 11 & 4294967295 | P >>> 21), P = I + (O ^ T ^ E) + R[3] + 3572445317 & 4294967295, I = O + (P << 16 & 4294967295 | P >>> 16), P = E + (I ^ O ^ T) + R[6] + 76029189 & 4294967295, E = I + (P << 23 & 4294967295 | P >>> 9), P = T + (E ^ I ^ O) + R[9] + 3654602809 & 4294967295, T = E + (P << 4 & 4294967295 | P >>> 28), P = O + (T ^ E ^ I) + R[12] + 3873151461 & 4294967295, O = T + (P << 11 & 4294967295 | P >>> 21), P = I + (O ^ T ^ E) + R[15] + 530742520 & 4294967295, I = O + (P << 16 & 4294967295 | P >>> 16), P = E + (I ^ O ^ T) + R[2] + 3299628645 & 4294967295, E = I + (P << 23 & 4294967295 | P >>> 9), P = T + (I ^ (E | ~O)) + R[0] + 4096336452 & 4294967295, T = E + (P << 6 & 4294967295 | P >>> 26), P = O + (E ^ (T | ~I)) + R[7] + 1126891415 & 4294967295, O = T + (P << 10 & 4294967295 | P >>> 22), P = I + (T ^ (O | ~E)) + R[14] + 2878612391 & 4294967295, I = O + (P << 15 & 4294967295 | P >>> 17), P = E + (O ^ (I | ~T)) + R[5] + 4237533241 & 4294967295, E = I + (P << 21 & 4294967295 | P >>> 11), P = T + (I ^ (E | ~O)) + R[12] + 1700485571 & 4294967295, T = E + (P << 6 & 4294967295 | P >>> 26), P = O + (E ^ (T | ~I)) + R[3] + 2399980690 & 4294967295, O = T + (P << 10 & 4294967295 | P >>> 22), P = I + (T ^ (O | ~E)) + R[10] + 4293915773 & 4294967295, I = O + (P << 15 & 4294967295 | P >>> 17), P = E + (O ^ (I | ~T)) + R[1] + 2240044497 & 4294967295, E = I + (P << 21 & 4294967295 | P >>> 11), P = T + (I ^ (E | ~O)) + R[8] + 1873313359 & 4294967295, T = E + (P << 6 & 4294967295 | P >>> 26), P = O + (E ^ (T | ~I)) + R[15] + 4264355552 & 4294967295, O = T + (P << 10 & 4294967295 | P >>> 22), P = I + (T ^ (O | ~E)) + R[6] + 2734768916 & 4294967295, I = O + (P << 15 & 4294967295 | P >>> 17), P = E + (O ^ (I | ~T)) + R[13] + 1309151649 & 4294967295, E = I + (P << 21 & 4294967295 | P >>> 11), P = T + (I ^ (E | ~O)) + R[4] + 4149444226 & 4294967295, T = E + (P << 6 & 4294967295 | P >>> 26), P = O + (E ^ (T | ~I)) + R[11] + 3174756917 & 4294967295, O = T + (P << 10 & 4294967295 | P >>> 22), P = I + (T ^ (O | ~E)) + R[2] + 718787259 & 4294967295, I = O + (P << 15 & 4294967295 | P >>> 17), P = E + (O ^ (I | ~T)) + R[9] + 3951481745 & 4294967295, x.g[0] = x.g[0] + T & 4294967295, x.g[1] = x.g[1] + (I + (P << 21 & 4294967295 | P >>> 11)) & 4294967295, x.g[2] = x.g[2] + I & 4294967295, x.g[3] = x.g[3] + O & 4294967295;
  }
  r.prototype.u = function(x, T) {
    T === void 0 && (T = x.length);
    for (var E = T - this.blockSize, R = this.B, I = this.h, O = 0; O < T; ) {
      if (I == 0)
        for (; O <= E; )
          i(this, x, O), O += this.blockSize;
      if (typeof x == "string") {
        for (; O < T; )
          if (R[I++] = x.charCodeAt(O++), I == this.blockSize) {
            i(this, R), I = 0;
            break;
          }
      } else
        for (; O < T; )
          if (R[I++] = x[O++], I == this.blockSize) {
            i(this, R), I = 0;
            break;
          }
    }
    this.h = I, this.o += T;
  }, r.prototype.v = function() {
    var x = Array((56 > this.h ? this.blockSize : 2 * this.blockSize) - this.h);
    x[0] = 128;
    for (var T = 1; T < x.length - 8; ++T)
      x[T] = 0;
    var E = 8 * this.o;
    for (T = x.length - 8; T < x.length; ++T)
      x[T] = E & 255, E /= 256;
    for (this.u(x), x = Array(16), T = E = 0; 4 > T; ++T)
      for (var R = 0; 32 > R; R += 8)
        x[E++] = this.g[T] >>> R & 255;
    return x;
  };
  function o(x, T) {
    var E = s;
    return Object.prototype.hasOwnProperty.call(E, x) ? E[x] : E[x] = T(x);
  }
  function a(x, T) {
    this.h = T;
    for (var E = [], R = !0, I = x.length - 1; 0 <= I; I--) {
      var O = x[I] | 0;
      R && O == T || (E[I] = O, R = !1);
    }
    this.g = E;
  }
  var s = {};
  function c(x) {
    return -128 <= x && 128 > x ? o(x, function(T) {
      return new a([T | 0], 0 > T ? -1 : 0);
    }) : new a([x | 0], 0 > x ? -1 : 0);
  }
  function l(x) {
    if (isNaN(x) || !isFinite(x))
      return d;
    if (0 > x)
      return m(l(-x));
    for (var T = [], E = 1, R = 0; x >= E; R++)
      T[R] = x / E | 0, E *= 4294967296;
    return new a(T, 0);
  }
  function u(x, T) {
    if (x.length == 0)
      throw Error("number format error: empty string");
    if (T = T || 10, 2 > T || 36 < T)
      throw Error("radix out of range: " + T);
    if (x.charAt(0) == "-")
      return m(u(x.substring(1), T));
    if (0 <= x.indexOf("-"))
      throw Error('number format error: interior "-" character');
    for (var E = l(Math.pow(T, 8)), R = d, I = 0; I < x.length; I += 8) {
      var O = Math.min(8, x.length - I), P = parseInt(x.substring(I, I + O), T);
      8 > O ? (O = l(Math.pow(T, O)), R = R.j(O).add(l(P))) : (R = R.j(E), R = R.add(l(P)));
    }
    return R;
  }
  var d = c(0), f = c(1), h = c(16777216);
  e = a.prototype, e.m = function() {
    if (g(this))
      return -m(this).m();
    for (var x = 0, T = 1, E = 0; E < this.g.length; E++) {
      var R = this.i(E);
      x += (0 <= R ? R : 4294967296 + R) * T, T *= 4294967296;
    }
    return x;
  }, e.toString = function(x) {
    if (x = x || 10, 2 > x || 36 < x)
      throw Error("radix out of range: " + x);
    if (p(this))
      return "0";
    if (g(this))
      return "-" + m(this).toString(x);
    for (var T = l(Math.pow(x, 6)), E = this, R = ""; ; ) {
      var I = b(E, T).g;
      E = v(E, I.j(T));
      var O = ((0 < E.g.length ? E.g[0] : E.h) >>> 0).toString(x);
      if (E = I, p(E))
        return O + R;
      for (; 6 > O.length; )
        O = "0" + O;
      R = O + R;
    }
  }, e.i = function(x) {
    return 0 > x ? 0 : x < this.g.length ? this.g[x] : this.h;
  };
  function p(x) {
    if (x.h != 0)
      return !1;
    for (var T = 0; T < x.g.length; T++)
      if (x.g[T] != 0)
        return !1;
    return !0;
  }
  function g(x) {
    return x.h == -1;
  }
  e.l = function(x) {
    return x = v(this, x), g(x) ? -1 : p(x) ? 0 : 1;
  };
  function m(x) {
    for (var T = x.g.length, E = [], R = 0; R < T; R++)
      E[R] = ~x.g[R];
    return new a(E, ~x.h).add(f);
  }
  e.abs = function() {
    return g(this) ? m(this) : this;
  }, e.add = function(x) {
    for (var T = Math.max(this.g.length, x.g.length), E = [], R = 0, I = 0; I <= T; I++) {
      var O = R + (this.i(I) & 65535) + (x.i(I) & 65535), P = (O >>> 16) + (this.i(I) >>> 16) + (x.i(I) >>> 16);
      R = P >>> 16, O &= 65535, P &= 65535, E[I] = P << 16 | O;
    }
    return new a(E, E[E.length - 1] & -2147483648 ? -1 : 0);
  };
  function v(x, T) {
    return x.add(m(T));
  }
  e.j = function(x) {
    if (p(this) || p(x))
      return d;
    if (g(this))
      return g(x) ? m(this).j(m(x)) : m(m(this).j(x));
    if (g(x))
      return m(this.j(m(x)));
    if (0 > this.l(h) && 0 > x.l(h))
      return l(this.m() * x.m());
    for (var T = this.g.length + x.g.length, E = [], R = 0; R < 2 * T; R++)
      E[R] = 0;
    for (R = 0; R < this.g.length; R++)
      for (var I = 0; I < x.g.length; I++) {
        var O = this.i(R) >>> 16, P = this.i(R) & 65535, k = x.i(I) >>> 16, L = x.i(I) & 65535;
        E[2 * R + 2 * I] += P * L, y(E, 2 * R + 2 * I), E[2 * R + 2 * I + 1] += O * L, y(E, 2 * R + 2 * I + 1), E[2 * R + 2 * I + 1] += P * k, y(E, 2 * R + 2 * I + 1), E[2 * R + 2 * I + 2] += O * k, y(E, 2 * R + 2 * I + 2);
      }
    for (R = 0; R < T; R++)
      E[R] = E[2 * R + 1] << 16 | E[2 * R];
    for (R = T; R < 2 * T; R++)
      E[R] = 0;
    return new a(E, 0);
  };
  function y(x, T) {
    for (; (x[T] & 65535) != x[T]; )
      x[T + 1] += x[T] >>> 16, x[T] &= 65535, T++;
  }
  function _(x, T) {
    this.g = x, this.h = T;
  }
  function b(x, T) {
    if (p(T))
      throw Error("division by zero");
    if (p(x))
      return new _(d, d);
    if (g(x))
      return T = b(m(x), T), new _(m(T.g), m(T.h));
    if (g(T))
      return T = b(x, m(T)), new _(m(T.g), T.h);
    if (30 < x.g.length) {
      if (g(x) || g(T))
        throw Error("slowDivide_ only works with positive integers.");
      for (var E = f, R = T; 0 >= R.l(x); )
        E = w(E), R = w(R);
      var I = C(E, 1), O = C(R, 1);
      for (R = C(R, 2), E = C(E, 2); !p(R); ) {
        var P = O.add(R);
        0 >= P.l(x) && (I = I.add(E), O = P), R = C(R, 1), E = C(E, 1);
      }
      return T = v(x, I.j(T)), new _(I, T);
    }
    for (I = d; 0 <= x.l(T); ) {
      for (E = Math.max(1, Math.floor(x.m() / T.m())), R = Math.ceil(Math.log(E) / Math.LN2), R = 48 >= R ? 1 : Math.pow(2, R - 48), O = l(E), P = O.j(T); g(P) || 0 < P.l(x); )
        E -= R, O = l(E), P = O.j(T);
      p(O) && (O = f), I = I.add(O), x = v(x, P);
    }
    return new _(I, x);
  }
  e.A = function(x) {
    return b(this, x).h;
  }, e.and = function(x) {
    for (var T = Math.max(this.g.length, x.g.length), E = [], R = 0; R < T; R++)
      E[R] = this.i(R) & x.i(R);
    return new a(E, this.h & x.h);
  }, e.or = function(x) {
    for (var T = Math.max(this.g.length, x.g.length), E = [], R = 0; R < T; R++)
      E[R] = this.i(R) | x.i(R);
    return new a(E, this.h | x.h);
  }, e.xor = function(x) {
    for (var T = Math.max(this.g.length, x.g.length), E = [], R = 0; R < T; R++)
      E[R] = this.i(R) ^ x.i(R);
    return new a(E, this.h ^ x.h);
  };
  function w(x) {
    for (var T = x.g.length + 1, E = [], R = 0; R < T; R++)
      E[R] = x.i(R) << 1 | x.i(R - 1) >>> 31;
    return new a(E, x.h);
  }
  function C(x, T) {
    var E = T >> 5;
    T %= 32;
    for (var R = x.g.length - E, I = [], O = 0; O < R; O++)
      I[O] = 0 < T ? x.i(O + E) >>> T | x.i(O + E + 1) << 32 - T : x.i(O + E);
    return new a(I, x.h);
  }
  r.prototype.digest = r.prototype.v, r.prototype.reset = r.prototype.s, r.prototype.update = r.prototype.u, mq = r, a.prototype.add = a.prototype.add, a.prototype.multiply = a.prototype.j, a.prototype.modulo = a.prototype.A, a.prototype.compare = a.prototype.l, a.prototype.toNumber = a.prototype.m, a.prototype.toString = a.prototype.toString, a.prototype.getBits = a.prototype.i, a.fromNumber = l, a.fromString = u, gu = a;
}).apply(typeof yD < "u" ? yD : typeof self < "u" ? self : typeof window < "u" ? window : {});
var Db = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
/** @license
Copyright The Closure Library Authors.
SPDX-License-Identifier: Apache-2.0
*/
var vq, o0, yq, n_, D$, bq, _q, Sq;
(function() {
  var e, t = typeof Object.defineProperties == "function" ? Object.defineProperty : function(S, M, F) {
    return S == Array.prototype || S == Object.prototype || (S[M] = F.value), S;
  };
  function n(S) {
    S = [typeof globalThis == "object" && globalThis, S, typeof window == "object" && window, typeof self == "object" && self, typeof Db == "object" && Db];
    for (var M = 0; M < S.length; ++M) {
      var F = S[M];
      if (F && F.Math == Math)
        return F;
    }
    throw Error("Cannot find global object");
  }
  var r = n(this);
  function i(S, M) {
    if (M)
      e: {
        var F = r;
        S = S.split(".");
        for (var G = 0; G < S.length - 1; G++) {
          var fe = S[G];
          if (!(fe in F))
            break e;
          F = F[fe];
        }
        S = S[S.length - 1], G = F[S], M = M(G), M != G && M != null && t(F, S, { configurable: !0, writable: !0, value: M });
      }
  }
  function o(S, M) {
    S instanceof String && (S += "");
    var F = 0, G = !1, fe = { next: function() {
      if (!G && F < S.length) {
        var _e = F++;
        return { value: M(_e, S[_e]), done: !1 };
      }
      return G = !0, { done: !0, value: void 0 };
    } };
    return fe[Symbol.iterator] = function() {
      return fe;
    }, fe;
  }
  i("Array.prototype.values", function(S) {
    return S || function() {
      return o(this, function(M, F) {
        return F;
      });
    };
  });
  /** @license
  
   Copyright The Closure Library Authors.
   SPDX-License-Identifier: Apache-2.0
  */
  var a = a || {}, s = this || self;
  function c(S) {
    var M = typeof S;
    return M = M != "object" ? M : S ? Array.isArray(S) ? "array" : M : "null", M == "array" || M == "object" && typeof S.length == "number";
  }
  function l(S) {
    var M = typeof S;
    return M == "object" && S != null || M == "function";
  }
  function u(S, M, F) {
    return S.call.apply(S.bind, arguments);
  }
  function d(S, M, F) {
    if (!S)
      throw Error();
    if (2 < arguments.length) {
      var G = Array.prototype.slice.call(arguments, 2);
      return function() {
        var fe = Array.prototype.slice.call(arguments);
        return Array.prototype.unshift.apply(fe, G), S.apply(M, fe);
      };
    }
    return function() {
      return S.apply(M, arguments);
    };
  }
  function f(S, M, F) {
    return f = Function.prototype.bind && Function.prototype.bind.toString().indexOf("native code") != -1 ? u : d, f.apply(null, arguments);
  }
  function h(S, M) {
    var F = Array.prototype.slice.call(arguments, 1);
    return function() {
      var G = F.slice();
      return G.push.apply(G, arguments), S.apply(this, G);
    };
  }
  function p(S, M) {
    function F() {
    }
    F.prototype = M.prototype, S.aa = M.prototype, S.prototype = new F(), S.prototype.constructor = S, S.Qb = function(G, fe, _e) {
      for (var at = Array(arguments.length - 2), nr = 2; nr < arguments.length; nr++)
        at[nr - 2] = arguments[nr];
      return M.prototype[fe].apply(G, at);
    };
  }
  function g(S) {
    const M = S.length;
    if (0 < M) {
      const F = Array(M);
      for (let G = 0; G < M; G++)
        F[G] = S[G];
      return F;
    }
    return [];
  }
  function m(S, M) {
    for (let F = 1; F < arguments.length; F++) {
      const G = arguments[F];
      if (c(G)) {
        const fe = S.length || 0, _e = G.length || 0;
        S.length = fe + _e;
        for (let at = 0; at < _e; at++)
          S[fe + at] = G[at];
      } else
        S.push(G);
    }
  }
  class v {
    constructor(M, F) {
      this.i = M, this.j = F, this.h = 0, this.g = null;
    }
    get() {
      let M;
      return 0 < this.h ? (this.h--, M = this.g, this.g = M.next, M.next = null) : M = this.i(), M;
    }
  }
  function y(S) {
    return /^[\s\xa0]*$/.test(S);
  }
  function _() {
    var S = s.navigator;
    return S && (S = S.userAgent) ? S : "";
  }
  function b(S) {
    return b[" "](S), S;
  }
  b[" "] = function() {
  };
  var w = _().indexOf("Gecko") != -1 && !(_().toLowerCase().indexOf("webkit") != -1 && _().indexOf("Edge") == -1) && !(_().indexOf("Trident") != -1 || _().indexOf("MSIE") != -1) && _().indexOf("Edge") == -1;
  function C(S, M, F) {
    for (const G in S)
      M.call(F, S[G], G, S);
  }
  function x(S, M) {
    for (const F in S)
      M.call(void 0, S[F], F, S);
  }
  function T(S) {
    const M = {};
    for (const F in S)
      M[F] = S[F];
    return M;
  }
  const E = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
  function R(S, M) {
    let F, G;
    for (let fe = 1; fe < arguments.length; fe++) {
      G = arguments[fe];
      for (F in G)
        S[F] = G[F];
      for (let _e = 0; _e < E.length; _e++)
        F = E[_e], Object.prototype.hasOwnProperty.call(G, F) && (S[F] = G[F]);
    }
  }
  function I(S) {
    var M = 1;
    S = S.split(":");
    const F = [];
    for (; 0 < M && S.length; )
      F.push(S.shift()), M--;
    return S.length && F.push(S.join(":")), F;
  }
  function O(S) {
    s.setTimeout(() => {
      throw S;
    }, 0);
  }
  function P() {
    var S = V;
    let M = null;
    return S.g && (M = S.g, S.g = S.g.next, S.g || (S.h = null), M.next = null), M;
  }
  class k {
    constructor() {
      this.h = this.g = null;
    }
    add(M, F) {
      const G = L.get();
      G.set(M, F), this.h ? this.h.next = G : this.g = G, this.h = G;
    }
  }
  var L = new v(() => new N(), (S) => S.reset());
  class N {
    constructor() {
      this.next = this.g = this.h = null;
    }
    set(M, F) {
      this.h = M, this.g = F, this.next = null;
    }
    reset() {
      this.next = this.g = this.h = null;
    }
  }
  let D, z = !1, V = new k(), B = () => {
    const S = s.Promise.resolve(void 0);
    D = () => {
      S.then(U);
    };
  };
  var U = () => {
    for (var S; S = P(); ) {
      try {
        S.h.call(S.g);
      } catch (F) {
        O(F);
      }
      var M = L;
      M.j(S), 100 > M.h && (M.h++, S.next = M.g, M.g = S);
    }
    z = !1;
  };
  function Q() {
    this.s = this.s, this.C = this.C;
  }
  Q.prototype.s = !1, Q.prototype.ma = function() {
    this.s || (this.s = !0, this.N());
  }, Q.prototype.N = function() {
    if (this.C)
      for (; this.C.length; )
        this.C.shift()();
  };
  function Y(S, M) {
    this.type = S, this.g = this.target = M, this.defaultPrevented = !1;
  }
  Y.prototype.h = function() {
    this.defaultPrevented = !0;
  };
  var q = function() {
    if (!s.addEventListener || !Object.defineProperty)
      return !1;
    var S = !1, M = Object.defineProperty({}, "passive", { get: function() {
      S = !0;
    } });
    try {
      const F = () => {
      };
      s.addEventListener("test", F, M), s.removeEventListener("test", F, M);
    } catch {
    }
    return S;
  }();
  function X(S, M) {
    if (Y.call(this, S ? S.type : ""), this.relatedTarget = this.g = this.target = null, this.button = this.screenY = this.screenX = this.clientY = this.clientX = 0, this.key = "", this.metaKey = this.shiftKey = this.altKey = this.ctrlKey = !1, this.state = null, this.pointerId = 0, this.pointerType = "", this.i = null, S) {
      var F = this.type = S.type, G = S.changedTouches && S.changedTouches.length ? S.changedTouches[0] : null;
      if (this.target = S.target || S.srcElement, this.g = M, M = S.relatedTarget) {
        if (w) {
          e: {
            try {
              b(M.nodeName);
              var fe = !0;
              break e;
            } catch {
            }
            fe = !1;
          }
          fe || (M = null);
        }
      } else
        F == "mouseover" ? M = S.fromElement : F == "mouseout" && (M = S.toElement);
      this.relatedTarget = M, G ? (this.clientX = G.clientX !== void 0 ? G.clientX : G.pageX, this.clientY = G.clientY !== void 0 ? G.clientY : G.pageY, this.screenX = G.screenX || 0, this.screenY = G.screenY || 0) : (this.clientX = S.clientX !== void 0 ? S.clientX : S.pageX, this.clientY = S.clientY !== void 0 ? S.clientY : S.pageY, this.screenX = S.screenX || 0, this.screenY = S.screenY || 0), this.button = S.button, this.key = S.key || "", this.ctrlKey = S.ctrlKey, this.altKey = S.altKey, this.shiftKey = S.shiftKey, this.metaKey = S.metaKey, this.pointerId = S.pointerId || 0, this.pointerType = typeof S.pointerType == "string" ? S.pointerType : ne[S.pointerType] || "", this.state = S.state, this.i = S, S.defaultPrevented && X.aa.h.call(this);
    }
  }
  p(X, Y);
  var ne = { 2: "touch", 3: "pen", 4: "mouse" };
  X.prototype.h = function() {
    X.aa.h.call(this);
    var S = this.i;
    S.preventDefault ? S.preventDefault() : S.returnValue = !1;
  };
  var Z = "closure_listenable_" + (1e6 * Math.random() | 0), J = 0;
  function K(S, M, F, G, fe) {
    this.listener = S, this.proxy = null, this.src = M, this.type = F, this.capture = !!G, this.ha = fe, this.key = ++J, this.da = this.fa = !1;
  }
  function ee(S) {
    S.da = !0, S.listener = null, S.proxy = null, S.src = null, S.ha = null;
  }
  function te(S) {
    this.src = S, this.g = {}, this.h = 0;
  }
  te.prototype.add = function(S, M, F, G, fe) {
    var _e = S.toString();
    S = this.g[_e], S || (S = this.g[_e] = [], this.h++);
    var at = ie(S, M, G, fe);
    return -1 < at ? (M = S[at], F || (M.fa = !1)) : (M = new K(M, this.src, _e, !!G, fe), M.fa = F, S.push(M)), M;
  };
  function H(S, M) {
    var F = M.type;
    if (F in S.g) {
      var G = S.g[F], fe = Array.prototype.indexOf.call(G, M, void 0), _e;
      (_e = 0 <= fe) && Array.prototype.splice.call(G, fe, 1), _e && (ee(M), S.g[F].length == 0 && (delete S.g[F], S.h--));
    }
  }
  function ie(S, M, F, G) {
    for (var fe = 0; fe < S.length; ++fe) {
      var _e = S[fe];
      if (!_e.da && _e.listener == M && _e.capture == !!F && _e.ha == G)
        return fe;
    }
    return -1;
  }
  var W = "closure_lm_" + (1e6 * Math.random() | 0), se = {};
  function le(S, M, F, G, fe) {
    if (G && G.once)
      return pe(S, M, F, G, fe);
    if (Array.isArray(M)) {
      for (var _e = 0; _e < M.length; _e++)
        le(S, M[_e], F, G, fe);
      return null;
    }
    return F = Ve(F), S && S[Z] ? S.K(M, F, l(G) ? !!G.capture : !!G, fe) : ge(S, M, F, !1, G, fe);
  }
  function ge(S, M, F, G, fe, _e) {
    if (!M)
      throw Error("Invalid event type");
    var at = l(fe) ? !!fe.capture : !!fe, nr = be(S);
    if (nr || (S[W] = nr = new te(S)), F = nr.add(M, F, G, at, _e), F.proxy)
      return F;
    if (G = me(), F.proxy = G, G.src = S, G.listener = F, S.addEventListener)
      q || (fe = at), fe === void 0 && (fe = !1), S.addEventListener(M.toString(), G, fe);
    else if (S.attachEvent)
      S.attachEvent(Ae(M.toString()), G);
    else if (S.addListener && S.removeListener)
      S.addListener(G);
    else
      throw Error("addEventListener and attachEvent are unavailable.");
    return F;
  }
  function me() {
    function S(F) {
      return M.call(S.src, S.listener, F);
    }
    const M = ue;
    return S;
  }
  function pe(S, M, F, G, fe) {
    if (Array.isArray(M)) {
      for (var _e = 0; _e < M.length; _e++)
        pe(S, M[_e], F, G, fe);
      return null;
    }
    return F = Ve(F), S && S[Z] ? S.L(M, F, l(G) ? !!G.capture : !!G, fe) : ge(S, M, F, !0, G, fe);
  }
  function Te(S, M, F, G, fe) {
    if (Array.isArray(M))
      for (var _e = 0; _e < M.length; _e++)
        Te(S, M[_e], F, G, fe);
    else
      G = l(G) ? !!G.capture : !!G, F = Ve(F), S && S[Z] ? (S = S.i, M = String(M).toString(), M in S.g && (_e = S.g[M], F = ie(_e, F, G, fe), -1 < F && (ee(_e[F]), Array.prototype.splice.call(_e, F, 1), _e.length == 0 && (delete S.g[M], S.h--)))) : S && (S = be(S)) && (M = S.g[M.toString()], S = -1, M && (S = ie(M, F, G, fe)), (F = -1 < S ? M[S] : null) && de(F));
  }
  function de(S) {
    if (typeof S != "number" && S && !S.da) {
      var M = S.src;
      if (M && M[Z])
        H(M.i, S);
      else {
        var F = S.type, G = S.proxy;
        M.removeEventListener ? M.removeEventListener(F, G, S.capture) : M.detachEvent ? M.detachEvent(Ae(F), G) : M.addListener && M.removeListener && M.removeListener(G), (F = be(M)) ? (H(F, S), F.h == 0 && (F.src = null, M[W] = null)) : ee(S);
      }
    }
  }
  function Ae(S) {
    return S in se ? se[S] : se[S] = "on" + S;
  }
  function ue(S, M) {
    if (S.da)
      S = !0;
    else {
      M = new X(M, this);
      var F = S.listener, G = S.ha || S.src;
      S.fa && de(S), S = F.call(G, M);
    }
    return S;
  }
  function be(S) {
    return S = S[W], S instanceof te ? S : null;
  }
  var Ie = "__closure_events_fn_" + (1e9 * Math.random() >>> 0);
  function Ve(S) {
    return typeof S == "function" ? S : (S[Ie] || (S[Ie] = function(M) {
      return S.handleEvent(M);
    }), S[Ie]);
  }
  function ze() {
    Q.call(this), this.i = new te(this), this.M = this, this.F = null;
  }
  p(ze, Q), ze.prototype[Z] = !0, ze.prototype.removeEventListener = function(S, M, F, G) {
    Te(this, S, M, F, G);
  };
  function Ne(S, M) {
    var F, G = S.F;
    if (G)
      for (F = []; G; G = G.F)
        F.push(G);
    if (S = S.M, G = M.type || M, typeof M == "string")
      M = new Y(M, S);
    else if (M instanceof Y)
      M.target = M.target || S;
    else {
      var fe = M;
      M = new Y(G, S), R(M, fe);
    }
    if (fe = !0, F)
      for (var _e = F.length - 1; 0 <= _e; _e--) {
        var at = M.g = F[_e];
        fe = lt(at, G, !0, M) && fe;
      }
    if (at = M.g = S, fe = lt(at, G, !0, M) && fe, fe = lt(at, G, !1, M) && fe, F)
      for (_e = 0; _e < F.length; _e++)
        at = M.g = F[_e], fe = lt(at, G, !1, M) && fe;
  }
  ze.prototype.N = function() {
    if (ze.aa.N.call(this), this.i) {
      var S = this.i, M;
      for (M in S.g) {
        for (var F = S.g[M], G = 0; G < F.length; G++)
          ee(F[G]);
        delete S.g[M], S.h--;
      }
    }
    this.F = null;
  }, ze.prototype.K = function(S, M, F, G) {
    return this.i.add(String(S), M, !1, F, G);
  }, ze.prototype.L = function(S, M, F, G) {
    return this.i.add(String(S), M, !0, F, G);
  };
  function lt(S, M, F, G) {
    if (M = S.i.g[String(M)], !M)
      return !0;
    M = M.concat();
    for (var fe = !0, _e = 0; _e < M.length; ++_e) {
      var at = M[_e];
      if (at && !at.da && at.capture == F) {
        var nr = at.listener, ji = at.ha || at.src;
        at.fa && H(S.i, at), fe = nr.call(ji, G) !== !1 && fe;
      }
    }
    return fe && !G.defaultPrevented;
  }
  function mt(S, M, F) {
    if (typeof S == "function")
      F && (S = f(S, F));
    else if (S && typeof S.handleEvent == "function")
      S = f(S.handleEvent, S);
    else
      throw Error("Invalid listener argument");
    return 2147483647 < Number(M) ? -1 : s.setTimeout(S, M || 0);
  }
  function vt(S) {
    S.g = mt(() => {
      S.g = null, S.i && (S.i = !1, vt(S));
    }, S.l);
    const M = S.h;
    S.h = null, S.m.apply(null, M);
  }
  class ke extends Q {
    constructor(M, F) {
      super(), this.m = M, this.l = F, this.h = null, this.i = !1, this.g = null;
    }
    j(M) {
      this.h = arguments, this.g ? this.i = !0 : vt(this);
    }
    N() {
      super.N(), this.g && (s.clearTimeout(this.g), this.g = null, this.i = !1, this.h = null);
    }
  }
  function xe(S) {
    Q.call(this), this.h = S, this.g = {};
  }
  p(xe, Q);
  var Re = [];
  function yt(S) {
    C(S.g, function(M, F) {
      this.g.hasOwnProperty(F) && de(M);
    }, S), S.g = {};
  }
  xe.prototype.N = function() {
    xe.aa.N.call(this), yt(this);
  }, xe.prototype.handleEvent = function() {
    throw Error("EventHandler.handleEvent not implemented");
  };
  var Pt = s.JSON.stringify, _t = s.JSON.parse, St = class {
    stringify(S) {
      return s.JSON.stringify(S, void 0);
    }
    parse(S) {
      return s.JSON.parse(S, void 0);
    }
  };
  function ft() {
  }
  ft.prototype.h = null;
  function kn(S) {
    return S.h || (S.h = S.i());
  }
  function Dt() {
  }
  var nt = { OPEN: "a", kb: "b", Ja: "c", wb: "d" };
  function Be() {
    Y.call(this, "d");
  }
  p(Be, Y);
  function st() {
    Y.call(this, "c");
  }
  p(st, Y);
  var pt = {}, Et = null;
  function Ke() {
    return Et = Et || new ze();
  }
  pt.La = "serverreachability";
  function rt(S) {
    Y.call(this, pt.La, S);
  }
  p(rt, Y);
  function Le(S) {
    const M = Ke();
    Ne(M, new rt(M));
  }
  pt.STAT_EVENT = "statevent";
  function Xt(S, M) {
    Y.call(this, pt.STAT_EVENT, S), this.stat = M;
  }
  p(Xt, Y);
  function Ht(S) {
    const M = Ke();
    Ne(M, new Xt(M, S));
  }
  pt.Ma = "timingevent";
  function Ue(S, M) {
    Y.call(this, pt.Ma, S), this.size = M;
  }
  p(Ue, Y);
  function We(S, M) {
    if (typeof S != "function")
      throw Error("Fn must not be null and must be a function");
    return s.setTimeout(function() {
      S();
    }, M);
  }
  function ct() {
    this.g = !0;
  }
  ct.prototype.xa = function() {
    this.g = !1;
  };
  function ht(S, M, F, G, fe, _e) {
    S.info(function() {
      if (S.g)
        if (_e)
          for (var at = "", nr = _e.split("&"), ji = 0; ji < nr.length; ji++) {
            var Nn = nr[ji].split("=");
            if (1 < Nn.length) {
              var Ji = Nn[0];
              Nn = Nn[1];
              var Zi = Ji.split("_");
              at = 2 <= Zi.length && Zi[1] == "type" ? at + (Ji + "=" + Nn + "&") : at + (Ji + "=redacted&");
            }
          }
        else
          at = null;
      else
        at = _e;
      return "XMLHTTP REQ (" + G + ") [attempt " + fe + "]: " + M + `
` + F + `
` + at;
    });
  }
  function Rt(S, M, F, G, fe, _e, at) {
    S.info(function() {
      return "XMLHTTP RESP (" + G + ") [ attempt " + fe + "]: " + M + `
` + F + `
` + _e + " " + at;
    });
  }
  function Ft(S, M, F, G) {
    S.info(function() {
      return "XMLHTTP TEXT (" + M + "): " + Se(S, F) + (G ? " " + G : "");
    });
  }
  function re(S, M) {
    S.info(function() {
      return "TIMEOUT: " + M;
    });
  }
  ct.prototype.info = function() {
  };
  function Se(S, M) {
    if (!S.g)
      return M;
    if (!M)
      return null;
    try {
      var F = JSON.parse(M);
      if (F) {
        for (S = 0; S < F.length; S++)
          if (Array.isArray(F[S])) {
            var G = F[S];
            if (!(2 > G.length)) {
              var fe = G[1];
              if (Array.isArray(fe) && !(1 > fe.length)) {
                var _e = fe[0];
                if (_e != "noop" && _e != "stop" && _e != "close")
                  for (var at = 1; at < fe.length; at++)
                    fe[at] = "";
              }
            }
          }
      }
      return Pt(F);
    } catch {
      return M;
    }
  }
  var De = { NO_ERROR: 0, gb: 1, tb: 2, sb: 3, nb: 4, rb: 5, ub: 6, Ia: 7, TIMEOUT: 8, xb: 9 }, Ye = { lb: "complete", Hb: "success", Ja: "error", Ia: "abort", zb: "ready", Ab: "readystatechange", TIMEOUT: "timeout", vb: "incrementaldata", yb: "progress", ob: "downloadprogress", Pb: "uploadprogress" }, $t;
  function Ct() {
  }
  p(Ct, ft), Ct.prototype.g = function() {
    return new XMLHttpRequest();
  }, Ct.prototype.i = function() {
    return {};
  }, $t = new Ct();
  function ut(S, M, F, G) {
    this.j = S, this.i = M, this.l = F, this.R = G || 1, this.U = new xe(this), this.I = 45e3, this.H = null, this.o = !1, this.m = this.A = this.v = this.L = this.F = this.S = this.B = null, this.D = [], this.g = null, this.C = 0, this.s = this.u = null, this.X = -1, this.J = !1, this.O = 0, this.M = null, this.W = this.K = this.T = this.P = !1, this.h = new Mt();
  }
  function Mt() {
    this.i = null, this.g = "", this.h = !1;
  }
  var Xe = {}, je = {};
  function Ze(S, M, F) {
    S.L = 1, S.v = ri(Zt(M)), S.m = F, S.P = !0, dt(S, null);
  }
  function dt(S, M) {
    S.F = Date.now(), Ot(S), S.A = Zt(S.v);
    var F = S.A, G = S.R;
    Array.isArray(G) || (G = [String(G)]), uh(F.i, "t", G), S.C = 0, F = S.j.J, S.h = new Mt(), S.g = fN(S.j, F ? M : null, !S.m), 0 < S.O && (S.M = new ke(f(S.Y, S, S.g), S.O)), M = S.U, F = S.g, G = S.ca;
    var fe = "readystatechange";
    Array.isArray(fe) || (fe && (Re[0] = fe.toString()), fe = Re);
    for (var _e = 0; _e < fe.length; _e++) {
      var at = le(F, fe[_e], G || M.handleEvent, !1, M.h || M);
      if (!at)
        break;
      M.g[at.key] = at;
    }
    M = S.H ? T(S.H) : {}, S.m ? (S.u || (S.u = "POST"), M["Content-Type"] = "application/x-www-form-urlencoded", S.g.ea(
      S.A,
      S.u,
      S.m,
      M
    )) : (S.u = "GET", S.g.ea(S.A, S.u, null, M)), Le(), ht(S.i, S.u, S.A, S.l, S.R, S.m);
  }
  ut.prototype.ca = function(S) {
    S = S.target;
    const M = this.M;
    M && Oc(S) == 3 ? M.j() : this.Y(S);
  }, ut.prototype.Y = function(S) {
    try {
      if (S == this.g)
        e: {
          const Zi = Oc(this.g);
          var M = this.g.Ba();
          const fh = this.g.Z();
          if (!(3 > Zi) && (Zi != 3 || this.g && (this.h.h || this.g.oa() || tN(this.g)))) {
            this.J || Zi != 4 || M == 7 || (M == 8 || 0 >= fh ? Le(3) : Le(2)), mr(this);
            var F = this.g.Z();
            this.X = F;
            t:
              if (Ge(this)) {
                var G = tN(this.g);
                S = "";
                var fe = G.length, _e = Oc(this.g) == 4;
                if (!this.h.i) {
                  if (typeof TextDecoder > "u") {
                    Tn(this), Kn(this);
                    var at = "";
                    break t;
                  }
                  this.h.i = new s.TextDecoder();
                }
                for (M = 0; M < fe; M++)
                  this.h.h = !0, S += this.h.i.decode(G[M], { stream: !(_e && M == fe - 1) });
                G.length = 0, this.h.g += S, this.C = 0, at = this.h.g;
              } else
                at = this.g.oa();
            if (this.o = F == 200, Rt(this.i, this.u, this.A, this.l, this.R, Zi, F), this.o) {
              if (this.T && !this.K) {
                t: {
                  if (this.g) {
                    var nr, ji = this.g;
                    if ((nr = ji.g ? ji.g.getResponseHeader("X-HTTP-Initial-Response") : null) && !y(nr)) {
                      var Nn = nr;
                      break t;
                    }
                  }
                  Nn = null;
                }
                if (F = Nn)
                  Ft(this.i, this.l, F, "Initial handshake response via X-HTTP-Initial-Response"), this.K = !0, Vr(this, F);
                else {
                  this.o = !1, this.s = 3, Ht(12), Tn(this), Kn(this);
                  break e;
                }
              }
              if (this.P) {
                F = !0;
                let rs;
                for (; !this.J && this.C < at.length; )
                  if (rs = Lt(this, at), rs == je) {
                    Zi == 4 && (this.s = 4, Ht(14), F = !1), Ft(this.i, this.l, null, "[Incomplete Response]");
                    break;
                  } else if (rs == Xe) {
                    this.s = 4, Ht(15), Ft(this.i, this.l, at, "[Invalid Chunk]"), F = !1;
                    break;
                  } else
                    Ft(this.i, this.l, rs, null), Vr(this, rs);
                if (Ge(this) && this.C != 0 && (this.h.g = this.h.g.slice(this.C), this.C = 0), Zi != 4 || at.length != 0 || this.h.h || (this.s = 1, Ht(16), F = !1), this.o = this.o && F, !F)
                  Ft(this.i, this.l, at, "[Invalid Chunked Response]"), Tn(this), Kn(this);
                else if (0 < at.length && !this.W) {
                  this.W = !0;
                  var Ji = this.j;
                  Ji.g == this && Ji.ba && !Ji.M && (Ji.j.info("Great, no buffering proxy detected. Bytes received: " + at.length), l5(Ji), Ji.M = !0, Ht(11));
                }
              } else
                Ft(this.i, this.l, at, null), Vr(this, at);
              Zi == 4 && Tn(this), this.o && !this.J && (Zi == 4 ? cN(this.j, this) : (this.o = !1, Ot(this)));
            } else
              cle(this.g), F == 400 && 0 < at.indexOf("Unknown SID") ? (this.s = 3, Ht(12)) : (this.s = 0, Ht(13)), Tn(this), Kn(this);
          }
        }
    } catch {
    } finally {
    }
  };
  function Ge(S) {
    return S.g ? S.u == "GET" && S.L != 2 && S.j.Ca : !1;
  }
  function Lt(S, M) {
    var F = S.C, G = M.indexOf(`
`, F);
    return G == -1 ? je : (F = Number(M.substring(F, G)), isNaN(F) ? Xe : (G += 1, G + F > M.length ? je : (M = M.slice(G, G + F), S.C = G + F, M)));
  }
  ut.prototype.cancel = function() {
    this.J = !0, Tn(this);
  };
  function Ot(S) {
    S.S = Date.now() + S.I, xn(S, S.I);
  }
  function xn(S, M) {
    if (S.B != null)
      throw Error("WatchDog timer not null");
    S.B = We(f(S.ba, S), M);
  }
  function mr(S) {
    S.B && (s.clearTimeout(S.B), S.B = null);
  }
  ut.prototype.ba = function() {
    this.B = null;
    const S = Date.now();
    0 <= S - this.S ? (re(this.i, this.A), this.L != 2 && (Le(), Ht(17)), Tn(this), this.s = 2, Kn(this)) : xn(this, this.S - S);
  };
  function Kn(S) {
    S.j.G == 0 || S.J || cN(S.j, S);
  }
  function Tn(S) {
    mr(S);
    var M = S.M;
    M && typeof M.ma == "function" && M.ma(), S.M = null, yt(S.U), S.g && (M = S.g, S.g = null, M.abort(), M.ma());
  }
  function Vr(S, M) {
    try {
      var F = S.j;
      if (F.G != 0 && (F.g == S || Tr(F.h, S))) {
        if (!S.K && Tr(F.h, S) && F.G == 3) {
          try {
            var G = F.Da.g.parse(M);
          } catch {
            G = null;
          }
          if (Array.isArray(G) && G.length == 3) {
            var fe = G;
            if (fe[0] == 0) {
              e:
                if (!F.u) {
                  if (F.g)
                    if (F.g.F + 3e3 < S.F)
                      Rb(F), $b(F);
                    else
                      break e;
                  c5(F), Ht(18);
                }
            } else
              F.za = fe[1], 0 < F.za - F.T && 37500 > fe[2] && F.F && F.v == 0 && !F.C && (F.C = We(f(F.Za, F), 6e3));
            if (1 >= Xr(F.h) && F.ca) {
              try {
                F.ca();
              } catch {
              }
              F.ca = void 0;
            }
          } else
            pd(F, 11);
        } else if ((S.K || F.g == S) && Rb(F), !y(M))
          for (fe = F.Da.g.parse(M), M = 0; M < fe.length; M++) {
            let Nn = fe[M];
            if (F.T = Nn[0], Nn = Nn[1], F.G == 2)
              if (Nn[0] == "c") {
                F.K = Nn[1], F.ia = Nn[2];
                const Ji = Nn[3];
                Ji != null && (F.la = Ji, F.j.info("VER=" + F.la));
                const Zi = Nn[4];
                Zi != null && (F.Aa = Zi, F.j.info("SVER=" + F.Aa));
                const fh = Nn[5];
                fh != null && typeof fh == "number" && 0 < fh && (G = 1.5 * fh, F.L = G, F.j.info("backChannelRequestTimeoutMs_=" + G)), G = F;
                const rs = S.g;
                if (rs) {
                  const Ob = rs.g ? rs.g.getResponseHeader("X-Client-Wire-Protocol") : null;
                  if (Ob) {
                    var _e = G.h;
                    _e.g || Ob.indexOf("spdy") == -1 && Ob.indexOf("quic") == -1 && Ob.indexOf("h2") == -1 || (_e.j = _e.l, _e.g = /* @__PURE__ */ new Set(), _e.h && (Qr(_e, _e.h), _e.h = null));
                  }
                  if (G.D) {
                    const u5 = rs.g ? rs.g.getResponseHeader("X-HTTP-Session-Id") : null;
                    u5 && (G.ya = u5, un(G.I, G.D, u5));
                  }
                }
                F.G = 3, F.l && F.l.ua(), F.ba && (F.R = Date.now() - S.F, F.j.info("Handshake RTT: " + F.R + "ms")), G = F;
                var at = S;
                if (G.qa = dN(G, G.J ? G.ia : null, G.W), at.K) {
                  Ti(G.h, at);
                  var nr = at, ji = G.L;
                  ji && (nr.I = ji), nr.B && (mr(nr), Ot(nr)), G.g = at;
                } else
                  aN(G);
                0 < F.i.length && Ab(F);
              } else
                Nn[0] != "stop" && Nn[0] != "close" || pd(F, 7);
            else
              F.G == 3 && (Nn[0] == "stop" || Nn[0] == "close" ? Nn[0] == "stop" ? pd(F, 7) : s5(F) : Nn[0] != "noop" && F.l && F.l.ta(Nn), F.v = 0);
          }
      }
      Le(4);
    } catch {
    }
  }
  var Yr = class {
    constructor(S, M) {
      this.g = S, this.map = M;
    }
  };
  function vr(S) {
    this.l = S || 10, s.PerformanceNavigationTiming ? (S = s.performance.getEntriesByType("navigation"), S = 0 < S.length && (S[0].nextHopProtocol == "hq" || S[0].nextHopProtocol == "h2")) : S = !!(s.chrome && s.chrome.loadTimes && s.chrome.loadTimes() && s.chrome.loadTimes().wasFetchedViaSpdy), this.j = S ? this.l : 1, this.g = null, 1 < this.j && (this.g = /* @__PURE__ */ new Set()), this.h = null, this.i = [];
  }
  function Cr(S) {
    return S.h ? !0 : S.g ? S.g.size >= S.j : !1;
  }
  function Xr(S) {
    return S.h ? 1 : S.g ? S.g.size : 0;
  }
  function Tr(S, M) {
    return S.h ? S.h == M : S.g ? S.g.has(M) : !1;
  }
  function Qr(S, M) {
    S.g ? S.g.add(M) : S.h = M;
  }
  function Ti(S, M) {
    S.h && S.h == M ? S.h = null : S.g && S.g.has(M) && S.g.delete(M);
  }
  vr.prototype.cancel = function() {
    if (this.i = Ii(this), this.h)
      this.h.cancel(), this.h = null;
    else if (this.g && this.g.size !== 0) {
      for (const S of this.g.values())
        S.cancel();
      this.g.clear();
    }
  };
  function Ii(S) {
    if (S.h != null)
      return S.i.concat(S.h.D);
    if (S.g != null && S.g.size !== 0) {
      let M = S.i;
      for (const F of S.g.values())
        M = M.concat(F.D);
      return M;
    }
    return g(S.i);
  }
  function Ni(S) {
    if (S.V && typeof S.V == "function")
      return S.V();
    if (typeof Map < "u" && S instanceof Map || typeof Set < "u" && S instanceof Set)
      return Array.from(S.values());
    if (typeof S == "string")
      return S.split("");
    if (c(S)) {
      for (var M = [], F = S.length, G = 0; G < F; G++)
        M.push(S[G]);
      return M;
    }
    M = [], F = 0;
    for (G in S)
      M[F++] = S[G];
    return M;
  }
  function tr(S) {
    if (S.na && typeof S.na == "function")
      return S.na();
    if (!S.V || typeof S.V != "function") {
      if (typeof Map < "u" && S instanceof Map)
        return Array.from(S.keys());
      if (!(typeof Set < "u" && S instanceof Set)) {
        if (c(S) || typeof S == "string") {
          var M = [];
          S = S.length;
          for (var F = 0; F < S; F++)
            M.push(F);
          return M;
        }
        M = [], F = 0;
        for (const G in S)
          M[F++] = G;
        return M;
      }
    }
  }
  function Qt(S, M) {
    if (S.forEach && typeof S.forEach == "function")
      S.forEach(M, void 0);
    else if (c(S) || typeof S == "string")
      Array.prototype.forEach.call(S, M, void 0);
    else
      for (var F = tr(S), G = Ni(S), fe = G.length, _e = 0; _e < fe; _e++)
        M.call(void 0, G[_e], F && F[_e], S);
  }
  var Bt = RegExp("^(?:([^:/?#.]+):)?(?://(?:([^\\\\/?#]*)@)?([^\\\\/?#]*?)(?::([0-9]+))?(?=[\\\\/?#]|$))?([^?#]+)?(?:\\?([^#]*))?(?:#([\\s\\S]*))?$");
  function nn(S, M) {
    if (S) {
      S = S.split("&");
      for (var F = 0; F < S.length; F++) {
        var G = S[F].indexOf("="), fe = null;
        if (0 <= G) {
          var _e = S[F].substring(0, G);
          fe = S[F].substring(G + 1);
        } else
          _e = S[F];
        M(_e, fe ? decodeURIComponent(fe.replace(/\+/g, " ")) : "");
      }
    }
  }
  function Jt(S) {
    if (this.g = this.o = this.j = "", this.s = null, this.m = this.l = "", this.h = !1, S instanceof Jt) {
      this.h = S.h, yn(this, S.j), this.o = S.o, this.g = S.g, Ir(this, S.s), this.l = S.l;
      var M = S.i, F = new Bo();
      F.i = M.i, M.g && (F.g = new Map(M.g), F.h = M.h), mi(this, F), this.m = S.m;
    } else
      S && (M = String(S).match(Bt)) ? (this.h = !1, yn(this, M[1] || "", !0), this.o = ii(M[2] || ""), this.g = ii(M[3] || "", !0), Ir(this, M[4]), this.l = ii(M[5] || "", !0), mi(this, M[6] || "", !0), this.m = ii(M[7] || "")) : (this.h = !1, this.i = new Bo(null, this.h));
  }
  Jt.prototype.toString = function() {
    var S = [], M = this.j;
    M && S.push(Qi(M, yo, !0), ":");
    var F = this.g;
    return (F || M == "file") && (S.push("//"), (M = this.o) && S.push(Qi(M, yo, !0), "@"), S.push(encodeURIComponent(String(F)).replace(/%25([0-9a-fA-F]{2})/g, "%$1")), F = this.s, F != null && S.push(":", String(F))), (F = this.l) && (this.g && F.charAt(0) != "/" && S.push("/"), S.push(Qi(F, F.charAt(0) == "/" ? Vo : bo, !0))), (F = this.i.toString()) && S.push("?", F), (F = this.m) && S.push("#", Qi(F, Rl)), S.join("");
  };
  function Zt(S) {
    return new Jt(S);
  }
  function yn(S, M, F) {
    S.j = F ? ii(M, !0) : M, S.j && (S.j = S.j.replace(/:$/, ""));
  }
  function Ir(S, M) {
    if (M) {
      if (M = Number(M), isNaN(M) || 0 > M)
        throw Error("Bad port number " + M);
      S.s = M;
    } else
      S.s = null;
  }
  function mi(S, M, F) {
    M instanceof Bo ? (S.i = M, vm(S.i, S.h)) : (F || (M = Qi(M, lh)), S.i = new Bo(M, S.h));
  }
  function un(S, M, F) {
    S.i.set(M, F);
  }
  function ri(S) {
    return un(S, "zx", Math.floor(2147483648 * Math.random()).toString(36) + Math.abs(Math.floor(2147483648 * Math.random()) ^ Date.now()).toString(36)), S;
  }
  function ii(S, M) {
    return S ? M ? decodeURI(S.replace(/%25/g, "%2525")) : decodeURIComponent(S) : "";
  }
  function Qi(S, M, F) {
    return typeof S == "string" ? (S = encodeURI(S).replace(M, Fo), F && (S = S.replace(/%25([0-9a-fA-F]{2})/g, "%$1")), S) : null;
  }
  function Fo(S) {
    return S = S.charCodeAt(0), "%" + (S >> 4 & 15).toString(16) + (S & 15).toString(16);
  }
  var yo = /[#\/\?@]/g, bo = /[#\?:]/g, Vo = /[#\?]/g, lh = /[#\?@]/g, Rl = /#/g;
  function Bo(S, M) {
    this.h = this.g = null, this.i = S || null, this.j = !!M;
  }
  function Di(S) {
    S.g || (S.g = /* @__PURE__ */ new Map(), S.h = 0, S.i && nn(S.i, function(M, F) {
      S.add(decodeURIComponent(M.replace(/\+/g, " ")), F);
    }));
  }
  e = Bo.prototype, e.add = function(S, M) {
    Di(this), this.i = null, S = Fs(this, S);
    var F = this.g.get(S);
    return F || this.g.set(S, F = []), F.push(M), this.h += 1, this;
  };
  function Pl(S, M) {
    Di(S), M = Fs(S, M), S.g.has(M) && (S.i = null, S.h -= S.g.get(M).length, S.g.delete(M));
  }
  function gd(S, M) {
    return Di(S), M = Fs(S, M), S.g.has(M);
  }
  e.forEach = function(S, M) {
    Di(this), this.g.forEach(function(F, G) {
      F.forEach(function(fe) {
        S.call(M, fe, G, this);
      }, this);
    }, this);
  }, e.na = function() {
    Di(this);
    const S = Array.from(this.g.values()), M = Array.from(this.g.keys()), F = [];
    for (let G = 0; G < M.length; G++) {
      const fe = S[G];
      for (let _e = 0; _e < fe.length; _e++)
        F.push(M[G]);
    }
    return F;
  }, e.V = function(S) {
    Di(this);
    let M = [];
    if (typeof S == "string")
      gd(this, S) && (M = M.concat(this.g.get(Fs(this, S))));
    else {
      S = Array.from(this.g.values());
      for (let F = 0; F < S.length; F++)
        M = M.concat(S[F]);
    }
    return M;
  }, e.set = function(S, M) {
    return Di(this), this.i = null, S = Fs(this, S), gd(this, S) && (this.h -= this.g.get(S).length), this.g.set(S, [M]), this.h += 1, this;
  }, e.get = function(S, M) {
    return S ? (S = this.V(S), 0 < S.length ? String(S[0]) : M) : M;
  };
  function uh(S, M, F) {
    Pl(S, M), 0 < F.length && (S.i = null, S.g.set(Fs(S, M), g(F)), S.h += F.length);
  }
  e.toString = function() {
    if (this.i)
      return this.i;
    if (!this.g)
      return "";
    const S = [], M = Array.from(this.g.keys());
    for (var F = 0; F < M.length; F++) {
      var G = M[F];
      const _e = encodeURIComponent(String(G)), at = this.V(G);
      for (G = 0; G < at.length; G++) {
        var fe = _e;
        at[G] !== "" && (fe += "=" + encodeURIComponent(String(at[G]))), S.push(fe);
      }
    }
    return this.i = S.join("&");
  };
  function Fs(S, M) {
    return M = String(M), S.j && (M = M.toLowerCase()), M;
  }
  function vm(S, M) {
    M && !S.j && (Di(S), S.i = null, S.g.forEach(function(F, G) {
      var fe = G.toLowerCase();
      G != fe && (Pl(this, G), uh(this, fe, F));
    }, S)), S.j = M;
  }
  function wt(S, M) {
    const F = new ct();
    if (s.Image) {
      const G = new Image();
      G.onload = h(On, F, "TestLoadImage: loaded", !0, M, G), G.onerror = h(On, F, "TestLoadImage: error", !1, M, G), G.onabort = h(On, F, "TestLoadImage: abort", !1, M, G), G.ontimeout = h(On, F, "TestLoadImage: timeout", !1, M, G), s.setTimeout(function() {
        G.ontimeout && G.ontimeout();
      }, 1e4), G.src = S;
    } else
      M(!1);
  }
  function zt(S, M) {
    const F = new ct(), G = new AbortController(), fe = setTimeout(() => {
      G.abort(), On(F, "TestPingServer: timeout", !1, M);
    }, 1e4);
    fetch(S, { signal: G.signal }).then((_e) => {
      clearTimeout(fe), _e.ok ? On(F, "TestPingServer: ok", !0, M) : On(F, "TestPingServer: server error", !1, M);
    }).catch(() => {
      clearTimeout(fe), On(F, "TestPingServer: error", !1, M);
    });
  }
  function On(S, M, F, G, fe) {
    try {
      fe && (fe.onload = null, fe.onerror = null, fe.onabort = null, fe.ontimeout = null), G(F);
    } catch {
    }
  }
  function Jr() {
    this.g = new St();
  }
  function $r(S, M, F) {
    const G = F || "";
    try {
      Qt(S, function(fe, _e) {
        let at = fe;
        l(fe) && (at = Pt(fe)), M.push(G + _e + "=" + encodeURIComponent(at));
      });
    } catch (fe) {
      throw M.push(G + "type=" + encodeURIComponent("_badmap")), fe;
    }
  }
  function Pc(S) {
    this.l = S.Ub || null, this.j = S.eb || !1;
  }
  p(Pc, ft), Pc.prototype.g = function() {
    return new Ol(this.l, this.j);
  }, Pc.prototype.i = function(S) {
    return function() {
      return S;
    };
  }({});
  function Ol(S, M) {
    ze.call(this), this.D = S, this.o = M, this.m = void 0, this.status = this.readyState = 0, this.responseType = this.responseText = this.response = this.statusText = "", this.onreadystatechange = null, this.u = new Headers(), this.h = null, this.B = "GET", this.A = "", this.g = !1, this.v = this.j = this.l = null;
  }
  p(Ol, ze), e = Ol.prototype, e.open = function(S, M) {
    if (this.readyState != 0)
      throw this.abort(), Error("Error reopening a connection");
    this.B = S, this.A = M, this.readyState = 1, bm(this);
  }, e.send = function(S) {
    if (this.readyState != 1)
      throw this.abort(), Error("need to call open() first. ");
    this.g = !0;
    const M = { headers: this.u, method: this.B, credentials: this.m, cache: void 0 };
    S && (M.body = S), (this.D || s).fetch(new Request(this.A, M)).then(this.Sa.bind(this), this.ga.bind(this));
  }, e.abort = function() {
    this.response = this.responseText = "", this.u = new Headers(), this.status = 0, this.j && this.j.cancel("Request was aborted.").catch(() => {
    }), 1 <= this.readyState && this.g && this.readyState != 4 && (this.g = !1, Vs(this)), this.readyState = 0;
  }, e.Sa = function(S) {
    if (this.g && (this.l = S, this.h || (this.status = this.l.status, this.statusText = this.l.statusText, this.h = S.headers, this.readyState = 2, bm(this)), this.g && (this.readyState = 3, bm(this), this.g)))
      if (this.responseType === "arraybuffer")
        S.arrayBuffer().then(this.Qa.bind(this), this.ga.bind(this));
      else if (typeof s.ReadableStream < "u" && "body" in S) {
        if (this.j = S.body.getReader(), this.o) {
          if (this.responseType)
            throw Error('responseType must be empty for "streamBinaryChunks" mode responses.');
          this.response = [];
        } else
          this.response = this.responseText = "", this.v = new TextDecoder();
        ym(this);
      } else
        S.text().then(this.Ra.bind(this), this.ga.bind(this));
  };
  function ym(S) {
    S.j.read().then(S.Pa.bind(S)).catch(S.ga.bind(S));
  }
  e.Pa = function(S) {
    if (this.g) {
      if (this.o && S.value)
        this.response.push(S.value);
      else if (!this.o) {
        var M = S.value ? S.value : new Uint8Array(0);
        (M = this.v.decode(M, { stream: !S.done })) && (this.response = this.responseText += M);
      }
      S.done ? Vs(this) : bm(this), this.readyState == 3 && ym(this);
    }
  }, e.Ra = function(S) {
    this.g && (this.response = this.responseText = S, Vs(this));
  }, e.Qa = function(S) {
    this.g && (this.response = S, Vs(this));
  }, e.ga = function() {
    this.g && Vs(this);
  };
  function Vs(S) {
    S.readyState = 4, S.l = null, S.j = null, S.v = null, bm(S);
  }
  e.setRequestHeader = function(S, M) {
    this.u.append(S, M);
  }, e.getResponseHeader = function(S) {
    return this.h && this.h.get(S.toLowerCase()) || "";
  }, e.getAllResponseHeaders = function() {
    if (!this.h)
      return "";
    const S = [], M = this.h.entries();
    for (var F = M.next(); !F.done; )
      F = F.value, S.push(F[0] + ": " + F[1]), F = M.next();
    return S.join(`\r
`);
  };
  function bm(S) {
    S.onreadystatechange && S.onreadystatechange.call(S);
  }
  Object.defineProperty(Ol.prototype, "withCredentials", { get: function() {
    return this.m === "include";
  }, set: function(S) {
    this.m = S ? "include" : "same-origin";
  } });
  function X4(S) {
    let M = "";
    return C(S, function(F, G) {
      M += G, M += ":", M += F, M += `\r
`;
    }), M;
  }
  function a5(S, M, F) {
    e: {
      for (G in F) {
        var G = !1;
        break e;
      }
      G = !0;
    }
    G || (F = X4(F), typeof S == "string" ? F != null && encodeURIComponent(String(F)) : un(S, M, F));
  }
  function Br(S) {
    ze.call(this), this.headers = /* @__PURE__ */ new Map(), this.o = S || null, this.h = !1, this.v = this.g = null, this.D = "", this.m = 0, this.l = "", this.j = this.B = this.u = this.A = !1, this.I = null, this.H = "", this.J = !1;
  }
  p(Br, ze);
  var ale = /^https?$/i, sle = ["POST", "PUT"];
  e = Br.prototype, e.Ha = function(S) {
    this.J = S;
  }, e.ea = function(S, M, F, G) {
    if (this.g)
      throw Error("[goog.net.XhrIo] Object is active with another request=" + this.D + "; newUri=" + S);
    M = M ? M.toUpperCase() : "GET", this.D = S, this.l = "", this.m = 0, this.A = !1, this.h = !0, this.g = this.o ? this.o.g() : $t.g(), this.v = this.o ? kn(this.o) : kn($t), this.g.onreadystatechange = f(this.Ea, this);
    try {
      this.B = !0, this.g.open(M, String(S), !0), this.B = !1;
    } catch (_e) {
      Q4(this, _e);
      return;
    }
    if (S = F || "", F = new Map(this.headers), G)
      if (Object.getPrototypeOf(G) === Object.prototype)
        for (var fe in G)
          F.set(fe, G[fe]);
      else if (typeof G.keys == "function" && typeof G.get == "function")
        for (const _e of G.keys())
          F.set(_e, G.get(_e));
      else
        throw Error("Unknown input type for opt_headers: " + String(G));
    G = Array.from(F.keys()).find((_e) => _e.toLowerCase() == "content-type"), fe = s.FormData && S instanceof s.FormData, !(0 <= Array.prototype.indexOf.call(sle, M, void 0)) || G || fe || F.set("Content-Type", "application/x-www-form-urlencoded;charset=utf-8");
    for (const [_e, at] of F)
      this.g.setRequestHeader(_e, at);
    this.H && (this.g.responseType = this.H), "withCredentials" in this.g && this.g.withCredentials !== this.J && (this.g.withCredentials = this.J);
    try {
      eN(this), this.u = !0, this.g.send(S), this.u = !1;
    } catch (_e) {
      Q4(this, _e);
    }
  };
  function Q4(S, M) {
    S.h = !1, S.g && (S.j = !0, S.g.abort(), S.j = !1), S.l = M, S.m = 5, J4(S), Ib(S);
  }
  function J4(S) {
    S.A || (S.A = !0, Ne(S, "complete"), Ne(S, "error"));
  }
  e.abort = function(S) {
    this.g && this.h && (this.h = !1, this.j = !0, this.g.abort(), this.j = !1, this.m = S || 7, Ne(this, "complete"), Ne(this, "abort"), Ib(this));
  }, e.N = function() {
    this.g && (this.h && (this.h = !1, this.j = !0, this.g.abort(), this.j = !1), Ib(this, !0)), Br.aa.N.call(this);
  }, e.Ea = function() {
    this.s || (this.B || this.u || this.j ? Z4(this) : this.bb());
  }, e.bb = function() {
    Z4(this);
  };
  function Z4(S) {
    if (S.h && typeof a < "u" && (!S.v[1] || Oc(S) != 4 || S.Z() != 2)) {
      if (S.u && Oc(S) == 4)
        mt(S.Ea, 0, S);
      else if (Ne(S, "readystatechange"), Oc(S) == 4) {
        S.h = !1;
        try {
          const at = S.Z();
          e:
            switch (at) {
              case 200:
              case 201:
              case 202:
              case 204:
              case 206:
              case 304:
              case 1223:
                var M = !0;
                break e;
              default:
                M = !1;
            }
          var F;
          if (!(F = M)) {
            var G;
            if (G = at === 0) {
              var fe = String(S.D).match(Bt)[1] || null;
              !fe && s.self && s.self.location && (fe = s.self.location.protocol.slice(0, -1)), G = !ale.test(fe ? fe.toLowerCase() : "");
            }
            F = G;
          }
          if (F)
            Ne(S, "complete"), Ne(S, "success");
          else {
            S.m = 6;
            try {
              var _e = 2 < Oc(S) ? S.g.statusText : "";
            } catch {
              _e = "";
            }
            S.l = _e + " [" + S.Z() + "]", J4(S);
          }
        } finally {
          Ib(S);
        }
      }
    }
  }
  function Ib(S, M) {
    if (S.g) {
      eN(S);
      const F = S.g, G = S.v[0] ? () => {
      } : null;
      S.g = null, S.v = null, M || Ne(S, "ready");
      try {
        F.onreadystatechange = G;
      } catch {
      }
    }
  }
  function eN(S) {
    S.I && (s.clearTimeout(S.I), S.I = null);
  }
  e.isActive = function() {
    return !!this.g;
  };
  function Oc(S) {
    return S.g ? S.g.readyState : 0;
  }
  e.Z = function() {
    try {
      return 2 < Oc(this) ? this.g.status : -1;
    } catch {
      return -1;
    }
  }, e.oa = function() {
    try {
      return this.g ? this.g.responseText : "";
    } catch {
      return "";
    }
  }, e.Oa = function(S) {
    if (this.g) {
      var M = this.g.responseText;
      return S && M.indexOf(S) == 0 && (M = M.substring(S.length)), _t(M);
    }
  };
  function tN(S) {
    try {
      if (!S.g)
        return null;
      if ("response" in S.g)
        return S.g.response;
      switch (S.H) {
        case "":
        case "text":
          return S.g.responseText;
        case "arraybuffer":
          if ("mozResponseArrayBuffer" in S.g)
            return S.g.mozResponseArrayBuffer;
      }
      return null;
    } catch {
      return null;
    }
  }
  function cle(S) {
    const M = {};
    S = (S.g && 2 <= Oc(S) && S.g.getAllResponseHeaders() || "").split(`\r
`);
    for (let G = 0; G < S.length; G++) {
      if (y(S[G]))
        continue;
      var F = I(S[G]);
      const fe = F[0];
      if (F = F[1], typeof F != "string")
        continue;
      F = F.trim();
      const _e = M[fe] || [];
      M[fe] = _e, _e.push(F);
    }
    x(M, function(G) {
      return G.join(", ");
    });
  }
  e.Ba = function() {
    return this.m;
  }, e.Ka = function() {
    return typeof this.l == "string" ? this.l : String(this.l);
  };
  function _m(S, M, F) {
    return F && F.internalChannelParams && F.internalChannelParams[S] || M;
  }
  function nN(S) {
    this.Aa = 0, this.i = [], this.j = new ct(), this.ia = this.qa = this.I = this.W = this.g = this.ya = this.D = this.H = this.m = this.S = this.o = null, this.Ya = this.U = 0, this.Va = _m("failFast", !1, S), this.F = this.C = this.u = this.s = this.l = null, this.X = !0, this.za = this.T = -1, this.Y = this.v = this.B = 0, this.Ta = _m("baseRetryDelayMs", 5e3, S), this.cb = _m("retryDelaySeedMs", 1e4, S), this.Wa = _m("forwardChannelMaxRetries", 2, S), this.wa = _m("forwardChannelRequestTimeoutMs", 2e4, S), this.pa = S && S.xmlHttpFactory || void 0, this.Xa = S && S.Tb || void 0, this.Ca = S && S.useFetchStreams || !1, this.L = void 0, this.J = S && S.supportsCrossDomainXhr || !1, this.K = "", this.h = new vr(S && S.concurrentRequestLimit), this.Da = new Jr(), this.P = S && S.fastHandshake || !1, this.O = S && S.encodeInitMessageHeaders || !1, this.P && this.O && (this.O = !1), this.Ua = S && S.Rb || !1, S && S.xa && this.j.xa(), S && S.forceLongPolling && (this.X = !1), this.ba = !this.P && this.X && S && S.detectBufferingProxy || !1, this.ja = void 0, S && S.longPollingTimeout && 0 < S.longPollingTimeout && (this.ja = S.longPollingTimeout), this.ca = void 0, this.R = 0, this.M = !1, this.ka = this.A = null;
  }
  e = nN.prototype, e.la = 8, e.G = 1, e.connect = function(S, M, F, G) {
    Ht(0), this.W = S, this.H = M || {}, F && G !== void 0 && (this.H.OSID = F, this.H.OAID = G), this.F = this.X, this.I = dN(this, null, this.W), Ab(this);
  };
  function s5(S) {
    if (rN(S), S.G == 3) {
      var M = S.U++, F = Zt(S.I);
      if (un(F, "SID", S.K), un(F, "RID", M), un(F, "TYPE", "terminate"), Sm(S, F), M = new ut(S, S.j, M), M.L = 2, M.v = ri(Zt(F)), F = !1, s.navigator && s.navigator.sendBeacon)
        try {
          F = s.navigator.sendBeacon(M.v.toString(), "");
        } catch {
        }
      !F && s.Image && (new Image().src = M.v, F = !0), F || (M.g = fN(M.j, null), M.g.ea(M.v)), M.F = Date.now(), Ot(M);
    }
    uN(S);
  }
  function $b(S) {
    S.g && (l5(S), S.g.cancel(), S.g = null);
  }
  function rN(S) {
    $b(S), S.u && (s.clearTimeout(S.u), S.u = null), Rb(S), S.h.cancel(), S.s && (typeof S.s == "number" && s.clearTimeout(S.s), S.s = null);
  }
  function Ab(S) {
    if (!Cr(S.h) && !S.s) {
      S.s = !0;
      var M = S.Ga;
      D || B(), z || (D(), z = !0), V.add(M, S), S.B = 0;
    }
  }
  function lle(S, M) {
    return Xr(S.h) >= S.h.j - (S.s ? 1 : 0) ? !1 : S.s ? (S.i = M.D.concat(S.i), !0) : S.G == 1 || S.G == 2 || S.B >= (S.Va ? 0 : S.Wa) ? !1 : (S.s = We(f(S.Ga, S, M), lN(S, S.B)), S.B++, !0);
  }
  e.Ga = function(S) {
    if (this.s)
      if (this.s = null, this.G == 1) {
        if (!S) {
          this.U = Math.floor(1e5 * Math.random()), S = this.U++;
          const fe = new ut(this, this.j, S);
          let _e = this.o;
          if (this.S && (_e ? (_e = T(_e), R(_e, this.S)) : _e = this.S), this.m !== null || this.O || (fe.H = _e, _e = null), this.P)
            e: {
              for (var M = 0, F = 0; F < this.i.length; F++) {
                t: {
                  var G = this.i[F];
                  if ("__data__" in G.map && (G = G.map.__data__, typeof G == "string")) {
                    G = G.length;
                    break t;
                  }
                  G = void 0;
                }
                if (G === void 0)
                  break;
                if (M += G, 4096 < M) {
                  M = F;
                  break e;
                }
                if (M === 4096 || F === this.i.length - 1) {
                  M = F + 1;
                  break e;
                }
              }
              M = 1e3;
            }
          else
            M = 1e3;
          M = oN(this, fe, M), F = Zt(this.I), un(F, "RID", S), un(F, "CVER", 22), this.D && un(F, "X-HTTP-Session-Id", this.D), Sm(this, F), _e && (this.O ? M = "headers=" + encodeURIComponent(String(X4(_e))) + "&" + M : this.m && a5(F, this.m, _e)), Qr(this.h, fe), this.Ua && un(F, "TYPE", "init"), this.P ? (un(F, "$req", M), un(F, "SID", "null"), fe.T = !0, Ze(fe, F, null)) : Ze(fe, F, M), this.G = 2;
        }
      } else
        this.G == 3 && (S ? iN(this, S) : this.i.length == 0 || Cr(this.h) || iN(this));
  };
  function iN(S, M) {
    var F;
    M ? F = M.l : F = S.U++;
    const G = Zt(S.I);
    un(G, "SID", S.K), un(G, "RID", F), un(G, "AID", S.T), Sm(S, G), S.m && S.o && a5(G, S.m, S.o), F = new ut(S, S.j, F, S.B + 1), S.m === null && (F.H = S.o), M && (S.i = M.D.concat(S.i)), M = oN(S, F, 1e3), F.I = Math.round(0.5 * S.wa) + Math.round(0.5 * S.wa * Math.random()), Qr(S.h, F), Ze(F, G, M);
  }
  function Sm(S, M) {
    S.H && C(S.H, function(F, G) {
      un(M, G, F);
    }), S.l && Qt({}, function(F, G) {
      un(M, G, F);
    });
  }
  function oN(S, M, F) {
    F = Math.min(S.i.length, F);
    var G = S.l ? f(S.l.Na, S.l, S) : null;
    e: {
      var fe = S.i;
      let _e = -1;
      for (; ; ) {
        const at = ["count=" + F];
        _e == -1 ? 0 < F ? (_e = fe[0].g, at.push("ofs=" + _e)) : _e = 0 : at.push("ofs=" + _e);
        let nr = !0;
        for (let ji = 0; ji < F; ji++) {
          let Nn = fe[ji].g;
          const Ji = fe[ji].map;
          if (Nn -= _e, 0 > Nn)
            _e = Math.max(0, fe[ji].g - 100), nr = !1;
          else
            try {
              $r(Ji, at, "req" + Nn + "_");
            } catch {
              G && G(Ji);
            }
        }
        if (nr) {
          G = at.join("&");
          break e;
        }
      }
    }
    return S = S.i.splice(0, F), M.D = S, G;
  }
  function aN(S) {
    if (!S.g && !S.u) {
      S.Y = 1;
      var M = S.Fa;
      D || B(), z || (D(), z = !0), V.add(M, S), S.v = 0;
    }
  }
  function c5(S) {
    return S.g || S.u || 3 <= S.v ? !1 : (S.Y++, S.u = We(f(S.Fa, S), lN(S, S.v)), S.v++, !0);
  }
  e.Fa = function() {
    if (this.u = null, sN(this), this.ba && !(this.M || this.g == null || 0 >= this.R)) {
      var S = 2 * this.R;
      this.j.info("BP detection timer enabled: " + S), this.A = We(f(this.ab, this), S);
    }
  }, e.ab = function() {
    this.A && (this.A = null, this.j.info("BP detection timeout reached."), this.j.info("Buffering proxy detected and switch to long-polling!"), this.F = !1, this.M = !0, Ht(10), $b(this), sN(this));
  };
  function l5(S) {
    S.A != null && (s.clearTimeout(S.A), S.A = null);
  }
  function sN(S) {
    S.g = new ut(S, S.j, "rpc", S.Y), S.m === null && (S.g.H = S.o), S.g.O = 0;
    var M = Zt(S.qa);
    un(M, "RID", "rpc"), un(M, "SID", S.K), un(M, "AID", S.T), un(M, "CI", S.F ? "0" : "1"), !S.F && S.ja && un(M, "TO", S.ja), un(M, "TYPE", "xmlhttp"), Sm(S, M), S.m && S.o && a5(M, S.m, S.o), S.L && (S.g.I = S.L);
    var F = S.g;
    S = S.ia, F.L = 1, F.v = ri(Zt(M)), F.m = null, F.P = !0, dt(F, S);
  }
  e.Za = function() {
    this.C != null && (this.C = null, $b(this), c5(this), Ht(19));
  };
  function Rb(S) {
    S.C != null && (s.clearTimeout(S.C), S.C = null);
  }
  function cN(S, M) {
    var F = null;
    if (S.g == M) {
      Rb(S), l5(S), S.g = null;
      var G = 2;
    } else if (Tr(S.h, M))
      F = M.D, Ti(S.h, M), G = 1;
    else
      return;
    if (S.G != 0) {
      if (M.o)
        if (G == 1) {
          F = M.m ? M.m.length : 0, M = Date.now() - M.F;
          var fe = S.B;
          G = Ke(), Ne(G, new Ue(G, F)), Ab(S);
        } else
          aN(S);
      else if (fe = M.s, fe == 3 || fe == 0 && 0 < M.X || !(G == 1 && lle(S, M) || G == 2 && c5(S)))
        switch (F && 0 < F.length && (M = S.h, M.i = M.i.concat(F)), fe) {
          case 1:
            pd(S, 5);
            break;
          case 4:
            pd(S, 10);
            break;
          case 3:
            pd(S, 6);
            break;
          default:
            pd(S, 2);
        }
    }
  }
  function lN(S, M) {
    let F = S.Ta + Math.floor(Math.random() * S.cb);
    return S.isActive() || (F *= 2), F * M;
  }
  function pd(S, M) {
    if (S.j.info("Error code " + M), M == 2) {
      var F = f(S.fb, S), G = S.Xa;
      const fe = !G;
      G = new Jt(G || "//www.google.com/images/cleardot.gif"), s.location && s.location.protocol == "http" || yn(G, "https"), ri(G), fe ? wt(G.toString(), F) : zt(G.toString(), F);
    } else
      Ht(2);
    S.G = 0, S.l && S.l.sa(M), uN(S), rN(S);
  }
  e.fb = function(S) {
    S ? (this.j.info("Successfully pinged google.com"), Ht(2)) : (this.j.info("Failed to ping google.com"), Ht(1));
  };
  function uN(S) {
    if (S.G = 0, S.ka = [], S.l) {
      const M = Ii(S.h);
      (M.length != 0 || S.i.length != 0) && (m(S.ka, M), m(S.ka, S.i), S.h.i.length = 0, g(S.i), S.i.length = 0), S.l.ra();
    }
  }
  function dN(S, M, F) {
    var G = F instanceof Jt ? Zt(F) : new Jt(F);
    if (G.g != "")
      M && (G.g = M + "." + G.g), Ir(G, G.s);
    else {
      var fe = s.location;
      G = fe.protocol, M = M ? M + "." + fe.hostname : fe.hostname, fe = +fe.port;
      var _e = new Jt(null);
      G && yn(_e, G), M && (_e.g = M), fe && Ir(_e, fe), F && (_e.l = F), G = _e;
    }
    return F = S.D, M = S.ya, F && M && un(G, F, M), un(G, "VER", S.la), Sm(S, G), G;
  }
  function fN(S, M, F) {
    if (M && !S.J)
      throw Error("Can't create secondary domain capable XhrIo object.");
    return M = S.Ca && !S.pa ? new Br(new Pc({ eb: F })) : new Br(S.pa), M.Ha(S.J), M;
  }
  e.isActive = function() {
    return !!this.l && this.l.isActive(this);
  };
  function hN() {
  }
  e = hN.prototype, e.ua = function() {
  }, e.ta = function() {
  }, e.sa = function() {
  }, e.ra = function() {
  }, e.isActive = function() {
    return !0;
  }, e.Na = function() {
  };
  function Pb() {
  }
  Pb.prototype.g = function(S, M) {
    return new aa(S, M);
  };
  function aa(S, M) {
    ze.call(this), this.g = new nN(M), this.l = S, this.h = M && M.messageUrlParams || null, S = M && M.messageHeaders || null, M && M.clientProtocolHeaderRequired && (S ? S["X-Client-Protocol"] = "webchannel" : S = { "X-Client-Protocol": "webchannel" }), this.g.o = S, S = M && M.initMessageHeaders || null, M && M.messageContentType && (S ? S["X-WebChannel-Content-Type"] = M.messageContentType : S = { "X-WebChannel-Content-Type": M.messageContentType }), M && M.va && (S ? S["X-WebChannel-Client-Profile"] = M.va : S = { "X-WebChannel-Client-Profile": M.va }), this.g.S = S, (S = M && M.Sb) && !y(S) && (this.g.m = S), this.v = M && M.supportsCrossDomainXhr || !1, this.u = M && M.sendRawJson || !1, (M = M && M.httpSessionIdParam) && !y(M) && (this.g.D = M, S = this.h, S !== null && M in S && (S = this.h, M in S && delete S[M])), this.j = new dh(this);
  }
  p(aa, ze), aa.prototype.m = function() {
    this.g.l = this.j, this.v && (this.g.J = !0), this.g.connect(this.l, this.h || void 0);
  }, aa.prototype.close = function() {
    s5(this.g);
  }, aa.prototype.o = function(S) {
    var M = this.g;
    if (typeof S == "string") {
      var F = {};
      F.__data__ = S, S = F;
    } else
      this.u && (F = {}, F.__data__ = Pt(S), S = F);
    M.i.push(new Yr(M.Ya++, S)), M.G == 3 && Ab(M);
  }, aa.prototype.N = function() {
    this.g.l = null, delete this.j, s5(this.g), delete this.g, aa.aa.N.call(this);
  };
  function gN(S) {
    Be.call(this), S.__headers__ && (this.headers = S.__headers__, this.statusCode = S.__status__, delete S.__headers__, delete S.__status__);
    var M = S.__sm__;
    if (M) {
      e: {
        for (const F in M) {
          S = F;
          break e;
        }
        S = void 0;
      }
      (this.i = S) && (S = this.i, M = M !== null && S in M ? M[S] : void 0), this.data = M;
    } else
      this.data = S;
  }
  p(gN, Be);
  function pN() {
    st.call(this), this.status = 1;
  }
  p(pN, st);
  function dh(S) {
    this.g = S;
  }
  p(dh, hN), dh.prototype.ua = function() {
    Ne(this.g, "a");
  }, dh.prototype.ta = function(S) {
    Ne(this.g, new gN(S));
  }, dh.prototype.sa = function(S) {
    Ne(this.g, new pN());
  }, dh.prototype.ra = function() {
    Ne(this.g, "b");
  }, Pb.prototype.createWebChannel = Pb.prototype.g, aa.prototype.send = aa.prototype.o, aa.prototype.open = aa.prototype.m, aa.prototype.close = aa.prototype.close, Sq = function() {
    return new Pb();
  }, _q = function() {
    return Ke();
  }, bq = pt, D$ = { mb: 0, pb: 1, qb: 2, Jb: 3, Ob: 4, Lb: 5, Mb: 6, Kb: 7, Ib: 8, Nb: 9, PROXY: 10, NOPROXY: 11, Gb: 12, Cb: 13, Db: 14, Bb: 15, Eb: 16, Fb: 17, ib: 18, hb: 19, jb: 20 }, De.NO_ERROR = 0, De.TIMEOUT = 8, De.HTTP_ERROR = 6, n_ = De, Ye.COMPLETE = "complete", yq = Ye, Dt.EventType = nt, nt.OPEN = "a", nt.CLOSE = "b", nt.ERROR = "c", nt.MESSAGE = "d", ze.prototype.listen = ze.prototype.K, o0 = Dt, Br.prototype.listenOnce = Br.prototype.L, Br.prototype.getLastError = Br.prototype.Ka, Br.prototype.getLastErrorCode = Br.prototype.Ba, Br.prototype.getStatus = Br.prototype.Z, Br.prototype.getResponseJson = Br.prototype.Oa, Br.prototype.getResponseText = Br.prototype.oa, Br.prototype.send = Br.prototype.ea, Br.prototype.setWithCredentials = Br.prototype.Ha, vq = Br;
}).apply(typeof Db < "u" ? Db : typeof self < "u" ? self : typeof window < "u" ? window : {});
const bD = "@firebase/firestore", _D = "4.8.0";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ao {
  constructor(t) {
    this.uid = t;
  }
  isAuthenticated() {
    return this.uid != null;
  }
  /**
   * Returns a key representing this user, suitable for inclusion in a
   * dictionary.
   */
  toKey() {
    return this.isAuthenticated() ? "uid:" + this.uid : "anonymous-user";
  }
  isEqual(t) {
    return t.uid === this.uid;
  }
}
ao.UNAUTHENTICATED = new ao(null), // TODO(mikelehen): Look into getting a proper uid-equivalent for
// non-FirebaseAuth providers.
ao.GOOGLE_CREDENTIALS = new ao("google-credentials-uid"), ao.FIRST_PARTY = new ao("first-party-uid"), ao.MOCK_USER = new ao("mock-user");
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
let Np = "11.10.0";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const hf = new Ox("@firebase/firestore");
function jh() {
  return hf.logLevel;
}
function bt(e, ...t) {
  if (hf.logLevel <= _n.DEBUG) {
    const n = t.map(VO);
    hf.debug(`Firestore (${Np}): ${e}`, ...n);
  }
}
function hl(e, ...t) {
  if (hf.logLevel <= _n.ERROR) {
    const n = t.map(VO);
    hf.error(`Firestore (${Np}): ${e}`, ...n);
  }
}
function Iu(e, ...t) {
  if (hf.logLevel <= _n.WARN) {
    const n = t.map(VO);
    hf.warn(`Firestore (${Np}): ${e}`, ...n);
  }
}
function VO(e) {
  if (typeof e == "string")
    return e;
  try {
    /**
    * @license
    * Copyright 2020 Google LLC
    *
    * Licensed under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License.
    * You may obtain a copy of the License at
    *
    *   http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software
    * distributed under the License is distributed on an "AS IS" BASIS,
    * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    * See the License for the specific language governing permissions and
    * limitations under the License.
    */
    return function(n) {
      return JSON.stringify(n);
    }(e);
  } catch {
    return e;
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function qt(e, t, n) {
  let r = "Unexpected state";
  typeof t == "string" ? r = t : n = t, wq(e, r, n);
}
function wq(e, t, n) {
  let r = `FIRESTORE (${Np}) INTERNAL ASSERTION FAILED: ${t} (ID: ${e.toString(16)})`;
  if (n !== void 0)
    try {
      r += " CONTEXT: " + JSON.stringify(n);
    } catch {
      r += " CONTEXT: " + n;
    }
  throw hl(r), new Error(r);
}
function Fn(e, t, n, r) {
  let i = "Unexpected state";
  typeof n == "string" ? i = n : r = n, e || wq(t, i, r);
}
function Gt(e, t) {
  return e;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const we = {
  // Causes are copied from:
  // https://github.com/grpc/grpc/blob/bceec94ea4fc5f0085d81235d8e1c06798dc341a/include/grpc%2B%2B/impl/codegen/status_code_enum.h
  /** Not an error; returned on success. */
  OK: "ok",
  /** The operation was cancelled (typically by the caller). */
  CANCELLED: "cancelled",
  /** Unknown error or an error from a different error domain. */
  UNKNOWN: "unknown",
  /**
   * Client specified an invalid argument. Note that this differs from
   * FAILED_PRECONDITION. INVALID_ARGUMENT indicates arguments that are
   * problematic regardless of the state of the system (e.g., a malformed file
   * name).
   */
  INVALID_ARGUMENT: "invalid-argument",
  /**
   * Deadline expired before operation could complete. For operations that
   * change the state of the system, this error may be returned even if the
   * operation has completed successfully. For example, a successful response
   * from a server could have been delayed long enough for the deadline to
   * expire.
   */
  DEADLINE_EXCEEDED: "deadline-exceeded",
  /** Some requested entity (e.g., file or directory) was not found. */
  NOT_FOUND: "not-found",
  /**
   * Some entity that we attempted to create (e.g., file or directory) already
   * exists.
   */
  ALREADY_EXISTS: "already-exists",
  /**
   * The caller does not have permission to execute the specified operation.
   * PERMISSION_DENIED must not be used for rejections caused by exhausting
   * some resource (use RESOURCE_EXHAUSTED instead for those errors).
   * PERMISSION_DENIED must not be used if the caller cannot be identified
   * (use UNAUTHENTICATED instead for those errors).
   */
  PERMISSION_DENIED: "permission-denied",
  /**
   * The request does not have valid authentication credentials for the
   * operation.
   */
  UNAUTHENTICATED: "unauthenticated",
  /**
   * Some resource has been exhausted, perhaps a per-user quota, or perhaps the
   * entire file system is out of space.
   */
  RESOURCE_EXHAUSTED: "resource-exhausted",
  /**
   * Operation was rejected because the system is not in a state required for
   * the operation's execution. For example, directory to be deleted may be
   * non-empty, an rmdir operation is applied to a non-directory, etc.
   *
   * A litmus test that may help a service implementor in deciding
   * between FAILED_PRECONDITION, ABORTED, and UNAVAILABLE:
   *  (a) Use UNAVAILABLE if the client can retry just the failing call.
   *  (b) Use ABORTED if the client should retry at a higher-level
   *      (e.g., restarting a read-modify-write sequence).
   *  (c) Use FAILED_PRECONDITION if the client should not retry until
   *      the system state has been explicitly fixed. E.g., if an "rmdir"
   *      fails because the directory is non-empty, FAILED_PRECONDITION
   *      should be returned since the client should not retry unless
   *      they have first fixed up the directory by deleting files from it.
   *  (d) Use FAILED_PRECONDITION if the client performs conditional
   *      REST Get/Update/Delete on a resource and the resource on the
   *      server does not match the condition. E.g., conflicting
   *      read-modify-write on the same resource.
   */
  FAILED_PRECONDITION: "failed-precondition",
  /**
   * The operation was aborted, typically due to a concurrency issue like
   * sequencer check failures, transaction aborts, etc.
   *
   * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
   * and UNAVAILABLE.
   */
  ABORTED: "aborted",
  /**
   * Operation was attempted past the valid range. E.g., seeking or reading
   * past end of file.
   *
   * Unlike INVALID_ARGUMENT, this error indicates a problem that may be fixed
   * if the system state changes. For example, a 32-bit file system will
   * generate INVALID_ARGUMENT if asked to read at an offset that is not in the
   * range [0,2^32-1], but it will generate OUT_OF_RANGE if asked to read from
   * an offset past the current file size.
   *
   * There is a fair bit of overlap between FAILED_PRECONDITION and
   * OUT_OF_RANGE. We recommend using OUT_OF_RANGE (the more specific error)
   * when it applies so that callers who are iterating through a space can
   * easily look for an OUT_OF_RANGE error to detect when they are done.
   */
  OUT_OF_RANGE: "out-of-range",
  /** Operation is not implemented or not supported/enabled in this service. */
  UNIMPLEMENTED: "unimplemented",
  /**
   * Internal errors. Means some invariants expected by underlying System has
   * been broken. If you see one of these errors, Something is very broken.
   */
  INTERNAL: "internal",
  /**
   * The service is currently unavailable. This is a most likely a transient
   * condition and may be corrected by retrying with a backoff.
   *
   * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
   * and UNAVAILABLE.
   */
  UNAVAILABLE: "unavailable",
  /** Unrecoverable data loss or corruption. */
  DATA_LOSS: "data-loss"
};
class Je extends Qa {
  /** @hideconstructor */
  constructor(t, n) {
    super(t, n), this.code = t, this.message = n, // HACK: We write a toString property directly because Error is not a real
    // class and so inheritance does not work correctly. We could alternatively
    // do the same "back-door inheritance" trick that FirebaseError does.
    this.toString = () => `${this.name}: [code=${this.code}]: ${this.message}`;
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class _s {
  constructor() {
    this.promise = new Promise((t, n) => {
      this.resolve = t, this.reject = n;
    });
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class xq {
  constructor(t, n) {
    this.user = n, this.type = "OAuth", this.headers = /* @__PURE__ */ new Map(), this.headers.set("Authorization", `Bearer ${t}`);
  }
}
class hSe {
  getToken() {
    return Promise.resolve(null);
  }
  invalidateToken() {
  }
  start(t, n) {
    t.enqueueRetryable(() => n(ao.UNAUTHENTICATED));
  }
  shutdown() {
  }
}
class gSe {
  constructor(t) {
    this.token = t, /**
     * Stores the listener registered with setChangeListener()
     * This isn't actually necessary since the UID never changes, but we use this
     * to verify the listen contract is adhered to in tests.
     */
    this.changeListener = null;
  }
  getToken() {
    return Promise.resolve(this.token);
  }
  invalidateToken() {
  }
  start(t, n) {
    this.changeListener = n, // Fire with initial user.
    t.enqueueRetryable(() => n(this.token.user));
  }
  shutdown() {
    this.changeListener = null;
  }
}
class pSe {
  constructor(t) {
    this.t = t, /** Tracks the current User. */
    this.currentUser = ao.UNAUTHENTICATED, /**
     * Counter used to detect if the token changed while a getToken request was
     * outstanding.
     */
    this.i = 0, this.forceRefresh = !1, this.auth = null;
  }
  start(t, n) {
    Fn(this.o === void 0, 42304);
    let r = this.i;
    const i = (c) => this.i !== r ? (r = this.i, n(c)) : Promise.resolve();
    let o = new _s();
    this.o = () => {
      this.i++, this.currentUser = this.u(), o.resolve(), o = new _s(), t.enqueueRetryable(() => i(this.currentUser));
    };
    const a = () => {
      const c = o;
      t.enqueueRetryable(async () => {
        await c.promise, await i(this.currentUser);
      });
    }, s = (c) => {
      bt("FirebaseAuthCredentialsProvider", "Auth detected"), this.auth = c, this.o && (this.auth.addAuthTokenListener(this.o), a());
    };
    this.t.onInit((c) => s(c)), // Our users can initialize Auth right after Firestore, so we give it
    // a chance to register itself with the component framework before we
    // determine whether to start up in unauthenticated mode.
    setTimeout(() => {
      if (!this.auth) {
        const c = this.t.getImmediate({
          optional: !0
        });
        c ? s(c) : (
          // If auth is still not available, proceed with `null` user
          (bt("FirebaseAuthCredentialsProvider", "Auth not yet detected"), o.resolve(), o = new _s())
        );
      }
    }, 0), a();
  }
  getToken() {
    const t = this.i, n = this.forceRefresh;
    return this.forceRefresh = !1, this.auth ? this.auth.getToken(n).then((r) => (
      // Cancel the request since the token changed while the request was
      // outstanding so the response is potentially for a previous user (which
      // user, we can't be sure).
      this.i !== t ? (bt("FirebaseAuthCredentialsProvider", "getToken aborted due to token change."), this.getToken()) : r ? (Fn(typeof r.accessToken == "string", 31837, {
        l: r
      }), new xq(r.accessToken, this.currentUser)) : null
    )) : Promise.resolve(null);
  }
  invalidateToken() {
    this.forceRefresh = !0;
  }
  shutdown() {
    this.auth && this.o && this.auth.removeAuthTokenListener(this.o), this.o = void 0;
  }
  // Auth.getUid() can return null even with a user logged in. It is because
  // getUid() is synchronous, but the auth code populating Uid is asynchronous.
  // This method should only be called in the AuthTokenListener callback
  // to guarantee to get the actual user.
  u() {
    const t = this.auth && this.auth.getUid();
    return Fn(t === null || typeof t == "string", 2055, {
      h: t
    }), new ao(t);
  }
}
class mSe {
  constructor(t, n, r) {
    this.P = t, this.T = n, this.I = r, this.type = "FirstParty", this.user = ao.FIRST_PARTY, this.A = /* @__PURE__ */ new Map();
  }
  /**
   * Gets an authorization token, using a provided factory function, or return
   * null.
   */
  R() {
    return this.I ? this.I() : null;
  }
  get headers() {
    this.A.set("X-Goog-AuthUser", this.P);
    const t = this.R();
    return t && this.A.set("Authorization", t), this.T && this.A.set("X-Goog-Iam-Authorization-Token", this.T), this.A;
  }
}
class vSe {
  constructor(t, n, r) {
    this.P = t, this.T = n, this.I = r;
  }
  getToken() {
    return Promise.resolve(new mSe(this.P, this.T, this.I));
  }
  start(t, n) {
    t.enqueueRetryable(() => n(ao.FIRST_PARTY));
  }
  shutdown() {
  }
  invalidateToken() {
  }
}
class SD {
  constructor(t) {
    this.value = t, this.type = "AppCheck", this.headers = /* @__PURE__ */ new Map(), t && t.length > 0 && this.headers.set("x-firebase-appcheck", this.value);
  }
}
class ySe {
  constructor(t, n) {
    this.V = n, this.forceRefresh = !1, this.appCheck = null, this.m = null, this.p = null, Io(t) && t.settings.appCheckToken && (this.p = t.settings.appCheckToken);
  }
  start(t, n) {
    Fn(this.o === void 0, 3512);
    const r = (o) => {
      o.error != null && bt("FirebaseAppCheckTokenProvider", `Error getting App Check token; using placeholder token instead. Error: ${o.error.message}`);
      const a = o.token !== this.m;
      return this.m = o.token, bt("FirebaseAppCheckTokenProvider", `Received ${a ? "new" : "existing"} token.`), a ? n(o.token) : Promise.resolve();
    };
    this.o = (o) => {
      t.enqueueRetryable(() => r(o));
    };
    const i = (o) => {
      bt("FirebaseAppCheckTokenProvider", "AppCheck detected"), this.appCheck = o, this.o && this.appCheck.addTokenListener(this.o);
    };
    this.V.onInit((o) => i(o)), // Our users can initialize AppCheck after Firestore, so we give it
    // a chance to register itself with the component framework.
    setTimeout(() => {
      if (!this.appCheck) {
        const o = this.V.getImmediate({
          optional: !0
        });
        o ? i(o) : (
          // If AppCheck is still not available, proceed without it.
          bt("FirebaseAppCheckTokenProvider", "AppCheck not yet detected")
        );
      }
    }, 0);
  }
  getToken() {
    if (this.p)
      return Promise.resolve(new SD(this.p));
    const t = this.forceRefresh;
    return this.forceRefresh = !1, this.appCheck ? this.appCheck.getToken(t).then((n) => n ? (Fn(typeof n.token == "string", 44558, {
      tokenResult: n
    }), this.m = n.token, new SD(n.token)) : null) : Promise.resolve(null);
  }
  invalidateToken() {
    this.forceRefresh = !0;
  }
  shutdown() {
    this.appCheck && this.o && this.appCheck.removeTokenListener(this.o), this.o = void 0;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function bSe(e) {
  const t = (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    typeof self < "u" && (self.crypto || self.msCrypto)
  ), n = new Uint8Array(e);
  if (t && typeof t.getRandomValues == "function")
    t.getRandomValues(n);
  else
    for (let r = 0; r < e; r++)
      n[r] = Math.floor(256 * Math.random());
  return n;
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Eq() {
  return new TextEncoder();
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class BO {
  static newId() {
    const t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", n = 62 * Math.floor(4.129032258064516);
    let r = "";
    for (; r.length < 20; ) {
      const i = bSe(40);
      for (let o = 0; o < i.length; ++o)
        r.length < 20 && i[o] < n && (r += t.charAt(i[o] % 62));
    }
    return r;
  }
}
function gn(e, t) {
  return e < t ? -1 : e > t ? 1 : 0;
}
function j$(e, t) {
  let n = 0;
  for (; n < e.length && n < t.length; ) {
    const r = e.codePointAt(n), i = t.codePointAt(n);
    if (r !== i) {
      if (r < 128 && i < 128)
        return gn(r, i);
      {
        const o = Eq(), a = _Se(o.encode(wD(e, n)), o.encode(wD(t, n)));
        return a !== 0 ? a : gn(r, i);
      }
    }
    n += r > 65535 ? 2 : 1;
  }
  return gn(e.length, t.length);
}
function wD(e, t) {
  return e.codePointAt(t) > 65535 ? e.substring(t, t + 2) : e.substring(t, t + 1);
}
function _Se(e, t) {
  for (let n = 0; n < e.length && n < t.length; ++n)
    if (e[n] !== t[n])
      return gn(e[n], t[n]);
  return gn(e.length, t.length);
}
function Tg(e, t, n) {
  return e.length === t.length && e.every((r, i) => n(r, t[i]));
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const xD = "__name__";
class Ks {
  constructor(t, n, r) {
    n === void 0 ? n = 0 : n > t.length && qt(637, {
      offset: n,
      range: t.length
    }), r === void 0 ? r = t.length - n : r > t.length - n && qt(1746, {
      length: r,
      range: t.length - n
    }), this.segments = t, this.offset = n, this.len = r;
  }
  get length() {
    return this.len;
  }
  isEqual(t) {
    return Ks.comparator(this, t) === 0;
  }
  child(t) {
    const n = this.segments.slice(this.offset, this.limit());
    return t instanceof Ks ? t.forEach((r) => {
      n.push(r);
    }) : n.push(t), this.construct(n);
  }
  /** The index of one past the last segment of the path. */
  limit() {
    return this.offset + this.length;
  }
  popFirst(t) {
    return t = t === void 0 ? 1 : t, this.construct(this.segments, this.offset + t, this.length - t);
  }
  popLast() {
    return this.construct(this.segments, this.offset, this.length - 1);
  }
  firstSegment() {
    return this.segments[this.offset];
  }
  lastSegment() {
    return this.get(this.length - 1);
  }
  get(t) {
    return this.segments[this.offset + t];
  }
  isEmpty() {
    return this.length === 0;
  }
  isPrefixOf(t) {
    if (t.length < this.length)
      return !1;
    for (let n = 0; n < this.length; n++)
      if (this.get(n) !== t.get(n))
        return !1;
    return !0;
  }
  isImmediateParentOf(t) {
    if (this.length + 1 !== t.length)
      return !1;
    for (let n = 0; n < this.length; n++)
      if (this.get(n) !== t.get(n))
        return !1;
    return !0;
  }
  forEach(t) {
    for (let n = this.offset, r = this.limit(); n < r; n++)
      t(this.segments[n]);
  }
  toArray() {
    return this.segments.slice(this.offset, this.limit());
  }
  /**
   * Compare 2 paths segment by segment, prioritizing numeric IDs
   * (e.g., "__id123__") in numeric ascending order, followed by string
   * segments in lexicographical order.
   */
  static comparator(t, n) {
    const r = Math.min(t.length, n.length);
    for (let i = 0; i < r; i++) {
      const o = Ks.compareSegments(t.get(i), n.get(i));
      if (o !== 0)
        return o;
    }
    return gn(t.length, n.length);
  }
  static compareSegments(t, n) {
    const r = Ks.isNumericId(t), i = Ks.isNumericId(n);
    return r && !i ? -1 : !r && i ? 1 : r && i ? Ks.extractNumericId(t).compare(Ks.extractNumericId(n)) : j$(t, n);
  }
  // Checks if a segment is a numeric ID (starts with "__id" and ends with "__").
  static isNumericId(t) {
    return t.startsWith("__id") && t.endsWith("__");
  }
  static extractNumericId(t) {
    return gu.fromString(t.substring(4, t.length - 2));
  }
}
class or extends Ks {
  construct(t, n, r) {
    return new or(t, n, r);
  }
  canonicalString() {
    return this.toArray().join("/");
  }
  toString() {
    return this.canonicalString();
  }
  /**
   * Returns a string representation of this path
   * where each path segment has been encoded with
   * `encodeURIComponent`.
   */
  toUriEncodedString() {
    return this.toArray().map(encodeURIComponent).join("/");
  }
  /**
   * Creates a resource path from the given slash-delimited string. If multiple
   * arguments are provided, all components are combined. Leading and trailing
   * slashes from all components are ignored.
   */
  static fromString(...t) {
    const n = [];
    for (const r of t) {
      if (r.indexOf("//") >= 0)
        throw new Je(we.INVALID_ARGUMENT, `Invalid segment (${r}). Paths must not contain // in them.`);
      n.push(...r.split("/").filter((i) => i.length > 0));
    }
    return new or(n);
  }
  static emptyPath() {
    return new or([]);
  }
}
const SSe = /^[_a-zA-Z][_a-zA-Z0-9]*$/;
class zi extends Ks {
  construct(t, n, r) {
    return new zi(t, n, r);
  }
  /**
   * Returns true if the string could be used as a segment in a field path
   * without escaping.
   */
  static isValidIdentifier(t) {
    return SSe.test(t);
  }
  canonicalString() {
    return this.toArray().map((t) => (t = t.replace(/\\/g, "\\\\").replace(/`/g, "\\`"), zi.isValidIdentifier(t) || (t = "`" + t + "`"), t)).join(".");
  }
  toString() {
    return this.canonicalString();
  }
  /**
   * Returns true if this field references the key of a document.
   */
  isKeyField() {
    return this.length === 1 && this.get(0) === xD;
  }
  /**
   * The field designating the key of a document.
   */
  static keyField() {
    return new zi([xD]);
  }
  /**
   * Parses a field string from the given server-formatted string.
   *
   * - Splitting the empty string is not allowed (for now at least).
   * - Empty segments within the string (e.g. if there are two consecutive
   *   separators) are not allowed.
   *
   * TODO(b/37244157): we should make this more strict. Right now, it allows
   * non-identifier path components, even if they aren't escaped.
   */
  static fromServerFormat(t) {
    const n = [];
    let r = "", i = 0;
    const o = () => {
      if (r.length === 0)
        throw new Je(we.INVALID_ARGUMENT, `Invalid field path (${t}). Paths must not be empty, begin with '.', end with '.', or contain '..'`);
      n.push(r), r = "";
    };
    let a = !1;
    for (; i < t.length; ) {
      const s = t[i];
      if (s === "\\") {
        if (i + 1 === t.length)
          throw new Je(we.INVALID_ARGUMENT, "Path has trailing escape character: " + t);
        const c = t[i + 1];
        if (c !== "\\" && c !== "." && c !== "`")
          throw new Je(we.INVALID_ARGUMENT, "Path has invalid escape sequence: " + t);
        r += c, i += 2;
      } else
        s === "`" ? (a = !a, i++) : s !== "." || a ? (r += s, i++) : (o(), i++);
    }
    if (o(), a)
      throw new Je(we.INVALID_ARGUMENT, "Unterminated ` in path: " + t);
    return new zi(n);
  }
  static emptyPath() {
    return new zi([]);
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class kt {
  constructor(t) {
    this.path = t;
  }
  static fromPath(t) {
    return new kt(or.fromString(t));
  }
  static fromName(t) {
    return new kt(or.fromString(t).popFirst(5));
  }
  static empty() {
    return new kt(or.emptyPath());
  }
  get collectionGroup() {
    return this.path.popLast().lastSegment();
  }
  /** Returns true if the document is in the specified collectionId. */
  hasCollectionId(t) {
    return this.path.length >= 2 && this.path.get(this.path.length - 2) === t;
  }
  /** Returns the collection group (i.e. the name of the parent collection) for this key. */
  getCollectionGroup() {
    return this.path.get(this.path.length - 2);
  }
  /** Returns the fully qualified path to the parent collection. */
  getCollectionPath() {
    return this.path.popLast();
  }
  isEqual(t) {
    return t !== null && or.comparator(this.path, t.path) === 0;
  }
  toString() {
    return this.path.toString();
  }
  static comparator(t, n) {
    return or.comparator(t.path, n.path);
  }
  static isDocumentKey(t) {
    return t.length % 2 == 0;
  }
  /**
   * Creates and returns a new document key with the given segments.
   *
   * @param segments - The segments of the path to the document
   * @returns A new instance of DocumentKey
   */
  static fromSegments(t) {
    return new kt(new or(t.slice()));
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Cq(e, t, n) {
  if (!n)
    throw new Je(we.INVALID_ARGUMENT, `Function ${e}() cannot be called with an empty ${t}.`);
}
function wSe(e, t, n, r) {
  if (t === !0 && r === !0)
    throw new Je(we.INVALID_ARGUMENT, `${e} and ${n} cannot be used together.`);
}
function ED(e) {
  if (!kt.isDocumentKey(e))
    throw new Je(we.INVALID_ARGUMENT, `Invalid document reference. Document references must have an even number of segments, but ${e} has ${e.length}.`);
}
function CD(e) {
  if (kt.isDocumentKey(e))
    throw new Je(we.INVALID_ARGUMENT, `Invalid collection reference. Collection references must have an odd number of segments, but ${e} has ${e.length}.`);
}
function Tq(e) {
  return typeof e == "object" && e !== null && (Object.getPrototypeOf(e) === Object.prototype || Object.getPrototypeOf(e) === null);
}
function Vx(e) {
  if (e === void 0)
    return "undefined";
  if (e === null)
    return "null";
  if (typeof e == "string")
    return e.length > 20 && (e = `${e.substring(0, 20)}...`), JSON.stringify(e);
  if (typeof e == "number" || typeof e == "boolean")
    return "" + e;
  if (typeof e == "object") {
    if (e instanceof Array)
      return "an array";
    {
      const t = (
        /** try to get the constructor name for an object. */
        function(r) {
          return r.constructor ? r.constructor.name : null;
        }(e)
      );
      return t ? `a custom ${t} object` : "an object";
    }
  }
  return typeof e == "function" ? "a function" : qt(12329, {
    type: typeof e
  });
}
function lo(e, t) {
  if ("_delegate" in e && // Unwrap Compat types
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (e = e._delegate), !(e instanceof t)) {
    if (t.name === e.constructor.name)
      throw new Je(we.INVALID_ARGUMENT, "Type does not match the expected instance. Did you pass a reference from a different Firestore SDK?");
    {
      const n = Vx(e);
      throw new Je(we.INVALID_ARGUMENT, `Expected type '${t.name}', but it was: ${n}`);
    }
  }
  return e;
}
function Iq(e, t) {
  if (t <= 0)
    throw new Je(we.INVALID_ARGUMENT, `Function ${e}() requires a positive number, but it was: ${t}.`);
}
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function ui(e, t) {
  const n = {
    typeString: e
  };
  return t && (n.value = t), n;
}
function uy(e, t) {
  if (!Tq(e))
    throw new Je(we.INVALID_ARGUMENT, "JSON must be an object");
  let n;
  for (const r in t)
    if (t[r]) {
      const i = t[r].typeString, o = "value" in t[r] ? {
        value: t[r].value
      } : void 0;
      if (!(r in e)) {
        n = `JSON missing required field: '${r}'`;
        break;
      }
      const a = e[r];
      if (i && typeof a !== i) {
        n = `JSON field '${r}' must be a ${i}.`;
        break;
      }
      if (o !== void 0 && a !== o.value) {
        n = `Expected '${r}' field to equal '${o.value}'`;
        break;
      }
    }
  if (n)
    throw new Je(we.INVALID_ARGUMENT, n);
  return !0;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const TD = -62135596800, ID = 1e6;
class jn {
  /**
   * Creates a new timestamp with the current date, with millisecond precision.
   *
   * @returns a new timestamp representing the current date.
   */
  static now() {
    return jn.fromMillis(Date.now());
  }
  /**
   * Creates a new timestamp from the given date.
   *
   * @param date - The date to initialize the `Timestamp` from.
   * @returns A new `Timestamp` representing the same point in time as the given
   *     date.
   */
  static fromDate(t) {
    return jn.fromMillis(t.getTime());
  }
  /**
   * Creates a new timestamp from the given number of milliseconds.
   *
   * @param milliseconds - Number of milliseconds since Unix epoch
   *     1970-01-01T00:00:00Z.
   * @returns A new `Timestamp` representing the same point in time as the given
   *     number of milliseconds.
   */
  static fromMillis(t) {
    const n = Math.floor(t / 1e3), r = Math.floor((t - 1e3 * n) * ID);
    return new jn(n, r);
  }
  /**
   * Creates a new timestamp.
   *
   * @param seconds - The number of seconds of UTC time since Unix epoch
   *     1970-01-01T00:00:00Z. Must be from 0001-01-01T00:00:00Z to
   *     9999-12-31T23:59:59Z inclusive.
   * @param nanoseconds - The non-negative fractions of a second at nanosecond
   *     resolution. Negative second values with fractions must still have
   *     non-negative nanoseconds values that count forward in time. Must be
   *     from 0 to 999,999,999 inclusive.
   */
  constructor(t, n) {
    if (this.seconds = t, this.nanoseconds = n, n < 0)
      throw new Je(we.INVALID_ARGUMENT, "Timestamp nanoseconds out of range: " + n);
    if (n >= 1e9)
      throw new Je(we.INVALID_ARGUMENT, "Timestamp nanoseconds out of range: " + n);
    if (t < TD)
      throw new Je(we.INVALID_ARGUMENT, "Timestamp seconds out of range: " + t);
    if (t >= 253402300800)
      throw new Je(we.INVALID_ARGUMENT, "Timestamp seconds out of range: " + t);
  }
  /**
   * Converts a `Timestamp` to a JavaScript `Date` object. This conversion
   * causes a loss of precision since `Date` objects only support millisecond
   * precision.
   *
   * @returns JavaScript `Date` object representing the same point in time as
   *     this `Timestamp`, with millisecond precision.
   */
  toDate() {
    return new Date(this.toMillis());
  }
  /**
   * Converts a `Timestamp` to a numeric timestamp (in milliseconds since
   * epoch). This operation causes a loss of precision.
   *
   * @returns The point in time corresponding to this timestamp, represented as
   *     the number of milliseconds since Unix epoch 1970-01-01T00:00:00Z.
   */
  toMillis() {
    return 1e3 * this.seconds + this.nanoseconds / ID;
  }
  _compareTo(t) {
    return this.seconds === t.seconds ? gn(this.nanoseconds, t.nanoseconds) : gn(this.seconds, t.seconds);
  }
  /**
   * Returns true if this `Timestamp` is equal to the provided one.
   *
   * @param other - The `Timestamp` to compare against.
   * @returns true if this `Timestamp` is equal to the provided one.
   */
  isEqual(t) {
    return t.seconds === this.seconds && t.nanoseconds === this.nanoseconds;
  }
  /** Returns a textual representation of this `Timestamp`. */
  toString() {
    return "Timestamp(seconds=" + this.seconds + ", nanoseconds=" + this.nanoseconds + ")";
  }
  /**
   * Returns a JSON-serializable representation of this `Timestamp`.
   */
  toJSON() {
    return {
      type: jn._jsonSchemaVersion,
      seconds: this.seconds,
      nanoseconds: this.nanoseconds
    };
  }
  /**
   * Builds a `Timestamp` instance from a JSON object created by {@link Timestamp.toJSON}.
   */
  static fromJSON(t) {
    if (uy(t, jn._jsonSchema))
      return new jn(t.seconds, t.nanoseconds);
  }
  /**
   * Converts this object to a primitive string, which allows `Timestamp` objects
   * to be compared using the `>`, `<=`, `>=` and `>` operators.
   */
  valueOf() {
    const t = this.seconds - TD;
    return String(t).padStart(12, "0") + "." + String(this.nanoseconds).padStart(9, "0");
  }
}
jn._jsonSchemaVersion = "firestore/timestamp/1.0", jn._jsonSchema = {
  type: ui("string", jn._jsonSchemaVersion),
  seconds: ui("number"),
  nanoseconds: ui("number")
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Kt {
  static fromTimestamp(t) {
    return new Kt(t);
  }
  static min() {
    return new Kt(new jn(0, 0));
  }
  static max() {
    return new Kt(new jn(253402300799, 999999999));
  }
  constructor(t) {
    this.timestamp = t;
  }
  compareTo(t) {
    return this.timestamp._compareTo(t.timestamp);
  }
  isEqual(t) {
    return this.timestamp.isEqual(t.timestamp);
  }
  /** Returns a number representation of the version for use in spec tests. */
  toMicroseconds() {
    return 1e6 * this.timestamp.seconds + this.timestamp.nanoseconds / 1e3;
  }
  toString() {
    return "SnapshotVersion(" + this.timestamp.toString() + ")";
  }
  toTimestamp() {
    return this.timestamp;
  }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const sv = -1;
function xSe(e, t) {
  const n = e.toTimestamp().seconds, r = e.toTimestamp().nanoseconds + 1, i = Kt.fromTimestamp(r === 1e9 ? new jn(n + 1, 0) : new jn(n, r));
  return new $u(i, kt.empty(), t);
}
function ESe(e) {
  return new $u(e.readTime, e.key, sv);
}
class $u {
  constructor(t, n, r) {
    this.readTime = t, this.documentKey = n, this.largestBatchId = r;
  }
  /** Returns an offset that sorts before all regular offsets. */
  static min() {
    return new $u(Kt.min(), kt.empty(), sv);
  }
  /** Returns an offset that sorts after all regular offsets. */
  static max() {
    return new $u(Kt.max(), kt.empty(), sv);
  }
}
function CSe(e, t) {
  let n = e.readTime.compareTo(t.readTime);
  return n !== 0 ? n : (n = kt.comparator(e.documentKey, t.documentKey), n !== 0 ? n : gn(e.largestBatchId, t.largestBatchId));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const TSe = "The current tab is not in the required state to perform this operation. It might be necessary to refresh the browser tab.";
class ISe {
  constructor() {
    this.onCommittedListeners = [];
  }
  addOnCommittedListener(t) {
    this.onCommittedListeners.push(t);
  }
  raiseOnCommittedEvent() {
    this.onCommittedListeners.forEach((t) => t());
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function Dp(e) {
  if (e.code !== we.FAILED_PRECONDITION || e.message !== TSe)
    throw e;
  bt("LocalStore", "Unexpectedly lost primary lease");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Pe {
  constructor(t) {
    this.nextCallback = null, this.catchCallback = null, // When the operation resolves, we'll set result or error and mark isDone.
    this.result = void 0, this.error = void 0, this.isDone = !1, // Set to true when .then() or .catch() are called and prevents additional
    // chaining.
    this.callbackAttached = !1, t((n) => {
      this.isDone = !0, this.result = n, this.nextCallback && // value should be defined unless T is Void, but we can't express
      // that in the type system.
      this.nextCallback(n);
    }, (n) => {
      this.isDone = !0, this.error = n, this.catchCallback && this.catchCallback(n);
    });
  }
  catch(t) {
    return this.next(void 0, t);
  }
  next(t, n) {
    return this.callbackAttached && qt(59440), this.callbackAttached = !0, this.isDone ? this.error ? this.wrapFailure(n, this.error) : this.wrapSuccess(t, this.result) : new Pe((r, i) => {
      this.nextCallback = (o) => {
        this.wrapSuccess(t, o).next(r, i);
      }, this.catchCallback = (o) => {
        this.wrapFailure(n, o).next(r, i);
      };
    });
  }
  toPromise() {
    return new Promise((t, n) => {
      this.next(t, n);
    });
  }
  wrapUserFunction(t) {
    try {
      const n = t();
      return n instanceof Pe ? n : Pe.resolve(n);
    } catch (n) {
      return Pe.reject(n);
    }
  }
  wrapSuccess(t, n) {
    return t ? this.wrapUserFunction(() => t(n)) : Pe.resolve(n);
  }
  wrapFailure(t, n) {
    return t ? this.wrapUserFunction(() => t(n)) : Pe.reject(n);
  }
  static resolve(t) {
    return new Pe((n, r) => {
      n(t);
    });
  }
  static reject(t) {
    return new Pe((n, r) => {
      r(t);
    });
  }
  static waitFor(t) {
    return new Pe((n, r) => {
      let i = 0, o = 0, a = !1;
      t.forEach((s) => {
        ++i, s.next(() => {
          ++o, a && o === i && n();
        }, (c) => r(c));
      }), a = !0, o === i && n();
    });
  }
  /**
   * Given an array of predicate functions that asynchronously evaluate to a
   * boolean, implements a short-circuiting `or` between the results. Predicates
   * will be evaluated until one of them returns `true`, then stop. The final
   * result will be whether any of them returned `true`.
   */
  static or(t) {
    let n = Pe.resolve(!1);
    for (const r of t)
      n = n.next((i) => i ? Pe.resolve(i) : r());
    return n;
  }
  static forEach(t, n) {
    const r = [];
    return t.forEach((i, o) => {
      r.push(n.call(this, i, o));
    }), this.waitFor(r);
  }
  /**
   * Concurrently map all array elements through asynchronous function.
   */
  static mapArray(t, n) {
    return new Pe((r, i) => {
      const o = t.length, a = new Array(o);
      let s = 0;
      for (let c = 0; c < o; c++) {
        const l = c;
        n(t[l]).next((u) => {
          a[l] = u, ++s, s === o && r(a);
        }, (u) => i(u));
      }
    });
  }
  /**
   * An alternative to recursive PersistencePromise calls, that avoids
   * potential memory problems from unbounded chains of promises.
   *
   * The `action` will be called repeatedly while `condition` is true.
   */
  static doWhile(t, n) {
    return new Pe((r, i) => {
      const o = () => {
        t() === !0 ? n().next(() => {
          o();
        }, i) : r();
      };
      o();
    });
  }
}
function $Se(e) {
  const t = e.match(/Android ([\d.]+)/i), n = t ? t[1].split(".").slice(0, 2).join(".") : "-1";
  return Number(n);
}
function jp(e) {
  return e.name === "IndexedDbTransactionError";
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Bx {
  constructor(t, n) {
    this.previousValue = t, n && (n.sequenceNumberHandler = (r) => this._e(r), this.ae = (r) => n.writeSequenceNumber(r));
  }
  _e(t) {
    return this.previousValue = Math.max(t, this.previousValue), this.previousValue;
  }
  next() {
    const t = ++this.previousValue;
    return this.ae && this.ae(t), t;
  }
}
Bx.ue = -1;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const zx = -1;
function Hx(e) {
  return e == null;
}
function Z_(e) {
  return e === 0 && 1 / e == -1 / 0;
}
function ASe(e) {
  return typeof e == "number" && Number.isInteger(e) && !Z_(e) && e <= Number.MAX_SAFE_INTEGER && e >= Number.MIN_SAFE_INTEGER;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const $q = "";
function RSe(e) {
  let t = "";
  for (let n = 0; n < e.length; n++)
    t.length > 0 && (t = $D(t)), t = PSe(e.get(n), t);
  return $D(t);
}
function PSe(e, t) {
  let n = t;
  const r = e.length;
  for (let i = 0; i < r; i++) {
    const o = e.charAt(i);
    switch (o) {
      case "\0":
        n += "";
        break;
      case $q:
        n += "";
        break;
      default:
        n += o;
    }
  }
  return n;
}
function $D(e) {
  return e + $q + "";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function AD(e) {
  let t = 0;
  for (const n in e)
    Object.prototype.hasOwnProperty.call(e, n) && t++;
  return t;
}
function Xu(e, t) {
  for (const n in e)
    Object.prototype.hasOwnProperty.call(e, n) && t(n, e[n]);
}
function OSe(e, t) {
  const n = [];
  for (const r in e)
    Object.prototype.hasOwnProperty.call(e, r) && n.push(t(e[r], r, e));
  return n;
}
function Aq(e) {
  for (const t in e)
    if (Object.prototype.hasOwnProperty.call(e, t))
      return !1;
  return !0;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Fr {
  constructor(t, n) {
    this.comparator = t, this.root = n || Bi.EMPTY;
  }
  // Returns a copy of the map, with the specified key/value added or replaced.
  insert(t, n) {
    return new Fr(this.comparator, this.root.insert(t, n, this.comparator).copy(null, null, Bi.BLACK, null, null));
  }
  // Returns a copy of the map, with the specified key removed.
  remove(t) {
    return new Fr(this.comparator, this.root.remove(t, this.comparator).copy(null, null, Bi.BLACK, null, null));
  }
  // Returns the value of the node with the given key, or null.
  get(t) {
    let n = this.root;
    for (; !n.isEmpty(); ) {
      const r = this.comparator(t, n.key);
      if (r === 0)
        return n.value;
      r < 0 ? n = n.left : r > 0 && (n = n.right);
    }
    return null;
  }
  // Returns the index of the element in this sorted map, or -1 if it doesn't
  // exist.
  indexOf(t) {
    let n = 0, r = this.root;
    for (; !r.isEmpty(); ) {
      const i = this.comparator(t, r.key);
      if (i === 0)
        return n + r.left.size;
      i < 0 ? r = r.left : (
        // Count all nodes left of the node plus the node itself
        (n += r.left.size + 1, r = r.right)
      );
    }
    return -1;
  }
  isEmpty() {
    return this.root.isEmpty();
  }
  // Returns the total number of nodes in the map.
  get size() {
    return this.root.size;
  }
  // Returns the minimum key in the map.
  minKey() {
    return this.root.minKey();
  }
  // Returns the maximum key in the map.
  maxKey() {
    return this.root.maxKey();
  }
  // Traverses the map in key order and calls the specified action function
  // for each key/value pair. If action returns true, traversal is aborted.
  // Returns the first truthy value returned by action, or the last falsey
  // value returned by action.
  inorderTraversal(t) {
    return this.root.inorderTraversal(t);
  }
  forEach(t) {
    this.inorderTraversal((n, r) => (t(n, r), !1));
  }
  toString() {
    const t = [];
    return this.inorderTraversal((n, r) => (t.push(`${n}:${r}`), !1)), `{${t.join(", ")}}`;
  }
  // Traverses the map in reverse key order and calls the specified action
  // function for each key/value pair. If action returns true, traversal is
  // aborted.
  // Returns the first truthy value returned by action, or the last falsey
  // value returned by action.
  reverseTraversal(t) {
    return this.root.reverseTraversal(t);
  }
  // Returns an iterator over the SortedMap.
  getIterator() {
    return new jb(this.root, null, this.comparator, !1);
  }
  getIteratorFrom(t) {
    return new jb(this.root, t, this.comparator, !1);
  }
  getReverseIterator() {
    return new jb(this.root, null, this.comparator, !0);
  }
  getReverseIteratorFrom(t) {
    return new jb(this.root, t, this.comparator, !0);
  }
}
class jb {
  constructor(t, n, r, i) {
    this.isReverse = i, this.nodeStack = [];
    let o = 1;
    for (; !t.isEmpty(); )
      if (o = n ? r(t.key, n) : 1, // flip the comparison if we're going in reverse
      n && i && (o *= -1), o < 0)
        t = this.isReverse ? t.left : t.right;
      else {
        if (o === 0) {
          this.nodeStack.push(t);
          break;
        }
        this.nodeStack.push(t), t = this.isReverse ? t.right : t.left;
      }
  }
  getNext() {
    let t = this.nodeStack.pop();
    const n = {
      key: t.key,
      value: t.value
    };
    if (this.isReverse)
      for (t = t.left; !t.isEmpty(); )
        this.nodeStack.push(t), t = t.right;
    else
      for (t = t.right; !t.isEmpty(); )
        this.nodeStack.push(t), t = t.left;
    return n;
  }
  hasNext() {
    return this.nodeStack.length > 0;
  }
  peek() {
    if (this.nodeStack.length === 0)
      return null;
    const t = this.nodeStack[this.nodeStack.length - 1];
    return {
      key: t.key,
      value: t.value
    };
  }
}
class Bi {
  constructor(t, n, r, i, o) {
    this.key = t, this.value = n, this.color = r ?? Bi.RED, this.left = i ?? Bi.EMPTY, this.right = o ?? Bi.EMPTY, this.size = this.left.size + 1 + this.right.size;
  }
  // Returns a copy of the current node, optionally replacing pieces of it.
  copy(t, n, r, i, o) {
    return new Bi(t ?? this.key, n ?? this.value, r ?? this.color, i ?? this.left, o ?? this.right);
  }
  isEmpty() {
    return !1;
  }
  // Traverses the tree in key order and calls the specified action function
  // for each node. If action returns true, traversal is aborted.
  // Returns the first truthy value returned by action, or the last falsey
  // value returned by action.
  inorderTraversal(t) {
    return this.left.inorderTraversal(t) || t(this.key, this.value) || this.right.inorderTraversal(t);
  }
  // Traverses the tree in reverse key order and calls the specified action
  // function for each node. If action returns true, traversal is aborted.
  // Returns the first truthy value returned by action, or the last falsey
  // value returned by action.
  reverseTraversal(t) {
    return this.right.reverseTraversal(t) || t(this.key, this.value) || this.left.reverseTraversal(t);
  }
  // Returns the minimum node in the tree.
  min() {
    return this.left.isEmpty() ? this : this.left.min();
  }
  // Returns the maximum key in the tree.
  minKey() {
    return this.min().key;
  }
  // Returns the maximum key in the tree.
  maxKey() {
    return this.right.isEmpty() ? this.key : this.right.maxKey();
  }
  // Returns new tree, with the key/value added.
  insert(t, n, r) {
    let i = this;
    const o = r(t, i.key);
    return i = o < 0 ? i.copy(null, null, null, i.left.insert(t, n, r), null) : o === 0 ? i.copy(null, n, null, null, null) : i.copy(null, null, null, null, i.right.insert(t, n, r)), i.fixUp();
  }
  removeMin() {
    if (this.left.isEmpty())
      return Bi.EMPTY;
    let t = this;
    return t.left.isRed() || t.left.left.isRed() || (t = t.moveRedLeft()), t = t.copy(null, null, null, t.left.removeMin(), null), t.fixUp();
  }
  // Returns new tree, with the specified item removed.
  remove(t, n) {
    let r, i = this;
    if (n(t, i.key) < 0)
      i.left.isEmpty() || i.left.isRed() || i.left.left.isRed() || (i = i.moveRedLeft()), i = i.copy(null, null, null, i.left.remove(t, n), null);
    else {
      if (i.left.isRed() && (i = i.rotateRight()), i.right.isEmpty() || i.right.isRed() || i.right.left.isRed() || (i = i.moveRedRight()), n(t, i.key) === 0) {
        if (i.right.isEmpty())
          return Bi.EMPTY;
        r = i.right.min(), i = i.copy(r.key, r.value, null, null, i.right.removeMin());
      }
      i = i.copy(null, null, null, null, i.right.remove(t, n));
    }
    return i.fixUp();
  }
  isRed() {
    return this.color;
  }
  // Returns new tree after performing any needed rotations.
  fixUp() {
    let t = this;
    return t.right.isRed() && !t.left.isRed() && (t = t.rotateLeft()), t.left.isRed() && t.left.left.isRed() && (t = t.rotateRight()), t.left.isRed() && t.right.isRed() && (t = t.colorFlip()), t;
  }
  moveRedLeft() {
    let t = this.colorFlip();
    return t.right.left.isRed() && (t = t.copy(null, null, null, null, t.right.rotateRight()), t = t.rotateLeft(), t = t.colorFlip()), t;
  }
  moveRedRight() {
    let t = this.colorFlip();
    return t.left.left.isRed() && (t = t.rotateRight(), t = t.colorFlip()), t;
  }
  rotateLeft() {
    const t = this.copy(null, null, Bi.RED, null, this.right.left);
    return this.right.copy(null, null, this.color, t, null);
  }
  rotateRight() {
    const t = this.copy(null, null, Bi.RED, this.left.right, null);
    return this.left.copy(null, null, this.color, null, t);
  }
  colorFlip() {
    const t = this.left.copy(null, null, !this.left.color, null, null), n = this.right.copy(null, null, !this.right.color, null, null);
    return this.copy(null, null, !this.color, t, n);
  }
  // For testing.
  checkMaxDepth() {
    const t = this.check();
    return Math.pow(2, t) <= this.size + 1;
  }
  // In a balanced RB tree, the black-depth (number of black nodes) from root to
  // leaves is equal on both sides.  This function verifies that or asserts.
  check() {
    if (this.isRed() && this.left.isRed())
      throw qt(43730, {
        key: this.key,
        value: this.value
      });
    if (this.right.isRed())
      throw qt(14113, {
        key: this.key,
        value: this.value
      });
    const t = this.left.check();
    if (t !== this.right.check())
      throw qt(27949);
    return t + (this.isRed() ? 0 : 1);
  }
}
Bi.EMPTY = null, Bi.RED = !0, Bi.BLACK = !1;
Bi.EMPTY = new // Represents an empty node (a leaf node in the Red-Black Tree).
class {
  constructor() {
    this.size = 0;
  }
  get key() {
    throw qt(57766);
  }
  get value() {
    throw qt(16141);
  }
  get color() {
    throw qt(16727);
  }
  get left() {
    throw qt(29726);
  }
  get right() {
    throw qt(36894);
  }
  // Returns a copy of the current node.
  copy(t, n, r, i, o) {
    return this;
  }
  // Returns a copy of the tree, with the specified key/value added.
  insert(t, n, r) {
    return new Bi(t, n);
  }
  // Returns a copy of the tree, with the specified key removed.
  remove(t, n) {
    return this;
  }
  isEmpty() {
    return !0;
  }
  inorderTraversal(t) {
    return !1;
  }
  reverseTraversal(t) {
    return !1;
  }
  minKey() {
    return null;
  }
  maxKey() {
    return null;
  }
  isRed() {
    return !1;
  }
  // For testing.
  checkMaxDepth() {
    return !0;
  }
  check() {
    return 0;
  }
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class wi {
  constructor(t) {
    this.comparator = t, this.data = new Fr(this.comparator);
  }
  has(t) {
    return this.data.get(t) !== null;
  }
  first() {
    return this.data.minKey();
  }
  last() {
    return this.data.maxKey();
  }
  get size() {
    return this.data.size;
  }
  indexOf(t) {
    return this.data.indexOf(t);
  }
  /** Iterates elements in order defined by "comparator" */
  forEach(t) {
    this.data.inorderTraversal((n, r) => (t(n), !1));
  }
  /** Iterates over `elem`s such that: range[0] &lt;= elem &lt; range[1]. */
  forEachInRange(t, n) {
    const r = this.data.getIteratorFrom(t[0]);
    for (; r.hasNext(); ) {
      const i = r.getNext();
      if (this.comparator(i.key, t[1]) >= 0)
        return;
      n(i.key);
    }
  }
  /**
   * Iterates over `elem`s such that: start &lt;= elem until false is returned.
   */
  forEachWhile(t, n) {
    let r;
    for (r = n !== void 0 ? this.data.getIteratorFrom(n) : this.data.getIterator(); r.hasNext(); )
      if (!t(r.getNext().key))
        return;
  }
  /** Finds the least element greater than or equal to `elem`. */
  firstAfterOrEqual(t) {
    const n = this.data.getIteratorFrom(t);
    return n.hasNext() ? n.getNext().key : null;
  }
  getIterator() {
    return new RD(this.data.getIterator());
  }
  getIteratorFrom(t) {
    return new RD(this.data.getIteratorFrom(t));
  }
  /** Inserts or updates an element */
  add(t) {
    return this.copy(this.data.remove(t).insert(t, !0));
  }
  /** Deletes an element */
  delete(t) {
    return this.has(t) ? this.copy(this.data.remove(t)) : this;
  }
  isEmpty() {
    return this.data.isEmpty();
  }
  unionWith(t) {
    let n = this;
    return n.size < t.size && (n = t, t = this), t.forEach((r) => {
      n = n.add(r);
    }), n;
  }
  isEqual(t) {
    if (!(t instanceof wi) || this.size !== t.size)
      return !1;
    const n = this.data.getIterator(), r = t.data.getIterator();
    for (; n.hasNext(); ) {
      const i = n.getNext().key, o = r.getNext().key;
      if (this.comparator(i, o) !== 0)
        return !1;
    }
    return !0;
  }
  toArray() {
    const t = [];
    return this.forEach((n) => {
      t.push(n);
    }), t;
  }
  toString() {
    const t = [];
    return this.forEach((n) => t.push(n)), "SortedSet(" + t.toString() + ")";
  }
  copy(t) {
    const n = new wi(this.comparator);
    return n.data = t, n;
  }
}
class RD {
  constructor(t) {
    this.iter = t;
  }
  getNext() {
    return this.iter.getNext().key;
  }
  hasNext() {
    return this.iter.hasNext();
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class va {
  constructor(t) {
    this.fields = t, // TODO(dimond): validation of FieldMask
    // Sort the field mask to support `FieldMask.isEqual()` and assert below.
    t.sort(zi.comparator);
  }
  static empty() {
    return new va([]);
  }
  /**
   * Returns a new FieldMask object that is the result of adding all the given
   * fields paths to this field mask.
   */
  unionWith(t) {
    let n = new wi(zi.comparator);
    for (const r of this.fields)
      n = n.add(r);
    for (const r of t)
      n = n.add(r);
    return new va(n.toArray());
  }
  /**
   * Verifies that `fieldPath` is included by at least one field in this field
   * mask.
   *
   * This is an O(n) operation, where `n` is the size of the field mask.
   */
  covers(t) {
    for (const n of this.fields)
      if (n.isPrefixOf(t))
        return !0;
    return !1;
  }
  isEqual(t) {
    return Tg(this.fields, t.fields, (n, r) => n.isEqual(r));
  }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Rq extends Error {
  constructor() {
    super(...arguments), this.name = "Base64DecodeError";
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Wi {
  constructor(t) {
    this.binaryString = t;
  }
  static fromBase64String(t) {
    const n = function(i) {
      try {
        return atob(i);
      } catch (o) {
        throw typeof DOMException < "u" && o instanceof DOMException ? new Rq("Invalid base64 string: " + o) : o;
      }
    }(t);
    return new Wi(n);
  }
  static fromUint8Array(t) {
    const n = (
      /**
      * Helper function to convert an Uint8array to a binary string.
      */
      function(i) {
        let o = "";
        for (let a = 0; a < i.length; ++a)
          o += String.fromCharCode(i[a]);
        return o;
      }(t)
    );
    return new Wi(n);
  }
  [Symbol.iterator]() {
    let t = 0;
    return {
      next: () => t < this.binaryString.length ? {
        value: this.binaryString.charCodeAt(t++),
        done: !1
      } : {
        value: void 0,
        done: !0
      }
    };
  }
  toBase64() {
    return function(n) {
      return btoa(n);
    }(this.binaryString);
  }
  toUint8Array() {
    return function(n) {
      const r = new Uint8Array(n.length);
      for (let i = 0; i < n.length; i++)
        r[i] = n.charCodeAt(i);
      return r;
    }(this.binaryString);
  }
  approximateByteSize() {
    return 2 * this.binaryString.length;
  }
  compareTo(t) {
    return gn(this.binaryString, t.binaryString);
  }
  isEqual(t) {
    return this.binaryString === t.binaryString;
  }
}
Wi.EMPTY_BYTE_STRING = new Wi("");
const MSe = new RegExp(/^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(?:\.(\d+))?Z$/);
function Au(e) {
  if (Fn(!!e, 39018), typeof e == "string") {
    let t = 0;
    const n = MSe.exec(e);
    if (Fn(!!n, 46558, {
      timestamp: e
    }), n[1]) {
      let i = n[1];
      i = (i + "000000000").substr(0, 9), t = Number(i);
    }
    const r = new Date(e);
    return {
      seconds: Math.floor(r.getTime() / 1e3),
      nanos: t
    };
  }
  return {
    seconds: ti(e.seconds),
    nanos: ti(e.nanos)
  };
}
function ti(e) {
  return typeof e == "number" ? e : typeof e == "string" ? Number(e) : 0;
}
function Ru(e) {
  return typeof e == "string" ? Wi.fromBase64String(e) : Wi.fromUint8Array(e);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Pq = "server_timestamp", Oq = "__type__", Mq = "__previous_value__", kq = "__local_write_time__";
function Ux(e) {
  var t, n;
  return ((n = (((t = e == null ? void 0 : e.mapValue) === null || t === void 0 ? void 0 : t.fields) || {})[Oq]) === null || n === void 0 ? void 0 : n.stringValue) === Pq;
}
function Wx(e) {
  const t = e.mapValue.fields[Mq];
  return Ux(t) ? Wx(t) : t;
}
function cv(e) {
  const t = Au(e.mapValue.fields[kq].timestampValue);
  return new jn(t.seconds, t.nanos);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class kSe {
  /**
   * Constructs a DatabaseInfo using the provided host, databaseId and
   * persistenceKey.
   *
   * @param databaseId - The database to use.
   * @param appId - The Firebase App Id.
   * @param persistenceKey - A unique identifier for this Firestore's local
   * storage (used in conjunction with the databaseId).
   * @param host - The Firestore backend host to connect to.
   * @param ssl - Whether to use SSL when connecting.
   * @param forceLongPolling - Whether to use the forceLongPolling option
   * when using WebChannel as the network transport.
   * @param autoDetectLongPolling - Whether to use the detectBufferingProxy
   * option when using WebChannel as the network transport.
   * @param longPollingOptions Options that configure long-polling.
   * @param useFetchStreams Whether to use the Fetch API instead of
   * XMLHTTPRequest
   */
  constructor(t, n, r, i, o, a, s, c, l, u) {
    this.databaseId = t, this.appId = n, this.persistenceKey = r, this.host = i, this.ssl = o, this.forceLongPolling = a, this.autoDetectLongPolling = s, this.longPollingOptions = c, this.useFetchStreams = l, this.isUsingEmulator = u;
  }
}
const lv = "(default)";
class uv {
  constructor(t, n) {
    this.projectId = t, this.database = n || lv;
  }
  static empty() {
    return new uv("", "");
  }
  get isDefaultDatabase() {
    return this.database === lv;
  }
  isEqual(t) {
    return t instanceof uv && t.projectId === this.projectId && t.database === this.database;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Nq = "__type__", Dq = "__max__", Lb = {
  mapValue: {
    fields: {
      __type__: {
        stringValue: Dq
      }
    }
  }
}, jq = "__vector__", eS = "value";
function Pu(e) {
  return "nullValue" in e ? 0 : "booleanValue" in e ? 1 : "integerValue" in e || "doubleValue" in e ? 2 : "timestampValue" in e ? 3 : "stringValue" in e ? 5 : "bytesValue" in e ? 6 : "referenceValue" in e ? 7 : "geoPointValue" in e ? 8 : "arrayValue" in e ? 9 : "mapValue" in e ? Ux(e) ? 4 : DSe(e) ? 9007199254740991 : NSe(e) ? 10 : 11 : qt(28295, {
    value: e
  });
}
function _c(e, t) {
  if (e === t)
    return !0;
  const n = Pu(e);
  if (n !== Pu(t))
    return !1;
  switch (n) {
    case 0:
    case 9007199254740991:
      return !0;
    case 1:
      return e.booleanValue === t.booleanValue;
    case 4:
      return cv(e).isEqual(cv(t));
    case 3:
      return function(i, o) {
        if (typeof i.timestampValue == "string" && typeof o.timestampValue == "string" && i.timestampValue.length === o.timestampValue.length)
          return i.timestampValue === o.timestampValue;
        const a = Au(i.timestampValue), s = Au(o.timestampValue);
        return a.seconds === s.seconds && a.nanos === s.nanos;
      }(e, t);
    case 5:
      return e.stringValue === t.stringValue;
    case 6:
      return function(i, o) {
        return Ru(i.bytesValue).isEqual(Ru(o.bytesValue));
      }(e, t);
    case 7:
      return e.referenceValue === t.referenceValue;
    case 8:
      return function(i, o) {
        return ti(i.geoPointValue.latitude) === ti(o.geoPointValue.latitude) && ti(i.geoPointValue.longitude) === ti(o.geoPointValue.longitude);
      }(e, t);
    case 2:
      return function(i, o) {
        if ("integerValue" in i && "integerValue" in o)
          return ti(i.integerValue) === ti(o.integerValue);
        if ("doubleValue" in i && "doubleValue" in o) {
          const a = ti(i.doubleValue), s = ti(o.doubleValue);
          return a === s ? Z_(a) === Z_(s) : isNaN(a) && isNaN(s);
        }
        return !1;
      }(e, t);
    case 9:
      return Tg(e.arrayValue.values || [], t.arrayValue.values || [], _c);
    case 10:
    case 11:
      return function(i, o) {
        const a = i.mapValue.fields || {}, s = o.mapValue.fields || {};
        if (AD(a) !== AD(s))
          return !1;
        for (const c in a)
          if (a.hasOwnProperty(c) && (s[c] === void 0 || !_c(a[c], s[c])))
            return !1;
        return !0;
      }(e, t);
    default:
      return qt(52216, {
        left: e
      });
  }
}
function dv(e, t) {
  return (e.values || []).find((n) => _c(n, t)) !== void 0;
}
function Ig(e, t) {
  if (e === t)
    return 0;
  const n = Pu(e), r = Pu(t);
  if (n !== r)
    return gn(n, r);
  switch (n) {
    case 0:
    case 9007199254740991:
      return 0;
    case 1:
      return gn(e.booleanValue, t.booleanValue);
    case 2:
      return function(o, a) {
        const s = ti(o.integerValue || o.doubleValue), c = ti(a.integerValue || a.doubleValue);
        return s < c ? -1 : s > c ? 1 : s === c ? 0 : (
          // one or both are NaN.
          isNaN(s) ? isNaN(c) ? 0 : -1 : 1
        );
      }(e, t);
    case 3:
      return PD(e.timestampValue, t.timestampValue);
    case 4:
      return PD(cv(e), cv(t));
    case 5:
      return j$(e.stringValue, t.stringValue);
    case 6:
      return function(o, a) {
        const s = Ru(o), c = Ru(a);
        return s.compareTo(c);
      }(e.bytesValue, t.bytesValue);
    case 7:
      return function(o, a) {
        const s = o.split("/"), c = a.split("/");
        for (let l = 0; l < s.length && l < c.length; l++) {
          const u = gn(s[l], c[l]);
          if (u !== 0)
            return u;
        }
        return gn(s.length, c.length);
      }(e.referenceValue, t.referenceValue);
    case 8:
      return function(o, a) {
        const s = gn(ti(o.latitude), ti(a.latitude));
        return s !== 0 ? s : gn(ti(o.longitude), ti(a.longitude));
      }(e.geoPointValue, t.geoPointValue);
    case 9:
      return OD(e.arrayValue, t.arrayValue);
    case 10:
      return function(o, a) {
        var s, c, l, u;
        const d = o.fields || {}, f = a.fields || {}, h = (s = d[eS]) === null || s === void 0 ? void 0 : s.arrayValue, p = (c = f[eS]) === null || c === void 0 ? void 0 : c.arrayValue, g = gn(((l = h == null ? void 0 : h.values) === null || l === void 0 ? void 0 : l.length) || 0, ((u = p == null ? void 0 : p.values) === null || u === void 0 ? void 0 : u.length) || 0);
        return g !== 0 ? g : OD(h, p);
      }(e.mapValue, t.mapValue);
    case 11:
      return function(o, a) {
        if (o === Lb.mapValue && a === Lb.mapValue)
          return 0;
        if (o === Lb.mapValue)
          return 1;
        if (a === Lb.mapValue)
          return -1;
        const s = o.fields || {}, c = Object.keys(s), l = a.fields || {}, u = Object.keys(l);
        c.sort(), u.sort();
        for (let d = 0; d < c.length && d < u.length; ++d) {
          const f = j$(c[d], u[d]);
          if (f !== 0)
            return f;
          const h = Ig(s[c[d]], l[u[d]]);
          if (h !== 0)
            return h;
        }
        return gn(c.length, u.length);
      }(e.mapValue, t.mapValue);
    default:
      throw qt(23264, {
        le: n
      });
  }
}
function PD(e, t) {
  if (typeof e == "string" && typeof t == "string" && e.length === t.length)
    return gn(e, t);
  const n = Au(e), r = Au(t), i = gn(n.seconds, r.seconds);
  return i !== 0 ? i : gn(n.nanos, r.nanos);
}
function OD(e, t) {
  const n = e.values || [], r = t.values || [];
  for (let i = 0; i < n.length && i < r.length; ++i) {
    const o = Ig(n[i], r[i]);
    if (o)
      return o;
  }
  return gn(n.length, r.length);
}
function $g(e) {
  return L$(e);
}
function L$(e) {
  return "nullValue" in e ? "null" : "booleanValue" in e ? "" + e.booleanValue : "integerValue" in e ? "" + e.integerValue : "doubleValue" in e ? "" + e.doubleValue : "timestampValue" in e ? function(n) {
    const r = Au(n);
    return `time(${r.seconds},${r.nanos})`;
  }(e.timestampValue) : "stringValue" in e ? e.stringValue : "bytesValue" in e ? function(n) {
    return Ru(n).toBase64();
  }(e.bytesValue) : "referenceValue" in e ? function(n) {
    return kt.fromName(n).toString();
  }(e.referenceValue) : "geoPointValue" in e ? function(n) {
    return `geo(${n.latitude},${n.longitude})`;
  }(e.geoPointValue) : "arrayValue" in e ? function(n) {
    let r = "[", i = !0;
    for (const o of n.values || [])
      i ? i = !1 : r += ",", r += L$(o);
    return r + "]";
  }(e.arrayValue) : "mapValue" in e ? function(n) {
    const r = Object.keys(n.fields || {}).sort();
    let i = "{", o = !0;
    for (const a of r)
      o ? o = !1 : i += ",", i += `${a}:${L$(n.fields[a])}`;
    return i + "}";
  }(e.mapValue) : qt(61005, {
    value: e
  });
}
function r_(e) {
  switch (Pu(e)) {
    case 0:
    case 1:
      return 4;
    case 2:
      return 8;
    case 3:
    case 8:
      return 16;
    case 4:
      const t = Wx(e);
      return t ? 16 + r_(t) : 16;
    case 5:
      return 2 * e.stringValue.length;
    case 6:
      return Ru(e.bytesValue).approximateByteSize();
    case 7:
      return e.referenceValue.length;
    case 9:
      return function(r) {
        return (r.values || []).reduce((i, o) => i + r_(o), 0);
      }(e.arrayValue);
    case 10:
    case 11:
      return function(r) {
        let i = 0;
        return Xu(r.fields, (o, a) => {
          i += o.length + r_(a);
        }), i;
      }(e.mapValue);
    default:
      throw qt(13486, {
        value: e
      });
  }
}
function tS(e, t) {
  return {
    referenceValue: `projects/${e.projectId}/databases/${e.database}/documents/${t.path.canonicalString()}`
  };
}
function F$(e) {
  return !!e && "integerValue" in e;
}
function zO(e) {
  return !!e && "arrayValue" in e;
}
function MD(e) {
  return !!e && "nullValue" in e;
}
function kD(e) {
  return !!e && "doubleValue" in e && isNaN(Number(e.doubleValue));
}
function i_(e) {
  return !!e && "mapValue" in e;
}
function NSe(e) {
  var t, n;
  return ((n = (((t = e == null ? void 0 : e.mapValue) === null || t === void 0 ? void 0 : t.fields) || {})[Nq]) === null || n === void 0 ? void 0 : n.stringValue) === jq;
}
function R0(e) {
  if (e.geoPointValue)
    return {
      geoPointValue: Object.assign({}, e.geoPointValue)
    };
  if (e.timestampValue && typeof e.timestampValue == "object")
    return {
      timestampValue: Object.assign({}, e.timestampValue)
    };
  if (e.mapValue) {
    const t = {
      mapValue: {
        fields: {}
      }
    };
    return Xu(e.mapValue.fields, (n, r) => t.mapValue.fields[n] = R0(r)), t;
  }
  if (e.arrayValue) {
    const t = {
      arrayValue: {
        values: []
      }
    };
    for (let n = 0; n < (e.arrayValue.values || []).length; ++n)
      t.arrayValue.values[n] = R0(e.arrayValue.values[n]);
    return t;
  }
  return Object.assign({}, e);
}
function DSe(e) {
  return (((e.mapValue || {}).fields || {}).__type__ || {}).stringValue === Dq;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Jo {
  constructor(t) {
    this.value = t;
  }
  static empty() {
    return new Jo({
      mapValue: {}
    });
  }
  /**
   * Returns the value at the given path or null.
   *
   * @param path - the path to search
   * @returns The value at the path or null if the path is not set.
   */
  field(t) {
    if (t.isEmpty())
      return this.value;
    {
      let n = this.value;
      for (let r = 0; r < t.length - 1; ++r)
        if (n = (n.mapValue.fields || {})[t.get(r)], !i_(n))
          return null;
      return n = (n.mapValue.fields || {})[t.lastSegment()], n || null;
    }
  }
  /**
   * Sets the field to the provided value.
   *
   * @param path - The field path to set.
   * @param value - The value to set.
   */
  set(t, n) {
    this.getFieldsMap(t.popLast())[t.lastSegment()] = R0(n);
  }
  /**
   * Sets the provided fields to the provided values.
   *
   * @param data - A map of fields to values (or null for deletes).
   */
  setAll(t) {
    let n = zi.emptyPath(), r = {}, i = [];
    t.forEach((a, s) => {
      if (!n.isImmediateParentOf(s)) {
        const c = this.getFieldsMap(n);
        this.applyChanges(c, r, i), r = {}, i = [], n = s.popLast();
      }
      a ? r[s.lastSegment()] = R0(a) : i.push(s.lastSegment());
    });
    const o = this.getFieldsMap(n);
    this.applyChanges(o, r, i);
  }
  /**
   * Removes the field at the specified path. If there is no field at the
   * specified path, nothing is changed.
   *
   * @param path - The field path to remove.
   */
  delete(t) {
    const n = this.field(t.popLast());
    i_(n) && n.mapValue.fields && delete n.mapValue.fields[t.lastSegment()];
  }
  isEqual(t) {
    return _c(this.value, t.value);
  }
  /**
   * Returns the map that contains the leaf element of `path`. If the parent
   * entry does not yet exist, or if it is not a map, a new map will be created.
   */
  getFieldsMap(t) {
    let n = this.value;
    n.mapValue.fields || (n.mapValue = {
      fields: {}
    });
    for (let r = 0; r < t.length; ++r) {
      let i = n.mapValue.fields[t.get(r)];
      i_(i) && i.mapValue.fields || (i = {
        mapValue: {
          fields: {}
        }
      }, n.mapValue.fields[t.get(r)] = i), n = i;
    }
    return n.mapValue.fields;
  }
  /**
   * Modifies `fieldsMap` by adding, replacing or deleting the specified
   * entries.
   */
  applyChanges(t, n, r) {
    Xu(n, (i, o) => t[i] = o);
    for (const i of r)
      delete t[i];
  }
  clone() {
    return new Jo(R0(this.value));
  }
}
function Lq(e) {
  const t = [];
  return Xu(e.fields, (n, r) => {
    const i = new zi([n]);
    if (i_(r)) {
      const o = Lq(r.mapValue).fields;
      if (o.length === 0)
        t.push(i);
      else
        for (const a of o)
          t.push(i.child(a));
    } else
      t.push(i);
  }), new va(t);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class so {
  constructor(t, n, r, i, o, a, s) {
    this.key = t, this.documentType = n, this.version = r, this.readTime = i, this.createTime = o, this.data = a, this.documentState = s;
  }
  /**
   * Creates a document with no known version or data, but which can serve as
   * base document for mutations.
   */
  static newInvalidDocument(t) {
    return new so(
      t,
      0,
      /* version */
      Kt.min(),
      /* readTime */
      Kt.min(),
      /* createTime */
      Kt.min(),
      Jo.empty(),
      0
      /* DocumentState.SYNCED */
    );
  }
  /**
   * Creates a new document that is known to exist with the given data at the
   * given version.
   */
  static newFoundDocument(t, n, r, i) {
    return new so(
      t,
      1,
      /* version */
      n,
      /* readTime */
      Kt.min(),
      /* createTime */
      r,
      i,
      0
      /* DocumentState.SYNCED */
    );
  }
  /** Creates a new document that is known to not exist at the given version. */
  static newNoDocument(t, n) {
    return new so(
      t,
      2,
      /* version */
      n,
      /* readTime */
      Kt.min(),
      /* createTime */
      Kt.min(),
      Jo.empty(),
      0
      /* DocumentState.SYNCED */
    );
  }
  /**
   * Creates a new document that is known to exist at the given version but
   * whose data is not known (e.g. a document that was updated without a known
   * base document).
   */
  static newUnknownDocument(t, n) {
    return new so(
      t,
      3,
      /* version */
      n,
      /* readTime */
      Kt.min(),
      /* createTime */
      Kt.min(),
      Jo.empty(),
      2
      /* DocumentState.HAS_COMMITTED_MUTATIONS */
    );
  }
  /**
   * Changes the document type to indicate that it exists and that its version
   * and data are known.
   */
  convertToFoundDocument(t, n) {
    return !this.createTime.isEqual(Kt.min()) || this.documentType !== 2 && this.documentType !== 0 || (this.createTime = t), this.version = t, this.documentType = 1, this.data = n, this.documentState = 0, this;
  }
  /**
   * Changes the document type to indicate that it doesn't exist at the given
   * version.
   */
  convertToNoDocument(t) {
    return this.version = t, this.documentType = 2, this.data = Jo.empty(), this.documentState = 0, this;
  }
  /**
   * Changes the document type to indicate that it exists at a given version but
   * that its data is not known (e.g. a document that was updated without a known
   * base document).
   */
  convertToUnknownDocument(t) {
    return this.version = t, this.documentType = 3, this.data = Jo.empty(), this.documentState = 2, this;
  }
  setHasCommittedMutations() {
    return this.documentState = 2, this;
  }
  setHasLocalMutations() {
    return this.documentState = 1, this.version = Kt.min(), this;
  }
  setReadTime(t) {
    return this.readTime = t, this;
  }
  get hasLocalMutations() {
    return this.documentState === 1;
  }
  get hasCommittedMutations() {
    return this.documentState === 2;
  }
  get hasPendingWrites() {
    return this.hasLocalMutations || this.hasCommittedMutations;
  }
  isValidDocument() {
    return this.documentType !== 0;
  }
  isFoundDocument() {
    return this.documentType === 1;
  }
  isNoDocument() {
    return this.documentType === 2;
  }
  isUnknownDocument() {
    return this.documentType === 3;
  }
  isEqual(t) {
    return t instanceof so && this.key.isEqual(t.key) && this.version.isEqual(t.version) && this.documentType === t.documentType && this.documentState === t.documentState && this.data.isEqual(t.data);
  }
  mutableCopy() {
    return new so(this.key, this.documentType, this.version, this.readTime, this.createTime, this.data.clone(), this.documentState);
  }
  toString() {
    return `Document(${this.key}, ${this.version}, ${JSON.stringify(this.data.value)}, {createTime: ${this.createTime}}), {documentType: ${this.documentType}}), {documentState: ${this.documentState}})`;
  }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Ag {
  constructor(t, n) {
    this.position = t, this.inclusive = n;
  }
}
function ND(e, t, n) {
  let r = 0;
  for (let i = 0; i < e.position.length; i++) {
    const o = t[i], a = e.position[i];
    if (o.field.isKeyField() ? r = kt.comparator(kt.fromName(a.referenceValue), n.key) : r = Ig(a, n.data.field(o.field)), o.dir === "desc" && (r *= -1), r !== 0)
      break;
  }
  return r;
}
function DD(e, t) {
  if (e === null)
    return t === null;
  if (t === null || e.inclusive !== t.inclusive || e.position.length !== t.position.length)
    return !1;
  for (let n = 0; n < e.position.length; n++)
    if (!_c(e.position[n], t.position[n]))
      return !1;
  return !0;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class fv {
  constructor(t, n = "asc") {
    this.field = t, this.dir = n;
  }
}
function jSe(e, t) {
  return e.dir === t.dir && e.field.isEqual(t.field);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Fq {
}
class li extends Fq {
  constructor(t, n, r) {
    super(), this.field = t, this.op = n, this.value = r;
  }
  /**
   * Creates a filter based on the provided arguments.
   */
  static create(t, n, r) {
    return t.isKeyField() ? n === "in" || n === "not-in" ? this.createKeyFieldInFilter(t, n, r) : new FSe(t, n, r) : n === "array-contains" ? new zSe(t, r) : n === "in" ? new HSe(t, r) : n === "not-in" ? new USe(t, r) : n === "array-contains-any" ? new WSe(t, r) : new li(t, n, r);
  }
  static createKeyFieldInFilter(t, n, r) {
    return n === "in" ? new VSe(t, r) : new BSe(t, r);
  }
  matches(t) {
    const n = t.data.field(this.field);
    return this.op === "!=" ? n !== null && n.nullValue === void 0 && this.matchesComparison(Ig(n, this.value)) : n !== null && Pu(this.value) === Pu(n) && this.matchesComparison(Ig(n, this.value));
  }
  matchesComparison(t) {
    switch (this.op) {
      case "<":
        return t < 0;
      case "<=":
        return t <= 0;
      case "==":
        return t === 0;
      case "!=":
        return t !== 0;
      case ">":
        return t > 0;
      case ">=":
        return t >= 0;
      default:
        return qt(47266, {
          operator: this.op
        });
    }
  }
  isInequality() {
    return [
      "<",
      "<=",
      ">",
      ">=",
      "!=",
      "not-in"
      /* Operator.NOT_IN */
    ].indexOf(this.op) >= 0;
  }
  getFlattenedFilters() {
    return [this];
  }
  getFilters() {
    return [this];
  }
}
class $s extends Fq {
  constructor(t, n) {
    super(), this.filters = t, this.op = n, this.he = null;
  }
  /**
   * Creates a filter based on the provided arguments.
   */
  static create(t, n) {
    return new $s(t, n);
  }
  matches(t) {
    return Vq(this) ? this.filters.find((n) => !n.matches(t)) === void 0 : this.filters.find((n) => n.matches(t)) !== void 0;
  }
  getFlattenedFilters() {
    return this.he !== null || (this.he = this.filters.reduce((t, n) => t.concat(n.getFlattenedFilters()), [])), this.he;
  }
  // Returns a mutable copy of `this.filters`
  getFilters() {
    return Object.assign([], this.filters);
  }
}
function Vq(e) {
  return e.op === "and";
}
function Bq(e) {
  return LSe(e) && Vq(e);
}
function LSe(e) {
  for (const t of e.filters)
    if (t instanceof $s)
      return !1;
  return !0;
}
function V$(e) {
  if (e instanceof li)
    return e.field.canonicalString() + e.op.toString() + $g(e.value);
  if (Bq(e))
    return e.filters.map((t) => V$(t)).join(",");
  {
    const t = e.filters.map((n) => V$(n)).join(",");
    return `${e.op}(${t})`;
  }
}
function zq(e, t) {
  return e instanceof li ? function(r, i) {
    return i instanceof li && r.op === i.op && r.field.isEqual(i.field) && _c(r.value, i.value);
  }(e, t) : e instanceof $s ? function(r, i) {
    return i instanceof $s && r.op === i.op && r.filters.length === i.filters.length ? r.filters.reduce((o, a, s) => o && zq(a, i.filters[s]), !0) : !1;
  }(e, t) : void qt(19439);
}
function Hq(e) {
  return e instanceof li ? function(n) {
    return `${n.field.canonicalString()} ${n.op} ${$g(n.value)}`;
  }(e) : e instanceof $s ? function(n) {
    return n.op.toString() + " {" + n.getFilters().map(Hq).join(" ,") + "}";
  }(e) : "Filter";
}
class FSe extends li {
  constructor(t, n, r) {
    super(t, n, r), this.key = kt.fromName(r.referenceValue);
  }
  matches(t) {
    const n = kt.comparator(t.key, this.key);
    return this.matchesComparison(n);
  }
}
class VSe extends li {
  constructor(t, n) {
    super(t, "in", n), this.keys = Uq("in", n);
  }
  matches(t) {
    return this.keys.some((n) => n.isEqual(t.key));
  }
}
class BSe extends li {
  constructor(t, n) {
    super(t, "not-in", n), this.keys = Uq("not-in", n);
  }
  matches(t) {
    return !this.keys.some((n) => n.isEqual(t.key));
  }
}
function Uq(e, t) {
  var n;
  return (((n = t.arrayValue) === null || n === void 0 ? void 0 : n.values) || []).map((r) => kt.fromName(r.referenceValue));
}
class zSe extends li {
  constructor(t, n) {
    super(t, "array-contains", n);
  }
  matches(t) {
    const n = t.data.field(this.field);
    return zO(n) && dv(n.arrayValue, this.value);
  }
}
class HSe extends li {
  constructor(t, n) {
    super(t, "in", n);
  }
  matches(t) {
    const n = t.data.field(this.field);
    return n !== null && dv(this.value.arrayValue, n);
  }
}
class USe extends li {
  constructor(t, n) {
    super(t, "not-in", n);
  }
  matches(t) {
    if (dv(this.value.arrayValue, {
      nullValue: "NULL_VALUE"
    }))
      return !1;
    const n = t.data.field(this.field);
    return n !== null && n.nullValue === void 0 && !dv(this.value.arrayValue, n);
  }
}
class WSe extends li {
  constructor(t, n) {
    super(t, "array-contains-any", n);
  }
  matches(t) {
    const n = t.data.field(this.field);
    return !(!zO(n) || !n.arrayValue.values) && n.arrayValue.values.some((r) => dv(this.value.arrayValue, r));
  }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class qSe {
  constructor(t, n = null, r = [], i = [], o = null, a = null, s = null) {
    this.path = t, this.collectionGroup = n, this.orderBy = r, this.filters = i, this.limit = o, this.startAt = a, this.endAt = s, this.Pe = null;
  }
}
function jD(e, t = null, n = [], r = [], i = null, o = null, a = null) {
  return new qSe(e, t, n, r, i, o, a);
}
function HO(e) {
  const t = Gt(e);
  if (t.Pe === null) {
    let n = t.path.canonicalString();
    t.collectionGroup !== null && (n += "|cg:" + t.collectionGroup), n += "|f:", n += t.filters.map((r) => V$(r)).join(","), n += "|ob:", n += t.orderBy.map((r) => function(o) {
      return o.field.canonicalString() + o.dir;
    }(r)).join(","), Hx(t.limit) || (n += "|l:", n += t.limit), t.startAt && (n += "|lb:", n += t.startAt.inclusive ? "b:" : "a:", n += t.startAt.position.map((r) => $g(r)).join(",")), t.endAt && (n += "|ub:", n += t.endAt.inclusive ? "a:" : "b:", n += t.endAt.position.map((r) => $g(r)).join(",")), t.Pe = n;
  }
  return t.Pe;
}
function UO(e, t) {
  if (e.limit !== t.limit || e.orderBy.length !== t.orderBy.length)
    return !1;
  for (let n = 0; n < e.orderBy.length; n++)
    if (!jSe(e.orderBy[n], t.orderBy[n]))
      return !1;
  if (e.filters.length !== t.filters.length)
    return !1;
  for (let n = 0; n < e.filters.length; n++)
    if (!zq(e.filters[n], t.filters[n]))
      return !1;
  return e.collectionGroup === t.collectionGroup && !!e.path.isEqual(t.path) && !!DD(e.startAt, t.startAt) && DD(e.endAt, t.endAt);
}
function B$(e) {
  return kt.isDocumentKey(e.path) && e.collectionGroup === null && e.filters.length === 0;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Qu {
  /**
   * Initializes a Query with a path and optional additional query constraints.
   * Path must currently be empty if this is a collection group query.
   */
  constructor(t, n = null, r = [], i = [], o = null, a = "F", s = null, c = null) {
    this.path = t, this.collectionGroup = n, this.explicitOrderBy = r, this.filters = i, this.limit = o, this.limitType = a, this.startAt = s, this.endAt = c, this.Te = null, // The corresponding `Target` of this `Query` instance, for use with
    // non-aggregate queries.
    this.Ie = null, // The corresponding `Target` of this `Query` instance, for use with
    // aggregate queries. Unlike targets for non-aggregate queries,
    // aggregate query targets do not contain normalized order-bys, they only
    // contain explicit order-bys.
    this.de = null, this.startAt, this.endAt;
  }
}
function GSe(e, t, n, r, i, o, a, s) {
  return new Qu(e, t, n, r, i, o, a, s);
}
function qx(e) {
  return new Qu(e);
}
function LD(e) {
  return e.filters.length === 0 && e.limit === null && e.startAt == null && e.endAt == null && (e.explicitOrderBy.length === 0 || e.explicitOrderBy.length === 1 && e.explicitOrderBy[0].field.isKeyField());
}
function WO(e) {
  return e.collectionGroup !== null;
}
function sg(e) {
  const t = Gt(e);
  if (t.Te === null) {
    t.Te = [];
    const n = /* @__PURE__ */ new Set();
    for (const o of t.explicitOrderBy)
      t.Te.push(o), n.add(o.field.canonicalString());
    const r = t.explicitOrderBy.length > 0 ? t.explicitOrderBy[t.explicitOrderBy.length - 1].dir : "asc";
    (function(a) {
      let s = new wi(zi.comparator);
      return a.filters.forEach((c) => {
        c.getFlattenedFilters().forEach((l) => {
          l.isInequality() && (s = s.add(l.field));
        });
      }), s;
    })(t).forEach((o) => {
      n.has(o.canonicalString()) || o.isKeyField() || t.Te.push(new fv(o, r));
    }), // Add the document key field to the last if it is not explicitly ordered.
    n.has(zi.keyField().canonicalString()) || t.Te.push(new fv(zi.keyField(), r));
  }
  return t.Te;
}
function uc(e) {
  const t = Gt(e);
  return t.Ie || (t.Ie = Wq(t, sg(e))), t.Ie;
}
function KSe(e) {
  const t = Gt(e);
  return t.de || // Do not include implicit order-bys for aggregate queries.
  (t.de = Wq(t, e.explicitOrderBy)), t.de;
}
function Wq(e, t) {
  if (e.limitType === "F")
    return jD(e.path, e.collectionGroup, t, e.filters, e.limit, e.startAt, e.endAt);
  {
    t = t.map((i) => {
      const o = i.dir === "desc" ? "asc" : "desc";
      return new fv(i.field, o);
    });
    const n = e.endAt ? new Ag(e.endAt.position, e.endAt.inclusive) : null, r = e.startAt ? new Ag(e.startAt.position, e.startAt.inclusive) : null;
    return jD(e.path, e.collectionGroup, t, e.filters, e.limit, n, r);
  }
}
function z$(e, t) {
  const n = e.filters.concat([t]);
  return new Qu(e.path, e.collectionGroup, e.explicitOrderBy.slice(), n, e.limit, e.limitType, e.startAt, e.endAt);
}
function nS(e, t, n) {
  return new Qu(e.path, e.collectionGroup, e.explicitOrderBy.slice(), e.filters.slice(), t, n, e.startAt, e.endAt);
}
function Gx(e, t) {
  return UO(uc(e), uc(t)) && e.limitType === t.limitType;
}
function qq(e) {
  return `${HO(uc(e))}|lt:${e.limitType}`;
}
function Lh(e) {
  return `Query(target=${function(n) {
    let r = n.path.canonicalString();
    return n.collectionGroup !== null && (r += " collectionGroup=" + n.collectionGroup), n.filters.length > 0 && (r += `, filters: [${n.filters.map((i) => Hq(i)).join(", ")}]`), Hx(n.limit) || (r += ", limit: " + n.limit), n.orderBy.length > 0 && (r += `, orderBy: [${n.orderBy.map((i) => function(a) {
      return `${a.field.canonicalString()} (${a.dir})`;
    }(i)).join(", ")}]`), n.startAt && (r += ", startAt: ", r += n.startAt.inclusive ? "b:" : "a:", r += n.startAt.position.map((i) => $g(i)).join(",")), n.endAt && (r += ", endAt: ", r += n.endAt.inclusive ? "a:" : "b:", r += n.endAt.position.map((i) => $g(i)).join(",")), `Target(${r})`;
  }(uc(e))}; limitType=${e.limitType})`;
}
function Kx(e, t) {
  return t.isFoundDocument() && function(r, i) {
    const o = i.key.path;
    return r.collectionGroup !== null ? i.key.hasCollectionId(r.collectionGroup) && r.path.isPrefixOf(o) : kt.isDocumentKey(r.path) ? r.path.isEqual(o) : r.path.isImmediateParentOf(o);
  }(e, t) && function(r, i) {
    for (const o of sg(r))
      if (!o.field.isKeyField() && i.data.field(o.field) === null)
        return !1;
    return !0;
  }(e, t) && function(r, i) {
    for (const o of r.filters)
      if (!o.matches(i))
        return !1;
    return !0;
  }(e, t) && function(r, i) {
    return !(r.startAt && !/**
    * Returns true if a document sorts before a bound using the provided sort
    * order.
    */
    function(a, s, c) {
      const l = ND(a, s, c);
      return a.inclusive ? l <= 0 : l < 0;
    }(r.startAt, sg(r), i) || r.endAt && !function(a, s, c) {
      const l = ND(a, s, c);
      return a.inclusive ? l >= 0 : l > 0;
    }(r.endAt, sg(r), i));
  }(e, t);
}
function YSe(e) {
  return e.collectionGroup || (e.path.length % 2 == 1 ? e.path.lastSegment() : e.path.get(e.path.length - 2));
}
function Gq(e) {
  return (t, n) => {
    let r = !1;
    for (const i of sg(e)) {
      const o = XSe(i, t, n);
      if (o !== 0)
        return o;
      r = r || i.field.isKeyField();
    }
    return 0;
  };
}
function XSe(e, t, n) {
  const r = e.field.isKeyField() ? kt.comparator(t.key, n.key) : function(o, a, s) {
    const c = a.data.field(o), l = s.data.field(o);
    return c !== null && l !== null ? Ig(c, l) : qt(42886);
  }(e.field, t, n);
  switch (e.dir) {
    case "asc":
      return r;
    case "desc":
      return -1 * r;
    default:
      return qt(19790, {
        direction: e.dir
      });
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Vf {
  constructor(t, n) {
    this.mapKeyFn = t, this.equalsFn = n, /**
     * The inner map for a key/value pair. Due to the possibility of collisions we
     * keep a list of entries that we do a linear search through to find an actual
     * match. Note that collisions should be rare, so we still expect near
     * constant time lookups in practice.
     */
    this.inner = {}, /** The number of entries stored in the map */
    this.innerSize = 0;
  }
  /** Get a value for this key, or undefined if it does not exist. */
  get(t) {
    const n = this.mapKeyFn(t), r = this.inner[n];
    if (r !== void 0) {
      for (const [i, o] of r)
        if (this.equalsFn(i, t))
          return o;
    }
  }
  has(t) {
    return this.get(t) !== void 0;
  }
  /** Put this key and value in the map. */
  set(t, n) {
    const r = this.mapKeyFn(t), i = this.inner[r];
    if (i === void 0)
      return this.inner[r] = [[t, n]], void this.innerSize++;
    for (let o = 0; o < i.length; o++)
      if (this.equalsFn(i[o][0], t))
        return void (i[o] = [t, n]);
    i.push([t, n]), this.innerSize++;
  }
  /**
   * Remove this key from the map. Returns a boolean if anything was deleted.
   */
  delete(t) {
    const n = this.mapKeyFn(t), r = this.inner[n];
    if (r === void 0)
      return !1;
    for (let i = 0; i < r.length; i++)
      if (this.equalsFn(r[i][0], t))
        return r.length === 1 ? delete this.inner[n] : r.splice(i, 1), this.innerSize--, !0;
    return !1;
  }
  forEach(t) {
    Xu(this.inner, (n, r) => {
      for (const [i, o] of r)
        t(i, o);
    });
  }
  isEmpty() {
    return Aq(this.inner);
  }
  size() {
    return this.innerSize;
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const QSe = new Fr(kt.comparator);
function gl() {
  return QSe;
}
const Kq = new Fr(kt.comparator);
function a0(...e) {
  let t = Kq;
  for (const n of e)
    t = t.insert(n.key, n);
  return t;
}
function Yq(e) {
  let t = Kq;
  return e.forEach((n, r) => t = t.insert(n, r.overlayedDocument)), t;
}
function kd() {
  return P0();
}
function Xq() {
  return P0();
}
function P0() {
  return new Vf((e) => e.toString(), (e, t) => e.isEqual(t));
}
const JSe = new Fr(kt.comparator), ZSe = new wi(kt.comparator);
function Sn(...e) {
  let t = ZSe;
  for (const n of e)
    t = t.add(n);
  return t;
}
const ewe = new wi(gn);
function twe() {
  return ewe;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function qO(e, t) {
  if (e.useProto3Json) {
    if (isNaN(t))
      return {
        doubleValue: "NaN"
      };
    if (t === 1 / 0)
      return {
        doubleValue: "Infinity"
      };
    if (t === -1 / 0)
      return {
        doubleValue: "-Infinity"
      };
  }
  return {
    doubleValue: Z_(t) ? "-0" : t
  };
}
function Qq(e) {
  return {
    integerValue: "" + e
  };
}
function nwe(e, t) {
  return ASe(t) ? Qq(t) : qO(e, t);
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Yx {
  constructor() {
    this._ = void 0;
  }
}
function rwe(e, t, n) {
  return e instanceof rS ? function(i, o) {
    const a = {
      fields: {
        [Oq]: {
          stringValue: Pq
        },
        [kq]: {
          timestampValue: {
            seconds: i.seconds,
            nanos: i.nanoseconds
          }
        }
      }
    };
    return o && Ux(o) && (o = Wx(o)), o && (a.fields[Mq] = o), {
      mapValue: a
    };
  }(n, t) : e instanceof hv ? Zq(e, t) : e instanceof gv ? eG(e, t) : function(i, o) {
    const a = Jq(i, o), s = FD(a) + FD(i.Ee);
    return F$(a) && F$(i.Ee) ? Qq(s) : qO(i.serializer, s);
  }(e, t);
}
function iwe(e, t, n) {
  return e instanceof hv ? Zq(e, t) : e instanceof gv ? eG(e, t) : n;
}
function Jq(e, t) {
  return e instanceof iS ? (
    /** Returns true if `value` is either an IntegerValue or a DoubleValue. */
    function(r) {
      return F$(r) || function(o) {
        return !!o && "doubleValue" in o;
      }(r);
    }(t) ? t : {
      integerValue: 0
    }
  ) : null;
}
class rS extends Yx {
}
class hv extends Yx {
  constructor(t) {
    super(), this.elements = t;
  }
}
function Zq(e, t) {
  const n = tG(t);
  for (const r of e.elements)
    n.some((i) => _c(i, r)) || n.push(r);
  return {
    arrayValue: {
      values: n
    }
  };
}
class gv extends Yx {
  constructor(t) {
    super(), this.elements = t;
  }
}
function eG(e, t) {
  let n = tG(t);
  for (const r of e.elements)
    n = n.filter((i) => !_c(i, r));
  return {
    arrayValue: {
      values: n
    }
  };
}
class iS extends Yx {
  constructor(t, n) {
    super(), this.serializer = t, this.Ee = n;
  }
}
function FD(e) {
  return ti(e.integerValue || e.doubleValue);
}
function tG(e) {
  return zO(e) && e.arrayValue.values ? e.arrayValue.values.slice() : [];
}
function owe(e, t) {
  return e.field.isEqual(t.field) && function(r, i) {
    return r instanceof hv && i instanceof hv || r instanceof gv && i instanceof gv ? Tg(r.elements, i.elements, _c) : r instanceof iS && i instanceof iS ? _c(r.Ee, i.Ee) : r instanceof rS && i instanceof rS;
  }(e.transform, t.transform);
}
class awe {
  constructor(t, n) {
    this.version = t, this.transformResults = n;
  }
}
class dc {
  constructor(t, n) {
    this.updateTime = t, this.exists = n;
  }
  /** Creates a new empty Precondition. */
  static none() {
    return new dc();
  }
  /** Creates a new Precondition with an exists flag. */
  static exists(t) {
    return new dc(void 0, t);
  }
  /** Creates a new Precondition based on a version a document exists at. */
  static updateTime(t) {
    return new dc(t);
  }
  /** Returns whether this Precondition is empty. */
  get isNone() {
    return this.updateTime === void 0 && this.exists === void 0;
  }
  isEqual(t) {
    return this.exists === t.exists && (this.updateTime ? !!t.updateTime && this.updateTime.isEqual(t.updateTime) : !t.updateTime);
  }
}
function o_(e, t) {
  return e.updateTime !== void 0 ? t.isFoundDocument() && t.version.isEqual(e.updateTime) : e.exists === void 0 || e.exists === t.isFoundDocument();
}
class Xx {
}
function nG(e, t) {
  if (!e.hasLocalMutations || t && t.fields.length === 0)
    return null;
  if (t === null)
    return e.isNoDocument() ? new iG(e.key, dc.none()) : new dy(e.key, e.data, dc.none());
  {
    const n = e.data, r = Jo.empty();
    let i = new wi(zi.comparator);
    for (let o of t.fields)
      if (!i.has(o)) {
        let a = n.field(o);
        a === null && o.length > 1 && (o = o.popLast(), a = n.field(o)), a === null ? r.delete(o) : r.set(o, a), i = i.add(o);
      }
    return new Ju(e.key, r, new va(i.toArray()), dc.none());
  }
}
function swe(e, t, n) {
  e instanceof dy ? function(i, o, a) {
    const s = i.value.clone(), c = BD(i.fieldTransforms, o, a.transformResults);
    s.setAll(c), o.convertToFoundDocument(a.version, s).setHasCommittedMutations();
  }(e, t, n) : e instanceof Ju ? function(i, o, a) {
    if (!o_(i.precondition, o))
      return void o.convertToUnknownDocument(a.version);
    const s = BD(i.fieldTransforms, o, a.transformResults), c = o.data;
    c.setAll(rG(i)), c.setAll(s), o.convertToFoundDocument(a.version, c).setHasCommittedMutations();
  }(e, t, n) : function(i, o, a) {
    o.convertToNoDocument(a.version).setHasCommittedMutations();
  }(0, t, n);
}
function O0(e, t, n, r) {
  return e instanceof dy ? function(o, a, s, c) {
    if (!o_(o.precondition, a))
      return s;
    const l = o.value.clone(), u = zD(o.fieldTransforms, c, a);
    return l.setAll(u), a.convertToFoundDocument(a.version, l).setHasLocalMutations(), null;
  }(e, t, n, r) : e instanceof Ju ? function(o, a, s, c) {
    if (!o_(o.precondition, a))
      return s;
    const l = zD(o.fieldTransforms, c, a), u = a.data;
    return u.setAll(rG(o)), u.setAll(l), a.convertToFoundDocument(a.version, u).setHasLocalMutations(), s === null ? null : s.unionWith(o.fieldMask.fields).unionWith(o.fieldTransforms.map((d) => d.field));
  }(e, t, n, r) : function(o, a, s) {
    return o_(o.precondition, a) ? (a.convertToNoDocument(a.version).setHasLocalMutations(), null) : s;
  }(e, t, n);
}
function cwe(e, t) {
  let n = null;
  for (const r of e.fieldTransforms) {
    const i = t.data.field(r.field), o = Jq(r.transform, i || null);
    o != null && (n === null && (n = Jo.empty()), n.set(r.field, o));
  }
  return n || null;
}
function VD(e, t) {
  return e.type === t.type && !!e.key.isEqual(t.key) && !!e.precondition.isEqual(t.precondition) && !!function(r, i) {
    return r === void 0 && i === void 0 || !(!r || !i) && Tg(r, i, (o, a) => owe(o, a));
  }(e.fieldTransforms, t.fieldTransforms) && (e.type === 0 ? e.value.isEqual(t.value) : e.type !== 1 || e.data.isEqual(t.data) && e.fieldMask.isEqual(t.fieldMask));
}
class dy extends Xx {
  constructor(t, n, r, i = []) {
    super(), this.key = t, this.value = n, this.precondition = r, this.fieldTransforms = i, this.type = 0;
  }
  getFieldMask() {
    return null;
  }
}
class Ju extends Xx {
  constructor(t, n, r, i, o = []) {
    super(), this.key = t, this.data = n, this.fieldMask = r, this.precondition = i, this.fieldTransforms = o, this.type = 1;
  }
  getFieldMask() {
    return this.fieldMask;
  }
}
function rG(e) {
  const t = /* @__PURE__ */ new Map();
  return e.fieldMask.fields.forEach((n) => {
    if (!n.isEmpty()) {
      const r = e.data.field(n);
      t.set(n, r);
    }
  }), t;
}
function BD(e, t, n) {
  const r = /* @__PURE__ */ new Map();
  Fn(e.length === n.length, 32656, {
    Ae: n.length,
    Re: e.length
  });
  for (let i = 0; i < n.length; i++) {
    const o = e[i], a = o.transform, s = t.data.field(o.field);
    r.set(o.field, iwe(a, s, n[i]));
  }
  return r;
}
function zD(e, t, n) {
  const r = /* @__PURE__ */ new Map();
  for (const i of e) {
    const o = i.transform, a = n.data.field(i.field);
    r.set(i.field, rwe(o, a, t));
  }
  return r;
}
class iG extends Xx {
  constructor(t, n) {
    super(), this.key = t, this.precondition = n, this.type = 2, this.fieldTransforms = [];
  }
  getFieldMask() {
    return null;
  }
}
class lwe extends Xx {
  constructor(t, n) {
    super(), this.key = t, this.precondition = n, this.type = 3, this.fieldTransforms = [];
  }
  getFieldMask() {
    return null;
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class uwe {
  /**
   * @param batchId - The unique ID of this mutation batch.
   * @param localWriteTime - The original write time of this mutation.
   * @param baseMutations - Mutations that are used to populate the base
   * values when this mutation is applied locally. This can be used to locally
   * overwrite values that are persisted in the remote document cache. Base
   * mutations are never sent to the backend.
   * @param mutations - The user-provided mutations in this mutation batch.
   * User-provided mutations are applied both locally and remotely on the
   * backend.
   */
  constructor(t, n, r, i) {
    this.batchId = t, this.localWriteTime = n, this.baseMutations = r, this.mutations = i;
  }
  /**
   * Applies all the mutations in this MutationBatch to the specified document
   * to compute the state of the remote document
   *
   * @param document - The document to apply mutations to.
   * @param batchResult - The result of applying the MutationBatch to the
   * backend.
   */
  applyToRemoteDocument(t, n) {
    const r = n.mutationResults;
    for (let i = 0; i < this.mutations.length; i++) {
      const o = this.mutations[i];
      o.key.isEqual(t.key) && swe(o, t, r[i]);
    }
  }
  /**
   * Computes the local view of a document given all the mutations in this
   * batch.
   *
   * @param document - The document to apply mutations to.
   * @param mutatedFields - Fields that have been updated before applying this mutation batch.
   * @returns A `FieldMask` representing all the fields that are mutated.
   */
  applyToLocalView(t, n) {
    for (const r of this.baseMutations)
      r.key.isEqual(t.key) && (n = O0(r, t, n, this.localWriteTime));
    for (const r of this.mutations)
      r.key.isEqual(t.key) && (n = O0(r, t, n, this.localWriteTime));
    return n;
  }
  /**
   * Computes the local view for all provided documents given the mutations in
   * this batch. Returns a `DocumentKey` to `Mutation` map which can be used to
   * replace all the mutation applications.
   */
  applyToLocalDocumentSet(t, n) {
    const r = Xq();
    return this.mutations.forEach((i) => {
      const o = t.get(i.key), a = o.overlayedDocument;
      let s = this.applyToLocalView(a, o.mutatedFields);
      s = n.has(i.key) ? null : s;
      const c = nG(a, s);
      c !== null && r.set(i.key, c), a.isValidDocument() || a.convertToNoDocument(Kt.min());
    }), r;
  }
  keys() {
    return this.mutations.reduce((t, n) => t.add(n.key), Sn());
  }
  isEqual(t) {
    return this.batchId === t.batchId && Tg(this.mutations, t.mutations, (n, r) => VD(n, r)) && Tg(this.baseMutations, t.baseMutations, (n, r) => VD(n, r));
  }
}
class GO {
  constructor(t, n, r, i) {
    this.batch = t, this.commitVersion = n, this.mutationResults = r, this.docVersions = i;
  }
  /**
   * Creates a new MutationBatchResult for the given batch and results. There
   * must be one result for each mutation in the batch. This static factory
   * caches a document=&gt;version mapping (docVersions).
   */
  static from(t, n, r) {
    Fn(t.mutations.length === r.length, 58842, {
      Ve: t.mutations.length,
      me: r.length
    });
    let i = function() {
      return JSe;
    }();
    const o = t.mutations;
    for (let a = 0; a < o.length; a++)
      i = i.insert(o[a].key, r[a].version);
    return new GO(t, n, r, i);
  }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
let dwe = class {
  constructor(t, n) {
    this.largestBatchId = t, this.mutation = n;
  }
  getKey() {
    return this.mutation.key;
  }
  isEqual(t) {
    return t !== null && this.mutation === t.mutation;
  }
  toString() {
    return `Overlay{
      largestBatchId: ${this.largestBatchId},
      mutation: ${this.mutation.toString()}
    }`;
  }
};
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class fwe {
  constructor(t, n, r) {
    this.alias = t, this.aggregateType = n, this.fieldPath = r;
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class hwe {
  constructor(t, n) {
    this.count = t, this.unchangedNames = n;
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var oi, In;
function gwe(e) {
  switch (e) {
    case we.OK:
      return qt(64938);
    case we.CANCELLED:
    case we.UNKNOWN:
    case we.DEADLINE_EXCEEDED:
    case we.RESOURCE_EXHAUSTED:
    case we.INTERNAL:
    case we.UNAVAILABLE:
    case we.UNAUTHENTICATED:
      return !1;
    case we.INVALID_ARGUMENT:
    case we.NOT_FOUND:
    case we.ALREADY_EXISTS:
    case we.PERMISSION_DENIED:
    case we.FAILED_PRECONDITION:
    case we.ABORTED:
    case we.OUT_OF_RANGE:
    case we.UNIMPLEMENTED:
    case we.DATA_LOSS:
      return !0;
    default:
      return qt(15467, {
        code: e
      });
  }
}
function oG(e) {
  if (e === void 0)
    return hl("GRPC error has no .code"), we.UNKNOWN;
  switch (e) {
    case oi.OK:
      return we.OK;
    case oi.CANCELLED:
      return we.CANCELLED;
    case oi.UNKNOWN:
      return we.UNKNOWN;
    case oi.DEADLINE_EXCEEDED:
      return we.DEADLINE_EXCEEDED;
    case oi.RESOURCE_EXHAUSTED:
      return we.RESOURCE_EXHAUSTED;
    case oi.INTERNAL:
      return we.INTERNAL;
    case oi.UNAVAILABLE:
      return we.UNAVAILABLE;
    case oi.UNAUTHENTICATED:
      return we.UNAUTHENTICATED;
    case oi.INVALID_ARGUMENT:
      return we.INVALID_ARGUMENT;
    case oi.NOT_FOUND:
      return we.NOT_FOUND;
    case oi.ALREADY_EXISTS:
      return we.ALREADY_EXISTS;
    case oi.PERMISSION_DENIED:
      return we.PERMISSION_DENIED;
    case oi.FAILED_PRECONDITION:
      return we.FAILED_PRECONDITION;
    case oi.ABORTED:
      return we.ABORTED;
    case oi.OUT_OF_RANGE:
      return we.OUT_OF_RANGE;
    case oi.UNIMPLEMENTED:
      return we.UNIMPLEMENTED;
    case oi.DATA_LOSS:
      return we.DATA_LOSS;
    default:
      return qt(39323, {
        code: e
      });
  }
}
(In = oi || (oi = {}))[In.OK = 0] = "OK", In[In.CANCELLED = 1] = "CANCELLED", In[In.UNKNOWN = 2] = "UNKNOWN", In[In.INVALID_ARGUMENT = 3] = "INVALID_ARGUMENT", In[In.DEADLINE_EXCEEDED = 4] = "DEADLINE_EXCEEDED", In[In.NOT_FOUND = 5] = "NOT_FOUND", In[In.ALREADY_EXISTS = 6] = "ALREADY_EXISTS", In[In.PERMISSION_DENIED = 7] = "PERMISSION_DENIED", In[In.UNAUTHENTICATED = 16] = "UNAUTHENTICATED", In[In.RESOURCE_EXHAUSTED = 8] = "RESOURCE_EXHAUSTED", In[In.FAILED_PRECONDITION = 9] = "FAILED_PRECONDITION", In[In.ABORTED = 10] = "ABORTED", In[In.OUT_OF_RANGE = 11] = "OUT_OF_RANGE", In[In.UNIMPLEMENTED = 12] = "UNIMPLEMENTED", In[In.INTERNAL = 13] = "INTERNAL", In[In.UNAVAILABLE = 14] = "UNAVAILABLE", In[In.DATA_LOSS = 15] = "DATA_LOSS";
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const pwe = new gu([4294967295, 4294967295], 0);
function HD(e) {
  const t = Eq().encode(e), n = new mq();
  return n.update(t), new Uint8Array(n.digest());
}
function UD(e) {
  const t = new DataView(e.buffer), n = t.getUint32(
    0,
    /* littleEndian= */
    !0
  ), r = t.getUint32(
    4,
    /* littleEndian= */
    !0
  ), i = t.getUint32(
    8,
    /* littleEndian= */
    !0
  ), o = t.getUint32(
    12,
    /* littleEndian= */
    !0
  );
  return [new gu([n, r], 0), new gu([i, o], 0)];
}
class KO {
  constructor(t, n, r) {
    if (this.bitmap = t, this.padding = n, this.hashCount = r, n < 0 || n >= 8)
      throw new s0(`Invalid padding: ${n}`);
    if (r < 0)
      throw new s0(`Invalid hash count: ${r}`);
    if (t.length > 0 && this.hashCount === 0)
      throw new s0(`Invalid hash count: ${r}`);
    if (t.length === 0 && n !== 0)
      throw new s0(`Invalid padding when bitmap length is 0: ${n}`);
    this.fe = 8 * t.length - n, // Set the bit count in Integer to avoid repetition in mightContain().
    this.ge = gu.fromNumber(this.fe);
  }
  // Calculate the ith hash value based on the hashed 64bit integers,
  // and calculate its corresponding bit index in the bitmap to be checked.
  pe(t, n, r) {
    let i = t.add(n.multiply(gu.fromNumber(r)));
    return i.compare(pwe) === 1 && (i = new gu([i.getBits(0), i.getBits(1)], 0)), i.modulo(this.ge).toNumber();
  }
  // Return whether the bit on the given index in the bitmap is set to 1.
  ye(t) {
    return !!(this.bitmap[Math.floor(t / 8)] & 1 << t % 8);
  }
  mightContain(t) {
    if (this.fe === 0)
      return !1;
    const n = HD(t), [r, i] = UD(n);
    for (let o = 0; o < this.hashCount; o++) {
      const a = this.pe(r, i, o);
      if (!this.ye(a))
        return !1;
    }
    return !0;
  }
  /** Create bloom filter for testing purposes only. */
  static create(t, n, r) {
    const i = t % 8 == 0 ? 0 : 8 - t % 8, o = new Uint8Array(Math.ceil(t / 8)), a = new KO(o, i, n);
    return r.forEach((s) => a.insert(s)), a;
  }
  insert(t) {
    if (this.fe === 0)
      return;
    const n = HD(t), [r, i] = UD(n);
    for (let o = 0; o < this.hashCount; o++) {
      const a = this.pe(r, i, o);
      this.we(a);
    }
  }
  we(t) {
    const n = Math.floor(t / 8), r = t % 8;
    this.bitmap[n] |= 1 << r;
  }
}
class s0 extends Error {
  constructor() {
    super(...arguments), this.name = "BloomFilterError";
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Qx {
  constructor(t, n, r, i, o) {
    this.snapshotVersion = t, this.targetChanges = n, this.targetMismatches = r, this.documentUpdates = i, this.resolvedLimboDocuments = o;
  }
  /**
   * HACK: Views require RemoteEvents in order to determine whether the view is
   * CURRENT, but secondary tabs don't receive remote events. So this method is
   * used to create a synthesized RemoteEvent that can be used to apply a
   * CURRENT status change to a View, for queries executed in a different tab.
   */
  // PORTING NOTE: Multi-tab only
  static createSynthesizedRemoteEventForCurrentChange(t, n, r) {
    const i = /* @__PURE__ */ new Map();
    return i.set(t, fy.createSynthesizedTargetChangeForCurrentChange(t, n, r)), new Qx(Kt.min(), i, new Fr(gn), gl(), Sn());
  }
}
class fy {
  constructor(t, n, r, i, o) {
    this.resumeToken = t, this.current = n, this.addedDocuments = r, this.modifiedDocuments = i, this.removedDocuments = o;
  }
  /**
   * This method is used to create a synthesized TargetChanges that can be used to
   * apply a CURRENT status change to a View (for queries executed in a different
   * tab) or for new queries (to raise snapshots with correct CURRENT status).
   */
  static createSynthesizedTargetChangeForCurrentChange(t, n, r) {
    return new fy(r, n, Sn(), Sn(), Sn());
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class a_ {
  constructor(t, n, r, i) {
    this.Se = t, this.removedTargetIds = n, this.key = r, this.be = i;
  }
}
class aG {
  constructor(t, n) {
    this.targetId = t, this.De = n;
  }
}
class sG {
  constructor(t, n, r = Wi.EMPTY_BYTE_STRING, i = null) {
    this.state = t, this.targetIds = n, this.resumeToken = r, this.cause = i;
  }
}
class WD {
  constructor() {
    this.ve = 0, /**
     * Keeps track of the document changes since the last raised snapshot.
     *
     * These changes are continuously updated as we receive document updates and
     * always reflect the current set of changes against the last issued snapshot.
     */
    this.Ce = qD(), /** See public getters for explanations of these fields. */
    this.Fe = Wi.EMPTY_BYTE_STRING, this.Me = !1, /**
     * Whether this target state should be included in the next snapshot. We
     * initialize to true so that newly-added targets are included in the next
     * RemoteEvent.
     */
    this.xe = !0;
  }
  /**
   * Whether this target has been marked 'current'.
   *
   * 'Current' has special meaning in the RPC protocol: It implies that the
   * Watch backend has sent us all changes up to the point at which the target
   * was added and that the target is consistent with the rest of the watch
   * stream.
   */
  get current() {
    return this.Me;
  }
  /** The last resume token sent to us for this target. */
  get resumeToken() {
    return this.Fe;
  }
  /** Whether this target has pending target adds or target removes. */
  get Oe() {
    return this.ve !== 0;
  }
  /** Whether we have modified any state that should trigger a snapshot. */
  get Ne() {
    return this.xe;
  }
  /**
   * Applies the resume token to the TargetChange, but only when it has a new
   * value. Empty resumeTokens are discarded.
   */
  Be(t) {
    t.approximateByteSize() > 0 && (this.xe = !0, this.Fe = t);
  }
  /**
   * Creates a target change from the current set of changes.
   *
   * To reset the document changes after raising this snapshot, call
   * `clearPendingChanges()`.
   */
  Le() {
    let t = Sn(), n = Sn(), r = Sn();
    return this.Ce.forEach((i, o) => {
      switch (o) {
        case 0:
          t = t.add(i);
          break;
        case 2:
          n = n.add(i);
          break;
        case 1:
          r = r.add(i);
          break;
        default:
          qt(38017, {
            changeType: o
          });
      }
    }), new fy(this.Fe, this.Me, t, n, r);
  }
  /**
   * Resets the document changes and sets `hasPendingChanges` to false.
   */
  ke() {
    this.xe = !1, this.Ce = qD();
  }
  qe(t, n) {
    this.xe = !0, this.Ce = this.Ce.insert(t, n);
  }
  Qe(t) {
    this.xe = !0, this.Ce = this.Ce.remove(t);
  }
  $e() {
    this.ve += 1;
  }
  Ue() {
    this.ve -= 1, Fn(this.ve >= 0, 3241, {
      ve: this.ve
    });
  }
  Ke() {
    this.xe = !0, this.Me = !0;
  }
}
class mwe {
  constructor(t) {
    this.We = t, /** The internal state of all tracked targets. */
    this.Ge = /* @__PURE__ */ new Map(), /** Keeps track of the documents to update since the last raised snapshot. */
    this.ze = gl(), this.je = Fb(), /** A mapping of document keys to their set of target IDs. */
    this.Je = Fb(), /**
     * A map of targets with existence filter mismatches. These targets are
     * known to be inconsistent and their listens needs to be re-established by
     * RemoteStore.
     */
    this.He = new Fr(gn);
  }
  /**
   * Processes and adds the DocumentWatchChange to the current set of changes.
   */
  Ye(t) {
    for (const n of t.Se)
      t.be && t.be.isFoundDocument() ? this.Ze(n, t.be) : this.Xe(n, t.key, t.be);
    for (const n of t.removedTargetIds)
      this.Xe(n, t.key, t.be);
  }
  /** Processes and adds the WatchTargetChange to the current set of changes. */
  et(t) {
    this.forEachTarget(t, (n) => {
      const r = this.tt(n);
      switch (t.state) {
        case 0:
          this.nt(n) && r.Be(t.resumeToken);
          break;
        case 1:
          r.Ue(), r.Oe || // We have a freshly added target, so we need to reset any state
          // that we had previously. This can happen e.g. when remove and add
          // back a target for existence filter mismatches.
          r.ke(), r.Be(t.resumeToken);
          break;
        case 2:
          r.Ue(), r.Oe || this.removeTarget(n);
          break;
        case 3:
          this.nt(n) && (r.Ke(), r.Be(t.resumeToken));
          break;
        case 4:
          this.nt(n) && // Reset the target and synthesizes removes for all existing
          // documents. The backend will re-add any documents that still
          // match the target before it sends the next global snapshot.
          (this.rt(n), r.Be(t.resumeToken));
          break;
        default:
          qt(56790, {
            state: t.state
          });
      }
    });
  }
  /**
   * Iterates over all targetIds that the watch change applies to: either the
   * targetIds explicitly listed in the change or the targetIds of all currently
   * active targets.
   */
  forEachTarget(t, n) {
    t.targetIds.length > 0 ? t.targetIds.forEach(n) : this.Ge.forEach((r, i) => {
      this.nt(i) && n(i);
    });
  }
  /**
   * Handles existence filters and synthesizes deletes for filter mismatches.
   * Targets that are invalidated by filter mismatches are added to
   * `pendingTargetResets`.
   */
  it(t) {
    const n = t.targetId, r = t.De.count, i = this.st(n);
    if (i) {
      const o = i.target;
      if (B$(o))
        if (r === 0) {
          const a = new kt(o.path);
          this.Xe(n, a, so.newNoDocument(a, Kt.min()));
        } else
          Fn(r === 1, 20013, {
            expectedCount: r
          });
      else {
        const a = this.ot(n);
        if (a !== r) {
          const s = this._t(t), c = s ? this.ut(s, t, a) : 1;
          if (c !== 0) {
            this.rt(n);
            const l = c === 2 ? "TargetPurposeExistenceFilterMismatchBloom" : "TargetPurposeExistenceFilterMismatch";
            this.He = this.He.insert(n, l);
          }
        }
      }
    }
  }
  /**
   * Parse the bloom filter from the "unchanged_names" field of an existence
   * filter.
   */
  _t(t) {
    const n = t.De.unchangedNames;
    if (!n || !n.bits)
      return null;
    const { bits: { bitmap: r = "", padding: i = 0 }, hashCount: o = 0 } = n;
    let a, s;
    try {
      a = Ru(r).toUint8Array();
    } catch (c) {
      if (c instanceof Rq)
        return Iu("Decoding the base64 bloom filter in existence filter failed (" + c.message + "); ignoring the bloom filter and falling back to full re-query."), null;
      throw c;
    }
    try {
      s = new KO(a, i, o);
    } catch (c) {
      return Iu(c instanceof s0 ? "BloomFilter error: " : "Applying bloom filter failed: ", c), null;
    }
    return s.fe === 0 ? null : s;
  }
  /**
   * Apply bloom filter to remove the deleted documents, and return the
   * application status.
   */
  ut(t, n, r) {
    return n.De.count === r - this.ht(t, n.targetId) ? 0 : 2;
  }
  /**
   * Filter out removed documents based on bloom filter membership result and
   * return number of documents removed.
   */
  ht(t, n) {
    const r = this.We.getRemoteKeysForTarget(n);
    let i = 0;
    return r.forEach((o) => {
      const a = this.We.lt(), s = `projects/${a.projectId}/databases/${a.database}/documents/${o.path.canonicalString()}`;
      t.mightContain(s) || (this.Xe(
        n,
        o,
        /*updatedDocument=*/
        null
      ), i++);
    }), i;
  }
  /**
   * Converts the currently accumulated state into a remote event at the
   * provided snapshot version. Resets the accumulated changes before returning.
   */
  Pt(t) {
    const n = /* @__PURE__ */ new Map();
    this.Ge.forEach((o, a) => {
      const s = this.st(a);
      if (s) {
        if (o.current && B$(s.target)) {
          const c = new kt(s.target.path);
          this.Tt(c).has(a) || this.It(a, c) || this.Xe(a, c, so.newNoDocument(c, t));
        }
        o.Ne && (n.set(a, o.Le()), o.ke());
      }
    });
    let r = Sn();
    this.Je.forEach((o, a) => {
      let s = !0;
      a.forEachWhile((c) => {
        const l = this.st(c);
        return !l || l.purpose === "TargetPurposeLimboResolution" || (s = !1, !1);
      }), s && (r = r.add(o));
    }), this.ze.forEach((o, a) => a.setReadTime(t));
    const i = new Qx(t, n, this.He, this.ze, r);
    return this.ze = gl(), this.je = Fb(), this.Je = Fb(), this.He = new Fr(gn), i;
  }
  /**
   * Adds the provided document to the internal list of document updates and
   * its document key to the given target's mapping.
   */
  // Visible for testing.
  Ze(t, n) {
    if (!this.nt(t))
      return;
    const r = this.It(t, n.key) ? 2 : 0;
    this.tt(t).qe(n.key, r), this.ze = this.ze.insert(n.key, n), this.je = this.je.insert(n.key, this.Tt(n.key).add(t)), this.Je = this.Je.insert(n.key, this.dt(n.key).add(t));
  }
  /**
   * Removes the provided document from the target mapping. If the
   * document no longer matches the target, but the document's state is still
   * known (e.g. we know that the document was deleted or we received the change
   * that caused the filter mismatch), the new document can be provided
   * to update the remote document cache.
   */
  // Visible for testing.
  Xe(t, n, r) {
    if (!this.nt(t))
      return;
    const i = this.tt(t);
    this.It(t, n) ? i.qe(
      n,
      1
      /* ChangeType.Removed */
    ) : (
      // The document may have entered and left the target before we raised a
      // snapshot, so we can just ignore the change.
      i.Qe(n)
    ), this.Je = this.Je.insert(n, this.dt(n).delete(t)), this.Je = this.Je.insert(n, this.dt(n).add(t)), r && (this.ze = this.ze.insert(n, r));
  }
  removeTarget(t) {
    this.Ge.delete(t);
  }
  /**
   * Returns the current count of documents in the target. This includes both
   * the number of documents that the LocalStore considers to be part of the
   * target as well as any accumulated changes.
   */
  ot(t) {
    const n = this.tt(t).Le();
    return this.We.getRemoteKeysForTarget(t).size + n.addedDocuments.size - n.removedDocuments.size;
  }
  /**
   * Increment the number of acks needed from watch before we can consider the
   * server to be 'in-sync' with the client's active targets.
   */
  $e(t) {
    this.tt(t).$e();
  }
  tt(t) {
    let n = this.Ge.get(t);
    return n || (n = new WD(), this.Ge.set(t, n)), n;
  }
  dt(t) {
    let n = this.Je.get(t);
    return n || (n = new wi(gn), this.Je = this.Je.insert(t, n)), n;
  }
  Tt(t) {
    let n = this.je.get(t);
    return n || (n = new wi(gn), this.je = this.je.insert(t, n)), n;
  }
  /**
   * Verifies that the user is still interested in this target (by calling
   * `getTargetDataForTarget()`) and that we are not waiting for pending ADDs
   * from watch.
   */
  nt(t) {
    const n = this.st(t) !== null;
    return n || bt("WatchChangeAggregator", "Detected inactive target", t), n;
  }
  /**
   * Returns the TargetData for an active target (i.e. a target that the user
   * is still interested in that has no outstanding target change requests).
   */
  st(t) {
    const n = this.Ge.get(t);
    return n && n.Oe ? null : this.We.Et(t);
  }
  /**
   * Resets the state of a Watch target to its initial state (e.g. sets
   * 'current' to false, clears the resume token and removes its target mapping
   * from all documents).
   */
  rt(t) {
    this.Ge.set(t, new WD()), this.We.getRemoteKeysForTarget(t).forEach((n) => {
      this.Xe(
        t,
        n,
        /*updatedDocument=*/
        null
      );
    });
  }
  /**
   * Returns whether the LocalStore considers the document to be part of the
   * specified target.
   */
  It(t, n) {
    return this.We.getRemoteKeysForTarget(t).has(n);
  }
}
function Fb() {
  return new Fr(kt.comparator);
}
function qD() {
  return new Fr(kt.comparator);
}
const vwe = (() => ({
  asc: "ASCENDING",
  desc: "DESCENDING"
}))(), ywe = (() => ({
  "<": "LESS_THAN",
  "<=": "LESS_THAN_OR_EQUAL",
  ">": "GREATER_THAN",
  ">=": "GREATER_THAN_OR_EQUAL",
  "==": "EQUAL",
  "!=": "NOT_EQUAL",
  "array-contains": "ARRAY_CONTAINS",
  in: "IN",
  "not-in": "NOT_IN",
  "array-contains-any": "ARRAY_CONTAINS_ANY"
}))(), bwe = (() => ({
  and: "AND",
  or: "OR"
}))();
class _we {
  constructor(t, n) {
    this.databaseId = t, this.useProto3Json = n;
  }
}
function H$(e, t) {
  return e.useProto3Json || Hx(t) ? t : {
    value: t
  };
}
function oS(e, t) {
  return e.useProto3Json ? `${new Date(1e3 * t.seconds).toISOString().replace(/\.\d*/, "").replace("Z", "")}.${("000000000" + t.nanoseconds).slice(-9)}Z` : {
    seconds: "" + t.seconds,
    nanos: t.nanoseconds
  };
}
function cG(e, t) {
  return e.useProto3Json ? t.toBase64() : t.toUint8Array();
}
function Swe(e, t) {
  return oS(e, t.toTimestamp());
}
function fc(e) {
  return Fn(!!e, 49232), Kt.fromTimestamp(function(n) {
    const r = Au(n);
    return new jn(r.seconds, r.nanos);
  }(e));
}
function YO(e, t) {
  return U$(e, t).canonicalString();
}
function U$(e, t) {
  const n = function(i) {
    return new or(["projects", i.projectId, "databases", i.database]);
  }(e).child("documents");
  return t === void 0 ? n : n.child(t);
}
function lG(e) {
  const t = or.fromString(e);
  return Fn(pG(t), 10190, {
    key: t.toString()
  }), t;
}
function W$(e, t) {
  return YO(e.databaseId, t.path);
}
function L5(e, t) {
  const n = lG(t);
  if (n.get(1) !== e.databaseId.projectId)
    throw new Je(we.INVALID_ARGUMENT, "Tried to deserialize key from different project: " + n.get(1) + " vs " + e.databaseId.projectId);
  if (n.get(3) !== e.databaseId.database)
    throw new Je(we.INVALID_ARGUMENT, "Tried to deserialize key from different database: " + n.get(3) + " vs " + e.databaseId.database);
  return new kt(dG(n));
}
function uG(e, t) {
  return YO(e.databaseId, t);
}
function wwe(e) {
  const t = lG(e);
  return t.length === 4 ? or.emptyPath() : dG(t);
}
function q$(e) {
  return new or(["projects", e.databaseId.projectId, "databases", e.databaseId.database]).canonicalString();
}
function dG(e) {
  return Fn(e.length > 4 && e.get(4) === "documents", 29091, {
    key: e.toString()
  }), e.popFirst(5);
}
function GD(e, t, n) {
  return {
    name: W$(e, t),
    fields: n.value.mapValue.fields
  };
}
function xwe(e, t) {
  let n;
  if ("targetChange" in t) {
    t.targetChange;
    const r = function(l) {
      return l === "NO_CHANGE" ? 0 : l === "ADD" ? 1 : l === "REMOVE" ? 2 : l === "CURRENT" ? 3 : l === "RESET" ? 4 : qt(39313, {
        state: l
      });
    }(t.targetChange.targetChangeType || "NO_CHANGE"), i = t.targetChange.targetIds || [], o = function(l, u) {
      return l.useProto3Json ? (Fn(u === void 0 || typeof u == "string", 58123), Wi.fromBase64String(u || "")) : (Fn(u === void 0 || // Check if the value is an instance of both Buffer and Uint8Array,
      // despite the fact that Buffer extends Uint8Array. In some
      // environments, such as jsdom, the prototype chain of Buffer
      // does not indicate that it extends Uint8Array.
      u instanceof Buffer || u instanceof Uint8Array, 16193), Wi.fromUint8Array(u || new Uint8Array()));
    }(e, t.targetChange.resumeToken), a = t.targetChange.cause, s = a && function(l) {
      const u = l.code === void 0 ? we.UNKNOWN : oG(l.code);
      return new Je(u, l.message || "");
    }(a);
    n = new sG(r, i, o, s || null);
  } else if ("documentChange" in t) {
    t.documentChange;
    const r = t.documentChange;
    r.document, r.document.name, r.document.updateTime;
    const i = L5(e, r.document.name), o = fc(r.document.updateTime), a = r.document.createTime ? fc(r.document.createTime) : Kt.min(), s = new Jo({
      mapValue: {
        fields: r.document.fields
      }
    }), c = so.newFoundDocument(i, o, a, s), l = r.targetIds || [], u = r.removedTargetIds || [];
    n = new a_(l, u, c.key, c);
  } else if ("documentDelete" in t) {
    t.documentDelete;
    const r = t.documentDelete;
    r.document;
    const i = L5(e, r.document), o = r.readTime ? fc(r.readTime) : Kt.min(), a = so.newNoDocument(i, o), s = r.removedTargetIds || [];
    n = new a_([], s, a.key, a);
  } else if ("documentRemove" in t) {
    t.documentRemove;
    const r = t.documentRemove;
    r.document;
    const i = L5(e, r.document), o = r.removedTargetIds || [];
    n = new a_([], o, i, null);
  } else {
    if (!("filter" in t))
      return qt(11601, {
        At: t
      });
    {
      t.filter;
      const r = t.filter;
      r.targetId;
      const { count: i = 0, unchangedNames: o } = r, a = new hwe(i, o), s = r.targetId;
      n = new aG(s, a);
    }
  }
  return n;
}
function Ewe(e, t) {
  let n;
  if (t instanceof dy)
    n = {
      update: GD(e, t.key, t.value)
    };
  else if (t instanceof iG)
    n = {
      delete: W$(e, t.key)
    };
  else if (t instanceof Ju)
    n = {
      update: GD(e, t.key, t.data),
      updateMask: Mwe(t.fieldMask)
    };
  else {
    if (!(t instanceof lwe))
      return qt(16599, {
        Rt: t.type
      });
    n = {
      verify: W$(e, t.key)
    };
  }
  return t.fieldTransforms.length > 0 && (n.updateTransforms = t.fieldTransforms.map((r) => function(o, a) {
    const s = a.transform;
    if (s instanceof rS)
      return {
        fieldPath: a.field.canonicalString(),
        setToServerValue: "REQUEST_TIME"
      };
    if (s instanceof hv)
      return {
        fieldPath: a.field.canonicalString(),
        appendMissingElements: {
          values: s.elements
        }
      };
    if (s instanceof gv)
      return {
        fieldPath: a.field.canonicalString(),
        removeAllFromArray: {
          values: s.elements
        }
      };
    if (s instanceof iS)
      return {
        fieldPath: a.field.canonicalString(),
        increment: s.Ee
      };
    throw qt(20930, {
      transform: a.transform
    });
  }(0, r))), t.precondition.isNone || (n.currentDocument = function(i, o) {
    return o.updateTime !== void 0 ? {
      updateTime: Swe(i, o.updateTime)
    } : o.exists !== void 0 ? {
      exists: o.exists
    } : qt(27497);
  }(e, t.precondition)), n;
}
function Cwe(e, t) {
  return e && e.length > 0 ? (Fn(t !== void 0, 14353), e.map((n) => function(i, o) {
    let a = i.updateTime ? fc(i.updateTime) : fc(o);
    return a.isEqual(Kt.min()) && // The Firestore Emulator currently returns an update time of 0 for
    // deletes of non-existing documents (rather than null). This breaks the
    // test "get deleted doc while offline with source=cache" as NoDocuments
    // with version 0 are filtered by IndexedDb's RemoteDocumentCache.
    // TODO(#2149): Remove this when Emulator is fixed
    (a = fc(o)), new awe(a, i.transformResults || []);
  }(n, t))) : [];
}
function Twe(e, t) {
  return {
    documents: [uG(e, t.path)]
  };
}
function fG(e, t) {
  const n = {
    structuredQuery: {}
  }, r = t.path;
  let i;
  t.collectionGroup !== null ? (i = r, n.structuredQuery.from = [{
    collectionId: t.collectionGroup,
    allDescendants: !0
  }]) : (i = r.popLast(), n.structuredQuery.from = [{
    collectionId: r.lastSegment()
  }]), n.parent = uG(e, i);
  const o = function(l) {
    if (l.length !== 0)
      return gG($s.create(
        l,
        "and"
        /* CompositeOperator.AND */
      ));
  }(t.filters);
  o && (n.structuredQuery.where = o);
  const a = function(l) {
    if (l.length !== 0)
      return l.map((u) => (
        // visible for testing
        function(f) {
          return {
            field: Ql(f.field),
            direction: Rwe(f.dir)
          };
        }(u)
      ));
  }(t.orderBy);
  a && (n.structuredQuery.orderBy = a);
  const s = H$(e, t.limit);
  return s !== null && (n.structuredQuery.limit = s), t.startAt && (n.structuredQuery.startAt = function(l) {
    return {
      before: l.inclusive,
      values: l.position
    };
  }(t.startAt)), t.endAt && (n.structuredQuery.endAt = function(l) {
    return {
      before: !l.inclusive,
      values: l.position
    };
  }(t.endAt)), {
    Vt: n,
    parent: i
  };
}
function Iwe(e, t, n, r) {
  const { Vt: i, parent: o } = fG(e, t), a = {}, s = [];
  let c = 0;
  return n.forEach((l) => {
    const u = r ? l.alias : "aggregate_" + c++;
    a[u] = l.alias, l.aggregateType === "count" ? s.push({
      alias: u,
      count: {}
    }) : l.aggregateType === "avg" ? s.push({
      alias: u,
      avg: {
        field: Ql(l.fieldPath)
      }
    }) : l.aggregateType === "sum" && s.push({
      alias: u,
      sum: {
        field: Ql(l.fieldPath)
      }
    });
  }), {
    request: {
      structuredAggregationQuery: {
        aggregations: s,
        structuredQuery: i.structuredQuery
      },
      parent: i.parent
    },
    ft: a,
    parent: o
  };
}
function $we(e) {
  let t = wwe(e.parent);
  const n = e.structuredQuery, r = n.from ? n.from.length : 0;
  let i = null;
  if (r > 0) {
    Fn(r === 1, 65062);
    const u = n.from[0];
    u.allDescendants ? i = u.collectionId : t = t.child(u.collectionId);
  }
  let o = [];
  n.where && (o = function(d) {
    const f = hG(d);
    return f instanceof $s && Bq(f) ? f.getFilters() : [f];
  }(n.where));
  let a = [];
  n.orderBy && (a = function(d) {
    return d.map((f) => function(p) {
      return new fv(
        Fh(p.field),
        // visible for testing
        function(m) {
          switch (m) {
            case "ASCENDING":
              return "asc";
            case "DESCENDING":
              return "desc";
            default:
              return;
          }
        }(p.direction)
      );
    }(f));
  }(n.orderBy));
  let s = null;
  n.limit && (s = function(d) {
    let f;
    return f = typeof d == "object" ? d.value : d, Hx(f) ? null : f;
  }(n.limit));
  let c = null;
  n.startAt && (c = function(d) {
    const f = !!d.before, h = d.values || [];
    return new Ag(h, f);
  }(n.startAt));
  let l = null;
  return n.endAt && (l = function(d) {
    const f = !d.before, h = d.values || [];
    return new Ag(h, f);
  }(n.endAt)), GSe(t, i, a, o, s, "F", c, l);
}
function Awe(e, t) {
  const n = function(i) {
    switch (i) {
      case "TargetPurposeListen":
        return null;
      case "TargetPurposeExistenceFilterMismatch":
        return "existence-filter-mismatch";
      case "TargetPurposeExistenceFilterMismatchBloom":
        return "existence-filter-mismatch-bloom";
      case "TargetPurposeLimboResolution":
        return "limbo-document";
      default:
        return qt(28987, {
          purpose: i
        });
    }
  }(t.purpose);
  return n == null ? null : {
    "goog-listen-tags": n
  };
}
function hG(e) {
  return e.unaryFilter !== void 0 ? function(n) {
    switch (n.unaryFilter.op) {
      case "IS_NAN":
        const r = Fh(n.unaryFilter.field);
        return li.create(r, "==", {
          doubleValue: NaN
        });
      case "IS_NULL":
        const i = Fh(n.unaryFilter.field);
        return li.create(i, "==", {
          nullValue: "NULL_VALUE"
        });
      case "IS_NOT_NAN":
        const o = Fh(n.unaryFilter.field);
        return li.create(o, "!=", {
          doubleValue: NaN
        });
      case "IS_NOT_NULL":
        const a = Fh(n.unaryFilter.field);
        return li.create(a, "!=", {
          nullValue: "NULL_VALUE"
        });
      case "OPERATOR_UNSPECIFIED":
        return qt(61313);
      default:
        return qt(60726);
    }
  }(e) : e.fieldFilter !== void 0 ? function(n) {
    return li.create(Fh(n.fieldFilter.field), function(i) {
      switch (i) {
        case "EQUAL":
          return "==";
        case "NOT_EQUAL":
          return "!=";
        case "GREATER_THAN":
          return ">";
        case "GREATER_THAN_OR_EQUAL":
          return ">=";
        case "LESS_THAN":
          return "<";
        case "LESS_THAN_OR_EQUAL":
          return "<=";
        case "ARRAY_CONTAINS":
          return "array-contains";
        case "IN":
          return "in";
        case "NOT_IN":
          return "not-in";
        case "ARRAY_CONTAINS_ANY":
          return "array-contains-any";
        case "OPERATOR_UNSPECIFIED":
          return qt(58110);
        default:
          return qt(50506);
      }
    }(n.fieldFilter.op), n.fieldFilter.value);
  }(e) : e.compositeFilter !== void 0 ? function(n) {
    return $s.create(n.compositeFilter.filters.map((r) => hG(r)), function(i) {
      switch (i) {
        case "AND":
          return "and";
        case "OR":
          return "or";
        default:
          return qt(1026);
      }
    }(n.compositeFilter.op));
  }(e) : qt(30097, {
    filter: e
  });
}
function Rwe(e) {
  return vwe[e];
}
function Pwe(e) {
  return ywe[e];
}
function Owe(e) {
  return bwe[e];
}
function Ql(e) {
  return {
    fieldPath: e.canonicalString()
  };
}
function Fh(e) {
  return zi.fromServerFormat(e.fieldPath);
}
function gG(e) {
  return e instanceof li ? function(n) {
    if (n.op === "==") {
      if (kD(n.value))
        return {
          unaryFilter: {
            field: Ql(n.field),
            op: "IS_NAN"
          }
        };
      if (MD(n.value))
        return {
          unaryFilter: {
            field: Ql(n.field),
            op: "IS_NULL"
          }
        };
    } else if (n.op === "!=") {
      if (kD(n.value))
        return {
          unaryFilter: {
            field: Ql(n.field),
            op: "IS_NOT_NAN"
          }
        };
      if (MD(n.value))
        return {
          unaryFilter: {
            field: Ql(n.field),
            op: "IS_NOT_NULL"
          }
        };
    }
    return {
      fieldFilter: {
        field: Ql(n.field),
        op: Pwe(n.op),
        value: n.value
      }
    };
  }(e) : e instanceof $s ? function(n) {
    const r = n.getFilters().map((i) => gG(i));
    return r.length === 1 ? r[0] : {
      compositeFilter: {
        op: Owe(n.op),
        filters: r
      }
    };
  }(e) : qt(54877, {
    filter: e
  });
}
function Mwe(e) {
  const t = [];
  return e.fields.forEach((n) => t.push(n.canonicalString())), {
    fieldPaths: t
  };
}
function pG(e) {
  return e.length >= 4 && e.get(0) === "projects" && e.get(2) === "databases";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class eu {
  constructor(t, n, r, i, o = Kt.min(), a = Kt.min(), s = Wi.EMPTY_BYTE_STRING, c = null) {
    this.target = t, this.targetId = n, this.purpose = r, this.sequenceNumber = i, this.snapshotVersion = o, this.lastLimboFreeSnapshotVersion = a, this.resumeToken = s, this.expectedCount = c;
  }
  /** Creates a new target data instance with an updated sequence number. */
  withSequenceNumber(t) {
    return new eu(this.target, this.targetId, this.purpose, t, this.snapshotVersion, this.lastLimboFreeSnapshotVersion, this.resumeToken, this.expectedCount);
  }
  /**
   * Creates a new target data instance with an updated resume token and
   * snapshot version.
   */
  withResumeToken(t, n) {
    return new eu(
      this.target,
      this.targetId,
      this.purpose,
      this.sequenceNumber,
      n,
      this.lastLimboFreeSnapshotVersion,
      t,
      /* expectedCount= */
      null
    );
  }
  /**
   * Creates a new target data instance with an updated expected count.
   */
  withExpectedCount(t) {
    return new eu(this.target, this.targetId, this.purpose, this.sequenceNumber, this.snapshotVersion, this.lastLimboFreeSnapshotVersion, this.resumeToken, t);
  }
  /**
   * Creates a new target data instance with an updated last limbo free
   * snapshot version number.
   */
  withLastLimboFreeSnapshotVersion(t) {
    return new eu(this.target, this.targetId, this.purpose, this.sequenceNumber, this.snapshotVersion, t, this.resumeToken, this.expectedCount);
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class kwe {
  constructor(t) {
    this.gt = t;
  }
}
function Nwe(e) {
  const t = $we({
    parent: e.parent,
    structuredQuery: e.structuredQuery
  });
  return e.limitType === "LAST" ? nS(
    t,
    t.limit,
    "L"
    /* LimitType.Last */
  ) : t;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Dwe {
  constructor() {
    this.Dn = new jwe();
  }
  addToCollectionParentIndex(t, n) {
    return this.Dn.add(n), Pe.resolve();
  }
  getCollectionParents(t, n) {
    return Pe.resolve(this.Dn.getEntries(n));
  }
  addFieldIndex(t, n) {
    return Pe.resolve();
  }
  deleteFieldIndex(t, n) {
    return Pe.resolve();
  }
  deleteAllFieldIndexes(t) {
    return Pe.resolve();
  }
  createTargetIndexes(t, n) {
    return Pe.resolve();
  }
  getDocumentsMatchingTarget(t, n) {
    return Pe.resolve(null);
  }
  getIndexType(t, n) {
    return Pe.resolve(
      0
      /* IndexType.NONE */
    );
  }
  getFieldIndexes(t, n) {
    return Pe.resolve([]);
  }
  getNextCollectionGroupToUpdate(t) {
    return Pe.resolve(null);
  }
  getMinOffset(t, n) {
    return Pe.resolve($u.min());
  }
  getMinOffsetFromCollectionGroup(t, n) {
    return Pe.resolve($u.min());
  }
  updateCollectionGroup(t, n, r) {
    return Pe.resolve();
  }
  updateIndexEntries(t, n) {
    return Pe.resolve();
  }
}
class jwe {
  constructor() {
    this.index = {};
  }
  // Returns false if the entry already existed.
  add(t) {
    const n = t.lastSegment(), r = t.popLast(), i = this.index[n] || new wi(or.comparator), o = !i.has(r);
    return this.index[n] = i.add(r), o;
  }
  has(t) {
    const n = t.lastSegment(), r = t.popLast(), i = this.index[n];
    return i && i.has(r);
  }
  getEntries(t) {
    return (this.index[t] || new wi(or.comparator)).toArray();
  }
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const KD = {
  didRun: !1,
  sequenceNumbersCollected: 0,
  targetsRemoved: 0,
  documentsRemoved: 0
}, mG = 41943040;
class Ko {
  static withCacheSize(t) {
    return new Ko(t, Ko.DEFAULT_COLLECTION_PERCENTILE, Ko.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT);
  }
  constructor(t, n, r) {
    this.cacheSizeCollectionThreshold = t, this.percentileToCollect = n, this.maximumSequenceNumbersToCollect = r;
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Ko.DEFAULT_COLLECTION_PERCENTILE = 10, Ko.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT = 1e3, Ko.DEFAULT = new Ko(mG, Ko.DEFAULT_COLLECTION_PERCENTILE, Ko.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT), Ko.DISABLED = new Ko(-1, 0, 0);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Rg {
  constructor(t) {
    this._r = t;
  }
  next() {
    return this._r += 2, this._r;
  }
  static ar() {
    return new Rg(0);
  }
  static ur() {
    return new Rg(-1);
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const YD = "LruGarbageCollector", vG = 1048576;
function XD([e, t], [n, r]) {
  const i = gn(e, n);
  return i === 0 ? gn(t, r) : i;
}
class Lwe {
  constructor(t) {
    this.Tr = t, this.buffer = new wi(XD), this.Ir = 0;
  }
  dr() {
    return ++this.Ir;
  }
  Er(t) {
    const n = [t, this.dr()];
    if (this.buffer.size < this.Tr)
      this.buffer = this.buffer.add(n);
    else {
      const r = this.buffer.last();
      XD(n, r) < 0 && (this.buffer = this.buffer.delete(r).add(n));
    }
  }
  get maxValue() {
    return this.buffer.last()[0];
  }
}
class Fwe {
  constructor(t, n, r) {
    this.garbageCollector = t, this.asyncQueue = n, this.localStore = r, this.Ar = null;
  }
  start() {
    this.garbageCollector.params.cacheSizeCollectionThreshold !== -1 && this.Rr(6e4);
  }
  stop() {
    this.Ar && (this.Ar.cancel(), this.Ar = null);
  }
  get started() {
    return this.Ar !== null;
  }
  Rr(t) {
    bt(YD, `Garbage collection scheduled in ${t}ms`), this.Ar = this.asyncQueue.enqueueAfterDelay("lru_garbage_collection", t, async () => {
      this.Ar = null;
      try {
        await this.localStore.collectGarbage(this.garbageCollector);
      } catch (n) {
        jp(n) ? bt(YD, "Ignoring IndexedDB error during garbage collection: ", n) : await Dp(n);
      }
      await this.Rr(3e5);
    });
  }
}
class Vwe {
  constructor(t, n) {
    this.Vr = t, this.params = n;
  }
  calculateTargetCount(t, n) {
    return this.Vr.mr(t).next((r) => Math.floor(n / 100 * r));
  }
  nthSequenceNumber(t, n) {
    if (n === 0)
      return Pe.resolve(Bx.ue);
    const r = new Lwe(n);
    return this.Vr.forEachTarget(t, (i) => r.Er(i.sequenceNumber)).next(() => this.Vr.gr(t, (i) => r.Er(i))).next(() => r.maxValue);
  }
  removeTargets(t, n, r) {
    return this.Vr.removeTargets(t, n, r);
  }
  removeOrphanedDocuments(t, n) {
    return this.Vr.removeOrphanedDocuments(t, n);
  }
  collect(t, n) {
    return this.params.cacheSizeCollectionThreshold === -1 ? (bt("LruGarbageCollector", "Garbage collection skipped; disabled"), Pe.resolve(KD)) : this.getCacheSize(t).next((r) => r < this.params.cacheSizeCollectionThreshold ? (bt("LruGarbageCollector", `Garbage collection skipped; Cache size ${r} is lower than threshold ${this.params.cacheSizeCollectionThreshold}`), KD) : this.pr(t, n));
  }
  getCacheSize(t) {
    return this.Vr.getCacheSize(t);
  }
  pr(t, n) {
    let r, i, o, a, s, c, l;
    const u = Date.now();
    return this.calculateTargetCount(t, this.params.percentileToCollect).next((d) => (
      // Cap at the configured max
      (d > this.params.maximumSequenceNumbersToCollect ? (bt("LruGarbageCollector", `Capping sequence numbers to collect down to the maximum of ${this.params.maximumSequenceNumbersToCollect} from ${d}`), i = this.params.maximumSequenceNumbersToCollect) : i = d, a = Date.now(), this.nthSequenceNumber(t, i))
    )).next((d) => (r = d, s = Date.now(), this.removeTargets(t, r, n))).next((d) => (o = d, c = Date.now(), this.removeOrphanedDocuments(t, r))).next((d) => (l = Date.now(), jh() <= _n.DEBUG && bt("LruGarbageCollector", `LRU Garbage Collection
	Counted targets in ${a - u}ms
	Determined least recently used ${i} in ` + (s - a) + `ms
	Removed ${o} targets in ` + (c - s) + `ms
	Removed ${d} documents in ` + (l - c) + `ms
Total Duration: ${l - u}ms`), Pe.resolve({
      didRun: !0,
      sequenceNumbersCollected: i,
      targetsRemoved: o,
      documentsRemoved: d
    })));
  }
}
function Bwe(e, t) {
  return new Vwe(e, t);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class zwe {
  constructor() {
    this.changes = new Vf((t) => t.toString(), (t, n) => t.isEqual(n)), this.changesApplied = !1;
  }
  /**
   * Buffers a `RemoteDocumentCache.addEntry()` call.
   *
   * You can only modify documents that have already been retrieved via
   * `getEntry()/getEntries()` (enforced via IndexedDbs `apply()`).
   */
  addEntry(t) {
    this.assertNotApplied(), this.changes.set(t.key, t);
  }
  /**
   * Buffers a `RemoteDocumentCache.removeEntry()` call.
   *
   * You can only remove documents that have already been retrieved via
   * `getEntry()/getEntries()` (enforced via IndexedDbs `apply()`).
   */
  removeEntry(t, n) {
    this.assertNotApplied(), this.changes.set(t, so.newInvalidDocument(t).setReadTime(n));
  }
  /**
   * Looks up an entry in the cache. The buffered changes will first be checked,
   * and if no buffered change applies, this will forward to
   * `RemoteDocumentCache.getEntry()`.
   *
   * @param transaction - The transaction in which to perform any persistence
   *     operations.
   * @param documentKey - The key of the entry to look up.
   * @returns The cached document or an invalid document if we have nothing
   * cached.
   */
  getEntry(t, n) {
    this.assertNotApplied();
    const r = this.changes.get(n);
    return r !== void 0 ? Pe.resolve(r) : this.getFromCache(t, n);
  }
  /**
   * Looks up several entries in the cache, forwarding to
   * `RemoteDocumentCache.getEntry()`.
   *
   * @param transaction - The transaction in which to perform any persistence
   *     operations.
   * @param documentKeys - The keys of the entries to look up.
   * @returns A map of cached documents, indexed by key. If an entry cannot be
   *     found, the corresponding key will be mapped to an invalid document.
   */
  getEntries(t, n) {
    return this.getAllFromCache(t, n);
  }
  /**
   * Applies buffered changes to the underlying RemoteDocumentCache, using
   * the provided transaction.
   */
  apply(t) {
    return this.assertNotApplied(), this.changesApplied = !0, this.applyChanges(t);
  }
  /** Helper to assert this.changes is not null  */
  assertNotApplied() {
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Hwe {
  constructor(t, n) {
    this.overlayedDocument = t, this.mutatedFields = n;
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Uwe {
  constructor(t, n, r, i) {
    this.remoteDocumentCache = t, this.mutationQueue = n, this.documentOverlayCache = r, this.indexManager = i;
  }
  /**
   * Get the local view of the document identified by `key`.
   *
   * @returns Local view of the document or null if we don't have any cached
   * state for it.
   */
  getDocument(t, n) {
    let r = null;
    return this.documentOverlayCache.getOverlay(t, n).next((i) => (r = i, this.remoteDocumentCache.getEntry(t, n))).next((i) => (r !== null && O0(r.mutation, i, va.empty(), jn.now()), i));
  }
  /**
   * Gets the local view of the documents identified by `keys`.
   *
   * If we don't have cached state for a document in `keys`, a NoDocument will
   * be stored for that key in the resulting set.
   */
  getDocuments(t, n) {
    return this.remoteDocumentCache.getEntries(t, n).next((r) => this.getLocalViewOfDocuments(t, r, Sn()).next(() => r));
  }
  /**
   * Similar to `getDocuments`, but creates the local view from the given
   * `baseDocs` without retrieving documents from the local store.
   *
   * @param transaction - The transaction this operation is scoped to.
   * @param docs - The documents to apply local mutations to get the local views.
   * @param existenceStateChanged - The set of document keys whose existence state
   *   is changed. This is useful to determine if some documents overlay needs
   *   to be recalculated.
   */
  getLocalViewOfDocuments(t, n, r = Sn()) {
    const i = kd();
    return this.populateOverlays(t, i, n).next(() => this.computeViews(t, n, i, r).next((o) => {
      let a = a0();
      return o.forEach((s, c) => {
        a = a.insert(s, c.overlayedDocument);
      }), a;
    }));
  }
  /**
   * Gets the overlayed documents for the given document map, which will include
   * the local view of those documents and a `FieldMask` indicating which fields
   * are mutated locally, `null` if overlay is a Set or Delete mutation.
   */
  getOverlayedDocuments(t, n) {
    const r = kd();
    return this.populateOverlays(t, r, n).next(() => this.computeViews(t, n, r, Sn()));
  }
  /**
   * Fetches the overlays for {@code docs} and adds them to provided overlay map
   * if the map does not already contain an entry for the given document key.
   */
  populateOverlays(t, n, r) {
    const i = [];
    return r.forEach((o) => {
      n.has(o) || i.push(o);
    }), this.documentOverlayCache.getOverlays(t, i).next((o) => {
      o.forEach((a, s) => {
        n.set(a, s);
      });
    });
  }
  /**
   * Computes the local view for the given documents.
   *
   * @param docs - The documents to compute views for. It also has the base
   *   version of the documents.
   * @param overlays - The overlays that need to be applied to the given base
   *   version of the documents.
   * @param existenceStateChanged - A set of documents whose existence states
   *   might have changed. This is used to determine if we need to re-calculate
   *   overlays from mutation queues.
   * @return A map represents the local documents view.
   */
  computeViews(t, n, r, i) {
    let o = gl();
    const a = P0(), s = function() {
      return P0();
    }();
    return n.forEach((c, l) => {
      const u = r.get(l.key);
      i.has(l.key) && (u === void 0 || u.mutation instanceof Ju) ? o = o.insert(l.key, l) : u !== void 0 ? (a.set(l.key, u.mutation.getFieldMask()), O0(u.mutation, l, u.mutation.getFieldMask(), jn.now())) : (
        // no overlay exists
        // Using EMPTY to indicate there is no overlay for the document.
        a.set(l.key, va.empty())
      );
    }), this.recalculateAndSaveOverlays(t, o).next((c) => (c.forEach((l, u) => a.set(l, u)), n.forEach((l, u) => {
      var d;
      return s.set(l, new Hwe(u, (d = a.get(l)) !== null && d !== void 0 ? d : null));
    }), s));
  }
  recalculateAndSaveOverlays(t, n) {
    const r = P0();
    let i = new Fr((a, s) => a - s), o = Sn();
    return this.mutationQueue.getAllMutationBatchesAffectingDocumentKeys(t, n).next((a) => {
      for (const s of a)
        s.keys().forEach((c) => {
          const l = n.get(c);
          if (l === null)
            return;
          let u = r.get(c) || va.empty();
          u = s.applyToLocalView(l, u), r.set(c, u);
          const d = (i.get(s.batchId) || Sn()).add(c);
          i = i.insert(s.batchId, d);
        });
    }).next(() => {
      const a = [], s = i.getReverseIterator();
      for (; s.hasNext(); ) {
        const c = s.getNext(), l = c.key, u = c.value, d = Xq();
        u.forEach((f) => {
          if (!o.has(f)) {
            const h = nG(n.get(f), r.get(f));
            h !== null && d.set(f, h), o = o.add(f);
          }
        }), a.push(this.documentOverlayCache.saveOverlays(t, l, d));
      }
      return Pe.waitFor(a);
    }).next(() => r);
  }
  /**
   * Recalculates overlays by reading the documents from remote document cache
   * first, and saves them after they are calculated.
   */
  recalculateAndSaveOverlaysForDocumentKeys(t, n) {
    return this.remoteDocumentCache.getEntries(t, n).next((r) => this.recalculateAndSaveOverlays(t, r));
  }
  /**
   * Performs a query against the local view of all documents.
   *
   * @param transaction - The persistence transaction.
   * @param query - The query to match documents against.
   * @param offset - Read time and key to start scanning by (exclusive).
   * @param context - A optional tracker to keep a record of important details
   *   during database local query execution.
   */
  getDocumentsMatchingQuery(t, n, r, i) {
    return function(a) {
      return kt.isDocumentKey(a.path) && a.collectionGroup === null && a.filters.length === 0;
    }(n) ? this.getDocumentsMatchingDocumentQuery(t, n.path) : WO(n) ? this.getDocumentsMatchingCollectionGroupQuery(t, n, r, i) : this.getDocumentsMatchingCollectionQuery(t, n, r, i);
  }
  /**
   * Given a collection group, returns the next documents that follow the provided offset, along
   * with an updated batch ID.
   *
   * <p>The documents returned by this method are ordered by remote version from the provided
   * offset. If there are no more remote documents after the provided offset, documents with
   * mutations in order of batch id from the offset are returned. Since all documents in a batch are
   * returned together, the total number of documents returned can exceed {@code count}.
   *
   * @param transaction
   * @param collectionGroup The collection group for the documents.
   * @param offset The offset to index into.
   * @param count The number of documents to return
   * @return A LocalWriteResult with the documents that follow the provided offset and the last processed batch id.
   */
  getNextDocuments(t, n, r, i) {
    return this.remoteDocumentCache.getAllFromCollectionGroup(t, n, r, i).next((o) => {
      const a = i - o.size > 0 ? this.documentOverlayCache.getOverlaysForCollectionGroup(t, n, r.largestBatchId, i - o.size) : Pe.resolve(kd());
      let s = sv, c = o;
      return a.next((l) => Pe.forEach(l, (u, d) => (s < d.largestBatchId && (s = d.largestBatchId), o.get(u) ? Pe.resolve() : this.remoteDocumentCache.getEntry(t, u).next((f) => {
        c = c.insert(u, f);
      }))).next(() => this.populateOverlays(t, l, o)).next(() => this.computeViews(t, c, l, Sn())).next((u) => ({
        batchId: s,
        changes: Yq(u)
      })));
    });
  }
  getDocumentsMatchingDocumentQuery(t, n) {
    return this.getDocument(t, new kt(n)).next((r) => {
      let i = a0();
      return r.isFoundDocument() && (i = i.insert(r.key, r)), i;
    });
  }
  getDocumentsMatchingCollectionGroupQuery(t, n, r, i) {
    const o = n.collectionGroup;
    let a = a0();
    return this.indexManager.getCollectionParents(t, o).next((s) => Pe.forEach(s, (c) => {
      const l = function(d, f) {
        return new Qu(
          f,
          /*collectionGroup=*/
          null,
          d.explicitOrderBy.slice(),
          d.filters.slice(),
          d.limit,
          d.limitType,
          d.startAt,
          d.endAt
        );
      }(n, c.child(o));
      return this.getDocumentsMatchingCollectionQuery(t, l, r, i).next((u) => {
        u.forEach((d, f) => {
          a = a.insert(d, f);
        });
      });
    }).next(() => a));
  }
  getDocumentsMatchingCollectionQuery(t, n, r, i) {
    let o;
    return this.documentOverlayCache.getOverlaysForCollection(t, n.path, r.largestBatchId).next((a) => (o = a, this.remoteDocumentCache.getDocumentsMatchingQuery(t, n, r, o, i))).next((a) => {
      o.forEach((c, l) => {
        const u = l.getKey();
        a.get(u) === null && (a = a.insert(u, so.newInvalidDocument(u)));
      });
      let s = a0();
      return a.forEach((c, l) => {
        const u = o.get(c);
        u !== void 0 && O0(u.mutation, l, va.empty(), jn.now()), // Finally, insert the documents that still match the query
        Kx(n, l) && (s = s.insert(c, l));
      }), s;
    });
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Wwe {
  constructor(t) {
    this.serializer = t, this.Br = /* @__PURE__ */ new Map(), this.Lr = /* @__PURE__ */ new Map();
  }
  getBundleMetadata(t, n) {
    return Pe.resolve(this.Br.get(n));
  }
  saveBundleMetadata(t, n) {
    return this.Br.set(
      n.id,
      /** Decodes a BundleMetadata proto into a BundleMetadata object. */
      function(i) {
        return {
          id: i.id,
          version: i.version,
          createTime: fc(i.createTime)
        };
      }(n)
    ), Pe.resolve();
  }
  getNamedQuery(t, n) {
    return Pe.resolve(this.Lr.get(n));
  }
  saveNamedQuery(t, n) {
    return this.Lr.set(n.name, function(i) {
      return {
        name: i.name,
        query: Nwe(i.bundledQuery),
        readTime: fc(i.readTime)
      };
    }(n)), Pe.resolve();
  }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class qwe {
  constructor() {
    this.overlays = new Fr(kt.comparator), this.kr = /* @__PURE__ */ new Map();
  }
  getOverlay(t, n) {
    return Pe.resolve(this.overlays.get(n));
  }
  getOverlays(t, n) {
    const r = kd();
    return Pe.forEach(n, (i) => this.getOverlay(t, i).next((o) => {
      o !== null && r.set(i, o);
    })).next(() => r);
  }
  saveOverlays(t, n, r) {
    return r.forEach((i, o) => {
      this.wt(t, n, o);
    }), Pe.resolve();
  }
  removeOverlaysForBatchId(t, n, r) {
    const i = this.kr.get(r);
    return i !== void 0 && (i.forEach((o) => this.overlays = this.overlays.remove(o)), this.kr.delete(r)), Pe.resolve();
  }
  getOverlaysForCollection(t, n, r) {
    const i = kd(), o = n.length + 1, a = new kt(n.child("")), s = this.overlays.getIteratorFrom(a);
    for (; s.hasNext(); ) {
      const c = s.getNext().value, l = c.getKey();
      if (!n.isPrefixOf(l.path))
        break;
      l.path.length === o && c.largestBatchId > r && i.set(c.getKey(), c);
    }
    return Pe.resolve(i);
  }
  getOverlaysForCollectionGroup(t, n, r, i) {
    let o = new Fr((l, u) => l - u);
    const a = this.overlays.getIterator();
    for (; a.hasNext(); ) {
      const l = a.getNext().value;
      if (l.getKey().getCollectionGroup() === n && l.largestBatchId > r) {
        let u = o.get(l.largestBatchId);
        u === null && (u = kd(), o = o.insert(l.largestBatchId, u)), u.set(l.getKey(), l);
      }
    }
    const s = kd(), c = o.getIterator();
    for (; c.hasNext() && (c.getNext().value.forEach((l, u) => s.set(l, u)), !(s.size() >= i)); )
      ;
    return Pe.resolve(s);
  }
  wt(t, n, r) {
    const i = this.overlays.get(r.key);
    if (i !== null) {
      const a = this.kr.get(i.largestBatchId).delete(r.key);
      this.kr.set(i.largestBatchId, a);
    }
    this.overlays = this.overlays.insert(r.key, new dwe(n, r));
    let o = this.kr.get(n);
    o === void 0 && (o = Sn(), this.kr.set(n, o)), this.kr.set(n, o.add(r.key));
  }
}
/**
 * @license
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Gwe {
  constructor() {
    this.sessionToken = Wi.EMPTY_BYTE_STRING;
  }
  getSessionToken(t) {
    return Pe.resolve(this.sessionToken);
  }
  setSessionToken(t, n) {
    return this.sessionToken = n, Pe.resolve();
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class XO {
  constructor() {
    this.qr = new wi(Ai.Qr), // A set of outstanding references to a document sorted by target id.
    this.$r = new wi(Ai.Ur);
  }
  /** Returns true if the reference set contains no references. */
  isEmpty() {
    return this.qr.isEmpty();
  }
  /** Adds a reference to the given document key for the given ID. */
  addReference(t, n) {
    const r = new Ai(t, n);
    this.qr = this.qr.add(r), this.$r = this.$r.add(r);
  }
  /** Add references to the given document keys for the given ID. */
  Kr(t, n) {
    t.forEach((r) => this.addReference(r, n));
  }
  /**
   * Removes a reference to the given document key for the given
   * ID.
   */
  removeReference(t, n) {
    this.Wr(new Ai(t, n));
  }
  Gr(t, n) {
    t.forEach((r) => this.removeReference(r, n));
  }
  /**
   * Clears all references with a given ID. Calls removeRef() for each key
   * removed.
   */
  zr(t) {
    const n = new kt(new or([])), r = new Ai(n, t), i = new Ai(n, t + 1), o = [];
    return this.$r.forEachInRange([r, i], (a) => {
      this.Wr(a), o.push(a.key);
    }), o;
  }
  jr() {
    this.qr.forEach((t) => this.Wr(t));
  }
  Wr(t) {
    this.qr = this.qr.delete(t), this.$r = this.$r.delete(t);
  }
  Jr(t) {
    const n = new kt(new or([])), r = new Ai(n, t), i = new Ai(n, t + 1);
    let o = Sn();
    return this.$r.forEachInRange([r, i], (a) => {
      o = o.add(a.key);
    }), o;
  }
  containsKey(t) {
    const n = new Ai(t, 0), r = this.qr.firstAfterOrEqual(n);
    return r !== null && t.isEqual(r.key);
  }
}
class Ai {
  constructor(t, n) {
    this.key = t, this.Hr = n;
  }
  /** Compare by key then by ID */
  static Qr(t, n) {
    return kt.comparator(t.key, n.key) || gn(t.Hr, n.Hr);
  }
  /** Compare by ID then by key */
  static Ur(t, n) {
    return gn(t.Hr, n.Hr) || kt.comparator(t.key, n.key);
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Kwe {
  constructor(t, n) {
    this.indexManager = t, this.referenceDelegate = n, /**
     * The set of all mutations that have been sent but not yet been applied to
     * the backend.
     */
    this.mutationQueue = [], /** Next value to use when assigning sequential IDs to each mutation batch. */
    this.er = 1, /** An ordered mapping between documents and the mutations batch IDs. */
    this.Yr = new wi(Ai.Qr);
  }
  checkEmpty(t) {
    return Pe.resolve(this.mutationQueue.length === 0);
  }
  addMutationBatch(t, n, r, i) {
    const o = this.er;
    this.er++, this.mutationQueue.length > 0 && this.mutationQueue[this.mutationQueue.length - 1];
    const a = new uwe(o, n, r, i);
    this.mutationQueue.push(a);
    for (const s of i)
      this.Yr = this.Yr.add(new Ai(s.key, o)), this.indexManager.addToCollectionParentIndex(t, s.key.path.popLast());
    return Pe.resolve(a);
  }
  lookupMutationBatch(t, n) {
    return Pe.resolve(this.Zr(n));
  }
  getNextMutationBatchAfterBatchId(t, n) {
    const r = n + 1, i = this.Xr(r), o = i < 0 ? 0 : i;
    return Pe.resolve(this.mutationQueue.length > o ? this.mutationQueue[o] : null);
  }
  getHighestUnacknowledgedBatchId() {
    return Pe.resolve(this.mutationQueue.length === 0 ? zx : this.er - 1);
  }
  getAllMutationBatches(t) {
    return Pe.resolve(this.mutationQueue.slice());
  }
  getAllMutationBatchesAffectingDocumentKey(t, n) {
    const r = new Ai(n, 0), i = new Ai(n, Number.POSITIVE_INFINITY), o = [];
    return this.Yr.forEachInRange([r, i], (a) => {
      const s = this.Zr(a.Hr);
      o.push(s);
    }), Pe.resolve(o);
  }
  getAllMutationBatchesAffectingDocumentKeys(t, n) {
    let r = new wi(gn);
    return n.forEach((i) => {
      const o = new Ai(i, 0), a = new Ai(i, Number.POSITIVE_INFINITY);
      this.Yr.forEachInRange([o, a], (s) => {
        r = r.add(s.Hr);
      });
    }), Pe.resolve(this.ei(r));
  }
  getAllMutationBatchesAffectingQuery(t, n) {
    const r = n.path, i = r.length + 1;
    let o = r;
    kt.isDocumentKey(o) || (o = o.child(""));
    const a = new Ai(new kt(o), 0);
    let s = new wi(gn);
    return this.Yr.forEachWhile((c) => {
      const l = c.key.path;
      return !!r.isPrefixOf(l) && // Rows with document keys more than one segment longer than the query
      // path can't be matches. For example, a query on 'rooms' can't match
      // the document /rooms/abc/messages/xyx.
      // TODO(mcg): we'll need a different scanner when we implement
      // ancestor queries.
      (l.length === i && (s = s.add(c.Hr)), !0);
    }, a), Pe.resolve(this.ei(s));
  }
  ei(t) {
    const n = [];
    return t.forEach((r) => {
      const i = this.Zr(r);
      i !== null && n.push(i);
    }), n;
  }
  removeMutationBatch(t, n) {
    Fn(this.ti(n.batchId, "removed") === 0, 55003), this.mutationQueue.shift();
    let r = this.Yr;
    return Pe.forEach(n.mutations, (i) => {
      const o = new Ai(i.key, n.batchId);
      return r = r.delete(o), this.referenceDelegate.markPotentiallyOrphaned(t, i.key);
    }).next(() => {
      this.Yr = r;
    });
  }
  rr(t) {
  }
  containsKey(t, n) {
    const r = new Ai(n, 0), i = this.Yr.firstAfterOrEqual(r);
    return Pe.resolve(n.isEqual(i && i.key));
  }
  performConsistencyCheck(t) {
    return this.mutationQueue.length, Pe.resolve();
  }
  /**
   * Finds the index of the given batchId in the mutation queue and asserts that
   * the resulting index is within the bounds of the queue.
   *
   * @param batchId - The batchId to search for
   * @param action - A description of what the caller is doing, phrased in passive
   * form (e.g. "acknowledged" in a routine that acknowledges batches).
   */
  ti(t, n) {
    return this.Xr(t);
  }
  /**
   * Finds the index of the given batchId in the mutation queue. This operation
   * is O(1).
   *
   * @returns The computed index of the batch with the given batchId, based on
   * the state of the queue. Note this index can be negative if the requested
   * batchId has already been removed from the queue or past the end of the
   * queue if the batchId is larger than the last added batch.
   */
  Xr(t) {
    return this.mutationQueue.length === 0 ? 0 : t - this.mutationQueue[0].batchId;
  }
  /**
   * A version of lookupMutationBatch that doesn't return a promise, this makes
   * other functions that uses this code easier to read and more efficient.
   */
  Zr(t) {
    const n = this.Xr(t);
    return n < 0 || n >= this.mutationQueue.length ? null : this.mutationQueue[n];
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Ywe {
  /**
   * @param sizer - Used to assess the size of a document. For eager GC, this is
   * expected to just return 0 to avoid unnecessarily doing the work of
   * calculating the size.
   */
  constructor(t) {
    this.ni = t, /** Underlying cache of documents and their read times. */
    this.docs = function() {
      return new Fr(kt.comparator);
    }(), /** Size of all cached documents. */
    this.size = 0;
  }
  setIndexManager(t) {
    this.indexManager = t;
  }
  /**
   * Adds the supplied entry to the cache and updates the cache size as appropriate.
   *
   * All calls of `addEntry`  are required to go through the RemoteDocumentChangeBuffer
   * returned by `newChangeBuffer()`.
   */
  addEntry(t, n) {
    const r = n.key, i = this.docs.get(r), o = i ? i.size : 0, a = this.ni(n);
    return this.docs = this.docs.insert(r, {
      document: n.mutableCopy(),
      size: a
    }), this.size += a - o, this.indexManager.addToCollectionParentIndex(t, r.path.popLast());
  }
  /**
   * Removes the specified entry from the cache and updates the cache size as appropriate.
   *
   * All calls of `removeEntry` are required to go through the RemoteDocumentChangeBuffer
   * returned by `newChangeBuffer()`.
   */
  removeEntry(t) {
    const n = this.docs.get(t);
    n && (this.docs = this.docs.remove(t), this.size -= n.size);
  }
  getEntry(t, n) {
    const r = this.docs.get(n);
    return Pe.resolve(r ? r.document.mutableCopy() : so.newInvalidDocument(n));
  }
  getEntries(t, n) {
    let r = gl();
    return n.forEach((i) => {
      const o = this.docs.get(i);
      r = r.insert(i, o ? o.document.mutableCopy() : so.newInvalidDocument(i));
    }), Pe.resolve(r);
  }
  getDocumentsMatchingQuery(t, n, r, i) {
    let o = gl();
    const a = n.path, s = new kt(a.child("__id-9223372036854775808__")), c = this.docs.getIteratorFrom(s);
    for (; c.hasNext(); ) {
      const { key: l, value: { document: u } } = c.getNext();
      if (!a.isPrefixOf(l.path))
        break;
      l.path.length > a.length + 1 || CSe(ESe(u), r) <= 0 || (i.has(u.key) || Kx(n, u)) && (o = o.insert(u.key, u.mutableCopy()));
    }
    return Pe.resolve(o);
  }
  getAllFromCollectionGroup(t, n, r, i) {
    qt(9500);
  }
  ri(t, n) {
    return Pe.forEach(this.docs, (r) => n(r));
  }
  newChangeBuffer(t) {
    return new Xwe(this);
  }
  getSize(t) {
    return Pe.resolve(this.size);
  }
}
class Xwe extends zwe {
  constructor(t) {
    super(), this.Or = t;
  }
  applyChanges(t) {
    const n = [];
    return this.changes.forEach((r, i) => {
      i.isValidDocument() ? n.push(this.Or.addEntry(t, i)) : this.Or.removeEntry(r);
    }), Pe.waitFor(n);
  }
  getFromCache(t, n) {
    return this.Or.getEntry(t, n);
  }
  getAllFromCache(t, n) {
    return this.Or.getEntries(t, n);
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Qwe {
  constructor(t) {
    this.persistence = t, /**
     * Maps a target to the data about that target
     */
    this.ii = new Vf((n) => HO(n), UO), /** The last received snapshot version. */
    this.lastRemoteSnapshotVersion = Kt.min(), /** The highest numbered target ID encountered. */
    this.highestTargetId = 0, /** The highest sequence number encountered. */
    this.si = 0, /**
     * A ordered bidirectional mapping between documents and the remote target
     * IDs.
     */
    this.oi = new XO(), this.targetCount = 0, this._i = Rg.ar();
  }
  forEachTarget(t, n) {
    return this.ii.forEach((r, i) => n(i)), Pe.resolve();
  }
  getLastRemoteSnapshotVersion(t) {
    return Pe.resolve(this.lastRemoteSnapshotVersion);
  }
  getHighestSequenceNumber(t) {
    return Pe.resolve(this.si);
  }
  allocateTargetId(t) {
    return this.highestTargetId = this._i.next(), Pe.resolve(this.highestTargetId);
  }
  setTargetsMetadata(t, n, r) {
    return r && (this.lastRemoteSnapshotVersion = r), n > this.si && (this.si = n), Pe.resolve();
  }
  hr(t) {
    this.ii.set(t.target, t);
    const n = t.targetId;
    n > this.highestTargetId && (this._i = new Rg(n), this.highestTargetId = n), t.sequenceNumber > this.si && (this.si = t.sequenceNumber);
  }
  addTargetData(t, n) {
    return this.hr(n), this.targetCount += 1, Pe.resolve();
  }
  updateTargetData(t, n) {
    return this.hr(n), Pe.resolve();
  }
  removeTargetData(t, n) {
    return this.ii.delete(n.target), this.oi.zr(n.targetId), this.targetCount -= 1, Pe.resolve();
  }
  removeTargets(t, n, r) {
    let i = 0;
    const o = [];
    return this.ii.forEach((a, s) => {
      s.sequenceNumber <= n && r.get(s.targetId) === null && (this.ii.delete(a), o.push(this.removeMatchingKeysForTargetId(t, s.targetId)), i++);
    }), Pe.waitFor(o).next(() => i);
  }
  getTargetCount(t) {
    return Pe.resolve(this.targetCount);
  }
  getTargetData(t, n) {
    const r = this.ii.get(n) || null;
    return Pe.resolve(r);
  }
  addMatchingKeys(t, n, r) {
    return this.oi.Kr(n, r), Pe.resolve();
  }
  removeMatchingKeys(t, n, r) {
    this.oi.Gr(n, r);
    const i = this.persistence.referenceDelegate, o = [];
    return i && n.forEach((a) => {
      o.push(i.markPotentiallyOrphaned(t, a));
    }), Pe.waitFor(o);
  }
  removeMatchingKeysForTargetId(t, n) {
    return this.oi.zr(n), Pe.resolve();
  }
  getMatchingKeysForTargetId(t, n) {
    const r = this.oi.Jr(n);
    return Pe.resolve(r);
  }
  containsKey(t, n) {
    return Pe.resolve(this.oi.containsKey(n));
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class yG {
  /**
   * The constructor accepts a factory for creating a reference delegate. This
   * allows both the delegate and this instance to have strong references to
   * each other without having nullable fields that would then need to be
   * checked or asserted on every access.
   */
  constructor(t, n) {
    this.ai = {}, this.overlays = {}, this.ui = new Bx(0), this.ci = !1, this.ci = !0, this.li = new Gwe(), this.referenceDelegate = t(this), this.hi = new Qwe(this), this.indexManager = new Dwe(), this.remoteDocumentCache = function(i) {
      return new Ywe(i);
    }((r) => this.referenceDelegate.Pi(r)), this.serializer = new kwe(n), this.Ti = new Wwe(this.serializer);
  }
  start() {
    return Promise.resolve();
  }
  shutdown() {
    return this.ci = !1, Promise.resolve();
  }
  get started() {
    return this.ci;
  }
  setDatabaseDeletedListener() {
  }
  setNetworkEnabled() {
  }
  getIndexManager(t) {
    return this.indexManager;
  }
  getDocumentOverlayCache(t) {
    let n = this.overlays[t.toKey()];
    return n || (n = new qwe(), this.overlays[t.toKey()] = n), n;
  }
  getMutationQueue(t, n) {
    let r = this.ai[t.toKey()];
    return r || (r = new Kwe(n, this.referenceDelegate), this.ai[t.toKey()] = r), r;
  }
  getGlobalsCache() {
    return this.li;
  }
  getTargetCache() {
    return this.hi;
  }
  getRemoteDocumentCache() {
    return this.remoteDocumentCache;
  }
  getBundleCache() {
    return this.Ti;
  }
  runTransaction(t, n, r) {
    bt("MemoryPersistence", "Starting transaction:", t);
    const i = new Jwe(this.ui.next());
    return this.referenceDelegate.Ii(), r(i).next((o) => this.referenceDelegate.di(i).next(() => o)).toPromise().then((o) => (i.raiseOnCommittedEvent(), o));
  }
  Ei(t, n) {
    return Pe.or(Object.values(this.ai).map((r) => () => r.containsKey(t, n)));
  }
}
class Jwe extends ISe {
  constructor(t) {
    super(), this.currentSequenceNumber = t;
  }
}
class QO {
  constructor(t) {
    this.persistence = t, /** Tracks all documents that are active in Query views. */
    this.Ai = new XO(), /** The list of documents that are potentially GCed after each transaction. */
    this.Ri = null;
  }
  static Vi(t) {
    return new QO(t);
  }
  get mi() {
    if (this.Ri)
      return this.Ri;
    throw qt(60996);
  }
  addReference(t, n, r) {
    return this.Ai.addReference(r, n), this.mi.delete(r.toString()), Pe.resolve();
  }
  removeReference(t, n, r) {
    return this.Ai.removeReference(r, n), this.mi.add(r.toString()), Pe.resolve();
  }
  markPotentiallyOrphaned(t, n) {
    return this.mi.add(n.toString()), Pe.resolve();
  }
  removeTarget(t, n) {
    this.Ai.zr(n.targetId).forEach((i) => this.mi.add(i.toString()));
    const r = this.persistence.getTargetCache();
    return r.getMatchingKeysForTargetId(t, n.targetId).next((i) => {
      i.forEach((o) => this.mi.add(o.toString()));
    }).next(() => r.removeTargetData(t, n));
  }
  Ii() {
    this.Ri = /* @__PURE__ */ new Set();
  }
  di(t) {
    const n = this.persistence.getRemoteDocumentCache().newChangeBuffer();
    return Pe.forEach(this.mi, (r) => {
      const i = kt.fromPath(r);
      return this.fi(t, i).next((o) => {
        o || n.removeEntry(i, Kt.min());
      });
    }).next(() => (this.Ri = null, n.apply(t)));
  }
  updateLimboDocument(t, n) {
    return this.fi(t, n).next((r) => {
      r ? this.mi.delete(n.toString()) : this.mi.add(n.toString());
    });
  }
  Pi(t) {
    return 0;
  }
  fi(t, n) {
    return Pe.or([() => Pe.resolve(this.Ai.containsKey(n)), () => this.persistence.getTargetCache().containsKey(t, n), () => this.persistence.Ei(t, n)]);
  }
}
class aS {
  constructor(t, n) {
    this.persistence = t, this.gi = new Vf((r) => RSe(r.path), (r, i) => r.isEqual(i)), this.garbageCollector = Bwe(this, n);
  }
  static Vi(t, n) {
    return new aS(t, n);
  }
  // No-ops, present so memory persistence doesn't have to care which delegate
  // it has.
  Ii() {
  }
  di(t) {
    return Pe.resolve();
  }
  forEachTarget(t, n) {
    return this.persistence.getTargetCache().forEachTarget(t, n);
  }
  mr(t) {
    const n = this.yr(t);
    return this.persistence.getTargetCache().getTargetCount(t).next((r) => n.next((i) => r + i));
  }
  yr(t) {
    let n = 0;
    return this.gr(t, (r) => {
      n++;
    }).next(() => n);
  }
  gr(t, n) {
    return Pe.forEach(this.gi, (r, i) => this.Sr(t, r, i).next((o) => o ? Pe.resolve() : n(i)));
  }
  removeTargets(t, n, r) {
    return this.persistence.getTargetCache().removeTargets(t, n, r);
  }
  removeOrphanedDocuments(t, n) {
    let r = 0;
    const i = this.persistence.getRemoteDocumentCache(), o = i.newChangeBuffer();
    return i.ri(t, (a) => this.Sr(t, a, n).next((s) => {
      s || (r++, o.removeEntry(a, Kt.min()));
    })).next(() => o.apply(t)).next(() => r);
  }
  markPotentiallyOrphaned(t, n) {
    return this.gi.set(n, t.currentSequenceNumber), Pe.resolve();
  }
  removeTarget(t, n) {
    const r = n.withSequenceNumber(t.currentSequenceNumber);
    return this.persistence.getTargetCache().updateTargetData(t, r);
  }
  addReference(t, n, r) {
    return this.gi.set(r, t.currentSequenceNumber), Pe.resolve();
  }
  removeReference(t, n, r) {
    return this.gi.set(r, t.currentSequenceNumber), Pe.resolve();
  }
  updateLimboDocument(t, n) {
    return this.gi.set(n, t.currentSequenceNumber), Pe.resolve();
  }
  Pi(t) {
    let n = t.key.toString().length;
    return t.isFoundDocument() && (n += r_(t.data.value)), n;
  }
  Sr(t, n, r) {
    return Pe.or([() => this.persistence.Ei(t, n), () => this.persistence.getTargetCache().containsKey(t, n), () => {
      const i = this.gi.get(n);
      return Pe.resolve(i !== void 0 && i > r);
    }]);
  }
  getCacheSize(t) {
    return this.persistence.getRemoteDocumentCache().getSize(t);
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class JO {
  constructor(t, n, r, i) {
    this.targetId = t, this.fromCache = n, this.Is = r, this.ds = i;
  }
  static Es(t, n) {
    let r = Sn(), i = Sn();
    for (const o of n.docChanges)
      switch (o.type) {
        case 0:
          r = r.add(o.doc.key);
          break;
        case 1:
          i = i.add(o.doc.key);
      }
    return new JO(t, n.fromCache, r, i);
  }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Zwe {
  constructor() {
    this._documentReadCount = 0;
  }
  get documentReadCount() {
    return this._documentReadCount;
  }
  incrementDocumentReadCount(t) {
    this._documentReadCount += t;
  }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class exe {
  constructor() {
    this.As = !1, this.Rs = !1, /**
     * SDK only decides whether it should create index when collection size is
     * larger than this.
     */
    this.Vs = 100, this.fs = /**
    * This cost represents the evaluation result of
    * (([index, docKey] + [docKey, docContent]) per document in the result set)
    * / ([docKey, docContent] per documents in full collection scan) coming from
    * experiment [enter PR experiment URL here].
    */
    function() {
      return Y0e() ? 8 : $Se(ho()) > 0 ? 6 : 4;
    }();
  }
  /** Sets the document view to query against. */
  initialize(t, n) {
    this.gs = t, this.indexManager = n, this.As = !0;
  }
  /** Returns all local documents matching the specified query. */
  getDocumentsMatchingQuery(t, n, r, i) {
    const o = {
      result: null
    };
    return this.ps(t, n).next((a) => {
      o.result = a;
    }).next(() => {
      if (!o.result)
        return this.ys(t, n, i, r).next((a) => {
          o.result = a;
        });
    }).next(() => {
      if (o.result)
        return;
      const a = new Zwe();
      return this.ws(t, n, a).next((s) => {
        if (o.result = s, this.Rs)
          return this.Ss(t, n, a, s.size);
      });
    }).next(() => o.result);
  }
  Ss(t, n, r, i) {
    return r.documentReadCount < this.Vs ? (jh() <= _n.DEBUG && bt("QueryEngine", "SDK will not create cache indexes for query:", Lh(n), "since it only creates cache indexes for collection contains", "more than or equal to", this.Vs, "documents"), Pe.resolve()) : (jh() <= _n.DEBUG && bt("QueryEngine", "Query:", Lh(n), "scans", r.documentReadCount, "local documents and returns", i, "documents as results."), r.documentReadCount > this.fs * i ? (jh() <= _n.DEBUG && bt("QueryEngine", "The SDK decides to create cache indexes for query:", Lh(n), "as using cache indexes may help improve performance."), this.indexManager.createTargetIndexes(t, uc(n))) : Pe.resolve());
  }
  /**
   * Performs an indexed query that evaluates the query based on a collection's
   * persisted index values. Returns `null` if an index is not available.
   */
  ps(t, n) {
    if (LD(n))
      return Pe.resolve(null);
    let r = uc(n);
    return this.indexManager.getIndexType(t, r).next((i) => i === 0 ? null : (n.limit !== null && i === 1 && // We cannot apply a limit for targets that are served using a partial
    // index. If a partial index will be used to serve the target, the
    // query may return a superset of documents that match the target
    // (e.g. if the index doesn't include all the target's filters), or
    // may return the correct set of documents in the wrong order (e.g. if
    // the index doesn't include a segment for one of the orderBys).
    // Therefore, a limit should not be applied in such cases.
    (n = nS(
      n,
      null,
      "F"
      /* LimitType.First */
    ), r = uc(n)), this.indexManager.getDocumentsMatchingTarget(t, r).next((o) => {
      const a = Sn(...o);
      return this.gs.getDocuments(t, a).next((s) => this.indexManager.getMinOffset(t, r).next((c) => {
        const l = this.bs(n, s);
        return this.Ds(n, l, a, c.readTime) ? this.ps(t, nS(
          n,
          null,
          "F"
          /* LimitType.First */
        )) : this.vs(t, l, n, c);
      }));
    })));
  }
  /**
   * Performs a query based on the target's persisted query mapping. Returns
   * `null` if the mapping is not available or cannot be used.
   */
  ys(t, n, r, i) {
    return LD(n) || i.isEqual(Kt.min()) ? Pe.resolve(null) : this.gs.getDocuments(t, r).next((o) => {
      const a = this.bs(n, o);
      return this.Ds(n, a, r, i) ? Pe.resolve(null) : (jh() <= _n.DEBUG && bt("QueryEngine", "Re-using previous result from %s to execute query: %s", i.toString(), Lh(n)), this.vs(t, a, n, xSe(i, sv)).next((s) => s));
    });
  }
  /** Applies the query filter and sorting to the provided documents.  */
  bs(t, n) {
    let r = new wi(Gq(t));
    return n.forEach((i, o) => {
      Kx(t, o) && (r = r.add(o));
    }), r;
  }
  /**
   * Determines if a limit query needs to be refilled from cache, making it
   * ineligible for index-free execution.
   *
   * @param query - The query.
   * @param sortedPreviousResults - The documents that matched the query when it
   * was last synchronized, sorted by the query's comparator.
   * @param remoteKeys - The document keys that matched the query at the last
   * snapshot.
   * @param limboFreeSnapshotVersion - The version of the snapshot when the
   * query was last synchronized.
   */
  Ds(t, n, r, i) {
    if (t.limit === null)
      return !1;
    if (r.size !== n.size)
      return !0;
    const o = t.limitType === "F" ? n.last() : n.first();
    return !!o && (o.hasPendingWrites || o.version.compareTo(i) > 0);
  }
  ws(t, n, r) {
    return jh() <= _n.DEBUG && bt("QueryEngine", "Using full collection scan to execute query:", Lh(n)), this.gs.getDocumentsMatchingQuery(t, n, $u.min(), r);
  }
  /**
   * Combines the results from an indexed execution with the remaining documents
   * that have not yet been indexed.
   */
  vs(t, n, r, i) {
    return this.gs.getDocumentsMatchingQuery(t, r, i).next((o) => (
      // Merge with existing results
      (n.forEach((a) => {
        o = o.insert(a.key, a);
      }), o)
    ));
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const ZO = "LocalStore", txe = 3e8;
class nxe {
  constructor(t, n, r, i) {
    this.persistence = t, this.Cs = n, this.serializer = i, /**
     * Maps a targetID to data about its target.
     *
     * PORTING NOTE: We are using an immutable data structure on Web to make re-runs
     * of `applyRemoteEvent()` idempotent.
     */
    this.Fs = new Fr(gn), /** Maps a target to its targetID. */
    // TODO(wuandy): Evaluate if TargetId can be part of Target.
    this.Ms = new Vf((o) => HO(o), UO), /**
     * A per collection group index of the last read time processed by
     * `getNewDocumentChanges()`.
     *
     * PORTING NOTE: This is only used for multi-tab synchronization.
     */
    this.xs = /* @__PURE__ */ new Map(), this.Os = t.getRemoteDocumentCache(), this.hi = t.getTargetCache(), this.Ti = t.getBundleCache(), this.Ns(r);
  }
  Ns(t) {
    this.documentOverlayCache = this.persistence.getDocumentOverlayCache(t), this.indexManager = this.persistence.getIndexManager(t), this.mutationQueue = this.persistence.getMutationQueue(t, this.indexManager), this.localDocuments = new Uwe(this.Os, this.mutationQueue, this.documentOverlayCache, this.indexManager), this.Os.setIndexManager(this.indexManager), this.Cs.initialize(this.localDocuments, this.indexManager);
  }
  collectGarbage(t) {
    return this.persistence.runTransaction("Collect garbage", "readwrite-primary", (n) => t.collect(n, this.Fs));
  }
}
function rxe(e, t, n, r) {
  return new nxe(e, t, n, r);
}
async function bG(e, t) {
  const n = Gt(e);
  return await n.persistence.runTransaction("Handle user change", "readonly", (r) => {
    let i;
    return n.mutationQueue.getAllMutationBatches(r).next((o) => (i = o, n.Ns(t), n.mutationQueue.getAllMutationBatches(r))).next((o) => {
      const a = [], s = [];
      let c = Sn();
      for (const l of i) {
        a.push(l.batchId);
        for (const u of l.mutations)
          c = c.add(u.key);
      }
      for (const l of o) {
        s.push(l.batchId);
        for (const u of l.mutations)
          c = c.add(u.key);
      }
      return n.localDocuments.getDocuments(r, c).next((l) => ({
        Bs: l,
        removedBatchIds: a,
        addedBatchIds: s
      }));
    });
  });
}
function ixe(e, t) {
  const n = Gt(e);
  return n.persistence.runTransaction("Acknowledge batch", "readwrite-primary", (r) => {
    const i = t.batch.keys(), o = n.Os.newChangeBuffer({
      trackRemovals: !0
    });
    return function(s, c, l, u) {
      const d = l.batch, f = d.keys();
      let h = Pe.resolve();
      return f.forEach((p) => {
        h = h.next(() => u.getEntry(c, p)).next((g) => {
          const m = l.docVersions.get(p);
          Fn(m !== null, 48541), g.version.compareTo(m) < 0 && (d.applyToRemoteDocument(g, l), g.isValidDocument() && // We use the commitVersion as the readTime rather than the
          // document's updateTime since the updateTime is not advanced
          // for updates that do not modify the underlying document.
          (g.setReadTime(l.commitVersion), u.addEntry(g)));
        });
      }), h.next(() => s.mutationQueue.removeMutationBatch(c, d));
    }(n, r, t, o).next(() => o.apply(r)).next(() => n.mutationQueue.performConsistencyCheck(r)).next(() => n.documentOverlayCache.removeOverlaysForBatchId(r, i, t.batch.batchId)).next(() => n.localDocuments.recalculateAndSaveOverlaysForDocumentKeys(r, function(s) {
      let c = Sn();
      for (let l = 0; l < s.mutationResults.length; ++l)
        s.mutationResults[l].transformResults.length > 0 && (c = c.add(s.batch.mutations[l].key));
      return c;
    }(t))).next(() => n.localDocuments.getDocuments(r, i));
  });
}
function _G(e) {
  const t = Gt(e);
  return t.persistence.runTransaction("Get last remote snapshot version", "readonly", (n) => t.hi.getLastRemoteSnapshotVersion(n));
}
function oxe(e, t) {
  const n = Gt(e), r = t.snapshotVersion;
  let i = n.Fs;
  return n.persistence.runTransaction("Apply remote event", "readwrite-primary", (o) => {
    const a = n.Os.newChangeBuffer({
      trackRemovals: !0
    });
    i = n.Fs;
    const s = [];
    t.targetChanges.forEach((u, d) => {
      const f = i.get(d);
      if (!f)
        return;
      s.push(n.hi.removeMatchingKeys(o, u.removedDocuments, d).next(() => n.hi.addMatchingKeys(o, u.addedDocuments, d)));
      let h = f.withSequenceNumber(o.currentSequenceNumber);
      t.targetMismatches.get(d) !== null ? h = h.withResumeToken(Wi.EMPTY_BYTE_STRING, Kt.min()).withLastLimboFreeSnapshotVersion(Kt.min()) : u.resumeToken.approximateByteSize() > 0 && (h = h.withResumeToken(u.resumeToken, r)), i = i.insert(d, h), // Update the target data if there are target changes (or if
      // sufficient time has passed since the last update).
      /**
      * Returns true if the newTargetData should be persisted during an update of
      * an active target. TargetData should always be persisted when a target is
      * being released and should not call this function.
      *
      * While the target is active, TargetData updates can be omitted when nothing
      * about the target has changed except metadata like the resume token or
      * snapshot version. Occasionally it's worth the extra write to prevent these
      * values from getting too stale after a crash, but this doesn't have to be
      * too frequent.
      */
      function(g, m, v) {
        return g.resumeToken.approximateByteSize() === 0 || m.snapshotVersion.toMicroseconds() - g.snapshotVersion.toMicroseconds() >= txe ? !0 : v.addedDocuments.size + v.modifiedDocuments.size + v.removedDocuments.size > 0;
      }(f, h, u) && s.push(n.hi.updateTargetData(o, h));
    });
    let c = gl(), l = Sn();
    if (t.documentUpdates.forEach((u) => {
      t.resolvedLimboDocuments.has(u) && s.push(n.persistence.referenceDelegate.updateLimboDocument(o, u));
    }), // Each loop iteration only affects its "own" doc, so it's safe to get all
    // the remote documents in advance in a single call.
    s.push(axe(o, a, t.documentUpdates).next((u) => {
      c = u.Ls, l = u.ks;
    })), !r.isEqual(Kt.min())) {
      const u = n.hi.getLastRemoteSnapshotVersion(o).next((d) => n.hi.setTargetsMetadata(o, o.currentSequenceNumber, r));
      s.push(u);
    }
    return Pe.waitFor(s).next(() => a.apply(o)).next(() => n.localDocuments.getLocalViewOfDocuments(o, c, l)).next(() => c);
  }).then((o) => (n.Fs = i, o));
}
function axe(e, t, n) {
  let r = Sn(), i = Sn();
  return n.forEach((o) => r = r.add(o)), t.getEntries(e, r).next((o) => {
    let a = gl();
    return n.forEach((s, c) => {
      const l = o.get(s);
      c.isFoundDocument() !== l.isFoundDocument() && (i = i.add(s)), // Note: The order of the steps below is important, since we want
      // to ensure that rejected limbo resolutions (which fabricate
      // NoDocuments with SnapshotVersion.min()) never add documents to
      // cache.
      c.isNoDocument() && c.version.isEqual(Kt.min()) ? (
        // NoDocuments with SnapshotVersion.min() are used in manufactured
        // events. We remove these documents from cache since we lost
        // access.
        (t.removeEntry(s, c.readTime), a = a.insert(s, c))
      ) : !l.isValidDocument() || c.version.compareTo(l.version) > 0 || c.version.compareTo(l.version) === 0 && l.hasPendingWrites ? (t.addEntry(c), a = a.insert(s, c)) : bt(ZO, "Ignoring outdated watch update for ", s, ". Current version:", l.version, " Watch version:", c.version);
    }), {
      Ls: a,
      ks: i
    };
  });
}
function sxe(e, t) {
  const n = Gt(e);
  return n.persistence.runTransaction("Get next mutation batch", "readonly", (r) => (t === void 0 && (t = zx), n.mutationQueue.getNextMutationBatchAfterBatchId(r, t)));
}
function cxe(e, t) {
  const n = Gt(e);
  return n.persistence.runTransaction("Allocate target", "readwrite", (r) => {
    let i;
    return n.hi.getTargetData(r, t).next((o) => o ? (
      // This target has been listened to previously, so reuse the
      // previous targetID.
      // TODO(mcg): freshen last accessed date?
      (i = o, Pe.resolve(i))
    ) : n.hi.allocateTargetId(r).next((a) => (i = new eu(t, a, "TargetPurposeListen", r.currentSequenceNumber), n.hi.addTargetData(r, i).next(() => i))));
  }).then((r) => {
    const i = n.Fs.get(r.targetId);
    return (i === null || r.snapshotVersion.compareTo(i.snapshotVersion) > 0) && (n.Fs = n.Fs.insert(r.targetId, r), n.Ms.set(t, r.targetId)), r;
  });
}
async function G$(e, t, n) {
  const r = Gt(e), i = r.Fs.get(t), o = n ? "readwrite" : "readwrite-primary";
  try {
    n || await r.persistence.runTransaction("Release target", o, (a) => r.persistence.referenceDelegate.removeTarget(a, i));
  } catch (a) {
    if (!jp(a))
      throw a;
    bt(ZO, `Failed to update sequence numbers for target ${t}: ${a}`);
  }
  r.Fs = r.Fs.remove(t), r.Ms.delete(i.target);
}
function QD(e, t, n) {
  const r = Gt(e);
  let i = Kt.min(), o = Sn();
  return r.persistence.runTransaction(
    "Execute query",
    "readwrite",
    // Use readwrite instead of readonly so indexes can be created
    // Use readwrite instead of readonly so indexes can be created
    (a) => function(c, l, u) {
      const d = Gt(c), f = d.Ms.get(u);
      return f !== void 0 ? Pe.resolve(d.Fs.get(f)) : d.hi.getTargetData(l, u);
    }(r, a, uc(t)).next((s) => {
      if (s)
        return i = s.lastLimboFreeSnapshotVersion, r.hi.getMatchingKeysForTargetId(a, s.targetId).next((c) => {
          o = c;
        });
    }).next(() => r.Cs.getDocumentsMatchingQuery(a, t, n ? i : Kt.min(), n ? o : Sn())).next((s) => (lxe(r, YSe(t), s), {
      documents: s,
      qs: o
    }))
  );
}
function lxe(e, t, n) {
  let r = e.xs.get(t) || Kt.min();
  n.forEach((i, o) => {
    o.readTime.compareTo(r) > 0 && (r = o.readTime);
  }), e.xs.set(t, r);
}
class JD {
  constructor() {
    this.activeTargetIds = twe();
  }
  Gs(t) {
    this.activeTargetIds = this.activeTargetIds.add(t);
  }
  zs(t) {
    this.activeTargetIds = this.activeTargetIds.delete(t);
  }
  /**
   * Converts this entry into a JSON-encoded format we can use for WebStorage.
   * Does not encode `clientId` as it is part of the key in WebStorage.
   */
  Ws() {
    const t = {
      activeTargetIds: this.activeTargetIds.toArray(),
      updateTimeMs: Date.now()
    };
    return JSON.stringify(t);
  }
}
class uxe {
  constructor() {
    this.Fo = new JD(), this.Mo = {}, this.onlineStateHandler = null, this.sequenceNumberHandler = null;
  }
  addPendingMutation(t) {
  }
  updateMutationState(t, n, r) {
  }
  addLocalQueryTarget(t, n = !0) {
    return n && this.Fo.Gs(t), this.Mo[t] || "not-current";
  }
  updateQueryState(t, n, r) {
    this.Mo[t] = n;
  }
  removeLocalQueryTarget(t) {
    this.Fo.zs(t);
  }
  isLocalQueryTarget(t) {
    return this.Fo.activeTargetIds.has(t);
  }
  clearQueryState(t) {
    delete this.Mo[t];
  }
  getAllActiveQueryTargets() {
    return this.Fo.activeTargetIds;
  }
  isActiveQueryTarget(t) {
    return this.Fo.activeTargetIds.has(t);
  }
  start() {
    return this.Fo = new JD(), Promise.resolve();
  }
  handleUserChange(t, n, r) {
  }
  setOnlineState(t) {
  }
  shutdown() {
  }
  writeSequenceNumber(t) {
  }
  notifyBundleLoaded(t) {
  }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class dxe {
  xo(t) {
  }
  shutdown() {
  }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const ZD = "ConnectivityMonitor";
class e8 {
  constructor() {
    this.Oo = () => this.No(), this.Bo = () => this.Lo(), this.ko = [], this.qo();
  }
  xo(t) {
    this.ko.push(t);
  }
  shutdown() {
    window.removeEventListener("online", this.Oo), window.removeEventListener("offline", this.Bo);
  }
  qo() {
    window.addEventListener("online", this.Oo), window.addEventListener("offline", this.Bo);
  }
  No() {
    bt(ZD, "Network connectivity changed: AVAILABLE");
    for (const t of this.ko)
      t(
        0
        /* NetworkStatus.AVAILABLE */
      );
  }
  Lo() {
    bt(ZD, "Network connectivity changed: UNAVAILABLE");
    for (const t of this.ko)
      t(
        1
        /* NetworkStatus.UNAVAILABLE */
      );
  }
  // TODO(chenbrian): Consider passing in window either into this component or
  // here for testing via FakeWindow.
  /** Checks that all used attributes of window are available. */
  static C() {
    return typeof window < "u" && window.addEventListener !== void 0 && window.removeEventListener !== void 0;
  }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
let Vb = null;
function K$() {
  return Vb === null ? Vb = function() {
    return 268435456 + Math.round(2147483648 * Math.random());
  }() : Vb++, "0x" + Vb.toString(16);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const F5 = "RestConnection", fxe = {
  BatchGetDocuments: "batchGet",
  Commit: "commit",
  RunQuery: "runQuery",
  RunAggregationQuery: "runAggregationQuery"
};
class hxe {
  get Qo() {
    return !1;
  }
  constructor(t) {
    this.databaseInfo = t, this.databaseId = t.databaseId;
    const n = t.ssl ? "https" : "http", r = encodeURIComponent(this.databaseId.projectId), i = encodeURIComponent(this.databaseId.database);
    this.$o = n + "://" + t.host, this.Uo = `projects/${r}/databases/${i}`, this.Ko = this.databaseId.database === lv ? `project_id=${r}` : `project_id=${r}&database_id=${i}`;
  }
  Wo(t, n, r, i, o) {
    const a = K$(), s = this.Go(t, n.toUriEncodedString());
    bt(F5, `Sending RPC '${t}' ${a}:`, s, r);
    const c = {
      "google-cloud-resource-prefix": this.Uo,
      "x-goog-request-params": this.Ko
    };
    this.zo(c, i, o);
    const { host: l } = new URL(s), u = Gu(l);
    return this.jo(t, s, c, r, u).then((d) => (bt(F5, `Received RPC '${t}' ${a}: `, d), d), (d) => {
      throw Iu(F5, `RPC '${t}' ${a} failed with error: `, d, "url: ", s, "request:", r), d;
    });
  }
  Jo(t, n, r, i, o, a) {
    return this.Wo(t, n, r, i, o);
  }
  /**
   * Modifies the headers for a request, adding any authorization token if
   * present and any additional headers for the request.
   */
  zo(t, n, r) {
    t["X-Goog-Api-Client"] = // SDK_VERSION is updated to different value at runtime depending on the entry point,
    // so we need to get its value when we need it in a function.
    function() {
      return "gl-js/ fire/" + Np;
    }(), // Content-Type: text/plain will avoid preflight requests which might
    // mess with CORS and redirects by proxies. If we add custom headers
    // we will need to change this code to potentially use the $httpOverwrite
    // parameter supported by ESF to avoid triggering preflight requests.
    t["Content-Type"] = "text/plain", this.databaseInfo.appId && (t["X-Firebase-GMPID"] = this.databaseInfo.appId), n && n.headers.forEach((i, o) => t[o] = i), r && r.headers.forEach((i, o) => t[o] = i);
  }
  Go(t, n) {
    const r = fxe[t];
    return `${this.$o}/v1/${n}:${r}`;
  }
  /**
   * Closes and cleans up any resources associated with the connection. This
   * implementation is a no-op because there are no resources associated
   * with the RestConnection that need to be cleaned up.
   */
  terminate() {
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class gxe {
  constructor(t) {
    this.Ho = t.Ho, this.Yo = t.Yo;
  }
  Zo(t) {
    this.Xo = t;
  }
  e_(t) {
    this.t_ = t;
  }
  n_(t) {
    this.r_ = t;
  }
  onMessage(t) {
    this.i_ = t;
  }
  close() {
    this.Yo();
  }
  send(t) {
    this.Ho(t);
  }
  s_() {
    this.Xo();
  }
  o_() {
    this.t_();
  }
  __(t) {
    this.r_(t);
  }
  a_(t) {
    this.i_(t);
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const eo = "WebChannelConnection";
class pxe extends hxe {
  constructor(t) {
    super(t), /** A collection of open WebChannel instances */
    this.u_ = [], this.forceLongPolling = t.forceLongPolling, this.autoDetectLongPolling = t.autoDetectLongPolling, this.useFetchStreams = t.useFetchStreams, this.longPollingOptions = t.longPollingOptions;
  }
  jo(t, n, r, i, o) {
    const a = K$();
    return new Promise((s, c) => {
      const l = new vq();
      l.setWithCredentials(!0), l.listenOnce(yq.COMPLETE, () => {
        try {
          switch (l.getLastErrorCode()) {
            case n_.NO_ERROR:
              const d = l.getResponseJson();
              bt(eo, `XHR for RPC '${t}' ${a} received:`, JSON.stringify(d)), s(d);
              break;
            case n_.TIMEOUT:
              bt(eo, `RPC '${t}' ${a} timed out`), c(new Je(we.DEADLINE_EXCEEDED, "Request time out"));
              break;
            case n_.HTTP_ERROR:
              const f = l.getStatus();
              if (bt(eo, `RPC '${t}' ${a} failed with status:`, f, "response text:", l.getResponseText()), f > 0) {
                let h = l.getResponseJson();
                Array.isArray(h) && (h = h[0]);
                const p = h == null ? void 0 : h.error;
                if (p && p.status && p.message) {
                  const g = function(v) {
                    const y = v.toLowerCase().replace(/_/g, "-");
                    return Object.values(we).indexOf(y) >= 0 ? y : we.UNKNOWN;
                  }(p.status);
                  c(new Je(g, p.message));
                } else
                  c(new Je(we.UNKNOWN, "Server responded with status " + l.getStatus()));
              } else
                c(new Je(we.UNAVAILABLE, "Connection failed."));
              break;
            default:
              qt(9055, {
                c_: t,
                streamId: a,
                l_: l.getLastErrorCode(),
                h_: l.getLastError()
              });
          }
        } finally {
          bt(eo, `RPC '${t}' ${a} completed.`);
        }
      });
      const u = JSON.stringify(i);
      bt(eo, `RPC '${t}' ${a} sending request:`, i), l.send(n, "POST", u, r, 15);
    });
  }
  P_(t, n, r) {
    const i = K$(), o = [this.$o, "/", "google.firestore.v1.Firestore", "/", t, "/channel"], a = Sq(), s = _q(), c = {
      // Required for backend stickiness, routing behavior is based on this
      // parameter.
      httpSessionIdParam: "gsessionid",
      initMessageHeaders: {},
      messageUrlParams: {
        // This param is used to improve routing and project isolation by the
        // backend and must be included in every request.
        database: `projects/${this.databaseId.projectId}/databases/${this.databaseId.database}`
      },
      sendRawJson: !0,
      supportsCrossDomainXhr: !0,
      internalChannelParams: {
        // Override the default timeout (randomized between 10-20 seconds) since
        // a large write batch on a slow internet connection may take a long
        // time to send to the backend. Rather than have WebChannel impose a
        // tight timeout which could lead to infinite timeouts and retries, we
        // set it very large (5-10 minutes) and rely on the browser's builtin
        // timeouts to kick in if the request isn't working.
        forwardChannelRequestTimeoutMs: 6e5
      },
      forceLongPolling: this.forceLongPolling,
      detectBufferingProxy: this.autoDetectLongPolling
    }, l = this.longPollingOptions.timeoutSeconds;
    l !== void 0 && (c.longPollingTimeout = Math.round(1e3 * l)), this.useFetchStreams && (c.useFetchStreams = !0), this.zo(c.initMessageHeaders, n, r), // Sending the custom headers we just added to request.initMessageHeaders
    // (Authorization, etc.) will trigger the browser to make a CORS preflight
    // request because the XHR will no longer meet the criteria for a "simple"
    // CORS request:
    // https://developer.mozilla.org/en-US/docs/Web/HTTP/CORS#Simple_requests
    // Therefore to avoid the CORS preflight request (an extra network
    // roundtrip), we use the encodeInitMessageHeaders option to specify that
    // the headers should instead be encoded in the request's POST payload,
    // which is recognized by the webchannel backend.
    c.encodeInitMessageHeaders = !0;
    const u = o.join("");
    bt(eo, `Creating RPC '${t}' stream ${i}: ${u}`, c);
    const d = a.createWebChannel(u, c);
    this.T_(d);
    let f = !1, h = !1;
    const p = new gxe({
      Ho: (m) => {
        h ? bt(eo, `Not sending because RPC '${t}' stream ${i} is closed:`, m) : (f || (bt(eo, `Opening RPC '${t}' stream ${i} transport.`), d.open(), f = !0), bt(eo, `RPC '${t}' stream ${i} sending:`, m), d.send(m));
      },
      Yo: () => d.close()
    }), g = (m, v, y) => {
      m.listen(v, (_) => {
        try {
          y(_);
        } catch (b) {
          setTimeout(() => {
            throw b;
          }, 0);
        }
      });
    };
    return g(d, o0.EventType.OPEN, () => {
      h || (bt(eo, `RPC '${t}' stream ${i} transport opened.`), p.s_());
    }), g(d, o0.EventType.CLOSE, () => {
      h || (h = !0, bt(eo, `RPC '${t}' stream ${i} transport closed`), p.__(), this.I_(d));
    }), g(d, o0.EventType.ERROR, (m) => {
      h || (h = !0, Iu(eo, `RPC '${t}' stream ${i} transport errored. Name:`, m.name, "Message:", m.message), p.__(new Je(we.UNAVAILABLE, "The operation could not be completed")));
    }), g(d, o0.EventType.MESSAGE, (m) => {
      var v;
      if (!h) {
        const y = m.data[0];
        Fn(!!y, 16349);
        const _ = y, b = (_ == null ? void 0 : _.error) || ((v = _[0]) === null || v === void 0 ? void 0 : v.error);
        if (b) {
          bt(eo, `RPC '${t}' stream ${i} received error:`, b);
          const w = b.status;
          let C = (
            /**
            * Maps an error Code from a GRPC status identifier like 'NOT_FOUND'.
            *
            * @returns The Code equivalent to the given status string or undefined if
            *     there is no match.
            */
            function(E) {
              const R = oi[E];
              if (R !== void 0)
                return oG(R);
            }(w)
          ), x = b.message;
          C === void 0 && (C = we.INTERNAL, x = "Unknown error status: " + w + " with message " + b.message), // Mark closed so no further events are propagated
          h = !0, p.__(new Je(C, x)), d.close();
        } else
          bt(eo, `RPC '${t}' stream ${i} received:`, y), p.a_(y);
      }
    }), g(s, bq.STAT_EVENT, (m) => {
      m.stat === D$.PROXY ? bt(eo, `RPC '${t}' stream ${i} detected buffering proxy`) : m.stat === D$.NOPROXY && bt(eo, `RPC '${t}' stream ${i} detected no buffering proxy`);
    }), setTimeout(() => {
      p.o_();
    }, 0), p;
  }
  /**
   * Closes and cleans up any resources associated with the connection.
   */
  terminate() {
    this.u_.forEach((t) => t.close()), this.u_ = [];
  }
  /**
   * Add a WebChannel instance to the collection of open instances.
   * @param webChannel
   */
  T_(t) {
    this.u_.push(t);
  }
  /**
   * Remove a WebChannel instance from the collection of open instances.
   * @param webChannel
   */
  I_(t) {
    this.u_ = this.u_.filter((n) => n === t);
  }
}
function V5() {
  return typeof document < "u" ? document : null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Jx(e) {
  return new _we(
    e,
    /* useProto3Json= */
    !0
  );
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class SG {
  constructor(t, n, r = 1e3, i = 1.5, o = 6e4) {
    this.Fi = t, this.timerId = n, this.d_ = r, this.E_ = i, this.A_ = o, this.R_ = 0, this.V_ = null, /** The last backoff attempt, as epoch milliseconds. */
    this.m_ = Date.now(), this.reset();
  }
  /**
   * Resets the backoff delay.
   *
   * The very next backoffAndWait() will have no delay. If it is called again
   * (i.e. due to an error), initialDelayMs (plus jitter) will be used, and
   * subsequent ones will increase according to the backoffFactor.
   */
  reset() {
    this.R_ = 0;
  }
  /**
   * Resets the backoff delay to the maximum delay (e.g. for use after a
   * RESOURCE_EXHAUSTED error).
   */
  f_() {
    this.R_ = this.A_;
  }
  /**
   * Returns a promise that resolves after currentDelayMs, and increases the
   * delay for any subsequent attempts. If there was a pending backoff operation
   * already, it will be canceled.
   */
  g_(t) {
    this.cancel();
    const n = Math.floor(this.R_ + this.p_()), r = Math.max(0, Date.now() - this.m_), i = Math.max(0, n - r);
    i > 0 && bt("ExponentialBackoff", `Backing off for ${i} ms (base delay: ${this.R_} ms, delay with jitter: ${n} ms, last attempt: ${r} ms ago)`), this.V_ = this.Fi.enqueueAfterDelay(this.timerId, i, () => (this.m_ = Date.now(), t())), // Apply backoff factor to determine next delay and ensure it is within
    // bounds.
    this.R_ *= this.E_, this.R_ < this.d_ && (this.R_ = this.d_), this.R_ > this.A_ && (this.R_ = this.A_);
  }
  y_() {
    this.V_ !== null && (this.V_.skipDelay(), this.V_ = null);
  }
  cancel() {
    this.V_ !== null && (this.V_.cancel(), this.V_ = null);
  }
  /** Returns a random value in the range [-currentBaseMs/2, currentBaseMs/2] */
  p_() {
    return (Math.random() - 0.5) * this.R_;
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const t8 = "PersistentStream";
class wG {
  constructor(t, n, r, i, o, a, s, c) {
    this.Fi = t, this.w_ = r, this.S_ = i, this.connection = o, this.authCredentialsProvider = a, this.appCheckCredentialsProvider = s, this.listener = c, this.state = 0, /**
     * A close count that's incremented every time the stream is closed; used by
     * getCloseGuardedDispatcher() to invalidate callbacks that happen after
     * close.
     */
    this.b_ = 0, this.D_ = null, this.v_ = null, this.stream = null, /**
     * Count of response messages received.
     */
    this.C_ = 0, this.F_ = new SG(t, n);
  }
  /**
   * Returns true if start() has been called and no error has occurred. True
   * indicates the stream is open or in the process of opening (which
   * encompasses respecting backoff, getting auth tokens, and starting the
   * actual RPC). Use isOpen() to determine if the stream is open and ready for
   * outbound requests.
   */
  M_() {
    return this.state === 1 || this.state === 5 || this.x_();
  }
  /**
   * Returns true if the underlying RPC is open (the onOpen() listener has been
   * called) and the stream is ready for outbound requests.
   */
  x_() {
    return this.state === 2 || this.state === 3;
  }
  /**
   * Starts the RPC. Only allowed if isStarted() returns false. The stream is
   * not immediately ready for use: onOpen() will be invoked when the RPC is
   * ready for outbound requests, at which point isOpen() will return true.
   *
   * When start returns, isStarted() will return true.
   */
  start() {
    this.C_ = 0, this.state !== 4 ? this.auth() : this.O_();
  }
  /**
   * Stops the RPC. This call is idempotent and allowed regardless of the
   * current isStarted() state.
   *
   * When stop returns, isStarted() and isOpen() will both return false.
   */
  async stop() {
    this.M_() && await this.close(
      0
      /* PersistentStreamState.Initial */
    );
  }
  /**
   * After an error the stream will usually back off on the next attempt to
   * start it. If the error warrants an immediate restart of the stream, the
   * sender can use this to indicate that the receiver should not back off.
   *
   * Each error will call the onClose() listener. That function can decide to
   * inhibit backoff if required.
   */
  N_() {
    this.state = 0, this.F_.reset();
  }
  /**
   * Marks this stream as idle. If no further actions are performed on the
   * stream for one minute, the stream will automatically close itself and
   * notify the stream's onClose() handler with Status.OK. The stream will then
   * be in a !isStarted() state, requiring the caller to start the stream again
   * before further use.
   *
   * Only streams that are in state 'Open' can be marked idle, as all other
   * states imply pending network operations.
   */
  B_() {
    this.x_() && this.D_ === null && (this.D_ = this.Fi.enqueueAfterDelay(this.w_, 6e4, () => this.L_()));
  }
  /** Sends a message to the underlying stream. */
  k_(t) {
    this.q_(), this.stream.send(t);
  }
  /** Called by the idle timer when the stream should close due to inactivity. */
  async L_() {
    if (this.x_())
      return this.close(
        0
        /* PersistentStreamState.Initial */
      );
  }
  /** Marks the stream as active again. */
  q_() {
    this.D_ && (this.D_.cancel(), this.D_ = null);
  }
  /** Cancels the health check delayed operation. */
  Q_() {
    this.v_ && (this.v_.cancel(), this.v_ = null);
  }
  /**
   * Closes the stream and cleans up as necessary:
   *
   * * closes the underlying GRPC stream;
   * * calls the onClose handler with the given 'error';
   * * sets internal stream state to 'finalState';
   * * adjusts the backoff timer based on the error
   *
   * A new stream can be opened by calling start().
   *
   * @param finalState - the intended state of the stream after closing.
   * @param error - the error the connection was closed with.
   */
  async close(t, n) {
    this.q_(), this.Q_(), this.F_.cancel(), // Invalidates any stream-related callbacks (e.g. from auth or the
    // underlying stream), guaranteeing they won't execute.
    this.b_++, t !== 4 ? (
      // If this is an intentional close ensure we don't delay our next connection attempt.
      this.F_.reset()
    ) : n && n.code === we.RESOURCE_EXHAUSTED ? (
      // Log the error. (Probably either 'quota exceeded' or 'max queue length reached'.)
      (hl(n.toString()), hl("Using maximum backoff delay to prevent overloading the backend."), this.F_.f_())
    ) : n && n.code === we.UNAUTHENTICATED && this.state !== 3 && // "unauthenticated" error means the token was rejected. This should rarely
    // happen since both Auth and AppCheck ensure a sufficient TTL when we
    // request a token. If a user manually resets their system clock this can
    // fail, however. In this case, we should get a Code.UNAUTHENTICATED error
    // before we received the first message and we need to invalidate the token
    // to ensure that we fetch a new token.
    (this.authCredentialsProvider.invalidateToken(), this.appCheckCredentialsProvider.invalidateToken()), // Clean up the underlying stream because we are no longer interested in events.
    this.stream !== null && (this.U_(), this.stream.close(), this.stream = null), // This state must be assigned before calling onClose() to allow the callback to
    // inhibit backoff or otherwise manipulate the state in its non-started state.
    this.state = t, // Notify the listener that the stream closed.
    await this.listener.n_(n);
  }
  /**
   * Can be overridden to perform additional cleanup before the stream is closed.
   * Calling super.tearDown() is not required.
   */
  U_() {
  }
  auth() {
    this.state = 1;
    const t = this.K_(this.b_), n = this.b_;
    Promise.all([this.authCredentialsProvider.getToken(), this.appCheckCredentialsProvider.getToken()]).then(([r, i]) => {
      this.b_ === n && // Normally we'd have to schedule the callback on the AsyncQueue.
      // However, the following calls are safe to be called outside the
      // AsyncQueue since they don't chain asynchronous calls
      this.W_(r, i);
    }, (r) => {
      t(() => {
        const i = new Je(we.UNKNOWN, "Fetching auth token failed: " + r.message);
        return this.G_(i);
      });
    });
  }
  W_(t, n) {
    const r = this.K_(this.b_);
    this.stream = this.z_(t, n), this.stream.Zo(() => {
      r(() => this.listener.Zo());
    }), this.stream.e_(() => {
      r(() => (this.state = 2, this.v_ = this.Fi.enqueueAfterDelay(this.S_, 1e4, () => (this.x_() && (this.state = 3), Promise.resolve())), this.listener.e_()));
    }), this.stream.n_((i) => {
      r(() => this.G_(i));
    }), this.stream.onMessage((i) => {
      r(() => ++this.C_ == 1 ? this.j_(i) : this.onNext(i));
    });
  }
  O_() {
    this.state = 5, this.F_.g_(async () => {
      this.state = 0, this.start();
    });
  }
  // Visible for tests
  G_(t) {
    return bt(t8, `close with error: ${t}`), this.stream = null, this.close(4, t);
  }
  /**
   * Returns a "dispatcher" function that dispatches operations onto the
   * AsyncQueue but only runs them if closeCount remains unchanged. This allows
   * us to turn auth / stream callbacks into no-ops if the stream is closed /
   * re-opened, etc.
   */
  K_(t) {
    return (n) => {
      this.Fi.enqueueAndForget(() => this.b_ === t ? n() : (bt(t8, "stream callback skipped by getCloseGuardedDispatcher."), Promise.resolve()));
    };
  }
}
class mxe extends wG {
  constructor(t, n, r, i, o, a) {
    super(t, "listen_stream_connection_backoff", "listen_stream_idle", "health_check_timeout", n, r, i, a), this.serializer = o;
  }
  z_(t, n) {
    return this.connection.P_("Listen", t, n);
  }
  j_(t) {
    return this.onNext(t);
  }
  onNext(t) {
    this.F_.reset();
    const n = xwe(this.serializer, t), r = function(o) {
      if (!("targetChange" in o))
        return Kt.min();
      const a = o.targetChange;
      return a.targetIds && a.targetIds.length ? Kt.min() : a.readTime ? fc(a.readTime) : Kt.min();
    }(t);
    return this.listener.J_(n, r);
  }
  /**
   * Registers interest in the results of the given target. If the target
   * includes a resumeToken it will be included in the request. Results that
   * affect the target will be streamed back as WatchChange messages that
   * reference the targetId.
   */
  H_(t) {
    const n = {};
    n.database = q$(this.serializer), n.addTarget = function(o, a) {
      let s;
      const c = a.target;
      if (s = B$(c) ? {
        documents: Twe(o, c)
      } : {
        query: fG(o, c).Vt
      }, s.targetId = a.targetId, a.resumeToken.approximateByteSize() > 0) {
        s.resumeToken = cG(o, a.resumeToken);
        const l = H$(o, a.expectedCount);
        l !== null && (s.expectedCount = l);
      } else if (a.snapshotVersion.compareTo(Kt.min()) > 0) {
        s.readTime = oS(o, a.snapshotVersion.toTimestamp());
        const l = H$(o, a.expectedCount);
        l !== null && (s.expectedCount = l);
      }
      return s;
    }(this.serializer, t);
    const r = Awe(this.serializer, t);
    r && (n.labels = r), this.k_(n);
  }
  /**
   * Unregisters interest in the results of the target associated with the
   * given targetId.
   */
  Y_(t) {
    const n = {};
    n.database = q$(this.serializer), n.removeTarget = t, this.k_(n);
  }
}
class vxe extends wG {
  constructor(t, n, r, i, o, a) {
    super(t, "write_stream_connection_backoff", "write_stream_idle", "health_check_timeout", n, r, i, a), this.serializer = o;
  }
  /**
   * Tracks whether or not a handshake has been successfully exchanged and
   * the stream is ready to accept mutations.
   */
  get Z_() {
    return this.C_ > 0;
  }
  // Override of PersistentStream.start
  start() {
    this.lastStreamToken = void 0, super.start();
  }
  U_() {
    this.Z_ && this.X_([]);
  }
  z_(t, n) {
    return this.connection.P_("Write", t, n);
  }
  j_(t) {
    return Fn(!!t.streamToken, 31322), this.lastStreamToken = t.streamToken, // The first response is always the handshake response
    Fn(!t.writeResults || t.writeResults.length === 0, 55816), this.listener.ea();
  }
  onNext(t) {
    Fn(!!t.streamToken, 12678), this.lastStreamToken = t.streamToken, // A successful first write response means the stream is healthy,
    // Note, that we could consider a successful handshake healthy, however,
    // the write itself might be causing an error we want to back off from.
    this.F_.reset();
    const n = Cwe(t.writeResults, t.commitTime), r = fc(t.commitTime);
    return this.listener.ta(r, n);
  }
  /**
   * Sends an initial streamToken to the server, performing the handshake
   * required to make the StreamingWrite RPC work. Subsequent
   * calls should wait until onHandshakeComplete was called.
   */
  na() {
    const t = {};
    t.database = q$(this.serializer), this.k_(t);
  }
  /** Sends a group of mutations to the Firestore backend to apply. */
  X_(t) {
    const n = {
      streamToken: this.lastStreamToken,
      writes: t.map((r) => Ewe(this.serializer, r))
    };
    this.k_(n);
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class yxe {
}
class bxe extends yxe {
  constructor(t, n, r, i) {
    super(), this.authCredentials = t, this.appCheckCredentials = n, this.connection = r, this.serializer = i, this.ra = !1;
  }
  ia() {
    if (this.ra)
      throw new Je(we.FAILED_PRECONDITION, "The client has already been terminated.");
  }
  /** Invokes the provided RPC with auth and AppCheck tokens. */
  Wo(t, n, r, i) {
    return this.ia(), Promise.all([this.authCredentials.getToken(), this.appCheckCredentials.getToken()]).then(([o, a]) => this.connection.Wo(t, U$(n, r), i, o, a)).catch((o) => {
      throw o.name === "FirebaseError" ? (o.code === we.UNAUTHENTICATED && (this.authCredentials.invalidateToken(), this.appCheckCredentials.invalidateToken()), o) : new Je(we.UNKNOWN, o.toString());
    });
  }
  /** Invokes the provided RPC with streamed results with auth and AppCheck tokens. */
  Jo(t, n, r, i, o) {
    return this.ia(), Promise.all([this.authCredentials.getToken(), this.appCheckCredentials.getToken()]).then(([a, s]) => this.connection.Jo(t, U$(n, r), i, a, s, o)).catch((a) => {
      throw a.name === "FirebaseError" ? (a.code === we.UNAUTHENTICATED && (this.authCredentials.invalidateToken(), this.appCheckCredentials.invalidateToken()), a) : new Je(we.UNKNOWN, a.toString());
    });
  }
  terminate() {
    this.ra = !0, this.connection.terminate();
  }
}
class _xe {
  constructor(t, n) {
    this.asyncQueue = t, this.onlineStateHandler = n, /** The current OnlineState. */
    this.state = "Unknown", /**
     * A count of consecutive failures to open the stream. If it reaches the
     * maximum defined by MAX_WATCH_STREAM_FAILURES, we'll set the OnlineState to
     * Offline.
     */
    this.sa = 0, /**
     * A timer that elapses after ONLINE_STATE_TIMEOUT_MS, at which point we
     * transition from OnlineState.Unknown to OnlineState.Offline without waiting
     * for the stream to actually fail (MAX_WATCH_STREAM_FAILURES times).
     */
    this.oa = null, /**
     * Whether the client should log a warning message if it fails to connect to
     * the backend (initially true, cleared after a successful stream, or if we've
     * logged the message already).
     */
    this._a = !0;
  }
  /**
   * Called by RemoteStore when a watch stream is started (including on each
   * backoff attempt).
   *
   * If this is the first attempt, it sets the OnlineState to Unknown and starts
   * the onlineStateTimer.
   */
  aa() {
    this.sa === 0 && (this.ua(
      "Unknown"
      /* OnlineState.Unknown */
    ), this.oa = this.asyncQueue.enqueueAfterDelay("online_state_timeout", 1e4, () => (this.oa = null, this.ca("Backend didn't respond within 10 seconds."), this.ua(
      "Offline"
      /* OnlineState.Offline */
    ), Promise.resolve())));
  }
  /**
   * Updates our OnlineState as appropriate after the watch stream reports a
   * failure. The first failure moves us to the 'Unknown' state. We then may
   * allow multiple failures (based on MAX_WATCH_STREAM_FAILURES) before we
   * actually transition to the 'Offline' state.
   */
  la(t) {
    this.state === "Online" ? this.ua(
      "Unknown"
      /* OnlineState.Unknown */
    ) : (this.sa++, this.sa >= 1 && (this.ha(), this.ca(`Connection failed 1 times. Most recent error: ${t.toString()}`), this.ua(
      "Offline"
      /* OnlineState.Offline */
    )));
  }
  /**
   * Explicitly sets the OnlineState to the specified state.
   *
   * Note that this resets our timers / failure counters, etc. used by our
   * Offline heuristics, so must not be used in place of
   * handleWatchStreamStart() and handleWatchStreamFailure().
   */
  set(t) {
    this.ha(), this.sa = 0, t === "Online" && // We've connected to watch at least once. Don't warn the developer
    // about being offline going forward.
    (this._a = !1), this.ua(t);
  }
  ua(t) {
    t !== this.state && (this.state = t, this.onlineStateHandler(t));
  }
  ca(t) {
    const n = `Could not reach Cloud Firestore backend. ${t}
This typically indicates that your device does not have a healthy Internet connection at the moment. The client will operate in offline mode until it is able to successfully connect to the backend.`;
    this._a ? (hl(n), this._a = !1) : bt("OnlineStateTracker", n);
  }
  ha() {
    this.oa !== null && (this.oa.cancel(), this.oa = null);
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const gf = "RemoteStore";
class Sxe {
  constructor(t, n, r, i, o) {
    this.localStore = t, this.datastore = n, this.asyncQueue = r, this.remoteSyncer = {}, /**
     * A list of up to MAX_PENDING_WRITES writes that we have fetched from the
     * LocalStore via fillWritePipeline() and have or will send to the write
     * stream.
     *
     * Whenever writePipeline.length > 0 the RemoteStore will attempt to start or
     * restart the write stream. When the stream is established the writes in the
     * pipeline will be sent in order.
     *
     * Writes remain in writePipeline until they are acknowledged by the backend
     * and thus will automatically be re-sent if the stream is interrupted /
     * restarted before they're acknowledged.
     *
     * Write responses from the backend are linked to their originating request
     * purely based on order, and so we can just shift() writes from the front of
     * the writePipeline as we receive responses.
     */
    this.Pa = [], /**
     * A mapping of watched targets that the client cares about tracking and the
     * user has explicitly called a 'listen' for this target.
     *
     * These targets may or may not have been sent to or acknowledged by the
     * server. On re-establishing the listen stream, these targets should be sent
     * to the server. The targets removed with unlistens are removed eagerly
     * without waiting for confirmation from the listen stream.
     */
    this.Ta = /* @__PURE__ */ new Map(), /**
     * A set of reasons for why the RemoteStore may be offline. If empty, the
     * RemoteStore may start its network connections.
     */
    this.Ia = /* @__PURE__ */ new Set(), /**
     * Event handlers that get called when the network is disabled or enabled.
     *
     * PORTING NOTE: These functions are used on the Web client to create the
     * underlying streams (to support tree-shakeable streams). On Android and iOS,
     * the streams are created during construction of RemoteStore.
     */
    this.da = [], this.Ea = o, this.Ea.xo((a) => {
      r.enqueueAndForget(async () => {
        Zu(this) && (bt(gf, "Restarting streams for network reachability change."), await async function(c) {
          const l = Gt(c);
          l.Ia.add(
            4
            /* OfflineCause.ConnectivityChange */
          ), await hy(l), l.Aa.set(
            "Unknown"
            /* OnlineState.Unknown */
          ), l.Ia.delete(
            4
            /* OfflineCause.ConnectivityChange */
          ), await Zx(l);
        }(this));
      });
    }), this.Aa = new _xe(r, i);
  }
}
async function Zx(e) {
  if (Zu(e))
    for (const t of e.da)
      await t(
        /* enabled= */
        !0
      );
}
async function hy(e) {
  for (const t of e.da)
    await t(
      /* enabled= */
      !1
    );
}
function xG(e, t) {
  const n = Gt(e);
  n.Ta.has(t.targetId) || // Mark this as something the client is currently listening for.
  (n.Ta.set(t.targetId, t), r6(n) ? (
    // The listen will be sent in onWatchStreamOpen
    n6(n)
  ) : Lp(n).x_() && t6(n, t));
}
function e6(e, t) {
  const n = Gt(e), r = Lp(n);
  n.Ta.delete(t), r.x_() && EG(n, t), n.Ta.size === 0 && (r.x_() ? r.B_() : Zu(n) && // Revert to OnlineState.Unknown if the watch stream is not open and we
  // have no listeners, since without any listens to send we cannot
  // confirm if the stream is healthy and upgrade to OnlineState.Online.
  n.Aa.set(
    "Unknown"
    /* OnlineState.Unknown */
  ));
}
function t6(e, t) {
  if (e.Ra.$e(t.targetId), t.resumeToken.approximateByteSize() > 0 || t.snapshotVersion.compareTo(Kt.min()) > 0) {
    const n = e.remoteSyncer.getRemoteKeysForTarget(t.targetId).size;
    t = t.withExpectedCount(n);
  }
  Lp(e).H_(t);
}
function EG(e, t) {
  e.Ra.$e(t), Lp(e).Y_(t);
}
function n6(e) {
  e.Ra = new mwe({
    getRemoteKeysForTarget: (t) => e.remoteSyncer.getRemoteKeysForTarget(t),
    Et: (t) => e.Ta.get(t) || null,
    lt: () => e.datastore.serializer.databaseId
  }), Lp(e).start(), e.Aa.aa();
}
function r6(e) {
  return Zu(e) && !Lp(e).M_() && e.Ta.size > 0;
}
function Zu(e) {
  return Gt(e).Ia.size === 0;
}
function CG(e) {
  e.Ra = void 0;
}
async function wxe(e) {
  e.Aa.set(
    "Online"
    /* OnlineState.Online */
  );
}
async function xxe(e) {
  e.Ta.forEach((t, n) => {
    t6(e, t);
  });
}
async function Exe(e, t) {
  CG(e), // If we still need the watch stream, retry the connection.
  r6(e) ? (e.Aa.la(t), n6(e)) : (
    // No need to restart watch stream because there are no active targets.
    // The online state is set to unknown because there is no active attempt
    // at establishing a connection
    e.Aa.set(
      "Unknown"
      /* OnlineState.Unknown */
    )
  );
}
async function Cxe(e, t, n) {
  if (
    // Mark the client as online since we got a message from the server
    e.Aa.set(
      "Online"
      /* OnlineState.Online */
    ), t instanceof sG && t.state === 2 && t.cause
  )
    try {
      await async function(i, o) {
        const a = o.cause;
        for (const s of o.targetIds)
          i.Ta.has(s) && (await i.remoteSyncer.rejectListen(s, a), i.Ta.delete(s), i.Ra.removeTarget(s));
      }(e, t);
    } catch (r) {
      bt(gf, "Failed to remove targets %s: %s ", t.targetIds.join(","), r), await sS(e, r);
    }
  else if (t instanceof a_ ? e.Ra.Ye(t) : t instanceof aG ? e.Ra.it(t) : e.Ra.et(t), !n.isEqual(Kt.min()))
    try {
      const r = await _G(e.localStore);
      n.compareTo(r) >= 0 && // We have received a target change with a global snapshot if the snapshot
      // version is not equal to SnapshotVersion.min().
      /**
      * Takes a batch of changes from the Datastore, repackages them as a
      * RemoteEvent, and passes that on to the listener, which is typically the
      * SyncEngine.
      */
      await function(o, a) {
        const s = o.Ra.Pt(a);
        return s.targetChanges.forEach((c, l) => {
          if (c.resumeToken.approximateByteSize() > 0) {
            const u = o.Ta.get(l);
            u && o.Ta.set(l, u.withResumeToken(c.resumeToken, a));
          }
        }), // Re-establish listens for the targets that have been invalidated by
        // existence filter mismatches.
        s.targetMismatches.forEach((c, l) => {
          const u = o.Ta.get(c);
          if (!u)
            return;
          o.Ta.set(c, u.withResumeToken(Wi.EMPTY_BYTE_STRING, u.snapshotVersion)), // Cause a hard reset by unwatching and rewatching immediately, but
          // deliberately don't send a resume token so that we get a full update.
          EG(o, c);
          const d = new eu(u.target, c, l, u.sequenceNumber);
          t6(o, d);
        }), o.remoteSyncer.applyRemoteEvent(s);
      }(e, n);
    } catch (r) {
      bt(gf, "Failed to raise snapshot:", r), await sS(e, r);
    }
}
async function sS(e, t, n) {
  if (!jp(t))
    throw t;
  e.Ia.add(
    1
    /* OfflineCause.IndexedDbFailed */
  ), // Disable network and raise offline snapshots
  await hy(e), e.Aa.set(
    "Offline"
    /* OnlineState.Offline */
  ), n || // Use a simple read operation to determine if IndexedDB recovered.
  // Ideally, we would expose a health check directly on SimpleDb, but
  // RemoteStore only has access to persistence through LocalStore.
  (n = () => _G(e.localStore)), // Probe IndexedDB periodically and re-enable network
  e.asyncQueue.enqueueRetryable(async () => {
    bt(gf, "Retrying IndexedDB access"), await n(), e.Ia.delete(
      1
      /* OfflineCause.IndexedDbFailed */
    ), await Zx(e);
  });
}
function TG(e, t) {
  return t().catch((n) => sS(e, n, t));
}
async function eE(e) {
  const t = Gt(e), n = Ou(t);
  let r = t.Pa.length > 0 ? t.Pa[t.Pa.length - 1].batchId : zx;
  for (; Txe(t); )
    try {
      const i = await sxe(t.localStore, r);
      if (i === null) {
        t.Pa.length === 0 && n.B_();
        break;
      }
      r = i.batchId, Ixe(t, i);
    } catch (i) {
      await sS(t, i);
    }
  IG(t) && $G(t);
}
function Txe(e) {
  return Zu(e) && e.Pa.length < 10;
}
function Ixe(e, t) {
  e.Pa.push(t);
  const n = Ou(e);
  n.x_() && n.Z_ && n.X_(t.mutations);
}
function IG(e) {
  return Zu(e) && !Ou(e).M_() && e.Pa.length > 0;
}
function $G(e) {
  Ou(e).start();
}
async function $xe(e) {
  Ou(e).na();
}
async function Axe(e) {
  const t = Ou(e);
  for (const n of e.Pa)
    t.X_(n.mutations);
}
async function Rxe(e, t, n) {
  const r = e.Pa.shift(), i = GO.from(r, t, n);
  await TG(e, () => e.remoteSyncer.applySuccessfulWrite(i)), // It's possible that with the completion of this mutation another
  // slot has freed up.
  await eE(e);
}
async function Pxe(e, t) {
  t && Ou(e).Z_ && // This error affects the actual write.
  await async function(r, i) {
    if (function(a) {
      return gwe(a) && a !== we.ABORTED;
    }(i.code)) {
      const o = r.Pa.shift();
      Ou(r).N_(), await TG(r, () => r.remoteSyncer.rejectFailedWrite(o.batchId, i)), // It's possible that with the completion of this mutation
      // another slot has freed up.
      await eE(r);
    }
  }(e, t), // The write stream might have been started by refilling the write
  // pipeline for failed writes
  IG(e) && $G(e);
}
async function n8(e, t) {
  const n = Gt(e);
  n.asyncQueue.verifyOperationInProgress(), bt(gf, "RemoteStore received new credentials");
  const r = Zu(n);
  n.Ia.add(
    3
    /* OfflineCause.CredentialChange */
  ), await hy(n), r && // Don't set the network status to Unknown if we are offline.
  n.Aa.set(
    "Unknown"
    /* OnlineState.Unknown */
  ), await n.remoteSyncer.handleCredentialChange(t), n.Ia.delete(
    3
    /* OfflineCause.CredentialChange */
  ), await Zx(n);
}
async function Oxe(e, t) {
  const n = Gt(e);
  t ? (n.Ia.delete(
    2
    /* OfflineCause.IsSecondary */
  ), await Zx(n)) : t || (n.Ia.add(
    2
    /* OfflineCause.IsSecondary */
  ), await hy(n), n.Aa.set(
    "Unknown"
    /* OnlineState.Unknown */
  ));
}
function Lp(e) {
  return e.Va || // Create stream (but note that it is not started yet).
  (e.Va = function(n, r, i) {
    const o = Gt(n);
    return o.ia(), new mxe(r, o.connection, o.authCredentials, o.appCheckCredentials, o.serializer, i);
  }(e.datastore, e.asyncQueue, {
    Zo: wxe.bind(null, e),
    e_: xxe.bind(null, e),
    n_: Exe.bind(null, e),
    J_: Cxe.bind(null, e)
  }), e.da.push(async (t) => {
    t ? (e.Va.N_(), r6(e) ? n6(e) : e.Aa.set(
      "Unknown"
      /* OnlineState.Unknown */
    )) : (await e.Va.stop(), CG(e));
  })), e.Va;
}
function Ou(e) {
  return e.ma || // Create stream (but note that it is not started yet).
  (e.ma = function(n, r, i) {
    const o = Gt(n);
    return o.ia(), new vxe(r, o.connection, o.authCredentials, o.appCheckCredentials, o.serializer, i);
  }(e.datastore, e.asyncQueue, {
    Zo: () => Promise.resolve(),
    e_: $xe.bind(null, e),
    n_: Pxe.bind(null, e),
    ea: Axe.bind(null, e),
    ta: Rxe.bind(null, e)
  }), e.da.push(async (t) => {
    t ? (e.ma.N_(), // This will start the write stream if necessary.
    await eE(e)) : (await e.ma.stop(), e.Pa.length > 0 && (bt(gf, `Stopping write stream with ${e.Pa.length} pending writes`), e.Pa = []));
  })), e.ma;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class i6 {
  constructor(t, n, r, i, o) {
    this.asyncQueue = t, this.timerId = n, this.targetTimeMs = r, this.op = i, this.removalCallback = o, this.deferred = new _s(), this.then = this.deferred.promise.then.bind(this.deferred.promise), // It's normal for the deferred promise to be canceled (due to cancellation)
    // and so we attach a dummy catch callback to avoid
    // 'UnhandledPromiseRejectionWarning' log spam.
    this.deferred.promise.catch((a) => {
    });
  }
  get promise() {
    return this.deferred.promise;
  }
  /**
   * Creates and returns a DelayedOperation that has been scheduled to be
   * executed on the provided asyncQueue after the provided delayMs.
   *
   * @param asyncQueue - The queue to schedule the operation on.
   * @param id - A Timer ID identifying the type of operation this is.
   * @param delayMs - The delay (ms) before the operation should be scheduled.
   * @param op - The operation to run.
   * @param removalCallback - A callback to be called synchronously once the
   *   operation is executed or canceled, notifying the AsyncQueue to remove it
   *   from its delayedOperations list.
   *   PORTING NOTE: This exists to prevent making removeDelayedOperation() and
   *   the DelayedOperation class public.
   */
  static createAndSchedule(t, n, r, i, o) {
    const a = Date.now() + r, s = new i6(t, n, a, i, o);
    return s.start(r), s;
  }
  /**
   * Starts the timer. This is called immediately after construction by
   * createAndSchedule().
   */
  start(t) {
    this.timerHandle = setTimeout(() => this.handleDelayElapsed(), t);
  }
  /**
   * Queues the operation to run immediately (if it hasn't already been run or
   * canceled).
   */
  skipDelay() {
    return this.handleDelayElapsed();
  }
  /**
   * Cancels the operation if it hasn't already been executed or canceled. The
   * promise will be rejected.
   *
   * As long as the operation has not yet been run, calling cancel() provides a
   * guarantee that the operation will not be run.
   */
  cancel(t) {
    this.timerHandle !== null && (this.clearTimeout(), this.deferred.reject(new Je(we.CANCELLED, "Operation cancelled" + (t ? ": " + t : ""))));
  }
  handleDelayElapsed() {
    this.asyncQueue.enqueueAndForget(() => this.timerHandle !== null ? (this.clearTimeout(), this.op().then((t) => this.deferred.resolve(t))) : Promise.resolve());
  }
  clearTimeout() {
    this.timerHandle !== null && (this.removalCallback(this), clearTimeout(this.timerHandle), this.timerHandle = null);
  }
}
function tE(e, t) {
  if (hl("AsyncQueue", `${t}: ${e}`), jp(e))
    return new Je(we.UNAVAILABLE, `${t}: ${e}`);
  throw e;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class cg {
  /**
   * Returns an empty copy of the existing DocumentSet, using the same
   * comparator.
   */
  static emptySet(t) {
    return new cg(t.comparator);
  }
  /** The default ordering is by key if the comparator is omitted */
  constructor(t) {
    this.comparator = t ? (n, r) => t(n, r) || kt.comparator(n.key, r.key) : (n, r) => kt.comparator(n.key, r.key), this.keyedMap = a0(), this.sortedSet = new Fr(this.comparator);
  }
  has(t) {
    return this.keyedMap.get(t) != null;
  }
  get(t) {
    return this.keyedMap.get(t);
  }
  first() {
    return this.sortedSet.minKey();
  }
  last() {
    return this.sortedSet.maxKey();
  }
  isEmpty() {
    return this.sortedSet.isEmpty();
  }
  /**
   * Returns the index of the provided key in the document set, or -1 if the
   * document key is not present in the set;
   */
  indexOf(t) {
    const n = this.keyedMap.get(t);
    return n ? this.sortedSet.indexOf(n) : -1;
  }
  get size() {
    return this.sortedSet.size;
  }
  /** Iterates documents in order defined by "comparator" */
  forEach(t) {
    this.sortedSet.inorderTraversal((n, r) => (t(n), !1));
  }
  /** Inserts or updates a document with the same key */
  add(t) {
    const n = this.delete(t.key);
    return n.copy(n.keyedMap.insert(t.key, t), n.sortedSet.insert(t, null));
  }
  /** Deletes a document with a given key */
  delete(t) {
    const n = this.get(t);
    return n ? this.copy(this.keyedMap.remove(t), this.sortedSet.remove(n)) : this;
  }
  isEqual(t) {
    if (!(t instanceof cg) || this.size !== t.size)
      return !1;
    const n = this.sortedSet.getIterator(), r = t.sortedSet.getIterator();
    for (; n.hasNext(); ) {
      const i = n.getNext().key, o = r.getNext().key;
      if (!i.isEqual(o))
        return !1;
    }
    return !0;
  }
  toString() {
    const t = [];
    return this.forEach((n) => {
      t.push(n.toString());
    }), t.length === 0 ? "DocumentSet ()" : `DocumentSet (
  ` + t.join(`  
`) + `
)`;
  }
  copy(t, n) {
    const r = new cg();
    return r.comparator = this.comparator, r.keyedMap = t, r.sortedSet = n, r;
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class r8 {
  constructor() {
    this.fa = new Fr(kt.comparator);
  }
  track(t) {
    const n = t.doc.key, r = this.fa.get(n);
    r ? (
      // Merge the new change with the existing change.
      t.type !== 0 && r.type === 3 ? this.fa = this.fa.insert(n, t) : t.type === 3 && r.type !== 1 ? this.fa = this.fa.insert(n, {
        type: r.type,
        doc: t.doc
      }) : t.type === 2 && r.type === 2 ? this.fa = this.fa.insert(n, {
        type: 2,
        doc: t.doc
      }) : t.type === 2 && r.type === 0 ? this.fa = this.fa.insert(n, {
        type: 0,
        doc: t.doc
      }) : t.type === 1 && r.type === 0 ? this.fa = this.fa.remove(n) : t.type === 1 && r.type === 2 ? this.fa = this.fa.insert(n, {
        type: 1,
        doc: r.doc
      }) : t.type === 0 && r.type === 1 ? this.fa = this.fa.insert(n, {
        type: 2,
        doc: t.doc
      }) : (
        // This includes these cases, which don't make sense:
        // Added->Added
        // Removed->Removed
        // Modified->Added
        // Removed->Modified
        // Metadata->Added
        // Removed->Metadata
        qt(63341, {
          At: t,
          ga: r
        })
      )
    ) : this.fa = this.fa.insert(n, t);
  }
  pa() {
    const t = [];
    return this.fa.inorderTraversal((n, r) => {
      t.push(r);
    }), t;
  }
}
class Pg {
  constructor(t, n, r, i, o, a, s, c, l) {
    this.query = t, this.docs = n, this.oldDocs = r, this.docChanges = i, this.mutatedKeys = o, this.fromCache = a, this.syncStateChanged = s, this.excludesMetadataChanges = c, this.hasCachedResults = l;
  }
  /** Returns a view snapshot as if all documents in the snapshot were added. */
  static fromInitialDocuments(t, n, r, i, o) {
    const a = [];
    return n.forEach((s) => {
      a.push({
        type: 0,
        doc: s
      });
    }), new Pg(
      t,
      n,
      cg.emptySet(n),
      a,
      r,
      i,
      /* syncStateChanged= */
      !0,
      /* excludesMetadataChanges= */
      !1,
      o
    );
  }
  get hasPendingWrites() {
    return !this.mutatedKeys.isEmpty();
  }
  isEqual(t) {
    if (!(this.fromCache === t.fromCache && this.hasCachedResults === t.hasCachedResults && this.syncStateChanged === t.syncStateChanged && this.mutatedKeys.isEqual(t.mutatedKeys) && Gx(this.query, t.query) && this.docs.isEqual(t.docs) && this.oldDocs.isEqual(t.oldDocs)))
      return !1;
    const n = this.docChanges, r = t.docChanges;
    if (n.length !== r.length)
      return !1;
    for (let i = 0; i < n.length; i++)
      if (n[i].type !== r[i].type || !n[i].doc.isEqual(r[i].doc))
        return !1;
    return !0;
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Mxe {
  constructor() {
    this.ya = void 0, this.wa = [];
  }
  // Helper methods that checks if the query has listeners that listening to remote store
  Sa() {
    return this.wa.some((t) => t.ba());
  }
}
class kxe {
  constructor() {
    this.queries = i8(), this.onlineState = "Unknown", this.Da = /* @__PURE__ */ new Set();
  }
  terminate() {
    (function(n, r) {
      const i = Gt(n), o = i.queries;
      i.queries = i8(), o.forEach((a, s) => {
        for (const c of s.wa)
          c.onError(r);
      });
    })(this, new Je(we.ABORTED, "Firestore shutting down"));
  }
}
function i8() {
  return new Vf((e) => qq(e), Gx);
}
async function o6(e, t) {
  const n = Gt(e);
  let r = 3;
  const i = t.query;
  let o = n.queries.get(i);
  o ? !o.Sa() && t.ba() && // Query has been listening to local cache, and tries to add a new listener sourced from watch.
  (r = 2) : (o = new Mxe(), r = t.ba() ? 0 : 1);
  try {
    switch (r) {
      case 0:
        o.ya = await n.onListen(
          i,
          /** enableRemoteListen= */
          !0
        );
        break;
      case 1:
        o.ya = await n.onListen(
          i,
          /** enableRemoteListen= */
          !1
        );
        break;
      case 2:
        await n.onFirstRemoteStoreListen(i);
    }
  } catch (a) {
    const s = tE(a, `Initialization of query '${Lh(t.query)}' failed`);
    return void t.onError(s);
  }
  n.queries.set(i, o), o.wa.push(t), // Run global snapshot listeners if a consistent snapshot has been emitted.
  t.va(n.onlineState), o.ya && t.Ca(o.ya) && s6(n);
}
async function a6(e, t) {
  const n = Gt(e), r = t.query;
  let i = 3;
  const o = n.queries.get(r);
  if (o) {
    const a = o.wa.indexOf(t);
    a >= 0 && (o.wa.splice(a, 1), o.wa.length === 0 ? i = t.ba() ? 0 : 1 : !o.Sa() && t.ba() && // The removed listener is the last one that sourced from watch.
    (i = 2));
  }
  switch (i) {
    case 0:
      return n.queries.delete(r), n.onUnlisten(
        r,
        /** disableRemoteListen= */
        !0
      );
    case 1:
      return n.queries.delete(r), n.onUnlisten(
        r,
        /** disableRemoteListen= */
        !1
      );
    case 2:
      return n.onLastRemoteStoreUnlisten(r);
    default:
      return;
  }
}
function Nxe(e, t) {
  const n = Gt(e);
  let r = !1;
  for (const i of t) {
    const o = i.query, a = n.queries.get(o);
    if (a) {
      for (const s of a.wa)
        s.Ca(i) && (r = !0);
      a.ya = i;
    }
  }
  r && s6(n);
}
function Dxe(e, t, n) {
  const r = Gt(e), i = r.queries.get(t);
  if (i)
    for (const o of i.wa)
      o.onError(n);
  r.queries.delete(t);
}
function s6(e) {
  e.Da.forEach((t) => {
    t.next();
  });
}
var Y$, o8;
(o8 = Y$ || (Y$ = {})).Fa = "default", /** Listen to changes in cache only */
o8.Cache = "cache";
class c6 {
  constructor(t, n, r) {
    this.query = t, this.Ma = n, /**
     * Initial snapshots (e.g. from cache) may not be propagated to the wrapped
     * observer. This flag is set to true once we've actually raised an event.
     */
    this.xa = !1, this.Oa = null, this.onlineState = "Unknown", this.options = r || {};
  }
  /**
   * Applies the new ViewSnapshot to this listener, raising a user-facing event
   * if applicable (depending on what changed, whether the user has opted into
   * metadata-only changes, etc.). Returns true if a user-facing event was
   * indeed raised.
   */
  Ca(t) {
    if (!this.options.includeMetadataChanges) {
      const r = [];
      for (const i of t.docChanges)
        i.type !== 3 && r.push(i);
      t = new Pg(
        t.query,
        t.docs,
        t.oldDocs,
        r,
        t.mutatedKeys,
        t.fromCache,
        t.syncStateChanged,
        /* excludesMetadataChanges= */
        !0,
        t.hasCachedResults
      );
    }
    let n = !1;
    return this.xa ? this.Na(t) && (this.Ma.next(t), n = !0) : this.Ba(t, this.onlineState) && (this.La(t), n = !0), this.Oa = t, n;
  }
  onError(t) {
    this.Ma.error(t);
  }
  /** Returns whether a snapshot was raised. */
  va(t) {
    this.onlineState = t;
    let n = !1;
    return this.Oa && !this.xa && this.Ba(this.Oa, t) && (this.La(this.Oa), n = !0), n;
  }
  Ba(t, n) {
    if (!t.fromCache || !this.ba())
      return !0;
    const r = n !== "Offline";
    return (!this.options.ka || !r) && (!t.docs.isEmpty() || t.hasCachedResults || n === "Offline");
  }
  Na(t) {
    if (t.docChanges.length > 0)
      return !0;
    const n = this.Oa && this.Oa.hasPendingWrites !== t.hasPendingWrites;
    return !(!t.syncStateChanged && !n) && this.options.includeMetadataChanges === !0;
  }
  La(t) {
    t = Pg.fromInitialDocuments(t.query, t.docs, t.mutatedKeys, t.fromCache, t.hasCachedResults), this.xa = !0, this.Ma.next(t);
  }
  ba() {
    return this.options.source !== Y$.Cache;
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class AG {
  constructor(t) {
    this.key = t;
  }
}
class RG {
  constructor(t) {
    this.key = t;
  }
}
class jxe {
  constructor(t, n) {
    this.query = t, this.Ha = n, this.Ya = null, this.hasCachedResults = !1, /**
     * A flag whether the view is current with the backend. A view is considered
     * current after it has seen the current flag from the backend and did not
     * lose consistency within the watch stream (e.g. because of an existence
     * filter mismatch).
     */
    this.current = !1, /** Documents in the view but not in the remote target */
    this.Za = Sn(), /** Document Keys that have local changes */
    this.mutatedKeys = Sn(), this.Xa = Gq(t), this.eu = new cg(this.Xa);
  }
  /**
   * The set of remote documents that the server has told us belongs to the target associated with
   * this view.
   */
  get tu() {
    return this.Ha;
  }
  /**
   * Iterates over a set of doc changes, applies the query limit, and computes
   * what the new results should be, what the changes were, and whether we may
   * need to go back to the local cache for more results. Does not make any
   * changes to the view.
   * @param docChanges - The doc changes to apply to this view.
   * @param previousChanges - If this is being called with a refill, then start
   *        with this set of docs and changes instead of the current view.
   * @returns a new set of docs, changes, and refill flag.
   */
  nu(t, n) {
    const r = n ? n.ru : new r8(), i = n ? n.eu : this.eu;
    let o = n ? n.mutatedKeys : this.mutatedKeys, a = i, s = !1;
    const c = this.query.limitType === "F" && i.size === this.query.limit ? i.last() : null, l = this.query.limitType === "L" && i.size === this.query.limit ? i.first() : null;
    if (t.inorderTraversal((u, d) => {
      const f = i.get(u), h = Kx(this.query, d) ? d : null, p = !!f && this.mutatedKeys.has(f.key), g = !!h && (h.hasLocalMutations || // We only consider committed mutations for documents that were
      // mutated during the lifetime of the view.
      this.mutatedKeys.has(h.key) && h.hasCommittedMutations);
      let m = !1;
      f && h ? f.data.isEqual(h.data) ? p !== g && (r.track({
        type: 3,
        doc: h
      }), m = !0) : this.iu(f, h) || (r.track({
        type: 2,
        doc: h
      }), m = !0, (c && this.Xa(h, c) > 0 || l && this.Xa(h, l) < 0) && // This doc moved from inside the limit to outside the limit.
      // That means there may be some other doc in the local cache
      // that should be included instead.
      (s = !0)) : !f && h ? (r.track({
        type: 0,
        doc: h
      }), m = !0) : f && !h && (r.track({
        type: 1,
        doc: f
      }), m = !0, (c || l) && // A doc was removed from a full limit query. We'll need to
      // requery from the local cache to see if we know about some other
      // doc that should be in the results.
      (s = !0)), m && (h ? (a = a.add(h), o = g ? o.add(u) : o.delete(u)) : (a = a.delete(u), o = o.delete(u)));
    }), this.query.limit !== null)
      for (; a.size > this.query.limit; ) {
        const u = this.query.limitType === "F" ? a.last() : a.first();
        a = a.delete(u.key), o = o.delete(u.key), r.track({
          type: 1,
          doc: u
        });
      }
    return {
      eu: a,
      ru: r,
      Ds: s,
      mutatedKeys: o
    };
  }
  iu(t, n) {
    return t.hasLocalMutations && n.hasCommittedMutations && !n.hasLocalMutations;
  }
  /**
   * Updates the view with the given ViewDocumentChanges and optionally updates
   * limbo docs and sync state from the provided target change.
   * @param docChanges - The set of changes to make to the view's docs.
   * @param limboResolutionEnabled - Whether to update limbo documents based on
   *        this change.
   * @param targetChange - A target change to apply for computing limbo docs and
   *        sync state.
   * @param targetIsPendingReset - Whether the target is pending to reset due to
   *        existence filter mismatch. If not explicitly specified, it is treated
   *        equivalently to `false`.
   * @returns A new ViewChange with the given docs, changes, and sync state.
   */
  // PORTING NOTE: The iOS/Android clients always compute limbo document changes.
  applyChanges(t, n, r, i) {
    const o = this.eu;
    this.eu = t.eu, this.mutatedKeys = t.mutatedKeys;
    const a = t.ru.pa();
    a.sort((u, d) => function(h, p) {
      const g = (m) => {
        switch (m) {
          case 0:
            return 1;
          case 2:
          case 3:
            return 2;
          case 1:
            return 0;
          default:
            return qt(20277, {
              At: m
            });
        }
      };
      return g(h) - g(p);
    }(u.type, d.type) || this.Xa(u.doc, d.doc)), this.su(r), i = i != null && i;
    const s = n && !i ? this.ou() : [], c = this.Za.size === 0 && this.current && !i ? 1 : 0, l = c !== this.Ya;
    return this.Ya = c, a.length !== 0 || l ? {
      snapshot: new Pg(
        this.query,
        t.eu,
        o,
        a,
        t.mutatedKeys,
        c === 0,
        l,
        /* excludesMetadataChanges= */
        !1,
        !!r && r.resumeToken.approximateByteSize() > 0
      ),
      _u: s
    } : {
      _u: s
    };
  }
  /**
   * Applies an OnlineState change to the view, potentially generating a
   * ViewChange if the view's syncState changes as a result.
   */
  va(t) {
    return this.current && t === "Offline" ? (
      // If we're offline, set `current` to false and then call applyChanges()
      // to refresh our syncState and generate a ViewChange as appropriate. We
      // are guaranteed to get a new TargetChange that sets `current` back to
      // true once the client is back online.
      (this.current = !1, this.applyChanges(
        {
          eu: this.eu,
          ru: new r8(),
          mutatedKeys: this.mutatedKeys,
          Ds: !1
        },
        /* limboResolutionEnabled= */
        !1
      ))
    ) : {
      _u: []
    };
  }
  /**
   * Returns whether the doc for the given key should be in limbo.
   */
  au(t) {
    return !this.Ha.has(t) && // The local store doesn't think it's a result, so it shouldn't be in limbo.
    !!this.eu.has(t) && !this.eu.get(t).hasLocalMutations;
  }
  /**
   * Updates syncedDocuments, current, and limbo docs based on the given change.
   * Returns the list of changes to which docs are in limbo.
   */
  su(t) {
    t && (t.addedDocuments.forEach((n) => this.Ha = this.Ha.add(n)), t.modifiedDocuments.forEach((n) => {
    }), t.removedDocuments.forEach((n) => this.Ha = this.Ha.delete(n)), this.current = t.current);
  }
  ou() {
    if (!this.current)
      return [];
    const t = this.Za;
    this.Za = Sn(), this.eu.forEach((r) => {
      this.au(r.key) && (this.Za = this.Za.add(r.key));
    });
    const n = [];
    return t.forEach((r) => {
      this.Za.has(r) || n.push(new RG(r));
    }), this.Za.forEach((r) => {
      t.has(r) || n.push(new AG(r));
    }), n;
  }
  /**
   * Update the in-memory state of the current view with the state read from
   * persistence.
   *
   * We update the query view whenever a client's primary status changes:
   * - When a client transitions from primary to secondary, it can miss
   *   LocalStorage updates and its query views may temporarily not be
   *   synchronized with the state on disk.
   * - For secondary to primary transitions, the client needs to update the list
   *   of `syncedDocuments` since secondary clients update their query views
   *   based purely on synthesized RemoteEvents.
   *
   * @param queryResult.documents - The documents that match the query according
   * to the LocalStore.
   * @param queryResult.remoteKeys - The keys of the documents that match the
   * query according to the backend.
   *
   * @returns The ViewChange that resulted from this synchronization.
   */
  // PORTING NOTE: Multi-tab only.
  uu(t) {
    this.Ha = t.qs, this.Za = Sn();
    const n = this.nu(t.documents);
    return this.applyChanges(
      n,
      /* limboResolutionEnabled= */
      !0
    );
  }
  /**
   * Returns a view snapshot as if this query was just listened to. Contains
   * a document add for every existing document and the `fromCache` and
   * `hasPendingWrites` status of the already established view.
   */
  // PORTING NOTE: Multi-tab only.
  cu() {
    return Pg.fromInitialDocuments(this.query, this.eu, this.mutatedKeys, this.Ya === 0, this.hasCachedResults);
  }
}
const nE = "SyncEngine";
class Lxe {
  constructor(t, n, r) {
    this.query = t, this.targetId = n, this.view = r;
  }
}
class Fxe {
  constructor(t) {
    this.key = t, /**
     * Set to true once we've received a document. This is used in
     * getRemoteKeysForTarget() and ultimately used by WatchChangeAggregator to
     * decide whether it needs to manufacture a delete event for the target once
     * the target is CURRENT.
     */
    this.lu = !1;
  }
}
class Vxe {
  constructor(t, n, r, i, o, a) {
    this.localStore = t, this.remoteStore = n, this.eventManager = r, this.sharedClientState = i, this.currentUser = o, this.maxConcurrentLimboResolutions = a, this.hu = {}, this.Pu = new Vf((s) => qq(s), Gx), this.Tu = /* @__PURE__ */ new Map(), /**
     * The keys of documents that are in limbo for which we haven't yet started a
     * limbo resolution query. The strings in this set are the result of calling
     * `key.path.canonicalString()` where `key` is a `DocumentKey` object.
     *
     * The `Set` type was chosen because it provides efficient lookup and removal
     * of arbitrary elements and it also maintains insertion order, providing the
     * desired queue-like FIFO semantics.
     */
    this.Iu = /* @__PURE__ */ new Set(), /**
     * Keeps track of the target ID for each document that is in limbo with an
     * active target.
     */
    this.du = new Fr(kt.comparator), /**
     * Keeps track of the information about an active limbo resolution for each
     * active target ID that was started for the purpose of limbo resolution.
     */
    this.Eu = /* @__PURE__ */ new Map(), this.Au = new XO(), /** Stores user completion handlers, indexed by User and BatchId. */
    this.Ru = {}, /** Stores user callbacks waiting for all pending writes to be acknowledged. */
    this.Vu = /* @__PURE__ */ new Map(), this.mu = Rg.ur(), this.onlineState = "Unknown", // The primary state is set to `true` or `false` immediately after Firestore
    // startup. In the interim, a client should only be considered primary if
    // `isPrimary` is true.
    this.fu = void 0;
  }
  get isPrimaryClient() {
    return this.fu === !0;
  }
}
async function Bxe(e, t, n = !0) {
  const r = DG(e);
  let i;
  const o = r.Pu.get(t);
  return o ? (
    // PORTING NOTE: With Multi-Tab Web, it is possible that a query view
    // already exists when EventManager calls us for the first time. This
    // happens when the primary tab is already listening to this query on
    // behalf of another tab and the user of the primary also starts listening
    // to the query. EventManager will not have an assigned target ID in this
    // case and calls `listen` to obtain this ID.
    (r.sharedClientState.addLocalQueryTarget(o.targetId), i = o.view.cu())
  ) : i = await PG(
    r,
    t,
    n,
    /** shouldInitializeView= */
    !0
  ), i;
}
async function zxe(e, t) {
  const n = DG(e);
  await PG(
    n,
    t,
    /** shouldListenToRemote= */
    !0,
    /** shouldInitializeView= */
    !1
  );
}
async function PG(e, t, n, r) {
  const i = await cxe(e.localStore, uc(t)), o = i.targetId, a = e.sharedClientState.addLocalQueryTarget(o, n);
  let s;
  return r && (s = await Hxe(e, t, o, a === "current", i.resumeToken)), e.isPrimaryClient && n && xG(e.remoteStore, i), s;
}
async function Hxe(e, t, n, r, i) {
  e.gu = (d, f, h) => async function(g, m, v, y) {
    let _ = m.view.nu(v);
    _.Ds && // The query has a limit and some docs were removed, so we need
    // to re-run the query against the local store to make sure we
    // didn't lose any good docs that had been past the limit.
    (_ = await QD(
      g.localStore,
      m.query,
      /* usePreviousResults= */
      !1
    ).then(({ documents: x }) => m.view.nu(x, _)));
    const b = y && y.targetChanges.get(m.targetId), w = y && y.targetMismatches.get(m.targetId) != null, C = m.view.applyChanges(
      _,
      /* limboResolutionEnabled= */
      g.isPrimaryClient,
      b,
      w
    );
    return s8(g, m.targetId, C._u), C.snapshot;
  }(e, d, f, h);
  const o = await QD(
    e.localStore,
    t,
    /* usePreviousResults= */
    !0
  ), a = new jxe(t, o.qs), s = a.nu(o.documents), c = fy.createSynthesizedTargetChangeForCurrentChange(n, r && e.onlineState !== "Offline", i), l = a.applyChanges(
    s,
    /* limboResolutionEnabled= */
    e.isPrimaryClient,
    c
  );
  s8(e, n, l._u);
  const u = new Lxe(t, n, a);
  return e.Pu.set(t, u), e.Tu.has(n) ? e.Tu.get(n).push(t) : e.Tu.set(n, [t]), l.snapshot;
}
async function Uxe(e, t, n) {
  const r = Gt(e), i = r.Pu.get(t), o = r.Tu.get(i.targetId);
  if (o.length > 1)
    return r.Tu.set(i.targetId, o.filter((a) => !Gx(a, t))), void r.Pu.delete(t);
  r.isPrimaryClient ? (r.sharedClientState.removeLocalQueryTarget(i.targetId), r.sharedClientState.isActiveQueryTarget(i.targetId) || await G$(
    r.localStore,
    i.targetId,
    /*keepPersistedTargetData=*/
    !1
  ).then(() => {
    r.sharedClientState.clearQueryState(i.targetId), n && e6(r.remoteStore, i.targetId), X$(r, i.targetId);
  }).catch(Dp)) : (X$(r, i.targetId), await G$(
    r.localStore,
    i.targetId,
    /*keepPersistedTargetData=*/
    !0
  ));
}
async function Wxe(e, t) {
  const n = Gt(e), r = n.Pu.get(t), i = n.Tu.get(r.targetId);
  n.isPrimaryClient && i.length === 1 && // PORTING NOTE: Unregister the target ID with local Firestore client as
  // watch target.
  (n.sharedClientState.removeLocalQueryTarget(r.targetId), e6(n.remoteStore, r.targetId));
}
async function qxe(e, t, n) {
  const r = eEe(e);
  try {
    const i = await function(a, s) {
      const c = Gt(a), l = jn.now(), u = s.reduce((h, p) => h.add(p.key), Sn());
      let d, f;
      return c.persistence.runTransaction("Locally write mutations", "readwrite", (h) => {
        let p = gl(), g = Sn();
        return c.Os.getEntries(h, u).next((m) => {
          p = m, p.forEach((v, y) => {
            y.isValidDocument() || (g = g.add(v));
          });
        }).next(() => c.localDocuments.getOverlayedDocuments(h, p)).next((m) => {
          d = m;
          const v = [];
          for (const y of s) {
            const _ = cwe(y, d.get(y.key).overlayedDocument);
            _ != null && // NOTE: The base state should only be applied if there's some
            // existing document to override, so use a Precondition of
            // exists=true
            v.push(new Ju(y.key, _, Lq(_.value.mapValue), dc.exists(!0)));
          }
          return c.mutationQueue.addMutationBatch(h, l, v, s);
        }).next((m) => {
          f = m;
          const v = m.applyToLocalDocumentSet(d, g);
          return c.documentOverlayCache.saveOverlays(h, m.batchId, v);
        });
      }).then(() => ({
        batchId: f.batchId,
        changes: Yq(d)
      }));
    }(r.localStore, t);
    r.sharedClientState.addPendingMutation(i.batchId), function(a, s, c) {
      let l = a.Ru[a.currentUser.toKey()];
      l || (l = new Fr(gn)), l = l.insert(s, c), a.Ru[a.currentUser.toKey()] = l;
    }(r, i.batchId, n), await gy(r, i.changes), await eE(r.remoteStore);
  } catch (i) {
    const o = tE(i, "Failed to persist write");
    n.reject(o);
  }
}
async function OG(e, t) {
  const n = Gt(e);
  try {
    const r = await oxe(n.localStore, t);
    t.targetChanges.forEach((i, o) => {
      const a = n.Eu.get(o);
      a && // Since this is a limbo resolution lookup, it's for a single document
      // and it could be added, modified, or removed, but not a combination.
      (Fn(i.addedDocuments.size + i.modifiedDocuments.size + i.removedDocuments.size <= 1, 22616), i.addedDocuments.size > 0 ? a.lu = !0 : i.modifiedDocuments.size > 0 ? Fn(a.lu, 14607) : i.removedDocuments.size > 0 && (Fn(a.lu, 42227), a.lu = !1));
    }), await gy(n, r, t);
  } catch (r) {
    await Dp(r);
  }
}
function a8(e, t, n) {
  const r = Gt(e);
  if (r.isPrimaryClient && n === 0 || !r.isPrimaryClient && n === 1) {
    const i = [];
    r.Pu.forEach((o, a) => {
      const s = a.view.va(t);
      s.snapshot && i.push(s.snapshot);
    }), function(a, s) {
      const c = Gt(a);
      c.onlineState = s;
      let l = !1;
      c.queries.forEach((u, d) => {
        for (const f of d.wa)
          f.va(s) && (l = !0);
      }), l && s6(c);
    }(r.eventManager, t), i.length && r.hu.J_(i), r.onlineState = t, r.isPrimaryClient && r.sharedClientState.setOnlineState(t);
  }
}
async function Gxe(e, t, n) {
  const r = Gt(e);
  r.sharedClientState.updateQueryState(t, "rejected", n);
  const i = r.Eu.get(t), o = i && i.key;
  if (o) {
    let a = new Fr(kt.comparator);
    a = a.insert(o, so.newNoDocument(o, Kt.min()));
    const s = Sn().add(o), c = new Qx(
      Kt.min(),
      /* targetChanges= */
      /* @__PURE__ */ new Map(),
      /* targetMismatches= */
      new Fr(gn),
      a,
      s
    );
    await OG(r, c), // Since this query failed, we won't want to manually unlisten to it.
    // We only remove it from bookkeeping after we successfully applied the
    // RemoteEvent. If `applyRemoteEvent()` throws, we want to re-listen to
    // this query when the RemoteStore restarts the Watch stream, which should
    // re-trigger the target failure.
    r.du = r.du.remove(o), r.Eu.delete(t), l6(r);
  } else
    await G$(
      r.localStore,
      t,
      /* keepPersistedTargetData */
      !1
    ).then(() => X$(r, t, n)).catch(Dp);
}
async function Kxe(e, t) {
  const n = Gt(e), r = t.batch.batchId;
  try {
    const i = await ixe(n.localStore, t);
    kG(
      n,
      r,
      /*error=*/
      null
    ), MG(n, r), n.sharedClientState.updateMutationState(r, "acknowledged"), await gy(n, i);
  } catch (i) {
    await Dp(i);
  }
}
async function Yxe(e, t, n) {
  const r = Gt(e);
  try {
    const i = await function(a, s) {
      const c = Gt(a);
      return c.persistence.runTransaction("Reject batch", "readwrite-primary", (l) => {
        let u;
        return c.mutationQueue.lookupMutationBatch(l, s).next((d) => (Fn(d !== null, 37113), u = d.keys(), c.mutationQueue.removeMutationBatch(l, d))).next(() => c.mutationQueue.performConsistencyCheck(l)).next(() => c.documentOverlayCache.removeOverlaysForBatchId(l, u, s)).next(() => c.localDocuments.recalculateAndSaveOverlaysForDocumentKeys(l, u)).next(() => c.localDocuments.getDocuments(l, u));
      });
    }(r.localStore, t);
    kG(r, t, n), MG(r, t), r.sharedClientState.updateMutationState(t, "rejected", n), await gy(r, i);
  } catch (i) {
    await Dp(i);
  }
}
async function Xxe(e, t) {
  const n = Gt(e);
  Zu(n.remoteStore) || bt(nE, "The network is disabled. The task returned by 'awaitPendingWrites()' will not complete until the network is enabled.");
  try {
    const r = await function(a) {
      const s = Gt(a);
      return s.persistence.runTransaction("Get highest unacknowledged batch id", "readonly", (c) => s.mutationQueue.getHighestUnacknowledgedBatchId(c));
    }(n.localStore);
    if (r === zx)
      return void t.resolve();
    const i = n.Vu.get(r) || [];
    i.push(t), n.Vu.set(r, i);
  } catch (r) {
    const i = tE(r, "Initialization of waitForPendingWrites() operation failed");
    t.reject(i);
  }
}
function MG(e, t) {
  (e.Vu.get(t) || []).forEach((n) => {
    n.resolve();
  }), e.Vu.delete(t);
}
function kG(e, t, n) {
  const r = Gt(e);
  let i = r.Ru[r.currentUser.toKey()];
  if (i) {
    const o = i.get(t);
    o && (n ? o.reject(n) : o.resolve(), i = i.remove(t)), r.Ru[r.currentUser.toKey()] = i;
  }
}
function X$(e, t, n = null) {
  e.sharedClientState.removeLocalQueryTarget(t);
  for (const r of e.Tu.get(t))
    e.Pu.delete(r), n && e.hu.pu(r, n);
  e.Tu.delete(t), e.isPrimaryClient && e.Au.zr(t).forEach((r) => {
    e.Au.containsKey(r) || // We removed the last reference for this key
    NG(e, r);
  });
}
function NG(e, t) {
  e.Iu.delete(t.path.canonicalString());
  const n = e.du.get(t);
  n !== null && (e6(e.remoteStore, n), e.du = e.du.remove(t), e.Eu.delete(n), l6(e));
}
function s8(e, t, n) {
  for (const r of n)
    r instanceof AG ? (e.Au.addReference(r.key, t), Qxe(e, r)) : r instanceof RG ? (bt(nE, "Document no longer in limbo: " + r.key), e.Au.removeReference(r.key, t), e.Au.containsKey(r.key) || // We removed the last reference for this key
    NG(e, r.key)) : qt(19791, {
      yu: r
    });
}
function Qxe(e, t) {
  const n = t.key, r = n.path.canonicalString();
  e.du.get(n) || e.Iu.has(r) || (bt(nE, "New document in limbo: " + n), e.Iu.add(r), l6(e));
}
function l6(e) {
  for (; e.Iu.size > 0 && e.du.size < e.maxConcurrentLimboResolutions; ) {
    const t = e.Iu.values().next().value;
    e.Iu.delete(t);
    const n = new kt(or.fromString(t)), r = e.mu.next();
    e.Eu.set(r, new Fxe(n)), e.du = e.du.insert(n, r), xG(e.remoteStore, new eu(uc(qx(n.path)), r, "TargetPurposeLimboResolution", Bx.ue));
  }
}
async function gy(e, t, n) {
  const r = Gt(e), i = [], o = [], a = [];
  r.Pu.isEmpty() || (r.Pu.forEach((s, c) => {
    a.push(r.gu(c, t, n).then((l) => {
      var u;
      if ((l || n) && r.isPrimaryClient) {
        const d = l ? !l.fromCache : (u = n == null ? void 0 : n.targetChanges.get(c.targetId)) === null || u === void 0 ? void 0 : u.current;
        r.sharedClientState.updateQueryState(c.targetId, d ? "current" : "not-current");
      }
      if (l) {
        i.push(l);
        const d = JO.Es(c.targetId, l);
        o.push(d);
      }
    }));
  }), await Promise.all(a), r.hu.J_(i), await async function(c, l) {
    const u = Gt(c);
    try {
      await u.persistence.runTransaction("notifyLocalViewChanges", "readwrite", (d) => Pe.forEach(l, (f) => Pe.forEach(f.Is, (h) => u.persistence.referenceDelegate.addReference(d, f.targetId, h)).next(() => Pe.forEach(f.ds, (h) => u.persistence.referenceDelegate.removeReference(d, f.targetId, h)))));
    } catch (d) {
      if (!jp(d))
        throw d;
      bt(ZO, "Failed to update sequence numbers: " + d);
    }
    for (const d of l) {
      const f = d.targetId;
      if (!d.fromCache) {
        const h = u.Fs.get(f), p = h.snapshotVersion, g = h.withLastLimboFreeSnapshotVersion(p);
        u.Fs = u.Fs.insert(f, g);
      }
    }
  }(r.localStore, o));
}
async function Jxe(e, t) {
  const n = Gt(e);
  if (!n.currentUser.isEqual(t)) {
    bt(nE, "User change. New user:", t.toKey());
    const r = await bG(n.localStore, t);
    n.currentUser = t, // Fails tasks waiting for pending writes requested by previous user.
    function(o, a) {
      o.Vu.forEach((s) => {
        s.forEach((c) => {
          c.reject(new Je(we.CANCELLED, a));
        });
      }), o.Vu.clear();
    }(n, "'waitForPendingWrites' promise is rejected due to a user change."), // TODO(b/114226417): Consider calling this only in the primary tab.
    n.sharedClientState.handleUserChange(t, r.removedBatchIds, r.addedBatchIds), await gy(n, r.Bs);
  }
}
function Zxe(e, t) {
  const n = Gt(e), r = n.Eu.get(t);
  if (r && r.lu)
    return Sn().add(r.key);
  {
    let i = Sn();
    const o = n.Tu.get(t);
    if (!o)
      return i;
    for (const a of o) {
      const s = n.Pu.get(a);
      i = i.unionWith(s.view.tu);
    }
    return i;
  }
}
function DG(e) {
  const t = Gt(e);
  return t.remoteStore.remoteSyncer.applyRemoteEvent = OG.bind(null, t), t.remoteStore.remoteSyncer.getRemoteKeysForTarget = Zxe.bind(null, t), t.remoteStore.remoteSyncer.rejectListen = Gxe.bind(null, t), t.hu.J_ = Nxe.bind(null, t.eventManager), t.hu.pu = Dxe.bind(null, t.eventManager), t;
}
function eEe(e) {
  const t = Gt(e);
  return t.remoteStore.remoteSyncer.applySuccessfulWrite = Kxe.bind(null, t), t.remoteStore.remoteSyncer.rejectFailedWrite = Yxe.bind(null, t), t;
}
class cS {
  constructor() {
    this.kind = "memory", this.synchronizeTabs = !1;
  }
  async initialize(t) {
    this.serializer = Jx(t.databaseInfo.databaseId), this.sharedClientState = this.bu(t), this.persistence = this.Du(t), await this.persistence.start(), this.localStore = this.vu(t), this.gcScheduler = this.Cu(t, this.localStore), this.indexBackfillerScheduler = this.Fu(t, this.localStore);
  }
  Cu(t, n) {
    return null;
  }
  Fu(t, n) {
    return null;
  }
  vu(t) {
    return rxe(this.persistence, new exe(), t.initialUser, this.serializer);
  }
  Du(t) {
    return new yG(QO.Vi, this.serializer);
  }
  bu(t) {
    return new uxe();
  }
  async terminate() {
    var t, n;
    (t = this.gcScheduler) === null || t === void 0 || t.stop(), (n = this.indexBackfillerScheduler) === null || n === void 0 || n.stop(), this.sharedClientState.shutdown(), await this.persistence.shutdown();
  }
}
cS.provider = {
  build: () => new cS()
};
class tEe extends cS {
  constructor(t) {
    super(), this.cacheSizeBytes = t;
  }
  Cu(t, n) {
    Fn(this.persistence.referenceDelegate instanceof aS, 46915);
    const r = this.persistence.referenceDelegate.garbageCollector;
    return new Fwe(r, t.asyncQueue, n);
  }
  Du(t) {
    const n = this.cacheSizeBytes !== void 0 ? Ko.withCacheSize(this.cacheSizeBytes) : Ko.DEFAULT;
    return new yG((r) => aS.Vi(r, n), this.serializer);
  }
}
class Q$ {
  async initialize(t, n) {
    this.localStore || (this.localStore = t.localStore, this.sharedClientState = t.sharedClientState, this.datastore = this.createDatastore(n), this.remoteStore = this.createRemoteStore(n), this.eventManager = this.createEventManager(n), this.syncEngine = this.createSyncEngine(
      n,
      /* startAsPrimary=*/
      !t.synchronizeTabs
    ), this.sharedClientState.onlineStateHandler = (r) => a8(
      this.syncEngine,
      r,
      1
      /* OnlineStateSource.SharedClientState */
    ), this.remoteStore.remoteSyncer.handleCredentialChange = Jxe.bind(null, this.syncEngine), await Oxe(this.remoteStore, this.syncEngine.isPrimaryClient));
  }
  createEventManager(t) {
    return function() {
      return new kxe();
    }();
  }
  createDatastore(t) {
    const n = Jx(t.databaseInfo.databaseId), r = function(o) {
      return new pxe(o);
    }(t.databaseInfo);
    return function(o, a, s, c) {
      return new bxe(o, a, s, c);
    }(t.authCredentials, t.appCheckCredentials, r, n);
  }
  createRemoteStore(t) {
    return function(r, i, o, a, s) {
      return new Sxe(r, i, o, a, s);
    }(this.localStore, this.datastore, t.asyncQueue, (n) => a8(
      this.syncEngine,
      n,
      0
      /* OnlineStateSource.RemoteStore */
    ), function() {
      return e8.C() ? new e8() : new dxe();
    }());
  }
  createSyncEngine(t, n) {
    return function(i, o, a, s, c, l, u) {
      const d = new Vxe(i, o, a, s, c, l);
      return u && (d.fu = !0), d;
    }(this.localStore, this.remoteStore, this.eventManager, this.sharedClientState, t.initialUser, t.maxConcurrentLimboResolutions, n);
  }
  async terminate() {
    var t, n;
    await async function(i) {
      const o = Gt(i);
      bt(gf, "RemoteStore shutting down."), o.Ia.add(
        5
        /* OfflineCause.Shutdown */
      ), await hy(o), o.Ea.shutdown(), // Set the OnlineState to Unknown (rather than Offline) to avoid potentially
      // triggering spurious listener events with cached data, etc.
      o.Aa.set(
        "Unknown"
        /* OnlineState.Unknown */
      );
    }(this.remoteStore), (t = this.datastore) === null || t === void 0 || t.terminate(), (n = this.eventManager) === null || n === void 0 || n.terminate();
  }
}
Q$.provider = {
  build: () => new Q$()
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class u6 {
  constructor(t) {
    this.observer = t, /**
     * When set to true, will not raise future events. Necessary to deal with
     * async detachment of listener.
     */
    this.muted = !1;
  }
  next(t) {
    this.muted || this.observer.next && this.xu(this.observer.next, t);
  }
  error(t) {
    this.muted || (this.observer.error ? this.xu(this.observer.error, t) : hl("Uncaught Error in snapshot listener:", t.toString()));
  }
  Ou() {
    this.muted = !0;
  }
  xu(t, n) {
    setTimeout(() => {
      this.muted || t(n);
    }, 0);
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Mu = "FirestoreClient";
class nEe {
  constructor(t, n, r, i, o) {
    this.authCredentials = t, this.appCheckCredentials = n, this.asyncQueue = r, this.databaseInfo = i, this.user = ao.UNAUTHENTICATED, this.clientId = BO.newId(), this.authCredentialListener = () => Promise.resolve(), this.appCheckCredentialListener = () => Promise.resolve(), this._uninitializedComponentsProvider = o, this.authCredentials.start(r, async (a) => {
      bt(Mu, "Received user=", a.uid), await this.authCredentialListener(a), this.user = a;
    }), this.appCheckCredentials.start(r, (a) => (bt(Mu, "Received new app check token=", a), this.appCheckCredentialListener(a, this.user)));
  }
  get configuration() {
    return {
      asyncQueue: this.asyncQueue,
      databaseInfo: this.databaseInfo,
      clientId: this.clientId,
      authCredentials: this.authCredentials,
      appCheckCredentials: this.appCheckCredentials,
      initialUser: this.user,
      maxConcurrentLimboResolutions: 100
    };
  }
  setCredentialChangeListener(t) {
    this.authCredentialListener = t;
  }
  setAppCheckTokenChangeListener(t) {
    this.appCheckCredentialListener = t;
  }
  terminate() {
    this.asyncQueue.enterRestrictedMode();
    const t = new _s();
    return this.asyncQueue.enqueueAndForgetEvenWhileRestricted(async () => {
      try {
        this._onlineComponents && await this._onlineComponents.terminate(), this._offlineComponents && await this._offlineComponents.terminate(), // The credentials provider must be terminated after shutting down the
        // RemoteStore as it will prevent the RemoteStore from retrieving auth
        // tokens.
        this.authCredentials.shutdown(), this.appCheckCredentials.shutdown(), t.resolve();
      } catch (n) {
        const r = tE(n, "Failed to shutdown persistence");
        t.reject(r);
      }
    }), t.promise;
  }
}
async function B5(e, t) {
  e.asyncQueue.verifyOperationInProgress(), bt(Mu, "Initializing OfflineComponentProvider");
  const n = e.configuration;
  await t.initialize(n);
  let r = n.initialUser;
  e.setCredentialChangeListener(async (i) => {
    r.isEqual(i) || (await bG(t.localStore, i), r = i);
  }), t.persistence.setDatabaseDeletedListener(() => {
    Iu("Terminating Firestore due to IndexedDb database deletion"), e.terminate().then(() => {
      bt("Terminating Firestore due to IndexedDb database deletion completed successfully");
    }).catch((i) => {
      Iu("Terminating Firestore due to IndexedDb database deletion failed", i);
    });
  }), e._offlineComponents = t;
}
async function c8(e, t) {
  e.asyncQueue.verifyOperationInProgress();
  const n = await rEe(e);
  bt(Mu, "Initializing OnlineComponentProvider"), await t.initialize(n, e.configuration), // The CredentialChangeListener of the online component provider takes
  // precedence over the offline component provider.
  e.setCredentialChangeListener((r) => n8(t.remoteStore, r)), e.setAppCheckTokenChangeListener((r, i) => n8(t.remoteStore, i)), e._onlineComponents = t;
}
async function rEe(e) {
  if (!e._offlineComponents)
    if (e._uninitializedComponentsProvider) {
      bt(Mu, "Using user provided OfflineComponentProvider");
      try {
        await B5(e, e._uninitializedComponentsProvider._offline);
      } catch (t) {
        const n = t;
        if (!function(i) {
          return i.name === "FirebaseError" ? i.code === we.FAILED_PRECONDITION || i.code === we.UNIMPLEMENTED : !(typeof DOMException < "u" && i instanceof DOMException) || // When the browser is out of quota we could get either quota exceeded
          // or an aborted error depending on whether the error happened during
          // schema migration.
          i.code === 22 || i.code === 20 || // Firefox Private Browsing mode disables IndexedDb and returns
          // INVALID_STATE for any usage.
          i.code === 11;
        }(n))
          throw n;
        Iu("Error using user provided cache. Falling back to memory cache: " + n), await B5(e, new cS());
      }
    } else
      bt(Mu, "Using default OfflineComponentProvider"), await B5(e, new tEe(void 0));
  return e._offlineComponents;
}
async function d6(e) {
  return e._onlineComponents || (e._uninitializedComponentsProvider ? (bt(Mu, "Using user provided OnlineComponentProvider"), await c8(e, e._uninitializedComponentsProvider._online)) : (bt(Mu, "Using default OnlineComponentProvider"), await c8(e, new Q$()))), e._onlineComponents;
}
function jG(e) {
  return d6(e).then((t) => t.syncEngine);
}
function iEe(e) {
  return d6(e).then((t) => t.datastore);
}
async function lS(e) {
  const t = await d6(e), n = t.eventManager;
  return n.onListen = Bxe.bind(null, t.syncEngine), n.onUnlisten = Uxe.bind(null, t.syncEngine), n.onFirstRemoteStoreListen = zxe.bind(null, t.syncEngine), n.onLastRemoteStoreUnlisten = Wxe.bind(null, t.syncEngine), n;
}
function LG(e, t, n = {}) {
  const r = new _s();
  return e.asyncQueue.enqueueAndForget(async () => function(o, a, s, c, l) {
    const u = new u6({
      next: (f) => {
        u.Ou(), a.enqueueAndForget(() => a6(o, d));
        const h = f.docs.has(s);
        !h && f.fromCache ? (
          // TODO(dimond): If we're online and the document doesn't
          // exist then we resolve with a doc.exists set to false. If
          // we're offline however, we reject the Promise in this
          // case. Two options: 1) Cache the negative response from
          // the server so we can deliver that even when you're
          // offline 2) Actually reject the Promise in the online case
          // if the document doesn't exist.
          l.reject(new Je(we.UNAVAILABLE, "Failed to get document because the client is offline."))
        ) : h && f.fromCache && c && c.source === "server" ? l.reject(new Je(we.UNAVAILABLE, 'Failed to get document from server. (However, this document does exist in the local cache. Run again without setting source to "server" to retrieve the cached document.)')) : l.resolve(f);
      },
      error: (f) => l.reject(f)
    }), d = new c6(qx(s.path), u, {
      includeMetadataChanges: !0,
      ka: !0
    });
    return o6(o, d);
  }(await lS(e), e.asyncQueue, t, n, r)), r.promise;
}
function oEe(e, t, n = {}) {
  const r = new _s();
  return e.asyncQueue.enqueueAndForget(async () => function(o, a, s, c, l) {
    const u = new u6({
      next: (f) => {
        u.Ou(), a.enqueueAndForget(() => a6(o, d)), f.fromCache && c.source === "server" ? l.reject(new Je(we.UNAVAILABLE, 'Failed to get documents from server. (However, these documents may exist in the local cache. Run again without setting source to "server" to retrieve the cached documents.)')) : l.resolve(f);
      },
      error: (f) => l.reject(f)
    }), d = new c6(s, u, {
      includeMetadataChanges: !0,
      ka: !0
    });
    return o6(o, d);
  }(await lS(e), e.asyncQueue, t, n, r)), r.promise;
}
function aEe(e, t, n) {
  const r = new _s();
  return e.asyncQueue.enqueueAndForget(async () => {
    try {
      const i = await iEe(e);
      r.resolve(async function(a, s, c) {
        var l;
        const u = Gt(a), { request: d, ft: f, parent: h } = Iwe(u.serializer, KSe(s), c);
        u.connection.Qo || delete d.parent;
        const p = (await u.Jo(
          "RunAggregationQuery",
          u.serializer.databaseId,
          h,
          d,
          /*expectedResponseCount=*/
          1
        )).filter((m) => !!m.result);
        Fn(p.length === 1, 64727);
        const g = (l = p[0].result) === null || l === void 0 ? void 0 : l.aggregateFields;
        return Object.keys(g).reduce((m, v) => (m[f[v]] = g[v], m), {});
      }(i, t, n));
    } catch (i) {
      r.reject(i);
    }
  }), r.promise;
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function FG(e) {
  const t = {};
  return e.timeoutSeconds !== void 0 && (t.timeoutSeconds = e.timeoutSeconds), t;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const l8 = /* @__PURE__ */ new Map();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const VG = "firestore.googleapis.com", u8 = !0;
class d8 {
  constructor(t) {
    var n, r;
    if (t.host === void 0) {
      if (t.ssl !== void 0)
        throw new Je(we.INVALID_ARGUMENT, "Can't provide ssl option if host option is not set");
      this.host = VG, this.ssl = u8;
    } else
      this.host = t.host, this.ssl = (n = t.ssl) !== null && n !== void 0 ? n : u8;
    if (this.isUsingEmulator = t.emulatorOptions !== void 0, this.credentials = t.credentials, this.ignoreUndefinedProperties = !!t.ignoreUndefinedProperties, this.localCache = t.localCache, t.cacheSizeBytes === void 0)
      this.cacheSizeBytes = mG;
    else {
      if (t.cacheSizeBytes !== -1 && t.cacheSizeBytes < vG)
        throw new Je(we.INVALID_ARGUMENT, "cacheSizeBytes must be at least 1048576");
      this.cacheSizeBytes = t.cacheSizeBytes;
    }
    wSe("experimentalForceLongPolling", t.experimentalForceLongPolling, "experimentalAutoDetectLongPolling", t.experimentalAutoDetectLongPolling), this.experimentalForceLongPolling = !!t.experimentalForceLongPolling, this.experimentalForceLongPolling ? this.experimentalAutoDetectLongPolling = !1 : t.experimentalAutoDetectLongPolling === void 0 ? this.experimentalAutoDetectLongPolling = !0 : (
      // For backwards compatibility, coerce the value to boolean even though
      // the TypeScript compiler has narrowed the type to boolean already.
      // noinspection PointlessBooleanExpressionJS
      this.experimentalAutoDetectLongPolling = !!t.experimentalAutoDetectLongPolling
    ), this.experimentalLongPollingOptions = FG((r = t.experimentalLongPollingOptions) !== null && r !== void 0 ? r : {}), function(o) {
      if (o.timeoutSeconds !== void 0) {
        if (isNaN(o.timeoutSeconds))
          throw new Je(we.INVALID_ARGUMENT, `invalid long polling timeout: ${o.timeoutSeconds} (must not be NaN)`);
        if (o.timeoutSeconds < 5)
          throw new Je(we.INVALID_ARGUMENT, `invalid long polling timeout: ${o.timeoutSeconds} (minimum allowed value is 5)`);
        if (o.timeoutSeconds > 30)
          throw new Je(we.INVALID_ARGUMENT, `invalid long polling timeout: ${o.timeoutSeconds} (maximum allowed value is 30)`);
      }
    }(this.experimentalLongPollingOptions), this.useFetchStreams = !!t.useFetchStreams;
  }
  isEqual(t) {
    return this.host === t.host && this.ssl === t.ssl && this.credentials === t.credentials && this.cacheSizeBytes === t.cacheSizeBytes && this.experimentalForceLongPolling === t.experimentalForceLongPolling && this.experimentalAutoDetectLongPolling === t.experimentalAutoDetectLongPolling && function(r, i) {
      return r.timeoutSeconds === i.timeoutSeconds;
    }(this.experimentalLongPollingOptions, t.experimentalLongPollingOptions) && this.ignoreUndefinedProperties === t.ignoreUndefinedProperties && this.useFetchStreams === t.useFetchStreams;
  }
}
class rE {
  /** @hideconstructor */
  constructor(t, n, r, i) {
    this._authCredentials = t, this._appCheckCredentials = n, this._databaseId = r, this._app = i, /**
     * Whether it's a Firestore or Firestore Lite instance.
     */
    this.type = "firestore-lite", this._persistenceKey = "(lite)", this._settings = new d8({}), this._settingsFrozen = !1, this._emulatorOptions = {}, // A task that is assigned when the terminate() is invoked and resolved when
    // all components have shut down. Otherwise, Firestore is not terminated,
    // which can mean either the FirestoreClient is in the process of starting,
    // or restarting.
    this._terminateTask = "notTerminated";
  }
  /**
   * The {@link @firebase/app#FirebaseApp} associated with this `Firestore` service
   * instance.
   */
  get app() {
    if (!this._app)
      throw new Je(we.FAILED_PRECONDITION, "Firestore was not initialized using the Firebase SDK. 'app' is not available");
    return this._app;
  }
  get _initialized() {
    return this._settingsFrozen;
  }
  get _terminated() {
    return this._terminateTask !== "notTerminated";
  }
  _setSettings(t) {
    if (this._settingsFrozen)
      throw new Je(we.FAILED_PRECONDITION, "Firestore has already been started and its settings can no longer be changed. You can only modify settings before calling any other methods on a Firestore object.");
    this._settings = new d8(t), this._emulatorOptions = t.emulatorOptions || {}, t.credentials !== void 0 && (this._authCredentials = function(r) {
      if (!r)
        return new hSe();
      switch (r.type) {
        case "firstParty":
          return new vSe(r.sessionIndex || "0", r.iamToken || null, r.authTokenFactory || null);
        case "provider":
          return r.client;
        default:
          throw new Je(we.INVALID_ARGUMENT, "makeAuthCredentialsProvider failed due to invalid credential type");
      }
    }(t.credentials));
  }
  _getSettings() {
    return this._settings;
  }
  _getEmulatorOptions() {
    return this._emulatorOptions;
  }
  _freezeSettings() {
    return this._settingsFrozen = !0, this._settings;
  }
  _delete() {
    return this._terminateTask === "notTerminated" && (this._terminateTask = this._terminate()), this._terminateTask;
  }
  async _restart() {
    this._terminateTask === "notTerminated" ? await this._terminate() : this._terminateTask = "notTerminated";
  }
  /** Returns a JSON-serializable representation of this `Firestore` instance. */
  toJSON() {
    return {
      app: this._app,
      databaseId: this._databaseId,
      settings: this._settings
    };
  }
  /**
   * Terminates all components used by this client. Subclasses can override
   * this method to clean up their own dependencies, but must also call this
   * method.
   *
   * Only ever called once.
   */
  _terminate() {
    return function(n) {
      const r = l8.get(n);
      r && (bt("ComponentProvider", "Removing Datastore"), l8.delete(n), r.terminate());
    }(this), Promise.resolve();
  }
}
function BG(e, t, n, r = {}) {
  var i;
  e = lo(e, rE);
  const o = Gu(t), a = e._getSettings(), s = Object.assign(Object.assign({}, a), {
    emulatorOptions: e._getEmulatorOptions()
  }), c = `${t}:${n}`;
  o && (Px(`https://${c}`), wO("Firestore", !0)), a.host !== VG && a.host !== c && Iu("Host has been set in both settings() and connectFirestoreEmulator(), emulator host will be used.");
  const l = Object.assign(Object.assign({}, a), {
    host: c,
    ssl: o,
    emulatorOptions: r
  });
  if (!ll(l, s) && (e._setSettings(l), r.mockUserToken)) {
    let u, d;
    if (typeof r.mockUserToken == "string")
      u = r.mockUserToken, d = ao.MOCK_USER;
    else {
      u = B0e(r.mockUserToken, (i = e._app) === null || i === void 0 ? void 0 : i.options.projectId);
      const f = r.mockUserToken.sub || r.mockUserToken.user_id;
      if (!f)
        throw new Je(we.INVALID_ARGUMENT, "mockUserToken must contain 'sub' or 'user_id' field!");
      d = new ao(f);
    }
    e._authCredentials = new gSe(new xq(u, d));
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Ns {
  // This is the lite version of the Query class in the main SDK.
  /** @hideconstructor protected */
  constructor(t, n, r) {
    this.converter = n, this._query = r, /** The type of this Firestore reference. */
    this.type = "query", this.firestore = t;
  }
  withConverter(t) {
    return new Ns(this.firestore, t, this._query);
  }
}
class jr {
  /** @hideconstructor */
  constructor(t, n, r) {
    this.converter = n, this._key = r, /** The type of this Firestore reference. */
    this.type = "document", this.firestore = t;
  }
  get _path() {
    return this._key.path;
  }
  /**
   * The document's identifier within its collection.
   */
  get id() {
    return this._key.path.lastSegment();
  }
  /**
   * A string representing the path of the referenced document (relative
   * to the root of the database).
   */
  get path() {
    return this._key.path.canonicalString();
  }
  /**
   * The collection this `DocumentReference` belongs to.
   */
  get parent() {
    return new pu(this.firestore, this.converter, this._key.path.popLast());
  }
  withConverter(t) {
    return new jr(this.firestore, t, this._key);
  }
  /**
   * Returns a JSON-serializable representation of this `DocumentReference` instance.
   *
   * @returns a JSON representation of this object.
   */
  toJSON() {
    return {
      type: jr._jsonSchemaVersion,
      referencePath: this._key.toString()
    };
  }
  static fromJSON(t, n, r) {
    if (uy(n, jr._jsonSchema))
      return new jr(t, r || null, new kt(or.fromString(n.referencePath)));
  }
}
jr._jsonSchemaVersion = "firestore/documentReference/1.0", jr._jsonSchema = {
  type: ui("string", jr._jsonSchemaVersion),
  referencePath: ui("string")
};
class pu extends Ns {
  /** @hideconstructor */
  constructor(t, n, r) {
    super(t, n, qx(r)), this._path = r, /** The type of this Firestore reference. */
    this.type = "collection";
  }
  /** The collection's identifier. */
  get id() {
    return this._query.path.lastSegment();
  }
  /**
   * A string representing the path of the referenced collection (relative
   * to the root of the database).
   */
  get path() {
    return this._query.path.canonicalString();
  }
  /**
   * A reference to the containing `DocumentReference` if this is a
   * subcollection. If this isn't a subcollection, the reference is null.
   */
  get parent() {
    const t = this._path.popLast();
    return t.isEmpty() ? null : new jr(
      this.firestore,
      /* converter= */
      null,
      new kt(t)
    );
  }
  withConverter(t) {
    return new pu(this.firestore, t, this._path);
  }
}
function gh(e, t, ...n) {
  if (e = Or(e), Cq("collection", "path", t), e instanceof rE) {
    const r = or.fromString(t, ...n);
    return CD(r), new pu(
      e,
      /* converter= */
      null,
      r
    );
  }
  {
    if (!(e instanceof jr || e instanceof pu))
      throw new Je(we.INVALID_ARGUMENT, "Expected first argument to collection() to be a CollectionReference, a DocumentReference or FirebaseFirestore");
    const r = e._path.child(or.fromString(t, ...n));
    return CD(r), new pu(
      e.firestore,
      /* converter= */
      null,
      r
    );
  }
}
function z5(e, t, ...n) {
  if (e = Or(e), // We allow omission of 'pathString' but explicitly prohibit passing in both
  // 'undefined' and 'null'.
  arguments.length === 1 && (t = BO.newId()), Cq("doc", "path", t), e instanceof rE) {
    const r = or.fromString(t, ...n);
    return ED(r), new jr(
      e,
      /* converter= */
      null,
      new kt(r)
    );
  }
  {
    if (!(e instanceof jr || e instanceof pu))
      throw new Je(we.INVALID_ARGUMENT, "Expected first argument to collection() to be a CollectionReference, a DocumentReference or FirebaseFirestore");
    const r = e._path.child(or.fromString(t, ...n));
    return ED(r), new jr(e.firestore, e instanceof pu ? e.converter : null, new kt(r));
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const f8 = "AsyncQueue";
class h8 {
  constructor(t = Promise.resolve()) {
    this.Zu = [], // Is this AsyncQueue being shut down? Once it is set to true, it will not
    // be changed again.
    this.Xu = !1, // Operations scheduled to be queued in the future. Operations are
    // automatically removed after they are run or canceled.
    this.ec = [], // visible for testing
    this.tc = null, // Flag set while there's an outstanding AsyncQueue operation, used for
    // assertion sanity-checks.
    this.nc = !1, // Enabled during shutdown on Safari to prevent future access to IndexedDB.
    this.rc = !1, // List of TimerIds to fast-forward delays for.
    this.sc = [], // Backoff timer used to schedule retries for retryable operations
    this.F_ = new SG(
      this,
      "async_queue_retry"
      /* TimerId.AsyncQueueRetry */
    ), // Visibility handler that triggers an immediate retry of all retryable
    // operations. Meant to speed up recovery when we regain file system access
    // after page comes into foreground.
    this.oc = () => {
      const r = V5();
      r && bt(f8, "Visibility state changed to " + r.visibilityState), this.F_.y_();
    }, this._c = t;
    const n = V5();
    n && typeof n.addEventListener == "function" && n.addEventListener("visibilitychange", this.oc);
  }
  get isShuttingDown() {
    return this.Xu;
  }
  /**
   * Adds a new operation to the queue without waiting for it to complete (i.e.
   * we ignore the Promise result).
   */
  enqueueAndForget(t) {
    this.enqueue(t);
  }
  enqueueAndForgetEvenWhileRestricted(t) {
    this.ac(), // eslint-disable-next-line @typescript-eslint/no-floating-promises
    this.uc(t);
  }
  enterRestrictedMode(t) {
    if (!this.Xu) {
      this.Xu = !0, this.rc = t || !1;
      const n = V5();
      n && typeof n.removeEventListener == "function" && n.removeEventListener("visibilitychange", this.oc);
    }
  }
  enqueue(t) {
    if (this.ac(), this.Xu)
      return new Promise(() => {
      });
    const n = new _s();
    return this.uc(() => this.Xu && this.rc ? Promise.resolve() : (t().then(n.resolve, n.reject), n.promise)).then(() => n.promise);
  }
  enqueueRetryable(t) {
    this.enqueueAndForget(() => (this.Zu.push(t), this.cc()));
  }
  /**
   * Runs the next operation from the retryable queue. If the operation fails,
   * reschedules with backoff.
   */
  async cc() {
    if (this.Zu.length !== 0) {
      try {
        await this.Zu[0](), this.Zu.shift(), this.F_.reset();
      } catch (t) {
        if (!jp(t))
          throw t;
        bt(f8, "Operation failed with retryable error: " + t);
      }
      this.Zu.length > 0 && // If there are additional operations, we re-schedule `retryNextOp()`.
      // This is necessary to run retryable operations that failed during
      // their initial attempt since we don't know whether they are already
      // enqueued. If, for example, `op1`, `op2`, `op3` are enqueued and `op1`
      // needs to  be re-run, we will run `op1`, `op1`, `op2` using the
      // already enqueued calls to `retryNextOp()`. `op3()` will then run in the
      // call scheduled here.
      // Since `backoffAndRun()` cancels an existing backoff and schedules a
      // new backoff on every call, there is only ever a single additional
      // operation in the queue.
      this.F_.g_(() => this.cc());
    }
  }
  uc(t) {
    const n = this._c.then(() => (this.nc = !0, t().catch((r) => {
      throw this.tc = r, this.nc = !1, hl("INTERNAL UNHANDLED ERROR: ", g8(r)), r;
    }).then((r) => (this.nc = !1, r))));
    return this._c = n, n;
  }
  enqueueAfterDelay(t, n, r) {
    this.ac(), // Fast-forward delays for timerIds that have been overridden.
    this.sc.indexOf(t) > -1 && (n = 0);
    const i = i6.createAndSchedule(this, t, n, r, (o) => this.lc(o));
    return this.ec.push(i), i;
  }
  ac() {
    this.tc && qt(47125, {
      hc: g8(this.tc)
    });
  }
  verifyOperationInProgress() {
  }
  /**
   * Waits until all currently queued tasks are finished executing. Delayed
   * operations are not run.
   */
  async Pc() {
    let t;
    do
      t = this._c, await t;
    while (t !== this._c);
  }
  /**
   * For Tests: Determine if a delayed operation with a particular TimerId
   * exists.
   */
  Tc(t) {
    for (const n of this.ec)
      if (n.timerId === t)
        return !0;
    return !1;
  }
  /**
   * For Tests: Runs some or all delayed operations early.
   *
   * @param lastTimerId - Delayed operations up to and including this TimerId
   * will be drained. Pass TimerId.All to run all delayed operations.
   * @returns a Promise that resolves once all operations have been run.
   */
  Ic(t) {
    return this.Pc().then(() => {
      this.ec.sort((n, r) => n.targetTimeMs - r.targetTimeMs);
      for (const n of this.ec)
        if (n.skipDelay(), t !== "all" && n.timerId === t)
          break;
      return this.Pc();
    });
  }
  /**
   * For Tests: Skip all subsequent delays for a timer id.
   */
  dc(t) {
    this.sc.push(t);
  }
  /** Called once a DelayedOperation is run or canceled. */
  lc(t) {
    const n = this.ec.indexOf(t);
    this.ec.splice(n, 1);
  }
}
function g8(e) {
  let t = e.message || "";
  return e.stack && (t = e.stack.includes(e.message) ? e.stack : e.message + `
` + e.stack), t;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function p8(e) {
  return function(n, r) {
    if (typeof n != "object" || n === null)
      return !1;
    const i = n;
    for (const o of r)
      if (o in i && typeof i[o] == "function")
        return !0;
    return !1;
  }(e, ["next", "error", "complete"]);
}
class Sc extends rE {
  /** @hideconstructor */
  constructor(t, n, r, i) {
    super(t, n, r, i), /**
     * Whether it's a {@link Firestore} or Firestore Lite instance.
     */
    this.type = "firestore", this._queue = new h8(), this._persistenceKey = (i == null ? void 0 : i.name) || "[DEFAULT]";
  }
  async _terminate() {
    if (this._firestoreClient) {
      const t = this._firestoreClient.terminate();
      this._queue = new h8(t), this._firestoreClient = void 0, await t;
    }
  }
}
function sEe(e, t, n) {
  n || (n = lv);
  const r = xl(e, "firestore");
  if (r.isInitialized(n)) {
    const i = r.getImmediate({
      identifier: n
    }), o = r.getOptions(n);
    if (ll(o, t))
      return i;
    throw new Je(we.FAILED_PRECONDITION, "initializeFirestore() has already been called with different options. To avoid this error, call initializeFirestore() with the same options as when it was originally called, or call getFirestore() to return the already initialized instance.");
  }
  if (t.cacheSizeBytes !== void 0 && t.localCache !== void 0)
    throw new Je(we.INVALID_ARGUMENT, "cache and cacheSizeBytes cannot be specified at the same time as cacheSizeBytes willbe deprecated. Instead, specify the cache size in the cache object");
  if (t.cacheSizeBytes !== void 0 && t.cacheSizeBytes !== -1 && t.cacheSizeBytes < vG)
    throw new Je(we.INVALID_ARGUMENT, "cacheSizeBytes must be at least 1048576");
  return t.host && Gu(t.host) && Px(t.host), r.initialize({
    options: t,
    instanceIdentifier: n
  });
}
function cEe(e, t) {
  const n = typeof e == "object" ? e : Mx(), r = typeof e == "string" ? e : t || lv, i = xl(n, "firestore").getImmediate({
    identifier: r
  });
  if (!i._initialized) {
    const o = XU("firestore");
    o && BG(i, ...o);
  }
  return i;
}
function Bf(e) {
  if (e._terminated)
    throw new Je(we.FAILED_PRECONDITION, "The client has already been terminated.");
  return e._firestoreClient || lEe(e), e._firestoreClient;
}
function lEe(e) {
  var t, n, r;
  const i = e._freezeSettings(), o = function(s, c, l, u) {
    return new kSe(s, c, l, u.host, u.ssl, u.experimentalForceLongPolling, u.experimentalAutoDetectLongPolling, FG(u.experimentalLongPollingOptions), u.useFetchStreams, u.isUsingEmulator);
  }(e._databaseId, ((t = e._app) === null || t === void 0 ? void 0 : t.options.appId) || "", e._persistenceKey, i);
  e._componentsProvider || !((n = i.localCache) === null || n === void 0) && n._offlineComponentProvider && (!((r = i.localCache) === null || r === void 0) && r._onlineComponentProvider) && (e._componentsProvider = {
    _offline: i.localCache._offlineComponentProvider,
    _online: i.localCache._onlineComponentProvider
  }), e._firestoreClient = new nEe(e._authCredentials, e._appCheckCredentials, e._queue, o, e._componentsProvider && function(s) {
    const c = s == null ? void 0 : s._online.build();
    return {
      _offline: s == null ? void 0 : s._offline.build(c),
      _online: c
    };
  }(e._componentsProvider));
}
function uEe(e) {
  return function(n) {
    const r = new _s();
    return n.asyncQueue.enqueueAndForget(async () => Xxe(await jG(n), r)), r.promise;
  }(Bf(e = lo(e, Sc)));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class dEe {
  /**
   * Create a new AggregateField<T>
   * @param aggregateType Specifies the type of aggregation operation to perform.
   * @param _internalFieldPath Optionally specifies the field that is aggregated.
   * @internal
   */
  constructor(t = "count", n) {
    this._internalFieldPath = n, /** A type string to uniquely identify instances of this class. */
    this.type = "AggregateField", this.aggregateType = t;
  }
}
class fEe {
  /** @hideconstructor */
  constructor(t, n, r) {
    this._userDataWriter = n, this._data = r, /** A type string to uniquely identify instances of this class. */
    this.type = "AggregateQuerySnapshot", this.query = t;
  }
  /**
   * Returns the results of the aggregations performed over the underlying
   * query.
   *
   * The keys of the returned object will be the same as those of the
   * `AggregateSpec` object specified to the aggregation method, and the values
   * will be the corresponding aggregation result.
   *
   * @returns The results of the aggregations performed over the underlying
   * query.
   */
  data() {
    return this._userDataWriter.convertObjectMap(this._data);
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Va {
  /** @hideconstructor */
  constructor(t) {
    this._byteString = t;
  }
  /**
   * Creates a new `Bytes` object from the given Base64 string, converting it to
   * bytes.
   *
   * @param base64 - The Base64 string used to create the `Bytes` object.
   */
  static fromBase64String(t) {
    try {
      return new Va(Wi.fromBase64String(t));
    } catch (n) {
      throw new Je(we.INVALID_ARGUMENT, "Failed to construct data from Base64 string: " + n);
    }
  }
  /**
   * Creates a new `Bytes` object from the given Uint8Array.
   *
   * @param array - The Uint8Array used to create the `Bytes` object.
   */
  static fromUint8Array(t) {
    return new Va(Wi.fromUint8Array(t));
  }
  /**
   * Returns the underlying bytes as a Base64-encoded string.
   *
   * @returns The Base64-encoded string created from the `Bytes` object.
   */
  toBase64() {
    return this._byteString.toBase64();
  }
  /**
   * Returns the underlying bytes in a new `Uint8Array`.
   *
   * @returns The Uint8Array created from the `Bytes` object.
   */
  toUint8Array() {
    return this._byteString.toUint8Array();
  }
  /**
   * Returns a string representation of the `Bytes` object.
   *
   * @returns A string representation of the `Bytes` object.
   */
  toString() {
    return "Bytes(base64: " + this.toBase64() + ")";
  }
  /**
   * Returns true if this `Bytes` object is equal to the provided one.
   *
   * @param other - The `Bytes` object to compare against.
   * @returns true if this `Bytes` object is equal to the provided one.
   */
  isEqual(t) {
    return this._byteString.isEqual(t._byteString);
  }
  /**
   * Returns a JSON-serializable representation of this `Bytes` instance.
   *
   * @returns a JSON representation of this object.
   */
  toJSON() {
    return {
      type: Va._jsonSchemaVersion,
      bytes: this.toBase64()
    };
  }
  /**
   * Builds a `Bytes` instance from a JSON object created by {@link Bytes.toJSON}.
   *
   * @param json a JSON object represention of a `Bytes` instance
   * @returns an instance of {@link Bytes} if the JSON object could be parsed. Throws a
   * {@link FirestoreError} if an error occurs.
   */
  static fromJSON(t) {
    if (uy(t, Va._jsonSchema))
      return Va.fromBase64String(t.bytes);
  }
}
Va._jsonSchemaVersion = "firestore/bytes/1.0", Va._jsonSchema = {
  type: ui("string", Va._jsonSchemaVersion),
  bytes: ui("string")
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class iE {
  /**
   * Creates a `FieldPath` from the provided field names. If more than one field
   * name is provided, the path will point to a nested field in a document.
   *
   * @param fieldNames - A list of field names.
   */
  constructor(...t) {
    for (let n = 0; n < t.length; ++n)
      if (t[n].length === 0)
        throw new Je(we.INVALID_ARGUMENT, "Invalid field name at argument $(i + 1). Field names must not be empty.");
    this._internalPath = new zi(t);
  }
  /**
   * Returns true if this `FieldPath` is equal to the provided one.
   *
   * @param other - The `FieldPath` to compare against.
   * @returns true if this `FieldPath` is equal to the provided one.
   */
  isEqual(t) {
    return this._internalPath.isEqual(t._internalPath);
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class f6 {
  /**
   * @param _methodName - The public API endpoint that returns this class.
   * @hideconstructor
   */
  constructor(t) {
    this._methodName = t;
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class hc {
  /**
   * Creates a new immutable `GeoPoint` object with the provided latitude and
   * longitude values.
   * @param latitude - The latitude as number between -90 and 90.
   * @param longitude - The longitude as number between -180 and 180.
   */
  constructor(t, n) {
    if (!isFinite(t) || t < -90 || t > 90)
      throw new Je(we.INVALID_ARGUMENT, "Latitude must be a number between -90 and 90, but was: " + t);
    if (!isFinite(n) || n < -180 || n > 180)
      throw new Je(we.INVALID_ARGUMENT, "Longitude must be a number between -180 and 180, but was: " + n);
    this._lat = t, this._long = n;
  }
  /**
   * The latitude of this `GeoPoint` instance.
   */
  get latitude() {
    return this._lat;
  }
  /**
   * The longitude of this `GeoPoint` instance.
   */
  get longitude() {
    return this._long;
  }
  /**
   * Returns true if this `GeoPoint` is equal to the provided one.
   *
   * @param other - The `GeoPoint` to compare against.
   * @returns true if this `GeoPoint` is equal to the provided one.
   */
  isEqual(t) {
    return this._lat === t._lat && this._long === t._long;
  }
  /**
   * Actually private to JS consumers of our API, so this function is prefixed
   * with an underscore.
   */
  _compareTo(t) {
    return gn(this._lat, t._lat) || gn(this._long, t._long);
  }
  /**
   * Returns a JSON-serializable representation of this `GeoPoint` instance.
   *
   * @returns a JSON representation of this object.
   */
  toJSON() {
    return {
      latitude: this._lat,
      longitude: this._long,
      type: hc._jsonSchemaVersion
    };
  }
  /**
   * Builds a `GeoPoint` instance from a JSON object created by {@link GeoPoint.toJSON}.
   *
   * @param json a JSON object represention of a `GeoPoint` instance
   * @returns an instance of {@link GeoPoint} if the JSON object could be parsed. Throws a
   * {@link FirestoreError} if an error occurs.
   */
  static fromJSON(t) {
    if (uy(t, hc._jsonSchema))
      return new hc(t.latitude, t.longitude);
  }
}
hc._jsonSchemaVersion = "firestore/geoPoint/1.0", hc._jsonSchema = {
  type: ui("string", hc._jsonSchemaVersion),
  latitude: ui("number"),
  longitude: ui("number")
};
/**
 * @license
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class gc {
  /**
   * @private
   * @internal
   */
  constructor(t) {
    this._values = (t || []).map((n) => n);
  }
  /**
   * Returns a copy of the raw number array form of the vector.
   */
  toArray() {
    return this._values.map((t) => t);
  }
  /**
   * Returns `true` if the two `VectorValue` values have the same raw number arrays, returns `false` otherwise.
   */
  isEqual(t) {
    return function(r, i) {
      if (r.length !== i.length)
        return !1;
      for (let o = 0; o < r.length; ++o)
        if (r[o] !== i[o])
          return !1;
      return !0;
    }(this._values, t._values);
  }
  /**
   * Returns a JSON-serializable representation of this `VectorValue` instance.
   *
   * @returns a JSON representation of this object.
   */
  toJSON() {
    return {
      type: gc._jsonSchemaVersion,
      vectorValues: this._values
    };
  }
  /**
   * Builds a `VectorValue` instance from a JSON object created by {@link VectorValue.toJSON}.
   *
   * @param json a JSON object represention of a `VectorValue` instance.
   * @returns an instance of {@link VectorValue} if the JSON object could be parsed. Throws a
   * {@link FirestoreError} if an error occurs.
   */
  static fromJSON(t) {
    if (uy(t, gc._jsonSchema)) {
      if (Array.isArray(t.vectorValues) && t.vectorValues.every((n) => typeof n == "number"))
        return new gc(t.vectorValues);
      throw new Je(we.INVALID_ARGUMENT, "Expected 'vectorValues' field to be a number array");
    }
  }
}
gc._jsonSchemaVersion = "firestore/vectorValue/1.0", gc._jsonSchema = {
  type: ui("string", gc._jsonSchemaVersion),
  vectorValues: ui("object")
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const hEe = /^__.*__$/;
class gEe {
  constructor(t, n, r) {
    this.data = t, this.fieldMask = n, this.fieldTransforms = r;
  }
  toMutation(t, n) {
    return this.fieldMask !== null ? new Ju(t, this.data, this.fieldMask, n, this.fieldTransforms) : new dy(t, this.data, n, this.fieldTransforms);
  }
}
class zG {
  constructor(t, n, r) {
    this.data = t, this.fieldMask = n, this.fieldTransforms = r;
  }
  toMutation(t, n) {
    return new Ju(t, this.data, this.fieldMask, n, this.fieldTransforms);
  }
}
function HG(e) {
  switch (e) {
    case 0:
    case 2:
    case 1:
      return !0;
    case 3:
    case 4:
      return !1;
    default:
      throw qt(40011, {
        Ec: e
      });
  }
}
class h6 {
  /**
   * Initializes a ParseContext with the given source and path.
   *
   * @param settings - The settings for the parser.
   * @param databaseId - The database ID of the Firestore instance.
   * @param serializer - The serializer to use to generate the Value proto.
   * @param ignoreUndefinedProperties - Whether to ignore undefined properties
   * rather than throw.
   * @param fieldTransforms - A mutable list of field transforms encountered
   * while parsing the data.
   * @param fieldMask - A mutable list of field paths encountered while parsing
   * the data.
   *
   * TODO(b/34871131): We don't support array paths right now, so path can be
   * null to indicate the context represents any location within an array (in
   * which case certain features will not work and errors will be somewhat
   * compromised).
   */
  constructor(t, n, r, i, o, a) {
    this.settings = t, this.databaseId = n, this.serializer = r, this.ignoreUndefinedProperties = i, // Minor hack: If fieldTransforms is undefined, we assume this is an
    // external call and we need to validate the entire path.
    o === void 0 && this.Ac(), this.fieldTransforms = o || [], this.fieldMask = a || [];
  }
  get path() {
    return this.settings.path;
  }
  get Ec() {
    return this.settings.Ec;
  }
  /** Returns a new context with the specified settings overwritten. */
  Rc(t) {
    return new h6(Object.assign(Object.assign({}, this.settings), t), this.databaseId, this.serializer, this.ignoreUndefinedProperties, this.fieldTransforms, this.fieldMask);
  }
  Vc(t) {
    var n;
    const r = (n = this.path) === null || n === void 0 ? void 0 : n.child(t), i = this.Rc({
      path: r,
      mc: !1
    });
    return i.fc(t), i;
  }
  gc(t) {
    var n;
    const r = (n = this.path) === null || n === void 0 ? void 0 : n.child(t), i = this.Rc({
      path: r,
      mc: !1
    });
    return i.Ac(), i;
  }
  yc(t) {
    return this.Rc({
      path: void 0,
      mc: !0
    });
  }
  wc(t) {
    return uS(t, this.settings.methodName, this.settings.Sc || !1, this.path, this.settings.bc);
  }
  /** Returns 'true' if 'fieldPath' was traversed when creating this context. */
  contains(t) {
    return this.fieldMask.find((n) => t.isPrefixOf(n)) !== void 0 || this.fieldTransforms.find((n) => t.isPrefixOf(n.field)) !== void 0;
  }
  Ac() {
    if (this.path)
      for (let t = 0; t < this.path.length; t++)
        this.fc(this.path.get(t));
  }
  fc(t) {
    if (t.length === 0)
      throw this.wc("Document fields must not be empty");
    if (HG(this.Ec) && hEe.test(t))
      throw this.wc('Document fields cannot begin and end with "__"');
  }
}
class pEe {
  constructor(t, n, r) {
    this.databaseId = t, this.ignoreUndefinedProperties = n, this.serializer = r || Jx(t);
  }
  /** Creates a new top-level parse context. */
  Dc(t, n, r, i = !1) {
    return new h6({
      Ec: t,
      methodName: n,
      bc: r,
      path: zi.emptyPath(),
      mc: !1,
      Sc: i
    }, this.databaseId, this.serializer, this.ignoreUndefinedProperties);
  }
}
function oE(e) {
  const t = e._freezeSettings(), n = Jx(e._databaseId);
  return new pEe(e._databaseId, !!t.ignoreUndefinedProperties, n);
}
function mEe(e, t, n, r, i, o = {}) {
  const a = e.Dc(o.merge || o.mergeFields ? 2 : 0, t, n, i);
  g6("Data must be an object, but it was:", a, r);
  const s = WG(r, a);
  let c, l;
  if (o.merge)
    c = new va(a.fieldMask), l = a.fieldTransforms;
  else if (o.mergeFields) {
    const u = [];
    for (const d of o.mergeFields) {
      const f = J$(t, d, n);
      if (!a.contains(f))
        throw new Je(we.INVALID_ARGUMENT, `Field '${f}' is specified in your field mask but missing from your input data.`);
      GG(u, f) || u.push(f);
    }
    c = new va(u), l = a.fieldTransforms.filter((d) => c.covers(d.field));
  } else
    c = null, l = a.fieldTransforms;
  return new gEe(new Jo(s), c, l);
}
class py extends f6 {
  _toFieldTransform(t) {
    if (t.Ec !== 2)
      throw t.Ec === 1 ? t.wc(`${this._methodName}() can only appear at the top level of your update data`) : t.wc(`${this._methodName}() cannot be used with set() unless you pass {merge:true}`);
    return t.fieldMask.push(t.path), null;
  }
  isEqual(t) {
    return t instanceof py;
  }
}
function vEe(e, t, n, r) {
  const i = e.Dc(1, t, n);
  g6("Data must be an object, but it was:", i, r);
  const o = [], a = Jo.empty();
  Xu(r, (c, l) => {
    const u = p6(t, c, n);
    l = Or(l);
    const d = i.gc(u);
    if (l instanceof py)
      o.push(u);
    else {
      const f = my(l, d);
      f != null && (o.push(u), a.set(u, f));
    }
  });
  const s = new va(o);
  return new zG(a, s, i.fieldTransforms);
}
function yEe(e, t, n, r, i, o) {
  const a = e.Dc(1, t, n), s = [J$(t, r, n)], c = [i];
  if (o.length % 2 != 0)
    throw new Je(we.INVALID_ARGUMENT, `Function ${t}() needs to be called with an even number of arguments that alternate between field names and values.`);
  for (let f = 0; f < o.length; f += 2)
    s.push(J$(t, o[f])), c.push(o[f + 1]);
  const l = [], u = Jo.empty();
  for (let f = s.length - 1; f >= 0; --f)
    if (!GG(l, s[f])) {
      const h = s[f];
      let p = c[f];
      p = Or(p);
      const g = a.gc(h);
      if (p instanceof py)
        l.push(h);
      else {
        const m = my(p, g);
        m != null && (l.push(h), u.set(h, m));
      }
    }
  const d = new va(l);
  return new zG(u, d, a.fieldTransforms);
}
function UG(e, t, n, r = !1) {
  return my(n, e.Dc(r ? 4 : 3, t));
}
function my(e, t) {
  if (qG(
    // Unwrap the API type from the Compat SDK. This will return the API type
    // from firestore-exp.
    e = Or(e)
  ))
    return g6("Unsupported field value:", t, e), WG(e, t);
  if (e instanceof f6)
    return function(r, i) {
      if (!HG(i.Ec))
        throw i.wc(`${r._methodName}() can only be used with update() and set()`);
      if (!i.path)
        throw i.wc(`${r._methodName}() is not currently supported inside arrays`);
      const o = r._toFieldTransform(i);
      o && i.fieldTransforms.push(o);
    }(e, t), null;
  if (e === void 0 && t.ignoreUndefinedProperties)
    return null;
  if (
    // If context.path is null we are inside an array and we don't support
    // field mask paths more granular than the top-level array.
    t.path && t.fieldMask.push(t.path), e instanceof Array
  ) {
    if (t.settings.mc && t.Ec !== 4)
      throw t.wc("Nested arrays are not supported");
    return function(r, i) {
      const o = [];
      let a = 0;
      for (const s of r) {
        let c = my(s, i.yc(a));
        c == null && // Just include nulls in the array for fields being replaced with a
        // sentinel.
        (c = {
          nullValue: "NULL_VALUE"
        }), o.push(c), a++;
      }
      return {
        arrayValue: {
          values: o
        }
      };
    }(e, t);
  }
  return function(r, i) {
    if ((r = Or(r)) === null)
      return {
        nullValue: "NULL_VALUE"
      };
    if (typeof r == "number")
      return nwe(i.serializer, r);
    if (typeof r == "boolean")
      return {
        booleanValue: r
      };
    if (typeof r == "string")
      return {
        stringValue: r
      };
    if (r instanceof Date) {
      const o = jn.fromDate(r);
      return {
        timestampValue: oS(i.serializer, o)
      };
    }
    if (r instanceof jn) {
      const o = new jn(r.seconds, 1e3 * Math.floor(r.nanoseconds / 1e3));
      return {
        timestampValue: oS(i.serializer, o)
      };
    }
    if (r instanceof hc)
      return {
        geoPointValue: {
          latitude: r.latitude,
          longitude: r.longitude
        }
      };
    if (r instanceof Va)
      return {
        bytesValue: cG(i.serializer, r._byteString)
      };
    if (r instanceof jr) {
      const o = i.databaseId, a = r.firestore._databaseId;
      if (!a.isEqual(o))
        throw i.wc(`Document reference is for database ${a.projectId}/${a.database} but should be for database ${o.projectId}/${o.database}`);
      return {
        referenceValue: YO(r.firestore._databaseId || i.databaseId, r._key.path)
      };
    }
    if (r instanceof gc)
      return function(a, s) {
        return {
          mapValue: {
            fields: {
              [Nq]: {
                stringValue: jq
              },
              [eS]: {
                arrayValue: {
                  values: a.toArray().map((l) => {
                    if (typeof l != "number")
                      throw s.wc("VectorValues must only contain numeric values.");
                    return qO(s.serializer, l);
                  })
                }
              }
            }
          }
        };
      }(r, i);
    throw i.wc(`Unsupported field value: ${Vx(r)}`);
  }(e, t);
}
function WG(e, t) {
  const n = {};
  return Aq(e) ? (
    // If we encounter an empty object, we explicitly add it to the update
    // mask to ensure that the server creates a map entry.
    t.path && t.path.length > 0 && t.fieldMask.push(t.path)
  ) : Xu(e, (r, i) => {
    const o = my(i, t.Vc(r));
    o != null && (n[r] = o);
  }), {
    mapValue: {
      fields: n
    }
  };
}
function qG(e) {
  return !(typeof e != "object" || e === null || e instanceof Array || e instanceof Date || e instanceof jn || e instanceof hc || e instanceof Va || e instanceof jr || e instanceof f6 || e instanceof gc);
}
function g6(e, t, n) {
  if (!qG(n) || !Tq(n)) {
    const r = Vx(n);
    throw r === "an object" ? t.wc(e + " a custom object") : t.wc(e + " " + r);
  }
}
function J$(e, t, n) {
  if (
    // If required, replace the FieldPath Compat class with the firestore-exp
    // FieldPath.
    (t = Or(t)) instanceof iE
  )
    return t._internalPath;
  if (typeof t == "string")
    return p6(e, t);
  throw uS(
    "Field path arguments must be of type string or ",
    e,
    /* hasConverter= */
    !1,
    /* path= */
    void 0,
    n
  );
}
const bEe = new RegExp("[~\\*/\\[\\]]");
function p6(e, t, n) {
  if (t.search(bEe) >= 0)
    throw uS(
      `Invalid field path (${t}). Paths must not contain '~', '*', '/', '[', or ']'`,
      e,
      /* hasConverter= */
      !1,
      /* path= */
      void 0,
      n
    );
  try {
    return new iE(...t.split("."))._internalPath;
  } catch {
    throw uS(
      `Invalid field path (${t}). Paths must not be empty, begin with '.', end with '.', or contain '..'`,
      e,
      /* hasConverter= */
      !1,
      /* path= */
      void 0,
      n
    );
  }
}
function uS(e, t, n, r, i) {
  const o = r && !r.isEmpty(), a = i !== void 0;
  let s = `Function ${t}() called with invalid data`;
  n && (s += " (via `toFirestore()`)"), s += ". ";
  let c = "";
  return (o || a) && (c += " (found", o && (c += ` in field ${r}`), a && (c += ` in document ${i}`), c += ")"), new Je(we.INVALID_ARGUMENT, s + e + c);
}
function GG(e, t) {
  return e.some((n) => n.isEqual(t));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class m6 {
  // Note: This class is stripped down version of the DocumentSnapshot in
  // the legacy SDK. The changes are:
  // - No support for SnapshotMetadata.
  // - No support for SnapshotOptions.
  /** @hideconstructor protected */
  constructor(t, n, r, i, o) {
    this._firestore = t, this._userDataWriter = n, this._key = r, this._document = i, this._converter = o;
  }
  /** Property of the `DocumentSnapshot` that provides the document's ID. */
  get id() {
    return this._key.path.lastSegment();
  }
  /**
   * The `DocumentReference` for the document included in the `DocumentSnapshot`.
   */
  get ref() {
    return new jr(this._firestore, this._converter, this._key);
  }
  /**
   * Signals whether or not the document at the snapshot's location exists.
   *
   * @returns true if the document exists.
   */
  exists() {
    return this._document !== null;
  }
  /**
   * Retrieves all fields in the document as an `Object`. Returns `undefined` if
   * the document doesn't exist.
   *
   * @returns An `Object` containing all fields in the document or `undefined`
   * if the document doesn't exist.
   */
  data() {
    if (this._document) {
      if (this._converter) {
        const t = new _Ee(
          this._firestore,
          this._userDataWriter,
          this._key,
          this._document,
          /* converter= */
          null
        );
        return this._converter.fromFirestore(t);
      }
      return this._userDataWriter.convertValue(this._document.data.value);
    }
  }
  /**
   * Retrieves the field specified by `fieldPath`. Returns `undefined` if the
   * document or field doesn't exist.
   *
   * @param fieldPath - The path (for example 'foo' or 'foo.bar') to a specific
   * field.
   * @returns The data at the specified field location or undefined if no such
   * field exists in the document.
   */
  // We are using `any` here to avoid an explicit cast by our users.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  get(t) {
    if (this._document) {
      const n = this._document.data.field(aE("DocumentSnapshot.get", t));
      if (n !== null)
        return this._userDataWriter.convertValue(n);
    }
  }
}
class _Ee extends m6 {
  /**
   * Retrieves all fields in the document as an `Object`.
   *
   * @override
   * @returns An `Object` containing all fields in the document.
   */
  data() {
    return super.data();
  }
}
function aE(e, t) {
  return typeof t == "string" ? p6(e, t) : t instanceof iE ? t._internalPath : t._delegate._internalPath;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function KG(e) {
  if (e.limitType === "L" && e.explicitOrderBy.length === 0)
    throw new Je(we.UNIMPLEMENTED, "limitToLast() queries require specifying at least one orderBy() clause");
}
class v6 {
}
class vy extends v6 {
}
function Bs(e, t, ...n) {
  let r = [];
  t instanceof v6 && r.push(t), r = r.concat(n), function(o) {
    const a = o.filter((c) => c instanceof y6).length, s = o.filter((c) => c instanceof sE).length;
    if (a > 1 || a > 0 && s > 0)
      throw new Je(we.INVALID_ARGUMENT, "InvalidQuery. When using composite filters, you cannot use more than one filter at the top level. Consider nesting the multiple filters within an `and(...)` statement. For example: change `query(query, where(...), or(...))` to `query(query, and(where(...), or(...)))`.");
  }(r);
  for (const i of r)
    e = i._apply(e);
  return e;
}
class sE extends vy {
  /**
   * @internal
   */
  constructor(t, n, r) {
    super(), this._field = t, this._op = n, this._value = r, /** The type of this query constraint */
    this.type = "where";
  }
  static _create(t, n, r) {
    return new sE(t, n, r);
  }
  _apply(t) {
    const n = this._parse(t);
    return XG(t._query, n), new Ns(t.firestore, t.converter, z$(t._query, n));
  }
  _parse(t) {
    const n = oE(t.firestore);
    return function(o, a, s, c, l, u, d) {
      let f;
      if (l.isKeyField()) {
        if (u === "array-contains" || u === "array-contains-any")
          throw new Je(we.INVALID_ARGUMENT, `Invalid Query. You can't perform '${u}' queries on documentId().`);
        if (u === "in" || u === "not-in") {
          S8(d, u);
          const p = [];
          for (const g of d)
            p.push(_8(c, o, g));
          f = {
            arrayValue: {
              values: p
            }
          };
        } else
          f = _8(c, o, d);
      } else
        u !== "in" && u !== "not-in" && u !== "array-contains-any" || S8(d, u), f = UG(
          s,
          a,
          d,
          /* allowArrays= */
          u === "in" || u === "not-in"
        );
      return li.create(l, u, f);
    }(t._query, "where", n, t.firestore._databaseId, this._field, this._op, this._value);
  }
}
function Bb(e, t, n) {
  const r = t, i = aE("where", e);
  return sE._create(i, r, n);
}
class y6 extends v6 {
  /**
   * @internal
   */
  constructor(t, n) {
    super(), this.type = t, this._queryConstraints = n;
  }
  static _create(t, n) {
    return new y6(t, n);
  }
  _parse(t) {
    const n = this._queryConstraints.map((r) => r._parse(t)).filter((r) => r.getFilters().length > 0);
    return n.length === 1 ? n[0] : $s.create(n, this._getOperator());
  }
  _apply(t) {
    const n = this._parse(t);
    return n.getFilters().length === 0 ? t : (function(i, o) {
      let a = i;
      const s = o.getFlattenedFilters();
      for (const c of s)
        XG(a, c), a = z$(a, c);
    }(t._query, n), new Ns(t.firestore, t.converter, z$(t._query, n)));
  }
  _getQueryConstraints() {
    return this._queryConstraints;
  }
  _getOperator() {
    return this.type === "and" ? "and" : "or";
  }
}
class b6 extends vy {
  /**
   * @internal
   */
  constructor(t, n) {
    super(), this._field = t, this._direction = n, /** The type of this query constraint */
    this.type = "orderBy";
  }
  static _create(t, n) {
    return new b6(t, n);
  }
  _apply(t) {
    const n = function(i, o, a) {
      if (i.startAt !== null)
        throw new Je(we.INVALID_ARGUMENT, "Invalid query. You must not call startAt() or startAfter() before calling orderBy().");
      if (i.endAt !== null)
        throw new Je(we.INVALID_ARGUMENT, "Invalid query. You must not call endAt() or endBefore() before calling orderBy().");
      return new fv(o, a);
    }(t._query, this._field, this._direction);
    return new Ns(t.firestore, t.converter, function(i, o) {
      const a = i.explicitOrderBy.concat([o]);
      return new Qu(i.path, i.collectionGroup, a, i.filters.slice(), i.limit, i.limitType, i.startAt, i.endAt);
    }(t._query, n));
  }
}
function Mc(e, t = "asc") {
  const n = t, r = aE("orderBy", e);
  return b6._create(r, n);
}
class cE extends vy {
  /**
   * @internal
   */
  constructor(t, n, r) {
    super(), this.type = t, this._limit = n, this._limitType = r;
  }
  static _create(t, n, r) {
    return new cE(t, n, r);
  }
  _apply(t) {
    return new Ns(t.firestore, t.converter, nS(t._query, this._limit, this._limitType));
  }
}
function md(e) {
  return Iq("limit", e), cE._create(
    "limit",
    e,
    "F"
    /* LimitType.First */
  );
}
function m8(e) {
  return Iq("limitToLast", e), cE._create(
    "limitToLast",
    e,
    "L"
    /* LimitType.Last */
  );
}
class lE extends vy {
  /**
   * @internal
   */
  constructor(t, n, r) {
    super(), this.type = t, this._docOrFields = n, this._inclusive = r;
  }
  static _create(t, n, r) {
    return new lE(t, n, r);
  }
  _apply(t) {
    const n = YG(t, this.type, this._docOrFields, this._inclusive);
    return new Ns(t.firestore, t.converter, function(i, o) {
      return new Qu(i.path, i.collectionGroup, i.explicitOrderBy.slice(), i.filters.slice(), i.limit, i.limitType, o, i.endAt);
    }(t._query, n));
  }
}
function v8(...e) {
  return lE._create(
    "startAt",
    e,
    /*inclusive=*/
    !0
  );
}
function y8(...e) {
  return lE._create(
    "startAfter",
    e,
    /*inclusive=*/
    !1
  );
}
class _6 extends vy {
  /**
   * @internal
   */
  constructor(t, n, r) {
    super(), this.type = t, this._docOrFields = n, this._inclusive = r;
  }
  static _create(t, n, r) {
    return new _6(t, n, r);
  }
  _apply(t) {
    const n = YG(t, this.type, this._docOrFields, this._inclusive);
    return new Ns(t.firestore, t.converter, function(i, o) {
      return new Qu(i.path, i.collectionGroup, i.explicitOrderBy.slice(), i.filters.slice(), i.limit, i.limitType, i.startAt, o);
    }(t._query, n));
  }
}
function b8(...e) {
  return _6._create(
    "endBefore",
    e,
    /*inclusive=*/
    !1
  );
}
function YG(e, t, n, r) {
  if (n[0] = Or(n[0]), n[0] instanceof m6)
    return function(o, a, s, c, l) {
      if (!c)
        throw new Je(we.NOT_FOUND, `Can't use a DocumentSnapshot that doesn't exist for ${s}().`);
      const u = [];
      for (const d of sg(o))
        if (d.field.isKeyField())
          u.push(tS(a, c.key));
        else {
          const f = c.data.field(d.field);
          if (Ux(f))
            throw new Je(we.INVALID_ARGUMENT, 'Invalid query. You are trying to start or end a query using a document for which the field "' + d.field + '" is an uncommitted server timestamp. (Since the value of this field is unknown, you cannot start/end a query with it.)');
          if (f === null) {
            const h = d.field.canonicalString();
            throw new Je(we.INVALID_ARGUMENT, `Invalid query. You are trying to start or end a query using a document for which the field '${h}' (used as the orderBy) does not exist.`);
          }
          u.push(f);
        }
      return new Ag(u, l);
    }(e._query, e.firestore._databaseId, t, n[0]._document, r);
  {
    const i = oE(e.firestore);
    return function(a, s, c, l, u, d) {
      const f = a.explicitOrderBy;
      if (u.length > f.length)
        throw new Je(we.INVALID_ARGUMENT, `Too many arguments provided to ${l}(). The number of arguments must be less than or equal to the number of orderBy() clauses`);
      const h = [];
      for (let p = 0; p < u.length; p++) {
        const g = u[p];
        if (f[p].field.isKeyField()) {
          if (typeof g != "string")
            throw new Je(we.INVALID_ARGUMENT, `Invalid query. Expected a string for document ID in ${l}(), but got a ${typeof g}`);
          if (!WO(a) && g.indexOf("/") !== -1)
            throw new Je(we.INVALID_ARGUMENT, `Invalid query. When querying a collection and ordering by documentId(), the value passed to ${l}() must be a plain document ID, but '${g}' contains a slash.`);
          const m = a.path.child(or.fromString(g));
          if (!kt.isDocumentKey(m))
            throw new Je(we.INVALID_ARGUMENT, `Invalid query. When querying a collection group and ordering by documentId(), the value passed to ${l}() must result in a valid document path, but '${m}' is not because it contains an odd number of segments.`);
          const v = new kt(m);
          h.push(tS(s, v));
        } else {
          const m = UG(c, l, g);
          h.push(m);
        }
      }
      return new Ag(h, d);
    }(e._query, e.firestore._databaseId, i, t, n, r);
  }
}
function _8(e, t, n) {
  if (typeof (n = Or(n)) == "string") {
    if (n === "")
      throw new Je(we.INVALID_ARGUMENT, "Invalid query. When querying with documentId(), you must provide a valid document ID, but it was an empty string.");
    if (!WO(t) && n.indexOf("/") !== -1)
      throw new Je(we.INVALID_ARGUMENT, `Invalid query. When querying a collection by documentId(), you must provide a plain document ID, but '${n}' contains a '/' character.`);
    const r = t.path.child(or.fromString(n));
    if (!kt.isDocumentKey(r))
      throw new Je(we.INVALID_ARGUMENT, `Invalid query. When querying a collection group by documentId(), the value provided must result in a valid document path, but '${r}' is not because it has an odd number of segments (${r.length}).`);
    return tS(e, new kt(r));
  }
  if (n instanceof jr)
    return tS(e, n._key);
  throw new Je(we.INVALID_ARGUMENT, `Invalid query. When querying with documentId(), you must provide a valid string or a DocumentReference, but it was: ${Vx(n)}.`);
}
function S8(e, t) {
  if (!Array.isArray(e) || e.length === 0)
    throw new Je(we.INVALID_ARGUMENT, `Invalid Query. A non-empty array is required for '${t.toString()}' filters.`);
}
function XG(e, t) {
  const n = function(i, o) {
    for (const a of i)
      for (const s of a.getFlattenedFilters())
        if (o.indexOf(s.op) >= 0)
          return s.op;
    return null;
  }(e.filters, function(i) {
    switch (i) {
      case "!=":
        return [
          "!=",
          "not-in"
          /* Operator.NOT_IN */
        ];
      case "array-contains-any":
      case "in":
        return [
          "not-in"
          /* Operator.NOT_IN */
        ];
      case "not-in":
        return [
          "array-contains-any",
          "in",
          "not-in",
          "!="
          /* Operator.NOT_EQUAL */
        ];
      default:
        return [];
    }
  }(t.op));
  if (n !== null)
    throw n === t.op ? new Je(we.INVALID_ARGUMENT, `Invalid query. You cannot use more than one '${t.op.toString()}' filter.`) : new Je(we.INVALID_ARGUMENT, `Invalid query. You cannot use '${t.op.toString()}' filters with '${n.toString()}' filters.`);
}
class SEe {
  convertValue(t, n = "none") {
    switch (Pu(t)) {
      case 0:
        return null;
      case 1:
        return t.booleanValue;
      case 2:
        return ti(t.integerValue || t.doubleValue);
      case 3:
        return this.convertTimestamp(t.timestampValue);
      case 4:
        return this.convertServerTimestamp(t, n);
      case 5:
        return t.stringValue;
      case 6:
        return this.convertBytes(Ru(t.bytesValue));
      case 7:
        return this.convertReference(t.referenceValue);
      case 8:
        return this.convertGeoPoint(t.geoPointValue);
      case 9:
        return this.convertArray(t.arrayValue, n);
      case 11:
        return this.convertObject(t.mapValue, n);
      case 10:
        return this.convertVectorValue(t.mapValue);
      default:
        throw qt(62114, {
          value: t
        });
    }
  }
  convertObject(t, n) {
    return this.convertObjectMap(t.fields, n);
  }
  /**
   * @internal
   */
  convertObjectMap(t, n = "none") {
    const r = {};
    return Xu(t, (i, o) => {
      r[i] = this.convertValue(o, n);
    }), r;
  }
  /**
   * @internal
   */
  convertVectorValue(t) {
    var n, r, i;
    const o = (i = (r = (n = t.fields) === null || n === void 0 ? void 0 : n[eS].arrayValue) === null || r === void 0 ? void 0 : r.values) === null || i === void 0 ? void 0 : i.map((a) => ti(a.doubleValue));
    return new gc(o);
  }
  convertGeoPoint(t) {
    return new hc(ti(t.latitude), ti(t.longitude));
  }
  convertArray(t, n) {
    return (t.values || []).map((r) => this.convertValue(r, n));
  }
  convertServerTimestamp(t, n) {
    switch (n) {
      case "previous":
        const r = Wx(t);
        return r == null ? null : this.convertValue(r, n);
      case "estimate":
        return this.convertTimestamp(cv(t));
      default:
        return null;
    }
  }
  convertTimestamp(t) {
    const n = Au(t);
    return new jn(n.seconds, n.nanos);
  }
  convertDocumentKey(t, n) {
    const r = or.fromString(t);
    Fn(pG(r), 9688, {
      name: t
    });
    const i = new uv(r.get(1), r.get(3)), o = new kt(r.popFirst(5));
    return i.isEqual(n) || // TODO(b/64130202): Somehow support foreign references.
    hl(`Document ${o} contains a document reference within a different database (${i.projectId}/${i.database}) which is not supported. It will be treated as a reference in the current database (${n.projectId}/${n.database}) instead.`), o;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function wEe(e, t, n) {
  let r;
  return r = e ? n && (n.merge || n.mergeFields) ? e.toFirestore(t, n) : e.toFirestore(t) : t, r;
}
function xEe() {
  return new dEe("count");
}
class c0 {
  /** @hideconstructor */
  constructor(t, n) {
    this.hasPendingWrites = t, this.fromCache = n;
  }
  /**
   * Returns true if this `SnapshotMetadata` is equal to the provided one.
   *
   * @param other - The `SnapshotMetadata` to compare against.
   * @returns true if this `SnapshotMetadata` is equal to the provided one.
   */
  isEqual(t) {
    return this.hasPendingWrites === t.hasPendingWrites && this.fromCache === t.fromCache;
  }
}
class Gd extends m6 {
  /** @hideconstructor protected */
  constructor(t, n, r, i, o, a) {
    super(t, n, r, i, a), this._firestore = t, this._firestoreImpl = t, this.metadata = o;
  }
  /**
   * Returns whether or not the data exists. True if the document exists.
   */
  exists() {
    return super.exists();
  }
  /**
   * Retrieves all fields in the document as an `Object`. Returns `undefined` if
   * the document doesn't exist.
   *
   * By default, `serverTimestamp()` values that have not yet been
   * set to their final value will be returned as `null`. You can override
   * this by passing an options object.
   *
   * @param options - An options object to configure how data is retrieved from
   * the snapshot (for example the desired behavior for server timestamps that
   * have not yet been set to their final value).
   * @returns An `Object` containing all fields in the document or `undefined` if
   * the document doesn't exist.
   */
  data(t = {}) {
    if (this._document) {
      if (this._converter) {
        const n = new s_(
          this._firestore,
          this._userDataWriter,
          this._key,
          this._document,
          this.metadata,
          /* converter= */
          null
        );
        return this._converter.fromFirestore(n, t);
      }
      return this._userDataWriter.convertValue(this._document.data.value, t.serverTimestamps);
    }
  }
  /**
   * Retrieves the field specified by `fieldPath`. Returns `undefined` if the
   * document or field doesn't exist.
   *
   * By default, a `serverTimestamp()` that has not yet been set to
   * its final value will be returned as `null`. You can override this by
   * passing an options object.
   *
   * @param fieldPath - The path (for example 'foo' or 'foo.bar') to a specific
   * field.
   * @param options - An options object to configure how the field is retrieved
   * from the snapshot (for example the desired behavior for server timestamps
   * that have not yet been set to their final value).
   * @returns The data at the specified field location or undefined if no such
   * field exists in the document.
   */
  // We are using `any` here to avoid an explicit cast by our users.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  get(t, n = {}) {
    if (this._document) {
      const r = this._document.data.field(aE("DocumentSnapshot.get", t));
      if (r !== null)
        return this._userDataWriter.convertValue(r, n.serverTimestamps);
    }
  }
  /**
   * Returns a JSON-serializable representation of this `DocumentSnapshot` instance.
   *
   * @returns a JSON representation of this object.  Throws a {@link FirestoreError} if this
   * `DocumentSnapshot` has pending writes.
   */
  toJSON() {
    if (this.metadata.hasPendingWrites)
      throw new Je(we.FAILED_PRECONDITION, "DocumentSnapshot.toJSON() attempted to serialize a document with pending writes. Await waitForPendingWrites() before invoking toJSON().");
    const t = this._document, n = {};
    return n.type = Gd._jsonSchemaVersion, n.bundle = "", n.bundleSource = "DocumentSnapshot", n.bundleName = this._key.toString(), !t || !t.isValidDocument() || !t.isFoundDocument() ? n : (this._userDataWriter.convertObjectMap(t.data.value.mapValue.fields, "previous"), n.bundle = (this._firestore, this.ref.path, "NOT SUPPORTED"), n);
  }
}
Gd._jsonSchemaVersion = "firestore/documentSnapshot/1.0", Gd._jsonSchema = {
  type: ui("string", Gd._jsonSchemaVersion),
  bundleSource: ui("string", "DocumentSnapshot"),
  bundleName: ui("string"),
  bundle: ui("string")
};
class s_ extends Gd {
  /**
   * Retrieves all fields in the document as an `Object`.
   *
   * By default, `serverTimestamp()` values that have not yet been
   * set to their final value will be returned as `null`. You can override
   * this by passing an options object.
   *
   * @override
   * @param options - An options object to configure how data is retrieved from
   * the snapshot (for example the desired behavior for server timestamps that
   * have not yet been set to their final value).
   * @returns An `Object` containing all fields in the document.
   */
  data(t = {}) {
    return super.data(t);
  }
}
class Kd {
  /** @hideconstructor */
  constructor(t, n, r, i) {
    this._firestore = t, this._userDataWriter = n, this._snapshot = i, this.metadata = new c0(i.hasPendingWrites, i.fromCache), this.query = r;
  }
  /** An array of all the documents in the `QuerySnapshot`. */
  get docs() {
    const t = [];
    return this.forEach((n) => t.push(n)), t;
  }
  /** The number of documents in the `QuerySnapshot`. */
  get size() {
    return this._snapshot.docs.size;
  }
  /** True if there are no documents in the `QuerySnapshot`. */
  get empty() {
    return this.size === 0;
  }
  /**
   * Enumerates all of the documents in the `QuerySnapshot`.
   *
   * @param callback - A callback to be called with a `QueryDocumentSnapshot` for
   * each document in the snapshot.
   * @param thisArg - The `this` binding for the callback.
   */
  forEach(t, n) {
    this._snapshot.docs.forEach((r) => {
      t.call(n, new s_(this._firestore, this._userDataWriter, r.key, r, new c0(this._snapshot.mutatedKeys.has(r.key), this._snapshot.fromCache), this.query.converter));
    });
  }
  /**
   * Returns an array of the documents changes since the last snapshot. If this
   * is the first snapshot, all documents will be in the list as 'added'
   * changes.
   *
   * @param options - `SnapshotListenOptions` that control whether metadata-only
   * changes (i.e. only `DocumentSnapshot.metadata` changed) should trigger
   * snapshot events.
   */
  docChanges(t = {}) {
    const n = !!t.includeMetadataChanges;
    if (n && this._snapshot.excludesMetadataChanges)
      throw new Je(we.INVALID_ARGUMENT, "To include metadata changes with your document changes, you must also pass { includeMetadataChanges:true } to onSnapshot().");
    return this._cachedChanges && this._cachedChangesIncludeMetadataChanges === n || (this._cachedChanges = /** Calculates the array of `DocumentChange`s for a given `ViewSnapshot`. */
    function(i, o) {
      if (i._snapshot.oldDocs.isEmpty()) {
        let a = 0;
        return i._snapshot.docChanges.map((s) => {
          const c = new s_(i._firestore, i._userDataWriter, s.doc.key, s.doc, new c0(i._snapshot.mutatedKeys.has(s.doc.key), i._snapshot.fromCache), i.query.converter);
          return s.doc, {
            type: "added",
            doc: c,
            oldIndex: -1,
            newIndex: a++
          };
        });
      }
      {
        let a = i._snapshot.oldDocs;
        return i._snapshot.docChanges.filter((s) => o || s.type !== 3).map((s) => {
          const c = new s_(i._firestore, i._userDataWriter, s.doc.key, s.doc, new c0(i._snapshot.mutatedKeys.has(s.doc.key), i._snapshot.fromCache), i.query.converter);
          let l = -1, u = -1;
          return s.type !== 0 && (l = a.indexOf(s.doc.key), a = a.delete(s.doc.key)), s.type !== 1 && (a = a.add(s.doc), u = a.indexOf(s.doc.key)), {
            type: EEe(s.type),
            doc: c,
            oldIndex: l,
            newIndex: u
          };
        });
      }
    }(this, n), this._cachedChangesIncludeMetadataChanges = n), this._cachedChanges;
  }
  /**
   * Returns a JSON-serializable representation of this `QuerySnapshot` instance.
   *
   * @returns a JSON representation of this object. Throws a {@link FirestoreError} if this
   * `QuerySnapshot` has pending writes.
   */
  toJSON() {
    if (this.metadata.hasPendingWrites)
      throw new Je(we.FAILED_PRECONDITION, "QuerySnapshot.toJSON() attempted to serialize a document with pending writes. Await waitForPendingWrites() before invoking toJSON().");
    const t = {};
    t.type = Kd._jsonSchemaVersion, t.bundleSource = "QuerySnapshot", t.bundleName = BO.newId(), this._firestore._databaseId.database, this._firestore._databaseId.projectId;
    const n = [], r = [], i = [];
    return this.docs.forEach((o) => {
      o._document !== null && (n.push(o._document), r.push(this._userDataWriter.convertObjectMap(o._document.data.value.mapValue.fields, "previous")), i.push(o.ref.path));
    }), t.bundle = (this._firestore, this.query._query, t.bundleName, "NOT SUPPORTED"), t;
  }
}
function EEe(e) {
  switch (e) {
    case 0:
      return "added";
    case 2:
    case 3:
      return "modified";
    case 1:
      return "removed";
    default:
      return qt(61501, {
        type: e
      });
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function H5(e) {
  e = lo(e, jr);
  const t = lo(e.firestore, Sc);
  return LG(Bf(t), e._key).then((n) => S6(t, e, n));
}
Kd._jsonSchemaVersion = "firestore/querySnapshot/1.0", Kd._jsonSchema = {
  type: ui("string", Kd._jsonSchemaVersion),
  bundleSource: ui("string", "QuerySnapshot"),
  bundleName: ui("string"),
  bundle: ui("string")
};
class uE extends SEe {
  constructor(t) {
    super(), this.firestore = t;
  }
  convertBytes(t) {
    return new Va(t);
  }
  convertReference(t) {
    const n = this.convertDocumentKey(t, this.firestore._databaseId);
    return new jr(
      this.firestore,
      /* converter= */
      null,
      n
    );
  }
}
function U5(e) {
  e = lo(e, jr);
  const t = lo(e.firestore, Sc);
  return LG(Bf(t), e._key, {
    source: "server"
  }).then((n) => S6(t, e, n));
}
function zb(e) {
  e = lo(e, Ns);
  const t = lo(e.firestore, Sc), n = Bf(t), r = new uE(t);
  return KG(e._query), oEe(n, e._query).then((i) => new Kd(t, r, e, i));
}
function Hb(e, t, n) {
  e = lo(e, jr);
  const r = lo(e.firestore, Sc), i = wEe(e.converter, t, n);
  return QG(r, [mEe(oE(r), "setDoc", e._key, i, e.converter !== null, n).toMutation(e._key, dc.none())]);
}
function w8(e, t, n, ...r) {
  e = lo(e, jr);
  const i = lo(e.firestore, Sc), o = oE(i);
  let a;
  return a = typeof // For Compat types, we have to "extract" the underlying types before
  // performing validation.
  (t = Or(t)) == "string" || t instanceof iE ? yEe(o, "updateDoc", e._key, t, n, r) : vEe(o, "updateDoc", e._key, t), QG(i, [a.toMutation(e._key, dc.exists(!0))]);
}
function ph(e, ...t) {
  var n, r, i;
  e = Or(e);
  let o = {
    includeMetadataChanges: !1,
    source: "default"
  }, a = 0;
  typeof t[a] != "object" || p8(t[a]) || (o = t[a++]);
  const s = {
    includeMetadataChanges: o.includeMetadataChanges,
    source: o.source
  };
  if (p8(t[a])) {
    const d = t[a];
    t[a] = (n = d.next) === null || n === void 0 ? void 0 : n.bind(d), t[a + 1] = (r = d.error) === null || r === void 0 ? void 0 : r.bind(d), t[a + 2] = (i = d.complete) === null || i === void 0 ? void 0 : i.bind(d);
  }
  let c, l, u;
  if (e instanceof jr)
    l = lo(e.firestore, Sc), u = qx(e._key.path), c = {
      next: (d) => {
        t[a] && t[a](S6(l, e, d));
      },
      error: t[a + 1],
      complete: t[a + 2]
    };
  else {
    const d = lo(e, Ns);
    l = lo(d.firestore, Sc), u = d._query;
    const f = new uE(l);
    c = {
      next: (h) => {
        t[a] && t[a](new Kd(l, f, d, h));
      },
      error: t[a + 1],
      complete: t[a + 2]
    }, KG(e._query);
  }
  return function(f, h, p, g) {
    const m = new u6(g), v = new c6(h, m, p);
    return f.asyncQueue.enqueueAndForget(async () => o6(await lS(f), v)), () => {
      m.Ou(), f.asyncQueue.enqueueAndForget(async () => a6(await lS(f), v));
    };
  }(Bf(l), u, s, c);
}
function QG(e, t) {
  return function(r, i) {
    const o = new _s();
    return r.asyncQueue.enqueueAndForget(async () => qxe(await jG(r), i, o)), o.promise;
  }(Bf(e), t);
}
function S6(e, t, n) {
  const r = n.docs.get(t._key), i = new uE(e);
  return new Gd(e, i, t._key, r, new c0(n.hasPendingWrites, n.fromCache), t.converter);
}
function CEe(e) {
  return TEe(e, {
    count: xEe()
  });
}
function TEe(e, t) {
  const n = lo(e.firestore, Sc), r = Bf(n), i = OSe(t, (o, a) => new fwe(a, o.aggregateType, o._internalFieldPath));
  return aEe(r, e._query, i).then((o) => (
    /**
    * Converts the core aggregation result to an `AggregateQuerySnapshot`
    * that can be returned to the consumer.
    * @param query
    * @param aggregateResult Core aggregation result
    * @internal
    */
    function(s, c, l) {
      const u = new uE(s);
      return new fEe(c, u, l);
    }(n, e, o)
  ));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function IEe() {
  return new py("deleteField");
}
(function(t, n = !0) {
  (function(i) {
    Np = i;
  })(Op), Is(new Ua("firestore", (r, { instanceIdentifier: i, options: o }) => {
    const a = r.getProvider("app").getImmediate(), s = new Sc(new pSe(r.getProvider("auth-internal")), new ySe(a, r.getProvider("app-check-internal")), function(l, u) {
      if (!Object.prototype.hasOwnProperty.apply(l.options, ["projectId"]))
        throw new Je(we.INVALID_ARGUMENT, '"projectId" not provided in firebase.initializeApp.');
      return new uv(l.options.projectId, u);
    }(a, i), a);
    return o = Object.assign({
      useFetchStreams: n
    }, o), s._setSettings(o), s;
  }, "PUBLIC").setMultipleInstances(!0)), ta(bD, _D, t), // BUILD_TARGET will be replaced by values like esm2017, cjs2017, etc during the compilation
  ta(bD, _D, "esm2017");
})();
function JG(e, t = {}) {
  pq(
    e,
    t.hostname ?? window.location.hostname,
    t.port ?? 5001
  );
}
function $Ee(e, t = {}) {
  BG(
    e,
    t.hostname ?? window.location.hostname,
    t.port ?? 8081
  );
}
function AEe(e, t = {}) {
  XW(
    e,
    `http://${t.hostname ?? window.location.hostname}:${t.port ?? 9099}`,
    {
      disableWarnings: !0
    }
  );
}
class LCt extends ple {
  constructor(n, r, i, o) {
    super();
    ve(this, "functions");
    ve(this, "userSubject");
    // private initialisedUserSubject: Subject<OptionalUser> = new Subject<OptionalUser>()
    ve(this, "errorSubject", new WH());
    ve(this, "auth");
    ve(this, "authUnsubscribe");
    ve(this, "log");
    ve(this, "provider");
    this.auth = q_e(n), this.functions = gq(n), this.log = i, this.log.info("VITE_USE_EMULATORS", r), this.log.info("VITE_AZURE_TENANT_ID", o), r && (AEe(this.auth), JG(this.functions)), this.userSubject = new Gs({
      user: void 0,
      initialised: !1
    }), this.provider = new A0("microsoft.com"), this.provider.setCustomParameters({ tenant: o ?? "" });
  }
  async initialise() {
    this.log.info("FirebaseUserManagerService", "initialise"), this.authUnsubscribe = this.auth.onAuthStateChanged((n) => this.updateCurrentUser(n)), this.log.info("FirebaseUserManagerService", "initialised");
  }
  dispose() {
    this.authUnsubscribe && this.authUnsubscribe();
  }
  async updateCurrentUser(n) {
    if (this.log.info("updateCurrentUser", n), n === null)
      this.userSubject.next({
        user: void 0,
        initialised: !0
      });
    else
      try {
        const r = await n.getIdTokenResult(!0);
        this.log.info("idTokenResult", r), this.userSubject.next({
          user: this.getOptionalUserFromFirebaseUser(n, r),
          initialised: !0
        });
      } catch (r) {
        this.userSubject.error(r), this.recordError(r, "Failed to connect to Firebase  to check user token.");
      }
  }
  async updateCurrentUserFromUserRecord(n) {
    this.log.info("updateCurrentUserFromUserRecord", n), this.userSubject.next({
      user: this.getUserFromUserRecord(n),
      initialised: !0
    });
  }
  recordError(n, r) {
    this.log.error(`Auth error. ${r}`, { error: n }), this.errorSubject.next(n);
  }
  getUser() {
    if (this.log.info("getUser"), this.userSubject.value.initialised)
      return this.userSubject.value.user;
    throw new Error("User is not yet initialised");
  }
  observeUser() {
    return this.log.info("observeUser"), this.userSubject;
  }
  observeErrors() {
    return this.log.info("observeErrors"), this.errorSubject;
  }
  async login(n) {
    this.log.info("login");
    try {
      await P1e(this.auth, n.email, n.password);
    } catch (r) {
      const i = r;
      this.log.error("Failed to log in.", { error: i }), this.errorSubject.next(i);
    }
  }
  async logout() {
    if (this.log.info("logout"), this.getUser())
      try {
        await k1e(this.auth);
      } catch (n) {
        const r = n;
        this.log.error("Error attempting to log out.", { error: r });
      }
    else
      this.log.error("Tried to logout but no user logged in.");
  }
  async loginWithMicrosoftPopup() {
    this.log.info("loginWithMicrosoft");
    try {
      const r = await (await e_e(this.auth, this.provider)).user.getIdTokenResult();
      if (typeof r.claims.admin != "boolean")
        throw new Error("Admin claim is not a boolean");
      return r.claims.admin;
    } catch (n) {
      throw this.log.error("Error logging in with Microsoft.", { context: n }), n;
    }
  }
  async loginWithMicrosoftRedirect() {
    this.log.info("loginWithMicrosoftRedirect");
    try {
      await a_e(this.auth, this.provider);
    } catch (n) {
      this.recordError(n, "Error logging in with Microsoft.");
    }
  }
  getOptionalUserFromFirebaseUser(n, r) {
    return {
      id: n.uid,
      email: n.email,
      isAdmin: r ? !!r.claims.admin : !1,
      anonymous: n.isAnonymous,
      lastActive: n.metadata.lastSignInTime ? new Date(Date.parse(n.metadata.lastSignInTime)) : void 0,
      created: n.metadata.creationTime ? new Date(Date.parse(n.metadata.creationTime)) : void 0
    };
  }
  getUserFromUserRecord(n) {
    var r;
    return {
      id: n.uid,
      email: n.email ? n.email : null,
      isAdmin: (r = n.customClaims) == null ? void 0 : r.admin,
      anonymous: !1,
      lastActive: n.metadata.lastSignInTime ? new Date(Date.parse(n.metadata.lastSignInTime)) : void 0,
      created: n.metadata.creationTime ? new Date(Date.parse(n.metadata.creationTime)) : void 0
    };
  }
  // public async createUser(credentials: LoginCredentials): Promise<void> {
  //   if (credentials.password === '') {
  //     this.recordError(new Error('Password cannot be empty'), 'Password cannot be empty')
  //     return
  //   }
  //   try {
  //     await createUserWithEmailAndPassword(this.auth, credentials.email, credentials.password)
  //     const { data } = await this.assignUserRole()
  //     this.log.info('createUser', data)
  //     if (data) {
  //       this.updateCurrentUserFromUserRecord(data)
  //     }
  //   } catch (e) {
  //     this.recordError(e as Error, 'Error creating new user.')
  //   }
  // }
  // public async refreshUser(): Promise<void> {
  //   log.info('refreshUser', this.auth.currentUser)
  //   try {
  //     if (this.auth.currentUser) await this.updateCurrentUser(this.auth.currentUser)
  //   } catch (e) {
  //     this.recordError(e as Error, 'Error refreshing user')
  //   }
  // }
  async createAnonymousUser() {
    this.log.info("createAnonymousUser");
    try {
      await T1e(this.auth);
    } catch (n) {
      this.recordError(n, "Error creating new anonymous user.");
    }
  }
  createUserProfile(n) {
  }
  // public async verifyUserEmail() {
  //   try {
  //     const user = this.auth.currentUser
  //     if (user) {
  //       await sendEmailVerification(user)
  //     } else {
  //       throw new Error('Tried to send email verification, but no user loggedn in.')
  //     }
  //   } catch (e) {
  //     this.recordError(e as Error)
  //   }
  // }
  resetPassword(n) {
    this.errorSubject.next(new Error("Password reset email sent"));
  }
  // public hasAccess(path: string | readonly string[] | undefined): boolean {
  //   if (this.userSubject.value.initialised) {
  //     const user = this.userSubject.value.user
  //     switch (path) {
  //       case adminPaths.dashboard:
  //         return !!user && !user.anonymous
  //       default:
  //         return false
  //     }
  //   }
  //   return false
  // }
}
const REe = {
  "Amazon Silk": "amazon_silk",
  "Android Browser": "android",
  Bada: "bada",
  BlackBerry: "blackberry",
  Chrome: "chrome",
  Chromium: "chromium",
  Electron: "electron",
  Epiphany: "epiphany",
  Firefox: "firefox",
  Focus: "focus",
  Generic: "generic",
  "Google Search": "google_search",
  Googlebot: "googlebot",
  "Internet Explorer": "ie",
  "K-Meleon": "k_meleon",
  Maxthon: "maxthon",
  "Microsoft Edge": "edge",
  "MZ Browser": "mz",
  "NAVER Whale Browser": "naver",
  Opera: "opera",
  "Opera Coast": "opera_coast",
  PhantomJS: "phantomjs",
  Puffin: "puffin",
  QupZilla: "qupzilla",
  QQ: "qq",
  QQLite: "qqlite",
  Safari: "safari",
  Sailfish: "sailfish",
  "Samsung Internet for Android": "samsung_internet",
  SeaMonkey: "seamonkey",
  Sleipnir: "sleipnir",
  Swing: "swing",
  Tizen: "tizen",
  "UC Browser": "uc",
  Vivaldi: "vivaldi",
  "WebOS Browser": "webos",
  WeChat: "wechat",
  "Yandex Browser": "yandex",
  Roku: "roku"
}, ZG = {
  amazon_silk: "Amazon Silk",
  android: "Android Browser",
  bada: "Bada",
  blackberry: "BlackBerry",
  chrome: "Chrome",
  chromium: "Chromium",
  electron: "Electron",
  epiphany: "Epiphany",
  firefox: "Firefox",
  focus: "Focus",
  generic: "Generic",
  googlebot: "Googlebot",
  google_search: "Google Search",
  ie: "Internet Explorer",
  k_meleon: "K-Meleon",
  maxthon: "Maxthon",
  edge: "Microsoft Edge",
  mz: "MZ Browser",
  naver: "NAVER Whale Browser",
  opera: "Opera",
  opera_coast: "Opera Coast",
  phantomjs: "PhantomJS",
  puffin: "Puffin",
  qupzilla: "QupZilla",
  qq: "QQ Browser",
  qqlite: "QQ Browser Lite",
  safari: "Safari",
  sailfish: "Sailfish",
  samsung_internet: "Samsung Internet for Android",
  seamonkey: "SeaMonkey",
  sleipnir: "Sleipnir",
  swing: "Swing",
  tizen: "Tizen",
  uc: "UC Browser",
  vivaldi: "Vivaldi",
  webos: "WebOS Browser",
  wechat: "WeChat",
  yandex: "Yandex Browser"
}, Zr = {
  tablet: "tablet",
  mobile: "mobile",
  desktop: "desktop",
  tv: "tv"
}, So = {
  WindowsPhone: "Windows Phone",
  Windows: "Windows",
  MacOS: "macOS",
  iOS: "iOS",
  Android: "Android",
  WebOS: "WebOS",
  BlackBerry: "BlackBerry",
  Bada: "Bada",
  Tizen: "Tizen",
  Linux: "Linux",
  ChromeOS: "Chrome OS",
  PlayStation4: "PlayStation 4",
  Roku: "Roku"
}, Dl = {
  EdgeHTML: "EdgeHTML",
  Blink: "Blink",
  Trident: "Trident",
  Presto: "Presto",
  Gecko: "Gecko",
  WebKit: "WebKit"
};
class Me {
  /**
   * Get first matched item for a string
   * @param {RegExp} regexp
   * @param {String} ua
   * @return {Array|{index: number, input: string}|*|boolean|string}
   */
  static getFirstMatch(t, n) {
    const r = n.match(t);
    return r && r.length > 0 && r[1] || "";
  }
  /**
   * Get second matched item for a string
   * @param regexp
   * @param {String} ua
   * @return {Array|{index: number, input: string}|*|boolean|string}
   */
  static getSecondMatch(t, n) {
    const r = n.match(t);
    return r && r.length > 1 && r[2] || "";
  }
  /**
   * Match a regexp and return a constant or undefined
   * @param {RegExp} regexp
   * @param {String} ua
   * @param {*} _const Any const that will be returned if regexp matches the string
   * @return {*}
   */
  static matchAndReturnConst(t, n, r) {
    if (t.test(n))
      return r;
  }
  static getWindowsVersionName(t) {
    switch (t) {
      case "NT":
        return "NT";
      case "XP":
        return "XP";
      case "NT 5.0":
        return "2000";
      case "NT 5.1":
        return "XP";
      case "NT 5.2":
        return "2003";
      case "NT 6.0":
        return "Vista";
      case "NT 6.1":
        return "7";
      case "NT 6.2":
        return "8";
      case "NT 6.3":
        return "8.1";
      case "NT 10.0":
        return "10";
      default:
        return;
    }
  }
  /**
   * Get macOS version name
   *    10.5 - Leopard
   *    10.6 - Snow Leopard
   *    10.7 - Lion
   *    10.8 - Mountain Lion
   *    10.9 - Mavericks
   *    10.10 - Yosemite
   *    10.11 - El Capitan
   *    10.12 - Sierra
   *    10.13 - High Sierra
   *    10.14 - Mojave
   *    10.15 - Catalina
   *
   * @example
   *   getMacOSVersionName("10.14") // 'Mojave'
   *
   * @param  {string} version
   * @return {string} versionName
   */
  static getMacOSVersionName(t) {
    const n = t.split(".").splice(0, 2).map((r) => parseInt(r, 10) || 0);
    if (n.push(0), n[0] === 10)
      switch (n[1]) {
        case 5:
          return "Leopard";
        case 6:
          return "Snow Leopard";
        case 7:
          return "Lion";
        case 8:
          return "Mountain Lion";
        case 9:
          return "Mavericks";
        case 10:
          return "Yosemite";
        case 11:
          return "El Capitan";
        case 12:
          return "Sierra";
        case 13:
          return "High Sierra";
        case 14:
          return "Mojave";
        case 15:
          return "Catalina";
        default:
          return;
      }
  }
  /**
   * Get Android version name
   *    1.5 - Cupcake
   *    1.6 - Donut
   *    2.0 - Eclair
   *    2.1 - Eclair
   *    2.2 - Froyo
   *    2.x - Gingerbread
   *    3.x - Honeycomb
   *    4.0 - Ice Cream Sandwich
   *    4.1 - Jelly Bean
   *    4.4 - KitKat
   *    5.x - Lollipop
   *    6.x - Marshmallow
   *    7.x - Nougat
   *    8.x - Oreo
   *    9.x - Pie
   *
   * @example
   *   getAndroidVersionName("7.0") // 'Nougat'
   *
   * @param  {string} version
   * @return {string} versionName
   */
  static getAndroidVersionName(t) {
    const n = t.split(".").splice(0, 2).map((r) => parseInt(r, 10) || 0);
    if (n.push(0), !(n[0] === 1 && n[1] < 5)) {
      if (n[0] === 1 && n[1] < 6)
        return "Cupcake";
      if (n[0] === 1 && n[1] >= 6)
        return "Donut";
      if (n[0] === 2 && n[1] < 2)
        return "Eclair";
      if (n[0] === 2 && n[1] === 2)
        return "Froyo";
      if (n[0] === 2 && n[1] > 2)
        return "Gingerbread";
      if (n[0] === 3)
        return "Honeycomb";
      if (n[0] === 4 && n[1] < 1)
        return "Ice Cream Sandwich";
      if (n[0] === 4 && n[1] < 4)
        return "Jelly Bean";
      if (n[0] === 4 && n[1] >= 4)
        return "KitKat";
      if (n[0] === 5)
        return "Lollipop";
      if (n[0] === 6)
        return "Marshmallow";
      if (n[0] === 7)
        return "Nougat";
      if (n[0] === 8)
        return "Oreo";
      if (n[0] === 9)
        return "Pie";
    }
  }
  /**
   * Get version precisions count
   *
   * @example
   *   getVersionPrecision("1.10.3") // 3
   *
   * @param  {string} version
   * @return {number}
   */
  static getVersionPrecision(t) {
    return t.split(".").length;
  }
  /**
   * Calculate browser version weight
   *
   * @example
   *   compareVersions('1.10.2.1',  '1.8.2.1.90')    // 1
   *   compareVersions('1.010.2.1', '1.09.2.1.90');  // 1
   *   compareVersions('1.10.2.1',  '1.10.2.1');     // 0
   *   compareVersions('1.10.2.1',  '1.0800.2');     // -1
   *   compareVersions('1.10.2.1',  '1.10',  true);  // 0
   *
   * @param {String} versionA versions versions to compare
   * @param {String} versionB versions versions to compare
   * @param {boolean} [isLoose] enable loose comparison
   * @return {Number} comparison result: -1 when versionA is lower,
   * 1 when versionA is bigger, 0 when both equal
   */
  /* eslint consistent-return: 1 */
  static compareVersions(t, n, r = !1) {
    const i = Me.getVersionPrecision(t), o = Me.getVersionPrecision(n);
    let a = Math.max(i, o), s = 0;
    const c = Me.map([t, n], (l) => {
      const u = a - Me.getVersionPrecision(l), d = l + new Array(u + 1).join(".0");
      return Me.map(d.split("."), (f) => new Array(20 - f.length).join("0") + f).reverse();
    });
    for (r && (s = a - Math.min(i, o)), a -= 1; a >= s; ) {
      if (c[0][a] > c[1][a])
        return 1;
      if (c[0][a] === c[1][a]) {
        if (a === s)
          return 0;
        a -= 1;
      } else if (c[0][a] < c[1][a])
        return -1;
    }
  }
  /**
   * Array::map polyfill
   *
   * @param  {Array} arr
   * @param  {Function} iterator
   * @return {Array}
   */
  static map(t, n) {
    const r = [];
    let i;
    if (Array.prototype.map)
      return Array.prototype.map.call(t, n);
    for (i = 0; i < t.length; i += 1)
      r.push(n(t[i]));
    return r;
  }
  /**
   * Array::find polyfill
   *
   * @param  {Array} arr
   * @param  {Function} predicate
   * @return {Array}
   */
  static find(t, n) {
    let r, i;
    if (Array.prototype.find)
      return Array.prototype.find.call(t, n);
    for (r = 0, i = t.length; r < i; r += 1) {
      const o = t[r];
      if (n(o, r))
        return o;
    }
  }
  /**
   * Object::assign polyfill
   *
   * @param  {Object} obj
   * @param  {Object} ...objs
   * @return {Object}
   */
  static assign(t, ...n) {
    const r = t;
    let i, o;
    if (Object.assign)
      return Object.assign(t, ...n);
    for (i = 0, o = n.length; i < o; i += 1) {
      const a = n[i];
      typeof a == "object" && a !== null && Object.keys(a).forEach((c) => {
        r[c] = a[c];
      });
    }
    return t;
  }
  /**
   * Get short version/alias for a browser name
   *
   * @example
   *   getBrowserAlias('Microsoft Edge') // edge
   *
   * @param  {string} browserName
   * @return {string}
   */
  static getBrowserAlias(t) {
    return REe[t];
  }
  /**
   * Get short version/alias for a browser name
   *
   * @example
   *   getBrowserAlias('edge') // Microsoft Edge
   *
   * @param  {string} browserAlias
   * @return {string}
   */
  static getBrowserTypeByAlias(t) {
    return ZG[t] || "";
  }
}
const rr = /version\/(\d+(\.?_?\d+)+)/i, PEe = [
  /* Googlebot */
  {
    test: [/googlebot/i],
    describe(e) {
      const t = {
        name: "Googlebot"
      }, n = Me.getFirstMatch(/googlebot\/(\d+(\.\d+))/i, e) || Me.getFirstMatch(rr, e);
      return n && (t.version = n), t;
    }
  },
  /* Opera < 13.0 */
  {
    test: [/opera/i],
    describe(e) {
      const t = {
        name: "Opera"
      }, n = Me.getFirstMatch(rr, e) || Me.getFirstMatch(/(?:opera)[\s/](\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  /* Opera > 13.0 */
  {
    test: [/opr\/|opios/i],
    describe(e) {
      const t = {
        name: "Opera"
      }, n = Me.getFirstMatch(/(?:opr|opios)[\s/](\S+)/i, e) || Me.getFirstMatch(rr, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/SamsungBrowser/i],
    describe(e) {
      const t = {
        name: "Samsung Internet for Android"
      }, n = Me.getFirstMatch(rr, e) || Me.getFirstMatch(/(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/Whale/i],
    describe(e) {
      const t = {
        name: "NAVER Whale Browser"
      }, n = Me.getFirstMatch(rr, e) || Me.getFirstMatch(/(?:whale)[\s/](\d+(?:\.\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/MZBrowser/i],
    describe(e) {
      const t = {
        name: "MZ Browser"
      }, n = Me.getFirstMatch(/(?:MZBrowser)[\s/](\d+(?:\.\d+)+)/i, e) || Me.getFirstMatch(rr, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/focus/i],
    describe(e) {
      const t = {
        name: "Focus"
      }, n = Me.getFirstMatch(/(?:focus)[\s/](\d+(?:\.\d+)+)/i, e) || Me.getFirstMatch(rr, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/swing/i],
    describe(e) {
      const t = {
        name: "Swing"
      }, n = Me.getFirstMatch(/(?:swing)[\s/](\d+(?:\.\d+)+)/i, e) || Me.getFirstMatch(rr, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/coast/i],
    describe(e) {
      const t = {
        name: "Opera Coast"
      }, n = Me.getFirstMatch(rr, e) || Me.getFirstMatch(/(?:coast)[\s/](\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/opt\/\d+(?:.?_?\d+)+/i],
    describe(e) {
      const t = {
        name: "Opera Touch"
      }, n = Me.getFirstMatch(/(?:opt)[\s/](\d+(\.?_?\d+)+)/i, e) || Me.getFirstMatch(rr, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/yabrowser/i],
    describe(e) {
      const t = {
        name: "Yandex Browser"
      }, n = Me.getFirstMatch(/(?:yabrowser)[\s/](\d+(\.?_?\d+)+)/i, e) || Me.getFirstMatch(rr, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/ucbrowser/i],
    describe(e) {
      const t = {
        name: "UC Browser"
      }, n = Me.getFirstMatch(rr, e) || Me.getFirstMatch(/(?:ucbrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/Maxthon|mxios/i],
    describe(e) {
      const t = {
        name: "Maxthon"
      }, n = Me.getFirstMatch(rr, e) || Me.getFirstMatch(/(?:Maxthon|mxios)[\s/](\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/epiphany/i],
    describe(e) {
      const t = {
        name: "Epiphany"
      }, n = Me.getFirstMatch(rr, e) || Me.getFirstMatch(/(?:epiphany)[\s/](\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/puffin/i],
    describe(e) {
      const t = {
        name: "Puffin"
      }, n = Me.getFirstMatch(rr, e) || Me.getFirstMatch(/(?:puffin)[\s/](\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/sleipnir/i],
    describe(e) {
      const t = {
        name: "Sleipnir"
      }, n = Me.getFirstMatch(rr, e) || Me.getFirstMatch(/(?:sleipnir)[\s/](\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/k-meleon/i],
    describe(e) {
      const t = {
        name: "K-Meleon"
      }, n = Me.getFirstMatch(rr, e) || Me.getFirstMatch(/(?:k-meleon)[\s/](\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/micromessenger/i],
    describe(e) {
      const t = {
        name: "WeChat"
      }, n = Me.getFirstMatch(/(?:micromessenger)[\s/](\d+(\.?_?\d+)+)/i, e) || Me.getFirstMatch(rr, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/qqbrowser/i],
    describe(e) {
      const t = {
        name: /qqbrowserlite/i.test(e) ? "QQ Browser Lite" : "QQ Browser"
      }, n = Me.getFirstMatch(/(?:qqbrowserlite|qqbrowser)[/](\d+(\.?_?\d+)+)/i, e) || Me.getFirstMatch(rr, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/msie|trident/i],
    describe(e) {
      const t = {
        name: "Internet Explorer"
      }, n = Me.getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/\sedg\//i],
    describe(e) {
      const t = {
        name: "Microsoft Edge"
      }, n = Me.getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/edg([ea]|ios)/i],
    describe(e) {
      const t = {
        name: "Microsoft Edge"
      }, n = Me.getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/vivaldi/i],
    describe(e) {
      const t = {
        name: "Vivaldi"
      }, n = Me.getFirstMatch(/vivaldi\/(\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/seamonkey/i],
    describe(e) {
      const t = {
        name: "SeaMonkey"
      }, n = Me.getFirstMatch(/seamonkey\/(\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/sailfish/i],
    describe(e) {
      const t = {
        name: "Sailfish"
      }, n = Me.getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/silk/i],
    describe(e) {
      const t = {
        name: "Amazon Silk"
      }, n = Me.getFirstMatch(/silk\/(\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/phantom/i],
    describe(e) {
      const t = {
        name: "PhantomJS"
      }, n = Me.getFirstMatch(/phantomjs\/(\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/slimerjs/i],
    describe(e) {
      const t = {
        name: "SlimerJS"
      }, n = Me.getFirstMatch(/slimerjs\/(\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/blackberry|\bbb\d+/i, /rim\stablet/i],
    describe(e) {
      const t = {
        name: "BlackBerry"
      }, n = Me.getFirstMatch(rr, e) || Me.getFirstMatch(/blackberry[\d]+\/(\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/(web|hpw)[o0]s/i],
    describe(e) {
      const t = {
        name: "WebOS Browser"
      }, n = Me.getFirstMatch(rr, e) || Me.getFirstMatch(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/bada/i],
    describe(e) {
      const t = {
        name: "Bada"
      }, n = Me.getFirstMatch(/dolfin\/(\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/tizen/i],
    describe(e) {
      const t = {
        name: "Tizen"
      }, n = Me.getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i, e) || Me.getFirstMatch(rr, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/qupzilla/i],
    describe(e) {
      const t = {
        name: "QupZilla"
      }, n = Me.getFirstMatch(/(?:qupzilla)[\s/](\d+(\.?_?\d+)+)/i, e) || Me.getFirstMatch(rr, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/firefox|iceweasel|fxios/i],
    describe(e) {
      const t = {
        name: "Firefox"
      }, n = Me.getFirstMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/electron/i],
    describe(e) {
      const t = {
        name: "Electron"
      }, n = Me.getFirstMatch(/(?:electron)\/(\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/MiuiBrowser/i],
    describe(e) {
      const t = {
        name: "Miui"
      }, n = Me.getFirstMatch(/(?:MiuiBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/chromium/i],
    describe(e) {
      const t = {
        name: "Chromium"
      }, n = Me.getFirstMatch(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i, e) || Me.getFirstMatch(rr, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/chrome|crios|crmo/i],
    describe(e) {
      const t = {
        name: "Chrome"
      }, n = Me.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/GSA/i],
    describe(e) {
      const t = {
        name: "Google Search"
      }, n = Me.getFirstMatch(/(?:GSA)\/(\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  /* Android Browser */
  {
    test(e) {
      const t = !e.test(/like android/i), n = e.test(/android/i);
      return t && n;
    },
    describe(e) {
      const t = {
        name: "Android Browser"
      }, n = Me.getFirstMatch(rr, e);
      return n && (t.version = n), t;
    }
  },
  /* PlayStation 4 */
  {
    test: [/playstation 4/i],
    describe(e) {
      const t = {
        name: "PlayStation 4"
      }, n = Me.getFirstMatch(rr, e);
      return n && (t.version = n), t;
    }
  },
  /* Safari */
  {
    test: [/safari|applewebkit/i],
    describe(e) {
      const t = {
        name: "Safari"
      }, n = Me.getFirstMatch(rr, e);
      return n && (t.version = n), t;
    }
  },
  /* Something else */
  {
    test: [/.*/i],
    describe(e) {
      const t = /^(.*)\/(.*) /, n = /^(.*)\/(.*)[ \t]\((.*)/, i = e.search("\\(") !== -1 ? n : t;
      return {
        name: Me.getFirstMatch(i, e),
        version: Me.getSecondMatch(i, e)
      };
    }
  }
], OEe = [
  /* Roku */
  {
    test: [/Roku\/DVP/],
    describe(e) {
      const t = Me.getFirstMatch(/Roku\/DVP-(\d+\.\d+)/i, e);
      return {
        name: So.Roku,
        version: t
      };
    }
  },
  /* Windows Phone */
  {
    test: [/windows phone/i],
    describe(e) {
      const t = Me.getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i, e);
      return {
        name: So.WindowsPhone,
        version: t
      };
    }
  },
  /* Windows */
  {
    test: [/windows /i],
    describe(e) {
      const t = Me.getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i, e), n = Me.getWindowsVersionName(t);
      return {
        name: So.Windows,
        version: t,
        versionName: n
      };
    }
  },
  /* Firefox on iPad */
  {
    test: [/Macintosh(.*?) FxiOS(.*?)\//],
    describe(e) {
      const t = {
        name: So.iOS
      }, n = Me.getSecondMatch(/(Version\/)(\d[\d.]+)/, e);
      return n && (t.version = n), t;
    }
  },
  /* macOS */
  {
    test: [/macintosh/i],
    describe(e) {
      const t = Me.getFirstMatch(/mac os x (\d+(\.?_?\d+)+)/i, e).replace(/[_\s]/g, "."), n = Me.getMacOSVersionName(t), r = {
        name: So.MacOS,
        version: t
      };
      return n && (r.versionName = n), r;
    }
  },
  /* iOS */
  {
    test: [/(ipod|iphone|ipad)/i],
    describe(e) {
      const t = Me.getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i, e).replace(/[_\s]/g, ".");
      return {
        name: So.iOS,
        version: t
      };
    }
  },
  /* Android */
  {
    test(e) {
      const t = !e.test(/like android/i), n = e.test(/android/i);
      return t && n;
    },
    describe(e) {
      const t = Me.getFirstMatch(/android[\s/-](\d+(\.\d+)*)/i, e), n = Me.getAndroidVersionName(t), r = {
        name: So.Android,
        version: t
      };
      return n && (r.versionName = n), r;
    }
  },
  /* WebOS */
  {
    test: [/(web|hpw)[o0]s/i],
    describe(e) {
      const t = Me.getFirstMatch(/(?:web|hpw)[o0]s\/(\d+(\.\d+)*)/i, e), n = {
        name: So.WebOS
      };
      return t && t.length && (n.version = t), n;
    }
  },
  /* BlackBerry */
  {
    test: [/blackberry|\bbb\d+/i, /rim\stablet/i],
    describe(e) {
      const t = Me.getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i, e) || Me.getFirstMatch(/blackberry\d+\/(\d+([_\s]\d+)*)/i, e) || Me.getFirstMatch(/\bbb(\d+)/i, e);
      return {
        name: So.BlackBerry,
        version: t
      };
    }
  },
  /* Bada */
  {
    test: [/bada/i],
    describe(e) {
      const t = Me.getFirstMatch(/bada\/(\d+(\.\d+)*)/i, e);
      return {
        name: So.Bada,
        version: t
      };
    }
  },
  /* Tizen */
  {
    test: [/tizen/i],
    describe(e) {
      const t = Me.getFirstMatch(/tizen[/\s](\d+(\.\d+)*)/i, e);
      return {
        name: So.Tizen,
        version: t
      };
    }
  },
  /* Linux */
  {
    test: [/linux/i],
    describe() {
      return {
        name: So.Linux
      };
    }
  },
  /* Chrome OS */
  {
    test: [/CrOS/],
    describe() {
      return {
        name: So.ChromeOS
      };
    }
  },
  /* Playstation 4 */
  {
    test: [/PlayStation 4/],
    describe(e) {
      const t = Me.getFirstMatch(/PlayStation 4[/\s](\d+(\.\d+)*)/i, e);
      return {
        name: So.PlayStation4,
        version: t
      };
    }
  }
], MEe = [
  /* Googlebot */
  {
    test: [/googlebot/i],
    describe() {
      return {
        type: "bot",
        vendor: "Google"
      };
    }
  },
  /* Huawei */
  {
    test: [/huawei/i],
    describe(e) {
      const t = Me.getFirstMatch(/(can-l01)/i, e) && "Nova", n = {
        type: Zr.mobile,
        vendor: "Huawei"
      };
      return t && (n.model = t), n;
    }
  },
  /* Nexus Tablet */
  {
    test: [/nexus\s*(?:7|8|9|10).*/i],
    describe() {
      return {
        type: Zr.tablet,
        vendor: "Nexus"
      };
    }
  },
  /* iPad */
  {
    test: [/ipad/i],
    describe() {
      return {
        type: Zr.tablet,
        vendor: "Apple",
        model: "iPad"
      };
    }
  },
  /* Firefox on iPad */
  {
    test: [/Macintosh(.*?) FxiOS(.*?)\//],
    describe() {
      return {
        type: Zr.tablet,
        vendor: "Apple",
        model: "iPad"
      };
    }
  },
  /* Amazon Kindle Fire */
  {
    test: [/kftt build/i],
    describe() {
      return {
        type: Zr.tablet,
        vendor: "Amazon",
        model: "Kindle Fire HD 7"
      };
    }
  },
  /* Another Amazon Tablet with Silk */
  {
    test: [/silk/i],
    describe() {
      return {
        type: Zr.tablet,
        vendor: "Amazon"
      };
    }
  },
  /* Tablet */
  {
    test: [/tablet(?! pc)/i],
    describe() {
      return {
        type: Zr.tablet
      };
    }
  },
  /* iPod/iPhone */
  {
    test(e) {
      const t = e.test(/ipod|iphone/i), n = e.test(/like (ipod|iphone)/i);
      return t && !n;
    },
    describe(e) {
      const t = Me.getFirstMatch(/(ipod|iphone)/i, e);
      return {
        type: Zr.mobile,
        vendor: "Apple",
        model: t
      };
    }
  },
  /* Nexus Mobile */
  {
    test: [/nexus\s*[0-6].*/i, /galaxy nexus/i],
    describe() {
      return {
        type: Zr.mobile,
        vendor: "Nexus"
      };
    }
  },
  /* Mobile */
  {
    test: [/[^-]mobi/i],
    describe() {
      return {
        type: Zr.mobile
      };
    }
  },
  /* BlackBerry */
  {
    test(e) {
      return e.getBrowserName(!0) === "blackberry";
    },
    describe() {
      return {
        type: Zr.mobile,
        vendor: "BlackBerry"
      };
    }
  },
  /* Bada */
  {
    test(e) {
      return e.getBrowserName(!0) === "bada";
    },
    describe() {
      return {
        type: Zr.mobile
      };
    }
  },
  /* Windows Phone */
  {
    test(e) {
      return e.getBrowserName() === "windows phone";
    },
    describe() {
      return {
        type: Zr.mobile,
        vendor: "Microsoft"
      };
    }
  },
  /* Android Tablet */
  {
    test(e) {
      const t = Number(String(e.getOSVersion()).split(".")[0]);
      return e.getOSName(!0) === "android" && t >= 3;
    },
    describe() {
      return {
        type: Zr.tablet
      };
    }
  },
  /* Android Mobile */
  {
    test(e) {
      return e.getOSName(!0) === "android";
    },
    describe() {
      return {
        type: Zr.mobile
      };
    }
  },
  /* desktop */
  {
    test(e) {
      return e.getOSName(!0) === "macos";
    },
    describe() {
      return {
        type: Zr.desktop,
        vendor: "Apple"
      };
    }
  },
  /* Windows */
  {
    test(e) {
      return e.getOSName(!0) === "windows";
    },
    describe() {
      return {
        type: Zr.desktop
      };
    }
  },
  /* Linux */
  {
    test(e) {
      return e.getOSName(!0) === "linux";
    },
    describe() {
      return {
        type: Zr.desktop
      };
    }
  },
  /* PlayStation 4 */
  {
    test(e) {
      return e.getOSName(!0) === "playstation 4";
    },
    describe() {
      return {
        type: Zr.tv
      };
    }
  },
  /* Roku */
  {
    test(e) {
      return e.getOSName(!0) === "roku";
    },
    describe() {
      return {
        type: Zr.tv
      };
    }
  }
], kEe = [
  /* EdgeHTML */
  {
    test(e) {
      return e.getBrowserName(!0) === "microsoft edge";
    },
    describe(e) {
      if (/\sedg\//i.test(e))
        return {
          name: Dl.Blink
        };
      const n = Me.getFirstMatch(/edge\/(\d+(\.?_?\d+)+)/i, e);
      return {
        name: Dl.EdgeHTML,
        version: n
      };
    }
  },
  /* Trident */
  {
    test: [/trident/i],
    describe(e) {
      const t = {
        name: Dl.Trident
      }, n = Me.getFirstMatch(/trident\/(\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  /* Presto */
  {
    test(e) {
      return e.test(/presto/i);
    },
    describe(e) {
      const t = {
        name: Dl.Presto
      }, n = Me.getFirstMatch(/presto\/(\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  /* Gecko */
  {
    test(e) {
      const t = e.test(/gecko/i), n = e.test(/like gecko/i);
      return t && !n;
    },
    describe(e) {
      const t = {
        name: Dl.Gecko
      }, n = Me.getFirstMatch(/gecko\/(\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  /* Blink */
  {
    test: [/(apple)?webkit\/537\.36/i],
    describe() {
      return {
        name: Dl.Blink
      };
    }
  },
  /* WebKit */
  {
    test: [/(apple)?webkit/i],
    describe(e) {
      const t = {
        name: Dl.WebKit
      }, n = Me.getFirstMatch(/webkit\/(\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  }
];
class x8 {
  /**
   * Create instance of Parser
   *
   * @param {String} UA User-Agent string
   * @param {Boolean} [skipParsing=false] parser can skip parsing in purpose of performance
   * improvements if you need to make a more particular parsing
   * like {@link Parser#parseBrowser} or {@link Parser#parsePlatform}
   *
   * @throw {Error} in case of empty UA String
   *
   * @constructor
   */
  constructor(t, n = !1) {
    if (t == null || t === "")
      throw new Error("UserAgent parameter can't be empty");
    this._ua = t, this.parsedResult = {}, n !== !0 && this.parse();
  }
  /**
   * Get UserAgent string of current Parser instance
   * @return {String} User-Agent String of the current <Parser> object
   *
   * @public
   */
  getUA() {
    return this._ua;
  }
  /**
   * Test a UA string for a regexp
   * @param {RegExp} regex
   * @return {Boolean}
   */
  test(t) {
    return t.test(this._ua);
  }
  /**
   * Get parsed browser object
   * @return {Object}
   */
  parseBrowser() {
    this.parsedResult.browser = {};
    const t = Me.find(PEe, (n) => {
      if (typeof n.test == "function")
        return n.test(this);
      if (n.test instanceof Array)
        return n.test.some((r) => this.test(r));
      throw new Error("Browser's test function is not valid");
    });
    return t && (this.parsedResult.browser = t.describe(this.getUA())), this.parsedResult.browser;
  }
  /**
   * Get parsed browser object
   * @return {Object}
   *
   * @public
   */
  getBrowser() {
    return this.parsedResult.browser ? this.parsedResult.browser : this.parseBrowser();
  }
  /**
   * Get browser's name
   * @return {String} Browser's name or an empty string
   *
   * @public
   */
  getBrowserName(t) {
    return t ? String(this.getBrowser().name).toLowerCase() || "" : this.getBrowser().name || "";
  }
  /**
   * Get browser's version
   * @return {String} version of browser
   *
   * @public
   */
  getBrowserVersion() {
    return this.getBrowser().version;
  }
  /**
   * Get OS
   * @return {Object}
   *
   * @example
   * this.getOS();
   * {
   *   name: 'macOS',
   *   version: '10.11.12'
   * }
   */
  getOS() {
    return this.parsedResult.os ? this.parsedResult.os : this.parseOS();
  }
  /**
   * Parse OS and save it to this.parsedResult.os
   * @return {*|{}}
   */
  parseOS() {
    this.parsedResult.os = {};
    const t = Me.find(OEe, (n) => {
      if (typeof n.test == "function")
        return n.test(this);
      if (n.test instanceof Array)
        return n.test.some((r) => this.test(r));
      throw new Error("Browser's test function is not valid");
    });
    return t && (this.parsedResult.os = t.describe(this.getUA())), this.parsedResult.os;
  }
  /**
   * Get OS name
   * @param {Boolean} [toLowerCase] return lower-cased value
   * @return {String} name of the OS — macOS, Windows, Linux, etc.
   */
  getOSName(t) {
    const { name: n } = this.getOS();
    return t ? String(n).toLowerCase() || "" : n || "";
  }
  /**
   * Get OS version
   * @return {String} full version with dots ('10.11.12', '5.6', etc)
   */
  getOSVersion() {
    return this.getOS().version;
  }
  /**
   * Get parsed platform
   * @return {{}}
   */
  getPlatform() {
    return this.parsedResult.platform ? this.parsedResult.platform : this.parsePlatform();
  }
  /**
   * Get platform name
   * @param {Boolean} [toLowerCase=false]
   * @return {*}
   */
  getPlatformType(t = !1) {
    const { type: n } = this.getPlatform();
    return t ? String(n).toLowerCase() || "" : n || "";
  }
  /**
   * Get parsed platform
   * @return {{}}
   */
  parsePlatform() {
    this.parsedResult.platform = {};
    const t = Me.find(MEe, (n) => {
      if (typeof n.test == "function")
        return n.test(this);
      if (n.test instanceof Array)
        return n.test.some((r) => this.test(r));
      throw new Error("Browser's test function is not valid");
    });
    return t && (this.parsedResult.platform = t.describe(this.getUA())), this.parsedResult.platform;
  }
  /**
   * Get parsed engine
   * @return {{}}
   */
  getEngine() {
    return this.parsedResult.engine ? this.parsedResult.engine : this.parseEngine();
  }
  /**
   * Get engines's name
   * @return {String} Engines's name or an empty string
   *
   * @public
   */
  getEngineName(t) {
    return t ? String(this.getEngine().name).toLowerCase() || "" : this.getEngine().name || "";
  }
  /**
   * Get parsed platform
   * @return {{}}
   */
  parseEngine() {
    this.parsedResult.engine = {};
    const t = Me.find(kEe, (n) => {
      if (typeof n.test == "function")
        return n.test(this);
      if (n.test instanceof Array)
        return n.test.some((r) => this.test(r));
      throw new Error("Browser's test function is not valid");
    });
    return t && (this.parsedResult.engine = t.describe(this.getUA())), this.parsedResult.engine;
  }
  /**
   * Parse full information about the browser
   * @returns {Parser}
   */
  parse() {
    return this.parseBrowser(), this.parseOS(), this.parsePlatform(), this.parseEngine(), this;
  }
  /**
   * Get parsed result
   * @return {ParsedResult}
   */
  getResult() {
    return Me.assign({}, this.parsedResult);
  }
  /**
   * Check if parsed browser matches certain conditions
   *
   * @param {Object} checkTree It's one or two layered object,
   * which can include a platform or an OS on the first layer
   * and should have browsers specs on the bottom-laying layer
   *
   * @returns {Boolean|undefined} Whether the browser satisfies the set conditions or not.
   * Returns `undefined` when the browser is no described in the checkTree object.
   *
   * @example
   * const browser = Bowser.getParser(window.navigator.userAgent);
   * if (browser.satisfies({chrome: '>118.01.1322' }))
   * // or with os
   * if (browser.satisfies({windows: { chrome: '>118.01.1322' } }))
   * // or with platforms
   * if (browser.satisfies({desktop: { chrome: '>118.01.1322' } }))
   */
  satisfies(t) {
    const n = {};
    let r = 0;
    const i = {};
    let o = 0;
    if (Object.keys(t).forEach((s) => {
      const c = t[s];
      typeof c == "string" ? (i[s] = c, o += 1) : typeof c == "object" && (n[s] = c, r += 1);
    }), r > 0) {
      const s = Object.keys(n), c = Me.find(s, (u) => this.isOS(u));
      if (c) {
        const u = this.satisfies(n[c]);
        if (u !== void 0)
          return u;
      }
      const l = Me.find(
        s,
        (u) => this.isPlatform(u)
      );
      if (l) {
        const u = this.satisfies(n[l]);
        if (u !== void 0)
          return u;
      }
    }
    if (o > 0) {
      const s = Object.keys(i), c = Me.find(s, (l) => this.isBrowser(l, !0));
      if (c !== void 0)
        return this.compareVersion(i[c]);
    }
  }
  /**
   * Check if the browser name equals the passed string
   * @param browserName The string to compare with the browser name
   * @param [includingAlias=false] The flag showing whether alias will be included into comparison
   * @returns {boolean}
   */
  isBrowser(t, n = !1) {
    const r = this.getBrowserName().toLowerCase();
    let i = t.toLowerCase();
    const o = Me.getBrowserTypeByAlias(i);
    return n && o && (i = o.toLowerCase()), i === r;
  }
  compareVersion(t) {
    let n = [0], r = t, i = !1;
    const o = this.getBrowserVersion();
    if (typeof o == "string")
      return t[0] === ">" || t[0] === "<" ? (r = t.substr(1), t[1] === "=" ? (i = !0, r = t.substr(2)) : n = [], t[0] === ">" ? n.push(1) : n.push(-1)) : t[0] === "=" ? r = t.substr(1) : t[0] === "~" && (i = !0, r = t.substr(1)), n.indexOf(
        Me.compareVersions(o, r, i)
      ) > -1;
  }
  isOS(t) {
    return this.getOSName(!0) === String(t).toLowerCase();
  }
  isPlatform(t) {
    return this.getPlatformType(!0) === String(t).toLowerCase();
  }
  isEngine(t) {
    return this.getEngineName(!0) === String(t).toLowerCase();
  }
  /**
   * Is anything? Check if the browser is called "anything",
   * the OS called "anything" or the platform called "anything"
   * @param {String} anything
   * @param [includingAlias=false] The flag showing whether alias will be included into comparison
   * @returns {Boolean}
   */
  is(t, n = !1) {
    return this.isBrowser(t, n) || this.isOS(t) || this.isPlatform(t);
  }
  /**
   * Check if any of the given values satisfies this.is(anything)
   * @param {String[]} anythings
   * @returns {Boolean}
   */
  some(t = []) {
    return t.some((n) => this.is(n));
  }
}
/*!
 * Bowser - a browser detector
 * https://github.com/lancedikson/bowser
 * MIT License | (c) Dustin Diaz 2012-2015
 * MIT License | (c) Denis Demchenko 2015-2019
 */
class NEe {
  /**
   * Creates a {@link Parser} instance
   *
   * @param {String} UA UserAgent string
   * @param {Boolean} [skipParsing=false] Will make the Parser postpone parsing until you ask it
   * explicitly. Same as `skipParsing` for {@link Parser}.
   * @returns {Parser}
   * @throws {Error} when UA is not a String
   *
   * @example
   * const parser = Bowser.getParser(window.navigator.userAgent);
   * const result = parser.getResult();
   */
  static getParser(t, n = !1) {
    if (typeof t != "string")
      throw new Error("UserAgent should be a string");
    return new x8(t, n);
  }
  /**
   * Creates a {@link Parser} instance and runs {@link Parser.getResult} immediately
   *
   * @param UA
   * @return {ParsedResult}
   *
   * @example
   * const result = Bowser.parse(window.navigator.userAgent);
   */
  static parse(t) {
    return new x8(t).getResult();
  }
  static get BROWSER_MAP() {
    return ZG;
  }
  static get ENGINE_MAP() {
    return Dl;
  }
  static get OS_MAP() {
    return So;
  }
  static get PLATFORMS_MAP() {
    return Zr;
  }
}
const eK = "%[a-f0-9]{2}", E8 = new RegExp("(" + eK + ")|([^%]+?)", "gi"), C8 = new RegExp("(" + eK + ")+", "gi");
function Z$(e, t) {
  try {
    return [decodeURIComponent(e.join(""))];
  } catch {
  }
  if (e.length === 1)
    return e;
  t = t || 1;
  const n = e.slice(0, t), r = e.slice(t);
  return Array.prototype.concat.call([], Z$(n), Z$(r));
}
function DEe(e) {
  try {
    return decodeURIComponent(e);
  } catch {
    let t = e.match(E8) || [];
    for (let n = 1; n < t.length; n++)
      e = Z$(t, n).join(""), t = e.match(E8) || [];
    return e;
  }
}
function jEe(e) {
  const t = {
    "%FE%FF": "��",
    "%FF%FE": "��"
  };
  let n = C8.exec(e);
  for (; n; ) {
    try {
      t[n[0]] = decodeURIComponent(n[0]);
    } catch {
      const i = DEe(n[0]);
      i !== n[0] && (t[n[0]] = i);
    }
    n = C8.exec(e);
  }
  t["%C2"] = "�";
  const r = Object.keys(t);
  for (const i of r)
    e = e.replace(new RegExp(i, "g"), t[i]);
  return e;
}
function LEe(e) {
  if (typeof e != "string")
    throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof e + "`");
  try {
    return decodeURIComponent(e);
  } catch {
    return jEe(e);
  }
}
function FEe(e, t) {
  const n = {};
  if (Array.isArray(t))
    for (const r of t) {
      const i = Object.getOwnPropertyDescriptor(e, r);
      i != null && i.enumerable && Object.defineProperty(n, r, i);
    }
  else
    for (const r of Reflect.ownKeys(e)) {
      const i = Object.getOwnPropertyDescriptor(e, r);
      if (i.enumerable) {
        const o = e[r];
        t(r, o, e) && Object.defineProperty(n, r, i);
      }
    }
  return n;
}
function tK(e, t) {
  if (!(typeof e == "string" && typeof t == "string"))
    throw new TypeError("Expected the arguments to be of type `string`");
  if (e === "" || t === "")
    return [];
  const n = e.indexOf(t);
  return n === -1 ? [] : [
    e.slice(0, n),
    e.slice(n + t.length)
  ];
}
const VEe = (e) => e == null, BEe = (e) => encodeURIComponent(e).replaceAll(/[!'()*]/g, (t) => `%${t.charCodeAt(0).toString(16).toUpperCase()}`), eA = Symbol("encodeFragmentIdentifier");
function zEe(e) {
  switch (e.arrayFormat) {
    case "index":
      return (t) => (n, r) => {
        const i = n.length;
        return r === void 0 || e.skipNull && r === null || e.skipEmptyString && r === "" ? n : r === null ? [
          ...n,
          [si(t, e), "[", i, "]"].join("")
        ] : [
          ...n,
          [si(t, e), "[", si(i, e), "]=", si(r, e)].join("")
        ];
      };
    case "bracket":
      return (t) => (n, r) => r === void 0 || e.skipNull && r === null || e.skipEmptyString && r === "" ? n : r === null ? [
        ...n,
        [si(t, e), "[]"].join("")
      ] : [
        ...n,
        [si(t, e), "[]=", si(r, e)].join("")
      ];
    case "colon-list-separator":
      return (t) => (n, r) => r === void 0 || e.skipNull && r === null || e.skipEmptyString && r === "" ? n : r === null ? [
        ...n,
        [si(t, e), ":list="].join("")
      ] : [
        ...n,
        [si(t, e), ":list=", si(r, e)].join("")
      ];
    case "comma":
    case "separator":
    case "bracket-separator": {
      const t = e.arrayFormat === "bracket-separator" ? "[]=" : "=";
      return (n) => (r, i) => i === void 0 || e.skipNull && i === null || e.skipEmptyString && i === "" ? r : (i = i === null ? "" : i, r.length === 0 ? [[si(n, e), t, si(i, e)].join("")] : [[r, si(i, e)].join(e.arrayFormatSeparator)]);
    }
    default:
      return (t) => (n, r) => r === void 0 || e.skipNull && r === null || e.skipEmptyString && r === "" ? n : r === null ? [
        ...n,
        si(t, e)
      ] : [
        ...n,
        [si(t, e), "=", si(r, e)].join("")
      ];
  }
}
function HEe(e) {
  let t;
  switch (e.arrayFormat) {
    case "index":
      return (n, r, i) => {
        if (t = /\[(\d*)]$/.exec(n), n = n.replace(/\[\d*]$/, ""), !t) {
          i[n] = r;
          return;
        }
        i[n] === void 0 && (i[n] = {}), i[n][t[1]] = r;
      };
    case "bracket":
      return (n, r, i) => {
        if (t = /(\[])$/.exec(n), n = n.replace(/\[]$/, ""), !t) {
          i[n] = r;
          return;
        }
        if (i[n] === void 0) {
          i[n] = [r];
          return;
        }
        i[n] = [...i[n], r];
      };
    case "colon-list-separator":
      return (n, r, i) => {
        if (t = /(:list)$/.exec(n), n = n.replace(/:list$/, ""), !t) {
          i[n] = r;
          return;
        }
        if (i[n] === void 0) {
          i[n] = [r];
          return;
        }
        i[n] = [...i[n], r];
      };
    case "comma":
    case "separator":
      return (n, r, i) => {
        const o = typeof r == "string" && r.includes(e.arrayFormatSeparator), a = typeof r == "string" && !o && Kc(r, e).includes(e.arrayFormatSeparator);
        r = a ? Kc(r, e) : r;
        const s = o || a ? r.split(e.arrayFormatSeparator).map((c) => Kc(c, e)) : r === null ? r : Kc(r, e);
        i[n] = s;
      };
    case "bracket-separator":
      return (n, r, i) => {
        const o = /(\[])$/.test(n);
        if (n = n.replace(/\[]$/, ""), !o) {
          i[n] = r && Kc(r, e);
          return;
        }
        const a = r === null ? [] : Kc(r, e).split(e.arrayFormatSeparator);
        if (i[n] === void 0) {
          i[n] = a;
          return;
        }
        i[n] = [...i[n], ...a];
      };
    default:
      return (n, r, i) => {
        if (i[n] === void 0) {
          i[n] = r;
          return;
        }
        i[n] = [...[i[n]].flat(), r];
      };
  }
}
function nK(e) {
  if (typeof e != "string" || e.length !== 1)
    throw new TypeError("arrayFormatSeparator must be single character string");
}
function si(e, t) {
  return t.encode ? t.strict ? BEe(e) : encodeURIComponent(e) : e;
}
function Kc(e, t) {
  return t.decode ? LEe(e) : e;
}
function rK(e) {
  return Array.isArray(e) ? e.sort() : typeof e == "object" ? rK(Object.keys(e)).sort((t, n) => Number(t) - Number(n)).map((t) => e[t]) : e;
}
function iK(e) {
  const t = e.indexOf("#");
  return t !== -1 && (e = e.slice(0, t)), e;
}
function UEe(e) {
  let t = "";
  const n = e.indexOf("#");
  return n !== -1 && (t = e.slice(n)), t;
}
function T8(e, t, n) {
  return n === "string" && typeof e == "string" ? e : typeof n == "function" && typeof e == "string" ? n(e) : n === "boolean" && e === null ? !0 : n === "boolean" && e !== null && (e.toLowerCase() === "true" || e.toLowerCase() === "false") ? e.toLowerCase() === "true" : n === "boolean" && e !== null && (e.toLowerCase() === "1" || e.toLowerCase() === "0") ? e.toLowerCase() === "1" : n === "string[]" && t.arrayFormat !== "none" && typeof e == "string" ? [e] : n === "number[]" && t.arrayFormat !== "none" && !Number.isNaN(Number(e)) && typeof e == "string" && e.trim() !== "" ? [Number(e)] : n === "number" && !Number.isNaN(Number(e)) && typeof e == "string" && e.trim() !== "" ? Number(e) : t.parseBooleans && e !== null && (e.toLowerCase() === "true" || e.toLowerCase() === "false") ? e.toLowerCase() === "true" : t.parseNumbers && !Number.isNaN(Number(e)) && typeof e == "string" && e.trim() !== "" ? Number(e) : e;
}
function w6(e) {
  e = iK(e);
  const t = e.indexOf("?");
  return t === -1 ? "" : e.slice(t + 1);
}
function x6(e, t) {
  t = {
    decode: !0,
    sort: !0,
    arrayFormat: "none",
    arrayFormatSeparator: ",",
    parseNumbers: !1,
    parseBooleans: !1,
    types: /* @__PURE__ */ Object.create(null),
    ...t
  }, nK(t.arrayFormatSeparator);
  const n = HEe(t), r = /* @__PURE__ */ Object.create(null);
  if (typeof e != "string" || (e = e.trim().replace(/^[?#&]/, ""), !e))
    return r;
  for (const i of e.split("&")) {
    if (i === "")
      continue;
    const o = t.decode ? i.replaceAll("+", " ") : i;
    let [a, s] = tK(o, "=");
    a === void 0 && (a = o), s = s === void 0 ? null : ["comma", "separator", "bracket-separator"].includes(t.arrayFormat) ? s : Kc(s, t), n(Kc(a, t), s, r);
  }
  for (const [i, o] of Object.entries(r))
    if (typeof o == "object" && o !== null && t.types[i] !== "string")
      for (const [a, s] of Object.entries(o)) {
        const c = t.types[i] ? t.types[i].replace("[]", "") : void 0;
        o[a] = T8(s, t, c);
      }
    else
      typeof o == "object" && o !== null && t.types[i] === "string" ? r[i] = Object.values(o).join(t.arrayFormatSeparator) : r[i] = T8(o, t, t.types[i]);
  return t.sort === !1 ? r : (t.sort === !0 ? Object.keys(r).sort() : Object.keys(r).sort(t.sort)).reduce((i, o) => {
    const a = r[o];
    return i[o] = a && typeof a == "object" && !Array.isArray(a) ? rK(a) : a, i;
  }, /* @__PURE__ */ Object.create(null));
}
function oK(e, t) {
  if (!e)
    return "";
  t = {
    encode: !0,
    strict: !0,
    arrayFormat: "none",
    arrayFormatSeparator: ",",
    ...t
  }, nK(t.arrayFormatSeparator);
  const n = (a) => t.skipNull && VEe(e[a]) || t.skipEmptyString && e[a] === "", r = zEe(t), i = {};
  for (const [a, s] of Object.entries(e))
    n(a) || (i[a] = s);
  const o = Object.keys(i);
  return t.sort !== !1 && o.sort(t.sort), o.map((a) => {
    const s = e[a];
    return s === void 0 ? "" : s === null ? si(a, t) : Array.isArray(s) ? s.length === 0 && t.arrayFormat === "bracket-separator" ? si(a, t) + "[]" : s.reduce(r(a), []).join("&") : si(a, t) + "=" + si(s, t);
  }).filter((a) => a.length > 0).join("&");
}
function aK(e, t) {
  var i;
  t = {
    decode: !0,
    ...t
  };
  let [n, r] = tK(e, "#");
  return n === void 0 && (n = e), {
    url: ((i = n == null ? void 0 : n.split("?")) == null ? void 0 : i[0]) ?? "",
    query: x6(w6(e), t),
    ...t && t.parseFragmentIdentifier && r ? { fragmentIdentifier: Kc(r, t) } : {}
  };
}
function sK(e, t) {
  t = {
    encode: !0,
    strict: !0,
    [eA]: !0,
    ...t
  };
  const n = iK(e.url).split("?")[0] || "", r = w6(e.url), i = {
    ...x6(r, { sort: !1, ...t }),
    ...e.query
  };
  let o = oK(i, t);
  o && (o = `?${o}`);
  let a = UEe(e.url);
  if (typeof e.fragmentIdentifier == "string") {
    const s = new URL(n);
    s.hash = e.fragmentIdentifier, a = t[eA] ? s.hash : `#${e.fragmentIdentifier}`;
  }
  return `${n}${o}${a}`;
}
function cK(e, t, n) {
  n = {
    parseFragmentIdentifier: !0,
    [eA]: !1,
    ...n
  };
  const { url: r, query: i, fragmentIdentifier: o } = aK(e, n);
  return sK({
    url: r,
    query: FEe(i, t),
    fragmentIdentifier: o
  }, n);
}
function WEe(e, t, n) {
  const r = Array.isArray(t) ? (i) => !t.includes(i) : (i, o) => !t(i, o);
  return cK(e, r, n);
}
const tA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  exclude: WEe,
  extract: w6,
  parse: x6,
  parseUrl: aK,
  pick: cK,
  stringify: oK,
  stringifyUrl: sK
}, Symbol.toStringTag, { value: "Module" }));
function lK(e, t) {
  const n = t.find((i) => i.id === e.attributeId), r = (n == null ? void 0 : n.levels.find((i) => i.rank === e.levelRank)) ?? (n == null ? void 0 : n.levels.find((i) => i.id === e.levelId));
  return { attribute: n, level: r };
}
function qEe(e, t) {
  return {
    ...e,
    attributes: e.attributes.map((n) => {
      const { attribute: r, level: i } = lK(n, t);
      return {
        ...n,
        attributeName: n.attributeName ?? (r == null ? void 0 : r.name) ?? String(n.attributeId),
        levelName: n.levelName ?? String((i == null ? void 0 : i.value) ?? n.levelId)
      };
    })
  };
}
function uK(e, t) {
  return t !== void 0 && e.some(
    (n) => n.attributes.some(
      (r) => r.attributeName === void 0 || r.levelName === void 0
    )
  ) ? t : e.map((n, r) => {
    const i = n.attributes.map(
      (o) => `${o.attributeName ?? o.attributeId}:${o.levelName ?? o.levelId}`
    );
    return `Option ${r}: ${i.join(" AND ")}`;
  }).join(" OR ");
}
function I8(e) {
  return typeof e == "object" && e !== null && !Array.isArray(e);
}
function $8(e) {
  return typeof e == "string" || typeof e == "number";
}
function GEe(e) {
  return I8(e) && Array.isArray(e.attributes) && e.attributes.every(
    (t) => I8(t) && $8(t.attributeId) && $8(t.levelId) && typeof t.levelRank == "number" && (t.attributeName === void 0 || typeof t.attributeName == "string") && (t.levelName === void 0 || typeof t.levelName == "string")
  );
}
function KEe(e) {
  const t = e.info;
  return !t || !Array.isArray(t.options) || !t.options.every(GEe) || typeof t.selectedOptionIndex != "number" || !Number.isInteger(t.selectedOptionIndex) || t.selectedOptionIndex < -1 || t.selectedOptionIndex >= t.options.length ? null : { options: t.options, selectedOptionIndex: t.selectedOptionIndex };
}
function dK(e) {
  return e.questionType !== "conjointAnalysis" && e.questionType !== "choiceExperiment" || e.value === null || Array.isArray(e.value) || Ha(e.value) || !Array.isArray(e.value.prevChoices) ? [] : e.value.prevChoices.map((t, n) => {
    const r = KEe(t);
    return {
      choiceNumber: n,
      description: r ? uK(r.options, String(t.id)) : String(t.id),
      selection: r ? `Selected option ${r.selectedOptionIndex}` : t.value,
      snapshot: r
    };
  });
}
const Ub = {
  mode: "none",
  exportAnswer: () => []
}, Tm = {
  mode: "single-column",
  exportAnswer: tCe
}, kc = {
  mode: "wide-columns",
  exportAnswer: rCe
}, Wb = {
  mode: "record-columns",
  exportAnswer: E6
}, YEe = {
  mode: "record-columns",
  exportAnswer: iCe
}, XEe = {
  mode: "record-columns",
  exportAnswer: (e) => e.value === null ? [] : E6(e)
}, A8 = {
  mode: "long-form",
  exportAnswer: ZEe
}, fK = {
  welcomePage: Ub,
  infoPage: XEe,
  endPage: Ub,
  commentBox: Tm,
  responsiveSlider: Tm,
  rewardPage: Ub,
  ranking: kc,
  singleSelect: Tm,
  multiSelect: kc,
  multiSelectMatrix: { mode: "record-columns", exportAnswer: nCe },
  matrix: Wb,
  "dropdown-matrix": YEe,
  "input-matrix": Wb,
  multiDropdown: kc,
  conjointAnalysis: A8,
  hidden: Wb,
  slider: Tm,
  multiInput: kc,
  dropdown: Tm,
  choiceExperiment: A8,
  choiceRank: kc,
  compareSlider: kc,
  loggingTestPage: Ub,
  shift: kc,
  shiftContinuous: kc,
  match: kc,
  vocinaConversation: Wb
};
function QEe(e) {
  return eCe(e) ? fK[e] : null;
}
function JEe(e, t) {
  const n = QEe(e.questionType);
  return n ? n.exportAnswer(e, t) : Og(e);
}
function ZEe(e, t) {
  if ((t == null ? void 0 : t.choiceFormat) === "legacy" || e.value === null || Array.isArray(e.value) || Ha(e.value) || !Array.isArray(e.value.prevChoices))
    return Og(e);
  const { prevChoices: n, ...r } = e.value;
  return [
    ...dK(e).flatMap(
      (i) => [
        ["options", i.description],
        ["selection", i.selection]
      ].map(([o, a]) => {
        const s = `prevChoices::v2::${i.choiceNumber}::${o}`;
        return { key: mf(e.questionId, s), response: { label: s, value: a } };
      })
    ),
    ...Og({ ...e, value: r })
  ];
}
function eCe(e) {
  return Object.prototype.hasOwnProperty.call(fK, e);
}
function tCe(e) {
  return e.value === null ? [dE(e.questionId)] : Ha(e.value) ? [
    {
      key: e.questionId,
      response: pf(e.value)
    }
  ] : Og(e);
}
function nCe(e) {
  const t = e.value && !Array.isArray(e.value) && !Ha(e.value) ? e.value : {};
  return (e.multiSelectMatrixCells ?? []).map((n) => {
    const r = l$(n.statementId, n.choiceId), i = t[n.statementId], o = Array.isArray(i) ? i : [];
    return {
      key: mf(e.questionId, r),
      response: {
        label: r,
        value: !n.available || o.length === 0 ? "" : o.some((a) => a.id === n.choiceId) ? "1" : "0"
      }
    };
  });
}
function rCe(e) {
  return e.value === null ? [dE(e.questionId)] : Array.isArray(e.value) ? dS(e.questionId, e.value) : Og(e);
}
function E6(e) {
  return e.value === null ? [dE(e.questionId)] : Ha(e.value) || Array.isArray(e.value) ? Og(e) : Object.entries(e.value).flatMap(([t, n]) => Array.isArray(n) ? dS(e.questionId, n, t) : [
    {
      key: mf(e.questionId, t),
      response: pf(n, t)
    }
  ]);
}
function iCe(e) {
  return e.value === null || Ha(e.value) || Array.isArray(e.value) ? E6(e) : Object.entries(e.value).flatMap(([t, n]) => Array.isArray(n) ? n.map((r) => {
    const i = `${t}::${typeof r.id}:${encodeURIComponent(String(r.id))}`;
    return {
      key: mf(e.questionId, i),
      response: pf(r, i)
    };
  }) : [
    {
      key: mf(e.questionId, t),
      response: pf(n, t)
    }
  ]);
}
function Og(e) {
  return e.value === null ? [dE(e.questionId)] : Array.isArray(e.value) ? dS(e.questionId, e.value) : Ha(e.value) ? [
    {
      key: e.questionId,
      response: pf(e.value)
    }
  ] : Object.entries(e.value).flatMap(([t, n]) => Array.isArray(n) ? dS(e.questionId, n, t) : [
    {
      key: mf(e.questionId, t),
      response: pf(n, t)
    }
  ]);
}
function dS(e, t, n) {
  const r = n ? `${n}::` : "";
  return t.map((i) => {
    const o = `${r}${i.id}`;
    return {
      key: mf(e, o),
      response: pf(i, o)
    };
  });
}
function pf(e, t) {
  return t === void 0 ? { value: e.value } : { value: e.value, label: t };
}
function dE(e) {
  return {
    key: e,
    response: { value: "No response" }
  };
}
function mf(e, t) {
  return `${e}::${t}`;
}
function oCe(e) {
  if (e.options.length !== 2)
    return [];
  const t = /* @__PURE__ */ new Map();
  return e.options.forEach((n, r) => {
    for (const i of n.attributes) {
      const o = `attr:${i.attributeName ?? i.attributeId}::level:${i.levelName ?? i.levelId}`;
      t.set(o, (t.get(o) ?? 0) + (r === 0 ? 1 : -1));
    }
  }), Array.from(t, ([n, r]) => ({ label: n, diff: r }));
}
function aCe(e) {
  const t = [];
  for (const n of e)
    for (const r of Object.values(n.answers))
      for (const i of dK(r))
        i.snapshot && t.push({
          documentId: n.documentId,
          user: n.metadata.userId,
          questionId: r.questionId,
          choiceNumber: i.choiceNumber,
          choice: i.snapshot.selectedOptionIndex,
          options: i.description,
          attrDiffs: oCe(i.snapshot)
        });
  return { data: t };
}
function sCe(e, t = "v2") {
  const n = new Set(
    e.data.flatMap((r) => r.attrDiffs.map((i) => i.label))
  );
  return [
    "user",
    "questionId",
    "choiceNumber",
    "choice",
    ...t === "v2" ? ["exportVersion", "documentId", "options"] : [],
    ...Array.from(n).sort((r, i) => r.localeCompare(i))
  ];
}
function FCt(e) {
  return e.map((t) => {
    const n = Object.entries(t).map(([r, i]) => [r, i.value]);
    return Object.fromEntries(n);
  });
}
function VCt(e, t = "v2") {
  return e.map((n) => ({
    user: n.user,
    questionId: n.questionId,
    choiceNumber: n.choiceNumber.toString(),
    choice: n.choice.toString(),
    ...t === "v2" ? { exportVersion: "2", documentId: n.documentId, options: n.options } : {},
    ...cCe(n.attrDiffs)
  }));
}
function cCe(e) {
  const t = /* @__PURE__ */ new Map();
  for (const { label: n, diff: r } of e)
    t.set(n, (t.get(n) ?? 0) + r);
  return Object.fromEntries(Array.from(t, ([n, r]) => [n, String(r)]));
}
function W5(e, t) {
  return {
    answers: {
      //   ..._.mapValues(submission.answers, (value, key) => exportData(value, key)),
      ...e.answers
    },
    metadata: {
      userId: e.userData.uid,
      email: e.userData.email,
      urlId: e.userData.urlId,
      urlGroupId: e.userData.urlGroupId,
      device: e.userData.device,
      browser: e.userData.browser,
      language: e.userData.language,
      rewardCode: e.rewardCode,
      rewardCodeStatus: e.rewardCodeStatus,
      completed: e.surveyCompleted,
      totalTime: e.timeTakenSeconds ? e.timeTakenSeconds : e.timeSoFarSeconds,
      submissionStarted: e.submissionStarted,
      submissionEnded: e.submissionEnded,
      lastAnswerTime: e.lastAnswerTime
    },
    documentId: t
  };
}
const nA = {
  userId: "userData.uid",
  email: "userData.email",
  urlId: "userData.urlId",
  urlGroupId: "userData.urlGroupId",
  device: "userData.device",
  browser: "userData.browser",
  language: "userData.language",
  rewardCode: "rewardCode",
  rewardCodeStatus: "rewardCodeStatus",
  completed: "surveyCompleted",
  totalTime: "timeSoFarSeconds",
  submissionStarted: "submissionStarted",
  submissionEnded: "submissionEnded",
  lastAnswerTime: "lastAnswerTime"
};
function R8(e) {
  return e in nA;
}
function BCt(e, t, n, r) {
  return t.info("responsesFromResultData", e), {
    data: e.map((o) => lCe(o, n, r))
  };
}
function lCe(e, t, n) {
  const r = dCe(e.answers, n), i = fCe(e.metadata, t);
  return {
    ...r,
    ...i,
    documentId: { value: e.documentId }
  };
}
function zCt(e, t) {
  const n = [], r = {};
  r.documentId = !0, n.push("documentId");
  for (const o of e)
    for (const a in o.metadata)
      r[a] || (r[a] = !0, n.push(a));
  const i = [];
  for (const o of t.data)
    for (const a in o)
      r[a] || (r[a] = !0, i.push(a));
  return i.sort(uCe), n.concat(i);
}
function uCe(e, t) {
  const n = e.match(/^(.*::prevChoices::v2::)(\d+)::/), r = t.match(/^(.*::prevChoices::v2::)(\d+)::/);
  if (n && r && n[1] === r[1]) {
    const i = Number(n[2]) - Number(r[2]);
    if (i !== 0)
      return i;
  }
  return e === t ? 0 : e > t ? 1 : -1;
}
function dCe(e, t) {
  const n = [];
  for (const r of Object.values(e)) {
    const i = JEe(r, t);
    for (const o of i)
      n.push([o.key, o.response]);
  }
  return Object.fromEntries(n);
}
function fCe(e, t) {
  return {
    submissionStarted: { value: q5(e.submissionStarted, t) },
    submissionEnded: {
      value: e.submissionEnded ? q5(e.submissionEnded, t) : ""
    },
    completed: { value: e.completed ? "true" : "false" },
    lastAnswerTime: {
      value: e.lastAnswerTime ? q5(e.lastAnswerTime, t) : ""
    },
    totalTime: { value: e.totalTime.toString() },
    userId: { value: e.userId },
    email: { value: e.email || "" },
    urlId: { value: e.urlId ? mN(e.urlId, " ") : "" },
    urlGroupId: { value: e.urlGroupId ? mN(e.urlGroupId, " ") : "" },
    device: { value: e.device || "" },
    browser: { value: e.browser || "" },
    language: { value: e.language || "" },
    rewardCode: { value: e.rewardCode || "" },
    rewardCodeStatus: { value: e.rewardCodeStatus || "" }
  };
}
function q5(e, t) {
  return t === "excelcsv" ? e.toDate().toLocaleString().replace(",", "") : e.toDate().toLocaleString();
}
function hCe(e) {
  return ks(
    e,
    "createSurveyDocs"
  );
}
function gCe(e) {
  return ks(
    e,
    "addSurveyOwner"
  );
}
function pCe(e) {
  return ks(
    e,
    "archiveSubmissions"
  );
}
function mCe(e) {
  return ks(
    e,
    "sendResumeEmail"
  );
}
function vCe(e) {
  return ks(
    e,
    "claimSubmission"
  );
}
function yCe(e) {
  return ks(
    e,
    "createVocinaPreAuthLaunch"
  );
}
function bCe(e) {
  return ks(
    e,
    "getSurveyRewardState"
  );
}
function _Ce(e) {
  return ks(
    e,
    "enterSurveyReward"
  );
}
function SCe(e) {
  return ks(e, "requestSurveyRewardEmailVerification");
}
function wCe(e) {
  return ks(
    e,
    "getSurveyRewardWinners"
  );
}
function xCe(e) {
  return ks(
    e,
    "getSurveyRewardEntries"
  );
}
function ECe(e) {
  return e === "endPage" || e === "rewardPage";
}
function CCe(e) {
  const t = tA.parse(e);
  if (!("code" in t))
    return { rewardCodeStatus: "missing" };
  const n = Array.isArray(t.code) ? t.code[0] : t.code;
  return { rewardCode: typeof n == "string" ? n.trim() : "", rewardCodeStatus: "unverified" };
}
class HCt extends mle {
  constructor(n, r, i) {
    super();
    ve(this, "firestore");
    ve(this, "functions");
    // private getResultsFirestore
    ve(this, "createSurveyDoc");
    ve(this, "addSurveyOwnerFirestore");
    ve(this, "archiveSubmissionsFirestore");
    ve(this, "sendResumeEmailFirestore");
    ve(this, "claimSubmissionFirestore");
    ve(this, "createVocinaPreAuthLaunchFirestore");
    ve(this, "getSurveyRewardStateFirestore");
    ve(this, "enterSurveyRewardFirestore");
    ve(this, "requestSurveyRewardEmailVerificationFirestore");
    ve(this, "getSurveyRewardWinnersFirestore");
    ve(this, "getSurveyRewardEntriesFirestore");
    ve(this, "surveyOwnersSubjects", {});
    ve(this, "surveysSubject");
    ve(this, "aggResultsSubject", {});
    ve(this, "surveyResponseCountSubject", new Gs(0));
    ve(this, "surveyResponsesSubject", new Gs(
      []
    ));
    ve(this, "surveyResponseCountSubscription");
    ve(this, "surveyResponsesSubscription");
    ve(this, "surveyResultsParamsSubject", new Gs({
      surveyName: void 0,
      pagination: { action: "start", pageSize: 10 },
      sorter: { column: "submissionStarted", direction: "desc" },
      filter: null
    }));
    ve(this, "surveyResultsParamsSubscription", null);
    ve(this, "unsubscribes", []);
    ve(this, "errorSubject", new WH());
    ve(this, "startDoc");
    ve(this, "endDoc");
    ve(this, "log");
    this.firestore = cEe(n), this.functions = gq(n), this.log = i, this.log.info("USE_FIREBASE_EMULATORS", r), r && ($Ee(this.firestore), JG(this.functions)), this.createSurveyDoc = hCe(this.functions), this.addSurveyOwnerFirestore = gCe(this.functions), this.archiveSubmissionsFirestore = pCe(this.functions), this.sendResumeEmailFirestore = mCe(this.functions), this.claimSubmissionFirestore = vCe(this.functions), this.createVocinaPreAuthLaunchFirestore = yCe(this.functions), this.getSurveyRewardStateFirestore = bCe(this.functions), this.enterSurveyRewardFirestore = _Ce(this.functions), this.requestSurveyRewardEmailVerificationFirestore = SCe(this.functions), this.getSurveyRewardWinnersFirestore = wCe(this.functions), this.getSurveyRewardEntriesFirestore = xCe(this.functions), this.subscribeToSurveyResultsParams();
  }
  async awaitPendingWrites() {
    await uEe(this.firestore);
  }
  dispose() {
    this.unsubscribes.forEach((n) => {
      n();
    }), this.surveyResultsParamsSubscription && this.surveyResultsParamsSubscription.unsubscribe();
  }
  subscribeToSurveyResultsParams() {
    this.log.info("subscribeToSurveyResultsParams"), this.surveyResultsParamsSubscription = this.surveyResultsParamsSubject.subscribe(
      ({ surveyName: n, pagination: r, sorter: i, filter: o }) => {
        if (n === void 0) {
          this.surveyResponseCountSubject.next(0), this.surveyResponsesSubject.next([]);
          return;
        }
        this.updateResponseCount(n), this.updateResponses(n, r, i, o);
      }
    );
  }
  updateResponseCount(n) {
    this.surveyResponseCountSubscription && this.surveyResponseCountSubscription();
    const r = ph(
      this.getSurveyDocRef(n),
      (i) => {
        var a;
        const o = ((a = i.data()) == null ? void 0 : a.submissionCount) ?? 0;
        this.surveyResponseCountSubject.next(o);
      },
      (i) => {
        this.recordError(new Error("Error updating survey response count"), i);
      }
    );
    this.surveyResponseCountSubscription = r;
  }
  updateResponses(n, r, i, o) {
    this.surveyResponsesSubscription && this.surveyResponsesSubscription();
    const a = this.getObserveResponsesQuery(n, r, i, o), s = ph(
      a,
      (c) => {
        const l = c.docs;
        this.startDoc = l[0], this.endDoc = l[l.length - 1];
        const u = l.map(
          (d) => W5(d.data(), d.id)
        );
        this.surveyResponsesSubject.next(u);
      },
      (c) => {
        this.recordError(new Error("Error updating survey responses"), c);
      }
    );
    this.surveyResponsesSubscription = s;
  }
  async subscribeToStore(n, r, i, o) {
    var m;
    this.log.info("subscribeToStore");
    const a = o ?? null, s = this.getUserData(i);
    let c, l, u = !1;
    if (a !== null) {
      c = this.getExistingSubmissionDocRef(r, a);
      try {
        const v = await U5(c);
        u = v.exists(), u && (l = ((m = v.data()) == null ? void 0 : m.submissionStarted) ?? jn.now());
      } catch (v) {
        this.log.error("Error getting submission", { error: v }), u = !1;
      }
    }
    (a === null || !u) && ([c, l] = await this.createInitialSubmission(
      n,
      r,
      i
    ));
    let d, f, h, p;
    const g = () => {
      const v = d, y = f, _ = h, b = p, w = n.getState().survey;
      let C;
      if (d = w.userAnswers, f = w.currentQuestionId ?? void 0, h = w.unlockedSectionIds, p = w.completedSectionIds, ECe(w.currentQuestionType)) {
        const x = jn.now(), T = x.seconds - l.seconds;
        C = {
          submissionStarted: l,
          submissionEnded: x,
          answers: d,
          surveyCompleted: !0,
          timeTakenSeconds: T,
          userData: s,
          currentQuestionId: f,
          currentQuestionType: w.currentQuestionType ?? void 0,
          questionHistory: w.questionHistory,
          ...h ? { unlockedSectionIds: h } : {},
          ...p ? { completedSectionIds: p } : {}
        }, this.updateSubmission(c, C);
      }
      if (v !== d || y !== f || _ !== h || b !== p) {
        const x = jn.now();
        C = {
          submissionStarted: l,
          lastAnswerTime: x,
          answers: d,
          timeSoFarSeconds: x.seconds - l.seconds,
          userData: s,
          currentQuestionId: f,
          currentQuestionType: w.currentQuestionType ?? void 0,
          questionHistory: w.questionHistory,
          ...h ? { unlockedSectionIds: h } : {},
          ...p ? { completedSectionIds: p } : {},
          initialised: !0
        }, this.updateSubmission(c, C);
      }
    };
    this.log.info("Subscribing Firestore to Redux store changes"), this.unsubscribes.push(n.subscribe(g));
  }
  async createInitialSubmission(n, r, i) {
    const o = this.getUserData(i), a = jn.now(), s = this.getNewSubmissionDocRef(r);
    n.dispatch(zU(s.id));
    const c = {
      userData: o,
      answers: {},
      submissionStarted: a,
      surveyCompleted: !1,
      timeSoFarSeconds: 0,
      ...this.getInitialRewardCode()
    };
    return this.log.debug("Setting initial response data in firebase", s, c), await this.initialiseSubmission(s, c), this.log.info("Finished setting initial response data"), [s, a];
  }
  getUserData(n) {
    const r = tA.parse(window.location.search), i = (l) => {
      const u = r[l];
      return u && typeof u == "string" ? u : Array.isArray(u) && u[0] ? u[0] : "empty";
    };
    let o = !1;
    if (r.noAgg && typeof r.noAgg == "string")
      o = r.noAgg === "true";
    else if (r.noAgg && Array.isArray(r.noAgg))
      for (const l of r.noAgg)
        l === "true" && (o = !0);
    const a = typeof r.panelId == "string" ? r.panelId : void 0, s = typeof r.lang == "string" ? r.lang : "default", c = {
      uid: n.id,
      email: null,
      lastActive: n.lastActive,
      created: n.created,
      urlId: i("id"),
      urlGroupId: i("groupid"),
      device: vde(),
      browser: NEe.getParser(window.navigator.userAgent).getBrowserName(),
      noAggregation: o,
      language: s
    };
    return a && (c.panelId = a), c;
  }
  getInitialRewardCode() {
    return CCe(window.location.search);
  }
  async getAggregatedResults(n) {
    var o;
    this.log.info("getAggregatedResults", n);
    const r = this.getSurveyDocRef(n), i = await H5(r);
    return this.log.debug("surveyDoc", i.data()), (o = i.data()) == null ? void 0 : o.aggResults;
  }
  observeAggregatedResults(n) {
    if (!this.aggResultsSubject[n]) {
      this.aggResultsSubject[n] = new Gs({});
      const r = ph(
        this.getSurveyDocRef(n),
        (i) => {
          var a;
          const o = (a = i.data()) == null ? void 0 : a.aggResults;
          this.aggResultsSubject[n].next(o);
        },
        (i) => {
          this.recordError(new Error("Error getting aggregate results"), i);
        }
      );
      this.unsubscribes.push(r);
    }
    return this.aggResultsSubject[n];
  }
  async addSurveyOwner(n, r) {
    await this.addSurveyOwnerFirestore({ email: n, surveyName: r });
  }
  observeSurveyOwners(n) {
    if (!this.surveyOwnersSubjects[n]) {
      this.surveyOwnersSubjects[n] = new Gs([]);
      const r = ph(
        gh(this.firestore, "surveys", n, "surveyOwners"),
        (i) => {
          const o = i.docs.map((a) => a.data().email);
          this.surveyOwnersSubjects[n].next(o);
        },
        (i) => {
          this.surveyOwnersSubjects[n].error(i), this.recordError(new Error("Error getting survey owners"), i);
        }
      );
      this.unsubscribes.push(r);
    }
    return this.surveyOwnersSubjects[n];
  }
  async getSurveyOwners(n) {
    throw new Error("Not implemented. Need to get value from firestore");
  }
  async isActive(n) {
    var r, i;
    this.log.info("isActive", n);
    try {
      return (i = (r = (await H5(this.getSurveyDocRef(n))).data()) == null ? void 0 : r.settings) == null ? void 0 : i.active;
    } catch (o) {
      return this.recordError(new Error("Could not find if survey active"), o), !1;
    }
  }
  observeSurveys(n) {
    if (this.log.info("observeSurveys", n), n.isAdmin) {
      if (!this.surveysSubject) {
        this.surveysSubject = new Gs([]);
        const r = ph(
          gh(this.firestore, "surveys"),
          (i) => {
            var a;
            const o = i.docs.map((s) => ({ id: s.id }));
            this.surveysSubject && o.length !== this.surveysSubject.value.length && ((a = this.surveysSubject) == null || a.next(o));
          },
          (i) => {
            var o;
            (o = this.surveysSubject) == null || o.error(i);
          }
        );
        this.unsubscribes.push(r);
      }
      return this.surveysSubject;
    } else {
      if (!this.surveysSubject) {
        this.surveysSubject = new Gs([]);
        const r = ph(
          gh(this.firestore, "users", n.id, "surveys"),
          (i) => {
            var a;
            const o = i.docs.map((s) => ({ id: s.id }));
            this.surveysSubject && o.length !== this.surveysSubject.value.length && ((a = this.surveysSubject) == null || a.next(o));
          }
        );
        this.unsubscribes.push(r);
      }
      return this.surveysSubject;
    }
  }
  async getSurveys(n) {
    if (this.log.info("getSurveys", n), n.isAdmin) {
      const r = await zb(gh(this.firestore, "surveys")), i = [];
      return r.forEach((o) => {
        i.push({ id: o.id });
      }), i;
    }
    return [];
  }
  async activateSurvey(n) {
    await Hb(
      this.getSurveyDocRef(n),
      {
        active: !0,
        saveResults: !0,
        aggregateResults: !0
      },
      { merge: !0 }
    ), this.addQuestionsToDb(n);
  }
  // private async setRecordAnswers(value) {
  //   const { settings } = surveyDoc
  //   if (settings) {
  //     const updateSettings = {
  //       settings: {
  //         saveResults: value, // toggle value
  //       },
  //     }
  //     db.collection('surveys')
  //       .doc(surveyName)
  //       .set(updateSettings, { merge: true })
  //     setRecording(updateSettings.settings.saveResults)
  //   }
  // }
  async addQuestionsToDb(n) {
  }
  async refreshSurveys(n) {
    const r = {};
    (await zb(gh(this.firestore, "surveys"))).forEach((a) => {
      r[a.id] = !0;
    });
    const o = n.filter((a) => !(a.settings.surveyName in r));
    try {
      await Promise.all(
        o.map(
          (a) => Hb(this.getSurveyDocRef(a.settings.surveyName), {}, { merge: !0 })
        )
      );
    } catch (a) {
      this.recordError(new Error("Error refreshing surveys"), a);
    }
  }
  observeResponseCount() {
    return this.log.info("observeResponseCounts"), this.surveyResponseCountSubject;
  }
  observeResponses() {
    return this.log.info("observeResponses"), this.surveyResponsesSubject;
  }
  getObserveResponsesQuery(n, r, i, o) {
    this.log.info("getObserveResponsesQuery", n, r, i, o), i === null && o === null && (i = { column: "submissionStarted", direction: "desc" });
    const a = [];
    switch (a.push(md(r.pageSize)), a.push(this.getOrderByQueryConstraint(i)), a.push(...this.getFilterByQueryConstraints(o)), r.action) {
      case "start":
        break;
      case "current":
        this.startDoc && a.push(v8(this.startDoc));
        break;
      case "next":
        this.endDoc && a.push(y8(this.endDoc));
        break;
      case "previous":
        this.startDoc ? a.push(b8(this.startDoc), m8(r.pageSize)) : this.log.debug("Tried to get previous but no startDoc found");
        break;
      default:
        xu(r.action);
    }
    return Bs(this.getSurveyCollectionRef(n), ...a);
  }
  getOrderByQueryConstraint(n) {
    const r = R8(n.column) ? nA[n.column] : "submissionStarted";
    return Mc(r, n.direction);
  }
  getFilterByQueryConstraints(n) {
    const r = [];
    if (n && R8(n.column)) {
      const i = nA[n.column];
      switch (i) {
        case "submissionStarted":
        case "submissionEnded":
        case "lastAnswerTime":
          if (typeof n.value != "string")
            break;
          if (n.operator === "==")
            try {
              const o = new Date(n.value), a = new Date(o.getTime() + 24 * 60 * 60 * 1e3);
              r.push(Bb(i, ">=", o)), r.push(Bb(i, "<", a));
            } catch (o) {
              this.log.error("Error parsing date", { error: o });
            }
          else
            try {
              const o = new Date(n.value);
              r.push(Bb(i, n.operator, o));
            } catch (o) {
              this.log.error("Error parsing date", { error: o });
            }
          break;
        default:
          r.push(Bb(i, n.operator, n.value));
      }
    }
    return r;
  }
  async getResponses(n, r, i) {
    let o;
    return r ? o = await this.getResultData(n, r) : o = await this.getAllResultData(n), o;
  }
  async getResponseCountAggregate(n, r, i) {
    this.log.info("getResponseCountAggregate");
    const o = [];
    o.push(this.getOrderByQueryConstraint(r)), o.push(...this.getFilterByQueryConstraints(i));
    const a = Bs(this.getSurveyCollectionRef(n), ...o);
    return (await CEe(a)).data().count;
  }
  setCurrentSurvey(n) {
    this.log.info("setCurrentSurvey", n), this.startDoc = void 0, this.endDoc = void 0, this.surveyResultsParamsSubject.next({
      surveyName: n,
      pagination: { action: "start", pageSize: 10 },
      sorter: { column: "submissionStarted", direction: "desc" },
      filter: null
    });
  }
  setPagination(n) {
    this.log.info("setPagination", n), this.surveyResultsParamsSubject.next({ ...this.surveyResultsParamsSubject.value, pagination: n });
  }
  setOrderBy(n) {
    this.log.info("setSorter", n), this.startDoc = void 0, this.endDoc = void 0, this.surveyResultsParamsSubject.next({
      ...this.surveyResultsParamsSubject.value,
      pagination: { action: "start", pageSize: 10 },
      sorter: n
    });
  }
  setFilterBy(n) {
    this.log.info("setFilterBy", n), this.startDoc = void 0, this.endDoc = void 0, this.surveyResultsParamsSubject.next({
      ...this.surveyResultsParamsSubject.value,
      pagination: { action: "start", pageSize: 10 },
      filter: n
    });
  }
  observeSurveyResultsParams() {
    return this.log.info("observeSurveyResultsParams"), this.surveyResultsParamsSubject;
  }
  async getAllResultData(n) {
    const r = Bs(
      this.getSurveyCollectionRef(n),
      Mc("submissionStarted", "desc")
    );
    try {
      return (await zb(r)).docs.map(
        (o) => W5(o.data(), o.id)
      );
    } catch (i) {
      const o = i;
      throw this.log.error(o.message, { error: o }), i;
    }
  }
  async getResultCount(n) {
    var i;
    return this.log.info("getResultCount", n), (i = (await H5(this.getSurveyDocRef(n))).data()) == null ? void 0 : i.submissionCount;
  }
  async getResultData(n, r) {
    this.log.info("getResultData", n);
    let i;
    switch (r.action) {
      case "start":
        i = Bs(
          this.getSurveyCollectionRef(n),
          Mc("submissionStarted", "desc"),
          md(r.pageSize)
        );
        break;
      case "current":
        this.startDoc ? i = Bs(
          this.getSurveyCollectionRef(n),
          Mc("submissionStarted", "desc"),
          v8(this.startDoc),
          md(r.pageSize)
        ) : i = Bs(
          this.getSurveyCollectionRef(n),
          Mc("submissionStarted", "desc"),
          md(r.pageSize)
        );
        break;
      case "next":
        this.endDoc ? i = Bs(
          this.getSurveyCollectionRef(n),
          Mc("submissionStarted", "desc"),
          y8(this.endDoc),
          md(r.pageSize)
        ) : (this.log.debug("Tried to get next, but no endDoc found"), i = Bs(
          this.getSurveyCollectionRef(n),
          Mc("submissionStarted", "desc"),
          md(r.pageSize)
        ));
        break;
      case "previous":
        this.startDoc ? i = Bs(
          this.getSurveyCollectionRef(n),
          Mc("submissionStarted", "desc"),
          b8(this.startDoc),
          m8(r.pageSize)
        ) : (this.log.debug("Tried to get previous but no startDoc found"), i = Bs(
          this.getSurveyCollectionRef(n),
          Mc("submissionStarted", "desc"),
          md(r.pageSize)
        ));
        break;
      default:
        xu(r.action);
    }
    try {
      const o = await zb(i);
      return this.startDoc = o.docs[0], this.endDoc = o.docs[o.docs.length - 1], this.startDoc && this.endDoc ? (this.log.debug("startDoc", this.startDoc.data().submissionStarted.toDate().toLocaleString()), this.log.debug("endDoc", this.endDoc.data().submissionStarted.toDate().toLocaleString()), o.docs.map(
        (a) => W5(a.data(), a.id)
      )) : [];
    } catch (o) {
      const a = o;
      throw this.log.error(a.message, { error: a }), o;
    }
  }
  async getChoiceData(n) {
    this.log.info("getChoiceData", n);
    const r = await this.getAllResultData(n), i = aCe(r), o = sCe(i).map((a) => ({
      title: a,
      dataIndex: a,
      key: a
    }));
    return [i, o];
  }
  recordError(n, r) {
    this.log.error("Database error", { error: n }), this.log.error("Database actual error", { error: r }), this.errorSubject.next(n);
  }
  observeErrors() {
    return this.errorSubject;
  }
  getSurveyDocRef(n, ...r) {
    return z5(this.firestore, "surveys", n, ...r);
  }
  getSurveyCollectionRef(n) {
    const r = {
      toFirestore: (i) => i,
      fromFirestore: (i) => i.data()
    };
    return gh(this.firestore, "surveys", n, "submissions").withConverter(r);
  }
  getNewSubmissionDocRef(n) {
    return z5(this.getSurveyCollectionRef(n));
  }
  getExistingSubmissionDocRef(n, r) {
    return z5(this.getSurveyCollectionRef(n), r);
  }
  async initialiseSubmission(n, r) {
    await Hb(n, r);
  }
  async updateSubmission(n, r) {
    Hb(n, r, { merge: !0 });
  }
  async clearAggregateResults(n) {
    this.log.info("clearAggregateResults", n);
    const r = this.getSurveyDocRef(n);
    await w8(r, {
      aggResults: IEe()
    });
  }
  async archiveSubmissions(n, r) {
    this.log.info("archiveSubmissions", n, r), await this.archiveSubmissionsFirestore({ surveyName: n, submissionIds: r });
  }
  /**
   * Generates a unique resume code, stores its SHA-256 hash on the submission document and
   * triggers a cloud function to email the user a link that contains the plain code.
   */
  async generateResumeLink(n, r, i) {
    this.log.info("generateResumeLink", n, r, i);
    const o = crypto.randomUUID(), s = new TextEncoder().encode(o), c = await crypto.subtle.digest("SHA-256", s), u = Array.from(new Uint8Array(c)).map((p) => p.toString(16).padStart(2, "0")).join(""), d = this.getExistingSubmissionDocRef(n, r);
    await w8(d, {
      resumeCodeHash: u,
      resumeCodeCreated: jn.now(),
      resumeCodeUsed: !1
    });
    const f = tA.stringify({ survey: n, sub: r, code: o }), h = `${window.location.origin}/restore?${f}`;
    await this.sendResumeEmailFirestore({ email: i, link: h });
  }
  /**
   * Attempts to claim an existing submission for the current anonymous user based on a resume code.
   * Returns the cloud function output so caller can decide what to do.
   */
  async claimSubmission(n, r, i) {
    this.log.info("claimSubmission", n, r);
    try {
      return await this.claimSubmissionFirestore({ surveyName: n, submissionId: r, code: i }), { success: !0 };
    } catch (o) {
      const a = o;
      return this.log.error("Error claiming submission", { error: a }), { success: !1, error: a };
    }
  }
  async createVocinaPreAuthLaunch(n) {
    this.log.info("createVocinaPreAuthLaunch", n);
    try {
      return (await this.createVocinaPreAuthLaunchFirestore(n)).data;
    } catch (r) {
      const i = r;
      throw this.log.error("Error creating Vocina pre-auth launch", { error: i, context: n }), i;
    }
  }
  async getSurveyRewardState(n) {
    return this.log.info("getSurveyRewardState", {
      surveyName: n.surveyName,
      campaignId: n.campaignId,
      submissionId: n.submissionId
    }), (await this.getSurveyRewardStateFirestore(n)).data;
  }
  async enterSurveyReward(n) {
    return this.log.info("enterSurveyReward", {
      surveyName: n.surveyName,
      campaignId: n.campaignId,
      submissionId: n.submissionId,
      contactMethod: n.contact ? n.contact.source === "surveyAnswer" ? "surveyAnswer" : n.contact.method : "verifiedEmail"
    }), (await this.enterSurveyRewardFirestore(n)).data;
  }
  async requestSurveyRewardEmailVerification(n) {
    return this.log.info("requestSurveyRewardEmailVerification", {
      surveyName: n.surveyName,
      campaignId: n.campaignId,
      submissionId: n.submissionId
    }), (await this.requestSurveyRewardEmailVerificationFirestore(n)).data;
  }
  async getSurveyRewardWinners(n) {
    return this.log.info("getSurveyRewardWinners", { surveyName: n }), (await this.getSurveyRewardWinnersFirestore({ surveyName: n })).data;
  }
  async getSurveyRewardEntries(n) {
    return this.log.info("getSurveyRewardEntries", { surveyName: n }), (await this.getSurveyRewardEntriesFirestore({ surveyName: n })).data;
  }
  /**
   * Explicitly create a brand-new submission document (used by the new public API).
   * This is largely the same logic that used to live inside `createInitialSubmission`,
   * but without any Redux interaction.
   */
  async createSubmission(n, r) {
    this.log.info("createSubmission", n);
    const i = jn.now(), o = this.getNewSubmissionDocRef(n), s = {
      userData: this.getUserData(r),
      answers: {},
      submissionStarted: i,
      surveyCompleted: !1,
      timeSoFarSeconds: 0,
      ...this.getInitialRewardCode()
    };
    return await this.initialiseSubmission(o, s), { submissionId: o.id };
  }
  /**
   * Load an existing submission and convert it into the shape expected by the survey slice.
   */
  async loadSubmissionState(n, r) {
    this.log.info("loadSubmissionState", { surveyName: n, submissionId: r });
    try {
      const i = this.getExistingSubmissionDocRef(n, r), o = await U5(i);
      if (!o.exists())
        return this.log.warn("Submission does not exist", { submissionId: r }), null;
      const a = o.data();
      return {
        submissionId: r,
        userAnswers: a.answers || {},
        currentQuestionId: a.currentQuestionId ?? void 0,
        currentQuestionType: a.currentQuestionType,
        questionHistory: a.questionHistory ?? [],
        unlockedSectionIds: a.unlockedSectionIds,
        completedSectionIds: a.completedSectionIds,
        timeOnCurrentQuestion: a.timeSoFarSeconds.toString(),
        isSubmitClicked: a.surveyCompleted || !1,
        direction: "forwards",
        initialised: a.initialised ?? !1
      };
    } catch (i) {
      return this.log.error("Error loading submission state", { error: i }), null;
    }
  }
  async loadExistingState(n, r, i) {
    if (this.log.info("loadExistingState", { surveyName: n, submissionId: i }), !i)
      return null;
    try {
      const o = this.getExistingSubmissionDocRef(n, i), a = await U5(o);
      if (!a.exists())
        return this.log.warn("No existing submission found", { submissionId: i }), null;
      const s = a.data();
      return {
        submissionId: i,
        userAnswers: s.answers || {},
        // We don't store these fields in Firestore, so we'll need to reconstruct them
        currentQuestionId: null,
        currentQuestionType: void 0,
        questionHistory: [],
        unlockedSectionIds: s.unlockedSectionIds,
        completedSectionIds: s.completedSectionIds,
        timeOnCurrentQuestion: "",
        isSubmitClicked: s.surveyCompleted || !1,
        direction: "forwards"
      };
    } catch (o) {
      return this.log.error("Error loading existing state", { error: o }), null;
    }
  }
}
const hK = Object.prototype.toString;
function gK(e) {
  switch (hK.call(e)) {
    case "[object Error]":
    case "[object Exception]":
    case "[object DOMException]":
      return !0;
    default:
      return pl(e, Error);
  }
}
function Fp(e, t) {
  return hK.call(e) === `[object ${t}]`;
}
function C6(e) {
  return Fp(e, "ErrorEvent");
}
function P8(e) {
  return Fp(e, "DOMError");
}
function TCe(e) {
  return Fp(e, "DOMException");
}
function pc(e) {
  return Fp(e, "String");
}
function T6(e) {
  return typeof e == "object" && e !== null && "__sentry_template_string__" in e && "__sentry_template_values__" in e;
}
function I6(e) {
  return e === null || T6(e) || typeof e != "object" && typeof e != "function";
}
function Mg(e) {
  return Fp(e, "Object");
}
function fE(e) {
  return typeof Event < "u" && pl(e, Event);
}
function ICe(e) {
  return typeof Element < "u" && pl(e, Element);
}
function $Ce(e) {
  return Fp(e, "RegExp");
}
function hE(e) {
  return !!(e && e.then && typeof e.then == "function");
}
function ACe(e) {
  return Mg(e) && "nativeEvent" in e && "preventDefault" in e && "stopPropagation" in e;
}
function pK(e) {
  return typeof e == "number" && e !== e;
}
function pl(e, t) {
  try {
    return e instanceof t;
  } catch {
    return !1;
  }
}
function mK(e) {
  return !!(typeof e == "object" && e !== null && (e.__isVue || e._isVue));
}
function lg(e, t = 0) {
  return typeof e != "string" || t === 0 || e.length <= t ? e : `${e.slice(0, t)}...`;
}
function O8(e, t) {
  if (!Array.isArray(e))
    return "";
  const n = [];
  for (let r = 0; r < e.length; r++) {
    const i = e[r];
    try {
      mK(i) ? n.push("[VueViewModel]") : n.push(String(i));
    } catch {
      n.push("[value cannot be serialized]");
    }
  }
  return n.join(t);
}
function RCe(e, t, n = !1) {
  return pc(e) ? $Ce(t) ? t.test(e) : pc(t) ? n ? e === t : e.includes(t) : !1 : !1;
}
function Vp(e, t = [], n = !1) {
  return t.some((r) => RCe(e, r, n));
}
function PCe(e, t, n = 250, r, i, o, a) {
  if (!o.exception || !o.exception.values || !a || !pl(a.originalException, Error))
    return;
  const s = o.exception.values.length > 0 ? o.exception.values[o.exception.values.length - 1] : void 0;
  s && (o.exception.values = OCe(
    rA(
      e,
      t,
      i,
      a.originalException,
      r,
      o.exception.values,
      s,
      0
    ),
    n
  ));
}
function rA(e, t, n, r, i, o, a, s) {
  if (o.length >= n + 1)
    return o;
  let c = [...o];
  if (pl(r[i], Error)) {
    M8(a, s);
    const l = e(t, r[i]), u = c.length;
    k8(l, i, u, s), c = rA(
      e,
      t,
      n,
      r[i],
      i,
      [l, ...c],
      l,
      u
    );
  }
  return Array.isArray(r.errors) && r.errors.forEach((l, u) => {
    if (pl(l, Error)) {
      M8(a, s);
      const d = e(t, l), f = c.length;
      k8(d, `errors[${u}]`, f, s), c = rA(
        e,
        t,
        n,
        l,
        i,
        [d, ...c],
        d,
        f
      );
    }
  }), c;
}
function M8(e, t) {
  e.mechanism = e.mechanism || { type: "generic", handled: !0 }, e.mechanism = {
    ...e.mechanism,
    ...e.type === "AggregateError" && { is_exception_group: !0 },
    exception_id: t
  };
}
function k8(e, t, n, r) {
  e.mechanism = e.mechanism || { type: "generic", handled: !0 }, e.mechanism = {
    ...e.mechanism,
    type: "chained",
    source: t,
    exception_id: n,
    parent_id: r
  };
}
function OCe(e, t) {
  return e.map((n) => (n.value && (n.value = lg(n.value, t)), n));
}
function qb(e) {
  return e && e.Math == Math ? e : void 0;
}
const An = typeof globalThis == "object" && qb(globalThis) || // eslint-disable-next-line no-restricted-globals
typeof window == "object" && qb(window) || typeof self == "object" && qb(self) || typeof global == "object" && qb(global) || function() {
  return this;
}() || {};
function $6() {
  return An;
}
function vK(e, t, n) {
  const r = n || An, i = r.__SENTRY__ = r.__SENTRY__ || {};
  return i[e] || (i[e] = t());
}
const ug = $6(), MCe = 80;
function ku(e, t = {}) {
  if (!e)
    return "<unknown>";
  try {
    let n = e;
    const r = 5, i = [];
    let o = 0, a = 0;
    const s = " > ", c = s.length;
    let l;
    const u = Array.isArray(t) ? t : t.keyAttrs, d = !Array.isArray(t) && t.maxStringLength || MCe;
    for (; n && o++ < r && (l = kCe(n, u), !(l === "html" || o > 1 && a + i.length * c + l.length >= d)); )
      i.push(l), a += l.length, n = n.parentNode;
    return i.reverse().join(s);
  } catch {
    return "<unknown>";
  }
}
function kCe(e, t) {
  const n = e, r = [];
  let i, o, a, s, c;
  if (!n || !n.tagName)
    return "";
  if (ug.HTMLElement && n instanceof HTMLElement && n.dataset && n.dataset.sentryComponent)
    return n.dataset.sentryComponent;
  r.push(n.tagName.toLowerCase());
  const l = t && t.length ? t.filter((d) => n.getAttribute(d)).map((d) => [d, n.getAttribute(d)]) : null;
  if (l && l.length)
    l.forEach((d) => {
      r.push(`[${d[0]}="${d[1]}"]`);
    });
  else if (n.id && r.push(`#${n.id}`), i = n.className, i && pc(i))
    for (o = i.split(/\s+/), c = 0; c < o.length; c++)
      r.push(`.${o[c]}`);
  const u = ["aria-label", "type", "name", "title", "alt"];
  for (c = 0; c < u.length; c++)
    a = u[c], s = n.getAttribute(a), s && r.push(`[${a}="${s}"]`);
  return r.join("");
}
function NCe() {
  try {
    return ug.document.location.href;
  } catch {
    return "";
  }
}
function DCe(e) {
  return ug.document && ug.document.querySelector ? ug.document.querySelector(e) : null;
}
function yK(e) {
  if (!ug.HTMLElement)
    return null;
  let t = e;
  const n = 5;
  for (let r = 0; r < n; r++) {
    if (!t)
      return null;
    if (t instanceof HTMLElement && t.dataset.sentryComponent)
      return t.dataset.sentryComponent;
    t = t.parentNode;
  }
  return null;
}
const Bp = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, jCe = "Sentry Logger ", iA = [
  "debug",
  "info",
  "warn",
  "error",
  "log",
  "assert",
  "trace"
], fS = {};
function vf(e) {
  if (!("console" in An))
    return e();
  const t = An.console, n = {}, r = Object.keys(fS);
  r.forEach((i) => {
    const o = fS[i];
    n[i] = t[i], t[i] = o;
  });
  try {
    return e();
  } finally {
    r.forEach((i) => {
      t[i] = n[i];
    });
  }
}
function LCe() {
  let e = !1;
  const t = {
    enable: () => {
      e = !0;
    },
    disable: () => {
      e = !1;
    },
    isEnabled: () => e
  };
  return Bp ? iA.forEach((n) => {
    t[n] = (...r) => {
      e && vf(() => {
        An.console[n](`${jCe}[${n}]:`, ...r);
      });
    };
  }) : iA.forEach((n) => {
    t[n] = () => {
    };
  }), t;
}
const Ce = LCe(), FCe = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function VCe(e) {
  return e === "http" || e === "https";
}
function zp(e, t = !1) {
  const { host: n, path: r, pass: i, port: o, projectId: a, protocol: s, publicKey: c } = e;
  return `${s}://${c}${t && i ? `:${i}` : ""}@${n}${o ? `:${o}` : ""}/${r && `${r}/`}${a}`;
}
function BCe(e) {
  const t = FCe.exec(e);
  if (!t) {
    vf(() => {
      console.error(`Invalid Sentry Dsn: ${e}`);
    });
    return;
  }
  const [n, r, i = "", o, a = "", s] = t.slice(1);
  let c = "", l = s;
  const u = l.split("/");
  if (u.length > 1 && (c = u.slice(0, -1).join("/"), l = u.pop()), l) {
    const d = l.match(/^\d+/);
    d && (l = d[0]);
  }
  return bK({ host: o, pass: i, path: c, projectId: l, port: a, protocol: n, publicKey: r });
}
function bK(e) {
  return {
    protocol: e.protocol,
    publicKey: e.publicKey || "",
    pass: e.pass || "",
    host: e.host,
    port: e.port || "",
    path: e.path || "",
    projectId: e.projectId
  };
}
function zCe(e) {
  if (!Bp)
    return !0;
  const { port: t, projectId: n, protocol: r } = e;
  return ["protocol", "publicKey", "host", "projectId"].find((a) => e[a] ? !1 : (Ce.error(`Invalid Sentry Dsn: ${a} missing`), !0)) ? !1 : n.match(/^\d+$/) ? VCe(r) ? t && isNaN(parseInt(t, 10)) ? (Ce.error(`Invalid Sentry Dsn: Invalid port ${t}`), !1) : !0 : (Ce.error(`Invalid Sentry Dsn: Invalid protocol ${r}`), !1) : (Ce.error(`Invalid Sentry Dsn: Invalid projectId ${n}`), !1);
}
function HCe(e) {
  const t = typeof e == "string" ? BCe(e) : bK(e);
  if (!(!t || !zCe(t)))
    return t;
}
class Zs extends Error {
  /** Display name of this error instance. */
  constructor(t, n = "warn") {
    super(t), this.message = t, this.name = new.target.prototype.constructor.name, Object.setPrototypeOf(this, new.target.prototype), this.logLevel = n;
  }
}
function Oi(e, t, n) {
  if (!(t in e))
    return;
  const r = e[t], i = n(r);
  typeof i == "function" && _K(i, r), e[t] = i;
}
function yf(e, t, n) {
  try {
    Object.defineProperty(e, t, {
      // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
      value: n,
      writable: !0,
      configurable: !0
    });
  } catch {
    Bp && Ce.log(`Failed to add non-enumerable property "${t}" to object`, e);
  }
}
function _K(e, t) {
  try {
    const n = t.prototype || {};
    e.prototype = t.prototype = n, yf(e, "__sentry_original__", t);
  } catch {
  }
}
function A6(e) {
  return e.__sentry_original__;
}
function UCe(e) {
  return Object.keys(e).map((t) => `${encodeURIComponent(t)}=${encodeURIComponent(e[t])}`).join("&");
}
function SK(e) {
  if (gK(e))
    return {
      message: e.message,
      name: e.name,
      stack: e.stack,
      ...D8(e)
    };
  if (fE(e)) {
    const t = {
      type: e.type,
      target: N8(e.target),
      currentTarget: N8(e.currentTarget),
      ...D8(e)
    };
    return typeof CustomEvent < "u" && pl(e, CustomEvent) && (t.detail = e.detail), t;
  } else
    return e;
}
function N8(e) {
  try {
    return ICe(e) ? ku(e) : Object.prototype.toString.call(e);
  } catch {
    return "<unknown>";
  }
}
function D8(e) {
  if (typeof e == "object" && e !== null) {
    const t = {};
    for (const n in e)
      Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
    return t;
  } else
    return {};
}
function WCe(e, t = 40) {
  const n = Object.keys(SK(e));
  if (n.sort(), !n.length)
    return "[object has no keys]";
  if (n[0].length >= t)
    return lg(n[0], t);
  for (let r = n.length; r > 0; r--) {
    const i = n.slice(0, r).join(", ");
    if (!(i.length > t))
      return r === n.length ? i : lg(i, t);
  }
  return "";
}
function Po(e) {
  return oA(e, /* @__PURE__ */ new Map());
}
function oA(e, t) {
  if (qCe(e)) {
    const n = t.get(e);
    if (n !== void 0)
      return n;
    const r = {};
    t.set(e, r);
    for (const i of Object.keys(e))
      typeof e[i] < "u" && (r[i] = oA(e[i], t));
    return r;
  }
  if (Array.isArray(e)) {
    const n = t.get(e);
    if (n !== void 0)
      return n;
    const r = [];
    return t.set(e, r), e.forEach((i) => {
      r.push(oA(i, t));
    }), r;
  }
  return e;
}
function qCe(e) {
  if (!Mg(e))
    return !1;
  try {
    const t = Object.getPrototypeOf(e).constructor.name;
    return !t || t === "Object";
  } catch {
    return !0;
  }
}
const wK = 50, j8 = /\(error: (.*)\)/, L8 = /captureMessage|captureException/;
function xK(...e) {
  const t = e.sort((n, r) => n[0] - r[0]).map((n) => n[1]);
  return (n, r = 0) => {
    const i = [], o = n.split(`
`);
    for (let a = r; a < o.length; a++) {
      const s = o[a];
      if (s.length > 1024)
        continue;
      const c = j8.test(s) ? s.replace(j8, "$1") : s;
      if (!c.match(/\S*Error: /)) {
        for (const l of t) {
          const u = l(c);
          if (u) {
            i.push(u);
            break;
          }
        }
        if (i.length >= wK)
          break;
      }
    }
    return KCe(i);
  };
}
function GCe(e) {
  return Array.isArray(e) ? xK(...e) : e;
}
function KCe(e) {
  if (!e.length)
    return [];
  const t = Array.from(e);
  return /sentryWrapped/.test(t[t.length - 1].function || "") && t.pop(), t.reverse(), L8.test(t[t.length - 1].function || "") && (t.pop(), L8.test(t[t.length - 1].function || "") && t.pop()), t.slice(0, wK).map((n) => ({
    ...n,
    filename: n.filename || t[t.length - 1].filename,
    function: n.function || "?"
  }));
}
const G5 = "<anonymous>";
function ml(e) {
  try {
    return !e || typeof e != "function" ? G5 : e.name || G5;
  } catch {
    return G5;
  }
}
const c_ = {}, F8 = {};
function zf(e, t) {
  c_[e] = c_[e] || [], c_[e].push(t);
}
function Hf(e, t) {
  F8[e] || (t(), F8[e] = !0);
}
function Ss(e, t) {
  const n = e && c_[e];
  if (n)
    for (const r of n)
      try {
        r(t);
      } catch (i) {
        Bp && Ce.error(
          `Error while triggering instrumentation handler.
Type: ${e}
Name: ${ml(r)}
Error:`,
          i
        );
      }
}
function YCe(e) {
  const t = "console";
  zf(t, e), Hf(t, XCe);
}
function XCe() {
  "console" in An && iA.forEach(function(e) {
    e in An.console && Oi(An.console, e, function(t) {
      return fS[e] = t, function(...n) {
        Ss("console", { args: n, level: e });
        const i = fS[e];
        i && i.apply(An.console, n);
      };
    });
  });
}
function Kr() {
  const e = An, t = e.crypto || e.msCrypto;
  let n = () => Math.random() * 16;
  try {
    if (t && t.randomUUID)
      return t.randomUUID().replace(/-/g, "");
    t && t.getRandomValues && (n = () => {
      const r = new Uint8Array(1);
      return t.getRandomValues(r), r[0];
    });
  } catch {
  }
  return ([1e7] + 1e3 + 4e3 + 8e3 + 1e11).replace(
    /[018]/g,
    (r) => (
      // eslint-disable-next-line no-bitwise
      (r ^ (n() & 15) >> r / 4).toString(16)
    )
  );
}
function EK(e) {
  return e.exception && e.exception.values ? e.exception.values[0] : void 0;
}
function Jl(e) {
  const { message: t, event_id: n } = e;
  if (t)
    return t;
  const r = EK(e);
  return r ? r.type && r.value ? `${r.type}: ${r.value}` : r.type || r.value || n || "<unknown>" : n || "<unknown>";
}
function aA(e, t, n) {
  const r = e.exception = e.exception || {}, i = r.values = r.values || [], o = i[0] = i[0] || {};
  o.value || (o.value = t || ""), o.type || (o.type = n || "Error");
}
function pv(e, t) {
  const n = EK(e);
  if (!n)
    return;
  const r = { type: "generic", handled: !0 }, i = n.mechanism;
  if (n.mechanism = { ...r, ...i, ...t }, t && "data" in t) {
    const o = { ...i && i.data, ...t.data };
    n.mechanism.data = o;
  }
}
function V8(e) {
  if (e && e.__sentry_captured__)
    return !0;
  try {
    yf(e, "__sentry_captured__", !0);
  } catch {
  }
  return !1;
}
function CK(e) {
  return Array.isArray(e) ? e : [e];
}
const Vh = An, QCe = 1e3;
let B8, sA, cA;
function TK(e) {
  const t = "dom";
  zf(t, e), Hf(t, JCe);
}
function JCe() {
  if (!Vh.document)
    return;
  const e = Ss.bind(null, "dom"), t = z8(e, !0);
  Vh.document.addEventListener("click", t, !1), Vh.document.addEventListener("keypress", t, !1), ["EventTarget", "Node"].forEach((n) => {
    const r = Vh[n] && Vh[n].prototype;
    !r || !r.hasOwnProperty || !r.hasOwnProperty("addEventListener") || (Oi(r, "addEventListener", function(i) {
      return function(o, a, s) {
        if (o === "click" || o == "keypress")
          try {
            const c = this, l = c.__sentry_instrumentation_handlers__ = c.__sentry_instrumentation_handlers__ || {}, u = l[o] = l[o] || { refCount: 0 };
            if (!u.handler) {
              const d = z8(e);
              u.handler = d, i.call(this, o, d, s);
            }
            u.refCount++;
          } catch {
          }
        return i.call(this, o, a, s);
      };
    }), Oi(
      r,
      "removeEventListener",
      function(i) {
        return function(o, a, s) {
          if (o === "click" || o == "keypress")
            try {
              const c = this, l = c.__sentry_instrumentation_handlers__ || {}, u = l[o];
              u && (u.refCount--, u.refCount <= 0 && (i.call(this, o, u.handler, s), u.handler = void 0, delete l[o]), Object.keys(l).length === 0 && delete c.__sentry_instrumentation_handlers__);
            } catch {
            }
          return i.call(this, o, a, s);
        };
      }
    ));
  });
}
function ZCe(e) {
  if (e.type !== sA)
    return !1;
  try {
    if (!e.target || e.target._sentryId !== cA)
      return !1;
  } catch {
  }
  return !0;
}
function e2e(e, t) {
  return e !== "keypress" ? !1 : !t || !t.tagName ? !0 : !(t.tagName === "INPUT" || t.tagName === "TEXTAREA" || t.isContentEditable);
}
function z8(e, t = !1) {
  return (n) => {
    if (!n || n._sentryCaptured)
      return;
    const r = t2e(n);
    if (e2e(n.type, r))
      return;
    yf(n, "_sentryCaptured", !0), r && !r._sentryId && yf(r, "_sentryId", Kr());
    const i = n.type === "keypress" ? "input" : n.type;
    ZCe(n) || (e({ event: n, name: i, global: t }), sA = n.type, cA = r ? r._sentryId : void 0), clearTimeout(B8), B8 = Vh.setTimeout(() => {
      cA = void 0, sA = void 0;
    }, QCe);
  };
}
function t2e(e) {
  try {
    return e.target;
  } catch {
    return null;
  }
}
const lA = $6();
function IK() {
  if (!("fetch" in lA))
    return !1;
  try {
    return new Headers(), new Request("http://www.example.com"), new Response(), !0;
  } catch {
    return !1;
  }
}
function uA(e) {
  return e && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(e.toString());
}
function n2e() {
  if (typeof EdgeRuntime == "string")
    return !0;
  if (!IK())
    return !1;
  if (uA(lA.fetch))
    return !0;
  let e = !1;
  const t = lA.document;
  if (t && typeof t.createElement == "function")
    try {
      const n = t.createElement("iframe");
      n.hidden = !0, t.head.appendChild(n), n.contentWindow && n.contentWindow.fetch && (e = uA(n.contentWindow.fetch)), t.head.removeChild(n);
    } catch (n) {
      Bp && Ce.warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", n);
    }
  return e;
}
function R6(e) {
  const t = "fetch";
  zf(t, e), Hf(t, r2e);
}
function r2e() {
  n2e() && Oi(An, "fetch", function(e) {
    return function(...t) {
      const { method: n, url: r } = i2e(t), i = {
        args: t,
        fetchData: {
          method: n,
          url: r
        },
        startTimestamp: Date.now()
      };
      return Ss("fetch", {
        ...i
      }), e.apply(An, t).then(
        (o) => {
          const a = {
            ...i,
            endTimestamp: Date.now(),
            response: o
          };
          return Ss("fetch", a), o;
        },
        (o) => {
          const a = {
            ...i,
            endTimestamp: Date.now(),
            error: o
          };
          throw Ss("fetch", a), o;
        }
      );
    };
  });
}
function dA(e, t) {
  return !!e && typeof e == "object" && !!e[t];
}
function H8(e) {
  return typeof e == "string" ? e : e ? dA(e, "url") ? e.url : e.toString ? e.toString() : "" : "";
}
function i2e(e) {
  if (e.length === 0)
    return { method: "GET", url: "" };
  if (e.length === 2) {
    const [n, r] = e;
    return {
      url: H8(n),
      method: dA(r, "method") ? String(r.method).toUpperCase() : "GET"
    };
  }
  const t = e[0];
  return {
    url: H8(t),
    method: dA(t, "method") ? String(t.method).toUpperCase() : "GET"
  };
}
let Gb = null;
function $K(e) {
  const t = "error";
  zf(t, e), Hf(t, o2e);
}
function o2e() {
  Gb = An.onerror, An.onerror = function(e, t, n, r, i) {
    return Ss("error", {
      column: r,
      error: i,
      line: n,
      msg: e,
      url: t
    }), Gb && !Gb.__SENTRY_LOADER__ ? Gb.apply(this, arguments) : !1;
  }, An.onerror.__SENTRY_INSTRUMENTED__ = !0;
}
let Kb = null;
function AK(e) {
  const t = "unhandledrejection";
  zf(t, e), Hf(t, a2e);
}
function a2e() {
  Kb = An.onunhandledrejection, An.onunhandledrejection = function(e) {
    return Ss("unhandledrejection", e), Kb && !Kb.__SENTRY_LOADER__ ? Kb.apply(this, arguments) : !0;
  }, An.onunhandledrejection.__SENTRY_INSTRUMENTED__ = !0;
}
const Yb = $6();
function s2e() {
  const e = Yb.chrome, t = e && e.app && e.app.runtime, n = "history" in Yb && !!Yb.history.pushState && !!Yb.history.replaceState;
  return !t && n;
}
const Im = An;
let Xb;
function gE(e) {
  const t = "history";
  zf(t, e), Hf(t, c2e);
}
function c2e() {
  if (!s2e())
    return;
  const e = Im.onpopstate;
  Im.onpopstate = function(...n) {
    const r = Im.location.href, i = Xb;
    if (Xb = r, Ss("history", { from: i, to: r }), e)
      try {
        return e.apply(this, n);
      } catch {
      }
  };
  function t(n) {
    return function(...r) {
      const i = r.length > 2 ? r[2] : void 0;
      if (i) {
        const o = Xb, a = String(i);
        Xb = a, Ss("history", { from: o, to: a });
      }
      return n.apply(this, r);
    };
  }
  Oi(Im.history, "pushState", t), Oi(Im.history, "replaceState", t);
}
const l2e = An, tu = "__sentry_xhr_v3__";
function P6(e) {
  const t = "xhr";
  zf(t, e), Hf(t, u2e);
}
function u2e() {
  if (!l2e.XMLHttpRequest)
    return;
  const e = XMLHttpRequest.prototype;
  Oi(e, "open", function(t) {
    return function(...n) {
      const r = Date.now(), i = pc(n[0]) ? n[0].toUpperCase() : void 0, o = d2e(n[1]);
      if (!i || !o)
        return t.apply(this, n);
      this[tu] = {
        method: i,
        url: o,
        request_headers: {}
      }, i === "POST" && o.match(/sentry_key/) && (this.__sentry_own_request__ = !0);
      const a = () => {
        const s = this[tu];
        if (s && this.readyState === 4) {
          try {
            s.status_code = this.status;
          } catch {
          }
          const c = {
            args: [i, o],
            endTimestamp: Date.now(),
            startTimestamp: r,
            xhr: this
          };
          Ss("xhr", c);
        }
      };
      return "onreadystatechange" in this && typeof this.onreadystatechange == "function" ? Oi(this, "onreadystatechange", function(s) {
        return function(...c) {
          return a(), s.apply(this, c);
        };
      }) : this.addEventListener("readystatechange", a), Oi(this, "setRequestHeader", function(s) {
        return function(...c) {
          const [l, u] = c, d = this[tu];
          return d && pc(l) && pc(u) && (d.request_headers[l.toLowerCase()] = u), s.apply(this, c);
        };
      }), t.apply(this, n);
    };
  }), Oi(e, "send", function(t) {
    return function(...n) {
      const r = this[tu];
      if (!r)
        return t.apply(this, n);
      n[0] !== void 0 && (r.body = n[0]);
      const i = {
        args: [r.method, r.url],
        startTimestamp: Date.now(),
        xhr: this
      };
      return Ss("xhr", i), t.apply(this, n);
    };
  });
}
function d2e(e) {
  if (pc(e))
    return e;
  try {
    return e.toString();
  } catch {
  }
}
function f2e() {
  return typeof __SENTRY_BROWSER_BUNDLE__ < "u" && !!__SENTRY_BROWSER_BUNDLE__;
}
function h2e() {
  return "npm";
}
function g2e() {
  return !f2e() && Object.prototype.toString.call(typeof process < "u" ? process : 0) === "[object process]";
}
function U8() {
  return typeof window < "u" && (!g2e() || p2e());
}
function p2e() {
  return (
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
    An.process !== void 0 && An.process.type === "renderer"
  );
}
function m2e() {
  const e = typeof WeakSet == "function", t = e ? /* @__PURE__ */ new WeakSet() : [];
  function n(i) {
    if (e)
      return t.has(i) ? !0 : (t.add(i), !1);
    for (let o = 0; o < t.length; o++)
      if (t[o] === i)
        return !0;
    return t.push(i), !1;
  }
  function r(i) {
    if (e)
      t.delete(i);
    else
      for (let o = 0; o < t.length; o++)
        if (t[o] === i) {
          t.splice(o, 1);
          break;
        }
  }
  return [n, r];
}
function Qs(e, t = 100, n = 1 / 0) {
  try {
    return fA("", e, t, n);
  } catch (r) {
    return { ERROR: `**non-serializable** (${r})` };
  }
}
function RK(e, t = 3, n = 100 * 1024) {
  const r = Qs(e, t);
  return _2e(r) > n ? RK(e, t - 1, n) : r;
}
function fA(e, t, n = 1 / 0, r = 1 / 0, i = m2e()) {
  const [o, a] = i;
  if (t == null || // this matches null and undefined -> eqeq not eqeqeq
  ["number", "boolean", "string"].includes(typeof t) && !pK(t))
    return t;
  const s = v2e(e, t);
  if (!s.startsWith("[object "))
    return s;
  if (t.__sentry_skip_normalization__)
    return t;
  const c = typeof t.__sentry_override_normalization_depth__ == "number" ? t.__sentry_override_normalization_depth__ : n;
  if (c === 0)
    return s.replace("object ", "");
  if (o(t))
    return "[Circular ~]";
  const l = t;
  if (l && typeof l.toJSON == "function")
    try {
      const h = l.toJSON();
      return fA("", h, c - 1, r, i);
    } catch {
    }
  const u = Array.isArray(t) ? [] : {};
  let d = 0;
  const f = SK(t);
  for (const h in f) {
    if (!Object.prototype.hasOwnProperty.call(f, h))
      continue;
    if (d >= r) {
      u[h] = "[MaxProperties ~]";
      break;
    }
    const p = f[h];
    u[h] = fA(h, p, c - 1, r, i), d++;
  }
  return a(t), u;
}
function v2e(e, t) {
  try {
    if (e === "domain" && t && typeof t == "object" && t._events)
      return "[Domain]";
    if (e === "domainEmitter")
      return "[DomainEmitter]";
    if (typeof global < "u" && t === global)
      return "[Global]";
    if (typeof window < "u" && t === window)
      return "[Window]";
    if (typeof document < "u" && t === document)
      return "[Document]";
    if (mK(t))
      return "[VueViewModel]";
    if (ACe(t))
      return "[SyntheticEvent]";
    if (typeof t == "number" && t !== t)
      return "[NaN]";
    if (typeof t == "function")
      return `[Function: ${ml(t)}]`;
    if (typeof t == "symbol")
      return `[${String(t)}]`;
    if (typeof t == "bigint")
      return `[BigInt: ${String(t)}]`;
    const n = y2e(t);
    return /^HTML(\w*)Element$/.test(n) ? `[HTMLElement: ${n}]` : `[object ${n}]`;
  } catch (n) {
    return `**non-serializable** (${n})`;
  }
}
function y2e(e) {
  const t = Object.getPrototypeOf(e);
  return t ? t.constructor.name : "null prototype";
}
function b2e(e) {
  return ~-encodeURI(e).split(/%..|./).length;
}
function _2e(e) {
  return b2e(JSON.stringify(e));
}
var Uc;
(function(e) {
  e[e.PENDING = 0] = "PENDING";
  const n = 1;
  e[e.RESOLVED = n] = "RESOLVED";
  const r = 2;
  e[e.REJECTED = r] = "REJECTED";
})(Uc || (Uc = {}));
function kg(e) {
  return new pa((t) => {
    t(e);
  });
}
function O6(e) {
  return new pa((t, n) => {
    n(e);
  });
}
class pa {
  constructor(t) {
    pa.prototype.__init.call(this), pa.prototype.__init2.call(this), pa.prototype.__init3.call(this), pa.prototype.__init4.call(this), this._state = Uc.PENDING, this._handlers = [];
    try {
      t(this._resolve, this._reject);
    } catch (n) {
      this._reject(n);
    }
  }
  /** JSDoc */
  then(t, n) {
    return new pa((r, i) => {
      this._handlers.push([
        !1,
        (o) => {
          if (!t)
            r(o);
          else
            try {
              r(t(o));
            } catch (a) {
              i(a);
            }
        },
        (o) => {
          if (!n)
            i(o);
          else
            try {
              r(n(o));
            } catch (a) {
              i(a);
            }
        }
      ]), this._executeHandlers();
    });
  }
  /** JSDoc */
  catch(t) {
    return this.then((n) => n, t);
  }
  /** JSDoc */
  finally(t) {
    return new pa((n, r) => {
      let i, o;
      return this.then(
        (a) => {
          o = !1, i = a, t && t();
        },
        (a) => {
          o = !0, i = a, t && t();
        }
      ).then(() => {
        if (o) {
          r(i);
          return;
        }
        n(i);
      });
    });
  }
  /** JSDoc */
  __init() {
    this._resolve = (t) => {
      this._setResult(Uc.RESOLVED, t);
    };
  }
  /** JSDoc */
  __init2() {
    this._reject = (t) => {
      this._setResult(Uc.REJECTED, t);
    };
  }
  /** JSDoc */
  __init3() {
    this._setResult = (t, n) => {
      if (this._state === Uc.PENDING) {
        if (hE(n)) {
          n.then(this._resolve, this._reject);
          return;
        }
        this._state = t, this._value = n, this._executeHandlers();
      }
    };
  }
  /** JSDoc */
  __init4() {
    this._executeHandlers = () => {
      if (this._state === Uc.PENDING)
        return;
      const t = this._handlers.slice();
      this._handlers = [], t.forEach((n) => {
        n[0] || (this._state === Uc.RESOLVED && n[1](this._value), this._state === Uc.REJECTED && n[2](this._value), n[0] = !0);
      });
    };
  }
}
function S2e(e) {
  const t = [];
  function n() {
    return e === void 0 || t.length < e;
  }
  function r(a) {
    return t.splice(t.indexOf(a), 1)[0];
  }
  function i(a) {
    if (!n())
      return O6(new Zs("Not adding Promise because buffer limit was reached."));
    const s = a();
    return t.indexOf(s) === -1 && t.push(s), s.then(() => r(s)).then(
      null,
      () => r(s).then(null, () => {
      })
    ), s;
  }
  function o(a) {
    return new pa((s, c) => {
      let l = t.length;
      if (!l)
        return s(!0);
      const u = setTimeout(() => {
        a && a > 0 && s(!1);
      }, a);
      t.forEach((d) => {
        kg(d).then(() => {
          --l || (clearTimeout(u), s(!0));
        }, c);
      });
    });
  }
  return {
    $: t,
    add: i,
    drain: o
  };
}
function Yd(e) {
  if (!e)
    return {};
  const t = e.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
  if (!t)
    return {};
  const n = t[6] || "", r = t[8] || "";
  return {
    host: t[4],
    path: t[5],
    protocol: t[2],
    search: n,
    hash: r,
    relative: t[5] + n + r
    // everything minus origin
  };
}
const w2e = ["fatal", "error", "warning", "log", "info", "debug"];
function x2e(e) {
  return e === "warn" ? "warning" : w2e.includes(e) ? e : "log";
}
const PK = 1e3;
function yy() {
  return Date.now() / PK;
}
function E2e() {
  const { performance: e } = An;
  if (!e || !e.now)
    return yy;
  const t = Date.now() - e.now(), n = e.timeOrigin == null ? t : e.timeOrigin;
  return () => (n + e.now()) / PK;
}
const by = E2e(), wa = (() => {
  const { performance: e } = An;
  if (!e || !e.now)
    return;
  const t = 3600 * 1e3, n = e.now(), r = Date.now(), i = e.timeOrigin ? Math.abs(e.timeOrigin + n - r) : t, o = i < t, a = e.timing && e.timing.navigationStart, c = typeof a == "number" ? Math.abs(a + n - r) : t, l = c < t;
  return o || l ? i <= c ? e.timeOrigin : a : r;
})(), hA = "baggage", OK = "sentry-", C2e = /^sentry-/, T2e = 8192;
function I2e(e) {
  if (!pc(e) && !Array.isArray(e))
    return;
  let t = {};
  if (Array.isArray(e))
    t = e.reduce((r, i) => {
      const o = W8(i);
      for (const a of Object.keys(o))
        r[a] = o[a];
      return r;
    }, {});
  else {
    if (!e)
      return;
    t = W8(e);
  }
  const n = Object.entries(t).reduce((r, [i, o]) => {
    if (i.match(C2e)) {
      const a = i.slice(OK.length);
      r[a] = o;
    }
    return r;
  }, {});
  if (Object.keys(n).length > 0)
    return n;
}
function MK(e) {
  if (!e)
    return;
  const t = Object.entries(e).reduce(
    (n, [r, i]) => (i && (n[`${OK}${r}`] = i), n),
    {}
  );
  return $2e(t);
}
function W8(e) {
  return e.split(",").map((t) => t.split("=").map((n) => decodeURIComponent(n.trim()))).reduce((t, [n, r]) => (t[n] = r, t), {});
}
function $2e(e) {
  if (Object.keys(e).length !== 0)
    return Object.entries(e).reduce((t, [n, r], i) => {
      const o = `${encodeURIComponent(n)}=${encodeURIComponent(r)}`, a = i === 0 ? o : `${t},${o}`;
      return a.length > T2e ? (Bp && Ce.warn(
        `Not adding key: ${n} with val: ${r} to baggage header due to exceeding baggage size limits.`
      ), t) : a;
    }, "");
}
const A2e = new RegExp(
  "^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$"
  // whitespace
);
function R2e(e) {
  if (!e)
    return;
  const t = e.match(A2e);
  if (!t)
    return;
  let n;
  return t[3] === "1" ? n = !0 : t[3] === "0" && (n = !1), {
    traceId: t[1],
    parentSampled: n,
    parentSpanId: t[2]
  };
}
function P2e(e, t) {
  const n = R2e(e), r = I2e(t), { traceId: i, parentSpanId: o, parentSampled: a } = n || {};
  return n ? {
    traceId: i || Kr(),
    parentSpanId: o || Kr().substring(16),
    spanId: Kr().substring(16),
    sampled: a,
    dsc: r || {}
    // If we have traceparent data but no DSC it means we are not head of trace and we must freeze it
  } : {
    traceId: i || Kr(),
    spanId: Kr().substring(16)
  };
}
function M6(e = Kr(), t = Kr().substring(16), n) {
  let r = "";
  return n !== void 0 && (r = n ? "-1" : "-0"), `${e}-${t}${r}`;
}
function ed(e, t = []) {
  return [e, t];
}
function O2e(e, t) {
  const [n, r] = e;
  return [n, [...r, t]];
}
function q8(e, t) {
  const n = e[1];
  for (const r of n) {
    const i = r[0].type;
    if (t(r, i))
      return !0;
  }
  return !1;
}
function gA(e, t) {
  return (t || new TextEncoder()).encode(e);
}
function M2e(e, t) {
  const [n, r] = e;
  let i = JSON.stringify(n);
  function o(a) {
    typeof i == "string" ? i = typeof a == "string" ? i + a : [gA(i, t), a] : i.push(typeof a == "string" ? gA(a, t) : a);
  }
  for (const a of r) {
    const [s, c] = a;
    if (o(`
${JSON.stringify(s)}
`), typeof c == "string" || c instanceof Uint8Array)
      o(c);
    else {
      let l;
      try {
        l = JSON.stringify(c);
      } catch {
        l = JSON.stringify(Qs(c));
      }
      o(l);
    }
  }
  return typeof i == "string" ? i : k2e(i);
}
function k2e(e) {
  const t = e.reduce((i, o) => i + o.length, 0), n = new Uint8Array(t);
  let r = 0;
  for (const i of e)
    n.set(i, r), r += i.length;
  return n;
}
function N2e(e, t) {
  const n = typeof e.data == "string" ? gA(e.data, t) : e.data;
  return [
    Po({
      type: "attachment",
      length: n.length,
      filename: e.filename,
      content_type: e.contentType,
      attachment_type: e.attachmentType
    }),
    n
  ];
}
const D2e = {
  session: "session",
  sessions: "session",
  attachment: "attachment",
  transaction: "transaction",
  event: "error",
  client_report: "internal",
  user_report: "default",
  profile: "profile",
  replay_event: "replay",
  replay_recording: "replay",
  check_in: "monitor",
  feedback: "feedback",
  span: "span",
  statsd: "metric_bucket"
};
function G8(e) {
  return D2e[e];
}
function k6(e) {
  if (!e || !e.sdk)
    return;
  const { name: t, version: n } = e.sdk;
  return { name: t, version: n };
}
function kK(e, t, n, r) {
  const i = e.sdkProcessingMetadata && e.sdkProcessingMetadata.dynamicSamplingContext;
  return {
    event_id: e.event_id,
    sent_at: (/* @__PURE__ */ new Date()).toISOString(),
    ...t && { sdk: t },
    ...!!n && r && { dsn: zp(r) },
    ...i && {
      trace: Po({ ...i })
    }
  };
}
function j2e(e, t, n) {
  const r = [
    { type: "client_report" },
    {
      timestamp: n || yy(),
      discarded_events: e
    }
  ];
  return ed(t ? { dsn: t } : {}, [r]);
}
const L2e = 60 * 1e3;
function F2e(e, t = Date.now()) {
  const n = parseInt(`${e}`, 10);
  if (!isNaN(n))
    return n * 1e3;
  const r = Date.parse(`${e}`);
  return isNaN(r) ? L2e : r - t;
}
function V2e(e, t) {
  return e[t] || e.all || 0;
}
function NK(e, t, n = Date.now()) {
  return V2e(e, t) > n;
}
function DK(e, { statusCode: t, headers: n }, r = Date.now()) {
  const i = {
    ...e
  }, o = n && n["x-sentry-rate-limits"], a = n && n["retry-after"];
  if (o)
    for (const s of o.trim().split(",")) {
      const [c, l, , , u] = s.split(":", 5), d = parseInt(c, 10), f = (isNaN(d) ? 60 : d) * 1e3;
      if (!l)
        i.all = r + f;
      else
        for (const h of l.split(";"))
          h === "metric_bucket" ? (!u || u.split(";").includes("custom")) && (i[h] = r + f) : i[h] = r + f;
    }
  else
    a ? i.all = r + F2e(a, r) : t === 429 && (i.all = r + 60 * 1e3);
  return i;
}
function B2e(e, t) {
  return e ?? t();
}
function K5(e) {
  let t, n = e[0], r = 1;
  for (; r < e.length; ) {
    const i = e[r], o = e[r + 1];
    if (r += 2, (i === "optionalAccess" || i === "optionalCall") && n == null)
      return;
    i === "access" || i === "optionalAccess" ? (t = n, n = o(n)) : (i === "call" || i === "optionalCall") && (n = o((...a) => n.call(t, ...a)), t = void 0);
  }
  return n;
}
const jt = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, pE = "production";
function N6() {
  return vK("globalEventProcessors", () => []);
}
function z2e(e) {
  N6().push(e);
}
function hS(e, t, n, r = 0) {
  return new pa((i, o) => {
    const a = e[r];
    if (t === null || typeof a != "function")
      i(t);
    else {
      const s = a({ ...t }, n);
      jt && a.id && s === null && Ce.log(`Event processor "${a.id}" dropped event`), hE(s) ? s.then((c) => hS(e, c, n, r + 1).then(i)).then(null, o) : hS(e, s, n, r + 1).then(i).then(null, o);
    }
  });
}
function jK(e) {
  const t = by(), n = {
    sid: Kr(),
    init: !0,
    timestamp: t,
    started: t,
    duration: 0,
    status: "ok",
    errors: 0,
    ignoreDuration: !1,
    toJSON: () => H2e(n)
  };
  return e && bf(n, e), n;
}
function bf(e, t = {}) {
  if (t.user && (!e.ipAddress && t.user.ip_address && (e.ipAddress = t.user.ip_address), !e.did && !t.did && (e.did = t.user.id || t.user.email || t.user.username)), e.timestamp = t.timestamp || by(), t.abnormal_mechanism && (e.abnormal_mechanism = t.abnormal_mechanism), t.ignoreDuration && (e.ignoreDuration = t.ignoreDuration), t.sid && (e.sid = t.sid.length === 32 ? t.sid : Kr()), t.init !== void 0 && (e.init = t.init), !e.did && t.did && (e.did = `${t.did}`), typeof t.started == "number" && (e.started = t.started), e.ignoreDuration)
    e.duration = void 0;
  else if (typeof t.duration == "number")
    e.duration = t.duration;
  else {
    const n = e.timestamp - e.started;
    e.duration = n >= 0 ? n : 0;
  }
  t.release && (e.release = t.release), t.environment && (e.environment = t.environment), !e.ipAddress && t.ipAddress && (e.ipAddress = t.ipAddress), !e.userAgent && t.userAgent && (e.userAgent = t.userAgent), typeof t.errors == "number" && (e.errors = t.errors), t.status && (e.status = t.status);
}
function LK(e, t) {
  let n = {};
  t ? n = { status: t } : e.status === "ok" && (n = { status: "exited" }), bf(e, n);
}
function H2e(e) {
  return Po({
    sid: `${e.sid}`,
    init: e.init,
    // Make sure that sec is converted to ms for date constructor
    started: new Date(e.started * 1e3).toISOString(),
    timestamp: new Date(e.timestamp * 1e3).toISOString(),
    status: e.status,
    errors: e.errors,
    did: typeof e.did == "number" || typeof e.did == "string" ? `${e.did}` : void 0,
    duration: e.duration,
    abnormal_mechanism: e.abnormal_mechanism,
    attrs: {
      release: e.release,
      environment: e.environment,
      ip_address: e.ipAddress,
      user_agent: e.userAgent
    }
  });
}
const U2e = 0, FK = 1;
function D6(e) {
  const { spanId: t, traceId: n } = e.spanContext(), { data: r, op: i, parent_span_id: o, status: a, tags: s, origin: c } = qi(e);
  return Po({
    data: r,
    op: i,
    parent_span_id: o,
    span_id: t,
    status: a,
    tags: s,
    trace_id: n,
    origin: c
  });
}
function mE(e) {
  const { traceId: t, spanId: n } = e.spanContext(), r = j6(e);
  return M6(t, n, r);
}
function vE(e) {
  return typeof e == "number" ? K8(e) : Array.isArray(e) ? e[0] + e[1] / 1e9 : e instanceof Date ? K8(e.getTime()) : by();
}
function K8(e) {
  return e > 9999999999 ? e / 1e3 : e;
}
function qi(e) {
  return W2e(e) ? e.getSpanJSON() : typeof e.toJSON == "function" ? e.toJSON() : {};
}
function W2e(e) {
  return typeof e.getSpanJSON == "function";
}
function j6(e) {
  const { traceFlags: t } = e.spanContext();
  return !!(t & FK);
}
function VK(e, t, n, r, i, o) {
  const { normalizeDepth: a = 3, normalizeMaxBreadth: s = 1e3 } = e, c = {
    ...t,
    event_id: t.event_id || n.event_id || Kr(),
    timestamp: t.timestamp || yy()
  }, l = n.integrations || e.integrations.map((m) => m.name);
  q2e(c, e), Y2e(c, l), t.type === void 0 && G2e(c, e.stackParser);
  const u = Q2e(r, n.captureContext);
  n.mechanism && pv(c, n.mechanism);
  const d = i && i.getEventProcessors ? i.getEventProcessors() : [], f = u5e().getScopeData();
  if (o) {
    const m = o.getScopeData();
    J8(f, m);
  }
  if (u) {
    const m = u.getScopeData();
    J8(f, m);
  }
  const h = [...n.attachments || [], ...f.attachments];
  h.length && (n.attachments = h), UK(c, f);
  const p = [
    ...d,
    // eslint-disable-next-line deprecation/deprecation
    ...N6(),
    // Run scope event processors _after_ all other processors
    ...f.eventProcessors
  ];
  return hS(p, c, n).then((m) => (m && K2e(m), typeof a == "number" && a > 0 ? X2e(m, a, s) : m));
}
function q2e(e, t) {
  const { environment: n, release: r, dist: i, maxValueLength: o = 250 } = t;
  "environment" in e || (e.environment = "environment" in t ? n : pE), e.release === void 0 && r !== void 0 && (e.release = r), e.dist === void 0 && i !== void 0 && (e.dist = i), e.message && (e.message = lg(e.message, o));
  const a = e.exception && e.exception.values && e.exception.values[0];
  a && a.value && (a.value = lg(a.value, o));
  const s = e.request;
  s && s.url && (s.url = lg(s.url, o));
}
const Y8 = /* @__PURE__ */ new WeakMap();
function G2e(e, t) {
  const n = An._sentryDebugIds;
  if (!n)
    return;
  let r;
  const i = Y8.get(t);
  i ? r = i : (r = /* @__PURE__ */ new Map(), Y8.set(t, r));
  const o = Object.keys(n).reduce((a, s) => {
    let c;
    const l = r.get(s);
    l ? c = l : (c = t(s), r.set(s, c));
    for (let u = c.length - 1; u >= 0; u--) {
      const d = c[u];
      if (d.filename) {
        a[d.filename] = n[s];
        break;
      }
    }
    return a;
  }, {});
  try {
    e.exception.values.forEach((a) => {
      a.stacktrace.frames.forEach((s) => {
        s.filename && (s.debug_id = o[s.filename]);
      });
    });
  } catch {
  }
}
function K2e(e) {
  const t = {};
  try {
    e.exception.values.forEach((r) => {
      r.stacktrace.frames.forEach((i) => {
        i.debug_id && (i.abs_path ? t[i.abs_path] = i.debug_id : i.filename && (t[i.filename] = i.debug_id), delete i.debug_id);
      });
    });
  } catch {
  }
  if (Object.keys(t).length === 0)
    return;
  e.debug_meta = e.debug_meta || {}, e.debug_meta.images = e.debug_meta.images || [];
  const n = e.debug_meta.images;
  Object.keys(t).forEach((r) => {
    n.push({
      type: "sourcemap",
      code_file: r,
      debug_id: t[r]
    });
  });
}
function Y2e(e, t) {
  t.length > 0 && (e.sdk = e.sdk || {}, e.sdk.integrations = [...e.sdk.integrations || [], ...t]);
}
function X2e(e, t, n) {
  if (!e)
    return null;
  const r = {
    ...e,
    ...e.breadcrumbs && {
      breadcrumbs: e.breadcrumbs.map((i) => ({
        ...i,
        ...i.data && {
          data: Qs(i.data, t, n)
        }
      }))
    },
    ...e.user && {
      user: Qs(e.user, t, n)
    },
    ...e.contexts && {
      contexts: Qs(e.contexts, t, n)
    },
    ...e.extra && {
      extra: Qs(e.extra, t, n)
    }
  };
  return e.contexts && e.contexts.trace && r.contexts && (r.contexts.trace = e.contexts.trace, e.contexts.trace.data && (r.contexts.trace.data = Qs(e.contexts.trace.data, t, n))), e.spans && (r.spans = e.spans.map((i) => {
    const o = qi(i).data;
    return o && (i.data = Qs(o, t, n)), i;
  })), r;
}
function Q2e(e, t) {
  if (!t)
    return e;
  const n = e ? e.clone() : new il();
  return n.update(t), n;
}
function J2e(e) {
  if (e)
    return Z2e(e) ? { captureContext: e } : t5e(e) ? {
      captureContext: e
    } : e;
}
function Z2e(e) {
  return e instanceof il || typeof e == "function";
}
const e5e = [
  "user",
  "level",
  "extra",
  "contexts",
  "tags",
  "fingerprint",
  "requestSession",
  "propagationContext"
];
function t5e(e) {
  return Object.keys(e).some((t) => e5e.includes(t));
}
function yE(e, t) {
  return Ia().captureException(e, J2e(t));
}
function BK(e, t) {
  return Ia().captureEvent(e, t);
}
function Nu(e, t) {
  Ia().addBreadcrumb(e, t);
}
function n5e(e, t) {
  Ia().setContext(e, t);
}
function r5e(...e) {
  const t = Ia();
  if (e.length === 2) {
    const [n, r] = e;
    return n ? t.withScope(() => (t.getStackTop().scope = n, r(n))) : t.withScope(r);
  }
  return t.withScope(e[0]);
}
function Jn() {
  return Ia().getClient();
}
function Ta() {
  return Ia().getScope();
}
function X8(e) {
  const t = Jn(), n = td(), r = Ta(), { release: i, environment: o = pE } = t && t.getOptions() || {}, { userAgent: a } = An.navigator || {}, s = jK({
    release: i,
    environment: o,
    user: r.getUser() || n.getUser(),
    ...a && { userAgent: a },
    ...e
  }), c = n.getSession();
  return c && c.status === "ok" && bf(c, { status: "exited" }), zK(), n.setSession(s), r.setSession(s), s;
}
function zK() {
  const e = td(), t = Ta(), n = t.getSession() || e.getSession();
  n && LK(n), HK(), e.setSession(), t.setSession();
}
function HK() {
  const e = td(), t = Ta(), n = Jn(), r = t.getSession() || e.getSession();
  r && n && n.captureSession && n.captureSession(r);
}
function Q8(e = !1) {
  if (e) {
    zK();
    return;
  }
  HK();
}
function gS(e) {
  return e.transaction;
}
function bE(e, t, n) {
  const r = t.getOptions(), { publicKey: i } = t.getDsn() || {}, { segment: o } = n && n.getUser() || {}, a = Po({
    environment: r.environment || pE,
    release: r.release,
    user_segment: o,
    public_key: i,
    trace_id: e
  });
  return t.emit && t.emit("createDsc", a), a;
}
function Ng(e) {
  const t = Jn();
  if (!t)
    return {};
  const n = bE(qi(e).trace_id || "", t, Ta()), r = gS(e);
  if (!r)
    return n;
  const i = r && r._frozenDynamicSamplingContext;
  if (i)
    return i;
  const { sampleRate: o, source: a } = r.metadata;
  o != null && (n.sample_rate = `${o}`);
  const s = qi(r);
  return a && a !== "url" && (n.transaction = s.description), n.sampled = String(j6(r)), t.emit && t.emit("createDsc", n), n;
}
function UK(e, t) {
  const { fingerprint: n, span: r, breadcrumbs: i, sdkProcessingMetadata: o } = t;
  i5e(e, t), r && s5e(e, r), c5e(e, n), o5e(e, i), a5e(e, o);
}
function J8(e, t) {
  const {
    extra: n,
    tags: r,
    user: i,
    contexts: o,
    level: a,
    sdkProcessingMetadata: s,
    breadcrumbs: c,
    fingerprint: l,
    eventProcessors: u,
    attachments: d,
    propagationContext: f,
    // eslint-disable-next-line deprecation/deprecation
    transactionName: h,
    span: p
  } = t;
  $m(e, "extra", n), $m(e, "tags", r), $m(e, "user", i), $m(e, "contexts", o), $m(e, "sdkProcessingMetadata", s), a && (e.level = a), h && (e.transactionName = h), p && (e.span = p), c.length && (e.breadcrumbs = [...e.breadcrumbs, ...c]), l.length && (e.fingerprint = [...e.fingerprint, ...l]), u.length && (e.eventProcessors = [...e.eventProcessors, ...u]), d.length && (e.attachments = [...e.attachments, ...d]), e.propagationContext = { ...e.propagationContext, ...f };
}
function $m(e, t, n) {
  if (n && Object.keys(n).length) {
    e[t] = { ...e[t] };
    for (const r in n)
      Object.prototype.hasOwnProperty.call(n, r) && (e[t][r] = n[r]);
  }
}
function i5e(e, t) {
  const {
    extra: n,
    tags: r,
    user: i,
    contexts: o,
    level: a,
    // eslint-disable-next-line deprecation/deprecation
    transactionName: s
  } = t, c = Po(n);
  c && Object.keys(c).length && (e.extra = { ...c, ...e.extra });
  const l = Po(r);
  l && Object.keys(l).length && (e.tags = { ...l, ...e.tags });
  const u = Po(i);
  u && Object.keys(u).length && (e.user = { ...u, ...e.user });
  const d = Po(o);
  d && Object.keys(d).length && (e.contexts = { ...d, ...e.contexts }), a && (e.level = a), s && (e.transaction = s);
}
function o5e(e, t) {
  const n = [...e.breadcrumbs || [], ...t];
  e.breadcrumbs = n.length ? n : void 0;
}
function a5e(e, t) {
  e.sdkProcessingMetadata = {
    ...e.sdkProcessingMetadata,
    ...t
  };
}
function s5e(e, t) {
  e.contexts = { trace: D6(t), ...e.contexts };
  const n = gS(t);
  if (n) {
    e.sdkProcessingMetadata = {
      dynamicSamplingContext: Ng(t),
      ...e.sdkProcessingMetadata
    };
    const r = qi(n).description;
    r && (e.tags = { transaction: r, ...e.tags });
  }
}
function c5e(e, t) {
  e.fingerprint = e.fingerprint ? CK(e.fingerprint) : [], t && (e.fingerprint = e.fingerprint.concat(t)), e.fingerprint && !e.fingerprint.length && delete e.fingerprint;
}
const l5e = 100;
let Y5;
class il {
  /** Flag if notifying is happening. */
  /** Callback for client to receive scope changes. */
  /** Callback list that will be called after {@link applyToEvent}. */
  /** Array of breadcrumbs. */
  /** User */
  /** Tags */
  /** Extra */
  /** Contexts */
  /** Attachments */
  /** Propagation Context for distributed tracing */
  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */
  /** Fingerprint */
  /** Severity */
  // eslint-disable-next-line deprecation/deprecation
  /**
   * Transaction Name
   */
  /** Span */
  /** Session */
  /** Request Mode Session Status */
  /** The client on this scope */
  // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
  constructor() {
    this._notifyingListeners = !1, this._scopeListeners = [], this._eventProcessors = [], this._breadcrumbs = [], this._attachments = [], this._user = {}, this._tags = {}, this._extra = {}, this._contexts = {}, this._sdkProcessingMetadata = {}, this._propagationContext = Z8();
  }
  /**
   * Inherit values from the parent scope.
   * @deprecated Use `scope.clone()` and `new Scope()` instead.
   */
  static clone(t) {
    return t ? t.clone() : new il();
  }
  /**
   * Clone this scope instance.
   */
  clone() {
    const t = new il();
    return t._breadcrumbs = [...this._breadcrumbs], t._tags = { ...this._tags }, t._extra = { ...this._extra }, t._contexts = { ...this._contexts }, t._user = this._user, t._level = this._level, t._span = this._span, t._session = this._session, t._transactionName = this._transactionName, t._fingerprint = this._fingerprint, t._eventProcessors = [...this._eventProcessors], t._requestSession = this._requestSession, t._attachments = [...this._attachments], t._sdkProcessingMetadata = { ...this._sdkProcessingMetadata }, t._propagationContext = { ...this._propagationContext }, t._client = this._client, t;
  }
  /** Update the client on the scope. */
  setClient(t) {
    this._client = t;
  }
  /**
   * Get the client assigned to this scope.
   *
   * It is generally recommended to use the global function `Sentry.getClient()` instead, unless you know what you are doing.
   */
  getClient() {
    return this._client;
  }
  /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */
  addScopeListener(t) {
    this._scopeListeners.push(t);
  }
  /**
   * @inheritDoc
   */
  addEventProcessor(t) {
    return this._eventProcessors.push(t), this;
  }
  /**
   * @inheritDoc
   */
  setUser(t) {
    return this._user = t || {
      email: void 0,
      id: void 0,
      ip_address: void 0,
      segment: void 0,
      username: void 0
    }, this._session && bf(this._session, { user: t }), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getUser() {
    return this._user;
  }
  /**
   * @inheritDoc
   */
  getRequestSession() {
    return this._requestSession;
  }
  /**
   * @inheritDoc
   */
  setRequestSession(t) {
    return this._requestSession = t, this;
  }
  /**
   * @inheritDoc
   */
  setTags(t) {
    return this._tags = {
      ...this._tags,
      ...t
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTag(t, n) {
    return this._tags = { ...this._tags, [t]: n }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtras(t) {
    return this._extra = {
      ...this._extra,
      ...t
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtra(t, n) {
    return this._extra = { ...this._extra, [t]: n }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setFingerprint(t) {
    return this._fingerprint = t, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setLevel(t) {
    return this._level = t, this._notifyScopeListeners(), this;
  }
  /**
   * Sets the transaction name on the scope for future events.
   */
  setTransactionName(t) {
    return this._transactionName = t, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setContext(t, n) {
    return n === null ? delete this._contexts[t] : this._contexts[t] = n, this._notifyScopeListeners(), this;
  }
  /**
   * Sets the Span on the scope.
   * @param span Span
   * @deprecated Instead of setting a span on a scope, use `startSpan()`/`startSpanManual()` instead.
   */
  setSpan(t) {
    return this._span = t, this._notifyScopeListeners(), this;
  }
  /**
   * Returns the `Span` if there is one.
   * @deprecated Use `getActiveSpan()` instead.
   */
  getSpan() {
    return this._span;
  }
  /**
   * Returns the `Transaction` attached to the scope (if there is one).
   * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
   */
  getTransaction() {
    const t = this._span;
    return t && t.transaction;
  }
  /**
   * @inheritDoc
   */
  setSession(t) {
    return t ? this._session = t : delete this._session, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getSession() {
    return this._session;
  }
  /**
   * @inheritDoc
   */
  update(t) {
    if (!t)
      return this;
    const n = typeof t == "function" ? t(this) : t;
    if (n instanceof il) {
      const r = n.getScopeData();
      this._tags = { ...this._tags, ...r.tags }, this._extra = { ...this._extra, ...r.extra }, this._contexts = { ...this._contexts, ...r.contexts }, r.user && Object.keys(r.user).length && (this._user = r.user), r.level && (this._level = r.level), r.fingerprint.length && (this._fingerprint = r.fingerprint), n.getRequestSession() && (this._requestSession = n.getRequestSession()), r.propagationContext && (this._propagationContext = r.propagationContext);
    } else if (Mg(n)) {
      const r = t;
      this._tags = { ...this._tags, ...r.tags }, this._extra = { ...this._extra, ...r.extra }, this._contexts = { ...this._contexts, ...r.contexts }, r.user && (this._user = r.user), r.level && (this._level = r.level), r.fingerprint && (this._fingerprint = r.fingerprint), r.requestSession && (this._requestSession = r.requestSession), r.propagationContext && (this._propagationContext = r.propagationContext);
    }
    return this;
  }
  /**
   * @inheritDoc
   */
  clear() {
    return this._breadcrumbs = [], this._tags = {}, this._extra = {}, this._user = {}, this._contexts = {}, this._level = void 0, this._transactionName = void 0, this._fingerprint = void 0, this._requestSession = void 0, this._span = void 0, this._session = void 0, this._notifyScopeListeners(), this._attachments = [], this._propagationContext = Z8(), this;
  }
  /**
   * @inheritDoc
   */
  addBreadcrumb(t, n) {
    const r = typeof n == "number" ? n : l5e;
    if (r <= 0)
      return this;
    const i = {
      timestamp: yy(),
      ...t
    }, o = this._breadcrumbs;
    return o.push(i), this._breadcrumbs = o.length > r ? o.slice(-r) : o, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getLastBreadcrumb() {
    return this._breadcrumbs[this._breadcrumbs.length - 1];
  }
  /**
   * @inheritDoc
   */
  clearBreadcrumbs() {
    return this._breadcrumbs = [], this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addAttachment(t) {
    return this._attachments.push(t), this;
  }
  /**
   * @inheritDoc
   * @deprecated Use `getScopeData()` instead.
   */
  getAttachments() {
    return this.getScopeData().attachments;
  }
  /**
   * @inheritDoc
   */
  clearAttachments() {
    return this._attachments = [], this;
  }
  /** @inheritDoc */
  getScopeData() {
    const {
      _breadcrumbs: t,
      _attachments: n,
      _contexts: r,
      _tags: i,
      _extra: o,
      _user: a,
      _level: s,
      _fingerprint: c,
      _eventProcessors: l,
      _propagationContext: u,
      _sdkProcessingMetadata: d,
      _transactionName: f,
      _span: h
    } = this;
    return {
      breadcrumbs: t,
      attachments: n,
      contexts: r,
      tags: i,
      extra: o,
      user: a,
      level: s,
      fingerprint: c || [],
      eventProcessors: l,
      propagationContext: u,
      sdkProcessingMetadata: d,
      transactionName: f,
      span: h
    };
  }
  /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   * @deprecated Use `applyScopeDataToEvent()` directly
   */
  applyToEvent(t, n = {}, r = []) {
    UK(t, this.getScopeData());
    const i = [
      ...r,
      // eslint-disable-next-line deprecation/deprecation
      ...N6(),
      ...this._eventProcessors
    ];
    return hS(i, t, n);
  }
  /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */
  setSDKProcessingMetadata(t) {
    return this._sdkProcessingMetadata = { ...this._sdkProcessingMetadata, ...t }, this;
  }
  /**
   * @inheritDoc
   */
  setPropagationContext(t) {
    return this._propagationContext = t, this;
  }
  /**
   * @inheritDoc
   */
  getPropagationContext() {
    return this._propagationContext;
  }
  /**
   * Capture an exception for this scope.
   *
   * @param exception The exception to capture.
   * @param hint Optinal additional data to attach to the Sentry event.
   * @returns the id of the captured Sentry event.
   */
  captureException(t, n) {
    const r = n && n.event_id ? n.event_id : Kr();
    if (!this._client)
      return Ce.warn("No client configured on scope - will not capture exception!"), r;
    const i = new Error("Sentry syntheticException");
    return this._client.captureException(
      t,
      {
        originalException: t,
        syntheticException: i,
        ...n,
        event_id: r
      },
      this
    ), r;
  }
  /**
   * Capture a message for this scope.
   *
   * @param message The message to capture.
   * @param level An optional severity level to report the message with.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured message.
   */
  captureMessage(t, n, r) {
    const i = r && r.event_id ? r.event_id : Kr();
    if (!this._client)
      return Ce.warn("No client configured on scope - will not capture message!"), i;
    const o = new Error(t);
    return this._client.captureMessage(
      t,
      n,
      {
        originalException: t,
        syntheticException: o,
        ...r,
        event_id: i
      },
      this
    ), i;
  }
  /**
   * Captures a manually created event for this scope and sends it to Sentry.
   *
   * @param exception The event to capture.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured event.
   */
  captureEvent(t, n) {
    const r = n && n.event_id ? n.event_id : Kr();
    return this._client ? (this._client.captureEvent(t, { ...n, event_id: r }, this), r) : (Ce.warn("No client configured on scope - will not capture event!"), r);
  }
  /**
   * This will be called on every set call.
   */
  _notifyScopeListeners() {
    this._notifyingListeners || (this._notifyingListeners = !0, this._scopeListeners.forEach((t) => {
      t(this);
    }), this._notifyingListeners = !1);
  }
}
function u5e() {
  return Y5 || (Y5 = new il()), Y5;
}
function Z8() {
  return {
    traceId: Kr(),
    spanId: Kr().substring(16)
  };
}
const pA = "7.120.0", WK = parseFloat(pA), d5e = 100;
class qK {
  /** Is a {@link Layer}[] containing the client and scope */
  /** Contains the last event id of a captured event.  */
  /**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   *
   * @deprecated Instantiation of Hub objects is deprecated and the constructor will be removed in version 8 of the SDK.
   *
   * If you are currently using the Hub for multi-client use like so:
   *
   * ```
   * // OLD
   * const hub = new Hub();
   * hub.bindClient(client);
   * makeMain(hub)
   * ```
   *
   * instead initialize the client as follows:
   *
   * ```
   * // NEW
   * Sentry.withIsolationScope(() => {
   *    Sentry.setCurrentClient(client);
   *    client.init();
   * });
   * ```
   *
   * If you are using the Hub to capture events like so:
   *
   * ```
   * // OLD
   * const client = new Client();
   * const hub = new Hub(client);
   * hub.captureException()
   * ```
   *
   * instead capture isolated events as follows:
   *
   * ```
   * // NEW
   * const client = new Client();
   * const scope = new Scope();
   * scope.setClient(client);
   * scope.captureException();
   * ```
   */
  constructor(t, n, r, i = WK) {
    this._version = i;
    let o;
    n ? o = n : (o = new il(), o.setClient(t));
    let a;
    r ? a = r : (a = new il(), a.setClient(t)), this._stack = [{ scope: o }], t && this.bindClient(t), this._isolationScope = a;
  }
  /**
   * Checks if this hub's version is older than the given version.
   *
   * @param version A version number to compare to.
   * @return True if the given version is newer; otherwise false.
   *
   * @deprecated This will be removed in v8.
   */
  isOlderThan(t) {
    return this._version < t;
  }
  /**
   * This binds the given client to the current scope.
   * @param client An SDK client (client) instance.
   *
   * @deprecated Use `initAndBind()` directly, or `setCurrentClient()` and/or `client.init()` instead.
   */
  bindClient(t) {
    const n = this.getStackTop();
    n.client = t, n.scope.setClient(t), t && t.setupIntegrations && t.setupIntegrations();
  }
  /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */
  pushScope() {
    const t = this.getScope().clone();
    return this.getStack().push({
      // eslint-disable-next-line deprecation/deprecation
      client: this.getClient(),
      scope: t
    }), t;
  }
  /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */
  popScope() {
    return this.getStack().length <= 1 ? !1 : !!this.getStack().pop();
  }
  /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.withScope()` instead.
   */
  withScope(t) {
    const n = this.pushScope();
    let r;
    try {
      r = t(n);
    } catch (i) {
      throw this.popScope(), i;
    }
    return hE(r) ? r.then(
      (i) => (this.popScope(), i),
      (i) => {
        throw this.popScope(), i;
      }
    ) : (this.popScope(), r);
  }
  /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.getClient()` instead.
   */
  getClient() {
    return this.getStackTop().client;
  }
  /**
   * Returns the scope of the top stack.
   *
   * @deprecated Use `Sentry.getCurrentScope()` instead.
   */
  getScope() {
    return this.getStackTop().scope;
  }
  /**
   * @deprecated Use `Sentry.getIsolationScope()` instead.
   */
  getIsolationScope() {
    return this._isolationScope;
  }
  /**
   * Returns the scope stack for domains or the process.
   * @deprecated This will be removed in v8.
   */
  getStack() {
    return this._stack;
  }
  /**
   * Returns the topmost scope layer in the order domain > local > process.
   * @deprecated This will be removed in v8.
   */
  getStackTop() {
    return this._stack[this._stack.length - 1];
  }
  /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureException()` instead.
   */
  captureException(t, n) {
    const r = this._lastEventId = n && n.event_id ? n.event_id : Kr(), i = new Error("Sentry syntheticException");
    return this.getScope().captureException(t, {
      originalException: t,
      syntheticException: i,
      ...n,
      event_id: r
    }), r;
  }
  /**
   * @inheritDoc
   *
   * @deprecated Use  `Sentry.captureMessage()` instead.
   */
  captureMessage(t, n, r) {
    const i = this._lastEventId = r && r.event_id ? r.event_id : Kr(), o = new Error(t);
    return this.getScope().captureMessage(t, n, {
      originalException: t,
      syntheticException: o,
      ...r,
      event_id: i
    }), i;
  }
  /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureEvent()` instead.
   */
  captureEvent(t, n) {
    const r = n && n.event_id ? n.event_id : Kr();
    return t.type || (this._lastEventId = r), this.getScope().captureEvent(t, { ...n, event_id: r }), r;
  }
  /**
   * @inheritDoc
   *
   * @deprecated This will be removed in v8.
   */
  lastEventId() {
    return this._lastEventId;
  }
  /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.addBreadcrumb()` instead.
   */
  addBreadcrumb(t, n) {
    const { scope: r, client: i } = this.getStackTop();
    if (!i)
      return;
    const { beforeBreadcrumb: o = null, maxBreadcrumbs: a = d5e } = i.getOptions && i.getOptions() || {};
    if (a <= 0)
      return;
    const c = { timestamp: yy(), ...t }, l = o ? vf(() => o(c, n)) : c;
    l !== null && (i.emit && i.emit("beforeAddBreadcrumb", l, n), r.addBreadcrumb(l, a));
  }
  /**
   * @inheritDoc
   * @deprecated Use `Sentry.setUser()` instead.
   */
  setUser(t) {
    this.getScope().setUser(t), this.getIsolationScope().setUser(t);
  }
  /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTags()` instead.
   */
  setTags(t) {
    this.getScope().setTags(t), this.getIsolationScope().setTags(t);
  }
  /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtras()` instead.
   */
  setExtras(t) {
    this.getScope().setExtras(t), this.getIsolationScope().setExtras(t);
  }
  /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTag()` instead.
   */
  setTag(t, n) {
    this.getScope().setTag(t, n), this.getIsolationScope().setTag(t, n);
  }
  /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtra()` instead.
   */
  setExtra(t, n) {
    this.getScope().setExtra(t, n), this.getIsolationScope().setExtra(t, n);
  }
  /**
   * @inheritDoc
   * @deprecated Use `Sentry.setContext()` instead.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setContext(t, n) {
    this.getScope().setContext(t, n), this.getIsolationScope().setContext(t, n);
  }
  /**
   * @inheritDoc
   *
   * @deprecated Use `getScope()` directly.
   */
  configureScope(t) {
    const { scope: n, client: r } = this.getStackTop();
    r && t(n);
  }
  /**
   * @inheritDoc
   */
  // eslint-disable-next-line deprecation/deprecation
  run(t) {
    const n = ej(this);
    try {
      t(this);
    } finally {
      ej(n);
    }
  }
  /**
   * @inheritDoc
   * @deprecated Use `Sentry.getClient().getIntegrationByName()` instead.
   */
  getIntegration(t) {
    const n = this.getClient();
    if (!n)
      return null;
    try {
      return n.getIntegration(t);
    } catch {
      return jt && Ce.warn(`Cannot retrieve integration ${t.id} from the current Hub`), null;
    }
  }
  /**
   * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
   *
   * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
   * new child span within the transaction or any span, call the respective `.startChild()` method.
   *
   * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
   *
   * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
   * finished child spans will be sent to Sentry.
   *
   * @param context Properties of the new `Transaction`.
   * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
   * default values). See {@link Options.tracesSampler}.
   *
   * @returns The transaction which was just started
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */
  startTransaction(t, n) {
    const r = this._callExtensionMethod("startTransaction", t, n);
    return jt && !r && (this.getClient() ? Ce.warn(`Tracing extension 'startTransaction' has not been added. Call 'addTracingExtensions' before calling 'init':
Sentry.addTracingExtensions();
Sentry.init({...});
`) : Ce.warn(
      "Tracing extension 'startTransaction' is missing. You should 'init' the SDK before calling 'startTransaction'"
    )), r;
  }
  /**
   * @inheritDoc
   * @deprecated Use `spanToTraceHeader()` instead.
   */
  traceHeaders() {
    return this._callExtensionMethod("traceHeaders");
  }
  /**
   * @inheritDoc
   *
   * @deprecated Use top level `captureSession` instead.
   */
  captureSession(t = !1) {
    if (t)
      return this.endSession();
    this._sendSessionUpdate();
  }
  /**
   * @inheritDoc
   * @deprecated Use top level `endSession` instead.
   */
  endSession() {
    const n = this.getStackTop().scope, r = n.getSession();
    r && LK(r), this._sendSessionUpdate(), n.setSession();
  }
  /**
   * @inheritDoc
   * @deprecated Use top level `startSession` instead.
   */
  startSession(t) {
    const { scope: n, client: r } = this.getStackTop(), { release: i, environment: o = pE } = r && r.getOptions() || {}, { userAgent: a } = An.navigator || {}, s = jK({
      release: i,
      environment: o,
      user: n.getUser(),
      ...a && { userAgent: a },
      ...t
    }), c = n.getSession && n.getSession();
    return c && c.status === "ok" && bf(c, { status: "exited" }), this.endSession(), n.setSession(s), s;
  }
  /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   *
   * @deprecated Use top-level `getClient().getOptions().sendDefaultPii` instead. This function
   * only unnecessarily increased API surface but only wrapped accessing the option.
   */
  shouldSendDefaultPii() {
    const t = this.getClient(), n = t && t.getOptions();
    return !!(n && n.sendDefaultPii);
  }
  /**
   * Sends the current Session on the scope
   */
  _sendSessionUpdate() {
    const { scope: t, client: n } = this.getStackTop(), r = t.getSession();
    r && n && n.captureSession && n.captureSession(r);
  }
  /**
   * Calls global extension method and binding current instance to the function call
   */
  // @ts-expect-error Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _callExtensionMethod(t, ...n) {
    const i = _y().__SENTRY__;
    if (i && i.extensions && typeof i.extensions[t] == "function")
      return i.extensions[t].apply(this, n);
    jt && Ce.warn(`Extension method ${t} couldn't be found, doing nothing.`);
  }
}
function _y() {
  return An.__SENTRY__ = An.__SENTRY__ || {
    extensions: {},
    hub: void 0
  }, An;
}
function ej(e) {
  const t = _y(), n = mA(t);
  return GK(t, e), n;
}
function Ia() {
  const e = _y();
  if (e.__SENTRY__ && e.__SENTRY__.acs) {
    const t = e.__SENTRY__.acs.getCurrentHub();
    if (t)
      return t;
  }
  return f5e(e);
}
function td() {
  return Ia().getIsolationScope();
}
function f5e(e = _y()) {
  return (!h5e(e) || // eslint-disable-next-line deprecation/deprecation
  mA(e).isOlderThan(WK)) && GK(e, new qK()), mA(e);
}
function h5e(e) {
  return !!(e && e.__SENTRY__ && e.__SENTRY__.hub);
}
function mA(e) {
  return vK("hub", () => new qK(), e);
}
function GK(e, t) {
  if (!e)
    return !1;
  const n = e.__SENTRY__ = e.__SENTRY__ || {};
  return n.hub = t, !0;
}
function _f(e) {
  return (e || Ia()).getScope().getTransaction();
}
let tj = !1;
function g5e() {
  tj || (tj = !0, $K(vA), AK(vA));
}
function vA() {
  const e = _f();
  if (e) {
    const t = "internal_error";
    jt && Ce.log(`[Tracing] Transaction: ${t} -> Global error occured`), e.setStatus(t);
  }
}
vA.tag = "sentry_tracingErrorCallback";
var nj;
(function(e) {
  const t = "ok";
  e.Ok = t;
  const n = "deadline_exceeded";
  e.DeadlineExceeded = n;
  const r = "unauthenticated";
  e.Unauthenticated = r;
  const i = "permission_denied";
  e.PermissionDenied = i;
  const o = "not_found";
  e.NotFound = o;
  const a = "resource_exhausted";
  e.ResourceExhausted = a;
  const s = "invalid_argument";
  e.InvalidArgument = s;
  const c = "unimplemented";
  e.Unimplemented = c;
  const l = "unavailable";
  e.Unavailable = l;
  const u = "internal_error";
  e.InternalError = u;
  const d = "unknown_error";
  e.UnknownError = d;
  const f = "cancelled";
  e.Cancelled = f;
  const h = "already_exists";
  e.AlreadyExists = h;
  const p = "failed_precondition";
  e.FailedPrecondition = p;
  const g = "aborted";
  e.Aborted = g;
  const m = "out_of_range";
  e.OutOfRange = m;
  const v = "data_loss";
  e.DataLoss = v;
})(nj || (nj = {}));
function p5e(e) {
  if (e < 400 && e >= 100)
    return "ok";
  if (e >= 400 && e < 500)
    switch (e) {
      case 401:
        return "unauthenticated";
      case 403:
        return "permission_denied";
      case 404:
        return "not_found";
      case 409:
        return "already_exists";
      case 413:
        return "failed_precondition";
      case 429:
        return "resource_exhausted";
      default:
        return "invalid_argument";
    }
  if (e >= 500 && e < 600)
    switch (e) {
      case 501:
        return "unimplemented";
      case 503:
        return "unavailable";
      case 504:
        return "deadline_exceeded";
      default:
        return "internal_error";
    }
  return "unknown_error";
}
function L6(e, t) {
  e.setTag("http.status_code", String(t)), e.setData("http.response.status_code", t);
  const n = p5e(t);
  n !== "unknown_error" && e.setStatus(n);
}
function Hp(e) {
  if (typeof __SENTRY_TRACING__ == "boolean" && !__SENTRY_TRACING__)
    return !1;
  const t = Jn(), n = e || t && t.getOptions();
  return !!n && (n.enableTracing || "tracesSampleRate" in n || "tracesSampler" in n);
}
function KK(e) {
  if (!Hp())
    return;
  const t = y5e(e), n = Ia(), r = e.scope ? (
    // eslint-disable-next-line deprecation/deprecation
    e.scope.getSpan()
  ) : m5e();
  if (e.onlyIfParent && !r)
    return;
  const a = (e.scope || Ta()).clone();
  return v5e(n, {
    parentSpan: r,
    spanContext: t,
    forceTransaction: e.forceTransaction,
    scope: a
  });
}
function m5e() {
  return Ta().getSpan();
}
function v5e(e, {
  parentSpan: t,
  spanContext: n,
  forceTransaction: r,
  scope: i
}) {
  if (!Hp())
    return;
  const o = td();
  let a;
  if (t && !r)
    a = t.startChild(n);
  else if (t) {
    const s = Ng(t), { traceId: c, spanId: l } = t.spanContext(), u = j6(t);
    a = e.startTransaction({
      traceId: c,
      parentSpanId: l,
      parentSampled: u,
      ...n,
      metadata: {
        dynamicSamplingContext: s,
        // eslint-disable-next-line deprecation/deprecation
        ...n.metadata
      }
    });
  } else {
    const { traceId: s, dsc: c, parentSpanId: l, sampled: u } = {
      ...o.getPropagationContext(),
      ...i.getPropagationContext()
    };
    a = e.startTransaction({
      traceId: s,
      parentSpanId: l,
      parentSampled: u,
      ...n,
      metadata: {
        dynamicSamplingContext: c,
        // eslint-disable-next-line deprecation/deprecation
        ...n.metadata
      }
    });
  }
  return i.setSpan(a), b5e(a, i, o), a;
}
function y5e(e) {
  if (e.startTime) {
    const t = { ...e };
    return t.startTimestamp = vE(e.startTime), delete t.startTime, t;
  }
  return e;
}
const YK = "_sentryScope", XK = "_sentryIsolationScope";
function b5e(e, t, n) {
  e && (yf(e, XK, n), yf(e, YK, t));
}
function _5e(e) {
  return {
    scope: e[YK],
    isolationScope: e[XK]
  };
}
const Xd = "sentry.source", Uh = "sentry.sample_rate", Qb = "sentry.op", Wh = "sentry.origin", S5e = "profile_id";
class QK {
  constructor(t = 1e3) {
    this._maxlen = t, this.spans = [];
  }
  /**
   * This is just so that we don't run out of memory while recording a lot
   * of spans. At some point we just stop and flush out the start of the
   * trace tree (i.e.the first n spans with the smallest
   * start_timestamp).
   */
  add(t) {
    this.spans.length > this._maxlen ? t.spanRecorder = void 0 : this.spans.push(t);
  }
}
class _E {
  /**
   * Tags for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */
  /**
   * Data for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  /**
   * List of spans that were finalized
   *
   * @deprecated This property will no longer be public. Span recording will be handled internally.
   */
  /**
   * @inheritDoc
   * @deprecated Use top level `Sentry.getRootSpan()` instead
   */
  /**
   * The instrumenter that created this span.
   *
   * TODO (v8): This can probably be replaced by an `instanceOf` check of the span class.
   *            the instrumenter can only be sentry or otel so we can check the span instance
   *            to verify which one it is and remove this field entirely.
   *
   * @deprecated This field will be removed.
   */
  /** Epoch timestamp in seconds when the span started. */
  /** Epoch timestamp in seconds when the span ended. */
  /** Internal keeper of the status */
  /**
   * You should never call the constructor manually, always use `Sentry.startTransaction()`
   * or call `startChild()` on an existing span.
   * @internal
   * @hideconstructor
   * @hidden
   */
  constructor(t = {}) {
    this._traceId = t.traceId || Kr(), this._spanId = t.spanId || Kr().substring(16), this._startTime = t.startTimestamp || by(), this.tags = t.tags ? { ...t.tags } : {}, this.data = t.data ? { ...t.data } : {}, this.instrumenter = t.instrumenter || "sentry", this._attributes = {}, this.setAttributes({
      [Wh]: t.origin || "manual",
      [Qb]: t.op,
      ...t.attributes
    }), this._name = t.name || t.description, t.parentSpanId && (this._parentSpanId = t.parentSpanId), "sampled" in t && (this._sampled = t.sampled), t.status && (this._status = t.status), t.endTimestamp && (this._endTime = t.endTimestamp), t.exclusiveTime !== void 0 && (this._exclusiveTime = t.exclusiveTime), this._measurements = t.measurements ? { ...t.measurements } : {};
  }
  // This rule conflicts with another eslint rule :(
  /* eslint-disable @typescript-eslint/member-ordering */
  /**
   * An alias for `description` of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */
  get name() {
    return this._name || "";
  }
  /**
   * Update the name of the span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */
  set name(t) {
    this.updateName(t);
  }
  /**
   * Get the description of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */
  get description() {
    return this._name;
  }
  /**
   * Get the description of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */
  set description(t) {
    this._name = t;
  }
  /**
   * The ID of the trace.
   * @deprecated Use `spanContext().traceId` instead.
   */
  get traceId() {
    return this._traceId;
  }
  /**
   * The ID of the trace.
   * @deprecated You cannot update the traceId of a span after span creation.
   */
  set traceId(t) {
    this._traceId = t;
  }
  /**
   * The ID of the span.
   * @deprecated Use `spanContext().spanId` instead.
   */
  get spanId() {
    return this._spanId;
  }
  /**
   * The ID of the span.
   * @deprecated You cannot update the spanId of a span after span creation.
   */
  set spanId(t) {
    this._spanId = t;
  }
  /**
   * @inheritDoc
   *
   * @deprecated Use `startSpan` functions instead.
   */
  set parentSpanId(t) {
    this._parentSpanId = t;
  }
  /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON(span).parent_span_id` instead.
   */
  get parentSpanId() {
    return this._parentSpanId;
  }
  /**
   * Was this span chosen to be sent as part of the sample?
   * @deprecated Use `isRecording()` instead.
   */
  get sampled() {
    return this._sampled;
  }
  /**
   * Was this span chosen to be sent as part of the sample?
   * @deprecated You cannot update the sampling decision of a span after span creation.
   */
  set sampled(t) {
    this._sampled = t;
  }
  /**
   * Attributes for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */
  get attributes() {
    return this._attributes;
  }
  /**
   * Attributes for the span.
   * @deprecated Use `setAttributes()` instead.
   */
  set attributes(t) {
    this._attributes = t;
  }
  /**
   * Timestamp in seconds (epoch time) indicating when the span started.
   * @deprecated Use `spanToJSON()` instead.
   */
  get startTimestamp() {
    return this._startTime;
  }
  /**
   * Timestamp in seconds (epoch time) indicating when the span started.
   * @deprecated In v8, you will not be able to update the span start time after creation.
   */
  set startTimestamp(t) {
    this._startTime = t;
  }
  /**
   * Timestamp in seconds when the span ended.
   * @deprecated Use `spanToJSON()` instead.
   */
  get endTimestamp() {
    return this._endTime;
  }
  /**
   * Timestamp in seconds when the span ended.
   * @deprecated Set the end time via `span.end()` instead.
   */
  set endTimestamp(t) {
    this._endTime = t;
  }
  /**
   * The status of the span.
   *
   * @deprecated Use `spanToJSON().status` instead to get the status.
   */
  get status() {
    return this._status;
  }
  /**
   * The status of the span.
   *
   * @deprecated Use `.setStatus()` instead to set or update the status.
   */
  set status(t) {
    this._status = t;
  }
  /**
   * Operation of the span
   *
   * @deprecated Use `spanToJSON().op` to read the op instead.
   */
  get op() {
    return this._attributes[Qb];
  }
  /**
   * Operation of the span
   *
   * @deprecated Use `startSpan()` functions to set or `span.setAttribute(SEMANTIC_ATTRIBUTE_SENTRY_OP, 'op')
   *             to update the span instead.
   */
  set op(t) {
    this.setAttribute(Qb, t);
  }
  /**
   * The origin of the span, giving context about what created the span.
   *
   * @deprecated Use `spanToJSON().origin` to read the origin instead.
   */
  get origin() {
    return this._attributes[Wh];
  }
  /**
   * The origin of the span, giving context about what created the span.
   *
   * @deprecated Use `startSpan()` functions to set the origin instead.
   */
  set origin(t) {
    this.setAttribute(Wh, t);
  }
  /* eslint-enable @typescript-eslint/member-ordering */
  /** @inheritdoc */
  spanContext() {
    const { _spanId: t, _traceId: n, _sampled: r } = this;
    return {
      spanId: t,
      traceId: n,
      traceFlags: r ? FK : U2e
    };
  }
  /**
   * Creates a new `Span` while setting the current `Span.id` as `parentSpanId`.
   * Also the `sampled` decision will be inherited.
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */
  startChild(t) {
    const n = new _E({
      ...t,
      parentSpanId: this._spanId,
      sampled: this._sampled,
      traceId: this._traceId
    });
    n.spanRecorder = this.spanRecorder, n.spanRecorder && n.spanRecorder.add(n);
    const r = gS(this);
    if (n.transaction = r, jt && r) {
      const i = t && t.op || "< unknown op >", o = qi(n).description || "< unknown name >", a = r.spanContext().spanId, s = `[Tracing] Starting '${i}' span on transaction '${o}' (${a}).`;
      Ce.log(s), this._logMessage = s;
    }
    return n;
  }
  /**
   * Sets the tag attribute on the current span.
   *
   * Can also be used to unset a tag, by passing `undefined`.
   *
   * @param key Tag key
   * @param value Tag value
   * @deprecated Use `setAttribute()` instead.
   */
  setTag(t, n) {
    return this.tags = { ...this.tags, [t]: n }, this;
  }
  /**
   * Sets the data attribute on the current span
   * @param key Data key
   * @param value Data value
   * @deprecated Use `setAttribute()` instead.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setData(t, n) {
    return this.data = { ...this.data, [t]: n }, this;
  }
  /** @inheritdoc */
  setAttribute(t, n) {
    n === void 0 ? delete this._attributes[t] : this._attributes[t] = n;
  }
  /** @inheritdoc */
  setAttributes(t) {
    Object.keys(t).forEach((n) => this.setAttribute(n, t[n]));
  }
  /**
   * @inheritDoc
   */
  setStatus(t) {
    return this._status = t, this;
  }
  /**
   * @inheritDoc
   * @deprecated Use top-level `setHttpStatus()` instead.
   */
  setHttpStatus(t) {
    return L6(this, t), this;
  }
  /**
   * @inheritdoc
   *
   * @deprecated Use `.updateName()` instead.
   */
  setName(t) {
    this.updateName(t);
  }
  /**
   * @inheritDoc
   */
  updateName(t) {
    return this._name = t, this;
  }
  /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON(span).status === 'ok'` instead.
   */
  isSuccess() {
    return this._status === "ok";
  }
  /**
   * @inheritDoc
   *
   * @deprecated Use `.end()` instead.
   */
  finish(t) {
    return this.end(t);
  }
  /** @inheritdoc */
  end(t) {
    if (this._endTime)
      return;
    const n = gS(this);
    if (jt && // Don't call this for transactions
    n && n.spanContext().spanId !== this._spanId) {
      const r = this._logMessage;
      r && Ce.log(r.replace("Starting", "Finishing"));
    }
    this._endTime = vE(t);
  }
  /**
   * @inheritDoc
   *
   * @deprecated Use `spanToTraceHeader()` instead.
   */
  toTraceparent() {
    return mE(this);
  }
  /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON()` or access the fields directly instead.
   */
  toContext() {
    return Po({
      data: this._getData(),
      description: this._name,
      endTimestamp: this._endTime,
      // eslint-disable-next-line deprecation/deprecation
      op: this.op,
      parentSpanId: this._parentSpanId,
      sampled: this._sampled,
      spanId: this._spanId,
      startTimestamp: this._startTime,
      status: this._status,
      // eslint-disable-next-line deprecation/deprecation
      tags: this.tags,
      traceId: this._traceId
    });
  }
  /**
   * @inheritDoc
   *
   * @deprecated Update the fields directly instead.
   */
  updateWithContext(t) {
    return this.data = t.data || {}, this._name = t.name || t.description, this._endTime = t.endTimestamp, this.op = t.op, this._parentSpanId = t.parentSpanId, this._sampled = t.sampled, this._spanId = t.spanId || this._spanId, this._startTime = t.startTimestamp || this._startTime, this._status = t.status, this.tags = t.tags || {}, this._traceId = t.traceId || this._traceId, this;
  }
  /**
   * @inheritDoc
   *
   * @deprecated Use `spanToTraceContext()` util function instead.
   */
  getTraceContext() {
    return D6(this);
  }
  /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */
  getSpanJSON() {
    return Po({
      data: this._getData(),
      description: this._name,
      op: this._attributes[Qb],
      parent_span_id: this._parentSpanId,
      span_id: this._spanId,
      start_timestamp: this._startTime,
      status: this._status,
      // eslint-disable-next-line deprecation/deprecation
      tags: Object.keys(this.tags).length > 0 ? this.tags : void 0,
      timestamp: this._endTime,
      trace_id: this._traceId,
      origin: this._attributes[Wh],
      _metrics_summary: void 0,
      profile_id: this._attributes[S5e],
      exclusive_time: this._exclusiveTime,
      measurements: Object.keys(this._measurements).length > 0 ? this._measurements : void 0
    });
  }
  /** @inheritdoc */
  isRecording() {
    return !this._endTime && !!this._sampled;
  }
  /**
   * Convert the object to JSON.
   * @deprecated Use `spanToJSON(span)` instead.
   */
  toJSON() {
    return this.getSpanJSON();
  }
  /**
   * Get the merged data for this span.
   * For now, this combines `data` and `attributes` together,
   * until eventually we can ingest `attributes` directly.
   */
  _getData() {
    const { data: t, _attributes: n } = this, r = Object.keys(t).length > 0, i = Object.keys(n).length > 0;
    if (!(!r && !i))
      return r && i ? {
        ...t,
        ...n
      } : r ? t : n;
  }
}
class JK extends _E {
  /**
   * The reference to the current hub.
   */
  // eslint-disable-next-line deprecation/deprecation
  // DO NOT yet remove this property, it is used in a hack for v7 backwards compatibility.
  /**
   * This constructor should never be called manually. Those instrumenting tracing should use
   * `Sentry.startTransaction()`, and internal methods should use `hub.startTransaction()`.
   * @internal
   * @hideconstructor
   * @hidden
   *
   * @deprecated Transactions will be removed in v8. Use spans instead.
   */
  // eslint-disable-next-line deprecation/deprecation
  constructor(t, n) {
    super(t), this._contexts = {}, this._hub = n || Ia(), this._name = t.name || "", this._metadata = {
      // eslint-disable-next-line deprecation/deprecation
      ...t.metadata
    }, this._trimEnd = t.trimEnd, this.transaction = this;
    const r = this._metadata.dynamicSamplingContext;
    r && (this._frozenDynamicSamplingContext = { ...r });
  }
  // This sadly conflicts with the getter/setter ordering :(
  /* eslint-disable @typescript-eslint/member-ordering */
  /**
   * Getter for `name` property.
   * @deprecated Use `spanToJSON(span).description` instead.
   */
  get name() {
    return this._name;
  }
  /**
   * Setter for `name` property, which also sets `source` as custom.
   * @deprecated Use `updateName()` and `setMetadata()` instead.
   */
  set name(t) {
    this.setName(t);
  }
  /**
   * Get the metadata for this transaction.
   * @deprecated Use `spanGetMetadata(transaction)` instead.
   */
  get metadata() {
    return {
      // Defaults
      // eslint-disable-next-line deprecation/deprecation
      source: "custom",
      spanMetadata: {},
      // Legacy metadata
      ...this._metadata,
      // From attributes
      ...this._attributes[Xd] && {
        source: this._attributes[Xd]
      },
      ...this._attributes[Uh] && {
        sampleRate: this._attributes[Uh]
      }
    };
  }
  /**
   * Update the metadata for this transaction.
   * @deprecated Use `spanGetMetadata(transaction)` instead.
   */
  set metadata(t) {
    this._metadata = t;
  }
  /* eslint-enable @typescript-eslint/member-ordering */
  /**
   * Setter for `name` property, which also sets `source` on the metadata.
   *
   * @deprecated Use `.updateName()` and `.setAttribute()` instead.
   */
  setName(t, n = "custom") {
    this._name = t, this.setAttribute(Xd, n);
  }
  /** @inheritdoc */
  updateName(t) {
    return this._name = t, this;
  }
  /**
   * Attaches SpanRecorder to the span itself
   * @param maxlen maximum number of spans that can be recorded
   */
  initSpanRecorder(t = 1e3) {
    this.spanRecorder || (this.spanRecorder = new QK(t)), this.spanRecorder.add(this);
  }
  /**
   * Set the context of a transaction event.
   * @deprecated Use either `.setAttribute()`, or set the context on the scope before creating the transaction.
   */
  setContext(t, n) {
    n === null ? delete this._contexts[t] : this._contexts[t] = n;
  }
  /**
   * @inheritDoc
   *
   * @deprecated Use top-level `setMeasurement()` instead.
   */
  setMeasurement(t, n, r = "") {
    this._measurements[t] = { value: n, unit: r };
  }
  /**
   * Store metadata on this transaction.
   * @deprecated Use attributes or store data on the scope instead.
   */
  setMetadata(t) {
    this._metadata = { ...this._metadata, ...t };
  }
  /**
   * @inheritDoc
   */
  end(t) {
    const n = vE(t), r = this._finishTransaction(n);
    if (r)
      return this._hub.captureEvent(r);
  }
  /**
   * @inheritDoc
   */
  toContext() {
    const t = super.toContext();
    return Po({
      ...t,
      name: this._name,
      trimEnd: this._trimEnd
    });
  }
  /**
   * @inheritDoc
   */
  updateWithContext(t) {
    return super.updateWithContext(t), this._name = t.name || "", this._trimEnd = t.trimEnd, this;
  }
  /**
   * @inheritdoc
   *
   * @experimental
   *
   * @deprecated Use top-level `getDynamicSamplingContextFromSpan` instead.
   */
  getDynamicSamplingContext() {
    return Ng(this);
  }
  /**
   * Override the current hub with a new one.
   * Used if you want another hub to finish the transaction.
   *
   * @internal
   */
  // eslint-disable-next-line deprecation/deprecation
  setHub(t) {
    this._hub = t;
  }
  /**
   * Get the profile id of the transaction.
   */
  getProfileId() {
    if (this._contexts !== void 0 && this._contexts.profile !== void 0)
      return this._contexts.profile.profile_id;
  }
  /**
   * Finish the transaction & prepare the event to send to Sentry.
   */
  _finishTransaction(t) {
    if (this._endTime !== void 0)
      return;
    this._name || (jt && Ce.warn("Transaction has no name, falling back to `<unlabeled transaction>`."), this._name = "<unlabeled transaction>"), super.end(t);
    const n = this._hub.getClient();
    if (n && n.emit && n.emit("finishTransaction", this), this._sampled !== !0) {
      jt && Ce.log("[Tracing] Discarding transaction because its trace was not chosen to be sampled."), n && n.recordDroppedEvent("sample_rate", "transaction");
      return;
    }
    const r = this.spanRecorder ? (
      // eslint-disable-next-line deprecation/deprecation
      this.spanRecorder.spans.filter((u) => u !== this && qi(u).timestamp)
    ) : [];
    if (this._trimEnd && r.length > 0) {
      const u = r.map((d) => qi(d).timestamp).filter(Boolean);
      this._endTime = u.reduce((d, f) => d > f ? d : f);
    }
    const { scope: i, isolationScope: o } = _5e(this), { metadata: a } = this, { source: s } = a, c = {
      contexts: {
        ...this._contexts,
        // We don't want to override trace context
        trace: D6(this)
      },
      // TODO: Pass spans serialized via `spanToJSON()` here instead in v8.
      spans: r,
      start_timestamp: this._startTime,
      // eslint-disable-next-line deprecation/deprecation
      tags: this.tags,
      timestamp: this._endTime,
      transaction: this._name,
      type: "transaction",
      sdkProcessingMetadata: {
        ...a,
        capturedSpanScope: i,
        capturedSpanIsolationScope: o,
        ...Po({
          dynamicSamplingContext: Ng(this)
        })
      },
      _metrics_summary: void 0,
      ...s && {
        transaction_info: {
          source: s
        }
      }
    };
    return Object.keys(this._measurements).length > 0 && (jt && Ce.log(
      "[Measurements] Adding measurements to transaction",
      JSON.stringify(this._measurements, void 0, 2)
    ), c.measurements = this._measurements), jt && Ce.log(`[Tracing] Finishing ${this.op} transaction: ${this._name}.`), c;
  }
}
const l_ = {
  idleTimeout: 1e3,
  finalTimeout: 3e4,
  heartbeatInterval: 5e3
}, w5e = "finishReason", mh = [
  "heartbeatFailed",
  "idleTimeout",
  "documentHidden",
  "finalTimeout",
  "externalFinish",
  "cancelled"
];
class x5e extends QK {
  constructor(t, n, r, i) {
    super(i), this._pushActivity = t, this._popActivity = n, this.transactionSpanId = r;
  }
  /**
   * @inheritDoc
   */
  add(t) {
    if (t.spanContext().spanId !== this.transactionSpanId) {
      const n = t.end;
      t.end = (...r) => (this._popActivity(t.spanContext().spanId), n.apply(t, r)), qi(t).timestamp === void 0 && this._pushActivity(t.spanContext().spanId);
    }
    super.add(t);
  }
}
class E5e extends JK {
  // Activities store a list of active spans
  // Track state of activities in previous heartbeat
  // Amount of times heartbeat has counted. Will cause transaction to finish after 3 beats.
  // We should not use heartbeat if we finished a transaction
  // Idle timeout was canceled and we should finish the transaction with the last span end.
  /**
   * Timer that tracks Transaction idleTimeout
   */
  /**
   * @deprecated Transactions will be removed in v8. Use spans instead.
   */
  constructor(t, n, r = l_.idleTimeout, i = l_.finalTimeout, o = l_.heartbeatInterval, a = !1, s = !1) {
    super(t, n), this._idleHub = n, this._idleTimeout = r, this._finalTimeout = i, this._heartbeatInterval = o, this._onScope = a, this.activities = {}, this._heartbeatCounter = 0, this._finished = !1, this._idleTimeoutCanceledPermanently = !1, this._beforeFinishCallbacks = [], this._finishReason = mh[4], this._autoFinishAllowed = !s, a && (jt && Ce.log(`Setting idle transaction on scope. Span ID: ${this.spanContext().spanId}`), n.getScope().setSpan(this)), s || this._restartIdleTimeout(), setTimeout(() => {
      this._finished || (this.setStatus("deadline_exceeded"), this._finishReason = mh[3], this.end());
    }, this._finalTimeout);
  }
  /** {@inheritDoc} */
  end(t) {
    const n = vE(t);
    if (this._finished = !0, this.activities = {}, this.op === "ui.action.click" && this.setAttribute(w5e, this._finishReason), this.spanRecorder) {
      jt && // eslint-disable-next-line deprecation/deprecation
      Ce.log("[Tracing] finishing IdleTransaction", new Date(n * 1e3).toISOString(), this.op);
      for (const r of this._beforeFinishCallbacks)
        r(this, n);
      this.spanRecorder.spans = this.spanRecorder.spans.filter((r) => {
        if (r.spanContext().spanId === this.spanContext().spanId)
          return !0;
        qi(r).timestamp || (r.setStatus("cancelled"), r.end(n), jt && Ce.log("[Tracing] cancelling span since transaction ended early", JSON.stringify(r, void 0, 2)));
        const { start_timestamp: i, timestamp: o } = qi(r), a = i && i < n, s = (this._finalTimeout + this._idleTimeout) / 1e3, c = o && i && o - i < s;
        if (jt) {
          const l = JSON.stringify(r, void 0, 2);
          a ? c || Ce.log("[Tracing] discarding Span since it finished after Transaction final timeout", l) : Ce.log("[Tracing] discarding Span since it happened after Transaction was finished", l);
        }
        return a && c;
      }), jt && Ce.log("[Tracing] flushing IdleTransaction");
    } else
      jt && Ce.log("[Tracing] No active IdleTransaction");
    if (this._onScope) {
      const r = this._idleHub.getScope();
      r.getTransaction() === this && r.setSpan(void 0);
    }
    return super.end(t);
  }
  /**
   * Register a callback function that gets executed before the transaction finishes.
   * Useful for cleanup or if you want to add any additional spans based on current context.
   *
   * This is exposed because users have no other way of running something before an idle transaction
   * finishes.
   */
  registerBeforeFinishCallback(t) {
    this._beforeFinishCallbacks.push(t);
  }
  /**
   * @inheritDoc
   */
  initSpanRecorder(t) {
    if (!this.spanRecorder) {
      const n = (i) => {
        this._finished || this._pushActivity(i);
      }, r = (i) => {
        this._finished || this._popActivity(i);
      };
      this.spanRecorder = new x5e(n, r, this.spanContext().spanId, t), jt && Ce.log("Starting heartbeat"), this._pingHeartbeat();
    }
    this.spanRecorder.add(this);
  }
  /**
   * Cancels the existing idle timeout, if there is one.
   * @param restartOnChildSpanChange Default is `true`.
   *                                 If set to false the transaction will end
   *                                 with the last child span.
   */
  cancelIdleTimeout(t, {
    restartOnChildSpanChange: n
  } = {
    restartOnChildSpanChange: !0
  }) {
    this._idleTimeoutCanceledPermanently = n === !1, this._idleTimeoutID && (clearTimeout(this._idleTimeoutID), this._idleTimeoutID = void 0, Object.keys(this.activities).length === 0 && this._idleTimeoutCanceledPermanently && (this._finishReason = mh[5], this.end(t)));
  }
  /**
   * Temporary method used to externally set the transaction's `finishReason`
   *
   * ** WARNING**
   * This is for the purpose of experimentation only and will be removed in the near future, do not use!
   *
   * @internal
   *
   */
  setFinishReason(t) {
    this._finishReason = t;
  }
  /**
   * Permits the IdleTransaction to automatically end itself via the idle timeout and heartbeat mechanisms when the `delayAutoFinishUntilSignal` option was set to `true`.
   */
  sendAutoFinishSignal() {
    this._autoFinishAllowed || (jt && Ce.log("[Tracing] Received finish signal for idle transaction."), this._restartIdleTimeout(), this._autoFinishAllowed = !0);
  }
  /**
   * Restarts idle timeout, if there is no running idle timeout it will start one.
   */
  _restartIdleTimeout(t) {
    this.cancelIdleTimeout(), this._idleTimeoutID = setTimeout(() => {
      !this._finished && Object.keys(this.activities).length === 0 && (this._finishReason = mh[1], this.end(t));
    }, this._idleTimeout);
  }
  /**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */
  _pushActivity(t) {
    this.cancelIdleTimeout(void 0, { restartOnChildSpanChange: !this._idleTimeoutCanceledPermanently }), jt && Ce.log(`[Tracing] pushActivity: ${t}`), this.activities[t] = !0, jt && Ce.log("[Tracing] new activities count", Object.keys(this.activities).length);
  }
  /**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */
  _popActivity(t) {
    if (this.activities[t] && (jt && Ce.log(`[Tracing] popActivity ${t}`), delete this.activities[t], jt && Ce.log("[Tracing] new activities count", Object.keys(this.activities).length)), Object.keys(this.activities).length === 0) {
      const n = by();
      this._idleTimeoutCanceledPermanently ? this._autoFinishAllowed && (this._finishReason = mh[5], this.end(n)) : this._restartIdleTimeout(n + this._idleTimeout / 1e3);
    }
  }
  /**
   * Checks when entries of this.activities are not changing for 3 beats.
   * If this occurs we finish the transaction.
   */
  _beat() {
    if (this._finished)
      return;
    const t = Object.keys(this.activities).join("");
    t === this._prevHeartbeatString ? this._heartbeatCounter++ : this._heartbeatCounter = 1, this._prevHeartbeatString = t, this._heartbeatCounter >= 3 ? this._autoFinishAllowed && (jt && Ce.log("[Tracing] Transaction finished because of no change for 3 heart beats"), this.setStatus("deadline_exceeded"), this._finishReason = mh[0], this.end()) : this._pingHeartbeat();
  }
  /**
   * Pings the heartbeat
   */
  _pingHeartbeat() {
    jt && Ce.log(`pinging Heartbeat -> current counter: ${this._heartbeatCounter}`), setTimeout(() => {
      this._beat();
    }, this._heartbeatInterval);
  }
}
function ZK(e, t, n) {
  if (!Hp(t))
    return e.sampled = !1, e;
  if (e.sampled !== void 0)
    return e.setAttribute(Uh, Number(e.sampled)), e;
  let r;
  return typeof t.tracesSampler == "function" ? (r = t.tracesSampler(n), e.setAttribute(Uh, Number(r))) : n.parentSampled !== void 0 ? r = n.parentSampled : typeof t.tracesSampleRate < "u" ? (r = t.tracesSampleRate, e.setAttribute(Uh, Number(r))) : (r = 1, e.setAttribute(Uh, r)), eY(r) ? r ? (e.sampled = Math.random() < r, e.sampled ? (jt && // eslint-disable-next-line deprecation/deprecation
  Ce.log(`[Tracing] starting ${e.op} transaction - ${qi(e).description}`), e) : (jt && Ce.log(
    `[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(
      r
    )})`
  ), e)) : (jt && Ce.log(
    `[Tracing] Discarding transaction because ${typeof t.tracesSampler == "function" ? "tracesSampler returned 0 or false" : "a negative sampling decision was inherited or tracesSampleRate is set to 0"}`
  ), e.sampled = !1, e) : (jt && Ce.warn("[Tracing] Discarding transaction because of invalid sample rate."), e.sampled = !1, e);
}
function eY(e) {
  return pK(e) || !(typeof e == "number" || typeof e == "boolean") ? (jt && Ce.warn(
    `[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(
      e
    )} of type ${JSON.stringify(typeof e)}.`
  ), !1) : e < 0 || e > 1 ? (jt && Ce.warn(`[Tracing] Given sample rate is invalid. Sample rate must be between 0 and 1. Got ${e}.`), !1) : !0;
}
function C5e() {
  const t = this.getScope().getSpan();
  return t ? {
    "sentry-trace": mE(t)
  } : {};
}
function T5e(e, t) {
  const n = this.getClient(), r = n && n.getOptions() || {}, i = r.instrumenter || "sentry", o = e.instrumenter || "sentry";
  i !== o && (jt && Ce.error(
    `A transaction was started with instrumenter=\`${o}\`, but the SDK is configured with the \`${i}\` instrumenter.
The transaction will not be sampled. Please use the ${i} instrumentation to start transactions.`
  ), e.sampled = !1);
  let a = new JK(e, this);
  return a = ZK(a, r, {
    name: e.name,
    parentSampled: e.parentSampled,
    transactionContext: e,
    attributes: {
      // eslint-disable-next-line deprecation/deprecation
      ...e.data,
      ...e.attributes
    },
    ...t
  }), a.isRecording() && a.initSpanRecorder(r._experiments && r._experiments.maxSpans), n && n.emit && n.emit("startTransaction", a), a;
}
function rj(e, t, n, r, i, o, a, s = !1) {
  const c = e.getClient(), l = c && c.getOptions() || {};
  let u = new E5e(
    t,
    e,
    n,
    r,
    a,
    i,
    s
  );
  return u = ZK(u, l, {
    name: t.name,
    parentSampled: t.parentSampled,
    transactionContext: t,
    attributes: {
      // eslint-disable-next-line deprecation/deprecation
      ...t.data,
      ...t.attributes
    },
    ...o
  }), u.isRecording() && u.initSpanRecorder(l._experiments && l._experiments.maxSpans), c && c.emit && c.emit("startTransaction", u), u;
}
function I5e() {
  const e = _y();
  e.__SENTRY__ && (e.__SENTRY__.extensions = e.__SENTRY__.extensions || {}, e.__SENTRY__.extensions.startTransaction || (e.__SENTRY__.extensions.startTransaction = T5e), e.__SENTRY__.extensions.traceHeaders || (e.__SENTRY__.extensions.traceHeaders = C5e), g5e());
}
function $5e(e, t, n) {
  const r = _f();
  r && r.setMeasurement(e, t, n);
}
function A5e(e, t) {
  return t && (e.sdk = e.sdk || {}, e.sdk.name = e.sdk.name || t.name, e.sdk.version = e.sdk.version || t.version, e.sdk.integrations = [...e.sdk.integrations || [], ...t.integrations || []], e.sdk.packages = [...e.sdk.packages || [], ...t.packages || []]), e;
}
function R5e(e, t, n, r) {
  const i = k6(n), o = {
    sent_at: (/* @__PURE__ */ new Date()).toISOString(),
    ...i && { sdk: i },
    ...!!r && t && { dsn: zp(t) }
  }, a = "aggregates" in e ? [{ type: "sessions" }, e] : [{ type: "session" }, e.toJSON()];
  return ed(o, [a]);
}
function P5e(e, t, n, r) {
  const i = k6(n), o = e.type && e.type !== "replay_event" ? e.type : "event";
  A5e(e, n && n.sdk);
  const a = kK(e, i, r, t);
  return delete e.sdkProcessingMetadata, ed(a, [[{ type: o }, e]]);
}
const O5e = "7";
function M5e(e) {
  const t = e.protocol ? `${e.protocol}:` : "", n = e.port ? `:${e.port}` : "";
  return `${t}//${e.host}${n}${e.path ? `/${e.path}` : ""}/api/`;
}
function k5e(e) {
  return `${M5e(e)}${e.projectId}/envelope/`;
}
function N5e(e, t) {
  return UCe({
    // We send only the minimum set of required information. See
    // https://github.com/getsentry/sentry-javascript/issues/2572.
    sentry_key: e.publicKey,
    sentry_version: O5e,
    ...t && { sentry_client: `${t.name}/${t.version}` }
  });
}
function D5e(e, t = {}) {
  const n = typeof t == "string" ? t : t.tunnel, r = typeof t == "string" || !t._metadata ? void 0 : t._metadata.sdk;
  return n || `${k5e(e)}?${N5e(e, r)}`;
}
const ij = [];
function j5e(e) {
  const t = {};
  return e.forEach((n) => {
    const { name: r } = n, i = t[r];
    i && !i.isDefaultInstance && n.isDefaultInstance || (t[r] = n);
  }), Object.keys(t).map((n) => t[n]);
}
function L5e(e) {
  const t = e.defaultIntegrations || [], n = e.integrations;
  t.forEach((a) => {
    a.isDefaultInstance = !0;
  });
  let r;
  Array.isArray(n) ? r = [...t, ...n] : typeof n == "function" ? r = CK(n(t)) : r = t;
  const i = j5e(r), o = V5e(i, (a) => a.name === "Debug");
  if (o !== -1) {
    const [a] = i.splice(o, 1);
    i.push(a);
  }
  return i;
}
function F5e(e, t) {
  const n = {};
  return t.forEach((r) => {
    r && tY(e, r, n);
  }), n;
}
function oj(e, t) {
  for (const n of t)
    n && n.afterAllSetup && n.afterAllSetup(e);
}
function tY(e, t, n) {
  if (n[t.name]) {
    jt && Ce.log(`Integration skipped because it was already installed: ${t.name}`);
    return;
  }
  if (n[t.name] = t, ij.indexOf(t.name) === -1 && (t.setupOnce(z2e, Ia), ij.push(t.name)), t.setup && typeof t.setup == "function" && t.setup(e), e.on && typeof t.preprocessEvent == "function") {
    const r = t.preprocessEvent.bind(t);
    e.on("preprocessEvent", (i, o) => r(i, o, e));
  }
  if (e.addEventProcessor && typeof t.processEvent == "function") {
    const r = t.processEvent.bind(t), i = Object.assign((o, a) => r(o, a, e), {
      id: t.name
    });
    e.addEventProcessor(i);
  }
  jt && Ce.log(`Integration installed: ${t.name}`);
}
function V5e(e, t) {
  for (let n = 0; n < e.length; n++)
    if (t(e[n]) === !0)
      return n;
  return -1;
}
function nd(e, t) {
  return Object.assign(
    function(...r) {
      return t(...r);
    },
    { id: e }
  );
}
function B5e(e) {
  let t = "";
  for (const n of e) {
    const r = Object.entries(n.tags), i = r.length > 0 ? `|#${r.map(([o, a]) => `${o}:${a}`).join(",")}` : "";
    t += `${n.name}@${n.unit}:${n.metric}|${n.metricType}${i}|T${n.timestamp}
`;
  }
  return t;
}
function z5e(e, t, n, r) {
  const i = {
    sent_at: (/* @__PURE__ */ new Date()).toISOString()
  };
  n && n.sdk && (i.sdk = {
    name: n.sdk.name,
    version: n.sdk.version
  }), r && t && (i.dsn = zp(t));
  const o = H5e(e);
  return ed(i, [o]);
}
function H5e(e) {
  const t = B5e(e);
  return [{
    type: "statsd",
    length: t.length
  }, t];
}
const aj = "Not capturing exception because it's already been captured.";
class U5e {
  /**
   * A reference to a metrics aggregator
   *
   * @experimental Note this is alpha API. It may experience breaking changes in the future.
   */
  /** Options passed to the SDK. */
  /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */
  /** Array of set up integrations. */
  /** Indicates whether this client's integrations have been set up. */
  /** Number of calls being processed */
  /** Holds flushable  */
  // eslint-disable-next-line @typescript-eslint/ban-types
  /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */
  constructor(t) {
    if (this._options = t, this._integrations = {}, this._integrationsInitialized = !1, this._numProcessing = 0, this._outcomes = {}, this._hooks = {}, this._eventProcessors = [], t.dsn ? this._dsn = HCe(t.dsn) : jt && Ce.warn("No DSN provided, client will not send events."), this._dsn) {
      const n = D5e(this._dsn, t);
      this._transport = t.transport({
        tunnel: this._options.tunnel,
        recordDroppedEvent: this.recordDroppedEvent.bind(this),
        ...t.transportOptions,
        url: n
      });
    }
  }
  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
  captureException(t, n, r) {
    if (V8(t)) {
      jt && Ce.log(aj);
      return;
    }
    let i = n && n.event_id;
    return this._process(
      this.eventFromException(t, n).then((o) => this._captureEvent(o, n, r)).then((o) => {
        i = o;
      })
    ), i;
  }
  /**
   * @inheritDoc
   */
  captureMessage(t, n, r, i) {
    let o = r && r.event_id;
    const a = T6(t) ? t : String(t), s = I6(t) ? this.eventFromMessage(a, n, r) : this.eventFromException(t, r);
    return this._process(
      s.then((c) => this._captureEvent(c, r, i)).then((c) => {
        o = c;
      })
    ), o;
  }
  /**
   * @inheritDoc
   */
  captureEvent(t, n, r) {
    if (n && n.originalException && V8(n.originalException)) {
      jt && Ce.log(aj);
      return;
    }
    let i = n && n.event_id;
    const a = (t.sdkProcessingMetadata || {}).capturedSpanScope;
    return this._process(
      this._captureEvent(t, n, a || r).then((s) => {
        i = s;
      })
    ), i;
  }
  /**
   * @inheritDoc
   */
  captureSession(t) {
    typeof t.release != "string" ? jt && Ce.warn("Discarded session because of missing or non-string release") : (this.sendSession(t), bf(t, { init: !1 }));
  }
  /**
   * @inheritDoc
   */
  getDsn() {
    return this._dsn;
  }
  /**
   * @inheritDoc
   */
  getOptions() {
    return this._options;
  }
  /**
   * @see SdkMetadata in @sentry/types
   *
   * @return The metadata of the SDK
   */
  getSdkMetadata() {
    return this._options._metadata;
  }
  /**
   * @inheritDoc
   */
  getTransport() {
    return this._transport;
  }
  /**
   * @inheritDoc
   */
  flush(t) {
    const n = this._transport;
    return n ? (this.metricsAggregator && this.metricsAggregator.flush(), this._isClientDoneProcessing(t).then((r) => n.flush(t).then((i) => r && i))) : kg(!0);
  }
  /**
   * @inheritDoc
   */
  close(t) {
    return this.flush(t).then((n) => (this.getOptions().enabled = !1, this.metricsAggregator && this.metricsAggregator.close(), n));
  }
  /** Get all installed event processors. */
  getEventProcessors() {
    return this._eventProcessors;
  }
  /** @inheritDoc */
  addEventProcessor(t) {
    this._eventProcessors.push(t);
  }
  /**
   * This is an internal function to setup all integrations that should run on the client.
   * @deprecated Use `client.init()` instead.
   */
  setupIntegrations(t) {
    (t && !this._integrationsInitialized || this._isEnabled() && !this._integrationsInitialized) && this._setupIntegrations();
  }
  /** @inheritdoc */
  init() {
    this._isEnabled() && this._setupIntegrations();
  }
  /**
   * Gets an installed integration by its `id`.
   *
   * @returns The installed integration or `undefined` if no integration with that `id` was installed.
   * @deprecated Use `getIntegrationByName()` instead.
   */
  getIntegrationById(t) {
    return this.getIntegrationByName(t);
  }
  /**
   * Gets an installed integration by its name.
   *
   * @returns The installed integration or `undefined` if no integration with that `name` was installed.
   */
  getIntegrationByName(t) {
    return this._integrations[t];
  }
  /**
   * Returns the client's instance of the given integration class, it any.
   * @deprecated Use `getIntegrationByName()` instead.
   */
  getIntegration(t) {
    try {
      return this._integrations[t.id] || null;
    } catch {
      return jt && Ce.warn(`Cannot retrieve integration ${t.id} from the current Client`), null;
    }
  }
  /**
   * @inheritDoc
   */
  addIntegration(t) {
    const n = this._integrations[t.name];
    tY(this, t, this._integrations), n || oj(this, [t]);
  }
  /**
   * @inheritDoc
   */
  sendEvent(t, n = {}) {
    this.emit("beforeSendEvent", t, n);
    let r = P5e(t, this._dsn, this._options._metadata, this._options.tunnel);
    for (const o of n.attachments || [])
      r = O2e(
        r,
        N2e(
          o,
          this._options.transportOptions && this._options.transportOptions.textEncoder
        )
      );
    const i = this._sendEnvelope(r);
    i && i.then((o) => this.emit("afterSendEvent", t, o), null);
  }
  /**
   * @inheritDoc
   */
  sendSession(t) {
    const n = R5e(t, this._dsn, this._options._metadata, this._options.tunnel);
    this._sendEnvelope(n);
  }
  /**
   * @inheritDoc
   */
  recordDroppedEvent(t, n, r) {
    if (this._options.sendClientReports) {
      const i = typeof r == "number" ? r : 1, o = `${t}:${n}`;
      jt && Ce.log(`Recording outcome: "${o}"${i > 1 ? ` (${i} times)` : ""}`), this._outcomes[o] = (this._outcomes[o] || 0) + i;
    }
  }
  /**
   * @inheritDoc
   */
  captureAggregateMetrics(t) {
    jt && Ce.log(`Flushing aggregated metrics, number of metrics: ${t.length}`);
    const n = z5e(
      t,
      this._dsn,
      this._options._metadata,
      this._options.tunnel
    );
    this._sendEnvelope(n);
  }
  // Keep on() & emit() signatures in sync with types' client.ts interface
  /* eslint-disable @typescript-eslint/unified-signatures */
  /** @inheritdoc */
  /** @inheritdoc */
  on(t, n) {
    this._hooks[t] || (this._hooks[t] = []), this._hooks[t].push(n);
  }
  /** @inheritdoc */
  /** @inheritdoc */
  emit(t, ...n) {
    this._hooks[t] && this._hooks[t].forEach((r) => r(...n));
  }
  /* eslint-enable @typescript-eslint/unified-signatures */
  /** Setup integrations for this client. */
  _setupIntegrations() {
    const { integrations: t } = this._options;
    this._integrations = F5e(this, t), oj(this, t), this._integrationsInitialized = !0;
  }
  /** Updates existing session based on the provided event */
  _updateSessionFromEvent(t, n) {
    let r = !1, i = !1;
    const o = n.exception && n.exception.values;
    if (o) {
      i = !0;
      for (const c of o) {
        const l = c.mechanism;
        if (l && l.handled === !1) {
          r = !0;
          break;
        }
      }
    }
    const a = t.status === "ok";
    (a && t.errors === 0 || a && r) && (bf(t, {
      ...r && { status: "crashed" },
      errors: t.errors || Number(i || r)
    }), this.captureSession(t));
  }
  /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */
  _isClientDoneProcessing(t) {
    return new pa((n) => {
      let r = 0;
      const i = 1, o = setInterval(() => {
        this._numProcessing == 0 ? (clearInterval(o), n(!0)) : (r += i, t && r >= t && (clearInterval(o), n(!1)));
      }, i);
    });
  }
  /** Determines whether this SDK is enabled and a transport is present. */
  _isEnabled() {
    return this.getOptions().enabled !== !1 && this._transport !== void 0;
  }
  /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A new event with more information.
   */
  _prepareEvent(t, n, r, i = td()) {
    const o = this.getOptions(), a = Object.keys(this._integrations);
    return !n.integrations && a.length > 0 && (n.integrations = a), this.emit("preprocessEvent", t, n), VK(o, t, n, r, this, i).then((s) => {
      if (s === null)
        return s;
      const c = {
        ...i.getPropagationContext(),
        ...r ? r.getPropagationContext() : void 0
      };
      if (!(s.contexts && s.contexts.trace) && c) {
        const { traceId: u, spanId: d, parentSpanId: f, dsc: h } = c;
        s.contexts = {
          trace: {
            trace_id: u,
            span_id: d,
            parent_span_id: f
          },
          ...s.contexts
        };
        const p = h || bE(u, this, r);
        s.sdkProcessingMetadata = {
          dynamicSamplingContext: p,
          ...s.sdkProcessingMetadata
        };
      }
      return s;
    });
  }
  /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */
  _captureEvent(t, n = {}, r) {
    return this._processEvent(t, n, r).then(
      (i) => i.event_id,
      (i) => {
        if (jt) {
          const o = i;
          o.logLevel === "log" ? Ce.log(o.message) : Ce.warn(o);
        }
      }
    );
  }
  /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */
  _processEvent(t, n, r) {
    const i = this.getOptions(), { sampleRate: o } = i, a = rY(t), s = nY(t), c = t.type || "error", l = `before send for type \`${c}\``;
    if (s && typeof o == "number" && Math.random() > o)
      return this.recordDroppedEvent("sample_rate", "error", t), O6(
        new Zs(
          `Discarding event because it's not included in the random sample (sampling rate = ${o})`,
          "log"
        )
      );
    const u = c === "replay_event" ? "replay" : c, f = (t.sdkProcessingMetadata || {}).capturedSpanIsolationScope;
    return this._prepareEvent(t, n, r, f).then((h) => {
      if (h === null)
        throw this.recordDroppedEvent("event_processor", u, t), new Zs("An event processor returned `null`, will not send event.", "log");
      if (n.data && n.data.__sentry__ === !0)
        return h;
      const g = q5e(i, h, n);
      return W5e(g, l);
    }).then((h) => {
      if (h === null) {
        if (this.recordDroppedEvent("before_send", u, t), a) {
          const v = 1 + (t.spans || []).length;
          this.recordDroppedEvent("before_send", "span", v);
        }
        throw new Zs(`${l} returned \`null\`, will not send event.`, "log");
      }
      const p = r && r.getSession();
      if (!a && p && this._updateSessionFromEvent(p, h), a) {
        const m = h.sdkProcessingMetadata && h.sdkProcessingMetadata.spanCountBeforeProcessing || 0, v = h.spans ? h.spans.length : 0, y = m - v;
        y > 0 && this.recordDroppedEvent("before_send", "span", y);
      }
      const g = h.transaction_info;
      if (a && g && h.transaction !== t.transaction) {
        const m = "custom";
        h.transaction_info = {
          ...g,
          source: m
        };
      }
      return this.sendEvent(h, n), h;
    }).then(null, (h) => {
      throw h instanceof Zs ? h : (this.captureException(h, {
        data: {
          __sentry__: !0
        },
        originalException: h
      }), new Zs(
        `Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.
Reason: ${h}`
      ));
    });
  }
  /**
   * Occupies the client with processing and event
   */
  _process(t) {
    this._numProcessing++, t.then(
      (n) => (this._numProcessing--, n),
      (n) => (this._numProcessing--, n)
    );
  }
  /**
   * @inheritdoc
   */
  _sendEnvelope(t) {
    if (this.emit("beforeEnvelope", t), this._isEnabled() && this._transport)
      return this._transport.send(t).then(null, (n) => {
        jt && Ce.error("Error while sending event:", n);
      });
    jt && Ce.error("Transport disabled");
  }
  /**
   * Clears outcomes on this client and returns them.
   */
  _clearOutcomes() {
    const t = this._outcomes;
    return this._outcomes = {}, Object.keys(t).map((n) => {
      const [r, i] = n.split(":");
      return {
        reason: r,
        category: i,
        quantity: t[n]
      };
    });
  }
  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
}
function W5e(e, t) {
  const n = `${t} must return \`null\` or a valid event.`;
  if (hE(e))
    return e.then(
      (r) => {
        if (!Mg(r) && r !== null)
          throw new Zs(n);
        return r;
      },
      (r) => {
        throw new Zs(`${t} rejected with ${r}`);
      }
    );
  if (!Mg(e) && e !== null)
    throw new Zs(n);
  return e;
}
function q5e(e, t, n) {
  const { beforeSend: r, beforeSendTransaction: i } = e;
  if (nY(t) && r)
    return r(t, n);
  if (rY(t) && i) {
    if (t.spans) {
      const o = t.spans.length;
      t.sdkProcessingMetadata = {
        ...t.sdkProcessingMetadata,
        spanCountBeforeProcessing: o
      };
    }
    return i(t, n);
  }
  return t;
}
function nY(e) {
  return e.type === void 0;
}
function rY(e) {
  return e.type === "transaction";
}
function G5e(e) {
  const t = Jn();
  !t || !t.addEventProcessor || t.addEventProcessor(e);
}
function K5e(e, t) {
  t.debug === !0 && (jt ? Ce.enable() : vf(() => {
    console.warn("[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.");
  })), Ta().update(t.initialScope);
  const r = new e(t);
  Y5e(r), X5e(r);
}
function Y5e(e) {
  const n = Ia().getStackTop();
  n.client = e, n.scope.setClient(e);
}
function X5e(e) {
  e.init ? e.init() : e.setupIntegrations && e.setupIntegrations();
}
const Q5e = 30;
function iY(e, t, n = S2e(
  e.bufferSize || Q5e
)) {
  let r = {};
  const i = (a) => n.drain(a);
  function o(a) {
    const s = [];
    if (q8(a, (d, f) => {
      const h = G8(f);
      if (NK(r, h)) {
        const p = sj(d, f);
        e.recordDroppedEvent("ratelimit_backoff", h, p);
      } else
        s.push(d);
    }), s.length === 0)
      return kg();
    const c = ed(a[0], s), l = (d) => {
      q8(c, (f, h) => {
        const p = sj(f, h);
        e.recordDroppedEvent(d, G8(h), p);
      });
    }, u = () => t({ body: M2e(c, e.textEncoder) }).then(
      (d) => (d.statusCode !== void 0 && (d.statusCode < 200 || d.statusCode >= 300) && jt && Ce.warn(`Sentry responded with status code ${d.statusCode} to sent event.`), r = DK(r, d), d),
      (d) => {
        throw l("network_error"), d;
      }
    );
    return n.add(u).then(
      (d) => d,
      (d) => {
        if (d instanceof Zs)
          return jt && Ce.error("Skipped sending event because buffer is full."), l("queue_overflow"), kg();
        throw d;
      }
    );
  }
  return o.__sentry__baseTransport__ = !0, {
    send: o,
    flush: i
  };
}
function sj(e, t) {
  if (!(t !== "event" && t !== "transaction"))
    return Array.isArray(e) ? e[1] : void 0;
}
function J5e(e, t) {
  const n = {
    sent_at: (/* @__PURE__ */ new Date()).toISOString()
  };
  t && (n.dsn = zp(t));
  const r = e.map(Z5e);
  return ed(n, r);
}
function Z5e(e) {
  return [{
    type: "span"
  }, e];
}
function eTe(e, t) {
  const n = t && rTe(t) ? (
    // eslint-disable-next-line deprecation/deprecation
    t.getClient()
  ) : t, r = n && n.getDsn(), i = n && n.getOptions().tunnel;
  return nTe(e, r) || tTe(e, i);
}
function tTe(e, t) {
  return t ? cj(e) === cj(t) : !1;
}
function nTe(e, t) {
  return t ? e.includes(t.host) : !1;
}
function cj(e) {
  return e[e.length - 1] === "/" ? e.slice(0, -1) : e;
}
function rTe(e) {
  return e.getClient !== void 0;
}
function oY(e, t, n = [t], r = "npm") {
  const i = e._metadata || {};
  i.sdk || (i.sdk = {
    name: `sentry.javascript.${t}`,
    packages: n.map((o) => ({
      name: `${r}:@sentry/${o}`,
      version: pA
    })),
    version: pA
  }), e._metadata = i;
}
const iTe = [
  /^Script error\.?$/,
  /^Javascript error: Script error\.? on line 0$/,
  /^ResizeObserver loop completed with undelivered notifications.$/,
  /^Cannot redefine property: googletag$/
], oTe = [
  /^.*\/healthcheck$/,
  /^.*\/healthy$/,
  /^.*\/live$/,
  /^.*\/ready$/,
  /^.*\/heartbeat$/,
  /^.*\/health$/,
  /^.*\/healthz$/
], aY = "InboundFilters", aTe = (e = {}) => ({
  name: aY,
  // TODO v8: Remove this
  setupOnce() {
  },
  // eslint-disable-line @typescript-eslint/no-empty-function
  processEvent(t, n, r) {
    const i = r.getOptions(), o = sTe(e, i);
    return cTe(t, o) ? null : t;
  }
}), sY = aTe;
nd(
  aY,
  sY
);
function sTe(e = {}, t = {}) {
  return {
    allowUrls: [...e.allowUrls || [], ...t.allowUrls || []],
    denyUrls: [...e.denyUrls || [], ...t.denyUrls || []],
    ignoreErrors: [
      ...e.ignoreErrors || [],
      ...t.ignoreErrors || [],
      ...e.disableErrorDefaults ? [] : iTe
    ],
    ignoreTransactions: [
      ...e.ignoreTransactions || [],
      ...t.ignoreTransactions || [],
      ...e.disableTransactionDefaults ? [] : oTe
    ],
    ignoreInternal: e.ignoreInternal !== void 0 ? e.ignoreInternal : !0
  };
}
function cTe(e, t) {
  return t.ignoreInternal && gTe(e) ? (jt && Ce.warn(`Event dropped due to being internal Sentry Error.
Event: ${Jl(e)}`), !0) : lTe(e, t.ignoreErrors) ? (jt && Ce.warn(
    `Event dropped due to being matched by \`ignoreErrors\` option.
Event: ${Jl(e)}`
  ), !0) : uTe(e, t.ignoreTransactions) ? (jt && Ce.warn(
    `Event dropped due to being matched by \`ignoreTransactions\` option.
Event: ${Jl(e)}`
  ), !0) : dTe(e, t.denyUrls) ? (jt && Ce.warn(
    `Event dropped due to being matched by \`denyUrls\` option.
Event: ${Jl(
      e
    )}.
Url: ${pS(e)}`
  ), !0) : fTe(e, t.allowUrls) ? !1 : (jt && Ce.warn(
    `Event dropped due to not being matched by \`allowUrls\` option.
Event: ${Jl(
      e
    )}.
Url: ${pS(e)}`
  ), !0);
}
function lTe(e, t) {
  return e.type || !t || !t.length ? !1 : hTe(e).some((n) => Vp(n, t));
}
function uTe(e, t) {
  if (e.type !== "transaction" || !t || !t.length)
    return !1;
  const n = e.transaction;
  return n ? Vp(n, t) : !1;
}
function dTe(e, t) {
  if (!t || !t.length)
    return !1;
  const n = pS(e);
  return n ? Vp(n, t) : !1;
}
function fTe(e, t) {
  if (!t || !t.length)
    return !0;
  const n = pS(e);
  return n ? Vp(n, t) : !0;
}
function hTe(e) {
  const t = [];
  e.message && t.push(e.message);
  let n;
  try {
    n = e.exception.values[e.exception.values.length - 1];
  } catch {
  }
  return n && n.value && (t.push(n.value), n.type && t.push(`${n.type}: ${n.value}`)), jt && t.length === 0 && Ce.error(`Could not extract message for event ${Jl(e)}`), t;
}
function gTe(e) {
  try {
    return e.exception.values[0].type === "SentryError";
  } catch {
  }
  return !1;
}
function pTe(e = []) {
  for (let t = e.length - 1; t >= 0; t--) {
    const n = e[t];
    if (n && n.filename !== "<anonymous>" && n.filename !== "[native code]")
      return n.filename || null;
  }
  return null;
}
function pS(e) {
  try {
    let t;
    try {
      t = e.exception.values[0].stacktrace.frames;
    } catch {
    }
    return t ? pTe(t) : null;
  } catch {
    return jt && Ce.error(`Cannot extract url for event ${Jl(e)}`), null;
  }
}
let lj;
const cY = "FunctionToString", uj = /* @__PURE__ */ new WeakMap(), mTe = () => ({
  name: cY,
  setupOnce() {
    lj = Function.prototype.toString;
    try {
      Function.prototype.toString = function(...e) {
        const t = A6(this), n = uj.has(Jn()) && t !== void 0 ? t : this;
        return lj.apply(n, e);
      };
    } catch {
    }
  },
  setup(e) {
    uj.set(e, !0);
  }
}), lY = mTe;
nd(
  cY,
  lY
);
const gr = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, cn = An;
function vTe() {
  cn.document ? cn.document.addEventListener("visibilitychange", () => {
    const e = _f();
    if (cn.document.hidden && e) {
      const t = "cancelled", { op: n, status: r } = qi(e);
      gr && Ce.log(`[Tracing] Transaction: ${t} -> since tab moved to the background, op: ${n}`), r || e.setStatus(t), e.setTag("visibilitychange", "document.hidden"), e.end();
    }
  }) : gr && Ce.warn("[Tracing] Could not set up background tab detection due to lack of global document");
}
const Sy = (e, t, n) => {
  let r, i;
  return (o) => {
    t.value >= 0 && (o || n) && (i = t.value - (r || 0), (i || r === void 0) && (r = t.value, t.delta = i, e(t)));
  };
}, yTe = () => `v3-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`, bTe = () => {
  const e = cn.performance.timing, t = cn.performance.navigation.type, n = {
    entryType: "navigation",
    startTime: 0,
    type: t == 2 ? "back_forward" : t === 1 ? "reload" : "navigate"
  };
  for (const r in e)
    r !== "navigationStart" && r !== "toJSON" && (n[r] = Math.max(e[r] - e.navigationStart, 0));
  return n;
}, SE = () => cn.__WEB_VITALS_POLYFILL__ ? cn.performance && (performance.getEntriesByType && performance.getEntriesByType("navigation")[0] || bTe()) : cn.performance && performance.getEntriesByType && performance.getEntriesByType("navigation")[0], F6 = () => {
  const e = SE();
  return e && e.activationStart || 0;
}, wy = (e, t) => {
  const n = SE();
  let r = "navigate";
  return n && (cn.document && cn.document.prerendering || F6() > 0 ? r = "prerender" : r = n.type.replace(/_/g, "-")), {
    name: e,
    value: typeof t > "u" ? -1 : t,
    rating: "good",
    // Will be updated if the value changes.
    delta: 0,
    entries: [],
    id: yTe(),
    navigationType: r
  };
}, Up = (e, t, n) => {
  try {
    if (PerformanceObserver.supportedEntryTypes.includes(e)) {
      const r = new PerformanceObserver((i) => {
        t(i.getEntries());
      });
      return r.observe(
        Object.assign(
          {
            type: e,
            buffered: !0
          },
          n || {}
        )
      ), r;
    }
  } catch {
  }
}, xy = (e, t) => {
  const n = (r) => {
    (r.type === "pagehide" || cn.document.visibilityState === "hidden") && (e(r), t && (removeEventListener("visibilitychange", n, !0), removeEventListener("pagehide", n, !0)));
  };
  cn.document && (addEventListener("visibilitychange", n, !0), addEventListener("pagehide", n, !0));
}, _Te = (e, t = {}) => {
  const n = wy("CLS", 0);
  let r, i = 0, o = [];
  const a = (c) => {
    c.forEach((l) => {
      if (!l.hadRecentInput) {
        const u = o[0], d = o[o.length - 1];
        i && o.length !== 0 && l.startTime - d.startTime < 1e3 && l.startTime - u.startTime < 5e3 ? (i += l.value, o.push(l)) : (i = l.value, o = [l]), i > n.value && (n.value = i, n.entries = o, r && r());
      }
    });
  }, s = Up("layout-shift", a);
  if (s) {
    r = Sy(e, n, t.reportAllChanges);
    const c = () => {
      a(s.takeRecords()), r(!0);
    };
    return xy(c), c;
  }
};
let mS = -1;
const STe = () => {
  cn.document && cn.document.visibilityState && (mS = cn.document.visibilityState === "hidden" && !cn.document.prerendering ? 0 : 1 / 0);
}, wTe = () => {
  xy(({ timeStamp: e }) => {
    mS = e;
  }, !0);
}, V6 = () => (mS < 0 && (STe(), wTe()), {
  get firstHiddenTime() {
    return mS;
  }
}), xTe = (e) => {
  const t = V6(), n = wy("FID");
  let r;
  const i = (s) => {
    s.startTime < t.firstHiddenTime && (n.value = s.processingStart - s.startTime, n.entries.push(s), r(!0));
  }, o = (s) => {
    s.forEach(i);
  }, a = Up("first-input", o);
  r = Sy(e, n), a && xy(() => {
    o(a.takeRecords()), a.disconnect();
  }, !0);
};
let uY = 0, X5 = 1 / 0, Jb = 0;
const ETe = (e) => {
  e.forEach((t) => {
    t.interactionId && (X5 = Math.min(X5, t.interactionId), Jb = Math.max(Jb, t.interactionId), uY = Jb ? (Jb - X5) / 7 + 1 : 0);
  });
};
let yA;
const CTe = () => yA ? uY : performance.interactionCount || 0, TTe = () => {
  "interactionCount" in performance || yA || (yA = Up("event", ETe, {
    type: "event",
    buffered: !0,
    durationThreshold: 0
  }));
}, dY = () => CTe(), dj = 10, Yc = [], Q5 = {}, fj = (e) => {
  const t = Yc[Yc.length - 1], n = Q5[e.interactionId];
  if (n || Yc.length < dj || e.duration > t.latency) {
    if (n)
      n.entries.push(e), n.latency = Math.max(n.latency, e.duration);
    else {
      const r = {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        id: e.interactionId,
        latency: e.duration,
        entries: [e]
      };
      Q5[r.id] = r, Yc.push(r);
    }
    Yc.sort((r, i) => i.latency - r.latency), Yc.splice(dj).forEach((r) => {
      delete Q5[r.id];
    });
  }
}, ITe = () => {
  const e = Math.min(
    Yc.length - 1,
    Math.floor(dY() / 50)
  );
  return Yc[e];
}, $Te = (e, t) => {
  t = t || {}, TTe();
  const n = wy("INP");
  let r;
  const i = (a) => {
    a.forEach((c) => {
      c.interactionId && fj(c), c.entryType === "first-input" && !Yc.some((u) => u.entries.some((d) => c.duration === d.duration && c.startTime === d.startTime)) && fj(c);
    });
    const s = ITe();
    s && s.latency !== n.value && (n.value = s.latency, n.entries = s.entries, r());
  }, o = Up("event", i, {
    // Event Timing entries have their durations rounded to the nearest 8ms,
    // so a duration of 40ms would be any event that spans 2.5 or more frames
    // at 60Hz. This threshold is chosen to strike a balance between usefulness
    // and performance. Running this callback for any interaction that spans
    // just one or two frames is likely not worth the insight that could be
    // gained.
    durationThreshold: t.durationThreshold || 40
  });
  r = Sy(e, n, t.reportAllChanges), o && (o.observe({ type: "first-input", buffered: !0 }), xy(() => {
    i(o.takeRecords()), n.value < 0 && dY() > 0 && (n.value = 0, n.entries = []), r(!0);
  }));
}, hj = {}, ATe = (e) => {
  const t = V6(), n = wy("LCP");
  let r;
  const i = (a) => {
    const s = a[a.length - 1];
    if (s) {
      const c = Math.max(s.startTime - F6(), 0);
      c < t.firstHiddenTime && (n.value = c, n.entries = [s], r());
    }
  }, o = Up("largest-contentful-paint", i);
  if (o) {
    r = Sy(e, n);
    const a = () => {
      hj[n.id] || (i(o.takeRecords()), o.disconnect(), hj[n.id] = !0, r(!0));
    };
    return ["keydown", "click"].forEach((s) => {
      cn.document && addEventListener(s, a, { once: !0, capture: !0 });
    }), xy(a, !0), a;
  }
}, bA = (e) => {
  cn.document && (cn.document.prerendering ? addEventListener("prerenderingchange", () => bA(e), !0) : cn.document.readyState !== "complete" ? addEventListener("load", () => bA(e), !0) : setTimeout(e, 0));
}, RTe = (e, t) => {
  t = t || {};
  const n = wy("TTFB"), r = Sy(e, n, t.reportAllChanges);
  bA(() => {
    const i = SE();
    if (i) {
      if (n.value = Math.max(i.responseStart - F6(), 0), n.value < 0 || n.value > performance.now())
        return;
      n.entries = [i], r(!0);
    }
  });
}, M0 = {}, vS = {};
let fY, hY, gY, pY, mY;
function PTe(e, t = !1) {
  return Ey("cls", e, NTe, fY, t);
}
function vY(e, t = !1) {
  return Ey("lcp", e, jTe, gY, t);
}
function OTe(e) {
  return Ey("ttfb", e, LTe, pY);
}
function MTe(e) {
  return Ey("fid", e, DTe, hY);
}
function kTe(e) {
  return Ey("inp", e, FTe, mY);
}
function Dg(e, t) {
  return yY(e, t), vS[e] || (VTe(e), vS[e] = !0), bY(e, t);
}
function Wp(e, t) {
  const n = M0[e];
  if (!(!n || !n.length))
    for (const r of n)
      try {
        r(t);
      } catch (i) {
        gr && Ce.error(
          `Error while triggering instrumentation handler.
Type: ${e}
Name: ${ml(r)}
Error:`,
          i
        );
      }
}
function NTe() {
  return _Te(
    (e) => {
      Wp("cls", {
        metric: e
      }), fY = e;
    },
    { reportAllChanges: !0 }
  );
}
function DTe() {
  return xTe((e) => {
    Wp("fid", {
      metric: e
    }), hY = e;
  });
}
function jTe() {
  return ATe((e) => {
    Wp("lcp", {
      metric: e
    }), gY = e;
  });
}
function LTe() {
  return RTe((e) => {
    Wp("ttfb", {
      metric: e
    }), pY = e;
  });
}
function FTe() {
  return $Te((e) => {
    Wp("inp", {
      metric: e
    }), mY = e;
  });
}
function Ey(e, t, n, r, i = !1) {
  yY(e, t);
  let o;
  return vS[e] || (o = n(), vS[e] = !0), r && t({ metric: r }), bY(e, t, i ? o : void 0);
}
function VTe(e) {
  const t = {};
  e === "event" && (t.durationThreshold = 0), Up(
    e,
    (n) => {
      Wp(e, { entries: n });
    },
    t
  );
}
function yY(e, t) {
  M0[e] = M0[e] || [], M0[e].push(t);
}
function bY(e, t, n) {
  return () => {
    n && n();
    const r = M0[e];
    if (!r)
      return;
    const i = r.indexOf(t);
    i !== -1 && r.splice(i, 1);
  };
}
function J5(e) {
  return typeof e == "number" && isFinite(e);
}
function jg(e, { startTimestamp: t, ...n }) {
  return t && e.startTimestamp > t && (e.startTimestamp = t), e.startChild({
    startTimestamp: t,
    ...n
  });
}
const BTe = 2147483647;
function Si(e) {
  return e / 1e3;
}
function B6() {
  return cn && cn.addEventListener && cn.performance;
}
let gj = 0, Wr = {}, qs, k0;
function zTe() {
  const e = B6();
  if (e && wa) {
    e.mark && cn.performance.mark("sentry-tracing-init");
    const t = KTe(), n = qTe(), r = GTe(), i = YTe();
    return () => {
      t(), n(), r(), i();
    };
  }
  return () => {
  };
}
function HTe() {
  Dg("longtask", ({ entries: e }) => {
    for (const t of e) {
      const n = _f();
      if (!n)
        return;
      const r = Si(wa + t.startTime), i = Si(t.duration);
      n.startChild({
        description: "Main UI thread blocked",
        op: "ui.long-task",
        origin: "auto.ui.browser.metrics",
        startTimestamp: r,
        endTimestamp: r + i
      });
    }
  });
}
function UTe() {
  Dg("event", ({ entries: e }) => {
    for (const t of e) {
      const n = _f();
      if (!n)
        return;
      if (t.name === "click") {
        const r = Si(wa + t.startTime), i = Si(t.duration), o = {
          description: ku(t.target),
          op: `ui.interaction.${t.name}`,
          origin: "auto.ui.browser.metrics",
          startTimestamp: r,
          endTimestamp: r + i
        }, a = yK(t.target);
        a && (o.attributes = { "ui.component_name": a }), n.startChild(o);
      }
    }
  });
}
function WTe(e, t) {
  if (B6() && wa) {
    const r = XTe(e, t);
    return () => {
      r();
    };
  }
  return () => {
  };
}
function qTe() {
  return PTe(({ metric: e }) => {
    const t = e.entries[e.entries.length - 1];
    t && (gr && Ce.log("[Measurements] Adding CLS"), Wr.cls = { value: e.value, unit: "" }, k0 = t);
  }, !0);
}
function GTe() {
  return vY(({ metric: e }) => {
    const t = e.entries[e.entries.length - 1];
    t && (gr && Ce.log("[Measurements] Adding LCP"), Wr.lcp = { value: e.value, unit: "millisecond" }, qs = t);
  }, !0);
}
function KTe() {
  return MTe(({ metric: e }) => {
    const t = e.entries[e.entries.length - 1];
    if (!t)
      return;
    const n = Si(wa), r = Si(t.startTime);
    gr && Ce.log("[Measurements] Adding FID"), Wr.fid = { value: e.value, unit: "millisecond" }, Wr["mark.fid"] = { value: n + r, unit: "second" };
  });
}
function YTe() {
  return OTe(({ metric: e }) => {
    e.entries[e.entries.length - 1] && (gr && Ce.log("[Measurements] Adding TTFB"), Wr.ttfb = { value: e.value, unit: "millisecond" });
  });
}
const pj = {
  click: "click",
  pointerdown: "click",
  pointerup: "click",
  mousedown: "click",
  mouseup: "click",
  touchstart: "click",
  touchend: "click",
  mouseover: "hover",
  mouseout: "hover",
  mouseenter: "hover",
  mouseleave: "hover",
  pointerover: "hover",
  pointerout: "hover",
  pointerenter: "hover",
  pointerleave: "hover",
  dragstart: "drag",
  dragend: "drag",
  drag: "drag",
  dragenter: "drag",
  dragleave: "drag",
  dragover: "drag",
  drop: "drag",
  keydown: "press",
  keyup: "press",
  keypress: "press",
  input: "press"
};
function XTe(e, t) {
  return kTe(({ metric: n }) => {
    if (n.value === void 0)
      return;
    const r = n.entries.find(
      (_) => _.duration === n.value && pj[_.name] !== void 0
    ), i = Jn();
    if (!r || !i)
      return;
    const o = pj[r.name], a = i.getOptions(), s = Si(wa + r.startTime), c = Si(n.value), l = r.interactionId !== void 0 ? e[r.interactionId] : void 0;
    if (l === void 0)
      return;
    const { routeName: u, parentContext: d, activeTransaction: f, user: h, replayId: p } = l, g = h !== void 0 ? h.email || h.id || h.ip_address : void 0, m = f !== void 0 ? f.getProfileId() : void 0, v = new _E({
      startTimestamp: s,
      endTimestamp: s + c,
      op: `ui.interaction.${o}`,
      name: ku(r.target),
      attributes: {
        release: a.release,
        environment: a.environment,
        transaction: u,
        ...g !== void 0 && g !== "" ? { user: g } : {},
        ...m !== void 0 ? { profile_id: m } : {},
        ...p !== void 0 ? { replay_id: p } : {}
      },
      exclusiveTime: n.value,
      measurements: {
        inp: { value: n.value, unit: "millisecond" }
      }
    }), y = oIe(d, a, t);
    if (y && Math.random() < y) {
      const _ = v ? J5e([v], i.getDsn()) : void 0, b = i && i.getTransport();
      b && _ && b.send(_).then(null, (w) => {
        gr && Ce.error("Error while sending interaction:", w);
      });
      return;
    }
  });
}
function QTe(e) {
  const t = B6();
  if (!t || !cn.performance.getEntries || !wa)
    return;
  gr && Ce.log("[Tracing] Adding & adjusting spans using Performance API");
  const n = Si(wa), r = t.getEntries(), { op: i, start_timestamp: o } = qi(e);
  if (r.slice(gj).forEach((a) => {
    const s = Si(a.startTime), c = Si(a.duration);
    if (!(e.op === "navigation" && o && n + s < o))
      switch (a.entryType) {
        case "navigation": {
          ZTe(e, a, n);
          break;
        }
        case "mark":
        case "paint":
        case "measure": {
          JTe(e, a, s, c, n);
          const l = V6(), u = a.startTime < l.firstHiddenTime;
          a.name === "first-paint" && u && (gr && Ce.log("[Measurements] Adding FP"), Wr.fp = { value: a.startTime, unit: "millisecond" }), a.name === "first-contentful-paint" && u && (gr && Ce.log("[Measurements] Adding FCP"), Wr.fcp = { value: a.startTime, unit: "millisecond" });
          break;
        }
        case "resource": {
          tIe(e, a, a.name, s, c, n);
          break;
        }
      }
  }), gj = Math.max(r.length - 1, 0), nIe(e), i === "pageload") {
    iIe(Wr), ["fcp", "fp", "lcp"].forEach((s) => {
      if (!Wr[s] || !o || n >= o)
        return;
      const c = Wr[s].value, l = n + Si(c), u = Math.abs((l - o) * 1e3), d = u - c;
      gr && Ce.log(`[Measurements] Normalized ${s} from ${c} to ${u} (${d})`), Wr[s].value = u;
    });
    const a = Wr["mark.fid"];
    a && Wr.fid && (jg(e, {
      description: "first input delay",
      endTimestamp: a.value + Si(Wr.fid.value),
      op: "ui.action",
      origin: "auto.ui.browser.metrics",
      startTimestamp: a.value
    }), delete Wr["mark.fid"]), "fcp" in Wr || delete Wr.cls, Object.keys(Wr).forEach((s) => {
      $5e(s, Wr[s].value, Wr[s].unit);
    }), rIe(e);
  }
  qs = void 0, k0 = void 0, Wr = {};
}
function JTe(e, t, n, r, i) {
  const o = i + n, a = o + r;
  return jg(e, {
    description: t.name,
    endTimestamp: a,
    op: t.entryType,
    origin: "auto.resource.browser.metrics",
    startTimestamp: o
  }), o;
}
function ZTe(e, t, n) {
  ["unloadEvent", "redirect", "domContentLoadedEvent", "loadEvent", "connect"].forEach((r) => {
    Zb(e, t, r, n);
  }), Zb(e, t, "secureConnection", n, "TLS/SSL", "connectEnd"), Zb(e, t, "fetch", n, "cache", "domainLookupStart"), Zb(e, t, "domainLookup", n, "DNS"), eIe(e, t, n);
}
function Zb(e, t, n, r, i, o) {
  const a = o ? t[o] : t[`${n}End`], s = t[`${n}Start`];
  !s || !a || jg(e, {
    op: "browser",
    origin: "auto.browser.browser.metrics",
    description: i || n,
    startTimestamp: r + Si(s),
    endTimestamp: r + Si(a)
  });
}
function eIe(e, t, n) {
  t.responseEnd && (jg(e, {
    op: "browser",
    origin: "auto.browser.browser.metrics",
    description: "request",
    startTimestamp: n + Si(t.requestStart),
    endTimestamp: n + Si(t.responseEnd)
  }), jg(e, {
    op: "browser",
    origin: "auto.browser.browser.metrics",
    description: "response",
    startTimestamp: n + Si(t.responseStart),
    endTimestamp: n + Si(t.responseEnd)
  }));
}
function tIe(e, t, n, r, i, o) {
  if (t.initiatorType === "xmlhttprequest" || t.initiatorType === "fetch")
    return;
  const a = Yd(n), s = {};
  Z5(s, t, "transferSize", "http.response_transfer_size"), Z5(s, t, "encodedBodySize", "http.response_content_length"), Z5(s, t, "decodedBodySize", "http.decoded_response_content_length"), "renderBlockingStatus" in t && (s["resource.render_blocking_status"] = t.renderBlockingStatus), a.protocol && (s["url.scheme"] = a.protocol.split(":").pop()), a.host && (s["server.address"] = a.host), s["url.same_origin"] = n.includes(cn.location.origin);
  const c = o + r, l = c + i;
  jg(e, {
    description: n.replace(cn.location.origin, ""),
    endTimestamp: l,
    op: t.initiatorType ? `resource.${t.initiatorType}` : "resource.other",
    origin: "auto.resource.browser.metrics",
    startTimestamp: c,
    data: s
  });
}
function nIe(e) {
  const t = cn.navigator;
  if (!t)
    return;
  const n = t.connection;
  n && (n.effectiveType && e.setTag("effectiveConnectionType", n.effectiveType), n.type && e.setTag("connectionType", n.type), J5(n.rtt) && (Wr["connection.rtt"] = { value: n.rtt, unit: "millisecond" })), J5(t.deviceMemory) && e.setTag("deviceMemory", `${t.deviceMemory} GB`), J5(t.hardwareConcurrency) && e.setTag("hardwareConcurrency", String(t.hardwareConcurrency));
}
function rIe(e) {
  qs && (gr && Ce.log("[Measurements] Adding LCP Data"), qs.element && e.setTag("lcp.element", ku(qs.element)), qs.id && e.setTag("lcp.id", qs.id), qs.url && e.setTag("lcp.url", qs.url.trim().slice(0, 200)), e.setTag("lcp.size", qs.size)), k0 && k0.sources && (gr && Ce.log("[Measurements] Adding CLS Data"), k0.sources.forEach(
    (t, n) => (
      // TODO: Can we rewrite this to an attribute?
      // eslint-disable-next-line deprecation/deprecation
      e.setTag(`cls.source.${n + 1}`, ku(t.node))
    )
  ));
}
function Z5(e, t, n, r) {
  const i = t[n];
  i != null && i < BTe && (e[r] = i);
}
function iIe(e) {
  const t = SE();
  if (!t)
    return;
  const { responseStart: n, requestStart: r } = t;
  r <= n && (gr && Ce.log("[Measurements] Adding TTFB Request Time"), e["ttfb.requestTime"] = {
    value: n - r,
    unit: "millisecond"
  });
}
function oIe(e, t, n) {
  if (!Hp(t))
    return !1;
  let r;
  return e !== void 0 && typeof t.tracesSampler == "function" ? r = t.tracesSampler({
    transactionContext: e,
    name: e.name,
    parentSampled: e.parentSampled,
    attributes: {
      // eslint-disable-next-line deprecation/deprecation
      ...e.data,
      ...e.attributes
    },
    location: cn.location
  }) : e !== void 0 && e.sampled !== void 0 ? r = e.sampled : typeof t.tracesSampleRate < "u" ? r = t.tracesSampleRate : r = 1, eY(r) ? r === !0 ? n : r === !1 ? 0 : r * n : (gr && Ce.warn("[Tracing] Discarding interaction span because of invalid sample rate."), !1);
}
function aIe(e, t, n, r, i = "auto.http.browser") {
  if (!Hp() || !e.fetchData)
    return;
  const o = t(e.fetchData.url);
  if (e.endTimestamp && o) {
    const h = e.fetchData.__span;
    if (!h)
      return;
    const p = r[h];
    p && (lIe(p, e), delete r[h]);
    return;
  }
  const a = Ta(), s = Jn(), { method: c, url: l } = e.fetchData, u = cIe(l), d = u ? Yd(u).host : void 0, f = o ? KK({
    name: `${c} ${l}`,
    onlyIfParent: !0,
    attributes: {
      url: l,
      type: "fetch",
      "http.method": c,
      "http.url": u,
      "server.address": d,
      [Wh]: i
    },
    op: "http.client"
  }) : void 0;
  if (f && (e.fetchData.__span = f.spanContext().spanId, r[f.spanContext().spanId] = f), n(e.fetchData.url) && s) {
    const h = e.args[0];
    e.args[1] = e.args[1] || {};
    const p = e.args[1];
    p.headers = sIe(h, s, a, p, f);
  }
  return f;
}
function sIe(e, t, n, r, i) {
  const o = i || n.getSpan(), a = td(), { traceId: s, spanId: c, sampled: l, dsc: u } = {
    ...a.getPropagationContext(),
    ...n.getPropagationContext()
  }, d = o ? mE(o) : M6(s, c, l), f = MK(
    u || (o ? Ng(o) : bE(s, t, n))
  ), h = r.headers || (typeof Request < "u" && pl(e, Request) ? e.headers : void 0);
  if (h)
    if (typeof Headers < "u" && pl(h, Headers)) {
      const p = new Headers(h);
      return p.append("sentry-trace", d), f && p.append(hA, f), p;
    } else if (Array.isArray(h)) {
      const p = [...h, ["sentry-trace", d]];
      return f && p.push([hA, f]), p;
    } else {
      const p = "baggage" in h ? h.baggage : void 0, g = [];
      return Array.isArray(p) ? g.push(...p) : p && g.push(p), f && g.push(f), {
        ...h,
        "sentry-trace": d,
        baggage: g.length > 0 ? g.join(",") : void 0
      };
    }
  else
    return { "sentry-trace": d, baggage: f };
}
function cIe(e) {
  try {
    return new URL(e).href;
  } catch {
    return;
  }
}
function lIe(e, t) {
  if (t.response) {
    L6(e, t.response.status);
    const n = t.response && t.response.headers && t.response.headers.get("content-length");
    if (n) {
      const r = parseInt(n);
      r > 0 && e.setAttribute("http.response_content_length", r);
    }
  } else
    t.error && e.setStatus("internal_error");
  e.end();
}
const _A = ["localhost", /^\/(?!\/)/], SA = {
  traceFetch: !0,
  traceXHR: !0,
  enableHTTPTimings: !0,
  // TODO (v8): Remove this property
  tracingOrigins: _A,
  tracePropagationTargets: _A
};
function uIe(e) {
  const {
    traceFetch: t,
    traceXHR: n,
    // eslint-disable-next-line deprecation/deprecation
    tracePropagationTargets: r,
    // eslint-disable-next-line deprecation/deprecation
    tracingOrigins: i,
    shouldCreateSpanForRequest: o,
    enableHTTPTimings: a
  } = {
    traceFetch: SA.traceFetch,
    traceXHR: SA.traceXHR,
    ...e
  }, s = typeof o == "function" ? o : (u) => !0, c = (u) => gIe(u, r || i), l = {};
  t && R6((u) => {
    const d = aIe(u, s, c, l);
    if (d) {
      const f = _Y(u.fetchData.url), h = f ? Yd(f).host : void 0;
      d.setAttributes({
        "http.url": f,
        "server.address": h
      });
    }
    a && d && mj(d);
  }), n && P6((u) => {
    const d = pIe(u, s, c, l);
    a && d && mj(d);
  });
}
function dIe(e) {
  return e.entryType === "resource" && "initiatorType" in e && typeof e.nextHopProtocol == "string" && (e.initiatorType === "fetch" || e.initiatorType === "xmlhttprequest");
}
function mj(e) {
  const { url: t } = qi(e).data || {};
  if (!t || typeof t != "string")
    return;
  const n = Dg("resource", ({ entries: r }) => {
    r.forEach((i) => {
      dIe(i) && i.name.endsWith(t) && (hIe(i).forEach((a) => e.setAttribute(...a)), setTimeout(n));
    });
  });
}
function fIe(e) {
  let t = "unknown", n = "unknown", r = "";
  for (const i of e) {
    if (i === "/") {
      [t, n] = e.split("/");
      break;
    }
    if (!isNaN(Number(i))) {
      t = r === "h" ? "http" : r, n = e.split(r)[1];
      break;
    }
    r += i;
  }
  return r === e && (t = r), { name: t, version: n };
}
function zs(e = 0) {
  return ((wa || performance.timeOrigin) + e) / 1e3;
}
function hIe(e) {
  const { name: t, version: n } = fIe(e.nextHopProtocol), r = [];
  return r.push(["network.protocol.version", n], ["network.protocol.name", t]), wa ? [
    ...r,
    ["http.request.redirect_start", zs(e.redirectStart)],
    ["http.request.fetch_start", zs(e.fetchStart)],
    ["http.request.domain_lookup_start", zs(e.domainLookupStart)],
    ["http.request.domain_lookup_end", zs(e.domainLookupEnd)],
    ["http.request.connect_start", zs(e.connectStart)],
    ["http.request.secure_connection_start", zs(e.secureConnectionStart)],
    ["http.request.connection_end", zs(e.connectEnd)],
    ["http.request.request_start", zs(e.requestStart)],
    ["http.request.response_start", zs(e.responseStart)],
    ["http.request.response_end", zs(e.responseEnd)]
  ] : r;
}
function gIe(e, t) {
  return Vp(e, t || _A);
}
function pIe(e, t, n, r) {
  const i = e.xhr, o = i && i[tu];
  if (!Hp() || !i || i.__sentry_own_request__ || !o)
    return;
  const a = t(o.url);
  if (e.endTimestamp && a) {
    const h = i.__sentry_xhr_span_id__;
    if (!h)
      return;
    const p = r[h];
    p && o.status_code !== void 0 && (L6(p, o.status_code), p.end(), delete r[h]);
    return;
  }
  const s = Ta(), c = td(), l = _Y(o.url), u = l ? Yd(l).host : void 0, d = a ? KK({
    name: `${o.method} ${o.url}`,
    onlyIfParent: !0,
    attributes: {
      type: "xhr",
      "http.method": o.method,
      "http.url": l,
      url: o.url,
      "server.address": u,
      [Wh]: "auto.http.browser"
    },
    op: "http.client"
  }) : void 0;
  d && (i.__sentry_xhr_span_id__ = d.spanContext().spanId, r[i.__sentry_xhr_span_id__] = d);
  const f = Jn();
  if (i.setRequestHeader && n(o.url) && f) {
    const { traceId: h, spanId: p, sampled: g, dsc: m } = {
      ...c.getPropagationContext(),
      ...s.getPropagationContext()
    }, v = d ? mE(d) : M6(h, p, g), y = MK(
      m || (d ? Ng(d) : bE(h, f, s))
    );
    mIe(i, v, y);
  }
  return d;
}
function mIe(e, t, n) {
  try {
    e.setRequestHeader("sentry-trace", t), n && e.setRequestHeader(hA, n);
  } catch {
  }
}
function _Y(e) {
  try {
    return new URL(e, cn.location.origin).href;
  } catch {
    return;
  }
}
function vIe(e, t = !0, n = !0) {
  if (!cn || !cn.location) {
    gr && Ce.warn("Could not initialize routing instrumentation due to invalid location");
    return;
  }
  let r = cn.location.href, i;
  t && (i = e({
    name: cn.location.pathname,
    // pageload should always start at timeOrigin (and needs to be in s, not ms)
    startTimestamp: wa ? wa / 1e3 : void 0,
    op: "pageload",
    origin: "auto.pageload.browser",
    metadata: { source: "url" }
  })), n && gE(({ to: o, from: a }) => {
    if (a === void 0 && r && r.indexOf(o) !== -1) {
      r = void 0;
      return;
    }
    a !== o && (r = void 0, i && (gr && Ce.log(`[Tracing] Finishing current transaction with op: ${i.op}`), i.end()), i = e({
      name: cn.location.pathname,
      op: "navigation",
      origin: "auto.navigation.browser",
      metadata: { source: "url" }
    }));
  });
}
const yIe = "BrowserTracing", bIe = {
  ...l_,
  markBackgroundTransactions: !0,
  routingInstrumentation: vIe,
  startTransactionOnLocationChange: !0,
  startTransactionOnPageLoad: !0,
  enableLongTask: !0,
  enableInp: !1,
  interactionsSampleRate: 1,
  _experiments: {},
  ...SA
}, vj = 10;
class _Ie {
  // This class currently doesn't have a static `id` field like the other integration classes, because it prevented
  // @sentry/tracing from being treeshaken. Tree shakers do not like static fields, because they behave like side effects.
  // TODO: Come up with a better plan, than using static fields on integration classes, and use that plan on all
  // integrations.
  /** Browser Tracing integration options */
  /**
   * @inheritDoc
   */
  // eslint-disable-next-line deprecation/deprecation
  constructor(t) {
    this.name = yIe, this._hasSetTracePropagationTargets = !1, I5e(), gr && (this._hasSetTracePropagationTargets = !!(t && // eslint-disable-next-line deprecation/deprecation
    (t.tracePropagationTargets || t.tracingOrigins))), this.options = {
      ...bIe,
      ...t
    }, this.options._experiments.enableLongTask !== void 0 && (this.options.enableLongTask = this.options._experiments.enableLongTask), t && !t.tracePropagationTargets && t.tracingOrigins && (this.options.tracePropagationTargets = t.tracingOrigins), this._collectWebVitals = zTe(), this._interactionIdToRouteNameMapping = {}, this.options.enableInp && WTe(this._interactionIdToRouteNameMapping, this.options.interactionsSampleRate), this.options.enableLongTask && HTe(), this.options._experiments.enableInteractions && UTe(), this._latestRoute = {
      name: void 0,
      context: void 0
    };
  }
  /**
   * @inheritDoc
   */
  // eslint-disable-next-line deprecation/deprecation
  setupOnce(t, n) {
    this._getCurrentHub = n;
    const i = n().getClient(), o = i && i.getOptions(), {
      routingInstrumentation: a,
      startTransactionOnLocationChange: s,
      startTransactionOnPageLoad: c,
      markBackgroundTransactions: l,
      traceFetch: u,
      traceXHR: d,
      shouldCreateSpanForRequest: f,
      enableHTTPTimings: h,
      _experiments: p
    } = this.options, g = o && o.tracePropagationTargets, m = g || this.options.tracePropagationTargets;
    gr && this._hasSetTracePropagationTargets && g && Ce.warn(
      "[Tracing] The `tracePropagationTargets` option was set in the BrowserTracing integration and top level `Sentry.init`. The top level `Sentry.init` value is being used."
    ), a(
      (v) => {
        const y = this._createRouteTransaction(v);
        return this.options._experiments.onStartRouteTransaction && this.options._experiments.onStartRouteTransaction(y, v, n), y;
      },
      c,
      s
    ), l && vTe(), p.enableInteractions && this._registerInteractionListener(), this.options.enableInp && this._registerInpInteractionListener(), uIe({
      traceFetch: u,
      traceXHR: d,
      tracePropagationTargets: m,
      shouldCreateSpanForRequest: f,
      enableHTTPTimings: h
    });
  }
  /** Create routing idle transaction. */
  _createRouteTransaction(t) {
    if (!this._getCurrentHub) {
      gr && Ce.warn(`[Tracing] Did not create ${t.op} transaction because _getCurrentHub is invalid.`);
      return;
    }
    const n = this._getCurrentHub(), { beforeNavigate: r, idleTimeout: i, finalTimeout: o, heartbeatInterval: a } = this.options, s = t.op === "pageload";
    let c;
    if (s) {
      const h = s ? yj("sentry-trace") : "", p = s ? yj("baggage") : void 0, { traceId: g, dsc: m, parentSpanId: v, sampled: y } = P2e(h, p);
      c = {
        traceId: g,
        parentSpanId: v,
        parentSampled: y,
        ...t,
        metadata: {
          // eslint-disable-next-line deprecation/deprecation
          ...t.metadata,
          dynamicSamplingContext: m
        },
        trimEnd: !0
      };
    } else
      c = {
        trimEnd: !0,
        ...t
      };
    const l = typeof r == "function" ? r(c) : c, u = l === void 0 ? { ...c, sampled: !1 } : l;
    u.metadata = u.name !== c.name ? (
      // eslint-disable-next-line deprecation/deprecation
      { ...u.metadata, source: "custom" }
    ) : (
      // eslint-disable-next-line deprecation/deprecation
      u.metadata
    ), this._latestRoute.name = u.name, this._latestRoute.context = u, u.sampled === !1 && gr && Ce.log(`[Tracing] Will not send ${u.op} transaction because of beforeNavigate.`), gr && Ce.log(`[Tracing] Starting ${u.op} transaction on scope`);
    const { location: d } = cn, f = rj(
      n,
      u,
      i,
      o,
      !0,
      { location: d },
      // for use in the tracesSampler
      a,
      s
      // should wait for finish signal if it's a pageload transaction
    );
    return s && cn.document && (cn.document.addEventListener("readystatechange", () => {
      ["interactive", "complete"].includes(cn.document.readyState) && f.sendAutoFinishSignal();
    }), ["interactive", "complete"].includes(cn.document.readyState) && f.sendAutoFinishSignal()), f.registerBeforeFinishCallback((h) => {
      this._collectWebVitals(), QTe(h);
    }), f;
  }
  /** Start listener for interaction transactions */
  _registerInteractionListener() {
    let t;
    const n = () => {
      const { idleTimeout: r, finalTimeout: i, heartbeatInterval: o } = this.options, a = "ui.action.click", s = _f();
      if (s && s.op && ["navigation", "pageload"].includes(s.op)) {
        gr && Ce.warn(
          `[Tracing] Did not create ${a} transaction because a pageload or navigation transaction is in progress.`
        );
        return;
      }
      if (t && (t.setFinishReason("interactionInterrupted"), t.end(), t = void 0), !this._getCurrentHub) {
        gr && Ce.warn(`[Tracing] Did not create ${a} transaction because _getCurrentHub is invalid.`);
        return;
      }
      if (!this._latestRoute.name) {
        gr && Ce.warn(`[Tracing] Did not create ${a} transaction because _latestRouteName is missing.`);
        return;
      }
      const c = this._getCurrentHub(), { location: l } = cn, u = {
        name: this._latestRoute.name,
        op: a,
        trimEnd: !0,
        data: {
          [Xd]: this._latestRoute.context ? SIe(this._latestRoute.context) : "url"
        }
      };
      t = rj(
        c,
        u,
        r,
        i,
        !0,
        { location: l },
        // for use in the tracesSampler
        o
      );
    };
    ["click"].forEach((r) => {
      cn.document && addEventListener(r, n, { once: !1, capture: !0 });
    });
  }
  /** Creates a listener on interaction entries, and maps interactionIds to the origin path of the interaction */
  _registerInpInteractionListener() {
    const t = ({ entries: n }) => {
      const r = Jn(), i = r !== void 0 && r.getIntegrationByName !== void 0 ? r.getIntegrationByName("Replay") : void 0, o = i !== void 0 ? i.getReplayId() : void 0, a = _f(), s = Ta(), c = s !== void 0 ? s.getUser() : void 0;
      n.forEach((l) => {
        if (wIe(l)) {
          const u = l.interactionId;
          if (u === void 0)
            return;
          const d = this._interactionIdToRouteNameMapping[u], f = l.duration, h = l.startTime, p = Object.keys(this._interactionIdToRouteNameMapping), g = p.length > 0 ? p.reduce((m, v) => this._interactionIdToRouteNameMapping[m].duration < this._interactionIdToRouteNameMapping[v].duration ? m : v) : void 0;
          if (l.entryType === "first-input" && p.map((v) => this._interactionIdToRouteNameMapping[v]).some((v) => v.duration === f && v.startTime === h) || !u)
            return;
          if (d)
            d.duration = Math.max(d.duration, f);
          else if (p.length < vj || g === void 0 || f > this._interactionIdToRouteNameMapping[g].duration) {
            const m = this._latestRoute.name, v = this._latestRoute.context;
            m && v && (g && Object.keys(this._interactionIdToRouteNameMapping).length >= vj && delete this._interactionIdToRouteNameMapping[g], this._interactionIdToRouteNameMapping[u] = {
              routeName: m,
              duration: f,
              parentContext: v,
              user: c,
              activeTransaction: a,
              replayId: o,
              startTime: h
            });
          }
        }
      });
    };
    Dg("event", t), Dg("first-input", t);
  }
}
function yj(e) {
  const t = DCe(`meta[name=${e}]`);
  return t ? t.getAttribute("content") : void 0;
}
function SIe(e) {
  const t = e.attributes && e.attributes[Xd], n = e.data && e.data[Xd], r = e.metadata && e.metadata.source;
  return t || n || r;
}
function wIe(e) {
  return "duration" in e;
}
const ir = An;
let wA = 0;
function SY() {
  return wA > 0;
}
function xIe() {
  wA++, setTimeout(() => {
    wA--;
  });
}
function Lg(e, t = {}, n) {
  if (typeof e != "function")
    return e;
  try {
    const i = e.__sentry_wrapped__;
    if (i)
      return typeof i == "function" ? i : e;
    if (A6(e))
      return e;
  } catch {
    return e;
  }
  const r = function() {
    const i = Array.prototype.slice.call(arguments);
    try {
      n && typeof n == "function" && n.apply(this, arguments);
      const o = i.map((a) => Lg(a, t));
      return e.apply(this, o);
    } catch (o) {
      throw xIe(), r5e((a) => {
        a.addEventProcessor((s) => (t.mechanism && (aA(s, void 0, void 0), pv(s, t.mechanism)), s.extra = {
          ...s.extra,
          arguments: i
        }, s)), yE(o);
      }), o;
    }
  };
  try {
    for (const i in e)
      Object.prototype.hasOwnProperty.call(e, i) && (r[i] = e[i]);
  } catch {
  }
  _K(r, e), yf(e, "__sentry_wrapped__", r);
  try {
    Object.getOwnPropertyDescriptor(r, "name").configurable && Object.defineProperty(r, "name", {
      get() {
        return e.name;
      }
    });
  } catch {
  }
  return r;
}
const Jc = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__;
function wY(e, t) {
  const n = z6(e, t), r = {
    type: t && t.name,
    value: IIe(t)
  };
  return n.length && (r.stacktrace = { frames: n }), r.type === void 0 && r.value === "" && (r.value = "Unrecoverable error caught"), r;
}
function EIe(e, t, n, r) {
  const i = Jn(), o = i && i.getOptions().normalizeDepth, a = {
    exception: {
      values: [
        {
          type: fE(t) ? t.constructor.name : r ? "UnhandledRejection" : "Error",
          value: RIe(t, { isUnhandledRejection: r })
        }
      ]
    },
    extra: {
      __serialized__: RK(t, o)
    }
  };
  if (n) {
    const s = z6(e, n);
    s.length && (a.exception.values[0].stacktrace = { frames: s });
  }
  return a;
}
function eT(e, t) {
  return {
    exception: {
      values: [wY(e, t)]
    }
  };
}
function z6(e, t) {
  const n = t.stacktrace || t.stack || "", r = TIe(t);
  try {
    return e(n, r);
  } catch {
  }
  return [];
}
const CIe = /Minified React error #\d+;/i;
function TIe(e) {
  if (e) {
    if (typeof e.framesToPop == "number")
      return e.framesToPop;
    if (CIe.test(e.message))
      return 1;
  }
  return 0;
}
function IIe(e) {
  const t = e && e.message;
  return t ? t.error && typeof t.error.message == "string" ? t.error.message : t : "No error message";
}
function $Ie(e, t, n, r) {
  const i = n && n.syntheticException || void 0, o = H6(e, t, i, r);
  return pv(o), o.level = "error", n && n.event_id && (o.event_id = n.event_id), kg(o);
}
function AIe(e, t, n = "info", r, i) {
  const o = r && r.syntheticException || void 0, a = xA(e, t, o, i);
  return a.level = n, r && r.event_id && (a.event_id = r.event_id), kg(a);
}
function H6(e, t, n, r, i) {
  let o;
  if (C6(t) && t.error)
    return eT(e, t.error);
  if (P8(t) || TCe(t)) {
    const a = t;
    if ("stack" in t)
      o = eT(e, t);
    else {
      const s = a.name || (P8(a) ? "DOMError" : "DOMException"), c = a.message ? `${s}: ${a.message}` : s;
      o = xA(e, c, n, r), aA(o, c);
    }
    return "code" in a && (o.tags = { ...o.tags, "DOMException.code": `${a.code}` }), o;
  }
  return gK(t) ? eT(e, t) : Mg(t) || fE(t) ? (o = EIe(e, t, n, i), pv(o, {
    synthetic: !0
  }), o) : (o = xA(e, t, n, r), aA(o, `${t}`, void 0), pv(o, {
    synthetic: !0
  }), o);
}
function xA(e, t, n, r) {
  const i = {};
  if (r && n) {
    const o = z6(e, n);
    o.length && (i.exception = {
      values: [{ value: t, stacktrace: { frames: o } }]
    });
  }
  if (T6(t)) {
    const { __sentry_template_string__: o, __sentry_template_values__: a } = t;
    return i.logentry = {
      message: o,
      params: a
    }, i;
  }
  return i.message = t, i;
}
function RIe(e, { isUnhandledRejection: t }) {
  const n = WCe(e), r = t ? "promise rejection" : "exception";
  return C6(e) ? `Event \`ErrorEvent\` captured as ${r} with message \`${e.message}\`` : fE(e) ? `Event \`${PIe(e)}\` (type=${e.type}) captured as ${r}` : `Object captured as ${r} with keys: ${n}`;
}
function PIe(e) {
  try {
    const t = Object.getPrototypeOf(e);
    return t ? t.constructor.name : void 0;
  } catch {
  }
}
function OIe(e, {
  metadata: t,
  tunnel: n,
  dsn: r
}) {
  const i = {
    event_id: e.event_id,
    sent_at: (/* @__PURE__ */ new Date()).toISOString(),
    ...t && t.sdk && {
      sdk: {
        name: t.sdk.name,
        version: t.sdk.version
      }
    },
    ...!!n && !!r && { dsn: zp(r) }
  }, o = MIe(e);
  return ed(i, [o]);
}
function MIe(e) {
  return [{
    type: "user_report"
  }, e];
}
class kIe extends U5e {
  /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */
  constructor(t) {
    const n = ir.SENTRY_SDK_SOURCE || h2e();
    oY(t, "browser", ["browser"], n), super(t), t.sendClientReports && ir.document && ir.document.addEventListener("visibilitychange", () => {
      ir.document.visibilityState === "hidden" && this._flushOutcomes();
    });
  }
  /**
   * @inheritDoc
   */
  eventFromException(t, n) {
    return $Ie(this._options.stackParser, t, n, this._options.attachStacktrace);
  }
  /**
   * @inheritDoc
   */
  eventFromMessage(t, n = "info", r) {
    return AIe(this._options.stackParser, t, n, r, this._options.attachStacktrace);
  }
  /**
   * Sends user feedback to Sentry.
   */
  captureUserFeedback(t) {
    if (!this._isEnabled()) {
      Jc && Ce.warn("SDK not enabled, will not capture user feedback.");
      return;
    }
    const n = OIe(t, {
      metadata: this.getSdkMetadata(),
      dsn: this.getDsn(),
      tunnel: this.getOptions().tunnel
    });
    this._sendEnvelope(n);
  }
  /**
   * @inheritDoc
   */
  _prepareEvent(t, n, r) {
    return t.platform = t.platform || "javascript", super._prepareEvent(t, n, r);
  }
  /**
   * Sends client reports as an envelope.
   */
  _flushOutcomes() {
    const t = this._clearOutcomes();
    if (t.length === 0) {
      Jc && Ce.log("No outcomes to send");
      return;
    }
    if (!this._dsn) {
      Jc && Ce.log("No dsn provided, will not send outcomes");
      return;
    }
    Jc && Ce.log("Sending outcomes:", t);
    const n = j2e(t, this._options.tunnel && zp(this._dsn));
    this._sendEnvelope(n);
  }
}
let l0;
function NIe() {
  if (l0)
    return l0;
  if (uA(ir.fetch))
    return l0 = ir.fetch.bind(ir);
  const e = ir.document;
  let t = ir.fetch;
  if (e && typeof e.createElement == "function")
    try {
      const n = e.createElement("iframe");
      n.hidden = !0, e.head.appendChild(n);
      const r = n.contentWindow;
      r && r.fetch && (t = r.fetch), e.head.removeChild(n);
    } catch (n) {
      Jc && Ce.warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", n);
    }
  return l0 = t.bind(ir);
}
function DIe() {
  l0 = void 0;
}
function jIe(e, t = NIe()) {
  let n = 0, r = 0;
  function i(o) {
    const a = o.body.length;
    n += a, r++;
    const s = {
      body: o.body,
      method: "POST",
      referrerPolicy: "origin",
      headers: e.headers,
      // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
      // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
      // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
      // frequently sending events right before the user is switching pages (eg. whenfinishing navigation transactions).
      // Gotchas:
      // - `keepalive` isn't supported by Firefox
      // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
      //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
      //   We will therefore only activate the flag when we're below that limit.
      // There is also a limit of requests that can be open at the same time, so we also limit this to 15
      // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
      keepalive: n <= 6e4 && r < 15,
      ...e.fetchOptions
    };
    try {
      return t(e.url, s).then((c) => (n -= a, r--, {
        statusCode: c.status,
        headers: {
          "x-sentry-rate-limits": c.headers.get("X-Sentry-Rate-Limits"),
          "retry-after": c.headers.get("Retry-After")
        }
      }));
    } catch (c) {
      return DIe(), n -= a, r--, O6(c);
    }
  }
  return iY(e, i);
}
const LIe = 4;
function FIe(e) {
  function t(n) {
    return new pa((r, i) => {
      const o = new XMLHttpRequest();
      o.onerror = i, o.onreadystatechange = () => {
        o.readyState === LIe && r({
          statusCode: o.status,
          headers: {
            "x-sentry-rate-limits": o.getResponseHeader("X-Sentry-Rate-Limits"),
            "retry-after": o.getResponseHeader("Retry-After")
          }
        });
      }, o.open("POST", e.url);
      for (const a in e.headers)
        Object.prototype.hasOwnProperty.call(e.headers, a) && o.setRequestHeader(a, e.headers[a]);
      o.send(n.body);
    });
  }
  return iY(e, t);
}
const wE = "?", VIe = 30, BIe = 40, zIe = 50;
function U6(e, t, n, r) {
  const i = {
    filename: e,
    function: t,
    in_app: !0
    // All browser frames are considered in_app
  };
  return n !== void 0 && (i.lineno = n), r !== void 0 && (i.colno = r), i;
}
const HIe = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i, UIe = /\((\S*)(?::(\d+))(?::(\d+))\)/, WIe = (e) => {
  const t = HIe.exec(e);
  if (t) {
    if (t[2] && t[2].indexOf("eval") === 0) {
      const o = UIe.exec(t[2]);
      o && (t[2] = o[1], t[3] = o[2], t[4] = o[3]);
    }
    const [r, i] = xY(t[1] || wE, t[2]);
    return U6(i, r, t[3] ? +t[3] : void 0, t[4] ? +t[4] : void 0);
  }
}, qIe = [VIe, WIe], GIe = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i, KIe = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i, YIe = (e) => {
  const t = GIe.exec(e);
  if (t) {
    if (t[3] && t[3].indexOf(" > eval") > -1) {
      const o = KIe.exec(t[3]);
      o && (t[1] = t[1] || "eval", t[3] = o[1], t[4] = o[2], t[5] = "");
    }
    let r = t[3], i = t[1] || wE;
    return [i, r] = xY(i, r), U6(r, i, t[4] ? +t[4] : void 0, t[5] ? +t[5] : void 0);
  }
}, XIe = [zIe, YIe], QIe = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i, JIe = (e) => {
  const t = QIe.exec(e);
  return t ? U6(t[2], t[1] || wE, +t[3], t[4] ? +t[4] : void 0) : void 0;
}, ZIe = [BIe, JIe], e$e = [qIe, XIe, ZIe], t$e = xK(...e$e), xY = (e, t) => {
  const n = e.indexOf("safari-extension") !== -1, r = e.indexOf("safari-web-extension") !== -1;
  return n || r ? [
    e.indexOf("@") !== -1 ? e.split("@")[0] : wE,
    n ? `safari-extension:${t}` : `safari-web-extension:${t}`
  ] : [e, t];
}, e1 = 1024, EY = "Breadcrumbs", n$e = (e = {}) => {
  const t = {
    console: !0,
    dom: !0,
    fetch: !0,
    history: !0,
    sentry: !0,
    xhr: !0,
    ...e
  };
  return {
    name: EY,
    // TODO v8: Remove this
    setupOnce() {
    },
    // eslint-disable-line @typescript-eslint/no-empty-function
    setup(n) {
      t.console && YCe(o$e(n)), t.dom && TK(i$e(n, t.dom)), t.xhr && P6(a$e(n)), t.fetch && R6(s$e(n)), t.history && gE(c$e(n)), t.sentry && n.on && n.on("beforeSendEvent", r$e(n));
    }
  };
}, CY = n$e;
nd(EY, CY);
function r$e(e) {
  return function(n) {
    Jn() === e && Nu(
      {
        category: `sentry.${n.type === "transaction" ? "transaction" : "event"}`,
        event_id: n.event_id,
        level: n.level,
        message: Jl(n)
      },
      {
        event: n
      }
    );
  };
}
function i$e(e, t) {
  return function(r) {
    if (Jn() !== e)
      return;
    let i, o, a = typeof t == "object" ? t.serializeAttribute : void 0, s = typeof t == "object" && typeof t.maxStringLength == "number" ? t.maxStringLength : void 0;
    s && s > e1 && (Jc && Ce.warn(
      `\`dom.maxStringLength\` cannot exceed ${e1}, but a value of ${s} was configured. Sentry will use ${e1} instead.`
    ), s = e1), typeof a == "string" && (a = [a]);
    try {
      const l = r.event, u = l$e(l) ? l.target : l;
      i = ku(u, { keyAttrs: a, maxStringLength: s }), o = yK(u);
    } catch {
      i = "<unknown>";
    }
    if (i.length === 0)
      return;
    const c = {
      category: `ui.${r.name}`,
      message: i
    };
    o && (c.data = { "ui.component_name": o }), Nu(c, {
      event: r.event,
      name: r.name,
      global: r.global
    });
  };
}
function o$e(e) {
  return function(n) {
    if (Jn() !== e)
      return;
    const r = {
      category: "console",
      data: {
        arguments: n.args,
        logger: "console"
      },
      level: x2e(n.level),
      message: O8(n.args, " ")
    };
    if (n.level === "assert")
      if (n.args[0] === !1)
        r.message = `Assertion failed: ${O8(n.args.slice(1), " ") || "console.assert"}`, r.data.arguments = n.args.slice(1);
      else
        return;
    Nu(r, {
      input: n.args,
      level: n.level
    });
  };
}
function a$e(e) {
  return function(n) {
    if (Jn() !== e)
      return;
    const { startTimestamp: r, endTimestamp: i } = n, o = n.xhr[tu];
    if (!r || !i || !o)
      return;
    const { method: a, url: s, status_code: c, body: l } = o, u = {
      method: a,
      url: s,
      status_code: c
    }, d = {
      xhr: n.xhr,
      input: l,
      startTimestamp: r,
      endTimestamp: i
    };
    Nu(
      {
        category: "xhr",
        data: u,
        type: "http"
      },
      d
    );
  };
}
function s$e(e) {
  return function(n) {
    if (Jn() !== e)
      return;
    const { startTimestamp: r, endTimestamp: i } = n;
    if (i && !(n.fetchData.url.match(/sentry_key/) && n.fetchData.method === "POST"))
      if (n.error) {
        const o = n.fetchData, a = {
          data: n.error,
          input: n.args,
          startTimestamp: r,
          endTimestamp: i
        };
        Nu(
          {
            category: "fetch",
            data: o,
            level: "error",
            type: "http"
          },
          a
        );
      } else {
        const o = n.response, a = {
          ...n.fetchData,
          status_code: o && o.status
        }, s = {
          input: n.args,
          response: o,
          startTimestamp: r,
          endTimestamp: i
        };
        Nu(
          {
            category: "fetch",
            data: a,
            type: "http"
          },
          s
        );
      }
  };
}
function c$e(e) {
  return function(n) {
    if (Jn() !== e)
      return;
    let r = n.from, i = n.to;
    const o = Yd(ir.location.href);
    let a = r ? Yd(r) : void 0;
    const s = Yd(i);
    (!a || !a.path) && (a = o), o.protocol === s.protocol && o.host === s.host && (i = s.relative), o.protocol === a.protocol && o.host === a.host && (r = a.relative), Nu({
      category: "navigation",
      data: {
        from: r,
        to: i
      }
    });
  };
}
function l$e(e) {
  return !!e && !!e.target;
}
const TY = "Dedupe", u$e = () => {
  let e;
  return {
    name: TY,
    // TODO v8: Remove this
    setupOnce() {
    },
    // eslint-disable-line @typescript-eslint/no-empty-function
    processEvent(t) {
      if (t.type)
        return t;
      try {
        if (d$e(t, e))
          return Jc && Ce.warn("Event dropped due to being a duplicate of previously captured event."), null;
      } catch {
      }
      return e = t;
    }
  };
}, IY = u$e;
nd(TY, IY);
function d$e(e, t) {
  return t ? !!(f$e(e, t) || h$e(e, t)) : !1;
}
function f$e(e, t) {
  const n = e.message, r = t.message;
  return !(!n && !r || n && !r || !n && r || n !== r || !AY(e, t) || !$Y(e, t));
}
function h$e(e, t) {
  const n = bj(t), r = bj(e);
  return !(!n || !r || n.type !== r.type || n.value !== r.value || !AY(e, t) || !$Y(e, t));
}
function $Y(e, t) {
  let n = _j(e), r = _j(t);
  if (!n && !r)
    return !0;
  if (n && !r || !n && r || (n = n, r = r, r.length !== n.length))
    return !1;
  for (let i = 0; i < r.length; i++) {
    const o = r[i], a = n[i];
    if (o.filename !== a.filename || o.lineno !== a.lineno || o.colno !== a.colno || o.function !== a.function)
      return !1;
  }
  return !0;
}
function AY(e, t) {
  let n = e.fingerprint, r = t.fingerprint;
  if (!n && !r)
    return !0;
  if (n && !r || !n && r)
    return !1;
  n = n, r = r;
  try {
    return n.join("") === r.join("");
  } catch {
    return !1;
  }
}
function bj(e) {
  return e.exception && e.exception.values && e.exception.values[0];
}
function _j(e) {
  const t = e.exception;
  if (t)
    try {
      return t.values[0].stacktrace.frames;
    } catch {
      return;
    }
}
const RY = "GlobalHandlers", g$e = (e = {}) => {
  const t = {
    onerror: !0,
    onunhandledrejection: !0,
    ...e
  };
  return {
    name: RY,
    setupOnce() {
      Error.stackTraceLimit = 50;
    },
    setup(n) {
      t.onerror && (p$e(n), Sj("onerror")), t.onunhandledrejection && (m$e(n), Sj("onunhandledrejection"));
    }
  };
}, PY = g$e;
nd(
  RY,
  PY
);
function p$e(e) {
  $K((t) => {
    const { stackParser: n, attachStacktrace: r } = MY();
    if (Jn() !== e || SY())
      return;
    const { msg: i, url: o, line: a, column: s, error: c } = t, l = c === void 0 && pc(i) ? b$e(i, o, a, s) : OY(
      H6(n, c || i, void 0, r, !1),
      o,
      a,
      s
    );
    l.level = "error", BK(l, {
      originalException: c,
      mechanism: {
        handled: !1,
        type: "onerror"
      }
    });
  });
}
function m$e(e) {
  AK((t) => {
    const { stackParser: n, attachStacktrace: r } = MY();
    if (Jn() !== e || SY())
      return;
    const i = v$e(t), o = I6(i) ? y$e(i) : H6(n, i, void 0, r, !0);
    o.level = "error", BK(o, {
      originalException: i,
      mechanism: {
        handled: !1,
        type: "onunhandledrejection"
      }
    });
  });
}
function v$e(e) {
  if (I6(e))
    return e;
  const t = e;
  try {
    if ("reason" in t)
      return t.reason;
    if ("detail" in t && "reason" in t.detail)
      return t.detail.reason;
  } catch {
  }
  return e;
}
function y$e(e) {
  return {
    exception: {
      values: [
        {
          type: "UnhandledRejection",
          // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
          value: `Non-Error promise rejection captured with value: ${String(e)}`
        }
      ]
    }
  };
}
function b$e(e, t, n, r) {
  const i = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
  let o = C6(e) ? e.message : e, a = "Error";
  const s = o.match(i);
  return s && (a = s[1], o = s[2]), OY({
    exception: {
      values: [
        {
          type: a,
          value: o
        }
      ]
    }
  }, t, n, r);
}
function OY(e, t, n, r) {
  const i = e.exception = e.exception || {}, o = i.values = i.values || [], a = o[0] = o[0] || {}, s = a.stacktrace = a.stacktrace || {}, c = s.frames = s.frames || [], l = isNaN(parseInt(r, 10)) ? void 0 : r, u = isNaN(parseInt(n, 10)) ? void 0 : n, d = pc(t) && t.length > 0 ? t : NCe();
  return c.length === 0 && c.push({
    colno: l,
    filename: d,
    function: "?",
    in_app: !0,
    lineno: u
  }), e;
}
function Sj(e) {
  Jc && Ce.log(`Global Handler attached: ${e}`);
}
function MY() {
  const e = Jn();
  return e && e.getOptions() || {
    stackParser: () => [],
    attachStacktrace: !1
  };
}
const kY = "HttpContext", _$e = () => ({
  name: kY,
  // TODO v8: Remove this
  setupOnce() {
  },
  // eslint-disable-line @typescript-eslint/no-empty-function
  preprocessEvent(e) {
    if (!ir.navigator && !ir.location && !ir.document)
      return;
    const t = e.request && e.request.url || ir.location && ir.location.href, { referrer: n } = ir.document || {}, { userAgent: r } = ir.navigator || {}, i = {
      ...e.request && e.request.headers,
      ...n && { Referer: n },
      ...r && { "User-Agent": r }
    }, o = { ...e.request, ...t && { url: t }, headers: i };
    e.request = o;
  }
}), NY = _$e;
nd(kY, NY);
const S$e = "cause", w$e = 5, DY = "LinkedErrors", x$e = (e = {}) => {
  const t = e.limit || w$e, n = e.key || S$e;
  return {
    name: DY,
    // TODO v8: Remove this
    setupOnce() {
    },
    // eslint-disable-line @typescript-eslint/no-empty-function
    preprocessEvent(r, i, o) {
      const a = o.getOptions();
      PCe(
        // This differs from the LinkedErrors integration in core by using a different exceptionFromError function
        wY,
        a.stackParser,
        a.maxValueLength,
        n,
        t,
        r,
        i
      );
    }
  };
}, jY = x$e;
nd(DY, jY);
const E$e = [
  "EventTarget",
  "Window",
  "Node",
  "ApplicationCache",
  "AudioTrackList",
  "BroadcastChannel",
  "ChannelMergerNode",
  "CryptoOperation",
  "EventSource",
  "FileReader",
  "HTMLUnknownElement",
  "IDBDatabase",
  "IDBRequest",
  "IDBTransaction",
  "KeyOperation",
  "MediaController",
  "MessagePort",
  "ModalWindow",
  "Notification",
  "SVGElementInstance",
  "Screen",
  "SharedWorker",
  "TextTrack",
  "TextTrackCue",
  "TextTrackList",
  "WebSocket",
  "WebSocketWorker",
  "Worker",
  "XMLHttpRequest",
  "XMLHttpRequestEventTarget",
  "XMLHttpRequestUpload"
], LY = "TryCatch", C$e = (e = {}) => {
  const t = {
    XMLHttpRequest: !0,
    eventTarget: !0,
    requestAnimationFrame: !0,
    setInterval: !0,
    setTimeout: !0,
    ...e
  };
  return {
    name: LY,
    // TODO: This currently only works for the first client this is setup
    // We may want to adjust this to check for client etc.
    setupOnce() {
      t.setTimeout && Oi(ir, "setTimeout", wj), t.setInterval && Oi(ir, "setInterval", wj), t.requestAnimationFrame && Oi(ir, "requestAnimationFrame", T$e), t.XMLHttpRequest && "XMLHttpRequest" in ir && Oi(XMLHttpRequest.prototype, "send", I$e);
      const n = t.eventTarget;
      n && (Array.isArray(n) ? n : E$e).forEach($$e);
    }
  };
}, FY = C$e;
nd(
  LY,
  FY
);
function wj(e) {
  return function(...t) {
    const n = t[0];
    return t[0] = Lg(n, {
      mechanism: {
        data: { function: ml(e) },
        handled: !1,
        type: "instrument"
      }
    }), e.apply(this, t);
  };
}
function T$e(e) {
  return function(t) {
    return e.apply(this, [
      Lg(t, {
        mechanism: {
          data: {
            function: "requestAnimationFrame",
            handler: ml(e)
          },
          handled: !1,
          type: "instrument"
        }
      })
    ]);
  };
}
function I$e(e) {
  return function(...t) {
    const n = this;
    return ["onload", "onerror", "onprogress", "onreadystatechange"].forEach((i) => {
      i in n && typeof n[i] == "function" && Oi(n, i, function(o) {
        const a = {
          mechanism: {
            data: {
              function: i,
              handler: ml(o)
            },
            handled: !1,
            type: "instrument"
          }
        }, s = A6(o);
        return s && (a.mechanism.data.handler = ml(s)), Lg(o, a);
      });
    }), e.apply(this, t);
  };
}
function $$e(e) {
  const t = ir, n = t[e] && t[e].prototype;
  !n || !n.hasOwnProperty || !n.hasOwnProperty("addEventListener") || (Oi(n, "addEventListener", function(r) {
    return function(i, o, a) {
      try {
        typeof o.handleEvent == "function" && (o.handleEvent = Lg(o.handleEvent, {
          mechanism: {
            data: {
              function: "handleEvent",
              handler: ml(o),
              target: e
            },
            handled: !1,
            type: "instrument"
          }
        }));
      } catch {
      }
      return r.apply(this, [
        i,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Lg(o, {
          mechanism: {
            data: {
              function: "addEventListener",
              handler: ml(o),
              target: e
            },
            handled: !1,
            type: "instrument"
          }
        }),
        a
      ]);
    };
  }), Oi(
    n,
    "removeEventListener",
    function(r) {
      return function(i, o, a) {
        const s = o;
        try {
          const c = s && s.__sentry_wrapped__;
          c && r.call(this, i, c, a);
        } catch {
        }
        return r.call(this, i, s, a);
      };
    }
  ));
}
const A$e = [
  sY(),
  lY(),
  FY(),
  CY(),
  PY(),
  jY(),
  IY(),
  NY()
];
function R$e(e) {
  return [
    // eslint-disable-next-line deprecation/deprecation
    ...A$e
  ];
}
function P$e(e = {}) {
  e.defaultIntegrations === void 0 && (e.defaultIntegrations = R$e()), e.release === void 0 && (typeof __SENTRY_RELEASE__ == "string" && (e.release = __SENTRY_RELEASE__), ir.SENTRY_RELEASE && ir.SENTRY_RELEASE.id && (e.release = ir.SENTRY_RELEASE.id)), e.autoSessionTracking === void 0 && (e.autoSessionTracking = !0), e.sendClientReports === void 0 && (e.sendClientReports = !0);
  const t = {
    ...e,
    stackParser: GCe(e.stackParser || t$e),
    integrations: L5e(e),
    transport: e.transport || (IK() ? jIe : FIe)
  };
  K5e(kIe, t), e.autoSessionTracking && O$e();
}
function O$e() {
  if (typeof ir.document > "u") {
    Jc && Ce.warn("Session tracking in non-browser environment with @sentry/browser is not supported.");
    return;
  }
  X8({ ignoreDuration: !0 }), Q8(), gE(({ from: e, to: t }) => {
    e !== void 0 && e !== t && (X8({ ignoreDuration: !0 }), Q8());
  });
}
const hr = An, W6 = "sentryReplaySession", M$e = "replay_event", q6 = "Unable to send Replay", k$e = 3e5, N$e = 9e5, D$e = 5e3, j$e = 5500, L$e = 6e4, F$e = 5e3, V$e = 3, xj = 15e4, t1 = 5e3, B$e = 3e3, z$e = 300, G6 = 2e7, H$e = 4999, U$e = 15e3, Ej = 36e5;
function W$e(e, t) {
  return e ?? t();
}
function yS(e) {
  let t, n = e[0], r = 1;
  for (; r < e.length; ) {
    const i = e[r], o = e[r + 1];
    if (r += 2, (i === "optionalAccess" || i === "optionalCall") && n == null)
      return;
    i === "access" || i === "optionalAccess" ? (t = n, n = o(n)) : (i === "call" || i === "optionalCall") && (n = o((...a) => n.call(t, ...a)), t = void 0);
  }
  return n;
}
var bi;
(function(e) {
  e[e.Document = 0] = "Document", e[e.DocumentType = 1] = "DocumentType", e[e.Element = 2] = "Element", e[e.Text = 3] = "Text", e[e.CDATA = 4] = "CDATA", e[e.Comment = 5] = "Comment";
})(bi || (bi = {}));
function q$e(e) {
  return e.nodeType === e.ELEMENT_NODE;
}
function N0(e) {
  const t = yS([e, "optionalAccess", (n) => n.host]);
  return yS([t, "optionalAccess", (n) => n.shadowRoot]) === e;
}
function D0(e) {
  return Object.prototype.toString.call(e) === "[object ShadowRoot]";
}
function G$e(e) {
  return e.includes(" background-clip: text;") && !e.includes(" -webkit-background-clip: text;") && (e = e.replace(" background-clip: text;", " -webkit-background-clip: text; background-clip: text;")), e;
}
function K$e(e) {
  const { cssText: t } = e;
  if (t.split('"').length < 3)
    return t;
  const n = ["@import", `url(${JSON.stringify(e.href)})`];
  return e.layerName === "" ? n.push("layer") : e.layerName && n.push(`layer(${e.layerName})`), e.supportsText && n.push(`supports(${e.supportsText})`), e.media.length && n.push(e.media.mediaText), n.join(" ") + ";";
}
function bS(e) {
  try {
    const t = e.rules || e.cssRules;
    return t ? G$e(Array.from(t, VY).join("")) : null;
  } catch {
    return null;
  }
}
function VY(e) {
  let t;
  if (X$e(e))
    try {
      t = bS(e.styleSheet) || K$e(e);
    } catch {
    }
  else if (Q$e(e) && e.selectorText.includes(":"))
    return Y$e(e.cssText);
  return t || e.cssText;
}
function Y$e(e) {
  const t = /(\[(?:[\w-]+)[^\\])(:(?:[\w-]+)\])/gm;
  return e.replace(t, "$1\\$2");
}
function X$e(e) {
  return "styleSheet" in e;
}
function Q$e(e) {
  return "selectorText" in e;
}
class BY {
  constructor() {
    this.idNodeMap = /* @__PURE__ */ new Map(), this.nodeMetaMap = /* @__PURE__ */ new WeakMap();
  }
  getId(t) {
    if (!t)
      return -1;
    const n = yS([this, "access", (r) => r.getMeta, "call", (r) => r(t), "optionalAccess", (r) => r.id]);
    return W$e(n, () => -1);
  }
  getNode(t) {
    return this.idNodeMap.get(t) || null;
  }
  getIds() {
    return Array.from(this.idNodeMap.keys());
  }
  getMeta(t) {
    return this.nodeMetaMap.get(t) || null;
  }
  removeNodeFromMap(t) {
    const n = this.getId(t);
    this.idNodeMap.delete(n), t.childNodes && t.childNodes.forEach((r) => this.removeNodeFromMap(r));
  }
  has(t) {
    return this.idNodeMap.has(t);
  }
  hasNode(t) {
    return this.nodeMetaMap.has(t);
  }
  add(t, n) {
    const r = n.id;
    this.idNodeMap.set(r, t), this.nodeMetaMap.set(t, n);
  }
  replace(t, n) {
    const r = this.getNode(t);
    if (r) {
      const i = this.nodeMetaMap.get(r);
      i && this.nodeMetaMap.set(n, i);
    }
    this.idNodeMap.set(t, n);
  }
  reset() {
    this.idNodeMap = /* @__PURE__ */ new Map(), this.nodeMetaMap = /* @__PURE__ */ new WeakMap();
  }
}
function J$e() {
  return new BY();
}
function xE({ maskInputOptions: e, tagName: t, type: n }) {
  return t === "OPTION" && (t = "SELECT"), !!(e[t.toLowerCase()] || n && e[n] || n === "password" || t === "INPUT" && !n && e.text);
}
function mv({ isMasked: e, element: t, value: n, maskInputFn: r }) {
  let i = n || "";
  return e ? (r && (i = r(i, t)), "*".repeat(i.length)) : i;
}
function Fg(e) {
  return e.toLowerCase();
}
function EA(e) {
  return e.toUpperCase();
}
const Cj = "__rrweb_original__";
function Z$e(e) {
  const t = e.getContext("2d");
  if (!t)
    return !0;
  const n = 50;
  for (let r = 0; r < e.width; r += n)
    for (let i = 0; i < e.height; i += n) {
      const o = t.getImageData, a = Cj in o ? o[Cj] : o;
      if (new Uint32Array(a.call(t, r, i, Math.min(n, e.width - r), Math.min(n, e.height - i)).data.buffer).some((c) => c !== 0))
        return !1;
    }
  return !0;
}
function K6(e) {
  const t = e.type;
  return e.hasAttribute("data-rr-is-password") ? "password" : t ? Fg(t) : null;
}
function _S(e, t, n) {
  return t === "INPUT" && (n === "radio" || n === "checkbox") ? e.getAttribute("value") || "" : e.value;
}
let eAe = 1;
const tAe = new RegExp("[^a-z0-9-_:]"), vv = -2;
function Y6() {
  return eAe++;
}
function nAe(e) {
  if (e instanceof HTMLFormElement)
    return "form";
  const t = Fg(e.tagName);
  return tAe.test(t) ? "div" : t;
}
function rAe(e) {
  let t = "";
  return e.indexOf("//") > -1 ? t = e.split("/").slice(0, 3).join("/") : t = e.split("/")[0], t = t.split("?")[0], t;
}
let vh, Tj;
const iAe = /url\((?:(')([^']*)'|(")(.*?)"|([^)]*))\)/gm, oAe = /^(?:[a-z+]+:)?\/\//i, aAe = /^www\..*/i, sAe = /^(data:)([^,]*),(.*)/i;
function SS(e, t) {
  return (e || "").replace(iAe, (n, r, i, o, a, s) => {
    const c = i || a || s, l = r || o || "";
    if (!c)
      return n;
    if (oAe.test(c) || aAe.test(c))
      return `url(${l}${c}${l})`;
    if (sAe.test(c))
      return `url(${l}${c}${l})`;
    if (c[0] === "/")
      return `url(${l}${rAe(t) + c}${l})`;
    const u = t.split("/"), d = c.split("/");
    u.pop();
    for (const f of d)
      f !== "." && (f === ".." ? u.pop() : u.push(f));
    return `url(${l}${u.join("/")}${l})`;
  });
}
const cAe = /^[^ \t\n\r\u000c]+/, lAe = /^[, \t\n\r\u000c]+/;
function uAe(e, t) {
  if (t.trim() === "")
    return t;
  let n = 0;
  function r(o) {
    let a;
    const s = o.exec(t.substring(n));
    return s ? (a = s[0], n += a.length, a) : "";
  }
  const i = [];
  for (; r(lAe), !(n >= t.length); ) {
    let o = r(cAe);
    if (o.slice(-1) === ",")
      o = qh(e, o.substring(0, o.length - 1)), i.push(o);
    else {
      let a = "";
      o = qh(e, o);
      let s = !1;
      for (; ; ) {
        const c = t.charAt(n);
        if (c === "") {
          i.push((o + a).trim());
          break;
        } else if (s)
          c === ")" && (s = !1);
        else if (c === ",") {
          n += 1, i.push((o + a).trim());
          break;
        } else
          c === "(" && (s = !0);
        a += c, n += 1;
      }
    }
  }
  return i.join(", ");
}
function qh(e, t) {
  if (!t || t.trim() === "")
    return t;
  const n = e.createElement("a");
  return n.href = t, n.href;
}
function dAe(e) {
  return !!(e.tagName === "svg" || e.ownerSVGElement);
}
function X6() {
  const e = document.createElement("a");
  return e.href = "", e.href;
}
function zY(e, t, n, r, i, o) {
  return r && (n === "src" || n === "href" && !(t === "use" && r[0] === "#") || n === "xlink:href" && r[0] !== "#" || n === "background" && (t === "table" || t === "td" || t === "th") ? qh(e, r) : n === "srcset" ? uAe(e, r) : n === "style" ? SS(r, X6()) : t === "object" && n === "data" ? qh(e, r) : typeof o == "function" ? o(n, r, i) : r);
}
function HY(e, t, n) {
  return (e === "video" || e === "audio") && t === "autoplay";
}
function fAe(e, t, n, r) {
  try {
    if (r && e.matches(r))
      return !1;
    if (typeof t == "string") {
      if (e.classList.contains(t))
        return !0;
    } else
      for (let i = e.classList.length; i--; ) {
        const o = e.classList[i];
        if (t.test(o))
          return !0;
      }
    if (n)
      return e.matches(n);
  } catch {
  }
  return !1;
}
function hAe(e, t) {
  for (let n = e.classList.length; n--; ) {
    const r = e.classList[n];
    if (t.test(r))
      return !0;
  }
  return !1;
}
function Nd(e, t, n = 1 / 0, r = 0) {
  return !e || e.nodeType !== e.ELEMENT_NODE || r > n ? -1 : t(e) ? r : Nd(e.parentNode, t, n, r + 1);
}
function Gh(e, t) {
  return (n) => {
    const r = n;
    if (r === null)
      return !1;
    try {
      if (e) {
        if (typeof e == "string") {
          if (r.matches(`.${e}`))
            return !0;
        } else if (hAe(r, e))
          return !0;
      }
      return !!(t && r.matches(t));
    } catch {
      return !1;
    }
  };
}
function Vg(e, t, n, r, i, o) {
  try {
    const a = e.nodeType === e.ELEMENT_NODE ? e : e.parentElement;
    if (a === null)
      return !1;
    if (a.tagName === "INPUT") {
      const l = a.getAttribute("autocomplete");
      if ([
        "current-password",
        "new-password",
        "cc-number",
        "cc-exp",
        "cc-exp-month",
        "cc-exp-year",
        "cc-csc"
      ].includes(l))
        return !0;
    }
    let s = -1, c = -1;
    if (o) {
      if (c = Nd(a, Gh(r, i)), c < 0)
        return !0;
      s = Nd(a, Gh(t, n), c >= 0 ? c : 1 / 0);
    } else {
      if (s = Nd(a, Gh(t, n)), s < 0)
        return !1;
      c = Nd(a, Gh(r, i), s >= 0 ? s : 1 / 0);
    }
    return s >= 0 ? c >= 0 ? s <= c : !0 : c >= 0 ? !1 : !!o;
  } catch {
  }
  return !!o;
}
function gAe(e, t, n) {
  const r = e.contentWindow;
  if (!r)
    return;
  let i = !1, o;
  try {
    o = r.document.readyState;
  } catch {
    return;
  }
  if (o !== "complete") {
    const s = setTimeout(() => {
      i || (t(), i = !0);
    }, n);
    e.addEventListener("load", () => {
      clearTimeout(s), i = !0, t();
    });
    return;
  }
  const a = "about:blank";
  if (r.location.href !== a || e.src === a || e.src === "")
    return setTimeout(t, 0), e.addEventListener("load", t);
  e.addEventListener("load", t);
}
function pAe(e, t, n) {
  let r = !1, i;
  try {
    i = e.sheet;
  } catch {
    return;
  }
  if (i)
    return;
  const o = setTimeout(() => {
    r || (t(), r = !0);
  }, n);
  e.addEventListener("load", () => {
    clearTimeout(o), r = !0, t();
  });
}
function mAe(e, t) {
  const { doc: n, mirror: r, blockClass: i, blockSelector: o, unblockSelector: a, maskAllText: s, maskAttributeFn: c, maskTextClass: l, unmaskTextClass: u, maskTextSelector: d, unmaskTextSelector: f, inlineStylesheet: h, maskInputOptions: p = {}, maskTextFn: g, maskInputFn: m, dataURLOptions: v = {}, inlineImages: y, recordCanvas: _, keepIframeSrcFn: b, newlyAddedElement: w = !1 } = t, C = vAe(n, r);
  switch (e.nodeType) {
    case e.DOCUMENT_NODE:
      return e.compatMode !== "CSS1Compat" ? {
        type: bi.Document,
        childNodes: [],
        compatMode: e.compatMode
      } : {
        type: bi.Document,
        childNodes: []
      };
    case e.DOCUMENT_TYPE_NODE:
      return {
        type: bi.DocumentType,
        name: e.name,
        publicId: e.publicId,
        systemId: e.systemId,
        rootId: C
      };
    case e.ELEMENT_NODE:
      return bAe(e, {
        doc: n,
        blockClass: i,
        blockSelector: o,
        unblockSelector: a,
        inlineStylesheet: h,
        maskAttributeFn: c,
        maskInputOptions: p,
        maskInputFn: m,
        dataURLOptions: v,
        inlineImages: y,
        recordCanvas: _,
        keepIframeSrcFn: b,
        newlyAddedElement: w,
        rootId: C,
        maskAllText: s,
        maskTextClass: l,
        unmaskTextClass: u,
        maskTextSelector: d,
        unmaskTextSelector: f
      });
    case e.TEXT_NODE:
      return yAe(e, {
        maskAllText: s,
        maskTextClass: l,
        unmaskTextClass: u,
        maskTextSelector: d,
        unmaskTextSelector: f,
        maskTextFn: g,
        maskInputOptions: p,
        maskInputFn: m,
        rootId: C
      });
    case e.CDATA_SECTION_NODE:
      return {
        type: bi.CDATA,
        textContent: "",
        rootId: C
      };
    case e.COMMENT_NODE:
      return {
        type: bi.Comment,
        textContent: e.textContent || "",
        rootId: C
      };
    default:
      return !1;
  }
}
function vAe(e, t) {
  if (!t.hasNode(e))
    return;
  const n = t.getId(e);
  return n === 1 ? void 0 : n;
}
function yAe(e, t) {
  const { maskAllText: n, maskTextClass: r, unmaskTextClass: i, maskTextSelector: o, unmaskTextSelector: a, maskTextFn: s, maskInputOptions: c, maskInputFn: l, rootId: u } = t, d = e.parentNode && e.parentNode.tagName;
  let f = e.textContent;
  const h = d === "STYLE" ? !0 : void 0, p = d === "SCRIPT" ? !0 : void 0, g = d === "TEXTAREA" ? !0 : void 0;
  if (h && f) {
    try {
      e.nextSibling || e.previousSibling || yS([e, "access", (v) => v.parentNode, "access", (v) => v.sheet, "optionalAccess", (v) => v.cssRules]) && (f = bS(e.parentNode.sheet));
    } catch (v) {
      console.warn(`Cannot get CSS styles from text's parentNode. Error: ${v}`, e);
    }
    f = SS(f, X6());
  }
  p && (f = "SCRIPT_PLACEHOLDER");
  const m = Vg(e, r, o, i, a, n);
  if (!h && !p && !g && f && m && (f = s ? s(f, e.parentElement) : f.replace(/[\S]/g, "*")), g && f && (c.textarea || m) && (f = l ? l(f, e.parentNode) : f.replace(/[\S]/g, "*")), d === "OPTION" && f) {
    const v = xE({
      type: null,
      tagName: d,
      maskInputOptions: c
    });
    f = mv({
      isMasked: Vg(e, r, o, i, a, v),
      element: e,
      value: f,
      maskInputFn: l
    });
  }
  return {
    type: bi.Text,
    textContent: f || "",
    isStyle: h,
    rootId: u
  };
}
function bAe(e, t) {
  const { doc: n, blockClass: r, blockSelector: i, unblockSelector: o, inlineStylesheet: a, maskInputOptions: s = {}, maskAttributeFn: c, maskInputFn: l, dataURLOptions: u = {}, inlineImages: d, recordCanvas: f, keepIframeSrcFn: h, newlyAddedElement: p = !1, rootId: g, maskAllText: m, maskTextClass: v, unmaskTextClass: y, maskTextSelector: _, unmaskTextSelector: b } = t, w = fAe(e, r, i, o), C = nAe(e);
  let x = {};
  const T = e.attributes.length;
  for (let R = 0; R < T; R++) {
    const I = e.attributes[R];
    I.name && !HY(C, I.name, I.value) && (x[I.name] = zY(n, C, Fg(I.name), I.value, e, c));
  }
  if (C === "link" && a) {
    const R = Array.from(n.styleSheets).find((O) => O.href === e.href);
    let I = null;
    R && (I = bS(R)), I && (delete x.rel, delete x.href, x._cssText = SS(I, R.href));
  }
  if (C === "style" && e.sheet && !(e.innerText || e.textContent || "").trim().length) {
    const R = bS(e.sheet);
    R && (x._cssText = SS(R, X6()));
  }
  if (C === "input" || C === "textarea" || C === "select" || C === "option") {
    const R = e, I = K6(R), O = _S(R, EA(C), I), P = R.checked;
    if (I !== "submit" && I !== "button" && O) {
      const k = Vg(R, v, _, y, b, xE({
        type: I,
        tagName: EA(C),
        maskInputOptions: s
      }));
      x.value = mv({
        isMasked: k,
        element: R,
        value: O,
        maskInputFn: l
      });
    }
    P && (x.checked = P);
  }
  if (C === "option" && (e.selected && !s.select ? x.selected = !0 : delete x.selected), C === "canvas" && f) {
    if (e.__context === "2d")
      Z$e(e) || (x.rr_dataURL = e.toDataURL(u.type, u.quality));
    else if (!("__context" in e)) {
      const R = e.toDataURL(u.type, u.quality), I = document.createElement("canvas");
      I.width = e.width, I.height = e.height;
      const O = I.toDataURL(u.type, u.quality);
      R !== O && (x.rr_dataURL = R);
    }
  }
  if (C === "img" && d) {
    vh || (vh = n.createElement("canvas"), Tj = vh.getContext("2d"));
    const R = e, I = R.crossOrigin;
    R.crossOrigin = "anonymous";
    const O = () => {
      R.removeEventListener("load", O);
      try {
        vh.width = R.naturalWidth, vh.height = R.naturalHeight, Tj.drawImage(R, 0, 0), x.rr_dataURL = vh.toDataURL(u.type, u.quality);
      } catch (P) {
        console.warn(`Cannot inline img src=${R.currentSrc}! Error: ${P}`);
      }
      I ? x.crossOrigin = I : R.removeAttribute("crossorigin");
    };
    R.complete && R.naturalWidth !== 0 ? O() : R.addEventListener("load", O);
  }
  if ((C === "audio" || C === "video") && (x.rr_mediaState = e.paused ? "paused" : "played", x.rr_mediaCurrentTime = e.currentTime), p || (e.scrollLeft && (x.rr_scrollLeft = e.scrollLeft), e.scrollTop && (x.rr_scrollTop = e.scrollTop)), w) {
    const { width: R, height: I } = e.getBoundingClientRect();
    x = {
      class: x.class,
      rr_width: `${R}px`,
      rr_height: `${I}px`
    };
  }
  C === "iframe" && !h(x.src) && (e.contentDocument || (x.rr_src = x.src), delete x.src);
  let E;
  try {
    customElements.get(C) && (E = !0);
  } catch {
  }
  return {
    type: bi.Element,
    tagName: C,
    attributes: x,
    childNodes: [],
    isSVG: dAe(e) || void 0,
    needBlock: w,
    rootId: g,
    isCustom: E
  };
}
function lr(e) {
  return e == null ? "" : e.toLowerCase();
}
function _Ae(e, t) {
  if (t.comment && e.type === bi.Comment)
    return !0;
  if (e.type === bi.Element) {
    if (t.script && (e.tagName === "script" || e.tagName === "link" && (e.attributes.rel === "preload" || e.attributes.rel === "modulepreload") && e.attributes.as === "script" || e.tagName === "link" && e.attributes.rel === "prefetch" && typeof e.attributes.href == "string" && e.attributes.href.endsWith(".js")))
      return !0;
    if (t.headFavicon && (e.tagName === "link" && e.attributes.rel === "shortcut icon" || e.tagName === "meta" && (lr(e.attributes.name).match(/^msapplication-tile(image|color)$/) || lr(e.attributes.name) === "application-name" || lr(e.attributes.rel) === "icon" || lr(e.attributes.rel) === "apple-touch-icon" || lr(e.attributes.rel) === "shortcut icon")))
      return !0;
    if (e.tagName === "meta") {
      if (t.headMetaDescKeywords && lr(e.attributes.name).match(/^description|keywords$/))
        return !0;
      if (t.headMetaSocial && (lr(e.attributes.property).match(/^(og|twitter|fb):/) || lr(e.attributes.name).match(/^(og|twitter):/) || lr(e.attributes.name) === "pinterest"))
        return !0;
      if (t.headMetaRobots && (lr(e.attributes.name) === "robots" || lr(e.attributes.name) === "googlebot" || lr(e.attributes.name) === "bingbot"))
        return !0;
      if (t.headMetaHttpEquiv && e.attributes["http-equiv"] !== void 0)
        return !0;
      if (t.headMetaAuthorship && (lr(e.attributes.name) === "author" || lr(e.attributes.name) === "generator" || lr(e.attributes.name) === "framework" || lr(e.attributes.name) === "publisher" || lr(e.attributes.name) === "progid" || lr(e.attributes.property).match(/^article:/) || lr(e.attributes.property).match(/^product:/)))
        return !0;
      if (t.headMetaVerification && (lr(e.attributes.name) === "google-site-verification" || lr(e.attributes.name) === "yandex-verification" || lr(e.attributes.name) === "csrf-token" || lr(e.attributes.name) === "p:domain_verify" || lr(e.attributes.name) === "verify-v1" || lr(e.attributes.name) === "verification" || lr(e.attributes.name) === "shopify-checkout-api-token"))
        return !0;
    }
  }
  return !1;
}
function Kh(e, t) {
  const { doc: n, mirror: r, blockClass: i, blockSelector: o, unblockSelector: a, maskAllText: s, maskTextClass: c, unmaskTextClass: l, maskTextSelector: u, unmaskTextSelector: d, skipChild: f = !1, inlineStylesheet: h = !0, maskInputOptions: p = {}, maskAttributeFn: g, maskTextFn: m, maskInputFn: v, slimDOMOptions: y, dataURLOptions: _ = {}, inlineImages: b = !1, recordCanvas: w = !1, onSerialize: C, onIframeLoad: x, iframeLoadTimeout: T = 5e3, onStylesheetLoad: E, stylesheetLoadTimeout: R = 5e3, keepIframeSrcFn: I = () => !1, newlyAddedElement: O = !1 } = t;
  let { preserveWhiteSpace: P = !0 } = t;
  const k = mAe(e, {
    doc: n,
    mirror: r,
    blockClass: i,
    blockSelector: o,
    maskAllText: s,
    unblockSelector: a,
    maskTextClass: c,
    unmaskTextClass: l,
    maskTextSelector: u,
    unmaskTextSelector: d,
    inlineStylesheet: h,
    maskInputOptions: p,
    maskAttributeFn: g,
    maskTextFn: m,
    maskInputFn: v,
    dataURLOptions: _,
    inlineImages: b,
    recordCanvas: w,
    keepIframeSrcFn: I,
    newlyAddedElement: O
  });
  if (!k)
    return console.warn(e, "not serialized"), null;
  let L;
  r.hasNode(e) ? L = r.getId(e) : _Ae(k, y) || !P && k.type === bi.Text && !k.isStyle && !k.textContent.replace(/^\s+|\s+$/gm, "").length ? L = vv : L = Y6();
  const N = Object.assign(k, { id: L });
  if (r.add(e, N), L === vv)
    return null;
  C && C(e);
  let D = !f;
  if (N.type === bi.Element) {
    D = D && !N.needBlock, delete N.needBlock;
    const z = e.shadowRoot;
    z && D0(z) && (N.isShadowHost = !0);
  }
  if ((N.type === bi.Document || N.type === bi.Element) && D) {
    y.headWhitespace && N.type === bi.Element && N.tagName === "head" && (P = !1);
    const z = {
      doc: n,
      mirror: r,
      blockClass: i,
      blockSelector: o,
      maskAllText: s,
      unblockSelector: a,
      maskTextClass: c,
      unmaskTextClass: l,
      maskTextSelector: u,
      unmaskTextSelector: d,
      skipChild: f,
      inlineStylesheet: h,
      maskInputOptions: p,
      maskAttributeFn: g,
      maskTextFn: m,
      maskInputFn: v,
      slimDOMOptions: y,
      dataURLOptions: _,
      inlineImages: b,
      recordCanvas: w,
      preserveWhiteSpace: P,
      onSerialize: C,
      onIframeLoad: x,
      iframeLoadTimeout: T,
      onStylesheetLoad: E,
      stylesheetLoadTimeout: R,
      keepIframeSrcFn: I
    };
    for (const V of Array.from(e.childNodes)) {
      const B = Kh(V, z);
      B && N.childNodes.push(B);
    }
    if (q$e(e) && e.shadowRoot)
      for (const V of Array.from(e.shadowRoot.childNodes)) {
        const B = Kh(V, z);
        B && (D0(e.shadowRoot) && (B.isShadow = !0), N.childNodes.push(B));
      }
  }
  return e.parentNode && N0(e.parentNode) && D0(e.parentNode) && (N.isShadow = !0), N.type === bi.Element && N.tagName === "iframe" && gAe(e, () => {
    const z = e.contentDocument;
    if (z && x) {
      const V = Kh(z, {
        doc: z,
        mirror: r,
        blockClass: i,
        blockSelector: o,
        unblockSelector: a,
        maskAllText: s,
        maskTextClass: c,
        unmaskTextClass: l,
        maskTextSelector: u,
        unmaskTextSelector: d,
        skipChild: !1,
        inlineStylesheet: h,
        maskInputOptions: p,
        maskAttributeFn: g,
        maskTextFn: m,
        maskInputFn: v,
        slimDOMOptions: y,
        dataURLOptions: _,
        inlineImages: b,
        recordCanvas: w,
        preserveWhiteSpace: P,
        onSerialize: C,
        onIframeLoad: x,
        iframeLoadTimeout: T,
        onStylesheetLoad: E,
        stylesheetLoadTimeout: R,
        keepIframeSrcFn: I
      });
      V && x(e, V);
    }
  }, T), N.type === bi.Element && N.tagName === "link" && N.attributes.rel === "stylesheet" && pAe(e, () => {
    if (E) {
      const z = Kh(e, {
        doc: n,
        mirror: r,
        blockClass: i,
        blockSelector: o,
        unblockSelector: a,
        maskAllText: s,
        maskTextClass: c,
        unmaskTextClass: l,
        maskTextSelector: u,
        unmaskTextSelector: d,
        skipChild: !1,
        inlineStylesheet: h,
        maskInputOptions: p,
        maskAttributeFn: g,
        maskTextFn: m,
        maskInputFn: v,
        slimDOMOptions: y,
        dataURLOptions: _,
        inlineImages: b,
        recordCanvas: w,
        preserveWhiteSpace: P,
        onSerialize: C,
        onIframeLoad: x,
        iframeLoadTimeout: T,
        onStylesheetLoad: E,
        stylesheetLoadTimeout: R,
        keepIframeSrcFn: I
      });
      z && E(e, z);
    }
  }, R), N;
}
function SAe(e, t) {
  const { mirror: n = new BY(), blockClass: r = "rr-block", blockSelector: i = null, unblockSelector: o = null, maskAllText: a = !1, maskTextClass: s = "rr-mask", unmaskTextClass: c = null, maskTextSelector: l = null, unmaskTextSelector: u = null, inlineStylesheet: d = !0, inlineImages: f = !1, recordCanvas: h = !1, maskAllInputs: p = !1, maskAttributeFn: g, maskTextFn: m, maskInputFn: v, slimDOM: y = !1, dataURLOptions: _, preserveWhiteSpace: b, onSerialize: w, onIframeLoad: C, iframeLoadTimeout: x, onStylesheetLoad: T, stylesheetLoadTimeout: E, keepIframeSrcFn: R = () => !1 } = t || {};
  return Kh(e, {
    doc: e,
    mirror: n,
    blockClass: r,
    blockSelector: i,
    unblockSelector: o,
    maskAllText: a,
    maskTextClass: s,
    unmaskTextClass: c,
    maskTextSelector: l,
    unmaskTextSelector: u,
    skipChild: !1,
    inlineStylesheet: d,
    maskInputOptions: p === !0 ? {
      color: !0,
      date: !0,
      "datetime-local": !0,
      email: !0,
      month: !0,
      number: !0,
      range: !0,
      search: !0,
      tel: !0,
      text: !0,
      time: !0,
      url: !0,
      week: !0,
      textarea: !0,
      select: !0
    } : p === !1 ? {} : p,
    maskAttributeFn: g,
    maskTextFn: m,
    maskInputFn: v,
    slimDOMOptions: y === !0 || y === "all" ? {
      script: !0,
      comment: !0,
      headFavicon: !0,
      headWhitespace: !0,
      headMetaDescKeywords: y === "all",
      headMetaSocial: !0,
      headMetaRobots: !0,
      headMetaHttpEquiv: !0,
      headMetaAuthorship: !0,
      headMetaVerification: !0
    } : y === !1 ? {} : y,
    dataURLOptions: _,
    inlineImages: f,
    recordCanvas: h,
    preserveWhiteSpace: b,
    onSerialize: w,
    onIframeLoad: C,
    iframeLoadTimeout: x,
    onStylesheetLoad: T,
    stylesheetLoadTimeout: E,
    keepIframeSrcFn: R,
    newlyAddedElement: !1
  });
}
function Bl(e) {
  let t, n = e[0], r = 1;
  for (; r < e.length; ) {
    const i = e[r], o = e[r + 1];
    if (r += 2, (i === "optionalAccess" || i === "optionalCall") && n == null)
      return;
    i === "access" || i === "optionalAccess" ? (t = n, n = o(n)) : (i === "call" || i === "optionalCall") && (n = o((...a) => n.call(t, ...a)), t = void 0);
  }
  return n;
}
function $o(e, t, n = document) {
  const r = { capture: !0, passive: !0 };
  return n.addEventListener(e, t, r), () => n.removeEventListener(e, t, r);
}
const Bh = `Please stop import mirror directly. Instead of that,\r
now you can use replayer.getMirror() to access the mirror instance of a replayer,\r
or you can use record.mirror to access the mirror instance during recording.`;
let Ij = {
  map: {},
  getId() {
    return console.error(Bh), -1;
  },
  getNode() {
    return console.error(Bh), null;
  },
  removeNodeFromMap() {
    console.error(Bh);
  },
  has() {
    return console.error(Bh), !1;
  },
  reset() {
    console.error(Bh);
  }
};
typeof window < "u" && window.Proxy && window.Reflect && (Ij = new Proxy(Ij, {
  get(e, t, n) {
    return t === "map" && console.error(Bh), Reflect.get(e, t, n);
  }
}));
function yv(e, t, n = {}) {
  let r = null, i = 0;
  return function(...o) {
    const a = Date.now();
    !i && n.leading === !1 && (i = a);
    const s = t - (a - i), c = this;
    s <= 0 || s > t ? (r && ($Ae(r), r = null), i = a, e.apply(c, o)) : !r && n.trailing !== !1 && (r = EE(() => {
      i = n.leading === !1 ? 0 : Date.now(), r = null, e.apply(c, o);
    }, s));
  };
}
function UY(e, t, n, r, i = window) {
  const o = i.Object.getOwnPropertyDescriptor(e, t);
  return i.Object.defineProperty(e, t, r ? n : {
    set(a) {
      EE(() => {
        n.set.call(this, a);
      }, 0), o && o.set && o.set.call(this, a);
    }
  }), () => UY(e, t, o || {}, !0);
}
function Q6(e, t, n) {
  try {
    if (!(t in e))
      return () => {
      };
    const r = e[t], i = n(r);
    return typeof i == "function" && (i.prototype = i.prototype || {}, Object.defineProperties(i, {
      __rrweb_original__: {
        enumerable: !1,
        value: r
      }
    })), e[t] = i, () => {
      e[t] = r;
    };
  } catch {
    return () => {
    };
  }
}
let wS = Date.now;
/[1-9][0-9]{12}/.test(Date.now().toString()) || (wS = () => (/* @__PURE__ */ new Date()).getTime());
function WY(e) {
  const t = e.document;
  return {
    left: t.scrollingElement ? t.scrollingElement.scrollLeft : e.pageXOffset !== void 0 ? e.pageXOffset : Bl([t, "optionalAccess", (n) => n.documentElement, "access", (n) => n.scrollLeft]) || Bl([t, "optionalAccess", (n) => n.body, "optionalAccess", (n) => n.parentElement, "optionalAccess", (n) => n.scrollLeft]) || Bl([t, "optionalAccess", (n) => n.body, "optionalAccess", (n) => n.scrollLeft]) || 0,
    top: t.scrollingElement ? t.scrollingElement.scrollTop : e.pageYOffset !== void 0 ? e.pageYOffset : Bl([t, "optionalAccess", (n) => n.documentElement, "access", (n) => n.scrollTop]) || Bl([t, "optionalAccess", (n) => n.body, "optionalAccess", (n) => n.parentElement, "optionalAccess", (n) => n.scrollTop]) || Bl([t, "optionalAccess", (n) => n.body, "optionalAccess", (n) => n.scrollTop]) || 0
  };
}
function qY() {
  return window.innerHeight || document.documentElement && document.documentElement.clientHeight || document.body && document.body.clientHeight;
}
function GY() {
  return window.innerWidth || document.documentElement && document.documentElement.clientWidth || document.body && document.body.clientWidth;
}
function KY(e) {
  return e ? e.nodeType === e.ELEMENT_NODE ? e : e.parentElement : null;
}
function fs(e, t, n, r, i) {
  if (!e)
    return !1;
  const o = KY(e);
  if (!o)
    return !1;
  const a = Gh(t, n);
  if (!i) {
    const l = r && o.matches(r);
    return a(o) && !l;
  }
  const s = Nd(o, a);
  let c = -1;
  return s < 0 ? !1 : (r && (c = Nd(o, Gh(null, r))), s > -1 && c < 0 ? !0 : s < c);
}
function wAe(e, t) {
  return t.getId(e) !== -1;
}
function tT(e, t) {
  return t.getId(e) === vv;
}
function YY(e, t) {
  if (N0(e))
    return !1;
  const n = t.getId(e);
  return t.has(n) ? e.parentNode && e.parentNode.nodeType === e.DOCUMENT_NODE ? !1 : e.parentNode ? YY(e.parentNode, t) : !0 : !0;
}
function CA(e) {
  return !!e.changedTouches;
}
function xAe(e = window) {
  "NodeList" in e && !e.NodeList.prototype.forEach && (e.NodeList.prototype.forEach = Array.prototype.forEach), "DOMTokenList" in e && !e.DOMTokenList.prototype.forEach && (e.DOMTokenList.prototype.forEach = Array.prototype.forEach), Node.prototype.contains || (Node.prototype.contains = (...t) => {
    let n = t[0];
    if (!(0 in t))
      throw new TypeError("1 argument is required");
    do
      if (this === n)
        return !0;
    while (n = n && n.parentNode);
    return !1;
  });
}
function XY(e, t) {
  return !!(e.nodeName === "IFRAME" && t.getMeta(e));
}
function QY(e, t) {
  return !!(e.nodeName === "LINK" && e.nodeType === e.ELEMENT_NODE && e.getAttribute && e.getAttribute("rel") === "stylesheet" && t.getMeta(e));
}
function TA(e) {
  return !!Bl([e, "optionalAccess", (t) => t.shadowRoot]);
}
class EAe {
  constructor() {
    this.id = 1, this.styleIDMap = /* @__PURE__ */ new WeakMap(), this.idStyleMap = /* @__PURE__ */ new Map();
  }
  getId(t) {
    return B2e(this.styleIDMap.get(t), () => -1);
  }
  has(t) {
    return this.styleIDMap.has(t);
  }
  add(t, n) {
    if (this.has(t))
      return this.getId(t);
    let r;
    return n === void 0 ? r = this.id++ : r = n, this.styleIDMap.set(t, r), this.idStyleMap.set(r, t), r;
  }
  getStyle(t) {
    return this.idStyleMap.get(t) || null;
  }
  reset() {
    this.styleIDMap = /* @__PURE__ */ new WeakMap(), this.idStyleMap = /* @__PURE__ */ new Map(), this.id = 1;
  }
  generateId() {
    return this.id++;
  }
}
function JY(e) {
  let t = null;
  return Bl([e, "access", (n) => n.getRootNode, "optionalCall", (n) => n(), "optionalAccess", (n) => n.nodeType]) === Node.DOCUMENT_FRAGMENT_NODE && e.getRootNode().host && (t = e.getRootNode().host), t;
}
function CAe(e) {
  let t = e, n;
  for (; n = JY(t); )
    t = n;
  return t;
}
function TAe(e) {
  const t = e.ownerDocument;
  if (!t)
    return !1;
  const n = CAe(e);
  return t.contains(n);
}
function ZY(e) {
  const t = e.ownerDocument;
  return t ? t.contains(e) || TAe(e) : !1;
}
const $j = {};
function J6(e) {
  const t = $j[e];
  if (t)
    return t;
  const n = window.document;
  let r = window[e];
  if (n && typeof n.createElement == "function")
    try {
      const i = n.createElement("iframe");
      i.hidden = !0, n.head.appendChild(i);
      const o = i.contentWindow;
      o && o[e] && (r = o[e]), n.head.removeChild(i);
    } catch {
    }
  return $j[e] = r.bind(window);
}
function IAe(...e) {
  return J6("requestAnimationFrame")(...e);
}
function EE(...e) {
  return J6("setTimeout")(...e);
}
function $Ae(...e) {
  return J6("clearTimeout")(...e);
}
var fn = /* @__PURE__ */ ((e) => (e[e.DomContentLoaded = 0] = "DomContentLoaded", e[e.Load = 1] = "Load", e[e.FullSnapshot = 2] = "FullSnapshot", e[e.IncrementalSnapshot = 3] = "IncrementalSnapshot", e[e.Meta = 4] = "Meta", e[e.Custom = 5] = "Custom", e[e.Plugin = 6] = "Plugin", e))(fn || {}), hn = /* @__PURE__ */ ((e) => (e[e.Mutation = 0] = "Mutation", e[e.MouseMove = 1] = "MouseMove", e[e.MouseInteraction = 2] = "MouseInteraction", e[e.Scroll = 3] = "Scroll", e[e.ViewportResize = 4] = "ViewportResize", e[e.Input = 5] = "Input", e[e.TouchMove = 6] = "TouchMove", e[e.MediaInteraction = 7] = "MediaInteraction", e[e.StyleSheetRule = 8] = "StyleSheetRule", e[e.CanvasMutation = 9] = "CanvasMutation", e[e.Font = 10] = "Font", e[e.Log = 11] = "Log", e[e.Drag = 12] = "Drag", e[e.StyleDeclaration = 13] = "StyleDeclaration", e[e.Selection = 14] = "Selection", e[e.AdoptedStyleSheet = 15] = "AdoptedStyleSheet", e[e.CustomElement = 16] = "CustomElement", e))(hn || {}), Eo = /* @__PURE__ */ ((e) => (e[e.MouseUp = 0] = "MouseUp", e[e.MouseDown = 1] = "MouseDown", e[e.Click = 2] = "Click", e[e.ContextMenu = 3] = "ContextMenu", e[e.DblClick = 4] = "DblClick", e[e.Focus = 5] = "Focus", e[e.Blur = 6] = "Blur", e[e.TouchStart = 7] = "TouchStart", e[e.TouchMove_Departed = 8] = "TouchMove_Departed", e[e.TouchEnd = 9] = "TouchEnd", e[e.TouchCancel = 10] = "TouchCancel", e))(Eo || {}), Nc = /* @__PURE__ */ ((e) => (e[e.Mouse = 0] = "Mouse", e[e.Pen = 1] = "Pen", e[e.Touch = 2] = "Touch", e))(Nc || {});
function AAe(e) {
  let t, n = e[0], r = 1;
  for (; r < e.length; ) {
    const i = e[r], o = e[r + 1];
    if (r += 2, (i === "optionalAccess" || i === "optionalCall") && n == null)
      return;
    i === "access" || i === "optionalAccess" ? (t = n, n = o(n)) : (i === "call" || i === "optionalCall") && (n = o((...a) => n.call(t, ...a)), t = void 0);
  }
  return n;
}
function Aj(e) {
  return "__ln" in e;
}
class RAe {
  constructor() {
    this.length = 0, this.head = null, this.tail = null;
  }
  get(t) {
    if (t >= this.length)
      throw new Error("Position outside of list range");
    let n = this.head;
    for (let r = 0; r < t; r++)
      n = AAe([n, "optionalAccess", (i) => i.next]) || null;
    return n;
  }
  addNode(t) {
    const n = {
      value: t,
      previous: null,
      next: null
    };
    if (t.__ln = n, t.previousSibling && Aj(t.previousSibling)) {
      const r = t.previousSibling.__ln.next;
      n.next = r, n.previous = t.previousSibling.__ln, t.previousSibling.__ln.next = n, r && (r.previous = n);
    } else if (t.nextSibling && Aj(t.nextSibling) && t.nextSibling.__ln.previous) {
      const r = t.nextSibling.__ln.previous;
      n.previous = r, n.next = t.nextSibling.__ln, t.nextSibling.__ln.previous = n, r && (r.next = n);
    } else
      this.head && (this.head.previous = n), n.next = this.head, this.head = n;
    n.next === null && (this.tail = n), this.length++;
  }
  removeNode(t) {
    const n = t.__ln;
    this.head && (n.previous ? (n.previous.next = n.next, n.next ? n.next.previous = n.previous : this.tail = n.previous) : (this.head = n.next, this.head ? this.head.previous = null : this.tail = null), t.__ln && delete t.__ln, this.length--);
  }
}
const Rj = (e, t) => `${e}@${t}`;
class PAe {
  constructor() {
    this.frozen = !1, this.locked = !1, this.texts = [], this.attributes = [], this.attributeMap = /* @__PURE__ */ new WeakMap(), this.removes = [], this.mapRemoves = [], this.movedMap = {}, this.addedSet = /* @__PURE__ */ new Set(), this.movedSet = /* @__PURE__ */ new Set(), this.droppedSet = /* @__PURE__ */ new Set(), this.processMutations = (t) => {
      t.forEach(this.processMutation), this.emit();
    }, this.emit = () => {
      if (this.frozen || this.locked)
        return;
      const t = [], n = /* @__PURE__ */ new Set(), r = new RAe(), i = (c) => {
        let l = c, u = vv;
        for (; u === vv; )
          l = l && l.nextSibling, u = l && this.mirror.getId(l);
        return u;
      }, o = (c) => {
        if (!c.parentNode || !ZY(c))
          return;
        const l = N0(c.parentNode) ? this.mirror.getId(JY(c)) : this.mirror.getId(c.parentNode), u = i(c);
        if (l === -1 || u === -1)
          return r.addNode(c);
        const d = Kh(c, {
          doc: this.doc,
          mirror: this.mirror,
          blockClass: this.blockClass,
          blockSelector: this.blockSelector,
          maskAllText: this.maskAllText,
          unblockSelector: this.unblockSelector,
          maskTextClass: this.maskTextClass,
          unmaskTextClass: this.unmaskTextClass,
          maskTextSelector: this.maskTextSelector,
          unmaskTextSelector: this.unmaskTextSelector,
          skipChild: !0,
          newlyAddedElement: !0,
          inlineStylesheet: this.inlineStylesheet,
          maskInputOptions: this.maskInputOptions,
          maskAttributeFn: this.maskAttributeFn,
          maskTextFn: this.maskTextFn,
          maskInputFn: this.maskInputFn,
          slimDOMOptions: this.slimDOMOptions,
          dataURLOptions: this.dataURLOptions,
          recordCanvas: this.recordCanvas,
          inlineImages: this.inlineImages,
          onSerialize: (f) => {
            XY(f, this.mirror) && this.iframeManager.addIframe(f), QY(f, this.mirror) && this.stylesheetManager.trackLinkElement(f), TA(c) && this.shadowDomManager.addShadowRoot(c.shadowRoot, this.doc);
          },
          onIframeLoad: (f, h) => {
            this.iframeManager.attachIframe(f, h), this.shadowDomManager.observeAttachShadow(f);
          },
          onStylesheetLoad: (f, h) => {
            this.stylesheetManager.attachLinkElement(f, h);
          }
        });
        d && (t.push({
          parentId: l,
          nextId: u,
          node: d
        }), n.add(d.id));
      };
      for (; this.mapRemoves.length; )
        this.mirror.removeNodeFromMap(this.mapRemoves.shift());
      for (const c of this.movedSet)
        Pj(this.removes, c, this.mirror) && !this.movedSet.has(c.parentNode) || o(c);
      for (const c of this.addedSet)
        !Oj(this.droppedSet, c) && !Pj(this.removes, c, this.mirror) || Oj(this.movedSet, c) ? o(c) : this.droppedSet.add(c);
      let a = null;
      for (; r.length; ) {
        let c = null;
        if (a) {
          const l = this.mirror.getId(a.value.parentNode), u = i(a.value);
          l !== -1 && u !== -1 && (c = a);
        }
        if (!c) {
          let l = r.tail;
          for (; l; ) {
            const u = l;
            if (l = l.previous, u) {
              const d = this.mirror.getId(u.value.parentNode);
              if (i(u.value) === -1)
                continue;
              if (d !== -1) {
                c = u;
                break;
              } else {
                const h = u.value;
                if (h.parentNode && h.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                  const p = h.parentNode.host;
                  if (this.mirror.getId(p) !== -1) {
                    c = u;
                    break;
                  }
                }
              }
            }
          }
        }
        if (!c) {
          for (; r.head; )
            r.removeNode(r.head.value);
          break;
        }
        a = c.previous, r.removeNode(c.value), o(c.value);
      }
      const s = {
        texts: this.texts.map((c) => ({
          id: this.mirror.getId(c.node),
          value: c.value
        })).filter((c) => !n.has(c.id)).filter((c) => this.mirror.has(c.id)),
        attributes: this.attributes.map((c) => {
          const { attributes: l } = c;
          if (typeof l.style == "string") {
            const u = JSON.stringify(c.styleDiff), d = JSON.stringify(c._unchangedStyles);
            u.length < l.style.length && (u + d).split("var(").length === l.style.split("var(").length && (l.style = c.styleDiff);
          }
          return {
            id: this.mirror.getId(c.node),
            attributes: l
          };
        }).filter((c) => !n.has(c.id)).filter((c) => this.mirror.has(c.id)),
        removes: this.removes,
        adds: t
      };
      !s.texts.length && !s.attributes.length && !s.removes.length && !s.adds.length || (this.texts = [], this.attributes = [], this.attributeMap = /* @__PURE__ */ new WeakMap(), this.removes = [], this.addedSet = /* @__PURE__ */ new Set(), this.movedSet = /* @__PURE__ */ new Set(), this.droppedSet = /* @__PURE__ */ new Set(), this.movedMap = {}, this.mutationCb(s));
    }, this.processMutation = (t) => {
      if (!tT(t.target, this.mirror))
        switch (t.type) {
          case "characterData": {
            const n = t.target.textContent;
            !fs(t.target, this.blockClass, this.blockSelector, this.unblockSelector, !1) && n !== t.oldValue && this.texts.push({
              value: Vg(t.target, this.maskTextClass, this.maskTextSelector, this.unmaskTextClass, this.unmaskTextSelector, this.maskAllText) && n ? this.maskTextFn ? this.maskTextFn(n, KY(t.target)) : n.replace(/[\S]/g, "*") : n,
              node: t.target
            });
            break;
          }
          case "attributes": {
            const n = t.target;
            let r = t.attributeName, i = t.target.getAttribute(r);
            if (r === "value") {
              const a = K6(n), s = n.tagName;
              i = _S(n, s, a);
              const c = xE({
                maskInputOptions: this.maskInputOptions,
                tagName: s,
                type: a
              }), l = Vg(t.target, this.maskTextClass, this.maskTextSelector, this.unmaskTextClass, this.unmaskTextSelector, c);
              i = mv({
                isMasked: l,
                element: n,
                value: i,
                maskInputFn: this.maskInputFn
              });
            }
            if (fs(t.target, this.blockClass, this.blockSelector, this.unblockSelector, !1) || i === t.oldValue)
              return;
            let o = this.attributeMap.get(t.target);
            if (n.tagName === "IFRAME" && r === "src" && !this.keepIframeSrcFn(i))
              if (!n.contentDocument)
                r = "rr_src";
              else
                return;
            if (o || (o = {
              node: t.target,
              attributes: {},
              styleDiff: {},
              _unchangedStyles: {}
            }, this.attributes.push(o), this.attributeMap.set(t.target, o)), r === "type" && n.tagName === "INPUT" && (t.oldValue || "").toLowerCase() === "password" && n.setAttribute("data-rr-is-password", "true"), !HY(n.tagName, r) && (o.attributes[r] = zY(this.doc, Fg(n.tagName), Fg(r), i, n, this.maskAttributeFn), r === "style")) {
              if (!this.unattachedDoc)
                try {
                  this.unattachedDoc = document.implementation.createHTMLDocument();
                } catch {
                  this.unattachedDoc = this.doc;
                }
              const a = this.unattachedDoc.createElement("span");
              t.oldValue && a.setAttribute("style", t.oldValue);
              for (const s of Array.from(n.style)) {
                const c = n.style.getPropertyValue(s), l = n.style.getPropertyPriority(s);
                c !== a.style.getPropertyValue(s) || l !== a.style.getPropertyPriority(s) ? l === "" ? o.styleDiff[s] = c : o.styleDiff[s] = [c, l] : o._unchangedStyles[s] = [c, l];
              }
              for (const s of Array.from(a.style))
                n.style.getPropertyValue(s) === "" && (o.styleDiff[s] = !1);
            }
            break;
          }
          case "childList": {
            if (fs(t.target, this.blockClass, this.blockSelector, this.unblockSelector, !0))
              return;
            t.addedNodes.forEach((n) => this.genAdds(n, t.target)), t.removedNodes.forEach((n) => {
              const r = this.mirror.getId(n), i = N0(t.target) ? this.mirror.getId(t.target.host) : this.mirror.getId(t.target);
              fs(t.target, this.blockClass, this.blockSelector, this.unblockSelector, !1) || tT(n, this.mirror) || !wAe(n, this.mirror) || (this.addedSet.has(n) ? (IA(this.addedSet, n), this.droppedSet.add(n)) : this.addedSet.has(t.target) && r === -1 || YY(t.target, this.mirror) || (this.movedSet.has(n) && this.movedMap[Rj(r, i)] ? IA(this.movedSet, n) : this.removes.push({
                parentId: i,
                id: r,
                isShadow: N0(t.target) && D0(t.target) ? !0 : void 0
              })), this.mapRemoves.push(n));
            });
            break;
          }
        }
    }, this.genAdds = (t, n) => {
      if (!this.processedNodeManager.inOtherBuffer(t, this) && !(this.addedSet.has(t) || this.movedSet.has(t))) {
        if (this.mirror.hasNode(t)) {
          if (tT(t, this.mirror))
            return;
          this.movedSet.add(t);
          let r = null;
          n && this.mirror.hasNode(n) && (r = this.mirror.getId(n)), r && r !== -1 && (this.movedMap[Rj(this.mirror.getId(t), r)] = !0);
        } else
          this.addedSet.add(t), this.droppedSet.delete(t);
        fs(t, this.blockClass, this.blockSelector, this.unblockSelector, !1) || (t.childNodes.forEach((r) => this.genAdds(r)), TA(t) && t.shadowRoot.childNodes.forEach((r) => {
          this.processedNodeManager.add(r, this), this.genAdds(r, t);
        }));
      }
    };
  }
  init(t) {
    [
      "mutationCb",
      "blockClass",
      "blockSelector",
      "unblockSelector",
      "maskAllText",
      "maskTextClass",
      "unmaskTextClass",
      "maskTextSelector",
      "unmaskTextSelector",
      "inlineStylesheet",
      "maskInputOptions",
      "maskAttributeFn",
      "maskTextFn",
      "maskInputFn",
      "keepIframeSrcFn",
      "recordCanvas",
      "inlineImages",
      "slimDOMOptions",
      "dataURLOptions",
      "doc",
      "mirror",
      "iframeManager",
      "stylesheetManager",
      "shadowDomManager",
      "canvasManager",
      "processedNodeManager"
    ].forEach((n) => {
      this[n] = t[n];
    });
  }
  freeze() {
    this.frozen = !0, this.canvasManager.freeze();
  }
  unfreeze() {
    this.frozen = !1, this.canvasManager.unfreeze(), this.emit();
  }
  isFrozen() {
    return this.frozen;
  }
  lock() {
    this.locked = !0, this.canvasManager.lock();
  }
  unlock() {
    this.locked = !1, this.canvasManager.unlock(), this.emit();
  }
  reset() {
    this.shadowDomManager.reset(), this.canvasManager.reset();
  }
}
function IA(e, t) {
  e.delete(t), t.childNodes.forEach((n) => IA(e, n));
}
function Pj(e, t, n) {
  return e.length === 0 ? !1 : eX(e, t, n);
}
function eX(e, t, n) {
  const { parentNode: r } = t;
  if (!r)
    return !1;
  const i = n.getId(r);
  return e.some((o) => o.id === i) ? !0 : eX(e, r, n);
}
function Oj(e, t) {
  return e.size === 0 ? !1 : tX(e, t);
}
function tX(e, t) {
  const { parentNode: n } = t;
  return n ? e.has(n) ? !0 : tX(e, n) : !1;
}
let j0;
function OAe(e) {
  j0 = e;
}
function MAe() {
  j0 = void 0;
}
const $n = (e) => j0 ? (...n) => {
  try {
    return e(...n);
  } catch (r) {
    if (j0 && j0(r) === !0)
      return () => {
      };
    throw r;
  }
} : e;
function Js(e) {
  let t, n = e[0], r = 1;
  for (; r < e.length; ) {
    const i = e[r], o = e[r + 1];
    if (r += 2, (i === "optionalAccess" || i === "optionalCall") && n == null)
      return;
    i === "access" || i === "optionalAccess" ? (t = n, n = o(n)) : (i === "call" || i === "optionalCall") && (n = o((...a) => n.call(t, ...a)), t = void 0);
  }
  return n;
}
const Yh = [];
function Cy(e) {
  try {
    if ("composedPath" in e) {
      const t = e.composedPath();
      if (t.length)
        return t[0];
    } else if ("path" in e && e.path.length)
      return e.path[0];
  } catch {
  }
  return e && e.target;
}
function nX(e, t) {
  const n = new PAe();
  Yh.push(n), n.init(e);
  let r = window.MutationObserver || window.__rrMutationObserver;
  const i = Js([window, "optionalAccess", (a) => a.Zone, "optionalAccess", (a) => a.__symbol__, "optionalCall", (a) => a("MutationObserver")]);
  i && window[i] && (r = window[i]);
  const o = new r($n((a) => {
    e.onMutation && e.onMutation(a) === !1 || n.processMutations.bind(n)(a);
  }));
  return o.observe(t, {
    attributes: !0,
    attributeOldValue: !0,
    characterData: !0,
    characterDataOldValue: !0,
    childList: !0,
    subtree: !0
  }), o;
}
function kAe({ mousemoveCb: e, sampling: t, doc: n, mirror: r }) {
  if (t.mousemove === !1)
    return () => {
    };
  const i = typeof t.mousemove == "number" ? t.mousemove : 50, o = typeof t.mousemoveCallback == "number" ? t.mousemoveCallback : 500;
  let a = [], s;
  const c = yv($n((d) => {
    const f = Date.now() - s;
    e(a.map((h) => (h.timeOffset -= f, h)), d), a = [], s = null;
  }), o), l = $n(yv($n((d) => {
    const f = Cy(d), { clientX: h, clientY: p } = CA(d) ? d.changedTouches[0] : d;
    s || (s = wS()), a.push({
      x: h,
      y: p,
      id: r.getId(f),
      timeOffset: wS() - s
    }), c(typeof DragEvent < "u" && d instanceof DragEvent ? hn.Drag : d instanceof MouseEvent ? hn.MouseMove : hn.TouchMove);
  }), i, {
    trailing: !1
  })), u = [
    $o("mousemove", l, n),
    $o("touchmove", l, n),
    $o("drag", l, n)
  ];
  return $n(() => {
    u.forEach((d) => d());
  });
}
function NAe({ mouseInteractionCb: e, doc: t, mirror: n, blockClass: r, blockSelector: i, unblockSelector: o, sampling: a }) {
  if (a.mouseInteraction === !1)
    return () => {
    };
  const s = a.mouseInteraction === !0 || a.mouseInteraction === void 0 ? {} : a.mouseInteraction, c = [];
  let l = null;
  const u = (d) => (f) => {
    const h = Cy(f);
    if (fs(h, r, i, o, !0))
      return;
    let p = null, g = d;
    if ("pointerType" in f) {
      switch (f.pointerType) {
        case "mouse":
          p = Nc.Mouse;
          break;
        case "touch":
          p = Nc.Touch;
          break;
        case "pen":
          p = Nc.Pen;
          break;
      }
      p === Nc.Touch ? Eo[d] === Eo.MouseDown ? g = "TouchStart" : Eo[d] === Eo.MouseUp && (g = "TouchEnd") : Nc.Pen;
    } else
      CA(f) && (p = Nc.Touch);
    p !== null ? (l = p, (g.startsWith("Touch") && p === Nc.Touch || g.startsWith("Mouse") && p === Nc.Mouse) && (p = null)) : Eo[d] === Eo.Click && (p = l, l = null);
    const m = CA(f) ? f.changedTouches[0] : f;
    if (!m)
      return;
    const v = n.getId(h), { clientX: y, clientY: _ } = m;
    $n(e)({
      type: Eo[g],
      id: v,
      x: y,
      y: _,
      ...p !== null && { pointerType: p }
    });
  };
  return Object.keys(Eo).filter((d) => Number.isNaN(Number(d)) && !d.endsWith("_Departed") && s[d] !== !1).forEach((d) => {
    let f = Fg(d);
    const h = u(d);
    if (window.PointerEvent)
      switch (Eo[d]) {
        case Eo.MouseDown:
        case Eo.MouseUp:
          f = f.replace("mouse", "pointer");
          break;
        case Eo.TouchStart:
        case Eo.TouchEnd:
          return;
      }
    c.push($o(f, h, t));
  }), $n(() => {
    c.forEach((d) => d());
  });
}
function rX({ scrollCb: e, doc: t, mirror: n, blockClass: r, blockSelector: i, unblockSelector: o, sampling: a }) {
  const s = $n(yv($n((c) => {
    const l = Cy(c);
    if (!l || fs(l, r, i, o, !0))
      return;
    const u = n.getId(l);
    if (l === t && t.defaultView) {
      const d = WY(t.defaultView);
      e({
        id: u,
        x: d.left,
        y: d.top
      });
    } else
      e({
        id: u,
        x: l.scrollLeft,
        y: l.scrollTop
      });
  }), a.scroll || 100));
  return $o("scroll", s, t);
}
function DAe({ viewportResizeCb: e }, { win: t }) {
  let n = -1, r = -1;
  const i = $n(yv($n(() => {
    const o = qY(), a = GY();
    (n !== o || r !== a) && (e({
      width: Number(a),
      height: Number(o)
    }), n = o, r = a);
  }), 200));
  return $o("resize", i, t);
}
const jAe = ["INPUT", "TEXTAREA", "SELECT"], Mj = /* @__PURE__ */ new WeakMap();
function LAe({ inputCb: e, doc: t, mirror: n, blockClass: r, blockSelector: i, unblockSelector: o, ignoreClass: a, ignoreSelector: s, maskInputOptions: c, maskInputFn: l, sampling: u, userTriggeredOnInput: d, maskTextClass: f, unmaskTextClass: h, maskTextSelector: p, unmaskTextSelector: g }) {
  function m(x) {
    let T = Cy(x);
    const E = x.isTrusted, R = T && EA(T.tagName);
    if (R === "OPTION" && (T = T.parentElement), !T || !R || jAe.indexOf(R) < 0 || fs(T, r, i, o, !0))
      return;
    const I = T;
    if (I.classList.contains(a) || s && I.matches(s))
      return;
    const O = K6(T);
    let P = _S(I, R, O), k = !1;
    const L = xE({
      maskInputOptions: c,
      tagName: R,
      type: O
    }), N = Vg(T, f, p, h, g, L);
    (O === "radio" || O === "checkbox") && (k = T.checked), P = mv({
      isMasked: N,
      element: T,
      value: P,
      maskInputFn: l
    }), v(T, d ? { text: P, isChecked: k, userTriggered: E } : { text: P, isChecked: k });
    const D = T.name;
    O === "radio" && D && k && t.querySelectorAll(`input[type="radio"][name="${D}"]`).forEach((z) => {
      if (z !== T) {
        const V = mv({
          isMasked: N,
          element: z,
          value: _S(z, R, O),
          maskInputFn: l
        });
        v(z, d ? { text: V, isChecked: !k, userTriggered: !1 } : { text: V, isChecked: !k });
      }
    });
  }
  function v(x, T) {
    const E = Mj.get(x);
    if (!E || E.text !== T.text || E.isChecked !== T.isChecked) {
      Mj.set(x, T);
      const R = n.getId(x);
      $n(e)({
        ...T,
        id: R
      });
    }
  }
  const _ = (u.input === "last" ? ["change"] : ["input", "change"]).map((x) => $o(x, $n(m), t)), b = t.defaultView;
  if (!b)
    return () => {
      _.forEach((x) => x());
    };
  const w = b.Object.getOwnPropertyDescriptor(b.HTMLInputElement.prototype, "value"), C = [
    [b.HTMLInputElement.prototype, "value"],
    [b.HTMLInputElement.prototype, "checked"],
    [b.HTMLSelectElement.prototype, "value"],
    [b.HTMLTextAreaElement.prototype, "value"],
    [b.HTMLSelectElement.prototype, "selectedIndex"],
    [b.HTMLOptionElement.prototype, "selected"]
  ];
  return w && w.set && _.push(...C.map((x) => UY(x[0], x[1], {
    set() {
      $n(m)({
        target: this,
        isTrusted: !1
      });
    }
  }, !1, b))), $n(() => {
    _.forEach((x) => x());
  });
}
function xS(e) {
  const t = [];
  function n(r, i) {
    if (n1("CSSGroupingRule") && r.parentRule instanceof CSSGroupingRule || n1("CSSMediaRule") && r.parentRule instanceof CSSMediaRule || n1("CSSSupportsRule") && r.parentRule instanceof CSSSupportsRule || n1("CSSConditionRule") && r.parentRule instanceof CSSConditionRule) {
      const a = Array.from(r.parentRule.cssRules).indexOf(r);
      i.unshift(a);
    } else if (r.parentStyleSheet) {
      const a = Array.from(r.parentStyleSheet.cssRules).indexOf(r);
      i.unshift(a);
    }
    return i;
  }
  return n(e, t);
}
function zl(e, t, n) {
  let r, i;
  return e ? (e.ownerNode ? r = t.getId(e.ownerNode) : i = n.getId(e), {
    styleId: i,
    id: r
  }) : {};
}
function FAe({ styleSheetRuleCb: e, mirror: t, stylesheetManager: n }, { win: r }) {
  if (!r.CSSStyleSheet || !r.CSSStyleSheet.prototype)
    return () => {
    };
  const i = r.CSSStyleSheet.prototype.insertRule;
  r.CSSStyleSheet.prototype.insertRule = new Proxy(i, {
    apply: $n((u, d, f) => {
      const [h, p] = f, { id: g, styleId: m } = zl(d, t, n.styleMirror);
      return (g && g !== -1 || m && m !== -1) && e({
        id: g,
        styleId: m,
        adds: [{ rule: h, index: p }]
      }), u.apply(d, f);
    })
  });
  const o = r.CSSStyleSheet.prototype.deleteRule;
  r.CSSStyleSheet.prototype.deleteRule = new Proxy(o, {
    apply: $n((u, d, f) => {
      const [h] = f, { id: p, styleId: g } = zl(d, t, n.styleMirror);
      return (p && p !== -1 || g && g !== -1) && e({
        id: p,
        styleId: g,
        removes: [{ index: h }]
      }), u.apply(d, f);
    })
  });
  let a;
  r.CSSStyleSheet.prototype.replace && (a = r.CSSStyleSheet.prototype.replace, r.CSSStyleSheet.prototype.replace = new Proxy(a, {
    apply: $n((u, d, f) => {
      const [h] = f, { id: p, styleId: g } = zl(d, t, n.styleMirror);
      return (p && p !== -1 || g && g !== -1) && e({
        id: p,
        styleId: g,
        replace: h
      }), u.apply(d, f);
    })
  }));
  let s;
  r.CSSStyleSheet.prototype.replaceSync && (s = r.CSSStyleSheet.prototype.replaceSync, r.CSSStyleSheet.prototype.replaceSync = new Proxy(s, {
    apply: $n((u, d, f) => {
      const [h] = f, { id: p, styleId: g } = zl(d, t, n.styleMirror);
      return (p && p !== -1 || g && g !== -1) && e({
        id: p,
        styleId: g,
        replaceSync: h
      }), u.apply(d, f);
    })
  }));
  const c = {};
  r1("CSSGroupingRule") ? c.CSSGroupingRule = r.CSSGroupingRule : (r1("CSSMediaRule") && (c.CSSMediaRule = r.CSSMediaRule), r1("CSSConditionRule") && (c.CSSConditionRule = r.CSSConditionRule), r1("CSSSupportsRule") && (c.CSSSupportsRule = r.CSSSupportsRule));
  const l = {};
  return Object.entries(c).forEach(([u, d]) => {
    l[u] = {
      insertRule: d.prototype.insertRule,
      deleteRule: d.prototype.deleteRule
    }, d.prototype.insertRule = new Proxy(l[u].insertRule, {
      apply: $n((f, h, p) => {
        const [g, m] = p, { id: v, styleId: y } = zl(h.parentStyleSheet, t, n.styleMirror);
        return (v && v !== -1 || y && y !== -1) && e({
          id: v,
          styleId: y,
          adds: [
            {
              rule: g,
              index: [
                ...xS(h),
                m || 0
              ]
            }
          ]
        }), f.apply(h, p);
      })
    }), d.prototype.deleteRule = new Proxy(l[u].deleteRule, {
      apply: $n((f, h, p) => {
        const [g] = p, { id: m, styleId: v } = zl(h.parentStyleSheet, t, n.styleMirror);
        return (m && m !== -1 || v && v !== -1) && e({
          id: m,
          styleId: v,
          removes: [
            { index: [...xS(h), g] }
          ]
        }), f.apply(h, p);
      })
    });
  }), $n(() => {
    r.CSSStyleSheet.prototype.insertRule = i, r.CSSStyleSheet.prototype.deleteRule = o, a && (r.CSSStyleSheet.prototype.replace = a), s && (r.CSSStyleSheet.prototype.replaceSync = s), Object.entries(c).forEach(([u, d]) => {
      d.prototype.insertRule = l[u].insertRule, d.prototype.deleteRule = l[u].deleteRule;
    });
  });
}
function iX({ mirror: e, stylesheetManager: t }, n) {
  let r = null;
  n.nodeName === "#document" ? r = e.getId(n) : r = e.getId(n.host);
  const i = n.nodeName === "#document" ? Js([n, "access", (a) => a.defaultView, "optionalAccess", (a) => a.Document]) : Js([n, "access", (a) => a.ownerDocument, "optionalAccess", (a) => a.defaultView, "optionalAccess", (a) => a.ShadowRoot]), o = Js([i, "optionalAccess", (a) => a.prototype]) ? Object.getOwnPropertyDescriptor(Js([i, "optionalAccess", (a) => a.prototype]), "adoptedStyleSheets") : void 0;
  return r === null || r === -1 || !i || !o ? () => {
  } : (Object.defineProperty(n, "adoptedStyleSheets", {
    configurable: o.configurable,
    enumerable: o.enumerable,
    get() {
      return Js([o, "access", (a) => a.get, "optionalAccess", (a) => a.call, "call", (a) => a(this)]);
    },
    set(a) {
      const s = Js([o, "access", (c) => c.set, "optionalAccess", (c) => c.call, "call", (c) => c(this, a)]);
      if (r !== null && r !== -1)
        try {
          t.adoptStyleSheets(a, r);
        } catch {
        }
      return s;
    }
  }), $n(() => {
    Object.defineProperty(n, "adoptedStyleSheets", {
      configurable: o.configurable,
      enumerable: o.enumerable,
      get: o.get,
      set: o.set
    });
  }));
}
function VAe({ styleDeclarationCb: e, mirror: t, ignoreCSSAttributes: n, stylesheetManager: r }, { win: i }) {
  const o = i.CSSStyleDeclaration.prototype.setProperty;
  i.CSSStyleDeclaration.prototype.setProperty = new Proxy(o, {
    apply: $n((s, c, l) => {
      const [u, d, f] = l;
      if (n.has(u))
        return o.apply(c, [u, d, f]);
      const { id: h, styleId: p } = zl(Js([c, "access", (g) => g.parentRule, "optionalAccess", (g) => g.parentStyleSheet]), t, r.styleMirror);
      return (h && h !== -1 || p && p !== -1) && e({
        id: h,
        styleId: p,
        set: {
          property: u,
          value: d,
          priority: f
        },
        index: xS(c.parentRule)
      }), s.apply(c, l);
    })
  });
  const a = i.CSSStyleDeclaration.prototype.removeProperty;
  return i.CSSStyleDeclaration.prototype.removeProperty = new Proxy(a, {
    apply: $n((s, c, l) => {
      const [u] = l;
      if (n.has(u))
        return a.apply(c, [u]);
      const { id: d, styleId: f } = zl(Js([c, "access", (h) => h.parentRule, "optionalAccess", (h) => h.parentStyleSheet]), t, r.styleMirror);
      return (d && d !== -1 || f && f !== -1) && e({
        id: d,
        styleId: f,
        remove: {
          property: u
        },
        index: xS(c.parentRule)
      }), s.apply(c, l);
    })
  }), $n(() => {
    i.CSSStyleDeclaration.prototype.setProperty = o, i.CSSStyleDeclaration.prototype.removeProperty = a;
  });
}
function BAe({ mediaInteractionCb: e, blockClass: t, blockSelector: n, unblockSelector: r, mirror: i, sampling: o, doc: a }) {
  const s = $n((l) => yv($n((u) => {
    const d = Cy(u);
    if (!d || fs(d, t, n, r, !0))
      return;
    const { currentTime: f, volume: h, muted: p, playbackRate: g } = d;
    e({
      type: l,
      id: i.getId(d),
      currentTime: f,
      volume: h,
      muted: p,
      playbackRate: g
    });
  }), o.media || 500)), c = [
    $o("play", s(0), a),
    $o("pause", s(1), a),
    $o("seeked", s(2), a),
    $o("volumechange", s(3), a),
    $o("ratechange", s(4), a)
  ];
  return $n(() => {
    c.forEach((l) => l());
  });
}
function zAe({ fontCb: e, doc: t }) {
  const n = t.defaultView;
  if (!n)
    return () => {
    };
  const r = [], i = /* @__PURE__ */ new WeakMap(), o = n.FontFace;
  n.FontFace = function(c, l, u) {
    const d = new o(c, l, u);
    return i.set(d, {
      family: c,
      buffer: typeof l != "string",
      descriptors: u,
      fontSource: typeof l == "string" ? l : JSON.stringify(Array.from(new Uint8Array(l)))
    }), d;
  };
  const a = Q6(t.fonts, "add", function(s) {
    return function(c) {
      return EE($n(() => {
        const l = i.get(c);
        l && (e(l), i.delete(c));
      }), 0), s.apply(this, [c]);
    };
  });
  return r.push(() => {
    n.FontFace = o;
  }), r.push(a), $n(() => {
    r.forEach((s) => s());
  });
}
function HAe(e) {
  const { doc: t, mirror: n, blockClass: r, blockSelector: i, unblockSelector: o, selectionCb: a } = e;
  let s = !0;
  const c = $n(() => {
    const l = t.getSelection();
    if (!l || s && Js([l, "optionalAccess", (f) => f.isCollapsed]))
      return;
    s = l.isCollapsed || !1;
    const u = [], d = l.rangeCount || 0;
    for (let f = 0; f < d; f++) {
      const h = l.getRangeAt(f), { startContainer: p, startOffset: g, endContainer: m, endOffset: v } = h;
      fs(p, r, i, o, !0) || fs(m, r, i, o, !0) || u.push({
        start: n.getId(p),
        startOffset: g,
        end: n.getId(m),
        endOffset: v
      });
    }
    a({ ranges: u });
  });
  return c(), $o("selectionchange", c);
}
function UAe({ doc: e, customElementCb: t }) {
  const n = e.defaultView;
  return !n || !n.customElements ? () => {
  } : Q6(n.customElements, "define", function(i) {
    return function(o, a, s) {
      try {
        t({
          define: {
            name: o
          }
        });
      } catch {
      }
      return i.apply(this, [o, a, s]);
    };
  });
}
function WAe(e, t = {}) {
  const n = e.doc.defaultView;
  if (!n)
    return () => {
    };
  const r = nX(e, e.doc), i = kAe(e), o = NAe(e), a = rX(e), s = DAe(e, {
    win: n
  }), c = LAe(e), l = BAe(e), u = FAe(e, { win: n }), d = iX(e, e.doc), f = VAe(e, {
    win: n
  }), h = e.collectFonts ? zAe(e) : () => {
  }, p = HAe(e), g = UAe(e), m = [];
  for (const v of e.plugins)
    m.push(v.observer(v.callback, n, v.options));
  return $n(() => {
    Yh.forEach((v) => v.reset()), r.disconnect(), i(), o(), a(), s(), c(), l(), u(), d(), f(), h(), p(), g(), m.forEach((v) => v());
  });
}
function n1(e) {
  return typeof window[e] < "u";
}
function r1(e) {
  return !!(typeof window[e] < "u" && window[e].prototype && "insertRule" in window[e].prototype && "deleteRule" in window[e].prototype);
}
class $A {
  constructor(t) {
    this.generateIdFn = t, this.iframeIdToRemoteIdMap = /* @__PURE__ */ new WeakMap(), this.iframeRemoteIdToIdMap = /* @__PURE__ */ new WeakMap();
  }
  getId(t, n, r, i) {
    const o = r || this.getIdToRemoteIdMap(t), a = i || this.getRemoteIdToIdMap(t);
    let s = o.get(n);
    return s || (s = this.generateIdFn(), o.set(n, s), a.set(s, n)), s;
  }
  getIds(t, n) {
    const r = this.getIdToRemoteIdMap(t), i = this.getRemoteIdToIdMap(t);
    return n.map((o) => this.getId(t, o, r, i));
  }
  getRemoteId(t, n, r) {
    const i = r || this.getRemoteIdToIdMap(t);
    if (typeof n != "number")
      return n;
    const o = i.get(n);
    return o || -1;
  }
  getRemoteIds(t, n) {
    const r = this.getRemoteIdToIdMap(t);
    return n.map((i) => this.getRemoteId(t, i, r));
  }
  reset(t) {
    if (!t) {
      this.iframeIdToRemoteIdMap = /* @__PURE__ */ new WeakMap(), this.iframeRemoteIdToIdMap = /* @__PURE__ */ new WeakMap();
      return;
    }
    this.iframeIdToRemoteIdMap.delete(t), this.iframeRemoteIdToIdMap.delete(t);
  }
  getIdToRemoteIdMap(t) {
    let n = this.iframeIdToRemoteIdMap.get(t);
    return n || (n = /* @__PURE__ */ new Map(), this.iframeIdToRemoteIdMap.set(t, n)), n;
  }
  getRemoteIdToIdMap(t) {
    let n = this.iframeRemoteIdToIdMap.get(t);
    return n || (n = /* @__PURE__ */ new Map(), this.iframeRemoteIdToIdMap.set(t, n)), n;
  }
}
function kj(e) {
  let t, n = e[0], r = 1;
  for (; r < e.length; ) {
    const i = e[r], o = e[r + 1];
    if (r += 2, (i === "optionalAccess" || i === "optionalCall") && n == null)
      return;
    i === "access" || i === "optionalAccess" ? (t = n, n = o(n)) : (i === "call" || i === "optionalCall") && (n = o((...a) => n.call(t, ...a)), t = void 0);
  }
  return n;
}
class qAe {
  constructor() {
    this.crossOriginIframeMirror = new $A(Y6), this.crossOriginIframeRootIdMap = /* @__PURE__ */ new WeakMap();
  }
  addIframe() {
  }
  addLoadListener() {
  }
  attachIframe() {
  }
}
class GAe {
  constructor(t) {
    this.iframes = /* @__PURE__ */ new WeakMap(), this.crossOriginIframeMap = /* @__PURE__ */ new WeakMap(), this.crossOriginIframeMirror = new $A(Y6), this.crossOriginIframeRootIdMap = /* @__PURE__ */ new WeakMap(), this.mutationCb = t.mutationCb, this.wrappedEmit = t.wrappedEmit, this.stylesheetManager = t.stylesheetManager, this.recordCrossOriginIframes = t.recordCrossOriginIframes, this.crossOriginIframeStyleMirror = new $A(this.stylesheetManager.styleMirror.generateId.bind(this.stylesheetManager.styleMirror)), this.mirror = t.mirror, this.recordCrossOriginIframes && window.addEventListener("message", this.handleMessage.bind(this));
  }
  addIframe(t) {
    this.iframes.set(t, !0), t.contentWindow && this.crossOriginIframeMap.set(t.contentWindow, t);
  }
  addLoadListener(t) {
    this.loadListener = t;
  }
  attachIframe(t, n) {
    this.mutationCb({
      adds: [
        {
          parentId: this.mirror.getId(t),
          nextId: null,
          node: n
        }
      ],
      removes: [],
      texts: [],
      attributes: [],
      isAttachIframe: !0
    }), kj([this, "access", (r) => r.loadListener, "optionalCall", (r) => r(t)]), t.contentDocument && t.contentDocument.adoptedStyleSheets && t.contentDocument.adoptedStyleSheets.length > 0 && this.stylesheetManager.adoptStyleSheets(t.contentDocument.adoptedStyleSheets, this.mirror.getId(t.contentDocument));
  }
  handleMessage(t) {
    const n = t;
    if (n.data.type !== "rrweb" || n.origin !== n.data.origin || !t.source)
      return;
    const i = this.crossOriginIframeMap.get(t.source);
    if (!i)
      return;
    const o = this.transformCrossOriginEvent(i, n.data.event);
    o && this.wrappedEmit(o, n.data.isCheckout);
  }
  transformCrossOriginEvent(t, n) {
    switch (n.type) {
      case fn.FullSnapshot: {
        this.crossOriginIframeMirror.reset(t), this.crossOriginIframeStyleMirror.reset(t), this.replaceIdOnNode(n.data.node, t);
        const r = n.data.node.id;
        return this.crossOriginIframeRootIdMap.set(t, r), this.patchRootIdOnNode(n.data.node, r), {
          timestamp: n.timestamp,
          type: fn.IncrementalSnapshot,
          data: {
            source: hn.Mutation,
            adds: [
              {
                parentId: this.mirror.getId(t),
                nextId: null,
                node: n.data.node
              }
            ],
            removes: [],
            texts: [],
            attributes: [],
            isAttachIframe: !0
          }
        };
      }
      case fn.Meta:
      case fn.Load:
      case fn.DomContentLoaded:
        return !1;
      case fn.Plugin:
        return n;
      case fn.Custom:
        return this.replaceIds(n.data.payload, t, ["id", "parentId", "previousId", "nextId"]), n;
      case fn.IncrementalSnapshot:
        switch (n.data.source) {
          case hn.Mutation:
            return n.data.adds.forEach((r) => {
              this.replaceIds(r, t, [
                "parentId",
                "nextId",
                "previousId"
              ]), this.replaceIdOnNode(r.node, t);
              const i = this.crossOriginIframeRootIdMap.get(t);
              i && this.patchRootIdOnNode(r.node, i);
            }), n.data.removes.forEach((r) => {
              this.replaceIds(r, t, ["parentId", "id"]);
            }), n.data.attributes.forEach((r) => {
              this.replaceIds(r, t, ["id"]);
            }), n.data.texts.forEach((r) => {
              this.replaceIds(r, t, ["id"]);
            }), n;
          case hn.Drag:
          case hn.TouchMove:
          case hn.MouseMove:
            return n.data.positions.forEach((r) => {
              this.replaceIds(r, t, ["id"]);
            }), n;
          case hn.ViewportResize:
            return !1;
          case hn.MediaInteraction:
          case hn.MouseInteraction:
          case hn.Scroll:
          case hn.CanvasMutation:
          case hn.Input:
            return this.replaceIds(n.data, t, ["id"]), n;
          case hn.StyleSheetRule:
          case hn.StyleDeclaration:
            return this.replaceIds(n.data, t, ["id"]), this.replaceStyleIds(n.data, t, ["styleId"]), n;
          case hn.Font:
            return n;
          case hn.Selection:
            return n.data.ranges.forEach((r) => {
              this.replaceIds(r, t, ["start", "end"]);
            }), n;
          case hn.AdoptedStyleSheet:
            return this.replaceIds(n.data, t, ["id"]), this.replaceStyleIds(n.data, t, ["styleIds"]), kj([n, "access", (r) => r.data, "access", (r) => r.styles, "optionalAccess", (r) => r.forEach, "call", (r) => r((i) => {
              this.replaceStyleIds(i, t, ["styleId"]);
            })]), n;
        }
    }
    return !1;
  }
  replace(t, n, r, i) {
    for (const o of i)
      !Array.isArray(n[o]) && typeof n[o] != "number" || (Array.isArray(n[o]) ? n[o] = t.getIds(r, n[o]) : n[o] = t.getId(r, n[o]));
    return n;
  }
  replaceIds(t, n, r) {
    return this.replace(this.crossOriginIframeMirror, t, n, r);
  }
  replaceStyleIds(t, n, r) {
    return this.replace(this.crossOriginIframeStyleMirror, t, n, r);
  }
  replaceIdOnNode(t, n) {
    this.replaceIds(t, n, ["id", "rootId"]), "childNodes" in t && t.childNodes.forEach((r) => {
      this.replaceIdOnNode(r, n);
    });
  }
  patchRootIdOnNode(t, n) {
    t.type !== bi.Document && !t.rootId && (t.rootId = n), "childNodes" in t && t.childNodes.forEach((r) => {
      this.patchRootIdOnNode(r, n);
    });
  }
}
class KAe {
  init() {
  }
  addShadowRoot() {
  }
  observeAttachShadow() {
  }
  reset() {
  }
}
class YAe {
  constructor(t) {
    this.shadowDoms = /* @__PURE__ */ new WeakSet(), this.restoreHandlers = [], this.mutationCb = t.mutationCb, this.scrollCb = t.scrollCb, this.bypassOptions = t.bypassOptions, this.mirror = t.mirror, this.init();
  }
  init() {
    this.reset(), this.patchAttachShadow(Element, document);
  }
  addShadowRoot(t, n) {
    if (!D0(t) || this.shadowDoms.has(t))
      return;
    this.shadowDoms.add(t);
    const r = nX({
      ...this.bypassOptions,
      doc: n,
      mutationCb: this.mutationCb,
      mirror: this.mirror,
      shadowDomManager: this
    }, t);
    this.restoreHandlers.push(() => r.disconnect()), this.restoreHandlers.push(rX({
      ...this.bypassOptions,
      scrollCb: this.scrollCb,
      doc: t,
      mirror: this.mirror
    })), EE(() => {
      t.adoptedStyleSheets && t.adoptedStyleSheets.length > 0 && this.bypassOptions.stylesheetManager.adoptStyleSheets(t.adoptedStyleSheets, this.mirror.getId(t.host)), this.restoreHandlers.push(iX({
        mirror: this.mirror,
        stylesheetManager: this.bypassOptions.stylesheetManager
      }, t));
    }, 0);
  }
  observeAttachShadow(t) {
    !t.contentWindow || !t.contentDocument || this.patchAttachShadow(t.contentWindow.Element, t.contentDocument);
  }
  patchAttachShadow(t, n) {
    const r = this;
    this.restoreHandlers.push(Q6(t.prototype, "attachShadow", function(i) {
      return function(o) {
        const a = i.call(this, o);
        return this.shadowRoot && ZY(this) && r.addShadowRoot(this.shadowRoot, n), a;
      };
    }));
  }
  reset() {
    this.restoreHandlers.forEach((t) => {
      try {
        t();
      } catch {
      }
    }), this.restoreHandlers = [], this.shadowDoms = /* @__PURE__ */ new WeakSet();
  }
}
class Nj {
  reset() {
  }
  freeze() {
  }
  unfreeze() {
  }
  lock() {
  }
  unlock() {
  }
  snapshot() {
  }
}
class XAe {
  constructor(t) {
    this.trackedLinkElements = /* @__PURE__ */ new WeakSet(), this.styleMirror = new EAe(), this.mutationCb = t.mutationCb, this.adoptedStyleSheetCb = t.adoptedStyleSheetCb;
  }
  attachLinkElement(t, n) {
    "_cssText" in n.attributes && this.mutationCb({
      adds: [],
      removes: [],
      texts: [],
      attributes: [
        {
          id: n.id,
          attributes: n.attributes
        }
      ]
    }), this.trackLinkElement(t);
  }
  trackLinkElement(t) {
    this.trackedLinkElements.has(t) || (this.trackedLinkElements.add(t), this.trackStylesheetInLinkElement(t));
  }
  adoptStyleSheets(t, n) {
    if (t.length === 0)
      return;
    const r = {
      id: n,
      styleIds: []
    }, i = [];
    for (const o of t) {
      let a;
      this.styleMirror.has(o) ? a = this.styleMirror.getId(o) : (a = this.styleMirror.add(o), i.push({
        styleId: a,
        rules: Array.from(o.rules || CSSRule, (s, c) => ({
          rule: VY(s),
          index: c
        }))
      })), r.styleIds.push(a);
    }
    i.length > 0 && (r.styles = i), this.adoptedStyleSheetCb(r);
  }
  reset() {
    this.styleMirror.reset(), this.trackedLinkElements = /* @__PURE__ */ new WeakSet();
  }
  trackStylesheetInLinkElement(t) {
  }
}
class QAe {
  constructor() {
    this.nodeMap = /* @__PURE__ */ new WeakMap(), this.loop = !0, this.periodicallyClear();
  }
  periodicallyClear() {
    IAe(() => {
      this.clear(), this.loop && this.periodicallyClear();
    });
  }
  inOtherBuffer(t, n) {
    const r = this.nodeMap.get(t);
    return r && Array.from(r).some((i) => i !== n);
  }
  add(t, n) {
    this.nodeMap.set(t, (this.nodeMap.get(t) || /* @__PURE__ */ new Set()).add(n));
  }
  clear() {
    this.nodeMap = /* @__PURE__ */ new WeakMap();
  }
  destroy() {
    this.loop = !1;
  }
}
let zr, ES;
const as = J$e();
function mu(e = {}) {
  const { emit: t, checkoutEveryNms: n, checkoutEveryNth: r, blockClass: i = "rr-block", blockSelector: o = null, unblockSelector: a = null, ignoreClass: s = "rr-ignore", ignoreSelector: c = null, maskAllText: l = !1, maskTextClass: u = "rr-mask", unmaskTextClass: d = null, maskTextSelector: f = null, unmaskTextSelector: h = null, inlineStylesheet: p = !0, maskAllInputs: g, maskInputOptions: m, slimDOMOptions: v, maskAttributeFn: y, maskInputFn: _, maskTextFn: b, maxCanvasSize: w = null, packFn: C, sampling: x = {}, dataURLOptions: T = {}, mousemoveWait: E, recordCanvas: R = !1, recordCrossOriginIframes: I = !1, recordAfter: O = e.recordAfter === "DOMContentLoaded" ? e.recordAfter : "load", userTriggeredOnInput: P = !1, collectFonts: k = !1, inlineImages: L = !1, plugins: N, keepIframeSrcFn: D = () => !1, ignoreCSSAttributes: z = /* @__PURE__ */ new Set([]), errorHandler: V, onMutation: B, getCanvasManager: U } = e;
  OAe(V);
  const Q = I ? window.parent === window : !0;
  let Y = !1;
  if (!Q)
    try {
      window.parent.document && (Y = !1);
    } catch {
      Y = !0;
    }
  if (Q && !t)
    throw new Error("emit function is required");
  E !== void 0 && x.mousemove === void 0 && (x.mousemove = E), as.reset();
  const q = g === !0 ? {
    color: !0,
    date: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0,
    textarea: !0,
    select: !0,
    radio: !0,
    checkbox: !0
  } : m !== void 0 ? m : {}, X = v === !0 || v === "all" ? {
    script: !0,
    comment: !0,
    headFavicon: !0,
    headWhitespace: !0,
    headMetaSocial: !0,
    headMetaRobots: !0,
    headMetaHttpEquiv: !0,
    headMetaVerification: !0,
    headMetaAuthorship: v === "all",
    headMetaDescKeywords: v === "all"
  } : v || {};
  xAe();
  let ne, Z = 0;
  const J = (pe) => {
    for (const Te of N || [])
      Te.eventProcessor && (pe = Te.eventProcessor(pe));
    return C && !Y && (pe = C(pe)), pe;
  };
  zr = (pe, Te) => {
    const de = pe;
    if (de.timestamp = wS(), K5([Yh, "access", (Ae) => Ae[0], "optionalAccess", (Ae) => Ae.isFrozen, "call", (Ae) => Ae()]) && de.type !== fn.FullSnapshot && !(de.type === fn.IncrementalSnapshot && de.data.source === hn.Mutation) && Yh.forEach((Ae) => Ae.unfreeze()), Q)
      K5([t, "optionalCall", (Ae) => Ae(J(de), Te)]);
    else if (Y) {
      const Ae = {
        type: "rrweb",
        event: J(de),
        origin: window.location.origin,
        isCheckout: Te
      };
      window.parent.postMessage(Ae, "*");
    }
    if (de.type === fn.FullSnapshot)
      ne = de, Z = 0;
    else if (de.type === fn.IncrementalSnapshot) {
      if (de.data.source === hn.Mutation && de.data.isAttachIframe)
        return;
      Z++;
      const Ae = r && Z >= r, ue = n && ne && de.timestamp - ne.timestamp > n;
      (Ae || ue) && me(!0);
    }
  };
  const K = (pe) => {
    zr({
      type: fn.IncrementalSnapshot,
      data: {
        source: hn.Mutation,
        ...pe
      }
    });
  }, ee = (pe) => zr({
    type: fn.IncrementalSnapshot,
    data: {
      source: hn.Scroll,
      ...pe
    }
  }), te = (pe) => zr({
    type: fn.IncrementalSnapshot,
    data: {
      source: hn.CanvasMutation,
      ...pe
    }
  }), H = (pe) => zr({
    type: fn.IncrementalSnapshot,
    data: {
      source: hn.AdoptedStyleSheet,
      ...pe
    }
  }), ie = new XAe({
    mutationCb: K,
    adoptedStyleSheetCb: H
  }), W = typeof __RRWEB_EXCLUDE_IFRAME__ == "boolean" && __RRWEB_EXCLUDE_IFRAME__ ? new qAe() : new GAe({
    mirror: as,
    mutationCb: K,
    stylesheetManager: ie,
    recordCrossOriginIframes: I,
    wrappedEmit: zr
  });
  for (const pe of N || [])
    pe.getMirror && pe.getMirror({
      nodeMirror: as,
      crossOriginIframeMirror: W.crossOriginIframeMirror,
      crossOriginIframeStyleMirror: W.crossOriginIframeStyleMirror
    });
  const se = new QAe(), le = ZAe(U, {
    mirror: as,
    win: window,
    mutationCb: (pe) => zr({
      type: fn.IncrementalSnapshot,
      data: {
        source: hn.CanvasMutation,
        ...pe
      }
    }),
    recordCanvas: R,
    blockClass: i,
    blockSelector: o,
    unblockSelector: a,
    maxCanvasSize: w,
    sampling: x.canvas,
    dataURLOptions: T,
    errorHandler: V
  }), ge = typeof __RRWEB_EXCLUDE_SHADOW_DOM__ == "boolean" && __RRWEB_EXCLUDE_SHADOW_DOM__ ? new KAe() : new YAe({
    mutationCb: K,
    scrollCb: ee,
    bypassOptions: {
      onMutation: B,
      blockClass: i,
      blockSelector: o,
      unblockSelector: a,
      maskAllText: l,
      maskTextClass: u,
      unmaskTextClass: d,
      maskTextSelector: f,
      unmaskTextSelector: h,
      inlineStylesheet: p,
      maskInputOptions: q,
      dataURLOptions: T,
      maskAttributeFn: y,
      maskTextFn: b,
      maskInputFn: _,
      recordCanvas: R,
      inlineImages: L,
      sampling: x,
      slimDOMOptions: X,
      iframeManager: W,
      stylesheetManager: ie,
      canvasManager: le,
      keepIframeSrcFn: D,
      processedNodeManager: se
    },
    mirror: as
  }), me = (pe = !1) => {
    zr({
      type: fn.Meta,
      data: {
        href: window.location.href,
        width: GY(),
        height: qY()
      }
    }, pe), ie.reset(), ge.init(), Yh.forEach((de) => de.lock());
    const Te = SAe(document, {
      mirror: as,
      blockClass: i,
      blockSelector: o,
      unblockSelector: a,
      maskAllText: l,
      maskTextClass: u,
      unmaskTextClass: d,
      maskTextSelector: f,
      unmaskTextSelector: h,
      inlineStylesheet: p,
      maskAllInputs: q,
      maskAttributeFn: y,
      maskInputFn: _,
      maskTextFn: b,
      slimDOM: X,
      dataURLOptions: T,
      recordCanvas: R,
      inlineImages: L,
      onSerialize: (de) => {
        XY(de, as) && W.addIframe(de), QY(de, as) && ie.trackLinkElement(de), TA(de) && ge.addShadowRoot(de.shadowRoot, document);
      },
      onIframeLoad: (de, Ae) => {
        W.attachIframe(de, Ae), ge.observeAttachShadow(de);
      },
      onStylesheetLoad: (de, Ae) => {
        ie.attachLinkElement(de, Ae);
      },
      keepIframeSrcFn: D
    });
    if (!Te)
      return console.warn("Failed to snapshot the document");
    zr({
      type: fn.FullSnapshot,
      data: {
        node: Te,
        initialOffset: WY(window)
      }
    }), Yh.forEach((de) => de.unlock()), document.adoptedStyleSheets && document.adoptedStyleSheets.length > 0 && ie.adoptStyleSheets(document.adoptedStyleSheets, as.getId(document));
  };
  ES = me;
  try {
    const pe = [], Te = (Ae) => $n(WAe)({
      onMutation: B,
      mutationCb: K,
      mousemoveCb: (ue, be) => zr({
        type: fn.IncrementalSnapshot,
        data: {
          source: be,
          positions: ue
        }
      }),
      mouseInteractionCb: (ue) => zr({
        type: fn.IncrementalSnapshot,
        data: {
          source: hn.MouseInteraction,
          ...ue
        }
      }),
      scrollCb: ee,
      viewportResizeCb: (ue) => zr({
        type: fn.IncrementalSnapshot,
        data: {
          source: hn.ViewportResize,
          ...ue
        }
      }),
      inputCb: (ue) => zr({
        type: fn.IncrementalSnapshot,
        data: {
          source: hn.Input,
          ...ue
        }
      }),
      mediaInteractionCb: (ue) => zr({
        type: fn.IncrementalSnapshot,
        data: {
          source: hn.MediaInteraction,
          ...ue
        }
      }),
      styleSheetRuleCb: (ue) => zr({
        type: fn.IncrementalSnapshot,
        data: {
          source: hn.StyleSheetRule,
          ...ue
        }
      }),
      styleDeclarationCb: (ue) => zr({
        type: fn.IncrementalSnapshot,
        data: {
          source: hn.StyleDeclaration,
          ...ue
        }
      }),
      canvasMutationCb: te,
      fontCb: (ue) => zr({
        type: fn.IncrementalSnapshot,
        data: {
          source: hn.Font,
          ...ue
        }
      }),
      selectionCb: (ue) => {
        zr({
          type: fn.IncrementalSnapshot,
          data: {
            source: hn.Selection,
            ...ue
          }
        });
      },
      customElementCb: (ue) => {
        zr({
          type: fn.IncrementalSnapshot,
          data: {
            source: hn.CustomElement,
            ...ue
          }
        });
      },
      blockClass: i,
      ignoreClass: s,
      ignoreSelector: c,
      maskAllText: l,
      maskTextClass: u,
      unmaskTextClass: d,
      maskTextSelector: f,
      unmaskTextSelector: h,
      maskInputOptions: q,
      inlineStylesheet: p,
      sampling: x,
      recordCanvas: R,
      inlineImages: L,
      userTriggeredOnInput: P,
      collectFonts: k,
      doc: Ae,
      maskAttributeFn: y,
      maskInputFn: _,
      maskTextFn: b,
      keepIframeSrcFn: D,
      blockSelector: o,
      unblockSelector: a,
      slimDOMOptions: X,
      dataURLOptions: T,
      mirror: as,
      iframeManager: W,
      stylesheetManager: ie,
      shadowDomManager: ge,
      processedNodeManager: se,
      canvasManager: le,
      ignoreCSSAttributes: z,
      plugins: K5([
        N,
        "optionalAccess",
        (ue) => ue.filter,
        "call",
        (ue) => ue((be) => be.observer),
        "optionalAccess",
        (ue) => ue.map,
        "call",
        (ue) => ue((be) => ({
          observer: be.observer,
          options: be.options,
          callback: (Ie) => zr({
            type: fn.Plugin,
            data: {
              plugin: be.name,
              payload: Ie
            }
          })
        }))
      ]) || []
    }, {});
    W.addLoadListener((Ae) => {
      try {
        pe.push(Te(Ae.contentDocument));
      } catch (ue) {
        console.warn(ue);
      }
    });
    const de = () => {
      me(), pe.push(Te(document));
    };
    return document.readyState === "interactive" || document.readyState === "complete" ? de() : (pe.push($o("DOMContentLoaded", () => {
      zr({
        type: fn.DomContentLoaded,
        data: {}
      }), O === "DOMContentLoaded" && de();
    })), pe.push($o("load", () => {
      zr({
        type: fn.Load,
        data: {}
      }), O === "load" && de();
    }, window))), () => {
      pe.forEach((Ae) => Ae()), se.destroy(), ES = void 0, MAe();
    };
  } catch (pe) {
    console.warn(pe);
  }
}
function JAe(e) {
  if (!ES)
    throw new Error("please take full snapshot after start recording");
  ES(e);
}
mu.mirror = as;
mu.takeFullSnapshot = JAe;
function ZAe(e, t) {
  try {
    return e ? e(t) : new Nj();
  } catch {
    return console.warn("Unable to initialize CanvasManager"), new Nj();
  }
}
const eRe = 3, tRe = 5;
function Z6(e) {
  return e > 9999999999 ? e : e * 1e3;
}
function nT(e) {
  return e > 9999999999 ? e / 1e3 : e;
}
function Ty(e, t) {
  t.category !== "sentry.transaction" && (["ui.click", "ui.input"].includes(t.category) ? e.triggerUserActivity() : e.checkAndHandleExpiredSession(), e.addUpdate(() => (e.throttledAddEvent({
    type: fn.Custom,
    // TODO: We were converting from ms to seconds for breadcrumbs, spans,
    // but maybe we should just keep them as milliseconds
    timestamp: (t.timestamp || 0) * 1e3,
    data: {
      tag: "breadcrumb",
      // normalize to max. 10 depth and 1_000 properties per object
      payload: Qs(t, 10, 1e3)
    }
  }), t.category === "console")));
}
const nRe = "button,a";
function oX(e) {
  return e.closest(nRe) || e;
}
function aX(e) {
  const t = sX(e);
  return !t || !(t instanceof Element) ? t : oX(t);
}
function sX(e) {
  return rRe(e) ? e.target : e;
}
function rRe(e) {
  return typeof e == "object" && !!e && "target" in e;
}
let Hl;
function iRe(e) {
  return Hl || (Hl = [], oRe()), Hl.push(e), () => {
    const t = Hl ? Hl.indexOf(e) : -1;
    t > -1 && Hl.splice(t, 1);
  };
}
function oRe() {
  Oi(hr, "open", function(e) {
    return function(...t) {
      if (Hl)
        try {
          Hl.forEach((n) => n());
        } catch {
        }
      return e.apply(hr, t);
    };
  });
}
function aRe(e, t, n) {
  e.handleClick(t, n);
}
class sRe {
  // protected for testing
  constructor(t, n, r = Ty) {
    this._lastMutation = 0, this._lastScroll = 0, this._clicks = [], this._timeout = n.timeout / 1e3, this._threshold = n.threshold / 1e3, this._scollTimeout = n.scrollTimeout / 1e3, this._replay = t, this._ignoreSelector = n.ignoreSelector, this._addBreadcrumbEvent = r;
  }
  /** Register click detection handlers on mutation or scroll. */
  addListeners() {
    const t = iRe(() => {
      this._lastMutation = Dj();
    });
    this._teardown = () => {
      t(), this._clicks = [], this._lastMutation = 0, this._lastScroll = 0;
    };
  }
  /** Clean up listeners. */
  removeListeners() {
    this._teardown && this._teardown(), this._checkClickTimeout && clearTimeout(this._checkClickTimeout);
  }
  /** @inheritDoc */
  handleClick(t, n) {
    if (lRe(n, this._ignoreSelector) || !uRe(t))
      return;
    const r = {
      timestamp: nT(t.timestamp),
      clickBreadcrumb: t,
      // Set this to 0 so we know it originates from the click breadcrumb
      clickCount: 0,
      node: n
    };
    this._clicks.some((i) => i.node === r.node && Math.abs(i.timestamp - r.timestamp) < 1) || (this._clicks.push(r), this._clicks.length === 1 && this._scheduleCheckClicks());
  }
  /** @inheritDoc */
  registerMutation(t = Date.now()) {
    this._lastMutation = nT(t);
  }
  /** @inheritDoc */
  registerScroll(t = Date.now()) {
    this._lastScroll = nT(t);
  }
  /** @inheritDoc */
  registerClick(t) {
    const n = oX(t);
    this._handleMultiClick(n);
  }
  /** Count multiple clicks on elements. */
  _handleMultiClick(t) {
    this._getClicks(t).forEach((n) => {
      n.clickCount++;
    });
  }
  /** Get all pending clicks for a given node. */
  _getClicks(t) {
    return this._clicks.filter((n) => n.node === t);
  }
  /** Check the clicks that happened. */
  _checkClicks() {
    const t = [], n = Dj();
    this._clicks.forEach((r) => {
      !r.mutationAfter && this._lastMutation && (r.mutationAfter = r.timestamp <= this._lastMutation ? this._lastMutation - r.timestamp : void 0), !r.scrollAfter && this._lastScroll && (r.scrollAfter = r.timestamp <= this._lastScroll ? this._lastScroll - r.timestamp : void 0), r.timestamp + this._timeout <= n && t.push(r);
    });
    for (const r of t) {
      const i = this._clicks.indexOf(r);
      i > -1 && (this._generateBreadcrumbs(r), this._clicks.splice(i, 1));
    }
    this._clicks.length && this._scheduleCheckClicks();
  }
  /** Generate matching breadcrumb(s) for the click. */
  _generateBreadcrumbs(t) {
    const n = this._replay, r = t.scrollAfter && t.scrollAfter <= this._scollTimeout, i = t.mutationAfter && t.mutationAfter <= this._threshold, o = !r && !i, { clickCount: a, clickBreadcrumb: s } = t;
    if (o) {
      const c = Math.min(t.mutationAfter || this._timeout, this._timeout) * 1e3, l = c < this._timeout * 1e3 ? "mutation" : "timeout", u = {
        type: "default",
        message: s.message,
        timestamp: s.timestamp,
        category: "ui.slowClickDetected",
        data: {
          ...s.data,
          url: hr.location.href,
          route: n.getCurrentRoute(),
          timeAfterClickMs: c,
          endReason: l,
          // If clickCount === 0, it means multiClick was not correctly captured here
          // - we still want to send 1 in this case
          clickCount: a || 1
        }
      };
      this._addBreadcrumbEvent(n, u);
      return;
    }
    if (a > 1) {
      const c = {
        type: "default",
        message: s.message,
        timestamp: s.timestamp,
        category: "ui.multiClick",
        data: {
          ...s.data,
          url: hr.location.href,
          route: n.getCurrentRoute(),
          clickCount: a,
          metric: !0
        }
      };
      this._addBreadcrumbEvent(n, c);
    }
  }
  /** Schedule to check current clicks. */
  _scheduleCheckClicks() {
    this._checkClickTimeout && clearTimeout(this._checkClickTimeout), this._checkClickTimeout = setTimeout(() => this._checkClicks(), 1e3);
  }
}
const cRe = ["A", "BUTTON", "INPUT"];
function lRe(e, t) {
  return !!(!cRe.includes(e.tagName) || e.tagName === "INPUT" && !["submit", "button"].includes(e.getAttribute("type") || "") || e.tagName === "A" && (e.hasAttribute("download") || e.hasAttribute("target") && e.getAttribute("target") !== "_self") || t && e.matches(t));
}
function uRe(e) {
  return !!(e.data && typeof e.data.nodeId == "number" && e.timestamp);
}
function Dj() {
  return Date.now() / 1e3;
}
function dRe(e, t) {
  try {
    if (!fRe(t))
      return;
    const { source: n } = t.data;
    if (n === hn.Mutation && e.registerMutation(t.timestamp), n === hn.Scroll && e.registerScroll(t.timestamp), hRe(t)) {
      const { type: r, id: i } = t.data, o = mu.mirror.getNode(i);
      o instanceof HTMLElement && r === Eo.Click && e.registerClick(o);
    }
  } catch {
  }
}
function fRe(e) {
  return e.type === eRe;
}
function hRe(e) {
  return e.data.source === hn.MouseInteraction;
}
function nc(e) {
  return {
    timestamp: Date.now() / 1e3,
    type: "default",
    ...e
  };
}
var CS;
(function(e) {
  e[e.Document = 0] = "Document", e[e.DocumentType = 1] = "DocumentType", e[e.Element = 2] = "Element", e[e.Text = 3] = "Text", e[e.CDATA = 4] = "CDATA", e[e.Comment = 5] = "Comment";
})(CS || (CS = {}));
const gRe = /* @__PURE__ */ new Set([
  "id",
  "class",
  "aria-label",
  "role",
  "name",
  "alt",
  "title",
  "data-test-id",
  "data-testid",
  "disabled",
  "aria-disabled",
  "data-sentry-component"
]);
function pRe(e) {
  const t = {};
  for (const n in e)
    if (gRe.has(n)) {
      let r = n;
      (n === "data-testid" || n === "data-test-id") && (r = "testId"), t[r] = e[n];
    }
  return t;
}
const mRe = (e) => (t) => {
  if (!e.isEnabled())
    return;
  const n = vRe(t);
  if (!n)
    return;
  const r = t.name === "click", i = r ? t.event : void 0;
  r && e.clickDetector && i && i.target && !i.altKey && !i.metaKey && !i.ctrlKey && !i.shiftKey && aRe(
    e.clickDetector,
    n,
    aX(t.event)
  ), Ty(e, n);
};
function cX(e, t) {
  const n = mu.mirror.getId(e), r = n && mu.mirror.getNode(n), i = r && mu.mirror.getMeta(r), o = i && bRe(i) ? i : null;
  return {
    message: t,
    data: o ? {
      nodeId: n,
      node: {
        id: n,
        tagName: o.tagName,
        textContent: Array.from(o.childNodes).map((a) => a.type === CS.Text && a.textContent).filter(Boolean).map((a) => a.trim()).join(""),
        attributes: pRe(o.attributes)
      }
    } : {}
  };
}
function vRe(e) {
  const { target: t, message: n } = yRe(e);
  return nc({
    category: `ui.${e.name}`,
    ...cX(t, n)
  });
}
function yRe(e) {
  const t = e.name === "click";
  let n, r = null;
  try {
    r = t ? aX(e.event) : sX(e.event), n = ku(r, { maxStringLength: 200 }) || "<unknown>";
  } catch {
    n = "<unknown>";
  }
  return { target: r, message: n };
}
function bRe(e) {
  return e.type === CS.Element;
}
function _Re(e, t) {
  if (!e.isEnabled())
    return;
  e.updateUserActivity();
  const n = SRe(t);
  n && Ty(e, n);
}
function SRe(e) {
  const { metaKey: t, shiftKey: n, ctrlKey: r, altKey: i, key: o, target: a } = e;
  if (!a || wRe(a) || !o)
    return null;
  const s = t || r || i, c = o.length === 1;
  if (!s && c)
    return null;
  const l = ku(a, { maxStringLength: 200 }) || "<unknown>", u = cX(a, l);
  return nc({
    category: "ui.keyDown",
    message: l,
    data: {
      ...u.data,
      metaKey: t,
      shiftKey: n,
      ctrlKey: r,
      altKey: i,
      key: o
    }
  });
}
function wRe(e) {
  return e.tagName === "INPUT" || e.tagName === "TEXTAREA" || e.isContentEditable;
}
const jj = {
  // @ts-expect-error TODO: entry type does not fit the create* functions entry type
  resource: IRe,
  paint: CRe,
  // @ts-expect-error TODO: entry type does not fit the create* functions entry type
  navigation: TRe
};
function xRe(e) {
  return e.map(ERe).filter(Boolean);
}
function ERe(e) {
  return jj[e.entryType] ? jj[e.entryType](e) : null;
}
function Bg(e) {
  return ((wa || hr.performance.timeOrigin) + e) / 1e3;
}
function CRe(e) {
  const { duration: t, entryType: n, name: r, startTime: i } = e, o = Bg(i);
  return {
    type: n,
    name: r,
    start: o,
    end: o + t,
    data: void 0
  };
}
function TRe(e) {
  const {
    entryType: t,
    name: n,
    decodedBodySize: r,
    duration: i,
    domComplete: o,
    encodedBodySize: a,
    domContentLoadedEventStart: s,
    domContentLoadedEventEnd: c,
    domInteractive: l,
    loadEventStart: u,
    loadEventEnd: d,
    redirectCount: f,
    startTime: h,
    transferSize: p,
    type: g
  } = e;
  return i === 0 ? null : {
    type: `${t}.${g}`,
    start: Bg(h),
    end: Bg(o),
    name: n,
    data: {
      size: p,
      decodedBodySize: r,
      encodedBodySize: a,
      duration: i,
      domInteractive: l,
      domContentLoadedEventStart: s,
      domContentLoadedEventEnd: c,
      loadEventStart: u,
      loadEventEnd: d,
      domComplete: o,
      redirectCount: f
    }
  };
}
function IRe(e) {
  const {
    entryType: t,
    initiatorType: n,
    name: r,
    responseEnd: i,
    startTime: o,
    decodedBodySize: a,
    encodedBodySize: s,
    responseStatus: c,
    transferSize: l
  } = e;
  return ["fetch", "xmlhttprequest"].includes(n) ? null : {
    type: `${t}.${n}`,
    start: Bg(o),
    end: Bg(i),
    name: r,
    data: {
      size: l,
      statusCode: c,
      decodedBodySize: a,
      encodedBodySize: s
    }
  };
}
function $Re(e) {
  const t = e.entries, n = t[t.length - 1], r = n ? n.element : void 0, i = e.value, o = Bg(i);
  return {
    type: "largest-contentful-paint",
    name: "largest-contentful-paint",
    start: o,
    end: o,
    data: {
      value: i,
      size: i,
      nodeId: r ? mu.mirror.getId(r) : void 0
    }
  };
}
function ARe(e) {
  function t(i) {
    e.performanceEntries.includes(i) || e.performanceEntries.push(i);
  }
  function n({ entries: i }) {
    i.forEach(t);
  }
  const r = [];
  return ["navigation", "paint", "resource"].forEach((i) => {
    r.push(Dg(i, n));
  }), r.push(
    vY(({ metric: i }) => {
      e.replayPerformanceEntries.push($Re(i));
    })
  ), () => {
    r.forEach((i) => i());
  };
}
const sr = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, RRe = 'var t=Uint8Array,n=Uint16Array,r=Int32Array,e=new t([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0,0,0,0]),i=new t([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13,0,0]),a=new t([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),s=function(t,e){for(var i=new n(31),a=0;a<31;++a)i[a]=e+=1<<t[a-1];var s=new r(i[30]);for(a=1;a<30;++a)for(var o=i[a];o<i[a+1];++o)s[o]=o-i[a]<<5|a;return{b:i,r:s}},o=s(e,2),f=o.b,h=o.r;f[28]=258,h[258]=28;for(var l=s(i,0).r,u=new n(32768),c=0;c<32768;++c){var v=(43690&c)>>1|(21845&c)<<1;v=(61680&(v=(52428&v)>>2|(13107&v)<<2))>>4|(3855&v)<<4,u[c]=((65280&v)>>8|(255&v)<<8)>>1}var d=function(t,r,e){for(var i=t.length,a=0,s=new n(r);a<i;++a)t[a]&&++s[t[a]-1];var o,f=new n(r);for(a=1;a<r;++a)f[a]=f[a-1]+s[a-1]<<1;if(e){o=new n(1<<r);var h=15-r;for(a=0;a<i;++a)if(t[a])for(var l=a<<4|t[a],c=r-t[a],v=f[t[a]-1]++<<c,d=v|(1<<c)-1;v<=d;++v)o[u[v]>>h]=l}else for(o=new n(i),a=0;a<i;++a)t[a]&&(o[a]=u[f[t[a]-1]++]>>15-t[a]);return o},g=new t(288);for(c=0;c<144;++c)g[c]=8;for(c=144;c<256;++c)g[c]=9;for(c=256;c<280;++c)g[c]=7;for(c=280;c<288;++c)g[c]=8;var w=new t(32);for(c=0;c<32;++c)w[c]=5;var p=d(g,9,0),y=d(w,5,0),m=function(t){return(t+7)/8|0},b=function(n,r,e){return(null==r||r<0)&&(r=0),(null==e||e>n.length)&&(e=n.length),new t(n.subarray(r,e))},M=["unexpected EOF","invalid block type","invalid length/literal","invalid distance","stream finished","no stream handler",,"no callback","invalid UTF-8 data","extra field too long","date not in range 1980-2099","filename too long","stream finishing","invalid zip data"],E=function(t,n,r){var e=new Error(n||M[t]);if(e.code=t,Error.captureStackTrace&&Error.captureStackTrace(e,E),!r)throw e;return e},z=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8},A=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8,t[e+2]|=r>>16},_=function(r,e){for(var i=[],a=0;a<r.length;++a)r[a]&&i.push({s:a,f:r[a]});var s=i.length,o=i.slice();if(!s)return{t:F,l:0};if(1==s){var f=new t(i[0].s+1);return f[i[0].s]=1,{t:f,l:1}}i.sort((function(t,n){return t.f-n.f})),i.push({s:-1,f:25001});var h=i[0],l=i[1],u=0,c=1,v=2;for(i[0]={s:-1,f:h.f+l.f,l:h,r:l};c!=s-1;)h=i[i[u].f<i[v].f?u++:v++],l=i[u!=c&&i[u].f<i[v].f?u++:v++],i[c++]={s:-1,f:h.f+l.f,l:h,r:l};var d=o[0].s;for(a=1;a<s;++a)o[a].s>d&&(d=o[a].s);var g=new n(d+1),w=x(i[c-1],g,0);if(w>e){a=0;var p=0,y=w-e,m=1<<y;for(o.sort((function(t,n){return g[n.s]-g[t.s]||t.f-n.f}));a<s;++a){var b=o[a].s;if(!(g[b]>e))break;p+=m-(1<<w-g[b]),g[b]=e}for(p>>=y;p>0;){var M=o[a].s;g[M]<e?p-=1<<e-g[M]++-1:++a}for(;a>=0&&p;--a){var E=o[a].s;g[E]==e&&(--g[E],++p)}w=e}return{t:new t(g),l:w}},x=function(t,n,r){return-1==t.s?Math.max(x(t.l,n,r+1),x(t.r,n,r+1)):n[t.s]=r},D=function(t){for(var r=t.length;r&&!t[--r];);for(var e=new n(++r),i=0,a=t[0],s=1,o=function(t){e[i++]=t},f=1;f<=r;++f)if(t[f]==a&&f!=r)++s;else{if(!a&&s>2){for(;s>138;s-=138)o(32754);s>2&&(o(s>10?s-11<<5|28690:s-3<<5|12305),s=0)}else if(s>3){for(o(a),--s;s>6;s-=6)o(8304);s>2&&(o(s-3<<5|8208),s=0)}for(;s--;)o(a);s=1,a=t[f]}return{c:e.subarray(0,i),n:r}},T=function(t,n){for(var r=0,e=0;e<n.length;++e)r+=t[e]*n[e];return r},k=function(t,n,r){var e=r.length,i=m(n+2);t[i]=255&e,t[i+1]=e>>8,t[i+2]=255^t[i],t[i+3]=255^t[i+1];for(var a=0;a<e;++a)t[i+a+4]=r[a];return 8*(i+4+e)},C=function(t,r,s,o,f,h,l,u,c,v,m){z(r,m++,s),++f[256];for(var b=_(f,15),M=b.t,E=b.l,x=_(h,15),C=x.t,U=x.l,F=D(M),I=F.c,S=F.n,L=D(C),O=L.c,j=L.n,q=new n(19),B=0;B<I.length;++B)++q[31&I[B]];for(B=0;B<O.length;++B)++q[31&O[B]];for(var G=_(q,7),H=G.t,J=G.l,K=19;K>4&&!H[a[K-1]];--K);var N,P,Q,R,V=v+5<<3,W=T(f,g)+T(h,w)+l,X=T(f,M)+T(h,C)+l+14+3*K+T(q,H)+2*q[16]+3*q[17]+7*q[18];if(c>=0&&V<=W&&V<=X)return k(r,m,t.subarray(c,c+v));if(z(r,m,1+(X<W)),m+=2,X<W){N=d(M,E,0),P=M,Q=d(C,U,0),R=C;var Y=d(H,J,0);z(r,m,S-257),z(r,m+5,j-1),z(r,m+10,K-4),m+=14;for(B=0;B<K;++B)z(r,m+3*B,H[a[B]]);m+=3*K;for(var Z=[I,O],$=0;$<2;++$){var tt=Z[$];for(B=0;B<tt.length;++B){var nt=31&tt[B];z(r,m,Y[nt]),m+=H[nt],nt>15&&(z(r,m,tt[B]>>5&127),m+=tt[B]>>12)}}}else N=p,P=g,Q=y,R=w;for(B=0;B<u;++B){var rt=o[B];if(rt>255){A(r,m,N[(nt=rt>>18&31)+257]),m+=P[nt+257],nt>7&&(z(r,m,rt>>23&31),m+=e[nt]);var et=31&rt;A(r,m,Q[et]),m+=R[et],et>3&&(A(r,m,rt>>5&8191),m+=i[et])}else A(r,m,N[rt]),m+=P[rt]}return A(r,m,N[256]),m+P[256]},U=new r([65540,131080,131088,131104,262176,1048704,1048832,2114560,2117632]),F=new t(0),I=function(){for(var t=new Int32Array(256),n=0;n<256;++n){for(var r=n,e=9;--e;)r=(1&r&&-306674912)^r>>>1;t[n]=r}return t}(),S=function(){var t=1,n=0;return{p:function(r){for(var e=t,i=n,a=0|r.length,s=0;s!=a;){for(var o=Math.min(s+2655,a);s<o;++s)i+=e+=r[s];e=(65535&e)+15*(e>>16),i=(65535&i)+15*(i>>16)}t=e,n=i},d:function(){return(255&(t%=65521))<<24|(65280&t)<<8|(255&(n%=65521))<<8|n>>8}}},L=function(a,s,o,f,u){if(!u&&(u={l:1},s.dictionary)){var c=s.dictionary.subarray(-32768),v=new t(c.length+a.length);v.set(c),v.set(a,c.length),a=v,u.w=c.length}return function(a,s,o,f,u,c){var v=c.z||a.length,d=new t(f+v+5*(1+Math.ceil(v/7e3))+u),g=d.subarray(f,d.length-u),w=c.l,p=7&(c.r||0);if(s){p&&(g[0]=c.r>>3);for(var y=U[s-1],M=y>>13,E=8191&y,z=(1<<o)-1,A=c.p||new n(32768),_=c.h||new n(z+1),x=Math.ceil(o/3),D=2*x,T=function(t){return(a[t]^a[t+1]<<x^a[t+2]<<D)&z},F=new r(25e3),I=new n(288),S=new n(32),L=0,O=0,j=c.i||0,q=0,B=c.w||0,G=0;j+2<v;++j){var H=T(j),J=32767&j,K=_[H];if(A[J]=K,_[H]=J,B<=j){var N=v-j;if((L>7e3||q>24576)&&(N>423||!w)){p=C(a,g,0,F,I,S,O,q,G,j-G,p),q=L=O=0,G=j;for(var P=0;P<286;++P)I[P]=0;for(P=0;P<30;++P)S[P]=0}var Q=2,R=0,V=E,W=J-K&32767;if(N>2&&H==T(j-W))for(var X=Math.min(M,N)-1,Y=Math.min(32767,j),Z=Math.min(258,N);W<=Y&&--V&&J!=K;){if(a[j+Q]==a[j+Q-W]){for(var $=0;$<Z&&a[j+$]==a[j+$-W];++$);if($>Q){if(Q=$,R=W,$>X)break;var tt=Math.min(W,$-2),nt=0;for(P=0;P<tt;++P){var rt=j-W+P&32767,et=rt-A[rt]&32767;et>nt&&(nt=et,K=rt)}}}W+=(J=K)-(K=A[J])&32767}if(R){F[q++]=268435456|h[Q]<<18|l[R];var it=31&h[Q],at=31&l[R];O+=e[it]+i[at],++I[257+it],++S[at],B=j+Q,++L}else F[q++]=a[j],++I[a[j]]}}for(j=Math.max(j,B);j<v;++j)F[q++]=a[j],++I[a[j]];p=C(a,g,w,F,I,S,O,q,G,j-G,p),w||(c.r=7&p|g[p/8|0]<<3,p-=7,c.h=_,c.p=A,c.i=j,c.w=B)}else{for(j=c.w||0;j<v+w;j+=65535){var st=j+65535;st>=v&&(g[p/8|0]=w,st=v),p=k(g,p+1,a.subarray(j,st))}c.i=v}return b(d,0,f+m(p)+u)}(a,null==s.level?6:s.level,null==s.mem?Math.ceil(1.5*Math.max(8,Math.min(13,Math.log(a.length)))):12+s.mem,o,f,u)},O=function(t,n,r){for(;r;++n)t[n]=r,r>>>=8},j=function(){function n(n,r){if("function"==typeof n&&(r=n,n={}),this.ondata=r,this.o=n||{},this.s={l:0,i:32768,w:32768,z:32768},this.b=new t(98304),this.o.dictionary){var e=this.o.dictionary.subarray(-32768);this.b.set(e,32768-e.length),this.s.i=32768-e.length}}return n.prototype.p=function(t,n){this.ondata(L(t,this.o,0,0,this.s),n)},n.prototype.push=function(n,r){this.ondata||E(5),this.s.l&&E(4);var e=n.length+this.s.z;if(e>this.b.length){if(e>2*this.b.length-32768){var i=new t(-32768&e);i.set(this.b.subarray(0,this.s.z)),this.b=i}var a=this.b.length-this.s.z;a&&(this.b.set(n.subarray(0,a),this.s.z),this.s.z=this.b.length,this.p(this.b,!1)),this.b.set(this.b.subarray(-32768)),this.b.set(n.subarray(a),32768),this.s.z=n.length-a+32768,this.s.i=32766,this.s.w=32768}else this.b.set(n,this.s.z),this.s.z+=n.length;this.s.l=1&r,(this.s.z>this.s.w+8191||r)&&(this.p(this.b,r||!1),this.s.w=this.s.i,this.s.i-=2)},n}();function q(t,n){n||(n={});var r=function(){var t=-1;return{p:function(n){for(var r=t,e=0;e<n.length;++e)r=I[255&r^n[e]]^r>>>8;t=r},d:function(){return~t}}}(),e=t.length;r.p(t);var i,a=L(t,n,10+((i=n).filename?i.filename.length+1:0),8),s=a.length;return function(t,n){var r=n.filename;if(t[0]=31,t[1]=139,t[2]=8,t[8]=n.level<2?4:9==n.level?2:0,t[9]=3,0!=n.mtime&&O(t,4,Math.floor(new Date(n.mtime||Date.now())/1e3)),r){t[3]=8;for(var e=0;e<=r.length;++e)t[e+10]=r.charCodeAt(e)}}(a,n),O(a,s-8,r.d()),O(a,s-4,e),a}var B=function(){function t(t,n){this.c=S(),this.v=1,j.call(this,t,n)}return t.prototype.push=function(t,n){this.c.p(t),j.prototype.push.call(this,t,n)},t.prototype.p=function(t,n){var r=L(t,this.o,this.v&&(this.o.dictionary?6:2),n&&4,this.s);this.v&&(function(t,n){var r=n.level,e=0==r?0:r<6?1:9==r?3:2;if(t[0]=120,t[1]=e<<6|(n.dictionary&&32),t[1]|=31-(t[0]<<8|t[1])%31,n.dictionary){var i=S();i.p(n.dictionary),O(t,2,i.d())}}(r,this.o),this.v=0),n&&O(r,r.length-4,this.c.d()),this.ondata(r,n)},t}(),G="undefined"!=typeof TextEncoder&&new TextEncoder,H="undefined"!=typeof TextDecoder&&new TextDecoder;try{H.decode(F,{stream:!0})}catch(t){}var J=function(){function t(t){this.ondata=t}return t.prototype.push=function(t,n){this.ondata||E(5),this.d&&E(4),this.ondata(K(t),this.d=n||!1)},t}();function K(n,r){if(r){for(var e=new t(n.length),i=0;i<n.length;++i)e[i]=n.charCodeAt(i);return e}if(G)return G.encode(n);var a=n.length,s=new t(n.length+(n.length>>1)),o=0,f=function(t){s[o++]=t};for(i=0;i<a;++i){if(o+5>s.length){var h=new t(o+8+(a-i<<1));h.set(s),s=h}var l=n.charCodeAt(i);l<128||r?f(l):l<2048?(f(192|l>>6),f(128|63&l)):l>55295&&l<57344?(f(240|(l=65536+(1047552&l)|1023&n.charCodeAt(++i))>>18),f(128|l>>12&63),f(128|l>>6&63),f(128|63&l)):(f(224|l>>12),f(128|l>>6&63),f(128|63&l))}return b(s,0,o)}const N=new class{constructor(){this._init()}clear(){this._init()}addEvent(t){if(!t)throw new Error("Adding invalid event");const n=this._hasEvents?",":"";this.stream.push(n+t),this._hasEvents=!0}finish(){this.stream.push("]",!0);const t=function(t){let n=0;for(let r=0,e=t.length;r<e;r++)n+=t[r].length;const r=new Uint8Array(n);for(let n=0,e=0,i=t.length;n<i;n++){const i=t[n];r.set(i,e),e+=i.length}return r}(this._deflatedData);return this._init(),t}_init(){this._hasEvents=!1,this._deflatedData=[],this.deflate=new B,this.deflate.ondata=(t,n)=>{this._deflatedData.push(t)},this.stream=new J(((t,n)=>{this.deflate.push(t,n)})),this.stream.push("[")}},P={clear:()=>{N.clear()},addEvent:t=>N.addEvent(t),finish:()=>N.finish(),compress:t=>function(t){return q(K(t))}(t)};addEventListener("message",(function(t){const n=t.data.method,r=t.data.id,e=t.data.arg;if(n in P&&"function"==typeof P[n])try{const t=P[n](e);postMessage({id:r,method:n,success:!0,response:t})}catch(t){postMessage({id:r,method:n,success:!1,response:t.message}),console.error(t)}})),postMessage({id:void 0,method:"init",success:!0,response:void 0});';
function PRe() {
  const e = new Blob([RRe]);
  return URL.createObjectURL(e);
}
function To(e, t) {
  sr && (Ce.info(e), t && lX(e));
}
function dg(e, t) {
  sr && (Ce.info(e), t && setTimeout(() => {
    lX(e);
  }, 0));
}
function lX(e) {
  Nu(
    {
      category: "console",
      data: {
        logger: "replay"
      },
      level: "info",
      message: e
    },
    { level: "info" }
  );
}
class eM extends Error {
  constructor() {
    super(`Event buffer exceeded maximum size of ${G6}.`);
  }
}
class uX {
  /** All the events that are buffered to be sent. */
  /** @inheritdoc */
  constructor() {
    this.events = [], this._totalSize = 0, this.hasCheckout = !1;
  }
  /** @inheritdoc */
  get hasEvents() {
    return this.events.length > 0;
  }
  /** @inheritdoc */
  get type() {
    return "sync";
  }
  /** @inheritdoc */
  destroy() {
    this.events = [];
  }
  /** @inheritdoc */
  async addEvent(t) {
    const n = JSON.stringify(t).length;
    if (this._totalSize += n, this._totalSize > G6)
      throw new eM();
    this.events.push(t);
  }
  /** @inheritdoc */
  finish() {
    return new Promise((t) => {
      const n = this.events;
      this.clear(), t(JSON.stringify(n));
    });
  }
  /** @inheritdoc */
  clear() {
    this.events = [], this._totalSize = 0, this.hasCheckout = !1;
  }
  /** @inheritdoc */
  getEarliestTimestamp() {
    const t = this.events.map((n) => n.timestamp).sort()[0];
    return t ? Z6(t) : null;
  }
}
class ORe {
  constructor(t) {
    this._worker = t, this._id = 0;
  }
  /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occured.
   */
  ensureReady() {
    return this._ensureReadyPromise ? this._ensureReadyPromise : (this._ensureReadyPromise = new Promise((t, n) => {
      this._worker.addEventListener(
        "message",
        ({ data: r }) => {
          r.success ? t() : n();
        },
        { once: !0 }
      ), this._worker.addEventListener(
        "error",
        (r) => {
          n(r);
        },
        { once: !0 }
      );
    }), this._ensureReadyPromise);
  }
  /**
   * Destroy the worker.
   */
  destroy() {
    To("[Replay] Destroying compression worker"), this._worker.terminate();
  }
  /**
   * Post message to worker and wait for response before resolving promise.
   */
  postMessage(t, n) {
    const r = this._getAndIncrementId();
    return new Promise((i, o) => {
      const a = ({ data: s }) => {
        const c = s;
        if (c.method === t && c.id === r) {
          if (this._worker.removeEventListener("message", a), !c.success) {
            sr && Ce.error("[Replay]", c.response), o(new Error("Error in compression worker"));
            return;
          }
          i(c.response);
        }
      };
      this._worker.addEventListener("message", a), this._worker.postMessage({ id: r, method: t, arg: n });
    });
  }
  /** Get the current ID and increment it for the next call. */
  _getAndIncrementId() {
    return this._id++;
  }
}
class MRe {
  /** @inheritdoc */
  constructor(t) {
    this._worker = new ORe(t), this._earliestTimestamp = null, this._totalSize = 0, this.hasCheckout = !1;
  }
  /** @inheritdoc */
  get hasEvents() {
    return !!this._earliestTimestamp;
  }
  /** @inheritdoc */
  get type() {
    return "worker";
  }
  /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occured.
   */
  ensureReady() {
    return this._worker.ensureReady();
  }
  /**
   * Destroy the event buffer.
   */
  destroy() {
    this._worker.destroy();
  }
  /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfuly received and processed by worker.
   */
  addEvent(t) {
    const n = Z6(t.timestamp);
    (!this._earliestTimestamp || n < this._earliestTimestamp) && (this._earliestTimestamp = n);
    const r = JSON.stringify(t);
    return this._totalSize += r.length, this._totalSize > G6 ? Promise.reject(new eM()) : this._sendEventToWorker(r);
  }
  /**
   * Finish the event buffer and return the compressed data.
   */
  finish() {
    return this._finishRequest();
  }
  /** @inheritdoc */
  clear() {
    this._earliestTimestamp = null, this._totalSize = 0, this.hasCheckout = !1, this._worker.postMessage("clear").then(null, (t) => {
      sr && Ce.warn('[Replay] Sending "clear" message to worker failed', t);
    });
  }
  /** @inheritdoc */
  getEarliestTimestamp() {
    return this._earliestTimestamp;
  }
  /**
   * Send the event to the worker.
   */
  _sendEventToWorker(t) {
    return this._worker.postMessage("addEvent", t);
  }
  /**
   * Finish the request and return the compressed data from the worker.
   */
  async _finishRequest() {
    const t = await this._worker.postMessage("finish");
    return this._earliestTimestamp = null, this._totalSize = 0, t;
  }
}
class kRe {
  constructor(t) {
    this._fallback = new uX(), this._compression = new MRe(t), this._used = this._fallback, this._ensureWorkerIsLoadedPromise = this._ensureWorkerIsLoaded();
  }
  /** @inheritdoc */
  get type() {
    return this._used.type;
  }
  /** @inheritDoc */
  get hasEvents() {
    return this._used.hasEvents;
  }
  /** @inheritdoc */
  get hasCheckout() {
    return this._used.hasCheckout;
  }
  /** @inheritdoc */
  set hasCheckout(t) {
    this._used.hasCheckout = t;
  }
  /** @inheritDoc */
  destroy() {
    this._fallback.destroy(), this._compression.destroy();
  }
  /** @inheritdoc */
  clear() {
    return this._used.clear();
  }
  /** @inheritdoc */
  getEarliestTimestamp() {
    return this._used.getEarliestTimestamp();
  }
  /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfully added.
   */
  addEvent(t) {
    return this._used.addEvent(t);
  }
  /** @inheritDoc */
  async finish() {
    return await this.ensureWorkerIsLoaded(), this._used.finish();
  }
  /** Ensure the worker has loaded. */
  ensureWorkerIsLoaded() {
    return this._ensureWorkerIsLoadedPromise;
  }
  /** Actually check if the worker has been loaded. */
  async _ensureWorkerIsLoaded() {
    try {
      await this._compression.ensureReady();
    } catch {
      To("[Replay] Failed to load the compression worker, falling back to simple buffer");
      return;
    }
    await this._switchToCompressionWorker();
  }
  /** Switch the used buffer to the compression worker. */
  async _switchToCompressionWorker() {
    const { events: t, hasCheckout: n } = this._fallback, r = [];
    for (const i of t)
      r.push(this._compression.addEvent(i));
    this._compression.hasCheckout = n, this._used = this._compression;
    try {
      await Promise.all(r);
    } catch (i) {
      sr && Ce.warn("[Replay] Failed to add events when switching buffers.", i);
    }
  }
}
function NRe({
  useCompression: e,
  workerUrl: t
}) {
  if (e && // eslint-disable-next-line no-restricted-globals
  window.Worker) {
    const n = DRe(t);
    if (n)
      return n;
  }
  return To("[Replay] Using simple buffer"), new uX();
}
function DRe(e) {
  try {
    const t = e || jRe();
    if (!t)
      return;
    To(`[Replay] Using compression worker${e ? ` from ${e}` : ""}`);
    const n = new Worker(t);
    return new kRe(n);
  } catch {
    To("[Replay] Failed to create compression worker");
  }
}
function jRe() {
  return typeof __SENTRY_EXCLUDE_REPLAY_WORKER__ > "u" || !__SENTRY_EXCLUDE_REPLAY_WORKER__ ? PRe() : "";
}
function tM() {
  try {
    return "sessionStorage" in hr && !!hr.sessionStorage;
  } catch {
    return !1;
  }
}
function LRe(e) {
  FRe(), e.session = void 0;
}
function FRe() {
  if (tM())
    try {
      hr.sessionStorage.removeItem(W6);
    } catch {
    }
}
function dX(e) {
  return e === void 0 ? !1 : Math.random() < e;
}
function fX(e) {
  const t = Date.now(), n = e.id || Kr(), r = e.started || t, i = e.lastActivity || t, o = e.segmentId || 0, a = e.sampled, s = e.previousSessionId;
  return {
    id: n,
    started: r,
    lastActivity: i,
    segmentId: o,
    sampled: a,
    previousSessionId: s
  };
}
function nM(e) {
  if (tM())
    try {
      hr.sessionStorage.setItem(W6, JSON.stringify(e));
    } catch {
    }
}
function VRe(e, t) {
  return dX(e) ? "session" : t ? "buffer" : !1;
}
function Lj({ sessionSampleRate: e, allowBuffering: t, stickySession: n = !1 }, { previousSessionId: r } = {}) {
  const i = VRe(e, t), o = fX({
    sampled: i,
    previousSessionId: r
  });
  return n && nM(o), o;
}
function BRe(e) {
  if (!tM())
    return null;
  try {
    const t = hr.sessionStorage.getItem(W6);
    if (!t)
      return null;
    const n = JSON.parse(t);
    return dg("[Replay] Loading existing session", e), fX(n);
  } catch {
    return null;
  }
}
function AA(e, t, n = +/* @__PURE__ */ new Date()) {
  return e === null || t === void 0 || t < 0 ? !0 : t === 0 ? !1 : e + t <= n;
}
function hX(e, {
  maxReplayDuration: t,
  sessionIdleExpire: n,
  targetTime: r = Date.now()
}) {
  return (
    // First, check that maximum session length has not been exceeded
    AA(e.started, t, r) || // check that the idle timeout has not been exceeded (i.e. user has
    // performed an action within the last `sessionIdleExpire` ms)
    AA(e.lastActivity, n, r)
  );
}
function gX(e, { sessionIdleExpire: t, maxReplayDuration: n }) {
  return !(!hX(e, { sessionIdleExpire: t, maxReplayDuration: n }) || e.sampled === "buffer" && e.segmentId === 0);
}
function rT({
  traceInternals: e,
  sessionIdleExpire: t,
  maxReplayDuration: n,
  previousSessionId: r
}, i) {
  const o = i.stickySession && BRe(e);
  return o ? gX(o, { sessionIdleExpire: t, maxReplayDuration: n }) ? (dg("[Replay] Session in sessionStorage is expired, creating new one..."), Lj(i, { previousSessionId: o.id })) : o : (dg("[Replay] Creating new session", e), Lj(i, { previousSessionId: r }));
}
function zRe(e) {
  return e.type === fn.Custom;
}
function rM(e, t, n) {
  return mX(e, t) ? (pX(e, t, n), !0) : !1;
}
function HRe(e, t, n) {
  return mX(e, t) ? pX(e, t, n) : Promise.resolve(null);
}
async function pX(e, t, n) {
  if (!e.eventBuffer)
    return null;
  try {
    n && e.recordingMode === "buffer" && e.eventBuffer.clear(), n && (e.eventBuffer.hasCheckout = !0);
    const r = e.getOptions(), i = URe(t, r.beforeAddRecordingEvent);
    return i ? await e.eventBuffer.addEvent(i) : void 0;
  } catch (r) {
    const i = r && r instanceof eM ? "addEventSizeExceeded" : "addEvent";
    sr && Ce.error(r), await e.stop({ reason: i });
    const o = Jn();
    o && o.recordDroppedEvent("internal_sdk_error", "replay");
  }
}
function mX(e, t) {
  if (!e.eventBuffer || e.isPaused() || !e.isEnabled())
    return !1;
  const n = Z6(t.timestamp);
  return n + e.timeouts.sessionIdlePause < Date.now() ? !1 : n > e.getContext().initialTimestamp + e.getOptions().maxReplayDuration ? (To(
    `[Replay] Skipping event with timestamp ${n} because it is after maxReplayDuration`,
    e.getOptions()._experiments.traceInternals
  ), !1) : !0;
}
function URe(e, t) {
  try {
    if (typeof t == "function" && zRe(e))
      return t(e);
  } catch (n) {
    return sr && Ce.error("[Replay] An error occured in the `beforeAddRecordingEvent` callback, skipping the event...", n), null;
  }
  return e;
}
function iM(e) {
  return !e.type;
}
function RA(e) {
  return e.type === "transaction";
}
function WRe(e) {
  return e.type === "replay_event";
}
function Fj(e) {
  return e.type === "feedback";
}
function vX(e) {
  const t = KRe();
  return (n, r) => {
    if (!e.isEnabled() || !iM(n) && !RA(n))
      return;
    const i = r && r.statusCode;
    if (!(t && (!i || i < 200 || i >= 300))) {
      if (RA(n)) {
        qRe(e, n);
        return;
      }
      GRe(e, n);
    }
  };
}
function qRe(e, t) {
  const n = e.getContext();
  t.contexts && t.contexts.trace && t.contexts.trace.trace_id && n.traceIds.size < 100 && n.traceIds.add(t.contexts.trace.trace_id);
}
function GRe(e, t) {
  const n = e.getContext();
  if (t.event_id && n.errorIds.size < 100 && n.errorIds.add(t.event_id), e.recordingMode !== "buffer" || !t.tags || !t.tags.replayId)
    return;
  const { beforeErrorSampling: r } = e.getOptions();
  typeof r == "function" && !r(t) || setTimeout(() => {
    e.sendBufferedReplayOrFlush();
  });
}
function KRe() {
  const e = Jn();
  if (!e)
    return !1;
  const t = e.getTransport();
  return t && t.send.__sentry__baseTransport__ || !1;
}
function YRe(e) {
  return (t) => {
    !e.isEnabled() || !iM(t) || XRe(e, t);
  };
}
function XRe(e, t) {
  const n = t.exception && t.exception.values && t.exception.values[0].value;
  if (typeof n == "string" && // Only matches errors in production builds of react-dom
  // Example https://reactjs.org/docs/error-decoder.html?invariant=423
  (n.match(/reactjs\.org\/docs\/error-decoder\.html\?invariant=(418|419|422|423|425)/) || // Development builds of react-dom
  // Error 1: Hydration failed because the initial UI does not match what was rendered on the server.
  // Error 2: Text content does not match server-rendered HTML. Warning: Text content did not match.
  n.match(/(does not match server-rendered HTML|Hydration failed because)/i))) {
    const r = nc({
      category: "replay.hydrate-error"
    });
    Ty(e, r);
  }
}
function QRe(e, t) {
  return e.type || !e.exception || !e.exception.values || !e.exception.values.length ? !1 : !!(t.originalException && t.originalException.__rrweb__);
}
function JRe(e, t) {
  e.triggerUserActivity(), e.addUpdate(() => t.timestamp ? (e.throttledAddEvent({
    type: fn.Custom,
    timestamp: t.timestamp * 1e3,
    data: {
      tag: "breadcrumb",
      payload: {
        timestamp: t.timestamp,
        type: "default",
        category: "sentry.feedback",
        data: {
          feedbackId: t.event_id
        }
      }
    }
  }), !1) : !0);
}
function ZRe(e, t) {
  return e.recordingMode !== "buffer" || t.message === q6 || !t.exception || t.type ? !1 : dX(e.getOptions().errorSampleRate);
}
function ePe(e, t = !1) {
  const n = t ? vX(e) : void 0;
  return Object.assign(
    (r, i) => e.isEnabled() ? WRe(r) ? (delete r.breadcrumbs, r) : !iM(r) && !RA(r) && !Fj(r) || !e.checkAndHandleExpiredSession() ? r : Fj(r) ? (e.flush(), r.contexts.feedback.replay_id = e.getSessionId(), JRe(e, r), r) : QRe(r, i) && !e.getOptions()._experiments.captureExceptions ? (sr && Ce.log("[Replay] Ignoring error from rrweb internals", r), null) : ((ZRe(e, r) || e.recordingMode === "session") && (r.tags = { ...r.tags, replayId: e.getSessionId() }), n && n(r, { statusCode: 200 }), r) : r,
    { id: "Replay" }
  );
}
function CE(e, t) {
  return t.map(({ type: n, start: r, end: i, name: o, data: a }) => {
    const s = e.throttledAddEvent({
      type: fn.Custom,
      timestamp: r,
      data: {
        tag: "performanceSpan",
        payload: {
          op: n,
          description: o,
          startTimestamp: r,
          endTimestamp: i,
          data: a
        }
      }
    });
    return typeof s == "string" ? Promise.resolve(null) : s;
  });
}
function tPe(e) {
  const { from: t, to: n } = e, r = Date.now() / 1e3;
  return {
    type: "navigation.push",
    start: r,
    end: r,
    name: n,
    data: {
      previous: t
    }
  };
}
function nPe(e) {
  return (t) => {
    if (!e.isEnabled())
      return;
    const n = tPe(t);
    n !== null && (e.getContext().urls.push(n.name), e.triggerUserActivity(), e.addUpdate(() => (CE(e, [n]), !1)));
  };
}
function rPe(e, t) {
  return sr && e.getOptions()._experiments.traceInternals ? !1 : eTe(t, Jn());
}
function TE(e, t) {
  e.isEnabled() && t !== null && (rPe(e, t.name) || e.addUpdate(() => (CE(e, [t]), !0)));
}
function iPe(e) {
  const { startTimestamp: t, endTimestamp: n, fetchData: r, response: i } = e;
  if (!n)
    return null;
  const { method: o, url: a } = r;
  return {
    type: "resource.fetch",
    start: t / 1e3,
    end: n / 1e3,
    name: a,
    data: {
      method: o,
      statusCode: i ? i.status : void 0
    }
  };
}
function oPe(e) {
  return (t) => {
    if (!e.isEnabled())
      return;
    const n = iPe(t);
    TE(e, n);
  };
}
function aPe(e) {
  const { startTimestamp: t, endTimestamp: n, xhr: r } = e, i = r[tu];
  if (!t || !n || !i)
    return null;
  const { method: o, url: a, status_code: s } = i;
  return a === void 0 ? null : {
    type: "resource.xhr",
    name: a,
    start: t / 1e3,
    end: n / 1e3,
    data: {
      method: o,
      statusCode: s
    }
  };
}
function sPe(e) {
  return (t) => {
    if (!e.isEnabled())
      return;
    const n = aPe(t);
    TE(e, n);
  };
}
function IE(e, t) {
  if (e)
    try {
      if (typeof e == "string")
        return t.encode(e).length;
      if (e instanceof URLSearchParams)
        return t.encode(e.toString()).length;
      if (e instanceof FormData) {
        const n = SX(e);
        return t.encode(n).length;
      }
      if (e instanceof Blob)
        return e.size;
      if (e instanceof ArrayBuffer)
        return e.byteLength;
    } catch {
    }
}
function yX(e) {
  if (!e)
    return;
  const t = parseInt(e, 10);
  return isNaN(t) ? void 0 : t;
}
function bX(e) {
  try {
    if (typeof e == "string")
      return [e];
    if (e instanceof URLSearchParams)
      return [e.toString()];
    if (e instanceof FormData)
      return [SX(e)];
    if (!e)
      return [void 0];
  } catch {
    return sr && Ce.warn("[Replay] Failed to serialize body", e), [void 0, "BODY_PARSE_ERROR"];
  }
  return sr && Ce.info("[Replay] Skipping network body because of body type", e), [void 0, "UNPARSEABLE_BODY_TYPE"];
}
function TS(e, t) {
  if (!e)
    return {
      headers: {},
      size: void 0,
      _meta: {
        warnings: [t]
      }
    };
  const n = { ...e._meta }, r = n.warnings || [];
  return n.warnings = [...r, t], e._meta = n, e;
}
function _X(e, t) {
  if (!t)
    return null;
  const { startTimestamp: n, endTimestamp: r, url: i, method: o, statusCode: a, request: s, response: c } = t;
  return {
    type: e,
    start: n / 1e3,
    end: r / 1e3,
    name: i,
    data: Po({
      method: o,
      statusCode: a,
      request: s,
      response: c
    })
  };
}
function bv(e) {
  return {
    headers: {},
    size: e,
    _meta: {
      warnings: ["URL_SKIPPED"]
    }
  };
}
function vu(e, t, n) {
  if (!t && Object.keys(e).length === 0)
    return;
  if (!t)
    return {
      headers: e
    };
  if (!n)
    return {
      headers: e,
      size: t
    };
  const r = {
    headers: e,
    size: t
  }, { body: i, warnings: o } = cPe(n);
  return r.body = i, o && o.length > 0 && (r._meta = {
    warnings: o
  }), r;
}
function PA(e, t) {
  return Object.keys(e).reduce((n, r) => {
    const i = r.toLowerCase();
    return t.includes(i) && e[r] && (n[i] = e[r]), n;
  }, {});
}
function SX(e) {
  return new URLSearchParams(e).toString();
}
function cPe(e) {
  if (!e || typeof e != "string")
    return {
      body: e
    };
  const t = e.length > xj, n = lPe(e);
  if (t) {
    const r = e.slice(0, xj);
    return n ? {
      body: r,
      warnings: ["MAYBE_JSON_TRUNCATED"]
    } : {
      body: `${r}…`,
      warnings: ["TEXT_TRUNCATED"]
    };
  }
  if (n)
    try {
      return {
        body: JSON.parse(e)
      };
    } catch {
    }
  return {
    body: e
  };
}
function lPe(e) {
  const t = e[0], n = e[e.length - 1];
  return t === "[" && n === "]" || t === "{" && n === "}";
}
function IS(e, t) {
  const n = uPe(e);
  return Vp(n, t);
}
function uPe(e, t = hr.document.baseURI) {
  if (e.startsWith("http://") || e.startsWith("https://") || e.startsWith(hr.location.origin))
    return e;
  const n = new URL(e, t);
  if (n.origin !== new URL(t).origin)
    return e;
  const r = n.href;
  return !e.endsWith("/") && r.endsWith("/") ? r.slice(0, -1) : r;
}
async function dPe(e, t, n) {
  try {
    const r = await hPe(e, t, n), i = _X("resource.fetch", r);
    TE(n.replay, i);
  } catch (r) {
    sr && Ce.error("[Replay] Failed to capture fetch breadcrumb", r);
  }
}
function fPe(e, t, n) {
  const { input: r, response: i } = t, o = r ? wX(r) : void 0, a = IE(o, n.textEncoder), s = i ? yX(i.headers.get("content-length")) : void 0;
  a !== void 0 && (e.data.request_body_size = a), s !== void 0 && (e.data.response_body_size = s);
}
async function hPe(e, t, n) {
  const r = Date.now(), { startTimestamp: i = r, endTimestamp: o = r } = t, {
    url: a,
    method: s,
    status_code: c = 0,
    request_body_size: l,
    response_body_size: u
  } = e.data, d = IS(a, n.networkDetailAllowUrls) && !IS(a, n.networkDetailDenyUrls), f = d ? gPe(n, t.input, l) : bv(l), h = await pPe(d, n, t.response, u);
  return {
    startTimestamp: i,
    endTimestamp: o,
    url: a,
    method: s,
    statusCode: c,
    request: f,
    response: h
  };
}
function gPe({ networkCaptureBodies: e, networkRequestHeaders: t }, n, r) {
  const i = n ? yPe(n, t) : {};
  if (!e)
    return vu(i, r, void 0);
  const o = wX(n), [a, s] = bX(o), c = vu(i, r, a);
  return s ? TS(c, s) : c;
}
async function pPe(e, {
  networkCaptureBodies: t,
  textEncoder: n,
  networkResponseHeaders: r
}, i, o) {
  if (!e && o !== void 0)
    return bv(o);
  const a = i ? xX(i.headers, r) : {};
  if (!i || !t && o !== void 0)
    return vu(a, o, void 0);
  const [s, c] = await vPe(i), l = mPe(s, {
    networkCaptureBodies: t,
    textEncoder: n,
    responseBodySize: o,
    captureDetails: e,
    headers: a
  });
  return c ? TS(l, c) : l;
}
function mPe(e, {
  networkCaptureBodies: t,
  textEncoder: n,
  responseBodySize: r,
  captureDetails: i,
  headers: o
}) {
  try {
    const a = e && e.length && r === void 0 ? IE(e, n) : r;
    return i ? t ? vu(o, a, e) : vu(o, a, void 0) : bv(a);
  } catch (a) {
    return sr && Ce.warn("[Replay] Failed to serialize response body", a), vu(o, r, void 0);
  }
}
async function vPe(e) {
  const t = bPe(e);
  if (!t)
    return [void 0, "BODY_PARSE_ERROR"];
  try {
    return [await _Pe(t)];
  } catch (n) {
    return sr && Ce.warn("[Replay] Failed to get text body from response", n), [void 0, "BODY_PARSE_ERROR"];
  }
}
function wX(e = []) {
  if (!(e.length !== 2 || typeof e[1] != "object"))
    return e[1].body;
}
function xX(e, t) {
  const n = {};
  return t.forEach((r) => {
    e.get(r) && (n[r] = e.get(r));
  }), n;
}
function yPe(e, t) {
  return e.length === 1 && typeof e[0] != "string" ? Vj(e[0], t) : e.length === 2 ? Vj(e[1], t) : {};
}
function Vj(e, t) {
  if (!e)
    return {};
  const n = e.headers;
  return n ? n instanceof Headers ? xX(n, t) : Array.isArray(n) ? {} : PA(n, t) : {};
}
function bPe(e) {
  try {
    return e.clone();
  } catch (t) {
    sr && Ce.warn("[Replay] Failed to clone response body", t);
  }
}
function _Pe(e) {
  return new Promise((t, n) => {
    const r = setTimeout(() => n(new Error("Timeout while trying to read response body")), 500);
    SPe(e).then(
      (i) => t(i),
      (i) => n(i)
    ).finally(() => clearTimeout(r));
  });
}
async function SPe(e) {
  return await e.text();
}
async function wPe(e, t, n) {
  try {
    const r = EPe(e, t, n), i = _X("resource.xhr", r);
    TE(n.replay, i);
  } catch (r) {
    sr && Ce.error("[Replay] Failed to capture xhr breadcrumb", r);
  }
}
function xPe(e, t, n) {
  const { xhr: r, input: i } = t;
  if (!r)
    return;
  const o = IE(i, n.textEncoder), a = r.getResponseHeader("content-length") ? yX(r.getResponseHeader("content-length")) : $Pe(r.response, r.responseType, n.textEncoder);
  o !== void 0 && (e.data.request_body_size = o), a !== void 0 && (e.data.response_body_size = a);
}
function EPe(e, t, n) {
  const r = Date.now(), { startTimestamp: i = r, endTimestamp: o = r, input: a, xhr: s } = t, {
    url: c,
    method: l,
    status_code: u = 0,
    request_body_size: d,
    response_body_size: f
  } = e.data;
  if (!c)
    return null;
  if (!s || !IS(c, n.networkDetailAllowUrls) || IS(c, n.networkDetailDenyUrls)) {
    const C = bv(d), x = bv(f);
    return {
      startTimestamp: i,
      endTimestamp: o,
      url: c,
      method: l,
      statusCode: u,
      request: C,
      response: x
    };
  }
  const h = s[tu], p = h ? PA(h.request_headers, n.networkRequestHeaders) : {}, g = PA(CPe(s), n.networkResponseHeaders), [m, v] = n.networkCaptureBodies ? bX(a) : [void 0], [y, _] = n.networkCaptureBodies ? TPe(s) : [void 0], b = vu(p, d, m), w = vu(g, f, y);
  return {
    startTimestamp: i,
    endTimestamp: o,
    url: c,
    method: l,
    statusCode: u,
    request: v ? TS(b, v) : b,
    response: _ ? TS(w, _) : w
  };
}
function CPe(e) {
  const t = e.getAllResponseHeaders();
  return t ? t.split(`\r
`).reduce((n, r) => {
    const [i, o] = r.split(": ");
    return n[i.toLowerCase()] = o, n;
  }, {}) : {};
}
function TPe(e) {
  const t = [];
  try {
    return [e.responseText];
  } catch (n) {
    t.push(n);
  }
  try {
    return IPe(e.response, e.responseType);
  } catch (n) {
    t.push(n);
  }
  return sr && Ce.warn("[Replay] Failed to get xhr response body", ...t), [void 0];
}
function IPe(e, t) {
  try {
    if (typeof e == "string")
      return [e];
    if (e instanceof Document)
      return [e.body.outerHTML];
    if (t === "json" && e && typeof e == "object")
      return [JSON.stringify(e)];
    if (!e)
      return [void 0];
  } catch {
    return sr && Ce.warn("[Replay] Failed to serialize body", e), [void 0, "BODY_PARSE_ERROR"];
  }
  return sr && Ce.info("[Replay] Skipping network body because of body type", e), [void 0, "UNPARSEABLE_BODY_TYPE"];
}
function $Pe(e, t, n) {
  try {
    const r = t === "json" && e && typeof e == "object" ? JSON.stringify(e) : e;
    return IE(r, n);
  } catch {
    return;
  }
}
function APe(e) {
  const t = Jn();
  try {
    const n = new TextEncoder(), {
      networkDetailAllowUrls: r,
      networkDetailDenyUrls: i,
      networkCaptureBodies: o,
      networkRequestHeaders: a,
      networkResponseHeaders: s
    } = e.getOptions(), c = {
      replay: e,
      textEncoder: n,
      networkDetailAllowUrls: r,
      networkDetailDenyUrls: i,
      networkCaptureBodies: o,
      networkRequestHeaders: a,
      networkResponseHeaders: s
    };
    t && t.on ? t.on("beforeAddBreadcrumb", (l, u) => RPe(c, l, u)) : (R6(oPe(e)), P6(sPe(e)));
  } catch {
  }
}
function RPe(e, t, n) {
  if (t.data)
    try {
      PPe(t) && MPe(n) && (xPe(t, n, e), wPe(t, n, e)), OPe(t) && kPe(n) && (fPe(t, n, e), dPe(t, n, e));
    } catch {
      sr && Ce.warn("Error when enriching network breadcrumb");
    }
}
function PPe(e) {
  return e.category === "xhr";
}
function OPe(e) {
  return e.category === "fetch";
}
function MPe(e) {
  return e && e.xhr;
}
function kPe(e) {
  return e && e.response;
}
let Bj = null;
function NPe(e) {
  return !!e.category;
}
const DPe = (e) => (t) => {
  if (!e.isEnabled())
    return;
  const n = jPe(t);
  n && Ty(e, n);
};
function jPe(e) {
  const t = e.getLastBreadcrumb && e.getLastBreadcrumb();
  return Bj === t || !t || (Bj = t, !NPe(t) || ["fetch", "xhr", "sentry.event", "sentry.transaction"].includes(t.category) || t.category.startsWith("ui.")) ? null : t.category === "console" ? LPe(t) : nc(t);
}
function LPe(e) {
  const t = e.data && e.data.arguments;
  if (!Array.isArray(t) || t.length === 0)
    return nc(e);
  let n = !1;
  const r = t.map((i) => {
    if (!i)
      return i;
    if (typeof i == "string")
      return i.length > t1 ? (n = !0, `${i.slice(0, t1)}…`) : i;
    if (typeof i == "object")
      try {
        const o = Qs(i, 7);
        return JSON.stringify(o).length > t1 ? (n = !0, `${JSON.stringify(o, null, 2).slice(0, t1)}…`) : o;
      } catch {
      }
    return i;
  });
  return nc({
    ...e,
    data: {
      ...e.data,
      arguments: r,
      ...n ? { _meta: { warnings: ["CONSOLE_ARG_TRUNCATED"] } } : {}
    }
  });
}
function FPe(e) {
  const t = Ta(), n = Jn();
  t.addScopeListener(DPe(e)), TK(mRe(e)), gE(nPe(e)), APe(e);
  const r = ePe(e, !zj(n));
  n && n.addEventProcessor ? n.addEventProcessor(r) : G5e(r), zj(n) && (n.on("beforeSendEvent", YRe(e)), n.on("afterSendEvent", vX(e)), n.on("createDsc", (i) => {
    const o = e.getSessionId();
    o && e.isEnabled() && e.recordingMode === "session" && e.checkAndHandleExpiredSession() && (i.replay_id = o);
  }), n.on("startTransaction", (i) => {
    e.lastTransaction = i;
  }), n.on("finishTransaction", (i) => {
    e.lastTransaction = i;
  }), n.on("beforeSendFeedback", (i, o) => {
    const a = e.getSessionId();
    o && o.includeReplay && e.isEnabled() && a && i.contexts && i.contexts.feedback && (i.contexts.feedback.replay_id = a);
  }));
}
function zj(e) {
  return !!(e && e.on);
}
async function VPe(e) {
  try {
    return Promise.all(
      CE(e, [
        // @ts-expect-error memory doesn't exist on type Performance as the API is non-standard (we check that it exists above)
        BPe(hr.performance.memory)
      ])
    );
  } catch {
    return [];
  }
}
function BPe(e) {
  const { jsHeapSizeLimit: t, totalJSHeapSize: n, usedJSHeapSize: r } = e, i = Date.now() / 1e3;
  return {
    type: "memory",
    name: "memory",
    start: i,
    end: i,
    data: {
      memory: {
        jsHeapSizeLimit: t,
        totalJSHeapSize: n,
        usedJSHeapSize: r
      }
    }
  };
}
function zPe(e, t, n) {
  let r, i, o;
  const a = n && n.maxWait ? Math.max(n.maxWait, t) : 0;
  function s() {
    return c(), r = e(), r;
  }
  function c() {
    i !== void 0 && clearTimeout(i), o !== void 0 && clearTimeout(o), i = o = void 0;
  }
  function l() {
    return i !== void 0 || o !== void 0 ? s() : r;
  }
  function u() {
    return i && clearTimeout(i), i = setTimeout(s, t), a && o === void 0 && (o = setTimeout(s, a)), r;
  }
  return u.cancel = c, u.flush = l, u;
}
function HPe(e) {
  let t = !1;
  return (n, r) => {
    if (!e.checkAndHandleExpiredSession()) {
      sr && Ce.warn("[Replay] Received replay event after session expired.");
      return;
    }
    const i = r || !t;
    t = !0, e.clickDetector && dRe(e.clickDetector, n), e.addUpdate(() => {
      if (e.recordingMode === "buffer" && i && e.setInitialState(), !rM(e, n, i))
        return !0;
      if (!i)
        return !1;
      if (WPe(e, i), e.session && e.session.previousSessionId)
        return !0;
      if (e.recordingMode === "buffer" && e.session && e.eventBuffer) {
        const o = e.eventBuffer.getEarliestTimestamp();
        o && (To(
          `[Replay] Updating session start time to earliest event in buffer to ${new Date(o)}`,
          e.getOptions()._experiments.traceInternals
        ), e.session.started = o, e.getOptions().stickySession && nM(e.session));
      }
      return e.recordingMode === "session" && e.flush(), !0;
    });
  };
}
function UPe(e) {
  const t = e.getOptions();
  return {
    type: fn.Custom,
    timestamp: Date.now(),
    data: {
      tag: "options",
      payload: {
        shouldRecordCanvas: e.isRecordingCanvas(),
        sessionSampleRate: t.sessionSampleRate,
        errorSampleRate: t.errorSampleRate,
        useCompressionOption: t.useCompression,
        blockAllMedia: t.blockAllMedia,
        maskAllText: t.maskAllText,
        maskAllInputs: t.maskAllInputs,
        useCompression: e.eventBuffer ? e.eventBuffer.type === "worker" : !1,
        networkDetailHasUrls: t.networkDetailAllowUrls.length > 0,
        networkCaptureBodies: t.networkCaptureBodies,
        networkRequestHasHeaders: t.networkRequestHeaders.length > 0,
        networkResponseHasHeaders: t.networkResponseHeaders.length > 0
      }
    }
  };
}
function WPe(e, t) {
  !t || !e.session || e.session.segmentId !== 0 || rM(e, UPe(e), !1);
}
function qPe(e, t, n, r) {
  return ed(
    kK(e, k6(e), r, n),
    [
      [{ type: "replay_event" }, e],
      [
        {
          type: "replay_recording",
          // If string then we need to encode to UTF8, otherwise will have
          // wrong size. TextEncoder has similar browser support to
          // MutationObserver, although it does not accept IE11.
          length: typeof t == "string" ? new TextEncoder().encode(t).length : t.length
        },
        t
      ]
    ]
  );
}
function GPe({
  recordingData: e,
  headers: t
}) {
  let n;
  const r = `${JSON.stringify(t)}
`;
  if (typeof e == "string")
    n = `${r}${e}`;
  else {
    const o = new TextEncoder().encode(r);
    n = new Uint8Array(o.length + e.length), n.set(o), n.set(e, o.length);
  }
  return n;
}
async function KPe({
  client: e,
  scope: t,
  replayId: n,
  event: r
}) {
  const i = typeof e._integrations == "object" && e._integrations !== null && !Array.isArray(e._integrations) ? Object.keys(e._integrations) : void 0, o = { event_id: n, integrations: i };
  e.emit && e.emit("preprocessEvent", r, o);
  const a = await VK(
    e.getOptions(),
    r,
    o,
    t,
    e,
    td()
  );
  if (!a)
    return null;
  a.platform = a.platform || "javascript";
  const s = e.getSdkMetadata && e.getSdkMetadata(), { name: c, version: l } = s && s.sdk || {};
  return a.sdk = {
    ...a.sdk,
    name: c || "sentry.javascript.unknown",
    version: l || "0.0.0"
  }, a;
}
async function YPe({
  recordingData: e,
  replayId: t,
  segmentId: n,
  eventContext: r,
  timestamp: i,
  session: o
}) {
  const a = GPe({
    recordingData: e,
    headers: {
      segment_id: n
    }
  }), { urls: s, errorIds: c, traceIds: l, initialTimestamp: u } = r, d = Jn(), f = Ta(), h = d && d.getTransport(), p = d && d.getDsn();
  if (!d || !h || !p || !o.sampled)
    return;
  const g = {
    type: M$e,
    replay_start_timestamp: u / 1e3,
    timestamp: i / 1e3,
    error_ids: c,
    trace_ids: l,
    urls: s,
    replay_id: t,
    segment_id: n,
    replay_type: o.sampled
  }, m = await KPe({ scope: f, client: d, replayId: t, event: g });
  if (!m) {
    d.recordDroppedEvent("event_processor", "replay", g), To("An event processor returned `null`, will not send event.");
    return;
  }
  delete m.sdkProcessingMetadata;
  const v = qPe(m, a, p, d.getOptions().tunnel);
  let y;
  try {
    y = await h.send(v);
  } catch (b) {
    const w = new Error(q6);
    try {
      w.cause = b;
    } catch {
    }
    throw w;
  }
  if (!y)
    return y;
  if (typeof y.statusCode == "number" && (y.statusCode < 200 || y.statusCode >= 300))
    throw new EX(y.statusCode);
  const _ = DK({}, y);
  if (NK(_, "replay"))
    throw new CX(_);
  return y;
}
class EX extends Error {
  constructor(t) {
    super(`Transport returned status code ${t}`);
  }
}
class CX extends Error {
  constructor(t) {
    super("Rate limit hit"), this.rateLimits = t;
  }
}
async function TX(e, t = {
  count: 0,
  interval: F$e
}) {
  const { recordingData: n, options: r } = e;
  if (n.length)
    try {
      return await YPe(e), !0;
    } catch (i) {
      if (i instanceof EX || i instanceof CX)
        throw i;
      if (n5e("Replays", {
        _retryCount: t.count
      }), sr && r._experiments && r._experiments.captureExceptions && yE(i), t.count >= V$e) {
        const o = new Error(`${q6} - max retries exceeded`);
        try {
          o.cause = i;
        } catch {
        }
        throw o;
      }
      return t.interval *= ++t.count, new Promise((o, a) => {
        setTimeout(async () => {
          try {
            await TX(e, t), o(!0);
          } catch (s) {
            a(s);
          }
        }, t.interval);
      });
    }
}
const IX = "__THROTTLED", XPe = "__SKIPPED";
function QPe(e, t, n) {
  const r = /* @__PURE__ */ new Map(), i = (s) => {
    const c = s - n;
    r.forEach((l, u) => {
      u < c && r.delete(u);
    });
  }, o = () => [...r.values()].reduce((s, c) => s + c, 0);
  let a = !1;
  return (...s) => {
    const c = Math.floor(Date.now() / 1e3);
    if (i(c), o() >= t) {
      const u = a;
      return a = !0, u ? XPe : IX;
    }
    a = !1;
    const l = r.get(c) || 0;
    return r.set(c, l + 1), e(...s);
  };
}
class Ul {
  /**
   * Recording can happen in one of three modes:
   *   - session: Record the whole session, sending it continuously
   *   - buffer: Always keep the last 60s of recording, requires:
   *     - having replaysOnErrorSampleRate > 0 to capture replay when an error occurs
   *     - or calling `flush()` to send the replay
   */
  /**
   * The current or last active transcation.
   * This is only available when performance is enabled.
   */
  /**
   * These are here so we can overwrite them in tests etc.
   * @hidden
   */
  /**
   * Options to pass to `rrweb.record()`
   */
  /**
   * Timestamp of the last user activity. This lives across sessions.
   */
  /**
   * Is the integration currently active?
   */
  /**
   * Paused is a state where:
   * - DOM Recording is not listening at all
   * - Nothing will be added to event buffer (e.g. core SDK events)
   */
  /**
   * Have we attached listeners to the core SDK?
   * Note we have to track this as there is no way to remove instrumentation handlers.
   */
  /**
   * Function to stop recording
   */
  /**
   * Internal use for canvas recording options
   */
  constructor({
    options: t,
    recordingOptions: n
  }) {
    Ul.prototype.__init.call(this), Ul.prototype.__init2.call(this), Ul.prototype.__init3.call(this), Ul.prototype.__init4.call(this), Ul.prototype.__init5.call(this), Ul.prototype.__init6.call(this), this.eventBuffer = null, this.performanceEntries = [], this.replayPerformanceEntries = [], this.recordingMode = "session", this.timeouts = {
      sessionIdlePause: k$e,
      sessionIdleExpire: N$e
    }, this._lastActivity = Date.now(), this._isEnabled = !1, this._isPaused = !1, this._hasInitializedCoreListeners = !1, this._context = {
      errorIds: /* @__PURE__ */ new Set(),
      traceIds: /* @__PURE__ */ new Set(),
      urls: [],
      initialTimestamp: Date.now(),
      initialUrl: ""
    }, this._recordingOptions = n, this._options = t, this._debouncedFlush = zPe(() => this._flush(), this._options.flushMinDelay, {
      maxWait: this._options.flushMaxDelay
    }), this._throttledAddEvent = QPe(
      (a, s) => HRe(this, a, s),
      // Max 300 events...
      300,
      // ... per 5s
      5
    );
    const { slowClickTimeout: r, slowClickIgnoreSelectors: i } = this.getOptions(), o = r ? {
      threshold: Math.min(B$e, r),
      timeout: r,
      scrollTimeout: z$e,
      ignoreSelector: i ? i.join(",") : ""
    } : void 0;
    o && (this.clickDetector = new sRe(this, o));
  }
  /** Get the event context. */
  getContext() {
    return this._context;
  }
  /** If recording is currently enabled. */
  isEnabled() {
    return this._isEnabled;
  }
  /** If recording is currently paused. */
  isPaused() {
    return this._isPaused;
  }
  /**
   * Determine if canvas recording is enabled
   */
  isRecordingCanvas() {
    return !!this._canvas;
  }
  /** Get the replay integration options. */
  getOptions() {
    return this._options;
  }
  /**
   * Initializes the plugin based on sampling configuration. Should not be
   * called outside of constructor.
   */
  initializeSampling(t) {
    const { errorSampleRate: n, sessionSampleRate: r } = this._options;
    if (!(n <= 0 && r <= 0)) {
      if (this._initializeSessionForSampling(t), !this.session) {
        this._handleException(new Error("Unable to initialize and create session"));
        return;
      }
      this.session.sampled !== !1 && (this.recordingMode = this.session.sampled === "buffer" && this.session.segmentId === 0 ? "buffer" : "session", dg(
        `[Replay] Starting replay in ${this.recordingMode} mode`,
        this._options._experiments.traceInternals
      ), this._initializeRecording());
    }
  }
  /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will throw an error if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * _performanceObserver, Recording, Sentry SDK, etc)
   */
  start() {
    if (this._isEnabled && this.recordingMode === "session")
      throw new Error("Replay recording is already in progress");
    if (this._isEnabled && this.recordingMode === "buffer")
      throw new Error("Replay buffering is in progress, call `flush()` to save the replay");
    dg("[Replay] Starting replay in session mode", this._options._experiments.traceInternals), this._updateUserActivity();
    const t = rT(
      {
        maxReplayDuration: this._options.maxReplayDuration,
        sessionIdleExpire: this.timeouts.sessionIdleExpire,
        traceInternals: this._options._experiments.traceInternals
      },
      {
        stickySession: this._options.stickySession,
        // This is intentional: create a new session-based replay when calling `start()`
        sessionSampleRate: 1,
        allowBuffering: !1
      }
    );
    this.session = t, this._initializeRecording();
  }
  /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, an error occurs.
   */
  startBuffering() {
    if (this._isEnabled)
      throw new Error("Replay recording is already in progress");
    dg("[Replay] Starting replay in buffer mode", this._options._experiments.traceInternals);
    const t = rT(
      {
        sessionIdleExpire: this.timeouts.sessionIdleExpire,
        maxReplayDuration: this._options.maxReplayDuration,
        traceInternals: this._options._experiments.traceInternals
      },
      {
        stickySession: this._options.stickySession,
        sessionSampleRate: 0,
        allowBuffering: !0
      }
    );
    this.session = t, this.recordingMode = "buffer", this._initializeRecording();
  }
  /**
   * Start recording.
   *
   * Note that this will cause a new DOM checkout
   */
  startRecording() {
    try {
      const t = this._canvas;
      this._stopRecording = mu({
        ...this._recordingOptions,
        // When running in error sampling mode, we need to overwrite `checkoutEveryNms`
        // Without this, it would record forever, until an error happens, which we don't want
        // instead, we'll always keep the last 60 seconds of replay before an error happened
        ...this.recordingMode === "buffer" && { checkoutEveryNms: L$e },
        emit: HPe(this),
        onMutation: this._onMutationHandler,
        ...t ? {
          recordCanvas: t.recordCanvas,
          getCanvasManager: t.getCanvasManager,
          sampling: t.sampling,
          dataURLOptions: t.dataURLOptions
        } : {}
      });
    } catch (t) {
      this._handleException(t);
    }
  }
  /**
   * Stops the recording, if it was running.
   *
   * Returns true if it was previously stopped, or is now stopped,
   * otherwise false.
   */
  stopRecording() {
    try {
      return this._stopRecording && (this._stopRecording(), this._stopRecording = void 0), !0;
    } catch (t) {
      return this._handleException(t), !1;
    }
  }
  /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */
  async stop({ forceFlush: t = !1, reason: n } = {}) {
    if (this._isEnabled) {
      this._isEnabled = !1;
      try {
        To(
          `[Replay] Stopping Replay${n ? ` triggered by ${n}` : ""}`,
          this._options._experiments.traceInternals
        ), this._removeListeners(), this.stopRecording(), this._debouncedFlush.cancel(), t && await this._flush({ force: !0 }), this.eventBuffer && this.eventBuffer.destroy(), this.eventBuffer = null, LRe(this);
      } catch (r) {
        this._handleException(r);
      }
    }
  }
  /**
   * Pause some replay functionality. See comments for `_isPaused`.
   * This differs from stop as this only stops DOM recording, it is
   * not as thorough of a shutdown as `stop()`.
   */
  pause() {
    this._isPaused || (this._isPaused = !0, this.stopRecording(), To("[Replay] Pausing replay", this._options._experiments.traceInternals));
  }
  /**
   * Resumes recording, see notes for `pause().
   *
   * Note that calling `startRecording()` here will cause a
   * new DOM checkout.`
   */
  resume() {
    !this._isPaused || !this._checkSession() || (this._isPaused = !1, this.startRecording(), To("[Replay] Resuming replay", this._options._experiments.traceInternals));
  }
  /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */
  async sendBufferedReplayOrFlush({ continueRecording: t = !0 } = {}) {
    if (this.recordingMode === "session")
      return this.flushImmediate();
    const n = Date.now();
    To("[Replay] Converting buffer to session", this._options._experiments.traceInternals), await this.flushImmediate();
    const r = this.stopRecording();
    !t || !r || this.recordingMode !== "session" && (this.recordingMode = "session", this.session && (this._updateUserActivity(n), this._updateSessionActivity(n), this._maybeSaveSession()), this.startRecording());
  }
  /**
   * We want to batch uploads of replay events. Save events only if
   * `<flushMinDelay>` milliseconds have elapsed since the last event
   * *OR* if `<flushMaxDelay>` milliseconds have elapsed.
   *
   * Accepts a callback to perform side-effects and returns true to stop batch
   * processing and hand back control to caller.
   */
  addUpdate(t) {
    const n = t();
    this.recordingMode !== "buffer" && n !== !0 && this._debouncedFlush();
  }
  /**
   * Updates the user activity timestamp and resumes recording. This should be
   * called in an event handler for a user action that we consider as the user
   * being "active" (e.g. a mouse click).
   */
  triggerUserActivity() {
    if (this._updateUserActivity(), !this._stopRecording) {
      if (!this._checkSession())
        return;
      this.resume();
      return;
    }
    this.checkAndHandleExpiredSession(), this._updateSessionActivity();
  }
  /**
   * Updates the user activity timestamp *without* resuming
   * recording. Some user events (e.g. keydown) can be create
   * low-value replays that only contain the keypress as a
   * breadcrumb. Instead this would require other events to
   * create a new replay after a session has expired.
   */
  updateUserActivity() {
    this._updateUserActivity(), this._updateSessionActivity();
  }
  /**
   * Only flush if `this.recordingMode === 'session'`
   */
  conditionalFlush() {
    return this.recordingMode === "buffer" ? Promise.resolve() : this.flushImmediate();
  }
  /**
   * Flush using debounce flush
   */
  flush() {
    return this._debouncedFlush();
  }
  /**
   * Always flush via `_debouncedFlush` so that we do not have flushes triggered
   * from calling both `flush` and `_debouncedFlush`. Otherwise, there could be
   * cases of mulitple flushes happening closely together.
   */
  flushImmediate() {
    return this._debouncedFlush(), this._debouncedFlush.flush();
  }
  /**
   * Cancels queued up flushes.
   */
  cancelFlush() {
    this._debouncedFlush.cancel();
  }
  /** Get the current sesion (=replay) ID */
  getSessionId() {
    return this.session && this.session.id;
  }
  /**
   * Checks if recording should be stopped due to user inactivity. Otherwise
   * check if session is expired and create a new session if so. Triggers a new
   * full snapshot on new session.
   *
   * Returns true if session is not expired, false otherwise.
   * @hidden
   */
  checkAndHandleExpiredSession() {
    if (this._lastActivity && AA(this._lastActivity, this.timeouts.sessionIdlePause) && this.session && this.session.sampled === "session") {
      this.pause();
      return;
    }
    return !!this._checkSession();
  }
  /**
   * Capture some initial state that can change throughout the lifespan of the
   * replay. This is required because otherwise they would be captured at the
   * first flush.
   */
  setInitialState() {
    const t = `${hr.location.pathname}${hr.location.hash}${hr.location.search}`, n = `${hr.location.origin}${t}`;
    this.performanceEntries = [], this.replayPerformanceEntries = [], this._clearContext(), this._context.initialUrl = n, this._context.initialTimestamp = Date.now(), this._context.urls.push(n);
  }
  /**
   * Add a breadcrumb event, that may be throttled.
   * If it was throttled, we add a custom breadcrumb to indicate that.
   */
  throttledAddEvent(t, n) {
    const r = this._throttledAddEvent(t, n);
    if (r === IX) {
      const i = nc({
        category: "replay.throttled"
      });
      this.addUpdate(() => !rM(this, {
        type: tRe,
        timestamp: i.timestamp || 0,
        data: {
          tag: "breadcrumb",
          payload: i,
          metric: !0
        }
      }));
    }
    return r;
  }
  /**
   * This will get the parametrized route name of the current page.
   * This is only available if performance is enabled, and if an instrumented router is used.
   */
  getCurrentRoute() {
    const t = this.lastTransaction || Ta().getTransaction(), r = (t && qi(t).data || {})[Xd];
    if (!(!t || !r || !["route", "custom"].includes(r)))
      return qi(t).description;
  }
  /**
   * Initialize and start all listeners to varying events (DOM,
   * Performance Observer, Recording, Sentry SDK, etc)
   */
  _initializeRecording() {
    this.setInitialState(), this._updateSessionActivity(), this.eventBuffer = NRe({
      useCompression: this._options.useCompression,
      workerUrl: this._options.workerUrl
    }), this._removeListeners(), this._addListeners(), this._isEnabled = !0, this._isPaused = !1, this.startRecording();
  }
  /** A wrapper to conditionally capture exceptions. */
  _handleException(t) {
    sr && Ce.error("[Replay]", t), sr && this._options._experiments && this._options._experiments.captureExceptions && yE(t);
  }
  /**
   * Loads (or refreshes) the current session.
   */
  _initializeSessionForSampling(t) {
    const n = this._options.errorSampleRate > 0, r = rT(
      {
        sessionIdleExpire: this.timeouts.sessionIdleExpire,
        maxReplayDuration: this._options.maxReplayDuration,
        traceInternals: this._options._experiments.traceInternals,
        previousSessionId: t
      },
      {
        stickySession: this._options.stickySession,
        sessionSampleRate: this._options.sessionSampleRate,
        allowBuffering: n
      }
    );
    this.session = r;
  }
  /**
   * Checks and potentially refreshes the current session.
   * Returns false if session is not recorded.
   */
  _checkSession() {
    if (!this.session)
      return !1;
    const t = this.session;
    return gX(t, {
      sessionIdleExpire: this.timeouts.sessionIdleExpire,
      maxReplayDuration: this._options.maxReplayDuration
    }) ? (this._refreshSession(t), !1) : !0;
  }
  /**
   * Refresh a session with a new one.
   * This stops the current session (without forcing a flush, as that would never work since we are expired),
   * and then does a new sampling based on the refreshed session.
   */
  async _refreshSession(t) {
    this._isEnabled && (await this.stop({ reason: "refresh session" }), this.initializeSampling(t.id));
  }
  /**
   * Adds listeners to record events for the replay
   */
  _addListeners() {
    try {
      hr.document.addEventListener("visibilitychange", this._handleVisibilityChange), hr.addEventListener("blur", this._handleWindowBlur), hr.addEventListener("focus", this._handleWindowFocus), hr.addEventListener("keydown", this._handleKeyboardEvent), this.clickDetector && this.clickDetector.addListeners(), this._hasInitializedCoreListeners || (FPe(this), this._hasInitializedCoreListeners = !0);
    } catch (t) {
      this._handleException(t);
    }
    this._performanceCleanupCallback = ARe(this);
  }
  /**
   * Cleans up listeners that were created in `_addListeners`
   */
  _removeListeners() {
    try {
      hr.document.removeEventListener("visibilitychange", this._handleVisibilityChange), hr.removeEventListener("blur", this._handleWindowBlur), hr.removeEventListener("focus", this._handleWindowFocus), hr.removeEventListener("keydown", this._handleKeyboardEvent), this.clickDetector && this.clickDetector.removeListeners(), this._performanceCleanupCallback && this._performanceCleanupCallback();
    } catch (t) {
      this._handleException(t);
    }
  }
  /**
   * Handle when visibility of the page content changes. Opening a new tab will
   * cause the state to change to hidden because of content of current page will
   * be hidden. Likewise, moving a different window to cover the contents of the
   * page will also trigger a change to a hidden state.
   */
  __init() {
    this._handleVisibilityChange = () => {
      hr.document.visibilityState === "visible" ? this._doChangeToForegroundTasks() : this._doChangeToBackgroundTasks();
    };
  }
  /**
   * Handle when page is blurred
   */
  __init2() {
    this._handleWindowBlur = () => {
      const t = nc({
        category: "ui.blur"
      });
      this._doChangeToBackgroundTasks(t);
    };
  }
  /**
   * Handle when page is focused
   */
  __init3() {
    this._handleWindowFocus = () => {
      const t = nc({
        category: "ui.focus"
      });
      this._doChangeToForegroundTasks(t);
    };
  }
  /** Ensure page remains active when a key is pressed. */
  __init4() {
    this._handleKeyboardEvent = (t) => {
      _Re(this, t);
    };
  }
  /**
   * Tasks to run when we consider a page to be hidden (via blurring and/or visibility)
   */
  _doChangeToBackgroundTasks(t) {
    !this.session || hX(this.session, {
      maxReplayDuration: this._options.maxReplayDuration,
      sessionIdleExpire: this.timeouts.sessionIdleExpire
    }) || (t && this._createCustomBreadcrumb(t), this.conditionalFlush());
  }
  /**
   * Tasks to run when we consider a page to be visible (via focus and/or visibility)
   */
  _doChangeToForegroundTasks(t) {
    if (!this.session)
      return;
    if (!this.checkAndHandleExpiredSession()) {
      To("[Replay] Document has become active, but session has expired");
      return;
    }
    t && this._createCustomBreadcrumb(t);
  }
  /**
   * Update user activity (across session lifespans)
   */
  _updateUserActivity(t = Date.now()) {
    this._lastActivity = t;
  }
  /**
   * Updates the session's last activity timestamp
   */
  _updateSessionActivity(t = Date.now()) {
    this.session && (this.session.lastActivity = t, this._maybeSaveSession());
  }
  /**
   * Helper to create (and buffer) a replay breadcrumb from a core SDK breadcrumb
   */
  _createCustomBreadcrumb(t) {
    this.addUpdate(() => {
      this.throttledAddEvent({
        type: fn.Custom,
        timestamp: t.timestamp || 0,
        data: {
          tag: "breadcrumb",
          payload: t
        }
      });
    });
  }
  /**
   * Observed performance events are added to `this.performanceEntries`. These
   * are included in the replay event before it is finished and sent to Sentry.
   */
  _addPerformanceEntries() {
    const t = xRe(this.performanceEntries).concat(this.replayPerformanceEntries);
    return this.performanceEntries = [], this.replayPerformanceEntries = [], Promise.all(CE(this, t));
  }
  /**
   * Clear _context
   */
  _clearContext() {
    this._context.errorIds.clear(), this._context.traceIds.clear(), this._context.urls = [];
  }
  /** Update the initial timestamp based on the buffer content. */
  _updateInitialTimestampFromEventBuffer() {
    const { session: t, eventBuffer: n } = this;
    if (!t || !n || t.segmentId)
      return;
    const r = n.getEarliestTimestamp();
    r && r < this._context.initialTimestamp && (this._context.initialTimestamp = r);
  }
  /**
   * Return and clear _context
   */
  _popEventContext() {
    const t = {
      initialTimestamp: this._context.initialTimestamp,
      initialUrl: this._context.initialUrl,
      errorIds: Array.from(this._context.errorIds),
      traceIds: Array.from(this._context.traceIds),
      urls: this._context.urls
    };
    return this._clearContext(), t;
  }
  /**
   * Flushes replay event buffer to Sentry.
   *
   * Performance events are only added right before flushing - this is
   * due to the buffered performance observer events.
   *
   * Should never be called directly, only by `flush`
   */
  async _runFlush() {
    const t = this.getSessionId();
    if (!this.session || !this.eventBuffer || !t) {
      sr && Ce.error("[Replay] No session or eventBuffer found to flush.");
      return;
    }
    if (await this._addPerformanceEntries(), !(!this.eventBuffer || !this.eventBuffer.hasEvents) && (await VPe(this), !!this.eventBuffer && t === this.getSessionId()))
      try {
        this._updateInitialTimestampFromEventBuffer();
        const n = Date.now();
        if (n - this._context.initialTimestamp > this._options.maxReplayDuration + 3e4)
          throw new Error("Session is too long, not sending replay");
        const r = this._popEventContext(), i = this.session.segmentId++;
        this._maybeSaveSession();
        const o = await this.eventBuffer.finish();
        await TX({
          replayId: t,
          recordingData: o,
          segmentId: i,
          eventContext: r,
          session: this.session,
          options: this.getOptions(),
          timestamp: n
        });
      } catch (n) {
        this._handleException(n), this.stop({ reason: "sendReplay" });
        const r = Jn();
        r && r.recordDroppedEvent("send_error", "replay");
      }
  }
  /**
   * Flush recording data to Sentry. Creates a lock so that only a single flush
   * can be active at a time. Do not call this directly.
   */
  __init5() {
    this._flush = async ({
      force: t = !1
    } = {}) => {
      if (!this._isEnabled && !t)
        return;
      if (!this.checkAndHandleExpiredSession()) {
        sr && Ce.error("[Replay] Attempting to finish replay event after session expired.");
        return;
      }
      if (!this.session)
        return;
      const n = this.session.started, i = Date.now() - n;
      this._debouncedFlush.cancel();
      const o = i < this._options.minReplayDuration, a = i > this._options.maxReplayDuration + 5e3;
      if (o || a) {
        To(
          `[Replay] Session duration (${Math.floor(i / 1e3)}s) is too ${o ? "short" : "long"}, not sending replay.`,
          this._options._experiments.traceInternals
        ), o && this._debouncedFlush();
        return;
      }
      const s = this.eventBuffer;
      if (s && this.session.segmentId === 0 && !s.hasCheckout && To("[Replay] Flushing initial segment without checkout.", this._options._experiments.traceInternals), !this._flushLock) {
        this._flushLock = this._runFlush(), await this._flushLock, this._flushLock = void 0;
        return;
      }
      try {
        await this._flushLock;
      } catch (c) {
        sr && Ce.error(c);
      } finally {
        this._debouncedFlush();
      }
    };
  }
  /** Save the session, if it is sticky */
  _maybeSaveSession() {
    this.session && this._options.stickySession && nM(this.session);
  }
  /** Handler for rrweb.record.onMutation */
  __init6() {
    this._onMutationHandler = (t) => {
      const n = t.length, r = this._options.mutationLimit, i = this._options.mutationBreadcrumbLimit, o = r && n > r;
      if (n > i || o) {
        const a = nc({
          category: "replay.mutations",
          data: {
            count: n,
            limit: o
          }
        });
        this._createCustomBreadcrumb(a);
      }
      return o ? (this.stop({ reason: "mutationLimit", forceFlush: this.recordingMode === "session" }), !1) : !0;
    };
  }
}
function Am(e, t, n, r) {
  const i = typeof r == "string" ? r.split(",") : [], o = [
    ...e,
    // @deprecated
    ...i,
    // sentry defaults
    ...t
  ];
  return typeof n < "u" && (typeof n == "string" && o.push(`.${n}`), vf(() => {
    console.warn(
      "[Replay] You are using a deprecated configuration item for privacy. Read the documentation on how to use the new privacy configuration."
    );
  })), o.join(",");
}
function JPe({
  mask: e,
  unmask: t,
  block: n,
  unblock: r,
  ignore: i,
  // eslint-disable-next-line deprecation/deprecation
  blockClass: o,
  // eslint-disable-next-line deprecation/deprecation
  blockSelector: a,
  // eslint-disable-next-line deprecation/deprecation
  maskTextClass: s,
  // eslint-disable-next-line deprecation/deprecation
  maskTextSelector: c,
  // eslint-disable-next-line deprecation/deprecation
  ignoreClass: l
}) {
  const u = ['base[href="/"]'], d = Am(e, [".sentry-mask", "[data-sentry-mask]"], s, c), f = Am(t, [".sentry-unmask", "[data-sentry-unmask]"]), h = {
    // We are making the decision to make text and input selectors the same
    maskTextSelector: d,
    unmaskTextSelector: f,
    blockSelector: Am(
      n,
      [".sentry-block", "[data-sentry-block]", ...u],
      o,
      a
    ),
    unblockSelector: Am(r, [".sentry-unblock", "[data-sentry-unblock]"]),
    ignoreSelector: Am(i, [".sentry-ignore", "[data-sentry-ignore]", 'input[type="file"]'], l)
  };
  return o instanceof RegExp && (h.blockClass = o), s instanceof RegExp && (h.maskTextClass = s), h;
}
function ZPe({
  el: e,
  key: t,
  maskAttributes: n,
  maskAllText: r,
  privacyOptions: i,
  value: o
}) {
  return !r || i.unmaskTextSelector && e.matches(i.unmaskTextSelector) ? o : n.includes(t) || // Need to mask `value` attribute for `<input>` if it's a button-like
  // type
  t === "value" && e.tagName === "INPUT" && ["submit", "button"].includes(e.getAttribute("type") || "") ? o.replace(/[\S]/g, "*") : o;
}
const Hj = 'img,image,svg,video,object,picture,embed,map,audio,link[rel="icon"],link[rel="apple-touch-icon"]', eOe = ["content-length", "content-type", "accept"];
let Uj = !1;
class $E {
  /**
   * @inheritDoc
   */
  static __initStatic() {
    this.id = "Replay";
  }
  /**
   * @inheritDoc
   */
  /**
   * Options to pass to `rrweb.record()`
   */
  /**
   * Initial options passed to the replay integration, merged with default values.
   * Note: `sessionSampleRate` and `errorSampleRate` are not required here, as they
   * can only be finally set when setupOnce() is called.
   *
   * @private
   */
  constructor({
    flushMinDelay: t = D$e,
    flushMaxDelay: n = j$e,
    minReplayDuration: r = H$e,
    maxReplayDuration: i = Ej,
    stickySession: o = !0,
    useCompression: a = !0,
    workerUrl: s,
    _experiments: c = {},
    sessionSampleRate: l,
    errorSampleRate: u,
    maskAllText: d = !0,
    maskAllInputs: f = !0,
    blockAllMedia: h = !0,
    mutationBreadcrumbLimit: p = 750,
    mutationLimit: g = 1e4,
    slowClickTimeout: m = 7e3,
    slowClickIgnoreSelectors: v = [],
    networkDetailAllowUrls: y = [],
    networkDetailDenyUrls: _ = [],
    networkCaptureBodies: b = !0,
    networkRequestHeaders: w = [],
    networkResponseHeaders: C = [],
    mask: x = [],
    maskAttributes: T = ["title", "placeholder"],
    unmask: E = [],
    block: R = [],
    unblock: I = [],
    ignore: O = [],
    maskFn: P,
    beforeAddRecordingEvent: k,
    beforeErrorSampling: L,
    // eslint-disable-next-line deprecation/deprecation
    blockClass: N,
    // eslint-disable-next-line deprecation/deprecation
    blockSelector: D,
    // eslint-disable-next-line deprecation/deprecation
    maskInputOptions: z,
    // eslint-disable-next-line deprecation/deprecation
    maskTextClass: V,
    // eslint-disable-next-line deprecation/deprecation
    maskTextSelector: B,
    // eslint-disable-next-line deprecation/deprecation
    ignoreClass: U
  } = {}) {
    this.name = $E.id;
    const Q = JPe({
      mask: x,
      unmask: E,
      block: R,
      unblock: I,
      ignore: O,
      blockClass: N,
      blockSelector: D,
      maskTextClass: V,
      maskTextSelector: B,
      ignoreClass: U
    });
    if (this._recordingOptions = {
      maskAllInputs: f,
      maskAllText: d,
      maskInputOptions: { ...z || {}, password: !0 },
      maskTextFn: P,
      maskInputFn: P,
      maskAttributeFn: (Y, q, X) => ZPe({
        maskAttributes: T,
        maskAllText: d,
        privacyOptions: Q,
        key: Y,
        value: q,
        el: X
      }),
      ...Q,
      // Our defaults
      slimDOMOptions: "all",
      inlineStylesheet: !0,
      // Disable inline images as it will increase segment/replay size
      inlineImages: !1,
      // collect fonts, but be aware that `sentry.io` needs to be an allowed
      // origin for playback
      collectFonts: !0,
      errorHandler: (Y) => {
        try {
          Y.__rrweb__ = !0;
        } catch {
        }
      }
    }, this._initialOptions = {
      flushMinDelay: t,
      flushMaxDelay: n,
      minReplayDuration: Math.min(r, U$e),
      maxReplayDuration: Math.min(i, Ej),
      stickySession: o,
      sessionSampleRate: l,
      errorSampleRate: u,
      useCompression: a,
      workerUrl: s,
      blockAllMedia: h,
      maskAllInputs: f,
      maskAllText: d,
      mutationBreadcrumbLimit: p,
      mutationLimit: g,
      slowClickTimeout: m,
      slowClickIgnoreSelectors: v,
      networkDetailAllowUrls: y,
      networkDetailDenyUrls: _,
      networkCaptureBodies: b,
      networkRequestHeaders: Wj(w),
      networkResponseHeaders: Wj(C),
      beforeAddRecordingEvent: k,
      beforeErrorSampling: L,
      _experiments: c
    }, typeof l == "number" && (console.warn(
      `[Replay] You are passing \`sessionSampleRate\` to the Replay integration.
This option is deprecated and will be removed soon.
Instead, configure \`replaysSessionSampleRate\` directly in the SDK init options, e.g.:
Sentry.init({ replaysSessionSampleRate: ${l} })`
    ), this._initialOptions.sessionSampleRate = l), typeof u == "number" && (console.warn(
      `[Replay] You are passing \`errorSampleRate\` to the Replay integration.
This option is deprecated and will be removed soon.
Instead, configure \`replaysOnErrorSampleRate\` directly in the SDK init options, e.g.:
Sentry.init({ replaysOnErrorSampleRate: ${u} })`
    ), this._initialOptions.errorSampleRate = u), this._initialOptions.blockAllMedia && (this._recordingOptions.blockSelector = this._recordingOptions.blockSelector ? `${this._recordingOptions.blockSelector},${Hj}` : Hj), this._isInitialized && U8())
      throw new Error("Multiple Sentry Session Replay instances are not supported");
    this._isInitialized = !0;
  }
  /** If replay has already been initialized */
  get _isInitialized() {
    return Uj;
  }
  /** Update _isInitialized */
  set _isInitialized(t) {
    Uj = t;
  }
  /**
   * Setup and initialize replay container
   */
  setupOnce() {
    U8() && (this._setup(), setTimeout(() => this._initialize()));
  }
  /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will throw an error if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * PerformanceObserver, Recording, Sentry SDK, etc)
   */
  start() {
    this._replay && this._replay.start();
  }
  /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, until an error occurs.
   */
  startBuffering() {
    this._replay && this._replay.startBuffering();
  }
  /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */
  stop() {
    return this._replay ? this._replay.stop({ forceFlush: this._replay.recordingMode === "session" }) : Promise.resolve();
  }
  /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */
  flush(t) {
    return !this._replay || !this._replay.isEnabled() ? Promise.resolve() : this._replay.sendBufferedReplayOrFlush(t);
  }
  /**
   * Get the current session ID.
   */
  getReplayId() {
    if (!(!this._replay || !this._replay.isEnabled()))
      return this._replay.getSessionId();
  }
  /**
   * Initializes replay.
   */
  _initialize() {
    this._replay && (this._maybeLoadFromReplayCanvasIntegration(), this._replay.initializeSampling());
  }
  /** Setup the integration. */
  _setup() {
    const t = tOe(this._initialOptions);
    this._replay = new Ul({
      options: t,
      recordingOptions: this._recordingOptions
    });
  }
  /** Get canvas options from ReplayCanvas integration, if it is also added. */
  _maybeLoadFromReplayCanvasIntegration() {
    try {
      const n = Jn().getIntegrationByName("ReplayCanvas");
      if (!n)
        return;
      this._replay._canvas = n.getOptions();
    } catch {
    }
  }
}
$E.__initStatic();
function tOe(e) {
  const t = Jn(), n = t && t.getOptions(), r = { sessionSampleRate: 0, errorSampleRate: 0, ...Po(e) };
  return n ? (e.sessionSampleRate == null && // TODO remove once deprecated rates are removed
  e.errorSampleRate == null && // TODO remove once deprecated rates are removed
  n.replaysSessionSampleRate == null && n.replaysOnErrorSampleRate == null && vf(() => {
    console.warn(
      "Replay is disabled because neither `replaysSessionSampleRate` nor `replaysOnErrorSampleRate` are set."
    );
  }), typeof n.replaysSessionSampleRate == "number" && (r.sessionSampleRate = n.replaysSessionSampleRate), typeof n.replaysOnErrorSampleRate == "number" && (r.errorSampleRate = n.replaysOnErrorSampleRate), r) : (vf(() => {
    console.warn("SDK client is not available.");
  }), r);
}
function Wj(e) {
  return [...eOe, ...e.map((t) => t.toLowerCase())];
}
function nOe(e) {
  const t = {
    ...e
  };
  oY(t, "react"), P$e(t);
}
class UCt extends vle {
  constructor(n, r) {
    super();
    ve(this, "log");
    ve(this, "options");
    this.log = n, this.options = r;
  }
  async initialise() {
    this.log.info("SentryCrashReportingService", "initialise"), this.options ? nOe({
      dsn: this.options.dsn,
      release: this.options.release,
      integrations: [new _Ie(), new $E()],
      // Performance Monitoring
      tracesSampleRate: this.options.tracesSampleRate ?? 0.1,
      // Capture 100% of the transactions, reduce in production!
      // Session Replay
      replaysSessionSampleRate: this.options.replaysSessionSampleRate ?? 0.1,
      // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
      replaysOnErrorSampleRate: 1
      // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    }) : this.log.info(
      "SentryCrashReportingService",
      "initialise",
      "skipped because no Sentry options provided"
    );
  }
  dispose() {
    this.log.info("SentryCrashReportingService", "dispose");
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  recordError(n, r) {
    const { local_msg: i, context: o } = r || { local_msg: void 0, context: void 0 }, a = { data: o };
    this.log.info("SentryCrashReportingService", "recordError", n, i, o), yE(n, { tags: { local_msg: i }, extra: a });
  }
}
var $X = { exports: {} };
(function(e) {
  (function(t, n) {
    e.exports ? e.exports = n() : t.log = n();
  })(t0, function() {
    var t = function() {
    }, n = "undefined", r = typeof window !== n && typeof window.navigator !== n && /Trident\/|MSIE /.test(window.navigator.userAgent), i = [
      "trace",
      "debug",
      "info",
      "warn",
      "error"
    ], o = {}, a = null;
    function s(g, m) {
      var v = g[m];
      if (typeof v.bind == "function")
        return v.bind(g);
      try {
        return Function.prototype.bind.call(v, g);
      } catch {
        return function() {
          return Function.prototype.apply.apply(v, [g, arguments]);
        };
      }
    }
    function c() {
      console.log && (console.log.apply ? console.log.apply(console, arguments) : Function.prototype.apply.apply(console.log, [console, arguments])), console.trace && console.trace();
    }
    function l(g) {
      return g === "debug" && (g = "log"), typeof console === n ? !1 : g === "trace" && r ? c : console[g] !== void 0 ? s(console, g) : console.log !== void 0 ? s(console, "log") : t;
    }
    function u() {
      for (var g = this.getLevel(), m = 0; m < i.length; m++) {
        var v = i[m];
        this[v] = m < g ? t : this.methodFactory(v, g, this.name);
      }
      if (this.log = this.debug, typeof console === n && g < this.levels.SILENT)
        return "No console available for logging";
    }
    function d(g) {
      return function() {
        typeof console !== n && (u.call(this), this[g].apply(this, arguments));
      };
    }
    function f(g, m, v) {
      return l(g) || d.apply(this, arguments);
    }
    function h(g, m) {
      var v = this, y, _, b, w = "loglevel";
      typeof g == "string" ? w += ":" + g : typeof g == "symbol" && (w = void 0);
      function C(I) {
        var O = (i[I] || "silent").toUpperCase();
        if (!(typeof window === n || !w)) {
          try {
            window.localStorage[w] = O;
            return;
          } catch {
          }
          try {
            window.document.cookie = encodeURIComponent(w) + "=" + O + ";";
          } catch {
          }
        }
      }
      function x() {
        var I;
        if (!(typeof window === n || !w)) {
          try {
            I = window.localStorage[w];
          } catch {
          }
          if (typeof I === n)
            try {
              var O = window.document.cookie, P = encodeURIComponent(w), k = O.indexOf(P + "=");
              k !== -1 && (I = /^([^;]+)/.exec(
                O.slice(k + P.length + 1)
              )[1]);
            } catch {
            }
          return v.levels[I] === void 0 && (I = void 0), I;
        }
      }
      function T() {
        if (!(typeof window === n || !w)) {
          try {
            window.localStorage.removeItem(w);
          } catch {
          }
          try {
            window.document.cookie = encodeURIComponent(w) + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC";
          } catch {
          }
        }
      }
      function E(I) {
        var O = I;
        if (typeof O == "string" && v.levels[O.toUpperCase()] !== void 0 && (O = v.levels[O.toUpperCase()]), typeof O == "number" && O >= 0 && O <= v.levels.SILENT)
          return O;
        throw new TypeError("log.setLevel() called with invalid level: " + I);
      }
      v.name = g, v.levels = {
        TRACE: 0,
        DEBUG: 1,
        INFO: 2,
        WARN: 3,
        ERROR: 4,
        SILENT: 5
      }, v.methodFactory = m || f, v.getLevel = function() {
        return b ?? _ ?? y;
      }, v.setLevel = function(I, O) {
        return b = E(I), O !== !1 && C(b), u.call(v);
      }, v.setDefaultLevel = function(I) {
        _ = E(I), x() || v.setLevel(I, !1);
      }, v.resetLevel = function() {
        b = null, T(), u.call(v);
      }, v.enableAll = function(I) {
        v.setLevel(v.levels.TRACE, I);
      }, v.disableAll = function(I) {
        v.setLevel(v.levels.SILENT, I);
      }, v.rebuild = function() {
        if (a !== v && (y = E(a.getLevel())), u.call(v), a === v)
          for (var I in o)
            o[I].rebuild();
      }, y = E(
        a ? a.getLevel() : "WARN"
      );
      var R = x();
      R != null && (b = E(R)), u.call(v);
    }
    a = new h(), a.getLogger = function(m) {
      if (typeof m != "symbol" && typeof m != "string" || m === "")
        throw new TypeError("You must supply a name when creating a logger.");
      var v = o[m];
      return v || (v = o[m] = new h(
        m,
        a.methodFactory
      )), v;
    };
    var p = typeof window !== n ? window.log : void 0;
    return a.noConflict = function() {
      return typeof window !== n && window.log === a && (window.log = p), a;
    }, a.getLoggers = function() {
      return o;
    }, a.default = a, a;
  });
})($X);
var rOe = $X.exports;
const Hs = /* @__PURE__ */ vn(rOe);
class WCt extends yle {
  constructor(n) {
    Hs.setLevel(n.logLevel ?? "debug");
    super();
    ve(this, "crashReportingService");
    this.crashReportingService = new ble(), this.debug = Hs.debug.bind(Hs), this.log = Hs.log.bind(Hs), this.info = Hs.info.bind(Hs), this.warn = Hs.warn.bind(Hs);
  }
  async initialise(n) {
    this.debug("RecorderLoggingService initialise"), this.crashReportingService = n;
  }
  dispose() {
    this.debug("RecorderLoggingService dispose");
  }
  debug(...n) {
  }
  log(...n) {
  }
  info(...n) {
  }
  warn(...n) {
  }
  error(n, r) {
    const { error: i, context: o } = r || { error: void 0, context: void 0 };
    Hs.error(n, i, o), this.crashReportingService.recordError(i ?? new Error(n), { local_msg: n, context: o });
  }
}
var AX = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function n() {
      for (var o = "", a = 0; a < arguments.length; a++) {
        var s = arguments[a];
        s && (o = i(o, r(s)));
      }
      return o;
    }
    function r(o) {
      if (typeof o == "string" || typeof o == "number")
        return o;
      if (typeof o != "object")
        return "";
      if (Array.isArray(o))
        return n.apply(null, o);
      if (o.toString !== Object.prototype.toString && !o.toString.toString().includes("[native code]"))
        return o.toString();
      var a = "";
      for (var s in o)
        t.call(o, s) && o[s] && (a = i(a, s));
      return a;
    }
    function i(o, a) {
      return a ? o ? o + " " + a : o + a : o;
    }
    e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
  })();
})(AX);
var qp = AX.exports;
const Ee = /* @__PURE__ */ vn(qp);
var OA = { exports: {} }, Un = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var qj;
function iOe() {
  if (qj)
    return Un;
  qj = 1;
  var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), a = Symbol.for("react.context"), s = Symbol.for("react.server_context"), c = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), p;
  p = Symbol.for("react.module.reference");
  function g(m) {
    if (typeof m == "object" && m !== null) {
      var v = m.$$typeof;
      switch (v) {
        case e:
          switch (m = m.type, m) {
            case n:
            case i:
            case r:
            case l:
            case u:
              return m;
            default:
              switch (m = m && m.$$typeof, m) {
                case s:
                case a:
                case c:
                case f:
                case d:
                case o:
                  return m;
                default:
                  return v;
              }
          }
        case t:
          return v;
      }
    }
  }
  return Un.ContextConsumer = a, Un.ContextProvider = o, Un.Element = e, Un.ForwardRef = c, Un.Fragment = n, Un.Lazy = f, Un.Memo = d, Un.Portal = t, Un.Profiler = i, Un.StrictMode = r, Un.Suspense = l, Un.SuspenseList = u, Un.isAsyncMode = function() {
    return !1;
  }, Un.isConcurrentMode = function() {
    return !1;
  }, Un.isContextConsumer = function(m) {
    return g(m) === a;
  }, Un.isContextProvider = function(m) {
    return g(m) === o;
  }, Un.isElement = function(m) {
    return typeof m == "object" && m !== null && m.$$typeof === e;
  }, Un.isForwardRef = function(m) {
    return g(m) === c;
  }, Un.isFragment = function(m) {
    return g(m) === n;
  }, Un.isLazy = function(m) {
    return g(m) === f;
  }, Un.isMemo = function(m) {
    return g(m) === d;
  }, Un.isPortal = function(m) {
    return g(m) === t;
  }, Un.isProfiler = function(m) {
    return g(m) === i;
  }, Un.isStrictMode = function(m) {
    return g(m) === r;
  }, Un.isSuspense = function(m) {
    return g(m) === l;
  }, Un.isSuspenseList = function(m) {
    return g(m) === u;
  }, Un.isValidElementType = function(m) {
    return typeof m == "string" || typeof m == "function" || m === n || m === i || m === r || m === l || m === u || m === h || typeof m == "object" && m !== null && (m.$$typeof === f || m.$$typeof === d || m.$$typeof === o || m.$$typeof === a || m.$$typeof === c || m.$$typeof === p || m.getModuleId !== void 0);
  }, Un.typeOf = g, Un;
}
var Wn = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Gj;
function oOe() {
  return Gj || (Gj = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), a = Symbol.for("react.context"), s = Symbol.for("react.server_context"), c = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), p = !1, g = !1, m = !1, v = !1, y = !1, _;
    _ = Symbol.for("react.module.reference");
    function b(W) {
      return !!(typeof W == "string" || typeof W == "function" || W === n || W === i || y || W === r || W === l || W === u || v || W === h || p || g || m || typeof W == "object" && W !== null && (W.$$typeof === f || W.$$typeof === d || W.$$typeof === o || W.$$typeof === a || W.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      W.$$typeof === _ || W.getModuleId !== void 0));
    }
    function w(W) {
      if (typeof W == "object" && W !== null) {
        var se = W.$$typeof;
        switch (se) {
          case e:
            var le = W.type;
            switch (le) {
              case n:
              case i:
              case r:
              case l:
              case u:
                return le;
              default:
                var ge = le && le.$$typeof;
                switch (ge) {
                  case s:
                  case a:
                  case c:
                  case f:
                  case d:
                  case o:
                    return ge;
                  default:
                    return se;
                }
            }
          case t:
            return se;
        }
      }
    }
    var C = a, x = o, T = e, E = c, R = n, I = f, O = d, P = t, k = i, L = r, N = l, D = u, z = !1, V = !1;
    function B(W) {
      return z || (z = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function U(W) {
      return V || (V = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function Q(W) {
      return w(W) === a;
    }
    function Y(W) {
      return w(W) === o;
    }
    function q(W) {
      return typeof W == "object" && W !== null && W.$$typeof === e;
    }
    function X(W) {
      return w(W) === c;
    }
    function ne(W) {
      return w(W) === n;
    }
    function Z(W) {
      return w(W) === f;
    }
    function J(W) {
      return w(W) === d;
    }
    function K(W) {
      return w(W) === t;
    }
    function ee(W) {
      return w(W) === i;
    }
    function te(W) {
      return w(W) === r;
    }
    function H(W) {
      return w(W) === l;
    }
    function ie(W) {
      return w(W) === u;
    }
    Wn.ContextConsumer = C, Wn.ContextProvider = x, Wn.Element = T, Wn.ForwardRef = E, Wn.Fragment = R, Wn.Lazy = I, Wn.Memo = O, Wn.Portal = P, Wn.Profiler = k, Wn.StrictMode = L, Wn.Suspense = N, Wn.SuspenseList = D, Wn.isAsyncMode = B, Wn.isConcurrentMode = U, Wn.isContextConsumer = Q, Wn.isContextProvider = Y, Wn.isElement = q, Wn.isForwardRef = X, Wn.isFragment = ne, Wn.isLazy = Z, Wn.isMemo = J, Wn.isPortal = K, Wn.isProfiler = ee, Wn.isStrictMode = te, Wn.isSuspense = H, Wn.isSuspenseList = ie, Wn.isValidElementType = b, Wn.typeOf = w;
  }()), Wn;
}
process.env.NODE_ENV === "production" ? OA.exports = iOe() : OA.exports = oOe();
var Qd = OA.exports;
function Sf(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = [];
  return j.Children.forEach(e, function(r) {
    r == null && !t.keepEmpty || (Array.isArray(r) ? n = n.concat(Sf(r)) : Qd.isFragment(r) && r.props ? n = n.concat(Sf(r.props.children, t)) : n.push(r));
  }), n;
}
var MA = {}, oM = [], aOe = function(t) {
  oM.push(t);
};
function Du(e, t) {
  if (process.env.NODE_ENV !== "production" && !e && console !== void 0) {
    var n = oM.reduce(function(r, i) {
      return i(r ?? "", "warning");
    }, t);
    n && console.error("Warning: ".concat(n));
  }
}
function sOe(e, t) {
  if (process.env.NODE_ENV !== "production" && !e && console !== void 0) {
    var n = oM.reduce(function(r, i) {
      return i(r ?? "", "note");
    }, t);
    n && console.warn("Note: ".concat(n));
  }
}
function RX() {
  MA = {};
}
function PX(e, t, n) {
  !t && !MA[n] && (e(!1, n), MA[n] = !0);
}
function sn(e, t) {
  PX(Du, e, t);
}
function kA(e, t) {
  PX(sOe, e, t);
}
sn.preMessage = aOe;
sn.resetWarned = RX;
sn.noteOnce = kA;
function _v(e) {
  return e instanceof HTMLElement || e instanceof SVGElement;
}
function cOe(e) {
  return e && It(e) === "object" && _v(e.nativeElement) ? e.nativeElement : _v(e) ? e : null;
}
function L0(e) {
  var t = cOe(e);
  if (t)
    return t;
  if (e instanceof j.Component) {
    var n;
    return (n = vN.findDOMNode) === null || n === void 0 ? void 0 : n.call(vN, e);
  }
  return null;
}
function Iy(e, t, n) {
  var r = $.useRef({});
  return (!("value" in r.current) || n(r.current.condition, t)) && (r.current.value = e(), r.current.condition = t), r.current.value;
}
var aM = function(t, n) {
  typeof t == "function" ? t(n) : It(t) === "object" && t && "current" in t && (t.current = n);
}, Ja = function() {
  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  var i = n.filter(Boolean);
  return i.length <= 1 ? i[0] : function(o) {
    n.forEach(function(a) {
      aM(a, o);
    });
  };
}, AE = function() {
  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  return Iy(function() {
    return Ja.apply(void 0, n);
  }, n, function(i, o) {
    return i.length !== o.length || i.every(function(a, s) {
      return a !== o[s];
    });
  });
}, $y = function(t) {
  var n, r, i = Qd.isMemo(t) ? t.type.type : t.type;
  return !(typeof i == "function" && !((n = i.prototype) !== null && n !== void 0 && n.render) && i.$$typeof !== Qd.ForwardRef || typeof t == "function" && !((r = t.prototype) !== null && r !== void 0 && r.render) && t.$$typeof !== Qd.ForwardRef);
};
function Kj(e) {
  return /* @__PURE__ */ ZP(e) && !Qd.isFragment(e);
}
Number(Rle.split(".")[0]) >= 19;
var NA = /* @__PURE__ */ $.createContext(null);
function lOe(e) {
  var t = e.children, n = e.onBatchResize, r = $.useRef(0), i = $.useRef([]), o = $.useContext(NA), a = $.useCallback(function(s, c, l) {
    r.current += 1;
    var u = r.current;
    i.current.push({
      size: s,
      element: c,
      data: l
    }), Promise.resolve().then(function() {
      u === r.current && (n == null || n(i.current), i.current = []);
    }), o == null || o(s, c, l);
  }, [n, o]);
  return /* @__PURE__ */ $.createElement(NA.Provider, {
    value: a
  }, t);
}
var OX = function() {
  if (typeof Map < "u")
    return Map;
  function e(t, n) {
    var r = -1;
    return t.some(function(i, o) {
      return i[0] === n ? (r = o, !0) : !1;
    }), r;
  }
  return (
    /** @class */
    function() {
      function t() {
        this.__entries__ = [];
      }
      return Object.defineProperty(t.prototype, "size", {
        /**
         * @returns {boolean}
         */
        get: function() {
          return this.__entries__.length;
        },
        enumerable: !0,
        configurable: !0
      }), t.prototype.get = function(n) {
        var r = e(this.__entries__, n), i = this.__entries__[r];
        return i && i[1];
      }, t.prototype.set = function(n, r) {
        var i = e(this.__entries__, n);
        ~i ? this.__entries__[i][1] = r : this.__entries__.push([n, r]);
      }, t.prototype.delete = function(n) {
        var r = this.__entries__, i = e(r, n);
        ~i && r.splice(i, 1);
      }, t.prototype.has = function(n) {
        return !!~e(this.__entries__, n);
      }, t.prototype.clear = function() {
        this.__entries__.splice(0);
      }, t.prototype.forEach = function(n, r) {
        r === void 0 && (r = null);
        for (var i = 0, o = this.__entries__; i < o.length; i++) {
          var a = o[i];
          n.call(r, a[1], a[0]);
        }
      }, t;
    }()
  );
}(), DA = typeof window < "u" && typeof document < "u" && window.document === document, $S = function() {
  return typeof global < "u" && global.Math === Math ? global : typeof self < "u" && self.Math === Math ? self : typeof window < "u" && window.Math === Math ? window : Function("return this")();
}(), uOe = function() {
  return typeof requestAnimationFrame == "function" ? requestAnimationFrame.bind($S) : function(e) {
    return setTimeout(function() {
      return e(Date.now());
    }, 1e3 / 60);
  };
}(), dOe = 2;
function fOe(e, t) {
  var n = !1, r = !1, i = 0;
  function o() {
    n && (n = !1, e()), r && s();
  }
  function a() {
    uOe(o);
  }
  function s() {
    var c = Date.now();
    if (n) {
      if (c - i < dOe)
        return;
      r = !0;
    } else
      n = !0, r = !1, setTimeout(a, t);
    i = c;
  }
  return s;
}
var hOe = 20, gOe = ["top", "right", "bottom", "left", "width", "height", "size", "weight"], pOe = typeof MutationObserver < "u", mOe = (
  /** @class */
  function() {
    function e() {
      this.connected_ = !1, this.mutationEventsAdded_ = !1, this.mutationsObserver_ = null, this.observers_ = [], this.onTransitionEnd_ = this.onTransitionEnd_.bind(this), this.refresh = fOe(this.refresh.bind(this), hOe);
    }
    return e.prototype.addObserver = function(t) {
      ~this.observers_.indexOf(t) || this.observers_.push(t), this.connected_ || this.connect_();
    }, e.prototype.removeObserver = function(t) {
      var n = this.observers_, r = n.indexOf(t);
      ~r && n.splice(r, 1), !n.length && this.connected_ && this.disconnect_();
    }, e.prototype.refresh = function() {
      var t = this.updateObservers_();
      t && this.refresh();
    }, e.prototype.updateObservers_ = function() {
      var t = this.observers_.filter(function(n) {
        return n.gatherActive(), n.hasActive();
      });
      return t.forEach(function(n) {
        return n.broadcastActive();
      }), t.length > 0;
    }, e.prototype.connect_ = function() {
      !DA || this.connected_ || (document.addEventListener("transitionend", this.onTransitionEnd_), window.addEventListener("resize", this.refresh), pOe ? (this.mutationsObserver_ = new MutationObserver(this.refresh), this.mutationsObserver_.observe(document, {
        attributes: !0,
        childList: !0,
        characterData: !0,
        subtree: !0
      })) : (document.addEventListener("DOMSubtreeModified", this.refresh), this.mutationEventsAdded_ = !0), this.connected_ = !0);
    }, e.prototype.disconnect_ = function() {
      !DA || !this.connected_ || (document.removeEventListener("transitionend", this.onTransitionEnd_), window.removeEventListener("resize", this.refresh), this.mutationsObserver_ && this.mutationsObserver_.disconnect(), this.mutationEventsAdded_ && document.removeEventListener("DOMSubtreeModified", this.refresh), this.mutationsObserver_ = null, this.mutationEventsAdded_ = !1, this.connected_ = !1);
    }, e.prototype.onTransitionEnd_ = function(t) {
      var n = t.propertyName, r = n === void 0 ? "" : n, i = gOe.some(function(o) {
        return !!~r.indexOf(o);
      });
      i && this.refresh();
    }, e.getInstance = function() {
      return this.instance_ || (this.instance_ = new e()), this.instance_;
    }, e.instance_ = null, e;
  }()
), MX = function(e, t) {
  for (var n = 0, r = Object.keys(t); n < r.length; n++) {
    var i = r[n];
    Object.defineProperty(e, i, {
      value: t[i],
      enumerable: !1,
      writable: !1,
      configurable: !0
    });
  }
  return e;
}, zg = function(e) {
  var t = e && e.ownerDocument && e.ownerDocument.defaultView;
  return t || $S;
}, kX = RE(0, 0, 0, 0);
function AS(e) {
  return parseFloat(e) || 0;
}
function Yj(e) {
  for (var t = [], n = 1; n < arguments.length; n++)
    t[n - 1] = arguments[n];
  return t.reduce(function(r, i) {
    var o = e["border-" + i + "-width"];
    return r + AS(o);
  }, 0);
}
function vOe(e) {
  for (var t = ["top", "right", "bottom", "left"], n = {}, r = 0, i = t; r < i.length; r++) {
    var o = i[r], a = e["padding-" + o];
    n[o] = AS(a);
  }
  return n;
}
function yOe(e) {
  var t = e.getBBox();
  return RE(0, 0, t.width, t.height);
}
function bOe(e) {
  var t = e.clientWidth, n = e.clientHeight;
  if (!t && !n)
    return kX;
  var r = zg(e).getComputedStyle(e), i = vOe(r), o = i.left + i.right, a = i.top + i.bottom, s = AS(r.width), c = AS(r.height);
  if (r.boxSizing === "border-box" && (Math.round(s + o) !== t && (s -= Yj(r, "left", "right") + o), Math.round(c + a) !== n && (c -= Yj(r, "top", "bottom") + a)), !SOe(e)) {
    var l = Math.round(s + o) - t, u = Math.round(c + a) - n;
    Math.abs(l) !== 1 && (s -= l), Math.abs(u) !== 1 && (c -= u);
  }
  return RE(i.left, i.top, s, c);
}
var _Oe = function() {
  return typeof SVGGraphicsElement < "u" ? function(e) {
    return e instanceof zg(e).SVGGraphicsElement;
  } : function(e) {
    return e instanceof zg(e).SVGElement && typeof e.getBBox == "function";
  };
}();
function SOe(e) {
  return e === zg(e).document.documentElement;
}
function wOe(e) {
  return DA ? _Oe(e) ? yOe(e) : bOe(e) : kX;
}
function xOe(e) {
  var t = e.x, n = e.y, r = e.width, i = e.height, o = typeof DOMRectReadOnly < "u" ? DOMRectReadOnly : Object, a = Object.create(o.prototype);
  return MX(a, {
    x: t,
    y: n,
    width: r,
    height: i,
    top: n,
    right: t + r,
    bottom: i + n,
    left: t
  }), a;
}
function RE(e, t, n, r) {
  return { x: e, y: t, width: n, height: r };
}
var EOe = (
  /** @class */
  function() {
    function e(t) {
      this.broadcastWidth = 0, this.broadcastHeight = 0, this.contentRect_ = RE(0, 0, 0, 0), this.target = t;
    }
    return e.prototype.isActive = function() {
      var t = wOe(this.target);
      return this.contentRect_ = t, t.width !== this.broadcastWidth || t.height !== this.broadcastHeight;
    }, e.prototype.broadcastRect = function() {
      var t = this.contentRect_;
      return this.broadcastWidth = t.width, this.broadcastHeight = t.height, t;
    }, e;
  }()
), COe = (
  /** @class */
  function() {
    function e(t, n) {
      var r = xOe(n);
      MX(this, { target: t, contentRect: r });
    }
    return e;
  }()
), TOe = (
  /** @class */
  function() {
    function e(t, n, r) {
      if (this.activeObservations_ = [], this.observations_ = new OX(), typeof t != "function")
        throw new TypeError("The callback provided as parameter 1 is not a function.");
      this.callback_ = t, this.controller_ = n, this.callbackCtx_ = r;
    }
    return e.prototype.observe = function(t) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(t instanceof zg(t).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var n = this.observations_;
        n.has(t) || (n.set(t, new EOe(t)), this.controller_.addObserver(this), this.controller_.refresh());
      }
    }, e.prototype.unobserve = function(t) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(t instanceof zg(t).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var n = this.observations_;
        n.has(t) && (n.delete(t), n.size || this.controller_.removeObserver(this));
      }
    }, e.prototype.disconnect = function() {
      this.clearActive(), this.observations_.clear(), this.controller_.removeObserver(this);
    }, e.prototype.gatherActive = function() {
      var t = this;
      this.clearActive(), this.observations_.forEach(function(n) {
        n.isActive() && t.activeObservations_.push(n);
      });
    }, e.prototype.broadcastActive = function() {
      if (this.hasActive()) {
        var t = this.callbackCtx_, n = this.activeObservations_.map(function(r) {
          return new COe(r.target, r.broadcastRect());
        });
        this.callback_.call(t, n, t), this.clearActive();
      }
    }, e.prototype.clearActive = function() {
      this.activeObservations_.splice(0);
    }, e.prototype.hasActive = function() {
      return this.activeObservations_.length > 0;
    }, e;
  }()
), NX = typeof WeakMap < "u" ? /* @__PURE__ */ new WeakMap() : new OX(), DX = (
  /** @class */
  function() {
    function e(t) {
      if (!(this instanceof e))
        throw new TypeError("Cannot call a class as a function.");
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      var n = mOe.getInstance(), r = new TOe(t, n, this);
      NX.set(this, r);
    }
    return e;
  }()
);
[
  "observe",
  "unobserve",
  "disconnect"
].forEach(function(e) {
  DX.prototype[e] = function() {
    var t;
    return (t = NX.get(this))[e].apply(t, arguments);
  };
});
var IOe = function() {
  return typeof $S.ResizeObserver < "u" ? $S.ResizeObserver : DX;
}(), Zc = /* @__PURE__ */ new Map();
function jX(e) {
  e.forEach(function(t) {
    var n, r = t.target;
    (n = Zc.get(r)) === null || n === void 0 || n.forEach(function(i) {
      return i(r);
    });
  });
}
var LX = new IOe(jX);
process.env.NODE_ENV;
process.env.NODE_ENV;
function $Oe(e, t) {
  Zc.has(e) || (Zc.set(e, /* @__PURE__ */ new Set()), LX.observe(e)), Zc.get(e).add(t);
}
function AOe(e, t) {
  Zc.has(e) && (Zc.get(e).delete(t), Zc.get(e).size || (LX.unobserve(e), Zc.delete(e)));
}
function xr(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Xj(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, uU(r.key), r);
  }
}
function Er(e, t, n) {
  return t && Xj(e.prototype, t), n && Xj(e, n), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function Sv(e, t) {
  return Sv = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, r) {
    return n.__proto__ = r, n;
  }, Sv(e, t);
}
function Ds(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && Sv(e, t);
}
function wf(e) {
  return wf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, wf(e);
}
function PE() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (PE = function() {
    return !!e;
  })();
}
function rn(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function FX(e, t) {
  if (t && (It(t) == "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return rn(e);
}
function Ac(e) {
  var t = PE();
  return function() {
    var n, r = wf(e);
    if (t) {
      var i = wf(this).constructor;
      n = Reflect.construct(r, arguments, i);
    } else
      n = r.apply(this, arguments);
    return FX(this, n);
  };
}
var ROe = /* @__PURE__ */ function(e) {
  Ds(n, e);
  var t = Ac(n);
  function n() {
    return xr(this, n), t.apply(this, arguments);
  }
  return Er(n, [{
    key: "render",
    value: function() {
      return this.props.children;
    }
  }]), n;
}($.Component);
function POe(e, t) {
  var n = e.children, r = e.disabled, i = $.useRef(null), o = $.useRef(null), a = $.useContext(NA), s = typeof n == "function", c = s ? n(i) : n, l = $.useRef({
    width: -1,
    height: -1,
    offsetWidth: -1,
    offsetHeight: -1
  }), u = !s && /* @__PURE__ */ $.isValidElement(c) && $y(c), d = u ? c.ref : null, f = AE(d, i), h = function() {
    var v;
    return L0(i.current) || // Support `nativeElement` format
    (i.current && It(i.current) === "object" ? L0((v = i.current) === null || v === void 0 ? void 0 : v.nativeElement) : null) || L0(o.current);
  };
  $.useImperativeHandle(t, function() {
    return h();
  });
  var p = $.useRef(e);
  p.current = e;
  var g = $.useCallback(function(m) {
    var v = p.current, y = v.onResize, _ = v.data, b = m.getBoundingClientRect(), w = b.width, C = b.height, x = m.offsetWidth, T = m.offsetHeight, E = Math.floor(w), R = Math.floor(C);
    if (l.current.width !== E || l.current.height !== R || l.current.offsetWidth !== x || l.current.offsetHeight !== T) {
      var I = {
        width: E,
        height: R,
        offsetWidth: x,
        offsetHeight: T
      };
      l.current = I;
      var O = x === Math.round(w) ? w : x, P = T === Math.round(C) ? C : T, k = ae(ae({}, I), {}, {
        offsetWidth: O,
        offsetHeight: P
      });
      a == null || a(k, m, _), y && Promise.resolve().then(function() {
        y(k, m);
      });
    }
  }, []);
  return $.useEffect(function() {
    var m = h();
    return m && !r && $Oe(m, g), function() {
      return AOe(m, g);
    };
  }, [i.current, r]), /* @__PURE__ */ $.createElement(ROe, {
    ref: o
  }, u ? /* @__PURE__ */ $.cloneElement(c, {
    ref: f
  }) : c);
}
var VX = /* @__PURE__ */ $.forwardRef(POe);
process.env.NODE_ENV !== "production" && (VX.displayName = "SingleObserver");
var OOe = "rc-observer-key";
function MOe(e, t) {
  var n = e.children, r = typeof n == "function" ? [n] : Sf(n);
  return process.env.NODE_ENV !== "production" && (r.length > 1 ? Du(!1, "Find more than one child node with `children` in ResizeObserver. Please use ResizeObserver.Collection instead.") : r.length === 0 && Du(!1, "`children` of ResizeObserver is empty. Nothing is in observe.")), r.map(function(i, o) {
    var a = (i == null ? void 0 : i.key) || "".concat(OOe, "-").concat(o);
    return /* @__PURE__ */ $.createElement(VX, xt({}, e, {
      key: a,
      ref: o === 0 ? t : void 0
    }), i);
  });
}
var Cl = /* @__PURE__ */ $.forwardRef(MOe);
process.env.NODE_ENV !== "production" && (Cl.displayName = "ResizeObserver");
Cl.Collection = lOe;
function rd(e, t) {
  var n = Object.assign({}, e);
  return Array.isArray(t) && t.forEach(function(r) {
    delete n[r];
  }), n;
}
function jA(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function kOe(e) {
  if (Array.isArray(e))
    return jA(e);
}
function BX(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function sM(e, t) {
  if (e) {
    if (typeof e == "string")
      return jA(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? jA(e, t) : void 0;
  }
}
function NOe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function tt(e) {
  return kOe(e) || BX(e) || sM(e) || NOe();
}
var zX = function(t) {
  return +setTimeout(t, 16);
}, HX = function(t) {
  return clearTimeout(t);
};
typeof window < "u" && "requestAnimationFrame" in window && (zX = function(t) {
  return window.requestAnimationFrame(t);
}, HX = function(t) {
  return window.cancelAnimationFrame(t);
});
var Qj = 0, OE = /* @__PURE__ */ new Map();
function UX(e) {
  OE.delete(e);
}
var Ln = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  Qj += 1;
  var r = Qj;
  function i(o) {
    if (o === 0)
      UX(r), t();
    else {
      var a = zX(function() {
        i(o - 1);
      });
      OE.set(r, a);
    }
  }
  return i(n), r;
};
Ln.cancel = function(e) {
  var t = OE.get(e);
  return UX(e), HX(t);
};
process.env.NODE_ENV !== "production" && (Ln.ids = function() {
  return OE;
});
function WX(e) {
  if (Array.isArray(e))
    return e;
}
function DOe(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, i, o, a, s = [], c = !0, l = !1;
    try {
      if (o = (n = n.call(e)).next, t === 0) {
        if (Object(n) !== n)
          return;
        c = !1;
      } else
        for (; !(c = (r = o.call(n)).done) && (s.push(r.value), s.length !== t); c = !0)
          ;
    } catch (u) {
      l = !0, i = u;
    } finally {
      try {
        if (!c && n.return != null && (a = n.return(), Object(a) !== a))
          return;
      } finally {
        if (l)
          throw i;
      }
    }
    return s;
  }
}
function qX() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function he(e, t) {
  return WX(e) || DOe(e, t) || sM(e, t) || qX();
}
function wv(e) {
  for (var t = 0, n, r = 0, i = e.length; i >= 4; ++r, i -= 4)
    n = e.charCodeAt(r) & 255 | (e.charCodeAt(++r) & 255) << 8 | (e.charCodeAt(++r) & 255) << 16 | (e.charCodeAt(++r) & 255) << 24, n = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= /* k >>> r: */
    n >>> 24, t = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  switch (i) {
    case 3:
      t ^= (e.charCodeAt(r + 2) & 255) << 16;
    case 2:
      t ^= (e.charCodeAt(r + 1) & 255) << 8;
    case 1:
      t ^= e.charCodeAt(r) & 255, t = /* Math.imul(h, m): */
      (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  }
  return t ^= t >>> 13, t = /* Math.imul(h, m): */
  (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
function uo() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
function jOe(e, t) {
  if (!e)
    return !1;
  if (e.contains)
    return e.contains(t);
  for (var n = t; n; ) {
    if (n === e)
      return !0;
    n = n.parentNode;
  }
  return !1;
}
var Jj = "data-rc-order", Zj = "data-rc-priority", LOe = "rc-util-key", LA = /* @__PURE__ */ new Map();
function GX() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = e.mark;
  return t ? t.startsWith("data-") ? t : "data-".concat(t) : LOe;
}
function ME(e) {
  if (e.attachTo)
    return e.attachTo;
  var t = document.querySelector("head");
  return t || document.body;
}
function FOe(e) {
  return e === "queue" ? "prependQueue" : e ? "prepend" : "append";
}
function cM(e) {
  return Array.from((LA.get(e) || e).children).filter(function(t) {
    return t.tagName === "STYLE";
  });
}
function KX(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (!uo())
    return null;
  var n = t.csp, r = t.prepend, i = t.priority, o = i === void 0 ? 0 : i, a = FOe(r), s = a === "prependQueue", c = document.createElement("style");
  c.setAttribute(Jj, a), s && o && c.setAttribute(Zj, "".concat(o)), n != null && n.nonce && (c.nonce = n == null ? void 0 : n.nonce), c.innerHTML = e;
  var l = ME(t), u = l.firstChild;
  if (r) {
    if (s) {
      var d = (t.styles || cM(l)).filter(function(f) {
        if (!["prepend", "prependQueue"].includes(f.getAttribute(Jj)))
          return !1;
        var h = Number(f.getAttribute(Zj) || 0);
        return o >= h;
      });
      if (d.length)
        return l.insertBefore(c, d[d.length - 1].nextSibling), c;
    }
    l.insertBefore(c, u);
  } else
    l.appendChild(c);
  return c;
}
function YX(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = ME(t);
  return (t.styles || cM(n)).find(function(r) {
    return r.getAttribute(GX(t)) === e;
  });
}
function Hg(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = YX(e, t);
  if (n) {
    var r = ME(t);
    r.removeChild(n);
  }
}
function VOe(e, t) {
  var n = LA.get(e);
  if (!n || !jOe(document, n)) {
    var r = KX("", t), i = r.parentNode;
    LA.set(e, i), e.removeChild(r);
  }
}
function mc(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = ME(n), i = cM(r), o = ae(ae({}, n), {}, {
    styles: i
  });
  VOe(r, o);
  var a = YX(t, o);
  if (a) {
    var s, c;
    if ((s = o.csp) !== null && s !== void 0 && s.nonce && a.nonce !== ((c = o.csp) === null || c === void 0 ? void 0 : c.nonce)) {
      var l;
      a.nonce = (l = o.csp) === null || l === void 0 ? void 0 : l.nonce;
    }
    return a.innerHTML !== e && (a.innerHTML = e), a;
  }
  var u = KX(e, o);
  return u.setAttribute(GX(o), t), u;
}
function En(e, t) {
  if (e == null)
    return {};
  var n, r, i = rue(e, t);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (r = 0; r < o.length; r++)
      n = o[r], t.includes(n) || {}.propertyIsEnumerable.call(e, n) && (i[n] = e[n]);
  }
  return i;
}
function Ug(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, r = /* @__PURE__ */ new Set();
  function i(o, a) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, c = r.has(o);
    if (sn(!c, "Warning: There may be circular references"), c)
      return !1;
    if (o === a)
      return !0;
    if (n && s > 1)
      return !1;
    r.add(o);
    var l = s + 1;
    if (Array.isArray(o)) {
      if (!Array.isArray(a) || o.length !== a.length)
        return !1;
      for (var u = 0; u < o.length; u++)
        if (!i(o[u], a[u], l))
          return !1;
      return !0;
    }
    if (o && a && It(o) === "object" && It(a) === "object") {
      var d = Object.keys(o);
      return d.length !== Object.keys(a).length ? !1 : d.every(function(f) {
        return i(o[f], a[f], l);
      });
    }
    return !1;
  }
  return i(e, t);
}
var BOe = "%";
function FA(e) {
  return e.join(BOe);
}
var zOe = /* @__PURE__ */ function() {
  function e(t) {
    xr(this, e), oe(this, "instanceId", void 0), oe(this, "cache", /* @__PURE__ */ new Map()), this.instanceId = t;
  }
  return Er(e, [{
    key: "get",
    value: function(n) {
      return this.opGet(FA(n));
    }
    /** A fast get cache with `get` concat. */
  }, {
    key: "opGet",
    value: function(n) {
      return this.cache.get(n) || null;
    }
  }, {
    key: "update",
    value: function(n, r) {
      return this.opUpdate(FA(n), r);
    }
    /** A fast get cache with `get` concat. */
  }, {
    key: "opUpdate",
    value: function(n, r) {
      var i = this.cache.get(n), o = r(i);
      o === null ? this.cache.delete(n) : this.cache.set(n, o);
    }
  }]), e;
}(), HOe = ["children"], Wg = "data-token-hash", ws = "data-css-hash", UOe = "data-cache-path", nu = "__cssinjs_instance__";
function lM() {
  var e = Math.random().toString(12).slice(2);
  if (typeof document < "u" && document.head && document.body) {
    var t = document.body.querySelectorAll("style[".concat(ws, "]")) || [], n = document.head.firstChild;
    Array.from(t).forEach(function(i) {
      i[nu] = i[nu] || e, i[nu] === e && document.head.insertBefore(i, n);
    });
    var r = {};
    Array.from(document.querySelectorAll("style[".concat(ws, "]"))).forEach(function(i) {
      var o = i.getAttribute(ws);
      if (r[o]) {
        if (i[nu] === e) {
          var a;
          (a = i.parentNode) === null || a === void 0 || a.removeChild(i);
        }
      } else
        r[o] = !0;
    });
  }
  return new zOe(e);
}
var qg = /* @__PURE__ */ $.createContext({
  hashPriority: "low",
  cache: lM(),
  defaultCache: !0
}), WOe = function(t) {
  var n = t.children, r = En(t, HOe), i = $.useContext(qg), o = Iy(function() {
    var a = ae({}, i);
    Object.keys(r).forEach(function(c) {
      var l = r[c];
      r[c] !== void 0 && (a[c] = l);
    });
    var s = r.cache;
    return a.cache = a.cache || lM(), a.defaultCache = !s && i.defaultCache, a;
  }, [i, r], function(a, s) {
    return !Ug(a[0], s[0], !0) || !Ug(a[1], s[1], !0);
  });
  return /* @__PURE__ */ $.createElement(qg.Provider, {
    value: o
  }, n);
}, XX = /* @__PURE__ */ Er(function e() {
  xr(this, e);
}), QX = "CALC_UNIT", qOe = new RegExp(QX, "g");
function iT(e) {
  return typeof e == "number" ? "".concat(e).concat(QX) : e;
}
var GOe = /* @__PURE__ */ function(e) {
  Ds(n, e);
  var t = Ac(n);
  function n(r, i) {
    var o;
    xr(this, n), o = t.call(this), oe(rn(o), "result", ""), oe(rn(o), "unitlessCssVar", void 0), oe(rn(o), "lowPriority", void 0);
    var a = It(r);
    return o.unitlessCssVar = i, r instanceof n ? o.result = "(".concat(r.result, ")") : a === "number" ? o.result = iT(r) : a === "string" && (o.result = r), o;
  }
  return Er(n, [{
    key: "add",
    value: function(i) {
      return i instanceof n ? this.result = "".concat(this.result, " + ").concat(i.getResult()) : (typeof i == "number" || typeof i == "string") && (this.result = "".concat(this.result, " + ").concat(iT(i))), this.lowPriority = !0, this;
    }
  }, {
    key: "sub",
    value: function(i) {
      return i instanceof n ? this.result = "".concat(this.result, " - ").concat(i.getResult()) : (typeof i == "number" || typeof i == "string") && (this.result = "".concat(this.result, " - ").concat(iT(i))), this.lowPriority = !0, this;
    }
  }, {
    key: "mul",
    value: function(i) {
      return this.lowPriority && (this.result = "(".concat(this.result, ")")), i instanceof n ? this.result = "".concat(this.result, " * ").concat(i.getResult(!0)) : (typeof i == "number" || typeof i == "string") && (this.result = "".concat(this.result, " * ").concat(i)), this.lowPriority = !1, this;
    }
  }, {
    key: "div",
    value: function(i) {
      return this.lowPriority && (this.result = "(".concat(this.result, ")")), i instanceof n ? this.result = "".concat(this.result, " / ").concat(i.getResult(!0)) : (typeof i == "number" || typeof i == "string") && (this.result = "".concat(this.result, " / ").concat(i)), this.lowPriority = !1, this;
    }
  }, {
    key: "getResult",
    value: function(i) {
      return this.lowPriority || i ? "(".concat(this.result, ")") : this.result;
    }
  }, {
    key: "equal",
    value: function(i) {
      var o = this, a = i || {}, s = a.unit, c = !0;
      return typeof s == "boolean" ? c = s : Array.from(this.unitlessCssVar).some(function(l) {
        return o.result.includes(l);
      }) && (c = !1), this.result = this.result.replace(qOe, c ? "px" : ""), typeof this.lowPriority < "u" ? "calc(".concat(this.result, ")") : this.result;
    }
  }]), n;
}(XX), KOe = /* @__PURE__ */ function(e) {
  Ds(n, e);
  var t = Ac(n);
  function n(r) {
    var i;
    return xr(this, n), i = t.call(this), oe(rn(i), "result", 0), r instanceof n ? i.result = r.result : typeof r == "number" && (i.result = r), i;
  }
  return Er(n, [{
    key: "add",
    value: function(i) {
      return i instanceof n ? this.result += i.result : typeof i == "number" && (this.result += i), this;
    }
  }, {
    key: "sub",
    value: function(i) {
      return i instanceof n ? this.result -= i.result : typeof i == "number" && (this.result -= i), this;
    }
  }, {
    key: "mul",
    value: function(i) {
      return i instanceof n ? this.result *= i.result : typeof i == "number" && (this.result *= i), this;
    }
  }, {
    key: "div",
    value: function(i) {
      return i instanceof n ? this.result /= i.result : typeof i == "number" && (this.result /= i), this;
    }
  }, {
    key: "equal",
    value: function() {
      return this.result;
    }
  }]), n;
}(XX), YOe = function(t, n) {
  var r = t === "css" ? GOe : KOe;
  return function(i) {
    return new r(i, n);
  };
};
function XOe(e, t) {
  if (e.length !== t.length)
    return !1;
  for (var n = 0; n < e.length; n++)
    if (e[n] !== t[n])
      return !1;
  return !0;
}
var uM = /* @__PURE__ */ function() {
  function e() {
    xr(this, e), oe(this, "cache", void 0), oe(this, "keys", void 0), oe(this, "cacheCallTimes", void 0), this.cache = /* @__PURE__ */ new Map(), this.keys = [], this.cacheCallTimes = 0;
  }
  return Er(e, [{
    key: "size",
    value: function() {
      return this.keys.length;
    }
  }, {
    key: "internalGet",
    value: function(n) {
      var r, i, o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, a = {
        map: this.cache
      };
      return n.forEach(function(s) {
        if (!a)
          a = void 0;
        else {
          var c;
          a = (c = a) === null || c === void 0 || (c = c.map) === null || c === void 0 ? void 0 : c.get(s);
        }
      }), (r = a) !== null && r !== void 0 && r.value && o && (a.value[1] = this.cacheCallTimes++), (i = a) === null || i === void 0 ? void 0 : i.value;
    }
  }, {
    key: "get",
    value: function(n) {
      var r;
      return (r = this.internalGet(n, !0)) === null || r === void 0 ? void 0 : r[0];
    }
  }, {
    key: "has",
    value: function(n) {
      return !!this.internalGet(n);
    }
  }, {
    key: "set",
    value: function(n, r) {
      var i = this;
      if (!this.has(n)) {
        if (this.size() + 1 > e.MAX_CACHE_SIZE + e.MAX_CACHE_OFFSET) {
          var o = this.keys.reduce(function(l, u) {
            var d = he(l, 2), f = d[1];
            return i.internalGet(u)[1] < f ? [u, i.internalGet(u)[1]] : l;
          }, [this.keys[0], this.cacheCallTimes]), a = he(o, 1), s = a[0];
          this.delete(s);
        }
        this.keys.push(n);
      }
      var c = this.cache;
      n.forEach(function(l, u) {
        if (u === n.length - 1)
          c.set(l, {
            value: [r, i.cacheCallTimes++]
          });
        else {
          var d = c.get(l);
          d ? d.map || (d.map = /* @__PURE__ */ new Map()) : c.set(l, {
            map: /* @__PURE__ */ new Map()
          }), c = c.get(l).map;
        }
      });
    }
  }, {
    key: "deleteByPath",
    value: function(n, r) {
      var i = n.get(r[0]);
      if (r.length === 1) {
        var o;
        return i.map ? n.set(r[0], {
          map: i.map
        }) : n.delete(r[0]), (o = i.value) === null || o === void 0 ? void 0 : o[0];
      }
      var a = this.deleteByPath(i.map, r.slice(1));
      return (!i.map || i.map.size === 0) && !i.value && n.delete(r[0]), a;
    }
  }, {
    key: "delete",
    value: function(n) {
      if (this.has(n))
        return this.keys = this.keys.filter(function(r) {
          return !XOe(r, n);
        }), this.deleteByPath(this.cache, n);
    }
  }]), e;
}();
oe(uM, "MAX_CACHE_SIZE", 20);
oe(uM, "MAX_CACHE_OFFSET", 5);
var eL = 0, dM = /* @__PURE__ */ function() {
  function e(t) {
    xr(this, e), oe(this, "derivatives", void 0), oe(this, "id", void 0), this.derivatives = Array.isArray(t) ? t : [t], this.id = eL, t.length === 0 && Du(t.length > 0, "[Ant Design CSS-in-JS] Theme should have at least one derivative function."), eL += 1;
  }
  return Er(e, [{
    key: "getDerivativeToken",
    value: function(n) {
      return this.derivatives.reduce(function(r, i) {
        return i(n, r);
      }, void 0);
    }
  }]), e;
}(), oT = new uM();
function RS(e) {
  var t = Array.isArray(e) ? e : [e];
  return oT.has(t) || oT.set(t, new dM(t)), oT.get(t);
}
var QOe = /* @__PURE__ */ new WeakMap(), aT = {};
function JOe(e, t) {
  for (var n = QOe, r = 0; r < t.length; r += 1) {
    var i = t[r];
    n.has(i) || n.set(i, /* @__PURE__ */ new WeakMap()), n = n.get(i);
  }
  return n.has(aT) || n.set(aT, e()), n.get(aT);
}
var tL = /* @__PURE__ */ new WeakMap();
function F0(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, n = tL.get(e) || "";
  return n || (Object.keys(e).forEach(function(r) {
    var i = e[r];
    n += r, i instanceof dM ? n += i.id : i && It(i) === "object" ? n += F0(i, t) : n += i;
  }), t && (n = wv(n)), tL.set(e, n)), n;
}
function nL(e, t) {
  return wv("".concat(t, "_").concat(F0(e, !0)));
}
var Gg = "random-".concat(Date.now(), "-").concat(Math.random()).replace(/\./g, ""), JX = "_bAmBoO_";
function ZX(e, t, n) {
  if (uo()) {
    var r, i;
    mc(e, Gg);
    var o = document.createElement("div");
    o.style.position = "fixed", o.style.left = "0", o.style.top = "0", t == null || t(o), document.body.appendChild(o), process.env.NODE_ENV !== "production" && (o.innerHTML = "Test", o.style.zIndex = "9999999");
    var a = n ? n(o) : (r = getComputedStyle(o).content) === null || r === void 0 ? void 0 : r.includes(JX);
    return (i = o.parentNode) === null || i === void 0 || i.removeChild(o), Hg(Gg), a;
  }
  return !1;
}
var sT = void 0;
function ZOe() {
  return sT === void 0 && (sT = ZX(":where(.".concat(Gg, ') { content: "').concat(JX, '"!important; }'), function(e) {
    e.className = Gg;
  })), sT;
}
var cT = void 0;
function e6e() {
  return cT === void 0 && (cT = ZX(".".concat(Gg, " { inset-block: 93px !important; }"), function(e) {
    e.className = Gg;
  }, function(e) {
    return getComputedStyle(e).bottom === "93px";
  })), cT;
}
var VA = uo();
function et(e) {
  return typeof e == "number" ? "".concat(e, "px") : e;
}
function xv(e, t, n) {
  var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !1;
  if (i)
    return e;
  var o = ae(ae({}, r), {}, oe(oe({}, Wg, t), ws, n)), a = Object.keys(o).map(function(s) {
    var c = o[s];
    return c ? "".concat(s, '="').concat(c, '"') : null;
  }).filter(function(s) {
    return s;
  }).join(" ");
  return "<style ".concat(a, ">").concat(e, "</style>");
}
var V0 = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
  return "--".concat(n ? "".concat(n, "-") : "").concat(t).replace(/([a-z0-9])([A-Z])/g, "$1-$2").replace(/([A-Z]+)([A-Z][a-z0-9]+)/g, "$1-$2").replace(/([a-z])([A-Z0-9])/g, "$1-$2").toLowerCase();
}, t6e = function(t, n, r) {
  return Object.keys(t).length ? ".".concat(n).concat(r != null && r.scope ? ".".concat(r.scope) : "", "{").concat(Object.entries(t).map(function(i) {
    var o = he(i, 2), a = o[0], s = o[1];
    return "".concat(a, ":").concat(s, ";");
  }).join(""), "}") : "";
}, eQ = function(t, n, r) {
  var i = {}, o = {};
  return Object.entries(t).forEach(function(a) {
    var s, c, l = he(a, 2), u = l[0], d = l[1];
    if (r != null && (s = r.preserve) !== null && s !== void 0 && s[u])
      o[u] = d;
    else if ((typeof d == "string" || typeof d == "number") && !(r != null && (c = r.ignore) !== null && c !== void 0 && c[u])) {
      var f, h = V0(u, r == null ? void 0 : r.prefix);
      i[h] = typeof d == "number" && !(r != null && (f = r.unitless) !== null && f !== void 0 && f[u]) ? "".concat(d, "px") : String(d), o[u] = "var(".concat(h, ")");
    }
  }), [o, t6e(i, n, {
    scope: r == null ? void 0 : r.scope
  })];
}, rL = process.env.NODE_ENV !== "test" && uo() ? $.useLayoutEffect : $.useEffect, ar = function(t, n) {
  var r = $.useRef(!0);
  rL(function() {
    return t(r.current);
  }, n), rL(function() {
    return r.current = !1, function() {
      r.current = !0;
    };
  }, []);
}, B0 = function(t, n) {
  ar(function(r) {
    if (!r)
      return t();
  }, n);
}, n6e = ae({}, $), iL = n6e.useInsertionEffect, r6e = function(t, n, r) {
  $.useMemo(t, r), ar(function() {
    return n(!0);
  }, r);
}, i6e = iL ? function(e, t, n) {
  return iL(function() {
    return e(), t();
  }, n);
} : r6e, o6e = ae({}, $), a6e = o6e.useInsertionEffect, s6e = function(t) {
  var n = [], r = !1;
  function i(o) {
    if (r) {
      process.env.NODE_ENV !== "production" && Du(!1, "[Ant Design CSS-in-JS] You are registering a cleanup function after unmount, which will not have any effect.");
      return;
    }
    n.push(o);
  }
  return $.useEffect(function() {
    return r = !1, function() {
      r = !0, n.length && n.forEach(function(o) {
        return o();
      });
    };
  }, t), i;
}, c6e = function() {
  return function(t) {
    t();
  };
}, l6e = typeof a6e < "u" ? s6e : c6e;
function u6e() {
  return !1;
}
var BA = !1;
function d6e() {
  return BA;
}
const f6e = process.env.NODE_ENV === "production" ? u6e : d6e;
if (process.env.NODE_ENV !== "production" && typeof module < "u" && module && module.hot && typeof window < "u") {
  var lT = window;
  if (typeof lT.webpackHotUpdate == "function") {
    var h6e = lT.webpackHotUpdate;
    lT.webpackHotUpdate = function() {
      return BA = !0, setTimeout(function() {
        BA = !1;
      }, 0), h6e.apply(void 0, arguments);
    };
  }
}
function fM(e, t, n, r, i) {
  var o = $.useContext(qg), a = o.cache, s = [e].concat(tt(t)), c = FA(s), l = l6e([c]), u = f6e(), d = function(g) {
    a.opUpdate(c, function(m) {
      var v = m || [void 0, void 0], y = he(v, 2), _ = y[0], b = _ === void 0 ? 0 : _, w = y[1], C = w;
      process.env.NODE_ENV !== "production" && w && u && (r == null || r(C, u), C = null);
      var x = C || n(), T = [b, x];
      return g ? g(T) : T;
    });
  };
  $.useMemo(
    function() {
      d();
    },
    /* eslint-disable react-hooks/exhaustive-deps */
    [c]
    /* eslint-enable */
  );
  var f = a.opGet(c);
  process.env.NODE_ENV !== "production" && !f && (d(), f = a.opGet(c));
  var h = f[1];
  return i6e(function() {
    i == null || i(h);
  }, function(p) {
    return d(function(g) {
      var m = he(g, 2), v = m[0], y = m[1];
      return p && v === 0 && (i == null || i(h)), [v + 1, y];
    }), function() {
      a.opUpdate(c, function(g) {
        var m = g || [], v = he(m, 2), y = v[0], _ = y === void 0 ? 0 : y, b = v[1], w = _ - 1;
        return w === 0 ? (l(function() {
          (p || !a.opGet(c)) && (r == null || r(b, !1));
        }), null) : [_ - 1, b];
      });
    };
  }, [c]), h;
}
var g6e = {}, p6e = process.env.NODE_ENV !== "production" ? "css-dev-only-do-not-override" : "css", Rd = /* @__PURE__ */ new Map();
function m6e(e) {
  Rd.set(e, (Rd.get(e) || 0) + 1);
}
function v6e(e, t) {
  if (typeof document < "u") {
    var n = document.querySelectorAll("style[".concat(Wg, '="').concat(e, '"]'));
    n.forEach(function(r) {
      if (r[nu] === t) {
        var i;
        (i = r.parentNode) === null || i === void 0 || i.removeChild(r);
      }
    });
  }
}
var y6e = 0;
function b6e(e, t) {
  Rd.set(e, (Rd.get(e) || 0) - 1);
  var n = Array.from(Rd.keys()), r = n.filter(function(i) {
    var o = Rd.get(i) || 0;
    return o <= 0;
  });
  n.length - r.length > y6e && r.forEach(function(i) {
    v6e(i, t), Rd.delete(i);
  });
}
var tQ = function(t, n, r, i) {
  var o = r.getDerivativeToken(t), a = ae(ae({}, o), n);
  return i && (a = i(a)), a;
}, nQ = "token";
function rQ(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = gt(qg), i = r.cache.instanceId, o = r.container, a = n.salt, s = a === void 0 ? "" : a, c = n.override, l = c === void 0 ? g6e : c, u = n.formatToken, d = n.getComputedToken, f = n.cssVar, h = JOe(function() {
    return Object.assign.apply(Object, [{}].concat(tt(t)));
  }, t), p = F0(h), g = F0(l), m = f ? F0(f) : "", v = fM(nQ, [s, e.id, p, g, m], function() {
    var y, _ = d ? d(h, l, e) : tQ(h, l, e, u), b = ae({}, _), w = "";
    if (f) {
      var C = eQ(_, f.key, {
        prefix: f.prefix,
        ignore: f.ignore,
        unitless: f.unitless,
        preserve: f.preserve
      }), x = he(C, 2);
      _ = x[0], w = x[1];
    }
    var T = nL(_, s);
    _._tokenKey = T, b._tokenKey = nL(b, s);
    var E = (y = f == null ? void 0 : f.key) !== null && y !== void 0 ? y : T;
    _._themeKey = E, m6e(E);
    var R = "".concat(p6e, "-").concat(wv(T));
    return _._hashId = R, [_, R, b, w, (f == null ? void 0 : f.key) || ""];
  }, function(y) {
    b6e(y[0]._themeKey, i);
  }, function(y) {
    var _ = he(y, 4), b = _[0], w = _[3];
    if (f && w) {
      var C = mc(w, wv("css-variables-".concat(b._themeKey)), {
        mark: ws,
        prepend: "queue",
        attachTo: o,
        priority: -999
      });
      C[nu] = i, C.setAttribute(Wg, b._themeKey);
    }
  });
  return v;
}
var _6e = function(t, n, r) {
  var i = he(t, 5), o = i[2], a = i[3], s = i[4], c = r || {}, l = c.plain;
  if (!a)
    return null;
  var u = o._tokenKey, d = -999, f = {
    "data-rc-order": "prependQueue",
    "data-rc-priority": "".concat(d)
  }, h = xv(a, s, u, f, l);
  return [d, u, h];
}, iQ = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, oQ = "comm", aQ = "rule", sQ = "decl", S6e = "@import", w6e = "@keyframes", x6e = "@layer", cQ = Math.abs, hM = String.fromCharCode;
function lQ(e) {
  return e.trim();
}
function u_(e, t, n) {
  return e.replace(t, n);
}
function E6e(e, t, n) {
  return e.indexOf(t, n);
}
function Ev(e, t) {
  return e.charCodeAt(t) | 0;
}
function Kg(e, t, n) {
  return e.slice(t, n);
}
function Ys(e) {
  return e.length;
}
function C6e(e) {
  return e.length;
}
function i1(e, t) {
  return t.push(e), e;
}
var kE = 1, Yg = 1, uQ = 0, qa = 0, ci = 0, Gp = "";
function gM(e, t, n, r, i, o, a, s) {
  return { value: e, root: t, parent: n, type: r, props: i, children: o, line: kE, column: Yg, length: a, return: "", siblings: s };
}
function T6e() {
  return ci;
}
function I6e() {
  return ci = qa > 0 ? Ev(Gp, --qa) : 0, Yg--, ci === 10 && (Yg = 1, kE--), ci;
}
function xs() {
  return ci = qa < uQ ? Ev(Gp, qa++) : 0, Yg++, ci === 10 && (Yg = 1, kE++), ci;
}
function ru() {
  return Ev(Gp, qa);
}
function d_() {
  return qa;
}
function NE(e, t) {
  return Kg(Gp, e, t);
}
function Cv(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function $6e(e) {
  return kE = Yg = 1, uQ = Ys(Gp = e), qa = 0, [];
}
function A6e(e) {
  return Gp = "", e;
}
function uT(e) {
  return lQ(NE(qa - 1, zA(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function R6e(e) {
  for (; (ci = ru()) && ci < 33; )
    xs();
  return Cv(e) > 2 || Cv(ci) > 3 ? "" : " ";
}
function P6e(e, t) {
  for (; --t && xs() && !(ci < 48 || ci > 102 || ci > 57 && ci < 65 || ci > 70 && ci < 97); )
    ;
  return NE(e, d_() + (t < 6 && ru() == 32 && xs() == 32));
}
function zA(e) {
  for (; xs(); )
    switch (ci) {
      case e:
        return qa;
      case 34:
      case 39:
        e !== 34 && e !== 39 && zA(ci);
        break;
      case 40:
        e === 41 && zA(e);
        break;
      case 92:
        xs();
        break;
    }
  return qa;
}
function O6e(e, t) {
  for (; xs() && e + ci !== 47 + 10; )
    if (e + ci === 42 + 42 && ru() === 47)
      break;
  return "/*" + NE(t, qa - 1) + "*" + hM(e === 47 ? e : xs());
}
function M6e(e) {
  for (; !Cv(ru()); )
    xs();
  return NE(e, qa);
}
function k6e(e) {
  return A6e(f_("", null, null, null, [""], e = $6e(e), 0, [0], e));
}
function f_(e, t, n, r, i, o, a, s, c) {
  for (var l = 0, u = 0, d = a, f = 0, h = 0, p = 0, g = 1, m = 1, v = 1, y = 0, _ = "", b = i, w = o, C = r, x = _; m; )
    switch (p = y, y = xs()) {
      case 40:
        if (p != 108 && Ev(x, d - 1) == 58) {
          E6e(x += u_(uT(y), "&", "&\f"), "&\f", cQ(l ? s[l - 1] : 0)) != -1 && (v = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        x += uT(y);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        x += R6e(p);
        break;
      case 92:
        x += P6e(d_() - 1, 7);
        continue;
      case 47:
        switch (ru()) {
          case 42:
          case 47:
            i1(N6e(O6e(xs(), d_()), t, n, c), c), (Cv(p || 1) == 5 || Cv(ru() || 1) == 5) && Ys(x) && Kg(x, -1, void 0) !== " " && (x += " ");
            break;
          default:
            x += "/";
        }
        break;
      case 123 * g:
        s[l++] = Ys(x) * v;
      case 125 * g:
      case 59:
      case 0:
        switch (y) {
          case 0:
          case 125:
            m = 0;
          case 59 + u:
            v == -1 && (x = u_(x, /\f/g, "")), h > 0 && (Ys(x) - d || g === 0 && p === 47) && i1(h > 32 ? aL(x + ";", r, n, d - 1, c) : aL(u_(x, " ", "") + ";", r, n, d - 2, c), c);
            break;
          case 59:
            x += ";";
          default:
            if (i1(C = oL(x, t, n, l, u, i, s, _, b = [], w = [], d, o), o), y === 123)
              if (u === 0)
                f_(x, t, C, C, b, o, d, s, w);
              else
                switch (f === 99 && Ev(x, 3) === 110 ? 100 : f) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    f_(e, C, C, r && i1(oL(e, C, C, 0, 0, i, s, _, i, b = [], d, w), w), i, w, d, s, r ? b : w);
                    break;
                  default:
                    f_(x, C, C, C, [""], w, 0, s, w);
                }
        }
        l = u = h = 0, g = v = 1, _ = x = "", d = a;
        break;
      case 58:
        d = 1 + Ys(x), h = p;
      default:
        if (g < 1) {
          if (y == 123)
            --g;
          else if (y == 125 && g++ == 0 && I6e() == 125)
            continue;
        }
        switch (x += hM(y), y * g) {
          case 38:
            v = u > 0 ? 1 : (x += "\f", -1);
            break;
          case 44:
            s[l++] = (Ys(x) - 1) * v, v = 1;
            break;
          case 64:
            ru() === 45 && (x += uT(xs())), f = ru(), u = d = Ys(_ = x += M6e(d_())), y++;
            break;
          case 45:
            p === 45 && Ys(x) == 2 && (g = 0);
        }
    }
  return o;
}
function oL(e, t, n, r, i, o, a, s, c, l, u, d) {
  for (var f = i - 1, h = i === 0 ? o : [""], p = C6e(h), g = 0, m = 0, v = 0; g < r; ++g)
    for (var y = 0, _ = Kg(e, f + 1, f = cQ(m = a[g])), b = e; y < p; ++y)
      (b = lQ(m > 0 ? h[y] + " " + _ : u_(_, /&\f/g, h[y]))) && (c[v++] = b);
  return gM(e, t, n, i === 0 ? aQ : s, c, l, u, d);
}
function N6e(e, t, n, r) {
  return gM(e, t, n, oQ, hM(T6e()), Kg(e, 2, -2), 0, r);
}
function aL(e, t, n, r, i) {
  return gM(e, t, n, sQ, Kg(e, 0, r), Kg(e, r + 1, -1), r, i);
}
function HA(e, t) {
  for (var n = "", r = 0; r < e.length; r++)
    n += t(e[r], r, e, t) || "";
  return n;
}
function D6e(e, t, n, r) {
  switch (e.type) {
    case x6e:
      if (e.children.length)
        break;
    case S6e:
    case sQ:
      return e.return = e.return || e.value;
    case oQ:
      return "";
    case w6e:
      return e.return = e.value + "{" + HA(e.children, r) + "}";
    case aQ:
      if (!Ys(e.value = e.props.join(",")))
        return "";
  }
  return Ys(n = HA(e.children, r)) ? e.return = e.value + "{" + n + "}" : "";
}
function el(e, t) {
  var n = t.path, r = t.parentSelectors;
  sn(!1, "[Ant Design CSS-in-JS] ".concat(n ? "Error in ".concat(n, ": ") : "").concat(e).concat(r.length ? " Selector: ".concat(r.join(" | ")) : ""));
}
var j6e = function(t, n, r) {
  if (t === "content") {
    var i = /(attr|counters?|url|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/, o = ["normal", "none", "initial", "inherit", "unset"];
    (typeof n != "string" || o.indexOf(n) === -1 && !i.test(n) && (n.charAt(0) !== n.charAt(n.length - 1) || n.charAt(0) !== '"' && n.charAt(0) !== "'")) && el("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"".concat(n, "\"'`."), r);
  }
}, L6e = function(t, n, r) {
  t === "animation" && r.hashId && n !== "none" && el("You seem to be using hashed animation '".concat(n, "', in which case 'animationName' with Keyframe as value is recommended."), r);
};
function F6e(e) {
  var t, n = ((t = e.match(/:not\(([^)]*)\)/)) === null || t === void 0 ? void 0 : t[1]) || "", r = n.split(/(\[[^[]*])|(?=[.#])/).filter(function(i) {
    return i;
  });
  return r.length > 1;
}
function V6e(e) {
  return e.parentSelectors.reduce(function(t, n) {
    return t ? n.includes("&") ? n.replace(/&/g, t) : "".concat(t, " ").concat(n) : n;
  }, "");
}
var B6e = function(t, n, r) {
  var i = V6e(r), o = i.match(/:not\([^)]*\)/g) || [];
  o.length > 0 && o.some(F6e) && el("Concat ':not' selector not support in legacy browsers.", r);
}, z6e = function(t, n, r) {
  switch (t) {
    case "marginLeft":
    case "marginRight":
    case "paddingLeft":
    case "paddingRight":
    case "left":
    case "right":
    case "borderLeft":
    case "borderLeftWidth":
    case "borderLeftStyle":
    case "borderLeftColor":
    case "borderRight":
    case "borderRightWidth":
    case "borderRightStyle":
    case "borderRightColor":
    case "borderTopLeftRadius":
    case "borderTopRightRadius":
    case "borderBottomLeftRadius":
    case "borderBottomRightRadius":
      el("You seem to be using non-logical property '".concat(t, "' which is not compatible with RTL mode. Please use logical properties and values instead. For more information: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Logical_Properties."), r);
      return;
    case "margin":
    case "padding":
    case "borderWidth":
    case "borderStyle":
      if (typeof n == "string") {
        var i = n.split(" ").map(function(s) {
          return s.trim();
        });
        i.length === 4 && i[1] !== i[3] && el("You seem to be using '".concat(t, "' property with different left ").concat(t, " and right ").concat(t, ", which is not compatible with RTL mode. Please use logical properties and values instead. For more information: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Logical_Properties."), r);
      }
      return;
    case "clear":
    case "textAlign":
      (n === "left" || n === "right") && el("You seem to be using non-logical value '".concat(n, "' of ").concat(t, ", which is not compatible with RTL mode. Please use logical properties and values instead. For more information: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Logical_Properties."), r);
      return;
    case "borderRadius":
      if (typeof n == "string") {
        var o = n.split("/").map(function(s) {
          return s.trim();
        }), a = o.reduce(function(s, c) {
          if (s)
            return s;
          var l = c.split(" ").map(function(u) {
            return u.trim();
          });
          return l.length >= 2 && l[0] !== l[1] || l.length === 3 && l[1] !== l[2] || l.length === 4 && l[2] !== l[3] ? !0 : s;
        }, !1);
        a && el("You seem to be using non-logical value '".concat(n, "' of ").concat(t, ", which is not compatible with RTL mode. Please use logical properties and values instead. For more information: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Logical_Properties."), r);
      }
      return;
  }
}, H6e = function(t, n, r) {
  (typeof n == "string" && /NaN/g.test(n) || Number.isNaN(n)) && el("Unexpected 'NaN' in property '".concat(t, ": ").concat(n, "'."), r);
}, U6e = function(t, n, r) {
  r.parentSelectors.some(function(i) {
    var o = i.split(",");
    return o.some(function(a) {
      return a.split("&").length > 2;
    });
  }) && el("Should not use more than one `&` in a selector.", r);
}, z0 = "data-ant-cssinjs-cache-path", dQ = "_FILE_STYLE__";
function W6e(e) {
  return Object.keys(e).map(function(t) {
    var n = e[t];
    return "".concat(t, ":").concat(n);
  }).join(";");
}
var Jd, fQ = !0;
function q6e() {
  if (!Jd && (Jd = {}, uo())) {
    var e = document.createElement("div");
    e.className = z0, e.style.position = "fixed", e.style.visibility = "hidden", e.style.top = "-9999px", document.body.appendChild(e);
    var t = getComputedStyle(e).content || "";
    t = t.replace(/^"/, "").replace(/"$/, ""), t.split(";").forEach(function(i) {
      var o = i.split(":"), a = he(o, 2), s = a[0], c = a[1];
      Jd[s] = c;
    });
    var n = document.querySelector("style[".concat(z0, "]"));
    if (n) {
      var r;
      fQ = !1, (r = n.parentNode) === null || r === void 0 || r.removeChild(n);
    }
    document.body.removeChild(e);
  }
}
function G6e(e) {
  return q6e(), !!Jd[e];
}
function K6e(e) {
  var t = Jd[e], n = null;
  if (t && uo())
    if (fQ)
      n = dQ;
    else {
      var r = document.querySelector("style[".concat(ws, '="').concat(Jd[e], '"]'));
      r ? n = r.innerHTML : delete Jd[e];
    }
  return [n, t];
}
var hQ = "_skip_check_", gQ = "_multi_value_";
function h_(e) {
  var t = HA(k6e(e), D6e);
  return t.replace(/\{%%%\:[^;];}/g, ";");
}
function Y6e(e) {
  return It(e) === "object" && e && (hQ in e || gQ in e);
}
function sL(e, t, n) {
  if (!t)
    return e;
  var r = ".".concat(t), i = n === "low" ? ":where(".concat(r, ")") : r, o = e.split(",").map(function(a) {
    var s, c = a.trim().split(/\s+/), l = c[0] || "", u = ((s = l.match(/^\w+/)) === null || s === void 0 ? void 0 : s[0]) || "";
    return l = "".concat(u).concat(i).concat(l.slice(u.length)), [l].concat(tt(c.slice(1))).join(" ");
  });
  return o.join(",");
}
var X6e = function e(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
    root: !0,
    parentSelectors: []
  }, i = r.root, o = r.injectHash, a = r.parentSelectors, s = n.hashId, c = n.layer, l = n.path, u = n.hashPriority, d = n.transformers, f = d === void 0 ? [] : d, h = n.linters, p = h === void 0 ? [] : h, g = "", m = {};
  function v(b) {
    var w = b.getName(s);
    if (!m[w]) {
      var C = e(b.style, n, {
        root: !1,
        parentSelectors: a
      }), x = he(C, 1), T = x[0];
      m[w] = "@keyframes ".concat(b.getName(s)).concat(T);
    }
  }
  function y(b) {
    var w = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    return b.forEach(function(C) {
      Array.isArray(C) ? y(C, w) : C && w.push(C);
    }), w;
  }
  var _ = y(Array.isArray(t) ? t : [t]);
  return _.forEach(function(b) {
    var w = typeof b == "string" && !i ? {} : b;
    if (typeof w == "string")
      g += "".concat(w, `
`);
    else if (w._keyframe)
      v(w);
    else {
      var C = f.reduce(function(x, T) {
        var E;
        return (T == null || (E = T.visit) === null || E === void 0 ? void 0 : E.call(T, x)) || x;
      }, w);
      Object.keys(C).forEach(function(x) {
        var T = C[x];
        if (It(T) === "object" && T && (x !== "animationName" || !T._keyframe) && !Y6e(T)) {
          var E = !1, R = x.trim(), I = !1;
          (i || o) && s ? R.startsWith("@") ? E = !0 : R === "&" ? R = sL("", s, u) : R = sL(x, s, u) : i && !s && (R === "&" || R === "") && (R = "", I = !0);
          var O = e(T, n, {
            root: I,
            injectHash: E,
            parentSelectors: [].concat(tt(a), [R])
          }), P = he(O, 2), k = P[0], L = P[1];
          m = ae(ae({}, m), L), g += "".concat(R).concat(k);
        } else {
          let z = function(V, B) {
            process.env.NODE_ENV !== "production" && (It(T) !== "object" || !(T != null && T[hQ])) && [j6e, L6e].concat(tt(p)).forEach(function(Y) {
              return Y(V, B, {
                path: l,
                hashId: s,
                parentSelectors: a
              });
            });
            var U = V.replace(/[A-Z]/g, function(Y) {
              return "-".concat(Y.toLowerCase());
            }), Q = B;
            !iQ[V] && typeof Q == "number" && Q !== 0 && (Q = "".concat(Q, "px")), V === "animationName" && B !== null && B !== void 0 && B._keyframe && (v(B), Q = B.getName(s)), g += "".concat(U, ":").concat(Q, ";");
          };
          var N, D = (N = T == null ? void 0 : T.value) !== null && N !== void 0 ? N : T;
          It(T) === "object" && T !== null && T !== void 0 && T[gQ] && Array.isArray(D) ? D.forEach(function(V) {
            z(x, V);
          }) : z(x, D);
        }
      });
    }
  }), i ? c && (g = "@layer ".concat(c.name, " {").concat(g, "}"), c.dependencies && (m["@layer ".concat(c.name)] = c.dependencies.map(function(b) {
    return "@layer ".concat(b, ", ").concat(c.name, ";");
  }).join(`
`))) : g = "{".concat(g, "}"), [g, m];
};
function pQ(e, t) {
  return wv("".concat(e.join("%")).concat(t));
}
function Q6e() {
  return null;
}
var mQ = "style";
function PS(e, t) {
  var n = e.token, r = e.path, i = e.hashId, o = e.layer, a = e.nonce, s = e.clientOnly, c = e.order, l = c === void 0 ? 0 : c, u = $.useContext(qg), d = u.autoClear, f = u.mock, h = u.defaultCache, p = u.hashPriority, g = u.container, m = u.ssrInline, v = u.transformers, y = u.linters, _ = u.cache, b = u.layer, w = n._tokenKey, C = [w];
  b && C.push("layer"), C.push.apply(C, tt(r));
  var x = VA;
  process.env.NODE_ENV !== "production" && f !== void 0 && (x = f === "client");
  var T = fM(
    mQ,
    C,
    // Create cache if needed
    function() {
      var P = C.join("|");
      if (G6e(P)) {
        var k = K6e(P), L = he(k, 2), N = L[0], D = L[1];
        if (N)
          return [N, w, D, {}, s, l];
      }
      var z = t(), V = X6e(z, {
        hashId: i,
        hashPriority: p,
        layer: b ? o : void 0,
        path: r.join("-"),
        transformers: v,
        linters: y
      }), B = he(V, 2), U = B[0], Q = B[1], Y = h_(U), q = pQ(C, Y);
      return [Y, w, q, Q, s, l];
    },
    // Remove cache if no need
    function(P, k) {
      var L = he(P, 3), N = L[2];
      (k || d) && VA && Hg(N, {
        mark: ws
      });
    },
    // Effect: Inject style here
    function(P) {
      var k = he(P, 4), L = k[0];
      k[1];
      var N = k[2], D = k[3];
      if (x && L !== dQ) {
        var z = {
          mark: ws,
          prepend: b ? !1 : "queue",
          attachTo: g,
          priority: l
        }, V = typeof a == "function" ? a() : a;
        V && (z.csp = {
          nonce: V
        });
        var B = [], U = [];
        Object.keys(D).forEach(function(Y) {
          Y.startsWith("@layer") ? B.push(Y) : U.push(Y);
        }), B.forEach(function(Y) {
          mc(h_(D[Y]), "_layer-".concat(Y), ae(ae({}, z), {}, {
            prepend: !0
          }));
        });
        var Q = mc(L, N, z);
        Q[nu] = _.instanceId, Q.setAttribute(Wg, w), process.env.NODE_ENV !== "production" && Q.setAttribute(UOe, C.join("|")), U.forEach(function(Y) {
          mc(h_(D[Y]), "_effect-".concat(Y), z);
        });
      }
    }
  ), E = he(T, 3), R = E[0], I = E[1], O = E[2];
  return function(P) {
    var k;
    return !m || x || !h ? k = /* @__PURE__ */ $.createElement(Q6e, null) : k = /* @__PURE__ */ $.createElement("style", xt({}, oe(oe({}, Wg, I), ws, O), {
      dangerouslySetInnerHTML: {
        __html: R
      }
    })), /* @__PURE__ */ $.createElement($.Fragment, null, k, P);
  };
}
var J6e = function(t, n, r) {
  var i = he(t, 6), o = i[0], a = i[1], s = i[2], c = i[3], l = i[4], u = i[5], d = r || {}, f = d.plain;
  if (l)
    return null;
  var h = o, p = {
    "data-rc-order": "prependQueue",
    "data-rc-priority": "".concat(u)
  };
  return h = xv(o, a, s, p, f), c && Object.keys(c).forEach(function(g) {
    if (!n[g]) {
      n[g] = !0;
      var m = h_(c[g]), v = xv(m, a, "_effect-".concat(g), p, f);
      g.startsWith("@layer") ? h = v + h : h += v;
    }
  }), [u, s, h];
}, vQ = "cssVar", yQ = function(t, n) {
  var r = t.key, i = t.prefix, o = t.unitless, a = t.ignore, s = t.token, c = t.scope, l = c === void 0 ? "" : c, u = gt(qg), d = u.cache.instanceId, f = u.container, h = s._tokenKey, p = [].concat(tt(t.path), [r, l, h]), g = fM(vQ, p, function() {
    var m = n(), v = eQ(m, r, {
      prefix: i,
      unitless: o,
      ignore: a,
      scope: l
    }), y = he(v, 2), _ = y[0], b = y[1], w = pQ(p, b);
    return [_, b, w, r];
  }, function(m) {
    var v = he(m, 3), y = v[2];
    VA && Hg(y, {
      mark: ws
    });
  }, function(m) {
    var v = he(m, 3), y = v[1], _ = v[2];
    if (y) {
      var b = mc(y, _, {
        mark: ws,
        prepend: "queue",
        attachTo: f,
        priority: -999
      });
      b[nu] = d, b.setAttribute(Wg, r);
    }
  });
  return g;
}, Z6e = function(t, n, r) {
  var i = he(t, 4), o = i[1], a = i[2], s = i[3], c = r || {}, l = c.plain;
  if (!o)
    return null;
  var u = -999, d = {
    "data-rc-order": "prependQueue",
    "data-rc-priority": "".concat(u)
  }, f = xv(o, s, a, d, l);
  return [u, a, f];
}, eMe = oe(oe(oe({}, mQ, J6e), nQ, _6e), vQ, Z6e);
function tMe(e) {
  return e !== null;
}
function nMe(e, t) {
  var n = typeof t == "boolean" ? {
    plain: t
  } : t || {}, r = n.plain, i = r === void 0 ? !1 : r, o = n.types, a = o === void 0 ? ["style", "token", "cssVar"] : o, s = new RegExp("^(".concat((typeof a == "string" ? [a] : a).join("|"), ")%")), c = Array.from(e.cache.keys()).filter(function(f) {
    return s.test(f);
  }), l = {}, u = {}, d = "";
  return c.map(function(f) {
    var h = f.replace(s, "").replace(/%/g, "|"), p = f.split("%"), g = he(p, 1), m = g[0], v = eMe[m], y = v(e.cache.get(f)[1], l, {
      plain: i
    });
    if (!y)
      return null;
    var _ = he(y, 3), b = _[0], w = _[1], C = _[2];
    return f.startsWith("style") && (u[h] = w), [b, C];
  }).filter(tMe).sort(function(f, h) {
    var p = he(f, 1), g = p[0], m = he(h, 1), v = m[0];
    return g - v;
  }).forEach(function(f) {
    var h = he(f, 2), p = h[1];
    d += p;
  }), d += xv(".".concat(z0, '{content:"').concat(W6e(u), '";}'), void 0, void 0, oe({}, z0, z0), i), d;
}
var Pn = /* @__PURE__ */ function() {
  function e(t, n) {
    xr(this, e), oe(this, "name", void 0), oe(this, "style", void 0), oe(this, "_keyframe", !0), this.name = t, this.style = n;
  }
  return Er(e, [{
    key: "getName",
    value: function() {
      var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
      return n ? "".concat(n, "-").concat(this.name) : this.name;
    }
  }]), e;
}();
function rMe(e) {
  if (typeof e == "number")
    return [[e], !1];
  var t = String(e).trim(), n = t.match(/(.*)(!important)/), r = (n ? n[1] : t).trim().split(/\s+/), i = [], o = 0;
  return [r.reduce(function(a, s) {
    if (s.includes("(") || s.includes(")")) {
      var c = s.split("(").length - 1, l = s.split(")").length - 1;
      o += c - l;
    }
    return o >= 0 && i.push(s), o === 0 && (a.push(i.join(" ")), i = []), a;
  }, []), !!n];
}
function yh(e) {
  return e.notSplit = !0, e;
}
var iMe = {
  // Inset
  inset: ["top", "right", "bottom", "left"],
  insetBlock: ["top", "bottom"],
  insetBlockStart: ["top"],
  insetBlockEnd: ["bottom"],
  insetInline: ["left", "right"],
  insetInlineStart: ["left"],
  insetInlineEnd: ["right"],
  // Margin
  marginBlock: ["marginTop", "marginBottom"],
  marginBlockStart: ["marginTop"],
  marginBlockEnd: ["marginBottom"],
  marginInline: ["marginLeft", "marginRight"],
  marginInlineStart: ["marginLeft"],
  marginInlineEnd: ["marginRight"],
  // Padding
  paddingBlock: ["paddingTop", "paddingBottom"],
  paddingBlockStart: ["paddingTop"],
  paddingBlockEnd: ["paddingBottom"],
  paddingInline: ["paddingLeft", "paddingRight"],
  paddingInlineStart: ["paddingLeft"],
  paddingInlineEnd: ["paddingRight"],
  // Border
  borderBlock: yh(["borderTop", "borderBottom"]),
  borderBlockStart: yh(["borderTop"]),
  borderBlockEnd: yh(["borderBottom"]),
  borderInline: yh(["borderLeft", "borderRight"]),
  borderInlineStart: yh(["borderLeft"]),
  borderInlineEnd: yh(["borderRight"]),
  // Border width
  borderBlockWidth: ["borderTopWidth", "borderBottomWidth"],
  borderBlockStartWidth: ["borderTopWidth"],
  borderBlockEndWidth: ["borderBottomWidth"],
  borderInlineWidth: ["borderLeftWidth", "borderRightWidth"],
  borderInlineStartWidth: ["borderLeftWidth"],
  borderInlineEndWidth: ["borderRightWidth"],
  // Border style
  borderBlockStyle: ["borderTopStyle", "borderBottomStyle"],
  borderBlockStartStyle: ["borderTopStyle"],
  borderBlockEndStyle: ["borderBottomStyle"],
  borderInlineStyle: ["borderLeftStyle", "borderRightStyle"],
  borderInlineStartStyle: ["borderLeftStyle"],
  borderInlineEndStyle: ["borderRightStyle"],
  // Border color
  borderBlockColor: ["borderTopColor", "borderBottomColor"],
  borderBlockStartColor: ["borderTopColor"],
  borderBlockEndColor: ["borderBottomColor"],
  borderInlineColor: ["borderLeftColor", "borderRightColor"],
  borderInlineStartColor: ["borderLeftColor"],
  borderInlineEndColor: ["borderRightColor"],
  // Border radius
  borderStartStartRadius: ["borderTopLeftRadius"],
  borderStartEndRadius: ["borderTopRightRadius"],
  borderEndStartRadius: ["borderBottomLeftRadius"],
  borderEndEndRadius: ["borderBottomRightRadius"]
};
function o1(e, t) {
  var n = e;
  return t && (n = "".concat(n, " !important")), {
    _skip_check_: !0,
    value: n
  };
}
var oMe = {
  visit: function(t) {
    var n = {};
    return Object.keys(t).forEach(function(r) {
      var i = t[r], o = iMe[r];
      if (o && (typeof i == "number" || typeof i == "string")) {
        var a = rMe(i), s = he(a, 2), c = s[0], l = s[1];
        o.length && o.notSplit ? o.forEach(function(u) {
          n[u] = o1(i, l);
        }) : o.length === 1 ? n[o[0]] = o1(c[0], l) : o.length === 2 ? o.forEach(function(u, d) {
          var f;
          n[u] = o1((f = c[d]) !== null && f !== void 0 ? f : c[0], l);
        }) : o.length === 4 ? o.forEach(function(u, d) {
          var f, h;
          n[u] = o1((f = (h = c[d]) !== null && h !== void 0 ? h : c[d - 2]) !== null && f !== void 0 ? f : c[0], l);
        }) : n[r] = i;
      } else
        n[r] = i;
    }), n;
  }
}, dT = /url\([^)]+\)|var\([^)]+\)|(\d*\.?\d+)px/g;
function aMe(e, t) {
  var n = Math.pow(10, t + 1), r = Math.floor(e * n);
  return Math.round(r / 10) * 10 / n;
}
var sMe = function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = t.rootValue, r = n === void 0 ? 16 : n, i = t.precision, o = i === void 0 ? 5 : i, a = t.mediaQuery, s = a === void 0 ? !1 : a, c = function(d, f) {
    if (!f)
      return d;
    var h = parseFloat(f);
    if (h <= 1)
      return d;
    var p = aMe(h / r, o);
    return "".concat(p, "rem");
  }, l = function(d) {
    var f = ae({}, d);
    return Object.entries(d).forEach(function(h) {
      var p = he(h, 2), g = p[0], m = p[1];
      if (typeof m == "string" && m.includes("px")) {
        var v = m.replace(dT, c);
        f[g] = v;
      }
      !iQ[g] && typeof m == "number" && m !== 0 && (f[g] = "".concat(m, "px").replace(dT, c));
      var y = g.trim();
      if (y.startsWith("@") && y.includes("px") && s) {
        var _ = g.replace(dT, c);
        f[_] = f[g], delete f[g];
      }
    }), f;
  };
  return {
    visit: l
  };
}, cMe = {
  supportModernCSS: function() {
    return ZOe() && e6e();
  }
};
const lMe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Keyframes: Pn,
  NaNLinter: H6e,
  StyleProvider: WOe,
  Theme: dM,
  _experimental: cMe,
  createCache: lM,
  createTheme: RS,
  extractStyle: nMe,
  genCalc: YOe,
  getComputedToken: tQ,
  legacyLogicalPropertiesTransformer: oMe,
  legacyNotSelectorLinter: B6e,
  logicalPropertiesLinter: z6e,
  parentSelectorLinter: U6e,
  px2remTransformer: sMe,
  token2CSSVar: V0,
  unit: et,
  useCSSVarRegister: yQ,
  useCacheToken: rQ,
  useStyleRegister: PS
}, Symbol.toStringTag, { value: "Module" }));
var uMe = /* @__PURE__ */ Ca({});
const pM = uMe;
function bQ(e) {
  return WX(e) || BX(e) || sM(e) || qX();
}
function rc(e, t) {
  for (var n = e, r = 0; r < t.length; r += 1) {
    if (n == null)
      return;
    n = n[t[r]];
  }
  return n;
}
function _Q(e, t, n, r) {
  if (!t.length)
    return n;
  var i = bQ(t), o = i[0], a = i.slice(1), s;
  return !e && typeof o == "number" ? s = [] : Array.isArray(e) ? s = tt(e) : s = ae({}, e), r && n === void 0 && a.length === 1 ? delete s[o][a[0]] : s[o] = _Q(s[o], a, n, r), s;
}
function ls(e, t, n) {
  var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
  return t.length && r && n === void 0 && !rc(e, t.slice(0, -1)) ? e : _Q(e, t, n, r);
}
function dMe(e) {
  return It(e) === "object" && e !== null && Object.getPrototypeOf(e) === Object.prototype;
}
function cL(e) {
  return Array.isArray(e) ? [] : {};
}
var fMe = typeof Reflect > "u" ? Object.keys : Reflect.ownKeys;
function Xh() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  var r = cL(t[0]);
  return t.forEach(function(i) {
    function o(a, s) {
      var c = new Set(s), l = rc(i, a), u = Array.isArray(l);
      if (u || dMe(l)) {
        if (!c.has(l)) {
          c.add(l);
          var d = rc(r, a);
          u ? r = ls(r, a, []) : (!d || It(d) !== "object") && (r = ls(r, a, cL(l))), fMe(l).forEach(function(f) {
            o([].concat(tt(a), [f]), c);
          });
        }
      } else
        r = ls(r, a, l);
    }
    o([]);
  }), r;
}
function SQ() {
}
let Dc = null;
function hMe() {
  Dc = null, RX();
}
let mM = SQ;
process.env.NODE_ENV !== "production" && (mM = (e, t, n) => {
  sn(e, `[antd: ${t}] ${n}`), process.env.NODE_ENV === "test" && hMe();
});
const wQ = /* @__PURE__ */ $.createContext({}), di = process.env.NODE_ENV !== "production" ? (e) => {
  const {
    strict: t
  } = $.useContext(wQ), n = (r, i, o) => {
    if (!r)
      if (t === !1 && i === "deprecated") {
        const a = Dc;
        Dc || (Dc = {}), Dc[e] = Dc[e] || [], Dc[e].includes(o || "") || Dc[e].push(o || ""), a || console.warn("[antd] There exists deprecated usage in your code:", Dc);
      } else
        process.env.NODE_ENV !== "production" && mM(r, e, o);
  };
  return n.deprecated = (r, i, o, a) => {
    n(r, "deprecated", `\`${i}\` is deprecated. Please use \`${o}\` instead.${a ? ` ${a}` : ""}`);
  }, n;
} : () => {
  const e = () => {
  };
  return e.deprecated = SQ, e;
}, DE = mM, gMe = /* @__PURE__ */ Ca(void 0);
var pMe = {
  // Options
  items_per_page: "/ page",
  jump_to: "Go to",
  jump_to_confirm: "confirm",
  page: "Page",
  // Pagination
  prev_page: "Previous Page",
  next_page: "Next Page",
  prev_5: "Previous 5 Pages",
  next_5: "Next 5 Pages",
  prev_3: "Previous 3 Pages",
  next_3: "Next 3 Pages",
  page_size: "Page Size"
}, mMe = {
  yearFormat: "YYYY",
  dayFormat: "D",
  cellMeridiemFormat: "A",
  monthBeforeYear: !0
}, vMe = ae(ae({}, mMe), {}, {
  locale: "en_US",
  today: "Today",
  now: "Now",
  backToToday: "Back to today",
  ok: "OK",
  clear: "Clear",
  month: "Month",
  year: "Year",
  timeSelect: "select time",
  dateSelect: "select date",
  weekSelect: "Choose a week",
  monthSelect: "Choose a month",
  yearSelect: "Choose a year",
  decadeSelect: "Choose a decade",
  dateFormat: "M/D/YYYY",
  dateTimeFormat: "M/D/YYYY HH:mm:ss",
  previousMonth: "Previous month (PageUp)",
  nextMonth: "Next month (PageDown)",
  previousYear: "Last year (Control + left)",
  nextYear: "Next year (Control + right)",
  previousDecade: "Last decade",
  nextDecade: "Next decade",
  previousCentury: "Last century",
  nextCentury: "Next century"
});
const yMe = {
  placeholder: "Select time",
  rangePlaceholder: ["Start time", "End time"]
}, xQ = yMe, bMe = {
  lang: Object.assign({
    placeholder: "Select date",
    yearPlaceholder: "Select year",
    quarterPlaceholder: "Select quarter",
    monthPlaceholder: "Select month",
    weekPlaceholder: "Select week",
    rangePlaceholder: ["Start date", "End date"],
    rangeYearPlaceholder: ["Start year", "End year"],
    rangeQuarterPlaceholder: ["Start quarter", "End quarter"],
    rangeMonthPlaceholder: ["Start month", "End month"],
    rangeWeekPlaceholder: ["Start week", "End week"]
  }, vMe),
  timePickerLocale: Object.assign({}, xQ)
}, lL = bMe, sa = "${label} is not a valid ${type}", _Me = {
  locale: "en",
  Pagination: pMe,
  DatePicker: lL,
  TimePicker: xQ,
  Calendar: lL,
  global: {
    placeholder: "Please select"
  },
  Table: {
    filterTitle: "Filter menu",
    filterConfirm: "OK",
    filterReset: "Reset",
    filterEmptyText: "No filters",
    filterCheckall: "Select all items",
    filterSearchPlaceholder: "Search in filters",
    emptyText: "No data",
    selectAll: "Select current page",
    selectInvert: "Invert current page",
    selectNone: "Clear all data",
    selectionAll: "Select all data",
    sortTitle: "Sort",
    expand: "Expand row",
    collapse: "Collapse row",
    triggerDesc: "Click to sort descending",
    triggerAsc: "Click to sort ascending",
    cancelSort: "Click to cancel sorting"
  },
  Tour: {
    Next: "Next",
    Previous: "Previous",
    Finish: "Finish"
  },
  Modal: {
    okText: "OK",
    cancelText: "Cancel",
    justOkText: "OK"
  },
  Popconfirm: {
    okText: "OK",
    cancelText: "Cancel"
  },
  Transfer: {
    titles: ["", ""],
    searchPlaceholder: "Search here",
    itemUnit: "item",
    itemsUnit: "items",
    remove: "Remove",
    selectCurrent: "Select current page",
    removeCurrent: "Remove current page",
    selectAll: "Select all data",
    deselectAll: "Deselect all data",
    removeAll: "Remove all data",
    selectInvert: "Invert current page"
  },
  Upload: {
    uploading: "Uploading...",
    removeFile: "Remove file",
    uploadError: "Upload error",
    previewFile: "Preview file",
    downloadFile: "Download file"
  },
  Empty: {
    description: "No data"
  },
  Icon: {
    icon: "icon"
  },
  Text: {
    edit: "Edit",
    copy: "Copy",
    copied: "Copied",
    expand: "Expand",
    collapse: "Collapse"
  },
  Form: {
    optional: "(optional)",
    defaultValidateMessages: {
      default: "Field validation error for ${label}",
      required: "Please enter ${label}",
      enum: "${label} must be one of [${enum}]",
      whitespace: "${label} cannot be a blank character",
      date: {
        format: "${label} date format is invalid",
        parse: "${label} cannot be converted to a date",
        invalid: "${label} is an invalid date"
      },
      types: {
        string: sa,
        method: sa,
        array: sa,
        object: sa,
        number: sa,
        date: sa,
        boolean: sa,
        integer: sa,
        float: sa,
        regexp: sa,
        email: sa,
        url: sa,
        hex: sa
      },
      string: {
        len: "${label} must be ${len} characters",
        min: "${label} must be at least ${min} characters",
        max: "${label} must be up to ${max} characters",
        range: "${label} must be between ${min}-${max} characters"
      },
      number: {
        len: "${label} must be equal to ${len}",
        min: "${label} must be minimum ${min}",
        max: "${label} must be maximum ${max}",
        range: "${label} must be between ${min}-${max}"
      },
      array: {
        len: "Must be ${len} ${label}",
        min: "At least ${min} ${label}",
        max: "At most ${max} ${label}",
        range: "The amount of ${label} must be between ${min}-${max}"
      },
      pattern: {
        mismatch: "${label} does not match the pattern ${pattern}"
      }
    }
  },
  Image: {
    preview: "Preview"
  },
  QRCode: {
    expired: "QR code expired",
    refresh: "Refresh",
    scanned: "Scanned"
  },
  ColorPicker: {
    presetEmpty: "Empty",
    transparent: "Transparent",
    singleColor: "Single",
    gradientColor: "Gradient"
  }
}, Xg = _Me;
Object.assign({}, Xg.Modal);
let g_ = [];
const uL = () => g_.reduce((e, t) => Object.assign(Object.assign({}, e), t), Xg.Modal);
function SMe(e) {
  if (e) {
    const t = Object.assign({}, e);
    return g_.push(t), uL(), () => {
      g_ = g_.filter((n) => n !== t), uL();
    };
  }
  Object.assign({}, Xg.Modal);
}
const wMe = /* @__PURE__ */ Ca(void 0), vM = wMe, xMe = (e, t) => {
  const n = $.useContext(vM), r = $.useMemo(() => {
    var o;
    const a = t || Xg[e], s = (o = n == null ? void 0 : n[e]) !== null && o !== void 0 ? o : {};
    return Object.assign(Object.assign({}, typeof a == "function" ? a() : a), s || {});
  }, [e, t, n]), i = $.useMemo(() => {
    const o = n == null ? void 0 : n.locale;
    return n != null && n.exist && !o ? Xg.locale : o;
  }, [n]);
  return [r, i];
}, yM = xMe, EQ = "internalMark", CQ = (e) => {
  const {
    locale: t = {},
    children: n,
    _ANT_MARK__: r
  } = e;
  if (process.env.NODE_ENV !== "production") {
    const o = di("LocaleProvider");
    process.env.NODE_ENV !== "production" && o(r === EQ, "deprecated", "`LocaleProvider` is deprecated. Please use `locale` with `ConfigProvider` instead: http://u.ant.design/locale");
  }
  $.useEffect(() => SMe(t == null ? void 0 : t.Modal), [t]);
  const i = $.useMemo(() => Object.assign(Object.assign({}, t), {
    exist: !0
  }), [t]);
  return /* @__PURE__ */ $.createElement(vM.Provider, {
    value: i
  }, n);
};
process.env.NODE_ENV !== "production" && (CQ.displayName = "LocaleProvider");
const EMe = CQ;
function Ui(e, t) {
  CMe(e) && (e = "100%");
  var n = TMe(e);
  return e = t === 360 ? e : Math.min(t, Math.max(0, parseFloat(e))), n && (e = parseInt(String(e * t), 10) / 100), Math.abs(e - t) < 1e-6 ? 1 : (t === 360 ? e = (e < 0 ? e % t + t : e % t) / parseFloat(String(t)) : e = e % t / parseFloat(String(t)), e);
}
function a1(e) {
  return Math.min(1, Math.max(0, e));
}
function CMe(e) {
  return typeof e == "string" && e.indexOf(".") !== -1 && parseFloat(e) === 1;
}
function TMe(e) {
  return typeof e == "string" && e.indexOf("%") !== -1;
}
function TQ(e) {
  return e = parseFloat(e), (isNaN(e) || e < 0 || e > 1) && (e = 1), e;
}
function Dd(e) {
  return e <= 1 ? "".concat(Number(e) * 100, "%") : e;
}
function ps(e) {
  return e.length === 1 ? "0" + e : String(e);
}
function IQ(e, t, n) {
  return {
    r: Ui(e, 255) * 255,
    g: Ui(t, 255) * 255,
    b: Ui(n, 255) * 255
  };
}
function UA(e, t, n) {
  e = Ui(e, 255), t = Ui(t, 255), n = Ui(n, 255);
  var r = Math.max(e, t, n), i = Math.min(e, t, n), o = 0, a = 0, s = (r + i) / 2;
  if (r === i)
    a = 0, o = 0;
  else {
    var c = r - i;
    switch (a = s > 0.5 ? c / (2 - r - i) : c / (r + i), r) {
      case e:
        o = (t - n) / c + (t < n ? 6 : 0);
        break;
      case t:
        o = (n - e) / c + 2;
        break;
      case n:
        o = (e - t) / c + 4;
        break;
    }
    o /= 6;
  }
  return { h: o, s: a, l: s };
}
function fT(e, t, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? e + (t - e) * (6 * n) : n < 1 / 2 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e;
}
function $Q(e, t, n) {
  var r, i, o;
  if (e = Ui(e, 360), t = Ui(t, 100), n = Ui(n, 100), t === 0)
    i = n, o = n, r = n;
  else {
    var a = n < 0.5 ? n * (1 + t) : n + t - n * t, s = 2 * n - a;
    r = fT(s, a, e + 1 / 3), i = fT(s, a, e), o = fT(s, a, e - 1 / 3);
  }
  return { r: r * 255, g: i * 255, b: o * 255 };
}
function OS(e, t, n) {
  e = Ui(e, 255), t = Ui(t, 255), n = Ui(n, 255);
  var r = Math.max(e, t, n), i = Math.min(e, t, n), o = 0, a = r, s = r - i, c = r === 0 ? 0 : s / r;
  if (r === i)
    o = 0;
  else {
    switch (r) {
      case e:
        o = (t - n) / s + (t < n ? 6 : 0);
        break;
      case t:
        o = (n - e) / s + 2;
        break;
      case n:
        o = (e - t) / s + 4;
        break;
    }
    o /= 6;
  }
  return { h: o, s: c, v: a };
}
function AQ(e, t, n) {
  e = Ui(e, 360) * 6, t = Ui(t, 100), n = Ui(n, 100);
  var r = Math.floor(e), i = e - r, o = n * (1 - t), a = n * (1 - i * t), s = n * (1 - (1 - i) * t), c = r % 6, l = [n, a, o, o, s, n][c], u = [s, n, n, a, o, o][c], d = [o, o, s, n, n, a][c];
  return { r: l * 255, g: u * 255, b: d * 255 };
}
function MS(e, t, n, r) {
  var i = [
    ps(Math.round(e).toString(16)),
    ps(Math.round(t).toString(16)),
    ps(Math.round(n).toString(16))
  ];
  return r && i[0].startsWith(i[0].charAt(1)) && i[1].startsWith(i[1].charAt(1)) && i[2].startsWith(i[2].charAt(1)) ? i[0].charAt(0) + i[1].charAt(0) + i[2].charAt(0) : i.join("");
}
function RQ(e, t, n, r, i) {
  var o = [
    ps(Math.round(e).toString(16)),
    ps(Math.round(t).toString(16)),
    ps(Math.round(n).toString(16)),
    ps(bM(r))
  ];
  return i && o[0].startsWith(o[0].charAt(1)) && o[1].startsWith(o[1].charAt(1)) && o[2].startsWith(o[2].charAt(1)) && o[3].startsWith(o[3].charAt(1)) ? o[0].charAt(0) + o[1].charAt(0) + o[2].charAt(0) + o[3].charAt(0) : o.join("");
}
function WA(e, t, n, r) {
  var i = [
    ps(bM(r)),
    ps(Math.round(e).toString(16)),
    ps(Math.round(t).toString(16)),
    ps(Math.round(n).toString(16))
  ];
  return i.join("");
}
function bM(e) {
  return Math.round(parseFloat(e) * 255).toString(16);
}
function qA(e) {
  return qo(e) / 255;
}
function qo(e) {
  return parseInt(e, 16);
}
function PQ(e) {
  return {
    r: e >> 16,
    g: (e & 65280) >> 8,
    b: e & 255
  };
}
var kS = {
  aliceblue: "#f0f8ff",
  antiquewhite: "#faebd7",
  aqua: "#00ffff",
  aquamarine: "#7fffd4",
  azure: "#f0ffff",
  beige: "#f5f5dc",
  bisque: "#ffe4c4",
  black: "#000000",
  blanchedalmond: "#ffebcd",
  blue: "#0000ff",
  blueviolet: "#8a2be2",
  brown: "#a52a2a",
  burlywood: "#deb887",
  cadetblue: "#5f9ea0",
  chartreuse: "#7fff00",
  chocolate: "#d2691e",
  coral: "#ff7f50",
  cornflowerblue: "#6495ed",
  cornsilk: "#fff8dc",
  crimson: "#dc143c",
  cyan: "#00ffff",
  darkblue: "#00008b",
  darkcyan: "#008b8b",
  darkgoldenrod: "#b8860b",
  darkgray: "#a9a9a9",
  darkgreen: "#006400",
  darkgrey: "#a9a9a9",
  darkkhaki: "#bdb76b",
  darkmagenta: "#8b008b",
  darkolivegreen: "#556b2f",
  darkorange: "#ff8c00",
  darkorchid: "#9932cc",
  darkred: "#8b0000",
  darksalmon: "#e9967a",
  darkseagreen: "#8fbc8f",
  darkslateblue: "#483d8b",
  darkslategray: "#2f4f4f",
  darkslategrey: "#2f4f4f",
  darkturquoise: "#00ced1",
  darkviolet: "#9400d3",
  deeppink: "#ff1493",
  deepskyblue: "#00bfff",
  dimgray: "#696969",
  dimgrey: "#696969",
  dodgerblue: "#1e90ff",
  firebrick: "#b22222",
  floralwhite: "#fffaf0",
  forestgreen: "#228b22",
  fuchsia: "#ff00ff",
  gainsboro: "#dcdcdc",
  ghostwhite: "#f8f8ff",
  goldenrod: "#daa520",
  gold: "#ffd700",
  gray: "#808080",
  green: "#008000",
  greenyellow: "#adff2f",
  grey: "#808080",
  honeydew: "#f0fff0",
  hotpink: "#ff69b4",
  indianred: "#cd5c5c",
  indigo: "#4b0082",
  ivory: "#fffff0",
  khaki: "#f0e68c",
  lavenderblush: "#fff0f5",
  lavender: "#e6e6fa",
  lawngreen: "#7cfc00",
  lemonchiffon: "#fffacd",
  lightblue: "#add8e6",
  lightcoral: "#f08080",
  lightcyan: "#e0ffff",
  lightgoldenrodyellow: "#fafad2",
  lightgray: "#d3d3d3",
  lightgreen: "#90ee90",
  lightgrey: "#d3d3d3",
  lightpink: "#ffb6c1",
  lightsalmon: "#ffa07a",
  lightseagreen: "#20b2aa",
  lightskyblue: "#87cefa",
  lightslategray: "#778899",
  lightslategrey: "#778899",
  lightsteelblue: "#b0c4de",
  lightyellow: "#ffffe0",
  lime: "#00ff00",
  limegreen: "#32cd32",
  linen: "#faf0e6",
  magenta: "#ff00ff",
  maroon: "#800000",
  mediumaquamarine: "#66cdaa",
  mediumblue: "#0000cd",
  mediumorchid: "#ba55d3",
  mediumpurple: "#9370db",
  mediumseagreen: "#3cb371",
  mediumslateblue: "#7b68ee",
  mediumspringgreen: "#00fa9a",
  mediumturquoise: "#48d1cc",
  mediumvioletred: "#c71585",
  midnightblue: "#191970",
  mintcream: "#f5fffa",
  mistyrose: "#ffe4e1",
  moccasin: "#ffe4b5",
  navajowhite: "#ffdead",
  navy: "#000080",
  oldlace: "#fdf5e6",
  olive: "#808000",
  olivedrab: "#6b8e23",
  orange: "#ffa500",
  orangered: "#ff4500",
  orchid: "#da70d6",
  palegoldenrod: "#eee8aa",
  palegreen: "#98fb98",
  paleturquoise: "#afeeee",
  palevioletred: "#db7093",
  papayawhip: "#ffefd5",
  peachpuff: "#ffdab9",
  peru: "#cd853f",
  pink: "#ffc0cb",
  plum: "#dda0dd",
  powderblue: "#b0e0e6",
  purple: "#800080",
  rebeccapurple: "#663399",
  red: "#ff0000",
  rosybrown: "#bc8f8f",
  royalblue: "#4169e1",
  saddlebrown: "#8b4513",
  salmon: "#fa8072",
  sandybrown: "#f4a460",
  seagreen: "#2e8b57",
  seashell: "#fff5ee",
  sienna: "#a0522d",
  silver: "#c0c0c0",
  skyblue: "#87ceeb",
  slateblue: "#6a5acd",
  slategray: "#708090",
  slategrey: "#708090",
  snow: "#fffafa",
  springgreen: "#00ff7f",
  steelblue: "#4682b4",
  tan: "#d2b48c",
  teal: "#008080",
  thistle: "#d8bfd8",
  tomato: "#ff6347",
  turquoise: "#40e0d0",
  violet: "#ee82ee",
  wheat: "#f5deb3",
  white: "#ffffff",
  whitesmoke: "#f5f5f5",
  yellow: "#ffff00",
  yellowgreen: "#9acd32"
};
function Pd(e) {
  var t = { r: 0, g: 0, b: 0 }, n = 1, r = null, i = null, o = null, a = !1, s = !1;
  return typeof e == "string" && (e = OQ(e)), typeof e == "object" && (Ws(e.r) && Ws(e.g) && Ws(e.b) ? (t = IQ(e.r, e.g, e.b), a = !0, s = String(e.r).substr(-1) === "%" ? "prgb" : "rgb") : Ws(e.h) && Ws(e.s) && Ws(e.v) ? (r = Dd(e.s), i = Dd(e.v), t = AQ(e.h, r, i), a = !0, s = "hsv") : Ws(e.h) && Ws(e.s) && Ws(e.l) && (r = Dd(e.s), o = Dd(e.l), t = $Q(e.h, r, o), a = !0, s = "hsl"), Object.prototype.hasOwnProperty.call(e, "a") && (n = e.a)), n = TQ(n), {
    ok: a,
    format: e.format || s,
    r: Math.min(255, Math.max(t.r, 0)),
    g: Math.min(255, Math.max(t.g, 0)),
    b: Math.min(255, Math.max(t.b, 0)),
    a: n
  };
}
var IMe = "[-\\+]?\\d+%?", $Me = "[-\\+]?\\d*\\.\\d+%?", iu = "(?:".concat($Me, ")|(?:").concat(IMe, ")"), hT = "[\\s|\\(]+(".concat(iu, ")[,|\\s]+(").concat(iu, ")[,|\\s]+(").concat(iu, ")\\s*\\)?"), gT = "[\\s|\\(]+(".concat(iu, ")[,|\\s]+(").concat(iu, ")[,|\\s]+(").concat(iu, ")[,|\\s]+(").concat(iu, ")\\s*\\)?"), ss = {
  CSS_UNIT: new RegExp(iu),
  rgb: new RegExp("rgb" + hT),
  rgba: new RegExp("rgba" + gT),
  hsl: new RegExp("hsl" + hT),
  hsla: new RegExp("hsla" + gT),
  hsv: new RegExp("hsv" + hT),
  hsva: new RegExp("hsva" + gT),
  hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
  hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
};
function OQ(e) {
  if (e = e.trim().toLowerCase(), e.length === 0)
    return !1;
  var t = !1;
  if (kS[e])
    e = kS[e], t = !0;
  else if (e === "transparent")
    return { r: 0, g: 0, b: 0, a: 0, format: "name" };
  var n = ss.rgb.exec(e);
  return n ? { r: n[1], g: n[2], b: n[3] } : (n = ss.rgba.exec(e), n ? { r: n[1], g: n[2], b: n[3], a: n[4] } : (n = ss.hsl.exec(e), n ? { h: n[1], s: n[2], l: n[3] } : (n = ss.hsla.exec(e), n ? { h: n[1], s: n[2], l: n[3], a: n[4] } : (n = ss.hsv.exec(e), n ? { h: n[1], s: n[2], v: n[3] } : (n = ss.hsva.exec(e), n ? { h: n[1], s: n[2], v: n[3], a: n[4] } : (n = ss.hex8.exec(e), n ? {
    r: qo(n[1]),
    g: qo(n[2]),
    b: qo(n[3]),
    a: qA(n[4]),
    format: t ? "name" : "hex8"
  } : (n = ss.hex6.exec(e), n ? {
    r: qo(n[1]),
    g: qo(n[2]),
    b: qo(n[3]),
    format: t ? "name" : "hex"
  } : (n = ss.hex4.exec(e), n ? {
    r: qo(n[1] + n[1]),
    g: qo(n[2] + n[2]),
    b: qo(n[3] + n[3]),
    a: qA(n[4] + n[4]),
    format: t ? "name" : "hex8"
  } : (n = ss.hex3.exec(e), n ? {
    r: qo(n[1] + n[1]),
    g: qo(n[2] + n[2]),
    b: qo(n[3] + n[3]),
    format: t ? "name" : "hex"
  } : !1)))))))));
}
function Ws(e) {
  return !!ss.CSS_UNIT.exec(String(e));
}
var Mn = (
  /** @class */
  function() {
    function e(t, n) {
      t === void 0 && (t = ""), n === void 0 && (n = {});
      var r;
      if (t instanceof e)
        return t;
      typeof t == "number" && (t = PQ(t)), this.originalInput = t;
      var i = Pd(t);
      this.originalInput = t, this.r = i.r, this.g = i.g, this.b = i.b, this.a = i.a, this.roundA = Math.round(100 * this.a) / 100, this.format = (r = n.format) !== null && r !== void 0 ? r : i.format, this.gradientType = n.gradientType, this.r < 1 && (this.r = Math.round(this.r)), this.g < 1 && (this.g = Math.round(this.g)), this.b < 1 && (this.b = Math.round(this.b)), this.isValid = i.ok;
    }
    return e.prototype.isDark = function() {
      return this.getBrightness() < 128;
    }, e.prototype.isLight = function() {
      return !this.isDark();
    }, e.prototype.getBrightness = function() {
      var t = this.toRgb();
      return (t.r * 299 + t.g * 587 + t.b * 114) / 1e3;
    }, e.prototype.getLuminance = function() {
      var t = this.toRgb(), n, r, i, o = t.r / 255, a = t.g / 255, s = t.b / 255;
      return o <= 0.03928 ? n = o / 12.92 : n = Math.pow((o + 0.055) / 1.055, 2.4), a <= 0.03928 ? r = a / 12.92 : r = Math.pow((a + 0.055) / 1.055, 2.4), s <= 0.03928 ? i = s / 12.92 : i = Math.pow((s + 0.055) / 1.055, 2.4), 0.2126 * n + 0.7152 * r + 0.0722 * i;
    }, e.prototype.getAlpha = function() {
      return this.a;
    }, e.prototype.setAlpha = function(t) {
      return this.a = TQ(t), this.roundA = Math.round(100 * this.a) / 100, this;
    }, e.prototype.isMonochrome = function() {
      var t = this.toHsl().s;
      return t === 0;
    }, e.prototype.toHsv = function() {
      var t = OS(this.r, this.g, this.b);
      return { h: t.h * 360, s: t.s, v: t.v, a: this.a };
    }, e.prototype.toHsvString = function() {
      var t = OS(this.r, this.g, this.b), n = Math.round(t.h * 360), r = Math.round(t.s * 100), i = Math.round(t.v * 100);
      return this.a === 1 ? "hsv(".concat(n, ", ").concat(r, "%, ").concat(i, "%)") : "hsva(".concat(n, ", ").concat(r, "%, ").concat(i, "%, ").concat(this.roundA, ")");
    }, e.prototype.toHsl = function() {
      var t = UA(this.r, this.g, this.b);
      return { h: t.h * 360, s: t.s, l: t.l, a: this.a };
    }, e.prototype.toHslString = function() {
      var t = UA(this.r, this.g, this.b), n = Math.round(t.h * 360), r = Math.round(t.s * 100), i = Math.round(t.l * 100);
      return this.a === 1 ? "hsl(".concat(n, ", ").concat(r, "%, ").concat(i, "%)") : "hsla(".concat(n, ", ").concat(r, "%, ").concat(i, "%, ").concat(this.roundA, ")");
    }, e.prototype.toHex = function(t) {
      return t === void 0 && (t = !1), MS(this.r, this.g, this.b, t);
    }, e.prototype.toHexString = function(t) {
      return t === void 0 && (t = !1), "#" + this.toHex(t);
    }, e.prototype.toHex8 = function(t) {
      return t === void 0 && (t = !1), RQ(this.r, this.g, this.b, this.a, t);
    }, e.prototype.toHex8String = function(t) {
      return t === void 0 && (t = !1), "#" + this.toHex8(t);
    }, e.prototype.toHexShortString = function(t) {
      return t === void 0 && (t = !1), this.a === 1 ? this.toHexString(t) : this.toHex8String(t);
    }, e.prototype.toRgb = function() {
      return {
        r: Math.round(this.r),
        g: Math.round(this.g),
        b: Math.round(this.b),
        a: this.a
      };
    }, e.prototype.toRgbString = function() {
      var t = Math.round(this.r), n = Math.round(this.g), r = Math.round(this.b);
      return this.a === 1 ? "rgb(".concat(t, ", ").concat(n, ", ").concat(r, ")") : "rgba(".concat(t, ", ").concat(n, ", ").concat(r, ", ").concat(this.roundA, ")");
    }, e.prototype.toPercentageRgb = function() {
      var t = function(n) {
        return "".concat(Math.round(Ui(n, 255) * 100), "%");
      };
      return {
        r: t(this.r),
        g: t(this.g),
        b: t(this.b),
        a: this.a
      };
    }, e.prototype.toPercentageRgbString = function() {
      var t = function(n) {
        return Math.round(Ui(n, 255) * 100);
      };
      return this.a === 1 ? "rgb(".concat(t(this.r), "%, ").concat(t(this.g), "%, ").concat(t(this.b), "%)") : "rgba(".concat(t(this.r), "%, ").concat(t(this.g), "%, ").concat(t(this.b), "%, ").concat(this.roundA, ")");
    }, e.prototype.toName = function() {
      if (this.a === 0)
        return "transparent";
      if (this.a < 1)
        return !1;
      for (var t = "#" + MS(this.r, this.g, this.b, !1), n = 0, r = Object.entries(kS); n < r.length; n++) {
        var i = r[n], o = i[0], a = i[1];
        if (t === a)
          return o;
      }
      return !1;
    }, e.prototype.toString = function(t) {
      var n = !!t;
      t = t ?? this.format;
      var r = !1, i = this.a < 1 && this.a >= 0, o = !n && i && (t.startsWith("hex") || t === "name");
      return o ? t === "name" && this.a === 0 ? this.toName() : this.toRgbString() : (t === "rgb" && (r = this.toRgbString()), t === "prgb" && (r = this.toPercentageRgbString()), (t === "hex" || t === "hex6") && (r = this.toHexString()), t === "hex3" && (r = this.toHexString(!0)), t === "hex4" && (r = this.toHex8String(!0)), t === "hex8" && (r = this.toHex8String()), t === "name" && (r = this.toName()), t === "hsl" && (r = this.toHslString()), t === "hsv" && (r = this.toHsvString()), r || this.toHexString());
    }, e.prototype.toNumber = function() {
      return (Math.round(this.r) << 16) + (Math.round(this.g) << 8) + Math.round(this.b);
    }, e.prototype.clone = function() {
      return new e(this.toString());
    }, e.prototype.lighten = function(t) {
      t === void 0 && (t = 10);
      var n = this.toHsl();
      return n.l += t / 100, n.l = a1(n.l), new e(n);
    }, e.prototype.brighten = function(t) {
      t === void 0 && (t = 10);
      var n = this.toRgb();
      return n.r = Math.max(0, Math.min(255, n.r - Math.round(255 * -(t / 100)))), n.g = Math.max(0, Math.min(255, n.g - Math.round(255 * -(t / 100)))), n.b = Math.max(0, Math.min(255, n.b - Math.round(255 * -(t / 100)))), new e(n);
    }, e.prototype.darken = function(t) {
      t === void 0 && (t = 10);
      var n = this.toHsl();
      return n.l -= t / 100, n.l = a1(n.l), new e(n);
    }, e.prototype.tint = function(t) {
      return t === void 0 && (t = 10), this.mix("white", t);
    }, e.prototype.shade = function(t) {
      return t === void 0 && (t = 10), this.mix("black", t);
    }, e.prototype.desaturate = function(t) {
      t === void 0 && (t = 10);
      var n = this.toHsl();
      return n.s -= t / 100, n.s = a1(n.s), new e(n);
    }, e.prototype.saturate = function(t) {
      t === void 0 && (t = 10);
      var n = this.toHsl();
      return n.s += t / 100, n.s = a1(n.s), new e(n);
    }, e.prototype.greyscale = function() {
      return this.desaturate(100);
    }, e.prototype.spin = function(t) {
      var n = this.toHsl(), r = (n.h + t) % 360;
      return n.h = r < 0 ? 360 + r : r, new e(n);
    }, e.prototype.mix = function(t, n) {
      n === void 0 && (n = 50);
      var r = this.toRgb(), i = new e(t).toRgb(), o = n / 100, a = {
        r: (i.r - r.r) * o + r.r,
        g: (i.g - r.g) * o + r.g,
        b: (i.b - r.b) * o + r.b,
        a: (i.a - r.a) * o + r.a
      };
      return new e(a);
    }, e.prototype.analogous = function(t, n) {
      t === void 0 && (t = 6), n === void 0 && (n = 30);
      var r = this.toHsl(), i = 360 / n, o = [this];
      for (r.h = (r.h - (i * t >> 1) + 720) % 360; --t; )
        r.h = (r.h + i) % 360, o.push(new e(r));
      return o;
    }, e.prototype.complement = function() {
      var t = this.toHsl();
      return t.h = (t.h + 180) % 360, new e(t);
    }, e.prototype.monochromatic = function(t) {
      t === void 0 && (t = 6);
      for (var n = this.toHsv(), r = n.h, i = n.s, o = n.v, a = [], s = 1 / t; t--; )
        a.push(new e({ h: r, s: i, v: o })), o = (o + s) % 1;
      return a;
    }, e.prototype.splitcomplement = function() {
      var t = this.toHsl(), n = t.h;
      return [
        this,
        new e({ h: (n + 72) % 360, s: t.s, l: t.l }),
        new e({ h: (n + 216) % 360, s: t.s, l: t.l })
      ];
    }, e.prototype.onBackground = function(t) {
      var n = this.toRgb(), r = new e(t).toRgb(), i = n.a + r.a * (1 - n.a);
      return new e({
        r: (n.r * n.a + r.r * r.a * (1 - n.a)) / i,
        g: (n.g * n.a + r.g * r.a * (1 - n.a)) / i,
        b: (n.b * n.a + r.b * r.a * (1 - n.a)) / i,
        a: i
      });
    }, e.prototype.triad = function() {
      return this.polyad(3);
    }, e.prototype.tetrad = function() {
      return this.polyad(4);
    }, e.prototype.polyad = function(t) {
      for (var n = this.toHsl(), r = n.h, i = [this], o = 360 / t, a = 1; a < t; a++)
        i.push(new e({ h: (r + a * o) % 360, s: n.s, l: n.l }));
      return i;
    }, e.prototype.equals = function(t) {
      return this.toRgbString() === new e(t).toRgbString();
    }, e;
  }()
);
function dL(e, t) {
  return e === void 0 && (e = ""), t === void 0 && (t = {}), new Mn(e, t);
}
function _M(e, t) {
  var n = new Mn(e), r = new Mn(t);
  return (Math.max(n.getLuminance(), r.getLuminance()) + 0.05) / (Math.min(n.getLuminance(), r.getLuminance()) + 0.05);
}
function MQ(e, t, n) {
  var r, i;
  n === void 0 && (n = { level: "AA", size: "small" });
  var o = _M(e, t);
  switch (((r = n.level) !== null && r !== void 0 ? r : "AA") + ((i = n.size) !== null && i !== void 0 ? i : "small")) {
    case "AAsmall":
    case "AAAlarge":
      return o >= 4.5;
    case "AAlarge":
      return o >= 3;
    case "AAAsmall":
      return o >= 7;
    default:
      return !1;
  }
}
function kQ(e, t, n) {
  n === void 0 && (n = { includeFallbackColors: !1, level: "AA", size: "small" });
  for (var r = null, i = 0, o = n.includeFallbackColors, a = n.level, s = n.size, c = 0, l = t; c < l.length; c++) {
    var u = l[c], d = _M(e, u);
    d > i && (i = d, r = new Mn(u));
  }
  return MQ(e, r, { level: a, size: s }) || !o ? r : (n.includeFallbackColors = !1, kQ(e, ["#fff", "#000"], n));
}
function AMe(e, t) {
  var n = new Mn(e), r = "#" + WA(n.r, n.g, n.b, n.a), i = r, o = n.gradientType ? "GradientType = 1, " : "";
  if (t) {
    var a = new Mn(t);
    i = "#" + WA(a.r, a.g, a.b, a.a);
  }
  return "progid:DXImageTransform.Microsoft.gradient(".concat(o, "startColorstr=").concat(r, ",endColorstr=").concat(i, ")");
}
function RMe(e, t) {
  var n = {
    r: Dd(e.r),
    g: Dd(e.g),
    b: Dd(e.b)
  };
  return e.a !== void 0 && (n.a = Number(e.a)), new Mn(n, t);
}
function PMe() {
  return new Mn({
    r: Math.random(),
    g: Math.random(),
    b: Math.random()
  });
}
function NQ(e) {
  if (e === void 0 && (e = {}), e.count !== void 0 && e.count !== null) {
    var t = e.count, n = [];
    for (e.count = void 0; t > n.length; )
      e.count = null, e.seed && (e.seed += 1), n.push(NQ(e));
    return e.count = t, n;
  }
  var r = OMe(e.hue, e.seed), i = MMe(r, e), o = kMe(r, i, e), a = { h: r, s: i, v: o };
  return e.alpha !== void 0 && (a.a = e.alpha), new Mn(a);
}
function OMe(e, t) {
  var n = DMe(e), r = NS(n, t);
  return r < 0 && (r = 360 + r), r;
}
function MMe(e, t) {
  if (t.hue === "monochrome")
    return 0;
  if (t.luminosity === "random")
    return NS([0, 100], t.seed);
  var n = DQ(e).saturationRange, r = n[0], i = n[1];
  switch (t.luminosity) {
    case "bright":
      r = 55;
      break;
    case "dark":
      r = i - 10;
      break;
    case "light":
      i = 55;
      break;
  }
  return NS([r, i], t.seed);
}
function kMe(e, t, n) {
  var r = NMe(e, t), i = 100;
  switch (n.luminosity) {
    case "dark":
      i = r + 20;
      break;
    case "light":
      r = (i + r) / 2;
      break;
    case "random":
      r = 0, i = 100;
      break;
  }
  return NS([r, i], n.seed);
}
function NMe(e, t) {
  for (var n = DQ(e).lowerBounds, r = 0; r < n.length - 1; r++) {
    var i = n[r][0], o = n[r][1], a = n[r + 1][0], s = n[r + 1][1];
    if (t >= i && t <= a) {
      var c = (s - o) / (a - i), l = o - c * i;
      return c * t + l;
    }
  }
  return 0;
}
function DMe(e) {
  var t = parseInt(e, 10);
  if (!Number.isNaN(t) && t < 360 && t > 0)
    return [t, t];
  if (typeof e == "string") {
    var n = SM.find(function(a) {
      return a.name === e;
    });
    if (n) {
      var r = jQ(n);
      if (r.hueRange)
        return r.hueRange;
    }
    var i = new Mn(e);
    if (i.isValid) {
      var o = i.toHsv().h;
      return [o, o];
    }
  }
  return [0, 360];
}
function DQ(e) {
  e >= 334 && e <= 360 && (e -= 360);
  for (var t = 0, n = SM; t < n.length; t++) {
    var r = n[t], i = jQ(r);
    if (i.hueRange && e >= i.hueRange[0] && e <= i.hueRange[1])
      return i;
  }
  throw Error("Color not found");
}
function NS(e, t) {
  if (t === void 0)
    return Math.floor(e[0] + Math.random() * (e[1] + 1 - e[0]));
  var n = e[1] || 1, r = e[0] || 0;
  t = (t * 9301 + 49297) % 233280;
  var i = t / 233280;
  return Math.floor(r + i * (n - r));
}
function jQ(e) {
  var t = e.lowerBounds[0][0], n = e.lowerBounds[e.lowerBounds.length - 1][0], r = e.lowerBounds[e.lowerBounds.length - 1][1], i = e.lowerBounds[0][1];
  return {
    name: e.name,
    hueRange: e.hueRange,
    lowerBounds: e.lowerBounds,
    saturationRange: [t, n],
    brightnessRange: [r, i]
  };
}
var SM = [
  {
    name: "monochrome",
    hueRange: null,
    lowerBounds: [
      [0, 0],
      [100, 0]
    ]
  },
  {
    name: "red",
    hueRange: [-26, 18],
    lowerBounds: [
      [20, 100],
      [30, 92],
      [40, 89],
      [50, 85],
      [60, 78],
      [70, 70],
      [80, 60],
      [90, 55],
      [100, 50]
    ]
  },
  {
    name: "orange",
    hueRange: [19, 46],
    lowerBounds: [
      [20, 100],
      [30, 93],
      [40, 88],
      [50, 86],
      [60, 85],
      [70, 70],
      [100, 70]
    ]
  },
  {
    name: "yellow",
    hueRange: [47, 62],
    lowerBounds: [
      [25, 100],
      [40, 94],
      [50, 89],
      [60, 86],
      [70, 84],
      [80, 82],
      [90, 80],
      [100, 75]
    ]
  },
  {
    name: "green",
    hueRange: [63, 178],
    lowerBounds: [
      [30, 100],
      [40, 90],
      [50, 85],
      [60, 81],
      [70, 74],
      [80, 64],
      [90, 50],
      [100, 40]
    ]
  },
  {
    name: "blue",
    hueRange: [179, 257],
    lowerBounds: [
      [20, 100],
      [30, 86],
      [40, 80],
      [50, 74],
      [60, 60],
      [70, 52],
      [80, 44],
      [90, 39],
      [100, 35]
    ]
  },
  {
    name: "purple",
    hueRange: [258, 282],
    lowerBounds: [
      [20, 100],
      [30, 87],
      [40, 79],
      [50, 70],
      [60, 65],
      [70, 59],
      [80, 52],
      [90, 45],
      [100, 42]
    ]
  },
  {
    name: "pink",
    hueRange: [283, 334],
    lowerBounds: [
      [20, 100],
      [30, 90],
      [40, 86],
      [60, 84],
      [80, 80],
      [90, 75],
      [100, 73]
    ]
  }
];
const jMe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  TinyColor: Mn,
  bounds: SM,
  convertDecimalToHex: bM,
  convertHexToDecimal: qA,
  default: dL,
  fromRatio: RMe,
  hslToRgb: $Q,
  hsvToRgb: AQ,
  inputToRGB: Pd,
  isReadable: MQ,
  isValidCSSUnit: Ws,
  legacyRandom: PMe,
  mostReadable: kQ,
  names: kS,
  numberInputToObject: PQ,
  parseIntFromHex: qo,
  random: NQ,
  readability: _M,
  rgbToHex: MS,
  rgbToHsl: UA,
  rgbToHsv: OS,
  rgbToRgb: IQ,
  rgbaToArgbHex: WA,
  rgbaToHex: RQ,
  stringInputToObject: OQ,
  tinycolor: dL,
  toMsFilter: AMe
}, Symbol.toStringTag, { value: "Module" }));
var s1 = 2, fL = 0.16, LMe = 0.05, FMe = 0.05, VMe = 0.15, LQ = 5, FQ = 4, BMe = [{
  index: 7,
  opacity: 0.15
}, {
  index: 6,
  opacity: 0.25
}, {
  index: 5,
  opacity: 0.3
}, {
  index: 5,
  opacity: 0.45
}, {
  index: 5,
  opacity: 0.65
}, {
  index: 5,
  opacity: 0.85
}, {
  index: 4,
  opacity: 0.9
}, {
  index: 3,
  opacity: 0.95
}, {
  index: 2,
  opacity: 0.97
}, {
  index: 1,
  opacity: 0.98
}];
function hL(e) {
  var t = e.r, n = e.g, r = e.b, i = OS(t, n, r);
  return {
    h: i.h * 360,
    s: i.s,
    v: i.v
  };
}
function c1(e) {
  var t = e.r, n = e.g, r = e.b;
  return "#".concat(MS(t, n, r, !1));
}
function zMe(e, t, n) {
  var r = n / 100, i = {
    r: (t.r - e.r) * r + e.r,
    g: (t.g - e.g) * r + e.g,
    b: (t.b - e.b) * r + e.b
  };
  return i;
}
function gL(e, t, n) {
  var r;
  return Math.round(e.h) >= 60 && Math.round(e.h) <= 240 ? r = n ? Math.round(e.h) - s1 * t : Math.round(e.h) + s1 * t : r = n ? Math.round(e.h) + s1 * t : Math.round(e.h) - s1 * t, r < 0 ? r += 360 : r >= 360 && (r -= 360), r;
}
function pL(e, t, n) {
  if (e.h === 0 && e.s === 0)
    return e.s;
  var r;
  return n ? r = e.s - fL * t : t === FQ ? r = e.s + fL : r = e.s + LMe * t, r > 1 && (r = 1), n && t === LQ && r > 0.1 && (r = 0.1), r < 0.06 && (r = 0.06), Number(r.toFixed(2));
}
function mL(e, t, n) {
  var r;
  return n ? r = e.v + FMe * t : r = e.v - VMe * t, r > 1 && (r = 1), Number(r.toFixed(2));
}
function Qg(e) {
  for (var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = [], r = Pd(e), i = LQ; i > 0; i -= 1) {
    var o = hL(r), a = c1(Pd({
      h: gL(o, i, !0),
      s: pL(o, i, !0),
      v: mL(o, i, !0)
    }));
    n.push(a);
  }
  n.push(c1(r));
  for (var s = 1; s <= FQ; s += 1) {
    var c = hL(r), l = c1(Pd({
      h: gL(c, s),
      s: pL(c, s),
      v: mL(c, s)
    }));
    n.push(l);
  }
  return t.theme === "dark" ? BMe.map(function(u) {
    var d = u.index, f = u.opacity, h = c1(zMe(Pd(t.backgroundColor || "#141414"), Pd(n[d]), f * 100));
    return h;
  }) : n;
}
var p_ = {
  red: "#F5222D",
  volcano: "#FA541C",
  orange: "#FA8C16",
  gold: "#FAAD14",
  yellow: "#FADB14",
  lime: "#A0D911",
  green: "#52C41A",
  cyan: "#13C2C2",
  blue: "#1677FF",
  geekblue: "#2F54EB",
  purple: "#722ED1",
  magenta: "#EB2F96",
  grey: "#666666"
}, DS = ["#fff1f0", "#ffccc7", "#ffa39e", "#ff7875", "#ff4d4f", "#f5222d", "#cf1322", "#a8071a", "#820014", "#5c0011"];
DS.primary = DS[5];
var jS = ["#fff2e8", "#ffd8bf", "#ffbb96", "#ff9c6e", "#ff7a45", "#fa541c", "#d4380d", "#ad2102", "#871400", "#610b00"];
jS.primary = jS[5];
var LS = ["#fff7e6", "#ffe7ba", "#ffd591", "#ffc069", "#ffa940", "#fa8c16", "#d46b08", "#ad4e00", "#873800", "#612500"];
LS.primary = LS[5];
var FS = ["#fffbe6", "#fff1b8", "#ffe58f", "#ffd666", "#ffc53d", "#faad14", "#d48806", "#ad6800", "#874d00", "#613400"];
FS.primary = FS[5];
var VS = ["#feffe6", "#ffffb8", "#fffb8f", "#fff566", "#ffec3d", "#fadb14", "#d4b106", "#ad8b00", "#876800", "#614700"];
VS.primary = VS[5];
var BS = ["#fcffe6", "#f4ffb8", "#eaff8f", "#d3f261", "#bae637", "#a0d911", "#7cb305", "#5b8c00", "#3f6600", "#254000"];
BS.primary = BS[5];
var zS = ["#f6ffed", "#d9f7be", "#b7eb8f", "#95de64", "#73d13d", "#52c41a", "#389e0d", "#237804", "#135200", "#092b00"];
zS.primary = zS[5];
var HS = ["#e6fffb", "#b5f5ec", "#87e8de", "#5cdbd3", "#36cfc9", "#13c2c2", "#08979c", "#006d75", "#00474f", "#002329"];
HS.primary = HS[5];
var Tv = ["#e6f4ff", "#bae0ff", "#91caff", "#69b1ff", "#4096ff", "#1677ff", "#0958d9", "#003eb3", "#002c8c", "#001d66"];
Tv.primary = Tv[5];
var US = ["#f0f5ff", "#d6e4ff", "#adc6ff", "#85a5ff", "#597ef7", "#2f54eb", "#1d39c4", "#10239e", "#061178", "#030852"];
US.primary = US[5];
var WS = ["#f9f0ff", "#efdbff", "#d3adf7", "#b37feb", "#9254de", "#722ed1", "#531dab", "#391085", "#22075e", "#120338"];
WS.primary = WS[5];
var qS = ["#fff0f6", "#ffd6e7", "#ffadd2", "#ff85c0", "#f759ab", "#eb2f96", "#c41d7f", "#9e1068", "#780650", "#520339"];
qS.primary = qS[5];
var Iv = ["#a6a6a6", "#999999", "#8c8c8c", "#808080", "#737373", "#666666", "#404040", "#1a1a1a", "#000000", "#000000"];
Iv.primary = Iv[5];
var HMe = Iv, m_ = {
  red: DS,
  volcano: jS,
  orange: LS,
  gold: FS,
  yellow: VS,
  lime: BS,
  green: zS,
  cyan: HS,
  blue: Tv,
  geekblue: US,
  purple: WS,
  magenta: qS,
  grey: Iv
}, GS = ["#2a1215", "#431418", "#58181c", "#791a1f", "#a61d24", "#d32029", "#e84749", "#f37370", "#f89f9a", "#fac8c3"];
GS.primary = GS[5];
var KS = ["#2b1611", "#441d12", "#592716", "#7c3118", "#aa3e19", "#d84a1b", "#e87040", "#f3956a", "#f8b692", "#fad4bc"];
KS.primary = KS[5];
var YS = ["#2b1d11", "#442a11", "#593815", "#7c4a15", "#aa6215", "#d87a16", "#e89a3c", "#f3b765", "#f8cf8d", "#fae3b7"];
YS.primary = YS[5];
var XS = ["#2b2111", "#443111", "#594214", "#7c5914", "#aa7714", "#d89614", "#e8b339", "#f3cc62", "#f8df8b", "#faedb5"];
XS.primary = XS[5];
var QS = ["#2b2611", "#443b11", "#595014", "#7c6e14", "#aa9514", "#d8bd14", "#e8d639", "#f3ea62", "#f8f48b", "#fafab5"];
QS.primary = QS[5];
var JS = ["#1f2611", "#2e3c10", "#3e4f13", "#536d13", "#6f9412", "#8bbb11", "#a9d134", "#c9e75d", "#e4f88b", "#f0fab5"];
JS.primary = JS[5];
var ZS = ["#162312", "#1d3712", "#274916", "#306317", "#3c8618", "#49aa19", "#6abe39", "#8fd460", "#b2e58b", "#d5f2bb"];
ZS.primary = ZS[5];
var ew = ["#112123", "#113536", "#144848", "#146262", "#138585", "#13a8a8", "#33bcb7", "#58d1c9", "#84e2d8", "#b2f1e8"];
ew.primary = ew[5];
var tw = ["#111a2c", "#112545", "#15325b", "#15417e", "#1554ad", "#1668dc", "#3c89e8", "#65a9f3", "#8dc5f8", "#b7dcfa"];
tw.primary = tw[5];
var nw = ["#131629", "#161d40", "#1c2755", "#203175", "#263ea0", "#2b4acb", "#5273e0", "#7f9ef3", "#a8c1f8", "#d2e0fa"];
nw.primary = nw[5];
var rw = ["#1a1325", "#24163a", "#301c4d", "#3e2069", "#51258f", "#642ab5", "#854eca", "#ab7ae0", "#cda8f0", "#ebd7fa"];
rw.primary = rw[5];
var iw = ["#291321", "#40162f", "#551c3b", "#75204f", "#a02669", "#cb2b83", "#e0529c", "#f37fb7", "#f8a8cc", "#fad2e3"];
iw.primary = iw[5];
var ow = ["#151515", "#1f1f1f", "#2d2d2d", "#393939", "#494949", "#5a5a5a", "#6a6a6a", "#7b7b7b", "#888888", "#969696"];
ow.primary = ow[5];
var UMe = {
  red: GS,
  volcano: KS,
  orange: YS,
  gold: XS,
  yellow: QS,
  lime: JS,
  green: ZS,
  cyan: ew,
  blue: tw,
  geekblue: nw,
  purple: rw,
  magenta: iw,
  grey: ow
};
const WMe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  blue: Tv,
  blueDark: tw,
  cyan: HS,
  cyanDark: ew,
  geekblue: US,
  geekblueDark: nw,
  generate: Qg,
  gold: FS,
  goldDark: XS,
  gray: HMe,
  green: zS,
  greenDark: ZS,
  grey: Iv,
  greyDark: ow,
  lime: BS,
  limeDark: JS,
  magenta: qS,
  magentaDark: iw,
  orange: LS,
  orangeDark: YS,
  presetDarkPalettes: UMe,
  presetPalettes: m_,
  presetPrimaryColors: p_,
  purple: WS,
  purpleDark: rw,
  red: DS,
  redDark: GS,
  volcano: jS,
  volcanoDark: KS,
  yellow: VS,
  yellowDark: QS
}, Symbol.toStringTag, { value: "Module" })), VQ = {
  blue: "#1677FF",
  purple: "#722ED1",
  cyan: "#13C2C2",
  green: "#52C41A",
  magenta: "#EB2F96",
  /**
   * @deprecated Use magenta instead
   */
  pink: "#EB2F96",
  red: "#F5222D",
  orange: "#FA8C16",
  yellow: "#FADB14",
  volcano: "#FA541C",
  geekblue: "#2F54EB",
  gold: "#FAAD14",
  lime: "#A0D911"
}, qMe = Object.assign(Object.assign({}, VQ), {
  // Color
  colorPrimary: "#1677ff",
  colorSuccess: "#52c41a",
  colorWarning: "#faad14",
  colorError: "#ff4d4f",
  colorInfo: "#1677ff",
  colorLink: "",
  colorTextBase: "",
  colorBgBase: "",
  // Font
  fontFamily: `-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,
'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',
'Noto Color Emoji'`,
  fontFamilyCode: "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace",
  fontSize: 14,
  // Line
  lineWidth: 1,
  lineType: "solid",
  // Motion
  motionUnit: 0.1,
  motionBase: 0,
  motionEaseOutCirc: "cubic-bezier(0.08, 0.82, 0.17, 1)",
  motionEaseInOutCirc: "cubic-bezier(0.78, 0.14, 0.15, 0.86)",
  motionEaseOut: "cubic-bezier(0.215, 0.61, 0.355, 1)",
  motionEaseInOut: "cubic-bezier(0.645, 0.045, 0.355, 1)",
  motionEaseOutBack: "cubic-bezier(0.12, 0.4, 0.29, 1.46)",
  motionEaseInBack: "cubic-bezier(0.71, -0.46, 0.88, 0.6)",
  motionEaseInQuint: "cubic-bezier(0.755, 0.05, 0.855, 0.06)",
  motionEaseOutQuint: "cubic-bezier(0.23, 1, 0.32, 1)",
  // Radius
  borderRadius: 6,
  // Size
  sizeUnit: 4,
  sizeStep: 4,
  sizePopupArrow: 16,
  // Control Base
  controlHeight: 32,
  // zIndex
  zIndexBase: 0,
  zIndexPopupBase: 1e3,
  // Image
  opacityImage: 1,
  // Wireframe
  wireframe: !1,
  // Motion
  motion: !0
}), $v = qMe;
function GMe(e, t) {
  let {
    generateColorPalettes: n,
    generateNeutralColorPalettes: r
  } = t;
  const {
    colorSuccess: i,
    colorWarning: o,
    colorError: a,
    colorInfo: s,
    colorPrimary: c,
    colorBgBase: l,
    colorTextBase: u
  } = e, d = n(c), f = n(i), h = n(o), p = n(a), g = n(s), m = r(l, u), v = e.colorLink || e.colorInfo, y = n(v), _ = new Mn(p[1]).mix(new Mn(p[3]), 50).toHexString();
  return Object.assign(Object.assign({}, m), {
    colorPrimaryBg: d[1],
    colorPrimaryBgHover: d[2],
    colorPrimaryBorder: d[3],
    colorPrimaryBorderHover: d[4],
    colorPrimaryHover: d[5],
    colorPrimary: d[6],
    colorPrimaryActive: d[7],
    colorPrimaryTextHover: d[8],
    colorPrimaryText: d[9],
    colorPrimaryTextActive: d[10],
    colorSuccessBg: f[1],
    colorSuccessBgHover: f[2],
    colorSuccessBorder: f[3],
    colorSuccessBorderHover: f[4],
    colorSuccessHover: f[4],
    colorSuccess: f[6],
    colorSuccessActive: f[7],
    colorSuccessTextHover: f[8],
    colorSuccessText: f[9],
    colorSuccessTextActive: f[10],
    colorErrorBg: p[1],
    colorErrorBgHover: p[2],
    colorErrorBgFilledHover: _,
    colorErrorBgActive: p[3],
    colorErrorBorder: p[3],
    colorErrorBorderHover: p[4],
    colorErrorHover: p[5],
    colorError: p[6],
    colorErrorActive: p[7],
    colorErrorTextHover: p[8],
    colorErrorText: p[9],
    colorErrorTextActive: p[10],
    colorWarningBg: h[1],
    colorWarningBgHover: h[2],
    colorWarningBorder: h[3],
    colorWarningBorderHover: h[4],
    colorWarningHover: h[4],
    colorWarning: h[6],
    colorWarningActive: h[7],
    colorWarningTextHover: h[8],
    colorWarningText: h[9],
    colorWarningTextActive: h[10],
    colorInfoBg: g[1],
    colorInfoBgHover: g[2],
    colorInfoBorder: g[3],
    colorInfoBorderHover: g[4],
    colorInfoHover: g[4],
    colorInfo: g[6],
    colorInfoActive: g[7],
    colorInfoTextHover: g[8],
    colorInfoText: g[9],
    colorInfoTextActive: g[10],
    colorLinkHover: y[4],
    colorLink: y[6],
    colorLinkActive: y[7],
    colorBgMask: new Mn("#000").setAlpha(0.45).toRgbString(),
    colorWhite: "#fff"
  });
}
const KMe = (e) => {
  let t = e, n = e, r = e, i = e;
  return e < 6 && e >= 5 ? t = e + 1 : e < 16 && e >= 6 ? t = e + 2 : e >= 16 && (t = 16), e < 7 && e >= 5 ? n = 4 : e < 8 && e >= 7 ? n = 5 : e < 14 && e >= 8 ? n = 6 : e < 16 && e >= 14 ? n = 7 : e >= 16 && (n = 8), e < 6 && e >= 2 ? r = 1 : e >= 6 && (r = 2), e > 4 && e < 8 ? i = 4 : e >= 8 && (i = 6), {
    borderRadius: e,
    borderRadiusXS: r,
    borderRadiusSM: n,
    borderRadiusLG: t,
    borderRadiusOuter: i
  };
}, YMe = KMe;
function XMe(e) {
  const {
    motionUnit: t,
    motionBase: n,
    borderRadius: r,
    lineWidth: i
  } = e;
  return Object.assign({
    // motion
    motionDurationFast: `${(n + t).toFixed(1)}s`,
    motionDurationMid: `${(n + t * 2).toFixed(1)}s`,
    motionDurationSlow: `${(n + t * 3).toFixed(1)}s`,
    // line
    lineWidthBold: i + 1
  }, YMe(r));
}
const QMe = (e) => {
  const {
    controlHeight: t
  } = e;
  return {
    controlHeightSM: t * 0.75,
    controlHeightXS: t * 0.5,
    controlHeightLG: t * 1.25
  };
}, JMe = QMe;
function v_(e) {
  return (e + 8) / e;
}
function ZMe(e) {
  const t = new Array(10).fill(null).map((n, r) => {
    const i = r - 1, o = e * Math.pow(Math.E, i / 5), a = r > 1 ? Math.floor(o) : Math.ceil(o);
    return Math.floor(a / 2) * 2;
  });
  return t[1] = e, t.map((n) => ({
    size: n,
    lineHeight: v_(n)
  }));
}
const e3e = (e) => {
  const t = ZMe(e), n = t.map((u) => u.size), r = t.map((u) => u.lineHeight), i = n[1], o = n[0], a = n[2], s = r[1], c = r[0], l = r[2];
  return {
    fontSizeSM: o,
    fontSize: i,
    fontSizeLG: a,
    fontSizeXL: n[3],
    fontSizeHeading1: n[6],
    fontSizeHeading2: n[5],
    fontSizeHeading3: n[4],
    fontSizeHeading4: n[3],
    fontSizeHeading5: n[2],
    lineHeight: s,
    lineHeightLG: l,
    lineHeightSM: c,
    fontHeight: Math.round(s * i),
    fontHeightLG: Math.round(l * a),
    fontHeightSM: Math.round(c * o),
    lineHeightHeading1: r[6],
    lineHeightHeading2: r[5],
    lineHeightHeading3: r[4],
    lineHeightHeading4: r[3],
    lineHeightHeading5: r[2]
  };
}, t3e = e3e;
function n3e(e) {
  const {
    sizeUnit: t,
    sizeStep: n
  } = e;
  return {
    sizeXXL: t * (n + 8),
    // 48
    sizeXL: t * (n + 4),
    // 32
    sizeLG: t * (n + 2),
    // 24
    sizeMD: t * (n + 1),
    // 20
    sizeMS: t * n,
    // 16
    size: t * n,
    // 16
    sizeSM: t * (n - 1),
    // 12
    sizeXS: t * (n - 2),
    // 8
    sizeXXS: t * (n - 3)
    // 4
  };
}
const Aa = (e, t) => new Mn(e).setAlpha(t).toRgbString(), Rm = (e, t) => new Mn(e).darken(t).toHexString(), r3e = (e) => {
  const t = Qg(e);
  return {
    1: t[0],
    2: t[1],
    3: t[2],
    4: t[3],
    5: t[4],
    6: t[5],
    7: t[6],
    8: t[4],
    9: t[5],
    10: t[6]
    // 8: colors[7],
    // 9: colors[8],
    // 10: colors[9],
  };
}, i3e = (e, t) => {
  const n = e || "#fff", r = t || "#000";
  return {
    colorBgBase: n,
    colorTextBase: r,
    colorText: Aa(r, 0.88),
    colorTextSecondary: Aa(r, 0.65),
    colorTextTertiary: Aa(r, 0.45),
    colorTextQuaternary: Aa(r, 0.25),
    colorFill: Aa(r, 0.15),
    colorFillSecondary: Aa(r, 0.06),
    colorFillTertiary: Aa(r, 0.04),
    colorFillQuaternary: Aa(r, 0.02),
    colorBgSolid: Aa(r, 1),
    colorBgSolidHover: Aa(r, 0.75),
    colorBgSolidActive: Aa(r, 0.95),
    colorBgLayout: Rm(n, 4),
    colorBgContainer: Rm(n, 0),
    colorBgElevated: Rm(n, 0),
    colorBgSpotlight: Aa(r, 0.85),
    colorBgBlur: "transparent",
    colorBorder: Rm(n, 15),
    colorBorderSecondary: Rm(n, 6)
  };
};
function o3e(e) {
  p_.pink = p_.magenta, m_.pink = m_.magenta;
  const t = Object.keys(VQ).map((n) => {
    const r = e[n] === p_[n] ? m_[n] : Qg(e[n]);
    return new Array(10).fill(1).reduce((i, o, a) => (i[`${n}-${a + 1}`] = r[a], i[`${n}${a + 1}`] = r[a], i), {});
  }).reduce((n, r) => (n = Object.assign(Object.assign({}, n), r), n), {});
  return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, e), t), GMe(e, {
    generateColorPalettes: r3e,
    generateNeutralColorPalettes: i3e
  })), t3e(e.fontSize)), n3e(e)), JMe(e)), XMe(e));
}
const BQ = RS(o3e), GA = {
  token: $v,
  override: {
    override: $v
  },
  hashed: !0
}, zQ = /* @__PURE__ */ j.createContext(GA), aw = "ant", wM = "anticon", a3e = ["outlined", "borderless", "filled"], s3e = (e, t) => t || (e ? `${aw}-${e}` : aw), Cn = /* @__PURE__ */ $.createContext({
  // We provide a default function for Context without provider
  getPrefixCls: s3e,
  iconPrefixCls: wM
}), c3e = `-ant-${Date.now()}-${Math.random()}`;
function l3e(e, t) {
  const n = {}, r = (a, s) => {
    let c = a.clone();
    return c = (s == null ? void 0 : s(c)) || c, c.toRgbString();
  }, i = (a, s) => {
    const c = new Mn(a), l = Qg(c.toRgbString());
    n[`${s}-color`] = r(c), n[`${s}-color-disabled`] = l[1], n[`${s}-color-hover`] = l[4], n[`${s}-color-active`] = l[6], n[`${s}-color-outline`] = c.clone().setAlpha(0.2).toRgbString(), n[`${s}-color-deprecated-bg`] = l[0], n[`${s}-color-deprecated-border`] = l[2];
  };
  if (t.primaryColor) {
    i(t.primaryColor, "primary");
    const a = new Mn(t.primaryColor), s = Qg(a.toRgbString());
    s.forEach((l, u) => {
      n[`primary-${u + 1}`] = l;
    }), n["primary-color-deprecated-l-35"] = r(a, (l) => l.lighten(35)), n["primary-color-deprecated-l-20"] = r(a, (l) => l.lighten(20)), n["primary-color-deprecated-t-20"] = r(a, (l) => l.tint(20)), n["primary-color-deprecated-t-50"] = r(a, (l) => l.tint(50)), n["primary-color-deprecated-f-12"] = r(a, (l) => l.setAlpha(l.getAlpha() * 0.12));
    const c = new Mn(s[0]);
    n["primary-color-active-deprecated-f-30"] = r(c, (l) => l.setAlpha(l.getAlpha() * 0.3)), n["primary-color-active-deprecated-d-02"] = r(c, (l) => l.darken(2));
  }
  return t.successColor && i(t.successColor, "success"), t.warningColor && i(t.warningColor, "warning"), t.errorColor && i(t.errorColor, "error"), t.infoColor && i(t.infoColor, "info"), `
  :root {
    ${Object.keys(n).map((a) => `--${e}-${a}: ${n[a]};`).join(`
`)}
  }
  `.trim();
}
function u3e(e, t) {
  const n = l3e(e, t);
  uo() ? mc(n, `${c3e}-dynamic-theme`) : process.env.NODE_ENV !== "production" && DE(!1, "ConfigProvider", "SSR do not support dynamic theme with css variables.");
}
const KA = /* @__PURE__ */ $.createContext(!1), d3e = (e) => {
  let {
    children: t,
    disabled: n
  } = e;
  const r = $.useContext(KA);
  return /* @__PURE__ */ $.createElement(KA.Provider, {
    value: n ?? r
  }, t);
}, id = KA, YA = /* @__PURE__ */ $.createContext(void 0), f3e = (e) => {
  let {
    children: t,
    size: n
  } = e;
  const r = $.useContext(YA);
  return /* @__PURE__ */ $.createElement(YA.Provider, {
    value: n || r
  }, t);
}, jE = YA;
function h3e() {
  const e = gt(id), t = gt(jE);
  return {
    componentDisabled: e,
    componentSize: t
  };
}
var HQ = /* @__PURE__ */ Er(function e() {
  xr(this, e);
}), UQ = "CALC_UNIT", g3e = new RegExp(UQ, "g");
function pT(e) {
  return typeof e == "number" ? "".concat(e).concat(UQ) : e;
}
var p3e = /* @__PURE__ */ function(e) {
  Ds(n, e);
  var t = Ac(n);
  function n(r, i) {
    var o;
    xr(this, n), o = t.call(this), oe(rn(o), "result", ""), oe(rn(o), "unitlessCssVar", void 0), oe(rn(o), "lowPriority", void 0);
    var a = It(r);
    return o.unitlessCssVar = i, r instanceof n ? o.result = "(".concat(r.result, ")") : a === "number" ? o.result = pT(r) : a === "string" && (o.result = r), o;
  }
  return Er(n, [{
    key: "add",
    value: function(i) {
      return i instanceof n ? this.result = "".concat(this.result, " + ").concat(i.getResult()) : (typeof i == "number" || typeof i == "string") && (this.result = "".concat(this.result, " + ").concat(pT(i))), this.lowPriority = !0, this;
    }
  }, {
    key: "sub",
    value: function(i) {
      return i instanceof n ? this.result = "".concat(this.result, " - ").concat(i.getResult()) : (typeof i == "number" || typeof i == "string") && (this.result = "".concat(this.result, " - ").concat(pT(i))), this.lowPriority = !0, this;
    }
  }, {
    key: "mul",
    value: function(i) {
      return this.lowPriority && (this.result = "(".concat(this.result, ")")), i instanceof n ? this.result = "".concat(this.result, " * ").concat(i.getResult(!0)) : (typeof i == "number" || typeof i == "string") && (this.result = "".concat(this.result, " * ").concat(i)), this.lowPriority = !1, this;
    }
  }, {
    key: "div",
    value: function(i) {
      return this.lowPriority && (this.result = "(".concat(this.result, ")")), i instanceof n ? this.result = "".concat(this.result, " / ").concat(i.getResult(!0)) : (typeof i == "number" || typeof i == "string") && (this.result = "".concat(this.result, " / ").concat(i)), this.lowPriority = !1, this;
    }
  }, {
    key: "getResult",
    value: function(i) {
      return this.lowPriority || i ? "(".concat(this.result, ")") : this.result;
    }
  }, {
    key: "equal",
    value: function(i) {
      var o = this, a = i || {}, s = a.unit, c = !0;
      return typeof s == "boolean" ? c = s : Array.from(this.unitlessCssVar).some(function(l) {
        return o.result.includes(l);
      }) && (c = !1), this.result = this.result.replace(g3e, c ? "px" : ""), typeof this.lowPriority < "u" ? "calc(".concat(this.result, ")") : this.result;
    }
  }]), n;
}(HQ), m3e = /* @__PURE__ */ function(e) {
  Ds(n, e);
  var t = Ac(n);
  function n(r) {
    var i;
    return xr(this, n), i = t.call(this), oe(rn(i), "result", 0), r instanceof n ? i.result = r.result : typeof r == "number" && (i.result = r), i;
  }
  return Er(n, [{
    key: "add",
    value: function(i) {
      return i instanceof n ? this.result += i.result : typeof i == "number" && (this.result += i), this;
    }
  }, {
    key: "sub",
    value: function(i) {
      return i instanceof n ? this.result -= i.result : typeof i == "number" && (this.result -= i), this;
    }
  }, {
    key: "mul",
    value: function(i) {
      return i instanceof n ? this.result *= i.result : typeof i == "number" && (this.result *= i), this;
    }
  }, {
    key: "div",
    value: function(i) {
      return i instanceof n ? this.result /= i.result : typeof i == "number" && (this.result /= i), this;
    }
  }, {
    key: "equal",
    value: function() {
      return this.result;
    }
  }]), n;
}(HQ), WQ = function(t, n) {
  var r = t === "css" ? p3e : m3e;
  return function(i) {
    return new r(i, n);
  };
}, vL = function(t, n) {
  return "".concat([n, t.replace(/([A-Z]+)([A-Z][a-z]+)/g, "$1-$2").replace(/([a-z])([A-Z])/g, "$1-$2")].filter(Boolean).join("-"));
};
function Pr(e) {
  var t = $.useRef();
  t.current = e;
  var n = $.useCallback(function() {
    for (var r, i = arguments.length, o = new Array(i), a = 0; a < i; a++)
      o[a] = arguments[a];
    return (r = t.current) === null || r === void 0 ? void 0 : r.call.apply(r, [t].concat(o));
  }, []);
  return n;
}
function Av(e) {
  var t = $.useRef(!1), n = $.useState(e), r = he(n, 2), i = r[0], o = r[1];
  $.useEffect(function() {
    return t.current = !1, function() {
      t.current = !0;
    };
  }, []);
  function a(s, c) {
    c && t.current || o(s);
  }
  return [i, a];
}
function mT(e) {
  return e !== void 0;
}
function wc(e, t) {
  var n = t || {}, r = n.defaultValue, i = n.value, o = n.onChange, a = n.postState, s = Av(function() {
    return mT(i) ? i : mT(r) ? typeof r == "function" ? r() : r : typeof e == "function" ? e() : e;
  }), c = he(s, 2), l = c[0], u = c[1], d = i !== void 0 ? i : l, f = a ? a(d) : d, h = Pr(o), p = Av([d]), g = he(p, 2), m = g[0], v = g[1];
  B0(function() {
    var _ = m[0];
    l !== _ && h(l, _);
  }, [m]), B0(function() {
    mT(i) || u(i);
  }, [i]);
  var y = Pr(function(_, b) {
    u(_, b), v([d], b);
  });
  return [f, y];
}
function yL(e, t, n, r) {
  var i = ae({}, t[e]);
  if (r != null && r.deprecatedTokens) {
    var o = r.deprecatedTokens;
    o.forEach(function(s) {
      var c = he(s, 2), l = c[0], u = c[1];
      if (process.env.NODE_ENV !== "production" && sn(!(i != null && i[l]), "Component Token `".concat(String(l), "` of ").concat(String(e), " is deprecated. Please use `").concat(String(u), "` instead.")), i != null && i[l] || i != null && i[u]) {
        var d;
        (d = i[u]) !== null && d !== void 0 || (i[u] = i == null ? void 0 : i[l]);
      }
    });
  }
  var a = ae(ae({}, n), i);
  return Object.keys(a).forEach(function(s) {
    a[s] === t[s] && delete a[s];
  }), a;
}
var qQ = process.env.NODE_ENV !== "production" || typeof CSSINJS_STATISTIC < "u", XA = !0;
function Mr() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  if (!qQ)
    return Object.assign.apply(Object, [{}].concat(t));
  XA = !1;
  var r = {};
  return t.forEach(function(i) {
    if (It(i) === "object") {
      var o = Object.keys(i);
      o.forEach(function(a) {
        Object.defineProperty(r, a, {
          configurable: !0,
          enumerable: !0,
          get: function() {
            return i[a];
          }
        });
      });
    }
  }), XA = !0, r;
}
var QA = {};
function v3e() {
}
var GQ = function(t) {
  var n, r = t, i = v3e;
  return qQ && typeof Proxy < "u" && (n = /* @__PURE__ */ new Set(), r = new Proxy(t, {
    get: function(a, s) {
      if (XA) {
        var c;
        (c = n) === null || c === void 0 || c.add(s);
      }
      return a[s];
    }
  }), i = function(a, s) {
    var c;
    QA[a] = {
      global: Array.from(n),
      component: ae(ae({}, (c = QA[a]) === null || c === void 0 ? void 0 : c.component), s)
    };
  }), {
    token: r,
    keys: n,
    flush: i
  };
};
function bL(e, t, n) {
  if (typeof n == "function") {
    var r;
    return n(Mr(t, (r = t[e]) !== null && r !== void 0 ? r : {}));
  }
  return n ?? {};
}
function y3e(e) {
  return e === "js" ? {
    max: Math.max,
    min: Math.min
  } : {
    max: function() {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
        r[i] = arguments[i];
      return "max(".concat(r.map(function(o) {
        return et(o);
      }).join(","), ")");
    },
    min: function() {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
        r[i] = arguments[i];
      return "min(".concat(r.map(function(o) {
        return et(o);
      }).join(","), ")");
    }
  };
}
var b3e = 1e3 * 60 * 10, _3e = /* @__PURE__ */ function() {
  function e() {
    xr(this, e), oe(this, "map", /* @__PURE__ */ new Map()), oe(this, "objectIDMap", /* @__PURE__ */ new WeakMap()), oe(this, "nextID", 0), oe(this, "lastAccessBeat", /* @__PURE__ */ new Map()), oe(this, "accessBeat", 0);
  }
  return Er(e, [{
    key: "set",
    value: function(n, r) {
      this.clear();
      var i = this.getCompositeKey(n);
      this.map.set(i, r), this.lastAccessBeat.set(i, Date.now());
    }
  }, {
    key: "get",
    value: function(n) {
      var r = this.getCompositeKey(n), i = this.map.get(r);
      return this.lastAccessBeat.set(r, Date.now()), this.accessBeat += 1, i;
    }
  }, {
    key: "getCompositeKey",
    value: function(n) {
      var r = this, i = n.map(function(o) {
        return o && It(o) === "object" ? "obj_".concat(r.getObjectID(o)) : "".concat(It(o), "_").concat(o);
      });
      return i.join("|");
    }
  }, {
    key: "getObjectID",
    value: function(n) {
      if (this.objectIDMap.has(n))
        return this.objectIDMap.get(n);
      var r = this.nextID;
      return this.objectIDMap.set(n, r), this.nextID += 1, r;
    }
  }, {
    key: "clear",
    value: function() {
      var n = this;
      if (this.accessBeat > 1e4) {
        var r = Date.now();
        this.lastAccessBeat.forEach(function(i, o) {
          r - i > b3e && (n.map.delete(o), n.lastAccessBeat.delete(o));
        }), this.accessBeat = 0;
      }
    }
  }]), e;
}(), _L = new _3e();
function S3e(e, t) {
  return j.useMemo(function() {
    var n = _L.get(t);
    if (n)
      return n;
    var r = e();
    return _L.set(t, r), r;
  }, t);
}
var w3e = function() {
  return {};
};
function KQ(e) {
  var t = e.useCSP, n = t === void 0 ? w3e : t, r = e.useToken, i = e.usePrefix, o = e.getResetStyles, a = e.getCommonStyle, s = e.getCompUnitless;
  function c(f, h, p, g) {
    var m = Array.isArray(f) ? f[0] : f;
    function v(T) {
      return "".concat(String(m)).concat(T.slice(0, 1).toUpperCase()).concat(T.slice(1));
    }
    var y = (g == null ? void 0 : g.unitless) || {}, _ = typeof s == "function" ? s(f) : {}, b = ae(ae({}, _), {}, oe({}, v("zIndexPopup"), !0));
    Object.keys(y).forEach(function(T) {
      b[v(T)] = y[T];
    });
    var w = ae(ae({}, g), {}, {
      unitless: b,
      prefixToken: v
    }), C = u(f, h, p, w), x = l(m, p, w);
    return function(T) {
      var E = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : T, R = C(T, E), I = he(R, 2), O = I[1], P = x(E), k = he(P, 2), L = k[0], N = k[1];
      return [L, O, N];
    };
  }
  function l(f, h, p) {
    var g = p.unitless, m = p.injectStyle, v = m === void 0 ? !0 : m, y = p.prefixToken, _ = p.ignore, b = function(x) {
      var T = x.rootCls, E = x.cssVar, R = E === void 0 ? {} : E, I = r(), O = I.realToken;
      return yQ({
        path: [f],
        prefix: R.prefix,
        key: R.key,
        unitless: g,
        ignore: _,
        token: O,
        scope: T
      }, function() {
        var P = bL(f, O, h), k = yL(f, O, P, {
          deprecatedTokens: p == null ? void 0 : p.deprecatedTokens
        });
        return Object.keys(P).forEach(function(L) {
          k[y(L)] = k[L], delete k[L];
        }), k;
      }), null;
    }, w = function(x) {
      var T = r(), E = T.cssVar;
      return [function(R) {
        return v && E ? /* @__PURE__ */ j.createElement(j.Fragment, null, /* @__PURE__ */ j.createElement(b, {
          rootCls: x,
          cssVar: E,
          component: f
        }), R) : R;
      }, E == null ? void 0 : E.key];
    };
    return w;
  }
  function u(f, h, p) {
    var g = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, m = Array.isArray(f) ? f : [f, f], v = he(m, 1), y = v[0], _ = m.join("-"), b = e.layer || {
      name: "antd"
    };
    return function(w) {
      var C = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : w, x = r(), T = x.theme, E = x.realToken, R = x.hashId, I = x.token, O = x.cssVar, P = i(), k = P.rootPrefixCls, L = P.iconPrefixCls, N = n(), D = O ? "css" : "js", z = S3e(function() {
        var q = /* @__PURE__ */ new Set();
        return O && Object.keys(g.unitless || {}).forEach(function(X) {
          q.add(V0(X, O.prefix)), q.add(V0(X, vL(y, O.prefix)));
        }), WQ(D, q);
      }, [D, y, O == null ? void 0 : O.prefix]), V = y3e(D), B = V.max, U = V.min, Q = {
        theme: T,
        token: I,
        hashId: R,
        nonce: function() {
          return N.nonce;
        },
        clientOnly: g.clientOnly,
        layer: b,
        // antd is always at top of styles
        order: g.order || -999
      };
      PS(ae(ae({}, Q), {}, {
        clientOnly: !1,
        path: ["Shared", k]
      }), function() {
        return typeof o == "function" ? o(I) : [];
      });
      var Y = PS(ae(ae({}, Q), {}, {
        path: [_, w, L]
      }), function() {
        if (g.injectStyle === !1)
          return [];
        var q = GQ(I), X = q.token, ne = q.flush, Z = bL(y, E, p), J = ".".concat(w), K = yL(y, E, Z, {
          deprecatedTokens: g.deprecatedTokens
        });
        O && Z && It(Z) === "object" && Object.keys(Z).forEach(function(ie) {
          Z[ie] = "var(".concat(V0(ie, vL(y, O.prefix)), ")");
        });
        var ee = Mr(X, {
          componentCls: J,
          prefixCls: w,
          iconCls: ".".concat(L),
          antCls: ".".concat(k),
          calc: z,
          // @ts-ignore
          max: B,
          // @ts-ignore
          min: U
        }, O ? Z : K), te = h(ee, {
          hashId: R,
          prefixCls: w,
          rootPrefixCls: k,
          iconPrefixCls: L
        });
        ne(y, K);
        var H = typeof a == "function" ? a(ee, w, C, g.resetFont) : null;
        return [g.resetStyle === !1 ? null : H, te];
      });
      return [Y, R];
    };
  }
  function d(f, h, p) {
    var g = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, m = u(f, h, p, ae({
      resetStyle: !1,
      // Sub Style should default after root one
      order: -998
    }, g)), v = function(_) {
      var b = _.prefixCls, w = _.rootCls, C = w === void 0 ? b : w;
      return m(b, C), null;
    };
    return process.env.NODE_ENV !== "production" && (v.displayName = "SubStyle_".concat(String(Array.isArray(f) ? f.join(".") : f))), v;
  }
  return {
    genStyleHooks: c,
    genSubStyleComponent: d,
    genComponentStyleHook: u
  };
}
const x3e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  genCalc: WQ,
  genStyleUtils: KQ,
  mergeToken: Mr,
  statistic: QA,
  statisticToken: GQ
}, Symbol.toStringTag, { value: "Module" })), sw = ["blue", "purple", "cyan", "green", "magenta", "pink", "red", "orange", "yellow", "volcano", "geekblue", "lime", "gold"], E3e = "5.22.1";
function vT(e) {
  return e >= 0 && e <= 255;
}
function l1(e, t) {
  const {
    r: n,
    g: r,
    b: i,
    a: o
  } = new Mn(e).toRgb();
  if (o < 1)
    return e;
  const {
    r: a,
    g: s,
    b: c
  } = new Mn(t).toRgb();
  for (let l = 0.01; l <= 1; l += 0.01) {
    const u = Math.round((n - a * (1 - l)) / l), d = Math.round((r - s * (1 - l)) / l), f = Math.round((i - c * (1 - l)) / l);
    if (vT(u) && vT(d) && vT(f))
      return new Mn({
        r: u,
        g: d,
        b: f,
        a: Math.round(l * 100) / 100
      }).toRgbString();
  }
  return new Mn({
    r: n,
    g: r,
    b: i,
    a: 1
  }).toRgbString();
}
var C3e = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
function YQ(e) {
  const {
    override: t
  } = e, n = C3e(e, ["override"]), r = Object.assign({}, t);
  Object.keys($v).forEach((f) => {
    delete r[f];
  });
  const i = Object.assign(Object.assign({}, n), r), o = 480, a = 576, s = 768, c = 992, l = 1200, u = 1600;
  if (i.motion === !1) {
    const f = "0s";
    i.motionDurationFast = f, i.motionDurationMid = f, i.motionDurationSlow = f;
  }
  return Object.assign(Object.assign(Object.assign({}, i), {
    // ============== Background ============== //
    colorFillContent: i.colorFillSecondary,
    colorFillContentHover: i.colorFill,
    colorFillAlter: i.colorFillQuaternary,
    colorBgContainerDisabled: i.colorFillTertiary,
    // ============== Split ============== //
    colorBorderBg: i.colorBgContainer,
    colorSplit: l1(i.colorBorderSecondary, i.colorBgContainer),
    // ============== Text ============== //
    colorTextPlaceholder: i.colorTextQuaternary,
    colorTextDisabled: i.colorTextQuaternary,
    colorTextHeading: i.colorText,
    colorTextLabel: i.colorTextSecondary,
    colorTextDescription: i.colorTextTertiary,
    colorTextLightSolid: i.colorWhite,
    colorHighlight: i.colorError,
    colorBgTextHover: i.colorFillSecondary,
    colorBgTextActive: i.colorFill,
    colorIcon: i.colorTextTertiary,
    colorIconHover: i.colorText,
    colorErrorOutline: l1(i.colorErrorBg, i.colorBgContainer),
    colorWarningOutline: l1(i.colorWarningBg, i.colorBgContainer),
    // Font
    fontSizeIcon: i.fontSizeSM,
    // Line
    lineWidthFocus: i.lineWidth * 3,
    // Control
    lineWidth: i.lineWidth,
    controlOutlineWidth: i.lineWidth * 2,
    // Checkbox size and expand icon size
    controlInteractiveSize: i.controlHeight / 2,
    controlItemBgHover: i.colorFillTertiary,
    controlItemBgActive: i.colorPrimaryBg,
    controlItemBgActiveHover: i.colorPrimaryBgHover,
    controlItemBgActiveDisabled: i.colorFill,
    controlTmpOutline: i.colorFillQuaternary,
    controlOutline: l1(i.colorPrimaryBg, i.colorBgContainer),
    lineType: i.lineType,
    borderRadius: i.borderRadius,
    borderRadiusXS: i.borderRadiusXS,
    borderRadiusSM: i.borderRadiusSM,
    borderRadiusLG: i.borderRadiusLG,
    fontWeightStrong: 600,
    opacityLoading: 0.65,
    linkDecoration: "none",
    linkHoverDecoration: "none",
    linkFocusDecoration: "none",
    controlPaddingHorizontal: 12,
    controlPaddingHorizontalSM: 8,
    paddingXXS: i.sizeXXS,
    paddingXS: i.sizeXS,
    paddingSM: i.sizeSM,
    padding: i.size,
    paddingMD: i.sizeMD,
    paddingLG: i.sizeLG,
    paddingXL: i.sizeXL,
    paddingContentHorizontalLG: i.sizeLG,
    paddingContentVerticalLG: i.sizeMS,
    paddingContentHorizontal: i.sizeMS,
    paddingContentVertical: i.sizeSM,
    paddingContentHorizontalSM: i.size,
    paddingContentVerticalSM: i.sizeXS,
    marginXXS: i.sizeXXS,
    marginXS: i.sizeXS,
    marginSM: i.sizeSM,
    margin: i.size,
    marginMD: i.sizeMD,
    marginLG: i.sizeLG,
    marginXL: i.sizeXL,
    marginXXL: i.sizeXXL,
    boxShadow: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowSecondary: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowTertiary: `
      0 1px 2px 0 rgba(0, 0, 0, 0.03),
      0 1px 6px -1px rgba(0, 0, 0, 0.02),
      0 2px 4px 0 rgba(0, 0, 0, 0.02)
    `,
    screenXS: o,
    screenXSMin: o,
    screenXSMax: a - 1,
    screenSM: a,
    screenSMMin: a,
    screenSMMax: s - 1,
    screenMD: s,
    screenMDMin: s,
    screenMDMax: c - 1,
    screenLG: c,
    screenLGMin: c,
    screenLGMax: l - 1,
    screenXL: l,
    screenXLMin: l,
    screenXLMax: u - 1,
    screenXXL: u,
    screenXXLMin: u,
    boxShadowPopoverArrow: "2px 2px 5px rgba(0, 0, 0, 0.05)",
    boxShadowCard: `
      0 1px 2px -2px ${new Mn("rgba(0, 0, 0, 0.16)").toRgbString()},
      0 3px 6px 0 ${new Mn("rgba(0, 0, 0, 0.12)").toRgbString()},
      0 5px 12px 4px ${new Mn("rgba(0, 0, 0, 0.09)").toRgbString()}
    `,
    boxShadowDrawerRight: `
      -6px 0 16px 0 rgba(0, 0, 0, 0.08),
      -3px 0 6px -4px rgba(0, 0, 0, 0.12),
      -9px 0 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowDrawerLeft: `
      6px 0 16px 0 rgba(0, 0, 0, 0.08),
      3px 0 6px -4px rgba(0, 0, 0, 0.12),
      9px 0 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowDrawerUp: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowDrawerDown: `
      0 -6px 16px 0 rgba(0, 0, 0, 0.08),
      0 -3px 6px -4px rgba(0, 0, 0, 0.12),
      0 -9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowTabsOverflowLeft: "inset 10px 0 8px -8px rgba(0, 0, 0, 0.08)",
    boxShadowTabsOverflowRight: "inset -10px 0 8px -8px rgba(0, 0, 0, 0.08)",
    boxShadowTabsOverflowTop: "inset 0 10px 8px -8px rgba(0, 0, 0, 0.08)",
    boxShadowTabsOverflowBottom: "inset 0 -10px 8px -8px rgba(0, 0, 0, 0.08)"
  }), r);
}
var SL = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
const XQ = {
  lineHeight: !0,
  lineHeightSM: !0,
  lineHeightLG: !0,
  lineHeightHeading1: !0,
  lineHeightHeading2: !0,
  lineHeightHeading3: !0,
  lineHeightHeading4: !0,
  lineHeightHeading5: !0,
  opacityLoading: !0,
  fontWeightStrong: !0,
  zIndexPopupBase: !0,
  zIndexBase: !0,
  opacityImage: !0
}, T3e = {
  size: !0,
  sizeSM: !0,
  sizeLG: !0,
  sizeMD: !0,
  sizeXS: !0,
  sizeXXS: !0,
  sizeMS: !0,
  sizeXL: !0,
  sizeXXL: !0,
  sizeUnit: !0,
  sizeStep: !0,
  motionBase: !0,
  motionUnit: !0
}, I3e = {
  screenXS: !0,
  screenXSMin: !0,
  screenXSMax: !0,
  screenSM: !0,
  screenSMMin: !0,
  screenSMMax: !0,
  screenMD: !0,
  screenMDMin: !0,
  screenMDMax: !0,
  screenLG: !0,
  screenLGMin: !0,
  screenLGMax: !0,
  screenXL: !0,
  screenXLMin: !0,
  screenXLMax: !0,
  screenXXL: !0,
  screenXXLMin: !0
}, QQ = (e, t, n) => {
  const r = n.getDerivativeToken(e), {
    override: i
  } = t, o = SL(t, ["override"]);
  let a = Object.assign(Object.assign({}, r), {
    override: i
  });
  return a = YQ(a), o && Object.entries(o).forEach((s) => {
    let [c, l] = s;
    const {
      theme: u
    } = l, d = SL(l, ["theme"]);
    let f = d;
    u && (f = QQ(Object.assign(Object.assign({}, a), d), {
      override: d
    }, u)), a[c] = f;
  }), a;
};
function js() {
  const {
    token: e,
    hashed: t,
    theme: n,
    override: r,
    cssVar: i
  } = j.useContext(zQ), o = `${E3e}-${t || ""}`, a = n || BQ, [s, c, l] = rQ(a, [$v, e], {
    salt: o,
    override: r,
    getComputedToken: QQ,
    // formatToken will not be consumed after 1.15.0 with getComputedToken.
    // But token will break if @ant-design/cssinjs is under 1.15.0 without it
    formatToken: YQ,
    cssVar: i && {
      prefix: i.prefix,
      key: i.key,
      unitless: XQ,
      ignore: T3e,
      preserve: I3e
    }
  });
  return [a, l, t ? c : "", s, i];
}
const JA = {
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis"
}, _a = function(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
  return {
    boxSizing: "border-box",
    margin: 0,
    padding: 0,
    color: e.colorText,
    fontSize: e.fontSize,
    // font-variant: @font-variant-base;
    lineHeight: e.lineHeight,
    listStyle: "none",
    // font-feature-settings: @font-feature-settings-base;
    fontFamily: t ? "inherit" : e.fontFamily
  };
}, LE = () => ({
  display: "inline-flex",
  alignItems: "center",
  color: "inherit",
  fontStyle: "normal",
  lineHeight: 0,
  textAlign: "center",
  textTransform: "none",
  // for SVG icon, see https://blog.prototypr.io/align-svg-icons-to-text-and-say-goodbye-to-font-icons-d44b3d7b26b4
  verticalAlign: "-0.125em",
  textRendering: "optimizeLegibility",
  "-webkit-font-smoothing": "antialiased",
  "-moz-osx-font-smoothing": "grayscale",
  "> *": {
    lineHeight: 1
  },
  svg: {
    display: "inline-block"
  }
}), $3e = () => ({
  // https://github.com/ant-design/ant-design/issues/21301#issuecomment-583955229
  "&::before": {
    display: "table",
    content: '""'
  },
  "&::after": {
    // https://github.com/ant-design/ant-design/issues/21864
    display: "table",
    clear: "both",
    content: '""'
  }
}), A3e = (e) => ({
  a: {
    color: e.colorLink,
    textDecoration: e.linkDecoration,
    backgroundColor: "transparent",
    // remove the gray background on active links in IE 10.
    outline: "none",
    cursor: "pointer",
    transition: `color ${e.motionDurationSlow}`,
    "-webkit-text-decoration-skip": "objects",
    // remove gaps in links underline in iOS 8+ and Safari 8+.
    "&:hover": {
      color: e.colorLinkHover
    },
    "&:active": {
      color: e.colorLinkActive
    },
    "&:active, &:hover": {
      textDecoration: e.linkHoverDecoration,
      outline: 0
    },
    // https://github.com/ant-design/ant-design/issues/22503
    "&:focus": {
      textDecoration: e.linkFocusDecoration,
      outline: 0
    },
    "&[disabled]": {
      color: e.colorTextDisabled,
      cursor: "not-allowed"
    }
  }
}), R3e = (e, t, n, r) => {
  const i = `[class^="${t}"], [class*=" ${t}"]`, o = n ? `.${n}` : i, a = {
    boxSizing: "border-box",
    "&::before, &::after": {
      boxSizing: "border-box"
    }
  };
  let s = {};
  return r !== !1 && (s = {
    fontFamily: e.fontFamily,
    fontSize: e.fontSize
  }), {
    [o]: Object.assign(Object.assign(Object.assign({}, s), a), {
      [i]: a
    })
  };
}, P3e = (e) => ({
  outline: `${et(e.lineWidthFocus)} solid ${e.colorPrimaryBorder}`,
  outlineOffset: 1,
  transition: "outline-offset 0s, outline 0s"
}), O3e = (e) => ({
  "&:focus-visible": Object.assign({}, P3e(e))
}), M3e = (e, t) => {
  const [n, r] = js();
  return PS({
    theme: n,
    token: r,
    hashId: "",
    path: ["ant-design-icons", e],
    nonce: () => t == null ? void 0 : t.nonce,
    layer: {
      name: "antd"
    }
  }, () => [{
    [`.${e}`]: Object.assign(Object.assign({}, LE()), {
      [`.${e} .${e}-icon`]: {
        display: "block"
      }
    })
  }]);
}, JQ = M3e, {
  genStyleHooks: Za,
  genComponentStyleHook: k3e,
  genSubStyleComponent: N3e
} = KQ({
  usePrefix: () => {
    const {
      getPrefixCls: e,
      iconPrefixCls: t
    } = gt(Cn);
    return {
      rootPrefixCls: e(),
      iconPrefixCls: t
    };
  },
  useToken: () => {
    const [e, t, n, r, i] = js();
    return {
      theme: e,
      realToken: t,
      hashId: n,
      token: r,
      cssVar: i
    };
  },
  useCSP: () => {
    const {
      csp: e,
      iconPrefixCls: t
    } = gt(Cn);
    return JQ(t, e), e ?? {};
  },
  getResetStyles: (e) => [{
    "&": A3e(e)
  }],
  getCommonStyle: R3e,
  getCompUnitless: () => XQ
});
function D3e(e, t) {
  return sw.reduce((n, r) => {
    const i = e[`${r}1`], o = e[`${r}3`], a = e[`${r}6`], s = e[`${r}7`];
    return Object.assign(Object.assign({}, n), t(r, {
      lightColor: i,
      lightBorderColor: o,
      darkColor: a,
      textColor: s
    }));
  }, {});
}
const j3e = Object.assign({}, $), {
  useId: wL
} = j3e, L3e = () => "", F3e = typeof wL > "u" ? L3e : wL, V3e = F3e;
function B3e(e, t, n) {
  var r, i;
  const o = di("ConfigProvider"), a = e || {}, s = a.inherit === !1 || !t ? Object.assign(Object.assign({}, GA), {
    hashed: (r = t == null ? void 0 : t.hashed) !== null && r !== void 0 ? r : GA.hashed,
    cssVar: t == null ? void 0 : t.cssVar
  }) : t, c = V3e();
  if (process.env.NODE_ENV !== "production") {
    const l = a.cssVar || s.cssVar, u = !!(typeof a.cssVar == "object" && (!((i = a.cssVar) === null || i === void 0) && i.key) || c);
    process.env.NODE_ENV !== "production" && o(!l || u, "breaking", "Missing key in `cssVar` config. Please upgrade to React 18 or set `cssVar.key` manually in each ConfigProvider inside `cssVar` enabled ConfigProvider.");
  }
  return Iy(() => {
    var l, u;
    if (!e)
      return t;
    const d = Object.assign({}, s.components);
    Object.keys(e.components || {}).forEach((p) => {
      d[p] = Object.assign(Object.assign({}, d[p]), e.components[p]);
    });
    const f = `css-var-${c.replace(/:/g, "")}`, h = ((l = a.cssVar) !== null && l !== void 0 ? l : s.cssVar) && Object.assign(Object.assign(Object.assign({
      prefix: n == null ? void 0 : n.prefixCls
    }, typeof s.cssVar == "object" ? s.cssVar : {}), typeof a.cssVar == "object" ? a.cssVar : {}), {
      key: typeof a.cssVar == "object" && ((u = a.cssVar) === null || u === void 0 ? void 0 : u.key) || f
    });
    return Object.assign(Object.assign(Object.assign({}, s), a), {
      token: Object.assign(Object.assign({}, s.token), a.token),
      components: d,
      cssVar: h
    });
  }, [a, s], (l, u) => l.some((d, f) => {
    const h = u[f];
    return !Ug(d, h, !0);
  }));
}
var z3e = ["children"], ZQ = /* @__PURE__ */ $.createContext({});
function eJ(e) {
  var t = e.children, n = En(e, z3e);
  return /* @__PURE__ */ $.createElement(ZQ.Provider, {
    value: n
  }, t);
}
var H3e = /* @__PURE__ */ function(e) {
  Ds(n, e);
  var t = Ac(n);
  function n() {
    return xr(this, n), t.apply(this, arguments);
  }
  return Er(n, [{
    key: "render",
    value: function() {
      return this.props.children;
    }
  }]), n;
}($.Component);
function U3e(e) {
  var t = $.useReducer(function(s) {
    return s + 1;
  }, 0), n = he(t, 2), r = n[1], i = $.useRef(e), o = Pr(function() {
    return i.current;
  }), a = Pr(function(s) {
    i.current = typeof s == "function" ? s(i.current) : s, r();
  });
  return [o, a];
}
var jl = "none", u1 = "appear", d1 = "enter", f1 = "leave", xL = "none", us = "prepare", Qh = "start", Jh = "active", xM = "end", tJ = "prepared";
function EL(e, t) {
  var n = {};
  return n[e.toLowerCase()] = t.toLowerCase(), n["Webkit".concat(e)] = "webkit".concat(t), n["Moz".concat(e)] = "moz".concat(t), n["ms".concat(e)] = "MS".concat(t), n["O".concat(e)] = "o".concat(t.toLowerCase()), n;
}
function W3e(e, t) {
  var n = {
    animationend: EL("Animation", "AnimationEnd"),
    transitionend: EL("Transition", "TransitionEnd")
  };
  return e && ("AnimationEvent" in t || delete n.animationend.animation, "TransitionEvent" in t || delete n.transitionend.transition), n;
}
var q3e = W3e(uo(), typeof window < "u" ? window : {}), nJ = {};
if (uo()) {
  var G3e = document.createElement("div");
  nJ = G3e.style;
}
var h1 = {};
function rJ(e) {
  if (h1[e])
    return h1[e];
  var t = q3e[e];
  if (t)
    for (var n = Object.keys(t), r = n.length, i = 0; i < r; i += 1) {
      var o = n[i];
      if (Object.prototype.hasOwnProperty.call(t, o) && o in nJ)
        return h1[e] = t[o], h1[e];
    }
  return "";
}
var iJ = rJ("animationend"), oJ = rJ("transitionend"), aJ = !!(iJ && oJ), CL = iJ || "animationend", TL = oJ || "transitionend";
function IL(e, t) {
  if (!e)
    return null;
  if (It(e) === "object") {
    var n = t.replace(/-\w/g, function(r) {
      return r[1].toUpperCase();
    });
    return e[n];
  }
  return "".concat(e, "-").concat(t);
}
const K3e = function(e) {
  var t = $e();
  function n(i) {
    i && (i.removeEventListener(TL, e), i.removeEventListener(CL, e));
  }
  function r(i) {
    t.current && t.current !== i && n(t.current), i && i !== t.current && (i.addEventListener(TL, e), i.addEventListener(CL, e), t.current = i);
  }
  return $.useEffect(function() {
    return function() {
      n(t.current);
    };
  }, []), [r, n];
};
var sJ = uo() ? Fa : ot;
const Y3e = function() {
  var e = $.useRef(null);
  function t() {
    Ln.cancel(e.current);
  }
  function n(r) {
    var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    t();
    var o = Ln(function() {
      i <= 1 ? r({
        isCanceled: function() {
          return o !== e.current;
        }
      }) : n(r, i - 1);
    });
    e.current = o;
  }
  return $.useEffect(function() {
    return function() {
      t();
    };
  }, []), [n, t];
};
var X3e = [us, Qh, Jh, xM], Q3e = [us, tJ], cJ = !1, J3e = !0;
function lJ(e) {
  return e === Jh || e === xM;
}
const Z3e = function(e, t, n) {
  var r = Av(xL), i = he(r, 2), o = i[0], a = i[1], s = Y3e(), c = he(s, 2), l = c[0], u = c[1];
  function d() {
    a(us, !0);
  }
  var f = t ? Q3e : X3e;
  return sJ(function() {
    if (o !== xL && o !== xM) {
      var h = f.indexOf(o), p = f[h + 1], g = n(o);
      g === cJ ? a(p, !0) : p && l(function(m) {
        function v() {
          m.isCanceled() || a(p, !0);
        }
        g === !0 ? v() : Promise.resolve(g).then(v);
      });
    }
  }, [e, o]), $.useEffect(function() {
    return function() {
      u();
    };
  }, []), [d, o];
};
function eke(e, t, n, r) {
  var i = r.motionEnter, o = i === void 0 ? !0 : i, a = r.motionAppear, s = a === void 0 ? !0 : a, c = r.motionLeave, l = c === void 0 ? !0 : c, u = r.motionDeadline, d = r.motionLeaveImmediately, f = r.onAppearPrepare, h = r.onEnterPrepare, p = r.onLeavePrepare, g = r.onAppearStart, m = r.onEnterStart, v = r.onLeaveStart, y = r.onAppearActive, _ = r.onEnterActive, b = r.onLeaveActive, w = r.onAppearEnd, C = r.onEnterEnd, x = r.onLeaveEnd, T = r.onVisibleChanged, E = Av(), R = he(E, 2), I = R[0], O = R[1], P = U3e(jl), k = he(P, 2), L = k[0], N = k[1], D = Av(null), z = he(D, 2), V = z[0], B = z[1], U = L(), Q = $e(!1), Y = $e(null);
  function q() {
    return n();
  }
  var X = $e(!1);
  function ne() {
    N(jl), B(null, !0);
  }
  var Z = Pr(function(Te) {
    var de = L();
    if (de !== jl) {
      var Ae = q();
      if (!(Te && !Te.deadline && Te.target !== Ae)) {
        var ue = X.current, be;
        de === u1 && ue ? be = w == null ? void 0 : w(Ae, Te) : de === d1 && ue ? be = C == null ? void 0 : C(Ae, Te) : de === f1 && ue && (be = x == null ? void 0 : x(Ae, Te)), ue && be !== !1 && ne();
      }
    }
  }), J = K3e(Z), K = he(J, 1), ee = K[0], te = function(de) {
    switch (de) {
      case u1:
        return oe(oe(oe({}, us, f), Qh, g), Jh, y);
      case d1:
        return oe(oe(oe({}, us, h), Qh, m), Jh, _);
      case f1:
        return oe(oe(oe({}, us, p), Qh, v), Jh, b);
      default:
        return {};
    }
  }, H = $.useMemo(function() {
    return te(U);
  }, [U]), ie = Z3e(U, !e, function(Te) {
    if (Te === us) {
      var de = H[us];
      return de ? de(q()) : cJ;
    }
    if (le in H) {
      var Ae;
      B(((Ae = H[le]) === null || Ae === void 0 ? void 0 : Ae.call(H, q(), null)) || null);
    }
    return le === Jh && U !== jl && (ee(q()), u > 0 && (clearTimeout(Y.current), Y.current = setTimeout(function() {
      Z({
        deadline: !0
      });
    }, u))), le === tJ && ne(), J3e;
  }), W = he(ie, 2), se = W[0], le = W[1], ge = lJ(le);
  X.current = ge, sJ(function() {
    O(t);
    var Te = Q.current;
    Q.current = !0;
    var de;
    !Te && t && s && (de = u1), Te && t && o && (de = d1), (Te && !t && l || !Te && d && !t && l) && (de = f1);
    var Ae = te(de);
    de && (e || Ae[us]) ? (N(de), se()) : N(jl);
  }, [t]), ot(function() {
    // Cancel appear
    (U === u1 && !s || // Cancel enter
    U === d1 && !o || // Cancel leave
    U === f1 && !l) && N(jl);
  }, [s, o, l]), ot(function() {
    return function() {
      Q.current = !1, clearTimeout(Y.current);
    };
  }, []);
  var me = $.useRef(!1);
  ot(function() {
    I && (me.current = !0), I !== void 0 && U === jl && ((me.current || I) && (T == null || T(I)), me.current = !0);
  }, [I, U]);
  var pe = V;
  return H[us] && le === Qh && (pe = ae({
    transition: "none"
  }, pe)), [U, le, pe, I ?? t];
}
function tke(e) {
  var t = e;
  It(e) === "object" && (t = e.transitionSupport);
  function n(i, o) {
    return !!(i.motionName && t && o !== !1);
  }
  var r = /* @__PURE__ */ $.forwardRef(function(i, o) {
    var a = i.visible, s = a === void 0 ? !0 : a, c = i.removeOnLeave, l = c === void 0 ? !0 : c, u = i.forceRender, d = i.children, f = i.motionName, h = i.leavedClassName, p = i.eventProps, g = $.useContext(ZQ), m = g.motion, v = n(i, m), y = $e(), _ = $e();
    function b() {
      try {
        return y.current instanceof HTMLElement ? y.current : L0(_.current);
      } catch {
        return null;
      }
    }
    var w = eke(v, s, b, i), C = he(w, 4), x = C[0], T = C[1], E = C[2], R = C[3], I = $.useRef(R);
    R && (I.current = !0);
    var O = $.useCallback(function(V) {
      y.current = V, aM(o, V);
    }, [o]), P, k = ae(ae({}, p), {}, {
      visible: s
    });
    if (!d)
      P = null;
    else if (x === jl)
      R ? P = d(ae({}, k), O) : !l && I.current && h ? P = d(ae(ae({}, k), {}, {
        className: h
      }), O) : u || !l && !h ? P = d(ae(ae({}, k), {}, {
        style: {
          display: "none"
        }
      }), O) : P = null;
    else {
      var L;
      T === us ? L = "prepare" : lJ(T) ? L = "active" : T === Qh && (L = "start");
      var N = IL(f, "".concat(x, "-").concat(L));
      P = d(ae(ae({}, k), {}, {
        className: Ee(IL(f, x), oe(oe({}, N, N && L), f, typeof f == "string")),
        style: E
      }), O);
    }
    if (/* @__PURE__ */ $.isValidElement(P) && $y(P)) {
      var D = P, z = D.ref;
      z || (P = /* @__PURE__ */ $.cloneElement(P, {
        ref: O
      }));
    }
    return /* @__PURE__ */ $.createElement(H3e, {
      ref: _
    }, P);
  });
  return r.displayName = "CSSMotion", r;
}
const Uf = tke(aJ);
var ZA = "add", eR = "keep", tR = "remove", yT = "removed";
function nke(e) {
  var t;
  return e && It(e) === "object" && "key" in e ? t = e : t = {
    key: e
  }, ae(ae({}, t), {}, {
    key: String(t.key)
  });
}
function nR() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
  return e.map(nke);
}
function rke() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], n = [], r = 0, i = t.length, o = nR(e), a = nR(t);
  o.forEach(function(l) {
    for (var u = !1, d = r; d < i; d += 1) {
      var f = a[d];
      if (f.key === l.key) {
        r < d && (n = n.concat(a.slice(r, d).map(function(h) {
          return ae(ae({}, h), {}, {
            status: ZA
          });
        })), r = d), n.push(ae(ae({}, f), {}, {
          status: eR
        })), r += 1, u = !0;
        break;
      }
    }
    u || n.push(ae(ae({}, l), {}, {
      status: tR
    }));
  }), r < i && (n = n.concat(a.slice(r).map(function(l) {
    return ae(ae({}, l), {}, {
      status: ZA
    });
  })));
  var s = {};
  n.forEach(function(l) {
    var u = l.key;
    s[u] = (s[u] || 0) + 1;
  });
  var c = Object.keys(s).filter(function(l) {
    return s[l] > 1;
  });
  return c.forEach(function(l) {
    n = n.filter(function(u) {
      var d = u.key, f = u.status;
      return d !== l || f !== tR;
    }), n.forEach(function(u) {
      u.key === l && (u.status = eR);
    });
  }), n;
}
var ike = ["component", "children", "onVisibleChanged", "onAllRemoved"], oke = ["status"], ake = ["eventProps", "visible", "children", "motionName", "motionAppear", "motionEnter", "motionLeave", "motionLeaveImmediately", "motionDeadline", "removeOnLeave", "leavedClassName", "onAppearPrepare", "onAppearStart", "onAppearActive", "onAppearEnd", "onEnterStart", "onEnterActive", "onEnterEnd", "onLeaveStart", "onLeaveActive", "onLeaveEnd"];
function ske(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Uf, n = /* @__PURE__ */ function(r) {
    Ds(o, r);
    var i = Ac(o);
    function o() {
      var a;
      xr(this, o);
      for (var s = arguments.length, c = new Array(s), l = 0; l < s; l++)
        c[l] = arguments[l];
      return a = i.call.apply(i, [this].concat(c)), oe(rn(a), "state", {
        keyEntities: []
      }), oe(rn(a), "removeKey", function(u) {
        a.setState(function(d) {
          var f = d.keyEntities.map(function(h) {
            return h.key !== u ? h : ae(ae({}, h), {}, {
              status: yT
            });
          });
          return {
            keyEntities: f
          };
        }, function() {
          var d = a.state.keyEntities, f = d.filter(function(h) {
            var p = h.status;
            return p !== yT;
          }).length;
          f === 0 && a.props.onAllRemoved && a.props.onAllRemoved();
        });
      }), a;
    }
    return Er(o, [{
      key: "render",
      value: function() {
        var s = this, c = this.state.keyEntities, l = this.props, u = l.component, d = l.children, f = l.onVisibleChanged;
        l.onAllRemoved;
        var h = En(l, ike), p = u || $.Fragment, g = {};
        return ake.forEach(function(m) {
          g[m] = h[m], delete h[m];
        }), delete h.keys, /* @__PURE__ */ $.createElement(p, h, c.map(function(m, v) {
          var y = m.status, _ = En(m, oke), b = y === ZA || y === eR;
          return /* @__PURE__ */ $.createElement(t, xt({}, g, {
            key: _.key,
            visible: b,
            eventProps: _,
            onVisibleChanged: function(C) {
              f == null || f(C, {
                key: _.key
              }), C || s.removeKey(_.key);
            }
          }), function(w, C) {
            return d(ae(ae({}, w), {}, {
              index: v
            }), C);
          });
        }));
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function(s, c) {
        var l = s.keys, u = c.keyEntities, d = nR(l), f = rke(u, d);
        return {
          keyEntities: f.filter(function(h) {
            var p = u.find(function(g) {
              var m = g.key;
              return h.key === m;
            });
            return !(p && p.status === yT && h.status === tR);
          })
        };
      }
    }]), o;
  }($.Component);
  return oe(n, "defaultProps", {
    component: "div"
  }), n;
}
const uJ = ske(aJ), cke = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CSSMotionList: uJ,
  Provider: eJ,
  default: Uf
}, Symbol.toStringTag, { value: "Module" }));
function lke(e) {
  const {
    children: t
  } = e, [, n] = js(), {
    motion: r
  } = n, i = $.useRef(!1);
  return i.current = i.current || r === !1, i.current ? /* @__PURE__ */ $.createElement(eJ, {
    motion: r
  }, t) : t;
}
const dJ = /* @__PURE__ */ $.memo((e) => {
  let {
    dropdownMatchSelectWidth: t
  } = e;
  return di("ConfigProvider").deprecated(t === void 0, "dropdownMatchSelectWidth", "popupMatchSelectWidth"), null;
});
process.env.NODE_ENV !== "production" && (dJ.displayName = "PropWarning");
const uke = process.env.NODE_ENV !== "production" ? dJ : () => null;
var dke = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
let rR = !1;
const fke = process.env.NODE_ENV !== "production" ? (e) => {
  process.env.NODE_ENV !== "production" && DE(!rR, e, "Static function can not consume context like dynamic theme. Please use 'App' component instead.");
} : (
  /* istanbul ignore next */
  null
), hke = ["getTargetContainer", "getPopupContainer", "renderEmpty", "input", "pagination", "form", "select", "button"];
let cw, fJ, hJ, gJ;
function y_() {
  return cw || aw;
}
function gke() {
  return fJ || wM;
}
function pke(e) {
  return Object.keys(e).some((t) => t.endsWith("Color"));
}
const mke = (e) => {
  const {
    prefixCls: t,
    iconPrefixCls: n,
    theme: r,
    holderRender: i
  } = e;
  t !== void 0 && (cw = t), n !== void 0 && (fJ = n), "holderRender" in e && (gJ = i), r && (pke(r) ? (process.env.NODE_ENV !== "production" && DE(!1, "ConfigProvider", "`config` of css variable theme is not work in v5. Please use new `theme` config instead."), u3e(y_(), r)) : hJ = r);
}, pJ = () => ({
  getPrefixCls: (e, t) => t || (e ? `${y_()}-${e}` : y_()),
  getIconPrefixCls: gke,
  getRootPrefixCls: () => cw || y_(),
  getTheme: () => hJ,
  holderRender: gJ
}), vke = (e) => {
  const {
    children: t,
    csp: n,
    autoInsertSpaceInButton: r,
    alert: i,
    anchor: o,
    form: a,
    locale: s,
    componentSize: c,
    direction: l,
    space: u,
    splitter: d,
    virtual: f,
    dropdownMatchSelectWidth: h,
    popupMatchSelectWidth: p,
    popupOverflow: g,
    legacyLocale: m,
    parentContext: v,
    iconPrefixCls: y,
    theme: _,
    componentDisabled: b,
    segmented: w,
    statistic: C,
    spin: x,
    calendar: T,
    carousel: E,
    cascader: R,
    collapse: I,
    typography: O,
    checkbox: P,
    descriptions: k,
    divider: L,
    drawer: N,
    skeleton: D,
    steps: z,
    image: V,
    layout: B,
    list: U,
    mentions: Q,
    modal: Y,
    progress: q,
    result: X,
    slider: ne,
    breadcrumb: Z,
    menu: J,
    pagination: K,
    input: ee,
    textArea: te,
    empty: H,
    badge: ie,
    radio: W,
    rate: se,
    switch: le,
    transfer: ge,
    avatar: me,
    message: pe,
    tag: Te,
    table: de,
    card: Ae,
    tabs: ue,
    timeline: be,
    timePicker: Ie,
    upload: Ve,
    notification: ze,
    tree: Ne,
    colorPicker: lt,
    datePicker: mt,
    rangePicker: vt,
    flex: ke,
    wave: xe,
    dropdown: Re,
    warning: yt,
    tour: Pt,
    floatButtonGroup: _t,
    variant: St,
    inputNumber: ft,
    treeSelect: kn
  } = e, Dt = $.useCallback((Ue, We) => {
    const {
      prefixCls: ct
    } = e;
    if (We)
      return We;
    const ht = ct || v.getPrefixCls("");
    return Ue ? `${ht}-${Ue}` : ht;
  }, [v.getPrefixCls, e.prefixCls]), nt = y || v.iconPrefixCls || wM, Be = n || v.csp;
  JQ(nt, Be);
  const st = B3e(_, v.theme, {
    prefixCls: Dt("")
  });
  process.env.NODE_ENV !== "production" && (rR = rR || !!st);
  const pt = {
    csp: Be,
    autoInsertSpaceInButton: r,
    alert: i,
    anchor: o,
    locale: s || m,
    direction: l,
    space: u,
    splitter: d,
    virtual: f,
    popupMatchSelectWidth: p ?? h,
    popupOverflow: g,
    getPrefixCls: Dt,
    iconPrefixCls: nt,
    theme: st,
    segmented: w,
    statistic: C,
    spin: x,
    calendar: T,
    carousel: E,
    cascader: R,
    collapse: I,
    typography: O,
    checkbox: P,
    descriptions: k,
    divider: L,
    drawer: N,
    skeleton: D,
    steps: z,
    image: V,
    input: ee,
    textArea: te,
    layout: B,
    list: U,
    mentions: Q,
    modal: Y,
    progress: q,
    result: X,
    slider: ne,
    breadcrumb: Z,
    menu: J,
    pagination: K,
    empty: H,
    badge: ie,
    radio: W,
    rate: se,
    switch: le,
    transfer: ge,
    avatar: me,
    message: pe,
    tag: Te,
    table: de,
    card: Ae,
    tabs: ue,
    timeline: be,
    timePicker: Ie,
    upload: Ve,
    notification: ze,
    tree: Ne,
    colorPicker: lt,
    datePicker: mt,
    rangePicker: vt,
    flex: ke,
    wave: xe,
    dropdown: Re,
    warning: yt,
    tour: Pt,
    floatButtonGroup: _t,
    variant: St,
    inputNumber: ft,
    treeSelect: kn
  };
  process.env.NODE_ENV !== "production" && di("ConfigProvider")(!("autoInsertSpaceInButton" in e), "deprecated", "`autoInsertSpaceInButton` is deprecated. Please use `{ button: { autoInsertSpace: boolean }}` instead.");
  const Et = Object.assign({}, v);
  Object.keys(pt).forEach((Ue) => {
    pt[Ue] !== void 0 && (Et[Ue] = pt[Ue]);
  }), hke.forEach((Ue) => {
    const We = e[Ue];
    We && (Et[Ue] = We);
  }), typeof r < "u" && (Et.button = Object.assign({
    autoInsertSpace: r
  }, Et.button));
  const Ke = Iy(() => Et, Et, (Ue, We) => {
    const ct = Object.keys(Ue), ht = Object.keys(We);
    return ct.length !== ht.length || ct.some((Rt) => Ue[Rt] !== We[Rt]);
  }), rt = $.useMemo(() => ({
    prefixCls: nt,
    csp: Be
  }), [nt, Be]);
  let Le = /* @__PURE__ */ $.createElement($.Fragment, null, /* @__PURE__ */ $.createElement(uke, {
    dropdownMatchSelectWidth: h
  }), t);
  const Xt = $.useMemo(() => {
    var Ue, We, ct, ht;
    return Xh(((Ue = Xg.Form) === null || Ue === void 0 ? void 0 : Ue.defaultValidateMessages) || {}, ((ct = (We = Ke.locale) === null || We === void 0 ? void 0 : We.Form) === null || ct === void 0 ? void 0 : ct.defaultValidateMessages) || {}, ((ht = Ke.form) === null || ht === void 0 ? void 0 : ht.validateMessages) || {}, (a == null ? void 0 : a.validateMessages) || {});
  }, [Ke, a == null ? void 0 : a.validateMessages]);
  Object.keys(Xt).length > 0 && (Le = /* @__PURE__ */ $.createElement(gMe.Provider, {
    value: Xt
  }, Le)), s && (Le = /* @__PURE__ */ $.createElement(EMe, {
    locale: s,
    _ANT_MARK__: EQ
  }, Le)), (nt || Be) && (Le = /* @__PURE__ */ $.createElement(pM.Provider, {
    value: rt
  }, Le)), c && (Le = /* @__PURE__ */ $.createElement(f3e, {
    size: c
  }, Le)), Le = /* @__PURE__ */ $.createElement(lke, null, Le);
  const Ht = $.useMemo(() => {
    const Ue = st || {}, {
      algorithm: We,
      token: ct,
      components: ht,
      cssVar: Rt
    } = Ue, Ft = dke(Ue, ["algorithm", "token", "components", "cssVar"]), re = We && (!Array.isArray(We) || We.length > 0) ? RS(We) : BQ, Se = {};
    Object.entries(ht || {}).forEach((Ye) => {
      let [$t, Ct] = Ye;
      const ut = Object.assign({}, Ct);
      "algorithm" in ut && (ut.algorithm === !0 ? ut.theme = re : (Array.isArray(ut.algorithm) || typeof ut.algorithm == "function") && (ut.theme = RS(ut.algorithm)), delete ut.algorithm), Se[$t] = ut;
    });
    const De = Object.assign(Object.assign({}, $v), ct);
    return Object.assign(Object.assign({}, Ft), {
      theme: re,
      token: De,
      components: Se,
      override: Object.assign({
        override: De
      }, Se),
      cssVar: Rt
    });
  }, [st]);
  return _ && (Le = /* @__PURE__ */ $.createElement(zQ.Provider, {
    value: Ht
  }, Le)), Ke.warning && (Le = /* @__PURE__ */ $.createElement(wQ.Provider, {
    value: Ke.warning
  }, Le)), b !== void 0 && (Le = /* @__PURE__ */ $.createElement(d3e, {
    disabled: b
  }, Le)), /* @__PURE__ */ $.createElement(Cn.Provider, {
    value: Ke
  }, Le);
}, go = (e) => {
  const t = $.useContext(Cn), n = $.useContext(vM);
  return /* @__PURE__ */ $.createElement(vke, Object.assign({
    parentContext: t,
    legacyLocale: n
  }, e));
};
go.ConfigContext = Cn;
go.SizeContext = jE;
go.config = mke;
go.useConfig = h3e;
Object.defineProperty(go, "SizeContext", {
  get: () => (process.env.NODE_ENV !== "production" && DE(!1, "ConfigProvider", "ConfigProvider.SizeContext is deprecated. Please use `ConfigProvider.useConfig().componentSize` instead."), jE)
});
process.env.NODE_ENV !== "production" && (go.displayName = "ConfigProvider");
var yke = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 01-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z" } }] }, name: "check-circle", theme: "filled" };
const bke = yke;
function mJ(e) {
  var t;
  return e == null || (t = e.getRootNode) === null || t === void 0 ? void 0 : t.call(e);
}
function _ke(e) {
  return mJ(e) instanceof ShadowRoot;
}
function lw(e) {
  return _ke(e) ? mJ(e) : null;
}
function Ske(e) {
  return e.replace(/-(.)/g, function(t, n) {
    return n.toUpperCase();
  });
}
function wke(e, t) {
  sn(e, "[@ant-design/icons] ".concat(t));
}
function $L(e) {
  return It(e) === "object" && typeof e.name == "string" && typeof e.theme == "string" && (It(e.icon) === "object" || typeof e.icon == "function");
}
function AL() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  return Object.keys(e).reduce(function(t, n) {
    var r = e[n];
    switch (n) {
      case "class":
        t.className = r, delete t.class;
        break;
      default:
        delete t[n], t[Ske(n)] = r;
    }
    return t;
  }, {});
}
function iR(e, t, n) {
  return n ? /* @__PURE__ */ j.createElement(e.tag, ae(ae({
    key: t
  }, AL(e.attrs)), n), (e.children || []).map(function(r, i) {
    return iR(r, "".concat(t, "-").concat(e.tag, "-").concat(i));
  })) : /* @__PURE__ */ j.createElement(e.tag, ae({
    key: t
  }, AL(e.attrs)), (e.children || []).map(function(r, i) {
    return iR(r, "".concat(t, "-").concat(e.tag, "-").concat(i));
  }));
}
function vJ(e) {
  return Qg(e)[0];
}
function yJ(e) {
  return e ? Array.isArray(e) ? e : [e] : [];
}
var xke = `
.anticon {
  display: inline-flex;
  align-items: center;
  color: inherit;
  font-style: normal;
  line-height: 0;
  text-align: center;
  text-transform: none;
  vertical-align: -0.125em;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.anticon > * {
  line-height: 1;
}

.anticon svg {
  display: inline-block;
}

.anticon::before {
  display: none;
}

.anticon .anticon-icon {
  display: block;
}

.anticon[tabindex] {
  cursor: pointer;
}

.anticon-spin::before,
.anticon-spin {
  display: inline-block;
  -webkit-animation: loadingCircle 1s infinite linear;
  animation: loadingCircle 1s infinite linear;
}

@-webkit-keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
`, Eke = function(t) {
  var n = gt(pM), r = n.csp, i = n.prefixCls, o = xke;
  i && (o = o.replace(/anticon/g, i)), ot(function() {
    var a = t.current, s = lw(a);
    mc(o, "@ant-design-icons", {
      prepend: !0,
      csp: r,
      attachTo: s
    });
  }, []);
}, Cke = ["icon", "className", "onClick", "style", "primaryColor", "secondaryColor"], H0 = {
  primaryColor: "#333",
  secondaryColor: "#E6E6E6",
  calculated: !1
};
function Tke(e) {
  var t = e.primaryColor, n = e.secondaryColor;
  H0.primaryColor = t, H0.secondaryColor = n || vJ(t), H0.calculated = !!n;
}
function Ike() {
  return ae({}, H0);
}
var FE = function(t) {
  var n = t.icon, r = t.className, i = t.onClick, o = t.style, a = t.primaryColor, s = t.secondaryColor, c = En(t, Cke), l = $.useRef(), u = H0;
  if (a && (u = {
    primaryColor: a,
    secondaryColor: s || vJ(a)
  }), Eke(l), wke($L(n), "icon should be icon definiton, but got ".concat(n)), !$L(n))
    return null;
  var d = n;
  return d && typeof d.icon == "function" && (d = ae(ae({}, d), {}, {
    icon: d.icon(u.primaryColor, u.secondaryColor)
  })), iR(d.icon, "svg-".concat(d.name), ae(ae({
    className: r,
    onClick: i,
    style: o,
    "data-icon": d.name,
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true"
  }, c), {}, {
    ref: l
  }));
};
FE.displayName = "IconReact";
FE.getTwoToneColors = Ike;
FE.setTwoToneColors = Tke;
const EM = FE;
function bJ(e) {
  var t = yJ(e), n = he(t, 2), r = n[0], i = n[1];
  return EM.setTwoToneColors({
    primaryColor: r,
    secondaryColor: i
  });
}
function $ke() {
  var e = EM.getTwoToneColors();
  return e.calculated ? [e.primaryColor, e.secondaryColor] : e.primaryColor;
}
var Ake = ["className", "icon", "spin", "rotate", "tabIndex", "onClick", "twoToneColor"];
bJ(Tv.primary);
var VE = /* @__PURE__ */ $.forwardRef(function(e, t) {
  var n = e.className, r = e.icon, i = e.spin, o = e.rotate, a = e.tabIndex, s = e.onClick, c = e.twoToneColor, l = En(e, Ake), u = $.useContext(pM), d = u.prefixCls, f = d === void 0 ? "anticon" : d, h = u.rootClassName, p = Ee(h, f, oe(oe({}, "".concat(f, "-").concat(r.name), !!r.name), "".concat(f, "-spin"), !!i || r.name === "loading"), n), g = a;
  g === void 0 && s && (g = -1);
  var m = o ? {
    msTransform: "rotate(".concat(o, "deg)"),
    transform: "rotate(".concat(o, "deg)")
  } : void 0, v = yJ(c), y = he(v, 2), _ = y[0], b = y[1];
  return /* @__PURE__ */ $.createElement("span", xt({
    role: "img",
    "aria-label": r.name
  }, l, {
    ref: t,
    tabIndex: g,
    onClick: s,
    className: p
  }), /* @__PURE__ */ $.createElement(EM, {
    icon: r,
    primaryColor: _,
    secondaryColor: b,
    style: m
  }));
});
VE.displayName = "AntdIcon";
VE.getTwoToneColor = $ke;
VE.setTwoToneColor = bJ;
const mo = VE;
var Rke = function(t, n) {
  return /* @__PURE__ */ $.createElement(mo, xt({}, t, {
    ref: n,
    icon: bke
  }));
}, _J = /* @__PURE__ */ $.forwardRef(Rke);
process.env.NODE_ENV !== "production" && (_J.displayName = "CheckCircleFilled");
const SJ = _J;
var Pke = { icon: { tag: "svg", attrs: { "fill-rule": "evenodd", viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64c247.4 0 448 200.6 448 448S759.4 960 512 960 64 759.4 64 512 264.6 64 512 64zm127.98 274.82h-.04l-.08.06L512 466.75 384.14 338.88c-.04-.05-.06-.06-.08-.06a.12.12 0 00-.07 0c-.03 0-.05.01-.09.05l-45.02 45.02a.2.2 0 00-.05.09.12.12 0 000 .07v.02a.27.27 0 00.06.06L466.75 512 338.88 639.86c-.05.04-.06.06-.06.08a.12.12 0 000 .07c0 .03.01.05.05.09l45.02 45.02a.2.2 0 00.09.05.12.12 0 00.07 0c.02 0 .04-.01.08-.05L512 557.25l127.86 127.87c.04.04.06.05.08.05a.12.12 0 00.07 0c.03 0 .05-.01.09-.05l45.02-45.02a.2.2 0 00.05-.09.12.12 0 000-.07v-.02a.27.27 0 00-.05-.06L557.25 512l127.87-127.86c.04-.04.05-.06.05-.08a.12.12 0 000-.07c0-.03-.01-.05-.05-.09l-45.02-45.02a.2.2 0 00-.09-.05.12.12 0 00-.07 0z" } }] }, name: "close-circle", theme: "filled" };
const Oke = Pke;
var Mke = function(t, n) {
  return /* @__PURE__ */ $.createElement(mo, xt({}, t, {
    ref: n,
    icon: Oke
  }));
}, wJ = /* @__PURE__ */ $.forwardRef(Mke);
process.env.NODE_ENV !== "production" && (wJ.displayName = "CloseCircleFilled");
const BE = wJ;
var kke = { icon: { tag: "svg", attrs: { "fill-rule": "evenodd", viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M799.86 166.31c.02 0 .04.02.08.06l57.69 57.7c.04.03.05.05.06.08a.12.12 0 010 .06c0 .03-.02.05-.06.09L569.93 512l287.7 287.7c.04.04.05.06.06.09a.12.12 0 010 .07c0 .02-.02.04-.06.08l-57.7 57.69c-.03.04-.05.05-.07.06a.12.12 0 01-.07 0c-.03 0-.05-.02-.09-.06L512 569.93l-287.7 287.7c-.04.04-.06.05-.09.06a.12.12 0 01-.07 0c-.02 0-.04-.02-.08-.06l-57.69-57.7c-.04-.03-.05-.05-.06-.07a.12.12 0 010-.07c0-.03.02-.05.06-.09L454.07 512l-287.7-287.7c-.04-.04-.05-.06-.06-.09a.12.12 0 010-.07c0-.02.02-.04.06-.08l57.7-57.69c.03-.04.05-.05.07-.06a.12.12 0 01.07 0c.03 0 .05.02.09.06L512 454.07l287.7-287.7c.04-.04.06-.05.09-.06a.12.12 0 01.07 0z" } }] }, name: "close", theme: "outlined" };
const Nke = kke;
var Dke = function(t, n) {
  return /* @__PURE__ */ $.createElement(mo, xt({}, t, {
    ref: n,
    icon: Nke
  }));
}, xJ = /* @__PURE__ */ $.forwardRef(Dke);
process.env.NODE_ENV !== "production" && (xJ.displayName = "CloseOutlined");
const zE = xJ;
var jke = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] }, name: "exclamation-circle", theme: "filled" };
const Lke = jke;
var Fke = function(t, n) {
  return /* @__PURE__ */ $.createElement(mo, xt({}, t, {
    ref: n,
    icon: Lke
  }));
}, EJ = /* @__PURE__ */ $.forwardRef(Fke);
process.env.NODE_ENV !== "production" && (EJ.displayName = "ExclamationCircleFilled");
const CM = EJ;
var Vke = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] }, name: "info-circle", theme: "filled" };
const Bke = Vke;
var zke = function(t, n) {
  return /* @__PURE__ */ $.createElement(mo, xt({}, t, {
    ref: n,
    icon: Bke
  }));
}, CJ = /* @__PURE__ */ $.forwardRef(zke);
process.env.NODE_ENV !== "production" && (CJ.displayName = "InfoCircleFilled");
const TJ = CJ;
var Hke = `accept acceptCharset accessKey action allowFullScreen allowTransparency
    alt async autoComplete autoFocus autoPlay capture cellPadding cellSpacing challenge
    charSet checked classID className colSpan cols content contentEditable contextMenu
    controls coords crossOrigin data dateTime default defer dir disabled download draggable
    encType form formAction formEncType formMethod formNoValidate formTarget frameBorder
    headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity
    is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media
    mediaGroup method min minLength multiple muted name noValidate nonce open
    optimum pattern placeholder poster preload radioGroup readOnly rel required
    reversed role rowSpan rows sandbox scope scoped scrolling seamless selected
    shape size sizes span spellCheck src srcDoc srcLang srcSet start step style
    summary tabIndex target title type useMap value width wmode wrap`, Uke = `onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown
    onKeyPress onKeyUp onFocus onBlur onChange onInput onSubmit onClick onContextMenu onDoubleClick
    onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown
    onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel
    onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough
    onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata
    onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onError`, Wke = "".concat(Hke, " ").concat(Uke).split(/[\s\n]+/), qke = "aria-", Gke = "data-";
function RL(e, t) {
  return e.indexOf(t) === 0;
}
function xf(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, n;
  t === !1 ? n = {
    aria: !0,
    data: !0,
    attr: !0
  } : t === !0 ? n = {
    aria: !0
  } : n = ae({}, t);
  var r = {};
  return Object.keys(e).forEach(function(i) {
    // Aria
    (n.aria && (i === "role" || RL(i, qke)) || // Data
    n.data && RL(i, Gke) || // Attr
    n.attr && Wke.includes(i)) && (r[i] = e[i]);
  }), r;
}
function IJ(e) {
  return e && /* @__PURE__ */ j.isValidElement(e) && e.type === j.Fragment;
}
const $J = (e, t, n) => /* @__PURE__ */ j.isValidElement(e) ? /* @__PURE__ */ j.cloneElement(e, typeof n == "function" ? n(e.props || {}) : n) : t;
function Jg(e, t) {
  return $J(e, e, t);
}
const g1 = (e, t, n, r, i) => ({
  background: e,
  border: `${et(r.lineWidth)} ${r.lineType} ${t}`,
  [`${i}-icon`]: {
    color: n
  }
}), Kke = (e) => {
  const {
    componentCls: t,
    motionDurationSlow: n,
    marginXS: r,
    marginSM: i,
    fontSize: o,
    fontSizeLG: a,
    lineHeight: s,
    borderRadiusLG: c,
    motionEaseInOutCirc: l,
    withDescriptionIconSize: u,
    colorText: d,
    colorTextHeading: f,
    withDescriptionPadding: h,
    defaultPadding: p
  } = e;
  return {
    [t]: Object.assign(Object.assign({}, _a(e)), {
      position: "relative",
      display: "flex",
      alignItems: "center",
      padding: p,
      wordWrap: "break-word",
      borderRadius: c,
      [`&${t}-rtl`]: {
        direction: "rtl"
      },
      [`${t}-content`]: {
        flex: 1,
        minWidth: 0
      },
      [`${t}-icon`]: {
        marginInlineEnd: r,
        lineHeight: 0
      },
      "&-description": {
        display: "none",
        fontSize: o,
        lineHeight: s
      },
      "&-message": {
        color: f
      },
      [`&${t}-motion-leave`]: {
        overflow: "hidden",
        opacity: 1,
        transition: `max-height ${n} ${l}, opacity ${n} ${l},
        padding-top ${n} ${l}, padding-bottom ${n} ${l},
        margin-bottom ${n} ${l}`
      },
      [`&${t}-motion-leave-active`]: {
        maxHeight: 0,
        marginBottom: "0 !important",
        paddingTop: 0,
        paddingBottom: 0,
        opacity: 0
      }
    }),
    [`${t}-with-description`]: {
      alignItems: "flex-start",
      padding: h,
      [`${t}-icon`]: {
        marginInlineEnd: i,
        fontSize: u,
        lineHeight: 0
      },
      [`${t}-message`]: {
        display: "block",
        marginBottom: r,
        color: f,
        fontSize: a
      },
      [`${t}-description`]: {
        display: "block",
        color: d
      }
    },
    [`${t}-banner`]: {
      marginBottom: 0,
      border: "0 !important",
      borderRadius: 0
    }
  };
}, Yke = (e) => {
  const {
    componentCls: t,
    colorSuccess: n,
    colorSuccessBorder: r,
    colorSuccessBg: i,
    colorWarning: o,
    colorWarningBorder: a,
    colorWarningBg: s,
    colorError: c,
    colorErrorBorder: l,
    colorErrorBg: u,
    colorInfo: d,
    colorInfoBorder: f,
    colorInfoBg: h
  } = e;
  return {
    [t]: {
      "&-success": g1(i, r, n, e, t),
      "&-info": g1(h, f, d, e, t),
      "&-warning": g1(s, a, o, e, t),
      "&-error": Object.assign(Object.assign({}, g1(u, l, c, e, t)), {
        [`${t}-description > pre`]: {
          margin: 0,
          padding: 0
        }
      })
    }
  };
}, Xke = (e) => {
  const {
    componentCls: t,
    iconCls: n,
    motionDurationMid: r,
    marginXS: i,
    fontSizeIcon: o,
    colorIcon: a,
    colorIconHover: s
  } = e;
  return {
    [t]: {
      "&-action": {
        marginInlineStart: i
      },
      [`${t}-close-icon`]: {
        marginInlineStart: i,
        padding: 0,
        overflow: "hidden",
        fontSize: o,
        lineHeight: et(o),
        backgroundColor: "transparent",
        border: "none",
        outline: "none",
        cursor: "pointer",
        [`${n}-close`]: {
          color: a,
          transition: `color ${r}`,
          "&:hover": {
            color: s
          }
        }
      },
      "&-close-text": {
        color: a,
        transition: `color ${r}`,
        "&:hover": {
          color: s
        }
      }
    }
  };
}, Qke = (e) => ({
  withDescriptionIconSize: e.fontSizeHeading3,
  defaultPadding: `${e.paddingContentVerticalSM}px 12px`,
  withDescriptionPadding: `${e.paddingMD}px ${e.paddingContentHorizontalLG}px`
}), Jke = Za("Alert", (e) => [Kke(e), Yke(e), Xke(e)], Qke);
var PL = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
const Zke = {
  success: SJ,
  info: TJ,
  error: BE,
  warning: CM
}, e4e = (e) => {
  const {
    icon: t,
    prefixCls: n,
    type: r
  } = e, i = Zke[r] || null;
  return t ? $J(t, /* @__PURE__ */ $.createElement("span", {
    className: `${n}-icon`
  }, t), () => ({
    className: Ee(`${n}-icon`, {
      [t.props.className]: t.props.className
    })
  })) : /* @__PURE__ */ $.createElement(i, {
    className: `${n}-icon`
  });
}, t4e = (e) => {
  const {
    isClosable: t,
    prefixCls: n,
    closeIcon: r,
    handleClose: i,
    ariaProps: o
  } = e, a = r === !0 || r === void 0 ? /* @__PURE__ */ $.createElement(zE, null) : r;
  return t ? /* @__PURE__ */ $.createElement("button", Object.assign({
    type: "button",
    onClick: i,
    className: `${n}-close-icon`,
    tabIndex: 0
  }, o), a) : null;
}, AJ = /* @__PURE__ */ $.forwardRef((e, t) => {
  const {
    description: n,
    prefixCls: r,
    message: i,
    banner: o,
    className: a,
    rootClassName: s,
    style: c,
    onMouseEnter: l,
    onMouseLeave: u,
    onClick: d,
    afterClose: f,
    showIcon: h,
    closable: p,
    closeText: g,
    closeIcon: m,
    action: v,
    id: y
  } = e, _ = PL(e, ["description", "prefixCls", "message", "banner", "className", "rootClassName", "style", "onMouseEnter", "onMouseLeave", "onClick", "afterClose", "showIcon", "closable", "closeText", "closeIcon", "action", "id"]), [b, w] = $.useState(!1);
  process.env.NODE_ENV !== "production" && di("Alert").deprecated(!g, "closeText", "closable.closeIcon");
  const C = $.useRef(null);
  $.useImperativeHandle(t, () => ({
    nativeElement: C.current
  }));
  const {
    getPrefixCls: x,
    direction: T,
    alert: E
  } = $.useContext(Cn), R = x("alert", r), [I, O, P] = Jke(R), k = (Q) => {
    var Y;
    w(!0), (Y = e.onClose) === null || Y === void 0 || Y.call(e, Q);
  }, L = $.useMemo(() => e.type !== void 0 ? e.type : o ? "warning" : "info", [e.type, o]), N = $.useMemo(() => typeof p == "object" && p.closeIcon || g ? !0 : typeof p == "boolean" ? p : m !== !1 && m !== null && m !== void 0 ? !0 : !!(E != null && E.closable), [g, m, p, E == null ? void 0 : E.closable]), D = o && h === void 0 ? !0 : h, z = Ee(R, `${R}-${L}`, {
    [`${R}-with-description`]: !!n,
    [`${R}-no-icon`]: !D,
    [`${R}-banner`]: !!o,
    [`${R}-rtl`]: T === "rtl"
  }, E == null ? void 0 : E.className, a, s, P, O), V = xf(_, {
    aria: !0,
    data: !0
  }), B = $.useMemo(() => {
    var Q, Y;
    return typeof p == "object" && p.closeIcon ? p.closeIcon : g || (m !== void 0 ? m : typeof (E == null ? void 0 : E.closable) == "object" && (!((Q = E == null ? void 0 : E.closable) === null || Q === void 0) && Q.closeIcon) ? (Y = E == null ? void 0 : E.closable) === null || Y === void 0 ? void 0 : Y.closeIcon : E == null ? void 0 : E.closeIcon);
  }, [m, p, g, E == null ? void 0 : E.closeIcon]), U = $.useMemo(() => {
    const Q = p ?? (E == null ? void 0 : E.closable);
    return typeof Q == "object" ? PL(Q, ["closeIcon"]) : {};
  }, [p, E == null ? void 0 : E.closable]);
  return I(/* @__PURE__ */ $.createElement(Uf, {
    visible: !b,
    motionName: `${R}-motion`,
    motionAppear: !1,
    motionEnter: !1,
    onLeaveStart: (Q) => ({
      maxHeight: Q.offsetHeight
    }),
    onLeaveEnd: f
  }, (Q, Y) => {
    let {
      className: q,
      style: X
    } = Q;
    return /* @__PURE__ */ $.createElement("div", Object.assign({
      id: y,
      ref: Ja(C, Y),
      "data-show": !b,
      className: Ee(z, q),
      style: Object.assign(Object.assign(Object.assign({}, E == null ? void 0 : E.style), c), X),
      onMouseEnter: l,
      onMouseLeave: u,
      onClick: d,
      role: "alert"
    }, V), D ? /* @__PURE__ */ $.createElement(e4e, {
      description: n,
      icon: e.icon,
      prefixCls: R,
      type: L
    }) : null, /* @__PURE__ */ $.createElement("div", {
      className: `${R}-content`
    }, i ? /* @__PURE__ */ $.createElement("div", {
      className: `${R}-message`
    }, i) : null, n ? /* @__PURE__ */ $.createElement("div", {
      className: `${R}-description`
    }, n) : null), v ? /* @__PURE__ */ $.createElement("div", {
      className: `${R}-action`
    }, v) : null, /* @__PURE__ */ $.createElement(t4e, {
      isClosable: N,
      prefixCls: R,
      closeIcon: B,
      handleClose: k,
      ariaProps: U
    }));
  }));
});
process.env.NODE_ENV !== "production" && (AJ.displayName = "Alert");
const RJ = AJ;
function n4e(e, t, n) {
  return t = wf(t), FX(e, PE() ? Reflect.construct(t, n || [], wf(e).constructor) : t.apply(e, n));
}
let r4e = /* @__PURE__ */ function(e) {
  function t() {
    var n;
    return xr(this, t), n = n4e(this, t, arguments), n.state = {
      error: void 0,
      info: {
        componentStack: ""
      }
    }, n;
  }
  return Ds(t, e), Er(t, [{
    key: "componentDidCatch",
    value: function(r, i) {
      this.setState({
        error: r,
        info: i
      });
    }
  }, {
    key: "render",
    value: function() {
      const {
        message: r,
        description: i,
        id: o,
        children: a
      } = this.props, {
        error: s,
        info: c
      } = this.state, l = (c == null ? void 0 : c.componentStack) || null, u = typeof r > "u" ? (s || "").toString() : r, d = typeof i > "u" ? l : i;
      return s ? /* @__PURE__ */ $.createElement(RJ, {
        id: o,
        type: "error",
        message: u,
        description: /* @__PURE__ */ $.createElement("pre", {
          style: {
            fontSize: "0.9em",
            overflowX: "auto"
          }
        }, d)
      }) : a;
    }
  }]);
}($.Component);
const i4e = r4e, PJ = RJ;
PJ.ErrorBoundary = i4e;
const o4e = PJ, a4e = (e) => {
  const [, , , , t] = js();
  return t ? `${e}-css-var` : "";
}, Wf = a4e;
var Oe = {
  /**
   * MAC_ENTER
   */
  MAC_ENTER: 3,
  /**
   * BACKSPACE
   */
  BACKSPACE: 8,
  /**
   * TAB
   */
  TAB: 9,
  /**
   * NUMLOCK on FF/Safari Mac
   */
  NUM_CENTER: 12,
  // NUMLOCK on FF/Safari Mac
  /**
   * ENTER
   */
  ENTER: 13,
  /**
   * SHIFT
   */
  SHIFT: 16,
  /**
   * CTRL
   */
  CTRL: 17,
  /**
   * ALT
   */
  ALT: 18,
  /**
   * PAUSE
   */
  PAUSE: 19,
  /**
   * CAPS_LOCK
   */
  CAPS_LOCK: 20,
  /**
   * ESC
   */
  ESC: 27,
  /**
   * SPACE
   */
  SPACE: 32,
  /**
   * PAGE_UP
   */
  PAGE_UP: 33,
  // also NUM_NORTH_EAST
  /**
   * PAGE_DOWN
   */
  PAGE_DOWN: 34,
  // also NUM_SOUTH_EAST
  /**
   * END
   */
  END: 35,
  // also NUM_SOUTH_WEST
  /**
   * HOME
   */
  HOME: 36,
  // also NUM_NORTH_WEST
  /**
   * LEFT
   */
  LEFT: 37,
  // also NUM_WEST
  /**
   * UP
   */
  UP: 38,
  // also NUM_NORTH
  /**
   * RIGHT
   */
  RIGHT: 39,
  // also NUM_EAST
  /**
   * DOWN
   */
  DOWN: 40,
  // also NUM_SOUTH
  /**
   * PRINT_SCREEN
   */
  PRINT_SCREEN: 44,
  /**
   * INSERT
   */
  INSERT: 45,
  // also NUM_INSERT
  /**
   * DELETE
   */
  DELETE: 46,
  // also NUM_DELETE
  /**
   * ZERO
   */
  ZERO: 48,
  /**
   * ONE
   */
  ONE: 49,
  /**
   * TWO
   */
  TWO: 50,
  /**
   * THREE
   */
  THREE: 51,
  /**
   * FOUR
   */
  FOUR: 52,
  /**
   * FIVE
   */
  FIVE: 53,
  /**
   * SIX
   */
  SIX: 54,
  /**
   * SEVEN
   */
  SEVEN: 55,
  /**
   * EIGHT
   */
  EIGHT: 56,
  /**
   * NINE
   */
  NINE: 57,
  /**
   * QUESTION_MARK
   */
  QUESTION_MARK: 63,
  // needs localization
  /**
   * A
   */
  A: 65,
  /**
   * B
   */
  B: 66,
  /**
   * C
   */
  C: 67,
  /**
   * D
   */
  D: 68,
  /**
   * E
   */
  E: 69,
  /**
   * F
   */
  F: 70,
  /**
   * G
   */
  G: 71,
  /**
   * H
   */
  H: 72,
  /**
   * I
   */
  I: 73,
  /**
   * J
   */
  J: 74,
  /**
   * K
   */
  K: 75,
  /**
   * L
   */
  L: 76,
  /**
   * M
   */
  M: 77,
  /**
   * N
   */
  N: 78,
  /**
   * O
   */
  O: 79,
  /**
   * P
   */
  P: 80,
  /**
   * Q
   */
  Q: 81,
  /**
   * R
   */
  R: 82,
  /**
   * S
   */
  S: 83,
  /**
   * T
   */
  T: 84,
  /**
   * U
   */
  U: 85,
  /**
   * V
   */
  V: 86,
  /**
   * W
   */
  W: 87,
  /**
   * X
   */
  X: 88,
  /**
   * Y
   */
  Y: 89,
  /**
   * Z
   */
  Z: 90,
  /**
   * META
   */
  META: 91,
  // WIN_KEY_LEFT
  /**
   * WIN_KEY_RIGHT
   */
  WIN_KEY_RIGHT: 92,
  /**
   * CONTEXT_MENU
   */
  CONTEXT_MENU: 93,
  /**
   * NUM_ZERO
   */
  NUM_ZERO: 96,
  /**
   * NUM_ONE
   */
  NUM_ONE: 97,
  /**
   * NUM_TWO
   */
  NUM_TWO: 98,
  /**
   * NUM_THREE
   */
  NUM_THREE: 99,
  /**
   * NUM_FOUR
   */
  NUM_FOUR: 100,
  /**
   * NUM_FIVE
   */
  NUM_FIVE: 101,
  /**
   * NUM_SIX
   */
  NUM_SIX: 102,
  /**
   * NUM_SEVEN
   */
  NUM_SEVEN: 103,
  /**
   * NUM_EIGHT
   */
  NUM_EIGHT: 104,
  /**
   * NUM_NINE
   */
  NUM_NINE: 105,
  /**
   * NUM_MULTIPLY
   */
  NUM_MULTIPLY: 106,
  /**
   * NUM_PLUS
   */
  NUM_PLUS: 107,
  /**
   * NUM_MINUS
   */
  NUM_MINUS: 109,
  /**
   * NUM_PERIOD
   */
  NUM_PERIOD: 110,
  /**
   * NUM_DIVISION
   */
  NUM_DIVISION: 111,
  /**
   * F1
   */
  F1: 112,
  /**
   * F2
   */
  F2: 113,
  /**
   * F3
   */
  F3: 114,
  /**
   * F4
   */
  F4: 115,
  /**
   * F5
   */
  F5: 116,
  /**
   * F6
   */
  F6: 117,
  /**
   * F7
   */
  F7: 118,
  /**
   * F8
   */
  F8: 119,
  /**
   * F9
   */
  F9: 120,
  /**
   * F10
   */
  F10: 121,
  /**
   * F11
   */
  F11: 122,
  /**
   * F12
   */
  F12: 123,
  /**
   * NUMLOCK
   */
  NUMLOCK: 144,
  /**
   * SEMICOLON
   */
  SEMICOLON: 186,
  // needs localization
  /**
   * DASH
   */
  DASH: 189,
  // needs localization
  /**
   * EQUALS
   */
  EQUALS: 187,
  // needs localization
  /**
   * COMMA
   */
  COMMA: 188,
  // needs localization
  /**
   * PERIOD
   */
  PERIOD: 190,
  // needs localization
  /**
   * SLASH
   */
  SLASH: 191,
  // needs localization
  /**
   * APOSTROPHE
   */
  APOSTROPHE: 192,
  // needs localization
  /**
   * SINGLE_QUOTE
   */
  SINGLE_QUOTE: 222,
  // needs localization
  /**
   * OPEN_SQUARE_BRACKET
   */
  OPEN_SQUARE_BRACKET: 219,
  // needs localization
  /**
   * BACKSLASH
   */
  BACKSLASH: 220,
  // needs localization
  /**
   * CLOSE_SQUARE_BRACKET
   */
  CLOSE_SQUARE_BRACKET: 221,
  // needs localization
  /**
   * WIN_KEY
   */
  WIN_KEY: 224,
  /**
   * MAC_FF_META
   */
  MAC_FF_META: 224,
  // Firefox (Gecko) fires this for the meta key instead of 91
  /**
   * WIN_IME
   */
  WIN_IME: 229,
  // ======================== Function ========================
  /**
   * whether text and modified key is entered at the same time.
   */
  isTextModifyingKeyEvent: function(t) {
    var n = t.keyCode;
    if (t.altKey && !t.ctrlKey || t.metaKey || // Function keys don't generate text
    n >= Oe.F1 && n <= Oe.F12)
      return !1;
    switch (n) {
      case Oe.ALT:
      case Oe.CAPS_LOCK:
      case Oe.CONTEXT_MENU:
      case Oe.CTRL:
      case Oe.DOWN:
      case Oe.END:
      case Oe.ESC:
      case Oe.HOME:
      case Oe.INSERT:
      case Oe.LEFT:
      case Oe.MAC_FF_META:
      case Oe.META:
      case Oe.NUMLOCK:
      case Oe.NUM_CENTER:
      case Oe.PAGE_DOWN:
      case Oe.PAGE_UP:
      case Oe.PAUSE:
      case Oe.PRINT_SCREEN:
      case Oe.RIGHT:
      case Oe.SHIFT:
      case Oe.UP:
      case Oe.WIN_KEY:
      case Oe.WIN_KEY_RIGHT:
        return !1;
      default:
        return !0;
    }
  },
  /**
   * whether character is entered.
   */
  isCharacterKey: function(t) {
    if (t >= Oe.ZERO && t <= Oe.NINE || t >= Oe.NUM_ZERO && t <= Oe.NUM_MULTIPLY || t >= Oe.A && t <= Oe.Z || window.navigator.userAgent.indexOf("WebKit") !== -1 && t === 0)
      return !0;
    switch (t) {
      case Oe.SPACE:
      case Oe.QUESTION_MARK:
      case Oe.NUM_PLUS:
      case Oe.NUM_MINUS:
      case Oe.NUM_PERIOD:
      case Oe.NUM_DIVISION:
      case Oe.SEMICOLON:
      case Oe.DASH:
      case Oe.EQUALS:
      case Oe.COMMA:
      case Oe.PERIOD:
      case Oe.SLASH:
      case Oe.APOSTROPHE:
      case Oe.SINGLE_QUOTE:
      case Oe.OPEN_SQUARE_BRACKET:
      case Oe.BACKSLASH:
      case Oe.CLOSE_SQUARE_BRACKET:
        return !0;
      default:
        return !1;
    }
  }
}, OJ = /* @__PURE__ */ $.forwardRef(function(e, t) {
  var n = e.prefixCls, r = e.style, i = e.className, o = e.duration, a = o === void 0 ? 4.5 : o, s = e.showProgress, c = e.pauseOnHover, l = c === void 0 ? !0 : c, u = e.eventKey, d = e.content, f = e.closable, h = e.closeIcon, p = h === void 0 ? "x" : h, g = e.props, m = e.onClick, v = e.onNoticeClose, y = e.times, _ = e.hovering, b = $.useState(!1), w = he(b, 2), C = w[0], x = w[1], T = $.useState(0), E = he(T, 2), R = E[0], I = E[1], O = $.useState(0), P = he(O, 2), k = P[0], L = P[1], N = _ || C, D = a > 0 && s, z = function() {
    v(u);
  }, V = function(X) {
    (X.key === "Enter" || X.code === "Enter" || X.keyCode === Oe.ENTER) && z();
  };
  $.useEffect(function() {
    if (!N && a > 0) {
      var q = Date.now() - k, X = setTimeout(function() {
        z();
      }, a * 1e3 - k);
      return function() {
        l && clearTimeout(X), L(Date.now() - q);
      };
    }
  }, [a, N, y]), $.useEffect(function() {
    if (!N && D && (l || k === 0)) {
      var q = performance.now(), X, ne = function Z() {
        cancelAnimationFrame(X), X = requestAnimationFrame(function(J) {
          var K = J + k - q, ee = Math.min(K / (a * 1e3), 1);
          I(ee * 100), ee < 1 && Z();
        });
      };
      return ne(), function() {
        l && cancelAnimationFrame(X);
      };
    }
  }, [a, k, N, D, y]);
  var B = $.useMemo(function() {
    return It(f) === "object" && f !== null ? f : f ? {
      closeIcon: p
    } : {};
  }, [f, p]), U = xf(B, !0), Q = 100 - (!R || R < 0 ? 0 : R > 100 ? 100 : R), Y = "".concat(n, "-notice");
  return /* @__PURE__ */ $.createElement("div", xt({}, g, {
    ref: t,
    className: Ee(Y, i, oe({}, "".concat(Y, "-closable"), f)),
    style: r,
    onMouseEnter: function(X) {
      var ne;
      x(!0), g == null || (ne = g.onMouseEnter) === null || ne === void 0 || ne.call(g, X);
    },
    onMouseLeave: function(X) {
      var ne;
      x(!1), g == null || (ne = g.onMouseLeave) === null || ne === void 0 || ne.call(g, X);
    },
    onClick: m
  }), /* @__PURE__ */ $.createElement("div", {
    className: "".concat(Y, "-content")
  }, d), f && /* @__PURE__ */ $.createElement("a", xt({
    tabIndex: 0,
    className: "".concat(Y, "-close"),
    onKeyDown: V,
    "aria-label": "Close"
  }, U, {
    onClick: function(X) {
      X.preventDefault(), X.stopPropagation(), z();
    }
  }), B.closeIcon), D && /* @__PURE__ */ $.createElement("progress", {
    className: "".concat(Y, "-progress"),
    max: "100",
    value: Q
  }, Q + "%"));
}), MJ = /* @__PURE__ */ j.createContext({}), s4e = function(t) {
  var n = t.children, r = t.classNames;
  return /* @__PURE__ */ j.createElement(MJ.Provider, {
    value: {
      classNames: r
    }
  }, n);
}, OL = 8, ML = 3, kL = 16, c4e = function(t) {
  var n = {
    offset: OL,
    threshold: ML,
    gap: kL
  };
  if (t && It(t) === "object") {
    var r, i, o;
    n.offset = (r = t.offset) !== null && r !== void 0 ? r : OL, n.threshold = (i = t.threshold) !== null && i !== void 0 ? i : ML, n.gap = (o = t.gap) !== null && o !== void 0 ? o : kL;
  }
  return [!!t, n];
}, l4e = ["className", "style", "classNames", "styles"], kJ = function(t) {
  var n = t.configList, r = t.placement, i = t.prefixCls, o = t.className, a = t.style, s = t.motion, c = t.onAllNoticeRemoved, l = t.onNoticeClose, u = t.stack, d = gt(MJ), f = d.classNames, h = $e({}), p = Qe(null), g = he(p, 2), m = g[0], v = g[1], y = Qe([]), _ = he(y, 2), b = _[0], w = _[1], C = n.map(function(N) {
    return {
      config: N,
      key: String(N.key)
    };
  }), x = c4e(u), T = he(x, 2), E = T[0], R = T[1], I = R.offset, O = R.threshold, P = R.gap, k = E && (b.length > 0 || C.length <= O), L = typeof s == "function" ? s(r) : s;
  return ot(function() {
    E && b.length > 1 && w(function(N) {
      return N.filter(function(D) {
        return C.some(function(z) {
          var V = z.key;
          return D === V;
        });
      });
    });
  }, [b, C, E]), ot(function() {
    var N;
    if (E && h.current[(N = C[C.length - 1]) === null || N === void 0 ? void 0 : N.key]) {
      var D;
      v(h.current[(D = C[C.length - 1]) === null || D === void 0 ? void 0 : D.key]);
    }
  }, [C, E]), /* @__PURE__ */ j.createElement(uJ, xt({
    key: r,
    className: Ee(i, "".concat(i, "-").concat(r), f == null ? void 0 : f.list, o, oe(oe({}, "".concat(i, "-stack"), !!E), "".concat(i, "-stack-expanded"), k)),
    style: a,
    keys: C,
    motionAppear: !0
  }, L, {
    onAllRemoved: function() {
      c(r);
    }
  }), function(N, D) {
    var z = N.config, V = N.className, B = N.style, U = N.index, Q = z, Y = Q.key, q = Q.times, X = String(Y), ne = z, Z = ne.className, J = ne.style, K = ne.classNames, ee = ne.styles, te = En(ne, l4e), H = C.findIndex(function(be) {
      return be.key === X;
    }), ie = {};
    if (E) {
      var W = C.length - 1 - (H > -1 ? H : U - 1), se = r === "top" || r === "bottom" ? "-50%" : "0";
      if (W > 0) {
        var le, ge, me;
        ie.height = k ? (le = h.current[X]) === null || le === void 0 ? void 0 : le.offsetHeight : m == null ? void 0 : m.offsetHeight;
        for (var pe = 0, Te = 0; Te < W; Te++) {
          var de;
          pe += ((de = h.current[C[C.length - 1 - Te].key]) === null || de === void 0 ? void 0 : de.offsetHeight) + P;
        }
        var Ae = (k ? pe : W * I) * (r.startsWith("top") ? 1 : -1), ue = !k && m !== null && m !== void 0 && m.offsetWidth && (ge = h.current[X]) !== null && ge !== void 0 && ge.offsetWidth ? ((m == null ? void 0 : m.offsetWidth) - I * 2 * (W < 3 ? W : 3)) / ((me = h.current[X]) === null || me === void 0 ? void 0 : me.offsetWidth) : 1;
        ie.transform = "translate3d(".concat(se, ", ").concat(Ae, "px, 0) scaleX(").concat(ue, ")");
      } else
        ie.transform = "translate3d(".concat(se, ", 0, 0)");
    }
    return /* @__PURE__ */ j.createElement("div", {
      ref: D,
      className: Ee("".concat(i, "-notice-wrapper"), V, K == null ? void 0 : K.wrapper),
      style: ae(ae(ae({}, B), ie), ee == null ? void 0 : ee.wrapper),
      onMouseEnter: function() {
        return w(function(Ie) {
          return Ie.includes(X) ? Ie : [].concat(tt(Ie), [X]);
        });
      },
      onMouseLeave: function() {
        return w(function(Ie) {
          return Ie.filter(function(Ve) {
            return Ve !== X;
          });
        });
      }
    }, /* @__PURE__ */ j.createElement(OJ, xt({}, te, {
      ref: function(Ie) {
        H > -1 ? h.current[X] = Ie : delete h.current[X];
      },
      prefixCls: i,
      classNames: K,
      styles: ee,
      className: Ee(Z, f == null ? void 0 : f.notice),
      style: J,
      times: q,
      key: Y,
      eventKey: Y,
      onNoticeClose: l,
      hovering: E && b.length > 0
    })));
  });
};
process.env.NODE_ENV !== "production" && (kJ.displayName = "NoticeList");
var NJ = /* @__PURE__ */ $.forwardRef(function(e, t) {
  var n = e.prefixCls, r = n === void 0 ? "rc-notification" : n, i = e.container, o = e.motion, a = e.maxCount, s = e.className, c = e.style, l = e.onAllRemoved, u = e.stack, d = e.renderNotifications, f = $.useState([]), h = he(f, 2), p = h[0], g = h[1], m = function(E) {
    var R, I = p.find(function(O) {
      return O.key === E;
    });
    I == null || (R = I.onClose) === null || R === void 0 || R.call(I), g(function(O) {
      return O.filter(function(P) {
        return P.key !== E;
      });
    });
  };
  $.useImperativeHandle(t, function() {
    return {
      open: function(E) {
        g(function(R) {
          var I = tt(R), O = I.findIndex(function(L) {
            return L.key === E.key;
          }), P = ae({}, E);
          if (O >= 0) {
            var k;
            P.times = (((k = R[O]) === null || k === void 0 ? void 0 : k.times) || 0) + 1, I[O] = P;
          } else
            P.times = 0, I.push(P);
          return a > 0 && I.length > a && (I = I.slice(-a)), I;
        });
      },
      close: function(E) {
        m(E);
      },
      destroy: function() {
        g([]);
      }
    };
  });
  var v = $.useState({}), y = he(v, 2), _ = y[0], b = y[1];
  $.useEffect(function() {
    var T = {};
    p.forEach(function(E) {
      var R = E.placement, I = R === void 0 ? "topRight" : R;
      I && (T[I] = T[I] || [], T[I].push(E));
    }), Object.keys(_).forEach(function(E) {
      T[E] = T[E] || [];
    }), b(T);
  }, [p]);
  var w = function(E) {
    b(function(R) {
      var I = ae({}, R), O = I[E] || [];
      return O.length || delete I[E], I;
    });
  }, C = $.useRef(!1);
  if ($.useEffect(function() {
    Object.keys(_).length > 0 ? C.current = !0 : C.current && (l == null || l(), C.current = !1);
  }, [_]), !i)
    return null;
  var x = Object.keys(_);
  return /* @__PURE__ */ rO(/* @__PURE__ */ $.createElement($.Fragment, null, x.map(function(T) {
    var E = _[T], R = /* @__PURE__ */ $.createElement(kJ, {
      key: T,
      configList: E,
      placement: T,
      prefixCls: r,
      className: s == null ? void 0 : s(T),
      style: c == null ? void 0 : c(T),
      motion: o,
      onNoticeClose: m,
      onAllNoticeRemoved: w,
      stack: u
    });
    return d ? d(R, {
      prefixCls: r,
      key: T
    }) : R;
  })), i);
});
process.env.NODE_ENV !== "production" && (NJ.displayName = "Notifications");
var u4e = ["getContainer", "motion", "prefixCls", "maxCount", "className", "style", "onAllRemoved", "stack", "renderNotifications"], d4e = function() {
  return document.body;
}, NL = 0;
function f4e() {
  for (var e = {}, t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  return n.forEach(function(i) {
    i && Object.keys(i).forEach(function(o) {
      var a = i[o];
      a !== void 0 && (e[o] = a);
    });
  }), e;
}
function h4e() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = e.getContainer, n = t === void 0 ? d4e : t, r = e.motion, i = e.prefixCls, o = e.maxCount, a = e.className, s = e.style, c = e.onAllRemoved, l = e.stack, u = e.renderNotifications, d = En(e, u4e), f = $.useState(), h = he(f, 2), p = h[0], g = h[1], m = $.useRef(), v = /* @__PURE__ */ $.createElement(NJ, {
    container: p,
    ref: m,
    prefixCls: i,
    motion: r,
    maxCount: o,
    className: a,
    style: s,
    onAllRemoved: c,
    stack: l,
    renderNotifications: u
  }), y = $.useState([]), _ = he(y, 2), b = _[0], w = _[1], C = $.useMemo(function() {
    return {
      open: function(T) {
        var E = f4e(d, T);
        (E.key === null || E.key === void 0) && (E.key = "rc-notification-".concat(NL), NL += 1), w(function(R) {
          return [].concat(tt(R), [{
            type: "open",
            config: E
          }]);
        });
      },
      close: function(T) {
        w(function(E) {
          return [].concat(tt(E), [{
            type: "close",
            key: T
          }]);
        });
      },
      destroy: function() {
        w(function(T) {
          return [].concat(tt(T), [{
            type: "destroy"
          }]);
        });
      }
    };
  }, []);
  return $.useEffect(function() {
    g(n());
  }), $.useEffect(function() {
    m.current && b.length && (b.forEach(function(x) {
      switch (x.type) {
        case "open":
          m.current.open(x.config);
          break;
        case "close":
          m.current.close(x.key);
          break;
        case "destroy":
          m.current.destroy();
          break;
      }
    }), w(function(x) {
      return x.filter(function(T) {
        return !b.includes(T);
      });
    }));
  }, [b]), [C, v];
}
var g4e = { icon: { tag: "svg", attrs: { viewBox: "0 0 1024 1024", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z" } }] }, name: "loading", theme: "outlined" };
const p4e = g4e;
var m4e = function(t, n) {
  return /* @__PURE__ */ $.createElement(mo, xt({}, t, {
    ref: n,
    icon: p4e
  }));
}, DJ = /* @__PURE__ */ $.forwardRef(m4e);
process.env.NODE_ENV !== "production" && (DJ.displayName = "LoadingOutlined");
const TM = DJ, jJ = /* @__PURE__ */ j.createContext(void 0);
process.env.NODE_ENV !== "production" && (jJ.displayName = "zIndexContext");
const LJ = jJ, Wc = 100, v4e = 10, FJ = Wc * v4e, y4e = FJ + Wc, VJ = {
  Modal: Wc,
  Drawer: Wc,
  Popover: Wc,
  Popconfirm: Wc,
  Tooltip: Wc,
  Tour: Wc,
  FloatButton: Wc
}, b4e = {
  SelectLike: 50,
  Dropdown: 50,
  DatePicker: 50,
  Menu: 50,
  ImagePreview: 1
};
function _4e(e) {
  return e in VJ;
}
const BJ = (e, t) => {
  const [, n] = js(), r = j.useContext(LJ), i = _4e(e);
  let o;
  if (t !== void 0)
    o = [t, t];
  else {
    let a = r ?? 0;
    i ? a += // Use preset token zIndex by default but not stack when has parent container
    (r ? 0 : n.zIndexPopupBase) + // Container offset
    VJ[e] : a += b4e[e], o = [r === void 0 ? t : a, a];
  }
  if (process.env.NODE_ENV !== "production") {
    const a = di(e), s = n.zIndexPopupBase + y4e, c = o[0] || 0;
    process.env.NODE_ENV !== "production" && a(t !== void 0 || c <= s, "usage", "`zIndex` is over design token `zIndexPopupBase` too much. It may cause unexpected override.");
  }
  return o;
}, S4e = (e) => {
  const {
    componentCls: t,
    iconCls: n,
    boxShadow: r,
    colorText: i,
    colorSuccess: o,
    colorError: a,
    colorWarning: s,
    colorInfo: c,
    fontSizeLG: l,
    motionEaseInOutCirc: u,
    motionDurationSlow: d,
    marginXS: f,
    paddingXS: h,
    borderRadiusLG: p,
    zIndexPopup: g,
    // Custom token
    contentPadding: m,
    contentBg: v
  } = e, y = `${t}-notice`, _ = new Pn("MessageMoveIn", {
    "0%": {
      padding: 0,
      transform: "translateY(-100%)",
      opacity: 0
    },
    "100%": {
      padding: h,
      transform: "translateY(0)",
      opacity: 1
    }
  }), b = new Pn("MessageMoveOut", {
    "0%": {
      maxHeight: e.height,
      padding: h,
      opacity: 1
    },
    "100%": {
      maxHeight: 0,
      padding: 0,
      opacity: 0
    }
  }), w = {
    padding: h,
    textAlign: "center",
    [`${t}-custom-content`]: {
      display: "flex",
      alignItems: "center"
    },
    [`${t}-custom-content > ${n}`]: {
      marginInlineEnd: f,
      // affected by ltr or rtl
      fontSize: l
    },
    [`${y}-content`]: {
      display: "inline-block",
      padding: m,
      background: v,
      borderRadius: p,
      boxShadow: r,
      pointerEvents: "all"
    },
    [`${t}-success > ${n}`]: {
      color: o
    },
    [`${t}-error > ${n}`]: {
      color: a
    },
    [`${t}-warning > ${n}`]: {
      color: s
    },
    [`${t}-info > ${n},
      ${t}-loading > ${n}`]: {
      color: c
    }
  };
  return [
    // ============================ Holder ============================
    {
      [t]: Object.assign(Object.assign({}, _a(e)), {
        color: i,
        position: "fixed",
        top: f,
        width: "100%",
        pointerEvents: "none",
        zIndex: g,
        [`${t}-move-up`]: {
          animationFillMode: "forwards"
        },
        [`
        ${t}-move-up-appear,
        ${t}-move-up-enter
      `]: {
          animationName: _,
          animationDuration: d,
          animationPlayState: "paused",
          animationTimingFunction: u
        },
        [`
        ${t}-move-up-appear${t}-move-up-appear-active,
        ${t}-move-up-enter${t}-move-up-enter-active
      `]: {
          animationPlayState: "running"
        },
        [`${t}-move-up-leave`]: {
          animationName: b,
          animationDuration: d,
          animationPlayState: "paused",
          animationTimingFunction: u
        },
        [`${t}-move-up-leave${t}-move-up-leave-active`]: {
          animationPlayState: "running"
        },
        "&-rtl": {
          direction: "rtl",
          span: {
            direction: "rtl"
          }
        }
      })
    },
    // ============================ Notice ============================
    {
      [t]: {
        [`${y}-wrapper`]: Object.assign({}, w)
      }
    },
    // ============================= Pure =============================
    {
      [`${t}-notice-pure-panel`]: Object.assign(Object.assign({}, w), {
        padding: 0,
        textAlign: "start"
      })
    }
  ];
}, w4e = (e) => ({
  zIndexPopup: e.zIndexPopupBase + FJ + 10,
  contentBg: e.colorBgElevated,
  contentPadding: `${(e.controlHeightLG - e.fontSize * e.lineHeight) / 2}px ${e.paddingSM}px`
}), zJ = Za("Message", (e) => {
  const t = Mr(e, {
    height: 150
  });
  return [S4e(t)];
}, w4e);
var x4e = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
const E4e = {
  info: /* @__PURE__ */ $.createElement(TJ, null),
  success: /* @__PURE__ */ $.createElement(SJ, null),
  error: /* @__PURE__ */ $.createElement(BE, null),
  warning: /* @__PURE__ */ $.createElement(CM, null),
  loading: /* @__PURE__ */ $.createElement(TM, null)
}, HJ = (e) => {
  let {
    prefixCls: t,
    type: n,
    icon: r,
    children: i
  } = e;
  return /* @__PURE__ */ $.createElement("div", {
    className: Ee(`${t}-custom-content`, `${t}-${n}`)
  }, r || E4e[n], /* @__PURE__ */ $.createElement("span", null, i));
}, C4e = (e) => {
  const {
    prefixCls: t,
    className: n,
    type: r,
    icon: i,
    content: o
  } = e, a = x4e(e, ["prefixCls", "className", "type", "icon", "content"]), {
    getPrefixCls: s
  } = $.useContext(Cn), c = t || s("message"), l = Wf(c), [u, d, f] = zJ(c, l);
  return u(/* @__PURE__ */ $.createElement(OJ, Object.assign({}, a, {
    prefixCls: c,
    className: Ee(n, d, `${c}-notice-pure-panel`, f, l),
    eventKey: "pure",
    duration: null,
    content: /* @__PURE__ */ $.createElement(HJ, {
      prefixCls: c,
      type: r,
      icon: i
    }, o)
  })));
}, T4e = C4e;
function I4e(e, t) {
  return {
    motionName: t ?? `${e}-move-up`
  };
}
function IM(e) {
  let t;
  const n = new Promise((i) => {
    t = e(() => {
      i(!0);
    });
  }), r = () => {
    t == null || t();
  };
  return r.then = (i, o) => n.then(i, o), r.promise = n, r;
}
var $4e = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
const A4e = 8, R4e = 3, P4e = (e) => {
  let {
    children: t,
    prefixCls: n
  } = e;
  const r = Wf(n), [i, o, a] = zJ(n, r);
  return i(/* @__PURE__ */ $.createElement(s4e, {
    classNames: {
      list: Ee(o, a, r)
    }
  }, t));
}, O4e = (e, t) => {
  let {
    prefixCls: n,
    key: r
  } = t;
  return /* @__PURE__ */ $.createElement(P4e, {
    prefixCls: n,
    key: r
  }, e);
}, M4e = /* @__PURE__ */ $.forwardRef((e, t) => {
  const {
    top: n,
    prefixCls: r,
    getContainer: i,
    maxCount: o,
    duration: a = R4e,
    rtl: s,
    transitionName: c,
    onAllRemoved: l
  } = e, {
    getPrefixCls: u,
    getPopupContainer: d,
    message: f,
    direction: h
  } = $.useContext(Cn), p = r || u("message"), g = () => ({
    left: "50%",
    transform: "translateX(-50%)",
    top: n ?? A4e
  }), m = () => Ee({
    [`${p}-rtl`]: s ?? h === "rtl"
  }), v = () => I4e(p, c), y = /* @__PURE__ */ $.createElement("span", {
    className: `${p}-close-x`
  }, /* @__PURE__ */ $.createElement(zE, {
    className: `${p}-close-icon`
  })), [_, b] = h4e({
    prefixCls: p,
    style: g,
    className: m,
    motion: v,
    closable: !1,
    closeIcon: y,
    duration: a,
    getContainer: () => (i == null ? void 0 : i()) || (d == null ? void 0 : d()) || document.body,
    maxCount: o,
    onAllRemoved: l,
    renderNotifications: O4e
  });
  return $.useImperativeHandle(t, () => Object.assign(Object.assign({}, _), {
    prefixCls: p,
    message: f
  })), b;
});
let DL = 0;
function UJ(e) {
  const t = $.useRef(null), n = di("Message");
  return [$.useMemo(() => {
    const i = (l) => {
      var u;
      (u = t.current) === null || u === void 0 || u.close(l);
    }, o = (l) => {
      if (!t.current) {
        process.env.NODE_ENV !== "production" && n(!1, "usage", "You are calling notice in render which will break in React 18 concurrent mode. Please trigger in effect instead.");
        const x = () => {
        };
        return x.then = () => {
        }, x;
      }
      const {
        open: u,
        prefixCls: d,
        message: f
      } = t.current, h = `${d}-notice`, {
        content: p,
        icon: g,
        type: m,
        key: v,
        className: y,
        style: _,
        onClose: b
      } = l, w = $4e(l, ["content", "icon", "type", "key", "className", "style", "onClose"]);
      let C = v;
      return C == null && (DL += 1, C = `antd-message-${DL}`), IM((x) => (u(Object.assign(Object.assign({}, w), {
        key: C,
        content: /* @__PURE__ */ $.createElement(HJ, {
          prefixCls: d,
          type: m,
          icon: g
        }, p),
        placement: "top",
        className: Ee(m && `${h}-${m}`, y, f == null ? void 0 : f.className),
        style: Object.assign(Object.assign({}, f == null ? void 0 : f.style), _),
        onClose: () => {
          b == null || b(), x();
        }
      })), () => {
        i(C);
      }));
    }, s = {
      open: o,
      destroy: (l) => {
        var u;
        l !== void 0 ? i(l) : (u = t.current) === null || u === void 0 || u.destroy();
      }
    };
    return ["info", "success", "warning", "error", "loading"].forEach((l) => {
      const u = (d, f, h) => {
        let p;
        d && typeof d == "object" && "content" in d ? p = d : p = {
          content: d
        };
        let g, m;
        typeof f == "function" ? m = f : (g = f, m = h);
        const v = Object.assign(Object.assign({
          onClose: m,
          duration: g
        }, p), {
          type: l
        });
        return o(v);
      };
      s[l] = u;
    }), s;
  }, []), /* @__PURE__ */ $.createElement(M4e, Object.assign({
    key: "message-holder"
  }, e, {
    ref: t
  }))];
}
function k4e(e) {
  return UJ(e);
}
function ko() {
  ko = function() {
    return t;
  };
  var e, t = {}, n = Object.prototype, r = n.hasOwnProperty, i = Object.defineProperty || function(N, D, z) {
    N[D] = z.value;
  }, o = typeof Symbol == "function" ? Symbol : {}, a = o.iterator || "@@iterator", s = o.asyncIterator || "@@asyncIterator", c = o.toStringTag || "@@toStringTag";
  function l(N, D, z) {
    return Object.defineProperty(N, D, {
      value: z,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), N[D];
  }
  try {
    l({}, "");
  } catch {
    l = function(z, V, B) {
      return z[V] = B;
    };
  }
  function u(N, D, z, V) {
    var B = D && D.prototype instanceof v ? D : v, U = Object.create(B.prototype), Q = new k(V || []);
    return i(U, "_invoke", {
      value: R(N, z, Q)
    }), U;
  }
  function d(N, D, z) {
    try {
      return {
        type: "normal",
        arg: N.call(D, z)
      };
    } catch (V) {
      return {
        type: "throw",
        arg: V
      };
    }
  }
  t.wrap = u;
  var f = "suspendedStart", h = "suspendedYield", p = "executing", g = "completed", m = {};
  function v() {
  }
  function y() {
  }
  function _() {
  }
  var b = {};
  l(b, a, function() {
    return this;
  });
  var w = Object.getPrototypeOf, C = w && w(w(L([])));
  C && C !== n && r.call(C, a) && (b = C);
  var x = _.prototype = v.prototype = Object.create(b);
  function T(N) {
    ["next", "throw", "return"].forEach(function(D) {
      l(N, D, function(z) {
        return this._invoke(D, z);
      });
    });
  }
  function E(N, D) {
    function z(B, U, Q, Y) {
      var q = d(N[B], N, U);
      if (q.type !== "throw") {
        var X = q.arg, ne = X.value;
        return ne && It(ne) == "object" && r.call(ne, "__await") ? D.resolve(ne.__await).then(function(Z) {
          z("next", Z, Q, Y);
        }, function(Z) {
          z("throw", Z, Q, Y);
        }) : D.resolve(ne).then(function(Z) {
          X.value = Z, Q(X);
        }, function(Z) {
          return z("throw", Z, Q, Y);
        });
      }
      Y(q.arg);
    }
    var V;
    i(this, "_invoke", {
      value: function(U, Q) {
        function Y() {
          return new D(function(q, X) {
            z(U, Q, q, X);
          });
        }
        return V = V ? V.then(Y, Y) : Y();
      }
    });
  }
  function R(N, D, z) {
    var V = f;
    return function(B, U) {
      if (V === p)
        throw Error("Generator is already running");
      if (V === g) {
        if (B === "throw")
          throw U;
        return {
          value: e,
          done: !0
        };
      }
      for (z.method = B, z.arg = U; ; ) {
        var Q = z.delegate;
        if (Q) {
          var Y = I(Q, z);
          if (Y) {
            if (Y === m)
              continue;
            return Y;
          }
        }
        if (z.method === "next")
          z.sent = z._sent = z.arg;
        else if (z.method === "throw") {
          if (V === f)
            throw V = g, z.arg;
          z.dispatchException(z.arg);
        } else
          z.method === "return" && z.abrupt("return", z.arg);
        V = p;
        var q = d(N, D, z);
        if (q.type === "normal") {
          if (V = z.done ? g : h, q.arg === m)
            continue;
          return {
            value: q.arg,
            done: z.done
          };
        }
        q.type === "throw" && (V = g, z.method = "throw", z.arg = q.arg);
      }
    };
  }
  function I(N, D) {
    var z = D.method, V = N.iterator[z];
    if (V === e)
      return D.delegate = null, z === "throw" && N.iterator.return && (D.method = "return", D.arg = e, I(N, D), D.method === "throw") || z !== "return" && (D.method = "throw", D.arg = new TypeError("The iterator does not provide a '" + z + "' method")), m;
    var B = d(V, N.iterator, D.arg);
    if (B.type === "throw")
      return D.method = "throw", D.arg = B.arg, D.delegate = null, m;
    var U = B.arg;
    return U ? U.done ? (D[N.resultName] = U.value, D.next = N.nextLoc, D.method !== "return" && (D.method = "next", D.arg = e), D.delegate = null, m) : U : (D.method = "throw", D.arg = new TypeError("iterator result is not an object"), D.delegate = null, m);
  }
  function O(N) {
    var D = {
      tryLoc: N[0]
    };
    1 in N && (D.catchLoc = N[1]), 2 in N && (D.finallyLoc = N[2], D.afterLoc = N[3]), this.tryEntries.push(D);
  }
  function P(N) {
    var D = N.completion || {};
    D.type = "normal", delete D.arg, N.completion = D;
  }
  function k(N) {
    this.tryEntries = [{
      tryLoc: "root"
    }], N.forEach(O, this), this.reset(!0);
  }
  function L(N) {
    if (N || N === "") {
      var D = N[a];
      if (D)
        return D.call(N);
      if (typeof N.next == "function")
        return N;
      if (!isNaN(N.length)) {
        var z = -1, V = function B() {
          for (; ++z < N.length; )
            if (r.call(N, z))
              return B.value = N[z], B.done = !1, B;
          return B.value = e, B.done = !0, B;
        };
        return V.next = V;
      }
    }
    throw new TypeError(It(N) + " is not iterable");
  }
  return y.prototype = _, i(x, "constructor", {
    value: _,
    configurable: !0
  }), i(_, "constructor", {
    value: y,
    configurable: !0
  }), y.displayName = l(_, c, "GeneratorFunction"), t.isGeneratorFunction = function(N) {
    var D = typeof N == "function" && N.constructor;
    return !!D && (D === y || (D.displayName || D.name) === "GeneratorFunction");
  }, t.mark = function(N) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(N, _) : (N.__proto__ = _, l(N, c, "GeneratorFunction")), N.prototype = Object.create(x), N;
  }, t.awrap = function(N) {
    return {
      __await: N
    };
  }, T(E.prototype), l(E.prototype, s, function() {
    return this;
  }), t.AsyncIterator = E, t.async = function(N, D, z, V, B) {
    B === void 0 && (B = Promise);
    var U = new E(u(N, D, z, V), B);
    return t.isGeneratorFunction(D) ? U : U.next().then(function(Q) {
      return Q.done ? Q.value : U.next();
    });
  }, T(x), l(x, c, "Generator"), l(x, a, function() {
    return this;
  }), l(x, "toString", function() {
    return "[object Generator]";
  }), t.keys = function(N) {
    var D = Object(N), z = [];
    for (var V in D)
      z.push(V);
    return z.reverse(), function B() {
      for (; z.length; ) {
        var U = z.pop();
        if (U in D)
          return B.value = U, B.done = !1, B;
      }
      return B.done = !0, B;
    };
  }, t.values = L, k.prototype = {
    constructor: k,
    reset: function(D) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = e, this.done = !1, this.delegate = null, this.method = "next", this.arg = e, this.tryEntries.forEach(P), !D)
        for (var z in this)
          z.charAt(0) === "t" && r.call(this, z) && !isNaN(+z.slice(1)) && (this[z] = e);
    },
    stop: function() {
      this.done = !0;
      var D = this.tryEntries[0].completion;
      if (D.type === "throw")
        throw D.arg;
      return this.rval;
    },
    dispatchException: function(D) {
      if (this.done)
        throw D;
      var z = this;
      function V(X, ne) {
        return Q.type = "throw", Q.arg = D, z.next = X, ne && (z.method = "next", z.arg = e), !!ne;
      }
      for (var B = this.tryEntries.length - 1; B >= 0; --B) {
        var U = this.tryEntries[B], Q = U.completion;
        if (U.tryLoc === "root")
          return V("end");
        if (U.tryLoc <= this.prev) {
          var Y = r.call(U, "catchLoc"), q = r.call(U, "finallyLoc");
          if (Y && q) {
            if (this.prev < U.catchLoc)
              return V(U.catchLoc, !0);
            if (this.prev < U.finallyLoc)
              return V(U.finallyLoc);
          } else if (Y) {
            if (this.prev < U.catchLoc)
              return V(U.catchLoc, !0);
          } else {
            if (!q)
              throw Error("try statement without catch or finally");
            if (this.prev < U.finallyLoc)
              return V(U.finallyLoc);
          }
        }
      }
    },
    abrupt: function(D, z) {
      for (var V = this.tryEntries.length - 1; V >= 0; --V) {
        var B = this.tryEntries[V];
        if (B.tryLoc <= this.prev && r.call(B, "finallyLoc") && this.prev < B.finallyLoc) {
          var U = B;
          break;
        }
      }
      U && (D === "break" || D === "continue") && U.tryLoc <= z && z <= U.finallyLoc && (U = null);
      var Q = U ? U.completion : {};
      return Q.type = D, Q.arg = z, U ? (this.method = "next", this.next = U.finallyLoc, m) : this.complete(Q);
    },
    complete: function(D, z) {
      if (D.type === "throw")
        throw D.arg;
      return D.type === "break" || D.type === "continue" ? this.next = D.arg : D.type === "return" ? (this.rval = this.arg = D.arg, this.method = "return", this.next = "end") : D.type === "normal" && z && (this.next = z), m;
    },
    finish: function(D) {
      for (var z = this.tryEntries.length - 1; z >= 0; --z) {
        var V = this.tryEntries[z];
        if (V.finallyLoc === D)
          return this.complete(V.completion, V.afterLoc), P(V), m;
      }
    },
    catch: function(D) {
      for (var z = this.tryEntries.length - 1; z >= 0; --z) {
        var V = this.tryEntries[z];
        if (V.tryLoc === D) {
          var B = V.completion;
          if (B.type === "throw") {
            var U = B.arg;
            P(V);
          }
          return U;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function(D, z, V) {
      return this.delegate = {
        iterator: L(D),
        resultName: z,
        nextLoc: V
      }, this.method === "next" && (this.arg = e), m;
    }
  }, t;
}
function jL(e, t, n, r, i, o, a) {
  try {
    var s = e[o](a), c = s.value;
  } catch (l) {
    return void n(l);
  }
  s.done ? t(c) : Promise.resolve(c).then(r, i);
}
function qf(e) {
  return function() {
    var t = this, n = arguments;
    return new Promise(function(r, i) {
      var o = e.apply(t, n);
      function a(c) {
        jL(o, r, i, a, s, "next", c);
      }
      function s(c) {
        jL(o, r, i, a, s, "throw", c);
      }
      a(void 0);
    });
  };
}
var Ay = ae({}, kle), N4e = Ay.version, D4e = Ay.render, j4e = Ay.unmountComponentAtNode, HE;
try {
  var L4e = Number((N4e || "").split(".")[0]);
  L4e >= 18 && (HE = Ay.createRoot);
} catch {
}
function LL(e) {
  var t = Ay.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
  t && It(t) === "object" && (t.usingClientEntryPoint = e);
}
var uw = "__rc_react_root__";
function F4e(e, t) {
  LL(!0);
  var n = t[uw] || HE(t);
  LL(!1), n.render(e), t[uw] = n;
}
function V4e(e, t) {
  D4e(e, t);
}
function WJ(e, t) {
  if (HE) {
    F4e(e, t);
    return;
  }
  V4e(e, t);
}
function B4e(e) {
  return oR.apply(this, arguments);
}
function oR() {
  return oR = qf(/* @__PURE__ */ ko().mark(function e(t) {
    return ko().wrap(function(r) {
      for (; ; )
        switch (r.prev = r.next) {
          case 0:
            return r.abrupt("return", Promise.resolve().then(function() {
              var i;
              (i = t[uw]) === null || i === void 0 || i.unmount(), delete t[uw];
            }));
          case 1:
          case "end":
            return r.stop();
        }
    }, e);
  })), oR.apply(this, arguments);
}
function z4e(e) {
  j4e(e);
}
function H4e(e) {
  return aR.apply(this, arguments);
}
function aR() {
  return aR = qf(/* @__PURE__ */ ko().mark(function e(t) {
    return ko().wrap(function(r) {
      for (; ; )
        switch (r.prev = r.next) {
          case 0:
            if (HE === void 0) {
              r.next = 2;
              break;
            }
            return r.abrupt("return", B4e(t));
          case 2:
            z4e(t);
          case 3:
          case "end":
            return r.stop();
        }
    }, e);
  })), aR.apply(this, arguments);
}
const qJ = (e, t, n) => n !== void 0 ? n : `${e}-${t}`, GJ = function(e) {
  if (!e)
    return !1;
  if (e instanceof Element) {
    if (e.offsetParent)
      return !0;
    if (e.getBBox) {
      var t = e.getBBox(), n = t.width, r = t.height;
      if (n || r)
        return !0;
    }
    if (e.getBoundingClientRect) {
      var i = e.getBoundingClientRect(), o = i.width, a = i.height;
      if (o || a)
        return !0;
    }
  }
  return !1;
}, U4e = (e) => {
  const {
    componentCls: t,
    colorPrimary: n
  } = e;
  return {
    [t]: {
      position: "absolute",
      background: "transparent",
      pointerEvents: "none",
      boxSizing: "border-box",
      color: `var(--wave-color, ${n})`,
      boxShadow: "0 0 0 0 currentcolor",
      opacity: 0.2,
      // =================== Motion ===================
      "&.wave-motion-appear": {
        transition: [`box-shadow 0.4s ${e.motionEaseOutCirc}`, `opacity 2s ${e.motionEaseOutCirc}`].join(","),
        "&-active": {
          boxShadow: "0 0 0 6px currentcolor",
          opacity: 0
        },
        "&.wave-quick": {
          transition: [`box-shadow ${e.motionDurationSlow} ${e.motionEaseInOut}`, `opacity ${e.motionDurationSlow} ${e.motionEaseInOut}`].join(",")
        }
      }
    }
  };
}, W4e = k3e("Wave", (e) => [U4e(e)]), KJ = `${aw}-wave-target`;
function bT(e) {
  return e && e !== "#fff" && e !== "#ffffff" && e !== "rgb(255, 255, 255)" && e !== "rgba(255, 255, 255, 1)" && !/rgba\((?:\d*, ){3}0\)/.test(e) && // any transparent rgba color
  e !== "transparent";
}
function q4e(e) {
  const {
    borderTopColor: t,
    borderColor: n,
    backgroundColor: r
  } = getComputedStyle(e);
  return bT(t) ? t : bT(n) ? n : bT(r) ? r : null;
}
function _T(e) {
  return Number.isNaN(e) ? 0 : e;
}
const G4e = (e) => {
  const {
    className: t,
    target: n,
    component: r
  } = e, i = $.useRef(null), [o, a] = $.useState(null), [s, c] = $.useState([]), [l, u] = $.useState(0), [d, f] = $.useState(0), [h, p] = $.useState(0), [g, m] = $.useState(0), [v, y] = $.useState(!1), _ = {
    left: l,
    top: d,
    width: h,
    height: g,
    borderRadius: s.map((C) => `${C}px`).join(" ")
  };
  o && (_["--wave-color"] = o);
  function b() {
    const C = getComputedStyle(n);
    a(q4e(n));
    const x = C.position === "static", {
      borderLeftWidth: T,
      borderTopWidth: E
    } = C;
    u(x ? n.offsetLeft : _T(-parseFloat(T))), f(x ? n.offsetTop : _T(-parseFloat(E))), p(n.offsetWidth), m(n.offsetHeight);
    const {
      borderTopLeftRadius: R,
      borderTopRightRadius: I,
      borderBottomLeftRadius: O,
      borderBottomRightRadius: P
    } = C;
    c([R, I, P, O].map((k) => _T(parseFloat(k))));
  }
  if ($.useEffect(() => {
    if (n) {
      const C = Ln(() => {
        b(), y(!0);
      });
      let x;
      return typeof ResizeObserver < "u" && (x = new ResizeObserver(b), x.observe(n)), () => {
        Ln.cancel(C), x == null || x.disconnect();
      };
    }
  }, []), !v)
    return null;
  const w = (r === "Checkbox" || r === "Radio") && (n == null ? void 0 : n.classList.contains(KJ));
  return /* @__PURE__ */ $.createElement(Uf, {
    visible: !0,
    motionAppear: !0,
    motionName: "wave-motion",
    motionDeadline: 5e3,
    onAppearEnd: (C, x) => {
      var T;
      if (x.deadline || x.propertyName === "opacity") {
        const E = (T = i.current) === null || T === void 0 ? void 0 : T.parentElement;
        H4e(E).then(() => {
          E == null || E.remove();
        });
      }
      return !1;
    }
  }, (C, x) => {
    let {
      className: T
    } = C;
    return /* @__PURE__ */ $.createElement("div", {
      ref: Ja(i, x),
      className: Ee(t, T, {
        "wave-quick": w
      }),
      style: _
    });
  });
}, K4e = (e, t) => {
  var n;
  const {
    component: r
  } = t;
  if (r === "Checkbox" && !(!((n = e.querySelector("input")) === null || n === void 0) && n.checked))
    return;
  const i = document.createElement("div");
  i.style.position = "absolute", i.style.left = "0px", i.style.top = "0px", e == null || e.insertBefore(i, e == null ? void 0 : e.firstChild), WJ(/* @__PURE__ */ $.createElement(G4e, Object.assign({}, t, {
    target: e
  })), i);
}, Y4e = K4e, X4e = (e, t, n) => {
  const {
    wave: r
  } = $.useContext(Cn), [, i, o] = js(), a = Pr((l) => {
    const u = e.current;
    if (r != null && r.disabled || !u)
      return;
    const d = u.querySelector(`.${KJ}`) || u, {
      showEffect: f
    } = r || {};
    (f || Y4e)(d, {
      className: t,
      token: i,
      component: n,
      event: l,
      hashId: o
    });
  }), s = $.useRef();
  return (l) => {
    Ln.cancel(s.current), s.current = Ln(() => {
      a(l);
    });
  };
}, Q4e = X4e, YJ = (e) => {
  const {
    children: t,
    disabled: n,
    component: r
  } = e, {
    getPrefixCls: i
  } = gt(Cn), o = $e(null), a = i("wave"), [, s] = W4e(a), c = Q4e(o, Ee(a, s), r);
  if (j.useEffect(() => {
    const u = o.current;
    if (!u || u.nodeType !== 1 || n)
      return;
    const d = (f) => {
      !GJ(f.target) || // No need wave
      !u.getAttribute || u.getAttribute("disabled") || u.disabled || u.className.includes("disabled") || u.className.includes("-leave") || c(f);
    };
    return u.addEventListener("click", d, !0), () => {
      u.removeEventListener("click", d, !0);
    };
  }, [n]), !/* @__PURE__ */ j.isValidElement(t))
    return t ?? null;
  const l = $y(t) ? Ja(t.ref, o) : o;
  return Jg(t, {
    ref: l
  });
};
process.env.NODE_ENV !== "production" && (YJ.displayName = "Wave");
const J4e = YJ, Z4e = (e) => {
  const t = j.useContext(jE);
  return j.useMemo(() => e ? typeof e == "string" ? e ?? t : e instanceof Function ? e(t) : t : t, [e, t]);
}, Gf = Z4e;
globalThis && globalThis.__rest;
const XJ = /* @__PURE__ */ $.createContext(null), Ry = (e, t) => {
  const n = $.useContext(XJ), r = $.useMemo(() => {
    if (!n)
      return "";
    const {
      compactDirection: i,
      isFirstItem: o,
      isLastItem: a
    } = n, s = i === "vertical" ? "-vertical-" : "-";
    return Ee(`${e}-compact${s}item`, {
      [`${e}-compact${s}first-item`]: o,
      [`${e}-compact${s}last-item`]: a,
      [`${e}-compact${s}item-rtl`]: t === "rtl"
    });
  }, [e, t, n]);
  return {
    compactSize: n == null ? void 0 : n.compactSize,
    compactDirection: n == null ? void 0 : n.compactDirection,
    compactItemClassnames: r
  };
}, eNe = (e) => {
  let {
    children: t
  } = e;
  return /* @__PURE__ */ $.createElement(XJ.Provider, {
    value: null
  }, t);
};
var tNe = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
const QJ = /* @__PURE__ */ $.createContext(void 0), nNe = (e) => {
  const {
    getPrefixCls: t,
    direction: n
  } = $.useContext(Cn), {
    prefixCls: r,
    size: i,
    className: o
  } = e, a = tNe(e, ["prefixCls", "size", "className"]), s = t("btn-group", r), [, , c] = js();
  let l = "";
  switch (i) {
    case "large":
      l = "lg";
      break;
    case "small":
      l = "sm";
      break;
  }
  if (process.env.NODE_ENV !== "production") {
    const d = di("Button.Group");
    process.env.NODE_ENV !== "production" && d(!i || ["large", "small", "middle"].includes(i), "usage", "Invalid prop `size`.");
  }
  const u = Ee(s, {
    [`${s}-${l}`]: l,
    [`${s}-rtl`]: n === "rtl"
  }, o, c);
  return /* @__PURE__ */ $.createElement(QJ.Provider, {
    value: i
  }, /* @__PURE__ */ $.createElement("div", Object.assign({}, a, {
    className: u
  })));
}, rNe = nNe, FL = /^[\u4E00-\u9FA5]{2}$/, sR = FL.test.bind(FL);
function VL(e) {
  return typeof e == "string";
}
function p1(e) {
  return e === "text" || e === "link";
}
function iNe(e, t) {
  if (e == null)
    return;
  const n = t ? " " : "";
  return typeof e != "string" && typeof e != "number" && VL(e.type) && sR(e.props.children) ? Jg(e, {
    children: e.props.children.split("").join(n)
  }) : VL(e) ? sR(e) ? /* @__PURE__ */ j.createElement("span", null, e.split("").join(n)) : /* @__PURE__ */ j.createElement("span", null, e) : IJ(e) ? /* @__PURE__ */ j.createElement("span", null, e) : e;
}
function oNe(e, t) {
  let n = !1;
  const r = [];
  return j.Children.forEach(e, (i) => {
    const o = typeof i, a = o === "string" || o === "number";
    if (n && a) {
      const s = r.length - 1, c = r[s];
      r[s] = `${c}${i}`;
    } else
      r.push(i);
    n = a;
  }), j.Children.map(r, (i) => iNe(i, t));
}
const aNe = /* @__PURE__ */ ia((e, t) => {
  const {
    className: n,
    style: r,
    children: i,
    prefixCls: o
  } = e, a = Ee(`${o}-icon`, n);
  return /* @__PURE__ */ j.createElement("span", {
    ref: t,
    className: a,
    style: r
  }, i);
}), JJ = aNe, BL = /* @__PURE__ */ ia((e, t) => {
  const {
    prefixCls: n,
    className: r,
    style: i,
    iconClassName: o
  } = e, a = Ee(`${n}-loading-icon`, r);
  return /* @__PURE__ */ j.createElement(JJ, {
    prefixCls: n,
    className: a,
    style: i,
    ref: t
  }, /* @__PURE__ */ j.createElement(TM, {
    className: o
  }));
}), ST = () => ({
  width: 0,
  opacity: 0,
  transform: "scale(0)"
}), wT = (e) => ({
  width: e.scrollWidth,
  opacity: 1,
  transform: "scale(1)"
}), sNe = (e) => {
  const {
    prefixCls: t,
    loading: n,
    existIcon: r,
    className: i,
    style: o
  } = e, a = !!n;
  return r ? /* @__PURE__ */ j.createElement(BL, {
    prefixCls: t,
    className: i,
    style: o
  }) : /* @__PURE__ */ j.createElement(Uf, {
    visible: a,
    // We do not really use this motionName
    motionName: `${t}-loading-icon-motion`,
    motionLeave: a,
    removeOnLeave: !0,
    onAppearStart: ST,
    onAppearActive: wT,
    onEnterStart: ST,
    onEnterActive: wT,
    onLeaveStart: wT,
    onLeaveActive: ST
  }, (s, c) => {
    let {
      className: l,
      style: u
    } = s;
    return /* @__PURE__ */ j.createElement(BL, {
      prefixCls: t,
      className: i,
      style: Object.assign(Object.assign({}, o), u),
      ref: c,
      iconClassName: l
    });
  });
}, cNe = sNe, zL = (e, t) => ({
  // Border
  [`> span, > ${e}`]: {
    "&:not(:last-child)": {
      [`&, & > ${e}`]: {
        "&:not(:disabled)": {
          borderInlineEndColor: t
        }
      }
    },
    "&:not(:first-child)": {
      [`&, & > ${e}`]: {
        "&:not(:disabled)": {
          borderInlineStartColor: t
        }
      }
    }
  }
}), lNe = (e) => {
  const {
    componentCls: t,
    fontSize: n,
    lineWidth: r,
    groupBorderColor: i,
    colorErrorHover: o
  } = e;
  return {
    [`${t}-group`]: [
      {
        position: "relative",
        display: "inline-flex",
        // Border
        [`> span, > ${t}`]: {
          "&:not(:last-child)": {
            [`&, & > ${t}`]: {
              borderStartEndRadius: 0,
              borderEndEndRadius: 0
            }
          },
          "&:not(:first-child)": {
            marginInlineStart: e.calc(r).mul(-1).equal(),
            [`&, & > ${t}`]: {
              borderStartStartRadius: 0,
              borderEndStartRadius: 0
            }
          }
        },
        [t]: {
          position: "relative",
          zIndex: 1,
          "&:hover, &:focus, &:active": {
            zIndex: 2
          },
          "&[disabled]": {
            zIndex: 0
          }
        },
        [`${t}-icon-only`]: {
          fontSize: n
        }
      },
      // Border Color
      zL(`${t}-primary`, i),
      zL(`${t}-danger`, o)
    ]
  };
}, uNe = lNe, $i = Math.round;
function xT(e, t) {
  const n = e.replace(/^[^(]*\((.*)/, "$1").replace(/\).*/, "").match(/\d*\.?\d+%?/g) || [], r = n.map((i) => parseFloat(i));
  for (let i = 0; i < 3; i += 1)
    r[i] = t(r[i] || 0, n[i] || "", i);
  return n[3] ? r[3] = n[3].includes("%") ? r[3] / 100 : r[3] : r[3] = 1, r;
}
const HL = (e, t, n) => n === 0 ? e : e / 100;
function Pm(e, t) {
  const n = t || 255;
  return e > n ? n : e < 0 ? 0 : e;
}
class UE {
  constructor(t) {
    oe(this, "isValid", !0), oe(this, "r", 0), oe(this, "g", 0), oe(this, "b", 0), oe(this, "a", 1), oe(this, "_h", void 0), oe(this, "_s", void 0), oe(this, "_l", void 0), oe(this, "_v", void 0), oe(this, "_max", void 0), oe(this, "_min", void 0), oe(this, "_brightness", void 0);
    function n(r) {
      return r[0] in t && r[1] in t && r[2] in t;
    }
    if (t)
      if (typeof t == "string") {
        let i = function(o) {
          return r.startsWith(o);
        };
        const r = t.trim();
        /^#?[A-F\d]{3,8}$/i.test(r) ? this.fromHexString(r) : i("rgb") ? this.fromRgbString(r) : i("hsl") ? this.fromHslString(r) : (i("hsv") || i("hsb")) && this.fromHsvString(r);
      } else if (t instanceof UE)
        this.r = t.r, this.g = t.g, this.b = t.b, this.a = t.a, this._h = t._h, this._s = t._s, this._l = t._l, this._v = t._v;
      else if (n("rgb"))
        this.r = Pm(t.r), this.g = Pm(t.g), this.b = Pm(t.b), this.a = typeof t.a == "number" ? Pm(t.a, 1) : 1;
      else if (n("hsl"))
        this.fromHsl(t);
      else if (n("hsv"))
        this.fromHsv(t);
      else
        throw new Error("@ant-design/fast-color: unsupported input " + JSON.stringify(t));
  }
  // ======================= Setter =======================
  setR(t) {
    return this._sc("r", t);
  }
  setG(t) {
    return this._sc("g", t);
  }
  setB(t) {
    return this._sc("b", t);
  }
  setA(t) {
    return this._sc("a", t, 1);
  }
  setHue(t) {
    const n = this.toHsv();
    return n.h = t, this._c(n);
  }
  // ======================= Getter =======================
  /**
   * Returns the perceived luminance of a color, from 0-1.
   * @see http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
   */
  getLuminance() {
    function t(o) {
      const a = o / 255;
      return a <= 0.03928 ? a / 12.92 : Math.pow((a + 0.055) / 1.055, 2.4);
    }
    const n = t(this.r), r = t(this.g), i = t(this.b);
    return 0.2126 * n + 0.7152 * r + 0.0722 * i;
  }
  getHue() {
    if (typeof this._h > "u") {
      const t = this.getMax() - this.getMin();
      t === 0 ? this._h = 0 : this._h = $i(60 * (this.r === this.getMax() ? (this.g - this.b) / t + (this.g < this.b ? 6 : 0) : this.g === this.getMax() ? (this.b - this.r) / t + 2 : (this.r - this.g) / t + 4));
    }
    return this._h;
  }
  getSaturation() {
    if (typeof this._s > "u") {
      const t = this.getMax() - this.getMin();
      t === 0 ? this._s = 0 : this._s = t / this.getMax();
    }
    return this._s;
  }
  getLightness() {
    return typeof this._l > "u" && (this._l = (this.getMax() + this.getMin()) / 510), this._l;
  }
  getValue() {
    return typeof this._v > "u" && (this._v = this.getMax() / 255), this._v;
  }
  /**
   * Returns the perceived brightness of the color, from 0-255.
   * Note: this is not the b of HSB
   * @see http://www.w3.org/TR/AERT#color-contrast
   */
  getBrightness() {
    return typeof this._brightness > "u" && (this._brightness = (this.r * 299 + this.g * 587 + this.b * 114) / 1e3), this._brightness;
  }
  // ======================== Func ========================
  darken(t = 10) {
    const n = this.getHue(), r = this.getSaturation();
    let i = this.getLightness() - t / 100;
    return i < 0 && (i = 0), this._c({
      h: n,
      s: r,
      l: i,
      a: this.a
    });
  }
  lighten(t = 10) {
    const n = this.getHue(), r = this.getSaturation();
    let i = this.getLightness() + t / 100;
    return i > 1 && (i = 1), this._c({
      h: n,
      s: r,
      l: i,
      a: this.a
    });
  }
  /**
   * Mix the current color a given amount with another color, from 0 to 100.
   * 0 means no mixing (return current color).
   */
  mix(t, n = 50) {
    const r = this._c(t), i = n / 100, o = (s) => (r[s] - this[s]) * i + this[s], a = {
      r: $i(o("r")),
      g: $i(o("g")),
      b: $i(o("b")),
      a: $i(o("a") * 100) / 100
    };
    return this._c(a);
  }
  /**
   * Mix the color with pure white, from 0 to 100.
   * Providing 0 will do nothing, providing 100 will always return white.
   */
  tint(t = 10) {
    return this.mix({
      r: 255,
      g: 255,
      b: 255,
      a: 1
    }, t);
  }
  /**
   * Mix the color with pure black, from 0 to 100.
   * Providing 0 will do nothing, providing 100 will always return black.
   */
  shade(t = 10) {
    return this.mix({
      r: 0,
      g: 0,
      b: 0,
      a: 1
    }, t);
  }
  onBackground(t) {
    const n = this._c(t), r = this.a + n.a * (1 - this.a), i = (o) => $i((this[o] * this.a + n[o] * n.a * (1 - this.a)) / r);
    return this._c({
      r: i("r"),
      g: i("g"),
      b: i("b"),
      a: r
    });
  }
  // ======================= Status =======================
  isDark() {
    return this.getBrightness() < 128;
  }
  isLight() {
    return this.getBrightness() >= 128;
  }
  // ======================== MISC ========================
  equals(t) {
    return this.r === t.r && this.g === t.g && this.b === t.b && this.a === t.a;
  }
  clone() {
    return this._c(this);
  }
  // ======================= Format =======================
  toHexString() {
    let t = "#";
    const n = (this.r || 0).toString(16);
    t += n.length === 2 ? n : "0" + n;
    const r = (this.g || 0).toString(16);
    t += r.length === 2 ? r : "0" + r;
    const i = (this.b || 0).toString(16);
    if (t += i.length === 2 ? i : "0" + i, typeof this.a == "number" && this.a >= 0 && this.a < 1) {
      const o = $i(this.a * 255).toString(16);
      t += o.length === 2 ? o : "0" + o;
    }
    return t;
  }
  /** CSS support color pattern */
  toHsl() {
    return {
      h: this.getHue(),
      s: this.getSaturation(),
      l: this.getLightness(),
      a: this.a
    };
  }
  /** CSS support color pattern */
  toHslString() {
    const t = this.getHue(), n = $i(this.getSaturation() * 100), r = $i(this.getLightness() * 100);
    return this.a !== 1 ? `hsla(${t},${n}%,${r}%,${this.a})` : `hsl(${t},${n}%,${r}%)`;
  }
  /** Same as toHsb */
  toHsv() {
    return {
      h: this.getHue(),
      s: this.getSaturation(),
      v: this.getValue(),
      a: this.a
    };
  }
  toRgb() {
    return {
      r: this.r,
      g: this.g,
      b: this.b,
      a: this.a
    };
  }
  toRgbString() {
    return this.a !== 1 ? `rgba(${this.r},${this.g},${this.b},${this.a})` : `rgb(${this.r},${this.g},${this.b})`;
  }
  toString() {
    return this.toRgbString();
  }
  // ====================== Privates ======================
  /** Return a new FastColor object with one channel changed */
  _sc(t, n, r) {
    const i = this.clone();
    return i[t] = Pm(n, r), i;
  }
  _c(t) {
    return new this.constructor(t);
  }
  getMax() {
    return typeof this._max > "u" && (this._max = Math.max(this.r, this.g, this.b)), this._max;
  }
  getMin() {
    return typeof this._min > "u" && (this._min = Math.min(this.r, this.g, this.b)), this._min;
  }
  fromHexString(t) {
    const n = t.replace("#", "");
    function r(i, o) {
      return parseInt(n[i] + n[o || i], 16);
    }
    n.length < 6 ? (this.r = r(0), this.g = r(1), this.b = r(2), this.a = n[3] ? r(3) / 255 : 1) : (this.r = r(0, 1), this.g = r(2, 3), this.b = r(4, 5), this.a = n[6] ? r(6, 7) / 255 : 1);
  }
  fromHsl({
    h: t,
    s: n,
    l: r,
    a: i
  }) {
    if (this._h = t % 360, this._s = n, this._l = r, this.a = typeof i == "number" ? i : 1, n <= 0) {
      const f = $i(r * 255);
      this.r = f, this.g = f, this.b = f;
    }
    let o = 0, a = 0, s = 0;
    const c = t / 60, l = (1 - Math.abs(2 * r - 1)) * n, u = l * (1 - Math.abs(c % 2 - 1));
    c >= 0 && c < 1 ? (o = l, a = u) : c >= 1 && c < 2 ? (o = u, a = l) : c >= 2 && c < 3 ? (a = l, s = u) : c >= 3 && c < 4 ? (a = u, s = l) : c >= 4 && c < 5 ? (o = u, s = l) : c >= 5 && c < 6 && (o = l, s = u);
    const d = r - l / 2;
    this.r = $i((o + d) * 255), this.g = $i((a + d) * 255), this.b = $i((s + d) * 255);
  }
  fromHsv({
    h: t,
    s: n,
    v: r,
    a: i
  }) {
    this._h = t % 360, this._s = n, this._v = r, this.a = typeof i == "number" ? i : 1;
    const o = $i(r * 255);
    if (this.r = o, this.g = o, this.b = o, n <= 0)
      return;
    const a = t / 60, s = Math.floor(a), c = a - s, l = $i(r * (1 - n) * 255), u = $i(r * (1 - n * c) * 255), d = $i(r * (1 - n * (1 - c)) * 255);
    switch (s) {
      case 0:
        this.g = d, this.b = l;
        break;
      case 1:
        this.r = u, this.b = l;
        break;
      case 2:
        this.r = l, this.b = d;
        break;
      case 3:
        this.r = l, this.g = u;
        break;
      case 4:
        this.r = d, this.g = l;
        break;
      case 5:
      default:
        this.g = l, this.b = u;
        break;
    }
  }
  fromHsvString(t) {
    const n = xT(t, HL);
    this.fromHsv({
      h: n[0],
      s: n[1],
      v: n[2],
      a: n[3]
    });
  }
  fromHslString(t) {
    const n = xT(t, HL);
    this.fromHsl({
      h: n[0],
      s: n[1],
      l: n[2],
      a: n[3]
    });
  }
  fromRgbString(t) {
    const n = xT(t, (r, i) => (
      // Convert percentage to number. e.g. 50% -> 128
      i.includes("%") ? $i(r / 100 * 255) : r
    ));
    this.r = n[0], this.g = n[1], this.b = n[2], this.a = n[3];
  }
}
var dNe = ["b"], fNe = ["v"], ET = function(t) {
  return Math.round(Number(t || 0));
}, hNe = function(t) {
  if (t instanceof UE)
    return t;
  if (t && It(t) === "object" && "h" in t && "b" in t) {
    var n = t, r = n.b, i = En(n, dNe);
    return ae(ae({}, i), {}, {
      v: r
    });
  }
  return typeof t == "string" && /hsb/.test(t) ? t.replace(/hsb/, "hsv") : t;
}, vl = /* @__PURE__ */ function(e) {
  Ds(n, e);
  var t = Ac(n);
  function n(r) {
    return xr(this, n), t.call(this, hNe(r));
  }
  return Er(n, [{
    key: "toHsbString",
    value: function() {
      var i = this.toHsb(), o = ET(i.s * 100), a = ET(i.b * 100), s = ET(i.h), c = i.a, l = "hsb(".concat(s, ", ").concat(o, "%, ").concat(a, "%)"), u = "hsba(".concat(s, ", ").concat(o, "%, ").concat(a, "%, ").concat(c.toFixed(c === 0 ? 0 : 2), ")");
      return c === 1 ? l : u;
    }
  }, {
    key: "toHsb",
    value: function() {
      var i = this.toHsv(), o = i.v, a = En(i, fNe);
      return ae(ae({}, a), {}, {
        b: o,
        a: this.a
      });
    }
  }]), n;
}(UE), gNe = "rc-color-picker", fg = function(t) {
  return t instanceof vl ? t : new vl(t);
}, pNe = fg("#1677ff"), ZJ = function(t) {
  var n = t.offset, r = t.targetRef, i = t.containerRef, o = t.color, a = t.type, s = i.current.getBoundingClientRect(), c = s.width, l = s.height, u = r.current.getBoundingClientRect(), d = u.width, f = u.height, h = d / 2, p = f / 2, g = (n.x + h) / c, m = 1 - (n.y + p) / l, v = o.toHsb(), y = g, _ = (n.x + h) / c * 360;
  if (a)
    switch (a) {
      case "hue":
        return fg(ae(ae({}, v), {}, {
          h: _ <= 0 ? 0 : _
        }));
      case "alpha":
        return fg(ae(ae({}, v), {}, {
          a: y <= 0 ? 0 : y
        }));
    }
  return fg({
    h: v.h,
    s: g <= 0 ? 0 : g,
    b: m >= 1 ? 1 : m,
    a: v.a
  });
}, eZ = function(t, n) {
  var r = t.toHsb();
  switch (n) {
    case "hue":
      return {
        x: r.h / 360 * 100,
        y: 50
      };
    case "alpha":
      return {
        x: t.a * 100,
        y: 50
      };
    default:
      return {
        x: r.s * 100,
        y: (1 - r.b) * 100
      };
  }
}, mNe = function(t) {
  var n = t.color, r = t.prefixCls, i = t.className, o = t.style, a = t.onClick, s = "".concat(r, "-color-block");
  return /* @__PURE__ */ j.createElement("div", {
    className: Ee(s, i),
    style: o,
    onClick: a
  }, /* @__PURE__ */ j.createElement("div", {
    className: "".concat(s, "-inner"),
    style: {
      background: n
    }
  }));
};
function vNe(e) {
  var t = "touches" in e ? e.touches[0] : e, n = document.documentElement.scrollLeft || document.body.scrollLeft || window.pageXOffset, r = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;
  return {
    pageX: t.pageX - n,
    pageY: t.pageY - r
  };
}
function tZ(e) {
  var t = e.targetRef, n = e.containerRef, r = e.direction, i = e.onDragChange, o = e.onDragChangeComplete, a = e.calculate, s = e.color, c = e.disabledDrag, l = Qe({
    x: 0,
    y: 0
  }), u = he(l, 2), d = u[0], f = u[1], h = $e(null), p = $e(null);
  ot(function() {
    f(a());
  }, [s]), ot(function() {
    return function() {
      document.removeEventListener("mousemove", h.current), document.removeEventListener("mouseup", p.current), document.removeEventListener("touchmove", h.current), document.removeEventListener("touchend", p.current), h.current = null, p.current = null;
    };
  }, []);
  var g = function(b) {
    var w = vNe(b), C = w.pageX, x = w.pageY, T = n.current.getBoundingClientRect(), E = T.x, R = T.y, I = T.width, O = T.height, P = t.current.getBoundingClientRect(), k = P.width, L = P.height, N = k / 2, D = L / 2, z = Math.max(0, Math.min(C - E, I)) - N, V = Math.max(0, Math.min(x - R, O)) - D, B = {
      x: z,
      y: r === "x" ? d.y : V
    };
    if (k === 0 && L === 0 || k !== L)
      return !1;
    i == null || i(B);
  }, m = function(b) {
    b.preventDefault(), g(b);
  }, v = function(b) {
    b.preventDefault(), document.removeEventListener("mousemove", h.current), document.removeEventListener("mouseup", p.current), document.removeEventListener("touchmove", h.current), document.removeEventListener("touchend", p.current), h.current = null, p.current = null, o == null || o();
  }, y = function(b) {
    document.removeEventListener("mousemove", h.current), document.removeEventListener("mouseup", p.current), !c && (g(b), document.addEventListener("mousemove", m), document.addEventListener("mouseup", v), document.addEventListener("touchmove", m), document.addEventListener("touchend", v), h.current = m, p.current = v);
  };
  return [d, y];
}
var nZ = function(t) {
  var n = t.size, r = n === void 0 ? "default" : n, i = t.color, o = t.prefixCls;
  return /* @__PURE__ */ j.createElement("div", {
    className: Ee("".concat(o, "-handler"), oe({}, "".concat(o, "-handler-sm"), r === "small")),
    style: {
      backgroundColor: i
    }
  });
}, rZ = function(t) {
  var n = t.children, r = t.style, i = t.prefixCls;
  return /* @__PURE__ */ j.createElement("div", {
    className: "".concat(i, "-palette"),
    style: ae({
      position: "relative"
    }, r)
  }, n);
}, iZ = /* @__PURE__ */ ia(function(e, t) {
  var n = e.children, r = e.x, i = e.y;
  return /* @__PURE__ */ j.createElement("div", {
    ref: t,
    style: {
      position: "absolute",
      left: "".concat(r, "%"),
      top: "".concat(i, "%"),
      zIndex: 1,
      transform: "translate(-50%, -50%)"
    }
  }, n);
}), yNe = function(t) {
  var n = t.color, r = t.onChange, i = t.prefixCls, o = t.onChangeComplete, a = t.disabled, s = $e(), c = $e(), l = $e(n), u = Pr(function(g) {
    var m = ZJ({
      offset: g,
      targetRef: c,
      containerRef: s,
      color: n
    });
    l.current = m, r(m);
  }), d = tZ({
    color: n,
    containerRef: s,
    targetRef: c,
    calculate: function() {
      return eZ(n);
    },
    onDragChange: u,
    onDragChangeComplete: function() {
      return o == null ? void 0 : o(l.current);
    },
    disabledDrag: a
  }), f = he(d, 2), h = f[0], p = f[1];
  return /* @__PURE__ */ j.createElement("div", {
    ref: s,
    className: "".concat(i, "-select"),
    onMouseDown: p,
    onTouchStart: p
  }, /* @__PURE__ */ j.createElement(rZ, {
    prefixCls: i
  }, /* @__PURE__ */ j.createElement(iZ, {
    x: h.x,
    y: h.y,
    ref: c
  }, /* @__PURE__ */ j.createElement(nZ, {
    color: n.toRgbString(),
    prefixCls: i
  })), /* @__PURE__ */ j.createElement("div", {
    className: "".concat(i, "-saturation"),
    style: {
      backgroundColor: "hsl(".concat(n.toHsb().h, ",100%, 50%)"),
      backgroundImage: "linear-gradient(0deg, #000, transparent),linear-gradient(90deg, #fff, hsla(0, 0%, 100%, 0))"
    }
  })));
}, bNe = function(t, n) {
  var r = wc(t, {
    value: n
  }), i = he(r, 2), o = i[0], a = i[1], s = Tt(function() {
    return fg(o);
  }, [o]);
  return [s, a];
}, _Ne = function(t) {
  var n = t.colors, r = t.children, i = t.direction, o = i === void 0 ? "to right" : i, a = t.type, s = t.prefixCls, c = Tt(function() {
    return n.map(function(l, u) {
      var d = fg(l);
      return a === "alpha" && u === n.length - 1 && (d = new vl(d.setA(1))), d.toRgbString();
    }).join(",");
  }, [n, a]);
  return /* @__PURE__ */ j.createElement("div", {
    className: "".concat(s, "-gradient"),
    style: {
      position: "absolute",
      inset: 0,
      background: "linear-gradient(".concat(o, ", ").concat(c, ")")
    }
  }, r);
}, SNe = function(t) {
  var n = t.prefixCls, r = t.colors, i = t.disabled, o = t.onChange, a = t.onChangeComplete, s = t.color, c = t.type, l = $e(), u = $e(), d = $e(s), f = function(w) {
    return c === "hue" ? w.getHue() : w.a * 100;
  }, h = Pr(function(b) {
    var w = ZJ({
      offset: b,
      targetRef: u,
      containerRef: l,
      color: s,
      type: c
    });
    d.current = w, o(f(w));
  }), p = tZ({
    color: s,
    targetRef: u,
    containerRef: l,
    calculate: function() {
      return eZ(s, c);
    },
    onDragChange: h,
    onDragChangeComplete: function() {
      a(f(d.current));
    },
    direction: "x",
    disabledDrag: i
  }), g = he(p, 2), m = g[0], v = g[1], y = j.useMemo(function() {
    if (c === "hue") {
      var b = s.toHsb();
      b.s = 1, b.b = 1, b.a = 1;
      var w = new vl(b);
      return w;
    }
    return s;
  }, [s, c]), _ = j.useMemo(function() {
    return r.map(function(b) {
      return "".concat(b.color, " ").concat(b.percent, "%");
    });
  }, [r]);
  return /* @__PURE__ */ j.createElement("div", {
    ref: l,
    className: Ee("".concat(n, "-slider"), "".concat(n, "-slider-").concat(c)),
    onMouseDown: v,
    onTouchStart: v
  }, /* @__PURE__ */ j.createElement(rZ, {
    prefixCls: n
  }, /* @__PURE__ */ j.createElement(iZ, {
    x: m.x,
    y: m.y,
    ref: u
  }, /* @__PURE__ */ j.createElement(nZ, {
    size: "small",
    color: y.toHexString(),
    prefixCls: n
  })), /* @__PURE__ */ j.createElement(_Ne, {
    colors: _,
    type: c,
    prefixCls: n
  })));
};
function wNe(e) {
  return $.useMemo(function() {
    var t = e || {}, n = t.slider;
    return [n || SNe];
  }, [e]);
}
var xNe = [{
  color: "rgb(255, 0, 0)",
  percent: 0
}, {
  color: "rgb(255, 255, 0)",
  percent: 17
}, {
  color: "rgb(0, 255, 0)",
  percent: 33
}, {
  color: "rgb(0, 255, 255)",
  percent: 50
}, {
  color: "rgb(0, 0, 255)",
  percent: 67
}, {
  color: "rgb(255, 0, 255)",
  percent: 83
}, {
  color: "rgb(255, 0, 0)",
  percent: 100
}], ENe = /* @__PURE__ */ ia(function(e, t) {
  var n = e.value, r = e.defaultValue, i = e.prefixCls, o = i === void 0 ? gNe : i, a = e.onChange, s = e.onChangeComplete, c = e.className, l = e.style, u = e.panelRender, d = e.disabledAlpha, f = d === void 0 ? !1 : d, h = e.disabled, p = h === void 0 ? !1 : h, g = e.components, m = wNe(g), v = he(m, 1), y = v[0], _ = bNe(r || pNe, n), b = he(_, 2), w = b[0], C = b[1], x = Tt(function() {
    return w.setA(1).toRgbString();
  }, [w]), T = function(V, B) {
    n || C(V), a == null || a(V, B);
  }, E = function(V) {
    return new vl(w.setHue(V));
  }, R = function(V) {
    return new vl(w.setA(V / 100));
  }, I = function(V) {
    T(E(V), {
      type: "hue",
      value: V
    });
  }, O = function(V) {
    T(R(V), {
      type: "alpha",
      value: V
    });
  }, P = function(V) {
    s && s(E(V));
  }, k = function(V) {
    s && s(R(V));
  }, L = Ee("".concat(o, "-panel"), c, oe({}, "".concat(o, "-panel-disabled"), p)), N = {
    prefixCls: o,
    disabled: p,
    color: w
  }, D = /* @__PURE__ */ j.createElement(j.Fragment, null, /* @__PURE__ */ j.createElement(yNe, xt({
    onChange: T
  }, N, {
    onChangeComplete: s
  })), /* @__PURE__ */ j.createElement("div", {
    className: "".concat(o, "-slider-container")
  }, /* @__PURE__ */ j.createElement("div", {
    className: Ee("".concat(o, "-slider-group"), oe({}, "".concat(o, "-slider-group-disabled-alpha"), f))
  }, /* @__PURE__ */ j.createElement(y, xt({}, N, {
    type: "hue",
    colors: xNe,
    min: 0,
    max: 359,
    value: w.getHue(),
    onChange: I,
    onChangeComplete: P
  })), !f && /* @__PURE__ */ j.createElement(y, xt({}, N, {
    type: "alpha",
    colors: [{
      percent: 0,
      color: "rgba(255, 0, 4, 0)"
    }, {
      percent: 100,
      color: x
    }],
    min: 0,
    max: 100,
    value: w.a * 100,
    onChange: O,
    onChangeComplete: k
  }))), /* @__PURE__ */ j.createElement(mNe, {
    color: w.toRgbString(),
    prefixCls: o
  })));
  return /* @__PURE__ */ j.createElement("div", {
    className: L,
    style: l,
    ref: t
  }, typeof u == "function" ? u(D) : D);
});
process.env.NODE_ENV !== "production" && (ENe.displayName = "ColorPicker");
const CNe = (e, t) => (e == null ? void 0 : e.replace(/[^\w/]/g, "").slice(0, t ? 8 : 6)) || "", TNe = (e, t) => e ? CNe(e, t) : "";
let INe = /* @__PURE__ */ function() {
  function e(t) {
    xr(this, e);
    var n;
    if (this.cleared = !1, t instanceof e) {
      this.metaColor = t.metaColor.clone(), this.colors = (n = t.colors) === null || n === void 0 ? void 0 : n.map((i) => ({
        color: new e(i.color),
        percent: i.percent
      })), this.cleared = t.cleared;
      return;
    }
    const r = Array.isArray(t);
    r && t.length ? (this.colors = t.map((i) => {
      let {
        color: o,
        percent: a
      } = i;
      return {
        color: new e(o),
        percent: a
      };
    }), this.metaColor = new vl(this.colors[0].color.metaColor)) : this.metaColor = new vl(r ? "" : t), (!t || r && !this.colors) && (this.metaColor = this.metaColor.setA(0), this.cleared = !0);
  }
  return Er(e, [{
    key: "toHsb",
    value: function() {
      return this.metaColor.toHsb();
    }
  }, {
    key: "toHsbString",
    value: function() {
      return this.metaColor.toHsbString();
    }
  }, {
    key: "toHex",
    value: function() {
      return TNe(this.toHexString(), this.metaColor.a < 1);
    }
  }, {
    key: "toHexString",
    value: function() {
      return this.metaColor.toHexString();
    }
  }, {
    key: "toRgb",
    value: function() {
      return this.metaColor.toRgb();
    }
  }, {
    key: "toRgbString",
    value: function() {
      return this.metaColor.toRgbString();
    }
  }, {
    key: "isGradient",
    value: function() {
      return !!this.colors && !this.cleared;
    }
  }, {
    key: "getColors",
    value: function() {
      return this.colors || [{
        color: this,
        percent: 0
      }];
    }
  }, {
    key: "toCssString",
    value: function() {
      const {
        colors: n
      } = this;
      return n ? `linear-gradient(90deg, ${n.map((i) => `${i.color.toRgbString()} ${i.percent}%`).join(", ")})` : this.metaColor.toRgbString();
    }
  }, {
    key: "equals",
    value: function(n) {
      return !n || this.isGradient() !== n.isGradient() ? !1 : this.isGradient() ? this.colors.length === n.colors.length && this.colors.every((r, i) => {
        const o = n.colors[i];
        return r.percent === o.percent && r.color.equals(o.color);
      }) : this.toHexString() === n.toHexString();
    }
  }]);
}();
var $Ne = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M765.7 486.8L314.9 134.7A7.97 7.97 0 00302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 000-50.4z" } }] }, name: "right", theme: "outlined" };
const ANe = $Ne;
var RNe = function(t, n) {
  return /* @__PURE__ */ $.createElement(mo, xt({}, t, {
    ref: n,
    icon: ANe
  }));
}, oZ = /* @__PURE__ */ $.forwardRef(RNe);
process.env.NODE_ENV !== "production" && (oZ.displayName = "RightOutlined");
const PNe = oZ, ONe = (e) => ({
  animationDuration: e,
  animationFillMode: "both"
}), MNe = (e) => ({
  animationDuration: e,
  animationFillMode: "both"
}), $M = function(e, t, n, r) {
  const o = (arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !1) ? "&" : "";
  return {
    [`
      ${o}${e}-enter,
      ${o}${e}-appear
    `]: Object.assign(Object.assign({}, ONe(r)), {
      animationPlayState: "paused"
    }),
    [`${o}${e}-leave`]: Object.assign(Object.assign({}, MNe(r)), {
      animationPlayState: "paused"
    }),
    [`
      ${o}${e}-enter${e}-enter-active,
      ${o}${e}-appear${e}-appear-active
    `]: {
      animationName: t,
      animationPlayState: "running"
    },
    [`${o}${e}-leave${e}-leave-active`]: {
      animationName: n,
      animationPlayState: "running",
      pointerEvents: "none"
    }
  };
}, kNe = new Pn("antMoveDownIn", {
  "0%": {
    transform: "translate3d(0, 100%, 0)",
    transformOrigin: "0 0",
    opacity: 0
  },
  "100%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  }
}), NNe = new Pn("antMoveDownOut", {
  "0%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  },
  "100%": {
    transform: "translate3d(0, 100%, 0)",
    transformOrigin: "0 0",
    opacity: 0
  }
}), DNe = new Pn("antMoveLeftIn", {
  "0%": {
    transform: "translate3d(-100%, 0, 0)",
    transformOrigin: "0 0",
    opacity: 0
  },
  "100%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  }
}), jNe = new Pn("antMoveLeftOut", {
  "0%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  },
  "100%": {
    transform: "translate3d(-100%, 0, 0)",
    transformOrigin: "0 0",
    opacity: 0
  }
}), LNe = new Pn("antMoveRightIn", {
  "0%": {
    transform: "translate3d(100%, 0, 0)",
    transformOrigin: "0 0",
    opacity: 0
  },
  "100%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  }
}), FNe = new Pn("antMoveRightOut", {
  "0%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  },
  "100%": {
    transform: "translate3d(100%, 0, 0)",
    transformOrigin: "0 0",
    opacity: 0
  }
}), VNe = new Pn("antMoveUpIn", {
  "0%": {
    transform: "translate3d(0, -100%, 0)",
    transformOrigin: "0 0",
    opacity: 0
  },
  "100%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  }
}), BNe = new Pn("antMoveUpOut", {
  "0%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  },
  "100%": {
    transform: "translate3d(0, -100%, 0)",
    transformOrigin: "0 0",
    opacity: 0
  }
}), zNe = {
  "move-up": {
    inKeyframes: VNe,
    outKeyframes: BNe
  },
  "move-down": {
    inKeyframes: kNe,
    outKeyframes: NNe
  },
  "move-left": {
    inKeyframes: DNe,
    outKeyframes: jNe
  },
  "move-right": {
    inKeyframes: LNe,
    outKeyframes: FNe
  }
}, UL = (e, t) => {
  const {
    antCls: n
  } = e, r = `${n}-${t}`, {
    inKeyframes: i,
    outKeyframes: o
  } = zNe[t];
  return [$M(r, i, o, e.motionDurationMid), {
    [`
        ${r}-enter,
        ${r}-appear
      `]: {
      opacity: 0,
      animationTimingFunction: e.motionEaseOutCirc
    },
    [`${r}-leave`]: {
      animationTimingFunction: e.motionEaseInOutCirc
    }
  }];
}, aZ = new Pn("antSlideUpIn", {
  "0%": {
    transform: "scaleY(0.8)",
    transformOrigin: "0% 0%",
    opacity: 0
  },
  "100%": {
    transform: "scaleY(1)",
    transformOrigin: "0% 0%",
    opacity: 1
  }
}), sZ = new Pn("antSlideUpOut", {
  "0%": {
    transform: "scaleY(1)",
    transformOrigin: "0% 0%",
    opacity: 1
  },
  "100%": {
    transform: "scaleY(0.8)",
    transformOrigin: "0% 0%",
    opacity: 0
  }
}), cZ = new Pn("antSlideDownIn", {
  "0%": {
    transform: "scaleY(0.8)",
    transformOrigin: "100% 100%",
    opacity: 0
  },
  "100%": {
    transform: "scaleY(1)",
    transformOrigin: "100% 100%",
    opacity: 1
  }
}), lZ = new Pn("antSlideDownOut", {
  "0%": {
    transform: "scaleY(1)",
    transformOrigin: "100% 100%",
    opacity: 1
  },
  "100%": {
    transform: "scaleY(0.8)",
    transformOrigin: "100% 100%",
    opacity: 0
  }
}), HNe = new Pn("antSlideLeftIn", {
  "0%": {
    transform: "scaleX(0.8)",
    transformOrigin: "0% 0%",
    opacity: 0
  },
  "100%": {
    transform: "scaleX(1)",
    transformOrigin: "0% 0%",
    opacity: 1
  }
}), UNe = new Pn("antSlideLeftOut", {
  "0%": {
    transform: "scaleX(1)",
    transformOrigin: "0% 0%",
    opacity: 1
  },
  "100%": {
    transform: "scaleX(0.8)",
    transformOrigin: "0% 0%",
    opacity: 0
  }
}), WNe = new Pn("antSlideRightIn", {
  "0%": {
    transform: "scaleX(0.8)",
    transformOrigin: "100% 0%",
    opacity: 0
  },
  "100%": {
    transform: "scaleX(1)",
    transformOrigin: "100% 0%",
    opacity: 1
  }
}), qNe = new Pn("antSlideRightOut", {
  "0%": {
    transform: "scaleX(1)",
    transformOrigin: "100% 0%",
    opacity: 1
  },
  "100%": {
    transform: "scaleX(0.8)",
    transformOrigin: "100% 0%",
    opacity: 0
  }
}), GNe = {
  "slide-up": {
    inKeyframes: aZ,
    outKeyframes: sZ
  },
  "slide-down": {
    inKeyframes: cZ,
    outKeyframes: lZ
  },
  "slide-left": {
    inKeyframes: HNe,
    outKeyframes: UNe
  },
  "slide-right": {
    inKeyframes: WNe,
    outKeyframes: qNe
  }
}, WL = (e, t) => {
  const {
    antCls: n
  } = e, r = `${n}-${t}`, {
    inKeyframes: i,
    outKeyframes: o
  } = GNe[t];
  return [$M(r, i, o, e.motionDurationMid), {
    [`
      ${r}-enter,
      ${r}-appear
    `]: {
      transform: "scale(0)",
      transformOrigin: "0% 0%",
      opacity: 0,
      animationTimingFunction: e.motionEaseOutQuint,
      "&-prepare": {
        transform: "scale(1)"
      }
    },
    [`${r}-leave`]: {
      animationTimingFunction: e.motionEaseInQuint
    }
  }];
}, KNe = new Pn("antZoomIn", {
  "0%": {
    transform: "scale(0.2)",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    opacity: 1
  }
}), YNe = new Pn("antZoomOut", {
  "0%": {
    transform: "scale(1)"
  },
  "100%": {
    transform: "scale(0.2)",
    opacity: 0
  }
}), qL = new Pn("antZoomBigIn", {
  "0%": {
    transform: "scale(0.8)",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    opacity: 1
  }
}), GL = new Pn("antZoomBigOut", {
  "0%": {
    transform: "scale(1)"
  },
  "100%": {
    transform: "scale(0.8)",
    opacity: 0
  }
}), XNe = new Pn("antZoomUpIn", {
  "0%": {
    transform: "scale(0.8)",
    transformOrigin: "50% 0%",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    transformOrigin: "50% 0%"
  }
}), QNe = new Pn("antZoomUpOut", {
  "0%": {
    transform: "scale(1)",
    transformOrigin: "50% 0%"
  },
  "100%": {
    transform: "scale(0.8)",
    transformOrigin: "50% 0%",
    opacity: 0
  }
}), JNe = new Pn("antZoomLeftIn", {
  "0%": {
    transform: "scale(0.8)",
    transformOrigin: "0% 50%",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    transformOrigin: "0% 50%"
  }
}), ZNe = new Pn("antZoomLeftOut", {
  "0%": {
    transform: "scale(1)",
    transformOrigin: "0% 50%"
  },
  "100%": {
    transform: "scale(0.8)",
    transformOrigin: "0% 50%",
    opacity: 0
  }
}), e7e = new Pn("antZoomRightIn", {
  "0%": {
    transform: "scale(0.8)",
    transformOrigin: "100% 50%",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    transformOrigin: "100% 50%"
  }
}), t7e = new Pn("antZoomRightOut", {
  "0%": {
    transform: "scale(1)",
    transformOrigin: "100% 50%"
  },
  "100%": {
    transform: "scale(0.8)",
    transformOrigin: "100% 50%",
    opacity: 0
  }
}), n7e = new Pn("antZoomDownIn", {
  "0%": {
    transform: "scale(0.8)",
    transformOrigin: "50% 100%",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    transformOrigin: "50% 100%"
  }
}), r7e = new Pn("antZoomDownOut", {
  "0%": {
    transform: "scale(1)",
    transformOrigin: "50% 100%"
  },
  "100%": {
    transform: "scale(0.8)",
    transformOrigin: "50% 100%",
    opacity: 0
  }
}), i7e = {
  zoom: {
    inKeyframes: KNe,
    outKeyframes: YNe
  },
  "zoom-big": {
    inKeyframes: qL,
    outKeyframes: GL
  },
  "zoom-big-fast": {
    inKeyframes: qL,
    outKeyframes: GL
  },
  "zoom-left": {
    inKeyframes: JNe,
    outKeyframes: ZNe
  },
  "zoom-right": {
    inKeyframes: e7e,
    outKeyframes: t7e
  },
  "zoom-up": {
    inKeyframes: XNe,
    outKeyframes: QNe
  },
  "zoom-down": {
    inKeyframes: n7e,
    outKeyframes: r7e
  }
}, o7e = (e, t) => {
  const {
    antCls: n
  } = e, r = `${n}-${t}`, {
    inKeyframes: i,
    outKeyframes: o
  } = i7e[t];
  return [$M(r, i, o, t === "zoom-big-fast" ? e.motionDurationFast : e.motionDurationMid), {
    [`
        ${r}-enter,
        ${r}-appear
      `]: {
      transform: "scale(0)",
      opacity: 0,
      animationTimingFunction: e.motionEaseOutCirc,
      "&-prepare": {
        transform: "none"
      }
    },
    [`${r}-leave`]: {
      animationTimingFunction: e.motionEaseInOutCirc
    }
  }];
}, a7e = (e, t) => {
  const {
    r: n,
    g: r,
    b: i,
    a: o
  } = e.toRgb(), a = new vl(e.toRgbString()).onBackground(t).toHsv();
  return o <= 0.5 ? a.v > 0.5 : n * 0.299 + r * 0.587 + i * 0.114 > 192;
}, uZ = (e) => {
  const {
    paddingInline: t,
    onlyIconSize: n,
    paddingBlock: r
  } = e;
  return Mr(e, {
    buttonPaddingHorizontal: t,
    buttonPaddingVertical: r,
    buttonIconOnlyFontSize: n
  });
}, dZ = (e) => {
  var t, n, r, i, o, a;
  const s = (t = e.contentFontSize) !== null && t !== void 0 ? t : e.fontSize, c = (n = e.contentFontSizeSM) !== null && n !== void 0 ? n : e.fontSize, l = (r = e.contentFontSizeLG) !== null && r !== void 0 ? r : e.fontSizeLG, u = (i = e.contentLineHeight) !== null && i !== void 0 ? i : v_(s), d = (o = e.contentLineHeightSM) !== null && o !== void 0 ? o : v_(c), f = (a = e.contentLineHeightLG) !== null && a !== void 0 ? a : v_(l), h = a7e(new INe(e.colorBgSolid), "#fff") ? "#000" : "#fff";
  return {
    fontWeight: 400,
    defaultShadow: `0 ${e.controlOutlineWidth}px 0 ${e.controlTmpOutline}`,
    primaryShadow: `0 ${e.controlOutlineWidth}px 0 ${e.controlOutline}`,
    dangerShadow: `0 ${e.controlOutlineWidth}px 0 ${e.colorErrorOutline}`,
    primaryColor: e.colorTextLightSolid,
    dangerColor: e.colorTextLightSolid,
    borderColorDisabled: e.colorBorder,
    defaultGhostColor: e.colorBgContainer,
    ghostBg: "transparent",
    defaultGhostBorderColor: e.colorBgContainer,
    paddingInline: e.paddingContentHorizontal - e.lineWidth,
    paddingInlineLG: e.paddingContentHorizontal - e.lineWidth,
    paddingInlineSM: 8 - e.lineWidth,
    onlyIconSize: e.fontSizeLG,
    onlyIconSizeSM: e.fontSizeLG - 2,
    onlyIconSizeLG: e.fontSizeLG + 2,
    groupBorderColor: e.colorPrimaryHover,
    linkHoverBg: "transparent",
    textTextColor: e.colorText,
    textTextHoverColor: e.colorText,
    textTextActiveColor: e.colorText,
    textHoverBg: e.colorFillTertiary,
    defaultColor: e.colorText,
    defaultBg: e.colorBgContainer,
    defaultBorderColor: e.colorBorder,
    defaultBorderColorDisabled: e.colorBorder,
    defaultHoverBg: e.colorBgContainer,
    defaultHoverColor: e.colorPrimaryHover,
    defaultHoverBorderColor: e.colorPrimaryHover,
    defaultActiveBg: e.colorBgContainer,
    defaultActiveColor: e.colorPrimaryActive,
    defaultActiveBorderColor: e.colorPrimaryActive,
    solidTextColor: h,
    contentFontSize: s,
    contentFontSizeSM: c,
    contentFontSizeLG: l,
    contentLineHeight: u,
    contentLineHeightSM: d,
    contentLineHeightLG: f,
    paddingBlock: Math.max((e.controlHeight - s * u) / 2 - e.lineWidth, 0),
    paddingBlockSM: Math.max((e.controlHeightSM - c * d) / 2 - e.lineWidth, 0),
    paddingBlockLG: Math.max((e.controlHeightLG - l * f) / 2 - e.lineWidth, 0)
  };
}, s7e = (e) => {
  const {
    componentCls: t,
    iconCls: n,
    fontWeight: r
  } = e;
  return {
    [t]: {
      outline: "none",
      position: "relative",
      display: "inline-flex",
      gap: e.marginXS,
      alignItems: "center",
      justifyContent: "center",
      fontWeight: r,
      whiteSpace: "nowrap",
      textAlign: "center",
      backgroundImage: "none",
      background: "transparent",
      border: `${et(e.lineWidth)} ${e.lineType} transparent`,
      cursor: "pointer",
      transition: `all ${e.motionDurationMid} ${e.motionEaseInOut}`,
      userSelect: "none",
      touchAction: "manipulation",
      color: e.colorText,
      "&:disabled > *": {
        pointerEvents: "none"
      },
      "> span": {
        display: "inline-block"
      },
      [`${t}-icon`]: {
        lineHeight: 1
      },
      "> a": {
        color: "currentColor"
      },
      "&:not(:disabled)": Object.assign({}, O3e(e)),
      [`&${t}-two-chinese-chars::first-letter`]: {
        letterSpacing: "0.34em"
      },
      [`&${t}-two-chinese-chars > *:not(${n})`]: {
        marginInlineEnd: "-0.34em",
        letterSpacing: "0.34em"
      },
      // iconPosition="end"
      "&-icon-end": {
        flexDirection: "row-reverse"
      }
    }
  };
}, fZ = (e, t, n) => ({
  [`&:not(:disabled):not(${e}-disabled)`]: {
    "&:hover": t,
    "&:active": n
  }
}), c7e = (e) => ({
  minWidth: e.controlHeight,
  paddingInlineStart: 0,
  paddingInlineEnd: 0,
  borderRadius: "50%"
}), l7e = (e) => ({
  borderRadius: e.controlHeight,
  paddingInlineStart: e.calc(e.controlHeight).div(2).equal(),
  paddingInlineEnd: e.calc(e.controlHeight).div(2).equal()
}), u7e = (e) => ({
  cursor: "not-allowed",
  borderColor: e.borderColorDisabled,
  color: e.colorTextDisabled,
  background: e.colorBgContainerDisabled,
  boxShadow: "none"
}), AM = (e, t, n, r, i, o, a, s) => ({
  [`&${e}-background-ghost`]: Object.assign(Object.assign({
    color: n || void 0,
    background: t,
    borderColor: r || void 0,
    boxShadow: "none"
  }, fZ(e, Object.assign({
    background: t
  }, a), Object.assign({
    background: t
  }, s))), {
    "&:disabled": {
      cursor: "not-allowed",
      color: i || void 0,
      borderColor: o || void 0
    }
  })
}), d7e = (e) => ({
  [`&:disabled, &${e.componentCls}-disabled`]: Object.assign({}, u7e(e))
}), f7e = (e) => ({
  [`&:disabled, &${e.componentCls}-disabled`]: {
    cursor: "not-allowed",
    color: e.colorTextDisabled
  }
}), WE = (e, t, n, r) => {
  const o = r && ["link", "text"].includes(r) ? f7e : d7e;
  return Object.assign(Object.assign({}, o(e)), fZ(e.componentCls, t, n));
}, RM = (e, t, n, r, i) => ({
  [`&${e.componentCls}-variant-solid`]: Object.assign({
    color: t,
    background: n
  }, WE(e, r, i))
}), PM = (e, t, n, r, i) => ({
  [`&${e.componentCls}-variant-outlined, &${e.componentCls}-variant-dashed`]: Object.assign({
    borderColor: t,
    background: n
  }, WE(e, r, i))
}), OM = (e) => ({
  [`&${e.componentCls}-variant-dashed`]: {
    borderStyle: "dashed"
  }
}), MM = (e, t, n, r) => ({
  [`&${e.componentCls}-variant-filled`]: Object.assign({
    boxShadow: "none",
    background: t
  }, WE(e, n, r))
}), Zg = (e, t, n, r, i) => ({
  [`&${e.componentCls}-variant-${n}`]: Object.assign({
    color: t,
    boxShadow: "none"
  }, WE(e, r, i, n))
}), h7e = (e) => Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
  color: e.defaultColor,
  boxShadow: e.defaultShadow
}, RM(e, e.solidTextColor, e.colorBgSolid, {
  background: e.colorBgSolidHover
}, {
  background: e.colorBgSolidActive
})), OM(e)), MM(e, e.colorFillTertiary, {
  background: e.colorFillSecondary
}, {
  background: e.colorFill
})), Zg(e, e.textTextColor, "link", {
  color: e.colorLinkHover,
  background: e.linkHoverBg
}, {
  color: e.colorLinkActive
})), AM(e.componentCls, e.ghostBg, e.defaultGhostColor, e.defaultGhostBorderColor, e.colorTextDisabled, e.colorBorder)), g7e = (e) => Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
  color: e.colorPrimary,
  boxShadow: e.primaryShadow
}, PM(e, e.colorPrimary, e.colorBgContainer, {
  color: e.colorPrimaryTextHover,
  borderColor: e.colorPrimaryHover,
  background: e.colorBgContainer
}, {
  color: e.colorPrimaryTextActive,
  borderColor: e.colorPrimaryActive,
  background: e.colorBgContainer
})), OM(e)), MM(e, e.colorPrimaryBg, {
  background: e.colorPrimaryBgHover
}, {
  background: e.colorPrimaryBorder
})), Zg(e, e.colorLink, "text", {
  color: e.colorPrimaryTextHover,
  background: e.colorPrimaryBg
}, {
  color: e.colorPrimaryTextActive,
  background: e.colorPrimaryBorder
})), AM(e.componentCls, e.ghostBg, e.colorPrimary, e.colorPrimary, e.colorTextDisabled, e.colorBorder, {
  color: e.colorPrimaryHover,
  borderColor: e.colorPrimaryHover
}, {
  color: e.colorPrimaryActive,
  borderColor: e.colorPrimaryActive
})), p7e = (e) => Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
  color: e.colorError,
  boxShadow: e.dangerShadow
}, RM(e, e.dangerColor, e.colorError, {
  background: e.colorErrorHover
}, {
  background: e.colorErrorActive
})), PM(e, e.colorError, e.colorBgContainer, {
  color: e.colorErrorHover,
  borderColor: e.colorErrorBorderHover
}, {
  color: e.colorErrorActive,
  borderColor: e.colorErrorActive
})), OM(e)), MM(e, e.colorErrorBg, {
  background: e.colorErrorBgFilledHover
}, {
  background: e.colorErrorBgActive
})), Zg(e, e.colorError, "text", {
  color: e.colorErrorHover,
  background: e.colorErrorBg
}, {
  color: e.colorErrorHover,
  background: e.colorErrorBgActive
})), Zg(e, e.colorError, "link", {
  color: e.colorErrorHover
}, {
  color: e.colorErrorActive
})), AM(e.componentCls, e.ghostBg, e.colorError, e.colorError, e.colorTextDisabled, e.colorBorder, {
  color: e.colorErrorHover,
  borderColor: e.colorErrorHover
}, {
  color: e.colorErrorActive,
  borderColor: e.colorErrorActive
})), m7e = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}-color-default`]: h7e(e),
    [`${t}-color-primary`]: g7e(e),
    [`${t}-color-dangerous`]: p7e(e)
  };
}, v7e = (e) => Object.assign(Object.assign(Object.assign(Object.assign({}, PM(e, e.defaultBorderColor, e.defaultBg, {
  color: e.defaultHoverColor,
  borderColor: e.defaultHoverBorderColor,
  background: e.defaultHoverBg
}, {
  color: e.defaultActiveColor,
  borderColor: e.defaultActiveBorderColor,
  background: e.defaultActiveBg
})), Zg(e, e.textTextColor, "text", {
  color: e.textTextHoverColor,
  background: e.textHoverBg
}, {
  color: e.textTextActiveColor,
  background: e.colorBgTextActive
})), RM(e, e.primaryColor, e.colorPrimary, {
  background: e.colorPrimaryHover,
  color: e.primaryColor
}, {
  background: e.colorPrimaryActive,
  color: e.primaryColor
})), Zg(e, e.colorLink, "link", {
  color: e.colorLinkHover,
  background: e.linkHoverBg
}, {
  color: e.colorLinkActive
})), kM = function(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
  const {
    componentCls: n,
    controlHeight: r,
    fontSize: i,
    lineHeight: o,
    borderRadius: a,
    buttonPaddingHorizontal: s,
    iconCls: c,
    buttonPaddingVertical: l
  } = e, u = `${n}-icon-only`;
  return [
    {
      [t]: {
        fontSize: i,
        lineHeight: o,
        height: r,
        padding: `${et(l)} ${et(s)}`,
        borderRadius: a,
        [`&${u}`]: {
          width: r,
          paddingInline: 0,
          // make `btn-icon-only` not too narrow
          [`&${n}-compact-item`]: {
            flex: "none"
          },
          [`&${n}-round`]: {
            width: "auto"
          },
          [c]: {
            fontSize: e.buttonIconOnlyFontSize
          }
        },
        // Loading
        [`&${n}-loading`]: {
          opacity: e.opacityLoading,
          cursor: "default"
        },
        [`${n}-loading-icon`]: {
          transition: `width ${e.motionDurationSlow} ${e.motionEaseInOut}, opacity ${e.motionDurationSlow} ${e.motionEaseInOut}`
        }
      }
    },
    // Shape - patch prefixCls again to override solid border radius style
    {
      [`${n}${n}-circle${t}`]: c7e(e)
    },
    {
      [`${n}${n}-round${t}`]: l7e(e)
    }
  ];
}, y7e = (e) => {
  const t = Mr(e, {
    fontSize: e.contentFontSize,
    lineHeight: e.contentLineHeight
  });
  return kM(t, e.componentCls);
}, b7e = (e) => {
  const t = Mr(e, {
    controlHeight: e.controlHeightSM,
    fontSize: e.contentFontSizeSM,
    lineHeight: e.contentLineHeightSM,
    padding: e.paddingXS,
    buttonPaddingHorizontal: e.paddingInlineSM,
    buttonPaddingVertical: e.paddingBlockSM,
    borderRadius: e.borderRadiusSM,
    buttonIconOnlyFontSize: e.onlyIconSizeSM
  });
  return kM(t, `${e.componentCls}-sm`);
}, _7e = (e) => {
  const t = Mr(e, {
    controlHeight: e.controlHeightLG,
    fontSize: e.contentFontSizeLG,
    lineHeight: e.contentLineHeightLG,
    buttonPaddingHorizontal: e.paddingInlineLG,
    buttonPaddingVertical: e.paddingBlockLG,
    borderRadius: e.borderRadiusLG,
    buttonIconOnlyFontSize: e.onlyIconSizeLG
  });
  return kM(t, `${e.componentCls}-lg`);
}, S7e = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [t]: {
      [`&${t}-block`]: {
        width: "100%"
      }
    }
  };
}, w7e = Za("Button", (e) => {
  const t = uZ(e);
  return [
    // Shared
    s7e(t),
    // Size
    y7e(t),
    b7e(t),
    _7e(t),
    // Block
    S7e(t),
    // Color
    m7e(t),
    // https://github.com/ant-design/ant-design/issues/50969
    v7e(t),
    // Button Group
    uNe(t)
  ];
}, dZ, {
  unitless: {
    fontWeight: !0,
    contentLineHeight: !0,
    contentLineHeightSM: !0,
    contentLineHeightLG: !0
  }
});
function x7e(e, t, n) {
  const {
    focusElCls: r,
    focus: i,
    borderElCls: o
  } = n, a = o ? "> *" : "", s = ["hover", i ? "focus" : null, "active"].filter(Boolean).map((c) => `&:${c} ${a}`).join(",");
  return {
    [`&-item:not(${t}-last-item)`]: {
      marginInlineEnd: e.calc(e.lineWidth).mul(-1).equal()
    },
    "&-item": Object.assign(Object.assign({
      [s]: {
        zIndex: 2
      }
    }, r ? {
      [`&${r}`]: {
        zIndex: 2
      }
    } : {}), {
      [`&[disabled] ${a}`]: {
        zIndex: 0
      }
    })
  };
}
function E7e(e, t, n) {
  const {
    borderElCls: r
  } = n, i = r ? `> ${r}` : "";
  return {
    [`&-item:not(${t}-first-item):not(${t}-last-item) ${i}`]: {
      borderRadius: 0
    },
    [`&-item:not(${t}-last-item)${t}-first-item`]: {
      [`& ${i}, &${e}-sm ${i}, &${e}-lg ${i}`]: {
        borderStartEndRadius: 0,
        borderEndEndRadius: 0
      }
    },
    [`&-item:not(${t}-first-item)${t}-last-item`]: {
      [`& ${i}, &${e}-sm ${i}, &${e}-lg ${i}`]: {
        borderStartStartRadius: 0,
        borderEndStartRadius: 0
      }
    }
  };
}
function qE(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    focus: !0
  };
  const {
    componentCls: n
  } = e, r = `${n}-compact`;
  return {
    [r]: Object.assign(Object.assign({}, x7e(e, r, t)), E7e(n, r, t))
  };
}
function C7e(e, t) {
  return {
    // border collapse
    [`&-item:not(${t}-last-item)`]: {
      marginBottom: e.calc(e.lineWidth).mul(-1).equal()
    },
    "&-item": {
      "&:hover,&:focus,&:active": {
        zIndex: 2
      },
      "&[disabled]": {
        zIndex: 0
      }
    }
  };
}
function T7e(e, t) {
  return {
    [`&-item:not(${t}-first-item):not(${t}-last-item)`]: {
      borderRadius: 0
    },
    [`&-item${t}-first-item:not(${t}-last-item)`]: {
      [`&, &${e}-sm, &${e}-lg`]: {
        borderEndEndRadius: 0,
        borderEndStartRadius: 0
      }
    },
    [`&-item${t}-last-item:not(${t}-first-item)`]: {
      [`&, &${e}-sm, &${e}-lg`]: {
        borderStartStartRadius: 0,
        borderStartEndRadius: 0
      }
    }
  };
}
function I7e(e) {
  const t = `${e.componentCls}-compact-vertical`;
  return {
    [t]: Object.assign(Object.assign({}, C7e(e, t)), T7e(e.componentCls, t))
  };
}
const $7e = (e) => {
  const {
    componentCls: t,
    calc: n
  } = e;
  return {
    [t]: {
      // Special styles for Primary Button
      [`&-compact-item${t}-primary`]: {
        [`&:not([disabled]) + ${t}-compact-item${t}-primary:not([disabled])`]: {
          position: "relative",
          "&:before": {
            position: "absolute",
            top: n(e.lineWidth).mul(-1).equal(),
            insetInlineStart: n(e.lineWidth).mul(-1).equal(),
            display: "inline-block",
            width: e.lineWidth,
            height: `calc(100% + ${et(e.lineWidth)} * 2)`,
            backgroundColor: e.colorPrimaryHover,
            content: '""'
          }
        }
      },
      // Special styles for Primary Button
      "&-compact-vertical-item": {
        [`&${t}-primary`]: {
          [`&:not([disabled]) + ${t}-compact-vertical-item${t}-primary:not([disabled])`]: {
            position: "relative",
            "&:before": {
              position: "absolute",
              top: n(e.lineWidth).mul(-1).equal(),
              insetInlineStart: n(e.lineWidth).mul(-1).equal(),
              display: "inline-block",
              width: `calc(100% + ${et(e.lineWidth)} * 2)`,
              height: e.lineWidth,
              backgroundColor: e.colorPrimaryHover,
              content: '""'
            }
          }
        }
      }
    }
  };
}, A7e = N3e(["Button", "compact"], (e) => {
  const t = uZ(e);
  return [
    // Space Compact
    qE(t),
    I7e(t),
    $7e(t)
  ];
}, dZ);
var R7e = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
function P7e(e) {
  if (typeof e == "object" && e) {
    let t = e == null ? void 0 : e.delay;
    return t = !Number.isNaN(t) && typeof t == "number" ? t : 0, {
      loading: t <= 0,
      delay: t
    };
  }
  return {
    loading: !!e,
    delay: 0
  };
}
const O7e = {
  default: ["default", "outlined"],
  primary: ["primary", "solid"],
  dashed: ["default", "dashed"],
  link: ["primary", "link"],
  text: ["default", "text"]
}, M7e = /* @__PURE__ */ j.forwardRef((e, t) => {
  var n, r, i, o;
  const {
    loading: a = !1,
    prefixCls: s,
    color: c,
    variant: l,
    type: u,
    danger: d = !1,
    shape: f = "default",
    size: h,
    styles: p,
    disabled: g,
    className: m,
    rootClassName: v,
    children: y,
    icon: _,
    iconPosition: b = "start",
    ghost: w = !1,
    block: C = !1,
    // React does not recognize the `htmlType` prop on a DOM element. Here we pick it out of `rest`.
    htmlType: x = "button",
    classNames: T,
    style: E = {},
    autoInsertSpace: R
  } = e, I = R7e(e, ["loading", "prefixCls", "color", "variant", "type", "danger", "shape", "size", "styles", "disabled", "className", "rootClassName", "children", "icon", "iconPosition", "ghost", "block", "htmlType", "classNames", "style", "autoInsertSpace"]), O = u || "default", [P, k] = Tt(() => {
    if (c && l)
      return [c, l];
    const vt = O7e[O] || [];
    return d ? ["danger", vt[1]] : vt;
  }, [u, c, l, d]), N = P === "danger" ? "dangerous" : P, {
    getPrefixCls: D,
    direction: z,
    button: V
  } = gt(Cn), B = (n = R ?? (V == null ? void 0 : V.autoInsertSpace)) !== null && n !== void 0 ? n : !0, U = D("btn", s), [Q, Y, q] = w7e(U), X = gt(id), ne = g ?? X, Z = gt(QJ), J = Tt(() => P7e(a), [a]), [K, ee] = Qe(J.loading), [te, H] = Qe(!1), W = Ja(t, /* @__PURE__ */ Ole()), se = Ple.count(y) === 1 && !_ && !p1(k);
  ot(() => {
    let vt = null;
    J.delay > 0 ? vt = setTimeout(() => {
      vt = null, ee(!0);
    }, J.delay) : ee(J.loading);
    function ke() {
      vt && (clearTimeout(vt), vt = null);
    }
    return ke;
  }, [J]), ot(() => {
    if (!W || !W.current || !B)
      return;
    const vt = W.current.textContent;
    se && sR(vt) ? te || H(!0) : te && H(!1);
  }, [W]);
  const le = j.useCallback((vt) => {
    var ke;
    if (K || ne) {
      vt.preventDefault();
      return;
    }
    (ke = e.onClick) === null || ke === void 0 || ke.call(e, vt);
  }, [e.onClick, K, ne]);
  if (process.env.NODE_ENV !== "production") {
    const vt = di("Button");
    process.env.NODE_ENV !== "production" && vt(!(typeof _ == "string" && _.length > 2), "breaking", `\`icon\` is using ReactNode instead of string naming in v4. Please check \`${_}\` at https://ant.design/components/icon`), process.env.NODE_ENV !== "production" && vt(!(w && p1(k)), "usage", "`link` or `text` button can't be a `ghost` button.");
  }
  const {
    compactSize: ge,
    compactItemClassnames: me
  } = Ry(U, z), pe = {
    large: "lg",
    small: "sm",
    middle: void 0
  }, Te = Gf((vt) => {
    var ke, xe;
    return (xe = (ke = h ?? ge) !== null && ke !== void 0 ? ke : Z) !== null && xe !== void 0 ? xe : vt;
  }), de = Te && (r = pe[Te]) !== null && r !== void 0 ? r : "", Ae = K ? "loading" : _, ue = rd(I, ["navigate"]), be = Ee(U, Y, q, {
    [`${U}-${f}`]: f !== "default" && f,
    // line(253 - 254): Compatible with versions earlier than 5.21.0
    [`${U}-${O}`]: O,
    [`${U}-dangerous`]: d,
    [`${U}-color-${N}`]: N,
    [`${U}-variant-${k}`]: k,
    [`${U}-${de}`]: de,
    [`${U}-icon-only`]: !y && y !== 0 && !!Ae,
    [`${U}-background-ghost`]: w && !p1(k),
    [`${U}-loading`]: K,
    [`${U}-two-chinese-chars`]: te && B && !K,
    [`${U}-block`]: C,
    [`${U}-rtl`]: z === "rtl",
    [`${U}-icon-end`]: b === "end"
  }, me, m, v, V == null ? void 0 : V.className), Ie = Object.assign(Object.assign({}, V == null ? void 0 : V.style), E), Ve = Ee(T == null ? void 0 : T.icon, (i = V == null ? void 0 : V.classNames) === null || i === void 0 ? void 0 : i.icon), ze = Object.assign(Object.assign({}, (p == null ? void 0 : p.icon) || {}), ((o = V == null ? void 0 : V.styles) === null || o === void 0 ? void 0 : o.icon) || {}), Ne = _ && !K ? /* @__PURE__ */ j.createElement(JJ, {
    prefixCls: U,
    className: Ve,
    style: ze
  }, _) : /* @__PURE__ */ j.createElement(cNe, {
    existIcon: !!_,
    prefixCls: U,
    loading: K
  }), lt = y || y === 0 ? oNe(y, se && B) : null;
  if (ue.href !== void 0)
    return Q(/* @__PURE__ */ j.createElement("a", Object.assign({}, ue, {
      className: Ee(be, {
        [`${U}-disabled`]: ne
      }),
      href: ne ? void 0 : ue.href,
      style: Ie,
      onClick: le,
      ref: W,
      tabIndex: ne ? -1 : 0
    }), Ne, lt));
  let mt = /* @__PURE__ */ j.createElement("button", Object.assign({}, I, {
    type: x,
    className: be,
    style: Ie,
    onClick: le,
    disabled: ne,
    ref: W
  }), Ne, lt, !!me && /* @__PURE__ */ j.createElement(A7e, {
    key: "compact",
    prefixCls: U
  }));
  return p1(k) || (mt = /* @__PURE__ */ j.createElement(J4e, {
    component: "Button",
    disabled: K
  }, mt)), Q(mt);
}), GE = M7e;
GE.Group = rNe;
GE.__ANT_BUTTON = !0;
process.env.NODE_ENV !== "production" && (GE.displayName = "Button");
const k7e = GE;
var hZ = /* @__PURE__ */ $.createContext(null), KL = [];
function N7e(e, t) {
  var n = $.useState(function() {
    if (!uo())
      return null;
    var p = document.createElement("div");
    return process.env.NODE_ENV !== "production" && t && p.setAttribute("data-debug", t), p;
  }), r = he(n, 1), i = r[0], o = $.useRef(!1), a = $.useContext(hZ), s = $.useState(KL), c = he(s, 2), l = c[0], u = c[1], d = a || (o.current ? void 0 : function(p) {
    u(function(g) {
      var m = [p].concat(tt(g));
      return m;
    });
  });
  function f() {
    i.parentElement || document.body.appendChild(i), o.current = !0;
  }
  function h() {
    var p;
    (p = i.parentElement) === null || p === void 0 || p.removeChild(i), o.current = !1;
  }
  return ar(function() {
    return e ? a ? a(f) : f() : h(), h;
  }, [e]), ar(function() {
    l.length && (l.forEach(function(p) {
      return p();
    }), u(KL));
  }, [l]), [i, d];
}
function D7e(e) {
  var t = "rc-scrollbar-measure-".concat(Math.random().toString(36).substring(7)), n = document.createElement("div");
  n.id = t;
  var r = n.style;
  r.position = "absolute", r.left = "0", r.top = "0", r.width = "100px", r.height = "100px", r.overflow = "scroll";
  var i, o;
  if (e) {
    var a = getComputedStyle(e);
    r.scrollbarColor = a.scrollbarColor, r.scrollbarWidth = a.scrollbarWidth;
    var s = getComputedStyle(e, "::-webkit-scrollbar"), c = parseInt(s.width, 10), l = parseInt(s.height, 10);
    try {
      var u = c ? "width: ".concat(s.width, ";") : "", d = l ? "height: ".concat(s.height, ";") : "";
      mc(`
#`.concat(t, `::-webkit-scrollbar {
`).concat(u, `
`).concat(d, `
}`), t);
    } catch (p) {
      console.error(p), i = c, o = l;
    }
  }
  document.body.appendChild(n);
  var f = e && i && !isNaN(i) ? i : n.offsetWidth - n.clientWidth, h = e && o && !isNaN(o) ? o : n.offsetHeight - n.clientHeight;
  return document.body.removeChild(n), Hg(t), {
    width: f,
    height: h
  };
}
function j7e(e) {
  return typeof document > "u" || !e || !(e instanceof Element) ? {
    width: 0,
    height: 0
  } : D7e(e);
}
function L7e() {
  return document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight) && window.innerWidth > document.body.offsetWidth;
}
var F7e = "rc-util-locker-".concat(Date.now()), YL = 0;
function V7e(e) {
  var t = !!e, n = $.useState(function() {
    return YL += 1, "".concat(F7e, "_").concat(YL);
  }), r = he(n, 1), i = r[0];
  ar(function() {
    if (t) {
      var o = j7e(document.body).width, a = L7e();
      mc(`
html body {
  overflow-y: hidden;
  `.concat(a ? "width: calc(100% - ".concat(o, "px);") : "", `
}`), i);
    } else
      Hg(i);
    return function() {
      Hg(i);
    };
  }, [t, i]);
}
var XL = !1;
function B7e(e) {
  return typeof e == "boolean" && (XL = e), XL;
}
var QL = function(t) {
  return t === !1 ? !1 : !uo() || !t ? null : typeof t == "string" ? document.querySelector(t) : typeof t == "function" ? t() : t;
}, NM = /* @__PURE__ */ $.forwardRef(function(e, t) {
  var n = e.open, r = e.autoLock, i = e.getContainer, o = e.debug, a = e.autoDestroy, s = a === void 0 ? !0 : a, c = e.children, l = $.useState(n), u = he(l, 2), d = u[0], f = u[1], h = d || n;
  process.env.NODE_ENV !== "production" && sn(uo() || !n, "Portal only work in client side. Please call 'useEffect' to show Portal instead default render in SSR."), $.useEffect(function() {
    (s || n) && f(n);
  }, [n, s]);
  var p = $.useState(function() {
    return QL(i);
  }), g = he(p, 2), m = g[0], v = g[1];
  $.useEffect(function() {
    var O = QL(i);
    v(O ?? null);
  });
  var y = N7e(h && !m, o), _ = he(y, 2), b = _[0], w = _[1], C = m ?? b;
  V7e(r && n && uo() && (C === b || C === document.body));
  var x = null;
  if (c && $y(c) && t) {
    var T = c;
    x = T.ref;
  }
  var E = AE(x, t);
  if (!h || !uo() || m === void 0)
    return null;
  var R = C === !1 || B7e(), I = c;
  return t && (I = /* @__PURE__ */ $.cloneElement(c, {
    ref: E
  })), /* @__PURE__ */ $.createElement(hZ.Provider, {
    value: w
  }, R ? I : /* @__PURE__ */ rO(I, C));
});
process.env.NODE_ENV !== "production" && (NM.displayName = "Portal");
function z7e() {
  var e = ae({}, $);
  return e.useId;
}
var JL = 0, ZL = z7e();
const H7e = ZL ? (
  // Use React `useId`
  function(t) {
    var n = ZL();
    return t || (process.env.NODE_ENV === "test" ? "test-id" : n);
  }
) : (
  // Use compatible of `useId`
  function(t) {
    var n = $.useState("ssr-id"), r = he(n, 2), i = r[0], o = r[1];
    return $.useEffect(function() {
      var a = JL;
      JL += 1, o("rc_unique_".concat(a));
    }, []), t || (process.env.NODE_ENV === "test" ? "test-id" : i);
  }
);
var jd = "RC_FORM_INTERNAL_HOOKS", Zn = function() {
  sn(!1, "Can not find FormContext. Please make sure you wrap Field under Form.");
}, Ef = /* @__PURE__ */ $.createContext({
  getFieldValue: Zn,
  getFieldsValue: Zn,
  getFieldError: Zn,
  getFieldWarning: Zn,
  getFieldsError: Zn,
  isFieldsTouched: Zn,
  isFieldTouched: Zn,
  isFieldValidating: Zn,
  isFieldsValidating: Zn,
  resetFields: Zn,
  setFields: Zn,
  setFieldValue: Zn,
  setFieldsValue: Zn,
  validateFields: Zn,
  submit: Zn,
  getInternalHooks: function() {
    return Zn(), {
      dispatch: Zn,
      initEntityValue: Zn,
      registerField: Zn,
      useSubscribe: Zn,
      setInitialValues: Zn,
      destroyForm: Zn,
      setCallbacks: Zn,
      registerWatch: Zn,
      getFields: Zn,
      setValidateMessages: Zn,
      setPreserve: Zn,
      getInitialValue: Zn
    };
  }
}), Rv = /* @__PURE__ */ $.createContext(null);
function cR(e) {
  return e == null ? [] : Array.isArray(e) ? e : [e];
}
function U7e(e) {
  return e && !!e._init;
}
function lR() {
  return {
    default: "Validation error on field %s",
    required: "%s is required",
    enum: "%s must be one of %s",
    whitespace: "%s cannot be empty",
    date: {
      format: "%s date %s is invalid for format %s",
      parse: "%s date could not be parsed, %s is invalid ",
      invalid: "%s date %s is invalid"
    },
    types: {
      string: "%s is not a %s",
      method: "%s is not a %s (function)",
      array: "%s is not an %s",
      object: "%s is not an %s",
      number: "%s is not a %s",
      date: "%s is not a %s",
      boolean: "%s is not a %s",
      integer: "%s is not an %s",
      float: "%s is not a %s",
      regexp: "%s is not a valid %s",
      email: "%s is not a valid %s",
      url: "%s is not a valid %s",
      hex: "%s is not a valid %s"
    },
    string: {
      len: "%s must be exactly %s characters",
      min: "%s must be at least %s characters",
      max: "%s cannot be longer than %s characters",
      range: "%s must be between %s and %s characters"
    },
    number: {
      len: "%s must equal %s",
      min: "%s cannot be less than %s",
      max: "%s cannot be greater than %s",
      range: "%s must be between %s and %s"
    },
    array: {
      len: "%s must be exactly %s in length",
      min: "%s cannot be less than %s in length",
      max: "%s cannot be greater than %s in length",
      range: "%s must be between %s and %s in length"
    },
    pattern: {
      mismatch: "%s value %s does not match pattern %s"
    },
    clone: function() {
      var t = JSON.parse(JSON.stringify(this));
      return t.clone = this.clone, t;
    }
  };
}
var uR = lR();
function W7e(e) {
  try {
    return Function.toString.call(e).indexOf("[native code]") !== -1;
  } catch {
    return typeof e == "function";
  }
}
function q7e(e, t, n) {
  if (PE())
    return Reflect.construct.apply(null, arguments);
  var r = [null];
  r.push.apply(r, t);
  var i = new (e.bind.apply(e, r))();
  return n && Sv(i, n.prototype), i;
}
function dR(e) {
  var t = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return dR = function(r) {
    if (r === null || !W7e(r))
      return r;
    if (typeof r != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (t !== void 0) {
      if (t.has(r))
        return t.get(r);
      t.set(r, i);
    }
    function i() {
      return q7e(r, arguments, wf(this).constructor);
    }
    return i.prototype = Object.create(r.prototype, {
      constructor: {
        value: i,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), Sv(i, r);
  }, dR(e);
}
var G7e = /%[sdj%]/g, gZ = function() {
};
typeof process < "u" && process.env && process.env.NODE_ENV !== "production" && typeof window < "u" && typeof document < "u" && (gZ = function(t, n) {
  typeof console < "u" && console.warn && typeof ASYNC_VALIDATOR_NO_WARNING > "u" && n.every(function(r) {
    return typeof r == "string";
  }) && console.warn(t, n);
});
function fR(e) {
  if (!e || !e.length)
    return null;
  var t = {};
  return e.forEach(function(n) {
    var r = n.field;
    t[r] = t[r] || [], t[r].push(n);
  }), t;
}
function ya(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  var i = 0, o = n.length;
  if (typeof e == "function")
    return e.apply(null, n);
  if (typeof e == "string") {
    var a = e.replace(G7e, function(s) {
      if (s === "%%")
        return "%";
      if (i >= o)
        return s;
      switch (s) {
        case "%s":
          return String(n[i++]);
        case "%d":
          return Number(n[i++]);
        case "%j":
          try {
            return JSON.stringify(n[i++]);
          } catch {
            return "[Circular]";
          }
          break;
        default:
          return s;
      }
    });
    return a;
  }
  return e;
}
function K7e(e) {
  return e === "string" || e === "url" || e === "hex" || e === "email" || e === "date" || e === "pattern";
}
function Ei(e, t) {
  return !!(e == null || t === "array" && Array.isArray(e) && !e.length || K7e(t) && typeof e == "string" && !e);
}
function Y7e(e, t, n) {
  var r = [], i = 0, o = e.length;
  function a(s) {
    r.push.apply(r, tt(s || [])), i++, i === o && n(r);
  }
  e.forEach(function(s) {
    t(s, a);
  });
}
function eF(e, t, n) {
  var r = 0, i = e.length;
  function o(a) {
    if (a && a.length) {
      n(a);
      return;
    }
    var s = r;
    r = r + 1, s < i ? t(e[s], o) : n([]);
  }
  o([]);
}
function X7e(e) {
  var t = [];
  return Object.keys(e).forEach(function(n) {
    t.push.apply(t, tt(e[n] || []));
  }), t;
}
var tF = /* @__PURE__ */ function(e) {
  Ds(n, e);
  var t = Ac(n);
  function n(r, i) {
    var o;
    return xr(this, n), o = t.call(this, "Async Validation Error"), oe(rn(o), "errors", void 0), oe(rn(o), "fields", void 0), o.errors = r, o.fields = i, o;
  }
  return Er(n);
}(/* @__PURE__ */ dR(Error));
function Q7e(e, t, n, r, i) {
  if (t.first) {
    var o = new Promise(function(f, h) {
      var p = function(v) {
        return r(v), v.length ? h(new tF(v, fR(v))) : f(i);
      }, g = X7e(e);
      eF(g, n, p);
    });
    return o.catch(function(f) {
      return f;
    }), o;
  }
  var a = t.firstFields === !0 ? Object.keys(e) : t.firstFields || [], s = Object.keys(e), c = s.length, l = 0, u = [], d = new Promise(function(f, h) {
    var p = function(m) {
      if (u.push.apply(u, m), l++, l === c)
        return r(u), u.length ? h(new tF(u, fR(u))) : f(i);
    };
    s.length || (r(u), f(i)), s.forEach(function(g) {
      var m = e[g];
      a.indexOf(g) !== -1 ? eF(m, n, p) : Y7e(m, n, p);
    });
  });
  return d.catch(function(f) {
    return f;
  }), d;
}
function J7e(e) {
  return !!(e && e.message !== void 0);
}
function Z7e(e, t) {
  for (var n = e, r = 0; r < t.length; r++) {
    if (n == null)
      return n;
    n = n[t[r]];
  }
  return n;
}
function nF(e, t) {
  return function(n) {
    var r;
    return e.fullFields ? r = Z7e(t, e.fullFields) : r = t[n.field || e.fullField], J7e(n) ? (n.field = n.field || e.fullField, n.fieldValue = r, n) : {
      message: typeof n == "function" ? n() : n,
      fieldValue: r,
      field: n.field || e.fullField
    };
  };
}
function rF(e, t) {
  if (t) {
    for (var n in t)
      if (t.hasOwnProperty(n)) {
        var r = t[n];
        It(r) === "object" && It(e[n]) === "object" ? e[n] = ae(ae({}, e[n]), r) : e[n] = r;
      }
  }
  return e;
}
var bh = "enum", eDe = function(t, n, r, i, o) {
  t[bh] = Array.isArray(t[bh]) ? t[bh] : [], t[bh].indexOf(n) === -1 && i.push(ya(o.messages[bh], t.fullField, t[bh].join(", ")));
}, tDe = function(t, n, r, i, o) {
  if (t.pattern) {
    if (t.pattern instanceof RegExp)
      t.pattern.lastIndex = 0, t.pattern.test(n) || i.push(ya(o.messages.pattern.mismatch, t.fullField, n, t.pattern));
    else if (typeof t.pattern == "string") {
      var a = new RegExp(t.pattern);
      a.test(n) || i.push(ya(o.messages.pattern.mismatch, t.fullField, n, t.pattern));
    }
  }
}, nDe = function(t, n, r, i, o) {
  var a = typeof t.len == "number", s = typeof t.min == "number", c = typeof t.max == "number", l = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g, u = n, d = null, f = typeof n == "number", h = typeof n == "string", p = Array.isArray(n);
  if (f ? d = "number" : h ? d = "string" : p && (d = "array"), !d)
    return !1;
  p && (u = n.length), h && (u = n.replace(l, "_").length), a ? u !== t.len && i.push(ya(o.messages[d].len, t.fullField, t.len)) : s && !c && u < t.min ? i.push(ya(o.messages[d].min, t.fullField, t.min)) : c && !s && u > t.max ? i.push(ya(o.messages[d].max, t.fullField, t.max)) : s && c && (u < t.min || u > t.max) && i.push(ya(o.messages[d].range, t.fullField, t.min, t.max));
}, pZ = function(t, n, r, i, o, a) {
  t.required && (!r.hasOwnProperty(t.field) || Ei(n, a || t.type)) && i.push(ya(o.messages.required, t.fullField));
}, m1;
const rDe = function() {
  if (m1)
    return m1;
  var e = "[a-fA-F\\d:]", t = function(C) {
    return C && C.includeBoundaries ? "(?:(?<=\\s|^)(?=".concat(e, ")|(?<=").concat(e, ")(?=\\s|$))") : "";
  }, n = "(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}", r = "[a-fA-F\\d]{1,4}", i = [
    "(?:".concat(r, ":){7}(?:").concat(r, "|:)"),
    // 1:2:3:4:5:6:7::  1:2:3:4:5:6:7:8
    "(?:".concat(r, ":){6}(?:").concat(n, "|:").concat(r, "|:)"),
    // 1:2:3:4:5:6::    1:2:3:4:5:6::8   1:2:3:4:5:6::8  1:2:3:4:5:6::
    "(?:".concat(r, ":){5}(?::").concat(n, "|(?::").concat(r, "){1,2}|:)"),
    // 1:2:3:4:5::      1:2:3:4:5::7:8   1:2:3:4:5::8    1:2:3:4:5::
    "(?:".concat(r, ":){4}(?:(?::").concat(r, "){0,1}:").concat(n, "|(?::").concat(r, "){1,3}|:)"),
    // 1:2:3:4::        1:2:3:4::6:7:8   1:2:3:4::8      1:2:3:4::
    "(?:".concat(r, ":){3}(?:(?::").concat(r, "){0,2}:").concat(n, "|(?::").concat(r, "){1,4}|:)"),
    // 1:2:3::          1:2:3::5:6:7:8   1:2:3::8        1:2:3::
    "(?:".concat(r, ":){2}(?:(?::").concat(r, "){0,3}:").concat(n, "|(?::").concat(r, "){1,5}|:)"),
    // 1:2::            1:2::4:5:6:7:8   1:2::8          1:2::
    "(?:".concat(r, ":){1}(?:(?::").concat(r, "){0,4}:").concat(n, "|(?::").concat(r, "){1,6}|:)"),
    // 1::              1::3:4:5:6:7:8   1::8            1::
    "(?::(?:(?::".concat(r, "){0,5}:").concat(n, "|(?::").concat(r, "){1,7}|:))")
    // ::2:3:4:5:6:7:8  ::2:3:4:5:6:7:8  ::8             ::
  ], o = "(?:%[0-9a-zA-Z]{1,})?", a = "(?:".concat(i.join("|"), ")").concat(o), s = new RegExp("(?:^".concat(n, "$)|(?:^").concat(a, "$)")), c = new RegExp("^".concat(n, "$")), l = new RegExp("^".concat(a, "$")), u = function(C) {
    return C && C.exact ? s : new RegExp("(?:".concat(t(C)).concat(n).concat(t(C), ")|(?:").concat(t(C)).concat(a).concat(t(C), ")"), "g");
  };
  u.v4 = function(w) {
    return w && w.exact ? c : new RegExp("".concat(t(w)).concat(n).concat(t(w)), "g");
  }, u.v6 = function(w) {
    return w && w.exact ? l : new RegExp("".concat(t(w)).concat(a).concat(t(w)), "g");
  };
  var d = "(?:(?:[a-z]+:)?//)", f = "(?:\\S+(?::\\S*)?@)?", h = u.v4().source, p = u.v6().source, g = "(?:(?:[a-z\\u00a1-\\uffff0-9][-_]*)*[a-z\\u00a1-\\uffff0-9]+)", m = "(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*", v = "(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))", y = "(?::\\d{2,5})?", _ = '(?:[/?#][^\\s"]*)?', b = "(?:".concat(d, "|www\\.)").concat(f, "(?:localhost|").concat(h, "|").concat(p, "|").concat(g).concat(m).concat(v, ")").concat(y).concat(_);
  return m1 = new RegExp("(?:^".concat(b, "$)"), "i"), m1;
};
var iF = {
  // http://emailregex.com/
  email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+\.)+[a-zA-Z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}))$/,
  // url: new RegExp(
  //   '^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$',
  //   'i',
  // ),
  hex: /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i
}, u0 = {
  integer: function(t) {
    return u0.number(t) && parseInt(t, 10) === t;
  },
  float: function(t) {
    return u0.number(t) && !u0.integer(t);
  },
  array: function(t) {
    return Array.isArray(t);
  },
  regexp: function(t) {
    if (t instanceof RegExp)
      return !0;
    try {
      return !!new RegExp(t);
    } catch {
      return !1;
    }
  },
  date: function(t) {
    return typeof t.getTime == "function" && typeof t.getMonth == "function" && typeof t.getYear == "function" && !isNaN(t.getTime());
  },
  number: function(t) {
    return isNaN(t) ? !1 : typeof t == "number";
  },
  object: function(t) {
    return It(t) === "object" && !u0.array(t);
  },
  method: function(t) {
    return typeof t == "function";
  },
  email: function(t) {
    return typeof t == "string" && t.length <= 320 && !!t.match(iF.email);
  },
  url: function(t) {
    return typeof t == "string" && t.length <= 2048 && !!t.match(rDe());
  },
  hex: function(t) {
    return typeof t == "string" && !!t.match(iF.hex);
  }
}, iDe = function(t, n, r, i, o) {
  if (t.required && n === void 0) {
    pZ(t, n, r, i, o);
    return;
  }
  var a = ["integer", "float", "array", "regexp", "object", "method", "email", "number", "date", "url", "hex"], s = t.type;
  a.indexOf(s) > -1 ? u0[s](n) || i.push(ya(o.messages.types[s], t.fullField, t.type)) : s && It(n) !== t.type && i.push(ya(o.messages.types[s], t.fullField, t.type));
}, oDe = function(t, n, r, i, o) {
  (/^\s+$/.test(n) || n === "") && i.push(ya(o.messages.whitespace, t.fullField));
};
const wn = {
  required: pZ,
  whitespace: oDe,
  type: iDe,
  range: nDe,
  enum: eDe,
  pattern: tDe
};
var aDe = function(t, n, r, i, o) {
  var a = [], s = t.required || !t.required && i.hasOwnProperty(t.field);
  if (s) {
    if (Ei(n) && !t.required)
      return r();
    wn.required(t, n, i, a, o);
  }
  r(a);
}, sDe = function(t, n, r, i, o) {
  var a = [], s = t.required || !t.required && i.hasOwnProperty(t.field);
  if (s) {
    if (n == null && !t.required)
      return r();
    wn.required(t, n, i, a, o, "array"), n != null && (wn.type(t, n, i, a, o), wn.range(t, n, i, a, o));
  }
  r(a);
}, cDe = function(t, n, r, i, o) {
  var a = [], s = t.required || !t.required && i.hasOwnProperty(t.field);
  if (s) {
    if (Ei(n) && !t.required)
      return r();
    wn.required(t, n, i, a, o), n !== void 0 && wn.type(t, n, i, a, o);
  }
  r(a);
}, lDe = function(t, n, r, i, o) {
  var a = [], s = t.required || !t.required && i.hasOwnProperty(t.field);
  if (s) {
    if (Ei(n, "date") && !t.required)
      return r();
    if (wn.required(t, n, i, a, o), !Ei(n, "date")) {
      var c;
      n instanceof Date ? c = n : c = new Date(n), wn.type(t, c, i, a, o), c && wn.range(t, c.getTime(), i, a, o);
    }
  }
  r(a);
}, uDe = "enum", dDe = function(t, n, r, i, o) {
  var a = [], s = t.required || !t.required && i.hasOwnProperty(t.field);
  if (s) {
    if (Ei(n) && !t.required)
      return r();
    wn.required(t, n, i, a, o), n !== void 0 && wn[uDe](t, n, i, a, o);
  }
  r(a);
}, fDe = function(t, n, r, i, o) {
  var a = [], s = t.required || !t.required && i.hasOwnProperty(t.field);
  if (s) {
    if (Ei(n) && !t.required)
      return r();
    wn.required(t, n, i, a, o), n !== void 0 && (wn.type(t, n, i, a, o), wn.range(t, n, i, a, o));
  }
  r(a);
}, hDe = function(t, n, r, i, o) {
  var a = [], s = t.required || !t.required && i.hasOwnProperty(t.field);
  if (s) {
    if (Ei(n) && !t.required)
      return r();
    wn.required(t, n, i, a, o), n !== void 0 && (wn.type(t, n, i, a, o), wn.range(t, n, i, a, o));
  }
  r(a);
}, gDe = function(t, n, r, i, o) {
  var a = [], s = t.required || !t.required && i.hasOwnProperty(t.field);
  if (s) {
    if (Ei(n) && !t.required)
      return r();
    wn.required(t, n, i, a, o), n !== void 0 && wn.type(t, n, i, a, o);
  }
  r(a);
}, pDe = function(t, n, r, i, o) {
  var a = [], s = t.required || !t.required && i.hasOwnProperty(t.field);
  if (s) {
    if (n === "" && (n = void 0), Ei(n) && !t.required)
      return r();
    wn.required(t, n, i, a, o), n !== void 0 && (wn.type(t, n, i, a, o), wn.range(t, n, i, a, o));
  }
  r(a);
}, mDe = function(t, n, r, i, o) {
  var a = [], s = t.required || !t.required && i.hasOwnProperty(t.field);
  if (s) {
    if (Ei(n) && !t.required)
      return r();
    wn.required(t, n, i, a, o), n !== void 0 && wn.type(t, n, i, a, o);
  }
  r(a);
}, vDe = function(t, n, r, i, o) {
  var a = [], s = t.required || !t.required && i.hasOwnProperty(t.field);
  if (s) {
    if (Ei(n, "string") && !t.required)
      return r();
    wn.required(t, n, i, a, o), Ei(n, "string") || wn.pattern(t, n, i, a, o);
  }
  r(a);
}, yDe = function(t, n, r, i, o) {
  var a = [], s = t.required || !t.required && i.hasOwnProperty(t.field);
  if (s) {
    if (Ei(n) && !t.required)
      return r();
    wn.required(t, n, i, a, o), Ei(n) || wn.type(t, n, i, a, o);
  }
  r(a);
}, bDe = function(t, n, r, i, o) {
  var a = [], s = Array.isArray(n) ? "array" : It(n);
  wn.required(t, n, i, a, o, s), r(a);
}, _De = function(t, n, r, i, o) {
  var a = [], s = t.required || !t.required && i.hasOwnProperty(t.field);
  if (s) {
    if (Ei(n, "string") && !t.required)
      return r();
    wn.required(t, n, i, a, o, "string"), Ei(n, "string") || (wn.type(t, n, i, a, o), wn.range(t, n, i, a, o), wn.pattern(t, n, i, a, o), t.whitespace === !0 && wn.whitespace(t, n, i, a, o));
  }
  r(a);
}, CT = function(t, n, r, i, o) {
  var a = t.type, s = [], c = t.required || !t.required && i.hasOwnProperty(t.field);
  if (c) {
    if (Ei(n, a) && !t.required)
      return r();
    wn.required(t, n, i, s, o, a), Ei(n, a) || wn.type(t, n, i, s, o);
  }
  r(s);
};
const U0 = {
  string: _De,
  method: gDe,
  number: pDe,
  boolean: cDe,
  regexp: yDe,
  integer: hDe,
  float: fDe,
  array: sDe,
  object: mDe,
  enum: dDe,
  pattern: vDe,
  date: lDe,
  url: CT,
  hex: CT,
  email: CT,
  required: bDe,
  any: aDe
};
var Py = /* @__PURE__ */ function() {
  function e(t) {
    xr(this, e), oe(this, "rules", null), oe(this, "_messages", uR), this.define(t);
  }
  return Er(e, [{
    key: "define",
    value: function(n) {
      var r = this;
      if (!n)
        throw new Error("Cannot configure a schema with no rules");
      if (It(n) !== "object" || Array.isArray(n))
        throw new Error("Rules must be an object");
      this.rules = {}, Object.keys(n).forEach(function(i) {
        var o = n[i];
        r.rules[i] = Array.isArray(o) ? o : [o];
      });
    }
  }, {
    key: "messages",
    value: function(n) {
      return n && (this._messages = rF(lR(), n)), this._messages;
    }
  }, {
    key: "validate",
    value: function(n) {
      var r = this, i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : function() {
      }, a = n, s = i, c = o;
      if (typeof s == "function" && (c = s, s = {}), !this.rules || Object.keys(this.rules).length === 0)
        return c && c(null, a), Promise.resolve(a);
      function l(p) {
        var g = [], m = {};
        function v(_) {
          if (Array.isArray(_)) {
            var b;
            g = (b = g).concat.apply(b, tt(_));
          } else
            g.push(_);
        }
        for (var y = 0; y < p.length; y++)
          v(p[y]);
        g.length ? (m = fR(g), c(g, m)) : c(null, a);
      }
      if (s.messages) {
        var u = this.messages();
        u === uR && (u = lR()), rF(u, s.messages), s.messages = u;
      } else
        s.messages = this.messages();
      var d = {}, f = s.keys || Object.keys(this.rules);
      f.forEach(function(p) {
        var g = r.rules[p], m = a[p];
        g.forEach(function(v) {
          var y = v;
          typeof y.transform == "function" && (a === n && (a = ae({}, a)), m = a[p] = y.transform(m), m != null && (y.type = y.type || (Array.isArray(m) ? "array" : It(m)))), typeof y == "function" ? y = {
            validator: y
          } : y = ae({}, y), y.validator = r.getValidationMethod(y), y.validator && (y.field = p, y.fullField = y.fullField || p, y.type = r.getType(y), d[p] = d[p] || [], d[p].push({
            rule: y,
            value: m,
            source: a,
            field: p
          }));
        });
      });
      var h = {};
      return Q7e(d, s, function(p, g) {
        var m = p.rule, v = (m.type === "object" || m.type === "array") && (It(m.fields) === "object" || It(m.defaultField) === "object");
        v = v && (m.required || !m.required && p.value), m.field = p.field;
        function y(x, T) {
          return ae(ae({}, T), {}, {
            fullField: "".concat(m.fullField, ".").concat(x),
            fullFields: m.fullFields ? [].concat(tt(m.fullFields), [x]) : [x]
          });
        }
        function _() {
          var x = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], T = Array.isArray(x) ? x : [x];
          !s.suppressWarning && T.length && e.warning("async-validator:", T), T.length && m.message !== void 0 && (T = [].concat(m.message));
          var E = T.map(nF(m, a));
          if (s.first && E.length)
            return h[m.field] = 1, g(E);
          if (!v)
            g(E);
          else {
            if (m.required && !p.value)
              return m.message !== void 0 ? E = [].concat(m.message).map(nF(m, a)) : s.error && (E = [s.error(m, ya(s.messages.required, m.field))]), g(E);
            var R = {};
            m.defaultField && Object.keys(p.value).map(function(P) {
              R[P] = m.defaultField;
            }), R = ae(ae({}, R), p.rule.fields);
            var I = {};
            Object.keys(R).forEach(function(P) {
              var k = R[P], L = Array.isArray(k) ? k : [k];
              I[P] = L.map(y.bind(null, P));
            });
            var O = new e(I);
            O.messages(s.messages), p.rule.options && (p.rule.options.messages = s.messages, p.rule.options.error = s.error), O.validate(p.value, p.rule.options || s, function(P) {
              var k = [];
              E && E.length && k.push.apply(k, tt(E)), P && P.length && k.push.apply(k, tt(P)), g(k.length ? k : null);
            });
          }
        }
        var b;
        if (m.asyncValidator)
          b = m.asyncValidator(m, p.value, _, p.source, s);
        else if (m.validator) {
          try {
            b = m.validator(m, p.value, _, p.source, s);
          } catch (x) {
            var w, C;
            (w = (C = console).error) === null || w === void 0 || w.call(C, x), s.suppressValidatorError || setTimeout(function() {
              throw x;
            }, 0), _(x.message);
          }
          b === !0 ? _() : b === !1 ? _(typeof m.message == "function" ? m.message(m.fullField || m.field) : m.message || "".concat(m.fullField || m.field, " fails")) : b instanceof Array ? _(b) : b instanceof Error && _(b.message);
        }
        b && b.then && b.then(function() {
          return _();
        }, function(x) {
          return _(x);
        });
      }, function(p) {
        l(p);
      }, a);
    }
  }, {
    key: "getType",
    value: function(n) {
      if (n.type === void 0 && n.pattern instanceof RegExp && (n.type = "pattern"), typeof n.validator != "function" && n.type && !U0.hasOwnProperty(n.type))
        throw new Error(ya("Unknown rule type %s", n.type));
      return n.type || "string";
    }
  }, {
    key: "getValidationMethod",
    value: function(n) {
      if (typeof n.validator == "function")
        return n.validator;
      var r = Object.keys(n), i = r.indexOf("message");
      return i !== -1 && r.splice(i, 1), r.length === 1 && r[0] === "required" ? U0.required : U0[this.getType(n)] || void 0;
    }
  }]), e;
}();
oe(Py, "register", function(t, n) {
  if (typeof n != "function")
    throw new Error("Cannot register a validator by type, validator is not a function");
  U0[t] = n;
});
oe(Py, "warning", gZ);
oe(Py, "messages", uR);
oe(Py, "validators", U0);
var ca = "'${name}' is not a valid ${type}", mZ = {
  default: "Validation error on field '${name}'",
  required: "'${name}' is required",
  enum: "'${name}' must be one of [${enum}]",
  whitespace: "'${name}' cannot be empty",
  date: {
    format: "'${name}' is invalid for format date",
    parse: "'${name}' could not be parsed as date",
    invalid: "'${name}' is invalid date"
  },
  types: {
    string: ca,
    method: ca,
    array: ca,
    object: ca,
    number: ca,
    date: ca,
    boolean: ca,
    integer: ca,
    float: ca,
    regexp: ca,
    email: ca,
    url: ca,
    hex: ca
  },
  string: {
    len: "'${name}' must be exactly ${len} characters",
    min: "'${name}' must be at least ${min} characters",
    max: "'${name}' cannot be longer than ${max} characters",
    range: "'${name}' must be between ${min} and ${max} characters"
  },
  number: {
    len: "'${name}' must equal ${len}",
    min: "'${name}' cannot be less than ${min}",
    max: "'${name}' cannot be greater than ${max}",
    range: "'${name}' must be between ${min} and ${max}"
  },
  array: {
    len: "'${name}' must be exactly ${len} in length",
    min: "'${name}' cannot be less than ${min} in length",
    max: "'${name}' cannot be greater than ${max} in length",
    range: "'${name}' must be between ${min} and ${max} in length"
  },
  pattern: {
    mismatch: "'${name}' does not match pattern ${pattern}"
  }
}, oF = Py;
function SDe(e, t) {
  return e.replace(/\\?\$\{\w+\}/g, function(n) {
    if (n.startsWith("\\"))
      return n.slice(1);
    var r = n.slice(2, -1);
    return t[r];
  });
}
var aF = "CODE_LOGIC_ERROR";
function hR(e, t, n, r, i) {
  return gR.apply(this, arguments);
}
function gR() {
  return gR = qf(/* @__PURE__ */ ko().mark(function e(t, n, r, i, o) {
    var a, s, c, l, u, d, f, h, p;
    return ko().wrap(function(m) {
      for (; ; )
        switch (m.prev = m.next) {
          case 0:
            return a = ae({}, r), delete a.ruleIndex, oF.warning = function() {
            }, a.validator && (s = a.validator, a.validator = function() {
              try {
                return s.apply(void 0, arguments);
              } catch (v) {
                return console.error(v), Promise.reject(aF);
              }
            }), c = null, a && a.type === "array" && a.defaultField && (c = a.defaultField, delete a.defaultField), l = new oF(oe({}, t, [a])), u = Xh(mZ, i.validateMessages), l.messages(u), d = [], m.prev = 10, m.next = 13, Promise.resolve(l.validate(oe({}, t, n), ae({}, i)));
          case 13:
            m.next = 18;
            break;
          case 15:
            m.prev = 15, m.t0 = m.catch(10), m.t0.errors && (d = m.t0.errors.map(function(v, y) {
              var _ = v.message, b = _ === aF ? u.default : _;
              return /* @__PURE__ */ $.isValidElement(b) ? (
                // Wrap ReactNode with `key`
                /* @__PURE__ */ $.cloneElement(b, {
                  key: "error_".concat(y)
                })
              ) : b;
            }));
          case 18:
            if (!(!d.length && c)) {
              m.next = 23;
              break;
            }
            return m.next = 21, Promise.all(n.map(function(v, y) {
              return hR("".concat(t, ".").concat(y), v, c, i, o);
            }));
          case 21:
            return f = m.sent, m.abrupt("return", f.reduce(function(v, y) {
              return [].concat(tt(v), tt(y));
            }, []));
          case 23:
            return h = ae(ae({}, r), {}, {
              name: t,
              enum: (r.enum || []).join(", ")
            }, o), p = d.map(function(v) {
              return typeof v == "string" ? SDe(v, h) : v;
            }), m.abrupt("return", p);
          case 26:
          case "end":
            return m.stop();
        }
    }, e, null, [[10, 15]]);
  })), gR.apply(this, arguments);
}
function wDe(e, t, n, r, i, o) {
  var a = e.join("."), s = n.map(function(u, d) {
    var f = u.validator, h = ae(ae({}, u), {}, {
      ruleIndex: d
    });
    return f && (h.validator = function(p, g, m) {
      var v = !1, y = function() {
        for (var w = arguments.length, C = new Array(w), x = 0; x < w; x++)
          C[x] = arguments[x];
        Promise.resolve().then(function() {
          sn(!v, "Your validator function has already return a promise. `callback` will be ignored."), v || m.apply(void 0, C);
        });
      }, _ = f(p, g, y);
      v = _ && typeof _.then == "function" && typeof _.catch == "function", sn(v, "`callback` is deprecated. Please return a promise instead."), v && _.then(function() {
        m();
      }).catch(function(b) {
        m(b || " ");
      });
    }), h;
  }).sort(function(u, d) {
    var f = u.warningOnly, h = u.ruleIndex, p = d.warningOnly, g = d.ruleIndex;
    return !!f == !!p ? h - g : f ? 1 : -1;
  }), c;
  if (i === !0)
    c = new Promise(/* @__PURE__ */ function() {
      var u = qf(/* @__PURE__ */ ko().mark(function d(f, h) {
        var p, g, m;
        return ko().wrap(function(y) {
          for (; ; )
            switch (y.prev = y.next) {
              case 0:
                p = 0;
              case 1:
                if (!(p < s.length)) {
                  y.next = 12;
                  break;
                }
                return g = s[p], y.next = 5, hR(a, t, g, r, o);
              case 5:
                if (m = y.sent, !m.length) {
                  y.next = 9;
                  break;
                }
                return h([{
                  errors: m,
                  rule: g
                }]), y.abrupt("return");
              case 9:
                p += 1, y.next = 1;
                break;
              case 12:
                f([]);
              case 13:
              case "end":
                return y.stop();
            }
        }, d);
      }));
      return function(d, f) {
        return u.apply(this, arguments);
      };
    }());
  else {
    var l = s.map(function(u) {
      return hR(a, t, u, r, o).then(function(d) {
        return {
          errors: d,
          rule: u
        };
      });
    });
    c = (i ? EDe(l) : xDe(l)).then(function(u) {
      return Promise.reject(u);
    });
  }
  return c.catch(function(u) {
    return u;
  }), c;
}
function xDe(e) {
  return pR.apply(this, arguments);
}
function pR() {
  return pR = qf(/* @__PURE__ */ ko().mark(function e(t) {
    return ko().wrap(function(r) {
      for (; ; )
        switch (r.prev = r.next) {
          case 0:
            return r.abrupt("return", Promise.all(t).then(function(i) {
              var o, a = (o = []).concat.apply(o, tt(i));
              return a;
            }));
          case 1:
          case "end":
            return r.stop();
        }
    }, e);
  })), pR.apply(this, arguments);
}
function EDe(e) {
  return mR.apply(this, arguments);
}
function mR() {
  return mR = qf(/* @__PURE__ */ ko().mark(function e(t) {
    var n;
    return ko().wrap(function(i) {
      for (; ; )
        switch (i.prev = i.next) {
          case 0:
            return n = 0, i.abrupt("return", new Promise(function(o) {
              t.forEach(function(a) {
                a.then(function(s) {
                  s.errors.length && o([s]), n += 1, n === t.length && o([]);
                });
              });
            }));
          case 2:
          case "end":
            return i.stop();
        }
    }, e);
  })), mR.apply(this, arguments);
}
function ei(e) {
  return cR(e);
}
function sF(e, t) {
  var n = {};
  return t.forEach(function(r) {
    var i = rc(e, r);
    n = ls(n, r, i);
  }), n;
}
function hg(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
  return e && e.some(function(r) {
    return vZ(t, r, n);
  });
}
function vZ(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
  return !e || !t || !n && e.length !== t.length ? !1 : t.every(function(r, i) {
    return e[i] === r;
  });
}
function CDe(e, t) {
  if (e === t)
    return !0;
  if (!e && t || e && !t || !e || !t || It(e) !== "object" || It(t) !== "object")
    return !1;
  var n = Object.keys(e), r = Object.keys(t), i = new Set([].concat(n, r));
  return tt(i).every(function(o) {
    var a = e[o], s = t[o];
    return typeof a == "function" && typeof s == "function" ? !0 : a === s;
  });
}
function TDe(e) {
  var t = arguments.length <= 1 ? void 0 : arguments[1];
  return t && t.target && It(t.target) === "object" && e in t.target ? t.target[e] : t;
}
function cF(e, t, n) {
  var r = e.length;
  if (t < 0 || t >= r || n < 0 || n >= r)
    return e;
  var i = e[t], o = t - n;
  return o > 0 ? [].concat(tt(e.slice(0, n)), [i], tt(e.slice(n, t)), tt(e.slice(t + 1, r))) : o < 0 ? [].concat(tt(e.slice(0, t)), tt(e.slice(t + 1, n + 1)), [i], tt(e.slice(n + 1, r))) : e;
}
var IDe = ["name"], Ra = [];
function TT(e, t, n, r, i, o) {
  return typeof e == "function" ? e(t, n, "source" in o ? {
    source: o.source
  } : {}) : r !== i;
}
var DM = /* @__PURE__ */ function(e) {
  Ds(n, e);
  var t = Ac(n);
  function n(r) {
    var i;
    if (xr(this, n), i = t.call(this, r), oe(rn(i), "state", {
      resetCount: 0
    }), oe(rn(i), "cancelRegisterFunc", null), oe(rn(i), "mounted", !1), oe(rn(i), "touched", !1), oe(rn(i), "dirty", !1), oe(rn(i), "validatePromise", void 0), oe(rn(i), "prevValidating", void 0), oe(rn(i), "errors", Ra), oe(rn(i), "warnings", Ra), oe(rn(i), "cancelRegister", function() {
      var c = i.props, l = c.preserve, u = c.isListField, d = c.name;
      i.cancelRegisterFunc && i.cancelRegisterFunc(u, l, ei(d)), i.cancelRegisterFunc = null;
    }), oe(rn(i), "getNamePath", function() {
      var c = i.props, l = c.name, u = c.fieldContext, d = u.prefixName, f = d === void 0 ? [] : d;
      return l !== void 0 ? [].concat(tt(f), tt(l)) : [];
    }), oe(rn(i), "getRules", function() {
      var c = i.props, l = c.rules, u = l === void 0 ? [] : l, d = c.fieldContext;
      return u.map(function(f) {
        return typeof f == "function" ? f(d) : f;
      });
    }), oe(rn(i), "refresh", function() {
      i.mounted && i.setState(function(c) {
        var l = c.resetCount;
        return {
          resetCount: l + 1
        };
      });
    }), oe(rn(i), "metaCache", null), oe(rn(i), "triggerMetaEvent", function(c) {
      var l = i.props.onMetaChange;
      if (l) {
        var u = ae(ae({}, i.getMeta()), {}, {
          destroy: c
        });
        Ug(i.metaCache, u) || l(u), i.metaCache = u;
      } else
        i.metaCache = null;
    }), oe(rn(i), "onStoreChange", function(c, l, u) {
      var d = i.props, f = d.shouldUpdate, h = d.dependencies, p = h === void 0 ? [] : h, g = d.onReset, m = u.store, v = i.getNamePath(), y = i.getValue(c), _ = i.getValue(m), b = l && hg(l, v);
      switch (u.type === "valueUpdate" && u.source === "external" && !Ug(y, _) && (i.touched = !0, i.dirty = !0, i.validatePromise = null, i.errors = Ra, i.warnings = Ra, i.triggerMetaEvent()), u.type) {
        case "reset":
          if (!l || b) {
            i.touched = !1, i.dirty = !1, i.validatePromise = void 0, i.errors = Ra, i.warnings = Ra, i.triggerMetaEvent(), g == null || g(), i.refresh();
            return;
          }
          break;
        case "remove": {
          if (f && TT(f, c, m, y, _, u)) {
            i.reRender();
            return;
          }
          break;
        }
        case "setField": {
          var w = u.data;
          if (b) {
            "touched" in w && (i.touched = w.touched), "validating" in w && !("originRCField" in w) && (i.validatePromise = w.validating ? Promise.resolve([]) : null), "errors" in w && (i.errors = w.errors || Ra), "warnings" in w && (i.warnings = w.warnings || Ra), i.dirty = !0, i.triggerMetaEvent(), i.reRender();
            return;
          } else if ("value" in w && hg(l, v, !0)) {
            i.reRender();
            return;
          }
          if (f && !v.length && TT(f, c, m, y, _, u)) {
            i.reRender();
            return;
          }
          break;
        }
        case "dependenciesUpdate": {
          var C = p.map(ei);
          if (C.some(function(x) {
            return hg(u.relatedFields, x);
          })) {
            i.reRender();
            return;
          }
          break;
        }
        default:
          if (b || (!p.length || v.length || f) && TT(f, c, m, y, _, u)) {
            i.reRender();
            return;
          }
          break;
      }
      f === !0 && i.reRender();
    }), oe(rn(i), "validateRules", function(c) {
      var l = i.getNamePath(), u = i.getValue(), d = c || {}, f = d.triggerName, h = d.validateOnly, p = h === void 0 ? !1 : h, g = Promise.resolve().then(/* @__PURE__ */ qf(/* @__PURE__ */ ko().mark(function m() {
        var v, y, _, b, w, C, x;
        return ko().wrap(function(E) {
          for (; ; )
            switch (E.prev = E.next) {
              case 0:
                if (i.mounted) {
                  E.next = 2;
                  break;
                }
                return E.abrupt("return", []);
              case 2:
                if (v = i.props, y = v.validateFirst, _ = y === void 0 ? !1 : y, b = v.messageVariables, w = v.validateDebounce, C = i.getRules(), f && (C = C.filter(function(R) {
                  return R;
                }).filter(function(R) {
                  var I = R.validateTrigger;
                  if (!I)
                    return !0;
                  var O = cR(I);
                  return O.includes(f);
                })), !(w && f)) {
                  E.next = 10;
                  break;
                }
                return E.next = 8, new Promise(function(R) {
                  setTimeout(R, w);
                });
              case 8:
                if (i.validatePromise === g) {
                  E.next = 10;
                  break;
                }
                return E.abrupt("return", []);
              case 10:
                return x = wDe(l, u, C, c, _, b), x.catch(function(R) {
                  return R;
                }).then(function() {
                  var R = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Ra;
                  if (i.validatePromise === g) {
                    var I;
                    i.validatePromise = null;
                    var O = [], P = [];
                    (I = R.forEach) === null || I === void 0 || I.call(R, function(k) {
                      var L = k.rule.warningOnly, N = k.errors, D = N === void 0 ? Ra : N;
                      L ? P.push.apply(P, tt(D)) : O.push.apply(O, tt(D));
                    }), i.errors = O, i.warnings = P, i.triggerMetaEvent(), i.reRender();
                  }
                }), E.abrupt("return", x);
              case 13:
              case "end":
                return E.stop();
            }
        }, m);
      })));
      return p || (i.validatePromise = g, i.dirty = !0, i.errors = Ra, i.warnings = Ra, i.triggerMetaEvent(), i.reRender()), g;
    }), oe(rn(i), "isFieldValidating", function() {
      return !!i.validatePromise;
    }), oe(rn(i), "isFieldTouched", function() {
      return i.touched;
    }), oe(rn(i), "isFieldDirty", function() {
      if (i.dirty || i.props.initialValue !== void 0)
        return !0;
      var c = i.props.fieldContext, l = c.getInternalHooks(jd), u = l.getInitialValue;
      return u(i.getNamePath()) !== void 0;
    }), oe(rn(i), "getErrors", function() {
      return i.errors;
    }), oe(rn(i), "getWarnings", function() {
      return i.warnings;
    }), oe(rn(i), "isListField", function() {
      return i.props.isListField;
    }), oe(rn(i), "isList", function() {
      return i.props.isList;
    }), oe(rn(i), "isPreserve", function() {
      return i.props.preserve;
    }), oe(rn(i), "getMeta", function() {
      i.prevValidating = i.isFieldValidating();
      var c = {
        touched: i.isFieldTouched(),
        validating: i.prevValidating,
        errors: i.errors,
        warnings: i.warnings,
        name: i.getNamePath(),
        validated: i.validatePromise === null
      };
      return c;
    }), oe(rn(i), "getOnlyChild", function(c) {
      if (typeof c == "function") {
        var l = i.getMeta();
        return ae(ae({}, i.getOnlyChild(c(i.getControlled(), l, i.props.fieldContext))), {}, {
          isFunction: !0
        });
      }
      var u = Sf(c);
      return u.length !== 1 || !/* @__PURE__ */ $.isValidElement(u[0]) ? {
        child: u,
        isFunction: !1
      } : {
        child: u[0],
        isFunction: !1
      };
    }), oe(rn(i), "getValue", function(c) {
      var l = i.props.fieldContext.getFieldsValue, u = i.getNamePath();
      return rc(c || l(!0), u);
    }), oe(rn(i), "getControlled", function() {
      var c = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, l = i.props, u = l.name, d = l.trigger, f = l.validateTrigger, h = l.getValueFromEvent, p = l.normalize, g = l.valuePropName, m = l.getValueProps, v = l.fieldContext, y = f !== void 0 ? f : v.validateTrigger, _ = i.getNamePath(), b = v.getInternalHooks, w = v.getFieldsValue, C = b(jd), x = C.dispatch, T = i.getValue(), E = m || function(k) {
        return oe({}, g, k);
      }, R = c[d], I = u !== void 0 ? E(T) : {};
      process.env.NODE_ENV !== "production" && I && Object.keys(I).forEach(function(k) {
        sn(typeof I[k] != "function", "It's not recommended to generate dynamic function prop by `getValueProps`. Please pass it to child component directly (prop: ".concat(k, ")"));
      });
      var O = ae(ae({}, c), I);
      O[d] = function() {
        i.touched = !0, i.dirty = !0, i.triggerMetaEvent();
        for (var k, L = arguments.length, N = new Array(L), D = 0; D < L; D++)
          N[D] = arguments[D];
        h ? k = h.apply(void 0, N) : k = TDe.apply(void 0, [g].concat(N)), p && (k = p(k, T, w(!0))), k !== T && x({
          type: "updateValue",
          namePath: _,
          value: k
        }), R && R.apply(void 0, N);
      };
      var P = cR(y || []);
      return P.forEach(function(k) {
        var L = O[k];
        O[k] = function() {
          L && L.apply(void 0, arguments);
          var N = i.props.rules;
          N && N.length && x({
            type: "validateField",
            namePath: _,
            triggerName: k
          });
        };
      }), O;
    }), r.fieldContext) {
      var o = r.fieldContext.getInternalHooks, a = o(jd), s = a.initEntityValue;
      s(rn(i));
    }
    return i;
  }
  return Er(n, [{
    key: "componentDidMount",
    value: function() {
      var i = this.props, o = i.shouldUpdate, a = i.fieldContext;
      if (this.mounted = !0, a) {
        var s = a.getInternalHooks, c = s(jd), l = c.registerField;
        this.cancelRegisterFunc = l(this);
      }
      o === !0 && this.reRender();
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.cancelRegister(), this.triggerMetaEvent(!0), this.mounted = !1;
    }
  }, {
    key: "reRender",
    value: function() {
      this.mounted && this.forceUpdate();
    }
  }, {
    key: "render",
    value: function() {
      var i = this.state.resetCount, o = this.props.children, a = this.getOnlyChild(o), s = a.child, c = a.isFunction, l;
      return c ? l = s : /* @__PURE__ */ $.isValidElement(s) ? l = /* @__PURE__ */ $.cloneElement(s, this.getControlled(s.props)) : (sn(!s, "`children` of Field is not validate ReactElement."), l = s), /* @__PURE__ */ $.createElement($.Fragment, {
        key: i
      }, l);
    }
  }]), n;
}($.Component);
oe(DM, "contextType", Ef);
oe(DM, "defaultProps", {
  trigger: "onChange",
  valuePropName: "value"
});
function jM(e) {
  var t = e.name, n = En(e, IDe), r = $.useContext(Ef), i = $.useContext(Rv), o = t !== void 0 ? ei(t) : void 0, a = "keep";
  return n.isListField || (a = "_".concat((o || []).join("_"))), process.env.NODE_ENV !== "production" && n.preserve === !1 && n.isListField && o.length <= 1 && sn(!1, "`preserve` should not apply on Form.List fields."), /* @__PURE__ */ $.createElement(DM, xt({
    key: a,
    name: o,
    isListField: !!i
  }, n, {
    fieldContext: r
  }));
}
function yZ(e) {
  var t = e.name, n = e.initialValue, r = e.children, i = e.rules, o = e.validateTrigger, a = e.isListField, s = $.useContext(Ef), c = $.useContext(Rv), l = $.useRef({
    keys: [],
    id: 0
  }), u = l.current, d = $.useMemo(function() {
    var g = ei(s.prefixName) || [];
    return [].concat(tt(g), tt(ei(t)));
  }, [s.prefixName, t]), f = $.useMemo(function() {
    return ae(ae({}, s), {}, {
      prefixName: d
    });
  }, [s, d]), h = $.useMemo(function() {
    return {
      getKey: function(m) {
        var v = d.length, y = m[v];
        return [u.keys[y], m.slice(v + 1)];
      }
    };
  }, [d]);
  if (typeof r != "function")
    return sn(!1, "Form.List only accepts function as children."), null;
  var p = function(m, v, y) {
    var _ = y.source;
    return _ === "internal" ? !1 : m !== v;
  };
  return /* @__PURE__ */ $.createElement(Rv.Provider, {
    value: h
  }, /* @__PURE__ */ $.createElement(Ef.Provider, {
    value: f
  }, /* @__PURE__ */ $.createElement(jM, {
    name: [],
    shouldUpdate: p,
    rules: i,
    validateTrigger: o,
    initialValue: n,
    isList: !0,
    isListField: a ?? !!c
  }, function(g, m) {
    var v = g.value, y = v === void 0 ? [] : v, _ = g.onChange, b = s.getFieldValue, w = function() {
      var E = b(d || []);
      return E || [];
    }, C = {
      add: function(E, R) {
        var I = w();
        R >= 0 && R <= I.length ? (u.keys = [].concat(tt(u.keys.slice(0, R)), [u.id], tt(u.keys.slice(R))), _([].concat(tt(I.slice(0, R)), [E], tt(I.slice(R))))) : (process.env.NODE_ENV !== "production" && (R < 0 || R > I.length) && sn(!1, "The second parameter of the add function should be a valid positive number."), u.keys = [].concat(tt(u.keys), [u.id]), _([].concat(tt(I), [E]))), u.id += 1;
      },
      remove: function(E) {
        var R = w(), I = new Set(Array.isArray(E) ? E : [E]);
        I.size <= 0 || (u.keys = u.keys.filter(function(O, P) {
          return !I.has(P);
        }), _(R.filter(function(O, P) {
          return !I.has(P);
        })));
      },
      move: function(E, R) {
        if (E !== R) {
          var I = w();
          E < 0 || E >= I.length || R < 0 || R >= I.length || (u.keys = cF(u.keys, E, R), _(cF(I, E, R)));
        }
      }
    }, x = y || [];
    return Array.isArray(x) || (x = [], process.env.NODE_ENV !== "production" && sn(!1, "Current value of '".concat(d.join(" > "), "' is not an array type."))), r(x.map(function(T, E) {
      var R = u.keys[E];
      return R === void 0 && (u.keys[E] = u.id, R = u.keys[E], u.id += 1), {
        name: E,
        key: R,
        isListField: !0
      };
    }), C, m);
  })));
}
function $De(e) {
  var t = !1, n = e.length, r = [];
  return e.length ? new Promise(function(i, o) {
    e.forEach(function(a, s) {
      a.catch(function(c) {
        return t = !0, c;
      }).then(function(c) {
        n -= 1, r[s] = c, !(n > 0) && (t && o(r), i(r));
      });
    });
  }) : Promise.resolve([]);
}
var bZ = "__@field_split__";
function IT(e) {
  return e.map(function(t) {
    return "".concat(It(t), ":").concat(t);
  }).join(bZ);
}
var _h = /* @__PURE__ */ function() {
  function e() {
    xr(this, e), oe(this, "kvs", /* @__PURE__ */ new Map());
  }
  return Er(e, [{
    key: "set",
    value: function(n, r) {
      this.kvs.set(IT(n), r);
    }
  }, {
    key: "get",
    value: function(n) {
      return this.kvs.get(IT(n));
    }
  }, {
    key: "update",
    value: function(n, r) {
      var i = this.get(n), o = r(i);
      o ? this.set(n, o) : this.delete(n);
    }
  }, {
    key: "delete",
    value: function(n) {
      this.kvs.delete(IT(n));
    }
    // Since we only use this in test, let simply realize this
  }, {
    key: "map",
    value: function(n) {
      return tt(this.kvs.entries()).map(function(r) {
        var i = he(r, 2), o = i[0], a = i[1], s = o.split(bZ);
        return n({
          key: s.map(function(c) {
            var l = c.match(/^([^:]*):(.*)$/), u = he(l, 3), d = u[1], f = u[2];
            return d === "number" ? Number(f) : f;
          }),
          value: a
        });
      });
    }
  }, {
    key: "toJSON",
    value: function() {
      var n = {};
      return this.map(function(r) {
        var i = r.key, o = r.value;
        return n[i.join(".")] = o, null;
      }), n;
    }
  }]), e;
}(), ADe = ["name"], RDe = /* @__PURE__ */ Er(function e(t) {
  var n = this;
  xr(this, e), oe(this, "formHooked", !1), oe(this, "forceRootUpdate", void 0), oe(this, "subscribable", !0), oe(this, "store", {}), oe(this, "fieldEntities", []), oe(this, "initialValues", {}), oe(this, "callbacks", {}), oe(this, "validateMessages", null), oe(this, "preserve", null), oe(this, "lastValidatePromise", null), oe(this, "getForm", function() {
    return {
      getFieldValue: n.getFieldValue,
      getFieldsValue: n.getFieldsValue,
      getFieldError: n.getFieldError,
      getFieldWarning: n.getFieldWarning,
      getFieldsError: n.getFieldsError,
      isFieldsTouched: n.isFieldsTouched,
      isFieldTouched: n.isFieldTouched,
      isFieldValidating: n.isFieldValidating,
      isFieldsValidating: n.isFieldsValidating,
      resetFields: n.resetFields,
      setFields: n.setFields,
      setFieldValue: n.setFieldValue,
      setFieldsValue: n.setFieldsValue,
      validateFields: n.validateFields,
      submit: n.submit,
      _init: !0,
      getInternalHooks: n.getInternalHooks
    };
  }), oe(this, "getInternalHooks", function(r) {
    return r === jd ? (n.formHooked = !0, {
      dispatch: n.dispatch,
      initEntityValue: n.initEntityValue,
      registerField: n.registerField,
      useSubscribe: n.useSubscribe,
      setInitialValues: n.setInitialValues,
      destroyForm: n.destroyForm,
      setCallbacks: n.setCallbacks,
      setValidateMessages: n.setValidateMessages,
      getFields: n.getFields,
      setPreserve: n.setPreserve,
      getInitialValue: n.getInitialValue,
      registerWatch: n.registerWatch
    }) : (sn(!1, "`getInternalHooks` is internal usage. Should not call directly."), null);
  }), oe(this, "useSubscribe", function(r) {
    n.subscribable = r;
  }), oe(this, "prevWithoutPreserves", null), oe(this, "setInitialValues", function(r, i) {
    if (n.initialValues = r || {}, i) {
      var o, a = Xh(r, n.store);
      (o = n.prevWithoutPreserves) === null || o === void 0 || o.map(function(s) {
        var c = s.key;
        a = ls(a, c, rc(r, c));
      }), n.prevWithoutPreserves = null, n.updateStore(a);
    }
  }), oe(this, "destroyForm", function(r) {
    if (r)
      n.updateStore({});
    else {
      var i = new _h();
      n.getFieldEntities(!0).forEach(function(o) {
        n.isMergedPreserve(o.isPreserve()) || i.set(o.getNamePath(), !0);
      }), n.prevWithoutPreserves = i;
    }
  }), oe(this, "getInitialValue", function(r) {
    var i = rc(n.initialValues, r);
    return r.length ? Xh(i) : i;
  }), oe(this, "setCallbacks", function(r) {
    n.callbacks = r;
  }), oe(this, "setValidateMessages", function(r) {
    n.validateMessages = r;
  }), oe(this, "setPreserve", function(r) {
    n.preserve = r;
  }), oe(this, "watchList", []), oe(this, "registerWatch", function(r) {
    return n.watchList.push(r), function() {
      n.watchList = n.watchList.filter(function(i) {
        return i !== r;
      });
    };
  }), oe(this, "notifyWatch", function() {
    var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    if (n.watchList.length) {
      var i = n.getFieldsValue(), o = n.getFieldsValue(!0);
      n.watchList.forEach(function(a) {
        a(i, o, r);
      });
    }
  }), oe(this, "timeoutId", null), oe(this, "warningUnhooked", function() {
    process.env.NODE_ENV !== "production" && !n.timeoutId && typeof window < "u" && (n.timeoutId = setTimeout(function() {
      n.timeoutId = null, n.formHooked || sn(!1, "Instance created by `useForm` is not connected to any Form element. Forget to pass `form` prop?");
    }));
  }), oe(this, "updateStore", function(r) {
    n.store = r;
  }), oe(this, "getFieldEntities", function() {
    var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
    return r ? n.fieldEntities.filter(function(i) {
      return i.getNamePath().length;
    }) : n.fieldEntities;
  }), oe(this, "getFieldsMap", function() {
    var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, i = new _h();
    return n.getFieldEntities(r).forEach(function(o) {
      var a = o.getNamePath();
      i.set(a, o);
    }), i;
  }), oe(this, "getFieldEntitiesForNamePathList", function(r) {
    if (!r)
      return n.getFieldEntities(!0);
    var i = n.getFieldsMap(!0);
    return r.map(function(o) {
      var a = ei(o);
      return i.get(a) || {
        INVALIDATE_NAME_PATH: ei(o)
      };
    });
  }), oe(this, "getFieldsValue", function(r, i) {
    n.warningUnhooked();
    var o, a, s;
    if (r === !0 || Array.isArray(r) ? (o = r, a = i) : r && It(r) === "object" && (s = r.strict, a = r.filter), o === !0 && !a)
      return n.store;
    var c = n.getFieldEntitiesForNamePathList(Array.isArray(o) ? o : null), l = [];
    return c.forEach(function(u) {
      var d, f, h = "INVALIDATE_NAME_PATH" in u ? u.INVALIDATE_NAME_PATH : u.getNamePath();
      if (s) {
        var p, g;
        if ((p = (g = u).isList) !== null && p !== void 0 && p.call(g))
          return;
      } else if (!o && (d = (f = u).isListField) !== null && d !== void 0 && d.call(f))
        return;
      if (!a)
        l.push(h);
      else {
        var m = "getMeta" in u ? u.getMeta() : null;
        a(m) && l.push(h);
      }
    }), sF(n.store, l.map(ei));
  }), oe(this, "getFieldValue", function(r) {
    n.warningUnhooked();
    var i = ei(r);
    return rc(n.store, i);
  }), oe(this, "getFieldsError", function(r) {
    n.warningUnhooked();
    var i = n.getFieldEntitiesForNamePathList(r);
    return i.map(function(o, a) {
      return o && !("INVALIDATE_NAME_PATH" in o) ? {
        name: o.getNamePath(),
        errors: o.getErrors(),
        warnings: o.getWarnings()
      } : {
        name: ei(r[a]),
        errors: [],
        warnings: []
      };
    });
  }), oe(this, "getFieldError", function(r) {
    n.warningUnhooked();
    var i = ei(r), o = n.getFieldsError([i])[0];
    return o.errors;
  }), oe(this, "getFieldWarning", function(r) {
    n.warningUnhooked();
    var i = ei(r), o = n.getFieldsError([i])[0];
    return o.warnings;
  }), oe(this, "isFieldsTouched", function() {
    n.warningUnhooked();
    for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++)
      i[o] = arguments[o];
    var a = i[0], s = i[1], c, l = !1;
    i.length === 0 ? c = null : i.length === 1 ? Array.isArray(a) ? (c = a.map(ei), l = !1) : (c = null, l = a) : (c = a.map(ei), l = s);
    var u = n.getFieldEntities(!0), d = function(m) {
      return m.isFieldTouched();
    };
    if (!c)
      return l ? u.every(function(g) {
        return d(g) || g.isList();
      }) : u.some(d);
    var f = new _h();
    c.forEach(function(g) {
      f.set(g, []);
    }), u.forEach(function(g) {
      var m = g.getNamePath();
      c.forEach(function(v) {
        v.every(function(y, _) {
          return m[_] === y;
        }) && f.update(v, function(y) {
          return [].concat(tt(y), [g]);
        });
      });
    });
    var h = function(m) {
      return m.some(d);
    }, p = f.map(function(g) {
      var m = g.value;
      return m;
    });
    return l ? p.every(h) : p.some(h);
  }), oe(this, "isFieldTouched", function(r) {
    return n.warningUnhooked(), n.isFieldsTouched([r]);
  }), oe(this, "isFieldsValidating", function(r) {
    n.warningUnhooked();
    var i = n.getFieldEntities();
    if (!r)
      return i.some(function(a) {
        return a.isFieldValidating();
      });
    var o = r.map(ei);
    return i.some(function(a) {
      var s = a.getNamePath();
      return hg(o, s) && a.isFieldValidating();
    });
  }), oe(this, "isFieldValidating", function(r) {
    return n.warningUnhooked(), n.isFieldsValidating([r]);
  }), oe(this, "resetWithFieldInitialValue", function() {
    var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, i = new _h(), o = n.getFieldEntities(!0);
    o.forEach(function(c) {
      var l = c.props.initialValue, u = c.getNamePath();
      if (l !== void 0) {
        var d = i.get(u) || /* @__PURE__ */ new Set();
        d.add({
          entity: c,
          value: l
        }), i.set(u, d);
      }
    });
    var a = function(l) {
      l.forEach(function(u) {
        var d = u.props.initialValue;
        if (d !== void 0) {
          var f = u.getNamePath(), h = n.getInitialValue(f);
          if (h !== void 0)
            sn(!1, "Form already set 'initialValues' with path '".concat(f.join("."), "'. Field can not overwrite it."));
          else {
            var p = i.get(f);
            if (p && p.size > 1)
              sn(!1, "Multiple Field with path '".concat(f.join("."), "' set 'initialValue'. Can not decide which one to pick."));
            else if (p) {
              var g = n.getFieldValue(f), m = u.isListField();
              !m && (!r.skipExist || g === void 0) && n.updateStore(ls(n.store, f, tt(p)[0].value));
            }
          }
        }
      });
    }, s;
    r.entities ? s = r.entities : r.namePathList ? (s = [], r.namePathList.forEach(function(c) {
      var l = i.get(c);
      if (l) {
        var u;
        (u = s).push.apply(u, tt(tt(l).map(function(d) {
          return d.entity;
        })));
      }
    })) : s = o, a(s);
  }), oe(this, "resetFields", function(r) {
    n.warningUnhooked();
    var i = n.store;
    if (!r) {
      n.updateStore(Xh(n.initialValues)), n.resetWithFieldInitialValue(), n.notifyObservers(i, null, {
        type: "reset"
      }), n.notifyWatch();
      return;
    }
    var o = r.map(ei);
    o.forEach(function(a) {
      var s = n.getInitialValue(a);
      n.updateStore(ls(n.store, a, s));
    }), n.resetWithFieldInitialValue({
      namePathList: o
    }), n.notifyObservers(i, o, {
      type: "reset"
    }), n.notifyWatch(o);
  }), oe(this, "setFields", function(r) {
    n.warningUnhooked();
    var i = n.store, o = [];
    r.forEach(function(a) {
      var s = a.name, c = En(a, ADe), l = ei(s);
      o.push(l), "value" in c && n.updateStore(ls(n.store, l, c.value)), n.notifyObservers(i, [l], {
        type: "setField",
        data: a
      });
    }), n.notifyWatch(o);
  }), oe(this, "getFields", function() {
    var r = n.getFieldEntities(!0), i = r.map(function(o) {
      var a = o.getNamePath(), s = o.getMeta(), c = ae(ae({}, s), {}, {
        name: a,
        value: n.getFieldValue(a)
      });
      return Object.defineProperty(c, "originRCField", {
        value: !0
      }), c;
    });
    return i;
  }), oe(this, "initEntityValue", function(r) {
    var i = r.props.initialValue;
    if (i !== void 0) {
      var o = r.getNamePath(), a = rc(n.store, o);
      a === void 0 && n.updateStore(ls(n.store, o, i));
    }
  }), oe(this, "isMergedPreserve", function(r) {
    var i = r !== void 0 ? r : n.preserve;
    return i ?? !0;
  }), oe(this, "registerField", function(r) {
    n.fieldEntities.push(r);
    var i = r.getNamePath();
    if (n.notifyWatch([i]), r.props.initialValue !== void 0) {
      var o = n.store;
      n.resetWithFieldInitialValue({
        entities: [r],
        skipExist: !0
      }), n.notifyObservers(o, [r.getNamePath()], {
        type: "valueUpdate",
        source: "internal"
      });
    }
    return function(a, s) {
      var c = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
      if (n.fieldEntities = n.fieldEntities.filter(function(d) {
        return d !== r;
      }), !n.isMergedPreserve(s) && (!a || c.length > 1)) {
        var l = a ? void 0 : n.getInitialValue(i);
        if (i.length && n.getFieldValue(i) !== l && n.fieldEntities.every(function(d) {
          return (
            // Only reset when no namePath exist
            !vZ(d.getNamePath(), i)
          );
        })) {
          var u = n.store;
          n.updateStore(ls(u, i, l, !0)), n.notifyObservers(u, [i], {
            type: "remove"
          }), n.triggerDependenciesUpdate(u, i);
        }
      }
      n.notifyWatch([i]);
    };
  }), oe(this, "dispatch", function(r) {
    switch (r.type) {
      case "updateValue": {
        var i = r.namePath, o = r.value;
        n.updateValue(i, o);
        break;
      }
      case "validateField": {
        var a = r.namePath, s = r.triggerName;
        n.validateFields([a], {
          triggerName: s
        });
        break;
      }
    }
  }), oe(this, "notifyObservers", function(r, i, o) {
    if (n.subscribable) {
      var a = ae(ae({}, o), {}, {
        store: n.getFieldsValue(!0)
      });
      n.getFieldEntities().forEach(function(s) {
        var c = s.onStoreChange;
        c(r, i, a);
      });
    } else
      n.forceRootUpdate();
  }), oe(this, "triggerDependenciesUpdate", function(r, i) {
    var o = n.getDependencyChildrenFields(i);
    return o.length && n.validateFields(o), n.notifyObservers(r, o, {
      type: "dependenciesUpdate",
      relatedFields: [i].concat(tt(o))
    }), o;
  }), oe(this, "updateValue", function(r, i) {
    var o = ei(r), a = n.store;
    n.updateStore(ls(n.store, o, i)), n.notifyObservers(a, [o], {
      type: "valueUpdate",
      source: "internal"
    }), n.notifyWatch([o]);
    var s = n.triggerDependenciesUpdate(a, o), c = n.callbacks.onValuesChange;
    if (c) {
      var l = sF(n.store, [o]);
      c(l, n.getFieldsValue());
    }
    n.triggerOnFieldsChange([o].concat(tt(s)));
  }), oe(this, "setFieldsValue", function(r) {
    n.warningUnhooked();
    var i = n.store;
    if (r) {
      var o = Xh(n.store, r);
      n.updateStore(o);
    }
    n.notifyObservers(i, null, {
      type: "valueUpdate",
      source: "external"
    }), n.notifyWatch();
  }), oe(this, "setFieldValue", function(r, i) {
    n.setFields([{
      name: r,
      value: i
    }]);
  }), oe(this, "getDependencyChildrenFields", function(r) {
    var i = /* @__PURE__ */ new Set(), o = [], a = new _h();
    n.getFieldEntities().forEach(function(c) {
      var l = c.props.dependencies;
      (l || []).forEach(function(u) {
        var d = ei(u);
        a.update(d, function() {
          var f = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : /* @__PURE__ */ new Set();
          return f.add(c), f;
        });
      });
    });
    var s = function c(l) {
      var u = a.get(l) || /* @__PURE__ */ new Set();
      u.forEach(function(d) {
        if (!i.has(d)) {
          i.add(d);
          var f = d.getNamePath();
          d.isFieldDirty() && f.length && (o.push(f), c(f));
        }
      });
    };
    return s(r), o;
  }), oe(this, "triggerOnFieldsChange", function(r, i) {
    var o = n.callbacks.onFieldsChange;
    if (o) {
      var a = n.getFields();
      if (i) {
        var s = new _h();
        i.forEach(function(l) {
          var u = l.name, d = l.errors;
          s.set(u, d);
        }), a.forEach(function(l) {
          l.errors = s.get(l.name) || l.errors;
        });
      }
      var c = a.filter(function(l) {
        var u = l.name;
        return hg(r, u);
      });
      c.length && o(c, a);
    }
  }), oe(this, "validateFields", function(r, i) {
    n.warningUnhooked();
    var o, a;
    Array.isArray(r) || typeof r == "string" || typeof i == "string" ? (o = r, a = i) : a = r;
    var s = !!o, c = s ? o.map(ei) : [], l = [], u = String(Date.now()), d = /* @__PURE__ */ new Set(), f = a || {}, h = f.recursive, p = f.dirty;
    n.getFieldEntities(!0).forEach(function(y) {
      if (s || c.push(y.getNamePath()), !(!y.props.rules || !y.props.rules.length) && !(p && !y.isFieldDirty())) {
        var _ = y.getNamePath();
        if (d.add(_.join(u)), !s || hg(c, _, h)) {
          var b = y.validateRules(ae({
            validateMessages: ae(ae({}, mZ), n.validateMessages)
          }, a));
          l.push(b.then(function() {
            return {
              name: _,
              errors: [],
              warnings: []
            };
          }).catch(function(w) {
            var C, x = [], T = [];
            return (C = w.forEach) === null || C === void 0 || C.call(w, function(E) {
              var R = E.rule.warningOnly, I = E.errors;
              R ? T.push.apply(T, tt(I)) : x.push.apply(x, tt(I));
            }), x.length ? Promise.reject({
              name: _,
              errors: x,
              warnings: T
            }) : {
              name: _,
              errors: x,
              warnings: T
            };
          }));
        }
      }
    });
    var g = $De(l);
    n.lastValidatePromise = g, g.catch(function(y) {
      return y;
    }).then(function(y) {
      var _ = y.map(function(b) {
        var w = b.name;
        return w;
      });
      n.notifyObservers(n.store, _, {
        type: "validateFinish"
      }), n.triggerOnFieldsChange(_, y);
    });
    var m = g.then(function() {
      return n.lastValidatePromise === g ? Promise.resolve(n.getFieldsValue(c)) : Promise.reject([]);
    }).catch(function(y) {
      var _ = y.filter(function(b) {
        return b && b.errors.length;
      });
      return Promise.reject({
        values: n.getFieldsValue(c),
        errorFields: _,
        outOfDate: n.lastValidatePromise !== g
      });
    });
    m.catch(function(y) {
      return y;
    });
    var v = c.filter(function(y) {
      return d.has(y.join(u));
    });
    return n.triggerOnFieldsChange(v), m;
  }), oe(this, "submit", function() {
    n.warningUnhooked(), n.validateFields().then(function(r) {
      var i = n.callbacks.onFinish;
      if (i)
        try {
          i(r);
        } catch (o) {
          console.error(o);
        }
    }).catch(function(r) {
      var i = n.callbacks.onFinishFailed;
      i && i(r);
    });
  }), this.forceRootUpdate = t;
});
function LM(e) {
  var t = $.useRef(), n = $.useState({}), r = he(n, 2), i = r[1];
  if (!t.current)
    if (e)
      t.current = e;
    else {
      var o = function() {
        i({});
      }, a = new RDe(o);
      t.current = a.getForm();
    }
  return [t.current];
}
var vR = /* @__PURE__ */ $.createContext({
  triggerFormChange: function() {
  },
  triggerFormFinish: function() {
  },
  registerForm: function() {
  },
  unregisterForm: function() {
  }
}), _Z = function(t) {
  var n = t.validateMessages, r = t.onFormChange, i = t.onFormFinish, o = t.children, a = $.useContext(vR), s = $.useRef({});
  return /* @__PURE__ */ $.createElement(vR.Provider, {
    value: ae(ae({}, a), {}, {
      validateMessages: ae(ae({}, a.validateMessages), n),
      // =========================================================
      // =                  Global Form Control                  =
      // =========================================================
      triggerFormChange: function(l, u) {
        r && r(l, {
          changedFields: u,
          forms: s.current
        }), a.triggerFormChange(l, u);
      },
      triggerFormFinish: function(l, u) {
        i && i(l, {
          values: u,
          forms: s.current
        }), a.triggerFormFinish(l, u);
      },
      registerForm: function(l, u) {
        l && (s.current = ae(ae({}, s.current), {}, oe({}, l, u))), a.registerForm(l, u);
      },
      unregisterForm: function(l) {
        var u = ae({}, s.current);
        delete u[l], s.current = u, a.unregisterForm(l);
      }
    })
  }, o);
}, PDe = ["name", "initialValues", "fields", "form", "preserve", "children", "component", "validateMessages", "validateTrigger", "onValuesChange", "onFieldsChange", "onFinish", "onFinishFailed", "clearOnDestroy"], ODe = function(t, n) {
  var r = t.name, i = t.initialValues, o = t.fields, a = t.form, s = t.preserve, c = t.children, l = t.component, u = l === void 0 ? "form" : l, d = t.validateMessages, f = t.validateTrigger, h = f === void 0 ? "onChange" : f, p = t.onValuesChange, g = t.onFieldsChange, m = t.onFinish, v = t.onFinishFailed, y = t.clearOnDestroy, _ = En(t, PDe), b = $.useRef(null), w = $.useContext(vR), C = LM(a), x = he(C, 1), T = x[0], E = T.getInternalHooks(jd), R = E.useSubscribe, I = E.setInitialValues, O = E.setCallbacks, P = E.setValidateMessages, k = E.setPreserve, L = E.destroyForm;
  $.useImperativeHandle(n, function() {
    return ae(ae({}, T), {}, {
      nativeElement: b.current
    });
  }), $.useEffect(function() {
    return w.registerForm(r, T), function() {
      w.unregisterForm(r);
    };
  }, [w, T, r]), P(ae(ae({}, w.validateMessages), d)), O({
    onValuesChange: p,
    onFieldsChange: function(q) {
      if (w.triggerFormChange(r, q), g) {
        for (var X = arguments.length, ne = new Array(X > 1 ? X - 1 : 0), Z = 1; Z < X; Z++)
          ne[Z - 1] = arguments[Z];
        g.apply(void 0, [q].concat(ne));
      }
    },
    onFinish: function(q) {
      w.triggerFormFinish(r, q), m && m(q);
    },
    onFinishFailed: v
  }), k(s);
  var N = $.useRef(null);
  I(i, !N.current), N.current || (N.current = !0), $.useEffect(
    function() {
      return function() {
        return L(y);
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  var D, z = typeof c == "function";
  if (z) {
    var V = T.getFieldsValue(!0);
    D = c(V, T);
  } else
    D = c;
  R(!z);
  var B = $.useRef();
  $.useEffect(function() {
    CDe(B.current || [], o || []) || T.setFields(o || []), B.current = o;
  }, [o, T]);
  var U = $.useMemo(function() {
    return ae(ae({}, T), {}, {
      validateTrigger: h
    });
  }, [T, h]), Q = /* @__PURE__ */ $.createElement(Rv.Provider, {
    value: null
  }, /* @__PURE__ */ $.createElement(Ef.Provider, {
    value: U
  }, D));
  return u === !1 ? Q : /* @__PURE__ */ $.createElement(u, xt({}, _, {
    ref: b,
    onSubmit: function(q) {
      q.preventDefault(), q.stopPropagation(), T.submit();
    },
    onReset: function(q) {
      var X;
      q.preventDefault(), T.resetFields(), (X = _.onReset) === null || X === void 0 || X.call(_, q);
    }
  }), Q);
};
function lF(e) {
  try {
    return JSON.stringify(e);
  } catch {
    return Math.random();
  }
}
var MDe = process.env.NODE_ENV !== "production" ? function(e) {
  var t = e.join("__RC_FIELD_FORM_SPLIT__"), n = $e(t);
  sn(n.current === t, "`useWatch` is not support dynamic `namePath`. Please provide static instead.");
} : function() {
};
function SZ() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  var r = t[0], i = t[1], o = i === void 0 ? {} : i, a = U7e(o) ? {
    form: o
  } : o, s = a.form, c = Qe(), l = he(c, 2), u = l[0], d = l[1], f = Tt(function() {
    return lF(u);
  }, [u]), h = $e(f);
  h.current = f;
  var p = gt(Ef), g = s || p, m = g && g._init;
  process.env.NODE_ENV !== "production" && sn(t.length === 2 ? s ? m : !0 : m, "useWatch requires a form instance since it can not auto detect from context.");
  var v = ei(r), y = $e(v);
  return y.current = v, MDe(v), ot(
    function() {
      if (m) {
        var _ = g.getFieldsValue, b = g.getInternalHooks, w = b(jd), C = w.registerWatch, x = function(I, O) {
          var P = a.preserve ? O : I;
          return typeof r == "function" ? r(P) : rc(P, y.current);
        }, T = C(function(R, I) {
          var O = x(R, I), P = lF(O);
          h.current !== P && (h.current = P, d(O));
        }), E = x(_(), _(!0));
        return u !== E && d(E), T;
      }
    },
    // We do not need re-register since namePath content is the same
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [m]
  ), u;
}
var kDe = /* @__PURE__ */ $.forwardRef(ODe), Kp = kDe;
Kp.FormProvider = _Z;
Kp.Field = jM;
Kp.List = yZ;
Kp.useForm = LM;
Kp.useWatch = SZ;
const NDe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Field: jM,
  FieldContext: Ef,
  FormProvider: _Z,
  List: yZ,
  ListContext: Rv,
  default: Kp,
  useForm: LM,
  useWatch: SZ
}, Symbol.toStringTag, { value: "Module" })), As = /* @__PURE__ */ $.createContext({});
process.env.NODE_ENV !== "production" && (As.displayName = "FormItemInputContext");
const DDe = (e) => {
  let {
    children: t,
    status: n,
    override: r
  } = e;
  const i = gt(As), o = Tt(() => {
    const a = Object.assign({}, i);
    return r && delete a.isFormItemInput, n && (delete a.status, delete a.hasFeedback, delete a.feedbackIcon), a;
  }, [n, r, i]);
  return /* @__PURE__ */ $.createElement(As.Provider, {
    value: o
  }, t);
}, jDe = /* @__PURE__ */ Ca(void 0), LDe = (e) => {
  const {
    space: t,
    form: n,
    children: r
  } = e;
  if (r == null)
    return null;
  let i = r;
  return n && (i = /* @__PURE__ */ j.createElement(DDe, {
    override: !0,
    status: !0
  }, i)), t && (i = /* @__PURE__ */ j.createElement(eNe, null, i)), i;
}, Pv = LDe, FDe = (e) => {
  const {
    prefixCls: t,
    className: n,
    style: r,
    size: i,
    shape: o
  } = e, a = Ee({
    [`${t}-lg`]: i === "large",
    [`${t}-sm`]: i === "small"
  }), s = Ee({
    [`${t}-circle`]: o === "circle",
    [`${t}-square`]: o === "square",
    [`${t}-round`]: o === "round"
  }), c = $.useMemo(() => typeof i == "number" ? {
    width: i,
    height: i,
    lineHeight: `${i}px`
  } : {}, [i]);
  return /* @__PURE__ */ $.createElement("span", {
    className: Ee(t, a, s, n),
    style: Object.assign(Object.assign({}, c), r)
  });
}, KE = FDe, VDe = new Pn("ant-skeleton-loading", {
  "0%": {
    backgroundPosition: "100% 50%"
  },
  "100%": {
    backgroundPosition: "0 50%"
  }
}), YE = (e) => ({
  height: e,
  lineHeight: et(e)
}), gg = (e) => Object.assign({
  width: e
}, YE(e)), BDe = (e) => ({
  background: e.skeletonLoadingBackground,
  backgroundSize: "400% 100%",
  animationName: VDe,
  animationDuration: e.skeletonLoadingMotionDuration,
  animationTimingFunction: "ease",
  animationIterationCount: "infinite"
}), $T = (e, t) => Object.assign({
  width: t(e).mul(5).equal(),
  minWidth: t(e).mul(5).equal()
}, YE(e)), zDe = (e) => {
  const {
    skeletonAvatarCls: t,
    gradientFromColor: n,
    controlHeight: r,
    controlHeightLG: i,
    controlHeightSM: o
  } = e;
  return {
    [t]: Object.assign({
      display: "inline-block",
      verticalAlign: "top",
      background: n
    }, gg(r)),
    [`${t}${t}-circle`]: {
      borderRadius: "50%"
    },
    [`${t}${t}-lg`]: Object.assign({}, gg(i)),
    [`${t}${t}-sm`]: Object.assign({}, gg(o))
  };
}, HDe = (e) => {
  const {
    controlHeight: t,
    borderRadiusSM: n,
    skeletonInputCls: r,
    controlHeightLG: i,
    controlHeightSM: o,
    gradientFromColor: a,
    calc: s
  } = e;
  return {
    [r]: Object.assign({
      display: "inline-block",
      verticalAlign: "top",
      background: a,
      borderRadius: n
    }, $T(t, s)),
    [`${r}-lg`]: Object.assign({}, $T(i, s)),
    [`${r}-sm`]: Object.assign({}, $T(o, s))
  };
}, uF = (e) => Object.assign({
  width: e
}, YE(e)), UDe = (e) => {
  const {
    skeletonImageCls: t,
    imageSizeBase: n,
    gradientFromColor: r,
    borderRadiusSM: i,
    calc: o
  } = e;
  return {
    [t]: Object.assign(Object.assign({
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      verticalAlign: "middle",
      background: r,
      borderRadius: i
    }, uF(o(n).mul(2).equal())), {
      [`${t}-path`]: {
        fill: "#bfbfbf"
      },
      [`${t}-svg`]: Object.assign(Object.assign({}, uF(n)), {
        maxWidth: o(n).mul(4).equal(),
        maxHeight: o(n).mul(4).equal()
      }),
      [`${t}-svg${t}-svg-circle`]: {
        borderRadius: "50%"
      }
    }),
    [`${t}${t}-circle`]: {
      borderRadius: "50%"
    }
  };
}, AT = (e, t, n) => {
  const {
    skeletonButtonCls: r
  } = e;
  return {
    [`${n}${r}-circle`]: {
      width: t,
      minWidth: t,
      borderRadius: "50%"
    },
    [`${n}${r}-round`]: {
      borderRadius: t
    }
  };
}, RT = (e, t) => Object.assign({
  width: t(e).mul(2).equal(),
  minWidth: t(e).mul(2).equal()
}, YE(e)), WDe = (e) => {
  const {
    borderRadiusSM: t,
    skeletonButtonCls: n,
    controlHeight: r,
    controlHeightLG: i,
    controlHeightSM: o,
    gradientFromColor: a,
    calc: s
  } = e;
  return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
    [n]: Object.assign({
      display: "inline-block",
      verticalAlign: "top",
      background: a,
      borderRadius: t,
      width: s(r).mul(2).equal(),
      minWidth: s(r).mul(2).equal()
    }, RT(r, s))
  }, AT(e, r, n)), {
    [`${n}-lg`]: Object.assign({}, RT(i, s))
  }), AT(e, i, `${n}-lg`)), {
    [`${n}-sm`]: Object.assign({}, RT(o, s))
  }), AT(e, o, `${n}-sm`));
}, qDe = (e) => {
  const {
    componentCls: t,
    skeletonAvatarCls: n,
    skeletonTitleCls: r,
    skeletonParagraphCls: i,
    skeletonButtonCls: o,
    skeletonInputCls: a,
    skeletonImageCls: s,
    controlHeight: c,
    controlHeightLG: l,
    controlHeightSM: u,
    gradientFromColor: d,
    padding: f,
    marginSM: h,
    borderRadius: p,
    titleHeight: g,
    blockRadius: m,
    paragraphLiHeight: v,
    controlHeightXS: y,
    paragraphMarginTop: _
  } = e;
  return {
    [t]: {
      display: "table",
      width: "100%",
      [`${t}-header`]: {
        display: "table-cell",
        paddingInlineEnd: f,
        verticalAlign: "top",
        // Avatar
        [n]: Object.assign({
          display: "inline-block",
          verticalAlign: "top",
          background: d
        }, gg(c)),
        [`${n}-circle`]: {
          borderRadius: "50%"
        },
        [`${n}-lg`]: Object.assign({}, gg(l)),
        [`${n}-sm`]: Object.assign({}, gg(u))
      },
      [`${t}-content`]: {
        display: "table-cell",
        width: "100%",
        verticalAlign: "top",
        // Title
        [r]: {
          width: "100%",
          height: g,
          background: d,
          borderRadius: m,
          [`+ ${i}`]: {
            marginBlockStart: u
          }
        },
        // paragraph
        [i]: {
          padding: 0,
          "> li": {
            width: "100%",
            height: v,
            listStyle: "none",
            background: d,
            borderRadius: m,
            "+ li": {
              marginBlockStart: y
            }
          }
        },
        [`${i}> li:last-child:not(:first-child):not(:nth-child(2))`]: {
          width: "61%"
        }
      },
      [`&-round ${t}-content`]: {
        [`${r}, ${i} > li`]: {
          borderRadius: p
        }
      }
    },
    [`${t}-with-avatar ${t}-content`]: {
      // Title
      [r]: {
        marginBlockStart: h,
        [`+ ${i}`]: {
          marginBlockStart: _
        }
      }
    },
    // Skeleton element
    [`${t}${t}-element`]: Object.assign(Object.assign(Object.assign(Object.assign({
      display: "inline-block",
      width: "auto"
    }, WDe(e)), zDe(e)), HDe(e)), UDe(e)),
    // Skeleton Block Button, Input
    [`${t}${t}-block`]: {
      width: "100%",
      [o]: {
        width: "100%"
      },
      [a]: {
        width: "100%"
      }
    },
    // With active animation
    [`${t}${t}-active`]: {
      [`
        ${r},
        ${i} > li,
        ${n},
        ${o},
        ${a},
        ${s}
      `]: Object.assign({}, BDe(e))
    }
  };
}, GDe = (e) => {
  const {
    colorFillContent: t,
    colorFill: n
  } = e, r = t, i = n;
  return {
    color: r,
    colorGradientEnd: i,
    gradientFromColor: r,
    gradientToColor: i,
    titleHeight: e.controlHeight / 2,
    blockRadius: e.borderRadiusSM,
    paragraphMarginTop: e.marginLG + e.marginXXS,
    paragraphLiHeight: e.controlHeight / 2
  };
}, Yp = Za("Skeleton", (e) => {
  const {
    componentCls: t,
    calc: n
  } = e, r = Mr(e, {
    skeletonAvatarCls: `${t}-avatar`,
    skeletonTitleCls: `${t}-title`,
    skeletonParagraphCls: `${t}-paragraph`,
    skeletonButtonCls: `${t}-button`,
    skeletonInputCls: `${t}-input`,
    skeletonImageCls: `${t}-image`,
    imageSizeBase: n(e.controlHeight).mul(1.5).equal(),
    borderRadius: 100,
    // Large number to make capsule shape
    skeletonLoadingBackground: `linear-gradient(90deg, ${e.gradientFromColor} 25%, ${e.gradientToColor} 37%, ${e.gradientFromColor} 63%)`,
    skeletonLoadingMotionDuration: "1.4s"
  });
  return [qDe(r)];
}, GDe, {
  deprecatedTokens: [["color", "gradientFromColor"], ["colorGradientEnd", "gradientToColor"]]
}), KDe = (e) => {
  const {
    prefixCls: t,
    className: n,
    rootClassName: r,
    active: i,
    shape: o = "circle",
    size: a = "default"
  } = e, {
    getPrefixCls: s
  } = $.useContext(Cn), c = s("skeleton", t), [l, u, d] = Yp(c), f = rd(e, ["prefixCls", "className"]), h = Ee(c, `${c}-element`, {
    [`${c}-active`]: i
  }, n, r, u, d);
  return l(/* @__PURE__ */ $.createElement("div", {
    className: h
  }, /* @__PURE__ */ $.createElement(KE, Object.assign({
    prefixCls: `${c}-avatar`,
    shape: o,
    size: a
  }, f))));
}, YDe = KDe, XDe = (e) => {
  const {
    prefixCls: t,
    className: n,
    rootClassName: r,
    active: i,
    block: o = !1,
    size: a = "default"
  } = e, {
    getPrefixCls: s
  } = $.useContext(Cn), c = s("skeleton", t), [l, u, d] = Yp(c), f = rd(e, ["prefixCls"]), h = Ee(c, `${c}-element`, {
    [`${c}-active`]: i,
    [`${c}-block`]: o
  }, n, r, u, d);
  return l(/* @__PURE__ */ $.createElement("div", {
    className: h
  }, /* @__PURE__ */ $.createElement(KE, Object.assign({
    prefixCls: `${c}-button`,
    size: a
  }, f))));
}, QDe = XDe, JDe = "M365.714286 329.142857q0 45.714286-32.036571 77.677714t-77.677714 32.036571-77.677714-32.036571-32.036571-77.677714 32.036571-77.677714 77.677714-32.036571 77.677714 32.036571 32.036571 77.677714zM950.857143 548.571429l0 256-804.571429 0 0-109.714286 182.857143-182.857143 91.428571 91.428571 292.571429-292.571429zM1005.714286 146.285714l-914.285714 0q-7.460571 0-12.873143 5.412571t-5.412571 12.873143l0 694.857143q0 7.460571 5.412571 12.873143t12.873143 5.412571l914.285714 0q7.460571 0 12.873143-5.412571t5.412571-12.873143l0-694.857143q0-7.460571-5.412571-12.873143t-12.873143-5.412571zM1097.142857 164.571429l0 694.857143q0 37.741714-26.843429 64.585143t-64.585143 26.843429l-914.285714 0q-37.741714 0-64.585143-26.843429t-26.843429-64.585143l0-694.857143q0-37.741714 26.843429-64.585143t64.585143-26.843429l914.285714 0q37.741714 0 64.585143 26.843429t26.843429 64.585143z", ZDe = (e) => {
  const {
    prefixCls: t,
    className: n,
    rootClassName: r,
    style: i,
    active: o
  } = e, {
    getPrefixCls: a
  } = $.useContext(Cn), s = a("skeleton", t), [c, l, u] = Yp(s), d = Ee(s, `${s}-element`, {
    [`${s}-active`]: o
  }, n, r, l, u);
  return c(/* @__PURE__ */ $.createElement("div", {
    className: d
  }, /* @__PURE__ */ $.createElement("div", {
    className: Ee(`${s}-image`, n),
    style: i
  }, /* @__PURE__ */ $.createElement("svg", {
    viewBox: "0 0 1098 1024",
    xmlns: "http://www.w3.org/2000/svg",
    className: `${s}-image-svg`
  }, /* @__PURE__ */ $.createElement("title", null, "Image placeholder"), /* @__PURE__ */ $.createElement("path", {
    d: JDe,
    className: `${s}-image-path`
  })))));
}, e8e = ZDe, t8e = (e) => {
  const {
    prefixCls: t,
    className: n,
    rootClassName: r,
    active: i,
    block: o,
    size: a = "default"
  } = e, {
    getPrefixCls: s
  } = $.useContext(Cn), c = s("skeleton", t), [l, u, d] = Yp(c), f = rd(e, ["prefixCls"]), h = Ee(c, `${c}-element`, {
    [`${c}-active`]: i,
    [`${c}-block`]: o
  }, n, r, u, d);
  return l(/* @__PURE__ */ $.createElement("div", {
    className: h
  }, /* @__PURE__ */ $.createElement(KE, Object.assign({
    prefixCls: `${c}-input`,
    size: a
  }, f))));
}, n8e = t8e, r8e = (e) => {
  const {
    prefixCls: t,
    className: n,
    rootClassName: r,
    style: i,
    active: o,
    children: a
  } = e, {
    getPrefixCls: s
  } = $.useContext(Cn), c = s("skeleton", t), [l, u, d] = Yp(c), f = Ee(c, `${c}-element`, {
    [`${c}-active`]: o
  }, u, n, r, d);
  return l(/* @__PURE__ */ $.createElement("div", {
    className: f
  }, /* @__PURE__ */ $.createElement("div", {
    className: Ee(`${c}-image`, n),
    style: i
  }, a)));
}, i8e = r8e, o8e = (e, t) => {
  const {
    width: n,
    rows: r = 2
  } = t;
  if (Array.isArray(n))
    return n[e];
  if (r - 1 === e)
    return n;
}, a8e = (e) => {
  const {
    prefixCls: t,
    className: n,
    style: r,
    rows: i
  } = e, o = tt(new Array(i)).map((a, s) => (
    // eslint-disable-next-line react/no-array-index-key
    /* @__PURE__ */ $.createElement("li", {
      key: s,
      style: {
        width: o8e(s, e)
      }
    })
  ));
  return /* @__PURE__ */ $.createElement("ul", {
    className: Ee(t, n),
    style: r
  }, o);
}, s8e = a8e, c8e = (e) => {
  let {
    prefixCls: t,
    className: n,
    width: r,
    style: i
  } = e;
  return (
    // biome-ignore lint/a11y/useHeadingContent: HOC here
    /* @__PURE__ */ $.createElement("h3", {
      className: Ee(t, n),
      style: Object.assign({
        width: r
      }, i)
    })
  );
}, l8e = c8e;
function PT(e) {
  return e && typeof e == "object" ? e : {};
}
function u8e(e, t) {
  return e && !t ? {
    size: "large",
    shape: "square"
  } : {
    size: "large",
    shape: "circle"
  };
}
function d8e(e, t) {
  return !e && t ? {
    width: "38%"
  } : e && t ? {
    width: "50%"
  } : {};
}
function f8e(e, t) {
  const n = {};
  return (!e || !t) && (n.width = "61%"), !e && t ? n.rows = 3 : n.rows = 2, n;
}
const Kf = (e) => {
  const {
    prefixCls: t,
    loading: n,
    className: r,
    rootClassName: i,
    style: o,
    children: a,
    avatar: s = !1,
    title: c = !0,
    paragraph: l = !0,
    active: u,
    round: d
  } = e, {
    getPrefixCls: f,
    direction: h,
    skeleton: p
  } = $.useContext(Cn), g = f("skeleton", t), [m, v, y] = Yp(g);
  if (n || !("loading" in e)) {
    const _ = !!s, b = !!c, w = !!l;
    let C;
    if (_) {
      const E = Object.assign(Object.assign({
        prefixCls: `${g}-avatar`
      }, u8e(b, w)), PT(s));
      C = /* @__PURE__ */ $.createElement("div", {
        className: `${g}-header`
      }, /* @__PURE__ */ $.createElement(KE, Object.assign({}, E)));
    }
    let x;
    if (b || w) {
      let E;
      if (b) {
        const I = Object.assign(Object.assign({
          prefixCls: `${g}-title`
        }, d8e(_, w)), PT(c));
        E = /* @__PURE__ */ $.createElement(l8e, Object.assign({}, I));
      }
      let R;
      if (w) {
        const I = Object.assign(Object.assign({
          prefixCls: `${g}-paragraph`
        }, f8e(_, b)), PT(l));
        R = /* @__PURE__ */ $.createElement(s8e, Object.assign({}, I));
      }
      x = /* @__PURE__ */ $.createElement("div", {
        className: `${g}-content`
      }, E, R);
    }
    const T = Ee(g, {
      [`${g}-with-avatar`]: _,
      [`${g}-active`]: u,
      [`${g}-rtl`]: h === "rtl",
      [`${g}-round`]: d
    }, p == null ? void 0 : p.className, r, i, v, y);
    return m(/* @__PURE__ */ $.createElement("div", {
      className: T,
      style: Object.assign(Object.assign({}, p == null ? void 0 : p.style), o)
    }, C, x));
  }
  return a ?? null;
};
Kf.Button = QDe;
Kf.Avatar = YDe;
Kf.Input = n8e;
Kf.Image = e8e;
Kf.Node = i8e;
process.env.NODE_ENV !== "production" && (Kf.displayName = "Skeleton");
const dF = Kf, h8e = /* @__PURE__ */ j.createContext({});
function g8e(e) {
  return (t) => /* @__PURE__ */ $.createElement(go, {
    theme: {
      token: {
        motion: !1,
        zIndexPopupBase: 0
      }
    }
  }, /* @__PURE__ */ $.createElement(e, Object.assign({}, t)));
}
const p8e = (e, t, n, r) => g8e((o) => {
  const {
    prefixCls: a,
    style: s
  } = o, c = $.useRef(null), [l, u] = $.useState(0), [d, f] = $.useState(0), [h, p] = wc(!1, {
    value: o.open
  }), {
    getPrefixCls: g
  } = $.useContext(Cn), m = g(t || "select", a);
  $.useEffect(() => {
    if (p(!0), typeof ResizeObserver < "u") {
      const _ = new ResizeObserver((w) => {
        const C = w[0].target;
        u(C.offsetHeight + 8), f(C.offsetWidth);
      }), b = setInterval(() => {
        var w;
        const C = n ? `.${n(m)}` : `.${m}-dropdown`, x = (w = c.current) === null || w === void 0 ? void 0 : w.querySelector(C);
        x && (clearInterval(b), _.observe(x));
      }, 10);
      return () => {
        clearInterval(b), _.disconnect();
      };
    }
  }, []);
  let v = Object.assign(Object.assign({}, o), {
    style: Object.assign(Object.assign({}, s), {
      margin: 0
    }),
    open: h,
    visible: h,
    getPopupContainer: () => c.current
  });
  r && (v = r(v));
  const y = {
    paddingBottom: l,
    position: "relative",
    minWidth: d
  };
  return /* @__PURE__ */ $.createElement("div", {
    ref: c,
    style: y
  }, /* @__PURE__ */ $.createElement(e, Object.assign({}, v)));
}), m8e = p8e, FM = function() {
  if (typeof navigator > "u" || typeof window > "u")
    return !1;
  var e = navigator.userAgent || navigator.vendor || window.opera;
  return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(e) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(e == null ? void 0 : e.substr(0, 4));
};
var XE = function(t) {
  var n = t.className, r = t.customizeIcon, i = t.customizeIconProps, o = t.children, a = t.onMouseDown, s = t.onClick, c = typeof r == "function" ? r(i) : r;
  return /* @__PURE__ */ $.createElement("span", {
    className: n,
    onMouseDown: function(u) {
      u.preventDefault(), a == null || a(u);
    },
    style: {
      userSelect: "none",
      WebkitUserSelect: "none"
    },
    unselectable: "on",
    onClick: s,
    "aria-hidden": !0
  }, c !== void 0 ? c : /* @__PURE__ */ $.createElement("span", {
    className: Ee(n.split(/\s+/).map(function(l) {
      return "".concat(l, "-icon");
    }))
  }, o));
}, v8e = function(t, n, r, i, o) {
  var a = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : !1, s = arguments.length > 6 ? arguments[6] : void 0, c = arguments.length > 7 ? arguments[7] : void 0, l = j.useMemo(function() {
    if (It(i) === "object")
      return i.clearIcon;
    if (o)
      return o;
  }, [i, o]), u = j.useMemo(function() {
    return !!(!a && i && (r.length || s) && !(c === "combobox" && s === ""));
  }, [i, a, r.length, s, c]);
  return {
    allowClear: u,
    clearIcon: /* @__PURE__ */ j.createElement(XE, {
      className: "".concat(t, "-clear"),
      onMouseDown: n,
      customizeIcon: l
    }, "×")
  };
}, wZ = /* @__PURE__ */ $.createContext(null);
function y8e() {
  return $.useContext(wZ);
}
function b8e() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 10, t = $.useState(!1), n = he(t, 2), r = n[0], i = n[1], o = $.useRef(null), a = function() {
    window.clearTimeout(o.current);
  };
  $.useEffect(function() {
    return a;
  }, []);
  var s = function(l, u) {
    a(), o.current = window.setTimeout(function() {
      i(l), u && u();
    }, e);
  };
  return [r, s, a];
}
function xZ() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 250, t = $.useRef(null), n = $.useRef(null);
  $.useEffect(function() {
    return function() {
      window.clearTimeout(n.current);
    };
  }, []);
  function r(i) {
    (i || t.current === null) && (t.current = i), window.clearTimeout(n.current), n.current = window.setTimeout(function() {
      t.current = null;
    }, e);
  }
  return [function() {
    return t.current;
  }, r];
}
function _8e(e, t, n, r) {
  var i = $.useRef(null);
  i.current = {
    open: t,
    triggerOpen: n,
    customizedTrigger: r
  }, $.useEffect(function() {
    function o(a) {
      var s;
      if (!((s = i.current) !== null && s !== void 0 && s.customizedTrigger)) {
        var c = a.target;
        c.shadowRoot && a.composed && (c = a.composedPath()[0] || c), i.current.open && e().filter(function(l) {
          return l;
        }).every(function(l) {
          return !l.contains(c) && l !== c;
        }) && i.current.triggerOpen(!1);
      }
    }
    return window.addEventListener("mousedown", o), function() {
      return window.removeEventListener("mousedown", o);
    };
  }, []);
}
function S8e(e) {
  return ![
    // System function button
    Oe.ESC,
    Oe.SHIFT,
    Oe.BACKSPACE,
    Oe.TAB,
    Oe.WIN_KEY,
    Oe.ALT,
    Oe.META,
    Oe.WIN_KEY_RIGHT,
    Oe.CTRL,
    Oe.SEMICOLON,
    Oe.EQUALS,
    Oe.CAPS_LOCK,
    Oe.CONTEXT_MENU,
    // F1-F12
    Oe.F1,
    Oe.F2,
    Oe.F3,
    Oe.F4,
    Oe.F5,
    Oe.F6,
    Oe.F7,
    Oe.F8,
    Oe.F9,
    Oe.F10,
    Oe.F11,
    Oe.F12
  ].includes(e);
}
var w8e = ["prefixCls", "invalidate", "item", "renderItem", "responsive", "responsiveDisabled", "registerSize", "itemKey", "className", "style", "children", "display", "order", "component"], Sh = void 0;
function x8e(e, t) {
  var n = e.prefixCls, r = e.invalidate, i = e.item, o = e.renderItem, a = e.responsive, s = e.responsiveDisabled, c = e.registerSize, l = e.itemKey, u = e.className, d = e.style, f = e.children, h = e.display, p = e.order, g = e.component, m = g === void 0 ? "div" : g, v = En(e, w8e), y = a && !h;
  function _(T) {
    c(l, T);
  }
  $.useEffect(function() {
    return function() {
      _(null);
    };
  }, []);
  var b = o && i !== Sh ? o(i) : f, w;
  r || (w = {
    opacity: y ? 0 : 1,
    height: y ? 0 : Sh,
    overflowY: y ? "hidden" : Sh,
    order: a ? p : Sh,
    pointerEvents: y ? "none" : Sh,
    position: y ? "absolute" : Sh
  });
  var C = {};
  y && (C["aria-hidden"] = !0);
  var x = /* @__PURE__ */ $.createElement(m, xt({
    className: Ee(!r && n, u),
    style: ae(ae({}, w), d)
  }, C, v, {
    ref: t
  }), b);
  return a && (x = /* @__PURE__ */ $.createElement(Cl, {
    onResize: function(E) {
      var R = E.offsetWidth;
      _(R);
    },
    disabled: s
  }, x)), x;
}
var W0 = /* @__PURE__ */ $.forwardRef(x8e);
W0.displayName = "Item";
function E8e(e) {
  if (typeof MessageChannel > "u")
    Ln(e);
  else {
    var t = new MessageChannel();
    t.port1.onmessage = function() {
      return e();
    }, t.port2.postMessage(void 0);
  }
}
function C8e() {
  var e = $.useRef(null), t = function(r) {
    e.current || (e.current = [], E8e(function() {
      nO(function() {
        e.current.forEach(function(i) {
          i();
        }), e.current = null;
      });
    })), e.current.push(r);
  };
  return t;
}
function Om(e, t) {
  var n = $.useState(t), r = he(n, 2), i = r[0], o = r[1], a = Pr(function(s) {
    e(function() {
      o(s);
    });
  });
  return [i, a];
}
var dw = /* @__PURE__ */ j.createContext(null), T8e = ["component"], I8e = ["className"], $8e = ["className"], A8e = function(t, n) {
  var r = $.useContext(dw);
  if (!r) {
    var i = t.component, o = i === void 0 ? "div" : i, a = En(t, T8e);
    return /* @__PURE__ */ $.createElement(o, xt({}, a, {
      ref: n
    }));
  }
  var s = r.className, c = En(r, I8e), l = t.className, u = En(t, $8e);
  return /* @__PURE__ */ $.createElement(dw.Provider, {
    value: null
  }, /* @__PURE__ */ $.createElement(W0, xt({
    ref: n,
    className: Ee(s, l)
  }, c, u)));
}, EZ = /* @__PURE__ */ $.forwardRef(A8e);
EZ.displayName = "RawItem";
var R8e = ["prefixCls", "data", "renderItem", "renderRawItem", "itemKey", "itemWidth", "ssr", "style", "className", "maxCount", "renderRest", "renderRawRest", "suffix", "component", "itemComponent", "onVisibleChange"], CZ = "responsive", TZ = "invalidate";
function P8e(e) {
  return "+ ".concat(e.length, " ...");
}
function O8e(e, t) {
  var n = e.prefixCls, r = n === void 0 ? "rc-overflow" : n, i = e.data, o = i === void 0 ? [] : i, a = e.renderItem, s = e.renderRawItem, c = e.itemKey, l = e.itemWidth, u = l === void 0 ? 10 : l, d = e.ssr, f = e.style, h = e.className, p = e.maxCount, g = e.renderRest, m = e.renderRawRest, v = e.suffix, y = e.component, _ = y === void 0 ? "div" : y, b = e.itemComponent, w = e.onVisibleChange, C = En(e, R8e), x = d === "full", T = C8e(), E = Om(T, null), R = he(E, 2), I = R[0], O = R[1], P = I || 0, k = Om(T, /* @__PURE__ */ new Map()), L = he(k, 2), N = L[0], D = L[1], z = Om(T, 0), V = he(z, 2), B = V[0], U = V[1], Q = Om(T, 0), Y = he(Q, 2), q = Y[0], X = Y[1], ne = Om(T, 0), Z = he(ne, 2), J = Z[0], K = Z[1], ee = Qe(null), te = he(ee, 2), H = te[0], ie = te[1], W = Qe(null), se = he(W, 2), le = se[0], ge = se[1], me = $.useMemo(function() {
    return le === null && x ? Number.MAX_SAFE_INTEGER : le || 0;
  }, [le, I]), pe = Qe(!1), Te = he(pe, 2), de = Te[0], Ae = Te[1], ue = "".concat(r, "-item"), be = Math.max(B, q), Ie = p === CZ, Ve = o.length && Ie, ze = p === TZ, Ne = Ve || typeof p == "number" && o.length > p, lt = Tt(function() {
    var Ke = o;
    return Ve ? I === null && x ? Ke = o : Ke = o.slice(0, Math.min(o.length, P / u)) : typeof p == "number" && (Ke = o.slice(0, p)), Ke;
  }, [o, u, I, p, Ve]), mt = Tt(function() {
    return Ve ? o.slice(me + 1) : o.slice(lt.length);
  }, [o, lt, Ve, me]), vt = Wt(function(Ke, rt) {
    var Le;
    return typeof c == "function" ? c(Ke) : (Le = c && (Ke == null ? void 0 : Ke[c])) !== null && Le !== void 0 ? Le : rt;
  }, [c]), ke = Wt(a || function(Ke) {
    return Ke;
  }, [a]);
  function xe(Ke, rt, Le) {
    le === Ke && (rt === void 0 || rt === H) || (ge(Ke), Le || (Ae(Ke < o.length - 1), w == null || w(Ke)), rt !== void 0 && ie(rt));
  }
  function Re(Ke, rt) {
    O(rt.clientWidth);
  }
  function yt(Ke, rt) {
    D(function(Le) {
      var Xt = new Map(Le);
      return rt === null ? Xt.delete(Ke) : Xt.set(Ke, rt), Xt;
    });
  }
  function Pt(Ke, rt) {
    X(rt), U(q);
  }
  function _t(Ke, rt) {
    K(rt);
  }
  function St(Ke) {
    return N.get(vt(lt[Ke], Ke));
  }
  ar(function() {
    if (P && typeof be == "number" && lt) {
      var Ke = J, rt = lt.length, Le = rt - 1;
      if (!rt) {
        xe(0, null);
        return;
      }
      for (var Xt = 0; Xt < rt; Xt += 1) {
        var Ht = St(Xt);
        if (x && (Ht = Ht || 0), Ht === void 0) {
          xe(Xt - 1, void 0, !0);
          break;
        }
        if (Ke += Ht, // Only one means `totalWidth` is the final width
        Le === 0 && Ke <= P || // Last two width will be the final width
        Xt === Le - 1 && Ke + St(Le) <= P) {
          xe(Le, null);
          break;
        } else if (Ke + be > P) {
          xe(Xt - 1, Ke - Ht - J + q);
          break;
        }
      }
      v && St(0) + J > P && ie(null);
    }
  }, [P, N, q, J, vt, lt]);
  var ft = de && !!mt.length, kn = {};
  H !== null && Ve && (kn = {
    position: "absolute",
    left: H,
    top: 0
  });
  var Dt = {
    prefixCls: ue,
    responsive: Ve,
    component: b,
    invalidate: ze
  }, nt = s ? function(Ke, rt) {
    var Le = vt(Ke, rt);
    return /* @__PURE__ */ $.createElement(dw.Provider, {
      key: Le,
      value: ae(ae({}, Dt), {}, {
        order: rt,
        item: Ke,
        itemKey: Le,
        registerSize: yt,
        display: rt <= me
      })
    }, s(Ke, rt));
  } : function(Ke, rt) {
    var Le = vt(Ke, rt);
    return /* @__PURE__ */ $.createElement(W0, xt({}, Dt, {
      order: rt,
      key: Le,
      item: Ke,
      renderItem: ke,
      itemKey: Le,
      registerSize: yt,
      display: rt <= me
    }));
  }, Be, st = {
    order: ft ? me : Number.MAX_SAFE_INTEGER,
    className: "".concat(ue, "-rest"),
    registerSize: Pt,
    display: ft
  };
  if (m)
    m && (Be = /* @__PURE__ */ $.createElement(dw.Provider, {
      value: ae(ae({}, Dt), st)
    }, m(mt)));
  else {
    var pt = g || P8e;
    Be = /* @__PURE__ */ $.createElement(W0, xt({}, Dt, st), typeof pt == "function" ? pt(mt) : pt);
  }
  var Et = /* @__PURE__ */ $.createElement(_, xt({
    className: Ee(!ze && r, h),
    style: f,
    ref: t
  }, C), lt.map(nt), Ne ? Be : null, v && /* @__PURE__ */ $.createElement(W0, xt({}, Dt, {
    responsive: Ie,
    responsiveDisabled: !Ve,
    order: me,
    className: "".concat(ue, "-suffix"),
    registerSize: _t,
    display: !0,
    style: kn
  }), v));
  return Ie && (Et = /* @__PURE__ */ $.createElement(Cl, {
    onResize: Re,
    disabled: !Ve
  }, Et)), Et;
}
var Oy = /* @__PURE__ */ $.forwardRef(O8e);
Oy.displayName = "Overflow";
Oy.Item = EZ;
Oy.RESPONSIVE = CZ;
Oy.INVALIDATE = TZ;
var M8e = function(t, n) {
  var r, i = t.prefixCls, o = t.id, a = t.inputElement, s = t.disabled, c = t.tabIndex, l = t.autoFocus, u = t.autoComplete, d = t.editable, f = t.activeDescendantId, h = t.value, p = t.maxLength, g = t.onKeyDown, m = t.onMouseDown, v = t.onChange, y = t.onPaste, _ = t.onCompositionStart, b = t.onCompositionEnd, w = t.open, C = t.attrs, x = a || /* @__PURE__ */ $.createElement("input", null), T = x, E = T.ref, R = T.props, I = R.onKeyDown, O = R.onChange, P = R.onMouseDown, k = R.onCompositionStart, L = R.onCompositionEnd, N = R.style;
  return Du(!("maxLength" in x.props), "Passing 'maxLength' to input element directly may not work because input in BaseSelect is controlled."), x = /* @__PURE__ */ $.cloneElement(x, ae(ae(ae({
    type: "search"
  }, R), {}, {
    // Override over origin props
    id: o,
    ref: Ja(n, E),
    disabled: s,
    tabIndex: c,
    autoComplete: u || "off",
    autoFocus: l,
    className: Ee("".concat(i, "-selection-search-input"), (r = x) === null || r === void 0 || (r = r.props) === null || r === void 0 ? void 0 : r.className),
    role: "combobox",
    "aria-expanded": w || !1,
    "aria-haspopup": "listbox",
    "aria-owns": "".concat(o, "_list"),
    "aria-autocomplete": "list",
    "aria-controls": "".concat(o, "_list"),
    "aria-activedescendant": w ? f : void 0
  }, C), {}, {
    value: d ? h : "",
    maxLength: p,
    readOnly: !d,
    unselectable: d ? null : "on",
    style: ae(ae({}, N), {}, {
      opacity: d ? null : 0
    }),
    onKeyDown: function(z) {
      g(z), I && I(z);
    },
    onMouseDown: function(z) {
      m(z), P && P(z);
    },
    onChange: function(z) {
      v(z), O && O(z);
    },
    onCompositionStart: function(z) {
      _(z), k && k(z);
    },
    onCompositionEnd: function(z) {
      b(z), L && L(z);
    },
    onPaste: y
  })), x;
}, VM = /* @__PURE__ */ $.forwardRef(M8e);
process.env.NODE_ENV !== "production" && (VM.displayName = "Input");
function BM(e) {
  return Array.isArray(e) ? e : e !== void 0 ? [e] : [];
}
var k8e = typeof window < "u" && window.document && window.document.documentElement, N8e = process.env.NODE_ENV !== "test" && k8e;
function D8e(e) {
  return e != null;
}
function j8e(e) {
  return !e && e !== 0;
}
function fF(e) {
  return ["string", "number"].includes(It(e));
}
function IZ(e) {
  var t = void 0;
  return e && (fF(e.title) ? t = e.title.toString() : fF(e.label) && (t = e.label.toString())), t;
}
function L8e(e, t) {
  N8e ? $.useLayoutEffect(e, t) : $.useEffect(e, t);
}
function F8e(e) {
  var t;
  return (t = e.key) !== null && t !== void 0 ? t : e.value;
}
var hF = function(t) {
  t.preventDefault(), t.stopPropagation();
}, V8e = function(t) {
  var n = t.id, r = t.prefixCls, i = t.values, o = t.open, a = t.searchValue, s = t.autoClearSearchValue, c = t.inputRef, l = t.placeholder, u = t.disabled, d = t.mode, f = t.showSearch, h = t.autoFocus, p = t.autoComplete, g = t.activeDescendantId, m = t.tabIndex, v = t.removeIcon, y = t.maxTagCount, _ = t.maxTagTextLength, b = t.maxTagPlaceholder, w = b === void 0 ? function(ie) {
    return "+ ".concat(ie.length, " ...");
  } : b, C = t.tagRender, x = t.onToggleOpen, T = t.onRemove, E = t.onInputChange, R = t.onInputPaste, I = t.onInputKeyDown, O = t.onInputMouseDown, P = t.onInputCompositionStart, k = t.onInputCompositionEnd, L = $.useRef(null), N = Qe(0), D = he(N, 2), z = D[0], V = D[1], B = Qe(!1), U = he(B, 2), Q = U[0], Y = U[1], q = "".concat(r, "-selection"), X = o || d === "multiple" && s === !1 || d === "tags" ? a : "", ne = d === "tags" || d === "multiple" && s === !1 || f && (o || Q);
  L8e(function() {
    V(L.current.scrollWidth);
  }, [X]);
  var Z = function(W, se, le, ge, me) {
    return /* @__PURE__ */ $.createElement("span", {
      title: IZ(W),
      className: Ee("".concat(q, "-item"), oe({}, "".concat(q, "-item-disabled"), le))
    }, /* @__PURE__ */ $.createElement("span", {
      className: "".concat(q, "-item-content")
    }, se), ge && /* @__PURE__ */ $.createElement(XE, {
      className: "".concat(q, "-item-remove"),
      onMouseDown: hF,
      onClick: me,
      customizeIcon: v
    }, "×"));
  }, J = function(W, se, le, ge, me, pe) {
    var Te = function(Ae) {
      hF(Ae), x(!o);
    };
    return /* @__PURE__ */ $.createElement("span", {
      onMouseDown: Te
    }, C({
      label: se,
      value: W,
      disabled: le,
      closable: ge,
      onClose: me,
      isMaxTag: !!pe
    }));
  }, K = function(W) {
    var se = W.disabled, le = W.label, ge = W.value, me = !u && !se, pe = le;
    if (typeof _ == "number" && (typeof le == "string" || typeof le == "number")) {
      var Te = String(pe);
      Te.length > _ && (pe = "".concat(Te.slice(0, _), "..."));
    }
    var de = function(ue) {
      ue && ue.stopPropagation(), T(W);
    };
    return typeof C == "function" ? J(ge, pe, se, me, de) : Z(W, pe, se, me, de);
  }, ee = function(W) {
    var se = typeof w == "function" ? w(W) : w;
    return typeof C == "function" ? J(void 0, se, !1, !1, void 0, !0) : Z({
      title: se
    }, se, !1);
  }, te = /* @__PURE__ */ $.createElement("div", {
    className: "".concat(q, "-search"),
    style: {
      width: z
    },
    onFocus: function() {
      Y(!0);
    },
    onBlur: function() {
      Y(!1);
    }
  }, /* @__PURE__ */ $.createElement(VM, {
    ref: c,
    open: o,
    prefixCls: r,
    id: n,
    inputElement: null,
    disabled: u,
    autoFocus: h,
    autoComplete: p,
    editable: ne,
    activeDescendantId: g,
    value: X,
    onKeyDown: I,
    onMouseDown: O,
    onChange: E,
    onPaste: R,
    onCompositionStart: P,
    onCompositionEnd: k,
    tabIndex: m,
    attrs: xf(t, !0)
  }), /* @__PURE__ */ $.createElement("span", {
    ref: L,
    className: "".concat(q, "-search-mirror"),
    "aria-hidden": !0
  }, X, " ")), H = /* @__PURE__ */ $.createElement(Oy, {
    prefixCls: "".concat(q, "-overflow"),
    data: i,
    renderItem: K,
    renderRest: ee,
    suffix: te,
    itemKey: F8e,
    maxCount: y
  });
  return /* @__PURE__ */ $.createElement("span", {
    className: "".concat(q, "-wrap")
  }, H, !i.length && !X && /* @__PURE__ */ $.createElement("span", {
    className: "".concat(q, "-placeholder")
  }, l));
}, B8e = function(t) {
  var n = t.inputElement, r = t.prefixCls, i = t.id, o = t.inputRef, a = t.disabled, s = t.autoFocus, c = t.autoComplete, l = t.activeDescendantId, u = t.mode, d = t.open, f = t.values, h = t.placeholder, p = t.tabIndex, g = t.showSearch, m = t.searchValue, v = t.activeValue, y = t.maxLength, _ = t.onInputKeyDown, b = t.onInputMouseDown, w = t.onInputChange, C = t.onInputPaste, x = t.onInputCompositionStart, T = t.onInputCompositionEnd, E = t.title, R = $.useState(!1), I = he(R, 2), O = I[0], P = I[1], k = u === "combobox", L = k || g, N = f[0], D = m || "";
  k && v && !O && (D = v), $.useEffect(function() {
    k && P(!1);
  }, [k, v]);
  var z = u !== "combobox" && !d && !g ? !1 : !!D, V = E === void 0 ? IZ(N) : E, B = $.useMemo(function() {
    return N ? null : /* @__PURE__ */ $.createElement("span", {
      className: "".concat(r, "-selection-placeholder"),
      style: z ? {
        visibility: "hidden"
      } : void 0
    }, h);
  }, [N, z, h, r]);
  return /* @__PURE__ */ $.createElement("span", {
    className: "".concat(r, "-selection-wrap")
  }, /* @__PURE__ */ $.createElement("span", {
    className: "".concat(r, "-selection-search")
  }, /* @__PURE__ */ $.createElement(VM, {
    ref: o,
    prefixCls: r,
    id: i,
    open: d,
    inputElement: n,
    disabled: a,
    autoFocus: s,
    autoComplete: c,
    editable: L,
    activeDescendantId: l,
    value: D,
    onKeyDown: _,
    onMouseDown: b,
    onChange: function(Q) {
      P(!0), w(Q);
    },
    onPaste: C,
    onCompositionStart: x,
    onCompositionEnd: T,
    tabIndex: p,
    attrs: xf(t, !0),
    maxLength: k ? y : void 0
  })), !k && N ? /* @__PURE__ */ $.createElement("span", {
    className: "".concat(r, "-selection-item"),
    title: V,
    style: z ? {
      visibility: "hidden"
    } : void 0
  }, N.label) : null, B);
}, z8e = function(t, n) {
  var r = $e(null), i = $e(!1), o = t.prefixCls, a = t.open, s = t.mode, c = t.showSearch, l = t.tokenWithEnter, u = t.disabled, d = t.prefix, f = t.autoClearSearchValue, h = t.onSearch, p = t.onSearchSubmit, g = t.onToggleOpen, m = t.onInputKeyDown, v = t.domRef;
  $.useImperativeHandle(n, function() {
    return {
      focus: function(V) {
        r.current.focus(V);
      },
      blur: function() {
        r.current.blur();
      }
    };
  });
  var y = xZ(0), _ = he(y, 2), b = _[0], w = _[1], C = function(V) {
    var B = V.which, U = r.current instanceof HTMLTextAreaElement;
    !U && a && (B === Oe.UP || B === Oe.DOWN) && V.preventDefault(), m && m(V), B === Oe.ENTER && s === "tags" && !i.current && !a && (p == null || p(V.target.value)), !(U && !a && ~[Oe.UP, Oe.DOWN, Oe.LEFT, Oe.RIGHT].indexOf(B)) && S8e(B) && g(!0);
  }, x = function() {
    w(!0);
  }, T = $e(null), E = function(V) {
    h(V, !0, i.current) !== !1 && g(!0);
  }, R = function() {
    i.current = !0;
  }, I = function(V) {
    i.current = !1, s !== "combobox" && E(V.target.value);
  }, O = function(V) {
    var B = V.target.value;
    if (l && T.current && /[\r\n]/.test(T.current)) {
      var U = T.current.replace(/[\r\n]+$/, "").replace(/\r\n/g, " ").replace(/[\r\n]/g, " ");
      B = B.replace(U, T.current);
    }
    T.current = null, E(B);
  }, P = function(V) {
    var B = V.clipboardData, U = B == null ? void 0 : B.getData("text");
    T.current = U || "";
  }, k = function(V) {
    var B = V.target;
    if (B !== r.current) {
      var U = document.body.style.msTouchAction !== void 0;
      U ? setTimeout(function() {
        r.current.focus();
      }) : r.current.focus();
    }
  }, L = function(V) {
    var B = b();
    V.target !== r.current && !B && !(s === "combobox" && u) && V.preventDefault(), (s !== "combobox" && (!c || !B) || !a) && (a && f !== !1 && h("", !0, !1), g());
  }, N = {
    inputRef: r,
    onInputKeyDown: C,
    onInputMouseDown: x,
    onInputChange: O,
    onInputPaste: P,
    onInputCompositionStart: R,
    onInputCompositionEnd: I
  }, D = s === "multiple" || s === "tags" ? /* @__PURE__ */ $.createElement(V8e, xt({}, t, N)) : /* @__PURE__ */ $.createElement(B8e, xt({}, t, N));
  return /* @__PURE__ */ $.createElement("div", {
    ref: v,
    className: "".concat(o, "-selector"),
    onClick: k,
    onMouseDown: L
  }, d && /* @__PURE__ */ $.createElement("div", {
    className: "".concat(o, "-prefix")
  }, d), D);
}, $Z = /* @__PURE__ */ $.forwardRef(z8e);
process.env.NODE_ENV !== "production" && ($Z.displayName = "Selector");
function H8e(e) {
  var t = e.prefixCls, n = e.align, r = e.arrow, i = e.arrowPos, o = r || {}, a = o.className, s = o.content, c = i.x, l = c === void 0 ? 0 : c, u = i.y, d = u === void 0 ? 0 : u, f = $.useRef();
  if (!n || !n.points)
    return null;
  var h = {
    position: "absolute"
  };
  if (n.autoArrow !== !1) {
    var p = n.points[0], g = n.points[1], m = p[0], v = p[1], y = g[0], _ = g[1];
    m === y || !["t", "b"].includes(m) ? h.top = d : m === "t" ? h.top = 0 : h.bottom = 0, v === _ || !["l", "r"].includes(v) ? h.left = l : v === "l" ? h.left = 0 : h.right = 0;
  }
  return /* @__PURE__ */ $.createElement("div", {
    ref: f,
    className: Ee("".concat(t, "-arrow"), a),
    style: h
  }, s);
}
function U8e(e) {
  var t = e.prefixCls, n = e.open, r = e.zIndex, i = e.mask, o = e.motion;
  return i ? /* @__PURE__ */ $.createElement(Uf, xt({}, o, {
    motionAppear: !0,
    visible: n,
    removeOnLeave: !0
  }), function(a) {
    var s = a.className;
    return /* @__PURE__ */ $.createElement("div", {
      style: {
        zIndex: r
      },
      className: Ee("".concat(t, "-mask"), s)
    });
  }) : null;
}
var AZ = /* @__PURE__ */ $.memo(function(e) {
  var t = e.children;
  return t;
}, function(e, t) {
  return t.cache;
});
process.env.NODE_ENV !== "production" && (AZ.displayName = "PopupContent");
var RZ = /* @__PURE__ */ $.forwardRef(function(e, t) {
  var n = e.popup, r = e.className, i = e.prefixCls, o = e.style, a = e.target, s = e.onVisibleChanged, c = e.open, l = e.keepDom, u = e.fresh, d = e.onClick, f = e.mask, h = e.arrow, p = e.arrowPos, g = e.align, m = e.motion, v = e.maskMotion, y = e.forceRender, _ = e.getPopupContainer, b = e.autoDestroy, w = e.portal, C = e.zIndex, x = e.onMouseEnter, T = e.onMouseLeave, E = e.onPointerEnter, R = e.onPointerDownCapture, I = e.ready, O = e.offsetX, P = e.offsetY, k = e.offsetR, L = e.offsetB, N = e.onAlign, D = e.onPrepare, z = e.stretch, V = e.targetWidth, B = e.targetHeight, U = typeof n == "function" ? n() : n, Q = c || l, Y = (_ == null ? void 0 : _.length) > 0, q = $.useState(!_ || !Y), X = he(q, 2), ne = X[0], Z = X[1];
  if (ar(function() {
    !ne && Y && a && Z(!0);
  }, [ne, Y, a]), !ne)
    return null;
  var J = "auto", K = {
    left: "-1000vw",
    top: "-1000vh",
    right: J,
    bottom: J
  };
  if (I || !c) {
    var ee, te = g.points, H = g.dynamicInset || ((ee = g._experimental) === null || ee === void 0 ? void 0 : ee.dynamicInset), ie = H && te[0][1] === "r", W = H && te[0][0] === "b";
    ie ? (K.right = k, K.left = J) : (K.left = O, K.right = J), W ? (K.bottom = L, K.top = J) : (K.top = P, K.bottom = J);
  }
  var se = {};
  return z && (z.includes("height") && B ? se.height = B : z.includes("minHeight") && B && (se.minHeight = B), z.includes("width") && V ? se.width = V : z.includes("minWidth") && V && (se.minWidth = V)), c || (se.pointerEvents = "none"), /* @__PURE__ */ $.createElement(w, {
    open: y || Q,
    getContainer: _ && function() {
      return _(a);
    },
    autoDestroy: b
  }, /* @__PURE__ */ $.createElement(U8e, {
    prefixCls: i,
    open: c,
    zIndex: C,
    mask: f,
    motion: v
  }), /* @__PURE__ */ $.createElement(Cl, {
    onResize: N,
    disabled: !c
  }, function(le) {
    return /* @__PURE__ */ $.createElement(Uf, xt({
      motionAppear: !0,
      motionEnter: !0,
      motionLeave: !0,
      removeOnLeave: !1,
      forceRender: y,
      leavedClassName: "".concat(i, "-hidden")
    }, m, {
      onAppearPrepare: D,
      onEnterPrepare: D,
      visible: c,
      onVisibleChanged: function(me) {
        var pe;
        m == null || (pe = m.onVisibleChanged) === null || pe === void 0 || pe.call(m, me), s(me);
      }
    }), function(ge, me) {
      var pe = ge.className, Te = ge.style, de = Ee(i, pe, r);
      return /* @__PURE__ */ $.createElement("div", {
        ref: Ja(le, t, me),
        className: de,
        style: ae(ae(ae(ae({
          "--arrow-x": "".concat(p.x || 0, "px"),
          "--arrow-y": "".concat(p.y || 0, "px")
        }, K), se), Te), {}, {
          boxSizing: "border-box",
          zIndex: C
        }, o),
        onMouseEnter: x,
        onMouseLeave: T,
        onPointerEnter: E,
        onClick: d,
        onPointerDownCapture: R
      }, h && /* @__PURE__ */ $.createElement(H8e, {
        prefixCls: i,
        arrow: h,
        arrowPos: p,
        align: g
      }), /* @__PURE__ */ $.createElement(AZ, {
        cache: !c && !u
      }, U));
    });
  }));
});
process.env.NODE_ENV !== "production" && (RZ.displayName = "Popup");
var PZ = /* @__PURE__ */ $.forwardRef(function(e, t) {
  var n = e.children, r = e.getTriggerDOMNode, i = $y(n), o = $.useCallback(function(s) {
    aM(t, r ? r(s) : s);
  }, [r]), a = AE(o, n.ref);
  return i ? /* @__PURE__ */ $.cloneElement(n, {
    ref: a
  }) : n;
});
process.env.NODE_ENV !== "production" && (PZ.displayName = "TriggerWrapper");
var gF = /* @__PURE__ */ $.createContext(null);
function pF(e) {
  return e ? Array.isArray(e) ? e : [e] : [];
}
function W8e(e, t, n, r) {
  return $.useMemo(function() {
    var i = pF(n ?? t), o = pF(r ?? t), a = new Set(i), s = new Set(o);
    return e && (a.has("hover") && (a.delete("hover"), a.add("click")), s.has("hover") && (s.delete("hover"), s.add("click"))), [a, s];
  }, [e, t, n, r]);
}
function q8e() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], n = arguments.length > 2 ? arguments[2] : void 0;
  return n ? e[0] === t[0] : e[0] === t[0] && e[1] === t[1];
}
function G8e(e, t, n, r) {
  for (var i = n.points, o = Object.keys(e), a = 0; a < o.length; a += 1) {
    var s, c = o[a];
    if (q8e((s = e[c]) === null || s === void 0 ? void 0 : s.points, i, r))
      return "".concat(t, "-placement-").concat(c);
  }
  return "";
}
function mF(e, t, n, r) {
  return t || (n ? {
    motionName: "".concat(e, "-").concat(n)
  } : r ? {
    motionName: r
  } : null);
}
function My(e) {
  return e.ownerDocument.defaultView;
}
function yR(e) {
  for (var t = [], n = e == null ? void 0 : e.parentElement, r = ["hidden", "scroll", "clip", "auto"]; n; ) {
    var i = My(n).getComputedStyle(n), o = i.overflowX, a = i.overflowY, s = i.overflow;
    [o, a, s].some(function(c) {
      return r.includes(c);
    }) && t.push(n), n = n.parentElement;
  }
  return t;
}
function Ov(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  return Number.isNaN(e) ? t : e;
}
function Mm(e) {
  return Ov(parseFloat(e), 0);
}
function vF(e, t) {
  var n = ae({}, e);
  return (t || []).forEach(function(r) {
    if (!(r instanceof HTMLBodyElement || r instanceof HTMLHtmlElement)) {
      var i = My(r).getComputedStyle(r), o = i.overflow, a = i.overflowClipMargin, s = i.borderTopWidth, c = i.borderBottomWidth, l = i.borderLeftWidth, u = i.borderRightWidth, d = r.getBoundingClientRect(), f = r.offsetHeight, h = r.clientHeight, p = r.offsetWidth, g = r.clientWidth, m = Mm(s), v = Mm(c), y = Mm(l), _ = Mm(u), b = Ov(Math.round(d.width / p * 1e3) / 1e3), w = Ov(Math.round(d.height / f * 1e3) / 1e3), C = (p - g - y - _) * b, x = (f - h - m - v) * w, T = m * w, E = v * w, R = y * b, I = _ * b, O = 0, P = 0;
      if (o === "clip") {
        var k = Mm(a);
        O = k * b, P = k * w;
      }
      var L = d.x + R - O, N = d.y + T - P, D = L + d.width + 2 * O - R - I - C, z = N + d.height + 2 * P - T - E - x;
      n.left = Math.max(n.left, L), n.top = Math.max(n.top, N), n.right = Math.min(n.right, D), n.bottom = Math.min(n.bottom, z);
    }
  }), n;
}
function yF(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, n = "".concat(t), r = n.match(/^(.*)\%$/);
  return r ? e * (parseFloat(r[1]) / 100) : parseFloat(n);
}
function bF(e, t) {
  var n = t || [], r = he(n, 2), i = r[0], o = r[1];
  return [yF(e.width, i), yF(e.height, o)];
}
function _F() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
  return [e[0], e[1]];
}
function wh(e, t) {
  var n = t[0], r = t[1], i, o;
  return n === "t" ? o = e.y : n === "b" ? o = e.y + e.height : o = e.y + e.height / 2, r === "l" ? i = e.x : r === "r" ? i = e.x + e.width : i = e.x + e.width / 2, {
    x: i,
    y: o
  };
}
function kl(e, t) {
  var n = {
    t: "b",
    b: "t",
    l: "r",
    r: "l"
  };
  return e.map(function(r, i) {
    return i === t ? n[r] || "c" : r;
  }).join("");
}
function K8e(e, t, n, r, i, o, a) {
  var s = $.useState({
    ready: !1,
    offsetX: 0,
    offsetY: 0,
    offsetR: 0,
    offsetB: 0,
    arrowX: 0,
    arrowY: 0,
    scaleX: 1,
    scaleY: 1,
    align: i[r] || {}
  }), c = he(s, 2), l = c[0], u = c[1], d = $.useRef(0), f = $.useMemo(function() {
    return t ? yR(t) : [];
  }, [t]), h = $.useRef({}), p = function() {
    h.current = {};
  };
  e || p();
  var g = Pr(function() {
    if (t && n && e) {
      let Vo = function(Rl, Bo) {
        var Di = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : be, Pl = q.x + Rl, gd = q.y + Bo, uh = Pl + ie, Fs = gd + H, vm = Math.max(Pl, Di.left), wt = Math.max(gd, Di.top), zt = Math.min(uh, Di.right), On = Math.min(Fs, Di.bottom);
        return Math.max(0, (zt - vm) * (On - wt));
      }, lh = function() {
        $t = q.y + Le, Ct = $t + H, ut = q.x + rt, Mt = ut + ie;
      };
      var y, _, b, w, C = t, x = C.ownerDocument, T = My(C), E = T.getComputedStyle(C), R = E.width, I = E.height, O = E.position, P = C.style.left, k = C.style.top, L = C.style.right, N = C.style.bottom, D = C.style.overflow, z = ae(ae({}, i[r]), o), V = x.createElement("div");
      (y = C.parentElement) === null || y === void 0 || y.appendChild(V), V.style.left = "".concat(C.offsetLeft, "px"), V.style.top = "".concat(C.offsetTop, "px"), V.style.position = O, V.style.height = "".concat(C.offsetHeight, "px"), V.style.width = "".concat(C.offsetWidth, "px"), C.style.left = "0", C.style.top = "0", C.style.right = "auto", C.style.bottom = "auto", C.style.overflow = "hidden";
      var B;
      if (Array.isArray(n))
        B = {
          x: n[0],
          y: n[1],
          width: 0,
          height: 0
        };
      else {
        var U, Q, Y = n.getBoundingClientRect();
        Y.x = (U = Y.x) !== null && U !== void 0 ? U : Y.left, Y.y = (Q = Y.y) !== null && Q !== void 0 ? Q : Y.top, B = {
          x: Y.x,
          y: Y.y,
          width: Y.width,
          height: Y.height
        };
      }
      var q = C.getBoundingClientRect();
      q.x = (_ = q.x) !== null && _ !== void 0 ? _ : q.left, q.y = (b = q.y) !== null && b !== void 0 ? b : q.top;
      var X = x.documentElement, ne = X.clientWidth, Z = X.clientHeight, J = X.scrollWidth, K = X.scrollHeight, ee = X.scrollTop, te = X.scrollLeft, H = q.height, ie = q.width, W = B.height, se = B.width, le = {
        left: 0,
        top: 0,
        right: ne,
        bottom: Z
      }, ge = {
        left: -te,
        top: -ee,
        right: J - te,
        bottom: K - ee
      }, me = z.htmlRegion, pe = "visible", Te = "visibleFirst";
      me !== "scroll" && me !== Te && (me = pe);
      var de = me === Te, Ae = vF(ge, f), ue = vF(le, f), be = me === pe ? ue : Ae, Ie = de ? ue : be;
      C.style.left = "auto", C.style.top = "auto", C.style.right = "0", C.style.bottom = "0";
      var Ve = C.getBoundingClientRect();
      C.style.left = P, C.style.top = k, C.style.right = L, C.style.bottom = N, C.style.overflow = D, (w = C.parentElement) === null || w === void 0 || w.removeChild(V);
      var ze = Ov(Math.round(ie / parseFloat(R) * 1e3) / 1e3), Ne = Ov(Math.round(H / parseFloat(I) * 1e3) / 1e3);
      if (ze === 0 || Ne === 0 || _v(n) && !GJ(n))
        return;
      var lt = z.offset, mt = z.targetOffset, vt = bF(q, lt), ke = he(vt, 2), xe = ke[0], Re = ke[1], yt = bF(B, mt), Pt = he(yt, 2), _t = Pt[0], St = Pt[1];
      B.x -= _t, B.y -= St;
      var ft = z.points || [], kn = he(ft, 2), Dt = kn[0], nt = kn[1], Be = _F(nt), st = _F(Dt), pt = wh(B, Be), Et = wh(q, st), Ke = ae({}, z), rt = pt.x - Et.x + xe, Le = pt.y - Et.y + Re, Xt = Vo(rt, Le), Ht = Vo(rt, Le, ue), Ue = wh(B, ["t", "l"]), We = wh(q, ["t", "l"]), ct = wh(B, ["b", "r"]), ht = wh(q, ["b", "r"]), Rt = z.overflow || {}, Ft = Rt.adjustX, re = Rt.adjustY, Se = Rt.shiftX, De = Rt.shiftY, Ye = function(Bo) {
        return typeof Bo == "boolean" ? Bo : Bo >= 0;
      }, $t, Ct, ut, Mt;
      lh();
      var Xe = Ye(re), je = st[0] === Be[0];
      if (Xe && st[0] === "t" && (Ct > Ie.bottom || h.current.bt)) {
        var Ze = Le;
        je ? Ze -= H - W : Ze = Ue.y - ht.y - Re;
        var dt = Vo(rt, Ze), Ge = Vo(rt, Ze, ue);
        // Of course use larger one
        dt > Xt || dt === Xt && (!de || // Choose recommend one
        Ge >= Ht) ? (h.current.bt = !0, Le = Ze, Re = -Re, Ke.points = [kl(st, 0), kl(Be, 0)]) : h.current.bt = !1;
      }
      if (Xe && st[0] === "b" && ($t < Ie.top || h.current.tb)) {
        var Lt = Le;
        je ? Lt += H - W : Lt = ct.y - We.y - Re;
        var Ot = Vo(rt, Lt), xn = Vo(rt, Lt, ue);
        // Of course use larger one
        Ot > Xt || Ot === Xt && (!de || // Choose recommend one
        xn >= Ht) ? (h.current.tb = !0, Le = Lt, Re = -Re, Ke.points = [kl(st, 0), kl(Be, 0)]) : h.current.tb = !1;
      }
      var mr = Ye(Ft), Kn = st[1] === Be[1];
      if (mr && st[1] === "l" && (Mt > Ie.right || h.current.rl)) {
        var Tn = rt;
        Kn ? Tn -= ie - se : Tn = Ue.x - ht.x - xe;
        var Vr = Vo(Tn, Le), Yr = Vo(Tn, Le, ue);
        // Of course use larger one
        Vr > Xt || Vr === Xt && (!de || // Choose recommend one
        Yr >= Ht) ? (h.current.rl = !0, rt = Tn, xe = -xe, Ke.points = [kl(st, 1), kl(Be, 1)]) : h.current.rl = !1;
      }
      if (mr && st[1] === "r" && (ut < Ie.left || h.current.lr)) {
        var vr = rt;
        Kn ? vr += ie - se : vr = ct.x - We.x - xe;
        var Cr = Vo(vr, Le), Xr = Vo(vr, Le, ue);
        // Of course use larger one
        Cr > Xt || Cr === Xt && (!de || // Choose recommend one
        Xr >= Ht) ? (h.current.lr = !0, rt = vr, xe = -xe, Ke.points = [kl(st, 1), kl(Be, 1)]) : h.current.lr = !1;
      }
      lh();
      var Tr = Se === !0 ? 0 : Se;
      typeof Tr == "number" && (ut < ue.left && (rt -= ut - ue.left - xe, B.x + se < ue.left + Tr && (rt += B.x - ue.left + se - Tr)), Mt > ue.right && (rt -= Mt - ue.right - xe, B.x > ue.right - Tr && (rt += B.x - ue.right + Tr)));
      var Qr = De === !0 ? 0 : De;
      typeof Qr == "number" && ($t < ue.top && (Le -= $t - ue.top - Re, B.y + W < ue.top + Qr && (Le += B.y - ue.top + W - Qr)), Ct > ue.bottom && (Le -= Ct - ue.bottom - Re, B.y > ue.bottom - Qr && (Le += B.y - ue.bottom + Qr)));
      var Ti = q.x + rt, Ii = Ti + ie, Ni = q.y + Le, tr = Ni + H, Qt = B.x, Bt = Qt + se, nn = B.y, Jt = nn + W, Zt = Math.max(Ti, Qt), yn = Math.min(Ii, Bt), Ir = (Zt + yn) / 2, mi = Ir - Ti, un = Math.max(Ni, nn), ri = Math.min(tr, Jt), ii = (un + ri) / 2, Qi = ii - Ni;
      a == null || a(t, Ke);
      var Fo = Ve.right - q.x - (rt + q.width), yo = Ve.bottom - q.y - (Le + q.height);
      ze === 1 && (rt = Math.round(rt), Fo = Math.round(Fo)), Ne === 1 && (Le = Math.round(Le), yo = Math.round(yo));
      var bo = {
        ready: !0,
        offsetX: rt / ze,
        offsetY: Le / Ne,
        offsetR: Fo / ze,
        offsetB: yo / Ne,
        arrowX: mi / ze,
        arrowY: Qi / Ne,
        scaleX: ze,
        scaleY: Ne,
        align: Ke
      };
      u(bo);
    }
  }), m = function() {
    d.current += 1;
    var _ = d.current;
    Promise.resolve().then(function() {
      d.current === _ && g();
    });
  }, v = function() {
    u(function(_) {
      return ae(ae({}, _), {}, {
        ready: !1
      });
    });
  };
  return ar(v, [r]), ar(function() {
    e || v();
  }, [e]), [l.ready, l.offsetX, l.offsetY, l.offsetR, l.offsetB, l.arrowX, l.arrowY, l.scaleX, l.scaleY, l.align, m];
}
function Y8e(e, t, n, r, i) {
  ar(function() {
    if (e && t && n) {
      let d = function() {
        r(), i();
      };
      var o = t, a = n, s = yR(o), c = yR(a), l = My(a), u = new Set([l].concat(tt(s), tt(c)));
      return u.forEach(function(f) {
        f.addEventListener("scroll", d, {
          passive: !0
        });
      }), l.addEventListener("resize", d, {
        passive: !0
      }), r(), function() {
        u.forEach(function(f) {
          f.removeEventListener("scroll", d), l.removeEventListener("resize", d);
        });
      };
    }
  }, [e, t, n]);
}
function X8e(e, t, n, r, i, o, a, s) {
  var c = $.useRef(e);
  c.current = e;
  var l = $.useRef(!1);
  $.useEffect(function() {
    if (t && r && (!i || o)) {
      var d = function() {
        l.current = !1;
      }, f = function(b) {
        var w;
        c.current && !a(((w = b.composedPath) === null || w === void 0 || (w = w.call(b)) === null || w === void 0 ? void 0 : w[0]) || b.target) && !l.current && s(!1);
      }, h = My(r);
      h.addEventListener("pointerdown", d, !0), h.addEventListener("mousedown", f, !0), h.addEventListener("contextmenu", f, !0);
      var p = lw(n);
      if (p && (p.addEventListener("mousedown", f, !0), p.addEventListener("contextmenu", f, !0)), process.env.NODE_ENV !== "production") {
        var g, m, v = n == null || (g = n.getRootNode) === null || g === void 0 ? void 0 : g.call(n), y = (m = r.getRootNode) === null || m === void 0 ? void 0 : m.call(r);
        Du(v === y, "trigger element and popup element should in same shadow root.");
      }
      return function() {
        h.removeEventListener("pointerdown", d, !0), h.removeEventListener("mousedown", f, !0), h.removeEventListener("contextmenu", f, !0), p && (p.removeEventListener("mousedown", f, !0), p.removeEventListener("contextmenu", f, !0));
      };
    }
  }, [t, n, r, i, o]);
  function u() {
    l.current = !0;
  }
  return u;
}
var Q8e = ["prefixCls", "children", "action", "showAction", "hideAction", "popupVisible", "defaultPopupVisible", "onPopupVisibleChange", "afterPopupVisibleChange", "mouseEnterDelay", "mouseLeaveDelay", "focusDelay", "blurDelay", "mask", "maskClosable", "getPopupContainer", "forceRender", "autoDestroy", "destroyPopupOnHide", "popup", "popupClassName", "popupStyle", "popupPlacement", "builtinPlacements", "popupAlign", "zIndex", "stretch", "getPopupClassNameFromAlign", "fresh", "alignPoint", "onPopupClick", "onPopupAlign", "arrow", "popupMotion", "maskMotion", "popupTransitionName", "popupAnimation", "maskTransitionName", "maskAnimation", "className", "getTriggerDOMNode"];
function J8e() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : NM, t = /* @__PURE__ */ $.forwardRef(function(n, r) {
    var i = n.prefixCls, o = i === void 0 ? "rc-trigger-popup" : i, a = n.children, s = n.action, c = s === void 0 ? "hover" : s, l = n.showAction, u = n.hideAction, d = n.popupVisible, f = n.defaultPopupVisible, h = n.onPopupVisibleChange, p = n.afterPopupVisibleChange, g = n.mouseEnterDelay, m = n.mouseLeaveDelay, v = m === void 0 ? 0.1 : m, y = n.focusDelay, _ = n.blurDelay, b = n.mask, w = n.maskClosable, C = w === void 0 ? !0 : w, x = n.getPopupContainer, T = n.forceRender, E = n.autoDestroy, R = n.destroyPopupOnHide, I = n.popup, O = n.popupClassName, P = n.popupStyle, k = n.popupPlacement, L = n.builtinPlacements, N = L === void 0 ? {} : L, D = n.popupAlign, z = n.zIndex, V = n.stretch, B = n.getPopupClassNameFromAlign, U = n.fresh, Q = n.alignPoint, Y = n.onPopupClick, q = n.onPopupAlign, X = n.arrow, ne = n.popupMotion, Z = n.maskMotion, J = n.popupTransitionName, K = n.popupAnimation, ee = n.maskTransitionName, te = n.maskAnimation, H = n.className, ie = n.getTriggerDOMNode, W = En(n, Q8e), se = E || R || !1, le = $.useState(!1), ge = he(le, 2), me = ge[0], pe = ge[1];
    ar(function() {
      pe(FM());
    }, []);
    var Te = $.useRef({}), de = $.useContext(gF), Ae = $.useMemo(function() {
      return {
        registerSubPopup: function(zt, On) {
          Te.current[zt] = On, de == null || de.registerSubPopup(zt, On);
        }
      };
    }, [de]), ue = H7e(), be = $.useState(null), Ie = he(be, 2), Ve = Ie[0], ze = Ie[1], Ne = $.useRef(null), lt = Pr(function(wt) {
      Ne.current = wt, _v(wt) && Ve !== wt && ze(wt), de == null || de.registerSubPopup(ue, wt);
    }), mt = $.useState(null), vt = he(mt, 2), ke = vt[0], xe = vt[1], Re = $.useRef(null), yt = Pr(function(wt) {
      _v(wt) && ke !== wt && (xe(wt), Re.current = wt);
    }), Pt = $.Children.only(a), _t = (Pt == null ? void 0 : Pt.props) || {}, St = {}, ft = Pr(function(wt) {
      var zt, On, Jr = ke;
      return (Jr == null ? void 0 : Jr.contains(wt)) || ((zt = lw(Jr)) === null || zt === void 0 ? void 0 : zt.host) === wt || wt === Jr || (Ve == null ? void 0 : Ve.contains(wt)) || ((On = lw(Ve)) === null || On === void 0 ? void 0 : On.host) === wt || wt === Ve || Object.values(Te.current).some(function($r) {
        return ($r == null ? void 0 : $r.contains(wt)) || wt === $r;
      });
    }), kn = mF(o, ne, K, J), Dt = mF(o, Z, te, ee), nt = $.useState(f || !1), Be = he(nt, 2), st = Be[0], pt = Be[1], Et = d ?? st, Ke = Pr(function(wt) {
      d === void 0 && pt(wt);
    });
    ar(function() {
      pt(d || !1);
    }, [d]);
    var rt = $.useRef(Et);
    rt.current = Et;
    var Le = $.useRef([]);
    Le.current = [];
    var Xt = Pr(function(wt) {
      var zt;
      Ke(wt), ((zt = Le.current[Le.current.length - 1]) !== null && zt !== void 0 ? zt : Et) !== wt && (Le.current.push(wt), h == null || h(wt));
    }), Ht = $.useRef(), Ue = function() {
      clearTimeout(Ht.current);
    }, We = function(zt) {
      var On = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
      Ue(), On === 0 ? Xt(zt) : Ht.current = setTimeout(function() {
        Xt(zt);
      }, On * 1e3);
    };
    $.useEffect(function() {
      return Ue;
    }, []);
    var ct = $.useState(!1), ht = he(ct, 2), Rt = ht[0], Ft = ht[1];
    ar(function(wt) {
      (!wt || Et) && Ft(!0);
    }, [Et]);
    var re = $.useState(null), Se = he(re, 2), De = Se[0], Ye = Se[1], $t = $.useState(null), Ct = he($t, 2), ut = Ct[0], Mt = Ct[1], Xe = function(zt) {
      Mt([zt.clientX, zt.clientY]);
    }, je = K8e(Et, Ve, Q && ut !== null ? ut : ke, k, N, D, q), Ze = he(je, 11), dt = Ze[0], Ge = Ze[1], Lt = Ze[2], Ot = Ze[3], xn = Ze[4], mr = Ze[5], Kn = Ze[6], Tn = Ze[7], Vr = Ze[8], Yr = Ze[9], vr = Ze[10], Cr = W8e(me, c, l, u), Xr = he(Cr, 2), Tr = Xr[0], Qr = Xr[1], Ti = Tr.has("click"), Ii = Qr.has("click") || Qr.has("contextMenu"), Ni = Pr(function() {
      Rt || vr();
    }), tr = function() {
      rt.current && Q && Ii && We(!1);
    };
    Y8e(Et, ke, Ve, Ni, tr), ar(function() {
      Ni();
    }, [ut, k]), ar(function() {
      Et && !(N != null && N[k]) && Ni();
    }, [JSON.stringify(D)]);
    var Qt = $.useMemo(function() {
      var wt = G8e(N, o, Yr, Q);
      return Ee(wt, B == null ? void 0 : B(Yr));
    }, [Yr, B, N, o, Q]);
    $.useImperativeHandle(r, function() {
      return {
        nativeElement: Re.current,
        popupElement: Ne.current,
        forceAlign: Ni
      };
    });
    var Bt = $.useState(0), nn = he(Bt, 2), Jt = nn[0], Zt = nn[1], yn = $.useState(0), Ir = he(yn, 2), mi = Ir[0], un = Ir[1], ri = function() {
      if (V && ke) {
        var zt = ke.getBoundingClientRect();
        Zt(zt.width), un(zt.height);
      }
    }, ii = function() {
      ri(), Ni();
    }, Qi = function(zt) {
      Ft(!1), vr(), p == null || p(zt);
    }, Fo = function() {
      return new Promise(function(zt) {
        ri(), Ye(function() {
          return zt;
        });
      });
    };
    ar(function() {
      De && (vr(), De(), Ye(null));
    }, [De]);
    function yo(wt, zt, On, Jr) {
      St[wt] = function($r) {
        var Pc;
        Jr == null || Jr($r), We(zt, On);
        for (var Ol = arguments.length, ym = new Array(Ol > 1 ? Ol - 1 : 0), Vs = 1; Vs < Ol; Vs++)
          ym[Vs - 1] = arguments[Vs];
        (Pc = _t[wt]) === null || Pc === void 0 || Pc.call.apply(Pc, [_t, $r].concat(ym));
      };
    }
    (Ti || Ii) && (St.onClick = function(wt) {
      var zt;
      rt.current && Ii ? We(!1) : !rt.current && Ti && (Xe(wt), We(!0));
      for (var On = arguments.length, Jr = new Array(On > 1 ? On - 1 : 0), $r = 1; $r < On; $r++)
        Jr[$r - 1] = arguments[$r];
      (zt = _t.onClick) === null || zt === void 0 || zt.call.apply(zt, [_t, wt].concat(Jr));
    });
    var bo = X8e(Et, Ii, ke, Ve, b, C, ft, We), Vo = Tr.has("hover"), lh = Qr.has("hover"), Rl, Bo;
    Vo && (yo("onMouseEnter", !0, g, function(wt) {
      Xe(wt);
    }), yo("onPointerEnter", !0, g, function(wt) {
      Xe(wt);
    }), Rl = function(zt) {
      (Et || Rt) && Ve !== null && Ve !== void 0 && Ve.contains(zt.target) && We(!0, g);
    }, Q && (St.onMouseMove = function(wt) {
      var zt;
      (zt = _t.onMouseMove) === null || zt === void 0 || zt.call(_t, wt);
    })), lh && (yo("onMouseLeave", !1, v), yo("onPointerLeave", !1, v), Bo = function() {
      We(!1, v);
    }), Tr.has("focus") && yo("onFocus", !0, y), Qr.has("focus") && yo("onBlur", !1, _), Tr.has("contextMenu") && (St.onContextMenu = function(wt) {
      var zt;
      rt.current && Qr.has("contextMenu") ? We(!1) : (Xe(wt), We(!0)), wt.preventDefault();
      for (var On = arguments.length, Jr = new Array(On > 1 ? On - 1 : 0), $r = 1; $r < On; $r++)
        Jr[$r - 1] = arguments[$r];
      (zt = _t.onContextMenu) === null || zt === void 0 || zt.call.apply(zt, [_t, wt].concat(Jr));
    }), H && (St.className = Ee(_t.className, H));
    var Di = ae(ae({}, _t), St), Pl = {}, gd = ["onContextMenu", "onClick", "onMouseDown", "onTouchStart", "onMouseEnter", "onMouseLeave", "onFocus", "onBlur"];
    gd.forEach(function(wt) {
      W[wt] && (Pl[wt] = function() {
        for (var zt, On = arguments.length, Jr = new Array(On), $r = 0; $r < On; $r++)
          Jr[$r] = arguments[$r];
        (zt = Di[wt]) === null || zt === void 0 || zt.call.apply(zt, [Di].concat(Jr)), W[wt].apply(W, Jr);
      });
    });
    var uh = /* @__PURE__ */ $.cloneElement(Pt, ae(ae({}, Di), Pl)), Fs = {
      x: mr,
      y: Kn
    }, vm = X ? ae({}, X !== !0 ? X : {}) : null;
    return /* @__PURE__ */ $.createElement($.Fragment, null, /* @__PURE__ */ $.createElement(Cl, {
      disabled: !Et,
      ref: yt,
      onResize: ii
    }, /* @__PURE__ */ $.createElement(PZ, {
      getTriggerDOMNode: ie
    }, uh)), /* @__PURE__ */ $.createElement(gF.Provider, {
      value: Ae
    }, /* @__PURE__ */ $.createElement(RZ, {
      portal: e,
      ref: lt,
      prefixCls: o,
      popup: I,
      className: Ee(O, Qt),
      style: P,
      target: ke,
      onMouseEnter: Rl,
      onMouseLeave: Bo,
      onPointerEnter: Rl,
      zIndex: z,
      open: Et,
      keepDom: Rt,
      fresh: U,
      onClick: Y,
      onPointerDownCapture: bo,
      mask: b,
      motion: kn,
      maskMotion: Dt,
      onVisibleChanged: Qi,
      onPrepare: Fo,
      forceRender: T,
      autoDestroy: se,
      getPopupContainer: x,
      align: Yr,
      arrow: vm,
      arrowPos: Fs,
      ready: dt,
      offsetX: Ge,
      offsetY: Lt,
      offsetR: Ot,
      offsetB: xn,
      onAlign: Ni,
      stretch: V,
      targetWidth: Jt / Tn,
      targetHeight: mi / Vr
    })));
  });
  return process.env.NODE_ENV !== "production" && (t.displayName = "Trigger"), t;
}
const OZ = J8e(NM);
var Z8e = ["prefixCls", "disabled", "visible", "children", "popupElement", "animation", "transitionName", "dropdownStyle", "dropdownClassName", "direction", "placement", "builtinPlacements", "dropdownMatchSelectWidth", "dropdownRender", "dropdownAlign", "getPopupContainer", "empty", "getTriggerDOMNode", "onPopupVisibleChange", "onPopupMouseEnter"], eje = function(t) {
  var n = t === !0 ? 0 : 1;
  return {
    bottomLeft: {
      points: ["tl", "bl"],
      offset: [0, 4],
      overflow: {
        adjustX: n,
        adjustY: 1
      },
      htmlRegion: "scroll"
    },
    bottomRight: {
      points: ["tr", "br"],
      offset: [0, 4],
      overflow: {
        adjustX: n,
        adjustY: 1
      },
      htmlRegion: "scroll"
    },
    topLeft: {
      points: ["bl", "tl"],
      offset: [0, -4],
      overflow: {
        adjustX: n,
        adjustY: 1
      },
      htmlRegion: "scroll"
    },
    topRight: {
      points: ["br", "tr"],
      offset: [0, -4],
      overflow: {
        adjustX: n,
        adjustY: 1
      },
      htmlRegion: "scroll"
    }
  };
}, tje = function(t, n) {
  var r = t.prefixCls;
  t.disabled;
  var i = t.visible, o = t.children, a = t.popupElement, s = t.animation, c = t.transitionName, l = t.dropdownStyle, u = t.dropdownClassName, d = t.direction, f = d === void 0 ? "ltr" : d, h = t.placement, p = t.builtinPlacements, g = t.dropdownMatchSelectWidth, m = t.dropdownRender, v = t.dropdownAlign, y = t.getPopupContainer, _ = t.empty, b = t.getTriggerDOMNode, w = t.onPopupVisibleChange, C = t.onPopupMouseEnter, x = En(t, Z8e), T = "".concat(r, "-dropdown"), E = a;
  m && (E = m(a));
  var R = $.useMemo(function() {
    return p || eje(g);
  }, [p, g]), I = s ? "".concat(T, "-").concat(s) : c, O = typeof g == "number", P = $.useMemo(function() {
    return O ? null : g === !1 ? "minWidth" : "width";
  }, [g, O]), k = l;
  O && (k = ae(ae({}, k), {}, {
    width: g
  }));
  var L = $.useRef(null);
  return $.useImperativeHandle(n, function() {
    return {
      getPopupElement: function() {
        var D;
        return (D = L.current) === null || D === void 0 ? void 0 : D.popupElement;
      }
    };
  }), /* @__PURE__ */ $.createElement(OZ, xt({}, x, {
    showAction: w ? ["click"] : [],
    hideAction: w ? ["click"] : [],
    popupPlacement: h || (f === "rtl" ? "bottomRight" : "bottomLeft"),
    builtinPlacements: R,
    prefixCls: T,
    popupTransitionName: I,
    popup: /* @__PURE__ */ $.createElement("div", {
      onMouseEnter: C
    }, E),
    ref: L,
    stretch: P,
    popupAlign: v,
    popupVisible: i,
    getPopupContainer: y,
    popupClassName: Ee(u, oe({}, "".concat(T, "-empty"), _)),
    popupStyle: k,
    getTriggerDOMNode: b,
    onPopupVisibleChange: w
  }), o);
}, MZ = /* @__PURE__ */ $.forwardRef(tje);
process.env.NODE_ENV !== "production" && (MZ.displayName = "SelectTrigger");
function SF(e, t) {
  var n = e.key, r;
  return "value" in e && (r = e.value), n ?? (r !== void 0 ? r : "rc-index-key-".concat(t));
}
function bR(e) {
  return typeof e < "u" && !Number.isNaN(e);
}
function kZ(e, t) {
  var n = e || {}, r = n.label, i = n.value, o = n.options, a = n.groupLabel, s = r || (t ? "children" : "label");
  return {
    label: s,
    value: i || "value",
    options: o || "options",
    groupLabel: a || s
  };
}
function nje(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.fieldNames, r = t.childrenAsData, i = [], o = kZ(n, !1), a = o.label, s = o.value, c = o.options, l = o.groupLabel;
  function u(d, f) {
    Array.isArray(d) && d.forEach(function(h) {
      if (f || !(c in h)) {
        var p = h[s];
        i.push({
          key: SF(h, i.length),
          groupOption: f,
          data: h,
          label: h[a],
          value: p
        });
      } else {
        var g = h[l];
        g === void 0 && r && (g = h.label), i.push({
          key: SF(h, i.length),
          group: !0,
          data: h,
          label: g
        }), u(h[c], !0);
      }
    });
  }
  return u(e, !1), i;
}
function _R(e) {
  var t = ae({}, e);
  return "props" in t || Object.defineProperty(t, "props", {
    get: function() {
      return sn(!1, "Return type is option instead of Option instance. Please read value directly instead of reading from `props`."), t;
    }
  }), t;
}
var rje = function(t, n, r) {
  if (!n || !n.length)
    return null;
  var i = !1, o = function s(c, l) {
    var u = bQ(l), d = u[0], f = u.slice(1);
    if (!d)
      return [c];
    var h = c.split(d);
    return i = i || h.length > 1, h.reduce(function(p, g) {
      return [].concat(tt(p), tt(s(g, f)));
    }, []).filter(Boolean);
  }, a = o(t, n);
  return i ? typeof r < "u" ? a.slice(0, r) : a : null;
}, zM = /* @__PURE__ */ $.createContext(null);
function ije(e) {
  var t = e.visible, n = e.values;
  if (!t)
    return null;
  var r = 50;
  return /* @__PURE__ */ $.createElement("span", {
    "aria-live": "polite",
    style: {
      width: 0,
      height: 0,
      position: "absolute",
      overflow: "hidden",
      opacity: 0
    }
  }, "".concat(n.slice(0, r).map(function(i) {
    var o = i.label, a = i.value;
    return ["number", "string"].includes(It(o)) ? o : a;
  }).join(", ")), n.length > r ? ", ..." : null);
}
var oje = ["id", "prefixCls", "className", "showSearch", "tagRender", "direction", "omitDomProps", "displayValues", "onDisplayValuesChange", "emptyOptions", "notFoundContent", "onClear", "mode", "disabled", "loading", "getInputElement", "getRawInputElement", "open", "defaultOpen", "onDropdownVisibleChange", "activeValue", "onActiveValueChange", "activeDescendantId", "searchValue", "autoClearSearchValue", "onSearch", "onSearchSplit", "tokenSeparators", "allowClear", "prefix", "suffixIcon", "clearIcon", "OptionList", "animation", "transitionName", "dropdownStyle", "dropdownClassName", "dropdownMatchSelectWidth", "dropdownRender", "dropdownAlign", "placement", "builtinPlacements", "getPopupContainer", "showAction", "onFocus", "onBlur", "onKeyUp", "onKeyDown", "onMouseDown"], aje = ["value", "onChange", "removeIcon", "placeholder", "autoFocus", "maxTagCount", "maxTagTextLength", "maxTagPlaceholder", "choiceTransitionName", "onInputKeyDown", "onPopupScroll", "tabIndex"], fw = function(t) {
  return t === "tags" || t === "multiple";
}, NZ = /* @__PURE__ */ $.forwardRef(function(e, t) {
  var n, r = e.id, i = e.prefixCls, o = e.className, a = e.showSearch, s = e.tagRender, c = e.direction, l = e.omitDomProps, u = e.displayValues, d = e.onDisplayValuesChange, f = e.emptyOptions, h = e.notFoundContent, p = h === void 0 ? "Not Found" : h, g = e.onClear, m = e.mode, v = e.disabled, y = e.loading, _ = e.getInputElement, b = e.getRawInputElement, w = e.open, C = e.defaultOpen, x = e.onDropdownVisibleChange, T = e.activeValue, E = e.onActiveValueChange, R = e.activeDescendantId, I = e.searchValue, O = e.autoClearSearchValue, P = e.onSearch, k = e.onSearchSplit, L = e.tokenSeparators, N = e.allowClear, D = e.prefix, z = e.suffixIcon, V = e.clearIcon, B = e.OptionList, U = e.animation, Q = e.transitionName, Y = e.dropdownStyle, q = e.dropdownClassName, X = e.dropdownMatchSelectWidth, ne = e.dropdownRender, Z = e.dropdownAlign, J = e.placement, K = e.builtinPlacements, ee = e.getPopupContainer, te = e.showAction, H = te === void 0 ? [] : te, ie = e.onFocus, W = e.onBlur, se = e.onKeyUp, le = e.onKeyDown, ge = e.onMouseDown, me = En(e, oje), pe = fw(m), Te = (a !== void 0 ? a : pe) || m === "combobox", de = ae({}, me);
  aje.forEach(function(Qt) {
    delete de[Qt];
  }), l == null || l.forEach(function(Qt) {
    delete de[Qt];
  });
  var Ae = $.useState(!1), ue = he(Ae, 2), be = ue[0], Ie = ue[1];
  $.useEffect(function() {
    Ie(FM());
  }, []);
  var Ve = $.useRef(null), ze = $.useRef(null), Ne = $.useRef(null), lt = $.useRef(null), mt = $.useRef(null), vt = $.useRef(!1), ke = b8e(), xe = he(ke, 3), Re = xe[0], yt = xe[1], Pt = xe[2];
  $.useImperativeHandle(t, function() {
    var Qt, Bt;
    return {
      focus: (Qt = lt.current) === null || Qt === void 0 ? void 0 : Qt.focus,
      blur: (Bt = lt.current) === null || Bt === void 0 ? void 0 : Bt.blur,
      scrollTo: function(Jt) {
        var Zt;
        return (Zt = mt.current) === null || Zt === void 0 ? void 0 : Zt.scrollTo(Jt);
      },
      nativeElement: Ve.current || ze.current
    };
  });
  var _t = $.useMemo(function() {
    var Qt;
    if (m !== "combobox")
      return I;
    var Bt = (Qt = u[0]) === null || Qt === void 0 ? void 0 : Qt.value;
    return typeof Bt == "string" || typeof Bt == "number" ? String(Bt) : "";
  }, [I, m, u]), St = m === "combobox" && typeof _ == "function" && _() || null, ft = typeof b == "function" && b(), kn = AE(ze, ft == null || (n = ft.props) === null || n === void 0 ? void 0 : n.ref), Dt = $.useState(!1), nt = he(Dt, 2), Be = nt[0], st = nt[1];
  ar(function() {
    st(!0);
  }, []);
  var pt = wc(!1, {
    defaultValue: C,
    value: w
  }), Et = he(pt, 2), Ke = Et[0], rt = Et[1], Le = Be ? Ke : !1, Xt = !p && f;
  (v || Xt && Le && m === "combobox") && (Le = !1);
  var Ht = Xt ? !1 : Le, Ue = $.useCallback(function(Qt) {
    var Bt = Qt !== void 0 ? Qt : !Le;
    v || (rt(Bt), Le !== Bt && (x == null || x(Bt)));
  }, [v, Le, rt, x]), We = $.useMemo(function() {
    return (L || []).some(function(Qt) {
      return [`
`, `\r
`].includes(Qt);
    });
  }, [L]), ct = $.useContext(zM) || {}, ht = ct.maxCount, Rt = ct.rawValues, Ft = function(Bt, nn, Jt) {
    if (!(pe && bR(ht) && (Rt == null ? void 0 : Rt.size) >= ht)) {
      var Zt = !0, yn = Bt;
      E == null || E(null);
      var Ir = rje(Bt, L, bR(ht) ? ht - Rt.size : void 0), mi = Jt ? null : Ir;
      return m !== "combobox" && mi && (yn = "", k == null || k(mi), Ue(!1), Zt = !1), P && _t !== yn && P(yn, {
        source: nn ? "typing" : "effect"
      }), Zt;
    }
  }, re = function(Bt) {
    !Bt || !Bt.trim() || P(Bt, {
      source: "submit"
    });
  };
  $.useEffect(function() {
    !Le && !pe && m !== "combobox" && Ft("", !1, !1);
  }, [Le]), $.useEffect(function() {
    Ke && v && rt(!1), v && !vt.current && yt(!1);
  }, [v]);
  var Se = xZ(), De = he(Se, 2), Ye = De[0], $t = De[1], Ct = $.useRef(!1), ut = function(Bt) {
    var nn = Ye(), Jt = Bt.key, Zt = Jt === "Enter";
    if (Zt && (m !== "combobox" && Bt.preventDefault(), Le || Ue(!0)), $t(!!_t), Jt === "Backspace" && !nn && pe && !_t && u.length) {
      for (var yn = tt(u), Ir = null, mi = yn.length - 1; mi >= 0; mi -= 1) {
        var un = yn[mi];
        if (!un.disabled) {
          yn.splice(mi, 1), Ir = un;
          break;
        }
      }
      Ir && d(yn, {
        type: "remove",
        values: [Ir]
      });
    }
    for (var ri = arguments.length, ii = new Array(ri > 1 ? ri - 1 : 0), Qi = 1; Qi < ri; Qi++)
      ii[Qi - 1] = arguments[Qi];
    if (Le && (!Zt || !Ct.current)) {
      var Fo;
      (Fo = mt.current) === null || Fo === void 0 || Fo.onKeyDown.apply(Fo, [Bt].concat(ii));
    }
    Zt && (Ct.current = !0), le == null || le.apply(void 0, [Bt].concat(ii));
  }, Mt = function(Bt) {
    for (var nn = arguments.length, Jt = new Array(nn > 1 ? nn - 1 : 0), Zt = 1; Zt < nn; Zt++)
      Jt[Zt - 1] = arguments[Zt];
    if (Le) {
      var yn;
      (yn = mt.current) === null || yn === void 0 || yn.onKeyUp.apply(yn, [Bt].concat(Jt));
    }
    Bt.key === "Enter" && (Ct.current = !1), se == null || se.apply(void 0, [Bt].concat(Jt));
  }, Xe = function(Bt) {
    var nn = u.filter(function(Jt) {
      return Jt !== Bt;
    });
    d(nn, {
      type: "remove",
      values: [Bt]
    });
  }, je = $.useRef(!1), Ze = function() {
    yt(!0), v || (ie && !je.current && ie.apply(void 0, arguments), H.includes("focus") && Ue(!0)), je.current = !0;
  }, dt = function() {
    vt.current = !0, yt(!1, function() {
      je.current = !1, vt.current = !1, Ue(!1);
    }), !v && (_t && (m === "tags" ? P(_t, {
      source: "submit"
    }) : m === "multiple" && P("", {
      source: "blur"
    })), W && W.apply(void 0, arguments));
  }, Ge = [];
  $.useEffect(function() {
    return function() {
      Ge.forEach(function(Qt) {
        return clearTimeout(Qt);
      }), Ge.splice(0, Ge.length);
    };
  }, []);
  var Lt = function(Bt) {
    var nn, Jt = Bt.target, Zt = (nn = Ne.current) === null || nn === void 0 ? void 0 : nn.getPopupElement();
    if (Zt && Zt.contains(Jt)) {
      var yn = setTimeout(function() {
        var ri = Ge.indexOf(yn);
        if (ri !== -1 && Ge.splice(ri, 1), Pt(), !be && !Zt.contains(document.activeElement)) {
          var ii;
          (ii = lt.current) === null || ii === void 0 || ii.focus();
        }
      });
      Ge.push(yn);
    }
    for (var Ir = arguments.length, mi = new Array(Ir > 1 ? Ir - 1 : 0), un = 1; un < Ir; un++)
      mi[un - 1] = arguments[un];
    ge == null || ge.apply(void 0, [Bt].concat(mi));
  }, Ot = $.useState({}), xn = he(Ot, 2), mr = xn[1];
  function Kn() {
    mr({});
  }
  var Tn;
  ft && (Tn = function(Bt) {
    Ue(Bt);
  }), _8e(function() {
    var Qt;
    return [Ve.current, (Qt = Ne.current) === null || Qt === void 0 ? void 0 : Qt.getPopupElement()];
  }, Ht, Ue, !!ft);
  var Vr = $.useMemo(function() {
    return ae(ae({}, e), {}, {
      notFoundContent: p,
      open: Le,
      triggerOpen: Ht,
      id: r,
      showSearch: Te,
      multiple: pe,
      toggleOpen: Ue
    });
  }, [e, p, Ht, Le, r, Te, pe, Ue]), Yr = !!z || y, vr;
  Yr && (vr = /* @__PURE__ */ $.createElement(XE, {
    className: Ee("".concat(i, "-arrow"), oe({}, "".concat(i, "-arrow-loading"), y)),
    customizeIcon: z,
    customizeIconProps: {
      loading: y,
      searchValue: _t,
      open: Le,
      focused: Re,
      showSearch: Te
    }
  }));
  var Cr = function() {
    var Bt;
    g == null || g(), (Bt = lt.current) === null || Bt === void 0 || Bt.focus(), d([], {
      type: "clear",
      values: u
    }), Ft("", !1, !1);
  }, Xr = v8e(i, Cr, u, N, V, v, _t, m), Tr = Xr.allowClear, Qr = Xr.clearIcon, Ti = /* @__PURE__ */ $.createElement(B, {
    ref: mt
  }), Ii = Ee(i, o, oe(oe(oe(oe(oe(oe(oe(oe(oe(oe({}, "".concat(i, "-focused"), Re), "".concat(i, "-multiple"), pe), "".concat(i, "-single"), !pe), "".concat(i, "-allow-clear"), N), "".concat(i, "-show-arrow"), Yr), "".concat(i, "-disabled"), v), "".concat(i, "-loading"), y), "".concat(i, "-open"), Le), "".concat(i, "-customize-input"), St), "".concat(i, "-show-search"), Te)), Ni = /* @__PURE__ */ $.createElement(MZ, {
    ref: Ne,
    disabled: v,
    prefixCls: i,
    visible: Ht,
    popupElement: Ti,
    animation: U,
    transitionName: Q,
    dropdownStyle: Y,
    dropdownClassName: q,
    direction: c,
    dropdownMatchSelectWidth: X,
    dropdownRender: ne,
    dropdownAlign: Z,
    placement: J,
    builtinPlacements: K,
    getPopupContainer: ee,
    empty: f,
    getTriggerDOMNode: function(Bt) {
      return (
        // TODO: This is workaround and should be removed in `rc-select`
        // And use new standard `nativeElement` for ref.
        // But we should update `rc-resize-observer` first.
        ze.current || Bt
      );
    },
    onPopupVisibleChange: Tn,
    onPopupMouseEnter: Kn
  }, ft ? /* @__PURE__ */ $.cloneElement(ft, {
    ref: kn
  }) : /* @__PURE__ */ $.createElement($Z, xt({}, e, {
    domRef: ze,
    prefixCls: i,
    inputElement: St,
    ref: lt,
    id: r,
    prefix: D,
    showSearch: Te,
    autoClearSearchValue: O,
    mode: m,
    activeDescendantId: R,
    tagRender: s,
    values: u,
    open: Le,
    onToggleOpen: Ue,
    activeValue: T,
    searchValue: _t,
    onSearch: Ft,
    onSearchSubmit: re,
    onRemove: Xe,
    tokenWithEnter: We
  }))), tr;
  return ft ? tr = Ni : tr = /* @__PURE__ */ $.createElement("div", xt({
    className: Ii
  }, de, {
    ref: Ve,
    onMouseDown: Lt,
    onKeyDown: ut,
    onKeyUp: Mt,
    onFocus: Ze,
    onBlur: dt
  }), /* @__PURE__ */ $.createElement(ije, {
    visible: Re && !Le,
    values: u
  }), Ni, vr, Tr && Qr), /* @__PURE__ */ $.createElement(wZ.Provider, {
    value: Vr
  }, tr);
});
process.env.NODE_ENV !== "production" && (NZ.displayName = "BaseSelect");
var HM = function() {
  return null;
};
HM.isSelectOptGroup = !0;
var UM = function() {
  return null;
};
UM.isSelectOption = !0;
var DZ = /* @__PURE__ */ $.forwardRef(function(e, t) {
  var n = e.height, r = e.offsetY, i = e.offsetX, o = e.children, a = e.prefixCls, s = e.onInnerResize, c = e.innerProps, l = e.rtl, u = e.extra, d = {}, f = {
    display: "flex",
    flexDirection: "column"
  };
  return r !== void 0 && (d = {
    height: n,
    position: "relative",
    overflow: "hidden"
  }, f = ae(ae({}, f), {}, oe(oe(oe(oe(oe({
    transform: "translateY(".concat(r, "px)")
  }, l ? "marginRight" : "marginLeft", -i), "position", "absolute"), "left", 0), "right", 0), "top", 0))), /* @__PURE__ */ $.createElement("div", {
    style: d
  }, /* @__PURE__ */ $.createElement(Cl, {
    onResize: function(p) {
      var g = p.offsetHeight;
      g && s && s();
    }
  }, /* @__PURE__ */ $.createElement("div", xt({
    style: f,
    className: Ee(oe({}, "".concat(a, "-holder-inner"), a)),
    ref: t
  }, c), o, u)));
});
DZ.displayName = "Filler";
function sje(e) {
  var t = e.children, n = e.setRef, r = $.useCallback(function(i) {
    n(i);
  }, []);
  return /* @__PURE__ */ $.cloneElement(t, {
    ref: r
  });
}
function cje(e, t, n, r, i, o, a, s) {
  var c = s.getKey;
  return e.slice(t, n + 1).map(function(l, u) {
    var d = t + u, f = a(l, d, {
      style: {
        width: r
      },
      offsetX: i
    }), h = c(l);
    return /* @__PURE__ */ $.createElement(sje, {
      key: h,
      setRef: function(g) {
        return o(l, g);
      }
    }, f);
  });
}
function lje(e, t, n) {
  var r = e.length, i = t.length, o, a;
  if (r === 0 && i === 0)
    return null;
  r < i ? (o = e, a = t) : (o = t, a = e);
  var s = {
    __EMPTY_ITEM__: !0
  };
  function c(p) {
    return p !== void 0 ? n(p) : s;
  }
  for (var l = null, u = Math.abs(r - i) !== 1, d = 0; d < a.length; d += 1) {
    var f = c(o[d]), h = c(a[d]);
    if (f !== h) {
      l = d, u = u || f !== c(a[d + 1]);
      break;
    }
  }
  return l === null ? null : {
    index: l,
    multiple: u
  };
}
function uje(e, t, n) {
  var r = $.useState(e), i = he(r, 2), o = i[0], a = i[1], s = $.useState(null), c = he(s, 2), l = c[0], u = c[1];
  return $.useEffect(function() {
    var d = lje(o || [], e || [], t);
    (d == null ? void 0 : d.index) !== void 0 && (n == null || n(d.index), u(e[d.index])), a(e);
  }, [e]), [l];
}
var wF = (typeof navigator > "u" ? "undefined" : It(navigator)) === "object" && /Firefox/i.test(navigator.userAgent);
const jZ = function(e, t, n, r) {
  var i = $e(!1), o = $e(null);
  function a() {
    clearTimeout(o.current), i.current = !0, o.current = setTimeout(function() {
      i.current = !1;
    }, 50);
  }
  var s = $e({
    top: e,
    bottom: t,
    left: n,
    right: r
  });
  return s.current.top = e, s.current.bottom = t, s.current.left = n, s.current.right = r, function(c, l) {
    var u = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, d = c ? (
      // Pass origin wheel when on the left
      l < 0 && s.current.left || // Pass origin wheel when on the right
      l > 0 && s.current.right
    ) : l < 0 && s.current.top || // Pass origin wheel when on the bottom
    l > 0 && s.current.bottom;
    return u && d ? (clearTimeout(o.current), i.current = !1) : (!d || i.current) && a(), !i.current && d;
  };
};
function dje(e, t, n, r, i, o, a) {
  var s = $e(0), c = $e(null), l = $e(null), u = $e(!1), d = jZ(t, n, r, i);
  function f(y, _) {
    if (Ln.cancel(c.current), !d(!1, _)) {
      var b = y;
      if (!b._virtualHandled)
        b._virtualHandled = !0;
      else
        return;
      s.current += _, l.current = _, wF || b.preventDefault(), c.current = Ln(function() {
        var w = u.current ? 10 : 1;
        a(s.current * w, !1), s.current = 0;
      });
    }
  }
  function h(y, _) {
    a(_, !0), wF || y.preventDefault();
  }
  var p = $e(null), g = $e(null);
  function m(y) {
    if (e) {
      Ln.cancel(g.current), g.current = Ln(function() {
        p.current = null;
      }, 2);
      var _ = y.deltaX, b = y.deltaY, w = y.shiftKey, C = _, x = b;
      (p.current === "sx" || !p.current && w && b && !_) && (C = b, x = 0, p.current = "sx");
      var T = Math.abs(C), E = Math.abs(x);
      p.current === null && (p.current = o && T > E ? "x" : "y"), p.current === "y" ? f(y, x) : h(y, C);
    }
  }
  function v(y) {
    e && (u.current = y.detail === l.current);
  }
  return [m, v];
}
function fje(e, t, n, r) {
  var i = $.useMemo(function() {
    return [/* @__PURE__ */ new Map(), []];
  }, [e, n.id, r]), o = he(i, 2), a = o[0], s = o[1], c = function(u) {
    var d = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : u, f = a.get(u), h = a.get(d);
    if (f === void 0 || h === void 0)
      for (var p = e.length, g = s.length; g < p; g += 1) {
        var m, v = e[g], y = t(v);
        a.set(y, g);
        var _ = (m = n.get(y)) !== null && m !== void 0 ? m : r;
        if (s[g] = (s[g - 1] || 0) + _, y === u && (f = g), y === d && (h = g), f !== void 0 && h !== void 0)
          break;
      }
    return {
      top: s[f - 1] || 0,
      bottom: s[h]
    };
  };
  return c;
}
var hje = /* @__PURE__ */ function() {
  function e() {
    xr(this, e), oe(this, "maps", void 0), oe(this, "id", 0), this.maps = /* @__PURE__ */ Object.create(null);
  }
  return Er(e, [{
    key: "set",
    value: function(n, r) {
      this.maps[n] = r, this.id += 1;
    }
  }, {
    key: "get",
    value: function(n) {
      return this.maps[n];
    }
  }]), e;
}();
function xF(e) {
  var t = parseFloat(e);
  return isNaN(t) ? 0 : t;
}
function gje(e, t, n) {
  var r = $.useState(0), i = he(r, 2), o = i[0], a = i[1], s = $e(/* @__PURE__ */ new Map()), c = $e(new hje()), l = $e();
  function u() {
    Ln.cancel(l.current);
  }
  function d() {
    var h = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
    u();
    var p = function() {
      s.current.forEach(function(m, v) {
        if (m && m.offsetParent) {
          var y = L0(m), _ = y.offsetHeight, b = getComputedStyle(y), w = b.marginTop, C = b.marginBottom, x = xF(w), T = xF(C), E = _ + x + T;
          c.current.get(v) !== E && c.current.set(v, E);
        }
      }), a(function(m) {
        return m + 1;
      });
    };
    h ? p() : l.current = Ln(p);
  }
  function f(h, p) {
    var g = e(h), m = s.current.get(g);
    p ? (s.current.set(g, p), d()) : s.current.delete(g), !m != !p && (p ? t == null || t(h) : n == null || n(h));
  }
  return ot(function() {
    return u;
  }, []), [f, d, c.current, o];
}
var EF = 14 / 15;
function pje(e, t, n) {
  var r = $e(!1), i = $e(0), o = $e(0), a = $e(null), s = $e(null), c, l = function(h) {
    if (r.current) {
      var p = Math.ceil(h.touches[0].pageX), g = Math.ceil(h.touches[0].pageY), m = i.current - p, v = o.current - g, y = Math.abs(m) > Math.abs(v);
      y ? i.current = p : o.current = g;
      var _ = n(y, y ? m : v, !1, h);
      _ && h.preventDefault(), clearInterval(s.current), _ && (s.current = setInterval(function() {
        y ? m *= EF : v *= EF;
        var b = Math.floor(y ? m : v);
        (!n(y, b, !0) || Math.abs(b) <= 0.1) && clearInterval(s.current);
      }, 16));
    }
  }, u = function() {
    r.current = !1, c();
  }, d = function(h) {
    c(), h.touches.length === 1 && !r.current && (r.current = !0, i.current = Math.ceil(h.touches[0].pageX), o.current = Math.ceil(h.touches[0].pageY), a.current = h.target, a.current.addEventListener("touchmove", l, {
      passive: !1
    }), a.current.addEventListener("touchend", u, {
      passive: !0
    }));
  };
  c = function() {
    a.current && (a.current.removeEventListener("touchmove", l), a.current.removeEventListener("touchend", u));
  }, ar(function() {
    return e && t.current.addEventListener("touchstart", d, {
      passive: !0
    }), function() {
      var f;
      (f = t.current) === null || f === void 0 || f.removeEventListener("touchstart", d), c(), clearInterval(s.current);
    };
  }, [e]);
}
var CF = 10;
function mje(e, t, n, r, i, o, a, s) {
  var c = $.useRef(), l = $.useState(null), u = he(l, 2), d = u[0], f = u[1];
  return ar(function() {
    if (d && d.times < CF) {
      if (!e.current) {
        f(function(V) {
          return ae({}, V);
        });
        return;
      }
      o();
      var h = d.targetAlign, p = d.originAlign, g = d.index, m = d.offset, v = e.current.clientHeight, y = !1, _ = h, b = null;
      if (v) {
        for (var w = h || p, C = 0, x = 0, T = 0, E = Math.min(t.length - 1, g), R = 0; R <= E; R += 1) {
          var I = i(t[R]);
          x = C;
          var O = n.get(I);
          T = x + (O === void 0 ? r : O), C = T;
        }
        for (var P = w === "top" ? m : v - m, k = E; k >= 0; k -= 1) {
          var L = i(t[k]), N = n.get(L);
          if (N === void 0) {
            y = !0;
            break;
          }
          if (P -= N, P <= 0)
            break;
        }
        switch (w) {
          case "top":
            b = x - m;
            break;
          case "bottom":
            b = T - v + m;
            break;
          default: {
            var D = e.current.scrollTop, z = D + v;
            x < D ? _ = "top" : T > z && (_ = "bottom");
          }
        }
        b !== null && a(b), b !== d.lastTop && (y = !0);
      }
      y && f(ae(ae({}, d), {}, {
        times: d.times + 1,
        targetAlign: _,
        lastTop: b
      }));
    } else
      process.env.NODE_ENV !== "production" && (d == null ? void 0 : d.times) === CF && sn(!1, "Seems `scrollTo` with `rc-virtual-list` reach the max limitation. Please fire issue for us. Thanks.");
  }, [d, e.current]), function(h) {
    if (h == null) {
      s();
      return;
    }
    if (Ln.cancel(c.current), typeof h == "number")
      a(h);
    else if (h && It(h) === "object") {
      var p, g = h.align;
      "index" in h ? p = h.index : p = t.findIndex(function(y) {
        return i(y) === h.key;
      });
      var m = h.offset, v = m === void 0 ? 0 : m;
      f({
        times: 0,
        index: p,
        offset: v,
        originAlign: g
      });
    }
  };
}
function TF(e, t) {
  var n = "touches" in e ? e.touches[0] : e;
  return n[t ? "pageX" : "pageY"];
}
var SR = /* @__PURE__ */ $.forwardRef(function(e, t) {
  var n = e.prefixCls, r = e.rtl, i = e.scrollOffset, o = e.scrollRange, a = e.onStartMove, s = e.onStopMove, c = e.onScroll, l = e.horizontal, u = e.spinSize, d = e.containerSize, f = e.style, h = e.thumbStyle, p = $.useState(!1), g = he(p, 2), m = g[0], v = g[1], y = $.useState(null), _ = he(y, 2), b = _[0], w = _[1], C = $.useState(null), x = he(C, 2), T = x[0], E = x[1], R = !r, I = $.useRef(), O = $.useRef(), P = $.useState(!1), k = he(P, 2), L = k[0], N = k[1], D = $.useRef(), z = function() {
    clearTimeout(D.current), N(!0), D.current = setTimeout(function() {
      N(!1);
    }, 3e3);
  }, V = o - d || 0, B = d - u || 0, U = $.useMemo(function() {
    if (i === 0 || V === 0)
      return 0;
    var ee = i / V;
    return ee * B;
  }, [i, V, B]), Q = function(te) {
    te.stopPropagation(), te.preventDefault();
  }, Y = $.useRef({
    top: U,
    dragging: m,
    pageY: b,
    startTop: T
  });
  Y.current = {
    top: U,
    dragging: m,
    pageY: b,
    startTop: T
  };
  var q = function(te) {
    v(!0), w(TF(te, l)), E(Y.current.top), a(), te.stopPropagation(), te.preventDefault();
  };
  $.useEffect(function() {
    var ee = function(W) {
      W.preventDefault();
    }, te = I.current, H = O.current;
    return te.addEventListener("touchstart", ee, {
      passive: !1
    }), H.addEventListener("touchstart", q, {
      passive: !1
    }), function() {
      te.removeEventListener("touchstart", ee), H.removeEventListener("touchstart", q);
    };
  }, []);
  var X = $.useRef();
  X.current = V;
  var ne = $.useRef();
  ne.current = B, $.useEffect(function() {
    if (m) {
      var ee, te = function(W) {
        var se = Y.current, le = se.dragging, ge = se.pageY, me = se.startTop;
        Ln.cancel(ee);
        var pe = I.current.getBoundingClientRect(), Te = d / (l ? pe.width : pe.height);
        if (le) {
          var de = (TF(W, l) - ge) * Te, Ae = me;
          !R && l ? Ae -= de : Ae += de;
          var ue = X.current, be = ne.current, Ie = be ? Ae / be : 0, Ve = Math.ceil(Ie * ue);
          Ve = Math.max(Ve, 0), Ve = Math.min(Ve, ue), ee = Ln(function() {
            c(Ve, l);
          });
        }
      }, H = function() {
        v(!1), s();
      };
      return window.addEventListener("mousemove", te, {
        passive: !0
      }), window.addEventListener("touchmove", te, {
        passive: !0
      }), window.addEventListener("mouseup", H, {
        passive: !0
      }), window.addEventListener("touchend", H, {
        passive: !0
      }), function() {
        window.removeEventListener("mousemove", te), window.removeEventListener("touchmove", te), window.removeEventListener("mouseup", H), window.removeEventListener("touchend", H), Ln.cancel(ee);
      };
    }
  }, [m]), $.useEffect(function() {
    return z(), function() {
      clearTimeout(D.current);
    };
  }, [i]), $.useImperativeHandle(t, function() {
    return {
      delayHidden: z
    };
  });
  var Z = "".concat(n, "-scrollbar"), J = {
    position: "absolute",
    visibility: L ? null : "hidden"
  }, K = {
    position: "absolute",
    background: "rgba(0, 0, 0, 0.5)",
    borderRadius: 99,
    cursor: "pointer",
    userSelect: "none"
  };
  return l ? (J.height = 8, J.left = 0, J.right = 0, J.bottom = 0, K.height = "100%", K.width = u, R ? K.left = U : K.right = U) : (J.width = 8, J.top = 0, J.bottom = 0, R ? J.right = 0 : J.left = 0, K.width = "100%", K.height = u, K.top = U), /* @__PURE__ */ $.createElement("div", {
    ref: I,
    className: Ee(Z, oe(oe(oe({}, "".concat(Z, "-horizontal"), l), "".concat(Z, "-vertical"), !l), "".concat(Z, "-visible"), L)),
    style: ae(ae({}, J), f),
    onMouseDown: Q,
    onMouseMove: z
  }, /* @__PURE__ */ $.createElement("div", {
    ref: O,
    className: Ee("".concat(Z, "-thumb"), oe({}, "".concat(Z, "-thumb-moving"), m)),
    style: ae(ae({}, K), h),
    onMouseDown: q
  }));
});
process.env.NODE_ENV !== "production" && (SR.displayName = "ScrollBar");
var vje = 20;
function IF() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, n = e / t * e;
  return isNaN(n) && (n = 0), n = Math.max(n, vje), Math.floor(n);
}
var yje = ["prefixCls", "className", "height", "itemHeight", "fullHeight", "style", "data", "children", "itemKey", "virtual", "direction", "scrollWidth", "component", "onScroll", "onVirtualScroll", "onVisibleChange", "innerProps", "extraRender", "styles"], bje = [], _je = {
  overflowY: "auto",
  overflowAnchor: "none"
};
function Sje(e, t) {
  var n = e.prefixCls, r = n === void 0 ? "rc-virtual-list" : n, i = e.className, o = e.height, a = e.itemHeight, s = e.fullHeight, c = s === void 0 ? !0 : s, l = e.style, u = e.data, d = e.children, f = e.itemKey, h = e.virtual, p = e.direction, g = e.scrollWidth, m = e.component, v = m === void 0 ? "div" : m, y = e.onScroll, _ = e.onVirtualScroll, b = e.onVisibleChange, w = e.innerProps, C = e.extraRender, x = e.styles, T = En(e, yje), E = $.useCallback(function(Xe) {
    return typeof f == "function" ? f(Xe) : Xe == null ? void 0 : Xe[f];
  }, [f]), R = gje(E, null, null), I = he(R, 4), O = I[0], P = I[1], k = I[2], L = I[3], N = !!(h !== !1 && o && a), D = $.useMemo(function() {
    return Object.values(k.maps).reduce(function(Xe, je) {
      return Xe + je;
    }, 0);
  }, [k.id, k.maps]), z = N && u && (Math.max(a * u.length, D) > o || !!g), V = p === "rtl", B = Ee(r, oe({}, "".concat(r, "-rtl"), V), i), U = u || bje, Q = $e(), Y = $e(), q = $e(), X = Qe(0), ne = he(X, 2), Z = ne[0], J = ne[1], K = Qe(0), ee = he(K, 2), te = ee[0], H = ee[1], ie = Qe(!1), W = he(ie, 2), se = W[0], le = W[1], ge = function() {
    le(!0);
  }, me = function() {
    le(!1);
  }, pe = {
    getKey: E
  };
  function Te(Xe) {
    J(function(je) {
      var Ze;
      typeof Xe == "function" ? Ze = Xe(je) : Ze = Xe;
      var dt = nt(Ze);
      return Q.current.scrollTop = dt, dt;
    });
  }
  var de = $e({
    start: 0,
    end: U.length
  }), Ae = $e(), ue = uje(U, E), be = he(ue, 1), Ie = be[0];
  Ae.current = Ie;
  var Ve = $.useMemo(function() {
    if (!N)
      return {
        scrollHeight: void 0,
        start: 0,
        end: U.length - 1,
        offset: void 0
      };
    if (!z) {
      var Xe;
      return {
        scrollHeight: ((Xe = Y.current) === null || Xe === void 0 ? void 0 : Xe.offsetHeight) || 0,
        start: 0,
        end: U.length - 1,
        offset: void 0
      };
    }
    for (var je = 0, Ze, dt, Ge, Lt = U.length, Ot = 0; Ot < Lt; Ot += 1) {
      var xn = U[Ot], mr = E(xn), Kn = k.get(mr), Tn = je + (Kn === void 0 ? a : Kn);
      Tn >= Z && Ze === void 0 && (Ze = Ot, dt = je), Tn > Z + o && Ge === void 0 && (Ge = Ot), je = Tn;
    }
    return Ze === void 0 && (Ze = 0, dt = 0, Ge = Math.ceil(o / a)), Ge === void 0 && (Ge = U.length - 1), Ge = Math.min(Ge + 1, U.length - 1), {
      scrollHeight: je,
      start: Ze,
      end: Ge,
      offset: dt
    };
  }, [z, N, Z, U, L, o]), ze = Ve.scrollHeight, Ne = Ve.start, lt = Ve.end, mt = Ve.offset;
  de.current.start = Ne, de.current.end = lt;
  var vt = $.useState({
    width: 0,
    height: o
  }), ke = he(vt, 2), xe = ke[0], Re = ke[1], yt = function(je) {
    Re({
      width: je.offsetWidth,
      height: je.offsetHeight
    });
  }, Pt = $e(), _t = $e(), St = $.useMemo(function() {
    return IF(xe.width, g);
  }, [xe.width, g]), ft = $.useMemo(function() {
    return IF(xe.height, ze);
  }, [xe.height, ze]), kn = ze - o, Dt = $e(kn);
  Dt.current = kn;
  function nt(Xe) {
    var je = Xe;
    return Number.isNaN(Dt.current) || (je = Math.min(je, Dt.current)), je = Math.max(je, 0), je;
  }
  var Be = Z <= 0, st = Z >= kn, pt = te <= 0, Et = te >= g, Ke = jZ(Be, st, pt, Et), rt = function() {
    return {
      x: V ? -te : te,
      y: Z
    };
  }, Le = $e(rt()), Xt = Pr(function(Xe) {
    if (_) {
      var je = ae(ae({}, rt()), Xe);
      (Le.current.x !== je.x || Le.current.y !== je.y) && (_(je), Le.current = je);
    }
  });
  function Ht(Xe, je) {
    var Ze = Xe;
    je ? (i$(function() {
      H(Ze);
    }), Xt()) : Te(Ze);
  }
  function Ue(Xe) {
    var je = Xe.currentTarget.scrollTop;
    je !== Z && Te(je), y == null || y(Xe), Xt();
  }
  var We = function(je) {
    var Ze = je, dt = g ? g - xe.width : 0;
    return Ze = Math.max(Ze, 0), Ze = Math.min(Ze, dt), Ze;
  }, ct = Pr(function(Xe, je) {
    je ? (i$(function() {
      H(function(Ze) {
        var dt = Ze + (V ? -Xe : Xe);
        return We(dt);
      });
    }), Xt()) : Te(function(Ze) {
      var dt = Ze + Xe;
      return dt;
    });
  }), ht = dje(N, Be, st, pt, Et, !!g, ct), Rt = he(ht, 2), Ft = Rt[0], re = Rt[1];
  pje(N, Q, function(Xe, je, Ze, dt) {
    var Ge = dt;
    return Ke(Xe, je, Ze) ? !1 : !Ge || !Ge._virtualHandled ? (Ge && (Ge._virtualHandled = !0), Ft({
      preventDefault: function() {
      },
      deltaX: Xe ? je : 0,
      deltaY: Xe ? 0 : je
    }), !0) : !1;
  }), ar(function() {
    function Xe(Ze) {
      var dt = Be && Ze.detail < 0, Ge = st && Ze.detail > 0;
      N && !dt && !Ge && Ze.preventDefault();
    }
    var je = Q.current;
    return je.addEventListener("wheel", Ft, {
      passive: !1
    }), je.addEventListener("DOMMouseScroll", re, {
      passive: !0
    }), je.addEventListener("MozMousePixelScroll", Xe, {
      passive: !1
    }), function() {
      je.removeEventListener("wheel", Ft), je.removeEventListener("DOMMouseScroll", re), je.removeEventListener("MozMousePixelScroll", Xe);
    };
  }, [N, Be, st]), ar(function() {
    if (g) {
      var Xe = We(te);
      H(Xe), Xt({
        x: Xe
      });
    }
  }, [xe.width, g]);
  var Se = function() {
    var je, Ze;
    (je = Pt.current) === null || je === void 0 || je.delayHidden(), (Ze = _t.current) === null || Ze === void 0 || Ze.delayHidden();
  }, De = mje(Q, U, k, a, E, function() {
    return P(!0);
  }, Te, Se);
  $.useImperativeHandle(t, function() {
    return {
      nativeElement: q.current,
      getScrollInfo: rt,
      scrollTo: function(je) {
        function Ze(dt) {
          return dt && It(dt) === "object" && ("left" in dt || "top" in dt);
        }
        Ze(je) ? (je.left !== void 0 && H(We(je.left)), De(je.top)) : De(je);
      }
    };
  }), ar(function() {
    if (b) {
      var Xe = U.slice(Ne, lt + 1);
      b(Xe, U);
    }
  }, [Ne, lt, U]);
  var Ye = fje(U, E, k, a), $t = C == null ? void 0 : C({
    start: Ne,
    end: lt,
    virtual: z,
    offsetX: te,
    offsetY: mt,
    rtl: V,
    getSize: Ye
  }), Ct = cje(U, Ne, lt, g, te, O, d, pe), ut = null;
  o && (ut = ae(oe({}, c ? "height" : "maxHeight", o), _je), N && (ut.overflowY = "hidden", g && (ut.overflowX = "hidden"), se && (ut.pointerEvents = "none")));
  var Mt = {};
  return V && (Mt.dir = "rtl"), /* @__PURE__ */ $.createElement("div", xt({
    ref: q,
    style: ae(ae({}, l), {}, {
      position: "relative"
    }),
    className: B
  }, Mt, T), /* @__PURE__ */ $.createElement(Cl, {
    onResize: yt
  }, /* @__PURE__ */ $.createElement(v, {
    className: "".concat(r, "-holder"),
    style: ut,
    ref: Q,
    onScroll: Ue,
    onMouseEnter: Se
  }, /* @__PURE__ */ $.createElement(DZ, {
    prefixCls: r,
    height: ze,
    offsetX: te,
    offsetY: mt,
    scrollWidth: g,
    onInnerResize: P,
    ref: Y,
    innerProps: w,
    rtl: V,
    extra: $t
  }, Ct))), z && ze > o && /* @__PURE__ */ $.createElement(SR, {
    ref: Pt,
    prefixCls: r,
    scrollOffset: Z,
    scrollRange: ze,
    rtl: V,
    onScroll: Ht,
    onStartMove: ge,
    onStopMove: me,
    spinSize: ft,
    containerSize: xe.height,
    style: x == null ? void 0 : x.verticalScrollBar,
    thumbStyle: x == null ? void 0 : x.verticalScrollBarThumb
  }), z && g > xe.width && /* @__PURE__ */ $.createElement(SR, {
    ref: _t,
    prefixCls: r,
    scrollOffset: te,
    scrollRange: g,
    rtl: V,
    onScroll: Ht,
    onStartMove: ge,
    onStopMove: me,
    spinSize: St,
    containerSize: xe.width,
    horizontal: !0,
    style: x == null ? void 0 : x.horizontalScrollBar,
    thumbStyle: x == null ? void 0 : x.horizontalScrollBarThumb
  }));
}
var LZ = /* @__PURE__ */ $.forwardRef(Sje);
LZ.displayName = "List";
function wje() {
  return /(mac\sos|macintosh)/i.test(navigator.appVersion);
}
var xje = ["disabled", "title", "children", "style", "className"];
function $F(e) {
  return typeof e == "string" || typeof e == "number";
}
var Eje = function(t, n) {
  var r = y8e(), i = r.prefixCls, o = r.id, a = r.open, s = r.multiple, c = r.mode, l = r.searchValue, u = r.toggleOpen, d = r.notFoundContent, f = r.onPopupScroll, h = $.useContext(zM), p = h.maxCount, g = h.flattenOptions, m = h.onActiveValue, v = h.defaultActiveFirstOption, y = h.onSelect, _ = h.menuItemSelectedIcon, b = h.rawValues, w = h.fieldNames, C = h.virtual, x = h.direction, T = h.listHeight, E = h.listItemHeight, R = h.optionRender, I = "".concat(i, "-item"), O = Iy(function() {
    return g;
  }, [a, g], function(te, H) {
    return H[0] && te[1] !== H[1];
  }), P = $.useRef(null), k = $.useMemo(function() {
    return s && bR(p) && (b == null ? void 0 : b.size) >= p;
  }, [s, p, b == null ? void 0 : b.size]), L = function(H) {
    H.preventDefault();
  }, N = function(H) {
    var ie;
    (ie = P.current) === null || ie === void 0 || ie.scrollTo(typeof H == "number" ? {
      index: H
    } : H);
  }, D = function(H) {
    for (var ie = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, W = O.length, se = 0; se < W; se += 1) {
      var le = (H + se * ie + W) % W, ge = O[le] || {}, me = ge.group, pe = ge.data;
      if (!me && !(pe != null && pe.disabled) && !k)
        return le;
    }
    return -1;
  }, z = $.useState(function() {
    return D(0);
  }), V = he(z, 2), B = V[0], U = V[1], Q = function(H) {
    var ie = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    U(H);
    var W = {
      source: ie ? "keyboard" : "mouse"
    }, se = O[H];
    if (!se) {
      m(null, -1, W);
      return;
    }
    m(se.value, H, W);
  };
  ot(function() {
    Q(v !== !1 ? D(0) : -1);
  }, [O.length, l]);
  var Y = $.useCallback(function(te) {
    return c === "combobox" ? !1 : b.has(te);
  }, [c, tt(b).toString(), b.size]), q = $.useCallback(function(te) {
    return c === "combobox" ? String(te).toLowerCase() === l.toLowerCase() : b.has(te);
  }, [c, l, tt(b).toString(), b.size]);
  ot(function() {
    var te = setTimeout(function() {
      if (!s && a && b.size === 1) {
        var ie = Array.from(b)[0], W = O.findIndex(function(se) {
          var le = se.data;
          return le.value === ie;
        });
        W !== -1 && (Q(W), N(W));
      }
    });
    if (a) {
      var H;
      (H = P.current) === null || H === void 0 || H.scrollTo(void 0);
    }
    return function() {
      return clearTimeout(te);
    };
  }, [a, l]);
  var X = function(H) {
    H !== void 0 && y(H, {
      selected: !b.has(H)
    }), s || u(!1);
  };
  if ($.useImperativeHandle(n, function() {
    return {
      onKeyDown: function(H) {
        var ie = H.which, W = H.ctrlKey;
        switch (ie) {
          case Oe.N:
          case Oe.P:
          case Oe.UP:
          case Oe.DOWN: {
            var se = 0;
            if (ie === Oe.UP ? se = -1 : ie === Oe.DOWN ? se = 1 : wje() && W && (ie === Oe.N ? se = 1 : ie === Oe.P && (se = -1)), se !== 0) {
              var le = D(B + se, se);
              N(le), Q(le, !0);
            }
            break;
          }
          case Oe.TAB:
          case Oe.ENTER: {
            var ge, me = O[B];
            me && !(me != null && (ge = me.data) !== null && ge !== void 0 && ge.disabled) && !k ? X(me.value) : X(void 0), a && H.preventDefault();
            break;
          }
          case Oe.ESC:
            u(!1), a && H.stopPropagation();
        }
      },
      onKeyUp: function() {
      },
      scrollTo: function(H) {
        N(H);
      }
    };
  }), O.length === 0)
    return /* @__PURE__ */ $.createElement("div", {
      role: "listbox",
      id: "".concat(o, "_list"),
      className: "".concat(I, "-empty"),
      onMouseDown: L
    }, d);
  var ne = Object.keys(w).map(function(te) {
    return w[te];
  }), Z = function(H) {
    return H.label;
  };
  function J(te, H) {
    var ie = te.group;
    return {
      role: ie ? "presentation" : "option",
      id: "".concat(o, "_list_").concat(H)
    };
  }
  var K = function(H) {
    var ie = O[H];
    if (!ie)
      return null;
    var W = ie.data || {}, se = W.value, le = ie.group, ge = xf(W, !0), me = Z(ie);
    return ie ? /* @__PURE__ */ $.createElement("div", xt({
      "aria-label": typeof me == "string" && !le ? me : null
    }, ge, {
      key: H
    }, J(ie, H), {
      "aria-selected": q(se)
    }), se) : null;
  }, ee = {
    role: "listbox",
    id: "".concat(o, "_list")
  };
  return /* @__PURE__ */ $.createElement($.Fragment, null, C && /* @__PURE__ */ $.createElement("div", xt({}, ee, {
    style: {
      height: 0,
      width: 0,
      overflow: "hidden"
    }
  }), K(B - 1), K(B), K(B + 1)), /* @__PURE__ */ $.createElement(LZ, {
    itemKey: "key",
    ref: P,
    data: O,
    height: T,
    itemHeight: E,
    fullHeight: !1,
    onMouseDown: L,
    onScroll: f,
    virtual: C,
    direction: x,
    innerProps: C ? null : ee
  }, function(te, H) {
    var ie = te.group, W = te.groupOption, se = te.data, le = te.label, ge = te.value, me = se.key;
    if (ie) {
      var pe, Te = (pe = se.title) !== null && pe !== void 0 ? pe : $F(le) ? le.toString() : void 0;
      return /* @__PURE__ */ $.createElement("div", {
        className: Ee(I, "".concat(I, "-group"), se.className),
        title: Te
      }, le !== void 0 ? le : me);
    }
    var de = se.disabled, Ae = se.title;
    se.children;
    var ue = se.style, be = se.className, Ie = En(se, xje), Ve = rd(Ie, ne), ze = Y(ge), Ne = de || !ze && k, lt = "".concat(I, "-option"), mt = Ee(I, lt, be, oe(oe(oe(oe({}, "".concat(lt, "-grouped"), W), "".concat(lt, "-active"), B === H && !Ne), "".concat(lt, "-disabled"), Ne), "".concat(lt, "-selected"), ze)), vt = Z(te), ke = !_ || typeof _ == "function" || ze, xe = typeof vt == "number" ? vt : vt || ge, Re = $F(xe) ? xe.toString() : void 0;
    return Ae !== void 0 && (Re = Ae), /* @__PURE__ */ $.createElement("div", xt({}, xf(Ve), C ? {} : J(te, H), {
      "aria-selected": q(ge),
      className: mt,
      title: Re,
      onMouseMove: function() {
        B === H || Ne || Q(H);
      },
      onClick: function() {
        Ne || X(ge);
      },
      style: ue
    }), /* @__PURE__ */ $.createElement("div", {
      className: "".concat(lt, "-content")
    }, typeof R == "function" ? R(te, {
      index: H
    }) : xe), /* @__PURE__ */ $.isValidElement(_) || ze, ke && /* @__PURE__ */ $.createElement(XE, {
      className: "".concat(I, "-option-state"),
      customizeIcon: _,
      customizeIconProps: {
        value: ge,
        disabled: Ne,
        isSelected: ze
      }
    }, ze ? "✓" : null));
  }));
}, FZ = /* @__PURE__ */ $.forwardRef(Eje);
process.env.NODE_ENV !== "production" && (FZ.displayName = "OptionList");
const Cje = function(e, t) {
  var n = $.useRef({
    values: /* @__PURE__ */ new Map(),
    options: /* @__PURE__ */ new Map()
  }), r = $.useMemo(function() {
    var o = n.current, a = o.values, s = o.options, c = e.map(function(d) {
      if (d.label === void 0) {
        var f;
        return ae(ae({}, d), {}, {
          label: (f = a.get(d.value)) === null || f === void 0 ? void 0 : f.label
        });
      }
      return d;
    }), l = /* @__PURE__ */ new Map(), u = /* @__PURE__ */ new Map();
    return c.forEach(function(d) {
      l.set(d.value, d), u.set(d.value, t.get(d.value) || s.get(d.value));
    }), n.current.values = l, n.current.options = u, c;
  }, [e, t]), i = $.useCallback(function(o) {
    return t.get(o) || n.current.options.get(o);
  }, [t]);
  return [r, i];
};
function OT(e, t) {
  return BM(e).join("").toUpperCase().includes(t);
}
const Tje = function(e, t, n, r, i) {
  return $.useMemo(function() {
    if (!n || r === !1)
      return e;
    var o = t.options, a = t.label, s = t.value, c = [], l = typeof r == "function", u = n.toUpperCase(), d = l ? r : function(h, p) {
      return i ? OT(p[i], u) : p[o] ? OT(p[a !== "children" ? a : "label"], u) : OT(p[s], u);
    }, f = l ? function(h) {
      return _R(h);
    } : function(h) {
      return h;
    };
    return e.forEach(function(h) {
      if (h[o]) {
        var p = d(n, f(h));
        if (p)
          c.push(h);
        else {
          var g = h[o].filter(function(m) {
            return d(n, f(m));
          });
          g.length && c.push(ae(ae({}, h), {}, oe({}, o, g)));
        }
        return;
      }
      d(n, f(h)) && c.push(h);
    }), c;
  }, [e, r, i, n, t]);
};
var AF = 0, Ije = process.env.NODE_ENV !== "test" && uo();
function $je() {
  var e;
  return Ije ? (e = AF, AF += 1) : e = "TEST_OR_SSR", e;
}
function Aje(e) {
  var t = $.useState(), n = he(t, 2), r = n[0], i = n[1];
  return $.useEffect(function() {
    i("rc_select_".concat($je()));
  }, []), e || r;
}
var Rje = ["children", "value"], Pje = ["children"];
function Oje(e) {
  var t = e, n = t.key, r = t.props, i = r.children, o = r.value, a = En(r, Rje);
  return ae({
    key: n,
    value: o !== void 0 ? o : n,
    children: i
  }, a);
}
function WM(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
  return Sf(e).map(function(n, r) {
    if (!/* @__PURE__ */ $.isValidElement(n) || !n.type)
      return null;
    var i = n, o = i.type.isSelectOptGroup, a = i.key, s = i.props, c = s.children, l = En(s, Pje);
    return t || !o ? Oje(n) : ae(ae({
      key: "__RC_SELECT_GRP__".concat(a === null ? r : a, "__"),
      label: a
    }, l), {}, {
      options: WM(c)
    });
  }).filter(function(n) {
    return n;
  });
}
var Mje = function(t, n, r, i, o) {
  return $.useMemo(function() {
    var a = t, s = !t;
    s && (a = WM(n));
    var c = /* @__PURE__ */ new Map(), l = /* @__PURE__ */ new Map(), u = function(h, p, g) {
      g && typeof g == "string" && h.set(p[g], p);
    }, d = function f(h) {
      for (var p = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, g = 0; g < h.length; g += 1) {
        var m = h[g];
        !m[r.options] || p ? (c.set(m[r.value], m), u(l, m, r.label), u(l, m, i), u(l, m, o)) : f(m[r.options], !0);
      }
    };
    return d(a), {
      options: a,
      valueOptions: c,
      labelOptions: l
    };
  }, [t, n, r, i, o]);
};
function RF(e) {
  var t = $.useRef();
  t.current = e;
  var n = $.useCallback(function() {
    return t.current.apply(t, arguments);
  }, []);
  return n;
}
function kje(e) {
  var t = e.mode, n = e.options, r = e.children, i = e.backfill, o = e.allowClear, a = e.placeholder, s = e.getInputElement, c = e.showSearch, l = e.onSearch, u = e.defaultOpen, d = e.autoFocus, f = e.labelInValue, h = e.value, p = e.inputValue, g = e.optionLabelProp, m = fw(t), v = c !== void 0 ? c : m || t === "combobox", y = n || WM(r);
  if (sn(t !== "tags" || y.every(function(C) {
    return !C.disabled;
  }), "Please avoid setting option to disabled in tags mode since user can always type text as tag."), t === "tags" || t === "combobox") {
    var _ = y.some(function(C) {
      return C.options ? C.options.some(function(x) {
        return typeof ("value" in x ? x.value : x.key) == "number";
      }) : typeof ("value" in C ? C.value : C.key) == "number";
    });
    sn(!_, "`value` of Option should not use number type when `mode` is `tags` or `combobox`.");
  }
  if (sn(t !== "combobox" || !g, "`combobox` mode not support `optionLabelProp`. Please set `value` on Option directly."), sn(t === "combobox" || !i, "`backfill` only works with `combobox` mode."), sn(t === "combobox" || !s, "`getInputElement` only work with `combobox` mode."), kA(t !== "combobox" || !s || !o || !a, "Customize `getInputElement` should customize clear and placeholder logic instead of configuring `allowClear` and `placeholder`."), l && !v && t !== "combobox" && t !== "tags" && sn(!1, "`onSearch` should work with `showSearch` instead of use alone."), kA(!u || d, "`defaultOpen` makes Select open without focus which means it will not close by click outside. You can set `autoFocus` if needed."), h != null) {
    var b = BM(h);
    sn(!f || b.every(function(C) {
      return It(C) === "object" && ("key" in C || "value" in C);
    }), "`value` should in shape of `{ value: string | number, label?: ReactNode }` when you set `labelInValue` to `true`"), sn(!m || Array.isArray(h), "`value` should be array when `mode` is `multiple` or `tags`");
  }
  if (r) {
    var w = null;
    Sf(r).some(function(C) {
      if (!/* @__PURE__ */ $.isValidElement(C) || !C.type)
        return !1;
      var x = C, T = x.type;
      if (T.isSelectOption)
        return !1;
      if (T.isSelectOptGroup) {
        var E = Sf(C.props.children).every(function(R) {
          return !/* @__PURE__ */ $.isValidElement(R) || !C.type || R.type.isSelectOption ? !0 : (w = R.type, !1);
        });
        return !E;
      }
      return w = T, !0;
    }), w && sn(!1, "`children` should be `Select.Option` or `Select.OptGroup` instead of `".concat(w.displayName || w.name || w, "`.")), sn(p === void 0, "`inputValue` is deprecated, please use `searchValue` instead.");
  }
}
function Nje(e, t) {
  if (e) {
    var n = function r(i) {
      for (var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, a = 0; a < i.length; a++) {
        var s = i[a];
        if (s[t == null ? void 0 : t.value] === null)
          return sn(!1, "`value` in Select options should not be `null`."), !0;
        if (!o && Array.isArray(s[t == null ? void 0 : t.options]) && r(s[t == null ? void 0 : t.options], !0))
          break;
      }
    };
    n(e);
  }
}
var Dje = ["id", "mode", "prefixCls", "backfill", "fieldNames", "inputValue", "searchValue", "onSearch", "autoClearSearchValue", "onSelect", "onDeselect", "dropdownMatchSelectWidth", "filterOption", "filterSort", "optionFilterProp", "optionLabelProp", "options", "optionRender", "children", "defaultActiveFirstOption", "menuItemSelectedIcon", "virtual", "direction", "listHeight", "listItemHeight", "labelRender", "value", "defaultValue", "labelInValue", "onChange", "maxCount"], jje = ["inputValue"];
function Lje(e) {
  return !e || It(e) !== "object";
}
var VZ = /* @__PURE__ */ $.forwardRef(function(e, t) {
  var n = e.id, r = e.mode, i = e.prefixCls, o = i === void 0 ? "rc-select" : i, a = e.backfill, s = e.fieldNames, c = e.inputValue, l = e.searchValue, u = e.onSearch, d = e.autoClearSearchValue, f = d === void 0 ? !0 : d, h = e.onSelect, p = e.onDeselect, g = e.dropdownMatchSelectWidth, m = g === void 0 ? !0 : g, v = e.filterOption, y = e.filterSort, _ = e.optionFilterProp, b = e.optionLabelProp, w = e.options, C = e.optionRender, x = e.children, T = e.defaultActiveFirstOption, E = e.menuItemSelectedIcon, R = e.virtual, I = e.direction, O = e.listHeight, P = O === void 0 ? 200 : O, k = e.listItemHeight, L = k === void 0 ? 20 : k, N = e.labelRender, D = e.value, z = e.defaultValue, V = e.labelInValue, B = e.onChange, U = e.maxCount, Q = En(e, Dje), Y = Aje(n), q = fw(r), X = !!(!w && x), ne = $.useMemo(function() {
    return v === void 0 && r === "combobox" ? !1 : v;
  }, [v, r]), Z = $.useMemo(
    function() {
      return kZ(s, X);
    },
    /* eslint-disable react-hooks/exhaustive-deps */
    [
      // We stringify fieldNames to avoid unnecessary re-renders.
      JSON.stringify(s),
      X
    ]
    /* eslint-enable react-hooks/exhaustive-deps */
  ), J = wc("", {
    value: l !== void 0 ? l : c,
    postState: function(We) {
      return We || "";
    }
  }), K = he(J, 2), ee = K[0], te = K[1], H = Mje(w, x, Z, _, b), ie = H.valueOptions, W = H.labelOptions, se = H.options, le = $.useCallback(function(Ue) {
    var We = BM(Ue);
    return We.map(function(ct) {
      var ht, Rt, Ft, re, Se;
      if (Lje(ct))
        ht = ct;
      else {
        var De;
        Ft = ct.key, Rt = ct.label, ht = (De = ct.value) !== null && De !== void 0 ? De : Ft;
      }
      var Ye = ie.get(ht);
      if (Ye) {
        var $t;
        if (Rt === void 0 && (Rt = Ye == null ? void 0 : Ye[b || Z.label]), Ft === void 0 && (Ft = ($t = Ye == null ? void 0 : Ye.key) !== null && $t !== void 0 ? $t : ht), re = Ye == null ? void 0 : Ye.disabled, Se = Ye == null ? void 0 : Ye.title, process.env.NODE_ENV !== "production" && !b) {
          var Ct = Ye == null ? void 0 : Ye[Z.label];
          Ct !== void 0 && !/* @__PURE__ */ $.isValidElement(Ct) && !/* @__PURE__ */ $.isValidElement(Rt) && Ct !== Rt && sn(!1, "`label` of `value` is not same as `label` in Select options.");
        }
      }
      return {
        label: Rt,
        value: ht,
        key: Ft,
        disabled: re,
        title: Se
      };
    });
  }, [Z, b, ie]), ge = wc(z, {
    value: D
  }), me = he(ge, 2), pe = me[0], Te = me[1], de = $.useMemo(function() {
    var Ue, We = q && pe === null ? [] : pe, ct = le(We);
    return r === "combobox" && j8e((Ue = ct[0]) === null || Ue === void 0 ? void 0 : Ue.value) ? [] : ct;
  }, [pe, le, r, q]), Ae = Cje(de, ie), ue = he(Ae, 2), be = ue[0], Ie = ue[1], Ve = $.useMemo(function() {
    if (!r && be.length === 1) {
      var Ue = be[0];
      if (Ue.value === null && (Ue.label === null || Ue.label === void 0))
        return [];
    }
    return be.map(function(We) {
      var ct;
      return ae(ae({}, We), {}, {
        label: (ct = typeof N == "function" ? N(We) : We.label) !== null && ct !== void 0 ? ct : We.value
      });
    });
  }, [r, be, N]), ze = $.useMemo(function() {
    return new Set(be.map(function(Ue) {
      return Ue.value;
    }));
  }, [be]);
  $.useEffect(function() {
    if (r === "combobox") {
      var Ue, We = (Ue = be[0]) === null || Ue === void 0 ? void 0 : Ue.value;
      te(D8e(We) ? String(We) : "");
    }
  }, [be]);
  var Ne = RF(function(Ue, We) {
    var ct = We ?? Ue;
    return oe(oe({}, Z.value, Ue), Z.label, ct);
  }), lt = $.useMemo(function() {
    if (r !== "tags")
      return se;
    var Ue = tt(se), We = function(ht) {
      return ie.has(ht);
    };
    return tt(be).sort(function(ct, ht) {
      return ct.value < ht.value ? -1 : 1;
    }).forEach(function(ct) {
      var ht = ct.value;
      We(ht) || Ue.push(Ne(ht, ct.label));
    }), Ue;
  }, [Ne, se, ie, be, r]), mt = Tje(lt, Z, ee, ne, _), vt = $.useMemo(function() {
    return r !== "tags" || !ee || mt.some(function(Ue) {
      return Ue[_ || "value"] === ee;
    }) || mt.some(function(Ue) {
      return Ue[Z.value] === ee;
    }) ? mt : [Ne(ee)].concat(tt(mt));
  }, [Ne, _, r, mt, ee, Z]), ke = function Ue(We) {
    var ct = tt(We).sort(function(ht, Rt) {
      return y(ht, Rt, {
        searchValue: ee
      });
    });
    return ct.map(function(ht) {
      return Array.isArray(ht.options) ? ae(ae({}, ht), {}, {
        options: ht.options.length > 0 ? Ue(ht.options) : ht.options
      }) : ht;
    });
  }, xe = $.useMemo(function() {
    return y ? ke(vt) : vt;
  }, [vt, y, ee]), Re = $.useMemo(function() {
    return nje(xe, {
      fieldNames: Z,
      childrenAsData: X
    });
  }, [xe, Z, X]), yt = function(We) {
    var ct = le(We);
    if (Te(ct), B && // Trigger event only when value changed
    (ct.length !== be.length || ct.some(function(Ft, re) {
      var Se;
      return ((Se = be[re]) === null || Se === void 0 ? void 0 : Se.value) !== (Ft == null ? void 0 : Ft.value);
    }))) {
      var ht = V ? ct : ct.map(function(Ft) {
        return Ft.value;
      }), Rt = ct.map(function(Ft) {
        return _R(Ie(Ft.value));
      });
      B(
        // Value
        q ? ht : ht[0],
        // Option
        q ? Rt : Rt[0]
      );
    }
  }, Pt = $.useState(null), _t = he(Pt, 2), St = _t[0], ft = _t[1], kn = $.useState(0), Dt = he(kn, 2), nt = Dt[0], Be = Dt[1], st = T !== void 0 ? T : r !== "combobox", pt = $.useCallback(function(Ue, We) {
    var ct = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, ht = ct.source, Rt = ht === void 0 ? "keyboard" : ht;
    Be(We), a && r === "combobox" && Ue !== null && Rt === "keyboard" && ft(String(Ue));
  }, [a, r]), Et = function(We, ct, ht) {
    var Rt = function() {
      var Xe, je = Ie(We);
      return [V ? {
        label: je == null ? void 0 : je[Z.label],
        value: We,
        key: (Xe = je == null ? void 0 : je.key) !== null && Xe !== void 0 ? Xe : We
      } : We, _R(je)];
    };
    if (ct && h) {
      var Ft = Rt(), re = he(Ft, 2), Se = re[0], De = re[1];
      h(Se, De);
    } else if (!ct && p && ht !== "clear") {
      var Ye = Rt(), $t = he(Ye, 2), Ct = $t[0], ut = $t[1];
      p(Ct, ut);
    }
  }, Ke = RF(function(Ue, We) {
    var ct, ht = q ? We.selected : !0;
    ht ? ct = q ? [].concat(tt(be), [Ue]) : [Ue] : ct = be.filter(function(Rt) {
      return Rt.value !== Ue;
    }), yt(ct), Et(Ue, ht), r === "combobox" ? ft("") : (!fw || f) && (te(""), ft(""));
  }), rt = function(We, ct) {
    yt(We);
    var ht = ct.type, Rt = ct.values;
    (ht === "remove" || ht === "clear") && Rt.forEach(function(Ft) {
      Et(Ft.value, !1, ht);
    });
  }, Le = function(We, ct) {
    if (te(We), ft(null), ct.source === "submit") {
      var ht = (We || "").trim();
      if (ht) {
        var Rt = Array.from(new Set([].concat(tt(ze), [ht])));
        yt(Rt), Et(ht, !0), te("");
      }
      return;
    }
    ct.source !== "blur" && (r === "combobox" && yt(We), u == null || u(We));
  }, Xt = function(We) {
    var ct = We;
    r !== "tags" && (ct = We.map(function(Rt) {
      var Ft = W.get(Rt);
      return Ft == null ? void 0 : Ft.value;
    }).filter(function(Rt) {
      return Rt !== void 0;
    }));
    var ht = Array.from(new Set([].concat(tt(ze), tt(ct))));
    yt(ht), ht.forEach(function(Rt) {
      Et(Rt, !0);
    });
  }, Ht = $.useMemo(function() {
    var Ue = R !== !1 && m !== !1;
    return ae(ae({}, H), {}, {
      flattenOptions: Re,
      onActiveValue: pt,
      defaultActiveFirstOption: st,
      onSelect: Ke,
      menuItemSelectedIcon: E,
      rawValues: ze,
      fieldNames: Z,
      virtual: Ue,
      direction: I,
      listHeight: P,
      listItemHeight: L,
      childrenAsData: X,
      maxCount: U,
      optionRender: C
    });
  }, [U, H, Re, pt, st, Ke, E, ze, Z, R, m, I, P, L, X, C]);
  return process.env.NODE_ENV !== "production" && (kje(e), Nje(se, Z)), /* @__PURE__ */ $.createElement(zM.Provider, {
    value: Ht
  }, /* @__PURE__ */ $.createElement(NZ, xt({}, Q, {
    // >>> MISC
    id: Y,
    prefixCls: o,
    ref: t,
    omitDomProps: jje,
    mode: r,
    displayValues: Ve,
    onDisplayValuesChange: rt,
    direction: I,
    searchValue: ee,
    onSearch: Le,
    autoClearSearchValue: f,
    onSearchSplit: Xt,
    dropdownMatchSelectWidth: m,
    OptionList: FZ,
    emptyOptions: !Re.length,
    activeValue: St,
    activeDescendantId: "".concat(Y, "_list_").concat(nt)
  })));
});
process.env.NODE_ENV !== "production" && (VZ.displayName = "Select");
var qM = VZ;
qM.Option = UM;
qM.OptGroup = HM;
function ep(e, t, n) {
  return Ee({
    [`${e}-status-success`]: t === "success",
    [`${e}-status-warning`]: t === "warning",
    [`${e}-status-error`]: t === "error",
    [`${e}-status-validating`]: t === "validating",
    [`${e}-has-feedback`]: n
  });
}
const ky = (e, t) => t || e, BZ = () => {
  const [, e] = js(), [t] = yM("Empty"), r = new Mn(e.colorBgBase).toHsl().l < 0.5 ? {
    opacity: 0.65
  } : {};
  return /* @__PURE__ */ $.createElement("svg", {
    style: r,
    width: "184",
    height: "152",
    viewBox: "0 0 184 152",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ $.createElement("title", null, (t == null ? void 0 : t.description) || "Empty"), /* @__PURE__ */ $.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /* @__PURE__ */ $.createElement("g", {
    transform: "translate(24 31.67)"
  }, /* @__PURE__ */ $.createElement("ellipse", {
    fillOpacity: ".8",
    fill: "#F5F5F7",
    cx: "67.797",
    cy: "106.89",
    rx: "67.797",
    ry: "12.668"
  }), /* @__PURE__ */ $.createElement("path", {
    d: "M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z",
    fill: "#AEB8C2"
  }), /* @__PURE__ */ $.createElement("path", {
    d: "M101.537 86.214L80.63 61.102c-1.001-1.207-2.507-1.867-4.048-1.867H31.724c-1.54 0-3.047.66-4.048 1.867L6.769 86.214v13.792h94.768V86.214z",
    fill: "url(#linearGradient-1)",
    transform: "translate(13.56)"
  }), /* @__PURE__ */ $.createElement("path", {
    d: "M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z",
    fill: "#F5F5F7"
  }), /* @__PURE__ */ $.createElement("path", {
    d: "M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z",
    fill: "#DCE0E6"
  })), /* @__PURE__ */ $.createElement("path", {
    d: "M149.121 33.292l-6.83 2.65a1 1 0 0 1-1.317-1.23l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902z",
    fill: "#DCE0E6"
  }), /* @__PURE__ */ $.createElement("g", {
    transform: "translate(149.65 15.383)",
    fill: "#FFF"
  }, /* @__PURE__ */ $.createElement("ellipse", {
    cx: "20.654",
    cy: "3.167",
    rx: "2.849",
    ry: "2.815"
  }), /* @__PURE__ */ $.createElement("path", {
    d: "M5.698 5.63H0L2.898.704zM9.259.704h4.985V5.63H9.259z"
  }))));
};
process.env.NODE_ENV !== "production" && (BZ.displayName = "EmptyImage");
const Fje = BZ, zZ = () => {
  const [, e] = js(), [t] = yM("Empty"), {
    colorFill: n,
    colorFillTertiary: r,
    colorFillQuaternary: i,
    colorBgContainer: o
  } = e, {
    borderColor: a,
    shadowColor: s,
    contentColor: c
  } = Tt(() => ({
    borderColor: new Mn(n).onBackground(o).toHexShortString(),
    shadowColor: new Mn(r).onBackground(o).toHexShortString(),
    contentColor: new Mn(i).onBackground(o).toHexShortString()
  }), [n, r, i, o]);
  return /* @__PURE__ */ $.createElement("svg", {
    width: "64",
    height: "41",
    viewBox: "0 0 64 41",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ $.createElement("title", null, (t == null ? void 0 : t.description) || "Empty"), /* @__PURE__ */ $.createElement("g", {
    transform: "translate(0 1)",
    fill: "none",
    fillRule: "evenodd"
  }, /* @__PURE__ */ $.createElement("ellipse", {
    fill: s,
    cx: "32",
    cy: "33",
    rx: "32",
    ry: "7"
  }), /* @__PURE__ */ $.createElement("g", {
    fillRule: "nonzero",
    stroke: a
  }, /* @__PURE__ */ $.createElement("path", {
    d: "M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z"
  }), /* @__PURE__ */ $.createElement("path", {
    d: "M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z",
    fill: c
  }))));
};
process.env.NODE_ENV !== "production" && (zZ.displayName = "SimpleImage");
const Vje = zZ, Bje = (e) => {
  const {
    componentCls: t,
    margin: n,
    marginXS: r,
    marginXL: i,
    fontSize: o,
    lineHeight: a
  } = e;
  return {
    [t]: {
      marginInline: r,
      fontSize: o,
      lineHeight: a,
      textAlign: "center",
      // 原来 &-image 没有父子结构，现在为了外层承担我们的 hashId，改成父子结构
      [`${t}-image`]: {
        height: e.emptyImgHeight,
        marginBottom: r,
        opacity: e.opacityImage,
        img: {
          height: "100%"
        },
        svg: {
          maxWidth: "100%",
          height: "100%",
          margin: "auto"
        }
      },
      [`${t}-description`]: {
        color: e.colorTextDescription
      },
      // 原来 &-footer 没有父子结构，现在为了外层承担我们的 hashId，改成父子结构
      [`${t}-footer`]: {
        marginTop: n
      },
      "&-normal": {
        marginBlock: i,
        color: e.colorTextDescription,
        [`${t}-description`]: {
          color: e.colorTextDescription
        },
        [`${t}-image`]: {
          height: e.emptyImgHeightMD
        }
      },
      "&-small": {
        marginBlock: r,
        color: e.colorTextDescription,
        [`${t}-image`]: {
          height: e.emptyImgHeightSM
        }
      }
    }
  };
}, zje = Za("Empty", (e) => {
  const {
    componentCls: t,
    controlHeightLG: n,
    calc: r
  } = e, i = Mr(e, {
    emptyImgCls: `${t}-img`,
    emptyImgHeight: r(n).mul(2.5).equal(),
    emptyImgHeightMD: n,
    emptyImgHeightSM: r(n).mul(0.875).equal()
  });
  return [Bje(i)];
});
var Hje = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
const HZ = /* @__PURE__ */ $.createElement(Fje, null), UZ = /* @__PURE__ */ $.createElement(Vje, null), QE = (e) => {
  var {
    className: t,
    rootClassName: n,
    prefixCls: r,
    image: i = HZ,
    description: o,
    children: a,
    imageStyle: s,
    style: c
  } = e, l = Hje(e, ["className", "rootClassName", "prefixCls", "image", "description", "children", "imageStyle", "style"]);
  const {
    getPrefixCls: u,
    direction: d,
    empty: f
  } = $.useContext(Cn), h = u("empty", r), [p, g, m] = zje(h), [v] = yM("Empty"), y = typeof o < "u" ? o : v == null ? void 0 : v.description, _ = typeof y == "string" ? y : "empty";
  let b = null;
  return typeof i == "string" ? b = /* @__PURE__ */ $.createElement("img", {
    alt: _,
    src: i
  }) : b = i, p(/* @__PURE__ */ $.createElement("div", Object.assign({
    className: Ee(g, m, h, f == null ? void 0 : f.className, {
      [`${h}-normal`]: i === UZ,
      [`${h}-rtl`]: d === "rtl"
    }, t, n),
    style: Object.assign(Object.assign({}, f == null ? void 0 : f.style), c)
  }, l), /* @__PURE__ */ $.createElement("div", {
    className: `${h}-image`,
    style: s
  }, b), y && /* @__PURE__ */ $.createElement("div", {
    className: `${h}-description`
  }, y), a && /* @__PURE__ */ $.createElement("div", {
    className: `${h}-footer`
  }, a)));
};
QE.PRESENTED_IMAGE_DEFAULT = HZ;
QE.PRESENTED_IMAGE_SIMPLE = UZ;
process.env.NODE_ENV !== "production" && (QE.displayName = "Empty");
const km = QE, Uje = (e) => {
  const {
    componentName: t
  } = e, {
    getPrefixCls: n
  } = gt(Cn), r = n("empty");
  switch (t) {
    case "Table":
    case "List":
      return /* @__PURE__ */ j.createElement(km, {
        image: km.PRESENTED_IMAGE_SIMPLE
      });
    case "Select":
    case "TreeSelect":
    case "Cascader":
    case "Transfer":
    case "Mentions":
      return /* @__PURE__ */ j.createElement(km, {
        image: km.PRESENTED_IMAGE_SIMPLE,
        className: `${r}-small`
      });
    case "Table.filter":
      return null;
    default:
      return /* @__PURE__ */ j.createElement(km, null);
  }
}, Wje = Uje, qje = function(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : void 0;
  var r, i;
  const {
    variant: o,
    [e]: a
  } = gt(Cn), s = gt(jDe), c = a == null ? void 0 : a.variant;
  let l;
  typeof t < "u" ? l = t : n === !1 ? l = "borderless" : l = (i = (r = s ?? c) !== null && r !== void 0 ? r : o) !== null && i !== void 0 ? i : "outlined";
  const u = a3e.includes(l);
  return [l, u];
}, JE = qje, Gje = (e) => {
  const n = {
    overflow: {
      adjustX: !0,
      adjustY: !0,
      shiftY: !0
    },
    htmlRegion: e === "scroll" ? "scroll" : "visible",
    dynamicInset: !0
  };
  return {
    bottomLeft: Object.assign(Object.assign({}, n), {
      points: ["tl", "bl"],
      offset: [0, 4]
    }),
    bottomRight: Object.assign(Object.assign({}, n), {
      points: ["tr", "br"],
      offset: [0, 4]
    }),
    topLeft: Object.assign(Object.assign({}, n), {
      points: ["bl", "tl"],
      offset: [0, -4]
    }),
    topRight: Object.assign(Object.assign({}, n), {
      points: ["br", "tr"],
      offset: [0, -4]
    })
  };
};
function Kje(e, t) {
  return e || Gje(t);
}
const PF = (e) => {
  const {
    optionHeight: t,
    optionFontSize: n,
    optionLineHeight: r,
    optionPadding: i
  } = e;
  return {
    position: "relative",
    display: "block",
    minHeight: t,
    padding: i,
    color: e.colorText,
    fontWeight: "normal",
    fontSize: n,
    lineHeight: r,
    boxSizing: "border-box"
  };
}, Yje = (e) => {
  const {
    antCls: t,
    componentCls: n
  } = e, r = `${n}-item`, i = `&${t}-slide-up-enter${t}-slide-up-enter-active`, o = `&${t}-slide-up-appear${t}-slide-up-appear-active`, a = `&${t}-slide-up-leave${t}-slide-up-leave-active`, s = `${n}-dropdown-placement-`;
  return [
    {
      [`${n}-dropdown`]: Object.assign(Object.assign({}, _a(e)), {
        position: "absolute",
        top: -9999,
        zIndex: e.zIndexPopup,
        boxSizing: "border-box",
        padding: e.paddingXXS,
        overflow: "hidden",
        fontSize: e.fontSize,
        // Fix select render lag of long text in chrome
        // https://github.com/ant-design/ant-design/issues/11456
        // https://github.com/ant-design/ant-design/issues/11843
        fontVariant: "initial",
        backgroundColor: e.colorBgElevated,
        borderRadius: e.borderRadiusLG,
        outline: "none",
        boxShadow: e.boxShadowSecondary,
        [`
          ${i}${s}bottomLeft,
          ${o}${s}bottomLeft
        `]: {
          animationName: aZ
        },
        [`
          ${i}${s}topLeft,
          ${o}${s}topLeft,
          ${i}${s}topRight,
          ${o}${s}topRight
        `]: {
          animationName: cZ
        },
        [`${a}${s}bottomLeft`]: {
          animationName: sZ
        },
        [`
          ${a}${s}topLeft,
          ${a}${s}topRight
        `]: {
          animationName: lZ
        },
        "&-hidden": {
          display: "none"
        },
        [r]: Object.assign(Object.assign({}, PF(e)), {
          cursor: "pointer",
          transition: `background ${e.motionDurationSlow} ease`,
          borderRadius: e.borderRadiusSM,
          // =========== Group ============
          "&-group": {
            color: e.colorTextDescription,
            fontSize: e.fontSizeSM,
            cursor: "default"
          },
          // =========== Option ===========
          "&-option": {
            display: "flex",
            "&-content": Object.assign({
              flex: "auto"
            }, JA),
            "&-state": {
              flex: "none",
              display: "flex",
              alignItems: "center"
            },
            [`&-active:not(${r}-option-disabled)`]: {
              backgroundColor: e.optionActiveBg
            },
            [`&-selected:not(${r}-option-disabled)`]: {
              color: e.optionSelectedColor,
              fontWeight: e.optionSelectedFontWeight,
              backgroundColor: e.optionSelectedBg,
              [`${r}-option-state`]: {
                color: e.colorPrimary
              },
              [`&:has(+ ${r}-option-selected:not(${r}-option-disabled))`]: {
                borderEndStartRadius: 0,
                borderEndEndRadius: 0,
                [`& + ${r}-option-selected:not(${r}-option-disabled)`]: {
                  borderStartStartRadius: 0,
                  borderStartEndRadius: 0
                }
              }
            },
            "&-disabled": {
              [`&${r}-option-selected`]: {
                backgroundColor: e.colorBgContainerDisabled
              },
              color: e.colorTextDisabled,
              cursor: "not-allowed"
            },
            "&-grouped": {
              paddingInlineStart: e.calc(e.controlPaddingHorizontal).mul(2).equal()
            }
          },
          "&-empty": Object.assign(Object.assign({}, PF(e)), {
            color: e.colorTextDisabled
          })
        }),
        // =========================== RTL ===========================
        "&-rtl": {
          direction: "rtl"
        }
      })
    },
    // Follow code may reuse in other components
    WL(e, "slide-up"),
    WL(e, "slide-down"),
    UL(e, "move-up"),
    UL(e, "move-down")
  ];
}, Xje = Yje, Qje = (e) => {
  const {
    multipleSelectItemHeight: t,
    paddingXXS: n,
    lineWidth: r,
    INTERNAL_FIXED_ITEM_MARGIN: i
  } = e, o = e.max(e.calc(n).sub(r).equal(), 0), a = e.max(e.calc(o).sub(i).equal(), 0);
  return {
    basePadding: o,
    containerPadding: a,
    itemHeight: et(t),
    itemLineHeight: et(e.calc(t).sub(e.calc(e.lineWidth).mul(2)).equal())
  };
}, Jje = (e) => {
  const {
    multipleSelectItemHeight: t,
    selectHeight: n,
    lineWidth: r
  } = e;
  return e.calc(n).sub(t).div(2).sub(r).equal();
}, Zje = (e) => {
  const {
    componentCls: t,
    iconCls: n,
    borderRadiusSM: r,
    motionDurationSlow: i,
    paddingXS: o,
    multipleItemColorDisabled: a,
    multipleItemBorderColorDisabled: s,
    colorIcon: c,
    colorIconHover: l,
    INTERNAL_FIXED_ITEM_MARGIN: u
  } = e;
  return {
    /**
     * Do not merge `height` & `line-height` under style with `selection` & `search`, since chrome
     * may update to redesign with its align logic.
     */
    // =========================== Overflow ===========================
    [`${t}-selection-overflow`]: {
      position: "relative",
      display: "flex",
      flex: "auto",
      flexWrap: "wrap",
      maxWidth: "100%",
      "&-item": {
        flex: "none",
        alignSelf: "center",
        maxWidth: "100%",
        display: "inline-flex"
      },
      // ======================== Selections ==========================
      [`${t}-selection-item`]: {
        display: "flex",
        alignSelf: "center",
        flex: "none",
        boxSizing: "border-box",
        maxWidth: "100%",
        marginBlock: u,
        borderRadius: r,
        cursor: "default",
        transition: `font-size ${i}, line-height ${i}, height ${i}`,
        marginInlineEnd: e.calc(u).mul(2).equal(),
        paddingInlineStart: o,
        paddingInlineEnd: e.calc(o).div(2).equal(),
        [`${t}-disabled&`]: {
          color: a,
          borderColor: s,
          cursor: "not-allowed"
        },
        // It's ok not to do this, but 24px makes bottom narrow in view should adjust
        "&-content": {
          display: "inline-block",
          marginInlineEnd: e.calc(o).div(2).equal(),
          overflow: "hidden",
          whiteSpace: "pre",
          // fix whitespace wrapping. custom tags display all whitespace within.
          textOverflow: "ellipsis"
        },
        "&-remove": Object.assign(Object.assign({}, LE()), {
          display: "inline-flex",
          alignItems: "center",
          color: c,
          fontWeight: "bold",
          fontSize: 10,
          lineHeight: "inherit",
          cursor: "pointer",
          [`> ${n}`]: {
            verticalAlign: "-0.2em"
          },
          "&:hover": {
            color: l
          }
        })
      }
    }
  };
}, eLe = (e, t) => {
  const {
    componentCls: n,
    INTERNAL_FIXED_ITEM_MARGIN: r
  } = e, i = `${n}-selection-overflow`, o = e.multipleSelectItemHeight, a = Jje(e), s = t ? `${n}-${t}` : "", c = Qje(e);
  return {
    [`${n}-multiple${s}`]: Object.assign(Object.assign({}, Zje(e)), {
      // ========================= Selector =========================
      [`${n}-selector`]: {
        display: "flex",
        alignItems: "center",
        width: "100%",
        height: "100%",
        // Multiple is little different that horizontal is follow the vertical
        paddingInline: c.basePadding,
        paddingBlock: c.containerPadding,
        borderRadius: e.borderRadius,
        [`${n}-disabled&`]: {
          background: e.multipleSelectorBgDisabled,
          cursor: "not-allowed"
        },
        "&:after": {
          display: "inline-block",
          width: 0,
          margin: `${et(r)} 0`,
          lineHeight: et(o),
          visibility: "hidden",
          content: '"\\a0"'
        }
      },
      [`${n}-selection-wrap`]: {
        width: "100%",
        overflow: "hidden"
      },
      // ======================== Selections ========================
      [`${n}-selection-item`]: {
        height: c.itemHeight,
        lineHeight: et(c.itemLineHeight)
      },
      // ========================== Input ==========================
      [`${i}-item + ${i}-item`]: {
        [`${n}-selection-search`]: {
          marginInlineStart: 0
        }
      },
      // https://github.com/ant-design/ant-design/issues/44754
      [`${i}-item-suffix`]: {
        height: "100%"
      },
      [`${n}-selection-search`]: {
        display: "inline-flex",
        position: "relative",
        maxWidth: "100%",
        marginInlineStart: e.calc(e.inputPaddingHorizontalBase).sub(a).equal(),
        "\n          &-input,\n          &-mirror\n        ": {
          height: o,
          fontFamily: e.fontFamily,
          lineHeight: et(o),
          transition: `all ${e.motionDurationSlow}`
        },
        "&-input": {
          width: "100%",
          minWidth: 4.1
          // fix search cursor missing
        },
        "&-mirror": {
          position: "absolute",
          top: 0,
          insetInlineStart: 0,
          insetInlineEnd: "auto",
          zIndex: 999,
          whiteSpace: "pre",
          // fix whitespace wrapping caused width calculation bug
          visibility: "hidden"
        }
      },
      // ======================= Placeholder =======================
      [`${n}-selection-placeholder`]: {
        position: "absolute",
        top: "50%",
        insetInlineStart: e.inputPaddingHorizontalBase,
        insetInlineEnd: e.inputPaddingHorizontalBase,
        transform: "translateY(-50%)",
        transition: `all ${e.motionDurationSlow}`
      },
      [`${n}-prefix`]: {
        height: c.itemHeight,
        lineHeight: et(c.itemLineHeight),
        marginInlineStart: `calc(${et(e.inputPaddingHorizontalBase)} - ${et(c.basePadding)})`,
        marginInlineEnd: e.selectAffixPadding
      }
    })
  };
};
function MT(e, t) {
  const {
    componentCls: n
  } = e, r = t ? `${n}-${t}` : "", i = {
    [`${n}-multiple${r}`]: {
      fontSize: e.fontSize,
      // ========================= Selector =========================
      [`${n}-selector`]: {
        [`${n}-show-search&`]: {
          cursor: "text"
        }
      },
      [`
        &${n}-show-arrow ${n}-selector,
        &${n}-allow-clear ${n}-selector
      `]: {
        paddingInlineEnd: e.calc(e.fontSizeIcon).add(e.controlPaddingHorizontal).equal()
      }
    }
  };
  return [eLe(e, t), i];
}
const tLe = (e) => {
  const {
    componentCls: t
  } = e, n = Mr(e, {
    selectHeight: e.controlHeightSM,
    multipleSelectItemHeight: e.multipleItemHeightSM,
    borderRadius: e.borderRadiusSM,
    borderRadiusSM: e.borderRadiusXS
  }), r = Mr(e, {
    fontSize: e.fontSizeLG,
    selectHeight: e.controlHeightLG,
    multipleSelectItemHeight: e.multipleItemHeightLG,
    borderRadius: e.borderRadiusLG,
    borderRadiusSM: e.borderRadius
  });
  return [
    MT(e),
    // ======================== Small ========================
    MT(n, "sm"),
    // Padding
    {
      [`${t}-multiple${t}-sm`]: {
        [`${t}-selection-placeholder`]: {
          insetInline: e.calc(e.controlPaddingHorizontalSM).sub(e.lineWidth).equal()
        },
        // https://github.com/ant-design/ant-design/issues/29559
        [`${t}-selection-search`]: {
          marginInlineStart: 2
          // Magic Number
        }
      }
    },
    // ======================== Large ========================
    MT(r, "lg")
  ];
}, nLe = tLe;
function kT(e, t) {
  const {
    componentCls: n,
    inputPaddingHorizontalBase: r,
    borderRadius: i,
    selectAffixPadding: o
  } = e, a = e.calc(e.controlHeight).sub(e.calc(e.lineWidth).mul(2)).equal(), s = t ? `${n}-${t}` : "";
  return {
    [`${n}-single${s}`]: {
      fontSize: e.fontSize,
      height: e.controlHeight,
      // ========================= Selector =========================
      [`${n}-selector`]: Object.assign(Object.assign({}, _a(e, !0)), {
        display: "flex",
        borderRadius: i,
        flex: "1 1 auto",
        [`${n}-selection-wrap`]: {
          display: "flex",
          width: "100%",
          position: "relative"
        },
        [`${n}-selection-search`]: {
          position: "absolute",
          inset: 0,
          width: "100%",
          "&-input": {
            width: "100%",
            WebkitAppearance: "textfield"
          }
        },
        [`
          ${n}-selection-item,
          ${n}-selection-placeholder,
          ${n}-prefix
        `]: {
          display: "block",
          padding: 0,
          lineHeight: et(a),
          transition: `all ${e.motionDurationSlow}, visibility 0s`,
          alignSelf: "center"
        },
        [`${n}-selection-placeholder`]: {
          transition: "none",
          pointerEvents: "none"
        },
        [`${n}-prefix`]: {
          marginInlineEnd: o
        },
        // For common baseline align
        [[
          "&:after",
          /* For '' value baseline align */
          `${n}-selection-item:empty:after`,
          /* For undefined value baseline align */
          `${n}-selection-placeholder:empty:after`
        ].join(",")]: {
          display: "inline-block",
          width: 0,
          visibility: "hidden",
          content: '"\\a0"'
        }
      }),
      [`
        &${n}-show-arrow ${n}-selection-item,
        &${n}-show-arrow ${n}-selection-search,
        &${n}-show-arrow ${n}-selection-placeholder
      `]: {
        paddingInlineEnd: e.showArrowPaddingInlineEnd
      },
      // Opacity selection if open
      [`&${n}-open ${n}-selection-item`]: {
        color: e.colorTextPlaceholder
      },
      // ========================== Input ==========================
      // We only change the style of non-customize input which is only support by `combobox` mode.
      // Not customize
      [`&:not(${n}-customize-input)`]: {
        [`${n}-selector`]: {
          width: "100%",
          height: "100%",
          padding: `0 ${et(r)}`,
          [`${n}-selection-search-input`]: {
            height: a
          },
          "&:after": {
            lineHeight: et(a)
          }
        }
      },
      [`&${n}-customize-input`]: {
        [`${n}-selector`]: {
          "&:after": {
            display: "none"
          },
          [`${n}-selection-search`]: {
            position: "static",
            width: "100%"
          },
          [`${n}-selection-placeholder`]: {
            position: "absolute",
            insetInlineStart: 0,
            insetInlineEnd: 0,
            padding: `0 ${et(r)}`,
            "&:after": {
              display: "none"
            }
          }
        }
      }
    }
  };
}
function rLe(e) {
  const {
    componentCls: t
  } = e, n = e.calc(e.controlPaddingHorizontalSM).sub(e.lineWidth).equal();
  return [
    kT(e),
    // ======================== Small ========================
    // Shared
    kT(Mr(e, {
      controlHeight: e.controlHeightSM,
      borderRadius: e.borderRadiusSM
    }), "sm"),
    // padding
    {
      [`${t}-single${t}-sm`]: {
        [`&:not(${t}-customize-input)`]: {
          [`${t}-selector`]: {
            padding: `0 ${et(n)}`
          },
          // With arrow should provides `padding-right` to show the arrow
          [`&${t}-show-arrow ${t}-selection-search`]: {
            insetInlineEnd: e.calc(n).add(e.calc(e.fontSize).mul(1.5)).equal()
          },
          [`
            &${t}-show-arrow ${t}-selection-item,
            &${t}-show-arrow ${t}-selection-placeholder
          `]: {
            paddingInlineEnd: e.calc(e.fontSize).mul(1.5).equal()
          }
        }
      }
    },
    // ======================== Large ========================
    // Shared
    kT(Mr(e, {
      controlHeight: e.singleItemHeightLG,
      fontSize: e.fontSizeLG,
      borderRadius: e.borderRadiusLG
    }), "lg")
  ];
}
const iLe = (e) => {
  const {
    fontSize: t,
    lineHeight: n,
    lineWidth: r,
    controlHeight: i,
    controlHeightSM: o,
    controlHeightLG: a,
    paddingXXS: s,
    controlPaddingHorizontal: c,
    zIndexPopupBase: l,
    colorText: u,
    fontWeightStrong: d,
    controlItemBgActive: f,
    controlItemBgHover: h,
    colorBgContainer: p,
    colorFillSecondary: g,
    colorBgContainerDisabled: m,
    colorTextDisabled: v,
    colorPrimaryHover: y,
    colorPrimary: _,
    controlOutline: b
  } = e, w = s * 2, C = r * 2, x = Math.min(i - w, i - C), T = Math.min(o - w, o - C), E = Math.min(a - w, a - C);
  return {
    INTERNAL_FIXED_ITEM_MARGIN: Math.floor(s / 2),
    zIndexPopup: l + 50,
    optionSelectedColor: u,
    optionSelectedFontWeight: d,
    optionSelectedBg: f,
    optionActiveBg: h,
    optionPadding: `${(i - t * n) / 2}px ${c}px`,
    optionFontSize: t,
    optionLineHeight: n,
    optionHeight: i,
    selectorBg: p,
    clearBg: p,
    singleItemHeightLG: a,
    multipleItemBg: g,
    multipleItemBorderColor: "transparent",
    multipleItemHeight: x,
    multipleItemHeightSM: T,
    multipleItemHeightLG: E,
    multipleSelectorBgDisabled: m,
    multipleItemColorDisabled: v,
    multipleItemBorderColorDisabled: "transparent",
    showArrowPaddingInlineEnd: Math.ceil(e.fontSize * 1.25),
    hoverBorderColor: y,
    activeBorderColor: _,
    activeOutlineColor: b,
    selectAffixPadding: s
  };
}, WZ = (e, t) => {
  const {
    componentCls: n,
    antCls: r,
    controlOutlineWidth: i
  } = e;
  return {
    [`&:not(${n}-customize-input) ${n}-selector`]: {
      border: `${et(e.lineWidth)} ${e.lineType} ${t.borderColor}`,
      background: e.selectorBg
    },
    [`&:not(${n}-disabled):not(${n}-customize-input):not(${r}-pagination-size-changer)`]: {
      [`&:hover ${n}-selector`]: {
        borderColor: t.hoverBorderHover
      },
      [`${n}-focused& ${n}-selector`]: {
        borderColor: t.activeBorderColor,
        boxShadow: `0 0 0 ${et(i)} ${t.activeOutlineColor}`,
        outline: 0
      }
    }
  };
}, OF = (e, t) => ({
  [`&${e.componentCls}-status-${t.status}`]: Object.assign({}, WZ(e, t))
}), oLe = (e) => ({
  "&-outlined": Object.assign(Object.assign(Object.assign(Object.assign({}, WZ(e, {
    borderColor: e.colorBorder,
    hoverBorderHover: e.hoverBorderColor,
    activeBorderColor: e.activeBorderColor,
    activeOutlineColor: e.activeOutlineColor
  })), OF(e, {
    status: "error",
    borderColor: e.colorError,
    hoverBorderHover: e.colorErrorHover,
    activeBorderColor: e.colorError,
    activeOutlineColor: e.colorErrorOutline
  })), OF(e, {
    status: "warning",
    borderColor: e.colorWarning,
    hoverBorderHover: e.colorWarningHover,
    activeBorderColor: e.colorWarning,
    activeOutlineColor: e.colorWarningOutline
  })), {
    [`&${e.componentCls}-disabled`]: {
      [`&:not(${e.componentCls}-customize-input) ${e.componentCls}-selector`]: {
        background: e.colorBgContainerDisabled,
        color: e.colorTextDisabled
      }
    },
    [`&${e.componentCls}-multiple ${e.componentCls}-selection-item`]: {
      background: e.multipleItemBg,
      border: `${et(e.lineWidth)} ${e.lineType} ${e.multipleItemBorderColor}`
    }
  })
}), qZ = (e, t) => {
  const {
    componentCls: n,
    antCls: r
  } = e;
  return {
    [`&:not(${n}-customize-input) ${n}-selector`]: {
      background: t.bg,
      border: `${et(e.lineWidth)} ${e.lineType} transparent`,
      color: t.color
    },
    [`&:not(${n}-disabled):not(${n}-customize-input):not(${r}-pagination-size-changer)`]: {
      [`&:hover ${n}-selector`]: {
        background: t.hoverBg
      },
      [`${n}-focused& ${n}-selector`]: {
        background: e.selectorBg,
        borderColor: t.activeBorderColor,
        outline: 0
      }
    }
  };
}, MF = (e, t) => ({
  [`&${e.componentCls}-status-${t.status}`]: Object.assign({}, qZ(e, t))
}), aLe = (e) => ({
  "&-filled": Object.assign(Object.assign(Object.assign(Object.assign({}, qZ(e, {
    bg: e.colorFillTertiary,
    hoverBg: e.colorFillSecondary,
    activeBorderColor: e.activeBorderColor,
    color: e.colorText
  })), MF(e, {
    status: "error",
    bg: e.colorErrorBg,
    hoverBg: e.colorErrorBgHover,
    activeBorderColor: e.colorError,
    color: e.colorError
  })), MF(e, {
    status: "warning",
    bg: e.colorWarningBg,
    hoverBg: e.colorWarningBgHover,
    activeBorderColor: e.colorWarning,
    color: e.colorWarning
  })), {
    [`&${e.componentCls}-disabled`]: {
      [`&:not(${e.componentCls}-customize-input) ${e.componentCls}-selector`]: {
        borderColor: e.colorBorder,
        background: e.colorBgContainerDisabled,
        color: e.colorTextDisabled
      }
    },
    [`&${e.componentCls}-multiple ${e.componentCls}-selection-item`]: {
      background: e.colorBgContainer,
      border: `${et(e.lineWidth)} ${e.lineType} ${e.colorSplit}`
    }
  })
}), sLe = (e) => ({
  "&-borderless": {
    [`${e.componentCls}-selector`]: {
      background: "transparent",
      borderColor: "transparent"
    },
    [`&${e.componentCls}-disabled`]: {
      [`&:not(${e.componentCls}-customize-input) ${e.componentCls}-selector`]: {
        color: e.colorTextDisabled
      }
    },
    [`&${e.componentCls}-multiple ${e.componentCls}-selection-item`]: {
      background: e.multipleItemBg,
      border: `${et(e.lineWidth)} ${e.lineType} ${e.multipleItemBorderColor}`
    },
    // Status
    [`&${e.componentCls}-status-error`]: {
      [`${e.componentCls}-selection-item`]: {
        color: e.colorError
      }
    },
    [`&${e.componentCls}-status-warning`]: {
      [`${e.componentCls}-selection-item`]: {
        color: e.colorWarning
      }
    }
  }
}), cLe = (e) => ({
  [e.componentCls]: Object.assign(Object.assign(Object.assign({}, oLe(e)), aLe(e)), sLe(e))
}), lLe = cLe, uLe = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    position: "relative",
    transition: `all ${e.motionDurationMid} ${e.motionEaseInOut}`,
    input: {
      cursor: "pointer"
    },
    [`${t}-show-search&`]: {
      cursor: "text",
      input: {
        cursor: "auto",
        color: "inherit",
        height: "100%"
      }
    },
    [`${t}-disabled&`]: {
      cursor: "not-allowed",
      input: {
        cursor: "not-allowed"
      }
    }
  };
}, dLe = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}-selection-search-input`]: {
      margin: 0,
      padding: 0,
      background: "transparent",
      border: "none",
      outline: "none",
      appearance: "none",
      fontFamily: "inherit",
      "&::-webkit-search-cancel-button": {
        display: "none",
        "-webkit-appearance": "none"
      }
    }
  };
}, fLe = (e) => {
  const {
    antCls: t,
    componentCls: n,
    inputPaddingHorizontalBase: r,
    iconCls: i
  } = e;
  return {
    [n]: Object.assign(Object.assign({}, _a(e)), {
      position: "relative",
      display: "inline-flex",
      cursor: "pointer",
      [`&:not(${n}-customize-input) ${n}-selector`]: Object.assign(Object.assign({}, uLe(e)), dLe(e)),
      // ======================== Selection ========================
      [`${n}-selection-item`]: Object.assign(Object.assign({
        flex: 1,
        fontWeight: "normal",
        position: "relative",
        userSelect: "none"
      }, JA), {
        // https://github.com/ant-design/ant-design/issues/40421
        [`> ${t}-typography`]: {
          display: "inline"
        }
      }),
      // ======================= Placeholder =======================
      [`${n}-selection-placeholder`]: Object.assign(Object.assign({}, JA), {
        flex: 1,
        color: e.colorTextPlaceholder,
        pointerEvents: "none"
      }),
      // ========================== Arrow ==========================
      [`${n}-arrow`]: Object.assign(Object.assign({}, LE()), {
        position: "absolute",
        top: "50%",
        insetInlineStart: "auto",
        insetInlineEnd: r,
        height: e.fontSizeIcon,
        marginTop: e.calc(e.fontSizeIcon).mul(-1).div(2).equal(),
        color: e.colorTextQuaternary,
        fontSize: e.fontSizeIcon,
        lineHeight: 1,
        textAlign: "center",
        pointerEvents: "none",
        display: "flex",
        alignItems: "center",
        transition: `opacity ${e.motionDurationSlow} ease`,
        [i]: {
          verticalAlign: "top",
          transition: `transform ${e.motionDurationSlow}`,
          "> svg": {
            verticalAlign: "top"
          },
          [`&:not(${n}-suffix)`]: {
            pointerEvents: "auto"
          }
        },
        [`${n}-disabled &`]: {
          cursor: "not-allowed"
        },
        "> *:not(:last-child)": {
          marginInlineEnd: 8
          // FIXME: magic
        }
      }),
      // ========================== Clear ==========================
      [`${n}-clear`]: {
        position: "absolute",
        top: "50%",
        insetInlineStart: "auto",
        insetInlineEnd: r,
        zIndex: 1,
        display: "inline-block",
        width: e.fontSizeIcon,
        height: e.fontSizeIcon,
        marginTop: e.calc(e.fontSizeIcon).mul(-1).div(2).equal(),
        color: e.colorTextQuaternary,
        fontSize: e.fontSizeIcon,
        fontStyle: "normal",
        lineHeight: 1,
        textAlign: "center",
        textTransform: "none",
        cursor: "pointer",
        opacity: 0,
        transition: `color ${e.motionDurationMid} ease, opacity ${e.motionDurationSlow} ease`,
        textRendering: "auto",
        "&:before": {
          display: "block"
        },
        "&:hover": {
          color: e.colorTextTertiary
        }
      },
      [`&:hover ${n}-clear`]: {
        opacity: 1,
        background: e.colorBgBase,
        borderRadius: "50%"
      }
    }),
    // ========================= Feedback ==========================
    [`${n}-has-feedback`]: {
      [`${n}-clear`]: {
        insetInlineEnd: e.calc(r).add(e.fontSize).add(e.paddingXS).equal()
      }
    }
  };
}, hLe = (e) => {
  const {
    componentCls: t
  } = e;
  return [
    {
      [t]: {
        // ==================== In Form ====================
        [`&${t}-in-form-item`]: {
          width: "100%"
        }
      }
    },
    // =====================================================
    // ==                       LTR                       ==
    // =====================================================
    // Base
    fLe(e),
    // Single
    rLe(e),
    // Multiple
    nLe(e),
    // Dropdown
    Xje(e),
    // =====================================================
    // ==                       RTL                       ==
    // =====================================================
    {
      [`${t}-rtl`]: {
        direction: "rtl"
      }
    },
    // =====================================================
    // ==             Space Compact                       ==
    // =====================================================
    qE(e, {
      borderElCls: `${t}-selector`,
      focusElCls: `${t}-focused`
    })
  ];
}, gLe = Za("Select", (e, t) => {
  let {
    rootPrefixCls: n
  } = t;
  const r = Mr(e, {
    rootPrefixCls: n,
    inputPaddingHorizontalBase: e.calc(e.paddingSM).sub(1).equal(),
    multipleSelectItemHeight: e.multipleItemHeight,
    selectHeight: e.controlHeight
  });
  return [hLe(r), lLe(r)];
}, iLe, {
  unitless: {
    optionLineHeight: !0,
    optionSelectedFontWeight: !0
  }
});
var pLe = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 00-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z" } }] }, name: "check", theme: "outlined" };
const mLe = pLe;
var vLe = function(t, n) {
  return /* @__PURE__ */ $.createElement(mo, xt({}, t, {
    ref: n,
    icon: mLe
  }));
}, GZ = /* @__PURE__ */ $.forwardRef(vLe);
process.env.NODE_ENV !== "production" && (GZ.displayName = "CheckOutlined");
const yLe = GZ;
var bLe = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z" } }] }, name: "down", theme: "outlined" };
const _Le = bLe;
var SLe = function(t, n) {
  return /* @__PURE__ */ $.createElement(mo, xt({}, t, {
    ref: n,
    icon: _Le
  }));
}, KZ = /* @__PURE__ */ $.forwardRef(SLe);
process.env.NODE_ENV !== "production" && (KZ.displayName = "DownOutlined");
const GM = KZ;
var wLe = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0011.6 0l43.6-43.5a8.2 8.2 0 000-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z" } }] }, name: "search", theme: "outlined" };
const xLe = wLe;
var ELe = function(t, n) {
  return /* @__PURE__ */ $.createElement(mo, xt({}, t, {
    ref: n,
    icon: xLe
  }));
}, YZ = /* @__PURE__ */ $.forwardRef(ELe);
process.env.NODE_ENV !== "production" && (YZ.displayName = "SearchOutlined");
const XZ = YZ;
function CLe(e) {
  let {
    suffixIcon: t,
    clearIcon: n,
    menuItemSelectedIcon: r,
    removeIcon: i,
    loading: o,
    multiple: a,
    hasFeedback: s,
    prefixCls: c,
    showSuffixIcon: l,
    feedbackIcon: u,
    showArrow: d,
    componentName: f
  } = e;
  process.env.NODE_ENV !== "production" && di(f).deprecated(!n, "clearIcon", "allowClear={{ clearIcon: React.ReactNode }}");
  const h = n ?? /* @__PURE__ */ $.createElement(BE, null), p = (y) => t === null && !s && !d ? null : /* @__PURE__ */ $.createElement($.Fragment, null, l !== !1 && y, s && u);
  let g = null;
  if (t !== void 0)
    g = p(t);
  else if (o)
    g = p(/* @__PURE__ */ $.createElement(TM, {
      spin: !0
    }));
  else {
    const y = `${c}-suffix`;
    g = (_) => {
      let {
        open: b,
        showSearch: w
      } = _;
      return p(b && w ? /* @__PURE__ */ $.createElement(XZ, {
        className: y
      }) : /* @__PURE__ */ $.createElement(GM, {
        className: y
      }));
    };
  }
  let m = null;
  r !== void 0 ? m = r : a ? m = /* @__PURE__ */ $.createElement(yLe, null) : m = null;
  let v = null;
  return i !== void 0 ? v = i : v = /* @__PURE__ */ $.createElement(zE, null), {
    clearIcon: h,
    suffixIcon: g,
    itemIcon: m,
    removeIcon: v
  };
}
function TLe(e, t) {
  return t !== void 0 ? t : e !== null;
}
var ILe = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
const QZ = "SECRET_COMBOBOX_MODE_DO_NOT_USE", JZ = (e, t) => {
  var n;
  const {
    prefixCls: r,
    bordered: i,
    className: o,
    rootClassName: a,
    getPopupContainer: s,
    popupClassName: c,
    dropdownClassName: l,
    listHeight: u = 256,
    placement: d,
    listItemHeight: f,
    size: h,
    disabled: p,
    notFoundContent: g,
    status: m,
    builtinPlacements: v,
    dropdownMatchSelectWidth: y,
    popupMatchSelectWidth: _,
    direction: b,
    style: w,
    allowClear: C,
    variant: x,
    dropdownStyle: T,
    transitionName: E,
    tagRender: R,
    maxCount: I,
    prefix: O
  } = e, P = ILe(e, ["prefixCls", "bordered", "className", "rootClassName", "getPopupContainer", "popupClassName", "dropdownClassName", "listHeight", "placement", "listItemHeight", "size", "disabled", "notFoundContent", "status", "builtinPlacements", "dropdownMatchSelectWidth", "popupMatchSelectWidth", "direction", "style", "allowClear", "variant", "dropdownStyle", "transitionName", "tagRender", "maxCount", "prefix"]), {
    getPopupContainer: k,
    getPrefixCls: L,
    renderEmpty: N,
    direction: D,
    virtual: z,
    popupMatchSelectWidth: V,
    popupOverflow: B,
    select: U
  } = $.useContext(Cn), [, Q] = js(), Y = f ?? (Q == null ? void 0 : Q.controlHeight), q = L("select", r), X = L(), ne = b ?? D, {
    compactSize: Z,
    compactItemClassnames: J
  } = Ry(q, ne), [K, ee] = JE("select", x, i), te = Wf(q), [H, ie, W] = gLe(q, te), se = $.useMemo(() => {
    const {
      mode: St
    } = e;
    if (St !== "combobox")
      return St === QZ ? "combobox" : St;
  }, [e.mode]), le = se === "multiple" || se === "tags", ge = TLe(e.suffixIcon, e.showArrow), me = (n = _ ?? y) !== null && n !== void 0 ? n : V, {
    status: pe,
    hasFeedback: Te,
    isFormItemInput: de,
    feedbackIcon: Ae
  } = $.useContext(As), ue = ky(pe, m);
  let be;
  g !== void 0 ? be = g : se === "combobox" ? be = null : be = (N == null ? void 0 : N("Select")) || /* @__PURE__ */ $.createElement(Wje, {
    componentName: "Select"
  });
  const {
    suffixIcon: Ie,
    itemIcon: Ve,
    removeIcon: ze,
    clearIcon: Ne
  } = CLe(Object.assign(Object.assign({}, P), {
    multiple: le,
    hasFeedback: Te,
    feedbackIcon: Ae,
    showSuffixIcon: ge,
    prefixCls: q,
    componentName: "Select"
  })), lt = C === !0 ? {
    clearIcon: Ne
  } : C, mt = rd(P, ["suffixIcon", "itemIcon"]), vt = Ee(c || l, {
    [`${q}-dropdown-${ne}`]: ne === "rtl"
  }, a, W, te, ie), ke = Gf((St) => {
    var ft;
    return (ft = h ?? Z) !== null && ft !== void 0 ? ft : St;
  }), xe = $.useContext(id), Re = p ?? xe, yt = Ee({
    [`${q}-lg`]: ke === "large",
    [`${q}-sm`]: ke === "small",
    [`${q}-rtl`]: ne === "rtl",
    [`${q}-${K}`]: ee,
    [`${q}-in-form-item`]: de
  }, ep(q, ue, Te), J, U == null ? void 0 : U.className, o, a, W, te, ie), Pt = $.useMemo(() => d !== void 0 ? d : ne === "rtl" ? "bottomRight" : "bottomLeft", [d, ne]);
  if (process.env.NODE_ENV !== "production") {
    const St = di("Select");
    St.deprecated(!l, "dropdownClassName", "popupClassName"), St.deprecated(y === void 0, "dropdownMatchSelectWidth", "popupMatchSelectWidth"), process.env.NODE_ENV !== "production" && St(!("showArrow" in e), "deprecated", "`showArrow` is deprecated which will be removed in next major version. It will be a default behavior, you can hide it by setting `suffixIcon` to null."), St.deprecated(!("bordered" in e), "bordered", "variant"), process.env.NODE_ENV !== "production" && St(!(typeof I < "u" && !le), "usage", "`maxCount` only works with mode `multiple` or `tags`");
  }
  const [_t] = BJ("SelectLike", T == null ? void 0 : T.zIndex);
  return H(/* @__PURE__ */ $.createElement(qM, Object.assign({
    ref: t,
    virtual: z,
    showSearch: U == null ? void 0 : U.showSearch
  }, mt, {
    style: Object.assign(Object.assign({}, U == null ? void 0 : U.style), w),
    dropdownMatchSelectWidth: me,
    transitionName: qJ(X, "slide-up", E),
    builtinPlacements: Kje(v, B),
    listHeight: u,
    listItemHeight: Y,
    mode: se,
    prefixCls: q,
    placement: Pt,
    direction: ne,
    prefix: O,
    suffixIcon: Ie,
    menuItemSelectedIcon: Ve,
    removeIcon: ze,
    allowClear: lt,
    notFoundContent: be,
    className: yt,
    getPopupContainer: s || k,
    dropdownClassName: vt,
    disabled: Re,
    dropdownStyle: Object.assign(Object.assign({}, T), {
      zIndex: _t
    }),
    maxCount: le ? I : void 0,
    tagRender: le ? R : void 0
  })));
};
process.env.NODE_ENV !== "production" && (JZ.displayName = "Select");
const Yf = /* @__PURE__ */ $.forwardRef(JZ), $Le = m8e(Yf);
Yf.SECRET_COMBOBOX_MODE_DO_NOT_USE = QZ;
Yf.Option = UM;
Yf.OptGroup = HM;
Yf._InternalPanelDoNotUseOrYouWillBeFired = $Le;
process.env.NODE_ENV !== "production" && (Yf.displayName = "Select");
const ALe = Yf;
function ZZ(e) {
  var t = e.children, n = e.prefixCls, r = e.id, i = e.overlayInnerStyle, o = e.className, a = e.style;
  return /* @__PURE__ */ $.createElement("div", {
    className: Ee("".concat(n, "-content"), o),
    style: a
  }, /* @__PURE__ */ $.createElement("div", {
    className: "".concat(n, "-inner"),
    id: r,
    role: "tooltip",
    style: i
  }, typeof t == "function" ? t() : t));
}
var xh = {
  shiftX: 64,
  adjustY: 1
}, Eh = {
  adjustX: 1,
  shiftY: !0
}, Pa = [0, 0], RLe = {
  left: {
    points: ["cr", "cl"],
    overflow: Eh,
    offset: [-4, 0],
    targetOffset: Pa
  },
  right: {
    points: ["cl", "cr"],
    overflow: Eh,
    offset: [4, 0],
    targetOffset: Pa
  },
  top: {
    points: ["bc", "tc"],
    overflow: xh,
    offset: [0, -4],
    targetOffset: Pa
  },
  bottom: {
    points: ["tc", "bc"],
    overflow: xh,
    offset: [0, 4],
    targetOffset: Pa
  },
  topLeft: {
    points: ["bl", "tl"],
    overflow: xh,
    offset: [0, -4],
    targetOffset: Pa
  },
  leftTop: {
    points: ["tr", "tl"],
    overflow: Eh,
    offset: [-4, 0],
    targetOffset: Pa
  },
  topRight: {
    points: ["br", "tr"],
    overflow: xh,
    offset: [0, -4],
    targetOffset: Pa
  },
  rightTop: {
    points: ["tl", "tr"],
    overflow: Eh,
    offset: [4, 0],
    targetOffset: Pa
  },
  bottomRight: {
    points: ["tr", "br"],
    overflow: xh,
    offset: [0, 4],
    targetOffset: Pa
  },
  rightBottom: {
    points: ["bl", "br"],
    overflow: Eh,
    offset: [4, 0],
    targetOffset: Pa
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: xh,
    offset: [0, 4],
    targetOffset: Pa
  },
  leftBottom: {
    points: ["br", "bl"],
    overflow: Eh,
    offset: [-4, 0],
    targetOffset: Pa
  }
}, PLe = ["overlayClassName", "trigger", "mouseEnterDelay", "mouseLeaveDelay", "overlayStyle", "prefixCls", "children", "onVisibleChange", "afterVisibleChange", "transitionName", "animation", "motion", "placement", "align", "destroyTooltipOnHide", "defaultVisible", "getTooltipContainer", "overlayInnerStyle", "arrowContent", "overlay", "id", "showArrow"], OLe = function(t, n) {
  var r = t.overlayClassName, i = t.trigger, o = i === void 0 ? ["hover"] : i, a = t.mouseEnterDelay, s = a === void 0 ? 0 : a, c = t.mouseLeaveDelay, l = c === void 0 ? 0.1 : c, u = t.overlayStyle, d = t.prefixCls, f = d === void 0 ? "rc-tooltip" : d, h = t.children, p = t.onVisibleChange, g = t.afterVisibleChange, m = t.transitionName, v = t.animation, y = t.motion, _ = t.placement, b = _ === void 0 ? "right" : _, w = t.align, C = w === void 0 ? {} : w, x = t.destroyTooltipOnHide, T = x === void 0 ? !1 : x, E = t.defaultVisible, R = t.getTooltipContainer, I = t.overlayInnerStyle;
  t.arrowContent;
  var O = t.overlay, P = t.id, k = t.showArrow, L = k === void 0 ? !0 : k, N = En(t, PLe), D = $e(null);
  eO(n, function() {
    return D.current;
  });
  var z = ae({}, N);
  "visible" in t && (z.popupVisible = t.visible);
  var V = function() {
    return /* @__PURE__ */ $.createElement(ZZ, {
      key: "content",
      prefixCls: f,
      id: P,
      overlayInnerStyle: I
    }, O);
  };
  return /* @__PURE__ */ $.createElement(OZ, xt({
    popupClassName: r,
    prefixCls: f,
    popup: V,
    action: o,
    builtinPlacements: RLe,
    popupPlacement: b,
    ref: D,
    popupAlign: C,
    getPopupContainer: R,
    onPopupVisibleChange: p,
    afterPopupVisibleChange: g,
    popupTransitionName: m,
    popupAnimation: v,
    popupMotion: y,
    defaultPopupVisible: E,
    autoDestroy: T,
    mouseLeaveDelay: l,
    popupStyle: u,
    mouseEnterDelay: s,
    arrow: L
  }, z), h);
};
const MLe = /* @__PURE__ */ ia(OLe);
function kLe(e) {
  const {
    sizePopupArrow: t,
    borderRadiusXS: n,
    borderRadiusOuter: r
  } = e, i = t / 2, o = 0, a = i, s = r * 1 / Math.sqrt(2), c = i - r * (1 - 1 / Math.sqrt(2)), l = i - n * (1 / Math.sqrt(2)), u = r * (Math.sqrt(2) - 1) + n * (1 / Math.sqrt(2)), d = 2 * i - l, f = u, h = 2 * i - s, p = c, g = 2 * i - o, m = a, v = i * Math.sqrt(2) + r * (Math.sqrt(2) - 2), y = r * (Math.sqrt(2) - 1), _ = `polygon(${y}px 100%, 50% ${y}px, ${2 * i - y}px 100%, ${y}px 100%)`, b = `path('M ${o} ${a} A ${r} ${r} 0 0 0 ${s} ${c} L ${l} ${u} A ${n} ${n} 0 0 1 ${d} ${f} L ${h} ${p} A ${r} ${r} 0 0 0 ${g} ${m} Z')`;
  return {
    arrowShadowWidth: v,
    arrowPath: b,
    arrowPolygon: _
  };
}
const NLe = (e, t, n) => {
  const {
    sizePopupArrow: r,
    arrowPolygon: i,
    arrowPath: o,
    arrowShadowWidth: a,
    borderRadiusXS: s,
    calc: c
  } = e;
  return {
    pointerEvents: "none",
    width: r,
    height: r,
    overflow: "hidden",
    "&::before": {
      position: "absolute",
      bottom: 0,
      insetInlineStart: 0,
      width: r,
      height: c(r).div(2).equal(),
      background: t,
      clipPath: {
        _multi_value_: !0,
        value: [i, o]
      },
      content: '""'
    },
    "&::after": {
      content: '""',
      position: "absolute",
      width: a,
      height: a,
      bottom: 0,
      insetInline: 0,
      margin: "auto",
      borderRadius: {
        _skip_check_: !0,
        value: `0 0 ${et(s)} 0`
      },
      transform: "translateY(50%) rotate(-135deg)",
      boxShadow: n,
      zIndex: 0,
      background: "transparent"
    }
  };
}, eee = 8;
function tee(e) {
  const {
    contentRadius: t,
    limitVerticalRadius: n
  } = e, r = t > 12 ? t + 2 : 12;
  return {
    arrowOffsetHorizontal: r,
    arrowOffsetVertical: n ? eee : r
  };
}
function v1(e, t) {
  return e ? t : {};
}
function DLe(e, t, n) {
  const {
    componentCls: r,
    boxShadowPopoverArrow: i,
    arrowOffsetVertical: o,
    arrowOffsetHorizontal: a
  } = e, {
    arrowDistance: s = 0,
    arrowPlacement: c = {
      left: !0,
      right: !0,
      top: !0,
      bottom: !0
    }
  } = n || {};
  return {
    [r]: Object.assign(Object.assign(Object.assign(Object.assign({
      // ============================ Basic ============================
      [`${r}-arrow`]: [Object.assign(Object.assign({
        position: "absolute",
        zIndex: 1,
        display: "block"
      }, NLe(e, t, i)), {
        "&:before": {
          background: t
        }
      })]
    }, v1(!!c.top, {
      [[`&-placement-top > ${r}-arrow`, `&-placement-topLeft > ${r}-arrow`, `&-placement-topRight > ${r}-arrow`].join(",")]: {
        bottom: s,
        transform: "translateY(100%) rotate(180deg)"
      },
      [`&-placement-top > ${r}-arrow`]: {
        left: {
          _skip_check_: !0,
          value: "50%"
        },
        transform: "translateX(-50%) translateY(100%) rotate(180deg)"
      },
      "&-placement-topLeft": {
        "--arrow-offset-horizontal": a,
        [`> ${r}-arrow`]: {
          left: {
            _skip_check_: !0,
            value: a
          }
        }
      },
      "&-placement-topRight": {
        "--arrow-offset-horizontal": `calc(100% - ${et(a)})`,
        [`> ${r}-arrow`]: {
          right: {
            _skip_check_: !0,
            value: a
          }
        }
      }
    })), v1(!!c.bottom, {
      [[`&-placement-bottom > ${r}-arrow`, `&-placement-bottomLeft > ${r}-arrow`, `&-placement-bottomRight > ${r}-arrow`].join(",")]: {
        top: s,
        transform: "translateY(-100%)"
      },
      [`&-placement-bottom > ${r}-arrow`]: {
        left: {
          _skip_check_: !0,
          value: "50%"
        },
        transform: "translateX(-50%) translateY(-100%)"
      },
      "&-placement-bottomLeft": {
        "--arrow-offset-horizontal": a,
        [`> ${r}-arrow`]: {
          left: {
            _skip_check_: !0,
            value: a
          }
        }
      },
      "&-placement-bottomRight": {
        "--arrow-offset-horizontal": `calc(100% - ${et(a)})`,
        [`> ${r}-arrow`]: {
          right: {
            _skip_check_: !0,
            value: a
          }
        }
      }
    })), v1(!!c.left, {
      [[`&-placement-left > ${r}-arrow`, `&-placement-leftTop > ${r}-arrow`, `&-placement-leftBottom > ${r}-arrow`].join(",")]: {
        right: {
          _skip_check_: !0,
          value: s
        },
        transform: "translateX(100%) rotate(90deg)"
      },
      [`&-placement-left > ${r}-arrow`]: {
        top: {
          _skip_check_: !0,
          value: "50%"
        },
        transform: "translateY(-50%) translateX(100%) rotate(90deg)"
      },
      [`&-placement-leftTop > ${r}-arrow`]: {
        top: o
      },
      [`&-placement-leftBottom > ${r}-arrow`]: {
        bottom: o
      }
    })), v1(!!c.right, {
      [[`&-placement-right > ${r}-arrow`, `&-placement-rightTop > ${r}-arrow`, `&-placement-rightBottom > ${r}-arrow`].join(",")]: {
        left: {
          _skip_check_: !0,
          value: s
        },
        transform: "translateX(-100%) rotate(-90deg)"
      },
      [`&-placement-right > ${r}-arrow`]: {
        top: {
          _skip_check_: !0,
          value: "50%"
        },
        transform: "translateY(-50%) translateX(-100%) rotate(-90deg)"
      },
      [`&-placement-rightTop > ${r}-arrow`]: {
        top: o
      },
      [`&-placement-rightBottom > ${r}-arrow`]: {
        bottom: o
      }
    }))
  };
}
function jLe(e, t, n, r) {
  if (r === !1)
    return {
      adjustX: !1,
      adjustY: !1
    };
  const i = r && typeof r == "object" ? r : {}, o = {};
  switch (e) {
    case "top":
    case "bottom":
      o.shiftX = t.arrowOffsetHorizontal * 2 + n, o.shiftY = !0, o.adjustY = !0;
      break;
    case "left":
    case "right":
      o.shiftY = t.arrowOffsetVertical * 2 + n, o.shiftX = !0, o.adjustX = !0;
      break;
  }
  const a = Object.assign(Object.assign({}, o), i);
  return a.shiftX || (a.adjustX = !0), a.shiftY || (a.adjustY = !0), a;
}
const kF = {
  left: {
    points: ["cr", "cl"]
  },
  right: {
    points: ["cl", "cr"]
  },
  top: {
    points: ["bc", "tc"]
  },
  bottom: {
    points: ["tc", "bc"]
  },
  topLeft: {
    points: ["bl", "tl"]
  },
  leftTop: {
    points: ["tr", "tl"]
  },
  topRight: {
    points: ["br", "tr"]
  },
  rightTop: {
    points: ["tl", "tr"]
  },
  bottomRight: {
    points: ["tr", "br"]
  },
  rightBottom: {
    points: ["bl", "br"]
  },
  bottomLeft: {
    points: ["tl", "bl"]
  },
  leftBottom: {
    points: ["br", "bl"]
  }
}, LLe = {
  topLeft: {
    points: ["bl", "tc"]
  },
  leftTop: {
    points: ["tr", "cl"]
  },
  topRight: {
    points: ["br", "tc"]
  },
  rightTop: {
    points: ["tl", "cr"]
  },
  bottomRight: {
    points: ["tr", "bc"]
  },
  rightBottom: {
    points: ["bl", "cr"]
  },
  bottomLeft: {
    points: ["tl", "bc"]
  },
  leftBottom: {
    points: ["br", "cl"]
  }
}, FLe = /* @__PURE__ */ new Set(["topLeft", "topRight", "bottomLeft", "bottomRight", "leftTop", "leftBottom", "rightTop", "rightBottom"]);
function VLe(e) {
  const {
    arrowWidth: t,
    autoAdjustOverflow: n,
    arrowPointAtCenter: r,
    offset: i,
    borderRadius: o,
    visibleFirst: a
  } = e, s = t / 2, c = {};
  return Object.keys(kF).forEach((l) => {
    const u = r && LLe[l] || kF[l], d = Object.assign(Object.assign({}, u), {
      offset: [0, 0],
      dynamicInset: !0
    });
    switch (c[l] = d, FLe.has(l) && (d.autoArrow = !1), l) {
      case "top":
      case "topLeft":
      case "topRight":
        d.offset[1] = -s - i;
        break;
      case "bottom":
      case "bottomLeft":
      case "bottomRight":
        d.offset[1] = s + i;
        break;
      case "left":
      case "leftTop":
      case "leftBottom":
        d.offset[0] = -s - i;
        break;
      case "right":
      case "rightTop":
      case "rightBottom":
        d.offset[0] = s + i;
        break;
    }
    const f = tee({
      contentRadius: o,
      limitVerticalRadius: !0
    });
    if (r)
      switch (l) {
        case "topLeft":
        case "bottomLeft":
          d.offset[0] = -f.arrowOffsetHorizontal - s;
          break;
        case "topRight":
        case "bottomRight":
          d.offset[0] = f.arrowOffsetHorizontal + s;
          break;
        case "leftTop":
        case "rightTop":
          d.offset[1] = -f.arrowOffsetHorizontal * 2 + s;
          break;
        case "leftBottom":
        case "rightBottom":
          d.offset[1] = f.arrowOffsetHorizontal * 2 - s;
          break;
      }
    d.overflow = jLe(l, f, t, n), a && (d.htmlRegion = "visibleFirst");
  }), c;
}
const BLe = (e) => {
  const {
    componentCls: t,
    // ant-tooltip
    tooltipMaxWidth: n,
    tooltipColor: r,
    tooltipBg: i,
    tooltipBorderRadius: o,
    zIndexPopup: a,
    controlHeight: s,
    boxShadowSecondary: c,
    paddingSM: l,
    paddingXS: u
  } = e;
  return [
    {
      [t]: Object.assign(Object.assign(Object.assign(Object.assign({}, _a(e)), {
        position: "absolute",
        zIndex: a,
        display: "block",
        width: "max-content",
        maxWidth: n,
        visibility: "visible",
        // When use `autoArrow`, origin will follow the arrow position
        "--valid-offset-x": "var(--arrow-offset-horizontal, var(--arrow-x))",
        transformOrigin: ["var(--valid-offset-x, 50%)", "var(--arrow-y, 50%)"].join(" "),
        "&-hidden": {
          display: "none"
        },
        "--antd-arrow-background-color": i,
        // Wrapper for the tooltip content
        [`${t}-inner`]: {
          minWidth: "1em",
          minHeight: s,
          padding: `${et(e.calc(l).div(2).equal())} ${et(u)}`,
          color: r,
          textAlign: "start",
          textDecoration: "none",
          wordWrap: "break-word",
          backgroundColor: i,
          borderRadius: o,
          boxShadow: c,
          boxSizing: "border-box"
        },
        // Limit left and right placement radius
        [["&-placement-left", "&-placement-leftTop", "&-placement-leftBottom", "&-placement-right", "&-placement-rightTop", "&-placement-rightBottom"].join(",")]: {
          [`${t}-inner`]: {
            borderRadius: e.min(o, eee)
          }
        },
        [`${t}-content`]: {
          position: "relative"
        }
      }), D3e(e, (d, f) => {
        let {
          darkColor: h
        } = f;
        return {
          [`&${t}-${d}`]: {
            [`${t}-inner`]: {
              backgroundColor: h
            },
            [`${t}-arrow`]: {
              "--antd-arrow-background-color": h
            }
          }
        };
      })), {
        // RTL
        "&-rtl": {
          direction: "rtl"
        }
      })
    },
    // Arrow Style
    DLe(e, "var(--antd-arrow-background-color)"),
    // Pure Render
    {
      [`${t}-pure`]: {
        position: "relative",
        maxWidth: "none",
        margin: e.sizePopupArrow
      }
    }
  ];
}, zLe = (e) => Object.assign(Object.assign({
  zIndexPopup: e.zIndexPopupBase + 70
}, tee({
  contentRadius: e.borderRadius,
  limitVerticalRadius: !0
})), kLe(Mr(e, {
  borderRadiusOuter: Math.min(e.borderRadiusOuter, 4)
}))), nee = function(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
  return Za("Tooltip", (r) => {
    const {
      borderRadius: i,
      colorTextLightSolid: o,
      colorBgSpotlight: a
    } = r, s = Mr(r, {
      // default variables
      tooltipMaxWidth: 250,
      tooltipColor: o,
      tooltipBorderRadius: i,
      tooltipBg: a
    });
    return [BLe(s), o7e(r, "zoom-big-fast")];
  }, zLe, {
    resetStyle: !1,
    // Popover use Tooltip as internal component. We do not need to handle this.
    injectStyle: t
  })(e);
}, HLe = sw.map((e) => `${e}-inverse`);
function ULe(e) {
  return (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0) ? [].concat(tt(HLe), tt(sw)).includes(e) : sw.includes(e);
}
function ree(e, t) {
  const n = ULe(t), r = Ee({
    [`${e}-${t}`]: t && n
  }), i = {}, o = {};
  return t && !n && (i.background = t, o["--antd-arrow-background-color"] = t), {
    className: r,
    overlayStyle: i,
    arrowStyle: o
  };
}
const WLe = (e) => {
  const {
    prefixCls: t,
    className: n,
    placement: r = "top",
    title: i,
    color: o,
    overlayInnerStyle: a
  } = e, {
    getPrefixCls: s
  } = $.useContext(Cn), c = s("tooltip", t), [l, u, d] = nee(c), f = ree(c, o), h = f.arrowStyle, p = Object.assign(Object.assign({}, a), f.overlayStyle), g = Ee(u, d, c, `${c}-pure`, `${c}-placement-${r}`, n, f.className);
  return l(/* @__PURE__ */ $.createElement("div", {
    className: g,
    style: h
  }, /* @__PURE__ */ $.createElement("div", {
    className: `${c}-arrow`
  }), /* @__PURE__ */ $.createElement(ZZ, Object.assign({}, e, {
    className: u,
    prefixCls: c,
    overlayInnerStyle: p
  }), i)));
}, qLe = WLe;
var GLe = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
const KLe = /* @__PURE__ */ $.forwardRef((e, t) => {
  var n, r;
  const {
    prefixCls: i,
    openClassName: o,
    getTooltipContainer: a,
    overlayClassName: s,
    color: c,
    overlayInnerStyle: l,
    children: u,
    afterOpenChange: d,
    afterVisibleChange: f,
    destroyTooltipOnHide: h,
    arrow: p = !0,
    title: g,
    overlay: m,
    builtinPlacements: v,
    arrowPointAtCenter: y = !1,
    autoAdjustOverflow: _ = !0
  } = e, b = !!p, [, w] = js(), {
    getPopupContainer: C,
    getPrefixCls: x,
    direction: T
  } = $.useContext(Cn), E = di("Tooltip"), R = $.useRef(null), I = () => {
    var ue;
    (ue = R.current) === null || ue === void 0 || ue.forceAlign();
  };
  $.useImperativeHandle(t, () => {
    var ue;
    return {
      forceAlign: I,
      forcePopupAlign: () => {
        E.deprecated(!1, "forcePopupAlign", "forceAlign"), I();
      },
      nativeElement: (ue = R.current) === null || ue === void 0 ? void 0 : ue.nativeElement
    };
  }), process.env.NODE_ENV !== "production" && ([["visible", "open"], ["defaultVisible", "defaultOpen"], ["onVisibleChange", "onOpenChange"], ["afterVisibleChange", "afterOpenChange"], ["arrowPointAtCenter", "arrow={{ pointAtCenter: true }}"]].forEach((ue) => {
    let [be, Ie] = ue;
    E.deprecated(!(be in e), be, Ie);
  }), process.env.NODE_ENV !== "production" && E(!h || typeof h == "boolean", "usage", "`destroyTooltipOnHide` no need config `keepParent` anymore. Please use `boolean` value directly."), process.env.NODE_ENV !== "production" && E(!p || typeof p == "boolean" || !("arrowPointAtCenter" in p), "deprecated", "`arrowPointAtCenter` in `arrow` is deprecated. Please use `pointAtCenter` instead."));
  const [O, P] = wc(!1, {
    value: (n = e.open) !== null && n !== void 0 ? n : e.visible,
    defaultValue: (r = e.defaultOpen) !== null && r !== void 0 ? r : e.defaultVisible
  }), k = !g && !m && g !== 0, L = (ue) => {
    var be, Ie;
    P(k ? !1 : ue), k || ((be = e.onOpenChange) === null || be === void 0 || be.call(e, ue), (Ie = e.onVisibleChange) === null || Ie === void 0 || Ie.call(e, ue));
  }, N = $.useMemo(() => {
    var ue, be;
    let Ie = y;
    return typeof p == "object" && (Ie = (be = (ue = p.pointAtCenter) !== null && ue !== void 0 ? ue : p.arrowPointAtCenter) !== null && be !== void 0 ? be : y), v || VLe({
      arrowPointAtCenter: Ie,
      autoAdjustOverflow: _,
      arrowWidth: b ? w.sizePopupArrow : 0,
      borderRadius: w.borderRadius,
      offset: w.marginXXS,
      visibleFirst: !0
    });
  }, [y, p, v, w]), D = $.useMemo(() => g === 0 ? g : m || g || "", [m, g]), z = /* @__PURE__ */ $.createElement(Pv, {
    space: !0
  }, typeof D == "function" ? D() : D), {
    getPopupContainer: V,
    placement: B = "top",
    mouseEnterDelay: U = 0.1,
    mouseLeaveDelay: Q = 0.1,
    overlayStyle: Y,
    rootClassName: q
  } = e, X = GLe(e, ["getPopupContainer", "placement", "mouseEnterDelay", "mouseLeaveDelay", "overlayStyle", "rootClassName"]), ne = x("tooltip", i), Z = x(), J = e["data-popover-inject"];
  let K = O;
  !("open" in e) && !("visible" in e) && k && (K = !1);
  const ee = /* @__PURE__ */ $.isValidElement(u) && !IJ(u) ? u : /* @__PURE__ */ $.createElement("span", null, u), te = ee.props, H = !te.className || typeof te.className == "string" ? Ee(te.className, o || `${ne}-open`) : te.className, [ie, W, se] = nee(ne, !J), le = ree(ne, c), ge = le.arrowStyle, me = Object.assign(Object.assign({}, l), le.overlayStyle), pe = Ee(s, {
    [`${ne}-rtl`]: T === "rtl"
  }, le.className, q, W, se), [Te, de] = BJ("Tooltip", X.zIndex), Ae = /* @__PURE__ */ $.createElement(MLe, Object.assign({}, X, {
    zIndex: Te,
    showArrow: b,
    placement: B,
    mouseEnterDelay: U,
    mouseLeaveDelay: Q,
    prefixCls: ne,
    overlayClassName: pe,
    overlayStyle: Object.assign(Object.assign({}, ge), Y),
    getTooltipContainer: V || a || C,
    ref: R,
    builtinPlacements: N,
    overlay: z,
    visible: K,
    onVisibleChange: L,
    afterVisibleChange: d ?? f,
    overlayInnerStyle: me,
    arrowContent: /* @__PURE__ */ $.createElement("span", {
      className: `${ne}-arrow-content`
    }),
    motion: {
      motionName: qJ(Z, "zoom-big-fast", e.transitionName),
      motionDeadline: 1e3
    },
    destroyTooltipOnHide: !!h
  }), K ? Jg(ee, {
    className: H
  }) : ee);
  return ie(/* @__PURE__ */ $.createElement(LJ.Provider, {
    value: de
  }, Ae));
}), KM = KLe;
process.env.NODE_ENV !== "production" && (KM.displayName = "Tooltip");
KM._InternalPanelDoNotUseOrYouWillBeFired = qLe;
const od = KM;
var YLe = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M724 218.3V141c0-6.7-7.7-10.4-12.9-6.3L260.3 486.8a31.86 31.86 0 000 50.3l450.8 352.1c5.3 4.1 12.9.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6l-360-281 360-281.1c3.8-3 6.1-7.7 6.1-12.6z" } }] }, name: "left", theme: "outlined" };
const XLe = YLe;
var QLe = function(t, n) {
  return /* @__PURE__ */ $.createElement(mo, xt({}, t, {
    ref: n,
    icon: XLe
  }));
}, iee = /* @__PURE__ */ $.forwardRef(QLe);
process.env.NODE_ENV !== "production" && (iee.displayName = "LeftOutlined");
const JLe = iee;
function YM(e) {
  return Mr(e, {
    inputAffixPadding: e.paddingXXS
  });
}
const XM = (e) => {
  const {
    controlHeight: t,
    fontSize: n,
    lineHeight: r,
    lineWidth: i,
    controlHeightSM: o,
    controlHeightLG: a,
    fontSizeLG: s,
    lineHeightLG: c,
    paddingSM: l,
    controlPaddingHorizontalSM: u,
    controlPaddingHorizontal: d,
    colorFillAlter: f,
    colorPrimaryHover: h,
    colorPrimary: p,
    controlOutlineWidth: g,
    controlOutline: m,
    colorErrorOutline: v,
    colorWarningOutline: y,
    colorBgContainer: _
  } = e;
  return {
    paddingBlock: Math.max(Math.round((t - n * r) / 2 * 10) / 10 - i, 0),
    paddingBlockSM: Math.max(Math.round((o - n * r) / 2 * 10) / 10 - i, 0),
    paddingBlockLG: Math.ceil((a - s * c) / 2 * 10) / 10 - i,
    paddingInline: l - i,
    paddingInlineSM: u - i,
    paddingInlineLG: d - i,
    addonBg: f,
    activeBorderColor: p,
    hoverBorderColor: h,
    activeShadow: `0 0 0 ${g}px ${m}`,
    errorActiveShadow: `0 0 0 ${g}px ${v}`,
    warningActiveShadow: `0 0 0 ${g}px ${y}`,
    hoverBg: _,
    activeBg: _,
    inputFontSize: n,
    inputFontSizeLG: s,
    inputFontSizeSM: n
  };
}, ZLe = (e) => ({
  borderColor: e.hoverBorderColor,
  backgroundColor: e.hoverBg
}), QM = (e) => ({
  color: e.colorTextDisabled,
  backgroundColor: e.colorBgContainerDisabled,
  borderColor: e.colorBorder,
  boxShadow: "none",
  cursor: "not-allowed",
  opacity: 1,
  "input[disabled], textarea[disabled]": {
    cursor: "not-allowed"
  },
  "&:hover:not([disabled])": Object.assign({}, ZLe(Mr(e, {
    hoverBorderColor: e.colorBorder,
    hoverBg: e.colorBgContainerDisabled
  })))
}), oee = (e, t) => ({
  background: e.colorBgContainer,
  borderWidth: e.lineWidth,
  borderStyle: e.lineType,
  borderColor: t.borderColor,
  "&:hover": {
    borderColor: t.hoverBorderColor,
    backgroundColor: e.hoverBg
  },
  "&:focus, &:focus-within": {
    borderColor: t.activeBorderColor,
    boxShadow: t.activeShadow,
    outline: 0,
    backgroundColor: e.activeBg
  }
}), NF = (e, t) => ({
  [`&${e.componentCls}-status-${t.status}:not(${e.componentCls}-disabled)`]: Object.assign(Object.assign({}, oee(e, t)), {
    [`${e.componentCls}-prefix, ${e.componentCls}-suffix`]: {
      color: t.affixColor
    }
  }),
  [`&${e.componentCls}-status-${t.status}${e.componentCls}-disabled`]: {
    borderColor: t.borderColor
  }
}), aee = (e, t) => ({
  "&-outlined": Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, oee(e, {
    borderColor: e.colorBorder,
    hoverBorderColor: e.hoverBorderColor,
    activeBorderColor: e.activeBorderColor,
    activeShadow: e.activeShadow
  })), {
    [`&${e.componentCls}-disabled, &[disabled]`]: Object.assign({}, QM(e))
  }), NF(e, {
    status: "error",
    borderColor: e.colorError,
    hoverBorderColor: e.colorErrorBorderHover,
    activeBorderColor: e.colorError,
    activeShadow: e.errorActiveShadow,
    affixColor: e.colorError
  })), NF(e, {
    status: "warning",
    borderColor: e.colorWarning,
    hoverBorderColor: e.colorWarningBorderHover,
    activeBorderColor: e.colorWarning,
    activeShadow: e.warningActiveShadow,
    affixColor: e.colorWarning
  })), t)
}), DF = (e, t) => ({
  [`&${e.componentCls}-group-wrapper-status-${t.status}`]: {
    [`${e.componentCls}-group-addon`]: {
      borderColor: t.addonBorderColor,
      color: t.addonColor
    }
  }
}), see = (e) => ({
  "&-outlined": Object.assign(Object.assign(Object.assign({
    [`${e.componentCls}-group`]: {
      "&-addon": {
        background: e.addonBg,
        border: `${et(e.lineWidth)} ${e.lineType} ${e.colorBorder}`
      },
      "&-addon:first-child": {
        borderInlineEnd: 0
      },
      "&-addon:last-child": {
        borderInlineStart: 0
      }
    }
  }, DF(e, {
    status: "error",
    addonBorderColor: e.colorError,
    addonColor: e.colorErrorText
  })), DF(e, {
    status: "warning",
    addonBorderColor: e.colorWarning,
    addonColor: e.colorWarningText
  })), {
    [`&${e.componentCls}-group-wrapper-disabled`]: {
      [`${e.componentCls}-group-addon`]: Object.assign({}, QM(e))
    }
  })
}), cee = (e, t) => {
  const {
    componentCls: n
  } = e;
  return {
    "&-borderless": Object.assign({
      background: "transparent",
      border: "none",
      "&:focus, &:focus-within": {
        outline: "none"
      },
      // >>>>> Disabled
      [`&${n}-disabled, &[disabled]`]: {
        color: e.colorTextDisabled,
        cursor: "not-allowed"
      },
      // >>>>> Status
      [`&${n}-status-error`]: {
        "&, & input, & textarea": {
          color: e.colorError
        }
      },
      [`&${n}-status-warning`]: {
        "&, & input, & textarea": {
          color: e.colorWarning
        }
      }
    }, t)
  };
}, lee = (e, t) => ({
  background: t.bg,
  borderWidth: e.lineWidth,
  borderStyle: e.lineType,
  borderColor: "transparent",
  "input&, & input, textarea&, & textarea": {
    color: t == null ? void 0 : t.inputColor
  },
  "&:hover": {
    background: t.hoverBg
  },
  "&:focus, &:focus-within": {
    outline: 0,
    borderColor: t.activeBorderColor,
    backgroundColor: e.activeBg
  }
}), jF = (e, t) => ({
  [`&${e.componentCls}-status-${t.status}:not(${e.componentCls}-disabled)`]: Object.assign(Object.assign({}, lee(e, t)), {
    [`${e.componentCls}-prefix, ${e.componentCls}-suffix`]: {
      color: t.affixColor
    }
  })
}), uee = (e, t) => ({
  "&-filled": Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, lee(e, {
    bg: e.colorFillTertiary,
    hoverBg: e.colorFillSecondary,
    activeBorderColor: e.activeBorderColor
  })), {
    [`&${e.componentCls}-disabled, &[disabled]`]: Object.assign({}, QM(e))
  }), jF(e, {
    status: "error",
    bg: e.colorErrorBg,
    hoverBg: e.colorErrorBgHover,
    activeBorderColor: e.colorError,
    inputColor: e.colorErrorText,
    affixColor: e.colorError
  })), jF(e, {
    status: "warning",
    bg: e.colorWarningBg,
    hoverBg: e.colorWarningBgHover,
    activeBorderColor: e.colorWarning,
    inputColor: e.colorWarningText,
    affixColor: e.colorWarning
  })), t)
}), LF = (e, t) => ({
  [`&${e.componentCls}-group-wrapper-status-${t.status}`]: {
    [`${e.componentCls}-group-addon`]: {
      background: t.addonBg,
      color: t.addonColor
    }
  }
}), dee = (e) => ({
  "&-filled": Object.assign(Object.assign(Object.assign({
    [`${e.componentCls}-group`]: {
      "&-addon": {
        background: e.colorFillTertiary
      },
      [`${e.componentCls}-filled:not(:focus):not(:focus-within)`]: {
        "&:not(:first-child)": {
          borderInlineStart: `${et(e.lineWidth)} ${e.lineType} ${e.colorSplit}`
        },
        "&:not(:last-child)": {
          borderInlineEnd: `${et(e.lineWidth)} ${e.lineType} ${e.colorSplit}`
        }
      }
    }
  }, LF(e, {
    status: "error",
    addonBg: e.colorErrorBg,
    addonColor: e.colorErrorText
  })), LF(e, {
    status: "warning",
    addonBg: e.colorWarningBg,
    addonColor: e.colorWarningText
  })), {
    [`&${e.componentCls}-group-wrapper-disabled`]: {
      [`${e.componentCls}-group`]: {
        "&-addon": {
          background: e.colorFillTertiary,
          color: e.colorTextDisabled
        },
        "&-addon:first-child": {
          borderInlineStart: `${et(e.lineWidth)} ${e.lineType} ${e.colorBorder}`,
          borderTop: `${et(e.lineWidth)} ${e.lineType} ${e.colorBorder}`,
          borderBottom: `${et(e.lineWidth)} ${e.lineType} ${e.colorBorder}`
        },
        "&-addon:last-child": {
          borderInlineEnd: `${et(e.lineWidth)} ${e.lineType} ${e.colorBorder}`,
          borderTop: `${et(e.lineWidth)} ${e.lineType} ${e.colorBorder}`,
          borderBottom: `${et(e.lineWidth)} ${e.lineType} ${e.colorBorder}`
        }
      }
    }
  })
}), fee = (e) => ({
  // Firefox
  "&::-moz-placeholder": {
    opacity: 1
  },
  "&::placeholder": {
    color: e,
    userSelect: "none"
    // https://github.com/ant-design/ant-design/pull/32639
  },
  "&:placeholder-shown": {
    textOverflow: "ellipsis"
  }
}), hee = (e) => {
  const {
    paddingBlockLG: t,
    lineHeightLG: n,
    borderRadiusLG: r,
    paddingInlineLG: i
  } = e;
  return {
    padding: `${et(t)} ${et(i)}`,
    fontSize: e.inputFontSizeLG,
    lineHeight: n,
    borderRadius: r
  };
}, gee = (e) => ({
  padding: `${et(e.paddingBlockSM)} ${et(e.paddingInlineSM)}`,
  fontSize: e.inputFontSizeSM,
  borderRadius: e.borderRadiusSM
}), ZE = (e) => Object.assign(Object.assign({
  position: "relative",
  display: "inline-block",
  width: "100%",
  minWidth: 0,
  padding: `${et(e.paddingBlock)} ${et(e.paddingInline)}`,
  color: e.colorText,
  fontSize: e.inputFontSize,
  lineHeight: e.lineHeight,
  borderRadius: e.borderRadius,
  transition: `all ${e.motionDurationMid}`
}, fee(e.colorTextPlaceholder)), {
  // Reset height for `textarea`s
  "textarea&": {
    maxWidth: "100%",
    // prevent textarea resize from coming out of its container
    height: "auto",
    minHeight: e.controlHeight,
    lineHeight: e.lineHeight,
    verticalAlign: "bottom",
    transition: `all ${e.motionDurationSlow}, height 0s`,
    resize: "vertical"
  },
  // Size
  "&-lg": Object.assign({}, hee(e)),
  "&-sm": Object.assign({}, gee(e)),
  // RTL
  "&-rtl, &-textarea-rtl": {
    direction: "rtl"
  }
}), pee = (e) => {
  const {
    componentCls: t,
    antCls: n
  } = e;
  return {
    position: "relative",
    display: "table",
    width: "100%",
    borderCollapse: "separate",
    borderSpacing: 0,
    // Undo padding and float of grid classes
    "&[class*='col-']": {
      paddingInlineEnd: e.paddingXS,
      "&:last-child": {
        paddingInlineEnd: 0
      }
    },
    // Sizing options
    [`&-lg ${t}, &-lg > ${t}-group-addon`]: Object.assign({}, hee(e)),
    [`&-sm ${t}, &-sm > ${t}-group-addon`]: Object.assign({}, gee(e)),
    // Fix https://github.com/ant-design/ant-design/issues/5754
    [`&-lg ${n}-select-single ${n}-select-selector`]: {
      height: e.controlHeightLG
    },
    [`&-sm ${n}-select-single ${n}-select-selector`]: {
      height: e.controlHeightSM
    },
    [`> ${t}`]: {
      display: "table-cell",
      "&:not(:first-child):not(:last-child)": {
        borderRadius: 0
      }
    },
    [`${t}-group`]: {
      "&-addon, &-wrap": {
        display: "table-cell",
        width: 1,
        whiteSpace: "nowrap",
        verticalAlign: "middle",
        "&:not(:first-child):not(:last-child)": {
          borderRadius: 0
        }
      },
      "&-wrap > *": {
        display: "block !important"
      },
      "&-addon": {
        position: "relative",
        padding: `0 ${et(e.paddingInline)}`,
        color: e.colorText,
        fontWeight: "normal",
        fontSize: e.inputFontSize,
        textAlign: "center",
        borderRadius: e.borderRadius,
        transition: `all ${e.motionDurationSlow}`,
        lineHeight: 1,
        // Reset Select's style in addon
        [`${n}-select`]: {
          margin: `${et(e.calc(e.paddingBlock).add(1).mul(-1).equal())} ${et(e.calc(e.paddingInline).mul(-1).equal())}`,
          [`&${n}-select-single:not(${n}-select-customize-input):not(${n}-pagination-size-changer)`]: {
            [`${n}-select-selector`]: {
              backgroundColor: "inherit",
              border: `${et(e.lineWidth)} ${e.lineType} transparent`,
              boxShadow: "none"
            }
          }
        },
        // https://github.com/ant-design/ant-design/issues/31333
        [`${n}-cascader-picker`]: {
          margin: `-9px ${et(e.calc(e.paddingInline).mul(-1).equal())}`,
          backgroundColor: "transparent",
          [`${n}-cascader-input`]: {
            textAlign: "start",
            border: 0,
            boxShadow: "none"
          }
        }
      }
    },
    [t]: {
      width: "100%",
      marginBottom: 0,
      textAlign: "inherit",
      "&:focus": {
        zIndex: 1,
        // Fix https://gw.alipayobjects.com/zos/rmsportal/DHNpoqfMXSfrSnlZvhsJ.png
        borderInlineEndWidth: 1
      },
      "&:hover": {
        zIndex: 1,
        borderInlineEndWidth: 1,
        [`${t}-search-with-button &`]: {
          zIndex: 0
        }
      }
    },
    // Reset rounded corners
    [`> ${t}:first-child, ${t}-group-addon:first-child`]: {
      borderStartEndRadius: 0,
      borderEndEndRadius: 0,
      // Reset Select's style in addon
      [`${n}-select ${n}-select-selector`]: {
        borderStartEndRadius: 0,
        borderEndEndRadius: 0
      }
    },
    [`> ${t}-affix-wrapper`]: {
      [`&:not(:first-child) ${t}`]: {
        borderStartStartRadius: 0,
        borderEndStartRadius: 0
      },
      [`&:not(:last-child) ${t}`]: {
        borderStartEndRadius: 0,
        borderEndEndRadius: 0
      }
    },
    [`> ${t}:last-child, ${t}-group-addon:last-child`]: {
      borderStartStartRadius: 0,
      borderEndStartRadius: 0,
      // Reset Select's style in addon
      [`${n}-select ${n}-select-selector`]: {
        borderStartStartRadius: 0,
        borderEndStartRadius: 0
      }
    },
    [`${t}-affix-wrapper`]: {
      "&:not(:last-child)": {
        borderStartEndRadius: 0,
        borderEndEndRadius: 0,
        [`${t}-search &`]: {
          borderStartStartRadius: e.borderRadius,
          borderEndStartRadius: e.borderRadius
        }
      },
      [`&:not(:first-child), ${t}-search &:not(:first-child)`]: {
        borderStartStartRadius: 0,
        borderEndStartRadius: 0
      }
    },
    [`&${t}-group-compact`]: Object.assign(Object.assign({
      display: "block"
    }, $3e()), {
      [`${t}-group-addon, ${t}-group-wrap, > ${t}`]: {
        "&:not(:first-child):not(:last-child)": {
          borderInlineEndWidth: e.lineWidth,
          "&:hover, &:focus": {
            zIndex: 1
          }
        }
      },
      "& > *": {
        display: "inline-flex",
        float: "none",
        verticalAlign: "top",
        // https://github.com/ant-design/ant-design-pro/issues/139
        borderRadius: 0
      },
      [`
        & > ${t}-affix-wrapper,
        & > ${t}-number-affix-wrapper,
        & > ${n}-picker-range
      `]: {
        display: "inline-flex"
      },
      "& > *:not(:last-child)": {
        marginInlineEnd: e.calc(e.lineWidth).mul(-1).equal(),
        borderInlineEndWidth: e.lineWidth
      },
      // Undo float for .ant-input-group .ant-input
      [t]: {
        float: "none"
      },
      // reset border for Select, DatePicker, AutoComplete, Cascader, Mention, TimePicker, Input
      [`& > ${n}-select > ${n}-select-selector,
      & > ${n}-select-auto-complete ${t},
      & > ${n}-cascader-picker ${t},
      & > ${t}-group-wrapper ${t}`]: {
        borderInlineEndWidth: e.lineWidth,
        borderRadius: 0,
        "&:hover, &:focus": {
          zIndex: 1
        }
      },
      [`& > ${n}-select-focused`]: {
        zIndex: 1
      },
      // update z-index for arrow icon
      [`& > ${n}-select > ${n}-select-arrow`]: {
        zIndex: 1
        // https://github.com/ant-design/ant-design/issues/20371
      },
      [`& > *:first-child,
      & > ${n}-select:first-child > ${n}-select-selector,
      & > ${n}-select-auto-complete:first-child ${t},
      & > ${n}-cascader-picker:first-child ${t}`]: {
        borderStartStartRadius: e.borderRadius,
        borderEndStartRadius: e.borderRadius
      },
      [`& > *:last-child,
      & > ${n}-select:last-child > ${n}-select-selector,
      & > ${n}-cascader-picker:last-child ${t},
      & > ${n}-cascader-picker-focused:last-child ${t}`]: {
        borderInlineEndWidth: e.lineWidth,
        borderStartEndRadius: e.borderRadius,
        borderEndEndRadius: e.borderRadius
      },
      // https://github.com/ant-design/ant-design/issues/12493
      [`& > ${n}-select-auto-complete ${t}`]: {
        verticalAlign: "top"
      },
      [`${t}-group-wrapper + ${t}-group-wrapper`]: {
        marginInlineStart: e.calc(e.lineWidth).mul(-1).equal(),
        [`${t}-affix-wrapper`]: {
          borderRadius: 0
        }
      },
      [`${t}-group-wrapper:not(:last-child)`]: {
        [`&${t}-search > ${t}-group`]: {
          [`& > ${t}-group-addon > ${t}-search-button`]: {
            borderRadius: 0
          },
          [`& > ${t}`]: {
            borderStartStartRadius: e.borderRadius,
            borderStartEndRadius: 0,
            borderEndEndRadius: 0,
            borderEndStartRadius: e.borderRadius
          }
        }
      }
    })
  };
}, eFe = (e) => {
  const {
    componentCls: t,
    controlHeightSM: n,
    lineWidth: r,
    calc: i
  } = e, o = 16, a = i(n).sub(i(r).mul(2)).sub(o).div(2).equal();
  return {
    [t]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, _a(e)), ZE(e)), aee(e)), uee(e)), cee(e)), {
      '&[type="color"]': {
        height: e.controlHeight,
        [`&${t}-lg`]: {
          height: e.controlHeightLG
        },
        [`&${t}-sm`]: {
          height: n,
          paddingTop: a,
          paddingBottom: a
        }
      },
      '&[type="search"]::-webkit-search-cancel-button, &[type="search"]::-webkit-search-decoration': {
        "-webkit-appearance": "none"
      }
    })
  };
}, tFe = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    // ========================= Input =========================
    [`${t}-clear-icon`]: {
      margin: 0,
      color: e.colorTextQuaternary,
      fontSize: e.fontSizeIcon,
      verticalAlign: -1,
      // https://github.com/ant-design/ant-design/pull/18151
      // https://codesandbox.io/s/wizardly-sun-u10br
      cursor: "pointer",
      transition: `color ${e.motionDurationSlow}`,
      "&:hover": {
        color: e.colorTextTertiary
      },
      "&:active": {
        color: e.colorText
      },
      "&-hidden": {
        visibility: "hidden"
      },
      "&-has-suffix": {
        margin: `0 ${et(e.inputAffixPadding)}`
      }
    }
  };
}, nFe = (e) => {
  const {
    componentCls: t,
    inputAffixPadding: n,
    colorTextDescription: r,
    motionDurationSlow: i,
    colorIcon: o,
    colorIconHover: a,
    iconCls: s
  } = e, c = `${t}-affix-wrapper`, l = `${t}-affix-wrapper-disabled`;
  return {
    [c]: Object.assign(Object.assign(Object.assign(Object.assign({}, ZE(e)), {
      display: "inline-flex",
      [`&:not(${t}-disabled):hover`]: {
        zIndex: 1,
        [`${t}-search-with-button &`]: {
          zIndex: 0
        }
      },
      "&-focused, &:focus": {
        zIndex: 1
      },
      [`> input${t}`]: {
        padding: 0
      },
      [`> input${t}, > textarea${t}`]: {
        fontSize: "inherit",
        border: "none",
        borderRadius: 0,
        outline: "none",
        background: "transparent",
        color: "inherit",
        "&::-ms-reveal": {
          display: "none"
        },
        "&:focus": {
          boxShadow: "none !important"
        }
      },
      "&::before": {
        display: "inline-block",
        width: 0,
        visibility: "hidden",
        content: '"\\a0"'
      },
      [t]: {
        "&-prefix, &-suffix": {
          display: "flex",
          flex: "none",
          alignItems: "center",
          "> *:not(:last-child)": {
            marginInlineEnd: e.paddingXS
          }
        },
        "&-show-count-suffix": {
          color: r
        },
        "&-show-count-has-suffix": {
          marginInlineEnd: e.paddingXXS
        },
        "&-prefix": {
          marginInlineEnd: n
        },
        "&-suffix": {
          marginInlineStart: n
        }
      }
    }), tFe(e)), {
      // password
      [`${s}${t}-password-icon`]: {
        color: o,
        cursor: "pointer",
        transition: `all ${i}`,
        "&:hover": {
          color: a
        }
      }
    }),
    [l]: {
      // password disabled
      [`${s}${t}-password-icon`]: {
        color: o,
        cursor: "not-allowed",
        "&:hover": {
          color: o
        }
      }
    }
  };
}, rFe = (e) => {
  const {
    componentCls: t,
    borderRadiusLG: n,
    borderRadiusSM: r
  } = e;
  return {
    [`${t}-group`]: Object.assign(Object.assign(Object.assign({}, _a(e)), pee(e)), {
      "&-rtl": {
        direction: "rtl"
      },
      "&-wrapper": Object.assign(Object.assign(Object.assign({
        display: "inline-block",
        width: "100%",
        textAlign: "start",
        verticalAlign: "top",
        "&-rtl": {
          direction: "rtl"
        },
        // Size
        "&-lg": {
          [`${t}-group-addon`]: {
            borderRadius: n,
            fontSize: e.inputFontSizeLG
          }
        },
        "&-sm": {
          [`${t}-group-addon`]: {
            borderRadius: r
          }
        }
      }, see(e)), dee(e)), {
        // '&-disabled': {
        //   [`${componentCls}-group-addon`]: {
        //     ...genDisabledStyle(token),
        //   },
        // },
        // Fix the issue of using icons in Space Compact mode
        // https://github.com/ant-design/ant-design/issues/42122
        [`&:not(${t}-compact-first-item):not(${t}-compact-last-item)${t}-compact-item`]: {
          [`${t}, ${t}-group-addon`]: {
            borderRadius: 0
          }
        },
        [`&:not(${t}-compact-last-item)${t}-compact-first-item`]: {
          [`${t}, ${t}-group-addon`]: {
            borderStartEndRadius: 0,
            borderEndEndRadius: 0
          }
        },
        [`&:not(${t}-compact-first-item)${t}-compact-last-item`]: {
          [`${t}, ${t}-group-addon`]: {
            borderStartStartRadius: 0,
            borderEndStartRadius: 0
          }
        },
        // Fix the issue of input use show-count param in space compact mode
        // https://github.com/ant-design/ant-design/issues/46872
        [`&:not(${t}-compact-last-item)${t}-compact-item`]: {
          [`${t}-affix-wrapper`]: {
            borderStartEndRadius: 0,
            borderEndEndRadius: 0
          }
        }
      })
    })
  };
}, iFe = (e) => {
  const {
    componentCls: t,
    antCls: n
  } = e, r = `${t}-search`;
  return {
    [r]: {
      [t]: {
        "&:hover, &:focus": {
          [`+ ${t}-group-addon ${r}-button:not(${n}-btn-primary)`]: {
            borderInlineStartColor: e.colorPrimaryHover
          }
        }
      },
      [`${t}-affix-wrapper`]: {
        height: e.controlHeight,
        borderRadius: 0
      },
      // fix slight height diff in Firefox:
      // https://ant.design/components/auto-complete-cn/#auto-complete-demo-certain-category
      [`${t}-lg`]: {
        lineHeight: e.calc(e.lineHeightLG).sub(2e-4).equal()
      },
      [`> ${t}-group`]: {
        [`> ${t}-group-addon:last-child`]: {
          insetInlineStart: -1,
          padding: 0,
          border: 0,
          [`${r}-button`]: {
            // Fix https://github.com/ant-design/ant-design/issues/47150
            marginInlineEnd: -1,
            paddingTop: 0,
            paddingBottom: 0,
            borderStartStartRadius: 0,
            borderEndStartRadius: 0,
            boxShadow: "none"
          },
          [`${r}-button:not(${n}-btn-primary)`]: {
            color: e.colorTextDescription,
            "&:hover": {
              color: e.colorPrimaryHover
            },
            "&:active": {
              color: e.colorPrimaryActive
            },
            [`&${n}-btn-loading::before`]: {
              insetInlineStart: 0,
              insetInlineEnd: 0,
              insetBlockStart: 0,
              insetBlockEnd: 0
            }
          }
        }
      },
      [`${r}-button`]: {
        height: e.controlHeight,
        "&:hover, &:focus": {
          zIndex: 1
        }
      },
      "&-large": {
        [`${t}-affix-wrapper, ${r}-button`]: {
          height: e.controlHeightLG
        }
      },
      "&-small": {
        [`${t}-affix-wrapper, ${r}-button`]: {
          height: e.controlHeightSM
        }
      },
      "&-rtl": {
        direction: "rtl"
      },
      // ===================== Compact Item Customized Styles =====================
      [`&${t}-compact-item`]: {
        [`&:not(${t}-compact-last-item)`]: {
          [`${t}-group-addon`]: {
            [`${t}-search-button`]: {
              marginInlineEnd: e.calc(e.lineWidth).mul(-1).equal(),
              borderRadius: 0
            }
          }
        },
        [`&:not(${t}-compact-first-item)`]: {
          [`${t},${t}-affix-wrapper`]: {
            borderRadius: 0
          }
        },
        [`> ${t}-group-addon ${t}-search-button,
        > ${t},
        ${t}-affix-wrapper`]: {
          "&:hover, &:focus, &:active": {
            zIndex: 2
          }
        },
        [`> ${t}-affix-wrapper-focused`]: {
          zIndex: 2
        }
      }
    }
  };
}, oFe = (e) => {
  const {
    componentCls: t,
    paddingLG: n
  } = e, r = `${t}-textarea`;
  return {
    [r]: {
      position: "relative",
      "&-show-count": {
        // https://github.com/ant-design/ant-design/issues/33049
        [`> ${t}`]: {
          height: "100%"
        },
        [`${t}-data-count`]: {
          position: "absolute",
          bottom: e.calc(e.fontSize).mul(e.lineHeight).mul(-1).equal(),
          insetInlineEnd: 0,
          color: e.colorTextDescription,
          whiteSpace: "nowrap",
          pointerEvents: "none"
        }
      },
      [`
        &-allow-clear > ${t},
        &-affix-wrapper${r}-has-feedback ${t}
      `]: {
        paddingInlineEnd: n
      },
      [`&-affix-wrapper${t}-affix-wrapper`]: {
        padding: 0,
        [`> textarea${t}`]: {
          fontSize: "inherit",
          border: "none",
          outline: "none",
          background: "transparent",
          "&:focus": {
            boxShadow: "none !important"
          }
        },
        [`${t}-suffix`]: {
          margin: 0,
          "> *:not(:last-child)": {
            marginInline: 0
          },
          // Clear Icon
          [`${t}-clear-icon`]: {
            position: "absolute",
            insetInlineEnd: e.paddingInline,
            insetBlockStart: e.paddingXS
          },
          // Feedback Icon
          [`${r}-suffix`]: {
            position: "absolute",
            top: 0,
            insetInlineEnd: e.paddingInline,
            bottom: 0,
            zIndex: 1,
            display: "inline-flex",
            alignItems: "center",
            margin: "auto",
            pointerEvents: "none"
          }
        }
      },
      [`&-affix-wrapper${t}-affix-wrapper-sm`]: {
        [`${t}-suffix`]: {
          [`${t}-clear-icon`]: {
            insetInlineEnd: e.paddingInlineSM
          }
        }
      }
    }
  };
}, aFe = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}-out-of-range`]: {
      [`&, & input, & textarea, ${t}-show-count-suffix, ${t}-data-count`]: {
        color: e.colorError
      }
    }
  };
}, JM = Za("Input", (e) => {
  const t = Mr(e, YM(e));
  return [
    eFe(t),
    oFe(t),
    nFe(t),
    rFe(t),
    iFe(t),
    aFe(t),
    // =====================================================
    // ==             Space Compact                       ==
    // =====================================================
    qE(t)
  ];
}, XM, {
  resetFont: !1
});
function sFe(e, t, n) {
  var r = n || {}, i = r.noTrailing, o = i === void 0 ? !1 : i, a = r.noLeading, s = a === void 0 ? !1 : a, c = r.debounceMode, l = c === void 0 ? void 0 : c, u, d = !1, f = 0;
  function h() {
    u && clearTimeout(u);
  }
  function p(m) {
    var v = m || {}, y = v.upcomingOnly, _ = y === void 0 ? !1 : y;
    h(), d = !_;
  }
  function g() {
    for (var m = arguments.length, v = new Array(m), y = 0; y < m; y++)
      v[y] = arguments[y];
    var _ = this, b = Date.now() - f;
    if (d)
      return;
    function w() {
      f = Date.now(), t.apply(_, v);
    }
    function C() {
      u = void 0;
    }
    !s && l && !u && w(), h(), l === void 0 && b > e ? s ? (f = Date.now(), o || (u = setTimeout(l ? C : w, e))) : w() : o !== !0 && (u = setTimeout(l ? C : w, l === void 0 ? e - b : e));
  }
  return g.cancel = p, g;
}
function cFe(e, t, n) {
  var r = n || {}, i = r.atBegin, o = i === void 0 ? !1 : i;
  return sFe(e, t, {
    debounceMode: o !== !1
  });
}
var lFe = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M890.5 755.3L537.9 269.2c-12.8-17.6-39-17.6-51.7 0L133.5 755.3A8 8 0 00140 768h75c5.1 0 9.9-2.5 12.9-6.6L512 369.8l284.1 391.6c3 4.1 7.8 6.6 12.9 6.6h75c6.5 0 10.3-7.4 6.5-12.7z" } }] }, name: "up", theme: "outlined" };
const uFe = lFe;
var dFe = function(t, n) {
  return /* @__PURE__ */ $.createElement(mo, xt({}, t, {
    ref: n,
    icon: uFe
  }));
}, mee = /* @__PURE__ */ $.forwardRef(dFe);
process.env.NODE_ENV !== "production" && (mee.displayName = "UpOutlined");
const vee = mee;
function wR() {
  return typeof BigInt == "function";
}
function yee(e) {
  return !e && e !== 0 && !Number.isNaN(e) || !String(e).trim();
}
function Zd(e) {
  var t = e.trim(), n = t.startsWith("-");
  n && (t = t.slice(1)), t = t.replace(/(\.\d*[^0])0*$/, "$1").replace(/\.0*$/, "").replace(/^0+/, ""), t.startsWith(".") && (t = "0".concat(t));
  var r = t || "0", i = r.split("."), o = i[0] || "0", a = i[1] || "0";
  o === "0" && a === "0" && (n = !1);
  var s = n ? "-" : "";
  return {
    negative: n,
    negativeStr: s,
    trimStr: r,
    integerStr: o,
    decimalStr: a,
    fullStr: "".concat(s).concat(r)
  };
}
function ZM(e) {
  var t = String(e);
  return !Number.isNaN(Number(t)) && t.includes("e");
}
function Ld(e) {
  var t = String(e);
  if (ZM(e)) {
    var n = Number(t.slice(t.indexOf("e-") + 2)), r = t.match(/\.(\d+)/);
    return r != null && r[1] && (n += r[1].length), n;
  }
  return t.includes(".") && e3(t) ? t.length - t.indexOf(".") - 1 : 0;
}
function eC(e) {
  var t = String(e);
  if (ZM(e)) {
    if (e > Number.MAX_SAFE_INTEGER)
      return String(wR() ? BigInt(e).toString() : Number.MAX_SAFE_INTEGER);
    if (e < Number.MIN_SAFE_INTEGER)
      return String(wR() ? BigInt(e).toString() : Number.MIN_SAFE_INTEGER);
    t = e.toFixed(Ld(t));
  }
  return Zd(t).fullStr;
}
function e3(e) {
  return typeof e == "number" ? !Number.isNaN(e) : e ? (
    // Normal type: 11.28
    /^\s*-?\d+(\.\d+)?\s*$/.test(e) || // Pre-number: 1.
    /^\s*-?\d+\.\s*$/.test(e) || // Post-number: .1
    /^\s*-?\.\d+\s*$/.test(e)
  ) : !1;
}
var fFe = /* @__PURE__ */ function() {
  function e(t) {
    if (xr(this, e), oe(this, "origin", ""), oe(this, "negative", void 0), oe(this, "integer", void 0), oe(this, "decimal", void 0), oe(this, "decimalLen", void 0), oe(this, "empty", void 0), oe(this, "nan", void 0), yee(t)) {
      this.empty = !0;
      return;
    }
    if (this.origin = String(t), t === "-" || Number.isNaN(t)) {
      this.nan = !0;
      return;
    }
    var n = t;
    if (ZM(n) && (n = Number(n)), n = typeof n == "string" ? n : eC(n), e3(n)) {
      var r = Zd(n);
      this.negative = r.negative;
      var i = r.trimStr.split(".");
      this.integer = BigInt(i[0]);
      var o = i[1] || "0";
      this.decimal = BigInt(o), this.decimalLen = o.length;
    } else
      this.nan = !0;
  }
  return Er(e, [{
    key: "getMark",
    value: function() {
      return this.negative ? "-" : "";
    }
  }, {
    key: "getIntegerStr",
    value: function() {
      return this.integer.toString();
    }
    /**
     * @private get decimal string
     */
  }, {
    key: "getDecimalStr",
    value: function() {
      return this.decimal.toString().padStart(this.decimalLen, "0");
    }
    /**
     * @private Align BigIntDecimal with same decimal length. e.g. 12.3 + 5 = 1230000
     * This is used for add function only.
     */
  }, {
    key: "alignDecimal",
    value: function(n) {
      var r = "".concat(this.getMark()).concat(this.getIntegerStr()).concat(this.getDecimalStr().padEnd(n, "0"));
      return BigInt(r);
    }
  }, {
    key: "negate",
    value: function() {
      var n = new e(this.toString());
      return n.negative = !n.negative, n;
    }
  }, {
    key: "cal",
    value: function(n, r, i) {
      var o = Math.max(this.getDecimalStr().length, n.getDecimalStr().length), a = this.alignDecimal(o), s = n.alignDecimal(o), c = r(a, s).toString(), l = i(o), u = Zd(c), d = u.negativeStr, f = u.trimStr, h = "".concat(d).concat(f.padStart(l + 1, "0"));
      return new e("".concat(h.slice(0, -l), ".").concat(h.slice(-l)));
    }
  }, {
    key: "add",
    value: function(n) {
      if (this.isInvalidate())
        return new e(n);
      var r = new e(n);
      return r.isInvalidate() ? this : this.cal(r, function(i, o) {
        return i + o;
      }, function(i) {
        return i;
      });
    }
  }, {
    key: "multi",
    value: function(n) {
      var r = new e(n);
      return this.isInvalidate() || r.isInvalidate() ? new e(NaN) : this.cal(r, function(i, o) {
        return i * o;
      }, function(i) {
        return i * 2;
      });
    }
  }, {
    key: "isEmpty",
    value: function() {
      return this.empty;
    }
  }, {
    key: "isNaN",
    value: function() {
      return this.nan;
    }
  }, {
    key: "isInvalidate",
    value: function() {
      return this.isEmpty() || this.isNaN();
    }
  }, {
    key: "equals",
    value: function(n) {
      return this.toString() === (n == null ? void 0 : n.toString());
    }
  }, {
    key: "lessEquals",
    value: function(n) {
      return this.add(n.negate().toString()).toNumber() <= 0;
    }
  }, {
    key: "toNumber",
    value: function() {
      return this.isNaN() ? NaN : Number(this.toString());
    }
  }, {
    key: "toString",
    value: function() {
      var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
      return n ? this.isInvalidate() ? "" : Zd("".concat(this.getMark()).concat(this.getIntegerStr(), ".").concat(this.getDecimalStr())).fullStr : this.origin;
    }
  }]), e;
}(), hFe = /* @__PURE__ */ function() {
  function e(t) {
    if (xr(this, e), oe(this, "origin", ""), oe(this, "number", void 0), oe(this, "empty", void 0), yee(t)) {
      this.empty = !0;
      return;
    }
    this.origin = String(t), this.number = Number(t);
  }
  return Er(e, [{
    key: "negate",
    value: function() {
      return new e(-this.toNumber());
    }
  }, {
    key: "add",
    value: function(n) {
      if (this.isInvalidate())
        return new e(n);
      var r = Number(n);
      if (Number.isNaN(r))
        return this;
      var i = this.number + r;
      if (i > Number.MAX_SAFE_INTEGER)
        return new e(Number.MAX_SAFE_INTEGER);
      if (i < Number.MIN_SAFE_INTEGER)
        return new e(Number.MIN_SAFE_INTEGER);
      var o = Math.max(Ld(this.number), Ld(r));
      return new e(i.toFixed(o));
    }
  }, {
    key: "multi",
    value: function(n) {
      var r = Number(n);
      if (this.isInvalidate() || Number.isNaN(r))
        return new e(NaN);
      var i = this.number * r;
      if (i > Number.MAX_SAFE_INTEGER)
        return new e(Number.MAX_SAFE_INTEGER);
      if (i < Number.MIN_SAFE_INTEGER)
        return new e(Number.MIN_SAFE_INTEGER);
      var o = Math.max(Ld(this.number), Ld(r));
      return new e(i.toFixed(o));
    }
  }, {
    key: "isEmpty",
    value: function() {
      return this.empty;
    }
  }, {
    key: "isNaN",
    value: function() {
      return Number.isNaN(this.number);
    }
  }, {
    key: "isInvalidate",
    value: function() {
      return this.isEmpty() || this.isNaN();
    }
  }, {
    key: "equals",
    value: function(n) {
      return this.toNumber() === (n == null ? void 0 : n.toNumber());
    }
  }, {
    key: "lessEquals",
    value: function(n) {
      return this.add(n.negate().toString()).toNumber() <= 0;
    }
  }, {
    key: "toNumber",
    value: function() {
      return this.number;
    }
  }, {
    key: "toString",
    value: function() {
      var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
      return n ? this.isInvalidate() ? "" : eC(this.number) : this.origin;
    }
  }]), e;
}();
function cs(e) {
  return wR() ? new fFe(e) : new hFe(e);
}
function b_(e, t, n) {
  var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
  if (e === "")
    return "";
  var i = Zd(e), o = i.negativeStr, a = i.integerStr, s = i.decimalStr, c = "".concat(t).concat(s), l = "".concat(o).concat(a);
  if (n >= 0) {
    var u = Number(s[n]);
    if (u >= 5 && !r) {
      var d = cs(e).add("".concat(o, "0.").concat("0".repeat(n)).concat(10 - u));
      return b_(d.toString(), t, n, r);
    }
    return n === 0 ? l : "".concat(l).concat(t).concat(s.padEnd(n, "0").slice(0, n));
  }
  return c === ".0" ? l : "".concat(l).concat(c);
}
function gFe(e) {
  return !!(e.addonBefore || e.addonAfter);
}
function pFe(e) {
  return !!(e.prefix || e.suffix || e.allowClear);
}
function FF(e, t, n) {
  var r = t.cloneNode(!0), i = Object.create(e, {
    target: {
      value: r
    },
    currentTarget: {
      value: r
    }
  });
  return r.value = n, typeof t.selectionStart == "number" && typeof t.selectionEnd == "number" && (r.selectionStart = t.selectionStart, r.selectionEnd = t.selectionEnd), r.setSelectionRange = function() {
    t.setSelectionRange.apply(t, arguments);
  }, i;
}
function hw(e, t, n, r) {
  if (n) {
    var i = t;
    if (t.type === "click") {
      i = FF(t, e, ""), n(i);
      return;
    }
    if (e.type !== "file" && r !== void 0) {
      i = FF(t, e, r), n(i);
      return;
    }
    n(i);
  }
}
function t3(e, t) {
  if (e) {
    e.focus(t);
    var n = t || {}, r = n.cursor;
    if (r) {
      var i = e.value.length;
      switch (r) {
        case "start":
          e.setSelectionRange(0, 0);
          break;
        case "end":
          e.setSelectionRange(i, i);
          break;
        default:
          e.setSelectionRange(0, i);
      }
    }
  }
}
var tC = /* @__PURE__ */ j.forwardRef(function(e, t) {
  var n, r, i = e.inputElement, o = e.children, a = e.prefixCls, s = e.prefix, c = e.suffix, l = e.addonBefore, u = e.addonAfter, d = e.className, f = e.style, h = e.disabled, p = e.readOnly, g = e.focused, m = e.triggerFocus, v = e.allowClear, y = e.value, _ = e.handleReset, b = e.hidden, w = e.classes, C = e.classNames, x = e.dataAttrs, T = e.styles, E = e.components, R = e.onClear, I = o ?? i, O = (E == null ? void 0 : E.affixWrapper) || "span", P = (E == null ? void 0 : E.groupWrapper) || "span", k = (E == null ? void 0 : E.wrapper) || "span", L = (E == null ? void 0 : E.groupAddon) || "span", N = $e(null), D = function(W) {
    var se;
    (se = N.current) !== null && se !== void 0 && se.contains(W.target) && (m == null || m());
  }, z = pFe(e), V = /* @__PURE__ */ YH(I, {
    value: y,
    className: Ee(I.props.className, !z && (C == null ? void 0 : C.variant)) || null
  }), B = $e(null);
  if (j.useImperativeHandle(t, function() {
    return {
      nativeElement: B.current || N.current
    };
  }), z) {
    var U = null;
    if (v) {
      var Q = !h && !p && y, Y = "".concat(a, "-clear-icon"), q = It(v) === "object" && v !== null && v !== void 0 && v.clearIcon ? v.clearIcon : "✖";
      U = /* @__PURE__ */ j.createElement("span", {
        onClick: function(W) {
          _ == null || _(W), R == null || R();
        },
        onMouseDown: function(W) {
          return W.preventDefault();
        },
        className: Ee(Y, oe(oe({}, "".concat(Y, "-hidden"), !Q), "".concat(Y, "-has-suffix"), !!c)),
        role: "button",
        tabIndex: -1
      }, q);
    }
    var X = "".concat(a, "-affix-wrapper"), ne = Ee(X, oe(oe(oe(oe(oe({}, "".concat(a, "-disabled"), h), "".concat(X, "-disabled"), h), "".concat(X, "-focused"), g), "".concat(X, "-readonly"), p), "".concat(X, "-input-with-clear-btn"), c && v && y), w == null ? void 0 : w.affixWrapper, C == null ? void 0 : C.affixWrapper, C == null ? void 0 : C.variant), Z = (c || v) && /* @__PURE__ */ j.createElement("span", {
      className: Ee("".concat(a, "-suffix"), C == null ? void 0 : C.suffix),
      style: T == null ? void 0 : T.suffix
    }, U, c);
    V = /* @__PURE__ */ j.createElement(O, xt({
      className: ne,
      style: T == null ? void 0 : T.affixWrapper,
      onClick: D
    }, x == null ? void 0 : x.affixWrapper, {
      ref: N
    }), s && /* @__PURE__ */ j.createElement("span", {
      className: Ee("".concat(a, "-prefix"), C == null ? void 0 : C.prefix),
      style: T == null ? void 0 : T.prefix
    }, s), V, Z);
  }
  if (gFe(e)) {
    var J = "".concat(a, "-group"), K = "".concat(J, "-addon"), ee = "".concat(J, "-wrapper"), te = Ee("".concat(a, "-wrapper"), J, w == null ? void 0 : w.wrapper, C == null ? void 0 : C.wrapper), H = Ee(ee, oe({}, "".concat(ee, "-disabled"), h), w == null ? void 0 : w.group, C == null ? void 0 : C.groupWrapper);
    V = /* @__PURE__ */ j.createElement(P, {
      className: H,
      ref: B
    }, /* @__PURE__ */ j.createElement(k, {
      className: te
    }, l && /* @__PURE__ */ j.createElement(L, {
      className: K
    }, l), V, u && /* @__PURE__ */ j.createElement(L, {
      className: K
    }, u)));
  }
  return /* @__PURE__ */ j.cloneElement(V, {
    className: Ee((n = V.props) === null || n === void 0 ? void 0 : n.className, d) || null,
    style: ae(ae({}, (r = V.props) === null || r === void 0 ? void 0 : r.style), f),
    hidden: b
  });
}), mFe = ["show"];
function bee(e, t) {
  return $.useMemo(function() {
    var n = {};
    t && (n.show = It(t) === "object" && t.formatter ? t.formatter : !!t), n = ae(ae({}, n), e);
    var r = n, i = r.show, o = En(r, mFe);
    return ae(ae({}, o), {}, {
      show: !!i,
      showFormatter: typeof i == "function" ? i : void 0,
      strategy: o.strategy || function(a) {
        return a.length;
      }
    });
  }, [e, t]);
}
var vFe = ["autoComplete", "onChange", "onFocus", "onBlur", "onPressEnter", "onKeyDown", "onKeyUp", "prefixCls", "disabled", "htmlSize", "className", "maxLength", "suffix", "showCount", "count", "type", "classes", "classNames", "styles", "onCompositionStart", "onCompositionEnd"], _ee = /* @__PURE__ */ ia(function(e, t) {
  var n = e.autoComplete, r = e.onChange, i = e.onFocus, o = e.onBlur, a = e.onPressEnter, s = e.onKeyDown, c = e.onKeyUp, l = e.prefixCls, u = l === void 0 ? "rc-input" : l, d = e.disabled, f = e.htmlSize, h = e.className, p = e.maxLength, g = e.suffix, m = e.showCount, v = e.count, y = e.type, _ = y === void 0 ? "text" : y, b = e.classes, w = e.classNames, C = e.styles, x = e.onCompositionStart, T = e.onCompositionEnd, E = En(e, vFe), R = Qe(!1), I = he(R, 2), O = I[0], P = I[1], k = $e(!1), L = $e(!1), N = $e(null), D = $e(null), z = function(be) {
    N.current && t3(N.current, be);
  }, V = wc(e.defaultValue, {
    value: e.value
  }), B = he(V, 2), U = B[0], Q = B[1], Y = U == null ? "" : String(U), q = Qe(null), X = he(q, 2), ne = X[0], Z = X[1], J = bee(v, m), K = J.max || p, ee = J.strategy(Y), te = !!K && ee > K;
  eO(t, function() {
    var ue;
    return {
      focus: z,
      blur: function() {
        var Ie;
        (Ie = N.current) === null || Ie === void 0 || Ie.blur();
      },
      setSelectionRange: function(Ie, Ve, ze) {
        var Ne;
        (Ne = N.current) === null || Ne === void 0 || Ne.setSelectionRange(Ie, Ve, ze);
      },
      select: function() {
        var Ie;
        (Ie = N.current) === null || Ie === void 0 || Ie.select();
      },
      input: N.current,
      nativeElement: ((ue = D.current) === null || ue === void 0 ? void 0 : ue.nativeElement) || N.current
    };
  }), ot(function() {
    P(function(ue) {
      return ue && d ? !1 : ue;
    });
  }, [d]);
  var H = function(be, Ie, Ve) {
    var ze = Ie;
    if (!k.current && J.exceedFormatter && J.max && J.strategy(Ie) > J.max) {
      if (ze = J.exceedFormatter(Ie, {
        max: J.max
      }), Ie !== ze) {
        var Ne, lt;
        Z([((Ne = N.current) === null || Ne === void 0 ? void 0 : Ne.selectionStart) || 0, ((lt = N.current) === null || lt === void 0 ? void 0 : lt.selectionEnd) || 0]);
      }
    } else if (Ve.source === "compositionEnd")
      return;
    Q(ze), N.current && hw(N.current, be, r, ze);
  };
  ot(function() {
    if (ne) {
      var ue;
      (ue = N.current) === null || ue === void 0 || ue.setSelectionRange.apply(ue, tt(ne));
    }
  }, [ne]);
  var ie = function(be) {
    H(be, be.target.value, {
      source: "change"
    });
  }, W = function(be) {
    k.current = !1, H(be, be.currentTarget.value, {
      source: "compositionEnd"
    }), T == null || T(be);
  }, se = function(be) {
    a && be.key === "Enter" && !L.current && (L.current = !0, a(be)), s == null || s(be);
  }, le = function(be) {
    be.key === "Enter" && (L.current = !1), c == null || c(be);
  }, ge = function(be) {
    P(!0), i == null || i(be);
  }, me = function(be) {
    P(!1), o == null || o(be);
  }, pe = function(be) {
    Q(""), z(), N.current && hw(N.current, be, r);
  }, Te = te && "".concat(u, "-out-of-range"), de = function() {
    var be = rd(e, [
      "prefixCls",
      "onPressEnter",
      "addonBefore",
      "addonAfter",
      "prefix",
      "suffix",
      "allowClear",
      // Input elements must be either controlled or uncontrolled,
      // specify either the value prop, or the defaultValue prop, but not both.
      "defaultValue",
      "showCount",
      "count",
      "classes",
      "htmlSize",
      "styles",
      "classNames",
      "onClear"
    ]);
    return /* @__PURE__ */ j.createElement("input", xt({
      autoComplete: n
    }, be, {
      onChange: ie,
      onFocus: ge,
      onBlur: me,
      onKeyDown: se,
      onKeyUp: le,
      className: Ee(u, oe({}, "".concat(u, "-disabled"), d), w == null ? void 0 : w.input),
      style: C == null ? void 0 : C.input,
      ref: N,
      size: f,
      type: _,
      onCompositionStart: function(Ve) {
        k.current = !0, x == null || x(Ve);
      },
      onCompositionEnd: W
    }));
  }, Ae = function() {
    var be = Number(K) > 0;
    if (g || J.show) {
      var Ie = J.showFormatter ? J.showFormatter({
        value: Y,
        count: ee,
        maxLength: K
      }) : "".concat(ee).concat(be ? " / ".concat(K) : "");
      return /* @__PURE__ */ j.createElement(j.Fragment, null, J.show && /* @__PURE__ */ j.createElement("span", {
        className: Ee("".concat(u, "-show-count-suffix"), oe({}, "".concat(u, "-show-count-has-suffix"), !!g), w == null ? void 0 : w.count),
        style: ae({}, C == null ? void 0 : C.count)
      }, Ie), g);
    }
    return null;
  };
  return /* @__PURE__ */ j.createElement(tC, xt({}, E, {
    prefixCls: u,
    className: Ee(h, Te),
    handleReset: pe,
    value: Y,
    focused: O,
    triggerFocus: z,
    suffix: Ae(),
    disabled: d,
    classes: b,
    classNames: w,
    styles: C
  }), de());
});
const yFe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BaseInput: tC,
  default: _ee
}, Symbol.toStringTag, { value: "Module" }));
function bFe(e, t) {
  return typeof Proxy < "u" && e ? new Proxy(e, {
    get: function(r, i) {
      if (t[i])
        return t[i];
      var o = r[i];
      return typeof o == "function" ? o.bind(r) : o;
    }
  }) : e;
}
function _Fe(e, t) {
  var n = $e(null);
  function r() {
    try {
      var o = e.selectionStart, a = e.selectionEnd, s = e.value, c = s.substring(0, o), l = s.substring(a);
      n.current = {
        start: o,
        end: a,
        value: s,
        beforeTxt: c,
        afterTxt: l
      };
    } catch {
    }
  }
  function i() {
    if (e && n.current && t)
      try {
        var o = e.value, a = n.current, s = a.beforeTxt, c = a.afterTxt, l = a.start, u = o.length;
        if (o.startsWith(s))
          u = s.length;
        else if (o.endsWith(c))
          u = o.length - n.current.afterTxt.length;
        else {
          var d = s[l - 1], f = o.indexOf(d, l - 1);
          f !== -1 && (u = f + 1);
        }
        e.setSelectionRange(u, u);
      } catch (h) {
        sn(!1, "Something warning of cursor restore. Please fire issue about this: ".concat(h.message));
      }
  }
  return [r, i];
}
var SFe = function() {
  var t = Qe(!1), n = he(t, 2), r = n[0], i = n[1];
  return ar(function() {
    i(FM());
  }, []), r;
}, wFe = 200, xFe = 600;
function EFe(e) {
  var t = e.prefixCls, n = e.upNode, r = e.downNode, i = e.upDisabled, o = e.downDisabled, a = e.onStep, s = $.useRef(), c = $.useRef([]), l = $.useRef();
  l.current = a;
  var u = function() {
    clearTimeout(s.current);
  }, d = function(_, b) {
    _.preventDefault(), u(), l.current(b);
    function w() {
      l.current(b), s.current = setTimeout(w, wFe);
    }
    s.current = setTimeout(w, xFe);
  };
  $.useEffect(function() {
    return function() {
      u(), c.current.forEach(function(y) {
        return Ln.cancel(y);
      });
    };
  }, []);
  var f = SFe();
  if (f)
    return null;
  var h = "".concat(t, "-handler"), p = Ee(h, "".concat(h, "-up"), oe({}, "".concat(h, "-up-disabled"), i)), g = Ee(h, "".concat(h, "-down"), oe({}, "".concat(h, "-down-disabled"), o)), m = function() {
    return c.current.push(Ln(u));
  }, v = {
    unselectable: "on",
    role: "button",
    onMouseUp: m,
    onMouseLeave: m
  };
  return /* @__PURE__ */ $.createElement("div", {
    className: "".concat(h, "-wrap")
  }, /* @__PURE__ */ $.createElement("span", xt({}, v, {
    onMouseDown: function(_) {
      d(_, !0);
    },
    "aria-label": "Increase Value",
    "aria-disabled": i,
    className: p
  }), n || /* @__PURE__ */ $.createElement("span", {
    unselectable: "on",
    className: "".concat(t, "-handler-up-inner")
  })), /* @__PURE__ */ $.createElement("span", xt({}, v, {
    onMouseDown: function(_) {
      d(_, !1);
    },
    "aria-label": "Decrease Value",
    "aria-disabled": o,
    className: g
  }), r || /* @__PURE__ */ $.createElement("span", {
    unselectable: "on",
    className: "".concat(t, "-handler-down-inner")
  })));
}
function VF(e) {
  var t = typeof e == "number" ? eC(e) : Zd(e).fullStr, n = t.includes(".");
  return n ? Zd(t.replace(/(\d)\.(\d)/g, "$1$2.")).fullStr : e + "0";
}
const CFe = function() {
  var e = $e(0), t = function() {
    Ln.cancel(e.current);
  };
  return ot(function() {
    return t;
  }, []), function(n) {
    t(), e.current = Ln(function() {
      n();
    });
  };
};
var TFe = ["prefixCls", "className", "style", "min", "max", "step", "defaultValue", "value", "disabled", "readOnly", "upHandler", "downHandler", "keyboard", "changeOnWheel", "controls", "classNames", "stringMode", "parser", "formatter", "precision", "decimalSeparator", "onChange", "onInput", "onPressEnter", "onStep", "changeOnBlur", "domRef"], IFe = ["disabled", "style", "prefixCls", "value", "prefix", "suffix", "addonBefore", "addonAfter", "className", "classNames"], BF = function(t, n) {
  return t || n.isEmpty() ? n.toString() : n.toNumber();
}, zF = function(t) {
  var n = cs(t);
  return n.isInvalidate() ? null : n;
}, $Fe = /* @__PURE__ */ $.forwardRef(function(e, t) {
  var n = e.prefixCls, r = e.className, i = e.style, o = e.min, a = e.max, s = e.step, c = s === void 0 ? 1 : s, l = e.defaultValue, u = e.value, d = e.disabled, f = e.readOnly, h = e.upHandler, p = e.downHandler, g = e.keyboard, m = e.changeOnWheel, v = m === void 0 ? !1 : m, y = e.controls, _ = y === void 0 ? !0 : y;
  e.classNames;
  var b = e.stringMode, w = e.parser, C = e.formatter, x = e.precision, T = e.decimalSeparator, E = e.onChange, R = e.onInput, I = e.onPressEnter, O = e.onStep, P = e.changeOnBlur, k = P === void 0 ? !0 : P, L = e.domRef, N = En(e, TFe), D = "".concat(n, "-input"), z = $.useRef(null), V = $.useState(!1), B = he(V, 2), U = B[0], Q = B[1], Y = $.useRef(!1), q = $.useRef(!1), X = $.useRef(!1), ne = $.useState(function() {
    return cs(u ?? l);
  }), Z = he(ne, 2), J = Z[0], K = Z[1];
  function ee(nt) {
    u === void 0 && K(nt);
  }
  var te = $.useCallback(function(nt, Be) {
    if (!Be)
      return x >= 0 ? x : Math.max(Ld(nt), Ld(c));
  }, [x, c]), H = $.useCallback(function(nt) {
    var Be = String(nt);
    if (w)
      return w(Be);
    var st = Be;
    return T && (st = st.replace(T, ".")), st.replace(/[^\w.-]+/g, "");
  }, [w, T]), ie = $.useRef(""), W = $.useCallback(function(nt, Be) {
    if (C)
      return C(nt, {
        userTyping: Be,
        input: String(ie.current)
      });
    var st = typeof nt == "number" ? eC(nt) : nt;
    if (!Be) {
      var pt = te(st, Be);
      if (e3(st) && (T || pt >= 0)) {
        var Et = T || ".";
        st = b_(st, Et, pt);
      }
    }
    return st;
  }, [C, te, T]), se = $.useState(function() {
    var nt = l ?? u;
    return J.isInvalidate() && ["string", "number"].includes(It(nt)) ? Number.isNaN(nt) ? "" : nt : W(J.toString(), !1);
  }), le = he(se, 2), ge = le[0], me = le[1];
  ie.current = ge;
  function pe(nt, Be) {
    me(W(
      // Invalidate number is sometime passed by external control, we should let it go
      // Otherwise is controlled by internal interactive logic which check by userTyping
      // You can ref 'show limited value when input is not focused' test for more info.
      nt.isInvalidate() ? nt.toString(!1) : nt.toString(!Be),
      Be
    ));
  }
  var Te = $.useMemo(function() {
    return zF(a);
  }, [a, x]), de = $.useMemo(function() {
    return zF(o);
  }, [o, x]), Ae = $.useMemo(function() {
    return !Te || !J || J.isInvalidate() ? !1 : Te.lessEquals(J);
  }, [Te, J]), ue = $.useMemo(function() {
    return !de || !J || J.isInvalidate() ? !1 : J.lessEquals(de);
  }, [de, J]), be = _Fe(z.current, U), Ie = he(be, 2), Ve = Ie[0], ze = Ie[1], Ne = function(Be) {
    return Te && !Be.lessEquals(Te) ? Te : de && !de.lessEquals(Be) ? de : null;
  }, lt = function(Be) {
    return !Ne(Be);
  }, mt = function(Be, st) {
    var pt = Be, Et = lt(pt) || pt.isEmpty();
    if (!pt.isEmpty() && !st && (pt = Ne(pt) || pt, Et = !0), !f && !d && Et) {
      var Ke = pt.toString(), rt = te(Ke, st);
      return rt >= 0 && (pt = cs(b_(Ke, ".", rt)), lt(pt) || (pt = cs(b_(Ke, ".", rt, !0)))), pt.equals(J) || (ee(pt), E == null || E(pt.isEmpty() ? null : BF(b, pt)), u === void 0 && pe(pt, st)), pt;
    }
    return J;
  }, vt = CFe(), ke = function nt(Be) {
    if (Ve(), ie.current = Be, me(Be), !q.current) {
      var st = H(Be), pt = cs(st);
      pt.isNaN() || mt(pt, !0);
    }
    R == null || R(Be), vt(function() {
      var Et = Be;
      w || (Et = Be.replace(/。/g, ".")), Et !== Be && nt(Et);
    });
  }, xe = function() {
    q.current = !0;
  }, Re = function() {
    q.current = !1, ke(z.current.value);
  }, yt = function(Be) {
    ke(Be.target.value);
  }, Pt = function(Be) {
    var st;
    if (!(Be && Ae || !Be && ue)) {
      Y.current = !1;
      var pt = cs(X.current ? VF(c) : c);
      Be || (pt = pt.negate());
      var Et = (J || cs(0)).add(pt.toString()), Ke = mt(Et, !1);
      O == null || O(BF(b, Ke), {
        offset: X.current ? VF(c) : c,
        type: Be ? "up" : "down"
      }), (st = z.current) === null || st === void 0 || st.focus();
    }
  }, _t = function(Be) {
    var st = cs(H(ge)), pt;
    st.isNaN() ? pt = mt(J, Be) : pt = mt(st, Be), u !== void 0 ? pe(J, !1) : pt.isNaN() || pe(pt, !1);
  }, St = function() {
    Y.current = !0;
  }, ft = function(Be) {
    var st = Be.key, pt = Be.shiftKey;
    Y.current = !0, X.current = pt, st === "Enter" && (q.current || (Y.current = !1), _t(!1), I == null || I(Be)), g !== !1 && !q.current && ["Up", "ArrowUp", "Down", "ArrowDown"].includes(st) && (Pt(st === "Up" || st === "ArrowUp"), Be.preventDefault());
  }, kn = function() {
    Y.current = !1, X.current = !1;
  };
  $.useEffect(function() {
    if (v && U) {
      var nt = function(pt) {
        Pt(pt.deltaY < 0), pt.preventDefault();
      }, Be = z.current;
      if (Be)
        return Be.addEventListener("wheel", nt, {
          passive: !1
        }), function() {
          return Be.removeEventListener("wheel", nt);
        };
    }
  });
  var Dt = function() {
    k && _t(!1), Q(!1), Y.current = !1;
  };
  return B0(function() {
    J.isInvalidate() || pe(J, !1);
  }, [x, C]), B0(function() {
    var nt = cs(u);
    K(nt);
    var Be = cs(H(ge));
    (!nt.equals(Be) || !Y.current || C) && pe(nt, Y.current);
  }, [u]), B0(function() {
    C && ze();
  }, [ge]), /* @__PURE__ */ $.createElement("div", {
    ref: L,
    className: Ee(n, r, oe(oe(oe(oe(oe({}, "".concat(n, "-focused"), U), "".concat(n, "-disabled"), d), "".concat(n, "-readonly"), f), "".concat(n, "-not-a-number"), J.isNaN()), "".concat(n, "-out-of-range"), !J.isInvalidate() && !lt(J))),
    style: i,
    onFocus: function() {
      Q(!0);
    },
    onBlur: Dt,
    onKeyDown: ft,
    onKeyUp: kn,
    onCompositionStart: xe,
    onCompositionEnd: Re,
    onBeforeInput: St
  }, _ && /* @__PURE__ */ $.createElement(EFe, {
    prefixCls: n,
    upNode: h,
    downNode: p,
    upDisabled: Ae,
    downDisabled: ue,
    onStep: Pt
  }), /* @__PURE__ */ $.createElement("div", {
    className: "".concat(D, "-wrap")
  }, /* @__PURE__ */ $.createElement("input", xt({
    autoComplete: "off",
    role: "spinbutton",
    "aria-valuemin": o,
    "aria-valuemax": a,
    "aria-valuenow": J.isInvalidate() ? null : J.toString(),
    step: c
  }, N, {
    ref: Ja(z, t),
    className: D,
    value: ge,
    onChange: yt,
    disabled: d,
    readOnly: f
  }))));
}), See = /* @__PURE__ */ $.forwardRef(function(e, t) {
  var n = e.disabled, r = e.style, i = e.prefixCls, o = i === void 0 ? "rc-input-number" : i, a = e.value, s = e.prefix, c = e.suffix, l = e.addonBefore, u = e.addonAfter, d = e.className, f = e.classNames, h = En(e, IFe), p = $.useRef(null), g = $.useRef(null), m = $.useRef(null), v = function(_) {
    m.current && t3(m.current, _);
  };
  return $.useImperativeHandle(t, function() {
    return bFe(m.current, {
      focus: v,
      nativeElement: p.current.nativeElement || g.current
    });
  }), /* @__PURE__ */ $.createElement(tC, {
    className: d,
    triggerFocus: v,
    prefixCls: o,
    value: a,
    disabled: n,
    style: r,
    prefix: s,
    suffix: c,
    addonAfter: u,
    addonBefore: l,
    classNames: f,
    components: {
      affixWrapper: "div",
      groupWrapper: "div",
      wrapper: "div",
      groupAddon: "div"
    },
    ref: p
  }, /* @__PURE__ */ $.createElement($Fe, xt({
    prefixCls: o,
    disabled: n,
    ref: m,
    domRef: g,
    className: f == null ? void 0 : f.input
  }, h)));
});
process.env.NODE_ENV !== "production" && (See.displayName = "InputNumber");
const AFe = (e) => {
  var t;
  const n = (t = e.handleVisible) !== null && t !== void 0 ? t : "auto";
  return Object.assign(Object.assign({}, XM(e)), {
    controlWidth: 90,
    handleWidth: e.controlHeightSM - e.lineWidth * 2,
    handleFontSize: e.fontSize / 2,
    handleVisible: n,
    handleActiveBg: e.colorFillAlter,
    handleBg: e.colorBgContainer,
    filledHandleBg: new Mn(e.colorFillSecondary).onBackground(e.colorBgContainer).toHexString(),
    handleHoverColor: e.colorPrimary,
    handleBorderColor: e.colorBorder,
    handleOpacity: n === !0 ? 1 : 0
  });
}, HF = (e, t) => {
  let {
    componentCls: n,
    borderRadiusSM: r,
    borderRadiusLG: i
  } = e;
  const o = t === "lg" ? i : r;
  return {
    [`&-${t}`]: {
      [`${n}-handler-wrap`]: {
        borderStartEndRadius: o,
        borderEndEndRadius: o
      },
      [`${n}-handler-up`]: {
        borderStartEndRadius: o
      },
      [`${n}-handler-down`]: {
        borderEndEndRadius: o
      }
    }
  };
}, RFe = (e) => {
  const {
    componentCls: t,
    lineWidth: n,
    lineType: r,
    borderRadius: i,
    inputFontSizeSM: o,
    inputFontSizeLG: a,
    controlHeightLG: s,
    controlHeightSM: c,
    colorError: l,
    paddingInlineSM: u,
    paddingBlockSM: d,
    paddingBlockLG: f,
    paddingInlineLG: h,
    colorTextDescription: p,
    motionDurationMid: g,
    handleHoverColor: m,
    handleOpacity: v,
    paddingInline: y,
    paddingBlock: _,
    handleBg: b,
    handleActiveBg: w,
    colorTextDisabled: C,
    borderRadiusSM: x,
    borderRadiusLG: T,
    controlWidth: E,
    handleBorderColor: R,
    filledHandleBg: I,
    lineHeightLG: O,
    calc: P
  } = e;
  return [
    {
      [t]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, _a(e)), ZE(e)), {
        display: "inline-block",
        width: E,
        margin: 0,
        padding: 0,
        borderRadius: i
      }), aee(e, {
        [`${t}-handler-wrap`]: {
          background: b,
          [`${t}-handler-down`]: {
            borderBlockStart: `${et(n)} ${r} ${R}`
          }
        }
      })), uee(e, {
        [`${t}-handler-wrap`]: {
          background: I,
          [`${t}-handler-down`]: {
            borderBlockStart: `${et(n)} ${r} ${R}`
          }
        },
        "&:focus-within": {
          [`${t}-handler-wrap`]: {
            background: b
          }
        }
      })), cee(e)), {
        "&-rtl": {
          direction: "rtl",
          [`${t}-input`]: {
            direction: "rtl"
          }
        },
        "&-lg": {
          padding: 0,
          fontSize: a,
          lineHeight: O,
          borderRadius: T,
          [`input${t}-input`]: {
            height: P(s).sub(P(n).mul(2)).equal(),
            padding: `${et(f)} ${et(h)}`
          }
        },
        "&-sm": {
          padding: 0,
          fontSize: o,
          borderRadius: x,
          [`input${t}-input`]: {
            height: P(c).sub(P(n).mul(2)).equal(),
            padding: `${et(d)} ${et(u)}`
          }
        },
        // ===================== Out Of Range =====================
        "&-out-of-range": {
          [`${t}-input-wrap`]: {
            input: {
              color: l
            }
          }
        },
        // Style for input-group: input with label, with button or dropdown...
        "&-group": Object.assign(Object.assign(Object.assign({}, _a(e)), pee(e)), {
          "&-wrapper": Object.assign(Object.assign(Object.assign({
            display: "inline-block",
            textAlign: "start",
            verticalAlign: "top",
            [`${t}-affix-wrapper`]: {
              width: "100%"
            },
            // Size
            "&-lg": {
              [`${t}-group-addon`]: {
                borderRadius: T,
                fontSize: e.fontSizeLG
              }
            },
            "&-sm": {
              [`${t}-group-addon`]: {
                borderRadius: x
              }
            }
          }, see(e)), dee(e)), {
            // Fix the issue of using icons in Space Compact mode
            // https://github.com/ant-design/ant-design/issues/45764
            [`&:not(${t}-compact-first-item):not(${t}-compact-last-item)${t}-compact-item`]: {
              [`${t}, ${t}-group-addon`]: {
                borderRadius: 0
              }
            },
            [`&:not(${t}-compact-last-item)${t}-compact-first-item`]: {
              [`${t}, ${t}-group-addon`]: {
                borderStartEndRadius: 0,
                borderEndEndRadius: 0
              }
            },
            [`&:not(${t}-compact-first-item)${t}-compact-last-item`]: {
              [`${t}, ${t}-group-addon`]: {
                borderStartStartRadius: 0,
                borderEndStartRadius: 0
              }
            }
          })
        }),
        [`&-disabled ${t}-input`]: {
          cursor: "not-allowed"
        },
        [t]: {
          "&-input": Object.assign(Object.assign(Object.assign(Object.assign({}, _a(e)), {
            width: "100%",
            padding: `${et(_)} ${et(y)}`,
            textAlign: "start",
            backgroundColor: "transparent",
            border: 0,
            borderRadius: i,
            outline: 0,
            transition: `all ${g} linear`,
            appearance: "textfield",
            fontSize: "inherit"
          }), fee(e.colorTextPlaceholder)), {
            '&[type="number"]::-webkit-inner-spin-button, &[type="number"]::-webkit-outer-spin-button': {
              margin: 0,
              webkitAppearance: "none",
              appearance: "none"
            }
          })
        },
        [`&:hover ${t}-handler-wrap, &-focused ${t}-handler-wrap`]: {
          width: e.handleWidth,
          opacity: 1
        }
      })
    },
    // Handler
    {
      [t]: Object.assign(Object.assign(Object.assign({
        [`${t}-handler-wrap`]: {
          position: "absolute",
          insetBlockStart: 0,
          insetInlineEnd: 0,
          width: 0,
          opacity: v,
          height: "100%",
          borderStartStartRadius: 0,
          borderStartEndRadius: i,
          borderEndEndRadius: i,
          borderEndStartRadius: 0,
          display: "flex",
          flexDirection: "column",
          alignItems: "stretch",
          transition: `all ${g}`,
          overflow: "hidden",
          // Fix input number inside Menu makes icon too large
          // We arise the selector priority by nest selector here
          // https://github.com/ant-design/ant-design/issues/14367
          [`${t}-handler`]: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flex: "auto",
            height: "40%",
            [`
              ${t}-handler-up-inner,
              ${t}-handler-down-inner
            `]: {
              marginInlineEnd: 0,
              fontSize: e.handleFontSize
            }
          }
        },
        [`${t}-handler`]: {
          height: "50%",
          overflow: "hidden",
          color: p,
          fontWeight: "bold",
          lineHeight: 0,
          textAlign: "center",
          cursor: "pointer",
          borderInlineStart: `${et(n)} ${r} ${R}`,
          transition: `all ${g} linear`,
          "&:active": {
            background: w
          },
          // Hover
          "&:hover": {
            height: "60%",
            [`
              ${t}-handler-up-inner,
              ${t}-handler-down-inner
            `]: {
              color: m
            }
          },
          "&-up-inner, &-down-inner": Object.assign(Object.assign({}, LE()), {
            color: p,
            transition: `all ${g} linear`,
            userSelect: "none"
          })
        },
        [`${t}-handler-up`]: {
          borderStartEndRadius: i
        },
        [`${t}-handler-down`]: {
          borderEndEndRadius: i
        }
      }, HF(e, "lg")), HF(e, "sm")), {
        // Disabled
        "&-disabled, &-readonly": {
          [`${t}-handler-wrap`]: {
            display: "none"
          },
          [`${t}-input`]: {
            color: "inherit"
          }
        },
        [`
          ${t}-handler-up-disabled,
          ${t}-handler-down-disabled
        `]: {
          cursor: "not-allowed"
        },
        [`
          ${t}-handler-up-disabled:hover &-handler-up-inner,
          ${t}-handler-down-disabled:hover &-handler-down-inner
        `]: {
          color: C
        }
      })
    }
  ];
}, PFe = (e) => {
  const {
    componentCls: t,
    paddingBlock: n,
    paddingInline: r,
    inputAffixPadding: i,
    controlWidth: o,
    borderRadiusLG: a,
    borderRadiusSM: s,
    paddingInlineLG: c,
    paddingInlineSM: l,
    paddingBlockLG: u,
    paddingBlockSM: d,
    motionDurationMid: f
  } = e;
  return {
    [`${t}-affix-wrapper`]: Object.assign(Object.assign({
      [`input${t}-input`]: {
        padding: `${et(n)} 0`
      }
    }, ZE(e)), {
      // or number handler will cover form status
      position: "relative",
      display: "inline-flex",
      alignItems: "center",
      width: o,
      padding: 0,
      paddingInlineStart: r,
      "&-lg": {
        borderRadius: a,
        paddingInlineStart: c,
        [`input${t}-input`]: {
          padding: `${et(u)} 0`
        }
      },
      "&-sm": {
        borderRadius: s,
        paddingInlineStart: l,
        [`input${t}-input`]: {
          padding: `${et(d)} 0`
        }
      },
      [`&:not(${t}-disabled):hover`]: {
        zIndex: 1
      },
      "&-focused, &:focus": {
        zIndex: 1
      },
      [`&-disabled > ${t}-disabled`]: {
        background: "transparent"
      },
      [`> div${t}`]: {
        width: "100%",
        border: "none",
        outline: "none",
        [`&${t}-focused`]: {
          boxShadow: "none !important"
        }
      },
      "&::before": {
        display: "inline-block",
        width: 0,
        visibility: "hidden",
        content: '"\\a0"'
      },
      [`${t}-handler-wrap`]: {
        zIndex: 2
      },
      [t]: {
        position: "static",
        color: "inherit",
        "&-prefix, &-suffix": {
          display: "flex",
          flex: "none",
          alignItems: "center",
          pointerEvents: "none"
        },
        "&-prefix": {
          marginInlineEnd: i
        },
        "&-suffix": {
          insetBlockStart: 0,
          insetInlineEnd: 0,
          height: "100%",
          marginInlineEnd: r,
          marginInlineStart: i,
          transition: `margin ${f}`
        }
      },
      [`&:hover ${t}-handler-wrap, &-focused ${t}-handler-wrap`]: {
        width: e.handleWidth,
        opacity: 1
      },
      [`&:not(${t}-affix-wrapper-without-controls):hover ${t}-suffix`]: {
        marginInlineEnd: e.calc(e.handleWidth).add(r).equal()
      }
    })
  };
}, OFe = Za("InputNumber", (e) => {
  const t = Mr(e, YM(e));
  return [
    RFe(t),
    PFe(t),
    // =====================================================
    // ==             Space Compact                       ==
    // =====================================================
    qE(t)
  ];
}, AFe, {
  unitless: {
    handleOpacity: !0
  }
});
var MFe = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
const wee = /* @__PURE__ */ $.forwardRef((e, t) => {
  if (process.env.NODE_ENV !== "production") {
    const J = di("InputNumber");
    J.deprecated(!("bordered" in e), "bordered", "variant"), J(!(e.type === "number" && e.changeOnWheel), "usage", "When `type=number` is used together with `changeOnWheel`, changeOnWheel may not work properly. Please delete `type=number` if it is not necessary.");
  }
  const {
    getPrefixCls: n,
    direction: r
  } = $.useContext(Cn), i = $.useRef(null);
  $.useImperativeHandle(t, () => i.current);
  const {
    className: o,
    rootClassName: a,
    size: s,
    disabled: c,
    prefixCls: l,
    addonBefore: u,
    addonAfter: d,
    prefix: f,
    suffix: h,
    bordered: p,
    readOnly: g,
    status: m,
    controls: v,
    variant: y
  } = e, _ = MFe(e, ["className", "rootClassName", "size", "disabled", "prefixCls", "addonBefore", "addonAfter", "prefix", "suffix", "bordered", "readOnly", "status", "controls", "variant"]), b = n("input-number", l), w = Wf(b), [C, x, T] = OFe(b, w), {
    compactSize: E,
    compactItemClassnames: R
  } = Ry(b, r);
  let I = /* @__PURE__ */ $.createElement(vee, {
    className: `${b}-handler-up-inner`
  }), O = /* @__PURE__ */ $.createElement(GM, {
    className: `${b}-handler-down-inner`
  });
  const P = typeof v == "boolean" ? v : void 0;
  typeof v == "object" && (I = typeof v.upIcon > "u" ? I : /* @__PURE__ */ $.createElement("span", {
    className: `${b}-handler-up-inner`
  }, v.upIcon), O = typeof v.downIcon > "u" ? O : /* @__PURE__ */ $.createElement("span", {
    className: `${b}-handler-down-inner`
  }, v.downIcon));
  const {
    hasFeedback: k,
    status: L,
    isFormItemInput: N,
    feedbackIcon: D
  } = $.useContext(As), z = ky(L, m), V = Gf((J) => {
    var K;
    return (K = s ?? E) !== null && K !== void 0 ? K : J;
  }), B = $.useContext(id), U = c ?? B, [Q, Y] = JE("inputNumber", y, p), q = k && /* @__PURE__ */ $.createElement($.Fragment, null, D), X = Ee({
    [`${b}-lg`]: V === "large",
    [`${b}-sm`]: V === "small",
    [`${b}-rtl`]: r === "rtl",
    [`${b}-in-form-item`]: N
  }, x), ne = `${b}-group`, Z = /* @__PURE__ */ $.createElement(See, Object.assign({
    ref: i,
    disabled: U,
    className: Ee(T, w, o, a, R),
    upHandler: I,
    downHandler: O,
    prefixCls: b,
    readOnly: g,
    controls: P,
    prefix: f,
    suffix: q || h,
    addonBefore: u && /* @__PURE__ */ $.createElement(Pv, {
      form: !0,
      space: !0
    }, u),
    addonAfter: d && /* @__PURE__ */ $.createElement(Pv, {
      form: !0,
      space: !0
    }, d),
    classNames: {
      input: X,
      variant: Ee({
        [`${b}-${Q}`]: Y
      }, ep(b, z, k)),
      affixWrapper: Ee({
        [`${b}-affix-wrapper-sm`]: V === "small",
        [`${b}-affix-wrapper-lg`]: V === "large",
        [`${b}-affix-wrapper-rtl`]: r === "rtl",
        [`${b}-affix-wrapper-without-controls`]: v === !1
      }, x),
      wrapper: Ee({
        [`${ne}-rtl`]: r === "rtl"
      }, x),
      groupWrapper: Ee({
        [`${b}-group-wrapper-sm`]: V === "small",
        [`${b}-group-wrapper-lg`]: V === "large",
        [`${b}-group-wrapper-rtl`]: r === "rtl",
        [`${b}-group-wrapper-${Q}`]: Y
      }, ep(`${b}-group-wrapper`, z, k), x)
    }
  }, _));
  return C(Z);
}), n3 = wee, kFe = (e) => /* @__PURE__ */ $.createElement(go, {
  theme: {
    components: {
      InputNumber: {
        handleVisible: !0
      }
    }
  }
}, /* @__PURE__ */ $.createElement(wee, Object.assign({}, e)));
process.env.NODE_ENV !== "production" && (n3.displayName = "InputNumber");
n3._InternalPanelDoNotUseOrYouWillBeFired = kFe;
const NFe = n3, DFe = (e) => {
  const {
    getPrefixCls: t,
    direction: n
  } = gt(Cn), {
    prefixCls: r,
    className: i
  } = e, o = t("input-group", r), a = t("input"), [s, c] = JM(a), l = Ee(o, {
    [`${o}-lg`]: e.size === "large",
    [`${o}-sm`]: e.size === "small",
    [`${o}-compact`]: e.compact,
    [`${o}-rtl`]: n === "rtl"
  }, c, i), u = gt(As), d = Tt(() => Object.assign(Object.assign({}, u), {
    isFormItemInput: !1
  }), [u]);
  return process.env.NODE_ENV !== "production" && di("Input.Group").deprecated(!1, "Input.Group", "Space.Compact"), s(/* @__PURE__ */ $.createElement("span", {
    className: l,
    style: e.style,
    onMouseEnter: e.onMouseEnter,
    onMouseLeave: e.onMouseLeave,
    onFocus: e.onFocus,
    onBlur: e.onBlur
  }, /* @__PURE__ */ $.createElement(As.Provider, {
    value: d
  }, e.children)));
}, jFe = DFe, LFe = (e) => {
  let t;
  return typeof e == "object" && (e != null && e.clearIcon) ? t = e : e && (t = {
    clearIcon: /* @__PURE__ */ j.createElement(BE, null)
  }), t;
}, xee = LFe;
function Eee(e, t) {
  const n = $e([]), r = () => {
    n.current.push(setTimeout(() => {
      var i, o, a, s;
      !((i = e.current) === null || i === void 0) && i.input && ((o = e.current) === null || o === void 0 ? void 0 : o.input.getAttribute("type")) === "password" && (!((a = e.current) === null || a === void 0) && a.input.hasAttribute("value")) && ((s = e.current) === null || s === void 0 || s.input.removeAttribute("value"));
    }));
  };
  return ot(() => (t && r(), () => n.current.forEach((i) => {
    i && clearTimeout(i);
  })), []), r;
}
function FFe(e) {
  return !!(e.prefix || e.suffix || e.allowClear || e.showCount);
}
var VFe = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
const Cee = /* @__PURE__ */ ia((e, t) => {
  var n;
  const {
    prefixCls: r,
    bordered: i = !0,
    status: o,
    size: a,
    disabled: s,
    onBlur: c,
    onFocus: l,
    suffix: u,
    allowClear: d,
    addonAfter: f,
    addonBefore: h,
    className: p,
    style: g,
    styles: m,
    rootClassName: v,
    onChange: y,
    classNames: _,
    variant: b
  } = e, w = VFe(e, ["prefixCls", "bordered", "status", "size", "disabled", "onBlur", "onFocus", "suffix", "allowClear", "addonAfter", "addonBefore", "className", "style", "styles", "rootClassName", "onChange", "classNames", "variant"]);
  if (process.env.NODE_ENV !== "production") {
    const {
      deprecated: W
    } = di("Input");
    W(!("bordered" in e), "bordered", "variant");
  }
  const {
    getPrefixCls: C,
    direction: x,
    input: T
  } = j.useContext(Cn), E = C("input", r), R = $e(null), I = Wf(E), [O, P, k] = JM(E, I), {
    compactSize: L,
    compactItemClassnames: N
  } = Ry(E, x), D = Gf((W) => {
    var se;
    return (se = a ?? L) !== null && se !== void 0 ? se : W;
  }), z = j.useContext(id), V = s ?? z, {
    status: B,
    hasFeedback: U,
    feedbackIcon: Q
  } = gt(As), Y = ky(B, o), q = FFe(e) || !!U, X = $e(q);
  if (process.env.NODE_ENV !== "production") {
    const W = di("Input");
    ot(() => {
      var se;
      q && !X.current && process.env.NODE_ENV !== "production" && W(document.activeElement === ((se = R.current) === null || se === void 0 ? void 0 : se.input), "usage", "When Input is focused, dynamic add or remove prefix / suffix will make it lose focus caused by dom structure change. Read more: https://ant.design/components/input/#FAQ"), X.current = q;
    }, [q]);
  }
  const ne = Eee(R, !0), Z = (W) => {
    ne(), c == null || c(W);
  }, J = (W) => {
    ne(), l == null || l(W);
  }, K = (W) => {
    ne(), y == null || y(W);
  }, ee = (U || u) && /* @__PURE__ */ j.createElement(j.Fragment, null, u, U && Q), te = xee(d ?? (T == null ? void 0 : T.allowClear)), [H, ie] = JE("input", b, i);
  return O(/* @__PURE__ */ j.createElement(_ee, Object.assign({
    ref: Ja(t, R),
    prefixCls: E,
    autoComplete: T == null ? void 0 : T.autoComplete
  }, w, {
    disabled: V,
    onBlur: Z,
    onFocus: J,
    style: Object.assign(Object.assign({}, T == null ? void 0 : T.style), g),
    styles: Object.assign(Object.assign({}, T == null ? void 0 : T.styles), m),
    suffix: ee,
    allowClear: te,
    className: Ee(p, v, k, I, N, T == null ? void 0 : T.className),
    onChange: K,
    addonBefore: h && /* @__PURE__ */ j.createElement(Pv, {
      form: !0,
      space: !0
    }, h),
    addonAfter: f && /* @__PURE__ */ j.createElement(Pv, {
      form: !0,
      space: !0
    }, f),
    classNames: Object.assign(Object.assign(Object.assign({}, _), T == null ? void 0 : T.classNames), {
      input: Ee({
        [`${E}-sm`]: D === "small",
        [`${E}-lg`]: D === "large",
        [`${E}-rtl`]: x === "rtl"
      }, _ == null ? void 0 : _.input, (n = T == null ? void 0 : T.classNames) === null || n === void 0 ? void 0 : n.input, P),
      variant: Ee({
        [`${E}-${H}`]: ie
      }, ep(E, Y)),
      affixWrapper: Ee({
        [`${E}-affix-wrapper-sm`]: D === "small",
        [`${E}-affix-wrapper-lg`]: D === "large",
        [`${E}-affix-wrapper-rtl`]: x === "rtl"
      }, P),
      wrapper: Ee({
        [`${E}-group-rtl`]: x === "rtl"
      }, P),
      groupWrapper: Ee({
        [`${E}-group-wrapper-sm`]: D === "small",
        [`${E}-group-wrapper-lg`]: D === "large",
        [`${E}-group-wrapper-rtl`]: x === "rtl",
        [`${E}-group-wrapper-${H}`]: ie
      }, ep(`${E}-group-wrapper`, Y, U), P)
    })
  })));
});
process.env.NODE_ENV !== "production" && (Cee.displayName = "Input");
const nC = Cee, BFe = (e) => {
  const {
    componentCls: t,
    paddingXS: n
  } = e;
  return {
    [t]: {
      display: "inline-flex",
      alignItems: "center",
      flexWrap: "nowrap",
      columnGap: n,
      "&-rtl": {
        direction: "rtl"
      },
      [`${t}-input`]: {
        textAlign: "center",
        paddingInline: e.paddingXXS
      },
      // ================= Size =================
      [`&${t}-sm ${t}-input`]: {
        paddingInline: e.calc(e.paddingXXS).div(2).equal()
      },
      [`&${t}-lg ${t}-input`]: {
        paddingInline: e.paddingXS
      }
    }
  };
}, zFe = Za(["Input", "OTP"], (e) => {
  const t = Mr(e, YM(e));
  return [BFe(t)];
}, XM);
var HFe = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
const UFe = /* @__PURE__ */ $.forwardRef((e, t) => {
  const {
    value: n,
    onChange: r,
    onActiveChange: i,
    index: o,
    mask: a
  } = e, s = HFe(e, ["value", "onChange", "onActiveChange", "index", "mask"]), c = n && typeof a == "string" ? a : n, l = (p) => {
    r(o, p.target.value);
  }, u = $.useRef(null);
  $.useImperativeHandle(t, () => u.current);
  const d = () => {
    Ln(() => {
      var p;
      const g = (p = u.current) === null || p === void 0 ? void 0 : p.input;
      document.activeElement === g && g && g.select();
    });
  }, f = (p) => {
    const {
      key: g,
      ctrlKey: m,
      metaKey: v
    } = p;
    g === "ArrowLeft" ? i(o - 1) : g === "ArrowRight" ? i(o + 1) : g === "z" && (m || v) && p.preventDefault(), d();
  }, h = (p) => {
    p.key === "Backspace" && !n && i(o - 1), d();
  };
  return /* @__PURE__ */ $.createElement(nC, Object.assign({
    type: a === !0 ? "password" : "text"
  }, s, {
    ref: u,
    value: c,
    onInput: l,
    onFocus: d,
    onKeyDown: f,
    onKeyUp: h,
    onMouseDown: d,
    onMouseUp: d
  }));
}), WFe = UFe;
var qFe = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
function y1(e) {
  return (e || "").split("");
}
const GFe = /* @__PURE__ */ $.forwardRef((e, t) => {
  const {
    prefixCls: n,
    length: r = 6,
    size: i,
    defaultValue: o,
    value: a,
    onChange: s,
    formatter: c,
    variant: l,
    disabled: u,
    status: d,
    autoFocus: f,
    mask: h,
    type: p,
    onInput: g,
    inputMode: m
  } = e, v = qFe(e, ["prefixCls", "length", "size", "defaultValue", "value", "onChange", "formatter", "variant", "disabled", "status", "autoFocus", "mask", "type", "onInput", "inputMode"]);
  if (process.env.NODE_ENV !== "production") {
    const q = di("Input.OTP");
    process.env.NODE_ENV !== "production" && q(!(typeof h == "string" && h.length > 1), "usage", "`mask` prop should be a single character.");
  }
  const {
    getPrefixCls: y,
    direction: _
  } = $.useContext(Cn), b = y("otp", n), w = xf(v, {
    aria: !0,
    data: !0,
    attr: !0
  }), C = Wf(b), [x, T, E] = zFe(b, C), R = Gf((q) => i ?? q), I = $.useContext(As), O = ky(I.status, d), P = $.useMemo(() => Object.assign(Object.assign({}, I), {
    status: O,
    hasFeedback: !1,
    feedbackIcon: null
  }), [I, O]), k = $.useRef(null), L = $.useRef({});
  $.useImperativeHandle(t, () => ({
    focus: () => {
      var q;
      (q = L.current[0]) === null || q === void 0 || q.focus();
    },
    blur: () => {
      var q;
      for (let X = 0; X < r; X += 1)
        (q = L.current[X]) === null || q === void 0 || q.blur();
    },
    nativeElement: k.current
  }));
  const N = (q) => c ? c(q) : q, [D, z] = $.useState(y1(N(o || "")));
  $.useEffect(() => {
    a !== void 0 && z(y1(a));
  }, [a]);
  const V = Pr((q) => {
    z(q), g && g(q), s && q.length === r && q.every((X) => X) && q.some((X, ne) => D[ne] !== X) && s(q.join(""));
  }), B = Pr((q, X) => {
    let ne = tt(D);
    for (let J = 0; J < q; J += 1)
      ne[J] || (ne[J] = "");
    X.length <= 1 ? ne[q] = X : ne = ne.slice(0, q).concat(y1(X)), ne = ne.slice(0, r);
    for (let J = ne.length - 1; J >= 0 && !ne[J]; J -= 1)
      ne.pop();
    const Z = N(ne.map((J) => J || " ").join(""));
    return ne = y1(Z).map((J, K) => J === " " && !ne[K] ? ne[K] : J), ne;
  }), U = (q, X) => {
    var ne;
    const Z = B(q, X), J = Math.min(q + X.length, r - 1);
    J !== q && ((ne = L.current[J]) === null || ne === void 0 || ne.focus()), V(Z);
  }, Q = (q) => {
    var X;
    (X = L.current[q]) === null || X === void 0 || X.focus();
  }, Y = {
    variant: l,
    disabled: u,
    status: O,
    mask: h,
    type: p,
    inputMode: m
  };
  return x(/* @__PURE__ */ $.createElement("div", Object.assign({}, w, {
    ref: k,
    className: Ee(b, {
      [`${b}-sm`]: R === "small",
      [`${b}-lg`]: R === "large",
      [`${b}-rtl`]: _ === "rtl"
    }, E, T)
  }), /* @__PURE__ */ $.createElement(As.Provider, {
    value: P
  }, Array.from({
    length: r
  }).map((q, X) => {
    const ne = `otp-${X}`, Z = D[X] || "";
    return /* @__PURE__ */ $.createElement(WFe, Object.assign({
      ref: (J) => {
        L.current[X] = J;
      },
      key: ne,
      index: X,
      size: R,
      htmlSize: 1,
      className: `${b}-input`,
      onChange: U,
      value: Z,
      onActiveChange: Q,
      autoFocus: X === 0 && f
    }, Y));
  }))));
}), KFe = GFe;
var YFe = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M942.2 486.2Q889.47 375.11 816.7 305l-50.88 50.88C807.31 395.53 843.45 447.4 874.7 512 791.5 684.2 673.4 766 512 766q-72.67 0-133.87-22.38L323 798.75Q408 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 000-51.5zm-63.57-320.64L836 122.88a8 8 0 00-11.32 0L715.31 232.2Q624.86 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 000 51.5q56.69 119.4 136.5 191.41L112.48 835a8 8 0 000 11.31L155.17 889a8 8 0 0011.31 0l712.15-712.12a8 8 0 000-11.32zM149.3 512C232.6 339.8 350.7 258 512 258c54.54 0 104.13 9.36 149.12 28.39l-70.3 70.3a176 176 0 00-238.13 238.13l-83.42 83.42C223.1 637.49 183.3 582.28 149.3 512zm246.7 0a112.11 112.11 0 01146.2-106.69L401.31 546.2A112 112 0 01396 512z" } }, { tag: "path", attrs: { d: "M508 624c-3.46 0-6.87-.16-10.25-.47l-52.82 52.82a176.09 176.09 0 00227.42-227.42l-52.82 52.82c.31 3.38.47 6.79.47 10.25a111.94 111.94 0 01-112 112z" } }] }, name: "eye-invisible", theme: "outlined" };
const XFe = YFe;
var QFe = function(t, n) {
  return /* @__PURE__ */ $.createElement(mo, xt({}, t, {
    ref: n,
    icon: XFe
  }));
}, Tee = /* @__PURE__ */ $.forwardRef(QFe);
process.env.NODE_ENV !== "production" && (Tee.displayName = "EyeInvisibleOutlined");
const JFe = Tee;
var ZFe = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 000 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z" } }] }, name: "eye", theme: "outlined" };
const e9e = ZFe;
var t9e = function(t, n) {
  return /* @__PURE__ */ $.createElement(mo, xt({}, t, {
    ref: n,
    icon: e9e
  }));
}, Iee = /* @__PURE__ */ $.forwardRef(t9e);
process.env.NODE_ENV !== "production" && (Iee.displayName = "EyeOutlined");
const n9e = Iee;
var r9e = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
const i9e = (e) => e ? /* @__PURE__ */ $.createElement(n9e, null) : /* @__PURE__ */ $.createElement(JFe, null), o9e = {
  click: "onClick",
  hover: "onMouseOver"
}, $ee = /* @__PURE__ */ $.forwardRef((e, t) => {
  const {
    disabled: n,
    action: r = "click",
    visibilityToggle: i = !0,
    iconRender: o = i9e
  } = e, a = $.useContext(id), s = n ?? a, c = typeof i == "object" && i.visible !== void 0, [l, u] = Qe(() => c ? i.visible : !1), d = $e(null);
  $.useEffect(() => {
    c && u(i.visible);
  }, [c, i]);
  const f = Eee(d), h = () => {
    s || (l && f(), u((R) => {
      var I;
      const O = !R;
      return typeof i == "object" && ((I = i.onVisibleChange) === null || I === void 0 || I.call(i, O)), O;
    }));
  }, p = (R) => {
    const I = o9e[r] || "", O = o(l), P = {
      [I]: h,
      className: `${R}-icon`,
      key: "passwordIcon",
      onMouseDown: (k) => {
        k.preventDefault();
      },
      onMouseUp: (k) => {
        k.preventDefault();
      }
    };
    return /* @__PURE__ */ $.cloneElement(/* @__PURE__ */ $.isValidElement(O) ? O : /* @__PURE__ */ $.createElement("span", null, O), P);
  }, {
    className: g,
    prefixCls: m,
    inputPrefixCls: v,
    size: y
  } = e, _ = r9e(e, ["className", "prefixCls", "inputPrefixCls", "size"]), {
    getPrefixCls: b
  } = $.useContext(Cn), w = b("input", v), C = b("input-password", m), x = i && p(C), T = Ee(C, g, {
    [`${C}-${y}`]: !!y
  }), E = Object.assign(Object.assign({}, rd(_, ["suffix", "iconRender", "visibilityToggle"])), {
    type: l ? "text" : "password",
    className: T,
    prefixCls: w,
    suffix: x
  });
  return y && (E.size = y), /* @__PURE__ */ $.createElement(nC, Object.assign({
    ref: Ja(t, d)
  }, E));
});
process.env.NODE_ENV !== "production" && ($ee.displayName = "Input.Password");
const a9e = $ee;
var s9e = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
const Aee = /* @__PURE__ */ $.forwardRef((e, t) => {
  const {
    prefixCls: n,
    inputPrefixCls: r,
    className: i,
    size: o,
    suffix: a,
    enterButton: s = !1,
    addonAfter: c,
    loading: l,
    disabled: u,
    onSearch: d,
    onChange: f,
    onCompositionStart: h,
    onCompositionEnd: p
  } = e, g = s9e(e, ["prefixCls", "inputPrefixCls", "className", "size", "suffix", "enterButton", "addonAfter", "loading", "disabled", "onSearch", "onChange", "onCompositionStart", "onCompositionEnd"]), {
    getPrefixCls: m,
    direction: v
  } = $.useContext(Cn), y = $.useRef(!1), _ = m("input-search", n), b = m("input", r), {
    compactSize: w
  } = Ry(_, v), C = Gf((B) => {
    var U;
    return (U = o ?? w) !== null && U !== void 0 ? U : B;
  }), x = $.useRef(null), T = (B) => {
    B != null && B.target && B.type === "click" && d && d(B.target.value, B, {
      source: "clear"
    }), f == null || f(B);
  }, E = (B) => {
    var U;
    document.activeElement === ((U = x.current) === null || U === void 0 ? void 0 : U.input) && B.preventDefault();
  }, R = (B) => {
    var U, Q;
    d && d((Q = (U = x.current) === null || U === void 0 ? void 0 : U.input) === null || Q === void 0 ? void 0 : Q.value, B, {
      source: "input"
    });
  }, I = (B) => {
    y.current || l || R(B);
  }, O = typeof s == "boolean" ? /* @__PURE__ */ $.createElement(XZ, null) : null, P = `${_}-button`;
  let k;
  const L = s || {}, N = L.type && L.type.__ANT_BUTTON === !0;
  N || L.type === "button" ? k = Jg(L, Object.assign({
    onMouseDown: E,
    onClick: (B) => {
      var U, Q;
      (Q = (U = L == null ? void 0 : L.props) === null || U === void 0 ? void 0 : U.onClick) === null || Q === void 0 || Q.call(U, B), R(B);
    },
    key: "enterButton"
  }, N ? {
    className: P,
    size: C
  } : {})) : k = /* @__PURE__ */ $.createElement(k7e, {
    className: P,
    type: s ? "primary" : void 0,
    size: C,
    disabled: u,
    key: "enterButton",
    onMouseDown: E,
    onClick: R,
    loading: l,
    icon: O
  }, s), c && (k = [k, Jg(c, {
    key: "addonAfter"
  })]);
  const D = Ee(_, {
    [`${_}-rtl`]: v === "rtl",
    [`${_}-${C}`]: !!C,
    [`${_}-with-button`]: !!s
  }, i), z = (B) => {
    y.current = !0, h == null || h(B);
  }, V = (B) => {
    y.current = !1, p == null || p(B);
  };
  return /* @__PURE__ */ $.createElement(nC, Object.assign({
    ref: Ja(x, t),
    onPressEnter: I
  }, g, {
    size: C,
    onCompositionStart: z,
    onCompositionEnd: V,
    prefixCls: b,
    addonAfter: k,
    suffix: a,
    onChange: T,
    className: D,
    disabled: u
  }));
});
process.env.NODE_ENV !== "production" && (Aee.displayName = "Search");
const c9e = Aee;
var l9e = `
  min-height:0 !important;
  max-height:none !important;
  height:0 !important;
  visibility:hidden !important;
  overflow:hidden !important;
  position:absolute !important;
  z-index:-1000 !important;
  top:0 !important;
  right:0 !important;
  pointer-events: none !important;
`, u9e = ["letter-spacing", "line-height", "padding-top", "padding-bottom", "font-family", "font-weight", "font-size", "font-variant", "text-rendering", "text-transform", "width", "text-indent", "padding-left", "padding-right", "border-width", "box-sizing", "word-break", "white-space"], NT = {}, la;
function d9e(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, n = e.getAttribute("id") || e.getAttribute("data-reactid") || e.getAttribute("name");
  if (t && NT[n])
    return NT[n];
  var r = window.getComputedStyle(e), i = r.getPropertyValue("box-sizing") || r.getPropertyValue("-moz-box-sizing") || r.getPropertyValue("-webkit-box-sizing"), o = parseFloat(r.getPropertyValue("padding-bottom")) + parseFloat(r.getPropertyValue("padding-top")), a = parseFloat(r.getPropertyValue("border-bottom-width")) + parseFloat(r.getPropertyValue("border-top-width")), s = u9e.map(function(l) {
    return "".concat(l, ":").concat(r.getPropertyValue(l));
  }).join(";"), c = {
    sizingStyle: s,
    paddingSize: o,
    borderSize: a,
    boxSizing: i
  };
  return t && n && (NT[n] = c), c;
}
function f9e(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
  la || (la = document.createElement("textarea"), la.setAttribute("tab-index", "-1"), la.setAttribute("aria-hidden", "true"), la.setAttribute("name", "hiddenTextarea"), document.body.appendChild(la)), e.getAttribute("wrap") ? la.setAttribute("wrap", e.getAttribute("wrap")) : la.removeAttribute("wrap");
  var i = d9e(e, t), o = i.paddingSize, a = i.borderSize, s = i.boxSizing, c = i.sizingStyle;
  la.setAttribute("style", "".concat(c, ";").concat(l9e)), la.value = e.value || e.placeholder || "";
  var l = void 0, u = void 0, d, f = la.scrollHeight;
  if (s === "border-box" ? f += a : s === "content-box" && (f -= o), n !== null || r !== null) {
    la.value = " ";
    var h = la.scrollHeight - o;
    n !== null && (l = h * n, s === "border-box" && (l = l + o + a), f = Math.max(l, f)), r !== null && (u = h * r, s === "border-box" && (u = u + o + a), d = f > u ? "" : "hidden", f = Math.min(u, f));
  }
  var p = {
    height: f,
    overflowY: d,
    resize: "none"
  };
  return l && (p.minHeight = l), u && (p.maxHeight = u), p;
}
var h9e = ["prefixCls", "defaultValue", "value", "autoSize", "onResize", "className", "style", "disabled", "onChange", "onInternalAutoSize"], DT = 0, jT = 1, LT = 2, Ree = /* @__PURE__ */ $.forwardRef(function(e, t) {
  var n = e, r = n.prefixCls, i = n.defaultValue, o = n.value, a = n.autoSize, s = n.onResize, c = n.className, l = n.style, u = n.disabled, d = n.onChange, f = n.onInternalAutoSize, h = En(n, h9e), p = wc(i, {
    value: o,
    postState: function(X) {
      return X ?? "";
    }
  }), g = he(p, 2), m = g[0], v = g[1], y = function(X) {
    v(X.target.value), d == null || d(X);
  }, _ = $.useRef();
  $.useImperativeHandle(t, function() {
    return {
      textArea: _.current
    };
  });
  var b = $.useMemo(function() {
    return a && It(a) === "object" ? [a.minRows, a.maxRows] : [];
  }, [a]), w = he(b, 2), C = w[0], x = w[1], T = !!a, E = function() {
    try {
      if (document.activeElement === _.current) {
        var X = _.current, ne = X.selectionStart, Z = X.selectionEnd, J = X.scrollTop;
        _.current.setSelectionRange(ne, Z), _.current.scrollTop = J;
      }
    } catch {
    }
  }, R = $.useState(LT), I = he(R, 2), O = I[0], P = I[1], k = $.useState(), L = he(k, 2), N = L[0], D = L[1], z = function() {
    P(DT), process.env.NODE_ENV === "test" && (f == null || f());
  };
  ar(function() {
    T && z();
  }, [o, C, x, T]), ar(function() {
    if (O === DT)
      P(jT);
    else if (O === jT) {
      var q = f9e(_.current, !1, C, x);
      P(LT), D(q);
    } else
      E();
  }, [O]);
  var V = $.useRef(), B = function() {
    Ln.cancel(V.current);
  }, U = function(X) {
    O === LT && (s == null || s(X), a && (B(), V.current = Ln(function() {
      z();
    })));
  };
  $.useEffect(function() {
    return B;
  }, []);
  var Q = T ? N : null, Y = ae(ae({}, l), Q);
  return (O === DT || O === jT) && (Y.overflowY = "hidden", Y.overflowX = "hidden"), /* @__PURE__ */ $.createElement(Cl, {
    onResize: U,
    disabled: !(a || s)
  }, /* @__PURE__ */ $.createElement("textarea", xt({}, h, {
    ref: _,
    style: Y,
    className: Ee(r, c, oe({}, "".concat(r, "-disabled"), u)),
    disabled: u,
    value: m,
    onChange: y
  })));
}), g9e = ["defaultValue", "value", "onFocus", "onBlur", "onChange", "allowClear", "maxLength", "onCompositionStart", "onCompositionEnd", "suffix", "prefixCls", "showCount", "count", "className", "style", "disabled", "hidden", "classNames", "styles", "onResize", "onClear", "onPressEnter", "readOnly", "autoSize", "onKeyDown"], Pee = /* @__PURE__ */ j.forwardRef(function(e, t) {
  var n, r = e.defaultValue, i = e.value, o = e.onFocus, a = e.onBlur, s = e.onChange, c = e.allowClear, l = e.maxLength, u = e.onCompositionStart, d = e.onCompositionEnd, f = e.suffix, h = e.prefixCls, p = h === void 0 ? "rc-textarea" : h, g = e.showCount, m = e.count, v = e.className, y = e.style, _ = e.disabled, b = e.hidden, w = e.classNames, C = e.styles, x = e.onResize, T = e.onClear, E = e.onPressEnter, R = e.readOnly, I = e.autoSize, O = e.onKeyDown, P = En(e, g9e), k = wc(r, {
    value: i,
    defaultValue: r
  }), L = he(k, 2), N = L[0], D = L[1], z = N == null ? "" : String(N), V = j.useState(!1), B = he(V, 2), U = B[0], Q = B[1], Y = j.useRef(!1), q = j.useState(null), X = he(q, 2), ne = X[0], Z = X[1], J = $e(null), K = $e(null), ee = function() {
    var Re;
    return (Re = K.current) === null || Re === void 0 ? void 0 : Re.textArea;
  }, te = function() {
    ee().focus();
  };
  eO(t, function() {
    var xe;
    return {
      resizableTextArea: K.current,
      focus: te,
      blur: function() {
        ee().blur();
      },
      nativeElement: ((xe = J.current) === null || xe === void 0 ? void 0 : xe.nativeElement) || ee()
    };
  }), ot(function() {
    Q(function(xe) {
      return !_ && xe;
    });
  }, [_]);
  var H = j.useState(null), ie = he(H, 2), W = ie[0], se = ie[1];
  j.useEffect(function() {
    if (W) {
      var xe;
      (xe = ee()).setSelectionRange.apply(xe, tt(W));
    }
  }, [W]);
  var le = bee(m, g), ge = (n = le.max) !== null && n !== void 0 ? n : l, me = Number(ge) > 0, pe = le.strategy(z), Te = !!ge && pe > ge, de = function(Re, yt) {
    var Pt = yt;
    !Y.current && le.exceedFormatter && le.max && le.strategy(yt) > le.max && (Pt = le.exceedFormatter(yt, {
      max: le.max
    }), yt !== Pt && se([ee().selectionStart || 0, ee().selectionEnd || 0])), D(Pt), hw(Re.currentTarget, Re, s, Pt);
  }, Ae = function(Re) {
    Y.current = !0, u == null || u(Re);
  }, ue = function(Re) {
    Y.current = !1, de(Re, Re.currentTarget.value), d == null || d(Re);
  }, be = function(Re) {
    de(Re, Re.target.value);
  }, Ie = function(Re) {
    Re.key === "Enter" && E && E(Re), O == null || O(Re);
  }, Ve = function(Re) {
    Q(!0), o == null || o(Re);
  }, ze = function(Re) {
    Q(!1), a == null || a(Re);
  }, Ne = function(Re) {
    D(""), te(), hw(ee(), Re, s);
  }, lt = f, mt;
  le.show && (le.showFormatter ? mt = le.showFormatter({
    value: z,
    count: pe,
    maxLength: ge
  }) : mt = "".concat(pe).concat(me ? " / ".concat(ge) : ""), lt = /* @__PURE__ */ j.createElement(j.Fragment, null, lt, /* @__PURE__ */ j.createElement("span", {
    className: Ee("".concat(p, "-data-count"), w == null ? void 0 : w.count),
    style: C == null ? void 0 : C.count
  }, mt)));
  var vt = function(Re) {
    var yt;
    x == null || x(Re), (yt = ee()) !== null && yt !== void 0 && yt.style.height && Z(!0);
  }, ke = !I && !g && !c;
  return /* @__PURE__ */ j.createElement(tC, {
    ref: J,
    value: z,
    allowClear: c,
    handleReset: Ne,
    suffix: lt,
    prefixCls: p,
    classNames: ae(ae({}, w), {}, {
      affixWrapper: Ee(w == null ? void 0 : w.affixWrapper, oe(oe({}, "".concat(p, "-show-count"), g), "".concat(p, "-textarea-allow-clear"), c))
    }),
    disabled: _,
    focused: U,
    className: Ee(v, Te && "".concat(p, "-out-of-range")),
    style: ae(ae({}, y), ne && !ke ? {
      height: "auto"
    } : {}),
    dataAttrs: {
      affixWrapper: {
        "data-count": typeof mt == "string" ? mt : void 0
      }
    },
    hidden: b,
    readOnly: R,
    onClear: T
  }, /* @__PURE__ */ j.createElement(Ree, xt({}, P, {
    autoSize: I,
    maxLength: l,
    onKeyDown: Ie,
    onChange: be,
    onFocus: Ve,
    onBlur: ze,
    onCompositionStart: Ae,
    onCompositionEnd: ue,
    className: Ee(w == null ? void 0 : w.textarea),
    style: ae(ae({}, C == null ? void 0 : C.textarea), {}, {
      resize: y == null ? void 0 : y.resize
    }),
    disabled: _,
    prefixCls: p,
    onResize: vt,
    ref: K,
    readOnly: R
  })));
});
const p9e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ResizableTextArea: Ree,
  default: Pee
}, Symbol.toStringTag, { value: "Module" }));
var m9e = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
const v9e = /* @__PURE__ */ ia((e, t) => {
  var n, r;
  const {
    prefixCls: i,
    bordered: o = !0,
    size: a,
    disabled: s,
    status: c,
    allowClear: l,
    classNames: u,
    rootClassName: d,
    className: f,
    style: h,
    styles: p,
    variant: g
  } = e, m = m9e(e, ["prefixCls", "bordered", "size", "disabled", "status", "allowClear", "classNames", "rootClassName", "className", "style", "styles", "variant"]);
  if (process.env.NODE_ENV !== "production") {
    const {
      deprecated: B
    } = di("TextArea");
    B(!("bordered" in e), "bordered", "variant");
  }
  const {
    getPrefixCls: v,
    direction: y,
    textArea: _
  } = $.useContext(Cn), b = Gf(a), w = $.useContext(id), C = s ?? w, {
    status: x,
    hasFeedback: T,
    feedbackIcon: E
  } = $.useContext(As), R = ky(x, c), I = $.useRef(null);
  $.useImperativeHandle(t, () => {
    var B;
    return {
      resizableTextArea: (B = I.current) === null || B === void 0 ? void 0 : B.resizableTextArea,
      focus: (U) => {
        var Q, Y;
        t3((Y = (Q = I.current) === null || Q === void 0 ? void 0 : Q.resizableTextArea) === null || Y === void 0 ? void 0 : Y.textArea, U);
      },
      blur: () => {
        var U;
        return (U = I.current) === null || U === void 0 ? void 0 : U.blur();
      }
    };
  });
  const O = v("input", i), P = Wf(O), [k, L, N] = JM(O, P), [D, z] = JE("textArea", g, o), V = xee(l ?? (_ == null ? void 0 : _.allowClear));
  return k(/* @__PURE__ */ $.createElement(Pee, Object.assign({
    autoComplete: _ == null ? void 0 : _.autoComplete
  }, m, {
    style: Object.assign(Object.assign({}, _ == null ? void 0 : _.style), h),
    styles: Object.assign(Object.assign({}, _ == null ? void 0 : _.styles), p),
    disabled: C,
    allowClear: V,
    className: Ee(N, P, f, d, _ == null ? void 0 : _.className),
    classNames: Object.assign(Object.assign(Object.assign({}, u), _ == null ? void 0 : _.classNames), {
      textarea: Ee({
        [`${O}-sm`]: b === "small",
        [`${O}-lg`]: b === "large"
      }, L, u == null ? void 0 : u.textarea, (n = _ == null ? void 0 : _.classNames) === null || n === void 0 ? void 0 : n.textarea),
      variant: Ee({
        [`${O}-${D}`]: z
      }, ep(O, R)),
      affixWrapper: Ee(`${O}-textarea-affix-wrapper`, {
        [`${O}-affix-wrapper-rtl`]: y === "rtl",
        [`${O}-affix-wrapper-sm`]: b === "small",
        [`${O}-affix-wrapper-lg`]: b === "large",
        [`${O}-textarea-show-count`]: e.showCount || ((r = e.count) === null || r === void 0 ? void 0 : r.show)
      }, L)
    }),
    prefixCls: O,
    suffix: T && /* @__PURE__ */ $.createElement("span", {
      className: `${O}-textarea-suffix`
    }, E),
    ref: I
  })));
}), y9e = v9e, Xp = nC;
Xp.Group = jFe;
Xp.Search = c9e;
Xp.TextArea = y9e;
Xp.Password = a9e;
Xp.OTP = KFe;
const b9e = Xp;
function xR(e, t, n) {
  return (e - t) / (n - t);
}
function r3(e, t, n, r) {
  var i = xR(t, n, r), o = {};
  switch (e) {
    case "rtl":
      o.right = "".concat(i * 100, "%"), o.transform = "translateX(50%)";
      break;
    case "btt":
      o.bottom = "".concat(i * 100, "%"), o.transform = "translateY(50%)";
      break;
    case "ttb":
      o.top = "".concat(i * 100, "%"), o.transform = "translateY(-50%)";
      break;
    default:
      o.left = "".concat(i * 100, "%"), o.transform = "translateX(-50%)";
      break;
  }
  return o;
}
function Zh(e, t) {
  return Array.isArray(e) ? e[t] : e;
}
var Xf = /* @__PURE__ */ $.createContext({
  min: 0,
  max: 0,
  direction: "ltr",
  step: 1,
  includedStart: 0,
  includedEnd: 0,
  tabIndex: 0,
  keyboard: !0,
  styles: {},
  classNames: {}
}), _9e = /* @__PURE__ */ $.createContext({}), S9e = ["prefixCls", "value", "valueIndex", "onStartMove", "onDelete", "style", "render", "dragging", "draggingDelete", "onOffsetChange", "onChangeComplete", "onFocus", "onMouseEnter"], ER = /* @__PURE__ */ $.forwardRef(function(e, t) {
  var n = e.prefixCls, r = e.value, i = e.valueIndex, o = e.onStartMove, a = e.onDelete, s = e.style, c = e.render, l = e.dragging, u = e.draggingDelete, d = e.onOffsetChange, f = e.onChangeComplete, h = e.onFocus, p = e.onMouseEnter, g = En(e, S9e), m = $.useContext(Xf), v = m.min, y = m.max, _ = m.direction, b = m.disabled, w = m.keyboard, C = m.range, x = m.tabIndex, T = m.ariaLabelForHandle, E = m.ariaLabelledByForHandle, R = m.ariaValueTextFormatterForHandle, I = m.styles, O = m.classNames, P = "".concat(n, "-handle"), k = function(q) {
    b || o(q, i);
  }, L = function(q) {
    h == null || h(q, i);
  }, N = function(q) {
    p(q, i);
  }, D = function(q) {
    if (!b && w) {
      var X = null;
      switch (q.which || q.keyCode) {
        case Oe.LEFT:
          X = _ === "ltr" || _ === "btt" ? -1 : 1;
          break;
        case Oe.RIGHT:
          X = _ === "ltr" || _ === "btt" ? 1 : -1;
          break;
        case Oe.UP:
          X = _ !== "ttb" ? 1 : -1;
          break;
        case Oe.DOWN:
          X = _ !== "ttb" ? -1 : 1;
          break;
        case Oe.HOME:
          X = "min";
          break;
        case Oe.END:
          X = "max";
          break;
        case Oe.PAGE_UP:
          X = 2;
          break;
        case Oe.PAGE_DOWN:
          X = -2;
          break;
        case Oe.BACKSPACE:
        case Oe.DELETE:
          a(i);
          break;
      }
      X !== null && (q.preventDefault(), d(X, i));
    }
  }, z = function(q) {
    switch (q.which || q.keyCode) {
      case Oe.LEFT:
      case Oe.RIGHT:
      case Oe.UP:
      case Oe.DOWN:
      case Oe.HOME:
      case Oe.END:
      case Oe.PAGE_UP:
      case Oe.PAGE_DOWN:
        f == null || f();
        break;
    }
  }, V = r3(_, r, v, y), B = {};
  if (i !== null) {
    var U;
    B = {
      tabIndex: b ? null : Zh(x, i),
      role: "slider",
      "aria-valuemin": v,
      "aria-valuemax": y,
      "aria-valuenow": r,
      "aria-disabled": b,
      "aria-label": Zh(T, i),
      "aria-labelledby": Zh(E, i),
      "aria-valuetext": (U = Zh(R, i)) === null || U === void 0 ? void 0 : U(r),
      "aria-orientation": _ === "ltr" || _ === "rtl" ? "horizontal" : "vertical",
      onMouseDown: k,
      onTouchStart: k,
      onFocus: L,
      onMouseEnter: N,
      onKeyDown: D,
      onKeyUp: z
    };
  }
  var Q = /* @__PURE__ */ $.createElement("div", xt({
    ref: t,
    className: Ee(P, oe(oe(oe({}, "".concat(P, "-").concat(i + 1), i !== null && C), "".concat(P, "-dragging"), l), "".concat(P, "-dragging-delete"), u), O.handle),
    style: ae(ae(ae({}, V), s), I.handle)
  }, B, g));
  return c && (Q = c(Q, {
    index: i,
    prefixCls: n,
    value: r,
    dragging: l,
    draggingDelete: u
  })), Q;
});
process.env.NODE_ENV !== "production" && (ER.displayName = "Handle");
var w9e = ["prefixCls", "style", "onStartMove", "onOffsetChange", "values", "handleRender", "activeHandleRender", "draggingIndex", "draggingDelete", "onFocus"], Oee = /* @__PURE__ */ $.forwardRef(function(e, t) {
  var n = e.prefixCls, r = e.style, i = e.onStartMove, o = e.onOffsetChange, a = e.values, s = e.handleRender, c = e.activeHandleRender, l = e.draggingIndex, u = e.draggingDelete, d = e.onFocus, f = En(e, w9e), h = $.useRef({}), p = $.useState(!1), g = he(p, 2), m = g[0], v = g[1], y = $.useState(-1), _ = he(y, 2), b = _[0], w = _[1], C = function(I) {
    w(I), v(!0);
  }, x = function(I, O) {
    C(O), d == null || d(I);
  }, T = function(I, O) {
    C(O);
  };
  $.useImperativeHandle(t, function() {
    return {
      focus: function(I) {
        var O;
        (O = h.current[I]) === null || O === void 0 || O.focus();
      },
      hideHelp: function() {
        i$(function() {
          v(!1);
        });
      }
    };
  });
  var E = ae({
    prefixCls: n,
    onStartMove: i,
    onOffsetChange: o,
    render: s,
    onFocus: x,
    onMouseEnter: T
  }, f);
  return /* @__PURE__ */ $.createElement($.Fragment, null, a.map(function(R, I) {
    var O = l === I;
    return /* @__PURE__ */ $.createElement(ER, xt({
      ref: function(k) {
        k ? h.current[I] = k : delete h.current[I];
      },
      dragging: O,
      draggingDelete: O && u,
      style: Zh(r, I),
      key: I,
      value: R,
      valueIndex: I
    }, E));
  }), c && m && /* @__PURE__ */ $.createElement(ER, xt({
    key: "a11y"
  }, E, {
    value: a[b],
    valueIndex: null,
    dragging: l !== -1,
    draggingDelete: u,
    render: c,
    style: {
      pointerEvents: "none"
    },
    tabIndex: null,
    "aria-hidden": !0
  })));
});
process.env.NODE_ENV !== "production" && (Oee.displayName = "Handles");
var x9e = function(t) {
  var n = t.prefixCls, r = t.style, i = t.children, o = t.value, a = t.onClick, s = $.useContext(Xf), c = s.min, l = s.max, u = s.direction, d = s.includedStart, f = s.includedEnd, h = s.included, p = "".concat(n, "-text"), g = r3(u, o, c, l);
  return /* @__PURE__ */ $.createElement("span", {
    className: Ee(p, oe({}, "".concat(p, "-active"), h && d <= o && o <= f)),
    style: ae(ae({}, g), r),
    onMouseDown: function(v) {
      v.stopPropagation();
    },
    onClick: function() {
      a(o);
    }
  }, i);
}, E9e = function(t) {
  var n = t.prefixCls, r = t.marks, i = t.onClick, o = "".concat(n, "-mark");
  return r.length ? /* @__PURE__ */ $.createElement("div", {
    className: o
  }, r.map(function(a) {
    var s = a.value, c = a.style, l = a.label;
    return /* @__PURE__ */ $.createElement(x9e, {
      key: s,
      prefixCls: o,
      style: c,
      value: s,
      onClick: i
    }, l);
  })) : null;
}, C9e = function(t) {
  var n = t.prefixCls, r = t.value, i = t.style, o = t.activeStyle, a = $.useContext(Xf), s = a.min, c = a.max, l = a.direction, u = a.included, d = a.includedStart, f = a.includedEnd, h = "".concat(n, "-dot"), p = u && d <= r && r <= f, g = ae(ae({}, r3(l, r, s, c)), typeof i == "function" ? i(r) : i);
  return p && (g = ae(ae({}, g), typeof o == "function" ? o(r) : o)), /* @__PURE__ */ $.createElement("span", {
    className: Ee(h, oe({}, "".concat(h, "-active"), p)),
    style: g
  });
}, T9e = function(t) {
  var n = t.prefixCls, r = t.marks, i = t.dots, o = t.style, a = t.activeStyle, s = $.useContext(Xf), c = s.min, l = s.max, u = s.step, d = $.useMemo(function() {
    var f = /* @__PURE__ */ new Set();
    if (r.forEach(function(p) {
      f.add(p.value);
    }), i && u !== null)
      for (var h = c; h <= l; )
        f.add(h), h += u;
    return Array.from(f);
  }, [c, l, u, i, r]);
  return /* @__PURE__ */ $.createElement("div", {
    className: "".concat(n, "-step")
  }, d.map(function(f) {
    return /* @__PURE__ */ $.createElement(C9e, {
      prefixCls: n,
      key: f,
      value: f,
      style: o,
      activeStyle: a
    });
  }));
}, UF = function(t) {
  var n = t.prefixCls, r = t.style, i = t.start, o = t.end, a = t.index, s = t.onStartMove, c = t.replaceCls, l = $.useContext(Xf), u = l.direction, d = l.min, f = l.max, h = l.disabled, p = l.range, g = l.classNames, m = "".concat(n, "-track"), v = xR(i, d, f), y = xR(o, d, f), _ = function(x) {
    !h && s && s(x, -1);
  }, b = {};
  switch (u) {
    case "rtl":
      b.right = "".concat(v * 100, "%"), b.width = "".concat(y * 100 - v * 100, "%");
      break;
    case "btt":
      b.bottom = "".concat(v * 100, "%"), b.height = "".concat(y * 100 - v * 100, "%");
      break;
    case "ttb":
      b.top = "".concat(v * 100, "%"), b.height = "".concat(y * 100 - v * 100, "%");
      break;
    default:
      b.left = "".concat(v * 100, "%"), b.width = "".concat(y * 100 - v * 100, "%");
  }
  var w = c || Ee(m, oe(oe({}, "".concat(m, "-").concat(a + 1), a !== null && p), "".concat(n, "-track-draggable"), s), g.track);
  return /* @__PURE__ */ $.createElement("div", {
    className: w,
    style: ae(ae({}, b), r),
    onMouseDown: _,
    onTouchStart: _
  });
}, I9e = function(t) {
  var n = t.prefixCls, r = t.style, i = t.values, o = t.startPoint, a = t.onStartMove, s = $.useContext(Xf), c = s.included, l = s.range, u = s.min, d = s.styles, f = s.classNames, h = $.useMemo(function() {
    if (!l) {
      if (i.length === 0)
        return [];
      var g = o ?? u, m = i[0];
      return [{
        start: Math.min(g, m),
        end: Math.max(g, m)
      }];
    }
    for (var v = [], y = 0; y < i.length - 1; y += 1)
      v.push({
        start: i[y],
        end: i[y + 1]
      });
    return v;
  }, [i, l, o, u]);
  if (!c)
    return null;
  var p = f.tracks || d.tracks ? /* @__PURE__ */ $.createElement(UF, {
    index: null,
    prefixCls: n,
    start: h[0].start,
    end: h[h.length - 1].end,
    replaceCls: Ee(f.tracks, "".concat(n, "-tracks")),
    style: d.tracks
  }) : null;
  return /* @__PURE__ */ $.createElement($.Fragment, null, p, h.map(function(g, m) {
    var v = g.start, y = g.end;
    return /* @__PURE__ */ $.createElement(UF, {
      index: m,
      prefixCls: n,
      style: ae(ae({}, Zh(r, m)), d.track),
      start: v,
      end: y,
      key: m,
      onStartMove: a
    });
  }));
}, $9e = 130;
function WF(e) {
  var t = "targetTouches" in e ? e.targetTouches[0] : e;
  return {
    pageX: t.pageX,
    pageY: t.pageY
  };
}
function A9e(e, t, n, r, i, o, a, s, c, l, u) {
  var d = $.useState(null), f = he(d, 2), h = f[0], p = f[1], g = $.useState(-1), m = he(g, 2), v = m[0], y = m[1], _ = $.useState(!1), b = he(_, 2), w = b[0], C = b[1], x = $.useState(n), T = he(x, 2), E = T[0], R = T[1], I = $.useState(n), O = he(I, 2), P = O[0], k = O[1], L = $.useRef(null), N = $.useRef(null), D = $.useRef(null), z = $.useContext(_9e), V = z.onDragStart, B = z.onDragChange;
  ar(function() {
    v === -1 && R(n);
  }, [n, v]), $.useEffect(function() {
    return function() {
      document.removeEventListener("mousemove", L.current), document.removeEventListener("mouseup", N.current), D.current && (D.current.removeEventListener("touchmove", L.current), D.current.removeEventListener("touchend", N.current));
    };
  }, []);
  var U = function(ne, Z, J) {
    Z !== void 0 && p(Z), R(ne);
    var K = ne;
    J && (K = ne.filter(function(ee, te) {
      return te !== v;
    })), a(K), B && B({
      rawValues: ne,
      deleteIndex: J ? v : -1,
      draggingIndex: v,
      draggingValue: Z
    });
  }, Q = Pr(function(X, ne, Z) {
    if (X === -1) {
      var J = P[0], K = P[P.length - 1], ee = r - J, te = i - K, H = ne * (i - r);
      H = Math.max(H, ee), H = Math.min(H, te);
      var ie = o(J + H);
      H = ie - J;
      var W = P.map(function(me) {
        return me + H;
      });
      U(W);
    } else {
      var se = (i - r) * ne, le = tt(E);
      le[X] = P[X];
      var ge = c(le, se, X, "dist");
      U(ge.values, ge.value, Z);
    }
  }), Y = function(ne, Z, J) {
    ne.stopPropagation();
    var K = J || n, ee = K[Z];
    y(Z), p(ee), k(K), R(K), C(!1);
    var te = WF(ne), H = te.pageX, ie = te.pageY, W = !1;
    V && V({
      rawValues: K,
      draggingIndex: Z,
      draggingValue: ee
    });
    var se = function(me) {
      me.preventDefault();
      var pe = WF(me), Te = pe.pageX, de = pe.pageY, Ae = Te - H, ue = de - ie, be = e.current.getBoundingClientRect(), Ie = be.width, Ve = be.height, ze, Ne;
      switch (t) {
        case "btt":
          ze = -ue / Ve, Ne = Ae;
          break;
        case "ttb":
          ze = ue / Ve, Ne = Ae;
          break;
        case "rtl":
          ze = -Ae / Ie, Ne = ue;
          break;
        default:
          ze = Ae / Ie, Ne = ue;
      }
      W = l ? Math.abs(Ne) > $9e && u < E.length : !1, C(W), Q(Z, ze, W);
    }, le = function ge(me) {
      me.preventDefault(), document.removeEventListener("mouseup", ge), document.removeEventListener("mousemove", se), D.current && (D.current.removeEventListener("touchmove", L.current), D.current.removeEventListener("touchend", N.current)), L.current = null, N.current = null, D.current = null, s(W), y(-1), C(!1);
    };
    document.addEventListener("mouseup", le), document.addEventListener("mousemove", se), ne.currentTarget.addEventListener("touchend", le), ne.currentTarget.addEventListener("touchmove", se), L.current = se, N.current = le, D.current = ne.currentTarget;
  }, q = $.useMemo(function() {
    var X = tt(n).sort(function(ee, te) {
      return ee - te;
    }), ne = tt(E).sort(function(ee, te) {
      return ee - te;
    }), Z = {};
    ne.forEach(function(ee) {
      Z[ee] = (Z[ee] || 0) + 1;
    }), X.forEach(function(ee) {
      Z[ee] = (Z[ee] || 0) - 1;
    });
    var J = l ? 1 : 0, K = Object.values(Z).reduce(function(ee, te) {
      return ee + Math.abs(te);
    }, 0);
    return K <= J ? E : n;
  }, [n, E, l]);
  return [v, h, w, q, Y];
}
function R9e(e, t, n, r, i, o) {
  var a = $.useCallback(function(h) {
    return Math.max(e, Math.min(t, h));
  }, [e, t]), s = $.useCallback(function(h) {
    if (n !== null) {
      var p = e + Math.round((a(h) - e) / n) * n, g = function(_) {
        return (String(_).split(".")[1] || "").length;
      }, m = Math.max(g(n), g(t), g(e)), v = Number(p.toFixed(m));
      return e <= v && v <= t ? v : null;
    }
    return null;
  }, [n, e, t, a]), c = $.useCallback(function(h) {
    var p = a(h), g = r.map(function(y) {
      return y.value;
    });
    n !== null && g.push(s(h)), g.push(e, t);
    var m = g[0], v = t - e;
    return g.forEach(function(y) {
      var _ = Math.abs(p - y);
      _ <= v && (m = y, v = _);
    }), m;
  }, [e, t, r, n, a, s]), l = function h(p, g, m) {
    var v = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "unit";
    if (typeof g == "number") {
      var y, _ = p[m], b = _ + g, w = [];
      r.forEach(function(R) {
        w.push(R.value);
      }), w.push(e, t), w.push(s(_));
      var C = g > 0 ? 1 : -1;
      v === "unit" ? w.push(s(_ + C * n)) : w.push(s(b)), w = w.filter(function(R) {
        return R !== null;
      }).filter(function(R) {
        return g < 0 ? R <= _ : R >= _;
      }), v === "unit" && (w = w.filter(function(R) {
        return R !== _;
      }));
      var x = v === "unit" ? _ : b;
      y = w[0];
      var T = Math.abs(y - x);
      if (w.forEach(function(R) {
        var I = Math.abs(R - x);
        I < T && (y = R, T = I);
      }), y === void 0)
        return g < 0 ? e : t;
      if (v === "dist")
        return y;
      if (Math.abs(g) > 1) {
        var E = tt(p);
        return E[m] = y, h(E, g - C, m, v);
      }
      return y;
    } else {
      if (g === "min")
        return e;
      if (g === "max")
        return t;
    }
  }, u = function(p, g, m) {
    var v = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "unit", y = p[m], _ = l(p, g, m, v);
    return {
      value: _,
      changed: _ !== y
    };
  }, d = function(p) {
    return o === null && p === 0 || typeof o == "number" && p < o;
  }, f = function(p, g, m) {
    var v = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "unit", y = p.map(c), _ = y[m], b = l(y, g, m, v);
    if (y[m] = b, i === !1) {
      var w = o || 0;
      m > 0 && y[m - 1] !== _ && (y[m] = Math.max(y[m], y[m - 1] + w)), m < y.length - 1 && y[m + 1] !== _ && (y[m] = Math.min(y[m], y[m + 1] - w));
    } else if (typeof o == "number" || o === null) {
      for (var C = m + 1; C < y.length; C += 1)
        for (var x = !0; d(y[C] - y[C - 1]) && x; ) {
          var T = u(y, 1, C);
          y[C] = T.value, x = T.changed;
        }
      for (var E = m; E > 0; E -= 1)
        for (var R = !0; d(y[E] - y[E - 1]) && R; ) {
          var I = u(y, -1, E - 1);
          y[E - 1] = I.value, R = I.changed;
        }
      for (var O = y.length - 1; O > 0; O -= 1)
        for (var P = !0; d(y[O] - y[O - 1]) && P; ) {
          var k = u(y, -1, O - 1);
          y[O - 1] = k.value, P = k.changed;
        }
      for (var L = 0; L < y.length - 1; L += 1)
        for (var N = !0; d(y[L + 1] - y[L]) && N; ) {
          var D = u(y, 1, L + 1);
          y[L + 1] = D.value, N = D.changed;
        }
    }
    return {
      value: y[m],
      values: y
    };
  };
  return [c, f];
}
function P9e(e) {
  return Tt(function() {
    if (e === !0 || !e)
      return [!!e, !1, !1, 0];
    var t = e.editable, n = e.draggableTrack, r = e.minCount, i = e.maxCount;
    return process.env.NODE_ENV !== "production" && Du(!t || !n, "`editable` can not work with `draggableTrack`."), [!0, t, !t && n, r || 0, i];
  }, [e]);
}
var Mee = /* @__PURE__ */ $.forwardRef(function(e, t) {
  var n = e.prefixCls, r = n === void 0 ? "rc-slider" : n, i = e.className, o = e.style, a = e.classNames, s = e.styles, c = e.id, l = e.disabled, u = l === void 0 ? !1 : l, d = e.keyboard, f = d === void 0 ? !0 : d, h = e.autoFocus, p = e.onFocus, g = e.onBlur, m = e.min, v = m === void 0 ? 0 : m, y = e.max, _ = y === void 0 ? 100 : y, b = e.step, w = b === void 0 ? 1 : b, C = e.value, x = e.defaultValue, T = e.range, E = e.count, R = e.onChange, I = e.onBeforeChange, O = e.onAfterChange, P = e.onChangeComplete, k = e.allowCross, L = k === void 0 ? !0 : k, N = e.pushable, D = N === void 0 ? !1 : N, z = e.reverse, V = e.vertical, B = e.included, U = B === void 0 ? !0 : B, Q = e.startPoint, Y = e.trackStyle, q = e.handleStyle, X = e.railStyle, ne = e.dotStyle, Z = e.activeDotStyle, J = e.marks, K = e.dots, ee = e.handleRender, te = e.activeHandleRender, H = e.track, ie = e.tabIndex, W = ie === void 0 ? 0 : ie, se = e.ariaLabelForHandle, le = e.ariaLabelledByForHandle, ge = e.ariaValueTextFormatterForHandle, me = $.useRef(null), pe = $.useRef(null), Te = $.useMemo(function() {
    return V ? z ? "ttb" : "btt" : z ? "rtl" : "ltr";
  }, [z, V]), de = P9e(T), Ae = he(de, 5), ue = Ae[0], be = Ae[1], Ie = Ae[2], Ve = Ae[3], ze = Ae[4], Ne = $.useMemo(function() {
    return isFinite(v) ? v : 0;
  }, [v]), lt = $.useMemo(function() {
    return isFinite(_) ? _ : 100;
  }, [_]), mt = $.useMemo(function() {
    return w !== null && w <= 0 ? 1 : w;
  }, [w]), vt = $.useMemo(function() {
    return typeof D == "boolean" ? D ? mt : !1 : D >= 0 ? D : !1;
  }, [D, mt]), ke = $.useMemo(function() {
    return Object.keys(J || {}).map(function(dt) {
      var Ge = J[dt], Lt = {
        value: Number(dt)
      };
      return Ge && It(Ge) === "object" && !/* @__PURE__ */ $.isValidElement(Ge) && ("label" in Ge || "style" in Ge) ? (Lt.style = Ge.style, Lt.label = Ge.label) : Lt.label = Ge, Lt;
    }).filter(function(dt) {
      var Ge = dt.label;
      return Ge || typeof Ge == "number";
    }).sort(function(dt, Ge) {
      return dt.value - Ge.value;
    });
  }, [J]), xe = R9e(Ne, lt, mt, ke, L, vt), Re = he(xe, 2), yt = Re[0], Pt = Re[1], _t = wc(x, {
    value: C
  }), St = he(_t, 2), ft = St[0], kn = St[1], Dt = $.useMemo(function() {
    var dt = ft == null ? [] : Array.isArray(ft) ? ft : [ft], Ge = he(dt, 1), Lt = Ge[0], Ot = Lt === void 0 ? Ne : Lt, xn = ft === null ? [] : [Ot];
    if (ue) {
      if (xn = tt(dt), E || ft === void 0) {
        var mr = E >= 0 ? E + 1 : 2;
        for (xn = xn.slice(0, mr); xn.length < mr; ) {
          var Kn;
          xn.push((Kn = xn[xn.length - 1]) !== null && Kn !== void 0 ? Kn : Ne);
        }
      }
      xn.sort(function(Tn, Vr) {
        return Tn - Vr;
      });
    }
    return xn.forEach(function(Tn, Vr) {
      xn[Vr] = yt(Tn);
    }), xn;
  }, [ft, ue, Ne, E, yt]), nt = function(Ge) {
    return ue ? Ge : Ge[0];
  }, Be = Pr(function(dt) {
    var Ge = tt(dt).sort(function(Lt, Ot) {
      return Lt - Ot;
    });
    R && !Ug(Ge, Dt, !0) && R(nt(Ge)), kn(Ge);
  }), st = Pr(function(dt) {
    dt && me.current.hideHelp();
    var Ge = nt(Dt);
    O == null || O(Ge), sn(!O, "[rc-slider] `onAfterChange` is deprecated. Please use `onChangeComplete` instead."), P == null || P(Ge);
  }), pt = function(Ge) {
    if (!(u || !be || Dt.length <= Ve)) {
      var Lt = tt(Dt);
      Lt.splice(Ge, 1), I == null || I(nt(Lt)), Be(Lt);
      var Ot = Math.max(0, Ge - 1);
      me.current.hideHelp(), me.current.focus(Ot);
    }
  }, Et = A9e(pe, Te, Dt, Ne, lt, yt, Be, st, Pt, be, Ve), Ke = he(Et, 5), rt = Ke[0], Le = Ke[1], Xt = Ke[2], Ht = Ke[3], Ue = Ke[4], We = function(Ge, Lt) {
    if (!u) {
      var Ot = tt(Dt), xn = 0, mr = 0, Kn = lt - Ne;
      Dt.forEach(function(Cr, Xr) {
        var Tr = Math.abs(Ge - Cr);
        Tr <= Kn && (Kn = Tr, xn = Xr), Cr < Ge && (mr = Xr);
      });
      var Tn = xn;
      be && Kn !== 0 && (!ze || Dt.length < ze) ? (Ot.splice(mr + 1, 0, Ge), Tn = mr + 1) : Ot[xn] = Ge, ue && !Dt.length && E === void 0 && Ot.push(Ge);
      var Vr = nt(Ot);
      if (I == null || I(Vr), Be(Ot), Lt) {
        var Yr, vr;
        (Yr = document.activeElement) === null || Yr === void 0 || (vr = Yr.blur) === null || vr === void 0 || vr.call(Yr), me.current.focus(Tn), Ue(Lt, Tn, Ot);
      } else
        O == null || O(Vr), sn(!O, "[rc-slider] `onAfterChange` is deprecated. Please use `onChangeComplete` instead."), P == null || P(Vr);
    }
  }, ct = function(Ge) {
    Ge.preventDefault();
    var Lt = pe.current.getBoundingClientRect(), Ot = Lt.width, xn = Lt.height, mr = Lt.left, Kn = Lt.top, Tn = Lt.bottom, Vr = Lt.right, Yr = Ge.clientX, vr = Ge.clientY, Cr;
    switch (Te) {
      case "btt":
        Cr = (Tn - vr) / xn;
        break;
      case "ttb":
        Cr = (vr - Kn) / xn;
        break;
      case "rtl":
        Cr = (Vr - Yr) / Ot;
        break;
      default:
        Cr = (Yr - mr) / Ot;
    }
    var Xr = Ne + Cr * (lt - Ne);
    We(yt(Xr), Ge);
  }, ht = $.useState(null), Rt = he(ht, 2), Ft = Rt[0], re = Rt[1], Se = function(Ge, Lt) {
    if (!u) {
      var Ot = Pt(Dt, Ge, Lt);
      I == null || I(nt(Dt)), Be(Ot.values), re(Ot.value);
    }
  };
  $.useEffect(function() {
    if (Ft !== null) {
      var dt = Dt.indexOf(Ft);
      dt >= 0 && me.current.focus(dt);
    }
    re(null);
  }, [Ft]);
  var De = $.useMemo(function() {
    return Ie && mt === null ? (process.env.NODE_ENV !== "production" && sn(!1, "`draggableTrack` is not supported when `step` is `null`."), !1) : Ie;
  }, [Ie, mt]), Ye = Pr(function(dt, Ge) {
    Ue(dt, Ge), I == null || I(nt(Dt));
  }), $t = rt !== -1;
  $.useEffect(function() {
    if (!$t) {
      var dt = Dt.lastIndexOf(Le);
      me.current.focus(dt);
    }
  }, [$t]);
  var Ct = $.useMemo(function() {
    return tt(Ht).sort(function(dt, Ge) {
      return dt - Ge;
    });
  }, [Ht]), ut = $.useMemo(function() {
    return ue ? [Ct[0], Ct[Ct.length - 1]] : [Ne, Ct[0]];
  }, [Ct, ue, Ne]), Mt = he(ut, 2), Xe = Mt[0], je = Mt[1];
  $.useImperativeHandle(t, function() {
    return {
      focus: function() {
        me.current.focus(0);
      },
      blur: function() {
        var Ge, Lt = document, Ot = Lt.activeElement;
        (Ge = pe.current) !== null && Ge !== void 0 && Ge.contains(Ot) && (Ot == null || Ot.blur());
      }
    };
  }), $.useEffect(function() {
    h && me.current.focus(0);
  }, []);
  var Ze = $.useMemo(function() {
    return {
      min: Ne,
      max: lt,
      direction: Te,
      disabled: u,
      keyboard: f,
      step: mt,
      included: U,
      includedStart: Xe,
      includedEnd: je,
      range: ue,
      tabIndex: W,
      ariaLabelForHandle: se,
      ariaLabelledByForHandle: le,
      ariaValueTextFormatterForHandle: ge,
      styles: s || {},
      classNames: a || {}
    };
  }, [Ne, lt, Te, u, f, mt, U, Xe, je, ue, W, se, le, ge, s, a]);
  return /* @__PURE__ */ $.createElement(Xf.Provider, {
    value: Ze
  }, /* @__PURE__ */ $.createElement("div", {
    ref: pe,
    className: Ee(r, i, oe(oe(oe(oe({}, "".concat(r, "-disabled"), u), "".concat(r, "-vertical"), V), "".concat(r, "-horizontal"), !V), "".concat(r, "-with-marks"), ke.length)),
    style: o,
    onMouseDown: ct,
    id: c
  }, /* @__PURE__ */ $.createElement("div", {
    className: Ee("".concat(r, "-rail"), a == null ? void 0 : a.rail),
    style: ae(ae({}, X), s == null ? void 0 : s.rail)
  }), H !== !1 && /* @__PURE__ */ $.createElement(I9e, {
    prefixCls: r,
    style: Y,
    values: Dt,
    startPoint: Q,
    onStartMove: De ? Ye : void 0
  }), /* @__PURE__ */ $.createElement(T9e, {
    prefixCls: r,
    marks: ke,
    dots: K,
    style: ne,
    activeStyle: Z
  }), /* @__PURE__ */ $.createElement(Oee, {
    ref: me,
    prefixCls: r,
    style: q,
    values: Ht,
    draggingIndex: rt,
    draggingDelete: Xt,
    onStartMove: Ye,
    onOffsetChange: Se,
    onFocus: p,
    onBlur: g,
    handleRender: ee,
    activeHandleRender: te,
    onChangeComplete: st,
    onDelete: be ? pt : void 0
  }), /* @__PURE__ */ $.createElement(E9e, {
    prefixCls: r,
    marks: ke,
    onClick: We
  })));
});
process.env.NODE_ENV !== "production" && (Mee.displayName = "Slider");
const kee = /* @__PURE__ */ $.forwardRef((e, t) => {
  const {
    open: n,
    draggingDelete: r
  } = e, i = $e(null), o = n && !r, a = $e(null);
  function s() {
    Ln.cancel(a.current), a.current = null;
  }
  function c() {
    a.current = Ln(() => {
      var l;
      (l = i.current) === null || l === void 0 || l.forceAlign(), a.current = null;
    });
  }
  return $.useEffect(() => (o ? c() : s(), s), [o, e.title]), /* @__PURE__ */ $.createElement(od, Object.assign({
    ref: Ja(i, t)
  }, e, {
    open: o
  }));
});
process.env.NODE_ENV !== "production" && (kee.displayName = "SliderTooltip");
const qF = kee, O9e = (e) => {
  const {
    componentCls: t,
    antCls: n,
    controlSize: r,
    dotSize: i,
    marginFull: o,
    marginPart: a,
    colorFillContentHover: s,
    handleColorDisabled: c,
    calc: l,
    handleSize: u,
    handleSizeHover: d,
    handleActiveColor: f,
    handleActiveOutlineColor: h,
    handleLineWidth: p,
    handleLineWidthHover: g,
    motionDurationMid: m
  } = e;
  return {
    [t]: Object.assign(Object.assign({}, _a(e)), {
      position: "relative",
      height: r,
      margin: `${et(a)} ${et(o)}`,
      padding: 0,
      cursor: "pointer",
      touchAction: "none",
      "&-vertical": {
        margin: `${et(o)} ${et(a)}`
      },
      [`${t}-rail`]: {
        position: "absolute",
        backgroundColor: e.railBg,
        borderRadius: e.borderRadiusXS,
        transition: `background-color ${m}`
      },
      [`${t}-track,${t}-tracks`]: {
        position: "absolute",
        transition: `background-color ${m}`
      },
      [`${t}-track`]: {
        backgroundColor: e.trackBg,
        borderRadius: e.borderRadiusXS
      },
      [`${t}-track-draggable`]: {
        boxSizing: "content-box",
        backgroundClip: "content-box",
        border: "solid rgba(0,0,0,0)"
      },
      "&:hover": {
        [`${t}-rail`]: {
          backgroundColor: e.railHoverBg
        },
        [`${t}-track`]: {
          backgroundColor: e.trackHoverBg
        },
        [`${t}-dot`]: {
          borderColor: s
        },
        [`${t}-handle::after`]: {
          boxShadow: `0 0 0 ${et(p)} ${e.colorPrimaryBorderHover}`
        },
        [`${t}-dot-active`]: {
          borderColor: e.dotActiveBorderColor
        }
      },
      [`${t}-handle`]: {
        position: "absolute",
        width: u,
        height: u,
        outline: "none",
        userSelect: "none",
        // Dragging status
        "&-dragging-delete": {
          opacity: 0
        },
        // 扩大选区
        "&::before": {
          content: '""',
          position: "absolute",
          insetInlineStart: l(p).mul(-1).equal(),
          insetBlockStart: l(p).mul(-1).equal(),
          width: l(u).add(l(p).mul(2)).equal(),
          height: l(u).add(l(p).mul(2)).equal(),
          backgroundColor: "transparent"
        },
        "&::after": {
          content: '""',
          position: "absolute",
          insetBlockStart: 0,
          insetInlineStart: 0,
          width: u,
          height: u,
          backgroundColor: e.colorBgElevated,
          boxShadow: `0 0 0 ${et(p)} ${e.handleColor}`,
          outline: "0px solid transparent",
          borderRadius: "50%",
          cursor: "pointer",
          transition: `
            inset-inline-start ${m},
            inset-block-start ${m},
            width ${m},
            height ${m},
            box-shadow ${m},
            outline ${m}
          `
        },
        "&:hover, &:active, &:focus": {
          "&::before": {
            insetInlineStart: l(d).sub(u).div(2).add(g).mul(-1).equal(),
            insetBlockStart: l(d).sub(u).div(2).add(g).mul(-1).equal(),
            width: l(d).add(l(g).mul(2)).equal(),
            height: l(d).add(l(g).mul(2)).equal()
          },
          "&::after": {
            boxShadow: `0 0 0 ${et(g)} ${f}`,
            outline: `6px solid ${h}`,
            width: d,
            height: d,
            insetInlineStart: e.calc(u).sub(d).div(2).equal(),
            insetBlockStart: e.calc(u).sub(d).div(2).equal()
          }
        }
      },
      [`&-lock ${t}-handle`]: {
        "&::before, &::after": {
          transition: "none"
        }
      },
      [`${t}-mark`]: {
        position: "absolute",
        fontSize: e.fontSize
      },
      [`${t}-mark-text`]: {
        position: "absolute",
        display: "inline-block",
        color: e.colorTextDescription,
        textAlign: "center",
        wordBreak: "keep-all",
        cursor: "pointer",
        userSelect: "none",
        "&-active": {
          color: e.colorText
        }
      },
      [`${t}-step`]: {
        position: "absolute",
        background: "transparent",
        pointerEvents: "none"
      },
      [`${t}-dot`]: {
        position: "absolute",
        width: i,
        height: i,
        backgroundColor: e.colorBgElevated,
        border: `${et(p)} solid ${e.dotBorderColor}`,
        borderRadius: "50%",
        cursor: "pointer",
        transition: `border-color ${e.motionDurationSlow}`,
        pointerEvents: "auto",
        "&-active": {
          borderColor: e.dotActiveBorderColor
        }
      },
      [`&${t}-disabled`]: {
        cursor: "not-allowed",
        [`${t}-rail`]: {
          backgroundColor: `${e.railBg} !important`
        },
        [`${t}-track`]: {
          backgroundColor: `${e.trackBgDisabled} !important`
        },
        [`
          ${t}-dot
        `]: {
          backgroundColor: e.colorBgElevated,
          borderColor: e.trackBgDisabled,
          boxShadow: "none",
          cursor: "not-allowed"
        },
        [`${t}-handle::after`]: {
          backgroundColor: e.colorBgElevated,
          cursor: "not-allowed",
          width: u,
          height: u,
          boxShadow: `0 0 0 ${et(p)} ${c}`,
          insetInlineStart: 0,
          insetBlockStart: 0
        },
        [`
          ${t}-mark-text,
          ${t}-dot
        `]: {
          cursor: "not-allowed !important"
        }
      },
      [`&-tooltip ${n}-tooltip-inner`]: {
        minWidth: "unset"
      }
    })
  };
}, Nee = (e, t) => {
  const {
    componentCls: n,
    railSize: r,
    handleSize: i,
    dotSize: o,
    marginFull: a,
    calc: s
  } = e, c = t ? "paddingBlock" : "paddingInline", l = t ? "width" : "height", u = t ? "height" : "width", d = t ? "insetBlockStart" : "insetInlineStart", f = t ? "top" : "insetInlineStart", h = s(r).mul(3).sub(i).div(2).equal(), p = s(i).sub(r).div(2).equal(), g = t ? {
    borderWidth: `${et(p)} 0`,
    transform: `translateY(${et(s(p).mul(-1).equal())})`
  } : {
    borderWidth: `0 ${et(p)}`,
    transform: `translateX(${et(e.calc(p).mul(-1).equal())})`
  };
  return {
    [c]: r,
    [u]: s(r).mul(3).equal(),
    [`${n}-rail`]: {
      [l]: "100%",
      [u]: r
    },
    [`${n}-track,${n}-tracks`]: {
      [u]: r
    },
    [`${n}-track-draggable`]: Object.assign({}, g),
    [`${n}-handle`]: {
      [d]: h
    },
    [`${n}-mark`]: {
      // Reset all
      insetInlineStart: 0,
      top: 0,
      // https://github.com/ant-design/ant-design/issues/43731
      [f]: s(r).mul(3).add(t ? 0 : a).equal(),
      [l]: "100%"
    },
    [`${n}-step`]: {
      // Reset all
      insetInlineStart: 0,
      top: 0,
      [f]: r,
      [l]: "100%",
      [u]: r
    },
    [`${n}-dot`]: {
      position: "absolute",
      [d]: s(r).sub(o).div(2).equal()
    }
  };
}, M9e = (e) => {
  const {
    componentCls: t,
    marginPartWithMark: n
  } = e;
  return {
    [`${t}-horizontal`]: Object.assign(Object.assign({}, Nee(e, !0)), {
      [`&${t}-with-marks`]: {
        marginBottom: n
      }
    })
  };
}, k9e = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}-vertical`]: Object.assign(Object.assign({}, Nee(e, !1)), {
      height: "100%"
    })
  };
}, N9e = (e) => {
  const n = e.controlHeightLG / 4, r = e.controlHeightSM / 2, i = e.lineWidth + 1, o = e.lineWidth + 1 * 1.5, a = e.colorPrimary, s = new Mn(a).setAlpha(0.2).toRgbString();
  return {
    controlSize: n,
    railSize: 4,
    handleSize: n,
    handleSizeHover: r,
    dotSize: 8,
    handleLineWidth: i,
    handleLineWidthHover: o,
    railBg: e.colorFillTertiary,
    railHoverBg: e.colorFillSecondary,
    trackBg: e.colorPrimaryBorder,
    trackHoverBg: e.colorPrimaryBorderHover,
    handleColor: e.colorPrimaryBorder,
    handleActiveColor: a,
    handleActiveOutlineColor: s,
    handleColorDisabled: new Mn(e.colorTextDisabled).onBackground(e.colorBgContainer).toHexShortString(),
    dotBorderColor: e.colorBorderSecondary,
    dotActiveBorderColor: e.colorPrimaryBorder,
    trackBgDisabled: e.colorBgContainerDisabled
  };
}, D9e = Za("Slider", (e) => {
  const t = Mr(e, {
    marginPart: e.calc(e.controlHeight).sub(e.controlSize).div(2).equal(),
    marginFull: e.calc(e.controlSize).div(2).equal(),
    marginPartWithMark: e.calc(e.controlHeightLG).sub(e.controlSize).equal()
  });
  return [O9e(t), M9e(t), k9e(t)];
}, N9e), j9e = /* @__PURE__ */ Ca({}), L9e = j9e;
function FT() {
  const [e, t] = $.useState(!1), n = $.useRef(), r = () => {
    Ln.cancel(n.current);
  }, i = (o) => {
    r(), o ? t(o) : n.current = Ln(() => {
      t(o);
    });
  };
  return $.useEffect(() => r, []), [e, i];
}
var F9e = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
function V9e(e, t) {
  return e || e === null ? e : t || t === null ? t : (n) => typeof n == "number" ? n.toString() : "";
}
const Dee = /* @__PURE__ */ j.forwardRef((e, t) => {
  const {
    prefixCls: n,
    range: r,
    className: i,
    rootClassName: o,
    style: a,
    disabled: s,
    // Deprecated Props
    tooltipPrefixCls: c,
    tipFormatter: l,
    tooltipVisible: u,
    getTooltipPopupContainer: d,
    tooltipPlacement: f,
    tooltip: h = {},
    onChangeComplete: p
  } = e, g = F9e(e, ["prefixCls", "range", "className", "rootClassName", "style", "disabled", "tooltipPrefixCls", "tipFormatter", "tooltipVisible", "getTooltipPopupContainer", "tooltipPlacement", "tooltip", "onChangeComplete"]), {
    vertical: m
  } = e, {
    direction: v,
    slider: y,
    getPrefixCls: _,
    getPopupContainer: b
  } = j.useContext(Cn), w = j.useContext(id), C = s ?? w, {
    handleRender: x,
    direction: T
  } = j.useContext(L9e), R = (T || v) === "rtl", [I, O] = FT(), [P, k] = FT(), L = Object.assign({}, h), {
    open: N,
    placement: D,
    getPopupContainer: z,
    prefixCls: V,
    formatter: B
  } = L, U = N ?? u, Q = (I || P) && U !== !1, Y = V9e(B, l), [q, X] = FT(), ne = (ge) => {
    p == null || p(ge), X(!1);
  }, Z = (ge, me) => ge || (me ? R ? "left" : "right" : "top"), J = _("slider", n), [K, ee, te] = D9e(J), H = Ee(i, y == null ? void 0 : y.className, o, {
    [`${J}-rtl`]: R,
    [`${J}-lock`]: q
  }, ee, te);
  if (R && !g.vertical && (g.reverse = !g.reverse), process.env.NODE_ENV !== "production") {
    const ge = di("Slider");
    [["tooltipPrefixCls", "prefixCls"], ["getTooltipPopupContainer", "getPopupContainer"], ["tipFormatter", "formatter"], ["tooltipPlacement", "placement"], ["tooltipVisible", "open"]].forEach((me) => {
      let [pe, Te] = me;
      ge.deprecated(!(pe in e), pe, `tooltip.${Te}`);
    });
  }
  j.useEffect(() => {
    const ge = () => {
      Ln(() => {
        k(!1);
      }, 1);
    };
    return document.addEventListener("mouseup", ge), () => {
      document.removeEventListener("mouseup", ge);
    };
  }, []);
  const ie = r && !U, W = x || ((ge, me) => {
    const {
      index: pe
    } = me, Te = ge.props;
    function de(Ie, Ve, ze) {
      var Ne, lt, mt, vt;
      ze && ((lt = (Ne = g)[Ie]) === null || lt === void 0 || lt.call(Ne, Ve)), (vt = (mt = Te)[Ie]) === null || vt === void 0 || vt.call(mt, Ve);
    }
    const Ae = Object.assign(Object.assign({}, Te), {
      onMouseEnter: (Ie) => {
        O(!0), de("onMouseEnter", Ie);
      },
      onMouseLeave: (Ie) => {
        O(!1), de("onMouseLeave", Ie);
      },
      onMouseDown: (Ie) => {
        k(!0), X(!0), de("onMouseDown", Ie);
      },
      onFocus: (Ie) => {
        var Ve;
        k(!0), (Ve = g.onFocus) === null || Ve === void 0 || Ve.call(g, Ie), de("onFocus", Ie, !0);
      },
      onBlur: (Ie) => {
        var Ve;
        k(!1), (Ve = g.onBlur) === null || Ve === void 0 || Ve.call(g, Ie), de("onBlur", Ie, !0);
      }
    }), ue = /* @__PURE__ */ j.cloneElement(ge, Ae), be = (!!U || Q) && Y !== null;
    return ie ? ue : /* @__PURE__ */ j.createElement(qF, Object.assign({}, L, {
      prefixCls: _("tooltip", V ?? c),
      title: Y ? Y(me.value) : "",
      open: be,
      placement: Z(D ?? f, m),
      key: pe,
      overlayClassName: `${J}-tooltip`,
      getPopupContainer: z || d || b
    }), ue);
  }), se = ie ? (ge, me) => {
    const pe = /* @__PURE__ */ j.cloneElement(ge, {
      style: Object.assign(Object.assign({}, ge.props.style), {
        visibility: "hidden"
      })
    });
    return /* @__PURE__ */ j.createElement(qF, Object.assign({}, L, {
      prefixCls: _("tooltip", V ?? c),
      title: Y ? Y(me.value) : "",
      open: Y !== null && Q,
      placement: Z(D ?? f, m),
      key: "tooltip",
      overlayClassName: `${J}-tooltip`,
      getPopupContainer: z || d || b,
      draggingDelete: me.draggingDelete
    }), pe);
  } : void 0, le = Object.assign(Object.assign({}, y == null ? void 0 : y.style), a);
  return K(
    // @ts-ignore
    /* @__PURE__ */ j.createElement(Mee, Object.assign({}, g, {
      step: g.step,
      range: r,
      className: H,
      style: le,
      disabled: C,
      ref: t,
      prefixCls: J,
      handleRender: W,
      activeHandleRender: se,
      onChangeComplete: ne
    }))
  );
});
process.env.NODE_ENV !== "production" && (Dee.displayName = "Slider");
const CR = Dee, gw = 100, jee = gw / 5, Lee = gw / 2 - jee / 2, VT = Lee * 2 * Math.PI, GF = 50, KF = (e) => {
  const {
    dotClassName: t,
    style: n,
    hasCircleCls: r
  } = e;
  return /* @__PURE__ */ $.createElement("circle", {
    className: Ee(`${t}-circle`, {
      [`${t}-circle-bg`]: r
    }),
    r: Lee,
    cx: GF,
    cy: GF,
    strokeWidth: jee,
    style: n
  });
}, B9e = (e) => {
  let {
    percent: t,
    prefixCls: n
  } = e;
  const r = `${n}-dot`, i = `${r}-holder`, o = `${i}-hidden`, [a, s] = $.useState(!1);
  ar(() => {
    t !== 0 && s(!0);
  }, [t !== 0]);
  const c = Math.max(Math.min(t, 100), 0);
  if (!a)
    return null;
  const l = {
    strokeDashoffset: `${VT / 4}`,
    strokeDasharray: `${VT * c / 100} ${VT * (100 - c) / 100}`
  };
  return /* @__PURE__ */ $.createElement("span", {
    className: Ee(i, `${r}-progress`, c <= 0 && o)
  }, /* @__PURE__ */ $.createElement("svg", {
    viewBox: `0 0 ${gw} ${gw}`,
    // biome-ignore lint/a11y/noNoninteractiveElementToInteractiveRole: progressbar could be readonly
    role: "progressbar",
    "aria-valuemin": 0,
    "aria-valuemax": 100,
    "aria-valuenow": c
  }, /* @__PURE__ */ $.createElement(KF, {
    dotClassName: r,
    hasCircleCls: !0
  }), /* @__PURE__ */ $.createElement(KF, {
    dotClassName: r,
    style: l
  })));
}, z9e = B9e;
function H9e(e) {
  const {
    prefixCls: t,
    percent: n = 0
  } = e, r = `${t}-dot`, i = `${r}-holder`, o = `${i}-hidden`;
  return /* @__PURE__ */ $.createElement($.Fragment, null, /* @__PURE__ */ $.createElement("span", {
    className: Ee(i, n > 0 && o)
  }, /* @__PURE__ */ $.createElement("span", {
    className: Ee(r, `${t}-dot-spin`)
  }, [1, 2, 3, 4].map((a) => /* @__PURE__ */ $.createElement("i", {
    className: `${t}-dot-item`,
    key: a
  })))), /* @__PURE__ */ $.createElement(z9e, {
    prefixCls: t,
    percent: n
  }));
}
function U9e(e) {
  const {
    prefixCls: t,
    indicator: n,
    percent: r
  } = e, i = `${t}-dot`;
  return n && /* @__PURE__ */ $.isValidElement(n) ? Jg(n, {
    className: Ee(n.props.className, i),
    percent: r
  }) : /* @__PURE__ */ $.createElement(H9e, {
    prefixCls: t,
    percent: r
  });
}
const W9e = new Pn("antSpinMove", {
  to: {
    opacity: 1
  }
}), q9e = new Pn("antRotate", {
  to: {
    transform: "rotate(405deg)"
  }
}), G9e = (e) => {
  const {
    componentCls: t,
    calc: n
  } = e;
  return {
    [t]: Object.assign(Object.assign({}, _a(e)), {
      position: "absolute",
      display: "none",
      color: e.colorPrimary,
      fontSize: 0,
      textAlign: "center",
      verticalAlign: "middle",
      opacity: 0,
      transition: `transform ${e.motionDurationSlow} ${e.motionEaseInOutCirc}`,
      "&-spinning": {
        position: "relative",
        display: "inline-block",
        opacity: 1
      },
      [`${t}-text`]: {
        fontSize: e.fontSize,
        paddingTop: n(n(e.dotSize).sub(e.fontSize)).div(2).add(2).equal()
      },
      "&-fullscreen": {
        position: "fixed",
        width: "100vw",
        height: "100vh",
        backgroundColor: e.colorBgMask,
        zIndex: e.zIndexPopupBase,
        inset: 0,
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "center",
        opacity: 0,
        visibility: "hidden",
        transition: `all ${e.motionDurationMid}`,
        "&-show": {
          opacity: 1,
          visibility: "visible"
        },
        [t]: {
          [`${t}-dot-holder`]: {
            color: e.colorWhite
          },
          [`${t}-text`]: {
            color: e.colorTextLightSolid
          }
        }
      },
      "&-nested-loading": {
        position: "relative",
        [`> div > ${t}`]: {
          position: "absolute",
          top: 0,
          insetInlineStart: 0,
          zIndex: 4,
          display: "block",
          width: "100%",
          height: "100%",
          maxHeight: e.contentHeight,
          [`${t}-dot`]: {
            position: "absolute",
            top: "50%",
            insetInlineStart: "50%",
            margin: n(e.dotSize).mul(-1).div(2).equal()
          },
          [`${t}-text`]: {
            position: "absolute",
            top: "50%",
            width: "100%",
            textShadow: `0 1px 2px ${e.colorBgContainer}`
            // FIXME: shadow
          },
          [`&${t}-show-text ${t}-dot`]: {
            marginTop: n(e.dotSize).div(2).mul(-1).sub(10).equal()
          },
          "&-sm": {
            [`${t}-dot`]: {
              margin: n(e.dotSizeSM).mul(-1).div(2).equal()
            },
            [`${t}-text`]: {
              paddingTop: n(n(e.dotSizeSM).sub(e.fontSize)).div(2).add(2).equal()
            },
            [`&${t}-show-text ${t}-dot`]: {
              marginTop: n(e.dotSizeSM).div(2).mul(-1).sub(10).equal()
            }
          },
          "&-lg": {
            [`${t}-dot`]: {
              margin: n(e.dotSizeLG).mul(-1).div(2).equal()
            },
            [`${t}-text`]: {
              paddingTop: n(n(e.dotSizeLG).sub(e.fontSize)).div(2).add(2).equal()
            },
            [`&${t}-show-text ${t}-dot`]: {
              marginTop: n(e.dotSizeLG).div(2).mul(-1).sub(10).equal()
            }
          }
        },
        [`${t}-container`]: {
          position: "relative",
          transition: `opacity ${e.motionDurationSlow}`,
          "&::after": {
            position: "absolute",
            top: 0,
            insetInlineEnd: 0,
            bottom: 0,
            insetInlineStart: 0,
            zIndex: 10,
            width: "100%",
            height: "100%",
            background: e.colorBgContainer,
            opacity: 0,
            transition: `all ${e.motionDurationSlow}`,
            content: '""',
            pointerEvents: "none"
          }
        },
        [`${t}-blur`]: {
          clear: "both",
          opacity: 0.5,
          userSelect: "none",
          pointerEvents: "none",
          "&::after": {
            opacity: 0.4,
            pointerEvents: "auto"
          }
        }
      },
      // tip
      // ------------------------------
      "&-tip": {
        color: e.spinDotDefault
      },
      // holder
      // ------------------------------
      [`${t}-dot-holder`]: {
        width: "1em",
        height: "1em",
        fontSize: e.dotSize,
        display: "inline-block",
        transition: `transform ${e.motionDurationSlow} ease, opacity ${e.motionDurationSlow} ease`,
        transformOrigin: "50% 50%",
        lineHeight: 1,
        color: e.colorPrimary,
        "&-hidden": {
          transform: "scale(0.3)",
          opacity: 0
        }
      },
      // progress
      // ------------------------------
      [`${t}-dot-progress`]: {
        position: "absolute",
        top: "50%",
        transform: "translate(-50%, -50%)",
        insetInlineStart: "50%"
      },
      // dots
      // ------------------------------
      [`${t}-dot`]: {
        position: "relative",
        display: "inline-block",
        fontSize: e.dotSize,
        width: "1em",
        height: "1em",
        "&-item": {
          position: "absolute",
          display: "block",
          width: n(e.dotSize).sub(n(e.marginXXS).div(2)).div(2).equal(),
          height: n(e.dotSize).sub(n(e.marginXXS).div(2)).div(2).equal(),
          background: "currentColor",
          borderRadius: "100%",
          transform: "scale(0.75)",
          transformOrigin: "50% 50%",
          opacity: 0.3,
          animationName: W9e,
          animationDuration: "1s",
          animationIterationCount: "infinite",
          animationTimingFunction: "linear",
          animationDirection: "alternate",
          "&:nth-child(1)": {
            top: 0,
            insetInlineStart: 0,
            animationDelay: "0s"
          },
          "&:nth-child(2)": {
            top: 0,
            insetInlineEnd: 0,
            animationDelay: "0.4s"
          },
          "&:nth-child(3)": {
            insetInlineEnd: 0,
            bottom: 0,
            animationDelay: "0.8s"
          },
          "&:nth-child(4)": {
            bottom: 0,
            insetInlineStart: 0,
            animationDelay: "1.2s"
          }
        },
        "&-spin": {
          transform: "rotate(45deg)",
          animationName: q9e,
          animationDuration: "1.2s",
          animationIterationCount: "infinite",
          animationTimingFunction: "linear"
        },
        "&-circle": {
          strokeLinecap: "round",
          transition: ["stroke-dashoffset", "stroke-dasharray", "stroke", "stroke-width", "opacity"].map((r) => `${r} ${e.motionDurationSlow} ease`).join(","),
          fillOpacity: 0,
          stroke: "currentcolor"
        },
        "&-circle-bg": {
          stroke: e.colorFillSecondary
        }
      },
      // small
      [`&-sm ${t}-dot`]: {
        "&, &-holder": {
          fontSize: e.dotSizeSM
        }
      },
      [`&-sm ${t}-dot-holder`]: {
        i: {
          width: n(n(e.dotSizeSM).sub(n(e.marginXXS).div(2))).div(2).equal(),
          height: n(n(e.dotSizeSM).sub(n(e.marginXXS).div(2))).div(2).equal()
        }
      },
      // large
      [`&-lg ${t}-dot`]: {
        "&, &-holder": {
          fontSize: e.dotSizeLG
        }
      },
      [`&-lg ${t}-dot-holder`]: {
        i: {
          width: n(n(e.dotSizeLG).sub(e.marginXXS)).div(2).equal(),
          height: n(n(e.dotSizeLG).sub(e.marginXXS)).div(2).equal()
        }
      },
      [`&${t}-show-text ${t}-text`]: {
        display: "block"
      }
    })
  };
}, K9e = (e) => {
  const {
    controlHeightLG: t,
    controlHeight: n
  } = e;
  return {
    contentHeight: 400,
    dotSize: t / 2,
    dotSizeSM: t * 0.35,
    dotSizeLG: n
  };
}, Y9e = Za("Spin", (e) => {
  const t = Mr(e, {
    spinDotDefault: e.colorTextDescription
  });
  return [G9e(t)];
}, K9e), X9e = 200, YF = [[30, 0.05], [70, 0.03], [96, 0.01]];
function Q9e(e, t) {
  const [n, r] = $.useState(0), i = $.useRef(), o = t === "auto";
  return $.useEffect(() => (o && e && (r(0), i.current = setInterval(() => {
    r((a) => {
      const s = 100 - a;
      for (let c = 0; c < YF.length; c += 1) {
        const [l, u] = YF[c];
        if (a <= l)
          return a + s * u;
      }
      return a;
    });
  }, X9e)), () => {
    clearInterval(i.current);
  }), [o, e]), o ? n : t;
}
var J9e = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
let Fee;
function Z9e(e, t) {
  return !!e && !!t && !isNaN(Number(t));
}
const i3 = (e) => {
  var t;
  const {
    prefixCls: n,
    spinning: r = !0,
    delay: i = 0,
    className: o,
    rootClassName: a,
    size: s = "default",
    tip: c,
    wrapperClassName: l,
    style: u,
    children: d,
    fullscreen: f = !1,
    indicator: h,
    percent: p
  } = e, g = J9e(e, ["prefixCls", "spinning", "delay", "className", "rootClassName", "size", "tip", "wrapperClassName", "style", "children", "fullscreen", "indicator", "percent"]), {
    getPrefixCls: m,
    direction: v,
    spin: y
  } = $.useContext(Cn), _ = m("spin", n), [b, w, C] = Y9e(_), [x, T] = $.useState(() => r && !Z9e(r, i)), E = Q9e(x, p);
  $.useEffect(() => {
    if (r) {
      const N = cFe(i, () => {
        T(!0);
      });
      return N(), () => {
        var D;
        (D = N == null ? void 0 : N.cancel) === null || D === void 0 || D.call(N);
      };
    }
    T(!1);
  }, [i, r]);
  const R = $.useMemo(() => typeof d < "u" && !f, [d, f]);
  if (process.env.NODE_ENV !== "production") {
    const N = di("Spin");
    process.env.NODE_ENV !== "production" && N(!c || R || f, "usage", "`tip` only work in nest or fullscreen pattern.");
  }
  const I = Ee(_, y == null ? void 0 : y.className, {
    [`${_}-sm`]: s === "small",
    [`${_}-lg`]: s === "large",
    [`${_}-spinning`]: x,
    [`${_}-show-text`]: !!c,
    [`${_}-rtl`]: v === "rtl"
  }, o, !f && a, w, C), O = Ee(`${_}-container`, {
    [`${_}-blur`]: x
  }), P = (t = h ?? (y == null ? void 0 : y.indicator)) !== null && t !== void 0 ? t : Fee, k = Object.assign(Object.assign({}, y == null ? void 0 : y.style), u), L = /* @__PURE__ */ $.createElement("div", Object.assign({}, g, {
    style: k,
    className: I,
    "aria-live": "polite",
    "aria-busy": x
  }), /* @__PURE__ */ $.createElement(U9e, {
    prefixCls: _,
    indicator: P,
    percent: E
  }), c && (R || f) ? /* @__PURE__ */ $.createElement("div", {
    className: `${_}-text`
  }, c) : null);
  return b(R ? /* @__PURE__ */ $.createElement("div", Object.assign({}, g, {
    className: Ee(`${_}-nested-loading`, l, w, C)
  }), x && /* @__PURE__ */ $.createElement("div", {
    key: "loading"
  }, L), /* @__PURE__ */ $.createElement("div", {
    className: O,
    key: "container"
  }, d)) : f ? /* @__PURE__ */ $.createElement("div", {
    className: Ee(`${_}-fullscreen`, {
      [`${_}-fullscreen-show`]: x
    }, a, w, C)
  }, L) : L);
};
i3.setDefaultIndicator = (e) => {
  Fee = e;
};
process.env.NODE_ENV !== "production" && (i3.displayName = "Spin");
const tp = i3;
let Da = null, Fd = (e) => e(), Mv = [], kv = {};
function XF() {
  const {
    getContainer: e,
    duration: t,
    rtl: n,
    maxCount: r,
    top: i
  } = kv, o = (e == null ? void 0 : e()) || document.body;
  return {
    getContainer: () => o,
    duration: t,
    rtl: n,
    maxCount: r,
    top: i
  };
}
const eVe = /* @__PURE__ */ j.forwardRef((e, t) => {
  const {
    messageConfig: n,
    sync: r
  } = e, {
    getPrefixCls: i
  } = gt(Cn), o = kv.prefixCls || i("message"), a = gt(h8e), [s, c] = UJ(Object.assign(Object.assign(Object.assign({}, n), {
    prefixCls: o
  }), a.message));
  return j.useImperativeHandle(t, () => {
    const l = Object.assign({}, s);
    return Object.keys(l).forEach((u) => {
      l[u] = function() {
        return r(), s[u].apply(s, arguments);
      };
    }), {
      instance: l,
      sync: r
    };
  }), c;
}), tVe = /* @__PURE__ */ j.forwardRef((e, t) => {
  const [n, r] = j.useState(XF), i = () => {
    r(XF);
  };
  j.useEffect(i, []);
  const o = pJ(), a = o.getRootPrefixCls(), s = o.getIconPrefixCls(), c = o.getTheme(), l = /* @__PURE__ */ j.createElement(eVe, {
    ref: t,
    sync: i,
    messageConfig: n
  });
  return /* @__PURE__ */ j.createElement(go, {
    prefixCls: a,
    iconPrefixCls: s,
    theme: c
  }, o.holderRender ? o.holderRender(l) : l);
});
function rC() {
  if (!Da) {
    const e = document.createDocumentFragment(), t = {
      fragment: e
    };
    Da = t, Fd(() => {
      WJ(/* @__PURE__ */ j.createElement(tVe, {
        ref: (n) => {
          const {
            instance: r,
            sync: i
          } = n || {};
          Promise.resolve().then(() => {
            !t.instance && r && (t.instance = r, t.sync = i, rC());
          });
        }
      }), e);
    });
    return;
  }
  Da.instance && (Mv.forEach((e) => {
    const {
      type: t,
      skipped: n
    } = e;
    if (!n)
      switch (t) {
        case "open": {
          Fd(() => {
            const r = Da.instance.open(Object.assign(Object.assign({}, kv), e.config));
            r == null || r.then(e.resolve), e.setCloseFn(r);
          });
          break;
        }
        case "destroy":
          Fd(() => {
            Da == null || Da.instance.destroy(e.key);
          });
          break;
        default:
          Fd(() => {
            var r;
            const i = (r = Da.instance)[t].apply(r, tt(e.args));
            i == null || i.then(e.resolve), e.setCloseFn(i);
          });
      }
  }), Mv = []);
}
function nVe(e) {
  kv = Object.assign(Object.assign({}, kv), e), Fd(() => {
    var t;
    (t = Da == null ? void 0 : Da.sync) === null || t === void 0 || t.call(Da);
  });
}
function rVe(e) {
  const t = IM((n) => {
    let r;
    const i = {
      type: "open",
      config: e,
      resolve: n,
      setCloseFn: (o) => {
        r = o;
      }
    };
    return Mv.push(i), () => {
      r ? Fd(() => {
        r();
      }) : i.skipped = !0;
    };
  });
  return rC(), t;
}
function iVe(e, t) {
  const n = pJ();
  process.env.NODE_ENV !== "production" && !n.holderRender && fke("message");
  const r = IM((i) => {
    let o;
    const a = {
      type: e,
      args: t,
      resolve: i,
      setCloseFn: (s) => {
        o = s;
      }
    };
    return Mv.push(a), () => {
      o ? Fd(() => {
        o();
      }) : a.skipped = !0;
    };
  });
  return rC(), r;
}
const oVe = (e) => {
  Mv.push({
    type: "destroy",
    key: e
  }), rC();
}, aVe = ["success", "info", "warning", "error", "loading"], sVe = {
  open: rVe,
  destroy: oVe,
  config: nVe,
  useMessage: k4e,
  _InternalPanelDoNotUseOrYouWillBeFired: T4e
}, Vee = sVe;
aVe.forEach((e) => {
  Vee[e] = function() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    return iVe(e, n);
  };
});
process.env.NODE_ENV;
process.env.NODE_ENV;
const cVe = Vee;
var lVe = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M300 276.5a56 56 0 1056-97 56 56 0 00-56 97zm0 284a56 56 0 1056-97 56 56 0 00-56 97zM640 228a56 56 0 10112 0 56 56 0 00-112 0zm0 284a56 56 0 10112 0 56 56 0 00-112 0zM300 844.5a56 56 0 1056-97 56 56 0 00-56 97zM640 796a56 56 0 10112 0 56 56 0 00-112 0z" } }] }, name: "holder", theme: "outlined" };
const uVe = lVe;
var dVe = function(t, n) {
  return /* @__PURE__ */ $.createElement(mo, xt({}, t, {
    ref: n,
    icon: uVe
  }));
}, Bee = /* @__PURE__ */ $.forwardRef(dVe);
process.env.NODE_ENV !== "production" && (Bee.displayName = "HolderOutlined");
const zee = Bee;
var fVe = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }, { tag: "path", attrs: { d: "M464 336a48 48 0 1096 0 48 48 0 10-96 0zm72 112h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V456c0-4.4-3.6-8-8-8z" } }] }, name: "info-circle", theme: "outlined" };
const hVe = fVe;
var gVe = function(t, n) {
  return /* @__PURE__ */ $.createElement(mo, xt({}, t, {
    ref: n,
    icon: hVe
  }));
}, Hee = /* @__PURE__ */ $.forwardRef(gVe);
process.env.NODE_ENV !== "production" && (Hee.displayName = "InfoCircleOutlined");
const pVe = Hee;
class mVe extends _le {
  constructor() {
    super();
    ve(this, "antdMessage");
    ve(this, "index", 0);
    this.antdMessage = cVe, this.antdMessage.config({ prefixCls: "prefix-survey-message", maxCount: 2, duration: 4 });
  }
  info(n) {
    this.addMessage(n, "info");
  }
  success(n) {
    this.addMessage(n, "success");
  }
  warning(n) {
    this.addMessage(n, "warning");
  }
  error(n) {
    this.addMessage(n, "error", /* @__PURE__ */ A.jsx(CM, { style: { color: "var(--error)" } }));
  }
  addMessage(n, r, i) {
    const o = this.index;
    this.antdMessage.open({
      key: o,
      content: /* @__PURE__ */ A.jsx(
        vVe,
        {
          type: r,
          message: n,
          closable: !0,
          closeIcon: /* @__PURE__ */ A.jsx(zE, {}),
          onClose: () => this.destroy(o),
          icon: i,
          showIcon: !0
        }
      ),
      className: "survey-message"
    }), this.index++;
  }
  destroy(n) {
    this.antdMessage.destroy(n);
  }
  destroyAll() {
    this.antdMessage.destroy();
  }
  config(n) {
    this.antdMessage.config({ ...n, prefixCls: "prefix-survey-message" });
  }
  setContainer(n) {
    this.antdMessage.config({ getContainer: () => n });
  }
}
const vVe = ce(o4e)`
  font-family: 'Rethink Sans', sans-serif;
  background-color: #ffffff;
  text-align: start;
  border: 0;
  width: 100%;

  > .ant-alert-icon {
    margin-right: 11px;
  }

  > .ant-alert-close-icon {
    margin-left: 11px;
  }
`;
class yVe extends Sle {
  constructor() {
    super(...arguments);
    ve(this, "helpPopup", new Gs({ content: null }));
  }
  setPopup(n, r, i, o) {
    if (i === !1 || o !== void 0 && !o.includes(r) || !Object.keys(n).includes(r))
      return;
    const a = n[r];
    this.helpPopup.next(a);
  }
  clearPopup() {
    this.helpPopup.next({ content: null });
  }
  observePopup() {
    return this.helpPopup;
  }
}
const iC = Ca({
  surveyName: ""
});
var bVe = "firebase", _Ve = "11.10.0";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
ta(bVe, _Ve, "app");
function qCt(e) {
  const t = oW(e);
  return sEe(t, { experimentalAutoDetectLongPolling: !0 }), t;
}
function yl(e, t) {
  const { loggingService: n } = gt(mn), [r, i] = Qe({ choices: [] });
  return ot(() => {
    n.info("useChoices useEffect", e, t);
    let o = !0;
    return typeof e == "function" ? Promise.resolve(e({ answers: t })).then((a) => {
      o && i({ choices: a, source: e, answers: t });
    }) : i({ choices: e, source: e, answers: t }), () => {
      o = !1;
    };
  }, [e, t, n]), { choices: r.choices, ready: r.source === e && r.answers === t };
}
function ju(e, t) {
  const { loggingService: n } = gt(mn), r = ac.isObject(t) ? Object.values(t) : [t], [i, o] = Qe({ dependencies: [], resolved: !1 });
  ot(() => {
    n.info("useOptionallyAsyncValue useEffect", e, t);
    let s = !0;
    return typeof e == "function" ? (async () => {
      const l = await e(t);
      s && o({ value: l, source: e, dependencies: r, resolved: !0 });
    })() : o({ value: e, source: e, dependencies: r, resolved: !0 }), () => {
      s = !1;
    };
  }, [e, n, ...r]);
  const a = i.resolved && i.source === e && i.dependencies.length === r.length && r.every((s, c) => Object.is(s, i.dependencies[c]));
  return { value: i.value, ready: a };
}
function Qn(e, t) {
  return ju(e, t).value;
}
function Ny(e, t) {
  const { currentAnswer: n, answers: r, aggregateAnswers: i } = t, o = Tt(
    () => ({ currentAnswer: n, answers: r, aggregateAnswers: i }),
    [n, r, i]
  );
  return Qn(e, o);
}
function Uee(e, t) {
  return yl(e, t).choices;
}
function Gn() {
  const e = gt(iC);
  return Tt(() => wle(e), [e]);
}
function o3() {
  const e = gt(iC);
  return e.font === void 0 ? "'Rethink Sans', sans-serif" : `${e.font.family}, 'Rethink Sans', sans-serif;`;
}
function Mi() {
  return gt(iC).borderRadius || "4px";
}
function Qf(e, t, n, r, i) {
  const { loggingService: o } = gt(mn);
  ot(() => {
    if (o.info("Running default value useEffect", t, n), !n || n.getValue(t.type) || t.id in r.raw())
      return;
    const a = e();
    o.debug("Default values in useEffect", a), a !== void 0 && i({
      value: a
    });
  }, [e, t, n, r, i, o]);
}
function Dy(e, t, n) {
  const r = JSON.stringify(e);
  ot(() => {
    er.isEqual(t.getAnswer().excludedFromAggregationIds ?? [], e) || n({ excludedFromAggregationIds: e });
  }, [t, e, r, n]);
}
function Cf(e) {
  return qn(e);
}
function qn(e) {
  const n = new URLSearchParams(window.location.search).get("lang") || "default";
  return bx(e) ? e[n] || e.default : e;
}
function Wee(e, t) {
  return t !== Xn.MOBILE && (e === "radio" || e === "checkbox");
}
function a3(e, t) {
  var n;
  return ((e == null ? void 0 : e.type) === "matrix" || (e == null ? void 0 : e.type) === "multiSelectMatrix") && Wee(e.layout, t) ? {
    contentWidth: "64rem",
    viewportStyle: ((n = e.tableOptions) == null ? void 0 : n.scrollContainer) === "parent" ? { scrollbarGutter: "auto" } : {}
  } : t !== Xn.MOBILE && ((e == null ? void 0 : e.type) === "dropdown-matrix" || (e == null ? void 0 : e.type) === "input-matrix") ? { contentWidth: "64rem", viewportStyle: {} } : { contentWidth: "40rem", viewportStyle: {} };
}
function GCt(e) {
  return a3(e, No());
}
const QF = (e, t, n) => {
  if (e.constraint) {
    const r = e.constraint.func({ currentAnswer: t });
    if (console.log("constraint", r), console.log("currentAnswer", t), !r)
      return n.error(e.constraint.message), !1;
  }
  if (e.type === "input-matrix")
    return JF(e, t, n);
  if (!e.required)
    return !0;
  switch (e.type) {
    case "singleSelect":
      return SVe(e, t, n);
    case "multiSelect":
      return wVe(e, t, n);
    case "matrix":
    case "multiSelectMatrix":
    case "dropdown-matrix":
      return JF(e, t, n);
    case "multiDropdown":
      return xVe(e, t, n);
    case "conjointAnalysis":
      return EVe();
    case "slider":
      return CVe(e, t, n);
    case "multiInput":
      return TVe(e, t, n);
    case "dropdown":
      return IVe(e, t, n);
    case "choiceExperiment":
      return OVe();
    case "ranking":
      return $Ve();
    case "commentBox":
      return AVe(e, t, n);
    case "responsiveSlider":
      return PVe();
    case "choiceRank":
      return MVe();
    case "compareSlider":
      return kVe();
    case "shift":
      return NVe();
    case "shiftContinuous":
      return DVe();
    case "match":
      return jVe(e, t, n);
    case "vocinaConversation":
      return RVe(e, t, n);
    case "loggingTestPage":
    case "welcomePage":
    case "infoPage":
    case "endPage":
    case "rewardPage":
    case "hidden":
      return !0;
    default:
      return xu();
  }
};
function SVe(e, t, n) {
  return console.log("checkSingleSelect", e, t), qH(t.getValue(e.type)) === null ? (n.error("This question requires an answer"), !1) : !0;
}
function wVe(e, t, n) {
  const r = xle(t.getValue(e.type));
  return r === null || r.length === 0 ? (n.error("This question requires an answer"), !1) : e.min && r.length < e.min ? (n.error(`Please select at least ${e.min} options`), !1) : e.max && r.length > e.max ? (n.error(`Please select no more than ${e.max} options`), !1) : !0;
}
function JF(e, t, n) {
  const r = t.isValid(e.type);
  if (!r)
    for (const i of t.invalidMessages(e.type))
      n.error(i);
  return r;
}
function xVe(e, t, n) {
  const r = t.getValue(e.type) ?? [];
  return r.length === 0 ? (n.error("This question requires an answer"), !1) : e.max && r.length > e.max ? (n.error(`Please select no more than ${e.max} options`), !1) : !0;
}
function EVe(e, t, n) {
  throw new Error("Function not implemented.");
}
function CVe(e, t, n) {
  const r = t.getValue(e.type);
  if (r === null)
    return n.error("This question requires an answer"), !1;
  const i = parseFloat(r.value);
  return isNaN(i) ? (n.error("Please enter a number"), !1) : !0;
}
function TVe(e, t, n) {
  const r = t.isValid(e.type);
  if (!r)
    for (const i of t.invalidMessages(e.type))
      n.error(i);
  return r;
}
function IVe(e, t, n) {
  return t.getValue(e.type) === null ? (n.error("This question requires an answer"), !1) : !0;
}
function $Ve(e, t, n) {
  return !0;
}
function AVe(e, t, n) {
  const r = t.getValue(e.type);
  return r === null || r.value.length === 0 ? (n.error("This question requires an answer"), !1) : !0;
}
function RVe(e, t, n) {
  return t.getValue(e.type) === null ? (n.error("Please complete the conversation before continuing"), !1) : !0;
}
function PVe(e, t, n) {
  throw new Error("Function not implemented.");
}
function OVe(e, t, n) {
  throw new Error("Function not implemented.");
}
function MVe(e, t, n) {
  throw new Error("Function not implemented.");
}
function kVe(e, t, n) {
  throw new Error("Function not implemented.");
}
function NVe(e, t, n) {
  throw new Error("Function not implemented.");
}
function DVe(e, t, n) {
  throw new Error("Function not implemented.");
}
function jVe(e, t, n) {
  return (t.getValue(e.type) ?? []).length !== e.leftChoices.length ? (n.error("This question requires an answer"), !1) : !0;
}
function ec(e, t = !0) {
  return { ready: t, complete: e, errors: [] };
}
function Rs(e, t, n = !0) {
  const r = ec(!0, n);
  for (const i of t) {
    const o = e == null ? void 0 : e[i.id];
    if (Array.isArray(o)) {
      o.length || (r.complete = !1);
      continue;
    }
    const a = o == null ? void 0 : o.value;
    if (a === void 0 || a.trim().length === 0) {
      r.complete = !1;
      continue;
    }
    const s = i.input;
    if (s) {
      if (s.type === "number" || s.type === "slider") {
        const c = Number(a);
        (!Number.isFinite(c) || s.min !== void 0 && c < s.min || s.max !== void 0 && c > s.max) && r.errors.push("Please enter a valid number within the allowed range");
      } else
        s.type === "email" && !GH(a) && r.errors.push("Please enter a valid email address");
      s.maxLength !== void 0 && a.length > s.maxLength && r.errors.push(`Please enter no more than ${s.maxLength} characters`);
    }
  }
  return r.errors = [...new Set(r.errors)], r;
}
function LVe(e, t, n = !0) {
  return Rs(
    Object.fromEntries((e ?? []).map((r) => [String(r.id), r])),
    t.filter((r) => r.type !== "label-only").map((r) => ({ id: r.id, input: r })),
    n
  );
}
function FVe(e) {
  return e === null ? !1 : Array.isArray(e) ? e.length > 0 : Ha(e) ? e.value.trim().length > 0 : Object.values(e).some(
    (t) => Array.isArray(t) ? t.length > 0 : !!t
  );
}
function jy(e, t) {
  const n = t.getAnswer().value;
  switch (e.type) {
    case "welcomePage":
    case "infoPage":
    case "endPage":
    case "rewardPage":
    case "hidden":
    case "loggingTestPage":
      return ec(!0);
    case "singleSelect":
    case "dropdown":
      return ec(n !== null);
    case "commentBox":
      return Rs(
        n && Ha(n) ? { text: n } : null,
        [{ id: "text", input: { type: "commentBox", maxLength: e.maxLength } }]
      );
    case "multiSelect":
    case "multiDropdown": {
      const r = Array.isArray(n) ? n : [], i = e.type === "multiSelect" ? e.min ?? 1 : 1, o = ec(r.length >= Math.max(1, i));
      return e.max !== void 0 && r.length > e.max && o.errors.push(`Please select no more than ${e.max} options`), o;
    }
    case "slider":
    case "responsiveSlider":
      return Rs(
        n && Ha(n) ? { slider: n } : null,
        [{ id: "slider", input: { type: "slider" } }]
      );
    case "ranking":
    case "choiceRank":
    case "vocinaConversation":
      return ec(FVe(n));
    case "matrix":
    case "multiSelectMatrix":
    case "dropdown-matrix":
    case "input-matrix":
    case "multiInput":
    case "match":
    case "shift":
    case "shiftContinuous":
    case "choiceExperiment":
    case "conjointAnalysis":
    case "compareSlider":
      return ec(!1, !1);
    default:
      return xu();
  }
}
const VVe = "This question hasn’t been fully answered. Please complete it, or click Next again to continue.";
class BVe {
  constructor() {
    ve(this, "warned", /* @__PURE__ */ new Set());
    ve(this, "validators", /* @__PURE__ */ new Map());
  }
  register(t, n) {
    return this.validators.set(t, n), () => {
      this.validators.get(t) === n && this.validators.delete(t);
    };
  }
  check(t, n, r) {
    var o;
    if (!t.softRequired || t.required)
      return "normal";
    if (t.constraint && !t.constraint.func({ currentAnswer: n }))
      return r.error(t.constraint.message), "blocked";
    const i = ((o = this.validators.get(t.id)) == null ? void 0 : o(n)) ?? jy(t, n);
    return i.ready ? i.errors.length ? (i.errors.forEach((a) => r.error(a)), "blocked") : i.complete ? "normal" : this.warned.has(t.id) ? "advance" : (this.warned.add(t.id), r.warning(VVe), "blocked") : (r.info("Please wait for this question to finish loading."), "blocked");
  }
}
const qee = Ca(null);
function Xi(e, t) {
  const n = gt(qee), r = $e(t);
  Fa(() => {
    r.current = t;
  });
  const i = e.softRequired === !0 && !e.required;
  Fa(() => {
    if (!(!i || !n))
      return n.register(e.id, (o) => r.current(o));
  }, [i, n, e.id]);
}
function zVe(e) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return t[n] === void 0 && (t[n] = e(n)), t[n];
  };
}
var HVe = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, UVe = /* @__PURE__ */ zVe(
  function(e) {
    return HVe.test(e) || e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) < 91;
  }
  /* Z+1 */
);
const BT = (e, t) => JSON.stringify([e, t]), ZF = (e) => new Map(e.map((t) => [String(t.id), t.value]));
class WVe {
  constructor(t, n, r, i, o) {
    ve(this, "entries", /* @__PURE__ */ new Map());
    ve(this, "listeners", /* @__PURE__ */ new Set());
    ve(this, "nextRunId", 0);
    ve(this, "closed", !0);
    ve(this, "subscribe", (t) => (this.listeners.add(t), () => {
      this.listeners.delete(t);
    }));
    ve(this, "getJob", (t, n) => {
      var r;
      return (r = this.entries.get(BT(t, n))) == null ? void 0 : r.view;
    });
    ve(this, "cancel", () => {
      this.closed = !0;
      for (const t of this.entries.values())
        t.controller.abort();
      this.entries.clear(), this.emit();
    });
    ve(this, "resume", () => {
      this.store.getState().survey.isSubmitClicked || (this.closed = !1);
    });
    this.store = t, this.service = n, this.messager = r, this.surveyName = i, this.submissionId = o;
  }
  connect() {
    this.closed = !1, this.observeAnswers();
    const t = this.store.subscribe(() => this.observeAnswers());
    return () => {
      t(), this.cancel();
    };
  }
  emit() {
    this.listeners.forEach((t) => t());
  }
  values(t) {
    var i;
    const n = this.store.getState().survey, r = n.currentQuestionId === t && ((i = n.currentAnswer) == null ? void 0 : i.questionId) === t ? n.currentAnswer : n.userAnswers[t];
    return (r == null ? void 0 : r.questionType) === "multiInput" && Array.isArray(r.value) ? r.value : [];
  }
  observeAnswers() {
    if (this.store.getState().survey.isSubmitClicked) {
      this.cancel();
      return;
    }
    for (const n of this.entries.values()) {
      if (!["processing", "ready"].includes(n.view.status))
        continue;
      const r = ZF(this.values(n.questionId));
      for (const i of /* @__PURE__ */ new Set([...n.previous.keys(), ...r.keys()]))
        n.previous.get(i) !== r.get(i) && n.edited.add(i);
      n.previous = r;
    }
  }
  markEdited(t, n) {
    for (const r of this.entries.values())
      r.questionId === t && ["processing", "ready"].includes(r.view.status) && r.edited.add(n);
  }
  start(t, n, r) {
    if (this.closed || !this.service || t.surveyName !== this.surveyName || t.submissionId !== this.submissionId)
      throw new Error("This survey session is no longer available. Please reopen the survey.");
    if ([...this.entries.values()].some(
      (s) => s.questionId === t.questionId && s.view.status === "processing"
    ))
      return;
    const i = ZF(this.values(t.questionId)), o = {
      questionId: t.questionId,
      controller: new AbortController(),
      previous: i,
      edited: new Set([...i].filter(([, s]) => s.trim()).map(([s]) => s)),
      view: {
        runId: ++this.nextRunId,
        status: "processing",
        applied: [],
        message: "Reading your files. You can edit answers and move between questions. Keep this survey open; we’ll notify you when suggestions are ready."
      }
    }, a = BT(t.questionId, t.profile);
    this.entries.set(a, o), this.emit(), this.extract(a, o, { ...t, files: n }, r);
  }
  async extract(t, n, r, i) {
    const o = () => !this.closed && !n.controller.signal.aborted && this.entries.get(t) === n;
    try {
      const a = await this.service.extract(r, { signal: n.controller.signal });
      if (!o())
        return;
      n.view = {
        ...n.view,
        status: "ready",
        result: a,
        message: "Suggestions are ready. Return to this question to check the answers."
      }, a.suggestions.length ? this.messager.success(`${i}: suggestions are ready. Please review this question.`) : this.messager.info(
        `${i}: no supported values were found. Please enter the answers you know.`
      ), this.emit();
    } catch (a) {
      if (!o())
        return;
      n.view = {
        ...n.view,
        status: "failed",
        message: "",
        error: a instanceof Error ? a.message : "The files could not be processed. Please try again."
      }, this.messager.error(`${i}: extraction failed. Return to the question to try again.`), this.emit();
    }
  }
  apply(t, n, r, i) {
    var s;
    const o = this.entries.get(BT(t, n)), a = this.store.getState().survey;
    if (!(this.closed || (o == null ? void 0 : o.view.status) !== "ready" || o.view.runId !== r || a.currentQuestionId !== t || ((s = a.currentAnswer) == null ? void 0 : s.questionId) !== t)) {
      o.view = { ...o.view, status: "applied" };
      try {
        const c = o.view.result.suggestions, l = i(c, new Set(o.edited), this.values(t)), u = c.length - l.length;
        o.view = {
          ...o.view,
          applied: l,
          message: l.length ? `Filled ${l.length} ${l.length === 1 ? "answer" : "answers"}. Please check and edit the answers below.${u ? ` Kept ${u} existing or edited answers.` : ""}` : c.length ? "Kept your existing or edited answers. No answers were replaced." : "No supported values were found. Please enter the answers you know below."
        };
      } catch (c) {
        o.view = {
          ...o.view,
          status: "failed",
          message: "",
          error: c instanceof Error ? c.message : "The suggested answers could not be applied."
        };
      }
      this.emit();
    }
  }
}
const Gee = Ca(void 0);
function qVe({
  surveyName: e,
  children: t
}) {
  const n = iU(), r = uf((s) => s.survey.submissionId), { documentExtractionService: i, messagerService: o } = gt(mn), a = Tt(
    () => r ? new WVe(
      n,
      i,
      o,
      e,
      r
    ) : void 0,
    [n, i, o, e, r]
  );
  return ot(() => {
    if (!a)
      return;
    const s = a.connect();
    return window.addEventListener("pagehide", a.cancel), window.addEventListener("pageshow", a.resume), () => {
      window.removeEventListener("pagehide", a.cancel), window.removeEventListener("pageshow", a.resume), s();
    };
  }, [a]), /* @__PURE__ */ A.jsx(Gee.Provider, { value: a, children: t });
}
const GVe = () => () => {
};
function Kee(e, t) {
  const n = gt(Gee), r = Wt(
    () => n == null ? void 0 : n.getJob(e, t),
    [n, e, t]
  ), i = Mle((n == null ? void 0 : n.subscribe) ?? GVe, r, r);
  return { session: n, job: i };
}
const oC = Ca({
  survey: {},
  submissionId: null,
  currentQuestion: void 0,
  currentSurveyQuestions: [],
  interactionDisabled: !1,
  loading: !0,
  currentPercentage: 0,
  submitAnswer: async () => {
  },
  goToPreviousQuestion: () => {
  },
  updateSurveyControls: (e) => {
  },
  setNextButtonBehaviour: () => {
  },
  setPreviousButtonBehaviour: () => {
  },
  displayBackButton: () => !0,
  displayNextButton: () => !0,
  displaySubmitButton: () => !0,
  previousQuestion: () => {
  },
  nextQuestion: () => {
  },
  onSubmitSurvey: () => {
  },
  surveyControlsState: {
    nextDisabled: !1,
    prevDisabled: !1
  },
  nextButtonText: void 0,
  previousButtonText: void 0,
  hideSurveyControls: () => !1,
  sectionNavigationItems: [],
  navigateToSection: () => {
  }
});
function KVe() {
  return gt(oC);
}
const YVe = ({
  survey: e,
  submissionId: t,
  startFrom: n,
  initialState: r,
  children: i,
  onSubmitAnswer: o,
  onComplete: a,
  storeManager: s,
  databaseService: c,
  userService: l,
  onReady: u,
  onError: d,
  currentQuestionId: f,
  currentAnswerTransformer: h,
  isSubmitClicked: p,
  loggingService: g
}) => {
  const [m] = Qe(() => new mVe()), [v] = Qe(() => new BVe()), y = new yVe(), [_, b] = Qe(!0), [w, C] = Qe(void 0), [x, T] = Qe(!1), [E, R] = Qe(e.questions), [I, O] = Qe({
    nextDisabled: !1,
    prevDisabled: !1
  }), [P, k] = Qe(), L = $e(), N = Wt(
    (ke, xe = "question") => {
      const Re = ke ? {
        behaviour: ke,
        scope: xe,
        questionId: s.getStore().getState().survey.currentQuestionId
      } : void 0;
      L.current = Re, k(Re);
    },
    [s]
  ), [D, z] = Qe(), V = $e(), B = Wt(
    (ke, xe = "question") => {
      const Re = ke ? {
        behaviour: ke,
        scope: xe,
        questionId: s.getStore().getState().survey.currentQuestionId
      } : void 0;
      V.current = Re, z(Re);
    },
    [s]
  ), U = $e(!1), [Q, Y] = Qe(), q = (P == null ? void 0 : P.questionId) === f ? P : void 0, X = (D == null ? void 0 : D.questionId) === f ? D : void 0, ne = WU(), Z = E.find((ke) => ke.id === f), J = uf((ke) => ke.survey), K = Tt(() => a$(e), [e]), [ee, te] = Qe(0), H = {
    busy: _ || x,
    ...I,
    customNavigation: (q == null ? void 0 : q.scope) === "question" || (X == null ? void 0 : X.scope) === "question"
  }, ie = (ke) => {
    g.error("Section navigation unavailable", { error: ke });
  }, W = s$(
    K,
    E,
    J,
    H,
    ie
  );
  ot(() => {
    K.errors.length && g.error("Invalid section navigation configuration", {
      error: new Error(K.errors.join(`
`))
    });
  }, [K, g]);
  function se(ke) {
    const xe = s.getStore().getState().survey, Re = s$(
      K,
      E,
      xe,
      H,
      ie
    ).find((ft) => ft.id === ke);
    if (!(Re != null && Re.targetQuestionId) || Re.disabledReason) {
      Re != null && Re.disabledReason && m.warning(Re.disabledReason);
      return;
    }
    if (Re.targetQuestionId === xe.currentQuestionId)
      return;
    const yt = E.findIndex((ft) => ft.id === xe.currentQuestionId), Pt = E.findIndex((ft) => ft.id === Re.targetQuestionId), _t = E[yt], St = xe.currentAnswer ? new lu(xe.currentAnswer, g) : void 0;
    K.mode === "review" && Pt > yt && _t && St && !QF(_t, St, m) || (ne(C0e({ survey: { ...e, questions: E }, sectionId: ke })), s.getStore().getState().survey.currentQuestionId !== xe.currentQuestionId && (N(void 0), B(void 0), Y(void 0), m.destroyAll(), y.clearPopup(), te((ft) => ft + 1), Pt > yt && (o == null || o({ question: _t, answer: St }))));
  }
  const le = $e(E);
  ot(() => {
    le.current = E;
  }, [E]);
  function ge(ke = !1) {
    var St;
    const xe = s.getStore().getState().survey, Re = le.current.find((ft) => ft.id === xe.currentQuestionId), yt = xe.currentAnswer ? new lu(xe.currentAnswer, g) : void 0, Pt = (Re == null ? void 0 : Re.softRequired) && !Re.required, _t = ((St = L.current) == null ? void 0 : St.questionId) === xe.currentQuestionId ? L.current : void 0;
    if (ke && (_t == null ? void 0 : _t.scope) === "internal-step") {
      yt && !_ && !U.current && !I.nextDisabled && _t.behaviour(yt);
      return;
    }
    if (!Pt && ke && _t && yt) {
      _t.behaviour(yt);
      return;
    }
    if (!(!Pt && Re && yt && !QF(Re, yt, m))) {
      if (Pt && Re && yt) {
        const ft = v.check(Re, yt, m);
        if (ft === "blocked")
          return;
        if (ft === "normal" && ke && _t) {
          _t.behaviour(yt);
          return;
        }
      }
      m.destroyAll(), y.clearPopup(), o == null || o({
        question: Re,
        answer: yt
      }), ne(A7()), Y(void 0), ne(T0e(le.current)), ne(R7(le.current));
    }
  }
  async function me(ke) {
    if (U.current)
      return;
    const xe = s.getStore().getState().survey.currentQuestionId;
    U.current = !0, T(!0);
    try {
      if (await new Promise((yt) => setTimeout(yt, 300)), s.getStore().getState().survey.currentQuestionId !== xe)
        return;
      const Re = () => {
        s.getStore().getState().survey.currentQuestionId === xe && ge();
      };
      ke ? ke(Re) : Re();
    } finally {
      U.current = !1, T(!1);
    }
  }
  function pe() {
    var Re;
    if (U.current)
      return;
    const ke = s.getStore().getState().survey, xe = ((Re = V.current) == null ? void 0 : Re.questionId) === ke.currentQuestionId ? V.current : void 0;
    if (xe && ke.currentAnswer) {
      if (xe.scope === "internal-step" && (_ || I.prevDisabled))
        return;
      xe.behaviour(new lu(ke.currentAnswer, g));
    } else
      Te();
  }
  function Te() {
    m.destroyAll(), y.clearPopup(), ne(A7()), ne(I0e(le.current)), Y(s.getStore().getState().survey.currentQuestionId), ne(R7(le.current));
  }
  const de = Wt((ke) => {
    O((xe) => ({
      ...xe,
      ...ke
    }));
  }, []);
  function Ae() {
    return (E.findIndex((xe) => xe.id === f) !== 0 || (X == null ? void 0 : X.scope) === "internal-step") && !(Z != null && Z.hidePreviousButton) && !(Z != null && Z.hideUi);
  }
  function ue() {
    return !nv(Z);
  }
  function be() {
    return (Z == null ? void 0 : Z.type) === "endPage" && !e.settings.hideSubmit;
  }
  function Ie() {
    if (!h)
      throw new Error("Missing CurrentAnswer");
    Promise.all([
      ne(
        HU({
          ...h.getAnswer()
        })
      ),
      ne(UU()),
      ne(A0e())
    ]).then(a);
  }
  function Ve() {
    return nv(Z) && p ? !0 : (Z == null ? void 0 : Z.hideUi) ?? !1;
  }
  function ze() {
    const ke = Z == null ? void 0 : Z.nextButtonText;
    return typeof ke == "function" ? ke({ currentAnswer: h }) : ke;
  }
  function Ne() {
    var xe;
    const ke = e.settings.primaryColour;
    ke && ((xe = document.querySelector('meta[name="theme-color"]')) == null || xe.setAttribute("content", ke));
  }
  function lt(ke) {
    return ke.map((xe) => {
      if ("shuffle" in xe && xe.shuffle && er.isArray(xe.choices)) {
        const [Re, yt] = er.partition(
          xe.choices,
          ({ type: Pt, submit: _t }) => Pt === "input" || _t
        );
        return { ...xe, choices: er.shuffle(yt).concat(Re) };
      }
      return xe;
    });
  }
  function mt() {
    return Math.round(
      E.findIndex((ke) => ke.id === f) * 100 / (E.length - 1)
    );
  }
  ot(() => {
    const ke = s.observeReady().subscribe({
      next: (xe) => {
        console.log("storeReadySubscription ready", xe), xe && (console.log("storeReadySubscription ready"), b(!1), u == null || u());
      },
      error: (xe) => {
        C(xe), d == null || d(xe);
      }
    });
    return s.initialise(
      e,
      c,
      l,
      t,
      n,
      r
    ), Ne(), () => {
      ke.unsubscribe();
    };
  }, [s, c, l]), ot(() => {
    const ke = lt(e.questions);
    R(ke);
  }, [e.questions]);
  const vt = gt(mn);
  return /* @__PURE__ */ A.jsx(
    mn.Provider,
    {
      value: {
        ...vt,
        loggingService: g,
        messagerService: m,
        popupService: y,
        userService: l,
        databaseService: c
      },
      children: /* @__PURE__ */ A.jsx(iC.Provider, { value: e.settings, children: /* @__PURE__ */ A.jsx(Nle, { shouldForwardProp: JVe, enableVendorPrefixes: !0, children: /* @__PURE__ */ A.jsx(
        oC.Provider,
        {
          value: {
            survey: e,
            submissionId: t,
            loading: _,
            error: w,
            interactionDisabled: x,
            currentPercentage: mt(),
            submitAnswer: me,
            currentQuestion: Z,
            currentSurveyQuestions: E,
            enteredFromPrevious: Q === f,
            goToPreviousQuestion: Te,
            updateSurveyControls: de,
            setNextButtonBehaviour: N,
            setPreviousButtonBehaviour: B,
            displayBackButton: Ae,
            displayNextButton: ue,
            displaySubmitButton: be,
            previousQuestion: pe,
            nextQuestion: () => ge(!0),
            onSubmitSurvey: Ie,
            surveyControlsState: I,
            nextButtonText: ze(),
            previousButtonText: Z == null ? void 0 : Z.previousButtonText,
            hideSurveyControls: Ve,
            sectionNavigationItems: W,
            navigateToSection: se,
            sectionNavigationFocusKey: ee
          },
          children: /* @__PURE__ */ A.jsx(qee.Provider, { value: v, children: /* @__PURE__ */ A.jsx(qVe, { surveyName: e.settings.surveyName, children: i }) })
        }
      ) }) })
    }
  );
}, XVe = ({
  survey: e,
  submissionId: t,
  startFrom: n,
  initialState: r,
  children: i,
  onSubmitAnswer: o,
  onComplete: a,
  storeManager: s,
  databaseService: c,
  userService: l,
  onReady: u,
  onError: d,
  loggingService: f
}) => {
  const { currentAnswer: h, currentQuestionId: p, isSubmitClicked: g } = uf(
    (v) => v.survey
  ), m = h ? new lu(h, f) : void 0;
  return /* @__PURE__ */ A.jsx(
    YVe,
    {
      survey: e,
      submissionId: t,
      startFrom: n,
      initialState: r,
      onSubmitAnswer: o,
      onComplete: a,
      storeManager: s,
      databaseService: c,
      userService: l,
      onReady: u,
      onError: d,
      loggingService: f,
      currentQuestionId: p,
      currentAnswerTransformer: m,
      isSubmitClicked: g,
      children: i
    }
  );
}, QVe = ({
  survey: e,
  children: t,
  onSubmitAnswer: n,
  onComplete: r,
  onReady: i,
  onError: o,
  databaseService: a,
  userService: s,
  submissionId: c,
  startFrom: l,
  initialState: u
}) => {
  const { loggingService: d } = gt(mn), [f] = Qe(() => new P0e(d)), h = f.getStore();
  return /* @__PURE__ */ A.jsx(gue, { store: h, children: /* @__PURE__ */ A.jsx(
    XVe,
    {
      survey: e,
      submissionId: c,
      startFrom: l,
      initialState: u,
      storeManager: f,
      onSubmitAnswer: n,
      onComplete: r,
      databaseService: a,
      userService: s,
      onReady: i,
      onError: o,
      loggingService: d,
      children: t
    }
  ) });
}, KCt = (e) => /* @__PURE__ */ A.jsx(
  QVe,
  {
    ...e
  },
  JSON.stringify([e.survey.settings.surveyName, e.submissionId])
);
function JVe(e, t) {
  return typeof t == "string" ? UVe(e) : !0;
}
const ZVe = ({ question: e, answers: t }) => {
  const { primaryColour: n } = Gn(), r = Mi(), i = No(), o = Qn(e.text, { answers: t }), a = Cf(o);
  let s = typeof a < "u" ? /* @__PURE__ */ A.jsx(tBe, { children: a }) : /* @__PURE__ */ A.jsx(dF, { active: !0, paragraph: { rows: 4 }, title: !1 });
  const c = Qn(e.header, { answers: t }), l = Cf(c);
  let u = l ? /* @__PURE__ */ A.jsx(eBe, { children: l }) : e.header ? /* @__PURE__ */ A.jsx(dF, { active: !0, paragraph: { rows: 1, width: "40%" }, title: !1 }) : null;
  return _x(({ survey: h }) => h.isSubmitClicked) && (e.type === "rewardPage" || e.type === "endPage" && !!e.contentAfterSubmit) && (s = null, u = null), i === Xn.MOBILE && e.type === "welcomePage" ? /* @__PURE__ */ A.jsxs(
    e9,
    {
      style: {
        // background: 'var(--dark)',
        background: n,
        opacity: 0.9,
        color: "white",
        borderRadius: r,
        padding: "1rem"
      },
      children: [
        u,
        s
      ]
    }
  ) : /* @__PURE__ */ A.jsxs(e9, { children: [
    u,
    s
  ] });
}, e9 = ce.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  z-index: 1;
  align-items: baseline;
  gap: 1rem;
`, eBe = ce.h1`
  font-size: var(--question-header-font-size);
  font-weight: 500;
  margin-top: 0;
`, tBe = ce.div`
  display: flex;
  align-self: 'baseline';
  margin-bottom: 0;
  width: 100%;
  font-size: var(--question-text-font-size);
`, nBe = { top: 0.5, left: 0.5, side: "left" }, rBe = (e) => {
  var h;
  const { container: t } = e, { popupService: n } = gt(mn), r = $e(null), [i, o] = Qe(nBe), a = KH(n.observePopup());
  if (ot(() => {
    if (r.current) {
      const { height: p, width: g } = r.current.getBoundingClientRect(), m = aBe(t, p, g, a == null ? void 0 : a.position);
      o(m);
    }
  }, [r.current, a == null ? void 0 : a.position, t, (h = r.current) == null ? void 0 : h.offsetWidth]), a === void 0 || a.content === null)
    return null;
  const { content: s } = a, { top: c, left: l, side: u } = i, d = iBe(t, u), f = oBe(t, u);
  return /* @__PURE__ */ A.jsx("div", { children: rO(
    /* @__PURE__ */ A.jsx(
      fBe,
      {
        top: c,
        left: l,
        maxWidth: d,
        maxHeight: f,
        ref: r,
        children: /* @__PURE__ */ A.jsx("span", { children: s })
      },
      s == null ? void 0 : s.toString()
    ),
    document.body
  ) });
};
function iBe(e, t) {
  switch (t) {
    case "left":
      return e.left - 20;
    case "right":
      return document.body.offsetWidth - e.right - 20;
    case "top":
    case "bottom":
      return e.width;
    default:
      xu();
  }
}
function oBe(e, t) {
  switch (t) {
    case "left":
    case "right":
      return e.height;
    case "top":
      return e.top;
    case "bottom":
      return document.body.offsetHeight - e.bottom;
    default:
      xu();
  }
}
function aBe(e, t, n, r) {
  const i = { top: 0, left: 0.5, side: "left" }, o = { ...i, ...r }, { top: a, left: s } = o;
  return a < 0 || a > 1 || s < 0 || s > 1 ? (console.error("Invalid popup position out of bounds", e.top, e.left, o), i) : sBe(e, t, n, o);
}
function sBe(e, t, n, r) {
  const { side: i } = r;
  switch (i) {
    case "left":
      return cBe(e, t, n, r);
    case "right":
      return lBe(e, t, n, r);
    case "top":
      return uBe(e, t, n, r);
    case "bottom":
      return dBe(e, t, n, r);
    default:
      xu();
  }
}
function cBe(e, t, n, r) {
  const { top: i, left: o, side: a } = r, s = n / 2, l = (e.left - n / 2 - s) * o + s, u = e.top;
  return { top: (e.top + e.height - t - u) * i + u, left: l, side: a };
}
function lBe(e, t, n, r) {
  const { top: i, left: o, side: a } = r, s = e.right + n / 2, l = (document.body.offsetWidth - n / 2 - s) * o + s, u = e.top;
  return { top: (e.top + e.height - t - u) * i + u, left: l, side: a };
}
function uBe(e, t, n, r) {
  const { top: i, left: o, side: a } = r, s = e.left + n / 2, l = (e.right - n / 2 - s) * o + s, u = 0;
  return { top: (e.top - t - u) * i + u, left: l, side: a };
}
function dBe(e, t, n, r) {
  const { top: i, left: o, side: a } = r, s = e.left + n / 2, l = (e.right - n / 2 - s) * o + s, u = e.bottom;
  return { top: (document.body.offsetHeight - t - u) * i + u, left: l, side: a };
}
const fBe = ce.div`
  position: absolute;
  background: var(--light);
  border: 1px solid var(--light);
  box-shadow: 2px 2px 4.1px 2px rgba(17, 17, 17, 0.1);
  padding: var(--spacing-sm);
  max-width: ${(e) => e.maxWidth}px;
  max-height: ${(e) => e.maxHeight}px;
  z-index: 3;
  transform: translateX(-50%);
  top: ${(e) => e.top}px;
  left: ${(e) => e.left}px;
  animation: fade-in 0.4s ease-in;
  @keyframes fade-in {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  overflow: auto;
`, hBe = (e) => +e;
function gBe(e) {
  return e * e;
}
function pBe(e) {
  return e * (2 - e);
}
function t9(e) {
  return ((e *= 2) <= 1 ? e * e : --e * (2 - e) + 1) / 2;
}
function mBe(e) {
  return e * e * e;
}
function vBe(e) {
  return --e * e * e + 1;
}
function n9(e) {
  return ((e *= 2) <= 1 ? e * e * e : (e -= 2) * e * e + 2) / 2;
}
var s3 = 3, yBe = function e(t) {
  t = +t;
  function n(r) {
    return Math.pow(r, t);
  }
  return n.exponent = e, n;
}(s3), bBe = function e(t) {
  t = +t;
  function n(r) {
    return 1 - Math.pow(1 - r, t);
  }
  return n.exponent = e, n;
}(s3), r9 = function e(t) {
  t = +t;
  function n(r) {
    return ((r *= 2) <= 1 ? Math.pow(r, t) : 2 - Math.pow(2 - r, t)) / 2;
  }
  return n.exponent = e, n;
}(s3), Yee = Math.PI, Xee = Yee / 2;
function _Be(e) {
  return +e == 1 ? 1 : 1 - Math.cos(e * Xee);
}
function SBe(e) {
  return Math.sin(e * Xee);
}
function i9(e) {
  return (1 - Math.cos(Yee * e)) / 2;
}
function Lu(e) {
  return (Math.pow(2, -10 * e) - 9765625e-10) * 1.0009775171065494;
}
function wBe(e) {
  return Lu(1 - +e);
}
function xBe(e) {
  return 1 - Lu(e);
}
function o9(e) {
  return ((e *= 2) <= 1 ? Lu(1 - e) : 2 - Lu(e - 1)) / 2;
}
function EBe(e) {
  return 1 - Math.sqrt(1 - e * e);
}
function CBe(e) {
  return Math.sqrt(1 - --e * e);
}
function a9(e) {
  return ((e *= 2) <= 1 ? 1 - Math.sqrt(1 - e * e) : Math.sqrt(1 - (e -= 2) * e) + 1) / 2;
}
var TR = 4 / 11, TBe = 6 / 11, IBe = 8 / 11, $Be = 3 / 4, ABe = 9 / 11, RBe = 10 / 11, PBe = 15 / 16, OBe = 21 / 22, MBe = 63 / 64, b1 = 1 / TR / TR;
function kBe(e) {
  return 1 - Nv(1 - e);
}
function Nv(e) {
  return (e = +e) < TR ? b1 * e * e : e < IBe ? b1 * (e -= TBe) * e + $Be : e < RBe ? b1 * (e -= ABe) * e + PBe : b1 * (e -= OBe) * e + MBe;
}
function NBe(e) {
  return ((e *= 2) <= 1 ? 1 - Nv(1 - e) : Nv(e - 1) + 1) / 2;
}
var c3 = 1.70158, DBe = function e(t) {
  t = +t;
  function n(r) {
    return (r = +r) * r * (t * (r - 1) + r);
  }
  return n.overshoot = e, n;
}(c3), jBe = function e(t) {
  t = +t;
  function n(r) {
    return --r * r * ((r + 1) * t + r) + 1;
  }
  return n.overshoot = e, n;
}(c3), s9 = function e(t) {
  t = +t;
  function n(r) {
    return ((r *= 2) < 1 ? r * r * ((t + 1) * r - t) : (r -= 2) * r * ((t + 1) * r + t) + 2) / 2;
  }
  return n.overshoot = e, n;
}(c3), np = 2 * Math.PI, l3 = 1, u3 = 0.3, LBe = function e(t, n) {
  var r = Math.asin(1 / (t = Math.max(1, t))) * (n /= np);
  function i(o) {
    return t * Lu(- --o) * Math.sin((r - o) / n);
  }
  return i.amplitude = function(o) {
    return e(o, n * np);
  }, i.period = function(o) {
    return e(t, o);
  }, i;
}(l3, u3), c9 = function e(t, n) {
  var r = Math.asin(1 / (t = Math.max(1, t))) * (n /= np);
  function i(o) {
    return 1 - t * Lu(o = +o) * Math.sin((o + r) / n);
  }
  return i.amplitude = function(o) {
    return e(o, n * np);
  }, i.period = function(o) {
    return e(t, o);
  }, i;
}(l3, u3), FBe = function e(t, n) {
  var r = Math.asin(1 / (t = Math.max(1, t))) * (n /= np);
  function i(o) {
    return ((o = o * 2 - 1) < 0 ? t * Lu(-o) * Math.sin((r - o) / n) : 2 - t * Lu(o) * Math.sin((r + o) / n)) / 2;
  }
  return i.amplitude = function(o) {
    return e(o, n * np);
  }, i.period = function(o) {
    return e(t, o);
  }, i;
}(l3, u3);
const VBe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  easeBack: s9,
  easeBackIn: DBe,
  easeBackInOut: s9,
  easeBackOut: jBe,
  easeBounce: Nv,
  easeBounceIn: kBe,
  easeBounceInOut: NBe,
  easeBounceOut: Nv,
  easeCircle: a9,
  easeCircleIn: EBe,
  easeCircleInOut: a9,
  easeCircleOut: CBe,
  easeCubic: n9,
  easeCubicIn: mBe,
  easeCubicInOut: n9,
  easeCubicOut: vBe,
  easeElastic: c9,
  easeElasticIn: LBe,
  easeElasticInOut: FBe,
  easeElasticOut: c9,
  easeExp: o9,
  easeExpIn: wBe,
  easeExpInOut: o9,
  easeExpOut: xBe,
  easeLinear: hBe,
  easePoly: r9,
  easePolyIn: yBe,
  easePolyInOut: r9,
  easePolyOut: bBe,
  easeQuad: t9,
  easeQuadIn: gBe,
  easeQuadInOut: t9,
  easeQuadOut: pBe,
  easeSin: i9,
  easeSinIn: _Be,
  easeSinInOut: i9,
  easeSinOut: SBe
}, Symbol.toStringTag, { value: "Module" }));
var BBe = kU, zBe = BBe(Object.getPrototypeOf, Object), d3 = zBe, HBe = wl, UBe = d3, WBe = Xa, qBe = "[object Object]", GBe = Function.prototype, KBe = Object.prototype, Qee = GBe.toString, YBe = KBe.hasOwnProperty, XBe = Qee.call(Object);
function QBe(e) {
  if (!WBe(e) || HBe(e) != qBe)
    return !1;
  var t = UBe(e);
  if (t === null)
    return !0;
  var n = YBe.call(t, "constructor") && t.constructor;
  return typeof n == "function" && n instanceof n && Qee.call(n) == XBe;
}
var f3 = QBe;
const ni = /* @__PURE__ */ vn(f3);
function JBe(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length, i = Array(r); ++n < r; )
    i[n] = t(e[n], n, e);
  return i;
}
var Ly = JBe, ZBe = wl, eze = Xa, tze = "[object Symbol]";
function nze(e) {
  return typeof e == "symbol" || eze(e) && ZBe(e) == tze;
}
var Fy = nze, rze = Yi, ize = Fy, oze = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, aze = /^\w*$/;
function sze(e, t) {
  if (rze(e))
    return !1;
  var n = typeof e;
  return n == "number" || n == "symbol" || n == "boolean" || e == null || ize(e) ? !0 : aze.test(e) || !oze.test(e) || t != null && e in Object(t);
}
var h3 = sze, Jee = gO, cze = "Expected a function";
function g3(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(cze);
  var n = function() {
    var r = arguments, i = t ? t.apply(this, r) : r[0], o = n.cache;
    if (o.has(i))
      return o.get(i);
    var a = e.apply(this, r);
    return n.cache = o.set(i, a) || o, a;
  };
  return n.cache = new (g3.Cache || Jee)(), n;
}
g3.Cache = Jee;
var Zee = g3;
const ete = /* @__PURE__ */ vn(Zee);
var lze = Zee, uze = 500;
function dze(e) {
  var t = lze(e, function(r) {
    return n.size === uze && n.clear(), r;
  }), n = t.cache;
  return t;
}
var fze = dze, hze = fze, gze = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, pze = /\\(\\)?/g, mze = hze(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(gze, function(n, r, i, o) {
    t.push(i ? o.replace(pze, "$1") : r || n);
  }), t;
}), vze = mze, l9 = Cp, yze = Ly, bze = Yi, _ze = Fy, Sze = 1 / 0, u9 = l9 ? l9.prototype : void 0, d9 = u9 ? u9.toString : void 0;
function tte(e) {
  if (typeof e == "string")
    return e;
  if (bze(e))
    return yze(e, tte) + "";
  if (_ze(e))
    return d9 ? d9.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -Sze ? "-0" : t;
}
var wze = tte, xze = wze;
function Eze(e) {
  return e == null ? "" : xze(e);
}
var nte = Eze, Cze = Yi, Tze = h3, Ize = vze, $ze = nte;
function Aze(e, t) {
  return Cze(e) ? e : Tze(e, t) ? [e] : Ize($ze(e));
}
var Qp = Aze, Rze = Fy, Pze = 1 / 0;
function Oze(e) {
  if (typeof e == "string" || Rze(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -Pze ? "-0" : t;
}
var Jp = Oze, Mze = Qp, kze = Jp;
function Nze(e, t) {
  t = Mze(t, e);
  for (var n = 0, r = t.length; e != null && n < r; )
    e = e[kze(t[n++])];
  return n && n == r ? e : void 0;
}
var Vy = Nze, Dze = Tx, jze = SO, Lze = 1, Fze = 2;
function Vze(e, t, n, r) {
  var i = n.length, o = i, a = !r;
  if (e == null)
    return !o;
  for (e = Object(e); i--; ) {
    var s = n[i];
    if (a && s[2] ? s[1] !== e[s[0]] : !(s[0] in e))
      return !1;
  }
  for (; ++i < o; ) {
    s = n[i];
    var c = s[0], l = e[c], u = s[1];
    if (a && s[2]) {
      if (l === void 0 && !(c in e))
        return !1;
    } else {
      var d = new Dze();
      if (r)
        var f = r(l, u, c, e, t, d);
      if (!(f === void 0 ? jze(u, l, Lze | Fze, r, d) : f))
        return !1;
    }
  }
  return !0;
}
var Bze = Vze, zze = Ya;
function Hze(e) {
  return e === e && !zze(e);
}
var rte = Hze, Uze = rte, Wze = Rp;
function qze(e) {
  for (var t = Wze(e), n = t.length; n--; ) {
    var r = t[n], i = e[r];
    t[n] = [r, i, Uze(i)];
  }
  return t;
}
var Gze = qze;
function Kze(e, t) {
  return function(n) {
    return n == null ? !1 : n[e] === t && (t !== void 0 || e in Object(n));
  };
}
var ite = Kze, Yze = Bze, Xze = Gze, Qze = ite;
function Jze(e) {
  var t = Xze(e);
  return t.length == 1 && t[0][2] ? Qze(t[0][0], t[0][1]) : function(n) {
    return n === e || Yze(n, e, t);
  };
}
var Zze = Jze, eHe = Vy;
function tHe(e, t, n) {
  var r = e == null ? void 0 : eHe(e, t);
  return r === void 0 ? n : r;
}
var ote = tHe;
const Tf = /* @__PURE__ */ vn(ote);
function nHe(e, t) {
  return e != null && t in Object(e);
}
var rHe = nHe, iHe = Qp, oHe = ny, aHe = Yi, sHe = Ix, cHe = _O, lHe = Jp;
function uHe(e, t, n) {
  t = iHe(t, e);
  for (var r = -1, i = t.length, o = !1; ++r < i; ) {
    var a = lHe(t[r]);
    if (!(o = e != null && n(e, a)))
      break;
    e = e[a];
  }
  return o || ++r != i ? o : (i = e == null ? 0 : e.length, !!i && cHe(i) && sHe(a, i) && (aHe(e) || oHe(e)));
}
var dHe = uHe, fHe = rHe, hHe = dHe;
function gHe(e, t) {
  return e != null && hHe(e, t, fHe);
}
var ate = gHe, pHe = SO, mHe = ote, vHe = ate, yHe = h3, bHe = rte, _He = ite, SHe = Jp, wHe = 1, xHe = 2;
function EHe(e, t) {
  return yHe(e) && bHe(t) ? _He(SHe(e), t) : function(n) {
    var r = mHe(n, e);
    return r === void 0 && r === t ? vHe(n, e) : pHe(t, r, wHe | xHe);
  };
}
var CHe = EHe;
function THe(e) {
  return e;
}
var By = THe;
const Zp = /* @__PURE__ */ vn(By);
function IHe(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
var $He = IHe, AHe = Vy;
function RHe(e) {
  return function(t) {
    return AHe(t, e);
  };
}
var PHe = RHe, OHe = $He, MHe = PHe, kHe = h3, NHe = Jp;
function DHe(e) {
  return kHe(e) ? OHe(NHe(e)) : MHe(e);
}
var ste = DHe;
const cte = /* @__PURE__ */ vn(ste);
var jHe = Zze, LHe = CHe, FHe = By, VHe = Yi, BHe = ste;
function zHe(e) {
  return typeof e == "function" ? e : e == null ? FHe : typeof e == "object" ? VHe(e) ? LHe(e[0], e[1]) : jHe(e) : BHe(e);
}
var em = zHe;
function HHe(e) {
  return function(t, n, r) {
    for (var i = -1, o = Object(t), a = r(t), s = a.length; s--; ) {
      var c = a[e ? s : ++i];
      if (n(o[c], c, o) === !1)
        break;
    }
    return t;
  };
}
var UHe = HHe, WHe = UHe, qHe = WHe(), lte = qHe, GHe = lte, KHe = Rp;
function YHe(e, t) {
  return e && GHe(e, t, KHe);
}
var XHe = YHe, QHe = qu;
function JHe(e, t) {
  return function(n, r) {
    if (n == null)
      return n;
    if (!QHe(n))
      return e(n, r);
    for (var i = n.length, o = t ? i : -1, a = Object(n); (t ? o-- : ++o < i) && r(a[o], o, a) !== !1; )
      ;
    return n;
  };
}
var ZHe = JHe, eUe = XHe, tUe = ZHe, nUe = tUe(eUe), p3 = nUe, rUe = p3, iUe = qu;
function oUe(e, t) {
  var n = -1, r = iUe(e) ? Array(e.length) : [];
  return rUe(e, function(i, o, a) {
    r[++n] = t(i, o, a);
  }), r;
}
var aUe = oUe;
function sUe(e, t) {
  var n = e.length;
  for (e.sort(t); n--; )
    e[n] = e[n].value;
  return e;
}
var cUe = sUe, f9 = Fy;
function lUe(e, t) {
  if (e !== t) {
    var n = e !== void 0, r = e === null, i = e === e, o = f9(e), a = t !== void 0, s = t === null, c = t === t, l = f9(t);
    if (!s && !l && !o && e > t || o && a && c && !s && !l || r && a && c || !n && c || !i)
      return 1;
    if (!r && !o && !l && e < t || l && n && i && !r && !o || s && n && i || !a && i || !c)
      return -1;
  }
  return 0;
}
var uUe = lUe, dUe = uUe;
function fUe(e, t, n) {
  for (var r = -1, i = e.criteria, o = t.criteria, a = i.length, s = n.length; ++r < a; ) {
    var c = dUe(i[r], o[r]);
    if (c) {
      if (r >= s)
        return c;
      var l = n[r];
      return c * (l == "desc" ? -1 : 1);
    }
  }
  return e.index - t.index;
}
var hUe = fUe, zT = Ly, gUe = Vy, pUe = em, mUe = aUe, vUe = cUe, yUe = Ap, bUe = hUe, _Ue = By, SUe = Yi;
function wUe(e, t, n) {
  t.length ? t = zT(t, function(o) {
    return SUe(o) ? function(a) {
      return gUe(a, o.length === 1 ? o[0] : o);
    } : o;
  }) : t = [_Ue];
  var r = -1;
  t = zT(t, yUe(pUe));
  var i = mUe(e, function(o, a, s) {
    var c = zT(t, function(l) {
      return l(o);
    });
    return { criteria: c, index: ++r, value: o };
  });
  return vUe(i, function(o, a) {
    return bUe(o, a, n);
  });
}
var ute = wUe, xUe = ute, h9 = Yi;
function EUe(e, t, n, r) {
  return e == null ? [] : (h9(t) || (t = t == null ? [] : [t]), n = r ? void 0 : n, h9(n) || (n = n == null ? [] : [n]), xUe(e, t, n));
}
var CUe = EUe;
const zy = /* @__PURE__ */ vn(CUe);
function aC(e, t, n) {
  e.prototype = t.prototype = n, n.constructor = e;
}
function m3(e, t) {
  var n = Object.create(e.prototype);
  for (var r in t)
    n[r] = t[r];
  return n;
}
function tm() {
}
var If = 0.7, rp = 1 / If, pg = "\\s*([+-]?\\d+)\\s*", Dv = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", vc = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", TUe = /^#([0-9a-f]{3,8})$/, IUe = new RegExp(`^rgb\\(${pg},${pg},${pg}\\)$`), $Ue = new RegExp(`^rgb\\(${vc},${vc},${vc}\\)$`), AUe = new RegExp(`^rgba\\(${pg},${pg},${pg},${Dv}\\)$`), RUe = new RegExp(`^rgba\\(${vc},${vc},${vc},${Dv}\\)$`), PUe = new RegExp(`^hsl\\(${Dv},${vc},${vc}\\)$`), OUe = new RegExp(`^hsla\\(${Dv},${vc},${vc},${Dv}\\)$`), g9 = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
aC(tm, jv, {
  copy(e) {
    return Object.assign(new this.constructor(), this, e);
  },
  displayable() {
    return this.rgb().displayable();
  },
  hex: p9,
  // Deprecated! Use color.formatHex.
  formatHex: p9,
  formatHex8: MUe,
  formatHsl: kUe,
  formatRgb: m9,
  toString: m9
});
function p9() {
  return this.rgb().formatHex();
}
function MUe() {
  return this.rgb().formatHex8();
}
function kUe() {
  return fte(this).formatHsl();
}
function m9() {
  return this.rgb().formatRgb();
}
function jv(e) {
  var t, n;
  return e = (e + "").trim().toLowerCase(), (t = TUe.exec(e)) ? (n = t[1].length, t = parseInt(t[1], 16), n === 6 ? v9(t) : n === 3 ? new co(t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, (t & 15) << 4 | t & 15, 1) : n === 8 ? _1(t >> 24 & 255, t >> 16 & 255, t >> 8 & 255, (t & 255) / 255) : n === 4 ? _1(t >> 12 & 15 | t >> 8 & 240, t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, ((t & 15) << 4 | t & 15) / 255) : null) : (t = IUe.exec(e)) ? new co(t[1], t[2], t[3], 1) : (t = $Ue.exec(e)) ? new co(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, 1) : (t = AUe.exec(e)) ? _1(t[1], t[2], t[3], t[4]) : (t = RUe.exec(e)) ? _1(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, t[4]) : (t = PUe.exec(e)) ? _9(t[1], t[2] / 100, t[3] / 100, 1) : (t = OUe.exec(e)) ? _9(t[1], t[2] / 100, t[3] / 100, t[4]) : g9.hasOwnProperty(e) ? v9(g9[e]) : e === "transparent" ? new co(NaN, NaN, NaN, 0) : null;
}
function v9(e) {
  return new co(e >> 16 & 255, e >> 8 & 255, e & 255, 1);
}
function _1(e, t, n, r) {
  return r <= 0 && (e = t = n = NaN), new co(e, t, n, r);
}
function dte(e) {
  return e instanceof tm || (e = jv(e)), e ? (e = e.rgb(), new co(e.r, e.g, e.b, e.opacity)) : new co();
}
function ip(e, t, n, r) {
  return arguments.length === 1 ? dte(e) : new co(e, t, n, r ?? 1);
}
function co(e, t, n, r) {
  this.r = +e, this.g = +t, this.b = +n, this.opacity = +r;
}
aC(co, ip, m3(tm, {
  brighter(e) {
    return e = e == null ? rp : Math.pow(rp, e), new co(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  darker(e) {
    return e = e == null ? If : Math.pow(If, e), new co(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  rgb() {
    return this;
  },
  clamp() {
    return new co(ef(this.r), ef(this.g), ef(this.b), pw(this.opacity));
  },
  displayable() {
    return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: y9,
  // Deprecated! Use color.formatHex.
  formatHex: y9,
  formatHex8: NUe,
  formatRgb: b9,
  toString: b9
}));
function y9() {
  return `#${Vd(this.r)}${Vd(this.g)}${Vd(this.b)}`;
}
function NUe() {
  return `#${Vd(this.r)}${Vd(this.g)}${Vd(this.b)}${Vd((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function b9() {
  const e = pw(this.opacity);
  return `${e === 1 ? "rgb(" : "rgba("}${ef(this.r)}, ${ef(this.g)}, ${ef(this.b)}${e === 1 ? ")" : `, ${e})`}`;
}
function pw(e) {
  return isNaN(e) ? 1 : Math.max(0, Math.min(1, e));
}
function ef(e) {
  return Math.max(0, Math.min(255, Math.round(e) || 0));
}
function Vd(e) {
  return e = ef(e), (e < 16 ? "0" : "") + e.toString(16);
}
function _9(e, t, n, r) {
  return r <= 0 ? e = t = n = NaN : n <= 0 || n >= 1 ? e = t = NaN : t <= 0 && (e = NaN), new hs(e, t, n, r);
}
function fte(e) {
  if (e instanceof hs)
    return new hs(e.h, e.s, e.l, e.opacity);
  if (e instanceof tm || (e = jv(e)), !e)
    return new hs();
  if (e instanceof hs)
    return e;
  e = e.rgb();
  var t = e.r / 255, n = e.g / 255, r = e.b / 255, i = Math.min(t, n, r), o = Math.max(t, n, r), a = NaN, s = o - i, c = (o + i) / 2;
  return s ? (t === o ? a = (n - r) / s + (n < r) * 6 : n === o ? a = (r - t) / s + 2 : a = (t - n) / s + 4, s /= c < 0.5 ? o + i : 2 - o - i, a *= 60) : s = c > 0 && c < 1 ? 0 : a, new hs(a, s, c, e.opacity);
}
function DUe(e, t, n, r) {
  return arguments.length === 1 ? fte(e) : new hs(e, t, n, r ?? 1);
}
function hs(e, t, n, r) {
  this.h = +e, this.s = +t, this.l = +n, this.opacity = +r;
}
aC(hs, DUe, m3(tm, {
  brighter(e) {
    return e = e == null ? rp : Math.pow(rp, e), new hs(this.h, this.s, this.l * e, this.opacity);
  },
  darker(e) {
    return e = e == null ? If : Math.pow(If, e), new hs(this.h, this.s, this.l * e, this.opacity);
  },
  rgb() {
    var e = this.h % 360 + (this.h < 0) * 360, t = isNaN(e) || isNaN(this.s) ? 0 : this.s, n = this.l, r = n + (n < 0.5 ? n : 1 - n) * t, i = 2 * n - r;
    return new co(
      HT(e >= 240 ? e - 240 : e + 120, i, r),
      HT(e, i, r),
      HT(e < 120 ? e + 240 : e - 120, i, r),
      this.opacity
    );
  },
  clamp() {
    return new hs(S9(this.h), S1(this.s), S1(this.l), pw(this.opacity));
  },
  displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl() {
    const e = pw(this.opacity);
    return `${e === 1 ? "hsl(" : "hsla("}${S9(this.h)}, ${S1(this.s) * 100}%, ${S1(this.l) * 100}%${e === 1 ? ")" : `, ${e})`}`;
  }
}));
function S9(e) {
  return e = (e || 0) % 360, e < 0 ? e + 360 : e;
}
function S1(e) {
  return Math.max(0, Math.min(1, e || 0));
}
function HT(e, t, n) {
  return (e < 60 ? t + (n - t) * e / 60 : e < 180 ? n : e < 240 ? t + (n - t) * (240 - e) / 60 : t) * 255;
}
const jUe = Math.PI / 180, LUe = 180 / Math.PI;
var hte = -0.14861, v3 = 1.78277, y3 = -0.29227, sC = -0.90649, Lv = 1.97294, w9 = Lv * sC, x9 = Lv * v3, E9 = v3 * y3 - sC * hte;
function FUe(e) {
  if (e instanceof tf)
    return new tf(e.h, e.s, e.l, e.opacity);
  e instanceof co || (e = dte(e));
  var t = e.r / 255, n = e.g / 255, r = e.b / 255, i = (E9 * r + w9 * t - x9 * n) / (E9 + w9 - x9), o = r - i, a = (Lv * (n - i) - y3 * o) / sC, s = Math.sqrt(a * a + o * o) / (Lv * i * (1 - i)), c = s ? Math.atan2(a, o) * LUe - 120 : NaN;
  return new tf(c < 0 ? c + 360 : c, s, i, e.opacity);
}
function xc(e, t, n, r) {
  return arguments.length === 1 ? FUe(e) : new tf(e, t, n, r ?? 1);
}
function tf(e, t, n, r) {
  this.h = +e, this.s = +t, this.l = +n, this.opacity = +r;
}
aC(tf, xc, m3(tm, {
  brighter(e) {
    return e = e == null ? rp : Math.pow(rp, e), new tf(this.h, this.s, this.l * e, this.opacity);
  },
  darker(e) {
    return e = e == null ? If : Math.pow(If, e), new tf(this.h, this.s, this.l * e, this.opacity);
  },
  rgb() {
    var e = isNaN(this.h) ? 0 : (this.h + 120) * jUe, t = +this.l, n = isNaN(this.s) ? 0 : this.s * t * (1 - t), r = Math.cos(e), i = Math.sin(e);
    return new co(
      255 * (t + n * (hte * r + v3 * i)),
      255 * (t + n * (y3 * r + sC * i)),
      255 * (t + n * (Lv * r)),
      this.opacity
    );
  }
}));
function VUe(e, t, n, r, i) {
  var o = e * e, a = o * e;
  return ((1 - 3 * e + 3 * o - a) * t + (4 - 6 * o + 3 * a) * n + (1 + 3 * e + 3 * o - 3 * a) * r + a * i) / 6;
}
function BUe(e) {
  var t = e.length - 1;
  return function(n) {
    var r = n <= 0 ? n = 0 : n >= 1 ? (n = 1, t - 1) : Math.floor(n * t), i = e[r], o = e[r + 1], a = r > 0 ? e[r - 1] : 2 * i - o, s = r < t - 1 ? e[r + 2] : 2 * o - i;
    return VUe((n - r / t) * t, a, i, o, s);
  };
}
const cC = (e) => () => e;
function gte(e, t) {
  return function(n) {
    return e + n * t;
  };
}
function zUe(e, t, n) {
  return e = Math.pow(e, n), t = Math.pow(t, n) - e, n = 1 / n, function(r) {
    return Math.pow(e + r * t, n);
  };
}
function HUe(e, t) {
  var n = t - e;
  return n ? gte(e, n > 180 || n < -180 ? n - 360 * Math.round(n / 360) : n) : cC(isNaN(e) ? t : e);
}
function UUe(e) {
  return (e = +e) == 1 ? mg : function(t, n) {
    return n - t ? zUe(t, n, e) : cC(isNaN(t) ? n : t);
  };
}
function mg(e, t) {
  var n = t - e;
  return n ? gte(e, n) : cC(isNaN(e) ? t : e);
}
const C9 = function e(t) {
  var n = UUe(t);
  function r(i, o) {
    var a = n((i = ip(i)).r, (o = ip(o)).r), s = n(i.g, o.g), c = n(i.b, o.b), l = mg(i.opacity, o.opacity);
    return function(u) {
      return i.r = a(u), i.g = s(u), i.b = c(u), i.opacity = l(u), i + "";
    };
  }
  return r.gamma = e, r;
}(1);
function WUe(e) {
  return function(t) {
    var n = t.length, r = new Array(n), i = new Array(n), o = new Array(n), a, s;
    for (a = 0; a < n; ++a)
      s = ip(t[a]), r[a] = s.r || 0, i[a] = s.g || 0, o[a] = s.b || 0;
    return r = e(r), i = e(i), o = e(o), s.opacity = 1, function(c) {
      return s.r = r(c), s.g = i(c), s.b = o(c), s + "";
    };
  };
}
var qUe = WUe(BUe);
function GUe(e, t) {
  t || (t = []);
  var n = e ? Math.min(t.length, e.length) : 0, r = t.slice(), i;
  return function(o) {
    for (i = 0; i < n; ++i)
      r[i] = e[i] * (1 - o) + t[i] * o;
    return r;
  };
}
function KUe(e) {
  return ArrayBuffer.isView(e) && !(e instanceof DataView);
}
function YUe(e, t) {
  var n = t ? t.length : 0, r = e ? Math.min(n, e.length) : 0, i = new Array(r), o = new Array(n), a;
  for (a = 0; a < r; ++a)
    i[a] = Rc(e[a], t[a]);
  for (; a < n; ++a)
    o[a] = t[a];
  return function(s) {
    for (a = 0; a < r; ++a)
      o[a] = i[a](s);
    return o;
  };
}
function XUe(e, t) {
  var n = /* @__PURE__ */ new Date();
  return e = +e, t = +t, function(r) {
    return n.setTime(e * (1 - r) + t * r), n;
  };
}
function mw(e, t) {
  return e = +e, t = +t, function(n) {
    return e * (1 - n) + t * n;
  };
}
function QUe(e, t) {
  var n = {}, r = {}, i;
  (e === null || typeof e != "object") && (e = {}), (t === null || typeof t != "object") && (t = {});
  for (i in t)
    i in e ? n[i] = Rc(e[i], t[i]) : r[i] = t[i];
  return function(o) {
    for (i in n)
      r[i] = n[i](o);
    return r;
  };
}
var IR = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, UT = new RegExp(IR.source, "g");
function JUe(e) {
  return function() {
    return e;
  };
}
function ZUe(e) {
  return function(t) {
    return e(t) + "";
  };
}
function pte(e, t) {
  var n = IR.lastIndex = UT.lastIndex = 0, r, i, o, a = -1, s = [], c = [];
  for (e = e + "", t = t + ""; (r = IR.exec(e)) && (i = UT.exec(t)); )
    (o = i.index) > n && (o = t.slice(n, o), s[a] ? s[a] += o : s[++a] = o), (r = r[0]) === (i = i[0]) ? s[a] ? s[a] += i : s[++a] = i : (s[++a] = null, c.push({ i: a, x: mw(r, i) })), n = UT.lastIndex;
  return n < t.length && (o = t.slice(n), s[a] ? s[a] += o : s[++a] = o), s.length < 2 ? c[0] ? ZUe(c[0].x) : JUe(t) : (t = c.length, function(l) {
    for (var u = 0, d; u < t; ++u)
      s[(d = c[u]).i] = d.x(l);
    return s.join("");
  });
}
function Rc(e, t) {
  var n = typeof t, r;
  return t == null || n === "boolean" ? cC(t) : (n === "number" ? mw : n === "string" ? (r = jv(t)) ? (t = r, C9) : pte : t instanceof jv ? C9 : t instanceof Date ? XUe : KUe(t) ? GUe : Array.isArray(t) ? YUe : typeof t.valueOf != "function" && typeof t.toString != "function" || isNaN(t) ? QUe : mw)(e, t);
}
function b3(e, t) {
  return e = +e, t = +t, function(n) {
    return Math.round(e * (1 - n) + t * n);
  };
}
function mte(e) {
  return function t(n) {
    n = +n;
    function r(i, o) {
      var a = e((i = xc(i)).h, (o = xc(o)).h), s = mg(i.s, o.s), c = mg(i.l, o.l), l = mg(i.opacity, o.opacity);
      return function(u) {
        return i.h = a(u), i.s = s(u), i.l = c(Math.pow(u, n)), i.opacity = l(u), i + "";
      };
    }
    return r.gamma = t, r;
  }(1);
}
mte(HUe);
var _3 = mte(mg);
function eWe(e, t) {
  t === void 0 && (t = e, e = Rc);
  for (var n = 0, r = t.length - 1, i = t[0], o = new Array(r < 0 ? 0 : r); n < r; )
    o[n] = e(i, i = t[++n]);
  return function(a) {
    var s = Math.max(0, Math.min(r - 1, Math.floor(a *= r)));
    return o[s](a - s);
  };
}
const vw = function(e) {
  if (e !== null)
    switch (typeof e) {
      case "undefined":
        return !1;
      case "number":
        return !isNaN(e) && e !== Number.POSITIVE_INFINITY && e !== Number.NEGATIVE_INFINITY;
      case "string":
        return !0;
      case "boolean":
        return !1;
      case "object":
        return e instanceof Date || Array.isArray(e) || ni(e);
      case "function":
        return !0;
    }
  return !1;
}, vte = function(e, t, n) {
  return n === void 0 && (n = 0), function(r) {
    return r < n ? e : t;
  };
}, yte = function(e, t) {
  return function(n) {
    return n >= 1 ? t : function() {
      const r = typeof e == "function" ? e.apply(this, arguments) : e, i = typeof t == "function" ? t.apply(this, arguments) : t;
      return Rc(r, i)(n);
    };
  };
}, bte = function(e, t) {
  const n = (l, u) => l === u || !vw(l) || !vw(u) ? vte(l, u) : typeof l == "function" || typeof u == "function" ? yte(l, u) : typeof l == "object" && ni(l) || typeof u == "object" && ni(u) ? bte(l, u) : Rc(l, u), r = (l) => Array.isArray(l) ? zy(l, "key") : l, i = {}, o = {};
  let a = e, s = t, c;
  (a === null || typeof a != "object") && (a = {}), (s === null || typeof s != "object") && (s = {});
  for (c in s)
    c in a ? i[c] = n(r(a[c]), r(s[c])) : o[c] = s[c];
  return function(l) {
    for (c in i)
      o[c] = i[c](l);
    return o;
  };
}, tWe = function(e, t) {
  const n = (r) => typeof r == "string" ? r.replace(/,/g, "") : r;
  return Rc(n(e), n(t));
}, nWe = function(e, t) {
  return e === t || !vw(e) || !vw(t) ? vte(e, t) : typeof e == "function" || typeof t == "function" ? yte(e, t) : ni(e) || ni(t) ? bte(e, t) : typeof e == "string" || typeof t == "string" ? tWe(e, t) : Rc(e, t);
};
var op = 0, d0 = 0, Nm = 0, _te = 1e3, yw, f0, bw = 0, $f = 0, lC = 0, Fv = typeof performance == "object" && performance.now ? performance : Date, Ste = typeof window == "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(e) {
  setTimeout(e, 17);
};
function _w() {
  return $f || (Ste(rWe), $f = Fv.now() + lC);
}
function rWe() {
  $f = 0;
}
function $R() {
  this._call = this._time = this._next = null;
}
$R.prototype = wte.prototype = {
  constructor: $R,
  restart: function(e, t, n) {
    if (typeof e != "function")
      throw new TypeError("callback is not a function");
    n = (n == null ? _w() : +n) + (t == null ? 0 : +t), !this._next && f0 !== this && (f0 ? f0._next = this : yw = this, f0 = this), this._call = e, this._time = n, AR();
  },
  stop: function() {
    this._call && (this._call = null, this._time = 1 / 0, AR());
  }
};
function wte(e, t, n) {
  var r = new $R();
  return r.restart(e, t, n), r;
}
function iWe() {
  _w(), ++op;
  for (var e = yw, t; e; )
    (t = $f - e._time) >= 0 && e._call.call(void 0, t), e = e._next;
  --op;
}
function T9() {
  $f = (bw = Fv.now()) + lC, op = d0 = 0;
  try {
    iWe();
  } finally {
    op = 0, aWe(), $f = 0;
  }
}
function oWe() {
  var e = Fv.now(), t = e - bw;
  t > _te && (lC -= t, bw = e);
}
function aWe() {
  for (var e, t = yw, n, r = 1 / 0; t; )
    t._call ? (r > t._time && (r = t._time), e = t, t = t._next) : (n = t._next, t._next = null, t = e ? e._next = n : yw = n);
  f0 = e, AR(r);
}
function AR(e) {
  if (!op) {
    d0 && (d0 = clearTimeout(d0));
    var t = e - $f;
    t > 24 ? (e < 1 / 0 && (d0 = setTimeout(T9, e - Fv.now() - lC)), Nm && (Nm = clearInterval(Nm))) : (Nm || (bw = Fv.now(), Nm = setInterval(oWe, _te)), op = 1, Ste(T9));
  }
}
let I9 = class {
  constructor() {
    ve(this, "loop", () => {
      this.subscribers.forEach((t) => {
        t.callback(_w() - t.startTime, t.duration);
      });
    });
    this.shouldAnimate = !0, this.subscribers = [], this.timer = null, this.activeSubscriptions = 0;
  }
  bypassAnimation() {
    this.shouldAnimate = !1;
  }
  resumeAnimation() {
    this.shouldAnimate = !0;
  }
  start() {
    this.timer || (this.timer = wte(this.loop));
  }
  stop() {
    this.timer && (this.timer.stop(), this.timer = null);
  }
  subscribe(t, n) {
    const r = this.subscribers.push({
      startTime: _w(),
      callback: t,
      duration: this.shouldAnimate ? n : 0
    });
    return this.activeSubscriptions++, this.start(), r;
  }
  unsubscribe(t) {
    t !== null && this.subscribers[t - 1] && (delete this.subscribers[t - 1], this.activeSubscriptions--), this.activeSubscriptions === 0 && this.stop();
  }
};
const xte = /* @__PURE__ */ j.createContext({
  transitionTimer: new I9(),
  animationTimer: new I9()
});
xte.displayName = "TimerContext";
const S3 = xte, sWe = (e) => `ease${e.charAt(0).toUpperCase() + e.slice(1)}`, cWe = 1e3, lWe = (e) => {
  let {
    duration: t = cWe,
    easing: n = "quadInOut",
    delay: r = 0,
    data: i,
    children: o,
    onEnd: a
  } = e;
  const [s, c] = j.useState({
    data: Array.isArray(i) ? i[0] : i,
    animationInfo: {
      progress: 0,
      animating: !1
    }
  }), l = j.useContext(S3).animationTimer, u = j.useRef(Array.isArray(i) ? i.slice(1) : []), d = j.useRef(null), f = j.useRef(void 0), h = VBe[sWe(n)];
  j.useEffect(() => (u.current.length && p(), () => {
    f.current ? l.unsubscribe(f.current) : l.stop();
  }), []), j.useEffect(() => {
    d.current && s.animationInfo && s.animationInfo.progress < 1 ? c({
      data: d.current(1),
      animationInfo: {
        progress: 1,
        animating: !1,
        terminating: !0
      }
    }) : (l.unsubscribe(f.current), u.current = Array.isArray(i) ? i : [i], p());
  }, [i]);
  const p = () => {
    if (u.current.length) {
      const m = u.current[0];
      d.current = nWe(s.data, m), r ? setTimeout(() => {
        f.current = l.subscribe(g, t);
      }, r) : f.current = l.subscribe(g, t);
    } else
      a && a();
  }, g = (m) => {
    if (!d.current)
      return;
    const v = t ? m / t : 1;
    if (v >= 1) {
      c({
        data: d.current(1),
        animationInfo: {
          progress: 1,
          animating: !1,
          terminating: !0
        }
      }), f.current && l.unsubscribe(f.current), u.current.shift(), p();
      return;
    }
    c({
      data: d.current(h(v)),
      animationInfo: {
        progress: v,
        animating: v < 1
      }
    });
  };
  return o(s.data, s.animationInfo);
};
var uWe = nte, dWe = 0;
function fWe(e) {
  var t = ++dWe;
  return uWe(e) + t;
}
var hWe = fWe;
const uC = /* @__PURE__ */ vn(hWe);
function RR() {
  return RR = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, RR.apply(this, arguments);
}
const gWe = /* @__PURE__ */ j.forwardRef((e, t) => /* @__PURE__ */ j.createElement("svg", RR({
  ref: t
}, e)));
function pWe(e, t, n) {
  switch (n.length) {
    case 0:
      return e.call(t);
    case 1:
      return e.call(t, n[0]);
    case 2:
      return e.call(t, n[0], n[1]);
    case 3:
      return e.call(t, n[0], n[1], n[2]);
  }
  return e.apply(t, n);
}
var mWe = pWe, vWe = mWe, $9 = Math.max;
function yWe(e, t, n) {
  return t = $9(t === void 0 ? e.length - 1 : t, 0), function() {
    for (var r = arguments, i = -1, o = $9(r.length - t, 0), a = Array(o); ++i < o; )
      a[i] = r[t + i];
    i = -1;
    for (var s = Array(t + 1); ++i < t; )
      s[i] = r[i];
    return s[t] = n(a), vWe(e, this, s);
  };
}
var Ete = yWe;
function bWe(e) {
  return function() {
    return e;
  };
}
var _We = bWe, SWe = Lf, wWe = function() {
  try {
    var e = SWe(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), Cte = wWe, xWe = _We, A9 = Cte, EWe = By, CWe = A9 ? function(e, t) {
  return A9(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: xWe(t),
    writable: !0
  });
} : EWe, TWe = CWe, IWe = 800, $We = 16, AWe = Date.now;
function RWe(e) {
  var t = 0, n = 0;
  return function() {
    var r = AWe(), i = $We - (r - n);
    if (n = r, i > 0) {
      if (++t >= IWe)
        return arguments[0];
    } else
      t = 0;
    return e.apply(void 0, arguments);
  };
}
var PWe = RWe, OWe = TWe, MWe = PWe, kWe = MWe(OWe), Tte = kWe, NWe = By, DWe = Ete, jWe = Tte;
function LWe(e, t) {
  return jWe(DWe(e, t, NWe), e + "");
}
var dC = LWe, FWe = jf, VWe = qu, BWe = Ix, zWe = Ya;
function HWe(e, t, n) {
  if (!zWe(n))
    return !1;
  var r = typeof t;
  return (r == "number" ? VWe(n) && BWe(t, n.length) : r == "string" && t in n) ? FWe(n[t], e) : !1;
}
var fC = HWe;
function UWe(e) {
  var t = [];
  if (e != null)
    for (var n in Object(e))
      t.push(n);
  return t;
}
var WWe = UWe, qWe = Ya, GWe = iy, KWe = WWe, YWe = Object.prototype, XWe = YWe.hasOwnProperty;
function QWe(e) {
  if (!qWe(e))
    return KWe(e);
  var t = GWe(e), n = [];
  for (var r in e)
    r == "constructor" && (t || !XWe.call(e, r)) || n.push(r);
  return n;
}
var JWe = QWe, ZWe = MU, eqe = JWe, tqe = qu;
function nqe(e) {
  return tqe(e) ? ZWe(e, !0) : eqe(e);
}
var nm = nqe, rqe = dC, iqe = jf, oqe = fC, aqe = nm, Ite = Object.prototype, sqe = Ite.hasOwnProperty, cqe = rqe(function(e, t) {
  e = Object(e);
  var n = -1, r = t.length, i = r > 2 ? t[2] : void 0;
  for (i && oqe(t[0], t[1], i) && (r = 1); ++n < r; )
    for (var o = t[n], a = aqe(o), s = -1, c = a.length; ++s < c; ) {
      var l = a[s], u = e[l];
      (u === void 0 || iqe(u, Ite[l]) && !sqe.call(e, l)) && (e[l] = o[l]);
    }
  return e;
}), lqe = cqe;
const qe = /* @__PURE__ */ vn(lqe);
var R9 = Cte;
function uqe(e, t, n) {
  t == "__proto__" && R9 ? R9(e, t, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : e[t] = n;
}
var hC = uqe, dqe = hC, fqe = jf, hqe = Object.prototype, gqe = hqe.hasOwnProperty;
function pqe(e, t, n) {
  var r = e[t];
  (!(gqe.call(e, t) && fqe(r, n)) || n === void 0 && !(t in e)) && dqe(e, t, n);
}
var gC = pqe, mqe = gC, vqe = Qp, yqe = Ix, P9 = Ya, bqe = Jp;
function _qe(e, t, n, r) {
  if (!P9(e))
    return e;
  t = vqe(t, e);
  for (var i = -1, o = t.length, a = o - 1, s = e; s != null && ++i < o; ) {
    var c = bqe(t[i]), l = n;
    if (c === "__proto__" || c === "constructor" || c === "prototype")
      return e;
    if (i != a) {
      var u = s[c];
      l = r ? r(u, c, s) : void 0, l === void 0 && (l = P9(u) ? u : yqe(t[i + 1]) ? [] : {});
    }
    mqe(s, c, l), s = s[c];
  }
  return e;
}
var $te = _qe, Sqe = Vy, wqe = $te, xqe = Qp;
function Eqe(e, t, n) {
  for (var r = -1, i = t.length, o = {}; ++r < i; ) {
    var a = t[r], s = Sqe(e, a);
    n(s, a) && wqe(o, xqe(a, e), s);
  }
  return o;
}
var Ate = Eqe, Cqe = Ate, Tqe = ate;
function Iqe(e, t) {
  return Cqe(e, t, function(n, r) {
    return Tqe(e, r);
  });
}
var $qe = Iqe, O9 = Cp, Aqe = ny, Rqe = Yi, M9 = O9 ? O9.isConcatSpreadable : void 0;
function Pqe(e) {
  return Rqe(e) || Aqe(e) || !!(M9 && e && e[M9]);
}
var Oqe = Pqe, Mqe = yO, kqe = Oqe;
function Rte(e, t, n, r, i) {
  var o = -1, a = e.length;
  for (n || (n = kqe), i || (i = []); ++o < a; ) {
    var s = e[o];
    t > 0 && n(s) ? t > 1 ? Rte(s, t - 1, n, r, i) : Mqe(i, s) : r || (i[i.length] = s);
  }
  return i;
}
var Pte = Rte, Nqe = Pte;
function Dqe(e) {
  var t = e == null ? 0 : e.length;
  return t ? Nqe(e, 1) : [];
}
var jqe = Dqe, Lqe = jqe, Fqe = Ete, Vqe = Tte;
function Bqe(e) {
  return Vqe(Fqe(e, void 0, Lqe), e + "");
}
var Ote = Bqe, zqe = $qe, Hqe = Ote, Uqe = Hqe(function(e, t) {
  return e == null ? {} : zqe(e, t);
}), Wqe = Uqe;
const Sw = /* @__PURE__ */ vn(Wqe);
function qqe(e) {
  return e.axis !== "x" ? [e.height - e.padding.bottom, e.padding.top] : [e.padding.left, e.width - e.padding.right];
}
function Gqe(e) {
  if (e.axis === "x") {
    const t = pr(e.startAngle || 0), n = pr(e.endAngle || 360);
    return [t, n];
  }
  return [e.innerRadius || 0, PR({
    height: e.height,
    width: e.width,
    padding: e.padding
  })];
}
function Mte(e) {
  return Object.entries(e).reduce((t, n) => (t[n[1]] = n[0], t), {});
}
function Jf(e, t) {
  t === void 0 && (t = []);
  const n = {};
  for (const r in e)
    t.indexOf(r) >= 0 || Object.prototype.hasOwnProperty.call(e, r) && (n[r] = e[r]);
  return n;
}
function kte(e) {
  const {
    _x: t,
    _x1: n,
    _x0: r,
    _voronoiX: i,
    _y: o,
    _y1: a,
    _y0: s,
    _voronoiY: c
  } = e;
  return qe({}, {
    x: i ?? (n ?? t),
    x0: r ?? t,
    y: c ?? (a ?? o),
    y0: s ?? o
  }, e);
}
function Hy(e, t) {
  const {
    scale: n,
    polar: r,
    horizontal: i
  } = e, o = kte(t), a = e.origin || {
    x: 0,
    y: 0
  }, s = i ? n.y(o.y) : n.x(o.x), c = i ? n.y(o.y0) : n.x(o.x0), l = i ? n.x(o.x) : n.y(o.y), u = i ? n.x(o.x0) : n.y(o.y0);
  return {
    x: r ? l * Math.cos(s) + a.x : s,
    x0: r ? u * Math.cos(c) + a.x : c,
    y: r ? -l * Math.sin(s) + a.y : l,
    y0: r ? -u * Math.sin(c) + a.x : u
  };
}
function Gi(e) {
  const t = typeof e == "number" ? e : 0, n = typeof e == "object" ? e : {};
  return {
    top: n.top || t,
    bottom: n.bottom || t,
    left: n.left || t,
    right: n.right || t
  };
}
function pC(e) {
  return (e && e.type && e.type.role) === "tooltip";
}
function Uy(e, t) {
  const {
    theme: n = {},
    labelComponent: r
  } = e, i = n[t] && n[t].style || {};
  if (!pC(r))
    return i;
  const o = n.tooltip && n.tooltip.style || {}, a = qe({}, o, i.labels);
  return qe({}, {
    labels: a
  }, i);
}
function rm(e, t) {
  const n = "100%", r = "100%";
  if (!e)
    return qe({
      parent: {
        height: r,
        width: n
      }
    }, t);
  const {
    data: i,
    labels: o,
    parent: a
  } = e, s = t && t.parent || {}, c = t && t.labels || {}, l = t && t.data || {};
  return {
    parent: qe({}, a, s, {
      width: n,
      height: r
    }),
    labels: qe({}, o, c),
    data: qe({}, i, l)
  };
}
function Fe(e, t) {
  return Rn(e) ? e(t) : e;
}
function Sr(e, t) {
  return t.disableInlineStyles ? {} : !e || !Object.keys(e).some((n) => Rn(e[n])) ? e : Object.keys(e).reduce((n, r) => (n[r] = Fe(e[r], t), n), {});
}
function pr(e) {
  return typeof e == "number" ? e * (Math.PI / 180) : e;
}
function ol(e) {
  return typeof e == "number" ? e / (Math.PI / 180) : e;
}
function PR(e) {
  const {
    width: t,
    height: n,
    padding: r
  } = e, {
    left: i,
    right: o,
    top: a,
    bottom: s
  } = r;
  return Math.min(t - i - o, n - a - s) / 2;
}
function Zf(e) {
  const {
    width: t,
    height: n
  } = e, {
    top: r,
    bottom: i,
    left: o,
    right: a
  } = Gi(e.padding), s = Math.min(t - o - a, n - r - i) / 2, c = t / 2 + o - a, l = n / 2 + r - i;
  return {
    x: c + s > t ? s + o - a : c,
    y: l + s > n ? s + r - i : l
  };
}
function kr(e, t) {
  return e.range && e.range[t] ? e.range[t] : e.range && Array.isArray(e.range) ? e.range : e.polar ? Gqe({
    axis: t,
    innerRadius: e.innerRadius,
    startAngle: e.startAngle,
    endAngle: e.endAngle,
    height: e.height,
    width: e.width,
    padding: Gi(e.padding)
  }) : qqe({
    axis: t,
    height: e.height,
    width: e.width,
    padding: Gi(e.padding)
  });
}
function Ga(e) {
  return e == null;
}
function Rn(e) {
  return typeof e == "function";
}
function mC(e) {
  return Rn(e) ? e : e == null ? (t) => t : cte(e);
}
function wr(e, t, n) {
  const r = e.theme && e.theme[n] ? e.theme[n] : {}, i = Jf(r, ["style"]), o = Kqe(e);
  return qe(o === void 0 ? {} : {
    horizontal: o
  }, e, i, t);
}
function Nte(e, t) {
  return t ? e === "x" ? "y" : "x" : e;
}
function w3(e, t, n) {
  const r = t ? e : 0;
  let i = t || e;
  i || (i = 0);
  const o = i - r, a = Math.abs(o), s = o / a || 1, c = n || 1, l = Math.max(Math.ceil(a / c), 0);
  return Array.from(Array(l), (u, d) => r + d * s * c);
}
function im(e, t, n, r, i) {
  n === void 0 && (n = {}), r === void 0 && (r = []), i === void 0 && (i = (l, u) => (
    // @ts-expect-error These defaults are hard to type
    l.concat(u)
  ));
  const o = ["data", "domain", "categories", "polar", "startAngle", "endAngle", "minDomain", "maxDomain", "horizontal"], a = (l, u, d) => l.reduce((f, h, p) => {
    let g = f;
    const m = h.type && h.type.role, v = h.props.name || `${m}-${u[p]}`;
    if (h.props && h.props.children) {
      const y = Object.assign({}, h.props, Sw(n, o)), _ = h.type && h.type.role === "stack" && Rn(h.type.getChildren) ? h.type.getChildren(y) : j.Children.toArray(h.props.children).map((C) => {
        const x = Object.assign({}, C.props, Sw(y, o));
        return /* @__PURE__ */ j.cloneElement(C, x);
      }), b = _.map((C, x) => `${v}-${x}`), w = a(_, b, h);
      g = i(g, w);
    } else {
      const y = t(h, v, d);
      y && (g = i(g, y));
    }
    return g;
  }, r), s = e.filter(ZP), c = s.map((l, u) => u);
  return a(s, c);
}
function Kqe(e) {
  if (e.horizontal !== void 0 || !e.children)
    return e.horizontal;
  const t = (n) => n.reduce((r, i) => {
    const o = i.props || {};
    return r || o.horizontal || !o.children ? r || o.horizontal : t(j.Children.toArray(o.children));
  }, !1);
  return t(j.Children.toArray(e.children));
}
const Dte = {
  startsWith: ["data-", "aria-"],
  exactMatch: []
}, Yqe = (e) => {
  let t = !1;
  return Dte.startsWith.forEach((n) => {
    new RegExp(`\\b(${n})(\\w|-)+`, "g").test(e) && (t = !0);
  }), t;
}, Xqe = (e) => Dte.exactMatch.includes(e), Qqe = (e) => !!(Yqe(e) || Xqe(e));
function w1(e, t) {
  if (e == null)
    throw new Error(t);
}
const es = (e) => {
  const t = {
    ...e
  };
  return Object.fromEntries(Object.entries(t).filter((n) => {
    let [r] = n;
    return Qqe(r);
  }).map((n) => {
    let [r, i] = n;
    return [r, Fe(i, e)];
  }));
}, Wy = (e, t) => /* @__PURE__ */ $.cloneElement(e, es(t));
var Jqe = NU, Zqe = oy, eGe = ny, tGe = Yi, nGe = qu, rGe = ry, iGe = iy, oGe = Ax, aGe = "[object Map]", sGe = "[object Set]", cGe = Object.prototype, lGe = cGe.hasOwnProperty;
function uGe(e) {
  if (e == null)
    return !0;
  if (nGe(e) && (tGe(e) || typeof e == "string" || typeof e.splice == "function" || rGe(e) || oGe(e) || eGe(e)))
    return !e.length;
  var t = Zqe(e);
  if (t == aGe || t == sGe)
    return !e.size;
  if (iGe(e))
    return !Jqe(e).length;
  for (var n in e)
    if (lGe.call(e, n))
      return !1;
  return !0;
}
var dGe = uGe;
const Lr = /* @__PURE__ */ vn(dGe);
var fGe = typeof Element < "u", hGe = typeof Map == "function", gGe = typeof Set == "function", pGe = typeof ArrayBuffer == "function" && !!ArrayBuffer.isView;
function __(e, t) {
  if (e === t)
    return !0;
  if (e && t && typeof e == "object" && typeof t == "object") {
    if (e.constructor !== t.constructor)
      return !1;
    var n, r, i;
    if (Array.isArray(e)) {
      if (n = e.length, n != t.length)
        return !1;
      for (r = n; r-- !== 0; )
        if (!__(e[r], t[r]))
          return !1;
      return !0;
    }
    var o;
    if (hGe && e instanceof Map && t instanceof Map) {
      if (e.size !== t.size)
        return !1;
      for (o = e.entries(); !(r = o.next()).done; )
        if (!t.has(r.value[0]))
          return !1;
      for (o = e.entries(); !(r = o.next()).done; )
        if (!__(r.value[1], t.get(r.value[0])))
          return !1;
      return !0;
    }
    if (gGe && e instanceof Set && t instanceof Set) {
      if (e.size !== t.size)
        return !1;
      for (o = e.entries(); !(r = o.next()).done; )
        if (!t.has(r.value[0]))
          return !1;
      return !0;
    }
    if (pGe && ArrayBuffer.isView(e) && ArrayBuffer.isView(t)) {
      if (n = e.length, n != t.length)
        return !1;
      for (r = n; r-- !== 0; )
        if (e[r] !== t[r])
          return !1;
      return !0;
    }
    if (e.constructor === RegExp)
      return e.source === t.source && e.flags === t.flags;
    if (e.valueOf !== Object.prototype.valueOf && typeof e.valueOf == "function" && typeof t.valueOf == "function")
      return e.valueOf() === t.valueOf();
    if (e.toString !== Object.prototype.toString && typeof e.toString == "function" && typeof t.toString == "function")
      return e.toString() === t.toString();
    if (i = Object.keys(e), n = i.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(t, i[r]))
        return !1;
    if (fGe && e instanceof Element)
      return !1;
    for (r = n; r-- !== 0; )
      if (!((i[r] === "_owner" || i[r] === "__v" || i[r] === "__o") && e.$$typeof) && !__(e[i[r]], t[i[r]]))
        return !1;
    return !0;
  }
  return e !== e && t !== t;
}
var mGe = function(t, n) {
  try {
    return __(t, n);
  } catch (r) {
    if ((r.message || "").match(/stack|recursion/i))
      return console.warn("react-fast-compare cannot handle circular refs"), !1;
    throw r;
  }
};
const Es = /* @__PURE__ */ vn(mGe);
function jte(e) {
  return Array.isArray(e) && e.length > 0;
}
function ww(e) {
  return Array.isArray(e) && e.some((t) => typeof t == "string");
}
function Fu(e) {
  return Array.isArray(e) && e.some((t) => t instanceof Date);
}
function vGe(e) {
  return jte(e) && e.every((t) => typeof t == "string");
}
function xw(e, t) {
  return e && t ? e.filter((n) => !t.includes(n)) : [];
}
function k9(e) {
  return jte(e) && e.every(Array.isArray);
}
function yGe(e) {
  return e.filter((t) => t !== void 0);
}
function xa(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  const i = e.concat(n);
  return Fu(i) ? new Date(Math.max(...i)) : Math.max(...i);
}
function Ea(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  const i = e.concat(n);
  return Fu(i) ? new Date(Math.min(...i)) : Math.min(...i);
}
function Lte(e, t) {
  return (e.key || t).toString();
}
function N9(e) {
  return e.reduce((t, n, r) => {
    const i = Lte(n, r);
    return t[i] = n, t;
  }, {});
}
function D9(e, t) {
  let n = !1;
  const r = Object.keys(e).reduce((i, o) => (o in t || (n = !0, i[o] = !0), i), {});
  return n && r;
}
function bGe(e, t) {
  const n = e && N9(e), r = t && N9(t);
  return {
    entering: n && D9(r, n),
    exiting: r && D9(n, r)
  };
}
function OR(e) {
  return e.type && e.type.getData ? e.type.getData(e.props) : e.props && e.props.data || !1;
}
function Fte(e, t) {
  let n = !1, r = !1;
  const i = (s, c) => {
    if (!c || s.type !== c.type)
      return {};
    const {
      entering: l,
      exiting: u
    } = bGe(OR(s), OR(c)) || {};
    return n = n || !!u, r = r || !!l, {
      entering: l || !1,
      exiting: u || !1
    };
  }, o = (s, c) => s.map((l, u) => l && l.props && l.props.children && c[u] ? o(j.Children.toArray(s[u].props.children), j.Children.toArray(c[u].props.children)) : i(l, c[u])), a = o(j.Children.toArray(e), j.Children.toArray(t));
  return {
    nodesWillExit: n,
    nodesWillEnter: r,
    childrenTransitions: a,
    // TODO: This may need to be refactored for the following situation.
    //       The component receives new props, and the data provided
    //       is a perfect match for the previous data and domain except
    //       for new nodes. In this case, we wouldn't want a delay before
    //       the new nodes appear.
    nodesShouldEnter: !1
  };
}
function _Ge(e, t) {
  const n = e.onEnter && e.onEnter.after ? e.onEnter.after : Zp;
  return {
    data: t.map((r, i) => Object.assign({}, r, n(r, i, t)))
  };
}
function SGe(e, t, n, r) {
  const i = Object.assign({}, e, {
    onEnd: r
  });
  if (i && i.onLoad && !i.onLoad.duration)
    return {
      animate: i,
      data: n
    };
  const o = i.onLoad && i.onLoad.before ? i.onLoad.before : Zp, a = n.map((s, c) => Object.assign({}, s, o(s, c, n)));
  return {
    animate: i,
    data: a,
    clipWidth: 0
  };
}
function wGe(e, t, n) {
  const r = Object.assign({}, e, {
    onEnd: n
  });
  let i = t;
  if (r && r.onLoad && !r.onLoad.duration)
    return {
      animate: e,
      data: t
    };
  const o = e.onLoad && e.onLoad.after ? e.onLoad.after : Zp;
  return i = t.map((a, s) => Object.assign({}, a, o(a, s, t))), {
    animate: r,
    data: i
  };
}
function xGe(e, t, n, r, i) {
  const o = e && e.onExit, a = Object.assign({}, e, o);
  let s = n;
  if (r) {
    e.onEnd = i;
    const c = e.onExit && e.onExit.before ? e.onExit.before : Zp;
    s = n.map((l, u) => {
      const d = (l.key || u).toString();
      return r[d] ? Object.assign({}, l, c(l, u, n)) : l;
    });
  }
  return {
    animate: a,
    data: s
  };
}
function EGe(e, t, n, r, i) {
  let o = e, a = n;
  if (r) {
    o = Object.assign({}, e, {
      onEnd: i
    });
    const s = e.onEnter && e.onEnter.before ? e.onEnter.before : Zp;
    a = n.map((c, l) => {
      const u = (c.key || l).toString();
      return r[u] ? Object.assign({}, c, s(c, l, n)) : c;
    });
  }
  return {
    animate: o,
    data: a
  };
}
function CGe(e, t, n, r) {
  const i = e && e.onEnter, o = Object.assign({}, e, i);
  let a = t;
  if (n) {
    o.onEnd = r;
    const s = o.onEnter && o.onEnter.after ? o.onEnter.after : Zp;
    a = t.map((c, l) => {
      const u = Lte(c, l);
      return n[u] ? Object.assign({}, c, s(c, l, t)) : c;
    });
  }
  return {
    animate: o,
    data: a
  };
}
function Vte(e, t, n) {
  const r = t && t.nodesWillExit, i = t && t.nodesWillEnter, o = t && t.nodesShouldEnter, a = t && t.nodesShouldLoad, s = t && t.nodesDoneLoad, c = t && t.childrenTransitions || [], l = {
    enter: e.animate && e.animate.onEnter && e.animate.onEnter.duration,
    exit: e.animate && e.animate.onExit && e.animate.onExit.duration,
    load: e.animate && e.animate.onLoad && e.animate.onLoad.duration,
    move: e.animate && e.animate.duration
  }, u = (p, g, m) => a ? wGe(m, g, () => {
    n({
      nodesShouldLoad: !1,
      nodesDoneLoad: !0
    });
  }) : SGe(m, p, g, () => {
    n({
      nodesDoneLoad: !0
    });
  }), d = (p, g, m, v) => xGe(v, g, m, p, () => {
    n({
      nodesWillExit: !1
    });
  }), f = (p, g, m, v) => o ? CGe(v, m, p, () => {
    n({
      nodesWillEnter: !1
    });
  }) : EGe(v, g, m, p, () => {
    n({
      nodesShouldEnter: !0
    });
  }), h = function(p, g) {
    const m = p.props.animate;
    if (!p.type)
      return {};
    const v = p.props && p.props.polar && p.type.defaultPolarTransitions || p.type.defaultTransitions;
    if (v) {
      const y = m[g] && m[g].duration;
      return y !== void 0 ? y : v[g] && v[g].duration;
    }
    return {};
  };
  return function(g, m) {
    const v = OR(g) || [], y = qe({}, e.animate, g.props.animate), _ = g.props.polar && g.type.defaultPolarTransitions || g.type.defaultTransitions;
    y.onExit = qe({}, y.onExit, _ && _.onExit), y.onEnter = qe({}, y.onEnter, _ && _.onEnter), y.onLoad = qe({}, y.onLoad, _ && _.onLoad);
    const b = c[m] || c[0];
    if (s) {
      if (r) {
        const w = b && b.exiting, C = l.exit !== void 0 ? l.exit : h(g, "onExit");
        return d(w, g, v, Object.assign({}, y, w ? {
          duration: C
        } : {
          delay: C
        }));
      } else if (i) {
        const w = b && b.entering, C = l.enter !== void 0 ? l.enter : h(g, "onEnter"), x = l.move !== void 0 ? l.move : g.props.animate && g.props.animate.duration;
        return f(w, g, v, Object.assign({}, y, {
          duration: o && w ? C : x
        }));
      } else if (!t && y && y.onExit)
        return _Ge(y, v);
    } else {
      const C = {
        duration: l.load !== void 0 ? l.load : h(g, "onLoad")
      };
      return u(g, v, Object.assign({}, y, C));
    }
    return {
      animate: y,
      data: v
    };
  };
}
function MR() {
  return MR = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, MR.apply(this, arguments);
}
class kR extends j.Component {
  constructor(t, n) {
    super(t, n), this.state = {
      nodesShouldLoad: !1,
      nodesDoneLoad: !1
    };
    const r = this.props.children, i = r.props.polar;
    this.continuous = !i && r.type && r.type.continuous === !0, this.timer = this.context.transitionTimer;
  }
  componentDidMount() {
    this.setState({
      nodesShouldLoad: !0
    });
  }
  shouldComponentUpdate(t) {
    return Es(this.props, t) || (this.timer.bypassAnimation(), this.setState(this.getTransitionState(this.props, t), () => this.timer.resumeAnimation())), !0;
  }
  componentWillUnmount() {
    this.timer.stop();
  }
  getTransitionState(t, n) {
    const {
      animate: r
    } = t;
    if (r) {
      if (r.parentState)
        return {
          oldProps: r.parentState.nodesWillExit ? t : null,
          nextProps: n
        };
    } else
      return {};
    const i = j.Children.toArray(t.children), o = j.Children.toArray(n.children), {
      nodesWillExit: a,
      nodesWillEnter: s,
      childrenTransitions: c,
      nodesShouldEnter: l
    } = Fte(i, o);
    return {
      nodesWillExit: a,
      nodesWillEnter: s,
      childrenTransitions: c,
      nodesShouldEnter: l,
      oldProps: a ? t : null,
      nextProps: n
    };
  }
  getDomainFromChildren(t, n) {
    const r = (c) => c.reduce((l, u) => {
      if (u.type && Rn(u.type.getDomain)) {
        const d = u.props && u.type.getDomain(u.props, n);
        return d ? l.concat(d) : l;
      } else if (u.props && u.props.children)
        return l.concat(r(j.Children.toArray(u.props.children)));
      return l;
    }, []), i = j.Children.toArray(t.children)[0], o = i.props || {}, a = Array.isArray(o.domain) ? o.domain : o.domain && o.domain[n];
    if (!o.children && a)
      return a;
    const s = r([i]);
    return s.length === 0 ? [0, 1] : [Ea(s), xa(s)];
  }
  pickProps() {
    return this.state ? this.state.nodesWillExit ? this.state.oldProps || this.props : this.props : this.props;
  }
  pickDomainProps(t) {
    var r;
    const n = (r = t.animate) == null ? void 0 : r.parentState;
    return n && n.nodesWillExit ? (this.continuous || n.continuous) && (n.nextProps || this.state.nextProps) || t : this.continuous && this.state.nodesWillExit && this.state.nextProps || t;
  }
  getClipWidth(t, n) {
    const r = () => {
      const o = kr(n.props, "x");
      return o ? Math.abs(o[1] - o[0]) : t.width;
    }, i = this.transitionProps ? this.transitionProps.clipWidth : void 0;
    return i !== void 0 ? i : r();
  }
  render() {
    var d;
    const t = this.pickProps(), n = (d = this.props.animate) != null && d.getTransitions ? this.props.animate.getTransitions : Vte(t, this.state, (f) => this.setState(f)), r = j.Children.toArray(t.children)[0], i = n(r);
    this.transitionProps = i;
    const o = {
      x: this.getDomainFromChildren(this.pickDomainProps(t), "x"),
      y: this.getDomainFromChildren(t, "y")
    }, a = this.getClipWidth(t, r), s = qe({
      domain: o,
      clipWidth: a
    }, i, r.props), l = (t.animationWhitelist || []).concat(["clipWidth"]), u = l.length ? Sw(s, l) : s;
    return /* @__PURE__ */ j.createElement(lWe, MR({}, s.animate, {
      data: u
    }), (f) => {
      if (r.props.groupComponent) {
        const h = this.continuous ? /* @__PURE__ */ j.cloneElement(r.props.groupComponent, {
          clipWidth: f.clipWidth || 0
        }) : r.props.groupComponent;
        return /* @__PURE__ */ j.cloneElement(r, qe({
          animate: null,
          animating: !0,
          groupComponent: h
        }, f, s));
      }
      return /* @__PURE__ */ j.cloneElement(r, qe({
        animate: null,
        animating: !0
      }, f, s));
    });
  }
}
ve(kR, "displayName", "VictoryTransition"), ve(kR, "contextType", S3);
var TGe = yO, IGe = d3, $Ge = bO, AGe = PU, RGe = Object.getOwnPropertySymbols, PGe = RGe ? function(e) {
  for (var t = []; e; )
    TGe(t, $Ge(e)), e = IGe(e);
  return t;
} : AGe, Bte = PGe, OGe = AU, MGe = Bte, kGe = nm;
function NGe(e) {
  return OGe(e, kGe, MGe);
}
var x3 = NGe, DGe = Ly, jGe = em, LGe = Ate, FGe = x3;
function VGe(e, t) {
  if (e == null)
    return {};
  var n = DGe(FGe(e), function(r) {
    return [r];
  });
  return t = jGe(t), LGe(e, n, function(r, i) {
    return t(r, i[0]);
  });
}
var zte = VGe;
const Ew = /* @__PURE__ */ vn(zte);
var BGe = "Expected a function";
function zGe(e) {
  if (typeof e != "function")
    throw new TypeError(BGe);
  return function() {
    var t = arguments;
    switch (t.length) {
      case 0:
        return !e.call(this);
      case 1:
        return !e.call(this, t[0]);
      case 2:
        return !e.call(this, t[0], t[1]);
      case 3:
        return !e.call(this, t[0], t[1], t[2]);
    }
    return !e.apply(this, t);
  };
}
var HGe = zGe, UGe = em, WGe = HGe, qGe = zte;
function GGe(e, t) {
  return qGe(e, WGe(UGe(t)));
}
var KGe = GGe;
const Hte = /* @__PURE__ */ vn(KGe);
function YGe(e, t, n, r) {
  for (var i = e.length, o = n + (r ? 1 : -1); r ? o-- : ++o < i; )
    if (t(e[o], o, e))
      return o;
  return -1;
}
var XGe = YGe;
function QGe(e) {
  return e !== e;
}
var JGe = QGe;
function ZGe(e, t, n) {
  for (var r = n - 1, i = e.length; ++r < i; )
    if (e[r] === t)
      return r;
  return -1;
}
var eKe = ZGe, tKe = XGe, nKe = JGe, rKe = eKe;
function iKe(e, t, n) {
  return t === t ? rKe(e, t, n) : tKe(e, nKe, n);
}
var oKe = iKe, aKe = oKe;
function sKe(e, t) {
  var n = e == null ? 0 : e.length;
  return !!n && aKe(e, t, 0) > -1;
}
var Ute = sKe;
function cKe(e, t, n) {
  for (var r = -1, i = e == null ? 0 : e.length; ++r < i; )
    if (n(t, e[r]))
      return !0;
  return !1;
}
var Wte = cKe;
function lKe() {
}
var uKe = lKe, WT = jU, dKe = uKe, fKe = vO, hKe = 1 / 0, gKe = WT && 1 / fKe(new WT([, -0]))[1] == hKe ? function(e) {
  return new WT(e);
} : dKe, pKe = gKe, mKe = pO, vKe = Ute, yKe = Wte, bKe = mO, _Ke = pKe, SKe = vO, wKe = 200;
function xKe(e, t, n) {
  var r = -1, i = vKe, o = e.length, a = !0, s = [], c = s;
  if (n)
    a = !1, i = yKe;
  else if (o >= wKe) {
    var l = t ? null : _Ke(e);
    if (l)
      return SKe(l);
    a = !1, i = bKe, c = new mKe();
  } else
    c = t ? [] : s;
  e:
    for (; ++r < o; ) {
      var u = e[r], d = t ? t(u) : u;
      if (u = n || u !== 0 ? u : 0, a && d === d) {
        for (var f = c.length; f--; )
          if (c[f] === d)
            continue e;
        t && c.push(d), s.push(u);
      } else
        i(c, d, n) || (c !== s && c.push(d), s.push(u));
    }
  return s;
}
var qte = xKe, EKe = qte;
function CKe(e) {
  return e && e.length ? EKe(e) : [];
}
var TKe = CKe;
const bl = /* @__PURE__ */ vn(TKe), E3 = /^onGlobal(.*)$/;
function Gte(e, t, n, r) {
  const i = (u) => {
    const f = (() => {
      const h = u.reduce((p, g) => g.target !== void 0 ? (Array.isArray(g.target) ? g.target.includes(t) : `${g.target}` == `${t}`) ? p.concat(g) : p : p.concat(g), []);
      return n !== void 0 && t !== "parent" ? h.filter((p) => {
        const g = p.eventKey, m = (v) => v ? `${v}` == `${n}` : !0;
        return Array.isArray(g) ? g.some((v) => m(v)) : m(g);
      }) : h;
    })();
    return Array.isArray(f) && f.reduce((h, p) => p ? Object.assign(h, p.eventHandlers) : h, {});
  }, a = (() => Array.isArray(this.componentEvents) ? Array.isArray(e.events) ? this.componentEvents.concat(...e.events) : this.componentEvents : e.events)(), s = a && Rn(r) ? r(i(a), t) : void 0;
  if (!e.sharedEvents)
    return s;
  const c = e.sharedEvents.getEvents, l = e.sharedEvents.events && c(i(e.sharedEvents.events), t);
  return Object.assign({}, l, s);
}
function Kte(e, t, n, r) {
  if (Lr(e))
    return {};
  const i = r || this.baseProps, o = (u, d) => {
    const {
      childName: f,
      target: h,
      key: p
    } = u, g = d === "props" ? i : this.state || {}, m = f == null || !g[f] ? g : g[f];
    return p === "parent" ? m.parent : m[p] && m[p][h];
  }, a = (u, d) => {
    const f = t === "parent" ? u.childName : u.childName || n, h = u.target || t, p = (y) => h === "parent" ? "parent" : u.eventKey === "all" ? i[y] ? Object.keys(i[y]).filter((_) => _ !== "parent") : Object.keys(i).filter((_) => _ !== "parent") : u.eventKey === void 0 && d === "parent" ? i[y] ? Object.keys(i[y]) : Object.keys(i) : u.eventKey !== void 0 ? u.eventKey : d, g = (y, _) => {
      const b = this.state || {};
      if (!Rn(u.mutation))
        return b;
      const w = o({
        childName: _,
        key: y,
        target: h
      }, "props"), C = o({
        childName: _,
        key: y,
        target: h
      }, "state"), x = u.mutation(Object.assign({}, w, C), i), T = b[_] || {}, E = (O) => (O[y] && O[y][h] && delete O[y][h], O[y] && !Object.keys(O[y]).length && delete O[y], O), R = (O) => h === "parent" ? Object.assign(O, {
        [y]: Object.assign(O[y] || {}, x)
      }) : Object.assign(O, {
        [y]: Object.assign(O[y] || {}, {
          [h]: x
        })
      }), I = (O) => x ? R(O) : E(O);
      return _ != null ? Object.assign(b, {
        [_]: I(T)
      }) : I(b);
    }, m = (y) => {
      const _ = p(y);
      return Array.isArray(_) ? _.reduce((b, w) => Object.assign(b, g(w, y)), {}) : g(_, y);
    }, v = f === "all" ? Object.keys(i).filter((y) => y !== "parent") : f;
    return Array.isArray(v) ? v.reduce((y, _) => Object.assign(y, m(_)), {}) : m(v);
  }, s = (u, d) => Array.isArray(u) ? u.reduce((f, h) => Object.assign({}, f, a(h, d)), {}) : a(u, d), c = (u) => {
    const d = (p) => Rn(p.callback) && p.callback, h = (Array.isArray(u) ? u.map((p) => d(p)) : [d(u)]).filter((p) => p !== !1);
    return h.length ? () => h.forEach((p) => p()) : void 0;
  }, l = (u, d, f, h) => {
    const p = e[h](u, d, f, this);
    if (!Lr(p)) {
      const g = c(p);
      this.setState(s(p, f), g);
    }
  };
  return Object.keys(e).reduce((u, d) => (u[d] = l, u), {});
}
function Yte(e, t, n) {
  return e ? Object.keys(e).reduce((r, i) => {
    const o = (a) => e[i](a, n, t, i);
    return r[i] = o, r;
  }, {}) : {};
}
function Xte(e, t, n) {
  const r = this.state || {};
  return n ? r[n] && r[n][e] && r[n][e][t] : e === "parent" ? r[e] && r[e][t] || r[e] : r[e] && r[e][t];
}
function IKe(e, t, n, r) {
  return t === void 0 && (t = {}), n === void 0 && (n = {}), r.reduce((i, o) => {
    const a = n[o], s = Qte(e, t[o], n[o], o);
    return i[o] = s || a, Ew(i, (c) => !Lr(c));
  }, {});
}
function Qte(e, t, n, r) {
  return t === void 0 && (t = {}), n === void 0 && (n = {}), Object.keys(t).reduce((o, a) => {
    const s = n[a] || {}, c = t[a] || {};
    if (a === "parent") {
      const u = j9(e, c, s, {
        eventKey: a,
        target: "parent"
      });
      o[a] = u !== void 0 ? Object.assign({}, s, u) : s;
    } else {
      const l = bl(Object.keys(c).concat(Object.keys(s)));
      o[a] = l.reduce((u, d) => {
        const f = {
          eventKey: a,
          target: d,
          childName: r
        }, h = j9(e, c[d], s[d], f);
        return u[d] = h !== void 0 ? Object.assign({}, s[d], h) : s[d], Ew(u, (p) => !Lr(p));
      }, {});
    }
    return Ew(o, (l) => !Lr(l));
  }, {});
}
function j9(e, t, n, r) {
  const i = (c, l) => typeof c[l] == "string" ? c[l] === "all" || c[l] === r[l] : Array.isArray(c[l]) ? c[l].map((d) => `${d}`).includes(r[l]) : !1;
  let o = Array.isArray(e) ? e : [e];
  r.childName && (o = e.filter((c) => i(c, "childName")));
  const a = o.filter((c) => i(c, "target"));
  if (Lr(a))
    return;
  const s = a.filter((c) => i(c, "eventKey"));
  if (!Lr(s))
    return s.reduce((c, l) => {
      const d = (l && Rn(l.mutation) ? l.mutation : () => {
      })(Object.assign({}, t, n));
      return Object.assign({}, c, d);
    }, {});
}
function C3(e, t) {
  const n = Array.isArray(t) && t.reduce((r, i) => {
    const o = e[i], a = o && o.type && o.type.defaultEvents, s = Rn(a) ? a(o.props) : a;
    return Array.isArray(s) ? r.concat(...s) : r;
  }, []);
  return n && n.length ? n : void 0;
}
function Cw(e) {
  const t = e.match(E3);
  return t && t[1] && t[1].toLowerCase();
}
const Jte = (e) => Ew(e, (t, n) => E3.test(n)), Zte = (e) => Hte(e, (t, n) => E3.test(n)), ene = (e) => Object.assign(e, {
  nativeEvent: e
}), $Ke = (e) => !Ga(e._x) && !Ga(e._y), AKe = [{
  name: "parent",
  index: "parent"
}, {
  name: "data"
}, {
  name: "labels"
}];
function ad(e, t) {
  t === void 0 && (t = {});
  class n extends e {
    constructor(o) {
      super(o);
      ve(this, "state", {});
      ve(this, "getEventState", Xte.bind(this));
      ve(this, "getScopedEvents", Kte.bind(this));
      ve(this, "getEvents", (o, a, s) => Gte.call(this, o, a, s, this.getScopedEvents));
      ve(this, "externalMutations", this.getExternalMutations(this.props));
      ve(this, "calculatedState", this.getStateChanges(this.props));
      ve(this, "globalEvents", {});
      ve(this, "prevGlobalEventKeys", []);
      ve(this, "boundGlobalEvents", {});
      this.cacheValues(this.getCalculatedValues(o));
    }
    shouldComponentUpdate(o) {
      const a = this.getExternalMutations(o), s = this.props.animating || this.props.animate, c = !Es(a, this.externalMutations);
      if (s || c)
        return this.cacheValues(this.getCalculatedValues(o)), this.externalMutations = a, this.applyExternalMutations(o, a), !0;
      const l = this.getStateChanges(o);
      return Es(this.calculatedState, l) ? Es(this.props, o) ? !1 : (this.cacheValues(this.getCalculatedValues(o)), !0) : (this.cacheValues(this.getCalculatedValues(o)), !0);
    }
    componentDidMount() {
      const o = Object.keys(this.globalEvents);
      o.forEach((a) => this.addGlobalListener(a)), this.prevGlobalEventKeys = o;
    }
    componentDidUpdate(o) {
      const a = this.getStateChanges(o);
      this.calculatedState = a;
      const s = Object.keys(this.globalEvents);
      xw(this.prevGlobalEventKeys, s).forEach((u) => this.removeGlobalListener(u)), xw(s, this.prevGlobalEventKeys).forEach((u) => this.addGlobalListener(u)), this.prevGlobalEventKeys = s;
    }
    componentWillUnmount() {
      this.prevGlobalEventKeys.forEach((o) => this.removeGlobalListener(o));
    }
    addGlobalListener(o) {
      const a = (s) => {
        const c = this.globalEvents[o];
        return c && c(ene(s));
      };
      this.boundGlobalEvents[o] = a, window.addEventListener(Cw(o), a);
    }
    removeGlobalListener(o) {
      window.removeEventListener(Cw(o), this.boundGlobalEvents[o]);
    }
    // compile all state changes from own and parent state. Order doesn't matter, as any state
    // state change should trigger a re-render
    getStateChanges(o) {
      if (!this.hasEvents)
        return {};
      const a = (l, u) => {
        const d = qe({}, this.getEventState(l, u), this.getSharedEventState(l, u));
        return Lr(d) ? void 0 : d;
      };
      return (t.components || AKe).map((l) => {
        if (!(!o.standalone && l.name === "parent"))
          return l.index !== void 0 ? a(l.index, l.name) : this.dataKeys.map((u) => a(u, l.name)).filter(Boolean);
      }).filter(Boolean);
    }
    applyExternalMutations(o, a) {
      if (!Lr(a)) {
        const s = o.externalEventMutations.reduce((l, u) => Rn(u.callback) ? l.concat(u.callback) : l, []), c = s.length ? () => {
          s.forEach((l) => l());
        } : void 0;
        this.setState(a, c);
      }
    }
    getCalculatedValues(o) {
      const {
        sharedEvents: a
      } = o, s = e.expectedComponents, c = C3(o, s), l = a && Rn(a.getEventState) ? a.getEventState : () => {
      }, u = this.getBaseProps(o, l), d = Object.keys(u).filter((p) => p !== "parent"), f = o.events || o.sharedEvents || c, h = this.getAllEvents(o);
      return {
        componentEvents: c,
        getSharedEventState: l,
        baseProps: u,
        dataKeys: d,
        hasEvents: f,
        events: h
      };
    }
    getExternalMutations(o) {
      const {
        sharedEvents: a,
        externalEventMutations: s
      } = o;
      return Lr(s) || a ? void 0 : Qte(s, this.baseProps, this.state);
    }
    cacheValues(o) {
      Object.keys(o).forEach((a) => {
        this[a] = o[a];
      });
    }
    getBaseProps(o, a) {
      const c = (a || this.getSharedEventState.bind(this))("parent", "parent"), l = this.getEventState("parent", "parent"), u = qe({}, l, c), d = u.parentControlledProps, f = d ? Sw(u, d) : {}, h = qe({}, f, o);
      return typeof e.getBaseProps == "function" ? e.getBaseProps(h) : {};
    }
    getAllEvents(o) {
      return Array.isArray(this.componentEvents) ? Array.isArray(o.events) ? this.componentEvents.concat(...o.events) : this.componentEvents : o.events;
    }
    getComponentProps(o, a, s) {
      const c = this.props.name || e.role, l = this.dataKeys && this.dataKeys[s] || s, u = `${c}-${a}-${l}`, d = this.baseProps[l] && this.baseProps[l][a] || this.baseProps[l];
      if (!d && !this.hasEvents)
        return;
      const f = o && typeof o == "object" && "props" in o ? o.props : void 0;
      if (this.hasEvents) {
        const h = this.getEvents(this.props, a, l), p = qe({
          index: s,
          key: u
        }, this.getEventState(l, a), this.getSharedEventState(l, a), f, d, {
          id: u
        }), g = qe({}, Yte(h, l, p), p.events);
        return Object.assign({}, p, {
          events: g
        });
      }
      return qe({
        index: s,
        key: u
      }, f, d, {
        id: u
      });
    }
    renderContainer(o, a) {
      const c = o.type && o.type.role === "container" ? this.getComponentProps(o, "parent", "parent") : {};
      return c.events && (this.globalEvents = Jte(c.events), c.events = Zte(c.events)), /* @__PURE__ */ j.cloneElement(o, c, a);
    }
    animateComponent(o, a) {
      var l;
      const s = typeof o.animate == "object" && ((l = o.animate) == null ? void 0 : l.animationWhitelist) || a, c = this.constructor;
      return /* @__PURE__ */ j.createElement(kR, {
        animate: o.animate,
        animationWhitelist: s
      }, /* @__PURE__ */ j.createElement(c, o));
    }
    // Used by `VictoryLine` and `VictoryArea`
    renderContinuousData(o) {
      const {
        dataComponent: a,
        labelComponent: s,
        groupComponent: c
      } = o, u = this.dataKeys.filter((h) => h !== "all").reduce((h, p) => {
        let g = h;
        const m = this.getComponentProps(s, "labels", p);
        return m && m.text !== void 0 && m.text !== null && (g = g.concat(/* @__PURE__ */ j.cloneElement(s, m))), g;
      }, []), d = this.getComponentProps(a, "data", "all"), f = [/* @__PURE__ */ j.cloneElement(a, d), ...u];
      return this.renderContainer(c, f);
    }
    renderData(o, a) {
      a === void 0 && (a = $Ke);
      const {
        dataComponent: s,
        labelComponent: c,
        groupComponent: l
      } = o, u = this.dataKeys.reduce((h, p, g) => {
        const m = this.getComponentProps(s, "data", g);
        return a(m.datum) && h.push(/* @__PURE__ */ j.cloneElement(s, m)), h;
      }, []), d = this.dataKeys.map((h, p) => {
        const g = this.getComponentProps(c, "labels", p);
        if (g.text !== void 0 && g.text !== null)
          return /* @__PURE__ */ j.cloneElement(c, g);
      }).filter(Boolean), f = [...u, ...d];
      return this.renderContainer(l, f);
    }
  }
  return n;
}
function RKe(e) {
  return (t) => {
    e.forEach((n) => {
      Rn(n) ? n(t) : n != null && (n.current = t);
    });
  };
}
var PKe = wl, OKe = Xa, MKe = "[object Date]";
function kKe(e) {
  return OKe(e) && PKe(e) == MKe;
}
var NKe = kKe, DKe = NKe, jKe = Ap, L9 = $x, F9 = L9 && L9.isDate, LKe = F9 ? jKe(F9) : DKe, FKe = LKe;
const tne = /* @__PURE__ */ vn(FKe);
var VKe = jf;
function BKe(e, t) {
  for (var n = -1, r = e.length, i = 0, o = []; ++n < r; ) {
    var a = e[n], s = t ? t(a) : a;
    if (!n || !VKe(s, c)) {
      var c = s;
      o[i++] = a === 0 ? 0 : a;
    }
  }
  return o;
}
var zKe = BKe, HKe = zKe;
function UKe(e) {
  return e && e.length ? HKe(e) : [];
}
var WKe = UKe;
const qKe = /* @__PURE__ */ vn(WKe);
function GKe(e) {
  return e === void 0;
}
var KKe = GKe;
const YKe = /* @__PURE__ */ vn(KKe);
function yu(e, t) {
  return e == null || t == null ? NaN : e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
}
function XKe(e, t) {
  return e == null || t == null ? NaN : t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
}
function T3(e) {
  let t, n, r;
  e.length !== 2 ? (t = yu, n = (s, c) => yu(e(s), c), r = (s, c) => e(s) - c) : (t = e === yu || e === XKe ? e : QKe, n = e, r = e);
  function i(s, c, l = 0, u = s.length) {
    if (l < u) {
      if (t(c, c) !== 0)
        return u;
      do {
        const d = l + u >>> 1;
        n(s[d], c) < 0 ? l = d + 1 : u = d;
      } while (l < u);
    }
    return l;
  }
  function o(s, c, l = 0, u = s.length) {
    if (l < u) {
      if (t(c, c) !== 0)
        return u;
      do {
        const d = l + u >>> 1;
        n(s[d], c) <= 0 ? l = d + 1 : u = d;
      } while (l < u);
    }
    return l;
  }
  function a(s, c, l = 0, u = s.length) {
    const d = i(s, c, l, u - 1);
    return d > l && r(s[d - 1], c) > -r(s[d], c) ? d - 1 : d;
  }
  return { left: i, center: a, right: o };
}
function QKe() {
  return 0;
}
function nne(e) {
  return e === null ? NaN : +e;
}
function* JKe(e, t) {
  if (t === void 0)
    for (let n of e)
      n != null && (n = +n) >= n && (yield n);
  else {
    let n = -1;
    for (let r of e)
      (r = t(r, ++n, e)) != null && (r = +r) >= r && (yield r);
  }
}
const ZKe = T3(yu), eYe = ZKe.right;
T3(nne).center;
const qy = eYe;
class V9 extends Map {
  constructor(t, n = rYe) {
    if (super(), Object.defineProperties(this, { _intern: { value: /* @__PURE__ */ new Map() }, _key: { value: n } }), t != null)
      for (const [r, i] of t)
        this.set(r, i);
  }
  get(t) {
    return super.get(B9(this, t));
  }
  has(t) {
    return super.has(B9(this, t));
  }
  set(t, n) {
    return super.set(tYe(this, t), n);
  }
  delete(t) {
    return super.delete(nYe(this, t));
  }
}
function B9({ _intern: e, _key: t }, n) {
  const r = t(n);
  return e.has(r) ? e.get(r) : n;
}
function tYe({ _intern: e, _key: t }, n) {
  const r = t(n);
  return e.has(r) ? e.get(r) : (e.set(r, n), n);
}
function nYe({ _intern: e, _key: t }, n) {
  const r = t(n);
  return e.has(r) && (n = e.get(n), e.delete(r)), n;
}
function rYe(e) {
  return e !== null && typeof e == "object" ? e.valueOf() : e;
}
function iYe(e = yu) {
  if (e === yu)
    return rne;
  if (typeof e != "function")
    throw new TypeError("compare is not a function");
  return (t, n) => {
    const r = e(t, n);
    return r || r === 0 ? r : (e(n, n) === 0) - (e(t, t) === 0);
  };
}
function rne(e, t) {
  return (e == null || !(e >= e)) - (t == null || !(t >= t)) || (e < t ? -1 : e > t ? 1 : 0);
}
const oYe = Math.sqrt(50), aYe = Math.sqrt(10), sYe = Math.sqrt(2);
function Tw(e, t, n) {
  const r = (t - e) / Math.max(0, n), i = Math.floor(Math.log10(r)), o = r / Math.pow(10, i), a = o >= oYe ? 10 : o >= aYe ? 5 : o >= sYe ? 2 : 1;
  let s, c, l;
  return i < 0 ? (l = Math.pow(10, -i) / a, s = Math.round(e * l), c = Math.round(t * l), s / l < e && ++s, c / l > t && --c, l = -l) : (l = Math.pow(10, i) * a, s = Math.round(e / l), c = Math.round(t / l), s * l < e && ++s, c * l > t && --c), c < s && 0.5 <= n && n < 2 ? Tw(e, t, n * 2) : [s, c, l];
}
function NR(e, t, n) {
  if (t = +t, e = +e, n = +n, !(n > 0))
    return [];
  if (e === t)
    return [e];
  const r = t < e, [i, o, a] = r ? Tw(t, e, n) : Tw(e, t, n);
  if (!(o >= i))
    return [];
  const s = o - i + 1, c = new Array(s);
  if (r)
    if (a < 0)
      for (let l = 0; l < s; ++l)
        c[l] = (o - l) / -a;
    else
      for (let l = 0; l < s; ++l)
        c[l] = (o - l) * a;
  else if (a < 0)
    for (let l = 0; l < s; ++l)
      c[l] = (i + l) / -a;
  else
    for (let l = 0; l < s; ++l)
      c[l] = (i + l) * a;
  return c;
}
function DR(e, t, n) {
  return t = +t, e = +e, n = +n, Tw(e, t, n)[2];
}
function jR(e, t, n) {
  t = +t, e = +e, n = +n;
  const r = t < e, i = r ? DR(t, e, n) : DR(e, t, n);
  return (r ? -1 : 1) * (i < 0 ? 1 / -i : i);
}
function z9(e, t) {
  let n;
  if (t === void 0)
    for (const r of e)
      r != null && (n < r || n === void 0 && r >= r) && (n = r);
  else {
    let r = -1;
    for (let i of e)
      (i = t(i, ++r, e)) != null && (n < i || n === void 0 && i >= i) && (n = i);
  }
  return n;
}
function H9(e, t) {
  let n;
  if (t === void 0)
    for (const r of e)
      r != null && (n > r || n === void 0 && r >= r) && (n = r);
  else {
    let r = -1;
    for (let i of e)
      (i = t(i, ++r, e)) != null && (n > i || n === void 0 && i >= i) && (n = i);
  }
  return n;
}
function ine(e, t, n = 0, r = 1 / 0, i) {
  if (t = Math.floor(t), n = Math.floor(Math.max(0, n)), r = Math.floor(Math.min(e.length - 1, r)), !(n <= t && t <= r))
    return e;
  for (i = i === void 0 ? rne : iYe(i); r > n; ) {
    if (r - n > 600) {
      const c = r - n + 1, l = t - n + 1, u = Math.log(c), d = 0.5 * Math.exp(2 * u / 3), f = 0.5 * Math.sqrt(u * d * (c - d) / c) * (l - c / 2 < 0 ? -1 : 1), h = Math.max(n, Math.floor(t - l * d / c + f)), p = Math.min(r, Math.floor(t + (c - l) * d / c + f));
      ine(e, t, h, p, i);
    }
    const o = e[t];
    let a = n, s = r;
    for (Dm(e, n, t), i(e[r], o) > 0 && Dm(e, n, r); a < s; ) {
      for (Dm(e, a, s), ++a, --s; i(e[a], o) < 0; )
        ++a;
      for (; i(e[s], o) > 0; )
        --s;
    }
    i(e[n], o) === 0 ? Dm(e, n, s) : (++s, Dm(e, s, r)), s <= t && (n = s + 1), t <= s && (r = s - 1);
  }
  return e;
}
function Dm(e, t, n) {
  const r = e[t];
  e[t] = e[n], e[n] = r;
}
function cYe(e, t, n) {
  if (e = Float64Array.from(JKe(e, n)), !(!(r = e.length) || isNaN(t = +t))) {
    if (t <= 0 || r < 2)
      return H9(e);
    if (t >= 1)
      return z9(e);
    var r, i = (r - 1) * t, o = Math.floor(i), a = z9(ine(e, o).subarray(0, o + 1)), s = H9(e.subarray(o + 1));
    return a + (s - a) * (i - o);
  }
}
function lYe(e, t, n = nne) {
  if (!(!(r = e.length) || isNaN(t = +t))) {
    if (t <= 0 || r < 2)
      return +n(e[0], 0, e);
    if (t >= 1)
      return +n(e[r - 1], r - 1, e);
    var r, i = (r - 1) * t, o = Math.floor(i), a = +n(e[o], o, e), s = +n(e[o + 1], o + 1, e);
    return a + (s - a) * (i - o);
  }
}
function uYe(e, t, n) {
  e = +e, t = +t, n = (i = arguments.length) < 2 ? (t = e, e = 0, 1) : i < 3 ? 1 : +n;
  for (var r = -1, i = Math.max(0, Math.ceil((t - e) / n)) | 0, o = new Array(i); ++r < i; )
    o[r] = e + r * n;
  return o;
}
function ts(e, t) {
  switch (arguments.length) {
    case 0:
      break;
    case 1:
      this.range(e);
      break;
    default:
      this.range(t).domain(e);
      break;
  }
  return this;
}
function Tl(e, t) {
  switch (arguments.length) {
    case 0:
      break;
    case 1: {
      typeof e == "function" ? this.interpolator(e) : this.range(e);
      break;
    }
    default: {
      this.domain(e), typeof t == "function" ? this.interpolator(t) : this.range(t);
      break;
    }
  }
  return this;
}
const LR = Symbol("implicit");
function tl() {
  var e = new V9(), t = [], n = [], r = LR;
  function i(o) {
    let a = e.get(o);
    if (a === void 0) {
      if (r !== LR)
        return r;
      e.set(o, a = t.push(o) - 1);
    }
    return n[a % n.length];
  }
  return i.domain = function(o) {
    if (!arguments.length)
      return t.slice();
    t = [], e = new V9();
    for (const a of o)
      e.has(a) || e.set(a, t.push(a) - 1);
    return i;
  }, i.range = function(o) {
    return arguments.length ? (n = Array.from(o), i) : n.slice();
  }, i.unknown = function(o) {
    return arguments.length ? (r = o, i) : r;
  }, i.copy = function() {
    return tl(t, n).unknown(r);
  }, ts.apply(i, arguments), i;
}
function vC() {
  var e = tl().unknown(void 0), t = e.domain, n = e.range, r = 0, i = 1, o, a, s = !1, c = 0, l = 0, u = 0.5;
  delete e.unknown;
  function d() {
    var f = t().length, h = i < r, p = h ? i : r, g = h ? r : i;
    o = (g - p) / Math.max(1, f - c + l * 2), s && (o = Math.floor(o)), p += (g - p - o * (f - c)) * u, a = o * (1 - c), s && (p = Math.round(p), a = Math.round(a));
    var m = uYe(f).map(function(v) {
      return p + o * v;
    });
    return n(h ? m.reverse() : m);
  }
  return e.domain = function(f) {
    return arguments.length ? (t(f), d()) : t();
  }, e.range = function(f) {
    return arguments.length ? ([r, i] = f, r = +r, i = +i, d()) : [r, i];
  }, e.rangeRound = function(f) {
    return [r, i] = f, r = +r, i = +i, s = !0, d();
  }, e.bandwidth = function() {
    return a;
  }, e.step = function() {
    return o;
  }, e.round = function(f) {
    return arguments.length ? (s = !!f, d()) : s;
  }, e.padding = function(f) {
    return arguments.length ? (c = Math.min(1, l = +f), d()) : c;
  }, e.paddingInner = function(f) {
    return arguments.length ? (c = Math.min(1, f), d()) : c;
  }, e.paddingOuter = function(f) {
    return arguments.length ? (l = +f, d()) : l;
  }, e.align = function(f) {
    return arguments.length ? (u = Math.max(0, Math.min(1, f)), d()) : u;
  }, e.copy = function() {
    return vC(t(), [r, i]).round(s).paddingInner(c).paddingOuter(l).align(u);
  }, ts.apply(d(), arguments);
}
function one(e) {
  var t = e.copy;
  return e.padding = e.paddingOuter, delete e.paddingInner, delete e.paddingOuter, e.copy = function() {
    return one(t());
  }, e;
}
function ane() {
  return one(vC.apply(null, arguments).paddingInner(1));
}
function dYe(e) {
  return function() {
    return e;
  };
}
function Iw(e) {
  return +e;
}
var U9 = [0, 1];
function Oo(e) {
  return e;
}
function FR(e, t) {
  return (t -= e = +e) ? function(n) {
    return (n - e) / t;
  } : dYe(isNaN(t) ? NaN : 0.5);
}
function fYe(e, t) {
  var n;
  return e > t && (n = e, e = t, t = n), function(r) {
    return Math.max(e, Math.min(t, r));
  };
}
function hYe(e, t, n) {
  var r = e[0], i = e[1], o = t[0], a = t[1];
  return i < r ? (r = FR(i, r), o = n(a, o)) : (r = FR(r, i), o = n(o, a)), function(s) {
    return o(r(s));
  };
}
function gYe(e, t, n) {
  var r = Math.min(e.length, t.length) - 1, i = new Array(r), o = new Array(r), a = -1;
  for (e[r] < e[0] && (e = e.slice().reverse(), t = t.slice().reverse()); ++a < r; )
    i[a] = FR(e[a], e[a + 1]), o[a] = n(t[a], t[a + 1]);
  return function(s) {
    var c = qy(e, s, 1, r) - 1;
    return o[c](i[c](s));
  };
}
function Gy(e, t) {
  return t.domain(e.domain()).range(e.range()).interpolate(e.interpolate()).clamp(e.clamp()).unknown(e.unknown());
}
function yC() {
  var e = U9, t = U9, n = Rc, r, i, o, a = Oo, s, c, l;
  function u() {
    var f = Math.min(e.length, t.length);
    return a !== Oo && (a = fYe(e[0], e[f - 1])), s = f > 2 ? gYe : hYe, c = l = null, d;
  }
  function d(f) {
    return f == null || isNaN(f = +f) ? o : (c || (c = s(e.map(r), t, n)))(r(a(f)));
  }
  return d.invert = function(f) {
    return a(i((l || (l = s(t, e.map(r), mw)))(f)));
  }, d.domain = function(f) {
    return arguments.length ? (e = Array.from(f, Iw), u()) : e.slice();
  }, d.range = function(f) {
    return arguments.length ? (t = Array.from(f), u()) : t.slice();
  }, d.rangeRound = function(f) {
    return t = Array.from(f), n = b3, u();
  }, d.clamp = function(f) {
    return arguments.length ? (a = f ? !0 : Oo, u()) : a !== Oo;
  }, d.interpolate = function(f) {
    return arguments.length ? (n = f, u()) : n;
  }, d.unknown = function(f) {
    return arguments.length ? (o = f, d) : o;
  }, function(f, h) {
    return r = f, i = h, u();
  };
}
function I3() {
  return yC()(Oo, Oo);
}
function pYe(e) {
  return Math.abs(e = Math.round(e)) >= 1e21 ? e.toLocaleString("en").replace(/,/g, "") : e.toString(10);
}
function $w(e, t) {
  if ((n = (e = t ? e.toExponential(t - 1) : e.toExponential()).indexOf("e")) < 0)
    return null;
  var n, r = e.slice(0, n);
  return [
    r.length > 1 ? r[0] + r.slice(2) : r,
    +e.slice(n + 1)
  ];
}
function ap(e) {
  return e = $w(Math.abs(e)), e ? e[1] : NaN;
}
function mYe(e, t) {
  return function(n, r) {
    for (var i = n.length, o = [], a = 0, s = e[0], c = 0; i > 0 && s > 0 && (c + s + 1 > r && (s = Math.max(1, r - c)), o.push(n.substring(i -= s, i + s)), !((c += s + 1) > r)); )
      s = e[a = (a + 1) % e.length];
    return o.reverse().join(t);
  };
}
function vYe(e) {
  return function(t) {
    return t.replace(/[0-9]/g, function(n) {
      return e[+n];
    });
  };
}
var yYe = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function Vv(e) {
  if (!(t = yYe.exec(e)))
    throw new Error("invalid format: " + e);
  var t;
  return new $3({
    fill: t[1],
    align: t[2],
    sign: t[3],
    symbol: t[4],
    zero: t[5],
    width: t[6],
    comma: t[7],
    precision: t[8] && t[8].slice(1),
    trim: t[9],
    type: t[10]
  });
}
Vv.prototype = $3.prototype;
function $3(e) {
  this.fill = e.fill === void 0 ? " " : e.fill + "", this.align = e.align === void 0 ? ">" : e.align + "", this.sign = e.sign === void 0 ? "-" : e.sign + "", this.symbol = e.symbol === void 0 ? "" : e.symbol + "", this.zero = !!e.zero, this.width = e.width === void 0 ? void 0 : +e.width, this.comma = !!e.comma, this.precision = e.precision === void 0 ? void 0 : +e.precision, this.trim = !!e.trim, this.type = e.type === void 0 ? "" : e.type + "";
}
$3.prototype.toString = function() {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};
function bYe(e) {
  e:
    for (var t = e.length, n = 1, r = -1, i; n < t; ++n)
      switch (e[n]) {
        case ".":
          r = i = n;
          break;
        case "0":
          r === 0 && (r = n), i = n;
          break;
        default:
          if (!+e[n])
            break e;
          r > 0 && (r = 0);
          break;
      }
  return r > 0 ? e.slice(0, r) + e.slice(i + 1) : e;
}
var sne;
function _Ye(e, t) {
  var n = $w(e, t);
  if (!n)
    return e + "";
  var r = n[0], i = n[1], o = i - (sne = Math.max(-8, Math.min(8, Math.floor(i / 3))) * 3) + 1, a = r.length;
  return o === a ? r : o > a ? r + new Array(o - a + 1).join("0") : o > 0 ? r.slice(0, o) + "." + r.slice(o) : "0." + new Array(1 - o).join("0") + $w(e, Math.max(0, t + o - 1))[0];
}
function W9(e, t) {
  var n = $w(e, t);
  if (!n)
    return e + "";
  var r = n[0], i = n[1];
  return i < 0 ? "0." + new Array(-i).join("0") + r : r.length > i + 1 ? r.slice(0, i + 1) + "." + r.slice(i + 1) : r + new Array(i - r.length + 2).join("0");
}
const q9 = {
  "%": function(e, t) {
    return (e * 100).toFixed(t);
  },
  b: function(e) {
    return Math.round(e).toString(2);
  },
  c: function(e) {
    return e + "";
  },
  d: pYe,
  e: function(e, t) {
    return e.toExponential(t);
  },
  f: function(e, t) {
    return e.toFixed(t);
  },
  g: function(e, t) {
    return e.toPrecision(t);
  },
  o: function(e) {
    return Math.round(e).toString(8);
  },
  p: function(e, t) {
    return W9(e * 100, t);
  },
  r: W9,
  s: _Ye,
  X: function(e) {
    return Math.round(e).toString(16).toUpperCase();
  },
  x: function(e) {
    return Math.round(e).toString(16);
  }
};
function G9(e) {
  return e;
}
var K9 = Array.prototype.map, Y9 = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
function SYe(e) {
  var t = e.grouping === void 0 || e.thousands === void 0 ? G9 : mYe(K9.call(e.grouping, Number), e.thousands + ""), n = e.currency === void 0 ? "" : e.currency[0] + "", r = e.currency === void 0 ? "" : e.currency[1] + "", i = e.decimal === void 0 ? "." : e.decimal + "", o = e.numerals === void 0 ? G9 : vYe(K9.call(e.numerals, String)), a = e.percent === void 0 ? "%" : e.percent + "", s = e.minus === void 0 ? "-" : e.minus + "", c = e.nan === void 0 ? "NaN" : e.nan + "";
  function l(d) {
    d = Vv(d);
    var f = d.fill, h = d.align, p = d.sign, g = d.symbol, m = d.zero, v = d.width, y = d.comma, _ = d.precision, b = d.trim, w = d.type;
    w === "n" ? (y = !0, w = "g") : q9[w] || (_ === void 0 && (_ = 12), b = !0, w = "g"), (m || f === "0" && h === "=") && (m = !0, f = "0", h = "=");
    var C = g === "$" ? n : g === "#" && /[boxX]/.test(w) ? "0" + w.toLowerCase() : "", x = g === "$" ? r : /[%p]/.test(w) ? a : "", T = q9[w], E = /[defgprs%]/.test(w);
    _ = _ === void 0 ? 6 : /[gprs]/.test(w) ? Math.max(1, Math.min(21, _)) : Math.max(0, Math.min(20, _));
    function R(I) {
      var O = C, P = x, k, L, N;
      if (w === "c")
        P = T(I) + P, I = "";
      else {
        I = +I;
        var D = I < 0 || 1 / I < 0;
        if (I = isNaN(I) ? c : T(Math.abs(I), _), b && (I = bYe(I)), D && +I == 0 && p !== "+" && (D = !1), O = (D ? p === "(" ? p : s : p === "-" || p === "(" ? "" : p) + O, P = (w === "s" ? Y9[8 + sne / 3] : "") + P + (D && p === "(" ? ")" : ""), E) {
          for (k = -1, L = I.length; ++k < L; )
            if (N = I.charCodeAt(k), 48 > N || N > 57) {
              P = (N === 46 ? i + I.slice(k + 1) : I.slice(k)) + P, I = I.slice(0, k);
              break;
            }
        }
      }
      y && !m && (I = t(I, 1 / 0));
      var z = O.length + I.length + P.length, V = z < v ? new Array(v - z + 1).join(f) : "";
      switch (y && m && (I = t(V + I, V.length ? v - P.length : 1 / 0), V = ""), h) {
        case "<":
          I = O + I + P + V;
          break;
        case "=":
          I = O + V + I + P;
          break;
        case "^":
          I = V.slice(0, z = V.length >> 1) + O + I + P + V.slice(z);
          break;
        default:
          I = V + O + I + P;
          break;
      }
      return o(I);
    }
    return R.toString = function() {
      return d + "";
    }, R;
  }
  function u(d, f) {
    var h = l((d = Vv(d), d.type = "f", d)), p = Math.max(-8, Math.min(8, Math.floor(ap(f) / 3))) * 3, g = Math.pow(10, -p), m = Y9[8 + p / 3];
    return function(v) {
      return h(g * v) + m;
    };
  }
  return {
    format: l,
    formatPrefix: u
  };
}
var x1, Ky, cne;
wYe({
  decimal: ".",
  thousands: ",",
  grouping: [3],
  currency: ["$", ""],
  minus: "-"
});
function wYe(e) {
  return x1 = SYe(e), Ky = x1.format, cne = x1.formatPrefix, x1;
}
function xYe(e) {
  return Math.max(0, -ap(Math.abs(e)));
}
function EYe(e, t) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(ap(t) / 3))) * 3 - ap(Math.abs(e)));
}
function CYe(e, t) {
  return e = Math.abs(e), t = Math.abs(t) - e, Math.max(0, ap(t) - ap(e)) + 1;
}
function lne(e, t, n, r) {
  var i = jR(e, t, n), o;
  switch (r = Vv(r ?? ",f"), r.type) {
    case "s": {
      var a = Math.max(Math.abs(e), Math.abs(t));
      return r.precision == null && !isNaN(o = EYe(i, a)) && (r.precision = o), cne(r, a);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      r.precision == null && !isNaN(o = CYe(i, Math.max(Math.abs(e), Math.abs(t)))) && (r.precision = o - (r.type === "e"));
      break;
    }
    case "f":
    case "%": {
      r.precision == null && !isNaN(o = xYe(i)) && (r.precision = o - (r.type === "%") * 2);
      break;
    }
  }
  return Ky(r);
}
function sd(e) {
  var t = e.domain;
  return e.ticks = function(n) {
    var r = t();
    return NR(r[0], r[r.length - 1], n ?? 10);
  }, e.tickFormat = function(n, r) {
    var i = t();
    return lne(i[0], i[i.length - 1], n ?? 10, r);
  }, e.nice = function(n) {
    n == null && (n = 10);
    var r = t(), i = 0, o = r.length - 1, a = r[i], s = r[o], c, l, u = 10;
    for (s < a && (l = a, a = s, s = l, l = i, i = o, o = l); u-- > 0; ) {
      if (l = DR(a, s, n), l === c)
        return r[i] = a, r[o] = s, t(r);
      if (l > 0)
        a = Math.floor(a / l) * l, s = Math.ceil(s / l) * l;
      else if (l < 0)
        a = Math.ceil(a * l) / l, s = Math.floor(s * l) / l;
      else
        break;
      c = l;
    }
    return e;
  }, e;
}
function Yy() {
  var e = I3();
  return e.copy = function() {
    return Gy(e, Yy());
  }, ts.apply(e, arguments), sd(e);
}
function une(e) {
  var t;
  function n(r) {
    return r == null || isNaN(r = +r) ? t : r;
  }
  return n.invert = n, n.domain = n.range = function(r) {
    return arguments.length ? (e = Array.from(r, Iw), n) : e.slice();
  }, n.unknown = function(r) {
    return arguments.length ? (t = r, n) : t;
  }, n.copy = function() {
    return une(e).unknown(t);
  }, e = arguments.length ? Array.from(e, Iw) : [0, 1], sd(n);
}
function dne(e, t) {
  e = e.slice();
  var n = 0, r = e.length - 1, i = e[n], o = e[r], a;
  return o < i && (a = n, n = r, r = a, a = i, i = o, o = a), e[n] = t.floor(i), e[r] = t.ceil(o), e;
}
function X9(e) {
  return Math.log(e);
}
function Q9(e) {
  return Math.exp(e);
}
function TYe(e) {
  return -Math.log(-e);
}
function IYe(e) {
  return -Math.exp(-e);
}
function $Ye(e) {
  return isFinite(e) ? +("1e" + e) : e < 0 ? 0 : e;
}
function AYe(e) {
  return e === 10 ? $Ye : e === Math.E ? Math.exp : (t) => Math.pow(e, t);
}
function RYe(e) {
  return e === Math.E ? Math.log : e === 10 && Math.log10 || e === 2 && Math.log2 || (e = Math.log(e), (t) => Math.log(t) / e);
}
function J9(e) {
  return (t, n) => -e(-t, n);
}
function A3(e) {
  const t = e(X9, Q9), n = t.domain;
  let r = 10, i, o;
  function a() {
    return i = RYe(r), o = AYe(r), n()[0] < 0 ? (i = J9(i), o = J9(o), e(TYe, IYe)) : e(X9, Q9), t;
  }
  return t.base = function(s) {
    return arguments.length ? (r = +s, a()) : r;
  }, t.domain = function(s) {
    return arguments.length ? (n(s), a()) : n();
  }, t.ticks = (s) => {
    const c = n();
    let l = c[0], u = c[c.length - 1];
    const d = u < l;
    d && ([l, u] = [u, l]);
    let f = i(l), h = i(u), p, g;
    const m = s == null ? 10 : +s;
    let v = [];
    if (!(r % 1) && h - f < m) {
      if (f = Math.floor(f), h = Math.ceil(h), l > 0) {
        for (; f <= h; ++f)
          for (p = 1; p < r; ++p)
            if (g = f < 0 ? p / o(-f) : p * o(f), !(g < l)) {
              if (g > u)
                break;
              v.push(g);
            }
      } else
        for (; f <= h; ++f)
          for (p = r - 1; p >= 1; --p)
            if (g = f > 0 ? p / o(-f) : p * o(f), !(g < l)) {
              if (g > u)
                break;
              v.push(g);
            }
      v.length * 2 < m && (v = NR(l, u, m));
    } else
      v = NR(f, h, Math.min(h - f, m)).map(o);
    return d ? v.reverse() : v;
  }, t.tickFormat = (s, c) => {
    if (s == null && (s = 10), c == null && (c = r === 10 ? "s" : ","), typeof c != "function" && (!(r % 1) && (c = Vv(c)).precision == null && (c.trim = !0), c = Ky(c)), s === 1 / 0)
      return c;
    const l = Math.max(1, r * s / t.ticks().length);
    return (u) => {
      let d = u / o(Math.round(i(u)));
      return d * r < r - 0.5 && (d *= r), d <= l ? c(u) : "";
    };
  }, t.nice = () => n(dne(n(), {
    floor: (s) => o(Math.floor(i(s))),
    ceil: (s) => o(Math.ceil(i(s)))
  })), t;
}
function R3() {
  const e = A3(yC()).domain([1, 10]);
  return e.copy = () => Gy(e, R3()).base(e.base()), ts.apply(e, arguments), e;
}
function Z9(e) {
  return function(t) {
    return Math.sign(t) * Math.log1p(Math.abs(t / e));
  };
}
function eV(e) {
  return function(t) {
    return Math.sign(t) * Math.expm1(Math.abs(t)) * e;
  };
}
function P3(e) {
  var t = 1, n = e(Z9(t), eV(t));
  return n.constant = function(r) {
    return arguments.length ? e(Z9(t = +r), eV(t)) : t;
  }, sd(n);
}
function O3() {
  var e = P3(yC());
  return e.copy = function() {
    return Gy(e, O3()).constant(e.constant());
  }, ts.apply(e, arguments);
}
function tV(e) {
  return function(t) {
    return t < 0 ? -Math.pow(-t, e) : Math.pow(t, e);
  };
}
function PYe(e) {
  return e < 0 ? -Math.sqrt(-e) : Math.sqrt(e);
}
function OYe(e) {
  return e < 0 ? -e * e : e * e;
}
function M3(e) {
  var t = e(Oo, Oo), n = 1;
  function r() {
    return n === 1 ? e(Oo, Oo) : n === 0.5 ? e(PYe, OYe) : e(tV(n), tV(1 / n));
  }
  return t.exponent = function(i) {
    return arguments.length ? (n = +i, r()) : n;
  }, sd(t);
}
function k3() {
  var e = M3(yC());
  return e.copy = function() {
    return Gy(e, k3()).exponent(e.exponent());
  }, ts.apply(e, arguments), e;
}
function MYe() {
  return k3.apply(null, arguments).exponent(0.5);
}
function nV(e) {
  return Math.sign(e) * e * e;
}
function kYe(e) {
  return Math.sign(e) * Math.sqrt(Math.abs(e));
}
function fne() {
  var e = I3(), t = [0, 1], n = !1, r;
  function i(o) {
    var a = kYe(e(o));
    return isNaN(a) ? r : n ? Math.round(a) : a;
  }
  return i.invert = function(o) {
    return e.invert(nV(o));
  }, i.domain = function(o) {
    return arguments.length ? (e.domain(o), i) : e.domain();
  }, i.range = function(o) {
    return arguments.length ? (e.range((t = Array.from(o, Iw)).map(nV)), i) : t.slice();
  }, i.rangeRound = function(o) {
    return i.range(o).round(!0);
  }, i.round = function(o) {
    return arguments.length ? (n = !!o, i) : n;
  }, i.clamp = function(o) {
    return arguments.length ? (e.clamp(o), i) : e.clamp();
  }, i.unknown = function(o) {
    return arguments.length ? (r = o, i) : r;
  }, i.copy = function() {
    return fne(e.domain(), t).round(n).clamp(e.clamp()).unknown(r);
  }, ts.apply(i, arguments), sd(i);
}
function hne() {
  var e = [], t = [], n = [], r;
  function i() {
    var a = 0, s = Math.max(1, t.length);
    for (n = new Array(s - 1); ++a < s; )
      n[a - 1] = lYe(e, a / s);
    return o;
  }
  function o(a) {
    return a == null || isNaN(a = +a) ? r : t[qy(n, a)];
  }
  return o.invertExtent = function(a) {
    var s = t.indexOf(a);
    return s < 0 ? [NaN, NaN] : [
      s > 0 ? n[s - 1] : e[0],
      s < n.length ? n[s] : e[e.length - 1]
    ];
  }, o.domain = function(a) {
    if (!arguments.length)
      return e.slice();
    e = [];
    for (let s of a)
      s != null && !isNaN(s = +s) && e.push(s);
    return e.sort(yu), i();
  }, o.range = function(a) {
    return arguments.length ? (t = Array.from(a), i()) : t.slice();
  }, o.unknown = function(a) {
    return arguments.length ? (r = a, o) : r;
  }, o.quantiles = function() {
    return n.slice();
  }, o.copy = function() {
    return hne().domain(e).range(t).unknown(r);
  }, ts.apply(o, arguments);
}
function gne() {
  var e = 0, t = 1, n = 1, r = [0.5], i = [0, 1], o;
  function a(c) {
    return c != null && c <= c ? i[qy(r, c, 0, n)] : o;
  }
  function s() {
    var c = -1;
    for (r = new Array(n); ++c < n; )
      r[c] = ((c + 1) * t - (c - n) * e) / (n + 1);
    return a;
  }
  return a.domain = function(c) {
    return arguments.length ? ([e, t] = c, e = +e, t = +t, s()) : [e, t];
  }, a.range = function(c) {
    return arguments.length ? (n = (i = Array.from(c)).length - 1, s()) : i.slice();
  }, a.invertExtent = function(c) {
    var l = i.indexOf(c);
    return l < 0 ? [NaN, NaN] : l < 1 ? [e, r[0]] : l >= n ? [r[n - 1], t] : [r[l - 1], r[l]];
  }, a.unknown = function(c) {
    return arguments.length && (o = c), a;
  }, a.thresholds = function() {
    return r.slice();
  }, a.copy = function() {
    return gne().domain([e, t]).range(i).unknown(o);
  }, ts.apply(sd(a), arguments);
}
function pne() {
  var e = [0.5], t = [0, 1], n, r = 1;
  function i(o) {
    return o != null && o <= o ? t[qy(e, o, 0, r)] : n;
  }
  return i.domain = function(o) {
    return arguments.length ? (e = Array.from(o), r = Math.min(e.length, t.length - 1), i) : e.slice();
  }, i.range = function(o) {
    return arguments.length ? (t = Array.from(o), r = Math.min(e.length, t.length - 1), i) : t.slice();
  }, i.invertExtent = function(o) {
    var a = t.indexOf(o);
    return [e[a - 1], e[a]];
  }, i.unknown = function(o) {
    return arguments.length ? (n = o, i) : n;
  }, i.copy = function() {
    return pne().domain(e).range(t).unknown(n);
  }, ts.apply(i, arguments);
}
const qT = /* @__PURE__ */ new Date(), GT = /* @__PURE__ */ new Date();
function Ci(e, t, n, r) {
  function i(o) {
    return e(o = arguments.length === 0 ? /* @__PURE__ */ new Date() : /* @__PURE__ */ new Date(+o)), o;
  }
  return i.floor = (o) => (e(o = /* @__PURE__ */ new Date(+o)), o), i.ceil = (o) => (e(o = new Date(o - 1)), t(o, 1), e(o), o), i.round = (o) => {
    const a = i(o), s = i.ceil(o);
    return o - a < s - o ? a : s;
  }, i.offset = (o, a) => (t(o = /* @__PURE__ */ new Date(+o), a == null ? 1 : Math.floor(a)), o), i.range = (o, a, s) => {
    const c = [];
    if (o = i.ceil(o), s = s == null ? 1 : Math.floor(s), !(o < a) || !(s > 0))
      return c;
    let l;
    do
      c.push(l = /* @__PURE__ */ new Date(+o)), t(o, s), e(o);
    while (l < o && o < a);
    return c;
  }, i.filter = (o) => Ci((a) => {
    if (a >= a)
      for (; e(a), !o(a); )
        a.setTime(a - 1);
  }, (a, s) => {
    if (a >= a)
      if (s < 0)
        for (; ++s <= 0; )
          for (; t(a, -1), !o(a); )
            ;
      else
        for (; --s >= 0; )
          for (; t(a, 1), !o(a); )
            ;
  }), n && (i.count = (o, a) => (qT.setTime(+o), GT.setTime(+a), e(qT), e(GT), Math.floor(n(qT, GT))), i.every = (o) => (o = Math.floor(o), !isFinite(o) || !(o > 0) ? null : o > 1 ? i.filter(r ? (a) => r(a) % o === 0 : (a) => i.count(0, a) % o === 0) : i)), i;
}
const Aw = Ci(() => {
}, (e, t) => {
  e.setTime(+e + t);
}, (e, t) => t - e);
Aw.every = (e) => (e = Math.floor(e), !isFinite(e) || !(e > 0) ? null : e > 1 ? Ci((t) => {
  t.setTime(Math.floor(t / e) * e);
}, (t, n) => {
  t.setTime(+t + n * e);
}, (t, n) => (n - t) / e) : Aw);
Aw.range;
const nl = 1e3, za = nl * 60, rl = za * 60, _l = rl * 24, N3 = _l * 7, rV = _l * 30, KT = _l * 365, Bd = Ci((e) => {
  e.setTime(e - e.getMilliseconds());
}, (e, t) => {
  e.setTime(+e + t * nl);
}, (e, t) => (t - e) / nl, (e) => e.getUTCSeconds());
Bd.range;
const D3 = Ci((e) => {
  e.setTime(e - e.getMilliseconds() - e.getSeconds() * nl);
}, (e, t) => {
  e.setTime(+e + t * za);
}, (e, t) => (t - e) / za, (e) => e.getMinutes());
D3.range;
const j3 = Ci((e) => {
  e.setUTCSeconds(0, 0);
}, (e, t) => {
  e.setTime(+e + t * za);
}, (e, t) => (t - e) / za, (e) => e.getUTCMinutes());
j3.range;
const L3 = Ci((e) => {
  e.setTime(e - e.getMilliseconds() - e.getSeconds() * nl - e.getMinutes() * za);
}, (e, t) => {
  e.setTime(+e + t * rl);
}, (e, t) => (t - e) / rl, (e) => e.getHours());
L3.range;
const F3 = Ci((e) => {
  e.setUTCMinutes(0, 0, 0);
}, (e, t) => {
  e.setTime(+e + t * rl);
}, (e, t) => (t - e) / rl, (e) => e.getUTCHours());
F3.range;
const V3 = Ci(
  (e) => e.setHours(0, 0, 0, 0),
  (e, t) => e.setDate(e.getDate() + t),
  (e, t) => (t - e - (t.getTimezoneOffset() - e.getTimezoneOffset()) * za) / _l,
  (e) => e.getDate() - 1
);
V3.range;
const mne = Ci((e) => {
  e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCDate(e.getUTCDate() + t);
}, (e, t) => (t - e) / _l, (e) => e.getUTCDate() - 1);
mne.range;
const vne = Ci((e) => {
  e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCDate(e.getUTCDate() + t);
}, (e, t) => (t - e) / _l, (e) => Math.floor(e / _l));
vne.range;
function eh(e) {
  return Ci((t) => {
    t.setDate(t.getDate() - (t.getDay() + 7 - e) % 7), t.setHours(0, 0, 0, 0);
  }, (t, n) => {
    t.setDate(t.getDate() + n * 7);
  }, (t, n) => (n - t - (n.getTimezoneOffset() - t.getTimezoneOffset()) * za) / N3);
}
const B3 = eh(0), NYe = eh(1), DYe = eh(2), jYe = eh(3), LYe = eh(4), FYe = eh(5), VYe = eh(6);
B3.range;
NYe.range;
DYe.range;
jYe.range;
LYe.range;
FYe.range;
VYe.range;
function th(e) {
  return Ci((t) => {
    t.setUTCDate(t.getUTCDate() - (t.getUTCDay() + 7 - e) % 7), t.setUTCHours(0, 0, 0, 0);
  }, (t, n) => {
    t.setUTCDate(t.getUTCDate() + n * 7);
  }, (t, n) => (n - t) / N3);
}
const z3 = th(0), BYe = th(1), zYe = th(2), HYe = th(3), UYe = th(4), WYe = th(5), qYe = th(6);
z3.range;
BYe.range;
zYe.range;
HYe.range;
UYe.range;
WYe.range;
qYe.range;
const H3 = Ci((e) => {
  e.setDate(1), e.setHours(0, 0, 0, 0);
}, (e, t) => {
  e.setMonth(e.getMonth() + t);
}, (e, t) => t.getMonth() - e.getMonth() + (t.getFullYear() - e.getFullYear()) * 12, (e) => e.getMonth());
H3.range;
const U3 = Ci((e) => {
  e.setUTCDate(1), e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCMonth(e.getUTCMonth() + t);
}, (e, t) => t.getUTCMonth() - e.getUTCMonth() + (t.getUTCFullYear() - e.getUTCFullYear()) * 12, (e) => e.getUTCMonth());
U3.range;
const bC = Ci((e) => {
  e.setMonth(0, 1), e.setHours(0, 0, 0, 0);
}, (e, t) => {
  e.setFullYear(e.getFullYear() + t);
}, (e, t) => t.getFullYear() - e.getFullYear(), (e) => e.getFullYear());
bC.every = (e) => !isFinite(e = Math.floor(e)) || !(e > 0) ? null : Ci((t) => {
  t.setFullYear(Math.floor(t.getFullYear() / e) * e), t.setMonth(0, 1), t.setHours(0, 0, 0, 0);
}, (t, n) => {
  t.setFullYear(t.getFullYear() + n * e);
});
bC.range;
const _C = Ci((e) => {
  e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCFullYear(e.getUTCFullYear() + t);
}, (e, t) => t.getUTCFullYear() - e.getUTCFullYear(), (e) => e.getUTCFullYear());
_C.every = (e) => !isFinite(e = Math.floor(e)) || !(e > 0) ? null : Ci((t) => {
  t.setUTCFullYear(Math.floor(t.getUTCFullYear() / e) * e), t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
}, (t, n) => {
  t.setUTCFullYear(t.getUTCFullYear() + n * e);
});
_C.range;
function yne(e, t, n, r, i, o) {
  const a = [
    [Bd, 1, nl],
    [Bd, 5, 5 * nl],
    [Bd, 15, 15 * nl],
    [Bd, 30, 30 * nl],
    [o, 1, za],
    [o, 5, 5 * za],
    [o, 15, 15 * za],
    [o, 30, 30 * za],
    [i, 1, rl],
    [i, 3, 3 * rl],
    [i, 6, 6 * rl],
    [i, 12, 12 * rl],
    [r, 1, _l],
    [r, 2, 2 * _l],
    [n, 1, N3],
    [t, 1, rV],
    [t, 3, 3 * rV],
    [e, 1, KT]
  ];
  function s(l, u, d) {
    const f = u < l;
    f && ([l, u] = [u, l]);
    const h = d && typeof d.range == "function" ? d : c(l, u, d), p = h ? h.range(l, +u + 1) : [];
    return f ? p.reverse() : p;
  }
  function c(l, u, d) {
    const f = Math.abs(u - l) / d, h = T3(([, , m]) => m).right(a, f);
    if (h === a.length)
      return e.every(jR(l / KT, u / KT, d));
    if (h === 0)
      return Aw.every(Math.max(jR(l, u, d), 1));
    const [p, g] = a[f / a[h - 1][2] < a[h][2] / f ? h - 1 : h];
    return p.every(g);
  }
  return [s, c];
}
const [GYe, KYe] = yne(_C, U3, z3, vne, F3, j3), [YYe, XYe] = yne(bC, H3, B3, V3, L3, D3);
var YT = /* @__PURE__ */ new Date(), XT = /* @__PURE__ */ new Date();
function fi(e, t, n, r) {
  function i(o) {
    return e(o = arguments.length === 0 ? /* @__PURE__ */ new Date() : /* @__PURE__ */ new Date(+o)), o;
  }
  return i.floor = function(o) {
    return e(o = /* @__PURE__ */ new Date(+o)), o;
  }, i.ceil = function(o) {
    return e(o = new Date(o - 1)), t(o, 1), e(o), o;
  }, i.round = function(o) {
    var a = i(o), s = i.ceil(o);
    return o - a < s - o ? a : s;
  }, i.offset = function(o, a) {
    return t(o = /* @__PURE__ */ new Date(+o), a == null ? 1 : Math.floor(a)), o;
  }, i.range = function(o, a, s) {
    var c = [], l;
    if (o = i.ceil(o), s = s == null ? 1 : Math.floor(s), !(o < a) || !(s > 0))
      return c;
    do
      c.push(l = /* @__PURE__ */ new Date(+o)), t(o, s), e(o);
    while (l < o && o < a);
    return c;
  }, i.filter = function(o) {
    return fi(function(a) {
      if (a >= a)
        for (; e(a), !o(a); )
          a.setTime(a - 1);
    }, function(a, s) {
      if (a >= a)
        if (s < 0)
          for (; ++s <= 0; )
            for (; t(a, -1), !o(a); )
              ;
        else
          for (; --s >= 0; )
            for (; t(a, 1), !o(a); )
              ;
    });
  }, n && (i.count = function(o, a) {
    return YT.setTime(+o), XT.setTime(+a), e(YT), e(XT), Math.floor(n(YT, XT));
  }, i.every = function(o) {
    return o = Math.floor(o), !isFinite(o) || !(o > 0) ? null : o > 1 ? i.filter(r ? function(a) {
      return r(a) % o === 0;
    } : function(a) {
      return i.count(0, a) % o === 0;
    }) : i;
  }), i;
}
var Rw = fi(function() {
}, function(e, t) {
  e.setTime(+e + t);
}, function(e, t) {
  return t - e;
});
Rw.every = function(e) {
  return e = Math.floor(e), !isFinite(e) || !(e > 0) ? null : e > 1 ? fi(function(t) {
    t.setTime(Math.floor(t / e) * e);
  }, function(t, n) {
    t.setTime(+t + n * e);
  }, function(t, n) {
    return (n - t) / e;
  }) : Rw;
};
const iV = Rw;
Rw.range;
var Pw = 1e3, Af = 6e4, Ow = 36e5, bne = 864e5, _ne = 6048e5, Sne = fi(function(e) {
  e.setTime(e - e.getMilliseconds());
}, function(e, t) {
  e.setTime(+e + t * Pw);
}, function(e, t) {
  return (t - e) / Pw;
}, function(e) {
  return e.getUTCSeconds();
});
const oV = Sne;
Sne.range;
var wne = fi(function(e) {
  e.setTime(e - e.getMilliseconds() - e.getSeconds() * Pw);
}, function(e, t) {
  e.setTime(+e + t * Af);
}, function(e, t) {
  return (t - e) / Af;
}, function(e) {
  return e.getMinutes();
});
const QYe = wne;
wne.range;
var xne = fi(function(e) {
  e.setTime(e - e.getMilliseconds() - e.getSeconds() * Pw - e.getMinutes() * Af);
}, function(e, t) {
  e.setTime(+e + t * Ow);
}, function(e, t) {
  return (t - e) / Ow;
}, function(e) {
  return e.getHours();
});
const JYe = xne;
xne.range;
var Ene = fi(function(e) {
  e.setHours(0, 0, 0, 0);
}, function(e, t) {
  e.setDate(e.getDate() + t);
}, function(e, t) {
  return (t - e - (t.getTimezoneOffset() - e.getTimezoneOffset()) * Af) / bne;
}, function(e) {
  return e.getDate() - 1;
});
const Cne = Ene;
Ene.range;
function nh(e) {
  return fi(function(t) {
    t.setDate(t.getDate() - (t.getDay() + 7 - e) % 7), t.setHours(0, 0, 0, 0);
  }, function(t, n) {
    t.setDate(t.getDate() + n * 7);
  }, function(t, n) {
    return (n - t - (n.getTimezoneOffset() - t.getTimezoneOffset()) * Af) / _ne;
  });
}
var Mw = nh(0), Bv = nh(1), Tne = nh(2), Ine = nh(3), Rf = nh(4), $ne = nh(5), Ane = nh(6);
Mw.range;
Bv.range;
Tne.range;
Ine.range;
Rf.range;
$ne.range;
Ane.range;
var Rne = fi(function(e) {
  e.setDate(1), e.setHours(0, 0, 0, 0);
}, function(e, t) {
  e.setMonth(e.getMonth() + t);
}, function(e, t) {
  return t.getMonth() - e.getMonth() + (t.getFullYear() - e.getFullYear()) * 12;
}, function(e) {
  return e.getMonth();
});
const ZYe = Rne;
Rne.range;
var W3 = fi(function(e) {
  e.setMonth(0, 1), e.setHours(0, 0, 0, 0);
}, function(e, t) {
  e.setFullYear(e.getFullYear() + t);
}, function(e, t) {
  return t.getFullYear() - e.getFullYear();
}, function(e) {
  return e.getFullYear();
});
W3.every = function(e) {
  return !isFinite(e = Math.floor(e)) || !(e > 0) ? null : fi(function(t) {
    t.setFullYear(Math.floor(t.getFullYear() / e) * e), t.setMonth(0, 1), t.setHours(0, 0, 0, 0);
  }, function(t, n) {
    t.setFullYear(t.getFullYear() + n * e);
  });
};
const sp = W3;
W3.range;
var Pne = fi(function(e) {
  e.setUTCSeconds(0, 0);
}, function(e, t) {
  e.setTime(+e + t * Af);
}, function(e, t) {
  return (t - e) / Af;
}, function(e) {
  return e.getUTCMinutes();
});
const eXe = Pne;
Pne.range;
var One = fi(function(e) {
  e.setUTCMinutes(0, 0, 0);
}, function(e, t) {
  e.setTime(+e + t * Ow);
}, function(e, t) {
  return (t - e) / Ow;
}, function(e) {
  return e.getUTCHours();
});
const tXe = One;
One.range;
var Mne = fi(function(e) {
  e.setUTCHours(0, 0, 0, 0);
}, function(e, t) {
  e.setUTCDate(e.getUTCDate() + t);
}, function(e, t) {
  return (t - e) / bne;
}, function(e) {
  return e.getUTCDate() - 1;
});
const kne = Mne;
Mne.range;
function rh(e) {
  return fi(function(t) {
    t.setUTCDate(t.getUTCDate() - (t.getUTCDay() + 7 - e) % 7), t.setUTCHours(0, 0, 0, 0);
  }, function(t, n) {
    t.setUTCDate(t.getUTCDate() + n * 7);
  }, function(t, n) {
    return (n - t) / _ne;
  });
}
var kw = rh(0), zv = rh(1), Nne = rh(2), Dne = rh(3), Pf = rh(4), jne = rh(5), Lne = rh(6);
kw.range;
zv.range;
Nne.range;
Dne.range;
Pf.range;
jne.range;
Lne.range;
var Fne = fi(function(e) {
  e.setUTCDate(1), e.setUTCHours(0, 0, 0, 0);
}, function(e, t) {
  e.setUTCMonth(e.getUTCMonth() + t);
}, function(e, t) {
  return t.getUTCMonth() - e.getUTCMonth() + (t.getUTCFullYear() - e.getUTCFullYear()) * 12;
}, function(e) {
  return e.getUTCMonth();
});
const nXe = Fne;
Fne.range;
var q3 = fi(function(e) {
  e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
}, function(e, t) {
  e.setUTCFullYear(e.getUTCFullYear() + t);
}, function(e, t) {
  return t.getUTCFullYear() - e.getUTCFullYear();
}, function(e) {
  return e.getUTCFullYear();
});
q3.every = function(e) {
  return !isFinite(e = Math.floor(e)) || !(e > 0) ? null : fi(function(t) {
    t.setUTCFullYear(Math.floor(t.getUTCFullYear() / e) * e), t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
  }, function(t, n) {
    t.setUTCFullYear(t.getUTCFullYear() + n * e);
  });
};
const cp = q3;
q3.range;
function QT(e) {
  if (0 <= e.y && e.y < 100) {
    var t = new Date(-1, e.m, e.d, e.H, e.M, e.S, e.L);
    return t.setFullYear(e.y), t;
  }
  return new Date(e.y, e.m, e.d, e.H, e.M, e.S, e.L);
}
function JT(e) {
  if (0 <= e.y && e.y < 100) {
    var t = new Date(Date.UTC(-1, e.m, e.d, e.H, e.M, e.S, e.L));
    return t.setUTCFullYear(e.y), t;
  }
  return new Date(Date.UTC(e.y, e.m, e.d, e.H, e.M, e.S, e.L));
}
function jm(e, t, n) {
  return { y: e, m: t, d: n, H: 0, M: 0, S: 0, L: 0 };
}
function rXe(e) {
  var t = e.dateTime, n = e.date, r = e.time, i = e.periods, o = e.days, a = e.shortDays, s = e.months, c = e.shortMonths, l = Lm(i), u = Fm(i), d = Lm(o), f = Fm(o), h = Lm(a), p = Fm(a), g = Lm(s), m = Fm(s), v = Lm(c), y = Fm(c), _ = {
    a: D,
    A: z,
    b: V,
    B,
    c: null,
    d: dV,
    e: dV,
    f: TXe,
    g: DXe,
    G: LXe,
    H: xXe,
    I: EXe,
    j: CXe,
    L: Vne,
    m: IXe,
    M: $Xe,
    p: U,
    q: Q,
    Q: gV,
    s: pV,
    S: AXe,
    u: RXe,
    U: PXe,
    V: OXe,
    w: MXe,
    W: kXe,
    x: null,
    X: null,
    y: NXe,
    Y: jXe,
    Z: FXe,
    "%": hV
  }, b = {
    a: Y,
    A: q,
    b: X,
    B: ne,
    c: null,
    d: fV,
    e: fV,
    f: HXe,
    g: ZXe,
    G: tQe,
    H: VXe,
    I: BXe,
    j: zXe,
    L: zne,
    m: UXe,
    M: WXe,
    p: Z,
    q: J,
    Q: gV,
    s: pV,
    S: qXe,
    u: GXe,
    U: KXe,
    V: YXe,
    w: XXe,
    W: QXe,
    x: null,
    X: null,
    y: JXe,
    Y: eQe,
    Z: nQe,
    "%": hV
  }, w = {
    a: R,
    A: I,
    b: O,
    B: P,
    c: k,
    d: lV,
    e: lV,
    f: bXe,
    g: cV,
    G: sV,
    H: uV,
    I: uV,
    j: pXe,
    L: yXe,
    m: gXe,
    M: mXe,
    p: E,
    q: hXe,
    Q: SXe,
    s: wXe,
    S: vXe,
    u: cXe,
    U: lXe,
    V: uXe,
    w: sXe,
    W: dXe,
    x: L,
    X: N,
    y: cV,
    Y: sV,
    Z: fXe,
    "%": _Xe
  };
  _.x = C(n, _), _.X = C(r, _), _.c = C(t, _), b.x = C(n, b), b.X = C(r, b), b.c = C(t, b);
  function C(K, ee) {
    return function(te) {
      var H = [], ie = -1, W = 0, se = K.length, le, ge, me;
      for (te instanceof Date || (te = /* @__PURE__ */ new Date(+te)); ++ie < se; )
        K.charCodeAt(ie) === 37 && (H.push(K.slice(W, ie)), (ge = aV[le = K.charAt(++ie)]) != null ? le = K.charAt(++ie) : ge = le === "e" ? " " : "0", (me = ee[le]) && (le = me(te, ge)), H.push(le), W = ie + 1);
      return H.push(K.slice(W, ie)), H.join("");
    };
  }
  function x(K, ee) {
    return function(te) {
      var H = jm(1900, void 0, 1), ie = T(H, K, te += "", 0), W, se;
      if (ie != te.length)
        return null;
      if ("Q" in H)
        return new Date(H.Q);
      if ("s" in H)
        return new Date(H.s * 1e3 + ("L" in H ? H.L : 0));
      if (ee && !("Z" in H) && (H.Z = 0), "p" in H && (H.H = H.H % 12 + H.p * 12), H.m === void 0 && (H.m = "q" in H ? H.q : 0), "V" in H) {
        if (H.V < 1 || H.V > 53)
          return null;
        "w" in H || (H.w = 1), "Z" in H ? (W = JT(jm(H.y, 0, 1)), se = W.getUTCDay(), W = se > 4 || se === 0 ? zv.ceil(W) : zv(W), W = kne.offset(W, (H.V - 1) * 7), H.y = W.getUTCFullYear(), H.m = W.getUTCMonth(), H.d = W.getUTCDate() + (H.w + 6) % 7) : (W = QT(jm(H.y, 0, 1)), se = W.getDay(), W = se > 4 || se === 0 ? Bv.ceil(W) : Bv(W), W = Cne.offset(W, (H.V - 1) * 7), H.y = W.getFullYear(), H.m = W.getMonth(), H.d = W.getDate() + (H.w + 6) % 7);
      } else
        ("W" in H || "U" in H) && ("w" in H || (H.w = "u" in H ? H.u % 7 : "W" in H ? 1 : 0), se = "Z" in H ? JT(jm(H.y, 0, 1)).getUTCDay() : QT(jm(H.y, 0, 1)).getDay(), H.m = 0, H.d = "W" in H ? (H.w + 6) % 7 + H.W * 7 - (se + 5) % 7 : H.w + H.U * 7 - (se + 6) % 7);
      return "Z" in H ? (H.H += H.Z / 100 | 0, H.M += H.Z % 100, JT(H)) : QT(H);
    };
  }
  function T(K, ee, te, H) {
    for (var ie = 0, W = ee.length, se = te.length, le, ge; ie < W; ) {
      if (H >= se)
        return -1;
      if (le = ee.charCodeAt(ie++), le === 37) {
        if (le = ee.charAt(ie++), ge = w[le in aV ? ee.charAt(ie++) : le], !ge || (H = ge(K, te, H)) < 0)
          return -1;
      } else if (le != te.charCodeAt(H++))
        return -1;
    }
    return H;
  }
  function E(K, ee, te) {
    var H = l.exec(ee.slice(te));
    return H ? (K.p = u.get(H[0].toLowerCase()), te + H[0].length) : -1;
  }
  function R(K, ee, te) {
    var H = h.exec(ee.slice(te));
    return H ? (K.w = p.get(H[0].toLowerCase()), te + H[0].length) : -1;
  }
  function I(K, ee, te) {
    var H = d.exec(ee.slice(te));
    return H ? (K.w = f.get(H[0].toLowerCase()), te + H[0].length) : -1;
  }
  function O(K, ee, te) {
    var H = v.exec(ee.slice(te));
    return H ? (K.m = y.get(H[0].toLowerCase()), te + H[0].length) : -1;
  }
  function P(K, ee, te) {
    var H = g.exec(ee.slice(te));
    return H ? (K.m = m.get(H[0].toLowerCase()), te + H[0].length) : -1;
  }
  function k(K, ee, te) {
    return T(K, t, ee, te);
  }
  function L(K, ee, te) {
    return T(K, n, ee, te);
  }
  function N(K, ee, te) {
    return T(K, r, ee, te);
  }
  function D(K) {
    return a[K.getDay()];
  }
  function z(K) {
    return o[K.getDay()];
  }
  function V(K) {
    return c[K.getMonth()];
  }
  function B(K) {
    return s[K.getMonth()];
  }
  function U(K) {
    return i[+(K.getHours() >= 12)];
  }
  function Q(K) {
    return 1 + ~~(K.getMonth() / 3);
  }
  function Y(K) {
    return a[K.getUTCDay()];
  }
  function q(K) {
    return o[K.getUTCDay()];
  }
  function X(K) {
    return c[K.getUTCMonth()];
  }
  function ne(K) {
    return s[K.getUTCMonth()];
  }
  function Z(K) {
    return i[+(K.getUTCHours() >= 12)];
  }
  function J(K) {
    return 1 + ~~(K.getUTCMonth() / 3);
  }
  return {
    format: function(K) {
      var ee = C(K += "", _);
      return ee.toString = function() {
        return K;
      }, ee;
    },
    parse: function(K) {
      var ee = x(K += "", !1);
      return ee.toString = function() {
        return K;
      }, ee;
    },
    utcFormat: function(K) {
      var ee = C(K += "", b);
      return ee.toString = function() {
        return K;
      }, ee;
    },
    utcParse: function(K) {
      var ee = x(K += "", !0);
      return ee.toString = function() {
        return K;
      }, ee;
    }
  };
}
var aV = { "-": "", _: " ", 0: "0" }, ki = /^\s*\d+/, iXe = /^%/, oXe = /[\\^$*+?|[\]().{}]/g;
function Dn(e, t, n) {
  var r = e < 0 ? "-" : "", i = (r ? -e : e) + "", o = i.length;
  return r + (o < n ? new Array(n - o + 1).join(t) + i : i);
}
function aXe(e) {
  return e.replace(oXe, "\\$&");
}
function Lm(e) {
  return new RegExp("^(?:" + e.map(aXe).join("|") + ")", "i");
}
function Fm(e) {
  return new Map(e.map((t, n) => [t.toLowerCase(), n]));
}
function sXe(e, t, n) {
  var r = ki.exec(t.slice(n, n + 1));
  return r ? (e.w = +r[0], n + r[0].length) : -1;
}
function cXe(e, t, n) {
  var r = ki.exec(t.slice(n, n + 1));
  return r ? (e.u = +r[0], n + r[0].length) : -1;
}
function lXe(e, t, n) {
  var r = ki.exec(t.slice(n, n + 2));
  return r ? (e.U = +r[0], n + r[0].length) : -1;
}
function uXe(e, t, n) {
  var r = ki.exec(t.slice(n, n + 2));
  return r ? (e.V = +r[0], n + r[0].length) : -1;
}
function dXe(e, t, n) {
  var r = ki.exec(t.slice(n, n + 2));
  return r ? (e.W = +r[0], n + r[0].length) : -1;
}
function sV(e, t, n) {
  var r = ki.exec(t.slice(n, n + 4));
  return r ? (e.y = +r[0], n + r[0].length) : -1;
}
function cV(e, t, n) {
  var r = ki.exec(t.slice(n, n + 2));
  return r ? (e.y = +r[0] + (+r[0] > 68 ? 1900 : 2e3), n + r[0].length) : -1;
}
function fXe(e, t, n) {
  var r = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(t.slice(n, n + 6));
  return r ? (e.Z = r[1] ? 0 : -(r[2] + (r[3] || "00")), n + r[0].length) : -1;
}
function hXe(e, t, n) {
  var r = ki.exec(t.slice(n, n + 1));
  return r ? (e.q = r[0] * 3 - 3, n + r[0].length) : -1;
}
function gXe(e, t, n) {
  var r = ki.exec(t.slice(n, n + 2));
  return r ? (e.m = r[0] - 1, n + r[0].length) : -1;
}
function lV(e, t, n) {
  var r = ki.exec(t.slice(n, n + 2));
  return r ? (e.d = +r[0], n + r[0].length) : -1;
}
function pXe(e, t, n) {
  var r = ki.exec(t.slice(n, n + 3));
  return r ? (e.m = 0, e.d = +r[0], n + r[0].length) : -1;
}
function uV(e, t, n) {
  var r = ki.exec(t.slice(n, n + 2));
  return r ? (e.H = +r[0], n + r[0].length) : -1;
}
function mXe(e, t, n) {
  var r = ki.exec(t.slice(n, n + 2));
  return r ? (e.M = +r[0], n + r[0].length) : -1;
}
function vXe(e, t, n) {
  var r = ki.exec(t.slice(n, n + 2));
  return r ? (e.S = +r[0], n + r[0].length) : -1;
}
function yXe(e, t, n) {
  var r = ki.exec(t.slice(n, n + 3));
  return r ? (e.L = +r[0], n + r[0].length) : -1;
}
function bXe(e, t, n) {
  var r = ki.exec(t.slice(n, n + 6));
  return r ? (e.L = Math.floor(r[0] / 1e3), n + r[0].length) : -1;
}
function _Xe(e, t, n) {
  var r = iXe.exec(t.slice(n, n + 1));
  return r ? n + r[0].length : -1;
}
function SXe(e, t, n) {
  var r = ki.exec(t.slice(n));
  return r ? (e.Q = +r[0], n + r[0].length) : -1;
}
function wXe(e, t, n) {
  var r = ki.exec(t.slice(n));
  return r ? (e.s = +r[0], n + r[0].length) : -1;
}
function dV(e, t) {
  return Dn(e.getDate(), t, 2);
}
function xXe(e, t) {
  return Dn(e.getHours(), t, 2);
}
function EXe(e, t) {
  return Dn(e.getHours() % 12 || 12, t, 2);
}
function CXe(e, t) {
  return Dn(1 + Cne.count(sp(e), e), t, 3);
}
function Vne(e, t) {
  return Dn(e.getMilliseconds(), t, 3);
}
function TXe(e, t) {
  return Vne(e, t) + "000";
}
function IXe(e, t) {
  return Dn(e.getMonth() + 1, t, 2);
}
function $Xe(e, t) {
  return Dn(e.getMinutes(), t, 2);
}
function AXe(e, t) {
  return Dn(e.getSeconds(), t, 2);
}
function RXe(e) {
  var t = e.getDay();
  return t === 0 ? 7 : t;
}
function PXe(e, t) {
  return Dn(Mw.count(sp(e) - 1, e), t, 2);
}
function Bne(e) {
  var t = e.getDay();
  return t >= 4 || t === 0 ? Rf(e) : Rf.ceil(e);
}
function OXe(e, t) {
  return e = Bne(e), Dn(Rf.count(sp(e), e) + (sp(e).getDay() === 4), t, 2);
}
function MXe(e) {
  return e.getDay();
}
function kXe(e, t) {
  return Dn(Bv.count(sp(e) - 1, e), t, 2);
}
function NXe(e, t) {
  return Dn(e.getFullYear() % 100, t, 2);
}
function DXe(e, t) {
  return e = Bne(e), Dn(e.getFullYear() % 100, t, 2);
}
function jXe(e, t) {
  return Dn(e.getFullYear() % 1e4, t, 4);
}
function LXe(e, t) {
  var n = e.getDay();
  return e = n >= 4 || n === 0 ? Rf(e) : Rf.ceil(e), Dn(e.getFullYear() % 1e4, t, 4);
}
function FXe(e) {
  var t = e.getTimezoneOffset();
  return (t > 0 ? "-" : (t *= -1, "+")) + Dn(t / 60 | 0, "0", 2) + Dn(t % 60, "0", 2);
}
function fV(e, t) {
  return Dn(e.getUTCDate(), t, 2);
}
function VXe(e, t) {
  return Dn(e.getUTCHours(), t, 2);
}
function BXe(e, t) {
  return Dn(e.getUTCHours() % 12 || 12, t, 2);
}
function zXe(e, t) {
  return Dn(1 + kne.count(cp(e), e), t, 3);
}
function zne(e, t) {
  return Dn(e.getUTCMilliseconds(), t, 3);
}
function HXe(e, t) {
  return zne(e, t) + "000";
}
function UXe(e, t) {
  return Dn(e.getUTCMonth() + 1, t, 2);
}
function WXe(e, t) {
  return Dn(e.getUTCMinutes(), t, 2);
}
function qXe(e, t) {
  return Dn(e.getUTCSeconds(), t, 2);
}
function GXe(e) {
  var t = e.getUTCDay();
  return t === 0 ? 7 : t;
}
function KXe(e, t) {
  return Dn(kw.count(cp(e) - 1, e), t, 2);
}
function Hne(e) {
  var t = e.getUTCDay();
  return t >= 4 || t === 0 ? Pf(e) : Pf.ceil(e);
}
function YXe(e, t) {
  return e = Hne(e), Dn(Pf.count(cp(e), e) + (cp(e).getUTCDay() === 4), t, 2);
}
function XXe(e) {
  return e.getUTCDay();
}
function QXe(e, t) {
  return Dn(zv.count(cp(e) - 1, e), t, 2);
}
function JXe(e, t) {
  return Dn(e.getUTCFullYear() % 100, t, 2);
}
function ZXe(e, t) {
  return e = Hne(e), Dn(e.getUTCFullYear() % 100, t, 2);
}
function eQe(e, t) {
  return Dn(e.getUTCFullYear() % 1e4, t, 4);
}
function tQe(e, t) {
  var n = e.getUTCDay();
  return e = n >= 4 || n === 0 ? Pf(e) : Pf.ceil(e), Dn(e.getUTCFullYear() % 1e4, t, 4);
}
function nQe() {
  return "+0000";
}
function hV() {
  return "%";
}
function gV(e) {
  return +e;
}
function pV(e) {
  return Math.floor(+e / 1e3);
}
var Ch, SC, Une, Wne, qne;
rQe({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});
function rQe(e) {
  return Ch = rXe(e), SC = Ch.format, Une = Ch.parse, Wne = Ch.utcFormat, qne = Ch.utcParse, Ch;
}
function iQe(e) {
  return new Date(e);
}
function oQe(e) {
  return e instanceof Date ? +e : +/* @__PURE__ */ new Date(+e);
}
function G3(e, t, n, r, i, o, a, s, c, l) {
  var u = I3(), d = u.invert, f = u.domain, h = l(".%L"), p = l(":%S"), g = l("%I:%M"), m = l("%I %p"), v = l("%a %d"), y = l("%b %d"), _ = l("%B"), b = l("%Y");
  function w(C) {
    return (c(C) < C ? h : s(C) < C ? p : a(C) < C ? g : o(C) < C ? m : r(C) < C ? i(C) < C ? v : y : n(C) < C ? _ : b)(C);
  }
  return u.invert = function(C) {
    return new Date(d(C));
  }, u.domain = function(C) {
    return arguments.length ? f(Array.from(C, oQe)) : f().map(iQe);
  }, u.ticks = function(C) {
    var x = f();
    return e(x[0], x[x.length - 1], C ?? 10);
  }, u.tickFormat = function(C, x) {
    return x == null ? w : l(x);
  }, u.nice = function(C) {
    var x = f();
    return (!C || typeof C.range != "function") && (C = t(x[0], x[x.length - 1], C ?? 10)), C ? f(dne(x, C)) : u;
  }, u.copy = function() {
    return Gy(u, G3(e, t, n, r, i, o, a, s, c, l));
  }, u;
}
function Gne() {
  return ts.apply(G3(YYe, XYe, bC, H3, B3, V3, L3, D3, Bd, SC).domain([new Date(2e3, 0, 1), new Date(2e3, 0, 2)]), arguments);
}
function Kne() {
  return ts.apply(G3(GYe, KYe, _C, U3, z3, mne, F3, j3, Bd, Wne).domain([Date.UTC(2e3, 0, 1), Date.UTC(2e3, 0, 2)]), arguments);
}
function wC() {
  var e = 0, t = 1, n, r, i, o, a = Oo, s = !1, c;
  function l(d) {
    return d == null || isNaN(d = +d) ? c : a(i === 0 ? 0.5 : (d = (o(d) - n) * i, s ? Math.max(0, Math.min(1, d)) : d));
  }
  l.domain = function(d) {
    return arguments.length ? ([e, t] = d, n = o(e = +e), r = o(t = +t), i = n === r ? 0 : 1 / (r - n), l) : [e, t];
  }, l.clamp = function(d) {
    return arguments.length ? (s = !!d, l) : s;
  }, l.interpolator = function(d) {
    return arguments.length ? (a = d, l) : a;
  };
  function u(d) {
    return function(f) {
      var h, p;
      return arguments.length ? ([h, p] = f, a = d(h, p), l) : [a(0), a(1)];
    };
  }
  return l.range = u(Rc), l.rangeRound = u(b3), l.unknown = function(d) {
    return arguments.length ? (c = d, l) : c;
  }, function(d) {
    return o = d, n = d(e), r = d(t), i = n === r ? 0 : 1 / (r - n), l;
  };
}
function cd(e, t) {
  return t.domain(e.domain()).interpolator(e.interpolator()).clamp(e.clamp()).unknown(e.unknown());
}
function Yne() {
  var e = sd(wC()(Oo));
  return e.copy = function() {
    return cd(e, Yne());
  }, Tl.apply(e, arguments);
}
function Xne() {
  var e = A3(wC()).domain([1, 10]);
  return e.copy = function() {
    return cd(e, Xne()).base(e.base());
  }, Tl.apply(e, arguments);
}
function Qne() {
  var e = P3(wC());
  return e.copy = function() {
    return cd(e, Qne()).constant(e.constant());
  }, Tl.apply(e, arguments);
}
function K3() {
  var e = M3(wC());
  return e.copy = function() {
    return cd(e, K3()).exponent(e.exponent());
  }, Tl.apply(e, arguments);
}
function aQe() {
  return K3.apply(null, arguments).exponent(0.5);
}
function Jne() {
  var e = [], t = Oo;
  function n(r) {
    if (r != null && !isNaN(r = +r))
      return t((qy(e, r, 1) - 1) / (e.length - 1));
  }
  return n.domain = function(r) {
    if (!arguments.length)
      return e.slice();
    e = [];
    for (let i of r)
      i != null && !isNaN(i = +i) && e.push(i);
    return e.sort(yu), n;
  }, n.interpolator = function(r) {
    return arguments.length ? (t = r, n) : t;
  }, n.range = function() {
    return e.map((r, i) => t(i / (e.length - 1)));
  }, n.quantiles = function(r) {
    return Array.from({ length: r + 1 }, (i, o) => cYe(e, o / r));
  }, n.copy = function() {
    return Jne(t).domain(e);
  }, Tl.apply(n, arguments);
}
function xC() {
  var e = 0, t = 0.5, n = 1, r = 1, i, o, a, s, c, l = Oo, u, d = !1, f;
  function h(g) {
    return isNaN(g = +g) ? f : (g = 0.5 + ((g = +u(g)) - o) * (r * g < r * o ? s : c), l(d ? Math.max(0, Math.min(1, g)) : g));
  }
  h.domain = function(g) {
    return arguments.length ? ([e, t, n] = g, i = u(e = +e), o = u(t = +t), a = u(n = +n), s = i === o ? 0 : 0.5 / (o - i), c = o === a ? 0 : 0.5 / (a - o), r = o < i ? -1 : 1, h) : [e, t, n];
  }, h.clamp = function(g) {
    return arguments.length ? (d = !!g, h) : d;
  }, h.interpolator = function(g) {
    return arguments.length ? (l = g, h) : l;
  };
  function p(g) {
    return function(m) {
      var v, y, _;
      return arguments.length ? ([v, y, _] = m, l = eWe(g, [v, y, _]), h) : [l(0), l(0.5), l(1)];
    };
  }
  return h.range = p(Rc), h.rangeRound = p(b3), h.unknown = function(g) {
    return arguments.length ? (f = g, h) : f;
  }, function(g) {
    return u = g, i = g(e), o = g(t), a = g(n), s = i === o ? 0 : 0.5 / (o - i), c = o === a ? 0 : 0.5 / (a - o), r = o < i ? -1 : 1, h;
  };
}
function Zne() {
  var e = sd(xC()(Oo));
  return e.copy = function() {
    return cd(e, Zne());
  }, Tl.apply(e, arguments);
}
function ere() {
  var e = A3(xC()).domain([0.1, 1, 10]);
  return e.copy = function() {
    return cd(e, ere()).base(e.base());
  }, Tl.apply(e, arguments);
}
function tre() {
  var e = P3(xC());
  return e.copy = function() {
    return cd(e, tre()).constant(e.constant());
  }, Tl.apply(e, arguments);
}
function Y3() {
  var e = M3(xC());
  return e.copy = function() {
    return cd(e, Y3()).exponent(e.exponent());
  }, Tl.apply(e, arguments);
}
function sQe() {
  return Y3.apply(null, arguments).exponent(0.5);
}
const cQe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  scaleBand: vC,
  scaleDiverging: Zne,
  scaleDivergingLog: ere,
  scaleDivergingPow: Y3,
  scaleDivergingSqrt: sQe,
  scaleDivergingSymlog: tre,
  scaleIdentity: une,
  scaleImplicit: LR,
  scaleLinear: Yy,
  scaleLog: R3,
  scaleOrdinal: tl,
  scalePoint: ane,
  scalePow: k3,
  scaleQuantile: hne,
  scaleQuantize: gne,
  scaleRadial: fne,
  scaleSequential: Yne,
  scaleSequentialLog: Xne,
  scaleSequentialPow: K3,
  scaleSequentialQuantile: Jne,
  scaleSequentialSqrt: aQe,
  scaleSequentialSymlog: Qne,
  scaleSqrt: MYe,
  scaleSymlog: O3,
  scaleThreshold: pne,
  scaleTime: Gne,
  scaleUtc: Kne,
  tickFormat: lne
}, Symbol.toStringTag, { value: "Module" })), lQe = ["linear", "time", "log", "sqrt"];
function uQe(e) {
  return `scale${((n) => n && n[0].toUpperCase() + n.slice(1))(e)}`;
}
function nre(e) {
  return typeof e == "function" ? Rn(e.copy) && Rn(e.domain) && Rn(e.range) : typeof e == "string" ? lQe.includes(e) : !1;
}
function rre(e, t) {
  if (e.scale) {
    if (e.scale.x || e.scale.y)
      return !!e.scale[t];
  } else
    return !1;
  return !0;
}
function dQe(e, t) {
  if (!rre(e, t))
    return;
  const n = e.scale[t] || e.scale;
  return typeof n == "string" ? n : ore(n);
}
function fQe(e, t) {
  let n;
  if (e.domain && e.domain[t] ? n = e.domain[t] : e.domain && Array.isArray(e.domain) && (n = e.domain), !!n)
    return Fu(n) ? "time" : "linear";
}
function ire(e, t) {
  if (!e.data)
    return "linear";
  const n = mC(e[t]), r = e.data.map((i) => {
    const o = ni(n(i)) ? n(i)[t] : n(i);
    return o !== void 0 ? o : i[t];
  });
  return Fu(r) ? "time" : "linear";
}
function Hv(e) {
  if (nre(e)) {
    const t = uQe(e);
    return cQe[t]();
  }
  return Yy();
}
function ra(e, t) {
  const n = Of(e, t);
  if (n)
    return typeof n == "string" ? Hv(n) : n;
  const r = fQe(e, t) || ire(e, t);
  return Hv(r);
}
function Of(e, t) {
  if (!rre(e, t))
    return;
  const n = e.scale[t] || e.scale;
  if (nre(n))
    return Rn(n) ? n : Hv(n);
}
function Nw(e, t) {
  return dQe(e, t) || ire(e, t);
}
const hQe = [
  {
    name: "quantile",
    method: "quantiles"
  },
  {
    name: "log",
    method: "base"
  }
  // TODO(2214): Re-evaluate (1) duck typing approach, and (2) if duck typing,
  //   do we need a different approach? (Multiple keys? Stringifying functions?)
  // https://github.com/FormidableLabs/victory/issues/2214
  // Below are matches that don't seem to otherwise occur in Victory code base.
  // { name: "ordinal", method: "unknown" },
  // { name: "pow-sqrt", method: "exponent" },
  // { name: "quantize-threshold", method: "invertExtent" }
];
function ore(e) {
  if (typeof e == "string")
    return e;
  const t = hQe.filter((n) => e[n.method] !== void 0)[0];
  return t ? t.name : void 0;
}
const gQe = "@@__IMMUTABLE_ITERABLE__@@", pQe = "@@__IMMUTABLE_RECORD__@@", mQe = "@@__IMMUTABLE_LIST__@@";
function Xy(e) {
  return !!(e && e[gQe]);
}
function vQe(e) {
  return !!(e && e[pQe]);
}
function yQe(e) {
  return Xy(e) || vQe(e);
}
function bQe(e) {
  return !!(e && e[mQe]);
}
function are(e, t) {
  return Xy(e) ? e.reduce((n, r, i) => {
    let o = r;
    return t && t[i] && (o = are(r)), n[i] = o, n;
  }, bQe(e) ? [] : {}) : e;
}
function VR(e) {
  const t = {
    errorX: !0,
    errorY: !0
  };
  return yQe(e) ? are(e, t) : e;
}
function _Qe(e) {
  return Xy(e) ? e.size : e.length;
}
function mV(e, t) {
  const r = (ni(e.domain) ? e.domain[t] : e.domain) || ra(e, t).domain(), i = e.samples || 1, o = Math.max(...r), a = Math.min(...r), s = (o - a) / i, c = w3(a, o, s);
  return c[c.length - 1] === o ? c : c.concat(o);
}
function sre(e, t, n) {
  if (n === void 0 && (n = "ascending"), !t)
    return e;
  let r = t;
  return (t === "x" || t === "y") && (r = `_${t}`), zy(e, r, n === "ascending" ? "asc" : "desc");
}
function SQe(e, t) {
  const n = 1 / Number.MAX_SAFE_INTEGER, r = {
    x: Nw(t, "x"),
    y: Nw(t, "y")
  };
  if (r.x !== "log" && r.y !== "log")
    return e;
  const i = (a, s) => r[s] === "log" ? a[`_${s}`] !== 0 : !0, o = (a) => {
    const s = i(a, "x") ? a._x : n, c = i(a, "y") ? a._y : n, l = i(a, "y0") ? a._y0 : n;
    return Object.assign({}, a, {
      _x: s,
      _y: c,
      _y0: l
    });
  };
  return e.map((a) => i(a, "x") && i(a, "y") && i(a, "y0") ? a : o(a));
}
function wQe(e) {
  return Rn(e) ? e : e == null ? () => {
  } : cte(e);
}
function xQe(e, t) {
  const n = !!e.eventKey, r = wQe(e.eventKey);
  return t.map((i, o) => {
    if (i.eventKey !== void 0)
      return i;
    if (n) {
      const a = r(i, o);
      return a !== void 0 ? Object.assign({
        eventKey: a
      }, i) : i;
    }
    return i;
  });
}
function cre(e, t, n) {
  const r = (p) => p !== void 0, i = Ea(t.x), o = xa(t.x), a = Ea(t.y), s = xa(t.y), c = (p) => (g) => r(g) && g < p, l = (p) => (g) => r(g) && g > p, u = c(i), d = c(a), f = l(o), h = l(s);
  return e.map((p) => {
    let {
      _x: g,
      _y: m,
      _y0: v,
      _y1: y
    } = p;
    (u(g) || f(g)) && (g = null);
    const _ = r(v) ? v : n, b = r(y) ? y : m;
    return r(b) ? (!r(_) && (d(b) || h(b)) && (m = null), (d(_) && d(b) || h(_) && h(b)) && (m = v = y = null), d(_) && !d(b) && (v = a), h(_) && !h(b) && (v = s), Object.assign({}, p, Hte({
      _x: g,
      _y: m,
      _y0: v,
      _y1: y
    }, YKe))) : p;
  });
}
function ZT(e, t) {
  const n = ure(e, t), r = lp(e, t), i = EQe(e, t), o = bl([...n, ...r, ...i]);
  return o.length === 0 ? null : o.reduce((a, s, c) => (a[s] = c + 1, a), {});
}
function Dw(e, t, n) {
  if (!(Array.isArray(e) || Xy(e)) || _Qe(e) < 1)
    return [];
  const i = ["x", "y", "y0"];
  n = Array.isArray(n) ? n : i;
  const o = (f) => mC(t[f] !== void 0 ? t[f] : f), a = n.reduce((f, h) => (f[h] = o(h), f), {}), s = VU(n, i) && t.x === "_x" && t.y === "_y" && t.y0 === "_y0";
  let c;
  s === !1 && (c = {
    x: n.indexOf("x") !== -1 ? ZT(t, "x") : void 0,
    y: n.indexOf("y") !== -1 ? ZT(t, "y") : void 0,
    y0: n.indexOf("y0") !== -1 ? ZT(t, "y") : void 0
  });
  const l = s ? e : e.reduce((f, h, p) => {
    const g = VR(h), m = {
      x: p,
      y: g
    }, v = n.reduce((_, b) => {
      const w = a[b](g), C = w !== void 0 ? w : m[b];
      return C !== void 0 && (typeof C == "string" && c[b] ? (_[`${b}Name`] = C, _[`_${b}`] = c[b][C]) : _[`_${b}`] = C), _;
    }, {}), y = Object.assign({}, v, g);
    return Lr(y) || f.push(y), f;
  }, []), u = sre(l, t.sortKey, t.sortOrder), d = SQe(u, t);
  return xQe(t, d);
}
function lre(e) {
  const t = mV(e, "x"), n = mV(e, "y");
  return t.map((i, o) => ({
    x: i,
    y: n[o]
  }));
}
function X3(e, t) {
  return e.categories && !Array.isArray(e.categories) ? e.categories[t] : e.categories;
}
function Do(e) {
  return e.data ? Dw(e.data, e) : Dw(lre(e), e);
}
function ure(e, t) {
  const {
    tickValues: n,
    tickFormat: r
  } = e;
  let i;
  return !n || !Array.isArray(n) && !n[t] ? i = r && Array.isArray(r) ? r : [] : i = n[t] || n, i.filter((o) => typeof o == "string");
}
function lp(e, t) {
  if (!e.categories)
    return [];
  const n = X3(e, t), r = n && n.filter((i) => typeof i == "string");
  return r ? yGe(r) : [];
}
function EQe(e, t) {
  if (!(Array.isArray(e.data) || Xy(e.data)))
    return [];
  const r = e[t] === void 0 ? t : e[t], i = mC(r), o = e.data.reduce((c, l) => (c.push(VR(l)), c), []);
  return sre(o, e.sortKey, e.sortOrder).reduce((c, l) => {
    const u = VR(l);
    return c.push(i(u)), c;
  }, []).filter((c) => typeof c == "string").reduce((c, l) => (l != null && c.indexOf(l) === -1 && c.push(l), c), []);
}
function dre(e) {
  const t = (i) => i && i.type ? i.type.role : "";
  let n = t(e);
  if (n === "portal") {
    const i = j.Children.toArray(e.props.children);
    n = i.length ? t(i[0]) : "";
  }
  return ["area", "bar", "boxplot", "candlestick", "errorbar", "group", "histogram", "line", "pie", "scatter", "stack", "voronoi"].includes(n);
}
function CQe(e, t, n) {
  return Nw(t, n) !== "log" ? e : ((o) => {
    const a = o[0] < 0 || o[1] < 0 ? -1 / Number.MAX_SAFE_INTEGER : 1 / Number.MAX_SAFE_INTEGER, s = o[0] === 0 ? a : o[0], c = o[1] === 0 ? a : o[1];
    return [s, c];
  })(e);
}
function TQe(e, t) {
  const n = (r) => Array.isArray(r) ? {
    left: r[0],
    right: r[1]
  } : {
    left: r,
    right: r
  };
  return ni(e.domainPadding) ? n(e.domainPadding[t]) : n(e.domainPadding);
}
function IQe(e, t) {
  const n = `_${t}`;
  return e.flat().map((r) => r[n] && r[n][1] !== void 0 ? r[n][1] : r[n]);
}
function vV(e, t, n) {
  n === void 0 && (n = "min");
  const r = (s) => n === "max" ? Math.max(...s) : Math.min(...s), i = n === "max" ? -1 / 0 : 1 / 0;
  let o = !1;
  const a = e.flat().reduce((s, c) => {
    const l = c[`_${t}0`] !== void 0 ? c[`_${t}0`] : c[`_${t}`], u = c[`_${t}1`] !== void 0 ? c[`_${t}1`] : c[`_${t}`], d = r([l, u]);
    return o = o || l instanceof Date || u instanceof Date, r([s, d]);
  }, i);
  return o ? new Date(a) : a;
}
function $Qe(e, t, n) {
  if (!t.domainPadding)
    return e;
  const r = ud(t, n), i = ld(t, n), o = TQe(t, n);
  if (!o.left && !o.right)
    return e;
  const a = Ea(e), s = xa(e), c = Nte(n, t.horizontal), l = kr(t, c), u = Math.abs(l[0] - l[1]), d = Math.max(u - o.left - o.right, 1), f = Math.abs(s.valueOf() - a.valueOf()) / d * u, h = {
    left: f * o.left / u,
    right: f * o.right / u
  };
  let p = {
    min: a.valueOf() - h.left,
    max: s.valueOf() + h.right
  };
  const g = ni(t.singleQuadrantDomainPadding) ? t.singleQuadrantDomainPadding[n] : t.singleQuadrantDomainPadding, m = a.valueOf() >= 0 && p.min <= 0 || s.valueOf() <= 0 && p.max >= 0, v = (_, b) => b === "min" && a.valueOf() >= 0 && _ <= 0 || b === "max" && s.valueOf() <= 0 && _ >= 0 ? 0 : _;
  if (m && g !== !1) {
    const _ = {
      // @ts-expect-error `max/min` might be dates
      left: Math.abs(s - a) * o.left / u,
      // @ts-expect-error `max/min` might be dates
      right: Math.abs(s - a) * o.right / u
    }, b = {
      min: v(a.valueOf() - _.left, "min"),
      max: v(s.valueOf() + _.right, "max")
    }, w = {
      left: Math.abs(b.max - b.min) * o.left / u,
      right: Math.abs(b.max - b.min) * o.right / u
    };
    p = {
      min: v(a.valueOf() - w.left, "min"),
      max: v(s.valueOf() + w.right, "max")
    };
  }
  const y = {
    min: r !== void 0 ? r : p.min,
    max: i !== void 0 ? i : p.max
  };
  return a instanceof Date || s instanceof Date ? Ps(new Date(y.min), new Date(y.max)) : Ps(y.min, y.max);
}
function EC(e, t) {
  const n = Rn(e) ? e : J3, r = Rn(t) ? t : Q3;
  return (i, o) => {
    const a = Z3(i, o);
    if (a)
      return r(a, i, o);
    const s = X3(i, o), c = s ? AQe(i, o, s) : n(i, o);
    return c ? r(c, i, o) : void 0;
  };
}
function Q3(e, t, n) {
  return CQe($Qe(e, t, n), t, n);
}
function Mf(e, t) {
  return EC()(e, t);
}
function AQe(e, t, n) {
  const r = n || X3(e, t), {
    polar: i,
    startAngle: o = 0,
    endAngle: a = 360
  } = e;
  if (!r)
    return;
  const s = ud(e, t), c = ld(e, t), l = ww(r) ? lp(e, t) : [], u = l.length === 0 ? null : l.reduce((g, m, v) => (g[m] = v + 1, g), {}), d = u ? r.map((g) => u[g]) : r, f = s !== void 0 ? s : Ea(d), h = c !== void 0 ? c : xa(d), p = Ps(f, h);
  return i && t === "x" && Math.abs(o - a) === 360 ? ek(p, d) : p;
}
function J3(e, t, n) {
  const r = n || Do(e), {
    polar: i,
    startAngle: o = 0,
    endAngle: a = 360
  } = e, s = ud(e, t), c = ld(e, t);
  if (r.length < 1)
    return s !== void 0 && c !== void 0 ? Ps(s, c) : void 0;
  const l = s !== void 0 ? s : vV(r, t, "min"), u = c !== void 0 ? c : vV(r, t, "max"), d = Ps(l, u);
  return i && t === "x" && Math.abs(o - a) === 360 ? ek(d, IQe(r, t)) : d;
}
function Ps(e, t) {
  const n = (r) => {
    const i = (
      // eslint-disable-next-line no-magic-numbers
      r === 0 ? 2 * Math.pow(10, -10) : Math.pow(10, -10)
    ), o = 1, a = r instanceof Date ? new Date(Number(r) - o) : Number(r) - i, s = r instanceof Date ? new Date(Number(r) + o) : Number(r) + i;
    return r === 0 ? [0, s] : [a, s];
  };
  return Number(e) === Number(t) ? n(t) : [e, t];
}
function Z3(e, t) {
  const n = ud(e, t), r = ld(e, t);
  if (ni(e.domain) && e.domain[t])
    return e.domain[t];
  if (Array.isArray(e.domain))
    return e.domain;
  if (n !== void 0 && r !== void 0)
    return Ps(n, r);
}
function BR(e, t) {
  const n = Z3(e, t);
  if (n)
    return n;
  const r = Do(e), i = r.reduce((c, l) => l._y0 < c ? l._y0 : c, 1 / 0), o = (c) => {
    if (t === "x")
      return c;
    const l = i !== 1 / 0 ? i : 0, u = ld(e, t), d = ud(e, t), f = u !== void 0 ? u : xa(c, l), h = d !== void 0 ? d : Ea(c, l);
    return Ps(h, f);
  };
  return EC(() => J3(e, t, r), (c) => Q3(o(c), e, t))(e, t);
}
function ld(e, t) {
  return ni(e.maxDomain) && e.maxDomain[t] !== void 0 ? e.maxDomain[t] : typeof e.maxDomain == "number" || tne(e.maxDomain) ? e.maxDomain : void 0;
}
function ud(e, t) {
  return ni(e.minDomain) && e.minDomain[t] !== void 0 ? e.minDomain[t] : typeof e.minDomain == "number" || tne(e.minDomain) ? e.minDomain : void 0;
}
function ek(e, t) {
  const n = qKe(t.sort((i, o) => i - o)), r = n[1] - n[0];
  return [e[0], e[1] + r];
}
function fre(e) {
  const t = (i) => i && i.type ? i.type.role : "";
  let n = t(e);
  if (n === "portal") {
    const i = j.Children.toArray(e.props.children);
    n = i.length ? t(i[0]) : "";
  }
  return ["area", "axis", "bar", "boxplot", "candlestick", "errorbar", "group", "histogram", "line", "pie", "scatter", "stack", "voronoi"].includes(n);
}
function RQe(e) {
  return e;
}
function ns(e) {
  const {
    dependentAxis: t
  } = e;
  return t ? "y" : "x";
}
function hre(e, t) {
  const n = t || RQe, r = (i) => i.reduce((o, a) => a.type && a.type.role === "axis" && n(a) ? o.concat(a) : a.props && a.props.children ? o.concat(r(j.Children.toArray(a.props.children))) : o, []);
  return r(e);
}
function gre(e, t) {
  return hre(e, (r) => r.type.getAxis(r.props) === t)[0];
}
function yV(e, t) {
  const n = (i) => t === "dependent" ? i.props.dependentAxis : !i.props.dependentAxis, r = (i) => i.reduce((o, a) => a.type && a.type.role === "axis" && n(a) || a.props && a.props.children && r(j.Children.toArray(a.props.children)).length > 0 ? o.concat(a) : o, []);
  return r(e);
}
function pre(e) {
  const t = (n) => {
    const r = Math.min(...n), i = Math.max(...n);
    return i < 0 ? i : Math.max(0, r);
  };
  return {
    x: Fu(e.x) ? new Date(Math.min(...e.x)) : t(e.x),
    y: Fu(e.y) ? new Date(Math.min(...e.y)) : t(e.y)
  };
}
function bV(e, t) {
  const n = () => e <= 0 && Math.max(...t) <= 0 ? "negative" : "positive";
  return Fu(t) ? "positive" : n();
}
function CC(e) {
  const t = e.orientation || (e.dependentAxis ? "left" : "bottom");
  return {
    top: !1,
    bottom: !1,
    left: !0,
    right: !0
  }[t];
}
function TC(e) {
  return e.tickValues !== void 0 && ww(e.tickValues);
}
function PQe(e) {
  const {
    tickValues: t
  } = e, n = ns(e), r = e.stringMap && e.stringMap[n], i = t && !Fu(t) ? (l) => l : void 0;
  if (!r)
    return TC(e) ? (l, u) => t[u] : i;
  const o = r && Mte(r), c = ["", ...zy(Object.values(r), (l) => l).map((l) => o[l]), ""];
  return (l) => c[l];
}
function OQe(e) {
  const t = ns(e), n = e.stringMap && e.stringMap[t], r = Array.isArray(e.categories) ? e.categories : e.categories && e.categories[t], i = r && vGe(r) ? r.map((a) => n[a]) : void 0, o = n && Object.values(n);
  return i && i.length !== 0 ? i : o;
}
function tk(e) {
  const {
    tickValues: t,
    tickFormat: n
  } = e;
  if ((t == null ? void 0 : t.length) === 0)
    return [];
  const r = ns(e), i = e.stringMap && e.stringMap[r], o = () => {
    if (!(!n || !Array.isArray(n)))
      return ww(n) ? n.map((l, u) => u) : n;
  };
  let a = t;
  i && (a = OQe(e)), t && ww(t) && (a = i ? t.map((l) => i[l]) : w3(1, t.length + 1));
  const s = a ? bl(a) : o(), c = (l) => {
    const u = [], d = e.domain && e.domain[r] || e.domain;
    if (l)
      return l.forEach((f, h) => {
        Array.isArray(d) ? f >= Ea(d).valueOf() && f <= xa(d).valueOf() && u.push({
          value: f,
          index: h
        }) : u.push({
          value: f,
          index: h
        });
      }), u;
  };
  return Array.isArray(s) && s.length ? c(s) : void 0;
}
function mre(e, t) {
  const {
    tickFormat: n
  } = e, r = ns(e), i = e.stringMap && e.stringMap[r];
  if (n) {
    if (n && Array.isArray(n)) {
      const o = tk(e), a = o == null ? void 0 : o.map((c) => c.index), s = n.filter((c, l) => a == null ? void 0 : a.includes(l));
      return (c, l) => s[l];
    } else if (n && Rn(n))
      return i ? (a, s, c) => {
        const l = Mte(i), u = c.map((d) => l[d]);
        return e.tickFormat(l[a], s, u);
      } : n;
  } else {
    const o = PQe(e), a = t.tickFormat && Rn(t.tickFormat) ? t.tickFormat() : (s) => s;
    return o || a;
  }
  return (o) => o;
}
function _V(e, t) {
  if (!t || !Array.isArray(e) || e.length <= t)
    return e;
  const n = Math.floor(e.length / t);
  return e.filter((r, i) => i % n === 0);
}
function vre(e, t, n) {
  n === void 0 && (n = !1);
  const {
    tickCount: r
  } = e, i = tk(e);
  if ((i == null ? void 0 : i.length) === 0)
    return [""];
  const o = i ? i.map((a) => a.value) : void 0;
  if (o)
    return _V(o, r);
  if (t.ticks && Rn(t.ticks)) {
    const a = r || 5, s = t.ticks(a), c = Array.isArray(s) && s.length ? s : t.domain(), l = _V(c, r);
    if (n) {
      const u = l.filter((d) => d !== 0);
      return u.length ? u : l;
    }
    return l;
  }
  return t.domain();
}
function MQe(e, t) {
  const {
    polar: n,
    startAngle: r = 0,
    endAngle: i = 360
  } = e, o = tk(e), a = o && (o == null ? void 0 : o.length) !== 0 ? o.map((v) => v.value) : void 0;
  if (!Array.isArray(a))
    return;
  const s = ud(e, t), c = ld(e, t), l = TC(e), u = a.map((v) => Number(v)), d = l ? 1 : Ea(u), f = l ? a.length : xa(u), g = Ps(s !== void 0 ? s : d, c !== void 0 ? c : f), m = n && t === "x" && Math.abs(r - i) === 360 ? ek(g, u) : g;
  return CC(e) && !n && m.reverse(), m;
}
function om(e, t) {
  const n = ns(e);
  if (!(t && t !== n))
    return EC(MQe)(e, n);
}
function yre(e, t) {
  if (!e.axisValue)
    return;
  const n = t === "x" ? "y" : "x", r = _$(e.scale) && Rn(e.scale[n]) ? e.scale[n] : void 0;
  if (!r)
    return;
  const i = t === "x" ? "y" : "x", o = _$(e.stringMap) && e.stringMap[i], a = o && typeof e.axisValue == "string" ? o[e.axisValue] : e.axisValue;
  return r(a);
}
function IC(e, t) {
  if (!_$(e.theme))
    return wr(e, t, "axis");
  let n = "axis";
  if (e.dependentAxis && e.theme.dependentAxis ? n = "dependentAxis" : !e.dependentAxis && e.theme.independentAxis && (n = "independentAxis"), n === "axis")
    return wr(e, t, "axis");
  const r = qe({}, e.theme[n], e.theme.axis), i = Object.assign({}, e.theme, {
    axis: r
  });
  return wr(Object.assign({}, e, {
    theme: i
  }), t, "axis");
}
function kQe() {
  return {
    onLoad: {
      duration: 2e3
    },
    onExit: {
      duration: 500
    },
    onEnter: {
      duration: 500
    }
  };
}
function NQe() {
  return {
    onLoad: {
      duration: 2e3,
      before: () => ({
        _y: 0,
        _y1: 0,
        _y0: 0
      }),
      after: (e) => ({
        _y: e._y,
        _y1: e._y1,
        _y0: e._y0
      })
    },
    onExit: {
      duration: 500,
      before: (e, t, n) => {
        const r = (i) => (t === 0 ? n[t + 1] : n[t - 1])[i];
        return {
          _x: r("_x"),
          _y: r("_y"),
          _y0: r("_y0")
        };
      }
    },
    onEnter: {
      duration: 500,
      before: (e, t, n) => {
        const r = (i) => (t === 0 ? n[t + 1] : n[t - 1])[i];
        return {
          _x: r("_x"),
          _y: r("_y"),
          _y0: r("_y0")
        };
      },
      after: (e) => ({
        _x: e._x,
        _y: e._y,
        _y1: e._y1,
        _y0: e._y0
      })
    }
  };
}
function bre() {
  return {
    onLoad: {
      duration: 2e3,
      before: () => ({
        opacity: 0
      }),
      after: (e) => e
    },
    onExit: {
      duration: 600,
      before: () => ({
        opacity: 0
      })
    },
    onEnter: {
      duration: 600,
      before: () => ({
        opacity: 0
      }),
      after: (e) => e
    }
  };
}
function nk(e) {
  const t = j.useRef();
  return j.useEffect(() => {
    t.current = e;
  }), t.current;
}
const DQe = {
  nodesShouldLoad: !1,
  nodesDoneLoad: !1,
  animating: !0
}, rk = function(e) {
  e === void 0 && (e = DQe);
  const [t, n] = j.useState(e), r = j.useCallback((s) => {
    n((c) => ({
      ...c,
      ...s
    }));
  }, [n]), i = j.useCallback((s, c, l) => {
    if (!(s != null && s.animate))
      return c.props.animate;
    const u = () => {
      let p = t && t.childrenTransitions;
      return p = k9(p) ? p[l] : p, qe({
        childrenTransitions: p
      }, t);
    };
    let d = s.animate && s.animate.getTransitions;
    const f = u(), h = s.animate && s.animate.parentState || f;
    if (!d) {
      const p = Vte(s, f, (g) => r(g));
      d = (g) => p(g, l);
    }
    return qe({
      getTransitions: d,
      parentState: h
    }, s.animate, c.props.animate);
  }, [t, r]), o = j.useCallback((s, c) => {
    if (s != null && s.animate)
      if (s.animate.parentState) {
        const u = s.animate.parentState.nodesWillExit ? s : null, d = qe({
          oldProps: u,
          nextProps: c
        }, s.animate.parentState);
        r(d);
      } else {
        const l = j.Children.toArray(s.children), u = j.Children.toArray(c.children), d = (v) => {
          const y = (_) => _.type && _.type.continuous;
          return Array.isArray(v) ? v.some(y) : y(v);
        }, f = !s.polar && l.some((v) => {
          var y;
          return d(v) || ((y = v == null ? void 0 : v.props) == null ? void 0 : y.children) && d(v.props.children);
        }), {
          nodesWillExit: h,
          nodesWillEnter: p,
          childrenTransitions: g,
          nodesShouldEnter: m
        } = Fte(l, u);
        r({
          nodesWillExit: h,
          nodesWillEnter: p,
          nodesShouldEnter: m,
          childrenTransitions: k9(g) ? g[0] : g,
          oldProps: h ? s : void 0,
          nextProps: c,
          continuous: f
        });
      }
  }, [r]), a = j.useCallback((s) => t && t.nodesWillExit && t.oldProps || s, [t]);
  return {
    state: t,
    setState: r,
    getAnimationProps: i,
    setAnimationState: o,
    getProps: a
  };
};
function jQe(e, t) {
  t === void 0 && (t = {});
  const n = t._y >= 0 ? 1 : -1, r = e.style && e.style.labels || {};
  return t.verticalAnchor || r.verticalAnchor ? t.verticalAnchor || r.verticalAnchor : e.horizontal ? "middle" : n >= 0 ? "end" : "start";
}
function LQe(e, t) {
  t === void 0 && (t = {});
  const {
    style: n,
    horizontal: r
  } = e, i = t._y >= 0 ? 1 : -1, o = n && n.labels || {};
  return t.verticalAnchor || o.verticalAnchor ? t.verticalAnchor || o.verticalAnchor : r ? i >= 0 ? "start" : "end" : "middle";
}
function FQe(e, t) {
  t === void 0 && (t = {});
  const n = e.style && e.style.labels || {};
  return t.angle === void 0 ? n.angle : t.angle;
}
function VQe(e, t) {
  t === void 0 && (t = {});
  const {
    horizontal: n,
    style: r
  } = e, i = r.labels || {}, o = Fe(i.padding, e) || 0, a = t._y < 0 ? -1 : 1;
  return {
    x: n ? a * o : 0,
    y: n ? 0 : -1 * a * o
  };
}
function BQe(e, t) {
  if (e.polar)
    return {};
  const n = VQe(e, t);
  return {
    dx: n.x,
    dy: n.y
  };
}
function zQe(e, t) {
  const {
    polar: n
  } = e, {
    x: r,
    y: i
  } = Hy(e, t);
  if (!n)
    return {
      x: r,
      y: i
    };
  const o = HQe(e, t);
  return {
    x: r + o.x,
    y: i + o.y
  };
}
function HQe(e, t) {
  const {
    style: n
  } = e, r = Uv(e, t), i = n.labels || {}, o = Fe(i.padding, e) || 0, a = pr(r);
  return {
    x: o * Math.cos(a),
    y: -o * Math.sin(a)
  };
}
function ik(e) {
  const {
    labelComponent: t,
    labelPlacement: n,
    polar: r
  } = e, i = r ? "perpendicular" : "vertical";
  return n || t.props && t.props.labelPlacement || i;
}
function UQe(e) {
  return e < 45 || e > 315 ? "right" : e >= 45 && e <= 135 ? "top" : e > 135 && e < 225 ? "left" : "bottom";
}
function Qy(e, t, n) {
  return t === void 0 && (t = {}), t.label !== void 0 ? t.label : Array.isArray(e.labels) ? e.labels[n] : e.labels;
}
function ok(e, t) {
  const n = ik(e);
  return n === "perpendicular" || n === "vertical" && (t === 90 || t === 270) ? "middle" : t <= 90 || t > 270 ? "start" : "end";
}
function _re(e, t) {
  const n = ik(e), r = UQe(t);
  return n === "parallel" || r === "left" || r === "right" ? "middle" : r === "top" ? "end" : "start";
}
function ak(e, t) {
  const {
    labelPlacement: n,
    datum: r
  } = e;
  if (!n || n === "vertical")
    return 0;
  const i = t !== void 0 ? t % 360 : Uv(e, r), o = i > 90 && i < 180 || i > 270 ? 1 : -1;
  let a = 0;
  return i === 0 || i === 180 ? a = 90 : i > 0 && i < 180 ? a = 90 - i : i > 180 && i < 360 && (a = 270 - i), a + o * (n === "perpendicular" ? 0 : 90);
}
function Uv(e, t) {
  const {
    x: n
  } = kte(t);
  return ol(e.scale.x(n)) % 360;
}
function sk(e, t) {
  const {
    scale: n,
    data: r,
    style: i,
    horizontal: o,
    polar: a,
    width: s,
    height: c,
    theme: l,
    labelComponent: u,
    disableInlineStyles: d
  } = e, f = r[t], h = Uv(e, f), p = a ? ok(e, h) : LQe(e, f), g = a ? _re(e, h) : jQe(e, f), m = FQe(e, f), v = Qy(e, f, t), y = ik(e), {
    x: _,
    y: b
  } = zQe(e, f), {
    dx: w,
    dy: C
  } = BQe(e, f), x = {
    angle: m,
    data: r,
    datum: f,
    disableInlineStyles: d,
    horizontal: o,
    index: t,
    polar: a,
    scale: n,
    labelPlacement: y,
    text: v,
    textAnchor: p,
    verticalAnchor: g,
    x: _,
    y: b,
    dx: w,
    dy: C,
    width: s,
    height: c,
    style: i.labels
  };
  if (!pC(u))
    return x;
  const T = l && l.tooltip || {};
  return qe({}, x, Jf(T, ["style"]));
}
function on(e) {
  return function() {
    return e;
  };
}
const SV = Math.abs, to = Math.atan2, qc = Math.cos, WQe = Math.max, vg = Math.min, Go = Math.sin, _r = Math.sqrt, io = 1e-12, Vu = Math.PI, jw = Vu / 2, bu = 2 * Vu;
function qQe(e) {
  return e > 1 ? 0 : e < -1 ? Vu : Math.acos(e);
}
function wV(e) {
  return e >= 1 ? jw : e <= -1 ? -jw : Math.asin(e);
}
const zR = Math.PI, HR = 2 * zR, Td = 1e-6, GQe = HR - Td;
function Sre(e) {
  this._ += e[0];
  for (let t = 1, n = e.length; t < n; ++t)
    this._ += arguments[t] + e[t];
}
function KQe(e) {
  let t = Math.floor(e);
  if (!(t >= 0))
    throw new Error(`invalid digits: ${e}`);
  if (t > 15)
    return Sre;
  const n = 10 ** t;
  return function(r) {
    this._ += r[0];
    for (let i = 1, o = r.length; i < o; ++i)
      this._ += Math.round(arguments[i] * n) / n + r[i];
  };
}
let YQe = class {
  constructor(t) {
    this._x0 = this._y0 = // start of current subpath
    this._x1 = this._y1 = null, this._ = "", this._append = t == null ? Sre : KQe(t);
  }
  moveTo(t, n) {
    this._append`M${this._x0 = this._x1 = +t},${this._y0 = this._y1 = +n}`;
  }
  closePath() {
    this._x1 !== null && (this._x1 = this._x0, this._y1 = this._y0, this._append`Z`);
  }
  lineTo(t, n) {
    this._append`L${this._x1 = +t},${this._y1 = +n}`;
  }
  quadraticCurveTo(t, n, r, i) {
    this._append`Q${+t},${+n},${this._x1 = +r},${this._y1 = +i}`;
  }
  bezierCurveTo(t, n, r, i, o, a) {
    this._append`C${+t},${+n},${+r},${+i},${this._x1 = +o},${this._y1 = +a}`;
  }
  arcTo(t, n, r, i, o) {
    if (t = +t, n = +n, r = +r, i = +i, o = +o, o < 0)
      throw new Error(`negative radius: ${o}`);
    let a = this._x1, s = this._y1, c = r - t, l = i - n, u = a - t, d = s - n, f = u * u + d * d;
    if (this._x1 === null)
      this._append`M${this._x1 = t},${this._y1 = n}`;
    else if (f > Td)
      if (!(Math.abs(d * c - l * u) > Td) || !o)
        this._append`L${this._x1 = t},${this._y1 = n}`;
      else {
        let h = r - a, p = i - s, g = c * c + l * l, m = h * h + p * p, v = Math.sqrt(g), y = Math.sqrt(f), _ = o * Math.tan((zR - Math.acos((g + f - m) / (2 * v * y))) / 2), b = _ / y, w = _ / v;
        Math.abs(b - 1) > Td && this._append`L${t + b * u},${n + b * d}`, this._append`A${o},${o},0,0,${+(d * h > u * p)},${this._x1 = t + w * c},${this._y1 = n + w * l}`;
      }
  }
  arc(t, n, r, i, o, a) {
    if (t = +t, n = +n, r = +r, a = !!a, r < 0)
      throw new Error(`negative radius: ${r}`);
    let s = r * Math.cos(i), c = r * Math.sin(i), l = t + s, u = n + c, d = 1 ^ a, f = a ? i - o : o - i;
    this._x1 === null ? this._append`M${l},${u}` : (Math.abs(this._x1 - l) > Td || Math.abs(this._y1 - u) > Td) && this._append`L${l},${u}`, r && (f < 0 && (f = f % HR + HR), f > GQe ? this._append`A${r},${r},0,1,${d},${t - s},${n - c}A${r},${r},0,1,${d},${this._x1 = l},${this._y1 = u}` : f > Td && this._append`A${r},${r},0,${+(f >= zR)},${d},${this._x1 = t + r * Math.cos(o)},${this._y1 = n + r * Math.sin(o)}`);
  }
  rect(t, n, r, i) {
    this._append`M${this._x0 = this._x1 = +t},${this._y0 = this._y1 = +n}h${r = +r}v${+i}h${-r}Z`;
  }
  toString() {
    return this._;
  }
};
function Jy(e) {
  let t = 3;
  return e.digits = function(n) {
    if (!arguments.length)
      return t;
    if (n == null)
      t = null;
    else {
      const r = Math.floor(n);
      if (!(r >= 0))
        throw new RangeError(`invalid digits: ${n}`);
      t = r;
    }
    return e;
  }, () => new YQe(t);
}
function XQe(e) {
  return e.innerRadius;
}
function QQe(e) {
  return e.outerRadius;
}
function JQe(e) {
  return e.startAngle;
}
function ZQe(e) {
  return e.endAngle;
}
function eJe(e) {
  return e && e.padAngle;
}
function tJe(e, t, n, r, i, o, a, s) {
  var c = n - e, l = r - t, u = a - i, d = s - o, f = d * c - u * l;
  if (!(f * f < io))
    return f = (u * (t - o) - d * (e - i)) / f, [e + f * c, t + f * l];
}
function E1(e, t, n, r, i, o, a) {
  var s = e - n, c = t - r, l = (a ? o : -o) / _r(s * s + c * c), u = l * c, d = -l * s, f = e + u, h = t + d, p = n + u, g = r + d, m = (f + p) / 2, v = (h + g) / 2, y = p - f, _ = g - h, b = y * y + _ * _, w = i - o, C = f * g - p * h, x = (_ < 0 ? -1 : 1) * _r(WQe(0, w * w * b - C * C)), T = (C * _ - y * x) / b, E = (-C * y - _ * x) / b, R = (C * _ + y * x) / b, I = (-C * y + _ * x) / b, O = T - m, P = E - v, k = R - m, L = I - v;
  return O * O + P * P > k * k + L * L && (T = R, E = I), {
    cx: T,
    cy: E,
    x01: -u,
    y01: -d,
    x11: T * (i / w - 1),
    y11: E * (i / w - 1)
  };
}
function $C() {
  var e = XQe, t = QQe, n = on(0), r = null, i = JQe, o = ZQe, a = eJe, s = null, c = Jy(l);
  function l() {
    var u, d, f = +e.apply(this, arguments), h = +t.apply(this, arguments), p = i.apply(this, arguments) - jw, g = o.apply(this, arguments) - jw, m = SV(g - p), v = g > p;
    if (s || (s = u = c()), h < f && (d = h, h = f, f = d), !(h > io))
      s.moveTo(0, 0);
    else if (m > bu - io)
      s.moveTo(h * qc(p), h * Go(p)), s.arc(0, 0, h, p, g, !v), f > io && (s.moveTo(f * qc(g), f * Go(g)), s.arc(0, 0, f, g, p, v));
    else {
      var y = p, _ = g, b = p, w = g, C = m, x = m, T = a.apply(this, arguments) / 2, E = T > io && (r ? +r.apply(this, arguments) : _r(f * f + h * h)), R = vg(SV(h - f) / 2, +n.apply(this, arguments)), I = R, O = R, P, k;
      if (E > io) {
        var L = wV(E / f * Go(T)), N = wV(E / h * Go(T));
        (C -= L * 2) > io ? (L *= v ? 1 : -1, b += L, w -= L) : (C = 0, b = w = (p + g) / 2), (x -= N * 2) > io ? (N *= v ? 1 : -1, y += N, _ -= N) : (x = 0, y = _ = (p + g) / 2);
      }
      var D = h * qc(y), z = h * Go(y), V = f * qc(w), B = f * Go(w);
      if (R > io) {
        var U = h * qc(_), Q = h * Go(_), Y = f * qc(b), q = f * Go(b), X;
        if (m < Vu)
          if (X = tJe(D, z, Y, q, U, Q, V, B)) {
            var ne = D - X[0], Z = z - X[1], J = U - X[0], K = Q - X[1], ee = 1 / Go(qQe((ne * J + Z * K) / (_r(ne * ne + Z * Z) * _r(J * J + K * K))) / 2), te = _r(X[0] * X[0] + X[1] * X[1]);
            I = vg(R, (f - te) / (ee - 1)), O = vg(R, (h - te) / (ee + 1));
          } else
            I = O = 0;
      }
      x > io ? O > io ? (P = E1(Y, q, D, z, h, O, v), k = E1(U, Q, V, B, h, O, v), s.moveTo(P.cx + P.x01, P.cy + P.y01), O < R ? s.arc(P.cx, P.cy, O, to(P.y01, P.x01), to(k.y01, k.x01), !v) : (s.arc(P.cx, P.cy, O, to(P.y01, P.x01), to(P.y11, P.x11), !v), s.arc(0, 0, h, to(P.cy + P.y11, P.cx + P.x11), to(k.cy + k.y11, k.cx + k.x11), !v), s.arc(k.cx, k.cy, O, to(k.y11, k.x11), to(k.y01, k.x01), !v))) : (s.moveTo(D, z), s.arc(0, 0, h, y, _, !v)) : s.moveTo(D, z), !(f > io) || !(C > io) ? s.lineTo(V, B) : I > io ? (P = E1(V, B, U, Q, f, -I, v), k = E1(D, z, Y, q, f, -I, v), s.lineTo(P.cx + P.x01, P.cy + P.y01), I < R ? s.arc(P.cx, P.cy, I, to(P.y01, P.x01), to(k.y01, k.x01), !v) : (s.arc(P.cx, P.cy, I, to(P.y01, P.x01), to(P.y11, P.x11), !v), s.arc(0, 0, f, to(P.cy + P.y11, P.cx + P.x11), to(k.cy + k.y11, k.cx + k.x11), v), s.arc(k.cx, k.cy, I, to(k.y11, k.x11), to(k.y01, k.x01), !v))) : s.arc(0, 0, f, w, b, v);
    }
    if (s.closePath(), u)
      return s = null, u + "" || null;
  }
  return l.centroid = function() {
    var u = (+e.apply(this, arguments) + +t.apply(this, arguments)) / 2, d = (+i.apply(this, arguments) + +o.apply(this, arguments)) / 2 - Vu / 2;
    return [qc(d) * u, Go(d) * u];
  }, l.innerRadius = function(u) {
    return arguments.length ? (e = typeof u == "function" ? u : on(+u), l) : e;
  }, l.outerRadius = function(u) {
    return arguments.length ? (t = typeof u == "function" ? u : on(+u), l) : t;
  }, l.cornerRadius = function(u) {
    return arguments.length ? (n = typeof u == "function" ? u : on(+u), l) : n;
  }, l.padRadius = function(u) {
    return arguments.length ? (r = u == null ? null : typeof u == "function" ? u : on(+u), l) : r;
  }, l.startAngle = function(u) {
    return arguments.length ? (i = typeof u == "function" ? u : on(+u), l) : i;
  }, l.endAngle = function(u) {
    return arguments.length ? (o = typeof u == "function" ? u : on(+u), l) : o;
  }, l.padAngle = function(u) {
    return arguments.length ? (a = typeof u == "function" ? u : on(+u), l) : a;
  }, l.context = function(u) {
    return arguments.length ? (s = u ?? null, l) : s;
  }, l;
}
var nJe = Array.prototype.slice;
function AC(e) {
  return typeof e == "object" && "length" in e ? e : Array.from(e);
}
function wre(e) {
  this._context = e;
}
wre.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
      default:
        this._context.lineTo(e, t);
        break;
    }
  }
};
function am(e) {
  return new wre(e);
}
function ck(e) {
  return e[0];
}
function lk(e) {
  return e[1];
}
function RC(e, t) {
  var n = on(!0), r = null, i = am, o = null, a = Jy(s);
  e = typeof e == "function" ? e : e === void 0 ? ck : on(e), t = typeof t == "function" ? t : t === void 0 ? lk : on(t);
  function s(c) {
    var l, u = (c = AC(c)).length, d, f = !1, h;
    for (r == null && (o = i(h = a())), l = 0; l <= u; ++l)
      !(l < u && n(d = c[l], l, c)) === f && ((f = !f) ? o.lineStart() : o.lineEnd()), f && o.point(+e(d, l, c), +t(d, l, c));
    if (h)
      return o = null, h + "" || null;
  }
  return s.x = function(c) {
    return arguments.length ? (e = typeof c == "function" ? c : on(+c), s) : e;
  }, s.y = function(c) {
    return arguments.length ? (t = typeof c == "function" ? c : on(+c), s) : t;
  }, s.defined = function(c) {
    return arguments.length ? (n = typeof c == "function" ? c : on(!!c), s) : n;
  }, s.curve = function(c) {
    return arguments.length ? (i = c, r != null && (o = i(r)), s) : i;
  }, s.context = function(c) {
    return arguments.length ? (c == null ? r = o = null : o = i(r = c), s) : r;
  }, s;
}
function xre(e, t, n) {
  var r = null, i = on(!0), o = null, a = am, s = null, c = Jy(l);
  e = typeof e == "function" ? e : e === void 0 ? ck : on(+e), t = typeof t == "function" ? t : on(t === void 0 ? 0 : +t), n = typeof n == "function" ? n : n === void 0 ? lk : on(+n);
  function l(d) {
    var f, h, p, g = (d = AC(d)).length, m, v = !1, y, _ = new Array(g), b = new Array(g);
    for (o == null && (s = a(y = c())), f = 0; f <= g; ++f) {
      if (!(f < g && i(m = d[f], f, d)) === v)
        if (v = !v)
          h = f, s.areaStart(), s.lineStart();
        else {
          for (s.lineEnd(), s.lineStart(), p = f - 1; p >= h; --p)
            s.point(_[p], b[p]);
          s.lineEnd(), s.areaEnd();
        }
      v && (_[f] = +e(m, f, d), b[f] = +t(m, f, d), s.point(r ? +r(m, f, d) : _[f], n ? +n(m, f, d) : b[f]));
    }
    if (y)
      return s = null, y + "" || null;
  }
  function u() {
    return RC().defined(i).curve(a).context(o);
  }
  return l.x = function(d) {
    return arguments.length ? (e = typeof d == "function" ? d : on(+d), r = null, l) : e;
  }, l.x0 = function(d) {
    return arguments.length ? (e = typeof d == "function" ? d : on(+d), l) : e;
  }, l.x1 = function(d) {
    return arguments.length ? (r = d == null ? null : typeof d == "function" ? d : on(+d), l) : r;
  }, l.y = function(d) {
    return arguments.length ? (t = typeof d == "function" ? d : on(+d), n = null, l) : t;
  }, l.y0 = function(d) {
    return arguments.length ? (t = typeof d == "function" ? d : on(+d), l) : t;
  }, l.y1 = function(d) {
    return arguments.length ? (n = d == null ? null : typeof d == "function" ? d : on(+d), l) : n;
  }, l.lineX0 = l.lineY0 = function() {
    return u().x(e).y(t);
  }, l.lineY1 = function() {
    return u().x(e).y(n);
  }, l.lineX1 = function() {
    return u().x(r).y(t);
  }, l.defined = function(d) {
    return arguments.length ? (i = typeof d == "function" ? d : on(!!d), l) : i;
  }, l.curve = function(d) {
    return arguments.length ? (a = d, o != null && (s = a(o)), l) : a;
  }, l.context = function(d) {
    return arguments.length ? (d == null ? o = s = null : s = a(o = d), l) : o;
  }, l;
}
function rJe(e, t) {
  return t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
}
function iJe(e) {
  return e;
}
function Ere() {
  var e = iJe, t = rJe, n = null, r = on(0), i = on(bu), o = on(0);
  function a(s) {
    var c, l = (s = AC(s)).length, u, d, f = 0, h = new Array(l), p = new Array(l), g = +r.apply(this, arguments), m = Math.min(bu, Math.max(-bu, i.apply(this, arguments) - g)), v, y = Math.min(Math.abs(m) / l, o.apply(this, arguments)), _ = y * (m < 0 ? -1 : 1), b;
    for (c = 0; c < l; ++c)
      (b = p[h[c] = c] = +e(s[c], c, s)) > 0 && (f += b);
    for (t != null ? h.sort(function(w, C) {
      return t(p[w], p[C]);
    }) : n != null && h.sort(function(w, C) {
      return n(s[w], s[C]);
    }), c = 0, d = f ? (m - l * _) / f : 0; c < l; ++c, g = v)
      u = h[c], b = p[u], v = g + (b > 0 ? b * d : 0) + _, p[u] = {
        data: s[u],
        index: c,
        value: b,
        startAngle: g,
        endAngle: v,
        padAngle: y
      };
    return p;
  }
  return a.value = function(s) {
    return arguments.length ? (e = typeof s == "function" ? s : on(+s), a) : e;
  }, a.sortValues = function(s) {
    return arguments.length ? (t = s, n = null, a) : t;
  }, a.sort = function(s) {
    return arguments.length ? (n = s, t = null, a) : n;
  }, a.startAngle = function(s) {
    return arguments.length ? (r = typeof s == "function" ? s : on(+s), a) : r;
  }, a.endAngle = function(s) {
    return arguments.length ? (i = typeof s == "function" ? s : on(+s), a) : i;
  }, a.padAngle = function(s) {
    return arguments.length ? (o = typeof s == "function" ? s : on(+s), a) : o;
  }, a;
}
var Cre = uk(am);
function Tre(e) {
  this._curve = e;
}
Tre.prototype = {
  areaStart: function() {
    this._curve.areaStart();
  },
  areaEnd: function() {
    this._curve.areaEnd();
  },
  lineStart: function() {
    this._curve.lineStart();
  },
  lineEnd: function() {
    this._curve.lineEnd();
  },
  point: function(e, t) {
    this._curve.point(t * Math.sin(e), t * -Math.cos(e));
  }
};
function uk(e) {
  function t(n) {
    return new Tre(e(n));
  }
  return t._curve = e, t;
}
function h0(e) {
  var t = e.curve;
  return e.angle = e.x, delete e.x, e.radius = e.y, delete e.y, e.curve = function(n) {
    return arguments.length ? t(uk(n)) : t()._curve;
  }, e;
}
function UR() {
  return h0(RC().curve(Cre));
}
function xV() {
  var e = xre().curve(Cre), t = e.curve, n = e.lineX0, r = e.lineX1, i = e.lineY0, o = e.lineY1;
  return e.angle = e.x, delete e.x, e.startAngle = e.x0, delete e.x0, e.endAngle = e.x1, delete e.x1, e.radius = e.y, delete e.y, e.innerRadius = e.y0, delete e.y0, e.outerRadius = e.y1, delete e.y1, e.lineStartAngle = function() {
    return h0(n());
  }, delete e.lineX0, e.lineEndAngle = function() {
    return h0(r());
  }, delete e.lineX1, e.lineInnerRadius = function() {
    return h0(i());
  }, delete e.lineY0, e.lineOuterRadius = function() {
    return h0(o());
  }, delete e.lineY1, e.curve = function(a) {
    return arguments.length ? t(uk(a)) : t()._curve;
  }, e;
}
function g0(e, t) {
  return [(t = +t) * Math.cos(e -= Math.PI / 2), t * Math.sin(e)];
}
class Ire {
  constructor(t, n) {
    this._context = t, this._x = n;
  }
  areaStart() {
    this._line = 0;
  }
  areaEnd() {
    this._line = NaN;
  }
  lineStart() {
    this._point = 0;
  }
  lineEnd() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  }
  point(t, n) {
    switch (t = +t, n = +n, this._point) {
      case 0: {
        this._point = 1, this._line ? this._context.lineTo(t, n) : this._context.moveTo(t, n);
        break;
      }
      case 1:
        this._point = 2;
      default: {
        this._x ? this._context.bezierCurveTo(this._x0 = (this._x0 + t) / 2, this._y0, this._x0, n, t, n) : this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + n) / 2, t, this._y0, t, n);
        break;
      }
    }
    this._x0 = t, this._y0 = n;
  }
}
class oJe {
  constructor(t) {
    this._context = t;
  }
  lineStart() {
    this._point = 0;
  }
  lineEnd() {
  }
  point(t, n) {
    if (t = +t, n = +n, this._point === 0)
      this._point = 1;
    else {
      const r = g0(this._x0, this._y0), i = g0(this._x0, this._y0 = (this._y0 + n) / 2), o = g0(t, this._y0), a = g0(t, n);
      this._context.moveTo(...r), this._context.bezierCurveTo(...i, ...o, ...a);
    }
    this._x0 = t, this._y0 = n;
  }
}
function $re(e) {
  return new Ire(e, !0);
}
function Are(e) {
  return new Ire(e, !1);
}
function aJe(e) {
  return new oJe(e);
}
function sJe(e) {
  return e.source;
}
function cJe(e) {
  return e.target;
}
function PC(e) {
  let t = sJe, n = cJe, r = ck, i = lk, o = null, a = null, s = Jy(c);
  function c() {
    let l;
    const u = nJe.call(arguments), d = t.apply(this, u), f = n.apply(this, u);
    if (o == null && (a = e(l = s())), a.lineStart(), u[0] = d, a.point(+r.apply(this, u), +i.apply(this, u)), u[0] = f, a.point(+r.apply(this, u), +i.apply(this, u)), a.lineEnd(), l)
      return a = null, l + "" || null;
  }
  return c.source = function(l) {
    return arguments.length ? (t = l, c) : t;
  }, c.target = function(l) {
    return arguments.length ? (n = l, c) : n;
  }, c.x = function(l) {
    return arguments.length ? (r = typeof l == "function" ? l : on(+l), c) : r;
  }, c.y = function(l) {
    return arguments.length ? (i = typeof l == "function" ? l : on(+l), c) : i;
  }, c.context = function(l) {
    return arguments.length ? (l == null ? o = a = null : a = e(o = l), c) : o;
  }, c;
}
function lJe() {
  return PC($re);
}
function uJe() {
  return PC(Are);
}
function dJe() {
  const e = PC(aJe);
  return e.angle = e.x, delete e.x, e.radius = e.y, delete e.y, e;
}
const fJe = _r(3), Rre = {
  draw(e, t) {
    const n = _r(t + vg(t / 28, 0.75)) * 0.59436, r = n / 2, i = r * fJe;
    e.moveTo(0, n), e.lineTo(0, -n), e.moveTo(-i, -r), e.lineTo(i, r), e.moveTo(-i, r), e.lineTo(i, -r);
  }
}, OC = {
  draw(e, t) {
    const n = _r(t / Vu);
    e.moveTo(n, 0), e.arc(0, 0, n, 0, bu);
  }
}, Pre = {
  draw(e, t) {
    const n = _r(t / 5) / 2;
    e.moveTo(-3 * n, -n), e.lineTo(-n, -n), e.lineTo(-n, -3 * n), e.lineTo(n, -3 * n), e.lineTo(n, -n), e.lineTo(3 * n, -n), e.lineTo(3 * n, n), e.lineTo(n, n), e.lineTo(n, 3 * n), e.lineTo(-n, 3 * n), e.lineTo(-n, n), e.lineTo(-3 * n, n), e.closePath();
  }
}, Ore = _r(1 / 3), hJe = Ore * 2, Mre = {
  draw(e, t) {
    const n = _r(t / hJe), r = n * Ore;
    e.moveTo(0, -n), e.lineTo(r, 0), e.lineTo(0, n), e.lineTo(-r, 0), e.closePath();
  }
}, kre = {
  draw(e, t) {
    const n = _r(t) * 0.62625;
    e.moveTo(0, -n), e.lineTo(n, 0), e.lineTo(0, n), e.lineTo(-n, 0), e.closePath();
  }
}, Nre = {
  draw(e, t) {
    const n = _r(t - vg(t / 7, 2)) * 0.87559;
    e.moveTo(-n, 0), e.lineTo(n, 0), e.moveTo(0, n), e.lineTo(0, -n);
  }
}, Dre = {
  draw(e, t) {
    const n = _r(t), r = -n / 2;
    e.rect(r, r, n, n);
  }
}, jre = {
  draw(e, t) {
    const n = _r(t) * 0.4431;
    e.moveTo(n, n), e.lineTo(n, -n), e.lineTo(-n, -n), e.lineTo(-n, n), e.closePath();
  }
}, gJe = 0.8908130915292852, Lre = Go(Vu / 10) / Go(7 * Vu / 10), pJe = Go(bu / 10) * Lre, mJe = -qc(bu / 10) * Lre, Fre = {
  draw(e, t) {
    const n = _r(t * gJe), r = pJe * n, i = mJe * n;
    e.moveTo(0, -n), e.lineTo(r, i);
    for (let o = 1; o < 5; ++o) {
      const a = bu * o / 5, s = qc(a), c = Go(a);
      e.lineTo(c * n, -s * n), e.lineTo(s * r - c * i, c * r + s * i);
    }
    e.closePath();
  }
}, eI = _r(3), Vre = {
  draw(e, t) {
    const n = -_r(t / (eI * 3));
    e.moveTo(0, n * 2), e.lineTo(-eI * n, -n), e.lineTo(eI * n, -n), e.closePath();
  }
}, vJe = _r(3), Bre = {
  draw(e, t) {
    const n = _r(t) * 0.6824, r = n / 2, i = n * vJe / 2;
    e.moveTo(0, -n), e.lineTo(i, r), e.lineTo(-i, r), e.closePath();
  }
}, Oa = -0.5, Ma = _r(3) / 2, WR = 1 / _r(12), yJe = (WR / 2 + 1) * 3, zre = {
  draw(e, t) {
    const n = _r(t / yJe), r = n / 2, i = n * WR, o = r, a = n * WR + n, s = -o, c = a;
    e.moveTo(r, i), e.lineTo(o, a), e.lineTo(s, c), e.lineTo(Oa * r - Ma * i, Ma * r + Oa * i), e.lineTo(Oa * o - Ma * a, Ma * o + Oa * a), e.lineTo(Oa * s - Ma * c, Ma * s + Oa * c), e.lineTo(Oa * r + Ma * i, Oa * i - Ma * r), e.lineTo(Oa * o + Ma * a, Oa * a - Ma * o), e.lineTo(Oa * s + Ma * c, Oa * c - Ma * s), e.closePath();
  }
}, qR = {
  draw(e, t) {
    const n = _r(t - vg(t / 6, 1.7)) * 0.6189;
    e.moveTo(-n, -n), e.lineTo(n, n), e.moveTo(-n, n), e.lineTo(n, -n);
  }
}, EV = [
  OC,
  Pre,
  Mre,
  Dre,
  Fre,
  Vre,
  zre
], bJe = [
  OC,
  Nre,
  qR,
  Bre,
  Rre,
  jre,
  kre
];
function _Je(e, t) {
  let n = null, r = Jy(i);
  e = typeof e == "function" ? e : on(e || OC), t = typeof t == "function" ? t : on(t === void 0 ? 64 : +t);
  function i() {
    let o;
    if (n || (n = o = r()), e.apply(this, arguments).draw(n, +t.apply(this, arguments)), o)
      return n = null, o + "" || null;
  }
  return i.type = function(o) {
    return arguments.length ? (e = typeof o == "function" ? o : on(o), i) : e;
  }, i.size = function(o) {
    return arguments.length ? (t = typeof o == "function" ? o : on(+o), i) : t;
  }, i.context = function(o) {
    return arguments.length ? (n = o ?? null, i) : n;
  }, i;
}
function Bu() {
}
function Lw(e, t, n) {
  e._context.bezierCurveTo(
    (2 * e._x0 + e._x1) / 3,
    (2 * e._y0 + e._y1) / 3,
    (e._x0 + 2 * e._x1) / 3,
    (e._y0 + 2 * e._y1) / 3,
    (e._x0 + 4 * e._x1 + t) / 6,
    (e._y0 + 4 * e._y1 + n) / 6
  );
}
function MC(e) {
  this._context = e;
}
MC.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 3:
        Lw(this, this._x1, this._y1);
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3, this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
      default:
        Lw(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
  }
};
function Hre(e) {
  return new MC(e);
}
function Ure(e) {
  this._context = e;
}
Ure.prototype = {
  areaStart: Bu,
  areaEnd: Bu,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x2, this._y2), this._context.closePath();
        break;
      }
      case 2: {
        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3), this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3), this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x2, this._y2), this.point(this._x3, this._y3), this.point(this._x4, this._y4);
        break;
      }
    }
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._x2 = e, this._y2 = t;
        break;
      case 1:
        this._point = 2, this._x3 = e, this._y3 = t;
        break;
      case 2:
        this._point = 3, this._x4 = e, this._y4 = t, this._context.moveTo((this._x0 + 4 * this._x1 + e) / 6, (this._y0 + 4 * this._y1 + t) / 6);
        break;
      default:
        Lw(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
  }
};
function Wre(e) {
  return new Ure(e);
}
function qre(e) {
  this._context = e;
}
qre.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 3) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        var n = (this._x0 + 4 * this._x1 + e) / 6, r = (this._y0 + 4 * this._y1 + t) / 6;
        this._line ? this._context.lineTo(n, r) : this._context.moveTo(n, r);
        break;
      case 3:
        this._point = 4;
      default:
        Lw(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
  }
};
function Gre(e) {
  return new qre(e);
}
function Kre(e, t) {
  this._basis = new MC(e), this._beta = t;
}
Kre.prototype = {
  lineStart: function() {
    this._x = [], this._y = [], this._basis.lineStart();
  },
  lineEnd: function() {
    var e = this._x, t = this._y, n = e.length - 1;
    if (n > 0)
      for (var r = e[0], i = t[0], o = e[n] - r, a = t[n] - i, s = -1, c; ++s <= n; )
        c = s / n, this._basis.point(
          this._beta * e[s] + (1 - this._beta) * (r + c * o),
          this._beta * t[s] + (1 - this._beta) * (i + c * a)
        );
    this._x = this._y = null, this._basis.lineEnd();
  },
  point: function(e, t) {
    this._x.push(+e), this._y.push(+t);
  }
};
const Yre = function e(t) {
  function n(r) {
    return t === 1 ? new MC(r) : new Kre(r, t);
  }
  return n.beta = function(r) {
    return e(+r);
  }, n;
}(0.85);
function Fw(e, t, n) {
  e._context.bezierCurveTo(
    e._x1 + e._k * (e._x2 - e._x0),
    e._y1 + e._k * (e._y2 - e._y0),
    e._x2 + e._k * (e._x1 - t),
    e._y2 + e._k * (e._y1 - n),
    e._x2,
    e._y2
  );
}
function dk(e, t) {
  this._context = e, this._k = (1 - t) / 6;
}
dk.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x2, this._y2);
        break;
      case 3:
        Fw(this, this._x1, this._y1);
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2, this._x1 = e, this._y1 = t;
        break;
      case 2:
        this._point = 3;
      default:
        Fw(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = e, this._y0 = this._y1, this._y1 = this._y2, this._y2 = t;
  }
};
const Xre = function e(t) {
  function n(r) {
    return new dk(r, t);
  }
  return n.tension = function(r) {
    return e(+r);
  }, n;
}(0);
function fk(e, t) {
  this._context = e, this._k = (1 - t) / 6;
}
fk.prototype = {
  areaStart: Bu,
  areaEnd: Bu,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3), this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3), this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3), this.point(this._x4, this._y4), this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._x3 = e, this._y3 = t;
        break;
      case 1:
        this._point = 2, this._context.moveTo(this._x4 = e, this._y4 = t);
        break;
      case 2:
        this._point = 3, this._x5 = e, this._y5 = t;
        break;
      default:
        Fw(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = e, this._y0 = this._y1, this._y1 = this._y2, this._y2 = t;
  }
};
const Qre = function e(t) {
  function n(r) {
    return new fk(r, t);
  }
  return n.tension = function(r) {
    return e(+r);
  }, n;
}(0);
function hk(e, t) {
  this._context = e, this._k = (1 - t) / 6;
}
hk.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 3) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3, this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
        break;
      case 3:
        this._point = 4;
      default:
        Fw(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = e, this._y0 = this._y1, this._y1 = this._y2, this._y2 = t;
  }
};
const Jre = function e(t) {
  function n(r) {
    return new hk(r, t);
  }
  return n.tension = function(r) {
    return e(+r);
  }, n;
}(0);
function gk(e, t, n) {
  var r = e._x1, i = e._y1, o = e._x2, a = e._y2;
  if (e._l01_a > io) {
    var s = 2 * e._l01_2a + 3 * e._l01_a * e._l12_a + e._l12_2a, c = 3 * e._l01_a * (e._l01_a + e._l12_a);
    r = (r * s - e._x0 * e._l12_2a + e._x2 * e._l01_2a) / c, i = (i * s - e._y0 * e._l12_2a + e._y2 * e._l01_2a) / c;
  }
  if (e._l23_a > io) {
    var l = 2 * e._l23_2a + 3 * e._l23_a * e._l12_a + e._l12_2a, u = 3 * e._l23_a * (e._l23_a + e._l12_a);
    o = (o * l + e._x1 * e._l23_2a - t * e._l12_2a) / u, a = (a * l + e._y1 * e._l23_2a - n * e._l12_2a) / u;
  }
  e._context.bezierCurveTo(r, i, o, a, e._x2, e._y2);
}
function Zre(e, t) {
  this._context = e, this._alpha = t;
}
Zre.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x2, this._y2);
        break;
      case 3:
        this.point(this._x2, this._y2);
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    if (e = +e, t = +t, this._point) {
      var n = this._x2 - e, r = this._y2 - t;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(n * n + r * r, this._alpha));
    }
    switch (this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
      default:
        gk(this, e, t);
        break;
    }
    this._l01_a = this._l12_a, this._l12_a = this._l23_a, this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a, this._x0 = this._x1, this._x1 = this._x2, this._x2 = e, this._y0 = this._y1, this._y1 = this._y2, this._y2 = t;
  }
};
const eie = function e(t) {
  function n(r) {
    return t ? new Zre(r, t) : new dk(r, 0);
  }
  return n.alpha = function(r) {
    return e(+r);
  }, n;
}(0.5);
function tie(e, t) {
  this._context = e, this._alpha = t;
}
tie.prototype = {
  areaStart: Bu,
  areaEnd: Bu,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN, this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3), this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3), this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3), this.point(this._x4, this._y4), this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(e, t) {
    if (e = +e, t = +t, this._point) {
      var n = this._x2 - e, r = this._y2 - t;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(n * n + r * r, this._alpha));
    }
    switch (this._point) {
      case 0:
        this._point = 1, this._x3 = e, this._y3 = t;
        break;
      case 1:
        this._point = 2, this._context.moveTo(this._x4 = e, this._y4 = t);
        break;
      case 2:
        this._point = 3, this._x5 = e, this._y5 = t;
        break;
      default:
        gk(this, e, t);
        break;
    }
    this._l01_a = this._l12_a, this._l12_a = this._l23_a, this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a, this._x0 = this._x1, this._x1 = this._x2, this._x2 = e, this._y0 = this._y1, this._y1 = this._y2, this._y2 = t;
  }
};
const nie = function e(t) {
  function n(r) {
    return t ? new tie(r, t) : new fk(r, 0);
  }
  return n.alpha = function(r) {
    return e(+r);
  }, n;
}(0.5);
function rie(e, t) {
  this._context = e, this._alpha = t;
}
rie.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 3) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    if (e = +e, t = +t, this._point) {
      var n = this._x2 - e, r = this._y2 - t;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(n * n + r * r, this._alpha));
    }
    switch (this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3, this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
        break;
      case 3:
        this._point = 4;
      default:
        gk(this, e, t);
        break;
    }
    this._l01_a = this._l12_a, this._l12_a = this._l23_a, this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a, this._x0 = this._x1, this._x1 = this._x2, this._x2 = e, this._y0 = this._y1, this._y1 = this._y2, this._y2 = t;
  }
};
const iie = function e(t) {
  function n(r) {
    return t ? new rie(r, t) : new hk(r, 0);
  }
  return n.alpha = function(r) {
    return e(+r);
  }, n;
}(0.5);
function oie(e) {
  this._context = e;
}
oie.prototype = {
  areaStart: Bu,
  areaEnd: Bu,
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    this._point && this._context.closePath();
  },
  point: function(e, t) {
    e = +e, t = +t, this._point ? this._context.lineTo(e, t) : (this._point = 1, this._context.moveTo(e, t));
  }
};
function aie(e) {
  return new oie(e);
}
function CV(e) {
  return e < 0 ? -1 : 1;
}
function TV(e, t, n) {
  var r = e._x1 - e._x0, i = t - e._x1, o = (e._y1 - e._y0) / (r || i < 0 && -0), a = (n - e._y1) / (i || r < 0 && -0), s = (o * i + a * r) / (r + i);
  return (CV(o) + CV(a)) * Math.min(Math.abs(o), Math.abs(a), 0.5 * Math.abs(s)) || 0;
}
function IV(e, t) {
  var n = e._x1 - e._x0;
  return n ? (3 * (e._y1 - e._y0) / n - t) / 2 : t;
}
function tI(e, t, n) {
  var r = e._x0, i = e._y0, o = e._x1, a = e._y1, s = (o - r) / 3;
  e._context.bezierCurveTo(r + s, i + s * t, o - s, a - s * n, o, a);
}
function Vw(e) {
  this._context = e;
}
Vw.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
      case 3:
        tI(this, this._t0, IV(this, this._t0));
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    var n = NaN;
    if (e = +e, t = +t, !(e === this._x1 && t === this._y1)) {
      switch (this._point) {
        case 0:
          this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
          break;
        case 1:
          this._point = 2;
          break;
        case 2:
          this._point = 3, tI(this, IV(this, n = TV(this, e, t)), n);
          break;
        default:
          tI(this, this._t0, n = TV(this, e, t));
          break;
      }
      this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t, this._t0 = n;
    }
  }
};
function sie(e) {
  this._context = new cie(e);
}
(sie.prototype = Object.create(Vw.prototype)).point = function(e, t) {
  Vw.prototype.point.call(this, t, e);
};
function cie(e) {
  this._context = e;
}
cie.prototype = {
  moveTo: function(e, t) {
    this._context.moveTo(t, e);
  },
  closePath: function() {
    this._context.closePath();
  },
  lineTo: function(e, t) {
    this._context.lineTo(t, e);
  },
  bezierCurveTo: function(e, t, n, r, i, o) {
    this._context.bezierCurveTo(t, e, r, n, o, i);
  }
};
function lie(e) {
  return new Vw(e);
}
function uie(e) {
  return new sie(e);
}
function die(e) {
  this._context = e;
}
die.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = [], this._y = [];
  },
  lineEnd: function() {
    var e = this._x, t = this._y, n = e.length;
    if (n)
      if (this._line ? this._context.lineTo(e[0], t[0]) : this._context.moveTo(e[0], t[0]), n === 2)
        this._context.lineTo(e[1], t[1]);
      else
        for (var r = $V(e), i = $V(t), o = 0, a = 1; a < n; ++o, ++a)
          this._context.bezierCurveTo(r[0][o], i[0][o], r[1][o], i[1][o], e[a], t[a]);
    (this._line || this._line !== 0 && n === 1) && this._context.closePath(), this._line = 1 - this._line, this._x = this._y = null;
  },
  point: function(e, t) {
    this._x.push(+e), this._y.push(+t);
  }
};
function $V(e) {
  var t, n = e.length - 1, r, i = new Array(n), o = new Array(n), a = new Array(n);
  for (i[0] = 0, o[0] = 2, a[0] = e[0] + 2 * e[1], t = 1; t < n - 1; ++t)
    i[t] = 1, o[t] = 4, a[t] = 4 * e[t] + 2 * e[t + 1];
  for (i[n - 1] = 2, o[n - 1] = 7, a[n - 1] = 8 * e[n - 1] + e[n], t = 1; t < n; ++t)
    r = i[t] / o[t - 1], o[t] -= r, a[t] -= r * a[t - 1];
  for (i[n - 1] = a[n - 1] / o[n - 1], t = n - 2; t >= 0; --t)
    i[t] = (a[t] - i[t + 1]) / o[t];
  for (o[n - 1] = (e[n] + i[n - 1]) / 2, t = 0; t < n - 1; ++t)
    o[t] = 2 * e[t + 1] - i[t + 1];
  return [i, o];
}
function fie(e) {
  return new die(e);
}
function kC(e, t) {
  this._context = e, this._t = t;
}
kC.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = this._y = NaN, this._point = 0;
  },
  lineEnd: function() {
    0 < this._t && this._t < 1 && this._point === 2 && this._context.lineTo(this._x, this._y), (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line >= 0 && (this._t = 1 - this._t, this._line = 1 - this._line);
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
      default: {
        if (this._t <= 0)
          this._context.lineTo(this._x, t), this._context.lineTo(e, t);
        else {
          var n = this._x * (1 - this._t) + e * this._t;
          this._context.lineTo(n, this._y), this._context.lineTo(n, t);
        }
        break;
      }
    }
    this._x = e, this._y = t;
  }
};
function hie(e) {
  return new kC(e, 0.5);
}
function gie(e) {
  return new kC(e, 0);
}
function pie(e) {
  return new kC(e, 1);
}
function up(e, t) {
  if ((a = e.length) > 1)
    for (var n = 1, r, i, o = e[t[0]], a, s = o.length; n < a; ++n)
      for (i = o, o = e[t[n]], r = 0; r < s; ++r)
        o[r][1] += o[r][0] = isNaN(i[r][1]) ? i[r][0] : i[r][1];
}
function dp(e) {
  for (var t = e.length, n = new Array(t); --t >= 0; )
    n[t] = t;
  return n;
}
function SJe(e, t) {
  return e[t];
}
function wJe(e) {
  const t = [];
  return t.key = e, t;
}
function xJe() {
  var e = on([]), t = dp, n = up, r = SJe;
  function i(o) {
    var a = Array.from(e.apply(this, arguments), wJe), s, c = a.length, l = -1, u;
    for (const d of o)
      for (s = 0, ++l; s < c; ++s)
        (a[s][l] = [0, +r(d, a[s].key, l, o)]).data = d;
    for (s = 0, u = AC(t(a)); s < c; ++s)
      a[u[s]].index = s;
    return n(a, u), a;
  }
  return i.keys = function(o) {
    return arguments.length ? (e = typeof o == "function" ? o : on(Array.from(o)), i) : e;
  }, i.value = function(o) {
    return arguments.length ? (r = typeof o == "function" ? o : on(+o), i) : r;
  }, i.order = function(o) {
    return arguments.length ? (t = o == null ? dp : typeof o == "function" ? o : on(Array.from(o)), i) : t;
  }, i.offset = function(o) {
    return arguments.length ? (n = o ?? up, i) : n;
  }, i;
}
function EJe(e, t) {
  if ((r = e.length) > 0) {
    for (var n, r, i = 0, o = e[0].length, a; i < o; ++i) {
      for (a = n = 0; n < r; ++n)
        a += e[n][i][1] || 0;
      if (a)
        for (n = 0; n < r; ++n)
          e[n][i][1] /= a;
    }
    up(e, t);
  }
}
function CJe(e, t) {
  if ((c = e.length) > 0)
    for (var n, r = 0, i, o, a, s, c, l = e[t[0]].length; r < l; ++r)
      for (a = s = 0, n = 0; n < c; ++n)
        (o = (i = e[t[n]][r])[1] - i[0]) > 0 ? (i[0] = a, i[1] = a += o) : o < 0 ? (i[1] = s, i[0] = s += o) : (i[0] = 0, i[1] = o);
}
function TJe(e, t) {
  if ((i = e.length) > 0) {
    for (var n = 0, r = e[t[0]], i, o = r.length; n < o; ++n) {
      for (var a = 0, s = 0; a < i; ++a)
        s += e[a][n][1] || 0;
      r[n][1] += r[n][0] = -s / 2;
    }
    up(e, t);
  }
}
function IJe(e, t) {
  if (!(!((a = e.length) > 0) || !((o = (i = e[t[0]]).length) > 0))) {
    for (var n = 0, r = 1, i, o, a; r < o; ++r) {
      for (var s = 0, c = 0, l = 0; s < a; ++s) {
        for (var u = e[t[s]], d = u[r][1] || 0, f = u[r - 1][1] || 0, h = (d - f) / 2, p = 0; p < s; ++p) {
          var g = e[t[p]], m = g[r][1] || 0, v = g[r - 1][1] || 0;
          h += m - v;
        }
        c += d, l += h * d;
      }
      i[r - 1][1] += i[r - 1][0] = n, c && (n -= l / c);
    }
    i[r - 1][1] += i[r - 1][0] = n, up(e, t);
  }
}
function mie(e) {
  var t = e.map($Je);
  return dp(e).sort(function(n, r) {
    return t[n] - t[r];
  });
}
function $Je(e) {
  for (var t = -1, n = 0, r = e.length, i, o = -1 / 0; ++t < r; )
    (i = +e[t][1]) > o && (o = i, n = t);
  return n;
}
function vie(e) {
  var t = e.map(yie);
  return dp(e).sort(function(n, r) {
    return t[n] - t[r];
  });
}
function yie(e) {
  for (var t = 0, n = -1, r = e.length, i; ++n < r; )
    (i = +e[n][1]) && (t += i);
  return t;
}
function AJe(e) {
  return vie(e).reverse();
}
function RJe(e) {
  var t = e.length, n, r, i = e.map(yie), o = mie(e), a = 0, s = 0, c = [], l = [];
  for (n = 0; n < t; ++n)
    r = o[n], a < s ? (a += i[r], c.push(r)) : (s += i[r], l.push(r));
  return l.reverse().concat(c);
}
function PJe(e) {
  return dp(e).reverse();
}
const OJe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  arc: $C,
  area: xre,
  areaRadial: xV,
  curveBasis: Hre,
  curveBasisClosed: Wre,
  curveBasisOpen: Gre,
  curveBumpX: $re,
  curveBumpY: Are,
  curveBundle: Yre,
  curveCardinal: Xre,
  curveCardinalClosed: Qre,
  curveCardinalOpen: Jre,
  curveCatmullRom: eie,
  curveCatmullRomClosed: nie,
  curveCatmullRomOpen: iie,
  curveLinear: am,
  curveLinearClosed: aie,
  curveMonotoneX: lie,
  curveMonotoneY: uie,
  curveNatural: fie,
  curveStep: hie,
  curveStepAfter: pie,
  curveStepBefore: gie,
  line: RC,
  lineRadial: UR,
  link: PC,
  linkHorizontal: lJe,
  linkRadial: dJe,
  linkVertical: uJe,
  pie: Ere,
  pointRadial: g0,
  radialArea: xV,
  radialLine: UR,
  stack: xJe,
  stackOffsetDiverging: CJe,
  stackOffsetExpand: EJe,
  stackOffsetNone: up,
  stackOffsetSilhouette: TJe,
  stackOffsetWiggle: IJe,
  stackOrderAppearance: mie,
  stackOrderAscending: vie,
  stackOrderDescending: AJe,
  stackOrderInsideOut: RJe,
  stackOrderNone: dp,
  stackOrderReverse: PJe,
  symbol: _Je,
  symbolAsterisk: Rre,
  symbolCircle: OC,
  symbolCross: Pre,
  symbolDiamond: Mre,
  symbolDiamond2: kre,
  symbolPlus: Nre,
  symbolSquare: Dre,
  symbolSquare2: jre,
  symbolStar: Fre,
  symbolTimes: qR,
  symbolTriangle: Vre,
  symbolTriangle2: Bre,
  symbolWye: zre,
  symbolX: qR,
  symbols: EV,
  symbolsFill: EV,
  symbolsStroke: bJe
}, Symbol.toStringTag, { value: "Module" })), AV = (e) => {
  const t = e._y1 !== void 0 ? e._y1 : e._y;
  return t != null && e._y0 !== null;
}, RV = (e) => (t) => e.x(t._x1 !== void 0 ? t._x1 : t._x), nI = (e) => (t) => e.y(t._y1 !== void 0 ? t._y1 : t._y), MJe = (e) => (t) => -1 * e.x(t._x1 !== void 0 ? t._x1 : t._x) + Math.PI / 2, bie = (e) => `curve${((n) => n && n[0].toUpperCase() + n.slice(1))(e)}`, kJe = (e) => `${bie(e)}Closed`, PV = (e) => {
  const {
    interpolation: t
  } = e;
  if (typeof t == "function")
    return t;
  if (typeof t == "string") {
    const {
      polar: n,
      openCurve: r = !n
    } = e, i = r ? bie(t) : kJe(t);
    return OJe[i];
  }
  return am;
}, NJe = (e) => {
  const {
    polar: t,
    scale: n,
    horizontal: r
  } = e;
  return t ? UR().defined(AV).curve(PV(e)).angle(MJe(n)).radius(nI(n)) : RC().defined(AV).curve(PV(e)).x(r ? nI(n) : RV(n)).y(r ? RV(n) : nI(n));
};
function pk(e) {
  process.env.NODE_ENV !== "production" && console && console.warn && console.warn(e);
}
function DJe(e, t, n) {
  return `M ${e}, ${t}
      m ${-n}, 0
      a ${n}, ${n} 0 1,0 ${n * 2},0
      a ${n}, ${n} 0 1,0 ${-n * 2},0`;
}
function jJe(e, t, n) {
  const r = 0.87 * n, i = e - r, o = t + r, a = e + r - i;
  return `M ${i}, ${o}
      h${a}
      v-${a}
      h-${a}
      z`;
}
function LJe(e, t, n) {
  const r = 0.87 * n, i = Math.sqrt(2 * (r * r));
  return `M ${e}, ${t + i}
      l ${i}, -${i}
      l -${i}, -${i}
      l -${i}, ${i}
      l ${i}, ${i}
      z`;
}
function FJe(e, t, n) {
  const r = n / 2 * Math.sqrt(3), i = e - n, o = e + n, a = t - n, s = t + r;
  return `M ${i}, ${a}
      L ${o}, ${a}
      L ${e}, ${s}
      z`;
}
function VJe(e, t, n) {
  const r = n / 2 * Math.sqrt(3), i = e - n, o = e + n, a = t - r, s = t + n;
  return `M ${i}, ${s}
      L ${o}, ${s}
      L ${e}, ${a}
      z`;
}
function BJe(e, t, n) {
  const r = 1.1 * n, i = r / 1.5;
  return `
      M ${e - i / 2}, ${t + r}
      v-${i}
      h-${i}
      v-${i}
      h${i}
      v-${i}
      h${i}
      v${i}
      h${i}
      v${i}
      h-${i}
      v${i}
      z`;
}
function zJe(e, t, n) {
  const r = 0.8 * n, i = r / 1.5;
  return `
      M ${e - i / 2}, ${t + r + i}
      v-${i * 2}
      h-${i}
      v-${i}
      h${i}
      v-${i}
      h${i}
      v${i}
      h${i}
      v${i}
      h-${i}
      v${i * 2}
      z`;
}
function HJe(e, t, n) {
  const r = 1.1 * n, i = r - r * 0.3, o = e - r, a = t + i / 2, s = e + r - o;
  return `M ${o}, ${a}
      h${s}
      v-${i}
      h-${s}
      z`;
}
function UJe(e, t, n) {
  const r = 1.35 * n, i = Math.PI / 5;
  return `M ${w3(10).map((a) => {
    const s = a % 2 === 0 ? r : r / 2;
    return `${s * Math.sin(i * (a + 1)) + e},
        ${s * Math.cos(i * (a + 1)) + t}`;
  }).join("L")} z`;
}
const WJe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  circle: DJe,
  cross: zJe,
  diamond: LJe,
  minus: HJe,
  plus: BJe,
  square: jJe,
  star: UJe,
  triangleDown: FJe,
  triangleUp: VJe
}, Symbol.toStringTag, { value: "Module" })), qJe = {
  blue: "#4F7DA1",
  pink: "#E2A37F",
  teal: "#00796B",
  purple: "#DF948A",
  green: "#8BC34A",
  orange: "#F4511E",
  cyan: "#006064",
  red: "#DF5A49",
  yellow: "#FFF59D"
}, zh = ["#252525", "#525252", "#737373", "#969696", "#bdbdbd", "#d9d9d9", "#f0f0f0"], wo = "#252525", rI = "#969696", GJe = ["#334D5C", "#45B29D", "#EFC94C", "#E27A3F", "#DF5A49", "#4F7DA1", "#55DBC1", "#EFDA97", "#E2A37F", "#DF948A"], KJe = ["#428517", "#77D200", "#D6D305", "#EC8E19", "#C92B05"], YJe = ["#940031", "#C43343", "#DC5429", "#FF821D", "#FFAF55"], XJe = ["#2746B9", "#0B69D4", "#2794DB", "#31BB76", "#60E83B"], QJe = ["#FCAE91", "#FB6A4A", "#DE2D26", "#A50F15", "#750B0E"], JJe = ["#354722", "#466631", "#649146", "#8AB25C", "#A9C97E"], ZJe = ["#002C61", "#004B8F", "#006BC9", "#3795E5", "#65B4F4"], eZe = "'Gill Sans', 'Seravek', 'Trebuchet MS', sans-serif", tZe = "normal", nZe = 14, ua = {
  width: 450,
  height: 300,
  padding: 50,
  colorScale: zh
}, vi = {
  fontFamily: eZe,
  fontSize: nZe,
  letterSpacing: tZe,
  padding: 10,
  fill: wo,
  stroke: "transparent"
}, rZe = Object.assign({
  textAnchor: "middle"
}, vi), iZe = "round", oZe = "round", aZe = {
  palette: {
    colors: qJe,
    grayscale: zh,
    qualitative: GJe,
    heatmap: KJe,
    warm: YJe,
    cool: XJe,
    red: QJe,
    green: JJe,
    blue: ZJe
  },
  area: Object.assign({
    style: {
      data: {
        fill: wo
      },
      labels: vi
    }
  }, ua),
  axis: Object.assign({
    style: {
      axis: {
        fill: "transparent",
        stroke: wo,
        strokeWidth: 1,
        strokeLinecap: iZe,
        strokeLinejoin: oZe
      },
      axisLabel: Object.assign({}, rZe, {
        padding: 25
      }),
      grid: {
        fill: "none",
        stroke: "none",
        pointerEvents: "painted"
      },
      ticks: {
        fill: "transparent",
        size: 1,
        stroke: "transparent"
      },
      tickLabels: vi
    }
  }, ua),
  bar: Object.assign({
    style: {
      data: {
        fill: wo,
        padding: 8,
        strokeWidth: 0
      },
      labels: vi
    }
  }, ua),
  boxplot: Object.assign({
    style: {
      max: {
        padding: 8,
        stroke: wo,
        strokeWidth: 1
      },
      maxLabels: Object.assign({}, vi, {
        padding: 3
      }),
      median: {
        padding: 8,
        stroke: wo,
        strokeWidth: 1
      },
      medianLabels: Object.assign({}, vi, {
        padding: 3
      }),
      min: {
        padding: 8,
        stroke: wo,
        strokeWidth: 1
      },
      minLabels: Object.assign({}, vi, {
        padding: 3
      }),
      q1: {
        padding: 8,
        fill: rI
      },
      q1Labels: Object.assign({}, vi, {
        padding: 3
      }),
      q3: {
        padding: 8,
        fill: rI
      },
      q3Labels: Object.assign({}, vi, {
        padding: 3
      })
    },
    boxWidth: 20
  }, ua),
  candlestick: Object.assign({
    style: {
      data: {
        stroke: wo,
        strokeWidth: 1
      },
      labels: Object.assign({}, vi, {
        padding: 5
      })
    },
    candleColors: {
      positive: "#ffffff",
      negative: wo
    }
  }, ua),
  chart: ua,
  errorbar: Object.assign({
    borderWidth: 8,
    style: {
      data: {
        fill: "transparent",
        stroke: wo,
        strokeWidth: 2
      },
      labels: vi
    }
  }, ua),
  group: Object.assign({
    colorScale: zh
  }, ua),
  histogram: Object.assign({
    style: {
      data: {
        fill: rI,
        stroke: wo,
        strokeWidth: 2
      },
      labels: vi
    }
  }, ua),
  legend: {
    colorScale: zh,
    gutter: 10,
    orientation: "vertical",
    titleOrientation: "top",
    style: {
      data: {
        type: "circle"
      },
      labels: vi,
      title: Object.assign({}, vi, {
        padding: 5
      })
    }
  },
  line: Object.assign({
    style: {
      data: {
        fill: "transparent",
        stroke: wo,
        strokeWidth: 2
      },
      labels: vi
    }
  }, ua),
  pie: {
    style: {
      data: {
        padding: 10,
        stroke: "transparent",
        strokeWidth: 1
      },
      labels: Object.assign({}, vi, {
        padding: 20
      })
    },
    colorScale: zh,
    width: 400,
    height: 400,
    padding: 50
  },
  scatter: Object.assign({
    style: {
      data: {
        fill: wo,
        stroke: "transparent",
        strokeWidth: 0
      },
      labels: vi
    }
  }, ua),
  stack: Object.assign({
    colorScale: zh
  }, ua),
  tooltip: {
    style: Object.assign({}, vi, {
      padding: 0,
      pointerEvents: "none"
    }),
    flyoutStyle: {
      stroke: wo,
      strokeWidth: 1,
      fill: "#f0f0f0",
      pointerEvents: "none"
    },
    flyoutPadding: 5,
    cornerRadius: 5,
    pointerLength: 10
  },
  voronoi: Object.assign({
    style: {
      data: {
        fill: "transparent",
        stroke: "transparent",
        strokeWidth: 0
      },
      labels: Object.assign({}, vi, {
        padding: 5,
        pointerEvents: "none"
      }),
      flyout: {
        stroke: wo,
        strokeWidth: 1,
        fill: "#f0f0f0",
        pointerEvents: "none"
      }
    }
  }, ua)
}, _ie = "#FFF59D", Sie = "#F4511E", sZe = "#DCE775", wie = "#8BC34A", xie = "#00796B", Eie = "#006064", C1 = [Sie, _ie, sZe, wie, xie, Eie], GR = "#ECEFF1", KR = "#90A4AE", Co = "#455A64", p0 = "#212121", cZe = {
  blue: "#4F7DA1",
  pink: "#E2A37F",
  teal: xie,
  purple: "#DF948A",
  green: wie,
  orange: Sie,
  cyan: Eie,
  red: "#DF5A49",
  yellow: _ie
}, lZe = [GR, KR, Co, p0], uZe = ["#334D5C", "#45B29D", "#EFC94C", "#E27A3F", "#DF5A49", "#4F7DA1", "#55DBC1", "#EFDA97", "#E2A37F", "#DF948A"], dZe = ["#428517", "#77D200", "#D6D305", "#EC8E19", "#C92B05"], fZe = ["#940031", "#C43343", "#DC5429", "#FF821D", "#FFAF55"], hZe = ["#2746B9", "#0B69D4", "#2794DB", "#31BB76", "#60E83B"], gZe = ["#FCAE91", "#FB6A4A", "#DE2D26", "#A50F15", "#750B0E"], pZe = ["#354722", "#466631", "#649146", "#8AB25C", "#A9C97E"], mZe = ["#002C61", "#004B8F", "#006BC9", "#3795E5", "#65B4F4"], vZe = "'Helvetica Neue', 'Helvetica', sans-serif", yZe = "normal", bZe = 12, jc = 8, zo = {
  width: 350,
  height: 350,
  padding: 50
}, yi = {
  fontFamily: vZe,
  fontSize: bZe,
  letterSpacing: yZe,
  padding: jc,
  fill: Co,
  stroke: "transparent",
  strokeWidth: 0
}, _Ze = Object.assign({
  textAnchor: "middle"
}, yi), SZe = "10, 5", iI = "round", oI = "round", wZe = {
  palette: {
    colors: cZe,
    grayscale: lZe,
    qualitative: uZe,
    heatmap: dZe,
    warm: fZe,
    cool: hZe,
    red: gZe,
    green: pZe,
    blue: mZe
  },
  area: Object.assign({
    style: {
      data: {
        fill: p0
      },
      labels: yi
    }
  }, zo),
  axis: Object.assign({
    style: {
      axis: {
        fill: "transparent",
        stroke: KR,
        strokeWidth: 2,
        strokeLinecap: iI,
        strokeLinejoin: oI
      },
      axisLabel: Object.assign({}, _Ze, {
        padding: jc,
        stroke: "transparent"
      }),
      grid: {
        fill: "none",
        stroke: GR,
        strokeDasharray: SZe,
        strokeLinecap: iI,
        strokeLinejoin: oI,
        pointerEvents: "painted"
      },
      ticks: {
        fill: "transparent",
        size: 5,
        stroke: KR,
        strokeWidth: 1,
        strokeLinecap: iI,
        strokeLinejoin: oI
      },
      tickLabels: Object.assign({}, yi, {
        fill: Co
      })
    }
  }, zo),
  polarDependentAxis: Object.assign({
    style: {
      ticks: {
        fill: "transparent",
        size: 1,
        stroke: "transparent"
      }
    }
  }),
  bar: Object.assign({
    style: {
      data: {
        fill: Co,
        padding: jc,
        strokeWidth: 0
      },
      labels: yi
    }
  }, zo),
  boxplot: Object.assign({
    style: {
      max: {
        padding: jc,
        stroke: Co,
        strokeWidth: 1
      },
      maxLabels: Object.assign({}, yi, {
        padding: 3
      }),
      median: {
        padding: jc,
        stroke: Co,
        strokeWidth: 1
      },
      medianLabels: Object.assign({}, yi, {
        padding: 3
      }),
      min: {
        padding: jc,
        stroke: Co,
        strokeWidth: 1
      },
      minLabels: Object.assign({}, yi, {
        padding: 3
      }),
      q1: {
        padding: jc,
        fill: Co
      },
      q1Labels: Object.assign({}, yi, {
        padding: 3
      }),
      q3: {
        padding: jc,
        fill: Co
      },
      q3Labels: Object.assign({}, yi, {
        padding: 3
      })
    },
    boxWidth: 20
  }, zo),
  candlestick: Object.assign({
    style: {
      data: {
        stroke: Co
      },
      labels: Object.assign({}, yi, {
        padding: 5
      })
    },
    candleColors: {
      positive: "#ffffff",
      negative: Co
    }
  }, zo),
  chart: zo,
  errorbar: Object.assign({
    borderWidth: 8,
    style: {
      data: {
        fill: "transparent",
        opacity: 1,
        stroke: Co,
        strokeWidth: 2
      },
      labels: yi
    }
  }, zo),
  group: Object.assign({
    colorScale: C1
  }, zo),
  histogram: Object.assign({
    style: {
      data: {
        fill: Co,
        stroke: p0,
        strokeWidth: 2
      },
      labels: yi
    }
  }, zo),
  legend: {
    colorScale: C1,
    gutter: 10,
    orientation: "vertical",
    titleOrientation: "top",
    style: {
      data: {
        type: "circle"
      },
      labels: yi,
      title: Object.assign({}, yi, {
        padding: 5
      })
    }
  },
  line: Object.assign({
    style: {
      data: {
        fill: "transparent",
        opacity: 1,
        stroke: Co,
        strokeWidth: 2
      },
      labels: yi
    }
  }, zo),
  pie: Object.assign({
    colorScale: C1,
    style: {
      data: {
        padding: jc,
        stroke: GR,
        strokeWidth: 1
      },
      labels: Object.assign({}, yi, {
        padding: 20
      })
    }
  }, zo),
  scatter: Object.assign({
    style: {
      data: {
        fill: Co,
        opacity: 1,
        stroke: "transparent",
        strokeWidth: 0
      },
      labels: yi
    }
  }, zo),
  stack: Object.assign({
    colorScale: C1
  }, zo),
  tooltip: {
    style: Object.assign({}, yi, {
      padding: 0,
      pointerEvents: "none"
    }),
    flyoutStyle: {
      stroke: p0,
      strokeWidth: 1,
      fill: "#f0f0f0",
      pointerEvents: "none"
    },
    flyoutPadding: 5,
    cornerRadius: 5,
    pointerLength: 10
  },
  voronoi: Object.assign({
    style: {
      data: {
        fill: "transparent",
        stroke: "transparent",
        strokeWidth: 0
      },
      labels: Object.assign({}, yi, {
        padding: 5,
        pointerEvents: "none"
      }),
      flyout: {
        stroke: p0,
        strokeWidth: 1,
        fill: "#f0f0f0",
        pointerEvents: "none"
      }
    }
  }, zo)
}, fr = {
  white: "#FFFFFF",
  50: "#FAFAFA",
  100: "#F2F2F2",
  200: "#E8E8E8",
  300: "#E0E0E0",
  400: "#D1D1D1",
  500: "#757575",
  600: "#5C5C5C",
  700: "#424242",
  800: "#333333",
  900: "#292929",
  black: "#0F0F0F"
}, Bw = {
  100: "#FFEAB6",
  300: "#FFD66E",
  500: "#FCB400",
  900: "#B87503"
}, zw = {
  100: "#FEE2D5",
  300: "#FFA981",
  500: "#FF6F2C",
  700: "#FF4E1B",
  900: "#D74D26"
}, Zy = {
  100: "#FFDCE5",
  300: "#FF9EB7",
  500: "#F82B60",
  700: "#D31A3D",
  900: "#BA1E45"
}, Cie = {
  100: "#EDE3FE",
  300: "#CDB0FF",
  500: "#8B46FF",
  900: "#6B1CB0"
}, eb = {
  100: "#CFDFFF",
  300: "#9CC7FF",
  500: "#2D7FF9",
  700: "#0056B3",
  900: "#2750AE"
}, mk = {
  100: "#D0F0FD",
  300: "#77D1F3",
  500: "#18BFFF",
  900: "#0B76B7"
}, Tie = {
  100: "#C2F5E9",
  300: "#72DDC3",
  500: "#20D9D2",
  900: "#06A09B"
}, fp = {
  100: "#D1F7C4",
  300: "#93E088",
  500: "#20C933",
  700: "#1B9B2A",
  900: "#338A17"
}, Iie = {
  blue: eb[500],
  cyan: mk[500],
  green: fp[500],
  yellow: Bw[500],
  orange: zw[500],
  red: Zy[500],
  purple: Cie[500],
  teal: Tie[500]
}, Ll = Object.values(Iie), xZe = [fr[100], fr[300], fr[500], fr[700], fr[900]], EZe = [Bw[300], Bw[500], zw[500], zw[900], Zy[500]], CZe = [Cie[500], eb[500], mk[500], Tie[500], fp[500]], TZe = [fp[900], fp[500], Bw[500], zw[500], Zy[500]], IZe = Object.values(Zy), $Ze = Object.values(fp), AZe = Object.values(eb), Vm = eb[500], RZe = "'Inter', 'Helvetica Neue', 'Seravek', 'Helvetica', sans-serif", PZe = "normal", OZe = 12, Lc = 8, Ho = {
  width: 450,
  height: 300,
  padding: 60,
  colorScale: Ll
}, Hr = {
  fontFamily: RZe,
  fontSize: OZe,
  fontWeight: 300,
  letterSpacing: PZe,
  padding: Lc,
  fill: fr[900],
  stroke: "transparent"
}, MZe = Object.assign({
  textAnchor: "middle"
}, Hr), OV = "10, 5", vd = "round", Th = "round", yd = 1, kZe = {
  palette: {
    colors: Iie,
    grayscale: xZe,
    qualitative: Ll,
    heatmap: TZe,
    warm: EZe,
    cool: CZe,
    red: IZe,
    green: $Ze,
    blue: AZe
  },
  area: Object.assign({
    style: {
      data: {
        fill: Vm,
        strokeWidth: 2,
        fillOpacity: 0.5
      },
      labels: Hr
    }
  }, Ho),
  axis: Object.assign({
    style: {
      axis: {
        fill: "transparent",
        stroke: fr[500],
        strokeWidth: 1,
        strokeLinecap: vd,
        strokeLinejoin: Th
      },
      axisLabel: Object.assign({}, MZe, {
        padding: 35,
        stroke: "transparent"
      }),
      grid: {
        fill: "none",
        stroke: "none",
        painterEvents: "painted"
      },
      ticks: {
        fill: "transparent",
        size: 5,
        stroke: "transparent"
      },
      tickLabels: Hr
    }
  }, Ho),
  polarAxis: Object.assign({
    style: {
      axis: {
        stroke: fr[500]
      },
      grid: {
        stroke: fr[400],
        strokeDasharray: OV,
        strokeLinecap: vd,
        strokeLinejoin: Th,
        pointerEvents: "painted"
      },
      ticks: {
        fill: "transparent",
        size: 5,
        stroke: fr[400],
        strokeWidth: 1,
        strokeLinecap: vd,
        strokeLinejoin: Th
      },
      tickLabels: Hr
    }
  }),
  polarDependentAxis: Object.assign({
    style: {
      axis: {
        stroke: fr[500]
      },
      grid: {
        stroke: fr[400],
        strokeDasharray: OV,
        strokeLinecap: vd,
        strokeLinejoin: Th,
        pointerEvents: "painted"
      },
      ticks: {
        fill: "transparent",
        size: 5,
        stroke: fr[300],
        strokeWidth: 1,
        strokeLinecap: vd,
        strokeLinejoin: Th
      },
      tickLabels: Hr
    }
  }),
  bar: Object.assign({
    style: {
      data: {
        fill: Vm,
        padding: Lc,
        strokeWidth: 1,
        fillOpacity: 0.5
      },
      labels: Hr
    },
    cornerRadius: {
      top: yd
    }
  }, Ho),
  boxplot: Object.assign({
    style: {
      max: {
        padding: Lc,
        stroke: fr[400],
        strokeWidth: 2
      },
      maxLabels: Object.assign({}, Hr, {
        padding: 3
      }),
      median: {
        padding: Lc,
        stroke: fr.white,
        strokeWidth: 2
      },
      medianLabels: Object.assign({}, Hr, {
        padding: 3
      }),
      min: {
        padding: Lc,
        stroke: fr[400],
        strokeWidth: 2
      },
      minLabels: Object.assign({}, Hr, {
        padding: 3
      }),
      q1: {
        padding: Lc,
        fill: Ll[0],
        rx: yd,
        strokeWidth: 2
      },
      q1Labels: Object.assign({}, Hr, {
        padding: 3
      }),
      q3: {
        padding: Lc,
        fill: Ll[1],
        rx: yd
      },
      q3Labels: Object.assign({}, Hr, {
        padding: 3
      })
    },
    boxWidth: 20
  }, Ho),
  candlestick: Object.assign({
    style: {
      data: {
        stroke: fr[300],
        strokeWidth: 0,
        rx: yd
      },
      labels: Object.assign({}, Hr, {
        padding: 5
      })
    },
    candleColors: {
      positive: fp[500],
      negative: Zy[500]
    },
    wickStrokeWidth: 2
  }, Ho),
  chart: Ho,
  errorbar: Object.assign({
    borderWidth: 8,
    style: {
      data: {
        fill: "transparent",
        opacity: 1,
        stroke: fr[700],
        strokeWidth: 2,
        strokeLinecap: vd
      },
      labels: Hr
    }
  }, Ho),
  group: Object.assign({
    colorScale: Ll
  }, Ho),
  histogram: Object.assign({
    style: {
      data: {
        fill: mk[500],
        fillOpacity: 0.5
      },
      labels: Hr
    },
    binSpacing: 4,
    cornerRadius: {
      top: yd
    }
  }, Ho),
  label: Hr,
  legend: {
    colorScale: Ll,
    gutter: 24,
    borderPadding: 10,
    orientation: "horizontal",
    titleOrientation: "top",
    centerTitle: !0,
    style: {
      data: {
        type: "circle"
      },
      labels: {
        ...Hr,
        fontSize: 12
      },
      title: Object.assign({}, Hr, {
        padding: Lc,
        fontSize: 16
      }),
      border: {
        stroke: fr[200],
        strokeWidth: 2,
        padding: 16
      }
    }
  },
  line: Object.assign({
    style: {
      data: {
        fill: "transparent",
        opacity: 1,
        stroke: Vm,
        strokeWidth: 2,
        strokeLinecap: vd,
        strokeLinejoin: Th
      },
      labels: Hr
    }
  }, Ho),
  pie: Object.assign({
    style: {
      parent: {
        backgroundColor: fr.white
      },
      data: {
        padding: Lc,
        stroke: fr.white,
        strokeWidth: 1
      },
      labels: {
        ...Hr,
        padding: 20,
        fill: fr[600],
        fontSize: 10
      }
    },
    colorScale: Ll,
    cornerRadius: yd
  }, Ho),
  scatter: Object.assign({
    style: {
      data: {
        fill: Vm,
        opacity: 1,
        stroke: "transparent",
        strokeWidth: 0
      },
      labels: {
        ...Hr,
        padding: 20
      }
    }
  }, Ho),
  stack: Object.assign({
    colorScale: Ll
  }, Ho),
  tooltip: {
    style: Object.assign({}, Hr, {
      padding: 0,
      pointerEvents: "none"
    }),
    flyoutStyle: {
      stroke: fr[300],
      strokeWidth: 2,
      fill: fr.white,
      pointerEvents: "none"
    },
    flyoutPadding: {
      top: 8,
      bottom: 8,
      left: 16,
      right: 16
    },
    cornerRadius: yd,
    pointerLength: 4
  },
  voronoi: Object.assign({
    style: {
      data: {
        fill: eb[100],
        stroke: Vm,
        strokeWidth: 2
      },
      labels: Object.assign({}, Hr, {
        padding: 5,
        pointerEvents: "none"
      }),
      flyout: {
        stroke: fr[900],
        strokeWidth: 1,
        fill: fr[100],
        pointerEvents: "none"
      },
      padding: {
        left: 2,
        bottom: 2
      }
    }
  }, Ho)
}, $a = {
  grayscale: aZe,
  material: wZe,
  clean: kZe
}, YR = function(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  if (n.length > 0)
    return n.reduce((o, a) => [o, YR(a)].join(" "), YR(e)).trim();
  if (e == null || typeof e == "string")
    return e;
  const i = [];
  for (const o in e)
    if (e.hasOwnProperty(o)) {
      const a = e[o];
      i.push(`${o}(${a})`);
    }
  return i.join(" ").trim();
};
function vk(e, t) {
  var f;
  t === void 0 && (t = $a.material);
  const {
    palette: {
      grayscale: n = ["#cccccc", "#969696", "#636363", "#252525"],
      qualitative: r = [],
      heatmap: i = [],
      warm: o = [],
      cool: a = [],
      red: s = [],
      blue: c = [],
      green: l = []
    } = {}
  } = t, u = {
    grayscale: n,
    qualitative: r,
    heatmap: i,
    warm: o,
    cool: a,
    red: s,
    blue: c,
    green: l
  };
  return e && ((f = u[e]) != null && f.length) ? u[e] : u.grayscale;
}
const MV = {
  "American Typewriter": {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.25, 0.4203125, 0.3296875, 0.6, 0.6375, 0.8015625, 0.8203125, 0.1875, 0.45625, 0.45625, 0.6375, 0.5, 0.2734375, 0.309375, 0.2734375, 0.4390625, 0.6375, 0.6375, 0.6375, 0.6375, 0.6375, 0.6375, 0.6375, 0.6375, 0.6375, 0.6375, 0.2734375, 0.2734375, 0.5, 0.5, 0.5, 0.6, 0.6921875, 0.7640625, 0.6921875, 0.6375, 0.728125, 0.6734375, 0.6203125, 0.7109375, 0.784375, 0.3828125, 0.6421875, 0.7859375, 0.6375, 0.9484375, 0.7640625, 0.65625, 0.6375, 0.65625, 0.7296875, 0.6203125, 0.6375, 0.7109375, 0.740625, 0.940625, 0.784375, 0.7578125, 0.6203125, 0.4375, 0.5, 0.4375, 0.5, 0.5, 0.4921875, 0.5734375, 0.5890625, 0.5109375, 0.6, 0.528125, 0.43125, 0.5578125, 0.6375, 0.3109375, 0.40625, 0.6234375, 0.309375, 0.928125, 0.6375, 0.546875, 0.6, 0.58125, 0.4921875, 0.4921875, 0.4, 0.6203125, 0.625, 0.825, 0.6375, 0.640625, 0.528125, 0.5, 0.5, 0.5, 0.6671875],
    avg: 0.5793421052631578
  },
  Arial: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.278125, 0.278125, 0.35625, 0.55625, 0.55625, 0.890625, 0.6671875, 0.1921875, 0.334375, 0.334375, 0.390625, 0.584375, 0.278125, 0.334375, 0.278125, 0.278125, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.278125, 0.278125, 0.584375, 0.584375, 0.584375, 0.55625, 1.015625, 0.6703125, 0.6671875, 0.7234375, 0.7234375, 0.6671875, 0.6109375, 0.778125, 0.7234375, 0.278125, 0.5, 0.6671875, 0.55625, 0.834375, 0.7234375, 0.778125, 0.6671875, 0.778125, 0.7234375, 0.6671875, 0.6109375, 0.7234375, 0.6671875, 0.9453125, 0.6671875, 0.6671875, 0.6109375, 0.278125, 0.278125, 0.278125, 0.4703125, 0.584375, 0.334375, 0.55625, 0.55625, 0.5, 0.55625, 0.55625, 0.3125, 0.55625, 0.55625, 0.2234375, 0.2703125, 0.5, 0.2234375, 0.834375, 0.55625, 0.55625, 0.55625, 0.55625, 0.346875, 0.5, 0.278125, 0.55625, 0.5, 0.7234375, 0.5, 0.5, 0.5, 0.334375, 0.2609375, 0.334375, 0.584375],
    avg: 0.528733552631579
  },
  "Arial Black": {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.33125, 0.334375, 0.5, 0.6609375, 0.6671875, 1, 0.890625, 0.278125, 0.390625, 0.390625, 0.55625, 0.6609375, 0.334375, 0.334375, 0.334375, 0.28125, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.334375, 0.334375, 0.6609375, 0.6609375, 0.6609375, 0.6109375, 0.7453125, 0.78125, 0.778125, 0.778125, 0.778125, 0.7234375, 0.6671875, 0.834375, 0.834375, 0.390625, 0.6671875, 0.834375, 0.6671875, 0.9453125, 0.834375, 0.834375, 0.7234375, 0.834375, 0.78125, 0.7234375, 0.7234375, 0.834375, 0.7796875, 1.003125, 0.78125, 0.78125, 0.7234375, 0.390625, 0.28125, 0.390625, 0.6609375, 0.5125, 0.334375, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.41875, 0.6671875, 0.6671875, 0.334375, 0.384375, 0.6671875, 0.334375, 1, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.4703125, 0.6109375, 0.4453125, 0.6671875, 0.6140625, 0.946875, 0.6671875, 0.615625, 0.55625, 0.390625, 0.278125, 0.390625, 0.6609375],
    avg: 0.6213157894736842
  },
  Baskerville: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.25, 0.25, 0.40625, 0.6671875, 0.490625, 0.875, 0.7015625, 0.178125, 0.2453125, 0.246875, 0.4171875, 0.6671875, 0.25, 0.3125, 0.25, 0.521875, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.25, 0.25, 0.6671875, 0.6671875, 0.6671875, 0.396875, 0.9171875, 0.684375, 0.615625, 0.71875, 0.7609375, 0.625, 0.553125, 0.771875, 0.803125, 0.3546875, 0.515625, 0.78125, 0.6046875, 0.928125, 0.75, 0.8234375, 0.5625, 0.96875, 0.7296875, 0.5421875, 0.6984375, 0.771875, 0.7296875, 0.9484375, 0.771875, 0.678125, 0.6359375, 0.3640625, 0.521875, 0.3640625, 0.46875, 0.5125, 0.334375, 0.46875, 0.521875, 0.428125, 0.521875, 0.4375, 0.3890625, 0.4765625, 0.53125, 0.25, 0.359375, 0.4640625, 0.240625, 0.803125, 0.53125, 0.5, 0.521875, 0.521875, 0.365625, 0.334375, 0.2921875, 0.521875, 0.4640625, 0.678125, 0.4796875, 0.465625, 0.428125, 0.4796875, 0.5109375, 0.4796875, 0.6671875],
    avg: 0.5323519736842108
  },
  Courier: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.5984375, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6078125, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.61875, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.615625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6140625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625],
    avg: 0.6020559210526316
  },
  "Courier New": {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.5984375, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625],
    avg: 0.6015296052631579
  },
  cursive: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.1921875, 0.24375, 0.40625, 0.5671875, 0.3984375, 0.721875, 0.909375, 0.2328125, 0.434375, 0.365625, 0.4734375, 0.5578125, 0.19375, 0.3484375, 0.19375, 0.7734375, 0.503125, 0.4171875, 0.5453125, 0.45, 0.6046875, 0.4703125, 0.5984375, 0.55625, 0.503125, 0.5546875, 0.20625, 0.2, 0.5625, 0.5546875, 0.546875, 0.403125, 0.70625, 0.734375, 0.7078125, 0.64375, 0.85, 0.753125, 0.75, 0.6484375, 1.0765625, 0.44375, 0.5359375, 0.8359375, 0.653125, 1.0109375, 1.1515625, 0.6796875, 0.6984375, 1.0625, 0.8234375, 0.5125, 0.9234375, 0.8546875, 0.70625, 0.9109375, 0.7421875, 0.715625, 0.6015625, 0.4640625, 0.3359375, 0.4109375, 0.5421875, 0.5421875, 0.4328125, 0.5125, 0.5, 0.3859375, 0.7375, 0.359375, 0.75625, 0.540625, 0.5328125, 0.3203125, 0.5296875, 0.5015625, 0.484375, 0.7890625, 0.5640625, 0.4203125, 0.703125, 0.471875, 0.4734375, 0.35, 0.4125, 0.5640625, 0.471875, 0.6484375, 0.5296875, 0.575, 0.4140625, 0.415625, 0.20625, 0.3796875, 0.5421875],
    avg: 0.5604440789473684
  },
  fantasy: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.215625, 0.2625, 0.3265625, 0.6109375, 0.534375, 0.7625, 0.7828125, 0.2, 0.4359375, 0.4359375, 0.3765625, 0.5109375, 0.2796875, 0.4609375, 0.2796875, 0.5296875, 0.6640625, 0.253125, 0.521875, 0.4765625, 0.6640625, 0.490625, 0.528125, 0.5546875, 0.496875, 0.5421875, 0.2796875, 0.2796875, 0.5625, 0.4609375, 0.5625, 0.4828125, 0.609375, 0.740625, 0.7234375, 0.740625, 0.8265625, 0.7234375, 0.6171875, 0.7359375, 0.765625, 0.240625, 0.5453125, 0.715625, 0.6078125, 0.8640625, 0.653125, 0.9125, 0.6484375, 0.946875, 0.6921875, 0.653125, 0.6953125, 0.8015625, 0.58125, 0.784375, 0.671875, 0.6265625, 0.690625, 0.4359375, 0.5296875, 0.4359375, 0.53125, 0.5, 0.2875, 0.5375, 0.603125, 0.4984375, 0.60625, 0.53125, 0.434375, 0.6421875, 0.56875, 0.209375, 0.4671875, 0.5484375, 0.2203125, 0.709375, 0.55, 0.5984375, 0.6140625, 0.5765625, 0.40625, 0.4734375, 0.3734375, 0.559375, 0.4421875, 0.6421875, 0.4890625, 0.578125, 0.4484375, 0.2546875, 0.2203125, 0.2546875, 0.55],
    avg: 0.536496710526316
  },
  Geneva: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.3328125, 0.3046875, 0.5, 0.6671875, 0.6671875, 0.90625, 0.728125, 0.3046875, 0.446875, 0.446875, 0.5078125, 0.6671875, 0.3046875, 0.3796875, 0.3046875, 0.5390625, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.3046875, 0.3046875, 0.6671875, 0.6671875, 0.6671875, 0.56875, 0.871875, 0.728125, 0.6375, 0.6515625, 0.7015625, 0.5765625, 0.5546875, 0.675, 0.690625, 0.2421875, 0.4921875, 0.6640625, 0.584375, 0.7890625, 0.709375, 0.7359375, 0.584375, 0.78125, 0.60625, 0.60625, 0.640625, 0.6671875, 0.728125, 0.946875, 0.6109375, 0.6109375, 0.5765625, 0.446875, 0.5390625, 0.446875, 0.6671875, 0.6671875, 0.5921875, 0.5546875, 0.6109375, 0.546875, 0.603125, 0.5765625, 0.390625, 0.6109375, 0.584375, 0.2359375, 0.334375, 0.5390625, 0.2359375, 0.8953125, 0.584375, 0.60625, 0.603125, 0.603125, 0.3875, 0.509375, 0.44375, 0.584375, 0.565625, 0.78125, 0.53125, 0.571875, 0.5546875, 0.4515625, 0.246875, 0.4515625, 0.6671875],
    avg: 0.5762664473684211
  },
  Georgia: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.2421875, 0.33125, 0.4125, 0.64375, 0.6109375, 0.81875, 0.7109375, 0.215625, 0.375, 0.375, 0.4734375, 0.64375, 0.2703125, 0.375, 0.2703125, 0.46875, 0.6140625, 0.4296875, 0.559375, 0.553125, 0.565625, 0.5296875, 0.5671875, 0.503125, 0.596875, 0.5671875, 0.3125, 0.3125, 0.64375, 0.64375, 0.64375, 0.4796875, 0.9296875, 0.715625, 0.6546875, 0.6421875, 0.75, 0.6546875, 0.6, 0.7265625, 0.815625, 0.390625, 0.51875, 0.7203125, 0.6046875, 0.928125, 0.7671875, 0.7453125, 0.6109375, 0.7453125, 0.7234375, 0.5625, 0.61875, 0.7578125, 0.70625, 0.99375, 0.7125, 0.6640625, 0.6015625, 0.375, 0.46875, 0.375, 0.64375, 0.65, 0.5, 0.5046875, 0.56875, 0.4546875, 0.575, 0.484375, 0.39375, 0.509375, 0.5828125, 0.29375, 0.3671875, 0.546875, 0.2875, 0.88125, 0.5921875, 0.5390625, 0.571875, 0.5640625, 0.4109375, 0.4328125, 0.3453125, 0.5765625, 0.5203125, 0.75625, 0.50625, 0.5171875, 0.4453125, 0.43125, 0.375, 0.43125, 0.64375],
    avg: 0.5551809210526316
  },
  "Gill Sans": {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.2765625, 0.271875, 0.3546875, 0.584375, 0.5421875, 0.6765625, 0.625, 0.1890625, 0.3234375, 0.3234375, 0.4171875, 0.584375, 0.2203125, 0.3234375, 0.2203125, 0.28125, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.2203125, 0.2296875, 0.584375, 0.584375, 0.584375, 0.334375, 1.0109375, 0.6671875, 0.5640625, 0.709375, 0.75, 0.5, 0.4703125, 0.740625, 0.7296875, 0.25, 0.3125, 0.65625, 0.490625, 0.78125, 0.78125, 0.8234375, 0.5109375, 0.8234375, 0.6046875, 0.459375, 0.6046875, 0.709375, 0.6046875, 1.0421875, 0.709375, 0.6046875, 0.646875, 0.334375, 0.28125, 0.334375, 0.4703125, 0.5828125, 0.334375, 0.428125, 0.5, 0.4390625, 0.5109375, 0.4796875, 0.296875, 0.428125, 0.5, 0.2203125, 0.2265625, 0.5, 0.2203125, 0.771875, 0.5, 0.553125, 0.5, 0.5, 0.3984375, 0.3859375, 0.334375, 0.5, 0.4390625, 0.7203125, 0.5, 0.4390625, 0.4171875, 0.334375, 0.2609375, 0.334375, 0.584375],
    avg: 0.4933717105263159
  },
  Helvetica: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.2796875, 0.2765625, 0.3546875, 0.5546875, 0.5546875, 0.8890625, 0.665625, 0.190625, 0.3328125, 0.3328125, 0.3890625, 0.5828125, 0.2765625, 0.3328125, 0.2765625, 0.3015625, 0.5546875, 0.5546875, 0.5546875, 0.5546875, 0.5546875, 0.5546875, 0.5546875, 0.5546875, 0.5546875, 0.5546875, 0.2765625, 0.2765625, 0.584375, 0.5828125, 0.584375, 0.5546875, 1.0140625, 0.665625, 0.665625, 0.721875, 0.721875, 0.665625, 0.609375, 0.7765625, 0.721875, 0.2765625, 0.5, 0.665625, 0.5546875, 0.8328125, 0.721875, 0.7765625, 0.665625, 0.7765625, 0.721875, 0.665625, 0.609375, 0.721875, 0.665625, 0.94375, 0.665625, 0.665625, 0.609375, 0.2765625, 0.3546875, 0.2765625, 0.4765625, 0.5546875, 0.3328125, 0.5546875, 0.5546875, 0.5, 0.5546875, 0.5546875, 0.2765625, 0.5546875, 0.5546875, 0.221875, 0.240625, 0.5, 0.221875, 0.8328125, 0.5546875, 0.5546875, 0.5546875, 0.5546875, 0.3328125, 0.5, 0.2765625, 0.5546875, 0.5, 0.721875, 0.5, 0.5, 0.5, 0.3546875, 0.259375, 0.353125, 0.5890625],
    avg: 0.5279276315789471
  },
  "Helvetica Neue": {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.278125, 0.259375, 0.4265625, 0.55625, 0.55625, 1, 0.6453125, 0.278125, 0.2703125, 0.26875, 0.353125, 0.6, 0.278125, 0.3890625, 0.278125, 0.36875, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.278125, 0.278125, 0.6, 0.6, 0.6, 0.55625, 0.8, 0.6625, 0.6859375, 0.7234375, 0.7046875, 0.6125, 0.575, 0.759375, 0.7234375, 0.259375, 0.5203125, 0.6703125, 0.55625, 0.871875, 0.7234375, 0.7609375, 0.6484375, 0.7609375, 0.6859375, 0.6484375, 0.575, 0.7234375, 0.6140625, 0.9265625, 0.6125, 0.6484375, 0.6125, 0.259375, 0.36875, 0.259375, 0.6, 0.5, 0.25625, 0.5375, 0.59375, 0.5375, 0.59375, 0.5375, 0.2984375, 0.575, 0.55625, 0.2234375, 0.2375, 0.5203125, 0.2234375, 0.853125, 0.55625, 0.575, 0.59375, 0.59375, 0.334375, 0.5, 0.315625, 0.55625, 0.5, 0.759375, 0.51875, 0.5, 0.48125, 0.334375, 0.2234375, 0.334375, 0.6],
    avg: 0.5279440789473684
  },
  "Hoefler Text": {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.2359375, 0.2234375, 0.3921875, 0.7125, 0.49375, 0.8859375, 0.771875, 0.2125, 0.3078125, 0.309375, 0.375, 0.4234375, 0.234375, 0.3125, 0.234375, 0.3, 0.5828125, 0.365625, 0.434375, 0.3921875, 0.5234375, 0.3984375, 0.5125, 0.4328125, 0.46875, 0.5125, 0.234375, 0.234375, 0.515625, 0.4234375, 0.515625, 0.340625, 0.7609375, 0.7359375, 0.6359375, 0.721875, 0.8125, 0.6375, 0.5875, 0.8078125, 0.853125, 0.4296875, 0.503125, 0.78125, 0.609375, 0.9609375, 0.8515625, 0.8140625, 0.6125, 0.8140625, 0.71875, 0.49375, 0.7125, 0.76875, 0.771875, 1.125, 0.7765625, 0.7734375, 0.65625, 0.321875, 0.3078125, 0.321875, 0.3546875, 0.5, 0.3375, 0.446875, 0.5359375, 0.45, 0.5296875, 0.4546875, 0.425, 0.4921875, 0.54375, 0.2671875, 0.240625, 0.5390625, 0.25, 0.815625, 0.5375, 0.5234375, 0.5390625, 0.5421875, 0.365625, 0.36875, 0.35625, 0.5171875, 0.5015625, 0.75, 0.5, 0.509375, 0.44375, 0.2421875, 0.14375, 0.2421875, 0.35],
    avg: 0.5116447368421051
  },
  Inter: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.2796875, 0.2890625, 0.4671875, 0.634375, 0.6421875, 0.9828125, 0.6453125, 0.3, 0.365625, 0.365625, 0.5015625, 0.6625, 0.2890625, 0.4609375, 0.2890625, 0.3609375, 0.63125, 0.4078125, 0.6109375, 0.61875, 0.646875, 0.59375, 0.6203125, 0.5671875, 0.61875, 0.6203125, 0.2890625, 0.303125, 0.6625, 0.6625, 0.6625, 0.5125, 0.9671875, 0.690625, 0.6546875, 0.73125, 0.721875, 0.6015625, 0.590625, 0.746875, 0.74375, 0.26875, 0.571875, 0.671875, 0.565625, 0.9046875, 0.7546875, 0.765625, 0.6390625, 0.765625, 0.64375, 0.6421875, 0.646875, 0.7453125, 0.690625, 0.9859375, 0.6828125, 0.6796875, 0.6296875, 0.365625, 0.3609375, 0.365625, 0.471875, 0.45625, 0.3234375, 0.5625, 0.6125, 0.571875, 0.6125, 0.584375, 0.3703125, 0.6140625, 0.5921875, 0.2421875, 0.2548828125, 0.55, 0.2421875, 0.8765625, 0.5921875, 0.6, 0.6125, 0.6125, 0.3765625, 0.528125, 0.328125, 0.5921875, 0.5625, 0.81875, 0.546875, 0.5625, 0.553125, 0.4265625, 0.3328125, 0.4265625, 0.6625],
    avg: 0.5624362664473683
  },
  Montserrat: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.2625, 0.2609375, 0.3734375, 0.696875, 0.615625, 0.8296875, 0.6703125, 0.203125, 0.3296875, 0.3296875, 0.3875, 0.575, 0.2125, 0.3828125, 0.2125, 0.3953125, 0.6625, 0.3625, 0.56875, 0.5640625, 0.6625, 0.5671875, 0.609375, 0.5890625, 0.6390625, 0.609375, 0.2125, 0.2125, 0.575, 0.575, 0.575, 0.5671875, 1.034375, 0.7171875, 0.7546875, 0.7203125, 0.8265625, 0.6703125, 0.634375, 0.7734375, 0.8140625, 0.303125, 0.5078125, 0.7125, 0.5890625, 0.95625, 0.8140625, 0.8390625, 0.71875, 0.8390625, 0.7234375, 0.615625, 0.575, 0.7921875, 0.6984375, 1.1125, 0.65625, 0.6359375, 0.6515625, 0.31875, 0.396875, 0.31875, 0.5765625, 0.5, 0.6, 0.590625, 0.678125, 0.5640625, 0.678125, 0.6046875, 0.375, 0.6875, 0.678125, 0.2703125, 0.365625, 0.6015625, 0.2703125, 1.0625, 0.678125, 0.628125, 0.678125, 0.678125, 0.4015625, 0.4890625, 0.40625, 0.6734375, 0.5421875, 0.8796875, 0.534375, 0.5671875, 0.5125, 0.334375, 0.2953125, 0.334375, 0.575],
    avg: 0.571792763157895
  },
  monospace: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.5984375, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6078125, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.61875, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.615625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6140625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625],
    avg: 0.6020559210526316
  },
  Overpass: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.2296875, 0.2765625, 0.4203125, 0.68125, 0.584375, 0.8515625, 0.7015625, 0.2203125, 0.3453125, 0.3453125, 0.53125, 0.63125, 0.2234375, 0.3953125, 0.2234375, 0.509375, 0.65, 0.4046875, 0.6171875, 0.60625, 0.6484375, 0.60625, 0.6015625, 0.5375, 0.615625, 0.6015625, 0.2234375, 0.2234375, 0.63125, 0.63125, 0.63125, 0.5015625, 0.8203125, 0.696875, 0.6671875, 0.65, 0.6859375, 0.6015625, 0.559375, 0.690625, 0.7078125, 0.2953125, 0.565625, 0.678125, 0.58125, 0.8046875, 0.7109375, 0.740625, 0.6421875, 0.740625, 0.6765625, 0.6046875, 0.590625, 0.696875, 0.6640625, 0.853125, 0.65, 0.6671875, 0.6625, 0.3734375, 0.509375, 0.3734375, 0.63125, 0.5125, 0.4, 0.5328125, 0.5625, 0.51875, 0.5625, 0.546875, 0.3359375, 0.5625, 0.565625, 0.25625, 0.3203125, 0.55, 0.265625, 0.85, 0.565625, 0.5671875, 0.5625, 0.5625, 0.4046875, 0.4765625, 0.3796875, 0.565625, 0.521875, 0.7265625, 0.53125, 0.5390625, 0.5125, 0.3671875, 0.275, 0.3671875, 0.63125],
    avg: 0.5430756578947369
  },
  Palatino: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.25, 0.278125, 0.371875, 0.60625, 0.5, 0.840625, 0.778125, 0.209375, 0.334375, 0.334375, 0.390625, 0.60625, 0.2578125, 0.334375, 0.25, 0.60625, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.25, 0.25, 0.60625, 0.60625, 0.60625, 0.4453125, 0.7484375, 0.778125, 0.6109375, 0.709375, 0.775, 0.6109375, 0.55625, 0.7640625, 0.8328125, 0.3375, 0.346875, 0.7265625, 0.6109375, 0.946875, 0.83125, 0.7875, 0.6046875, 0.7875, 0.66875, 0.525, 0.6140625, 0.778125, 0.7234375, 1, 0.6671875, 0.6671875, 0.6671875, 0.334375, 0.60625, 0.334375, 0.60625, 0.5, 0.334375, 0.5, 0.565625, 0.4453125, 0.6109375, 0.4796875, 0.340625, 0.55625, 0.5828125, 0.2921875, 0.2671875, 0.5640625, 0.2921875, 0.8828125, 0.5828125, 0.546875, 0.6015625, 0.5609375, 0.3953125, 0.425, 0.3265625, 0.603125, 0.565625, 0.834375, 0.5171875, 0.55625, 0.5, 0.334375, 0.60625, 0.334375, 0.60625],
    avg: 0.5408552631578947
  },
  RedHatText: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.2328125, 0.2203125, 0.35625, 0.6890625, 0.55, 0.7390625, 0.6703125, 0.2140625, 0.4015625, 0.4015625, 0.4546875, 0.53125, 0.2203125, 0.45625, 0.2203125, 0.515625, 0.6609375, 0.3078125, 0.5484375, 0.5875, 0.61875, 0.5703125, 0.6203125, 0.559375, 0.6140625, 0.6203125, 0.2203125, 0.2234375, 0.465625, 0.534375, 0.465625, 0.5125, 0.7671875, 0.6609375, 0.6703125, 0.7265625, 0.728125, 0.6203125, 0.6109375, 0.8, 0.73125, 0.253125, 0.6, 0.6125, 0.6078125, 0.8625, 0.7390625, 0.8109375, 0.6546875, 0.809375, 0.6484375, 0.6234375, 0.6171875, 0.7125, 0.6609375, 0.8984375, 0.6546875, 0.646875, 0.60625, 0.3625, 0.5203125, 0.3625, 0.540625, 0.4609375, 0.5234375, 0.5265625, 0.584375, 0.509375, 0.5828125, 0.5578125, 0.3703125, 0.5828125, 0.553125, 0.2234375, 0.24375, 0.4890625, 0.2234375, 0.8453125, 0.553125, 0.58125, 0.584375, 0.5828125, 0.353125, 0.453125, 0.378125, 0.553125, 0.5015625, 0.6984375, 0.4875, 0.4984375, 0.459375, 0.3953125, 0.2921875, 0.3953125, 0.58125],
    avg: 0.5341940789473685
  },
  "sans-serif": {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.278125, 0.278125, 0.35625, 0.55625, 0.55625, 0.890625, 0.6671875, 0.1921875, 0.334375, 0.334375, 0.390625, 0.584375, 0.278125, 0.334375, 0.278125, 0.303125, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.278125, 0.278125, 0.5859375, 0.584375, 0.5859375, 0.55625, 1.015625, 0.6671875, 0.6671875, 0.7234375, 0.7234375, 0.6671875, 0.6109375, 0.778125, 0.7234375, 0.278125, 0.5, 0.6671875, 0.55625, 0.834375, 0.7234375, 0.778125, 0.6671875, 0.778125, 0.7234375, 0.6671875, 0.6109375, 0.7234375, 0.6671875, 0.9453125, 0.6671875, 0.6671875, 0.6109375, 0.278125, 0.35625, 0.278125, 0.478125, 0.55625, 0.334375, 0.55625, 0.55625, 0.5, 0.55625, 0.55625, 0.278125, 0.55625, 0.55625, 0.2234375, 0.2421875, 0.5, 0.2234375, 0.834375, 0.55625, 0.55625, 0.55625, 0.55625, 0.334375, 0.5, 0.278125, 0.55625, 0.5, 0.7234375, 0.5, 0.5, 0.5, 0.35625, 0.2609375, 0.3546875, 0.590625],
    avg: 0.5293256578947368
  },
  Seravek: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.215625, 0.296875, 0.4171875, 0.6734375, 0.4953125, 0.9125, 0.740625, 0.2421875, 0.3375, 0.3375, 0.409375, 0.60625, 0.2609375, 0.35625, 0.25625, 0.41875, 0.5921875, 0.3515625, 0.475, 0.4875, 0.5375, 0.509375, 0.5484375, 0.4546875, 0.5421875, 0.5484375, 0.25625, 0.2546875, 0.5875, 0.6171875, 0.5875, 0.4578125, 0.8140625, 0.6765625, 0.5703125, 0.6109375, 0.684375, 0.5109375, 0.4953125, 0.678125, 0.6859375, 0.2625, 0.2625, 0.5859375, 0.4734375, 0.846875, 0.709375, 0.740625, 0.509375, 0.740625, 0.584375, 0.5015625, 0.528125, 0.675, 0.5953125, 0.9453125, 0.596875, 0.540625, 0.540625, 0.359375, 0.4203125, 0.359375, 0.5109375, 0.421875, 0.4046875, 0.5015625, 0.5421875, 0.446875, 0.5453125, 0.484375, 0.38125, 0.5140625, 0.5546875, 0.240625, 0.2640625, 0.490625, 0.2765625, 0.8625, 0.5546875, 0.546875, 0.5453125, 0.5453125, 0.3625, 0.41875, 0.3890625, 0.5453125, 0.4703125, 0.7546875, 0.4921875, 0.4609375, 0.453125, 0.4015625, 0.2640625, 0.4015625, 0.58125],
    avg: 0.5044078947368421
  },
  serif: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.2484375, 0.334375, 0.409375, 0.5, 0.5, 0.834375, 0.778125, 0.18125, 0.334375, 0.334375, 0.5, 0.5640625, 0.25, 0.334375, 0.25, 0.278125, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.278125, 0.278125, 0.5640625, 0.5640625, 0.5640625, 0.4453125, 0.921875, 0.7234375, 0.6671875, 0.6671875, 0.7234375, 0.6109375, 0.55625, 0.7234375, 0.7234375, 0.334375, 0.390625, 0.7234375, 0.6109375, 0.890625, 0.7234375, 0.7234375, 0.55625, 0.7234375, 0.6671875, 0.55625, 0.6109375, 0.7234375, 0.7234375, 0.9453125, 0.7234375, 0.7234375, 0.6109375, 0.334375, 0.340625, 0.334375, 0.4703125, 0.5, 0.3453125, 0.4453125, 0.5, 0.4453125, 0.5, 0.4453125, 0.3828125, 0.5, 0.5, 0.278125, 0.3359375, 0.5, 0.278125, 0.778125, 0.5, 0.5, 0.5, 0.5, 0.3375, 0.390625, 0.2796875, 0.5, 0.5, 0.7234375, 0.5, 0.5, 0.4453125, 0.48125, 0.2015625, 0.48125, 0.5421875],
    avg: 0.5126315789473684
  },
  Tahoma: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.3109375, 0.3328125, 0.4015625, 0.728125, 0.546875, 0.9765625, 0.70625, 0.2109375, 0.3828125, 0.3828125, 0.546875, 0.728125, 0.303125, 0.3640625, 0.303125, 0.3953125, 0.546875, 0.546875, 0.546875, 0.546875, 0.546875, 0.546875, 0.546875, 0.546875, 0.546875, 0.546875, 0.3546875, 0.3546875, 0.728125, 0.728125, 0.728125, 0.475, 0.909375, 0.6109375, 0.590625, 0.6015625, 0.6796875, 0.5625, 0.521875, 0.66875, 0.6765625, 0.3734375, 0.4171875, 0.6046875, 0.4984375, 0.771875, 0.66875, 0.7078125, 0.5515625, 0.7078125, 0.6375, 0.5578125, 0.5875, 0.65625, 0.60625, 0.903125, 0.58125, 0.5890625, 0.559375, 0.3828125, 0.39375, 0.3828125, 0.728125, 0.5625, 0.546875, 0.525, 0.553125, 0.4625, 0.553125, 0.5265625, 0.3546875, 0.553125, 0.5578125, 0.2296875, 0.328125, 0.51875, 0.2296875, 0.840625, 0.5578125, 0.54375, 0.553125, 0.553125, 0.3609375, 0.446875, 0.3359375, 0.5578125, 0.4984375, 0.7421875, 0.4953125, 0.4984375, 0.4453125, 0.48125, 0.3828125, 0.48125, 0.728125],
    avg: 0.5384374999999998
  },
  "Times New Roman": {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.2484375, 0.334375, 0.409375, 0.5, 0.5, 0.834375, 0.778125, 0.18125, 0.334375, 0.334375, 0.5, 0.5640625, 0.25, 0.334375, 0.25, 0.28125, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.278125, 0.278125, 0.5640625, 0.5640625, 0.5640625, 0.4453125, 0.921875, 0.7234375, 0.6671875, 0.6671875, 0.7234375, 0.6109375, 0.55625, 0.7234375, 0.7234375, 0.334375, 0.390625, 0.73125, 0.6109375, 0.890625, 0.7375, 0.7234375, 0.55625, 0.7234375, 0.6765625, 0.55625, 0.6109375, 0.7234375, 0.7234375, 0.9453125, 0.7234375, 0.7234375, 0.6109375, 0.334375, 0.28125, 0.334375, 0.4703125, 0.51875, 0.334375, 0.4453125, 0.503125, 0.4453125, 0.503125, 0.4453125, 0.4359375, 0.5, 0.5, 0.278125, 0.35625, 0.50625, 0.278125, 0.778125, 0.5, 0.5, 0.5046875, 0.5, 0.340625, 0.390625, 0.2796875, 0.5, 0.5, 0.7234375, 0.5, 0.5, 0.4453125, 0.48125, 0.2015625, 0.48125, 0.5421875],
    avg: 0.5134375
  },
  "Trebuchet MS": {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.3015625, 0.3671875, 0.325, 0.53125, 0.525, 0.6015625, 0.70625, 0.1609375, 0.3671875, 0.3671875, 0.3671875, 0.525, 0.3671875, 0.3671875, 0.3671875, 0.525, 0.525, 0.525, 0.525, 0.525, 0.525, 0.525, 0.525, 0.525, 0.525, 0.525, 0.3671875, 0.3671875, 0.525, 0.525, 0.525, 0.3671875, 0.771875, 0.590625, 0.5671875, 0.5984375, 0.6140625, 0.5359375, 0.525, 0.6765625, 0.6546875, 0.2796875, 0.4765625, 0.5765625, 0.5078125, 0.7109375, 0.6390625, 0.675, 0.5578125, 0.7421875, 0.5828125, 0.48125, 0.58125, 0.6484375, 0.5875, 0.853125, 0.5578125, 0.5703125, 0.5515625, 0.3671875, 0.3578125, 0.3671875, 0.525, 0.53125, 0.525, 0.5265625, 0.5578125, 0.4953125, 0.5578125, 0.546875, 0.375, 0.503125, 0.546875, 0.2859375, 0.3671875, 0.5046875, 0.2953125, 0.83125, 0.546875, 0.5375, 0.5578125, 0.5578125, 0.3890625, 0.40625, 0.396875, 0.546875, 0.490625, 0.7453125, 0.5015625, 0.49375, 0.475, 0.3671875, 0.525, 0.3671875, 0.525],
    avg: 0.5085197368421052
  },
  Verdana: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.35, 0.39375, 0.459375, 0.81875, 0.6359375, 1.0765625, 0.759375, 0.26875, 0.4546875, 0.4546875, 0.6359375, 0.81875, 0.3640625, 0.4546875, 0.3640625, 0.4703125, 0.6359375, 0.6359375, 0.6359375, 0.6359375, 0.6359375, 0.6359375, 0.6359375, 0.6359375, 0.6359375, 0.6359375, 0.4546875, 0.4546875, 0.81875, 0.81875, 0.81875, 0.546875, 1, 0.684375, 0.6859375, 0.6984375, 0.771875, 0.6328125, 0.575, 0.7765625, 0.7515625, 0.421875, 0.4546875, 0.69375, 0.5578125, 0.84375, 0.7484375, 0.7875, 0.603125, 0.7875, 0.7, 0.684375, 0.6171875, 0.7328125, 0.684375, 0.9890625, 0.6859375, 0.615625, 0.6859375, 0.4546875, 0.46875, 0.4546875, 0.81875, 0.6421875, 0.6359375, 0.6015625, 0.6234375, 0.521875, 0.6234375, 0.596875, 0.384375, 0.6234375, 0.6328125, 0.275, 0.3765625, 0.5921875, 0.275, 0.9734375, 0.6328125, 0.6078125, 0.6234375, 0.6234375, 0.43125, 0.521875, 0.3953125, 0.6328125, 0.5921875, 0.81875, 0.5921875, 0.5921875, 0.5265625, 0.6359375, 0.4546875, 0.6359375, 0.81875],
    avg: 0.6171875000000003
  }
}, kV = {
  mm: 3.8,
  sm: 38,
  pt: 1.33,
  pc: 16,
  in: 96,
  px: 1
}, NV = {
  em: 1,
  ex: 0.5
}, $ie = {
  heightOverlapCoef: 1.05,
  // Coefficient for height value to prevent overlap.
  lineCapitalCoef: 1.15
  // Coefficient for height value. Reserve space for capital chars.
}, Aie = {
  lineHeight: 1,
  letterSpacing: "0px",
  fontSize: 0,
  angle: 0,
  fontFamily: ""
}, NZe = (e) => e * Math.PI / 180, DZe = (e) => {
  const n = e.split(",").map((r) => r.replace(/'|"/g, "")).find((r) => MV[r]) || "Helvetica";
  return MV[n];
}, yk = (e) => Array.isArray(e) ? e : e.toString().split(/\r\n|\r|\n/g), Hw = (e, t, n) => {
  const r = NZe(n);
  return Math.abs(Math.cos(r) * e) + Math.abs(Math.sin(r) * t);
}, XR = (e, t) => {
  var o;
  const n = (o = e.match(/[a-zA-Z%]+/)) == null ? void 0 : o[0], r = Number(e.match(/[0-9.,]+/));
  let i;
  return n ? kV.hasOwnProperty(n) ? i = r * kV[n] : NV.hasOwnProperty(n) ? i = (t ? r * t : r * Aie.fontSize) * NV[n] : i = r : i = r || 0, i;
}, bk = (e, t) => {
  const n = Array.isArray(e) ? e[t] : e, r = qe({}, n, Aie);
  return Object.assign({}, r, {
    fontFamily: r.fontFamily,
    letterSpacing: typeof r.letterSpacing == "number" ? r.letterSpacing : XR(String(r.letterSpacing), r.fontSize),
    fontSize: typeof r.fontSize == "number" ? r.fontSize : XR(String(r.fontSize))
  });
}, jZe = (e, t) => {
  if (e === void 0 || e === "" || e === null)
    return 0;
  const n = yk(e).map((r, i) => {
    const o = r.toString().length, {
      fontSize: a,
      letterSpacing: s,
      fontFamily: c
    } = bk(t, i), l = DZe(c);
    return r.toString().split("").map((d) => d.charCodeAt(0) < l.widths.length ? l.widths[d.charCodeAt(0)] : l.avg).reduce((d, f) => f + d, 0) * a + s * Math.max(o - 1, 0);
  });
  return Math.max(...n);
}, LZe = (e, t) => e === void 0 || e === "" || e === null ? 0 : yk(e).reduce((n, r, i) => {
  const o = bk(t, i), s = r.toString().match(/[(A-Z)(0-9)]/) ? o.fontSize * $ie.lineCapitalCoef : o.fontSize;
  return n + o.lineHeight * s;
}, 0), FZe = (e, t) => {
  const n = Array.isArray(t) ? t[0] && t[0].angle : t && t.angle, r = LZe(e, t), i = jZe(e, t), o = n ? Hw(i, r, n) : i, a = n ? Hw(r, i, n) : r;
  return {
    width: o,
    height: a * $ie.heightOverlapCoef
  };
}, aI = ete(() => {
  const e = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  e.setAttribute("xlink", "http://www.w3.org/1999/xlink"), e.setAttribute("width", "300"), e.setAttribute("height", "300"), e.setAttribute("viewBox", "0 0 300 300"), e.setAttribute("aria-hidden", "true");
  const t = document.createElementNS("http://www.w3.org/2000/svg", "text");
  return e.appendChild(t), e.style.position = "fixed", e.style.top = "-9999px", e.style.left = "-9999px", document.body.appendChild(e), t;
}), DV = (e) => e ? `${e.angle}:${e.fontFamily}:${e.fontSize}:${e.letterSpacing}:${e.lineHeight}` : "null", VZe = ete((e, t) => {
  var a, s;
  let n = aI();
  n.isConnected || ((s = (a = aI.cache).clear) == null || s.call(a), n = aI());
  const r = yk(e);
  let i = 0;
  for (const [c, l] of r.entries()) {
    const u = document.createElementNS("http://www.w3.org/2000/svg", "tspan"), d = bk(t, c);
    u.style.fontFamily = d.fontFamily, u.style.fontSize = `${d.fontSize}px`, u.style.lineHeight = d.lineHeight, u.style.fontFamily = d.fontFamily, u.style.letterSpacing = d.letterSpacing, u.textContent = l, u.setAttribute("x", "0"), u.setAttribute("y", `${i}`), n.appendChild(u), i += d.lineHeight * u.getBoundingClientRect().height;
  }
  const {
    width: o
  } = n.getBoundingClientRect();
  return n.innerHTML = "", {
    width: t != null && t.angle ? Hw(o, i, t == null ? void 0 : t.angle) : o,
    height: t != null && t.angle ? Hw(i, o, t == null ? void 0 : t.angle) : i
  };
}, (e, t) => {
  const n = Array.isArray(e) ? e.join() : e, r = Array.isArray(t) ? t.map(DV).join() : DV(t);
  return `${n}::${r}`;
}), BZe = {
  impl: function(e, t, n) {
    return n === void 0 && (n = !1), !(typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u") || n ? FZe(e, t) : VZe(e, t);
  }
}, hp = (e, t) => BZe.impl(e, t);
function zZe(e, t, n, r) {
  for (var i = -1, o = e == null ? 0 : e.length; ++i < o; ) {
    var a = e[i];
    t(r, a, n(a), e);
  }
  return r;
}
var HZe = zZe, UZe = p3;
function WZe(e, t, n, r) {
  return UZe(e, function(i, o, a) {
    t(r, i, n(i), a);
  }), r;
}
var qZe = WZe, GZe = HZe, KZe = qZe, YZe = em, XZe = Yi;
function QZe(e, t) {
  return function(n, r) {
    var i = XZe(n) ? GZe : KZe, o = t ? t() : {};
    return i(n, e, YZe(r), o);
  };
}
var JZe = QZe, ZZe = hC, eet = JZe, tet = Object.prototype, net = tet.hasOwnProperty, ret = eet(function(e, t, n) {
  net.call(e, n) ? e[n].push(t) : ZZe(e, n, [t]);
}), iet = ret;
const _k = /* @__PURE__ */ vn(iet);
var oet = em, aet = qte;
function set(e, t) {
  return e && e.length ? aet(e, oet(t)) : [];
}
var cet = set;
const Sk = /* @__PURE__ */ vn(cet);
function uet(e) {
  let {
    children: t,
    props: n,
    childComponents: r,
    parentProps: i
  } = e;
  const o = t.some((c) => c.type && c.type.role === "histogram"), a = o && t.length && t.every((c) => c.type && c.type.role === "histogram");
  if (o && !a && pk("VictoryHistogram only supports being stacked with other VictoryHistogram components. Check to make sure that you are only passing VictoryHistogram components to VictoryStack"), !a)
    return i;
  let s = n.bins || r[0].props.bins;
  if (!Array.isArray(s)) {
    const c = t.reduce((u, d) => {
      const f = mC(d.props.x || "x");
      return u.concat(d.props.data.map((h) => ({
        x: f(h)
      })));
    }, []), l = t[0].type.getFormattedData;
    s = l({
      data: c,
      bins: s
    }).reduce((u, d, f) => {
      let {
        x0: h,
        x1: p
      } = d;
      return f === 0 ? u.concat([h, p]) : u.concat(p);
    }, []);
  }
  return {
    ...i,
    bins: s
  };
}
function Rie(e, t) {
  const {
    polar: n,
    startAngle: r,
    endAngle: i,
    categories: o,
    minDomain: a,
    maxDomain: s
  } = e;
  let c = {
    polar: n,
    startAngle: r,
    endAngle: i,
    categories: o,
    minDomain: a,
    maxDomain: s
  }, l = 0;
  const u = t ? t.slice(0) : j.Children.toArray(e.children);
  c = uet({
    children: u,
    props: e,
    childComponents: t,
    parentProps: c
  });
  const d = (m, v, y) => {
    const _ = Object.assign({}, m.props, c);
    let b, w = m;
    if (dre(m))
      m.type && Rn(m.type.getData) ? (w = y ? /* @__PURE__ */ j.cloneElement(m, y.props) : m, b = w.type.getData(_)) : b = Do(_);
    else
      return null;
    return l += 1, b.map((C, x) => Object.assign({
      _stack: l,
      _group: x
    }, C));
  }, f = u.filter((m) => m.type && m.type.role === "stack").length, p = im(u, d, e, [], (m, v) => m.concat(Sk(v, "_group")));
  return Object.values(_k(p, f ? "_group" : "_stack"));
}
function Pie(e, t, n) {
  const {
    datasets: r,
    horizontal: i
  } = e, o = i ? kr(e, "y") : kr(e, "x"), a = Math.abs(o[1] - o[0]), s = n !== void 0 ? n : Array.isArray(r[0]) && r[0].length || 1, l = (t || r.length) * s;
  return Math.round(0.5 * a / l);
}
function det(e, t, n) {
  if (e.polar || t !== "x")
    return;
  const r = n.filter((u) => u.type && u.type.role && u.type.role === "group");
  if (r.length < 1)
    return;
  const {
    offset: i,
    children: o
  } = r[0].props;
  if (!i)
    return;
  const a = Array.isArray(o) && o[0];
  if (!a)
    return;
  let s = a.props.barWidth, c = a.props.data && a.props.data.length || 1;
  if (a && a.type.role === "stack") {
    const u = a.props.children && a.props.children[0];
    if (!u)
      return;
    s = u.props.barWidth, c = a.props.children.length;
  }
  const l = s || Pie(e, o.length, c);
  return {
    x: l * o.length / 2 + (i - l * ((o.length - 1) / 2))
  };
}
function fet(e, t, n) {
  const r = n ? n.slice(0) : j.Children.toArray(e.children), i = e.data ? Do(e) : void 0, {
    polar: o,
    startAngle: a,
    endAngle: s,
    categories: c,
    minDomain: l,
    maxDomain: u,
    horizontal: d
  } = e, f = {
    horizontal: d,
    polar: o,
    startAngle: a,
    endAngle: s,
    minDomain: l,
    maxDomain: u,
    categories: c
  }, h = i ? Object.assign(f, {
    data: i
  }) : f, g = im(r, (y) => {
    const _ = Object.assign({}, y.props, h);
    if (fre(y)) {
      if (y.type && Rn(y.type.getDomain))
        return y.props && y.type.getDomain(_, t);
    } else
      return null;
    return Mf(_, t);
  }, e), m = g.length === 0 ? 0 : Ea(g), v = g.length === 0 ? 1 : xa(g);
  return [m, v];
}
function Wv(e, t, n) {
  const r = n || j.Children.toArray(e.children), i = Z3(e, t), o = det(e, t, r);
  let a;
  if (i)
    a = i;
  else {
    const s = ud(e, t), c = ld(e, t), l = (e.data || e.y) && Do(e), u = l ? J3(e, t, l) : [], d = fet(e, t, r), f = s || Ea([...u, ...d]), h = c || xa([...u, ...d]);
    a = Ps(f, h);
  }
  return Q3(a, Object.assign({
    domainPadding: o
  }, e), t);
}
function gp(e, t, n) {
  if (e.data)
    return ra(e, t);
  const r = n ? n.slice(0) : j.Children.toArray(e.children), o = bl(im(r, (a) => {
    const s = Object.assign({}, a.props, {
      horizontal: e.horizontal
    });
    return Nw(s, t);
  }, e));
  return o.length > 1 ? Hv("linear") : Hv(o[0]);
}
function wk(e) {
  const n = C3(e, ["groupComponent", "containerComponent", "labelComponent"]);
  let r = e.events;
  return Array.isArray(n) && (r = Array.isArray(e.events) ? n.concat(...e.events) : n), r || [];
}
function het(e, t, n, r) {
  const {
    style: i
  } = e;
  let {
    colorScale: o,
    color: a
  } = e;
  if (i && i.data && i.data.fill)
    return i.data.fill;
  if (o = t.props && t.props.colorScale ? t.props.colorScale : o, a = t.props && t.props.color ? t.props.color : a, !o && !a)
    return;
  const s = Array.isArray(o) ? o : vk(o, r);
  return a || s[n % s.length];
}
function Oie(e, t, n) {
  const r = e && e[n] && e[n].style ? e[n].style : {};
  return rm(t, r);
}
function Mie(e, t, n, r) {
  const {
    style: i,
    role: o
  } = n, a = e.props.style || {};
  if (Array.isArray(a))
    return a;
  const s = e.type && e.type.role, c = s === "stack" ? void 0 : het(n, e, t, r), l = s === "line" ? {
    fill: "none",
    stroke: c
  } : {
    fill: c
  }, u = o === "stack" ? {} : {
    width: Pie(n)
  }, d = qe({}, a.data, Object.assign({}, u, i.data, l)), f = qe({}, a.labels, i.labels);
  return {
    ...a,
    parent: i.parent,
    data: d,
    labels: f
  };
}
function get(e, t) {
  const n = (r) => {
    if (!fre(r))
      return null;
    const i = r.props || {};
    return lp(i, t);
  };
  return im(e.slice(0), n);
}
function pet(e) {
  const t = (i) => {
    const o = i.props || {};
    let a;
    if (dre(i))
      i.type && Rn(i.type.getData) ? a = i.type.getData(o) : a = Do(o);
    else
      return null;
    return a.map((s) => ({
      x: s.xName,
      y: s.yName
    }));
  }, n = {
    x: [],
    y: []
  }, r = (i, o) => {
    const a = Array.isArray(o) ? o.map((c) => c.x).filter(Boolean) : o.x, s = Array.isArray(o) ? o.map((c) => c.y).filter(Boolean) : o.y;
    return {
      x: a !== void 0 ? i.x.concat(a) : i.x,
      y: s !== void 0 ? i.y.concat(s) : i.y
    };
  };
  return im(e.slice(0), t, {}, n, r);
}
function jV(e, t, n) {
  const r = lp(e, t), i = gre(n, t), o = i ? ure(i.props, t) : [], a = r.length ? r : get(n, t);
  return bl([...a, ...o].flat());
}
function kie(e, t) {
  const n = t || j.Children.toArray(e.children), r = jV(e, "x", n), i = jV(e, "y", n), o = pet(n);
  return {
    x: bl([...r, ...o.x].flat()),
    y: bl([...i, ...o.y].flat())
  };
}
function xk(e, t, n) {
  const r = e.categories && lp(e, "x"), i = e.categories && lp(e, "y"), a = !r || !i ? n || kie(e, t) : {}, s = r || a.x, c = i || a.y;
  return {
    x: s.length > 0 ? s : void 0,
    y: c.length > 0 ? c : void 0
  };
}
const Ek = /* @__PURE__ */ j.createContext(void 0);
Ek.displayName = "PortalContext";
const Nie = () => j.useContext(Ek), met = (e) => {
  let {
    children: t
  } = e;
  const [n, r] = j.useState(/* @__PURE__ */ new Map()), i = j.useCallback((s, c) => {
    r((l) => {
      const u = new Map(l);
      return u.set(s, c), u;
    });
  }, [r]), o = j.useCallback((s) => {
    r((c) => {
      const l = new Map(c);
      return l.delete(s), l;
    });
  }, [r]), a = j.useMemo(() => ({
    addChild: i,
    removeChild: o,
    children: n
  }), [i, o, n]);
  return /* @__PURE__ */ j.createElement(Ek.Provider, {
    value: a
  }, t);
}, vet = (e) => {
  let {
    as: t,
    ...n
  } = e;
  const r = Nie();
  if (!r)
    return null;
  const i = Array.from(r.children.values());
  return /* @__PURE__ */ j.cloneElement(t, n, i);
};
function QR() {
  return QR = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, QR.apply(this, arguments);
}
const yet = {
  className: "VictoryContainer",
  portalComponent: /* @__PURE__ */ j.createElement(gWe, null),
  portalZIndex: 99,
  responsive: !0,
  role: "img"
};
function bet(e) {
  const t = {
    ...yet,
    ...e
  }, {
    title: n,
    desc: r,
    width: i,
    height: o,
    responsive: a
  } = t, s = $e(null), c = $e(uC("victory-container-")), l = t.containerId ?? c.current, u = (_) => `${l}-${_}`, d = es(t), f = a ? {
    width: "100%",
    height: "100%"
  } : {
    width: i,
    height: o
  }, h = a ? `0 0 ${i} ${o}` : void 0, p = a ? t.preserveAspectRatio : void 0, g = [n && u("title"), t["aria-labelledby"]].filter(Boolean).join(" ") || void 0, m = [r && u("desc"), t["aria-describedby"]].filter(Boolean).join(" ") || void 0, v = u("title"), y = u("desc");
  return {
    ...t,
    titleId: v,
    descId: y,
    dimensions: f,
    viewBox: h,
    preserveAspectRatio: p,
    ariaLabelledBy: g,
    ariaDescribedBy: m,
    userProps: d,
    localContainerRef: s
  };
}
const jo = (e) => {
  const {
    role: t,
    title: n,
    desc: r,
    children: i,
    className: o,
    portalZIndex: a,
    portalComponent: s,
    width: c,
    height: l,
    style: u,
    tabIndex: d,
    responsive: f,
    events: h,
    ouiaId: p,
    ouiaSafe: g,
    ouiaType: m,
    dimensions: v,
    ariaDescribedBy: y,
    ariaLabelledBy: _,
    viewBox: b,
    preserveAspectRatio: w,
    userProps: C,
    titleId: x,
    descId: T,
    containerRef: E,
    localContainerRef: R
  } = bet(e);
  return j.useEffect(() => {
    if (!(h != null && h.onWheel))
      return;
    const I = (P) => P.preventDefault(), O = R == null ? void 0 : R.current;
    return O == null || O.addEventListener("wheel", I), () => {
      O == null || O.removeEventListener("wheel", I);
    };
  }, []), /* @__PURE__ */ j.createElement("div", {
    className: o,
    style: {
      ...u,
      width: f ? u == null ? void 0 : u.width : v.width,
      height: f ? u == null ? void 0 : u.height : v.height,
      pointerEvents: (u == null ? void 0 : u.pointerEvents) ?? "none",
      touchAction: (u == null ? void 0 : u.touchAction) ?? "none",
      position: (u == null ? void 0 : u.position) ?? "relative"
    },
    "data-ouia-component-id": p,
    "data-ouia-component-type": m,
    "data-ouia-safe": g,
    ref: RKe([R, E])
  }, /* @__PURE__ */ j.createElement(met, null, /* @__PURE__ */ j.createElement("svg", QR({
    width: c,
    height: l,
    tabIndex: d,
    role: t,
    "aria-labelledby": _,
    "aria-describedby": y,
    viewBox: b,
    preserveAspectRatio: w,
    style: {
      ...v,
      pointerEvents: "all"
    }
  }, C, h), n ? /* @__PURE__ */ j.createElement("title", {
    id: x
  }, n) : null, r ? /* @__PURE__ */ j.createElement("desc", {
    id: T
  }, r) : null, i), /* @__PURE__ */ j.createElement("div", {
    style: {
      ...v,
      zIndex: a,
      position: "absolute",
      top: 0,
      left: 0
    }
  }, /* @__PURE__ */ j.createElement(vet, {
    as: s,
    width: c,
    height: l,
    viewBox: b,
    preserveAspectRatio: w,
    style: {
      ...v,
      overflow: "visible"
    }
  }))));
};
jo.role = "container";
const _et = {
  groupComponent: /* @__PURE__ */ j.createElement("g", null)
}, Uw = (e) => {
  const t = {
    ..._et,
    ...e
  }, [n] = Qe(uC()), r = Nie();
  r || pk("`renderInPortal` is not supported outside of `VictoryContainer`. Component will be rendered in place");
  const i = Array.isArray(t.children) ? t.children[0] : t.children, {
    groupComponent: o
  } = t, a = i && i.props || {}, s = a.groupComponent ? {
    groupComponent: o,
    standalone: !1
  } : {}, c = qe(s, a, Jf(t, ["children", "groupComponent"]), {
    key: a.key ?? n
  }), l = i && /* @__PURE__ */ j.cloneElement(i, c);
  return j.useEffect(() => {
    r == null || r.addChild(n, l);
  }, [t.children]), j.useEffect(() => () => r == null ? void 0 : r.removeChild(n), []), r ? null : l;
};
Uw.role = "portal";
function Ww() {
  return Ww = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ww.apply(this, arguments);
}
const NC = /* @__PURE__ */ ia((e, t) => {
  var c;
  const {
    desc: n,
    id: r,
    tabIndex: i,
    origin: o,
    ...a
  } = e, s = {
    vectorEffect: "non-scaling-stroke",
    id: (c = Fe(r, e)) == null ? void 0 : c.toString(),
    tabIndex: Fe(i, e),
    ...a
  };
  return n ? /* @__PURE__ */ j.createElement("rect", Ww({}, s, {
    ref: t
  }), /* @__PURE__ */ j.createElement("desc", null, n)) : /* @__PURE__ */ j.createElement("rect", Ww({}, s, {
    ref: t
  }));
}), wet = (e) => {
  var l;
  const {
    children: t,
    desc: n,
    id: r,
    origin: i,
    tabIndex: o,
    title: a,
    ...s
  } = e, c = {
    id: (l = Fe(r, e)) == null ? void 0 : l.toString(),
    tabIndex: Fe(o, e),
    ...s
  };
  return /* @__PURE__ */ j.createElement("text", c, a && /* @__PURE__ */ j.createElement("title", null, a), n && /* @__PURE__ */ j.createElement("desc", null, n), t);
}, xet = (e) => {
  var s;
  const {
    desc: t,
    id: n,
    tabIndex: r,
    origin: i,
    ...o
  } = e, a = {
    id: (s = Fe(n, e)) == null ? void 0 : s.toString(),
    tabIndex: Fe(r, e),
    ...o
  };
  return /* @__PURE__ */ j.createElement("tspan", a);
}, nf = {
  fill: "#252525",
  fontSize: 14,
  fontFamily: "'Gill Sans', 'Gill Sans MT', 'Ser­avek', 'Trebuchet MS', sans-serif",
  stroke: "transparent"
}, LV = (e, t) => e.datum ? Hy(e, e.datum)[t] : 0, FV = (e) => {
  const t = e && e.fontSize;
  if (typeof t == "number")
    return t;
  if (t == null)
    return nf.fontSize;
  if (typeof t == "string") {
    const n = Number(t.replace("px", ""));
    return isNaN(n) ? (pk("fontSize should be expressed as a number of pixels"), nf.fontSize) : n;
  }
  return nf.fontSize;
}, Ao = function(e, t) {
  return t === void 0 && (t = 0), Array.isArray(e) ? e[t] || e[0] : e;
}, Die = (e) => {
  const {
    backgroundStyle: t,
    backgroundPadding: n
  } = e;
  return Array.isArray(t) && !Lr(t) || Array.isArray(n) && !Lr(n);
}, Eet = (e, t) => {
  if (t.disableInlineStyles) {
    const r = Sr(e, t);
    return {
      // Font size is necessary to calculate the y position of the label
      fontSize: FV(r)
    };
  }
  const n = (r) => {
    const i = Sr(r ? qe({}, r, nf) : nf, t);
    return Object.assign({}, i, {
      fontSize: FV(i)
    });
  };
  return Array.isArray(e) && !Lr(e) ? e.map((r) => n(r)) : n(e);
}, Cet = (e, t) => {
  if (e)
    return Array.isArray(e) && !Lr(e) ? e.map((n) => Sr(n, t)) : Sr(e, t);
}, Tet = (e) => {
  if (e.backgroundPadding && Array.isArray(e.backgroundPadding))
    return e.backgroundPadding.map((n) => {
      const r = Fe(n, e);
      return Gi(r);
    });
  const t = Fe(e.backgroundPadding, e);
  return Gi(t);
}, Iet = (e) => {
  const t = Fe(e.lineHeight, e);
  return Array.isArray(t) && Lr(t) ? [1] : t;
}, $et = (e, t) => {
  if (e == null)
    return;
  if (Array.isArray(e))
    return e.map((r) => Fe(r, t));
  const n = Fe(e, t);
  if (n != null)
    return Array.isArray(n) ? n : `${n}`.split(`
`);
}, Aet = (e, t, n) => {
  const r = e.dy ? Fe(e.dy, e) : 0, i = e.inline ? 1 : e.text.length, o = Fe(e.capHeight, e), a = t ? Fe(t, e) : "middle", s = [...Array(i).keys()].map((u) => Ao(e.style, u).fontSize), c = [...Array(i).keys()].map((u) => Ao(n, u));
  if (a === "start")
    return r + (o / 2 + c[0] / 2) * s[0];
  if (e.inline)
    return a === "end" ? r + (o / 2 - c[0] / 2) * s[0] : r + o / 2 * s[0];
  if (i === 1)
    return a === "end" ? r + (o / 2 + (0.5 - i) * c[0]) * s[0] : r + (o / 2 + (0.5 - i / 2) * c[0]) * s[0];
  const l = [...Array(i).keys()].reduce((u, d) => u + (o / 2 + (0.5 - i) * c[d]) * s[d] / i, 0);
  return a === "end" ? r + l : r + l / 2 + o / 2 * c[i - 1] * s[i - 1];
}, Ret = (e, t, n) => {
  const {
    polar: r
  } = e, i = Ao(e.style), o = r ? ak(e) : 0, a = i.angle === void 0 ? Fe(e.angle, e) : i.angle, s = a === void 0 ? o : a, c = e.transform || i.transform, l = c && Fe(c, e);
  return l || s ? YR(l, s && {
    rotate: [s, t, n]
  }) : void 0;
}, jie = (e, t) => {
  const {
    direction: n,
    textAnchor: r,
    x: i,
    dx: o
  } = e;
  if (n === "rtl")
    return i - t;
  switch (r) {
    case "middle":
      return Math.round(i - t / 2);
    case "end":
      return Math.round(i - t);
    default:
      return i + (o || 0);
  }
}, Lie = (e, t) => {
  const {
    verticalAnchor: n,
    y: r,
    originalDy: i = 0
  } = e, o = r + i;
  switch (n) {
    case "start":
      return Math.floor(o);
    case "end":
      return Math.ceil(o - t);
    default:
      return Math.floor(o - t / 2);
  }
}, Pet = (e, t) => {
  const {
    dx: n = 0,
    transform: r,
    backgroundComponent: i,
    backgroundStyle: o,
    inline: a,
    backgroundPadding: s,
    capHeight: c
  } = e, l = t.map((g) => g.textSize), u = a ? Math.max(...l.map((g) => g.height)) : l.reduce((g, m, v) => {
    const y = v ? 0 : c / 2;
    return g + m.height * (t[v].lineHeight - y);
  }, 0), d = a ? l.reduce((g, m, v) => {
    const y = v ? n : 0;
    return g + m.width + y;
  }, 0) : Math.max(...l.map((g) => g.width)), f = jie(e, d), h = Lie(e, u), p = {
    key: "background",
    height: u + s.top + s.bottom,
    style: o,
    transform: r,
    width: d + s.left + s.right,
    x: a ? f - s.left : f + n - s.left,
    y: h
  };
  return /* @__PURE__ */ j.cloneElement(i, qe({}, i.props, p));
}, Oet = (e, t, n) => {
  const {
    textAnchor: r
  } = e, i = t.map((s) => s.widthWithPadding), a = -i.reduce((s, c) => s + c, 0) / 2;
  switch (r) {
    case "start":
      return i.reduce((s, c, l) => l < n ? s + c : s, 0);
    case "end":
      return i.reduce((s, c, l) => l > n ? s - c : s, 0);
    default:
      return i.reduce((s, c, l) => {
        const u = l < n ? c : 0;
        return l === n ? s + c / 2 : s + u;
      }, a);
  }
}, Met = (e, t) => {
  const {
    dy: n,
    dx: r,
    transform: i,
    backgroundStyle: o,
    backgroundPadding: a,
    backgroundComponent: s,
    inline: c,
    y: l
  } = e, u = t.map((d, f) => {
    const h = Ao(t, f - 1), p = d.textSize, g = d.fontSize * d.lineHeight, m = Math.ceil(g), v = Ao(a, f), y = Ao(a, f - 1), _ = c && r || 0, b = f && !c ? h.fontSize * h.lineHeight + y.top + y.bottom : n - g * 0.5 - (d.fontSize - d.capHeight);
    return {
      textHeight: m,
      labelSize: p,
      heightWithPadding: m + v.top + v.bottom,
      widthWithPadding: p.width + v.left + v.right + _,
      y: l,
      fontSize: d.fontSize,
      dy: b
    };
  });
  return u.map((d, f) => {
    const h = jie(e, d.labelSize.width), p = u.slice(0, f + 1).reduce((b, w) => b + w.dy, l), g = Ao(a, f), m = d.heightWithPadding, v = c ? Oet(e, u, f) + h - g.left : h, y = c ? Lie(e, m) - g.top : p, _ = {
      key: `tspan-background-${f}`,
      height: m,
      style: Ao(o, f),
      width: d.widthWithPadding,
      transform: i,
      x: v - g.left,
      y
    };
    return /* @__PURE__ */ j.cloneElement(s, qe({}, s.props, _));
  });
}, ket = (e, t) => Die(e) ? Met(e, t) : Pet(e, t), Net = (e, t, n) => {
  const r = Ao(e, t), i = Ao(e, t - 1), o = i.fontSize * i.lineHeight, a = r.fontSize * r.lineHeight, s = i.fontSize - i.capHeight, c = r.fontSize - r.capHeight, l = o - i.fontSize / 2 + r.fontSize / 2 - o / 2 + a / 2 - c / 2 + s / 2;
  return Die(n) ? l + r.backgroundPadding.top + i.backgroundPadding.bottom : l;
}, Det = (e, t, n) => {
  const {
    inline: r
  } = t, i = Ao(e, n);
  return n && !r ? Net(e, n, t) : r ? n === 0 ? i.backgroundPadding.top : void 0 : i.backgroundPadding.top;
}, jet = (e) => {
  const t = $et(e.text, e), n = Eet(e.style, Object.assign({}, e, {
    text: t
  })), r = Cet(e.backgroundStyle, Object.assign({}, e, {
    text: t,
    style: n
  })), i = Tet(Object.assign({}, e, {
    text: t,
    style: n,
    backgroundStyle: r
  })), o = Fe(e.id, e);
  return Object.assign({}, e, {
    backgroundStyle: r,
    backgroundPadding: i,
    style: n,
    text: t,
    id: o
  });
}, Let = (e) => {
  const t = Fe(e.ariaLabel, e), n = Ao(e.style), r = Iet(e), i = e.direction ? Fe(e.direction, e) : "inherit", o = e.textAnchor ? Fe(e.textAnchor, e) : n.textAnchor || "start", a = e.verticalAnchor ? Fe(e.verticalAnchor, e) : n.verticalAnchor || "middle", s = e.dx ? Fe(e.dx, e) : 0, c = Aet(e, a, r), l = e.x !== void 0 ? e.x : LV(e, "x"), u = e.y !== void 0 ? e.y : LV(e, "y"), d = Ret(e, l, u);
  return Object.assign({}, e, {
    ariaLabel: t,
    lineHeight: r,
    direction: i,
    textAnchor: o,
    verticalAnchor: a,
    dx: s,
    dy: c,
    originalDy: Fe(e.dy, e),
    transform: d,
    x: l,
    y: u
  });
}, Fet = (e, t) => {
  const {
    ariaLabel: n,
    inline: r,
    className: i,
    title: o,
    events: a,
    direction: s,
    text: c,
    textAnchor: l,
    dx: u,
    dy: d,
    transform: f,
    x: h,
    y: p,
    desc: g,
    id: m,
    tabIndex: v,
    tspanComponent: y,
    textComponent: _
  } = e, b = es(e), w = {
    "aria-label": n,
    key: "text",
    ...a,
    direction: s,
    dx: u,
    x: h,
    y: p + d,
    transform: f,
    className: i,
    title: o,
    desc: Fe(g, e),
    tabIndex: Fe(v, e),
    id: m,
    ...b
  }, C = c.map((x, T) => {
    const E = t[T].style, R = {
      key: `${m}-key-${T}`,
      x: r ? void 0 : h,
      dx: r ? u + t[T].backgroundPadding.left : u,
      dy: Det(t, e, T),
      textAnchor: E.textAnchor || l,
      style: E,
      children: x
    };
    return /* @__PURE__ */ j.cloneElement(y, R);
  });
  return /* @__PURE__ */ j.cloneElement(_, w, C);
}, Vet = {
  backgroundComponent: /* @__PURE__ */ j.createElement(NC, null),
  groupComponent: /* @__PURE__ */ j.createElement("g", null),
  direction: "inherit",
  textComponent: /* @__PURE__ */ j.createElement(wet, null),
  tspanComponent: /* @__PURE__ */ j.createElement(xet, null),
  capHeight: 0.71,
  // Magic number from d3.
  lineHeight: 1
}, Ki = (e) => {
  const t = jet(qe({}, e, Vet));
  if (t.text === null || t.text === void 0)
    return null;
  const n = Let(t), {
    text: r,
    style: i,
    capHeight: o,
    backgroundPadding: a,
    lineHeight: s
  } = n, c = r.map((u, d) => {
    const f = Ao(i, d), h = XR(`${o}em`, f.fontSize), p = Ao(s, d);
    return {
      style: f,
      fontSize: f.fontSize || nf.fontSize,
      capHeight: h,
      text: u,
      // TODO: This looks like a bug:
      textSize: hp(u, f),
      lineHeight: p,
      backgroundPadding: Ao(a, d)
    };
  }), l = Fet(n, c);
  if (t.backgroundStyle) {
    const d = [ket(n, c), l], f = /* @__PURE__ */ j.cloneElement(t.groupComponent, {}, d);
    return t.renderInPortal ? /* @__PURE__ */ j.createElement(Uw, null, f) : f;
  }
  return t.renderInPortal ? /* @__PURE__ */ j.createElement(Uw, null, l) : l;
};
Ki.displayName = "VictoryLabel";
Ki.role = "label";
Ki.defaultStyles = nf;
const Bet = (e) => {
  var t;
  return /* @__PURE__ */ j.createElement("defs", null, /* @__PURE__ */ j.createElement("clipPath", {
    id: (t = e.clipId) == null ? void 0 : t.toString()
  }, e.children));
};
function qw() {
  return qw = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, qw.apply(this, arguments);
}
const Fie = /* @__PURE__ */ ia((e, t) => {
  var c;
  const {
    desc: n,
    id: r,
    tabIndex: i,
    origin: o,
    ...a
  } = e, s = {
    vectorEffect: "non-scaling-stroke",
    id: (c = Fe(r, e)) == null ? void 0 : c.toString(),
    tabIndex: Fe(i, e),
    ...a
  };
  return n ? /* @__PURE__ */ j.createElement("circle", qw({}, s, {
    ref: t
  }), /* @__PURE__ */ j.createElement("desc", null, n)) : /* @__PURE__ */ j.createElement("circle", qw({}, s, {
    ref: t
  }));
});
class yg extends j.Component {
  constructor(t) {
    super(t), this.state = {
      clipId: t == null ? void 0 : t.clipId
    };
  }
  // The clipId state is used to prevent hydration mismatches between the server and client (issue #2941).
  // A better alternative would be to utilize React 18's useId hook instead of uniqueId, which would avoid needing state for this purpose.
  // However, this component currently supports React 16 at the time of writing, so this workaround is necessary.
  componentDidMount() {
    this.state.clipId || this.setState({
      clipId: uC("victory-clip-")
    });
  }
  calculateAttributes(t) {
    const {
      polar: n,
      origin: r,
      clipWidth: i = 0,
      clipHeight: o = 0,
      translateX: a = 0,
      translateY: s = 0
    } = t, c = Gi(t.clipPadding), l = t.radius || PR(t);
    return {
      x: (n ? r.x : a) - c.left,
      y: (n ? r.y : s) - c.top,
      width: Math.max((n ? l : i) + c.left + c.right, 0),
      height: Math.max((n ? l : o) + c.top + c.bottom, 0)
    };
  }
  renderClippedGroup(t, n) {
    const r = es(t), {
      style: i,
      events: o,
      transform: a,
      children: s,
      className: c,
      groupComponent: l,
      tabIndex: u
    } = t, d = this.renderClipComponent(t, n), f = Object.assign({
      className: c,
      style: i,
      transform: a,
      key: `clipped-group-${n}`,
      clipPath: `url(#${n})`
    }, o);
    return /* @__PURE__ */ j.cloneElement(l, {
      ...f,
      tabIndex: u,
      ...r
    }, [d, ...j.Children.toArray(s)]);
  }
  renderGroup(t) {
    const {
      style: n,
      events: r,
      transform: i,
      children: o,
      className: a,
      groupComponent: s,
      tabIndex: c
    } = t;
    return /* @__PURE__ */ j.cloneElement(s, Object.assign({
      className: a,
      style: n,
      transform: i,
      "aria-label": t["aria-label"],
      tabIndex: c
    }, r), o);
  }
  renderClipComponent(t, n) {
    const {
      polar: r,
      origin: i,
      clipWidth: o = 0,
      clipHeight: a = 0,
      translateX: s = 0,
      translateY: c = 0,
      circleComponent: l,
      rectComponent: u,
      clipPathComponent: d
    } = t, {
      top: f,
      bottom: h,
      left: p,
      right: g
    } = Gi(t.clipPadding);
    let m;
    if (r) {
      const v = t.radius || PR(t), y = {
        r: Math.max(v + p + g, v + f + h, 0),
        cx: i.x - p,
        cy: i.y - f
      };
      m = /* @__PURE__ */ j.cloneElement(l, y);
    } else {
      const v = {
        x: s - p,
        y: c - f,
        width: Math.max(o + p + g, 0),
        height: Math.max(a + f + h, 0)
      };
      m = /* @__PURE__ */ j.cloneElement(u, v);
    }
    return /* @__PURE__ */ j.cloneElement(d, Object.assign({
      key: `clip-path-${n}`
    }, t, {
      clipId: n
    }), m);
  }
  getClipValue(t, n) {
    const r = {
      x: t.clipWidth,
      y: t.clipHeight
    };
    if (r[n] !== void 0)
      return r[n];
    const i = kr(t, n);
    return i && Math.abs(i[0] - i[1]) || void 0;
  }
  getTranslateValue(t, n) {
    const r = {
      x: t.translateX,
      y: t.translateY
    };
    if (r[n] !== void 0)
      return r[n];
    const i = kr(t, n);
    return i ? Math.min(...i) : void 0;
  }
  render() {
    const t = this.getClipValue(this.props, "y"), n = this.getClipValue(this.props, "x");
    if (n === void 0 || t === void 0)
      return this.renderGroup(this.props);
    const r = this.getTranslateValue(this.props, "x"), i = this.getTranslateValue(this.props, "y"), o = qe({}, this.props, {
      clipHeight: t,
      clipWidth: n,
      translateX: r,
      translateY: i
    });
    return this.renderClippedGroup(o, this.state.clipId);
  }
}
ve(yg, "displayName", "VictoryClipContainer"), ve(yg, "role", "container"), ve(yg, "defaultProps", {
  circleComponent: /* @__PURE__ */ j.createElement(Fie, null),
  rectComponent: /* @__PURE__ */ j.createElement(NC, null),
  clipPathComponent: /* @__PURE__ */ j.createElement(Bet, null),
  groupComponent: /* @__PURE__ */ j.createElement("g", null)
});
function Gw() {
  return Gw = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Gw.apply(this, arguments);
}
const sm = /* @__PURE__ */ ia((e, t) => {
  var c;
  const {
    desc: n,
    id: r,
    tabIndex: i,
    origin: o,
    ...a
  } = e, s = {
    id: (c = Fe(r, e)) == null ? void 0 : c.toString(),
    tabIndex: Fe(i, e),
    ...a
  };
  return n ? /* @__PURE__ */ j.createElement("path", Gw({}, s, {
    ref: t
  }), /* @__PURE__ */ j.createElement("desc", null, n)) : /* @__PURE__ */ j.createElement("path", Gw({}, s, {
    ref: t
  }));
}), zet = (e) => {
  const {
    cx: t,
    cy: n,
    r,
    startAngle: i,
    endAngle: o,
    closedPath: a
  } = e, s = Math.abs(o - i) / 2 + i, c = t + r * Math.cos(pr(i)), l = n - r * Math.sin(pr(i)), u = t + r * Math.cos(pr(s)), d = n - r * Math.sin(pr(s)), f = t + r * Math.cos(pr(o)), h = n - r * Math.sin(pr(o)), p = s - i <= 180 ? 0 : 1, g = o - s <= 180 ? 0 : 1, m = a ? ` M ${t}, ${n} L ${c}, ${l}` : `M ${c}, ${l}`, v = `A ${r}, ${r}, 0, ${p}, 0, ${u}, ${d}`, y = `A ${r}, ${r}, 0, ${g}, 0, ${f}, ${h}`;
  return `${m} ${v} ${y} ${a ? "Z" : ""}`;
}, Het = (e) => {
  const t = Fe(e.ariaLabel, e), n = Fe(e.desc, e), r = Fe(e.id, e), i = Sr(Object.assign({
    stroke: "black",
    fill: "none"
  }, e.style), e), o = Fe(e.tabIndex, e);
  return Object.assign({}, e, {
    ariaLabel: t,
    desc: n,
    id: r,
    style: i,
    tabIndex: o
  });
}, Uet = {
  pathComponent: /* @__PURE__ */ j.createElement(sm, null),
  role: "presentation",
  shapeRendering: "auto"
}, VV = (e) => {
  const t = Het(qe({}, e, Uet));
  return /* @__PURE__ */ j.cloneElement(t.pathComponent, {
    ...t.events,
    "aria-label": t.ariaLabel,
    d: zet(t),
    style: t.style,
    desc: t.desc,
    tabIndex: t.tabIndex,
    className: t.className,
    role: t.role,
    shapeRendering: t.shapeRendering,
    transform: t.transform,
    clipPath: t.clipPath
  });
}, Wet = (e) => {
  const t = Fe(e.id, e);
  return Object.assign({}, e, {
    id: t
  });
}, qet = {
  circleComponent: /* @__PURE__ */ j.createElement(Fie, null),
  rectComponent: /* @__PURE__ */ j.createElement(NC, null),
  role: "presentation",
  shapeRendering: "auto"
}, Get = (e) => {
  const t = Wet(qe({}, e, qet));
  return t.polar ? /* @__PURE__ */ j.cloneElement(t.circleComponent, {
    ...t.events,
    style: t.style,
    role: t.role,
    shapeRendering: t.shapeRendering,
    cx: t.x,
    cy: t.y,
    r: t.height,
    className: t.className
  }) : /* @__PURE__ */ j.cloneElement(t.rectComponent, {
    ...t.events,
    style: t.style,
    role: t.role,
    shapeRendering: t.shapeRendering,
    x: t.x,
    y: t.y,
    rx: t.rx,
    ry: t.ry,
    width: t.width,
    height: t.height,
    className: t.className
  });
}, Ket = (e) => {
  const t = Fe(e.ariaLabel, e), n = Fe(e.desc, e), r = Fe(e.id, e), i = Sr(Object.assign({
    fill: "none"
  }, e.style), e), o = Fe(e.tabIndex, e);
  return Object.assign({}, e, {
    ariaLabel: t,
    desc: n,
    id: r,
    style: i,
    tabIndex: o
  });
}, Yet = {
  rectComponent: /* @__PURE__ */ j.createElement(NC, null),
  role: "presentation",
  shapeRendering: "auto"
}, Xet = (e) => {
  const t = Ket(qe({}, e, Yet));
  return /* @__PURE__ */ j.cloneElement(t.rectComponent, {
    ...t.events,
    "aria-label": t.ariaLabel,
    style: t.style,
    desc: t.desc,
    tabIndex: t.tabIndex,
    transform: t.transform,
    className: t.className,
    role: t.role,
    shapeRendering: t.shapeRendering,
    x: t.x,
    y: t.y,
    width: t.width,
    height: t.height,
    clipPath: t.clipPath
  });
};
function Kw() {
  return Kw = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Kw.apply(this, arguments);
}
const Vie = /* @__PURE__ */ ia((e, t) => {
  var c;
  const {
    desc: n,
    id: r,
    tabIndex: i,
    origin: o,
    ...a
  } = e, s = {
    vectorEffect: "non-scaling-stroke",
    id: (c = Fe(r, e)) == null ? void 0 : c.toString(),
    tabIndex: Fe(i, e),
    ...a
  };
  return n ? /* @__PURE__ */ j.createElement("line", Kw({}, s, {
    ref: t
  }), /* @__PURE__ */ j.createElement("desc", null, n)) : /* @__PURE__ */ j.createElement("line", Kw({}, s, {
    ref: t
  }));
}), Qet = (e) => {
  const t = Fe(e.ariaLabel, e), n = Fe(e.desc, e), r = Fe(e.id, e), i = Sr(Object.assign({
    stroke: "black"
  }, e.style), e), o = Fe(e.tabIndex, e);
  return Object.assign({}, e, {
    ariaLabel: t,
    desc: n,
    id: r,
    style: i,
    tabIndex: o
  });
}, Jet = {
  lineComponent: /* @__PURE__ */ j.createElement(Vie, null),
  role: "presentation",
  shapeRendering: "auto"
}, rf = (e) => {
  const t = Qet(qe({}, e, Jet));
  return /* @__PURE__ */ j.cloneElement(t.lineComponent, {
    ...t.events,
    "aria-label": t.ariaLabel,
    style: t.style,
    desc: t.desc,
    tabIndex: t.tabIndex,
    className: t.className,
    role: t.role,
    shapeRendering: t.shapeRendering,
    x1: t.x1,
    x2: t.x2,
    y1: t.y1,
    y2: t.y2,
    transform: t.transform,
    clipPath: t.clipPath
  });
}, Zet = (e) => {
  const {
    x: t,
    y: n,
    size: r,
    symbol: i
  } = e;
  if (e.getPath)
    return e.getPath(t, n, r);
  const o = WJe;
  return (typeof o[i] == "function" ? o[i] : o.circle)(t, n, r);
}, ett = (e) => {
  const t = Fe(e.ariaLabel, e), n = Fe(e.desc, e), r = Fe(e.id, e), i = Fe(e.size, e), o = Sr(e.style, e), a = Fe(e.symbol, e), s = Fe(e.tabIndex, e);
  return Object.assign({}, e, {
    ariaLabel: t,
    desc: n,
    id: r,
    size: i,
    style: o,
    symbol: a,
    tabIndex: s
  });
}, ttt = {
  pathComponent: /* @__PURE__ */ j.createElement(sm, null),
  role: "presentation",
  shapeRendering: "auto"
}, Bie = (e) => {
  const t = ett(qe({}, e, ttt)), n = es(t);
  return /* @__PURE__ */ j.cloneElement(t.pathComponent, {
    ...t.events,
    "aria-label": t.ariaLabel,
    d: Zet(t),
    style: t.style,
    desc: t.desc,
    tabIndex: t.tabIndex,
    role: t.role,
    shapeRendering: t.shapeRendering,
    className: t.className,
    transform: t.transform,
    clipPath: t.clipPath,
    ...n
  });
}, Ck = {
  top: -1,
  left: -1,
  right: 1,
  bottom: 1
}, Yw = (e) => e != null, ntt = (e, t) => {
  const {
    orientation: n,
    horizontal: r
  } = e;
  return n ? {
    top: "x",
    bottom: "x",
    left: "y",
    right: "y"
  }[n] : r ? t === "x" ? "y" : "x" : t;
}, rtt = (e) => {
  const t = ns(e), n = ntt(e, t), r = ra(e, t), o = e.domain && e.domain[t] || om(e) || r.domain();
  return r.range(kr(e, n)), r.domain(o), r;
}, itt = (e) => {
  const {
    theme: t,
    dependentAxis: n
  } = e, r = t && t.axis && t.axis.style, i = n ? "dependentAxis" : "independentAxis", o = t && t[i] && t[i].style;
  return r && o ? (() => ["axis", "axisLabel", "grid", "parent", "tickLabels", "ticks"].reduce((c, l) => (c[l] = qe({}, o[l], r[l]), c), {}))() : o || r;
}, zie = function(e, t) {
  t === void 0 && (t = {});
  const n = e.style || {}, r = {
    height: "100%",
    width: "100%"
  };
  return {
    parent: qe(n.parent, t.parent, r),
    axis: qe({}, n.axis, t.axis),
    axisLabel: qe({}, n.axisLabel, t.axisLabel),
    grid: qe({}, n.grid, t.grid),
    ticks: qe({}, n.ticks, t.ticks),
    tickLabels: qe({}, n.tickLabels, t.tickLabels)
  };
}, ott = (e, t, n) => {
  const {
    position: r,
    transform: i
  } = e;
  return {
    x1: i.x,
    y1: i.y,
    x2: i.x + r.x2,
    y2: i.y + r.y2,
    style: t,
    datum: n
  };
}, att = (e, t, n, r, i) => {
  const {
    position: o,
    transform: a
  } = e;
  return {
    style: t,
    x: a.x + o.x,
    y: a.y + o.y,
    verticalAnchor: n.verticalAnchor,
    textAnchor: n.textAnchor,
    angle: t.angle,
    text: i,
    datum: r
  };
}, stt = (e, t, n) => {
  const {
    edge: r,
    transform: i
  } = e;
  return {
    x1: i.x,
    y1: i.y,
    x2: r.x + i.x,
    y2: r.y + i.y,
    style: t,
    datum: n
  };
}, ctt = (e, t, n) => {
  const {
    style: r,
    padding: i,
    isVertical: o
  } = t, {
    width: a,
    height: s
  } = e;
  return {
    style: r.axis,
    x1: o ? n.x : i.left + n.x,
    x2: o ? n.x : a - i.right + n.x,
    y1: o ? i.top + n.y : n.y,
    y2: o ? s - i.bottom + n.y : n.y
  };
}, ltt = (e, t) => ({
  tickStyle: Sr(e.ticks, t),
  labelStyle: Sr(e.tickLabels, t),
  gridStyle: Sr(e.grid, t)
}), utt = (e, t, n) => {
  const {
    style: r,
    orientation: i,
    padding: o,
    labelPadding: a,
    isVertical: s
  } = t, c = Ck[i], l = o.left + o.right, u = o.top + o.bottom, d = c < 0 ? "end" : "start", f = r.axisLabel, h = s ? -90 : 0, p = s ? n.x + c * a : (e.width - l) / 2 + o.left + n.x, g = s ? (e.height - u) / 2 + o.top + n.y : c * a + n.y;
  return {
    x: p,
    y: g,
    verticalAnchor: f.verticalAnchor || d,
    textAnchor: f.textAnchor || "middle",
    angle: f.angle === void 0 ? h : f.angle,
    style: f,
    text: e.label
  };
}, dtt = (e, t) => {
  const r = {
    top: "end",
    left: "end",
    right: "start",
    bottom: "start"
  }[e];
  return {
    textAnchor: t ? r : "middle",
    verticalAnchor: t ? "middle" : r
  };
}, ftt = (e, t) => {
  const n = t.axisLabel || {};
  if (n.padding !== void 0 && n.padding !== null)
    return n.padding;
  const r = CC(e), i = n.fontSize || 14;
  return e.label ? i * (r ? 2.3 : 1.6) : 0;
}, BV = (e, t, n) => {
  const r = t || "positive";
  return n ? {
    positive: {
      x: "left",
      y: "bottom"
    },
    negative: {
      x: "right",
      y: "top"
    }
  }[r][e] : {
    positive: {
      x: "bottom",
      y: "left"
    },
    negative: {
      x: "top",
      y: "right"
    }
  }[r][e];
}, htt = (e, t) => {
  const {
    style: n,
    scale: r,
    orientation: i,
    padding: o,
    axis: a,
    ticks: s,
    stringTicks: c,
    isVertical: l,
    labelPadding: u
  } = t, {
    polar: d,
    horizontal: f
  } = e, h = {
    scale: {
      [a]: r
    },
    polar: d,
    horizontal: f,
    ticks: s,
    stringTicks: c
  }, p = i === "right" ? o.right : o.left, g = i === "top" ? o.top : o.bottom, m = e.offsetX !== null && e.offsetX !== void 0 ? e.offsetX : p, v = e.offsetY !== null && e.offsetY !== void 0 ? e.offsetY : g, y = n.axisLabel.fontSize || 14, _ = s.map((T, E) => {
    const R = c ? e.tickValues[T - 1] : T;
    return Sr(n.ticks, Object.assign({}, h, {
      tick: R,
      index: E
    })).size || 0;
  }), b = y + 2 * Math.max(..._) + u, w = 1.2 * y;
  return {
    x: m ?? (l ? b : w),
    y: v ?? (l ? w : b)
  };
}, ou = (e, t) => e instanceof Date && t instanceof Date ? e.getTime() === t.getTime() : e === t, gtt = (e, t) => {
  const {
    scale: n,
    origin: r,
    orientation: i,
    orientations: o,
    domain: a,
    padding: s
  } = t, {
    top: c,
    bottom: l,
    left: u,
    right: d
  } = s, f = {
    x: i === "bottom" || i === "top" ? i : o.x,
    y: i === "left" || i === "right" ? i : o.y
  }, h = {
    x: f.y === "left" ? u : d,
    y: f.x === "bottom" ? l : c
  }, p = {
    x: f.y === "left" ? 0 : e.width,
    y: f.x === "bottom" ? e.height : 0
  }, g = {
    x: ou(r.x, a.x[0]) || ou(r.x, a.x[1]) ? 0 : n.x(r.x),
    y: ou(r.y, a.y[0]) || ou(r.y, a.y[1]) ? 0 : n.y(r.y)
  }, m = g.x ? Math.abs(p.x - g.x) : h.x, v = g.y ? Math.abs(p.y - g.y) : h.y, y = Yw(e.offsetX) ? e.offsetX : m, _ = Yw(e.offsetY) ? e.offsetY : v;
  return {
    x: y,
    y: _
  };
}, ptt = (e, t) => {
  const {
    scale: n,
    origin: r,
    orientation: i,
    orientations: o,
    domain: a,
    padding: s
  } = t, {
    top: c,
    bottom: l,
    left: u,
    right: d
  } = s, f = {
    y: i === "bottom" || i === "top" ? i : o.x,
    x: i === "left" || i === "right" ? i : o.y
  }, h = {
    x: f.y === "bottom" ? l : c,
    y: f.x === "left" ? u : d
  }, p = {
    y: f.x === "left" ? 0 : e.width,
    x: f.y === "bottom" ? e.height : 0
  }, g = {
    x: ou(r.x, a.x[0]) || ou(r.x, a.x[1]) ? 0 : n.x(r.x),
    y: ou(r.y, a.y[0]) || ou(r.y, a.y[1]) ? 0 : n.y(r.y)
  }, m = g.x ? Math.abs(p.x - g.x) : h.x, v = g.y ? Math.abs(p.y - g.y) : h.y, y = Yw(e.offsetX) ? e.offsetX : v, _ = Yw(e.offsetY) ? e.offsetY : m;
  return {
    x: y,
    y: _
  };
}, mtt = (e, t, n) => {
  const {
    orientation: r,
    axis: i
  } = t, o = yre(e, i);
  return {
    top: {
      x: 0,
      y: o !== void 0 ? o : n.y
    },
    bottom: {
      x: 0,
      y: o !== void 0 ? o : e.height - n.y
    },
    left: {
      x: o !== void 0 ? o : n.x,
      y: 0
    },
    right: {
      x: o !== void 0 ? o : e.width - n.x,
      y: 0
    }
  }[r];
}, vtt = (e, t, n) => {
  const {
    tickStyle: r,
    labelStyle: i
  } = e, o = r.size || 0, a = r.padding || 0, s = i.padding || 0, c = o + a + s, l = Ck[t];
  return {
    x: n ? l * c : 0,
    x2: n ? l * o : 0,
    y: n ? 0 : l * c,
    y2: n ? 0 : l * o
  };
}, ytt = (e, t, n) => ({
  x: n ? t.x : e + t.x,
  y: n ? e + t.y : t.y
}), btt = (e, t) => {
  const {
    orientation: n,
    padding: r,
    isVertical: i
  } = t, o = -Ck[n], a = i ? o * (e.width - (r.left + r.right)) : 0, s = i ? 0 : o * (e.height - (r.top + r.bottom));
  return {
    x: a,
    y: s
  };
}, _tt = (e, t) => {
  const {
    padding: n,
    orientation: r,
    crossAxis: i
  } = e, o = r === "right" ? n.right : n.left, a = r === "top" ? n.top : n.bottom;
  return {
    x: i ? t.x - o : 0,
    y: i ? t.y - a : 0
  };
}, Stt = (e, t) => {
  let n;
  return t.domain.x && t.domain.y ? n = e.horizontal ? ptt(e, t) : gtt(e, t) : n = htt(e, t), {
    globalTransform: mtt(e, t, n),
    gridOffset: _tt(t, n),
    gridEdge: btt(e, t)
  };
}, wtt = (e) => {
  if (e.orientation)
    return e.orientation;
  const t = {
    dependent: e.horizontal ? "bottom" : "left",
    independent: e.horizontal ? "left" : "bottom"
  };
  return e.dependentAxis ? t.dependent : t.independent;
}, xtt = (e) => {
  const t = itt(e), n = zie(e, t), r = Gi(e.padding), i = ftt(e, n), o = TC(e) ? e.tickValues : void 0, a = ns(e), s = om(e), c = rtt(e), l = a === "x" ? s : void 0, u = a === "y" ? s : void 0, d = a === "x" ? c : void 0, f = a === "y" ? c : void 0, h = !(e.crossAxis === !1 || e.standalone === !0), p = vre(e, c, h), g = mre(e, c), m = {
    x: kr(e, "x"),
    y: kr(e, "y")
  }, v = {
    x: e.domain && e.domain.x ? e.domain.x : l,
    y: e.domain && e.domain.y ? e.domain.y : u
  }, y = {
    x: e.domain && e.domain.x ? ra(e, "x").domain(e.domain.x).range(e.horizontal ? m.y : m.x) : d,
    y: e.domain && e.domain.y ? ra(e, "y").domain(e.domain.y).range(e.horizontal ? m.x : m.y) : f
  }, _ = v.x && v.y ? pre(v) : void 0, b = _ ? {
    x: bV(_.x, v.x),
    y: bV(_.y, v.y)
  } : void 0, w = b ? {
    x: BV("x", b.y, e.horizontal),
    y: BV("y", b.x, e.horizontal)
  } : void 0, C = w ? e.orientation || w[a] : wtt(e), x = CC(Object.assign({}, e, {
    orientation: C
  }));
  return {
    anchors: dtt(C, x),
    axis: a,
    crossAxis: h,
    domain: v,
    isVertical: x,
    labelPadding: i,
    orientation: C,
    orientations: w,
    origin: _,
    padding: r,
    scale: y,
    stringTicks: o,
    style: n,
    tickFormat: g,
    ticks: p
  };
}, Ett = (e, t) => {
  const n = IC(e, t), r = xtt(n), {
    axis: i,
    style: o,
    orientation: a,
    isVertical: s,
    scale: c,
    ticks: l,
    tickFormat: u,
    anchors: d,
    domain: f,
    stringTicks: h
  } = r, p = i === "x" ? "y" : "x", {
    width: g,
    height: m,
    standalone: v,
    theme: y,
    polar: _,
    padding: b,
    horizontal: w
  } = n, {
    globalTransform: C,
    gridOffset: x,
    gridEdge: T
  } = Stt(n, r), E = {
    scale: {
      [i]: c[i]
    },
    polar: _,
    horizontal: w,
    ticks: l,
    stringTicks: h
  }, R = ctt(n, r, C), I = utt(n, r, C), O = {
    parent: Object.assign({
      style: o.parent,
      ticks: l,
      standalone: v,
      theme: y,
      width: g,
      height: m,
      padding: b,
      domain: f
    }, E)
  }, P = {
    dimension: p,
    range: {
      [p]: kr(n, p)
    },
    scale: n.scale && n.scale[p] ? {
      [p]: n.scale[p]
    } : void 0
  };
  return l.reduce((k, L, N) => {
    var Q, Y, q;
    const D = h ? h[N] : L, z = u(L, N, l), V = ltt(o, Object.assign({}, E, {
      tick: D,
      tickValue: L,
      index: N,
      text: z
    })), B = {
      position: vtt(V, a, s),
      transform: ytt((Q = c[i]) == null ? void 0 : Q.call(c, L), C, s)
    }, U = {
      edge: T,
      transform: {
        x: s ? -x.x + C.x : ((Y = c[i]) == null ? void 0 : Y.call(c, L)) + C.x,
        y: s ? ((q = c[i]) == null ? void 0 : q.call(c, L)) + C.y : x.y + C.y
      }
    };
    return k[N] = {
      axis: Object.assign({
        dimension: i
      }, E, R),
      axisLabel: Object.assign({}, E, I),
      ticks: Object.assign({}, E, ott(B, V.tickStyle, L)),
      tickLabels: Object.assign({}, E, att(B, V.labelStyle, d, L, z)),
      grid: Object.assign({}, E, P, stt(U, V.gridStyle, L))
    }, k;
  }, O);
}, zV = {
  width: 450,
  height: 300,
  padding: 50
}, Ctt = {
  components: [{
    name: "axis",
    index: 0
  }, {
    name: "axisLabel",
    index: 0
  }, {
    name: "grid"
  }, {
    name: "parent",
    index: "parent"
  }, {
    name: "ticks"
  }, {
    name: "tickLabels"
  }]
};
class Fc extends j.Component {
  static getStyles(t) {
    return zie(t);
  }
  static getBaseProps(t) {
    return Ett(t, zV);
  }
  renderLine(t) {
    const {
      axisComponent: n
    } = t, r = this.getComponentProps(n, "axis", 0);
    return /* @__PURE__ */ j.cloneElement(n, r);
  }
  renderLabel(t) {
    const {
      axisLabelComponent: n,
      label: r
    } = t;
    if (!r)
      return null;
    const i = this.getComponentProps(n, "axisLabel", 0);
    return /* @__PURE__ */ j.cloneElement(n, i);
  }
  renderGridAndTicks(t) {
    const {
      tickComponent: n,
      tickLabelComponent: r,
      gridComponent: i,
      name: o
    } = t, a = (s) => {
      const {
        style: c = {},
        events: l = {}
      } = s;
      return c.stroke !== "transparent" && c.stroke !== "none" && c.strokeWidth !== 0 || !Lr(l);
    };
    return this.dataKeys.map((s, c) => {
      const l = this.getComponentProps(n, "ticks", c), u = /* @__PURE__ */ j.cloneElement(n, l), d = a(u.props) ? u : void 0, f = this.getComponentProps(i, "grid", c), h = /* @__PURE__ */ j.cloneElement(i, f), p = a(h.props) ? h : void 0, g = this.getComponentProps(r, "tickLabels", c), v = [p, d, /* @__PURE__ */ j.cloneElement(r, g)].filter(Boolean);
      return /* @__PURE__ */ j.cloneElement(t.groupComponent, {
        key: `${o}-tick-group-${s}`
      }, v);
    });
  }
  fixLabelOverlap(t, n) {
    const r = CC(n), i = r ? n.height : n.width, o = (h) => h.type && h.type.role === "label", a = t.map((h) => h.props.children).reduce((h, p) => h.concat(p), []).filter(o).map((h) => h.props), s = (h) => typeof h == "object" ? Object.assign({}, {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    }, h) : {
      top: h,
      right: h,
      bottom: h,
      left: h
    }, c = a.reduce((h, p) => {
      const g = s(p.style.padding), m = hp(p.text, {
        angle: p.angle,
        fontSize: p.style.fontSize,
        letterSpacing: p.style.letterSpacing,
        fontFamily: p.style.fontFamily
      });
      return h + (r ? m.height + g.top + g.bottom : m.width + g.right + g.left);
    }, 0), l = Math.floor(i * t.length / c), u = Math.ceil(t.length / l) || 1, d = (h) => h.props.children.filter(o).reduce((p, g) => (r ? g.props.y : g.props.x) || 0, 0);
    return t.sort(
      (h, p) => r ? d(p) - d(h) : d(h) - d(p)
      // ordinary axis has left-right orientation
    ).filter((h, p) => p % u === 0);
  }
  // Overridden in native versions
  shouldAnimate() {
    return !!this.props.animate;
  }
  render() {
    const {
      animationWhitelist: t
    } = ms, n = IC(this.props, zV), r = es(this.props);
    if (this.shouldAnimate())
      return this.animateComponent(n, t);
    const i = this.renderGridAndTicks(n), o = n.fixLabelOverlap ? this.fixLabelOverlap(i, n) : i, a = [this.renderLine(n), this.renderLabel(n), ...o], s = /* @__PURE__ */ j.cloneElement(n.containerComponent, r);
    return n.standalone ? this.renderContainer(s, a) : /* @__PURE__ */ j.cloneElement(n.groupComponent, r, a);
  }
}
ve(Fc, "animationWhitelist", ["style", "domain", "range", "tickCount", "tickValues", "offsetX", "offsetY", "padding", "width", "height"]), ve(Fc, "displayName", "VictoryAxis"), ve(Fc, "role", "axis"), ve(Fc, "defaultTransitions", {
  onExit: {
    duration: 500
  },
  onEnter: {
    duration: 500
  }
}), ve(Fc, "defaultProps", {
  axisComponent: /* @__PURE__ */ j.createElement(rf, null),
  axisLabelComponent: /* @__PURE__ */ j.createElement(Ki, null),
  tickLabelComponent: /* @__PURE__ */ j.createElement(Ki, null),
  tickComponent: /* @__PURE__ */ j.createElement(rf, null),
  gridComponent: /* @__PURE__ */ j.createElement(rf, null),
  standalone: !0,
  theme: $a.grayscale,
  containerComponent: /* @__PURE__ */ j.createElement(jo, null),
  groupComponent: /* @__PURE__ */ j.createElement("g", {
    role: "presentation"
  }),
  fixLabelOverlap: !1
}), ve(Fc, "getDomain", om), ve(Fc, "getAxis", ns), ve(Fc, "expectedComponents", ["axisComponent", "axisLabelComponent", "groupComponent", "containerComponent", "tickComponent", "tickLabelComponent", "gridComponent"]);
const ms = ad(Fc, Ctt), Ttt = (e, t) => {
  const n = (o) => {
    let s = ore(e.scale[o]) === "log" ? 1 / Number.MAX_SAFE_INTEGER : 0;
    const c = Ea(e.domain[o]), l = xa(e.domain[o]);
    return c < 0 && l <= 0 ? s = l : c >= 0 && l > 0 && (s = c), t[`_${o}`] instanceof Date ? new Date(s) : s;
  }, r = t._y0 !== void 0 ? t._y0 : n("y"), i = t._x0 !== void 0 ? t._x0 : n("x");
  return Hy(e, Object.assign({}, t, {
    _y0: r,
    _x0: i
  }));
}, Itt = (e) => {
  var l;
  const {
    polar: t
  } = e, n = Uy(e, "bar"), r = e.disableInlineStyles ? {} : rm(e.style, n), i = e.range || {
    x: kr(e, "x"),
    y: kr(e, "y")
  }, o = {
    x: BR(e, "x"),
    y: BR(e, "y")
  }, a = {
    x: ra(e, "x").domain(o.x).range(e.horizontal ? i.y : i.x),
    y: ra(e, "y").domain(o.y).range(e.horizontal ? i.x : i.y)
  }, s = t ? e.origin || Zf(e) : void 0;
  let c = Do(e);
  return c = cre(c, o, 0), ((l = e.groupComponent) == null ? void 0 : l.type) === yg && (c = c.map((u) => ({
    ...u,
    _x: u.x,
    _y: u.y
  }))), {
    style: r,
    data: c,
    scale: a,
    domain: o,
    origin: s
  };
}, $tt = (e, t) => {
  const n = wr(e, t, "bar"), r = Object.assign({}, n, Itt(n)), {
    alignment: i,
    barRatio: o,
    cornerRadius: a,
    data: s,
    disableInlineStyles: c,
    domain: l,
    events: u,
    height: d,
    horizontal: f,
    origin: h,
    padding: p,
    polar: g,
    scale: m,
    sharedEvents: v,
    standalone: y,
    style: _,
    theme: b,
    width: w,
    labels: C,
    name: x,
    barWidth: T,
    getPath: E
  } = r, R = {
    parent: {
      horizontal: f,
      domain: l,
      scale: m,
      width: w,
      height: d,
      data: s,
      standalone: y,
      name: x,
      theme: b,
      polar: g,
      origin: h,
      padding: p,
      style: _.parent
    }
  };
  return s.reduce((I, O, P) => {
    const k = Ga(O.eventKey) ? P : O.eventKey, {
      x: L,
      y: N,
      y0: D,
      x0: z
    } = Ttt(r, O), V = {
      alignment: i,
      barRatio: o,
      barWidth: T,
      cornerRadius: a,
      data: s,
      datum: O,
      disableInlineStyles: c,
      getPath: E,
      horizontal: f,
      index: P,
      polar: g,
      origin: h,
      scale: m,
      style: _.data,
      width: w,
      height: d,
      x: L,
      y: N,
      y0: D,
      x0: z
    };
    I[k] = {
      data: V
    };
    const B = Qy(r, O, P);
    return (B != null || C && (u || v)) && (I[k].labels = sk(r, P)), I;
  }, R);
}, Att = 8, Rtt = (e, t) => {
  const {
    scale: n,
    data: r,
    style: i
  } = t;
  if (e)
    return Fe(e, t);
  if (i.width)
    return i.width;
  const o = n.x.range(), a = Math.abs(o[1] - o[0]), s = r.length + 2, l = (t.barRatio || 0.5) * (r.length < 2 ? Att : a / s);
  return Math.max(1, l);
}, Ptt = (e, t) => {
  const n = {
    topLeft: 0,
    topRight: 0,
    bottomLeft: 0,
    bottomRight: 0
  }, r = (i, o) => {
    Ga(e[i]) ? Ga(e[o]) || (n[i] = Fe(e[o], t)) : n[i] = Fe(e[i], t);
  };
  return r("topLeft", "top"), r("topRight", "top"), r("bottomLeft", "bottom"), r("bottomRight", "bottom"), n;
};
function Ott(e) {
  return ni(e);
}
const Mtt = (e, t) => {
  const n = {
    topLeft: 0,
    topRight: 0,
    bottomLeft: 0,
    bottomRight: 0
  };
  return e ? Ott(e) ? Ptt(e, t) : (n.topLeft = Fe(e, t), n.topRight = Fe(e, t), n) : n;
}, ktt = function(e, t) {
  if (e === void 0 && (e = {}), t.disableInlineStyles)
    return {};
  const r = {
    fill: "black",
    stroke: e.fill || "black"
  };
  return Sr(Object.assign(r, e), t);
}, ic = (e, t) => ({
  x: e,
  y: t,
  distance(n) {
    return Math.sqrt(Math.pow(this.x - n.x, 2) + Math.pow(this.y - n.y, 2));
  },
  // vector addition in 2d plane
  add(n) {
    return ic(this.x + n.x, this.y + n.y);
  },
  // vector subtraction in 2d
  // returns p0 - p1
  subtract(n) {
    return ic(this.x - n.x, this.y - n.y);
  },
  // multiply a 2d point by a scalar
  scalarMult(n) {
    return ic(this.x * n, this.y * n);
  },
  scalarDivide(n) {
    if (n === 0)
      throw new Error("Division by 0 error");
    return ic(this.x / n, this.y / n);
  },
  equals(n) {
    return this.x === n.x && this.y === n.y;
  }
}), Xw = (e, t) => ({
  center: e,
  radius: t,
  hasIntersection(n) {
    const r = this.center, i = n.center, o = this.radius, a = n.radius, s = r.distance(i);
    return !(s > o + a || s < Math.abs(o - a));
  },
  equals(n) {
    const r = this.center, i = n.center, o = this.radius, a = n.radius;
    return o === a && r.equals(i);
  },
  // Source: http://paulbourke.net/geometry/circlesphere/
  // "Intersection of two circles" by Paul Bourke
  // Left-most point is returned as 0th element of array
  // Right-most point is returned as 1st elemennt of array
  intersection(n) {
    const r = this.center, i = n.center, o = this.radius, a = n.radius, s = r.distance(i);
    if (!this.hasIntersection(n) || this.equals(n))
      return [];
    const c = (Math.pow(o, 2) - Math.pow(a, 2) + Math.pow(s, 2)) / (2 * s), l = Math.sqrt(Math.pow(o, 2) - Math.pow(c, 2)), u = r.add(i.subtract(r).scalarMult(c).scalarDivide(s)), {
      x: d,
      y: f
    } = r, {
      x: h,
      y: p
    } = i, {
      x: g,
      y: m
    } = u, v = [ic(g - l * (p - f) / s, m + l * (h - d) / s), ic(g + l * (p - f) / s, m - l * (h - d) / s)];
    return v.sort((y, _) => y.x - _.x), v;
  },
  solveX(n) {
    const r = Math.sqrt(Math.pow(this.radius, 2) - Math.pow(n - this.center.y, 2));
    return [this.center.x - r, this.center.x + r];
  },
  solveY(n) {
    const r = Math.sqrt(Math.pow(this.radius, 2) - Math.pow(n - this.center.x, 2));
    return [this.center.y - r, this.center.y + r];
  }
}), Tk = (e, t) => {
  const {
    x: n,
    x0: r,
    y: i,
    y0: o,
    horizontal: a
  } = e, s = e.alignment || "middle", c = s === "middle" ? t / 2 : t, l = a ? -1 : 1;
  return a ? {
    x0: r,
    x1: n,
    y0: s === "start" ? i : i - l * c,
    y1: s === "end" ? i : i + l * c
  } : {
    x0: s === "start" ? n : n - l * c,
    x1: s === "end" ? n : n + l * c,
    y0: o,
    y1: i
  };
}, zd = (e, t) => {
  const {
    data: n,
    scale: r
  } = e, i = n[t]._x1 === void 0 ? "_x" : "_x1";
  return r.x(n[t][i]);
}, Ntt = (e, t) => {
  const {
    scale: n
  } = e, r = n.y.range(), i = Math.max(...r), o = Math.abs(n.x.range()[1] - n.x.range()[0]);
  return t / (2 * Math.PI * i) * o;
}, HV = (e) => -1 * e + Math.PI / 2, Dtt = (e, t) => {
  const {
    getPath: n
  } = e;
  if (typeof n == "function") {
    const r = {
      ...e,
      ...Tk(e, t)
    };
    return n(r);
  }
}, jtt = (e, t) => {
  const {
    data: n,
    scale: r,
    alignment: i
  } = e, o = zd(e, t), a = Math.abs(r.x.range()[1] - r.x.range()[0]), s = t === 0 ? zd(e, n.length - 1) - Math.PI * 2 : zd(e, t - 1);
  return t === 0 && a < 2 * Math.PI ? r.x.range()[0] : i === "start" || i === "end" ? i === "start" ? s : o : (o + s) / 2;
}, Ltt = (e, t) => {
  const {
    data: n,
    scale: r,
    alignment: i
  } = e, o = zd(e, t), a = Math.abs(r.x.range()[1] - r.x.range()[0]), s = r.x.range()[1] === 2 * Math.PI ? zd(e, 0) + Math.PI * 2 : r.x.range()[1], c = t === n.length - 1 ? zd(e, 0) + Math.PI * 2 : zd(e, t + 1);
  return t === n.length - 1 && a < 2 * Math.PI ? s : i === "start" || i === "end" ? i === "start" ? o : c : (o + c) / 2;
}, Hie = (e, t, n) => {
  const r = `${t.topLeft} ${t.topLeft} ${n}`, i = `${t.topRight} ${t.topRight} ${n}`, o = `${t.bottomLeft} ${t.bottomLeft} ${n}`, a = `${t.bottomRight} ${t.bottomRight} ${n}`;
  return `${["M", `A ${o},`, "L", `A ${r},`, "L", `A ${i},`, "L", `A ${a},`].reduce((l, u, d) => `${l}${u} ${e[d].x}, ${e[d].y} 
`, "")} z`;
}, Ftt = (e, t, n) => {
  const {
    x0: r,
    x1: i,
    y0: o,
    y1: a
  } = e, s = (c) => {
    const l = c === "Left", u = l ? 1 : -1, d = l ? r : i;
    let f = {
      x: d + u * n[`bottom${c}`],
      y: o
    }, h = {
      x: d,
      y: o - t * n[`bottom${c}`]
    }, p = {
      x: d,
      y: a + t * n[`top${c}`]
    }, g = {
      x: d + u * n[`top${c}`],
      y: a
    };
    if (t === 1 ? o - n[`bottom${c}`] < a + n[`top${c}`] : o + n[`bottom${c}`] > a - n[`top${c}`]) {
      const y = ic(d + u * n[`top${c}`], a + t * n[`top${c}`]), _ = Xw(y, n[`top${c}`]), b = ic(d + u * n[`bottom${c}`], o - t * n[`bottom${c}`]), w = Xw(b, n[`bottom${c}`]), C = _.intersection(w);
      if (C.length > 0) {
        const T = C[l ? 0 : 1];
        h = {
          x: T.x,
          y: T.y
        }, p = {
          x: T.x,
          y: T.y
        };
      } else if (n[`top${c}`] > n[`bottom${c}`]) {
        const E = _.solveX(o)[l ? 0 : 1];
        f = {
          x: E,
          y: o
        }, h = {
          x: E,
          y: o
        }, p = {
          x: E,
          y: o
        };
      } else {
        const E = w.solveX(a)[l ? 0 : 1];
        h = {
          x: E,
          y: a
        }, p = {
          x: E,
          y: a
        }, g = {
          x: E,
          y: a
        };
      }
    }
    const v = [f, h, p, g];
    return l ? v : v.reverse();
  };
  return s("Left").concat(s("Right"));
}, Vtt = (e, t, n) => {
  const {
    y0: r,
    y1: i
  } = e, o = e.x0 < e.x1 ? e.x0 : e.x1, a = e.x0 < e.x1 ? e.x1 : e.x0, s = (u) => {
    const d = u === "top", f = d ? -1 : 1, h = d ? i : r;
    let p = {
      x: o,
      y: h - f * n[`${u}Left`]
    }, g = {
      x: o + n[`${u}Left`],
      y: h
    }, m = {
      x: a - n[`${u}Right`],
      y: h
    }, v = {
      x: a,
      y: h - f * n[`${u}Right`]
    };
    if (g.x > m.x) {
      const _ = ic(o + n[`${u}Left`], h - f * n[`${u}Left`]), b = Xw(_, n[`${u}Left`]), w = ic(a - n[`${u}Right`], h - f * n[`${u}Right`]), C = Xw(w, n[`${u}Right`]), x = b.intersection(C);
      if (x.length > 0) {
        const E = x[t > 0 ? 1 : 0];
        g = {
          x: E.x,
          y: E.y
        }, m = {
          x: E.x,
          y: E.y
        };
      } else if (n[`${u}Right`] > n[`${u}Left`]) {
        const R = C.solveY(o)[d ? 0 : 1];
        p = {
          x: o,
          y: R
        }, g = {
          x: o,
          y: R
        }, m = {
          x: o,
          y: R
        };
      } else {
        const R = b.solveY(a)[d ? 0 : 1];
        v = {
          x: a,
          y: R
        }, m = {
          x: a,
          y: R
        }, g = {
          x: a,
          y: R
        };
      }
    }
    return [p, g, m, v];
  }, c = s("top"), l = s("bottom");
  return [
    l[1],
    l[0],
    ...c,
    // eslint-disable-next-line no-magic-numbers
    l[3],
    l[2]
  ];
}, Btt = (e, t, n) => {
  const r = Tk(e, t), i = r.y0 > r.y1 ? 1 : -1, o = i > 0 ? "0 0 1" : "0 0 0", a = Ftt(r, i, n);
  return Hie(a, n, o);
}, ztt = (e, t, n) => {
  const r = Tk(e, t), i = r.x0 < r.x1 ? 1 : -1, o = "0 0 1", a = {
    topRight: i > 0 ? n.topLeft : n.bottomLeft,
    bottomRight: i > 0 ? n.topRight : n.bottomRight,
    bottomLeft: i > 0 ? n.bottomRight : n.topRight,
    topLeft: i > 0 ? n.bottomLeft : n.topLeft
  }, s = Vtt(r, i, a);
  return Hie(s, a, o);
}, Htt = (e, t) => {
  const {
    datum: n,
    scale: r,
    index: i,
    alignment: o,
    style: a
  } = e, s = r.y(n._y0 || 0), c = r.y(n._y1 !== void 0 ? n._y1 : n._y), l = r.x(n._x1 !== void 0 ? n._x1 : n._x);
  let u, d;
  if (a.width) {
    const b = Ntt(e, a.width), w = o === "middle" ? b / 2 : b;
    u = o === "start" ? l : l - w, d = o === "end" ? l : l + w;
  } else
    u = jtt(e, Number(i)), d = Ltt(e, Number(i));
  const f = (b) => $C().innerRadius(s).outerRadius(c).startAngle(HV(u)).endAngle(HV(d)).cornerRadius(t[b])(), h = (b) => {
    const w = f(`${b}Right`), C = w.match(/[A-Z]/g) || [], x = w.split(/[A-Z]/).slice(1), T = C.indexOf("L"), E = f(`${b}Left`), R = E.match(/[A-Z]/g) || [], I = E.split(/[A-Z]/).slice(1), O = R.indexOf("L");
    return {
      rightMoves: C,
      rightCoords: x,
      rightMiddle: T,
      leftMoves: R,
      leftCoords: I,
      leftMiddle: O
    };
  }, p = () => {
    const {
      topRight: b,
      topLeft: w
    } = t, C = c * Math.abs(d - u), {
      rightMoves: x,
      rightCoords: T,
      rightMiddle: E,
      leftMoves: R,
      leftCoords: I,
      leftMiddle: O
    } = h("top");
    let P, k;
    if (b === w || C < 2 * b + 2 * w)
      P = b > w ? x : R, k = b > w ? T : I;
    else {
      const z = (U) => U < 3, V = w > b && z(E) ? 1 : 2;
      let B;
      if (b > w) {
        const U = z(E) ? O : O - 2;
        B = z(O) ? O - 1 : U;
      } else {
        const U = z(O) ? 1 : 2;
        B = z(E) ? U : O - 2;
      }
      P = [...x.slice(0, V), ...R.slice(B)], k = [...T.slice(0, V), ...I.slice(B)];
    }
    const L = P.indexOf("L"), N = P.slice(0, L), D = k.slice(0, L);
    return N.map((z, V) => ({
      command: z,
      coords: D[V].split(",")
    }));
  }, g = () => {
    const {
      bottomRight: b,
      bottomLeft: w
    } = t, C = s * Math.abs(d - u), {
      rightMoves: x,
      rightCoords: T,
      rightMiddle: E,
      leftMoves: R,
      leftCoords: I,
      leftMiddle: O
    } = h("bottom");
    let P, k;
    if (b === w || C < 2 * b + 2 * w)
      P = b > w ? x : R, k = b > w ? T : I;
    else {
      const z = (U, Q) => U.length - Q < 4, B = (b > w ? z(x, E) : z(R, O)) ? -1 : -3;
      P = [...R.slice(0, O + 2), ...x.slice(B)], k = [...I.slice(0, O + 2), ...T.slice(B)];
    }
    const L = P.indexOf("L"), N = P.slice(L, -1), D = k.slice(L, -1);
    return N.map((z, V) => ({
      command: z,
      coords: D[V].split(",")
    }));
  }, m = p(), v = g();
  return `${[...m, ...v].reduce((b, w) => `${b}${w.command} ${w.coords.join()}`, "")} z`;
}, Utt = (e, t, n) => e.getPath ? Dtt(e, t) : e.horizontal ? ztt(e, t, n) : Btt(e, t, n), Wtt = (e, t) => Htt(e, t), qtt = (e) => {
  const t = ktt(e.style, e), n = Rtt(e.barWidth, Object.assign({}, e, {
    style: t
  })), r = Mtt(e.cornerRadius, Object.assign({}, e, {
    style: t,
    barWidth: n
  })), i = Fe(e.ariaLabel, e), o = Fe(e.desc, e), a = Fe(e.id, e), s = Fe(e.tabIndex, e);
  return Object.assign({}, e, {
    ariaLabel: i,
    style: t,
    barWidth: n,
    cornerRadius: r,
    desc: o,
    id: a,
    tabIndex: s
  });
}, Gtt = {
  pathComponent: /* @__PURE__ */ j.createElement(sm, null),
  role: "presentation",
  shapeRendering: "auto"
}, Ktt = /* @__PURE__ */ ia(
  // eslint-disable-next-line prefer-arrow-callback
  function(t, n) {
    const r = qtt(qe({}, t, Gtt)), {
      polar: i,
      origin: o,
      style: a,
      barWidth: s,
      cornerRadius: c
    } = r, l = i ? Wtt(r, c) : Utt(r, s, c), u = i && o ? `translate(${o.x}, ${o.y})` : void 0;
    return r.pathComponent ? /* @__PURE__ */ j.cloneElement(r.pathComponent, {
      ...r.events,
      "aria-label": r.ariaLabel,
      style: a,
      d: l,
      className: r.className,
      clipPath: r.clipPath,
      desc: r.desc,
      index: r.index,
      role: r.role,
      shapeRendering: r.shapeRendering,
      transform: r.transform || u,
      tabIndex: r.tabIndex,
      ref: n
    }) : null;
  }
), UV = {
  width: 450,
  height: 300,
  padding: 50
}, Ytt = [{
  x: 1,
  y: 1
}, {
  x: 2,
  y: 2
}, {
  x: 3,
  y: 3
}, {
  x: 4,
  y: 4
}], Na = class Na extends j.Component {
  static getBaseProps(t) {
    return $tt(t, UV);
  }
  // Overridden in native versions
  shouldAnimate() {
    return !!this.props.animate;
  }
  render() {
    var a;
    const {
      animationWhitelist: t,
      role: n
    } = ZR, r = wr(this.props, UV, n);
    if (this.shouldAnimate())
      return this.animateComponent(r, t);
    let i;
    ((a = r.groupComponent) == null ? void 0 : a.type) === yg ? i = this.renderData(r, Na.shouldRenderDatum) : i = this.renderData(r);
    const o = r.standalone ? this.renderContainer(r.containerComponent, i) : i;
    return Wy(o, r);
  }
};
ve(Na, "animationWhitelist", ["data", "domain", "height", "padding", "style", "width"]), ve(Na, "displayName", "VictoryBar"), ve(Na, "role", "bar"), ve(Na, "defaultTransitions", {
  onLoad: {
    duration: 2e3,
    before: () => ({
      _y: 0,
      _y1: 0,
      _y0: 0
    }),
    after: (t) => ({
      _y: t._y,
      _y1: t._y1,
      _y0: t._y0
    })
  },
  onExit: {
    duration: 500,
    before: () => ({
      _y: 0,
      yOffset: 0
    })
  },
  onEnter: {
    duration: 500,
    before: () => ({
      _y: 0,
      _y1: 0,
      _y0: 0
    }),
    after: (t) => ({
      _y: t._y,
      _y1: t._y1,
      _y0: t._y0
    })
  }
}), ve(Na, "defaultProps", {
  containerComponent: /* @__PURE__ */ j.createElement(jo, null),
  data: Ytt,
  dataComponent: /* @__PURE__ */ j.createElement(Ktt, null),
  groupComponent: /* @__PURE__ */ j.createElement("g", {
    role: "presentation"
  }),
  labelComponent: /* @__PURE__ */ j.createElement(Ki, null),
  samples: 50,
  sortOrder: "ascending",
  standalone: !0,
  theme: $a.grayscale
}), ve(Na, "getDomain", BR), ve(Na, "getData", Do), ve(Na, "expectedComponents", ["dataComponent", "labelComponent", "groupComponent", "containerComponent"]), // passed to addEvents.renderData to prevent data props with undefined _x or _y from excluding data from render.
// used when inside of VictoryZoomContainer
ve(Na, "shouldRenderDatum", () => !0);
let JR = Na;
const ZR = ad(JR);
var Xtt = /\s/;
function Qtt(e) {
  for (var t = e.length; t-- && Xtt.test(e.charAt(t)); )
    ;
  return t;
}
var Jtt = Qtt, Ztt = Jtt, ent = /^\s+/;
function tnt(e) {
  return e && e.slice(0, Ztt(e) + 1).replace(ent, "");
}
var nnt = tnt, rnt = nnt, WV = Ya, int = Fy, qV = 0 / 0, ont = /^[-+]0x[0-9a-f]+$/i, ant = /^0b[01]+$/i, snt = /^0o[0-7]+$/i, cnt = parseInt;
function lnt(e) {
  if (typeof e == "number")
    return e;
  if (int(e))
    return qV;
  if (WV(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = WV(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = rnt(e);
  var n = ant.test(e);
  return n || snt.test(e) ? cnt(e.slice(2), n ? 2 : 8) : ont.test(e) ? qV : +e;
}
var unt = lnt;
function dnt(e) {
  for (var t = -1, n = e == null ? 0 : e.length, r = {}; ++t < n; ) {
    var i = e[t];
    r[i[0]] = i[1];
  }
  return r;
}
var fnt = dnt;
const hnt = /* @__PURE__ */ vn(fnt);
var eP = { exports: {} };
(function(e, t) {
  t = e.exports = n, t.getSerialize = r;
  function n(i, o, a, s) {
    return JSON.stringify(i, r(o, s), a);
  }
  function r(i, o) {
    var a = [], s = [];
    return o == null && (o = function(c, l) {
      return a[0] === l ? "[Circular ~]" : "[Circular ~." + s.slice(0, a.indexOf(l)).join(".") + "]";
    }), function(c, l) {
      if (a.length > 0) {
        var u = a.indexOf(this);
        ~u ? a.splice(u + 1) : a.push(this), ~u ? s.splice(u, 1 / 0, c) : s.push(c), ~a.indexOf(l) && (l = o.call(this, c, l));
      } else
        a.push(l);
      return i == null ? l : i.call(this, c, l);
    };
  }
})(eP, eP.exports);
var gnt = eP.exports;
const pnt = /* @__PURE__ */ vn(gnt);
class Hd extends j.Component {
  constructor(t) {
    super(t), this.getScopedEvents = Kte.bind(this), this.getEventState = Xte.bind(this), this.state = this.state || {}, this.sharedEventsCache = {}, this.globalEvents = {}, this.prevGlobalEventKeys = [], this.boundGlobalEvents = {}, this.baseProps = this.getBaseProps(t);
  }
  shouldComponentUpdate(t) {
    if (!Es(this.props, t)) {
      this.baseProps = this.getBaseProps(t);
      const n = this.getExternalMutations(t, this.baseProps);
      this.applyExternalMutations(t, n);
    }
    return !0;
  }
  componentDidMount() {
    const t = Object.keys(this.globalEvents);
    t.forEach((n) => this.addGlobalListener(n)), this.prevGlobalEventKeys = t;
  }
  componentDidUpdate() {
    const t = Object.keys(this.globalEvents);
    xw(this.prevGlobalEventKeys, t).forEach((i) => this.removeGlobalListener(i)), xw(t, this.prevGlobalEventKeys).forEach((i) => this.addGlobalListener(i)), this.prevGlobalEventKeys = t;
  }
  componentWillUnmount() {
    this.prevGlobalEventKeys.forEach((t) => this.removeGlobalListener(t));
  }
  addGlobalListener(t) {
    const n = (r) => {
      const i = this.globalEvents[t];
      return i && i(ene(r));
    };
    this.boundGlobalEvents[t] = n, window.addEventListener(Cw(t), n);
  }
  removeGlobalListener(t) {
    window.removeEventListener(Cw(t), this.boundGlobalEvents[t]);
  }
  getAllEvents(t) {
    const r = C3(t, ["container", "groupComponent"]);
    return Array.isArray(r) ? Array.isArray(t.events) ? r.concat(...t.events) : r : t.events;
  }
  applyExternalMutations(t, n) {
    if (!Lr(n)) {
      const r = t.externalEventMutations.reduce((o, a) => Rn(a.callback) ? o.concat(a.callback) : o, []), i = r.length ? () => {
        r.forEach((o) => o());
      } : void 0;
      this.setState(n, i);
    }
  }
  getExternalMutations(t, n) {
    return Lr(t.externalEventMutations) ? void 0 : IKe(t.externalEventMutations, n, this.state, Object.keys(n));
  }
  cacheSharedEvents(t, n, r) {
    this.sharedEventsCache[t] = [n, r];
  }
  getCachedSharedEvents(t, n) {
    const [r, i] = this.sharedEventsCache[t] || [];
    if (r && Es(n, i))
      return r;
  }
  getBaseProps(t) {
    const {
      container: n
    } = t, r = j.Children.toArray(this.props.children), i = this.getBasePropsFromChildren(r), o = n ? n.props : {};
    return Object.assign({}, i, {
      parent: o
    });
  }
  getBasePropsFromChildren(t) {
    const r = im(t, (i, o) => {
      if (i.type && Rn(i.type.getBaseProps)) {
        const a = i.props && i.type.getBaseProps(i.props);
        return a ? [[o, a]] : null;
      }
      return null;
    });
    return hnt(r);
  }
  getNewChildren(t, n) {
    const {
      events: r,
      eventKey: i
    } = t, o = (c, l) => c.reduce((u, d, f) => {
      if (d.props.children) {
        const h = j.Children.toArray(d.props.children), p = l.slice(f, f + h.length), g = /* @__PURE__ */ j.cloneElement(d, d.props, o(h, p));
        return u.concat(g);
      } else if (l[f] !== "parent" && d.type && Rn(d.type.getBaseProps)) {
        const h = d.props.name || l[f], p = Array.isArray(r) && r.filter((v) => v.target === "parent" ? !1 : Array.isArray(v.childName) ? v.childName.indexOf(h) > -1 : v.childName === h || v.childName === "all"), g = [h, n, p, pnt(this.state[h])], m = this.getCachedSharedEvents(h, g) || {
          events: p,
          // partially apply child name and baseProps,
          getEvents: (v, y) => this.getScopedEvents(v, y, h, n),
          // partially apply child name
          getEventState: (v, y) => this.getEventState(v, y, h)
        };
        return this.cacheSharedEvents(h, m, g), u.concat(/* @__PURE__ */ j.cloneElement(d, Object.assign({
          key: `events-${h}`,
          sharedEvents: m,
          eventKey: i,
          name: h
        }, d.props)));
      }
      return u.concat(d);
    }, []), a = Object.keys(n), s = j.Children.toArray(t.children);
    return o(s, a);
  }
  getContainer(t, n, r) {
    const i = this.getNewChildren(t, n), o = Array.isArray(r) ? r.filter((g) => g.target === "parent") : [], a = o.length > 0 ? {
      events: o,
      // partially apply childName (null) and baseProps,
      getEvents: (g, m) => this.getScopedEvents(g, m, null, n),
      getEventState: this.getEventState
    } : null, s = t.container || t.groupComponent, c = s.type && s.type.role, l = s.props || {}, u = Gte.bind(this), d = a && u({
      sharedEvents: a
    }, "parent"), f = qe({}, this.getEventState("parent", "parent"), l, n.parent, {
      children: i
    }), h = qe({}, Yte(d, "parent", f), l.events);
    this.globalEvents = Jte(h);
    const p = Zte(h);
    return c === "container" ? /* @__PURE__ */ j.cloneElement(s, Object.assign({}, f, {
      events: p
    })) : /* @__PURE__ */ j.cloneElement(s, p, i);
  }
  render() {
    const t = this.getAllEvents(this.props);
    return t ? this.getContainer(this.props, this.baseProps, t) : /* @__PURE__ */ j.cloneElement(this.props.container, {
      children: this.props.children
    });
  }
}
ve(Hd, "displayName", "VictorySharedEvents"), ve(Hd, "role", "shared-event-wrapper"), ve(Hd, "contextType", S3), ve(Hd, "defaultProps", {
  groupComponent: /* @__PURE__ */ j.createElement("g", null)
});
const ea = (e, t, n) => n === "x" ? e * Math.cos(t) : -e * Math.sin(t), Uie = (e) => {
  const t = e.dependentAxis ? "radial" : "angular", n = t === "angular" ? "radial" : "angular";
  return e.horizontal ? n : t;
}, mnt = (e, t) => Sk(e, (r) => t(r) % (2 * Math.PI)), Ik = (e, t) => ({
  tickStyle: Sr(e.ticks, t),
  labelStyle: Sr(e.tickLabels, t),
  gridStyle: Sr(e.grid, t)
}), vnt = (e) => {
  var c, l;
  const {
    theme: t = {},
    dependentAxis: n
  } = e, r = t.polarAxis && t.polarAxis.style || t.axis && t.axis.style, i = n ? "polarDependentAxis" : "polarIndependentAxis", o = n ? "dependentAxis" : "independentAxis", a = ((c = t == null ? void 0 : t[i]) == null ? void 0 : c.style) || ((l = t == null ? void 0 : t[o]) == null ? void 0 : l.style);
  return r && a ? (() => ["axis", "axisLabel", "grid", "parent", "tickLabels", "ticks"].reduce((d, f) => (d[f] = qe({}, a == null ? void 0 : a[f], r == null ? void 0 : r[f]), d), {}))() : a || r;
}, Wie = (e) => {
  const {
    left: t,
    right: n,
    top: r,
    bottom: i
  } = Gi(e.padding), {
    width: o,
    height: a
  } = e;
  if (o === void 0 || a === void 0)
    throw new Error("VictoryPolarAxis: width and height properties are required for standalone axes.");
  return Math.min(o - t - n, a - r - i) / 2;
}, qie = (e, t) => {
  if (e.range && e.range[t])
    return e.range[t];
  if (e.range && Array.isArray(e.range))
    return e.range;
  if (Uie(e) === "angular") {
    const i = pr(e.startAngle), o = pr(e.endAngle);
    return [i, o];
  }
  const r = Wie(e);
  return [e.innerRadius || 0, r];
}, Gie = (e) => {
  const t = ns(e), n = ra(e, t), r = om(e, t) || n.domain(), i = qie(e, t);
  return n.range(i), n.domain(r), n;
}, Kie = function(e, t) {
  if (t === void 0 && (t = {}), e.disableInlineStyles)
    return {};
  const n = e.style || {};
  return {
    parent: qe({
      height: "auto",
      width: "100%"
    }, n.parent, t.parent),
    axis: qe({}, n.axis, t.axis),
    axisLabel: qe({}, n.axisLabel, t.axisLabel),
    grid: qe({}, n.grid, t.grid),
    ticks: qe({}, n.ticks, t.ticks),
    tickLabels: qe({}, n.tickLabels, t.tickLabels)
  };
}, DC = (e) => {
  const {
    axisAngle: t,
    startAngle: n,
    dependentAxis: r
  } = e, i = ns(e), o = yre(e, i);
  return o === void 0 || !r ? t === void 0 ? n : t : ol(o);
}, ynt = (e, t, n, r) => {
  const {
    axisType: i,
    radius: o,
    scale: a,
    style: s,
    stringTicks: c,
    ticks: l,
    tickFormat: u,
    origin: d
  } = t, f = u(n, r, l), h = c ? c[r] : n, {
    tickStyle: p
  } = Ik(s, {
    tick: h,
    tickValue: n,
    index: r,
    ticks: l,
    stringTicks: c,
    radius: o,
    scale: a,
    axisType: i,
    text: f
  }), g = i === "radial" ? DC(e) : void 0, m = p.padding || p.size || 0, v = pr(90 - g), y = i === "angular" ? a(n) : pr(-1 * g), _ = i === "angular" ? o : a(n);
  return i === "angular" ? {
    index: r,
    datum: h,
    style: p,
    x1: ea(_, y, "x") + d.x,
    y1: ea(_, y, "y") + d.y,
    x2: ea(_ + m, y, "x") + d.x,
    y2: ea(_ + m, y, "y") + d.y
  } : {
    index: r,
    datum: h,
    style: p,
    x1: _ * Math.cos(y) + Math.cos(v) * m + d.x,
    x2: _ * Math.cos(y) - Math.cos(v) * m + d.x,
    y1: _ * Math.sin(y) + Math.sin(v) * m + d.y,
    y2: _ * Math.sin(y) - Math.sin(v) * m + d.y
  };
}, bnt = (e, t, n, r) => {
  const {
    axisType: i,
    radius: o,
    tickFormat: a,
    style: s,
    scale: c,
    ticks: l,
    stringTicks: u,
    origin: d
  } = t, f = a(n, r, l), h = u ? u[r] : n, {
    labelStyle: p
  } = Ik(s, {
    text: f,
    tick: h,
    tickValue: n,
    index: r,
    ticks: l,
    stringTicks: u,
    radius: o,
    scale: c,
    axisType: i
  }), {
    tickLabelComponent: g
  } = e, m = g != null && g.props.labelPlacement ? g.props.labelPlacement : e.labelPlacement, v = p.padding || 0, y = 0, _ = i === "radial" ? DC(e) : void 0, b = i === "angular" ? ol(c(n)) : _ + y, w = p.angle === void 0 ? ak(Object.assign({}, e, {
    labelPlacement: m
  }), b) : p.angle, C = i === "angular" ? o + v : c(n), x = p.textAnchor || ok(Object.assign({}, e, {
    labelPlacement: m
  }), b);
  return {
    index: r,
    datum: h,
    style: p,
    angle: w,
    textAnchor: x,
    text: f,
    x: C * Math.cos(pr(b)) + d.x,
    y: -C * Math.sin(pr(b)) + d.y
  };
}, _nt = (e, t, n, r) => {
  const {
    axisType: i,
    radius: o,
    style: a,
    scale: s,
    stringTicks: c,
    ticks: l,
    tickFormat: u,
    origin: d
  } = t, f = u(n, r, l), {
    startAngle: h,
    endAngle: p,
    innerRadius: g = 0
  } = e, m = c ? c[r] : n, {
    gridStyle: v
  } = Ik(a, {
    tick: m,
    tickValue: n,
    index: r,
    ticks: l,
    stringTicks: c,
    radius: o,
    scale: s,
    axisType: i,
    text: f
  }), y = s(n);
  return i === "angular" ? {
    index: r,
    datum: m,
    style: v,
    x1: ea(o, y, "x") + d.x,
    y1: ea(o, y, "y") + d.y,
    x2: ea(g, y, "x") + d.x,
    y2: ea(g, y, "y") + d.y
  } : {
    style: v,
    index: r,
    datum: m,
    cx: d.x,
    cy: d.y,
    r: s(n),
    startAngle: h,
    endAngle: p
  };
}, Snt = (e, t) => {
  const {
    axisType: n,
    radius: r,
    style: i,
    origin: o
  } = t, {
    axisLabelComponent: a
  } = e;
  if (n !== "radial")
    return {};
  const s = a != null && a.props.labelPlacement ? a.props.labelPlacement : e.labelPlacement, c = i && i.axisLabel || {}, l = n === "radial" ? DC(e) : void 0, u = c.angle === void 0 ? ak(Object.assign({}, e, {
    labelPlacement: s
  }), l) : c.angle, d = r + (c.padding || 0), f = c.textAnchor || ok(Object.assign({}, e, {
    labelPlacement: s
  }), l), h = c.verticalAnchor || _re(Object.assign({}, e, {
    labelPlacement: s
  }), l);
  return {
    style: c,
    angle: u,
    textAnchor: f,
    verticalAnchor: h,
    text: e.label,
    x: ea(d, pr(l), "x") + o.x,
    y: ea(d, pr(l), "y") + o.y
  };
}, wnt = (e, t) => {
  const {
    style: n,
    axisType: r,
    radius: i,
    origin: o
  } = t, {
    startAngle: a,
    endAngle: s,
    innerRadius: c = 0
  } = e, l = r === "radial" ? pr(DC(e)) : void 0;
  return r === "radial" ? {
    style: n.axis,
    x1: ea(c, l, "x") + o.x,
    x2: ea(i, l, "x") + o.x,
    y1: ea(c, l, "y") + o.y,
    y2: ea(i, l, "y") + o.y
  } : {
    style: n.axis,
    cx: o.x,
    cy: o.y,
    r: i,
    startAngle: a,
    endAngle: s
  };
}, xnt = (e) => {
  const t = Object.assign({
    polar: !0
  }, e), n = vnt(t), r = Kie(t, n), i = Gi(t.padding), o = ns(t), a = Uie(t), s = TC(t) ? t.tickValues : void 0, c = om(t, o), l = qie(t, o), u = Gie(t), d = vre(t, u), f = a === "angular" ? mnt(d, u) : d, h = mre(t, u), p = Wie(t), g = Zf(t);
  return {
    axis: o,
    style: r,
    padding: i,
    stringTicks: s,
    axisType: a,
    scale: u,
    ticks: f,
    tickFormat: h,
    domain: c,
    range: l,
    radius: p,
    origin: g
  };
}, Ent = (e, t) => {
  const n = IC(e, t), r = xnt(n), {
    style: i,
    scale: o,
    ticks: a,
    domain: s
  } = r, {
    width: c,
    height: l,
    standalone: u,
    theme: d,
    name: f
  } = n, h = wnt(n, r), p = Snt(n, r), g = {
    parent: {
      style: i.parent,
      ticks: a,
      scale: o,
      width: c,
      height: l,
      domain: s,
      standalone: u,
      theme: d,
      name: f
    }
  };
  return a.reduce((m, v, y) => (m[y] = {
    axis: h,
    axisLabel: p,
    ticks: ynt(n, r, v, y),
    tickLabels: bnt(n, r, v, y),
    grid: _nt(n, r, v, y)
  }, m), g);
}, sI = {
  width: 450,
  height: 300,
  padding: 50
};
class Vc extends j.Component {
  static getScale(t) {
    return Gie(t);
  }
  static getStyles(t) {
    return Kie(t, sI.style);
  }
  static getBaseProps(t) {
    return Ent(t, sI);
  }
  renderAxisLine(t) {
    const {
      dependentAxis: n
    } = t, r = n ? t.axisComponent : t.circularAxisComponent, i = this.getComponentProps(r, "axis", 0);
    return /* @__PURE__ */ j.cloneElement(r, i);
  }
  renderLabel(t) {
    const {
      axisLabelComponent: n,
      dependentAxis: r,
      label: i
    } = t;
    if (!i || !r)
      return null;
    const o = this.getComponentProps(n, "axisLabel", 0);
    return /* @__PURE__ */ j.cloneElement(n, o);
  }
  renderAxis(t) {
    const {
      tickComponent: n,
      tickLabelComponent: r,
      name: i
    } = t, o = (p) => {
      const {
        style: g = {},
        events: m = {}
      } = p;
      return g.stroke !== "transparent" && g.stroke !== "none" && g.strokeWidth !== 0 || !Lr(m);
    }, s = (t.dependentAxis ? "radial" : "angular") === "radial" ? t.circularGridComponent : t.gridComponent, c = this.dataKeys.map((p, g) => {
      const m = Object.assign({
        key: `${i}-tick-${p}`
      }, this.getComponentProps(n, "ticks", g)), v = /* @__PURE__ */ j.cloneElement(n, m);
      return o(v.props) ? v : void 0;
    }).filter(Boolean), l = this.dataKeys.map((p, g) => {
      const m = Object.assign({
        key: `${i}-grid-${p}`
      }, this.getComponentProps(s, "grid", g)), v = /* @__PURE__ */ j.cloneElement(s, m);
      return o(v.props) ? v : void 0;
    }).filter(Boolean), u = this.dataKeys.map((p, g) => {
      const m = Object.assign({
        key: `${i}-tick-${p}`
      }, this.getComponentProps(r, "tickLabels", g));
      return /* @__PURE__ */ j.cloneElement(r, m);
    }), d = this.renderAxisLine(t), f = this.renderLabel(t), h = [d, f, ...c, ...l, ...u];
    return this.renderGroup(t, h);
  }
  // Overridden in victory-native
  renderGroup(t, n) {
    const {
      groupComponent: r
    } = t;
    return /* @__PURE__ */ j.cloneElement(r, {}, n);
  }
  shouldAnimate() {
    return !!this.props.animate;
  }
  render() {
    const {
      animationWhitelist: t
    } = tP, n = IC(this.props, sI);
    if (this.shouldAnimate())
      return this.animateComponent(n, t);
    const r = this.renderAxis(n);
    return n.standalone ? this.renderContainer(n.containerComponent, r) : r;
  }
}
ve(Vc, "animationWhitelist", ["style", "domain", "range", "tickCount", "tickValues", "padding", "width", "height"]), ve(Vc, "displayName", "VictoryAxis"), ve(Vc, "role", "axis"), ve(Vc, "defaultTransitions", {
  onExit: {
    duration: 500
  },
  onEnter: {
    duration: 500
  }
}), ve(Vc, "defaultProps", {
  axisComponent: /* @__PURE__ */ j.createElement(rf, null),
  axisLabelComponent: /* @__PURE__ */ j.createElement(Ki, null),
  circularAxisComponent: /* @__PURE__ */ j.createElement(VV, null),
  circularGridComponent: /* @__PURE__ */ j.createElement(VV, null),
  containerComponent: /* @__PURE__ */ j.createElement(jo, null),
  endAngle: 360,
  gridComponent: /* @__PURE__ */ j.createElement(rf, null),
  groupComponent: /* @__PURE__ */ j.createElement("g", {
    role: "presentation"
  }),
  labelPlacement: "parallel",
  startAngle: 0,
  standalone: !0,
  theme: $a.grayscale,
  tickComponent: /* @__PURE__ */ j.createElement(rf, null),
  tickLabelComponent: /* @__PURE__ */ j.createElement(Ki, null)
}), ve(Vc, "getDomain", om), ve(Vc, "getAxis", ns), ve(Vc, "expectedComponents", ["axisComponent", "circularAxisComponent", "groupComponent", "containerComponent", "tickComponent", "tickLabelComponent", "gridComponent", "circularGridComponent"]);
const Cnt = {
  components: [{
    name: "axis",
    index: 0
  }, {
    name: "axisLabel",
    index: 0
  }, {
    name: "grid"
  }, {
    name: "parent",
    index: "parent"
  }, {
    name: "ticks"
  }, {
    name: "tickLabels"
  }]
}, tP = ad(Vc, Cnt), Tnt = {
  width: 450,
  height: 300,
  padding: 50
};
function Int(e, t, n) {
  const {
    domain: r,
    scale: i,
    stringMap: o,
    categories: a,
    horizontal: s
  } = n;
  return {
    stringMap: o,
    horizontal: s,
    categories: a,
    startAngle: t.startAngle,
    endAngle: t.endAngle,
    innerRadius: t.innerRadius,
    domain: r,
    scale: i
  };
}
function $nt(e, t) {
  const n = e.backgroundComponent, r = e.polar ? t.range.y[1] : t.range.y[0] - t.range.y[1], i = t.range.x[1] - t.range.x[0], o = e.horizontal ? t.scale.y.range()[0] : t.scale.x.range()[0], a = e.horizontal ? t.scale.x.range()[1] : t.scale.y.range()[1], s = e.polar ? t.origin.x : o, c = e.polar ? t.origin.y : a, l = e.name || "chart", u = {
    height: r,
    polar: e.polar,
    scale: t.scale,
    style: e.style.background,
    x: s,
    y: c,
    key: `${l}-background`,
    width: i
  };
  return /* @__PURE__ */ j.cloneElement(n, qe({}, n.props, u));
}
function Ant(e, t, n) {
  const r = hre([e]);
  if (r.length > 0)
    return Int(r[0], t, n);
  const {
    categories: i,
    domain: o,
    range: a,
    scale: s,
    stringMap: c,
    horizontal: l
  } = n;
  return {
    categories: i,
    domain: o,
    range: a,
    scale: s,
    stringMap: c,
    horizontal: l
  };
}
function Rnt(e) {
  const t = e.style && e.style.parent;
  return {
    parent: qe({}, t, {
      height: "100%",
      width: "100%",
      userSelect: "none"
    })
  };
}
function Yie(e, t) {
  const n = Rnt(e), r = wr(e, Tnt, "chart"), {
    horizontal: i,
    polar: o
  } = r, a = kie(r, t), s = xk(r, t, a), c = Ont(r, t, a), l = {
    x: GV(Object.assign({}, r, {
      categories: s
    }), "x", t),
    y: GV(Object.assign({}, r, {
      categories: s
    }), "y", t)
  }, u = {
    x: kr(r, "x"),
    y: kr(r, "y")
  }, d = {
    x: Of(r, "x") || gp(r, "x"),
    y: Of(r, "y") || gp(r, "y")
  }, f = {
    x: d.x.domain(l.x).range(i ? u.y : u.x),
    y: d.y.domain(l.y).range(i ? u.x : u.y)
  }, h = o ? Zf(r) : pre(l), p = Gi(r.padding);
  return {
    categories: s,
    domain: l,
    range: u,
    horizontal: i,
    scale: f,
    stringMap: c,
    style: n,
    origin: h,
    padding: p
  };
}
function Pnt(e, t, n) {
  const r = t || Xie(e), i = n || Yie(e, r), o = i.style.parent, {
    height: a,
    polar: s,
    theme: c,
    width: l
  } = e, {
    origin: u,
    horizontal: d
  } = i, f = e.name || "chart";
  return r.filter(j.isValidElement).map((h, p) => {
    const g = h.type && h.type.role, m = Array.isArray(h.props.style) ? h.props.style : qe({}, h.props.style, {
      parent: o
    }), v = Ant(h, e, i), y = h.props.name || `${f}-${g}-${p}`, _ = qe({
      horizontal: d,
      height: a,
      polar: s,
      theme: c,
      width: l,
      style: m,
      name: y,
      origin: s ? u : void 0,
      padding: i.padding,
      key: `${y}-key-${p}`,
      standalone: !1
    }, v);
    return /* @__PURE__ */ j.cloneElement(h, _);
  });
}
const Xie = (e, t) => {
  let n = j.Children.toArray(e.children);
  if (n.length === 0)
    n.push(t.independent, t.dependent);
  else {
    const r = {
      dependent: yV(n, "dependent"),
      independent: yV(n, "independent")
    };
    r.dependent.length === 0 && r.independent.length === 0 && (n = e.prependDefaultAxes ? [t.independent, t.dependent].concat(n) : n.concat([t.independent, t.dependent]));
  }
  return n;
}, GV = (e, t, n) => {
  const r = n || j.Children.toArray(e.children), i = Wv(e, t, r), o = gre(r, t);
  return o && o.props && o.props.invertAxis ? i.concat().reverse() : i;
}, Ont = (e, t, n) => {
  const r = !n.x || n.x.length === 0 ? null : n.x.reduce((o, a, s) => (o[a] = s + 1, o), {}), i = !n.y || n.y.length === 0 ? null : n.y.reduce((o, a, s) => (o[a] = s + 1, o), {});
  return {
    x: r,
    y: i
  };
}, Mnt = {
  width: 450,
  height: 300,
  padding: 50
}, knt = {
  backgroundComponent: /* @__PURE__ */ j.createElement(Get, null),
  containerComponent: /* @__PURE__ */ j.createElement(jo, null),
  defaultAxes: {
    independent: /* @__PURE__ */ j.createElement(ms, null),
    dependent: /* @__PURE__ */ j.createElement(ms, {
      dependentAxis: !0
    })
  },
  defaultPolarAxes: {
    independent: /* @__PURE__ */ j.createElement(tP, null),
    dependent: /* @__PURE__ */ j.createElement(tP, {
      dependentAxis: !0
    })
  },
  groupComponent: /* @__PURE__ */ j.createElement("g", null),
  standalone: !0,
  theme: $a.grayscale
}, Nnt = (e) => {
  const t = j.useMemo(() => qe({}, e, knt), [e]), n = "chart", {
    getAnimationProps: r,
    setAnimationState: i,
    getProps: o
  } = rk(), a = o(t), s = wr(a, Mnt, n), {
    desc: c,
    eventKey: l,
    containerComponent: u,
    standalone: d,
    groupComponent: f,
    externalEventMutations: h,
    width: p,
    height: g,
    theme: m,
    polar: v,
    name: y,
    title: _
  } = s, b = a.polar ? s.defaultPolarAxes : s.defaultAxes, w = j.useMemo(() => Xie(s, b), [s, b]), C = j.useMemo(() => Yie(s, w), [s, w]), {
    domain: x,
    scale: T,
    style: E,
    origin: R,
    horizontal: I
  } = C, O = j.useMemo(() => {
    const z = Pnt(a, w, C).map((V, B) => {
      const U = Object.assign({
        animate: r(a, V, B)
      }, V.props);
      return /* @__PURE__ */ j.cloneElement(V, U);
    });
    if (a.style && a.style.background) {
      const V = $nt(a, C);
      z.unshift(V);
    }
    return z;
  }, [r, w, a, C]), P = j.useMemo(() => d ? {
    desc: c,
    domain: x,
    width: p,
    height: g,
    horizontal: I,
    name: y,
    origin: v ? R : void 0,
    polar: v,
    theme: m,
    title: _,
    scale: T,
    standalone: d,
    style: E.parent
  } : {}, [c, x, g, I, y, R, v, T, d, E, _, m, p]), k = j.useMemo(() => {
    if (d) {
      const D = qe({}, u.props, P, es(t));
      return /* @__PURE__ */ j.cloneElement(u, D);
    }
    return f;
  }, [f, d, u, P, t]), L = j.useMemo(() => wk(a), [a]), N = nk(t);
  return j.useEffect(() => () => {
    t.animate && i(N, t);
  }, [i, N, t]), Lr(L) ? /* @__PURE__ */ j.cloneElement(k, k.props, O) : /* @__PURE__ */ j.createElement(Hd, {
    container: k,
    eventKey: l,
    events: L,
    externalEventMutations: h
  }, O);
}, pp = /* @__PURE__ */ j.memo(Nnt, Es);
pp.displayName = "VictoryChart";
pp.expectedComponents = ["groupComponent", "containerComponent"];
const Dnt = (e) => {
  const {
    pointerWidth: t,
    cornerRadius: n,
    orientation: r,
    width: i,
    height: o,
    center: a
  } = e, s = r === "bottom" ? 1 : -1, c = e.x + (e.dx || 0), l = e.y + (e.dy || 0), u = a.x, d = a.y, f = d + s * (o / 2), h = d - s * (o / 2), p = u + i / 2, g = u - i / 2, m = s * (l - f) < 0 ? 0 : e.pointerLength, y = `${n} ${n} ${r === "bottom" ? "0 0 0" : "0 0 1"}`;
  return `M ${u - t / 2}, ${f}
    L ${m ? c : u + t / 2}, ${m ? l : f}
    L ${u + t / 2}, ${f}
    L ${p - n}, ${f}
    A ${y} ${p}, ${f - s * n}
    L ${p}, ${h + s * n}
    A ${y} ${p - n}, ${h}
    L ${g + n}, ${h}
    A ${y} ${g}, ${h + s * n}
    L ${g}, ${f - s * n}
    A ${y} ${g + n}, ${f}
    z`;
}, jnt = (e) => {
  const {
    pointerWidth: t,
    cornerRadius: n,
    orientation: r,
    width: i,
    height: o,
    center: a
  } = e, s = r === "left" ? 1 : -1, c = e.x + (e.dx || 0), l = e.y + (e.dy || 0), u = a.x, d = a.y, f = u - s * (i / 2), h = u + s * (i / 2), p = d + o / 2, g = d - o / 2, m = s * (c - f) > 0 ? 0 : e.pointerLength, y = `${n} ${n} ${r === "left" ? "0 0 0" : "0 0 1"}`;
  return `M ${f}, ${d - t / 2}
    L ${m ? c : f}, ${m ? l : d + t / 2}
    L ${f}, ${d + t / 2}
    L ${f}, ${p - n}
    A ${y} ${f + s * n}, ${p}
    L ${h - s * n}, ${p}
    A ${y} ${h}, ${p - n}
    L ${h}, ${g + n}
    A ${y} ${h - s * n}, ${g}
    L ${f + s * n}, ${g}
    A ${y} ${f}, ${g + n}
    z`;
}, Lnt = (e) => {
  const t = e.orientation || "top";
  return t === "left" || t === "right" ? jnt(e) : Dnt(e);
}, Fnt = (e) => {
  const t = Fe(e.id, e), n = Sr(e.style, e);
  return {
    ...e,
    id: t,
    style: n
  };
}, Vnt = {
  pathComponent: /* @__PURE__ */ j.createElement(sm, null),
  role: "presentation",
  shapeRendering: "auto"
}, Bnt = (e) => {
  const t = Fnt(qe({}, e, Vnt)), n = es(t);
  w1(t.height, "Flyout props[height] is undefined"), w1(t.width, "Flyout props[width] is undefined"), w1(t.x, "Flyout props[x] is undefined"), w1(t.y, "Flyout props[y] is undefined");
  const r = {
    center: t.center || {
      x: 0,
      y: 0
    },
    cornerRadius: t.cornerRadius || 0,
    dx: t.dx,
    dy: t.dy,
    height: t.height,
    orientation: t.orientation || "top",
    pointerLength: t.pointerLength || 0,
    pointerWidth: t.pointerWidth || 0,
    width: t.width,
    x: t.x,
    y: t.y
  };
  return /* @__PURE__ */ j.cloneElement(t.pathComponent, {
    ...t.events,
    ...n,
    style: t.style,
    d: Lnt(r),
    className: t.className,
    shapeRendering: t.shapeRendering,
    role: t.role,
    transform: t.transform,
    clipPath: t.clipPath
  });
}, znt = {
  cornerRadius: 5,
  pointerLength: 10,
  pointerWidth: 10
};
class bg extends j.Component {
  static defaultEvents(t) {
    const n = t.activateData ? [{
      target: "labels",
      mutation: () => ({
        active: !0
      })
    }, {
      target: "data",
      mutation: () => ({
        active: !0
      })
    }] : [{
      target: "labels",
      mutation: () => ({
        active: !0
      })
    }], r = t.activateData ? [{
      target: "labels",
      mutation: () => ({
        active: void 0
      })
    }, {
      target: "data",
      mutation: () => ({
        active: void 0
      })
    }] : [{
      target: "labels",
      mutation: () => ({
        active: void 0
      })
    }];
    return [{
      target: "data",
      eventHandlers: {
        onMouseOver: () => n,
        onFocus: () => n,
        onTouchStart: () => n,
        onMouseOut: () => r,
        onBlur: () => r,
        onTouchEnd: () => r
      }
    }];
  }
  constructor(t) {
    super(t), this.id = t.id === void 0 ? uC("tooltip-") : t.id;
  }
  getDefaultOrientation(t) {
    const {
      datum: n,
      horizontal: r,
      polar: i
    } = t;
    if (!i) {
      const o = r ? "right" : "top", a = r ? "left" : "bottom";
      return n && n.y < 0 ? a : o;
    }
    return this.getPolarOrientation(t);
  }
  getPolarOrientation(t) {
    const n = Uv(t, t.datum), r = t.labelPlacement || "vertical";
    return r === "vertical" ? this.getVerticalOrientations(n) : r === "parallel" ? n < 90 || n > 270 ? "right" : "left" : n > 180 ? "bottom" : "top";
  }
  getVerticalOrientations(t) {
    return t < 45 || t > 315 ? "right" : t >= 45 && t <= 135 ? "top" : t > 135 && t < 225 ? "left" : "bottom";
  }
  getStyles(t) {
    const n = t.theme || $a.grayscale, r = n && n.tooltip && n.tooltip.style ? n.tooltip.style : {}, i = Array.isArray(t.style) ? t.style.map((l) => qe({}, l, r)) : qe({}, t.style, r), o = n && n.tooltip && n.tooltip.flyoutStyle ? n.tooltip.flyoutStyle : {}, a = t.flyoutStyle ? qe({}, t.flyoutStyle, o) : o, s = Array.isArray(i) ? i.map((l) => Sr(l, t)) : Sr(i, t), c = Sr(a, Object.assign({}, t, {
      style: s
    }));
    return {
      style: s,
      flyoutStyle: c
    };
  }
  getEvaluatedProps(t) {
    const {
      cornerRadius: n,
      centerOffset: r,
      dx: i,
      dy: o
    } = t, a = Fe(t.active, t);
    let s = Fe(t.text, Object.assign({}, t, {
      active: a
    }));
    s == null && (s = ""), typeof s == "number" && (s = s.toString());
    const {
      style: c,
      flyoutStyle: l
    } = this.getStyles(Object.assign({}, t, {
      active: a,
      text: s
    })), u = Fe(t.orientation, Object.assign({}, t, {
      active: a,
      text: s,
      style: c,
      flyoutStyle: l
    })) || this.getDefaultOrientation(t), d = Fe(t.flyoutPadding, Object.assign({}, t, {
      active: a,
      text: s,
      style: c,
      flyoutStyle: l,
      orientation: u
    })) || this.getLabelPadding(c), f = Gi(d), h = Fe(t.pointerWidth, Object.assign({}, t, {
      active: a,
      text: s,
      style: c,
      flyoutStyle: l,
      orientation: u
    })), p = Fe(t.pointerLength, Object.assign({}, t, {
      active: a,
      text: s,
      style: c,
      flyoutStyle: l,
      orientation: u
    })), g = hp(s, c), {
      flyoutHeight: m,
      flyoutWidth: v
    } = this.getDimensions(Object.assign({}, t, {
      style: c,
      flyoutStyle: l,
      active: a,
      text: s,
      orientation: u,
      flyoutPadding: f,
      pointerWidth: h,
      pointerLength: p
    }), g), y = Object.assign({}, t, {
      active: a,
      text: s,
      style: c,
      flyoutStyle: l,
      orientation: u,
      flyoutHeight: m,
      flyoutWidth: v,
      flyoutPadding: f,
      pointerWidth: h,
      pointerLength: p
    }), _ = ni(r) && (r == null ? void 0 : r.x) !== void 0 ? Fe(r.x, y) : 0, b = ni(r) && (r == null ? void 0 : r.y) !== void 0 ? Fe(r.y, y) : 0;
    return {
      ...y,
      centerOffset: {
        x: _,
        y: b
      },
      dx: i !== void 0 ? Fe(i, y) : 0,
      dy: o !== void 0 ? Fe(o, y) : 0,
      cornerRadius: Fe(n, y)
    };
  }
  getCalculatedValues(t) {
    const {
      style: n,
      text: r,
      flyoutStyle: i,
      flyoutHeight: o,
      flyoutWidth: a
    } = t, s = hp(r, n), c = {
      height: o,
      width: a
    }, l = this.getFlyoutCenter(t, c), u = this.getTransform(t);
    return {
      style: n,
      flyoutStyle: i,
      labelSize: s,
      flyoutDimensions: c,
      flyoutCenter: l,
      transform: u
    };
  }
  getTransform(t) {
    const {
      x: n,
      y: r,
      style: i
    } = t, a = (i || {}).angle || t.angle || this.getDefaultAngle(t);
    return a ? `rotate(${a} ${n} ${r})` : void 0;
  }
  getDefaultAngle(t) {
    const {
      polar: n,
      labelPlacement: r,
      orientation: i,
      datum: o
    } = t;
    if (!n || !r || r === "vertical")
      return 0;
    const a = Uv(t, o), s = a > 90 && a < 180 || a > 270 ? 1 : -1, c = r === "perpendicular" ? 0 : 90;
    let l = 0;
    return a === 0 || a === 180 ? l = i === "top" && a === 180 ? 270 : 90 : a > 0 && a < 180 ? l = 90 - a : a > 180 && a < 360 && (l = 270 - a), l + s * c;
  }
  constrainTooltip(t, n, r) {
    const {
      x: i,
      y: o
    } = t, {
      width: a,
      height: s
    } = r, c = {
      x: [0, n.width],
      y: [0, n.height]
    }, l = {
      x: [i - a / 2, i + a / 2],
      y: [o - s / 2, o + s / 2]
    }, u = {
      x: [l.x[0] < c.x[0] ? c.x[0] - l.x[0] : 0, l.x[1] > c.x[1] ? l.x[1] - c.x[1] : 0],
      y: [l.y[0] < c.y[0] ? c.y[0] - l.y[0] : 0, l.y[1] > c.y[1] ? l.y[1] - c.y[1] : 0]
    };
    return {
      x: Math.round(i + u.x[0] - u.x[1]),
      y: Math.round(o + u.y[0] - u.y[1])
    };
  }
  getFlyoutCenter(t, n) {
    const {
      x: r,
      y: i,
      dx: o,
      dy: a,
      pointerLength: s,
      orientation: c,
      constrainToVisibleArea: l,
      centerOffset: u
    } = t, {
      height: d,
      width: f
    } = n, h = c === "left" ? -1 : 1, p = c === "bottom" ? -1 : 1, g = {
      x: c === "left" || c === "right" ? r + h * (s + f / 2 + h * o) : r + o,
      y: c === "top" || c === "bottom" ? i - p * (s + d / 2 - p * a) : i + a
    }, m = {
      x: ni(t.center) && t.center.x !== void 0 ? t.center.x : g.x,
      y: ni(t.center) && t.center.y !== void 0 ? t.center.y : g.y
    }, v = {
      x: m.x + u.x,
      y: m.y + u.y
    };
    return l ? this.constrainTooltip(v, t, n) : v;
  }
  getLabelPadding(t) {
    if (!t)
      return 0;
    const n = Array.isArray(t) ? t.map((r) => r.padding) : [t.padding];
    return Math.max(...n, 0);
  }
  getDimensions(t, n) {
    const {
      orientation: r,
      pointerLength: i,
      pointerWidth: o,
      flyoutHeight: a,
      flyoutWidth: s,
      flyoutPadding: c
    } = t, l = Fe(t.cornerRadius, t), u = () => {
      const f = n.height + c.top + c.bottom, h = r === "top" || r === "bottom" ? 2 * l : 2 * l + o;
      return Math.max(h, f);
    }, d = () => {
      const f = n.width + c.left + c.right, h = r === "left" || r === "right" ? 2 * l + i : 2 * l;
      return Math.max(h, f);
    };
    return {
      flyoutHeight: a ? Fe(a, t) : u(),
      flyoutWidth: s ? Fe(s, t) : d()
    };
  }
  getLabelProps(t, n) {
    const {
      flyoutCenter: r,
      style: i,
      labelSize: o,
      dy: a = 0,
      dx: s = 0
    } = n, {
      text: c,
      datum: l,
      activePoints: u,
      labelComponent: d,
      index: f,
      flyoutPadding: h
    } = t, p = (Array.isArray(i) && i.length ? i[0].textAnchor : i.textAnchor) || "middle", g = () => {
      if (!p || p === "middle")
        return r.x;
      const m = p === "end" ? -1 : 1;
      return r.x - m * (o.width / 2);
    };
    return qe({}, d.props, {
      key: `${this.id}-label-${f}`,
      text: c,
      datum: l,
      activePoints: u,
      textAnchor: p,
      dy: a,
      dx: s,
      style: i,
      x: g() + (h.left - h.right) / 2,
      y: r.y + (h.top - h.bottom) / 2,
      verticalAnchor: "middle",
      angle: i.angle
    });
  }
  getPointerOrientation(t, n, r) {
    const i = {
      bottom: n.y + r.height / 2,
      top: n.y - r.height / 2,
      left: n.x - r.width / 2,
      right: n.x + r.width / 2
    }, o = [{
      side: "top",
      val: i.top > t.y ? i.top - t.y : -1
    }, {
      side: "bottom",
      val: i.bottom < t.y ? t.y - i.bottom : -1
    }, {
      side: "right",
      val: i.right < t.x ? t.x - i.right : -1
    }, {
      side: "left",
      val: i.left > t.x ? i.left - t.x : -1
    }];
    return zy(o, "val", "desc")[0].side;
  }
  getFlyoutProps(t, n) {
    const {
      flyoutDimensions: r,
      flyoutStyle: i,
      flyoutCenter: o
    } = n, {
      x: a,
      y: s,
      dx: c,
      dy: l,
      datum: u,
      activePoints: d,
      index: f,
      pointerLength: h,
      pointerWidth: p,
      cornerRadius: g,
      events: m,
      flyoutComponent: v
    } = t, y = Fe(t.pointerOrientation, t);
    return qe({}, v.props, {
      x: a,
      y: s,
      dx: c,
      dy: l,
      datum: u,
      activePoints: d,
      index: f,
      pointerLength: h,
      pointerWidth: p,
      cornerRadius: g,
      events: m,
      orientation: y || this.getPointerOrientation({
        x: a,
        y: s
      }, o, r),
      key: `${this.id}-tooltip-${f}`,
      width: r.width,
      height: r.height,
      style: i,
      center: o
    });
  }
  // Overridden in victory-core-native
  renderTooltip(t) {
    const n = Fe(t.active, t), {
      renderInPortal: r
    } = t;
    if (!n)
      return null;
    const i = this.getEvaluatedProps(t), {
      flyoutComponent: o,
      labelComponent: a,
      groupComponent: s
    } = i, c = this.getCalculatedValues(i), l = [/* @__PURE__ */ j.cloneElement(o, this.getFlyoutProps(i, c)), /* @__PURE__ */ j.cloneElement(a, this.getLabelProps(i, c))], u = /* @__PURE__ */ j.cloneElement(s, {
      role: "presentation",
      transform: c.transform
    }, l);
    return r ? /* @__PURE__ */ j.createElement(Uw, null, u) : u;
  }
  render() {
    const t = wr(this.props, znt, "tooltip");
    return this.renderTooltip(t);
  }
}
ve(bg, "displayName", "VictoryTooltip"), ve(bg, "role", "tooltip"), ve(bg, "defaultProps", {
  active: !1,
  renderInPortal: !0,
  labelComponent: /* @__PURE__ */ j.createElement(Ki, null),
  flyoutComponent: /* @__PURE__ */ j.createElement(Bnt, null),
  groupComponent: /* @__PURE__ */ j.createElement("g", null)
});
const T1 = (e, t, n) => {
  const r = n === "right" || n === "left";
  return /* @__PURE__ */ j.cloneElement(e.lineComponent, {
    ...e.events,
    role: e.role,
    shapeRendering: e.shapeRendering,
    className: e.className,
    style: e.style,
    transform: e.transform,
    key: `${e.id}-border-${n}`,
    x1: r ? t[n] : e.x - e.borderWidth,
    x2: r ? t[n] : e.x + e.borderWidth,
    y1: r ? e.y - e.borderWidth : t[n],
    y2: r ? e.y + e.borderWidth : t[n],
    "data-type": `border-${n}`
  });
}, I1 = (e, t, n) => {
  const r = n === "top" || n === "bottom";
  return /* @__PURE__ */ j.cloneElement(e.lineComponent, {
    ...e.events,
    role: e.role,
    shapeRendering: e.shapeRendering,
    className: e.className,
    style: e.style,
    transform: e.transform,
    key: `${e.id}-cross-${n}`,
    x1: e.x,
    x2: r ? e.x : t[n],
    y1: e.y,
    y2: r ? t[n] : e.y,
    "data-type": `cross-${n}`
  });
}, Hnt = (e) => {
  const {
    errorX: t,
    errorY: n
  } = e, r = {
    right: {
      error: t,
      errorIndex: 0
    },
    left: {
      error: t,
      errorIndex: 1
    },
    top: {
      error: n,
      errorIndex: 1
    },
    bottom: {
      error: n,
      errorIndex: 0
    }
  }, i = (a) => {
    const {
      error: s,
      errorIndex: c
    } = r[a];
    return s ? s[c] : void 0;
  };
  return ["right", "left", "top", "bottom"].reduce((a, s) => (a[s] = i(s), a), {});
}, Unt = (e) => {
  const t = Fe(e.ariaLabel, e), n = Fe(e.id, e), r = Sr(Object.assign({
    stroke: "black"
  }, e.style), e), i = Fe(e.tabIndex, e);
  return Object.assign({}, e, {
    ariaLabel: t,
    id: n,
    style: r,
    tabIndex: i
  });
}, Wnt = {
  groupComponent: /* @__PURE__ */ j.createElement("g", null),
  lineComponent: /* @__PURE__ */ j.createElement(Vie, null),
  role: "presentation",
  shapeRendering: "auto"
}, qnt = (e) => {
  const t = Unt(qe({}, e, Wnt)), {
    groupComponent: n
  } = t, r = es(t), {
    tabIndex: i,
    ariaLabel: o
  } = t, a = Hnt(t), s = [a.right ? T1(t, a, "right") : null, a.left ? T1(t, a, "left") : null, a.bottom ? T1(t, a, "bottom") : null, a.top ? T1(t, a, "top") : null, a.right ? I1(t, a, "right") : null, a.left ? I1(t, a, "left") : null, a.bottom ? I1(t, a, "bottom") : null, a.top ? I1(t, a, "top") : null].filter(Boolean);
  return /* @__PURE__ */ j.cloneElement(n, {
    tabIndex: i,
    "aria-label": o,
    ...r
  }, s);
};
var Gnt = gC, Knt = hC;
function Ynt(e, t, n, r) {
  var i = !n;
  n || (n = {});
  for (var o = -1, a = t.length; ++o < a; ) {
    var s = t[o], c = r ? r(n[s], e[s], s, n, e) : void 0;
    c === void 0 && (c = e[s]), i ? Knt(n, s, c) : Gnt(n, s, c);
  }
  return n;
}
var ih = Ynt, Xnt = dC, Qnt = fC;
function Jnt(e) {
  return Xnt(function(t, n) {
    var r = -1, i = n.length, o = i > 1 ? n[i - 1] : void 0, a = i > 2 ? n[2] : void 0;
    for (o = e.length > 3 && typeof o == "function" ? (i--, o) : void 0, a && Qnt(n[0], n[1], a) && (o = i < 3 ? void 0 : o, i = 1), t = Object(t); ++r < i; ) {
      var s = n[r];
      s && e(t, s, r, o);
    }
    return t;
  });
}
var Qie = Jnt, Znt = gC, ert = ih, trt = Qie, nrt = qu, rrt = iy, irt = Rp, ort = Object.prototype, art = ort.hasOwnProperty, srt = trt(function(e, t) {
  if (rrt(t) || nrt(t)) {
    ert(t, irt(t), e);
    return;
  }
  for (var n in t)
    art.call(t, n) && Znt(e, n, t[n]);
}), crt = srt;
const lrt = /* @__PURE__ */ vn(crt), KV = (e, t, n) => {
  const i = t[{
    x: "_errorX",
    y: "_errorY"
  }[n]];
  if (i === 0)
    return !1;
  const o = e.scale[n];
  return Array.isArray(i) ? [i[0] === 0 ? !1 : o(i[0] + t[`_${n}`]), i[1] === 0 ? !1 : o(t[`_${n}`] - i[1])] : [o(i + t[`_${n}`]), o(t[`_${n}`] - i)];
}, $k = (e) => {
  const t = ["x", "y", "errorX", "errorY"];
  if (e.data)
    return Dw(e.data, e, t);
  const n = e.errorX || e.errorY ? lre(e) : [];
  return Dw(n, e, t);
}, urt = (e, t) => {
  const n = ud(e, t), r = ld(e, t), i = $k(e);
  if (i.length < 1)
    return n !== void 0 && r !== void 0 ? Ps(n, r) : void 0;
  const o = t === "x" ? "_errorX" : "_errorY", a = (l) => {
    const u = l === "min" ? 1 / 0 : -1 / 0, d = l === "min" ? 1 : 0, f = l === "min" ? -1 : 1;
    return i.reduce((h, p) => {
      const g = Array.isArray(p[o]) ? p[o][d] : p[o], m = p[`_${t}`] + f * (g || 0);
      return h < m && l === "min" || h > m && l === "max" ? h : m;
    }, u);
  }, s = n !== void 0 ? n : a("min"), c = r !== void 0 ? r : a("max");
  return Ps(s, c);
}, nP = (e, t) => EC(urt)(e, t), drt = (e, t) => {
  const n = Ea(t.x), r = xa(t.x), i = Ea(t.y), o = xa(t.y);
  let {
    _x: a,
    _y: s
  } = e;
  return (a < n || a > r || s < i || s > o) && (a = s = null), Object.assign({}, e, {
    _x: a,
    _y: s
  });
}, frt = (e) => {
  const t = Uy(e, "errorbar"), n = rm(e.style, t) || {}, r = $k(e), i = {
    x: kr(e, "x"),
    y: kr(e, "y")
  }, o = {
    x: nP(e, "x"),
    y: nP(e, "y")
  }, a = {
    x: ra(e, "x").domain(o.x).range(e.horizontal ? i.y : i.x),
    y: ra(e, "y").domain(o.y).range(e.horizontal ? i.x : i.y)
  }, s = e.polar ? e.origin || Zf(e) : void 0;
  return {
    domain: o,
    data: r,
    scale: a,
    style: n,
    origin: s
  };
}, hrt = (e, t, n) => {
  const {
    x: r,
    y: i,
    index: o,
    scale: a,
    errorY: s,
    errorX: c,
    horizontal: l,
    labelComponent: u,
    theme: d,
    disableInlineStyles: f
  } = e, h = function(b) {
    b === void 0 && (b = "x");
    const w = b === "y" ? s : c;
    return (w && Array.isArray(w) ? w[0] : w) || e[b];
  }, p = n.labels || {}, g = p.padding || 0, m = l ? "start" : "middle", v = l ? "middle" : "end", y = {
    style: p,
    y: l ? i : h("y"),
    x: l ? h("x") : r,
    dy: l ? 0 : -g,
    dx: l ? g : 0,
    text: t,
    index: o,
    scale: a,
    datum: e.datum,
    data: e.data,
    textAnchor: p.textAnchor || m,
    verticalAnchor: p.verticalAnchor || v,
    angle: p.angle,
    horizontal: l,
    disableInlineStyles: f
  };
  if (!pC(u))
    return y;
  const _ = d && d.tooltip || {};
  return qe({}, y, Jf(_, ["style"]));
}, grt = (e, t) => {
  const n = wr(e, t, "errorbar"), r = Object.assign({}, n, frt(n)), {
    borderWidth: i,
    data: o,
    domain: a,
    events: s,
    groupComponent: c,
    height: l,
    horizontal: u,
    labels: d,
    name: f,
    origin: h,
    padding: p,
    polar: g,
    scale: m,
    sharedEvents: v,
    standalone: y,
    style: _,
    theme: b,
    width: w,
    disableInlineStyles: C
  } = r, x = {
    parent: {
      data: o,
      domain: a,
      height: l,
      horizontal: u,
      name: f,
      origin: h,
      padding: p,
      polar: g,
      scale: m,
      standalone: y,
      style: _.parent,
      theme: b,
      width: w
    }
  };
  return o.reduce((T, E, R) => {
    const I = Ga(E.eventKey) ? R : E.eventKey, {
      x: O,
      y: P
    } = Hy(lrt({}, r, {
      scale: m
    }), E), k = drt(E, a), L = KV(r, k, "x"), N = KV(r, k, "y"), D = {
      borderWidth: i,
      data: o,
      datum: k,
      errorX: u ? N : L,
      errorY: u ? L : N,
      groupComponent: c,
      horizontal: u,
      index: R,
      scale: m,
      style: C ? {} : _.data,
      x: O,
      y: P,
      disableInlineStyles: C
    };
    T[I] = {
      data: D
    };
    const z = Qy(r, E, R);
    return (z != null || d && (s || v)) && (T[I].labels = hrt(Object.assign({}, r, D), z, _)), T;
  }, x);
}, YV = {
  width: 450,
  height: 300,
  padding: 50
}, prt = [{
  x: 1,
  y: 1,
  errorX: 0.1,
  errorY: 0.1
}, {
  x: 2,
  y: 2,
  errorX: 0.2,
  errorY: 0.2
}, {
  x: 3,
  y: 3,
  errorX: 0.3,
  errorY: 0.3
}, {
  x: 4,
  y: 4,
  errorX: 0.4,
  errorY: 0.4
}];
class Id extends j.Component {
  static getDomain(t, n) {
    return nP(t, n);
  }
  static getData(t) {
    return $k(t);
  }
  static getBaseProps(t) {
    return grt(t, YV);
  }
  // Overridden in native versions
  shouldAnimate() {
    return !!this.props.animate;
  }
  render() {
    const {
      animationWhitelist: t,
      role: n
    } = Jie, r = wr(this.props, YV, n);
    if (this.shouldAnimate())
      return this.animateComponent(r, t);
    const i = this.renderData(r), o = r.standalone ? this.renderContainer(r.containerComponent, i) : i;
    return Wy(o, r);
  }
}
ve(Id, "animationWhitelist", ["data", "domain", "height", "padding", "samples", "style", "width", "errorX", "errorY", "borderWidth"]), ve(Id, "displayName", "VictoryErrorBar"), ve(Id, "role", "errorbar"), ve(Id, "defaultTransitions", bre()), ve(Id, "defaultProps", {
  containerComponent: /* @__PURE__ */ j.createElement(jo, null),
  data: prt,
  dataComponent: /* @__PURE__ */ j.createElement(qnt, null),
  labelComponent: /* @__PURE__ */ j.createElement(Ki, null),
  groupComponent: /* @__PURE__ */ j.createElement("g", {
    role: "presentation"
  }),
  samples: 50,
  sortOrder: "ascending",
  standalone: !0,
  theme: $a.grayscale
}), ve(Id, "expectedComponents", ["dataComponent", "labelComponent", "groupComponent", "containerComponent"]);
const Jie = ad(Id), Zie = {
  width: 450,
  height: 300,
  padding: 50,
  offset: 0
};
function eoe(e, t) {
  const n = "group", r = wr(e, Zie, n), i = Oie(r.theme, r.style, n), {
    offset: o,
    colorScale: a,
    color: s,
    polar: c,
    horizontal: l
  } = r, u = r.categories || xk(r, t, null), d = r.datasets || Rie(r, null), f = {
    x: Wv(Object.assign({}, r, {
      categories: u
    }), "x", t),
    y: Wv(Object.assign({}, r, {
      categories: u
    }), "y", t)
  }, h = r.range || {
    x: kr(r, "x"),
    y: kr(r, "y")
  }, p = {
    x: Of(r, "x") || gp(r, "x"),
    y: Of(r, "y") || gp(r, "y")
  }, g = {
    x: p.x.domain(f.x).range(r.horizontal ? h.y : h.x),
    y: p.y.domain(f.y).range(r.horizontal ? h.x : h.y)
  }, m = c ? r.origin : Zf(r), v = Gi(r.padding);
  return {
    datasets: d,
    categories: u,
    range: h,
    domain: f,
    horizontal: l,
    scale: g,
    style: i,
    colorScale: a,
    color: s,
    offset: o,
    origin: m,
    padding: v
  };
}
const mrt = (e) => {
  const {
    children: t
  } = e, n = j.Children.toArray(t).map((r) => ({
    ...r,
    props: Jf(r.props, ["sharedEvents"])
  }));
  return e.children = n, e;
};
function vrt(e) {
  const t = mrt(e), [n, r] = j.useState(t);
  return j.useEffect(() => {
    Es(t, n) || r(t);
  }, [n, r, t]), j.useMemo(() => eoe(n, n.children), [n]);
}
function yrt(e, t, n) {
  if (!e.offset)
    return 0;
  const r = Nte(t, e.horizontal), i = n.domain[t], o = n.range[r], a = Math.max(...i) - Math.min(...i), s = Math.max(...o) - Math.min(...o);
  return a / s * e.offset;
}
function brt(e, t, n, r) {
  const o = ((r === "stack" ? t.datasets[0].length : t.datasets.length) - 1) / 2, a = yrt(e, "x", t);
  return (n - o) * a;
}
function _rt(e, t, n, r) {
  const o = ((r === "stack" ? t.datasets[0].length : t.datasets.length) - 1) / 2, a = Srt(e, t);
  return (n - o) * a;
}
function Srt(e, t) {
  const {
    range: n
  } = t, r = Math.abs(n.x[1] - n.x[0]), i = Math.max(...n.y);
  return e.offset / (2 * Math.PI * i) * r;
}
function wrt(e, t, n) {
  if (e.labels)
    return Math.floor(t.length / 2) === n ? e.labels : void 0;
}
function xrt(e, t) {
  const {
    categories: n,
    domain: r,
    range: i,
    scale: o,
    horizontal: a,
    origin: s,
    padding: c
  } = t, {
    width: l,
    height: u,
    theme: d,
    polar: f
  } = e;
  return {
    height: u,
    width: l,
    theme: d,
    polar: f,
    origin: s,
    categories: n,
    domain: r,
    range: i,
    scale: o,
    horizontal: a,
    padding: c,
    standalone: !1
  };
}
function Ert(e, t) {
  const n = t.type && t.type.role, r = t.props.colorScale || e.colorScale;
  if (!(n !== "group" && n !== "stack"))
    return e.theme && e.theme.group ? r || e.theme.group.colorScale : r;
}
function Crt(e, t, n) {
  t === void 0 && (t = []);
  const r = e.data || e.y ? Do(e) : t, i = n || 0;
  return r.map((o) => {
    const a = o._x instanceof Date ? new Date(o._x.getTime() + i) : o._x + i;
    return Object.assign({}, o, {
      _x1: a
    });
  });
}
function toe(e, t, n) {
  const r = wr(e, Zie, "stack"), i = t || j.Children.toArray(r.children), o = n || eoe(r, i), {
    datasets: a
  } = o, {
    labelComponent: s,
    polar: c,
    theme: l
  } = r, u = xrt(r, o), d = r.name || "group";
  return i.map((f, h) => {
    const p = f.type && f.type.role, g = c ? _rt(r, o, h, p) : brt(r, o, h, p), m = p === "voronoi" || p === "tooltip" || p === "label" ? f.props.style : Mie(f, h, o, l), v = r.labels ? wrt(r, a, h) : f.props.labels, y = f.props.name || `${d}-${p}-${h}`;
    return /* @__PURE__ */ j.cloneElement(f, Object.assign({
      labels: v,
      style: m,
      key: `${y}-key-${h}`,
      name: y,
      data: Crt(r, a[h], g),
      colorScale: Ert(r, f),
      labelComponent: s || f.props.labelComponent,
      xOffset: g
    }, u));
  });
}
const Trt = {
  width: 450,
  height: 300,
  padding: 50,
  offset: 0
}, Irt = {
  containerComponent: /* @__PURE__ */ j.createElement(jo, null),
  groupComponent: /* @__PURE__ */ j.createElement("g", null),
  samples: 50,
  standalone: !0,
  theme: $a.grayscale
}, $rt = (e) => {
  const t = _g == null ? void 0 : _g.role, {
    getAnimationProps: n,
    setAnimationState: r,
    getProps: i
  } = rk(), o = j.useMemo(() => qe({}, e, Irt), [e]), a = i(o), s = wr(a, Trt, t), {
    eventKey: c,
    containerComponent: l,
    standalone: u,
    groupComponent: d,
    externalEventMutations: f,
    width: h,
    height: p,
    theme: g,
    polar: m,
    horizontal: v,
    name: y
  } = s, _ = j.Children.toArray(s.children), b = vrt(s), {
    domain: w,
    scale: C,
    style: x,
    origin: T
  } = b, E = j.useMemo(() => toe(a, _, b).map((N, D) => {
    const z = Object.assign({
      animate: n(a, N, D)
    }, N.props);
    return /* @__PURE__ */ j.cloneElement(N, z);
  }), [a, _, b, n]), R = j.useMemo(() => u ? {
    domain: w,
    scale: C,
    width: h,
    height: p,
    standalone: u,
    theme: g,
    style: x.parent,
    horizontal: v,
    polar: m,
    origin: T,
    name: y
  } : {}, [u, w, C, h, p, g, x, v, m, T, y]), I = j.useMemo(() => es(o), [o]), O = j.useMemo(() => {
    if (u) {
      const L = qe({}, l.props, R, I);
      return /* @__PURE__ */ j.cloneElement(l, L);
    }
    return /* @__PURE__ */ j.cloneElement(d, I);
  }, [d, u, l, R, I]), P = j.useMemo(() => wk(a), [a]), k = nk(o);
  return j.useEffect(() => () => {
    o.animate && r(k, a);
  }, [r, k, o, a]), Lr(P) ? /* @__PURE__ */ j.cloneElement(O, O.props, E) : /* @__PURE__ */ j.createElement(Hd, {
    container: O,
    eventKey: c,
    events: P,
    externalEventMutations: f
  }, E);
}, Art = {
  role: "group",
  expectedComponents: ["groupComponent", "containerComponent", "labelComponent"],
  getChildren: toe
}, _g = Object.assign(/* @__PURE__ */ j.memo($rt, Es), Art);
_g.displayName = "VictoryGroup";
var Rrt = Math.ceil, Prt = Math.max;
function Ort(e, t, n, r) {
  for (var i = -1, o = Prt(Rrt((t - e) / (n || 1)), 0), a = Array(o); o--; )
    a[r ? o : ++i] = e, e += n;
  return a;
}
var Mrt = Ort, krt = unt, XV = 1 / 0, Nrt = 17976931348623157e292;
function Drt(e) {
  if (!e)
    return e === 0 ? e : 0;
  if (e = krt(e), e === XV || e === -XV) {
    var t = e < 0 ? -1 : 1;
    return t * Nrt;
  }
  return e === e ? e : 0;
}
var jrt = Drt, Lrt = Mrt, Frt = fC, cI = jrt;
function Vrt(e) {
  return function(t, n, r) {
    return r && typeof r != "number" && Frt(t, n, r) && (n = r = void 0), t = cI(t), n === void 0 ? (n = t, t = 0) : n = cI(n), r = r === void 0 ? t < n ? 1 : -1 : cI(r), Lrt(t, n, r, e);
  };
}
var Brt = Vrt, zrt = Brt, Hrt = zrt(), Urt = Hrt;
const QV = /* @__PURE__ */ vn(Urt), Wrt = (e) => {
  const {
    colorScale: t,
    theme: n
  } = e;
  return typeof t == "string" ? vk(t, n) : t || [];
}, noe = (e) => {
  const {
    data: t,
    style: n
  } = e;
  return t.map((r, i) => {
    const o = qe({}, r.labels, n.labels);
    return Sr(o, {
      datum: r,
      index: i,
      data: t
    });
  });
}, qrt = function(e, t) {
  t === void 0 && (t = {});
  const n = e.style || {}, r = {
    height: "100%",
    width: "100%"
  };
  return {
    parent: qe(n.parent, t.parent, r),
    data: qe({}, n.data, t.data),
    labels: qe({}, n.labels, t.labels),
    border: qe({}, n.border, t.border),
    title: qe({}, n.title, t.title)
  };
}, roe = (e) => {
  const {
    orientation: t,
    theme: n
  } = e, r = n && n.legend && n.legend.style ? n.legend.style : {}, i = qrt(e, r), o = Wrt(e), a = t === "horizontal", s = Gi(e.borderPadding);
  return Object.assign({}, e, {
    style: i,
    isHorizontal: a,
    colorScale: o,
    borderPadding: s
  });
}, Grt = (e, t) => {
  const {
    itemsPerRow: n,
    isHorizontal: r
  } = e;
  return n ? r ? t % n : Math.floor(t / n) : r ? t : 0;
}, Krt = (e, t) => {
  const {
    itemsPerRow: n,
    isHorizontal: r
  } = e;
  return n ? r ? Math.floor(t / n) : t % n : r ? 0 : t;
}, ioe = (e) => {
  const {
    data: t
  } = e, n = e.style && e.style.data || {}, r = noe(e);
  return t.map((i, o) => {
    const a = i.symbol || {}, {
      fontSize: s
    } = r[o], c = a.size || n.size || s / 2.5, l = e.symbolSpacer || Math.max(c, s);
    return {
      ...i,
      size: c,
      symbolSpacer: l,
      fontSize: s,
      textSize: hp(i.name, r[o]),
      column: Grt(e, o),
      row: Krt(e, o)
    };
  });
}, ooe = (e, t) => {
  const n = e.gutter || {}, r = typeof n == "object" ? (n.left || 0) + (n.right || 0) : n || 0, i = _k(t, "column");
  return Object.keys(i).reduce((a, s, c) => {
    const l = i[s].map((u) => u.textSize.width + u.size + u.symbolSpacer + r);
    return a[c] = Math.max(...l), a;
  }, []);
}, aoe = (e, t) => {
  const n = e.rowGutter || {}, r = typeof n == "object" ? (n.top || 0) + (n.bottom || 0) : n || 0, i = _k(t, "row");
  return Object.keys(i).reduce((o, a, s) => {
    const l = i[a].map((u) => u.textSize.height + u.symbolSpacer + r);
    return o[s] = Math.max(...l), o;
  }, []);
}, soe = (e) => {
  const t = e.style && e.style.title || {}, n = hp(e.title, t), r = t.padding || 0;
  return {
    height: n.height + 2 * r || 0,
    width: n.width + 2 * r || 0
  };
}, Yrt = (e, t, n) => {
  const {
    column: r,
    row: i
  } = e;
  return {
    x: QV(r).reduce((o, a) => o + n[a], 0),
    y: QV(i).reduce((o, a) => o + t[a], 0)
  };
}, Xrt = (e, t) => {
  const n = {
    textAnchor: e === "right" ? "end" : "start",
    verticalAnchor: e === "bottom" ? "end" : "start"
  };
  if (t) {
    const r = e === "top" || e === "bottom";
    return {
      textAnchor: r ? "middle" : n.textAnchor,
      verticalAnchor: r ? n.verticalAnchor : "middle"
    };
  }
  return n;
}, Qrt = (e) => {
  const {
    titleOrientation: t,
    centerTitle: n,
    titleComponent: r
  } = e, i = e.style && e.style.title || {}, o = r.props && r.props.style || {}, a = Xrt(t, n);
  return Array.isArray(o) ? o.map((s) => qe({}, s, i, a)) : qe({}, o, i, a);
}, Jrt = (e, t) => {
  const {
    title: n,
    titleOrientation: r,
    centerTitle: i,
    borderPadding: o
  } = e, {
    height: a,
    width: s
  } = t, c = Qrt(e), l = Array.isArray(c) ? c[0].padding : c.padding, u = r === "top" || r === "bottom", d = r === "bottom" ? "bottom" : "top", f = r === "right" ? "right" : "left", h = {
    x: i ? s / 2 : o[d] + (l || 0),
    y: i ? a / 2 : o[f] + (l || 0)
  }, p = () => o[r] + (l || 0), g = u ? h.x : p(), m = u ? p() : h.y;
  return {
    x: r === "right" ? e.x + s - g : e.x + g,
    y: r === "bottom" ? e.y + a - m : e.y + m,
    style: c,
    text: n
  };
}, Zrt = (e, t, n) => {
  const {
    x: r,
    y: i,
    borderPadding: o,
    style: a
  } = e, s = (t || 0) + o.top + o.bottom, c = (n || 0) + o.left + o.right;
  return {
    x: r,
    y: i,
    height: s,
    width: c,
    style: Object.assign({
      fill: "none"
    }, a.border)
  };
}, coe = (e, t) => {
  const n = wr(e, t, "legend"), r = Object.assign({}, n, roe(n)), {
    title: i,
    titleOrientation: o
  } = r, a = ioe(r), s = ooe(r, a), c = aoe(r, a), l = i ? soe(r) : {
    height: 0,
    width: 0
  };
  return {
    height: o === "left" || o === "right" ? Math.max($1(c), l.height) : $1(c) + l.height,
    width: o === "left" || o === "right" ? $1(s) + l.width : Math.max($1(s), l.width)
  };
}, eit = (e, t) => {
  const n = wr(e, t, "legend"), r = Object.assign({}, n, roe(n)), {
    data: i,
    standalone: o,
    theme: a,
    padding: s,
    style: c,
    colorScale: l,
    gutter: u,
    rowGutter: d,
    borderPadding: f,
    title: h,
    titleOrientation: p,
    name: g,
    x: m = 0,
    y: v = 0
  } = r, y = ioe(r), _ = ooe(r, y), b = aoe(r, y), w = noe(r), C = h ? soe(r) : {
    height: 0,
    width: 0
  }, x = {
    x: p === "left" ? C.width : 0,
    y: p === "top" ? C.height : 0
  }, T = {
    x: u && typeof u == "object" && u.left || 0,
    y: d && typeof d == "object" && d.top || 0
  }, {
    height: E,
    width: R
  } = coe(r, t), I = Zrt(r, E, R), O = Jrt(r, I), P = {
    parent: {
      data: i,
      standalone: o,
      theme: a,
      padding: s,
      name: g,
      height: r.height,
      width: r.width,
      style: c.parent
    },
    all: {
      border: I,
      title: O
    }
  };
  return y.reduce((k, L, N) => {
    const D = l[N % l.length], z = qe({}, L.symbol, c.data, {
      fill: D
    }), V = Ga(L.eventKey) ? N : L.eventKey, B = Yrt(L, b, _), U = v + f.top + L.symbolSpacer, Q = m + f.left + L.symbolSpacer, Y = {
      index: N,
      data: i,
      datum: L,
      symbol: z.type || z.symbol || "circle",
      size: L.size,
      style: z,
      y: U + B.y + x.y + T.y,
      x: Q + B.x + x.x + T.x
    }, q = {
      datum: L,
      data: i,
      text: L.name,
      style: w[N],
      y: Y.y,
      x: Y.x + L.symbolSpacer + L.size / 2
    };
    return k[V] = {
      data: Y,
      labels: q
    }, k;
  }, P);
};
function $1(e) {
  if (e && e.length) {
    let t = 0;
    for (let n = 0; n < e.length; n++)
      t += e[n];
    return t;
  }
  return 0;
}
const lI = {
  orientation: "vertical",
  titleOrientation: "top",
  width: 450,
  height: 300,
  x: 0,
  y: 0
}, tit = [{
  name: "Series 1"
}, {
  name: "Series 2"
}];
class m0 extends j.Component {
  static getBaseProps(t) {
    return eit(t, lI);
  }
  static getDimensions(t) {
    return coe(t, lI);
  }
  renderChildren(t) {
    const {
      dataComponent: n,
      labelComponent: r,
      title: i
    } = t, o = [];
    if (t.borderComponent) {
      const a = this.getComponentProps(t.borderComponent, "border", "all"), s = /* @__PURE__ */ j.cloneElement(t.borderComponent, a);
      o.push(s);
    }
    if (n) {
      const a = this.dataKeys.map((s, c) => {
        if (s === "all")
          return;
        const l = this.getComponentProps(n, "data", c);
        return /* @__PURE__ */ j.cloneElement(n, l);
      }).filter((s) => s !== void 0);
      o.push(...a);
    }
    if (i && t.titleComponent) {
      const a = this.getComponentProps(i, "title", "all"), s = /* @__PURE__ */ j.cloneElement(t.titleComponent, a);
      o.push(s);
    }
    if (r) {
      const a = this.dataKeys.map((s, c) => {
        if (s === "all")
          return;
        const l = this.getComponentProps(r, "labels", c);
        if (l.text !== void 0 && l.text !== null)
          return /* @__PURE__ */ j.cloneElement(r, l);
      }).filter((s) => s !== void 0);
      o.push(...a);
    }
    return o;
  }
  render() {
    const {
      role: t
    } = this.constructor, n = wr(this.props, lI, t), r = this.renderChildren(n);
    return n.standalone ? this.renderContainer(n.containerComponent, r) : /* @__PURE__ */ j.cloneElement(n.groupComponent, {}, r);
  }
}
ve(m0, "displayName", "VictoryLegend"), ve(m0, "role", "legend"), ve(m0, "defaultProps", {
  borderComponent: /* @__PURE__ */ j.createElement(Xet, null),
  data: tit,
  containerComponent: /* @__PURE__ */ j.createElement(jo, null),
  dataComponent: /* @__PURE__ */ j.createElement(Bie, null),
  groupComponent: /* @__PURE__ */ j.createElement("g", null),
  labelComponent: /* @__PURE__ */ j.createElement(Ki, null),
  standalone: !0,
  theme: $a.grayscale,
  titleComponent: /* @__PURE__ */ j.createElement(Ki, null)
}), ve(m0, "expectedComponents", ["borderComponent", "containerComponent", "dataComponent", "groupComponent", "labelComponent", "titleComponent"]);
const Qw = ad(m0), nit = (e) => {
  let t = Do(e);
  t.length < 2 && (t = []);
  const n = {
    x: kr(e, "x"),
    y: kr(e, "y")
  }, r = {
    x: Mf(e, "x"),
    y: Mf(e, "y")
  }, i = {
    x: ra(e, "x").domain(r.x).range(e.horizontal ? n.y : n.x),
    y: ra(e, "y").domain(r.y).range(e.horizontal ? n.x : n.y)
  }, o = e.polar ? e.origin || Zf(e) : void 0, a = Uy(e, "line"), s = rm(e.style, a);
  return {
    domain: r,
    data: t,
    scale: i,
    style: s,
    origin: o
  };
}, rit = (e, t) => {
  const n = wr(e, t, "line"), r = Object.assign({}, n, nit(n)), {
    data: i,
    domain: o,
    events: a,
    groupComponent: s,
    height: c,
    horizontal: l,
    interpolation: u,
    origin: d,
    padding: f,
    polar: h,
    scale: p,
    sharedEvents: g,
    standalone: m,
    style: v,
    theme: y,
    width: _,
    labels: b,
    name: w,
    disableInlineStyles: C
  } = r, x = {
    parent: {
      style: v.parent,
      scale: p,
      data: i,
      height: c,
      width: _,
      name: w,
      domain: o,
      standalone: m,
      polar: h,
      origin: d,
      padding: f,
      horizontal: l
    },
    all: {
      data: {
        horizontal: l,
        polar: h,
        origin: d,
        scale: p,
        data: i,
        interpolation: u,
        groupComponent: s,
        style: C ? {} : v.data,
        theme: y,
        disableInlineStyles: C
      }
    }
  };
  return i.reduce((T, E, R) => {
    const I = Qy(r, E, R);
    if (I != null || b && (a || g)) {
      const O = Ga(E.eventKey) ? R : E.eventKey;
      T[O] = {
        labels: sk(r, R)
      };
    }
    return T;
  }, x);
}, iit = (e) => {
  const t = Fe(e.ariaLabel, e), n = Fe(e.id, e), r = Sr(Object.assign({
    fill: "none",
    stroke: "black",
    pointerEvents: "stroke"
  }, e.style), e), i = Fe(e.tabIndex, e);
  return Object.assign({}, e, {
    ariaLabel: t,
    id: n,
    style: r,
    tabIndex: i
  });
}, oit = {
  pathComponent: /* @__PURE__ */ j.createElement(sm, null),
  role: "presentation",
  shapeRendering: "auto"
}, ait = (e) => {
  const t = iit(qe({}, e, oit)), n = es(t), {
    polar: r,
    origin: i
  } = t, o = NJe(t), a = r && i ? `translate(${i.x}, ${i.y})` : void 0, s = o(t.data);
  return /* @__PURE__ */ j.cloneElement(t.pathComponent, {
    ...t.events,
    ...n,
    "aria-label": t.ariaLabel,
    d: s,
    style: t.style,
    transform: t.transform || a,
    className: t.className,
    role: t.role,
    shapeRendering: t.shapeRendering,
    clipPath: t.clipPath,
    tabIndex: t.tabIndex
  });
}, JV = {
  width: 450,
  height: 300,
  padding: 50,
  interpolation: "linear"
}, sit = {
  components: [{
    name: "parent",
    index: "parent"
  }, {
    name: "data",
    index: "all"
  }, {
    name: "labels"
  }]
}, ga = class ga extends j.Component {
  constructor(t) {
    super(t);
  }
  static getBaseProps(t) {
    return rit(t, JV);
  }
  // Overridden in native versions
  shouldAnimate() {
    return !!this.props.animate;
  }
  render() {
    const {
      animationWhitelist: t,
      role: n
    } = ga, r = wr(this.props, JV, n);
    if (this.shouldAnimate())
      return this.animateComponent(r, t);
    const i = this.renderContinuousData(r), o = r.standalone ? this.renderContainer(r.containerComponent, i) : i;
    return Wy(o, r);
  }
};
ve(ga, "animationWhitelist", ["data", "domain", "height", "padding", "samples", "style", "width"]), ve(ga, "displayName", "VictoryLine"), ve(ga, "role", "line"), ve(ga, "defaultTransitions", kQe()), ve(ga, "defaultPolarTransitions", NQe()), ve(ga, "continuous", !0), ve(ga, "defaultProps", {
  containerComponent: /* @__PURE__ */ j.createElement(jo, null),
  dataComponent: /* @__PURE__ */ j.createElement(ait, null),
  labelComponent: /* @__PURE__ */ j.createElement(Ki, {
    renderInPortal: !0
  }),
  groupComponent: /* @__PURE__ */ j.createElement(yg, null),
  samples: 50,
  sortKey: "x",
  sortOrder: "ascending",
  standalone: !0,
  theme: $a.grayscale
}), ve(ga, "getDomain", Mf), ve(ga, "getData", Do), ve(ga, "expectedComponents", ["dataComponent", "labelComponent", "groupComponent", "containerComponent"]);
let rP = ga;
const cit = ad(rP, sit), lit = (e) => e == null || Rn(e) ? e : `${e}`, uit = (e, t, n) => e && e.data && e.data.fill ? e.data.fill : t && t[n % t.length], dit = (e, t) => typeof e.radius == "number" ? e.radius : Math.min(e.width - t.left - t.right, e.height - t.top - t.bottom) / 2, fit = (e, t) => {
  const {
    width: n,
    height: r
  } = e, i = ni(e.origin) ? e.origin : {};
  return {
    x: i.x !== void 0 ? i.x : (t.left - t.right + n) / 2,
    y: i.y !== void 0 ? i.y : (t.top - t.bottom + r) / 2
  };
}, hit = (e, t) => {
  const n = Rn(e.padAngle) ? 0 : e.padAngle;
  return Ere().sort(null).startAngle(pr(e.startAngle)).endAngle(pr(e.endAngle)).padAngle(pr(n)).value((i) => i._y)(t);
}, git = (e) => {
  var t;
  return Array.isArray(e.categories) ? e.categories : ((t = e == null ? void 0 : e.categories) == null ? void 0 : t.x) ?? [];
}, pit = (e, t) => {
  const n = [];
  return git(e).forEach((r) => {
    const i = t.findIndex((o) => {
      let {
        x: a
      } = o;
      return a === r;
    });
    if (i >= 0) {
      const o = t.splice(i, 1)[0];
      n.push(o);
    }
  }), [...n, ...t];
}, mit = (e) => {
  const {
    colorScale: t,
    theme: n
  } = e, r = Uy(e, "pie"), i = rm(e.style, r), o = Array.isArray(t) ? t : vk(t, n), a = Gi(e.padding), s = dit(e, a), c = fit(e, a), l = pit(e, Do(e)), u = hit(e, l);
  return Object.assign({}, e, {
    style: i,
    colors: o,
    padding: a,
    defaultRadius: s,
    data: l,
    slices: u,
    origin: c
  });
}, vit = (e, t) => {
  const {
    style: n,
    colors: r
  } = t, i = uit(n, r, e);
  return Object.assign({
    fill: i
  }, n.data);
}, yit = (e, t, n) => {
  let r;
  return t.label ? r = t.label : Array.isArray(e.labels) ? r = e.labels[n] : r = Rn(e.labels) ? e.labels : t.xName || t._x, lit(r);
}, bit = (e) => $C().outerRadius(e).innerRadius(e), _it = (e, t, n) => {
  const r = n && n.padding || 0;
  return t || e + r;
}, Sit = (e, t, n) => {
  const r = {
    startAngle: n === "startAngle" ? t.startAngle : t.endAngle,
    endAngle: n === "endAngle" ? t.endAngle : t.startAngle
  }, i = Object.assign({}, t, r);
  return e.centroid(i);
}, wit = (e, t) => t === "perpendicular" ? e > 90 && e < 270 ? "bottom" : "top" : t === "parallel" ? e >= 0 && e <= 180 ? "right" : "left" : e < 45 || e > 315 ? "top" : e >= 45 && e < 135 ? "right" : e >= 135 && e < 225 ? "bottom" : "left", xit = (e) => e === "top" || e === "bottom" ? "middle" : e === "right" ? "start" : "end", Eit = (e) => e === "left" || e === "right" ? "middle" : e === "bottom" ? "start" : "end", Cit = (e, t, n) => {
  let r = 0;
  return t.angle !== void 0 ? r = n.angle : t === "centroid" ? r = ol((e.startAngle + e.endAngle) / 2) : r = ol(t === "startAngle" ? e.startAngle : e.endAngle), (r < 0 ? 360 - r : r) % 360;
}, Tit = (e, t) => t === "vertical" ? 0 : t === "parallel" ? e > 180 && e < 360 ? e + 90 : e - 90 : e > 90 && e < 270 ? e - 180 : e, Iit = (e, t, n) => {
  const {
    index: r,
    datum: i,
    data: o,
    slice: a,
    labelComponent: s,
    theme: c
  } = t, {
    style: l,
    defaultRadius: u,
    origin: d,
    width: f,
    height: h
  } = n, p = Fe(n.labelRadius, Object.assign({
    text: e
  }, t)), g = Fe(n.labelPosition, Object.assign({
    text: e
  }, t)) || "centroid", m = Fe(n.labelPlacement, Object.assign({
    text: e
  }, t)) || "vertical", v = Object.assign({
    padding: 0
  }, l.labels), y = Sr(v, Object.assign({
    labelRadius: p,
    text: e
  }, t)), _ = _it(u, p, y), b = bit(_), w = Sit(b, a, g), C = Cit(a, g, v), x = Tit(C, m), T = wit(C, m), E = v.textAnchor || xit(T), R = v.verticalAnchor || Eit(T), I = {
    width: f,
    height: h,
    index: r,
    datum: i,
    data: o,
    slice: a,
    orientation: T,
    text: e,
    style: v,
    x: Math.round(w[0]) + d.x,
    y: Math.round(w[1]) + d.y,
    textAnchor: E,
    verticalAnchor: R,
    angle: x,
    calculatedLabelRadius: _
  };
  if (!pC(s))
    return I;
  const O = c && c.tooltip || {};
  return qe({}, I, Jf(O, ["style"]));
}, $it = (e) => Math.cos(e - pr(90)), Ait = (e) => Math.sin(e - pr(90)), ZV = (e, t) => e * $it(t), eB = (e, t) => e * Ait(t), tB = (e) => e.reduce((t, n) => t + n, 0) / e.length, Rit = (e, t, n) => {
  const {
    innerRadius: r,
    radius: i,
    slice: {
      startAngle: o,
      endAngle: a
    },
    labelIndicatorInnerOffset: s,
    labelIndicatorOuterOffset: c,
    index: l
  } = e, {
    height: u,
    width: d
  } = t, {
    calculatedLabelRadius: f
  } = n, h = tB([r, i]), p = tB([a, o]), g = d / 2, m = u / 2, v = h + s, y = f - c, _ = g + ZV(v, p), b = m + eB(v, p), w = g + ZV(y, p), C = m + eB(y, p);
  return qe({}, {
    x1: _,
    y1: b,
    x2: w,
    y2: C,
    index: l
  });
}, Pit = (e, t) => {
  const n = wr(e, t, "pie"), r = mit(n), {
    slices: i,
    style: o,
    data: a,
    origin: s,
    defaultRadius: c,
    labels: l,
    events: u,
    sharedEvents: d,
    height: f,
    width: h,
    standalone: p,
    name: g,
    innerRadius: m,
    cornerRadius: v,
    padAngle: y,
    disableInlineStyles: _,
    labelIndicator: b
  } = r, w = n.radius || c, C = {
    parent: {
      standalone: p,
      height: f,
      width: h,
      slices: i,
      name: g,
      style: o.parent
    }
  };
  return i.reduce((x, T, E) => {
    const R = qe({}, a[E], {
      startAngle: ol(T.startAngle),
      endAngle: ol(T.endAngle),
      padAngle: ol(T.padAngle)
    }), I = Ga(R.eventKey) ? E : R.eventKey, O = {
      index: E,
      slice: T,
      datum: R,
      data: a,
      origin: s,
      innerRadius: m,
      radius: w,
      cornerRadius: v,
      padAngle: y,
      style: _ ? {} : vit(E, r),
      disableInlineStyles: _
    };
    x[I] = {
      data: O
    };
    const P = yit(n, R, E);
    if (P != null || l && (u || d)) {
      const k = Fe(P, O);
      if (x[I].labels = Iit(k, Object.assign({}, n, O), r), b) {
        const L = x[I].labels;
        L.calculatedLabelRadius > w && (x[I].labelIndicators = Rit(Object.assign({}, n, O), r, L));
      }
    }
    return x;
  }, C);
}, Oit = (e) => {
  const {
    slice: t,
    radius: n,
    innerRadius: r,
    cornerRadius: i
  } = e;
  if (Rn(e.pathFunction))
    return e.pathFunction(t);
  const o = pr(e.padAngle), a = pr(e.sliceStartAngle), s = pr(e.sliceEndAngle);
  return $C().cornerRadius(i).outerRadius(n).innerRadius(r || 0)(qe({
    startAngle: a,
    endAngle: s,
    padAngle: o
  }, t));
}, Mit = (e) => {
  const t = Sr(e.style, e), n = Fe(e.radius, Object.assign({}, e, {
    style: t
  })), r = Fe(e.innerRadius, Object.assign({}, e, {
    style: t,
    radius: n
  })), i = Fe(e.ariaLabel, e), o = Fe(e.id, e), a = Fe(e.cornerRadius, e), s = Fe(e.padAngle, e), c = Fe(e.sliceStartAngle, e), l = Fe(e.sliceEndAngle, e), u = Fe(e.tabIndex, e);
  return Object.assign({}, e, {
    ariaLabel: i,
    style: t,
    radius: n,
    innerRadius: r,
    id: o,
    cornerRadius: a,
    padAngle: s,
    sliceStartAngle: c,
    sliceEndAngle: l,
    tabIndex: u
  });
}, kit = {
  pathComponent: /* @__PURE__ */ j.createElement(sm, null),
  role: "presentation",
  shapeRendering: "auto"
}, Nit = (e) => {
  const t = Mit(qe({}, e, kit)), n = t.origin ? `translate(${t.origin.x}, ${t.origin.y})` : void 0;
  return /* @__PURE__ */ j.cloneElement(t.pathComponent, {
    ...t.events,
    "aria-label": t.ariaLabel,
    d: Oit(t),
    style: t.style,
    transform: t.transform || n,
    className: t.className,
    role: t.role,
    shapeRendering: t.shapeRendering,
    clipPath: t.clipPath,
    tabIndex: t.tabIndex
  });
}, nB = {
  endAngle: 360,
  height: 400,
  innerRadius: 0,
  cornerRadius: 0,
  padAngle: 0,
  padding: 30,
  width: 400,
  startAngle: 0,
  colorScale: ["#ffffff", "#f0f0f0", "#d9d9d9", "#bdbdbd", "#969696", "#737373", "#525252", "#252525", "#000000"],
  labelPosition: "centroid",
  labelIndicatorInnerOffset: 15,
  labelIndicatorOuterOffset: 5
}, Dit = (e) => !Ga(e._x) && !Ga(e._y);
class Fl extends j.Component {
  static getBaseProps(t) {
    return Pit(t, nB);
  }
  // Overridden in victory-native
  shouldAnimate() {
    return !!this.props.animate;
  }
  renderComponents(t, n) {
    n === void 0 && (n = Dit);
    const {
      dataComponent: r,
      labelComponent: i,
      groupComponent: o,
      labelIndicator: a,
      labelPosition: s
    } = t;
    if (!o)
      throw new Error("VictoryPie expects a groupComponent prop");
    const c = a && s === "centroid", l = [];
    if (r) {
      const u = this.dataKeys.reduce((d, f, h) => {
        const p = this.getComponentProps(r, "data", h);
        return n(p.datum) && d.push(/* @__PURE__ */ j.cloneElement(r, p)), d;
      }, []);
      l.push(...u);
    }
    if (i) {
      const u = this.dataKeys.map((d, f) => {
        const h = this.getComponentProps(i, "labels", f);
        if (h.text !== void 0 && h.text !== null)
          return /* @__PURE__ */ j.cloneElement(i, h);
      }).filter((d) => d !== void 0);
      l.push(...u);
    }
    if (c && a) {
      let u = /* @__PURE__ */ j.createElement(rf, null);
      typeof a == "object" && (u = a);
      const d = this.dataKeys.map((f, h) => {
        const p = this.getComponentProps(u, "labelIndicators", h);
        return /* @__PURE__ */ j.cloneElement(u, p);
      });
      l.push(...d);
    }
    return this.renderContainer(o, l);
  }
  render() {
    const {
      animationWhitelist: t,
      role: n
    } = loe, r = wr(this.props, nB, n);
    if (this.shouldAnimate())
      return this.animateComponent(r, t);
    const i = this.renderComponents(r), o = r.standalone ? this.renderContainer(r.containerComponent, i) : i;
    return Wy(o, r);
  }
}
ve(Fl, "animationWhitelist", ["data", "endAngle", "height", "innerRadius", "cornerRadius", "padAngle", "padding", "colorScale", "startAngle", "style", "width"]), ve(Fl, "displayName", "VictoryPie"), ve(Fl, "role", "pie"), ve(Fl, "defaultTransitions", {
  onExit: {
    duration: 500,
    before: () => ({
      _y: 0,
      label: " "
    })
  },
  onEnter: {
    duration: 500,
    before: () => ({
      _y: 0,
      label: " "
    }),
    after: (t) => ({
      y_: t._y,
      label: t.label
    })
  }
}), ve(Fl, "defaultProps", {
  data: [{
    x: "A",
    y: 1
  }, {
    x: "B",
    y: 2
  }, {
    x: "C",
    y: 3
  }, {
    x: "D",
    y: 1
  }, {
    x: "E",
    y: 2
  }],
  standalone: !0,
  dataComponent: /* @__PURE__ */ j.createElement(Nit, null),
  labelComponent: /* @__PURE__ */ j.createElement(Ki, null),
  containerComponent: /* @__PURE__ */ j.createElement(jo, null),
  groupComponent: /* @__PURE__ */ j.createElement("g", null),
  sortOrder: "ascending",
  theme: $a.grayscale
}), ve(Fl, "getData", Do), ve(Fl, "expectedComponents", ["dataComponent", "labelComponent", "groupComponent", "containerComponent", "labelIndicatorComponent"]);
const loe = ad(Fl), jit = (e, t) => t.bubbleProperty ? "circle" : e.symbol || t.symbol, Lit = (e, t) => {
  const {
    data: n,
    z: r,
    maxBubbleSize: i,
    minBubbleSize: o
  } = t, a = n.map((v) => v[r]), s = Math.min(...a), c = Math.max(...a), u = i || (() => {
    const v = Math.min(...Object.values(Gi(t.padding)));
    return Math.max(v, 5);
  })(), d = o || u * 0.1;
  if (c === s)
    return Math.max(d, 1);
  const f = Math.PI * Math.pow(u, 2), h = Math.PI * Math.pow(d, 2), p = (e[r] - s) / (c - s) * f, g = Math.max(p, h), m = Math.sqrt(g / Math.PI);
  return Math.max(m, 1);
}, Fit = (e, t) => {
  const {
    size: n,
    z: r
  } = t;
  return e.size ? typeof e.size == "function" ? e.size : Math.max(e.size, 1) : typeof t.size == "function" ? n : e[r] ? Lit(e, t) : Math.max(n || 0, 1);
}, Vit = (e) => {
  const t = Uy(e, "scatter"), n = rm(e.style, t), r = {
    x: kr(e, "x"),
    y: kr(e, "y")
  }, i = {
    x: Mf(e, "x"),
    y: Mf(e, "y")
  }, o = {
    x: ra(e, "x").domain(i.x).range(e.horizontal ? r.y : r.x),
    y: ra(e, "y").domain(i.y).range(e.horizontal ? r.x : r.y)
  }, a = e.polar ? e.origin || Zf(e) : void 0, s = e.bubbleProperty || "z";
  let c = Do(e);
  return c = cre(c, i), {
    domain: i,
    data: c,
    scale: o,
    style: n,
    origin: a,
    z: s
  };
}, Bit = (e, t) => {
  const n = wr(e, t, "scatter"), r = Object.assign({}, n, Vit(n)), {
    data: i,
    domain: o,
    events: a,
    height: s,
    origin: c,
    padding: l,
    polar: u,
    scale: d,
    name: f,
    sharedEvents: h,
    standalone: p,
    style: g,
    theme: m,
    width: v,
    labels: y,
    horizontal: _,
    disableInlineStyles: b
  } = r, w = {
    parent: {
      style: g.parent,
      scale: d,
      domain: o,
      data: i,
      height: s,
      width: v,
      standalone: p,
      theme: m,
      origin: c,
      polar: u,
      padding: l,
      name: f,
      horizontal: _
    }
  };
  return i.reduce((C, x, T) => {
    const E = Ga(x.eventKey) ? T : x.eventKey, {
      x: R,
      y: I
    } = Hy(r, x), O = {
      x: R,
      y: I,
      datum: x,
      data: i,
      index: T,
      scale: d,
      polar: u,
      origin: c,
      horizontal: _,
      size: Fit(x, r),
      symbol: jit(x, r),
      style: b ? {} : g.data,
      disableInlineStyles: b
    };
    C[E] = {
      data: O
    };
    const P = Qy(r, x, T);
    return (P != null || y && (a || h)) && (C[E].labels = sk(r, T)), C;
  }, w);
}, rB = {
  width: 450,
  height: 300,
  padding: 50,
  size: 3,
  symbol: "circle"
};
class Bc extends j.Component {
  static getBaseProps(t) {
    return Bit(t, rB);
  }
  // Overridden in native versions
  shouldAnimate() {
    return !!this.props.animate;
  }
  render() {
    const {
      animationWhitelist: t,
      role: n
    } = uoe, r = wr(this.props, rB, n);
    if (this.shouldAnimate())
      return this.animateComponent(r, t);
    const i = this.renderData(r), o = r.standalone ? this.renderContainer(r.containerComponent, i) : i;
    return Wy(o, r);
  }
}
ve(Bc, "animationWhitelist", ["data", "domain", "height", "maxBubbleSize", "padding", "samples", "size", "style", "width"]), ve(Bc, "displayName", "VictoryScatter"), ve(Bc, "role", "scatter"), ve(Bc, "defaultTransitions", bre()), ve(Bc, "defaultProps", {
  containerComponent: /* @__PURE__ */ j.createElement(jo, null),
  dataComponent: /* @__PURE__ */ j.createElement(Bie, null),
  labelComponent: /* @__PURE__ */ j.createElement(Ki, null),
  groupComponent: /* @__PURE__ */ j.createElement("g", null),
  samples: 50,
  sortOrder: "ascending",
  standalone: !0,
  theme: $a.grayscale
}), ve(Bc, "getDomain", Mf), ve(Bc, "getData", Do), ve(Bc, "expectedComponents", ["dataComponent", "labelComponent", "groupComponent", "containerComponent"]);
const uoe = ad(Bc), doe = {
  width: 450,
  height: 300,
  padding: 50
};
function zit(e, t) {
  const {
    fillInMissingData: n
  } = e, r = t.reduce((a, s) => (s.forEach((c) => {
    a[c._x instanceof Date ? c._x.getTime() : c._x] = !0;
  }), a), {}), i = Object.keys(r).map((a) => Number(a)), o = zy(i);
  return t.map((a) => {
    let s = 0;
    const c = a[0] && a[0]._x instanceof Date;
    return o.map((u, d) => {
      let f = Number(u);
      const h = a[d - s];
      if (h) {
        if ((c ? h._x.getTime() : h._x) === f)
          return h;
        s++;
        const m = n ? 0 : null;
        return f = c ? new Date(f) : f, {
          x: f,
          y: m,
          _x: f,
          _y: m
        };
      }
      const p = n ? 0 : null;
      return f = c ? new Date(f) : f, {
        x: f,
        y: p,
        _x: f,
        _y: p
      };
    });
  });
}
function Hit(e, t, n) {
  if (e.y0)
    return e.y0;
  const r = e._y, i = e._group, o = n[0].map((l) => l.y0), s = n.slice(0, t).reduce((l, u) => l.concat(u.filter((d) => e._x instanceof Date ? d._x.getTime() === e._x.getTime() : d._x === e._x).map((d) => d._y || 0)), []), c = s.length && s.reduce((l, u) => r < 0 && u < 0 || r >= 0 && u >= 0 ? Number(u) + l : l, o[i] || 0);
  return s.some((l) => l instanceof Date) ? new Date(c) : c;
}
function Uit(e, t, n) {
  const r = e.xOffset || 0;
  return t[n].map((i) => {
    const o = Hit(i, n, t) || 0;
    return Object.assign({}, i, {
      _y0: i._y instanceof Date ? o ? new Date(o) : i._y : o,
      _y1: i._y === null ? null : i._y instanceof Date ? new Date(Number(i._y) + Number(o)) : i._y + o,
      _x1: i._x === null ? null : i._x instanceof Date ? new Date(Number(i._x) + Number(r)) : i._x + r
    });
  });
}
function Wit(e, t) {
  const n = Rie(e, t), r = zit(e, n);
  return r.map((o) => o.filter((a) => a._x !== null && a._y !== null)).map((o, a) => Uit(e, r, a));
}
function foe(e, t) {
  const n = t || j.Children.toArray(e.children), r = "stack", i = wr(e, doe, r), o = Oie(i.theme, i.style, r), a = i.categories || xk(i, n), s = i.datasets || Wit(i, n), c = n.map((g, m) => /* @__PURE__ */ j.cloneElement(g, {
    data: s[m]
  })), l = {
    x: Wv(Object.assign({}, i, {
      categories: a
    }), "x", c),
    y: Wv(Object.assign({}, i, {
      categories: a
    }), "y", c)
  }, u = i.range || {
    x: kr(i, "x"),
    y: kr(i, "y")
  }, d = {
    x: Of(i, "x") || gp(i, "x"),
    y: Of(i, "y") || gp(i, "y")
  }, f = {
    x: d.x.domain(l.x).range(i.horizontal ? u.y : u.x),
    y: d.y.domain(l.y).range(i.horizontal ? u.x : u.y)
  }, {
    colorScale: h,
    horizontal: p
  } = i;
  return {
    datasets: s,
    categories: a,
    range: u,
    domain: l,
    horizontal: p,
    scale: f,
    style: o,
    colorScale: h,
    role: r
  };
}
const qit = (e) => {
  const {
    children: t
  } = e, n = j.Children.toArray(t).map((r) => {
    const i = r;
    return {
      ...i,
      props: Jf(i.props, ["sharedEvents"])
    };
  });
  return e.children = n, e;
};
function Git(e) {
  const t = qit(e), [n, r] = j.useState(t);
  return j.useEffect(() => {
    Es(t, n) || r(t);
  }, [n, r, t]), j.useMemo(() => foe(n, n.children), [n]);
}
function Kit(e, t, n) {
  if (e.labels)
    return t.length === n + 1 ? e.labels : void 0;
}
function Yit(e, t) {
  const {
    categories: n,
    domain: r,
    range: i,
    scale: o,
    horizontal: a
  } = t;
  return {
    height: e.height,
    width: e.width,
    padding: Gi(e.padding),
    standalone: !1,
    theme: e.theme,
    categories: n,
    domain: r,
    range: i,
    scale: o,
    horizontal: a
  };
}
function Xit(e, t) {
  const n = t.type && t.type.role, r = t.props.colorScale || e.colorScale;
  if (!(n !== "group" && n !== "stack"))
    return e.theme ? r || e.theme.props.colorScale : r;
}
function hoe(e, t, n) {
  const r = wr(e, doe, "stack"), i = t || j.Children.toArray(r.children), o = n || foe(r, i), {
    datasets: a
  } = o, s = Yit(r, o), c = r.name || "stack", {
    theme: l
  } = r;
  return i.map((u, d) => {
    const f = u.type && u.type.role, h = a[d], p = Mie(u, d, o, l), g = r.labels ? Kit(r, a, d) : u.props.labels, m = u.props.name || `${c}-${f}-${d}`;
    return /* @__PURE__ */ j.cloneElement(u, Object.assign({
      key: `${m}-key-${d}`,
      labels: g,
      name: m,
      domainPadding: u.props.domainPadding || r.domainPadding,
      theme: r.theme,
      labelComponent: r.labelComponent || u.props.labelComponent,
      style: p,
      colorScale: Xit(r, u),
      data: h,
      polar: r.polar
    }, s));
  });
}
const Qit = {
  width: 450,
  height: 300,
  padding: 50
}, Jit = {
  containerComponent: /* @__PURE__ */ j.createElement(jo, null),
  groupComponent: /* @__PURE__ */ j.createElement("g", null),
  standalone: !0,
  theme: $a.grayscale,
  fillInMissingData: !0
}, Zit = (e) => {
  const {
    role: t
  } = Ak, n = j.useMemo(() => qe({}, e, Jit), [e]), {
    setAnimationState: r,
    getAnimationProps: i,
    getProps: o
  } = rk(), a = o(n), s = wr(a, Qit, t), {
    eventKey: c,
    containerComponent: l,
    standalone: u,
    groupComponent: d,
    externalEventMutations: f,
    width: h,
    height: p,
    theme: g,
    polar: m,
    horizontal: v,
    name: y
  } = s, _ = j.Children.toArray(s.children), b = Git(s), {
    domain: w,
    scale: C,
    style: x
  } = b, T = j.useMemo(() => hoe(a, _, b).map((N, D) => {
    const z = Object.assign({
      animate: i(a, N, D)
    }, N.props);
    return /* @__PURE__ */ j.cloneElement(N, z);
  }).reverse(), [a, _, b, i]), E = j.useMemo(() => u ? {
    domain: w,
    scale: C,
    width: h,
    height: p,
    standalone: u,
    theme: g,
    style: x.parent,
    horizontal: v,
    polar: m,
    name: y
  } : {}, [u, w, C, h, p, g, x, v, m, y]), R = j.useMemo(() => es(n), [n]), I = j.useMemo(() => {
    if (u) {
      const k = qe({}, l.props, E, R);
      return /* @__PURE__ */ j.cloneElement(l, k);
    }
    return /* @__PURE__ */ j.cloneElement(d, R);
  }, [d, u, l, E, R]), O = j.useMemo(() => wk(a), [a]), P = nk(n);
  return j.useEffect(() => () => {
    n.animate && r(P, n);
  }, [r, P, n]), Lr(O) ? /* @__PURE__ */ j.cloneElement(I, I.props, T) : /* @__PURE__ */ j.createElement(Hd, {
    container: I,
    eventKey: c,
    events: O,
    externalEventMutations: f
  }, T);
}, eot = {
  role: "stack",
  expectedComponents: ["groupComponent", "containerComponent", "labelComponent"],
  getChildren: hoe
}, Ak = Object.assign(/* @__PURE__ */ j.memo(Zit, Es), eot);
Ak.displayName = "VictoryStack";
const uI = (e) => {
  const { loggingService: t } = gt(mn), n = $e(null);
  return ot(() => {
    n.current && t.debug("SizedVictoryLabel ref", n.current.getBBox());
  }, [t]), /* @__PURE__ */ A.jsx("g", { role: "presentation", ref: n, children: /* @__PURE__ */ A.jsx(
    Ki,
    {
      ...e,
      // dy: labelRef.current?.getBBox().height ? -labelRef.current.getBBox().height / 2 : 0,
      dy: -20
    }
  ) });
};
function Rk(e, t) {
  const n = t.colours ?? [
    e.primaryColour || "#252525",
    e.contrastColour || "#737373",
    "#969696",
    "#bdbdbd",
    "#d9d9d9",
    "#f0f0f0",
    "#525252"
  ], r = "#252525", i = "#969696", o = "inherit", a = "normal", s = 16, c = {
    // animate: { duration: 2000 },
    width: 450,
    height: 300,
    padding: { left: 75, top: 25, right: 50, bottom: 50 },
    colorScale: n
  }, l = {
    fontFamily: o,
    fontSize: s,
    letterSpacing: a,
    padding: 10,
    fill: r,
    stroke: "transparent"
  }, u = Object.assign({ textAnchor: "middle" }, l), d = "round", f = "round";
  return {
    area: Object.assign(
      {
        style: {
          data: {
            fill: r
          },
          labels: l
        }
      },
      c
    ),
    axis: Object.assign(
      {
        style: {
          axis: {
            fill: "transparent",
            stroke: r,
            strokeWidth: 1,
            strokeLinecap: d,
            strokeLinejoin: f
          },
          axisLabel: Object.assign({}, u, { padding: 35 }),
          grid: {
            fill: "none",
            stroke: "none",
            pointerEvents: "painted"
          },
          ticks: {
            fill: "transparent",
            size: 1,
            stroke: "transparent"
          },
          tickLabels: l
        }
      },
      c
    ),
    dependentAxis: Object.assign(
      {
        style: {
          axis: {
            fill: "transparent",
            stroke: r,
            strokeWidth: 1,
            strokeLinecap: d,
            strokeLinejoin: f
          },
          axisLabel: Object.assign({}, u, {
            padding: 35
          }),
          grid: {
            fill: "none",
            stroke: "none",
            pointerEvents: "painted"
          },
          ticks: {
            fill: "transparent",
            size: 1,
            stroke: "transparent"
          },
          tickLabels: l
        }
      },
      c
    ),
    bar: Object.assign(
      {
        style: {
          data: {
            fill: r,
            padding: 8,
            strokeWidth: 0
          },
          labels: l
        }
      },
      c
    ),
    boxplot: Object.assign(
      {
        style: {
          max: { padding: 8, stroke: r, strokeWidth: 1 },
          maxLabels: Object.assign({}, l, { padding: 3 }),
          median: { padding: 8, stroke: r, strokeWidth: 1 },
          medianLabels: Object.assign({}, l, { padding: 3 }),
          min: { padding: 8, stroke: r, strokeWidth: 1 },
          minLabels: Object.assign({}, l, { padding: 3 }),
          q1: { padding: 8, fill: i },
          q1Labels: Object.assign({}, l, { padding: 3 }),
          q3: { padding: 8, fill: i },
          q3Labels: Object.assign({}, l, { padding: 3 })
        },
        boxWidth: 20
      },
      c
    ),
    candlestick: Object.assign(
      {
        style: {
          data: {
            stroke: r,
            strokeWidth: 1
          },
          labels: Object.assign({}, l, { padding: 5 })
        },
        candleColors: {
          positive: "#ffffff",
          negative: r
        }
      },
      c
    ),
    chart: c,
    errorbar: Object.assign(
      {
        borderWidth: 8,
        style: {
          data: {
            fill: "transparent",
            stroke: r,
            strokeWidth: 2
          },
          labels: l
        }
      },
      c
    ),
    group: Object.assign(
      {
        colorScale: n
      },
      c
    ),
    histogram: Object.assign(
      {
        style: {
          data: {
            fill: i,
            stroke: r,
            strokeWidth: 2
          },
          labels: l
        }
      },
      c
    ),
    legend: {
      colorScale: n,
      gutter: 10,
      orientation: "vertical",
      titleOrientation: "top",
      style: {
        data: {
          type: "circle"
        },
        labels: l,
        title: Object.assign({}, l, { padding: 5 })
      }
    },
    line: Object.assign(
      {
        style: {
          data: {
            fill: "transparent",
            stroke: r,
            strokeWidth: 2
          },
          labels: l
        }
      },
      c
    ),
    pie: {
      style: {
        data: {
          padding: 10,
          stroke: "transparent",
          strokeWidth: 1
        },
        labels: Object.assign({}, l, { padding: 20 })
      },
      colorScale: n,
      width: 400,
      height: 400,
      padding: 50
    },
    scatter: Object.assign(
      {
        style: {
          data: {
            fill: r,
            stroke: "transparent",
            strokeWidth: 0
          },
          labels: l
        }
      },
      c
    ),
    stack: Object.assign(
      {
        colorScale: n
      },
      c
    ),
    tooltip: {
      style: Object.assign({}, l, { padding: 0, pointerEvents: "none" }),
      flyoutStyle: {
        stroke: r,
        strokeWidth: 1,
        fill: "#f0f0f0",
        pointerEvents: "none"
      },
      flyoutPadding: 5,
      cornerRadius: 5,
      pointerLength: 10
    },
    voronoi: Object.assign(
      {
        style: {
          data: {
            fill: "transparent",
            stroke: "transparent",
            strokeWidth: 0
          },
          labels: Object.assign({}, l, { padding: 5, pointerEvents: "none" }),
          flyout: {
            stroke: r,
            strokeWidth: 1,
            fill: "#f0f0f0",
            pointerEvents: "none"
          }
        }
      },
      c
    )
  };
}
const of = (e) => /* @__PURE__ */ A.jsx(tot, { style: e.style, children: e.children }), tot = ce.div`
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  justify-content: center;
  padding: 0;
  overflow: visible;
`, not = ({
  output: e,
  currentAnswer: t,
  answers: n,
  settings: r,
  aggregateAnswers: i
}) => {
  var _, b;
  const { loggingService: o } = gt(mn), a = No(), s = Ny(e.data, { currentAnswer: t, answers: n, aggregateAnswers: i }), c = Qn(e.text, { currentAnswer: t, answers: n, aggregateAnswers: i }), l = Qn(e.legendOptions, { currentAnswer: t, answers: n, aggregateAnswers: i }) ?? {}, u = Qn(e.chartOptions, { currentAnswer: t, answers: n, aggregateAnswers: i }) ?? {}, d = Qn(e.xAxisOptions, {
    currentAnswer: t,
    answers: n,
    aggregateAnswers: i
  }), f = Qn(e.yAxisOptions, {
    currentAnswer: t,
    answers: n,
    aggregateAnswers: i
  }), { colourShades: h } = Gn(), p = Rk(r, { colours: u.colours ?? h });
  if (o.debug("data", s), s === "loading")
    return /* @__PURE__ */ A.jsx(of, { style: e.style, children: /* @__PURE__ */ A.jsx(tp, {}) });
  const g = s == null ? void 0 : s.map((w) => w.label), m = {
    theme: p,
    containerComponent: /* @__PURE__ */ A.jsx(jo, { style: { touchAction: "auto" } }),
    ...u
  };
  a === Xn.MOBILE && (m.width = 400);
  const v = g == null ? void 0 : g.map((w) => ({ name: w })), y = {
    theme: p,
    orientation: l.orientation,
    x: rot(l.position, m.width || ((_ = p.chart) == null ? void 0 : _.width)),
    y: iot(l.position, m.height || ((b = p.chart) == null ? void 0 : b.height)),
    data: v,
    gutter: l.gutter,
    colorScale: l.colorScale ?? void 0
  };
  switch (e.barType) {
    case "grouped":
      return /* @__PURE__ */ A.jsxs(of, { style: e.style, children: [
        e.title ? /* @__PURE__ */ A.jsx(iB, { children: e.title }) : void 0,
        c && /* @__PURE__ */ A.jsx(oB, { children: c }),
        /* @__PURE__ */ A.jsxs(pp, { horizontal: e.orientation === "horizontal", ...m, children: [
          /* @__PURE__ */ A.jsx(_g, { offset: 21, colorScale: e.groupColours, children: s && s.map((w, C) => /* @__PURE__ */ A.jsx(
            ZR,
            {
              categories: e.categories ? { x: e.categories } : void 0,
              barWidth: u.barWidth ?? 25,
              labelComponent: u.tooltips ? /* @__PURE__ */ A.jsx(bg, {}) : void 0,
              labels: w.dataset.map((x) => x.annotation ?? ""),
              data: w.dataset.map((x, T) => ({
                x: x.label,
                y: x.value,
                fill: x.fill,
                stroke: x.stroke
              })),
              style: {
                data: {
                  fill: ({ datum: x }) => {
                    var T, E;
                    return x.fill ?? ((E = (T = p.bar) == null ? void 0 : T.colorScale) == null ? void 0 : E[C]);
                  },
                  stroke: ({ datum: x }) => x.stroke,
                  strokeWidth: ({ datum: x }) => x.stroke ? 2 : 0
                }
              }
            },
            C
          )).toReversed() }),
          /* @__PURE__ */ A.jsx(_g, { offset: 21, children: s && s.map((w, C) => /* @__PURE__ */ A.jsx(
            Jie,
            {
              data: w.dataset.map((x) => ({
                x: x.label,
                y: x.value,
                errorY: x.error
              }))
            },
            `${C}-error`
          )).toReversed() }),
          /* @__PURE__ */ A.jsx(
            ms,
            {
              label: e.xLabel,
              axisLabelComponent: /* @__PURE__ */ A.jsx(uI, {}),
              tickFormat: d == null ? void 0 : d.tickFormat,
              tickValues: d == null ? void 0 : d.tickValues
            }
          ),
          /* @__PURE__ */ A.jsx(
            ms,
            {
              dependentAxis: !0,
              label: e.yLabel,
              axisLabelComponent: /* @__PURE__ */ A.jsx(uI, {}),
              style: { axisLabel: { padding: 50 } },
              tickValues: f == null ? void 0 : f.tickValues,
              tickFormat: f == null ? void 0 : f.tickFormat
            }
          ),
          e.legendOptions && /* @__PURE__ */ A.jsx(Qw, { ...y })
        ] })
      ] });
    case "stacked":
      return /* @__PURE__ */ A.jsxs(of, { style: e.style, children: [
        e.title ? /* @__PURE__ */ A.jsx(iB, { children: e.title }) : void 0,
        c && /* @__PURE__ */ A.jsx(oB, { children: c }),
        /* @__PURE__ */ A.jsxs(
          pp,
          {
            domainPadding: { x: [50, 50] },
            horizontal: e.orientation === "horizontal",
            ...m,
            children: [
              /* @__PURE__ */ A.jsx(Ak, { children: s && s.map((w, C) => /* @__PURE__ */ A.jsx(
                ZR,
                {
                  categories: e.categories ? { x: e.categories } : void 0,
                  data: w.dataset.map((x, T) => ({
                    x: x.label,
                    y: x.value,
                    fill: x.fill,
                    stroke: x.stroke
                  })),
                  labels: w.dataset.map((x) => x.annotation ?? ""),
                  labelComponent: u.tooltips ? /* @__PURE__ */ A.jsx(bg, {}) : void 0,
                  barWidth: u.barWidth ?? 25,
                  barRatio: e.categories ? void 0 : 0.7,
                  style: {
                    data: {
                      fill: ({ datum: x }) => {
                        var T, E;
                        return x.fill ?? ((E = (T = p.bar) == null ? void 0 : T.colorScale) == null ? void 0 : E[C]);
                      },
                      stroke: ({ datum: x }) => x.stroke,
                      strokeWidth: ({ datum: x }) => x.stroke ? 2 : 0
                    }
                  }
                },
                C
              )) }),
              /* @__PURE__ */ A.jsx(
                ms,
                {
                  label: e.xLabel,
                  tickFormat: d == null ? void 0 : d.tickFormat,
                  tickValues: d == null ? void 0 : d.tickValues
                }
              ),
              /* @__PURE__ */ A.jsx(
                ms,
                {
                  dependentAxis: !0,
                  label: e.yLabel,
                  axisLabelComponent: /* @__PURE__ */ A.jsx(uI, {}),
                  tickFormat: f == null ? void 0 : f.tickFormat,
                  tickValues: f == null ? void 0 : f.tickValues
                }
              ),
              e.legendOptions && /* @__PURE__ */ A.jsx(Qw, { ...y })
            ]
          }
        )
      ] });
  }
};
function rot(e, t) {
  if (!(e === void 0 || t === void 0) && typeof e != "string")
    return (e == null ? void 0 : e.x) * t;
}
function iot(e, t) {
  if (!(e === void 0 || t === void 0) && typeof e != "string")
    return (e == null ? void 0 : e.y) * t;
}
const iB = ce.div`
  display: flex;
  justify-content: center;
`, oB = ce.div`
  display: flex;
  flex-direction: column;
`, oot = (e) => /* @__PURE__ */ A.jsx(not, { ...e }), aot = ({
  output: e,
  currentAnswer: t,
  answers: n,
  aggregateAnswers: r
}) => {
  const i = Ny(e.value, { currentAnswer: t, answers: n, aggregateAnswers: r });
  return /* @__PURE__ */ A.jsxs(of, { style: e.style, children: [
    /* @__PURE__ */ A.jsx("div", { children: e.header }),
    /* @__PURE__ */ A.jsx(sot, { children: i }),
    /* @__PURE__ */ A.jsx("div", { children: e.text })
  ] });
}, sot = ce.div`
  font-size: 5rem;
`, cot = ({
  output: e,
  currentAnswer: t,
  answers: n,
  aggregateAnswers: r
}) => {
  const i = Ny(e.content, { currentAnswer: t, answers: n, aggregateAnswers: r });
  return /* @__PURE__ */ A.jsx(of, { style: e.style, children: i });
}, lot = ({
  output: e,
  currentAnswer: t,
  answers: n,
  settings: r,
  aggregateAnswers: i
}) => {
  var g, m, v;
  const o = Ny(e.data, { currentAnswer: t, answers: n, aggregateAnswers: i }), a = o == null ? void 0 : o.map((y) => y.label), s = [];
  o == null || o.forEach((y) => {
    er.isUndefined(y.scatter) || s.push(...y.scatter);
  });
  const c = Qn(e.legendOptions, { currentAnswer: t, answers: n, aggregateAnswers: i }) ?? {}, l = Qn(e.chartOptions, { currentAnswer: t, answers: n, aggregateAnswers: i }) ?? {}, u = Rk(r, { colours: l.colours }), d = {
    theme: u,
    containerComponent: /* @__PURE__ */ A.jsx(jo, { style: { touchAction: "auto" } }),
    ...l
  }, f = {
    theme: u,
    orientation: c.orientation,
    x: dot(c.position, d.width || ((g = u.chart) == null ? void 0 : g.width)),
    y: fot(c.position, d.height || ((m = u.chart) == null ? void 0 : m.height)),
    data: ((v = Qn(c.labels, {
      currentAnswer: t,
      answers: n,
      aggregateAnswers: i
    })) == null ? void 0 : v.map((y) => ({ name: y.text }))) ?? (a == null ? void 0 : a.map((y) => ({ name: y })))
  }, h = {
    label: e.xLabel,
    ...Qn(e.xAxisOptions, { currentAnswer: t, answers: n, aggregateAnswers: i })
  }, p = Qn(e.yAxisOptions, {
    currentAnswer: t,
    answers: n,
    aggregateAnswers: i
  });
  return /* @__PURE__ */ A.jsxs(of, { style: { alignItems: "center" }, children: [
    e.title ? /* @__PURE__ */ A.jsx(uot, { children: e.title }) : void 0,
    /* @__PURE__ */ A.jsx("div", { children: /* @__PURE__ */ A.jsxs(pp, { ...d, children: [
      o && o.map((y, _) => {
        var b, w;
        return /* @__PURE__ */ A.jsx(
          cit,
          {
            data: y.dataset,
            interpolation: y.interpolation,
            style: {
              data: {
                stroke: (b = u.line) != null && b.colorScale ? (w = u.line) == null ? void 0 : w.colorScale[_] : void 0
              }
            }
          },
          _
        );
      }),
      /* @__PURE__ */ A.jsx(uoe, { data: s }),
      o && o.length > 1 && /* @__PURE__ */ A.jsx(Qw, { centerTitle: !0, theme: u, ...f }),
      /* @__PURE__ */ A.jsx(ms, { ...h }),
      /* @__PURE__ */ A.jsx(
        ms,
        {
          dependentAxis: !0,
          label: e.yLabel,
          axisLabelComponent: /* @__PURE__ */ A.jsx(Ki, { dy: -((p == null ? void 0 : p.shiftLabel) ?? 0) }),
          domain: (p == null ? void 0 : p.min) !== void 0 || (p == null ? void 0 : p.max) !== void 0 ? [p.min ?? 0, p.max ?? 1] : void 0
        }
      )
    ] }) })
  ] });
}, uot = ce.div`
  display: flex;
  justify-content: center;
`;
function dot(e, t) {
  if (!(e === void 0 || t === void 0) && typeof e != "string")
    return (e == null ? void 0 : e.x) * t;
}
function fot(e, t) {
  if (!(e === void 0 || t === void 0) && typeof e != "string")
    return (e == null ? void 0 : e.y) * t;
}
const hot = (e) => /* @__PURE__ */ A.jsx(lot, { ...e }), got = ({
  output: e,
  currentAnswer: t,
  answers: n,
  settings: r,
  aggregateAnswers: i
}) => {
  var y, _;
  const { loggingService: o } = gt(mn), a = Ny(e.data, { currentAnswer: t, answers: n, aggregateAnswers: i }), s = Qn(e.legendOptions, { currentAnswer: t, answers: n, aggregateAnswers: i }) ?? {}, c = Qn(e.chartOptions, { currentAnswer: t, answers: n, aggregateAnswers: i }) ?? {}, l = Rk(r, { colours: c.colours });
  o.debug("data", a);
  const u = {
    theme: l,
    containerComponent: /* @__PURE__ */ A.jsx(jo, { style: { touchAction: "auto" } }),
    ...c
  }, d = Qn(s.labels, {
    currentAnswer: t,
    answers: n,
    aggregateAnswers: i
  }), f = d ? d.map((b) => ({ name: b.text })) : a == null ? void 0 : a.map(({ label: b }) => ({ name: b })), h = (d == null ? void 0 : d.filter((b) => b.icon !== void 0)) ?? [], p = h.length > 0;
  class g extends j.Component {
    render() {
      const w = this.props, { x: C, y: x } = w, T = w.index, E = h[T].icon;
      if (C === void 0 || x === void 0 || E === void 0) {
        o.error("Error: x or y or icon is undefined. It was not passed to CustomComponent");
        return;
      }
      const R = E.component, I = E.size, O = C - I / 2, P = x - I / 2;
      return /* @__PURE__ */ A.jsx(R, { x: O, y: P, width: I, height: I });
    }
  }
  const m = {
    theme: l,
    orientation: s.orientation,
    x: pot(s.position, c.width || ((y = l.chart) == null ? void 0 : y.width)),
    y: mot(s.position, c.height || ((_ = l.chart) == null ? void 0 : _.height)),
    data: f,
    height: s.height,
    width: s.width,
    dataComponent: p ? /* @__PURE__ */ A.jsx(g, {}) : void 0
  }, v = e.showTooltips ? /* @__PURE__ */ A.jsx(bg, { active: e.tooltipsOpen }) : void 0;
  return /* @__PURE__ */ A.jsxs(of, { style: { ...e.style, alignItems: "center" }, children: [
    e.title && /* @__PURE__ */ A.jsx(vot, { children: e.title }),
    /* @__PURE__ */ A.jsx(yot, { children: a && /* @__PURE__ */ A.jsxs(pp, { ...u, children: [
      /* @__PURE__ */ A.jsx(ms, { style: { axis: { visibility: "hidden" } }, tickFormat: () => "" }),
      /* @__PURE__ */ A.jsx(
        ms,
        {
          dependentAxis: !0,
          style: { axis: { visibility: "hidden" } },
          tickFormat: () => ""
        }
      ),
      /* @__PURE__ */ A.jsx(
        loe,
        {
          data: a.map((b, w) => ({
            x: b.label,
            y: b.value
          })),
          labels: ({ datum: b }) => e.labels ? e.labels({ label: b.x, value: b.y }) : b.x,
          labelComponent: v
        }
      ),
      /* @__PURE__ */ A.jsx(Qw, { ...m })
    ] }) })
  ] });
};
function pot(e, t) {
  if (!(e === void 0 || t === void 0) && typeof e != "string")
    return (e == null ? void 0 : e.x) * t;
}
function mot(e, t) {
  if (!(e === void 0 || t === void 0) && typeof e != "string")
    return (e == null ? void 0 : e.y) * t;
}
const vot = ce.div`
  display: flex;
  justify-content: center;
`, yot = ce.div`
  /* display: flex;
  flex: 1 1 100%; */
`, bot = (e) => /* @__PURE__ */ A.jsx(got, { ...e });
var iP = { exports: {} };
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var dI, aB;
function _ot() {
  if (aB)
    return dI;
  aB = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(o) {
    if (o == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(o);
  }
  function i() {
    try {
      if (!Object.assign)
        return !1;
      var o = new String("abc");
      if (o[5] = "de", Object.getOwnPropertyNames(o)[0] === "5")
        return !1;
      for (var a = {}, s = 0; s < 10; s++)
        a["_" + String.fromCharCode(s)] = s;
      var c = Object.getOwnPropertyNames(a).map(function(u) {
        return a[u];
      });
      if (c.join("") !== "0123456789")
        return !1;
      var l = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(u) {
        l[u] = u;
      }), Object.keys(Object.assign({}, l)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return dI = i() ? Object.assign : function(o, a) {
    for (var s, c = r(o), l, u = 1; u < arguments.length; u++) {
      s = Object(arguments[u]);
      for (var d in s)
        t.call(s, d) && (c[d] = s[d]);
      if (e) {
        l = e(s);
        for (var f = 0; f < l.length; f++)
          n.call(s, l[f]) && (c[l[f]] = s[l[f]]);
      }
    }
    return c;
  }, dI;
}
var fI, sB;
function Pk() {
  if (sB)
    return fI;
  sB = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return fI = e, fI;
}
var hI, cB;
function goe() {
  return cB || (cB = 1, hI = Function.call.bind(Object.prototype.hasOwnProperty)), hI;
}
var gI, lB;
function Sot() {
  if (lB)
    return gI;
  lB = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = Pk(), n = {}, r = goe();
    e = function(o) {
      var a = "Warning: " + o;
      typeof console < "u" && console.error(a);
      try {
        throw new Error(a);
      } catch {
      }
    };
  }
  function i(o, a, s, c, l) {
    if (process.env.NODE_ENV !== "production") {
      for (var u in o)
        if (r(o, u)) {
          var d;
          try {
            if (typeof o[u] != "function") {
              var f = Error(
                (c || "React class") + ": " + s + " type `" + u + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof o[u] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw f.name = "Invariant Violation", f;
            }
            d = o[u](a, u, c, s, null, t);
          } catch (p) {
            d = p;
          }
          if (d && !(d instanceof Error) && e(
            (c || "React class") + ": type specification of " + s + " `" + u + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof d + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), d instanceof Error && !(d.message in n)) {
            n[d.message] = !0;
            var h = l ? l() : "";
            e(
              "Failed " + s + " type: " + d.message + (h ?? "")
            );
          }
        }
    }
  }
  return i.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, gI = i, gI;
}
var pI, uB;
function wot() {
  if (uB)
    return pI;
  uB = 1;
  var e = oO, t = _ot(), n = Pk(), r = goe(), i = Sot(), o = function() {
  };
  process.env.NODE_ENV !== "production" && (o = function(s) {
    var c = "Warning: " + s;
    typeof console < "u" && console.error(c);
    try {
      throw new Error(c);
    } catch {
    }
  });
  function a() {
    return null;
  }
  return pI = function(s, c) {
    var l = typeof Symbol == "function" && Symbol.iterator, u = "@@iterator";
    function d(B) {
      var U = B && (l && B[l] || B[u]);
      if (typeof U == "function")
        return U;
    }
    var f = "<<anonymous>>", h = {
      array: v("array"),
      bigint: v("bigint"),
      bool: v("boolean"),
      func: v("function"),
      number: v("number"),
      object: v("object"),
      string: v("string"),
      symbol: v("symbol"),
      any: y(),
      arrayOf: _,
      element: b(),
      elementType: w(),
      instanceOf: C,
      node: R(),
      objectOf: T,
      oneOf: x,
      oneOfType: E,
      shape: O,
      exact: P
    };
    function p(B, U) {
      return B === U ? B !== 0 || 1 / B === 1 / U : B !== B && U !== U;
    }
    function g(B, U) {
      this.message = B, this.data = U && typeof U == "object" ? U : {}, this.stack = "";
    }
    g.prototype = Error.prototype;
    function m(B) {
      if (process.env.NODE_ENV !== "production")
        var U = {}, Q = 0;
      function Y(X, ne, Z, J, K, ee, te) {
        if (J = J || f, ee = ee || Z, te !== n) {
          if (c) {
            var H = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw H.name = "Invariant Violation", H;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var ie = J + ":" + Z;
            !U[ie] && // Avoid spamming the console because they are often not actionable except for lib authors
            Q < 3 && (o(
              "You are manually calling a React.PropTypes validation function for the `" + ee + "` prop on `" + J + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), U[ie] = !0, Q++);
          }
        }
        return ne[Z] == null ? X ? ne[Z] === null ? new g("The " + K + " `" + ee + "` is marked as required " + ("in `" + J + "`, but its value is `null`.")) : new g("The " + K + " `" + ee + "` is marked as required in " + ("`" + J + "`, but its value is `undefined`.")) : null : B(ne, Z, J, K, ee);
      }
      var q = Y.bind(null, !1);
      return q.isRequired = Y.bind(null, !0), q;
    }
    function v(B) {
      function U(Q, Y, q, X, ne, Z) {
        var J = Q[Y], K = N(J);
        if (K !== B) {
          var ee = D(J);
          return new g(
            "Invalid " + X + " `" + ne + "` of type " + ("`" + ee + "` supplied to `" + q + "`, expected ") + ("`" + B + "`."),
            { expectedType: B }
          );
        }
        return null;
      }
      return m(U);
    }
    function y() {
      return m(a);
    }
    function _(B) {
      function U(Q, Y, q, X, ne) {
        if (typeof B != "function")
          return new g("Property `" + ne + "` of component `" + q + "` has invalid PropType notation inside arrayOf.");
        var Z = Q[Y];
        if (!Array.isArray(Z)) {
          var J = N(Z);
          return new g("Invalid " + X + " `" + ne + "` of type " + ("`" + J + "` supplied to `" + q + "`, expected an array."));
        }
        for (var K = 0; K < Z.length; K++) {
          var ee = B(Z, K, q, X, ne + "[" + K + "]", n);
          if (ee instanceof Error)
            return ee;
        }
        return null;
      }
      return m(U);
    }
    function b() {
      function B(U, Q, Y, q, X) {
        var ne = U[Q];
        if (!s(ne)) {
          var Z = N(ne);
          return new g("Invalid " + q + " `" + X + "` of type " + ("`" + Z + "` supplied to `" + Y + "`, expected a single ReactElement."));
        }
        return null;
      }
      return m(B);
    }
    function w() {
      function B(U, Q, Y, q, X) {
        var ne = U[Q];
        if (!e.isValidElementType(ne)) {
          var Z = N(ne);
          return new g("Invalid " + q + " `" + X + "` of type " + ("`" + Z + "` supplied to `" + Y + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return m(B);
    }
    function C(B) {
      function U(Q, Y, q, X, ne) {
        if (!(Q[Y] instanceof B)) {
          var Z = B.name || f, J = V(Q[Y]);
          return new g("Invalid " + X + " `" + ne + "` of type " + ("`" + J + "` supplied to `" + q + "`, expected ") + ("instance of `" + Z + "`."));
        }
        return null;
      }
      return m(U);
    }
    function x(B) {
      if (!Array.isArray(B))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? o(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : o("Invalid argument supplied to oneOf, expected an array.")), a;
      function U(Q, Y, q, X, ne) {
        for (var Z = Q[Y], J = 0; J < B.length; J++)
          if (p(Z, B[J]))
            return null;
        var K = JSON.stringify(B, function(te, H) {
          var ie = D(H);
          return ie === "symbol" ? String(H) : H;
        });
        return new g("Invalid " + X + " `" + ne + "` of value `" + String(Z) + "` " + ("supplied to `" + q + "`, expected one of " + K + "."));
      }
      return m(U);
    }
    function T(B) {
      function U(Q, Y, q, X, ne) {
        if (typeof B != "function")
          return new g("Property `" + ne + "` of component `" + q + "` has invalid PropType notation inside objectOf.");
        var Z = Q[Y], J = N(Z);
        if (J !== "object")
          return new g("Invalid " + X + " `" + ne + "` of type " + ("`" + J + "` supplied to `" + q + "`, expected an object."));
        for (var K in Z)
          if (r(Z, K)) {
            var ee = B(Z, K, q, X, ne + "." + K, n);
            if (ee instanceof Error)
              return ee;
          }
        return null;
      }
      return m(U);
    }
    function E(B) {
      if (!Array.isArray(B))
        return process.env.NODE_ENV !== "production" && o("Invalid argument supplied to oneOfType, expected an instance of array."), a;
      for (var U = 0; U < B.length; U++) {
        var Q = B[U];
        if (typeof Q != "function")
          return o(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + z(Q) + " at index " + U + "."
          ), a;
      }
      function Y(q, X, ne, Z, J) {
        for (var K = [], ee = 0; ee < B.length; ee++) {
          var te = B[ee], H = te(q, X, ne, Z, J, n);
          if (H == null)
            return null;
          H.data && r(H.data, "expectedType") && K.push(H.data.expectedType);
        }
        var ie = K.length > 0 ? ", expected one of type [" + K.join(", ") + "]" : "";
        return new g("Invalid " + Z + " `" + J + "` supplied to " + ("`" + ne + "`" + ie + "."));
      }
      return m(Y);
    }
    function R() {
      function B(U, Q, Y, q, X) {
        return k(U[Q]) ? null : new g("Invalid " + q + " `" + X + "` supplied to " + ("`" + Y + "`, expected a ReactNode."));
      }
      return m(B);
    }
    function I(B, U, Q, Y, q) {
      return new g(
        (B || "React class") + ": " + U + " type `" + Q + "." + Y + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + q + "`."
      );
    }
    function O(B) {
      function U(Q, Y, q, X, ne) {
        var Z = Q[Y], J = N(Z);
        if (J !== "object")
          return new g("Invalid " + X + " `" + ne + "` of type `" + J + "` " + ("supplied to `" + q + "`, expected `object`."));
        for (var K in B) {
          var ee = B[K];
          if (typeof ee != "function")
            return I(q, X, ne, K, D(ee));
          var te = ee(Z, K, q, X, ne + "." + K, n);
          if (te)
            return te;
        }
        return null;
      }
      return m(U);
    }
    function P(B) {
      function U(Q, Y, q, X, ne) {
        var Z = Q[Y], J = N(Z);
        if (J !== "object")
          return new g("Invalid " + X + " `" + ne + "` of type `" + J + "` " + ("supplied to `" + q + "`, expected `object`."));
        var K = t({}, Q[Y], B);
        for (var ee in K) {
          var te = B[ee];
          if (r(B, ee) && typeof te != "function")
            return I(q, X, ne, ee, D(te));
          if (!te)
            return new g(
              "Invalid " + X + " `" + ne + "` key `" + ee + "` supplied to `" + q + "`.\nBad object: " + JSON.stringify(Q[Y], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(B), null, "  ")
            );
          var H = te(Z, ee, q, X, ne + "." + ee, n);
          if (H)
            return H;
        }
        return null;
      }
      return m(U);
    }
    function k(B) {
      switch (typeof B) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !B;
        case "object":
          if (Array.isArray(B))
            return B.every(k);
          if (B === null || s(B))
            return !0;
          var U = d(B);
          if (U) {
            var Q = U.call(B), Y;
            if (U !== B.entries) {
              for (; !(Y = Q.next()).done; )
                if (!k(Y.value))
                  return !1;
            } else
              for (; !(Y = Q.next()).done; ) {
                var q = Y.value;
                if (q && !k(q[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function L(B, U) {
      return B === "symbol" ? !0 : U ? U["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && U instanceof Symbol : !1;
    }
    function N(B) {
      var U = typeof B;
      return Array.isArray(B) ? "array" : B instanceof RegExp ? "object" : L(U, B) ? "symbol" : U;
    }
    function D(B) {
      if (typeof B > "u" || B === null)
        return "" + B;
      var U = N(B);
      if (U === "object") {
        if (B instanceof Date)
          return "date";
        if (B instanceof RegExp)
          return "regexp";
      }
      return U;
    }
    function z(B) {
      var U = D(B);
      switch (U) {
        case "array":
        case "object":
          return "an " + U;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + U;
        default:
          return U;
      }
    }
    function V(B) {
      return !B.constructor || !B.constructor.name ? f : B.constructor.name;
    }
    return h.checkPropTypes = i, h.resetWarningCache = i.resetWarningCache, h.PropTypes = h, h;
  }, pI;
}
var mI, dB;
function xot() {
  if (dB)
    return mI;
  dB = 1;
  var e = Pk();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, mI = function() {
    function r(a, s, c, l, u, d) {
      if (d !== e) {
        var f = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw f.name = "Invariant Violation", f;
      }
    }
    r.isRequired = r;
    function i() {
      return r;
    }
    var o = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: i,
      element: r,
      elementType: r,
      instanceOf: i,
      node: r,
      objectOf: i,
      oneOf: i,
      oneOfType: i,
      shape: i,
      exact: i,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return o.PropTypes = o, o;
  }, mI;
}
if (process.env.NODE_ENV !== "production") {
  var Eot = oO, Cot = !0;
  iP.exports = wot()(Eot.isElement, Cot);
} else
  iP.exports = xot()();
var Tot = iP.exports;
const ye = /* @__PURE__ */ vn(Tot);
var Ok = nb(), an = (e) => tb(e, Ok), Mk = nb();
an.write = (e) => tb(e, Mk);
var jC = nb();
an.onStart = (e) => tb(e, jC);
var kk = nb();
an.onFrame = (e) => tb(e, kk);
var Nk = nb();
an.onFinish = (e) => tb(e, Nk);
var Sg = [];
an.setTimeout = (e, t) => {
  const n = an.now() + t, r = () => {
    const o = Sg.findIndex((a) => a.cancel == r);
    ~o && Sg.splice(o, 1), su -= ~o ? 1 : 0;
  }, i = { time: n, handler: e, cancel: r };
  return Sg.splice(poe(n), 0, i), su += 1, moe(), i;
};
var poe = (e) => ~(~Sg.findIndex((t) => t.time > e) || ~Sg.length);
an.cancel = (e) => {
  jC.delete(e), kk.delete(e), Nk.delete(e), Ok.delete(e), Mk.delete(e);
};
an.sync = (e) => {
  oP = !0, an.batchedUpdates(e), oP = !1;
};
an.throttle = (e) => {
  let t;
  function n() {
    try {
      e(...t);
    } finally {
      t = null;
    }
  }
  function r(...i) {
    t = i, an.onStart(n);
  }
  return r.handler = e, r.cancel = () => {
    jC.delete(n), t = null;
  }, r;
};
var Dk = typeof window < "u" ? window.requestAnimationFrame : (
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  () => {
  }
);
an.use = (e) => Dk = e;
an.now = typeof performance < "u" ? () => performance.now() : Date.now;
an.batchedUpdates = (e) => e();
an.catch = console.error;
an.frameLoop = "always";
an.advance = () => {
  an.frameLoop !== "demand" ? console.warn(
    "Cannot call the manual advancement of rafz whilst frameLoop is not set as demand"
  ) : yoe();
};
var au = -1, su = 0, oP = !1;
function tb(e, t) {
  oP ? (t.delete(e), e(0)) : (t.add(e), moe());
}
function moe() {
  au < 0 && (au = 0, an.frameLoop !== "demand" && Dk(voe));
}
function Iot() {
  au = -1;
}
function voe() {
  ~au && (Dk(voe), an.batchedUpdates(yoe));
}
function yoe() {
  const e = au;
  au = an.now();
  const t = poe(au);
  if (t && (boe(Sg.splice(0, t), (n) => n.handler()), su -= t), !su) {
    Iot();
    return;
  }
  jC.flush(), Ok.flush(e ? Math.min(64, au - e) : 16.667), kk.flush(), Mk.flush(), Nk.flush();
}
function nb() {
  let e = /* @__PURE__ */ new Set(), t = e;
  return {
    add(n) {
      su += t == e && !e.has(n) ? 1 : 0, e.add(n);
    },
    delete(n) {
      return su -= t == e && e.has(n) ? 1 : 0, e.delete(n);
    },
    flush(n) {
      t.size && (e = /* @__PURE__ */ new Set(), su -= t.size, boe(t, (r) => r(n) && e.add(r)), su += e.size, t = e);
    }
  };
}
function boe(e, t) {
  e.forEach((n) => {
    try {
      t(n);
    } catch (r) {
      an.catch(r);
    }
  });
}
var $ot = Object.defineProperty, Aot = (e, t) => {
  for (var n in t)
    $ot(e, n, { get: t[n], enumerable: !0 });
}, Os = {};
Aot(Os, {
  assign: () => Pot,
  colors: () => _u,
  createStringInterpolator: () => Lk,
  skipAnimation: () => Soe,
  to: () => _oe,
  willAdvance: () => Fk
});
function aP() {
}
var Rot = (e, t, n) => Object.defineProperty(e, t, { value: n, writable: !0, configurable: !0 }), He = {
  arr: Array.isArray,
  obj: (e) => !!e && e.constructor.name === "Object",
  fun: (e) => typeof e == "function",
  str: (e) => typeof e == "string",
  num: (e) => typeof e == "number",
  und: (e) => e === void 0
};
function Gc(e, t) {
  if (He.arr(e)) {
    if (!He.arr(t) || e.length !== t.length)
      return !1;
    for (let n = 0; n < e.length; n++)
      if (e[n] !== t[n])
        return !1;
    return !0;
  }
  return e === t;
}
var Yt = (e, t) => e.forEach(t);
function Ec(e, t, n) {
  if (He.arr(e)) {
    for (let r = 0; r < e.length; r++)
      t.call(n, e[r], `${r}`);
    return;
  }
  for (const r in e)
    e.hasOwnProperty(r) && t.call(n, e[r], r);
}
var Mo = (e) => He.und(e) ? [] : He.arr(e) ? e : [e];
function q0(e, t) {
  if (e.size) {
    const n = Array.from(e);
    e.clear(), Yt(n, t);
  }
}
var v0 = (e, ...t) => q0(e, (n) => n(...t)), jk = () => typeof window > "u" || !window.navigator || /ServerSideRendering|^Deno\//.test(window.navigator.userAgent), Lk, _oe, _u = null, Soe = !1, Fk = aP, Pot = (e) => {
  e.to && (_oe = e.to), e.now && (an.now = e.now), e.colors !== void 0 && (_u = e.colors), e.skipAnimation != null && (Soe = e.skipAnimation), e.createStringInterpolator && (Lk = e.createStringInterpolator), e.requestAnimationFrame && an.use(e.requestAnimationFrame), e.batchedUpdates && (an.batchedUpdates = e.batchedUpdates), e.willAdvance && (Fk = e.willAdvance), e.frameLoop && (an.frameLoop = e.frameLoop);
}, G0 = /* @__PURE__ */ new Set(), Ba = [], vI = [], Jw = 0, LC = {
  get idle() {
    return !G0.size && !Ba.length;
  },
  /** Advance the given animation on every frame until idle. */
  start(e) {
    Jw > e.priority ? (G0.add(e), an.onStart(Oot)) : (woe(e), an(sP));
  },
  /** Advance all animations by the given time. */
  advance: sP,
  /** Call this when an animation's priority changes. */
  sort(e) {
    if (Jw)
      an.onFrame(() => LC.sort(e));
    else {
      const t = Ba.indexOf(e);
      ~t && (Ba.splice(t, 1), xoe(e));
    }
  },
  /**
   * Clear all animations. For testing purposes.
   *
   * ☠️ Never call this from within the frameloop.
   */
  clear() {
    Ba = [], G0.clear();
  }
};
function Oot() {
  G0.forEach(woe), G0.clear(), an(sP);
}
function woe(e) {
  Ba.includes(e) || xoe(e);
}
function xoe(e) {
  Ba.splice(
    Mot(Ba, (t) => t.priority > e.priority),
    0,
    e
  );
}
function sP(e) {
  const t = vI;
  for (let n = 0; n < Ba.length; n++) {
    const r = Ba[n];
    Jw = r.priority, r.idle || (Fk(r), r.advance(e), r.idle || t.push(r));
  }
  return Jw = 0, vI = Ba, vI.length = 0, Ba = t, Ba.length > 0;
}
function Mot(e, t) {
  const n = e.findIndex(t);
  return n < 0 ? e.length : n;
}
var kot = (e, t, n) => Math.min(Math.max(n, e), t), Not = {
  transparent: 0,
  aliceblue: 4042850303,
  antiquewhite: 4209760255,
  aqua: 16777215,
  aquamarine: 2147472639,
  azure: 4043309055,
  beige: 4126530815,
  bisque: 4293182719,
  black: 255,
  blanchedalmond: 4293643775,
  blue: 65535,
  blueviolet: 2318131967,
  brown: 2771004159,
  burlywood: 3736635391,
  burntsienna: 3934150143,
  cadetblue: 1604231423,
  chartreuse: 2147418367,
  chocolate: 3530104575,
  coral: 4286533887,
  cornflowerblue: 1687547391,
  cornsilk: 4294499583,
  crimson: 3692313855,
  cyan: 16777215,
  darkblue: 35839,
  darkcyan: 9145343,
  darkgoldenrod: 3095792639,
  darkgray: 2846468607,
  darkgreen: 6553855,
  darkgrey: 2846468607,
  darkkhaki: 3182914559,
  darkmagenta: 2332068863,
  darkolivegreen: 1433087999,
  darkorange: 4287365375,
  darkorchid: 2570243327,
  darkred: 2332033279,
  darksalmon: 3918953215,
  darkseagreen: 2411499519,
  darkslateblue: 1211993087,
  darkslategray: 793726975,
  darkslategrey: 793726975,
  darkturquoise: 13554175,
  darkviolet: 2483082239,
  deeppink: 4279538687,
  deepskyblue: 12582911,
  dimgray: 1768516095,
  dimgrey: 1768516095,
  dodgerblue: 512819199,
  firebrick: 2988581631,
  floralwhite: 4294635775,
  forestgreen: 579543807,
  fuchsia: 4278255615,
  gainsboro: 3705462015,
  ghostwhite: 4177068031,
  gold: 4292280575,
  goldenrod: 3668254975,
  gray: 2155905279,
  green: 8388863,
  greenyellow: 2919182335,
  grey: 2155905279,
  honeydew: 4043305215,
  hotpink: 4285117695,
  indianred: 3445382399,
  indigo: 1258324735,
  ivory: 4294963455,
  khaki: 4041641215,
  lavender: 3873897215,
  lavenderblush: 4293981695,
  lawngreen: 2096890111,
  lemonchiffon: 4294626815,
  lightblue: 2916673279,
  lightcoral: 4034953471,
  lightcyan: 3774873599,
  lightgoldenrodyellow: 4210742015,
  lightgray: 3553874943,
  lightgreen: 2431553791,
  lightgrey: 3553874943,
  lightpink: 4290167295,
  lightsalmon: 4288707327,
  lightseagreen: 548580095,
  lightskyblue: 2278488831,
  lightslategray: 2005441023,
  lightslategrey: 2005441023,
  lightsteelblue: 2965692159,
  lightyellow: 4294959359,
  lime: 16711935,
  limegreen: 852308735,
  linen: 4210091775,
  magenta: 4278255615,
  maroon: 2147483903,
  mediumaquamarine: 1724754687,
  mediumblue: 52735,
  mediumorchid: 3126187007,
  mediumpurple: 2473647103,
  mediumseagreen: 1018393087,
  mediumslateblue: 2070474495,
  mediumspringgreen: 16423679,
  mediumturquoise: 1221709055,
  mediumvioletred: 3340076543,
  midnightblue: 421097727,
  mintcream: 4127193855,
  mistyrose: 4293190143,
  moccasin: 4293178879,
  navajowhite: 4292783615,
  navy: 33023,
  oldlace: 4260751103,
  olive: 2155872511,
  olivedrab: 1804477439,
  orange: 4289003775,
  orangered: 4282712319,
  orchid: 3664828159,
  palegoldenrod: 4008225535,
  palegreen: 2566625535,
  paleturquoise: 2951671551,
  palevioletred: 3681588223,
  papayawhip: 4293907967,
  peachpuff: 4292524543,
  peru: 3448061951,
  pink: 4290825215,
  plum: 3718307327,
  powderblue: 2967529215,
  purple: 2147516671,
  rebeccapurple: 1714657791,
  red: 4278190335,
  rosybrown: 3163525119,
  royalblue: 1097458175,
  saddlebrown: 2336560127,
  salmon: 4202722047,
  sandybrown: 4104413439,
  seagreen: 780883967,
  seashell: 4294307583,
  sienna: 2689740287,
  silver: 3233857791,
  skyblue: 2278484991,
  slateblue: 1784335871,
  slategray: 1887473919,
  slategrey: 1887473919,
  snow: 4294638335,
  springgreen: 16744447,
  steelblue: 1182971135,
  tan: 3535047935,
  teal: 8421631,
  thistle: 3636451583,
  tomato: 4284696575,
  turquoise: 1088475391,
  violet: 4001558271,
  wheat: 4125012991,
  white: 4294967295,
  whitesmoke: 4126537215,
  yellow: 4294902015,
  yellowgreen: 2597139199
}, vs = "[-+]?\\d*\\.?\\d+", Zw = vs + "%";
function FC(...e) {
  return "\\(\\s*(" + e.join(")\\s*,\\s*(") + ")\\s*\\)";
}
var Dot = new RegExp("rgb" + FC(vs, vs, vs)), jot = new RegExp("rgba" + FC(vs, vs, vs, vs)), Lot = new RegExp("hsl" + FC(vs, Zw, Zw)), Fot = new RegExp(
  "hsla" + FC(vs, Zw, Zw, vs)
), Vot = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/, Bot = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/, zot = /^#([0-9a-fA-F]{6})$/, Hot = /^#([0-9a-fA-F]{8})$/;
function Uot(e) {
  let t;
  return typeof e == "number" ? e >>> 0 === e && e >= 0 && e <= 4294967295 ? e : null : (t = zot.exec(e)) ? parseInt(t[1] + "ff", 16) >>> 0 : _u && _u[e] !== void 0 ? _u[e] : (t = Dot.exec(e)) ? (Ih(t[1]) << 24 | // r
  Ih(t[2]) << 16 | // g
  Ih(t[3]) << 8 | // b
  255) >>> // a
  0 : (t = jot.exec(e)) ? (Ih(t[1]) << 24 | // r
  Ih(t[2]) << 16 | // g
  Ih(t[3]) << 8 | // b
  gB(t[4])) >>> // a
  0 : (t = Vot.exec(e)) ? parseInt(
    t[1] + t[1] + // r
    t[2] + t[2] + // g
    t[3] + t[3] + // b
    "ff",
    // a
    16
  ) >>> 0 : (t = Hot.exec(e)) ? parseInt(t[1], 16) >>> 0 : (t = Bot.exec(e)) ? parseInt(
    t[1] + t[1] + // r
    t[2] + t[2] + // g
    t[3] + t[3] + // b
    t[4] + t[4],
    // a
    16
  ) >>> 0 : (t = Lot.exec(e)) ? (fB(
    hB(t[1]),
    // h
    A1(t[2]),
    // s
    A1(t[3])
    // l
  ) | 255) >>> // a
  0 : (t = Fot.exec(e)) ? (fB(
    hB(t[1]),
    // h
    A1(t[2]),
    // s
    A1(t[3])
    // l
  ) | gB(t[4])) >>> // a
  0 : null;
}
function yI(e, t, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? e + (t - e) * 6 * n : n < 1 / 2 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e;
}
function fB(e, t, n) {
  const r = n < 0.5 ? n * (1 + t) : n + t - n * t, i = 2 * n - r, o = yI(i, r, e + 1 / 3), a = yI(i, r, e), s = yI(i, r, e - 1 / 3);
  return Math.round(o * 255) << 24 | Math.round(a * 255) << 16 | Math.round(s * 255) << 8;
}
function Ih(e) {
  const t = parseInt(e, 10);
  return t < 0 ? 0 : t > 255 ? 255 : t;
}
function hB(e) {
  return (parseFloat(e) % 360 + 360) % 360 / 360;
}
function gB(e) {
  const t = parseFloat(e);
  return t < 0 ? 0 : t > 1 ? 255 : Math.round(t * 255);
}
function A1(e) {
  const t = parseFloat(e);
  return t < 0 ? 0 : t > 100 ? 1 : t / 100;
}
function pB(e) {
  let t = Uot(e);
  if (t === null)
    return e;
  t = t || 0;
  const n = (t & 4278190080) >>> 24, r = (t & 16711680) >>> 16, i = (t & 65280) >>> 8, o = (t & 255) / 255;
  return `rgba(${n}, ${r}, ${i}, ${o})`;
}
var qv = (e, t, n) => {
  if (He.fun(e))
    return e;
  if (He.arr(e))
    return qv({
      range: e,
      output: t,
      extrapolate: n
    });
  if (He.str(e.output[0]))
    return Lk(e);
  const r = e, i = r.output, o = r.range || [0, 1], a = r.extrapolateLeft || r.extrapolate || "extend", s = r.extrapolateRight || r.extrapolate || "extend", c = r.easing || ((l) => l);
  return (l) => {
    const u = qot(l, o);
    return Wot(
      l,
      o[u],
      o[u + 1],
      i[u],
      i[u + 1],
      c,
      a,
      s,
      r.map
    );
  };
};
function Wot(e, t, n, r, i, o, a, s, c) {
  let l = c ? c(e) : e;
  if (l < t) {
    if (a === "identity")
      return l;
    a === "clamp" && (l = t);
  }
  if (l > n) {
    if (s === "identity")
      return l;
    s === "clamp" && (l = n);
  }
  return r === i ? r : t === n ? e <= t ? r : i : (t === -1 / 0 ? l = -l : n === 1 / 0 ? l = l - t : l = (l - t) / (n - t), l = o(l), r === -1 / 0 ? l = -l : i === 1 / 0 ? l = l + r : l = l * (i - r) + r, l);
}
function qot(e, t) {
  for (var n = 1; n < t.length - 1 && !(t[n] >= e); ++n)
    ;
  return n - 1;
}
var Got = (e, t = "end") => (n) => {
  n = t === "end" ? Math.min(n, 0.999) : Math.max(n, 1e-3);
  const r = n * e, i = t === "end" ? Math.floor(r) : Math.ceil(r);
  return kot(0, 1, i / e);
}, ex = 1.70158, R1 = ex * 1.525, mB = ex + 1, vB = 2 * Math.PI / 3, yB = 2 * Math.PI / 4.5, P1 = (e) => e < 1 / 2.75 ? 7.5625 * e * e : e < 2 / 2.75 ? 7.5625 * (e -= 1.5 / 2.75) * e + 0.75 : e < 2.5 / 2.75 ? 7.5625 * (e -= 2.25 / 2.75) * e + 0.9375 : 7.5625 * (e -= 2.625 / 2.75) * e + 0.984375, Kot = {
  linear: (e) => e,
  easeInQuad: (e) => e * e,
  easeOutQuad: (e) => 1 - (1 - e) * (1 - e),
  easeInOutQuad: (e) => e < 0.5 ? 2 * e * e : 1 - Math.pow(-2 * e + 2, 2) / 2,
  easeInCubic: (e) => e * e * e,
  easeOutCubic: (e) => 1 - Math.pow(1 - e, 3),
  easeInOutCubic: (e) => e < 0.5 ? 4 * e * e * e : 1 - Math.pow(-2 * e + 2, 3) / 2,
  easeInQuart: (e) => e * e * e * e,
  easeOutQuart: (e) => 1 - Math.pow(1 - e, 4),
  easeInOutQuart: (e) => e < 0.5 ? 8 * e * e * e * e : 1 - Math.pow(-2 * e + 2, 4) / 2,
  easeInQuint: (e) => e * e * e * e * e,
  easeOutQuint: (e) => 1 - Math.pow(1 - e, 5),
  easeInOutQuint: (e) => e < 0.5 ? 16 * e * e * e * e * e : 1 - Math.pow(-2 * e + 2, 5) / 2,
  easeInSine: (e) => 1 - Math.cos(e * Math.PI / 2),
  easeOutSine: (e) => Math.sin(e * Math.PI / 2),
  easeInOutSine: (e) => -(Math.cos(Math.PI * e) - 1) / 2,
  easeInExpo: (e) => e === 0 ? 0 : Math.pow(2, 10 * e - 10),
  easeOutExpo: (e) => e === 1 ? 1 : 1 - Math.pow(2, -10 * e),
  easeInOutExpo: (e) => e === 0 ? 0 : e === 1 ? 1 : e < 0.5 ? Math.pow(2, 20 * e - 10) / 2 : (2 - Math.pow(2, -20 * e + 10)) / 2,
  easeInCirc: (e) => 1 - Math.sqrt(1 - Math.pow(e, 2)),
  easeOutCirc: (e) => Math.sqrt(1 - Math.pow(e - 1, 2)),
  easeInOutCirc: (e) => e < 0.5 ? (1 - Math.sqrt(1 - Math.pow(2 * e, 2))) / 2 : (Math.sqrt(1 - Math.pow(-2 * e + 2, 2)) + 1) / 2,
  easeInBack: (e) => mB * e * e * e - ex * e * e,
  easeOutBack: (e) => 1 + mB * Math.pow(e - 1, 3) + ex * Math.pow(e - 1, 2),
  easeInOutBack: (e) => e < 0.5 ? Math.pow(2 * e, 2) * ((R1 + 1) * 2 * e - R1) / 2 : (Math.pow(2 * e - 2, 2) * ((R1 + 1) * (e * 2 - 2) + R1) + 2) / 2,
  easeInElastic: (e) => e === 0 ? 0 : e === 1 ? 1 : -Math.pow(2, 10 * e - 10) * Math.sin((e * 10 - 10.75) * vB),
  easeOutElastic: (e) => e === 0 ? 0 : e === 1 ? 1 : Math.pow(2, -10 * e) * Math.sin((e * 10 - 0.75) * vB) + 1,
  easeInOutElastic: (e) => e === 0 ? 0 : e === 1 ? 1 : e < 0.5 ? -(Math.pow(2, 20 * e - 10) * Math.sin((20 * e - 11.125) * yB)) / 2 : Math.pow(2, -20 * e + 10) * Math.sin((20 * e - 11.125) * yB) / 2 + 1,
  easeInBounce: (e) => 1 - P1(1 - e),
  easeOutBounce: P1,
  easeInOutBounce: (e) => e < 0.5 ? (1 - P1(1 - 2 * e)) / 2 : (1 + P1(2 * e - 1)) / 2,
  steps: Got
}, Gv = Symbol.for("FluidValue.get"), mp = Symbol.for("FluidValue.observers"), La = (e) => !!(e && e[Gv]), Yo = (e) => e && e[Gv] ? e[Gv]() : e, bB = (e) => e[mp] || null;
function Yot(e, t) {
  e.eventObserved ? e.eventObserved(t) : e(t);
}
function Kv(e, t) {
  const n = e[mp];
  n && n.forEach((r) => {
    Yot(r, t);
  });
}
var Eoe = class {
  constructor(e) {
    if (!e && !(e = this.get))
      throw Error("Unknown getter");
    Xot(this, e);
  }
}, Xot = (e, t) => Coe(e, Gv, t);
function cm(e, t) {
  if (e[Gv]) {
    let n = e[mp];
    n || Coe(e, mp, n = /* @__PURE__ */ new Set()), n.has(t) || (n.add(t), e.observerAdded && e.observerAdded(n.size, t));
  }
  return t;
}
function Yv(e, t) {
  const n = e[mp];
  if (n && n.has(t)) {
    const r = n.size - 1;
    r ? n.delete(t) : e[mp] = null, e.observerRemoved && e.observerRemoved(r, t);
  }
}
var Coe = (e, t, n) => Object.defineProperty(e, t, {
  value: n,
  writable: !0,
  configurable: !0
}), S_ = /[+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, Qot = /(#(?:[0-9a-f]{2}){2,4}|(#[0-9a-f]{3})|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d\.]+%?\))/gi, _B = new RegExp(`(${S_.source})(%|[a-z]+)`, "i"), Jot = /rgba\(([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+)\)/gi, VC = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/, Toe = (e) => {
  const [t, n] = Zot(e);
  if (!t || jk())
    return e;
  const r = window.getComputedStyle(document.documentElement).getPropertyValue(t);
  if (r)
    return r.trim();
  if (n && n.startsWith("--")) {
    const i = window.getComputedStyle(document.documentElement).getPropertyValue(n);
    return i || e;
  } else {
    if (n && VC.test(n))
      return Toe(n);
    if (n)
      return n;
  }
  return e;
}, Zot = (e) => {
  const t = VC.exec(e);
  if (!t)
    return [,];
  const [, n, r] = t;
  return [n, r];
}, bI, eat = (e, t, n, r, i) => `rgba(${Math.round(t)}, ${Math.round(n)}, ${Math.round(r)}, ${i})`, Ioe = (e) => {
  bI || (bI = _u ? (
    // match color names, ignore partial matches
    new RegExp(`(${Object.keys(_u).join("|")})(?!\\w)`, "g")
  ) : (
    // never match
    /^\b$/
  ));
  const t = e.output.map((o) => Yo(o).replace(VC, Toe).replace(Qot, pB).replace(bI, pB)), n = t.map((o) => o.match(S_).map(Number)), i = n[0].map(
    (o, a) => n.map((s) => {
      if (!(a in s))
        throw Error('The arity of each "output" value must be equal');
      return s[a];
    })
  ).map(
    (o) => qv({ ...e, output: o })
  );
  return (o) => {
    var c;
    const a = !_B.test(t[0]) && ((c = t.find((l) => _B.test(l))) == null ? void 0 : c.replace(S_, ""));
    let s = 0;
    return t[0].replace(
      S_,
      () => `${i[s++](o)}${a || ""}`
    ).replace(Jot, eat);
  };
}, Vk = "react-spring: ", $oe = (e) => {
  const t = e;
  let n = !1;
  if (typeof t != "function")
    throw new TypeError(`${Vk}once requires a function parameter`);
  return (...r) => {
    n || (t(...r), n = !0);
  };
}, tat = $oe(console.warn);
function nat() {
  tat(
    `${Vk}The "interpolate" function is deprecated in v9 (use "to" instead)`
  );
}
var rat = $oe(console.warn);
function iat() {
  rat(
    `${Vk}Directly calling start instead of using the api object is deprecated in v9 (use ".start" instead), this will be removed in later 0.X.0 versions`
  );
}
function BC(e) {
  return He.str(e) && (e[0] == "#" || /\d/.test(e) || // Do not identify a CSS variable as an AnimatedString if its SSR
  !jk() && VC.test(e) || e in (_u || {}));
}
var Ud = jk() ? ot : Fa, oat = () => {
  const e = $e(!1);
  return Ud(() => (e.current = !0, () => {
    e.current = !1;
  }), []), e;
};
function Bk() {
  const e = Qe()[1], t = oat();
  return () => {
    t.current && e(Math.random());
  };
}
function aat(e, t) {
  const [n] = Qe(
    () => ({
      inputs: t,
      result: e()
    })
  ), r = $e(), i = r.current;
  let o = i;
  return o ? t && o.inputs && sat(t, o.inputs) || (o = {
    inputs: t,
    result: e()
  }) : o = n, ot(() => {
    r.current = o, i == n && (n.inputs = n.result = void 0);
  }, [o]), o.result;
}
function sat(e, t) {
  if (e.length !== t.length)
    return !1;
  for (let n = 0; n < e.length; n++)
    if (e[n] !== t[n])
      return !1;
  return !0;
}
var zk = (e) => ot(e, cat), cat = [];
function cP(e) {
  const t = $e();
  return ot(() => {
    t.current = e;
  }), t.current;
}
var Xv = Symbol.for("Animated:node"), lat = (e) => !!e && e[Xv] === e, Xs = (e) => e && e[Xv], Hk = (e, t) => Rot(e, Xv, t), zC = (e) => e && e[Xv] && e[Xv].getPayload(), Aoe = class {
  constructor() {
    Hk(this, this);
  }
  /** Get every `AnimatedValue` used by this node. */
  getPayload() {
    return this.payload || [];
  }
}, rb = class extends Aoe {
  constructor(e) {
    super(), this._value = e, this.done = !0, this.durationProgress = 0, He.num(this._value) && (this.lastPosition = this._value);
  }
  /** @internal */
  static create(e) {
    return new rb(e);
  }
  getPayload() {
    return [this];
  }
  getValue() {
    return this._value;
  }
  setValue(e, t) {
    return He.num(e) && (this.lastPosition = e, t && (e = Math.round(e / t) * t, this.done && (this.lastPosition = e))), this._value === e ? !1 : (this._value = e, !0);
  }
  reset() {
    const { done: e } = this;
    this.done = !1, He.num(this._value) && (this.elapsedTime = 0, this.durationProgress = 0, this.lastPosition = this._value, e && (this.lastVelocity = null), this.v0 = null);
  }
}, Qv = class extends rb {
  constructor(e) {
    super(0), this._string = null, this._toString = qv({
      output: [e, e]
    });
  }
  /** @internal */
  static create(e) {
    return new Qv(e);
  }
  getValue() {
    const e = this._string;
    return e ?? (this._string = this._toString(this._value));
  }
  setValue(e) {
    if (He.str(e)) {
      if (e == this._string)
        return !1;
      this._string = e, this._value = 1;
    } else if (super.setValue(e))
      this._string = null;
    else
      return !1;
    return !0;
  }
  reset(e) {
    e && (this._toString = qv({
      output: [this.getValue(), e]
    })), this._value = 0, super.reset();
  }
}, tx = { dependencies: null }, HC = class extends Aoe {
  constructor(e) {
    super(), this.source = e, this.setValue(e);
  }
  getValue(e) {
    const t = {};
    return Ec(this.source, (n, r) => {
      lat(n) ? t[r] = n.getValue(e) : La(n) ? t[r] = Yo(n) : e || (t[r] = n);
    }), t;
  }
  /** Replace the raw object data */
  setValue(e) {
    this.source = e, this.payload = this._makePayload(e);
  }
  reset() {
    this.payload && Yt(this.payload, (e) => e.reset());
  }
  /** Create a payload set. */
  _makePayload(e) {
    if (e) {
      const t = /* @__PURE__ */ new Set();
      return Ec(e, this._addToPayload, t), Array.from(t);
    }
  }
  /** Add to a payload set. */
  _addToPayload(e) {
    tx.dependencies && La(e) && tx.dependencies.add(e);
    const t = zC(e);
    t && Yt(t, (n) => this.add(n));
  }
}, Roe = class extends HC {
  constructor(e) {
    super(e);
  }
  /** @internal */
  static create(e) {
    return new Roe(e);
  }
  getValue() {
    return this.source.map((e) => e.getValue());
  }
  setValue(e) {
    const t = this.getPayload();
    return e.length == t.length ? t.map((n, r) => n.setValue(e[r])).some(Boolean) : (super.setValue(e.map(uat)), !0);
  }
};
function uat(e) {
  return (BC(e) ? Qv : rb).create(e);
}
function lP(e) {
  const t = Xs(e);
  return t ? t.constructor : He.arr(e) ? Roe : BC(e) ? Qv : rb;
}
var SB = (e, t) => {
  const n = (
    // Function components must use "forwardRef" to avoid being
    // re-rendered on every animation frame.
    !He.fun(e) || e.prototype && e.prototype.isReactComponent
  );
  return ia((r, i) => {
    const o = $e(null), a = n && // eslint-disable-next-line react-hooks/rules-of-hooks
    Wt(
      (p) => {
        o.current = hat(i, p);
      },
      [i]
    ), [s, c] = fat(r, t), l = Bk(), u = () => {
      const p = o.current;
      if (n && !p)
        return;
      (p ? t.applyAnimatedValues(p, s.getValue(!0)) : !1) === !1 && l();
    }, d = new dat(u, c), f = $e();
    Ud(() => (f.current = d, Yt(c, (p) => cm(p, d)), () => {
      f.current && (Yt(
        f.current.deps,
        (p) => Yv(p, f.current)
      ), an.cancel(f.current.update));
    })), ot(u, []), zk(() => () => {
      const p = f.current;
      Yt(p.deps, (g) => Yv(g, p));
    });
    const h = t.getComponentProps(s.getValue());
    return /* @__PURE__ */ $.createElement(e, { ...h, ref: a });
  });
}, dat = class {
  constructor(e, t) {
    this.update = e, this.deps = t;
  }
  eventObserved(e) {
    e.type == "change" && an.write(this.update);
  }
};
function fat(e, t) {
  const n = /* @__PURE__ */ new Set();
  return tx.dependencies = n, e.style && (e = {
    ...e,
    style: t.createAnimatedStyle(e.style)
  }), e = new HC(e), tx.dependencies = null, [e, n];
}
function hat(e, t) {
  return e && (He.fun(e) ? e(t) : e.current = t), t;
}
var wB = Symbol.for("AnimatedComponent"), gat = (e, {
  applyAnimatedValues: t = () => !1,
  createAnimatedStyle: n = (i) => new HC(i),
  getComponentProps: r = (i) => i
} = {}) => {
  const i = {
    applyAnimatedValues: t,
    createAnimatedStyle: n,
    getComponentProps: r
  }, o = (a) => {
    const s = xB(a) || "Anonymous";
    return He.str(a) ? a = o[a] || (o[a] = SB(a, i)) : a = a[wB] || (a[wB] = SB(a, i)), a.displayName = `Animated(${s})`, a;
  };
  return Ec(e, (a, s) => {
    He.arr(e) && (s = xB(a)), o[s] = o(a);
  }), {
    animated: o
  };
}, xB = (e) => He.str(e) ? e : e && He.str(e.displayName) ? e.displayName : He.fun(e) && e.name || null;
function Xo(e, ...t) {
  return He.fun(e) ? e(...t) : e;
}
var K0 = (e, t) => e === !0 || !!(t && e && (He.fun(e) ? e(t) : Mo(e).includes(t))), Poe = (e, t) => He.obj(e) ? t && e[t] : e, Ooe = (e, t) => e.default === !0 ? e[t] : e.default ? e.default[t] : void 0, pat = (e) => e, UC = (e, t = pat) => {
  let n = mat;
  e.default && e.default !== !0 && (e = e.default, n = Object.keys(e));
  const r = {};
  for (const i of n) {
    const o = t(e[i], i);
    He.und(o) || (r[i] = o);
  }
  return r;
}, mat = [
  "config",
  "onProps",
  "onStart",
  "onChange",
  "onPause",
  "onResume",
  "onRest"
], vat = {
  config: 1,
  from: 1,
  to: 1,
  ref: 1,
  loop: 1,
  reset: 1,
  pause: 1,
  cancel: 1,
  reverse: 1,
  immediate: 1,
  default: 1,
  delay: 1,
  onProps: 1,
  onStart: 1,
  onChange: 1,
  onPause: 1,
  onResume: 1,
  onRest: 1,
  onResolve: 1,
  // Transition props
  items: 1,
  trail: 1,
  sort: 1,
  expires: 1,
  initial: 1,
  enter: 1,
  update: 1,
  leave: 1,
  children: 1,
  onDestroyed: 1,
  // Internal props
  keys: 1,
  callId: 1,
  parentId: 1
};
function yat(e) {
  const t = {};
  let n = 0;
  if (Ec(e, (r, i) => {
    vat[i] || (t[i] = r, n++);
  }), n)
    return t;
}
function Uk(e) {
  const t = yat(e);
  if (t) {
    const n = { to: t };
    return Ec(e, (r, i) => i in t || (n[i] = r)), n;
  }
  return { ...e };
}
function Jv(e) {
  return e = Yo(e), He.arr(e) ? e.map(Jv) : BC(e) ? Os.createStringInterpolator({
    range: [0, 1],
    output: [e, e]
  })(1) : e;
}
function Moe(e) {
  for (const t in e)
    return !0;
  return !1;
}
function uP(e) {
  return He.fun(e) || He.arr(e) && He.obj(e[0]);
}
function dP(e, t) {
  var n;
  (n = e.ref) == null || n.delete(e), t == null || t.delete(e);
}
function koe(e, t) {
  var n;
  t && e.ref !== t && ((n = e.ref) == null || n.delete(e), t.add(e), e.ref = t);
}
var Wk = {
  default: { tension: 170, friction: 26 },
  gentle: { tension: 120, friction: 14 },
  wobbly: { tension: 180, friction: 12 },
  stiff: { tension: 210, friction: 20 },
  slow: { tension: 280, friction: 60 },
  molasses: { tension: 280, friction: 120 }
}, fP = {
  ...Wk.default,
  mass: 1,
  damping: 1,
  easing: Kot.linear,
  clamp: !1
}, bat = class {
  constructor() {
    this.velocity = 0, Object.assign(this, fP);
  }
};
function _at(e, t, n) {
  n && (n = { ...n }, EB(n, t), t = { ...n, ...t }), EB(e, t), Object.assign(e, t);
  for (const a in fP)
    e[a] == null && (e[a] = fP[a]);
  let { frequency: r, damping: i } = e;
  const { mass: o } = e;
  return He.und(r) || (r < 0.01 && (r = 0.01), i < 0 && (i = 0), e.tension = Math.pow(2 * Math.PI / r, 2) * o, e.friction = 4 * Math.PI * i * o / r), e;
}
function EB(e, t) {
  if (!He.und(t.decay))
    e.duration = void 0;
  else {
    const n = !He.und(t.tension) || !He.und(t.friction);
    (n || !He.und(t.frequency) || !He.und(t.damping) || !He.und(t.mass)) && (e.duration = void 0, e.decay = void 0), n && (e.frequency = void 0);
  }
}
var CB = [], Sat = class {
  constructor() {
    this.changed = !1, this.values = CB, this.toValues = null, this.fromValues = CB, this.config = new bat(), this.immediate = !1;
  }
};
function Noe(e, { key: t, props: n, defaultProps: r, state: i, actions: o }) {
  return new Promise((a, s) => {
    let c, l, u = K0(n.cancel ?? (r == null ? void 0 : r.cancel), t);
    if (u)
      h();
    else {
      He.und(n.pause) || (i.paused = K0(n.pause, t));
      let p = r == null ? void 0 : r.pause;
      p !== !0 && (p = i.paused || K0(p, t)), c = Xo(n.delay || 0, t), p ? (i.resumeQueue.add(f), o.pause()) : (o.resume(), f());
    }
    function d() {
      i.resumeQueue.add(f), i.timeouts.delete(l), l.cancel(), c = l.time - an.now();
    }
    function f() {
      c > 0 && !Os.skipAnimation ? (i.delayed = !0, l = an.setTimeout(h, c), i.pauseQueue.add(d), i.timeouts.add(l)) : h();
    }
    function h() {
      i.delayed && (i.delayed = !1), i.pauseQueue.delete(d), i.timeouts.delete(l), e <= (i.cancelId || 0) && (u = !0);
      try {
        o.start({ ...n, callId: e, cancel: u }, a);
      } catch (p) {
        s(p);
      }
    }
  });
}
var qk = (e, t) => t.length == 1 ? t[0] : t.some((n) => n.cancelled) ? wg(e.get()) : t.every((n) => n.noop) ? Doe(e.get()) : ds(
  e.get(),
  t.every((n) => n.finished)
), Doe = (e) => ({
  value: e,
  noop: !0,
  finished: !0,
  cancelled: !1
}), ds = (e, t, n = !1) => ({
  value: e,
  finished: t,
  cancelled: n
}), wg = (e) => ({
  value: e,
  cancelled: !0,
  finished: !1
});
function joe(e, t, n, r) {
  const { callId: i, parentId: o, onRest: a } = t, { asyncTo: s, promise: c } = n;
  return !o && e === s && !t.reset ? c : n.promise = (async () => {
    n.asyncId = i, n.asyncTo = e;
    const l = UC(
      t,
      (m, v) => (
        // The `onRest` prop is only called when the `runAsync` promise is resolved.
        v === "onRest" ? void 0 : m
      )
    );
    let u, d;
    const f = new Promise(
      (m, v) => (u = m, d = v)
    ), h = (m) => {
      const v = (
        // The `cancel` prop or `stop` method was used.
        i <= (n.cancelId || 0) && wg(r) || // The async `to` prop was replaced.
        i !== n.asyncId && ds(r, !1)
      );
      if (v)
        throw m.result = v, d(m), m;
    }, p = (m, v) => {
      const y = new TB(), _ = new IB();
      return (async () => {
        if (Os.skipAnimation)
          throw Zv(n), _.result = ds(r, !1), d(_), _;
        h(y);
        const b = He.obj(m) ? { ...m } : { ...v, to: m };
        b.parentId = i, Ec(l, (C, x) => {
          He.und(b[x]) && (b[x] = C);
        });
        const w = await r.start(b);
        return h(y), n.paused && await new Promise((C) => {
          n.resumeQueue.add(C);
        }), w;
      })();
    };
    let g;
    if (Os.skipAnimation)
      return Zv(n), ds(r, !1);
    try {
      let m;
      He.arr(e) ? m = (async (v) => {
        for (const y of v)
          await p(y);
      })(e) : m = Promise.resolve(e(p, r.stop.bind(r))), await Promise.all([m.then(u), f]), g = ds(r.get(), !0, !1);
    } catch (m) {
      if (m instanceof TB)
        g = m.result;
      else if (m instanceof IB)
        g = m.result;
      else
        throw m;
    } finally {
      i == n.asyncId && (n.asyncId = o, n.asyncTo = o ? s : void 0, n.promise = o ? c : void 0);
    }
    return He.fun(a) && an.batchedUpdates(() => {
      a(g, r, r.item);
    }), g;
  })();
}
function Zv(e, t) {
  q0(e.timeouts, (n) => n.cancel()), e.pauseQueue.clear(), e.resumeQueue.clear(), e.asyncId = e.asyncTo = e.promise = void 0, t && (e.cancelId = t);
}
var TB = class extends Error {
  constructor() {
    super(
      "An async animation has been interrupted. You see this error because you forgot to use `await` or `.catch(...)` on its returned promise."
    );
  }
}, IB = class extends Error {
  constructor() {
    super("SkipAnimationSignal");
  }
}, hP = (e) => e instanceof Gk, wat = 1, Gk = class extends Eoe {
  constructor() {
    super(...arguments), this.id = wat++, this._priority = 0;
  }
  get priority() {
    return this._priority;
  }
  set priority(e) {
    this._priority != e && (this._priority = e, this._onPriorityChange(e));
  }
  /** Get the current value */
  get() {
    const e = Xs(this);
    return e && e.getValue();
  }
  /** Create a spring that maps our value to another value */
  to(...e) {
    return Os.to(this, e);
  }
  /** @deprecated Use the `to` method instead. */
  interpolate(...e) {
    return nat(), Os.to(this, e);
  }
  toJSON() {
    return this.get();
  }
  observerAdded(e) {
    e == 1 && this._attach();
  }
  observerRemoved(e) {
    e == 0 && this._detach();
  }
  /** Called when the first child is added. */
  _attach() {
  }
  /** Called when the last child is removed. */
  _detach() {
  }
  /** Tell our children about our new value */
  _onChange(e, t = !1) {
    Kv(this, {
      type: "change",
      parent: this,
      value: e,
      idle: t
    });
  }
  /** Tell our children about our new priority */
  _onPriorityChange(e) {
    this.idle || LC.sort(this), Kv(this, {
      type: "priority",
      parent: this,
      priority: e
    });
  }
}, kf = Symbol.for("SpringPhase"), Loe = 1, gP = 2, pP = 4, _I = (e) => (e[kf] & Loe) > 0, Nl = (e) => (e[kf] & gP) > 0, Bm = (e) => (e[kf] & pP) > 0, $B = (e, t) => t ? e[kf] |= gP | Loe : e[kf] &= ~gP, AB = (e, t) => t ? e[kf] |= pP : e[kf] &= ~pP, xat = class extends Gk {
  constructor(e, t) {
    if (super(), this.animation = new Sat(), this.defaultProps = {}, this._state = {
      paused: !1,
      delayed: !1,
      pauseQueue: /* @__PURE__ */ new Set(),
      resumeQueue: /* @__PURE__ */ new Set(),
      timeouts: /* @__PURE__ */ new Set()
    }, this._pendingCalls = /* @__PURE__ */ new Set(), this._lastCallId = 0, this._lastToId = 0, this._memoizedDuration = 0, !He.und(e) || !He.und(t)) {
      const n = He.obj(e) ? { ...e } : { ...t, from: e };
      He.und(n.default) && (n.default = !0), this.start(n);
    }
  }
  /** Equals true when not advancing on each frame. */
  get idle() {
    return !(Nl(this) || this._state.asyncTo) || Bm(this);
  }
  get goal() {
    return Yo(this.animation.to);
  }
  get velocity() {
    const e = Xs(this);
    return e instanceof rb ? e.lastVelocity || 0 : e.getPayload().map((t) => t.lastVelocity || 0);
  }
  /**
   * When true, this value has been animated at least once.
   */
  get hasAnimated() {
    return _I(this);
  }
  /**
   * When true, this value has an unfinished animation,
   * which is either active or paused.
   */
  get isAnimating() {
    return Nl(this);
  }
  /**
   * When true, all current and future animations are paused.
   */
  get isPaused() {
    return Bm(this);
  }
  /**
   *
   *
   */
  get isDelayed() {
    return this._state.delayed;
  }
  /** Advance the current animation by a number of milliseconds */
  advance(e) {
    let t = !0, n = !1;
    const r = this.animation;
    let { toValues: i } = r;
    const { config: o } = r, a = zC(r.to);
    !a && La(r.to) && (i = Mo(Yo(r.to))), r.values.forEach((l, u) => {
      if (l.done)
        return;
      const d = (
        // Animated strings always go from 0 to 1.
        l.constructor == Qv ? 1 : a ? a[u].lastPosition : i[u]
      );
      let f = r.immediate, h = d;
      if (!f) {
        if (h = l.lastPosition, o.tension <= 0) {
          l.done = !0;
          return;
        }
        let p = l.elapsedTime += e;
        const g = r.fromValues[u], m = l.v0 != null ? l.v0 : l.v0 = He.arr(o.velocity) ? o.velocity[u] : o.velocity;
        let v;
        const y = o.precision || (g == d ? 5e-3 : Math.min(1, Math.abs(d - g) * 1e-3));
        if (He.und(o.duration))
          if (o.decay) {
            const _ = o.decay === !0 ? 0.998 : o.decay, b = Math.exp(-(1 - _) * p);
            h = g + m / (1 - _) * (1 - b), f = Math.abs(l.lastPosition - h) <= y, v = m * b;
          } else {
            v = l.lastVelocity == null ? m : l.lastVelocity;
            const _ = o.restVelocity || y / 10, b = o.clamp ? 0 : o.bounce, w = !He.und(b), C = g == d ? l.v0 > 0 : g < d;
            let x, T = !1;
            const E = 1, R = Math.ceil(e / E);
            for (let I = 0; I < R && (x = Math.abs(v) > _, !(!x && (f = Math.abs(d - h) <= y, f))); ++I) {
              w && (T = h == d || h > d == C, T && (v = -v * b, h = d));
              const O = -o.tension * 1e-6 * (h - d), P = -o.friction * 1e-3 * v, k = (O + P) / o.mass;
              v = v + k * E, h = h + v * E;
            }
          }
        else {
          let _ = 1;
          o.duration > 0 && (this._memoizedDuration !== o.duration && (this._memoizedDuration = o.duration, l.durationProgress > 0 && (l.elapsedTime = o.duration * l.durationProgress, p = l.elapsedTime += e)), _ = (o.progress || 0) + p / this._memoizedDuration, _ = _ > 1 ? 1 : _ < 0 ? 0 : _, l.durationProgress = _), h = g + o.easing(_) * (d - g), v = (h - l.lastPosition) / e, f = _ == 1;
        }
        l.lastVelocity = v, Number.isNaN(h) && (console.warn("Got NaN while animating:", this), f = !0);
      }
      a && !a[u].done && (f = !1), f ? l.done = !0 : t = !1, l.setValue(h, o.round) && (n = !0);
    });
    const s = Xs(this), c = s.getValue();
    if (t) {
      const l = Yo(r.to);
      (c !== l || n) && !o.decay ? (s.setValue(l), this._onChange(l)) : n && o.decay && this._onChange(c), this._stop();
    } else
      n && this._onChange(c);
  }
  /** Set the current value, while stopping the current animation */
  set(e) {
    return an.batchedUpdates(() => {
      this._stop(), this._focus(e), this._set(e);
    }), this;
  }
  /**
   * Freeze the active animation in time, as well as any updates merged
   * before `resume` is called.
   */
  pause() {
    this._update({ pause: !0 });
  }
  /** Resume the animation if paused. */
  resume() {
    this._update({ pause: !1 });
  }
  /** Skip to the end of the current animation. */
  finish() {
    if (Nl(this)) {
      const { to: e, config: t } = this.animation;
      an.batchedUpdates(() => {
        this._onStart(), t.decay || this._set(e, !1), this._stop();
      });
    }
    return this;
  }
  /** Push props into the pending queue. */
  update(e) {
    return (this.queue || (this.queue = [])).push(e), this;
  }
  start(e, t) {
    let n;
    return He.und(e) ? (n = this.queue || [], this.queue = []) : n = [He.obj(e) ? e : { ...t, to: e }], Promise.all(
      n.map((r) => this._update(r))
    ).then((r) => qk(this, r));
  }
  /**
   * Stop the current animation, and cancel any delayed updates.
   *
   * Pass `true` to call `onRest` with `cancelled: true`.
   */
  stop(e) {
    const { to: t } = this.animation;
    return this._focus(this.get()), Zv(this._state, e && this._lastCallId), an.batchedUpdates(() => this._stop(t, e)), this;
  }
  /** Restart the animation. */
  reset() {
    this._update({ reset: !0 });
  }
  /** @internal */
  eventObserved(e) {
    e.type == "change" ? this._start() : e.type == "priority" && (this.priority = e.priority + 1);
  }
  /**
   * Parse the `to` and `from` range from the given `props` object.
   *
   * This also ensures the initial value is available to animated components
   * during the render phase.
   */
  _prepareNode(e) {
    const t = this.key || "";
    let { to: n, from: r } = e;
    n = He.obj(n) ? n[t] : n, (n == null || uP(n)) && (n = void 0), r = He.obj(r) ? r[t] : r, r == null && (r = void 0);
    const i = { to: n, from: r };
    return _I(this) || (e.reverse && ([n, r] = [r, n]), r = Yo(r), He.und(r) ? Xs(this) || this._set(n) : this._set(r)), i;
  }
  /** Every update is processed by this method before merging. */
  _update({ ...e }, t) {
    const { key: n, defaultProps: r } = this;
    e.default && Object.assign(
      r,
      UC(
        e,
        (a, s) => /^on/.test(s) ? Poe(a, n) : a
      )
    ), PB(this, e, "onProps"), Hm(this, "onProps", e, this);
    const i = this._prepareNode(e);
    if (Object.isFrozen(this))
      throw Error(
        "Cannot animate a `SpringValue` object that is frozen. Did you forget to pass your component to `animated(...)` before animating its props?"
      );
    const o = this._state;
    return Noe(++this._lastCallId, {
      key: n,
      props: e,
      defaultProps: r,
      state: o,
      actions: {
        pause: () => {
          Bm(this) || (AB(this, !0), v0(o.pauseQueue), Hm(
            this,
            "onPause",
            ds(this, zm(this, this.animation.to)),
            this
          ));
        },
        resume: () => {
          Bm(this) && (AB(this, !1), Nl(this) && this._resume(), v0(o.resumeQueue), Hm(
            this,
            "onResume",
            ds(this, zm(this, this.animation.to)),
            this
          ));
        },
        start: this._merge.bind(this, i)
      }
    }).then((a) => {
      if (e.loop && a.finished && !(t && a.noop)) {
        const s = Foe(e);
        if (s)
          return this._update(s, !0);
      }
      return a;
    });
  }
  /** Merge props into the current animation */
  _merge(e, t, n) {
    if (t.cancel)
      return this.stop(!0), n(wg(this));
    const r = !He.und(e.to), i = !He.und(e.from);
    if (r || i)
      if (t.callId > this._lastToId)
        this._lastToId = t.callId;
      else
        return n(wg(this));
    const { key: o, defaultProps: a, animation: s } = this, { to: c, from: l } = s;
    let { to: u = c, from: d = l } = e;
    i && !r && (!t.default || He.und(u)) && (u = d), t.reverse && ([u, d] = [d, u]);
    const f = !Gc(d, l);
    f && (s.from = d), d = Yo(d);
    const h = !Gc(u, c);
    h && this._focus(u);
    const p = uP(t.to), { config: g } = s, { decay: m, velocity: v } = g;
    (r || i) && (g.velocity = 0), t.config && !p && _at(
      g,
      Xo(t.config, o),
      // Avoid calling the same "config" prop twice.
      t.config !== a.config ? Xo(a.config, o) : void 0
    );
    let y = Xs(this);
    if (!y || He.und(u))
      return n(ds(this, !0));
    const _ = (
      // When `reset` is undefined, the `from` prop implies `reset: true`,
      // except for declarative updates. When `reset` is defined, there
      // must exist a value to animate from.
      He.und(t.reset) ? i && !t.default : !He.und(d) && K0(t.reset, o)
    ), b = _ ? d : this.get(), w = Jv(u), C = He.num(w) || He.arr(w) || BC(w), x = !p && (!C || K0(a.immediate || t.immediate, o));
    if (h) {
      const I = lP(u);
      if (I !== y.constructor)
        if (x)
          y = this._set(w);
        else
          throw Error(
            `Cannot animate between ${y.constructor.name} and ${I.name}, as the "to" prop suggests`
          );
    }
    const T = y.constructor;
    let E = La(u), R = !1;
    if (!E) {
      const I = _ || !_I(this) && f;
      (h || I) && (R = Gc(Jv(b), w), E = !R), (!Gc(s.immediate, x) && !x || !Gc(g.decay, m) || !Gc(g.velocity, v)) && (E = !0);
    }
    if (R && Nl(this) && (s.changed && !_ ? E = !0 : E || this._stop(c)), !p && ((E || La(c)) && (s.values = y.getPayload(), s.toValues = La(u) ? null : T == Qv ? [1] : Mo(w)), s.immediate != x && (s.immediate = x, !x && !_ && this._set(c)), E)) {
      const { onRest: I } = s;
      Yt(Cat, (P) => PB(this, t, P));
      const O = ds(this, zm(this, c));
      v0(this._pendingCalls, O), this._pendingCalls.add(n), s.changed && an.batchedUpdates(() => {
        var P;
        s.changed = !_, I == null || I(O, this), _ ? Xo(a.onRest, O) : (P = s.onStart) == null || P.call(s, O, this);
      });
    }
    _ && this._set(b), p ? n(joe(t.to, t, this._state, this)) : E ? this._start() : Nl(this) && !h ? this._pendingCalls.add(n) : n(Doe(b));
  }
  /** Update the `animation.to` value, which might be a `FluidValue` */
  _focus(e) {
    const t = this.animation;
    e !== t.to && (bB(this) && this._detach(), t.to = e, bB(this) && this._attach());
  }
  _attach() {
    let e = 0;
    const { to: t } = this.animation;
    La(t) && (cm(t, this), hP(t) && (e = t.priority + 1)), this.priority = e;
  }
  _detach() {
    const { to: e } = this.animation;
    La(e) && Yv(e, this);
  }
  /**
   * Update the current value from outside the frameloop,
   * and return the `Animated` node.
   */
  _set(e, t = !0) {
    const n = Yo(e);
    if (!He.und(n)) {
      const r = Xs(this);
      if (!r || !Gc(n, r.getValue())) {
        const i = lP(n);
        !r || r.constructor != i ? Hk(this, i.create(n)) : r.setValue(n), r && an.batchedUpdates(() => {
          this._onChange(n, t);
        });
      }
    }
    return Xs(this);
  }
  _onStart() {
    const e = this.animation;
    e.changed || (e.changed = !0, Hm(
      this,
      "onStart",
      ds(this, zm(this, e.to)),
      this
    ));
  }
  _onChange(e, t) {
    t || (this._onStart(), Xo(this.animation.onChange, e, this)), Xo(this.defaultProps.onChange, e, this), super._onChange(e, t);
  }
  // This method resets the animation state (even if already animating) to
  // ensure the latest from/to range is used, and it also ensures this spring
  // is added to the frameloop.
  _start() {
    const e = this.animation;
    Xs(this).reset(Yo(e.to)), e.immediate || (e.fromValues = e.values.map((t) => t.lastPosition)), Nl(this) || ($B(this, !0), Bm(this) || this._resume());
  }
  _resume() {
    Os.skipAnimation ? this.finish() : LC.start(this);
  }
  /**
   * Exit the frameloop and notify `onRest` listeners.
   *
   * Always wrap `_stop` calls with `batchedUpdates`.
   */
  _stop(e, t) {
    if (Nl(this)) {
      $B(this, !1);
      const n = this.animation;
      Yt(n.values, (i) => {
        i.done = !0;
      }), n.toValues && (n.onChange = n.onPause = n.onResume = void 0), Kv(this, {
        type: "idle",
        parent: this
      });
      const r = t ? wg(this.get()) : ds(this.get(), zm(this, e ?? n.to));
      v0(this._pendingCalls, r), n.changed && (n.changed = !1, Hm(this, "onRest", r, this));
    }
  }
};
function zm(e, t) {
  const n = Jv(t), r = Jv(e.get());
  return Gc(r, n);
}
function Foe(e, t = e.loop, n = e.to) {
  const r = Xo(t);
  if (r) {
    const i = r !== !0 && Uk(r), o = (i || e).reverse, a = !i || i.reset;
    return ey({
      ...e,
      loop: t,
      // Avoid updating default props when looping.
      default: !1,
      // Never loop the `pause` prop.
      pause: void 0,
      // For the "reverse" prop to loop as expected, the "to" prop
      // must be undefined. The "reverse" prop is ignored when the
      // "to" prop is an array or function.
      to: !o || uP(n) ? n : void 0,
      // Ignore the "from" prop except on reset.
      from: a ? e.from : void 0,
      reset: a,
      // The "loop" prop can return a "useSpring" props object to
      // override any of the original props.
      ...i
    });
  }
}
function ey(e) {
  const { to: t, from: n } = e = Uk(e), r = /* @__PURE__ */ new Set();
  return He.obj(t) && RB(t, r), He.obj(n) && RB(n, r), e.keys = r.size ? Array.from(r) : null, e;
}
function Eat(e) {
  const t = ey(e);
  return He.und(t.default) && (t.default = UC(t)), t;
}
function RB(e, t) {
  Ec(e, (n, r) => n != null && t.add(r));
}
var Cat = [
  "onStart",
  "onRest",
  "onChange",
  "onPause",
  "onResume"
];
function PB(e, t, n) {
  e.animation[n] = t[n] !== Ooe(t, n) ? Poe(t[n], e.key) : void 0;
}
function Hm(e, t, ...n) {
  var r, i, o, a;
  (i = (r = e.animation)[t]) == null || i.call(r, ...n), (a = (o = e.defaultProps)[t]) == null || a.call(o, ...n);
}
var Tat = ["onStart", "onChange", "onRest"], Iat = 1, Voe = class {
  constructor(e, t) {
    this.id = Iat++, this.springs = {}, this.queue = [], this._lastAsyncId = 0, this._active = /* @__PURE__ */ new Set(), this._changed = /* @__PURE__ */ new Set(), this._started = !1, this._state = {
      paused: !1,
      pauseQueue: /* @__PURE__ */ new Set(),
      resumeQueue: /* @__PURE__ */ new Set(),
      timeouts: /* @__PURE__ */ new Set()
    }, this._events = {
      onStart: /* @__PURE__ */ new Map(),
      onChange: /* @__PURE__ */ new Map(),
      onRest: /* @__PURE__ */ new Map()
    }, this._onFrame = this._onFrame.bind(this), t && (this._flush = t), e && this.start({ default: !0, ...e });
  }
  /**
   * Equals `true` when no spring values are in the frameloop, and
   * no async animation is currently active.
   */
  get idle() {
    return !this._state.asyncTo && Object.values(this.springs).every((e) => e.idle && !e.isDelayed && !e.isPaused);
  }
  get item() {
    return this._item;
  }
  set item(e) {
    this._item = e;
  }
  /** Get the current values of our springs */
  get() {
    const e = {};
    return this.each((t, n) => e[n] = t.get()), e;
  }
  /** Set the current values without animating. */
  set(e) {
    for (const t in e) {
      const n = e[t];
      He.und(n) || this.springs[t].set(n);
    }
  }
  /** Push an update onto the queue of each value. */
  update(e) {
    return e && this.queue.push(ey(e)), this;
  }
  /**
   * Start the queued animations for every spring, and resolve the returned
   * promise once all queued animations have finished or been cancelled.
   *
   * When you pass a queue (instead of nothing), that queue is used instead of
   * the queued animations added with the `update` method, which are left alone.
   */
  start(e) {
    let { queue: t } = this;
    return e ? t = Mo(e).map(ey) : this.queue = [], this._flush ? this._flush(this, t) : (Woe(this, t), mP(this, t));
  }
  /** @internal */
  stop(e, t) {
    if (e !== !!e && (t = e), t) {
      const n = this.springs;
      Yt(Mo(t), (r) => n[r].stop(!!e));
    } else
      Zv(this._state, this._lastAsyncId), this.each((n) => n.stop(!!e));
    return this;
  }
  /** Freeze the active animation in time */
  pause(e) {
    if (He.und(e))
      this.start({ pause: !0 });
    else {
      const t = this.springs;
      Yt(Mo(e), (n) => t[n].pause());
    }
    return this;
  }
  /** Resume the animation if paused. */
  resume(e) {
    if (He.und(e))
      this.start({ pause: !1 });
    else {
      const t = this.springs;
      Yt(Mo(e), (n) => t[n].resume());
    }
    return this;
  }
  /** Call a function once per spring value */
  each(e) {
    Ec(this.springs, e);
  }
  /** @internal Called at the end of every animation frame */
  _onFrame() {
    const { onStart: e, onChange: t, onRest: n } = this._events, r = this._active.size > 0, i = this._changed.size > 0;
    (r && !this._started || i && !this._started) && (this._started = !0, q0(e, ([s, c]) => {
      c.value = this.get(), s(c, this, this._item);
    }));
    const o = !r && this._started, a = i || o && n.size ? this.get() : null;
    i && t.size && q0(t, ([s, c]) => {
      c.value = a, s(c, this, this._item);
    }), o && (this._started = !1, q0(n, ([s, c]) => {
      c.value = a, s(c, this, this._item);
    }));
  }
  /** @internal */
  eventObserved(e) {
    if (e.type == "change")
      this._changed.add(e.parent), e.idle || this._active.add(e.parent);
    else if (e.type == "idle")
      this._active.delete(e.parent);
    else
      return;
    an.onFrame(this._onFrame);
  }
};
function mP(e, t) {
  return Promise.all(t.map((n) => Boe(e, n))).then(
    (n) => qk(e, n)
  );
}
async function Boe(e, t, n) {
  const { keys: r, to: i, from: o, loop: a, onRest: s, onResolve: c } = t, l = He.obj(t.default) && t.default;
  a && (t.loop = !1), i === !1 && (t.to = null), o === !1 && (t.from = null);
  const u = He.arr(i) || He.fun(i) ? i : void 0;
  u ? (t.to = void 0, t.onRest = void 0, l && (l.onRest = void 0)) : Yt(Tat, (g) => {
    const m = t[g];
    if (He.fun(m)) {
      const v = e._events[g];
      t[g] = ({ finished: y, cancelled: _ }) => {
        const b = v.get(m);
        b ? (y || (b.finished = !1), _ && (b.cancelled = !0)) : v.set(m, {
          value: null,
          finished: y || !1,
          cancelled: _ || !1
        });
      }, l && (l[g] = t[g]);
    }
  });
  const d = e._state;
  t.pause === !d.paused ? (d.paused = t.pause, v0(t.pause ? d.pauseQueue : d.resumeQueue)) : d.paused && (t.pause = !0);
  const f = (r || Object.keys(e.springs)).map(
    (g) => e.springs[g].start(t)
  ), h = t.cancel === !0 || Ooe(t, "cancel") === !0;
  (u || h && d.asyncId) && f.push(
    Noe(++e._lastAsyncId, {
      props: t,
      state: d,
      actions: {
        pause: aP,
        resume: aP,
        start(g, m) {
          h ? (Zv(d, e._lastAsyncId), m(wg(e))) : (g.onRest = s, m(
            joe(
              u,
              g,
              d,
              e
            )
          ));
        }
      }
    })
  ), d.paused && await new Promise((g) => {
    d.resumeQueue.add(g);
  });
  const p = qk(e, await Promise.all(f));
  if (a && p.finished && !(n && p.noop)) {
    const g = Foe(t, a, i);
    if (g)
      return Woe(e, [g]), Boe(e, g, !0);
  }
  return c && an.batchedUpdates(() => c(p, e, e.item)), p;
}
function vP(e, t) {
  const n = { ...e.springs };
  return t && Yt(Mo(t), (r) => {
    He.und(r.keys) && (r = ey(r)), He.obj(r.to) || (r = { ...r, to: void 0 }), Uoe(n, r, (i) => Hoe(i));
  }), zoe(e, n), n;
}
function zoe(e, t) {
  Ec(t, (n, r) => {
    e.springs[r] || (e.springs[r] = n, cm(n, e));
  });
}
function Hoe(e, t) {
  const n = new xat();
  return n.key = e, t && cm(n, t), n;
}
function Uoe(e, t, n) {
  t.keys && Yt(t.keys, (r) => {
    (e[r] || (e[r] = n(r)))._prepareNode(t);
  });
}
function Woe(e, t) {
  Yt(t, (n) => {
    Uoe(e.springs, n, (r) => Hoe(r, e));
  });
}
var ib = ({
  children: e,
  ...t
}) => {
  const n = gt(nx), r = t.pause || !!n.pause, i = t.immediate || !!n.immediate;
  t = aat(() => ({ pause: r, immediate: i }), [r, i]);
  const { Provider: o } = nx;
  return /* @__PURE__ */ $.createElement(o, { value: t }, e);
}, nx = $at(ib, {});
ib.Provider = nx.Provider;
ib.Consumer = nx.Consumer;
function $at(e, t) {
  return Object.assign(e, $.createContext(t)), e.Provider._context = e, e.Consumer._context = e, e;
}
var qoe = () => {
  const e = [], t = function(r) {
    iat();
    const i = [];
    return Yt(e, (o, a) => {
      if (He.und(r))
        i.push(o.start());
      else {
        const s = n(r, o, a);
        s && i.push(o.start(s));
      }
    }), i;
  };
  t.current = e, t.add = function(r) {
    e.includes(r) || e.push(r);
  }, t.delete = function(r) {
    const i = e.indexOf(r);
    ~i && e.splice(i, 1);
  }, t.pause = function() {
    return Yt(e, (r) => r.pause(...arguments)), this;
  }, t.resume = function() {
    return Yt(e, (r) => r.resume(...arguments)), this;
  }, t.set = function(r) {
    Yt(e, (i, o) => {
      const a = He.fun(r) ? r(o, i) : r;
      a && i.set(a);
    });
  }, t.start = function(r) {
    const i = [];
    return Yt(e, (o, a) => {
      if (He.und(r))
        i.push(o.start());
      else {
        const s = this._getProps(r, o, a);
        s && i.push(o.start(s));
      }
    }), i;
  }, t.stop = function() {
    return Yt(e, (r) => r.stop(...arguments)), this;
  }, t.update = function(r) {
    return Yt(e, (i, o) => i.update(this._getProps(r, i, o))), this;
  };
  const n = function(r, i, o) {
    return He.fun(r) ? r(o, i) : r;
  };
  return t._getProps = n, t;
};
function Aat(e, t, n) {
  const r = He.fun(t) && t;
  r && !n && (n = []);
  const i = Tt(
    () => r || arguments.length == 3 ? qoe() : void 0,
    []
  ), o = $e(0), a = Bk(), s = Tt(
    () => ({
      ctrls: [],
      queue: [],
      flush(v, y) {
        const _ = vP(v, y);
        return o.current > 0 && !s.queue.length && !Object.keys(_).some((w) => !v.springs[w]) ? mP(v, y) : new Promise((w) => {
          zoe(v, _), s.queue.push(() => {
            w(mP(v, y));
          }), a();
        });
      }
    }),
    []
  ), c = $e([...s.ctrls]), l = [], u = cP(e) || 0;
  Tt(() => {
    Yt(c.current.slice(e, u), (v) => {
      dP(v, i), v.stop(!0);
    }), c.current.length = e, d(u, e);
  }, [e]), Tt(() => {
    d(0, Math.min(u, e));
  }, n);
  function d(v, y) {
    for (let _ = v; _ < y; _++) {
      const b = c.current[_] || (c.current[_] = new Voe(null, s.flush)), w = r ? r(_, b) : t[_];
      w && (l[_] = Eat(w));
    }
  }
  const f = c.current.map((v, y) => vP(v, l[y])), h = gt(ib), p = cP(h), g = h !== p && Moe(h);
  Ud(() => {
    o.current++, s.ctrls = c.current;
    const { queue: v } = s;
    v.length && (s.queue = [], Yt(v, (y) => y())), Yt(c.current, (y, _) => {
      i == null || i.add(y), g && y.start({ default: h });
      const b = l[_];
      b && (koe(y, b.ref), y.ref ? y.queue.push(b) : y.start(b));
    });
  }), zk(() => () => {
    Yt(s.ctrls, (v) => v.stop(!0));
  });
  const m = f.map((v) => ({ ...v }));
  return i ? [m, i] : m;
}
function Il(e, t) {
  const n = He.fun(e), [[r], i] = Aat(
    1,
    n ? e : [e],
    n ? t || [] : t
  );
  return n || arguments.length == 2 ? [r, i] : r;
}
function Kk(e, t, n) {
  const r = He.fun(t) && t, {
    reset: i,
    sort: o,
    trail: a = 0,
    expires: s = !0,
    exitBeforeEnter: c = !1,
    onDestroyed: l,
    ref: u,
    config: d
  } = r ? r() : t, f = Tt(
    () => r || arguments.length == 3 ? qoe() : void 0,
    []
  ), h = Mo(e), p = [], g = $e(null), m = i ? null : g.current;
  Ud(() => {
    g.current = p;
  }), zk(() => (Yt(p, (k) => {
    f == null || f.add(k.ctrl), k.ctrl.ref = f;
  }), () => {
    Yt(g.current, (k) => {
      k.expired && clearTimeout(k.expirationId), dP(k.ctrl, f), k.ctrl.stop(!0);
    });
  }));
  const v = Pat(h, r ? r() : t, m), y = i && g.current || [];
  Ud(
    () => Yt(y, ({ ctrl: k, item: L, key: N }) => {
      dP(k, f), Xo(l, L, N);
    })
  );
  const _ = [];
  if (m && Yt(m, (k, L) => {
    k.expired ? (clearTimeout(k.expirationId), y.push(k)) : (L = _[L] = v.indexOf(k.key), ~L && (p[L] = k));
  }), Yt(h, (k, L) => {
    p[L] || (p[L] = {
      key: v[L],
      item: k,
      phase: "mount",
      ctrl: new Voe()
    }, p[L].ctrl.item = k);
  }), _.length) {
    let k = -1;
    const { leave: L } = r ? r() : t;
    Yt(_, (N, D) => {
      const z = m[D];
      ~N ? (k = p.indexOf(z), p[k] = { ...z, item: h[N] }) : L && p.splice(++k, 0, z);
    });
  }
  He.fun(o) && p.sort((k, L) => o(k.item, L.item));
  let b = -a;
  const w = Bk(), C = UC(t), x = /* @__PURE__ */ new Map(), T = $e(/* @__PURE__ */ new Map()), E = $e(!1);
  Yt(p, (k, L) => {
    const N = k.key, D = k.phase, z = r ? r() : t;
    let V, B;
    const U = Xo(z.delay || 0, N);
    if (D == "mount")
      V = z.enter, B = "enter";
    else {
      const X = v.indexOf(N) < 0;
      if (D != "leave")
        if (X)
          V = z.leave, B = "leave";
        else if (V = z.update)
          B = "update";
        else
          return;
      else if (!X)
        V = z.enter, B = "enter";
      else
        return;
    }
    if (V = Xo(V, k.item, L), V = He.obj(V) ? Uk(V) : { to: V }, !V.config) {
      const X = d || C.config;
      V.config = Xo(X, k.item, L, B);
    }
    b += a;
    const Q = {
      ...C,
      // we need to add our props.delay value you here.
      delay: U + b,
      ref: u,
      immediate: z.immediate,
      // This prevents implied resets.
      reset: !1,
      // Merge any phase-specific props.
      ...V
    };
    if (B == "enter" && He.und(Q.from)) {
      const X = r ? r() : t, ne = He.und(X.initial) || m ? X.from : X.initial;
      Q.from = Xo(ne, k.item, L);
    }
    const { onResolve: Y } = Q;
    Q.onResolve = (X) => {
      Xo(Y, X);
      const ne = g.current, Z = ne.find((J) => J.key === N);
      if (Z && !(X.cancelled && Z.phase != "update") && Z.ctrl.idle) {
        const J = ne.every((K) => K.ctrl.idle);
        if (Z.phase == "leave") {
          const K = Xo(s, Z.item);
          if (K !== !1) {
            const ee = K === !0 ? 0 : K;
            if (Z.expired = !0, !J && ee > 0) {
              ee <= 2147483647 && (Z.expirationId = setTimeout(w, ee));
              return;
            }
          }
        }
        J && ne.some((K) => K.expired) && (T.current.delete(Z), c && (E.current = !0), w());
      }
    };
    const q = vP(k.ctrl, Q);
    B === "leave" && c ? T.current.set(k, { phase: B, springs: q, payload: Q }) : x.set(k, { phase: B, springs: q, payload: Q });
  });
  const R = gt(ib), I = cP(R), O = R !== I && Moe(R);
  Ud(() => {
    O && Yt(p, (k) => {
      k.ctrl.start({ default: R });
    });
  }, [R]), Yt(x, (k, L) => {
    if (T.current.size) {
      const N = p.findIndex((D) => D.key === L.key);
      p.splice(N, 1);
    }
  }), Ud(
    () => {
      Yt(
        T.current.size ? T.current : x,
        ({ phase: k, payload: L }, N) => {
          const { ctrl: D } = N;
          N.phase = k, f == null || f.add(D), O && k == "enter" && D.start({ default: R }), L && (koe(D, L.ref), (D.ref || f) && !E.current ? D.update(L) : (D.start(L), E.current && (E.current = !1)));
        }
      );
    },
    i ? void 0 : n
  );
  const P = (k) => /* @__PURE__ */ $.createElement($.Fragment, null, p.map((L, N) => {
    const { springs: D } = x.get(L) || L.ctrl, z = k({ ...D }, L.item, L, N);
    return z && z.type ? /* @__PURE__ */ $.createElement(
      z.type,
      {
        ...z.props,
        key: He.str(L.key) || He.num(L.key) ? L.key : L.ctrl.id,
        ref: z.ref
      }
    ) : z;
  }));
  return f ? [P, f] : P;
}
var Rat = 1;
function Pat(e, { key: t, keys: n = t }, r) {
  if (n === null) {
    const i = /* @__PURE__ */ new Set();
    return e.map((o) => {
      const a = r && r.find(
        (s) => s.item === o && s.phase !== "leave" && !i.has(s)
      );
      return a ? (i.add(a), a.key) : Rat++;
    });
  }
  return He.und(n) ? e : He.fun(n) ? e.map(n) : Mo(n);
}
var Goe = class extends Gk {
  constructor(e, t) {
    super(), this.source = e, this.idle = !0, this._active = /* @__PURE__ */ new Set(), this.calc = qv(...t);
    const n = this._get(), r = lP(n);
    Hk(this, r.create(n));
  }
  advance(e) {
    const t = this._get(), n = this.get();
    Gc(t, n) || (Xs(this).setValue(t), this._onChange(t, this.idle)), !this.idle && OB(this._active) && SI(this);
  }
  _get() {
    const e = He.arr(this.source) ? this.source.map(Yo) : Mo(Yo(this.source));
    return this.calc(...e);
  }
  _start() {
    this.idle && !OB(this._active) && (this.idle = !1, Yt(zC(this), (e) => {
      e.done = !1;
    }), Os.skipAnimation ? (an.batchedUpdates(() => this.advance()), SI(this)) : LC.start(this));
  }
  // Observe our sources only when we're observed.
  _attach() {
    let e = 1;
    Yt(Mo(this.source), (t) => {
      La(t) && cm(t, this), hP(t) && (t.idle || this._active.add(t), e = Math.max(e, t.priority + 1));
    }), this.priority = e, this._start();
  }
  // Stop observing our sources once we have no observers.
  _detach() {
    Yt(Mo(this.source), (e) => {
      La(e) && Yv(e, this);
    }), this._active.clear(), SI(this);
  }
  /** @internal */
  eventObserved(e) {
    e.type == "change" ? e.idle ? this.advance() : (this._active.add(e.parent), this._start()) : e.type == "idle" ? this._active.delete(e.parent) : e.type == "priority" && (this.priority = Mo(this.source).reduce(
      (t, n) => Math.max(t, (hP(n) ? n.priority : 0) + 1),
      0
    ));
  }
};
function Oat(e) {
  return e.idle !== !1;
}
function OB(e) {
  return !e.size || Array.from(e).every(Oat);
}
function SI(e) {
  e.idle || (e.idle = !0, Yt(zC(e), (t) => {
    t.done = !0;
  }), Kv(e, {
    type: "idle",
    parent: e
  }));
}
var Koe = (e, ...t) => new Goe(e, t);
Os.assign({
  createStringInterpolator: Ioe,
  to: (e, t) => new Goe(e, t)
});
var Yoe = /^--/;
function Mat(e, t) {
  return t == null || typeof t == "boolean" || t === "" ? "" : typeof t == "number" && t !== 0 && !Yoe.test(e) && !(Y0.hasOwnProperty(e) && Y0[e]) ? t + "px" : ("" + t).trim();
}
var MB = {};
function kat(e, t) {
  if (!e.nodeType || !e.setAttribute)
    return !1;
  const n = e.nodeName === "filter" || e.parentNode && e.parentNode.nodeName === "filter", {
    className: r,
    style: i,
    children: o,
    scrollTop: a,
    scrollLeft: s,
    viewBox: c,
    ...l
  } = t, u = Object.values(l), d = Object.keys(l).map(
    (f) => n || e.hasAttribute(f) ? f : MB[f] || (MB[f] = f.replace(
      /([A-Z])/g,
      // Attributes are written in dash case
      (h) => "-" + h.toLowerCase()
    ))
  );
  o !== void 0 && (e.textContent = o);
  for (const f in i)
    if (i.hasOwnProperty(f)) {
      const h = Mat(f, i[f]);
      Yoe.test(f) ? e.style.setProperty(f, h) : e.style[f] = h;
    }
  d.forEach((f, h) => {
    e.setAttribute(f, u[h]);
  }), r !== void 0 && (e.className = r), a !== void 0 && (e.scrollTop = a), s !== void 0 && (e.scrollLeft = s), c !== void 0 && e.setAttribute("viewBox", c);
}
var Y0 = {
  animationIterationCount: !0,
  borderImageOutset: !0,
  borderImageSlice: !0,
  borderImageWidth: !0,
  boxFlex: !0,
  boxFlexGroup: !0,
  boxOrdinalGroup: !0,
  columnCount: !0,
  columns: !0,
  flex: !0,
  flexGrow: !0,
  flexPositive: !0,
  flexShrink: !0,
  flexNegative: !0,
  flexOrder: !0,
  gridRow: !0,
  gridRowEnd: !0,
  gridRowSpan: !0,
  gridRowStart: !0,
  gridColumn: !0,
  gridColumnEnd: !0,
  gridColumnSpan: !0,
  gridColumnStart: !0,
  fontWeight: !0,
  lineClamp: !0,
  lineHeight: !0,
  opacity: !0,
  order: !0,
  orphans: !0,
  tabSize: !0,
  widows: !0,
  zIndex: !0,
  zoom: !0,
  // SVG-related properties
  fillOpacity: !0,
  floodOpacity: !0,
  stopOpacity: !0,
  strokeDasharray: !0,
  strokeDashoffset: !0,
  strokeMiterlimit: !0,
  strokeOpacity: !0,
  strokeWidth: !0
}, Nat = (e, t) => e + t.charAt(0).toUpperCase() + t.substring(1), Dat = ["Webkit", "Ms", "Moz", "O"];
Y0 = Object.keys(Y0).reduce((e, t) => (Dat.forEach((n) => e[Nat(n, t)] = e[t]), e), Y0);
var jat = /^(matrix|translate|scale|rotate|skew)/, Lat = /^(translate)/, Fat = /^(rotate|skew)/, wI = (e, t) => He.num(e) && e !== 0 ? e + t : e, w_ = (e, t) => He.arr(e) ? e.every((n) => w_(n, t)) : He.num(e) ? e === t : parseFloat(e) === t, Vat = class extends HC {
  constructor({ x: e, y: t, z: n, ...r }) {
    const i = [], o = [];
    (e || t || n) && (i.push([e || 0, t || 0, n || 0]), o.push((a) => [
      `translate3d(${a.map((s) => wI(s, "px")).join(",")})`,
      // prettier-ignore
      w_(a, 0)
    ])), Ec(r, (a, s) => {
      if (s === "transform")
        i.push([a || ""]), o.push((c) => [c, c === ""]);
      else if (jat.test(s)) {
        if (delete r[s], He.und(a))
          return;
        const c = Lat.test(s) ? "px" : Fat.test(s) ? "deg" : "";
        i.push(Mo(a)), o.push(
          s === "rotate3d" ? ([l, u, d, f]) => [
            `rotate3d(${l},${u},${d},${wI(f, c)})`,
            w_(f, 0)
          ] : (l) => [
            `${s}(${l.map((u) => wI(u, c)).join(",")})`,
            w_(l, s.startsWith("scale") ? 1 : 0)
          ]
        );
      }
    }), i.length && (r.transform = new Bat(i, o)), super(r);
  }
}, Bat = class extends Eoe {
  constructor(e, t) {
    super(), this.inputs = e, this.transforms = t, this._value = null;
  }
  get() {
    return this._value || (this._value = this._get());
  }
  _get() {
    let e = "", t = !0;
    return Yt(this.inputs, (n, r) => {
      const i = Yo(n[0]), [o, a] = this.transforms[r](
        He.arr(i) ? i : n.map(Yo)
      );
      e += " " + o, t = t && a;
    }), t ? "none" : e;
  }
  // Start observing our inputs once we have an observer.
  observerAdded(e) {
    e == 1 && Yt(
      this.inputs,
      (t) => Yt(
        t,
        (n) => La(n) && cm(n, this)
      )
    );
  }
  // Stop observing our inputs once we have no observers.
  observerRemoved(e) {
    e == 0 && Yt(
      this.inputs,
      (t) => Yt(
        t,
        (n) => La(n) && Yv(n, this)
      )
    );
  }
  eventObserved(e) {
    e.type == "change" && (this._value = null), Kv(this, e);
  }
}, zat = [
  "a",
  "abbr",
  "address",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "bdi",
  "bdo",
  "big",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "data",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "keygen",
  "label",
  "legend",
  "li",
  "link",
  "main",
  "map",
  "mark",
  "menu",
  "menuitem",
  "meta",
  "meter",
  "nav",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "param",
  "picture",
  "pre",
  "progress",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "script",
  "section",
  "select",
  "small",
  "source",
  "span",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "u",
  "ul",
  "var",
  "video",
  "wbr",
  // SVG
  "circle",
  "clipPath",
  "defs",
  "ellipse",
  "foreignObject",
  "g",
  "image",
  "line",
  "linearGradient",
  "mask",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "radialGradient",
  "rect",
  "stop",
  "svg",
  "text",
  "tspan"
];
Os.assign({
  batchedUpdates: nO,
  createStringInterpolator: Ioe,
  colors: Not
});
var Hat = gat(zat, {
  applyAnimatedValues: kat,
  createAnimatedStyle: (e) => new Vat(e),
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getComponentProps: ({ scrollTop: e, scrollLeft: t, ...n }) => n
}), xi = Hat.animated;
function Nf() {
  return Nf = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Nf.apply(this, arguments);
}
var Uat = { pointerEvents: "none", position: "absolute", zIndex: 10, top: 0, left: 0 }, kB = function(e, t) {
  return "translate(" + e + "px, " + t + "px)";
}, Xoe = hi(function(e) {
  var t, n = e.position, r = e.anchor, i = e.children, o = vo(), a = Ls(), s = a.animate, c = a.config, l = Sae(), u = l[0], d = l[1], f = $e(!1), h = void 0, p = !1, g = d.width > 0 && d.height > 0, m = Math.round(n[0]), v = Math.round(n[1]);
  g && (r === "top" ? (m -= d.width / 2, v -= d.height + 14) : r === "right" ? (m += 14, v -= d.height / 2) : r === "bottom" ? (m -= d.width / 2, v += 14) : r === "left" ? (m -= d.width + 14, v -= d.height / 2) : r === "center" && (m -= d.width / 2, v -= d.height / 2), h = { transform: kB(m, v) }, f.current || (p = !0), f.current = [m, v]);
  var y = Il({ to: h, config: c, immediate: !s || p }), _ = Nf({}, Uat, o.tooltip.wrapper, { transform: (t = y.transform) != null ? t : kB(m, v), opacity: y.transform ? 1 : 0 });
  return A.jsx(xi.div, { ref: u, style: _, children: i });
});
Xoe.displayName = "TooltipWrapper";
var Wat = hi(function(e) {
  var t = e.size, n = t === void 0 ? 12 : t, r = e.color, i = e.style;
  return A.jsx("span", { style: Nf({ display: "block", width: n, height: n, background: r }, i === void 0 ? {} : i) });
}), qat = hi(function(e) {
  var t, n = e.id, r = e.value, i = e.format, o = e.enableChip, a = o !== void 0 && o, s = e.color, c = e.renderContent, l = vo(), u = wae(i);
  if (typeof c == "function")
    t = c();
  else {
    var d = r;
    u !== void 0 && d !== void 0 && (d = u(d)), t = A.jsxs("div", { style: l.tooltip.basic, children: [a && A.jsx(Wat, { color: s, style: l.tooltip.chip }), d !== void 0 ? A.jsxs("span", { children: [n, ": ", A.jsx("strong", { children: "" + d })] }) : n] });
  }
  return A.jsx("div", { style: l.tooltip.container, children: t });
}), Gat = { width: "100%", borderCollapse: "collapse" }, Kat = hi(function(e) {
  var t, n = e.title, r = e.rows, i = r === void 0 ? [] : r, o = e.renderContent, a = vo();
  return i.length ? (t = typeof o == "function" ? o() : A.jsxs("div", { children: [n && n, A.jsx("table", { style: Nf({}, Gat, a.tooltip.table), children: A.jsx("tbody", { children: i.map(function(s, c) {
    return A.jsx("tr", { children: s.map(function(l, u) {
      return A.jsx("td", { style: a.tooltip.tableCell, children: l }, u);
    }) }, c);
  }) }) })] }), A.jsx("div", { style: a.tooltip.container, children: t })) : null;
});
Kat.displayName = "TableTooltip";
var yP = hi(function(e) {
  var t = e.x0, n = e.x1, r = e.y0, i = e.y1, o = vo(), a = Ls(), s = a.animate, c = a.config, l = Tt(function() {
    return Nf({}, o.crosshair.line, { pointerEvents: "none" });
  }, [o.crosshair.line]), u = Il({ x1: t, x2: n, y1: r, y2: i, config: c, immediate: !s });
  return A.jsx(xi.line, Nf({}, u, { fill: "none", style: l }));
});
yP.displayName = "CrosshairLine";
var Yat = hi(function(e) {
  var t, n, r = e.width, i = e.height, o = e.type, a = e.x, s = e.y;
  return o === "cross" ? (t = { x0: a, x1: a, y0: 0, y1: i }, n = { x0: 0, x1: r, y0: s, y1: s }) : o === "top-left" ? (t = { x0: a, x1: a, y0: 0, y1: s }, n = { x0: 0, x1: a, y0: s, y1: s }) : o === "top" ? t = { x0: a, x1: a, y0: 0, y1: s } : o === "top-right" ? (t = { x0: a, x1: a, y0: 0, y1: s }, n = { x0: a, x1: r, y0: s, y1: s }) : o === "right" ? n = { x0: a, x1: r, y0: s, y1: s } : o === "bottom-right" ? (t = { x0: a, x1: a, y0: s, y1: i }, n = { x0: a, x1: r, y0: s, y1: s }) : o === "bottom" ? t = { x0: a, x1: a, y0: s, y1: i } : o === "bottom-left" ? (t = { x0: a, x1: a, y0: s, y1: i }, n = { x0: 0, x1: a, y0: s, y1: s }) : o === "left" ? n = { x0: 0, x1: a, y0: s, y1: s } : o === "x" ? t = { x0: a, x1: a, y0: 0, y1: i } : o === "y" && (n = { x0: 0, x1: r, y0: s, y1: s }), A.jsxs(A.Fragment, { children: [t && A.jsx(yP, { x0: t.x0, x1: t.x1, y0: t.y0, y1: t.y1 }), n && A.jsx(yP, { x0: n.x0, x1: n.x1, y0: n.y0, y1: n.y1 })] });
});
Yat.displayName = "Crosshair";
var Qoe = Ca({ showTooltipAt: function() {
}, showTooltipFromEvent: function() {
}, hideTooltip: function() {
} }), bP = { isVisible: !1, position: [null, null], content: null, anchor: null }, Joe = Ca(bP), Xat = function(e) {
  var t = Qe(bP), n = t[0], r = t[1], i = Wt(function(s, c, l) {
    var u = c[0], d = c[1];
    l === void 0 && (l = "top"), r({ isVisible: !0, position: [u, d], anchor: l, content: s });
  }, [r]), o = Wt(function(s, c, l) {
    l === void 0 && (l = "top");
    var u = e.current.getBoundingClientRect(), d = e.current.offsetWidth, f = d === u.width ? 1 : d / u.width, h = "touches" in c ? c.touches[0] : c, p = h.clientX, g = h.clientY, m = (p - u.left) * f, v = (g - u.top) * f;
    l !== "left" && l !== "right" || (l = m < u.width / 2 ? "right" : "left"), r({ isVisible: !0, position: [m, v], anchor: l, content: s });
  }, [e, r]), a = Wt(function() {
    r(bP);
  }, [r]);
  return { actions: Tt(function() {
    return { showTooltipAt: i, showTooltipFromEvent: o, hideTooltip: a };
  }, [i, o, a]), state: n };
}, Yk = function() {
  var e = gt(Qoe);
  if (e === void 0)
    throw new Error("useTooltip must be used within a TooltipProvider");
  return e;
}, Qat = function() {
  var e = gt(Joe);
  if (e === void 0)
    throw new Error("useTooltipState must be used within a TooltipProvider");
  return e;
}, Jat = function(e) {
  return e.isVisible;
}, Zat = function() {
  var e = Qat();
  return Jat(e) ? A.jsx(Xoe, { position: e.position, anchor: e.anchor, children: e.content }) : null;
}, est = function(e) {
  var t = e.container, n = e.children, r = Xat(t), i = r.actions, o = r.state;
  return A.jsx(Qoe.Provider, { value: i, children: A.jsx(Joe.Provider, { value: o, children: n }) });
}, tst = hC, nst = jf;
function rst(e, t, n) {
  (n !== void 0 && !nst(e[t], n) || n === void 0 && !(t in e)) && tst(e, t, n);
}
var Zoe = rst, rx = { exports: {} };
rx.exports;
(function(e, t) {
  var n = $c, r = t && !t.nodeType && t, i = r && !0 && e && !e.nodeType && e, o = i && i.exports === r, a = o ? n.Buffer : void 0, s = a ? a.allocUnsafe : void 0;
  function c(l, u) {
    if (u)
      return l.slice();
    var d = l.length, f = s ? s(d) : new l.constructor(d);
    return l.copy(f), f;
  }
  e.exports = c;
})(rx, rx.exports);
var eae = rx.exports, NB = $U;
function ist(e) {
  var t = new e.constructor(e.byteLength);
  return new NB(t).set(new NB(e)), t;
}
var Xk = ist, ost = Xk;
function ast(e, t) {
  var n = t ? ost(e.buffer) : e.buffer;
  return new e.constructor(n, e.byteOffset, e.length);
}
var tae = ast;
function sst(e, t) {
  var n = -1, r = e.length;
  for (t || (t = Array(r)); ++n < r; )
    t[n] = e[n];
  return t;
}
var nae = sst, cst = Ya, DB = Object.create, lst = function() {
  function e() {
  }
  return function(t) {
    if (!cst(t))
      return {};
    if (DB)
      return DB(t);
    e.prototype = t;
    var n = new e();
    return e.prototype = void 0, n;
  };
}(), ust = lst, dst = ust, fst = d3, hst = iy;
function gst(e) {
  return typeof e.constructor == "function" && !hst(e) ? dst(fst(e)) : {};
}
var rae = gst, pst = qu, mst = Xa;
function vst(e) {
  return mst(e) && pst(e);
}
var iae = vst;
function yst(e, t) {
  if (!(t === "constructor" && typeof e[t] == "function") && t != "__proto__")
    return e[t];
}
var oae = yst, bst = ih, _st = nm;
function Sst(e) {
  return bst(e, _st(e));
}
var wst = Sst, jB = Zoe, xst = eae, Est = tae, Cst = nae, Tst = rae, LB = ny, FB = Yi, Ist = iae, $st = ry, Ast = xx, Rst = Ya, Pst = f3, Ost = Ax, VB = oae, Mst = wst;
function kst(e, t, n, r, i, o, a) {
  var s = VB(e, n), c = VB(t, n), l = a.get(c);
  if (l) {
    jB(e, n, l);
    return;
  }
  var u = o ? o(s, c, n + "", e, t, a) : void 0, d = u === void 0;
  if (d) {
    var f = FB(c), h = !f && $st(c), p = !f && !h && Ost(c);
    u = c, f || h || p ? FB(s) ? u = s : Ist(s) ? u = Cst(s) : h ? (d = !1, u = xst(c, !0)) : p ? (d = !1, u = Est(c, !0)) : u = [] : Pst(c) || LB(c) ? (u = s, LB(s) ? u = Mst(s) : (!Rst(s) || Ast(s)) && (u = Tst(c))) : d = !1;
  }
  d && (a.set(c, u), i(u, c, r, o, a), a.delete(c)), jB(e, n, u);
}
var Nst = kst, Dst = Tx, jst = Zoe, Lst = lte, Fst = Nst, Vst = Ya, Bst = nm, zst = oae;
function aae(e, t, n, r, i) {
  e !== t && Lst(t, function(o, a) {
    if (i || (i = new Dst()), Vst(o))
      Fst(e, t, a, n, aae, r, i);
    else {
      var s = r ? r(zst(e, a), o, a + "", e, t, i) : void 0;
      s === void 0 && (s = o), jst(e, a, s);
    }
  }, Bst);
}
var Hst = aae, Ust = Hst, Wst = Qie, qst = Wst(function(e, t, n) {
  Ust(e, t, n);
}), Gst = qst;
const Kst = /* @__PURE__ */ vn(Gst);
var Yst = $te;
function Xst(e, t, n) {
  return e == null ? e : Yst(e, t, n);
}
var Qst = Xst;
const Jst = /* @__PURE__ */ vn(Qst);
var Zst = wl, ect = Yi, tct = Xa, nct = "[object String]";
function rct(e) {
  return typeof e == "string" || !ect(e) && tct(e) && Zst(e) == nct;
}
var ict = rct;
const sae = /* @__PURE__ */ vn(ict);
function oct(e) {
  var t = e == null ? 0 : e.length;
  return t ? e[t - 1] : void 0;
}
var cae = oct;
const Nt = /* @__PURE__ */ vn(cae);
function ln(e) {
  for (var t = e.length / 6 | 0, n = new Array(t), r = 0; r < t; )
    n[r] = "#" + e.slice(r * 6, ++r * 6);
  return n;
}
const lae = ln("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf"), uae = ln("7fc97fbeaed4fdc086ffff99386cb0f0027fbf5b17666666"), dae = ln("1b9e77d95f027570b3e7298a66a61ee6ab02a6761d666666"), fae = ln("a6cee31f78b4b2df8a33a02cfb9a99e31a1cfdbf6fff7f00cab2d66a3d9affff99b15928"), hae = ln("fbb4aeb3cde3ccebc5decbe4fed9a6ffffcce5d8bdfddaecf2f2f2"), gae = ln("b3e2cdfdcdaccbd5e8f4cae4e6f5c9fff2aef1e2cccccccc"), pae = ln("e41a1c377eb84daf4a984ea3ff7f00ffff33a65628f781bf999999"), mae = ln("66c2a5fc8d628da0cbe78ac3a6d854ffd92fe5c494b3b3b3"), Qk = ln("8dd3c7ffffb3bebadafb807280b1d3fdb462b3de69fccde5d9d9d9bc80bdccebc5ffed6f"), act = ln("4e79a7f28e2ce1575976b7b259a14fedc949af7aa1ff9da79c755fbab0ab"), cr = (e) => qUe(e[e.length - 1]);
var WC = new Array(3).concat(
  "d8b365f5f5f55ab4ac",
  "a6611adfc27d80cdc1018571",
  "a6611adfc27df5f5f580cdc1018571",
  "8c510ad8b365f6e8c3c7eae55ab4ac01665e",
  "8c510ad8b365f6e8c3f5f5f5c7eae55ab4ac01665e",
  "8c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e",
  "8c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e",
  "5430058c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e003c30",
  "5430058c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e003c30"
).map(ln);
const sct = cr(WC);
var qC = new Array(3).concat(
  "af8dc3f7f7f77fbf7b",
  "7b3294c2a5cfa6dba0008837",
  "7b3294c2a5cff7f7f7a6dba0008837",
  "762a83af8dc3e7d4e8d9f0d37fbf7b1b7837",
  "762a83af8dc3e7d4e8f7f7f7d9f0d37fbf7b1b7837",
  "762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b7837",
  "762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b7837",
  "40004b762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b783700441b",
  "40004b762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b783700441b"
).map(ln);
const cct = cr(qC);
var GC = new Array(3).concat(
  "e9a3c9f7f7f7a1d76a",
  "d01c8bf1b6dab8e1864dac26",
  "d01c8bf1b6daf7f7f7b8e1864dac26",
  "c51b7de9a3c9fde0efe6f5d0a1d76a4d9221",
  "c51b7de9a3c9fde0eff7f7f7e6f5d0a1d76a4d9221",
  "c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221",
  "c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221",
  "8e0152c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221276419",
  "8e0152c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221276419"
).map(ln);
const lct = cr(GC);
var KC = new Array(3).concat(
  "998ec3f7f7f7f1a340",
  "5e3c99b2abd2fdb863e66101",
  "5e3c99b2abd2f7f7f7fdb863e66101",
  "542788998ec3d8daebfee0b6f1a340b35806",
  "542788998ec3d8daebf7f7f7fee0b6f1a340b35806",
  "5427888073acb2abd2d8daebfee0b6fdb863e08214b35806",
  "5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b35806",
  "2d004b5427888073acb2abd2d8daebfee0b6fdb863e08214b358067f3b08",
  "2d004b5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b358067f3b08"
).map(ln);
const uct = cr(KC);
var YC = new Array(3).concat(
  "ef8a62f7f7f767a9cf",
  "ca0020f4a58292c5de0571b0",
  "ca0020f4a582f7f7f792c5de0571b0",
  "b2182bef8a62fddbc7d1e5f067a9cf2166ac",
  "b2182bef8a62fddbc7f7f7f7d1e5f067a9cf2166ac",
  "b2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac",
  "b2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac",
  "67001fb2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac053061",
  "67001fb2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac053061"
).map(ln);
const dct = cr(YC);
var XC = new Array(3).concat(
  "ef8a62ffffff999999",
  "ca0020f4a582bababa404040",
  "ca0020f4a582ffffffbababa404040",
  "b2182bef8a62fddbc7e0e0e09999994d4d4d",
  "b2182bef8a62fddbc7ffffffe0e0e09999994d4d4d",
  "b2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d",
  "b2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d",
  "67001fb2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d1a1a1a",
  "67001fb2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d1a1a1a"
).map(ln);
const fct = cr(XC);
var QC = new Array(3).concat(
  "fc8d59ffffbf91bfdb",
  "d7191cfdae61abd9e92c7bb6",
  "d7191cfdae61ffffbfabd9e92c7bb6",
  "d73027fc8d59fee090e0f3f891bfdb4575b4",
  "d73027fc8d59fee090ffffbfe0f3f891bfdb4575b4",
  "d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4",
  "d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4",
  "a50026d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4313695",
  "a50026d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4313695"
).map(ln);
const hct = cr(QC);
var JC = new Array(3).concat(
  "fc8d59ffffbf91cf60",
  "d7191cfdae61a6d96a1a9641",
  "d7191cfdae61ffffbfa6d96a1a9641",
  "d73027fc8d59fee08bd9ef8b91cf601a9850",
  "d73027fc8d59fee08bffffbfd9ef8b91cf601a9850",
  "d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850",
  "d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850",
  "a50026d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850006837",
  "a50026d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850006837"
).map(ln);
const gct = cr(JC);
var ZC = new Array(3).concat(
  "fc8d59ffffbf99d594",
  "d7191cfdae61abdda42b83ba",
  "d7191cfdae61ffffbfabdda42b83ba",
  "d53e4ffc8d59fee08be6f59899d5943288bd",
  "d53e4ffc8d59fee08bffffbfe6f59899d5943288bd",
  "d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd",
  "d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd",
  "9e0142d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd5e4fa2",
  "9e0142d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd5e4fa2"
).map(ln);
const pct = cr(ZC);
var e2 = new Array(3).concat(
  "e5f5f999d8c92ca25f",
  "edf8fbb2e2e266c2a4238b45",
  "edf8fbb2e2e266c2a42ca25f006d2c",
  "edf8fbccece699d8c966c2a42ca25f006d2c",
  "edf8fbccece699d8c966c2a441ae76238b45005824",
  "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45005824",
  "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45006d2c00441b"
).map(ln);
const mct = cr(e2);
var t2 = new Array(3).concat(
  "e0ecf49ebcda8856a7",
  "edf8fbb3cde38c96c688419d",
  "edf8fbb3cde38c96c68856a7810f7c",
  "edf8fbbfd3e69ebcda8c96c68856a7810f7c",
  "edf8fbbfd3e69ebcda8c96c68c6bb188419d6e016b",
  "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d6e016b",
  "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d810f7c4d004b"
).map(ln);
const vct = cr(t2);
var n2 = new Array(3).concat(
  "e0f3dba8ddb543a2ca",
  "f0f9e8bae4bc7bccc42b8cbe",
  "f0f9e8bae4bc7bccc443a2ca0868ac",
  "f0f9e8ccebc5a8ddb57bccc443a2ca0868ac",
  "f0f9e8ccebc5a8ddb57bccc44eb3d32b8cbe08589e",
  "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe08589e",
  "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe0868ac084081"
).map(ln);
const yct = cr(n2);
var r2 = new Array(3).concat(
  "fee8c8fdbb84e34a33",
  "fef0d9fdcc8afc8d59d7301f",
  "fef0d9fdcc8afc8d59e34a33b30000",
  "fef0d9fdd49efdbb84fc8d59e34a33b30000",
  "fef0d9fdd49efdbb84fc8d59ef6548d7301f990000",
  "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301f990000",
  "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301fb300007f0000"
).map(ln);
const bct = cr(r2);
var i2 = new Array(3).concat(
  "ece2f0a6bddb1c9099",
  "f6eff7bdc9e167a9cf02818a",
  "f6eff7bdc9e167a9cf1c9099016c59",
  "f6eff7d0d1e6a6bddb67a9cf1c9099016c59",
  "f6eff7d0d1e6a6bddb67a9cf3690c002818a016450",
  "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016450",
  "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016c59014636"
).map(ln);
const _ct = cr(i2);
var o2 = new Array(3).concat(
  "ece7f2a6bddb2b8cbe",
  "f1eef6bdc9e174a9cf0570b0",
  "f1eef6bdc9e174a9cf2b8cbe045a8d",
  "f1eef6d0d1e6a6bddb74a9cf2b8cbe045a8d",
  "f1eef6d0d1e6a6bddb74a9cf3690c00570b0034e7b",
  "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0034e7b",
  "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0045a8d023858"
).map(ln);
const Sct = cr(o2);
var a2 = new Array(3).concat(
  "e7e1efc994c7dd1c77",
  "f1eef6d7b5d8df65b0ce1256",
  "f1eef6d7b5d8df65b0dd1c77980043",
  "f1eef6d4b9dac994c7df65b0dd1c77980043",
  "f1eef6d4b9dac994c7df65b0e7298ace125691003f",
  "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125691003f",
  "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125698004367001f"
).map(ln);
const wct = cr(a2);
var s2 = new Array(3).concat(
  "fde0ddfa9fb5c51b8a",
  "feebe2fbb4b9f768a1ae017e",
  "feebe2fbb4b9f768a1c51b8a7a0177",
  "feebe2fcc5c0fa9fb5f768a1c51b8a7a0177",
  "feebe2fcc5c0fa9fb5f768a1dd3497ae017e7a0177",
  "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a0177",
  "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a017749006a"
).map(ln);
const xct = cr(s2);
var c2 = new Array(3).concat(
  "edf8b17fcdbb2c7fb8",
  "ffffcca1dab441b6c4225ea8",
  "ffffcca1dab441b6c42c7fb8253494",
  "ffffccc7e9b47fcdbb41b6c42c7fb8253494",
  "ffffccc7e9b47fcdbb41b6c41d91c0225ea80c2c84",
  "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea80c2c84",
  "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea8253494081d58"
).map(ln);
const Ect = cr(c2);
var l2 = new Array(3).concat(
  "f7fcb9addd8e31a354",
  "ffffccc2e69978c679238443",
  "ffffccc2e69978c67931a354006837",
  "ffffccd9f0a3addd8e78c67931a354006837",
  "ffffccd9f0a3addd8e78c67941ab5d238443005a32",
  "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443005a32",
  "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443006837004529"
).map(ln);
const Cct = cr(l2);
var u2 = new Array(3).concat(
  "fff7bcfec44fd95f0e",
  "ffffd4fed98efe9929cc4c02",
  "ffffd4fed98efe9929d95f0e993404",
  "ffffd4fee391fec44ffe9929d95f0e993404",
  "ffffd4fee391fec44ffe9929ec7014cc4c028c2d04",
  "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c028c2d04",
  "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c02993404662506"
).map(ln);
const Tct = cr(u2);
var d2 = new Array(3).concat(
  "ffeda0feb24cf03b20",
  "ffffb2fecc5cfd8d3ce31a1c",
  "ffffb2fecc5cfd8d3cf03b20bd0026",
  "ffffb2fed976feb24cfd8d3cf03b20bd0026",
  "ffffb2fed976feb24cfd8d3cfc4e2ae31a1cb10026",
  "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cb10026",
  "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cbd0026800026"
).map(ln);
const Ict = cr(d2);
var f2 = new Array(3).concat(
  "deebf79ecae13182bd",
  "eff3ffbdd7e76baed62171b5",
  "eff3ffbdd7e76baed63182bd08519c",
  "eff3ffc6dbef9ecae16baed63182bd08519c",
  "eff3ffc6dbef9ecae16baed64292c62171b5084594",
  "f7fbffdeebf7c6dbef9ecae16baed64292c62171b5084594",
  "f7fbffdeebf7c6dbef9ecae16baed64292c62171b508519c08306b"
).map(ln);
const $ct = cr(f2);
var h2 = new Array(3).concat(
  "e5f5e0a1d99b31a354",
  "edf8e9bae4b374c476238b45",
  "edf8e9bae4b374c47631a354006d2c",
  "edf8e9c7e9c0a1d99b74c47631a354006d2c",
  "edf8e9c7e9c0a1d99b74c47641ab5d238b45005a32",
  "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45005a32",
  "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45006d2c00441b"
).map(ln);
const Act = cr(h2);
var g2 = new Array(3).concat(
  "f0f0f0bdbdbd636363",
  "f7f7f7cccccc969696525252",
  "f7f7f7cccccc969696636363252525",
  "f7f7f7d9d9d9bdbdbd969696636363252525",
  "f7f7f7d9d9d9bdbdbd969696737373525252252525",
  "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525",
  "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525000000"
).map(ln);
const Rct = cr(g2);
var p2 = new Array(3).concat(
  "efedf5bcbddc756bb1",
  "f2f0f7cbc9e29e9ac86a51a3",
  "f2f0f7cbc9e29e9ac8756bb154278f",
  "f2f0f7dadaebbcbddc9e9ac8756bb154278f",
  "f2f0f7dadaebbcbddc9e9ac8807dba6a51a34a1486",
  "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a34a1486",
  "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a354278f3f007d"
).map(ln);
const Pct = cr(p2);
var m2 = new Array(3).concat(
  "fee0d2fc9272de2d26",
  "fee5d9fcae91fb6a4acb181d",
  "fee5d9fcae91fb6a4ade2d26a50f15",
  "fee5d9fcbba1fc9272fb6a4ade2d26a50f15",
  "fee5d9fcbba1fc9272fb6a4aef3b2ccb181d99000d",
  "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181d99000d",
  "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181da50f1567000d"
).map(ln);
const Oct = cr(m2);
var v2 = new Array(3).concat(
  "fee6cefdae6be6550d",
  "feeddefdbe85fd8d3cd94701",
  "feeddefdbe85fd8d3ce6550da63603",
  "feeddefdd0a2fdae6bfd8d3ce6550da63603",
  "feeddefdd0a2fdae6bfd8d3cf16913d948018c2d04",
  "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d948018c2d04",
  "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d94801a636037f2704"
).map(ln);
const Mct = cr(v2);
function kct(e) {
  return e = Math.max(0, Math.min(1, e)), "rgb(" + Math.max(0, Math.min(255, Math.round(-4.54 - e * (35.34 - e * (2381.73 - e * (6402.7 - e * (7024.72 - e * 2710.57))))))) + ", " + Math.max(0, Math.min(255, Math.round(32.49 + e * (170.73 + e * (52.82 - e * (131.46 - e * (176.58 - e * 67.37))))))) + ", " + Math.max(0, Math.min(255, Math.round(81.24 + e * (442.36 - e * (2482.43 - e * (6167.24 - e * (6614.94 - e * 2475.67))))))) + ")";
}
const Nct = _3(xc(300, 0.5, 0), xc(-240, 0.5, 1));
var Dct = _3(xc(-100, 0.75, 0.35), xc(80, 1.5, 0.8)), jct = _3(xc(260, 0.75, 0.35), xc(80, 1.5, 0.8)), O1 = xc();
function Lct(e) {
  (e < 0 || e > 1) && (e -= Math.floor(e));
  var t = Math.abs(e - 0.5);
  return O1.h = 360 * e - 100, O1.s = 1.5 - 1.5 * t, O1.l = 0.8 - 0.9 * t, O1 + "";
}
var M1 = ip(), Fct = Math.PI / 3, Vct = Math.PI * 2 / 3;
function Bct(e) {
  var t;
  return e = (0.5 - e) * Math.PI, M1.r = 255 * (t = Math.sin(e)) * t, M1.g = 255 * (t = Math.sin(e + Fct)) * t, M1.b = 255 * (t = Math.sin(e + Vct)) * t, M1 + "";
}
function zct(e) {
  return e = Math.max(0, Math.min(1, e)), "rgb(" + Math.max(0, Math.min(255, Math.round(34.61 + e * (1172.33 - e * (10793.56 - e * (33300.12 - e * (38394.49 - e * 14825.05))))))) + ", " + Math.max(0, Math.min(255, Math.round(23.31 + e * (557.33 + e * (1225.33 - e * (3574.96 - e * (1073.77 + e * 707.56))))))) + ", " + Math.max(0, Math.min(255, Math.round(27.2 + e * (3211.1 - e * (15327.97 - e * (27814 - e * (22569.18 - e * 6838.66))))))) + ")";
}
function y2(e) {
  var t = e.length;
  return function(n) {
    return e[Math.max(0, Math.min(t - 1, Math.floor(n * t)))];
  };
}
const Hct = y2(ln("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));
var Uct = y2(ln("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf")), Wct = y2(ln("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4")), qct = y2(ln("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921")), Gct = pO, Kct = Ute, Yct = Wte, Xct = Ly, Qct = Ap, Jct = mO, Zct = 200;
function elt(e, t, n, r) {
  var i = -1, o = Kct, a = !0, s = e.length, c = [], l = t.length;
  if (!s)
    return c;
  n && (t = Xct(t, Qct(n))), r ? (o = Yct, a = !1) : t.length >= Zct && (o = Jct, a = !1, t = new Gct(t));
  e:
    for (; ++i < s; ) {
      var u = e[i], d = n == null ? u : n(u);
      if (u = r || u !== 0 ? u : 0, a && d === d) {
        for (var f = l; f--; )
          if (t[f] === d)
            continue e;
        c.push(u);
      } else
        o(t, d, r) || c.push(u);
    }
  return c;
}
var tlt = elt, nlt = tlt, rlt = dC, ilt = iae, olt = rlt(function(e, t) {
  return ilt(e) ? nlt(e, t) : [];
}), alt = olt;
const vae = /* @__PURE__ */ vn(alt);
var slt = { background: "transparent", text: { fontFamily: "sans-serif", fontSize: 11, fill: "#333333", outlineWidth: 0, outlineColor: "transparent", outlineOpacity: 1 }, axis: { domain: { line: { stroke: "transparent", strokeWidth: 1 } }, ticks: { line: { stroke: "#777777", strokeWidth: 1 }, text: {} }, legend: { text: { fontSize: 12 } } }, grid: { line: { stroke: "#dddddd", strokeWidth: 1 } }, legends: { hidden: { symbol: { fill: "#333333", opacity: 0.6 }, text: { fill: "#333333", opacity: 0.6 } }, text: {}, ticks: { line: { stroke: "#777777", strokeWidth: 1 }, text: { fontSize: 10 } }, title: { text: {} } }, labels: { text: {} }, markers: { lineColor: "#000000", lineStrokeWidth: 1, text: {} }, dots: { text: {} }, tooltip: { container: { background: "white", color: "inherit", fontSize: "inherit", borderRadius: "2px", boxShadow: "0 1px 2px rgba(0, 0, 0, 0.25)", padding: "5px 9px" }, basic: { whiteSpace: "pre", display: "flex", alignItems: "center" }, chip: { marginRight: 7 }, table: {}, tableCell: { padding: "3px 5px" }, tableCellValue: { fontWeight: "bold" } }, crosshair: { line: { stroke: "#000000", strokeWidth: 1, strokeOpacity: 0.75, strokeDasharray: "6 6" } }, annotations: { text: { fontSize: 13, outlineWidth: 2, outlineColor: "#ffffff", outlineOpacity: 1 }, link: { stroke: "#000000", strokeWidth: 1, outlineWidth: 2, outlineColor: "#ffffff", outlineOpacity: 1 }, outline: { fill: "none", stroke: "#000000", strokeWidth: 2, outlineWidth: 2, outlineColor: "#ffffff", outlineOpacity: 1 }, symbol: { fill: "#000000", outlineWidth: 2, outlineColor: "#ffffff", outlineOpacity: 1 } } };
function zu() {
  return zu = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, zu.apply(this, arguments);
}
function Jk(e, t) {
  if (e == null)
    return {};
  var n, r, i = {}, o = Object.keys(e);
  for (r = 0; r < o.length; r++)
    n = o[r], t.indexOf(n) >= 0 || (i[n] = e[n]);
  return i;
}
var clt = ["axis.ticks.text", "axis.legend.text", "legends.title.text", "legends.text", "legends.ticks.text", "legends.title.text", "labels.text", "dots.text", "markers.text", "annotations.text"], llt = function(e, t) {
  return zu({}, t, e);
}, ult = function(e, t) {
  var n = Kst({}, e, t);
  return clt.forEach(function(r) {
    Jst(n, r, llt(Tf(n, r), n.text));
  }), n;
}, yae = Ca(), bae = function(e) {
  var t = e.children, n = e.animate, r = n === void 0 || n, i = e.config, o = i === void 0 ? "default" : i, a = Tt(function() {
    var s = sae(o) ? Wk[o] : o;
    return { animate: r, config: s };
  }, [r, o]);
  return A.jsx(yae.Provider, { value: a, children: t });
}, BB = { animate: ye.bool, motionConfig: ye.oneOfType([ye.oneOf(Object.keys(Wk)), ye.shape({ mass: ye.number, tension: ye.number, friction: ye.number, clamp: ye.bool, precision: ye.number, velocity: ye.number, duration: ye.number, easing: ye.func })]) };
bae.propTypes = { children: ye.node.isRequired, animate: BB.animate, config: BB.motionConfig };
var Ls = function() {
  return gt(yae);
}, dlt = function(e) {
  var t = Ls(), n = t.animate, r = t.config, i = function(s) {
    var c = $e();
    return ot(function() {
      c.current = s;
    }, [s]), c.current;
  }(e), o = Tt(function() {
    return pte(i, e);
  }, [i, e]), a = Il({ from: { value: 0 }, to: { value: 1 }, reset: !0, config: r, immediate: !n }).value;
  return Koe(a, o);
}, flt = { nivo: ["#d76445", "#f47560", "#e8c1a0", "#97e3d5", "#61cdbb", "#00b0a7"], BrBG: Nt(WC), PRGn: Nt(qC), PiYG: Nt(GC), PuOr: Nt(KC), RdBu: Nt(YC), RdGy: Nt(XC), RdYlBu: Nt(QC), RdYlGn: Nt(JC), spectral: Nt(ZC), blues: Nt(f2), greens: Nt(h2), greys: Nt(g2), oranges: Nt(v2), purples: Nt(p2), reds: Nt(m2), BuGn: Nt(e2), BuPu: Nt(t2), GnBu: Nt(n2), OrRd: Nt(r2), PuBuGn: Nt(i2), PuBu: Nt(o2), PuRd: Nt(a2), RdPu: Nt(s2), YlGnBu: Nt(c2), YlGn: Nt(l2), YlOrBr: Nt(u2), YlOrRd: Nt(d2) }, hlt = Object.keys(flt);
Nt(WC), Nt(qC), Nt(GC), Nt(KC), Nt(YC), Nt(XC), Nt(QC), Nt(JC), Nt(ZC), Nt(f2), Nt(h2), Nt(g2), Nt(v2), Nt(p2), Nt(m2), Nt(e2), Nt(t2), Nt(n2), Nt(r2), Nt(i2), Nt(o2), Nt(a2), Nt(s2), Nt(c2), Nt(l2), Nt(u2), Nt(d2);
ye.oneOfType([ye.oneOf(hlt), ye.func, ye.arrayOf(ye.string)]);
var glt = { basis: Hre, basisClosed: Wre, basisOpen: Gre, bundle: Yre, cardinal: Xre, cardinalClosed: Qre, cardinalOpen: Jre, catmullRom: eie, catmullRomClosed: nie, catmullRomOpen: iie, linear: am, linearClosed: aie, monotoneX: lie, monotoneY: uie, natural: fie, step: hie, stepAfter: pie, stepBefore: gie }, Zk = Object.keys(glt);
Zk.filter(function(e) {
  return e.endsWith("Closed");
});
vae(Zk, "bundle", "basisClosed", "basisOpen", "cardinalClosed", "cardinalOpen", "catmullRomClosed", "catmullRomOpen", "linearClosed");
vae(Zk, "bundle", "basisClosed", "basisOpen", "cardinalClosed", "cardinalOpen", "catmullRomClosed", "catmullRomOpen", "linearClosed");
ye.shape({ top: ye.number, right: ye.number, bottom: ye.number, left: ye.number }).isRequired;
var plt = ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"];
ye.oneOf(plt);
tl(Qk);
var _ae = { top: 0, right: 0, bottom: 0, left: 0 }, mlt = function(e, t, n) {
  return n === void 0 && (n = {}), Tt(function() {
    var r = zu({}, _ae, n);
    return { margin: r, innerWidth: e - r.left - r.right, innerHeight: t - r.top - r.bottom, outerWidth: e, outerHeight: t };
  }, [e, t, n.top, n.right, n.bottom, n.left]);
}, Sae = function() {
  var e = $e(null), t = Qe({ left: 0, top: 0, width: 0, height: 0 }), n = t[0], r = t[1], i = Qe(function() {
    return typeof ResizeObserver > "u" ? null : new ResizeObserver(function(o) {
      var a = o[0];
      return r(a.contentRect);
    });
  })[0];
  return ot(function() {
    return e.current && i !== null && i.observe(e.current), function() {
      i !== null && i.disconnect();
    };
  }, []), [e, n];
}, vlt = function(e) {
  return Tt(function() {
    return ult(slt, e);
  }, [e]);
}, ylt = function(e) {
  return typeof e == "function" ? e : typeof e == "string" ? e.indexOf("time:") === 0 ? SC(e.slice("5")) : Ky(e) : function(t) {
    return "" + t;
  };
}, wae = function(e) {
  return Tt(function() {
    return ylt(e);
  }, [e]);
}, xae = Ca(), blt = {}, Eae = function(e) {
  var t = e.theme, n = t === void 0 ? blt : t, r = e.children, i = vlt(n);
  return A.jsx(xae.Provider, { value: i, children: r });
};
Eae.propTypes = { children: ye.node.isRequired, theme: ye.object };
var vo = function() {
  return gt(xae);
}, _lt = ["outlineWidth", "outlineColor", "outlineOpacity"], Cae = function(e) {
  return e.outlineWidth, e.outlineColor, e.outlineOpacity, Jk(e, _lt);
}, Tae = function(e) {
  var t = e.children, n = e.condition, r = e.wrapper;
  return n ? YH(r, {}, t) : t;
};
Tae.propTypes = { children: ye.node.isRequired, condition: ye.bool.isRequired, wrapper: ye.element.isRequired };
var Slt = { position: "relative" }, Iae = function(e) {
  var t = e.children, n = e.theme, r = e.renderWrapper, i = r === void 0 || r, o = e.isInteractive, a = o === void 0 || o, s = e.animate, c = e.motionConfig, l = $e(null);
  return A.jsx(Eae, { theme: n, children: A.jsx(bae, { animate: s, config: c, children: A.jsx(est, { container: l, children: A.jsxs(Tae, { condition: i, wrapper: A.jsx("div", { style: Slt, ref: l }), children: [t, a && A.jsx(Zat, {})] }) }) }) });
};
Iae.propTypes = { children: ye.element.isRequired, isInteractive: ye.bool, renderWrapper: ye.bool, theme: ye.object, animate: ye.bool, motionConfig: ye.string };
ye.func.isRequired, ye.bool, ye.bool, ye.object.isRequired, ye.bool.isRequired, ye.string;
var $ae = function(e) {
  var t = e.children, n = Sae(), r = n[0], i = n[1], o = i.width > 0 && i.height > 0;
  return A.jsx("div", { ref: r, style: { width: "100%", height: "100%" }, children: o && t({ width: i.width, height: i.height }) });
};
$ae.propTypes = { children: ye.func.isRequired };
var wlt = ["id", "colors"], Aae = function(e) {
  var t = e.id, n = e.colors, r = Jk(e, wlt);
  return A.jsx("linearGradient", zu({ id: t, x1: 0, x2: 0, y1: 0, y2: 1 }, r, { children: n.map(function(i) {
    var o = i.offset, a = i.color, s = i.opacity;
    return A.jsx("stop", { offset: o + "%", stopColor: a, stopOpacity: s !== void 0 ? s : 1 }, o);
  }) }));
};
Aae.propTypes = { id: ye.string.isRequired, colors: ye.arrayOf(ye.shape({ offset: ye.number.isRequired, color: ye.string.isRequired, opacity: ye.number })).isRequired, gradientTransform: ye.string };
var xlt = { linearGradient: Aae }, Um = { color: "#000000", background: "#ffffff", size: 4, padding: 4, stagger: !1 }, _P = hi(function(e) {
  var t = e.id, n = e.background, r = n === void 0 ? Um.background : n, i = e.color, o = i === void 0 ? Um.color : i, a = e.size, s = a === void 0 ? Um.size : a, c = e.padding, l = c === void 0 ? Um.padding : c, u = e.stagger, d = u === void 0 ? Um.stagger : u, f = s + l, h = s / 2, p = l / 2;
  return d === !0 && (f = 2 * s + 2 * l), A.jsxs("pattern", { id: t, width: f, height: f, patternUnits: "userSpaceOnUse", children: [A.jsx("rect", { width: f, height: f, fill: r }), A.jsx("circle", { cx: p + h, cy: p + h, r: h, fill: o }), d && A.jsx("circle", { cx: 1.5 * l + s + h, cy: 1.5 * l + s + h, r: h, fill: o })] });
});
_P.displayName = "PatternDots", _P.propTypes = { id: ye.string.isRequired, color: ye.string.isRequired, background: ye.string.isRequired, size: ye.number.isRequired, padding: ye.number.isRequired, stagger: ye.bool.isRequired };
var SP = function(e) {
  return e * Math.PI / 180;
}, Elt = function(e) {
  return 180 * e / Math.PI;
}, Clt = function(e, t) {
  return { x: Math.cos(e) * t, y: Math.sin(e) * t };
}, Tlt = function(e) {
  var t = e % 360;
  return t < 0 && (t += 360), t;
}, Ilt = { svg: { align: { left: "start", center: "middle", right: "end", start: "start", middle: "middle", end: "end" }, baseline: { top: "text-before-edge", center: "central", bottom: "alphabetic" } }, canvas: { align: { left: "left", center: "center", right: "right", start: "left", middle: "center", end: "right" }, baseline: { top: "top", center: "middle", bottom: "bottom" } } }, Wm = { spacing: 5, rotation: 0, background: "#000000", color: "#ffffff", lineWidth: 2 }, wP = hi(function(e) {
  var t = e.id, n = e.spacing, r = n === void 0 ? Wm.spacing : n, i = e.rotation, o = i === void 0 ? Wm.rotation : i, a = e.background, s = a === void 0 ? Wm.background : a, c = e.color, l = c === void 0 ? Wm.color : c, u = e.lineWidth, d = u === void 0 ? Wm.lineWidth : u, f = Math.round(o) % 360, h = Math.abs(r);
  f > 180 ? f -= 360 : f > 90 ? f -= 180 : f < -180 ? f += 360 : f < -90 && (f += 180);
  var p, g = h, m = h;
  return f === 0 ? p = `
                M 0 0 L ` + g + ` 0
                M 0 ` + m + " L " + g + " " + m + `
            ` : f === 90 ? p = `
                M 0 0 L 0 ` + m + `
                M ` + g + " 0 L " + g + " " + m + `
            ` : (g = Math.abs(h / Math.sin(SP(f))), m = h / Math.sin(SP(90 - f)), p = f > 0 ? `
                    M 0 ` + -m + " L " + 2 * g + " " + m + `
                    M ` + -g + " " + -m + " L " + g + " " + m + `
                    M ` + -g + " 0 L " + g + " " + 2 * m + `
                ` : `
                    M ` + -g + " " + m + " L " + g + " " + -m + `
                    M ` + -g + " " + 2 * m + " L " + 2 * g + " " + -m + `
                    M 0 ` + 2 * m + " L " + 2 * g + ` 0
                `), A.jsxs("pattern", { id: t, width: g, height: m, patternUnits: "userSpaceOnUse", children: [A.jsx("rect", { width: g, height: m, fill: s, stroke: "rgba(255, 0, 0, 0.1)", strokeWidth: 0 }), A.jsx("path", { d: p, strokeWidth: d, stroke: l, strokeLinecap: "square" })] });
});
wP.displayName = "PatternLines", wP.propTypes = { id: ye.string.isRequired, spacing: ye.number.isRequired, rotation: ye.number.isRequired, background: ye.string.isRequired, color: ye.string.isRequired, lineWidth: ye.number.isRequired };
var qm = { color: "#000000", background: "#ffffff", size: 4, padding: 4, stagger: !1 }, xP = hi(function(e) {
  var t = e.id, n = e.color, r = n === void 0 ? qm.color : n, i = e.background, o = i === void 0 ? qm.background : i, a = e.size, s = a === void 0 ? qm.size : a, c = e.padding, l = c === void 0 ? qm.padding : c, u = e.stagger, d = u === void 0 ? qm.stagger : u, f = s + l, h = l / 2;
  return d === !0 && (f = 2 * s + 2 * l), A.jsxs("pattern", { id: t, width: f, height: f, patternUnits: "userSpaceOnUse", children: [A.jsx("rect", { width: f, height: f, fill: o }), A.jsx("rect", { x: h, y: h, width: s, height: s, fill: r }), d && A.jsx("rect", { x: 1.5 * l + s, y: 1.5 * l + s, width: s, height: s, fill: r })] });
});
xP.displayName = "PatternSquares", xP.propTypes = { id: ye.string.isRequired, color: ye.string.isRequired, background: ye.string.isRequired, size: ye.number.isRequired, padding: ye.number.isRequired, stagger: ye.bool.isRequired };
var $lt = { patternDots: _P, patternLines: wP, patternSquares: xP }, Alt = ["type"], EP = zu({}, xlt, $lt), Rae = function(e) {
  var t = e.defs;
  return !t || t.length < 1 ? null : A.jsx("defs", { "aria-hidden": !0, children: t.map(function(n) {
    var r = n.type, i = Jk(n, Alt);
    return EP[r] ? cf(EP[r], zu({ key: i.id }, i)) : null;
  }) });
};
Rae.propTypes = { defs: ye.arrayOf(ye.shape({ type: ye.oneOf(Object.keys(EP)).isRequired, id: ye.string.isRequired })) };
var Rlt = hi(Rae), Pae = function(e) {
  var t = e.width, n = e.height, r = e.margin, i = e.defs, o = e.children, a = e.role, s = e.ariaLabel, c = e.ariaLabelledBy, l = e.ariaDescribedBy, u = e.isFocusable, d = vo();
  return A.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", width: t, height: n, role: a, "aria-label": s, "aria-labelledby": c, "aria-describedby": l, focusable: u, tabIndex: u ? 0 : void 0, children: [A.jsx(Rlt, { defs: i }), A.jsx("rect", { width: t, height: n, fill: d.background }), A.jsx("g", { transform: "translate(" + r.left + "," + r.top + ")", children: o })] });
};
Pae.propTypes = { width: ye.number.isRequired, height: ye.number.isRequired, margin: ye.shape({ top: ye.number.isRequired, left: ye.number.isRequired }).isRequired, defs: ye.array, children: ye.oneOfType([ye.arrayOf(ye.node), ye.node]).isRequired, role: ye.string, isFocusable: ye.bool, ariaLabel: ye.string, ariaLabelledBy: ye.string, ariaDescribedBy: ye.string };
var Oae = function(e) {
  var t = e.size, n = e.color, r = e.borderWidth, i = e.borderColor;
  return A.jsx("circle", { r: t / 2, fill: n, stroke: i, strokeWidth: r, style: { pointerEvents: "none" } });
};
Oae.propTypes = { size: ye.number.isRequired, color: ye.string.isRequired, borderWidth: ye.number.isRequired, borderColor: ye.string.isRequired };
var Plt = hi(Oae), Mae = function(e) {
  var t = e.x, n = e.y, r = e.symbol, i = r === void 0 ? Plt : r, o = e.size, a = e.datum, s = e.color, c = e.borderWidth, l = e.borderColor, u = e.label, d = e.labelTextAnchor, f = d === void 0 ? "middle" : d, h = e.labelYOffset, p = h === void 0 ? -12 : h, g = vo(), m = Ls(), v = m.animate, y = m.config, _ = Il({ transform: "translate(" + t + ", " + n + ")", config: y, immediate: !v });
  return A.jsxs(xi.g, { transform: _.transform, style: { pointerEvents: "none" }, children: [cf(i, { size: o, color: s, datum: a, borderWidth: c, borderColor: l }), u && A.jsx("text", { textAnchor: f, y: p, style: Cae(g.dots.text), children: u })] });
};
Mae.propTypes = { x: ye.number.isRequired, y: ye.number.isRequired, datum: ye.object.isRequired, size: ye.number.isRequired, color: ye.string.isRequired, borderWidth: ye.number.isRequired, borderColor: ye.string.isRequired, symbol: ye.oneOfType([ye.func, ye.object]), label: ye.oneOfType([ye.string, ye.number]), labelTextAnchor: ye.oneOf(["start", "middle", "end"]), labelYOffset: ye.number };
hi(Mae);
var kae = function(e) {
  var t = e.width, n = e.height, r = e.axis, i = e.scale, o = e.value, a = e.lineStyle, s = e.textStyle, c = e.legend, l = e.legendPosition, u = l === void 0 ? "top-right" : l, d = e.legendOffsetX, f = d === void 0 ? 14 : d, h = e.legendOffsetY, p = h === void 0 ? 14 : h, g = e.legendOrientation, m = g === void 0 ? "horizontal" : g, v = vo(), y = 0, _ = 0, b = 0, w = 0;
  r === "y" ? (b = i(o), _ = t) : (y = i(o), w = n);
  var C = null;
  if (c) {
    var x = function(T) {
      var E = T.axis, R = T.width, I = T.height, O = T.position, P = T.offsetX, k = T.offsetY, L = T.orientation, N = 0, D = 0, z = L === "vertical" ? -90 : 0, V = "start";
      if (E === "x")
        switch (O) {
          case "top-left":
            N = -P, D = k, V = "end";
            break;
          case "top":
            D = -k, V = L === "horizontal" ? "middle" : "start";
            break;
          case "top-right":
            N = P, D = k, V = L === "horizontal" ? "start" : "end";
            break;
          case "right":
            N = P, D = I / 2, V = L === "horizontal" ? "start" : "middle";
            break;
          case "bottom-right":
            N = P, D = I - k, V = "start";
            break;
          case "bottom":
            D = I + k, V = L === "horizontal" ? "middle" : "end";
            break;
          case "bottom-left":
            D = I - k, N = -P, V = L === "horizontal" ? "end" : "start";
            break;
          case "left":
            N = -P, D = I / 2, V = L === "horizontal" ? "end" : "middle";
        }
      else
        switch (O) {
          case "top-left":
            N = P, D = -k, V = "start";
            break;
          case "top":
            N = R / 2, D = -k, V = L === "horizontal" ? "middle" : "start";
            break;
          case "top-right":
            N = R - P, D = -k, V = L === "horizontal" ? "end" : "start";
            break;
          case "right":
            N = R + P, V = L === "horizontal" ? "start" : "middle";
            break;
          case "bottom-right":
            N = R - P, D = k, V = "end";
            break;
          case "bottom":
            N = R / 2, D = k, V = L === "horizontal" ? "middle" : "end";
            break;
          case "bottom-left":
            N = P, D = k, V = L === "horizontal" ? "start" : "end";
            break;
          case "left":
            N = -P, V = L === "horizontal" ? "end" : "middle";
        }
      return { x: N, y: D, rotation: z, textAnchor: V };
    }({ axis: r, width: t, height: n, position: u, offsetX: f, offsetY: p, orientation: m });
    C = A.jsx("text", { transform: "translate(" + x.x + ", " + x.y + ") rotate(" + x.rotation + ")", textAnchor: x.textAnchor, dominantBaseline: "central", style: s, children: c });
  }
  return A.jsxs("g", { transform: "translate(" + y + ", " + b + ")", children: [A.jsx("line", { x1: 0, x2: _, y1: 0, y2: w, stroke: v.markers.lineColor, strokeWidth: v.markers.lineStrokeWidth, style: a }), C] });
};
kae.propTypes = { width: ye.number.isRequired, height: ye.number.isRequired, axis: ye.oneOf(["x", "y"]).isRequired, scale: ye.func.isRequired, value: ye.oneOfType([ye.number, ye.string, ye.instanceOf(Date)]).isRequired, lineStyle: ye.object, textStyle: ye.object, legend: ye.string, legendPosition: ye.oneOf(["top-left", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left"]), legendOffsetX: ye.number.isRequired, legendOffsetY: ye.number.isRequired, legendOrientation: ye.oneOf(["horizontal", "vertical"]).isRequired };
var Olt = hi(kae), Nae = function(e) {
  var t = e.markers, n = e.width, r = e.height, i = e.xScale, o = e.yScale;
  return t && t.length !== 0 ? t.map(function(a, s) {
    return A.jsx(Olt, zu({}, a, { width: n, height: r, scale: a.axis === "y" ? o : i }), s);
  }) : null;
};
Nae.propTypes = { width: ye.number.isRequired, height: ye.number.isRequired, xScale: ye.func.isRequired, yScale: ye.func.isRequired, markers: ye.arrayOf(ye.shape({ axis: ye.oneOf(["x", "y"]).isRequired, value: ye.oneOfType([ye.number, ye.string, ye.instanceOf(Date)]).isRequired, lineStyle: ye.object, textStyle: ye.object })) };
hi(Nae);
var Mlt = function(e) {
  return Efe(e) ? e : function(t) {
    return Tf(t, e);
  };
}, k1 = function(e) {
  return Tt(function() {
    return Mlt(e);
  }, [e]);
}, klt = function(e, t, n, r) {
  var i = n - e, o = r - t;
  return i *= i, o *= o, Math.sqrt(i + o);
}, Nlt = function(e, t) {
  var n, r = "touches" in t ? t.touches[0] : t, i = r.clientX, o = r.clientY, a = e.getBoundingClientRect(), s = (n = e.getBBox !== void 0 ? e.getBBox() : { width: e.offsetWidth || 0, height: e.offsetHeight || 0 }).width === a.width ? 1 : n.width / a.width;
  return [(i - a.left) * s, (o - a.top) * s];
}, Dlt = Pte, jlt = ute, Llt = dC, zB = fC, Flt = Llt(function(e, t) {
  if (e == null)
    return [];
  var n = t.length;
  return n > 1 && zB(e, t[0], t[1]) ? t = [] : n > 2 && zB(t[0], t[1], t[2]) && (t = [t[0]]), jlt(e, Dlt(t, 1), []);
}), Vlt = Flt;
const Blt = /* @__PURE__ */ vn(Vlt);
var $h = [function(e) {
  return e.setMilliseconds(0);
}, function(e) {
  return e.setSeconds(0);
}, function(e) {
  return e.setMinutes(0);
}, function(e) {
  return e.setHours(0);
}, function(e) {
  return e.setDate(1);
}, function(e) {
  return e.setMonth(0);
}], zlt = { millisecond: [], second: $h.slice(0, 1), minute: $h.slice(0, 2), hour: $h.slice(0, 3), day: $h.slice(0, 4), month: $h.slice(0, 5), year: $h.slice(0, 6) }, Hlt = function(e) {
  return function(t) {
    return zlt[e].forEach(function(n) {
      n(t);
    }), t;
  };
}, e4 = function(e) {
  var t = e.format, n = t === void 0 ? "native" : t, r = e.precision, i = r === void 0 ? "millisecond" : r, o = e.useUTC, a = o === void 0 || o, s = Hlt(i);
  return function(c) {
    if (c === void 0)
      return c;
    if (n === "native" || c instanceof Date)
      return s(c);
    var l = a ? qne(n) : Une(n);
    return s(l(c));
  };
}, Ult = function(e, t, n, r) {
  var i, o, a, s, c = e.min, l = c === void 0 ? 0 : c, u = e.max, d = u === void 0 ? "auto" : u, f = e.stacked, h = f !== void 0 && f, p = e.reverse, g = p !== void 0 && p, m = e.clamp, v = m !== void 0 && m, y = e.nice, _ = y !== void 0 && y;
  l === "auto" ? i = h === !0 ? (o = t.minStacked) != null ? o : 0 : t.min : i = l, d === "auto" ? a = h === !0 ? (s = t.maxStacked) != null ? s : 0 : t.max : a = d;
  var b = Yy().rangeRound(r === "x" ? [0, n] : [n, 0]).domain(g ? [a, i] : [i, a]).clamp(v);
  return _ === !0 ? b.nice() : typeof _ == "number" && b.nice(_), Wlt(b, h);
}, Wlt = function(e, t) {
  t === void 0 && (t = !1);
  var n = e;
  return n.type = "linear", n.stacked = t, n;
}, qlt = function(e, t, n) {
  var r = ane().range([0, n]).domain(t.all);
  return r.type = "point", r;
}, Glt = function(e, t, n, r) {
  var i = e.round, o = i === void 0 || i, a = vC().range(r === "x" ? [0, n] : [n, 0]).domain(t.all).round(o);
  return Klt(a);
}, Klt = function(e) {
  var t = e;
  return t.type = "band", t;
}, Ylt = function(e, t, n) {
  var r, i, o = e.format, a = o === void 0 ? "native" : o, s = e.precision, c = s === void 0 ? "millisecond" : s, l = e.min, u = l === void 0 ? "auto" : l, d = e.max, f = d === void 0 ? "auto" : d, h = e.useUTC, p = h === void 0 || h, g = e.nice, m = g !== void 0 && g, v = e4({ format: a, precision: c, useUTC: p });
  r = u === "auto" ? v(t.min) : a !== "native" ? v(u) : u, i = f === "auto" ? v(t.max) : a !== "native" ? v(f) : f;
  var y = p ? Kne() : Gne();
  y.range([0, n]), r && i && y.domain([r, i]), m === !0 ? y.nice() : typeof m != "object" && typeof m != "number" || y.nice(m);
  var _ = y;
  return _.type = "time", _.useUTC = p, _;
}, Xlt = function(e, t, n, r) {
  var i, o = e.base, a = o === void 0 ? 10 : o, s = e.min, c = s === void 0 ? "auto" : s, l = e.max, u = l === void 0 ? "auto" : l;
  if (t.all.some(function(g) {
    return g === 0;
  }))
    throw new Error("a log scale domain must not include or cross zero");
  var d, f, h = !1;
  if (t.all.filter(function(g) {
    return g != null;
  }).forEach(function(g) {
    h || (i === void 0 ? i = Math.sign(g) : Math.sign(g) !== i && (h = !0));
  }), h)
    throw new Error("a log scale domain must be strictly-positive or strictly-negative");
  d = c === "auto" ? t.min : c, f = u === "auto" ? t.max : u;
  var p = R3().domain([d, f]).rangeRound(r === "x" ? [0, n] : [n, 0]).base(a).nice();
  return p.type = "log", p;
}, Qlt = function(e, t, n, r) {
  var i, o, a = e.constant, s = a === void 0 ? 1 : a, c = e.min, l = c === void 0 ? "auto" : c, u = e.max, d = u === void 0 ? "auto" : u, f = e.reverse, h = f !== void 0 && f;
  i = l === "auto" ? t.min : l, o = d === "auto" ? t.max : d;
  var p = O3().constant(s).rangeRound(r === "x" ? [0, n] : [n, 0]).nice();
  h === !0 ? p.domain([o, i]) : p.domain([i, o]);
  var g = p;
  return g.type = "symlog", g;
};
function HB(e, t, n, r) {
  switch (e.type) {
    case "linear":
      return Ult(e, t, n, r);
    case "point":
      return qlt(e, t, n);
    case "band":
      return Glt(e, t, n, r);
    case "time":
      return Ylt(e, t, n);
    case "log":
      return Xlt(e, t, n, r);
    case "symlog":
      return Qlt(e, t, n, r);
    default:
      throw new Error("invalid scale spec");
  }
}
var Jlt = function(e, t, n, r) {
  var i = r === void 0 ? {} : r, o = i.getValue, a = o === void 0 ? function(p) {
    return p.data[t];
  } : o, s = i.setValue, c = s === void 0 ? function(p, g) {
    p.data[t] = g;
  } : s;
  if (n.type === "linear")
    e.forEach(function(p) {
      p.data.forEach(function(g) {
        var m = a(g);
        m && c(g, parseFloat(String(m)));
      });
    });
  else if (n.type === "time" && n.format !== "native") {
    var l = e4(n);
    e.forEach(function(p) {
      p.data.forEach(function(g) {
        var m = a(g);
        m && c(g, l(m));
      });
    });
  }
  var u = [];
  switch (e.forEach(function(p) {
    p.data.forEach(function(g) {
      u.push(a(g));
    });
  }), n.type) {
    case "linear":
      var d = Blt(bl(u).filter(function(p) {
        return p !== null;
      }), function(p) {
        return p;
      });
      return { all: d, min: Math.min.apply(Math, d), max: Math.max.apply(Math, d) };
    case "time":
      var f = Sk(u, function(p) {
        return p.getTime();
      }).slice(0).sort(function(p, g) {
        return g.getTime() - p.getTime();
      }).reverse();
      return { all: f, min: f[0], max: Nt(f) };
    default:
      var h = bl(u);
      return { all: h, min: h[0], max: Nt(h) };
  }
}, Dae = function(e) {
  var t = e.bandwidth();
  if (t === 0)
    return e;
  var n = t / 2;
  return e.round() && (n = Math.round(n)), function(r) {
    var i;
    return ((i = e(r)) != null ? i : 0) + n;
  };
}, jae = { millisecond: [iV, iV], second: [oV, oV], minute: [QYe, eXe], hour: [JYe, tXe], day: [fi(function(e) {
  return e.setHours(0, 0, 0, 0);
}, function(e, t) {
  return e.setDate(e.getDate() + t);
}, function(e, t) {
  return (t.getTime() - e.getTime()) / 864e5;
}, function(e) {
  return Math.floor(e.getTime() / 864e5);
}), fi(function(e) {
  return e.setUTCHours(0, 0, 0, 0);
}, function(e, t) {
  return e.setUTCDate(e.getUTCDate() + t);
}, function(e, t) {
  return (t.getTime() - e.getTime()) / 864e5;
}, function(e) {
  return Math.floor(e.getTime() / 864e5);
})], week: [Mw, kw], sunday: [Mw, kw], monday: [Bv, zv], tuesday: [Tne, Nne], wednesday: [Ine, Dne], thursday: [Rf, Pf], friday: [$ne, jne], saturday: [Ane, Lne], month: [ZYe, nXe], year: [sp, cp] }, Zlt = Object.keys(jae), eut = new RegExp("^every\\s*(\\d+)?\\s*(" + Zlt.join("|") + ")s?$", "i"), Lae = function(e, t) {
  if (Array.isArray(t))
    return t;
  if (typeof t == "string" && "useUTC" in e) {
    var n = t.match(eut);
    if (n) {
      var r = n[1], i = n[2], o = jae[i][e.useUTC ? 1 : 0];
      if (i === "day") {
        var a, s, c = e.domain(), l = c[0], u = c[1], d = new Date(u);
        return d.setDate(d.getDate() + 1), (a = (s = o.every(Number(r ?? 1))) == null ? void 0 : s.range(l, d)) != null ? a : [];
      }
      if (r === void 0)
        return e.ticks(o);
      var f = o.every(Number(r));
      if (f)
        return e.ticks(f);
    }
    throw new Error("Invalid tickValues: " + t);
  }
  if ("ticks" in e) {
    if (t === void 0)
      return e.ticks();
    if (typeof (h = t) == "number" && isFinite(h) && Math.floor(h) === h)
      return e.ticks(t);
  }
  var h;
  return e.domain();
};
function Cs() {
  return Cs = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Cs.apply(this, arguments);
}
var tut = function(e) {
  var t, n = e.axis, r = e.scale, i = e.ticksPosition, o = e.tickValues, a = e.tickSize, s = e.tickPadding, c = e.tickRotation, l = e.truncateTickAt, u = e.engine, d = u === void 0 ? "svg" : u, f = Lae(r, o), h = Ilt[d], p = "bandwidth" in r ? Dae(r) : r, g = { lineX: 0, lineY: 0 }, m = { textX: 0, textY: 0 }, v = typeof document == "object" && document.dir === "rtl", y = h.align.center, _ = h.baseline.center;
  return n === "x" ? (t = function(b) {
    var w;
    return { x: (w = p(b)) != null ? w : 0, y: 0 };
  }, g.lineY = a * (i === "after" ? 1 : -1), m.textY = (a + s) * (i === "after" ? 1 : -1), _ = i === "after" ? h.baseline.top : h.baseline.bottom, c === 0 ? y = h.align.center : i === "after" && c < 0 || i === "before" && c > 0 ? (y = h.align[v ? "left" : "right"], _ = h.baseline.center) : (i === "after" && c > 0 || i === "before" && c < 0) && (y = h.align[v ? "right" : "left"], _ = h.baseline.center)) : (t = function(b) {
    var w;
    return { x: 0, y: (w = p(b)) != null ? w : 0 };
  }, g.lineX = a * (i === "after" ? 1 : -1), m.textX = (a + s) * (i === "after" ? 1 : -1), y = i === "after" ? h.align.left : h.align.right), { ticks: f.map(function(b) {
    var w = typeof b == "string" ? function(C) {
      var x = String(C).length;
      return l && l > 0 && x > l ? "" + String(C).slice(0, l).concat("...") : "" + C;
    }(b) : b;
    return Cs({ key: b instanceof Date ? "" + b.valueOf() : "" + b, value: w }, t(b), g, m);
  }), textAlign: y, textBaseline: _ };
}, nut = function(e, t) {
  if (e === void 0 || typeof e == "function")
    return e;
  if (t.type === "time") {
    var n = SC(e);
    return function(r) {
      return n(r instanceof Date ? r : new Date(r));
    };
  }
  return Ky(e);
}, UB = function(e) {
  var t, n = e.width, r = e.height, i = e.scale, o = e.axis, a = e.values, s = (t = a, (Array.isArray(t) ? a : void 0) || Lae(i, a)), c = "bandwidth" in i ? Dae(i) : i, l = o === "x" ? s.map(function(u) {
    var d, f;
    return { key: u instanceof Date ? "" + u.valueOf() : "" + u, x1: (d = c(u)) != null ? d : 0, x2: (f = c(u)) != null ? f : 0, y1: 0, y2: r };
  }) : s.map(function(u) {
    var d, f;
    return { key: u instanceof Date ? "" + u.valueOf() : "" + u, x1: 0, x2: n, y1: (d = c(u)) != null ? d : 0, y2: (f = c(u)) != null ? f : 0 };
  });
  return l;
}, rut = hi(function(e) {
  var t, n = e.value, r = e.format, i = e.lineX, o = e.lineY, a = e.onClick, s = e.textBaseline, c = e.textAnchor, l = e.animatedProps, u = vo(), d = u.axis.ticks.line, f = u.axis.ticks.text, h = (t = r == null ? void 0 : r(n)) != null ? t : n, p = Tt(function() {
    var g = { opacity: l.opacity };
    return a ? { style: Cs({}, g, { cursor: "pointer" }), onClick: function(m) {
      return a(m, h);
    } } : { style: g };
  }, [l.opacity, a, h]);
  return A.jsxs(xi.g, Cs({ transform: l.transform }, p, { children: [A.jsx("line", { x1: 0, x2: i, y1: 0, y2: o, style: d }), f.outlineWidth > 0 && A.jsx(xi.text, { dominantBaseline: s, textAnchor: c, transform: l.textTransform, style: f, strokeWidth: 2 * f.outlineWidth, stroke: f.outlineColor, strokeLinejoin: "round", children: "" + h }), A.jsx(xi.text, { dominantBaseline: s, textAnchor: c, transform: l.textTransform, style: Cae(f), children: "" + h })] }));
}), iut = function(e) {
  var t = e.axis, n = e.scale, r = e.x, i = r === void 0 ? 0 : r, o = e.y, a = o === void 0 ? 0 : o, s = e.length, c = e.ticksPosition, l = e.tickValues, u = e.tickSize, d = u === void 0 ? 5 : u, f = e.tickPadding, h = f === void 0 ? 5 : f, p = e.tickRotation, g = p === void 0 ? 0 : p, m = e.format, v = e.renderTick, y = v === void 0 ? rut : v, _ = e.truncateTickAt, b = e.legend, w = e.legendPosition, C = w === void 0 ? "end" : w, x = e.legendOffset, T = x === void 0 ? 0 : x, E = e.onClick, R = e.ariaHidden, I = vo(), O = I.axis.legend.text, P = Tt(function() {
    return nut(m, n);
  }, [m, n]), k = tut({ axis: t, scale: n, ticksPosition: c, tickValues: l, tickSize: d, tickPadding: h, tickRotation: g, truncateTickAt: _ }), L = k.ticks, N = k.textAlign, D = k.textBaseline, z = null;
  if (b !== void 0) {
    var V, B = 0, U = 0, Q = 0;
    t === "y" ? (Q = -90, B = T, C === "start" ? (V = "start", U = s) : C === "middle" ? (V = "middle", U = s / 2) : C === "end" && (V = "end")) : (U = T, C === "start" ? V = "start" : C === "middle" ? (V = "middle", B = s / 2) : C === "end" && (V = "end", B = s)), z = A.jsxs(A.Fragment, { children: [O.outlineWidth > 0 && A.jsx("text", { transform: "translate(" + B + ", " + U + ") rotate(" + Q + ")", textAnchor: V, style: Cs({ dominantBaseline: "central" }, O), strokeWidth: 2 * O.outlineWidth, stroke: O.outlineColor, strokeLinejoin: "round", children: b }), A.jsx("text", { transform: "translate(" + B + ", " + U + ") rotate(" + Q + ")", textAnchor: V, style: Cs({ dominantBaseline: "central" }, O), children: b })] });
  }
  var Y = Ls(), q = Y.animate, X = Y.config, ne = Il({ transform: "translate(" + i + "," + a + ")", lineX2: t === "x" ? s : 0, lineY2: t === "x" ? 0 : s, config: X, immediate: !q }), Z = Wt(function(ee) {
    return { opacity: 1, transform: "translate(" + ee.x + "," + ee.y + ")", textTransform: "translate(" + ee.textX + "," + ee.textY + ") rotate(" + g + ")" };
  }, [g]), J = Wt(function(ee) {
    return { opacity: 0, transform: "translate(" + ee.x + "," + ee.y + ")", textTransform: "translate(" + ee.textX + "," + ee.textY + ") rotate(" + g + ")" };
  }, [g]), K = Kk(L, { keys: function(ee) {
    return ee.key;
  }, initial: Z, from: J, enter: Z, update: Z, leave: { opacity: 0 }, config: X, immediate: !q });
  return A.jsxs(xi.g, { transform: ne.transform, "aria-hidden": R, children: [K(function(ee, te, H, ie) {
    return $.createElement(y, Cs({ tickIndex: ie, format: P, rotate: g, textBaseline: D, textAnchor: N, truncateTickAt: _, animatedProps: ee }, te, E ? { onClick: E } : {}));
  }), A.jsx(xi.line, { style: I.axis.domain.line, x1: 0, x2: ne.lineX2, y1: 0, y2: ne.lineY2 }), z] });
}, out = hi(iut), aut = ["top", "right", "bottom", "left"], sut = hi(function(e) {
  var t = e.xScale, n = e.yScale, r = e.width, i = e.height, o = { top: e.top, right: e.right, bottom: e.bottom, left: e.left };
  return A.jsx(A.Fragment, { children: aut.map(function(a) {
    var s = o[a];
    if (!s)
      return null;
    var c = a === "top" || a === "bottom";
    return A.jsx(out, Cs({}, s, { axis: c ? "x" : "y", x: a === "right" ? r : 0, y: a === "bottom" ? i : 0, scale: c ? t : n, length: c ? r : i, ticksPosition: a === "top" || a === "left" ? "before" : "after", truncateTickAt: s.truncateTickAt }), a);
  }) });
}), cut = hi(function(e) {
  var t = e.animatedProps, n = vo();
  return A.jsx(xi.line, Cs({}, t, n.grid.line));
}), WB = hi(function(e) {
  var t = e.lines, n = Ls(), r = n.animate, i = n.config, o = Kk(t, { keys: function(a) {
    return a.key;
  }, initial: function(a) {
    return { opacity: 1, x1: a.x1, x2: a.x2, y1: a.y1, y2: a.y2 };
  }, from: function(a) {
    return { opacity: 0, x1: a.x1, x2: a.x2, y1: a.y1, y2: a.y2 };
  }, enter: function(a) {
    return { opacity: 1, x1: a.x1, x2: a.x2, y1: a.y1, y2: a.y2 };
  }, update: function(a) {
    return { opacity: 1, x1: a.x1, x2: a.x2, y1: a.y1, y2: a.y2 };
  }, leave: { opacity: 0 }, config: i, immediate: !r });
  return A.jsx("g", { children: o(function(a, s) {
    return cf(cut, Cs({}, s, { key: s.key, animatedProps: a }));
  }) });
}), lut = hi(function(e) {
  var t = e.width, n = e.height, r = e.xScale, i = e.yScale, o = e.xValues, a = e.yValues, s = Tt(function() {
    return !!r && UB({ width: t, height: n, scale: r, axis: "x", values: o });
  }, [r, o, t, n]), c = Tt(function() {
    return !!i && UB({ width: t, height: n, scale: i, axis: "y", values: a });
  }, [n, t, i, a]);
  return A.jsxs(A.Fragment, { children: [s && A.jsx(WB, { lines: s }), c && A.jsx(WB, { lines: c })] });
});
const al = 11102230246251565e-32, no = 134217729, uut = (3 + 8 * al) * al;
function xI(e, t, n, r, i) {
  let o, a, s, c, l = t[0], u = r[0], d = 0, f = 0;
  u > l == u > -l ? (o = l, l = t[++d]) : (o = u, u = r[++f]);
  let h = 0;
  if (d < e && f < n)
    for (u > l == u > -l ? (a = l + o, s = o - (a - l), l = t[++d]) : (a = u + o, s = o - (a - u), u = r[++f]), o = a, s !== 0 && (i[h++] = s); d < e && f < n; )
      u > l == u > -l ? (a = o + l, c = a - o, s = o - (a - c) + (l - c), l = t[++d]) : (a = o + u, c = a - o, s = o - (a - c) + (u - c), u = r[++f]), o = a, s !== 0 && (i[h++] = s);
  for (; d < e; )
    a = o + l, c = a - o, s = o - (a - c) + (l - c), l = t[++d], o = a, s !== 0 && (i[h++] = s);
  for (; f < n; )
    a = o + u, c = a - o, s = o - (a - c) + (u - c), u = r[++f], o = a, s !== 0 && (i[h++] = s);
  return (o !== 0 || h === 0) && (i[h++] = o), h;
}
function dut(e, t) {
  let n = t[0];
  for (let r = 1; r < e; r++)
    n += t[r];
  return n;
}
function ob(e) {
  return new Float64Array(e);
}
const fut = (3 + 16 * al) * al, hut = (2 + 12 * al) * al, gut = (9 + 64 * al) * al * al, Ah = ob(4), qB = ob(8), GB = ob(12), KB = ob(16), _o = ob(4);
function put(e, t, n, r, i, o, a) {
  let s, c, l, u, d, f, h, p, g, m, v, y, _, b, w, C, x, T;
  const E = e - i, R = n - i, I = t - o, O = r - o;
  b = E * O, f = no * E, h = f - (f - E), p = E - h, f = no * O, g = f - (f - O), m = O - g, w = p * m - (b - h * g - p * g - h * m), C = I * R, f = no * I, h = f - (f - I), p = I - h, f = no * R, g = f - (f - R), m = R - g, x = p * m - (C - h * g - p * g - h * m), v = w - x, d = w - v, Ah[0] = w - (v + d) + (d - x), y = b + v, d = y - b, _ = b - (y - d) + (v - d), v = _ - C, d = _ - v, Ah[1] = _ - (v + d) + (d - C), T = y + v, d = T - y, Ah[2] = y - (T - d) + (v - d), Ah[3] = T;
  let P = dut(4, Ah), k = hut * a;
  if (P >= k || -P >= k || (d = e - E, s = e - (E + d) + (d - i), d = n - R, l = n - (R + d) + (d - i), d = t - I, c = t - (I + d) + (d - o), d = r - O, u = r - (O + d) + (d - o), s === 0 && c === 0 && l === 0 && u === 0) || (k = gut * a + uut * Math.abs(P), P += E * u + O * s - (I * l + R * c), P >= k || -P >= k))
    return P;
  b = s * O, f = no * s, h = f - (f - s), p = s - h, f = no * O, g = f - (f - O), m = O - g, w = p * m - (b - h * g - p * g - h * m), C = c * R, f = no * c, h = f - (f - c), p = c - h, f = no * R, g = f - (f - R), m = R - g, x = p * m - (C - h * g - p * g - h * m), v = w - x, d = w - v, _o[0] = w - (v + d) + (d - x), y = b + v, d = y - b, _ = b - (y - d) + (v - d), v = _ - C, d = _ - v, _o[1] = _ - (v + d) + (d - C), T = y + v, d = T - y, _o[2] = y - (T - d) + (v - d), _o[3] = T;
  const L = xI(4, Ah, 4, _o, qB);
  b = E * u, f = no * E, h = f - (f - E), p = E - h, f = no * u, g = f - (f - u), m = u - g, w = p * m - (b - h * g - p * g - h * m), C = I * l, f = no * I, h = f - (f - I), p = I - h, f = no * l, g = f - (f - l), m = l - g, x = p * m - (C - h * g - p * g - h * m), v = w - x, d = w - v, _o[0] = w - (v + d) + (d - x), y = b + v, d = y - b, _ = b - (y - d) + (v - d), v = _ - C, d = _ - v, _o[1] = _ - (v + d) + (d - C), T = y + v, d = T - y, _o[2] = y - (T - d) + (v - d), _o[3] = T;
  const N = xI(L, qB, 4, _o, GB);
  b = s * u, f = no * s, h = f - (f - s), p = s - h, f = no * u, g = f - (f - u), m = u - g, w = p * m - (b - h * g - p * g - h * m), C = c * l, f = no * c, h = f - (f - c), p = c - h, f = no * l, g = f - (f - l), m = l - g, x = p * m - (C - h * g - p * g - h * m), v = w - x, d = w - v, _o[0] = w - (v + d) + (d - x), y = b + v, d = y - b, _ = b - (y - d) + (v - d), v = _ - C, d = _ - v, _o[1] = _ - (v + d) + (d - C), T = y + v, d = T - y, _o[2] = y - (T - d) + (v - d), _o[3] = T;
  const D = xI(N, GB, 4, _o, KB);
  return KB[D - 1];
}
function N1(e, t, n, r, i, o) {
  const a = (t - o) * (n - i), s = (e - i) * (r - o), c = a - s, l = Math.abs(a + s);
  return Math.abs(c) >= fut * l ? c : -put(e, t, n, r, i, o, l);
}
const YB = Math.pow(2, -52), D1 = new Uint32Array(512);
class ix {
  static from(t, n = _ut, r = Sut) {
    const i = t.length, o = new Float64Array(i * 2);
    for (let a = 0; a < i; a++) {
      const s = t[a];
      o[2 * a] = n(s), o[2 * a + 1] = r(s);
    }
    return new ix(o);
  }
  constructor(t) {
    const n = t.length >> 1;
    if (n > 0 && typeof t[0] != "number")
      throw new Error("Expected coords to contain numbers.");
    this.coords = t;
    const r = Math.max(2 * n - 5, 0);
    this._triangles = new Uint32Array(r * 3), this._halfedges = new Int32Array(r * 3), this._hashSize = Math.ceil(Math.sqrt(n)), this._hullPrev = new Uint32Array(n), this._hullNext = new Uint32Array(n), this._hullTri = new Uint32Array(n), this._hullHash = new Int32Array(this._hashSize), this._ids = new Uint32Array(n), this._dists = new Float64Array(n), this.update();
  }
  update() {
    const { coords: t, _hullPrev: n, _hullNext: r, _hullTri: i, _hullHash: o } = this, a = t.length >> 1;
    let s = 1 / 0, c = 1 / 0, l = -1 / 0, u = -1 / 0;
    for (let E = 0; E < a; E++) {
      const R = t[2 * E], I = t[2 * E + 1];
      R < s && (s = R), I < c && (c = I), R > l && (l = R), I > u && (u = I), this._ids[E] = E;
    }
    const d = (s + l) / 2, f = (c + u) / 2;
    let h, p, g;
    for (let E = 0, R = 1 / 0; E < a; E++) {
      const I = EI(d, f, t[2 * E], t[2 * E + 1]);
      I < R && (h = E, R = I);
    }
    const m = t[2 * h], v = t[2 * h + 1];
    for (let E = 0, R = 1 / 0; E < a; E++) {
      if (E === h)
        continue;
      const I = EI(m, v, t[2 * E], t[2 * E + 1]);
      I < R && I > 0 && (p = E, R = I);
    }
    let y = t[2 * p], _ = t[2 * p + 1], b = 1 / 0;
    for (let E = 0; E < a; E++) {
      if (E === h || E === p)
        continue;
      const R = yut(m, v, y, _, t[2 * E], t[2 * E + 1]);
      R < b && (g = E, b = R);
    }
    let w = t[2 * g], C = t[2 * g + 1];
    if (b === 1 / 0) {
      for (let I = 0; I < a; I++)
        this._dists[I] = t[2 * I] - t[0] || t[2 * I + 1] - t[1];
      eg(this._ids, this._dists, 0, a - 1);
      const E = new Uint32Array(a);
      let R = 0;
      for (let I = 0, O = -1 / 0; I < a; I++) {
        const P = this._ids[I], k = this._dists[P];
        k > O && (E[R++] = P, O = k);
      }
      this.hull = E.subarray(0, R), this.triangles = new Uint32Array(0), this.halfedges = new Uint32Array(0);
      return;
    }
    if (N1(m, v, y, _, w, C) < 0) {
      const E = p, R = y, I = _;
      p = g, y = w, _ = C, g = E, w = R, C = I;
    }
    const x = but(m, v, y, _, w, C);
    this._cx = x.x, this._cy = x.y;
    for (let E = 0; E < a; E++)
      this._dists[E] = EI(t[2 * E], t[2 * E + 1], x.x, x.y);
    eg(this._ids, this._dists, 0, a - 1), this._hullStart = h;
    let T = 3;
    r[h] = n[g] = p, r[p] = n[h] = g, r[g] = n[p] = h, i[h] = 0, i[p] = 1, i[g] = 2, o.fill(-1), o[this._hashKey(m, v)] = h, o[this._hashKey(y, _)] = p, o[this._hashKey(w, C)] = g, this.trianglesLen = 0, this._addTriangle(h, p, g, -1, -1, -1);
    for (let E = 0, R, I; E < this._ids.length; E++) {
      const O = this._ids[E], P = t[2 * O], k = t[2 * O + 1];
      if (E > 0 && Math.abs(P - R) <= YB && Math.abs(k - I) <= YB || (R = P, I = k, O === h || O === p || O === g))
        continue;
      let L = 0;
      for (let B = 0, U = this._hashKey(P, k); B < this._hashSize && (L = o[(U + B) % this._hashSize], !(L !== -1 && L !== r[L])); B++)
        ;
      L = n[L];
      let N = L, D;
      for (; D = r[N], N1(P, k, t[2 * N], t[2 * N + 1], t[2 * D], t[2 * D + 1]) >= 0; )
        if (N = D, N === L) {
          N = -1;
          break;
        }
      if (N === -1)
        continue;
      let z = this._addTriangle(N, O, r[N], -1, -1, i[N]);
      i[O] = this._legalize(z + 2), i[N] = z, T++;
      let V = r[N];
      for (; D = r[V], N1(P, k, t[2 * V], t[2 * V + 1], t[2 * D], t[2 * D + 1]) < 0; )
        z = this._addTriangle(V, O, D, i[O], -1, i[V]), i[O] = this._legalize(z + 2), r[V] = V, T--, V = D;
      if (N === L)
        for (; D = n[N], N1(P, k, t[2 * D], t[2 * D + 1], t[2 * N], t[2 * N + 1]) < 0; )
          z = this._addTriangle(D, O, N, -1, i[N], i[D]), this._legalize(z + 2), i[D] = z, r[N] = N, T--, N = D;
      this._hullStart = n[O] = N, r[N] = n[V] = O, r[O] = V, o[this._hashKey(P, k)] = O, o[this._hashKey(t[2 * N], t[2 * N + 1])] = N;
    }
    this.hull = new Uint32Array(T);
    for (let E = 0, R = this._hullStart; E < T; E++)
      this.hull[E] = R, R = r[R];
    this.triangles = this._triangles.subarray(0, this.trianglesLen), this.halfedges = this._halfedges.subarray(0, this.trianglesLen);
  }
  _hashKey(t, n) {
    return Math.floor(mut(t - this._cx, n - this._cy) * this._hashSize) % this._hashSize;
  }
  _legalize(t) {
    const { _triangles: n, _halfedges: r, coords: i } = this;
    let o = 0, a = 0;
    for (; ; ) {
      const s = r[t], c = t - t % 3;
      if (a = c + (t + 2) % 3, s === -1) {
        if (o === 0)
          break;
        t = D1[--o];
        continue;
      }
      const l = s - s % 3, u = c + (t + 1) % 3, d = l + (s + 2) % 3, f = n[a], h = n[t], p = n[u], g = n[d];
      if (vut(
        i[2 * f],
        i[2 * f + 1],
        i[2 * h],
        i[2 * h + 1],
        i[2 * p],
        i[2 * p + 1],
        i[2 * g],
        i[2 * g + 1]
      )) {
        n[t] = g, n[s] = f;
        const v = r[d];
        if (v === -1) {
          let _ = this._hullStart;
          do {
            if (this._hullTri[_] === d) {
              this._hullTri[_] = t;
              break;
            }
            _ = this._hullPrev[_];
          } while (_ !== this._hullStart);
        }
        this._link(t, v), this._link(s, r[a]), this._link(a, d);
        const y = l + (s + 1) % 3;
        o < D1.length && (D1[o++] = y);
      } else {
        if (o === 0)
          break;
        t = D1[--o];
      }
    }
    return a;
  }
  _link(t, n) {
    this._halfedges[t] = n, n !== -1 && (this._halfedges[n] = t);
  }
  // add a new triangle given vertex indices and adjacent half-edge ids
  _addTriangle(t, n, r, i, o, a) {
    const s = this.trianglesLen;
    return this._triangles[s] = t, this._triangles[s + 1] = n, this._triangles[s + 2] = r, this._link(s, i), this._link(s + 1, o), this._link(s + 2, a), this.trianglesLen += 3, s;
  }
}
function mut(e, t) {
  const n = e / (Math.abs(e) + Math.abs(t));
  return (t > 0 ? 3 - n : 1 + n) / 4;
}
function EI(e, t, n, r) {
  const i = e - n, o = t - r;
  return i * i + o * o;
}
function vut(e, t, n, r, i, o, a, s) {
  const c = e - a, l = t - s, u = n - a, d = r - s, f = i - a, h = o - s, p = c * c + l * l, g = u * u + d * d, m = f * f + h * h;
  return c * (d * m - g * h) - l * (u * m - g * f) + p * (u * h - d * f) < 0;
}
function yut(e, t, n, r, i, o) {
  const a = n - e, s = r - t, c = i - e, l = o - t, u = a * a + s * s, d = c * c + l * l, f = 0.5 / (a * l - s * c), h = (l * u - s * d) * f, p = (a * d - c * u) * f;
  return h * h + p * p;
}
function but(e, t, n, r, i, o) {
  const a = n - e, s = r - t, c = i - e, l = o - t, u = a * a + s * s, d = c * c + l * l, f = 0.5 / (a * l - s * c), h = e + (l * u - s * d) * f, p = t + (a * d - c * u) * f;
  return { x: h, y: p };
}
function eg(e, t, n, r) {
  if (r - n <= 20)
    for (let i = n + 1; i <= r; i++) {
      const o = e[i], a = t[o];
      let s = i - 1;
      for (; s >= n && t[e[s]] > a; )
        e[s + 1] = e[s--];
      e[s + 1] = o;
    }
  else {
    const i = n + r >> 1;
    let o = n + 1, a = r;
    Gm(e, i, o), t[e[n]] > t[e[r]] && Gm(e, n, r), t[e[o]] > t[e[r]] && Gm(e, o, r), t[e[n]] > t[e[o]] && Gm(e, n, o);
    const s = e[o], c = t[s];
    for (; ; ) {
      do
        o++;
      while (t[e[o]] < c);
      do
        a--;
      while (t[e[a]] > c);
      if (a < o)
        break;
      Gm(e, o, a);
    }
    e[n + 1] = e[a], e[a] = s, r - o + 1 >= a - n ? (eg(e, t, o, r), eg(e, t, n, a - 1)) : (eg(e, t, n, a - 1), eg(e, t, o, r));
  }
}
function Gm(e, t, n) {
  const r = e[t];
  e[t] = e[n], e[n] = r;
}
function _ut(e) {
  return e[0];
}
function Sut(e) {
  return e[1];
}
const XB = 1e-6;
class Wd {
  constructor() {
    this._x0 = this._y0 = // start of current subpath
    this._x1 = this._y1 = null, this._ = "";
  }
  moveTo(t, n) {
    this._ += `M${this._x0 = this._x1 = +t},${this._y0 = this._y1 = +n}`;
  }
  closePath() {
    this._x1 !== null && (this._x1 = this._x0, this._y1 = this._y0, this._ += "Z");
  }
  lineTo(t, n) {
    this._ += `L${this._x1 = +t},${this._y1 = +n}`;
  }
  arc(t, n, r) {
    t = +t, n = +n, r = +r;
    const i = t + r, o = n;
    if (r < 0)
      throw new Error("negative radius");
    this._x1 === null ? this._ += `M${i},${o}` : (Math.abs(this._x1 - i) > XB || Math.abs(this._y1 - o) > XB) && (this._ += "L" + i + "," + o), r && (this._ += `A${r},${r},0,1,1,${t - r},${n}A${r},${r},0,1,1,${this._x1 = i},${this._y1 = o}`);
  }
  rect(t, n, r, i) {
    this._ += `M${this._x0 = this._x1 = +t},${this._y0 = this._y1 = +n}h${+r}v${+i}h${-r}Z`;
  }
  value() {
    return this._ || null;
  }
}
class CP {
  constructor() {
    this._ = [];
  }
  moveTo(t, n) {
    this._.push([t, n]);
  }
  closePath() {
    this._.push(this._[0].slice());
  }
  lineTo(t, n) {
    this._.push([t, n]);
  }
  value() {
    return this._.length ? this._ : null;
  }
}
class wut {
  constructor(t, [n, r, i, o] = [0, 0, 960, 500]) {
    if (!((i = +i) >= (n = +n)) || !((o = +o) >= (r = +r)))
      throw new Error("invalid bounds");
    this.delaunay = t, this._circumcenters = new Float64Array(t.points.length * 2), this.vectors = new Float64Array(t.points.length * 2), this.xmax = i, this.xmin = n, this.ymax = o, this.ymin = r, this._init();
  }
  update() {
    return this.delaunay.update(), this._init(), this;
  }
  _init() {
    const { delaunay: { points: t, hull: n, triangles: r }, vectors: i } = this;
    let o, a;
    const s = this.circumcenters = this._circumcenters.subarray(0, r.length / 3 * 2);
    for (let g = 0, m = 0, v = r.length, y, _; g < v; g += 3, m += 2) {
      const b = r[g] * 2, w = r[g + 1] * 2, C = r[g + 2] * 2, x = t[b], T = t[b + 1], E = t[w], R = t[w + 1], I = t[C], O = t[C + 1], P = E - x, k = R - T, L = I - x, N = O - T, D = (P * N - k * L) * 2;
      if (Math.abs(D) < 1e-9) {
        if (o === void 0) {
          o = a = 0;
          for (const V of n)
            o += t[V * 2], a += t[V * 2 + 1];
          o /= n.length, a /= n.length;
        }
        const z = 1e9 * Math.sign((o - x) * N - (a - T) * L);
        y = (x + I) / 2 - z * N, _ = (T + O) / 2 + z * L;
      } else {
        const z = 1 / D, V = P * P + k * k, B = L * L + N * N;
        y = x + (N * V - k * B) * z, _ = T + (P * B - L * V) * z;
      }
      s[m] = y, s[m + 1] = _;
    }
    let c = n[n.length - 1], l, u = c * 4, d, f = t[2 * c], h, p = t[2 * c + 1];
    i.fill(0);
    for (let g = 0; g < n.length; ++g)
      c = n[g], l = u, d = f, h = p, u = c * 4, f = t[2 * c], p = t[2 * c + 1], i[l + 2] = i[u] = h - p, i[l + 3] = i[u + 1] = f - d;
  }
  render(t) {
    const n = t == null ? t = new Wd() : void 0, { delaunay: { halfedges: r, inedges: i, hull: o }, circumcenters: a, vectors: s } = this;
    if (o.length <= 1)
      return null;
    for (let u = 0, d = r.length; u < d; ++u) {
      const f = r[u];
      if (f < u)
        continue;
      const h = Math.floor(u / 3) * 2, p = Math.floor(f / 3) * 2, g = a[h], m = a[h + 1], v = a[p], y = a[p + 1];
      this._renderSegment(g, m, v, y, t);
    }
    let c, l = o[o.length - 1];
    for (let u = 0; u < o.length; ++u) {
      c = l, l = o[u];
      const d = Math.floor(i[l] / 3) * 2, f = a[d], h = a[d + 1], p = c * 4, g = this._project(f, h, s[p + 2], s[p + 3]);
      g && this._renderSegment(f, h, g[0], g[1], t);
    }
    return n && n.value();
  }
  renderBounds(t) {
    const n = t == null ? t = new Wd() : void 0;
    return t.rect(this.xmin, this.ymin, this.xmax - this.xmin, this.ymax - this.ymin), n && n.value();
  }
  renderCell(t, n) {
    const r = n == null ? n = new Wd() : void 0, i = this._clip(t);
    if (i === null || !i.length)
      return;
    n.moveTo(i[0], i[1]);
    let o = i.length;
    for (; i[0] === i[o - 2] && i[1] === i[o - 1] && o > 1; )
      o -= 2;
    for (let a = 2; a < o; a += 2)
      (i[a] !== i[a - 2] || i[a + 1] !== i[a - 1]) && n.lineTo(i[a], i[a + 1]);
    return n.closePath(), r && r.value();
  }
  *cellPolygons() {
    const { delaunay: { points: t } } = this;
    for (let n = 0, r = t.length / 2; n < r; ++n) {
      const i = this.cellPolygon(n);
      i && (i.index = n, yield i);
    }
  }
  cellPolygon(t) {
    const n = new CP();
    return this.renderCell(t, n), n.value();
  }
  _renderSegment(t, n, r, i, o) {
    let a;
    const s = this._regioncode(t, n), c = this._regioncode(r, i);
    s === 0 && c === 0 ? (o.moveTo(t, n), o.lineTo(r, i)) : (a = this._clipSegment(t, n, r, i, s, c)) && (o.moveTo(a[0], a[1]), o.lineTo(a[2], a[3]));
  }
  contains(t, n, r) {
    return n = +n, n !== n || (r = +r, r !== r) ? !1 : this.delaunay._step(t, n, r) === t;
  }
  *neighbors(t) {
    const n = this._clip(t);
    if (n)
      for (const r of this.delaunay.neighbors(t)) {
        const i = this._clip(r);
        if (i) {
          e:
            for (let o = 0, a = n.length; o < a; o += 2)
              for (let s = 0, c = i.length; s < c; s += 2)
                if (n[o] === i[s] && n[o + 1] === i[s + 1] && n[(o + 2) % a] === i[(s + c - 2) % c] && n[(o + 3) % a] === i[(s + c - 1) % c]) {
                  yield r;
                  break e;
                }
        }
      }
  }
  _cell(t) {
    const { circumcenters: n, delaunay: { inedges: r, halfedges: i, triangles: o } } = this, a = r[t];
    if (a === -1)
      return null;
    const s = [];
    let c = a;
    do {
      const l = Math.floor(c / 3);
      if (s.push(n[l * 2], n[l * 2 + 1]), c = c % 3 === 2 ? c - 2 : c + 1, o[c] !== t)
        break;
      c = i[c];
    } while (c !== a && c !== -1);
    return s;
  }
  _clip(t) {
    if (t === 0 && this.delaunay.hull.length === 1)
      return [this.xmax, this.ymin, this.xmax, this.ymax, this.xmin, this.ymax, this.xmin, this.ymin];
    const n = this._cell(t);
    if (n === null)
      return null;
    const { vectors: r } = this, i = t * 4;
    return this._simplify(r[i] || r[i + 1] ? this._clipInfinite(t, n, r[i], r[i + 1], r[i + 2], r[i + 3]) : this._clipFinite(t, n));
  }
  _clipFinite(t, n) {
    const r = n.length;
    let i = null, o, a, s = n[r - 2], c = n[r - 1], l, u = this._regioncode(s, c), d, f = 0;
    for (let h = 0; h < r; h += 2)
      if (o = s, a = c, s = n[h], c = n[h + 1], l = u, u = this._regioncode(s, c), l === 0 && u === 0)
        d = f, f = 0, i ? i.push(s, c) : i = [s, c];
      else {
        let p, g, m, v, y;
        if (l === 0) {
          if ((p = this._clipSegment(o, a, s, c, l, u)) === null)
            continue;
          [g, m, v, y] = p;
        } else {
          if ((p = this._clipSegment(s, c, o, a, u, l)) === null)
            continue;
          [v, y, g, m] = p, d = f, f = this._edgecode(g, m), d && f && this._edge(t, d, f, i, i.length), i ? i.push(g, m) : i = [g, m];
        }
        d = f, f = this._edgecode(v, y), d && f && this._edge(t, d, f, i, i.length), i ? i.push(v, y) : i = [v, y];
      }
    if (i)
      d = f, f = this._edgecode(i[0], i[1]), d && f && this._edge(t, d, f, i, i.length);
    else if (this.contains(t, (this.xmin + this.xmax) / 2, (this.ymin + this.ymax) / 2))
      return [this.xmax, this.ymin, this.xmax, this.ymax, this.xmin, this.ymax, this.xmin, this.ymin];
    return i;
  }
  _clipSegment(t, n, r, i, o, a) {
    const s = o < a;
    for (s && ([t, n, r, i, o, a] = [r, i, t, n, a, o]); ; ) {
      if (o === 0 && a === 0)
        return s ? [r, i, t, n] : [t, n, r, i];
      if (o & a)
        return null;
      let c, l, u = o || a;
      u & 8 ? (c = t + (r - t) * (this.ymax - n) / (i - n), l = this.ymax) : u & 4 ? (c = t + (r - t) * (this.ymin - n) / (i - n), l = this.ymin) : u & 2 ? (l = n + (i - n) * (this.xmax - t) / (r - t), c = this.xmax) : (l = n + (i - n) * (this.xmin - t) / (r - t), c = this.xmin), o ? (t = c, n = l, o = this._regioncode(t, n)) : (r = c, i = l, a = this._regioncode(r, i));
    }
  }
  _clipInfinite(t, n, r, i, o, a) {
    let s = Array.from(n), c;
    if ((c = this._project(s[0], s[1], r, i)) && s.unshift(c[0], c[1]), (c = this._project(s[s.length - 2], s[s.length - 1], o, a)) && s.push(c[0], c[1]), s = this._clipFinite(t, s))
      for (let l = 0, u = s.length, d, f = this._edgecode(s[u - 2], s[u - 1]); l < u; l += 2)
        d = f, f = this._edgecode(s[l], s[l + 1]), d && f && (l = this._edge(t, d, f, s, l), u = s.length);
    else
      this.contains(t, (this.xmin + this.xmax) / 2, (this.ymin + this.ymax) / 2) && (s = [this.xmin, this.ymin, this.xmax, this.ymin, this.xmax, this.ymax, this.xmin, this.ymax]);
    return s;
  }
  _edge(t, n, r, i, o) {
    for (; n !== r; ) {
      let a, s;
      switch (n) {
        case 5:
          n = 4;
          continue;
        case 4:
          n = 6, a = this.xmax, s = this.ymin;
          break;
        case 6:
          n = 2;
          continue;
        case 2:
          n = 10, a = this.xmax, s = this.ymax;
          break;
        case 10:
          n = 8;
          continue;
        case 8:
          n = 9, a = this.xmin, s = this.ymax;
          break;
        case 9:
          n = 1;
          continue;
        case 1:
          n = 5, a = this.xmin, s = this.ymin;
          break;
      }
      (i[o] !== a || i[o + 1] !== s) && this.contains(t, a, s) && (i.splice(o, 0, a, s), o += 2);
    }
    return o;
  }
  _project(t, n, r, i) {
    let o = 1 / 0, a, s, c;
    if (i < 0) {
      if (n <= this.ymin)
        return null;
      (a = (this.ymin - n) / i) < o && (c = this.ymin, s = t + (o = a) * r);
    } else if (i > 0) {
      if (n >= this.ymax)
        return null;
      (a = (this.ymax - n) / i) < o && (c = this.ymax, s = t + (o = a) * r);
    }
    if (r > 0) {
      if (t >= this.xmax)
        return null;
      (a = (this.xmax - t) / r) < o && (s = this.xmax, c = n + (o = a) * i);
    } else if (r < 0) {
      if (t <= this.xmin)
        return null;
      (a = (this.xmin - t) / r) < o && (s = this.xmin, c = n + (o = a) * i);
    }
    return [s, c];
  }
  _edgecode(t, n) {
    return (t === this.xmin ? 1 : t === this.xmax ? 2 : 0) | (n === this.ymin ? 4 : n === this.ymax ? 8 : 0);
  }
  _regioncode(t, n) {
    return (t < this.xmin ? 1 : t > this.xmax ? 2 : 0) | (n < this.ymin ? 4 : n > this.ymax ? 8 : 0);
  }
  _simplify(t) {
    if (t && t.length > 4) {
      for (let n = 0; n < t.length; n += 2) {
        const r = (n + 2) % t.length, i = (n + 4) % t.length;
        (t[n] === t[r] && t[r] === t[i] || t[n + 1] === t[r + 1] && t[r + 1] === t[i + 1]) && (t.splice(r, 2), n -= 2);
      }
      t.length || (t = null);
    }
    return t;
  }
}
const xut = 2 * Math.PI, Rh = Math.pow;
function Eut(e) {
  return e[0];
}
function Cut(e) {
  return e[1];
}
function Tut(e) {
  const { triangles: t, coords: n } = e;
  for (let r = 0; r < t.length; r += 3) {
    const i = 2 * t[r], o = 2 * t[r + 1], a = 2 * t[r + 2];
    if ((n[a] - n[i]) * (n[o + 1] - n[i + 1]) - (n[o] - n[i]) * (n[a + 1] - n[i + 1]) > 1e-10)
      return !1;
  }
  return !0;
}
function Iut(e, t, n) {
  return [e + Math.sin(e + t) * n, t + Math.cos(e - t) * n];
}
class t4 {
  static from(t, n = Eut, r = Cut, i) {
    return new t4("length" in t ? $ut(t, n, r, i) : Float64Array.from(Aut(t, n, r, i)));
  }
  constructor(t) {
    this._delaunator = new ix(t), this.inedges = new Int32Array(t.length / 2), this._hullIndex = new Int32Array(t.length / 2), this.points = this._delaunator.coords, this._init();
  }
  update() {
    return this._delaunator.update(), this._init(), this;
  }
  _init() {
    const t = this._delaunator, n = this.points;
    if (t.hull && t.hull.length > 2 && Tut(t)) {
      this.collinear = Int32Array.from({ length: n.length / 2 }, (f, h) => h).sort((f, h) => n[2 * f] - n[2 * h] || n[2 * f + 1] - n[2 * h + 1]);
      const c = this.collinear[0], l = this.collinear[this.collinear.length - 1], u = [n[2 * c], n[2 * c + 1], n[2 * l], n[2 * l + 1]], d = 1e-8 * Math.hypot(u[3] - u[1], u[2] - u[0]);
      for (let f = 0, h = n.length / 2; f < h; ++f) {
        const p = Iut(n[2 * f], n[2 * f + 1], d);
        n[2 * f] = p[0], n[2 * f + 1] = p[1];
      }
      this._delaunator = new ix(n);
    } else
      delete this.collinear;
    const r = this.halfedges = this._delaunator.halfedges, i = this.hull = this._delaunator.hull, o = this.triangles = this._delaunator.triangles, a = this.inedges.fill(-1), s = this._hullIndex.fill(-1);
    for (let c = 0, l = r.length; c < l; ++c) {
      const u = o[c % 3 === 2 ? c - 2 : c + 1];
      (r[c] === -1 || a[u] === -1) && (a[u] = c);
    }
    for (let c = 0, l = i.length; c < l; ++c)
      s[i[c]] = c;
    i.length <= 2 && i.length > 0 && (this.triangles = new Int32Array(3).fill(-1), this.halfedges = new Int32Array(3).fill(-1), this.triangles[0] = i[0], a[i[0]] = 1, i.length === 2 && (a[i[1]] = 0, this.triangles[1] = i[1], this.triangles[2] = i[1]));
  }
  voronoi(t) {
    return new wut(this, t);
  }
  *neighbors(t) {
    const { inedges: n, hull: r, _hullIndex: i, halfedges: o, triangles: a, collinear: s } = this;
    if (s) {
      const d = s.indexOf(t);
      d > 0 && (yield s[d - 1]), d < s.length - 1 && (yield s[d + 1]);
      return;
    }
    const c = n[t];
    if (c === -1)
      return;
    let l = c, u = -1;
    do {
      if (yield u = a[l], l = l % 3 === 2 ? l - 2 : l + 1, a[l] !== t)
        return;
      if (l = o[l], l === -1) {
        const d = r[(i[t] + 1) % r.length];
        d !== u && (yield d);
        return;
      }
    } while (l !== c);
  }
  find(t, n, r = 0) {
    if (t = +t, t !== t || (n = +n, n !== n))
      return -1;
    const i = r;
    let o;
    for (; (o = this._step(r, t, n)) >= 0 && o !== r && o !== i; )
      r = o;
    return o;
  }
  _step(t, n, r) {
    const { inedges: i, hull: o, _hullIndex: a, halfedges: s, triangles: c, points: l } = this;
    if (i[t] === -1 || !l.length)
      return (t + 1) % (l.length >> 1);
    let u = t, d = Rh(n - l[t * 2], 2) + Rh(r - l[t * 2 + 1], 2);
    const f = i[t];
    let h = f;
    do {
      let p = c[h];
      const g = Rh(n - l[p * 2], 2) + Rh(r - l[p * 2 + 1], 2);
      if (g < d && (d = g, u = p), h = h % 3 === 2 ? h - 2 : h + 1, c[h] !== t)
        break;
      if (h = s[h], h === -1) {
        if (h = o[(a[t] + 1) % o.length], h !== p && Rh(n - l[h * 2], 2) + Rh(r - l[h * 2 + 1], 2) < d)
          return h;
        break;
      }
    } while (h !== f);
    return u;
  }
  render(t) {
    const n = t == null ? t = new Wd() : void 0, { points: r, halfedges: i, triangles: o } = this;
    for (let a = 0, s = i.length; a < s; ++a) {
      const c = i[a];
      if (c < a)
        continue;
      const l = o[a] * 2, u = o[c] * 2;
      t.moveTo(r[l], r[l + 1]), t.lineTo(r[u], r[u + 1]);
    }
    return this.renderHull(t), n && n.value();
  }
  renderPoints(t, n) {
    n === void 0 && (!t || typeof t.moveTo != "function") && (n = t, t = null), n = n == null ? 2 : +n;
    const r = t == null ? t = new Wd() : void 0, { points: i } = this;
    for (let o = 0, a = i.length; o < a; o += 2) {
      const s = i[o], c = i[o + 1];
      t.moveTo(s + n, c), t.arc(s, c, n, 0, xut);
    }
    return r && r.value();
  }
  renderHull(t) {
    const n = t == null ? t = new Wd() : void 0, { hull: r, points: i } = this, o = r[0] * 2, a = r.length;
    t.moveTo(i[o], i[o + 1]);
    for (let s = 1; s < a; ++s) {
      const c = 2 * r[s];
      t.lineTo(i[c], i[c + 1]);
    }
    return t.closePath(), n && n.value();
  }
  hullPolygon() {
    const t = new CP();
    return this.renderHull(t), t.value();
  }
  renderTriangle(t, n) {
    const r = n == null ? n = new Wd() : void 0, { points: i, triangles: o } = this, a = o[t *= 3] * 2, s = o[t + 1] * 2, c = o[t + 2] * 2;
    return n.moveTo(i[a], i[a + 1]), n.lineTo(i[s], i[s + 1]), n.lineTo(i[c], i[c + 1]), n.closePath(), r && r.value();
  }
  *trianglePolygons() {
    const { triangles: t } = this;
    for (let n = 0, r = t.length / 3; n < r; ++n)
      yield this.trianglePolygon(n);
  }
  trianglePolygon(t) {
    const n = new CP();
    return this.renderTriangle(t, n), n.value();
  }
}
function $ut(e, t, n, r) {
  const i = e.length, o = new Float64Array(i * 2);
  for (let a = 0; a < i; ++a) {
    const s = e[a];
    o[a * 2] = t.call(r, s, a, e), o[a * 2 + 1] = n.call(r, s, a, e);
  }
  return o;
}
function* Aut(e, t, n, r) {
  let i = 0;
  for (const o of e)
    yield t.call(r, o, i, e), yield n.call(r, o, i, e), ++i;
}
var n4 = function(e) {
  return [e.x, e.y];
}, ab = _ae, Fae = "cursor", Vae = "top", Rut = function(e) {
  var t = e.points, n = e.getNodePosition, r = n === void 0 ? n4 : n, i = e.margin, o = i === void 0 ? ab : i;
  return t.map(function(a) {
    var s = r(a), c = s[0], l = s[1];
    return [c + o.left, l + o.top];
  });
}, Put = function(e) {
  var t = e.points, n = e.width, r = e.height, i = e.margin, o = i === void 0 ? ab : i, a = e.debug, s = t4.from(t), c = a ? s.voronoi([0, 0, o.left + n + o.right, o.top + r + o.bottom]) : void 0;
  return { points: t, delaunay: s, voronoi: c };
}, Out = function(e) {
  var t = e.points, n = e.getNodePosition, r = n === void 0 ? n4 : n, i = e.width, o = e.height, a = e.margin, s = a === void 0 ? ab : a, c = e.debug;
  return Tt(function() {
    return Put({ points: Rut({ points: t, margin: s, getNodePosition: r }), width: i, height: o, margin: s, debug: c });
  }, [t, i, o, s, c]);
}, Mut = function(e) {
  var t = e.elementRef, n = e.nodes, r = e.getNodePosition, i = r === void 0 ? n4 : r, o = e.delaunay, a = e.setCurrent, s = e.margin, c = s === void 0 ? ab : s, l = e.detectionRadius, u = l === void 0 ? 1 / 0 : l, d = e.isInteractive, f = d === void 0 || d, h = e.onMouseEnter, p = e.onMouseMove, g = e.onMouseLeave, m = e.onClick, v = e.onTouchStart, y = e.onTouchMove, _ = e.onTouchEnd, b = e.enableTouchCrosshair, w = b !== void 0 && b, C = e.tooltip, x = e.tooltipPosition, T = x === void 0 ? Fae : x, E = e.tooltipAnchor, R = E === void 0 ? Vae : E, I = Qe(null), O = I[0], P = I[1], k = $e(null);
  ot(function() {
    k.current = O;
  }, [k, O]);
  var L = Wt(function(J) {
    if (!t.current)
      return null;
    var K = Nlt(t.current, J), ee = K[0], te = K[1], H = o.find(ee, te), ie = H !== void 0 ? n[H] : null;
    if (ie && u !== 1 / 0) {
      var W = i(ie), se = W[0], le = W[1];
      klt(ee, te, se + c.left, le + c.top) > u && (H = null, ie = null);
    }
    return H === null || ie === null ? null : [H, ie];
  }, [t, o, n, i, c, u]), N = Yk(), D = N.showTooltipAt, z = N.showTooltipFromEvent, V = N.hideTooltip, B = Tt(function() {
    if (C)
      return T === "cursor" ? function(J, K) {
        z(C(J), K, R);
      } : function(J) {
        var K = i(J), ee = K[0], te = K[1];
        D(C(J), [ee + c.left, te + c.top], R);
      };
  }, [D, z, C, T, R, i, c]), U = Wt(function(J) {
    var K = L(J);
    if (P(K), a == null || a(K ? K[1] : null), K) {
      var ee = K[1];
      B == null || B(ee, J), h == null || h(K[1], J);
    }
  }, [L, P, a, B, h]), Q = Wt(function(J) {
    var K = L(J);
    if (P(K), K) {
      var ee = K[0], te = K[1];
      if (a == null || a(te), B == null || B(te, J), k.current) {
        var H = k.current, ie = H[0], W = H[1];
        ee !== ie ? g == null || g(W, J) : p == null || p(te, J);
      } else
        h == null || h(te, J);
    } else
      a == null || a(null), V == null || V(), k.current && (g == null || g(k.current[1], J));
  }, [L, P, k, h, p, g, B, V]), Y = Wt(function(J) {
    P(null), a == null || a(null), V(), g && k.current && g(k.current[1], J);
  }, [P, a, k, V, g]), q = Wt(function(J) {
    var K = L(J);
    P(K), K && (m == null || m(K[1], J));
  }, [L, P, m]), X = Wt(function(J) {
    var K = L(J);
    w && (P(K), a == null || a(K ? K[1] : null)), K && (v == null || v(K[1], J));
  }, [L, P, a, w, v]), ne = Wt(function(J) {
    var K = L(J);
    w && (P(K), a == null || a(K ? K[1] : null)), K && (y == null || y(K[1], J));
  }, [L, P, a, w, y]), Z = Wt(function(J) {
    w && (P(null), a == null || a(null)), _ && k.current && _(k.current[1], J);
  }, [w, P, a, _, k]);
  return { current: O, handleMouseEnter: f ? U : void 0, handleMouseMove: f ? Q : void 0, handleMouseLeave: f ? Y : void 0, handleClick: f ? q : void 0, handleTouchStart: f ? X : void 0, handleTouchMove: f ? ne : void 0, handleTouchEnd: f ? Z : void 0 };
}, kut = function(e) {
  var t = e.nodes, n = e.width, r = e.height, i = e.margin, o = i === void 0 ? ab : i, a = e.getNodePosition, s = e.setCurrent, c = e.onMouseEnter, l = e.onMouseMove, u = e.onMouseLeave, d = e.onClick, f = e.onTouchStart, h = e.onTouchMove, p = e.onTouchEnd, g = e.enableTouchCrosshair, m = g !== void 0 && g, v = e.detectionRadius, y = v === void 0 ? 1 / 0 : v, _ = e.tooltip, b = e.tooltipPosition, w = b === void 0 ? Fae : b, C = e.tooltipAnchor, x = C === void 0 ? Vae : C, T = e.debug, E = $e(null), R = Out({ points: t, getNodePosition: a, width: n, height: r, margin: o, debug: T }), I = R.delaunay, O = R.voronoi, P = Mut({ elementRef: E, nodes: t, delaunay: I, margin: o, detectionRadius: y, setCurrent: s, onMouseEnter: c, onMouseMove: l, onMouseLeave: u, onClick: d, onTouchStart: f, onTouchMove: h, onTouchEnd: p, enableTouchCrosshair: m, tooltip: _, tooltipPosition: w, tooltipAnchor: x }), k = P.current, L = P.handleMouseEnter, N = P.handleMouseMove, D = P.handleMouseLeave, z = P.handleClick, V = P.handleTouchStart, B = P.handleTouchMove, U = P.handleTouchEnd, Q = Tt(function() {
    if (T && O)
      return O.render();
  }, [T, O]);
  return A.jsxs("g", { ref: E, transform: "translate(" + -o.left + "," + -o.top + ")", children: [T && O && A.jsxs(A.Fragment, { children: [A.jsx("path", { d: Q, stroke: "red", strokeWidth: 1, opacity: 0.75 }), y < 1 / 0 && A.jsx("path", { stroke: "red", strokeWidth: 0.35, fill: "none", d: I.renderPoints(void 0, y) }), k && A.jsx("path", { fill: "pink", opacity: 0.35, d: O.renderCell(k[0]) })] }), A.jsx("rect", { "data-ref": "mesh-interceptor", width: o.left + n + o.right, height: o.top + r + o.bottom, fill: "red", opacity: 0, style: { cursor: "auto" }, onMouseEnter: L, onMouseMove: N, onMouseLeave: D, onTouchStart: V, onTouchMove: B, onTouchEnd: U, onClick: z })] });
};
function ox() {
  return ox = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ox.apply(this, arguments);
}
function QB(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function Nut(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n)
    return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = function(i, o) {
    if (i) {
      if (typeof i == "string")
        return QB(i, o);
      var a = Object.prototype.toString.call(i).slice(8, -1);
      return a === "Object" && i.constructor && (a = i.constructor.name), a === "Map" || a === "Set" ? Array.from(i) : a === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a) ? QB(i, o) : void 0;
    }
  }(e)) || t && e && typeof e.length == "number") {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var Bae = { nivo: ["#e8c1a0", "#f47560", "#f1e15b", "#e8a838", "#61cdbb", "#97e3d5"], category10: lae, accent: uae, dark2: dae, paired: fae, pastel1: hae, pastel2: gae, set1: pae, set2: mae, set3: Qk, tableau10: act }, Dut = Object.keys(Bae), zae = { brown_blueGreen: WC, purpleRed_green: qC, pink_yellowGreen: GC, purple_orange: KC, red_blue: YC, red_grey: XC, red_yellow_blue: QC, red_yellow_green: JC, spectral: ZC }, jut = Object.keys(zae), Lut = { brown_blueGreen: sct, purpleRed_green: cct, pink_yellowGreen: lct, purple_orange: uct, red_blue: dct, red_grey: fct, red_yellow_blue: hct, red_yellow_green: gct, spectral: pct }, Hae = { blues: f2, greens: h2, greys: g2, oranges: v2, purples: p2, reds: m2, blue_green: e2, blue_purple: t2, green_blue: n2, orange_red: r2, purple_blue_green: i2, purple_blue: o2, purple_red: a2, red_purple: s2, yellow_green_blue: c2, yellow_green: l2, yellow_orange_brown: u2, yellow_orange_red: d2 }, Fut = Object.keys(Hae), Vut = { blues: $ct, greens: Act, greys: Rct, oranges: Mct, purples: Pct, reds: Oct, turbo: zct, viridis: Hct, inferno: Wct, magma: Uct, plasma: qct, cividis: kct, warm: Dct, cool: jct, cubehelixDefault: Nct, blue_green: mct, blue_purple: vct, green_blue: yct, orange_red: bct, purple_blue_green: _ct, purple_blue: Sct, purple_red: wct, red_purple: xct, yellow_green_blue: Ect, yellow_green: Cct, yellow_orange_brown: Tct, yellow_orange_red: Ict }, CI = ox({}, Bae, zae, Hae), But = function(e) {
  return Dut.includes(e);
}, zut = function(e) {
  return jut.includes(e);
}, Hut = function(e) {
  return Fut.includes(e);
}, Uut = { rainbow: Lct, sinebow: Bct };
ox({}, Lut, Vut, Uut);
var Wut = function(e, t) {
  if (typeof e == "function")
    return e;
  if (ni(e)) {
    if (function(c) {
      return c.theme !== void 0;
    }(e)) {
      if (t === void 0)
        throw new Error("Unable to use color from theme as no theme was provided");
      var n = Tf(t, e.theme);
      if (n === void 0)
        throw new Error("Color from theme is undefined at path: '" + e.theme + "'");
      return function() {
        return n;
      };
    }
    if (function(c) {
      return c.from !== void 0;
    }(e)) {
      var r = function(c) {
        return Tf(c, e.from);
      };
      if (Array.isArray(e.modifiers)) {
        for (var i, o = [], a = function() {
          var c = i.value, l = c[0], u = c[1];
          if (l === "brighter")
            o.push(function(d) {
              return d.brighter(u);
            });
          else if (l === "darker")
            o.push(function(d) {
              return d.darker(u);
            });
          else {
            if (l !== "opacity")
              throw new Error("Invalid color modifier: '" + l + "', must be one of: 'brighter', 'darker', 'opacity'");
            o.push(function(d) {
              return d.opacity = u, d;
            });
          }
        }, s = Nut(e.modifiers); !(i = s()).done; )
          a();
        return o.length === 0 ? r : function(c) {
          return o.reduce(function(l, u) {
            return u(l);
          }, ip(r(c))).toString();
        };
      }
      return r;
    }
    throw new Error("Invalid color spec, you should either specify 'theme' or 'from' when using a config object");
  }
  return function() {
    return e;
  };
}, qut = function(e, t) {
  return Tt(function() {
    return Wut(e, t);
  }, [e, t]);
};
ye.oneOfType([ye.string, ye.func, ye.shape({ theme: ye.string.isRequired }), ye.shape({ from: ye.string.isRequired, modifiers: ye.arrayOf(ye.array) })]);
var Gut = function(e, t) {
  if (typeof e == "function")
    return e;
  var n = typeof t == "function" ? t : function(d) {
    return Tf(d, t);
  };
  if (Array.isArray(e)) {
    var r = tl(e), i = function(d) {
      return r(n(d));
    };
    return i.scale = r, i;
  }
  if (ni(e)) {
    if (function(d) {
      return d.datum !== void 0;
    }(e))
      return function(d) {
        return Tf(d, e.datum);
      };
    if (function(d) {
      return d.scheme !== void 0;
    }(e)) {
      if (But(e.scheme)) {
        var o = tl(CI[e.scheme]), a = function(d) {
          return o(n(d));
        };
        return a.scale = o, a;
      }
      if (zut(e.scheme)) {
        if (e.size !== void 0 && (e.size < 3 || e.size > 11))
          throw new Error("Invalid size '" + e.size + "' for diverging color scheme '" + e.scheme + "', must be between 3~11");
        var s = tl(CI[e.scheme][e.size || 11]), c = function(d) {
          return s(n(d));
        };
        return c.scale = s, c;
      }
      if (Hut(e.scheme)) {
        if (e.size !== void 0 && (e.size < 3 || e.size > 9))
          throw new Error("Invalid size '" + e.size + "' for sequential color scheme '" + e.scheme + "', must be between 3~9");
        var l = tl(CI[e.scheme][e.size || 9]), u = function(d) {
          return l(n(d));
        };
        return u.scale = l, u;
      }
    }
    throw new Error("Invalid colors, when using an object, you should either pass a 'datum' or a 'scheme' property");
  }
  return function() {
    return e;
  };
}, Kut = function(e, t) {
  return Tt(function() {
    return Gut(e, t);
  }, [e, t]);
}, Yut = p3;
function Xut(e, t) {
  var n = [];
  return Yut(e, function(r, i, o) {
    t(r, i, o) && n.push(r);
  }), n;
}
var Qut = Xut, Jut = RU, Zut = Qut, edt = em, tdt = Yi;
function ndt(e, t) {
  var n = tdt(e) ? Jut : Zut;
  return n(e, edt(t));
}
var rdt = ndt;
const idt = /* @__PURE__ */ vn(rdt);
var odt = wl, adt = Xa, sdt = "[object Number]";
function cdt(e) {
  return typeof e == "number" || adt(e) && odt(e) == sdt;
}
var ldt = cdt;
const TP = /* @__PURE__ */ vn(ldt);
function udt(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length; ++n < r && t(e[n], n, e) !== !1; )
    ;
  return e;
}
var ddt = udt, fdt = ih, hdt = Rp;
function gdt(e, t) {
  return e && fdt(t, hdt(t), e);
}
var pdt = gdt, mdt = ih, vdt = nm;
function ydt(e, t) {
  return e && mdt(t, vdt(t), e);
}
var bdt = ydt, _dt = ih, Sdt = bO;
function wdt(e, t) {
  return _dt(e, Sdt(e), t);
}
var xdt = wdt, Edt = ih, Cdt = Bte;
function Tdt(e, t) {
  return Edt(e, Cdt(e), t);
}
var Idt = Tdt, $dt = Object.prototype, Adt = $dt.hasOwnProperty;
function Rdt(e) {
  var t = e.length, n = new e.constructor(t);
  return t && typeof e[0] == "string" && Adt.call(e, "index") && (n.index = e.index, n.input = e.input), n;
}
var Pdt = Rdt, Odt = Xk;
function Mdt(e, t) {
  var n = t ? Odt(e.buffer) : e.buffer;
  return new e.constructor(n, e.byteOffset, e.byteLength);
}
var kdt = Mdt, Ndt = /\w*$/;
function Ddt(e) {
  var t = new e.constructor(e.source, Ndt.exec(e));
  return t.lastIndex = e.lastIndex, t;
}
var jdt = Ddt, JB = Cp, ZB = JB ? JB.prototype : void 0, ez = ZB ? ZB.valueOf : void 0;
function Ldt(e) {
  return ez ? Object(ez.call(e)) : {};
}
var Fdt = Ldt, Vdt = Xk, Bdt = kdt, zdt = jdt, Hdt = Fdt, Udt = tae, Wdt = "[object Boolean]", qdt = "[object Date]", Gdt = "[object Map]", Kdt = "[object Number]", Ydt = "[object RegExp]", Xdt = "[object Set]", Qdt = "[object String]", Jdt = "[object Symbol]", Zdt = "[object ArrayBuffer]", eft = "[object DataView]", tft = "[object Float32Array]", nft = "[object Float64Array]", rft = "[object Int8Array]", ift = "[object Int16Array]", oft = "[object Int32Array]", aft = "[object Uint8Array]", sft = "[object Uint8ClampedArray]", cft = "[object Uint16Array]", lft = "[object Uint32Array]";
function uft(e, t, n) {
  var r = e.constructor;
  switch (t) {
    case Zdt:
      return Vdt(e);
    case Wdt:
    case qdt:
      return new r(+e);
    case eft:
      return Bdt(e, n);
    case tft:
    case nft:
    case rft:
    case ift:
    case oft:
    case aft:
    case sft:
    case cft:
    case lft:
      return Udt(e, n);
    case Gdt:
      return new r();
    case Kdt:
    case Qdt:
      return new r(e);
    case Ydt:
      return zdt(e);
    case Xdt:
      return new r();
    case Jdt:
      return Hdt(e);
  }
}
var dft = uft, fft = oy, hft = Xa, gft = "[object Map]";
function pft(e) {
  return hft(e) && fft(e) == gft;
}
var mft = pft, vft = mft, yft = Ap, tz = $x, nz = tz && tz.isMap, bft = nz ? yft(nz) : vft, _ft = bft, Sft = oy, wft = Xa, xft = "[object Set]";
function Eft(e) {
  return wft(e) && Sft(e) == xft;
}
var Cft = Eft, Tft = Cft, Ift = Ap, rz = $x, iz = rz && rz.isSet, $ft = iz ? Ift(iz) : Tft, Aft = $ft, Rft = Tx, Pft = ddt, Oft = gC, Mft = pdt, kft = bdt, Nft = eae, Dft = nae, jft = xdt, Lft = Idt, Fft = DU, Vft = x3, Bft = oy, zft = Pdt, Hft = dft, Uft = rae, Wft = Yi, qft = ry, Gft = _ft, Kft = Ya, Yft = Aft, Xft = Rp, Qft = nm, Jft = 1, Zft = 2, eht = 4, Uae = "[object Arguments]", tht = "[object Array]", nht = "[object Boolean]", rht = "[object Date]", iht = "[object Error]", Wae = "[object Function]", oht = "[object GeneratorFunction]", aht = "[object Map]", sht = "[object Number]", qae = "[object Object]", cht = "[object RegExp]", lht = "[object Set]", uht = "[object String]", dht = "[object Symbol]", fht = "[object WeakMap]", hht = "[object ArrayBuffer]", ght = "[object DataView]", pht = "[object Float32Array]", mht = "[object Float64Array]", vht = "[object Int8Array]", yht = "[object Int16Array]", bht = "[object Int32Array]", _ht = "[object Uint8Array]", Sht = "[object Uint8ClampedArray]", wht = "[object Uint16Array]", xht = "[object Uint32Array]", dr = {};
dr[Uae] = dr[tht] = dr[hht] = dr[ght] = dr[nht] = dr[rht] = dr[pht] = dr[mht] = dr[vht] = dr[yht] = dr[bht] = dr[aht] = dr[sht] = dr[qae] = dr[cht] = dr[lht] = dr[uht] = dr[dht] = dr[_ht] = dr[Sht] = dr[wht] = dr[xht] = !0;
dr[iht] = dr[Wae] = dr[fht] = !1;
function x_(e, t, n, r, i, o) {
  var a, s = t & Jft, c = t & Zft, l = t & eht;
  if (n && (a = i ? n(e, r, i, o) : n(e)), a !== void 0)
    return a;
  if (!Kft(e))
    return e;
  var u = Wft(e);
  if (u) {
    if (a = zft(e), !s)
      return Dft(e, a);
  } else {
    var d = Bft(e), f = d == Wae || d == oht;
    if (qft(e))
      return Nft(e, s);
    if (d == qae || d == Uae || f && !i) {
      if (a = c || f ? {} : Uft(e), !s)
        return c ? Lft(e, kft(a, e)) : jft(e, Mft(a, e));
    } else {
      if (!dr[d])
        return i ? e : {};
      a = Hft(e, d, s);
    }
  }
  o || (o = new Rft());
  var h = o.get(e);
  if (h)
    return h;
  o.set(e, a), Yft(e) ? e.forEach(function(m) {
    a.add(x_(m, t, n, m, e, o));
  }) : Gft(e) && e.forEach(function(m, v) {
    a.set(v, x_(m, t, n, v, e, o));
  });
  var p = l ? c ? Vft : Fft : c ? Qft : Xft, g = u ? void 0 : p(e);
  return Pft(g || e, function(m, v) {
    g && (v = m, m = e[v]), Oft(a, v, x_(m, t, n, v, e, o));
  }), a;
}
var Eht = x_;
function Cht(e, t, n) {
  var r = -1, i = e.length;
  t < 0 && (t = -t > i ? 0 : i + t), n = n > i ? i : n, n < 0 && (n += i), i = t > n ? 0 : n - t >>> 0, t >>>= 0;
  for (var o = Array(i); ++r < i; )
    o[r] = e[r + t];
  return o;
}
var Tht = Cht, Iht = Vy, $ht = Tht;
function Aht(e, t) {
  return t.length < 2 ? e : Iht(e, $ht(t, 0, -1));
}
var Rht = Aht, Pht = Qp, Oht = cae, Mht = Rht, kht = Jp;
function Nht(e, t) {
  return t = Pht(t, e), e = Mht(e, t), e == null || delete e[kht(Oht(t))];
}
var Dht = Nht, jht = f3;
function Lht(e) {
  return jht(e) ? void 0 : e;
}
var Fht = Lht, Vht = Ly, Bht = Eht, zht = Dht, Hht = Qp, Uht = ih, Wht = Fht, qht = Ote, Ght = x3, Kht = 1, Yht = 2, Xht = 4, Qht = qht(function(e, t) {
  var n = {};
  if (e == null)
    return n;
  var r = !1;
  t = Vht(t, function(o) {
    return o = Hht(o, e), r || (r = o.length > 1), o;
  }), Uht(e, Ght(e), n), r && (n = Bht(n, Kht | Yht | Xht, Wht));
  for (var i = t.length; i--; )
    zht(n, t[i]);
  return n;
}), Jht = Qht;
const Gae = /* @__PURE__ */ vn(Jht);
function Hu() {
  return Hu = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Hu.apply(this, arguments);
}
var IP = { dotSize: 4, noteWidth: 120, noteTextOffset: 8, animate: !0 }, Zht = function(e) {
  var t = typeof e;
  return ZP(e) || t === "string" || t === "function" || t === "object";
}, r4 = function(e) {
  return e.type === "circle";
}, egt = function(e) {
  return e.type === "dot";
}, i4 = function(e) {
  return e.type === "rect";
}, tgt = function(e) {
  var t = e.data, n = e.annotations, r = e.getPosition, i = e.getDimensions;
  return n.reduce(function(o, a) {
    var s = a.offset || 0;
    return [].concat(o, idt(t, a.match).map(function(c) {
      var l = r(c), u = i(c);
      return (r4(a) || i4(a)) && (u.size = u.size + 2 * s, u.width = u.width + 2 * s, u.height = u.height + 2 * s), Hu({}, Gae(a, ["match", "offset"]), l, u, { size: a.size || u.size, datum: c });
    }));
  }, []);
}, ngt = function(e, t, n, r) {
  var i = Math.atan2(r - t, n - e);
  return Tlt(Elt(i));
}, rgt = function(e) {
  var t, n, r = e.x, i = e.y, o = e.noteX, a = e.noteY, s = e.noteWidth, c = s === void 0 ? IP.noteWidth : s, l = e.noteTextOffset, u = l === void 0 ? IP.noteTextOffset : l;
  if (TP(o))
    t = r + o;
  else {
    if (o.abs === void 0)
      throw new Error("noteX should be either a number or an object containing an 'abs' property");
    t = o.abs;
  }
  if (TP(a))
    n = i + a;
  else {
    if (a.abs === void 0)
      throw new Error("noteY should be either a number or an object containing an 'abs' property");
    n = a.abs;
  }
  var d = r, f = i, h = ngt(r, i, t, n);
  if (r4(e)) {
    var p = Clt(SP(h), e.size / 2);
    d += p.x, f += p.y;
  }
  if (i4(e)) {
    var g = Math.round((h + 90) / 45) % 8;
    g === 0 && (f -= e.height / 2), g === 1 && (d += e.width / 2, f -= e.height / 2), g === 2 && (d += e.width / 2), g === 3 && (d += e.width / 2, f += e.height / 2), g === 4 && (f += e.height / 2), g === 5 && (d -= e.width / 2, f += e.height / 2), g === 6 && (d -= e.width / 2), g === 7 && (d -= e.width / 2, f -= e.height / 2);
  }
  var m = t, v = t;
  return (h + 90) % 360 > 180 ? (m -= c, v -= c) : v += c, { points: [[d, f], [t, n], [v, n]], text: [m, n - u], angle: h + 90 };
}, igt = function(e) {
  var t = e.data, n = e.annotations, r = e.getPosition, i = e.getDimensions;
  return Tt(function() {
    return tgt({ data: t, annotations: n, getPosition: r, getDimensions: i });
  }, [t, n, r, i]);
}, ogt = function(e) {
  return Tt(function() {
    return rgt(e);
  }, [e]);
}, agt = function(e) {
  var t = e.datum, n = e.x, r = e.y, i = e.note, o = vo(), a = Ls(), s = a.animate, c = a.config, l = Il({ x: n, y: r, config: c, immediate: !s });
  return typeof i == "function" ? cf(i, { x: n, y: r, datum: t }) : A.jsxs(A.Fragment, { children: [o.annotations.text.outlineWidth > 0 && A.jsx(xi.text, { x: l.x, y: l.y, style: Hu({}, o.annotations.text, { strokeLinejoin: "round", strokeWidth: 2 * o.annotations.text.outlineWidth, stroke: o.annotations.text.outlineColor }), children: i }), A.jsx(xi.text, { x: l.x, y: l.y, style: Gae(o.annotations.text, ["outlineWidth", "outlineColor"]), children: i })] });
}, oz = function(e) {
  var t = e.points, n = e.isOutline, r = n !== void 0 && n, i = vo(), o = Tt(function() {
    var c = t[0];
    return t.slice(1).reduce(function(l, u) {
      return l + " L" + u[0] + "," + u[1];
    }, "M" + c[0] + "," + c[1]);
  }, [t]), a = dlt(o);
  if (r && i.annotations.link.outlineWidth <= 0)
    return null;
  var s = Hu({}, i.annotations.link);
  return r && (s.strokeLinecap = "square", s.strokeWidth = i.annotations.link.strokeWidth + 2 * i.annotations.link.outlineWidth, s.stroke = i.annotations.link.outlineColor, s.opacity = i.annotations.link.outlineOpacity), A.jsx(xi.path, { fill: "none", d: a, style: s });
}, sgt = function(e) {
  var t = e.x, n = e.y, r = e.size, i = vo(), o = Ls(), a = o.animate, s = o.config, c = Il({ x: t, y: n, radius: r / 2, config: s, immediate: !a });
  return A.jsxs(A.Fragment, { children: [i.annotations.outline.outlineWidth > 0 && A.jsx(xi.circle, { cx: c.x, cy: c.y, r: c.radius, style: Hu({}, i.annotations.outline, { fill: "none", strokeWidth: i.annotations.outline.strokeWidth + 2 * i.annotations.outline.outlineWidth, stroke: i.annotations.outline.outlineColor, opacity: i.annotations.outline.outlineOpacity }) }), A.jsx(xi.circle, { cx: c.x, cy: c.y, r: c.radius, style: i.annotations.outline })] });
}, cgt = function(e) {
  var t = e.x, n = e.y, r = e.size, i = r === void 0 ? IP.dotSize : r, o = vo(), a = Ls(), s = a.animate, c = a.config, l = Il({ x: t, y: n, radius: i / 2, config: c, immediate: !s });
  return A.jsxs(A.Fragment, { children: [o.annotations.outline.outlineWidth > 0 && A.jsx(xi.circle, { cx: l.x, cy: l.y, r: l.radius, style: Hu({}, o.annotations.outline, { fill: "none", strokeWidth: 2 * o.annotations.outline.outlineWidth, stroke: o.annotations.outline.outlineColor, opacity: o.annotations.outline.outlineOpacity }) }), A.jsx(xi.circle, { cx: l.x, cy: l.y, r: l.radius, style: o.annotations.symbol })] });
}, lgt = function(e) {
  var t = e.x, n = e.y, r = e.width, i = e.height, o = e.borderRadius, a = o === void 0 ? 6 : o, s = vo(), c = Ls(), l = c.animate, u = c.config, d = Il({ x: t - r / 2, y: n - i / 2, width: r, height: i, config: u, immediate: !l });
  return A.jsxs(A.Fragment, { children: [s.annotations.outline.outlineWidth > 0 && A.jsx(xi.rect, { x: d.x, y: d.y, rx: a, ry: a, width: d.width, height: d.height, style: Hu({}, s.annotations.outline, { fill: "none", strokeWidth: s.annotations.outline.strokeWidth + 2 * s.annotations.outline.outlineWidth, stroke: s.annotations.outline.outlineColor, opacity: s.annotations.outline.outlineOpacity }) }), A.jsx(xi.rect, { x: d.x, y: d.y, rx: a, ry: a, width: d.width, height: d.height, style: s.annotations.outline })] });
}, ugt = function(e) {
  var t = e.datum, n = e.x, r = e.y, i = e.note, o = ogt(e);
  if (!Zht(i))
    throw new Error("note should be a valid react element");
  return A.jsxs(A.Fragment, { children: [A.jsx(oz, { points: o.points, isOutline: !0 }), r4(e) && A.jsx(sgt, { x: n, y: r, size: e.size }), egt(e) && A.jsx(cgt, { x: n, y: r, size: e.size }), i4(e) && A.jsx(lgt, { x: n, y: r, width: e.width, height: e.height, borderRadius: e.borderRadius }), A.jsx(oz, { points: o.points }), A.jsx(agt, { datum: t, x: o.text[0], y: o.text[1], note: i })] });
};
function dgt(e) {
  const t = +this._x.call(null, e), n = +this._y.call(null, e);
  return Kae(this.cover(t, n), t, n, e);
}
function Kae(e, t, n, r) {
  if (isNaN(t) || isNaN(n))
    return e;
  var i, o = e._root, a = { data: r }, s = e._x0, c = e._y0, l = e._x1, u = e._y1, d, f, h, p, g, m, v, y;
  if (!o)
    return e._root = a, e;
  for (; o.length; )
    if ((g = t >= (d = (s + l) / 2)) ? s = d : l = d, (m = n >= (f = (c + u) / 2)) ? c = f : u = f, i = o, !(o = o[v = m << 1 | g]))
      return i[v] = a, e;
  if (h = +e._x.call(null, o.data), p = +e._y.call(null, o.data), t === h && n === p)
    return a.next = o, i ? i[v] = a : e._root = a, e;
  do
    i = i ? i[v] = new Array(4) : e._root = new Array(4), (g = t >= (d = (s + l) / 2)) ? s = d : l = d, (m = n >= (f = (c + u) / 2)) ? c = f : u = f;
  while ((v = m << 1 | g) === (y = (p >= f) << 1 | h >= d));
  return i[y] = o, i[v] = a, e;
}
function fgt(e) {
  var t, n, r = e.length, i, o, a = new Array(r), s = new Array(r), c = 1 / 0, l = 1 / 0, u = -1 / 0, d = -1 / 0;
  for (n = 0; n < r; ++n)
    isNaN(i = +this._x.call(null, t = e[n])) || isNaN(o = +this._y.call(null, t)) || (a[n] = i, s[n] = o, i < c && (c = i), i > u && (u = i), o < l && (l = o), o > d && (d = o));
  if (c > u || l > d)
    return this;
  for (this.cover(c, l).cover(u, d), n = 0; n < r; ++n)
    Kae(this, a[n], s[n], e[n]);
  return this;
}
function hgt(e, t) {
  if (isNaN(e = +e) || isNaN(t = +t))
    return this;
  var n = this._x0, r = this._y0, i = this._x1, o = this._y1;
  if (isNaN(n))
    i = (n = Math.floor(e)) + 1, o = (r = Math.floor(t)) + 1;
  else {
    for (var a = i - n || 1, s = this._root, c, l; n > e || e >= i || r > t || t >= o; )
      switch (l = (t < r) << 1 | e < n, c = new Array(4), c[l] = s, s = c, a *= 2, l) {
        case 0:
          i = n + a, o = r + a;
          break;
        case 1:
          n = i - a, o = r + a;
          break;
        case 2:
          i = n + a, r = o - a;
          break;
        case 3:
          n = i - a, r = o - a;
          break;
      }
    this._root && this._root.length && (this._root = s);
  }
  return this._x0 = n, this._y0 = r, this._x1 = i, this._y1 = o, this;
}
function ggt() {
  var e = [];
  return this.visit(function(t) {
    if (!t.length)
      do
        e.push(t.data);
      while (t = t.next);
  }), e;
}
function pgt(e) {
  return arguments.length ? this.cover(+e[0][0], +e[0][1]).cover(+e[1][0], +e[1][1]) : isNaN(this._x0) ? void 0 : [[this._x0, this._y0], [this._x1, this._y1]];
}
function Ro(e, t, n, r, i) {
  this.node = e, this.x0 = t, this.y0 = n, this.x1 = r, this.y1 = i;
}
function mgt(e, t, n) {
  var r, i = this._x0, o = this._y0, a, s, c, l, u = this._x1, d = this._y1, f = [], h = this._root, p, g;
  for (h && f.push(new Ro(h, i, o, u, d)), n == null ? n = 1 / 0 : (i = e - n, o = t - n, u = e + n, d = t + n, n *= n); p = f.pop(); )
    if (!(!(h = p.node) || (a = p.x0) > u || (s = p.y0) > d || (c = p.x1) < i || (l = p.y1) < o))
      if (h.length) {
        var m = (a + c) / 2, v = (s + l) / 2;
        f.push(
          new Ro(h[3], m, v, c, l),
          new Ro(h[2], a, v, m, l),
          new Ro(h[1], m, s, c, v),
          new Ro(h[0], a, s, m, v)
        ), (g = (t >= v) << 1 | e >= m) && (p = f[f.length - 1], f[f.length - 1] = f[f.length - 1 - g], f[f.length - 1 - g] = p);
      } else {
        var y = e - +this._x.call(null, h.data), _ = t - +this._y.call(null, h.data), b = y * y + _ * _;
        if (b < n) {
          var w = Math.sqrt(n = b);
          i = e - w, o = t - w, u = e + w, d = t + w, r = h.data;
        }
      }
  return r;
}
function vgt(e) {
  if (isNaN(u = +this._x.call(null, e)) || isNaN(d = +this._y.call(null, e)))
    return this;
  var t, n = this._root, r, i, o, a = this._x0, s = this._y0, c = this._x1, l = this._y1, u, d, f, h, p, g, m, v;
  if (!n)
    return this;
  if (n.length)
    for (; ; ) {
      if ((p = u >= (f = (a + c) / 2)) ? a = f : c = f, (g = d >= (h = (s + l) / 2)) ? s = h : l = h, t = n, !(n = n[m = g << 1 | p]))
        return this;
      if (!n.length)
        break;
      (t[m + 1 & 3] || t[m + 2 & 3] || t[m + 3 & 3]) && (r = t, v = m);
    }
  for (; n.data !== e; )
    if (i = n, !(n = n.next))
      return this;
  return (o = n.next) && delete n.next, i ? (o ? i.next = o : delete i.next, this) : t ? (o ? t[m] = o : delete t[m], (n = t[0] || t[1] || t[2] || t[3]) && n === (t[3] || t[2] || t[1] || t[0]) && !n.length && (r ? r[v] = n : this._root = n), this) : (this._root = o, this);
}
function ygt(e) {
  for (var t = 0, n = e.length; t < n; ++t)
    this.remove(e[t]);
  return this;
}
function bgt() {
  return this._root;
}
function _gt() {
  var e = 0;
  return this.visit(function(t) {
    if (!t.length)
      do
        ++e;
      while (t = t.next);
  }), e;
}
function Sgt(e) {
  var t = [], n, r = this._root, i, o, a, s, c;
  for (r && t.push(new Ro(r, this._x0, this._y0, this._x1, this._y1)); n = t.pop(); )
    if (!e(r = n.node, o = n.x0, a = n.y0, s = n.x1, c = n.y1) && r.length) {
      var l = (o + s) / 2, u = (a + c) / 2;
      (i = r[3]) && t.push(new Ro(i, l, u, s, c)), (i = r[2]) && t.push(new Ro(i, o, u, l, c)), (i = r[1]) && t.push(new Ro(i, l, a, s, u)), (i = r[0]) && t.push(new Ro(i, o, a, l, u));
    }
  return this;
}
function wgt(e) {
  var t = [], n = [], r;
  for (this._root && t.push(new Ro(this._root, this._x0, this._y0, this._x1, this._y1)); r = t.pop(); ) {
    var i = r.node;
    if (i.length) {
      var o, a = r.x0, s = r.y0, c = r.x1, l = r.y1, u = (a + c) / 2, d = (s + l) / 2;
      (o = i[0]) && t.push(new Ro(o, a, s, u, d)), (o = i[1]) && t.push(new Ro(o, u, s, c, d)), (o = i[2]) && t.push(new Ro(o, a, d, u, l)), (o = i[3]) && t.push(new Ro(o, u, d, c, l));
    }
    n.push(r);
  }
  for (; r = n.pop(); )
    e(r.node, r.x0, r.y0, r.x1, r.y1);
  return this;
}
function xgt(e) {
  return e[0];
}
function Egt(e) {
  return arguments.length ? (this._x = e, this) : this._x;
}
function Cgt(e) {
  return e[1];
}
function Tgt(e) {
  return arguments.length ? (this._y = e, this) : this._y;
}
function Yae(e, t, n) {
  var r = new o4(t ?? xgt, n ?? Cgt, NaN, NaN, NaN, NaN);
  return e == null ? r : r.addAll(e);
}
function o4(e, t, n, r, i, o) {
  this._x = e, this._y = t, this._x0 = n, this._y0 = r, this._x1 = i, this._y1 = o, this._root = void 0;
}
function az(e) {
  for (var t = { data: e.data }, n = t; e = e.next; )
    n = n.next = { data: e.data };
  return t;
}
var Lo = Yae.prototype = o4.prototype;
Lo.copy = function() {
  var e = new o4(this._x, this._y, this._x0, this._y0, this._x1, this._y1), t = this._root, n, r;
  if (!t)
    return e;
  if (!t.length)
    return e._root = az(t), e;
  for (n = [{ source: t, target: e._root = new Array(4) }]; t = n.pop(); )
    for (var i = 0; i < 4; ++i)
      (r = t.source[i]) && (r.length ? n.push({ source: r, target: t.target[i] = new Array(4) }) : t.target[i] = az(r));
  return e;
};
Lo.add = dgt;
Lo.addAll = fgt;
Lo.cover = hgt;
Lo.data = ggt;
Lo.extent = pgt;
Lo.find = mgt;
Lo.remove = vgt;
Lo.removeAll = ygt;
Lo.root = bgt;
Lo.size = _gt;
Lo.visit = Sgt;
Lo.visitAfter = wgt;
Lo.x = Egt;
Lo.y = Tgt;
function oc(e) {
  return function() {
    return e;
  };
}
function sz(e) {
  return (e() - 0.5) * 1e-6;
}
function Igt(e) {
  return e.x + e.vx;
}
function $gt(e) {
  return e.y + e.vy;
}
function Agt(e) {
  var t, n, r, i = 1, o = 1;
  typeof e != "function" && (e = oc(e == null ? 1 : +e));
  function a() {
    for (var l, u = t.length, d, f, h, p, g, m, v = 0; v < o; ++v)
      for (d = Yae(t, Igt, $gt).visitAfter(s), l = 0; l < u; ++l)
        f = t[l], g = n[f.index], m = g * g, h = f.x + f.vx, p = f.y + f.vy, d.visit(y);
    function y(_, b, w, C, x) {
      var T = _.data, E = _.r, R = g + E;
      if (T) {
        if (T.index > f.index) {
          var I = h - T.x - T.vx, O = p - T.y - T.vy, P = I * I + O * O;
          P < R * R && (I === 0 && (I = sz(r), P += I * I), O === 0 && (O = sz(r), P += O * O), P = (R - (P = Math.sqrt(P))) / P * i, f.vx += (I *= P) * (R = (E *= E) / (m + E)), f.vy += (O *= P) * R, T.vx -= I * (R = 1 - R), T.vy -= O * R);
        }
        return;
      }
      return b > h + R || C < h - R || w > p + R || x < p - R;
    }
  }
  function s(l) {
    if (l.data)
      return l.r = n[l.data.index];
    for (var u = l.r = 0; u < 4; ++u)
      l[u] && l[u].r > l.r && (l.r = l[u].r);
  }
  function c() {
    if (t) {
      var l, u = t.length, d;
      for (n = new Array(u), l = 0; l < u; ++l)
        d = t[l], n[d.index] = +e(d, l, t);
    }
  }
  return a.initialize = function(l, u) {
    t = l, r = u, c();
  }, a.iterations = function(l) {
    return arguments.length ? (o = +l, a) : o;
  }, a.strength = function(l) {
    return arguments.length ? (i = +l, a) : i;
  }, a.radius = function(l) {
    return arguments.length ? (e = typeof l == "function" ? l : oc(+l), c(), a) : e;
  }, a;
}
var Rgt = { value: () => {
} };
function Xae() {
  for (var e = 0, t = arguments.length, n = {}, r; e < t; ++e) {
    if (!(r = arguments[e] + "") || r in n || /[\s.]/.test(r))
      throw new Error("illegal type: " + r);
    n[r] = [];
  }
  return new E_(n);
}
function E_(e) {
  this._ = e;
}
function Pgt(e, t) {
  return e.trim().split(/^|\s+/).map(function(n) {
    var r = "", i = n.indexOf(".");
    if (i >= 0 && (r = n.slice(i + 1), n = n.slice(0, i)), n && !t.hasOwnProperty(n))
      throw new Error("unknown type: " + n);
    return { type: n, name: r };
  });
}
E_.prototype = Xae.prototype = {
  constructor: E_,
  on: function(e, t) {
    var n = this._, r = Pgt(e + "", n), i, o = -1, a = r.length;
    if (arguments.length < 2) {
      for (; ++o < a; )
        if ((i = (e = r[o]).type) && (i = Ogt(n[i], e.name)))
          return i;
      return;
    }
    if (t != null && typeof t != "function")
      throw new Error("invalid callback: " + t);
    for (; ++o < a; )
      if (i = (e = r[o]).type)
        n[i] = cz(n[i], e.name, t);
      else if (t == null)
        for (i in n)
          n[i] = cz(n[i], e.name, null);
    return this;
  },
  copy: function() {
    var e = {}, t = this._;
    for (var n in t)
      e[n] = t[n].slice();
    return new E_(e);
  },
  call: function(e, t) {
    if ((i = arguments.length - 2) > 0)
      for (var n = new Array(i), r = 0, i, o; r < i; ++r)
        n[r] = arguments[r + 2];
    if (!this._.hasOwnProperty(e))
      throw new Error("unknown type: " + e);
    for (o = this._[e], r = 0, i = o.length; r < i; ++r)
      o[r].value.apply(t, n);
  },
  apply: function(e, t, n) {
    if (!this._.hasOwnProperty(e))
      throw new Error("unknown type: " + e);
    for (var r = this._[e], i = 0, o = r.length; i < o; ++i)
      r[i].value.apply(t, n);
  }
};
function Ogt(e, t) {
  for (var n = 0, r = e.length, i; n < r; ++n)
    if ((i = e[n]).name === t)
      return i.value;
}
function cz(e, t, n) {
  for (var r = 0, i = e.length; r < i; ++r)
    if (e[r].name === t) {
      e[r] = Rgt, e = e.slice(0, r).concat(e.slice(r + 1));
      break;
    }
  return n != null && e.push({ name: t, value: n }), e;
}
var vp = 0, y0 = 0, Km = 0, Qae = 1e3, ax, b0, sx = 0, Df = 0, b2 = 0, ty = typeof performance == "object" && performance.now ? performance : Date, Jae = typeof window == "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(e) {
  setTimeout(e, 17);
};
function Zae() {
  return Df || (Jae(Mgt), Df = ty.now() + b2);
}
function Mgt() {
  Df = 0;
}
function $P() {
  this._call = this._time = this._next = null;
}
$P.prototype = ese.prototype = {
  constructor: $P,
  restart: function(e, t, n) {
    if (typeof e != "function")
      throw new TypeError("callback is not a function");
    n = (n == null ? Zae() : +n) + (t == null ? 0 : +t), !this._next && b0 !== this && (b0 ? b0._next = this : ax = this, b0 = this), this._call = e, this._time = n, AP();
  },
  stop: function() {
    this._call && (this._call = null, this._time = 1 / 0, AP());
  }
};
function ese(e, t, n) {
  var r = new $P();
  return r.restart(e, t, n), r;
}
function kgt() {
  Zae(), ++vp;
  for (var e = ax, t; e; )
    (t = Df - e._time) >= 0 && e._call.call(null, t), e = e._next;
  --vp;
}
function lz() {
  Df = (sx = ty.now()) + b2, vp = y0 = 0;
  try {
    kgt();
  } finally {
    vp = 0, Dgt(), Df = 0;
  }
}
function Ngt() {
  var e = ty.now(), t = e - sx;
  t > Qae && (b2 -= t, sx = e);
}
function Dgt() {
  for (var e, t = ax, n, r = 1 / 0; t; )
    t._call ? (r > t._time && (r = t._time), e = t, t = t._next) : (n = t._next, t._next = null, t = e ? e._next = n : ax = n);
  b0 = e, AP(r);
}
function AP(e) {
  if (!vp) {
    y0 && (y0 = clearTimeout(y0));
    var t = e - Df;
    t > 24 ? (e < 1 / 0 && (y0 = setTimeout(lz, e - ty.now() - b2)), Km && (Km = clearInterval(Km))) : (Km || (sx = ty.now(), Km = setInterval(Ngt, Qae)), vp = 1, Jae(lz));
  }
}
const jgt = 1664525, Lgt = 1013904223, uz = 4294967296;
function Fgt() {
  let e = 1;
  return () => (e = (jgt * e + Lgt) % uz) / uz;
}
var Vgt = 10, Bgt = Math.PI * (3 - Math.sqrt(5));
function zgt(e) {
  var t, n = 1, r = 1e-3, i = 1 - Math.pow(r, 1 / 300), o = 0, a = 0.6, s = /* @__PURE__ */ new Map(), c = ese(d), l = Xae("tick", "end"), u = Fgt();
  e == null && (e = []);
  function d() {
    f(), l.call("tick", t), n < r && (c.stop(), l.call("end", t));
  }
  function f(g) {
    var m, v = e.length, y;
    g === void 0 && (g = 1);
    for (var _ = 0; _ < g; ++_)
      for (n += (o - n) * i, s.forEach(function(b) {
        b(n);
      }), m = 0; m < v; ++m)
        y = e[m], y.fx == null ? y.x += y.vx *= a : (y.x = y.fx, y.vx = 0), y.fy == null ? y.y += y.vy *= a : (y.y = y.fy, y.vy = 0);
    return t;
  }
  function h() {
    for (var g = 0, m = e.length, v; g < m; ++g) {
      if (v = e[g], v.index = g, v.fx != null && (v.x = v.fx), v.fy != null && (v.y = v.fy), isNaN(v.x) || isNaN(v.y)) {
        var y = Vgt * Math.sqrt(0.5 + g), _ = g * Bgt;
        v.x = y * Math.cos(_), v.y = y * Math.sin(_);
      }
      (isNaN(v.vx) || isNaN(v.vy)) && (v.vx = v.vy = 0);
    }
  }
  function p(g) {
    return g.initialize && g.initialize(e, u), g;
  }
  return h(), t = {
    tick: f,
    restart: function() {
      return c.restart(d), t;
    },
    stop: function() {
      return c.stop(), t;
    },
    nodes: function(g) {
      return arguments.length ? (e = g, h(), s.forEach(p), t) : e;
    },
    alpha: function(g) {
      return arguments.length ? (n = +g, t) : n;
    },
    alphaMin: function(g) {
      return arguments.length ? (r = +g, t) : r;
    },
    alphaDecay: function(g) {
      return arguments.length ? (i = +g, t) : +i;
    },
    alphaTarget: function(g) {
      return arguments.length ? (o = +g, t) : o;
    },
    velocityDecay: function(g) {
      return arguments.length ? (a = 1 - g, t) : 1 - a;
    },
    randomSource: function(g) {
      return arguments.length ? (u = g, s.forEach(p), t) : u;
    },
    force: function(g, m) {
      return arguments.length > 1 ? (m == null ? s.delete(g) : s.set(g, p(m)), t) : s.get(g);
    },
    find: function(g, m, v) {
      var y = 0, _ = e.length, b, w, C, x, T;
      for (v == null ? v = 1 / 0 : v *= v, y = 0; y < _; ++y)
        x = e[y], b = g - x.x, w = m - x.y, C = b * b + w * w, C < v && (T = x, v = C);
      return T;
    },
    on: function(g, m) {
      return arguments.length > 1 ? (l.on(g, m), t) : l.on(g);
    }
  };
}
function dz(e) {
  var t = oc(0.1), n, r, i;
  typeof e != "function" && (e = oc(e == null ? 0 : +e));
  function o(s) {
    for (var c = 0, l = n.length, u; c < l; ++c)
      u = n[c], u.vx += (i[c] - u.x) * r[c] * s;
  }
  function a() {
    if (n) {
      var s, c = n.length;
      for (r = new Array(c), i = new Array(c), s = 0; s < c; ++s)
        r[s] = isNaN(i[s] = +e(n[s], s, n)) ? 0 : +t(n[s], s, n);
    }
  }
  return o.initialize = function(s) {
    n = s, a();
  }, o.strength = function(s) {
    return arguments.length ? (t = typeof s == "function" ? s : oc(+s), a(), o) : t;
  }, o.x = function(s) {
    return arguments.length ? (e = typeof s == "function" ? s : oc(+s), a(), o) : e;
  }, o;
}
function fz(e) {
  var t = oc(0.1), n, r, i;
  typeof e != "function" && (e = oc(e == null ? 0 : +e));
  function o(s) {
    for (var c = 0, l = n.length, u; c < l; ++c)
      u = n[c], u.vy += (i[c] - u.y) * r[c] * s;
  }
  function a() {
    if (n) {
      var s, c = n.length;
      for (r = new Array(c), i = new Array(c), s = 0; s < c; ++s)
        r[s] = isNaN(i[s] = +e(n[s], s, n)) ? 0 : +t(n[s], s, n);
    }
  }
  return o.initialize = function(s) {
    n = s, a();
  }, o.strength = function(s) {
    return arguments.length ? (t = typeof s == "function" ? s : oc(+s), a(), o) : t;
  }, o.y = function(s) {
    return arguments.length ? (e = typeof s == "function" ? s : oc(+s), a(), o) : e;
  }, o;
}
function Uu() {
  return Uu = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Uu.apply(this, arguments);
}
function tse(e, t) {
  if (e == null)
    return {};
  var n, r, i = {}, o = Object.keys(e);
  for (r = 0; r < o.length; r++)
    n = o[r], t.indexOf(n) >= 0 || (i[n] = e[n]);
  return i;
}
var hz, Hgt = function(e) {
  var t = e.id, n = e.formattedValue, r = e.color;
  return A.jsx(qat, { id: t, value: n, enableChip: !0, color: r });
}, Yn = { id: "id", value: "value", valueScale: { type: "linear", min: 0, max: "auto" }, groupBy: "group", size: 6, spacing: 2, layout: "vertical", gap: 0, forceStrength: 1, simulationIterations: 120, colors: { scheme: "nivo" }, colorBy: "group", borderWidth: 0, borderColor: "rgba(0, 0, 0, 0)", layers: ["grid", "axes", "circles", "annotations", "mesh"], enableGridX: !0, enableGridY: !0, axisTop: {}, axisRight: {}, axisBottom: {}, axisLeft: {}, isInteractive: !0, useMesh: !1, debugMesh: !1, tooltip: Hgt, animate: !0, motionConfig: "gentle", annotations: [], role: "img", pixelRatio: typeof window < "u" && (hz = window.devicePixelRatio) != null ? hz : 1 }, Ugt = function(e) {
  var t = e.width, n = e.height, r = e.axis, i = e.groups, o = e.gap;
  if (!Array.isArray(i) || i.length === 0)
    throw new Error("'groups' should be an array containing at least one item");
  var a, s = i.length;
  r === "x" ? a = (n - o * (s - 1)) / s : r === "y" && (a = (t - o * (s - 1)) / s);
  var c = i.map(function(l, u) {
    return u * (a + o) + a / 2;
  });
  return tl(c).domain(i);
}, Wgt = function(e) {
  var t = e.width, n = e.height, r = e.axis, i = e.getValue, o = e.scale, a = e.data.map(i);
  if (o.type === "time") {
    var s = [{ data: a.map(function(d) {
      var f;
      return { data: (f = { x: null, y: null }, f[r] = d, f) };
    }) }], c = Jlt(s, r, o);
    return HB(o, c, r === "x" ? t : n, r);
  }
  var l = Math.min.apply(Math, a), u = Math.max.apply(Math, a);
  return HB(o, { all: a, min: l, max: u }, r === "x" ? t : n, r);
}, qgt = function(e) {
  if (typeof e == "function")
    return e;
  if (TP(e))
    return function() {
      return e;
    };
  if (ni(e)) {
    if (!sae(e.key))
      throw new Error("Size is invalid, key should be a string pointing to the property to use to determine node size");
    if (!Array.isArray(e.values) || e.values.length !== 2)
      throw new Error("Size is invalid, values spec should be an array containing two values, min and max");
    if (!Array.isArray(e.sizes) || e.sizes.length !== 2)
      throw new Error("Size is invalid, sizes spec should be an array containing two values, min and max");
    var t = Yy().domain([e.values[0], e.values[1]]).range([e.sizes[0], e.sizes[1]]);
    return function(n) {
      return t(Tf(n, e.key));
    };
  }
  throw new Error("Size is invalid, it should be either a function, a number or an object");
}, Ggt = function(e) {
  var t, n, r = e.axis, i = e.valueScale, o = e.ordinalScale, a = e.spacing, s = e.forceStrength, c = Agt(function(l) {
    return l.size / 2 + a / 2;
  });
  if (r === "x")
    t = dz(function(l) {
      return i(l.value);
    }).strength(s), n = fz(function(l) {
      return o(l.group);
    });
  else {
    if (r !== "y")
      throw new Error("Invalid axis provided: " + r);
    t = dz(function(l) {
      return o(l.group);
    }), n = fz(function(l) {
      return i(l.value);
    }).strength(s);
  }
  return { x: t, y: n, collision: c };
}, Kgt = function(e) {
  var t, n, r = e.data, i = e.getId, o = e.layout, a = e.getValue, s = e.valueScale, c = e.getGroup, l = e.ordinalScale, u = e.getSize, d = e.forces, f = e.simulationIterations, h = e.valueScaleConfig, p = { horizontal: ["x", "y"], vertical: ["y", "x"] }, g = (n = h).type === "time" && n.format !== "native" ? e4(n) : function(y) {
    return y;
  }, m = r.map(function(y) {
    return { id: i(y), group: c(y), value: g(a(y)), size: u(y), data: Uu({}, y) };
  }), v = zgt(m).force("x", d.x).force("y", d.y).force("collide", d.collision).stop();
  return v.tick(f), (t = {})[p[o][0] + "Scale"] = s, t[p[o][1] + "Scale"] = l, t.nodes = v.nodes(), t;
}, Ygt = function(e) {
  var t = e.width, n = e.height, r = e.axis, i = e.getValue, o = e.scale, a = e.data;
  return Tt(function() {
    return Wgt({ width: t, height: n, axis: r, getValue: i, scale: o, data: a });
  }, [t, n, r, i, o, a]);
}, Xgt = function(e) {
  var t = e.width, n = e.height, r = e.axis, i = e.groups, o = e.gap;
  return Tt(function() {
    return Ugt({ width: t, height: n, axis: r, groups: i, gap: o });
  }, [t, n, r, i, o]);
}, Qgt = function(e) {
  var t = e.axis, n = e.valueScale, r = e.ordinalScale, i = e.spacing, o = e.forceStrength;
  return Tt(function() {
    return Ggt({ axis: t, valueScale: n, ordinalScale: r, spacing: i, forceStrength: o });
  }, [t, n, r, i, o]);
}, Jgt = function(e) {
  var t = e.data, n = e.width, r = e.height, i = e.id, o = e.value, a = e.valueFormat, s = e.valueScale, c = e.groups, l = e.groupBy, u = e.size, d = e.spacing, f = e.layout, h = e.gap, p = e.forceStrength, g = e.simulationIterations, m = e.colors, v = e.colorBy, y = f === "horizontal" ? "x" : "y", _ = k1(i), b = k1(o), w = wae(a), C = k1(l), x = function(D) {
    return Tt(function() {
      return qgt(D);
    }, [D]);
  }(u), T = k1(v), E = Kut(m, T), R = Ygt({ width: n, height: r, axis: y, getValue: b, scale: s, data: t }), I = Xgt({ width: n, height: r, axis: y, groups: c, gap: h }), O = Qgt({ axis: y, valueScale: R, ordinalScale: I, spacing: d, forceStrength: p }), P = Tt(function() {
    return Kgt({ data: t, getId: _, layout: f, getValue: b, valueScale: R, getGroup: C, ordinalScale: I, getSize: x, forces: O, simulationIterations: g, valueScaleConfig: s });
  }, [t, _, f, b, R, C, I, x, O, g, s]), k = P.nodes, L = P.xScale, N = P.yScale;
  return { nodes: Tt(function() {
    return k.map(function(D) {
      return Uu({}, D, { formattedValue: w(D.value), color: E(D) });
    });
  }, [k, w, E]), xScale: L, yScale: N, getColor: E };
}, Zgt = function(e) {
  return Tt(function() {
    return typeof e == "function" ? e : function() {
      return e;
    };
  }, [e]);
}, ept = function(e) {
  var t = e.isInteractive, n = e.onClick, r = e.onMouseEnter, i = e.onMouseLeave, o = e.onMouseMove, a = e.tooltip, s = Yk(), c = s.showTooltipFromEvent, l = s.hideTooltip;
  return { onMouseEnter: Wt(function(u, d) {
    t && (c(a(u), d), r == null || r(u, d));
  }, [t, r, c, a]), onMouseMove: Wt(function(u, d) {
    t && (c(a(u), d), o == null || o(u, d));
  }, [t, o, c, a]), onMouseLeave: Wt(function(u, d) {
    t && (l(), i == null || i(u, d));
  }, [t, l, i]), onClick: Wt(function(u, d) {
    t && (n == null || n(u, d));
  }, [t, n]) };
}, tpt = function(e) {
  return { x: e.x, y: e.y };
}, npt = function(e) {
  return { size: e.size, width: e.size, height: e.size };
}, rpt = function(e, t) {
  return igt({ data: e, annotations: t, getPosition: tpt, getDimensions: npt });
}, ipt = function(e) {
  var t = e.nodes, n = e.xScale, r = e.yScale, i = e.innerWidth, o = e.innerHeight, a = e.outerWidth, s = e.outerHeight, c = e.margin;
  return Tt(function() {
    return { nodes: t, xScale: n, yScale: r, innerWidth: i, innerHeight: o, outerWidth: a, outerHeight: s, margin: c };
  }, [t, n, r, i, o, a, s, c]);
}, opt = function(e) {
  var t = e.nodes, n = e.borderWidth, r = e.borderColor, i = e.component, o = e.isInteractive, a = e.onMouseEnter, s = e.onMouseMove, c = e.onMouseLeave, l = e.onClick, u = e.tooltip, d = Yk(), f = d.showTooltipFromEvent, h = d.hideTooltip, p = Tt(function() {
    if (o)
      return function(R, I) {
        f(cf(u, R), I), a == null || a(R, I);
      };
  }, [o, f, u, a]), g = Tt(function() {
    if (o)
      return function(R, I) {
        f(cf(u, R), I), s == null || s(R, I);
      };
  }, [o, f, u, s]), m = Tt(function() {
    if (o)
      return function(R, I) {
        h(), c == null || c(R, I);
      };
  }, [o, h, c]), v = Tt(function() {
    if (o)
      return function(R, I) {
        l == null || l(R, I);
      };
  }, [o, l]), y = Ls(), _ = y.animate, b = y.config, w = vo(), C = Zgt(n), x = qut(r, w), T = Tt(function() {
    return function(R) {
      return { enter: function(I) {
        return { x: I.x, y: I.y, radius: 0, color: I.color, borderColor: R(I), opacity: 0 };
      }, update: function(I) {
        return { x: I.x, y: I.y, radius: I.size / 2, color: I.color, borderColor: R(I), opacity: 1 };
      }, leave: function(I) {
        return { x: I.x, y: I.y, radius: 0, color: I.color, borderColor: R(I), opacity: 0 };
      } };
    }(x);
  }, [x]), E = Kk(t, { keys: function(R) {
    return R.id;
  }, initial: T.update, from: T.enter, enter: T.update, update: T.update, leave: T.leave, config: b, immediate: !_ });
  return A.jsx(A.Fragment, { children: E(function(R, I) {
    return $.createElement(i, { key: I.id, node: I, style: Uu({}, R, { radius: (O = R.radius, Koe([O], function(P) {
      return Math.max(0, P);
    })), borderWidth: C(I) }), onMouseEnter: p, onMouseMove: g, onMouseLeave: m, onClick: v });
    var O;
  }) });
}, apt = function(e) {
  var t = e.node, n = e.style, r = e.onMouseEnter, i = e.onMouseMove, o = e.onMouseLeave, a = e.onClick;
  return A.jsx(xi.circle, { cx: n.x, cy: n.y, r: n.radius, fill: n.color, stroke: n.borderColor, strokeWidth: n.borderWidth, opacity: n.opacity, onMouseEnter: function(s) {
    return r == null ? void 0 : r(t, s);
  }, onMouseMove: function(s) {
    return i == null ? void 0 : i(t, s);
  }, onMouseLeave: function(s) {
    return o == null ? void 0 : o(t, s);
  }, onClick: function(s) {
    return a == null ? void 0 : a(t, s);
  } }, t.id);
}, spt = function(e) {
  var t = e.nodes, n = e.annotations, r = rpt(t, n);
  return A.jsx(A.Fragment, { children: r.map(function(i, o) {
    return A.jsx(ugt, Uu({}, i), o);
  }) });
}, cpt = ["nodes"], lpt = ["theme", "isInteractive", "animate", "motionConfig", "renderWrapper"], upt = function(e) {
  var t = e.data, n = e.width, r = e.height, i = e.margin, o = e.id, a = o === void 0 ? Yn.id : o, s = e.value, c = s === void 0 ? Yn.value : s, l = e.valueScale, u = l === void 0 ? Yn.valueScale : l, d = e.valueFormat, f = e.groups, h = e.groupBy, p = h === void 0 ? Yn.groupBy : h, g = e.size, m = g === void 0 ? Yn.size : g, v = e.forceStrength, y = v === void 0 ? Yn.forceStrength : v, _ = e.simulationIterations, b = _ === void 0 ? Yn.simulationIterations : _, w = e.colors, C = w === void 0 ? Yn.colors : w, x = e.colorBy, T = x === void 0 ? Yn.colorBy : x, E = e.borderColor, R = E === void 0 ? Yn.borderColor : E, I = e.borderWidth, O = I === void 0 ? Yn.borderWidth : I, P = e.layout, k = P === void 0 ? Yn.layout : P, L = e.spacing, N = L === void 0 ? Yn.spacing : L, D = e.gap, z = D === void 0 ? Yn.gap : D, V = e.layers, B = V === void 0 ? Yn.layers : V, U = e.circleComponent, Q = U === void 0 ? apt : U, Y = e.useMesh, q = Y === void 0 ? Yn.useMesh : Y, X = e.debugMesh, ne = X === void 0 ? Yn.debugMesh : X, Z = e.enableGridX, J = Z === void 0 ? Yn.enableGridX : Z, K = e.gridXValues, ee = e.enableGridY, te = ee === void 0 ? Yn.enableGridY : ee, H = e.gridYValues, ie = e.axisTop, W = ie === void 0 ? Yn.axisTop : ie, se = e.axisRight, le = se === void 0 ? Yn.axisRight : se, ge = e.axisBottom, me = ge === void 0 ? Yn.axisBottom : ge, pe = e.axisLeft, Te = pe === void 0 ? Yn.axisLeft : pe, de = e.isInteractive, Ae = e.onMouseEnter, ue = e.onMouseMove, be = e.onMouseLeave, Ie = e.onClick, Ve = e.tooltip, ze = Ve === void 0 ? Yn.tooltip : Ve, Ne = e.annotations, lt = Ne === void 0 ? Yn.annotations : Ne, mt = e.role, vt = mt === void 0 ? Yn.role : mt, ke = mlt(n, r, i), xe = ke.outerWidth, Re = ke.outerHeight, yt = ke.margin, Pt = ke.innerWidth, _t = ke.innerHeight, St = Jgt({ width: Pt, height: _t, data: t, id: a, value: c, valueFormat: d, valueScale: u, groups: f, groupBy: p, size: m, spacing: N, layout: k, gap: z, colors: C, colorBy: T, forceStrength: y, simulationIterations: b }), ft = St.nodes, kn = tse(St, cpt), Dt = kn.xScale, nt = kn.yScale, Be = ept({ isInteractive: de, onClick: Ie, onMouseEnter: Ae, onMouseLeave: be, onMouseMove: ue, tooltip: ze }), st = { grid: null, axes: null, circles: null, annotations: null, mesh: null };
  B.includes("grid") && (st.grid = A.jsx(lut, { width: Pt, height: _t, xScale: J ? Dt : null, xValues: K, yScale: te ? nt : null, yValues: H }, "grid")), B.includes("axes") && (st.axes = A.jsx(sut, { xScale: Dt, yScale: nt, width: Pt, height: _t, top: W ?? void 0, right: le ?? void 0, bottom: me ?? void 0, left: Te ?? void 0 }, "axes")), B.includes("circles") && (st.circles = A.jsx(opt, { nodes: ft, borderWidth: O, borderColor: R, isInteractive: de, tooltip: ze, component: Q, onMouseEnter: Ae, onMouseMove: ue, onMouseLeave: be, onClick: Ie }, "circles")), B.includes("annotations") && (st.annotations = A.jsx(spt, { nodes: ft, annotations: lt }, "annotations")), de && q && (st.mesh = A.jsx(kut, { nodes: ft, width: Pt, height: _t, onMouseEnter: Be.onMouseEnter, onMouseMove: Be.onMouseMove, onMouseLeave: Be.onMouseLeave, onClick: Be.onClick, debug: ne }, "mesh"));
  var pt = ipt({ nodes: ft, xScale: Dt, yScale: nt, innerWidth: Pt, innerHeight: _t, outerWidth: xe, outerHeight: Re, margin: yt });
  return A.jsx(Pae, { width: xe, height: Re, margin: yt, role: vt, children: B.map(function(Et, Ke) {
    return st[Et] !== void 0 ? st[Et] : typeof Et == "function" ? A.jsx(XH, { children: cf(Et, pt) }, Ke) : null;
  }) });
}, dpt = function(e) {
  var t = e.theme, n = e.isInteractive, r = n === void 0 ? Yn.isInteractive : n, i = e.animate, o = i === void 0 ? Yn.animate : i, a = e.motionConfig, s = a === void 0 ? Yn.motionConfig : a, c = e.renderWrapper, l = tse(e, lpt);
  return A.jsx(Iae, { isInteractive: r, animate: o, motionConfig: s, theme: t, renderWrapper: c, children: A.jsx(upt, Uu({ isInteractive: r }, l)) });
}, fpt = function(e) {
  return A.jsx($ae, { children: function(t) {
    var n = t.width, r = t.height;
    return A.jsx(dpt, Uu({ width: n, height: r }, e));
  } });
};
const hpt = {
  text: {
    fontSize: 16,
    fontFamily: "Inter, sans-serif"
  }
}, gpt = (e) => {
  const { primaryColour: t } = Gn(), n = Qn(e.output.data, {
    currentAnswer: e.currentAnswer,
    answers: e.answers,
    aggregateAnswers: e.aggregateAnswers
  }), r = Qn(e.output.xAxisOptions, {
    currentAnswer: e.currentAnswer,
    answers: e.answers,
    aggregateAnswers: e.aggregateAnswers
  }), i = Qn(e.output.chartOptions, {
    currentAnswer: e.currentAnswer,
    answers: e.answers,
    aggregateAnswers: e.aggregateAnswers
  }), o = ppt(n), a = mpt(n);
  return !o || o.length === 0 ? null : /* @__PURE__ */ A.jsx(
    ypt,
    {
      height: i != null && i.height ? `${i == null ? void 0 : i.height}px` : void 0,
      width: i != null && i.width ? `${i.width}px` : void 0,
      children: /* @__PURE__ */ A.jsx(
        fpt,
        {
          data: o,
          groups: a,
          colors: t,
          valueFormat: e.output.hoverFormat,
          valueScale: {
            type: "linear",
            min: r == null ? void 0 : r.min,
            max: r == null ? void 0 : r.max,
            reverse: !1
          },
          size: (s) => vpt(s, e.output.defaultSize),
          layout: e.output.layout ?? "horizontal",
          forceStrength: 4,
          simulationIterations: 100,
          borderColor: {
            from: "color",
            modifiers: [
              ["darker", 0.6],
              ["opacity", 0.5]
            ]
          },
          enableGridX: !1,
          gridXValues: r == null ? void 0 : r.tickValues,
          margin: { top: 80, right: 100, bottom: 80, left: 100 },
          theme: hpt,
          axisTop: {
            tickValues: r == null ? void 0 : r.tickValues
          },
          axisBottom: {
            tickValues: r == null ? void 0 : r.tickValues
          },
          axisLeft: e.output.leftAxisLabel ? {
            legend: /* @__PURE__ */ A.jsx("tspan", { style: { fontSize: "1rem" }, children: e.output.leftAxisLabel }),
            legendPosition: "middle",
            legendOffset: -60
          } : void 0,
          axisRight: e.output.rightAxisLabel ? {
            legend: /* @__PURE__ */ A.jsx("tspan", { style: { fontSize: "1rem" }, children: e.output.rightAxisLabel }),
            legendPosition: "middle",
            legendOffset: 60
          } : void 0,
          circleComponent: e.output.showPointLabels ? ({ node: s, style: c }) => /* @__PURE__ */ A.jsxs("g", { transform: `translate(${s.x},${s.y})`, children: [
            /* @__PURE__ */ A.jsx("text", { transform: `translate(${s.size / 2 + 5}, 0) rotate(-45)`, children: s.data.label }),
            /* @__PURE__ */ A.jsx(
              "circle",
              {
                r: s.size / 2,
                fill: c.color.get(),
                stroke: c.borderColor.get(),
                strokeWidth: c.borderWidth
              }
            )
          ] }) : void 0,
          tooltip: (s) => /* @__PURE__ */ A.jsx(
            "div",
            {
              style: {
                padding: "0.3rem",
                background: "white",
                border: "1px solid #ccc",
                borderRadius: "0.3rem",
                boxShadow: "0 1px 2px rgba(0, 0, 0, 0.25)"
              },
              children: /* @__PURE__ */ A.jsx("div", { children: s.data.label ? `${s.data.label}: ${s.value.toLocaleString()}` : s.value.toLocaleString() })
            }
          )
        }
      )
    }
  );
};
function ppt(e) {
  if (!e)
    return;
  const t = [];
  return e.forEach((n) => {
    n.dataset.forEach((r) => {
      t.push({
        id: r.id,
        group: n.label,
        value: r.value,
        size: r.size,
        label: r.label
      });
    });
  }), t;
}
function mpt(e) {
  return e ? e.map((n) => n.label) : [];
}
function vpt(e, t = 10) {
  return e.size ?? t;
}
const ypt = ce.div`
  display: flex;
  flex: 1 1 auto;
  height: ${(e) => e.height || "30rem"};
  width: ${(e) => e.width || "100%"};
`, bpt = (e) => /* @__PURE__ */ A.jsx(gpt, { ...e }), gz = ({
  outputs: e,
  currentAnswer: t,
  answers: n,
  settings: r,
  direction: i,
  style: o,
  location: a
}) => /* @__PURE__ */ A.jsx(_pt, { direction: i, location: a ?? "right", style: o, children: e ? e.map((s, c) => /* @__PURE__ */ A.jsx(Spt, { output: s, currentAnswer: t, answers: n, settings: r }, c)) : void 0 }), _pt = ce.div`
  display: flex;
  flex-direction: ${(e) => e.direction || "column"};
  flex-wrap: ${(e) => e.direction === "row" ? "wrap" : "nowrap"};
  gap: 0.5rem;
  flex: 1 1;
  flex-basis: ${(e) => e.location === "right" ? "32rem" : "auto"};
  /* width: ${(e) => e.location === "right" ? "unset" : "40rem"}; */
  /* max-width: 32rem; */
  /* flex: 1 1; */
  position: sticky;
  top: 1rem;
  /* margin: 1rem; */
`, Spt = ({ output: e, currentAnswer: t, answers: n, settings: r }) => {
  const { databaseService: i } = gt(mn), o = e.getAggregateAnswers ? i.observeAggregatedResults(r.surveyName) : mde, a = KH(o);
  switch (e.type) {
    case "card":
      return /* @__PURE__ */ A.jsx(aot, { output: e, currentAnswer: t, answers: n, settings: r, aggregateAnswers: a });
    case "line-chart":
      return /* @__PURE__ */ A.jsx(hot, { output: e, currentAnswer: t, answers: n, settings: r, aggregateAnswers: a });
    case "bar-chart":
      return /* @__PURE__ */ A.jsx(oot, { output: e, currentAnswer: t, answers: n, settings: r, aggregateAnswers: a });
    case "generic":
      return /* @__PURE__ */ A.jsx(cot, { output: e, currentAnswer: t, answers: n, settings: r, aggregateAnswers: a });
    case "swarm-chart":
      return /* @__PURE__ */ A.jsx(bpt, { output: e, currentAnswer: t, answers: n, settings: r, aggregateAnswers: a });
    case "pie-chart":
      return /* @__PURE__ */ A.jsx(bot, { output: e, currentAnswer: t, answers: n, settings: r, aggregateAnswers: a });
  }
}, lm = ce.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-width: 0;
  max-width: 40rem;
  gap: 1rem;
  align-items: stretch;
  /* margin: ${(e) => e.device === Xn.MOBILE ? "1rem 30px" : "1rem"}; */
`, Su = (e) => {
  const t = e.currentTarget, n = document.createElement("span"), r = Math.max(t.clientWidth, t.clientHeight), i = r / 2;
  n.style.width = n.style.height = `${r}px`, n.style.left = `${e.clientX - (t.offsetLeft + i)}px`, n.style.top = `${e.clientY - (t.offsetTop + i)}px`, n.classList.add("ripple");
  const o = t.getElementsByClassName("ripple")[0];
  o && o.remove(), t.appendChild(n);
}, wpt = gi`
   0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`, a4 = ce.button`
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  border-radius: ${(e) => e.borderRadius};
  cursor: pointer;
  border: ${(e) => e.active ? `2px solid ${e.primaryColour}` : "1px solid var(--mid)"};
  color: var(--dark);
  min-height: var(--button-height);
  padding: var(--spacing-sm) var(--spacing-sm);
  justify-content: space-between;
  transition:
    background-color 150ms ease-in-out,
    color 150ms ease-in-out;
  background-color: ${(e) => e.active ? "var(--light)" : e.shadeColour ? e.shadeColour : "var(--light)"};

  @media (hover: hover) {
    &:hover {
      border-color: ${(e) => e.primaryColour};
      box-shadow: 0 0 5px 0px rgba(0, 0, 0, 0.3);
    }
  }

  span.ripple {
    position: absolute;
    border-radius: 50%;
    transform: scale(0);
    animation: ripple 500ms linear;
    background-color: ${(e) => e.primaryColour};
    opacity: 0.5;
  }

  @keyframes ripple {
    to {
      transform: scale(4);
      opacity: 0;
    }
  }
`, xpt = (e) => {
  const t = Mi();
  return /* @__PURE__ */ A.jsx(Ept, { ...e, borderRadius: t, children: e.children });
}, Ept = ce(a4)`
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  cursor: ${(e) => e.disabled ? "wait" : "pointer"};
  animation: 0.5s ${wpt} ease;
  background-color: ${(e) => e.active ? e.primaryColour : e.shadeColour ? e.shadeColour : "var(--light)"};
  color: ${(e) => e.active ? "var(--light)" : "var(--dark)"};
`, Cpt = ({ primaryColour: e, active: t, showInactive: n }) => /* @__PURE__ */ A.jsx(Tpt, { primaryColour: e, active: t, showInactive: n, children: /* @__PURE__ */ A.jsx(Ipt, { colour: e, active: t }) }), Tpt = ce.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  flex-shrink: 0;
  /* padding: 2px; */
  border-radius: 26px;
  border: ${(e) => e.active ? "1px solid var(--dark)" : e.showInactive ? "1px solid var(--mid)" : "none"};

  background-color: ${(e) => e.active || e.showInactive ? "var(--light)" : "transparent"};
`, Ipt = ce.div`
  width: ${(e) => e.active ? "12px" : "0px"};
  height: ${(e) => e.active ? "12px" : "0px"};
  border-radius: ${(e) => e.active ? "12px" : "0px"};
  background-color: ${(e) => e.active ? e.colour : "transparent"};
  transition: all 150ms ease-in-out;
`, cx = (e) => {
  const {
    onClick: t,
    buttonText: n,
    ButtonIcon: r,
    active: i,
    colour: o,
    shadeColour: a,
    fill: s,
    showInactiveCircle: c,
    onFocus: l,
    onMouseEnter: u,
    onMouseLeave: d,
    onPointerEnter: f,
    onPointerLeave: h
  } = e, p = Mi();
  return /* @__PURE__ */ A.jsxs(
    nse,
    {
      onClick: t,
      borderRadius: p,
      active: i,
      primaryColour: o,
      shadeColour: a,
      role: "button",
      "aria-pressed": i,
      onFocus: l,
      onMouseEnter: u,
      onMouseLeave: d,
      onPointerEnter: f,
      onPointerLeave: h,
      children: [
        /* @__PURE__ */ A.jsxs(Ppt, { children: [
          r ? /* @__PURE__ */ A.jsx(Apt, { active: i, fill: s || o, children: /* @__PURE__ */ A.jsx(r, {}) }) : void 0,
          /* @__PURE__ */ A.jsx(Rpt, { children: n })
        ] }),
        /* @__PURE__ */ A.jsx(Cpt, { active: i, primaryColour: o, showInactive: c })
      ]
    }
  );
}, $pt = (e) => gi`
  0% {
    box-shadow: 0 0 1px ${e}, 0 0 2px ${e}, 0 0 3px ${e}, 0 0 4px ${e};
  }
  30% {
    box-shadow: 0 0 2px ${e}, 0 0 4px ${e}, 0 0 5px ${e}, 0 0 5px ${e};
  }
  70% {
    box-shadow: 0 0 2px ${e}, 0 0 4px ${e}, 0 0 5px ${e}, 0 0 5px ${e};
  }
  100% {
    box-shadow: 0 0 1px ${e}, 0 0 2px ${e}, 0 0 3px ${e}, 0 0 4px ${e};
  }
`, nse = ce(a4)`
  @media (hover: hover) {
    &:hover {
      animation: none;
    }
  }
  animation: ${(e) => e.glow ? Dle`
          ${$pt(e.primaryColour)} 2s infinite
        ` : "none"};
`, Apt = ce.span`
  margin-right: 1rem;
  display: flex;
  align-content: center;
  justify-content: center;
  align-items: center;
  svg {
    fill: ${(e) => e.active ? e.primaryColour : e.fill};
    width: 2rem;
    height: auto;
  }
`, Rpt = ce.span`
  font-weight: 400;
  font-size: var(--choice-text-font-size);
  text-align: left;
  text-overflow: ellipsis;
  word-wrap: break-word;
  word-break: break-word;
  margin-bottom: 0rem;
  /* line-height: 1.5; */
`, Ppt = ce.div`
  display: flex;
  align-content: baseline;
  align-items: center;
  margin-right: 0.5rem;
  flex-grow: 1;

  background-color: transparent;
`;
function _2(e) {
  const { title: t, children: n, primaryColour: r, placement: i } = e;
  return /* @__PURE__ */ A.jsx(
    go,
    {
      theme: r ? {
        token: {
          colorPrimary: r
        }
      } : void 0,
      children: /* @__PURE__ */ A.jsx(od, { title: t, placement: i, trigger: ["hover", "contextMenu"], children: n })
    }
  );
}
const lx = "prevChoices", rse = ({
  question: e,
  currentAnswer: t,
  injectCurrent: n,
  submitAnswer: r,
  recordAnswer: i,
  answers: o,
  settings: a,
  updateSurveyControls: s,
  setNextButtonBehaviour: c,
  setPreviousButtonBehaviour: l
}) => {
  const { loggingService: u, messagerService: d, popupService: f } = gt(mn), [h, p] = j.useState(null), [g, m] = j.useState(!1), [v, y] = j.useState(!1), { primaryColour: _, shadeColour: b } = Gn(), w = t.getValue(e.type), C = pz(w), [x, T] = j.useState(C.length), [E, R] = j.useState(null), I = No();
  u.debug("ChoiceExperimentQuestion: prevChoices", C);
  const O = Wt(async () => {
    y(!0), s({ nextDisabled: !0, prevDisabled: !0 });
    const Y = await Ele(
      e.choiceGenerator(C.slice(0, x)),
      500
    );
    return s({ nextDisabled: !1, prevDisabled: !1 }), y(!1), x === C.length ? p(null) : x < C.length && p(C[x].selectedOptionIndex), R(x), Y;
  }, [C.length, x, s]), P = Cle(O);
  Xi(e, (Y) => {
    const q = pz(
      Y.convertedToQuestionType("choiceExperiment").getValue("choiceExperiment")
    );
    return ec(
      P === null || e.maxChoices !== void 0 && q.length >= e.maxChoices,
      P !== void 0 && !v
    );
  }), u.debug("ChoiceExperimentQuestion: profiles", P), ot(() => (x > 0 ? l(() => {
    m(!1), T((Y) => Y - 1);
  }) : l(void 0), () => {
    l(void 0);
  }), [x, l]), ot(() => (P !== null && (!e.maxChoices || x < e.maxChoices) ? c(() => {
    if (x === C.length) {
      d.error("Please select an option");
      return;
    }
    m(!0), T((Y) => Y + 1);
  }) : c(void 0), () => {
    c(void 0);
  }), [x, P, C.length, e.maxChoices, c]);
  function k(Y, q, X) {
    if (er.isUndefined(P))
      return;
    const ne = (P ?? []).map(
      (K) => qEe(K, e.attributes)
    ), Z = [
      ...C.slice(0, x),
      {
        options: ne,
        selectedOption: q === null ? null : ne[X],
        selectedOptionIndex: X
      }
    ], J = {
      ...w,
      [lx]: Z.map((K, ee) => {
        var te, H;
        return {
          id: uK(
            K.options,
            (H = (te = w == null ? void 0 : w[lx]) == null ? void 0 : te[ee]) == null ? void 0 : H.id.toString()
          ),
          value: `Selected option ${K.selectedOptionIndex}`,
          info: K
        };
      })
    };
    u.debug("ChoiceExperimentQuestion: newAnswer", J), n({ value: J }), i(), p(X), Su(Y), m(!0), T((K) => K + 1);
  }
  ot(() => {
    u.debug("ChoiceExperimentQuestion: useEffect", P), er.isNull(P) && g && (r(), m(!1));
  }, [g, P, r, u]);
  const N = Ms({
    default: { content: "Click the option you prefer", position: { side: "bottom" } },
    goingBack: {
      content: "All choices have been made. Click Next to go to the next question, or Previous to change your answers",
      position: { side: "bottom" }
    },
    firstChoice: {
      content: "Click the option you prefer",
      position: { side: "right" }
    }
  }, e.helpPopups), D = e.showHelpPopups ?? !1, z = e.helpPopupsToShow;
  ot(() => {
    P ? x === 0 ? f.setPopup(N, "firstChoice", D, z) : f.setPopup(N, "default", D, z) : g || x === 0 || f.setPopup(N, "goingBack", D, z);
  }, [N, D, z, P, g, x]);
  const [V, B] = Qe(!1);
  function U(Y) {
    Su(Y), B(!0), r();
  }
  function Q(Y) {
    k(Y, null, -1);
  }
  return /* @__PURE__ */ A.jsxs(Lpt, { children: [
    /* @__PURE__ */ A.jsx(Vpt, { device: I, "data-testid": "choice-experiment-container", children: P ? P.map((Y, q) => /* @__PURE__ */ A.jsx(
      Opt,
      {
        profile: Y,
        character: e.characterGenerator ? e.characterGenerator(Y, C) : void 0,
        attributes: e.attributes,
        onClick: v ? () => {
        } : k,
        index: q,
        primaryColour: _,
        shadeColour: e.shade ? b : void 0,
        active: h === q,
        disabled: v,
        profilePosition: q === 0 ? "first" : q === P.length - 1 ? "last" : "middle",
        profileInfo: e.profileInfo
      },
      Dpt(Y, q, E ?? 0)
    )) : g || x === 0 ? /* @__PURE__ */ A.jsx(tp, {}) : /* @__PURE__ */ A.jsx("div", { children: "All choices have been made. Click Next to go to the next question, or Previous to change your answers." }) }),
    e.neitherOption && /* @__PURE__ */ A.jsx(
      cx,
      {
        onClick: Q,
        buttonText: typeof e.neitherOption == "object" ? e.neitherOption.label ?? "No preference" : "No preference",
        active: h === -1,
        colour: _
      }
    ),
    e.allowSkip && (!e.skipAfter || x >= e.skipAfter) && /* @__PURE__ */ A.jsx(
      cx,
      {
        onClick: U,
        buttonText: typeof e.allowSkip == "object" ? e.allowSkip.label ?? "Skip remaining choices" : "Skip remaining choices",
        active: V,
        colour: _
      }
    ),
    e.maxChoices && E !== null && E < e.maxChoices && /* @__PURE__ */ A.jsx(Fpt, { children: /* @__PURE__ */ A.jsxs("i", { children: [
      "Choice ",
      E + 1,
      " of ",
      e.maxChoices
    ] }) })
  ] });
}, Opt = (e) => /* @__PURE__ */ A.jsxs(
  xpt,
  {
    ...e,
    primaryColour: e.primaryColour,
    shadeColour: e.shadeColour,
    onClick: (t) => e.onClick(t, e.profile, e.index),
    active: e.active,
    disabled: e.disabled,
    children: [
      e.character && /* @__PURE__ */ A.jsx(Mpt, { character: e.character }),
      /* @__PURE__ */ A.jsx(Bpt, { "data-testid": "attributes-wrapper", children: /* @__PURE__ */ A.jsx(
        kpt,
        {
          profile: e.profile,
          attributes: e.attributes,
          active: e.active,
          profilePosition: e.profilePosition
        }
      ) }),
      e.profileInfo && /* @__PURE__ */ A.jsx("div", { style: { paddingLeft: "var(--spacing-sm)", paddingTop: "var(--spacing-sm)" }, children: e.profileInfo(e.profile) })
    ]
  }
), Mpt = (e) => {
  var t, n, r, i;
  return /* @__PURE__ */ A.jsxs(zpt, { children: [
    /* @__PURE__ */ A.jsx(
      "img",
      {
        src: (t = e.character) == null ? void 0 : t.image,
        alt: ((n = e.character) == null ? void 0 : n.description) || ((r = e.character) == null ? void 0 : r.name)
      }
    ),
    /* @__PURE__ */ A.jsx("div", { children: (i = e.character) == null ? void 0 : i.name })
  ] });
}, kpt = (e) => /* @__PURE__ */ A.jsx(Hpt, { "data-testid": "attributes-card", children: e.profile.attributes.map((t) => /* @__PURE__ */ A.jsx(
  Npt,
  {
    attributeLevel: t,
    attributes: e.attributes,
    active: e.active,
    profilePosition: e.profilePosition
  },
  t.attributeId
)) }), Npt = (e) => {
  const { attribute: t, level: n } = lK(e.attributeLevel, e.attributes);
  if (n != null && n.hideLevel)
    return null;
  const r = n != null && n.hideName ? void 0 : e.attributeLevel.attributeName ?? (t == null ? void 0 : t.name) ?? e.attributeLevel.attributeId, i = t != null && t.hideName ? void 0 : (n == null ? void 0 : n.description) ?? e.attributeLevel.levelName ?? (n == null ? void 0 : n.value) ?? e.attributeLevel.levelId, o = t == null ? void 0 : t.icon, a = e.profilePosition === "first" ? "left" : e.profilePosition === "last" ? "right" : "top";
  return console.log("tooltipPlacement", a, e.profilePosition, n == null ? void 0 : n.value), /* @__PURE__ */ A.jsx(_2, { title: jpt(t, n), placement: a, children: /* @__PURE__ */ A.jsxs(Upt, { children: [
    /* @__PURE__ */ A.jsx(Wpt, { children: o !== void 0 ? /* @__PURE__ */ A.jsx(o, { height: 64, width: 64, fill: e.active ? "white" : "black" }) : (t == null ? void 0 : t.image) !== void 0 && /* @__PURE__ */ A.jsx("img", { src: t == null ? void 0 : t.image, alt: t.name, height: 64, width: 64 }) }),
    (n == null ? void 0 : n.image) !== void 0 && /* @__PURE__ */ A.jsx(qpt, { children: typeof (n == null ? void 0 : n.image) == "string" ? /* @__PURE__ */ A.jsx("img", { src: n == null ? void 0 : n.image, alt: n == null ? void 0 : n.value.toString() }) : n == null ? void 0 : n.image }),
    /* @__PURE__ */ A.jsxs(Gpt, { children: [
      /* @__PURE__ */ A.jsx(Kpt, { active: e.active, children: r }),
      /* @__PURE__ */ A.jsx(Ypt, { active: e.active, tooltip: !!(n != null && n.tooltip), children: i })
    ] })
  ] }) });
};
function pz(e) {
  return e && lx in e ? e[lx].map((t) => t.info) : [];
}
function Dpt(e, t, n) {
  return `${e.attributes.map((r) => `${r.attributeId}:${r.levelId}`).join("-")}#${t}#${n}`;
}
function jpt(e, t) {
  const n = [];
  return e && e.tooltip && n.push(e.tooltip), t && t.tooltip && n.push(t.tooltip), n.join(`
`);
}
const Lpt = ce.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-sm);
`, Fpt = ce.div``, Vpt = ce.div`
  display: flex;
  flex-direction: ${(e) => e.device === Xn.MOBILE ? "column" : "row"};
  justify-content: space-between;
  align-items: stretch;
  gap: 1rem;
`, Bpt = ce.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`, zpt = ce.div`
  display: flex;
  flex-direction: column;
`, Hpt = ce.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-sm);
`, Upt = ce.div`
  display: flex;
  flex-direction: row;
  gap: var(--spacing-sm);
`, Wpt = ce.div`
  display: flex;
  flex: 0 1;
`, qpt = ce.div`
  display: flex;
  flex: 0 1;
`, Gpt = ce.div`
  display: flex;
  flex-direction: column;
  flex: 4 1 auto;
  gap: var(--spacing-xs);
  align-self: center;
  text-align: left;
`, Kpt = ce.div`
  display: flex;
  color: ${(e) => e.active ? "var(--light)" : "var(--dark)"};
  font-size: var(--choice-text-font-size);
`, Ypt = ce.div`
  display: flex;
  color: ${(e) => e.active ? "var(--light);" : "var(--dark);"};
  font-weight: ${(e) => e.active ? "bold" : "normal"};
  font-size: var(--question-text-font-size);
  ${(e) => e.tooltip && "text-decoration: underline; text-decoration-color: var(--mid); text-decoration-style: dashed;"}
  &:hover {
    ${(e) => e.tooltip && "text-decoration-color: var(--dark);"}
  }
`, Xpt = ce(lm)`
  max-width: 40rem;
`, Qpt = ({
  question: e,
  updateCurrent: t,
  currentAnswer: n,
  submitAnswer: r,
  settings: i
}) => {
  const { primaryColour: o } = Gn(), { popupService: a } = gt(mn), s = No(), c = e.attributes[0].levels, l = e.attributes[1].levels, u = c.length * l.length, d = Math.random() > 0.5 ? e.characters.filter((V) => V.gender === "female") : e.characters.filter((V) => V.gender === "male"), f = [
    {
      id: 1,
      attr_1_index: 1,
      attr_1: c[1].value,
      attr_1_text: c[1].text,
      attr_2: l[0].value,
      attr_2_text: l[0].text
    },
    {
      id: 2,
      attr_1_index: 0,
      attr_1: c[0].value,
      attr_1_text: c[0].text,
      attr_2: l[1].value,
      attr_2_text: l[1].text
    }
  ], h = {
    id: 0,
    attr_1_index: 0,
    attr_1: c[0].value,
    attr_1_text: c[0].text,
    attr_2: l[0].value,
    attr_2_text: l[0].text
  }, p = {
    id: u - 1,
    attr_1_index: c.length - 1,
    attr_1: c[c.length - 1].value,
    attr_1_text: c[c.length - 1].text,
    attr_2: l[1].value,
    attr_2_text: l[1].text
  }, [g, m] = Qe(f[0]), [v, y] = Qe(f[1]), [_, b] = Qe(3), [w, C] = Qe([h]), [x, T] = Qe(!1), E = (V, B, U, Q = w) => {
    const Y = Q.concat(V);
    if (C(Y), V.attr_1_index === c.length - 1) {
      T(!0), V.attr_2 ? R(Y.concat([p])) : R(Jpt(Y, B, c));
      return;
    }
    b(U + 1);
    const q = {
      id: U,
      attr_1_index: V.attr_1_index + 1,
      attr_1: c[V.attr_1_index + 1].value,
      attr_1_text: c[V.attr_1_index + 1].text,
      attr_2: V.attr_2,
      attr_2_text: V.attr_2 ? l[1].text : l[0].text
    };
    q.attr_2 ? (y(q), q.attr_1 === B.attr_1 && E(B, q, U + 1, Y)) : m(q);
  }, R = (V) => {
    const B = V.map((U) => Zpt(U));
    t({
      ...n.getAnswer(),
      value: B
    }), r();
  }, I = (V) => {
    const B = V.attr_2 ? g : v, U = V.attr_2 ? v : g;
    E(B, U, _);
  }, O = (V) => x ? /* @__PURE__ */ A.jsxs(yz, { disabled: !0, primaryColor: o, device: s, children: [
    /* @__PURE__ */ A.jsx(mz, { src: d[0].portrait, device: s }),
    /* @__PURE__ */ A.jsxs(vz, { children: [
      /* @__PURE__ */ A.jsx(Ph, { children: "loading" }),
      /* @__PURE__ */ A.jsx(Ph, { children: V.attr_1_text }),
      /* @__PURE__ */ A.jsx(Ph, { children: V.attr_2_text })
    ] })
  ] }, V.id) : /* @__PURE__ */ A.jsxs(
    yz,
    {
      onClick: () => I(V),
      primaryColor: o,
      device: s,
      children: [
        /* @__PURE__ */ A.jsx(
          mz,
          {
            src: d[V.id % d.length] ? d[V.id % d.length].portrait : d[0].portrait,
            device: s
          }
        ),
        /* @__PURE__ */ A.jsxs(vz, { children: [
          /* @__PURE__ */ A.jsx(Ph, { children: d[V.id % d.length] ? d[V.id % d.length].name : "loading" }),
          /* @__PURE__ */ A.jsx(Ph, { children: V.attr_1_text }),
          /* @__PURE__ */ A.jsx(Ph, { children: V.attr_2_text })
        ] })
      ]
    },
    V.id
  );
  console.log("storeAns", w);
  let P, k;
  d[g.id % d.length] && (P = d[g.id % d.length].name), d[v.id % d.length] && (k = d[v.id % d.length].name);
  const L = {
    default: { content: `Click to choose between ${P} and ${k}` }
  }, N = Ms(L, e.helpPopups), D = e.showHelpPopups ?? !1, z = e.helpPopupsToShow;
  return ot(() => {
    if (P === void 0 || k === void 0) {
      a.clearPopup();
      return;
    }
    a.setPopup(N, "default", D, z);
  }, [N, D, z, P, k]), /* @__PURE__ */ A.jsxs(tmt, { device: s, children: [
    O(g),
    O(v)
  ] });
};
function Jpt(e, t, n) {
  const r = n.slice(t.attr_1_index).map((i, o) => ({
    id: e.length + 1 + o,
    attr_1_index: t.attr_1_index + o,
    attr_1: i.value,
    attr_1_text: i.text,
    attr_2: t.attr_2,
    attr_2_text: t.attr_2_text
  }));
  return console.log("remainingPeople", r), e.concat(r);
}
function Zpt(e) {
  return {
    id: e.id,
    value: `${e.attr_1} - ${e.attr_2}`,
    info: {
      attr_1_index: e.attr_1_index,
      attr_1: e.attr_1,
      attr_2: e.attr_2
    }
  };
}
const mz = ce.img`
  max-height: ${(e) => e.device === Xn.MOBILE ? "10rem" : "15rem"};
  display: flex;
  align-self: center;
`, vz = ce.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: baseline;
  text-align: left;
  gap: 0.5rem;
`, Ph = ce.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`, emt = gi`
   0% {
    opacity: 0;
    // transform: translateY(20px);
  }
  100% {
    opacity: 1;
    // transform: translateY(0);
  }
`, yz = ce.button`
  display: flex;
  flex-direction: ${(e) => e.device === Xn.MOBILE ? "row" : "column"};
  animation: 0.5s ${emt} ease;
  padding: 1rem 1rem;
  cursor: pointer;
  text-align: center;
  text-decoration: none;
  outline: none;
  color: #000;
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.3);
  border-radius: 0.2rem;
  @media (hover: hover) {
    &:hover {
      background-color: ${(e) => e.primaryColor};
      color: #fff;
    }
  }
  &:active {
    background-color: ${(e) => e.primaryColor};
    box-shadow: 0 5px #666;
    border: 3px solid rgba(0, 0, 0, 0.3);
    // transform: translateY(4px);
  }
`, tmt = ce.div`
  display: flex;
  flex-direction: ${(e) => e.device === Xn.MOBILE ? "column" : "row"};
  justify-content: ${(e) => e.device === Xn.MOBILE ? "flex-start" : "space-between"};
  align-items: ${(e) => e.device === Xn.MOBILE ? "baseline" : "stretch"};
  gap: 1rem;
`;
var s4 = {}, ise = { exports: {} };
(function(e) {
  function t(n) {
    return n && n.__esModule ? n : {
      default: n
    };
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(ise);
var dn = ise.exports, ose = { exports: {} }, ase = { exports: {} };
(function(e) {
  function t(n) {
    "@babel/helpers - typeof";
    return e.exports = t = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
      return typeof r;
    } : function(r) {
      return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
    }, e.exports.__esModule = !0, e.exports.default = e.exports, t(n);
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(ase);
var oh = ase.exports;
(function(e) {
  var t = oh.default;
  function n(i) {
    if (typeof WeakMap != "function")
      return null;
    var o = /* @__PURE__ */ new WeakMap(), a = /* @__PURE__ */ new WeakMap();
    return (n = function(c) {
      return c ? a : o;
    })(i);
  }
  function r(i, o) {
    if (!o && i && i.__esModule)
      return i;
    if (i === null || t(i) != "object" && typeof i != "function")
      return {
        default: i
      };
    var a = n(o);
    if (a && a.has(i))
      return a.get(i);
    var s = {
      __proto__: null
    }, c = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var l in i)
      if (l !== "default" && {}.hasOwnProperty.call(i, l)) {
        var u = c ? Object.getOwnPropertyDescriptor(i, l) : null;
        u && (u.get || u.set) ? Object.defineProperty(s, l, u) : s[l] = i[l];
      }
    return s.default = i, a && a.set(i, s), s;
  }
  e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
})(ose);
var pi = ose.exports;
const nmt = /* @__PURE__ */ Ic(p9e);
var sb = {}, RP = { exports: {} }, S2 = {}, sse = { exports: {} };
(function(e) {
  function t() {
    return e.exports = t = Object.assign ? Object.assign.bind() : function(n) {
      for (var r = 1; r < arguments.length; r++) {
        var i = arguments[r];
        for (var o in i)
          ({}).hasOwnProperty.call(i, o) && (n[o] = i[o]);
      }
      return n;
    }, e.exports.__esModule = !0, e.exports.default = e.exports, t.apply(null, arguments);
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(sse);
var cse = sse.exports, c4 = {};
Object.defineProperty(c4, "__esModule", { value: !0 });
var rmt = { icon: { tag: "svg", attrs: { "fill-rule": "evenodd", viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64c247.4 0 448 200.6 448 448S759.4 960 512 960 64 759.4 64 512 264.6 64 512 64zm127.98 274.82h-.04l-.08.06L512 466.75 384.14 338.88c-.04-.05-.06-.06-.08-.06a.12.12 0 00-.07 0c-.03 0-.05.01-.09.05l-45.02 45.02a.2.2 0 00-.05.09.12.12 0 000 .07v.02a.27.27 0 00.06.06L466.75 512 338.88 639.86c-.05.04-.06.06-.06.08a.12.12 0 000 .07c0 .03.01.05.05.09l45.02 45.02a.2.2 0 00.09.05.12.12 0 00.07 0c.02 0 .04-.01.08-.05L512 557.25l127.86 127.87c.04.04.06.05.08.05a.12.12 0 00.07 0c.03 0 .05-.01.09-.05l45.02-45.02a.2.2 0 00.05-.09.12.12 0 000-.07v-.02a.27.27 0 00-.05-.06L557.25 512l127.87-127.86c.04-.04.05-.06.05-.08a.12.12 0 000-.07c0-.03-.01-.05-.05-.09l-45.02-45.02a.2.2 0 00-.09-.05.12.12 0 00-.07 0z" } }] }, name: "close-circle", theme: "filled" };
c4.default = rmt;
var w2 = {}, lse = { exports: {} }, use = { exports: {} };
(function(e) {
  function t(n) {
    if (Array.isArray(n))
      return n;
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(use);
var dse = use.exports, fse = { exports: {} };
(function(e) {
  function t(n, r) {
    var i = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
    if (i != null) {
      var o, a, s, c, l = [], u = !0, d = !1;
      try {
        if (s = (i = i.call(n)).next, r === 0) {
          if (Object(i) !== i)
            return;
          u = !1;
        } else
          for (; !(u = (o = s.call(i)).done) && (l.push(o.value), l.length !== r); u = !0)
            ;
      } catch (f) {
        d = !0, a = f;
      } finally {
        try {
          if (!u && i.return != null && (c = i.return(), Object(c) !== c))
            return;
        } finally {
          if (d)
            throw a;
        }
      }
      return l;
    }
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(fse);
var imt = fse.exports, hse = { exports: {} }, gse = { exports: {} };
(function(e) {
  function t(n, r) {
    (r == null || r > n.length) && (r = n.length);
    for (var i = 0, o = Array(r); i < r; i++)
      o[i] = n[i];
    return o;
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(gse);
var pse = gse.exports;
(function(e) {
  var t = pse;
  function n(r, i) {
    if (r) {
      if (typeof r == "string")
        return t(r, i);
      var o = {}.toString.call(r).slice(8, -1);
      return o === "Object" && r.constructor && (o = r.constructor.name), o === "Map" || o === "Set" ? Array.from(r) : o === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o) ? t(r, i) : void 0;
    }
  }
  e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
})(hse);
var l4 = hse.exports, mse = { exports: {} };
(function(e) {
  function t() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(mse);
var vse = mse.exports;
(function(e) {
  var t = dse, n = imt, r = l4, i = vse;
  function o(a, s) {
    return t(a) || n(a, s) || r(a, s) || i();
  }
  e.exports = o, e.exports.__esModule = !0, e.exports.default = e.exports;
})(lse);
var yse = lse.exports, bse = { exports: {} }, _se = { exports: {} }, Sse = { exports: {} };
(function(e) {
  var t = oh.default;
  function n(r, i) {
    if (t(r) != "object" || !r)
      return r;
    var o = r[Symbol.toPrimitive];
    if (o !== void 0) {
      var a = o.call(r, i || "default");
      if (t(a) != "object")
        return a;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (i === "string" ? String : Number)(r);
  }
  e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
})(Sse);
var omt = Sse.exports;
(function(e) {
  var t = oh.default, n = omt;
  function r(i) {
    var o = n(i, "string");
    return t(o) == "symbol" ? o : o + "";
  }
  e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
})(_se);
var amt = _se.exports;
(function(e) {
  var t = amt;
  function n(r, i, o) {
    return (i = t(i)) in r ? Object.defineProperty(r, i, {
      value: o,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : r[i] = o, r;
  }
  e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
})(bse);
var wse = bse.exports, xse = { exports: {} }, Ese = { exports: {} };
(function(e) {
  function t(n, r) {
    if (n == null)
      return {};
    var i = {};
    for (var o in n)
      if ({}.hasOwnProperty.call(n, o)) {
        if (r.includes(o))
          continue;
        i[o] = n[o];
      }
    return i;
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(Ese);
var smt = Ese.exports;
(function(e) {
  var t = smt;
  function n(r, i) {
    if (r == null)
      return {};
    var o, a, s = t(r, i);
    if (Object.getOwnPropertySymbols) {
      var c = Object.getOwnPropertySymbols(r);
      for (a = 0; a < c.length; a++)
        o = c[a], i.includes(o) || {}.propertyIsEnumerable.call(r, o) && (s[o] = r[o]);
    }
    return s;
  }
  e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
})(xse);
var Cse = xse.exports;
const cb = /* @__PURE__ */ Ic(WMe);
var um = {};
Object.defineProperty(um, "__esModule", {
  value: !0
});
um.default = void 0;
var cmt = j, lmt = /* @__PURE__ */ (0, cmt.createContext)({});
um.default = lmt;
var lb = {}, Tse = { exports: {} };
(function(e) {
  var t = wse;
  function n(i, o) {
    var a = Object.keys(i);
    if (Object.getOwnPropertySymbols) {
      var s = Object.getOwnPropertySymbols(i);
      o && (s = s.filter(function(c) {
        return Object.getOwnPropertyDescriptor(i, c).enumerable;
      })), a.push.apply(a, s);
    }
    return a;
  }
  function r(i) {
    for (var o = 1; o < arguments.length; o++) {
      var a = arguments[o] != null ? arguments[o] : {};
      o % 2 ? n(Object(a), !0).forEach(function(s) {
        t(i, s, a[s]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(i, Object.getOwnPropertyDescriptors(a)) : n(Object(a)).forEach(function(s) {
        Object.defineProperty(i, s, Object.getOwnPropertyDescriptor(a, s));
      });
    }
    return i;
  }
  e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
})(Tse);
var ub = Tse.exports, po = {}, ah = {}, x2 = {};
Object.defineProperty(x2, "__esModule", {
  value: !0
});
x2.default = umt;
function umt() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
var u4 = {};
Object.defineProperty(u4, "__esModule", {
  value: !0
});
u4.default = dmt;
function dmt(e, t) {
  if (!e)
    return !1;
  if (e.contains)
    return e.contains(t);
  for (var n = t; n; ) {
    if (n === e)
      return !0;
    n = n.parentNode;
  }
  return !1;
}
var d4 = dn.default;
Object.defineProperty(ah, "__esModule", {
  value: !0
});
ah.clearContainerCache = ymt;
ah.injectCSS = h4;
ah.removeCSS = mmt;
ah.updateCSS = bmt;
var bz = d4(ub), fmt = d4(x2), hmt = d4(u4), _z = "data-rc-order", Sz = "data-rc-priority", gmt = "rc-util-key", ux = /* @__PURE__ */ new Map();
function Ise() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = e.mark;
  return t ? t.startsWith("data-") ? t : "data-".concat(t) : gmt;
}
function E2(e) {
  if (e.attachTo)
    return e.attachTo;
  var t = document.querySelector("head");
  return t || document.body;
}
function pmt(e) {
  return e === "queue" ? "prependQueue" : e ? "prepend" : "append";
}
function f4(e) {
  return Array.from((ux.get(e) || e).children).filter(function(t) {
    return t.tagName === "STYLE";
  });
}
function h4(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (!(0, fmt.default)())
    return null;
  var n = t.csp, r = t.prepend, i = t.priority, o = i === void 0 ? 0 : i, a = pmt(r), s = a === "prependQueue", c = document.createElement("style");
  c.setAttribute(_z, a), s && o && c.setAttribute(Sz, "".concat(o)), n != null && n.nonce && (c.nonce = n == null ? void 0 : n.nonce), c.innerHTML = e;
  var l = E2(t), u = l.firstChild;
  if (r) {
    if (s) {
      var d = (t.styles || f4(l)).filter(function(f) {
        if (!["prepend", "prependQueue"].includes(f.getAttribute(_z)))
          return !1;
        var h = Number(f.getAttribute(Sz) || 0);
        return o >= h;
      });
      if (d.length)
        return l.insertBefore(c, d[d.length - 1].nextSibling), c;
    }
    l.insertBefore(c, u);
  } else
    l.appendChild(c);
  return c;
}
function $se(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = E2(t);
  return (t.styles || f4(n)).find(function(r) {
    return r.getAttribute(Ise(t)) === e;
  });
}
function mmt(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = $se(e, t);
  if (n) {
    var r = E2(t);
    r.removeChild(n);
  }
}
function vmt(e, t) {
  var n = ux.get(e);
  if (!n || !(0, hmt.default)(document, n)) {
    var r = h4("", t), i = r.parentNode;
    ux.set(e, i), e.removeChild(r);
  }
}
function ymt() {
  ux.clear();
}
function bmt(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = E2(n), i = f4(r), o = (0, bz.default)((0, bz.default)({}, n), {}, {
    styles: i
  });
  vmt(r, o);
  var a = $se(t, o);
  if (a) {
    var s, c;
    if ((s = o.csp) !== null && s !== void 0 && s.nonce && a.nonce !== ((c = o.csp) === null || c === void 0 ? void 0 : c.nonce)) {
      var l;
      a.nonce = (l = o.csp) === null || l === void 0 ? void 0 : l.nonce;
    }
    return a.innerHTML !== e && (a.innerHTML = e), a;
  }
  var u = h4(e, o);
  return u.setAttribute(Ise(o), t), u;
}
var C2 = {};
Object.defineProperty(C2, "__esModule", {
  value: !0
});
C2.getShadowRoot = _mt;
C2.inShadow = Rse;
function Ase(e) {
  var t;
  return e == null || (t = e.getRootNode) === null || t === void 0 ? void 0 : t.call(e);
}
function Rse(e) {
  return Ase(e) instanceof ShadowRoot;
}
function _mt(e) {
  return Rse(e) ? Ase(e) : null;
}
var oa = {};
Object.defineProperty(oa, "__esModule", {
  value: !0
});
oa.call = p4;
oa.default = void 0;
oa.note = Ose;
oa.noteOnce = kse;
oa.preMessage = void 0;
oa.resetWarned = Mse;
oa.warning = Pse;
oa.warningOnce = db;
var PP = {}, g4 = [], Smt = oa.preMessage = function(t) {
  g4.push(t);
};
function Pse(e, t) {
  if (process.env.NODE_ENV !== "production" && !e && console !== void 0) {
    var n = g4.reduce(function(r, i) {
      return i(r ?? "", "warning");
    }, t);
    n && console.error("Warning: ".concat(n));
  }
}
function Ose(e, t) {
  if (process.env.NODE_ENV !== "production" && !e && console !== void 0) {
    var n = g4.reduce(function(r, i) {
      return i(r ?? "", "note");
    }, t);
    n && console.warn("Note: ".concat(n));
  }
}
function Mse() {
  PP = {};
}
function p4(e, t, n) {
  !t && !PP[n] && (e(!1, n), PP[n] = !0);
}
function db(e, t) {
  p4(Pse, e, t);
}
function kse(e, t) {
  p4(Ose, e, t);
}
db.preMessage = Smt;
db.resetWarned = Mse;
db.noteOnce = kse;
oa.default = db;
var wmt = pi.default, T2 = dn.default;
Object.defineProperty(po, "__esModule", {
  value: !0
});
po.generate = MP;
po.getSecondaryColor = Pmt;
po.iconStyles = void 0;
po.isIconDefinition = Rmt;
po.normalizeAttrs = OP;
po.normalizeTwoToneColors = Omt;
po.useInsertStyles = po.svgBaseProps = void 0;
po.warning = Amt;
var TI = T2(ub), wz = T2(oh), xmt = cb, Emt = ah, Cmt = C2, Tmt = T2(oa), dx = wmt(j), Imt = T2(um);
function $mt(e) {
  return e.replace(/-(.)/g, function(t, n) {
    return n.toUpperCase();
  });
}
function Amt(e, t) {
  (0, Tmt.default)(e, "[@ant-design/icons] ".concat(t));
}
function Rmt(e) {
  return (0, wz.default)(e) === "object" && typeof e.name == "string" && typeof e.theme == "string" && ((0, wz.default)(e.icon) === "object" || typeof e.icon == "function");
}
function OP() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  return Object.keys(e).reduce(function(t, n) {
    var r = e[n];
    switch (n) {
      case "class":
        t.className = r, delete t.class;
        break;
      default:
        delete t[n], t[$mt(n)] = r;
    }
    return t;
  }, {});
}
function MP(e, t, n) {
  return n ? /* @__PURE__ */ dx.default.createElement(e.tag, (0, TI.default)((0, TI.default)({
    key: t
  }, OP(e.attrs)), n), (e.children || []).map(function(r, i) {
    return MP(r, "".concat(t, "-").concat(e.tag, "-").concat(i));
  })) : /* @__PURE__ */ dx.default.createElement(e.tag, (0, TI.default)({
    key: t
  }, OP(e.attrs)), (e.children || []).map(function(r, i) {
    return MP(r, "".concat(t, "-").concat(e.tag, "-").concat(i));
  }));
}
function Pmt(e) {
  return (0, xmt.generate)(e)[0];
}
function Omt(e) {
  return e ? Array.isArray(e) ? e : [e] : [];
}
po.svgBaseProps = {
  width: "1em",
  height: "1em",
  fill: "currentColor",
  "aria-hidden": "true",
  focusable: "false"
};
var Mmt = po.iconStyles = `
.anticon {
  display: inline-flex;
  align-items: center;
  color: inherit;
  font-style: normal;
  line-height: 0;
  text-align: center;
  text-transform: none;
  vertical-align: -0.125em;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.anticon > * {
  line-height: 1;
}

.anticon svg {
  display: inline-block;
}

.anticon::before {
  display: none;
}

.anticon .anticon-icon {
  display: block;
}

.anticon[tabindex] {
  cursor: pointer;
}

.anticon-spin::before,
.anticon-spin {
  display: inline-block;
  -webkit-animation: loadingCircle 1s infinite linear;
  animation: loadingCircle 1s infinite linear;
}

@-webkit-keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
`;
po.useInsertStyles = function(t) {
  var n = (0, dx.useContext)(Imt.default), r = n.csp, i = n.prefixCls, o = Mmt;
  i && (o = o.replace(/anticon/g, i)), (0, dx.useEffect)(function() {
    var a = t.current, s = (0, Cmt.getShadowRoot)(a);
    (0, Emt.updateCSS)(o, "@ant-design-icons", {
      prepend: !0,
      csp: r,
      attachTo: s
    });
  }, []);
};
var Nse = dn.default, kmt = pi.default;
Object.defineProperty(lb, "__esModule", {
  value: !0
});
lb.default = void 0;
var Nmt = Nse(Cse), _0 = Nse(ub), Dmt = kmt(j), $d = po, jmt = ["icon", "className", "onClick", "style", "primaryColor", "secondaryColor"], X0 = {
  primaryColor: "#333",
  secondaryColor: "#E6E6E6",
  calculated: !1
};
function Lmt(e) {
  var t = e.primaryColor, n = e.secondaryColor;
  X0.primaryColor = t, X0.secondaryColor = n || (0, $d.getSecondaryColor)(t), X0.calculated = !!n;
}
function Fmt() {
  return (0, _0.default)({}, X0);
}
var I2 = function(t) {
  var n = t.icon, r = t.className, i = t.onClick, o = t.style, a = t.primaryColor, s = t.secondaryColor, c = (0, Nmt.default)(t, jmt), l = Dmt.useRef(), u = X0;
  if (a && (u = {
    primaryColor: a,
    secondaryColor: s || (0, $d.getSecondaryColor)(a)
  }), (0, $d.useInsertStyles)(l), (0, $d.warning)((0, $d.isIconDefinition)(n), "icon should be icon definiton, but got ".concat(n)), !(0, $d.isIconDefinition)(n))
    return null;
  var d = n;
  return d && typeof d.icon == "function" && (d = (0, _0.default)((0, _0.default)({}, d), {}, {
    icon: d.icon(u.primaryColor, u.secondaryColor)
  })), (0, $d.generate)(d.icon, "svg-".concat(d.name), (0, _0.default)((0, _0.default)({
    className: r,
    onClick: i,
    style: o,
    "data-icon": d.name,
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true"
  }, c), {}, {
    ref: l
  }));
};
I2.displayName = "IconReact";
I2.getTwoToneColors = Fmt;
I2.setTwoToneColors = Lmt;
lb.default = I2;
var $2 = {}, Dse = dn.default;
Object.defineProperty($2, "__esModule", {
  value: !0
});
$2.getTwoToneColor = Hmt;
$2.setTwoToneColor = zmt;
var Vmt = Dse(yse), jse = Dse(lb), Bmt = po;
function zmt(e) {
  var t = (0, Bmt.normalizeTwoToneColors)(e), n = (0, Vmt.default)(t, 2), r = n[0], i = n[1];
  return jse.default.setTwoToneColors({
    primaryColor: r,
    secondaryColor: i
  });
}
function Hmt() {
  var e = jse.default.getTwoToneColors();
  return e.calculated ? [e.primaryColor, e.secondaryColor] : e.primaryColor;
}
var sh = dn.default, Umt = pi.default;
Object.defineProperty(w2, "__esModule", {
  value: !0
});
w2.default = void 0;
var Wmt = sh(cse), qmt = sh(yse), xz = sh(wse), Gmt = sh(Cse), j1 = Umt(j), Kmt = sh(qp), Ymt = cb, Xmt = sh(um), Qmt = sh(lb), m4 = $2, Jmt = po, Zmt = ["className", "icon", "spin", "rotate", "tabIndex", "onClick", "twoToneColor"];
(0, m4.setTwoToneColor)(Ymt.blue.primary);
var A2 = /* @__PURE__ */ j1.forwardRef(function(e, t) {
  var n = e.className, r = e.icon, i = e.spin, o = e.rotate, a = e.tabIndex, s = e.onClick, c = e.twoToneColor, l = (0, Gmt.default)(e, Zmt), u = j1.useContext(Xmt.default), d = u.prefixCls, f = d === void 0 ? "anticon" : d, h = u.rootClassName, p = (0, Kmt.default)(h, f, (0, xz.default)((0, xz.default)({}, "".concat(f, "-").concat(r.name), !!r.name), "".concat(f, "-spin"), !!i || r.name === "loading"), n), g = a;
  g === void 0 && s && (g = -1);
  var m = o ? {
    msTransform: "rotate(".concat(o, "deg)"),
    transform: "rotate(".concat(o, "deg)")
  } : void 0, v = (0, Jmt.normalizeTwoToneColors)(c), y = (0, qmt.default)(v, 2), _ = y[0], b = y[1];
  return /* @__PURE__ */ j1.createElement("span", (0, Wmt.default)({
    role: "img",
    "aria-label": r.name
  }, l, {
    ref: t,
    tabIndex: g,
    onClick: s,
    className: p
  }), /* @__PURE__ */ j1.createElement(Qmt.default, {
    icon: r,
    primaryColor: _,
    secondaryColor: b,
    style: m
  }));
});
A2.displayName = "AntdIcon";
A2.getTwoToneColor = m4.getTwoToneColor;
A2.setTwoToneColor = m4.setTwoToneColor;
w2.default = A2;
var e0t = pi.default, v4 = dn.default;
Object.defineProperty(S2, "__esModule", {
  value: !0
});
S2.default = void 0;
var t0t = v4(cse), Lse = e0t(j), n0t = v4(c4), r0t = v4(w2), i0t = function(t, n) {
  return /* @__PURE__ */ Lse.createElement(r0t.default, (0, t0t.default)({}, t, {
    ref: n,
    icon: n0t.default
  }));
}, Fse = /* @__PURE__ */ Lse.forwardRef(i0t);
process.env.NODE_ENV !== "production" && (Fse.displayName = "CloseCircleFilled");
S2.default = Fse;
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  const n = r(S2);
  function r(o) {
    return o && o.__esModule ? o : { default: o };
  }
  const i = n;
  t.default = i, e.exports = i;
})(RP, RP.exports);
var o0t = RP.exports, Vse = dn.default;
Object.defineProperty(sb, "__esModule", {
  value: !0
});
sb.default = void 0;
var a0t = Vse(j), s0t = Vse(o0t);
const c0t = (e) => {
  let t;
  return typeof e == "object" && (e != null && e.clearIcon) ? t = e : e && (t = {
    clearIcon: /* @__PURE__ */ a0t.default.createElement(s0t.default, null)
  }), t;
};
sb.default = c0t;
var dm = {}, l0t = dn.default;
Object.defineProperty(dm, "__esModule", {
  value: !0
});
dm.getMergedStatus = void 0;
dm.getStatusClassNames = d0t;
var u0t = l0t(qp);
function d0t(e, t, n) {
  return (0, u0t.default)({
    [`${e}-status-success`]: t === "success",
    [`${e}-status-warning`]: t === "warning",
    [`${e}-status-error`]: t === "error",
    [`${e}-status-validating`]: t === "validating",
    [`${e}-has-feedback`]: n
  });
}
const f0t = (e, t) => t || e;
dm.getMergedStatus = f0t;
var fo = {}, Bse = pi.default;
Object.defineProperty(fo, "__esModule", {
  value: !0
});
fo.devUseWarning = fo.default = fo.WarningContext = void 0;
fo.noop = y4;
fo.resetWarned = Use;
var zse = Bse(j), Hse = Bse(oa);
function y4() {
}
let zc = null;
function Use() {
  zc = null, (0, Hse.resetWarned)();
}
let b4 = y4;
process.env.NODE_ENV !== "production" && (b4 = (e, t, n) => {
  (0, Hse.default)(e, `[antd: ${t}] ${n}`), process.env.NODE_ENV === "test" && Use();
});
const h0t = fo.WarningContext = /* @__PURE__ */ zse.createContext({});
fo.devUseWarning = process.env.NODE_ENV !== "production" ? (e) => {
  const {
    strict: t
  } = zse.useContext(h0t), n = (r, i, o) => {
    if (!r)
      if (t === !1 && i === "deprecated") {
        const a = zc;
        zc || (zc = {}), zc[e] = zc[e] || [], zc[e].includes(o || "") || zc[e].push(o || ""), a || console.warn("[antd] There exists deprecated usage in your code:", zc);
      } else
        process.env.NODE_ENV !== "production" && b4(r, e, o);
  };
  return n.deprecated = (r, i, o, a) => {
    n(r, "deprecated", `\`${i}\` is deprecated. Please use \`${o}\` instead.${a ? ` ${a}` : ""}`);
  }, n;
} : () => {
  const e = () => {
  };
  return e.deprecated = y4, e;
};
fo.default = b4;
var fb = {};
const dd = /* @__PURE__ */ Ic(lMe);
var hb = {}, g0t = pi.default;
Object.defineProperty(hb, "__esModule", {
  value: !0
});
hb.default = m0t;
var p0t = g0t(j);
function m0t(e, t, n) {
  var r = p0t.useRef({});
  return (!("value" in r.current) || n(r.current.condition, t)) && (r.current.value = e(), r.current.condition = t), r.current.value;
}
var R2 = {}, Wse = { exports: {} }, qse = { exports: {} };
(function(e) {
  var t = pse;
  function n(r) {
    if (Array.isArray(r))
      return t(r);
  }
  e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
})(qse);
var v0t = qse.exports, Gse = { exports: {} };
(function(e) {
  function t(n) {
    if (typeof Symbol < "u" && n[Symbol.iterator] != null || n["@@iterator"] != null)
      return Array.from(n);
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(Gse);
var Kse = Gse.exports, Yse = { exports: {} };
(function(e) {
  function t() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(Yse);
var y0t = Yse.exports;
(function(e) {
  var t = v0t, n = Kse, r = l4, i = y0t;
  function o(a) {
    return t(a) || n(a) || r(a) || i();
  }
  e.exports = o, e.exports.__esModule = !0, e.exports.default = e.exports;
})(Wse);
var b0t = Wse.exports, Xse = { exports: {} };
(function(e) {
  var t = dse, n = Kse, r = l4, i = vse;
  function o(a) {
    return t(a) || n(a) || r(a) || i();
  }
  e.exports = o, e.exports.__esModule = !0, e.exports.default = e.exports;
})(Xse);
var _0t = Xse.exports, _4 = {};
Object.defineProperty(_4, "__esModule", {
  value: !0
});
_4.default = S0t;
function S0t(e, t) {
  for (var n = e, r = 0; r < t.length; r += 1) {
    if (n == null)
      return;
    n = n[t[r]];
  }
  return n;
}
var gb = dn.default;
Object.defineProperty(R2, "__esModule", {
  value: !0
});
R2.default = C_;
R2.merge = T0t;
var Qse = gb(oh), w0t = gb(ub), Jse = gb(b0t), x0t = gb(_0t), kP = gb(_4);
function Zse(e, t, n, r) {
  if (!t.length)
    return n;
  var i = (0, x0t.default)(t), o = i[0], a = i.slice(1), s;
  return !e && typeof o == "number" ? s = [] : Array.isArray(e) ? s = (0, Jse.default)(e) : s = (0, w0t.default)({}, e), r && n === void 0 && a.length === 1 ? delete s[o][a[0]] : s[o] = Zse(s[o], a, n, r), s;
}
function C_(e, t, n) {
  var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
  return t.length && r && n === void 0 && !(0, kP.default)(e, t.slice(0, -1)) ? e : Zse(e, t, n, r);
}
function E0t(e) {
  return (0, Qse.default)(e) === "object" && e !== null && Object.getPrototypeOf(e) === Object.prototype;
}
function Ez(e) {
  return Array.isArray(e) ? [] : {};
}
var C0t = typeof Reflect > "u" ? Object.keys : Reflect.ownKeys;
function T0t() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  var r = Ez(t[0]);
  return t.forEach(function(i) {
    function o(a, s) {
      var c = new Set(s), l = (0, kP.default)(i, a), u = Array.isArray(l);
      if (u || E0t(l)) {
        if (!c.has(l)) {
          c.add(l);
          var d = (0, kP.default)(r, a);
          u ? r = C_(r, a, []) : (!d || (0, Qse.default)(d) !== "object") && (r = C_(r, a, Ez(l))), C0t(l).forEach(function(f) {
            o([].concat((0, Jse.default)(a), [f]), c);
          });
        }
      } else
        r = C_(r, a, l);
    }
    o([]);
  }), r;
}
var P2 = {};
Object.defineProperty(P2, "__esModule", {
  value: !0
});
P2.default = void 0;
var I0t = j;
P2.default = /* @__PURE__ */ (0, I0t.createContext)(void 0);
var ece = {}, O2 = {}, fm = {}, M2 = {};
Object.defineProperty(M2, "__esModule", {
  value: !0
});
M2.default = void 0;
var $0t = {
  // Options
  items_per_page: "/ page",
  jump_to: "Go to",
  jump_to_confirm: "confirm",
  page: "Page",
  // Pagination
  prev_page: "Previous Page",
  next_page: "Next Page",
  prev_5: "Previous 5 Pages",
  next_5: "Next 5 Pages",
  prev_3: "Previous 3 Pages",
  next_3: "Next 3 Pages",
  page_size: "Page Size"
};
M2.default = $0t;
var k2 = {}, pb = {}, N2 = {}, D2 = {};
Object.defineProperty(D2, "__esModule", {
  value: !0
});
D2.commonLocale = void 0;
D2.commonLocale = {
  yearFormat: "YYYY",
  dayFormat: "D",
  cellMeridiemFormat: "A",
  monthBeforeYear: !0
};
var A0t = dn.default;
Object.defineProperty(N2, "__esModule", {
  value: !0
});
N2.default = void 0;
var Cz = A0t(ub), R0t = D2, P0t = (0, Cz.default)((0, Cz.default)({}, R0t.commonLocale), {}, {
  locale: "en_US",
  today: "Today",
  now: "Now",
  backToToday: "Back to today",
  ok: "OK",
  clear: "Clear",
  month: "Month",
  year: "Year",
  timeSelect: "select time",
  dateSelect: "select date",
  weekSelect: "Choose a week",
  monthSelect: "Choose a month",
  yearSelect: "Choose a year",
  decadeSelect: "Choose a decade",
  dateFormat: "M/D/YYYY",
  dateTimeFormat: "M/D/YYYY HH:mm:ss",
  previousMonth: "Previous month (PageUp)",
  nextMonth: "Next month (PageDown)",
  previousYear: "Last year (Control + left)",
  nextYear: "Next year (Control + right)",
  previousDecade: "Last decade",
  nextDecade: "Next decade",
  previousCentury: "Last century",
  nextCentury: "Next century"
});
N2.default = P0t;
var mb = {};
Object.defineProperty(mb, "__esModule", {
  value: !0
});
mb.default = void 0;
const O0t = {
  placeholder: "Select time",
  rangePlaceholder: ["Start time", "End time"]
};
mb.default = O0t;
var tce = dn.default;
Object.defineProperty(pb, "__esModule", {
  value: !0
});
pb.default = void 0;
var M0t = tce(N2), k0t = tce(mb);
const N0t = {
  lang: Object.assign({
    placeholder: "Select date",
    yearPlaceholder: "Select year",
    quarterPlaceholder: "Select quarter",
    monthPlaceholder: "Select month",
    weekPlaceholder: "Select week",
    rangePlaceholder: ["Start date", "End date"],
    rangeYearPlaceholder: ["Start year", "End year"],
    rangeQuarterPlaceholder: ["Start quarter", "End quarter"],
    rangeMonthPlaceholder: ["Start month", "End month"],
    rangeWeekPlaceholder: ["Start week", "End week"]
  }, M0t.default),
  timePickerLocale: Object.assign({}, k0t.default)
};
pb.default = N0t;
var D0t = dn.default;
Object.defineProperty(k2, "__esModule", {
  value: !0
});
k2.default = void 0;
var j0t = D0t(pb);
k2.default = j0t.default;
var j2 = dn.default;
Object.defineProperty(fm, "__esModule", {
  value: !0
});
fm.default = void 0;
var L0t = j2(M2), F0t = j2(k2), V0t = j2(pb), B0t = j2(mb);
const da = "${label} is not a valid ${type}", z0t = {
  locale: "en",
  Pagination: L0t.default,
  DatePicker: V0t.default,
  TimePicker: B0t.default,
  Calendar: F0t.default,
  global: {
    placeholder: "Please select"
  },
  Table: {
    filterTitle: "Filter menu",
    filterConfirm: "OK",
    filterReset: "Reset",
    filterEmptyText: "No filters",
    filterCheckall: "Select all items",
    filterSearchPlaceholder: "Search in filters",
    emptyText: "No data",
    selectAll: "Select current page",
    selectInvert: "Invert current page",
    selectNone: "Clear all data",
    selectionAll: "Select all data",
    sortTitle: "Sort",
    expand: "Expand row",
    collapse: "Collapse row",
    triggerDesc: "Click to sort descending",
    triggerAsc: "Click to sort ascending",
    cancelSort: "Click to cancel sorting"
  },
  Tour: {
    Next: "Next",
    Previous: "Previous",
    Finish: "Finish"
  },
  Modal: {
    okText: "OK",
    cancelText: "Cancel",
    justOkText: "OK"
  },
  Popconfirm: {
    okText: "OK",
    cancelText: "Cancel"
  },
  Transfer: {
    titles: ["", ""],
    searchPlaceholder: "Search here",
    itemUnit: "item",
    itemsUnit: "items",
    remove: "Remove",
    selectCurrent: "Select current page",
    removeCurrent: "Remove current page",
    selectAll: "Select all data",
    deselectAll: "Deselect all data",
    removeAll: "Remove all data",
    selectInvert: "Invert current page"
  },
  Upload: {
    uploading: "Uploading...",
    removeFile: "Remove file",
    uploadError: "Upload error",
    previewFile: "Preview file",
    downloadFile: "Download file"
  },
  Empty: {
    description: "No data"
  },
  Icon: {
    icon: "icon"
  },
  Text: {
    edit: "Edit",
    copy: "Copy",
    copied: "Copied",
    expand: "Expand",
    collapse: "Collapse"
  },
  Form: {
    optional: "(optional)",
    defaultValidateMessages: {
      default: "Field validation error for ${label}",
      required: "Please enter ${label}",
      enum: "${label} must be one of [${enum}]",
      whitespace: "${label} cannot be a blank character",
      date: {
        format: "${label} date format is invalid",
        parse: "${label} cannot be converted to a date",
        invalid: "${label} is an invalid date"
      },
      types: {
        string: da,
        method: da,
        array: da,
        object: da,
        number: da,
        date: da,
        boolean: da,
        integer: da,
        float: da,
        regexp: da,
        email: da,
        url: da,
        hex: da
      },
      string: {
        len: "${label} must be ${len} characters",
        min: "${label} must be at least ${min} characters",
        max: "${label} must be up to ${max} characters",
        range: "${label} must be between ${min}-${max} characters"
      },
      number: {
        len: "${label} must be equal to ${len}",
        min: "${label} must be minimum ${min}",
        max: "${label} must be maximum ${max}",
        range: "${label} must be between ${min}-${max}"
      },
      array: {
        len: "Must be ${len} ${label}",
        min: "At least ${min} ${label}",
        max: "At most ${max} ${label}",
        range: "The amount of ${label} must be between ${min}-${max}"
      },
      pattern: {
        mismatch: "${label} does not match the pattern ${pattern}"
      }
    }
  },
  Image: {
    preview: "Preview"
  },
  QRCode: {
    expired: "QR code expired",
    refresh: "Refresh",
    scanned: "Scanned"
  },
  ColorPicker: {
    presetEmpty: "Empty",
    transparent: "Transparent",
    singleColor: "Single",
    gradientColor: "Gradient"
  }
};
fm.default = z0t;
var H0t = dn.default;
Object.defineProperty(O2, "__esModule", {
  value: !0
});
O2.changeConfirmLocale = U0t;
O2.getConfirmLocale = W0t;
var S4 = H0t(fm);
let T_ = Object.assign({}, S4.default.Modal), I_ = [];
const Tz = () => I_.reduce((e, t) => Object.assign(Object.assign({}, e), t), S4.default.Modal);
function U0t(e) {
  if (e) {
    const t = Object.assign({}, e);
    return I_.push(t), T_ = Tz(), () => {
      I_ = I_.filter((n) => n !== t), T_ = Tz();
    };
  }
  T_ = Object.assign({}, S4.default.Modal);
}
function W0t() {
  return T_;
}
var hm = {};
Object.defineProperty(hm, "__esModule", {
  value: !0
});
hm.default = void 0;
var q0t = j;
const G0t = /* @__PURE__ */ (0, q0t.createContext)(void 0);
hm.default = G0t;
var L2 = {}, nce = dn.default, K0t = pi.default;
Object.defineProperty(L2, "__esModule", {
  value: !0
});
L2.default = void 0;
var II = K0t(j), Y0t = nce(hm), Iz = nce(fm);
const X0t = (e, t) => {
  const n = II.useContext(Y0t.default), r = II.useMemo(() => {
    var o;
    const a = t || Iz.default[e], s = (o = n == null ? void 0 : n[e]) !== null && o !== void 0 ? o : {};
    return Object.assign(Object.assign({}, typeof a == "function" ? a() : a), s || {});
  }, [e, t, n]), i = II.useMemo(() => {
    const o = n == null ? void 0 : n.locale;
    return n != null && n.exist && !o ? Iz.default.locale : o;
  }, [n]);
  return [r, i];
};
L2.default = X0t;
(function(e) {
  "use client";
  var t = dn.default, n = pi.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = e.ANT_MARK = void 0, Object.defineProperty(e, "useLocale", {
    enumerable: !0,
    get: function() {
      return s.default;
    }
  });
  var r = n(j), i = fo, o = O2, a = t(hm), s = t(L2);
  const c = e.ANT_MARK = "internalMark", l = (u) => {
    const {
      locale: d = {},
      children: f,
      _ANT_MARK__: h
    } = u;
    if (process.env.NODE_ENV !== "production") {
      const g = (0, i.devUseWarning)("LocaleProvider");
      process.env.NODE_ENV !== "production" && g(h === c, "deprecated", "`LocaleProvider` is deprecated. Please use `locale` with `ConfigProvider` instead: http://u.ant.design/locale");
    }
    r.useEffect(() => (0, o.changeConfirmLocale)(d == null ? void 0 : d.Modal), [d]);
    const p = r.useMemo(() => Object.assign(Object.assign({}, d), {
      exist: !0
    }), [d]);
    return /* @__PURE__ */ r.createElement(a.default.Provider, {
      value: p
    }, f);
  };
  process.env.NODE_ENV !== "production" && (l.displayName = "LocaleProvider"), e.default = l;
})(ece);
var yc = {}, w4 = {}, Cc = {};
Object.defineProperty(Cc, "__esModule", {
  value: !0
});
Cc.defaultPresetColors = Cc.default = void 0;
const Q0t = Cc.defaultPresetColors = {
  blue: "#1677FF",
  purple: "#722ED1",
  cyan: "#13C2C2",
  green: "#52C41A",
  magenta: "#EB2F96",
  /**
   * @deprecated Use magenta instead
   */
  pink: "#EB2F96",
  red: "#F5222D",
  orange: "#FA8C16",
  yellow: "#FADB14",
  volcano: "#FA541C",
  geekblue: "#2F54EB",
  gold: "#FAAD14",
  lime: "#A0D911"
}, J0t = Object.assign(Object.assign({}, Q0t), {
  // Color
  colorPrimary: "#1677ff",
  colorSuccess: "#52c41a",
  colorWarning: "#faad14",
  colorError: "#ff4d4f",
  colorInfo: "#1677ff",
  colorLink: "",
  colorTextBase: "",
  colorBgBase: "",
  // Font
  fontFamily: `-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,
'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',
'Noto Color Emoji'`,
  fontFamilyCode: "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace",
  fontSize: 14,
  // Line
  lineWidth: 1,
  lineType: "solid",
  // Motion
  motionUnit: 0.1,
  motionBase: 0,
  motionEaseOutCirc: "cubic-bezier(0.08, 0.82, 0.17, 1)",
  motionEaseInOutCirc: "cubic-bezier(0.78, 0.14, 0.15, 0.86)",
  motionEaseOut: "cubic-bezier(0.215, 0.61, 0.355, 1)",
  motionEaseInOut: "cubic-bezier(0.645, 0.045, 0.355, 1)",
  motionEaseOutBack: "cubic-bezier(0.12, 0.4, 0.29, 1.46)",
  motionEaseInBack: "cubic-bezier(0.71, -0.46, 0.88, 0.6)",
  motionEaseInQuint: "cubic-bezier(0.755, 0.05, 0.855, 0.06)",
  motionEaseOutQuint: "cubic-bezier(0.23, 1, 0.32, 1)",
  // Radius
  borderRadius: 6,
  // Size
  sizeUnit: 4,
  sizeStep: 4,
  sizePopupArrow: 16,
  // Control Base
  controlHeight: 32,
  // zIndex
  zIndexBase: 0,
  zIndexPopupBase: 1e3,
  // Image
  opacityImage: 1,
  // Wireframe
  wireframe: !1,
  // Motion
  motion: !0
});
Cc.default = J0t;
var x4 = {};
const vb = /* @__PURE__ */ Ic(jMe);
Object.defineProperty(x4, "__esModule", {
  value: !0
});
x4.default = Z0t;
var $I = vb;
function Z0t(e, t) {
  let {
    generateColorPalettes: n,
    generateNeutralColorPalettes: r
  } = t;
  const {
    colorSuccess: i,
    colorWarning: o,
    colorError: a,
    colorInfo: s,
    colorPrimary: c,
    colorBgBase: l,
    colorTextBase: u
  } = e, d = n(c), f = n(i), h = n(o), p = n(a), g = n(s), m = r(l, u), v = e.colorLink || e.colorInfo, y = n(v), _ = new $I.TinyColor(p[1]).mix(new $I.TinyColor(p[3]), 50).toHexString();
  return Object.assign(Object.assign({}, m), {
    colorPrimaryBg: d[1],
    colorPrimaryBgHover: d[2],
    colorPrimaryBorder: d[3],
    colorPrimaryBorderHover: d[4],
    colorPrimaryHover: d[5],
    colorPrimary: d[6],
    colorPrimaryActive: d[7],
    colorPrimaryTextHover: d[8],
    colorPrimaryText: d[9],
    colorPrimaryTextActive: d[10],
    colorSuccessBg: f[1],
    colorSuccessBgHover: f[2],
    colorSuccessBorder: f[3],
    colorSuccessBorderHover: f[4],
    colorSuccessHover: f[4],
    colorSuccess: f[6],
    colorSuccessActive: f[7],
    colorSuccessTextHover: f[8],
    colorSuccessText: f[9],
    colorSuccessTextActive: f[10],
    colorErrorBg: p[1],
    colorErrorBgHover: p[2],
    colorErrorBgFilledHover: _,
    colorErrorBgActive: p[3],
    colorErrorBorder: p[3],
    colorErrorBorderHover: p[4],
    colorErrorHover: p[5],
    colorError: p[6],
    colorErrorActive: p[7],
    colorErrorTextHover: p[8],
    colorErrorText: p[9],
    colorErrorTextActive: p[10],
    colorWarningBg: h[1],
    colorWarningBgHover: h[2],
    colorWarningBorder: h[3],
    colorWarningBorderHover: h[4],
    colorWarningHover: h[4],
    colorWarning: h[6],
    colorWarningActive: h[7],
    colorWarningTextHover: h[8],
    colorWarningText: h[9],
    colorWarningTextActive: h[10],
    colorInfoBg: g[1],
    colorInfoBgHover: g[2],
    colorInfoBorder: g[3],
    colorInfoBorderHover: g[4],
    colorInfoHover: g[4],
    colorInfo: g[6],
    colorInfoActive: g[7],
    colorInfoTextHover: g[8],
    colorInfoText: g[9],
    colorInfoTextActive: g[10],
    colorLinkHover: y[4],
    colorLink: y[6],
    colorLinkActive: y[7],
    colorBgMask: new $I.TinyColor("#000").setAlpha(0.45).toRgbString(),
    colorWhite: "#fff"
  });
}
var E4 = {}, F2 = {};
Object.defineProperty(F2, "__esModule", {
  value: !0
});
F2.default = void 0;
const evt = (e) => {
  let t = e, n = e, r = e, i = e;
  return e < 6 && e >= 5 ? t = e + 1 : e < 16 && e >= 6 ? t = e + 2 : e >= 16 && (t = 16), e < 7 && e >= 5 ? n = 4 : e < 8 && e >= 7 ? n = 5 : e < 14 && e >= 8 ? n = 6 : e < 16 && e >= 14 ? n = 7 : e >= 16 && (n = 8), e < 6 && e >= 2 ? r = 1 : e >= 6 && (r = 2), e > 4 && e < 8 ? i = 4 : e >= 8 && (i = 6), {
    borderRadius: e,
    borderRadiusXS: r,
    borderRadiusSM: n,
    borderRadiusLG: t,
    borderRadiusOuter: i
  };
};
F2.default = evt;
var tvt = dn.default;
Object.defineProperty(E4, "__esModule", {
  value: !0
});
E4.default = rvt;
var nvt = tvt(F2);
function rvt(e) {
  const {
    motionUnit: t,
    motionBase: n,
    borderRadius: r,
    lineWidth: i
  } = e;
  return Object.assign({
    // motion
    motionDurationFast: `${(n + t).toFixed(1)}s`,
    motionDurationMid: `${(n + t * 2).toFixed(1)}s`,
    motionDurationSlow: `${(n + t * 3).toFixed(1)}s`,
    // line
    lineWidthBold: i + 1
  }, (0, nvt.default)(r));
}
var V2 = {};
Object.defineProperty(V2, "__esModule", {
  value: !0
});
V2.default = void 0;
const ivt = (e) => {
  const {
    controlHeight: t
  } = e;
  return {
    controlHeightSM: t * 0.75,
    controlHeightXS: t * 0.5,
    controlHeightLG: t * 1.25
  };
};
V2.default = ivt;
var B2 = {}, yb = {};
Object.defineProperty(yb, "__esModule", {
  value: !0
});
yb.default = ovt;
yb.getLineHeight = rce;
function rce(e) {
  return (e + 8) / e;
}
function ovt(e) {
  const t = new Array(10).fill(null).map((n, r) => {
    const i = r - 1, o = e * Math.pow(Math.E, i / 5), a = r > 1 ? Math.floor(o) : Math.ceil(o);
    return Math.floor(a / 2) * 2;
  });
  return t[1] = e, t.map((n) => ({
    size: n,
    lineHeight: rce(n)
  }));
}
var avt = dn.default;
Object.defineProperty(B2, "__esModule", {
  value: !0
});
B2.default = void 0;
var svt = avt(yb);
const cvt = (e) => {
  const t = (0, svt.default)(e), n = t.map((u) => u.size), r = t.map((u) => u.lineHeight), i = n[1], o = n[0], a = n[2], s = r[1], c = r[0], l = r[2];
  return {
    fontSizeSM: o,
    fontSize: i,
    fontSizeLG: a,
    fontSizeXL: n[3],
    fontSizeHeading1: n[6],
    fontSizeHeading2: n[5],
    fontSizeHeading3: n[4],
    fontSizeHeading4: n[3],
    fontSizeHeading5: n[2],
    lineHeight: s,
    lineHeightLG: l,
    lineHeightSM: c,
    fontHeight: Math.round(s * i),
    fontHeightLG: Math.round(l * a),
    fontHeightSM: Math.round(c * o),
    lineHeightHeading1: r[6],
    lineHeightHeading2: r[5],
    lineHeightHeading3: r[4],
    lineHeightHeading4: r[3],
    lineHeightHeading5: r[2]
  };
};
B2.default = cvt;
var C4 = {};
Object.defineProperty(C4, "__esModule", {
  value: !0
});
C4.default = lvt;
function lvt(e) {
  const {
    sizeUnit: t,
    sizeStep: n
  } = e;
  return {
    sizeXXL: t * (n + 8),
    // 48
    sizeXL: t * (n + 4),
    // 32
    sizeLG: t * (n + 2),
    // 24
    sizeMD: t * (n + 1),
    // 20
    sizeMS: t * n,
    // 16
    size: t * n,
    // 16
    sizeSM: t * (n - 1),
    // 12
    sizeXS: t * (n - 2),
    // 8
    sizeXXS: t * (n - 3)
    // 4
  };
}
var yp = {}, bp = {};
Object.defineProperty(bp, "__esModule", {
  value: !0
});
bp.getSolidColor = bp.getAlphaColor = void 0;
var ice = vb;
const uvt = (e, t) => new ice.TinyColor(e).setAlpha(t).toRgbString();
bp.getAlphaColor = uvt;
const dvt = (e, t) => new ice.TinyColor(e).darken(t).toHexString();
bp.getSolidColor = dvt;
Object.defineProperty(yp, "__esModule", {
  value: !0
});
yp.generateNeutralColorPalettes = yp.generateColorPalettes = void 0;
var fvt = cb, Li = bp;
const hvt = (e) => {
  const t = (0, fvt.generate)(e);
  return {
    1: t[0],
    2: t[1],
    3: t[2],
    4: t[3],
    5: t[4],
    6: t[5],
    7: t[6],
    8: t[4],
    9: t[5],
    10: t[6]
    // 8: colors[7],
    // 9: colors[8],
    // 10: colors[9],
  };
};
yp.generateColorPalettes = hvt;
const gvt = (e, t) => {
  const n = e || "#fff", r = t || "#000";
  return {
    colorBgBase: n,
    colorTextBase: r,
    colorText: (0, Li.getAlphaColor)(r, 0.88),
    colorTextSecondary: (0, Li.getAlphaColor)(r, 0.65),
    colorTextTertiary: (0, Li.getAlphaColor)(r, 0.45),
    colorTextQuaternary: (0, Li.getAlphaColor)(r, 0.25),
    colorFill: (0, Li.getAlphaColor)(r, 0.15),
    colorFillSecondary: (0, Li.getAlphaColor)(r, 0.06),
    colorFillTertiary: (0, Li.getAlphaColor)(r, 0.04),
    colorFillQuaternary: (0, Li.getAlphaColor)(r, 0.02),
    colorBgSolid: (0, Li.getAlphaColor)(r, 1),
    colorBgSolidHover: (0, Li.getAlphaColor)(r, 0.75),
    colorBgSolidActive: (0, Li.getAlphaColor)(r, 0.95),
    colorBgLayout: (0, Li.getSolidColor)(n, 4),
    colorBgContainer: (0, Li.getSolidColor)(n, 0),
    colorBgElevated: (0, Li.getSolidColor)(n, 0),
    colorBgSpotlight: (0, Li.getAlphaColor)(r, 0.85),
    colorBgBlur: "transparent",
    colorBorder: (0, Li.getSolidColor)(n, 15),
    colorBorderSecondary: (0, Li.getSolidColor)(n, 6)
  };
};
yp.generateNeutralColorPalettes = gvt;
var bb = dn.default;
Object.defineProperty(w4, "__esModule", {
  value: !0
});
w4.default = Svt;
var bd = cb, pvt = Cc, mvt = bb(x4), vvt = bb(E4), yvt = bb(V2), bvt = bb(B2), _vt = bb(C4), $z = yp;
function Svt(e) {
  bd.presetPrimaryColors.pink = bd.presetPrimaryColors.magenta, bd.presetPalettes.pink = bd.presetPalettes.magenta;
  const t = Object.keys(pvt.defaultPresetColors).map((n) => {
    const r = e[n] === bd.presetPrimaryColors[n] ? bd.presetPalettes[n] : (0, bd.generate)(e[n]);
    return new Array(10).fill(1).reduce((i, o, a) => (i[`${n}-${a + 1}`] = r[a], i[`${n}${a + 1}`] = r[a], i), {});
  }).reduce((n, r) => (n = Object.assign(Object.assign({}, n), r), n), {});
  return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, e), t), (0, mvt.default)(e, {
    generateColorPalettes: $z.generateColorPalettes,
    generateNeutralColorPalettes: $z.generateNeutralColorPalettes
  })), (0, bvt.default)(e.fontSize)), (0, _vt.default)(e)), (0, yvt.default)(e)), (0, vvt.default)(e));
}
var T4 = dn.default;
Object.defineProperty(yc, "__esModule", {
  value: !0
});
yc.defaultTheme = yc.defaultConfig = yc.DesignTokenContext = void 0;
var wvt = T4(j), xvt = dd, Evt = T4(w4), Az = T4(Cc);
yc.defaultTheme = (0, xvt.createTheme)(Evt.default);
const Cvt = yc.defaultConfig = {
  token: Az.default,
  override: {
    override: Az.default
  },
  hashed: !0
};
yc.DesignTokenContext = /* @__PURE__ */ wvt.default.createContext(Cvt);
var ma = {}, Tvt = pi.default;
Object.defineProperty(ma, "__esModule", {
  value: !0
});
ma.defaultPrefixCls = ma.defaultIconPrefixCls = ma.Variants = ma.ConfigContext = ma.ConfigConsumer = void 0;
var Ivt = Tvt(j);
const Rz = ma.defaultPrefixCls = "ant", $vt = ma.defaultIconPrefixCls = "anticon";
ma.Variants = ["outlined", "borderless", "filled"];
const Avt = (e, t) => t || (e ? `${Rz}-${e}` : Rz), Rvt = ma.ConfigContext = /* @__PURE__ */ Ivt.createContext({
  // We provide a default function for Context without provider
  getPrefixCls: Avt,
  iconPrefixCls: $vt
}), {
  Consumer: Pvt
} = Rvt;
ma.ConfigConsumer = Pvt;
var z2 = {}, oce = dn.default;
Object.defineProperty(z2, "__esModule", {
  value: !0
});
z2.getStyle = ace;
z2.registerTheme = Dvt;
var Pz = cb, AI = vb, Ovt = oce(x2), Mvt = ah, kvt = oce(fo);
const Nvt = `-ant-${Date.now()}-${Math.random()}`;
function ace(e, t) {
  const n = {}, r = (a, s) => {
    let c = a.clone();
    return c = (s == null ? void 0 : s(c)) || c, c.toRgbString();
  }, i = (a, s) => {
    const c = new AI.TinyColor(a), l = (0, Pz.generate)(c.toRgbString());
    n[`${s}-color`] = r(c), n[`${s}-color-disabled`] = l[1], n[`${s}-color-hover`] = l[4], n[`${s}-color-active`] = l[6], n[`${s}-color-outline`] = c.clone().setAlpha(0.2).toRgbString(), n[`${s}-color-deprecated-bg`] = l[0], n[`${s}-color-deprecated-border`] = l[2];
  };
  if (t.primaryColor) {
    i(t.primaryColor, "primary");
    const a = new AI.TinyColor(t.primaryColor), s = (0, Pz.generate)(a.toRgbString());
    s.forEach((l, u) => {
      n[`primary-${u + 1}`] = l;
    }), n["primary-color-deprecated-l-35"] = r(a, (l) => l.lighten(35)), n["primary-color-deprecated-l-20"] = r(a, (l) => l.lighten(20)), n["primary-color-deprecated-t-20"] = r(a, (l) => l.tint(20)), n["primary-color-deprecated-t-50"] = r(a, (l) => l.tint(50)), n["primary-color-deprecated-f-12"] = r(a, (l) => l.setAlpha(l.getAlpha() * 0.12));
    const c = new AI.TinyColor(s[0]);
    n["primary-color-active-deprecated-f-30"] = r(c, (l) => l.setAlpha(l.getAlpha() * 0.3)), n["primary-color-active-deprecated-d-02"] = r(c, (l) => l.darken(2));
  }
  return t.successColor && i(t.successColor, "success"), t.warningColor && i(t.warningColor, "warning"), t.errorColor && i(t.errorColor, "error"), t.infoColor && i(t.infoColor, "info"), `
  :root {
    ${Object.keys(n).map((a) => `--${e}-${a}: ${n[a]};`).join(`
`)}
  }
  `.trim();
}
function Dvt(e, t) {
  const n = ace(e, t);
  (0, Ovt.default)() ? (0, Mvt.updateCSS)(n, `${Nvt}-dynamic-theme`) : process.env.NODE_ENV !== "production" && (0, kvt.default)(!1, "ConfigProvider", "SSR do not support dynamic theme with css variables.");
}
var Sl = {}, jvt = pi.default;
Object.defineProperty(Sl, "__esModule", {
  value: !0
});
Sl.default = Sl.DisabledContextProvider = void 0;
var NP = jvt(j);
const DP = /* @__PURE__ */ NP.createContext(!1), Lvt = (e) => {
  let {
    children: t,
    disabled: n
  } = e;
  const r = NP.useContext(DP);
  return /* @__PURE__ */ NP.createElement(DP.Provider, {
    value: n ?? r
  }, t);
};
Sl.DisabledContextProvider = Lvt;
Sl.default = DP;
var H2 = {}, Wu = {}, Fvt = pi.default;
Object.defineProperty(Wu, "__esModule", {
  value: !0
});
Wu.default = Wu.SizeContextProvider = void 0;
var jP = Fvt(j);
const LP = /* @__PURE__ */ jP.createContext(void 0), Vvt = (e) => {
  let {
    children: t,
    size: n
  } = e;
  const r = jP.useContext(LP);
  return /* @__PURE__ */ jP.createElement(LP.Provider, {
    value: n || r
  }, t);
};
Wu.SizeContextProvider = Vvt;
Wu.default = LP;
var sce = dn.default;
Object.defineProperty(H2, "__esModule", {
  value: !0
});
H2.default = void 0;
var Oz = j, Bvt = sce(Sl), zvt = sce(Wu);
function Hvt() {
  const e = (0, Oz.useContext)(Bvt.default), t = (0, Oz.useContext)(zvt.default);
  return {
    componentDisabled: e,
    componentSize: t
  };
}
H2.default = Hvt;
var I4 = {}, U2 = {}, cce = dn.default;
Object.defineProperty(U2, "__esModule", {
  value: !0
});
U2.default = void 0;
var Mz = cce(oh), Uvt = cce(oa);
function Wvt(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, r = /* @__PURE__ */ new Set();
  function i(o, a) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, c = r.has(o);
    if ((0, Uvt.default)(!c, "Warning: There may be circular references"), c)
      return !1;
    if (o === a)
      return !0;
    if (n && s > 1)
      return !1;
    r.add(o);
    var l = s + 1;
    if (Array.isArray(o)) {
      if (!Array.isArray(a) || o.length !== a.length)
        return !1;
      for (var u = 0; u < o.length; u++)
        if (!i(o[u], a[u], l))
          return !1;
      return !0;
    }
    if (o && a && (0, Mz.default)(o) === "object" && (0, Mz.default)(a) === "object") {
      var d = Object.keys(o);
      return d.length !== Object.keys(a).length ? !1 : d.every(function(f) {
        return i(o[f], a[f], l);
      });
    }
    return !1;
  }
  return i(e, t);
}
U2.default = Wvt;
var $l = {};
const lce = /* @__PURE__ */ Ic(x3e);
var $4 = {}, W2 = {};
Object.defineProperty(W2, "__esModule", {
  value: !0
});
W2.PresetColors = void 0;
W2.PresetColors = ["blue", "purple", "cyan", "green", "magenta", "pink", "red", "orange", "yellow", "volcano", "geekblue", "lime", "gold"];
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "PresetColors", {
    enumerable: !0,
    get: function() {
      return t.PresetColors;
    }
  });
  var t = W2;
})($4);
var Ts = {}, q2 = {}, G2 = {};
Object.defineProperty(G2, "__esModule", {
  value: !0
});
G2.default = void 0;
G2.default = "5.22.1";
var qvt = dn.default;
Object.defineProperty(q2, "__esModule", {
  value: !0
});
q2.default = void 0;
var Gvt = qvt(G2);
q2.default = Gvt.default;
var A4 = {}, K2 = {};
Object.defineProperty(K2, "__esModule", {
  value: !0
});
K2.default = void 0;
var L1 = vb;
function RI(e) {
  return e >= 0 && e <= 255;
}
function Kvt(e, t) {
  const {
    r: n,
    g: r,
    b: i,
    a: o
  } = new L1.TinyColor(e).toRgb();
  if (o < 1)
    return e;
  const {
    r: a,
    g: s,
    b: c
  } = new L1.TinyColor(t).toRgb();
  for (let l = 0.01; l <= 1; l += 0.01) {
    const u = Math.round((n - a * (1 - l)) / l), d = Math.round((r - s * (1 - l)) / l), f = Math.round((i - c * (1 - l)) / l);
    if (RI(u) && RI(d) && RI(f))
      return new L1.TinyColor({
        r: u,
        g: d,
        b: f,
        a: Math.round(l * 100) / 100
      }).toRgbString();
  }
  return new L1.TinyColor({
    r: n,
    g: r,
    b: i,
    a: 1
  }).toRgbString();
}
K2.default = Kvt;
var uce = dn.default;
Object.defineProperty(A4, "__esModule", {
  value: !0
});
A4.default = Qvt;
var PI = vb, Yvt = uce(Cc), F1 = uce(K2), Xvt = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
function Qvt(e) {
  const {
    override: t
  } = e, n = Xvt(e, ["override"]), r = Object.assign({}, t);
  Object.keys(Yvt.default).forEach((f) => {
    delete r[f];
  });
  const i = Object.assign(Object.assign({}, n), r), o = 480, a = 576, s = 768, c = 992, l = 1200, u = 1600;
  if (i.motion === !1) {
    const f = "0s";
    i.motionDurationFast = f, i.motionDurationMid = f, i.motionDurationSlow = f;
  }
  return Object.assign(Object.assign(Object.assign({}, i), {
    // ============== Background ============== //
    colorFillContent: i.colorFillSecondary,
    colorFillContentHover: i.colorFill,
    colorFillAlter: i.colorFillQuaternary,
    colorBgContainerDisabled: i.colorFillTertiary,
    // ============== Split ============== //
    colorBorderBg: i.colorBgContainer,
    colorSplit: (0, F1.default)(i.colorBorderSecondary, i.colorBgContainer),
    // ============== Text ============== //
    colorTextPlaceholder: i.colorTextQuaternary,
    colorTextDisabled: i.colorTextQuaternary,
    colorTextHeading: i.colorText,
    colorTextLabel: i.colorTextSecondary,
    colorTextDescription: i.colorTextTertiary,
    colorTextLightSolid: i.colorWhite,
    colorHighlight: i.colorError,
    colorBgTextHover: i.colorFillSecondary,
    colorBgTextActive: i.colorFill,
    colorIcon: i.colorTextTertiary,
    colorIconHover: i.colorText,
    colorErrorOutline: (0, F1.default)(i.colorErrorBg, i.colorBgContainer),
    colorWarningOutline: (0, F1.default)(i.colorWarningBg, i.colorBgContainer),
    // Font
    fontSizeIcon: i.fontSizeSM,
    // Line
    lineWidthFocus: i.lineWidth * 3,
    // Control
    lineWidth: i.lineWidth,
    controlOutlineWidth: i.lineWidth * 2,
    // Checkbox size and expand icon size
    controlInteractiveSize: i.controlHeight / 2,
    controlItemBgHover: i.colorFillTertiary,
    controlItemBgActive: i.colorPrimaryBg,
    controlItemBgActiveHover: i.colorPrimaryBgHover,
    controlItemBgActiveDisabled: i.colorFill,
    controlTmpOutline: i.colorFillQuaternary,
    controlOutline: (0, F1.default)(i.colorPrimaryBg, i.colorBgContainer),
    lineType: i.lineType,
    borderRadius: i.borderRadius,
    borderRadiusXS: i.borderRadiusXS,
    borderRadiusSM: i.borderRadiusSM,
    borderRadiusLG: i.borderRadiusLG,
    fontWeightStrong: 600,
    opacityLoading: 0.65,
    linkDecoration: "none",
    linkHoverDecoration: "none",
    linkFocusDecoration: "none",
    controlPaddingHorizontal: 12,
    controlPaddingHorizontalSM: 8,
    paddingXXS: i.sizeXXS,
    paddingXS: i.sizeXS,
    paddingSM: i.sizeSM,
    padding: i.size,
    paddingMD: i.sizeMD,
    paddingLG: i.sizeLG,
    paddingXL: i.sizeXL,
    paddingContentHorizontalLG: i.sizeLG,
    paddingContentVerticalLG: i.sizeMS,
    paddingContentHorizontal: i.sizeMS,
    paddingContentVertical: i.sizeSM,
    paddingContentHorizontalSM: i.size,
    paddingContentVerticalSM: i.sizeXS,
    marginXXS: i.sizeXXS,
    marginXS: i.sizeXS,
    marginSM: i.sizeSM,
    margin: i.size,
    marginMD: i.sizeMD,
    marginLG: i.sizeLG,
    marginXL: i.sizeXL,
    marginXXL: i.sizeXXL,
    boxShadow: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowSecondary: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowTertiary: `
      0 1px 2px 0 rgba(0, 0, 0, 0.03),
      0 1px 6px -1px rgba(0, 0, 0, 0.02),
      0 2px 4px 0 rgba(0, 0, 0, 0.02)
    `,
    screenXS: o,
    screenXSMin: o,
    screenXSMax: a - 1,
    screenSM: a,
    screenSMMin: a,
    screenSMMax: s - 1,
    screenMD: s,
    screenMDMin: s,
    screenMDMax: c - 1,
    screenLG: c,
    screenLGMin: c,
    screenLGMax: l - 1,
    screenXL: l,
    screenXLMin: l,
    screenXLMax: u - 1,
    screenXXL: u,
    screenXXLMin: u,
    boxShadowPopoverArrow: "2px 2px 5px rgba(0, 0, 0, 0.05)",
    boxShadowCard: `
      0 1px 2px -2px ${new PI.TinyColor("rgba(0, 0, 0, 0.16)").toRgbString()},
      0 3px 6px 0 ${new PI.TinyColor("rgba(0, 0, 0, 0.12)").toRgbString()},
      0 5px 12px 4px ${new PI.TinyColor("rgba(0, 0, 0, 0.09)").toRgbString()}
    `,
    boxShadowDrawerRight: `
      -6px 0 16px 0 rgba(0, 0, 0, 0.08),
      -3px 0 6px -4px rgba(0, 0, 0, 0.12),
      -9px 0 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowDrawerLeft: `
      6px 0 16px 0 rgba(0, 0, 0, 0.08),
      3px 0 6px -4px rgba(0, 0, 0, 0.12),
      9px 0 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowDrawerUp: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowDrawerDown: `
      0 -6px 16px 0 rgba(0, 0, 0, 0.08),
      0 -3px 6px -4px rgba(0, 0, 0, 0.12),
      0 -9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowTabsOverflowLeft: "inset 10px 0 8px -8px rgba(0, 0, 0, 0.08)",
    boxShadowTabsOverflowRight: "inset -10px 0 8px -8px rgba(0, 0, 0, 0.08)",
    boxShadowTabsOverflowTop: "inset 0 10px 8px -8px rgba(0, 0, 0, 0.08)",
    boxShadowTabsOverflowBottom: "inset 0 -10px 8px -8px rgba(0, 0, 0, 0.08)"
  }), r);
}
var Y2 = dn.default;
Object.defineProperty(Ts, "__esModule", {
  value: !0
});
Ts.default = oyt;
Ts.unitless = Ts.ignore = Ts.getComputedToken = void 0;
var Jvt = Y2(j), Zvt = dd, eyt = Y2(q2), kz = yc, tyt = Y2(Cc), dce = Y2(A4), Nz = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
const nyt = Ts.unitless = {
  lineHeight: !0,
  lineHeightSM: !0,
  lineHeightLG: !0,
  lineHeightHeading1: !0,
  lineHeightHeading2: !0,
  lineHeightHeading3: !0,
  lineHeightHeading4: !0,
  lineHeightHeading5: !0,
  opacityLoading: !0,
  fontWeightStrong: !0,
  zIndexPopupBase: !0,
  zIndexBase: !0,
  opacityImage: !0
}, ryt = Ts.ignore = {
  size: !0,
  sizeSM: !0,
  sizeLG: !0,
  sizeMD: !0,
  sizeXS: !0,
  sizeXXS: !0,
  sizeMS: !0,
  sizeXL: !0,
  sizeXXL: !0,
  sizeUnit: !0,
  sizeStep: !0,
  motionBase: !0,
  motionUnit: !0
}, iyt = {
  screenXS: !0,
  screenXSMin: !0,
  screenXSMax: !0,
  screenSM: !0,
  screenSMMin: !0,
  screenSMMax: !0,
  screenMD: !0,
  screenMDMin: !0,
  screenMDMax: !0,
  screenLG: !0,
  screenLGMin: !0,
  screenLGMax: !0,
  screenXL: !0,
  screenXLMin: !0,
  screenXLMax: !0,
  screenXXL: !0,
  screenXXLMin: !0
}, R4 = (e, t, n) => {
  const r = n.getDerivativeToken(e), {
    override: i
  } = t, o = Nz(t, ["override"]);
  let a = Object.assign(Object.assign({}, r), {
    override: i
  });
  return a = (0, dce.default)(a), o && Object.entries(o).forEach((s) => {
    let [c, l] = s;
    const {
      theme: u
    } = l, d = Nz(l, ["theme"]);
    let f = d;
    u && (f = R4(Object.assign(Object.assign({}, a), d), {
      override: d
    }, u)), a[c] = f;
  }), a;
};
Ts.getComputedToken = R4;
function oyt() {
  const {
    token: e,
    hashed: t,
    theme: n,
    override: r,
    cssVar: i
  } = Jvt.default.useContext(kz.DesignTokenContext), o = `${eyt.default}-${t || ""}`, a = n || kz.defaultTheme, [s, c, l] = (0, Zvt.useCacheToken)(a, [tyt.default, e], {
    salt: o,
    override: r,
    getComputedToken: R4,
    // formatToken will not be consumed after 1.15.0 with getComputedToken.
    // But token will break if @ant-design/cssinjs is under 1.15.0 without it
    formatToken: dce.default,
    cssVar: i && {
      prefix: i.prefix,
      key: i.key,
      unitless: nyt,
      ignore: ryt,
      preserve: iyt
    }
  });
  return [a, l, t ? c : "", s, i];
}
var wu = {}, qr = {};
Object.defineProperty(qr, "__esModule", {
  value: !0
});
qr.textEllipsis = qr.resetIcon = qr.resetComponent = qr.operationUnit = qr.genLinkStyle = qr.genFocusStyle = qr.genFocusOutline = qr.genCommonStyle = qr.clearFix = void 0;
var ayt = dd;
qr.textEllipsis = {
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis"
};
const syt = function(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
  return {
    boxSizing: "border-box",
    margin: 0,
    padding: 0,
    color: e.colorText,
    fontSize: e.fontSize,
    // font-variant: @font-variant-base;
    lineHeight: e.lineHeight,
    listStyle: "none",
    // font-feature-settings: @font-feature-settings-base;
    fontFamily: t ? "inherit" : e.fontFamily
  };
};
qr.resetComponent = syt;
const cyt = () => ({
  display: "inline-flex",
  alignItems: "center",
  color: "inherit",
  fontStyle: "normal",
  lineHeight: 0,
  textAlign: "center",
  textTransform: "none",
  // for SVG icon, see https://blog.prototypr.io/align-svg-icons-to-text-and-say-goodbye-to-font-icons-d44b3d7b26b4
  verticalAlign: "-0.125em",
  textRendering: "optimizeLegibility",
  "-webkit-font-smoothing": "antialiased",
  "-moz-osx-font-smoothing": "grayscale",
  "> *": {
    lineHeight: 1
  },
  svg: {
    display: "inline-block"
  }
});
qr.resetIcon = cyt;
const lyt = () => ({
  // https://github.com/ant-design/ant-design/issues/21301#issuecomment-583955229
  "&::before": {
    display: "table",
    content: '""'
  },
  "&::after": {
    // https://github.com/ant-design/ant-design/issues/21864
    display: "table",
    clear: "both",
    content: '""'
  }
});
qr.clearFix = lyt;
const uyt = (e) => ({
  a: {
    color: e.colorLink,
    textDecoration: e.linkDecoration,
    backgroundColor: "transparent",
    // remove the gray background on active links in IE 10.
    outline: "none",
    cursor: "pointer",
    transition: `color ${e.motionDurationSlow}`,
    "-webkit-text-decoration-skip": "objects",
    // remove gaps in links underline in iOS 8+ and Safari 8+.
    "&:hover": {
      color: e.colorLinkHover
    },
    "&:active": {
      color: e.colorLinkActive
    },
    "&:active, &:hover": {
      textDecoration: e.linkHoverDecoration,
      outline: 0
    },
    // https://github.com/ant-design/ant-design/issues/22503
    "&:focus": {
      textDecoration: e.linkFocusDecoration,
      outline: 0
    },
    "&[disabled]": {
      color: e.colorTextDisabled,
      cursor: "not-allowed"
    }
  }
});
qr.genLinkStyle = uyt;
const dyt = (e, t, n, r) => {
  const i = `[class^="${t}"], [class*=" ${t}"]`, o = n ? `.${n}` : i, a = {
    boxSizing: "border-box",
    "&::before, &::after": {
      boxSizing: "border-box"
    }
  };
  let s = {};
  return r !== !1 && (s = {
    fontFamily: e.fontFamily,
    fontSize: e.fontSize
  }), {
    [o]: Object.assign(Object.assign(Object.assign({}, s), a), {
      [i]: a
    })
  };
};
qr.genCommonStyle = dyt;
const fce = (e) => ({
  outline: `${(0, ayt.unit)(e.lineWidthFocus)} solid ${e.colorPrimaryBorder}`,
  outlineOffset: 1,
  transition: "outline-offset 0s, outline 0s"
});
qr.genFocusOutline = fce;
const hce = (e) => ({
  "&:focus-visible": Object.assign({}, fce(e))
});
qr.genFocusStyle = hce;
const fyt = (e) => Object.assign(Object.assign({
  // FIXME: This use link but is a operation unit. Seems should be a colorPrimary.
  // And Typography use this to generate link style which should not do this.
  color: e.colorLink,
  textDecoration: e.linkDecoration,
  outline: "none",
  cursor: "pointer",
  transition: `all ${e.motionDurationSlow}`,
  border: 0,
  padding: 0,
  background: "none",
  userSelect: "none"
}, hce(e)), {
  "&:focus, &:hover": {
    color: e.colorLinkHover
  },
  "&:active": {
    color: e.colorLinkActive
  }
});
qr.operationUnit = fyt;
var _b = {}, hyt = dn.default;
Object.defineProperty(_b, "__esModule", {
  value: !0
});
_b.default = void 0;
var gyt = dd, pyt = qr, myt = hyt(Ts);
const vyt = (e, t) => {
  const [n, r] = (0, myt.default)();
  return (0, gyt.useStyleRegister)({
    theme: n,
    token: r,
    hashId: "",
    path: ["ant-design-icons", e],
    nonce: () => t == null ? void 0 : t.nonce,
    layer: {
      name: "antd"
    }
  }, () => [{
    [`.${e}`]: Object.assign(Object.assign({}, (0, pyt.resetIcon)()), {
      [`.${e} .${e}-icon`]: {
        display: "block"
      }
    })
  }]);
};
_b.default = vyt;
var yyt = dn.default, byt = pi.default;
Object.defineProperty(wu, "__esModule", {
  value: !0
});
wu.genSubStyleComponent = wu.genStyleHooks = wu.genComponentStyleHook = void 0;
var Dz = j, _yt = lce, jz = ma, Lz = qr, Fz = byt(Ts), Syt = yyt(_b);
const {
  genStyleHooks: wyt,
  genComponentStyleHook: xyt,
  genSubStyleComponent: Eyt
} = (0, _yt.genStyleUtils)({
  usePrefix: () => {
    const {
      getPrefixCls: e,
      iconPrefixCls: t
    } = (0, Dz.useContext)(jz.ConfigContext);
    return {
      rootPrefixCls: e(),
      iconPrefixCls: t
    };
  },
  useToken: () => {
    const [e, t, n, r, i] = (0, Fz.default)();
    return {
      theme: e,
      realToken: t,
      hashId: n,
      token: r,
      cssVar: i
    };
  },
  useCSP: () => {
    const {
      csp: e,
      iconPrefixCls: t
    } = (0, Dz.useContext)(jz.ConfigContext);
    return (0, Syt.default)(t, e), e ?? {};
  },
  getResetStyles: (e) => [{
    "&": (0, Lz.genLinkStyle)(e)
  }],
  getCommonStyle: Lz.genCommonStyle,
  getCompUnitless: () => Fz.unitless
});
wu.genSubStyleComponent = Eyt;
wu.genComponentStyleHook = xyt;
wu.genStyleHooks = wyt;
var P4 = {};
Object.defineProperty(P4, "__esModule", {
  value: !0
});
P4.default = Tyt;
var Cyt = $4;
function Tyt(e, t) {
  return Cyt.PresetColors.reduce((n, r) => {
    const i = e[`${r}1`], o = e[`${r}3`], a = e[`${r}6`], s = e[`${r}7`];
    return Object.assign(Object.assign({}, n), t(r, {
      lightColor: i,
      lightBorderColor: o,
      darkColor: a,
      textColor: s
    }));
  }, {});
}
(function(e) {
  var t = dn.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "DesignTokenContext", {
    enumerable: !0,
    get: function() {
      return u.DesignTokenContext;
    }
  }), Object.defineProperty(e, "PresetColors", {
    enumerable: !0,
    get: function() {
      return i.PresetColors;
    }
  }), Object.defineProperty(e, "calc", {
    enumerable: !0,
    get: function() {
      return r.genCalc;
    }
  }), Object.defineProperty(e, "defaultConfig", {
    enumerable: !0,
    get: function() {
      return u.defaultConfig;
    }
  }), Object.defineProperty(e, "genComponentStyleHook", {
    enumerable: !0,
    get: function() {
      return s.genComponentStyleHook;
    }
  }), Object.defineProperty(e, "genPresetColor", {
    enumerable: !0,
    get: function() {
      return c.default;
    }
  }), Object.defineProperty(e, "genStyleHooks", {
    enumerable: !0,
    get: function() {
      return s.genStyleHooks;
    }
  }), Object.defineProperty(e, "genSubStyleComponent", {
    enumerable: !0,
    get: function() {
      return s.genSubStyleComponent;
    }
  }), Object.defineProperty(e, "getLineHeight", {
    enumerable: !0,
    get: function() {
      return o.getLineHeight;
    }
  }), Object.defineProperty(e, "mergeToken", {
    enumerable: !0,
    get: function() {
      return r.mergeToken;
    }
  }), Object.defineProperty(e, "statistic", {
    enumerable: !0,
    get: function() {
      return r.statistic;
    }
  }), Object.defineProperty(e, "statisticToken", {
    enumerable: !0,
    get: function() {
      return r.statisticToken;
    }
  }), Object.defineProperty(e, "useResetIconStyle", {
    enumerable: !0,
    get: function() {
      return l.default;
    }
  }), Object.defineProperty(e, "useStyleRegister", {
    enumerable: !0,
    get: function() {
      return n.useStyleRegister;
    }
  }), Object.defineProperty(e, "useToken", {
    enumerable: !0,
    get: function() {
      return a.default;
    }
  });
  var n = dd, r = lce, i = $4, o = yb, a = t(Ts), s = wu, c = t(P4), l = t(_b), u = yc;
})($l);
var X2 = {}, Iyt = pi.default;
Object.defineProperty(X2, "__esModule", {
  value: !0
});
X2.default = void 0;
var $yt = Iyt(j);
const Ayt = Object.assign({}, $yt), {
  useId: Vz
} = Ayt, Ryt = () => "", Pyt = typeof Vz > "u" ? Ryt : Vz;
X2.default = Pyt;
var O4 = dn.default;
Object.defineProperty(I4, "__esModule", {
  value: !0
});
I4.default = Dyt;
var Oyt = O4(hb), Myt = O4(U2), kyt = fo, Bz = $l, Nyt = O4(X2);
function Dyt(e, t, n) {
  var r, i;
  const o = (0, kyt.devUseWarning)("ConfigProvider"), a = e || {}, s = a.inherit === !1 || !t ? Object.assign(Object.assign({}, Bz.defaultConfig), {
    hashed: (r = t == null ? void 0 : t.hashed) !== null && r !== void 0 ? r : Bz.defaultConfig.hashed,
    cssVar: t == null ? void 0 : t.cssVar
  }) : t, c = (0, Nyt.default)();
  if (process.env.NODE_ENV !== "production") {
    const l = a.cssVar || s.cssVar, u = !!(typeof a.cssVar == "object" && (!((i = a.cssVar) === null || i === void 0) && i.key) || c);
    process.env.NODE_ENV !== "production" && o(!l || u, "breaking", "Missing key in `cssVar` config. Please upgrade to React 18 or set `cssVar.key` manually in each ConfigProvider inside `cssVar` enabled ConfigProvider.");
  }
  return (0, Oyt.default)(() => {
    var l, u;
    if (!e)
      return t;
    const d = Object.assign({}, s.components);
    Object.keys(e.components || {}).forEach((p) => {
      d[p] = Object.assign(Object.assign({}, d[p]), e.components[p]);
    });
    const f = `css-var-${c.replace(/:/g, "")}`, h = ((l = a.cssVar) !== null && l !== void 0 ? l : s.cssVar) && Object.assign(Object.assign(Object.assign({
      prefix: n == null ? void 0 : n.prefixCls
    }, typeof s.cssVar == "object" ? s.cssVar : {}), typeof a.cssVar == "object" ? a.cssVar : {}), {
      key: typeof a.cssVar == "object" && ((u = a.cssVar) === null || u === void 0 ? void 0 : u.key) || f
    });
    return Object.assign(Object.assign(Object.assign({}, s), a), {
      token: Object.assign(Object.assign({}, s.token), a.token),
      components: d,
      cssVar: h
    });
  }, [a, s], (l, u) => l.some((d, f) => {
    const h = u[f];
    return !(0, Myt.default)(d, h, !0);
  }));
}
var M4 = {};
const jyt = /* @__PURE__ */ Ic(cke);
var Lyt = pi.default;
Object.defineProperty(M4, "__esModule", {
  value: !0
});
M4.default = Byt;
var zz = Lyt(j), Fyt = jyt, Vyt = $l;
function Byt(e) {
  const {
    children: t
  } = e, [, n] = (0, Vyt.useToken)(), {
    motion: r
  } = n, i = zz.useRef(!1);
  return i.current = i.current || r === !1, i.current ? /* @__PURE__ */ zz.createElement(Fyt.Provider, {
    motion: r
  }, t) : t;
}
var Q2 = {}, zyt = pi.default;
Object.defineProperty(Q2, "__esModule", {
  value: !0
});
Q2.default = void 0;
var Hyt = zyt(j), Uyt = fo;
const gce = /* @__PURE__ */ Hyt.memo((e) => {
  let {
    dropdownMatchSelectWidth: t
  } = e;
  return (0, Uyt.devUseWarning)("ConfigProvider").deprecated(t === void 0, "dropdownMatchSelectWidth", "popupMatchSelectWidth"), null;
});
process.env.NODE_ENV !== "production" && (gce.displayName = "PropWarning");
Q2.default = process.env.NODE_ENV !== "production" ? gce : () => null;
var pce = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function() {
      return t.useResetIconStyle;
    }
  });
  var t = $l;
})(pce);
(function(e) {
  "use client";
  var t = dn.default, n = pi.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "ConfigConsumer", {
    enumerable: !0,
    get: function() {
      return g.ConfigConsumer;
    }
  }), Object.defineProperty(e, "ConfigContext", {
    enumerable: !0,
    get: function() {
      return g.ConfigContext;
    }
  }), Object.defineProperty(e, "Variants", {
    enumerable: !0,
    get: function() {
      return g.Variants;
    }
  }), e.default = e.configConsumerProps = void 0, Object.defineProperty(e, "defaultIconPrefixCls", {
    enumerable: !0,
    get: function() {
      return g.defaultIconPrefixCls;
    }
  }), Object.defineProperty(e, "defaultPrefixCls", {
    enumerable: !0,
    get: function() {
      return g.defaultPrefixCls;
    }
  }), e.warnContext = e.globalConfig = void 0;
  var r = n(j), i = dd, o = t(um), a = t(hb), s = R2, c = n(fo), l = t(P2), u = n(ece), d = t(hm), f = t(fm), h = yc, p = t(Cc), g = ma, m = z2, v = Sl, y = t(H2), _ = t(I4), b = t(M4), w = t(Q2), C = n(Wu), x = t(pce), T = function(Q, Y) {
    var q = {};
    for (var X in Q)
      Object.prototype.hasOwnProperty.call(Q, X) && Y.indexOf(X) < 0 && (q[X] = Q[X]);
    if (Q != null && typeof Object.getOwnPropertySymbols == "function")
      for (var ne = 0, X = Object.getOwnPropertySymbols(Q); ne < X.length; ne++)
        Y.indexOf(X[ne]) < 0 && Object.prototype.propertyIsEnumerable.call(Q, X[ne]) && (q[X[ne]] = Q[X[ne]]);
    return q;
  };
  let E = !1;
  e.warnContext = process.env.NODE_ENV !== "production" ? (Q) => {
    process.env.NODE_ENV !== "production" && (0, c.default)(!E, Q, "Static function can not consume context like dynamic theme. Please use 'App' component instead.");
  } : (
    /* istanbul ignore next */
    null
  ), e.configConsumerProps = ["getTargetContainer", "getPopupContainer", "rootPrefixCls", "getPrefixCls", "renderEmpty", "csp", "autoInsertSpaceInButton", "locale"];
  const R = ["getTargetContainer", "getPopupContainer", "renderEmpty", "input", "pagination", "form", "select", "button"];
  let I, O, P, k;
  function L() {
    return I || g.defaultPrefixCls;
  }
  function N() {
    return O || g.defaultIconPrefixCls;
  }
  function D(Q) {
    return Object.keys(Q).some((Y) => Y.endsWith("Color"));
  }
  const z = (Q) => {
    const {
      prefixCls: Y,
      iconPrefixCls: q,
      theme: X,
      holderRender: ne
    } = Q;
    Y !== void 0 && (I = Y), q !== void 0 && (O = q), "holderRender" in Q && (k = ne), X && (D(X) ? (process.env.NODE_ENV !== "production" && (0, c.default)(!1, "ConfigProvider", "`config` of css variable theme is not work in v5. Please use new `theme` config instead."), (0, m.registerTheme)(L(), X)) : P = X);
  }, V = () => ({
    getPrefixCls: (Q, Y) => Y || (Q ? `${L()}-${Q}` : L()),
    getIconPrefixCls: N,
    getRootPrefixCls: () => I || L(),
    getTheme: () => P,
    holderRender: k
  });
  e.globalConfig = V;
  const B = (Q) => {
    const {
      children: Y,
      csp: q,
      autoInsertSpaceInButton: X,
      alert: ne,
      anchor: Z,
      form: J,
      locale: K,
      componentSize: ee,
      direction: te,
      space: H,
      splitter: ie,
      virtual: W,
      dropdownMatchSelectWidth: se,
      popupMatchSelectWidth: le,
      popupOverflow: ge,
      legacyLocale: me,
      parentContext: pe,
      iconPrefixCls: Te,
      theme: de,
      componentDisabled: Ae,
      segmented: ue,
      statistic: be,
      spin: Ie,
      calendar: Ve,
      carousel: ze,
      cascader: Ne,
      collapse: lt,
      typography: mt,
      checkbox: vt,
      descriptions: ke,
      divider: xe,
      drawer: Re,
      skeleton: yt,
      steps: Pt,
      image: _t,
      layout: St,
      list: ft,
      mentions: kn,
      modal: Dt,
      progress: nt,
      result: Be,
      slider: st,
      breadcrumb: pt,
      menu: Et,
      pagination: Ke,
      input: rt,
      textArea: Le,
      empty: Xt,
      badge: Ht,
      radio: Ue,
      rate: We,
      switch: ct,
      transfer: ht,
      avatar: Rt,
      message: Ft,
      tag: re,
      table: Se,
      card: De,
      tabs: Ye,
      timeline: $t,
      timePicker: Ct,
      upload: ut,
      notification: Mt,
      tree: Xe,
      colorPicker: je,
      datePicker: Ze,
      rangePicker: dt,
      flex: Ge,
      wave: Lt,
      dropdown: Ot,
      warning: xn,
      tour: mr,
      floatButtonGroup: Kn,
      variant: Tn,
      inputNumber: Vr,
      treeSelect: Yr
    } = Q, vr = r.useCallback((nn, Jt) => {
      const {
        prefixCls: Zt
      } = Q;
      if (Jt)
        return Jt;
      const yn = Zt || pe.getPrefixCls("");
      return nn ? `${yn}-${nn}` : yn;
    }, [pe.getPrefixCls, Q.prefixCls]), Cr = Te || pe.iconPrefixCls || g.defaultIconPrefixCls, Xr = q || pe.csp;
    (0, x.default)(Cr, Xr);
    const Tr = (0, _.default)(de, pe.theme, {
      prefixCls: vr("")
    });
    process.env.NODE_ENV !== "production" && (E = E || !!Tr);
    const Qr = {
      csp: Xr,
      autoInsertSpaceInButton: X,
      alert: ne,
      anchor: Z,
      locale: K || me,
      direction: te,
      space: H,
      splitter: ie,
      virtual: W,
      popupMatchSelectWidth: le ?? se,
      popupOverflow: ge,
      getPrefixCls: vr,
      iconPrefixCls: Cr,
      theme: Tr,
      segmented: ue,
      statistic: be,
      spin: Ie,
      calendar: Ve,
      carousel: ze,
      cascader: Ne,
      collapse: lt,
      typography: mt,
      checkbox: vt,
      descriptions: ke,
      divider: xe,
      drawer: Re,
      skeleton: yt,
      steps: Pt,
      image: _t,
      input: rt,
      textArea: Le,
      layout: St,
      list: ft,
      mentions: kn,
      modal: Dt,
      progress: nt,
      result: Be,
      slider: st,
      breadcrumb: pt,
      menu: Et,
      pagination: Ke,
      empty: Xt,
      badge: Ht,
      radio: Ue,
      rate: We,
      switch: ct,
      transfer: ht,
      avatar: Rt,
      message: Ft,
      tag: re,
      table: Se,
      card: De,
      tabs: Ye,
      timeline: $t,
      timePicker: Ct,
      upload: ut,
      notification: Mt,
      tree: Xe,
      colorPicker: je,
      datePicker: Ze,
      rangePicker: dt,
      flex: Ge,
      wave: Lt,
      dropdown: Ot,
      warning: xn,
      tour: mr,
      floatButtonGroup: Kn,
      variant: Tn,
      inputNumber: Vr,
      treeSelect: Yr
    };
    process.env.NODE_ENV !== "production" && (0, c.devUseWarning)("ConfigProvider")(!("autoInsertSpaceInButton" in Q), "deprecated", "`autoInsertSpaceInButton` is deprecated. Please use `{ button: { autoInsertSpace: boolean }}` instead.");
    const Ti = Object.assign({}, pe);
    Object.keys(Qr).forEach((nn) => {
      Qr[nn] !== void 0 && (Ti[nn] = Qr[nn]);
    }), R.forEach((nn) => {
      const Jt = Q[nn];
      Jt && (Ti[nn] = Jt);
    }), typeof X < "u" && (Ti.button = Object.assign({
      autoInsertSpace: X
    }, Ti.button));
    const Ii = (0, a.default)(() => Ti, Ti, (nn, Jt) => {
      const Zt = Object.keys(nn), yn = Object.keys(Jt);
      return Zt.length !== yn.length || Zt.some((Ir) => nn[Ir] !== Jt[Ir]);
    }), Ni = r.useMemo(() => ({
      prefixCls: Cr,
      csp: Xr
    }), [Cr, Xr]);
    let tr = /* @__PURE__ */ r.createElement(r.Fragment, null, /* @__PURE__ */ r.createElement(w.default, {
      dropdownMatchSelectWidth: se
    }), Y);
    const Qt = r.useMemo(() => {
      var nn, Jt, Zt, yn;
      return (0, s.merge)(((nn = f.default.Form) === null || nn === void 0 ? void 0 : nn.defaultValidateMessages) || {}, ((Zt = (Jt = Ii.locale) === null || Jt === void 0 ? void 0 : Jt.Form) === null || Zt === void 0 ? void 0 : Zt.defaultValidateMessages) || {}, ((yn = Ii.form) === null || yn === void 0 ? void 0 : yn.validateMessages) || {}, (J == null ? void 0 : J.validateMessages) || {});
    }, [Ii, J == null ? void 0 : J.validateMessages]);
    Object.keys(Qt).length > 0 && (tr = /* @__PURE__ */ r.createElement(l.default.Provider, {
      value: Qt
    }, tr)), K && (tr = /* @__PURE__ */ r.createElement(u.default, {
      locale: K,
      _ANT_MARK__: u.ANT_MARK
    }, tr)), (Cr || Xr) && (tr = /* @__PURE__ */ r.createElement(o.default.Provider, {
      value: Ni
    }, tr)), ee && (tr = /* @__PURE__ */ r.createElement(C.SizeContextProvider, {
      size: ee
    }, tr)), tr = /* @__PURE__ */ r.createElement(b.default, null, tr);
    const Bt = r.useMemo(() => {
      const nn = Tr || {}, {
        algorithm: Jt,
        token: Zt,
        components: yn,
        cssVar: Ir
      } = nn, mi = T(nn, ["algorithm", "token", "components", "cssVar"]), un = Jt && (!Array.isArray(Jt) || Jt.length > 0) ? (0, i.createTheme)(Jt) : h.defaultTheme, ri = {};
      Object.entries(yn || {}).forEach((Qi) => {
        let [Fo, yo] = Qi;
        const bo = Object.assign({}, yo);
        "algorithm" in bo && (bo.algorithm === !0 ? bo.theme = un : (Array.isArray(bo.algorithm) || typeof bo.algorithm == "function") && (bo.theme = (0, i.createTheme)(bo.algorithm)), delete bo.algorithm), ri[Fo] = bo;
      });
      const ii = Object.assign(Object.assign({}, p.default), Zt);
      return Object.assign(Object.assign({}, mi), {
        theme: un,
        token: ii,
        components: ri,
        override: Object.assign({
          override: ii
        }, ri),
        cssVar: Ir
      });
    }, [Tr]);
    return de && (tr = /* @__PURE__ */ r.createElement(h.DesignTokenContext.Provider, {
      value: Bt
    }, tr)), Ii.warning && (tr = /* @__PURE__ */ r.createElement(c.WarningContext.Provider, {
      value: Ii.warning
    }, tr)), Ae !== void 0 && (tr = /* @__PURE__ */ r.createElement(v.DisabledContextProvider, {
      disabled: Ae
    }, tr)), /* @__PURE__ */ r.createElement(g.ConfigContext.Provider, {
      value: Ii
    }, tr);
  }, U = (Q) => {
    const Y = r.useContext(g.ConfigContext), q = r.useContext(d.default);
    return /* @__PURE__ */ r.createElement(B, Object.assign({
      parentContext: Y,
      legacyLocale: q
    }, Q));
  };
  U.ConfigContext = g.ConfigContext, U.SizeContext = C.default, U.config = z, U.useConfig = y.default, Object.defineProperty(U, "SizeContext", {
    get: () => (process.env.NODE_ENV !== "production" && (0, c.default)(!1, "ConfigProvider", "ConfigProvider.SizeContext is deprecated. Please use `ConfigProvider.useConfig().componentSize` instead."), C.default)
  }), process.env.NODE_ENV !== "production" && (U.displayName = "ConfigProvider"), e.default = U;
})(fb);
var Sb = {};
Object.defineProperty(Sb, "__esModule", {
  value: !0
});
Sb.default = void 0;
var Wyt = $l;
const qyt = (e) => {
  const [, , , , t] = (0, Wyt.useToken)();
  return t ? `${e}-css-var` : "";
};
Sb.default = qyt;
var gm = {}, mce = dn.default;
Object.defineProperty(gm, "__esModule", {
  value: !0
});
gm.default = void 0;
var Hz = mce(j), Gyt = mce(Wu);
const Kyt = (e) => {
  const t = Hz.default.useContext(Gyt.default);
  return Hz.default.useMemo(() => e ? typeof e == "string" ? e ?? t : e instanceof Function ? e(t) : t : t, [e, t]);
};
gm.default = Kyt;
var _i = {};
const Yyt = /* @__PURE__ */ Ic(NDe);
var k4 = {};
Object.defineProperty(k4, "__esModule", {
  value: !0
});
k4.default = Xyt;
function Xyt(e, t) {
  var n = Object.assign({}, e);
  return Array.isArray(t) && t.forEach(function(r) {
    delete n[r];
  }), n;
}
var Qyt = dn.default, Jyt = pi.default;
Object.defineProperty(_i, "__esModule", {
  value: !0
});
_i.VariantContext = _i.NoStyleItemContext = _i.NoFormStyle = _i.FormProvider = _i.FormItemPrefixContext = _i.FormItemInputContext = _i.FormContext = void 0;
var fx = Jyt(j), pm = fx, Zyt = Yyt, ebt = Qyt(k4);
_i.FormContext = /* @__PURE__ */ pm.createContext({
  labelAlign: "right",
  vertical: !1,
  itemRef: () => {
  }
});
_i.NoStyleItemContext = /* @__PURE__ */ pm.createContext(null);
const tbt = (e) => {
  const t = (0, ebt.default)(e, ["prefixCls"]);
  return /* @__PURE__ */ pm.createElement(Zyt.FormProvider, Object.assign({}, t));
};
_i.FormProvider = tbt;
_i.FormItemPrefixContext = /* @__PURE__ */ pm.createContext({
  prefixCls: ""
});
const FP = _i.FormItemInputContext = /* @__PURE__ */ pm.createContext({});
process.env.NODE_ENV !== "production" && (FP.displayName = "FormItemInputContext");
const nbt = (e) => {
  let {
    children: t,
    status: n,
    override: r
  } = e;
  const i = (0, fx.useContext)(FP), o = (0, fx.useMemo)(() => {
    const a = Object.assign({}, i);
    return r && delete a.isFormItemInput, n && (delete a.status, delete a.hasFeedback, delete a.feedbackIcon), a;
  }, [n, r, i]);
  return /* @__PURE__ */ pm.createElement(FP.Provider, {
    value: o
  }, t);
};
_i.NoFormStyle = nbt;
_i.VariantContext = /* @__PURE__ */ (0, fx.createContext)(void 0);
var wb = {};
Object.defineProperty(wb, "__esModule", {
  value: !0
});
wb.default = void 0;
var Uz = j, rbt = _i, Wz = fb;
const ibt = function(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : void 0;
  var r, i;
  const {
    variant: o,
    [e]: a
  } = (0, Uz.useContext)(Wz.ConfigContext), s = (0, Uz.useContext)(rbt.VariantContext), c = a == null ? void 0 : a.variant;
  let l;
  typeof t < "u" ? l = t : n === !1 ? l = "borderless" : l = (i = (r = s ?? c) !== null && r !== void 0 ? r : o) !== null && i !== void 0 ? i : "outlined";
  const u = Wz.Variants.includes(l);
  return [l, u];
};
wb.default = ibt;
var vce = {};
const obt = /* @__PURE__ */ Ic(yFe);
var mm = {};
Object.defineProperty(mm, "__esModule", {
  value: !0
});
mm.hasAddon = abt;
mm.hasPrefixSuffix = sbt;
mm.resolveOnChange = cbt;
mm.triggerFocus = lbt;
function abt(e) {
  return !!(e.addonBefore || e.addonAfter);
}
function sbt(e) {
  return !!(e.prefix || e.suffix || e.allowClear);
}
function qz(e, t, n) {
  var r = t.cloneNode(!0), i = Object.create(e, {
    target: {
      value: r
    },
    currentTarget: {
      value: r
    }
  });
  return r.value = n, typeof t.selectionStart == "number" && typeof t.selectionEnd == "number" && (r.selectionStart = t.selectionStart, r.selectionEnd = t.selectionEnd), r.setSelectionRange = function() {
    t.setSelectionRange.apply(t, arguments);
  }, i;
}
function cbt(e, t, n, r) {
  if (n) {
    var i = t;
    if (t.type === "click") {
      i = qz(t, e, ""), n(i);
      return;
    }
    if (e.type !== "file" && r !== void 0) {
      i = qz(t, e, r), n(i);
      return;
    }
    n(i);
  }
}
function lbt(e, t) {
  if (e) {
    e.focus(t);
    var n = t || {}, r = n.cursor;
    if (r) {
      var i = e.value.length;
      switch (r) {
        case "start":
          e.setSelectionRange(0, 0);
          break;
        case "end":
          e.setSelectionRange(i, i);
          break;
        default:
          e.setSelectionRange(0, i);
      }
    }
  }
}
var Qo = {}, yce = dn.default;
Object.defineProperty(Qo, "__esModule", {
  value: !0
});
Qo.useComposeRef = Qo.supportRef = Qo.supportNodeRef = Qo.getNodeRef = Qo.fillRef = Qo.composeRef = void 0;
var ubt = yce(oh), bce = j, $_ = Qd, dbt = yce(hb), fbt = Qo.fillRef = function(t, n) {
  typeof t == "function" ? t(n) : (0, ubt.default)(t) === "object" && t && "current" in t && (t.current = n);
}, hbt = Qo.composeRef = function() {
  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  var i = n.filter(Boolean);
  return i.length <= 1 ? i[0] : function(o) {
    n.forEach(function(a) {
      fbt(a, o);
    });
  };
};
Qo.useComposeRef = function() {
  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  return (0, dbt.default)(function() {
    return hbt.apply(void 0, n);
  }, n, function(i, o) {
    return i.length !== o.length || i.every(function(a, s) {
      return a !== o[s];
    });
  });
};
var gbt = Qo.supportRef = function(t) {
  var n, r, i = (0, $_.isMemo)(t) ? t.type.type : t.type;
  return !(typeof i == "function" && !((n = i.prototype) !== null && n !== void 0 && n.render) && i.$$typeof !== $_.ForwardRef || typeof t == "function" && !((r = t.prototype) !== null && r !== void 0 && r.render) && t.$$typeof !== $_.ForwardRef);
};
function VP(e) {
  return /* @__PURE__ */ (0, bce.isValidElement)(e) && !(0, $_.isFragment)(e);
}
Qo.supportNodeRef = function(t) {
  return VP(t) && gbt(t);
};
Qo.getNodeRef = Number(bce.version.split(".")[0]) >= 19 ? (
  // >= React 19
  function(e) {
    return VP(e) ? e.props.ref : null;
  }
) : (
  // < React 19
  function(e) {
    return VP(e) ? e.ref : null;
  }
);
var J2 = {}, ys = {}, N4 = {}, pbt = dn.default;
Object.defineProperty(N4, "__esModule", {
  value: !0
});
N4.default = BP;
var mbt = pbt(j), vbt = Qd;
function BP(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = [];
  return mbt.default.Children.forEach(e, function(r) {
    r == null && !t.keepEmpty || (Array.isArray(r) ? n = n.concat(BP(r)) : (0, vbt.isFragment)(r) && r.props ? n = n.concat(BP(r.props.children, t)) : n.push(r));
  }), n;
}
var _p = {}, Z2 = {};
Object.defineProperty(Z2, "__esModule", {
  value: !0
});
Z2.default = void 0;
const ybt = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [t]: {
      "&-block": {
        display: "flex",
        width: "100%"
      },
      "&-vertical": {
        flexDirection: "column"
      }
    }
  };
};
Z2.default = ybt;
var bbt = dn.default;
Object.defineProperty(_p, "__esModule", {
  value: !0
});
_p.prepareComponentToken = _p.default = void 0;
var Gz = $l, _bt = bbt(Z2);
const Sbt = (e) => {
  const {
    componentCls: t,
    antCls: n
  } = e;
  return {
    [t]: {
      display: "inline-flex",
      "&-rtl": {
        direction: "rtl"
      },
      "&-vertical": {
        flexDirection: "column"
      },
      "&-align": {
        flexDirection: "column",
        "&-center": {
          alignItems: "center"
        },
        "&-start": {
          alignItems: "flex-start"
        },
        "&-end": {
          alignItems: "flex-end"
        },
        "&-baseline": {
          alignItems: "baseline"
        }
      },
      [`${t}-item:empty`]: {
        display: "none"
      },
      // https://github.com/ant-design/ant-design/issues/47875
      [`${t}-item > ${n}-badge-not-a-wrapper:only-child`]: {
        display: "block"
      }
    }
  };
}, wbt = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [t]: {
      "&-gap-row-small": {
        rowGap: e.spaceGapSmallSize
      },
      "&-gap-row-middle": {
        rowGap: e.spaceGapMiddleSize
      },
      "&-gap-row-large": {
        rowGap: e.spaceGapLargeSize
      },
      "&-gap-col-small": {
        columnGap: e.spaceGapSmallSize
      },
      "&-gap-col-middle": {
        columnGap: e.spaceGapMiddleSize
      },
      "&-gap-col-large": {
        columnGap: e.spaceGapLargeSize
      }
    }
  };
}, xbt = () => ({});
_p.prepareComponentToken = xbt;
_p.default = (0, Gz.genStyleHooks)("Space", (e) => {
  const t = (0, Gz.mergeToken)(e, {
    spaceGapSmallSize: e.paddingXS,
    spaceGapMiddleSize: e.padding,
    spaceGapLargeSize: e.paddingLG
  });
  return [Sbt(t), wbt(t), (0, _bt.default)(t)];
}, () => ({}), {
  // Space component don't apply extra font style
  // https://github.com/ant-design/ant-design/issues/40315
  resetStyle: !1
});
var e5 = dn.default, Ebt = pi.default;
Object.defineProperty(ys, "__esModule", {
  value: !0
});
ys.useCompactItemContext = ys.default = ys.SpaceCompactItemContext = ys.NoCompactStyle = void 0;
var tc = Ebt(j), _ce = e5(qp), Cbt = e5(N4), Tbt = fb, Ibt = e5(gm), $bt = e5(_p), Sce = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
const t5 = ys.SpaceCompactItemContext = /* @__PURE__ */ tc.createContext(null), Abt = (e, t) => {
  const n = tc.useContext(t5), r = tc.useMemo(() => {
    if (!n)
      return "";
    const {
      compactDirection: i,
      isFirstItem: o,
      isLastItem: a
    } = n, s = i === "vertical" ? "-vertical-" : "-";
    return (0, _ce.default)(`${e}-compact${s}item`, {
      [`${e}-compact${s}first-item`]: o,
      [`${e}-compact${s}last-item`]: a,
      [`${e}-compact${s}item-rtl`]: t === "rtl"
    });
  }, [e, t, n]);
  return {
    compactSize: n == null ? void 0 : n.compactSize,
    compactDirection: n == null ? void 0 : n.compactDirection,
    compactItemClassnames: r
  };
};
ys.useCompactItemContext = Abt;
const Rbt = (e) => {
  let {
    children: t
  } = e;
  return /* @__PURE__ */ tc.createElement(t5.Provider, {
    value: null
  }, t);
};
ys.NoCompactStyle = Rbt;
const Pbt = (e) => {
  var {
    children: t
  } = e, n = Sce(e, ["children"]);
  return /* @__PURE__ */ tc.createElement(t5.Provider, {
    value: n
  }, t);
}, Obt = (e) => {
  const {
    getPrefixCls: t,
    direction: n
  } = tc.useContext(Tbt.ConfigContext), {
    size: r,
    direction: i,
    block: o,
    prefixCls: a,
    className: s,
    rootClassName: c,
    children: l
  } = e, u = Sce(e, ["size", "direction", "block", "prefixCls", "className", "rootClassName", "children"]), d = (0, Ibt.default)((_) => r ?? _), f = t("space-compact", a), [h, p] = (0, $bt.default)(f), g = (0, _ce.default)(f, p, {
    [`${f}-rtl`]: n === "rtl",
    [`${f}-block`]: o,
    [`${f}-vertical`]: i === "vertical"
  }, s, c), m = tc.useContext(t5), v = (0, Cbt.default)(l), y = tc.useMemo(() => v.map((_, b) => {
    const w = (_ == null ? void 0 : _.key) || `${f}-item-${b}`;
    return /* @__PURE__ */ tc.createElement(Pbt, {
      key: w,
      compactSize: d,
      compactDirection: i,
      isFirstItem: b === 0 && (!m || (m == null ? void 0 : m.isFirstItem)),
      isLastItem: b === v.length - 1 && (!m || (m == null ? void 0 : m.isLastItem))
    }, _);
  }), [r, v, m]);
  return v.length === 0 ? null : h(/* @__PURE__ */ tc.createElement("div", Object.assign({
    className: g
  }, u), y));
};
ys.default = Obt;
var Mbt = dn.default;
Object.defineProperty(J2, "__esModule", {
  value: !0
});
J2.default = void 0;
var Kz = Mbt(j), kbt = _i, Nbt = ys;
const Dbt = (e) => {
  const {
    space: t,
    form: n,
    children: r
  } = e;
  if (r == null)
    return null;
  let i = r;
  return n && (i = /* @__PURE__ */ Kz.default.createElement(kbt.NoFormStyle, {
    override: !0,
    status: !0
  }, i)), t && (i = /* @__PURE__ */ Kz.default.createElement(Nbt.NoCompactStyle, null, i)), i;
};
J2.default = Dbt;
var D4 = {};
Object.defineProperty(D4, "__esModule", {
  value: !0
});
D4.default = jbt;
var Yz = j;
function jbt(e, t) {
  const n = (0, Yz.useRef)([]), r = () => {
    n.current.push(setTimeout(() => {
      var i, o, a, s;
      !((i = e.current) === null || i === void 0) && i.input && ((o = e.current) === null || o === void 0 ? void 0 : o.input.getAttribute("type")) === "password" && (!((a = e.current) === null || a === void 0) && a.input.hasAttribute("value")) && ((s = e.current) === null || s === void 0 || s.input.removeAttribute("value"));
    }));
  };
  return (0, Yz.useEffect)(() => (t && r(), () => n.current.forEach((i) => {
    i && clearTimeout(i);
  })), []), r;
}
var j4 = {}, L4 = {};
Object.defineProperty(L4, "__esModule", {
  value: !0
});
L4.genCompactItemStyle = Vbt;
function Lbt(e, t, n) {
  const {
    focusElCls: r,
    focus: i,
    borderElCls: o
  } = n, a = o ? "> *" : "", s = ["hover", i ? "focus" : null, "active"].filter(Boolean).map((c) => `&:${c} ${a}`).join(",");
  return {
    [`&-item:not(${t}-last-item)`]: {
      marginInlineEnd: e.calc(e.lineWidth).mul(-1).equal()
    },
    "&-item": Object.assign(Object.assign({
      [s]: {
        zIndex: 2
      }
    }, r ? {
      [`&${r}`]: {
        zIndex: 2
      }
    } : {}), {
      [`&[disabled] ${a}`]: {
        zIndex: 0
      }
    })
  };
}
function Fbt(e, t, n) {
  const {
    borderElCls: r
  } = n, i = r ? `> ${r}` : "";
  return {
    [`&-item:not(${t}-first-item):not(${t}-last-item) ${i}`]: {
      borderRadius: 0
    },
    [`&-item:not(${t}-last-item)${t}-first-item`]: {
      [`& ${i}, &${e}-sm ${i}, &${e}-lg ${i}`]: {
        borderStartEndRadius: 0,
        borderEndEndRadius: 0
      }
    },
    [`&-item:not(${t}-first-item)${t}-last-item`]: {
      [`& ${i}, &${e}-sm ${i}, &${e}-lg ${i}`]: {
        borderStartStartRadius: 0,
        borderEndStartRadius: 0
      }
    }
  };
}
function Vbt(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    focus: !0
  };
  const {
    componentCls: n
  } = e, r = `${n}-compact`;
  return {
    [r]: Object.assign(Object.assign({}, Lbt(e, r, t)), Fbt(n, r, t))
  };
}
var xb = {};
Object.defineProperty(xb, "__esModule", {
  value: !0
});
xb.initComponentToken = void 0;
xb.initInputToken = zbt;
var Bbt = $l;
function zbt(e) {
  return (0, Bbt.mergeToken)(e, {
    inputAffixPadding: e.paddingXXS
  });
}
const Hbt = (e) => {
  const {
    controlHeight: t,
    fontSize: n,
    lineHeight: r,
    lineWidth: i,
    controlHeightSM: o,
    controlHeightLG: a,
    fontSizeLG: s,
    lineHeightLG: c,
    paddingSM: l,
    controlPaddingHorizontalSM: u,
    controlPaddingHorizontal: d,
    colorFillAlter: f,
    colorPrimaryHover: h,
    colorPrimary: p,
    controlOutlineWidth: g,
    controlOutline: m,
    colorErrorOutline: v,
    colorWarningOutline: y,
    colorBgContainer: _
  } = e;
  return {
    paddingBlock: Math.max(Math.round((t - n * r) / 2 * 10) / 10 - i, 0),
    paddingBlockSM: Math.max(Math.round((o - n * r) / 2 * 10) / 10 - i, 0),
    paddingBlockLG: Math.ceil((a - s * c) / 2 * 10) / 10 - i,
    paddingInline: l - i,
    paddingInlineSM: u - i,
    paddingInlineLG: d - i,
    addonBg: f,
    activeBorderColor: p,
    hoverBorderColor: h,
    activeShadow: `0 0 0 ${g}px ${m}`,
    errorActiveShadow: `0 0 0 ${g}px ${v}`,
    warningActiveShadow: `0 0 0 ${g}px ${y}`,
    hoverBg: _,
    activeBg: _,
    inputFontSize: n,
    inputFontSizeLG: s,
    inputFontSizeSM: n
  };
};
xb.initComponentToken = Hbt;
var Ri = {};
Object.defineProperty(Ri, "__esModule", {
  value: !0
});
Ri.genOutlinedStyle = Ri.genOutlinedGroupStyle = Ri.genHoverStyle = Ri.genFilledStyle = Ri.genFilledGroupStyle = Ri.genDisabledStyle = Ri.genBorderlessStyle = Ri.genBaseOutlinedStyle = void 0;
var Hc = dd, Ubt = $l;
const wce = (e) => ({
  borderColor: e.hoverBorderColor,
  backgroundColor: e.hoverBg
});
Ri.genHoverStyle = wce;
const n5 = (e) => ({
  color: e.colorTextDisabled,
  backgroundColor: e.colorBgContainerDisabled,
  borderColor: e.colorBorder,
  boxShadow: "none",
  cursor: "not-allowed",
  opacity: 1,
  "input[disabled], textarea[disabled]": {
    cursor: "not-allowed"
  },
  "&:hover:not([disabled])": Object.assign({}, wce((0, Ubt.mergeToken)(e, {
    hoverBorderColor: e.colorBorder,
    hoverBg: e.colorBgContainerDisabled
  })))
});
Ri.genDisabledStyle = n5;
const F4 = (e, t) => ({
  background: e.colorBgContainer,
  borderWidth: e.lineWidth,
  borderStyle: e.lineType,
  borderColor: t.borderColor,
  "&:hover": {
    borderColor: t.hoverBorderColor,
    backgroundColor: e.hoverBg
  },
  "&:focus, &:focus-within": {
    borderColor: t.activeBorderColor,
    boxShadow: t.activeShadow,
    outline: 0,
    backgroundColor: e.activeBg
  }
});
Ri.genBaseOutlinedStyle = F4;
const Xz = (e, t) => ({
  [`&${e.componentCls}-status-${t.status}:not(${e.componentCls}-disabled)`]: Object.assign(Object.assign({}, F4(e, t)), {
    [`${e.componentCls}-prefix, ${e.componentCls}-suffix`]: {
      color: t.affixColor
    }
  }),
  [`&${e.componentCls}-status-${t.status}${e.componentCls}-disabled`]: {
    borderColor: t.borderColor
  }
}), Wbt = (e, t) => ({
  "&-outlined": Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, F4(e, {
    borderColor: e.colorBorder,
    hoverBorderColor: e.hoverBorderColor,
    activeBorderColor: e.activeBorderColor,
    activeShadow: e.activeShadow
  })), {
    [`&${e.componentCls}-disabled, &[disabled]`]: Object.assign({}, n5(e))
  }), Xz(e, {
    status: "error",
    borderColor: e.colorError,
    hoverBorderColor: e.colorErrorBorderHover,
    activeBorderColor: e.colorError,
    activeShadow: e.errorActiveShadow,
    affixColor: e.colorError
  })), Xz(e, {
    status: "warning",
    borderColor: e.colorWarning,
    hoverBorderColor: e.colorWarningBorderHover,
    activeBorderColor: e.colorWarning,
    activeShadow: e.warningActiveShadow,
    affixColor: e.colorWarning
  })), t)
});
Ri.genOutlinedStyle = Wbt;
const Qz = (e, t) => ({
  [`&${e.componentCls}-group-wrapper-status-${t.status}`]: {
    [`${e.componentCls}-group-addon`]: {
      borderColor: t.addonBorderColor,
      color: t.addonColor
    }
  }
}), qbt = (e) => ({
  "&-outlined": Object.assign(Object.assign(Object.assign({
    [`${e.componentCls}-group`]: {
      "&-addon": {
        background: e.addonBg,
        border: `${(0, Hc.unit)(e.lineWidth)} ${e.lineType} ${e.colorBorder}`
      },
      "&-addon:first-child": {
        borderInlineEnd: 0
      },
      "&-addon:last-child": {
        borderInlineStart: 0
      }
    }
  }, Qz(e, {
    status: "error",
    addonBorderColor: e.colorError,
    addonColor: e.colorErrorText
  })), Qz(e, {
    status: "warning",
    addonBorderColor: e.colorWarning,
    addonColor: e.colorWarningText
  })), {
    [`&${e.componentCls}-group-wrapper-disabled`]: {
      [`${e.componentCls}-group-addon`]: Object.assign({}, n5(e))
    }
  })
});
Ri.genOutlinedGroupStyle = qbt;
const Gbt = (e, t) => {
  const {
    componentCls: n
  } = e;
  return {
    "&-borderless": Object.assign({
      background: "transparent",
      border: "none",
      "&:focus, &:focus-within": {
        outline: "none"
      },
      // >>>>> Disabled
      [`&${n}-disabled, &[disabled]`]: {
        color: e.colorTextDisabled,
        cursor: "not-allowed"
      },
      // >>>>> Status
      [`&${n}-status-error`]: {
        "&, & input, & textarea": {
          color: e.colorError
        }
      },
      [`&${n}-status-warning`]: {
        "&, & input, & textarea": {
          color: e.colorWarning
        }
      }
    }, t)
  };
};
Ri.genBorderlessStyle = Gbt;
const xce = (e, t) => ({
  background: t.bg,
  borderWidth: e.lineWidth,
  borderStyle: e.lineType,
  borderColor: "transparent",
  "input&, & input, textarea&, & textarea": {
    color: t == null ? void 0 : t.inputColor
  },
  "&:hover": {
    background: t.hoverBg
  },
  "&:focus, &:focus-within": {
    outline: 0,
    borderColor: t.activeBorderColor,
    backgroundColor: e.activeBg
  }
}), Jz = (e, t) => ({
  [`&${e.componentCls}-status-${t.status}:not(${e.componentCls}-disabled)`]: Object.assign(Object.assign({}, xce(e, t)), {
    [`${e.componentCls}-prefix, ${e.componentCls}-suffix`]: {
      color: t.affixColor
    }
  })
}), Kbt = (e, t) => ({
  "&-filled": Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, xce(e, {
    bg: e.colorFillTertiary,
    hoverBg: e.colorFillSecondary,
    activeBorderColor: e.activeBorderColor
  })), {
    [`&${e.componentCls}-disabled, &[disabled]`]: Object.assign({}, n5(e))
  }), Jz(e, {
    status: "error",
    bg: e.colorErrorBg,
    hoverBg: e.colorErrorBgHover,
    activeBorderColor: e.colorError,
    inputColor: e.colorErrorText,
    affixColor: e.colorError
  })), Jz(e, {
    status: "warning",
    bg: e.colorWarningBg,
    hoverBg: e.colorWarningBgHover,
    activeBorderColor: e.colorWarning,
    inputColor: e.colorWarningText,
    affixColor: e.colorWarning
  })), t)
});
Ri.genFilledStyle = Kbt;
const Zz = (e, t) => ({
  [`&${e.componentCls}-group-wrapper-status-${t.status}`]: {
    [`${e.componentCls}-group-addon`]: {
      background: t.addonBg,
      color: t.addonColor
    }
  }
}), Ybt = (e) => ({
  "&-filled": Object.assign(Object.assign(Object.assign({
    [`${e.componentCls}-group`]: {
      "&-addon": {
        background: e.colorFillTertiary
      },
      [`${e.componentCls}-filled:not(:focus):not(:focus-within)`]: {
        "&:not(:first-child)": {
          borderInlineStart: `${(0, Hc.unit)(e.lineWidth)} ${e.lineType} ${e.colorSplit}`
        },
        "&:not(:last-child)": {
          borderInlineEnd: `${(0, Hc.unit)(e.lineWidth)} ${e.lineType} ${e.colorSplit}`
        }
      }
    }
  }, Zz(e, {
    status: "error",
    addonBg: e.colorErrorBg,
    addonColor: e.colorErrorText
  })), Zz(e, {
    status: "warning",
    addonBg: e.colorWarningBg,
    addonColor: e.colorWarningText
  })), {
    [`&${e.componentCls}-group-wrapper-disabled`]: {
      [`${e.componentCls}-group`]: {
        "&-addon": {
          background: e.colorFillTertiary,
          color: e.colorTextDisabled
        },
        "&-addon:first-child": {
          borderInlineStart: `${(0, Hc.unit)(e.lineWidth)} ${e.lineType} ${e.colorBorder}`,
          borderTop: `${(0, Hc.unit)(e.lineWidth)} ${e.lineType} ${e.colorBorder}`,
          borderBottom: `${(0, Hc.unit)(e.lineWidth)} ${e.lineType} ${e.colorBorder}`
        },
        "&-addon:last-child": {
          borderInlineEnd: `${(0, Hc.unit)(e.lineWidth)} ${e.lineType} ${e.colorBorder}`,
          borderTop: `${(0, Hc.unit)(e.lineWidth)} ${e.lineType} ${e.colorBorder}`,
          borderBottom: `${(0, Hc.unit)(e.lineWidth)} ${e.lineType} ${e.colorBorder}`
        }
      }
    }
  })
});
Ri.genFilledGroupStyle = Ybt;
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.genPlaceholderStyle = e.genInputSmallStyle = e.genInputGroupStyle = e.genBasicInputStyle = e.genActiveStyle = e.default = void 0, Object.defineProperty(e, "initComponentToken", {
    enumerable: !0,
    get: function() {
      return o.initComponentToken;
    }
  }), Object.defineProperty(e, "initInputToken", {
    enumerable: !0,
    get: function() {
      return o.initInputToken;
    }
  });
  var t = dd, n = qr, r = L4, i = $l, o = xb, a = Ri;
  const s = (b) => ({
    // Firefox
    "&::-moz-placeholder": {
      opacity: 1
    },
    "&::placeholder": {
      color: b,
      userSelect: "none"
      // https://github.com/ant-design/ant-design/pull/32639
    },
    "&:placeholder-shown": {
      textOverflow: "ellipsis"
    }
  });
  e.genPlaceholderStyle = s;
  const c = (b) => ({
    borderColor: b.activeBorderColor,
    boxShadow: b.activeShadow,
    outline: 0,
    backgroundColor: b.activeBg
  });
  e.genActiveStyle = c;
  const l = (b) => {
    const {
      paddingBlockLG: w,
      lineHeightLG: C,
      borderRadiusLG: x,
      paddingInlineLG: T
    } = b;
    return {
      padding: `${(0, t.unit)(w)} ${(0, t.unit)(T)}`,
      fontSize: b.inputFontSizeLG,
      lineHeight: C,
      borderRadius: x
    };
  }, u = (b) => ({
    padding: `${(0, t.unit)(b.paddingBlockSM)} ${(0, t.unit)(b.paddingInlineSM)}`,
    fontSize: b.inputFontSizeSM,
    borderRadius: b.borderRadiusSM
  });
  e.genInputSmallStyle = u;
  const d = (b) => Object.assign(Object.assign({
    position: "relative",
    display: "inline-block",
    width: "100%",
    minWidth: 0,
    padding: `${(0, t.unit)(b.paddingBlock)} ${(0, t.unit)(b.paddingInline)}`,
    color: b.colorText,
    fontSize: b.inputFontSize,
    lineHeight: b.lineHeight,
    borderRadius: b.borderRadius,
    transition: `all ${b.motionDurationMid}`
  }, s(b.colorTextPlaceholder)), {
    // Reset height for `textarea`s
    "textarea&": {
      maxWidth: "100%",
      // prevent textarea resize from coming out of its container
      height: "auto",
      minHeight: b.controlHeight,
      lineHeight: b.lineHeight,
      verticalAlign: "bottom",
      transition: `all ${b.motionDurationSlow}, height 0s`,
      resize: "vertical"
    },
    // Size
    "&-lg": Object.assign({}, l(b)),
    "&-sm": Object.assign({}, u(b)),
    // RTL
    "&-rtl, &-textarea-rtl": {
      direction: "rtl"
    }
  });
  e.genBasicInputStyle = d;
  const f = (b) => {
    const {
      componentCls: w,
      antCls: C
    } = b;
    return {
      position: "relative",
      display: "table",
      width: "100%",
      borderCollapse: "separate",
      borderSpacing: 0,
      // Undo padding and float of grid classes
      "&[class*='col-']": {
        paddingInlineEnd: b.paddingXS,
        "&:last-child": {
          paddingInlineEnd: 0
        }
      },
      // Sizing options
      [`&-lg ${w}, &-lg > ${w}-group-addon`]: Object.assign({}, l(b)),
      [`&-sm ${w}, &-sm > ${w}-group-addon`]: Object.assign({}, u(b)),
      // Fix https://github.com/ant-design/ant-design/issues/5754
      [`&-lg ${C}-select-single ${C}-select-selector`]: {
        height: b.controlHeightLG
      },
      [`&-sm ${C}-select-single ${C}-select-selector`]: {
        height: b.controlHeightSM
      },
      [`> ${w}`]: {
        display: "table-cell",
        "&:not(:first-child):not(:last-child)": {
          borderRadius: 0
        }
      },
      [`${w}-group`]: {
        "&-addon, &-wrap": {
          display: "table-cell",
          width: 1,
          whiteSpace: "nowrap",
          verticalAlign: "middle",
          "&:not(:first-child):not(:last-child)": {
            borderRadius: 0
          }
        },
        "&-wrap > *": {
          display: "block !important"
        },
        "&-addon": {
          position: "relative",
          padding: `0 ${(0, t.unit)(b.paddingInline)}`,
          color: b.colorText,
          fontWeight: "normal",
          fontSize: b.inputFontSize,
          textAlign: "center",
          borderRadius: b.borderRadius,
          transition: `all ${b.motionDurationSlow}`,
          lineHeight: 1,
          // Reset Select's style in addon
          [`${C}-select`]: {
            margin: `${(0, t.unit)(b.calc(b.paddingBlock).add(1).mul(-1).equal())} ${(0, t.unit)(b.calc(b.paddingInline).mul(-1).equal())}`,
            [`&${C}-select-single:not(${C}-select-customize-input):not(${C}-pagination-size-changer)`]: {
              [`${C}-select-selector`]: {
                backgroundColor: "inherit",
                border: `${(0, t.unit)(b.lineWidth)} ${b.lineType} transparent`,
                boxShadow: "none"
              }
            }
          },
          // https://github.com/ant-design/ant-design/issues/31333
          [`${C}-cascader-picker`]: {
            margin: `-9px ${(0, t.unit)(b.calc(b.paddingInline).mul(-1).equal())}`,
            backgroundColor: "transparent",
            [`${C}-cascader-input`]: {
              textAlign: "start",
              border: 0,
              boxShadow: "none"
            }
          }
        }
      },
      [w]: {
        width: "100%",
        marginBottom: 0,
        textAlign: "inherit",
        "&:focus": {
          zIndex: 1,
          // Fix https://gw.alipayobjects.com/zos/rmsportal/DHNpoqfMXSfrSnlZvhsJ.png
          borderInlineEndWidth: 1
        },
        "&:hover": {
          zIndex: 1,
          borderInlineEndWidth: 1,
          [`${w}-search-with-button &`]: {
            zIndex: 0
          }
        }
      },
      // Reset rounded corners
      [`> ${w}:first-child, ${w}-group-addon:first-child`]: {
        borderStartEndRadius: 0,
        borderEndEndRadius: 0,
        // Reset Select's style in addon
        [`${C}-select ${C}-select-selector`]: {
          borderStartEndRadius: 0,
          borderEndEndRadius: 0
        }
      },
      [`> ${w}-affix-wrapper`]: {
        [`&:not(:first-child) ${w}`]: {
          borderStartStartRadius: 0,
          borderEndStartRadius: 0
        },
        [`&:not(:last-child) ${w}`]: {
          borderStartEndRadius: 0,
          borderEndEndRadius: 0
        }
      },
      [`> ${w}:last-child, ${w}-group-addon:last-child`]: {
        borderStartStartRadius: 0,
        borderEndStartRadius: 0,
        // Reset Select's style in addon
        [`${C}-select ${C}-select-selector`]: {
          borderStartStartRadius: 0,
          borderEndStartRadius: 0
        }
      },
      [`${w}-affix-wrapper`]: {
        "&:not(:last-child)": {
          borderStartEndRadius: 0,
          borderEndEndRadius: 0,
          [`${w}-search &`]: {
            borderStartStartRadius: b.borderRadius,
            borderEndStartRadius: b.borderRadius
          }
        },
        [`&:not(:first-child), ${w}-search &:not(:first-child)`]: {
          borderStartStartRadius: 0,
          borderEndStartRadius: 0
        }
      },
      [`&${w}-group-compact`]: Object.assign(Object.assign({
        display: "block"
      }, (0, n.clearFix)()), {
        [`${w}-group-addon, ${w}-group-wrap, > ${w}`]: {
          "&:not(:first-child):not(:last-child)": {
            borderInlineEndWidth: b.lineWidth,
            "&:hover, &:focus": {
              zIndex: 1
            }
          }
        },
        "& > *": {
          display: "inline-flex",
          float: "none",
          verticalAlign: "top",
          // https://github.com/ant-design/ant-design-pro/issues/139
          borderRadius: 0
        },
        [`
        & > ${w}-affix-wrapper,
        & > ${w}-number-affix-wrapper,
        & > ${C}-picker-range
      `]: {
          display: "inline-flex"
        },
        "& > *:not(:last-child)": {
          marginInlineEnd: b.calc(b.lineWidth).mul(-1).equal(),
          borderInlineEndWidth: b.lineWidth
        },
        // Undo float for .ant-input-group .ant-input
        [w]: {
          float: "none"
        },
        // reset border for Select, DatePicker, AutoComplete, Cascader, Mention, TimePicker, Input
        [`& > ${C}-select > ${C}-select-selector,
      & > ${C}-select-auto-complete ${w},
      & > ${C}-cascader-picker ${w},
      & > ${w}-group-wrapper ${w}`]: {
          borderInlineEndWidth: b.lineWidth,
          borderRadius: 0,
          "&:hover, &:focus": {
            zIndex: 1
          }
        },
        [`& > ${C}-select-focused`]: {
          zIndex: 1
        },
        // update z-index for arrow icon
        [`& > ${C}-select > ${C}-select-arrow`]: {
          zIndex: 1
          // https://github.com/ant-design/ant-design/issues/20371
        },
        [`& > *:first-child,
      & > ${C}-select:first-child > ${C}-select-selector,
      & > ${C}-select-auto-complete:first-child ${w},
      & > ${C}-cascader-picker:first-child ${w}`]: {
          borderStartStartRadius: b.borderRadius,
          borderEndStartRadius: b.borderRadius
        },
        [`& > *:last-child,
      & > ${C}-select:last-child > ${C}-select-selector,
      & > ${C}-cascader-picker:last-child ${w},
      & > ${C}-cascader-picker-focused:last-child ${w}`]: {
          borderInlineEndWidth: b.lineWidth,
          borderStartEndRadius: b.borderRadius,
          borderEndEndRadius: b.borderRadius
        },
        // https://github.com/ant-design/ant-design/issues/12493
        [`& > ${C}-select-auto-complete ${w}`]: {
          verticalAlign: "top"
        },
        [`${w}-group-wrapper + ${w}-group-wrapper`]: {
          marginInlineStart: b.calc(b.lineWidth).mul(-1).equal(),
          [`${w}-affix-wrapper`]: {
            borderRadius: 0
          }
        },
        [`${w}-group-wrapper:not(:last-child)`]: {
          [`&${w}-search > ${w}-group`]: {
            [`& > ${w}-group-addon > ${w}-search-button`]: {
              borderRadius: 0
            },
            [`& > ${w}`]: {
              borderStartStartRadius: b.borderRadius,
              borderStartEndRadius: 0,
              borderEndEndRadius: 0,
              borderEndStartRadius: b.borderRadius
            }
          }
        }
      })
    };
  };
  e.genInputGroupStyle = f;
  const h = (b) => {
    const {
      componentCls: w,
      controlHeightSM: C,
      lineWidth: x,
      calc: T
    } = b, E = 16, R = T(C).sub(T(x).mul(2)).sub(E).div(2).equal();
    return {
      [w]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (0, n.resetComponent)(b)), d(b)), (0, a.genOutlinedStyle)(b)), (0, a.genFilledStyle)(b)), (0, a.genBorderlessStyle)(b)), {
        '&[type="color"]': {
          height: b.controlHeight,
          [`&${w}-lg`]: {
            height: b.controlHeightLG
          },
          [`&${w}-sm`]: {
            height: C,
            paddingTop: R,
            paddingBottom: R
          }
        },
        '&[type="search"]::-webkit-search-cancel-button, &[type="search"]::-webkit-search-decoration': {
          "-webkit-appearance": "none"
        }
      })
    };
  }, p = (b) => {
    const {
      componentCls: w
    } = b;
    return {
      // ========================= Input =========================
      [`${w}-clear-icon`]: {
        margin: 0,
        color: b.colorTextQuaternary,
        fontSize: b.fontSizeIcon,
        verticalAlign: -1,
        // https://github.com/ant-design/ant-design/pull/18151
        // https://codesandbox.io/s/wizardly-sun-u10br
        cursor: "pointer",
        transition: `color ${b.motionDurationSlow}`,
        "&:hover": {
          color: b.colorTextTertiary
        },
        "&:active": {
          color: b.colorText
        },
        "&-hidden": {
          visibility: "hidden"
        },
        "&-has-suffix": {
          margin: `0 ${(0, t.unit)(b.inputAffixPadding)}`
        }
      }
    };
  }, g = (b) => {
    const {
      componentCls: w,
      inputAffixPadding: C,
      colorTextDescription: x,
      motionDurationSlow: T,
      colorIcon: E,
      colorIconHover: R,
      iconCls: I
    } = b, O = `${w}-affix-wrapper`, P = `${w}-affix-wrapper-disabled`;
    return {
      [O]: Object.assign(Object.assign(Object.assign(Object.assign({}, d(b)), {
        display: "inline-flex",
        [`&:not(${w}-disabled):hover`]: {
          zIndex: 1,
          [`${w}-search-with-button &`]: {
            zIndex: 0
          }
        },
        "&-focused, &:focus": {
          zIndex: 1
        },
        [`> input${w}`]: {
          padding: 0
        },
        [`> input${w}, > textarea${w}`]: {
          fontSize: "inherit",
          border: "none",
          borderRadius: 0,
          outline: "none",
          background: "transparent",
          color: "inherit",
          "&::-ms-reveal": {
            display: "none"
          },
          "&:focus": {
            boxShadow: "none !important"
          }
        },
        "&::before": {
          display: "inline-block",
          width: 0,
          visibility: "hidden",
          content: '"\\a0"'
        },
        [w]: {
          "&-prefix, &-suffix": {
            display: "flex",
            flex: "none",
            alignItems: "center",
            "> *:not(:last-child)": {
              marginInlineEnd: b.paddingXS
            }
          },
          "&-show-count-suffix": {
            color: x
          },
          "&-show-count-has-suffix": {
            marginInlineEnd: b.paddingXXS
          },
          "&-prefix": {
            marginInlineEnd: C
          },
          "&-suffix": {
            marginInlineStart: C
          }
        }
      }), p(b)), {
        // password
        [`${I}${w}-password-icon`]: {
          color: E,
          cursor: "pointer",
          transition: `all ${T}`,
          "&:hover": {
            color: R
          }
        }
      }),
      [P]: {
        // password disabled
        [`${I}${w}-password-icon`]: {
          color: E,
          cursor: "not-allowed",
          "&:hover": {
            color: E
          }
        }
      }
    };
  }, m = (b) => {
    const {
      componentCls: w,
      borderRadiusLG: C,
      borderRadiusSM: x
    } = b;
    return {
      [`${w}-group`]: Object.assign(Object.assign(Object.assign({}, (0, n.resetComponent)(b)), f(b)), {
        "&-rtl": {
          direction: "rtl"
        },
        "&-wrapper": Object.assign(Object.assign(Object.assign({
          display: "inline-block",
          width: "100%",
          textAlign: "start",
          verticalAlign: "top",
          "&-rtl": {
            direction: "rtl"
          },
          // Size
          "&-lg": {
            [`${w}-group-addon`]: {
              borderRadius: C,
              fontSize: b.inputFontSizeLG
            }
          },
          "&-sm": {
            [`${w}-group-addon`]: {
              borderRadius: x
            }
          }
        }, (0, a.genOutlinedGroupStyle)(b)), (0, a.genFilledGroupStyle)(b)), {
          // '&-disabled': {
          //   [`${componentCls}-group-addon`]: {
          //     ...genDisabledStyle(token),
          //   },
          // },
          // Fix the issue of using icons in Space Compact mode
          // https://github.com/ant-design/ant-design/issues/42122
          [`&:not(${w}-compact-first-item):not(${w}-compact-last-item)${w}-compact-item`]: {
            [`${w}, ${w}-group-addon`]: {
              borderRadius: 0
            }
          },
          [`&:not(${w}-compact-last-item)${w}-compact-first-item`]: {
            [`${w}, ${w}-group-addon`]: {
              borderStartEndRadius: 0,
              borderEndEndRadius: 0
            }
          },
          [`&:not(${w}-compact-first-item)${w}-compact-last-item`]: {
            [`${w}, ${w}-group-addon`]: {
              borderStartStartRadius: 0,
              borderEndStartRadius: 0
            }
          },
          // Fix the issue of input use show-count param in space compact mode
          // https://github.com/ant-design/ant-design/issues/46872
          [`&:not(${w}-compact-last-item)${w}-compact-item`]: {
            [`${w}-affix-wrapper`]: {
              borderStartEndRadius: 0,
              borderEndEndRadius: 0
            }
          }
        })
      })
    };
  }, v = (b) => {
    const {
      componentCls: w,
      antCls: C
    } = b, x = `${w}-search`;
    return {
      [x]: {
        [w]: {
          "&:hover, &:focus": {
            [`+ ${w}-group-addon ${x}-button:not(${C}-btn-primary)`]: {
              borderInlineStartColor: b.colorPrimaryHover
            }
          }
        },
        [`${w}-affix-wrapper`]: {
          height: b.controlHeight,
          borderRadius: 0
        },
        // fix slight height diff in Firefox:
        // https://ant.design/components/auto-complete-cn/#auto-complete-demo-certain-category
        [`${w}-lg`]: {
          lineHeight: b.calc(b.lineHeightLG).sub(2e-4).equal()
        },
        [`> ${w}-group`]: {
          [`> ${w}-group-addon:last-child`]: {
            insetInlineStart: -1,
            padding: 0,
            border: 0,
            [`${x}-button`]: {
              // Fix https://github.com/ant-design/ant-design/issues/47150
              marginInlineEnd: -1,
              paddingTop: 0,
              paddingBottom: 0,
              borderStartStartRadius: 0,
              borderEndStartRadius: 0,
              boxShadow: "none"
            },
            [`${x}-button:not(${C}-btn-primary)`]: {
              color: b.colorTextDescription,
              "&:hover": {
                color: b.colorPrimaryHover
              },
              "&:active": {
                color: b.colorPrimaryActive
              },
              [`&${C}-btn-loading::before`]: {
                insetInlineStart: 0,
                insetInlineEnd: 0,
                insetBlockStart: 0,
                insetBlockEnd: 0
              }
            }
          }
        },
        [`${x}-button`]: {
          height: b.controlHeight,
          "&:hover, &:focus": {
            zIndex: 1
          }
        },
        "&-large": {
          [`${w}-affix-wrapper, ${x}-button`]: {
            height: b.controlHeightLG
          }
        },
        "&-small": {
          [`${w}-affix-wrapper, ${x}-button`]: {
            height: b.controlHeightSM
          }
        },
        "&-rtl": {
          direction: "rtl"
        },
        // ===================== Compact Item Customized Styles =====================
        [`&${w}-compact-item`]: {
          [`&:not(${w}-compact-last-item)`]: {
            [`${w}-group-addon`]: {
              [`${w}-search-button`]: {
                marginInlineEnd: b.calc(b.lineWidth).mul(-1).equal(),
                borderRadius: 0
              }
            }
          },
          [`&:not(${w}-compact-first-item)`]: {
            [`${w},${w}-affix-wrapper`]: {
              borderRadius: 0
            }
          },
          [`> ${w}-group-addon ${w}-search-button,
        > ${w},
        ${w}-affix-wrapper`]: {
            "&:hover, &:focus, &:active": {
              zIndex: 2
            }
          },
          [`> ${w}-affix-wrapper-focused`]: {
            zIndex: 2
          }
        }
      }
    };
  }, y = (b) => {
    const {
      componentCls: w,
      paddingLG: C
    } = b, x = `${w}-textarea`;
    return {
      [x]: {
        position: "relative",
        "&-show-count": {
          // https://github.com/ant-design/ant-design/issues/33049
          [`> ${w}`]: {
            height: "100%"
          },
          [`${w}-data-count`]: {
            position: "absolute",
            bottom: b.calc(b.fontSize).mul(b.lineHeight).mul(-1).equal(),
            insetInlineEnd: 0,
            color: b.colorTextDescription,
            whiteSpace: "nowrap",
            pointerEvents: "none"
          }
        },
        [`
        &-allow-clear > ${w},
        &-affix-wrapper${x}-has-feedback ${w}
      `]: {
          paddingInlineEnd: C
        },
        [`&-affix-wrapper${w}-affix-wrapper`]: {
          padding: 0,
          [`> textarea${w}`]: {
            fontSize: "inherit",
            border: "none",
            outline: "none",
            background: "transparent",
            "&:focus": {
              boxShadow: "none !important"
            }
          },
          [`${w}-suffix`]: {
            margin: 0,
            "> *:not(:last-child)": {
              marginInline: 0
            },
            // Clear Icon
            [`${w}-clear-icon`]: {
              position: "absolute",
              insetInlineEnd: b.paddingInline,
              insetBlockStart: b.paddingXS
            },
            // Feedback Icon
            [`${x}-suffix`]: {
              position: "absolute",
              top: 0,
              insetInlineEnd: b.paddingInline,
              bottom: 0,
              zIndex: 1,
              display: "inline-flex",
              alignItems: "center",
              margin: "auto",
              pointerEvents: "none"
            }
          }
        },
        [`&-affix-wrapper${w}-affix-wrapper-sm`]: {
          [`${w}-suffix`]: {
            [`${w}-clear-icon`]: {
              insetInlineEnd: b.paddingInlineSM
            }
          }
        }
      }
    };
  }, _ = (b) => {
    const {
      componentCls: w
    } = b;
    return {
      [`${w}-out-of-range`]: {
        [`&, & input, & textarea, ${w}-show-count-suffix, ${w}-data-count`]: {
          color: b.colorError
        }
      }
    };
  };
  e.default = (0, i.genStyleHooks)("Input", (b) => {
    const w = (0, i.mergeToken)(b, (0, o.initInputToken)(b));
    return [
      h(w),
      y(w),
      g(w),
      m(w),
      v(w),
      _(w),
      // =====================================================
      // ==             Space Compact                       ==
      // =====================================================
      (0, r.genCompactItemStyle)(w)
    ];
  }, o.initComponentToken, {
    resetFont: !1
  });
})(j4);
var V4 = {};
Object.defineProperty(V4, "__esModule", {
  value: !0
});
V4.hasPrefixSuffix = Xbt;
function Xbt(e) {
  return !!(e.prefix || e.suffix || e.allowClear || e.showCount);
}
(function(e) {
  "use client";
  var t = dn.default, n = pi.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0, Object.defineProperty(e, "triggerFocus", {
    enumerable: !0,
    get: function() {
      return a.triggerFocus;
    }
  });
  var r = n(j), i = t(qp), o = t(obt), a = mm, s = Qo, c = t(J2), l = t(sb), u = dm, d = fo, f = fb, h = t(Sl), p = t(Sb), g = t(gm), m = _i, v = t(wb), y = ys, _ = t(D4), b = t(j4), w = V4, C = function(T, E) {
    var R = {};
    for (var I in T)
      Object.prototype.hasOwnProperty.call(T, I) && E.indexOf(I) < 0 && (R[I] = T[I]);
    if (T != null && typeof Object.getOwnPropertySymbols == "function")
      for (var O = 0, I = Object.getOwnPropertySymbols(T); O < I.length; O++)
        E.indexOf(I[O]) < 0 && Object.prototype.propertyIsEnumerable.call(T, I[O]) && (R[I[O]] = T[I[O]]);
    return R;
  };
  const x = /* @__PURE__ */ (0, r.forwardRef)((T, E) => {
    var R;
    const {
      prefixCls: I,
      bordered: O = !0,
      status: P,
      size: k,
      disabled: L,
      onBlur: N,
      onFocus: D,
      suffix: z,
      allowClear: V,
      addonAfter: B,
      addonBefore: U,
      className: Q,
      style: Y,
      styles: q,
      rootClassName: X,
      onChange: ne,
      classNames: Z,
      variant: J
    } = T, K = C(T, ["prefixCls", "bordered", "status", "size", "disabled", "onBlur", "onFocus", "suffix", "allowClear", "addonAfter", "addonBefore", "className", "style", "styles", "rootClassName", "onChange", "classNames", "variant"]);
    if (process.env.NODE_ENV !== "production") {
      const {
        deprecated: St
      } = (0, d.devUseWarning)("Input");
      St(!("bordered" in T), "bordered", "variant");
    }
    const {
      getPrefixCls: ee,
      direction: te,
      input: H
    } = r.default.useContext(f.ConfigContext), ie = ee("input", I), W = (0, r.useRef)(null), se = (0, p.default)(ie), [le, ge, me] = (0, b.default)(ie, se), {
      compactSize: pe,
      compactItemClassnames: Te
    } = (0, y.useCompactItemContext)(ie, te), de = (0, g.default)((St) => {
      var ft;
      return (ft = k ?? pe) !== null && ft !== void 0 ? ft : St;
    }), Ae = r.default.useContext(h.default), ue = L ?? Ae, {
      status: be,
      hasFeedback: Ie,
      feedbackIcon: Ve
    } = (0, r.useContext)(m.FormItemInputContext), ze = (0, u.getMergedStatus)(be, P), Ne = (0, w.hasPrefixSuffix)(T) || !!Ie, lt = (0, r.useRef)(Ne);
    if (process.env.NODE_ENV !== "production") {
      const St = (0, d.devUseWarning)("Input");
      (0, r.useEffect)(() => {
        var ft;
        Ne && !lt.current && process.env.NODE_ENV !== "production" && St(document.activeElement === ((ft = W.current) === null || ft === void 0 ? void 0 : ft.input), "usage", "When Input is focused, dynamic add or remove prefix / suffix will make it lose focus caused by dom structure change. Read more: https://ant.design/components/input/#FAQ"), lt.current = Ne;
      }, [Ne]);
    }
    const mt = (0, _.default)(W, !0), vt = (St) => {
      mt(), N == null || N(St);
    }, ke = (St) => {
      mt(), D == null || D(St);
    }, xe = (St) => {
      mt(), ne == null || ne(St);
    }, Re = (Ie || z) && /* @__PURE__ */ r.default.createElement(r.default.Fragment, null, z, Ie && Ve), yt = (0, l.default)(V ?? (H == null ? void 0 : H.allowClear)), [Pt, _t] = (0, v.default)("input", J, O);
    return le(/* @__PURE__ */ r.default.createElement(o.default, Object.assign({
      ref: (0, s.composeRef)(E, W),
      prefixCls: ie,
      autoComplete: H == null ? void 0 : H.autoComplete
    }, K, {
      disabled: ue,
      onBlur: vt,
      onFocus: ke,
      style: Object.assign(Object.assign({}, H == null ? void 0 : H.style), Y),
      styles: Object.assign(Object.assign({}, H == null ? void 0 : H.styles), q),
      suffix: Re,
      allowClear: yt,
      className: (0, i.default)(Q, X, me, se, Te, H == null ? void 0 : H.className),
      onChange: xe,
      addonBefore: U && /* @__PURE__ */ r.default.createElement(c.default, {
        form: !0,
        space: !0
      }, U),
      addonAfter: B && /* @__PURE__ */ r.default.createElement(c.default, {
        form: !0,
        space: !0
      }, B),
      classNames: Object.assign(Object.assign(Object.assign({}, Z), H == null ? void 0 : H.classNames), {
        input: (0, i.default)({
          [`${ie}-sm`]: de === "small",
          [`${ie}-lg`]: de === "large",
          [`${ie}-rtl`]: te === "rtl"
        }, Z == null ? void 0 : Z.input, (R = H == null ? void 0 : H.classNames) === null || R === void 0 ? void 0 : R.input, ge),
        variant: (0, i.default)({
          [`${ie}-${Pt}`]: _t
        }, (0, u.getStatusClassNames)(ie, ze)),
        affixWrapper: (0, i.default)({
          [`${ie}-affix-wrapper-sm`]: de === "small",
          [`${ie}-affix-wrapper-lg`]: de === "large",
          [`${ie}-affix-wrapper-rtl`]: te === "rtl"
        }, ge),
        wrapper: (0, i.default)({
          [`${ie}-group-rtl`]: te === "rtl"
        }, ge),
        groupWrapper: (0, i.default)({
          [`${ie}-group-wrapper-sm`]: de === "small",
          [`${ie}-group-wrapper-lg`]: de === "large",
          [`${ie}-group-wrapper-rtl`]: te === "rtl",
          [`${ie}-group-wrapper-${Pt}`]: _t
        }, (0, u.getStatusClassNames)(`${ie}-group-wrapper`, ze, Ie), ge)
      })
    })));
  });
  process.env.NODE_ENV !== "production" && (x.displayName = "Input"), e.default = x;
})(vce);
var fd = dn.default, Qbt = pi.default;
Object.defineProperty(s4, "__esModule", {
  value: !0
});
var Ece = s4.default = void 0, Cce = Qbt(j), _d = Cce, V1 = fd(qp), Jbt = fd(nmt), Zbt = fd(sb), eH = dm, e1t = fo, t1t = fb, n1t = fd(Sl), r1t = fd(Sb), i1t = fd(gm), o1t = _i, a1t = fd(wb), s1t = vce, c1t = fd(j4), l1t = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
const u1t = /* @__PURE__ */ (0, Cce.forwardRef)((e, t) => {
  var n, r;
  const {
    prefixCls: i,
    bordered: o = !0,
    size: a,
    disabled: s,
    status: c,
    allowClear: l,
    classNames: u,
    rootClassName: d,
    className: f,
    style: h,
    styles: p,
    variant: g
  } = e, m = l1t(e, ["prefixCls", "bordered", "size", "disabled", "status", "allowClear", "classNames", "rootClassName", "className", "style", "styles", "variant"]);
  if (process.env.NODE_ENV !== "production") {
    const {
      deprecated: B
    } = (0, e1t.devUseWarning)("TextArea");
    B(!("bordered" in e), "bordered", "variant");
  }
  const {
    getPrefixCls: v,
    direction: y,
    textArea: _
  } = _d.useContext(t1t.ConfigContext), b = (0, i1t.default)(a), w = _d.useContext(n1t.default), C = s ?? w, {
    status: x,
    hasFeedback: T,
    feedbackIcon: E
  } = _d.useContext(o1t.FormItemInputContext), R = (0, eH.getMergedStatus)(x, c), I = _d.useRef(null);
  _d.useImperativeHandle(t, () => {
    var B;
    return {
      resizableTextArea: (B = I.current) === null || B === void 0 ? void 0 : B.resizableTextArea,
      focus: (U) => {
        var Q, Y;
        (0, s1t.triggerFocus)((Y = (Q = I.current) === null || Q === void 0 ? void 0 : Q.resizableTextArea) === null || Y === void 0 ? void 0 : Y.textArea, U);
      },
      blur: () => {
        var U;
        return (U = I.current) === null || U === void 0 ? void 0 : U.blur();
      }
    };
  });
  const O = v("input", i), P = (0, r1t.default)(O), [k, L, N] = (0, c1t.default)(O, P), [D, z] = (0, a1t.default)("textArea", g, o), V = (0, Zbt.default)(l ?? (_ == null ? void 0 : _.allowClear));
  return k(/* @__PURE__ */ _d.createElement(Jbt.default, Object.assign({
    autoComplete: _ == null ? void 0 : _.autoComplete
  }, m, {
    style: Object.assign(Object.assign({}, _ == null ? void 0 : _.style), h),
    styles: Object.assign(Object.assign({}, _ == null ? void 0 : _.styles), p),
    disabled: C,
    allowClear: V,
    className: (0, V1.default)(N, P, f, d, _ == null ? void 0 : _.className),
    classNames: Object.assign(Object.assign(Object.assign({}, u), _ == null ? void 0 : _.classNames), {
      textarea: (0, V1.default)({
        [`${O}-sm`]: b === "small",
        [`${O}-lg`]: b === "large"
      }, L, u == null ? void 0 : u.textarea, (n = _ == null ? void 0 : _.classNames) === null || n === void 0 ? void 0 : n.textarea),
      variant: (0, V1.default)({
        [`${O}-${D}`]: z
      }, (0, eH.getStatusClassNames)(O, R)),
      affixWrapper: (0, V1.default)(`${O}-textarea-affix-wrapper`, {
        [`${O}-affix-wrapper-rtl`]: y === "rtl",
        [`${O}-affix-wrapper-sm`]: b === "small",
        [`${O}-affix-wrapper-lg`]: b === "large",
        [`${O}-textarea-show-count`]: e.showCount || ((r = e.count) === null || r === void 0 ? void 0 : r.show)
      }, L)
    }),
    prefixCls: O,
    suffix: T && /* @__PURE__ */ _d.createElement("span", {
      className: `${O}-textarea-suffix`
    }, E),
    ref: I
  })));
});
Ece = s4.default = u1t;
function B4() {
  const { primaryColour: e, primary25: t } = Gn(), n = o3(), r = Mi(), i = d5(
    getComputedStyle(document.documentElement).getPropertyValue("--button-height").trim()
  ), o = getComputedStyle(document.documentElement).getPropertyValue("--error").trim(), a = getComputedStyle(document.documentElement).getPropertyValue("--dark").trim(), s = d5(
    getComputedStyle(document.documentElement).getPropertyValue("--choice-text-font-size").trim()
  );
  return {
    token: {
      colorPrimary: e,
      borderRadius: d5(r),
      colorError: o,
      fontFamily: n,
      fontSize: s
    },
    components: {
      Select: {
        optionSelectedBg: t,
        controlHeight: i
      },
      Slider: {
        handleSize: 28,
        handleSizeHover: 28,
        railSize: 12,
        dotSize: 18,
        dotBorderColor: a,
        handleLineWidth: 1,
        handleColor: e,
        railHoverBg: "#A2A2A2",
        railBg: "#C2C2C2"
      }
    }
  };
}
const z4 = ({
  value: e,
  onChange: t,
  label: n,
  allowClear: r,
  placeholder: i,
  autoSize: o,
  dynamicColour: a,
  maxLength: s,
  onMaxLengthExceeded: c
}) => {
  const l = Mi(), u = B4(), d = o3(), f = $e(!1), h = Wt(
    (p) => {
      s && p.target.value.length > s ? (p.target.value = p.target.value.slice(0, s), !f.current && c && (c(s), f.current = !0)) : f.current && s && p.target.value.length < s && (f.current = !1), t(p);
    },
    [s, c, t]
  );
  return /* @__PURE__ */ A.jsx(go, { theme: u, children: /* @__PURE__ */ A.jsx(
    d1t,
    {
      value: e,
      allowClear: r,
      placeholder: i,
      autoSize: o,
      onChange: h,
      colour: a,
      fontFamily: d,
      style: { borderRadius: l }
    }
  ) });
}, d1t = ce(Ece)`
  width: 100%;
  font-size: var(--choice-text-font-size);
  padding: var(--spacing-sm);
  background-color: var(--light);
  border: 1px solid var(--mid);
  font-family: ${(e) => e.fontFamily};

  * {
    font-family: ${(e) => e.fontFamily};
  }

  @media (hover: hover) {
    &:hover {
      border: 1px solid ${(e) => e.colour};
      box-shadow: 0 0 5px 0px rgba(0, 0, 0, 0.3);
    }
  }
  &:focus {
    border: 2px solid ${(e) => e.colour};
    animation: none;
  }
`, f1t = ({
  currentAnswer: e,
  settings: t,
  injectCurrent: n,
  question: r
}) => {
  const i = e.getValue(r.type), { primaryColour: o } = Gn(), { messagerService: a } = gt(mn);
  return /* @__PURE__ */ A.jsx(
    z4,
    {
      value: (i == null ? void 0 : i.value) || "",
      onChange: (s) => {
        n({ value: { id: r.id, value: s.target.value } });
      },
      placeholder: r.placeholder,
      maxLength: r.maxLength,
      onMaxLengthExceeded: (s) => {
        a.warning(`You've reached the character limit of ${s} characters.`);
      },
      dynamicColour: o
    }
  );
};
const h1t = ({
  currentAnswer: e,
  updateCurrent: t,
  injectCurrent: n,
  submitAnswer: r,
  answers: i,
  question: o
}) => {
  var Y, q, X, ne;
  const { loggingService: a, popupService: s } = gt(mn), c = 600;
  let l = o.max;
  const u = 1;
  let d = o.convertStep, f = o.convertValue, h = {
    0: "$0",
    [d(l * 0.02, c, l)]: "$" + l * 0.02,
    [d(l * 0.05, c, l)]: "$" + l * 0.05,
    [d(l * 0.1, c, l)]: "$" + l * 0.1,
    [d(l * 0.2, c, l)]: "$" + l * 0.2,
    [d(l * 0.5, c, l)]: "$" + l * 0.5,
    [c]: "$" + l
  };
  const p = o.attributes[0].levels, g = o.attributes[1].levels, m = o.ranking({ answers: i }), v = o.pairSet(m.length);
  if (v.length === 0)
    throw new Error("invalid pair set");
  const y = v.map((Z) => Z.pair), [_, b] = Qe(0);
  Xi(
    o,
    (Z) => Rs(
      Object.fromEntries(
        (Z.getValue("compareSlider") ?? []).map((J) => [String(J.id), J])
      ),
      [...new Set(y.flat())].map((J) => ({
        id: zP(m[J]),
        input: { type: "number" }
      }))
    )
  );
  const [w, C] = Qe(
    o.default ? d(o.default, c, l) : 0
  ), [x, T] = Qe(
    Math.random() > 0.5 ? o.characters.filter((Z) => Z.gender === "female") : o.characters.filter((Z) => Z.gender === "male")
  ), E = (Z, J) => {
    if (!Z)
      return /* @__PURE__ */ A.jsx(oH, { children: /* @__PURE__ */ A.jsxs(iH, { children: [
        /* @__PURE__ */ A.jsx(tH, {}),
        /* @__PURE__ */ A.jsxs(nH, { children: [
          /* @__PURE__ */ A.jsx(Oh, { children: "None" }),
          /* @__PURE__ */ A.jsx(Oh, { children: "None" }),
          /* @__PURE__ */ A.jsx(Oh, { children: "None" })
        ] })
      ] }) });
    const K = p.find((te) => te.value === Z.attr_1), ee = K ? K.text : "";
    return (
      // <AnimatedDiv key={person.id + text}>
      /* @__PURE__ */ A.jsx(oH, { children: /* @__PURE__ */ A.jsxs(iH, { children: [
        /* @__PURE__ */ A.jsx(
          tH,
          {
            src: x[Z.id % x.length] ? x[Z.id % x.length].portrait : x[0].portrait
          }
        ),
        /* @__PURE__ */ A.jsxs(nH, { children: [
          /* @__PURE__ */ A.jsx(Oh, { children: x[Z.id % x.length] ? x[Z.id % x.length].name : "loading..." }),
          /* @__PURE__ */ A.jsx(Oh, { children: ee }),
          /* @__PURE__ */ A.jsx(Oh, { children: Z.attr_2 ? g[1].text : g[0].text })
        ] })
      ] }) })
    );
  };
  let R, I;
  if (_ < y.length) {
    const Z = m[y[_][0]], J = m[y[_][1]];
    x[Z.id % x.length] && (R = x[Z.id % x.length].name), x[J.id % x.length] && (I = x[J.id % x.length].name);
  }
  const O = {
    default: {
      content: `Click and drag the amount you would pay extra per hour for ${I} over ${R}, and click the next button`
    }
  }, P = Ms(O, o.helpPopups), k = o.showHelpPopups ?? !1, L = o.helpPopupsToShow;
  if (ot(() => {
    if (R === void 0 || I === void 0) {
      s.clearPopup();
      return;
    }
    s.setPopup(P, "default", k, L);
  }, [P, k, L, R, I]), _ >= y.length)
    return /* @__PURE__ */ A.jsx("div", { children: /* @__PURE__ */ A.jsxs(cH, { children: [
      E(null),
      /* @__PURE__ */ A.jsx(aH, { children: "Loading" }),
      E(null)
    ] }) });
  const N = [m[y[_][0]], m[y[_][1]]];
  if (v[_].intermediate) {
    f = (K, ee, te) => (K / ee * te).toFixed(2), d = (K, ee, te) => K === 0 ? 0 : Math.round(K / te * ee);
    const Z = (Y = e.getValue(o.type)) == null ? void 0 : Y.findLast(
      (K) => {
        var ee, te;
        return Number((ee = K.info) == null ? void 0 : ee.rank) < N[1].rank && er.isNumber((te = K.info) == null ? void 0 : te.absVal);
      }
    ), J = (q = e.getValue(o.type)) == null ? void 0 : q.find(
      (K) => {
        var ee, te;
        return Number((ee = K.info) == null ? void 0 : ee.rank) > N[1].rank && er.isNumber((te = K.info) == null ? void 0 : te.absVal);
      }
    );
    l = Number((X = J == null ? void 0 : J.info) == null ? void 0 : X.absVal) - Number((ne = Z == null ? void 0 : Z.info) == null ? void 0 : ne.absVal), h = {
      0: "$0",
      // [maxStep * 0.5]: '$' + maxAbs * 0.5,
      [c]: "$" + l.toFixed(2)
    };
  }
  const D = () => {
    T(
      Math.random() > 0.5 ? o.characters.filter((te) => te.gender === "female") : o.characters.filter((te) => te.gender === "male")
    );
    let Z = e.getValue(o.type);
    Z === null && (Z = [Ym(N[0], 0)]);
    const J = Z.find((te) => te.id === zP(N[0])), K = Z.concat(
      Ym(
        N[1],
        parseFloat(f(w, c, l)) + Number(J == null ? void 0 : J.value)
      )
    );
    n({
      // value: _.sortBy(answerVal, 'rank'),
      value: er.sortBy(K, (te) => {
        var H;
        return (H = te.info) == null ? void 0 : H.rank;
      })
    });
    let ee = typeof o.default == "number" ? d(o.default, c, l) : c / 2;
    ee > c && (ee = c), a.debug("newInputVal", ee), C(ee), _ === y.length - 1 ? (r(), b(_ + y.length)) : b(_ + 1);
  }, z = (Z) => {
    var J;
    return ((J = e.getValue(o.type)) == null ? void 0 : J.filter((K) => {
      var ee;
      return ((ee = K.info) == null ? void 0 : ee.rank) === Z.rank;
    }).length) === 0;
  }, V = () => {
    var H;
    const Z = er.sortBy(
      m.filter((ie) => z(ie)),
      "rank"
    ), J = er.sortBy(e.getValue(o.type), (ie) => {
      var W;
      return (W = ie.info) == null ? void 0 : W.rank;
    }), K = Z.map((ie) => {
      var le, ge, me;
      const W = J.findLast((pe) => {
        var Te;
        return Number((Te = pe.info) == null ? void 0 : Te.rank) < ie.rank;
      }), se = J.find((pe) => {
        var Te;
        return Number((Te = pe.info) == null ? void 0 : Te.rank) > ie.rank;
      });
      return er.isUndefined(W) ? Ym(ie, Number(se == null ? void 0 : se.value) / 2) : er.isUndefined(se) ? Ym(ie, Number(W.value)) : Ym(
        ie,
        Number(W.value) + (Number(se.value) - Number(W.value)) / (Number((le = se.info) == null ? void 0 : le.rank) - Number((ge = W.info) == null ? void 0 : ge.rank)) * (ie.rank - Number((me = W.info) == null ? void 0 : me.rank))
      );
    }), ee = er.uniqBy(
      (H = e.getValue(o.type)) == null ? void 0 : H.concat(K),
      "id"
    ), te = er.sortBy(ee, (ie) => {
      var W;
      return (W = ie.info) == null ? void 0 : W.rank;
    });
    n({
      value: te
    });
  }, B = () => {
    V(), r(), b(_ + y.length);
  }, U = o.intermediateSkippable && v[_].intermediate ? "visible" : "hidden", Q = (Z) => {
    C(Z);
  };
  return /* @__PURE__ */ A.jsxs(g1t, { children: [
    /* @__PURE__ */ A.jsxs(m1t, { children: [
      /* @__PURE__ */ A.jsx("div", { children: "Your rank:" }),
      m.map((Z) => {
        let J = "white";
        return (Z.rank === N[0].rank || Z.rank === N[1].rank) && (J = "#4cb8d2"), /* @__PURE__ */ A.jsxs(v1t, { style: { backgroundColor: J }, children: [
          /* @__PURE__ */ A.jsxs("div", { style: { textAlign: "center" }, children: [
            Z.attr_1,
            "-year"
          ] }),
          /* @__PURE__ */ A.jsx("div", { children: Z.attr_2 ? /* @__PURE__ */ A.jsx(sH, { children: /* @__PURE__ */ A.jsx("img", { src: g[1].icon, alt: "Tick", height: "20" }) }) : /* @__PURE__ */ A.jsx(sH, { children: /* @__PURE__ */ A.jsx("img", { src: g[0].icon, alt: "Cross", height: "20" }) }) })
        ] }, Z.rank);
      })
    ] }),
    /* @__PURE__ */ A.jsxs(cH, { children: [
      E(N[0]),
      /* @__PURE__ */ A.jsxs(aH, { children: [
        /* @__PURE__ */ A.jsx("div", { style: { marginBottom: "0", fontSize: "1rem", width: "100%" }, children: "I would pay an extra" }),
        /* @__PURE__ */ A.jsx("div", { children: Object.keys(h).filter((Z) => parseInt(Z) === w).length !== 0 ? h[w] : "$" + f(w, c, l) }),
        /* @__PURE__ */ A.jsxs("div", { style: { marginBottom: "0", fontSize: "1rem", width: "100%" }, children: [
          "per hour for ",
          x[N[1].id % x.length].name,
          " over",
          " ",
          x[N[0].id % x.length].name,
          "."
        ] })
      ] }),
      E(N[1])
    ] }),
    /* @__PURE__ */ A.jsx(rH, { children: /* @__PURE__ */ A.jsx(
      CR,
      {
        marks: h,
        min: 0,
        max: c,
        onChange: Q,
        value: w,
        step: u,
        tooltip: { open: !1 }
      }
    ) }),
    /* @__PURE__ */ A.jsx(p1t, {}),
    /* @__PURE__ */ A.jsxs(rH, { children: [
      /* @__PURE__ */ A.jsx(lH, { color: "#4cb8d2", onClick: D, children: "Next" }),
      /* @__PURE__ */ A.jsx(
        lH,
        {
          color: "#4cb8d2",
          style: {
            marginLeft: "2.5rem ",
            visibility: U
          },
          onClick: B,
          children: "Skip"
        }
      )
    ] })
  ] });
};
function Ym(e, t) {
  return {
    id: zP(e),
    value: t.toFixed(2),
    info: {
      absVal: t,
      rank: e.rank,
      attr_1: e.attr_1,
      attr_2: e.attr_2,
      attr_1_index: e.attr_1_index
    }
  };
}
function zP(e) {
  return `${e.attr_1}-${e.attr_2}`;
}
const g1t = ce.div`
  display: flex;
  flex-direction: column;
`, tH = ce.img`
  max-height: 10rem;
`, nH = ce.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: baseline;
  text-align: left;
`, Oh = ce.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding-bottom: 0.5rem;
`, p1t = ce.div`
  display: flex;
  height: 3rem;
`, rH = ce.div`
  // margin: auto;
  display: flex;
  // width: 49rem;

  align-items: baseline;
  justify-content: center;
  // margin-bottom: 3rem;
  .ant-slider {
    width: 90%;
    margin: auto;
  }
  .button {
    display: inline-block;
    padding: 1rem 1.5rem;
    font-size: 1rem;
    cursor: pointer;
    text-align: center;
    text-decoration: none;
    outline: none;
    color: #fff;
    background-color: #8fd9e8;
    border: none;
    border-radius: 1rem;
    box-shadow: 0 5px #999;
  }
  @media (hover: hover) {
    .button:hover {
      background-color: #4cb8d2;
    }
  }
  .button:active {
    background-color: #4cb8d2;
    box-shadow: 0 5px #666;
    transform: translateY(4px);
  }

  @media (min-width: 0px) and (max-width: 479px) {
    /* small viewport  */
    width: 80vw;
    margin-top: 1rem;
    h1 {
      margin-left: 1rem;
    }
  }
  @media (min-width: 480px) and (max-width: 768px) {
    /* medium viewport  */
    width: 80vw;
    h1 {
      margin-left: 1rem;
    }
  }
  @media (min-width: 769px) and (max-width: 1025px) {
    width: 80vw;
  }
`, iH = ce.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1rem;
  font-size: 1rem;
  // width: 300px;
  color: #000;
  background-color: transparent;
  border: 1px solid rgba(0, 0, 0, 0.3);
  border-radius: 0.2rem;
  text-align: center;
`, oH = ce.div`
  display: flex;
  flex-direction: row;
`, aH = ce.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
  width: 10rem;
  margin: 0.5rem;
  font-size: 3rem;
`, m1t = ce.div`
  display: flex;
  justify-content: space-between;
  margin: 0 0 1rem 0;
  align-items: stretch;
  font-size: 0.8rem;
  p {
    margin-right: 1rem;
  }
`, v1t = ce.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 1;
  justify-content: space-between;
  border: 1px solid rgba(0, 0, 0, 0.3);
  border-radius: 0.2rem;
  // margin: 0.2rem;
  // box-shadow: 5px 5px 5px lightblue;
  padding: 0.2rem;
`, sH = ce.div`
  display: flex;
  width: 50px;
  align-items: center;
  justify-content: center;
`, cH = ce.div`
  display: flex;
  flex-direction: row;
  // flex-wrap: wrap;
  justify-content: space-between;
  align-items: stretch;
  grid-gap: auto;
  margin-bottom: 2rem;

  @media (min-width: 0px) and (max-width: 900px) {
    /* small viewport  */
    flex-direction: column;
    width: 80vw;
    grid-gap: 3rem;
  }
`, lH = ce.button`
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  text-transform: uppercase;
  letter-spacing: 0.1rem;
  height: 2rem;
  width: 160px;
  font-weight: 501;

  background-color: ${(e) => e.color ? e.color : "#E82D7C"};
  /* background-color: #7398ff; */
  /* background-color: #ffffff; */
  cursor: pointer;
  transition:
    background 250ms ease-in-out,
    transform 150ms ease;
  color: white;
  border-radius: 3px;
  i {
    margin-left: 1rem;
  }
  user-select: none;
  @media (min-width: 0px) and (max-width: 479px) {
    /* width: 90vw;
    height: 3.125rem;
    margin-bottom: 1rem; */
    width: 45%;
    height: 3.125rem;
  }
  /* color: #5d5d5de8; */
`, y1t = ce(lm)`
  max-width: 45rem;
`;
let B1;
const b1t = new Uint8Array(16);
function _1t() {
  if (!B1 && (B1 = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !B1))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return B1(b1t);
}
const Fi = [];
for (let e = 0; e < 256; ++e)
  Fi.push((e + 256).toString(16).slice(1));
function S1t(e, t = 0) {
  return Fi[e[t + 0]] + Fi[e[t + 1]] + Fi[e[t + 2]] + Fi[e[t + 3]] + "-" + Fi[e[t + 4]] + Fi[e[t + 5]] + "-" + Fi[e[t + 6]] + Fi[e[t + 7]] + "-" + Fi[e[t + 8]] + Fi[e[t + 9]] + "-" + Fi[e[t + 10]] + Fi[e[t + 11]] + Fi[e[t + 12]] + Fi[e[t + 13]] + Fi[e[t + 14]] + Fi[e[t + 15]];
}
const w1t = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), uH = {
  randomUUID: w1t
};
function x1t(e, t, n) {
  if (uH.randomUUID && !t && !e)
    return uH.randomUUID();
  e = e || {};
  const r = e.random || (e.rng || _1t)();
  if (r[6] = r[6] & 15 | 64, r[8] = r[8] & 63 | 128, t) {
    n = n || 0;
    for (let i = 0; i < 16; ++i)
      t[n + i] = r[i];
    return t;
  }
  return S1t(r);
}
const E1t = "https://conjoint-backend-4.confer.online/get_question", Tce = x1t(), C1t = (e) => {
  const { loggingService: t } = gt(mn), n = Qn(
    e.question.attributes,
    { answers: e.answers }
  ), r = Qn(
    e.question.maxChoices,
    { answers: e.answers }
  );
  if (n === void 0 || r === void 0)
    return /* @__PURE__ */ A.jsx("div", { children: "Loading conjoint questions" });
  if (n.length === 0)
    return /* @__PURE__ */ A.jsx(T1t, { question: e.question });
  M1t(n);
  const i = e.currentAnswer.getValue(e.question.type);
  function o(l) {
    if (t.info("injectPartworths", l), t.info("injectCurrent attributes", n), n === void 0)
      return;
    const u = l.flatMap((f) => f.partworth_value.map((h) => {
      const p = n.find((m) => m.id === f.attribute_id), g = p == null ? void 0 : p.levels.find((m) => m.rank === h.level_id);
      return {
        id: `${p == null ? void 0 : p.name}-${g == null ? void 0 : g.value}`,
        value: h.partworth.toString(),
        info: {
          error: h.error ?? null
        }
      };
    })), d = {
      ...i,
      partworths: u
    };
    e.injectCurrent({
      value: d
    });
  }
  async function a(l) {
    if (n === void 0 || r === void 0)
      return null;
    let u, d = [];
    e.question.presetChoices ? d = e.question.presetChoices.concat(l) : d = l, d.length === 0 ? u = $1t(n) : u = I1t(n, d), e.question.expectedCorrectProbability !== void 0 && (u.settings = {
      alpha: e.question.expectedCorrectProbability
    }), t.info("ChoiceExperimentQuestion: body", u);
    const h = await (await fetch(E1t, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(u)
    })).json();
    return t.debug("ChoiceExperimentQuestion: json", h), h.partworths && o(h.partworths), er.isNull(h.new_profile_set) || l.length >= r ? null : h.new_profile_set.map((p) => R1t(p, n));
  }
  const s = {
    ...e.question,
    type: "choiceExperiment",
    attributes: n,
    maxChoices: r,
    choiceGenerator: a,
    profileInfo: e.question.profileInfo
  }, c = {
    ...e,
    question: s,
    currentAnswer: e.currentAnswer.convertedToQuestionType("choiceExperiment")
  };
  return /* @__PURE__ */ A.jsx(rse, { ...c });
};
function T1t({ question: e }) {
  return Xi(e, () => ec(!0)), /* @__PURE__ */ A.jsx("div", { children: "No conjoint questions" });
}
function I1t(e, t) {
  return {
    id: Tce,
    attributes: e.map(Ice),
    choicePair: O1t(t[t.length - 1]),
    answer: t[t.length - 1].selectedOptionIndex,
    previous_questions: t.map(A1t)
  };
}
function $1t(e) {
  return {
    id: Tce,
    attributes: e.map(Ice),
    choicePair: null,
    answer: null,
    previous_questions: []
  };
}
function A1t(e) {
  return {
    options: e.options.map((t, n) => ({
      id: n,
      attributes_and_levels: t.attributes.map((r) => ({
        attribute_id: r.attributeId,
        level_id: r.levelRank
      }))
    })),
    choice_id: e.selectedOptionIndex
  };
}
function R1t(e, t) {
  return {
    // id: profile.id,
    attributes: e.attributes_and_levels.map((n) => {
      var r, i, o;
      return {
        attributeId: n.attribute_id,
        attributeName: ((r = t.find((a) => a.id === n.attribute_id)) == null ? void 0 : r.name) ?? n.attribute_id.toString(),
        levelId: n.level_id,
        levelName: (((o = (i = t.find((a) => a.id === n.attribute_id)) == null ? void 0 : i.levels.find((a) => a.rank === n.level_id)) == null ? void 0 : o.value) ?? n.level_id).toString(),
        levelRank: n.level_id
      };
    })
  };
}
function Ice(e) {
  return {
    id: e.id,
    value: e.name,
    levels: e.levels.map(P1t),
    attribute_represents_a_cost: !!e.isCost
  };
}
function P1t(e) {
  return {
    id: e.rank,
    value: e.value.toString()
  };
}
function O1t(e) {
  return e.options.length === 0 ? null : e.options.map((t, n) => ({
    id: n,
    attributes_and_levels: t.attributes.map((r) => ({
      attribute_id: r.attributeId,
      level_id: r.levelRank
    }))
  }));
}
function M1t(e) {
  k1t(e);
  for (const t of e)
    N1t(t.levels);
}
function k1t(e) {
  r$(
    e.map((t) => t.id),
    "Conjoint attribute ids must be unique"
  );
}
function N1t(e) {
  r$(
    e.map((t) => t.rank),
    "Conjoint level ranks must be unique"
  ), r$(
    e.map((t) => t.id),
    "Conjoint level ids must be unique"
  );
}
const r5 = ({
  options: e,
  value: t,
  onChange: n,
  searchable: r,
  multiple: i,
  placeholder: o,
  allowClear: a,
  onClear: s,
  ariaLabelledBy: c,
  ariaRequired: l
}) => {
  let u;
  const d = i ? "multiple" : void 0;
  r && (u = (h, p) => p === void 0 ? !1 : Tle(h, p.value));
  const f = B4();
  return /* @__PURE__ */ A.jsx(go, { theme: f, children: /* @__PURE__ */ A.jsx(D1t, { children: /* @__PURE__ */ A.jsx(
    ALe,
    {
      options: e,
      value: t,
      onChange: (h) => {
        h === void 0 ? s == null || s() : n(h);
      },
      showSearch: r,
      filterOption: u,
      mode: d,
      placeholder: o,
      allowClear: a,
      "aria-labelledby": c,
      "aria-required": l
    }
  ) }) });
}, D1t = ce.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  /* max-width: 90vw; */
`, j1t = ({
  question: e,
  currentAnswer: t,
  injectCurrent: n,
  submitAnswer: r,
  answers: i,
  settings: o
}) => {
  var y;
  const { loggingService: a, popupService: s } = gt(mn), { choices: c, ready: l } = yl(e.choices, i);
  Xi(e, (_) => ({
    ...jy(e, _),
    ready: l
  }));
  const u = Wt(() => {
    if (!e.defaultValues)
      return;
    const _ = e.defaultValues({ answers: i, choices: c }), b = c.find((w) => w.id === _);
    if (b)
      return {
        id: b.id,
        value: b.value
      };
  }, [e, i, c]);
  Qf(u, e, t, i, n);
  const d = (_) => {
    if (er.isArray(_))
      throw new Error("Dropdown question received an array as a current answer value");
    {
      const b = c.find((w) => w.value === _);
      if (b) {
        const w = {
          id: b.id,
          value: b.value
        };
        n({
          value: w
        });
      }
    }
  };
  a.debug("DropdownQuestion: currentAnswer", t);
  const f = (y = t.getValue(e.type)) == null ? void 0 : y.value, { searchable: h } = e;
  a.debug(
    "options as string",
    c.map((_) => String(qn(_.text) || _.value))
  );
  const g = Ms({
    noneSelected: { content: "Please select an option" },
    selected: { content: "Click next to continue" },
    notRequired: { content: "Please select an option or click next to continue" }
  }, e.helpPopups), m = e.showHelpPopups ?? !1, v = e.helpPopupsToShow;
  return ot(() => {
    e.required ? f === void 0 ? s.setPopup(g, "noneSelected", m, v) : s.setPopup(g, "selected", m, v) : s.setPopup(g, "notRequired", m, v);
  }, [g, m, v, e.required, f]), /* @__PURE__ */ A.jsx(
    r5,
    {
      options: c.map((_) => ({
        id: _.id,
        value: _.value,
        label: _.text ? qn(_.text) : _.value
      })),
      value: f,
      onChange: d,
      searchable: h
    }
  );
};
class H4 extends Error {
  constructor(t, n) {
    super(`Question of type ${t} received incorrect input of type ${n}`);
  }
}
const L1t = "Thanks for completing the survey!", F1t = Array.from({ length: 8 }, (e, t) => t), dH = ({ children: e, centered: t = !1 }) => {
  const { contrastColour: n, primaryColour: r, primary50: i, shadeColour: o } = Gn();
  return /* @__PURE__ */ A.jsxs(q1t, { role: "status", "aria-live": "polite", children: [
    /* @__PURE__ */ A.jsxs(G1t, { "aria-hidden": "true", children: [
      /* @__PURE__ */ A.jsx(K1t, { $colour: r }),
      F1t.map((a) => /* @__PURE__ */ A.jsx(
        Q1t,
        {
          $angle: a * 45,
          $colour: a % 2 === 0 ? r : i,
          $delay: a * 22
        },
        a
      )),
      /* @__PURE__ */ A.jsx(Y1t, { $colour: r, $shadow: o, children: /* @__PURE__ */ A.jsx("svg", { viewBox: "0 0 32 32", focusable: "false", children: /* @__PURE__ */ A.jsx(X1t, { $colour: n, d: "M8 16.5l5 5L24.5 10" }) }) })
    ] }),
    /* @__PURE__ */ A.jsx(J1t, { $centered: t, children: e })
  ] });
}, V1t = ({
  question: e,
  settings: t
}) => {
  const { analyticsService: n } = gt(mn);
  if (e.type !== "endPage")
    throw new H4("endPage", e.type);
  ot(() => {
    n.logCompletion(t.surveyName);
  }, [n, t.surveyName]);
  const r = _x(({ survey: o }) => o.isSubmitClicked);
  return e.contentAfterSubmit && r ? /* @__PURE__ */ A.jsx(dH, { children: qn(e.contentAfterSubmit) }) : r ? /* @__PURE__ */ A.jsx(dH, { centered: !0, children: qn(L1t) }) : null;
}, B1t = gi`
  0% {
    opacity: 0;
    filter: blur(2px);
    transform: translateY(12px);
  }
  100% {
    opacity: 1;
    filter: blur(0);
    transform: translateY(0);
  }
`, z1t = gi`
  0% {
    opacity: 0;
    transform: scale(0.55) rotate(-8deg);
  }
  65% {
    opacity: 1;
    transform: scale(1.08) rotate(2deg);
  }
  100% {
    opacity: 1;
    transform: scale(1) rotate(0);
  }
`, H1t = gi`
  0% {
    opacity: 0.5;
    transform: scale(0.7);
  }
  100% {
    opacity: 0;
    transform: scale(1.55);
  }
`, U1t = gi`
  to {
    stroke-dashoffset: 0;
  }
`, W1t = gi`
  0% {
    opacity: 0;
    transform: rotate(var(--spark-angle)) translateY(-18px) scale(0.2);
  }
  35% {
    opacity: 0.9;
  }
  100% {
    opacity: 0;
    transform: rotate(var(--spark-angle)) translateY(-42px) scale(1);
  }
`, q1t = ce.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  gap: 0.8rem;
`, G1t = ce.div`
  position: relative;
  display: grid;
  width: 4.25rem;
  height: 4.25rem;
  flex: 0 0 4.25rem;
  place-items: center;
`, K1t = ce.span`
  position: absolute;
  width: 3.25rem;
  height: 3.25rem;
  border: 2px solid ${(e) => e.$colour};
  border-radius: 50%;
  animation: ${H1t} 700ms 100ms cubic-bezier(0.22, 1, 0.36, 1) both;

  @media (prefers-reduced-motion: reduce) {
    display: none;
  }
`, Y1t = ce.span`
  z-index: 1;
  display: grid;
  width: 3.25rem;
  height: 3.25rem;
  border-radius: 50%;
  background: ${(e) => e.$colour};
  box-shadow:
    0 0.45rem 1.4rem ${(e) => e.$shadow},
    inset 0 1px 0 rgba(255, 255, 255, 0.25);
  animation: ${z1t} 520ms cubic-bezier(0.34, 1.56, 0.64, 1) both;
  place-items: center;

  svg {
    width: 2rem;
    height: 2rem;
    overflow: visible;
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`, X1t = ce.path`
  fill: none;
  stroke: ${(e) => e.$colour};
  stroke-width: 3;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-dasharray: 24;
  stroke-dashoffset: 24;
  animation: ${U1t} 420ms 260ms cubic-bezier(0.22, 1, 0.36, 1) forwards;

  @media (prefers-reduced-motion: reduce) {
    stroke-dashoffset: 0;
    animation: none;
  }
`, Q1t = ce.span`
  --spark-angle: ${(e) => e.$angle}deg;

  position: absolute;
  top: calc(50% - 0.25rem);
  left: calc(50% - 0.1rem);
  width: 0.2rem;
  height: 0.5rem;
  border-radius: 999px;
  background: ${(e) => e.$colour};
  opacity: 0;
  animation: ${W1t} 680ms ${(e) => 90 + e.$delay}ms cubic-bezier(0.22, 1, 0.36, 1)
    both;
  transform-origin: 0.1rem 0.25rem;

  @media (prefers-reduced-motion: reduce) {
    display: none;
  }
`, J1t = ce.div`
  width: 100%;
  text-align: ${(e) => e.$centered ? "center" : "inherit"};
  font-weight: ${(e) => e.$centered ? "600" : "inherit"};
  animation: ${B1t} 520ms 150ms cubic-bezier(0.22, 1, 0.36, 1) both;

  @media (prefers-reduced-motion: reduce) {
    filter: none;
    transform: none;
    animation: none;
  }
`, Z1t = ({
  question: e,
  injectCurrent: t,
  submitAnswer: n,
  answers: r,
  updateSurveyControls: i,
  goToPreviousQuestion: o
}) => {
  const a = uf((s) => s.survey.direction);
  return ot(() => {
    a === "backwards" && o();
  }, [a]), Fa(() => (i({
    nextDisabled: !0,
    prevDisabled: !0
  }), () => {
    i({
      nextDisabled: !1,
      prevDisabled: !1
    });
  }), []), ot(() => {
    let s = !0;
    const c = async (l, u) => {
      const d = await l(u);
      s && (t({ value: d ?? null }), n());
    };
    return er.isFunction(e.answerValue) ? c(e.answerValue, { answers: r }) : (t({ value: e.answerValue ?? null }), n()), () => {
      s = !1;
    };
  }, []), /* @__PURE__ */ A.jsx(tp, {});
}, e_t = ({
  question: e,
  currentAnswer: t,
  injectCurrent: n,
  submitAnswer: r,
  answers: i,
  settings: o
}) => (ot(() => {
  const a = e.answerValue ? e.answerValue({ answers: i }) : null;
  n({ value: a });
}, []), null), t_t = (e) => {
  const { question: t, settings: n } = e, { loggingService: r } = gt(mn);
  if (t.type !== "loggingTestPage")
    throw new H4("loggingTestPage", t.type);
  switch (t.loggingType) {
    case "debug":
      return r.debug(n.surveyName, "debug"), /* @__PURE__ */ A.jsx(Mh, { children: "debug" });
    case "log":
      return r.log(n.surveyName, "log"), /* @__PURE__ */ A.jsx(Mh, { children: "log" });
    case "info":
      return r.info(n.surveyName, "info"), /* @__PURE__ */ A.jsx(Mh, { children: "info" });
    case "warn":
      return r.warn(n.surveyName, "warn"), /* @__PURE__ */ A.jsx(Mh, { children: "warn" });
    case "error":
      return r.error("error", {
        error: new Error("Test error"),
        context: n.surveyName
      }), /* @__PURE__ */ A.jsx(Mh, { children: "error" });
    default:
      return /* @__PURE__ */ A.jsx(Mh, { children: "no logging type set" });
  }
}, Mh = ce.div`
  display: flex;
  flex-direction: column;
  // width: 800px;
  justify-content: center;
  align-items: baseline;
  @media (min-width: 0px) and (max-width: 479px) {
    margin: 10px;
  }
`, HP = j.forwardRef(
  ({ onClick: e, text: t, active: n, colour: r, contrastColour: i, glow: o, shadeColour: a }, s) => {
    const c = Mi();
    return /* @__PURE__ */ A.jsx(
      n_t,
      {
        onClick: e,
        borderRadius: c,
        active: n,
        primaryColour: r,
        glow: o,
        ref: s,
        children: /* @__PURE__ */ A.jsx(r_t, { children: t })
      }
    );
  }
);
HP.displayName = "UiMatchButton";
const n_t = ce(nse)`
  background-color: ${(e) => e.active ? e.primaryColour : e.shadeColour ? e.shadeColour : "var(--light)"};
  color: ${(e) => e.active ? "var(--light)" : "var(--dark)"};
`, r_t = ce.div`
  font-weight: 400;
  font-size: var(--choice-text-font-size);
  text-align: left;
  text-overflow: ellipsis;
  word-wrap: break-word;
  word-break: break-word;
  margin-bottom: 0rem;
`, i_t = ({
  question: e,
  currentAnswer: t,
  injectCurrent: n,
  submitAnswer: r,
  answers: i,
  settings: o
}) => {
  const { loggingService: a, popupService: s } = gt(mn), c = $e(null), [l, u] = Qe(null), [d, f] = Qe([]), { primaryColour: h, contrastColour: p, colourShades: g } = Gn(), { choices: m, ready: v } = yl(
    e.leftChoices,
    i
  ), { choices: y, ready: _ } = yl(
    e.rightChoices,
    i
  );
  Xi(e, (P) => {
    const k = P.getValue("match") ?? [];
    return ec(
      m.every((L) => k.some((N) => N.id === L.value)),
      v && _
    );
  });
  const b = Tt(() => y.sort((P, k) => Math.random() - 0.5), [y]), w = t.getValue(e.type), C = (P) => {
    a.debug("startMatch", P), l && l.id === P.id ? u(null) : u(P);
  }, x = (P) => {
    if (a.debug("completeMatch", P, l), l) {
      let k;
      w ? k = w.filter((L) => L.id !== l.value && L.value !== P.value).concat({
        id: l.value,
        value: P.value
      }) : k = [
        {
          id: l.value,
          value: P.value
        }
      ], n({ value: k }), u(null);
    }
  }, T = Wt(
    (P) => {
      const k = c.current;
      if (!k)
        return;
      const L = k.getBoundingClientRect(), N = P.map((D) => {
        const z = hH(D.left, L), V = hH(D.right, L), B = z.x + z.width, U = z.y + z.height / 2, Q = V.x, Y = V.y + V.height / 2;
        return [B, U, Q, Y];
      });
      console.log("newCoords", N), f(N);
    },
    [f]
  ), R = Ms({
    selectLeft: { content: "Click on a left option", position: { left: 0, top: 0 } },
    selectRight: { content: "Click on a right option to match", position: { left: 1, top: 0 } },
    allMatched: { content: "Click next to continue" }
  }, e.helpPopups), I = e.showHelpPopups ?? !1, O = e.helpPopupsToShow;
  return ot(() => {
    w !== null && w.length === m.length ? s.setPopup(R, "allMatched", I, O) : l === null ? s.setPopup(R, "selectLeft", I, O) : s.setPopup(R, "selectRight", I, O);
  }, [R, I, O, w, m, l]), /* @__PURE__ */ A.jsxs(c_t, { children: [
    /* @__PURE__ */ A.jsxs(l_t, { ref: c, children: [
      /* @__PURE__ */ A.jsx(o_t, { leftHeader: e.leftLabel, rightHeader: e.rightLabel }),
      /* @__PURE__ */ A.jsx(
        a_t,
        {
          leftChoices: m,
          rightChoices: b,
          currentLeft: l,
          startMatch: C,
          completeMatch: x,
          currentAnswerValue: w,
          primaryColour: h,
          colourShades: g,
          onDOMRects: T
        }
      )
    ] }),
    /* @__PURE__ */ A.jsx(s_t, { lineCoords: d, matchGridRef: c })
  ] });
}, o_t = ({ leftHeader: e, rightHeader: t }) => !e && !t ? null : /* @__PURE__ */ A.jsxs(A.Fragment, { children: [
  /* @__PURE__ */ A.jsx(fH, { children: e }),
  /* @__PURE__ */ A.jsx(fH, { children: t })
] }), fH = ce.div`
  /* font-size: 1.5rem; */
  font-weight: bold;
  text-align: center;
`, a_t = ({
  leftChoices: e,
  rightChoices: t,
  currentLeft: n,
  primaryColour: r,
  startMatch: i,
  completeMatch: o,
  currentAnswerValue: a,
  onDOMRects: s,
  colourShades: c
}) => {
  const l = $e([]), u = $e([]);
  return ot(() => {
    const d = [];
    a == null || a.forEach((f) => {
      const h = e.findIndex((g) => g.value === f.id), p = t.findIndex((g) => g.value === f.value);
      h !== -1 && p !== -1 && d.push({
        left: l.current[h].getBoundingClientRect(),
        right: u.current[p].getBoundingClientRect()
      });
    }), s(d);
  }, [a, e, t, s]), /* @__PURE__ */ A.jsx(A.Fragment, { children: e.map((d, f) => {
    const h = t[f], p = a !== null && a.find((m) => m.value === h.value), g = p ? e.findIndex((m) => m.value === p.id) : null;
    return /* @__PURE__ */ A.jsxs(XH, { children: [
      /* @__PURE__ */ A.jsx(
        HP,
        {
          onClick: () => i(d),
          text: d.text ? qn(d.text) : d.value,
          active: a !== null && a.findIndex((m) => m.id === d.value) !== -1 || (n == null ? void 0 : n.id) === d.id,
          colour: c[f],
          contrastColour: "black",
          glow: n !== null && n.id === d.id,
          ref: (m) => {
            m && (l.current[f] = m);
          }
        },
        `${d.id}-left`
      ),
      /* @__PURE__ */ A.jsx(
        HP,
        {
          onClick: () => o(h),
          text: h.text ? qn(h.text) : h.value,
          active: a !== null && a.findIndex((m) => m.value === h.value) !== -1,
          colour: g !== null ? c[g] : r,
          contrastColour: "black",
          glow: n !== null,
          ref: (m) => {
            m && (u.current[f] = m);
          }
        },
        `${h.id}-right`
      )
    ] }, d.id);
  }) });
}, s_t = ({ lineCoords: e, matchGridRef: t }) => {
  var i;
  const { width: n, height: r } = ((i = t.current) == null ? void 0 : i.getBoundingClientRect()) ?? { width: 0, height: 0 };
  return console.log("lineCoords", e, n, r), /* @__PURE__ */ A.jsx(
    u_t,
    {
      width: "100%",
      height: "100%",
      viewBox: `0 0 ${n} ${r}`,
      xmlns: "http://www.w3.org/2000/svg",
      preserveAspectRatio: "none",
      children: e.map(([o, a, s, c], l) => /* @__PURE__ */ A.jsx(
        d_t,
        {
          x1: o * n,
          y1: a * r,
          x2: s * n,
          y2: c * r,
          stroke: "#3C4142",
          strokeWidth: "2",
          strokeLinecap: "round"
        },
        c.toString() + a.toString()
      ))
    }
  );
};
function hH(e, t) {
  return {
    x: (e.x - t.x) / t.width,
    y: (e.y - t.y) / t.height,
    height: e.height / t.height,
    width: e.width / t.width
  };
}
const c_t = ce.div`
  position: relative;
  /* display: flex;
  flex-direction: column; */
`, l_t = ce.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 5rem;
  row-gap: 1rem;
`, u_t = ce.svg`
  position: absolute;
  top: 0;
  pointer-events: none;
  /* flex: 1 1; */
`, d_t = ce.line`
  @keyframes grow {
    from {
      stroke-dashoffset: 500;
    }
    to {
      stroke-dashoffset: 0;
    }
  }
  stroke-dasharray: 500;
  animation: grow 1s ease-out forwards;
`, $ce = (e) => {
  const { label: t, image: n, imageAlt: r, stacked: i = !1, ...o } = e, a = Mi();
  return /* @__PURE__ */ A.jsx(f_t, { ...o, borderRadius: a, $stacked: i, type: "button", children: /* @__PURE__ */ A.jsxs(h_t, { $stacked: i, children: [
    i ? /* @__PURE__ */ A.jsx(p_t, { $stacked: i, children: typeof n == "string" ? /* @__PURE__ */ A.jsx(m_t, { src: n, alt: r || "" }) : n }) : void 0,
    /* @__PURE__ */ A.jsx(g_t, { $stacked: i, children: t })
  ] }) });
}, f_t = ce(a4)`
  flex: 1;
  justify-content: center;
  text-align: center;
  border: 1px solid var(--mid);
  background-color: ${(e) => e.active ? e.primaryColour : e.shadeColour ? e.shadeColour : "var(--light)"};
  font-size: var(--choice-text-font-size);
  span.ripple {
    background-color: ${(e) => e.contrastColour || "var(--light)"};
  }
  /* font-weight: ${(e) => e.active ? "500" : "400"}; */
  color: ${(e) => e.active ? e.contrastColour || "var(--light)" : "var(--dark)"};
  min-height: ${(e) => e.$stacked ? "12rem" : "var(--button-height)"};
  padding: ${(e) => e.$stacked ? "var(--spacing-sm)" : "var(--spacing-sm) var(--spacing-sm)"};
`, h_t = ce.div`
  display: flex;
  flex-direction: ${({ $stacked: e }) => e ? "column" : "row"};
  align-items: center;
  justify-content: center;
  gap: ${({ $stacked: e }) => e ? "0.75rem" : "0"};
  width: 100%;
`, g_t = ce.span`
  display: block;
  text-align: center;
  width: 100%;
  word-wrap: break-word;
  word-break: break-word;
  ${({ $stacked: e }) => e ? "font-weight: 500;" : ""}
`, p_t = ce.div`
  width: 100%;
  min-height: ${({ $stacked: e }) => e ? "6rem" : "0"};
  max-height: ${({ $stacked: e }) => e ? "6rem" : "none"};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: inherit;
  overflow: hidden;

  img {
    width: 100%;
    max-width: 100%;
    height: 100%;
    max-height: 6rem;
    object-fit: contain;
  }
`, m_t = ce.img`
  display: block;
`;
function Ace({
  layout: e,
  shade: t,
  onSelect: n,
  animateSelection: r,
  tableOptions: i,
  ...o
}) {
  const a = No(), s = Mi(), { primaryColour: c, contrastColour: l, shadeColour: u } = Gn();
  return Wee(e, a) ? /* @__PURE__ */ A.jsx(
    __t,
    {
      ...o,
      tableOptions: i,
      primaryColour: c,
      borderRadius: s,
      updateMatrixAnswer: n
    }
  ) : /* @__PURE__ */ A.jsx(
    y_t,
    {
      ...o,
      animateSelection: r,
      primaryColour: c,
      contrastColour: l,
      shadeColour: t ? u : void 0,
      updateMatrixAnswer: n,
      hasChoiceImages: o.choices.some((d) => !!d.image),
      device: a
    }
  );
}
function v_t(e, t) {
  if (!(typeof e != "number" || !Number.isFinite(e)))
    return Math.min(Math.max(Math.floor(e), 1), Math.max(t, 1));
}
const y_t = ({
  statements: e,
  choices: t,
  isSelected: n,
  multiple: r,
  primaryColour: i,
  contrastColour: o,
  shadeColour: a,
  updateMatrixAnswer: s,
  hasChoiceImages: c,
  mobileColumns: l,
  device: u,
  statementHeadingRef: d,
  animateSelection: f
}) => /* @__PURE__ */ A.jsx(x_t, { children: e.map((h) => /* @__PURE__ */ A.jsx(
  b_t,
  {
    statement: h,
    choices: t,
    isSelected: n,
    multiple: r,
    primaryColour: i,
    contrastColour: o,
    shadeColour: a,
    updateMatrixAnswer: s,
    hasChoiceImages: c,
    mobileColumns: l,
    device: u,
    statementHeadingRef: d,
    animateSelection: f
  },
  h.id
)) }), b_t = ({
  statement: e,
  choices: t,
  isSelected: n,
  multiple: r,
  primaryColour: i,
  contrastColour: o,
  shadeColour: a,
  updateMatrixAnswer: s,
  hasChoiceImages: c,
  mobileColumns: l,
  device: u,
  statementHeadingRef: d,
  animateSelection: f
}) => /* @__PURE__ */ A.jsxs(E_t, { role: "group", "aria-label": e.value, children: [
  /* @__PURE__ */ A.jsx(Rce, { statement: e, headingRef: d }),
  /* @__PURE__ */ A.jsx(
    C_t,
    {
      $device: u,
      $hasChoiceImages: c,
      $numChoices: t.length,
      $mobileColumns: v_t(l, t.length),
      children: t.map((h) => /* @__PURE__ */ A.jsx(
        w_t,
        {
          choice: h,
          primaryColour: i,
          contrastColour: o,
          shadeColour: h.fill ?? a,
          active: n(e, h),
          pressed: r ? n(e, h) : void 0,
          onClick: () => s(e, h),
          animateSelection: f,
          hasChoiceImages: c
        },
        `${typeof h.id}:${h.id}`
      ))
    }
  )
] }), Rce = ({ statement: e, headingRef: t }) => {
  const n = /* @__PURE__ */ A.jsx(
    Pce,
    {
      ref: t,
      tabIndex: t ? -1 : void 0,
      role: t ? "heading" : void 0,
      "aria-level": t ? 3 : void 0,
      children: e.text ? qn(e.text) : e.value
    }
  );
  return e.toolTip ? /* @__PURE__ */ A.jsx(od, { placement: "topLeft", title: e.toolTip, children: n }) : n;
}, __t = ({
  questionId: e,
  statements: t,
  choices: n,
  isSelected: r,
  multiple: i,
  primaryColour: o,
  borderRadius: a,
  updateMatrixAnswer: s,
  tableOptions: c
}) => {
  const l = (c == null ? void 0 : c.scrollContainer) === "parent";
  return /* @__PURE__ */ A.jsx(T_t, { $borderRadius: a, $parentScroll: l, children: /* @__PURE__ */ A.jsxs(
    I_t,
    {
      $numChoices: n.length,
      $tableOptions: c,
      $parentScroll: l,
      children: [
        /* @__PURE__ */ A.jsxs("colgroup", { children: [
          /* @__PURE__ */ A.jsx($_t, {}),
          n.map((u) => /* @__PURE__ */ A.jsx("col", {}, `${typeof u.id}:${u.id}`))
        ] }),
        /* @__PURE__ */ A.jsx("thead", { children: /* @__PURE__ */ A.jsxs("tr", { children: [
          /* @__PURE__ */ A.jsx(A_t, { scope: "col" }),
          n.map((u) => /* @__PURE__ */ A.jsx(R_t, { scope: "col", children: /* @__PURE__ */ A.jsx(S_t, { choice: u, showImage: !!u.image }) }, `${typeof u.id}:${u.id}`))
        ] }) }),
        /* @__PURE__ */ A.jsx("tbody", { children: t.map((u) => /* @__PURE__ */ A.jsxs("tr", { children: [
          /* @__PURE__ */ A.jsx(P_t, { scope: "row", children: /* @__PURE__ */ A.jsx(Rce, { statement: u }) }),
          n.map((d) => /* @__PURE__ */ A.jsx(O_t, { children: /* @__PURE__ */ A.jsx(M_t, { children: /* @__PURE__ */ A.jsx(
            k_t,
            {
              type: i ? "checkbox" : "radio",
              name: `matrix-${e}-${u.id}`,
              value: String(d.id),
              checked: r(u, d),
              onChange: () => s(u, d),
              "aria-label": `${d.value} for ${u.value}`,
              $primaryColour: o
            }
          ) }) }, `${typeof d.id}:${d.id}`))
        ] }, u.id)) })
      ]
    }
  ) });
}, S_t = ({ choice: e, showImage: t }) => {
  const n = /* @__PURE__ */ A.jsxs(N_t, { $stacked: t, children: [
    t ? /* @__PURE__ */ A.jsx(j_t, { children: typeof e.image == "string" ? /* @__PURE__ */ A.jsx(L_t, { src: e.image, alt: e.imageAlt || e.value }) : e.image }) : void 0,
    /* @__PURE__ */ A.jsx(D_t, { children: e.text ? qn(e.text) : e.value })
  ] });
  return e.toolTip ? /* @__PURE__ */ A.jsx(od, { placement: "topLeft", title: e.toolTip, children: n }) : n;
}, w_t = ({
  choice: e,
  primaryColour: t,
  contrastColour: n,
  shadeColour: r,
  active: i,
  pressed: o,
  onClick: a,
  hasChoiceImages: s,
  animateSelection: c
}) => {
  let l = /* @__PURE__ */ A.jsx(
    $ce,
    {
      primaryColour: t,
      contrastColour: n,
      shadeColour: r,
      active: i,
      "aria-pressed": o,
      onClick: (u) => {
        a(), c && Su(u);
      },
      label: e.text ? qn(e.text) : e.value,
      image: e.image,
      imageAlt: e.imageAlt || e.value,
      stacked: s
    }
  );
  return e.toolTip && (l = /* @__PURE__ */ A.jsx(od, { placement: "topLeft", title: e.toolTip, children: l })), l;
}, x_t = ce.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 1rem;
`, E_t = ce.div`
  word-wrap: break-word;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`, Pce = ce.div`
  font-weight: 500;
  font-size: var(--question-text-font-size);
`, C_t = ce.div`
  display: ${({ $device: e, $hasChoiceImages: t, $mobileColumns: n }) => e === Xn.MOBILE && n !== void 0 || t ? "grid" : "flex"};
  justify-content: ${({ $device: e, $hasChoiceImages: t, $mobileColumns: n }) => e === Xn.MOBILE && n !== void 0 || t ? "initial" : "space-between"};
  gap: 0.5rem;
  flex-direction: ${({ $device: e, $hasChoiceImages: t, $mobileColumns: n }) => e === Xn.MOBILE && n !== void 0 || t ? "initial" : e === Xn.MOBILE ? "column" : "row"};
  grid-template-columns: ${({ $device: e, $hasChoiceImages: t, $numChoices: n, $mobileColumns: r }) => e === Xn.MOBILE && r !== void 0 ? `repeat(${r}, minmax(0, 1fr))` : t ? e === Xn.MOBILE ? "minmax(0, 1fr)" : `repeat(${Math.max(n, 1)}, minmax(0, 1fr))` : "none"};
`, T_t = ce.div`
  width: ${(e) => e.$parentScroll ? "max-content" : "100%"};
  max-width: ${(e) => e.$parentScroll ? "none" : "100%"};
  overflow: ${(e) => e.$parentScroll ? "visible" : "auto"};
  border: 1px solid var(--mid);
  border-radius: ${(e) => e.$borderRadius};
  background: var(--light);
`, UP = (e) => `calc(
  var(--radio-statement-column-width) +
  ${Math.max(e.$numChoices, 1)} * var(--radio-choice-column-width)
)`, gH = (e) => {
  var t;
  return (t = e.$tableOptions) != null && t.statementColumnWidth ? UP(e) : `max(
        calc(var(--radio-statement-column-width) / 0.34),
        calc(${Math.max(e.$numChoices, 1)} * var(--radio-choice-column-width) / 0.66)
      )`;
}, I_t = ce.table`
  --radio-statement-column-width: ${(e) => {
  var t;
  return ((t = e.$tableOptions) == null ? void 0 : t.statementColumnWidth) ?? "10rem";
}};
  --radio-statement-column-size: ${(e) => {
  var t;
  return ((t = e.$tableOptions) == null ? void 0 : t.statementColumnWidth) ?? "34%";
}};
  --radio-choice-column-width: ${(e) => {
  var t;
  return ((t = e.$tableOptions) == null ? void 0 : t.choiceColumnMinWidth) ?? "6rem";
}};
  --radio-cell-block-padding: var(--spacing-sm);
  --radio-cell-inline-padding: var(--spacing-xs);
  --radio-header-font-size: var(--choice-text-font-size);
  --radio-statement-font-size: inherit;
  --radio-control-size: 1.25rem;
  --radio-cell-min-height: 2rem;

  width: ${(e) => e.$parentScroll ? gH(e) : "100%"};
  table-layout: fixed;
  /* Reserve the statement column and divide the remaining width equally between choices. */
  min-width: ${gH};
  border-collapse: separate;
  border-spacing: 0;

  th,
  td {
    padding: var(--radio-cell-block-padding) var(--radio-cell-inline-padding);
  }

  thead th {
    border-bottom: 1px solid var(--mid);
  }

  tbody tr:nth-child(even) {
    background: var(--off-light);
  }

  tbody tr:nth-child(odd) > th:first-child {
    background: var(--light);
  }

  tbody tr:nth-child(even) > th:first-child {
    background: var(--off-light);
  }

  tbody th,
  tbody td {
    vertical-align: middle;
  }

  @media (max-width: 1023px) {
    /* Leave room for answer controls beside the sticky statement column on tablets. */
    --radio-statement-column-size: var(--radio-statement-column-width);
    width: ${(e) => e.$parentScroll ? UP(e) : "100%"};
    min-width: ${UP};
  }

  @media (max-width: 479px) {
    --radio-statement-column-width: 6.75rem;
    --radio-choice-column-width: 2.75rem;
    --radio-cell-block-padding: 0.35rem;
    --radio-cell-inline-padding: 0.1rem;
    --radio-header-font-size: 0.55rem;
    --radio-statement-font-size: 0.74rem;
    --radio-control-size: 0.95rem;
    --radio-cell-min-height: 2.25rem;
  }
`, $_t = ce.col`
  width: var(--radio-statement-column-size);
`, A_t = ce.th`
  position: sticky;
  top: 0;
  left: 0;
  z-index: 3;
  background: var(--light);
  box-shadow: 0.5rem 0 0.75rem -0.75rem rgba(0, 0, 0, 0.35);
`, R_t = ce.th`
  position: sticky;
  top: 0;
  z-index: 2;
  background: var(--light);
  text-align: center;
  font-weight: 500;
  font-size: var(--radio-header-font-size);
  line-height: 1.25;
`, P_t = ce.th`
  position: sticky;
  left: 0;
  z-index: 1;
  text-align: left;
  font-weight: 500;
  font-size: var(--radio-statement-font-size);
  line-height: 1.35;
  box-shadow: 0.5rem 0 0.75rem -0.75rem rgba(0, 0, 0, 0.35);

  @media (max-width: 479px) {
    ${Pce} {
      font-size: inherit;
      line-height: inherit;
    }
  }
`, O_t = ce.td`
  text-align: center;
`, M_t = ce.label`
  min-height: var(--radio-cell-min-height);
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`, k_t = ce.input`
  width: var(--radio-control-size);
  height: var(--radio-control-size);
  margin: 0;
  flex: 0 0 auto;
  cursor: pointer;
  accent-color: ${(e) => e.$primaryColour};
  background-color: white;
`, N_t = ce.div`
  display: flex;
  flex-direction: ${({ $stacked: e }) => e ? "column" : "row"};
  align-items: center;
  justify-content: center;
  gap: ${({ $stacked: e }) => e ? "0.5rem" : "0"};
  width: 100%;
`, D_t = ce.span`
  display: block;
  width: 100%;
  text-align: center;
  white-space: normal;
  overflow-wrap: normal;
  word-break: normal;
`, j_t = ce.div`
  width: 100%;
  min-height: 3.5rem;
  max-height: 3.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`, L_t = ce.img`
  display: block;
  width: 100%;
  max-width: 100%;
  height: 100%;
  max-height: 3.5rem;
  object-fit: contain;
`, F_t = ce(lm)`
  max-width: ${(e) => e.$contentWidth};
`;
function V_t(e) {
  const {
    question: t,
    enabled: n,
    ready: r,
    statements: i,
    choices: o,
    value: a,
    hasSavedAnswer: s,
    enteredFromPrevious: c,
    setNextButtonBehaviour: l,
    setPreviousButtonBehaviour: u,
    updateSurveyControls: d
  } = e, { messagerService: f } = gt(mn), [h, p] = Qe(), g = (h == null ? void 0 : h.questionId) === t.id ? h : void 0, m = i.find((P) => !OI(a, P, o)), v = i.find((P) => P.id === (g == null ? void 0 : g.statementId)) ?? (!g && c ? i[i.length - 1] : g || s ? m ?? i[i.length - 1] : i[0]), y = v ? i.indexOf(v) : -1, _ = $e(null), b = $e(!1), w = $e(), C = $e(e), x = $e();
  Fa(() => (x.current = void 0, () => {
    x.current = void 0;
  }), [n, t.id]), Fa(() => {
    C.current = e, w.current = v == null ? void 0 : v.id;
  }), Fa(() => {
    var P, k;
    !n || !r || ((!g || g.statementId !== (v == null ? void 0 : v.id)) && p({ questionId: t.id, statementId: v == null ? void 0 : v.id }), b.current && _.current && (_.current.focus({ preventScroll: !0 }), (k = (P = _.current).scrollIntoView) == null || k.call(P, { block: "nearest" }), b.current = !1));
  }, [n, r, t.id, g, v == null ? void 0 : v.id]), Fa(() => {
    if (n)
      return d({ nextDisabled: !r, prevDisabled: !r }), () => d({ nextDisabled: !1, prevDisabled: !1 });
  }, [n, r, t.id, d]);
  const T = Wt(
    (P) => {
      w.current = P.id, b.current = !0, f.destroyAll(), p({ questionId: t.id, statementId: P.id });
    },
    [t.id, f]
  ), E = Wt(
    (P, k) => {
      const L = C.current;
      if (!L.enabled || !L.ready || L.question.id !== t.id)
        return;
      const N = L.statements.findIndex(
        (V) => V.id === w.current
      ), D = L.statements[N];
      if (L.question.required && D && !OI(P, D, L.choices)) {
        f.error("Please select an answer for this row.");
        return;
      }
      if (N < L.statements.length - 1) {
        L.recordAnswer(), T(L.statements[N + 1]);
        return;
      }
      const z = L.statements.find(
        (V) => !OI(P, V, L.choices)
      );
      if (L.question.required && z) {
        T(z), f.error("This question requires an answer for every row");
        return;
      }
      k ? k() : L.submitAnswer();
    },
    [t.id, f, T]
  ), R = Wt(
    (P) => !x.current && w.current === P,
    []
  ), I = Wt(() => {
    const P = C.current;
    if (!P.enabled || !P.ready || x.current)
      return;
    const k = w.current, L = {};
    x.current = L, P.submitAnswer((N) => {
      if (x.current !== L)
        return;
      x.current = void 0;
      const D = C.current;
      !D.enabled || !D.ready || !D.question.mobileAutoNext || D.question.id !== t.id || w.current !== k || E(D.value, N);
    });
  }, [t.id, E]), O = y > 0;
  return Fa(() => {
    if (n)
      return l((P) => {
        P.getAnswer().questionId === t.id && E(P.getValue("matrix") ?? {});
      }, "internal-step"), O && u(() => {
        const P = C.current, k = P.statements.findIndex(
          (L) => L.id === w.current
        );
        !P.ready || k <= 0 || (P.recordAnswer(), T(P.statements[k - 1]));
      }, "internal-step"), () => {
        l(void 0), O && u(void 0);
      };
  }, [
    n,
    t.id,
    O,
    E,
    T,
    l,
    u
  ]), { activeStatement: v, activeIndex: y, headingRef: _, autoAdvanceRow: I, isActiveStatement: R };
}
function OI(e, t, n) {
  return n.some((r) => {
    var i;
    return r.id === ((i = e[t.id]) == null ? void 0 : i.id);
  });
}
const B_t = ({
  answers: e,
  question: t,
  currentAnswer: n,
  injectCurrent: r,
  submitAnswer: i,
  recordAnswer: o,
  setNextButtonBehaviour: a,
  setPreviousButtonBehaviour: s,
  updateSurveyControls: c,
  enteredFromPrevious: l
}) => {
  var O;
  const u = No(), d = t.mobileLayout === "one-row" && u === Xn.MOBILE, { value: f, ready: h } = ju(t.statements, {
    answers: e
  }), p = Tt(() => f || [], [f]), { choices: g, ready: m } = yl(
    t.choices,
    e
  ), v = n.getAnswer(), y = n.getValue(t.type), _ = h && m, b = Tt(
    () => H_t({
      answerValue: y,
      currentValidity: v.validity,
      statements: p,
      choices: g,
      ready: d ? _ && (g.length > 0 || p.length === 0) : f !== void 0 && g.length > 0
    }),
    [
      v.validity,
      f,
      g,
      p,
      y,
      d,
      _
    ]
  ), w = Wt(() => {
    if (!t.defaultValues || d && !_)
      return;
    const P = t.defaultValues({
      answers: e,
      choices: g,
      statements: p
    }), k = {};
    for (const [L, N] of Object.entries(P)) {
      const D = g.find((V) => V.id === N), z = p.find((V) => V.id === L);
      D && z && (k[z.id] = {
        id: D.id,
        value: D.value,
        info: { statementValue: z.value }
      });
    }
    if (Object.keys(k).length > 0)
      return k;
  }, [t, e, g, p, d, _]);
  Qf(w, t, n, e, r), Xi(
    t,
    (P) => Rs(
      P.getValue("matrix"),
      p.map((k) => ({ id: k.id })),
      h && m
    )
  ), ot(() => {
    var P;
    if (v.questionId === t.id) {
      if (d && _ && p.length === 0 && !((P = v.validity) != null && P.valid)) {
        r({ validity: { valid: !0, messages: [] } });
        return;
      }
      !b.ready || !b.needsSync || v.questionId !== t.id || r({ value: b.value, validity: b.validity });
    }
  }, [
    v.questionId,
    (O = v.validity) == null ? void 0 : O.valid,
    r,
    b,
    t.id,
    d,
    _,
    p.length
  ]);
  const { activeStatement: C, activeIndex: x, headingRef: T, autoAdvanceRow: E, isActiveStatement: R } = V_t({
    question: t,
    enabled: d,
    ready: _,
    statements: p,
    choices: g,
    value: b.value,
    hasSavedAnswer: t.id in e.raw(),
    enteredFromPrevious: l,
    recordAnswer: o,
    submitAnswer: i,
    setNextButtonBehaviour: a,
    setPreviousButtonBehaviour: s,
    updateSurveyControls: c
  }), I = (P, k) => {
    if (d && (!_ || !R(P.id)))
      return;
    const L = {
      ...b.value,
      [P.id]: {
        id: k.id,
        value: k.value,
        info: { statementValue: P.value }
      }
    }, N = Oce(L, p);
    if (r({ value: L, validity: N }), d && t.mobileAutoNext) {
      E();
      return;
    }
    const D = Object.keys(b.value).length;
    !d && t.autoNext && N.valid && D === p.length - 1 && i();
  };
  return d && !_ ? /* @__PURE__ */ A.jsx("p", { role: "status", children: "Loading options…" }) : /* @__PURE__ */ A.jsxs(A.Fragment, { children: [
    d && C && /* @__PURE__ */ A.jsxs("p", { role: "status", "aria-live": "polite", "aria-atomic": "true", children: [
      "Statement ",
      x + 1,
      " of ",
      p.length
    ] }),
    /* @__PURE__ */ A.jsx(
      Ace,
      {
        questionId: t.id,
        statements: d ? C ? [C] : [] : p,
        choices: g,
        layout: t.layout,
        tableOptions: t.tableOptions,
        shade: t.shade,
        mobileColumns: t.mobileColumns,
        animateSelection: d && t.mobileAutoNext,
        isSelected: (P, k) => z_t(P, k, b.value),
        onSelect: I,
        statementHeadingRef: d ? T : void 0
      }
    )
  ] });
};
function z_t(e, t, n) {
  if (!(e.id in n))
    return !1;
  const r = qH(n[e.id]);
  return r ? r.id === t.id : !1;
}
function H_t({
  answerValue: e,
  currentValidity: t,
  statements: n,
  choices: r,
  ready: i
}) {
  if (!i || e === null)
    return {
      ready: !1,
      value: e || {},
      validity: t,
      needsSync: !1
    };
  const o = U_t(e, n, r), a = Oce(o, n);
  return {
    ready: !0,
    value: o,
    validity: a,
    needsSync: !W_t(e || {}, o) || !q_t(t, a)
  };
}
function U_t(e, t, n) {
  if (e === null)
    return {};
  const r = {};
  for (const i of t) {
    const o = e[i.id], a = n.find((s) => s.id === (o == null ? void 0 : o.id));
    !o || !a || (r[i.id] = {
      id: a.id,
      value: a.value,
      info: { ...o.info, statementValue: i.value }
    });
  }
  return r;
}
function Oce(e, t) {
  const n = t.map((o) => o.id), i = Object.keys(e).length === n.length && n.every((o) => e[o] !== void 0);
  return {
    valid: i,
    messages: i ? [] : ["This question requires an answer for every row"]
  };
}
function W_t(e, t) {
  const n = Object.keys(e), r = Object.keys(t);
  return n.length !== r.length ? !1 : r.every((i) => {
    var s, c;
    const o = e[i], a = t[i];
    return (o == null ? void 0 : o.id) === a.id && o.value === a.value && ((s = o.info) == null ? void 0 : s.statementValue) === ((c = a.info) == null ? void 0 : c.statementValue);
  });
}
function q_t(e, t) {
  return (e == null ? void 0 : e.valid) === t.valid && (e.messages ?? []).join(`
`) === (t.messages ?? []).join(`
`);
}
const G_t = ({
  question: e,
  answers: t,
  currentAnswer: n,
  injectCurrent: r
}) => {
  var h, p;
  const i = `dropdown-matrix-${tO().replace(/:/g, "")}`, o = Wt(async () => {
    const [g, m] = await Promise.all([
      typeof e.rows == "function" ? e.rows({ answers: t }) : e.rows,
      typeof e.columns == "function" ? e.columns({ answers: t }) : e.columns
    ]), v = await Promise.all(
      g.flatMap(
        (y) => m.map(async (_) => ({
          key: c$(y.id, _.id),
          row: y,
          column: _,
          choices: typeof e.choices == "function" ? await e.choices({ answers: t, row: y, column: _ }) : e.choices
        }))
      )
    );
    return { question: e, answers: t, rows: g, columns: m, cells: v };
  }, [e, t]), a = Qn(o, {}), s = (a == null ? void 0 : a.question) === e && (a == null ? void 0 : a.answers) === t;
  Xi(
    e,
    (g) => Rs(
      g.getValue("dropdown-matrix"),
      ((a == null ? void 0 : a.cells) ?? []).map((m) => ({ id: m.key })),
      s
    )
  );
  const c = n.getValue(e.type), l = n.getAnswer(), u = {};
  if (s && a) {
    const g = c === null && !(e.id in t.raw()) ? (h = e.defaultValues) == null ? void 0 : h.call(e, { answers: t }) : void 0;
    for (const m of a.cells) {
      const v = c == null ? void 0 : c[m.key], y = v ? (Array.isArray(v) ? v : [v]).map((w) => w.id) : (p = g == null ? void 0 : g[m.row.id]) == null ? void 0 : p[m.column.id], b = (Array.isArray(y) ? y : y === void 0 ? [] : [y]).flatMap((w) => {
        const C = m.choices.find((x) => x.id === w);
        return C ? [C] : [];
      });
      b.length && (u[m.key] = e.multiple ? b.map((w) => z1(w, m.row, m.column)) : z1(b[0], m.row, m.column));
    }
  }
  const d = (g) => {
    const m = !!(s && a && a.cells.every((v) => {
      const y = g[v.key];
      return Array.isArray(y) ? y.length > 0 : !!y;
    }));
    return {
      valid: m,
      messages: m ? [] : ["This question requires an answer for every cell"]
    };
  }, f = d(u);
  return ot(() => {
    if (l.questionId !== e.id)
      return;
    if (!s) {
      ac.isEqual(l.validity, f) || r({ validity: f });
      return;
    }
    (c !== null || Object.keys(u).length > 0) && !ac.isEqual(c, u) ? r({ value: u, validity: f }) : ac.isEqual(l.validity, f) || r({ validity: f });
  }, [
    l.questionId,
    l.validity,
    e.id,
    s,
    c,
    u,
    f,
    r
  ]), !s || !a ? /* @__PURE__ */ A.jsx("p", { role: "status", children: "Loading options…" }) : /* @__PURE__ */ A.jsx(K_t, { role: "region", "aria-label": "Dropdown matrix", tabIndex: 0, children: /* @__PURE__ */ A.jsxs(X_t, { children: [
    /* @__PURE__ */ A.jsx("thead", { children: /* @__PURE__ */ A.jsxs("tr", { children: [
      /* @__PURE__ */ A.jsx("th", { scope: "col", "aria-label": "Rows" }),
      a.columns.map((g, m) => /* @__PURE__ */ A.jsx("th", { scope: "col", id: `${i}-column-${m}`, children: qn(g.text) ?? g.value }, g.id))
    ] }) }),
    /* @__PURE__ */ A.jsx("tbody", { children: a.rows.map((g, m) => /* @__PURE__ */ A.jsxs("tr", { children: [
      /* @__PURE__ */ A.jsx("th", { scope: "row", id: `${i}-row-${m}`, children: qn(g.text) ?? g.value }),
      a.columns.map((v, y) => {
        const _ = a.cells[m * a.columns.length + y], b = u[_.key], C = (b ? (Array.isArray(b) ? b : [b]).map((T) => T.id) : []).flatMap((T) => {
          const E = _.choices.findIndex((R) => R.id === T);
          return E < 0 ? [] : [String(E)];
        }), x = (T) => {
          const E = { ...u }, R = T.map((I) => _.choices[Number(I)]).filter((I) => I !== void 0);
          R.length ? E[_.key] = e.multiple ? R.map((I) => z1(I, g, v)) : z1(R[0], g, v) : delete E[_.key], r({ value: E, validity: d(E) });
        };
        return /* @__PURE__ */ A.jsx("td", { children: /* @__PURE__ */ A.jsx(Q_t, { children: /* @__PURE__ */ A.jsx(
          r5,
          {
            ariaLabelledBy: `${i}-row-${m} ${i}-column-${y}`,
            ariaRequired: e.required,
            multiple: e.multiple,
            allowClear: !0,
            placeholder: e.placeholder ?? (e.multiple ? "Select options" : "Select an option"),
            value: e.multiple ? C : C[0],
            options: _.choices.map((T, E) => ({
              id: T.id,
              value: String(E),
              label: qn(T.text) ?? T.value
            })),
            onChange: (T) => x(Array.isArray(T) ? T : [T]),
            onClear: () => x([])
          }
        ) }) }, v.id);
      })
    ] }, g.id)) })
  ] }) });
};
function z1(e, t, n) {
  return {
    id: e.id,
    value: e.value,
    info: { rowId: t.id, rowValue: t.value, columnId: n.id, columnValue: n.value }
  };
}
const K_t = ce.div`
  width: 100%;
  min-width: 0;
  overflow-x: auto;
`, Y_t = ce(lm)`
  max-width: 64rem;
`, X_t = ce.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  text-align: left;

  th,
  td {
    padding: 0.75rem;
    border-bottom: 1px solid #ddd;
  }

  tbody th {
    min-width: 8rem;
    position: sticky;
    left: 0;
    background: white;
  }
`, Q_t = ce.div`
  min-width: 10rem;

  .ant-select {
    width: 100%;
  }
  .ant-select-selector {
    min-height: 44px;
  }
`;
function Mce(e) {
  const { value: t, onChange: n, primaryColour: r, step: i, min: o, max: a, suffix: s, ariaLabelledBy: c, ariaRequired: l } = e;
  return /* @__PURE__ */ A.jsx(
    go,
    {
      theme: r ? {
        token: {
          colorPrimary: r
        }
      } : void 0,
      children: /* @__PURE__ */ A.jsx(
        NFe,
        {
          "aria-labelledby": c,
          "aria-required": l,
          value: t,
          onChange: (u) => {
            n(u);
          },
          step: i,
          min: o,
          max: a,
          addonAfter: s
        }
      )
    }
  );
}
function hx(e) {
  const {
    value: t,
    onChange: n,
    type: r,
    placeholder: i,
    primaryColour: o,
    maxLength: a,
    onMaxLengthExceeded: s,
    ariaLabelledBy: c,
    ariaRequired: l
  } = e, u = $e(!1), d = Wt(
    (f) => {
      let h = f.target.value;
      a && h.length > a ? (h = h.slice(0, a), !u.current && s && (s(a), u.current = !0)) : u.current && a && h.length < a && (u.current = !1), n(h);
    },
    [a, s, n]
  );
  return /* @__PURE__ */ A.jsx(
    go,
    {
      theme: o ? {
        token: {
          colorPrimary: o
        }
      } : void 0,
      children: /* @__PURE__ */ A.jsx(
        b9e,
        {
          value: t,
          onChange: d,
          type: r,
          placeholder: i,
          "aria-labelledby": c,
          "aria-required": l
        }
      )
    }
  );
}
const J_t = ({
  question: e,
  answers: t,
  currentAnswer: n,
  injectCurrent: r
}) => {
  var v, y, _;
  const i = `input-matrix-${tO().replace(/:/g, "")}`, { primaryColour: o } = Gn(), { messagerService: a } = gt(mn), s = Wt(async () => {
    const [b, w] = await Promise.all([
      typeof e.rows == "function" ? e.rows({ answers: t }) : e.rows,
      typeof e.columns == "function" ? e.columns({ answers: t }) : e.columns
    ]);
    return {
      question: e,
      answers: t,
      rows: b,
      columns: w,
      cells: b.flatMap(
        (C) => w.map((x) => ({
          key: c$(C.id, x.id),
          row: C,
          column: x
        }))
      )
    };
  }, [e, t]), c = Qn(s, {}), l = (c == null ? void 0 : c.question) === e && (c == null ? void 0 : c.answers) === t;
  Xi(
    e,
    (b) => Rs(
      b.getValue("input-matrix"),
      ((c == null ? void 0 : c.cells) ?? []).map((w) => ({ id: w.key, input: w.column.input })),
      l
    )
  );
  const u = n.getAnswer(), d = n.getValue(e.type), f = {};
  if (l && c) {
    const b = d === null && !(e.id in t.raw()) ? (v = e.defaultValues) == null ? void 0 : v.call(e, { answers: t }) : void 0;
    for (const w of c.cells) {
      const C = ((y = d == null ? void 0 : d[w.key]) == null ? void 0 : y.value) ?? ((_ = b == null ? void 0 : b[w.row.id]) == null ? void 0 : _[w.column.id]);
      C == null || String(C).trim().length === 0 || (f[w.key] = MI(w.key, String(C), w.row, w.column));
    }
  }
  const h = l && c ? c.cells.filter((b) => b.column.input.type === "text").map((b) => b.key) : u.excludedFromAggregationIds ?? [];
  Dy(h, n, r);
  const p = (b) => {
    var w;
    if (!l || !c)
      return { valid: !1, messages: ["Loading inputs…"] };
    if (e.required && c.cells.length === 0)
      return { valid: !1, messages: ["This question requires an answer for every cell"] };
    for (const C of c.cells) {
      const x = (w = b[C.key]) == null ? void 0 : w.value;
      if (x === void 0 || x.trim().length === 0) {
        if (e.required)
          return { valid: !1, messages: ["This question requires an answer for every cell"] };
        continue;
      }
      const T = C.column.input;
      if (T.type === "number") {
        const E = Number(x);
        if (!Number.isFinite(E) || T.min !== void 0 && E < T.min || T.max !== void 0 && E > T.max)
          return {
            valid: !1,
            messages: [`Enter a valid number for ${C.row.value}, ${C.column.value}`]
          };
      } else if (T.maxLength !== void 0 && x.length > T.maxLength)
        return {
          valid: !1,
          messages: [
            `Enter no more than ${T.maxLength} characters for ${C.row.value}, ${C.column.value}`
          ]
        };
    }
    return { valid: !0, messages: [] };
  }, g = p(f);
  ot(() => {
    if (u.questionId !== e.id)
      return;
    if (!l) {
      ac.isEqual(u.validity, g) || r({ validity: g });
      return;
    }
    (d !== null || Object.keys(f).length > 0) && !ac.isEqual(d, f) ? r({ value: f, validity: g }) : ac.isEqual(u.validity, g) || r({ validity: g });
  }, [
    u.questionId,
    u.validity,
    e.id,
    l,
    d,
    f,
    g,
    r
  ]);
  const m = (b, w, C, x) => {
    var R;
    let T = { ...f };
    const E = MI(b, w ?? "", C, x);
    if (w === null || w.trim().length === 0 ? delete T[b] : T[b] = E, e.answerModifier && c) {
      const I = e.answerModifier(E, T);
      T = {};
      for (const O of c.cells) {
        const P = (R = I[O.key]) == null ? void 0 : R.value;
        P === void 0 || P.trim().length === 0 || (T[O.key] = MI(O.key, P, O.row, O.column));
      }
    }
    r({ value: T, validity: p(T) });
  };
  return !l || !c ? /* @__PURE__ */ A.jsx("p", { role: "status", children: "Loading inputs…" }) : /* @__PURE__ */ A.jsx(Z_t, { role: "region", "aria-label": "Input matrix", tabIndex: 0, children: /* @__PURE__ */ A.jsxs(tSt, { children: [
    /* @__PURE__ */ A.jsx("thead", { children: /* @__PURE__ */ A.jsxs("tr", { children: [
      /* @__PURE__ */ A.jsx("th", { scope: "col", "aria-label": "Rows" }),
      c.columns.map((b, w) => /* @__PURE__ */ A.jsx("th", { scope: "col", id: `${i}-column-${w}`, children: qn(b.text) ?? b.value }, b.id))
    ] }) }),
    /* @__PURE__ */ A.jsx("tbody", { children: c.rows.map((b, w) => /* @__PURE__ */ A.jsxs("tr", { children: [
      /* @__PURE__ */ A.jsx("th", { scope: "row", id: `${i}-row-${w}`, children: qn(b.text) ?? b.value }),
      c.columns.map((C, x) => {
        var k;
        const T = c$(b.id, C.id), E = C.input, R = `${i}-row-${w} ${i}-column-${x}`, I = (k = f[T]) == null ? void 0 : k.value, O = I === void 0 || !Number.isFinite(Number(I)) ? void 0 : Number(I), P = E.type === "number" ? typeof E.suffix == "function" ? E.suffix({ inputValue: O, currentAnswer: n, answers: t }) : E.suffix : void 0;
        return /* @__PURE__ */ A.jsx("td", { children: /* @__PURE__ */ A.jsx(nSt, { children: E.type === "number" ? /* @__PURE__ */ A.jsx(
          Mce,
          {
            ariaLabelledBy: R,
            ariaRequired: e.required,
            value: O,
            min: E.min,
            max: E.max,
            step: E.step,
            suffix: P,
            primaryColour: o,
            onChange: (L) => m(T, L === null ? null : String(L), b, C)
          }
        ) : /* @__PURE__ */ A.jsx(
          hx,
          {
            ariaLabelledBy: R,
            ariaRequired: e.required,
            value: I,
            placeholder: E.placeholder,
            maxLength: E.maxLength,
            primaryColour: o,
            onMaxLengthExceeded: (L) => a.warning(
              `You've reached the character limit of ${L} characters.`
            ),
            onChange: (L) => m(T, L, b, C)
          }
        ) }) }, C.id);
      })
    ] }, b.id)) })
  ] }) });
};
function MI(e, t, n, r) {
  return {
    id: e,
    value: t,
    info: { rowId: n.id, rowValue: n.value, columnId: r.id, columnValue: r.value }
  };
}
const Z_t = ce.div`
  width: 100%;
  min-width: 0;
  overflow-x: auto;
`, eSt = ce(lm)`
  max-width: 64rem;
`, tSt = ce.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  text-align: left;

  th,
  td {
    padding: 0.75rem;
    border-bottom: 1px solid #ddd;
  }

  tbody th {
    min-width: 8rem;
    position: sticky;
    left: 0;
    background: white;
  }
`, nSt = ce.div`
  min-width: 10rem;

  .ant-input,
  .ant-input-number,
  .ant-input-number-group-wrapper {
    width: 100%;
  }
`, rSt = ({
  question: e,
  currentAnswer: t,
  injectCurrent: n,
  submitAnswer: r,
  answers: i,
  settings: o
}) => {
  var w;
  const { loggingService: a, messagerService: s, popupService: c } = gt(mn), { choices: l, ready: u } = yl(
    e.choices,
    i
  );
  Xi(e, (C) => ({
    ...jy(e, C),
    ready: u
  })), a.info("getDefaultChoices", l);
  const d = Wt(() => {
    if (!e.defaultValues)
      return;
    const C = e.defaultValues({ answers: i, choices: l }), x = l.filter(
      (T) => C.some((E) => E === T.id)
    );
    if (x.length !== 0)
      return a.debug("MultiDropdown defaults", C, l, x), x.map((T) => ({
        id: T.id,
        value: T.value
      }));
  }, [e, i, l, a]);
  Qf(d, e, t, i, n);
  const f = () => {
    s.error(
      `Oops, looks like you have tried to select more than ${e.max} answers. To choose another answer, please deselect one of your current choices.`
    );
  }, h = (C) => {
    if (er.isArray(C)) {
      if (e.max && C.length > e.max) {
        f();
        return;
      }
      const x = l.filter((T) => C.includes(T.value)).map((T) => ({ id: T.id, value: T.value }));
      n({
        value: x
      });
    } else
      throw new Error("Dropdown question did not receive an array as a current answer value");
  };
  a.debug("MultiDropdownQuestion: currentAnswer", t);
  const p = (w = t.getValue(e.type)) == null ? void 0 : w.map((C) => C.value);
  a.debug(
    "options as string",
    l.map((C) => String(C.text || C.value))
  );
  const g = e.max ?? l.length, m = {
    notSatisfied: {
      content: `Please select up to ${g} options`,
      position: { top: 1 }
    },
    satisfied: { content: "Click next to continue", position: { top: 1 } },
    notRequired: {
      content: `Please select up to ${g} options or click next to continue`,
      position: { top: 1 }
    }
  }, v = Ms(m, e.helpPopups), y = e.showHelpPopups ?? !1, _ = e.helpPopupsToShow, b = p ?? [];
  return ot(() => {
    e.required ? b.length === 0 || b.length > g ? c.setPopup(v, "notSatisfied", y, _) : c.setPopup(v, "satisfied", y, _) : c.setPopup(v, "notRequired", y, _);
  }, [v, y, _, e.required, b]), /* @__PURE__ */ A.jsx(
    r5,
    {
      options: l.map((C) => {
        const x = C.text ? qn(C.text) : C.value;
        return {
          id: C.id,
          value: C.value,
          label: x
        };
      }),
      value: p,
      onChange: h,
      searchable: e.searchable,
      multiple: !0
    }
  );
}, iSt = ce.input.attrs({ type: "checkbox" })`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;

  &:checked ~ span {
    background-color: ${(e) => e.primaryColour};
  }

  &:checked ~ span:after {
    display: block;
  }
`, oSt = ce.label`
  display: flex;
  align-items: center;
  height: 32px;
  position: relative;
  padding-left: 40px;
  cursor: pointer;
  user-select: none;

  @media (hover: hover) {
    &:hover input ~ span {
      border: 1px solid ${(e) => e.primaryColour};
      box-shadow: 0 0 5px 0px rgba(0, 0, 0, 0.3);
    }
  }
`, aSt = ce.span`
  position: absolute;
  top: 0;
  left: 0;
  height: 32px;
  width: 32px;
  background-color: var(--light);
  border: 1px solid var(--mid);
  border-radius: ${(e) => e.borderRadius};
  transition: all 300ms ease;

  &:after {
    content: '';
    position: absolute;
    display: none;

    left: 11px;
    top: 6px;
    width: 6px;
    height: 12px;
    border: solid var(--light);
    border-width: 0 3px 3px 0;
    transform: rotate(45deg);
  }
`, sSt = ({ label: e, checked: t, onChange: n, primaryColour: r }) => {
  const i = Mi();
  return /* @__PURE__ */ A.jsxs(oSt, { primaryColour: r, borderRadius: i, children: [
    e,
    /* @__PURE__ */ A.jsx(
      iSt,
      {
        primaryColour: r,
        borderRadius: i,
        checked: t,
        onChange: n
      }
    ),
    /* @__PURE__ */ A.jsx(aSt, { primaryColour: r, borderRadius: i })
  ] });
}, kce = ({
  value: e,
  marks: t,
  max: n,
  min: r,
  step: i,
  tipFormatter: o,
  onChange: a,
  vertical: s,
  primaryColor: c,
  sliderStyle: l,
  tooltipPlacement: u
}) => {
  const d = $e(null), [f, h] = j.useState(null), p = No(), g = B4(), m = (y) => {
    typeof y == "number" && a && a(y);
  };
  let v;
  return o == null ? v = o : v = (y) => {
    if (y !== void 0)
      return o(y);
  }, Fa(() => {
    const y = d.current;
    if (y) {
      const _ = y.querySelectorAll(".ant-slider-mark-text");
      if (_.length > 0) {
        let b = 0;
        _.forEach((w) => {
          const C = w.getBoundingClientRect();
          C.height > b && (b = C.height);
        }), h(b);
      }
    }
  }, [f, h, t]), s ? /* @__PURE__ */ A.jsx(go, { theme: g, children: /* @__PURE__ */ A.jsx(cSt, { children: /* @__PURE__ */ A.jsx(
    CR,
    {
      value: e ?? r ?? 0,
      vertical: s,
      marks: t,
      max: n,
      min: r,
      step: i,
      tooltip: { formatter: v, placement: u },
      onChange: m,
      reverse: !0
    }
  ) }) }) : /* @__PURE__ */ A.jsx(go, { theme: g, children: /* @__PURE__ */ A.jsx(lSt, { device: p, marksHeight: f, ref: d, children: /* @__PURE__ */ A.jsx(
    CR,
    {
      value: e ?? r ?? 0,
      vertical: s,
      marks: t,
      max: n,
      min: r,
      step: i,
      tooltip: { formatter: v, placement: u },
      onChange: m
    }
  ) }) });
}, cSt = ce.div`
  height: 50vh;
  margin: 3rem;
  align-self: flex-start;
`, lSt = ce.div`
  width: 100%;
  padding-bottom: ${(e) => e.marksHeight ?? 0}px;
  align-self: center;
  padding-left: ${(e) => e.device === Xn.MOBILE ? "var(--spacing-sm)" : "0"};
  padding-right: ${(e) => e.device === Xn.MOBILE ? "var(--spacing-sm)" : "0"};
`, Nce = ({
  question: e,
  currentAnswer: t,
  answers: n,
  injectCurrent: r,
  updateCurrent: i,
  settings: o,
  setNextButtonBehaviour: a
}) => {
  const { popupService: s, messagerService: c } = gt(mn), { primaryColour: l } = Gn(), u = t.getValue(e.type), { value: d, ready: f } = ju(e.max, { answers: n }), { value: h, ready: p } = ju(e.min, { answers: n });
  let g = d ?? 100, m = h ?? 0;
  Xi(e, (k) => {
    const L = k.convertedToQuestionType("slider").getValue("slider");
    return Rs(
      L ? { slider: L } : null,
      [{ id: "slider", input: { type: "slider", min: h ?? 0, max: d ?? 100 } }],
      p && f
    );
  });
  let v = e.step ?? 1;
  g = kI(g, e.scaleType), m = kI(m, e.scaleType), v = dSt(v, m, g, e.steps, e.scaleType);
  const y = u != null && u.value ? kI(Number(u.value), e.scaleType) : void 0, _ = Dce(
    e.tooltipFormatter,
    e.hideTooltip,
    e.scaleType
  ), b = Qn(e.marks, { answers: n });
  function w(k) {
    return bx(k) && !("label" in k) && !("style" in k);
  }
  let C;
  b && (C = Object.fromEntries(
    Object.entries(b).map(([k, L]) => w(L) ? [k, Cf(L)] : L.label === void 0 ? [k, L] : [k, { label: Cf(L.label), style: L.style }])
  ));
  const x = fSt(C, e.scaleType), T = Wt(() => {
    if (!e.defaultValues)
      return;
    const k = e.defaultValues({ answers: n });
    return { id: k, value: k.toString() };
  }, [e, n]);
  Qf(T, e, t, n, r);
  const E = (k) => {
    const L = uSt(k, e.scaleType), N = {
      id: L,
      value: L.toString()
    };
    r({ value: N });
  };
  ot(() => {
    const k = t.getValue(e.type);
    if (!e.required)
      return;
    a(k !== null ? void 0 : () => {
      const N = { id: e.id, value: m.toString() };
      r({ value: N }), c.warning(
        `It looks like you haven't made any changes to the slider. If you're happy with the placement value, please click "Next" again.`
      );
    });
  }, [e.required, e.type, m, t, r, a]);
  const I = Ms({
    default: {
      content: "Click and drag the slider to select a value, and click next to continue"
    },
    notRequired: {
      content: "Please click and drag the slider to select a value, or click next to continue "
    }
  }, e.helpPopups), O = e.showHelpPopups ?? !1, P = e.helpPopupsToShow;
  return ot(() => {
    e.required ? s.setPopup(I, "default", O, P) : s.setPopup(I, "notRequired", O, P);
  }, [I, O, P, e.required]), /* @__PURE__ */ A.jsx(
    kce,
    {
      value: y,
      vertical: e.vertical,
      marks: x,
      max: g,
      min: m,
      step: v,
      tipFormatter: _,
      onChange: E,
      primaryColor: l,
      tooltipPlacement: e.tooltipPlacement
    }
  );
};
function kI(e, t) {
  if (!t || e === void 0)
    return e;
  switch (t) {
    case "log":
      return Math.log(e);
    case "linear":
      return e;
  }
}
function uSt(e, t) {
  if (!t)
    return e;
  switch (t) {
    case "log":
      return Math.exp(e);
    case "linear":
      return e;
  }
}
function dSt(e, t, n, r = 100, i) {
  if (!i)
    return e;
  switch (i) {
    case "log":
      return (n - t) / r;
    case "linear":
      return e;
  }
}
function Dce(e, t, n) {
  if (t)
    return null;
  if (!n)
    return e;
  switch (n) {
    case "log":
      return (r) => e ? e(Math.exp(r)) : Ile(Math.exp(r), 2);
    case "linear":
      return e;
  }
}
function fSt(e, t) {
  if (!e)
    return {};
  switch (t) {
    case "log":
      return Object.fromEntries(
        Object.entries(e).map(([n, r]) => [Math.log(Number(n)), r])
      );
    case "linear":
    default:
      return Object.fromEntries(Object.entries(e).map(([n, r]) => [parseInt(n), r]));
  }
}
function hSt({
  config: e,
  service: t,
  context: n,
  inputs: r,
  onSuggestions: i
}) {
  const o = tO(), a = $e(null), { session: s, job: c } = Kee(n.questionId, n.profile), [l, u] = Qe([]), [d, f] = Qe(""), h = (c == null ? void 0 : c.status) === "processing", p = c == null ? void 0 : c.message, g = (c == null ? void 0 : c.applied) ?? [];
  ot(() => {
    (c == null ? void 0 : c.status) === "ready" && (s == null || s.apply(n.questionId, n.profile, c.runId, i));
  }, [s, c == null ? void 0 : c.status, c == null ? void 0 : c.runId, n.questionId, n.profile, i]);
  function m() {
    if (h || !s)
      return;
    const { maxFiles: v, maxBytes: y, extensions: _ } = t.limits;
    if (!l.length || l.length > v || l.reduce((b, w) => b + w.size, 0) > y || l.some(
      (b) => !_.some((w) => b.name.toLowerCase().endsWith(w.toLowerCase()))
    ) || new Set(l.map((b) => b.name.toLowerCase())).size !== l.length) {
      f(
        `Choose up to ${v} files (${_.join(", ")}), with different names and no more than ${y / 1024 / 1024} MB total.`
      );
      return;
    }
    try {
      s.start(n, l, e.title ?? "Document suggestions"), f(""), u([]), a.current && (a.current.value = "");
    } catch (b) {
      f(
        b instanceof Error ? b.message : "The files could not be processed. Please try again."
      );
    }
  }
  return s ? /* @__PURE__ */ A.jsxs(gSt, { "aria-label": "Fill answers from documents", children: [
    /* @__PURE__ */ A.jsx("strong", { children: e.title ?? "Fill answers from your records" }),
    /* @__PURE__ */ A.jsx("p", { children: e.description ?? "Upload documents, then check the suggested answers." }),
    /* @__PURE__ */ A.jsx(
      "input",
      {
        ref: a,
        id: o,
        type: "file",
        "aria-label": "Choose files",
        multiple: !0,
        accept: t.limits.extensions.join(","),
        disabled: h,
        onChange: (v) => {
          u(Array.from(v.target.files ?? [])), f("");
        }
      }
    ),
    /* @__PURE__ */ A.jsxs("small", { children: [
      "Up to ",
      t.limits.maxFiles,
      " files, ",
      t.limits.maxBytes / 1024 / 1024,
      " MB total."
    ] }),
    /* @__PURE__ */ A.jsx("button", { type: "button", disabled: h || !l.length, onClick: m, children: h ? "Reading files…" : "Fill answers from files" }),
    e.fileHandlingNotice && /* @__PURE__ */ A.jsx("p", { children: /* @__PURE__ */ A.jsx("small", { children: /* @__PURE__ */ A.jsx("i", { children: e.fileHandlingNotice }) }) }),
    p && /* @__PURE__ */ A.jsx("p", { role: "status", children: p }),
    (d || (c == null ? void 0 : c.error)) && /* @__PURE__ */ A.jsx("p", { role: "alert", children: d || (c == null ? void 0 : c.error) }),
    g.length > 0 && /* @__PURE__ */ A.jsxs("details", { children: [
      /* @__PURE__ */ A.jsx("summary", { children: "See sources for the filled answers" }),
      g.map((v) => {
        var y;
        return /* @__PURE__ */ A.jsxs("div", { children: [
          /* @__PURE__ */ A.jsxs("strong", { children: [
            qn(
              ((y = r.find((_) => _.id === v.inputId)) == null ? void 0 : y.label) ?? v.inputId
            ),
            ": ",
            v.value.toFixed(v.decimalPlaces)
          ] }),
          /* @__PURE__ */ A.jsx("p", { children: v.explanation }),
          /* @__PURE__ */ A.jsx("ul", { children: v.sources.map((_, b) => /* @__PURE__ */ A.jsxs("li", { children: [
            _.filename,
            " — ",
            _.location,
            _.excerpt && `: ${_.excerpt}`
          ] }, b)) })
        ] }, v.inputId);
      })
    ] })
  ] }) : null;
}
const gSt = ce.section`
  box-sizing: border-box;
  padding: 1rem;
  border: 1px solid #a4b88d;
  border-radius: 8px;
  background: #f6f9f1;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  p {
    margin: 0;
  }
  input {
    max-width: 100%;
  }
  button {
    align-self: flex-start;
    padding: 0.6rem 1rem;
    cursor: pointer;
  }
  button:disabled {
    cursor: default;
  }
  [role='alert'] {
    color: #a32121;
  }
  details {
    overflow-wrap: anywhere;
  }
  summary {
    cursor: pointer;
  }
  details > div {
    margin-top: 1rem;
  }
`;
function pSt(e, t, n, r, i) {
  let o = [...e];
  const a = [], s = /* @__PURE__ */ new Set();
  for (const c of t) {
    const l = n.find((u) => u.id === c.inputId);
    if (!l || l.type !== "number" || s.has(l.id) || !Number.isFinite(c.value) || !Number.isInteger(c.decimalPlaces) || c.decimalPlaces < 0 || c.decimalPlaces > 8 || l.min !== void 0 && c.value < l.min || l.max !== void 0 && c.value > l.max)
      throw new Error("The suggested values do not match this question.");
    s.add(l.id);
  }
  for (const c of t) {
    const l = o.find((d) => d.id === c.inputId);
    if (r.has(c.inputId) || l != null && l.value.trim())
      continue;
    const u = {
      ...l,
      id: c.inputId,
      value: c.value.toFixed(c.decimalPlaces)
    };
    o = o.filter((d) => d.id !== u.id).concat(u), i && (o = i(u, o)), a.push(c);
  }
  return { values: o, applied: a };
}
const mSt = ({
  question: e,
  currentAnswer: t,
  injectCurrent: n,
  submitAnswer: r,
  answers: i,
  settings: o
}) => {
  var m;
  const { primaryColour: a } = Gn(), { documentExtractionService: s } = gt(mn), c = uf((v) => v.survey.submissionId), { session: l } = Kee(
    e.id,
    ((m = e.documentPrefill) == null ? void 0 : m.profile) ?? ""
  ), { value: u, ready: d } = ju(e.inputs, {
    answers: i
  }), f = u ?? [];
  Xi(
    e,
    (v) => LVe(v.getValue("multiInput"), f, d)
  ), Dy($le(f), t, n);
  const h = Wt(() => {
    if (e.defaultValues)
      return e.defaultValues({ answers: i });
  }, [e, i]);
  Qf(h, e, t, i, n);
  function p(v) {
    var y;
    if (!(t.getValue(e.type) === null || !er.isArray(t.getValue(e.type))))
      return (y = t.getValue(e.type)) == null ? void 0 : y.find((_) => _.id === v);
  }
  function g(v, y) {
    var _;
    if (l == null || l.markEdited(e.id, y.id), t.getValue(e.type)) {
      const b = ((_ = t.getValue(e.type)) == null ? void 0 : _.filter((w) => w.id !== y.id)) || [];
      if (er.isNull(v))
        n({ value: b, validity: H1(b, f) });
      else {
        let w = b.concat([
          { id: y.id, value: v }
        ]);
        e.answerModifier && (w = e.answerModifier({ id: y.id, value: v }, w)), n({ value: w, validity: H1(w, f) });
      }
    } else {
      if (er.isNull(v))
        return;
      {
        let b = [{ id: y.id, value: v }];
        e.answerModifier && (b = e.answerModifier({ id: y.id, value: v }, b)), n({ value: b, validity: H1(b, f) });
      }
    }
  }
  return /* @__PURE__ */ A.jsxs(TSt, { children: [
    e.documentPrefill && s && c && f.length > 0 && f.every((v) => v.type === "number") && /* @__PURE__ */ A.jsx(
      hSt,
      {
        config: e.documentPrefill,
        service: s,
        context: {
          surveyName: o.surveyName,
          submissionId: c,
          questionId: e.id,
          profile: e.documentPrefill.profile
        },
        inputs: f,
        onSuggestions: (v, y, _) => {
          const { values: b, applied: w } = pSt(
            _,
            v,
            f,
            y,
            e.answerModifier
          );
          return w.length && n({ value: b, validity: H1(b, f) }), w;
        }
      },
      `${e.id}:${e.documentPrefill.profile}:${c}`
    ),
    f.map((v) => /* @__PURE__ */ A.jsx(
      vSt,
      {
        input: v,
        getAnswerValue: p,
        updateAnswerValue: g,
        currentAnswer: t,
        answers: i,
        primaryColour: a,
        question: e
      },
      v.id
    ))
  ] });
};
function vSt({
  input: e,
  getAnswerValue: t,
  updateAnswerValue: n,
  currentAnswer: r,
  answers: i,
  primaryColour: o,
  question: a
}) {
  const { shadeColour: s } = Gn();
  switch (e.type) {
    case "slider":
      return /* @__PURE__ */ A.jsx(Us, { children: /* @__PURE__ */ A.jsx(
        ySt,
        {
          input: e,
          getAnswerValue: t,
          updateAnswerValue: n,
          currentAnswer: r,
          answers: i,
          primaryColour: o,
          sliderStyle: e.sliderStyle
        }
      ) }, e.id);
    case "number":
      return /* @__PURE__ */ A.jsx(Us, { layout: a.layout, children: /* @__PURE__ */ A.jsx(
        bSt,
        {
          input: e,
          getAnswerValue: t,
          updateAnswerValue: n,
          currentAnswer: r,
          answers: i,
          primaryColour: o
        }
      ) }, e.id);
    case "text":
      return /* @__PURE__ */ A.jsx(Us, { layout: a.layout, children: /* @__PURE__ */ A.jsx(
        pH,
        {
          input: e,
          getAnswerValue: t,
          updateAnswerValue: n,
          currentAnswer: r,
          answers: i,
          primaryColour: o
        }
      ) }, e.id);
    case "email":
      return /* @__PURE__ */ A.jsx(Us, { layout: a.layout, children: /* @__PURE__ */ A.jsx(
        pH,
        {
          input: e,
          getAnswerValue: t,
          updateAnswerValue: n,
          currentAnswer: r,
          answers: i,
          textInputType: "email",
          primaryColour: o
        }
      ) }, e.id);
    case "dropdown":
      return /* @__PURE__ */ A.jsx(Us, { layout: a.layout, children: /* @__PURE__ */ A.jsx(
        _St,
        {
          input: e,
          getAnswerValue: t,
          updateAnswerValue: n,
          currentAnswer: r,
          answers: i,
          primaryColour: o,
          shadeColour: a.shade ? s : void 0
        }
      ) }, e.id);
    case "commentBox":
      return /* @__PURE__ */ A.jsx(Us, { layout: a.layout, children: /* @__PURE__ */ A.jsx(
        SSt,
        {
          input: e,
          getAnswerValue: t,
          updateAnswerValue: n,
          currentAnswer: r,
          answers: i,
          primaryColour: o
        }
      ) }, e.id);
    case "checkbox":
      return /* @__PURE__ */ A.jsx(Us, { layout: a.layout, children: /* @__PURE__ */ A.jsx(
        wSt,
        {
          input: e,
          getAnswerValue: t,
          updateAnswerValue: n,
          currentAnswer: r,
          answers: i,
          primaryColour: o
        }
      ) }, e.id);
    case "label-only":
      return /* @__PURE__ */ A.jsx(Us, { layout: a.layout, children: /* @__PURE__ */ A.jsx(ch, { ...e }) }, e.id);
    case "matrix-row":
      return /* @__PURE__ */ A.jsx(Us, { layout: a.layout, children: /* @__PURE__ */ A.jsx(
        xSt,
        {
          input: e,
          getAnswerValue: t,
          updateAnswerValue: n,
          currentAnswer: r,
          answers: i,
          primaryColour: o
        }
      ) }, e.id);
    default:
      return /* @__PURE__ */ A.jsxs(Us, { layout: a.layout, children: [
        "Input type ",
        e.type,
        " not implemented"
      ] }, e.id);
  }
}
function ySt({
  input: e,
  getAnswerValue: t,
  updateAnswerValue: n,
  primaryColour: r
}) {
  var u;
  const i = (u = t(e.id)) == null ? void 0 : u.value, o = i ? parseFloat(i) : void 0, a = Qn(e.marks, void 0);
  function s(d) {
    return bx(d) && !("label" in d) && !("style" in d);
  }
  let c;
  a && (c = Object.fromEntries(
    Object.entries(a).map(([d, f]) => s(f) ? [d, Cf(f)] : f.label === void 0 ? [d, f] : [d, { label: Cf(f.label), style: f.style }])
  ));
  const l = Dce(e.tooltipFormatter, e.hideTooltip, e.scaleType);
  return /* @__PURE__ */ A.jsxs(A.Fragment, { children: [
    /* @__PURE__ */ A.jsx(ch, { ...e }),
    /* @__PURE__ */ A.jsx(
      kce,
      {
        value: o,
        min: e.min,
        max: e.max,
        step: e.step,
        marks: c,
        onChange: (d) => n(d.toString(), e),
        primaryColor: r,
        tipFormatter: l,
        sliderStyle: e.sliderStyle
      }
    ),
    e.displayValue && /* @__PURE__ */ A.jsx("div", { children: e.displayValue(o) })
  ] });
}
function bSt({
  input: e,
  getAnswerValue: t,
  updateAnswerValue: n,
  currentAnswer: r,
  answers: i,
  primaryColour: o
}) {
  var l;
  const a = (l = t(e.id)) == null ? void 0 : l.value, s = a ? parseFloat(a) : void 0;
  let c;
  return typeof e.suffix == "function" ? c = e.suffix({ inputValue: s, currentAnswer: r, answers: i }) : c = e.suffix || "", /* @__PURE__ */ A.jsxs(A.Fragment, { children: [
    /* @__PURE__ */ A.jsx(ch, { ...e }),
    /* @__PURE__ */ A.jsx(
      Mce,
      {
        value: s,
        step: e.step,
        min: e.min,
        max: e.max,
        onChange: (u) => {
          const d = er.isUndefined(u) || er.isNull(u) ? null : u.toString();
          return n(d, e);
        },
        suffix: c,
        primaryColour: o
      }
    )
  ] });
}
function pH({
  input: e,
  textInputType: t,
  getAnswerValue: n,
  updateAnswerValue: r,
  primaryColour: i
}) {
  var s;
  const o = (s = n(e.id)) == null ? void 0 : s.value, { messagerService: a } = gt(mn);
  return /* @__PURE__ */ A.jsxs(A.Fragment, { children: [
    /* @__PURE__ */ A.jsx(ch, { ...e }),
    /* @__PURE__ */ A.jsx(
      hx,
      {
        value: o,
        onChange: (c) => r(c, e),
        type: t,
        primaryColour: i,
        placeholder: e.placeholder,
        maxLength: e.maxLength,
        onMaxLengthExceeded: (c) => {
          a.warning(`You've reached the character limit of ${c} characters.`);
        }
      }
    )
  ] });
}
function _St({
  input: e,
  answers: t,
  updateAnswerValue: n,
  getAnswerValue: r,
  primaryColour: i,
  shadeColour: o
}) {
  var l;
  const a = Uee(e.choices ?? [], t), s = (u) => {
    if (er.isArray(u))
      throw new Error("Dropdown question received an array as a current answer value");
    return n(u.toString(), e);
  }, c = (l = r(e.id)) == null ? void 0 : l.value;
  return /* @__PURE__ */ A.jsxs(A.Fragment, { children: [
    /* @__PURE__ */ A.jsx(ch, { ...e }),
    /* @__PURE__ */ A.jsx(
      r5,
      {
        value: c,
        options: a.map((u) => {
          const d = u.text ? qn(u.text) : u.value;
          return {
            id: u.id,
            value: u.value,
            label: d
          };
        }),
        onChange: (u) => s(u)
      }
    )
  ] });
}
function SSt({
  input: e,
  textInputType: t,
  getAnswerValue: n,
  updateAnswerValue: r,
  primaryColour: i,
  currentAnswer: o
}) {
  var c;
  const a = ((c = n(e.id)) == null ? void 0 : c.value) ?? "", { messagerService: s } = gt(mn);
  return /* @__PURE__ */ A.jsxs(A.Fragment, { children: [
    /* @__PURE__ */ A.jsx(ch, { ...e }),
    /* @__PURE__ */ A.jsx(
      z4,
      {
        dynamicColour: i,
        value: a,
        onChange: (l) => {
          const u = l.target.value;
          r(u, e);
        },
        placeholder: e.placeholder,
        maxLength: e.maxLength,
        onMaxLengthExceeded: (l) => {
          s.warning(`You've reached the character limit of ${l} characters.`);
        }
      }
    )
  ] });
}
function wSt({
  input: e,
  textInputType: t,
  getAnswerValue: n,
  updateAnswerValue: r,
  primaryColour: i,
  currentAnswer: o
}) {
  var s;
  const a = ((s = n(e.id)) == null ? void 0 : s.value) ?? "";
  return /* @__PURE__ */ A.jsx(A.Fragment, { children: /* @__PURE__ */ A.jsx(
    sSt,
    {
      label: qn(e.label),
      checked: a === "true",
      onChange: (c) => r(c.target.checked.toString(), e),
      primaryColour: i
    }
  ) });
}
function xSt({
  input: e,
  getAnswerValue: t,
  updateAnswerValue: n,
  answers: r,
  primaryColour: i,
  shadeColour: o
}) {
  const a = No(), s = Uee(e.choices ?? [], r), c = s.some((l) => !!l.image);
  return /* @__PURE__ */ A.jsxs(A.Fragment, { children: [
    /* @__PURE__ */ A.jsx(ch, { ...e }),
    /* @__PURE__ */ A.jsx(ISt, { children: /* @__PURE__ */ A.jsx(
      $St,
      {
        $device: a,
        $hasChoiceImages: c,
        $numChoices: s.length,
        children: s.map((l) => {
          var u;
          return /* @__PURE__ */ A.jsx(
            ESt,
            {
              choice: l,
              primaryColour: i,
              shadeColour: l.fill ?? o,
              active: ((u = t(e.id)) == null ? void 0 : u.value) === l.value,
              onClick: () => n(l.value, e),
              hasChoiceImages: c
            },
            l.id
          );
        })
      }
    ) })
  ] });
}
const ESt = ({
  choice: e,
  primaryColour: t,
  shadeColour: n,
  active: r,
  onClick: i,
  hasChoiceImages: o
}) => {
  let a = /* @__PURE__ */ A.jsx(
    $ce,
    {
      primaryColour: t,
      shadeColour: n,
      active: r,
      onClick: i,
      label: e.text ? qn(e.text) : e.value,
      image: e.image,
      imageAlt: e.imageAlt || e.value,
      stacked: o
    }
  );
  return e.toolTip && (a = /* @__PURE__ */ A.jsx(_2, { placement: "topLeft", title: e.toolTip, children: a })), a;
};
function ch(e) {
  const t = Qn(e.tooltip, void 0), n = Cf(e.label);
  return t ? /* @__PURE__ */ A.jsx(mH, { children: /* @__PURE__ */ A.jsx(_2, { title: t, children: n }) }) : /* @__PURE__ */ A.jsx(mH, { children: n });
}
function H1(e, t) {
  return er.isNull(e) ? { valid: !1, messages: ["This question requires an answer"] } : e.every((n) => n.value.length > 0) && e.length === t.length ? CSt(e, t) : {
    valid: !1,
    messages: ["All questions on this page require an answer"]
  };
}
function CSt(e, t) {
  const n = [];
  return { valid: t.every((i) => {
    const o = e.find((a) => a.id === i.id);
    switch (i.type) {
      case "text":
      case "number":
      case "slider":
        break;
      case "email":
        if (!o || !GH(o.value))
          return n.push("Please enter a valid email address"), !1;
    }
    return !0;
  }), messages: n };
}
const TSt = ce.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 1rem;
`, Us = ce.div`
  display: flex;
  gap: 0.5rem;
  flex-direction: ${(e) => e.layout === "beside" ? "row" : "column"};
  align-items: stretch;
`, mH = ce.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`, ISt = ce.div`
  word-wrap: break-word;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`, $St = ce.div`
  display: ${({ $hasChoiceImages: e }) => e ? "grid" : "flex"};
  justify-content: ${({ $hasChoiceImages: e }) => e ? "initial" : "space-between"};
  gap: 0.5rem;
  flex-direction: ${({ $device: e, $hasChoiceImages: t }) => t ? "initial" : e === Xn.MOBILE ? "column" : "row"};
  grid-template-columns: ${({ $device: e, $hasChoiceImages: t, $numChoices: n }) => t ? e === Xn.MOBILE ? "minmax(0, 1fr)" : `repeat(${Math.max(n, 1)}, minmax(0, 1fr))` : "none"};
`, U4 = (e) => {
  const {
    inputValue: t,
    onValueChange: n,
    label: r,
    placeholder: i,
    type: o,
    shadeColour: a,
    primaryColour: s,
    active: c,
    noBorder: l,
    maxLength: u,
    onMaxLengthExceeded: d
  } = e, f = Mi(), h = $e(!1), p = Wt(
    (g) => {
      u && g.target.value.length > u ? (g.target.value = g.target.value.slice(0, u), !h.current && d && (d(u), h.current = !0)) : h.current && u && g.target.value.length < u && (h.current = !1), n(g);
    },
    [u, d, n]
  );
  return /* @__PURE__ */ A.jsxs(
    ASt,
    {
      dynamicColour: s,
      shadeColour: a,
      borderRadius: f,
      active: c,
      noBorder: l,
      children: [
        /* @__PURE__ */ A.jsx(
          "input",
          {
            type: o ?? "text",
            placeholder: i,
            value: t,
            onChange: p
          }
        ),
        /* @__PURE__ */ A.jsx("hr", {}),
        /* @__PURE__ */ A.jsx("label", { children: r })
      ]
    }
  );
}, ASt = ce.fieldset`
  height: var(--text-input-height);
  width: 100%;
  position: relative;
  padding: 0;
  border: none;
  overflow: visible;

  input {
    box-sizing: border-box;
    width: inherit;
    height: inherit;
    border-radius: ${(e) => e.borderRadius};
    padding: var(--spacing-sm) var(--spacing-sm) var(--spacing-xs);
    box-shadow: none;
    border-style: ${(e) => e.noBorder ? "none" : "solid"};
    border-width: ${(e) => e.active ? "2px" : "1px"};
    border-color: ${(e) => e.active ? e.dynamicColour : "var(--mid)"};
    background-color: ${(e) => e.active ? "var(--light)" : e.shadeColour ? e.shadeColour : "var(--light)"};
    font-size: var(--choice-text-font-size);
    outline: none;
    cursor: text;

    @media (hover: hover) {
      &:hover {
        border-color: ${(e) => e.dynamicColour};
        box-shadow: 0 0 5px 0px rgba(0, 0, 0, 0.3);
        animation: none;
      }
    }
    &:focus {
      border-color: ${(e) => e.dynamicColour};
      border-width: 2px;
    }

    &::-moz-placeholder {
      transition: color 300ms ease;
    }
    &:not(:focus)::-moz-input-placeholder {
      color: transparent;
    }

    &::-webkit-input-placeholder {
      transition: color 300ms ease;
    }
    &:not(:focus)::-webkit-input-placeholder {
      color: transparent;
    }
  }

  hr {
    content: '';
    display: block;
    position: absolute;
    bottom: var(--spacing-sm);
    left: ${(e) => e.borderRadius};
    margin: 0;
    padding: 0;
    width: calc(100% - 2 * ${(e) => e.borderRadius});
    height: 2px;
    border: none;
    /* background: ${(e) => e.dynamicColour}; */
    background: var(--mid);
    font-size: 1px;
    will-change: transform, visibility;
    transition: all 200ms ease-out;
    transform: scaleX(0);
    visibility: hidden;
    z-index: 10;
  }
  input:focus ~ hr {
    transform: scaleX(1);
    visibility: visible;
  }

  label {
    position: absolute;
    top: var(--spacing-xxs);
    left: var(--spacing-sm);
    font-size: var(--text-input-label-font-size);
    color: var(--dark);
    pointer-events: none;
  }
`;
function RSt(e) {
  return Array(e).fill(`${100 / e}%`).join(" ");
}
function PSt(e, t) {
  return t === Xn.MOBILE ? 1 : e || 1;
}
const OSt = ce.div`
  display: grid;
  grid-template-columns: ${(e) => RSt(e.numColumns)};
  column-gap: 0.5rem;
  row-gap: 0.5rem;
`, jce = (e) => {
  const { children: t, numColumns: n } = e, r = No(), i = PSt(n, r), o = (t == null ? void 0 : t.length) || 1, a = Math.ceil(o / i);
  return /* @__PURE__ */ A.jsx(OSt, { numColumns: i, numRows: a, children: t });
}, MSt = ({
  question: e,
  answers: t,
  currentAnswer: n,
  settings: r,
  submitAnswer: i,
  updateCurrent: o,
  injectCurrent: a
}) => {
  const { loggingService: s, messagerService: c, popupService: l } = gt(mn), u = n == null ? void 0 : n.getValue(e.type), { choices: d, ready: f } = yl(
    e.choices,
    t
  );
  Xi(e, (w) => ({
    ...jy(e, w),
    ready: f
  })), Dy(JP(d), n, a);
  const h = Wt(() => {
    if (s.info("getDefaultChoices", d), !e.defaultValues)
      return;
    const w = e.defaultValues({ answers: t, choices: d }), C = d.filter(
      (x) => w.some((T) => T === x.id)
    );
    if (C.length !== 0)
      return s.debug("MultiSelect defaults", w, d, C), C.map((x) => ({
        id: x.id,
        value: x.value
      }));
  }, [e, t, d, s]);
  Qf(h, e, n, t, a);
  const p = () => {
    c.error(
      `Oops, looks like you have tried to select more than ${e.max} answers. Clicking a selected answer again removes it from selection.`
    );
  }, g = e.min ?? 1, m = e.max ?? d.length, v = {
    notSatisfied: { content: `Please select between ${g} to ${m} options` },
    satisfied: { content: "Click next to continue" },
    notRequired: {
      content: `Please select between ${g} to ${m} options or click next to continue`
    }
  }, y = Ms(v, e.helpPopups), _ = e.showHelpPopups ?? !1, b = e.helpPopupsToShow;
  return ot(() => {
    e.required ? u === null || u.length < g || u.length > m ? l.setPopup(y, "notSatisfied", _, b) : l.setPopup(y, "satisfied", _, b) : l.setPopup(y, "notRequired", _, b);
  }, [y, _, b, e.required, u, g, m]), /* @__PURE__ */ A.jsx(jce, { settings: r, numColumns: e.numColumns, children: d.map((w) => /* @__PURE__ */ A.jsx(
    kSt,
    {
      choice: w,
      currentAnswerValue: u,
      injectCurrent: a,
      submitAnswer: i,
      maxChoices: e.max,
      noAutoNext: e.noAutoNext ?? !1,
      onTooMany: p,
      shadeButton: e.shade ?? !1
    },
    w.id
  )) });
};
function kSt(e) {
  switch (e.choice.type) {
    case "input":
      return /* @__PURE__ */ A.jsx(NSt, { ...e });
    default:
      return /* @__PURE__ */ A.jsx(DSt, { ...e });
  }
}
function NSt({
  choice: e,
  currentAnswerValue: t,
  injectCurrent: n,
  onTooMany: r,
  maxChoices: i,
  shadeButton: o
}) {
  const { primaryColour: a, shadeColour: s } = Gn(), { messagerService: c } = gt(mn), l = (u, d) => {
    const f = u.target.value, h = t ?? [], p = h.some((m) => m.id === d.id);
    let g;
    f === "" ? (g = h.filter((m) => m.id !== d.id), n({ value: g })) : i && i === h.length && !p ? r() : (g = [
      ...h.filter((m) => {
        var v;
        return !((v = m.info) != null && v.submit);
      }).filter((m) => m.id !== d.id),
      {
        id: d.id,
        value: `${d.value}: ${f}`,
        info: { rawValue: f }
      }
    ], n({ value: g }));
  };
  return /* @__PURE__ */ A.jsx(
    U4,
    {
      type: "text",
      active: Lce(e, t),
      inputValue: jSt(e, t),
      onValueChange: (u) => l(u, e),
      label: e.text ? qn(e.text) : e.value,
      placeholder: e.placeholder,
      maxLength: e.maxLength,
      onMaxLengthExceeded: (u) => {
        c.warning(`You've reached the character limit of ${u} characters.`);
      },
      primaryColour: a,
      shadeColour: o ? s : void 0
    },
    e.id
  );
}
function DSt({
  choice: e,
  currentAnswerValue: t,
  injectCurrent: n,
  submitAnswer: r,
  maxChoices: i,
  noAutoNext: o,
  onTooMany: a,
  shadeButton: s
}) {
  var f;
  const { primaryColour: c, shadeColour: l } = Gn(), u = (h) => {
    const p = t || [];
    let g;
    h.submit ? (g = [{ id: h.id, value: h.value, info: { submit: !0 } }], n({ value: g }), o || r()) : p.some((m) => m.id === h.id) ? (g = p.filter((m) => m.id !== h.id), n({ value: g })) : i && p.length >= i ? a() : (g = p.filter((m) => {
      var v;
      return !((v = m.info) != null && v.submit);
    }).concat([{ id: h.id, value: h.value }]), n({ value: g }));
  };
  let d = s ? l : void 0;
  return (f = e.style) != null && f.backgroundColor && (d = e.style.backgroundColor), /* @__PURE__ */ A.jsx(_2, { title: e.toolTip, children: /* @__PURE__ */ A.jsx(
    cx,
    {
      active: Lce(e, t),
      colour: c,
      shadeColour: d,
      buttonText: e.text ? qn(e.text) : e.value,
      ButtonIcon: e.icon,
      fill: e.fill,
      onClick: (h) => {
        u(e), Su(h);
      },
      showInactiveCircle: !e.submit
    },
    e.id
  ) });
}
function Lce(e, t) {
  return !!t && t.some((n) => n.id === e.id);
}
function jSt(e, t) {
  var r, i;
  const n = t ? (i = (r = t.find((o) => o.id === e.id)) == null ? void 0 : r.info) == null ? void 0 : i.rawValue : "";
  return n ? n.toString() : "";
}
function LSt({
  question: e,
  answers: t,
  currentAnswer: n,
  injectCurrent: r
}) {
  var g;
  const i = Wt(async () => {
    const [m, v] = await Promise.all([
      typeof e.statements == "function" ? e.statements({ answers: t }) : e.statements,
      typeof e.choices == "function" ? e.choices({ answers: t }) : e.choices
    ]);
    return { question: e, answers: t, statements: m, choices: v };
  }, [e, t]), o = Qn(i, {}), a = (o == null ? void 0 : o.question) === e && (o == null ? void 0 : o.answers) === t;
  Xi(
    e,
    (m) => Rs(
      m.getValue("multiSelectMatrix"),
      ((o == null ? void 0 : o.statements) ?? []).map((v) => ({ id: v.id })),
      a
    )
  );
  const s = n.getAnswer(), c = n.getValue("multiSelectMatrix"), l = a && o && c === null && !(e.id in t.raw()) ? (g = e.defaultValues) == null ? void 0 : g.call(e, { answers: t, statements: o.statements, choices: o.choices }) : void 0, u = c === null ? l ?? {} : Object.fromEntries(
    Object.entries(c).map(([m, v]) => [m, v.map((y) => y.id)])
  ), d = a && o ? yN(o.statements, o.choices, u) : c ?? {}, f = a && o ? Ble(s.multiSelectMatrixCells, o.statements, o.choices) : s.multiSelectMatrixCells, h = a && o ? bN(d, o.statements, e.required === !0) : { valid: !1, messages: ["Loading options…"] };
  if (ot(() => {
    if (s.questionId !== e.id)
      return;
    const m = c === null && Object.keys(d).length === 0 ? null : d;
    a && (!ac.isEqual(c, m) || !ac.isEqual(s.multiSelectMatrixCells, f)) ? r({ value: m, multiSelectMatrixCells: f, validity: h }) : ac.isEqual(s.validity, h) || r({ validity: h });
  }, [
    s.questionId,
    s.multiSelectMatrixCells,
    s.validity,
    e.id,
    c,
    d,
    f,
    h,
    a,
    r
  ]), !a || !o)
    return /* @__PURE__ */ A.jsx("p", { role: "status", children: "Loading options…" });
  const p = (m, v) => {
    const y = Array.isArray(d[m.id]) ? d[m.id] : [], _ = y.some((w) => w.id === v.id) ? y.filter((w) => w.id !== v.id).map((w) => w.id) : v.submit ? [v.id] : [
      ...y.filter((w) => {
        var C;
        return !((C = w.info) != null && C.submit);
      }).map((w) => w.id),
      v.id
    ], b = yN(o.statements, o.choices, {
      ...u,
      [m.id]: _
    });
    r({
      value: b,
      multiSelectMatrixCells: f,
      validity: bN(b, o.statements, e.required === !0)
    });
  };
  return /* @__PURE__ */ A.jsx(
    Ace,
    {
      questionId: e.id,
      statements: o.statements,
      choices: o.choices,
      layout: e.layout,
      tableOptions: e.tableOptions,
      multiple: !0,
      shade: e.shade,
      mobileColumns: e.mobileColumns,
      isSelected: (m, v) => Array.isArray(d[m.id]) && d[m.id].some((y) => y.id === v.id),
      onSelect: p
    }
  );
}
var Fce = { exports: {} };
/**!
 * Sortable 1.15.3
 * @author	RubaXa   <trash@rubaxa.org>
 * @author	owenm    <owen23355@gmail.com>
 * @license MIT
 */
function vH(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Tc(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? vH(Object(n), !0).forEach(function(r) {
      FSt(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : vH(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function A_(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? A_ = function(t) {
    return typeof t;
  } : A_ = function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, A_(e);
}
function FSt(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function Ka() {
  return Ka = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ka.apply(this, arguments);
}
function VSt(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), i, o;
  for (o = 0; o < r.length; o++)
    i = r[o], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
function BSt(e, t) {
  if (e == null)
    return {};
  var n = VSt(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function zSt(e) {
  return HSt(e) || USt(e) || WSt(e) || qSt();
}
function HSt(e) {
  if (Array.isArray(e))
    return WP(e);
}
function USt(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function WSt(e, t) {
  if (e) {
    if (typeof e == "string")
      return WP(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return WP(e, t);
  }
}
function WP(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function qSt() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var GSt = "1.15.3";
function sl(e) {
  if (typeof window < "u" && window.navigator)
    return !!/* @__PURE__ */ navigator.userAgent.match(e);
}
var Al = sl(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i), Eb = sl(/Edge/i), yH = sl(/firefox/i), Q0 = sl(/safari/i) && !sl(/chrome/i) && !sl(/android/i), Vce = sl(/iP(ad|od|hone)/i), Bce = sl(/chrome/i) && sl(/android/i), zce = {
  capture: !1,
  passive: !1
};
function bn(e, t, n) {
  e.addEventListener(t, n, !Al && zce);
}
function pn(e, t, n) {
  e.removeEventListener(t, n, !Al && zce);
}
function gx(e, t) {
  if (t) {
    if (t[0] === ">" && (t = t.substring(1)), e)
      try {
        if (e.matches)
          return e.matches(t);
        if (e.msMatchesSelector)
          return e.msMatchesSelector(t);
        if (e.webkitMatchesSelector)
          return e.webkitMatchesSelector(t);
      } catch {
        return !1;
      }
    return !1;
  }
}
function Hce(e) {
  return e.host && e !== document && e.host.nodeType ? e.host : e.parentNode;
}
function ja(e, t, n, r) {
  if (e) {
    n = n || document;
    do {
      if (t != null && (t[0] === ">" ? e.parentNode === n && gx(e, t) : gx(e, t)) || r && e === n)
        return e;
      if (e === n)
        break;
    } while (e = Hce(e));
  }
  return null;
}
var bH = /\s+/g;
function Dr(e, t, n) {
  if (e && t)
    if (e.classList)
      e.classList[n ? "add" : "remove"](t);
    else {
      var r = (" " + e.className + " ").replace(bH, " ").replace(" " + t + " ", " ");
      e.className = (r + (n ? " " + t : "")).replace(bH, " ");
    }
}
function At(e, t, n) {
  var r = e && e.style;
  if (r) {
    if (n === void 0)
      return document.defaultView && document.defaultView.getComputedStyle ? n = document.defaultView.getComputedStyle(e, "") : e.currentStyle && (n = e.currentStyle), t === void 0 ? n : n[t];
    !(t in r) && t.indexOf("webkit") === -1 && (t = "-webkit-" + t), r[t] = n + (typeof n == "string" ? "" : "px");
  }
}
function af(e, t) {
  var n = "";
  if (typeof e == "string")
    n = e;
  else
    do {
      var r = At(e, "transform");
      r && r !== "none" && (n = r + " " + n);
    } while (!t && (e = e.parentNode));
  var i = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
  return i && new i(n);
}
function Uce(e, t, n) {
  if (e) {
    var r = e.getElementsByTagName(t), i = 0, o = r.length;
    if (n)
      for (; i < o; i++)
        n(r[i], i);
    return r;
  }
  return [];
}
function bc() {
  var e = document.scrollingElement;
  return e || document.documentElement;
}
function br(e, t, n, r, i) {
  if (!(!e.getBoundingClientRect && e !== window)) {
    var o, a, s, c, l, u, d;
    if (e !== window && e.parentNode && e !== bc() ? (o = e.getBoundingClientRect(), a = o.top, s = o.left, c = o.bottom, l = o.right, u = o.height, d = o.width) : (a = 0, s = 0, c = window.innerHeight, l = window.innerWidth, u = window.innerHeight, d = window.innerWidth), (t || n) && e !== window && (i = i || e.parentNode, !Al))
      do
        if (i && i.getBoundingClientRect && (At(i, "transform") !== "none" || n && At(i, "position") !== "static")) {
          var f = i.getBoundingClientRect();
          a -= f.top + parseInt(At(i, "border-top-width")), s -= f.left + parseInt(At(i, "border-left-width")), c = a + o.height, l = s + o.width;
          break;
        }
      while (i = i.parentNode);
    if (r && e !== window) {
      var h = af(i || e), p = h && h.a, g = h && h.d;
      h && (a /= g, s /= p, d /= p, u /= g, c = a + u, l = s + d);
    }
    return {
      top: a,
      left: s,
      bottom: c,
      right: l,
      width: d,
      height: u
    };
  }
}
function _H(e, t, n) {
  for (var r = cu(e, !0), i = br(e)[t]; r; ) {
    var o = br(r)[n], a = void 0;
    if (n === "top" || n === "left" ? a = i >= o : a = i <= o, !a)
      return r;
    if (r === bc())
      break;
    r = cu(r, !1);
  }
  return !1;
}
function Sp(e, t, n, r) {
  for (var i = 0, o = 0, a = e.children; o < a.length; ) {
    if (a[o].style.display !== "none" && a[o] !== Ut.ghost && (r || a[o] !== Ut.dragged) && ja(a[o], n.draggable, e, !1)) {
      if (i === t)
        return a[o];
      i++;
    }
    o++;
  }
  return null;
}
function W4(e, t) {
  for (var n = e.lastElementChild; n && (n === Ut.ghost || At(n, "display") === "none" || t && !gx(n, t)); )
    n = n.previousElementSibling;
  return n || null;
}
function Gr(e, t) {
  var n = 0;
  if (!e || !e.parentNode)
    return -1;
  for (; e = e.previousElementSibling; )
    e.nodeName.toUpperCase() !== "TEMPLATE" && e !== Ut.clone && (!t || gx(e, t)) && n++;
  return n;
}
function SH(e) {
  var t = 0, n = 0, r = bc();
  if (e)
    do {
      var i = af(e), o = i.a, a = i.d;
      t += e.scrollLeft * o, n += e.scrollTop * a;
    } while (e !== r && (e = e.parentNode));
  return [t, n];
}
function KSt(e, t) {
  for (var n in e)
    if (e.hasOwnProperty(n)) {
      for (var r in t)
        if (t.hasOwnProperty(r) && t[r] === e[n][r])
          return Number(n);
    }
  return -1;
}
function cu(e, t) {
  if (!e || !e.getBoundingClientRect)
    return bc();
  var n = e, r = !1;
  do
    if (n.clientWidth < n.scrollWidth || n.clientHeight < n.scrollHeight) {
      var i = At(n);
      if (n.clientWidth < n.scrollWidth && (i.overflowX == "auto" || i.overflowX == "scroll") || n.clientHeight < n.scrollHeight && (i.overflowY == "auto" || i.overflowY == "scroll")) {
        if (!n.getBoundingClientRect || n === document.body)
          return bc();
        if (r || t)
          return n;
        r = !0;
      }
    }
  while (n = n.parentNode);
  return bc();
}
function YSt(e, t) {
  if (e && t)
    for (var n in t)
      t.hasOwnProperty(n) && (e[n] = t[n]);
  return e;
}
function NI(e, t) {
  return Math.round(e.top) === Math.round(t.top) && Math.round(e.left) === Math.round(t.left) && Math.round(e.height) === Math.round(t.height) && Math.round(e.width) === Math.round(t.width);
}
var J0;
function Wce(e, t) {
  return function() {
    if (!J0) {
      var n = arguments, r = this;
      n.length === 1 ? e.call(r, n[0]) : e.apply(r, n), J0 = setTimeout(function() {
        J0 = void 0;
      }, t);
    }
  };
}
function XSt() {
  clearTimeout(J0), J0 = void 0;
}
function qce(e, t, n) {
  e.scrollLeft += t, e.scrollTop += n;
}
function q4(e) {
  var t = window.Polymer, n = window.jQuery || window.Zepto;
  return t && t.dom ? t.dom(e).cloneNode(!0) : n ? n(e).clone(!0)[0] : e.cloneNode(!0);
}
function wH(e, t) {
  At(e, "position", "absolute"), At(e, "top", t.top), At(e, "left", t.left), At(e, "width", t.width), At(e, "height", t.height);
}
function DI(e) {
  At(e, "position", ""), At(e, "top", ""), At(e, "left", ""), At(e, "width", ""), At(e, "height", "");
}
function Gce(e, t, n) {
  var r = {};
  return Array.from(e.children).forEach(function(i) {
    var o, a, s, c;
    if (!(!ja(i, t.draggable, e, !1) || i.animated || i === n)) {
      var l = br(i);
      r.left = Math.min((o = r.left) !== null && o !== void 0 ? o : 1 / 0, l.left), r.top = Math.min((a = r.top) !== null && a !== void 0 ? a : 1 / 0, l.top), r.right = Math.max((s = r.right) !== null && s !== void 0 ? s : -1 / 0, l.right), r.bottom = Math.max((c = r.bottom) !== null && c !== void 0 ? c : -1 / 0, l.bottom);
    }
  }), r.width = r.right - r.left, r.height = r.bottom - r.top, r.x = r.left, r.y = r.top, r;
}
var Hi = "Sortable" + (/* @__PURE__ */ new Date()).getTime();
function QSt() {
  var e = [], t;
  return {
    captureAnimationState: function() {
      if (e = [], !!this.options.animation) {
        var r = [].slice.call(this.el.children);
        r.forEach(function(i) {
          if (!(At(i, "display") === "none" || i === Ut.ghost)) {
            e.push({
              target: i,
              rect: br(i)
            });
            var o = Tc({}, e[e.length - 1].rect);
            if (i.thisAnimationDuration) {
              var a = af(i, !0);
              a && (o.top -= a.f, o.left -= a.e);
            }
            i.fromRect = o;
          }
        });
      }
    },
    addAnimationState: function(r) {
      e.push(r);
    },
    removeAnimationState: function(r) {
      e.splice(KSt(e, {
        target: r
      }), 1);
    },
    animateAll: function(r) {
      var i = this;
      if (!this.options.animation) {
        clearTimeout(t), typeof r == "function" && r();
        return;
      }
      var o = !1, a = 0;
      e.forEach(function(s) {
        var c = 0, l = s.target, u = l.fromRect, d = br(l), f = l.prevFromRect, h = l.prevToRect, p = s.rect, g = af(l, !0);
        g && (d.top -= g.f, d.left -= g.e), l.toRect = d, l.thisAnimationDuration && NI(f, d) && !NI(u, d) && // Make sure animatingRect is on line between toRect & fromRect
        (p.top - d.top) / (p.left - d.left) === (u.top - d.top) / (u.left - d.left) && (c = ZSt(p, f, h, i.options)), NI(d, u) || (l.prevFromRect = u, l.prevToRect = d, c || (c = i.options.animation), i.animate(l, p, d, c)), c && (o = !0, a = Math.max(a, c), clearTimeout(l.animationResetTimer), l.animationResetTimer = setTimeout(function() {
          l.animationTime = 0, l.prevFromRect = null, l.fromRect = null, l.prevToRect = null, l.thisAnimationDuration = null;
        }, c), l.thisAnimationDuration = c);
      }), clearTimeout(t), o ? t = setTimeout(function() {
        typeof r == "function" && r();
      }, a) : typeof r == "function" && r(), e = [];
    },
    animate: function(r, i, o, a) {
      if (a) {
        At(r, "transition", ""), At(r, "transform", "");
        var s = af(this.el), c = s && s.a, l = s && s.d, u = (i.left - o.left) / (c || 1), d = (i.top - o.top) / (l || 1);
        r.animatingX = !!u, r.animatingY = !!d, At(r, "transform", "translate3d(" + u + "px," + d + "px,0)"), this.forRepaintDummy = JSt(r), At(r, "transition", "transform " + a + "ms" + (this.options.easing ? " " + this.options.easing : "")), At(r, "transform", "translate3d(0,0,0)"), typeof r.animated == "number" && clearTimeout(r.animated), r.animated = setTimeout(function() {
          At(r, "transition", ""), At(r, "transform", ""), r.animated = !1, r.animatingX = !1, r.animatingY = !1;
        }, a);
      }
    }
  };
}
function JSt(e) {
  return e.offsetWidth;
}
function ZSt(e, t, n, r) {
  return Math.sqrt(Math.pow(t.top - e.top, 2) + Math.pow(t.left - e.left, 2)) / Math.sqrt(Math.pow(t.top - n.top, 2) + Math.pow(t.left - n.left, 2)) * r.animation;
}
var kh = [], jI = {
  initializeByDefault: !0
}, Cb = {
  mount: function(t) {
    for (var n in jI)
      jI.hasOwnProperty(n) && !(n in t) && (t[n] = jI[n]);
    kh.forEach(function(r) {
      if (r.pluginName === t.pluginName)
        throw "Sortable: Cannot mount plugin ".concat(t.pluginName, " more than once");
    }), kh.push(t);
  },
  pluginEvent: function(t, n, r) {
    var i = this;
    this.eventCanceled = !1, r.cancel = function() {
      i.eventCanceled = !0;
    };
    var o = t + "Global";
    kh.forEach(function(a) {
      n[a.pluginName] && (n[a.pluginName][o] && n[a.pluginName][o](Tc({
        sortable: n
      }, r)), n.options[a.pluginName] && n[a.pluginName][t] && n[a.pluginName][t](Tc({
        sortable: n
      }, r)));
    });
  },
  initializePlugins: function(t, n, r, i) {
    kh.forEach(function(s) {
      var c = s.pluginName;
      if (!(!t.options[c] && !s.initializeByDefault)) {
        var l = new s(t, n, t.options);
        l.sortable = t, l.options = t.options, t[c] = l, Ka(r, l.defaults);
      }
    });
    for (var o in t.options)
      if (t.options.hasOwnProperty(o)) {
        var a = this.modifyOption(t, o, t.options[o]);
        typeof a < "u" && (t.options[o] = a);
      }
  },
  getEventProperties: function(t, n) {
    var r = {};
    return kh.forEach(function(i) {
      typeof i.eventProperties == "function" && Ka(r, i.eventProperties.call(n[i.pluginName], t));
    }), r;
  },
  modifyOption: function(t, n, r) {
    var i;
    return kh.forEach(function(o) {
      t[o.pluginName] && o.optionListeners && typeof o.optionListeners[n] == "function" && (i = o.optionListeners[n].call(t[o.pluginName], r));
    }), i;
  }
};
function S0(e) {
  var t = e.sortable, n = e.rootEl, r = e.name, i = e.targetEl, o = e.cloneEl, a = e.toEl, s = e.fromEl, c = e.oldIndex, l = e.newIndex, u = e.oldDraggableIndex, d = e.newDraggableIndex, f = e.originalEvent, h = e.putSortable, p = e.extraEventProperties;
  if (t = t || n && n[Hi], !!t) {
    var g, m = t.options, v = "on" + r.charAt(0).toUpperCase() + r.substr(1);
    window.CustomEvent && !Al && !Eb ? g = new CustomEvent(r, {
      bubbles: !0,
      cancelable: !0
    }) : (g = document.createEvent("Event"), g.initEvent(r, !0, !0)), g.to = a || n, g.from = s || n, g.item = i || n, g.clone = o, g.oldIndex = c, g.newIndex = l, g.oldDraggableIndex = u, g.newDraggableIndex = d, g.originalEvent = f, g.pullMode = h ? h.lastPutMode : void 0;
    var y = Tc(Tc({}, p), Cb.getEventProperties(r, t));
    for (var _ in y)
      g[_] = y[_];
    n && n.dispatchEvent(g), m[v] && m[v].call(t, g);
  }
}
var ewt = ["evt"], Uo = function(t, n) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, i = r.evt, o = BSt(r, ewt);
  Cb.pluginEvent.bind(Ut)(t, n, Tc({
    dragEl: it,
    parentEl: Ur,
    ghostEl: tn,
    rootEl: Ar,
    nextEl: Ad,
    lastDownEl: R_,
    cloneEl: Nr,
    cloneHidden: Zl,
    dragStarted: w0,
    putSortable: Vi,
    activeSortable: Ut.active,
    originalEvent: i,
    oldIndex: tg,
    oldDraggableIndex: Z0,
    newIndex: ha,
    newDraggableIndex: Wl,
    hideGhostForTarget: Qce,
    unhideGhostForTarget: Jce,
    cloneNowHidden: function() {
      Zl = !0;
    },
    cloneNowShown: function() {
      Zl = !1;
    },
    dispatchSortableEvent: function(s) {
      xo({
        sortable: n,
        name: s,
        originalEvent: i
      });
    }
  }, o));
};
function xo(e) {
  S0(Tc({
    putSortable: Vi,
    cloneEl: Nr,
    targetEl: it,
    rootEl: Ar,
    oldIndex: tg,
    oldDraggableIndex: Z0,
    newIndex: ha,
    newDraggableIndex: Wl
  }, e));
}
var it, Ur, tn, Ar, Ad, R_, Nr, Zl, tg, ha, Z0, Wl, U1, Vi, Hh = !1, px = !1, mx = [], Sd, is, LI, FI, xH, EH, w0, Nh, ev, tv = !1, W1 = !1, P_, ro, VI = [], qP = !1, vx = [], i5 = typeof document < "u", q1 = Vce, CH = Eb || Al ? "cssFloat" : "float", twt = i5 && !Bce && !Vce && "draggable" in document.createElement("div"), Kce = function() {
  if (i5) {
    if (Al)
      return !1;
    var e = document.createElement("x");
    return e.style.cssText = "pointer-events:auto", e.style.pointerEvents === "auto";
  }
}(), Yce = function(t, n) {
  var r = At(t), i = parseInt(r.width) - parseInt(r.paddingLeft) - parseInt(r.paddingRight) - parseInt(r.borderLeftWidth) - parseInt(r.borderRightWidth), o = Sp(t, 0, n), a = Sp(t, 1, n), s = o && At(o), c = a && At(a), l = s && parseInt(s.marginLeft) + parseInt(s.marginRight) + br(o).width, u = c && parseInt(c.marginLeft) + parseInt(c.marginRight) + br(a).width;
  if (r.display === "flex")
    return r.flexDirection === "column" || r.flexDirection === "column-reverse" ? "vertical" : "horizontal";
  if (r.display === "grid")
    return r.gridTemplateColumns.split(" ").length <= 1 ? "vertical" : "horizontal";
  if (o && s.float && s.float !== "none") {
    var d = s.float === "left" ? "left" : "right";
    return a && (c.clear === "both" || c.clear === d) ? "vertical" : "horizontal";
  }
  return o && (s.display === "block" || s.display === "flex" || s.display === "table" || s.display === "grid" || l >= i && r[CH] === "none" || a && r[CH] === "none" && l + u > i) ? "vertical" : "horizontal";
}, nwt = function(t, n, r) {
  var i = r ? t.left : t.top, o = r ? t.right : t.bottom, a = r ? t.width : t.height, s = r ? n.left : n.top, c = r ? n.right : n.bottom, l = r ? n.width : n.height;
  return i === s || o === c || i + a / 2 === s + l / 2;
}, rwt = function(t, n) {
  var r;
  return mx.some(function(i) {
    var o = i[Hi].options.emptyInsertThreshold;
    if (!(!o || W4(i))) {
      var a = br(i), s = t >= a.left - o && t <= a.right + o, c = n >= a.top - o && n <= a.bottom + o;
      if (s && c)
        return r = i;
    }
  }), r;
}, Xce = function(t) {
  function n(o, a) {
    return function(s, c, l, u) {
      var d = s.options.group.name && c.options.group.name && s.options.group.name === c.options.group.name;
      if (o == null && (a || d))
        return !0;
      if (o == null || o === !1)
        return !1;
      if (a && o === "clone")
        return o;
      if (typeof o == "function")
        return n(o(s, c, l, u), a)(s, c, l, u);
      var f = (a ? s : c).options.group.name;
      return o === !0 || typeof o == "string" && o === f || o.join && o.indexOf(f) > -1;
    };
  }
  var r = {}, i = t.group;
  (!i || A_(i) != "object") && (i = {
    name: i
  }), r.name = i.name, r.checkPull = n(i.pull, !0), r.checkPut = n(i.put), r.revertClone = i.revertClone, t.group = r;
}, Qce = function() {
  !Kce && tn && At(tn, "display", "none");
}, Jce = function() {
  !Kce && tn && At(tn, "display", "");
};
i5 && !Bce && document.addEventListener("click", function(e) {
  if (px)
    return e.preventDefault(), e.stopPropagation && e.stopPropagation(), e.stopImmediatePropagation && e.stopImmediatePropagation(), px = !1, !1;
}, !0);
var wd = function(t) {
  if (it) {
    t = t.touches ? t.touches[0] : t;
    var n = rwt(t.clientX, t.clientY);
    if (n) {
      var r = {};
      for (var i in t)
        t.hasOwnProperty(i) && (r[i] = t[i]);
      r.target = r.rootEl = n, r.preventDefault = void 0, r.stopPropagation = void 0, n[Hi]._onDragOver(r);
    }
  }
}, iwt = function(t) {
  it && it.parentNode[Hi]._isOutsideThisEl(t.target);
};
function Ut(e, t) {
  if (!(e && e.nodeType && e.nodeType === 1))
    throw "Sortable: `el` must be an HTMLElement, not ".concat({}.toString.call(e));
  this.el = e, this.options = t = Ka({}, t), e[Hi] = this;
  var n = {
    group: null,
    sort: !0,
    disabled: !1,
    store: null,
    handle: null,
    draggable: /^[uo]l$/i.test(e.nodeName) ? ">li" : ">*",
    swapThreshold: 1,
    // percentage; 0 <= x <= 1
    invertSwap: !1,
    // invert always
    invertedSwapThreshold: null,
    // will be set to same as swapThreshold if default
    removeCloneOnHide: !0,
    direction: function() {
      return Yce(e, this.options);
    },
    ghostClass: "sortable-ghost",
    chosenClass: "sortable-chosen",
    dragClass: "sortable-drag",
    ignore: "a, img",
    filter: null,
    preventOnFilter: !0,
    animation: 0,
    easing: null,
    setData: function(a, s) {
      a.setData("Text", s.textContent);
    },
    dropBubble: !1,
    dragoverBubble: !1,
    dataIdAttr: "data-id",
    delay: 0,
    delayOnTouchOnly: !1,
    touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
    forceFallback: !1,
    fallbackClass: "sortable-fallback",
    fallbackOnBody: !1,
    fallbackTolerance: 0,
    fallbackOffset: {
      x: 0,
      y: 0
    },
    supportPointer: Ut.supportPointer !== !1 && "PointerEvent" in window && !Q0,
    emptyInsertThreshold: 5
  };
  Cb.initializePlugins(this, e, n);
  for (var r in n)
    !(r in t) && (t[r] = n[r]);
  Xce(t);
  for (var i in this)
    i.charAt(0) === "_" && typeof this[i] == "function" && (this[i] = this[i].bind(this));
  this.nativeDraggable = t.forceFallback ? !1 : twt, this.nativeDraggable && (this.options.touchStartThreshold = 1), t.supportPointer ? bn(e, "pointerdown", this._onTapStart) : (bn(e, "mousedown", this._onTapStart), bn(e, "touchstart", this._onTapStart)), this.nativeDraggable && (bn(e, "dragover", this), bn(e, "dragenter", this)), mx.push(this.el), t.store && t.store.get && this.sort(t.store.get(this) || []), Ka(this, QSt());
}
Ut.prototype = /** @lends Sortable.prototype */
{
  constructor: Ut,
  _isOutsideThisEl: function(t) {
    !this.el.contains(t) && t !== this.el && (Nh = null);
  },
  _getDirection: function(t, n) {
    return typeof this.options.direction == "function" ? this.options.direction.call(this, t, n, it) : this.options.direction;
  },
  _onTapStart: function(t) {
    if (t.cancelable) {
      var n = this, r = this.el, i = this.options, o = i.preventOnFilter, a = t.type, s = t.touches && t.touches[0] || t.pointerType && t.pointerType === "touch" && t, c = (s || t).target, l = t.target.shadowRoot && (t.path && t.path[0] || t.composedPath && t.composedPath()[0]) || c, u = i.filter;
      if (fwt(r), !it && !(/mousedown|pointerdown/.test(a) && t.button !== 0 || i.disabled) && !l.isContentEditable && !(!this.nativeDraggable && Q0 && c && c.tagName.toUpperCase() === "SELECT") && (c = ja(c, i.draggable, r, !1), !(c && c.animated) && R_ !== c)) {
        if (tg = Gr(c), Z0 = Gr(c, i.draggable), typeof u == "function") {
          if (u.call(this, t, c, this)) {
            xo({
              sortable: n,
              rootEl: l,
              name: "filter",
              targetEl: c,
              toEl: r,
              fromEl: r
            }), Uo("filter", n, {
              evt: t
            }), o && t.cancelable && t.preventDefault();
            return;
          }
        } else if (u && (u = u.split(",").some(function(d) {
          if (d = ja(l, d.trim(), r, !1), d)
            return xo({
              sortable: n,
              rootEl: d,
              name: "filter",
              targetEl: c,
              fromEl: r,
              toEl: r
            }), Uo("filter", n, {
              evt: t
            }), !0;
        }), u)) {
          o && t.cancelable && t.preventDefault();
          return;
        }
        i.handle && !ja(l, i.handle, r, !1) || this._prepareDragStart(t, s, c);
      }
    }
  },
  _prepareDragStart: function(t, n, r) {
    var i = this, o = i.el, a = i.options, s = o.ownerDocument, c;
    if (r && !it && r.parentNode === o) {
      var l = br(r);
      if (Ar = o, it = r, Ur = it.parentNode, Ad = it.nextSibling, R_ = r, U1 = a.group, Ut.dragged = it, Sd = {
        target: it,
        clientX: (n || t).clientX,
        clientY: (n || t).clientY
      }, xH = Sd.clientX - l.left, EH = Sd.clientY - l.top, this._lastX = (n || t).clientX, this._lastY = (n || t).clientY, it.style["will-change"] = "all", c = function() {
        if (Uo("delayEnded", i, {
          evt: t
        }), Ut.eventCanceled) {
          i._onDrop();
          return;
        }
        i._disableDelayedDragEvents(), !yH && i.nativeDraggable && (it.draggable = !0), i._triggerDragStart(t, n), xo({
          sortable: i,
          name: "choose",
          originalEvent: t
        }), Dr(it, a.chosenClass, !0);
      }, a.ignore.split(",").forEach(function(u) {
        Uce(it, u.trim(), BI);
      }), bn(s, "dragover", wd), bn(s, "mousemove", wd), bn(s, "touchmove", wd), bn(s, "mouseup", i._onDrop), bn(s, "touchend", i._onDrop), bn(s, "touchcancel", i._onDrop), yH && this.nativeDraggable && (this.options.touchStartThreshold = 4, it.draggable = !0), Uo("delayStart", this, {
        evt: t
      }), a.delay && (!a.delayOnTouchOnly || n) && (!this.nativeDraggable || !(Eb || Al))) {
        if (Ut.eventCanceled) {
          this._onDrop();
          return;
        }
        bn(s, "mouseup", i._disableDelayedDrag), bn(s, "touchend", i._disableDelayedDrag), bn(s, "touchcancel", i._disableDelayedDrag), bn(s, "mousemove", i._delayedDragTouchMoveHandler), bn(s, "touchmove", i._delayedDragTouchMoveHandler), a.supportPointer && bn(s, "pointermove", i._delayedDragTouchMoveHandler), i._dragStartTimer = setTimeout(c, a.delay);
      } else
        c();
    }
  },
  _delayedDragTouchMoveHandler: function(t) {
    var n = t.touches ? t.touches[0] : t;
    Math.max(Math.abs(n.clientX - this._lastX), Math.abs(n.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1)) && this._disableDelayedDrag();
  },
  _disableDelayedDrag: function() {
    it && BI(it), clearTimeout(this._dragStartTimer), this._disableDelayedDragEvents();
  },
  _disableDelayedDragEvents: function() {
    var t = this.el.ownerDocument;
    pn(t, "mouseup", this._disableDelayedDrag), pn(t, "touchend", this._disableDelayedDrag), pn(t, "touchcancel", this._disableDelayedDrag), pn(t, "mousemove", this._delayedDragTouchMoveHandler), pn(t, "touchmove", this._delayedDragTouchMoveHandler), pn(t, "pointermove", this._delayedDragTouchMoveHandler);
  },
  _triggerDragStart: function(t, n) {
    n = n || t.pointerType == "touch" && t, !this.nativeDraggable || n ? this.options.supportPointer ? bn(document, "pointermove", this._onTouchMove) : n ? bn(document, "touchmove", this._onTouchMove) : bn(document, "mousemove", this._onTouchMove) : (bn(it, "dragend", this), bn(Ar, "dragstart", this._onDragStart));
    try {
      document.selection ? O_(function() {
        document.selection.empty();
      }) : window.getSelection().removeAllRanges();
    } catch {
    }
  },
  _dragStarted: function(t, n) {
    if (Hh = !1, Ar && it) {
      Uo("dragStarted", this, {
        evt: n
      }), this.nativeDraggable && bn(document, "dragover", iwt);
      var r = this.options;
      !t && Dr(it, r.dragClass, !1), Dr(it, r.ghostClass, !0), Ut.active = this, t && this._appendGhost(), xo({
        sortable: this,
        name: "start",
        originalEvent: n
      });
    } else
      this._nulling();
  },
  _emulateDragOver: function() {
    if (is) {
      this._lastX = is.clientX, this._lastY = is.clientY, Qce();
      for (var t = document.elementFromPoint(is.clientX, is.clientY), n = t; t && t.shadowRoot && (t = t.shadowRoot.elementFromPoint(is.clientX, is.clientY), t !== n); )
        n = t;
      if (it.parentNode[Hi]._isOutsideThisEl(t), n)
        do {
          if (n[Hi]) {
            var r = void 0;
            if (r = n[Hi]._onDragOver({
              clientX: is.clientX,
              clientY: is.clientY,
              target: t,
              rootEl: n
            }), r && !this.options.dragoverBubble)
              break;
          }
          t = n;
        } while (n = Hce(n));
      Jce();
    }
  },
  _onTouchMove: function(t) {
    if (Sd) {
      var n = this.options, r = n.fallbackTolerance, i = n.fallbackOffset, o = t.touches ? t.touches[0] : t, a = tn && af(tn, !0), s = tn && a && a.a, c = tn && a && a.d, l = q1 && ro && SH(ro), u = (o.clientX - Sd.clientX + i.x) / (s || 1) + (l ? l[0] - VI[0] : 0) / (s || 1), d = (o.clientY - Sd.clientY + i.y) / (c || 1) + (l ? l[1] - VI[1] : 0) / (c || 1);
      if (!Ut.active && !Hh) {
        if (r && Math.max(Math.abs(o.clientX - this._lastX), Math.abs(o.clientY - this._lastY)) < r)
          return;
        this._onDragStart(t, !0);
      }
      if (tn) {
        a ? (a.e += u - (LI || 0), a.f += d - (FI || 0)) : a = {
          a: 1,
          b: 0,
          c: 0,
          d: 1,
          e: u,
          f: d
        };
        var f = "matrix(".concat(a.a, ",").concat(a.b, ",").concat(a.c, ",").concat(a.d, ",").concat(a.e, ",").concat(a.f, ")");
        At(tn, "webkitTransform", f), At(tn, "mozTransform", f), At(tn, "msTransform", f), At(tn, "transform", f), LI = u, FI = d, is = o;
      }
      t.cancelable && t.preventDefault();
    }
  },
  _appendGhost: function() {
    if (!tn) {
      var t = this.options.fallbackOnBody ? document.body : Ar, n = br(it, !0, q1, !0, t), r = this.options;
      if (q1) {
        for (ro = t; At(ro, "position") === "static" && At(ro, "transform") === "none" && ro !== document; )
          ro = ro.parentNode;
        ro !== document.body && ro !== document.documentElement ? (ro === document && (ro = bc()), n.top += ro.scrollTop, n.left += ro.scrollLeft) : ro = bc(), VI = SH(ro);
      }
      tn = it.cloneNode(!0), Dr(tn, r.ghostClass, !1), Dr(tn, r.fallbackClass, !0), Dr(tn, r.dragClass, !0), At(tn, "transition", ""), At(tn, "transform", ""), At(tn, "box-sizing", "border-box"), At(tn, "margin", 0), At(tn, "top", n.top), At(tn, "left", n.left), At(tn, "width", n.width), At(tn, "height", n.height), At(tn, "opacity", "0.8"), At(tn, "position", q1 ? "absolute" : "fixed"), At(tn, "zIndex", "100000"), At(tn, "pointerEvents", "none"), Ut.ghost = tn, t.appendChild(tn), At(tn, "transform-origin", xH / parseInt(tn.style.width) * 100 + "% " + EH / parseInt(tn.style.height) * 100 + "%");
    }
  },
  _onDragStart: function(t, n) {
    var r = this, i = t.dataTransfer, o = r.options;
    if (Uo("dragStart", this, {
      evt: t
    }), Ut.eventCanceled) {
      this._onDrop();
      return;
    }
    Uo("setupClone", this), Ut.eventCanceled || (Nr = q4(it), Nr.removeAttribute("id"), Nr.draggable = !1, Nr.style["will-change"] = "", this._hideClone(), Dr(Nr, this.options.chosenClass, !1), Ut.clone = Nr), r.cloneId = O_(function() {
      Uo("clone", r), !Ut.eventCanceled && (r.options.removeCloneOnHide || Ar.insertBefore(Nr, it), r._hideClone(), xo({
        sortable: r,
        name: "clone"
      }));
    }), !n && Dr(it, o.dragClass, !0), n ? (px = !0, r._loopId = setInterval(r._emulateDragOver, 50)) : (pn(document, "mouseup", r._onDrop), pn(document, "touchend", r._onDrop), pn(document, "touchcancel", r._onDrop), i && (i.effectAllowed = "move", o.setData && o.setData.call(r, i, it)), bn(document, "drop", r), At(it, "transform", "translateZ(0)")), Hh = !0, r._dragStartId = O_(r._dragStarted.bind(r, n, t)), bn(document, "selectstart", r), w0 = !0, Q0 && At(document.body, "user-select", "none");
  },
  // Returns true - if no further action is needed (either inserted or another condition)
  _onDragOver: function(t) {
    var n = this.el, r = t.target, i, o, a, s = this.options, c = s.group, l = Ut.active, u = U1 === c, d = s.sort, f = Vi || l, h, p = this, g = !1;
    if (qP)
      return;
    function m(z, V) {
      Uo(z, p, Tc({
        evt: t,
        isOwner: u,
        axis: h ? "vertical" : "horizontal",
        revert: a,
        dragRect: i,
        targetRect: o,
        canSort: d,
        fromSortable: f,
        target: r,
        completed: y,
        onMove: function(U, Q) {
          return G1(Ar, n, it, i, U, br(U), t, Q);
        },
        changed: _
      }, V));
    }
    function v() {
      m("dragOverAnimationCapture"), p.captureAnimationState(), p !== f && f.captureAnimationState();
    }
    function y(z) {
      return m("dragOverCompleted", {
        insertion: z
      }), z && (u ? l._hideClone() : l._showClone(p), p !== f && (Dr(it, Vi ? Vi.options.ghostClass : l.options.ghostClass, !1), Dr(it, s.ghostClass, !0)), Vi !== p && p !== Ut.active ? Vi = p : p === Ut.active && Vi && (Vi = null), f === p && (p._ignoreWhileAnimating = r), p.animateAll(function() {
        m("dragOverAnimationComplete"), p._ignoreWhileAnimating = null;
      }), p !== f && (f.animateAll(), f._ignoreWhileAnimating = null)), (r === it && !it.animated || r === n && !r.animated) && (Nh = null), !s.dragoverBubble && !t.rootEl && r !== document && (it.parentNode[Hi]._isOutsideThisEl(t.target), !z && wd(t)), !s.dragoverBubble && t.stopPropagation && t.stopPropagation(), g = !0;
    }
    function _() {
      ha = Gr(it), Wl = Gr(it, s.draggable), xo({
        sortable: p,
        name: "change",
        toEl: n,
        newIndex: ha,
        newDraggableIndex: Wl,
        originalEvent: t
      });
    }
    if (t.preventDefault !== void 0 && t.cancelable && t.preventDefault(), r = ja(r, s.draggable, n, !0), m("dragOver"), Ut.eventCanceled)
      return g;
    if (it.contains(t.target) || r.animated && r.animatingX && r.animatingY || p._ignoreWhileAnimating === r)
      return y(!1);
    if (px = !1, l && !s.disabled && (u ? d || (a = Ur !== Ar) : Vi === this || (this.lastPutMode = U1.checkPull(this, l, it, t)) && c.checkPut(this, l, it, t))) {
      if (h = this._getDirection(t, r) === "vertical", i = br(it), m("dragOverValid"), Ut.eventCanceled)
        return g;
      if (a)
        return Ur = Ar, v(), this._hideClone(), m("revert"), Ut.eventCanceled || (Ad ? Ar.insertBefore(it, Ad) : Ar.appendChild(it)), y(!0);
      var b = W4(n, s.draggable);
      if (!b || cwt(t, h, this) && !b.animated) {
        if (b === it)
          return y(!1);
        if (b && n === t.target && (r = b), r && (o = br(r)), G1(Ar, n, it, i, r, o, t, !!r) !== !1)
          return v(), b && b.nextSibling ? n.insertBefore(it, b.nextSibling) : n.appendChild(it), Ur = n, _(), y(!0);
      } else if (b && swt(t, h, this)) {
        var w = Sp(n, 0, s, !0);
        if (w === it)
          return y(!1);
        if (r = w, o = br(r), G1(Ar, n, it, i, r, o, t, !1) !== !1)
          return v(), n.insertBefore(it, w), Ur = n, _(), y(!0);
      } else if (r.parentNode === n) {
        o = br(r);
        var C = 0, x, T = it.parentNode !== n, E = !nwt(it.animated && it.toRect || i, r.animated && r.toRect || o, h), R = h ? "top" : "left", I = _H(r, "top", "top") || _H(it, "top", "top"), O = I ? I.scrollTop : void 0;
        Nh !== r && (x = o[R], tv = !1, W1 = !E && s.invertSwap || T), C = lwt(t, r, o, h, E ? 1 : s.swapThreshold, s.invertedSwapThreshold == null ? s.swapThreshold : s.invertedSwapThreshold, W1, Nh === r);
        var P;
        if (C !== 0) {
          var k = Gr(it);
          do
            k -= C, P = Ur.children[k];
          while (P && (At(P, "display") === "none" || P === tn));
        }
        if (C === 0 || P === r)
          return y(!1);
        Nh = r, ev = C;
        var L = r.nextElementSibling, N = !1;
        N = C === 1;
        var D = G1(Ar, n, it, i, r, o, t, N);
        if (D !== !1)
          return (D === 1 || D === -1) && (N = D === 1), qP = !0, setTimeout(awt, 30), v(), N && !L ? n.appendChild(it) : r.parentNode.insertBefore(it, N ? L : r), I && qce(I, 0, O - I.scrollTop), Ur = it.parentNode, x !== void 0 && !W1 && (P_ = Math.abs(x - br(r)[R])), _(), y(!0);
      }
      if (n.contains(it))
        return y(!1);
    }
    return !1;
  },
  _ignoreWhileAnimating: null,
  _offMoveEvents: function() {
    pn(document, "mousemove", this._onTouchMove), pn(document, "touchmove", this._onTouchMove), pn(document, "pointermove", this._onTouchMove), pn(document, "dragover", wd), pn(document, "mousemove", wd), pn(document, "touchmove", wd);
  },
  _offUpEvents: function() {
    var t = this.el.ownerDocument;
    pn(t, "mouseup", this._onDrop), pn(t, "touchend", this._onDrop), pn(t, "pointerup", this._onDrop), pn(t, "touchcancel", this._onDrop), pn(document, "selectstart", this);
  },
  _onDrop: function(t) {
    var n = this.el, r = this.options;
    if (ha = Gr(it), Wl = Gr(it, r.draggable), Uo("drop", this, {
      evt: t
    }), Ur = it && it.parentNode, ha = Gr(it), Wl = Gr(it, r.draggable), Ut.eventCanceled) {
      this._nulling();
      return;
    }
    Hh = !1, W1 = !1, tv = !1, clearInterval(this._loopId), clearTimeout(this._dragStartTimer), GP(this.cloneId), GP(this._dragStartId), this.nativeDraggable && (pn(document, "drop", this), pn(n, "dragstart", this._onDragStart)), this._offMoveEvents(), this._offUpEvents(), Q0 && At(document.body, "user-select", ""), At(it, "transform", ""), t && (w0 && (t.cancelable && t.preventDefault(), !r.dropBubble && t.stopPropagation()), tn && tn.parentNode && tn.parentNode.removeChild(tn), (Ar === Ur || Vi && Vi.lastPutMode !== "clone") && Nr && Nr.parentNode && Nr.parentNode.removeChild(Nr), it && (this.nativeDraggable && pn(it, "dragend", this), BI(it), it.style["will-change"] = "", w0 && !Hh && Dr(it, Vi ? Vi.options.ghostClass : this.options.ghostClass, !1), Dr(it, this.options.chosenClass, !1), xo({
      sortable: this,
      name: "unchoose",
      toEl: Ur,
      newIndex: null,
      newDraggableIndex: null,
      originalEvent: t
    }), Ar !== Ur ? (ha >= 0 && (xo({
      rootEl: Ur,
      name: "add",
      toEl: Ur,
      fromEl: Ar,
      originalEvent: t
    }), xo({
      sortable: this,
      name: "remove",
      toEl: Ur,
      originalEvent: t
    }), xo({
      rootEl: Ur,
      name: "sort",
      toEl: Ur,
      fromEl: Ar,
      originalEvent: t
    }), xo({
      sortable: this,
      name: "sort",
      toEl: Ur,
      originalEvent: t
    })), Vi && Vi.save()) : ha !== tg && ha >= 0 && (xo({
      sortable: this,
      name: "update",
      toEl: Ur,
      originalEvent: t
    }), xo({
      sortable: this,
      name: "sort",
      toEl: Ur,
      originalEvent: t
    })), Ut.active && ((ha == null || ha === -1) && (ha = tg, Wl = Z0), xo({
      sortable: this,
      name: "end",
      toEl: Ur,
      originalEvent: t
    }), this.save()))), this._nulling();
  },
  _nulling: function() {
    Uo("nulling", this), Ar = it = Ur = tn = Ad = Nr = R_ = Zl = Sd = is = w0 = ha = Wl = tg = Z0 = Nh = ev = Vi = U1 = Ut.dragged = Ut.ghost = Ut.clone = Ut.active = null, vx.forEach(function(t) {
      t.checked = !0;
    }), vx.length = LI = FI = 0;
  },
  handleEvent: function(t) {
    switch (t.type) {
      case "drop":
      case "dragend":
        this._onDrop(t);
        break;
      case "dragenter":
      case "dragover":
        it && (this._onDragOver(t), owt(t));
        break;
      case "selectstart":
        t.preventDefault();
        break;
    }
  },
  /**
   * Serializes the item into an array of string.
   * @returns {String[]}
   */
  toArray: function() {
    for (var t = [], n, r = this.el.children, i = 0, o = r.length, a = this.options; i < o; i++)
      n = r[i], ja(n, a.draggable, this.el, !1) && t.push(n.getAttribute(a.dataIdAttr) || dwt(n));
    return t;
  },
  /**
   * Sorts the elements according to the array.
   * @param  {String[]}  order  order of the items
   */
  sort: function(t, n) {
    var r = {}, i = this.el;
    this.toArray().forEach(function(o, a) {
      var s = i.children[a];
      ja(s, this.options.draggable, i, !1) && (r[o] = s);
    }, this), n && this.captureAnimationState(), t.forEach(function(o) {
      r[o] && (i.removeChild(r[o]), i.appendChild(r[o]));
    }), n && this.animateAll();
  },
  /**
   * Save the current sorting
   */
  save: function() {
    var t = this.options.store;
    t && t.set && t.set(this);
  },
  /**
   * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
   * @param   {HTMLElement}  el
   * @param   {String}       [selector]  default: `options.draggable`
   * @returns {HTMLElement|null}
   */
  closest: function(t, n) {
    return ja(t, n || this.options.draggable, this.el, !1);
  },
  /**
   * Set/get option
   * @param   {string} name
   * @param   {*}      [value]
   * @returns {*}
   */
  option: function(t, n) {
    var r = this.options;
    if (n === void 0)
      return r[t];
    var i = Cb.modifyOption(this, t, n);
    typeof i < "u" ? r[t] = i : r[t] = n, t === "group" && Xce(r);
  },
  /**
   * Destroy
   */
  destroy: function() {
    Uo("destroy", this);
    var t = this.el;
    t[Hi] = null, pn(t, "mousedown", this._onTapStart), pn(t, "touchstart", this._onTapStart), pn(t, "pointerdown", this._onTapStart), this.nativeDraggable && (pn(t, "dragover", this), pn(t, "dragenter", this)), Array.prototype.forEach.call(t.querySelectorAll("[draggable]"), function(n) {
      n.removeAttribute("draggable");
    }), this._onDrop(), this._disableDelayedDragEvents(), mx.splice(mx.indexOf(this.el), 1), this.el = t = null;
  },
  _hideClone: function() {
    if (!Zl) {
      if (Uo("hideClone", this), Ut.eventCanceled)
        return;
      At(Nr, "display", "none"), this.options.removeCloneOnHide && Nr.parentNode && Nr.parentNode.removeChild(Nr), Zl = !0;
    }
  },
  _showClone: function(t) {
    if (t.lastPutMode !== "clone") {
      this._hideClone();
      return;
    }
    if (Zl) {
      if (Uo("showClone", this), Ut.eventCanceled)
        return;
      it.parentNode == Ar && !this.options.group.revertClone ? Ar.insertBefore(Nr, it) : Ad ? Ar.insertBefore(Nr, Ad) : Ar.appendChild(Nr), this.options.group.revertClone && this.animate(it, Nr), At(Nr, "display", ""), Zl = !1;
    }
  }
};
function owt(e) {
  e.dataTransfer && (e.dataTransfer.dropEffect = "move"), e.cancelable && e.preventDefault();
}
function G1(e, t, n, r, i, o, a, s) {
  var c, l = e[Hi], u = l.options.onMove, d;
  return window.CustomEvent && !Al && !Eb ? c = new CustomEvent("move", {
    bubbles: !0,
    cancelable: !0
  }) : (c = document.createEvent("Event"), c.initEvent("move", !0, !0)), c.to = t, c.from = e, c.dragged = n, c.draggedRect = r, c.related = i || t, c.relatedRect = o || br(t), c.willInsertAfter = s, c.originalEvent = a, e.dispatchEvent(c), u && (d = u.call(l, c, a)), d;
}
function BI(e) {
  e.draggable = !1;
}
function awt() {
  qP = !1;
}
function swt(e, t, n) {
  var r = br(Sp(n.el, 0, n.options, !0)), i = Gce(n.el, n.options, tn), o = 10;
  return t ? e.clientX < i.left - o || e.clientY < r.top && e.clientX < r.right : e.clientY < i.top - o || e.clientY < r.bottom && e.clientX < r.left;
}
function cwt(e, t, n) {
  var r = br(W4(n.el, n.options.draggable)), i = Gce(n.el, n.options, tn), o = 10;
  return t ? e.clientX > i.right + o || e.clientY > r.bottom && e.clientX > r.left : e.clientY > i.bottom + o || e.clientX > r.right && e.clientY > r.top;
}
function lwt(e, t, n, r, i, o, a, s) {
  var c = r ? e.clientY : e.clientX, l = r ? n.height : n.width, u = r ? n.top : n.left, d = r ? n.bottom : n.right, f = !1;
  if (!a) {
    if (s && P_ < l * i) {
      if (!tv && (ev === 1 ? c > u + l * o / 2 : c < d - l * o / 2) && (tv = !0), tv)
        f = !0;
      else if (ev === 1 ? c < u + P_ : c > d - P_)
        return -ev;
    } else if (c > u + l * (1 - i) / 2 && c < d - l * (1 - i) / 2)
      return uwt(t);
  }
  return f = f || a, f && (c < u + l * o / 2 || c > d - l * o / 2) ? c > u + l / 2 ? 1 : -1 : 0;
}
function uwt(e) {
  return Gr(it) < Gr(e) ? 1 : -1;
}
function dwt(e) {
  for (var t = e.tagName + e.className + e.src + e.href + e.textContent, n = t.length, r = 0; n--; )
    r += t.charCodeAt(n);
  return r.toString(36);
}
function fwt(e) {
  vx.length = 0;
  for (var t = e.getElementsByTagName("input"), n = t.length; n--; ) {
    var r = t[n];
    r.checked && vx.push(r);
  }
}
function O_(e) {
  return setTimeout(e, 0);
}
function GP(e) {
  return clearTimeout(e);
}
i5 && bn(document, "touchmove", function(e) {
  (Ut.active || Hh) && e.cancelable && e.preventDefault();
});
Ut.utils = {
  on: bn,
  off: pn,
  css: At,
  find: Uce,
  is: function(t, n) {
    return !!ja(t, n, t, !1);
  },
  extend: YSt,
  throttle: Wce,
  closest: ja,
  toggleClass: Dr,
  clone: q4,
  index: Gr,
  nextTick: O_,
  cancelNextTick: GP,
  detectDirection: Yce,
  getChild: Sp,
  expando: Hi
};
Ut.get = function(e) {
  return e[Hi];
};
Ut.mount = function() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  t[0].constructor === Array && (t = t[0]), t.forEach(function(r) {
    if (!r.prototype || !r.prototype.constructor)
      throw "Sortable: Mounted plugin must be a constructor function, not ".concat({}.toString.call(r));
    r.utils && (Ut.utils = Tc(Tc({}, Ut.utils), r.utils)), Cb.mount(r);
  });
};
Ut.create = function(e, t) {
  return new Ut(e, t);
};
Ut.version = GSt;
var ai = [], x0, KP, YP = !1, zI, HI, yx, E0;
function hwt() {
  function e() {
    this.defaults = {
      scroll: !0,
      forceAutoScrollFallback: !1,
      scrollSensitivity: 30,
      scrollSpeed: 10,
      bubbleScroll: !0
    };
    for (var t in this)
      t.charAt(0) === "_" && typeof this[t] == "function" && (this[t] = this[t].bind(this));
  }
  return e.prototype = {
    dragStarted: function(n) {
      var r = n.originalEvent;
      this.sortable.nativeDraggable ? bn(document, "dragover", this._handleAutoScroll) : this.options.supportPointer ? bn(document, "pointermove", this._handleFallbackAutoScroll) : r.touches ? bn(document, "touchmove", this._handleFallbackAutoScroll) : bn(document, "mousemove", this._handleFallbackAutoScroll);
    },
    dragOverCompleted: function(n) {
      var r = n.originalEvent;
      !this.options.dragOverBubble && !r.rootEl && this._handleAutoScroll(r);
    },
    drop: function() {
      this.sortable.nativeDraggable ? pn(document, "dragover", this._handleAutoScroll) : (pn(document, "pointermove", this._handleFallbackAutoScroll), pn(document, "touchmove", this._handleFallbackAutoScroll), pn(document, "mousemove", this._handleFallbackAutoScroll)), TH(), M_(), XSt();
    },
    nulling: function() {
      yx = KP = x0 = YP = E0 = zI = HI = null, ai.length = 0;
    },
    _handleFallbackAutoScroll: function(n) {
      this._handleAutoScroll(n, !0);
    },
    _handleAutoScroll: function(n, r) {
      var i = this, o = (n.touches ? n.touches[0] : n).clientX, a = (n.touches ? n.touches[0] : n).clientY, s = document.elementFromPoint(o, a);
      if (yx = n, r || this.options.forceAutoScrollFallback || Eb || Al || Q0) {
        UI(n, this.options, s, r);
        var c = cu(s, !0);
        YP && (!E0 || o !== zI || a !== HI) && (E0 && TH(), E0 = setInterval(function() {
          var l = cu(document.elementFromPoint(o, a), !0);
          l !== c && (c = l, M_()), UI(n, i.options, l, r);
        }, 10), zI = o, HI = a);
      } else {
        if (!this.options.bubbleScroll || cu(s, !0) === bc()) {
          M_();
          return;
        }
        UI(n, this.options, cu(s, !1), !1);
      }
    }
  }, Ka(e, {
    pluginName: "scroll",
    initializeByDefault: !0
  });
}
function M_() {
  ai.forEach(function(e) {
    clearInterval(e.pid);
  }), ai = [];
}
function TH() {
  clearInterval(E0);
}
var UI = Wce(function(e, t, n, r) {
  if (t.scroll) {
    var i = (e.touches ? e.touches[0] : e).clientX, o = (e.touches ? e.touches[0] : e).clientY, a = t.scrollSensitivity, s = t.scrollSpeed, c = bc(), l = !1, u;
    KP !== n && (KP = n, M_(), x0 = t.scroll, u = t.scrollFn, x0 === !0 && (x0 = cu(n, !0)));
    var d = 0, f = x0;
    do {
      var h = f, p = br(h), g = p.top, m = p.bottom, v = p.left, y = p.right, _ = p.width, b = p.height, w = void 0, C = void 0, x = h.scrollWidth, T = h.scrollHeight, E = At(h), R = h.scrollLeft, I = h.scrollTop;
      h === c ? (w = _ < x && (E.overflowX === "auto" || E.overflowX === "scroll" || E.overflowX === "visible"), C = b < T && (E.overflowY === "auto" || E.overflowY === "scroll" || E.overflowY === "visible")) : (w = _ < x && (E.overflowX === "auto" || E.overflowX === "scroll"), C = b < T && (E.overflowY === "auto" || E.overflowY === "scroll"));
      var O = w && (Math.abs(y - i) <= a && R + _ < x) - (Math.abs(v - i) <= a && !!R), P = C && (Math.abs(m - o) <= a && I + b < T) - (Math.abs(g - o) <= a && !!I);
      if (!ai[d])
        for (var k = 0; k <= d; k++)
          ai[k] || (ai[k] = {});
      (ai[d].vx != O || ai[d].vy != P || ai[d].el !== h) && (ai[d].el = h, ai[d].vx = O, ai[d].vy = P, clearInterval(ai[d].pid), (O != 0 || P != 0) && (l = !0, ai[d].pid = setInterval((function() {
        r && this.layer === 0 && Ut.active._onTouchMove(yx);
        var L = ai[this.layer].vy ? ai[this.layer].vy * s : 0, N = ai[this.layer].vx ? ai[this.layer].vx * s : 0;
        typeof u == "function" && u.call(Ut.dragged.parentNode[Hi], N, L, e, yx, ai[this.layer].el) !== "continue" || qce(ai[this.layer].el, N, L);
      }).bind({
        layer: d
      }), 24))), d++;
    } while (t.bubbleScroll && f !== c && (f = cu(f, !1)));
    YP = l;
  }
}, 30), Zce = function(t) {
  var n = t.originalEvent, r = t.putSortable, i = t.dragEl, o = t.activeSortable, a = t.dispatchSortableEvent, s = t.hideGhostForTarget, c = t.unhideGhostForTarget;
  if (n) {
    var l = r || o;
    s();
    var u = n.changedTouches && n.changedTouches.length ? n.changedTouches[0] : n, d = document.elementFromPoint(u.clientX, u.clientY);
    c(), l && !l.el.contains(d) && (a("spill"), this.onSpill({
      dragEl: i,
      putSortable: r
    }));
  }
};
function G4() {
}
G4.prototype = {
  startIndex: null,
  dragStart: function(t) {
    var n = t.oldDraggableIndex;
    this.startIndex = n;
  },
  onSpill: function(t) {
    var n = t.dragEl, r = t.putSortable;
    this.sortable.captureAnimationState(), r && r.captureAnimationState();
    var i = Sp(this.sortable.el, this.startIndex, this.options);
    i ? this.sortable.el.insertBefore(n, i) : this.sortable.el.appendChild(n), this.sortable.animateAll(), r && r.animateAll();
  },
  drop: Zce
};
Ka(G4, {
  pluginName: "revertOnSpill"
});
function K4() {
}
K4.prototype = {
  onSpill: function(t) {
    var n = t.dragEl, r = t.putSortable, i = r || this.sortable;
    i.captureAnimationState(), n.parentNode && n.parentNode.removeChild(n), i.animateAll();
  },
  drop: Zce
};
Ka(K4, {
  pluginName: "removeOnSpill"
});
var ka;
function gwt() {
  function e() {
    this.defaults = {
      swapClass: "sortable-swap-highlight"
    };
  }
  return e.prototype = {
    dragStart: function(n) {
      var r = n.dragEl;
      ka = r;
    },
    dragOverValid: function(n) {
      var r = n.completed, i = n.target, o = n.onMove, a = n.activeSortable, s = n.changed, c = n.cancel;
      if (a.options.swap) {
        var l = this.sortable.el, u = this.options;
        if (i && i !== l) {
          var d = ka;
          o(i) !== !1 ? (Dr(i, u.swapClass, !0), ka = i) : ka = null, d && d !== ka && Dr(d, u.swapClass, !1);
        }
        s(), r(!0), c();
      }
    },
    drop: function(n) {
      var r = n.activeSortable, i = n.putSortable, o = n.dragEl, a = i || this.sortable, s = this.options;
      ka && Dr(ka, s.swapClass, !1), ka && (s.swap || i && i.options.swap) && o !== ka && (a.captureAnimationState(), a !== r && r.captureAnimationState(), pwt(o, ka), a.animateAll(), a !== r && r.animateAll());
    },
    nulling: function() {
      ka = null;
    }
  }, Ka(e, {
    pluginName: "swap",
    eventProperties: function() {
      return {
        swapItem: ka
      };
    }
  });
}
function pwt(e, t) {
  var n = e.parentNode, r = t.parentNode, i, o;
  !n || !r || n.isEqualNode(t) || r.isEqualNode(e) || (i = Gr(e), o = Gr(t), n.isEqualNode(r) && i < o && o++, n.insertBefore(t, n.children[i]), r.insertBefore(e, r.children[o]));
}
var en = [], fa = [], Xm, os, Qm = !1, Wo = !1, Dh = !1, ur, Jm, K1;
function mwt() {
  function e(t) {
    for (var n in this)
      n.charAt(0) === "_" && typeof this[n] == "function" && (this[n] = this[n].bind(this));
    t.options.avoidImplicitDeselect || (t.options.supportPointer ? bn(document, "pointerup", this._deselectMultiDrag) : (bn(document, "mouseup", this._deselectMultiDrag), bn(document, "touchend", this._deselectMultiDrag))), bn(document, "keydown", this._checkKeyDown), bn(document, "keyup", this._checkKeyUp), this.defaults = {
      selectedClass: "sortable-selected",
      multiDragKey: null,
      avoidImplicitDeselect: !1,
      setData: function(i, o) {
        var a = "";
        en.length && os === t ? en.forEach(function(s, c) {
          a += (c ? ", " : "") + s.textContent;
        }) : a = o.textContent, i.setData("Text", a);
      }
    };
  }
  return e.prototype = {
    multiDragKeyDown: !1,
    isMultiDrag: !1,
    delayStartGlobal: function(n) {
      var r = n.dragEl;
      ur = r;
    },
    delayEnded: function() {
      this.isMultiDrag = ~en.indexOf(ur);
    },
    setupClone: function(n) {
      var r = n.sortable, i = n.cancel;
      if (this.isMultiDrag) {
        for (var o = 0; o < en.length; o++)
          fa.push(q4(en[o])), fa[o].sortableIndex = en[o].sortableIndex, fa[o].draggable = !1, fa[o].style["will-change"] = "", Dr(fa[o], this.options.selectedClass, !1), en[o] === ur && Dr(fa[o], this.options.chosenClass, !1);
        r._hideClone(), i();
      }
    },
    clone: function(n) {
      var r = n.sortable, i = n.rootEl, o = n.dispatchSortableEvent, a = n.cancel;
      this.isMultiDrag && (this.options.removeCloneOnHide || en.length && os === r && (IH(!0, i), o("clone"), a()));
    },
    showClone: function(n) {
      var r = n.cloneNowShown, i = n.rootEl, o = n.cancel;
      this.isMultiDrag && (IH(!1, i), fa.forEach(function(a) {
        At(a, "display", "");
      }), r(), K1 = !1, o());
    },
    hideClone: function(n) {
      var r = this;
      n.sortable;
      var i = n.cloneNowHidden, o = n.cancel;
      this.isMultiDrag && (fa.forEach(function(a) {
        At(a, "display", "none"), r.options.removeCloneOnHide && a.parentNode && a.parentNode.removeChild(a);
      }), i(), K1 = !0, o());
    },
    dragStartGlobal: function(n) {
      n.sortable, !this.isMultiDrag && os && os.multiDrag._deselectMultiDrag(), en.forEach(function(r) {
        r.sortableIndex = Gr(r);
      }), en = en.sort(function(r, i) {
        return r.sortableIndex - i.sortableIndex;
      }), Dh = !0;
    },
    dragStarted: function(n) {
      var r = this, i = n.sortable;
      if (this.isMultiDrag) {
        if (this.options.sort && (i.captureAnimationState(), this.options.animation)) {
          en.forEach(function(a) {
            a !== ur && At(a, "position", "absolute");
          });
          var o = br(ur, !1, !0, !0);
          en.forEach(function(a) {
            a !== ur && wH(a, o);
          }), Wo = !0, Qm = !0;
        }
        i.animateAll(function() {
          Wo = !1, Qm = !1, r.options.animation && en.forEach(function(a) {
            DI(a);
          }), r.options.sort && Y1();
        });
      }
    },
    dragOver: function(n) {
      var r = n.target, i = n.completed, o = n.cancel;
      Wo && ~en.indexOf(r) && (i(!1), o());
    },
    revert: function(n) {
      var r = n.fromSortable, i = n.rootEl, o = n.sortable, a = n.dragRect;
      en.length > 1 && (en.forEach(function(s) {
        o.addAnimationState({
          target: s,
          rect: Wo ? br(s) : a
        }), DI(s), s.fromRect = a, r.removeAnimationState(s);
      }), Wo = !1, vwt(!this.options.removeCloneOnHide, i));
    },
    dragOverCompleted: function(n) {
      var r = n.sortable, i = n.isOwner, o = n.insertion, a = n.activeSortable, s = n.parentEl, c = n.putSortable, l = this.options;
      if (o) {
        if (i && a._hideClone(), Qm = !1, l.animation && en.length > 1 && (Wo || !i && !a.options.sort && !c)) {
          var u = br(ur, !1, !0, !0);
          en.forEach(function(f) {
            f !== ur && (wH(f, u), s.appendChild(f));
          }), Wo = !0;
        }
        if (!i)
          if (Wo || Y1(), en.length > 1) {
            var d = K1;
            a._showClone(r), a.options.animation && !K1 && d && fa.forEach(function(f) {
              a.addAnimationState({
                target: f,
                rect: Jm
              }), f.fromRect = Jm, f.thisAnimationDuration = null;
            });
          } else
            a._showClone(r);
      }
    },
    dragOverAnimationCapture: function(n) {
      var r = n.dragRect, i = n.isOwner, o = n.activeSortable;
      if (en.forEach(function(s) {
        s.thisAnimationDuration = null;
      }), o.options.animation && !i && o.multiDrag.isMultiDrag) {
        Jm = Ka({}, r);
        var a = af(ur, !0);
        Jm.top -= a.f, Jm.left -= a.e;
      }
    },
    dragOverAnimationComplete: function() {
      Wo && (Wo = !1, Y1());
    },
    drop: function(n) {
      var r = n.originalEvent, i = n.rootEl, o = n.parentEl, a = n.sortable, s = n.dispatchSortableEvent, c = n.oldIndex, l = n.putSortable, u = l || this.sortable;
      if (r) {
        var d = this.options, f = o.children;
        if (!Dh)
          if (d.multiDragKey && !this.multiDragKeyDown && this._deselectMultiDrag(), Dr(ur, d.selectedClass, !~en.indexOf(ur)), ~en.indexOf(ur))
            en.splice(en.indexOf(ur), 1), Xm = null, S0({
              sortable: a,
              rootEl: i,
              name: "deselect",
              targetEl: ur,
              originalEvent: r
            });
          else {
            if (en.push(ur), S0({
              sortable: a,
              rootEl: i,
              name: "select",
              targetEl: ur,
              originalEvent: r
            }), r.shiftKey && Xm && a.el.contains(Xm)) {
              var h = Gr(Xm), p = Gr(ur);
              if (~h && ~p && h !== p) {
                var g, m;
                for (p > h ? (m = h, g = p) : (m = p, g = h + 1); m < g; m++)
                  ~en.indexOf(f[m]) || (Dr(f[m], d.selectedClass, !0), en.push(f[m]), S0({
                    sortable: a,
                    rootEl: i,
                    name: "select",
                    targetEl: f[m],
                    originalEvent: r
                  }));
              }
            } else
              Xm = ur;
            os = u;
          }
        if (Dh && this.isMultiDrag) {
          if (Wo = !1, (o[Hi].options.sort || o !== i) && en.length > 1) {
            var v = br(ur), y = Gr(ur, ":not(." + this.options.selectedClass + ")");
            if (!Qm && d.animation && (ur.thisAnimationDuration = null), u.captureAnimationState(), !Qm && (d.animation && (ur.fromRect = v, en.forEach(function(b) {
              if (b.thisAnimationDuration = null, b !== ur) {
                var w = Wo ? br(b) : v;
                b.fromRect = w, u.addAnimationState({
                  target: b,
                  rect: w
                });
              }
            })), Y1(), en.forEach(function(b) {
              f[y] ? o.insertBefore(b, f[y]) : o.appendChild(b), y++;
            }), c === Gr(ur))) {
              var _ = !1;
              en.forEach(function(b) {
                if (b.sortableIndex !== Gr(b)) {
                  _ = !0;
                  return;
                }
              }), _ && (s("update"), s("sort"));
            }
            en.forEach(function(b) {
              DI(b);
            }), u.animateAll();
          }
          os = u;
        }
        (i === o || l && l.lastPutMode !== "clone") && fa.forEach(function(b) {
          b.parentNode && b.parentNode.removeChild(b);
        });
      }
    },
    nullingGlobal: function() {
      this.isMultiDrag = Dh = !1, fa.length = 0;
    },
    destroyGlobal: function() {
      this._deselectMultiDrag(), pn(document, "pointerup", this._deselectMultiDrag), pn(document, "mouseup", this._deselectMultiDrag), pn(document, "touchend", this._deselectMultiDrag), pn(document, "keydown", this._checkKeyDown), pn(document, "keyup", this._checkKeyUp);
    },
    _deselectMultiDrag: function(n) {
      if (!(typeof Dh < "u" && Dh) && os === this.sortable && !(n && ja(n.target, this.options.draggable, this.sortable.el, !1)) && !(n && n.button !== 0))
        for (; en.length; ) {
          var r = en[0];
          Dr(r, this.options.selectedClass, !1), en.shift(), S0({
            sortable: this.sortable,
            rootEl: this.sortable.el,
            name: "deselect",
            targetEl: r,
            originalEvent: n
          });
        }
    },
    _checkKeyDown: function(n) {
      n.key === this.options.multiDragKey && (this.multiDragKeyDown = !0);
    },
    _checkKeyUp: function(n) {
      n.key === this.options.multiDragKey && (this.multiDragKeyDown = !1);
    }
  }, Ka(e, {
    // Static methods & properties
    pluginName: "multiDrag",
    utils: {
      /**
       * Selects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be selected
       */
      select: function(n) {
        var r = n.parentNode[Hi];
        !r || !r.options.multiDrag || ~en.indexOf(n) || (os && os !== r && (os.multiDrag._deselectMultiDrag(), os = r), Dr(n, r.options.selectedClass, !0), en.push(n));
      },
      /**
       * Deselects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be deselected
       */
      deselect: function(n) {
        var r = n.parentNode[Hi], i = en.indexOf(n);
        !r || !r.options.multiDrag || !~i || (Dr(n, r.options.selectedClass, !1), en.splice(i, 1));
      }
    },
    eventProperties: function() {
      var n = this, r = [], i = [];
      return en.forEach(function(o) {
        r.push({
          multiDragElement: o,
          index: o.sortableIndex
        });
        var a;
        Wo && o !== ur ? a = -1 : Wo ? a = Gr(o, ":not(." + n.options.selectedClass + ")") : a = Gr(o), i.push({
          multiDragElement: o,
          index: a
        });
      }), {
        items: zSt(en),
        clones: [].concat(fa),
        oldIndicies: r,
        newIndicies: i
      };
    },
    optionListeners: {
      multiDragKey: function(n) {
        return n = n.toLowerCase(), n === "ctrl" ? n = "Control" : n.length > 1 && (n = n.charAt(0).toUpperCase() + n.substr(1)), n;
      }
    }
  });
}
function vwt(e, t) {
  en.forEach(function(n, r) {
    var i = t.children[n.sortableIndex + (e ? Number(r) : 0)];
    i ? t.insertBefore(n, i) : t.appendChild(n);
  });
}
function IH(e, t) {
  fa.forEach(function(n, r) {
    var i = t.children[n.sortableIndex + (e ? Number(r) : 0)];
    i ? t.insertBefore(n, i) : t.appendChild(n);
  });
}
function Y1() {
  en.forEach(function(e) {
    e !== ur && e.parentNode && e.parentNode.removeChild(e);
  });
}
Ut.mount(new hwt());
Ut.mount(K4, G4);
const ywt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MultiDrag: mwt,
  Sortable: Ut,
  Swap: gwt,
  default: Ut
}, Symbol.toStringTag, { value: "Module" })), bwt = /* @__PURE__ */ Ic(ywt);
var ele = { exports: {} };
/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function n() {
      for (var r = [], i = 0; i < arguments.length; i++) {
        var o = arguments[i];
        if (o) {
          var a = typeof o;
          if (a === "string" || a === "number")
            r.push(o);
          else if (Array.isArray(o)) {
            if (o.length) {
              var s = n.apply(null, o);
              s && r.push(s);
            }
          } else if (a === "object")
            if (o.toString === Object.prototype.toString)
              for (var c in o)
                t.call(o, c) && o[c] && r.push(c);
            else
              r.push(o.toString());
        }
      }
      return r.join(" ");
    }
    e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
  })();
})(ele);
var _wt = ele.exports, Swt = process.env.NODE_ENV === "production", WI = "Invariant failed";
function wwt(e, t) {
  if (!e) {
    if (Swt)
      throw new Error(WI);
    var n = typeof t == "function" ? t() : t, r = n ? WI + ": " + n : WI;
    throw new Error(r);
  }
}
const xwt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: wwt
}, Symbol.toStringTag, { value: "Module" })), Ewt = /* @__PURE__ */ Ic(xwt);
(function(e) {
  var t = bwt, n = _wt, r = j, i = Ewt;
  function o(C) {
    return C && C.__esModule ? C.default : C;
  }
  function a(C, x, T, E) {
    Object.defineProperty(C, x, { get: T, set: E, enumerable: !0, configurable: !0 });
  }
  function s(C, x) {
    return Object.keys(x).forEach(function(T) {
      T === "default" || T === "__esModule" || C.hasOwnProperty(T) || Object.defineProperty(C, T, {
        enumerable: !0,
        get: function() {
          return x[T];
        }
      });
    }), C;
  }
  a(e.exports, "Sortable", () => $882b6d93070905b3$re_export$Sortable), a(e.exports, "Direction", () => $882b6d93070905b3$re_export$Direction), a(e.exports, "DOMRect", () => $882b6d93070905b3$re_export$DOMRect), a(e.exports, "GroupOptions", () => $882b6d93070905b3$re_export$GroupOptions), a(e.exports, "MoveEvent", () => $882b6d93070905b3$re_export$MoveEvent), a(e.exports, "Options", () => $882b6d93070905b3$re_export$Options), a(e.exports, "PullResult", () => $882b6d93070905b3$re_export$PullResult), a(e.exports, "PutResult", () => $882b6d93070905b3$re_export$PutResult), a(e.exports, "SortableEvent", () => $882b6d93070905b3$re_export$SortableEvent), a(e.exports, "SortableOptions", () => $882b6d93070905b3$re_export$SortableOptions), a(e.exports, "Utils", () => $882b6d93070905b3$re_export$Utils), a(e.exports, "ReactSortable", () => b);
  function c(C) {
    C.parentElement !== null && C.parentElement.removeChild(C);
  }
  function l(C, x, T) {
    const E = C.children[T] || null;
    C.insertBefore(x, E);
  }
  function u(C) {
    C.forEach((x) => c(x.element));
  }
  function d(C) {
    C.forEach((x) => {
      l(x.parentElement, x.element, x.oldIndex);
    });
  }
  function f(C, x) {
    const T = m(C), E = {
      parentElement: C.from
    };
    let R = [];
    switch (T) {
      case "normal":
        R = [
          {
            element: C.item,
            newIndex: C.newIndex,
            oldIndex: C.oldIndex,
            parentElement: C.from
          }
        ];
        break;
      case "swap":
        const P = {
          element: C.item,
          oldIndex: C.oldIndex,
          newIndex: C.newIndex,
          ...E
        }, k = {
          element: C.swapItem,
          oldIndex: C.newIndex,
          newIndex: C.oldIndex,
          ...E
        };
        R = [
          P,
          k
        ];
        break;
      case "multidrag":
        R = C.oldIndicies.map((L, N) => ({
          element: L.multiDragElement,
          oldIndex: L.index,
          newIndex: C.newIndicies[N].index,
          ...E
        }));
        break;
    }
    return v(R, x);
  }
  function h(C, x) {
    const T = p(C, x);
    return g(C, T);
  }
  function p(C, x) {
    const T = [
      ...x
    ];
    return C.concat().reverse().forEach((E) => T.splice(E.oldIndex, 1)), T;
  }
  function g(C, x, T, E) {
    const R = [
      ...x
    ];
    return C.forEach((I) => {
      const O = E && T && E(I.item, T);
      R.splice(I.newIndex, 0, O || I.item);
    }), R;
  }
  function m(C) {
    return C.oldIndicies && C.oldIndicies.length > 0 ? "multidrag" : C.swapItem ? "swap" : "normal";
  }
  function v(C, x) {
    return C.map((E) => ({
      ...E,
      item: x[E.oldIndex]
    })).sort((E, R) => E.oldIndex - R.oldIndex);
  }
  function y(C) {
    const { list: x, setList: T, children: E, tag: R, style: I, className: O, clone: P, onAdd: k, onChange: L, onChoose: N, onClone: D, onEnd: z, onFilter: V, onRemove: B, onSort: U, onStart: Q, onUnchoose: Y, onUpdate: q, onMove: X, onSpill: ne, onSelect: Z, onDeselect: J, ...K } = C;
    return K;
  }
  const _ = {
    dragging: null
  };
  class b extends r.Component {
    constructor(x) {
      super(x), this.ref = /* @__PURE__ */ (0, r.createRef)();
      const T = [
        ...x.list
      ].map((E) => Object.assign(E, {
        chosen: !1,
        selected: !1
      }));
      x.setList(T, this.sortable, _), o(i)(
        //@ts-expect-error: Doesn't exist. Will deprecate soon.
        !x.plugins,
        `
Plugins prop is no longer supported.
Instead, mount it with "Sortable.mount(new MultiDrag())"
Please read the updated README.md at https://github.com/SortableJS/react-sortablejs.
      `
      );
    }
    componentDidMount() {
      if (this.ref.current === null)
        return;
      const x = this.makeOptions();
      o(t).create(this.ref.current, x);
    }
    componentDidUpdate(x) {
      x.disabled !== this.props.disabled && this.sortable && this.sortable.option("disabled", this.props.disabled);
    }
    render() {
      const { tag: x, style: T, className: E, id: R } = this.props, I = {
        style: T,
        className: E,
        id: R
      }, O = !x || x === null ? "div" : x;
      return /* @__PURE__ */ (0, r.createElement)(O, {
        // @todo - find a way (perhaps with the callback) to allow AntD components to work
        ref: this.ref,
        ...I
      }, this.getChildren());
    }
    getChildren() {
      const { children: x, dataIdAttr: T, selectedClass: E = "sortable-selected", chosenClass: R = "sortable-chosen", dragClass: I = "sortable-drag", fallbackClass: O = "sortable-falback", ghostClass: P = "sortable-ghost", swapClass: k = "sortable-swap-highlight", filter: L = "sortable-filter", list: N } = this.props;
      if (!x || x == null)
        return null;
      const D = T || "data-id";
      return r.Children.map(x, (z, V) => {
        if (z === void 0)
          return;
        const B = N[V] || {}, { className: U } = z.props, Q = typeof L == "string" && {
          [L.replace(".", "")]: !!B.filtered
        }, Y = o(n)(U, {
          [E]: B.selected,
          [R]: B.chosen,
          ...Q
        });
        return /* @__PURE__ */ (0, r.cloneElement)(z, {
          [D]: z.key,
          className: Y
        });
      });
    }
    /** Appends the `sortable` property to this component */
    get sortable() {
      const x = this.ref.current;
      if (x === null)
        return null;
      const T = Object.keys(x).find((E) => E.includes("Sortable"));
      return T ? x[T] : null;
    }
    /** Converts all the props from `ReactSortable` into the `options` object that `Sortable.create(el, [options])` can use. */
    makeOptions() {
      const x = [
        "onAdd",
        "onChoose",
        "onDeselect",
        "onEnd",
        "onRemove",
        "onSelect",
        "onSpill",
        "onStart",
        "onUnchoose",
        "onUpdate"
      ], T = [
        "onChange",
        "onClone",
        "onFilter",
        "onSort"
      ], E = y(this.props);
      return x.forEach((I) => E[I] = this.prepareOnHandlerPropAndDOM(I)), T.forEach((I) => E[I] = this.prepareOnHandlerProp(I)), {
        ...E,
        onMove: (I, O) => {
          const { onMove: P } = this.props, k = I.willInsertAfter || -1;
          if (!P)
            return k;
          const L = P(I, O, this.sortable, _);
          return typeof L > "u" ? !1 : L;
        }
      };
    }
    /** Prepares a method that will be used in the sortable options to call an `on[Handler]` prop & an `on[Handler]` ReactSortable method.  */
    prepareOnHandlerPropAndDOM(x) {
      return (T) => {
        this.callOnHandlerProp(T, x), this[x](T);
      };
    }
    /** Prepares a method that will be used in the sortable options to call an `on[Handler]` prop */
    prepareOnHandlerProp(x) {
      return (T) => {
        this.callOnHandlerProp(T, x);
      };
    }
    /** Calls the `props.on[Handler]` function */
    callOnHandlerProp(x, T) {
      const E = this.props[T];
      E && E(x, this.sortable, _);
    }
    // SORTABLE DOM HANDLING
    onAdd(x) {
      const { list: T, setList: E, clone: R } = this.props, I = [
        ..._.dragging.props.list
      ], O = f(x, I);
      u(O);
      const P = g(O, T, x, R).map((k) => Object.assign(k, {
        selected: !1
      }));
      E(P, this.sortable, _);
    }
    onRemove(x) {
      const { list: T, setList: E } = this.props, R = m(x), I = f(x, T);
      d(I);
      let O = [
        ...T
      ];
      if (x.pullMode !== "clone")
        O = p(I, O);
      else {
        let P = I;
        switch (R) {
          case "multidrag":
            P = I.map((k, L) => ({
              ...k,
              element: x.clones[L]
            }));
            break;
          case "normal":
            P = I.map((k) => ({
              ...k,
              element: x.clone
            }));
            break;
          case "swap":
          default:
            o(i)(!0, `mode "${R}" cannot clone. Please remove "props.clone" from <ReactSortable/> when using the "${R}" plugin`);
        }
        u(P), I.forEach((k) => {
          const L = k.oldIndex, N = this.props.clone(k.item, x);
          O.splice(L, 1, N);
        });
      }
      O = O.map((P) => Object.assign(P, {
        selected: !1
      })), E(O, this.sortable, _);
    }
    onUpdate(x) {
      const { list: T, setList: E } = this.props, R = f(x, T);
      u(R), d(R);
      const I = h(R, T);
      return E(I, this.sortable, _);
    }
    onStart() {
      _.dragging = this;
    }
    onEnd() {
      _.dragging = null;
    }
    onChoose(x) {
      const { list: T, setList: E } = this.props, R = T.map((I, O) => {
        let P = I;
        return O === x.oldIndex && (P = Object.assign(I, {
          chosen: !0
        })), P;
      });
      E(R, this.sortable, _);
    }
    onUnchoose(x) {
      const { list: T, setList: E } = this.props, R = T.map((I, O) => {
        let P = I;
        return O === x.oldIndex && (P = Object.assign(P, {
          chosen: !1
        })), P;
      });
      E(R, this.sortable, _);
    }
    onSpill(x) {
      const { removeOnSpill: T, revertOnSpill: E } = this.props;
      T && !E && c(x.item);
    }
    onSelect(x) {
      const { list: T, setList: E } = this.props, R = T.map((I) => Object.assign(I, {
        selected: !1
      }));
      x.newIndicies.forEach((I) => {
        const O = I.index;
        if (O === -1) {
          console.log(`"${x.type}" had indice of "${I.index}", which is probably -1 and doesn't usually happen here.`), console.log(x);
          return;
        }
        R[O].selected = !0;
      }), E(R, this.sortable, _);
    }
    onDeselect(x) {
      const { list: T, setList: E } = this.props, R = T.map((I) => Object.assign(I, {
        selected: !1
      }));
      x.newIndicies.forEach((I) => {
        const O = I.index;
        O !== -1 && (R[O].selected = !0);
      }), E(R, this.sortable, _);
    }
  }
  /* eslint-disable-next-line */
  ve(b, "defaultProps", {
    clone: (x) => x
  });
  var w = {};
  s(e.exports, w);
})(Fce);
var Cwt = Fce.exports;
const Twt = (e) => {
  const t = Mi(), { primaryColour: n } = Gn();
  return /* @__PURE__ */ A.jsxs(
    Iwt,
    {
      primaryColour: n,
      borderRadius: t,
      disabled: e.disabled,
      children: [
        /* @__PURE__ */ A.jsx(zee, { style: { fontSize: 26 } }),
        e.children
      ]
    }
  );
}, Iwt = ce.div`
  display: flex;
  flex-grow: 1;
  gap: var(--spacing-sm);
  min-height: var(--button-height);
  cursor: ${(e) => e.disabled ? "default" : "grab"};
  user-select: none;
  align-items: center;
  padding: var(--spacing-xxs) var(--spacing-sm);
  background-color: var(--light);

  border: 1px solid var(--mid);

  border-radius: ${(e) => e.borderRadius};

  @media (hover: hover) {
    &:hover {
      border-color: ${(e) => e.primaryColour};
      box-shadow: 0 0 5px 0px rgba(0, 0, 0, 0.3);
    }
  }

  span {
    /* width: 100%; */
    font-size: var(--choice-text-font-size);
    text-align: left;
    text-overflow: ellipsis;
    word-wrap: break-word;
    word-break: break-word;
    color: var(--dark);
  }
`, $wt = ({ item: e, onChange: t }) => {
  const { primaryColour: n } = Gn(), r = Mi();
  return /* @__PURE__ */ A.jsxs(Awt, { borderRadius: r, primaryColour: n, children: [
    /* @__PURE__ */ A.jsx(zee, { style: { fontSize: 26 } }),
    /* @__PURE__ */ A.jsx(
      U4,
      {
        inputValue: e.value,
        onValueChange: t,
        placeholder: e.placeholder,
        label: e.text ? qn(e.text) : "",
        primaryColour: n,
        noBorder: !0
      }
    )
  ] });
}, Awt = ce.div`
  display: flex;
  flex-grow: 1;
  /* gap: var(--spacing-sm); */

  min-height: var(--button-height);
  cursor: grab;
  user-select: none;
  align-items: center;
  padding: var(--spacing-xxs) var(--spacing-sm);
  border: 1px solid var(--mid);
  border-radius: ${(e) => e.borderRadius};
  background-color: var(--light);
  @media (hover: hover) {
    &:hover {
      border-color: ${(e) => e.primaryColour};
      box-shadow: 0 0 5px 0px rgba(0, 0, 0, 0.3);
    }
  }
`, Rwt = ({
  updateCurrent: e,
  currentAnswer: t,
  settings: n,
  question: r,
  submitAnswer: i,
  injectCurrent: o,
  answers: a,
  setNextButtonBehaviour: s
}) => {
  const { loggingService: c, messagerService: l, popupService: u } = gt(mn), { choices: d, ready: f } = yl(
    r.choices,
    a
  );
  Xi(r, (x) => {
    const T = x.getValue("ranking");
    return ec(
      T !== null && d.every((E) => T.some((R) => R.id === E.id)),
      f
    );
  }), Dy(JP(d), t, o);
  const h = t.getValue(r.type), p = kwt(h, d), { primaryColour: g } = Gn(), m = Mi(), v = (x) => {
    if (c.info("onListChange", x), x.length > 0) {
      const T = qI(x);
      o({ value: T });
    }
  };
  ot(() => {
    const x = t.getValue(r.type);
    if (x !== null && d.length !== 0) {
      const T = tle(x, d);
      if (Dwt(x, T))
        return;
      const E = qI(T);
      o({ value: E });
    }
  }, [d, t, o, r.type]);
  const y = (x, T) => {
    if (r.disabled)
      return;
    const E = x + T;
    if (E < 0 || E >= p.length)
      return;
    const R = [...p], [I] = R.splice(x, 1);
    R.splice(E, 0, I), v(R);
  };
  ot(() => {
    const x = t.getValue(r.type);
    if (r.required)
      if (x && x.length > 0)
        s(void 0);
      else
        return s(() => {
          const E = qI(d);
          o({ value: E }), l.warning(
            `It looks like you haven't made any changes to the ranking. If you're happy with the ranking, please click "Next" again.`
          );
        }), () => {
          s(void 0);
        };
  }, [
    r.required,
    r.type,
    t,
    d,
    o,
    i,
    s
  ]);
  const b = Ms({
    default: {
      content: "Drag and drop to rank the options. Once you are happy with your ranking, click next to continue"
    },
    notRequired: { content: "Please drag and drop to rank the options, or click next to continue" }
  }, r.helpPopups), w = r.showHelpPopups ?? !1, C = r.helpPopupsToShow;
  return ot(() => {
    r.required ? u.setPopup(b, "default", w, C) : u.setPopup(b, "notRequired", w, C);
  }, [b, w, C, r.required]), /* @__PURE__ */ A.jsx(jwt, { $dynamicColour: g, $borderRadius: m, children: /* @__PURE__ */ A.jsx(
    Cwt.ReactSortable,
    {
      className: "sortableContainer",
      animation: 200,
      ghostClass: "ghost",
      list: p,
      setList: v,
      filter: "input, button",
      preventOnFilter: !1,
      delay: 100,
      delayOnTouchOnly: !0,
      touchStartThreshold: 4,
      disabled: r.disabled,
      children: p.map((x, T) => /* @__PURE__ */ A.jsxs(Lwt, { children: [
        /* @__PURE__ */ A.jsxs(Fwt, { children: [
          /* @__PURE__ */ A.jsx(
            $H,
            {
              type: "button",
              "aria-label": `Move rank ${T + 1} up`,
              title: "Move up",
              $dynamicColour: g,
              disabled: r.disabled || T === 0,
              onClick: () => y(T, -1),
              children: /* @__PURE__ */ A.jsx(vee, {})
            }
          ),
          /* @__PURE__ */ A.jsx(Vwt, { $dynamicColour: g, children: T + 1 }),
          /* @__PURE__ */ A.jsx(
            $H,
            {
              type: "button",
              "aria-label": `Move rank ${T + 1} down`,
              title: "Move down",
              $dynamicColour: g,
              disabled: r.disabled || T === p.length - 1,
              onClick: () => y(T, 1),
              children: /* @__PURE__ */ A.jsx(GM, {})
            }
          )
        ] }),
        /* @__PURE__ */ A.jsx(
          Pwt,
          {
            item: x,
            settings: n,
            listState: p,
            onListChange: v,
            disabled: r.disabled,
            colour: r.shade ? g : void 0
          }
        )
      ] }, x.id))
    }
  ) });
}, Pwt = (e) => e.item.type === "input" ? /* @__PURE__ */ A.jsx(Mwt, { ...e }) : /* @__PURE__ */ A.jsx(Owt, { ...e }), Owt = ({ item: e, disabled: t }) => /* @__PURE__ */ A.jsx(A.Fragment, { children: /* @__PURE__ */ A.jsx(Twt, { disabled: t, children: /* @__PURE__ */ A.jsx("span", { children: e.text ? qn(e.text) : e.value }) }, e.id) }), Mwt = ({ item: e, settings: t, listState: n, onListChange: r }) => {
  const i = (o) => {
    const a = n.map((s) => s.id === e.id ? { ...s, value: o.target.value } : s);
    r(a);
  };
  return /* @__PURE__ */ A.jsx($wt, { item: e, onChange: i });
};
function kwt(e, t) {
  return e && e.length > 0 && t.length > 0 ? tle(e, t) : t;
}
function tle(e, t) {
  const n = e.map((i) => {
    const o = t.find((a) => a.id === i.id);
    if (o !== void 0)
      return Nwt(o, i);
  }).filter((i) => i !== void 0), r = t.filter(
    (i) => !e.find((o) => o.id === i.id)
  );
  return [...n, ...r];
}
function Nwt(e, t) {
  var r;
  if (e.type !== "input")
    return e;
  const n = (r = t.info) == null ? void 0 : r.itemValue;
  return typeof n != "string" ? e : { ...e, value: n };
}
function Dwt(e, t) {
  return e.length !== t.length ? !1 : t.every((n, r) => {
    var o;
    const i = e[r];
    return i.id === n.id && i.value === (r + 1).toFixed(0) && ((o = i.info) == null ? void 0 : o.itemValue) === n.value;
  });
}
function qI(e) {
  return e.map((n, r) => ({ id: n.id, value: (r + 1).toFixed(0), info: { itemValue: n.value } }));
}
const jwt = ce.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: stretch;

  .sortableContainer {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 0.5rem;
    cursor: grab;
  }

  .ghost {
    opacity: 0.5;
    background: ${(e) => e.$dynamicColour};
    border-radius: ${(e) => e.$borderRadius};
    cursor: grabbing;
  }
`, Lwt = ce.div`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  gap: 0.5rem;
`, Fwt = ce.div`
  display: flex;
  flex: 0 0 var(--spacing-lg);
  flex-direction: column;
  align-items: center;
  justify-content: center;
`, Vwt = ce.div`
  font-size: 1.5rem;
  line-height: 1.2;
  display: flex;
  min-height: 1.5rem;
  align-items: center;
  justify-content: center;
  color: ${(e) => e.$dynamicColour};
  pointer-events: none;
`, $H = ce.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: var(--spacing-lg);
  height: 0.85rem;
  padding: 0;
  border: 0;
  border-radius: 2px;
  background: transparent;
  color: ${(e) => e.$dynamicColour};
  cursor: pointer;

  &:disabled {
    cursor: default;
    opacity: 0.25;
  }

  &:not(:disabled):hover {
    background: var(--light);
  }

  &:focus-visible {
    outline: 2px solid ${(e) => e.$dynamicColour};
    outline-offset: 1px;
  }

  svg {
    font-size: 0.75rem;
  }
`, Bwt = (e) => {
  const t = No();
  let n = { ...e.question, type: "slider", vertical: !0 };
  t !== Xn.MOBILE && (n = { ...e.question, type: "slider", vertical: !1 });
  const r = {
    ...e,
    question: n,
    currentAnswer: e.currentAnswer.convertedToQuestionType("slider")
  };
  return /* @__PURE__ */ A.jsx(Nce, { ...r });
}, zwt = Array.from({ length: 12 }, (e, t) => t);
function Hwt({
  outcome: e,
  primaryColour: t,
  contrastColour: n,
  shadeColour: r,
  borderRadius: i
}) {
  return /* @__PURE__ */ A.jsxs(qwt, { "aria-hidden": "true", "data-testid": "gift-card-reveal", children: [
    e.won ? zwt.map((o) => /* @__PURE__ */ A.jsx(
      Kwt,
      {
        $index: o,
        $colour: o % 2 === 0 ? t : r
      },
      o
    )) : null,
    /* @__PURE__ */ A.jsxs(
      Gwt,
      {
        $won: e.won,
        $primaryColour: t,
        $contrastColour: n,
        $borderRadius: i,
        children: [
          /* @__PURE__ */ A.jsx("span", { children: e.won ? "YOU WON" : "THANK YOU" }),
          /* @__PURE__ */ A.jsx("small", { children: e.prizeLabel })
        ]
      }
    )
  ] });
}
const Uwt = gi`
  0% {
    opacity: 0;
    transform: translateY(1.5rem) rotate(-5deg) scale(0.85);
  }
  70% {
    opacity: 1;
    transform: translateY(-0.2rem) rotate(1deg) scale(1.03);
  }
  100% {
    opacity: 1;
    transform: translateY(0) rotate(0) scale(1);
  }
`, Wwt = gi`
  0% {
    opacity: 0;
    transform: translate(0, 0) rotate(0);
  }
  25% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    transform: translate(var(--confetti-x), var(--confetti-y)) rotate(240deg);
  }
`, qwt = ce.div`
  position: relative;
  display: grid;
  width: min(100%, 18rem);
  min-height: 8.5rem;
  place-items: center;
`, Gwt = ce.div`
  position: relative;
  z-index: 1;
  display: flex;
  width: 13rem;
  min-height: 7rem;
  padding: 1rem;
  border: 1px solid ${(e) => e.$primaryColour};
  border-radius: ${(e) => e.$borderRadius};
  background: ${(e) => e.$won ? `linear-gradient(135deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.28)), ${e.$primaryColour}` : `linear-gradient(135deg, white, ${e.$primaryColour}18)`};
  box-shadow: 0 1rem 2rem rgba(41, 50, 56, 0.18);
  color: ${(e) => e.$won ? e.$contrastColour : e.$primaryColour};
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  animation: ${Uwt} 700ms cubic-bezier(0.22, 1, 0.36, 1) both;
  text-align: left;

  span {
    font-size: 1.15rem;
    font-weight: 700;
    letter-spacing: 0.08em;
  }

  small {
    font-size: 0.9rem;
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`, Kwt = ce.span`
  --confetti-x: ${(e) => `${(Math.cos(e.$index * Math.PI / 6) * 7).toFixed(2)}rem`};
  --confetti-y: ${(e) => `${(Math.sin(e.$index * Math.PI / 6) * 5).toFixed(2)}rem`};
  position: absolute;
  z-index: 0;
  width: 0.45rem;
  height: 0.8rem;
  border-radius: 0.15rem;
  background: ${(e) => e.$colour};
  animation: ${Wwt} 900ms ${(e) => e.$index * 25}ms ease-out both;

  @media (prefers-reduced-motion: reduce) {
    display: none;
  }
`;
function AH({ primaryColour: e, className: t, title: n }) {
  return /* @__PURE__ */ A.jsxs(
    Xwt,
    {
      "aria-hidden": n ? void 0 : !0,
      className: t,
      role: n ? "img" : void 0,
      viewBox: "0 0 110 80",
      $primaryColour: e,
      children: [
        n ? /* @__PURE__ */ A.jsx("title", { children: n }) : null,
        /* @__PURE__ */ A.jsx("ellipse", { cx: "56", cy: "74", rx: "31", ry: "3.5", fill: "#293238", opacity: "0.1" }),
        /* @__PURE__ */ A.jsx("g", { className: "tail", children: /* @__PURE__ */ A.jsx(
          "path",
          {
            d: "M28 45 C13 42 8 34 10 25 C11 20 14 16 18 13",
            fill: "none",
            stroke: "#b66d3c",
            strokeLinecap: "round",
            strokeWidth: "10"
          }
        ) }),
        /* @__PURE__ */ A.jsx(
          "path",
          {
            d: "M31 48 C29 55 29 63 29 69 C29 72 31 74 34 74 H36 C39 74 41 72 41 69 V49 Z",
            fill: "#985832"
          }
        ),
        /* @__PURE__ */ A.jsx(
          "path",
          {
            d: "M63 49 C62 56 62 64 62 69 C62 72 64 74 67 74 H69 C72 74 74 72 74 69 V48 Z",
            fill: "#9f5e35"
          }
        ),
        /* @__PURE__ */ A.jsx(
          "path",
          {
            d: "M26 44 C27 34 39 28 54 28 C68 28 78 33 83 42 C83 52 73 61 59 63 H43 C32 62 25 55 26 44 Z",
            fill: "#c9854e"
          }
        ),
        /* @__PURE__ */ A.jsx(
          "path",
          {
            d: "M29 43 C32 35 42 32 54 32 C61 32 67 34 71 37 C61 36 51 39 47 46 C43 53 46 59 50 63 H43 C32 62 25 55 26 44 Z",
            fill: "#d38d54",
            opacity: "0.72"
          }
        ),
        /* @__PURE__ */ A.jsx(
          "path",
          {
            d: "M64.5 38 C67.5 45 73.5 50 82 52",
            fill: "none",
            className: "collar",
            strokeLinecap: "round",
            strokeWidth: "6"
          }
        ),
        /* @__PURE__ */ A.jsx("path", { d: "M68 22 C63 14 63 7 67 5 C72 3 78 11 80 20 L76 30 Z", fill: "#75452f" }),
        /* @__PURE__ */ A.jsx("path", { d: "M91 19 C96 10 101 6 104 9 C108 13 104 23 97 29 Z", fill: "#75452f" }),
        /* @__PURE__ */ A.jsx(
          "path",
          {
            d: "M64 31 C64 20 72 13 83 13 C96 13 103 22 102 34 C102 45 94 51 83 51 C72 51 65 43 64 31 Z",
            fill: "#d99a61"
          }
        ),
        /* @__PURE__ */ A.jsx(
          "path",
          {
            d: "M65 29 C66 21 72 16 79 14 C75 20 75 27 79 32 C82 36 87 38 92 38 C90 45 85 49 78 50 C69 48 64 41 64 31 Z",
            fill: "#e4a364",
            opacity: "0.78"
          }
        ),
        /* @__PURE__ */ A.jsx(
          "path",
          {
            d: "M78 50 L83 53.5 L80 59 L74.5 55 Z",
            className: "tag",
            stroke: "#8a512f",
            strokeLinejoin: "round",
            strokeWidth: "1.25"
          }
        ),
        /* @__PURE__ */ A.jsx("circle", { cx: "79.2", cy: "53.5", r: "0.9", fill: "#ffffff", opacity: "0.8" }),
        /* @__PURE__ */ A.jsx("ellipse", { cx: "99", cy: "38", rx: "14", ry: "10.5", fill: "#f3d2a7" }),
        /* @__PURE__ */ A.jsx("ellipse", { cx: "106", cy: "34.5", rx: "4.6", ry: "4", fill: "#293238" }),
        /* @__PURE__ */ A.jsx("circle", { cx: "107.2", cy: "33.3", r: "1", fill: "#ffffff", opacity: "0.68" }),
        /* @__PURE__ */ A.jsx("circle", { cx: "86", cy: "28", r: "3.5", fill: "#293238" }),
        /* @__PURE__ */ A.jsx("circle", { cx: "87.1", cy: "26.9", r: "1.15", fill: "#ffffff" }),
        /* @__PURE__ */ A.jsx(
          "path",
          {
            d: "M95 42.5 C98 45.5 102 46 105 43",
            fill: "none",
            stroke: "#293238",
            strokeLinecap: "round",
            strokeWidth: "2"
          }
        ),
        /* @__PURE__ */ A.jsx(
          "path",
          {
            d: "M99 45 C99.5 48 102.5 48.5 104 45.5",
            fill: "#e98580",
            stroke: "#293238",
            strokeLinejoin: "round",
            strokeWidth: "1.2"
          }
        )
      ]
    }
  );
}
const Ywt = gi`
  0%, 100% {
    transform: rotate(-7deg);
  }
  50% {
    transform: rotate(13deg);
  }
`, Xwt = ce.svg`
  display: block;
  width: 100%;
  overflow: visible;

  .tail {
    transform-box: fill-box;
    transform-origin: right center;
    animation: ${Ywt} 420ms ease-in-out infinite;
  }

  .collar {
    stroke: ${(e) => e.$primaryColour};
  }

  .tag {
    fill: ${(e) => e.$primaryColour};
  }

  @media (prefers-reduced-motion: reduce) {
    .tail {
      animation: none;
    }
  }
`, Qwt = [-2.4, -1.7, -0.9, 0.9, 1.7, 2.4], Jwt = Array.from({ length: 6 }, (e, t) => t);
function Zwt({
  outcome: e,
  primaryColour: t,
  contrastColour: n,
  shadeColour: r,
  borderRadius: i
}) {
  return /* @__PURE__ */ A.jsx(cxt, { "aria-hidden": "true", "data-testid": "treasure-map-dog-reveal", children: /* @__PURE__ */ A.jsxs(
    lxt,
    {
      $borderRadius: i,
      $primaryColour: t,
      $shadeColour: r,
      children: [
        /* @__PURE__ */ A.jsxs(uxt, { viewBox: "0 0 560 260", preserveAspectRatio: "none", children: [
          /* @__PURE__ */ A.jsx(YI, { d: "M172 97 C142 57 112 44 76 55" }),
          /* @__PURE__ */ A.jsx(YI, { d: "M300 151 C275 103 278 61 312 36" }),
          /* @__PURE__ */ A.jsx(YI, { d: "M424 101 C470 65 500 64 532 76" }),
          /* @__PURE__ */ A.jsx(RH, { x: 72, y: 34, scale: 1.03 }),
          /* @__PURE__ */ A.jsx(RH, { x: 506, y: 17, scale: 0.88, mirror: !0 }),
          /* @__PURE__ */ A.jsx(dxt, { d: "M37 190 C102 177 108 91 172 97 S238 193 300 151 S364 61 424 101 S472 177 518 188" }),
          /* @__PURE__ */ A.jsx(
            fxt,
            {
              d: "M37 190 C102 177 108 91 172 97 S238 193 300 151 S364 61 424 101 S472 177 518 188",
              $primaryColour: t
            }
          ),
          /* @__PURE__ */ A.jsx(GI, { x: 154, y: 51 }),
          /* @__PURE__ */ A.jsx(GI, { x: 282, y: 105, mirror: !0 }),
          /* @__PURE__ */ A.jsx(GI, { x: 406, y: 55 }),
          /* @__PURE__ */ A.jsx(KI, { x: 172, y: 97, primaryColour: t }),
          /* @__PURE__ */ A.jsx(KI, { x: 300, y: 151, primaryColour: t }),
          /* @__PURE__ */ A.jsx(KI, { x: 424, y: 101, primaryColour: t }),
          /* @__PURE__ */ A.jsx(ext, { x: 518, y: 188, primaryColour: t })
        ] }),
        /* @__PURE__ */ A.jsxs(hxt, { viewBox: "0 0 48 52", children: [
          /* @__PURE__ */ A.jsx("text", { x: "24", y: "8", children: "N" }),
          /* @__PURE__ */ A.jsx("circle", { cx: "24", cy: "30", r: "17" }),
          /* @__PURE__ */ A.jsx("path", { className: "compass-cross", d: "M24 15 V45 M9 30 H39" }),
          /* @__PURE__ */ A.jsx("path", { className: "compass-north", d: "M24 14 L29 30 L24 27 L19 30 Z" }),
          /* @__PURE__ */ A.jsx("path", { className: "compass-south", d: "M24 46 L19 30 L24 33 L29 30 Z" }),
          /* @__PURE__ */ A.jsx("circle", { className: "compass-pin", cx: "24", cy: "30", r: "2.5" })
        ] }),
        /* @__PURE__ */ A.jsx(gxt, { children: "THE GREAT REWARD TRAIL" }),
        /* @__PURE__ */ A.jsx(pxt, { children: /* @__PURE__ */ A.jsx(AH, { primaryColour: t }) }),
        /* @__PURE__ */ A.jsxs(mxt, { children: [
          /* @__PURE__ */ A.jsx(yxt, {}),
          Qwt.map((o, a) => /* @__PURE__ */ A.jsx(bxt, { $index: a, $x: o }, o)),
          /* @__PURE__ */ A.jsx(vxt, { children: /* @__PURE__ */ A.jsx(AH, { primaryColour: t }) })
        ] }),
        /* @__PURE__ */ A.jsx(_xt, { children: e.won ? /* @__PURE__ */ A.jsxs(A.Fragment, { children: [
          Jwt.map((o) => /* @__PURE__ */ A.jsx(
            xxt,
            {
              $index: o,
              $colour: o % 2 === 0 ? t : "#f4b942"
            },
            o
          )),
          /* @__PURE__ */ A.jsxs(
            Sxt,
            {
              $primaryColour: t,
              $contrastColour: n,
              $borderRadius: i,
              children: [
                /* @__PURE__ */ A.jsx("strong", { children: "FOUND IT!" }),
                /* @__PURE__ */ A.jsx("span", { children: e.prizeLabel })
              ]
            }
          )
        ] }) : /* @__PURE__ */ A.jsx(wxt, { $primaryColour: t, children: /* @__PURE__ */ A.jsx("strong", { children: "NICE TRY!" }) }) })
      ]
    }
  ) });
}
function RH({ x: e, y: t, scale: n, mirror: r = !1 }) {
  const i = r ? -n : n;
  return /* @__PURE__ */ A.jsxs("g", { transform: `translate(${e} ${t}) scale(${i} ${n})`, children: [
    /* @__PURE__ */ A.jsx("ellipse", { cx: "0", cy: "62", rx: "23", ry: "4", fill: "#6e563c", opacity: "0.14" }),
    /* @__PURE__ */ A.jsx(
      "path",
      {
        d: "M-5 29 C-4 39 -5 51 -6 61 C-2 63 2 63 6 61 C4 50 5 39 4 29 Z",
        fill: "#87613d",
        stroke: "#6e4d32",
        strokeLinejoin: "round",
        strokeWidth: "1.5"
      }
    ),
    /* @__PURE__ */ A.jsx("path", { d: "M0 44 L-12 31 M1 40 L12 28", stroke: "#795637", strokeLinecap: "round", strokeWidth: "4" }),
    /* @__PURE__ */ A.jsx(
      "path",
      {
        d: "M-2 36 C-1 45 -2 53 -2 59",
        fill: "none",
        stroke: "#a98252",
        strokeLinecap: "round",
        strokeWidth: "1.8"
      }
    ),
    /* @__PURE__ */ A.jsx("circle", { cx: "-15", cy: "28", r: "15.5", fill: "#6f865f" }),
    /* @__PURE__ */ A.jsx("circle", { cx: "15", cy: "29", r: "15", fill: "#68805a" }),
    /* @__PURE__ */ A.jsx("circle", { cx: "1", cy: "34", r: "17", fill: "#789168" }),
    /* @__PURE__ */ A.jsx("circle", { cx: "0", cy: "17", r: "17", fill: "#819a70" }),
    /* @__PURE__ */ A.jsx("circle", { cx: "-6", cy: "11", r: "7", fill: "#9caf87", opacity: "0.85" }),
    /* @__PURE__ */ A.jsx(
      "path",
      {
        d: "M-20 24 C-17 18 -12 16 -7 17",
        fill: "none",
        stroke: "#9daf87",
        strokeLinecap: "round",
        strokeWidth: "3",
        opacity: "0.72"
      }
    ),
    /* @__PURE__ */ A.jsx(
      "path",
      {
        d: "M7 38 C12 36 16 32 18 27",
        fill: "none",
        stroke: "#5e754f",
        strokeLinecap: "round",
        strokeWidth: "3",
        opacity: "0.58"
      }
    ),
    /* @__PURE__ */ A.jsx(
      "path",
      {
        d: "M-15 61 Q-10 55 -6 61 M8 61 Q12 55 16 61",
        fill: "none",
        stroke: "#71845e",
        strokeLinecap: "round",
        strokeWidth: "2"
      }
    )
  ] });
}
function GI({ x: e, y: t, mirror: n = !1 }) {
  const r = n ? "translate(36 0) scale(-1 1)" : void 0;
  return /* @__PURE__ */ A.jsx("g", { transform: `translate(${e} ${t})`, children: /* @__PURE__ */ A.jsxs("g", { transform: r, children: [
    /* @__PURE__ */ A.jsx("ellipse", { cx: "18", cy: "46", rx: "12", ry: "3", fill: "#6e563c", opacity: "0.15" }),
    /* @__PURE__ */ A.jsx(
      "path",
      {
        d: "M15 4 Q18 1 21 4 L20.5 45 Q18 48 15.5 45 Z",
        fill: "#8a623d",
        stroke: "#6e4d32",
        strokeLinejoin: "round",
        strokeWidth: "2.5"
      }
    ),
    /* @__PURE__ */ A.jsx(
      "path",
      {
        d: "M17.5 7 C18 19 17 31 17.5 41",
        fill: "none",
        stroke: "#b18755",
        strokeLinecap: "round",
        strokeWidth: "1.5"
      }
    ),
    /* @__PURE__ */ A.jsx("path", { d: "M16 6 H43 L52 14 L43 22 H16 Z", fill: "#9a7044", opacity: "0.55" }),
    /* @__PURE__ */ A.jsx(
      "path",
      {
        d: "M16 4 H43 L52 12 L43 20 H16 Z",
        fill: "#d6aa6b",
        stroke: "#765334",
        strokeLinejoin: "round",
        strokeWidth: "2.5"
      }
    ),
    /* @__PURE__ */ A.jsx(
      "path",
      {
        d: "M22 8 H41 M23 15 H36",
        fill: "none",
        stroke: "#f0cc94",
        strokeLinecap: "round",
        strokeWidth: "1.5",
        opacity: "0.78"
      }
    ),
    /* @__PURE__ */ A.jsx("path", { d: "M20 24 H-7 L-16 32 L-7 40 H20 Z", fill: "#936a40", opacity: "0.55" }),
    /* @__PURE__ */ A.jsx(
      "path",
      {
        d: "M20 22 H-7 L-16 30 L-7 38 H20 Z",
        fill: "#c99a5c",
        stroke: "#765334",
        strokeLinejoin: "round",
        strokeWidth: "2.5"
      }
    ),
    /* @__PURE__ */ A.jsx(
      "path",
      {
        d: "M-5 26 H13 M-1 33 H14",
        fill: "none",
        stroke: "#efd09d",
        strokeLinecap: "round",
        strokeWidth: "1.5",
        opacity: "0.72"
      }
    ),
    /* @__PURE__ */ A.jsx("circle", { cx: "18", cy: "12", r: "2.3", fill: "#6e4d32" }),
    /* @__PURE__ */ A.jsx("circle", { cx: "17.4", cy: "11.4", r: "0.7", fill: "#e1bc82", opacity: "0.85" }),
    /* @__PURE__ */ A.jsx("circle", { cx: "18", cy: "30", r: "2.3", fill: "#6e4d32" }),
    /* @__PURE__ */ A.jsx("circle", { cx: "17.4", cy: "29.4", r: "0.7", fill: "#e1bc82", opacity: "0.85" })
  ] }) });
}
function KI({ x: e, y: t, primaryColour: n }) {
  return /* @__PURE__ */ A.jsxs("g", { transform: `translate(${e} ${t})`, children: [
    /* @__PURE__ */ A.jsx("circle", { cy: "2", r: "11", fill: "#6e563c", opacity: "0.16" }),
    /* @__PURE__ */ A.jsx("circle", { r: "10", fill: "#fff8e8", stroke: "#806744", strokeWidth: "2.5" }),
    /* @__PURE__ */ A.jsx("circle", { r: "4.3", fill: n }),
    /* @__PURE__ */ A.jsx("circle", { cx: "-1.2", cy: "-1.2", r: "1.2", fill: "#ffffff", opacity: "0.75" })
  ] });
}
function ext({ x: e, y: t, primaryColour: n }) {
  return /* @__PURE__ */ A.jsxs("g", { transform: `translate(${e} ${t}) rotate(-7)`, children: [
    /* @__PURE__ */ A.jsx("circle", { cy: "2", r: "21", fill: "#6e563c", opacity: "0.12" }),
    /* @__PURE__ */ A.jsx("circle", { r: "19", fill: "#fff8e8", opacity: "0.82" }),
    /* @__PURE__ */ A.jsx(
      "circle",
      {
        r: "17",
        fill: "none",
        stroke: n,
        strokeDasharray: "3 5",
        strokeLinecap: "round",
        strokeWidth: "3"
      }
    ),
    /* @__PURE__ */ A.jsx("path", { d: "M-8 -8 L8 8 M8 -8 L-8 8", stroke: "#fff8e8", strokeLinecap: "round", strokeWidth: "8" }),
    /* @__PURE__ */ A.jsx(
      "path",
      {
        d: "M-8 -8 L8 8 M8 -8 L-8 8",
        stroke: n,
        strokeLinecap: "round",
        strokeWidth: "4.5"
      }
    ),
    /* @__PURE__ */ A.jsx("circle", { cx: "-7", cy: "-8", r: "1.2", fill: "#ffffff", opacity: "0.72" })
  ] });
}
const txt = gi`
  from {
    stroke-dashoffset: 720;
  }
  to {
    stroke-dashoffset: 0;
  }
`, nxt = gi`
  0% {
    left: 6%;
    top: 73%;
    opacity: 0;
  }
  5% {
    opacity: 1;
  }
  21% {
    left: 29%;
    top: 37%;
  }
  29% {
    left: 29%;
    top: 37%;
  }
  45% {
    left: 53%;
    top: 58%;
  }
  53% {
    left: 53%;
    top: 58%;
  }
  69% {
    left: 75%;
    top: 38%;
  }
  77% {
    left: 75%;
    top: 38%;
  }
  94% {
    left: 91%;
    top: 72%;
    opacity: 1;
  }
  100% {
    left: 91%;
    top: 72%;
    opacity: 0;
  }
`, rxt = gi`
  0%, 100% {
    transform: translateY(0) rotate(-1deg);
  }
  50% {
    transform: translateY(-0.28rem) rotate(1deg);
  }
`, ixt = gi`
  0% {
    opacity: 0;
    transform: translateY(-0.8rem);
  }
  15% {
    opacity: 1;
  }
  35%, 55%, 75% {
    transform: translateY(0) rotate(-4deg);
  }
  45%, 65%, 85% {
    transform: translateY(0.15rem) rotate(5deg);
  }
  100% {
    opacity: 1;
    transform: translateY(0) rotate(0);
  }
`, oxt = gi`
  0% {
    opacity: 0;
    transform: translate(0, 0) scale(0.5);
  }
  25% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    transform: translate(var(--dirt-x), -2.8rem) scale(1);
  }
`, axt = gi`
  0% {
    opacity: 0;
    transform: translateY(2.3rem) rotate(-5deg) scale(0.55);
  }
  68% {
    opacity: 1;
    transform: translateY(-0.25rem) rotate(2deg) scale(1.06);
  }
  100% {
    opacity: 1;
    transform: translateY(0) rotate(0) scale(1);
  }
`, sxt = gi`
  0% {
    opacity: 0;
    transform: rotate(0) translateY(0) scale(0.4);
  }
  45% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    transform: rotate(var(--spark-angle)) translateY(-3.5rem) scale(1);
  }
`, cxt = ce.div`
  position: relative;
  width: min(100%, 35rem);
`, lxt = ce.div`
  position: relative;
  width: 100%;
  height: clamp(14rem, 43vw, 17rem);
  border: 1px solid ${(e) => e.$primaryColour}66;
  border-radius: ${(e) => e.$borderRadius};
  background: radial-gradient(
      circle at 18% 30%,
      ${(e) => e.$shadeColour} 0 4%,
      transparent 4.5%
    ),
    radial-gradient(circle at 79% 72%, rgba(140, 111, 68, 0.08) 0 5%, transparent 5.5%), #f8efd9;
  box-shadow:
    inset 0 0 2.5rem rgba(126, 92, 52, 0.12),
    0 1rem 2.2rem rgba(41, 50, 56, 0.12);
  overflow: hidden;

  @media (prefers-reduced-motion: reduce) {
    *,
    *::before,
    *::after {
      animation: none !important;
    }
  }
`, uxt = ce.svg`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
`, YI = ce.path`
  fill: none;
  stroke: #b9a77e;
  stroke-dasharray: 2 8;
  stroke-linecap: round;
  stroke-width: 2.5;
  opacity: 0.78;
`, dxt = ce.path`
  fill: none;
  stroke: #fff8e8;
  stroke-linecap: round;
  stroke-width: 10;
`, fxt = ce.path`
  fill: none;
  stroke: ${(e) => e.$primaryColour};
  stroke-dasharray: 8 11;
  stroke-dashoffset: 720;
  stroke-linecap: round;
  stroke-width: 4;
  animation: ${txt} 1100ms 150ms ease-out both;

  @media (prefers-reduced-motion: reduce) {
    stroke-dashoffset: 0;
    animation: none;
  }
`, hxt = ce.svg`
  position: absolute;
  top: 0.8rem;
  right: 0.9rem;
  width: 2.75rem;
  height: 3rem;
  overflow: visible;

  text {
    fill: #6d583a;
    font-family: Georgia, serif;
    font-size: 9px;
    font-weight: 700;
    text-anchor: middle;
  }

  > circle:first-of-type {
    fill: rgba(255, 248, 232, 0.48);
    stroke: rgba(89, 69, 42, 0.52);
    stroke-width: 1.5;
  }

  .compass-cross {
    fill: none;
    stroke: rgba(109, 88, 58, 0.3);
    stroke-linecap: round;
    stroke-width: 1;
  }

  .compass-north {
    fill: #71583a;
  }

  .compass-south {
    fill: #d3ad70;
    stroke: #71583a;
    stroke-linejoin: round;
    stroke-width: 0.8;
  }

  .compass-pin {
    fill: #fff8e8;
    stroke: #71583a;
    stroke-width: 1.2;
  }
`, gxt = ce.span`
  position: absolute;
  top: 0.75rem;
  left: 1rem;
  color: rgba(93, 70, 38, 0.75);
  font-family: Georgia, serif;
  font-size: clamp(0.55rem, 1.8vw, 0.72rem);
  font-weight: 700;
  letter-spacing: 0.12em;
`, pxt = ce.div`
  position: absolute;
  z-index: 3;
  left: 6%;
  top: 73%;
  width: clamp(3.2rem, 13%, 4.8rem);
  opacity: 0;
  animation: ${nxt} 3200ms 350ms linear both;
  transform: translate(-50%, -50%);

  > svg {
    animation: ${rxt} 280ms ease-in-out infinite;
  }

  @media (prefers-reduced-motion: reduce) {
    display: none;
  }
`, mxt = ce.div`
  position: absolute;
  z-index: 4;
  right: 0.3rem;
  bottom: 0.2rem;
  width: clamp(4.3rem, 16%, 5.7rem);
  height: 5.3rem;
  opacity: 0;
  animation: ${ixt} 900ms 3150ms ease-in-out both;

  @media (prefers-reduced-motion: reduce) {
    opacity: 1;
    animation: none;
  }
`, vxt = ce.div`
  position: absolute;
  right: 0;
  bottom: 0.3rem;
  width: 100%;
  transform: rotate(-10deg);
`, yxt = ce.span`
  position: absolute;
  right: -0.6rem;
  bottom: 0;
  width: 4.2rem;
  height: 1.2rem;
  border-radius: 50% 50% 24% 24%;
  background: #9d744b;
  box-shadow: inset 0 0.25rem 0 rgba(255, 255, 255, 0.14);
`, bxt = ce.span`
  --dirt-x: ${(e) => e.$x}rem;
  position: absolute;
  right: 1.2rem;
  bottom: 0.55rem;
  width: ${(e) => 0.28 + e.$index % 2 * 0.1}rem;
  height: ${(e) => 0.28 + e.$index % 2 * 0.1}rem;
  border-radius: 50%;
  background: ${(e) => e.$index % 2 === 0 ? "#a77a4e" : "#7d5939"};
  opacity: 0;
  animation: ${oxt} 650ms ${(e) => 3220 + e.$index * 85}ms ease-out both;

  @media (prefers-reduced-motion: reduce) {
    display: none;
  }
`, _xt = ce.div`
  position: absolute;
  z-index: 5;
  top: 15%;
  right: 4%;
  display: grid;
  width: min(33%, 8.3rem);
  min-width: 6.7rem;
  opacity: 0;
  animation: ${axt} 720ms 3950ms cubic-bezier(0.22, 1, 0.36, 1) both;
  place-items: center;

  @media (prefers-reduced-motion: reduce) {
    opacity: 1;
    animation: none;
  }
`, Sxt = ce.div`
  position: relative;
  z-index: 1;
  display: flex;
  width: 100%;
  min-height: 4.3rem;
  padding: 0.65rem 0.75rem;
  border: 2px solid rgba(255, 255, 255, 0.65);
  border-radius: ${(e) => e.$borderRadius};
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.18), transparent),
    ${(e) => e.$primaryColour};
  box-shadow:
    0 0 0 3px ${(e) => e.$primaryColour}55,
    0 0.75rem 1.3rem rgba(69, 48, 27, 0.25);
  color: ${(e) => e.$contrastColour};
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  text-align: left;

  strong {
    font-size: 0.72rem;
    letter-spacing: 0.1em;
  }

  span {
    font-size: 0.7rem;
  }
`, wxt = ce.div`
  position: relative;
  display: grid;
  width: 6.4rem;
  min-height: 2.35rem;
  border: 2px solid ${(e) => e.$primaryColour};
  border-radius: 1.1rem;
  background: #fffdf6;
  box-shadow: 0 0.7rem 1.2rem rgba(69, 48, 27, 0.2);
  color: ${(e) => e.$primaryColour};
  font-size: 0.64rem;
  letter-spacing: 0.08em;
  place-items: center;
  transform: rotate(-5deg);

  &::before,
  &::after {
    position: absolute;
    width: 1.45rem;
    height: 1.45rem;
    border: 2px solid ${(e) => e.$primaryColour};
    border-radius: 50%;
    background: #fffdf6;
    content: '';
  }

  &::before {
    left: -0.65rem;
  }

  &::after {
    right: -0.65rem;
  }

  strong {
    position: relative;
    z-index: 1;
  }
`, xxt = ce.span`
  --spark-angle: ${(e) => e.$index * 60}deg;
  position: absolute;
  z-index: 0;
  width: 0.42rem;
  height: 0.42rem;
  border-radius: 0.08rem;
  background: ${(e) => e.$colour};
  opacity: 0;
  animation: ${sxt} 850ms ${(e) => 4050 + e.$index * 45}ms ease-out both;

  @media (prefers-reduced-motion: reduce) {
    display: none;
  }
`, Ext = {
  giftCard: Hwt,
  treasureMapDog: Zwt
}, Cxt = {
  giftCard: 300,
  treasureMapDog: 4100
};
function Txt(e) {
  return Cxt[e ?? "giftCard"];
}
function Ixt({
  animation: e = "giftCard",
  ...t
}) {
  const n = Ext[e];
  return /* @__PURE__ */ A.jsx(n, { ...t });
}
const PH = "cloudflare-turnstile-script";
let Zm;
function $xt() {
  return window.turnstile ? Promise.resolve(window.turnstile) : Zm || (Zm = new Promise((e, t) => {
    const n = document.getElementById(PH), r = n ?? document.createElement("script"), i = () => {
      window.turnstile ? e(window.turnstile) : (r.remove(), t(new Error("Turnstile did not initialise.")));
    }, o = () => {
      r.remove(), t(new Error("Turnstile could not be loaded."));
    };
    r.addEventListener("load", i, { once: !0 }), r.addEventListener("error", o, { once: !0 }), n || (r.id = PH, r.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit", r.async = !0, r.defer = !0, document.head.appendChild(r));
  }).catch((e) => {
    throw Zm = void 0, e;
  }), Zm);
}
function Axt({
  siteKey: e,
  action: t,
  cData: n,
  resetKey: r,
  onToken: i
}) {
  const o = $e(null), [a, s] = Qe(!1), [c, l] = Qe(0);
  return ot(() => {
    let u = !0, d;
    return i(void 0), s(!1), $xt().then((f) => {
      !u || !o.current || (d = f.render(o.current, {
        sitekey: e,
        action: t,
        cData: n,
        theme: "auto",
        callback: (h) => {
          u && i(h);
        },
        "expired-callback": () => {
          u && i(void 0);
        },
        "error-callback": () => {
          u && (i(void 0), s(!0));
        }
      }));
    }).catch(() => {
      u && (i(void 0), s(!0));
    }), () => {
      u = !1, d && window.turnstile && window.turnstile.remove(d);
    };
  }, [t, n, i, r, c, e]), /* @__PURE__ */ A.jsxs("div", { children: [
    /* @__PURE__ */ A.jsx("div", { ref: o }),
    a ? /* @__PURE__ */ A.jsxs("div", { role: "alert", children: [
      /* @__PURE__ */ A.jsx("p", { children: "The security check could not load. Check your connection and try again." }),
      /* @__PURE__ */ A.jsx("button", { type: "button", onClick: () => l((u) => u + 1), children: "Try security check again" })
    ] }) : null
  ] });
}
const Rxt = /^[^\s@]+@[^\s@]+\.[^\s@]+$/, Pxt = /^\+?[0-9 ]*[0-9][0-9 ]*$/, Oxt = /^\d{6}$/, Mxt = /* @__PURE__ */ new Set([
  "already-exists",
  "deadline-exceeded",
  "failed-precondition",
  "invalid-argument",
  "permission-denied",
  "resource-exhausted",
  "unauthenticated",
  "unavailable"
]), kxt = ({ question: e, settings: t }) => {
  if (e.type !== "rewardPage")
    throw new H4("rewardPage", e.type);
  const { analyticsService: n, databaseService: r, loggingService: i } = gt(mn), { onSubmitSurvey: o } = KVe(), { isSubmitClicked: a, submissionId: s } = _x(({ survey: de }) => de), { primaryColour: c, primary75: l, primary50: u, contrastColour: d, shadeColour: f } = Gn(), h = Mi(), [p, g] = Qe({ status: "loading" }), [m, v] = Qe(0), [y, _] = Qe("email"), [b, w] = Qe(""), [C, x] = Qe(), [T, E] = Qe(), [R, I] = Qe(!1), [O, P] = Qe(), [k, L] = Qe(), [N, D] = Qe(), [z, V] = Qe(""), [B, U] = Qe(), [Q, Y] = Qe(0), [q, X] = Qe(() => Date.now()), ne = $e(s);
  ne.current = s;
  const Z = Wt((de) => {
    U(de);
  }, []);
  ot(() => {
    let de = !0;
    async function Ae() {
      if (!s) {
        g({ status: "error" });
        return;
      }
      g({ status: "loading" }), D(void 0), V(""), E(void 0), P(void 0), L(void 0), U(void 0), I(!1);
      try {
        await r.awaitPendingWrites();
        const ue = await r.getSurveyRewardState({
          surveyName: t.surveyName,
          campaignId: e.campaignId,
          submissionId: s
        });
        if (!de)
          return;
        const be = ue.entryRoute === "verifiedEmail" ? (ue.contactCandidates ?? []).filter((Ve) => Ve.method === "email") : ue.contactCandidates ?? [], Ie = be[0];
        x(Ie == null ? void 0 : Ie.candidateId), _(
          ue.entryRoute === "verifiedEmail" ? "email" : (Ie == null ? void 0 : Ie.method) ?? ue.campaign.contactMethods[0] ?? "email"
        ), g({
          status: "ready",
          submissionId: s,
          campaign: ue.campaign,
          entryRoute: ue.entryRoute,
          emailVerification: ue.emailVerification,
          codeStatus: ue.codeStatus,
          contactCandidates: be,
          outcome: ue.outcome
        });
      } catch (ue) {
        if (!de)
          return;
        i.error("Error loading survey reward state", {
          error: ue,
          context: {
            surveyName: t.surveyName,
            campaignId: e.campaignId,
            submissionId: s
          }
        }), g({ status: "error" });
      }
    }
    return Ae(), () => {
      de = !1;
    };
  }, [r, m, i, e.campaignId, t.surveyName, s]), ot(() => {
    if (!N)
      return;
    const de = window.setInterval(() => X(Date.now()), 1e3);
    return () => window.clearInterval(de);
  }, [N]), ot(() => {
    p.status === "ready" && p.outcome && (n.logCompletion(t.surveyName), a || o());
  }, [n, a, p, o, t.surveyName]);
  function J() {
    if (C)
      return;
    const de = b.trim();
    if (!de)
      return y === "email" ? "Enter your email address." : "Enter your phone number.";
    if (y === "email" && (!Rxt.test(de) || de.length > 254))
      return "Enter a valid email address.";
    if (y === "phone" && !Pxt.test(de))
      return "Use only numbers and spaces, with an optional + at the beginning.";
  }
  function K() {
    return C ? { source: "surveyAnswer", candidateId: C } : {
      method: y,
      value: y === "phone" ? Nxt(b) : b.trim().toLowerCase()
    };
  }
  async function ee() {
    if (p.status !== "ready" || p.entryRoute !== "verifiedEmail" || !p.emailVerification || !B) {
      L("Complete the security check.");
      return;
    }
    const de = p.submissionId;
    try {
      const Ae = await r.requestSurveyRewardEmailVerification({
        surveyName: t.surveyName,
        campaignId: e.campaignId,
        submissionId: p.submissionId,
        contact: K(),
        turnstileToken: B
      });
      if (ne.current !== de)
        return;
      D(Ae), V(""), X(Date.now()), U(void 0);
    } catch (Ae) {
      if (ne.current !== de)
        return;
      i.error("Error requesting reward email verification", {
        error: Ae,
        context: {
          surveyName: t.surveyName,
          campaignId: e.campaignId,
          submissionId: p.submissionId
        }
      }), L(XI(Ae, "We couldn’t send the verification code.")), U(void 0), Y((ue) => ue + 1);
    }
  }
  async function te(de) {
    de.preventDefault();
    const Ae = J();
    if (E(Ae), P(void 0), L(void 0), Ae || R || p.status !== "ready" || p.submissionId !== s)
      return;
    const ue = p.submissionId;
    I(!0);
    try {
      if (p.entryRoute === "verifiedEmail" && !N) {
        await ee();
        return;
      }
      if (p.entryRoute === "verifiedEmail" && (!N || !Oxt.test(z))) {
        E("Enter the six-digit verification code.");
        return;
      }
      const be = await r.enterSurveyReward({
        surveyName: t.surveyName,
        campaignId: e.campaignId,
        submissionId: ue,
        ...p.entryRoute === "verifiedEmail" ? {
          emailVerification: {
            verificationId: N.verificationId,
            code: z
          }
        } : { contact: K() }
      });
      if (ne.current !== ue)
        return;
      g({
        ...p,
        outcome: be.outcome
      });
    } catch (be) {
      if (ne.current !== ue)
        return;
      i.error("Error entering survey reward", {
        error: be,
        context: {
          surveyName: t.surveyName,
          campaignId: e.campaignId,
          submissionId: ue,
          contactMethod: y
        }
      }), P(
        p.entryRoute === "verifiedEmail" ? XI(be, "We couldn’t verify your entry. Please try again.") : XI(
          be,
          "We couldn’t determine your result. Your entry has not been counted yet. Please try again."
        )
      );
    } finally {
      ne.current === ue && I(!1);
    }
  }
  function H() {
    D(void 0), V(""), E(void 0), L(void 0), U(void 0), Y((de) => de + 1);
  }
  function ie() {
    n.logCompletion(t.surveyName), a || o();
  }
  if (p.status === "loading")
    return /* @__PURE__ */ A.jsxs(QI, { role: "status", "aria-live": "polite", children: [
      /* @__PURE__ */ A.jsx(tp, {}),
      /* @__PURE__ */ A.jsx("span", { children: "Confirming your survey completion…" })
    ] });
  if (p.status === "error")
    return /* @__PURE__ */ A.jsxs(QI, { role: "alert", children: [
      /* @__PURE__ */ A.jsx("p", { children: "We couldn’t confirm your reward eligibility." }),
      /* @__PURE__ */ A.jsx(
        kH,
        {
          type: "button",
          $primaryColour: c,
          $hoverColour: u,
          $contrastColour: d,
          $borderRadius: h,
          onClick: () => v((de) => de + 1),
          children: "Try again"
        }
      ),
      /* @__PURE__ */ A.jsx(t$, { type: "button", onClick: ie, children: "Finish without entering" })
    ] });
  if (p.outcome)
    return /* @__PURE__ */ A.jsx(
      Bxt,
      {
        outcome: p.outcome,
        primaryColour: c,
        contrastColour: d,
        shadeColour: f,
        borderRadius: h,
        revealAnimation: e.revealAnimation,
        grandPrizeLabel: p.campaign.grandPrizeLabel,
        winningHeader: e.winningHeader,
        winningText: e.winningText,
        losingHeader: e.losingHeader,
        losingText: e.losingText
      }
    );
  const { campaign: W } = p, se = W.selection ?? {
    type: "randomChance",
    winChance: W.winChance ?? 0
  }, le = p.entryRoute === "verifiedEmail", ge = p.entryRoute === "uploadedCode" || p.entryRoute === void 0 && p.codeStatus !== void 0, me = Lxt(
    p.codeStatus,
    ge
  ), pe = le ? ["email"] : W.contactMethods, Te = N ? q >= new Date(N.resendAfter).getTime() : !1;
  return me ? /* @__PURE__ */ A.jsxs(QI, { role: "status", "aria-live": "polite", children: [
    /* @__PURE__ */ A.jsx("h2", { children: Fxt(me) }),
    /* @__PURE__ */ A.jsx("p", { children: Vxt(me) }),
    /* @__PURE__ */ A.jsx(
      kH,
      {
        type: "button",
        $primaryColour: c,
        $hoverColour: u,
        $contrastColour: d,
        $borderRadius: h,
        onClick: ie,
        children: "Finish survey"
      }
    )
  ] }) : /* @__PURE__ */ A.jsxs(Uxt, { onSubmit: (de) => void te(de), noValidate: !0, children: [
    /* @__PURE__ */ A.jsx(Wxt, { $shadeColour: f, $borderRadius: h, children: se.type === "everyNth" ? /* @__PURE__ */ A.jsxs(A.Fragment, { children: [
      /* @__PURE__ */ A.jsxs("strong", { children: [
        "Every ",
        jxt(se.interval)
      ] }),
      /* @__PURE__ */ A.jsxs("span", { children: [
        "eligible entry wins ",
        W.prizeLabel
      ] })
    ] }) : /* @__PURE__ */ A.jsxs(A.Fragment, { children: [
      /* @__PURE__ */ A.jsx("strong", { children: Dxt(se.winChance) }),
      /* @__PURE__ */ A.jsxs("span", { children: [
        "chance to win ",
        W.prizeLabel
      ] })
    ] }) }),
    N ? /* @__PURE__ */ A.jsxs(Kxt, { role: "status", "aria-live": "polite", children: [
      /* @__PURE__ */ A.jsxs("p", { children: [
        "We sent a six-digit code to ",
        /* @__PURE__ */ A.jsx("strong", { children: N.contactMasked }),
        "."
      ] }),
      /* @__PURE__ */ A.jsxs(MH, { children: [
        /* @__PURE__ */ A.jsx("span", { children: "Verification code" }),
        /* @__PURE__ */ A.jsx(
          hx,
          {
            value: z,
            onChange: (de) => {
              V(de.replace(/\D/g, "").slice(0, 6)), E(void 0), P(void 0);
            },
            type: "text",
            placeholder: "123456",
            primaryColour: c,
            maxLength: 6
          }
        )
      ] }),
      /* @__PURE__ */ A.jsxs(ZI, { children: [
        "The code expires at ",
        new Date(N.expiresAt).toLocaleTimeString(),
        "."
      ] }),
      /* @__PURE__ */ A.jsx(
        t$,
        {
          type: "button",
          onClick: H,
          disabled: R || !Te,
          children: Te ? "Send another code" : "You can request another code shortly"
        }
      )
    ] }) : /* @__PURE__ */ A.jsxs(A.Fragment, { children: [
      p.contactCandidates.length > 0 ? /* @__PURE__ */ A.jsxs(OH, { children: [
        /* @__PURE__ */ A.jsx("legend", { children: "Use contact details you already provided?" }),
        /* @__PURE__ */ A.jsxs(Gxt, { children: [
          p.contactCandidates.map((de) => /* @__PURE__ */ A.jsxs(
            JI,
            {
              $selected: C === de.candidateId,
              $primaryColour: c,
              $shadeColour: f,
              $borderRadius: h,
              children: [
                /* @__PURE__ */ A.jsx(
                  "input",
                  {
                    type: "radio",
                    name: "reward-contact-source",
                    checked: C === de.candidateId,
                    onChange: () => {
                      x(de.candidateId), _(de.method), E(void 0), L(void 0), P(void 0);
                    }
                  }
                ),
                de.method === "email" ? "Email" : "Phone",
                ": ",
                de.maskedValue
              ]
            },
            de.candidateId
          )),
          /* @__PURE__ */ A.jsxs(
            JI,
            {
              $selected: !C,
              $primaryColour: c,
              $shadeColour: f,
              $borderRadius: h,
              children: [
                /* @__PURE__ */ A.jsx(
                  "input",
                  {
                    type: "radio",
                    name: "reward-contact-source",
                    checked: !C,
                    onChange: () => {
                      x(void 0), E(void 0), L(void 0), P(void 0);
                    }
                  }
                ),
                "Use different contact details"
              ]
            }
          )
        ] })
      ] }) : null,
      C ? null : /* @__PURE__ */ A.jsxs(OH, { children: [
        /* @__PURE__ */ A.jsx("legend", { children: "How should we contact you if you win?" }),
        /* @__PURE__ */ A.jsx(qxt, { children: pe.map((de) => /* @__PURE__ */ A.jsxs(
          JI,
          {
            $selected: y === de,
            $primaryColour: c,
            $shadeColour: f,
            $borderRadius: h,
            children: [
              /* @__PURE__ */ A.jsx(
                "input",
                {
                  type: "radio",
                  name: "reward-contact-method",
                  value: de,
                  checked: y === de,
                  onChange: () => {
                    x(void 0), _(de), w(""), E(void 0), L(void 0), P(void 0);
                  }
                }
              ),
              de === "email" ? "Email" : "Phone"
            ]
          },
          de
        )) })
      ] }),
      C ? null : /* @__PURE__ */ A.jsxs(MH, { children: [
        /* @__PURE__ */ A.jsx("span", { children: y === "email" ? "Email address" : "Phone number" }),
        /* @__PURE__ */ A.jsx(
          hx,
          {
            value: b,
            onChange: (de) => {
              w(de), E(void 0), L(void 0), P(void 0);
            },
            type: y === "email" ? "email" : "tel",
            placeholder: y === "email" ? "you@example.com" : "+64211234567",
            primaryColour: c,
            maxLength: y === "email" ? 254 : 24
          }
        )
      ] }),
      !C && y === "phone" ? /* @__PURE__ */ A.jsx(ZI, { children: "Use numbers and spaces, with an optional + at the beginning." }) : null,
      le && p.emailVerification ? /* @__PURE__ */ A.jsx(
        Axt,
        {
          siteKey: p.emailVerification.siteKey,
          action: p.emailVerification.action,
          cData: p.submissionId,
          resetKey: Q,
          onToken: Z
        }
      ) : null
    ] }),
    T ? /* @__PURE__ */ A.jsx(e$, { role: "alert", children: T }) : null,
    k ? /* @__PURE__ */ A.jsx(e$, { role: "alert", children: k }) : null,
    O ? /* @__PURE__ */ A.jsx(e$, { role: "alert", children: O }) : null,
    O && le ? /* @__PURE__ */ A.jsx(ZI, { children: "Your entry has not been counted yet." }) : null,
    /* @__PURE__ */ A.jsx(Yxt, { children: "We’ll only use these details to administer the survey incentives." }),
    /* @__PURE__ */ A.jsxs(
      Xxt,
      {
        type: "submit",
        disabled: R || le && !N && !B,
        $primaryColour: c,
        $hoverColour: l,
        $contrastColour: d,
        $borderRadius: h,
        children: [
          /* @__PURE__ */ A.jsx(NH, { "aria-hidden": "true", children: "✦" }),
          /* @__PURE__ */ A.jsx("span", { children: R ? "Checking…" : le && !N ? "Send verification code" : le ? "Verify and reveal my result" : "Reveal my result" }),
          /* @__PURE__ */ A.jsx(NH, { "aria-hidden": "true", children: "✦" })
        ]
      }
    ),
    /* @__PURE__ */ A.jsx(t$, { type: "button", onClick: ie, disabled: R, children: "Finish without entering" })
  ] });
};
function Nxt(e) {
  return e.replace(/\s/g, "");
}
function XI(e, t) {
  if (e && typeof e == "object" && "code" in e && Mxt.has(String(e.code).replace(/^functions\//, "")) && "message" in e) {
    const n = String(e.message).replace(/^FirebaseError:\s*/, "").trim();
    if (n)
      return n;
  }
  return t;
}
function Dxt(e) {
  return new Intl.NumberFormat(void 0, {
    style: "percent",
    maximumSignificantDigits: 4
  }).format(e);
}
function jxt(e) {
  const t = e % 100;
  if (t >= 11 && t <= 13)
    return `${e}th`;
  switch (e % 10) {
    case 1:
      return `${e}st`;
    case 2:
      return `${e}nd`;
    case 3:
      return `${e}rd`;
    default:
      return `${e}th`;
  }
}
function Lxt(e, t) {
  if (e === "test")
    return e;
  if (!(!t || !e || e === "valid" || e === "unverified"))
    return e;
}
function Fxt(e) {
  return e === "test" ? "Test response recorded" : e === "missing" ? "Response recorded" : "This link is not eligible for rewards";
}
function Vxt(e) {
  return e === "test" ? "Your answers have been saved, but test responses are not included in the reward promotion." : e === "missing" ? "Your answers have been saved, but a survey code is required to enter the reward promotion." : e === "already-used" ? "This survey code has already been used for another reward entry. Your answers have still been saved." : "The survey code in this link was not recognised. Your answers have still been saved.";
}
function Bxt({
  outcome: e,
  primaryColour: t,
  contrastColour: n,
  shadeColour: r,
  borderRadius: i,
  revealAnimation: o,
  grandPrizeLabel: a,
  winningHeader: s,
  winningText: c,
  losingHeader: l,
  losingText: u
}) {
  return /* @__PURE__ */ A.jsxs(
    Qxt,
    {
      role: "status",
      "aria-live": "polite",
      $shadeColour: r,
      $borderRadius: i,
      children: [
        /* @__PURE__ */ A.jsx(
          Ixt,
          {
            animation: o,
            outcome: e,
            primaryColour: t,
            contrastColour: n,
            shadeColour: r,
            borderRadius: i
          }
        ),
        /* @__PURE__ */ A.jsxs(Jxt, { $delayMs: Txt(o), children: [
          /* @__PURE__ */ A.jsx("h2", { children: e.won ? s ?? `You won ${e.prizeLabel}!` : l ?? "Not a winner" }),
          /* @__PURE__ */ A.jsx("p", { children: e.won ? c ?? `We’ll contact you${e.contactMasked ? ` at ${e.contactMasked}` : ""} with the next steps.` : u ?? (e.grandPrizeEligible && a ? `You have been entered into ${a}.` : "Thanks for taking part and for completing the survey.") })
        ] })
      ]
    }
  );
}
const zxt = gi`
  from {
    opacity: 0;
    transform: translateY(0.75rem);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`, Hxt = gi`
  0%, 100% {
    opacity: 0.65;
    transform: scale(0.85) rotate(0deg);
  }
  50% {
    opacity: 1;
    transform: scale(1.15) rotate(20deg);
  }
`, QI = ce.div`
  display: flex;
  min-height: 9rem;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  text-align: center;
`, Uxt = ce.form`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 1rem;
`, Wxt = ce.div`
  display: flex;
  align-items: baseline;
  gap: 0.5rem;
  padding: 0.9rem 1rem;
  border-radius: ${(e) => e.$borderRadius};
  background: ${(e) => e.$shadeColour};

  strong {
    font-size: 1.25rem;
  }
`, OH = ce.fieldset`
  display: flex;
  margin: 0;
  padding: 0;
  border: 0;
  flex-direction: column;
  gap: 0.65rem;

  legend {
    margin-bottom: 0.65rem;
    font-weight: 500;
  }
`, qxt = ce.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.75rem;
`, Gxt = ce.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`, JI = ce.label`
  display: flex;
  min-height: 3rem;
  align-items: center;
  justify-content: center;
  gap: 0.55rem;
  border: 1px solid
    ${(e) => e.$selected ? e.$primaryColour : "rgba(41, 50, 56, 0.25)"};
  border-radius: ${(e) => e.$borderRadius};
  background: ${(e) => e.$selected ? e.$shadeColour : "transparent"};
  cursor: pointer;
  font-weight: ${(e) => e.$selected ? 600 : 400};
`, MH = ce.label`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  font-weight: 500;
`, Kxt = ce.div`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;

  p {
    margin: 0;
  }
`, ZI = ce.span`
  margin-top: -0.6rem;
  color: rgba(41, 50, 56, 0.72);
  font-size: 0.9rem;
`, e$ = ce.p`
  margin: -0.35rem 0 0;
  color: #9d1c1c;
`, Yxt = ce.p`
  margin: 0;
  color: rgba(41, 50, 56, 0.78);
  font-size: 0.9rem;
`, kH = ce.button`
  min-height: var(--button-height);
  padding: 0.75rem 1.25rem;
  border: 1px solid ${(e) => e.$primaryColour};
  border-radius: ${(e) => e.$borderRadius};
  background: ${(e) => e.$primaryColour};
  color: ${(e) => e.$contrastColour};
  cursor: pointer;
  font-size: 1.05rem;
  font-weight: 500;
  transition:
    background-color 160ms ease,
    transform 160ms ease;

  &:hover:not(:disabled) {
    background: ${(e) => e.$hoverColour};
    transform: translateY(-1px);
  }

  &:disabled {
    cursor: wait;
    opacity: 0.65;
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`, Xxt = ce.button`
  position: relative;
  isolation: isolate;
  display: flex;
  min-height: calc(var(--button-height) + 0.35rem);
  padding: 0.85rem 1.5rem;
  border: 2px solid ${(e) => e.$contrastColour};
  border-radius: calc(${(e) => e.$borderRadius} + 0.25rem);
  background: linear-gradient(
    120deg,
    ${(e) => e.$primaryColour} 0%,
    ${(e) => e.$hoverColour} 50%,
    ${(e) => e.$primaryColour} 100%
  );
  box-shadow:
    0 0 0 2px ${(e) => e.$primaryColour},
    0 0.65rem 1.5rem color-mix(in srgb, ${(e) => e.$primaryColour} 38%, transparent);
  color: ${(e) => e.$contrastColour};
  cursor: pointer;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  overflow: hidden;
  font-size: 1.1rem;
  font-weight: 700;
  letter-spacing: 0.015em;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.18);
  transition:
    box-shadow 180ms ease,
    filter 180ms ease,
    transform 180ms ease;

  &::before {
    position: absolute;
    z-index: -1;
    inset: 0;
    background: linear-gradient(
      105deg,
      transparent 28%,
      rgba(255, 255, 255, 0.42) 48%,
      transparent 68%
    );
    content: '';
    transform: translateX(-120%);
    transition: transform 480ms ease;
  }

  &:hover:not(:disabled) {
    box-shadow:
      0 0 0 2px ${(e) => e.$primaryColour},
      0 0.9rem 1.9rem color-mix(in srgb, ${(e) => e.$primaryColour} 48%, transparent);
    filter: saturate(1.12) brightness(1.04);
    transform: translateY(-2px) scale(1.015);
  }

  &:hover:not(:disabled)::before {
    transform: translateX(120%);
  }

  &:focus-visible {
    outline: 3px solid ${(e) => e.$contrastColour};
    outline-offset: 4px;
  }

  &:disabled {
    cursor: wait;
    filter: grayscale(0.15);
    opacity: 0.72;
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;

    &::before {
      display: none;
    }

    &:hover:not(:disabled) {
      transform: none;
    }
  }
`, NH = ce.span`
  display: inline-block;
  animation: ${Hxt} 1.8s ease-in-out infinite;
  font-size: 1.1em;

  &:last-child {
    animation-delay: 0.45s;
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`, t$ = ce.button`
  min-height: var(--button-height);
  padding: 0.75rem 1.25rem;
  border: 0;
  background: transparent;
  color: inherit;
  cursor: pointer;
  text-decoration: underline;

  &:disabled {
    cursor: wait;
    opacity: 0.65;
  }
`, Qxt = ce.div`
  display: flex;
  width: 100%;
  min-height: 19rem;
  padding: 1.5rem;
  border-radius: ${(e) => e.$borderRadius};
  background: radial-gradient(circle at 50% 20%, ${(e) => e.$shadeColour}, transparent 55%),
    rgba(255, 255, 255, 0.48);
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1.25rem;
  overflow: hidden;
  text-align: center;
`, Jxt = ce.div`
  animation: ${zxt} 450ms ${(e) => e.$delayMs}ms ease-out both;

  h2 {
    margin: 0 0 0.5rem;
  }

  p {
    margin: 0;
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`, Zxt = ({
  question: e,
  currentAnswer: t,
  injectCurrent: n,
  submitAnswer: r,
  answers: i,
  settings: o
}) => {
  const { primaryColour: a, contrastColour: s } = Gn(), c = t == null ? void 0 : t.getValue(e.type), { value: l, ready: u } = ju(e.buckets, { answers: i }), { value: d, ready: f } = ju(e.initialStates, {
    answers: i
  });
  Xi(
    e,
    (k) => Rs(
      Object.fromEntries(
        (k.getValue("shift") ?? []).map((L) => [String(L.id), L])
      ),
      (d ?? []).map((L) => ({ id: `${L.id}::final` })),
      f && u
    )
  );
  const h = $e(null), [p, g] = j.useState(null), [m, v] = j.useState(null), [y, _] = j.useState(null), [b, w] = j.useState(null), C = Tt(
    () => ({
      canvasWidth: 400,
      canvasHeight: 300,
      paddingTop: 50,
      paddingBottom: 20,
      paddingLeft: 10,
      paddingRight: 10,
      circleRadius: 7,
      tickHeight: 10,
      primaryColour: a
    }),
    [a]
  ), x = Wt(
    (k) => {
      k.clearRect(0, 0, C.canvasWidth, C.canvasHeight), eEt(k, d, l, p, y, b, C), nEt(k, c, d, l, C), tEt(k, d, l, m, p, C);
    },
    [
      l,
      b,
      C,
      c,
      d,
      m,
      y,
      p
    ]
  ), T = (k) => {
    const L = window.devicePixelRatio || 1, N = k.getBoundingClientRect();
    k.width = N.width * L, k.height = N.height * L;
    const D = k.getContext("2d");
    return D ? (D.scale(L, L), D) : null;
  };
  ot(() => {
    const k = h.current;
    if (!k)
      return;
    const L = T(k);
    L && x(L);
  }, [x]);
  const E = (k, L) => {
    const N = {
      id: `${k.id}::final`,
      value: L.id
    };
    if (c) {
      const D = c.filter((z) => z.id !== `${k.id}::final`);
      D.push(N), n({ value: D });
    } else
      n({ value: [N] });
  }, R = (k, L) => {
    const D = o5(d, l, C).find((z) => {
      const V = k - z.x, B = L - z.y;
      return Math.sqrt(V * V + B * B) < z.radius;
    });
    return D ? (d == null ? void 0 : d.find((z) => z.id === D.id)) ?? null : null;
  }, I = (k, L) => (l == null ? void 0 : l.find((D) => k > D.lower * C.canvasWidth && k < D.upper * C.canvasWidth && L > 0.5 * C.canvasHeight)) ?? null, O = (k) => {
    const L = h.current;
    if (!L)
      return;
    const N = L.getBoundingClientRect(), D = k.clientX - N.left, z = k.clientY - N.top;
    if (p === null) {
      const V = R(D, z);
      V && g(V.id);
    } else {
      const V = I(D, z);
      if (V) {
        const B = d == null ? void 0 : d.find((U) => U.id === p);
        if (!B)
          return;
        E(B, V), g(null);
      }
    }
  }, P = (k) => {
    const L = h.current;
    if (!L)
      return;
    const N = L.getBoundingClientRect(), D = k.clientX - N.left, z = k.clientY - N.top;
    v([D, z]);
    const V = R(D, z);
    _(V ? V.id : null);
    const B = I(D, z);
    w(B ? B.id : null);
  };
  return /* @__PURE__ */ A.jsx(lEt, { children: /* @__PURE__ */ A.jsx(
    "canvas",
    {
      id: "shiftCanvas",
      width: C.canvasWidth,
      height: C.canvasHeight,
      ref: h,
      onClick: O,
      onMouseMove: P
    }
  ) });
}, eEt = (e, t, n, r, i, o, a) => {
  sEt(e, t, n, r, i, a), cEt(e, n, r, o, a);
}, tEt = (e, t, n, r, i, o) => {
  if (!r)
    return;
  const a = o5(t, n, o);
  if (!a)
    return;
  const s = a.find((u) => u.id === i);
  if (!s)
    return;
  const [c, l] = r;
  wp(e, s.x, s.y, c, l, o.primaryColour);
}, nEt = (e, t, n, r, i) => {
  if (!t)
    return;
  const o = o5(n, r, i);
  if (!o)
    return;
  const a = Tb(i);
  t.forEach((s) => {
    const c = o.find((u) => `${u.id}::final` === s.id);
    if (!c)
      return;
    const l = r == null ? void 0 : r.find((u) => u.id === s.value);
    l && wp(
      e,
      c.x,
      c.y,
      (l.lower + l.upper) / 2 * a + i.paddingLeft,
      i.canvasHeight - i.paddingBottom
    );
  });
}, o5 = (e, t, n) => {
  if (!e)
    return [];
  const r = {};
  return e.forEach((o) => {
    r[o.bucketId] || (r[o.bucketId] = []), r[o.bucketId].push(o);
  }), Object.entries(r).map(([o, a]) => {
    const s = t == null ? void 0 : t.find((d) => d.id === o);
    if (!s)
      return [];
    const c = n.paddingTop, l = n.circleRadius, u = Tb(n);
    return a.map((d, f) => ({
      x: (s.lower + (s.upper - s.lower) * (f + 1) / (a.length + 1)) * u + n.paddingLeft,
      y: c,
      id: d.id,
      radius: l,
      state: d
    }));
  }).flat();
}, nle = (e, t, n, r) => {
  if (!n)
    return;
  const i = Tb(r);
  n.forEach((o, a) => {
    const s = o.lower * i + r.paddingLeft, c = o.upper * i + r.paddingLeft;
    wp(e, s, t - r.tickHeight / 2, s, t + r.tickHeight / 2), wp(e, c, t - r.tickHeight / 2, c, t + r.tickHeight / 2);
  });
}, rEt = (e, t, n) => {
  if (!t)
    return;
  const r = Tb(n);
  t.forEach((i, o) => {
    const a = i.lower * r + n.paddingLeft, s = i.upper * r + n.paddingLeft;
    e.font = "1rem Inter", e.fillStyle = "black", e.textAlign = "center", e.fillText(
      i.label,
      (a + s) / 2,
      n.canvasHeight - n.paddingBottom + 20,
      s - a
    );
  });
}, iEt = (e, t, n, r, i) => {
  if (!t || !n || !r)
    return;
  const o = Tb(i), a = t.find((l) => l.id === r);
  if (!a)
    return;
  const s = a.lower * o + i.paddingLeft, c = a.upper * o + i.paddingLeft;
  e.fillStyle = "rgba(0, 0, 0, 0.1)", e.fillRect(
    s,
    i.canvasHeight - i.paddingBottom,
    c - s,
    -(i.canvasHeight - i.paddingTop - i.paddingBottom)
  );
}, oEt = (e, t, n, r, i) => {
  e.save(), e.translate(t, n), e.rotate(-Math.PI / 4), e.translate(-t, -n), e.font = "1rem Inter", e.fillStyle = "black", e.textAlign = "center", e.fillText(r, t + i + 25, n + i), e.restore();
}, aEt = (e, t, n, r, i, o) => {
  o5(t, n, o).forEach((s, c) => {
    oEt(e, s.x, s.y, s.state.label, s.radius), e.beginPath(), e.arc(s.x, s.y, s.radius, 0, 2 * Math.PI), r === s.id || i === s.id ? (e.fillStyle = o.primaryColour, e.fill()) : (e.strokeStyle = "black", e.stroke());
  });
}, sEt = (e, t, n, r, i, o) => {
  wp(
    e,
    o.paddingLeft,
    o.paddingTop,
    o.canvasWidth - o.paddingRight,
    o.paddingTop
  ), nle(e, o.paddingTop, n, o), aEt(e, t, n, r, i, o);
}, cEt = (e, t, n, r, i) => {
  wp(
    e,
    i.paddingLeft,
    i.canvasHeight - i.paddingBottom,
    i.canvasWidth - i.paddingRight,
    i.canvasHeight - i.paddingBottom
  ), nle(e, i.canvasHeight - i.paddingBottom, t, i), rEt(e, t, i), iEt(e, t, n, r, i);
};
function Tb(e) {
  return e.canvasWidth - e.paddingLeft - e.paddingRight;
}
const wp = (e, t, n, r, i, o = "black") => {
  e.beginPath(), e.strokeStyle = o, e.moveTo(t, n), e.lineTo(r, i), e.stroke();
}, lEt = ce.div`
  display: flex;
  flex-direction: column;
`, DH = 0.01, uEt = ({
  question: e,
  currentAnswer: t,
  injectCurrent: n,
  submitAnswer: r,
  answers: i,
  settings: o
}) => {
  const { messagerService: a, popupService: s } = gt(mn), { primaryColour: c, primary50: l } = Gn(), u = t == null ? void 0 : t.getValue(e.type);
  let d = o3();
  d.endsWith(";") && (d = d.slice(0, -1));
  const { value: f, ready: h } = ju(e.initialStates, {
    answers: i
  });
  Xi(
    e,
    (H) => Rs(
      Object.fromEntries(
        (H.getValue("shiftContinuous") ?? []).map((ie) => [String(ie.id), ie])
      ),
      (f ?? []).map((ie) => ({
        id: `${ie.id}::final`,
        input: { type: "number", min: e.onlyAllowForwards ? ie.value : 0, max: 1 }
      })),
      h
    )
  );
  const p = $e(null), g = $e(null), [m, v] = j.useState(null), [y, _] = j.useState(null), [b, w] = j.useState(null), [C, x] = j.useState(null), [T, E] = j.useState([]), [R, I] = j.useState(512), [O, P] = j.useState(300), [k, L] = j.useState(20), N = Tt(
    () => ({
      canvasWidth: 512,
      canvasHeight: 300,
      paddingTop: 20,
      paddingBottom: 40,
      paddingLeft: 15,
      paddingRight: 15,
      circleRadius: 10,
      tickHeight: 10,
      primaryColour: c,
      secondaryColour: l,
      fontFamily: d
    }),
    [c, d]
  ), D = {
    ...N,
    canvasWidth: R,
    canvasHeight: O,
    paddingTop: k
  };
  Fa(() => {
    const H = jH(p.current);
    let ie = [];
    H && f && (ie = LH(
      H.context,
      f,
      D
    ));
    const W = fEt(ie), se = {
      ...D,
      paddingTop: W ?? N.paddingTop
    };
    H && f && W !== null && (ie = LH(
      H.context,
      f,
      se
    )), E(ie), L(se.paddingTop);
  }, [f, N, D.canvasWidth, D.canvasHeight]), ot(() => {
    const H = p.current;
    if (!H)
      return;
    dEt(H);
    const ie = jH(H);
    if (!ie)
      return;
    const { context: W, width: se, height: le } = ie, ge = le;
    I(se), P(ge);
    const me = {
      ...D,
      canvasWidth: se,
      canvasHeight: ge
    };
    W.clearRect(0, 0, me.canvasWidth, me.canvasHeight), hEt(W, me), pEt(W, u, f, m, b, me), bEt(
      W,
      f,
      m,
      b,
      u,
      T,
      me
    ), CEt(W, m, f, C, me, e.onlyAllowForwards), gEt(W, f, y, m, me);
  }, [
    f,
    m,
    b,
    C,
    u,
    N,
    k,
    y,
    T,
    e.onlyAllowForwards
  ]);
  const z = (H, ie) => {
    const W = {
      id: `${H.id}::final`,
      value: ie.value.toPrecision(3)
    };
    if (u) {
      const se = u.filter((le) => le.id !== `${H.id}::final`);
      se.push(W), n({ value: se });
    } else
      n({ value: [W] });
  }, V = (H, ie) => {
    if (!f)
      return null;
    let W = f.find((se) => {
      const [le, ge, me] = Y4(se, D), pe = H - le, Te = ie - ge;
      return Math.sqrt(pe * pe + Te * Te) < me;
    });
    if (!W) {
      const se = T.find((le) => H > le.left && H < le.right && ie > le.top && ie < le.bottom);
      if (!se)
        return null;
      W = se.state;
    }
    return W ?? null;
  }, B = (H, ie) => {
    if (ie < D.paddingTop + 0.6 * (D.canvasHeight - D.paddingTop - D.paddingBottom))
      return null;
    const W = hd(D), se = (H - D.paddingLeft) / W;
    return se < 0 || se > 1 ? null : {
      value: se
    };
  }, U = (H) => {
    const ie = p.current;
    if (!ie)
      return;
    const W = ie.getBoundingClientRect(), se = H.clientX - W.left, le = H.clientY - W.top;
    if (m === null) {
      const ge = V(se, le);
      ge && v(ge.id);
    } else {
      const ge = B(se, le);
      if (ge) {
        const pe = f == null ? void 0 : f.find((Te) => Te.id === m);
        if (!pe)
          return;
        if (e.onlyAllowForwards && pe.value > ge.value + DH) {
          a.error("Final value must be greater than initial value");
          return;
        }
        z(pe, ge), v(null);
        return;
      }
      const me = V(se, le);
      if (me)
        if (me.id === m) {
          v(null);
          return;
        } else {
          v(me.id);
          return;
        }
    }
  }, Q = (H) => {
    const ie = p.current;
    if (!ie)
      return;
    const W = ie.getBoundingClientRect(), se = H.clientX - W.left, le = H.clientY - W.top;
    _([se, le]);
    const ge = V(se, le);
    w(ge ? ge.id : null);
    const me = B(se, le);
    x(me ? me.value : null);
  }, Y = (H) => {
    H.preventDefault(), m && v(null);
  }, q = (H) => {
    H.preventDefault();
    const ie = p.current;
    if (!ie)
      return;
    const W = ie.getBoundingClientRect(), se = H.touches[0].clientX - W.left, le = H.touches[0].clientY - W.top, ge = V(se, le);
    ge && v(ge.id);
  }, X = (H) => {
    const ie = p.current;
    if (!ie)
      return;
    const W = ie.getBoundingClientRect(), se = H.changedTouches[0].clientX - W.left, le = H.changedTouches[0].clientY - W.top, ge = B(se, le);
    if (ge) {
      const me = f == null ? void 0 : f.find((pe) => pe.id === m);
      if (!me)
        return;
      if (e.onlyAllowForwards && me.value > ge.value + DH) {
        a.error("Final value must be greater than initial value"), v(null);
        return;
      }
      z(me, ge), v(null);
      return;
    }
    v(null);
  }, ne = (H) => {
    H.preventDefault();
    const ie = p.current;
    if (!ie)
      return;
    const W = ie.getBoundingClientRect(), se = H.touches[0].clientX - W.left, le = H.touches[0].clientY - W.top;
    _([se, le]);
    const ge = B(se, le);
    x(ge ? ge.value : null);
  }, Z = window.devicePixelRatio || 1, K = Ms({
    selectInitial: {
      content: "Click an initial state at the top",
      position: { left: 1, top: 0 }
    },
    shiftSelected: {
      content: "Click the desired state along the bottom",
      position: { left: 1, top: 1 }
    },
    allShifted: { content: "Once you are happy with the shifts, click next to continue" }
  }, e.helpPopups), ee = e.showHelpPopups ?? !1, te = e.helpPopupsToShow;
  return ot(() => {
    u && f && u.length === f.length ? s.setPopup(K, "allShifted", ee, te) : m === null ? s.setPopup(K, "selectInitial", ee, te) : s.setPopup(K, "shiftSelected", ee, te);
  }, [K, ee, te, f, u, m]), /* @__PURE__ */ A.jsx(AEt, { ref: g, children: /* @__PURE__ */ A.jsx(
    REt,
    {
      id: "shiftCanvas",
      width: N.canvasWidth,
      height: (1 + D.paddingTop / D.canvasHeight) * N.canvasHeight * Z,
      ref: p,
      onClick: U,
      onAuxClick: Y,
      onContextMenu: (H) => H.preventDefault(),
      onMouseMove: Q,
      onTouchStart: q,
      onTouchMove: ne,
      onTouchEnd: X
    }
  ) });
}, jH = (e) => {
  if (!e)
    return null;
  const t = window.devicePixelRatio || 1, n = e.getContext("2d");
  return n ? (n.scale(t, t), {
    context: n,
    width: e.width / t,
    height: e.height / t
  }) : null;
};
function dEt(e) {
  const t = window.devicePixelRatio || 1, n = e.getBoundingClientRect();
  e.width = n.width * t, e.height = n.height * t;
}
function fEt(e) {
  if (e.length === 0)
    return null;
  const t = e.sort((r, i) => r.y - i.y);
  return t[t.length - 1].y - t[0].y + t[0].height + 50;
}
function Y4(e, t) {
  return [
    e.value * hd(t) + t.paddingLeft,
    t.paddingTop,
    t.circleRadius
  ];
}
const hEt = (e, t) => {
  mEt(e, t), vEt(e, t), sf(
    e,
    t.paddingLeft,
    t.canvasHeight - t.paddingBottom,
    t.canvasWidth - t.paddingRight,
    t.canvasHeight - t.paddingBottom
  );
}, gEt = (e, t, n, r, i) => {
  if (!n || !t)
    return;
  const o = t.find((c) => c.id === r);
  if (!o)
    return;
  const [a, s] = n;
  e.lineWidth = 2, $Et(
    e,
    o.value * hd(i) + i.paddingLeft,
    i.paddingTop,
    a,
    s,
    "black"
  ), e.lineWidth = 1;
}, pEt = (e, t, n, r, i, o) => {
  if (!t || !n)
    return;
  const a = hd(o);
  t.forEach((s) => {
    const c = n.find((d) => `${d.id}::final` === s.id);
    if (!c)
      return;
    let l = "black", u = 1;
    r === c.id ? l = "rgba(0, 0, 0, 0.3)" : i === c.id && (u = 2), sf(
      e,
      c.value * a + o.paddingLeft,
      o.paddingTop,
      Number(s.value) * a + o.paddingLeft,
      o.canvasHeight - o.paddingBottom,
      l,
      u
    ), e.beginPath(), e.arc(
      Number(s.value) * a + o.paddingLeft,
      o.canvasHeight - o.paddingBottom,
      o.circleRadius,
      0,
      2 * Math.PI
    ), e.fillStyle = o.secondaryColour, e.fill(), e.fillStyle = "white", e.font = `0.5rem ${o.fontFamily}`, e.fillText(
      (Number(s.value) * 100).toFixed(0) + "%",
      Number(s.value) * a + o.paddingLeft,
      o.canvasHeight - o.paddingBottom + o.circleRadius / 4
    );
  });
};
function mEt(e, t) {
  e.fillStyle = "rgba(0, 0, 0, 0.05)", e.fillRect(
    t.paddingLeft,
    t.paddingTop,
    t.canvasWidth - t.paddingLeft - t.paddingRight,
    t.canvasHeight - t.paddingBottom - t.paddingTop
  );
}
const vEt = (e, t) => {
  const n = hd(t), r = [0, 0.2, 0.4, 0.6, 0.8, 1], i = t.paddingTop, o = t.canvasHeight - t.paddingBottom;
  r.forEach((a, s) => {
    const c = a * n + t.paddingLeft;
    sf(e, c, i - t.tickHeight / 2, c, i + t.tickHeight / 2), sf(e, c, o - t.tickHeight / 2, c, o + t.tickHeight / 2), sf(e, c, i, c, o, "rgba(0, 0, 0, 0.2)");
  }), r.forEach((a, s) => {
    const c = a * n + t.paddingLeft;
    e.font = `1rem ${t.fontFamily}`, e.fillStyle = "black", e.textAlign = "center", e.fillText((a * 100).toFixed(0), c, o + t.tickHeight + 20);
  });
}, yEt = (e, t, n, r, i, o) => {
  if (!t)
    return;
  const a = o.paddingTop;
  t.forEach((s, c) => {
    const l = s.value * hd(o) + o.paddingLeft, u = i == null ? void 0 : i.find((d) => d.id === `${s.id}::final`);
    e.beginPath(), e.arc(l, a, o.circleRadius, 0, 2 * Math.PI), n === s.id || r === s.id ? (e.fillStyle = "black", e.fill(), e.strokeStyle = o.secondaryColour, e.lineWidth = 5, e.stroke(), e.lineWidth = 1) : u ? (e.fillStyle = o.primaryColour, e.fill(), e.strokeStyle = o.secondaryColour, e.lineWidth = 5, e.stroke(), e.lineWidth = 1) : (e.fillStyle = o.primaryColour, e.fill());
  });
}, bEt = (e, t, n, r, i, o, a) => {
  sf(
    e,
    a.paddingLeft,
    a.paddingTop,
    a.canvasWidth - a.paddingRight,
    a.paddingTop
  ), yEt(e, t, n, r, i, a), _Et(e, n, r, i, o, a);
};
function _Et(e, t, n, r, i, o) {
  SEt(e, i, t, n, r, o);
}
function SEt(e, t, n, r, i, o) {
  t.forEach((s) => {
    const c = i == null ? void 0 : i.find((l) => l.id === `${s.state.id}::final`);
    wEt(e, s, n, r, c, o);
  });
  let a = null;
  if (n ? a = t.find((s) => s.state.id === n) ?? null : r && (a = t.find((s) => s.state.id === r) ?? null), a) {
    const [s, c] = Y4(a.state, o);
    e.lineWidth = 2, sf(e, a.x, a.y, s, c, "black"), e.lineWidth = 1;
  }
}
function wEt(e, t, n, r, i, o) {
  i ? e.fillStyle = o.secondaryColour : e.fillStyle = o.primaryColour, e.fillRect(
    t.left - 7,
    t.top - 7,
    t.width + 2 * 7,
    t.height + 2 * 7
  ), n === t.state.id || r === t.state.id ? e.font = `bold 1rem ${o.fontFamily}` : e.font = `1rem ${o.fontFamily}`, e.textAlign = "left", e.fillStyle = "white", e.fillText(t.state.label, t.x, t.y), (n === t.state.id || r === t.state.id) && (e.font = `bold 1rem ${o.fontFamily}`, e.strokeStyle = "white", e.lineWidth = 3, e.strokeText((t.state.value * 100).toFixed(0) + "%", t.x - 40, t.y), e.fillStyle = "black", e.fillText((t.state.value * 100).toFixed(0) + "%", t.x - 40, t.y));
}
function LH(e, t, n) {
  const r = [];
  for (const i of t) {
    const [o, a] = Y4(i, n);
    rle(e, o, a - n.circleRadius - 10, i, r, n);
  }
  return r;
}
function rle(e, t, n, r, i, o) {
  const a = xEt(e, t, n, r, o);
  i.some((s) => EEt(s, a)) ? rle(e, t, n - 20, r, i, o) : i.push(a);
}
function xEt(e, t, n, r, i) {
  e.font = `1rem ${i.fontFamily}`, e.textAlign = "left";
  const o = e.measureText(r.label);
  return {
    x: t,
    y: n,
    width: o.width,
    height: o.actualBoundingBoxAscent + o.actualBoundingBoxDescent,
    left: t - o.actualBoundingBoxLeft,
    right: t + o.actualBoundingBoxRight,
    top: n - o.actualBoundingBoxAscent,
    bottom: n + o.actualBoundingBoxDescent,
    state: r
  };
}
function EEt(e, t, n = 10, r = 0) {
  return e.x < t.x + t.width + n && e.x + e.width > t.x - n && e.y < t.y + t.height + r && e.y + e.height > t.y - r;
}
const CEt = (e, t, n, r, i, o = !1) => {
  o && TEt(e, r, n, t, i), IEt(e, r, t, i);
};
function TEt(e, t, n, r, i) {
  if (!t || !n || !r)
    return;
  const o = n.find((l) => l.id === r);
  if (!o || o.value < t)
    return;
  const a = hd(i), s = i.paddingLeft, c = o.value * a + i.paddingLeft;
  e.fillStyle = "rgba(139, 0, 0, 0.1)", e.fillRect(
    s,
    i.canvasHeight - i.paddingBottom,
    c,
    -(i.canvasHeight - i.paddingTop - i.paddingBottom)
  );
}
function IEt(e, t, n, r) {
  if (!t || !n)
    return;
  const i = hd(r), o = t * i + r.paddingLeft - r.circleRadius, a = t * i + r.paddingLeft + r.circleRadius;
  e.fillStyle = "rgba(0, 0, 0, 0.1)", e.fillRect(
    o,
    r.canvasHeight - r.paddingBottom,
    a - o,
    -(r.canvasHeight - r.paddingTop - r.paddingBottom)
  ), e.font = `1rem ${r.fontFamily}`, e.textAlign = "center", e.fillStyle = "black", e.fillText(
    (t * 100).toFixed(0) + "%",
    t * i + r.paddingLeft,
    r.canvasHeight - r.paddingBottom + 20
  );
}
function hd(e) {
  return e.canvasWidth - e.paddingLeft - e.paddingRight;
}
function $Et(e, t, n, r, i, o = "black", a = 1) {
  const c = r - t, l = i - n, u = Math.atan2(l, c);
  e.beginPath(), e.strokeStyle = o, e.lineWidth = a, e.moveTo(t, n), e.lineTo(r, i), e.lineTo(
    r - 10 * Math.cos(u - Math.PI / 6),
    i - 10 * Math.sin(u - Math.PI / 6)
  ), e.moveTo(r, i), e.lineTo(
    r - 10 * Math.cos(u + Math.PI / 6),
    i - 10 * Math.sin(u + Math.PI / 6)
  ), e.stroke();
}
const sf = (e, t, n, r, i, o = "black", a = 1) => {
  e.beginPath(), e.lineWidth = a, e.strokeStyle = o, e.moveTo(t, n), e.lineTo(r, i), e.stroke();
}, AEt = ce.div`
  display: flex;
  flex-direction: column;
`, REt = ce.canvas`
  display: flex;
  width: 100%;
  touch-action: none;
`, PEt = ({
  question: e,
  currentAnswer: t,
  injectCurrent: n,
  submitAnswer: r,
  answers: i,
  settings: o
}) => {
  const { loggingService: a, popupService: s } = gt(mn);
  a.info("SingleSelectQuestion");
  const c = t.getValue(e.type);
  if (c && er.isArray(c))
    throw new Error("SingleSelect question received an array as a current answer value");
  const { choices: l, ready: u } = yl(
    e.choices,
    i
  );
  Xi(e, (v) => ({
    ...jy(e, v),
    ready: u
  })), Dy(JP(l), t, n);
  const d = Wt(() => {
    if (!e.defaultValues)
      return;
    const v = e.defaultValues({ answers: i, choices: l }), y = l.find((_) => _.id === v);
    if (y)
      return {
        id: y.id,
        value: y.value
      };
  }, [e, i, l]);
  Qf(d, e, t, i, n);
  const f = {
    noneSelected: { content: "Please select an option" },
    selected: { content: "Click next to continue" },
    notRequired: { content: "Please select an option or click next to continue" }
  }, h = Qn(e.helpPopups, { answers: i }), p = Ms(f, h), g = e.showHelpPopups ?? !1, m = e.helpPopupsToShow;
  return ot(() => {
    e.required ? c === null ? s.setPopup(p, "noneSelected", g, m) : s.setPopup(p, "selected", g, m) : s.setPopup(p, "notRequired", g, m);
  }, [p, g, m, e.required, c]), /* @__PURE__ */ A.jsx(jce, { settings: o, numColumns: e.numColumns, children: l.map((v) => /* @__PURE__ */ A.jsx(
    OEt,
    {
      choice: v,
      currentAnswerValue: c,
      noAutoNext: e.noAutoNext ?? !1,
      injectCurrent: n,
      submitAnswer: r,
      shadeButton: e.shade ?? !1
    },
    v.id
  )) });
};
function OEt({
  choice: e,
  currentAnswerValue: t,
  injectCurrent: n,
  submitAnswer: r,
  noAutoNext: i,
  shadeButton: o
}) {
  switch (e.type) {
    case "input":
      return /* @__PURE__ */ A.jsx(
        MEt,
        {
          choice: e,
          currentAnswerValue: t,
          injectCurrent: n,
          submitAnswer: r,
          noAutoNext: i,
          shadeButton: o
        }
      );
    case "commentBox":
      return /* @__PURE__ */ A.jsx(
        kEt,
        {
          choice: e,
          currentAnswerValue: t,
          injectCurrent: n,
          submitAnswer: r,
          noAutoNext: i,
          shadeButton: o
        }
      );
    default:
      return /* @__PURE__ */ A.jsx(
        NEt,
        {
          choice: e,
          currentAnswerValue: t,
          injectCurrent: n,
          submitAnswer: r,
          noAutoNext: i,
          shadeButton: o
        }
      );
  }
}
function MEt({
  choice: e,
  currentAnswerValue: t,
  injectCurrent: n
}) {
  const r = (t == null ? void 0 : t.id) === e.id && (t == null ? void 0 : t.value), { primaryColour: i } = Gn(), { messagerService: o } = gt(mn), a = /* @__PURE__ */ A.jsx(
    U4,
    {
      type: "text",
      placeholder: e.placeholder || "",
      inputValue: r || "",
      active: !!t && e.id === t.id,
      onValueChange: (s) => {
        n({
          value: {
            id: e.id,
            value: s.target.value
          }
        });
      },
      label: e.text ? qn(e.text) : e.value,
      maxLength: e.maxLength,
      onMaxLengthExceeded: (s) => {
        o.warning(`You've reached the character limit of ${s} characters.`);
      },
      primaryColour: i
    }
  );
  return e.toolTip ? /* @__PURE__ */ A.jsx(od, { title: e.toolTip, children: /* @__PURE__ */ A.jsx("div", { children: a }) }) : a;
}
function kEt({
  choice: e,
  currentAnswerValue: t,
  injectCurrent: n
}) {
  const r = (t == null ? void 0 : t.id) === e.id && (t == null ? void 0 : t.value), { primaryColour: i } = Gn(), o = e.minRows !== void 0 && { minRows: e.minRows }, a = /* @__PURE__ */ A.jsx(
    z4,
    {
      type: "text",
      allowClear: !0,
      dynamicColour: i,
      placeholder: e.placeholder,
      label: e.value,
      value: r || "",
      onChange: (s) => {
        const c = {
          id: e.id,
          value: s.target.value
        };
        n({
          value: c
        });
      },
      autoSize: o
    },
    e.id
  );
  return e.toolTip ? /* @__PURE__ */ A.jsx(od, { title: e.toolTip, children: /* @__PURE__ */ A.jsx("div", { children: a }) }) : a;
}
function NEt({
  choice: e,
  currentAnswerValue: t,
  injectCurrent: n,
  noAutoNext: r,
  submitAnswer: i,
  shadeButton: o
}) {
  var d;
  const { primaryColour: a, shadeColour: s } = Gn(), c = (f) => {
    const h = { id: f.id, value: f.value };
    r ? n({ value: h }) : (n({ value: h }), i());
  };
  let l = o ? s : void 0;
  (d = e.style) != null && d.backgroundColor && (l = e.style.backgroundColor);
  const u = /* @__PURE__ */ A.jsx(
    cx,
    {
      active: !!t && e.id === t.id,
      colour: a,
      shadeColour: l,
      buttonText: e.text ? qn(e.text) : e.value,
      ButtonIcon: e.icon,
      fill: e.icon && e.fill ? e.fill : "",
      onClick: (f) => {
        c(e), Su(f);
      }
    }
  );
  return e.toolTip ? /* @__PURE__ */ A.jsx(od, { title: e.toolTip, placement: "topLeft", children: u }, e.id) : u;
}
const DEt = (e) => null, jEt = ["record_answer"], LEt = ({
  question: e,
  settings: t,
  currentAnswer: n,
  injectCurrent: r,
  recordAnswer: i,
  answers: o,
  updateSurveyControls: a
}) => {
  const { databaseService: s, loggingService: c } = gt(mn), { primaryColour: l } = Gn(), u = $e(null), d = $e([]), f = $e(/* @__PURE__ */ new Set()), h = n.getValue(e.type), [p, g] = Qe(0), [m, v] = Qe(h === null), [y, _] = Qe(null), [b, w] = Qe(null), [C, x] = Qe(h === null ? "idle" : "completed"), [T, E] = Qe(
    h === null ? null : "Conversation completed."
  ), [R, I] = Qe(null), [O, P] = Qe(!1), [k, L] = Qe(!1), [N, D] = Qe(!1), [z, V] = Qe(null), B = Qn(e.contextText, { answers: o }), U = e.contextText === void 0 || B !== void 0, Q = e.emitToolNames ?? jEt, Y = Tt(() => z ? z.transcript : HEt(h, "vocinaTranscript"), [z, h]);
  ot(() => {
    if (e.required)
      return a({
        nextDisabled: n.getValue(e.type) === null
      }), () => {
        a({ nextDisabled: !1 });
      };
  }, [n, e.required, e.type, a]), ot(() => {
    if (!m)
      return;
    let ee = !1;
    return x("launching"), E("Preparing your Vocina conversation..."), I(null), _(null), w(null), P(!1), L(!1), D(!1), V(null), d.current = [], f.current = /* @__PURE__ */ new Set(), s.createVocinaPreAuthLaunch({
      agentId: e.agentId,
      ...e.courseId ? { courseId: e.courseId } : {},
      surveyName: t.surveyName,
      questionId: e.id
    }).then((te) => {
      ee || (_(te), w(VEt(e.id)), x(U ? "waiting_for_ready" : "waiting_for_context"), E("Waiting for Vocina to finish loading..."));
    }).catch((te) => {
      ee || (c.error("Failed to create Vocina pre-auth launch", {
        error: te,
        context: { questionId: e.id }
      }), v(!1), x("error"), E(null), I(te.message || "Unable to prepare the Vocina conversation."));
    }), () => {
      ee = !0;
    };
  }, [
    s,
    m,
    p,
    c,
    e.agentId,
    e.courseId,
    e.id,
    t.surveyName
  ]), ot(() => {
    if (!y)
      return;
    const ee = (te) => {
      if (te.origin !== y.vocinaEmbedOrigin)
        return;
      const H = BEt(te.data);
      if (H && !(H.version !== 1 || H.agentId !== y.agentId) && !("launchId" in H && H.launchId !== void 0 && H.launchId !== b))
        switch (H.type) {
          case "vocina.embed.ready":
            P(!0), x(U ? "initialising" : "waiting_for_context"), E(
              U ? "Initialising Vocina..." : "Preparing survey context before starting Vocina..."
            );
            break;
          case "vocina.embed.init_ack":
            D(!0), x("ready"), E("Vocina is ready. Start the conversation in the embedded panel below.");
            break;
          case "vocina.embed.call_started":
            x("in_call"), E("Conversation in progress...");
            break;
          case "vocina.embed.tool_result":
            if (!H.ok) {
              c.warn("Vocina tool result failed", H);
              return;
            }
            c.debug("Vocina tool result received", H), q(H);
            break;
          case "vocina.embed.call_completed":
            try {
              const W = {
                ...(e.answerMapper ?? jle)({
                  toolResults: d.current,
                  completion: H,
                  answers: o,
                  conferQuestionId: e.id
                }),
                ...zEt(H, b ?? H.launchId)
              };
              r({ value: W }), i(), V(H), v(!1), _(null), x("completed"), E("Conversation completed. Review the summary below, then continue."), I(null);
            } catch (ie) {
              const W = ie;
              c.error("Failed to map Vocina answer", {
                error: W,
                context: { questionId: e.id }
              }), v(!1), _(null), x("error"), E(null), I(W.message || "Unable to save the Vocina result.");
            }
            break;
          case "vocina.embed.error":
            X(H);
            break;
        }
    };
    return window.addEventListener("message", ee), () => {
      window.removeEventListener("message", ee);
    };
  }, [o, U, r, y, b, c, e, i]), ot(() => {
    var H;
    if (!y || !b || !O || !U || k)
      return;
    const ee = (H = u.current) == null ? void 0 : H.contentWindow;
    if (!ee)
      return;
    const te = {
      type: "vocina.embed.init",
      version: 1,
      launchId: b,
      contextText: B ?? "",
      emitToolNames: Q,
      waitForPersistedArtifacts: e.waitForPersistedArtifacts ?? !1
    };
    ee.postMessage(te, y.vocinaEmbedOrigin), L(!0), x("initialising"), E("Initialising Vocina...");
  }, [
    U,
    Q,
    k,
    y,
    b,
    e.waitForPersistedArtifacts,
    O,
    B
  ]), ot(() => {
    !y || !O || U || C === "launching" || (x("waiting_for_context"), E("Preparing survey context before starting Vocina..."));
  }, [U, y, O, C]);
  function q(ee) {
    const te = JSON.stringify({
      toolName: ee.toolName,
      input: ee.input,
      result: ee.result
    });
    f.current.has(te) || (f.current.add(te), d.current = [...d.current, ee]);
  }
  function X(ee) {
    v(!1), _(null), x("error"), E(null), I(ee.message);
  }
  function ne() {
    r({ value: null }), i(), I(null), V(null), v(!0), g((ee) => ee + 1);
  }
  function Z() {
    ne();
  }
  const J = y !== null && m, K = y ? FEt(y, window.location.origin) : void 0;
  return /* @__PURE__ */ A.jsxs(UEt, { "data-testid": "vocina-conversation-question", children: [
    /* @__PURE__ */ A.jsx(WEt, { children: J && K ? /* @__PURE__ */ A.jsx(
      qEt,
      {
        ref: u,
        src: K,
        title: `Vocina conversation for ${e.id}`,
        allow: "microphone; autoplay; screen-wake-lock",
        "data-testid": "vocina-iframe"
      }
    ) : /* @__PURE__ */ A.jsxs(GEt, { "data-testid": "vocina-state-panel", children: [
      C === "launching" || C === "waiting_for_ready" || C === "waiting_for_context" || C === "initialising" ? /* @__PURE__ */ A.jsxs(A.Fragment, { children: [
        /* @__PURE__ */ A.jsx(tp, {}),
        /* @__PURE__ */ A.jsx(e0, { children: T })
      ] }) : null,
      C === "ready" || C === "in_call" ? /* @__PURE__ */ A.jsx(e0, { children: T }) : null,
      C === "completed" ? /* @__PURE__ */ A.jsxs(A.Fragment, { children: [
        /* @__PURE__ */ A.jsx(FH, { children: "Conversation Completed" }),
        /* @__PURE__ */ A.jsx(e0, { children: T }),
        Y ? /* @__PURE__ */ A.jsx(KEt, { "data-testid": "vocina-transcript", children: Y }) : null,
        /* @__PURE__ */ A.jsx(VH, { children: /* @__PURE__ */ A.jsx(BH, { type: "button", onClick: Z, $colour: l, children: "Start a new conversation" }) })
      ] }) : null,
      C === "error" ? /* @__PURE__ */ A.jsxs(A.Fragment, { children: [
        /* @__PURE__ */ A.jsx(FH, { children: "Vocina Unavailable" }),
        /* @__PURE__ */ A.jsx(e0, { children: R ?? "Something went wrong while launching Vocina." }),
        /* @__PURE__ */ A.jsx(VH, { children: /* @__PURE__ */ A.jsx(BH, { type: "button", onClick: ne, $colour: l, children: "Retry" }) })
      ] }) : null,
      C === "idle" ? /* @__PURE__ */ A.jsxs(A.Fragment, { children: [
        /* @__PURE__ */ A.jsx(e0, { children: "Preparing Vocina..." }),
        /* @__PURE__ */ A.jsx(tp, {})
      ] }) : null
    ] }) }),
    J ? /* @__PURE__ */ A.jsxs(YEt, { children: [
      /* @__PURE__ */ A.jsx(XEt, { children: T }),
      N ? /* @__PURE__ */ A.jsx(QEt, { children: "Vocina is ready to start when the participant is." }) : null
    ] }) : null,
    C === "error" ? /* @__PURE__ */ A.jsx(JEt, { "data-testid": "vocina-error-message", children: R ?? "Unable to start the Vocina conversation." }) : null
  ] });
};
function FEt(e, t) {
  const n = new URLSearchParams({
    token: e.token,
    bridge: "1",
    parentOrigin: t
  });
  return e.courseId && n.set("courseId", e.courseId), `${e.vocinaEmbedOrigin}/embed/pre-auth/agents/${encodeURIComponent(
    e.agentId
  )}?${n.toString()}`;
}
function VEt(e) {
  return typeof crypto < "u" && typeof crypto.randomUUID == "function" ? `vocina-${e}-${crypto.randomUUID()}` : `vocina-${e}-${Date.now()}`;
}
function BEt(e) {
  return !bx(e) || typeof e.type != "string" || typeof e.agentId != "string" || e.version !== 1 || ![
    "vocina.embed.ready",
    "vocina.embed.init_ack",
    "vocina.embed.call_started",
    "vocina.embed.tool_result",
    "vocina.embed.call_completed",
    "vocina.embed.error"
  ].includes(e.type) ? null : e;
}
function zEt(e, t) {
  return {
    vocinaTranscript: X1("vocinaTranscript", e.transcript),
    vocinaAudioUrl: X1("vocinaAudioUrl", e.audioUrl ?? ""),
    vocinaSessionId: X1("vocinaSessionId", e.sessionId),
    vocinaLaunchId: X1("vocinaLaunchId", t)
  };
}
function X1(e, t) {
  return { id: e, value: t };
}
function HEt(e, t) {
  if (!e)
    return null;
  const n = e[t];
  return !n || Array.isArray(n) ? null : n.value;
}
const UEt = ce.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`, WEt = ce.div`
  display: flex;
  flex-direction: column;
  min-height: 36rem;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 12px;
  overflow: hidden;
  background: white;
`, qEt = ce.iframe`
  width: 100%;
  min-height: 36rem;
  border: 0;
  background: white;
`, GEt = ce.div`
  display: flex;
  flex: 1;
  min-height: 36rem;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  padding: 2rem;
  text-align: center;
`, FH = ce.h3`
  margin: 0;
`, e0 = ce.p`
  margin: 0;
  max-width: 36rem;
`, KEt = ce.pre`
  width: 100%;
  max-width: 42rem;
  max-height: 16rem;
  margin: 0;
  padding: 1rem;
  overflow: auto;
  text-align: left;
  white-space: pre-wrap;
  word-break: break-word;
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.04);
`, VH = ce.div`
  display: flex;
  justify-content: center;
  margin-top: 0.5rem;
`, BH = ce.button`
  border: 0;
  border-radius: 999px;
  padding: 0.85rem 1.25rem;
  font-size: 1rem;
  font-weight: 600;
  color: white;
  background: ${({ $colour: e }) => e};
  cursor: pointer;
`, YEt = ce.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`, XEt = ce.p`
  margin: 0;
`, QEt = ce.p`
  margin: 0;
  color: rgba(0, 0, 0, 0.6);
  font-size: 0.95rem;
`, JEt = ce.p`
  margin: 0;
  color: #b42318;
`, ZEt = (e) => {
  const { question: t } = e;
  switch (t.type) {
    case "welcomePage":
      return /* @__PURE__ */ A.jsx(DEt, { ...e, question: t });
    case "infoPage":
      return /* @__PURE__ */ A.jsx(e_t, { ...e, question: t });
    case "endPage":
      return /* @__PURE__ */ A.jsx(V1t, { ...e, question: t });
    case "singleSelect":
      return /* @__PURE__ */ A.jsx(PEt, { ...e, question: t });
    case "multiSelect":
      return /* @__PURE__ */ A.jsx(MSt, { ...e, question: t });
    case "multiInput":
      return /* @__PURE__ */ A.jsx(mSt, { ...e, question: t });
    case "slider":
      return /* @__PURE__ */ A.jsx(Nce, { ...e, question: t });
    case "responsiveSlider":
      return /* @__PURE__ */ A.jsx(Bwt, { ...e, question: t });
    case "rewardPage":
      return /* @__PURE__ */ A.jsx(kxt, { ...e, question: t });
    case "matrix":
      return /* @__PURE__ */ A.jsx(B_t, { ...e, question: t });
    case "multiSelectMatrix":
      return /* @__PURE__ */ A.jsx(LSt, { ...e, question: t });
    case "dropdown-matrix":
      return /* @__PURE__ */ A.jsx(G_t, { ...e, question: t });
    case "input-matrix":
      return /* @__PURE__ */ A.jsx(J_t, { ...e, question: t });
    case "ranking":
      return /* @__PURE__ */ A.jsx(Rwt, { ...e, question: t });
    case "dropdown":
      return /* @__PURE__ */ A.jsx(j1t, { ...e, question: t });
    case "multiDropdown":
      return /* @__PURE__ */ A.jsx(rSt, { ...e, question: t });
    case "choiceExperiment":
      return /* @__PURE__ */ A.jsx(rse, { ...e, question: t });
    case "conjointAnalysis":
      return /* @__PURE__ */ A.jsx(C1t, { ...e, question: t });
    case "commentBox":
      return /* @__PURE__ */ A.jsx(f1t, { ...e, question: t });
    case "choiceRank":
      return /* @__PURE__ */ A.jsx(Qpt, { ...e, question: t });
    case "compareSlider":
      return /* @__PURE__ */ A.jsx(h1t, { ...e, question: t });
    case "loggingTestPage":
      return /* @__PURE__ */ A.jsx(t_t, { ...e, question: t });
    case "hidden":
      return /* @__PURE__ */ A.jsx(Z1t, { ...e, question: t });
    case "shift":
      return /* @__PURE__ */ A.jsx(Zxt, { ...e, question: t });
    case "shiftContinuous":
      return /* @__PURE__ */ A.jsx(uEt, { ...e, question: t });
    case "match":
      return /* @__PURE__ */ A.jsx(i_t, { ...e, question: t });
    case "vocinaConversation":
      return /* @__PURE__ */ A.jsx(LEt, { ...e, question: t });
    default:
      xu();
  }
}, eCt = ({ question: e, children: t }) => {
  const n = No();
  switch (e.type) {
    case "dropdown-matrix":
      return /* @__PURE__ */ A.jsx(Y_t, { device: n, style: e.style, children: t });
    case "input-matrix":
      return /* @__PURE__ */ A.jsx(eSt, { device: n, style: e.style, children: t });
    case "matrix":
    case "multiSelectMatrix":
      return /* @__PURE__ */ A.jsx(
        F_t,
        {
          device: n,
          style: e.style,
          $contentWidth: a3(e, n).contentWidth,
          children: t
        }
      );
    case "compareSlider":
      return /* @__PURE__ */ A.jsx(y1t, { device: n, children: t });
    case "conjointAnalysis":
    case "choiceExperiment":
      return /* @__PURE__ */ A.jsx(Xpt, { device: n, style: e.style, children: t });
    default:
      return /* @__PURE__ */ A.jsx(lm, { device: n, style: e.style, children: t });
  }
}, tCt = () => {
  const { messagerService: e } = gt(mn), t = $e(null), n = $e(null), r = Mi();
  return ot(() => {
    const i = t.current, o = n.current;
    if (i && o) {
      e.setContainer(o);
      const a = new ResizeObserver((s) => {
        for (const c of s)
          o.style.width = `${c.contentRect.width}px`;
      });
      return a.observe(i), () => a.disconnect();
    }
  }, []), /* @__PURE__ */ A.jsx(nCt, { ref: t, children: /* @__PURE__ */ A.jsx(rCt, { ref: n, borderRadius: r }) });
}, nCt = ce.div`
  position: relative;
`, rCt = ce.div`
  position: fixed;
  z-index: 2;

  > .prefix-survey-message-top {
    position: unset;
    transform: unset !important;

    > .prefix-survey-message-notice-wrapper {
      padding: 0;
    }
  }

  .survey-message > .prefix-survey-message-notice-content {
    background: none;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    box-shadow: 2px 2px 4.1px 2px rgba(17, 17, 17, 0.1);
    width: 100%;
    border-radius: ${({ borderRadius: e }) => e};
    .ant-alert {
      border-radius: ${({ borderRadius: e }) => e};
    }
  }

  .survey-message
    > .prefix-survey-message-notice-content
    > .prefix-survey-message-custom-content
    > span {
    width: 100%;
  }
`, iCt = (e) => {
  const t = WU(), n = No(), { loggingService: r } = gt(mn), i = a3(e.question, n), o = Wt(
    (x) => {
      t($0e(x));
    },
    [t]
  ), a = Wt(() => {
    t(UU());
  }, [t]), s = Wt(
    (x) => {
      t(HU(x));
    },
    [t]
  ), [c, l] = Qe({
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    width: 0,
    height: 0
  }), u = $e(null);
  ot(() => {
    const x = () => {
      const T = u.current;
      if (T === null)
        return;
      const { left: E, right: R, top: I, bottom: O, width: P, height: k } = T.getBoundingClientRect();
      l({ left: E, right: R, top: I, bottom: O, width: P, height: k });
    };
    return x(), window.addEventListener("resize", x), () => {
      window.removeEventListener("resize", x);
    };
  }, []);
  const d = new ResizeObserver((x) => {
    const T = u.current;
    if (T === null)
      return;
    const { left: E, right: R, top: I, bottom: O, width: P, height: k } = T.getBoundingClientRect();
    l({ left: E, right: R, top: I, bottom: O, width: P, height: k });
  });
  ot(() => {
    const x = u.current;
    return x && d.observe(x), () => {
      d.disconnect();
    };
  }, [u.current]);
  const { left: f, right: h, top: p, bottom: g, width: m, height: v } = c, y = uf((x) => x.survey.currentAnswer), _ = Tt(() => {
    if (y)
      return new lu(y, r);
  }, [y]), b = uf((x) => x.survey.userAnswers), w = Tt(() => new C0(b, r), [b]);
  if (!_)
    return null;
  const C = {
    ...e,
    currentAnswer: _,
    answers: w,
    injectCurrent: o,
    updateCurrent: s,
    recordAnswer: a
  };
  return /* @__PURE__ */ A.jsxs(oCt, { direction: "row", device: n, children: [
    /* @__PURE__ */ A.jsxs(aCt, { $width: i.contentWidth, style: e.question.containerStyle, children: [
      /* @__PURE__ */ A.jsxs("div", { ref: u, children: [
        /* @__PURE__ */ A.jsx(rBe, { container: { left: f, right: h, top: p, bottom: g, width: m, height: v } }),
        /* @__PURE__ */ A.jsxs(eCt, { question: e.question, children: [
          /* @__PURE__ */ A.jsx(tCt, {}),
          /* @__PURE__ */ A.jsx(ZVe, { ...C }),
          /* @__PURE__ */ A.jsx(ZEt, { ...C })
        ] })
      ] }),
      e.question.outputs && zH(e.question, n) === "column" && /* @__PURE__ */ A.jsx(
        gz,
        {
          outputs: e.question.outputs,
          currentAnswer: _,
          answers: w,
          settings: e.settings,
          direction: e.question.outputDirection,
          location: e.question.outputLocation,
          style: e.question.outputStyle
        }
      )
    ] }),
    e.question.outputs && zH(e.question, n) === "row" && /* @__PURE__ */ A.jsx(
      gz,
      {
        outputs: e.question.outputs,
        currentAnswer: _,
        answers: w,
        settings: e.settings,
        direction: e.question.outputDirection,
        location: e.question.outputLocation,
        style: e.question.outputStyle
      }
    )
  ] });
};
function zH(e, t) {
  return t === Xn.MOBILE || t === Xn.TABLET || e.outputLocation === "below" ? "column" : "row";
}
const oCt = ce.div`
  display: flex;
  flex-direction: ${(e) => e.direction || "row"};
  align-items: ${(e) => e.direction === "column" ? "stretch" : "flex-start"};
  justify-content: center;
  width: 100%;
  /* padding: 0 30px; */
  padding: ${(e) => e.device === Xn.MOBILE ? "0 16px" : "0 1rem"};
`, aCt = ce.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  flex: 0 1 ${(e) => e.$width};
  min-width: 0;
  padding-bottom: 10px;
  /* width: 40rem; */
`, QCt = () => {
  const {
    survey: e,
    currentQuestion: t,
    currentSurveyQuestions: n,
    enteredFromPrevious: r,
    submitAnswer: i,
    goToPreviousQuestion: o,
    updateSurveyControls: a,
    setNextButtonBehaviour: s,
    setPreviousButtonBehaviour: c
  } = gt(oC);
  return t ? /* @__PURE__ */ A.jsx(
    iCt,
    {
      question: t,
      settings: e.settings,
      currentSurveyQuestions: n,
      enteredFromPrevious: r,
      submitAnswer: i,
      goToPreviousQuestion: o,
      updateSurveyControls: a,
      setNextButtonBehaviour: s,
      setPreviousButtonBehaviour: c
    }
  ) : null;
}, sCt = ce.span`
  margin: auto;
`, n$ = ({
  onClick: e,
  fill: t,
  stroke: n,
  hoverFill: r,
  disabled: i,
  text: o,
  arrow: a,
  compactNavButtons: s
}) => {
  const c = No(), l = Mi();
  return /* @__PURE__ */ A.jsxs(
    cCt,
    {
      borderRadius: l,
      disabled: i,
      fill: t,
      stroke: n,
      hoverFill: r,
      type: "button",
      onClick: e,
      device: c,
      compactNavButtons: s,
      children: [
        a === "left" ? /* @__PURE__ */ A.jsx(JLe, {}) : null,
        /* @__PURE__ */ A.jsx(sCt, { children: o }),
        a === "right" ? /* @__PURE__ */ A.jsx(PNe, {}) : null
      ]
    }
  );
}, cCt = ce.button`
  position: relative;
  display: flex;
  flex: 1 1 50%;
  justify-content: space-between;
  align-items: center;
  border: none;
  height: ${(e) => e.device === Xn.MOBILE && e.compactNavButtons ? "var(--compact-button-height)" : "var(--button-height)"};
  padding-left: var(--spacing-md);
  padding-right: var(--spacing-md);
  font-size: 18px;

  background-color: ${(e) => e.fill};
  border: 1px solid ${(e) => e.stroke};

  cursor: ${(e) => e.disabled ? "not-allowed" : "pointer"};

  color: white;
  border-radius: ${(e) => e.borderRadius};

  user-select: none;
  overflow: hidden;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      background-color: ${(e) => e.hoverFill};
    }
  }

  span.ripple {
    position: absolute;
    border-radius: 50%;
    transform: scale(0);
    animation: ripple 500ms linear;
    background-color: rgba(255, 255, 255, 0.7);
  }

  @keyframes ripple {
    to {
      transform: scale(4);
      opacity: 0;
    }
  }
`, lCt = {
  default: "Previous",
  mi: "O mua",
  fr: "Précédent",
  es: "Anterior",
  de: "Zurück",
  nl: "Vorige",
  it: "Indietro",
  pt: "Anterior",
  pl: "Poprzedni",
  ru: "Назад",
  ja: "前へ",
  zh: "上一页",
  tr: "Önceki",
  ko: "이전",
  ar: "السابق",
  hi: "पिछला",
  bn: "পূর্ববর্তী",
  pa: "ਪਿਛਲਾ",
  gu: "પાછળનું",
  fil: "Nakaraan",
  sm: "talu ai",
  si: "පෙර",
  //Sinhala
  ta: "முந்தைய"
  //Tamil
}, uCt = {
  default: "Next",
  mi: "Panuku",
  fr: "Suivant",
  es: "Siguiente",
  de: "Weiter",
  nl: "Volgende",
  it: "Avanti",
  pt: "Próximo",
  pl: "Dalej",
  ru: "Далее",
  ja: "次へ",
  zh: "下一页",
  tr: "Sonraki",
  ko: "다음",
  ar: "التالي",
  hi: "अगला",
  bn: "পরবর্তী",
  pa: "ਅਗਲਾ",
  gu: "આગળ વધો",
  fil: "Susunod",
  sm: "le isi",
  si: "ඊළඟ",
  ta: "அடுத்து"
}, dCt = {
  default: "Submit",
  mi: "Tukuna",
  fr: "Soumettre",
  es: "Enviar",
  de: "Einreichen",
  nl: "Indienen",
  it: "Invia",
  pt: "Enviar",
  pl: "Prześlij",
  ru: "Отправить",
  ja: "提出する",
  zh: "提交",
  tr: "Gönder",
  ko: "제출",
  ar: "إرسال",
  hi: "जमा करें",
  bn: "জমা দিন",
  pa: "ਜਮਾ ਕਰੋ",
  gu: "સબમિટ કરો",
  fil: "Ipasa",
  sm: "tuʻu",
  si: "ඉදිරිපත් කරන්න",
  ta: "சமர்ப்பிக்கவும்"
};
function JCt() {
  const {
    survey: e,
    displayBackButton: t,
    displayNextButton: n,
    displaySubmitButton: r,
    previousQuestion: i,
    nextQuestion: o,
    onSubmitSurvey: a,
    surveyControlsState: s,
    nextButtonText: c,
    previousButtonText: l,
    hideSurveyControls: u
  } = gt(oC), { primaryColour: d, primary50: f } = Gn(), h = No();
  return /* @__PURE__ */ A.jsx(fCt, { settings: e.settings, visible: !u(), children: /* @__PURE__ */ A.jsxs(hCt, { device: h, children: [
    t() ? /* @__PURE__ */ A.jsx(
      n$,
      {
        text: l ?? qn(lCt),
        arrow: "left",
        disabled: s.prevDisabled,
        fill: d,
        stroke: d,
        hoverFill: f,
        onClick: (p) => {
          Su(p), i();
        },
        compactNavButtons: e.settings.compactNavButtons
      }
    ) : null,
    n() ? /* @__PURE__ */ A.jsx(
      n$,
      {
        arrow: "right",
        disabled: s.nextDisabled,
        onClick: (p) => {
          Su(p), o();
        },
        fill: d,
        stroke: d,
        hoverFill: f,
        text: c ?? qn(uCt),
        compactNavButtons: e.settings.compactNavButtons
      }
    ) : null,
    r() ? /* @__PURE__ */ A.jsx(
      n$,
      {
        text: qn(dCt),
        fill: d,
        onClick: (p) => {
          Su(p), a();
        },
        stroke: d,
        hoverFill: f,
        compactNavButtons: e.settings.compactNavButtons
      }
    ) : null
  ] }) });
}
const fCt = ce.div`
  display: flex;
  margin-top: auto;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  overflow: hidden;

  z-index: 99;
  visibility: ${(e) => e.visible ? "visible" : "hidden"};
  max-height: ${(e) => e.visible ? "8rem" : "0"};
  opacity: ${(e) => e.visible ? "1" : "0"};
  pointer-events: ${(e) => e.visible ? "auto" : "none"};
  transform: ${(e) => e.visible ? "translateY(0)" : "translateY(0.75rem)"};
  transition:
    opacity 220ms ease,
    transform 320ms cubic-bezier(0.22, 1, 0.36, 1),
    max-height 320ms cubic-bezier(0.22, 1, 0.36, 1),
    visibility 0s linear ${(e) => e.visible ? "0s" : "320ms"};
  flex-shrink: 0;

  @media (prefers-reduced-motion: reduce) {
    transform: none;
    transition: none;
  }
`, hCt = ce.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 2rem;
  margin: ${(e) => e.device === Xn.MOBILE ? "0.5rem 30px 0.5rem" : "0.5rem 2rem var(--spacing-lg)"};

  max-width: 40rem;
  flex-grow: 1;
`;
function gCt(e) {
  return /* @__PURE__ */ A.jsx(pCt, { colour: e.colour || "black", children: /* @__PURE__ */ A.jsx(pVe, {}) });
}
const pCt = ce.span`
  color: ${(e) => e.colour};
  font-size: 1.2em;
`, mCt = ({ children: e, isOpen: t, onClose: n }) => {
  const [r, i] = Qe({ top: 0, left: 0 }), o = $e(null), a = $e(null);
  return ot(() => {
    if (o.current && a.current && t) {
      const s = o.current.getBoundingClientRect(), c = a.current.getBoundingClientRect();
      let l = 0;
      const u = window.innerWidth - c.right;
      u < s.width && (l = u - s.width - 25), i({
        top: (c == null ? void 0 : c.height) ?? 0,
        left: l
      });
    }
  }, [t]), t ? /* @__PURE__ */ A.jsxs(A.Fragment, { children: [
    /* @__PURE__ */ A.jsx(vCt, { onClick: n }),
    /* @__PURE__ */ A.jsx(yCt, { ref: a, children: /* @__PURE__ */ A.jsxs(bCt, { ref: o, style: { top: r.top, left: r.left }, children: [
      /* @__PURE__ */ A.jsx(_Ct, { onClick: n, children: "×" }),
      e
    ] }) })
  ] }) : null;
}, vCt = ce.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0);
  z-index: 1000;
`, yCt = ce.span`
  position: relative;
  top: 0;
  left: 0;
  height: 0;
  width: 0;
`, bCt = ce.div`
  position: absolute;
  background-color: white;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1001;
  width: 300px;
  color: var(--dark);
  // max-width: 300px;
`, _Ct = ce.button`
  position: absolute;
  top: 5px;
  right: 5px;
  background: none;
  border: none;
  font-size: 30px;
  cursor: pointer;
  color: #333;
`, ZCt = ({ children: e, startOpen: t = !1, colour: n }) => {
  const [r, i] = Qe(t), { primaryColour: o } = Gn();
  return /* @__PURE__ */ A.jsxs(A.Fragment, { children: [
    /* @__PURE__ */ A.jsx(SCt, { onClick: () => i(!r), children: /* @__PURE__ */ A.jsx(gCt, { colour: n ?? o }) }),
    /* @__PURE__ */ A.jsx(mCt, { isOpen: r, onClose: () => i(!1), children: e })
  ] });
}, SCt = ce.span`
  cursor: pointer;
`, wCt = {
  default: "complete",
  mi: "kua oti",
  fr: "complété",
  es: "completado",
  de: "abgeschlossen",
  nl: "voltooid",
  it: "completato",
  pt: "concluído",
  pl: "zakończony",
  ru: "завершено",
  ja: "完了",
  zh: "完成",
  tr: "tamamlandı",
  ko: "완료",
  ar: "مكتمل",
  hi: "पूरा",
  bn: "সম্পন্ন",
  pa: "ਮੁਕੰਮਲ",
  gu: "પૂરું",
  fil: "kumpleto",
  sm: "uma"
}, e2t = ({ percentage: e, settings: t, hide: n }) => {
  const { primaryColour: r, backgroundColour: i } = Gn(), o = Mi(), a = qn(wCt);
  return n ? null : e === 0 ? /* @__PURE__ */ A.jsx(HH, { children: /* @__PURE__ */ A.jsx(UH, { borderRadius: o, backgroundColour: i, children: /* @__PURE__ */ A.jsxs(XP, { children: [
    "0% ",
    a
  ] }) }) }) : /* @__PURE__ */ A.jsx(HH, { children: /* @__PURE__ */ A.jsxs(UH, { borderRadius: o, backgroundColour: i, children: [
    /* @__PURE__ */ A.jsx(ile, { children: /* @__PURE__ */ A.jsx(ole, { percentage: e, primaryColour: r }) }),
    /* @__PURE__ */ A.jsxs(XP, { children: [
      e.toFixed(0),
      "%"
    ] })
  ] }) });
}, HH = ce.div`
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-left: var(--spacing-lg);
  padding-right: var(--spacing-lg);
  padding-bottom: var(--spacing-lg);
`, UH = ce.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  gap: 1rem;
  height: 58px;
  background: ${(e) => e.backgroundColour};
  padding-left: 25px;
  padding-right: 25px;
  border-radius: ${(e) => e.borderRadius};
`, XP = ce.div`
  display: flex;
  justify-content: flex-end;
  // width: 350px;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.1rem;
  min-width: 2.5rem;
  .filler {
    background: ${(e) => e.color ? e.color : "#E82D7C"};
  }
`, ile = ce.div`
  position: relative;
  flex-grow: 1;
  height: 8px;
  border-radius: 4px;
  background: var(--mid-light);
`, ole = ce.div`
  width: ${(e) => `${e.percentage}%`};
  background: ${(e) => e.primaryColour}; /* fallback for old browsers */

  height: 100%;
  border-radius: inherit;
  transition: width 0.3s ease-in;
`, t2t = ({
  percentage: e,
  settings: t,
  hide: n,
  compact: r
}) => {
  const { primaryColour: i, backgroundColour: o } = Gn(), a = Mi();
  return /* @__PURE__ */ A.jsx(xCt, { hide: n, children: /* @__PURE__ */ A.jsxs(
    ECt,
    {
      compact: r,
      borderRadius: a,
      backgroundColour: o,
      children: [
        /* @__PURE__ */ A.jsx(ile, { children: /* @__PURE__ */ A.jsx(ole, { percentage: e, primaryColour: i }) }),
        /* @__PURE__ */ A.jsxs(XP, { children: [
          e.toFixed(0),
          "%"
        ] })
      ]
    }
  ) });
}, xCt = ce.div`
  display: flex;
  flex-direction: column;
  visibility: ${(e) => e.hide ? "hidden" : "visible"};
`, ECt = ce.div`
  display: flex;
  margin-left: 20px;
  margin-right: 20px;
  padding-left: var(--spacing-sm);
  padding-right: var(--spacing-sm);
  height: ${(e) => e.compact ? "20px" : "var(--button-height)"};
  align-items: center;
  border-top-left-radius: ${(e) => e.borderRadius};
  border-top-right-radius: ${(e) => e.borderRadius};
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
  transition: height 0.5s;
  overflow: hidden;
`;
export {
  gle as AnalyticsService,
  vle as CrashReportingService,
  mle as DatabaseManagerService,
  Xn as Device,
  NCt as FirebaseAnalyticsService,
  HCt as FirebaseDatabaseManagerService,
  LCt as FirebaseUserManagerService,
  ZCt as InfoCallout,
  gCt as InfoSymbol,
  yle as LoggingService,
  mVe as MessageMessagerService,
  _le as MessagerService,
  t2t as MobileProgressBar,
  i2t as MockAnalyticsService,
  ble as MockCrashReportingService,
  o2t as MockDatabaseManagerService,
  Q1 as MockLoggingService,
  a2t as MockMessagerService,
  s2t as MockPopupService,
  c2t as MockUserManagerService,
  Sle as PopupService,
  e2t as ProgressBar,
  yVe as RealPopupService,
  WCt as RecorderLoggingService,
  P0e as ReduxStoreManager,
  UCt as SentryCrashReportingService,
  mn as ServiceContext,
  iC as SettingsContext,
  JCt as SurveyControls,
  QCt as SurveyQuestion,
  KCt as SurveyWrapper,
  AH as TreasureDog,
  ple as UserManagerService,
  OCt as checkAtLength,
  MCt as checkEmailPattern,
  sCe as choiceResultHeaders,
  aCe as choiceResultsFromResultData,
  uCe as compareResultColumnKeys,
  VCt as csvDataFromChoiceData,
  FCt as csvDataFromResponses,
  jle as defaultVocinaAnswerMapper,
  c$ as dropdownMatrixCellKey,
  JEe as exportCellsFromAnswer,
  l2t as getEntries,
  QEe as getQuestionExportAdapter,
  E5 as getSecondsBetween,
  a$ as getSectionNavigationDefinition,
  vde as getUserDeviceType,
  qCt as initializeFirebase,
  R8 as isKeyOfResultDataMetadata,
  l$ as multiSelectMatrixCellKey,
  u2t as newUser,
  PCt as parseLength,
  RCt as parseOnlyLetterAndSpace,
  W5 as processSubmission,
  fK as questionExportAdapters,
  a3 as resolveQuestionLayout,
  BCt as responsesFromResultData,
  nA as resultDataMetadataMap,
  zCt as resultHeadersFromResultData,
  zU as setSubmissionId,
  Mi as useBorderRadius,
  Gn as useColours,
  No as useDevice,
  o3 as useFont,
  GCt as useQuestionLayout,
  KVe as useSurveyContext
};
//# sourceMappingURL=index.es.js.map
